webpackJsonp([2],{

/***/ "+27R":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'ss': [number + ' secondanim', number + ' second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),

/***/ "+66z":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "+7/x":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        ss : '%d விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),

/***/ "+8aO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = /*@__PURE__*/ __webpack_require__("TToO").__decorate;
var __metadata = /*@__PURE__*/ __webpack_require__("TToO").__metadata;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var common_1 = __webpack_require__("wTuo");
var inputtext_1 = __webpack_require__("iE7H");
var button_1 = __webpack_require__("ovmJ");
var shared_1 = __webpack_require__("WtLm");
var domhandler_1 = __webpack_require__("55Fp");
var objectutils_1 = __webpack_require__("NtYx");
var forms_1 = __webpack_require__("B+Nj");
exports.AUTOCOMPLETE_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return AutoComplete; }),
    multi: true
};
var AutoComplete = /*@__PURE__*/ (function () {
    function AutoComplete(el, domHandler, renderer, objectUtils, cd, differs) {
        this.el = el;
        this.domHandler = domHandler;
        this.renderer = renderer;
        this.objectUtils = objectUtils;
        this.cd = cd;
        this.differs = differs;
        this.minLength = 1;
        this.delay = 300;
        this.type = 'text';
        this.completeMethod = new core_1.EventEmitter();
        this.onSelect = new core_1.EventEmitter();
        this.onUnselect = new core_1.EventEmitter();
        this.onFocus = new core_1.EventEmitter();
        this.onBlur = new core_1.EventEmitter();
        this.onDropdownClick = new core_1.EventEmitter();
        this.onClear = new core_1.EventEmitter();
        this.onKeyUp = new core_1.EventEmitter();
        this.scrollHeight = '200px';
        this.dropdownMode = 'blank';
        this.immutable = true;
        this.onModelChange = function () { };
        this.onModelTouched = function () { };
        this.panelVisible = false;
        this.focus = false;
        this.inputFieldValue = null;
        this.differ = differs.find([]).create(null);
    }
    Object.defineProperty(AutoComplete.prototype, "suggestions", {
        get: function () {
            return this._suggestions;
        },
        set: function (val) {
            this._suggestions = val;
            if (this.immutable) {
                this.handleSuggestionsChange();
            }
        },
        enumerable: true,
        configurable: true
    });
    AutoComplete.prototype.ngDoCheck = function () {
        if (!this.immutable) {
            var changes = this.differ.diff(this.suggestions);
            if (changes) {
                this.handleSuggestionsChange();
            }
        }
    };
    AutoComplete.prototype.handleSuggestionsChange = function () {
        if (this._suggestions != null) {
            if (this.panelEL && this.panelEL.nativeElement && this.loading) {
                this.highlightOption = null;
                if (this._suggestions && this._suggestions.length) {
                    this.noResults = false;
                    this.show();
                    this.suggestionsUpdated = true;
                    if (this.autoHighlight) {
                        this.highlightOption = this._suggestions[0];
                    }
                }
                else {
                    this.noResults = true;
                    if (this.emptyMessage) {
                        this.show();
                        this.suggestionsUpdated = true;
                    }
                    else {
                        this.hide();
                    }
                }
            }
            this.loading = false;
        }
    };
    AutoComplete.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.templates.forEach(function (item) {
            switch (item.getType()) {
                case 'item':
                    _this.itemTemplate = item.template;
                    break;
                case 'selectedItem':
                    _this.selectedItemTemplate = item.template;
                    break;
                default:
                    _this.itemTemplate = item.template;
                    break;
            }
        });
    };
    AutoComplete.prototype.ngAfterViewInit = function () {
        if (this.appendTo) {
            if (this.appendTo === 'body')
                document.body.appendChild(this.panelEL.nativeElement);
            else
                this.domHandler.appendChild(this.panelEL.nativeElement, this.appendTo);
        }
    };
    AutoComplete.prototype.ngAfterViewChecked = function () {
        var _this = this;
        //Use timeouts as since Angular 4.2, AfterViewChecked is broken and not called after panel is updated
        if (this.suggestionsUpdated && this.panelEL.nativeElement && this.panelEL.nativeElement.offsetParent) {
            setTimeout(function () { return _this.align(); }, 1);
            this.suggestionsUpdated = false;
        }
        if (this.highlightOptionChanged) {
            setTimeout(function () {
                var listItem = _this.domHandler.findSingle(_this.panelEL.nativeElement, 'li.ui-state-highlight');
                if (listItem) {
                    _this.domHandler.scrollInView(_this.panelEL.nativeElement, listItem);
                }
            }, 1);
            this.highlightOptionChanged = false;
        }
    };
    AutoComplete.prototype.writeValue = function (value) {
        this.value = value;
        this.filled = this.value && this.value != '';
        this.updateInputField();
    };
    AutoComplete.prototype.registerOnChange = function (fn) {
        this.onModelChange = fn;
    };
    AutoComplete.prototype.registerOnTouched = function (fn) {
        this.onModelTouched = fn;
    };
    AutoComplete.prototype.setDisabledState = function (val) {
        this.disabled = val;
    };
    AutoComplete.prototype.onInput = function (event) {
        var _this = this;
        if (!this.inputKeyDown) {
            return;
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        var value = event.target.value;
        if (!this.multiple && !this.forceSelection) {
            this.onModelChange(value);
        }
        if (value.length === 0) {
            this.hide();
            this.onClear.emit(event);
        }
        if (value.length >= this.minLength) {
            this.timeout = setTimeout(function () {
                _this.search(event, value);
            }, this.delay);
        }
        else {
            this.suggestions = null;
            this.hide();
        }
        this.updateFilledState();
        this.inputKeyDown = false;
    };
    AutoComplete.prototype.onInputClick = function (event) {
        if (this.documentClickListener) {
            this.inputClick = true;
        }
    };
    AutoComplete.prototype.search = function (event, query) {
        //allow empty string but not undefined or null
        if (query === undefined || query === null) {
            return;
        }
        this.loading = true;
        this.completeMethod.emit({
            originalEvent: event,
            query: query
        });
    };
    AutoComplete.prototype.selectItem = function (option, focus) {
        if (focus === void 0) {
            focus = true;
        }
        if (this.multiple) {
            this.multiInputEL.nativeElement.value = '';
            this.value = this.value || [];
            if (!this.isSelected(option)) {
                this.value = this.value.concat([option]);
                this.onModelChange(this.value);
            }
        }
        else {
            this.inputEL.nativeElement.value = this.field ? this.objectUtils.resolveFieldData(option, this.field) || '' : option;
            this.value = option;
            this.onModelChange(this.value);
        }
        this.onSelect.emit(option);
        this.updateFilledState();
        this._suggestions = null;
        if (focus) {
            this.focusInput();
        }
    };
    AutoComplete.prototype.show = function () {
        if (this.multiInputEL || this.inputEL) {
            var hasFocus = this.multiple ? document.activeElement == this.multiInputEL.nativeElement : document.activeElement == this.inputEL.nativeElement;
            if (!this.panelVisible && hasFocus) {
                this.panelVisible = true;
                if (this.appendTo) {
                    this.panelEL.nativeElement.style.minWidth = this.domHandler.getWidth(this.el.nativeElement.children[0]) + 'px';
                }
                this.panelEL.nativeElement.style.zIndex = ++domhandler_1.DomHandler.zindex;
                this.domHandler.fadeIn(this.panelEL.nativeElement, 200);
                this.bindDocumentClickListener();
            }
        }
    };
    AutoComplete.prototype.align = function () {
        if (this.appendTo)
            this.domHandler.absolutePosition(this.panelEL.nativeElement, (this.multiple ? this.multiContainerEL.nativeElement : this.inputEL.nativeElement));
        else
            this.domHandler.relativePosition(this.panelEL.nativeElement, (this.multiple ? this.multiContainerEL.nativeElement : this.inputEL.nativeElement));
    };
    AutoComplete.prototype.hide = function () {
        this.panelVisible = false;
        this.unbindDocumentClickListener();
    };
    AutoComplete.prototype.handleDropdownClick = function (event) {
        this.focusInput();
        var queryValue = this.multiple ? this.multiInputEL.nativeElement.value : this.inputEL.nativeElement.value;
        if (this.dropdownMode === 'blank')
            this.search(event, '');
        else if (this.dropdownMode === 'current')
            this.search(event, queryValue);
        this.onDropdownClick.emit({
            originalEvent: event,
            query: queryValue
        });
    };
    AutoComplete.prototype.focusInput = function () {
        if (this.multiple)
            this.multiInputEL.nativeElement.focus();
        else
            this.inputEL.nativeElement.focus();
    };
    AutoComplete.prototype.removeItem = function (item) {
        var itemIndex = this.domHandler.index(item);
        var removedValue = this.value[itemIndex];
        this.value = this.value.filter(function (val, i) { return i != itemIndex; });
        this.onModelChange(this.value);
        this.updateFilledState();
        this.onUnselect.emit(removedValue);
    };
    AutoComplete.prototype.onKeydown = function (event) {
        if (this.panelVisible) {
            var highlightItemIndex = this.findOptionIndex(this.highlightOption);
            switch (event.which) {
                //down
                case 40:
                    if (highlightItemIndex != -1) {
                        var nextItemIndex = highlightItemIndex + 1;
                        if (nextItemIndex != (this.suggestions.length)) {
                            this.highlightOption = this.suggestions[nextItemIndex];
                            this.highlightOptionChanged = true;
                        }
                    }
                    else {
                        this.highlightOption = this.suggestions[0];
                    }
                    event.preventDefault();
                    break;
                //up
                case 38:
                    if (highlightItemIndex > 0) {
                        var prevItemIndex = highlightItemIndex - 1;
                        this.highlightOption = this.suggestions[prevItemIndex];
                        this.highlightOptionChanged = true;
                    }
                    event.preventDefault();
                    break;
                //enter
                case 13:
                    if (this.highlightOption) {
                        this.selectItem(this.highlightOption);
                        this.hide();
                    }
                    event.preventDefault();
                    break;
                //escape
                case 27:
                    this.hide();
                    event.preventDefault();
                    break;
                //tab
                case 9:
                    if (this.highlightOption) {
                        this.selectItem(this.highlightOption);
                    }
                    this.hide();
                    break;
            }
        }
        else {
            if (event.which === 40 && this.suggestions) {
                this.search(event, event.target.value);
            }
        }
        if (this.multiple) {
            switch (event.which) {
                //backspace
                case 8:
                    if (this.value && this.value.length && !this.multiInputEL.nativeElement.value) {
                        this.value = this.value.slice();
                        var removedValue = this.value.pop();
                        this.onModelChange(this.value);
                        this.updateFilledState();
                        this.onUnselect.emit(removedValue);
                    }
                    break;
            }
        }
        this.inputKeyDown = true;
    };
    AutoComplete.prototype.onKeyup = function (event) {
        this.onKeyUp.emit(event);
    };
    AutoComplete.prototype.onInputFocus = function (event) {
        this.focus = true;
        this.onFocus.emit(event);
    };
    AutoComplete.prototype.onInputBlur = function (event) {
        this.focus = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    };
    AutoComplete.prototype.onInputChange = function (event) {
        if (this.forceSelection && this.suggestions) {
            var valid = false;
            var inputValue = event.target.value.trim();
            if (this.suggestions) {
                for (var _i = 0, _a = this.suggestions; _i < _a.length; _i++) {
                    var suggestion = _a[_i];
                    var itemValue = this.field ? this.objectUtils.resolveFieldData(suggestion, this.field) : suggestion;
                    if (itemValue && inputValue === itemValue.trim()) {
                        valid = true;
                        this.selectItem(suggestion, false);
                        break;
                    }
                }
            }
            if (!valid) {
                if (this.multiple) {
                    this.multiInputEL.nativeElement.value = '';
                }
                else {
                    this.value = null;
                    this.inputEL.nativeElement.value = '';
                }
                this.onClear.emit(event);
                this.onModelChange(this.value);
            }
        }
    };
    AutoComplete.prototype.isSelected = function (val) {
        var selected = false;
        if (this.value && this.value.length) {
            for (var i = 0; i < this.value.length; i++) {
                if (this.objectUtils.equals(this.value[i], val, this.dataKey)) {
                    selected = true;
                    break;
                }
            }
        }
        return selected;
    };
    AutoComplete.prototype.findOptionIndex = function (option) {
        var index = -1;
        if (this.suggestions) {
            for (var i = 0; i < this.suggestions.length; i++) {
                if (this.objectUtils.equals(option, this.suggestions[i])) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    };
    AutoComplete.prototype.updateFilledState = function () {
        if (this.multiple)
            this.filled = (this.value && this.value.length) || (this.multiInputEL && this.multiInputEL.nativeElement && this.multiInputEL.nativeElement.value != '');
        else
            this.filled = (this.inputFieldValue && this.inputFieldValue != '') || (this.inputEL && this.inputEL.nativeElement && this.inputEL.nativeElement.value != '');
        ;
    };
    AutoComplete.prototype.updateInputField = function () {
        var formattedValue = this.value ? (this.field ? this.objectUtils.resolveFieldData(this.value, this.field) || '' : this.value) : '';
        this.inputFieldValue = formattedValue;
        if (this.inputEL && this.inputEL.nativeElement) {
            this.inputEL.nativeElement.value = formattedValue;
        }
        this.updateFilledState();
    };
    AutoComplete.prototype.bindDocumentClickListener = function () {
        var _this = this;
        if (!this.documentClickListener) {
            this.documentClickListener = this.renderer.listen('document', 'click', function (event) {
                if (event.which === 3) {
                    return;
                }
                if (!_this.inputClick && !_this.isDropdownClick(event)) {
                    _this.hide();
                }
                _this.inputClick = false;
                _this.cd.markForCheck();
            });
        }
    };
    AutoComplete.prototype.isDropdownClick = function (event) {
        if (this.dropdown) {
            var target = event.target;
            return (target === this.dropdownButton.nativeElement || target.parentNode === this.dropdownButton.nativeElement);
        }
        else {
            return false;
        }
    };
    AutoComplete.prototype.unbindDocumentClickListener = function () {
        if (this.documentClickListener) {
            this.documentClickListener();
            this.documentClickListener = null;
        }
    };
    AutoComplete.prototype.ngOnDestroy = function () {
        this.unbindDocumentClickListener();
        if (this.appendTo) {
            this.el.nativeElement.appendChild(this.panelEL.nativeElement);
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], AutoComplete.prototype, "minLength", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], AutoComplete.prototype, "delay", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AutoComplete.prototype, "style", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "styleClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AutoComplete.prototype, "inputStyle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "inputId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "inputStyleClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "placeholder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AutoComplete.prototype, "readonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AutoComplete.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], AutoComplete.prototype, "maxlength", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AutoComplete.prototype, "required", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], AutoComplete.prototype, "size", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], AutoComplete.prototype, "appendTo", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AutoComplete.prototype, "autoHighlight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AutoComplete.prototype, "forceSelection", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "type", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AutoComplete.prototype, "completeMethod", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AutoComplete.prototype, "onSelect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AutoComplete.prototype, "onUnselect", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AutoComplete.prototype, "onFocus", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AutoComplete.prototype, "onBlur", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AutoComplete.prototype, "onDropdownClick", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AutoComplete.prototype, "onClear", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], AutoComplete.prototype, "onKeyUp", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "field", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "scrollHeight", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AutoComplete.prototype, "dropdown", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "dropdownMode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AutoComplete.prototype, "multiple", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], AutoComplete.prototype, "tabindex", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "dataKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], AutoComplete.prototype, "emptyMessage", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], AutoComplete.prototype, "immutable", void 0);
    __decorate([
        core_1.ViewChild('in'),
        __metadata("design:type", core_1.ElementRef)
    ], AutoComplete.prototype, "inputEL", void 0);
    __decorate([
        core_1.ViewChild('multiIn'),
        __metadata("design:type", core_1.ElementRef)
    ], AutoComplete.prototype, "multiInputEL", void 0);
    __decorate([
        core_1.ViewChild('panel'),
        __metadata("design:type", core_1.ElementRef)
    ], AutoComplete.prototype, "panelEL", void 0);
    __decorate([
        core_1.ViewChild('multiContainer'),
        __metadata("design:type", core_1.ElementRef)
    ], AutoComplete.prototype, "multiContainerEL", void 0);
    __decorate([
        core_1.ViewChild('ddBtn'),
        __metadata("design:type", core_1.ElementRef)
    ], AutoComplete.prototype, "dropdownButton", void 0);
    __decorate([
        core_1.ContentChildren(shared_1.PrimeTemplate),
        __metadata("design:type", core_1.QueryList)
    ], AutoComplete.prototype, "templates", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], AutoComplete.prototype, "suggestions", null);
    AutoComplete = __decorate([
        core_1.Component({
            selector: 'p-autoComplete',
            template: "\n        <span [ngClass]=\"{'ui-autocomplete ui-widget':true,'ui-autocomplete-dd':dropdown,'ui-autocomplete-multiple':multiple}\" [ngStyle]=\"style\" [class]=\"styleClass\">\n            <input *ngIf=\"!multiple\" #in [attr.type]=\"type\" [attr.id]=\"inputId\" [ngStyle]=\"inputStyle\" [class]=\"inputStyleClass\" autocomplete=\"off\" [attr.required]=\"required\"\n            [ngClass]=\"'ui-inputtext ui-widget ui-state-default ui-corner-all ui-autocomplete-input'\" [value]=\"inputFieldValue\"\n            (click)=\"onInputClick($event)\" (input)=\"onInput($event)\" (keydown)=\"onKeydown($event)\" (keyup)=\"onKeyup($event)\" (focus)=\"onInputFocus($event)\" (blur)=\"onInputBlur($event)\" (change)=\"onInputChange($event)\"\n            [attr.placeholder]=\"placeholder\" [attr.size]=\"size\" [attr.maxlength]=\"maxlength\" [attr.tabindex]=\"tabindex\" [readonly]=\"readonly\" [disabled]=\"disabled\"\n            ><ul *ngIf=\"multiple\" #multiContainer class=\"ui-autocomplete-multiple-container ui-widget ui-inputtext ui-state-default ui-corner-all\" [ngClass]=\"{'ui-state-disabled':disabled,'ui-state-focus':focus}\" (click)=\"multiIn.focus()\">\n                <li #token *ngFor=\"let val of value\" class=\"ui-autocomplete-token ui-state-highlight ui-corner-all\">\n                    <span class=\"ui-autocomplete-token-icon fa fa-fw fa-close\" (click)=\"removeItem(token)\" *ngIf=\"!disabled\"></span>\n                    <span *ngIf=\"!selectedItemTemplate\" class=\"ui-autocomplete-token-label\">{{field ? objectUtils.resolveFieldData(val, field): val}}</span>\n                    <ng-container *ngTemplateOutlet=\"selectedItemTemplate; context: {$implicit: val}\"></ng-container>\n                </li>\n                <li class=\"ui-autocomplete-input-token\">\n                    <input #multiIn [attr.type]=\"type\" [attr.id]=\"inputId\" [disabled]=\"disabled\" [attr.placeholder]=\"(value&&value.length ? null : placeholder)\" [attr.tabindex]=\"tabindex\" (input)=\"onInput($event)\"  (click)=\"onInputClick($event)\"\n                            (keydown)=\"onKeydown($event)\" [readonly]=\"readonly\" (keyup)=\"onKeyup($event)\" (focus)=\"onInputFocus($event)\" (blur)=\"onInputBlur($event)\" (change)=\"onInputChange($event)\" autocomplete=\"off\" [ngStyle]=\"inputStyle\" [class]=\"inputStyleClass\">\n                </li>\n            </ul\n            ><i *ngIf=\"loading\" class=\"ui-autocomplete-loader fa fa-circle-o-notch fa-spin fa-fw\"></i><button #ddBtn type=\"button\" pButton icon=\"fa-fw fa-caret-down\" class=\"ui-autocomplete-dropdown\" [disabled]=\"disabled\"\n                (click)=\"handleDropdownClick($event)\" *ngIf=\"dropdown\"></button>\n            <div #panel class=\"ui-autocomplete-panel ui-widget-content ui-corner-all ui-shadow\" [style.display]=\"panelVisible ? 'block' : 'none'\" [style.width]=\"appendTo ? 'auto' : '100%'\" [style.max-height]=\"scrollHeight\">\n                <ul class=\"ui-autocomplete-items ui-autocomplete-list ui-widget-content ui-widget ui-corner-all ui-helper-reset\" *ngIf=\"panelVisible\">\n                    <li *ngFor=\"let option of suggestions; let idx = index\" [ngClass]=\"{'ui-autocomplete-list-item ui-corner-all':true,'ui-state-highlight':(highlightOption==option)}\"\n                        (mouseenter)=\"highlightOption=option\" (mouseleave)=\"highlightOption=null\" (click)=\"selectItem(option)\">\n                        <span *ngIf=\"!itemTemplate\">{{field ? objectUtils.resolveFieldData(option, field) : option}}</span>\n                        <ng-container *ngTemplateOutlet=\"itemTemplate; context: {$implicit: option, index: idx}\"></ng-container>\n                    </li>\n                    <li *ngIf=\"noResults && emptyMessage\" class=\"ui-autocomplete-list-item ui-corner-all\">{{emptyMessage}}</li>\n                </ul>\n            </div>\n        </span>\n    ",
            host: {
                '[class.ui-inputwrapper-filled]': 'filled',
                '[class.ui-inputwrapper-focus]': 'focus'
            },
            providers: [domhandler_1.DomHandler, objectutils_1.ObjectUtils, exports.AUTOCOMPLETE_VALUE_ACCESSOR]
        })
    ], AutoComplete);
    return AutoComplete;
}());
exports.AutoComplete = AutoComplete;
var AutoCompleteModule = /*@__PURE__*/ (function () {
    function AutoCompleteModule() {
    }
    AutoCompleteModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule, inputtext_1.InputTextModule, button_1.ButtonModule, shared_1.SharedModule],
            exports: [AutoComplete, shared_1.SharedModule],
            declarations: [AutoComplete]
        })
    ], AutoCompleteModule);
    return AutoCompleteModule;
}());
exports.AutoCompleteModule = AutoCompleteModule;



/***/ }),

/***/ "+X65":
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__("O4Lo"),
    isObject = __webpack_require__("yCNF");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ "+gg+":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "/4GN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__["toArray"]; });

//# sourceMappingURL=toArray.js.map

/***/ }),

/***/ "/6P1":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss' : 'sekundė_sekundžių_sekundes',
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        ss : translate,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),

/***/ "/GnY":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("HT7L"),
    nativeKeys = __webpack_require__("W529");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "/I3N":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "/Kc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeMap;
/* unused harmony export MergeMapOperator */
/* unused harmony export MergeMapSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_subscribeToResult__ = /*@__PURE__*/__webpack_require__("3SjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__ = /*@__PURE__*/__webpack_require__("1E73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map__ = /*@__PURE__*/__webpack_require__("rylm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__observable_from__ = /*@__PURE__*/__webpack_require__("5XgX");
/** PURE_IMPORTS_START tslib,_util_subscribeToResult,_OuterSubscriber,_map,_observable_from PURE_IMPORTS_END */





/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        // DEPRECATED PATH
        return function (source) { return source.pipe(mergeMap(function (a, i) { return Object(__WEBPACK_IMPORTED_MODULE_4__observable_from__["a" /* from */])(project(a, i)).pipe(Object(__WEBPACK_IMPORTED_MODULE_3__map__["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(Object(__WEBPACK_IMPORTED_MODULE_1__util_subscribeToResult__["a" /* subscribeToResult */])(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__OuterSubscriber__["a" /* OuterSubscriber */]));






/***/ }),

/***/ "/Nc3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */

/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */
var EmptyError = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](EmptyError, _super);
    function EmptyError() {
        var _this = _super.call(this, 'no elements in sequence') || this;
        _this.name = 'EmptyError';
        Object.setPrototypeOf(_this, EmptyError.prototype);
        return _this;
    }
    return EmptyError;
}(Error));






/***/ }),

/***/ "/bsm":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        ss : '%d soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),

/***/ "/lQQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__("TdOr");
var ng2_auto_complete_component_1 = __webpack_require__("BUs8");
var forms_1 = __webpack_require__("B+Nj");
/**
 * display auto-complete section with input and dropdown list when it is clicked
 */
var Ng2AutoCompleteDirective = /*@__PURE__*/ (function () {
    function Ng2AutoCompleteDirective(resolver, renderer, viewContainerRef, parentForm) {
        var _this = this;
        this.resolver = resolver;
        this.renderer = renderer;
        this.viewContainerRef = viewContainerRef;
        this.parentForm = parentForm;
        this.loadingText = "Loading";
        this.tabToSelect = true;
        this.matchFormatted = false;
        this.ngModelChange = new core_1.EventEmitter();
        this.valueChanged = new core_1.EventEmitter();
        //show auto-complete list below the current element
        this.showAutoCompleteDropdown = function (event) {
            var factory = _this.resolver.resolveComponentFactory(ng2_auto_complete_component_1.Ng2AutoCompleteComponent);
            _this.componentRef = _this.viewContainerRef.createComponent(factory);
            var component = _this.componentRef.instance;
            component.showInputTag = false; //Do NOT display autocomplete input tag separately
            component.pathToData = _this.pathToData;
            component.minChars = _this.minChars;
            component.source = _this.source;
            component.placeholder = _this.autoCompletePlaceholder;
            component.acceptUserInput = _this.acceptUserInput;
            component.maxNumList = parseInt(_this.maxNumList, 10);
            component.loadingText = _this.loadingText;
            component.listFormatter = _this.listFormatter;
            component.blankOptionText = _this.blankOptionText;
            component.noMatchFoundText = _this.noMatchFoundText;
            component.tabToSelect = _this.tabToSelect;
            component.matchFormatted = _this.matchFormatted;
            component.valueSelected.subscribe(_this.selectNewValue);
            _this.acDropdownEl = _this.componentRef.location.nativeElement;
            _this.acDropdownEl.style.display = "none";
            // if this element is not an input tag, move dropdown after input tag
            // so that it displays correctly
            if (_this.el.tagName !== "INPUT" && _this.acDropdownEl) {
                _this.inputEl.parentElement.insertBefore(_this.acDropdownEl, _this.inputEl.nextSibling);
            }
            _this.revertValue = typeof _this.ngModel !== "undefined" ? _this.ngModel : _this.inputEl.value;
            setTimeout(function () {
                component.reloadList(_this.inputEl.value);
                _this.styleAutoCompleteDropdown();
                component.dropdownVisible = true;
            });
        };
        this.hideAutoCompleteDropdown = function (event) {
            if (_this.componentRef) {
                var currentItem = void 0;
                var hasRevertValue = (typeof _this.revertValue !== "undefined");
                if (_this.inputEl && hasRevertValue && _this.acceptUserInput === false) {
                    currentItem = _this.componentRef.instance.findItemFromSelectValue(_this.inputEl.value);
                }
                _this.componentRef.destroy();
                _this.componentRef = undefined;
                if (_this.inputEl &&
                    hasRevertValue &&
                    _this.acceptUserInput === false &&
                    currentItem === null) {
                    _this.selectNewValue(_this.revertValue);
                }
            }
        };
        this.styleAutoCompleteDropdown = function () {
            if (_this.componentRef) {
                var component = _this.componentRef.instance;
                /* setting width/height auto complete */
                var thisElBCR = _this.el.getBoundingClientRect();
                var thisInputElBCR = _this.inputEl.getBoundingClientRect();
                var closeToBottom = thisInputElBCR.bottom + 100 > window.innerHeight;
                _this.acDropdownEl.style.width = thisInputElBCR.width + "px";
                _this.acDropdownEl.style.position = "absolute";
                _this.acDropdownEl.style.zIndex = "1";
                _this.acDropdownEl.style.left = "0";
                _this.acDropdownEl.style.display = "inline-block";
                if (closeToBottom) {
                    _this.acDropdownEl.style.bottom = thisInputElBCR.height + "px";
                }
                else {
                    _this.acDropdownEl.style.top = thisInputElBCR.height + "px";
                }
            }
        };
        this.selectNewValue = function (item) {
            // make displayable value
            if (item && typeof item === "object") {
                item = _this.setToStringFunction(item);
            }
            _this.inputEl && (_this.inputEl.value = '' + item);
            // make return value
            var val = item;
            if (_this.selectValueOf && item[_this.selectValueOf]) {
                val = item[_this.selectValueOf];
            }
            if ((_this.parentForm && _this.formControlName) || _this.extFormControl) {
                if (!!val) {
                    _this.formControl.patchValue(val);
                }
            }
            (val !== _this.ngModel) && _this.ngModelChange.emit(val);
            _this.valueChanged.emit(val);
            _this.hideAutoCompleteDropdown();
        };
        this.keydownEventHandler = function (evt) {
            if (_this.componentRef) {
                var component = _this.componentRef.instance;
                component.inputElKeyHandler(evt);
            }
        };
        this.inputEventHandler = function (evt) {
            if (_this.componentRef) {
                var component = _this.componentRef.instance;
                component.dropdownVisible = true;
                component.reloadListInDelay(evt);
            }
            else {
                _this.showAutoCompleteDropdown();
            }
        };
        this.el = this.viewContainerRef.element.nativeElement;
    }
    Ng2AutoCompleteDirective.prototype.ngOnInit = function () {
        // wrap this element with <div class="ng2-auto-complete">
        this.wrapperEl = document.createElement("div");
        this.wrapperEl.className = "ng2-auto-complete-wrapper";
        this.wrapperEl.style.position = "relative";
        this.el.parentElement.insertBefore(this.wrapperEl, this.el.nextSibling);
        this.wrapperEl.appendChild(this.el);
        //Check if we were supplied with a [formControlName] and it is inside a [form]
        //else check if we are supplied with a [FormControl] regardless if it is inside a [form] tag
        if (this.parentForm && this.formControlName) {
            if (this.parentForm['form']) {
                this.formControl = this.parentForm['form'].get(this.formControlName);
            }
            else if (this.parentForm instanceof forms_1.FormGroupName) {
                this.formControl = this.parentForm.control.controls[this.formControlName];
            }
        }
        else if (this.extFormControl) {
            this.formControl = this.extFormControl;
        }
        // apply toString() method for the object
        if (!!this.ngModel) {
            this.selectNewValue(this.ngModel);
        }
        else if (!!this.formControl && this.formControl.value) {
            this.selectNewValue(this.formControl.value[this.displayPropertyName]);
        }
    };
    Ng2AutoCompleteDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        // if this element is not an input tag, move dropdown after input tag
        // so that it displays correctly
        this.inputEl = this.el.tagName === "INPUT" ?
            this.el : this.el.querySelector("input");
        this.inputEl.addEventListener('focus', function (e) { return _this.showAutoCompleteDropdown(e); });
        this.inputEl.addEventListener('blur', function (e) { return _this.hideAutoCompleteDropdown(e); });
        this.inputEl.addEventListener('keydown', function (e) { return _this.keydownEventHandler(e); });
        this.inputEl.addEventListener('input', function (e) { return _this.inputEventHandler(e); });
    };
    Ng2AutoCompleteDirective.prototype.ngOnDestroy = function () {
        if (this.componentRef) {
            this.componentRef.instance.valueSelected.unsubscribe();
        }
    };
    Ng2AutoCompleteDirective.prototype.ngOnChanges = function (changes) {
        if (changes['ngModel']) {
            this.ngModel = this.setToStringFunction(changes['ngModel'].currentValue);
        }
    };
    Ng2AutoCompleteDirective.prototype.setToStringFunction = function (item) {
        if (item && typeof item === "object") {
            var displayVal_1;
            if (typeof this.valueFormatter === 'string') {
                var matches = this.valueFormatter.match(/[a-zA-Z0-9_\$]+/g);
                var formatted_1 = this.valueFormatter;
                if (matches && typeof item !== 'string') {
                    matches.forEach(function (key) {
                        formatted_1 = formatted_1.replace(key, item[key]);
                    });
                }
                displayVal_1 = formatted_1;
            }
            else if (typeof this.valueFormatter === 'function') {
                displayVal_1 = this.valueFormatter(item);
            }
            else if (this.displayPropertyName) {
                displayVal_1 = item[this.displayPropertyName];
            }
            else if (typeof this.listFormatter === 'string' && this.listFormatter.match(/^\w+$/)) {
                displayVal_1 = item[this.listFormatter];
            }
            else {
                displayVal_1 = item.value;
            }
            item.toString = function () {
                return displayVal_1;
            };
        }
        return item;
    };
    Ng2AutoCompleteDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: "[auto-complete], [ng2-auto-complete]"
                },] },
    ];
    /** @nocollapse */
    Ng2AutoCompleteDirective.ctorParameters = [
        { type: core_1.ComponentFactoryResolver, },
        { type: core_1.Renderer, },
        { type: core_1.ViewContainerRef, },
        { type: forms_1.ControlContainer, decorators: [{ type: core_1.Optional }, { type: core_1.Host }, { type: core_1.SkipSelf },] },
    ];
    Ng2AutoCompleteDirective.propDecorators = {
        'autoCompletePlaceholder': [{ type: core_1.Input, args: ["auto-complete-placeholder",] },],
        'source': [{ type: core_1.Input, args: ["source",] },],
        'pathToData': [{ type: core_1.Input, args: ["path-to-data",] },],
        'minChars': [{ type: core_1.Input, args: ["min-chars",] },],
        'displayPropertyName': [{ type: core_1.Input, args: ["display-property-name",] },],
        'acceptUserInput': [{ type: core_1.Input, args: ["accept-user-input",] },],
        'maxNumList': [{ type: core_1.Input, args: ["max-num-list",] },],
        'selectValueOf': [{ type: core_1.Input, args: ["select-value-of",] },],
        'listFormatter': [{ type: core_1.Input, args: ["list-formatter",] },],
        'loadingText': [{ type: core_1.Input, args: ["loading-text",] },],
        'blankOptionText': [{ type: core_1.Input, args: ["blank-option-text",] },],
        'noMatchFoundText': [{ type: core_1.Input, args: ["no-match-found-text",] },],
        'valueFormatter': [{ type: core_1.Input, args: ["value-formatter",] },],
        'tabToSelect': [{ type: core_1.Input, args: ["tab-to-select",] },],
        'matchFormatted': [{ type: core_1.Input, args: ["match-formatted",] },],
        'ngModel': [{ type: core_1.Input },],
        'formControlName': [{ type: core_1.Input, args: ['formControlName',] },],
        'extFormControl': [{ type: core_1.Input, args: ['formControl',] },],
        'ngModelChange': [{ type: core_1.Output },],
        'valueChanged': [{ type: core_1.Output },],
    };
    return Ng2AutoCompleteDirective;
}());
exports.Ng2AutoCompleteDirective = Ng2AutoCompleteDirective;



/***/ }),

/***/ "/mhn":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        ss : '%d सेकेण्ड',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),

/***/ "/mv9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var TextDirective = /*@__PURE__*/ (function () {
    function TextDirective() {
        this.newValue = new core_1.EventEmitter();
    }
    TextDirective.prototype.changeInput = function (value) {
        if (this.rg === undefined) {
            this.newValue.emit(value);
        }
        else {
            var numeric = parseFloat(value);
            if (!isNaN(numeric) && numeric >= 0 && numeric <= this.rg) {
                this.newValue.emit({ v: numeric, rg: this.rg });
            }
        }
    };
    TextDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[text]',
                    host: {
                        '(input)': 'changeInput($event.target.value)'
                    }
                },] },
    ];
    TextDirective.propDecorators = {
        'newValue': [{ type: core_1.Output, args: ['newValue',] },],
        'text': [{ type: core_1.Input, args: ['text',] },],
        'rg': [{ type: core_1.Input, args: ['rg',] },],
    };
    return TextDirective;
}());
exports.TextDirective = TextDirective;
var SliderDirective = /*@__PURE__*/ (function () {
    function SliderDirective(el) {
        var _this = this;
        this.el = el;
        this.newValue = new core_1.EventEmitter();
        this.dragStart = new core_1.EventEmitter();
        this.dragEnd = new core_1.EventEmitter();
        this.listenerMove = function (event) { _this.move(event); };
        this.listenerStop = function () { _this.stop(); };
    }
    SliderDirective.prototype.setCursor = function (event) {
        var height = this.el.nativeElement.offsetHeight;
        var width = this.el.nativeElement.offsetWidth;
        var x = Math.max(0, Math.min(this.getX(event), width));
        var y = Math.max(0, Math.min(this.getY(event), height));
        if (this.rgX !== undefined && this.rgY !== undefined) {
            this.newValue.emit({ s: x / width, v: (1 - y / height), rgX: this.rgX, rgY: this.rgY });
        }
        else if (this.rgX === undefined && this.rgY !== undefined) {
            this.newValue.emit({ v: y / height, rg: this.rgY });
        }
        else {
            this.newValue.emit({ v: x / width, rg: this.rgX });
        }
    };
    SliderDirective.prototype.move = function (event) {
        event.preventDefault();
        this.setCursor(event);
    };
    SliderDirective.prototype.start = function (event) {
        this.setCursor(event);
        document.addEventListener('mousemove', this.listenerMove);
        document.addEventListener('touchmove', this.listenerMove);
        document.addEventListener('mouseup', this.listenerStop);
        document.addEventListener('touchend', this.listenerStop);
        this.dragStart.emit();
    };
    SliderDirective.prototype.stop = function () {
        document.removeEventListener('mousemove', this.listenerMove);
        document.removeEventListener('touchmove', this.listenerMove);
        document.removeEventListener('mouseup', this.listenerStop);
        document.removeEventListener('touchend', this.listenerStop);
        this.dragEnd.emit();
    };
    SliderDirective.prototype.getX = function (event) {
        return (event.pageX !== undefined ? event.pageX : event.touches[0].pageX) - this.el.nativeElement.getBoundingClientRect().left - window.pageXOffset;
    };
    SliderDirective.prototype.getY = function (event) {
        return (event.pageY !== undefined ? event.pageY : event.touches[0].pageY) - this.el.nativeElement.getBoundingClientRect().top - window.pageYOffset;
    };
    SliderDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[slider]',
                    host: {
                        '(mousedown)': 'start($event)',
                        '(touchstart)': 'start($event)'
                    }
                },] },
    ];
    SliderDirective.propDecorators = {
        'newValue': [{ type: core_1.Output, args: ['newValue',] },],
        'dragStart': [{ type: core_1.Output, args: ['dragStart',] },],
        'dragEnd': [{ type: core_1.Output, args: ['dragEnd',] },],
        'slider': [{ type: core_1.Input, args: ['slider',] },],
        'rgX': [{ type: core_1.Input, args: ['rgX',] },],
        'rgY': [{ type: core_1.Input, args: ['rgY',] },],
    };
    return SliderDirective;
}());
exports.SliderDirective = SliderDirective;
var SliderPosition = /*@__PURE__*/ (function () {
    function SliderPosition(h, s, v, a) {
        this.h = h;
        this.s = s;
        this.v = v;
        this.a = a;
    }
    return SliderPosition;
}());
exports.SliderPosition = SliderPosition;
var SliderDimension = /*@__PURE__*/ (function () {
    function SliderDimension(h, s, v, a) {
        this.h = h;
        this.s = s;
        this.v = v;
        this.a = a;
    }
    return SliderDimension;
}());
exports.SliderDimension = SliderDimension;
function detectIE() {
    var ua = '';
    if (typeof navigator !== "undefined") {
        ua = navigator.userAgent.toLowerCase();
    }
    var msie = ua.indexOf('msie ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    // other browser
    return false;
}
exports.detectIE = detectIE;



/***/ }),

/***/ "/qTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = refCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));





/***/ }),

/***/ "037f":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("1oyr"),
    defineProperty = __webpack_require__("p0bc"),
    identity = __webpack_require__("wSKX");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "03ca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumeric;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray__ = /*@__PURE__*/__webpack_require__("YgML");
/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */

function isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !Object(__WEBPACK_IMPORTED_MODULE_0__isArray__["a" /* isArray */])(val) && (val - parseFloat(val) + 1) >= 0;
}
//# sourceMappingURL=isNumeric.js.map


/***/ }),

/***/ "09Qt":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("uIr7"),
    getPrototype = __webpack_require__("vi0E"),
    getSymbols = __webpack_require__("l9Lx"),
    stubArray = __webpack_require__("C0hh");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ "0DSl":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("YkxI"),
    isIterateeCall = __webpack_require__("zBOP");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "0Dfv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VirtualTimeScheduler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VirtualAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = /*@__PURE__*/__webpack_require__("2mZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AsyncScheduler__ = /*@__PURE__*/__webpack_require__("g8cW");
/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */



var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
            SchedulerAction = VirtualAction;
        }
        if (maxFrames === void 0) {
            maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(__WEBPACK_IMPORTED_MODULE_2__AsyncScheduler__["a" /* AsyncScheduler */]));

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var VirtualAction = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) {
            index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));






/***/ }),

/***/ "0X8Q":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        ss : '%d giây' ,
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),

/***/ "0gQV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js + 1 modules
var AsyncAction = __webpack_require__("2mZA");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/QueueAction.js
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var QueueAction_QueueAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction["a" /* AsyncAction */]));





// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js
var AsyncScheduler = __webpack_require__("g8cW");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/QueueScheduler.js
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var QueueScheduler_QueueScheduler = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(AsyncScheduler["a" /* AsyncScheduler */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/queue.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return queue; });
/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */


/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */
var queue = /*@__PURE__*/ new QueueScheduler_QueueScheduler(QueueAction_QueueAction);
//# sourceMappingURL=queue.js.map


/***/ }),

/***/ "0nHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js
var Observable = __webpack_require__("lWPP");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js
var ConnectableObservable = __webpack_require__("gne3");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/groupBy.js
var groupBy = __webpack_require__("SYCm");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/observable.js
var observable = __webpack_require__("V9Cg");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subject.js
var Subject = __webpack_require__("tUzZ");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/BehaviorSubject.js
var BehaviorSubject = __webpack_require__("0snD");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/ReplaySubject.js
var ReplaySubject = __webpack_require__("NG/L");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/AsyncSubject.js
var AsyncSubject = __webpack_require__("0uOn");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/asap.js + 2 modules
var asap = __webpack_require__("wdeq");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/async.js
var scheduler_async = __webpack_require__("QX4X");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/queue.js + 2 modules
var queue = __webpack_require__("0gQV");

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js + 1 modules
var AsyncAction = __webpack_require__("2mZA");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameAction.js
/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AnimationFrameAction_AnimationFrameAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction["a" /* AsyncAction */]));





// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js
var AsyncScheduler = __webpack_require__("g8cW");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AnimationFrameScheduler.js
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AnimationFrameScheduler_AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler["a" /* AsyncScheduler */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/animationFrame.js
/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */


/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.animationFrame.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */
var animationFrame = /*@__PURE__*/ new AnimationFrameScheduler_AnimationFrameScheduler(AnimationFrameAction_AnimationFrameAction);
//# sourceMappingURL=animationFrame.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/VirtualTimeScheduler.js
var VirtualTimeScheduler = __webpack_require__("0Dfv");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Scheduler.js
var Scheduler = __webpack_require__("Wubi");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__("HC03");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscriber.js
var Subscriber = __webpack_require__("p1Bo");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Notification.js
var Notification = __webpack_require__("NGRO");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/pipe.js
var pipe = __webpack_require__("eYUY");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/noop.js
var noop = __webpack_require__("VWaN");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/identity.js
var identity = __webpack_require__("92UZ");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/isObservable.js
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

/**
 * Tests to see if the object is an RxJS {@link Observable}
 * @param obj the object to test
 */
function isObservable(obj) {
    return obj && obj instanceof Observable["a" /* Observable */] || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function');
}
//# sourceMappingURL=isObservable.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js
var ArgumentOutOfRangeError = __webpack_require__("uxTV");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/EmptyError.js
var EmptyError = __webpack_require__("/Nc3");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js
var ObjectUnsubscribedError = __webpack_require__("LHMe");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js
var UnsubscriptionError = __webpack_require__("kk5+");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/TimeoutError.js
var TimeoutError = __webpack_require__("7mk3");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/map.js
var map = __webpack_require__("rylm");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArray.js
var isArray = __webpack_require__("YgML");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isScheduler.js
var isScheduler = __webpack_require__("5eyr");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/bindCallback.js
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_isArray,_util_isScheduler PURE_IMPORTS_END */





// tslint:enable:max-line-length
/**
 * Converts a callback API to a function that returns an Observable.
 *
 * <span class="informal">Give it a function `f` of type `f(x, callback)` and
 * it will return a function `g` that when called as `g(x)` will output an
 * Observable.</span>
 *
 * `bindCallback` is not an operator because its input and output are not
 * Observables. The input is a function `func` with some parameters, the
 * last parameter must be a callback function that `func` calls when it is
 * done.
 *
 * The output of `bindCallback` is a function that takes the same parameters
 * as `func`, except the last one (the callback). When the output function
 * is called with arguments it will return an Observable. If function `func`
 * calls its callback with one argument the Observable will emit that value.
 * If on the other hand the callback is called with multiple values the resulting
 * Observable will emit an array with said values as arguments.
 *
 * It is very important to remember that input function `func` is not called
 * when the output function is, but rather when the Observable returned by the output
 * function is subscribed. This means if `func` makes an AJAX request, that request
 * will be made every time someone subscribes to the resulting Observable, but not before.
 *
 * The last optional parameter - {@link Scheduler} - can be used to control when the call
 * to `func` happens after someone subscribes to Observable, as well as when results
 * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
 * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
 * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
 * and call `subscribe` on the output Observable all function calls that are currently executing
 * will end before `func` is invoked.
 *
 * By default results passed to the callback are emitted immediately after `func` invokes the callback.
 * In particular, if the callback is called synchronously the subscription of the resulting Observable
 * will call the `next` function synchronously as well.  If you want to defer that call,
 * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
 * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
 *
 * Note that the Observable created by the output function will always emit a single value
 * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
 * calls will not appear in the stream. If you need to listen for multiple calls,
 *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
 *
 * If `func` depends on some context (`this` property) and is not already bound the context of `func`
 * will be the context that the output function has at call time. In particular, if `func`
 * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
 * it is recommended that the context of the output function is set to that object as well.
 *
 * If the input function calls its callback in the "node style" (i.e. first argument to callback is
 * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
 * provides convenient error handling and probably is a better choice.
 * `bindCallback` will treat such functions the same as any other and error parameters
 * (whether passed or not) will always be interpreted as regular callback argument.
 *
 *
 * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
 * // Suppose we have jQuery.getJSON('/my/url', callback)
 * var getJSONAsObservable = bindCallback(jQuery.getJSON);
 * var result = getJSONAsObservable('/my/url');
 * result.subscribe(x => console.log(x), e => console.error(e));
 *
 *
 * @example <caption>Receive an array of arguments passed to a callback</caption>
 * someFunction((a, b, c) => {
 *   console.log(a); // 5
 *   console.log(b); // 'some string'
 *   console.log(c); // {someProperty: 'someValue'}
 * });
 *
 * const boundSomeFunction = bindCallback(someFunction);
 * boundSomeFunction().subscribe(values => {
 *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
 * });
 *
 *
 * @example <caption>Compare behaviour with and without async Scheduler</caption>
 * function iCallMyCallbackSynchronously(cb) {
 *   cb();
 * }
 *
 * const boundSyncFn = bindCallback(iCallMyCallbackSynchronously);
 * const boundAsyncFn = bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
 *
 * boundSyncFn().subscribe(() => console.log('I was sync!'));
 * boundAsyncFn().subscribe(() => console.log('I was async!'));
 * console.log('This happened...');
 *
 * // Logs:
 * // I was sync!
 * // This happened...
 * // I was async!
 *
 *
 * @example <caption>Use bindCallback on an object method</caption>
 * const boundMethod = bindCallback(someObject.methodWithCallback);
 * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
 * .subscribe(subscriber);
 *
 *
 * @see {@link bindNodeCallback}
 * @see {@link from}
 * @see {@link fromPromise}
 *
 * @param {function} func A function with a callback as the last parameter.
 * @param {Scheduler} [scheduler] The scheduler on which to schedule the
 * callbacks.
 * @return {function(...params: *): Observable} A function which returns the
 * Observable that delivers the same values the callback would deliver.
 * @name bindCallback
 */
function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(isScheduler["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            // DEPRECATED PATH
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(map["a" /* map */])(function (args) { return Object(isArray["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new Observable["a" /* Observable */](function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new AsyncSubject["a" /* AsyncSubject */]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        subject.error(err);
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(dispatch, 0, state);
            }
        });
    };
}
function dispatch(state) {
    var _this = this;
    var self = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject["a" /* AsyncSubject */]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(state) {
    var err = state.err, subject = state.subject;
    subject.error(err);
}
//# sourceMappingURL=bindCallback.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/bindNodeCallback.js
/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_isScheduler,_util_isArray PURE_IMPORTS_END */





/**
 * Converts a Node.js-style callback API to a function that returns an
 * Observable.
 *
 * <span class="informal">It's just like {@link bindCallback}, but the
 * callback is expected to be of type `callback(error, result)`.</span>
 *
 * `bindNodeCallback` is not an operator because its input and output are not
 * Observables. The input is a function `func` with some parameters, but the
 * last parameter must be a callback function that `func` calls when it is
 * done. The callback function is expected to follow Node.js conventions,
 * where the first argument to the callback is an error object, signaling
 * whether call was successful. If that object is passed to callback, it means
 * something went wrong.
 *
 * The output of `bindNodeCallback` is a function that takes the same
 * parameters as `func`, except the last one (the callback). When the output
 * function is called with arguments, it will return an Observable.
 * If `func` calls its callback with error parameter present, Observable will
 * error with that value as well. If error parameter is not passed, Observable will emit
 * second parameter. If there are more parameters (third and so on),
 * Observable will emit an array with all arguments, except first error argument.
 *
 * Note that `func` will not be called at the same time output function is,
 * but rather whenever resulting Observable is subscribed. By default call to
 * `func` will happen synchronously after subscription, but that can be changed
 * with proper {@link Scheduler} provided as optional third parameter. Scheduler
 * can also control when values from callback will be emitted by Observable.
 * To find out more, check out documentation for {@link bindCallback}, where
 * Scheduler works exactly the same.
 *
 * As in {@link bindCallback}, context (`this` property) of input function will be set to context
 * of returned function, when it is called.
 *
 * After Observable emits value, it will complete immediately. This means
 * even if `func` calls callback again, values from second and consecutive
 * calls will never appear on the stream. If you need to handle functions
 * that call callbacks multiple times, check out {@link fromEvent} or
 * {@link fromEventPattern} instead.
 *
 * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
 * "Node.js-style" callbacks are just a convention, so if you write for
 * browsers or any other environment and API you use implements that callback style,
 * `bindNodeCallback` can be safely used on that API functions as well.
 *
 * Remember that Error object passed to callback does not have to be an instance
 * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
 * Error parameter of callback function is interpreted as "present", when value
 * of that parameter is truthy. It could be, for example, non-zero number, non-empty
 * string or boolean `true`. In all of these cases resulting Observable would error
 * with that value. This means usually regular style callbacks will fail very often when
 * `bindNodeCallback` is used. If your Observable errors much more often then you
 * would expect, check if callback really is called in Node.js-style and, if not,
 * switch to {@link bindCallback} instead.
 *
 * Note that even if error parameter is technically present in callback, but its value
 * is falsy, it still won't appear in array emitted by Observable.
 *
 *
 * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
 * import * as fs from 'fs';
 * var readFileAsObservable = bindNodeCallback(fs.readFile);
 * var result = readFileAsObservable('./roadNames.txt', 'utf8');
 * result.subscribe(x => console.log(x), e => console.error(e));
 *
 *
 * @example <caption>Use on function calling callback with multiple arguments</caption>
 * someFunction((err, a, b) => {
 *   console.log(err); // null
 *   console.log(a); // 5
 *   console.log(b); // "some string"
 * });
 * var boundSomeFunction = bindNodeCallback(someFunction);
 * boundSomeFunction()
 * .subscribe(value => {
 *   console.log(value); // [5, "some string"]
 * });
 *
 * @example <caption>Use on function calling callback in regular style</caption>
 * someFunction(a => {
 *   console.log(a); // 5
 * });
 * var boundSomeFunction = bindNodeCallback(someFunction);
 * boundSomeFunction()
 * .subscribe(
 *   value => {}             // never gets called
 *   err => console.log(err) // 5
 * );
 *
 *
 * @see {@link bindCallback}
 * @see {@link from}
 * @see {@link fromPromise}
 *
 * @param {function} func Function with a Node.js-style callback as the last parameter.
 * @param {Scheduler} [scheduler] The scheduler on which to schedule the
 * callbacks.
 * @return {function(...params: *): Observable} A function which returns the
 * Observable that delivers the same values the Node.js callback would
 * deliver.
 * @name bindNodeCallback
 */
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(isScheduler["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            // DEPRECATED PATH
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(Object(map["a" /* map */])(function (args) { return Object(isArray["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new Observable["a" /* Observable */](function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new AsyncSubject["a" /* AsyncSubject */]();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        subject.error(err);
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(bindNodeCallback_dispatch, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
function bindNodeCallback_dispatch(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject["a" /* AsyncSubject */]();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(bindNodeCallback_dispatchError, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(bindNodeCallback_dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(bindNodeCallback_dispatchError, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function bindNodeCallback_dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function bindNodeCallback_dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=bindNodeCallback.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js
var combineLatest = __webpack_require__("jAXq");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/concat.js
var concat = __webpack_require__("S/xh");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/defer.js
var defer = __webpack_require__("JBKL");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/empty.js
var empty = __webpack_require__("w5lW");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js
var subscribeToResult = __webpack_require__("3SjU");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/OuterSubscriber.js
var OuterSubscriber = __webpack_require__("1E73");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/forkJoin.js
/** PURE_IMPORTS_START tslib,_Observable,_util_isArray,_empty,_util_subscribeToResult,_OuterSubscriber,_operators_map PURE_IMPORTS_END */







/* tslint:enable:max-line-length */
/**
 * Joins last values emitted by passed Observables.
 *
 * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
 *
 * <img src="./img/forkJoin.png" width="100%">
 *
 * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
 * or directly as arguments. If no input Observables are provided, resulting stream will complete
 * immediately.
 *
 * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
 * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
 * array will have `n` values, where first value is the last thing emitted by the first Observable,
 * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
 * not emit more than once and it will complete after that. If you need to emit combined values not only
 * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
 * or {@link zip} instead.
 *
 * In order for resulting array to have the same length as the number of input Observables, whenever any of
 * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
 * and it will not emit anything either, even if it already has some last values from other Observables.
 * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
 * unless at any point some other Observable completes without emitting value, which brings us back to
 * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
 * have to emit something at least once and complete.
 *
 * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
 * will be immediately unsubscribed.
 *
 * Optionally `forkJoin` accepts project function, that will be called with values which normally
 * would land in emitted array. Whatever is returned by project function, will appear in output
 * Observable instead. This means that default project can be thought of as a function that takes
 * all its arguments and puts them into an array. Note that project function will be called only
 * when output Observable is supposed to emit a result.
 *
 * @example <caption>Use forkJoin with operator emitting immediately</caption>
 * import { forkJoin, of } from 'rxjs';
 *
 * const observable = forkJoin(
 *   of(1, 2, 3, 4),
 *   of(5, 6, 7, 8)
 * );
 * observable.subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('This is how it ends!')
 * );
 *
 * // Logs:
 * // [4, 8]
 * // "This is how it ends!"
 *
 *
 * @example <caption>Use forkJoin with operator emitting after some time</caption>
 * import { forkJoin, interval } from 'rxjs';
 * import { take } from 'rxjs/operators';
 *
 * const observable = forkJoin(
 *   interval(1000).pipe(take(3)), // emit 0, 1, 2 every second and complete
 *   interval(500).pipe(take(4)) // emit 0, 1, 2, 3 every half a second and complete
 * );
 * observable.subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('This is how it ends!')
 * );
 *
 * // Logs:
 * // [2, 3] after 3 seconds
 * // "This is how it ends!" immediately after
 *
 *
 * @example <caption>Use forkJoin with project function</caption>
 * import { jorkJoin, interval } from 'rxjs';
 * import { take } from 'rxjs/operators';
 *
 * const observable = forkJoin(
 *   interval(1000).pipe(take(3)), // emit 0, 1, 2 every second and complete
 *   interval(500).pipe(take(4)), // emit 0, 1, 2, 3 every half a second and complete
 *   (n, m) => n + m
 * );
 * observable.subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('This is how it ends!')
 * );
 *
 * // Logs:
 * // 5 after 3 seconds
 * // "This is how it ends!" immediately after
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 *
 * @param {...ObservableInput} sources Any number of Observables provided either as an array or as an arguments
 * passed directly to the operator.
 * @param {function} [project] Function that takes values emitted by input Observables and returns value
 * that will appear in resulting Observable instead of default array.
 * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
 * or value from project function.
 */
function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var resultSelector;
    if (typeof sources[sources.length - 1] === 'function') {
        // DEPRECATED PATH
        resultSelector = sources.pop();
    }
    // if the first and only other argument is an array
    // assume it's been called with `forkJoin([obs1, obs2, obs3])`
    if (sources.length === 1 && Object(isArray["a" /* isArray */])(sources[0])) {
        sources = sources[0];
    }
    if (sources.length === 0) {
        return empty["a" /* EMPTY */];
    }
    if (resultSelector) {
        // DEPRECATED PATH
        return forkJoin(sources).pipe(Object(map["a" /* map */])(function (args) { return resultSelector.apply(void 0, args); }));
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        return new forkJoin_ForkJoinSubscriber(subscriber, sources);
    });
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var forkJoin_ForkJoinSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources) {
        var _this = _super.call(this, destination) || this;
        _this.sources = sources;
        _this.completed = 0;
        _this.haveValues = 0;
        var len = sources.length;
        _this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            var source = sources[i];
            var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(_this, source, null, i);
            if (innerSubscription) {
                _this.add(innerSubscription);
            }
        }
        return _this;
    }
    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
        var _a = this, destination = _a.destination, haveValues = _a.haveValues, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) {
            return;
        }
        if (haveValues === len) {
            destination.next(values);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/from.js + 1 modules
var from = __webpack_require__("5XgX");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isFunction.js
var isFunction = __webpack_require__("bOhj");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromEvent.js
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




var fromEvent_toString = Object.prototype.toString;
/* tslint:enable:max-line-length */
/**
 * Creates an Observable that emits events of a specific type coming from the
 * given event target.
 *
 * <span class="informal">Creates an Observable from DOM events, or Node.js
 * EventEmitter events or others.</span>
 *
 * <img src="./img/fromEvent.png" width="100%">
 *
 * `fromEvent` accepts as a first argument event target, which is an object with methods
 * for registering event handler functions. As a second argument it takes string that indicates
 * type of event we want to listen for. `fromEvent` supports selected types of event targets,
 * which are described in detail below. If your event target does not match any of the ones listed,
 * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
 * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
 * handler functions have different names, but they all accept a string describing event type
 * and function itself, which will be called whenever said event happens.
 *
 * Every time resulting Observable is subscribed, event handler function will be registered
 * to event target on given event type. When that event fires, value
 * passed as a first argument to registered function will be emitted by output Observable.
 * When Observable is unsubscribed, function will be unregistered from event target.
 *
 * Note that if event target calls registered function with more than one argument, second
 * and following arguments will not appear in resulting stream. In order to get access to them,
 * you can pass to `fromEvent` optional project function, which will be called with all arguments
 * passed to event handler. Output Observable will then emit value returned by project function,
 * instead of the usual value.
 *
 * Remember that event targets listed below are checked via duck typing. It means that
 * no matter what kind of object you have and no matter what environment you work in,
 * you can safely use `fromEvent` on that object if it exposes described methods (provided
 * of course they behave as was described above). So for example if Node.js library exposes
 * event target which has the same method names as DOM EventTarget, `fromEvent` is still
 * a good choice.
 *
 * If the API you use is more callback then event handler oriented (subscribed
 * callback function fires only once and thus there is no need to manually
 * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
 * instead.
 *
 * `fromEvent` supports following types of event targets:
 *
 * **DOM EventTarget**
 *
 * This is an object with `addEventListener` and `removeEventListener` methods.
 *
 * In the browser, `addEventListener` accepts - apart from event type string and event
 * handler function arguments - optional third parameter, which is either an object or boolean,
 * both used for additional configuration how and when passed function will be called. When
 * `fromEvent` is used with event target of that type, you can provide this values
 * as third parameter as well.
 *
 * **Node.js EventEmitter**
 *
 * An object with `addListener` and `removeListener` methods.
 *
 * **JQuery-style event target**
 *
 * An object with `on` and `off` methods
 *
 * **DOM NodeList**
 *
 * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
 *
 * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
 * it contains and install event handler function in every of them. When returned Observable
 * is unsubscribed, function will be removed from all Nodes.
 *
 * **DOM HtmlCollection**
 *
 * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
 * installed and removed in each of elements.
 *
 *
 * @example <caption>Emits clicks happening on the DOM document</caption>
 * var clicks = fromEvent(document, 'click');
 * clicks.subscribe(x => console.log(x));
 *
 * // Results in:
 * // MouseEvent object logged to console every time a click
 * // occurs on the document.
 *
 *
 * @example <caption>Use addEventListener with capture option</caption>
 * var clicksInDocument = fromEvent(document, 'click', true); // note optional configuration parameter
 *                                                                          // which will be passed to addEventListener
 * var clicksInDiv = fromEvent(someDivInDocument, 'click');
 *
 * clicksInDocument.subscribe(() => console.log('document'));
 * clicksInDiv.subscribe(() => console.log('div'));
 *
 * // By default events bubble UP in DOM tree, so normally
 * // when we would click on div in document
 * // "div" would be logged first and then "document".
 * // Since we specified optional `capture` option, document
 * // will catch event when it goes DOWN DOM tree, so console
 * // will log "document" and then "div".
 *
 * @see {@link bindCallback}
 * @see {@link bindNodeCallback}
 * @see {@link fromEventPattern}
 *
 * @param {FromEventTarget<T>} target The DOM EventTarget, Node.js
 * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
 * @param {string} eventName The event name of interest, being emitted by the
 * `target`.
 * @param {EventListenerOptions} [options] Options to pass through to addEventListener
 * @return {Observable<T>}
 * @name fromEvent
 */
function fromEvent(target, eventName, options, resultSelector) {
    if (Object(isFunction["a" /* isFunction */])(options)) {
        // DEPRECATED PATH
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        // DEPRECATED PATH
        return fromEvent(target, eventName, options).pipe(Object(map["a" /* map */])(function (args) { return Object(isArray["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
//# sourceMappingURL=fromEvent.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromEventPattern.js
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */




/* tslint:enable:max-line-length */
/**
 * Creates an Observable from an API based on addHandler/removeHandler
 * functions.
 *
 * <span class="informal">Converts any addHandler/removeHandler API to an
 * Observable.</span>
 *
 * <img src="./img/fromEventPattern.png" width="100%">
 *
 * Creates an Observable by using the `addHandler` and `removeHandler`
 * functions to add and remove the handlers. The `addHandler` is
 * called when the output Observable is subscribed, and `removeHandler` is
 * called when the Subscription is unsubscribed.
 *
 * @example <caption>Emits clicks happening on the DOM document</caption>
 * function addClickHandler(handler) {
 *   document.addEventListener('click', handler);
 * }
 *
 * function removeClickHandler(handler) {
 *   document.removeEventListener('click', handler);
 * }
 *
 * var clicks = fromEventPattern(
 *   addClickHandler,
 *   removeClickHandler
 * );
 * clicks.subscribe(x => console.log(x));
 *
 * @see {@link from}
 * @see {@link fromEvent}
 *
 * @param {function(handler: Function): any} addHandler A function that takes
 * a `handler` function as argument and attaches it somehow to the actual
 * source of events.
 * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
 * takes a `handler` function as argument and removes it in case it was
 * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
 * removeHandler function will forward it.
 * @return {Observable<T>}
 * @name fromEventPattern
 */
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        // DEPRECATED PATH
        return fromEventPattern(addHandler, removeHandler).pipe(Object(map["a" /* map */])(function (args) { return Object(isArray["a" /* isArray */])(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!Object(isFunction["a" /* isFunction */])(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}
//# sourceMappingURL=fromEventPattern.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/generate.js
/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */



function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || identity["a" /* identity */];
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || Object(isScheduler["a" /* isScheduler */])(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = identity["a" /* identity */];
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(generate_dispatch, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
function generate_dispatch(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}
//# sourceMappingURL=generate.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/iif.js
/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */


/**
 * Decides at subscription time which Observable will actually be subscribed.
 *
 * <span class="informal">`If` statement for Observables.</span>
 *
 * `if` accepts a condition function and two Observables. When
 * an Observable returned by the operator is subscribed, condition function will be called.
 * Based on what boolean it returns at that moment, consumer will subscribe either to
 * the first Observable (if condition was true) or to the second (if condition was false). Condition
 * function may also not return anything - in that case condition will be evaluated as false and
 * second Observable will be subscribed.
 *
 * Note that Observables for both cases (true and false) are optional. If condition points to an Observable that
 * was left undefined, resulting stream will simply complete immediately. That allows you to, rather
 * then controlling which Observable will be subscribed, decide at runtime if consumer should have access
 * to given Observable or not.
 *
 * If you have more complex logic that requires decision between more than two Observables, {@link defer}
 * will probably be a better choice. Actually `if` can be easily implemented with {@link defer}
 * and exists only for convenience and readability reasons.
 *
 *
 * @example <caption>Change at runtime which Observable will be subscribed</caption>
 * let subscribeToFirst;
 * const firstOrSecond = Rx.Observable.if(
 *   () => subscribeToFirst,
 *   Rx.Observable.of('first'),
 *   Rx.Observable.of('second')
 * );
 *
 * subscribeToFirst = true;
 * firstOrSecond.subscribe(value => console.log(value));
 *
 * // Logs:
 * // "first"
 *
 * subscribeToFirst = false;
 * firstOrSecond.subscribe(value => console.log(value));
 *
 * // Logs:
 * // "second"
 *
 *
 * @example <caption>Control an access to an Observable</caption>
 * let accessGranted;
 * const observableIfYouHaveAccess = Rx.Observable.if(
 *   () => accessGranted,
 *   Rx.Observable.of('It seems you have an access...') // Note that only one Observable is passed to the operator.
 * );
 *
 * accessGranted = true;
 * observableIfYouHaveAccess.subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('The end')
 * );
 *
 * // Logs:
 * // "It seems you have an access..."
 * // "The end"
 *
 * accessGranted = false;
 * observableIfYouHaveAccess.subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('The end')
 * );
 *
 * // Logs:
 * // "The end"
 *
 * @see {@link defer}
 *
 * @param {function(): boolean} condition Condition which Observable should be chosen.
 * @param {Observable} [trueObservable] An Observable that will be subscribed if condition is true.
 * @param {Observable} [falseObservable] An Observable that will be subscribed if condition is false.
 * @return {Observable} Either first or second Observable, depending on condition.
 * @static true
 * @name iif
 * @owner Observable
 */
function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) {
        trueResult = empty["a" /* EMPTY */];
    }
    if (falseResult === void 0) {
        falseResult = empty["a" /* EMPTY */];
    }
    return Object(defer["a" /* defer */])(function () { return condition() ? trueResult : falseResult; });
}
//# sourceMappingURL=iif.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isNumeric.js
var isNumeric = __webpack_require__("03ca");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/interval.js
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */



/**
 * Creates an Observable that emits sequential numbers every specified
 * interval of time, on a specified IScheduler.
 *
 * <span class="informal">Emits incremental numbers periodically in time.
 * </span>
 *
 * <img src="./img/interval.png" width="100%">
 *
 * `interval` returns an Observable that emits an infinite sequence of
 * ascending integers, with a constant interval of time of your choosing
 * between those emissions. The first emission is not sent immediately, but
 * only after the first period has passed. By default, this operator uses the
 * `async` IScheduler to provide a notion of time, but you may pass any
 * IScheduler to it.
 *
 * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
 * var numbers = Rx.Observable.interval(1000);
 * numbers.subscribe(x => console.log(x));
 *
 * @see {@link timer}
 * @see {@link delay}
 *
 * @param {number} [period=0] The interval size in milliseconds (by default)
 * or the time unit determined by the scheduler's clock.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
 * the emission of values, and providing a notion of "time".
 * @return {Observable} An Observable that emits a sequential number each time
 * interval.
 * @static true
 * @name interval
 * @owner Observable
 */
function interval(period, scheduler) {
    if (period === void 0) {
        period = 0;
    }
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    if (!Object(isNumeric["a" /* isNumeric */])(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = scheduler_async["a" /* async */];
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        subscriber.add(scheduler.schedule(interval_dispatch, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
function interval_dispatch(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}
//# sourceMappingURL=interval.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/merge.js
var merge = __webpack_require__("im1K");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/never.js
/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */


/**
 * An Observable that emits no items to the Observer and never completes.
 *
 * <img src="./img/never.png" width="100%">
 *
 * A simple Observable that emits neither values nor errors nor the completion
 * notification. It can be used for testing purposes or for composing with other
 * Observables. Please note that by never emitting a complete notification, this
 * Observable keeps the subscription from being disposed automatically.
 * Subscriptions need to be manually disposed.
 *
 * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
 * function info() {
 *   console.log('Will not be called');
 * }
 * var result = NEVER.startWith(7);
 * result.subscribe(x => console.log(x), info, info);
 *
 * @see {@link create}
 * @see {@link EMPTY}
 * @see {@link of}
 * @see {@link throwError}
 */
var NEVER = /*@__PURE__*/ new Observable["a" /* Observable */](noop["a" /* noop */]);
/**
 * @deprecated Deprecated in favor of using NEVER constant.
 */
function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/of.js
var of = __webpack_require__("MnTv");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/onErrorResumeNext.js
/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */




/* tslint:enable:max-line-length */
/**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` Will subscribe to each observable source it is provided, in order.
 * If the source it's subscribed to emits an error or completes, it will move to the next source
 * without error.
 *
 * If `onErrorResumeNext` is provided no arguments, or a single, empty array, it will return {@link EMPTY}.
 *
 * `onErrorResumeNext` is basically {@link concat}, only it will continue, even if one of its
 * sources emits an error.
 *
 * Note that there is no way to handle any errors thrown by sources via the resuult of
 * `onErrorResumeNext`. If you want to handle errors thrown in any given source, you can
 * always use the {@link catchError} operator on them before passing them into `onErrorResumeNext`.
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * import { onErrorResumeNext, of } from 'rxjs/create';
 * import { map } from 'rxjs/operators';
 *
 * onErrorResumeNext(
 *  of(1, 2, 3, 0).pipe(
 *    map(x => {
 *      if (x === 0) throw Error();
 *      return 10 / x;
 *    })
 *  ),
 *  of(1, 2, 3),
 * )
 * .subscribe(
 *   val => console.log(val),
 *   err => console.log(err),          // Will never be called.
 *   () => console.log('done')
 * );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "done"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} sources Observables (or anything that *is* observable) passed either directly or as an array.
 * @return {Observable} An Observable that concatenates all sources, one after the other,
 * ignoring all errors, such that any error causes it to move on to the next source.
 */
function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return empty["a" /* EMPTY */];
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && Object(isArray["a" /* isArray */])(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new Observable["a" /* Observable */](function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return Object(from["a" /* from */])(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}
//# sourceMappingURL=onErrorResumeNext.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/pairs.js
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */


/**
 * Convert an object into an observable sequence of [key, value] pairs
 * using an optional IScheduler to enumerate the object.
 *
 * @example <caption>Converts a javascript object to an Observable</caption>
 * var obj = {
 *   foo: 42,
 *   bar: 56,
 *   baz: 78
 * };
 *
 * var source = Rx.Observable.pairs(obj);
 *
 * var subscription = source.subscribe(
 *   function (x) {
 *     console.log('Next: %s', x);
 *   },
 *   function (err) {
 *     console.log('Error: %s', err);
 *   },
 *   function () {
 *     console.log('Completed');
 *   });
 *
 * @param {Object} obj The object to inspect and turn into an
 * Observable sequence.
 * @param {Scheduler} [scheduler] An optional IScheduler to run the
 * enumeration of the input sequence on.
 * @returns {(Observable<[string, T]>)} An observable sequence of
 * [key, value] pairs from the object.
 */
function pairs(obj, scheduler) {
    if (!scheduler) {
        return new Observable["a" /* Observable */](function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new Observable["a" /* Observable */](function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new Subscription["a" /* Subscription */]();
            subscription.add(scheduler.schedule(pairs_dispatch, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
/** @internal */
function pairs_dispatch(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}
//# sourceMappingURL=pairs.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/race.js
var race = __webpack_require__("v38c");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/range.js
var range = __webpack_require__("j+ls");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/throwError.js
var throwError = __webpack_require__("G0Bs");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/timer.js
var timer = __webpack_require__("cCSk");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/using.js
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */

 // from from from! LAWL

/**
 * Creates an Observable that uses a resource which will be disposed at the same time as the Observable.
 *
 * <span class="informal">Use it when you catch yourself cleaning up after an Observable.</span>
 *
 * `using` is a factory operator, which accepts two functions. First function returns a disposable resource.
 * It can be an arbitrary object that implements `unsubscribe` method. Second function will be injected with
 * that object and should return an Observable. That Observable can use resource object during its execution.
 * Both functions passed to `using` will be called every time someone subscribes - neither an Observable nor
 * resource object will be shared in any way between subscriptions.
 *
 * When Observable returned by `using` is subscribed, Observable returned from the second function will be subscribed
 * as well. All its notifications (nexted values, completion and error events) will be emitted unchanged by the output
 * Observable. If however someone unsubscribes from the Observable or source Observable completes or errors by itself,
 * the `unsubscribe` method on resource object will be called. This can be used to do any necessary clean up, which
 * otherwise would have to be handled by hand. Note that complete or error notifications are not emitted when someone
 * cancels subscription to an Observable via `unsubscribe`, so `using` can be used as a hook, allowing you to make
 * sure that all resources which need to exist during an Observable execution will be disposed at appropriate time.
 *
 * @see {@link defer}
 *
 * @param {function(): ISubscription} resourceFactory A function which creates any resource object
 * that implements `unsubscribe` method.
 * @param {function(resource: ISubscription): Observable<T>} observableFactory A function which
 * creates an Observable, that can use injected resource object.
 * @return {Observable<T>} An Observable that behaves the same as Observable returned by `observableFactory`, but
 * which - when completed, errored or unsubscribed - will also call `unsubscribe` on created resource object.
 */
function using(resourceFactory, observableFactory) {
    return new Observable["a" /* Observable */](function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? Object(from["a" /* from */])(result) : empty["a" /* EMPTY */];
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}
//# sourceMappingURL=using.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/zip.js
var zip = __webpack_require__("lyWU");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/config.js
var config = __webpack_require__("lKpf");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return Observable["a" /* Observable */]; });
/* unused concated harmony import ConnectableObservable */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import GroupedObservable */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return /* unused reexport */undefined; });
/* unused concated harmony import observable */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return observable["a" /* observable */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return Subject["b" /* Subject */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return BehaviorSubject["a" /* BehaviorSubject */]; });
/* unused concated harmony import ReplaySubject */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ReplaySubject["a" /* ReplaySubject */]; });
/* unused concated harmony import AsyncSubject */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return AsyncSubject["a" /* AsyncSubject */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return asap["a" /* asap */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "i", function() { return scheduler_async["a" /* async */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "A", function() { return queue["a" /* queue */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return animationFrame; });
/* unused concated harmony import VirtualTimeScheduler */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return VirtualTimeScheduler["b" /* VirtualTimeScheduler */]; });
/* unused concated harmony import VirtualAction */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return VirtualTimeScheduler["a" /* VirtualAction */]; });
/* unused concated harmony import Scheduler */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Scheduler["a" /* Scheduler */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return Subscription["a" /* Subscription */]; });
/* unused concated harmony import Subscriber */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Subscriber["a" /* Subscriber */]; });
/* unused concated harmony import Notification */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return Notification["a" /* Notification */]; });
/* unused concated harmony import pipe */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return pipe["a" /* pipe */]; });
/* unused concated harmony import noop */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return noop["a" /* noop */]; });
/* unused concated harmony import identity */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return identity["a" /* identity */]; });
/* unused concated harmony import isObservable */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return isObservable; });
/* unused concated harmony import ArgumentOutOfRangeError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return EmptyError["a" /* EmptyError */]; });
/* unused concated harmony import ObjectUnsubscribedError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return ObjectUnsubscribedError["a" /* ObjectUnsubscribedError */]; });
/* unused concated harmony import UnsubscriptionError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return UnsubscriptionError["a" /* UnsubscriptionError */]; });
/* unused concated harmony import TimeoutError */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return TimeoutError["a" /* TimeoutError */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return bindCallback; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return bindNodeCallback; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return combineLatest["b" /* combineLatest */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "m", function() { return concat["a" /* concat */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return defer["a" /* defer */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return empty["b" /* empty */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return forkJoin; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return from["a" /* from */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return fromEvent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return fromEventPattern; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return generate; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return iif; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return interval; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return merge["a" /* merge */]; });
/* unused concated harmony import never */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return never; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return of["a" /* of */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "y", function() { return onErrorResumeNext; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "z", function() { return pairs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "B", function() { return race["a" /* race */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "C", function() { return range["a" /* range */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "D", function() { return throwError["a" /* throwError */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "E", function() { return timer["a" /* timer */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "F", function() { return using; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "G", function() { return zip["b" /* zip */]; });
/* unused concated harmony import EMPTY */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return empty["a" /* EMPTY */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return NEVER; });
/* unused concated harmony import config */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return config["a" /* config */]; });
/* Observable */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */




/* Subjects */




/* Schedulers */






/* Subscription */


/* Notification */

/* Utils */




/* Error types */





/* Static observable creation exports */
























/* Constants */


/* Config */

//# sourceMappingURL=index.js.map


/***/ }),

/***/ "0snD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BehaviorSubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = /*@__PURE__*/__webpack_require__("tUzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ObjectUnsubscribedError__ = /*@__PURE__*/__webpack_require__("LHMe");
/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */



/**
 * @class BehaviorSubject<T>
 */
var BehaviorSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated This is an internal implementation detail, do not use. */
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_2__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["b" /* Subject */]));






/***/ }),

/***/ "0uOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncSubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = /*@__PURE__*/__webpack_require__("tUzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */



/**
 * @class AsyncSubject<T>
 */
var AsyncSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    /** @deprecated This is an internal implementation detail, do not use. */
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */].EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */].EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["b" /* Subject */]));






/***/ }),

/***/ "0uX4":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn");

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ "15xe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export FroalaEditorDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_forms__ = /*@__PURE__*/__webpack_require__("B+Nj");


var FroalaEditorDirective = /*@__PURE__*/ (function () {
    function FroalaEditorDirective(el, zone) {
        this.zone = zone;
        // editor options
        this._opts = {
            immediateAngularModelUpdate: false,
            angularIgnoreAttrs: null
        };
        this.SPECIAL_TAGS = ['img', 'button', 'input', 'a'];
        this.INNER_HTML_ATTR = 'innerHTML';
        this._hasSpecialTag = false;
        this._listeningEvents = [];
        this._editorInitialized = false;
        this._oldModel = null;
        // Begin ControlValueAccesor methods.
        this.onChange = function (_) { };
        this.onTouched = function () { };
        // froalaModel directive as output: update model if editor contentChanged
        this.froalaModelChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        // froalaInit directive as output: send manual editor initialization
        this.froalaInit = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        var element = el.nativeElement;
        // check if the element is a special tag
        if (this.SPECIAL_TAGS.indexOf(element.tagName.toLowerCase()) != -1) {
            this._hasSpecialTag = true;
        }
        // jquery wrap and store element
        this._$element = $(element);
        this.zone = zone;
    }
    // Form model content changed.
    // Form model content changed.
    FroalaEditorDirective.prototype.writeValue =
        // Form model content changed.
        function (content) {
            this.updateEditor(content);
        };
    FroalaEditorDirective.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    FroalaEditorDirective.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    Object.defineProperty(FroalaEditorDirective.prototype, "froalaEditor", {
        set: 
        // End ControlValueAccesor methods.
        // froalaEditor directive as input: store the editor options
        function (opts) {
            this._opts = opts || this._opts;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FroalaEditorDirective.prototype, "froalaModel", {
        set: 
        // froalaModel directive as input: store initial editor content
        function (content) {
            this.updateEditor(content);
        },
        enumerable: true,
        configurable: true
    });
    // Update editor with model contents.
    // Update editor with model contents.
    FroalaEditorDirective.prototype.updateEditor =
        // Update editor with model contents.
        function (content) {
            if (JSON.stringify(this._oldModel) == JSON.stringify(content)) {
                return;
            }
            this._model = content;
            if (this._editorInitialized) {
                this._$element.froalaEditor('html.set', content);
            }
            else {
                this._$element.html(content);
            }
        };
    // update model if editor contentChanged
    // update model if editor contentChanged
    FroalaEditorDirective.prototype.updateModel =
        // update model if editor contentChanged
        function () {
            var _this = this;
            this.zone.run(function () {
                var modelContent = null;
                if (_this._hasSpecialTag) {
                    var attributeNodes = _this._$element[0].attributes;
                    var attrs = {};
                    for (var i = 0; i < attributeNodes.length; i++) {
                        var attrName = attributeNodes[i].name;
                        if (_this._opts.angularIgnoreAttrs && _this._opts.angularIgnoreAttrs.indexOf(attrName) != -1) {
                            continue;
                        }
                        attrs[attrName] = attributeNodes[i].value;
                    }
                    if (_this._$element[0].innerHTML) {
                        attrs[_this.INNER_HTML_ATTR] = _this._$element[0].innerHTML;
                    }
                    modelContent = attrs;
                }
                else {
                    var returnedHtml = _this._$element.froalaEditor('html.get');
                    if (typeof returnedHtml === 'string') {
                        modelContent = returnedHtml;
                    }
                }
                _this._oldModel = modelContent;
                // Update froalaModel.
                // Update froalaModel.
                _this.froalaModelChange.emit(modelContent);
                // Update form model.
                // Update form model.
                _this.onChange(modelContent);
            });
        };
    // register event on jquery element
    // register event on jquery element
    FroalaEditorDirective.prototype.registerEvent =
        // register event on jquery element
        function (element, eventName, callback) {
            if (!element || !eventName || !callback) {
                return;
            }
            this._listeningEvents.push(eventName);
            element.on(eventName, callback);
        };
    FroalaEditorDirective.prototype.initListeners = function () {
        var self = this;
        // bind contentChange and keyup event to froalaModel
        this.registerEvent(this._$element, 'froalaEditor.contentChanged', function () {
            setTimeout(function () {
                self.updateModel();
            }, 0);
        });
        if (this._opts.immediateAngularModelUpdate) {
            this.registerEvent(this._editor, 'keyup', function () {
                setTimeout(function () {
                    self.updateModel();
                }, 0);
            });
        }
    };
    // register events from editor options
    // register events from editor options
    FroalaEditorDirective.prototype.registerFroalaEvents =
        // register events from editor options
        function () {
            if (!this._opts.events) {
                return;
            }
            for (var eventName in this._opts.events) {
                if (this._opts.events.hasOwnProperty(eventName)) {
                    this.registerEvent(this._$element, eventName, this._opts.events[eventName]);
                }
            }
        };
    FroalaEditorDirective.prototype.createEditor = function () {
        var _this = this;
        if (this._editorInitialized) {
            return;
        }
        this.setContent(true);
        // Registering events before initializing the editor will bind the initialized event correctly.
        this.registerFroalaEvents();
        this.initListeners();
        // init editor
        this.zone.runOutsideAngular(function () {
            _this._editor = _this._$element.froalaEditor(_this._opts).data('froala.editor').$el;
        });
        this._editorInitialized = true;
    };
    FroalaEditorDirective.prototype.setHtml = function () {
        this._$element.froalaEditor('html.set', this._model || '', true);
        // This will reset the undo stack everytime the model changes externally. Can we fix this?
        this._$element.froalaEditor('undo.reset');
        this._$element.froalaEditor('undo.saveStep');
    };
    FroalaEditorDirective.prototype.setContent = function (firstTime) {
        if (firstTime === void 0) {
            firstTime = false;
        }
        var self = this;
        // Set initial content
        if (this._model || this._model == '') {
            this._oldModel = this._model;
            if (this._hasSpecialTag) {
                var tags = this._model;
                // add tags on element
                if (tags) {
                    for (var attr in tags) {
                        if (tags.hasOwnProperty(attr) && attr != this.INNER_HTML_ATTR) {
                            this._$element.attr(attr, tags[attr]);
                        }
                    }
                    if (tags.hasOwnProperty(this.INNER_HTML_ATTR)) {
                        this._$element[0].innerHTML = tags[this.INNER_HTML_ATTR];
                    }
                }
            }
            else {
                if (firstTime) {
                    this.registerEvent(this._$element, 'froalaEditor.initialized', function () {
                        self.setHtml();
                    });
                }
                else {
                    self.setHtml();
                }
            }
        }
    };
    FroalaEditorDirective.prototype.destroyEditor = function () {
        if (this._editorInitialized) {
            this._$element.off(this._listeningEvents.join(" "));
            this._editor.off('keyup');
            this._$element.froalaEditor('destroy');
            this._listeningEvents.length = 0;
            this._editorInitialized = false;
        }
    };
    FroalaEditorDirective.prototype.getEditor = function () {
        if (this._$element) {
            return this._$element.froalaEditor.bind(this._$element);
        }
        return null;
    };
    // send manual editor initialization
    // send manual editor initialization
    FroalaEditorDirective.prototype.generateManualController =
        // send manual editor initialization
        function () {
            var self = this;
            var controls = {
                initialize: this.createEditor.bind(this),
                destroy: this.destroyEditor.bind(this),
                getEditor: this.getEditor.bind(this),
            };
            this.froalaInit.emit(controls);
        };
    // TODO not sure if ngOnInit is executed after @inputs
    // TODO not sure if ngOnInit is executed after @inputs
    FroalaEditorDirective.prototype.ngOnInit =
        // TODO not sure if ngOnInit is executed after @inputs
        function () {
            // check if output froalaInit is present. Maybe observers is private and should not be used?? TODO how to better test that an output directive is present.
            if (!this.froalaInit.observers.length) {
                this.createEditor();
            }
            else {
                this.generateManualController();
            }
        };
    FroalaEditorDirective.prototype.ngOnDestroy = function () {
        this.destroyEditor();
    };
    return FroalaEditorDirective;
}());





/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("mypn");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "16tV":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("tO4o"),
    keys = __webpack_require__("ktak");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "1C79":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("uIr7"),
    isFlattenable = __webpack_require__("Qp3N");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ "1E73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OuterSubscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));






/***/ }),

/***/ "1QDk":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("tv3T"),
    getSymbolsIn = __webpack_require__("09Qt");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "1SoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isDate;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
//# sourceMappingURL=isDate.js.map


/***/ }),

/***/ "1Yb9":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("mgnk"),
    isObjectLike = __webpack_require__("UnEC");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "1o7w":
/***/ (function(module, exports) {

var ENTITIES = [['Aacute', [193]], ['aacute', [225]], ['Abreve', [258]], ['abreve', [259]], ['ac', [8766]], ['acd', [8767]], ['acE', [8766, 819]], ['Acirc', [194]], ['acirc', [226]], ['acute', [180]], ['Acy', [1040]], ['acy', [1072]], ['AElig', [198]], ['aelig', [230]], ['af', [8289]], ['Afr', [120068]], ['afr', [120094]], ['Agrave', [192]], ['agrave', [224]], ['alefsym', [8501]], ['aleph', [8501]], ['Alpha', [913]], ['alpha', [945]], ['Amacr', [256]], ['amacr', [257]], ['amalg', [10815]], ['amp', [38]], ['AMP', [38]], ['andand', [10837]], ['And', [10835]], ['and', [8743]], ['andd', [10844]], ['andslope', [10840]], ['andv', [10842]], ['ang', [8736]], ['ange', [10660]], ['angle', [8736]], ['angmsdaa', [10664]], ['angmsdab', [10665]], ['angmsdac', [10666]], ['angmsdad', [10667]], ['angmsdae', [10668]], ['angmsdaf', [10669]], ['angmsdag', [10670]], ['angmsdah', [10671]], ['angmsd', [8737]], ['angrt', [8735]], ['angrtvb', [8894]], ['angrtvbd', [10653]], ['angsph', [8738]], ['angst', [197]], ['angzarr', [9084]], ['Aogon', [260]], ['aogon', [261]], ['Aopf', [120120]], ['aopf', [120146]], ['apacir', [10863]], ['ap', [8776]], ['apE', [10864]], ['ape', [8778]], ['apid', [8779]], ['apos', [39]], ['ApplyFunction', [8289]], ['approx', [8776]], ['approxeq', [8778]], ['Aring', [197]], ['aring', [229]], ['Ascr', [119964]], ['ascr', [119990]], ['Assign', [8788]], ['ast', [42]], ['asymp', [8776]], ['asympeq', [8781]], ['Atilde', [195]], ['atilde', [227]], ['Auml', [196]], ['auml', [228]], ['awconint', [8755]], ['awint', [10769]], ['backcong', [8780]], ['backepsilon', [1014]], ['backprime', [8245]], ['backsim', [8765]], ['backsimeq', [8909]], ['Backslash', [8726]], ['Barv', [10983]], ['barvee', [8893]], ['barwed', [8965]], ['Barwed', [8966]], ['barwedge', [8965]], ['bbrk', [9141]], ['bbrktbrk', [9142]], ['bcong', [8780]], ['Bcy', [1041]], ['bcy', [1073]], ['bdquo', [8222]], ['becaus', [8757]], ['because', [8757]], ['Because', [8757]], ['bemptyv', [10672]], ['bepsi', [1014]], ['bernou', [8492]], ['Bernoullis', [8492]], ['Beta', [914]], ['beta', [946]], ['beth', [8502]], ['between', [8812]], ['Bfr', [120069]], ['bfr', [120095]], ['bigcap', [8898]], ['bigcirc', [9711]], ['bigcup', [8899]], ['bigodot', [10752]], ['bigoplus', [10753]], ['bigotimes', [10754]], ['bigsqcup', [10758]], ['bigstar', [9733]], ['bigtriangledown', [9661]], ['bigtriangleup', [9651]], ['biguplus', [10756]], ['bigvee', [8897]], ['bigwedge', [8896]], ['bkarow', [10509]], ['blacklozenge', [10731]], ['blacksquare', [9642]], ['blacktriangle', [9652]], ['blacktriangledown', [9662]], ['blacktriangleleft', [9666]], ['blacktriangleright', [9656]], ['blank', [9251]], ['blk12', [9618]], ['blk14', [9617]], ['blk34', [9619]], ['block', [9608]], ['bne', [61, 8421]], ['bnequiv', [8801, 8421]], ['bNot', [10989]], ['bnot', [8976]], ['Bopf', [120121]], ['bopf', [120147]], ['bot', [8869]], ['bottom', [8869]], ['bowtie', [8904]], ['boxbox', [10697]], ['boxdl', [9488]], ['boxdL', [9557]], ['boxDl', [9558]], ['boxDL', [9559]], ['boxdr', [9484]], ['boxdR', [9554]], ['boxDr', [9555]], ['boxDR', [9556]], ['boxh', [9472]], ['boxH', [9552]], ['boxhd', [9516]], ['boxHd', [9572]], ['boxhD', [9573]], ['boxHD', [9574]], ['boxhu', [9524]], ['boxHu', [9575]], ['boxhU', [9576]], ['boxHU', [9577]], ['boxminus', [8863]], ['boxplus', [8862]], ['boxtimes', [8864]], ['boxul', [9496]], ['boxuL', [9563]], ['boxUl', [9564]], ['boxUL', [9565]], ['boxur', [9492]], ['boxuR', [9560]], ['boxUr', [9561]], ['boxUR', [9562]], ['boxv', [9474]], ['boxV', [9553]], ['boxvh', [9532]], ['boxvH', [9578]], ['boxVh', [9579]], ['boxVH', [9580]], ['boxvl', [9508]], ['boxvL', [9569]], ['boxVl', [9570]], ['boxVL', [9571]], ['boxvr', [9500]], ['boxvR', [9566]], ['boxVr', [9567]], ['boxVR', [9568]], ['bprime', [8245]], ['breve', [728]], ['Breve', [728]], ['brvbar', [166]], ['bscr', [119991]], ['Bscr', [8492]], ['bsemi', [8271]], ['bsim', [8765]], ['bsime', [8909]], ['bsolb', [10693]], ['bsol', [92]], ['bsolhsub', [10184]], ['bull', [8226]], ['bullet', [8226]], ['bump', [8782]], ['bumpE', [10926]], ['bumpe', [8783]], ['Bumpeq', [8782]], ['bumpeq', [8783]], ['Cacute', [262]], ['cacute', [263]], ['capand', [10820]], ['capbrcup', [10825]], ['capcap', [10827]], ['cap', [8745]], ['Cap', [8914]], ['capcup', [10823]], ['capdot', [10816]], ['CapitalDifferentialD', [8517]], ['caps', [8745, 65024]], ['caret', [8257]], ['caron', [711]], ['Cayleys', [8493]], ['ccaps', [10829]], ['Ccaron', [268]], ['ccaron', [269]], ['Ccedil', [199]], ['ccedil', [231]], ['Ccirc', [264]], ['ccirc', [265]], ['Cconint', [8752]], ['ccups', [10828]], ['ccupssm', [10832]], ['Cdot', [266]], ['cdot', [267]], ['cedil', [184]], ['Cedilla', [184]], ['cemptyv', [10674]], ['cent', [162]], ['centerdot', [183]], ['CenterDot', [183]], ['cfr', [120096]], ['Cfr', [8493]], ['CHcy', [1063]], ['chcy', [1095]], ['check', [10003]], ['checkmark', [10003]], ['Chi', [935]], ['chi', [967]], ['circ', [710]], ['circeq', [8791]], ['circlearrowleft', [8634]], ['circlearrowright', [8635]], ['circledast', [8859]], ['circledcirc', [8858]], ['circleddash', [8861]], ['CircleDot', [8857]], ['circledR', [174]], ['circledS', [9416]], ['CircleMinus', [8854]], ['CirclePlus', [8853]], ['CircleTimes', [8855]], ['cir', [9675]], ['cirE', [10691]], ['cire', [8791]], ['cirfnint', [10768]], ['cirmid', [10991]], ['cirscir', [10690]], ['ClockwiseContourIntegral', [8754]], ['clubs', [9827]], ['clubsuit', [9827]], ['colon', [58]], ['Colon', [8759]], ['Colone', [10868]], ['colone', [8788]], ['coloneq', [8788]], ['comma', [44]], ['commat', [64]], ['comp', [8705]], ['compfn', [8728]], ['complement', [8705]], ['complexes', [8450]], ['cong', [8773]], ['congdot', [10861]], ['Congruent', [8801]], ['conint', [8750]], ['Conint', [8751]], ['ContourIntegral', [8750]], ['copf', [120148]], ['Copf', [8450]], ['coprod', [8720]], ['Coproduct', [8720]], ['copy', [169]], ['COPY', [169]], ['copysr', [8471]], ['CounterClockwiseContourIntegral', [8755]], ['crarr', [8629]], ['cross', [10007]], ['Cross', [10799]], ['Cscr', [119966]], ['cscr', [119992]], ['csub', [10959]], ['csube', [10961]], ['csup', [10960]], ['csupe', [10962]], ['ctdot', [8943]], ['cudarrl', [10552]], ['cudarrr', [10549]], ['cuepr', [8926]], ['cuesc', [8927]], ['cularr', [8630]], ['cularrp', [10557]], ['cupbrcap', [10824]], ['cupcap', [10822]], ['CupCap', [8781]], ['cup', [8746]], ['Cup', [8915]], ['cupcup', [10826]], ['cupdot', [8845]], ['cupor', [10821]], ['cups', [8746, 65024]], ['curarr', [8631]], ['curarrm', [10556]], ['curlyeqprec', [8926]], ['curlyeqsucc', [8927]], ['curlyvee', [8910]], ['curlywedge', [8911]], ['curren', [164]], ['curvearrowleft', [8630]], ['curvearrowright', [8631]], ['cuvee', [8910]], ['cuwed', [8911]], ['cwconint', [8754]], ['cwint', [8753]], ['cylcty', [9005]], ['dagger', [8224]], ['Dagger', [8225]], ['daleth', [8504]], ['darr', [8595]], ['Darr', [8609]], ['dArr', [8659]], ['dash', [8208]], ['Dashv', [10980]], ['dashv', [8867]], ['dbkarow', [10511]], ['dblac', [733]], ['Dcaron', [270]], ['dcaron', [271]], ['Dcy', [1044]], ['dcy', [1076]], ['ddagger', [8225]], ['ddarr', [8650]], ['DD', [8517]], ['dd', [8518]], ['DDotrahd', [10513]], ['ddotseq', [10871]], ['deg', [176]], ['Del', [8711]], ['Delta', [916]], ['delta', [948]], ['demptyv', [10673]], ['dfisht', [10623]], ['Dfr', [120071]], ['dfr', [120097]], ['dHar', [10597]], ['dharl', [8643]], ['dharr', [8642]], ['DiacriticalAcute', [180]], ['DiacriticalDot', [729]], ['DiacriticalDoubleAcute', [733]], ['DiacriticalGrave', [96]], ['DiacriticalTilde', [732]], ['diam', [8900]], ['diamond', [8900]], ['Diamond', [8900]], ['diamondsuit', [9830]], ['diams', [9830]], ['die', [168]], ['DifferentialD', [8518]], ['digamma', [989]], ['disin', [8946]], ['div', [247]], ['divide', [247]], ['divideontimes', [8903]], ['divonx', [8903]], ['DJcy', [1026]], ['djcy', [1106]], ['dlcorn', [8990]], ['dlcrop', [8973]], ['dollar', [36]], ['Dopf', [120123]], ['dopf', [120149]], ['Dot', [168]], ['dot', [729]], ['DotDot', [8412]], ['doteq', [8784]], ['doteqdot', [8785]], ['DotEqual', [8784]], ['dotminus', [8760]], ['dotplus', [8724]], ['dotsquare', [8865]], ['doublebarwedge', [8966]], ['DoubleContourIntegral', [8751]], ['DoubleDot', [168]], ['DoubleDownArrow', [8659]], ['DoubleLeftArrow', [8656]], ['DoubleLeftRightArrow', [8660]], ['DoubleLeftTee', [10980]], ['DoubleLongLeftArrow', [10232]], ['DoubleLongLeftRightArrow', [10234]], ['DoubleLongRightArrow', [10233]], ['DoubleRightArrow', [8658]], ['DoubleRightTee', [8872]], ['DoubleUpArrow', [8657]], ['DoubleUpDownArrow', [8661]], ['DoubleVerticalBar', [8741]], ['DownArrowBar', [10515]], ['downarrow', [8595]], ['DownArrow', [8595]], ['Downarrow', [8659]], ['DownArrowUpArrow', [8693]], ['DownBreve', [785]], ['downdownarrows', [8650]], ['downharpoonleft', [8643]], ['downharpoonright', [8642]], ['DownLeftRightVector', [10576]], ['DownLeftTeeVector', [10590]], ['DownLeftVectorBar', [10582]], ['DownLeftVector', [8637]], ['DownRightTeeVector', [10591]], ['DownRightVectorBar', [10583]], ['DownRightVector', [8641]], ['DownTeeArrow', [8615]], ['DownTee', [8868]], ['drbkarow', [10512]], ['drcorn', [8991]], ['drcrop', [8972]], ['Dscr', [119967]], ['dscr', [119993]], ['DScy', [1029]], ['dscy', [1109]], ['dsol', [10742]], ['Dstrok', [272]], ['dstrok', [273]], ['dtdot', [8945]], ['dtri', [9663]], ['dtrif', [9662]], ['duarr', [8693]], ['duhar', [10607]], ['dwangle', [10662]], ['DZcy', [1039]], ['dzcy', [1119]], ['dzigrarr', [10239]], ['Eacute', [201]], ['eacute', [233]], ['easter', [10862]], ['Ecaron', [282]], ['ecaron', [283]], ['Ecirc', [202]], ['ecirc', [234]], ['ecir', [8790]], ['ecolon', [8789]], ['Ecy', [1069]], ['ecy', [1101]], ['eDDot', [10871]], ['Edot', [278]], ['edot', [279]], ['eDot', [8785]], ['ee', [8519]], ['efDot', [8786]], ['Efr', [120072]], ['efr', [120098]], ['eg', [10906]], ['Egrave', [200]], ['egrave', [232]], ['egs', [10902]], ['egsdot', [10904]], ['el', [10905]], ['Element', [8712]], ['elinters', [9191]], ['ell', [8467]], ['els', [10901]], ['elsdot', [10903]], ['Emacr', [274]], ['emacr', [275]], ['empty', [8709]], ['emptyset', [8709]], ['EmptySmallSquare', [9723]], ['emptyv', [8709]], ['EmptyVerySmallSquare', [9643]], ['emsp13', [8196]], ['emsp14', [8197]], ['emsp', [8195]], ['ENG', [330]], ['eng', [331]], ['ensp', [8194]], ['Eogon', [280]], ['eogon', [281]], ['Eopf', [120124]], ['eopf', [120150]], ['epar', [8917]], ['eparsl', [10723]], ['eplus', [10865]], ['epsi', [949]], ['Epsilon', [917]], ['epsilon', [949]], ['epsiv', [1013]], ['eqcirc', [8790]], ['eqcolon', [8789]], ['eqsim', [8770]], ['eqslantgtr', [10902]], ['eqslantless', [10901]], ['Equal', [10869]], ['equals', [61]], ['EqualTilde', [8770]], ['equest', [8799]], ['Equilibrium', [8652]], ['equiv', [8801]], ['equivDD', [10872]], ['eqvparsl', [10725]], ['erarr', [10609]], ['erDot', [8787]], ['escr', [8495]], ['Escr', [8496]], ['esdot', [8784]], ['Esim', [10867]], ['esim', [8770]], ['Eta', [919]], ['eta', [951]], ['ETH', [208]], ['eth', [240]], ['Euml', [203]], ['euml', [235]], ['euro', [8364]], ['excl', [33]], ['exist', [8707]], ['Exists', [8707]], ['expectation', [8496]], ['exponentiale', [8519]], ['ExponentialE', [8519]], ['fallingdotseq', [8786]], ['Fcy', [1060]], ['fcy', [1092]], ['female', [9792]], ['ffilig', [64259]], ['fflig', [64256]], ['ffllig', [64260]], ['Ffr', [120073]], ['ffr', [120099]], ['filig', [64257]], ['FilledSmallSquare', [9724]], ['FilledVerySmallSquare', [9642]], ['fjlig', [102, 106]], ['flat', [9837]], ['fllig', [64258]], ['fltns', [9649]], ['fnof', [402]], ['Fopf', [120125]], ['fopf', [120151]], ['forall', [8704]], ['ForAll', [8704]], ['fork', [8916]], ['forkv', [10969]], ['Fouriertrf', [8497]], ['fpartint', [10765]], ['frac12', [189]], ['frac13', [8531]], ['frac14', [188]], ['frac15', [8533]], ['frac16', [8537]], ['frac18', [8539]], ['frac23', [8532]], ['frac25', [8534]], ['frac34', [190]], ['frac35', [8535]], ['frac38', [8540]], ['frac45', [8536]], ['frac56', [8538]], ['frac58', [8541]], ['frac78', [8542]], ['frasl', [8260]], ['frown', [8994]], ['fscr', [119995]], ['Fscr', [8497]], ['gacute', [501]], ['Gamma', [915]], ['gamma', [947]], ['Gammad', [988]], ['gammad', [989]], ['gap', [10886]], ['Gbreve', [286]], ['gbreve', [287]], ['Gcedil', [290]], ['Gcirc', [284]], ['gcirc', [285]], ['Gcy', [1043]], ['gcy', [1075]], ['Gdot', [288]], ['gdot', [289]], ['ge', [8805]], ['gE', [8807]], ['gEl', [10892]], ['gel', [8923]], ['geq', [8805]], ['geqq', [8807]], ['geqslant', [10878]], ['gescc', [10921]], ['ges', [10878]], ['gesdot', [10880]], ['gesdoto', [10882]], ['gesdotol', [10884]], ['gesl', [8923, 65024]], ['gesles', [10900]], ['Gfr', [120074]], ['gfr', [120100]], ['gg', [8811]], ['Gg', [8921]], ['ggg', [8921]], ['gimel', [8503]], ['GJcy', [1027]], ['gjcy', [1107]], ['gla', [10917]], ['gl', [8823]], ['glE', [10898]], ['glj', [10916]], ['gnap', [10890]], ['gnapprox', [10890]], ['gne', [10888]], ['gnE', [8809]], ['gneq', [10888]], ['gneqq', [8809]], ['gnsim', [8935]], ['Gopf', [120126]], ['gopf', [120152]], ['grave', [96]], ['GreaterEqual', [8805]], ['GreaterEqualLess', [8923]], ['GreaterFullEqual', [8807]], ['GreaterGreater', [10914]], ['GreaterLess', [8823]], ['GreaterSlantEqual', [10878]], ['GreaterTilde', [8819]], ['Gscr', [119970]], ['gscr', [8458]], ['gsim', [8819]], ['gsime', [10894]], ['gsiml', [10896]], ['gtcc', [10919]], ['gtcir', [10874]], ['gt', [62]], ['GT', [62]], ['Gt', [8811]], ['gtdot', [8919]], ['gtlPar', [10645]], ['gtquest', [10876]], ['gtrapprox', [10886]], ['gtrarr', [10616]], ['gtrdot', [8919]], ['gtreqless', [8923]], ['gtreqqless', [10892]], ['gtrless', [8823]], ['gtrsim', [8819]], ['gvertneqq', [8809, 65024]], ['gvnE', [8809, 65024]], ['Hacek', [711]], ['hairsp', [8202]], ['half', [189]], ['hamilt', [8459]], ['HARDcy', [1066]], ['hardcy', [1098]], ['harrcir', [10568]], ['harr', [8596]], ['hArr', [8660]], ['harrw', [8621]], ['Hat', [94]], ['hbar', [8463]], ['Hcirc', [292]], ['hcirc', [293]], ['hearts', [9829]], ['heartsuit', [9829]], ['hellip', [8230]], ['hercon', [8889]], ['hfr', [120101]], ['Hfr', [8460]], ['HilbertSpace', [8459]], ['hksearow', [10533]], ['hkswarow', [10534]], ['hoarr', [8703]], ['homtht', [8763]], ['hookleftarrow', [8617]], ['hookrightarrow', [8618]], ['hopf', [120153]], ['Hopf', [8461]], ['horbar', [8213]], ['HorizontalLine', [9472]], ['hscr', [119997]], ['Hscr', [8459]], ['hslash', [8463]], ['Hstrok', [294]], ['hstrok', [295]], ['HumpDownHump', [8782]], ['HumpEqual', [8783]], ['hybull', [8259]], ['hyphen', [8208]], ['Iacute', [205]], ['iacute', [237]], ['ic', [8291]], ['Icirc', [206]], ['icirc', [238]], ['Icy', [1048]], ['icy', [1080]], ['Idot', [304]], ['IEcy', [1045]], ['iecy', [1077]], ['iexcl', [161]], ['iff', [8660]], ['ifr', [120102]], ['Ifr', [8465]], ['Igrave', [204]], ['igrave', [236]], ['ii', [8520]], ['iiiint', [10764]], ['iiint', [8749]], ['iinfin', [10716]], ['iiota', [8489]], ['IJlig', [306]], ['ijlig', [307]], ['Imacr', [298]], ['imacr', [299]], ['image', [8465]], ['ImaginaryI', [8520]], ['imagline', [8464]], ['imagpart', [8465]], ['imath', [305]], ['Im', [8465]], ['imof', [8887]], ['imped', [437]], ['Implies', [8658]], ['incare', [8453]], ['in', [8712]], ['infin', [8734]], ['infintie', [10717]], ['inodot', [305]], ['intcal', [8890]], ['int', [8747]], ['Int', [8748]], ['integers', [8484]], ['Integral', [8747]], ['intercal', [8890]], ['Intersection', [8898]], ['intlarhk', [10775]], ['intprod', [10812]], ['InvisibleComma', [8291]], ['InvisibleTimes', [8290]], ['IOcy', [1025]], ['iocy', [1105]], ['Iogon', [302]], ['iogon', [303]], ['Iopf', [120128]], ['iopf', [120154]], ['Iota', [921]], ['iota', [953]], ['iprod', [10812]], ['iquest', [191]], ['iscr', [119998]], ['Iscr', [8464]], ['isin', [8712]], ['isindot', [8949]], ['isinE', [8953]], ['isins', [8948]], ['isinsv', [8947]], ['isinv', [8712]], ['it', [8290]], ['Itilde', [296]], ['itilde', [297]], ['Iukcy', [1030]], ['iukcy', [1110]], ['Iuml', [207]], ['iuml', [239]], ['Jcirc', [308]], ['jcirc', [309]], ['Jcy', [1049]], ['jcy', [1081]], ['Jfr', [120077]], ['jfr', [120103]], ['jmath', [567]], ['Jopf', [120129]], ['jopf', [120155]], ['Jscr', [119973]], ['jscr', [119999]], ['Jsercy', [1032]], ['jsercy', [1112]], ['Jukcy', [1028]], ['jukcy', [1108]], ['Kappa', [922]], ['kappa', [954]], ['kappav', [1008]], ['Kcedil', [310]], ['kcedil', [311]], ['Kcy', [1050]], ['kcy', [1082]], ['Kfr', [120078]], ['kfr', [120104]], ['kgreen', [312]], ['KHcy', [1061]], ['khcy', [1093]], ['KJcy', [1036]], ['kjcy', [1116]], ['Kopf', [120130]], ['kopf', [120156]], ['Kscr', [119974]], ['kscr', [120000]], ['lAarr', [8666]], ['Lacute', [313]], ['lacute', [314]], ['laemptyv', [10676]], ['lagran', [8466]], ['Lambda', [923]], ['lambda', [955]], ['lang', [10216]], ['Lang', [10218]], ['langd', [10641]], ['langle', [10216]], ['lap', [10885]], ['Laplacetrf', [8466]], ['laquo', [171]], ['larrb', [8676]], ['larrbfs', [10527]], ['larr', [8592]], ['Larr', [8606]], ['lArr', [8656]], ['larrfs', [10525]], ['larrhk', [8617]], ['larrlp', [8619]], ['larrpl', [10553]], ['larrsim', [10611]], ['larrtl', [8610]], ['latail', [10521]], ['lAtail', [10523]], ['lat', [10923]], ['late', [10925]], ['lates', [10925, 65024]], ['lbarr', [10508]], ['lBarr', [10510]], ['lbbrk', [10098]], ['lbrace', [123]], ['lbrack', [91]], ['lbrke', [10635]], ['lbrksld', [10639]], ['lbrkslu', [10637]], ['Lcaron', [317]], ['lcaron', [318]], ['Lcedil', [315]], ['lcedil', [316]], ['lceil', [8968]], ['lcub', [123]], ['Lcy', [1051]], ['lcy', [1083]], ['ldca', [10550]], ['ldquo', [8220]], ['ldquor', [8222]], ['ldrdhar', [10599]], ['ldrushar', [10571]], ['ldsh', [8626]], ['le', [8804]], ['lE', [8806]], ['LeftAngleBracket', [10216]], ['LeftArrowBar', [8676]], ['leftarrow', [8592]], ['LeftArrow', [8592]], ['Leftarrow', [8656]], ['LeftArrowRightArrow', [8646]], ['leftarrowtail', [8610]], ['LeftCeiling', [8968]], ['LeftDoubleBracket', [10214]], ['LeftDownTeeVector', [10593]], ['LeftDownVectorBar', [10585]], ['LeftDownVector', [8643]], ['LeftFloor', [8970]], ['leftharpoondown', [8637]], ['leftharpoonup', [8636]], ['leftleftarrows', [8647]], ['leftrightarrow', [8596]], ['LeftRightArrow', [8596]], ['Leftrightarrow', [8660]], ['leftrightarrows', [8646]], ['leftrightharpoons', [8651]], ['leftrightsquigarrow', [8621]], ['LeftRightVector', [10574]], ['LeftTeeArrow', [8612]], ['LeftTee', [8867]], ['LeftTeeVector', [10586]], ['leftthreetimes', [8907]], ['LeftTriangleBar', [10703]], ['LeftTriangle', [8882]], ['LeftTriangleEqual', [8884]], ['LeftUpDownVector', [10577]], ['LeftUpTeeVector', [10592]], ['LeftUpVectorBar', [10584]], ['LeftUpVector', [8639]], ['LeftVectorBar', [10578]], ['LeftVector', [8636]], ['lEg', [10891]], ['leg', [8922]], ['leq', [8804]], ['leqq', [8806]], ['leqslant', [10877]], ['lescc', [10920]], ['les', [10877]], ['lesdot', [10879]], ['lesdoto', [10881]], ['lesdotor', [10883]], ['lesg', [8922, 65024]], ['lesges', [10899]], ['lessapprox', [10885]], ['lessdot', [8918]], ['lesseqgtr', [8922]], ['lesseqqgtr', [10891]], ['LessEqualGreater', [8922]], ['LessFullEqual', [8806]], ['LessGreater', [8822]], ['lessgtr', [8822]], ['LessLess', [10913]], ['lesssim', [8818]], ['LessSlantEqual', [10877]], ['LessTilde', [8818]], ['lfisht', [10620]], ['lfloor', [8970]], ['Lfr', [120079]], ['lfr', [120105]], ['lg', [8822]], ['lgE', [10897]], ['lHar', [10594]], ['lhard', [8637]], ['lharu', [8636]], ['lharul', [10602]], ['lhblk', [9604]], ['LJcy', [1033]], ['ljcy', [1113]], ['llarr', [8647]], ['ll', [8810]], ['Ll', [8920]], ['llcorner', [8990]], ['Lleftarrow', [8666]], ['llhard', [10603]], ['lltri', [9722]], ['Lmidot', [319]], ['lmidot', [320]], ['lmoustache', [9136]], ['lmoust', [9136]], ['lnap', [10889]], ['lnapprox', [10889]], ['lne', [10887]], ['lnE', [8808]], ['lneq', [10887]], ['lneqq', [8808]], ['lnsim', [8934]], ['loang', [10220]], ['loarr', [8701]], ['lobrk', [10214]], ['longleftarrow', [10229]], ['LongLeftArrow', [10229]], ['Longleftarrow', [10232]], ['longleftrightarrow', [10231]], ['LongLeftRightArrow', [10231]], ['Longleftrightarrow', [10234]], ['longmapsto', [10236]], ['longrightarrow', [10230]], ['LongRightArrow', [10230]], ['Longrightarrow', [10233]], ['looparrowleft', [8619]], ['looparrowright', [8620]], ['lopar', [10629]], ['Lopf', [120131]], ['lopf', [120157]], ['loplus', [10797]], ['lotimes', [10804]], ['lowast', [8727]], ['lowbar', [95]], ['LowerLeftArrow', [8601]], ['LowerRightArrow', [8600]], ['loz', [9674]], ['lozenge', [9674]], ['lozf', [10731]], ['lpar', [40]], ['lparlt', [10643]], ['lrarr', [8646]], ['lrcorner', [8991]], ['lrhar', [8651]], ['lrhard', [10605]], ['lrm', [8206]], ['lrtri', [8895]], ['lsaquo', [8249]], ['lscr', [120001]], ['Lscr', [8466]], ['lsh', [8624]], ['Lsh', [8624]], ['lsim', [8818]], ['lsime', [10893]], ['lsimg', [10895]], ['lsqb', [91]], ['lsquo', [8216]], ['lsquor', [8218]], ['Lstrok', [321]], ['lstrok', [322]], ['ltcc', [10918]], ['ltcir', [10873]], ['lt', [60]], ['LT', [60]], ['Lt', [8810]], ['ltdot', [8918]], ['lthree', [8907]], ['ltimes', [8905]], ['ltlarr', [10614]], ['ltquest', [10875]], ['ltri', [9667]], ['ltrie', [8884]], ['ltrif', [9666]], ['ltrPar', [10646]], ['lurdshar', [10570]], ['luruhar', [10598]], ['lvertneqq', [8808, 65024]], ['lvnE', [8808, 65024]], ['macr', [175]], ['male', [9794]], ['malt', [10016]], ['maltese', [10016]], ['Map', [10501]], ['map', [8614]], ['mapsto', [8614]], ['mapstodown', [8615]], ['mapstoleft', [8612]], ['mapstoup', [8613]], ['marker', [9646]], ['mcomma', [10793]], ['Mcy', [1052]], ['mcy', [1084]], ['mdash', [8212]], ['mDDot', [8762]], ['measuredangle', [8737]], ['MediumSpace', [8287]], ['Mellintrf', [8499]], ['Mfr', [120080]], ['mfr', [120106]], ['mho', [8487]], ['micro', [181]], ['midast', [42]], ['midcir', [10992]], ['mid', [8739]], ['middot', [183]], ['minusb', [8863]], ['minus', [8722]], ['minusd', [8760]], ['minusdu', [10794]], ['MinusPlus', [8723]], ['mlcp', [10971]], ['mldr', [8230]], ['mnplus', [8723]], ['models', [8871]], ['Mopf', [120132]], ['mopf', [120158]], ['mp', [8723]], ['mscr', [120002]], ['Mscr', [8499]], ['mstpos', [8766]], ['Mu', [924]], ['mu', [956]], ['multimap', [8888]], ['mumap', [8888]], ['nabla', [8711]], ['Nacute', [323]], ['nacute', [324]], ['nang', [8736, 8402]], ['nap', [8777]], ['napE', [10864, 824]], ['napid', [8779, 824]], ['napos', [329]], ['napprox', [8777]], ['natural', [9838]], ['naturals', [8469]], ['natur', [9838]], ['nbsp', [160]], ['nbump', [8782, 824]], ['nbumpe', [8783, 824]], ['ncap', [10819]], ['Ncaron', [327]], ['ncaron', [328]], ['Ncedil', [325]], ['ncedil', [326]], ['ncong', [8775]], ['ncongdot', [10861, 824]], ['ncup', [10818]], ['Ncy', [1053]], ['ncy', [1085]], ['ndash', [8211]], ['nearhk', [10532]], ['nearr', [8599]], ['neArr', [8663]], ['nearrow', [8599]], ['ne', [8800]], ['nedot', [8784, 824]], ['NegativeMediumSpace', [8203]], ['NegativeThickSpace', [8203]], ['NegativeThinSpace', [8203]], ['NegativeVeryThinSpace', [8203]], ['nequiv', [8802]], ['nesear', [10536]], ['nesim', [8770, 824]], ['NestedGreaterGreater', [8811]], ['NestedLessLess', [8810]], ['nexist', [8708]], ['nexists', [8708]], ['Nfr', [120081]], ['nfr', [120107]], ['ngE', [8807, 824]], ['nge', [8817]], ['ngeq', [8817]], ['ngeqq', [8807, 824]], ['ngeqslant', [10878, 824]], ['nges', [10878, 824]], ['nGg', [8921, 824]], ['ngsim', [8821]], ['nGt', [8811, 8402]], ['ngt', [8815]], ['ngtr', [8815]], ['nGtv', [8811, 824]], ['nharr', [8622]], ['nhArr', [8654]], ['nhpar', [10994]], ['ni', [8715]], ['nis', [8956]], ['nisd', [8954]], ['niv', [8715]], ['NJcy', [1034]], ['njcy', [1114]], ['nlarr', [8602]], ['nlArr', [8653]], ['nldr', [8229]], ['nlE', [8806, 824]], ['nle', [8816]], ['nleftarrow', [8602]], ['nLeftarrow', [8653]], ['nleftrightarrow', [8622]], ['nLeftrightarrow', [8654]], ['nleq', [8816]], ['nleqq', [8806, 824]], ['nleqslant', [10877, 824]], ['nles', [10877, 824]], ['nless', [8814]], ['nLl', [8920, 824]], ['nlsim', [8820]], ['nLt', [8810, 8402]], ['nlt', [8814]], ['nltri', [8938]], ['nltrie', [8940]], ['nLtv', [8810, 824]], ['nmid', [8740]], ['NoBreak', [8288]], ['NonBreakingSpace', [160]], ['nopf', [120159]], ['Nopf', [8469]], ['Not', [10988]], ['not', [172]], ['NotCongruent', [8802]], ['NotCupCap', [8813]], ['NotDoubleVerticalBar', [8742]], ['NotElement', [8713]], ['NotEqual', [8800]], ['NotEqualTilde', [8770, 824]], ['NotExists', [8708]], ['NotGreater', [8815]], ['NotGreaterEqual', [8817]], ['NotGreaterFullEqual', [8807, 824]], ['NotGreaterGreater', [8811, 824]], ['NotGreaterLess', [8825]], ['NotGreaterSlantEqual', [10878, 824]], ['NotGreaterTilde', [8821]], ['NotHumpDownHump', [8782, 824]], ['NotHumpEqual', [8783, 824]], ['notin', [8713]], ['notindot', [8949, 824]], ['notinE', [8953, 824]], ['notinva', [8713]], ['notinvb', [8951]], ['notinvc', [8950]], ['NotLeftTriangleBar', [10703, 824]], ['NotLeftTriangle', [8938]], ['NotLeftTriangleEqual', [8940]], ['NotLess', [8814]], ['NotLessEqual', [8816]], ['NotLessGreater', [8824]], ['NotLessLess', [8810, 824]], ['NotLessSlantEqual', [10877, 824]], ['NotLessTilde', [8820]], ['NotNestedGreaterGreater', [10914, 824]], ['NotNestedLessLess', [10913, 824]], ['notni', [8716]], ['notniva', [8716]], ['notnivb', [8958]], ['notnivc', [8957]], ['NotPrecedes', [8832]], ['NotPrecedesEqual', [10927, 824]], ['NotPrecedesSlantEqual', [8928]], ['NotReverseElement', [8716]], ['NotRightTriangleBar', [10704, 824]], ['NotRightTriangle', [8939]], ['NotRightTriangleEqual', [8941]], ['NotSquareSubset', [8847, 824]], ['NotSquareSubsetEqual', [8930]], ['NotSquareSuperset', [8848, 824]], ['NotSquareSupersetEqual', [8931]], ['NotSubset', [8834, 8402]], ['NotSubsetEqual', [8840]], ['NotSucceeds', [8833]], ['NotSucceedsEqual', [10928, 824]], ['NotSucceedsSlantEqual', [8929]], ['NotSucceedsTilde', [8831, 824]], ['NotSuperset', [8835, 8402]], ['NotSupersetEqual', [8841]], ['NotTilde', [8769]], ['NotTildeEqual', [8772]], ['NotTildeFullEqual', [8775]], ['NotTildeTilde', [8777]], ['NotVerticalBar', [8740]], ['nparallel', [8742]], ['npar', [8742]], ['nparsl', [11005, 8421]], ['npart', [8706, 824]], ['npolint', [10772]], ['npr', [8832]], ['nprcue', [8928]], ['nprec', [8832]], ['npreceq', [10927, 824]], ['npre', [10927, 824]], ['nrarrc', [10547, 824]], ['nrarr', [8603]], ['nrArr', [8655]], ['nrarrw', [8605, 824]], ['nrightarrow', [8603]], ['nRightarrow', [8655]], ['nrtri', [8939]], ['nrtrie', [8941]], ['nsc', [8833]], ['nsccue', [8929]], ['nsce', [10928, 824]], ['Nscr', [119977]], ['nscr', [120003]], ['nshortmid', [8740]], ['nshortparallel', [8742]], ['nsim', [8769]], ['nsime', [8772]], ['nsimeq', [8772]], ['nsmid', [8740]], ['nspar', [8742]], ['nsqsube', [8930]], ['nsqsupe', [8931]], ['nsub', [8836]], ['nsubE', [10949, 824]], ['nsube', [8840]], ['nsubset', [8834, 8402]], ['nsubseteq', [8840]], ['nsubseteqq', [10949, 824]], ['nsucc', [8833]], ['nsucceq', [10928, 824]], ['nsup', [8837]], ['nsupE', [10950, 824]], ['nsupe', [8841]], ['nsupset', [8835, 8402]], ['nsupseteq', [8841]], ['nsupseteqq', [10950, 824]], ['ntgl', [8825]], ['Ntilde', [209]], ['ntilde', [241]], ['ntlg', [8824]], ['ntriangleleft', [8938]], ['ntrianglelefteq', [8940]], ['ntriangleright', [8939]], ['ntrianglerighteq', [8941]], ['Nu', [925]], ['nu', [957]], ['num', [35]], ['numero', [8470]], ['numsp', [8199]], ['nvap', [8781, 8402]], ['nvdash', [8876]], ['nvDash', [8877]], ['nVdash', [8878]], ['nVDash', [8879]], ['nvge', [8805, 8402]], ['nvgt', [62, 8402]], ['nvHarr', [10500]], ['nvinfin', [10718]], ['nvlArr', [10498]], ['nvle', [8804, 8402]], ['nvlt', [60, 8402]], ['nvltrie', [8884, 8402]], ['nvrArr', [10499]], ['nvrtrie', [8885, 8402]], ['nvsim', [8764, 8402]], ['nwarhk', [10531]], ['nwarr', [8598]], ['nwArr', [8662]], ['nwarrow', [8598]], ['nwnear', [10535]], ['Oacute', [211]], ['oacute', [243]], ['oast', [8859]], ['Ocirc', [212]], ['ocirc', [244]], ['ocir', [8858]], ['Ocy', [1054]], ['ocy', [1086]], ['odash', [8861]], ['Odblac', [336]], ['odblac', [337]], ['odiv', [10808]], ['odot', [8857]], ['odsold', [10684]], ['OElig', [338]], ['oelig', [339]], ['ofcir', [10687]], ['Ofr', [120082]], ['ofr', [120108]], ['ogon', [731]], ['Ograve', [210]], ['ograve', [242]], ['ogt', [10689]], ['ohbar', [10677]], ['ohm', [937]], ['oint', [8750]], ['olarr', [8634]], ['olcir', [10686]], ['olcross', [10683]], ['oline', [8254]], ['olt', [10688]], ['Omacr', [332]], ['omacr', [333]], ['Omega', [937]], ['omega', [969]], ['Omicron', [927]], ['omicron', [959]], ['omid', [10678]], ['ominus', [8854]], ['Oopf', [120134]], ['oopf', [120160]], ['opar', [10679]], ['OpenCurlyDoubleQuote', [8220]], ['OpenCurlyQuote', [8216]], ['operp', [10681]], ['oplus', [8853]], ['orarr', [8635]], ['Or', [10836]], ['or', [8744]], ['ord', [10845]], ['order', [8500]], ['orderof', [8500]], ['ordf', [170]], ['ordm', [186]], ['origof', [8886]], ['oror', [10838]], ['orslope', [10839]], ['orv', [10843]], ['oS', [9416]], ['Oscr', [119978]], ['oscr', [8500]], ['Oslash', [216]], ['oslash', [248]], ['osol', [8856]], ['Otilde', [213]], ['otilde', [245]], ['otimesas', [10806]], ['Otimes', [10807]], ['otimes', [8855]], ['Ouml', [214]], ['ouml', [246]], ['ovbar', [9021]], ['OverBar', [8254]], ['OverBrace', [9182]], ['OverBracket', [9140]], ['OverParenthesis', [9180]], ['para', [182]], ['parallel', [8741]], ['par', [8741]], ['parsim', [10995]], ['parsl', [11005]], ['part', [8706]], ['PartialD', [8706]], ['Pcy', [1055]], ['pcy', [1087]], ['percnt', [37]], ['period', [46]], ['permil', [8240]], ['perp', [8869]], ['pertenk', [8241]], ['Pfr', [120083]], ['pfr', [120109]], ['Phi', [934]], ['phi', [966]], ['phiv', [981]], ['phmmat', [8499]], ['phone', [9742]], ['Pi', [928]], ['pi', [960]], ['pitchfork', [8916]], ['piv', [982]], ['planck', [8463]], ['planckh', [8462]], ['plankv', [8463]], ['plusacir', [10787]], ['plusb', [8862]], ['pluscir', [10786]], ['plus', [43]], ['plusdo', [8724]], ['plusdu', [10789]], ['pluse', [10866]], ['PlusMinus', [177]], ['plusmn', [177]], ['plussim', [10790]], ['plustwo', [10791]], ['pm', [177]], ['Poincareplane', [8460]], ['pointint', [10773]], ['popf', [120161]], ['Popf', [8473]], ['pound', [163]], ['prap', [10935]], ['Pr', [10939]], ['pr', [8826]], ['prcue', [8828]], ['precapprox', [10935]], ['prec', [8826]], ['preccurlyeq', [8828]], ['Precedes', [8826]], ['PrecedesEqual', [10927]], ['PrecedesSlantEqual', [8828]], ['PrecedesTilde', [8830]], ['preceq', [10927]], ['precnapprox', [10937]], ['precneqq', [10933]], ['precnsim', [8936]], ['pre', [10927]], ['prE', [10931]], ['precsim', [8830]], ['prime', [8242]], ['Prime', [8243]], ['primes', [8473]], ['prnap', [10937]], ['prnE', [10933]], ['prnsim', [8936]], ['prod', [8719]], ['Product', [8719]], ['profalar', [9006]], ['profline', [8978]], ['profsurf', [8979]], ['prop', [8733]], ['Proportional', [8733]], ['Proportion', [8759]], ['propto', [8733]], ['prsim', [8830]], ['prurel', [8880]], ['Pscr', [119979]], ['pscr', [120005]], ['Psi', [936]], ['psi', [968]], ['puncsp', [8200]], ['Qfr', [120084]], ['qfr', [120110]], ['qint', [10764]], ['qopf', [120162]], ['Qopf', [8474]], ['qprime', [8279]], ['Qscr', [119980]], ['qscr', [120006]], ['quaternions', [8461]], ['quatint', [10774]], ['quest', [63]], ['questeq', [8799]], ['quot', [34]], ['QUOT', [34]], ['rAarr', [8667]], ['race', [8765, 817]], ['Racute', [340]], ['racute', [341]], ['radic', [8730]], ['raemptyv', [10675]], ['rang', [10217]], ['Rang', [10219]], ['rangd', [10642]], ['range', [10661]], ['rangle', [10217]], ['raquo', [187]], ['rarrap', [10613]], ['rarrb', [8677]], ['rarrbfs', [10528]], ['rarrc', [10547]], ['rarr', [8594]], ['Rarr', [8608]], ['rArr', [8658]], ['rarrfs', [10526]], ['rarrhk', [8618]], ['rarrlp', [8620]], ['rarrpl', [10565]], ['rarrsim', [10612]], ['Rarrtl', [10518]], ['rarrtl', [8611]], ['rarrw', [8605]], ['ratail', [10522]], ['rAtail', [10524]], ['ratio', [8758]], ['rationals', [8474]], ['rbarr', [10509]], ['rBarr', [10511]], ['RBarr', [10512]], ['rbbrk', [10099]], ['rbrace', [125]], ['rbrack', [93]], ['rbrke', [10636]], ['rbrksld', [10638]], ['rbrkslu', [10640]], ['Rcaron', [344]], ['rcaron', [345]], ['Rcedil', [342]], ['rcedil', [343]], ['rceil', [8969]], ['rcub', [125]], ['Rcy', [1056]], ['rcy', [1088]], ['rdca', [10551]], ['rdldhar', [10601]], ['rdquo', [8221]], ['rdquor', [8221]], ['CloseCurlyDoubleQuote', [8221]], ['rdsh', [8627]], ['real', [8476]], ['realine', [8475]], ['realpart', [8476]], ['reals', [8477]], ['Re', [8476]], ['rect', [9645]], ['reg', [174]], ['REG', [174]], ['ReverseElement', [8715]], ['ReverseEquilibrium', [8651]], ['ReverseUpEquilibrium', [10607]], ['rfisht', [10621]], ['rfloor', [8971]], ['rfr', [120111]], ['Rfr', [8476]], ['rHar', [10596]], ['rhard', [8641]], ['rharu', [8640]], ['rharul', [10604]], ['Rho', [929]], ['rho', [961]], ['rhov', [1009]], ['RightAngleBracket', [10217]], ['RightArrowBar', [8677]], ['rightarrow', [8594]], ['RightArrow', [8594]], ['Rightarrow', [8658]], ['RightArrowLeftArrow', [8644]], ['rightarrowtail', [8611]], ['RightCeiling', [8969]], ['RightDoubleBracket', [10215]], ['RightDownTeeVector', [10589]], ['RightDownVectorBar', [10581]], ['RightDownVector', [8642]], ['RightFloor', [8971]], ['rightharpoondown', [8641]], ['rightharpoonup', [8640]], ['rightleftarrows', [8644]], ['rightleftharpoons', [8652]], ['rightrightarrows', [8649]], ['rightsquigarrow', [8605]], ['RightTeeArrow', [8614]], ['RightTee', [8866]], ['RightTeeVector', [10587]], ['rightthreetimes', [8908]], ['RightTriangleBar', [10704]], ['RightTriangle', [8883]], ['RightTriangleEqual', [8885]], ['RightUpDownVector', [10575]], ['RightUpTeeVector', [10588]], ['RightUpVectorBar', [10580]], ['RightUpVector', [8638]], ['RightVectorBar', [10579]], ['RightVector', [8640]], ['ring', [730]], ['risingdotseq', [8787]], ['rlarr', [8644]], ['rlhar', [8652]], ['rlm', [8207]], ['rmoustache', [9137]], ['rmoust', [9137]], ['rnmid', [10990]], ['roang', [10221]], ['roarr', [8702]], ['robrk', [10215]], ['ropar', [10630]], ['ropf', [120163]], ['Ropf', [8477]], ['roplus', [10798]], ['rotimes', [10805]], ['RoundImplies', [10608]], ['rpar', [41]], ['rpargt', [10644]], ['rppolint', [10770]], ['rrarr', [8649]], ['Rrightarrow', [8667]], ['rsaquo', [8250]], ['rscr', [120007]], ['Rscr', [8475]], ['rsh', [8625]], ['Rsh', [8625]], ['rsqb', [93]], ['rsquo', [8217]], ['rsquor', [8217]], ['CloseCurlyQuote', [8217]], ['rthree', [8908]], ['rtimes', [8906]], ['rtri', [9657]], ['rtrie', [8885]], ['rtrif', [9656]], ['rtriltri', [10702]], ['RuleDelayed', [10740]], ['ruluhar', [10600]], ['rx', [8478]], ['Sacute', [346]], ['sacute', [347]], ['sbquo', [8218]], ['scap', [10936]], ['Scaron', [352]], ['scaron', [353]], ['Sc', [10940]], ['sc', [8827]], ['sccue', [8829]], ['sce', [10928]], ['scE', [10932]], ['Scedil', [350]], ['scedil', [351]], ['Scirc', [348]], ['scirc', [349]], ['scnap', [10938]], ['scnE', [10934]], ['scnsim', [8937]], ['scpolint', [10771]], ['scsim', [8831]], ['Scy', [1057]], ['scy', [1089]], ['sdotb', [8865]], ['sdot', [8901]], ['sdote', [10854]], ['searhk', [10533]], ['searr', [8600]], ['seArr', [8664]], ['searrow', [8600]], ['sect', [167]], ['semi', [59]], ['seswar', [10537]], ['setminus', [8726]], ['setmn', [8726]], ['sext', [10038]], ['Sfr', [120086]], ['sfr', [120112]], ['sfrown', [8994]], ['sharp', [9839]], ['SHCHcy', [1065]], ['shchcy', [1097]], ['SHcy', [1064]], ['shcy', [1096]], ['ShortDownArrow', [8595]], ['ShortLeftArrow', [8592]], ['shortmid', [8739]], ['shortparallel', [8741]], ['ShortRightArrow', [8594]], ['ShortUpArrow', [8593]], ['shy', [173]], ['Sigma', [931]], ['sigma', [963]], ['sigmaf', [962]], ['sigmav', [962]], ['sim', [8764]], ['simdot', [10858]], ['sime', [8771]], ['simeq', [8771]], ['simg', [10910]], ['simgE', [10912]], ['siml', [10909]], ['simlE', [10911]], ['simne', [8774]], ['simplus', [10788]], ['simrarr', [10610]], ['slarr', [8592]], ['SmallCircle', [8728]], ['smallsetminus', [8726]], ['smashp', [10803]], ['smeparsl', [10724]], ['smid', [8739]], ['smile', [8995]], ['smt', [10922]], ['smte', [10924]], ['smtes', [10924, 65024]], ['SOFTcy', [1068]], ['softcy', [1100]], ['solbar', [9023]], ['solb', [10692]], ['sol', [47]], ['Sopf', [120138]], ['sopf', [120164]], ['spades', [9824]], ['spadesuit', [9824]], ['spar', [8741]], ['sqcap', [8851]], ['sqcaps', [8851, 65024]], ['sqcup', [8852]], ['sqcups', [8852, 65024]], ['Sqrt', [8730]], ['sqsub', [8847]], ['sqsube', [8849]], ['sqsubset', [8847]], ['sqsubseteq', [8849]], ['sqsup', [8848]], ['sqsupe', [8850]], ['sqsupset', [8848]], ['sqsupseteq', [8850]], ['square', [9633]], ['Square', [9633]], ['SquareIntersection', [8851]], ['SquareSubset', [8847]], ['SquareSubsetEqual', [8849]], ['SquareSuperset', [8848]], ['SquareSupersetEqual', [8850]], ['SquareUnion', [8852]], ['squarf', [9642]], ['squ', [9633]], ['squf', [9642]], ['srarr', [8594]], ['Sscr', [119982]], ['sscr', [120008]], ['ssetmn', [8726]], ['ssmile', [8995]], ['sstarf', [8902]], ['Star', [8902]], ['star', [9734]], ['starf', [9733]], ['straightepsilon', [1013]], ['straightphi', [981]], ['strns', [175]], ['sub', [8834]], ['Sub', [8912]], ['subdot', [10941]], ['subE', [10949]], ['sube', [8838]], ['subedot', [10947]], ['submult', [10945]], ['subnE', [10955]], ['subne', [8842]], ['subplus', [10943]], ['subrarr', [10617]], ['subset', [8834]], ['Subset', [8912]], ['subseteq', [8838]], ['subseteqq', [10949]], ['SubsetEqual', [8838]], ['subsetneq', [8842]], ['subsetneqq', [10955]], ['subsim', [10951]], ['subsub', [10965]], ['subsup', [10963]], ['succapprox', [10936]], ['succ', [8827]], ['succcurlyeq', [8829]], ['Succeeds', [8827]], ['SucceedsEqual', [10928]], ['SucceedsSlantEqual', [8829]], ['SucceedsTilde', [8831]], ['succeq', [10928]], ['succnapprox', [10938]], ['succneqq', [10934]], ['succnsim', [8937]], ['succsim', [8831]], ['SuchThat', [8715]], ['sum', [8721]], ['Sum', [8721]], ['sung', [9834]], ['sup1', [185]], ['sup2', [178]], ['sup3', [179]], ['sup', [8835]], ['Sup', [8913]], ['supdot', [10942]], ['supdsub', [10968]], ['supE', [10950]], ['supe', [8839]], ['supedot', [10948]], ['Superset', [8835]], ['SupersetEqual', [8839]], ['suphsol', [10185]], ['suphsub', [10967]], ['suplarr', [10619]], ['supmult', [10946]], ['supnE', [10956]], ['supne', [8843]], ['supplus', [10944]], ['supset', [8835]], ['Supset', [8913]], ['supseteq', [8839]], ['supseteqq', [10950]], ['supsetneq', [8843]], ['supsetneqq', [10956]], ['supsim', [10952]], ['supsub', [10964]], ['supsup', [10966]], ['swarhk', [10534]], ['swarr', [8601]], ['swArr', [8665]], ['swarrow', [8601]], ['swnwar', [10538]], ['szlig', [223]], ['Tab', [9]], ['target', [8982]], ['Tau', [932]], ['tau', [964]], ['tbrk', [9140]], ['Tcaron', [356]], ['tcaron', [357]], ['Tcedil', [354]], ['tcedil', [355]], ['Tcy', [1058]], ['tcy', [1090]], ['tdot', [8411]], ['telrec', [8981]], ['Tfr', [120087]], ['tfr', [120113]], ['there4', [8756]], ['therefore', [8756]], ['Therefore', [8756]], ['Theta', [920]], ['theta', [952]], ['thetasym', [977]], ['thetav', [977]], ['thickapprox', [8776]], ['thicksim', [8764]], ['ThickSpace', [8287, 8202]], ['ThinSpace', [8201]], ['thinsp', [8201]], ['thkap', [8776]], ['thksim', [8764]], ['THORN', [222]], ['thorn', [254]], ['tilde', [732]], ['Tilde', [8764]], ['TildeEqual', [8771]], ['TildeFullEqual', [8773]], ['TildeTilde', [8776]], ['timesbar', [10801]], ['timesb', [8864]], ['times', [215]], ['timesd', [10800]], ['tint', [8749]], ['toea', [10536]], ['topbot', [9014]], ['topcir', [10993]], ['top', [8868]], ['Topf', [120139]], ['topf', [120165]], ['topfork', [10970]], ['tosa', [10537]], ['tprime', [8244]], ['trade', [8482]], ['TRADE', [8482]], ['triangle', [9653]], ['triangledown', [9663]], ['triangleleft', [9667]], ['trianglelefteq', [8884]], ['triangleq', [8796]], ['triangleright', [9657]], ['trianglerighteq', [8885]], ['tridot', [9708]], ['trie', [8796]], ['triminus', [10810]], ['TripleDot', [8411]], ['triplus', [10809]], ['trisb', [10701]], ['tritime', [10811]], ['trpezium', [9186]], ['Tscr', [119983]], ['tscr', [120009]], ['TScy', [1062]], ['tscy', [1094]], ['TSHcy', [1035]], ['tshcy', [1115]], ['Tstrok', [358]], ['tstrok', [359]], ['twixt', [8812]], ['twoheadleftarrow', [8606]], ['twoheadrightarrow', [8608]], ['Uacute', [218]], ['uacute', [250]], ['uarr', [8593]], ['Uarr', [8607]], ['uArr', [8657]], ['Uarrocir', [10569]], ['Ubrcy', [1038]], ['ubrcy', [1118]], ['Ubreve', [364]], ['ubreve', [365]], ['Ucirc', [219]], ['ucirc', [251]], ['Ucy', [1059]], ['ucy', [1091]], ['udarr', [8645]], ['Udblac', [368]], ['udblac', [369]], ['udhar', [10606]], ['ufisht', [10622]], ['Ufr', [120088]], ['ufr', [120114]], ['Ugrave', [217]], ['ugrave', [249]], ['uHar', [10595]], ['uharl', [8639]], ['uharr', [8638]], ['uhblk', [9600]], ['ulcorn', [8988]], ['ulcorner', [8988]], ['ulcrop', [8975]], ['ultri', [9720]], ['Umacr', [362]], ['umacr', [363]], ['uml', [168]], ['UnderBar', [95]], ['UnderBrace', [9183]], ['UnderBracket', [9141]], ['UnderParenthesis', [9181]], ['Union', [8899]], ['UnionPlus', [8846]], ['Uogon', [370]], ['uogon', [371]], ['Uopf', [120140]], ['uopf', [120166]], ['UpArrowBar', [10514]], ['uparrow', [8593]], ['UpArrow', [8593]], ['Uparrow', [8657]], ['UpArrowDownArrow', [8645]], ['updownarrow', [8597]], ['UpDownArrow', [8597]], ['Updownarrow', [8661]], ['UpEquilibrium', [10606]], ['upharpoonleft', [8639]], ['upharpoonright', [8638]], ['uplus', [8846]], ['UpperLeftArrow', [8598]], ['UpperRightArrow', [8599]], ['upsi', [965]], ['Upsi', [978]], ['upsih', [978]], ['Upsilon', [933]], ['upsilon', [965]], ['UpTeeArrow', [8613]], ['UpTee', [8869]], ['upuparrows', [8648]], ['urcorn', [8989]], ['urcorner', [8989]], ['urcrop', [8974]], ['Uring', [366]], ['uring', [367]], ['urtri', [9721]], ['Uscr', [119984]], ['uscr', [120010]], ['utdot', [8944]], ['Utilde', [360]], ['utilde', [361]], ['utri', [9653]], ['utrif', [9652]], ['uuarr', [8648]], ['Uuml', [220]], ['uuml', [252]], ['uwangle', [10663]], ['vangrt', [10652]], ['varepsilon', [1013]], ['varkappa', [1008]], ['varnothing', [8709]], ['varphi', [981]], ['varpi', [982]], ['varpropto', [8733]], ['varr', [8597]], ['vArr', [8661]], ['varrho', [1009]], ['varsigma', [962]], ['varsubsetneq', [8842, 65024]], ['varsubsetneqq', [10955, 65024]], ['varsupsetneq', [8843, 65024]], ['varsupsetneqq', [10956, 65024]], ['vartheta', [977]], ['vartriangleleft', [8882]], ['vartriangleright', [8883]], ['vBar', [10984]], ['Vbar', [10987]], ['vBarv', [10985]], ['Vcy', [1042]], ['vcy', [1074]], ['vdash', [8866]], ['vDash', [8872]], ['Vdash', [8873]], ['VDash', [8875]], ['Vdashl', [10982]], ['veebar', [8891]], ['vee', [8744]], ['Vee', [8897]], ['veeeq', [8794]], ['vellip', [8942]], ['verbar', [124]], ['Verbar', [8214]], ['vert', [124]], ['Vert', [8214]], ['VerticalBar', [8739]], ['VerticalLine', [124]], ['VerticalSeparator', [10072]], ['VerticalTilde', [8768]], ['VeryThinSpace', [8202]], ['Vfr', [120089]], ['vfr', [120115]], ['vltri', [8882]], ['vnsub', [8834, 8402]], ['vnsup', [8835, 8402]], ['Vopf', [120141]], ['vopf', [120167]], ['vprop', [8733]], ['vrtri', [8883]], ['Vscr', [119985]], ['vscr', [120011]], ['vsubnE', [10955, 65024]], ['vsubne', [8842, 65024]], ['vsupnE', [10956, 65024]], ['vsupne', [8843, 65024]], ['Vvdash', [8874]], ['vzigzag', [10650]], ['Wcirc', [372]], ['wcirc', [373]], ['wedbar', [10847]], ['wedge', [8743]], ['Wedge', [8896]], ['wedgeq', [8793]], ['weierp', [8472]], ['Wfr', [120090]], ['wfr', [120116]], ['Wopf', [120142]], ['wopf', [120168]], ['wp', [8472]], ['wr', [8768]], ['wreath', [8768]], ['Wscr', [119986]], ['wscr', [120012]], ['xcap', [8898]], ['xcirc', [9711]], ['xcup', [8899]], ['xdtri', [9661]], ['Xfr', [120091]], ['xfr', [120117]], ['xharr', [10231]], ['xhArr', [10234]], ['Xi', [926]], ['xi', [958]], ['xlarr', [10229]], ['xlArr', [10232]], ['xmap', [10236]], ['xnis', [8955]], ['xodot', [10752]], ['Xopf', [120143]], ['xopf', [120169]], ['xoplus', [10753]], ['xotime', [10754]], ['xrarr', [10230]], ['xrArr', [10233]], ['Xscr', [119987]], ['xscr', [120013]], ['xsqcup', [10758]], ['xuplus', [10756]], ['xutri', [9651]], ['xvee', [8897]], ['xwedge', [8896]], ['Yacute', [221]], ['yacute', [253]], ['YAcy', [1071]], ['yacy', [1103]], ['Ycirc', [374]], ['ycirc', [375]], ['Ycy', [1067]], ['ycy', [1099]], ['yen', [165]], ['Yfr', [120092]], ['yfr', [120118]], ['YIcy', [1031]], ['yicy', [1111]], ['Yopf', [120144]], ['yopf', [120170]], ['Yscr', [119988]], ['yscr', [120014]], ['YUcy', [1070]], ['yucy', [1102]], ['yuml', [255]], ['Yuml', [376]], ['Zacute', [377]], ['zacute', [378]], ['Zcaron', [381]], ['zcaron', [382]], ['Zcy', [1047]], ['zcy', [1079]], ['Zdot', [379]], ['zdot', [380]], ['zeetrf', [8488]], ['ZeroWidthSpace', [8203]], ['Zeta', [918]], ['zeta', [950]], ['zfr', [120119]], ['Zfr', [8488]], ['ZHcy', [1046]], ['zhcy', [1078]], ['zigrarr', [8669]], ['zopf', [120171]], ['Zopf', [8484]], ['Zscr', [119989]], ['zscr', [120015]], ['zwj', [8205]], ['zwnj', [8204]]];

var alphaIndex = {};
var charIndex = {};

createIndexes(alphaIndex, charIndex);

/**
 * @constructor
 */
function Html5Entities() {}

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.decode = function(str) {
    if (!str || !str.length) {
        return '';
    }
    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
        var chr;
        if (entity.charAt(0) === "#") {
            var code = entity.charAt(1) === 'x' ?
                parseInt(entity.substr(2).toLowerCase(), 16) :
                parseInt(entity.substr(1));

            if (!(isNaN(code) || code < -32768 || code > 65535)) {
                chr = String.fromCharCode(code);
            }
        } else {
            chr = alphaIndex[entity];
        }
        return chr || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
 Html5Entities.decode = function(str) {
    return new Html5Entities().decode(str);
 };

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encode = function(str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var charInfo = charIndex[str.charCodeAt(i)];
        if (charInfo) {
            var alpha = charInfo[str.charCodeAt(i + 1)];
            if (alpha) {
                i++;
            } else {
                alpha = charInfo[''];
            }
            if (alpha) {
                result += "&" + alpha + ";";
                i++;
                continue;
            }
        }
        result += str.charAt(i);
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
 Html5Entities.encode = function(str) {
    return new Html5Entities().encode(str);
 };

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encodeNonUTF = function(str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        var charInfo = charIndex[c];
        if (charInfo) {
            var alpha = charInfo[str.charCodeAt(i + 1)];
            if (alpha) {
                i++;
            } else {
                alpha = charInfo[''];
            }
            if (alpha) {
                result += "&" + alpha + ";";
                i++;
                continue;
            }
        }
        if (c < 32 || c > 126) {
            result += '&#' + c + ';';
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
 Html5Entities.encodeNonUTF = function(str) {
    return new Html5Entities().encodeNonUTF(str);
 };

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encodeNonASCII = function(str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
 Html5Entities.encodeNonASCII = function(str) {
    return new Html5Entities().encodeNonASCII(str);
 };

/**
 * @param {Object} alphaIndex Passed by reference.
 * @param {Object} charIndex Passed by reference.
 */
function createIndexes(alphaIndex, charIndex) {
    var i = ENTITIES.length;
    var _results = [];
    while (i--) {
        var e = ENTITIES[i];
        var alpha = e[0];
        var chars = e[1];
        var chr = chars[0];
        var addChar = (chr < 32 || chr > 126) || chr === 62 || chr === 60 || chr === 38 || chr === 34 || chr === 39;
        var charInfo;
        if (addChar) {
            charInfo = charIndex[chr] = charIndex[chr] || {};
        }
        if (chars[1]) {
            var chr2 = chars[1];
            alphaIndex[alpha] = String.fromCharCode(chr) + String.fromCharCode(chr2);
            _results.push(addChar && (charInfo[chr2] = alpha));
        } else {
            alphaIndex[alpha] = String.fromCharCode(chr);
            _results.push(addChar && (charInfo[''] = alpha));
        }
    }
}

module.exports = Html5Entities;


/***/ }),

/***/ "1oyr":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "22B7":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "2Hvv":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("imBK");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "2N6f":
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__("rCVp"),
    overRest = __webpack_require__("Q2wK"),
    setToString = __webpack_require__("WHce");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ "2X2u":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "2mZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__("HC03");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/Action.js
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */
var Action_Action = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return this;
    };
    return Action;
}(Subscription["a" /* Subscription */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncAction_AsyncAction; });
/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsyncAction_AsyncAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        // Always replace the current state with the new state.
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return clearInterval(id) && undefined || undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            // Dequeue if the action didn't reschedule itself. Don't call
            // unsubscribe(), because the action could reschedule later.
            // For example:
            // ```
            // scheduler.schedule(function doWork(counter) {
            //   /* ... I'm a busy worker bee ... */
            //   var originalAction = this;
            //   /* wait 100ms before rescheduling the action */
            //   setTimeout(function () {
            //     originalAction.schedule(counter + 1);
            //   }, 100);
            // }, 1000);
            // ```
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action_Action));






/***/ }),

/***/ "2pmY":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        ss : 'ثانیه d%',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),

/***/ "2s1U":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'ss':
            if (number === 1) {
                result += withoutSuffix ? 'sekundo' : 'sekundi';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
            } else {
                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),

/***/ "3BtS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Hsva = /*@__PURE__*/ (function () {
    function Hsva(h, s, v, a) {
        this.h = h;
        this.s = s;
        this.v = v;
        this.a = a;
    }
    return Hsva;
}());
exports.Hsva = Hsva;
var Hsla = /*@__PURE__*/ (function () {
    function Hsla(h, s, l, a) {
        this.h = h;
        this.s = s;
        this.l = l;
        this.a = a;
    }
    return Hsla;
}());
exports.Hsla = Hsla;
var Rgba = /*@__PURE__*/ (function () {
    function Rgba(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    return Rgba;
}());
exports.Rgba = Rgba;



/***/ }),

/***/ "3CJN":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        ss : '%d sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),

/***/ "3Did":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("uCi2");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "3IRH":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "3K28":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),

/***/ "3LKG":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        ss : '%d segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),

/***/ "3MVc":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),

/***/ "3SjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeToResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InnerSubscriber__ = /*@__PURE__*/__webpack_require__("pHYG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribeTo__ = /*@__PURE__*/__webpack_require__("dfzL");
/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo PURE_IMPORTS_END */


function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new __WEBPACK_IMPORTED_MODULE_0__InnerSubscriber__["a" /* InnerSubscriber */](outerSubscriber, outerValue, outerIndex);
    return Object(__WEBPACK_IMPORTED_MODULE_1__subscribeTo__["a" /* subscribeTo */])(result)(destination);
}
//# sourceMappingURL=subscribeToResult.js.map


/***/ }),

/***/ "3hfc":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),

/***/ "3rZI":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ "4jp/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeMap__ = /*@__PURE__*/__webpack_require__("/Kc/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = /*@__PURE__*/__webpack_require__("92UZ");
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */


/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(__WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */], concurrent);
}
//# sourceMappingURL=mergeAll.js.map


/***/ }),

/***/ "5/Qr":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("Kzd6"),
    cloneDataView = __webpack_require__("6Git"),
    cloneMap = __webpack_require__("Jqj6"),
    cloneRegExp = __webpack_require__("WyC4"),
    cloneSet = __webpack_require__("7jYp"),
    cloneSymbol = __webpack_require__("0uX4"),
    cloneTypedArray = __webpack_require__("Ilb/");

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ "54GR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__("TdOr");
var core_2 = __webpack_require__("TdOr");
var mention_list_component_1 = __webpack_require__("vFoO");
var mention_utils_1 = __webpack_require__("gBXS");
var KEY_BACKSPACE = 8;
var KEY_TAB = 9;
var KEY_ENTER = 13;
var KEY_SHIFT = 16;
var KEY_ESCAPE = 27;
var KEY_SPACE = 32;
var KEY_LEFT = 37;
var KEY_UP = 38;
var KEY_RIGHT = 39;
var KEY_DOWN = 40;
var KEY_2 = 50;
/**
 * Angular 2 Mentions.
 * https://github.com/dmacfarlane/angular-mentions
 *
 * Copyright (c) 2017 Dan MacFarlane
 */
var MentionDirective = /*@__PURE__*/ (function () {
    function MentionDirective(_element, _componentResolver, _viewContainerRef) {
        var _this = this;
        this._element = _element;
        this._componentResolver = _componentResolver;
        this._viewContainerRef = _viewContainerRef;
        // the provided configuration object
        this.mentionConfig = { items: [] };
        this.DEFAULT_CONFIG = {
            items: [],
            triggerChar: '@',
            labelKey: 'label',
            maxItems: -1,
            mentionSelect: function (item) { return _this.activeConfig.triggerChar + item[_this.activeConfig.labelKey]; }
        };
        // event emitted whenever the search term changes
        this.searchTerm = new core_2.EventEmitter();
        // option to diable internal filtering. can be used to show the full list returned
        // from an async operation (or allows a custom filter function to be used - in future)
        this.disableSearch = false;
        this.triggerChars = {};
    }
    Object.defineProperty(MentionDirective.prototype, "mention", {
        set: function (items) {
            this.mentionItems = items;
        },
        enumerable: true,
        configurable: true
    });
    MentionDirective.prototype.ngOnChanges = function (changes) {
        // console.log('config change', changes);
        if (changes['mention'] || changes['mentionConfig']) {
            this.updateConfig();
        }
    };
    MentionDirective.prototype.updateConfig = function () {
        var _this = this;
        var config = this.mentionConfig;
        this.triggerChars = {};
        // use items from directive if they have been set
        if (this.mentionItems) {
            config.items = this.mentionItems;
        }
        this.addConfig(config);
        // nested configs
        if (config.mentions) {
            config.mentions.forEach(function (config) { return _this.addConfig(config); });
        }
    };
    // add configuration for a trigger char
    MentionDirective.prototype.addConfig = function (config) {
        // defaults
        var defaults = Object.assign({}, this.DEFAULT_CONFIG);
        config = Object.assign(defaults, config);
        // items
        var items = config.items;
        if (items && items.length > 0) {
            // convert strings to objects
            if (typeof items[0] == 'string') {
                items = items.map(function (label) {
                    var object = {};
                    object[config.labelKey] = label;
                    return object;
                });
            }
            // remove items without an labelKey (as it's required to filter the list)
            items = items.filter(function (e) { return e[config.labelKey]; });
            if (!config.disableSort) {
                items.sort(function (a, b) { return a[config.labelKey].localeCompare(b[config.labelKey]); });
            }
        }
        config.items = items;
        // add the config
        this.triggerChars[config.triggerChar] = config;
        // for async update while menu/search is active
        if (this.activeConfig && this.activeConfig.triggerChar == config.triggerChar) {
            this.activeConfig = config;
            this.updateSearchList();
        }
    };
    MentionDirective.prototype.setIframe = function (iframe) {
        this.iframe = iframe;
    };
    MentionDirective.prototype.stopEvent = function (event) {
        //if (event instanceof KeyboardEvent) { // does not work for iframe
        if (!event.wasClick) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
    };
    MentionDirective.prototype.blurHandler = function (event) {
        this.stopEvent(event);
        this.stopSearch = true;
        if (this.searchList) {
            this.searchList.hidden = true;
        }
    };
    MentionDirective.prototype.keyHandler = function (event, nativeElement) {
        if (nativeElement === void 0) {
            nativeElement = this._element.nativeElement;
        }
        var val = mention_utils_1.getValue(nativeElement);
        var pos = mention_utils_1.getCaretPosition(nativeElement, this.iframe);
        var charPressed = event.key;
        if (!charPressed) {
            var charCode = event.which || event.keyCode;
            if (!event.shiftKey && (charCode >= 65 && charCode <= 90)) {
                charPressed = String.fromCharCode(charCode + 32);
            }
            else {
                // TODO (dmacfarlane) fix this for non-alpha keys
                // http://stackoverflow.com/questions/2220196/how-to-decode-character-pressed-from-jquerys-keydowns-event-handler?lq=1
                charPressed = String.fromCharCode(event.which || event.keyCode);
            }
        }
        if (event.keyCode == KEY_ENTER && event.wasClick && pos < this.startPos) {
            // put caret back in position prior to contenteditable menu click
            pos = this.startNode.length;
            mention_utils_1.setCaretPosition(this.startNode, pos, this.iframe);
        }
        //console.log("keyHandler", this.startPos, pos, val, charPressed, event);
        var config = this.triggerChars[charPressed];
        if (config) {
            this.activeConfig = config;
            this.startPos = pos;
            this.startNode = (this.iframe ? this.iframe.contentWindow.getSelection() : window.getSelection()).anchorNode;
            this.stopSearch = false;
            this.searchString = null;
            this.showSearchList(nativeElement);
            this.updateSearchList();
        }
        else if (this.startPos >= 0 && !this.stopSearch) {
            if (pos <= this.startPos) {
                this.searchList.hidden = true;
            }
            else if (event.keyCode !== KEY_SHIFT &&
                !event.metaKey &&
                !event.altKey &&
                !event.ctrlKey &&
                pos > this.startPos) {
                if (event.keyCode === KEY_SPACE) {
                    this.startPos = -1;
                }
                else if (event.keyCode === KEY_BACKSPACE && pos > 0) {
                    pos--;
                    if (pos == this.startPos) {
                        this.stopSearch = true;
                    }
                    this.searchList.hidden = this.stopSearch;
                }
                else if (!this.searchList.hidden) {
                    if (event.keyCode === KEY_TAB || event.keyCode === KEY_ENTER) {
                        this.stopEvent(event);
                        this.searchList.hidden = true;
                        var text = this.activeConfig.mentionSelect(this.searchList.activeItem);
                        // value is inserted without a trailing space for consistency
                        // between element types (div and iframe do not preserve the space)
                        mention_utils_1.insertValue(nativeElement, this.startPos, pos, text, this.iframe);
                        // fire input event so angular bindings are updated
                        if ("createEvent" in document) {
                            var evt = document.createEvent("HTMLEvents");
                            evt.initEvent("input", false, true);
                            nativeElement.dispatchEvent(evt);
                        }
                        this.startPos = -1;
                        return false;
                    }
                    else if (event.keyCode === KEY_ESCAPE) {
                        this.stopEvent(event);
                        this.searchList.hidden = true;
                        this.stopSearch = true;
                        return false;
                    }
                    else if (event.keyCode === KEY_DOWN) {
                        this.stopEvent(event);
                        this.searchList.activateNextItem();
                        return false;
                    }
                    else if (event.keyCode === KEY_UP) {
                        this.stopEvent(event);
                        this.searchList.activatePreviousItem();
                        return false;
                    }
                }
                if (event.keyCode === KEY_LEFT || event.keyCode === KEY_RIGHT) {
                    this.stopEvent(event);
                    return false;
                }
                else {
                    var mention = val.substring(this.startPos + 1, pos);
                    if (event.keyCode !== KEY_BACKSPACE) {
                        mention += charPressed;
                    }
                    this.searchString = mention;
                    this.searchTerm.emit(this.searchString);
                    this.updateSearchList();
                }
            }
        }
    };
    MentionDirective.prototype.updateSearchList = function () {
        var _this = this;
        var matches = [];
        if (this.activeConfig && this.activeConfig.items) {
            var objects = this.activeConfig.items;
            // disabling the search relies on the async operation to do the filtering
            if (!this.disableSearch && this.searchString) {
                var searchStringLowerCase_1 = this.searchString.toLowerCase();
                objects = objects.filter(function (e) { return e[_this.activeConfig.labelKey].toLowerCase().startsWith(searchStringLowerCase_1); });
            }
            matches = objects;
            if (this.activeConfig.maxItems > 0) {
                matches = matches.slice(0, this.activeConfig.maxItems);
            }
        }
        // update the search list
        if (this.searchList) {
            this.searchList.labelKey = this.activeConfig.labelKey;
            this.searchList.items = matches;
            this.searchList.hidden = matches.length == 0;
        }
    };
    MentionDirective.prototype.showSearchList = function (nativeElement) {
        var _this = this;
        if (this.searchList == null) {
            var componentFactory = this._componentResolver.resolveComponentFactory(mention_list_component_1.MentionListComponent);
            var componentRef = this._viewContainerRef.createComponent(componentFactory);
            this.searchList = componentRef.instance;
            this.searchList.position(nativeElement, this.iframe, this.activeConfig.dropUp);
            this.searchList.itemTemplate = this.mentionListTemplate;
            componentRef.instance['itemClick'].subscribe(function () {
                nativeElement.focus();
                var fakeKeydown = { "keyCode": KEY_ENTER, "wasClick": true };
                _this.keyHandler(fakeKeydown, nativeElement);
            });
        }
        else {
            this.searchList.labelKey = this.activeConfig.labelKey;
            this.searchList.activeIndex = 0;
            this.searchList.position(nativeElement, this.iframe, this.activeConfig.dropUp);
            window.setTimeout(function () { return _this.searchList.resetScroll(); });
        }
    };
    MentionDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[mention], [mentionConfig]',
                    host: {
                        '(keydown)': 'keyHandler($event)',
                        '(blur)': 'blurHandler($event)',
                        'autocomplete': 'off'
                    }
                },] },
    ];
    MentionDirective.propDecorators = {
        'mention': [{ type: core_2.Input, args: ['mention',] },],
        'mentionConfig': [{ type: core_2.Input },],
        'mentionListTemplate': [{ type: core_2.Input },],
        'searchTerm': [{ type: core_2.Output },],
    };
    return MentionDirective;
}());
exports.MentionDirective = MentionDirective;



/***/ }),

/***/ "55Fp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = /*@__PURE__*/ __webpack_require__("TToO").__decorate;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var DomHandler = /*@__PURE__*/ (function () {
    function DomHandler() {
        this.calculatedScrollbarWidth = null;
    }
    DomHandler.prototype.addClass = function (element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    };
    DomHandler.prototype.addMultipleClasses = function (element, className) {
        if (element.classList) {
            var styles = className.split(' ');
            for (var i = 0; i < styles.length; i++) {
                element.classList.add(styles[i]);
            }
        }
        else {
            var styles = className.split(' ');
            for (var i = 0; i < styles.length; i++) {
                element.className += ' ' + styles[i];
            }
        }
    };
    DomHandler.prototype.removeClass = function (element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    };
    DomHandler.prototype.hasClass = function (element, className) {
        if (element.classList)
            return element.classList.contains(className);
        else
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
    };
    DomHandler.prototype.siblings = function (element) {
        return Array.prototype.filter.call(element.parentNode.children, function (child) {
            return child !== element;
        });
    };
    DomHandler.prototype.find = function (element, selector) {
        return element.querySelectorAll(selector);
    };
    DomHandler.prototype.findSingle = function (element, selector) {
        return element.querySelector(selector);
    };
    DomHandler.prototype.index = function (element) {
        var children = element.parentNode.childNodes;
        var num = 0;
        for (var i = 0; i < children.length; i++) {
            if (children[i] == element)
                return num;
            if (children[i].nodeType == 1)
                num++;
        }
        return -1;
    };
    DomHandler.prototype.indexWithinGroup = function (element, attributeName) {
        var children = element.parentNode.childNodes;
        var num = 0;
        for (var i = 0; i < children.length; i++) {
            if (children[i] == element)
                return num;
            if (children[i].attributes && children[i].attributes[attributeName] && children[i].nodeType == 1)
                num++;
        }
        return -1;
    };
    DomHandler.prototype.relativePosition = function (element, target) {
        var elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : this.getHiddenElementDimensions(element);
        var targetHeight = target.offsetHeight;
        var targetWidth = target.offsetWidth;
        var targetOffset = target.getBoundingClientRect();
        var windowScrollTop = this.getWindowScrollTop();
        var viewport = this.getViewport();
        var top, left;
        if ((targetOffset.top + targetHeight + elementDimensions.height) > viewport.height) {
            top = -1 * (elementDimensions.height);
            if (targetOffset.top + top < 0) {
                top = 0;
            }
        }
        else {
            top = targetHeight;
        }
        if ((targetOffset.left + elementDimensions.width) > viewport.width)
            left = targetWidth - elementDimensions.width;
        else
            left = 0;
        element.style.top = top + 'px';
        element.style.left = left + 'px';
    };
    DomHandler.prototype.absolutePosition = function (element, target) {
        var elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : this.getHiddenElementDimensions(element);
        var elementOuterHeight = elementDimensions.height;
        var elementOuterWidth = elementDimensions.width;
        var targetOuterHeight = target.offsetHeight;
        var targetOuterWidth = target.offsetWidth;
        var targetOffset = target.getBoundingClientRect();
        var windowScrollTop = this.getWindowScrollTop();
        var windowScrollLeft = this.getWindowScrollLeft();
        var viewport = this.getViewport();
        var top, left;
        if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
            top = targetOffset.top + windowScrollTop - elementOuterHeight;
            if (top < 0) {
                top = 0 + windowScrollTop;
            }
        }
        else {
            top = targetOuterHeight + targetOffset.top + windowScrollTop;
        }
        if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width)
            left = targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth;
        else
            left = targetOffset.left + windowScrollLeft;
        element.style.top = top + 'px';
        element.style.left = left + 'px';
    };
    DomHandler.prototype.getHiddenElementOuterHeight = function (element) {
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        var elementHeight = element.offsetHeight;
        element.style.display = 'none';
        element.style.visibility = 'visible';
        return elementHeight;
    };
    DomHandler.prototype.getHiddenElementOuterWidth = function (element) {
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        var elementWidth = element.offsetWidth;
        element.style.display = 'none';
        element.style.visibility = 'visible';
        return elementWidth;
    };
    DomHandler.prototype.getHiddenElementDimensions = function (element) {
        var dimensions = {};
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        dimensions.width = element.offsetWidth;
        dimensions.height = element.offsetHeight;
        element.style.display = 'none';
        element.style.visibility = 'visible';
        return dimensions;
    };
    DomHandler.prototype.scrollInView = function (container, item) {
        var borderTopValue = getComputedStyle(container).getPropertyValue('borderTopWidth');
        var borderTop = borderTopValue ? parseFloat(borderTopValue) : 0;
        var paddingTopValue = getComputedStyle(container).getPropertyValue('paddingTop');
        var paddingTop = paddingTopValue ? parseFloat(paddingTopValue) : 0;
        var containerRect = container.getBoundingClientRect();
        var itemRect = item.getBoundingClientRect();
        var offset = (itemRect.top + document.body.scrollTop) - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
        var scroll = container.scrollTop;
        var elementHeight = container.clientHeight;
        var itemHeight = this.getOuterHeight(item);
        if (offset < 0) {
            container.scrollTop = scroll + offset;
        }
        else if ((offset + itemHeight) > elementHeight) {
            container.scrollTop = scroll + offset - elementHeight + itemHeight;
        }
    };
    DomHandler.prototype.fadeIn = function (element, duration) {
        element.style.opacity = 0;
        var last = +new Date();
        var opacity = 0;
        var tick = function () {
            opacity = +element.style.opacity.replace(",", ".") + (new Date().getTime() - last) / duration;
            element.style.opacity = opacity;
            last = +new Date();
            if (+opacity < 1) {
                (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
            }
        };
        tick();
    };
    DomHandler.prototype.fadeOut = function (element, ms) {
        var opacity = 1, interval = 50, duration = ms, gap = interval / duration;
        var fading = setInterval(function () {
            opacity = opacity - gap;
            if (opacity <= 0) {
                opacity = 0;
                clearInterval(fading);
            }
            element.style.opacity = opacity;
        }, interval);
    };
    DomHandler.prototype.getWindowScrollTop = function () {
        var doc = document.documentElement;
        return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    };
    DomHandler.prototype.getWindowScrollLeft = function () {
        var doc = document.documentElement;
        return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
    };
    DomHandler.prototype.matches = function (element, selector) {
        var p = Element.prototype;
        var f = p['matches'] || p.webkitMatchesSelector || p['mozMatchesSelector'] || p.msMatchesSelector || function (s) {
            return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
        };
        return f.call(element, selector);
    };
    DomHandler.prototype.getOuterWidth = function (el, margin) {
        var width = el.offsetWidth;
        if (margin) {
            var style = getComputedStyle(el);
            width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        }
        return width;
    };
    DomHandler.prototype.getHorizontalPadding = function (el) {
        var style = getComputedStyle(el);
        return parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    };
    DomHandler.prototype.getHorizontalMargin = function (el) {
        var style = getComputedStyle(el);
        return parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    };
    DomHandler.prototype.innerWidth = function (el) {
        var width = el.offsetWidth;
        var style = getComputedStyle(el);
        width += parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        return width;
    };
    DomHandler.prototype.width = function (el) {
        var width = el.offsetWidth;
        var style = getComputedStyle(el);
        width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        return width;
    };
    DomHandler.prototype.getInnerHeight = function (el) {
        var height = el.offsetHeight;
        var style = getComputedStyle(el);
        height += parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        return height;
    };
    DomHandler.prototype.getOuterHeight = function (el, margin) {
        var height = el.offsetHeight;
        if (margin) {
            var style = getComputedStyle(el);
            height += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        }
        return height;
    };
    DomHandler.prototype.getHeight = function (el) {
        var height = el.offsetHeight;
        var style = getComputedStyle(el);
        height -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        return height;
    };
    DomHandler.prototype.getWidth = function (el) {
        var width = el.offsetWidth;
        var style = getComputedStyle(el);
        width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
        return width;
    };
    DomHandler.prototype.getViewport = function () {
        var win = window, d = document, e = d.documentElement, g = d.getElementsByTagName('body')[0], w = win.innerWidth || e.clientWidth || g.clientWidth, h = win.innerHeight || e.clientHeight || g.clientHeight;
        return { width: w, height: h };
    };
    DomHandler.prototype.getOffset = function (el) {
        var rect = el.getBoundingClientRect();
        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        };
    };
    DomHandler.prototype.replaceElementWith = function (element, replacementElement) {
        var parentNode = element.parentNode;
        if (!parentNode)
            throw "Can't replace element";
        return parentNode.replaceChild(replacementElement, element);
    };
    DomHandler.prototype.getUserAgent = function () {
        return navigator.userAgent;
    };
    DomHandler.prototype.isIE = function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return true;
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return true;
        }
        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return true;
        }
        // other browser
        return false;
    };
    DomHandler.prototype.appendChild = function (element, target) {
        if (this.isElement(target))
            target.appendChild(element);
        else if (target.el && target.el.nativeElement)
            target.el.nativeElement.appendChild(element);
        else
            throw 'Cannot append ' + target + ' to ' + element;
    };
    DomHandler.prototype.removeChild = function (element, target) {
        if (this.isElement(target))
            target.removeChild(element);
        else if (target.el && target.el.nativeElement)
            target.el.nativeElement.removeChild(element);
        else
            throw 'Cannot remove ' + element + ' from ' + target;
    };
    DomHandler.prototype.isElement = function (obj) {
        return (typeof HTMLElement === "object" ? obj instanceof HTMLElement :
            obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string");
    };
    DomHandler.prototype.calculateScrollbarWidth = function () {
        if (this.calculatedScrollbarWidth !== null)
            return this.calculatedScrollbarWidth;
        var scrollDiv = document.createElement("div");
        scrollDiv.className = "ui-scrollbar-measure";
        document.body.appendChild(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        this.calculatedScrollbarWidth = scrollbarWidth;
        return scrollbarWidth;
    };
    DomHandler.prototype.invokeElementMethod = function (element, methodName, args) {
        element[methodName].apply(element, args);
    };
    DomHandler.prototype.clearSelection = function () {
        if (window.getSelection) {
            if (window.getSelection().empty) {
                window.getSelection().empty();
            }
            else if (window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) {
                window.getSelection().removeAllRanges();
            }
        }
        else if (document['selection'] && document['selection'].empty) {
            try {
                document['selection'].empty();
            }
            catch (error) {
                //ignore IE bug
            }
        }
    };
    DomHandler.prototype.getBrowser = function () {
        if (!this.browser) {
            var matched = this.resolveUserAgent();
            this.browser = {};
            if (matched.browser) {
                this.browser[matched.browser] = true;
                this.browser['version'] = matched.version;
            }
            if (this.browser['chrome']) {
                this.browser['webkit'] = true;
            }
            else if (this.browser['webkit']) {
                this.browser['safari'] = true;
            }
        }
        return this.browser;
    };
    DomHandler.prototype.resolveUserAgent = function () {
        var ua = navigator.userAgent.toLowerCase();
        var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
            /(webkit)[ \/]([\w.]+)/.exec(ua) ||
            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
            /(msie) ([\w.]+)/.exec(ua) ||
            ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
            [];
        return {
            browser: match[1] || "",
            version: match[2] || "0"
        };
    };
    DomHandler.zindex = 1000;
    DomHandler = __decorate([
        core_1.Injectable()
    ], DomHandler);
    return DomHandler;
}());
exports.DomHandler = DomHandler;



/***/ }),

/***/ "5D2H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_c */
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_b */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return errorHandler; });
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_k */
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_d */
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_i */
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_h */
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_e */
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_f */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _createNgProbe; });
/* unused harmony export ɵangular_packages_platform_browser_platform_browser_g */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return platformBrowser; });
/* unused harmony export Meta */
/* unused harmony export Title */
/* unused harmony export disableDebugTools */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return enableDebugTools; });
/* unused harmony export BrowserTransferStateModule */
/* unused harmony export TransferState */
/* unused harmony export makeStateKey */
/* unused harmony export By */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOCUMENT$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EVENT_MANAGER_PLUGINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EventManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HAMMER_GESTURE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HAMMER_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HammerGestureConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DomSanitizer; });
/* unused harmony export VERSION */
/* unused harmony export ɵBROWSER_SANITIZATION_PROVIDERS */
/* unused harmony export ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS */
/* unused harmony export ɵinitDomAdapter */
/* unused harmony export ɵBrowserDomAdapter */
/* unused harmony export ɵBrowserPlatformLocation */
/* unused harmony export ɵTRANSITION_ID */
/* unused harmony export ɵBrowserGetTestability */
/* unused harmony export ɵescapeHtml */
/* unused harmony export ɵELEMENT_PROBE_PROVIDERS */
/* unused harmony export ɵDomAdapter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getDOM; });
/* unused harmony export ɵsetRootDomAdapter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DomRendererFactory2; });
/* unused harmony export ɵNAMESPACE_URIS */
/* unused harmony export ɵflattenStyles */
/* unused harmony export ɵshimContentAttribute */
/* unused harmony export ɵshimHostAttribute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DomEventsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return HammerGesturesPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return KeyEventsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DomSharedStylesHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SharedStylesHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DomSanitizerImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = /*@__PURE__*/__webpack_require__("wTuo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START tslib,_angular_common,_angular_core PURE_IMPORTS_END */



/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _DOM = null;
function getDOM() {
    return _DOM;
}
function setRootDomAdapter(adapter) {
    if (!_DOM) {
        _DOM = adapter;
    }
}
/* tslint:disable:requireParameterType */
/**
 * Provides DOM operations in an environment-agnostic way.
 *
 * @security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 */
var DomAdapter = /*@__PURE__*/ (function () {
    function DomAdapter() {
        this.resourceLoaderType = null;
    }
    Object.defineProperty(DomAdapter.prototype, "attrToPropMap", {
        /**
         * Maps attribute names to their corresponding property names for cases
         * where attribute name doesn't match property name.
         */
        get: function () { return this._attrToPropMap; },
        set: function (value) { this._attrToPropMap = value; },
        enumerable: true,
        configurable: true
    });
    return DomAdapter;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Provides DOM operations in any browser environment.
 *
 * @security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 */
var GenericBrowserDomAdapter = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(GenericBrowserDomAdapter, _super);
    function GenericBrowserDomAdapter() {
        var _this = _super.call(this) || this;
        _this._animationPrefix = null;
        _this._transitionEnd = null;
        try {
            var element_1 = _this.createElement('div', document);
            if (_this.getStyle(element_1, 'animationName') != null) {
                _this._animationPrefix = '';
            }
            else {
                var domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
                for (var i = 0; i < domPrefixes.length; i++) {
                    if (_this.getStyle(element_1, domPrefixes[i] + 'AnimationName') != null) {
                        _this._animationPrefix = '-' + domPrefixes[i].toLowerCase() + '-';
                        break;
                    }
                }
            }
            var transEndEventNames_1 = {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd otransitionend',
                transition: 'transitionend'
            };
            Object.keys(transEndEventNames_1).forEach(function (key) {
                if (_this.getStyle(element_1, key) != null) {
                    _this._transitionEnd = transEndEventNames_1[key];
                }
            });
        }
        catch (e) {
            _this._animationPrefix = null;
            _this._transitionEnd = null;
        }
        return _this;
    }
    GenericBrowserDomAdapter.prototype.getDistributedNodes = function (el) { return el.getDistributedNodes(); };
    GenericBrowserDomAdapter.prototype.resolveAndSetHref = function (el, baseUrl, href) {
        el.href = href == null ? baseUrl : baseUrl + '/../' + href;
    };
    GenericBrowserDomAdapter.prototype.supportsDOMEvents = function () { return true; };
    GenericBrowserDomAdapter.prototype.supportsNativeShadowDOM = function () {
        return typeof document.body.createShadowRoot === 'function';
    };
    GenericBrowserDomAdapter.prototype.getAnimationPrefix = function () { return this._animationPrefix ? this._animationPrefix : ''; };
    GenericBrowserDomAdapter.prototype.getTransitionEnd = function () { return this._transitionEnd ? this._transitionEnd : ''; };
    GenericBrowserDomAdapter.prototype.supportsAnimation = function () {
        return this._animationPrefix != null && this._transitionEnd != null;
    };
    return GenericBrowserDomAdapter;
}(DomAdapter));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _attrToPropMap = {
    'class': 'className',
    'innerHtml': 'innerHTML',
    'readonly': 'readOnly',
    'tabindex': 'tabIndex',
};
var DOM_KEY_LOCATION_NUMPAD = 3;
// Map to convert some key or keyIdentifier values to what will be returned by getEventKey
var _keyMap = {
    // The following values are here for cross-browser compatibility and to match the W3C standard
    // cf http://www.w3.org/TR/DOM-Level-3-Events-key/
    '\b': 'Backspace',
    '\t': 'Tab',
    '\x7F': 'Delete',
    '\x1B': 'Escape',
    'Del': 'Delete',
    'Esc': 'Escape',
    'Left': 'ArrowLeft',
    'Right': 'ArrowRight',
    'Up': 'ArrowUp',
    'Down': 'ArrowDown',
    'Menu': 'ContextMenu',
    'Scroll': 'ScrollLock',
    'Win': 'OS'
};
// There is a bug in Chrome for numeric keypad keys:
// https://code.google.com/p/chromium/issues/detail?id=155654
// 1, 2, 3 ... are reported as A, B, C ...
var _chromeNumKeyPadMap = {
    'A': '1',
    'B': '2',
    'C': '3',
    'D': '4',
    'E': '5',
    'F': '6',
    'G': '7',
    'H': '8',
    'I': '9',
    'J': '*',
    'K': '+',
    'M': '-',
    'N': '.',
    'O': '/',
    '\x60': '0',
    '\x90': 'NumLock'
};
var nodeContains;
if (__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['Node']) {
    nodeContains = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['Node'].prototype.contains || function (node) {
        return !!(this.compareDocumentPosition(node) & 16);
    };
}
/**
 * A `DomAdapter` powered by full browser DOM APIs.
 *
 * @security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 */
/* tslint:disable:requireParameterType no-console */
var BrowserDomAdapter = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(BrowserDomAdapter, _super);
    function BrowserDomAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrowserDomAdapter.prototype.parse = function (templateHtml) { throw new Error('parse not implemented'); };
    BrowserDomAdapter.makeCurrent = function () { setRootDomAdapter(new BrowserDomAdapter()); };
    BrowserDomAdapter.prototype.hasProperty = function (element, name) { return name in element; };
    BrowserDomAdapter.prototype.setProperty = function (el, name, value) { el[name] = value; };
    BrowserDomAdapter.prototype.getProperty = function (el, name) { return el[name]; };
    BrowserDomAdapter.prototype.invoke = function (el, methodName, args) {
        var _a;
        (_a = el)[methodName].apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(args));
    };
    // TODO(tbosch): move this into a separate environment class once we have it
    BrowserDomAdapter.prototype.logError = function (error) {
        if (window.console) {
            if (console.error) {
                console.error(error);
            }
            else {
                console.log(error);
            }
        }
    };
    BrowserDomAdapter.prototype.log = function (error) {
        if (window.console) {
            window.console.log && window.console.log(error);
        }
    };
    BrowserDomAdapter.prototype.logGroup = function (error) {
        if (window.console) {
            window.console.group && window.console.group(error);
        }
    };
    BrowserDomAdapter.prototype.logGroupEnd = function () {
        if (window.console) {
            window.console.groupEnd && window.console.groupEnd();
        }
    };
    Object.defineProperty(BrowserDomAdapter.prototype, "attrToPropMap", {
        get: function () { return _attrToPropMap; },
        enumerable: true,
        configurable: true
    });
    BrowserDomAdapter.prototype.contains = function (nodeA, nodeB) { return nodeContains.call(nodeA, nodeB); };
    BrowserDomAdapter.prototype.querySelector = function (el, selector) { return el.querySelector(selector); };
    BrowserDomAdapter.prototype.querySelectorAll = function (el, selector) { return el.querySelectorAll(selector); };
    BrowserDomAdapter.prototype.on = function (el, evt, listener) { el.addEventListener(evt, listener, false); };
    BrowserDomAdapter.prototype.onAndCancel = function (el, evt, listener) {
        el.addEventListener(evt, listener, false);
        // Needed to follow Dart's subscription semantic, until fix of
        // https://code.google.com/p/dart/issues/detail?id=17406
        return function () { el.removeEventListener(evt, listener, false); };
    };
    BrowserDomAdapter.prototype.dispatchEvent = function (el, evt) { el.dispatchEvent(evt); };
    BrowserDomAdapter.prototype.createMouseEvent = function (eventType) {
        var evt = this.getDefaultDocument().createEvent('MouseEvent');
        evt.initEvent(eventType, true, true);
        return evt;
    };
    BrowserDomAdapter.prototype.createEvent = function (eventType) {
        var evt = this.getDefaultDocument().createEvent('Event');
        evt.initEvent(eventType, true, true);
        return evt;
    };
    BrowserDomAdapter.prototype.preventDefault = function (evt) {
        evt.preventDefault();
        evt.returnValue = false;
    };
    BrowserDomAdapter.prototype.isPrevented = function (evt) {
        return evt.defaultPrevented || evt.returnValue != null && !evt.returnValue;
    };
    BrowserDomAdapter.prototype.getInnerHTML = function (el) { return el.innerHTML; };
    BrowserDomAdapter.prototype.getTemplateContent = function (el) {
        return 'content' in el && this.isTemplateElement(el) ? el.content : null;
    };
    BrowserDomAdapter.prototype.getOuterHTML = function (el) { return el.outerHTML; };
    BrowserDomAdapter.prototype.nodeName = function (node) { return node.nodeName; };
    BrowserDomAdapter.prototype.nodeValue = function (node) { return node.nodeValue; };
    BrowserDomAdapter.prototype.type = function (node) { return node.type; };
    BrowserDomAdapter.prototype.content = function (node) {
        if (this.hasProperty(node, 'content')) {
            return node.content;
        }
        else {
            return node;
        }
    };
    BrowserDomAdapter.prototype.firstChild = function (el) { return el.firstChild; };
    BrowserDomAdapter.prototype.nextSibling = function (el) { return el.nextSibling; };
    BrowserDomAdapter.prototype.parentElement = function (el) { return el.parentNode; };
    BrowserDomAdapter.prototype.childNodes = function (el) { return el.childNodes; };
    BrowserDomAdapter.prototype.childNodesAsList = function (el) {
        var childNodes = el.childNodes;
        var res = new Array(childNodes.length);
        for (var i = 0; i < childNodes.length; i++) {
            res[i] = childNodes[i];
        }
        return res;
    };
    BrowserDomAdapter.prototype.clearNodes = function (el) {
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
    };
    BrowserDomAdapter.prototype.appendChild = function (el, node) { el.appendChild(node); };
    BrowserDomAdapter.prototype.removeChild = function (el, node) { el.removeChild(node); };
    BrowserDomAdapter.prototype.replaceChild = function (el, newChild, oldChild) { el.replaceChild(newChild, oldChild); };
    BrowserDomAdapter.prototype.remove = function (node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
        return node;
    };
    BrowserDomAdapter.prototype.insertBefore = function (parent, ref, node) { parent.insertBefore(node, ref); };
    BrowserDomAdapter.prototype.insertAllBefore = function (parent, ref, nodes) {
        nodes.forEach(function (n) { return parent.insertBefore(n, ref); });
    };
    BrowserDomAdapter.prototype.insertAfter = function (parent, ref, node) { parent.insertBefore(node, ref.nextSibling); };
    BrowserDomAdapter.prototype.setInnerHTML = function (el, value) { el.innerHTML = value; };
    BrowserDomAdapter.prototype.getText = function (el) { return el.textContent; };
    BrowserDomAdapter.prototype.setText = function (el, value) { el.textContent = value; };
    BrowserDomAdapter.prototype.getValue = function (el) { return el.value; };
    BrowserDomAdapter.prototype.setValue = function (el, value) { el.value = value; };
    BrowserDomAdapter.prototype.getChecked = function (el) { return el.checked; };
    BrowserDomAdapter.prototype.setChecked = function (el, value) { el.checked = value; };
    BrowserDomAdapter.prototype.createComment = function (text) { return this.getDefaultDocument().createComment(text); };
    BrowserDomAdapter.prototype.createTemplate = function (html) {
        var t = this.getDefaultDocument().createElement('template');
        t.innerHTML = html;
        return t;
    };
    BrowserDomAdapter.prototype.createElement = function (tagName, doc) {
        doc = doc || this.getDefaultDocument();
        return doc.createElement(tagName);
    };
    BrowserDomAdapter.prototype.createElementNS = function (ns, tagName, doc) {
        doc = doc || this.getDefaultDocument();
        return doc.createElementNS(ns, tagName);
    };
    BrowserDomAdapter.prototype.createTextNode = function (text, doc) {
        doc = doc || this.getDefaultDocument();
        return doc.createTextNode(text);
    };
    BrowserDomAdapter.prototype.createScriptTag = function (attrName, attrValue, doc) {
        doc = doc || this.getDefaultDocument();
        var el = doc.createElement('SCRIPT');
        el.setAttribute(attrName, attrValue);
        return el;
    };
    BrowserDomAdapter.prototype.createStyleElement = function (css, doc) {
        doc = doc || this.getDefaultDocument();
        var style = doc.createElement('style');
        this.appendChild(style, this.createTextNode(css, doc));
        return style;
    };
    BrowserDomAdapter.prototype.createShadowRoot = function (el) { return el.createShadowRoot(); };
    BrowserDomAdapter.prototype.getShadowRoot = function (el) { return el.shadowRoot; };
    BrowserDomAdapter.prototype.getHost = function (el) { return el.host; };
    BrowserDomAdapter.prototype.clone = function (node) { return node.cloneNode(true); };
    BrowserDomAdapter.prototype.getElementsByClassName = function (element, name) {
        return element.getElementsByClassName(name);
    };
    BrowserDomAdapter.prototype.getElementsByTagName = function (element, name) {
        return element.getElementsByTagName(name);
    };
    BrowserDomAdapter.prototype.classList = function (element) { return Array.prototype.slice.call(element.classList, 0); };
    BrowserDomAdapter.prototype.addClass = function (element, className) { element.classList.add(className); };
    BrowserDomAdapter.prototype.removeClass = function (element, className) { element.classList.remove(className); };
    BrowserDomAdapter.prototype.hasClass = function (element, className) {
        return element.classList.contains(className);
    };
    BrowserDomAdapter.prototype.setStyle = function (element, styleName, styleValue) {
        element.style[styleName] = styleValue;
    };
    BrowserDomAdapter.prototype.removeStyle = function (element, stylename) {
        // IE requires '' instead of null
        // see https://github.com/angular/angular/issues/7916
        element.style[stylename] = '';
    };
    BrowserDomAdapter.prototype.getStyle = function (element, stylename) { return element.style[stylename]; };
    BrowserDomAdapter.prototype.hasStyle = function (element, styleName, styleValue) {
        var value = this.getStyle(element, styleName) || '';
        return styleValue ? value == styleValue : value.length > 0;
    };
    BrowserDomAdapter.prototype.tagName = function (element) { return element.tagName; };
    BrowserDomAdapter.prototype.attributeMap = function (element) {
        var res = new Map();
        var elAttrs = element.attributes;
        for (var i = 0; i < elAttrs.length; i++) {
            var attrib = elAttrs.item(i);
            res.set(attrib.name, attrib.value);
        }
        return res;
    };
    BrowserDomAdapter.prototype.hasAttribute = function (element, attribute) {
        return element.hasAttribute(attribute);
    };
    BrowserDomAdapter.prototype.hasAttributeNS = function (element, ns, attribute) {
        return element.hasAttributeNS(ns, attribute);
    };
    BrowserDomAdapter.prototype.getAttribute = function (element, attribute) {
        return element.getAttribute(attribute);
    };
    BrowserDomAdapter.prototype.getAttributeNS = function (element, ns, name) {
        return element.getAttributeNS(ns, name);
    };
    BrowserDomAdapter.prototype.setAttribute = function (element, name, value) { element.setAttribute(name, value); };
    BrowserDomAdapter.prototype.setAttributeNS = function (element, ns, name, value) {
        element.setAttributeNS(ns, name, value);
    };
    BrowserDomAdapter.prototype.removeAttribute = function (element, attribute) { element.removeAttribute(attribute); };
    BrowserDomAdapter.prototype.removeAttributeNS = function (element, ns, name) {
        element.removeAttributeNS(ns, name);
    };
    BrowserDomAdapter.prototype.templateAwareRoot = function (el) { return this.isTemplateElement(el) ? this.content(el) : el; };
    BrowserDomAdapter.prototype.createHtmlDocument = function () {
        return document.implementation.createHTMLDocument('fakeTitle');
    };
    BrowserDomAdapter.prototype.getDefaultDocument = function () { return document; };
    BrowserDomAdapter.prototype.getBoundingClientRect = function (el) {
        try {
            return el.getBoundingClientRect();
        }
        catch (e) {
            return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
        }
    };
    BrowserDomAdapter.prototype.getTitle = function (doc) { return doc.title; };
    BrowserDomAdapter.prototype.setTitle = function (doc, newTitle) { doc.title = newTitle || ''; };
    BrowserDomAdapter.prototype.elementMatches = function (n, selector) {
        if (this.isElementNode(n)) {
            return n.matches && n.matches(selector) ||
                n.msMatchesSelector && n.msMatchesSelector(selector) ||
                n.webkitMatchesSelector && n.webkitMatchesSelector(selector);
        }
        return false;
    };
    BrowserDomAdapter.prototype.isTemplateElement = function (el) {
        return this.isElementNode(el) && el.nodeName === 'TEMPLATE';
    };
    BrowserDomAdapter.prototype.isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    BrowserDomAdapter.prototype.isCommentNode = function (node) { return node.nodeType === Node.COMMENT_NODE; };
    BrowserDomAdapter.prototype.isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    BrowserDomAdapter.prototype.hasShadowRoot = function (node) {
        return node.shadowRoot != null && node instanceof HTMLElement;
    };
    BrowserDomAdapter.prototype.isShadowRoot = function (node) { return node instanceof DocumentFragment; };
    BrowserDomAdapter.prototype.importIntoDoc = function (node) { return document.importNode(this.templateAwareRoot(node), true); };
    BrowserDomAdapter.prototype.adoptNode = function (node) { return document.adoptNode(node); };
    BrowserDomAdapter.prototype.getHref = function (el) { return el.getAttribute('href'); };
    BrowserDomAdapter.prototype.getEventKey = function (event) {
        var key = event.key;
        if (key == null) {
            key = event.keyIdentifier;
            // keyIdentifier is defined in the old draft of DOM Level 3 Events implemented by Chrome and
            // Safari cf
            // http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/events.html#Events-KeyboardEvents-Interfaces
            if (key == null) {
                return 'Unidentified';
            }
            if (key.startsWith('U+')) {
                key = String.fromCharCode(parseInt(key.substring(2), 16));
                if (event.location === DOM_KEY_LOCATION_NUMPAD && _chromeNumKeyPadMap.hasOwnProperty(key)) {
                    // There is a bug in Chrome for numeric keypad keys:
                    // https://code.google.com/p/chromium/issues/detail?id=155654
                    // 1, 2, 3 ... are reported as A, B, C ...
                    key = _chromeNumKeyPadMap[key];
                }
            }
        }
        return _keyMap[key] || key;
    };
    BrowserDomAdapter.prototype.getGlobalEventTarget = function (doc, target) {
        if (target === 'window') {
            return window;
        }
        if (target === 'document') {
            return doc;
        }
        if (target === 'body') {
            return doc.body;
        }
        return null;
    };
    BrowserDomAdapter.prototype.getHistory = function () { return window.history; };
    BrowserDomAdapter.prototype.getLocation = function () { return window.location; };
    BrowserDomAdapter.prototype.getBaseHref = function (doc) {
        var href = getBaseElementHref();
        return href == null ? null : relativePath(href);
    };
    BrowserDomAdapter.prototype.resetBaseElement = function () { baseElement = null; };
    BrowserDomAdapter.prototype.getUserAgent = function () { return window.navigator.userAgent; };
    BrowserDomAdapter.prototype.setData = function (element, name, value) {
        this.setAttribute(element, 'data-' + name, value);
    };
    BrowserDomAdapter.prototype.getData = function (element, name) {
        return this.getAttribute(element, 'data-' + name);
    };
    BrowserDomAdapter.prototype.getComputedStyle = function (element) { return getComputedStyle(element); };
    // TODO(tbosch): move this into a separate environment class once we have it
    BrowserDomAdapter.prototype.supportsWebAnimation = function () {
        return typeof Element.prototype['animate'] === 'function';
    };
    BrowserDomAdapter.prototype.performanceNow = function () {
        // performance.now() is not available in all browsers, see
        // http://caniuse.com/#search=performance.now
        return window.performance && window.performance.now ? window.performance.now() :
            new Date().getTime();
    };
    BrowserDomAdapter.prototype.supportsCookies = function () { return true; };
    BrowserDomAdapter.prototype.getCookie = function (name) { return Object(__WEBPACK_IMPORTED_MODULE_1__angular_common__["ɵparseCookieValue"])(document.cookie, name); };
    BrowserDomAdapter.prototype.setCookie = function (name, value) {
        // document.cookie is magical, assigning into it assigns/overrides one cookie value, but does
        // not clear other cookies.
        document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    };
    return BrowserDomAdapter;
}(GenericBrowserDomAdapter));
var baseElement = null;
function getBaseElementHref() {
    if (!baseElement) {
        baseElement = document.querySelector('base');
        if (!baseElement) {
            return null;
        }
    }
    return baseElement.getAttribute('href');
}
// based on urlUtils.js in AngularJS 1
var urlParsingNode;
function relativePath(url) {
    if (!urlParsingNode) {
        urlParsingNode = document.createElement('a');
    }
    urlParsingNode.setAttribute('href', url);
    return (urlParsingNode.pathname.charAt(0) === '/') ? urlParsingNode.pathname :
        '/' + urlParsingNode.pathname;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A DI Token representing the main rendering context. In a browser this is the DOM Document.
 *
 * Note: Document might not be available in the Application Context when Application and Rendering
 * Contexts are not the same (e.g. when running the application into a Web Worker).
 *
 * @deprecated import from `@angular/common` instead.
 */
var DOCUMENT$1 = __WEBPACK_IMPORTED_MODULE_1__angular_common__["DOCUMENT"];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function supportsState() {
    return !!window.history.pushState;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * `PlatformLocation` encapsulates all of the direct calls to platform APIs.
 * This class should not be used directly by an application developer. Instead, use
 * {@link Location}.
 */
var BrowserPlatformLocation = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(BrowserPlatformLocation, _super);
    function BrowserPlatformLocation(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        _this._init();
        return _this;
    }
    // This is moved to its own method so that `MockPlatformLocationStrategy` can overwrite it
    /** @internal */
    BrowserPlatformLocation.prototype._init = function () {
        this.location = getDOM().getLocation();
        this._history = getDOM().getHistory();
    };
    BrowserPlatformLocation.prototype.getBaseHrefFromDOM = function () { return getDOM().getBaseHref(this._doc); };
    BrowserPlatformLocation.prototype.onPopState = function (fn) {
        getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('popstate', fn, false);
    };
    BrowserPlatformLocation.prototype.onHashChange = function (fn) {
        getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('hashchange', fn, false);
    };
    Object.defineProperty(BrowserPlatformLocation.prototype, "pathname", {
        get: function () { return this.location.pathname; },
        set: function (newPath) { this.location.pathname = newPath; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatformLocation.prototype, "search", {
        get: function () { return this.location.search; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatformLocation.prototype, "hash", {
        get: function () { return this.location.hash; },
        enumerable: true,
        configurable: true
    });
    BrowserPlatformLocation.prototype.pushState = function (state, title, url) {
        if (supportsState()) {
            this._history.pushState(state, title, url);
        }
        else {
            this.location.hash = url;
        }
    };
    BrowserPlatformLocation.prototype.replaceState = function (state, title, url) {
        if (supportsState()) {
            this._history.replaceState(state, title, url);
        }
        else {
            this.location.hash = url;
        }
    };
    BrowserPlatformLocation.prototype.forward = function () { this._history.forward(); };
    BrowserPlatformLocation.prototype.back = function () { this._history.back(); };
    BrowserPlatformLocation = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(DOCUMENT$1)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [Object])
    ], BrowserPlatformLocation);
    return BrowserPlatformLocation;
}(__WEBPACK_IMPORTED_MODULE_1__angular_common__["PlatformLocation"]));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An id that identifies a particular application being bootstrapped, that should
 * match across the client/server boundary.
 */
var TRANSITION_ID = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_2__angular_core__["InjectionToken"]('TRANSITION_ID');
function appInitializerFactory(transitionId, document, injector) {
    return function () {
        // Wait for all application initializers to be completed before removing the styles set by
        // the server.
        injector.get(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ApplicationInitStatus"]).donePromise.then(function () {
            var dom = getDOM();
            var styles = Array.prototype.slice.apply(dom.querySelectorAll(document, "style[ng-transition]"));
            styles.filter(function (el) { return dom.getAttribute(el, 'ng-transition') === transitionId; })
                .forEach(function (el) { return dom.remove(el); });
        });
    };
}
var SERVER_TRANSITION_PROVIDERS = [
    {
        provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["APP_INITIALIZER"],
        useFactory: appInitializerFactory,
        deps: [TRANSITION_ID, DOCUMENT$1, __WEBPACK_IMPORTED_MODULE_2__angular_core__["Injector"]],
        multi: true
    },
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var BrowserGetTestability = /*@__PURE__*/ (function () {
    function BrowserGetTestability() {
    }
    BrowserGetTestability.init = function () { Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["setTestabilityGetter"])(new BrowserGetTestability()); };
    BrowserGetTestability.prototype.addToWindow = function (registry) {
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['getAngularTestability'] = function (elem, findInAncestors) {
            if (findInAncestors === void 0) {
                findInAncestors = true;
            }
            var testability = registry.findTestabilityInTree(elem, findInAncestors);
            if (testability == null) {
                throw new Error('Could not find testability for element.');
            }
            return testability;
        };
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['getAllAngularTestabilities'] = function () { return registry.getAllTestabilities(); };
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['getAllAngularRootElements'] = function () { return registry.getAllRootElements(); };
        var whenAllStable = function (callback /** TODO #9100 */) {
            var testabilities = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['getAllAngularTestabilities']();
            var count = testabilities.length;
            var didWork = false;
            var decrement = function (didWork_ /** TODO #9100 */) {
                didWork = didWork || didWork_;
                count--;
                if (count == 0) {
                    callback(didWork);
                }
            };
            testabilities.forEach(function (testability /** TODO #9100 */) {
                testability.whenStable(decrement);
            });
        };
        if (!__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['frameworkStabilizers']) {
            __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['frameworkStabilizers'] = [];
        }
        __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['frameworkStabilizers'].push(whenAllStable);
    };
    BrowserGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
        if (elem == null) {
            return null;
        }
        var t = registry.getTestability(elem);
        if (t != null) {
            return t;
        }
        else if (!findInAncestors) {
            return null;
        }
        if (getDOM().isShadowRoot(elem)) {
            return this.findTestabilityInTree(registry, getDOM().getHost(elem), true);
        }
        return this.findTestabilityInTree(registry, getDOM().parentElement(elem), true);
    };
    return BrowserGetTestability;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Exports the value under a given `name` in the global property `ng`. For example `ng.probe` if
 * `name` is `'probe'`.
 * @param name Name under which it will be exported. Keep in mind this will be a property of the
 * global `ng` object.
 * @param value The value to export.
 */
function exportNgVar(name, value) {
    if (typeof COMPILED === 'undefined' || !COMPILED) {
        // Note: we can't export `ng` when using closure enhanced optimization as:
        // - closure declares globals itself for minified names, which sometimes clobber our `ng` global
        // - we can't declare a closure extern as the namespace `ng` is already used within Google
        //   for typings for angularJS (via `goog.provide('ng....')`).
        var ng = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['ng'] = __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵglobal"]['ng'] || {};
        ng[name] = value;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CORE_TOKENS = {
    'ApplicationRef': __WEBPACK_IMPORTED_MODULE_2__angular_core__["ApplicationRef"],
    'NgZone': __WEBPACK_IMPORTED_MODULE_2__angular_core__["NgZone"],
};
var INSPECT_GLOBAL_NAME = 'probe';
var CORE_TOKENS_GLOBAL_NAME = 'coreTokens';
/**
 * Returns a {@link DebugElement} for the given native DOM element, or
 * null if the given native element does not have an Angular view associated
 * with it.
 */
function inspectNativeElement(element) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["getDebugNode"])(element);
}
function _createNgProbe(coreTokens) {
    exportNgVar(INSPECT_GLOBAL_NAME, inspectNativeElement);
    exportNgVar(CORE_TOKENS_GLOBAL_NAME, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, CORE_TOKENS, _ngProbeTokensToMap(coreTokens || [])));
    return function () { return inspectNativeElement; };
}
function _ngProbeTokensToMap(tokens) {
    return tokens.reduce(function (prev, t) { return (prev[t.name] = t.token, prev); }, {});
}
/**
 * Providers which support debugging Angular applications (e.g. via `ng.probe`).
 */
var ELEMENT_PROBE_PROVIDERS = [
    {
        provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["APP_INITIALIZER"],
        useFactory: _createNgProbe,
        deps: [
            [__WEBPACK_IMPORTED_MODULE_2__angular_core__["NgProbeToken"], /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_2__angular_core__["Optional"]()],
        ],
        multi: true,
    },
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The injection token for the event-manager plug-in service.
 */
var EVENT_MANAGER_PLUGINS = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_2__angular_core__["InjectionToken"]('EventManagerPlugins');
/**
 * An injectable service that provides event management for Angular
 * through a browser plug-in.
 */
var EventManager = /*@__PURE__*/ (function () {
    /**
     * Initializes an instance of the event-manager service.
     */
    function EventManager(plugins, _zone) {
        var _this = this;
        this._zone = _zone;
        this._eventNameToPlugin = new Map();
        plugins.forEach(function (p) { return p.manager = _this; });
        this._plugins = plugins.slice().reverse();
    }
    /**
     * Registers a handler for a specific element and event.
     *
     * @param element The HTML element to receive event notifications.
     * @param eventName The name of the event to listen for.
     * @param handler A function to call when the notification occurs. Receives the
     * event object as an argument.
     * @returns  A callback function that can be used to remove the handler.
     */
    EventManager.prototype.addEventListener = function (element, eventName, handler) {
        var plugin = this._findPluginFor(eventName);
        return plugin.addEventListener(element, eventName, handler);
    };
    /**
     * Registers a global handler for an event in a target view.
     *
     * @param target A target for global event notifications. One of "window", "document", or "body".
     * @param eventName The name of the event to listen for.
     * @param handler A function to call when the notification occurs. Receives the
     * event object as an argument.
     * @returns A callback function that can be used to remove the handler.
     */
    EventManager.prototype.addGlobalEventListener = function (target, eventName, handler) {
        var plugin = this._findPluginFor(eventName);
        return plugin.addGlobalEventListener(target, eventName, handler);
    };
    /**
     * Retrieves the compilation zone in which event listeners are registered.
     */
    EventManager.prototype.getZone = function () { return this._zone; };
    /** @internal */
    EventManager.prototype._findPluginFor = function (eventName) {
        var plugin = this._eventNameToPlugin.get(eventName);
        if (plugin) {
            return plugin;
        }
        var plugins = this._plugins;
        for (var i = 0; i < plugins.length; i++) {
            var plugin_1 = plugins[i];
            if (plugin_1.supports(eventName)) {
                this._eventNameToPlugin.set(eventName, plugin_1);
                return plugin_1;
            }
        }
        throw new Error("No event manager plugin found for event " + eventName);
    };
    EventManager = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(EVENT_MANAGER_PLUGINS))
    ], EventManager);
    return EventManager;
}());
var EventManagerPlugin = /*@__PURE__*/ (function () {
    function EventManagerPlugin(_doc) {
        this._doc = _doc;
    }
    EventManagerPlugin.prototype.addGlobalEventListener = function (element, eventName, handler) {
        var target = getDOM().getGlobalEventTarget(this._doc, element);
        if (!target) {
            throw new Error("Unsupported event target " + target + " for event " + eventName);
        }
        return this.addEventListener(target, eventName, handler);
    };
    return EventManagerPlugin;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SharedStylesHost = /*@__PURE__*/ (function () {
    function SharedStylesHost() {
        /** @internal */
        this._stylesSet = new Set();
    }
    SharedStylesHost.prototype.addStyles = function (styles) {
        var _this = this;
        var additions = new Set();
        styles.forEach(function (style) {
            if (!_this._stylesSet.has(style)) {
                _this._stylesSet.add(style);
                additions.add(style);
            }
        });
        this.onStylesAdded(additions);
    };
    SharedStylesHost.prototype.onStylesAdded = function (additions) { };
    SharedStylesHost.prototype.getAllStyles = function () { return Array.from(this._stylesSet); };
    return SharedStylesHost;
}());
var DomSharedStylesHost = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(DomSharedStylesHost, _super);
    function DomSharedStylesHost(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        _this._hostNodes = new Set();
        _this._styleNodes = new Set();
        _this._hostNodes.add(_doc.head);
        return _this;
    }
    DomSharedStylesHost.prototype._addStylesToHost = function (styles, host) {
        var _this = this;
        styles.forEach(function (style) {
            var styleEl = _this._doc.createElement('style');
            styleEl.textContent = style;
            _this._styleNodes.add(host.appendChild(styleEl));
        });
    };
    DomSharedStylesHost.prototype.addHost = function (hostNode) {
        this._addStylesToHost(this._stylesSet, hostNode);
        this._hostNodes.add(hostNode);
    };
    DomSharedStylesHost.prototype.removeHost = function (hostNode) { this._hostNodes.delete(hostNode); };
    DomSharedStylesHost.prototype.onStylesAdded = function (additions) {
        var _this = this;
        this._hostNodes.forEach(function (hostNode) { return _this._addStylesToHost(additions, hostNode); });
    };
    DomSharedStylesHost.prototype.ngOnDestroy = function () { this._styleNodes.forEach(function (styleNode) { return getDOM().remove(styleNode); }); };
    DomSharedStylesHost = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(DOCUMENT$1))
    ], DomSharedStylesHost);
    return DomSharedStylesHost;
}(SharedStylesHost));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NAMESPACE_URIS = {
    'svg': 'http://www.w3.org/2000/svg',
    'xhtml': 'http://www.w3.org/1999/xhtml',
    'xlink': 'http://www.w3.org/1999/xlink',
    'xml': 'http://www.w3.org/XML/1998/namespace',
    'xmlns': 'http://www.w3.org/2000/xmlns/',
};
var COMPONENT_REGEX = /%COMP%/g;
var COMPONENT_VARIABLE = '%COMP%';
var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
function shimContentAttribute(componentShortId) {
    return CONTENT_ATTR.replace(COMPONENT_REGEX, componentShortId);
}
function shimHostAttribute(componentShortId) {
    return HOST_ATTR.replace(COMPONENT_REGEX, componentShortId);
}
function flattenStyles(compId, styles, target) {
    for (var i = 0; i < styles.length; i++) {
        var style = styles[i];
        if (Array.isArray(style)) {
            flattenStyles(compId, style, target);
        }
        else {
            style = style.replace(COMPONENT_REGEX, compId);
            target.push(style);
        }
    }
    return target;
}
function decoratePreventDefault(eventHandler) {
    return function (event) {
        var allowDefaultBehavior = eventHandler(event);
        if (allowDefaultBehavior === false) {
            // TODO(tbosch): move preventDefault into event plugins...
            event.preventDefault();
            event.returnValue = false;
        }
    };
}
var DomRendererFactory2 = /*@__PURE__*/ (function () {
    function DomRendererFactory2(eventManager, sharedStylesHost) {
        this.eventManager = eventManager;
        this.sharedStylesHost = sharedStylesHost;
        this.rendererByCompId = new Map();
        this.defaultRenderer = new DefaultDomRenderer2(eventManager);
    }
    DomRendererFactory2.prototype.createRenderer = function (element, type) {
        if (!element || !type) {
            return this.defaultRenderer;
        }
        switch (type.encapsulation) {
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].Emulated: {
                var renderer = this.rendererByCompId.get(type.id);
                if (!renderer) {
                    renderer =
                        new EmulatedEncapsulationDomRenderer2(this.eventManager, this.sharedStylesHost, type);
                    this.rendererByCompId.set(type.id, renderer);
                }
                renderer.applyToHost(element);
                return renderer;
            }
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].Native:
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].ShadowDom:
                return new ShadowDomRenderer(this.eventManager, this.sharedStylesHost, element, type);
            default: {
                if (!this.rendererByCompId.has(type.id)) {
                    var styles = flattenStyles(type.id, type.styles, []);
                    this.sharedStylesHost.addStyles(styles);
                    this.rendererByCompId.set(type.id, this.defaultRenderer);
                }
                return this.defaultRenderer;
            }
        }
    };
    DomRendererFactory2.prototype.begin = function () { };
    DomRendererFactory2.prototype.end = function () { };
    return DomRendererFactory2;
}());
var DefaultDomRenderer2 = /*@__PURE__*/ (function () {
    function DefaultDomRenderer2(eventManager) {
        this.eventManager = eventManager;
        this.data = Object.create(null);
    }
    DefaultDomRenderer2.prototype.destroy = function () { };
    DefaultDomRenderer2.prototype.createElement = function (name, namespace) {
        if (namespace) {
            return document.createElementNS(NAMESPACE_URIS[namespace], name);
        }
        return document.createElement(name);
    };
    DefaultDomRenderer2.prototype.createComment = function (value) { return document.createComment(value); };
    DefaultDomRenderer2.prototype.createText = function (value) { return document.createTextNode(value); };
    DefaultDomRenderer2.prototype.appendChild = function (parent, newChild) { parent.appendChild(newChild); };
    DefaultDomRenderer2.prototype.insertBefore = function (parent, newChild, refChild) {
        if (parent) {
            parent.insertBefore(newChild, refChild);
        }
    };
    DefaultDomRenderer2.prototype.removeChild = function (parent, oldChild) {
        if (parent) {
            parent.removeChild(oldChild);
        }
    };
    DefaultDomRenderer2.prototype.selectRootElement = function (selectorOrNode) {
        var el = typeof selectorOrNode === 'string' ? document.querySelector(selectorOrNode) :
            selectorOrNode;
        if (!el) {
            throw new Error("The selector \"" + selectorOrNode + "\" did not match any elements");
        }
        el.textContent = '';
        return el;
    };
    DefaultDomRenderer2.prototype.parentNode = function (node) { return node.parentNode; };
    DefaultDomRenderer2.prototype.nextSibling = function (node) { return node.nextSibling; };
    DefaultDomRenderer2.prototype.setAttribute = function (el, name, value, namespace) {
        if (namespace) {
            name = namespace + ":" + name;
            var namespaceUri = NAMESPACE_URIS[namespace];
            if (namespaceUri) {
                el.setAttributeNS(namespaceUri, name, value);
            }
            else {
                el.setAttribute(name, value);
            }
        }
        else {
            el.setAttribute(name, value);
        }
    };
    DefaultDomRenderer2.prototype.removeAttribute = function (el, name, namespace) {
        if (namespace) {
            var namespaceUri = NAMESPACE_URIS[namespace];
            if (namespaceUri) {
                el.removeAttributeNS(namespaceUri, name);
            }
            else {
                el.removeAttribute(namespace + ":" + name);
            }
        }
        else {
            el.removeAttribute(name);
        }
    };
    DefaultDomRenderer2.prototype.addClass = function (el, name) { el.classList.add(name); };
    DefaultDomRenderer2.prototype.removeClass = function (el, name) { el.classList.remove(name); };
    DefaultDomRenderer2.prototype.setStyle = function (el, style, value, flags) {
        if (flags & __WEBPACK_IMPORTED_MODULE_2__angular_core__["RendererStyleFlags2"].DashCase) {
            el.style.setProperty(style, value, !!(flags & __WEBPACK_IMPORTED_MODULE_2__angular_core__["RendererStyleFlags2"].Important) ? 'important' : '');
        }
        else {
            el.style[style] = value;
        }
    };
    DefaultDomRenderer2.prototype.removeStyle = function (el, style, flags) {
        if (flags & __WEBPACK_IMPORTED_MODULE_2__angular_core__["RendererStyleFlags2"].DashCase) {
            el.style.removeProperty(style);
        }
        else {
            // IE requires '' instead of null
            // see https://github.com/angular/angular/issues/7916
            el.style[style] = '';
        }
    };
    DefaultDomRenderer2.prototype.setProperty = function (el, name, value) {
        checkNoSyntheticProp(name, 'property');
        el[name] = value;
    };
    DefaultDomRenderer2.prototype.setValue = function (node, value) { node.nodeValue = value; };
    DefaultDomRenderer2.prototype.listen = function (target, event, callback) {
        checkNoSyntheticProp(event, 'listener');
        if (typeof target === 'string') {
            return this.eventManager.addGlobalEventListener(target, event, decoratePreventDefault(callback));
        }
        return this.eventManager.addEventListener(target, event, decoratePreventDefault(callback));
    };
    return DefaultDomRenderer2;
}());
var AT_CHARCODE = /*@__PURE__*/ '@'.charCodeAt(0);
function checkNoSyntheticProp(name, nameKind) {
    if (name.charCodeAt(0) === AT_CHARCODE) {
        throw new Error("Found the synthetic " + nameKind + " " + name + ". Please include either \"BrowserAnimationsModule\" or \"NoopAnimationsModule\" in your application.");
    }
}
var EmulatedEncapsulationDomRenderer2 = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(EmulatedEncapsulationDomRenderer2, _super);
    function EmulatedEncapsulationDomRenderer2(eventManager, sharedStylesHost, component) {
        var _this = _super.call(this, eventManager) || this;
        _this.component = component;
        var styles = flattenStyles(component.id, component.styles, []);
        sharedStylesHost.addStyles(styles);
        _this.contentAttr = shimContentAttribute(component.id);
        _this.hostAttr = shimHostAttribute(component.id);
        return _this;
    }
    EmulatedEncapsulationDomRenderer2.prototype.applyToHost = function (element) { _super.prototype.setAttribute.call(this, element, this.hostAttr, ''); };
    EmulatedEncapsulationDomRenderer2.prototype.createElement = function (parent, name) {
        var el = _super.prototype.createElement.call(this, parent, name);
        _super.prototype.setAttribute.call(this, el, this.contentAttr, '');
        return el;
    };
    return EmulatedEncapsulationDomRenderer2;
}(DefaultDomRenderer2));
var ShadowDomRenderer = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ShadowDomRenderer, _super);
    function ShadowDomRenderer(eventManager, sharedStylesHost, hostEl, component) {
        var _this = _super.call(this, eventManager) || this;
        _this.sharedStylesHost = sharedStylesHost;
        _this.hostEl = hostEl;
        _this.component = component;
        if (component.encapsulation === __WEBPACK_IMPORTED_MODULE_2__angular_core__["ViewEncapsulation"].ShadowDom) {
            _this.shadowRoot = hostEl.attachShadow({ mode: 'open' });
        }
        else {
            _this.shadowRoot = hostEl.createShadowRoot();
        }
        _this.sharedStylesHost.addHost(_this.shadowRoot);
        var styles = flattenStyles(component.id, component.styles, []);
        for (var i = 0; i < styles.length; i++) {
            var styleEl = document.createElement('style');
            styleEl.textContent = styles[i];
            _this.shadowRoot.appendChild(styleEl);
        }
        return _this;
    }
    ShadowDomRenderer.prototype.nodeOrShadowRoot = function (node) { return node === this.hostEl ? this.shadowRoot : node; };
    ShadowDomRenderer.prototype.destroy = function () { this.sharedStylesHost.removeHost(this.shadowRoot); };
    ShadowDomRenderer.prototype.appendChild = function (parent, newChild) {
        return _super.prototype.appendChild.call(this, this.nodeOrShadowRoot(parent), newChild);
    };
    ShadowDomRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
        return _super.prototype.insertBefore.call(this, this.nodeOrShadowRoot(parent), newChild, refChild);
    };
    ShadowDomRenderer.prototype.removeChild = function (parent, oldChild) {
        return _super.prototype.removeChild.call(this, this.nodeOrShadowRoot(parent), oldChild);
    };
    ShadowDomRenderer.prototype.parentNode = function (node) {
        return this.nodeOrShadowRoot(_super.prototype.parentNode.call(this, this.nodeOrShadowRoot(node)));
    };
    return ShadowDomRenderer;
}(DefaultDomRenderer2));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ɵ0 = function (v) {
    return '__zone_symbol__' + v;
};
/**
 * Detect if Zone is present. If it is then use simple zone aware 'addEventListener'
 * since Angular can do much more
 * efficient bookkeeping than Zone can, because we have additional information. This speeds up
 * addEventListener by 3x.
 */
var __symbol__ = (typeof Zone !== 'undefined') && Zone['__symbol__'] || ɵ0;
var ADD_EVENT_LISTENER = /*@__PURE__*/ __symbol__('addEventListener');
var REMOVE_EVENT_LISTENER = /*@__PURE__*/ __symbol__('removeEventListener');
var symbolNames = {};
var FALSE = 'FALSE';
var ANGULAR = 'ANGULAR';
var NATIVE_ADD_LISTENER = 'addEventListener';
var NATIVE_REMOVE_LISTENER = 'removeEventListener';
// use the same symbol string which is used in zone.js
var stopSymbol = '__zone_symbol__propagationStopped';
var stopMethodSymbol = '__zone_symbol__stopImmediatePropagation';
var blackListedEvents = (typeof Zone !== 'undefined') && Zone[/*@__PURE__*/ __symbol__('BLACK_LISTED_EVENTS')];
var blackListedMap;
if (blackListedEvents) {
    blackListedMap = {};
    /*@__PURE__*/ blackListedEvents.forEach(function (eventName) { blackListedMap[eventName] = eventName; });
}
var isBlackListedEvent = function (eventName) {
    if (!blackListedMap) {
        return false;
    }
    return blackListedMap.hasOwnProperty(eventName);
};
// a global listener to handle all dom event,
// so we do not need to create a closure every time
var globalListener = function (event) {
    var symbolName = symbolNames[event.type];
    if (!symbolName) {
        return;
    }
    var taskDatas = this[symbolName];
    if (!taskDatas) {
        return;
    }
    var args = [event];
    if (taskDatas.length === 1) {
        // if taskDatas only have one element, just invoke it
        var taskData = taskDatas[0];
        if (taskData.zone !== Zone.current) {
            // only use Zone.run when Zone.current not equals to stored zone
            return taskData.zone.run(taskData.handler, this, args);
        }
        else {
            return taskData.handler.apply(this, args);
        }
    }
    else {
        // copy tasks as a snapshot to avoid event handlers remove
        // itself or others
        var copiedTasks = taskDatas.slice();
        for (var i = 0; i < copiedTasks.length; i++) {
            // if other listener call event.stopImmediatePropagation
            // just break
            if (event[stopSymbol] === true) {
                break;
            }
            var taskData = copiedTasks[i];
            if (taskData.zone !== Zone.current) {
                // only use Zone.run when Zone.current not equals to stored zone
                taskData.zone.run(taskData.handler, this, args);
            }
            else {
                taskData.handler.apply(this, args);
            }
        }
    }
};
var DomEventsPlugin = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(DomEventsPlugin, _super);
    function DomEventsPlugin(doc, ngZone, platformId) {
        var _this = _super.call(this, doc) || this;
        _this.ngZone = ngZone;
        if (!platformId || !Object(__WEBPACK_IMPORTED_MODULE_1__angular_common__["isPlatformServer"])(platformId)) {
            _this.patchEvent();
        }
        return _this;
    }
    DomEventsPlugin.prototype.patchEvent = function () {
        if (typeof Event === 'undefined' || !Event || !Event.prototype) {
            return;
        }
        if (Event.prototype[stopMethodSymbol]) {
            // already patched by zone.js
            return;
        }
        var delegate = Event.prototype[stopMethodSymbol] =
            Event.prototype.stopImmediatePropagation;
        Event.prototype.stopImmediatePropagation = function () {
            if (this) {
                this[stopSymbol] = true;
            }
            // should call native delegate in case
            // in some environment part of the application
            // will not use the patched Event
            delegate && delegate.apply(this, arguments);
        };
    };
    // This plugin should come last in the list of plugins, because it accepts all
    // events.
    DomEventsPlugin.prototype.supports = function (eventName) { return true; };
    DomEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
        var _this = this;
        var zoneJsLoaded = element[ADD_EVENT_LISTENER];
        var callback = handler;
        // if zonejs is loaded and current zone is not ngZone
        // we keep Zone.current on target for later restoration.
        if (zoneJsLoaded && (!__WEBPACK_IMPORTED_MODULE_2__angular_core__["NgZone"].isInAngularZone() || isBlackListedEvent(eventName))) {
            var symbolName = symbolNames[eventName];
            if (!symbolName) {
                symbolName = symbolNames[eventName] = __symbol__(ANGULAR + eventName + FALSE);
            }
            var taskDatas = element[symbolName];
            var globalListenerRegistered = taskDatas && taskDatas.length > 0;
            if (!taskDatas) {
                taskDatas = element[symbolName] = [];
            }
            var zone = isBlackListedEvent(eventName) ? Zone.root : Zone.current;
            if (taskDatas.length === 0) {
                taskDatas.push({ zone: zone, handler: callback });
            }
            else {
                var callbackRegistered = false;
                for (var i = 0; i < taskDatas.length; i++) {
                    if (taskDatas[i].handler === callback) {
                        callbackRegistered = true;
                        break;
                    }
                }
                if (!callbackRegistered) {
                    taskDatas.push({ zone: zone, handler: callback });
                }
            }
            if (!globalListenerRegistered) {
                element[ADD_EVENT_LISTENER](eventName, globalListener, false);
            }
        }
        else {
            element[NATIVE_ADD_LISTENER](eventName, callback, false);
        }
        return function () { return _this.removeEventListener(element, eventName, callback); };
    };
    DomEventsPlugin.prototype.removeEventListener = function (target, eventName, callback) {
        var underlyingRemove = target[REMOVE_EVENT_LISTENER];
        // zone.js not loaded, use native removeEventListener
        if (!underlyingRemove) {
            return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
        }
        var symbolName = symbolNames[eventName];
        var taskDatas = symbolName && target[symbolName];
        if (!taskDatas) {
            // addEventListener not using patched version
            // just call native removeEventListener
            return target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
        }
        // fix issue 20532, should be able to remove
        // listener which was added inside of ngZone
        var found = false;
        for (var i = 0; i < taskDatas.length; i++) {
            // remove listener from taskDatas if the callback equals
            if (taskDatas[i].handler === callback) {
                found = true;
                taskDatas.splice(i, 1);
                break;
            }
        }
        if (found) {
            if (taskDatas.length === 0) {
                // all listeners are removed, we can remove the globalListener from target
                underlyingRemove.apply(target, [eventName, globalListener, false]);
            }
        }
        else {
            // not found in taskDatas, the callback may be added inside of ngZone
            // use native remove listener to remove the callback
            target[NATIVE_REMOVE_LISTENER].apply(target, [eventName, callback, false]);
        }
    };
    DomEventsPlugin = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(DOCUMENT$1)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_2__angular_core__["PLATFORM_ID"]))
    ], DomEventsPlugin);
    return DomEventsPlugin;
}(EventManagerPlugin));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Supported HammerJS recognizer event names.
 */
var EVENT_NAMES = {
    // pan
    'pan': true,
    'panstart': true,
    'panmove': true,
    'panend': true,
    'pancancel': true,
    'panleft': true,
    'panright': true,
    'panup': true,
    'pandown': true,
    // pinch
    'pinch': true,
    'pinchstart': true,
    'pinchmove': true,
    'pinchend': true,
    'pinchcancel': true,
    'pinchin': true,
    'pinchout': true,
    // press
    'press': true,
    'pressup': true,
    // rotate
    'rotate': true,
    'rotatestart': true,
    'rotatemove': true,
    'rotateend': true,
    'rotatecancel': true,
    // swipe
    'swipe': true,
    'swipeleft': true,
    'swiperight': true,
    'swipeup': true,
    'swipedown': true,
    // tap
    'tap': true,
};
/**
 * DI token for providing [HammerJS](http://hammerjs.github.io/) support to Angular.
 * @see `HammerGestureConfig`
 *
 * @experimental
 */
var HAMMER_GESTURE_CONFIG = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_2__angular_core__["InjectionToken"]('HammerGestureConfig');
/** Injection token used to provide a {@link HammerLoader} to Angular. */
var HAMMER_LOADER = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_2__angular_core__["InjectionToken"]('HammerLoader');
/**
 * An injectable [HammerJS Manager](http://hammerjs.github.io/api/#hammer.manager)
 * for gesture recognition. Configures specific event recognition.
 * @experimental
 */
var HammerGestureConfig = /*@__PURE__*/ (function () {
    function HammerGestureConfig() {
        /**
         * A set of supported event names for gestures to be used in Angular.
         * Angular supports all built-in recognizers, as listed in
         * [HammerJS documentation](http://hammerjs.github.io/).
         */
        this.events = [];
        /**
        * Maps gesture event names to a set of configuration options
        * that specify overrides to the default values for specific properties.
        *
        * The key is a supported event name to be configured,
        * and the options object contains a set of properties, with override values
        * to be applied to the named recognizer event.
        * For example, to disable recognition of the rotate event, specify
        *  `{"rotate": {"enable": false}}`.
        *
        * Properties that are not present take the HammerJS default values.
        * For information about which properties are supported for which events,
        * and their allowed and default values, see
        * [HammerJS documentation](http://hammerjs.github.io/).
        *
        */
        this.overrides = {};
    }
    /**
     * Creates a [HammerJS Manager](http://hammerjs.github.io/api/#hammer.manager)
     * and attaches it to a given HTML element.
     * @param element The element that will recognize gestures.
     * @returns A HammerJS event-manager object.
     */
    HammerGestureConfig.prototype.buildHammer = function (element) {
        var mc = new Hammer(element, this.options);
        mc.get('pinch').set({ enable: true });
        mc.get('rotate').set({ enable: true });
        for (var eventName in this.overrides) {
            mc.get(eventName).set(this.overrides[eventName]);
        }
        return mc;
    };
    return HammerGestureConfig;
}());
var HammerGesturesPlugin = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(HammerGesturesPlugin, _super);
    function HammerGesturesPlugin(doc, _config, console, loader) {
        var _this = _super.call(this, doc) || this;
        _this._config = _config;
        _this.console = console;
        _this.loader = loader;
        return _this;
    }
    HammerGesturesPlugin.prototype.supports = function (eventName) {
        if (!EVENT_NAMES.hasOwnProperty(eventName.toLowerCase()) && !this.isCustomEvent(eventName)) {
            return false;
        }
        if (!window.Hammer && !this.loader) {
            this.console.warn("The \"" + eventName + "\" event cannot be bound because Hammer.JS is not " +
                "loaded and no custom loader has been specified.");
            return false;
        }
        return true;
    };
    HammerGesturesPlugin.prototype.addEventListener = function (element, eventName, handler) {
        var _this = this;
        var zone = this.manager.getZone();
        eventName = eventName.toLowerCase();
        // If Hammer is not present but a loader is specified, we defer adding the event listener
        // until Hammer is loaded.
        if (!window.Hammer && this.loader) {
            // This `addEventListener` method returns a function to remove the added listener.
            // Until Hammer is loaded, the returned function needs to *cancel* the registration rather
            // than remove anything.
            var cancelRegistration_1 = false;
            var deregister_1 = function () { cancelRegistration_1 = true; };
            this.loader()
                .then(function () {
                // If Hammer isn't actually loaded when the custom loader resolves, give up.
                if (!window.Hammer) {
                    _this.console.warn("The custom HAMMER_LOADER completed, but Hammer.JS is not present.");
                    deregister_1 = function () { };
                    return;
                }
                if (!cancelRegistration_1) {
                    // Now that Hammer is loaded and the listener is being loaded for real,
                    // the deregistration function changes from canceling registration to removal.
                    deregister_1 = _this.addEventListener(element, eventName, handler);
                }
            })
                .catch(function () {
                _this.console.warn("The \"" + eventName + "\" event cannot be bound because the custom " +
                    "Hammer.JS loader failed.");
                deregister_1 = function () { };
            });
            // Return a function that *executes* `deregister` (and not `deregister` itself) so that we
            // can change the behavior of `deregister` once the listener is added. Using a closure in
            // this way allows us to avoid any additional data structures to track listener removal.
            return function () { deregister_1(); };
        }
        return zone.runOutsideAngular(function () {
            // Creating the manager bind events, must be done outside of angular
            var mc = _this._config.buildHammer(element);
            var callback = function (eventObj) {
                zone.runGuarded(function () { handler(eventObj); });
            };
            mc.on(eventName, callback);
            return function () {
                mc.off(eventName, callback);
                // destroy mc to prevent memory leak
                if (typeof mc.destroy === 'function') {
                    mc.destroy();
                }
            };
        });
    };
    HammerGesturesPlugin.prototype.isCustomEvent = function (eventName) { return this._config.events.indexOf(eventName) > -1; };
    HammerGesturesPlugin = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(DOCUMENT$1)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(HAMMER_GESTURE_CONFIG)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(HAMMER_LOADER))
    ], HammerGesturesPlugin);
    return HammerGesturesPlugin;
}(EventManagerPlugin));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Defines supported modifiers for key events.
 */
var MODIFIER_KEYS = ['alt', 'control', 'meta', 'shift'];
var ɵ0$1 = function (event) { return event.altKey; }, ɵ1$1 = function (event) { return event.ctrlKey; }, ɵ2$1 = function (event) { return event.metaKey; }, ɵ3 = function (event) { return event.shiftKey; };
/**
 * Retrieves modifiers from key-event objects.
 */
var MODIFIER_KEY_GETTERS = {
    'alt': ɵ0$1,
    'control': ɵ1$1,
    'meta': ɵ2$1,
    'shift': ɵ3
};
/**
 * @experimental
 * A browser plug-in that provides support for handling of key events in Angular.
 */
var KeyEventsPlugin = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(KeyEventsPlugin, _super);
    /**
     * Initializes an instance of the browser plug-in.
     * @param doc The document in which key events will be detected.
     */
    function KeyEventsPlugin(doc) {
        return _super.call(this, doc) || this;
    }
    KeyEventsPlugin_1 = KeyEventsPlugin;
    /**
      * Reports whether a named key event is supported.
      * @param eventName The event name to query.
      * @return True if the named key event is supported.
     */
    KeyEventsPlugin.prototype.supports = function (eventName) { return KeyEventsPlugin_1.parseEventName(eventName) != null; };
    /**
     * Registers a handler for a specific element and key event.
     * @param element The HTML element to receive event notifications.
     * @param eventName The name of the key event to listen for.
     * @param handler A function to call when the notification occurs. Receives the
     * event object as an argument.
     * @returns The key event that was registered.
    */
    KeyEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
        var parsedEvent = KeyEventsPlugin_1.parseEventName(eventName);
        var outsideHandler = KeyEventsPlugin_1.eventCallback(parsedEvent['fullKey'], handler, this.manager.getZone());
        return this.manager.getZone().runOutsideAngular(function () {
            return getDOM().onAndCancel(element, parsedEvent['domEventName'], outsideHandler);
        });
    };
    KeyEventsPlugin.parseEventName = function (eventName) {
        var parts = eventName.toLowerCase().split('.');
        var domEventName = parts.shift();
        if ((parts.length === 0) || !(domEventName === 'keydown' || domEventName === 'keyup')) {
            return null;
        }
        var key = KeyEventsPlugin_1._normalizeKey(parts.pop());
        var fullKey = '';
        MODIFIER_KEYS.forEach(function (modifierName) {
            var index = parts.indexOf(modifierName);
            if (index > -1) {
                parts.splice(index, 1);
                fullKey += modifierName + '.';
            }
        });
        fullKey += key;
        if (parts.length != 0 || key.length === 0) {
            // returning null instead of throwing to let another plugin process the event
            return null;
        }
        var result = {};
        result['domEventName'] = domEventName;
        result['fullKey'] = fullKey;
        return result;
    };
    KeyEventsPlugin.getEventFullKey = function (event) {
        var fullKey = '';
        var key = getDOM().getEventKey(event);
        key = key.toLowerCase();
        if (key === ' ') {
            key = 'space'; // for readability
        }
        else if (key === '.') {
            key = 'dot'; // because '.' is used as a separator in event names
        }
        MODIFIER_KEYS.forEach(function (modifierName) {
            if (modifierName != key) {
                var modifierGetter = MODIFIER_KEY_GETTERS[modifierName];
                if (modifierGetter(event)) {
                    fullKey += modifierName + '.';
                }
            }
        });
        fullKey += key;
        return fullKey;
    };
    /**
     * Configures a handler callback for a key event.
     * @param fullKey The event name that combines all simultaneous keystrokes.
     * @param handler The function that responds to the key event.
     * @param zone The zone in which the event occurred.
     * @returns A callback function.
     */
    KeyEventsPlugin.eventCallback = function (fullKey, handler, zone) {
        return function (event /** TODO #9100 */) {
            if (KeyEventsPlugin_1.getEventFullKey(event) === fullKey) {
                zone.runGuarded(function () { return handler(event); });
            }
        };
    };
    /** @internal */
    KeyEventsPlugin._normalizeKey = function (keyName) {
        // TODO: switch to a Map if the mapping grows too much
        switch (keyName) {
            case 'esc':
                return 'escape';
            default:
                return keyName;
        }
    };
    var KeyEventsPlugin_1;
    KeyEventsPlugin = KeyEventsPlugin_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(DOCUMENT$1))
    ], KeyEventsPlugin);
    return KeyEventsPlugin;
}(EventManagerPlugin));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * DomSanitizer helps preventing Cross Site Scripting Security bugs (XSS) by sanitizing
 * values to be safe to use in the different DOM contexts.
 *
 * For example, when binding a URL in an `<a [href]="someValue">` hyperlink, `someValue` will be
 * sanitized so that an attacker cannot inject e.g. a `javascript:` URL that would execute code on
 * the website.
 *
 * In specific situations, it might be necessary to disable sanitization, for example if the
 * application genuinely needs to produce a `javascript:` style link with a dynamic value in it.
 * Users can bypass security by constructing a value with one of the `bypassSecurityTrust...`
 * methods, and then binding to that value from the template.
 *
 * These situations should be very rare, and extraordinary care must be taken to avoid creating a
 * Cross Site Scripting (XSS) security bug!
 *
 * When using `bypassSecurityTrust...`, make sure to call the method as early as possible and as
 * close as possible to the source of the value, to make it easy to verify no security bug is
 * created by its use.
 *
 * It is not required (and not recommended) to bypass security if the value is safe, e.g. a URL that
 * does not start with a suspicious protocol, or an HTML snippet that does not contain dangerous
 * code. The sanitizer leaves safe values intact.
 *
 * @security Calling any of the `bypassSecurityTrust...` APIs disables Angular's built-in
 * sanitization for the value passed in. Carefully check and audit all values and code paths going
 * into this call. Make sure any user data is appropriately escaped for this security context.
 * For more detail, see the [Security Guide](http://g.co/ng/security).
 *
 *
 */
var DomSanitizer = /*@__PURE__*/ (function () {
    function DomSanitizer() {
    }
    return DomSanitizer;
}());
var DomSanitizerImpl = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(DomSanitizerImpl, _super);
    function DomSanitizerImpl(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        return _this;
    }
    DomSanitizerImpl.prototype.sanitize = function (ctx, value) {
        if (value == null)
            return null;
        switch (ctx) {
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["SecurityContext"].NONE:
                return value;
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["SecurityContext"].HTML:
                if (value instanceof SafeHtmlImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'HTML');
                return Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵ_sanitizeHtml"])(this._doc, String(value));
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["SecurityContext"].STYLE:
                if (value instanceof SafeStyleImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'Style');
                return Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵ_sanitizeStyle"])(value);
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["SecurityContext"].SCRIPT:
                if (value instanceof SafeScriptImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'Script');
                throw new Error('unsafe value used in a script context');
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["SecurityContext"].URL:
                if (value instanceof SafeResourceUrlImpl || value instanceof SafeUrlImpl) {
                    // Allow resource URLs in URL contexts, they are strictly more trusted.
                    return value.changingThisBreaksApplicationSecurity;
                }
                this.checkNotSafeValue(value, 'URL');
                return Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵ_sanitizeUrl"])(String(value));
            case __WEBPACK_IMPORTED_MODULE_2__angular_core__["SecurityContext"].RESOURCE_URL:
                if (value instanceof SafeResourceUrlImpl) {
                    return value.changingThisBreaksApplicationSecurity;
                }
                this.checkNotSafeValue(value, 'ResourceURL');
                throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
            default:
                throw new Error("Unexpected SecurityContext " + ctx + " (see http://g.co/ng/security#xss)");
        }
    };
    DomSanitizerImpl.prototype.checkNotSafeValue = function (value, expectedType) {
        if (value instanceof SafeValueImpl) {
            throw new Error("Required a safe " + expectedType + ", got a " + value.getTypeName() + " " +
                "(see http://g.co/ng/security#xss)");
        }
    };
    DomSanitizerImpl.prototype.bypassSecurityTrustHtml = function (value) { return new SafeHtmlImpl(value); };
    DomSanitizerImpl.prototype.bypassSecurityTrustStyle = function (value) { return new SafeStyleImpl(value); };
    DomSanitizerImpl.prototype.bypassSecurityTrustScript = function (value) { return new SafeScriptImpl(value); };
    DomSanitizerImpl.prototype.bypassSecurityTrustUrl = function (value) { return new SafeUrlImpl(value); };
    DomSanitizerImpl.prototype.bypassSecurityTrustResourceUrl = function (value) {
        return new SafeResourceUrlImpl(value);
    };
    DomSanitizerImpl = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(DOCUMENT$1))
    ], DomSanitizerImpl);
    return DomSanitizerImpl;
}(DomSanitizer));
var SafeValueImpl = /*@__PURE__*/ (function () {
    function SafeValueImpl(changingThisBreaksApplicationSecurity) {
        this.changingThisBreaksApplicationSecurity = changingThisBreaksApplicationSecurity;
        // empty
    }
    SafeValueImpl.prototype.toString = function () {
        return "SafeValue must use [property]=binding: " + this.changingThisBreaksApplicationSecurity +
            " (see http://g.co/ng/security#xss)";
    };
    return SafeValueImpl;
}());
var SafeHtmlImpl = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(SafeHtmlImpl, _super);
    function SafeHtmlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SafeHtmlImpl.prototype.getTypeName = function () { return 'HTML'; };
    return SafeHtmlImpl;
}(SafeValueImpl));
var SafeStyleImpl = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(SafeStyleImpl, _super);
    function SafeStyleImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SafeStyleImpl.prototype.getTypeName = function () { return 'Style'; };
    return SafeStyleImpl;
}(SafeValueImpl));
var SafeScriptImpl = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(SafeScriptImpl, _super);
    function SafeScriptImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SafeScriptImpl.prototype.getTypeName = function () { return 'Script'; };
    return SafeScriptImpl;
}(SafeValueImpl));
var SafeUrlImpl = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(SafeUrlImpl, _super);
    function SafeUrlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SafeUrlImpl.prototype.getTypeName = function () { return 'URL'; };
    return SafeUrlImpl;
}(SafeValueImpl));
var SafeResourceUrlImpl = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(SafeResourceUrlImpl, _super);
    function SafeResourceUrlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SafeResourceUrlImpl.prototype.getTypeName = function () { return 'ResourceURL'; };
    return SafeResourceUrlImpl;
}(SafeValueImpl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var INTERNAL_BROWSER_PLATFORM_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["PLATFORM_ID"], useValue: __WEBPACK_IMPORTED_MODULE_1__angular_common__["ɵPLATFORM_BROWSER_ID"] },
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["PLATFORM_INITIALIZER"], useValue: initDomAdapter, multi: true },
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_common__["PlatformLocation"], useClass: BrowserPlatformLocation, deps: [DOCUMENT$1] },
    { provide: DOCUMENT$1, useFactory: _document, deps: [] },
];
/**
 * @security Replacing built-in sanitization providers exposes the application to XSS risks.
 * Attacker-controlled data introduced by an unsanitized provider could expose your
 * application to XSS risks. For more detail, see the [Security Guide](http://g.co/ng/security).
 * @experimental
 */
var BROWSER_SANITIZATION_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Sanitizer"], useExisting: DomSanitizer },
    { provide: DomSanitizer, useClass: DomSanitizerImpl, deps: [DOCUMENT$1] },
];
var platformBrowser = /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["createPlatformFactory"])(__WEBPACK_IMPORTED_MODULE_2__angular_core__["platformCore"], 'browser', INTERNAL_BROWSER_PLATFORM_PROVIDERS);
function initDomAdapter() {
    BrowserDomAdapter.makeCurrent();
    BrowserGetTestability.init();
}
function errorHandler() {
    return new __WEBPACK_IMPORTED_MODULE_2__angular_core__["ErrorHandler"]();
}
function _document() {
    return document;
}
var BROWSER_MODULE_PROVIDERS = [
    BROWSER_SANITIZATION_PROVIDERS,
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵAPP_ROOT"], useValue: true },
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["ErrorHandler"], useFactory: errorHandler, deps: [] },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: DomEventsPlugin,
        multi: true,
        deps: [DOCUMENT$1, __WEBPACK_IMPORTED_MODULE_2__angular_core__["NgZone"], __WEBPACK_IMPORTED_MODULE_2__angular_core__["PLATFORM_ID"]]
    },
    { provide: EVENT_MANAGER_PLUGINS, useClass: KeyEventsPlugin, multi: true, deps: [DOCUMENT$1] },
    {
        provide: EVENT_MANAGER_PLUGINS,
        useClass: HammerGesturesPlugin,
        multi: true,
        deps: [DOCUMENT$1, HAMMER_GESTURE_CONFIG, __WEBPACK_IMPORTED_MODULE_2__angular_core__["ɵConsole"], [/*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_2__angular_core__["Optional"](), HAMMER_LOADER]]
    },
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig, deps: [] },
    {
        provide: DomRendererFactory2,
        useClass: DomRendererFactory2,
        deps: [EventManager, DomSharedStylesHost]
    },
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["RendererFactory2"], useExisting: DomRendererFactory2 },
    { provide: SharedStylesHost, useExisting: DomSharedStylesHost },
    { provide: DomSharedStylesHost, useClass: DomSharedStylesHost, deps: [DOCUMENT$1] },
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Testability"], useClass: __WEBPACK_IMPORTED_MODULE_2__angular_core__["Testability"], deps: [__WEBPACK_IMPORTED_MODULE_2__angular_core__["NgZone"]] },
    { provide: EventManager, useClass: EventManager, deps: [EVENT_MANAGER_PLUGINS, __WEBPACK_IMPORTED_MODULE_2__angular_core__["NgZone"]] },
    ELEMENT_PROBE_PROVIDERS,
];
/**
 * Exports required infrastructure for all Angular apps.
 * Included by defaults in all Angular apps created with the CLI
 * `new` command.
 * Re-exports `CommonModule` and `ApplicationModule`, making their
 * exports and providers available to all apps.
 *
 *
 */
var BrowserModule = /*@__PURE__*/ (function () {
    function BrowserModule(parentModule) {
        if (parentModule) {
            throw new Error("BrowserModule has already been loaded. If you need access to common directives such as NgIf and NgFor from a lazy loaded module, import CommonModule instead.");
        }
    }
    BrowserModule_1 = BrowserModule;
    /**
     * Configures a browser-based app to transition from a server-rendered app, if
     * one is present on the page.
     *
     * @param params An object containing an identifier for the app to transition.
     * The ID must match between the client and server versions of the app.
     * @returns The reconfigured `BrowserModule` to import into the app's root `AppModule`.
     *
     * @experimental
     */
    BrowserModule.withServerTransition = function (params) {
        return {
            ngModule: BrowserModule_1,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_2__angular_core__["APP_ID"], useValue: params.appId },
                { provide: TRANSITION_ID, useExisting: __WEBPACK_IMPORTED_MODULE_2__angular_core__["APP_ID"] },
                SERVER_TRANSITION_PROVIDERS,
            ],
        };
    };
    var BrowserModule_1;
    BrowserModule = BrowserModule_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["SkipSelf"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(BrowserModule_1))
    ], BrowserModule);
    return BrowserModule;
}());
/**
 * Factory to create Meta service.
 */
function createMeta() {
    return new Meta(Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["inject"])(DOCUMENT$1));
}
/**
 * A service that can be used to get and add meta tags.
 *
 * @experimental
 */
var Meta = /*@__PURE__*/ (function () {
    function Meta(_doc) {
        this._doc = _doc;
        this._dom = getDOM();
    }
    Meta.prototype.addTag = function (tag, forceCreation) {
        if (forceCreation === void 0) {
            forceCreation = false;
        }
        if (!tag)
            return null;
        return this._getOrCreateElement(tag, forceCreation);
    };
    Meta.prototype.addTags = function (tags, forceCreation) {
        var _this = this;
        if (forceCreation === void 0) {
            forceCreation = false;
        }
        if (!tags)
            return [];
        return tags.reduce(function (result, tag) {
            if (tag) {
                result.push(_this._getOrCreateElement(tag, forceCreation));
            }
            return result;
        }, []);
    };
    Meta.prototype.getTag = function (attrSelector) {
        if (!attrSelector)
            return null;
        return this._dom.querySelector(this._doc, "meta[" + attrSelector + "]") || null;
    };
    Meta.prototype.getTags = function (attrSelector) {
        if (!attrSelector)
            return [];
        var list /*NodeList*/ = this._dom.querySelectorAll(this._doc, "meta[" + attrSelector + "]");
        return list ? [].slice.call(list) : [];
    };
    Meta.prototype.updateTag = function (tag, selector) {
        if (!tag)
            return null;
        selector = selector || this._parseSelector(tag);
        var meta = this.getTag(selector);
        if (meta) {
            return this._setMetaElementAttributes(tag, meta);
        }
        return this._getOrCreateElement(tag, true);
    };
    Meta.prototype.removeTag = function (attrSelector) { this.removeTagElement(this.getTag(attrSelector)); };
    Meta.prototype.removeTagElement = function (meta) {
        if (meta) {
            this._dom.remove(meta);
        }
    };
    Meta.prototype._getOrCreateElement = function (meta, forceCreation) {
        if (forceCreation === void 0) {
            forceCreation = false;
        }
        if (!forceCreation) {
            var selector = this._parseSelector(meta);
            var elem = this.getTag(selector);
            // It's allowed to have multiple elements with the same name so it's not enough to
            // just check that element with the same name already present on the page. We also need to
            // check if element has tag attributes
            if (elem && this._containsAttributes(meta, elem))
                return elem;
        }
        var element = this._dom.createElement('meta');
        this._setMetaElementAttributes(meta, element);
        var head = this._dom.getElementsByTagName(this._doc, 'head')[0];
        this._dom.appendChild(head, element);
        return element;
    };
    Meta.prototype._setMetaElementAttributes = function (tag, el) {
        var _this = this;
        Object.keys(tag).forEach(function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); });
        return el;
    };
    Meta.prototype._parseSelector = function (tag) {
        var attr = tag.name ? 'name' : 'property';
        return attr + "=\"" + tag[attr] + "\"";
    };
    Meta.prototype._containsAttributes = function (tag, elem) {
        var _this = this;
        return Object.keys(tag).every(function (key) { return _this._dom.getAttribute(elem, key) === tag[key]; });
    };
    Meta.ngInjectableDef = Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["defineInjectable"])({ factory: createMeta, token: Meta, providedIn: "root" });
    Meta = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(DOCUMENT$1))
    ], Meta);
    return Meta;
}());
/**
 * Factory to create Title service.
 */
function createTitle() {
    return new Title(Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["inject"])(DOCUMENT$1));
}
/**
 * A service that can be used to get and set the title of a current HTML document.
 *
 * Since an Angular application can't be bootstrapped on the entire HTML document (`<html>` tag)
 * it is not possible to bind to the `text` property of the `HTMLTitleElement` elements
 * (representing the `<title>` tag). Instead, this service can be used to set and get the current
 * title value.
 *
 * @experimental
 */
var Title = /*@__PURE__*/ (function () {
    function Title(_doc) {
        this._doc = _doc;
    }
    /**
     * Get the title of the current HTML document.
     */
    Title.prototype.getTitle = function () { return getDOM().getTitle(this._doc); };
    /**
     * Set the title of the current HTML document.
     * @param newTitle
     */
    Title.prototype.setTitle = function (newTitle) { getDOM().setTitle(this._doc, newTitle); };
    Title.ngInjectableDef = Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["defineInjectable"])({ factory: createTitle, token: Title, providedIn: "root" });
    Title = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_2__angular_core__["Inject"])(DOCUMENT$1))
    ], Title);
    return Title;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var win = typeof window !== 'undefined' && window || {};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ChangeDetectionPerfRecord = /*@__PURE__*/ (function () {
    function ChangeDetectionPerfRecord(msPerTick, numTicks) {
        this.msPerTick = msPerTick;
        this.numTicks = numTicks;
    }
    return ChangeDetectionPerfRecord;
}());
/**
 * Entry point for all Angular profiling-related debug tools. This object
 * corresponds to the `ng.profiler` in the dev console.
 */
var AngularProfiler = /*@__PURE__*/ (function () {
    function AngularProfiler(ref) {
        this.appRef = ref.injector.get(__WEBPACK_IMPORTED_MODULE_2__angular_core__["ApplicationRef"]);
    }
    // tslint:disable:no-console
    /**
     * Exercises change detection in a loop and then prints the average amount of
     * time in milliseconds how long a single round of change detection takes for
     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
     * of 500 milliseconds.
     *
     * Optionally, a user may pass a `config` parameter containing a map of
     * options. Supported options are:
     *
     * `record` (boolean) - causes the profiler to record a CPU profile while
     * it exercises the change detector. Example:
     *
     * ```
     * ng.profiler.timeChangeDetection({record: true})
     * ```
     */
    AngularProfiler.prototype.timeChangeDetection = function (config) {
        var record = config && config['record'];
        var profileName = 'Change Detection';
        // Profiler is not available in Android browsers, nor in IE 9 without dev tools opened
        var isProfilerAvailable = win.console.profile != null;
        if (record && isProfilerAvailable) {
            win.console.profile(profileName);
        }
        var start = getDOM().performanceNow();
        var numTicks = 0;
        while (numTicks < 5 || (getDOM().performanceNow() - start) < 500) {
            this.appRef.tick();
            numTicks++;
        }
        var end = getDOM().performanceNow();
        if (record && isProfilerAvailable) {
            // need to cast to <any> because type checker thinks there's no argument
            // while in fact there is:
            //
            // https://developer.mozilla.org/en-US/docs/Web/API/Console/profileEnd
            win.console.profileEnd(profileName);
        }
        var msPerTick = (end - start) / numTicks;
        win.console.log("ran " + numTicks + " change detection cycles");
        win.console.log(msPerTick.toFixed(2) + " ms per check");
        return new ChangeDetectionPerfRecord(msPerTick, numTicks);
    };
    return AngularProfiler;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var PROFILER_GLOBAL_NAME = 'profiler';
/**
 * Enabled Angular debug tools that are accessible via your browser's
 * developer console.
 *
 * Usage:
 *
 * 1. Open developer console (e.g. in Chrome Ctrl + Shift + j)
 * 1. Type `ng.` (usually the console will show auto-complete suggestion)
 * 1. Try the change detection profiler `ng.profiler.timeChangeDetection()`
 *    then hit Enter.
 *
 * @experimental All debugging apis are currently experimental.
 */
function enableDebugTools(ref) {
    exportNgVar(PROFILER_GLOBAL_NAME, new AngularProfiler(ref));
    return ref;
}
/**
 * Disables Angular tools.
 *
 * @experimental All debugging apis are currently experimental.
 */
function disableDebugTools() {
    exportNgVar(PROFILER_GLOBAL_NAME, null);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function escapeHtml(text) {
    var escapedText = {
        '&': '&a;',
        '"': '&q;',
        '\'': '&s;',
        '<': '&l;',
        '>': '&g;',
    };
    return text.replace(/[&"'<>]/g, function (s) { return escapedText[s]; });
}
function unescapeHtml(text) {
    var unescapedText = {
        '&a;': '&',
        '&q;': '"',
        '&s;': '\'',
        '&l;': '<',
        '&g;': '>',
    };
    return text.replace(/&[^;]+;/g, function (s) { return unescapedText[s]; });
}
/**
 * Create a `StateKey<T>` that can be used to store value of type T with `TransferState`.
 *
 * Example:
 *
 * ```
 * const COUNTER_KEY = makeStateKey<number>('counter');
 * let value = 10;
 *
 * transferState.set(COUNTER_KEY, value);
 * ```
 *
 * @experimental
 */
function makeStateKey(key) {
    return key;
}
/**
 * A key value store that is transferred from the application on the server side to the application
 * on the client side.
 *
 * `TransferState` will be available as an injectable token. To use it import
 * `ServerTransferStateModule` on the server and `BrowserTransferStateModule` on the client.
 *
 * The values in the store are serialized/deserialized using JSON.stringify/JSON.parse. So only
 * boolean, number, string, null and non-class objects will be serialized and deserialzied in a
 * non-lossy manner.
 *
 * @experimental
 */
var TransferState = /*@__PURE__*/ (function () {
    function TransferState() {
        this.store = {};
        this.onSerializeCallbacks = {};
    }
    TransferState_1 = TransferState;
    /** @internal */
    TransferState.init = function (initState) {
        var transferState = new TransferState_1();
        transferState.store = initState;
        return transferState;
    };
    /**
     * Get the value corresponding to a key. Return `defaultValue` if key is not found.
     */
    TransferState.prototype.get = function (key, defaultValue) {
        return this.store[key] !== undefined ? this.store[key] : defaultValue;
    };
    /**
     * Set the value corresponding to a key.
     */
    TransferState.prototype.set = function (key, value) { this.store[key] = value; };
    /**
     * Remove a key from the store.
     */
    TransferState.prototype.remove = function (key) { delete this.store[key]; };
    /**
     * Test whether a key exists in the store.
     */
    TransferState.prototype.hasKey = function (key) { return this.store.hasOwnProperty(key); };
    /**
     * Register a callback to provide the value for a key when `toJson` is called.
     */
    TransferState.prototype.onSerialize = function (key, callback) {
        this.onSerializeCallbacks[key] = callback;
    };
    /**
     * Serialize the current state of the store to JSON.
     */
    TransferState.prototype.toJson = function () {
        // Call the onSerialize callbacks and put those values into the store.
        for (var key in this.onSerializeCallbacks) {
            if (this.onSerializeCallbacks.hasOwnProperty(key)) {
                try {
                    this.store[key] = this.onSerializeCallbacks[key]();
                }
                catch (e) {
                    console.warn('Exception in onSerialize callback: ', e);
                }
            }
        }
        return JSON.stringify(this.store);
    };
    var TransferState_1;
    return TransferState;
}());
function initTransferState(doc, appId) {
    // Locate the script tag with the JSON data transferred from the server.
    // The id of the script tag is set to the Angular appId + 'state'.
    var script = doc.getElementById(appId + '-state');
    var initialState = {};
    if (script && script.textContent) {
        try {
            initialState = JSON.parse(unescapeHtml(script.textContent));
        }
        catch (e) {
            console.warn('Exception while restoring TransferState for app ' + appId, e);
        }
    }
    return TransferState.init(initialState);
}
/**
 * NgModule to install on the client side while using the `TransferState` to transfer state from
 * server to client.
 *
 * @experimental
 */
var BrowserTransferStateModule = /*@__PURE__*/ (function () {
    function BrowserTransferStateModule() {
    }
    return BrowserTransferStateModule;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Predicates for use with {@link DebugElement}'s query functions.
 *
 * @experimental All debugging apis are currently experimental.
 */
var By = /*@__PURE__*/ (function () {
    function By() {
    }
    /**
     * Match all elements.
     *
     * @usageNotes
     * ### Example
     *
     * {@example platform-browser/dom/debug/ts/by/by.ts region='by_all'}
     */
    By.all = function () { return function (debugElement) { return true; }; };
    /**
     * Match elements by the given CSS selector.
     *
     * @usageNotes
     * ### Example
     *
     * {@example platform-browser/dom/debug/ts/by/by.ts region='by_css'}
     */
    By.css = function (selector) {
        return function (debugElement) {
            return debugElement.nativeElement != null ?
                getDOM().elementMatches(debugElement.nativeElement, selector) :
                false;
        };
    };
    /**
     * Match elements that have the given directive present.
     *
     * @usageNotes
     * ### Example
     *
     * {@example platform-browser/dom/debug/ts/by/by.ts region='by_directive'}
     */
    By.directive = function (type) {
        return function (debugElement) { return debugElement.providerTokens.indexOf(type) !== -1; };
    };
    return By;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var VERSION = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_2__angular_core__["Version"]('6.1.10');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */






/***/ }),

/***/ "5N57":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD"),
    root = __webpack_require__("TQ3y");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "5Omq":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        ss: '%d sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),

/***/ "5XgX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js
var Observable = __webpack_require__("lWPP");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isPromise.js
var isPromise = __webpack_require__("XTlk");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArrayLike.js
var isArrayLike = __webpack_require__("6iAM");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js
var isInteropObservable = __webpack_require__("CmsN");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isIterable.js
var isIterable = __webpack_require__("I6Lf");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromArray.js
var fromArray = __webpack_require__("b2EL");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromPromise.js
var fromPromise = __webpack_require__("CPX7");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromIterable.js
var fromIterable = __webpack_require__("qpVq");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__("HC03");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/observable.js
var symbol_observable = __webpack_require__("V9Cg");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js
var subscribeToObservable = __webpack_require__("JzXe");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromObservable.js
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable,_util_subscribeToObservable PURE_IMPORTS_END */




function fromObservable(input, scheduler) {
    if (!scheduler) {
        return new Observable["a" /* Observable */](Object(subscribeToObservable["a" /* subscribeToObservable */])(input));
    }
    else {
        return new Observable["a" /* Observable */](function (subscriber) {
            var sub = new Subscription["a" /* Subscription */]();
            sub.add(scheduler.schedule(function () {
                var observable = input[symbol_observable["a" /* observable */]]();
                sub.add(observable.subscribe({
                    next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                    error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                    complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
                }));
            }));
            return sub;
        });
    }
}
//# sourceMappingURL=fromObservable.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeTo.js
var subscribeTo = __webpack_require__("dfzL");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/from.js
/* harmony export (immutable) */ __webpack_exports__["a"] = from;
/** PURE_IMPORTS_START _Observable,_util_isPromise,_util_isArrayLike,_util_isInteropObservable,_util_isIterable,_fromArray,_fromPromise,_fromIterable,_fromObservable,_util_subscribeTo PURE_IMPORTS_END */










function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof Observable["a" /* Observable */]) {
            return input;
        }
        return new Observable["a" /* Observable */](Object(subscribeTo["a" /* subscribeTo */])(input));
    }
    if (input != null) {
        if (Object(isInteropObservable["a" /* isInteropObservable */])(input)) {
            return fromObservable(input, scheduler);
        }
        else if (Object(isPromise["a" /* isPromise */])(input)) {
            return Object(fromPromise["a" /* fromPromise */])(input, scheduler);
        }
        else if (Object(isArrayLike["a" /* isArrayLike */])(input)) {
            return Object(fromArray["a" /* fromArray */])(input, scheduler);
        }
        else if (Object(isIterable["a" /* isIterable */])(input) || typeof input === 'string') {
            return Object(fromIterable["a" /* fromIterable */])(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}
//# sourceMappingURL=from.js.map


/***/ }),

/***/ "5Zxu":
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__("sBat");

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ "5eyr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isScheduler;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
//# sourceMappingURL=isScheduler.js.map


/***/ }),

/***/ "5j66":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        ss: '%d វិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),

/***/ "5vPg":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'ss': output = '%d सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'ss': output = '%d सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        ss: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),

/***/ "6Git":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("Kzd6");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ "6MiT":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ "6OI+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var common_1 = __webpack_require__("wTuo");
var helpers_1 = __webpack_require__("/mv9");
var color_picker_service_1 = __webpack_require__("RlMM");
var color_picker_component_1 = __webpack_require__("yCRx");
var color_picker_directive_1 = __webpack_require__("M96w");
var ColorPickerModule = /*@__PURE__*/ (function () {
    function ColorPickerModule() {
    }
    ColorPickerModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule],
                    providers: [color_picker_service_1.ColorPickerService],
                    declarations: [color_picker_component_1.ColorPickerComponent, color_picker_directive_1.ColorPickerDirective, helpers_1.TextDirective, helpers_1.SliderDirective],
                    exports: [color_picker_directive_1.ColorPickerDirective],
                    entryComponents: [color_picker_component_1.ColorPickerComponent]
                },] },
    ];
    return ColorPickerModule;
}());
exports.ColorPickerModule = ColorPickerModule;



/***/ }),

/***/ "6cf8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        ss : '%d секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),

/***/ "6iAM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArrayLike; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map


/***/ }),

/***/ "7HNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubjectSubscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(__WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]));






/***/ }),

/***/ "7LV+":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            return result + (plural(number) ? 'sekundy' : 'sekund');
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W niedzielę o] LT';

                case 2:
                    return '[We wtorek o] LT';

                case 3:
                    return '[W środę o] LT';

                case 6:
                    return '[W sobotę o] LT';

                default:
                    return '[W] dddd [o] LT';
            }
        },
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),

/***/ "7MHZ":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),

/***/ "7OnE":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),

/***/ "7Q8x":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        ss : '%d mzuzwana',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),

/***/ "7YkW":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("YeCl"),
    setCacheAdd = __webpack_require__("Cskv"),
    setCacheHas = __webpack_require__("aQOO");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "7e4z":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("uieL"),
    isArguments = __webpack_require__("1Yb9"),
    isArray = __webpack_require__("NGEn"),
    isBuffer = __webpack_require__("ggOT"),
    isIndex = __webpack_require__("ZGh9"),
    isTypedArray = __webpack_require__("YsVG");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "7jYp":
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__("nWuj"),
    arrayReduce = __webpack_require__("3rZI"),
    setToArray = __webpack_require__("octw");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),

/***/ "7mk3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeoutError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */

/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */
var TimeoutError = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](TimeoutError, _super);
    function TimeoutError() {
        var _this = _super.call(this, 'Timeout has occurred') || this;
        Object.setPrototypeOf(_this, TimeoutError.prototype);
        return _this;
    }
    return TimeoutError;
}(Error));






/***/ }),

/***/ "7t+N":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.2.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( ">tbody", elem )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with computed style
	var valueIsBorderBox,
		styles = getStyles( elem ),
		val = curCSS( elem, name, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Computed unit is not pixels. Stop here and return.
	if ( rnumnonpx.test( val ) ) {
		return val;
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = isBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ name ] );

	// Fall back to offsetWidth/Height when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	if ( val === "auto" ) {
		val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
	}

	// Normalize "", auto, and prepare for extra
	val = parseFloat( val ) || 0;

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var doc, docElem, rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		doc = elem.ownerDocument;
		docElem = doc.documentElement;
		win = doc.defaultView;

		return {
			top: rect.top + win.pageYOffset - docElem.clientTop,
			left: rect.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( jQuery.isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ "8++/":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ "8AZL":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "8LP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = not;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
//# sourceMappingURL=not.js.map


/***/ }),

/***/ "8QP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/index.js + 16 modules
var _esm5 = __webpack_require__("0nHL");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/operators/index.js + 91 modules
var operators = __webpack_require__("Nyrq");

// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/map.js

/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return Object(operators["map"])(project, thisArg)(this);
}
//# sourceMappingURL=map.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/map.js


_esm5["d" /* Observable */].prototype.map = map;
//# sourceMappingURL=map.js.map

/***/ }),

/***/ "8gK5":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "8v14":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),

/***/ "9/kn":
/***/ (function(module, exports, __webpack_require__) {

/**
* @license
* Copyright Google Inc. All Rights Reserved.
*
* Use of this source code is governed by an MIT-style license that can be
* found in the LICENSE file at https://angular.io/license
*/
(function (global, factory) {
     true ? factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (factory());
}(this, (function () {
    'use strict';
    /**
     * @license
     * Copyright Google Inc. All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /**
     * @fileoverview
     * @suppress {globalThis}
     */
    var NEWLINE = '\n';
    var IGNORE_FRAMES = {};
    var creationTrace = '__creationTrace__';
    var ERROR_TAG = 'STACKTRACE TRACKING';
    var SEP_TAG = '__SEP_TAG__';
    var sepTemplate = SEP_TAG + '@[native]';
    var LongStackTrace = /*@__PURE__*/ (function () {
        function LongStackTrace() {
            this.error = getStacktrace();
            this.timestamp = new Date();
        }
        return LongStackTrace;
    }());
    function getStacktraceWithUncaughtError() {
        return new Error(ERROR_TAG);
    }
    function getStacktraceWithCaughtError() {
        try {
            throw getStacktraceWithUncaughtError();
        }
        catch (err) {
            return err;
        }
    }
    // Some implementations of exception handling don't create a stack trace if the exception
    // isn't thrown, however it's faster not to actually throw the exception.
    var error = getStacktraceWithUncaughtError();
    var caughtError = getStacktraceWithCaughtError();
    var getStacktrace = error.stack ?
        getStacktraceWithUncaughtError :
        (caughtError.stack ? getStacktraceWithCaughtError : getStacktraceWithUncaughtError);
    function getFrames(error) {
        return error.stack ? error.stack.split(NEWLINE) : [];
    }
    function addErrorStack(lines, error) {
        var trace = getFrames(error);
        for (var i = 0; i < trace.length; i++) {
            var frame = trace[i];
            // Filter out the Frames which are part of stack capturing.
            if (!IGNORE_FRAMES.hasOwnProperty(frame)) {
                lines.push(trace[i]);
            }
        }
    }
    function renderLongStackTrace(frames, stack) {
        var longTrace = [stack ? stack.trim() : ''];
        if (frames) {
            var timestamp = new Date().getTime();
            for (var i = 0; i < frames.length; i++) {
                var traceFrames = frames[i];
                var lastTime = traceFrames.timestamp;
                var separator = "____________________Elapsed " + (timestamp - lastTime.getTime()) + " ms; At: " + lastTime;
                separator = separator.replace(/[^\w\d]/g, '_');
                longTrace.push(sepTemplate.replace(SEP_TAG, separator));
                addErrorStack(longTrace, traceFrames.error);
                timestamp = lastTime.getTime();
            }
        }
        return longTrace.join(NEWLINE);
    }
    Zone['longStackTraceZoneSpec'] = {
        name: 'long-stack-trace',
        longStackTraceLimit: 10,
        // add a getLongStackTrace method in spec to
        // handle handled reject promise error.
        getLongStackTrace: function (error) {
            if (!error) {
                return undefined;
            }
            var task = error[Zone.__symbol__('currentTask')];
            var trace = task && task.data && task.data[creationTrace];
            if (!trace) {
                return error.stack;
            }
            return renderLongStackTrace(trace, error.stack);
        },
        onScheduleTask: function (parentZoneDelegate, currentZone, targetZone, task) {
            if (Error.stackTraceLimit > 0) {
                // if Error.stackTraceLimit is 0, means stack trace
                // is disabled, so we don't need to generate long stack trace
                // this will improve performance in some test(some test will
                // set stackTraceLimit to 0, https://github.com/angular/zone.js/issues/698
                var currentTask = Zone.currentTask;
                var trace = currentTask && currentTask.data && currentTask.data[creationTrace] || [];
                trace = [new LongStackTrace()].concat(trace);
                if (trace.length > this.longStackTraceLimit) {
                    trace.length = this.longStackTraceLimit;
                }
                if (!task.data)
                    task.data = {};
                task.data[creationTrace] = trace;
            }
            return parentZoneDelegate.scheduleTask(targetZone, task);
        },
        onHandleError: function (parentZoneDelegate, currentZone, targetZone, error) {
            if (Error.stackTraceLimit > 0) {
                // if Error.stackTraceLimit is 0, means stack trace
                // is disabled, so we don't need to generate long stack trace
                // this will improve performance in some test(some test will
                // set stackTraceLimit to 0, https://github.com/angular/zone.js/issues/698
                var parentTask = Zone.currentTask || error.task;
                if (error instanceof Error && parentTask) {
                    var longStack = renderLongStackTrace(parentTask.data && parentTask.data[creationTrace], error.stack);
                    try {
                        error.stack = error.longStack = longStack;
                    }
                    catch (err) {
                    }
                }
            }
            return parentZoneDelegate.handleError(targetZone, error);
        }
    };
    function captureStackTraces(stackTraces, count) {
        if (count > 0) {
            stackTraces.push(getFrames((new LongStackTrace()).error));
            captureStackTraces(stackTraces, count - 1);
        }
    }
    function computeIgnoreFrames() {
        if (Error.stackTraceLimit <= 0) {
            return;
        }
        var frames = [];
        captureStackTraces(frames, 2);
        var frames1 = frames[0];
        var frames2 = frames[1];
        for (var i = 0; i < frames1.length; i++) {
            var frame1 = frames1[i];
            if (frame1.indexOf(ERROR_TAG) == -1) {
                var match = frame1.match(/^\s*at\s+/);
                if (match) {
                    sepTemplate = match[0] + SEP_TAG + ' (http://localhost)';
                    break;
                }
            }
        }
        for (var i = 0; i < frames1.length; i++) {
            var frame1 = frames1[i];
            var frame2 = frames2[i];
            if (frame1 === frame2) {
                IGNORE_FRAMES[frame1] = true;
            }
            else {
                break;
            }
        }
    }
    computeIgnoreFrames();
})));



/***/ }),

/***/ "92UZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map


/***/ }),

/***/ "94sX":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dCZQ");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "9UkZ":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    getPrototype = __webpack_require__("vi0E"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "9hho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToArray; });
/**
 * Subscribes to an ArrayLike with a subscriber
 * @param array The array or array-like to subscribe to
 */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        if (!subscriber.closed) {
            subscriber.complete();
        }
    };
};
//# sourceMappingURL=subscribeToArray.js.map


/***/ }),

/***/ "9vdN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scalar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

function scalar(value) {
    var result = new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        subscriber.next(value);
        subscriber.complete();
    });
    result._isScalar = true;
    result.value = value;
    return result;
}
//# sourceMappingURL=scalar.js.map


/***/ }),

/***/ "A9mX":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("pTUa");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "ALEw":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),

/***/ "Ab7C":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),

/***/ "Ai/T":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "AoDM":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),

/***/ "B+Nj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bb", function() { return InternalFormsSharedModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_ba", function() { return REACTIVE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_y", function() { return SHARED_FORM_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_z", function() { return TEMPLATE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_a", function() { return CHECKBOX_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_b", function() { return DEFAULT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_c", function() { return AbstractControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_d", function() { return ngControlStatusHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_e", function() { return formDirectiveProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_f", function() { return formControlBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_g", function() { return modelGroupProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bg", function() { return NgNoValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bc", function() { return NUMBER_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bd", function() { return NumberValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_h", function() { return RADIO_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_i", function() { return RadioControlRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_be", function() { return RANGE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_bf", function() { return RangeValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_j", function() { return NG_MODEL_WITH_FORM_CONTROL_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_k", function() { return formControlBinding$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_l", function() { return controlNameBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_m", function() { return formDirectiveProvider$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_o", function() { return formArrayNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_n", function() { return formGroupNameProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_p", function() { return SELECT_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_r", function() { return NgSelectMultipleOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_q", function() { return SELECT_MULTIPLE_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_t", function() { return CHECKBOX_REQUIRED_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_u", function() { return EMAIL_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_w", function() { return MAX_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_v", function() { return MIN_LENGTH_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_x", function() { return PATTERN_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_forms_forms_s", function() { return REQUIRED_VALIDATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControlDirective", function() { return AbstractControlDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractFormGroupDirective", function() { return AbstractFormGroupDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxControlValueAccessor", function() { return CheckboxControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ControlContainer", function() { return ControlContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALUE_ACCESSOR", function() { return NG_VALUE_ACCESSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPOSITION_BUFFER_MODE", function() { return COMPOSITION_BUFFER_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultValueAccessor", function() { return DefaultValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControl", function() { return NgControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatus", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgControlStatusGroup", function() { return NgControlStatusGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForm", function() { return NgForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModel", function() { return NgModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModelGroup", function() { return NgModelGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioControlValueAccessor", function() { return RadioControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlDirective", function() { return FormControlDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControlName", function() { return FormControlName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupDirective", function() { return FormGroupDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArrayName", function() { return FormArrayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroupName", function() { return FormGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSelectOption", function() { return NgSelectOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectControlValueAccessor", function() { return SelectControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectMultipleControlValueAccessor", function() { return SelectMultipleControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxRequiredValidator", function() { return CheckboxRequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() { return EmailValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MaxLengthValidator", function() { return MaxLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinLengthValidator", function() { return MinLengthValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PatternValidator", function() { return PatternValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequiredValidator", function() { return RequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormBuilder", function() { return FormBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AbstractControl", function() { return AbstractControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormArray", function() { return FormArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return FormControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_ASYNC_VALIDATORS", function() { return NG_ASYNC_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NG_VALIDATORS", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Validators", function() { return Validators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormsModule", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactiveFormsModule", function() { return ReactiveFormsModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = /*@__PURE__*/__webpack_require__("0nHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__ = /*@__PURE__*/__webpack_require__("5D2H");
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START tslib,_angular_core,rxjs,rxjs_operators,_angular_platform_browser PURE_IMPORTS_END */





/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 * Base class for control directives.
 *
 * This class is only used internally in the `ReactiveFormsModule` and the `FormsModule`.
 *
 */
var AbstractControlDirective = /*@__PURE__*/ (function () {
    function AbstractControlDirective() {
    }
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        /**
         * @description
         * Reports the value of the control if it is present, otherwise null.
         */
        get: function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        /**
         * @description
         * Reports whether the control is valid. A control is considered valid if no
         * validation errors exist with the current value.
         * If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        /**
         * @description
         * Reports whether the control is invalid, meaning that an error exists in the input value.
         * If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        /**
         * @description
         * Reports whether a control is pending, meaning that that async validation is occurring and
         * errors are not yet available for the input value. If the control is not present, null is
         * returned.
         */
        get: function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        /**
         * @description
         * Reports whether the control is disabled, meaning that the control is disabled
         * in the UI and is exempt from validation checks and excluded from aggregate
         * values of ancestor controls. If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        /**
         * @description
         * Reports whether the control is enabled, meaning that the control is included in ancestor
         * calculations of validity or value. If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        /**
         * @description
         * Reports the control's validation errors. If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        /**
         * @description
         * Reports whether the control is pristine, meaning that the user has not yet changed
         * the value in the UI. If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        /**
         * @description
         * Reports whether the control is dirty, meaning that the user has changed
         * the value in the UI. If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        /**
         * @description
         * Reports whether the control is touched, meaning that the user has triggered
         * a `blur` event on it. If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "status", {
        /**
         * @description
         * Reports the validation status of the control. Possible values include:
         * 'VALID', 'INVALID', 'DISABLED', and 'PENDING'.
         * If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.status : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        /**
         * @description
         * Reports whether the control is untouched, meaning that the user has not yet triggered
         * a `blur` event on it. If the control is not present, null is returned.
         */
        get: function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        /**
         * @description
         * Returns a multicasting observable that emits a validation status whenever it is
         * calculated for the control. If the control is not present, null is returned.
         */
        get: function () {
            return this.control ? this.control.statusChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        /**
         * @description
         * Returns a multicasting observable of value changes for the control that emits every time the
         * value of the control changes in the UI or programmatically.
         * If the control is not present, null is returned.
         */
        get: function () {
            return this.control ? this.control.valueChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        /**
         * @description
         * Returns an array that represents the path from the top-level form to this control.
         * Each index is the string name of the control on that level.
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    /**
     * @description
     * Resets the control with the provided value if the control is present.
     */
    AbstractControlDirective.prototype.reset = function (value) {
        if (value === void 0) {
            value = undefined;
        }
        if (this.control)
            this.control.reset(value);
    };
    /**
     * @description
     * Reports whether the control with the given path has the error specified.
     * If no path is given, it checks for the error on the present control.
     * If the control is not present, false is returned.
     */
    AbstractControlDirective.prototype.hasError = function (errorCode, path) {
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    /**
     * @description
     * Reports error data for the control with the given path.
     * If the control is not present, null is returned.
     */
    AbstractControlDirective.prototype.getError = function (errorCode, path) {
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 * A base class for directives that contain multiple registered instances of `NgControl`.
 * Only used by the forms module.
 */
var ControlContainer = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ControlContainer, _super);
    function ControlContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * @description
         * The top-level form directive for the control.
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * @description
         * The path to this group.
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(AbstractControlDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * @description
 * An `InjectionToken` for registering additional synchronous validators used with `AbstractControl`s.
 *
 * @see `NG_ASYNC_VALIDATORS`
 *
 * @usageNotes
 *
 * ### Providing a custom validator
 *
 * The following example registers a custom validator directive. Adding the validator to the
 * existing collection of validators requires the `multi: true` option.
 *
 * ```typescript
 * @Directive({
 *   selector: '[customValidator]',
 *   providers: [{provide: NG_VALIDATORS, useExisting: CustomValidatorDirective, multi: true}]
 * })
 * class CustomValidatorDirective implements Validator {
 *   validate(control: AbstractControl): ValidationErrors | null {
 *     return { 'custom': true };
 *   }
 * }
 * ```
 *
 */
var NG_VALIDATORS = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgValidators');
/**
 * @description
 * An `InjectionToken` for registering additional asynchronous validators used with `AbstractControl`s.
 *
 * @see `NG_VALIDATORS`
 *
 */
var NG_ASYNC_VALIDATORS = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgAsyncValidators');
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
/**
 * @description
 * Provides a set of built-in validators that can be used by form controls.
 *
 * A validator is a function that processes a `FormControl` or collection of
 * controls and returns an error map or null. A null map means that validation has passed.
 *
 * @see [Form Validation](/guide/form-validation)
 *
 */
var Validators = /*@__PURE__*/ (function () {
    function Validators() {
    }
    /**
     * @description
     * Validator that requires the control's value to be greater than or equal to the provided number.
     * The validator exists only as a function and not as a directive.
     *
     * @usageNotes
     *
     * ### Validate against a minimum of 3
     *
     * ```typescript
     * const control = new FormControl(2, Validators.min(3));
     *
     * console.log(control.errors); // {min: {min: 3, actual: 2}}
     * ```
     *
     * @returns A validator function that returns an error map with the
     * `min` property if the validation check fails, otherwise `null`.
     *
     */
    Validators.min = function (min) {
        return function (control) {
            if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
                return null; // don't validate empty values to allow optional controls
            }
            var value = parseFloat(control.value);
            // Controls with NaN values after parsing should be treated as not having a
            // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
            return !isNaN(value) && value < min ? { 'min': { 'min': min, 'actual': control.value } } : null;
        };
    };
    /**
     * @description
     * Validator that requires the control's value to be less than or equal to the provided number.
     * The validator exists only as a function and not as a directive.
     *
     * @usageNotes
     *
     * ### Validate against a maximum of 15
     *
     * ```typescript
     * const control = new FormControl(16, Validators.max(15));
     *
     * console.log(control.errors); // {max: {max: 15, actual: 16}}
     * ```
     *
     * @returns A validator function that returns an error map with the
     * `max` property if the validation check fails, otherwise `null`.
     *
     */
    Validators.max = function (max) {
        return function (control) {
            if (isEmptyInputValue(control.value) || isEmptyInputValue(max)) {
                return null; // don't validate empty values to allow optional controls
            }
            var value = parseFloat(control.value);
            // Controls with NaN values after parsing should be treated as not having a
            // maximum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-max
            return !isNaN(value) && value > max ? { 'max': { 'max': max, 'actual': control.value } } : null;
        };
    };
    /**
     * @description
     * Validator that requires the control have a non-empty value.
     *
     * @usageNotes
     *
     * ### Validate that the field is non-empty
     *
     * ```typescript
     * const control = new FormControl('', Validators.required);
     *
     * console.log(control.errors); // {required: true}
     * ```
     *
     * @returns An error map with the `required` property
     * if the validation check fails, otherwise `null`.
     *
     */
    Validators.required = function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * @description
     * Validator that requires the control's value be true. This validator is commonly
     * used for required checkboxes.
     *
     * @usageNotes
     *
     * ### Validate that the field value is true
     *
     * ```typescript
     * const control = new FormControl('', Validators.requiredTrue);
     *
     * console.log(control.errors); // {required: true}
     * ```
     *
     * @returns An error map that contains the `required` property
     * set to `true` if the validation check fails, otherwise `null`.
     */
    Validators.requiredTrue = function (control) {
        return control.value === true ? null : { 'required': true };
    };
    /**
     * @description
     * Validator that requires the control's value pass an email validation test.
     *
     * @usageNotes
     *
     * ### Validate that the field matches a valid email pattern
     *
     * ```typescript
     * const control = new FormControl('bad@', Validators.email);
     *
     * console.log(control.errors); // {email: true}
     * ```
     *
     * @returns An error map with the `email` property
     * if the validation check fails, otherwise `null`.
     *
     */
    Validators.email = function (control) {
        if (isEmptyInputValue(control.value)) {
            return null; // don't validate empty values to allow optional controls
        }
        return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
    };
    /**
     * @description
     * Validator that requires the length of the control's value to be greater than or equal
     * to the provided minimum length. This validator is also provided by default if you use the
     * the HTML5 `minlength` attribute.
     *
     * @usageNotes
     *
     * ### Validate that the field has a minimum of 3 characters
     *
     * ```typescript
     * const control = new FormControl('ng', Validators.minLength(3));
     *
     * console.log(control.errors); // {minlength: {requiredLength: 3, actualLength: 2}}
     * ```
     *
     * ```html
     * <input minlength="5">
     * ```
     *
     * @returns A validator function that returns an error map with the
     * `minlength` if the validation check fails, otherwise `null`.
     */
    Validators.minLength = function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var length = control.value ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * @description
     * Validator that requires the length of the control's value to be less than or equal
     * to the provided maximum length. This validator is also provided by default if you use the
     * the HTML5 `maxlength` attribute.
     *
     * @usageNotes
     *
     * ### Validate that the field has maximum of 5 characters
     *
     * ```typescript
     * const control = new FormControl('Angular', Validators.maxLength(5));
     *
     * console.log(control.errors); // {maxlength: {requiredLength: 5, actualLength: 7}}
     * ```
     *
     * ```html
     * <input maxlength="5">
     * ```
     *
     * @returns A validator function that returns an error map with the
     * `maxlength` property if the validation check fails, otherwise `null`.
     */
    Validators.maxLength = function (maxLength) {
        return function (control) {
            var length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * @description
     * Validator that requires the control's value to match a regex pattern. This validator is also
     * provided
     * by default if you use the HTML5 `pattern` attribute.
     *
     * @usageNotes
     *
     * ### Validate that the field only contains letters or spaces
     *
     * ```typescript
     * const control = new FormControl('1', Validators.pattern('[a-zA-Z ]*'));
     *
     * console.log(control.errors); // {pattern: {requiredPattern: '^[a-zA-Z ]*$', actualValue: '1'}}
     * ```
     *
     * ```html
     * <input pattern="[a-zA-Z ]*">
     * ```
     *
     * @returns A validator function that returns an error map with the
     * `pattern` property if the validation check fails, otherwise `null`.
     */
    Validators.pattern = function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var regex;
        var regexStr;
        if (typeof pattern === 'string') {
            regexStr = '';
            if (pattern.charAt(0) !== '^')
                regexStr += '^';
            regexStr += pattern;
            if (pattern.charAt(pattern.length - 1) !== '$')
                regexStr += '$';
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     * @description
     * Validator that performs no operation.
     */
    Validators.nullValidator = function (control) { return null; };
    Validators.compose = function (validators) {
        if (!validators)
            return null;
        var presentValidators = validators.filter(isPresent);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    /**
     * @description
     * Compose multiple async validators into a single function that returns the union
     * of the individual error objects for the provided control.
     *
     * @returns A validator function that returns an error map with the
     * merged error objects of the async validators if the validation check fails, otherwise `null`.
    */
    Validators.composeAsync = function (validators) {
        if (!validators)
            return null;
        var presentValidators = validators.filter(isPresent);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["p" /* forkJoin */])(observables).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(_mergeErrors));
        };
    };
    return Validators;
}());
function isPresent(o) {
    return o != null;
}
function toObservable(r) {
    var obs = Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisPromise"])(r) ? Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(r) : r;
    if (!(Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisObservable"])(obs))) {
        throw new Error("Expected validator to return Promise or Observable.");
    }
    return obs;
}
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
function _mergeErrors(arrayOfErrors) {
    var res = arrayOfErrors.reduce(function (res, errors) {
        return errors != null ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, res, errors) : res;
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to provide a `ControlValueAccessor` for form controls.
 *
 * See `DefaultValueAccessor` for how to implement one.
 *
 */
var NG_VALUE_ACCESSOR = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgValueAccessor');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <input type="checkbox" name="rememberLogin" ngModel>
 * ```
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var CheckboxControlValueAccessor = /*@__PURE__*/ (function () {
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', value);
    };
    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return CheckboxControlValueAccessor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DEFAULT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 */
function _isAndroid() {
    var userAgent = Object(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["t" /* ɵgetDOM */])() ? Object(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["t" /* ɵgetDOM */])().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
/**
 * Turn this mode on if you want form directives to buffer IME input until compositionend
 * @experimental
 */
var COMPOSITION_BUFFER_MODE = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('CompositionEventMode');
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * `NgModel`, `FormControlDirective`, and `FormControlName` directives.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <input type="text" name="searchQuery" ngModel>
 * ```
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var DefaultValueAccessor = /*@__PURE__*/ (function () {
    function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        /** Whether the user is creating a composition string (IME events). */
        this._composing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    DefaultValueAccessor.prototype.writeValue = function (value) {
        var normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    DefaultValueAccessor.prototype._handleInput = function (value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this.onChange(value);
        }
    };
    /** @internal */
    DefaultValueAccessor.prototype._compositionStart = function () { this._composing = true; };
    /** @internal */
    DefaultValueAccessor.prototype._compositionEnd = function (value) {
        this._composing = false;
        this._compositionMode && this.onChange(value);
    };
    DefaultValueAccessor = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(COMPOSITION_BUFFER_MODE))
    ], DefaultValueAccessor);
    return DefaultValueAccessor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function normalizeValidator(validator) {
    if (validator.validate) {
        return function (c) { return validator.validate(c); };
    }
    else {
        return validator;
    }
}
function normalizeAsyncValidator(validator) {
    if (validator.validate) {
        return function (c) { return validator.validate(c); };
    }
    else {
        return validator;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NUMBER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * `NgModel`, `FormControlDirective`, and `FormControlName` directives.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <input type="number" [(ngModel)]="age">
 * ```
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var NumberValueAccessor = /*@__PURE__*/ (function () {
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    NumberValueAccessor.prototype.writeValue = function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    NumberValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return NumberValueAccessor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * @description
 * A base class that all control `FormControl`-based directives extend. It binds a `FormControl`
 * object to a DOM element.
 */
var NgControl = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgControl, _super);
    function NgControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * @description
         * The parent form for the control.
         *
         * @internal
         */
        _this._parent = null;
        /**
         * @description
         * The name for the control
         */
        _this.name = null;
        /**
         * @description
         * The value accessor for the control
         */
        _this.valueAccessor = null;
        /**
         * @description
         * The uncomposed array of synchronous validators for the control
         *
         * @internal
         */
        _this._rawValidators = [];
        /**
         * @description
         * The uncomposed array of async validators for the control
         *
         * @internal
         */
        _this._rawAsyncValidators = [];
        return _this;
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        /**
         * @description
         * The registered synchronous validator function for the control
         *
         * @throws An exception that this method is not implemented
         */
        get: function () { return unimplemented(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        /**
         * @description
         * The registered async validator function for the control
         *
         * @throws An exception that this method is not implemented
         */
        get: function () { return unimplemented(); },
        enumerable: true,
        configurable: true
    });
    return NgControl;
}(AbstractControlDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = /*@__PURE__*/ (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    RadioControlRegistry.prototype.add = function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    RadioControlRegistry.prototype.remove = function (accessor) {
        for (var i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    RadioControlRegistry.prototype.select = function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    return RadioControlRegistry;
}());
/**
 * @description
 *
 * Writes radio control values and listens to radio control changes.
 *
 * Used by `NgModel`, `FormControlDirective`, and `FormControlName`
 * to keep the view synced with the `FormControl` model.
 *
 * If you have imported the `FormsModule` or the `ReactiveFormsModule`, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * @usageNotes
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var RadioControlValueAccessor = /*@__PURE__*/ (function () {
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    RadioControlValueAccessor.prototype.ngOnInit = function () {
        this._control = this._injector.get(NgControl);
        this._checkName();
        this._registry.add(this._control, this);
    };
    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
    RadioControlValueAccessor.prototype.writeValue = function (value) {
        this._state = value === this.value;
        this._renderer.setProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    RadioControlValueAccessor.prototype._checkName = function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    RadioControlValueAccessor.prototype._throwNameError = function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    return RadioControlValueAccessor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RANGE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * `NgModel`, `FormControlDirective`, and `FormControlName` directives.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <input type="range" [(ngModel)]="age" >
 * ```
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var RangeValueAccessor = /*@__PURE__*/ (function () {
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    RangeValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    RangeValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return RangeValueAccessor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ReactiveErrors = /*@__PURE__*/ (function () {
    function ReactiveErrors() {
    }
    ReactiveErrors.controlParentException = function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
    };
    ReactiveErrors.ngModelGroupException = function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
    };
    ReactiveErrors.missingFormException = function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
    };
    ReactiveErrors.groupParentException = function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
    };
    ReactiveErrors.arrayParentException = function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
    };
    ReactiveErrors.disabledAttrWarning = function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    ReactiveErrors.ngModelWarning = function (directiveName) {
        console.warn("\n    It looks like you're using ngModel on the same form field as " + directiveName + ". \n    Support for using the ngModel input property and ngModelChange event with \n    reactive form directives has been deprecated in Angular v6 and will be removed \n    in Angular v7.\n    \n    For more information on this, see our API docs here:\n    https://angular.io/api/forms/" + (directiveName === 'formControl' ? 'FormControlDirective'
            : 'FormControlName') + "#use-with-ngmodel\n    ");
    };
    return ReactiveErrors;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * @description
 *
 * Writes values and listens to changes on a select element.
 *
 * Used by `NgModel`, `FormControlDirective`, and `FormControlName`
 * to keep the view synced with the `FormControl` model.
 *
 * If you have imported the `FormsModule` or the `ReactiveFormsModule`, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * @usageNotes
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * ### Caveat: Option selection
 *
 * Angular uses object identity to select option. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
 * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects option by the return value of the function.
 *
 * ### Syntax
 *
 * ```
 * <select [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var SelectControlValueAccessor = /*@__PURE__*/ (function () {
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    SelectControlValueAccessor.prototype.writeValue = function (value) {
        this.value = value;
        var id = this._getOptionId(value);
        if (id == null) {
            this._renderer.setProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
        }
        var valueString = _buildValueString(id, value);
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = _this._getOptionValue(valueString);
            fn(_this.value);
        };
    };
    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
    /** @internal */
    SelectControlValueAccessor.prototype._getOptionId = function (value) {
        var e_1, _a;
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Array.from(this._optionMap.keys())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var id = _c.value;
                if (this._compareWith(this._optionMap.get(id), value))
                    return id;
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return null;
    };
    /** @internal */
    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    return SelectControlValueAccessor;
}());
/**
 * @description
 *
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * See docs for `SelectControlValueAccessor` for usage examples.
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var NgSelectOption = /*@__PURE__*/ (function () {
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        set: function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        set: function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    NgSelectOption.prototype._setElementValue = function (value) {
        this._renderer.setProperty(this._element.nativeElement, 'value', value);
    };
    NgSelectOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectOption = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"])())
    ], NgSelectOption);
    return NgSelectOption;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
function _buildValueString$1(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
function _extractId$1(valueString) {
    return valueString.split(':')[0];
}
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 * @usageNotes
 * ### Caveat: Options selection
 *
 * Angular uses object identity to select options. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select multiple>` supports `compareWith`
 * input. `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects options by the return value of the function.
 *
 * ### Syntax
 *
 * ```
 * <select multiple [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * @ngModule ReactiveFormsModule
 * @ngModule FormsModule
 */
var SelectMultipleControlValueAccessor = /*@__PURE__*/ (function () {
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        var optionSelectedStateSetter;
        if (Array.isArray(value)) {
            // convert values to ids
            var ids_1 = value.map(function (v) { return _this._getOptionId(v); });
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
        }
        else {
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
        }
        this._optionMap.forEach(optionSelectedStateSetter);
    };
    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var options = _.selectedOptions;
                for (var i = 0; i < options.length; i++) {
                    var opt = options.item(i);
                    var val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var options = _.options;
                for (var i = 0; i < options.length; i++) {
                    var opt = options.item(i);
                    if (opt.selected) {
                        var val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            _this.value = selected;
            fn(selected);
        };
    };
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
        var id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
        var e_1, _a;
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Array.from(this._optionMap.keys())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var id = _c.value;
                if (this._compareWith(this._optionMap.get(id)._value, value))
                    return id;
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return null;
    };
    /** @internal */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var id = _extractId$1(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id)._value : valueString;
    };
    return SelectMultipleControlValueAccessor;
}());
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var NgSelectMultipleOption = /*@__PURE__*/ (function () {
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        set: function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString$1(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        set: function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString$1(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    NgSelectMultipleOption.prototype._setElementValue = function (value) {
        this._renderer.setProperty(this._element.nativeElement, 'value', value);
    };
    /** @internal */
    NgSelectMultipleOption.prototype._setSelected = function (selected) {
        this._renderer.setProperty(this._element.nativeElement, 'selected', selected);
    };
    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectMultipleOption = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"])())
    ], NgSelectMultipleOption);
    return NgSelectMultipleOption;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function controlPath(name, parent) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(parent.path, [name]);
}
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = Validators.compose([control.validator, dir.validator]);
    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
    dir.valueAccessor.writeValue(control.value);
    setUpViewChangePipeline(control, dir);
    setUpModelChangePipeline(control, dir);
    setUpBlurPipeline(control, dir);
    if (dir.valueAccessor.setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange)
            validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange)
            validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
}
function cleanUpControl(control, dir) {
    dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
    dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
function setUpViewChangePipeline(control, dir) {
    dir.valueAccessor.registerOnChange(function (newValue) {
        control._pendingValue = newValue;
        control._pendingChange = true;
        control._pendingDirty = true;
        if (control.updateOn === 'change')
            updateControl(control, dir);
    });
}
function setUpBlurPipeline(control, dir) {
    dir.valueAccessor.registerOnTouched(function () {
        control._pendingTouched = true;
        if (control.updateOn === 'blur' && control._pendingChange)
            updateControl(control, dir);
        if (control.updateOn !== 'submit')
            control.markAsTouched();
    });
}
function updateControl(control, dir) {
    if (control._pendingDirty)
        control.markAsDirty();
    control.setValue(control._pendingValue, { emitModelToViewChange: false });
    dir.viewToModelUpdate(control._pendingValue);
    control._pendingChange = false;
}
function setUpModelChangePipeline(control, dir) {
    control.registerOnChange(function (newValue, emitModelEvent) {
        // control -> view
        dir.valueAccessor.writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
}
function setUpFormContainer(control, dir) {
    if (control == null)
        _throwError(dir, 'Cannot find control with');
    control.validator = Validators.compose([control.validator, dir.validator]);
    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
}
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
function _throwError(dir, message) {
    var messageEnd;
    if (dir.path.length > 1) {
        messageEnd = "path: '" + dir.path.join(' -> ') + "'";
    }
    else if (dir.path[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
function composeValidators(validators) {
    return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
}
function composeAsyncValidators(validators) {
    return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
        null;
}
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵlooseIdentical"])(viewModel, change.currentValue);
}
var BUILTIN_ACCESSORS = [
    CheckboxControlValueAccessor,
    RangeValueAccessor,
    NumberValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
];
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
function syncPendingControls(form, directives) {
    form._syncPendingControls();
    directives.forEach(function (dir) {
        var control = dir.control;
        if (control.updateOn === 'submit' && control._pendingChange) {
            dir.viewToModelUpdate(control._pendingValue);
            control._pendingChange = false;
        }
    });
}
// TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    if (!Array.isArray(valueAccessors))
        _throwError(dir, 'Value accessor was not provided as an array for form control with');
    var defaultAccessor = undefined;
    var builtinAccessor = undefined;
    var customAccessor = undefined;
    valueAccessors.forEach(function (v) {
        if (v.constructor === DefaultValueAccessor) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
function removeDir(list, el) {
    var index = list.indexOf(el);
    if (index > -1)
        list.splice(index, 1);
}
// TODO(kara): remove after deprecation period
function _ngModelWarning(name, type, instance, warningConfig) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() || warningConfig === 'never')
        return;
    if (((warningConfig === null || warningConfig === 'once') && !type._ngModelWarningSentOnce) ||
        (warningConfig === 'always' && !instance._ngModelWarningSent)) {
        ReactiveErrors.ngModelWarning(name);
        type._ngModelWarningSentOnce = true;
        instance._ngModelWarningSent = true;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 * A base class for code shared between the `NgModelGroup` and `FormGroupName` directives.
 *
 */
var AbstractFormGroupDirective = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @description
     * An internal callback method triggered on the instance after the inputs are set.
     * Registers the group with its parent group.
     */
    AbstractFormGroupDirective.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormGroup(this);
    };
    /**
     * @description
     * An internal callback method triggered before the instance is destroyed.
     * Removes the group from its parent group.
     */
    AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * @description
         * The `FormGroup` bound to this directive.
         */
        get: function () { return this.formDirective.getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * @description
         * The path to this group from the top-level directive.
         */
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * @description
         * The top-level directive for this group if present, otherwise null.
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        /**
         * @description
         * The synchronous validators registered with this group.
         */
        get: function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        /**
         * @description
         * The async validators registered with this group.
         */
        get: function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    AbstractFormGroupDirective.prototype._checkParentType = function () { };
    return AbstractFormGroupDirective;
}(ControlContainer));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AbstractControlStatus = /*@__PURE__*/ (function () {
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        get: function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        get: function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        get: function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        get: function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        get: function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        get: function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        get: function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
var ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status. The following classes are applied as the properties
 * become true:
 *
 * * ng-valid
 * * ng-invalid
 * * ng-pending
 * * ng-pristine
 * * ng-dirty
 * * ng-untouched
 * * ng-touched
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var NgControlStatus = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgControlStatus, _super);
    function NgControlStatus(cd) {
        return _super.call(this, cd) || this;
    }
    NgControlStatus = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])())
    ], NgControlStatus);
    return NgControlStatus;
}(AbstractControlStatus));
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var NgControlStatusGroup = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgControlStatusGroup, _super);
    function NgControlStatusGroup(cd) {
        return _super.call(this, cd) || this;
    }
    NgControlStatusGroup = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])())
    ], NgControlStatusGroup);
    return NgControlStatusGroup;
}(AbstractControlStatus));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Reports that a FormControl is valid, meaning that no errors exist in the input value.
 *
 * @see `status`
 */
var VALID = 'VALID';
/**
 * Reports that a FormControl is invalid, meaning that an error exists in the input value.
 *
 * @see `status`
 */
var INVALID = 'INVALID';
/**
 * Reports that a FormControl is pending, meaning that that async validation is occurring and
 * errors are not yet available for the input value.
 *
 * @see `markAsPending`
 * @see `status`
 */
var PENDING = 'PENDING';
/**
 * Reports that a FormControl is disabled, meaning that the control is exempt from ancestor
 * calculations of validity or value.
 *
 * @see `markAsDisabled`
 * @see `status`
 */
var DISABLED = 'DISABLED';
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = path.split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return path.reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls.hasOwnProperty(name) ? v.controls[name] : null;
        }
        if (v instanceof FormArray) {
            return v.at(name) || null;
        }
        return null;
    }, control);
}
function coerceToValidator(validatorOrOpts) {
    var validator = (isOptionsObj(validatorOrOpts) ? validatorOrOpts.validators :
        validatorOrOpts);
    return Array.isArray(validator) ? composeValidators(validator) : validator || null;
}
function coerceToAsyncValidator(asyncValidator, validatorOrOpts) {
    var origAsyncValidator = (isOptionsObj(validatorOrOpts) ? validatorOrOpts.asyncValidators :
        asyncValidator);
    return Array.isArray(origAsyncValidator) ? composeAsyncValidators(origAsyncValidator) :
        origAsyncValidator || null;
}
function isOptionsObj(validatorOrOpts) {
    return validatorOrOpts != null && !Array.isArray(validatorOrOpts) &&
        typeof validatorOrOpts === 'object';
}
/**
 * This is the base class for `FormControl`, `FormGroup`, and `FormArray`.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * @see [Forms Guide](/guide/forms)
 * @see [Reactive Forms Guide](/guide/reactive-forms)
 * @see [Dynamic Forms Guide](/guide/dynamic-form)
 *
 */
var AbstractControl = /*@__PURE__*/ (function () {
    /**
     * Initialize the AbstractControl instance.
     *
     * @param validator The function that determines the synchronous validity of this control.
     * @param asyncValidator The function that determines the asynchronous validity of this
     * control.
     */
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /** @internal */
        this._onCollectionChange = function () { };
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * @returns True if the user has not yet changed the value in the UI; compare `dirty`.
         * Programmatic changes to a control's value do not mark it dirty.
         */
        this.pristine = true;
        /**
         * True if the control is marked as `touched`.
         *
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         */
        this.touched = false;
        /** @internal */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         * The parent control.
         */
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status` is `VALID`.
         *
         * @see `status`
         *
         * @returns True if the control has passed all of its validation tests,
         * false otherwise.
         */
        get: function () { return this.status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status` is `INVALID`.
         *
         * @see `status`
         *
         * @returns True if this control has failed one or more of its validation checks,
         * false otherwise.
         */
        get: function () { return this.status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status` is `PENDING`.
         *
         * @see `status`
         *
         * @returns True if this control is in the process of conducting a validation check,
         * false otherwise.
         */
        get: function () { return this.status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status` is `DISABLED`.
         *
         * @see `status`
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         *
         * @returns True if the control is disabled, false otherwise.
         */
        get: function () { return this.status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status` is not `DISABLED`.
         *
         * @see `status`
         *
         * @returns True if the control has any status other than 'DISABLED',
         * false if the status is 'DISABLED'.
         *
         */
        get: function () { return this.status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * @returns True if the user has changed the value of this control in the UI; compare `pristine`.
         * Programmatic changes to a control's value do not mark it dirty.
         */
        get: function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * True if the control has not been marked as touched
         *
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         */
        get: function () { return !this.touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "updateOn", {
        /**
         * Reports the update strategy of the `AbstractControl` (meaning
         * the event on which the control updates itself).
         * Possible values: `'change'` | `'blur'` | `'submit'`
         * Default value: `'change'`
         */
        get: function () {
            return this._updateOn ? this._updateOn : (this.parent ? this.parent.updateOn : 'change');
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this overwrites any existing sync validators.
     */
    AbstractControl.prototype.setValidators = function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * overwrites any existing async validators.
     */
    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     */
    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     */
    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`. A control is touched by focus and
     * blur events that do not change the value; compare `markAsDirty`;
     *
     *  @param opts Configuration options that determine how the control propagates changes
     * and emits events events after marking is applied.
     * * `onlySelf`: When true, mark only this control. When false or not supplied,
     * marks all direct ancestors. Default is false.
     */
    AbstractControl.prototype.markAsTouched = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.touched = true;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsTouched(opts);
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, also marks all children as `untouched`
     * and recalculates the `touched` status of all parent controls.
     *
     *  @param opts Configuration options that determine how the control propagates changes
     * and emits events after the marking is applied.
     * * `onlySelf`: When true, mark only this control. When false or not supplied,
     * marks all direct ancestors. Default is false.
     */
    AbstractControl.prototype.markAsUntouched = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.touched = false;
        this._pendingTouched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !opts.onlySelf) {
            this._parent._updateTouched(opts);
        }
    };
    /**
     * Marks the control as `dirty`. A control becomes dirty when
     * the control's is changed through the UI; compare `markAsTouched`.
     *
     *  @param opts Configuration options that determine how the control propagates changes
     * and emits events after marking is applied.
     * * `onlySelf`: When true, mark only this control. When false or not supplied,
     * marks all direct ancestors. Default is false.
     */
    AbstractControl.prototype.markAsDirty = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.pristine = false;
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsDirty(opts);
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, marks all children as `pristine`,
     * and recalculates the `pristine` status of all parent
     * controls.
     *
     *  @param opts Configuration options that determine how the control emits events after
     * marking is applied.
     * * `onlySelf`: When true, mark only this control. When false or not supplied,
     * marks all direct ancestors. Default is false..
     */
    AbstractControl.prototype.markAsPristine = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.pristine = true;
        this._pendingDirty = false;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !opts.onlySelf) {
            this._parent._updatePristine(opts);
        }
    };
    /**
     * Marks the control as `pending`.
     *
     * A control is pending while the control performs async validation.
     *
     *  @param opts Configuration options that determine how the control propagates changes and
     * emits events after marking is applied.
     * * `onlySelf`: When true, mark only this control. When false or not supplied,
     * marks all direct ancestors. Default is false..
     * * `emitEvent`: When true or not supplied (the default), the `statusChanges`
     * observable emits an event with the latest status the control is marked pending.
     * When false, no events are emitted.
     *
     */
    AbstractControl.prototype.markAsPending = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.status = PENDING;
        if (opts.emitEvent !== false) {
            this.statusChanges.emit(this.status);
        }
        if (this._parent && !opts.onlySelf) {
            this._parent.markAsPending(opts);
        }
    };
    /**
     * Disables the control. This means the control is exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children are also disabled.
     *
     *  @param opts Configuration options that determine how the control propagates
     * changes and emits events after the control is disabled.
     * * `onlySelf`: When true, mark only this control. When false or not supplied,
     * marks all direct ancestors. Default is false..
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control is disabled.
     * When false, no events are emitted.
     */
    AbstractControl.prototype.disable = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.status = DISABLED;
        this.errors = null;
        this._forEachChild(function (control) { control.disable(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, opts, { onlySelf: true })); });
        this._updateValue();
        if (opts.emitEvent !== false) {
            this.valueChanges.emit(this.value);
            this.statusChanges.emit(this.status);
        }
        this._updateAncestors(opts);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control is included in validation checks and
     * the aggregate value of its parent. Its status recalculates based on its value and
     * its validators.
     *
     * By default, if the control has children, all children are enabled.
     *
     *  @param opts Configure options that control how the control propagates changes and
     * emits events when marked as untouched
     * * `onlySelf`: When true, mark only this control. When false or not supplied,
     * marks all direct ancestors. Default is false..
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control is enabled.
     * When false, no events are emitted.
     */
    AbstractControl.prototype.enable = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.status = VALID;
        this._forEachChild(function (control) { control.enable(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, opts, { onlySelf: true })); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
        this._updateAncestors(opts);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    AbstractControl.prototype._updateAncestors = function (opts) {
        if (this._parent && !opts.onlySelf) {
            this._parent.updateValueAndValidity(opts);
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    /**
     * @param parent Sets the parent of the control
     */
    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
    /**
     * Recalculates the value and validation status of the control.
     *
     * By default, it also updates the value and validity of its ancestors.
     *
     * @param opts Configuration options determine how the control propagates changes and emits events
     * after updates and validity checks are applied.
     * * `onlySelf`: When true, only update this control. When false or not supplied,
     * update all direct ancestors. Default is false..
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control is updated.
     * When false, no events are emitted.
     */
    AbstractControl.prototype.updateValueAndValidity = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._cancelExistingSubscription();
            this.errors = this._runValidator();
            this.status = this._calculateStatus();
            if (this.status === VALID || this.status === PENDING) {
                this._runAsyncValidator(opts.emitEvent);
            }
        }
        if (opts.emitEvent !== false) {
            this.valueChanges.emit(this.value);
            this.statusChanges.emit(this.status);
        }
        if (this._parent && !opts.onlySelf) {
            this._parent.updateValueAndValidity(opts);
        }
    };
    /** @internal */
    AbstractControl.prototype._updateTreeValidity = function (opts) {
        if (opts === void 0) {
            opts = { emitEvent: true };
        }
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity(opts); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: opts.emitEvent });
    };
    AbstractControl.prototype._setInitialStatus = function () {
        this.status = this._allControlsDisabled() ? DISABLED : VALID;
    };
    AbstractControl.prototype._runValidator = function () {
        return this.validator ? this.validator(this) : null;
    };
    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            this.status = PENDING;
            var obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe(function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); });
        }
    };
    AbstractControl.prototype._cancelExistingSubscription = function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control when running validations manually, rather than automatically.
     *
     * Calling `setErrors` also updates the validity of the parent control.
     *
     * @usageNotes
     * ### Manually set the errors for a control
     *
     * ```
     * const login = new FormControl('someLogin');
     * login.setErrors({
     *   notUnique: true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({ notUnique: true });
     *
     * login.setValue('someOtherLogin');
     *
     * expect(login.valid).toEqual(true);
     * ```
     */
    AbstractControl.prototype.setErrors = function (errors, opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.errors = errors;
        this._updateControlsErrors(opts.emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * @param path A dot-delimited string or array of string/number values that define the path to the
     * control.
     *
     * @usageNotes
     * ### Retrieve a nested control
     *
     * For example, to get a `name` control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     */
    AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
    /**
     * Reports error data for a specific error occurring in this control or in another control.
     *
     * @param errorCode The error code for which to retrieve data
     * @param path The path to a control to check. If not supplied, checks for the error in this
     * control.
     *
     * @returns The error data if the control with the given path has the given error, otherwise null
     * or undefined.
     */
    AbstractControl.prototype.getError = function (errorCode, path) {
        var control = path ? this.get(path) : this;
        return control && control.errors ? control.errors[errorCode] : null;
    };
    /**
     * Reports whether the control with the given path has the error specified.
     *
     * @param errorCode The error code for which to retrieve data
     * @param path The path to a control to check. If not supplied, checks for the error in this
     * control.
     * @returns True when the control with the given path has the error, otherwise false.
     */
    AbstractControl.prototype.hasError = function (errorCode, path) { return !!this.getError(errorCode, path); };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         */
        get: function () {
            var x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
        this.status = this._calculateStatus();
        if (emitEvent) {
            this.statusChanges.emit(this.status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /** @internal */
    AbstractControl.prototype._initObservables = function () {
        this.valueChanges = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.statusChanges = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
    };
    AbstractControl.prototype._calculateStatus = function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this.errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /** @internal */
    AbstractControl.prototype._anyControlsHaveStatus = function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /** @internal */
    AbstractControl.prototype._anyControlsDirty = function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /** @internal */
    AbstractControl.prototype._anyControlsTouched = function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /** @internal */
    AbstractControl.prototype._updatePristine = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.pristine = !this._anyControlsDirty();
        if (this._parent && !opts.onlySelf) {
            this._parent._updatePristine(opts);
        }
    };
    /** @internal */
    AbstractControl.prototype._updateTouched = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        this.touched = this._anyControlsTouched();
        if (this._parent && !opts.onlySelf) {
            this._parent._updateTouched(opts);
        }
    };
    /** @internal */
    AbstractControl.prototype._isBoxedValue = function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /** @internal */
    AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
    /** @internal */
    AbstractControl.prototype._setUpdateStrategy = function (opts) {
        if (isOptionsObj(opts) && opts.updateOn != null) {
            this._updateOn = opts.updateOn;
        }
    };
    return AbstractControl;
}());
/**
 * Tracks the value and validation status of an individual form control.
 *
 * This is one of the three fundamental building blocks of Angular forms, along with
 * `FormGroup` and `FormArray`. It extends the `AbstractControl` class that
 * implements most of the base functionality for accessing the value, validation status,
 * user interactions and events.
 *
 * @see `AbstractControl`
 * @see [Reactive Forms Guide](guide/reactive-forms)
 * @see [Usage Notes](#usage-notes)
 *
 * @usageNotes
 *
 * ### Initializing Form Controls
 *
 * Instantiate a `FormControl`, with an initial value.
 *
 * ```ts
 * const control = new FormControl('some value');
 * console.log(control.value);     // 'some value'
 *```
 *
 * The following example initializes the control with a form state object. The `value`
 * and `disabled` keys are required in this case.
 *
 * ```ts
 * const control = new FormControl({ value: 'n/a', disabled: true });
 * console.log(control.value);     // 'n/a'
 * console.log(control.status);    // 'DISABLED'
 * ```
 *
 * The following example initializes the control with a sync validator.
 *
 * ```ts
 * const control = new FormControl('', Validators.required);
 * console.log(control.value);      // ''
 * console.log(control.status);     // 'INVALID'
 * ```
 *
 * The following example initializes the control using an options object.
 *
 * ```ts
 * const control = new FormControl('', {
 *    validators: Validators.required,
 *    asyncValidators: myAsyncValidator
 * });
 * ```
 *
 * ### Configure the control to update on a blur event
 *
 * Set the `updateOn` option to `'blur'` to update on the blur `event`.
 *
 * ```ts
 * const control = new FormControl('', { updateOn: 'blur' });
 * ```
 *
 * ### Configure the control to update on a submit event
 *
 * Set the `updateOn` option to `'submit'` to update on a submit `event`.
 *
 * ```ts
 * const control = new FormControl('', { updateOn: 'submit' });
 * ```
 *
 * ### Reset the control back to an initial value
 *
 * You reset to a specific form state by passing through a standalone
 * value or a form state object that contains both a value and a disabled state
 * (these are the only two properties that cannot be calculated).
 *
 * ```ts
 * const control = new FormControl('Nancy');
 *
 * console.log(control.value); // 'Nancy'
 *
 * control.reset('Drew');
 *
 * console.log(control.value); // 'Drew'
 * ```
 *
 * ### Reset the control back to an initial value and disabled
 *
 * ```
 * const control = new FormControl('Nancy');
 *
 * console.log(control.value); // 'Nancy'
 * console.log(control.status); // 'VALID'
 *
 * control.reset({ value: 'Drew', disabled: true });
 *
 * console.log(control.value); // 'Drew'
 * console.log(control.status); // 'DISABLED'
 *
*/
var FormControl = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FormControl, _super);
    /**
    * Creates a new `FormControl` instance.
    *
    * @param formState Initializes the control with an initial value,
    * or an object that defines the initial value and disabled state.
    *
    * @param validatorOrOpts A synchronous validator function, or an array of
    * such functions, or an `AbstractControlOptions` object that contains validation functions
    * and a validation trigger.
    *
    * @param asyncValidator A single async validator or array of async validator functions
    *
    */
    function FormControl(formState, validatorOrOpts, asyncValidator) {
        if (formState === void 0) {
            formState = null;
        }
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        /** @internal */
        _this._onChange = [];
        _this._applyFormState(formState);
        _this._setUpdateStrategy(validatorOrOpts);
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        _this._initObservables();
        return _this;
    }
    /**
     * Sets a new value for the form control.
     *
     * @param value The new value for the control.
     * @param options Configuration options that determine how the control proopagates changes
     * and emits events when the value changes.
     * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
     * updateValueAndValidity} method.
     *
     * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
     * false.
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control value is updated.
     * When false, no events are emitted.
     * * `emitModelToViewChange`: When true or not supplied  (the default), each change triggers an
     * `onChange` event to
     * update the view.
     * * `emitViewToModelChange`: When true or not supplied (the default), each change triggers an
     * `ngModelChange`
     * event to update the model.
     *
     */
    FormControl.prototype.setValue = function (value, options) {
        var _this = this;
        if (options === void 0) {
            options = {};
        }
        this.value = this._pendingValue = value;
        if (this._onChange.length && options.emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this.value, options.emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity(options);
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {@link FormControl#setValue setValue} at this level.
     * It exists for symmetry with {@link FormGroup#patchValue patchValue} on `FormGroups` and
     * `FormArrays`, where it does behave differently.
     *
     * @see `setValue` for options
     */
    FormControl.prototype.patchValue = function (value, options) {
        if (options === void 0) {
            options = {};
        }
        this.setValue(value, options);
    };
    /**
     * Resets the form control, marking it `pristine` and `untouched`, and setting
     * the value to null.
     *
     * @param formState Resets the control with an initial value,
     * or an object that defines the initial value and disabled state.
     *
     * @param options Configuration options that determine how the control propagates changes
     * and emits events after the value changes.
     *
     * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
     * false.
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control is reset.
     * When false, no events are emitted.
     *
     */
    FormControl.prototype.reset = function (formState, options) {
        if (formState === void 0) {
            formState = null;
        }
        if (options === void 0) {
            options = {};
        }
        this._applyFormState(formState);
        this.markAsPristine(options);
        this.markAsUntouched(options);
        this.setValue(this.value, options);
        this._pendingChange = false;
    };
    /**
     * @internal
     */
    FormControl.prototype._updateValue = function () { };
    /**
     * @internal
     */
    FormControl.prototype._anyControls = function (condition) { return false; };
    /**
     * @internal
     */
    FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
    /**
     * Register a listener for change events.
     *
     * @param fn The method that is called when the value changes
     */
    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
    /**
     * @internal
     */
    FormControl.prototype._clearChangeFns = function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     *
     * @param fn The method that is called when the disabled status changes.
     */
    FormControl.prototype.registerOnDisabledChange = function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * @internal
     */
    FormControl.prototype._forEachChild = function (cb) { };
    /** @internal */
    FormControl.prototype._syncPendingControls = function () {
        if (this.updateOn === 'submit') {
            if (this._pendingDirty)
                this.markAsDirty();
            if (this._pendingTouched)
                this.markAsTouched();
            if (this._pendingChange) {
                this.setValue(this._pendingValue, { onlySelf: true, emitModelToViewChange: false });
                return true;
            }
        }
        return false;
    };
    FormControl.prototype._applyFormState = function (formState) {
        if (this._isBoxedValue(formState)) {
            this.value = this._pendingValue = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            this.value = this._pendingValue = formState;
        }
    };
    return FormControl;
}(AbstractControl));
/**
 * Tracks the value and validity state of a group of `FormControl` instances.
 *
 * A `FormGroup` aggregates the values of each child `FormControl` into one object,
 * with each control name as the key.  It calculates its status by reducing the status values
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with `FormControl` and `FormArray`.
 *
 * When instantiating a `FormGroup`, pass in a collection of child controls as the first
 * argument. The key for each child registers the name for the control.
 *
 * @usageNotes
 *
 * ### Create a form group with 2 controls
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * ### Create a form group with a group-level validator
 *
 * You include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * Like `FormControl` instances, you choose to pass in
 * validators and async validators as part of an options object.
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('')
 *   passwordConfirm: new FormControl('')
 * }, { validators: passwordMatchValidator, asyncValidators: otherValidator });
 * ```
 *
 * ### Set the updateOn property for all controls in a form group
 *
 * The options object is used to set a default value for each child
 * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
 * group level, all child controls default to 'blur', unless the child
 * has explicitly specified a different `updateOn` value.
 *
 * ```ts
 * const c = new FormGroup({
 *   one: new FormControl()
 * }, { updateOn: 'blur' });
 * ```
 */
var FormGroup = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FormGroup, _super);
    /**
    * Creates a new `FormGroup` instance.
    *
    * @param controls A collection of child controls. The key for each child is the name
    * under which it is registered.
    *
    * @param validatorOrOpts A synchronous validator function, or an array of
    * such functions, or an `AbstractControlOptions` object that contains validation functions
    * and a validation trigger.
    *
    * @param asyncValidator A single async validator or array of async validator functions
    *
    */
    function FormGroup(controls, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpdateStrategy(validatorOrOpts);
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update the value or validity of the control.
     * Use {@link FormGroup#addControl addControl} instead.
     *
     * @param name The control name to register in the collection
     * @param control Provides the control for the given name
     */
    FormGroup.prototype.registerControl = function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     *
     * This method also updates the value and validity of the control.
     *
     * @param name The control name to add to the collection
     * @param control Provides the control for the given name
     */
    FormGroup.prototype.addControl = function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     *
     * @param name The control name to remove from the collection
     */
    FormGroup.prototype.removeControl = function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     *
     * @param name The control name to replace in the collection
     * @param control Provides the control for the given name
     */
    FormGroup.prototype.setControl = function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * Reports false for disabled controls. If you'd like to check for existence in the group
     * only, use {@link AbstractControl#get get} instead.
     *
     * @param name The control name to check for existence in the collection
     *
     * @returns false for disabled controls, true otherwise.
     */
    FormGroup.prototype.contains = function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     * Sets the value of the `FormGroup`. It accepts an object that matches
     * the structure of the group, with control names as keys.
     *
     * @usageNotes
     * ### Set the complete value for the form group
     *
     * ```
     * const form = new FormGroup({
     *   first: new FormControl(),
     *   last: new FormControl()
     * });
     *
     * console.log(form.value);   // {first: null, last: null}
     *
     * form.setValue({first: 'Nancy', last: 'Drew'});
     * console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     * ```
     *
     * @throws When strict checks fail, such as setting the value of a control
     * that doesn't exist or if you excluding the value of a control.
     *
     * @param value The new value for the control that matches the structure of the group.
     * @param options Configuration options that determine how the control propagates changes
     * and emits events after the value changes.
     * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
     * updateValueAndValidity} method.
     *
     * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
     * false.
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control value is updated.
     * When false, no events are emitted.
     */
    FormGroup.prototype.setValue = function (value, options) {
        var _this = this;
        if (options === void 0) {
            options = {};
        }
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Patches the value of the `FormGroup`. It accepts an object with control
     * names as keys, and does its best to match the values to the correct controls
     * in the group.
     *
     * It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     * @usageNotes
     * ### Patch the value for a form group
     *
     * ```
     * const form = new FormGroup({
     *    first: new FormControl(),
     *    last: new FormControl()
     * });
     * console.log(form.value);   // {first: null, last: null}
     *
     * form.patchValue({first: 'Nancy'});
     * console.log(form.value);   // {first: 'Nancy', last: null}
     * ```
     *
     * @param value The object that matches the structure of the group.
     * @param options Configuration options that determine how the control propagates changes and
     * emits events after the value is patched.
     * * `onlySelf`: When true, each change only affects this control and not its parent. Default is
     * true.
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control value is updated.
     * When false, no events are emitted.
     * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
     * updateValueAndValidity} method.
     */
    FormGroup.prototype.patchValue = function (value, options) {
        var _this = this;
        if (options === void 0) {
            options = {};
        }
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: options.emitEvent });
            }
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Resets the `FormGroup`, marks all descendants are marked `pristine` and `untouched`, and
     * the value of all descendants to null.
     *
     * You reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * is a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * @param formState Resets the control with an initial value,
     * or an object that defines the initial value and disabled state.
     *
     * @param options Configuration options that determine how the control propagates changes
     * and emits events when the group is reset.
     * * `onlySelf`: When true, each change only affects this control, and not its parent. Default is
     * false.
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control is reset.
     * When false, no events are emitted.
     * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
     * updateValueAndValidity} method.
     *
     * @usageNotes
     *
     * ### Reset the form group values
     *
     * ```ts
     * const form = new FormGroup({
     *   first: new FormControl('first name'),
     *   last: new FormControl('last name')
     * });
     *
     * console.log(form.value);  // {first: 'first name', last: 'last name'}
     *
     * form.reset({ first: 'name', last: 'last name' });
     *
     * console.log(form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * ### Reset the form group values and disabled status
     *
     * ```
     * const form = new FormGroup({
     *   first: new FormControl('first name'),
     *   last: new FormControl('last name')
     * });
     *
     * form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     */
    FormGroup.prototype.reset = function (value, options) {
        if (value === void 0) {
            value = {};
        }
        if (options === void 0) {
            options = {};
        }
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
        this._updatePristine(options);
        this._updateTouched(options);
    };
    /**
     * The aggregate value of the `FormGroup`, including any disabled controls.
     *
     * Retrieves all values regardless of disabled status.
     * The `value` property is the best way to get the value of the group, because
     * it excludes disabled controls in the `FormGroup`.
     */
    FormGroup.prototype.getRawValue = function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control instanceof FormControl ? control.value : control.getRawValue();
            return acc;
        });
    };
    /** @internal */
    FormGroup.prototype._syncPendingControls = function () {
        var subtreeUpdated = this._reduceChildren(false, function (updated, child) {
            return child._syncPendingControls() ? true : updated;
        });
        if (subtreeUpdated)
            this.updateValueAndValidity({ onlySelf: true });
        return subtreeUpdated;
    };
    /** @internal */
    FormGroup.prototype._throwIfControlMissing = function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /** @internal */
    FormGroup.prototype._forEachChild = function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /** @internal */
    FormGroup.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /** @internal */
    FormGroup.prototype._updateValue = function () { this.value = this._reduceValue(); };
    /** @internal */
    FormGroup.prototype._anyControls = function (condition) {
        var _this = this;
        var res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /** @internal */
    FormGroup.prototype._reduceValue = function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /** @internal */
    FormGroup.prototype._reduceChildren = function (initValue, fn) {
        var res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /** @internal */
    FormGroup.prototype._allControlsDisabled = function () {
        var e_1, _a;
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Object.keys(this.controls)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var controlName = _c.value;
                if (this.controls[controlName].enabled) {
                    return false;
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /** @internal */
    FormGroup.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
/**
 * Tracks the value and validity state of an array of `FormControl`,
 * `FormGroup` or `FormArray` instances.
 *
 * A `FormArray` aggregates the values of each child `FormControl` into an array.
 * It calculates its status by reducing the status values of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with `FormControl` and `FormGroup`.
 *
 * @usageNotes
 *
 * ### Create an array of form controls
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * ### Create a form array with array-level validators
 *
 * You include array-level validators and async validators. These come in handy
 * when you want to perform validation that considers the value of more than one child
 * control.
 *
 * The two types of validators are passed in separately as the second and third arg
 * respectively, or together as part of an options object.
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy'),
 *   new FormControl('Drew')
 * ], {validators: myValidator, asyncValidators: myAsyncValidator});
 * ```
 *
  * ### Set the updateOn property for all controls in a form array
 *
 * The options object is used to set a default value for each child
 * control's `updateOn` property. If you set `updateOn` to `'blur'` at the
 * array level, all child controls default to 'blur', unless the child
 * has explicitly specified a different `updateOn` value.
 *
 * ```ts
 * const arr = new FormArray([
 *    new FormControl()
 * ], {updateOn: 'blur'});
 * ```
 *
 * ### Adding or removing controls from a form array
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that result in strange and unexpected behavior such
 * as broken change detection.
 *
 *
 */
var FormArray = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FormArray, _super);
    /**
    * Creates a new `FormArray` instance.
    *
    * @param controls An array of child controls. Each child control is given an index
    * where it is registered.
    *
    * @param validatorOrOpts A synchronous validator function, or an array of
    * such functions, or an `AbstractControlOptions` object that contains validation functions
    * and a validation trigger.
    *
    * @param asyncValidator A single async validator or array of async validator functions
    *
    */
    function FormArray(controls, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, coerceToValidator(validatorOrOpts), coerceToAsyncValidator(asyncValidator, validatorOrOpts)) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpdateStrategy(validatorOrOpts);
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Get the `AbstractControl` at the given `index` in the array.
     *
     * @param index Index in the array to retrieve the control
     */
    FormArray.prototype.at = function (index) { return this.controls[index]; };
    /**
     * Insert a new `AbstractControl` at the end of the array.
     *
     * @param control Form control to be inserted
     */
    FormArray.prototype.push = function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Insert a new `AbstractControl` at the given `index` in the array.
     *
     * @param index Index in the array to insert the control
     * @param control Form control to be inserted
     */
    FormArray.prototype.insert = function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
    };
    /**
     * Remove the control at the given `index` in the array.
     *
     * @param index Index in the array to remove the control
     */
    FormArray.prototype.removeAt = function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
    };
    /**
     * Replace an existing control.
     *
     * @param index Index in the array to replace the control
     * @param control The `AbstractControl` control to replace the existing control
     */
    FormArray.prototype.setControl = function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         */
        get: function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the value of the `FormArray`. It accepts an array that matches
     * the structure of the control.
     *
     * This method performs strict checks, and throws an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     * @usageNotes
     * ### Set the values for the controls in the form array
     *
     * ```
     * const arr = new FormArray([
     *   new FormControl(),
     *   new FormControl()
     * ]);
     * console.log(arr.value);   // [null, null]
     *
     * arr.setValue(['Nancy', 'Drew']);
     * console.log(arr.value);   // ['Nancy', 'Drew']
     * ```
     *
     * @param value Array of values for the controls
     * @param options Configure options that determine how the control propagates changes and
     * emits events after the value changes
     *
     * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
     * is false.
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control value is updated.
     * When false, no events are emitted.
     * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
     * updateValueAndValidity} method.
     */
    FormArray.prototype.setValue = function (value, options) {
        var _this = this;
        if (options === void 0) {
            options = {};
        }
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Patches the value of the `FormArray`. It accepts an array that matches the
     * structure of the control, and does its best to match the values to the correct
     * controls in the group.
     *
     * It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     * @usageNotes
     * ### Patch the values for controls in a form array
     *
     * ```
     * const arr = new FormArray([
     *    new FormControl(),
     *    new FormControl()
     * ]);
     * console.log(arr.value);   // [null, null]
     *
     * arr.patchValue(['Nancy']);
     * console.log(arr.value);   // ['Nancy', null]
     * ```
     *
     * @param value Array of latest values for the controls
     * @param options Configure options that determine how the control propagates changes and
     * emits events after the value changes
     *
     * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
     * is false.
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control value is updated.
     * When false, no events are emitted.
     * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
     * updateValueAndValidity} method.
     */
    FormArray.prototype.patchValue = function (value, options) {
        var _this = this;
        if (options === void 0) {
            options = {};
        }
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: options.emitEvent });
            }
        });
        this.updateValueAndValidity(options);
    };
    /**
     * Resets the `FormArray` and all descendants are marked `pristine` and `untouched`, and the
     * value of all descendants to null or null maps.
     *
     * You reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state is a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * @usageNotes
     * ### Reset the values in a form array
     *
     * ```ts
     * const arr = new FormArray([
     *    new FormControl(),
     *    new FormControl()
     * ]);
     * arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * ### Reset the values in a form array and the disabled status for the first control
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     *
     * @param value Array of values for the controls
     * @param options Configure options that determine how the control propagates changes and
     * emits events after the value changes
     *
     * * `onlySelf`: When true, each change only affects this control, and not its parent. Default
     * is false.
     * * `emitEvent`: When true or not supplied (the default), both the `statusChanges` and
     * `valueChanges`
     * observables emit events with the latest status and value when the control is reset.
     * When false, no events are emitted.
     * The configuration options are passed to the {@link AbstractControl#updateValueAndValidity
     * updateValueAndValidity} method.
     */
    FormArray.prototype.reset = function (value, options) {
        if (value === void 0) {
            value = [];
        }
        if (options === void 0) {
            options = {};
        }
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: options.emitEvent });
        });
        this.updateValueAndValidity(options);
        this._updatePristine(options);
        this._updateTouched(options);
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * Reports all values regardless of disabled status.
     * For enabled controls only, the `value` property is the best way to get the value of the array.
     */
    FormArray.prototype.getRawValue = function () {
        return this.controls.map(function (control) {
            return control instanceof FormControl ? control.value : control.getRawValue();
        });
    };
    /** @internal */
    FormArray.prototype._syncPendingControls = function () {
        var subtreeUpdated = this.controls.reduce(function (updated, child) {
            return child._syncPendingControls() ? true : updated;
        }, false);
        if (subtreeUpdated)
            this.updateValueAndValidity({ onlySelf: true });
        return subtreeUpdated;
    };
    /** @internal */
    FormArray.prototype._throwIfControlMissing = function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /** @internal */
    FormArray.prototype._forEachChild = function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /** @internal */
    FormArray.prototype._updateValue = function () {
        var _this = this;
        this.value =
            this.controls.filter(function (control) { return control.enabled || _this.disabled; })
                .map(function (control) { return control.value; });
    };
    /** @internal */
    FormArray.prototype._anyControls = function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /** @internal */
    FormArray.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /** @internal */
    FormArray.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /** @internal */
    FormArray.prototype._allControlsDisabled = function () {
        var e_2, _a;
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(this.controls), _c = _b.next(); !_c.done; _c = _b.next()) {
                var control = _c.value;
                if (control.enabled)
                    return false;
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        return this.controls.length > 0 || this.disabled;
    };
    FormArray.prototype._registerControl = function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider = {
    provide: ControlContainer,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgForm; })
};
var resolvedPromise = /*@__PURE__*/ Promise.resolve(null);
/**
 * @description
 *
 * Creates a top-level `FormGroup` instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * `FormGroup` instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use `NgModel` with a
 * `name` attribute.  You can also use `NgModelGroup` if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * In template driven forms, all `<form>` tags are automatically tagged as `NgForm`.
 * If you want to import the `FormsModule` but skip its usage in some forms,
 * for example, to use native HTML5 validation, you can add `ngNoForm` and the `<form>`
 * tags won't create an `NgForm` directive. In reactive forms, using `ngNoForm` is
 * unnecessary because the `<form>` tags are inert. In that case, you would
 * refrain from using the `formGroup` directive.
 *
 * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * **npm package**: `@angular/forms`
 *
 * @ngModule FormsModule
 */
var NgForm = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgForm, _super);
    function NgForm(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this.submitted = false;
        _this._directives = [];
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this.form =
            new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
        return _this;
    }
    NgForm.prototype.ngAfterViewInit = function () { this._setUpdateStrategy(); };
    Object.defineProperty(NgForm.prototype, "formDirective", {
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    NgForm.prototype.addControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            dir.control =
                container.registerControl(dir.name, dir.control);
            setUpControl(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
            _this._directives.push(dir);
        });
    };
    NgForm.prototype.getControl = function (dir) { return this.form.get(dir.path); };
    NgForm.prototype.removeControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
            removeDir(_this._directives, dir);
        });
    };
    NgForm.prototype.addFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            var group = new FormGroup({});
            setUpFormContainer(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    NgForm.prototype.removeFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    NgForm.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
    NgForm.prototype.updateModel = function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var ctrl = _this.form.get(dir.path);
            ctrl.setValue(value);
        });
    };
    NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
    NgForm.prototype.onSubmit = function ($event) {
        this.submitted = true;
        syncPendingControls(this.form, this._directives);
        this.ngSubmit.emit($event);
        return false;
    };
    NgForm.prototype.onReset = function () { this.resetForm(); };
    NgForm.prototype.resetForm = function (value) {
        if (value === void 0) {
            value = undefined;
        }
        this.form.reset(value);
        this.submitted = false;
    };
    NgForm.prototype._setUpdateStrategy = function () {
        if (this.options && this.options.updateOn != null) {
            this.form._updateOn = this.options.updateOn;
        }
    };
    /** @internal */
    NgForm.prototype._findContainer = function (path) {
        path.pop();
        return path.length ? this.form.get(path) : this.form;
    };
    NgForm = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_ASYNC_VALIDATORS))
    ], NgForm);
    return NgForm;
}(ControlContainer));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TemplateDrivenErrors = /*@__PURE__*/ (function () {
    function TemplateDrivenErrors() {
    }
    TemplateDrivenErrors.modelParentException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
    };
    TemplateDrivenErrors.formGroupNameException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    TemplateDrivenErrors.missingNameException = function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    TemplateDrivenErrors.modelGroupParentException = function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    return TemplateDrivenErrors;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var modelGroupProvider = {
    provide: ControlContainer,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * @description
 *
 * Creates and binds a `FormGroup` instance to a DOM element.
 *
 * This directive can only be used as a child of `NgForm` (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * @ngModule FormsModule
 */
var NgModelGroup = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgModelGroup, _super);
    function NgModelGroup(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    NgModelGroup_1 = NgModelGroup;
    /** @internal */
    NgModelGroup.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup_1) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelGroupParentException();
        }
    };
    var NgModelGroup_1;
    NgModelGroup = NgModelGroup_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"])()),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_ASYNC_VALIDATORS))
    ], NgModelGroup);
    return NgModelGroup;
}(AbstractFormGroupDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding = {
    provide: NgControl,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var resolvedPromise$1 = /*@__PURE__*/ Promise.resolve(null);
/**
 * @description
 *
 * Creates a `FormControl` instance from a domain model and binds it
 * to a form control element.
 *
 * The `FormControl` instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional `Input`. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated `FormControl` (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in `AbstractControlDirective`.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: `RadioControlValueAccessor`
 * * Selects: `SelectControlValueAccessor`
 *
 * @ngModule FormsModule
 */
var NgModel = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgModel, _super);
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this.control = new FormControl();
        /** @internal */
        _this._registered = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    NgModel.prototype.ngOnChanges = function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "path", {
        get: function () {
            return this._parent ? controlPath(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    NgModel.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    NgModel.prototype._setUpControl = function () {
        this._setUpdateStrategy();
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    NgModel.prototype._setUpdateStrategy = function () {
        if (this.options && this.options.updateOn != null) {
            this.control._updateOn = this.options.updateOn;
        }
    };
    NgModel.prototype._isStandalone = function () {
        return !this._parent || !!(this.options && this.options.standalone);
    };
    NgModel.prototype._setUpStandalone = function () {
        setUpControl(this.control, this);
        this.control.updateValueAndValidity({ emitEvent: false });
    };
    NgModel.prototype._checkForErrors = function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    NgModel.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) &&
            this._parent instanceof AbstractFormGroupDirective) {
            TemplateDrivenErrors.formGroupNameException();
        }
        else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelParentException();
        }
    };
    NgModel.prototype._checkName = function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            TemplateDrivenErrors.missingNameException();
        }
    };
    NgModel.prototype._updateValue = function (value) {
        var _this = this;
        resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    NgModel.prototype._updateDisabled = function (changes) {
        var _this = this;
        var disabledValue = changes['isDisabled'].currentValue;
        var isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise$1.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    NgModel = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"])()),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_ASYNC_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALUE_ACCESSOR))
    ], NgModel);
    return NgModel;
}(NgControl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Token to provide to turn off the ngModel warning on formControl and formControlName.
 */
var NG_MODEL_WITH_FORM_CONTROL_WARNING = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('NgModelWithFormControlWarning');
var formControlBinding$1 = {
    provide: NgControl,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * @description
 *
 * Syncs a standalone `FormControl` instance to a form control element.
 *
 * This directive ensures that any values written to the `FormControl`
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * `FormControl` instance (view -> model).
 *
 * @usageNotes
 * Use this directive if you'd like to create and manage a `FormControl` instance directly.
 * Simply create a `FormControl`, save it to your component class, and pass it into the
 * `FormControlDirective`.
 *
 * This directive is designed to be used as a standalone control.  Unlike `FormControlName`,
 * it does not require that your `FormControl` instance be part of any parent
 * `FormGroup`, and it won't be registered to any `FormGroupDirective` that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * `FormControl` instance. See a full list of available properties in
 * `AbstractControl`.
 *
 * **Set the value**: You can pass in an initial value when instantiating the `FormControl`,
 * or you can set it programmatically later using {@link AbstractControl#setValue setValue} or
 * {@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * ### Use with ngModel
 *
 * Support for using the `ngModel` input property and `ngModelChange` event with reactive
 * form directives has been deprecated in Angular v6 and will be removed in Angular v7.
 *
 * Now deprecated:
 *
 * ```html
 * <input [formControl]="control" [(ngModel)]="value">
 * ```
 *
 * ```ts
 * this.value = 'some value';
 * ```
 *
 * This has been deprecated for a few reasons. First, developers have found this pattern
 * confusing. It seems like the actual `ngModel` directive is being used, but in fact it's
 * an input/output property named `ngModel` on the reactive form directive that simply
 * approximates (some of) its behavior. Specifically, it allows getting/setting the value
 * and intercepting value events. However, some of `ngModel`'s other features - like
 * delaying updates with`ngModelOptions` or exporting the directive - simply don't work,
 * which has understandably caused some confusion.
 *
 * In addition, this pattern mixes template-driven and reactive forms strategies, which
 * we generally don't recommend because it doesn't take advantage of the full benefits of
 * either strategy. Setting the value in the template violates the template-agnostic
 * principles behind reactive forms, whereas adding a `FormControl`/`FormGroup` layer in
 * the class removes the convenience of defining forms in the template.
 *
 * To update your code before v7, you'll want to decide whether to stick with reactive form
 * directives (and get/set values using reactive forms patterns) or switch over to
 * template-driven directives.
 *
 * After (choice 1 - use reactive forms):
 *
 * ```html
 * <input [formControl]="control">
 * ```
 *
 * ```ts
 * this.control.setValue('some value');
 * ```
 *
 * After (choice 2 - use template-driven forms):
 *
 * ```html
 * <input [(ngModel)]="value">
 * ```
 *
 * ```ts
 * this.value = 'some value';
 * ```
 *
 * By default, when you use this pattern, you will see a deprecation warning once in dev
 * mode. You can choose to silence this warning by providing a config for
 * `ReactiveFormsModule` at import time:
 *
 * ```ts
 * imports: [
 *   ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'});
 * ]
 * ```
 *
 * Alternatively, you can choose to surface a separate warning for each instance of this
 * pattern with a config value of `"always"`. This may help to track down where in the code
 * the pattern is being used as the code is being updated.
 *
 * @ngModule ReactiveFormsModule
 */
var FormControlDirective = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FormControlDirective, _super);
    function FormControlDirective(validators, asyncValidators, valueAccessors, _ngModelWarningConfig) {
        var _this = _super.call(this) || this;
        _this._ngModelWarningConfig = _ngModelWarningConfig;
        /** @deprecated as of v6 */
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        /**
         * Instance property used to track whether an ngModel warning has been sent out for this
         * particular FormControlDirective instance. Used to support warning config of "always".
         *
         * @internal
         */
        _this._ngModelWarningSent = false;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    FormControlDirective_1 = FormControlDirective;
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    FormControlDirective.prototype.ngOnChanges = function (changes) {
        if (this._isControlChanged(changes)) {
            setUpControl(this.form, this);
            if (this.control.disabled && this.valueAccessor.setDisabledState) {
                this.valueAccessor.setDisabledState(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            _ngModelWarning('formControl', FormControlDirective_1, this, this._ngModelWarningConfig);
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    FormControlDirective.prototype._isControlChanged = function (changes) {
        return changes.hasOwnProperty('form');
    };
    var FormControlDirective_1;
    /**
     * Static property used to track whether any ngModel warnings have been sent across
     * all instances of FormControlDirective. Used to support warning config of "once".
     *
     * @internal
     */
    FormControlDirective._ngModelWarningSentOnce = false;
    FormControlDirective = FormControlDirective_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_ASYNC_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALUE_ACCESSOR)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_MODEL_WITH_FORM_CONTROL_WARNING))
    ], FormControlDirective);
    return FormControlDirective;
}(NgControl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider$1 = {
    provide: ControlContainer,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * @description
 *
 * Binds an existing `FormGroup` to a DOM element.
 *
 * This directive accepts an existing `FormGroup` instance. It will then use this
 * `FormGroup` instance to match any child `FormControl`, `FormGroup`,
 * and `FormArray` instances to child `FormControlName`, `FormGroupName`,
 * and `FormArrayName` directives.
 *
 * @usageNotes
 * **Set value**: You can set the form's initial value when instantiating the
 * `FormGroup`, or you can set it programmatically later using the `FormGroup`'s
 * {@link AbstractControl#setValue setValue} or {@link AbstractControl#patchValue patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the `FormGroup`'s {@link AbstractControl#valueChanges valueChanges} event.  You can also
 * listen to its {@link AbstractControl#statusChanges statusChanges} event to be notified when the
 * validation status is re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * @ngModule ReactiveFormsModule
 */
var FormGroupDirective = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FormGroupDirective, _super);
    function FormGroupDirective(_validators, _asyncValidators) {
        var _this = _super.call(this) || this;
        _this._validators = _validators;
        _this._asyncValidators = _asyncValidators;
        _this.submitted = false;
        _this.directives = [];
        _this.form = null;
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        return _this;
    }
    FormGroupDirective.prototype.ngOnChanges = function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    FormGroupDirective.prototype.addControl = function (dir) {
        var ctrl = this.form.get(dir.path);
        setUpControl(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    FormGroupDirective.prototype.getControl = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.removeControl = function (dir) { removeDir(this.directives, dir); };
    FormGroupDirective.prototype.addFormGroup = function (dir) {
        var ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
    FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.addFormArray = function (dir) {
        var ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype.removeFormArray = function (dir) { };
    FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.get(dir.path); };
    FormGroupDirective.prototype.updateModel = function (dir, value) {
        var ctrl = this.form.get(dir.path);
        ctrl.setValue(value);
    };
    FormGroupDirective.prototype.onSubmit = function ($event) {
        this.submitted = true;
        syncPendingControls(this.form, this.directives);
        this.ngSubmit.emit($event);
        return false;
    };
    FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
    FormGroupDirective.prototype.resetForm = function (value) {
        if (value === void 0) {
            value = undefined;
        }
        this.form.reset(value);
        this.submitted = false;
    };
    /** @internal */
    FormGroupDirective.prototype._updateDomValue = function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var newCtrl = _this.form.get(dir.path);
            if (dir.control !== newCtrl) {
                cleanUpControl(dir.control, dir);
                if (newCtrl)
                    setUpControl(newCtrl, dir);
                dir.control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    FormGroupDirective.prototype._updateRegistrations = function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    FormGroupDirective.prototype._updateValidators = function () {
        var sync = composeValidators(this._validators);
        this.form.validator = Validators.compose([this.form.validator, sync]);
        var async = composeAsyncValidators(this._asyncValidators);
        this.form.asyncValidator = Validators.composeAsync([this.form.asyncValidator, async]);
    };
    FormGroupDirective.prototype._checkFormPresent = function () {
        if (!this.form) {
            ReactiveErrors.missingFormException();
        }
    };
    FormGroupDirective = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_ASYNC_VALIDATORS))
    ], FormGroupDirective);
    return FormGroupDirective;
}(ControlContainer));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formGroupNameProvider = {
    provide: ControlContainer,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * @description
 *
 * Syncs a nested `FormGroup` to a DOM element.
 *
 * This directive can only be used with a parent `FormGroupDirective` (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested `FormGroup` you want to link, and
 * will look for a `FormGroup` registered with that name in the parent
 * `FormGroup` instance you passed into `FormGroupDirective`.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * @usageNotes
 * **Access the group**: You can access the associated `FormGroup` using the
 * {@link AbstractControl#get get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * `FormGroup`. See a full list of available properties in `AbstractControl`.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the `FormGroup`, or you can set it programmatically later using
 * {@link AbstractControl#setValue setValue} or {@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * @ngModule ReactiveFormsModule
 */
var FormGroupName = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FormGroupName, _super);
    function FormGroupName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /** @internal */
    FormGroupName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.groupParentException();
        }
    };
    FormGroupName = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"])()),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_ASYNC_VALIDATORS))
    ], FormGroupName);
    return FormGroupName;
}(AbstractFormGroupDirective));
var formArrayNameProvider = {
    provide: ControlContainer,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * @description
 *
 * Syncs a nested `FormArray` to a DOM element.
 *
 * This directive is designed to be used with a parent `FormGroupDirective` (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested `FormArray` you want to link, and
 * will look for a `FormArray` registered with that name in the parent
 * `FormGroup` instance you passed into `FormGroupDirective`.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * @usageNotes
 * **Access the array**: You can access the associated `FormArray` using the
 * {@link AbstractControl#get get} method on the parent `FormGroup`.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * `FormArray`. See a full list of available properties in `AbstractControl`.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the `FormArray`, or you can set the value programmatically later using the
 * `FormArray`'s {@link AbstractControl#setValue setValue} or
 * {@link AbstractControl#patchValue patchValue} methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the `FormArray`'s {@link AbstractControl#valueChanges valueChanges} event.
 * You can also listen to its {@link AbstractControl#statusChanges statusChanges} event to be
 * notified when the validation status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the `FormArray` dynamically by calling
 * its {@link FormArray#push push} method.
 * Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * @ngModule ReactiveFormsModule
 */
var FormArrayName = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FormArrayName, _super);
    function FormArrayName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    FormArrayName.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormArray(this);
    };
    FormArrayName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        get: function () { return this.formDirective.getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        get: function () {
            return this._parent ? this._parent.formDirective : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        get: function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        get: function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    FormArrayName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.arrayParentException();
        }
    };
    FormArrayName = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"])()),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_ASYNC_VALIDATORS))
    ], FormArrayName);
    return FormArrayName;
}(ControlContainer));
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
        !(parent instanceof FormArrayName);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var controlNameBinding = {
    provide: NgControl,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * @description
 *
 * Syncs a `FormControl` in an existing `FormGroup` to a form control
 * element by name.
 *
 * This directive ensures that any values written to the `FormControl`
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * `FormControl` instance (view -> model).
 *
 * @usageNotes
 * This directive is designed to be used with a parent `FormGroupDirective` (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the `FormControl` instance you want to
 * link, and will look for a `FormControl` registered with that name in the
 * closest `FormGroup` or `FormArray` above it.
 *
 * **Access the control**: You can access the `FormControl` associated with
 * this directive by using the {@link AbstractControl#get get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the `FormControl`.
 * See a full list of available properties in `AbstractControl`.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  `FormControl`, or you can set it programmatically later using
 *  {@link AbstractControl#setValue setValue} or {@link AbstractControl#patchValue patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {@link AbstractControl#valueChanges valueChanges} event.  You can also listen to
 * {@link AbstractControl#statusChanges statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: `RadioControlValueAccessor`
 * * Selects: `SelectControlValueAccessor`
 *
 * ### Use with ngModel
 *
 * Support for using the `ngModel` input property and `ngModelChange` event with reactive
 * form directives has been deprecated in Angular v6 and will be removed in Angular v7.
 *
 * Now deprecated:
 *
 * ```html
 * <form [formGroup]="form">
 *   <input formControlName="first" [(ngModel)]="value">
 * </form>
 * ```
 *
 * ```ts
 * this.value = 'some value';
 * ```
 *
 * This has been deprecated for a few reasons. First, developers have found this pattern
 * confusing. It seems like the actual `ngModel` directive is being used, but in fact it's
 * an input/output property named `ngModel` on the reactive form directive that simply
 * approximates (some of) its behavior. Specifically, it allows getting/setting the value
 * and intercepting value events. However, some of `ngModel`'s other features - like
 * delaying updates with`ngModelOptions` or exporting the directive - simply don't work,
 * which has understandably caused some confusion.
 *
 * In addition, this pattern mixes template-driven and reactive forms strategies, which
 * we generally don't recommend because it doesn't take advantage of the full benefits of
 * either strategy. Setting the value in the template violates the template-agnostic
 * principles behind reactive forms, whereas adding a `FormControl`/`FormGroup` layer in
 * the class removes the convenience of defining forms in the template.
 *
 * To update your code before v7, you'll want to decide whether to stick with reactive form
 * directives (and get/set values using reactive forms patterns) or switch over to
 * template-driven directives.
 *
 * After (choice 1 - use reactive forms):
 *
 * ```html
 * <form [formGroup]="form">
 *   <input formControlName="first">
 * </form>
 * ```
 *
 * ```ts
 * this.form.get('first').setValue('some value');
 * ```
 *
 * After (choice 2 - use template-driven forms):
 *
 * ```html
 * <input [(ngModel)]="value">
 * ```
 *
 * ```ts
 * this.value = 'some value';
 * ```
 *
 * By default, when you use this pattern, you will see a deprecation warning once in dev
 * mode. You can choose to silence this warning by providing a config for
 * `ReactiveFormsModule` at import time:
 *
 * ```ts
 * imports: [
 *   ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'});
 * ]
 * ```
 *
 * Alternatively, you can choose to surface a separate warning for each instance of this
 * pattern with a config value of `"always"`. This may help to track down where in the code
 * the pattern is being used as the code is being updated.
 *
 * @ngModule ReactiveFormsModule
 */
var FormControlName = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FormControlName, _super);
    function FormControlName(parent, validators, asyncValidators, valueAccessors, _ngModelWarningConfig) {
        var _this = _super.call(this) || this;
        _this._ngModelWarningConfig = _ngModelWarningConfig;
        _this._added = false;
        /** @deprecated as of v6 */
        _this.update = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        /**
         * Instance property used to track whether an ngModel warning has been sent out for this
         * particular FormControlName instance. Used to support warning config of "always".
         *
         * @internal
         */
        _this._ngModelWarningSent = false;
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    FormControlName_1 = FormControlName;
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    FormControlName.prototype.ngOnChanges = function (changes) {
        if (!this._added)
            this._setUpControl();
        if (isPropertyUpdated(changes, this.viewModel)) {
            _ngModelWarning('formControlName', FormControlName_1, this, this._ngModelWarningConfig);
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    FormControlName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    FormControlName.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    FormControlName.prototype._checkParentType = function () {
        if (!(this._parent instanceof FormGroupName) &&
            this._parent instanceof AbstractFormGroupDirective) {
            ReactiveErrors.ngModelGroupException();
        }
        else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
            !(this._parent instanceof FormArrayName)) {
            ReactiveErrors.controlParentException();
        }
    };
    FormControlName.prototype._setUpControl = function () {
        this._checkParentType();
        this.control = this.formDirective.addControl(this);
        if (this.control.disabled && this.valueAccessor.setDisabledState) {
            this.valueAccessor.setDisabledState(true);
        }
        this._added = true;
    };
    var FormControlName_1;
    /**
     * Static property used to track whether any ngModel warnings have been sent across
     * all instances of FormControlName. Used to support warning config of "once".
     *
     * @internal
     */
    FormControlName._ngModelWarningSentOnce = false;
    FormControlName = FormControlName_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Host"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"])()),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_ASYNC_VALIDATORS)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Self"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_VALUE_ACCESSOR)),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(4, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(4, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(NG_MODEL_WITH_FORM_CONTROL_WARNING))
    ], FormControlName);
    return FormControlName;
}(NgControl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
var CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return CheckboxRequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the `NG_VALIDATORS` binding.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var RequiredValidator = /*@__PURE__*/ (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        get: function () { return this._required; },
        set: function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    RequiredValidator.prototype.validate = function (control) {
        return this.required ? Validators.required(control) : null;
    };
    RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    return RequiredValidator;
}());
/**
 * A Directive that adds the `required` validator to checkbox controls marked with the
 * `required` attribute, via the `NG_VALIDATORS` binding.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <input type="checkbox" name="active" ngModel required>
 * ```
 *
 * @experimental
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var CheckboxRequiredValidator = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(CheckboxRequiredValidator, _super);
    function CheckboxRequiredValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckboxRequiredValidator.prototype.validate = function (control) {
        return this.required ? Validators.requiredTrue(control) : null;
    };
    return CheckboxRequiredValidator;
}(RequiredValidator));
/**
 * Provider which adds `EmailValidator` to `NG_VALIDATORS`.
 */
var EMAIL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return EmailValidator; }),
    multi: true
};
/**
 * A Directive that adds the `email` validator to controls marked with the
 * `email` attribute, via the `NG_VALIDATORS` binding.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <input type="email" name="email" ngModel email>
 * <input type="email" name="email" ngModel email="true">
 * <input type="email" name="email" ngModel [email]="true">
 * ```
 *
 * @experimental
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var EmailValidator = /*@__PURE__*/ (function () {
    function EmailValidator() {
    }
    Object.defineProperty(EmailValidator.prototype, "email", {
        set: function (value) {
            this._enabled = value === '' || value === true || value === 'true';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    EmailValidator.prototype.validate = function (control) {
        return this._enabled ? Validators.email(control) : null;
    };
    EmailValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    return EmailValidator;
}());
/**
 * Provider which adds `MinLengthValidator` to `NG_VALIDATORS`.
 *
 * @usageNotes
 * ### Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='min'}
 */
var MIN_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the `MinLengthValidator` for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var MinLengthValidator = /*@__PURE__*/ (function () {
    function MinLengthValidator() {
    }
    MinLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    MinLengthValidator.prototype.validate = function (control) {
        return this.minlength == null ? null : this._validator(control);
    };
    MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    MinLengthValidator.prototype._createValidator = function () {
        this._validator = Validators.minLength(parseInt(this.minlength, 10));
    };
    return MinLengthValidator;
}());
/**
 * Provider which adds `MaxLengthValidator` to `NG_VALIDATORS`.
 *
 * @usageNotes
 * ### Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='max'}
 */
var MAX_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the `MaxLengthValidator` for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `maxlength` attribute.
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var MaxLengthValidator = /*@__PURE__*/ (function () {
    function MaxLengthValidator() {
    }
    MaxLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    MaxLengthValidator.prototype.validate = function (control) {
        return this.maxlength != null ? this._validator(control) : null;
    };
    MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    MaxLengthValidator.prototype._createValidator = function () {
        this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
    };
    return MaxLengthValidator;
}());
var PATTERN_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: /*@__PURE__*/ Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the `NG_VALIDATORS` binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 *
 * @ngModule FormsModule
 * @ngModule ReactiveFormsModule
 */
var PatternValidator = /*@__PURE__*/ (function () {
    function PatternValidator() {
    }
    PatternValidator.prototype.ngOnChanges = function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    PatternValidator.prototype.validate = function (control) { return this._validator(control); };
    PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
    return PatternValidator;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 * Creates an `AbstractControl` from a user-specified configuration.
 *
 * The `FormBuilder` provides syntactic sugar that shortens creating instances of a `FormControl`,
 * `FormGroup`, or `FormArray`. It reduces the amount of boilerplate needed to build complex
 * forms.
 *
 * @see [Reactive Forms Guide](/guide/reactive-forms)
 *
 */
var FormBuilder = /*@__PURE__*/ (function () {
    function FormBuilder() {
    }
    /**
     * @description
     * Construct a new `FormGroup` instance.
     *
     * @param controlsConfig A collection of child controls. The key for each child is the name
     * under which it is registered.
     *
     * @param extra An object of configuration options for the `FormGroup`.
     * * `validator`: A synchronous validator function, or an array of validator functions
     * * `asyncValidator`: A single async validator or array of async validator functions
     *
     */
    FormBuilder.prototype.group = function (controlsConfig, extra) {
        if (extra === void 0) {
            extra = null;
        }
        var controls = this._reduceControls(controlsConfig);
        var validator = extra != null ? extra['validator'] : null;
        var asyncValidator = extra != null ? extra['asyncValidator'] : null;
        return new FormGroup(controls, validator, asyncValidator);
    };
    /**
     * @description
     * Construct a new `FormControl` instance.
     *
     * @param formState Initializes the control with an initial value,
     * or an object that defines the initial value and disabled state.
     *
     * @param validator A synchronous validator function, or an array of synchronous validator
     * functions.
     *
     * @param asyncValidator A single async validator or array of async validator functions
     *
     * @usageNotes
     *
     * ### Initialize a control as disabled
     *
     * The following example returns a control with an initial value in a disabled state.
     *
     * <code-example path="forms/ts/formBuilder/form_builder_example.ts"
     *   linenums="false" region="disabled-control">
     * </code-example>
     *
     */
    FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
        return new FormControl(formState, validator, asyncValidator);
    };
    /**
     * @description
     * Construct a new `FormArray` instance.
     *
     * @param controlsConfig An array of child controls. The key for each child control is its index
     * in the array.
     *
     * @param validator A synchronous validator function, or an array of synchronous validator
     * functions.
     *
     * @param asyncValidator A single async validator or array of async validator functions
     */
    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new FormArray(controls, validator, asyncValidator);
    };
    /** @internal */
    FormBuilder.prototype._reduceControls = function (controlsConfig) {
        var _this = this;
        var controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /** @internal */
    FormBuilder.prototype._createControl = function (controlConfig) {
        if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
            controlConfig instanceof FormArray) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var value = controlConfig[0];
            var validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    return FormBuilder;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var VERSION = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('6.1.10');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Adds `novalidate` attribute to all forms by default.
 *
 * `novalidate` is used to disable browser's native form validation.
 *
 * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
 *
 * ```
 * <form ngNativeValidate></form>
 * ```
 *
 * @experimental
 * @ngModule ReactiveFormsModule
 * @ngModule FormsModule
 */
var NgNoValidate = /*@__PURE__*/ (function () {
    function NgNoValidate() {
    }
    return NgNoValidate;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SHARED_FORM_DIRECTIVES = [
    NgNoValidate,
    NgSelectOption,
    NgSelectMultipleOption,
    DefaultValueAccessor,
    NumberValueAccessor,
    RangeValueAccessor,
    CheckboxControlValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
    NgControlStatus,
    NgControlStatusGroup,
    RequiredValidator,
    MinLengthValidator,
    MaxLengthValidator,
    PatternValidator,
    CheckboxRequiredValidator,
    EmailValidator,
];
var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = /*@__PURE__*/ (function () {
    function InternalFormsSharedModule() {
    }
    return InternalFormsSharedModule;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Exports the required providers and directives for template-driven forms,
 * making them available for import by NgModules that import this module.
 * @see [Forms](guide/forms)
 *
 * @see [Forms Guide](/guide/forms)
 */
var FormsModule = /*@__PURE__*/ (function () {
    function FormsModule() {
    }
    return FormsModule;
}());
/**
 * Exports the required infrastructure and directives for reactive forms,
 * making them available for import by NgModules that import this module.
 * @see [Forms](guide/reactive-forms)
 *
 * @see [Reactive Forms Guide](/guide/reactive-forms)
 *
 */
var ReactiveFormsModule = /*@__PURE__*/ (function () {
    function ReactiveFormsModule() {
    }
    ReactiveFormsModule_1 = ReactiveFormsModule;
    /**
     * @description
     * Provides options for configuring the reactive forms module.
     *
     * @param opts An object of configuration options `warnOnNgModelWithFormControl` Configures when
     * to emit a warning when an `ngModel binding is used with reactive form directives.
     */
    ReactiveFormsModule.withConfig = function (opts) {
        return {
            ngModule: ReactiveFormsModule_1,
            providers: [{
                    provide: NG_MODEL_WITH_FORM_CONTROL_WARNING,
                    useValue: opts.warnOnNgModelWithFormControl
                }]
        };
    };
    var ReactiveFormsModule_1;
    return ReactiveFormsModule;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */






/***/ }),

/***/ "B+PI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEem":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        ss : '%d ثانية',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),

/***/ "BUs8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__("TdOr");
var ng2_auto_complete_1 = __webpack_require__("Hoss");
/**
 * show a selected date in monthly calendar
 * Each filteredList item has the following property in addition to data itself
 *   1. displayValue as string e.g. Allen Kim
 *   2. dataValue as any e.g.
 */
var Ng2AutoCompleteComponent = /*@__PURE__*/ (function () {
    /**
     * constructor
     */
    function Ng2AutoCompleteComponent(elementRef, autoComplete) {
        var _this = this;
        this.autoComplete = autoComplete;
        this.minChars = 0;
        this.loadingText = "Loading";
        this.showInputTag = true;
        this.showDropdownOnInit = false;
        this.tabToSelect = true;
        this.matchFormatted = false;
        this.valueSelected = new core_1.EventEmitter();
        this.dropdownVisible = false;
        this.isLoading = false;
        this.filteredList = [];
        this.minCharsEntered = false;
        this.itemIndex = 0;
        this.reloadListInDelay = function (evt) {
            var delayMs = _this.isSrcArr() ? 10 : 500;
            var keyword = evt.target.value;
            // executing after user stopped typing
            _this.delay(function () { return _this.reloadList(keyword); }, delayMs);
        };
        this.inputElKeyHandler = function (evt) {
            var totalNumItem = _this.filteredList.length;
            switch (evt.keyCode) {
                case 27:
                    break;
                case 38:
                    _this.itemIndex = (totalNumItem + _this.itemIndex - 1) % totalNumItem;
                    break;
                case 40:
                    _this.dropdownVisible = true;
                    _this.itemIndex = (totalNumItem + _this.itemIndex + 1) % totalNumItem;
                    break;
                case 13:
                    if (_this.filteredList.length > 0) {
                        _this.selectOne(_this.filteredList[_this.itemIndex]);
                    }
                    evt.preventDefault();
                    break;
                case 9:
                    if (_this.tabToSelect && _this.filteredList.length > 0) {
                        _this.selectOne(_this.filteredList[_this.itemIndex]);
                    }
                    break;
            }
        };
        this.delay = (function () {
            var timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();
        this.el = elementRef.nativeElement;
    }
    Ng2AutoCompleteComponent.prototype.isSrcArr = function () {
        return (this.source.constructor.name === "Array");
    };
    /**
     * user enters into input el, shows list to select, then select one
     */
    Ng2AutoCompleteComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.autoComplete.source = this.source;
        this.autoComplete.pathToData = this.pathToData;
        this.autoComplete.listFormatter = this.listFormatter;
        setTimeout(function () {
            if (_this.autoCompleteInput) {
                _this.autoCompleteInput.nativeElement.focus();
            }
            if (_this.showDropdownOnInit) {
                _this.showDropdownList({ target: { value: '' } });
            }
        });
    };
    Ng2AutoCompleteComponent.prototype.showDropdownList = function (event) {
        this.dropdownVisible = true;
        this.reloadList(event.target.value);
    };
    Ng2AutoCompleteComponent.prototype.hideDropdownList = function () {
        this.dropdownVisible = false;
    };
    Ng2AutoCompleteComponent.prototype.findItemFromSelectValue = function (selectText) {
        var matchingItems = this.filteredList
            .filter(function (item) { return ('' + item) === selectText; });
        return matchingItems.length ? matchingItems[0] : null;
    };
    Ng2AutoCompleteComponent.prototype.reloadList = function (keyword) {
        var _this = this;
        this.filteredList = [];
        if (keyword.length < (this.minChars || 0)) {
            this.minCharsEntered = false;
            return;
        }
        else {
            this.minCharsEntered = true;
        }
        if (this.isSrcArr()) {
            this.isLoading = false;
            this.filteredList = this.autoComplete.filter(this.source, keyword, this.matchFormatted);
            if (this.maxNumList) {
                this.filteredList = this.filteredList.slice(0, this.maxNumList);
            }
        }
        else {
            this.isLoading = true;
            if (typeof this.source === "function") {
                // custom function that returns observable
                this.source(keyword).subscribe(function (resp) {
                    if (_this.pathToData) {
                        var paths = _this.pathToData.split(".");
                        paths.forEach(function (prop) { return resp = resp[prop]; });
                    }
                    _this.filteredList = resp;
                    if (_this.maxNumList) {
                        _this.filteredList = _this.filteredList.slice(0, _this.maxNumList);
                    }
                }, function (error) { return null; }, function () { return _this.isLoading = false; } // complete
                );
            }
            else {
                // remote source
                this.autoComplete.getRemoteData(keyword).subscribe(function (resp) {
                    _this.filteredList = resp;
                    if (_this.maxNumList) {
                        _this.filteredList = _this.filteredList.slice(0, _this.maxNumList);
                    }
                }, function (error) { return null; }, function () { return _this.isLoading = false; } // complete
                );
            }
        }
    };
    Ng2AutoCompleteComponent.prototype.selectOne = function (data) {
        this.valueSelected.emit(data);
    };
    ;
    Object.defineProperty(Ng2AutoCompleteComponent.prototype, "emptyList", {
        get: function () {
            return !(this.isLoading ||
                (this.minCharsEntered && !this.isLoading && !this.filteredList.length) ||
                (this.filteredList.length));
        },
        enumerable: true,
        configurable: true
    });
    Ng2AutoCompleteComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: "ng2-auto-complete",
                    template: "\n  <div class=\"ng2-auto-complete\">\n\n    <!-- keyword input -->\n    <input *ngIf=\"showInputTag\"\n           #autoCompleteInput class=\"keyword\"\n           placeholder=\"{{placeholder}}\"\n           (focus)=\"showDropdownList($event)\"\n           (blur)=\"hideDropdownList()\"\n           (keydown)=\"inputElKeyHandler($event)\"\n           (input)=\"reloadListInDelay($event)\"\n           [(ngModel)]=\"keyword\" />\n\n    <!-- dropdown that user can select -->\n    <ul *ngIf=\"dropdownVisible\" [class.empty]=\"emptyList\">\n      <li *ngIf=\"isLoading\" class=\"loading\">{{loadingText}}</li>\n      <li *ngIf=\"minCharsEntered && !isLoading && !filteredList.length\"\n           (mousedown)=\"selectOne('')\"\n           class=\"no-match-found\">{{noMatchFoundText || 'No Result Found'}}</li>\n      <li *ngIf=\"blankOptionText && filteredList.length\"\n          (mousedown)=\"selectOne('')\"\n          class=\"blank-item\">{{blankOptionText}}</li>\n      <li class=\"item\"\n          *ngFor=\"let item of filteredList; let i=index\"\n          (mousedown)=\"selectOne(item)\"\n          [ngClass]=\"{selected: i === itemIndex}\"\n          [innerHtml]=\"autoComplete.getFormattedListItem(item)\">\n      </li>\n    </ul>\n\n  </div>",
                    providers: [ng2_auto_complete_1.Ng2AutoComplete],
                    styles: ["\n  @keyframes slideDown {\n    0% {\n      transform:  translateY(-10px);\n    }\n    100% {\n      transform: translateY(0px);\n    }\n  }\n  .ng2-auto-complete {\n    background-color: transparent;\n  }\n  .ng2-auto-complete > input {\n    outline: none;\n    border: 0;\n    padding: 2px; \n    box-sizing: border-box;\n    background-clip: content-box;\n  }\n\n  .ng2-auto-complete > ul {\n    background-color: #fff;\n    margin: 0;\n    width : 100%;\n    overflow-y: auto;\n    list-style-type: none;\n    padding: 0;\n    border: 1px solid #ccc;\n    box-sizing: border-box;\n    animation: slideDown 0.1s;\n  }\n  .ng2-auto-complete > ul.empty {\n    display: none;\n  }\n\n  .ng2-auto-complete > ul li {\n    padding: 2px 5px;\n    border-bottom: 1px solid #eee;\n  }\n\n  .ng2-auto-complete > ul li.selected {\n    background-color: #ccc;\n  }\n\n  .ng2-auto-complete > ul li:last-child {\n    border-bottom: none;\n  }\n\n  .ng2-auto-complete > ul li:hover {\n    background-color: #ccc;\n  }"
                    ],
                    encapsulation: core_1.ViewEncapsulation.None
                },] },
    ];
    /** @nocollapse */
    Ng2AutoCompleteComponent.ctorParameters = [
        { type: core_1.ElementRef, },
        { type: ng2_auto_complete_1.Ng2AutoComplete, },
    ];
    Ng2AutoCompleteComponent.propDecorators = {
        'listFormatter': [{ type: core_1.Input, args: ["list-formatter",] },],
        'source': [{ type: core_1.Input, args: ["source",] },],
        'pathToData': [{ type: core_1.Input, args: ["path-to-data",] },],
        'minChars': [{ type: core_1.Input, args: ["min-chars",] },],
        'placeholder': [{ type: core_1.Input, args: ["placeholder",] },],
        'blankOptionText': [{ type: core_1.Input, args: ["blank-option-text",] },],
        'noMatchFoundText': [{ type: core_1.Input, args: ["no-match-found-text",] },],
        'acceptUserInput': [{ type: core_1.Input, args: ["accept-user-input",] },],
        'loadingText': [{ type: core_1.Input, args: ["loading-text",] },],
        'maxNumList': [{ type: core_1.Input, args: ["max-num-list",] },],
        'showInputTag': [{ type: core_1.Input, args: ["show-input-tag",] },],
        'showDropdownOnInit': [{ type: core_1.Input, args: ["show-dropdown-on-init",] },],
        'tabToSelect': [{ type: core_1.Input, args: ["tab-to-select",] },],
        'matchFormatted': [{ type: core_1.Input, args: ["match-formatted",] },],
        'valueSelected': [{ type: core_1.Output },],
        'autoCompleteInput': [{ type: core_1.ViewChild, args: ['autoCompleteInput',] },],
    };
    return Ng2AutoCompleteComponent;
}());
exports.Ng2AutoCompleteComponent = Ng2AutoCompleteComponent;



/***/ }),

/***/ "BbgG":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),

/***/ "BdDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hostReportError;
/**
 * Throws an error on another job so that it's picked up by the runtime's
 * uncaught error handling mechanism.
 * @param err the error to throw
 */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; });
}
//# sourceMappingURL=hostReportError.js.map


/***/ }),

/***/ "Bp2f":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        ss : '%d seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),

/***/ "C0hh":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "C2y9":
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ "C7av":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        ss : '%d sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),

/***/ "CFqe":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        ss : '%d δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),

/***/ "CHen":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("uCi2"),
    baseSet = __webpack_require__("HAGj"),
    castPath = __webpack_require__("bIjD");

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),

/***/ "CPX7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToPromise__ = /*@__PURE__*/__webpack_require__("bqNY");
/** PURE_IMPORTS_START _Observable,_Subscription,_util_subscribeToPromise PURE_IMPORTS_END */



function fromPromise(input, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToPromise__["a" /* subscribeToPromise */])(input));
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            sub.add(scheduler.schedule(function () {
                return input.then(function (value) {
                    sub.add(scheduler.schedule(function () {
                        subscriber.next(value);
                        sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                    }));
                }, function (err) {
                    sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
                });
            }));
            return sub;
        });
    }
}
//# sourceMappingURL=fromPromise.js.map


/***/ }),

/***/ "CUT0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Hot Module Replacement
function identity(val) {
    return val;
}
function bootloader(main, before, after) {
    if (typeof main === 'object') {
        var _main = main.main;
        before = main.before;
        after = main.after;
        main = _main;
    }
    before = before || identity;
    after = after || identity;
    var readyState = document.readyState;
    function __domReadyHandler() {
        document.removeEventListener('DOMContentLoaded', __domReadyHandler);
        after(main(before(readyState)));
    }
    switch (readyState) {
        case 'loading':
            document.addEventListener('DOMContentLoaded', __domReadyHandler);
            break;
        case 'interactive':
        case 'complete':
        default:
            after(main(before(readyState)));
    }
}
exports.bootloader = bootloader;
// create new host elements and remove the old elements
function createNewHosts(cmps) {
    var components = Array.prototype.map.call(cmps, function (componentNode) {
        var newNode = document.createElement(componentNode.tagName);
        var parentNode = componentNode.parentNode;
        var currentDisplay = newNode.style.display;
        newNode.style.display = 'none';
        parentNode.insertBefore(newNode, componentNode);
        function removeOldHost() {
            newNode.style.display = currentDisplay;
            try {
                parentNode.removeChild(componentNode);
            }
            catch (e) { }
        }
        return removeOldHost;
    });
    return function removeOldHosts() {
        components.forEach(function (removeOldHost) { return removeOldHost(); });
    };
}
exports.createNewHosts = createNewHosts;
// remove old styles
function removeNgStyles() {
    var docHead = document.head;
    var _styles = docHead.querySelectorAll('style');
    var styles = Array.prototype.slice.call(_styles);
    styles
        .filter(function (style) { return style.innerText.indexOf('_ng') !== -1; })
        .map(function (el) { return docHead.removeChild(el); });
}
exports.removeNgStyles = removeNgStyles;
// get input values
function getInputValues() {
    var _inputs = document.querySelectorAll('input');
    var inputs = Array.prototype.slice.call(_inputs);
    return inputs.map(function (input) { return input.value; });
}
exports.getInputValues = getInputValues;
// set input values
function setInputValues(_inputs) {
    var inputs = document.querySelectorAll('input');
    if (_inputs && inputs.length === _inputs.length) {
        _inputs.forEach(function (value, i) {
            var el = inputs[i];
            el.value = value;
            el.dispatchEvent(new CustomEvent('input', { detail: el.value }));
        });
        // clear array
        _inputs.length = 0;
    }
}
exports.setInputValues = setInputValues;
// get/set input values
function createInputTransfer() {
    var _inputs = getInputValues();
    return function restoreInputValues() {
        return setInputValues(_inputs);
    };
}
exports.createInputTransfer = createInputTransfer;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ "CW5P":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("T/bE"),
    ListCache = __webpack_require__("duB3"),
    Map = __webpack_require__("POb3");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "Cf65":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("uCi2"),
    baseSlice = __webpack_require__("M1c9");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ "CmsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInteropObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_observable__ = /*@__PURE__*/__webpack_require__("V9Cg");
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

/** Identifies an input as being Observable (but not necessary an Rx Observable) */
function isInteropObservable(input) {
    return input && typeof input[__WEBPACK_IMPORTED_MODULE_0__symbol_observable__["a" /* observable */]] === 'function';
}
//# sourceMappingURL=isInteropObservable.js.map


/***/ }),

/***/ "Cskv":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "DOkx":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),

/***/ "DSXN":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        ss : 'sekunde %d',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),

/***/ "Dc0G":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("blYT");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "Dc7M":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("Hxdr"),
    baseClone = __webpack_require__("Fkvj"),
    baseUnset = __webpack_require__("Vi3P"),
    castPath = __webpack_require__("bIjD"),
    copyObject = __webpack_require__("tv3T"),
    customOmitClone = __webpack_require__("dYhQ"),
    flatRest = __webpack_require__("2N6f"),
    getAllKeysIn = __webpack_require__("xond");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ "Dovw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _root; });
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _root = __window || __global || __self;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
/*@__PURE__*/ (function () {
    if (!_root) {
        throw /*@__PURE__*/ new Error('RxJS could not find any global context (window, self, global)');
    }
})();

//# sourceMappingURL=root.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "Dv2r":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("pTUa");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "DxBg":
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),

/***/ "E4Hj":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "EHRO":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn"),
    Uint8Array = __webpack_require__("qwTf"),
    eq = __webpack_require__("22B7"),
    equalArrays = __webpack_require__("FhcP"),
    mapToArray = __webpack_require__("WFiI"),
    setToArray = __webpack_require__("octw");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "EKta":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "ESBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return empty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = /*@__PURE__*/__webpack_require__("lKpf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_hostReportError__ = /*@__PURE__*/__webpack_require__("BdDE");
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */


var empty = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (__WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__util_hostReportError__["a" /* hostReportError */])(err);
        }
    },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


/***/ }),

/***/ "ETHv":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        ss : '%d सेकंड',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),

/***/ "Egod":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rxSubscriber; });
/* unused harmony export $$rxSubscriber */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function')
    ? /*@__PURE__*/ Symbol.for('rxSubscriber')
    : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
var $$rxSubscriber = rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map


/***/ }),

/***/ "EuP9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("EKta")
var ieee754 = __webpack_require__("ujcs")
var isArray = __webpack_require__("sOR5")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "F+2e":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        ss : '%d စက္ကန့်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),

/***/ "F9S/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FCuZ":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("uIr7"),
    isArray = __webpack_require__("NGEn");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "FKXc":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        ss : '%d secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),

/***/ "FRPF":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        ss : '%d ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),

/***/ "FhcP":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("7YkW"),
    arraySome = __webpack_require__("2X2u"),
    cacheHas = __webpack_require__("dmQx");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "Fkvj":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("bJWQ"),
    arrayEach = __webpack_require__("PqYH"),
    assignValue = __webpack_require__("i4ON"),
    baseAssign = __webpack_require__("jD7S"),
    baseAssignIn = __webpack_require__("py9u"),
    cloneBuffer = __webpack_require__("mKB/"),
    copyArray = __webpack_require__("hrPF"),
    copySymbols = __webpack_require__("Nkkh"),
    copySymbolsIn = __webpack_require__("1QDk"),
    getAllKeys = __webpack_require__("MoMe"),
    getAllKeysIn = __webpack_require__("xond"),
    getTag = __webpack_require__("gHOb"),
    initCloneArray = __webpack_require__("UfSK"),
    initCloneByTag = __webpack_require__("5/Qr"),
    initCloneObject = __webpack_require__("WQFf"),
    isArray = __webpack_require__("NGEn"),
    isBuffer = __webpack_require__("ggOT"),
    isObject = __webpack_require__("yCNF"),
    keys = __webpack_require__("ktak");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "FlzV":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        ss : '%d sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),

/***/ "Fp5l":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("bGc4"),
    isObjectLike = __webpack_require__("UnEC");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "Fpqq":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        ss : '%d sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),

/***/ "Frex":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        ss : '%d Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),

/***/ "FuaP":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),

/***/ "Fv6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timestamp;
/* unused harmony export Timestamp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = /*@__PURE__*/__webpack_require__("QX4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = /*@__PURE__*/__webpack_require__("rylm");
/** PURE_IMPORTS_START _scheduler_async,_map PURE_IMPORTS_END */


/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp(scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* map */])(function (value) { return new Timestamp(value, scheduler.now()); });
    // return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
var Timestamp = /*@__PURE__*/ (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());






/***/ }),

/***/ "G++c":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),

/***/ "G0Bs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throwError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

/**
 * Creates an Observable that emits no items to the Observer and immediately
 * emits an error notification.
 *
 * <span class="informal">Just emits 'error', and nothing else.
 * </span>
 *
 * <img src="./img/throw.png" width="100%">
 *
 * This static operator is useful for creating a simple Observable that only
 * emits the error notification. It can be used for composing with other
 * Observables, such as in a {@link mergeMap}.
 *
 * @example <caption>Emit the number 7, then emit an error.</caption>
 * import { throwError, concat, of } from 'rxjs/create';
 *
 * const result = concat(of(7), throwError(new Error('oops!')));
 * result.subscribe(x => console.log(x), e => console.error(e));
 *
 * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
 * import { throwError, interval, of } from 'rxjs/create';
 * import { mergeMap } from 'rxjs/operators';
 *
 * interval(1000).pipe(
 *   mergeMap(x => x === 13 ?
 *     throwError('Thirteens are bad') :
 *     of('a', 'b', 'c')
 *   )
 * ).subscribe(x => console.log(x), e => console.error(e));
 *
 * @see {@link create}
 * @see {@link empty}
 * @see {@link never}
 * @see {@link of}
 *
 * @param {any} error The particular Error to pass to the error notification.
 * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
 * the emission of the error notification.
 * @return {Observable} An error Observable: emits only the error notification
 * using the given error argument.
 * @static true
 * @name throw
 * @owner Observable
 */
function throwError(error, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return scheduler.schedule(dispatch, 0, { error: error, subscriber: subscriber }); });
    }
}
function dispatch(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}
//# sourceMappingURL=throwError.js.map


/***/ }),

/***/ "G0Wc":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF"),
    isPrototype = __webpack_require__("HT7L"),
    nativeKeysIn = __webpack_require__("8gK5");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "G2xm":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "G8ar":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("cdq7"),
    baseIsNaN = __webpack_require__("8++/"),
    strictIndexOf = __webpack_require__("i6nN");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ "GrS7":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        ss : '%d վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),

/***/ "H0JA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = /*@__PURE__*/__webpack_require__("0nHL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs__["d"]; });

//# sourceMappingURL=Observable.js.map

/***/ }),

/***/ "H74/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = tryCatch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errorObject__ = /*@__PURE__*/__webpack_require__("SQxw");
/** PURE_IMPORTS_START _errorObject PURE_IMPORTS_END */

var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        __WEBPACK_IMPORTED_MODULE_0__errorObject__["a" /* errorObject */].e = e;
        return __WEBPACK_IMPORTED_MODULE_0__errorObject__["a" /* errorObject */];
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
//# sourceMappingURL=tryCatch.js.map


/***/ }),

/***/ "HAGj":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("i4ON"),
    castPath = __webpack_require__("bIjD"),
    isIndex = __webpack_require__("ZGh9"),
    isObject = __webpack_require__("yCNF"),
    toKey = __webpack_require__("Ubhr");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ "HC03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isArray__ = /*@__PURE__*/__webpack_require__("YgML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isObject__ = /*@__PURE__*/__webpack_require__("ai7y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isFunction__ = /*@__PURE__*/__webpack_require__("bOhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_tryCatch__ = /*@__PURE__*/__webpack_require__("H74/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_errorObject__ = /*@__PURE__*/__webpack_require__("SQxw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__ = /*@__PURE__*/__webpack_require__("kk5+");
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_tryCatch,_util_errorObject,_util_UnsubscriptionError PURE_IMPORTS_END */






/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = /*@__PURE__*/ (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        /** @internal */
        this._parent = null;
        /** @internal */
        this._parents = null;
        /** @internal */
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isFunction__["a" /* isFunction */])(_unsubscribe)) {
            var trial = Object(__WEBPACK_IMPORTED_MODULE_3__util_tryCatch__["a" /* tryCatch */])(_unsubscribe).call(this);
            if (trial === __WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */]) {
                hasErrors = true;
                errors = errors || (__WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e instanceof __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__["a" /* UnsubscriptionError */] ?
                    flattenUnsubscriptionErrors(__WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e.errors) : [__WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e]);
            }
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__util_isArray__["a" /* isArray */])(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isObject__["a" /* isObject */])(sub)) {
                    var trial = Object(__WEBPACK_IMPORTED_MODULE_3__util_tryCatch__["a" /* tryCatch */])(sub.unsubscribe).call(sub);
                    if (trial === __WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */]) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = __WEBPACK_IMPORTED_MODULE_4__util_errorObject__["a" /* errorObject */].e;
                        if (err instanceof __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__["a" /* UnsubscriptionError */]) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__["a" /* UnsubscriptionError */](errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    /** @internal */
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    /** @nocollapse */
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());

function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof __WEBPACK_IMPORTED_MODULE_5__util_UnsubscriptionError__["a" /* UnsubscriptionError */]) ? err.errors : err); }, []);
}





/***/ }),

/***/ "HETl":
/***/ (function(module, exports) {

// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.
//# sourceMappingURL=toPromise.js.map

/***/ }),

/***/ "HT7L":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "HbnZ":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("bJWQ"),
    assignMergeValue = __webpack_require__("O1jc"),
    baseFor = __webpack_require__("rpnb"),
    baseMergeDeep = __webpack_require__("jMi8"),
    isObject = __webpack_require__("yCNF"),
    keysIn = __webpack_require__("t8rQ");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "Hoss":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__("TdOr");
var http_1 = __webpack_require__("T3q3");
__webpack_require__("8QP5");
/**
 * provides auto-complete related utility functions
 */
var Ng2AutoComplete = /*@__PURE__*/ (function () {
    function Ng2AutoComplete(http) {
        this.http = http;
        // ...
    }
    Ng2AutoComplete.prototype.filter = function (list, keyword, matchFormatted) {
        var _this = this;
        return list.filter(function (el) {
            var objStr = matchFormatted ? _this.getFormattedListItem(el).toLowerCase() : JSON.stringify(el).toLowerCase();
            keyword = keyword.toLowerCase();
            //console.log(objStr, keyword, objStr.indexOf(keyword) !== -1);
            return objStr.indexOf(keyword) !== -1;
        });
    };
    Ng2AutoComplete.prototype.getFormattedListItem = function (data) {
        var formatted;
        var formatter = this.listFormatter || '(id) value';
        if (typeof formatter === 'function') {
            formatted = formatter.apply(this, [data]);
        }
        else if (typeof data !== 'object') {
            formatted = data;
        }
        else if (typeof formatter === 'string') {
            formatted = formatter;
            var matches = formatter.match(/[a-zA-Z0-9_\$]+/g);
            if (matches && typeof data !== 'string') {
                matches.forEach(function (key) {
                    formatted = formatted.replace(key, data[key]);
                });
            }
        }
        return formatted;
    };
    /**
     * return remote data from the given source and options, and data path
     */
    Ng2AutoComplete.prototype.getRemoteData = function (keyword) {
        var _this = this;
        if (typeof this.source !== 'string') {
            throw "Invalid type of source, must be a string. e.g. http://www.google.com?q=:my_keyword";
        }
        else if (!this.http) {
            throw "Http is required.";
        }
        var matches = this.source.match(/:[a-zA-Z_]+/);
        if (matches === null) {
            throw "Replacement word is missing.";
        }
        var replacementWord = matches[0];
        var url = this.source.replace(replacementWord, keyword);
        return this.http.get(url)
            .map(function (resp) { return resp.json(); })
            .map(function (resp) {
            var list = resp.data || resp;
            if (_this.pathToData) {
                var paths = _this.pathToData.split(".");
                paths.forEach(function (prop) { return list = list[prop]; });
            }
            return list;
        });
    };
    ;
    Ng2AutoComplete.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    Ng2AutoComplete.ctorParameters = [
        { type: http_1.Http, decorators: [{ type: core_1.Optional },] },
    ];
    return Ng2AutoComplete;
}());
exports.Ng2AutoComplete = Ng2AutoComplete;



/***/ }),

/***/ "Hxdr":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "I6Lf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_iterator__ = /*@__PURE__*/__webpack_require__("uOsm");
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

/** Identifies an input as being an Iterable */
function isIterable(input) {
    return input && typeof input[__WEBPACK_IMPORTED_MODULE_0__symbol_iterator__["a" /* iterator */]] === 'function';
}
//# sourceMappingURL=isIterable.js.map


/***/ }),

/***/ "ICSD":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("ITwD"),
    getValue = __webpack_require__("mTAn");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "IGcM":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("bIjD"),
    isArguments = __webpack_require__("1Yb9"),
    isArray = __webpack_require__("NGEn"),
    isIndex = __webpack_require__("ZGh9"),
    isLength = __webpack_require__("Rh28"),
    toKey = __webpack_require__("Ubhr");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "INcR":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esUs = moment.defineLocale('es-us', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'MM/DD/YYYY',
        LL : 'MMMM [de] D [de] YYYY',
        LLL : 'MMMM [de] D [de] YYYY h:mm A',
        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return esUs;

})));


/***/ }),

/***/ "ITwD":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("gGqR"),
    isMasked = __webpack_require__("eFps"),
    isObject = __webpack_require__("yCNF"),
    toSource = __webpack_require__("Ai/T");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "Ilb/":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("Kzd6");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "J009":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ "JBKL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = /*@__PURE__*/__webpack_require__("5XgX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty__ = /*@__PURE__*/__webpack_require__("w5lW");
/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */

 // lol

/**
 * Creates an Observable that, on subscribe, calls an Observable factory to
 * make an Observable for each new Observer.
 *
 * <span class="informal">Creates the Observable lazily, that is, only when it
 * is subscribed.
 * </span>
 *
 * <img src="./img/defer.png" width="100%">
 *
 * `defer` allows you to create the Observable only when the Observer
 * subscribes, and create a fresh Observable for each Observer. It waits until
 * an Observer subscribes to it, and then it generates an Observable,
 * typically with an Observable factory function. It does this afresh for each
 * subscriber, so although each subscriber may think it is subscribing to the
 * same Observable, in fact each subscriber gets its own individual
 * Observable.
 *
 * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
 * var clicksOrInterval = Rx.Observable.defer(function () {
 *   if (Math.random() > 0.5) {
 *     return Rx.Observable.fromEvent(document, 'click');
 *   } else {
 *     return Rx.Observable.interval(1000);
 *   }
 * });
 * clicksOrInterval.subscribe(x => console.log(x));
 *
 * // Results in the following behavior:
 * // If the result of Math.random() is greater than 0.5 it will listen
 * // for clicks anywhere on the "document"; when document is clicked it
 * // will log a MouseEvent object to the console. If the result is less
 * // than 0.5 it will emit ascending numbers, one every second(1000ms).
 *
 * @see {@link create}
 *
 * @param {function(): SubscribableOrPromise} observableFactory The Observable
 * factory function to invoke for each Observer that subscribes to the output
 * Observable. May also return a Promise, which will be converted on the fly
 * to an Observable.
 * @return {Observable} An Observable whose Observers' subscriptions trigger
 * an invocation of the given Observable factory function.
 * @static true
 * @name defer
 * @owner Observable
 */
function defer(observableFactory) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? Object(__WEBPACK_IMPORTED_MODULE_1__from__["a" /* from */])(input) : Object(__WEBPACK_IMPORTED_MODULE_2__empty__["b" /* empty */])();
        return source.subscribe(subscriber);
    });
}
//# sourceMappingURL=defer.js.map


/***/ }),

/***/ "JBvZ":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("imBK");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "JDN0":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isArray = __webpack_require__("NGEn"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ "Jqj6":
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__("U7Aq"),
    arrayReduce = __webpack_require__("3rZI"),
    mapToArray = __webpack_require__("WFiI");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),

/***/ "JwiF":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        ss : '%d detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),

/***/ "JyYQ":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("d+aQ"),
    baseMatchesProperty = __webpack_require__("eKBv"),
    identity = __webpack_require__("wSKX"),
    isArray = __webpack_require__("NGEn"),
    property = __webpack_require__("iL3P");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "JzXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_observable__ = /*@__PURE__*/__webpack_require__("V9Cg");
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */

/**
 * Subscribes to an object that implements Symbol.observable with the given
 * Subscriber.
 * @param obj An object that implements Symbol.observable
 */
var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[__WEBPACK_IMPORTED_MODULE_0__symbol_observable__["a" /* observable */]]();
        if (typeof obs.subscribe !== 'function') {
            // Should be caught by observable subscribe function error handling.
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};
//# sourceMappingURL=subscribeToObservable.js.map


/***/ }),

/***/ "K3Sm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concatAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeAll__ = /*@__PURE__*/__webpack_require__("4jp/");
/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */

/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeAll__["a" /* mergeAll */])(1);
}
//# sourceMappingURL=concatAll.js.map


/***/ }),

/***/ "KHsn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = /*@__PURE__*/__webpack_require__("0nHL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs__["x"]; });

//# sourceMappingURL=of.js.map

/***/ }),

/***/ "KgVm":
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__("cdq7"),
    baseIteratee = __webpack_require__("JyYQ"),
    toInteger = __webpack_require__("5Zxu");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ "KmWZ":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("duB3");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "Kzd6":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("qwTf");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "L8MQ":
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__("ktnU"),
    keys = __webpack_require__("ktak");

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ "LC74":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ "LGuY":
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "LHMe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectUnsubscribedError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */

/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var _this = _super.call(this, 'object unsubscribed') || this;
        _this.name = 'ObjectUnsubscribedError';
        Object.setPrototypeOf(_this, ObjectUnsubscribedError.prototype);
        return _this;
    }
    return ObjectUnsubscribedError;
}(Error));






/***/ }),

/***/ "LT9G":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsRegex : monthsRegex,
    monthsShortRegex : monthsRegex,
    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        ss : '%d segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),

/***/ "Lgqo":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        ss : 'තත්පර %d',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),

/***/ "LkuQ":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("v9aJ");

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),

/***/ "Lrp7":
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__("PD94"),
    baseEvery = __webpack_require__("MuA4"),
    baseIteratee = __webpack_require__("JyYQ"),
    isArray = __webpack_require__("NGEn"),
    isIterateeCall = __webpack_require__("zBOP");

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),

/***/ "M1c9":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ "M4fF":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "M6Wl":
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__("rpnb"),
    keys = __webpack_require__("ktak");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ "M96w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var color_picker_service_1 = __webpack_require__("RlMM");
var color_picker_component_1 = __webpack_require__("yCRx");
var ColorPickerDirective = /*@__PURE__*/ (function () {
    function ColorPickerDirective(injector, cfr, appRef, vcRef, elRef, service) {
        this.injector = injector;
        this.cfr = cfr;
        this.appRef = appRef;
        this.vcRef = vcRef;
        this.elRef = elRef;
        this.service = service;
        this.cpPosition = 'right';
        this.cpPositionOffset = '0%';
        this.cpPositionRelativeToArrow = false;
        this.cpOutputFormat = 'hex';
        this.cpPresetLabel = 'Preset colors';
        this.cpPresetEmptyMessage = 'No colors added';
        this.cpPresetEmptyMessageClass = 'preset-empty-message';
        this.cpMaxPresetColorsLength = 6;
        this.cpCancelButton = false;
        this.cpCancelButtonClass = 'cp-cancel-button-class';
        this.cpCancelButtonText = 'Cancel';
        this.cpOKButton = false;
        this.cpOKButtonClass = 'cp-ok-button-class';
        this.cpOKButtonText = 'OK';
        this.cpAddColorButton = false;
        this.cpAddColorButtonClass = 'cp-add-color-button-class';
        this.cpAddColorButtonText = 'Add color';
        this.cpRemoveColorButtonClass = 'cp-remove-color-button-class';
        this.cpFallbackColor = '#fff';
        this.cpHeight = 'auto';
        this.cpWidth = '230px';
        this.cpIgnoredElements = [];
        this.cpDialogDisplay = 'popup';
        this.cpSaveClickOutside = true;
        this.cpAlphaChannel = 'enabled';
        this.cpUseRootViewContainer = false;
        this.cpInputChange = new core_1.EventEmitter(true);
        this.cpToggleChange = new core_1.EventEmitter(true);
        this.cpSliderChange = new core_1.EventEmitter(true);
        this.cpSliderDragEnd = new core_1.EventEmitter(true);
        this.cpSliderDragStart = new core_1.EventEmitter(true);
        this.colorPickerCancel = new core_1.EventEmitter(true);
        this.colorPickerSelect = new core_1.EventEmitter(true);
        this.colorPickerChange = new core_1.EventEmitter(false);
        this.presetColorsChange = new core_1.EventEmitter(true);
        this.ignoreChanges = false;
        this.created = false;
    }
    ColorPickerDirective.prototype.ngOnChanges = function (changes) {
        if (changes.cpToggle) {
            if (changes.cpToggle.currentValue)
                this.openDialog();
            if (!changes.cpToggle.currentValue && this.dialog)
                this.dialog.closeColorPicker();
        }
        if (changes.colorPicker) {
            if (this.dialog && !this.ignoreChanges) {
                if (this.cpDialogDisplay === 'inline') {
                    this.dialog.setInitialColor(changes.colorPicker.currentValue);
                }
                this.dialog.setColorFromString(changes.colorPicker.currentValue, false);
            }
            this.ignoreChanges = false;
        }
        if (changes.cpPresetLabel || changes.cpPresetColors) {
            if (this.dialog) {
                this.dialog.setPresetConfig(this.cpPresetLabel, this.cpPresetColors);
            }
        }
    };
    ColorPickerDirective.prototype.ngOnInit = function () {
        this.colorPicker = this.colorPicker || this.cpFallbackColor || 'rgba(0, 0, 0, 1)';
        /*let hsva = this.service.stringToHsva(this.colorPicker);
        if (hsva === null) hsva = this.service.stringToHsva(this.colorPicker, true);
        if (hsva == null) {
            hsva = this.service.stringToHsva(this.cpFallbackColor);
        }
        let color = this.service.outputFormat(hsva, this.cpOutputFormat, this.cpAlphaChannel);
        if (color !== this.colorPicker) {
            //setTimeout(() => {
              this.colorPickerChange.emit(color);
              this.cdr.detectChanges();
            //}, 0);
        }*/
    };
    ColorPickerDirective.prototype.ngOnDestroy = function () {
        if (this.cmpRef !== undefined) {
            this.cmpRef.destroy();
        }
    };
    ColorPickerDirective.prototype.openDialog = function () {
        this.colorPicker = this.colorPicker || this.cpFallbackColor || 'rgba(0, 0, 0, 1)';
        if (!this.created) {
            this.created = true;
            var vcRef = this.vcRef;
            if (this.cpUseRootViewContainer && this.cpDialogDisplay !== 'inline') {
                var classOfRootComponent = this.appRef.componentTypes[0];
                var appInstance = this.injector.get(classOfRootComponent);
                vcRef = appInstance.vcRef || appInstance.viewContainerRef || this.vcRef;
                if (vcRef === this.vcRef) {
                    console.warn('You are using cpUseRootViewContainer, but the root component is not exposing viewContainerRef!' +
                        'Please expose it by adding \'public vcRef: ViewContainerRef\' to the constructor.');
                }
            }
            var compFactory = this.cfr.resolveComponentFactory(color_picker_component_1.ColorPickerComponent);
            var injector = core_1.ReflectiveInjector.fromResolvedProviders([], vcRef.parentInjector);
            this.cmpRef = vcRef.createComponent(compFactory, 0, injector, []);
            this.cmpRef.instance.setDialog(this, this.elRef, this.colorPicker, this.cpPosition, this.cpPositionOffset, this.cpPositionRelativeToArrow, this.cpOutputFormat, this.cpPresetLabel, this.cpPresetEmptyMessage, this.cpPresetEmptyMessageClass, this.cpPresetColors, this.cpMaxPresetColorsLength, this.cpCancelButton, this.cpCancelButtonClass, this.cpCancelButtonText, this.cpOKButton, this.cpOKButtonClass, this.cpOKButtonText, this.cpAddColorButton, this.cpAddColorButtonClass, this.cpAddColorButtonText, this.cpRemoveColorButtonClass, this.cpHeight, this.cpWidth, this.cpIgnoredElements, this.cpDialogDisplay, this.cpSaveClickOutside, this.cpAlphaChannel, this.cpUseRootViewContainer);
            this.dialog = this.cmpRef.instance;
            if (this.vcRef !== vcRef) {
                this.cmpRef.changeDetectorRef.detectChanges();
            }
        }
        else if (this.dialog) {
            this.dialog.openDialog(this.colorPicker);
        }
    };
    ColorPickerDirective.prototype.toggle = function (value) {
        this.cpToggleChange.emit(value);
    };
    ColorPickerDirective.prototype.colorChanged = function (value, ignore) {
        if (ignore === void 0) {
            ignore = true;
        }
        this.ignoreChanges = ignore;
        this.colorPickerChange.emit(value);
    };
    ColorPickerDirective.prototype.colorCanceled = function () {
        this.colorPickerCancel.emit();
    };
    ColorPickerDirective.prototype.colorSelected = function (value) {
        this.colorPickerSelect.emit(value);
    };
    ColorPickerDirective.prototype.presetColorsChanged = function (value) {
        this.presetColorsChange.emit(value);
    };
    ColorPickerDirective.prototype.inputFocus = function () {
        var _this = this;
        if (this.cpIgnoredElements.filter(function (item) { return item === _this.elRef.nativeElement; }).length === 0) {
            this.openDialog();
        }
    };
    ColorPickerDirective.prototype.inputChange = function (value) {
        if (this.dialog) {
            this.dialog.setColorFromString(value, true);
        }
        else {
            this.colorPicker = value || this.cpFallbackColor || 'rgba(0, 0, 0, 1)';
            this.colorPickerChange.emit(this.colorPicker);
        }
    };
    ColorPickerDirective.prototype.inputChanged = function (event) {
        this.cpInputChange.emit(event);
    };
    ColorPickerDirective.prototype.sliderChanged = function (event) {
        this.cpSliderChange.emit(event);
    };
    ColorPickerDirective.prototype.sliderDragEnd = function (event) {
        this.cpSliderDragEnd.emit(event);
    };
    ColorPickerDirective.prototype.sliderDragStart = function (event) {
        this.cpSliderDragStart.emit(event);
    };
    ColorPickerDirective.decorators = [
        { type: core_1.Directive, args: [{
                    selector: '[colorPicker]',
                    host: {
                        '(click)': 'inputFocus()',
                        '(focus)': 'inputFocus()',
                        '(input)': 'inputChange($event.target.value)'
                    }
                },] },
    ];
    ColorPickerDirective.propDecorators = {
        'colorPicker': [{ type: core_1.Input, args: ['colorPicker',] },],
        'cpToggle': [{ type: core_1.Input, args: ['cpToggle',] },],
        'cpPosition': [{ type: core_1.Input, args: ['cpPosition',] },],
        'cpPositionOffset': [{ type: core_1.Input, args: ['cpPositionOffset',] },],
        'cpPositionRelativeToArrow': [{ type: core_1.Input, args: ['cpPositionRelativeToArrow',] },],
        'cpOutputFormat': [{ type: core_1.Input, args: ['cpOutputFormat',] },],
        'cpPresetLabel': [{ type: core_1.Input, args: ['cpPresetLabel',] },],
        'cpPresetEmptyMessage': [{ type: core_1.Input, args: ['cpPresetEmptyMessage',] },],
        'cpPresetEmptyMessageClass': [{ type: core_1.Input, args: ['cpPresetEmptyMessageClass',] },],
        'cpPresetColors': [{ type: core_1.Input, args: ['cpPresetColors',] },],
        'cpMaxPresetColorsLength': [{ type: core_1.Input, args: ['cpMaxPresetColorsLength',] },],
        'cpCancelButton': [{ type: core_1.Input, args: ['cpCancelButton',] },],
        'cpCancelButtonClass': [{ type: core_1.Input, args: ['cpCancelButtonClass',] },],
        'cpCancelButtonText': [{ type: core_1.Input, args: ['cpCancelButtonText',] },],
        'cpOKButton': [{ type: core_1.Input, args: ['cpOKButton',] },],
        'cpOKButtonClass': [{ type: core_1.Input, args: ['cpOKButtonClass',] },],
        'cpOKButtonText': [{ type: core_1.Input, args: ['cpOKButtonText',] },],
        'cpAddColorButton': [{ type: core_1.Input, args: ['cpAddColorButton',] },],
        'cpAddColorButtonClass': [{ type: core_1.Input, args: ['cpAddColorButtonClass',] },],
        'cpAddColorButtonText': [{ type: core_1.Input, args: ['cpAddColorButtonText',] },],
        'cpRemoveColorButtonClass': [{ type: core_1.Input, args: ['cpRemoveColorButtonClass',] },],
        'cpFallbackColor': [{ type: core_1.Input, args: ['cpFallbackColor',] },],
        'cpHeight': [{ type: core_1.Input, args: ['cpHeight',] },],
        'cpWidth': [{ type: core_1.Input, args: ['cpWidth',] },],
        'cpIgnoredElements': [{ type: core_1.Input, args: ['cpIgnoredElements',] },],
        'cpDialogDisplay': [{ type: core_1.Input, args: ['cpDialogDisplay',] },],
        'cpSaveClickOutside': [{ type: core_1.Input, args: ['cpSaveClickOutside',] },],
        'cpAlphaChannel': [{ type: core_1.Input, args: ['cpAlphaChannel',] },],
        'cpUseRootViewContainer': [{ type: core_1.Input, args: ['cpUseRootViewContainer',] },],
        'cpInputChange': [{ type: core_1.Output, args: ['cpInputChange',] },],
        'cpToggleChange': [{ type: core_1.Output, args: ['cpToggleChange',] },],
        'cpSliderChange': [{ type: core_1.Output, args: ['cpSliderChange',] },],
        'cpSliderDragEnd': [{ type: core_1.Output, args: ['cpSliderDragEnd',] },],
        'cpSliderDragStart': [{ type: core_1.Output, args: ['cpSliderDragStart',] },],
        'colorPickerCancel': [{ type: core_1.Output, args: ['colorPickerCancel',] },],
        'colorPickerSelect': [{ type: core_1.Output, args: ['colorPickerSelect',] },],
        'colorPickerChange': [{ type: core_1.Output, args: ['colorPickerChange',] },],
        'presetColorsChange': [{ type: core_1.Output, args: ['cpPresetColorsChange',] },],
    };
    return ColorPickerDirective;
}());
exports.ColorPickerDirective = ColorPickerDirective;



/***/ }),

/***/ "MnTv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = of;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isScheduler__ = /*@__PURE__*/__webpack_require__("5eyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromArray__ = /*@__PURE__*/__webpack_require__("b2EL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty__ = /*@__PURE__*/__webpack_require__("w5lW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scalar__ = /*@__PURE__*/__webpack_require__("9vdN");
/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_empty,_scalar PURE_IMPORTS_END */




function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
        args.pop();
    }
    else {
        scheduler = undefined;
    }
    switch (args.length) {
        case 0:
            return Object(__WEBPACK_IMPORTED_MODULE_2__empty__["b" /* empty */])(scheduler);
        case 1:
            return scheduler ? Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* fromArray */])(args, scheduler) : Object(__WEBPACK_IMPORTED_MODULE_3__scalar__["a" /* scalar */])(args[0]);
        default:
            return Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* fromArray */])(args, scheduler);
    }
}
//# sourceMappingURL=of.js.map


/***/ }),

/***/ "MoMe":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("FCuZ"),
    getSymbols = __webpack_require__("l9Lx"),
    keys = __webpack_require__("ktak");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "MuA4":
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__("v9aJ");

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),

/***/ "N3vo":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        ss : '%d ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),

/***/ "NG/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReplaySubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = /*@__PURE__*/__webpack_require__("tUzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_queue__ = /*@__PURE__*/__webpack_require__("0gQV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operators_observeOn__ = /*@__PURE__*/__webpack_require__("XtZC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ObjectUnsubscribedError__ = /*@__PURE__*/__webpack_require__("LHMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubjectSubscription__ = /*@__PURE__*/__webpack_require__("7HNm");
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */







/**
 * @class ReplaySubject<T>
 */
var ReplaySubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
            bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
            windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        var _events = this._events;
        _events.push(value);
        // Since this method is invoked in every next() call than the buffer
        // can overgrow the max size only by one item
        if (_events.length > this._bufferSize) {
            _events.shift();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        this._events.push(new ReplayEvent(this._getNow(), value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    ReplaySubject.prototype._subscribe = function (subscriber) {
        // When `_infiniteTimeWindow === true` then the buffer is already trimmed
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_5__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else if (this.isStopped || this.hasError) {
            subscription = __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new __WEBPACK_IMPORTED_MODULE_6__SubjectSubscription__["a" /* SubjectSubscription */](this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new __WEBPACK_IMPORTED_MODULE_4__operators_observeOn__["a" /* ObserveOnSubscriber */](subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || __WEBPACK_IMPORTED_MODULE_2__scheduler_queue__["a" /* queue */]).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["b" /* Subject */]));

var ReplayEvent = /*@__PURE__*/ (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());





/***/ }),

/***/ "NGEn":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "NGRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_empty__ = /*@__PURE__*/__webpack_require__("w5lW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_of__ = /*@__PURE__*/__webpack_require__("MnTv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_throwError__ = /*@__PURE__*/__webpack_require__("G0Bs");
/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */



/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Object(__WEBPACK_IMPORTED_MODULE_1__observable_of__["a" /* of */])(this.value);
            case 'E':
                return Object(__WEBPACK_IMPORTED_MODULE_2__observable_throwError__["a" /* throwError */])(this.error);
            case 'C':
                return Object(__WEBPACK_IMPORTED_MODULE_0__observable_empty__["b" /* empty */])();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     * @nocollapse
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     * @nocollapse
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     * @nocollapse
     */
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());






/***/ }),

/***/ "NTqS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Hot Module Replacement
__export(__webpack_require__("CUT0"));
__export(__webpack_require__("wZJE"));
__export(__webpack_require__("vRV5"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "Nd3h":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        ss : '%d sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),

/***/ "NkRn":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "Nkkh":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("tv3T"),
    getSymbols = __webpack_require__("l9Lx");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "Nlnz":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        ss : '%d సెకన్లు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),

/***/ "NqZt":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "NtYx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = /*@__PURE__*/ __webpack_require__("TToO").__decorate;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var ObjectUtils = /*@__PURE__*/ (function () {
    function ObjectUtils() {
    }
    ObjectUtils.prototype.equals = function (obj1, obj2, field) {
        if (field)
            return (this.resolveFieldData(obj1, field) === this.resolveFieldData(obj2, field));
        else
            return this.equalsByValue(obj1, obj2);
    };
    ObjectUtils.prototype.equalsByValue = function (obj1, obj2, visited) {
        if (obj1 == null && obj2 == null) {
            return true;
        }
        if (obj1 == null || obj2 == null) {
            return false;
        }
        if (obj1 == obj2) {
            return true;
        }
        if (typeof obj1 == 'object' && typeof obj2 == 'object') {
            if (visited) {
                if (visited.indexOf(obj1) !== -1)
                    return false;
            }
            else {
                visited = [];
            }
            visited.push(obj1);
            for (var p in obj1) {
                if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
                    return false;
                }
                switch (typeof (obj1[p])) {
                    case 'object':
                        if (!this.equalsByValue(obj1[p], obj2[p], visited))
                            return false;
                        break;
                    case 'function':
                        if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString()))
                            return false;
                        break;
                    default:
                        if (obj1[p] != obj2[p])
                            return false;
                        break;
                }
            }
            for (var p in obj2) {
                if (typeof (obj1[p]) == 'undefined')
                    return false;
            }
            delete obj1._$visited;
            return true;
        }
        return false;
    };
    ObjectUtils.prototype.resolveFieldData = function (data, field) {
        if (data && field) {
            if (field.indexOf('.') == -1) {
                return data[field];
            }
            else {
                var fields = field.split('.');
                var value = data;
                for (var i = 0, len = fields.length; i < len; ++i) {
                    if (value == null) {
                        return null;
                    }
                    value = value[fields[i]];
                }
                return value;
            }
        }
        else {
            return null;
        }
    };
    ObjectUtils.prototype.filter = function (value, fields, filterValue) {
        var filteredItems = [];
        if (value) {
            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                var item = value_1[_i];
                for (var _a = 0, fields_1 = fields; _a < fields_1.length; _a++) {
                    var field = fields_1[_a];
                    if (String(this.resolveFieldData(item, field)).toLowerCase().indexOf(filterValue.toLowerCase()) > -1) {
                        filteredItems.push(item);
                        break;
                    }
                }
            }
        }
        return filteredItems;
    };
    ObjectUtils.prototype.reorderArray = function (value, from, to) {
        var target;
        if (value && (from !== to)) {
            if (to >= value.length) {
                target = to - value.length;
                while ((target--) + 1) {
                    value.push(undefined);
                }
            }
            value.splice(to, 0, value.splice(from, 1)[0]);
        }
    };
    ObjectUtils.prototype.generateSelectItems = function (val, field) {
        var selectItems;
        if (val && val.length) {
            selectItems = [];
            for (var _i = 0, val_1 = val; _i < val_1.length; _i++) {
                var item = val_1[_i];
                selectItems.push({ label: this.resolveFieldData(item, field), value: item });
            }
        }
        return selectItems;
    };
    ObjectUtils.prototype.insertIntoOrderedArray = function (item, index, arr, sourceArr) {
        if (arr.length > 0) {
            var injected = false;
            for (var i = 0; i < arr.length; i++) {
                var currentItemIndex = this.findIndexInList(arr[i], sourceArr);
                if (currentItemIndex > index) {
                    arr.splice(i, 0, item);
                    injected = true;
                    break;
                }
            }
            if (!injected) {
                arr.push(item);
            }
        }
        else {
            arr.push(item);
        }
    };
    ObjectUtils.prototype.findIndexInList = function (item, list) {
        var index = -1;
        if (list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i] == item) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    };
    ObjectUtils = __decorate([
        core_1.Injectable()
    ], ObjectUtils);
    return ObjectUtils;
}());
exports.ObjectUtils = ObjectUtils;



/***/ }),

/***/ "Nyrq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/tryCatch.js
var tryCatch = __webpack_require__("H74/");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/errorObject.js
var errorObject = __webpack_require__("SQxw");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/OuterSubscriber.js
var OuterSubscriber = __webpack_require__("1E73");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js
var subscribeToResult = __webpack_require__("3SjU");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/audit.js
/** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */
function audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new AuditOperator(durationSelector));
    };
}
var AuditOperator = /*@__PURE__*/ (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new audit_AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var audit_AuditSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        return _this;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = Object(tryCatch["a" /* tryCatch */])(this.durationSelector)(value);
            if (duration === errorObject["a" /* errorObject */]) {
                this.destination.error(errorObject["a" /* errorObject */].e);
            }
            else {
                var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, duration);
                if (!innerSubscription || innerSubscription.closed) {
                    this.clearThrottle();
                }
                else {
                    this.add(this.throttled = innerSubscription);
                }
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/async.js
var scheduler_async = __webpack_require__("QX4X");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/timer.js
var timer = __webpack_require__("cCSk");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/auditTime.js
/** PURE_IMPORTS_START _scheduler_async,_audit,_observable_timer PURE_IMPORTS_END */



/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */
function auditTime(duration, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return audit(function () { return Object(timer["a" /* timer */])(duration, scheduler); });
}
//# sourceMappingURL=auditTime.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/buffer.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */
function buffer_buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
var BufferOperator = /*@__PURE__*/ (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new buffer_BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var buffer_BufferSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        var _this = _super.call(this, destination) || this;
        _this.buffer = [];
        _this.add(Object(subscribeToResult["a" /* subscribeToResult */])(_this, closingNotifier));
        return _this;
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscriber.js
var Subscriber = __webpack_require__("p1Bo");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/bufferCount.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) {
        startBufferEvery = null;
    }
    return function bufferCountOperatorFunction(source) {
        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
    };
}
var BufferCountOperator = /*@__PURE__*/ (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = bufferCount_BufferCountSubscriber;
        }
        else {
            this.subscriberClass = bufferCount_BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var bufferCount_BufferCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.buffer = [];
        return _this;
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(Subscriber["a" /* Subscriber */]));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var bufferCount_BufferSkipCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        var _this = _super.call(this, destination) || this;
        _this.bufferSize = bufferSize;
        _this.startBufferEvery = startBufferEvery;
        _this.buffers = [];
        _this.count = 0;
        return _this;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isScheduler.js
var isScheduler = __webpack_require__("5eyr");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/bufferTime.js
/** PURE_IMPORTS_START tslib,_scheduler_async,_Subscriber,_util_isScheduler PURE_IMPORTS_END */




/* tslint:enable:max-line-length */
/**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = scheduler_async["a" /* async */];
    if (Object(isScheduler["a" /* isScheduler */])(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
var BufferTimeOperator = /*@__PURE__*/ (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new bufferTime_BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = /*@__PURE__*/ (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var bufferTime_BufferTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.bufferTimeSpan = bufferTimeSpan;
        _this.bufferCreationInterval = bufferCreationInterval;
        _this.maxBufferSize = maxBufferSize;
        _this.scheduler = scheduler;
        _this.contexts = [];
        var context = _this.openContext();
        _this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (_this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: _this, context: context, bufferTimeSpan: bufferTimeSpan };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: _this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
        return _this;
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context_1 = contexts[i];
            var buffer = context_1.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context_1;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            destination.next(context_2.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__("HC03");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/bufferToggle.js
/** PURE_IMPORTS_START tslib,_Subscription,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */




/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */
function bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new BufferToggleOperator(openings, closingSelector));
    };
}
var BufferToggleOperator = /*@__PURE__*/ (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new bufferToggle_BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var bufferToggle_BufferToggleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(Object(subscribeToResult["a" /* subscribeToResult */])(_this, openings));
        return _this;
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_1 = contexts.shift();
            context_1.subscription.unsubscribe();
            context_1.buffer = null;
            context_1.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context_2 = contexts.shift();
            this.destination.next(context_2.buffer);
            context_2.subscription.unsubscribe();
            context_2.buffer = null;
            context_2.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new Subscription["a" /* Subscription */]();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/bufferWhen.js
/** PURE_IMPORTS_START tslib,_Subscription,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return function (source) {
        return source.lift(new BufferWhenOperator(closingSelector));
    };
}
var BufferWhenOperator = /*@__PURE__*/ (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new bufferWhen_BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var bufferWhen_BufferWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.closingSelector = closingSelector;
        _this.subscribing = false;
        _this.openBuffer();
        return _this;
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier = Object(tryCatch["a" /* tryCatch */])(this.closingSelector)();
        if (closingNotifier === errorObject["a" /* errorObject */]) {
            this.error(errorObject["a" /* errorObject */].e);
        }
        else {
            closingSubscription = new Subscription["a" /* Subscription */]();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/catchError.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */
function catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new CatchOperator(selector);
        var caught = source.lift(operator);
        return (operator.caught = caught);
    };
}
var CatchOperator = /*@__PURE__*/ (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new catchError_CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var catchError_CatchSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        var _this = _super.call(this, destination) || this;
        _this.selector = selector;
        _this.caught = caught;
        return _this;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, result));
        }
    };
    return CatchSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js
var combineLatest = __webpack_require__("jAXq");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/combineAll.js
/** PURE_IMPORTS_START _observable_combineLatest PURE_IMPORTS_END */

function combineAll(project) {
    return function (source) { return source.lift(new combineLatest["a" /* CombineLatestOperator */](project)); };
}
//# sourceMappingURL=combineAll.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArray.js
var isArray = __webpack_require__("YgML");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/from.js + 1 modules
var from = __webpack_require__("5XgX");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/combineLatest.js
/** PURE_IMPORTS_START _util_isArray,_observable_combineLatest,_observable_from PURE_IMPORTS_END */



var none = {};
/* tslint:enable:max-line-length */
/**
 * @deprecated Deprecated in favor of static combineLatest.
 */
function combineLatest_combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && Object(isArray["a" /* isArray */])(observables[0])) {
        observables = observables[0].slice();
    }
    return function (source) { return source.lift.call(Object(from["a" /* from */])([source].concat(observables)), new combineLatest["a" /* CombineLatestOperator */](project)); };
}
//# sourceMappingURL=combineLatest.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/concat.js
var concat = __webpack_require__("S/xh");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/concat.js
/** PURE_IMPORTS_START _observable_concat PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * @deprecated Deprecated in favor of static concat.
 */
function concat_concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(concat["a" /* concat */].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=concat.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/concatAll.js
var concatAll = __webpack_require__("K3Sm");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/mergeMap.js
var mergeMap = __webpack_require__("/Kc/");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/concatMap.js
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return Object(mergeMap["a" /* mergeMap */])(project, resultSelector, 1);
}
//# sourceMappingURL=concatMap.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/concatMapTo.js
/** PURE_IMPORTS_START _concatMap PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return concatMap(function () { return innerObservable; }, resultSelector);
}
//# sourceMappingURL=concatMapTo.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/count.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */
function count_count(predicate) {
    return function (source) { return source.lift(new CountOperator(predicate, source)); };
}
var CountOperator = /*@__PURE__*/ (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new count_CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var count_CountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.count = 0;
        _this.index = 0;
        return _this;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/debounce.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */
function debounce(durationSelector) {
    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
}
var DebounceOperator = /*@__PURE__*/ (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new debounce_DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var debounce_DebounceSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.durationSelector = durationSelector;
        _this.hasValue = false;
        _this.durationSubscription = null;
        return _this;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, duration);
        if (subscription && !subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            // This must be done *before* passing the value
            // along to the destination because it's possible for
            // the value to synchronously re-enter this operator
            // recursively if the duration selector Observable
            // emits synchronously
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/debounceTime.js
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
}
var DebounceTimeOperator = /*@__PURE__*/ (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new debounceTime_DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var debounceTime_DebounceTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.dueTime = dueTime;
        _this.scheduler = scheduler;
        _this.debouncedSubscription = null;
        _this.lastValue = null;
        _this.hasValue = false;
        return _this;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            var lastValue = this.lastValue;
            // This must be done *before* passing the value
            // along to the destination because it's possible for
            // the value to synchronously re-enter this operator
            // recursively when scheduled with things like
            // VirtualScheduler/TestScheduler.
            this.lastValue = null;
            this.hasValue = false;
            this.destination.next(lastValue);
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/defaultIfEmpty.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/* tslint:enable:max-line-length */
/**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) {
        defaultValue = null;
    }
    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
}
var DefaultIfEmptyOperator = /*@__PURE__*/ (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new defaultIfEmpty_DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var defaultIfEmpty_DefaultIfEmptySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isDate.js
var isDate = __webpack_require__("1SoI");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Notification.js
var Notification = __webpack_require__("NGRO");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/delay.js
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_Subscriber,_Notification PURE_IMPORTS_END */





/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay_delay(delay, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    var absoluteDelay = Object(isDate["a" /* isDate */])(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
}
var DelayOperator = /*@__PURE__*/ (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new delay_DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var delay_DelaySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.delay = delay;
        _this.scheduler = scheduler;
        _this.queue = [];
        _this.active = false;
        _this.errored = false;
        return _this;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(Notification["a" /* Notification */].createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(Notification["a" /* Notification */].createComplete());
    };
    return DelaySubscriber;
}(Subscriber["a" /* Subscriber */]));
var DelayMessage = /*@__PURE__*/ (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js
var Observable = __webpack_require__("lWPP");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/delayWhen.js
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return function (source) {
            return new delayWhen_SubscriptionDelayObservable(source, subscriptionDelay)
                .lift(new DelayWhenOperator(delayDurationSelector));
        };
    }
    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
}
var DelayWhenOperator = /*@__PURE__*/ (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new delayWhen_DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var delayWhen_DelayWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        var _this = _super.call(this, destination) || this;
        _this.delayDurationSelector = delayDurationSelector;
        _this.completed = false;
        _this.delayNotifierSubscriptions = [];
        _this.values = [];
        return _this;
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var delayWhen_SubscriptionDelayObservable = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subscriptionDelay = subscriptionDelay;
        return _this;
    }
    /** @deprecated This is an internal implementation detail, do not use. */
    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new delayWhen_SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(Observable["a" /* Observable */]));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var delayWhen_SubscriptionDelaySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.source = source;
        _this.sourceSubscribed = false;
        return _this;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/dematerialize.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */
function dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new DeMaterializeOperator());
    };
}
var DeMaterializeOperator = /*@__PURE__*/ (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new dematerialize_DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var dematerialize_DeMaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinct.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */
function distinct(keySelector, flushes) {
    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
}
var DistinctOperator = /*@__PURE__*/ (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new distinct_DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var distinct_DistinctSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.values = new Set();
        if (flushes) {
            _this.add(Object(subscribeToResult["a" /* subscribeToResult */])(_this, flushes));
        }
        return _this;
    }
    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_tryCatch,_util_errorObject PURE_IMPORTS_END */




/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
}
var DistinctUntilChangedOperator = /*@__PURE__*/ (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new distinctUntilChanged_DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var distinctUntilChanged_DistinctUntilChangedSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.hasKey = false;
        if (typeof compare === 'function') {
            _this.compare = compare;
        }
        return _this;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = Object(tryCatch["a" /* tryCatch */])(this.keySelector)(value);
            if (key === errorObject["a" /* errorObject */]) {
                return this.destination.error(errorObject["a" /* errorObject */].e);
            }
        }
        var result = false;
        if (this.hasKey) {
            result = Object(tryCatch["a" /* tryCatch */])(this.compare)(this.key, key);
            if (result === errorObject["a" /* errorObject */]) {
                return this.destination.error(errorObject["a" /* errorObject */].e);
            }
        }
        else {
            this.hasKey = true;
        }
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilKeyChanged.js
/** PURE_IMPORTS_START _distinctUntilChanged PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */
function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
}
//# sourceMappingURL=distinctUntilKeyChanged.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js
var ArgumentOutOfRangeError = __webpack_require__("uxTV");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/filter.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new filter_FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var filter_FilterSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/noop.js
var noop = __webpack_require__("VWaN");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isFunction.js
var isFunction = __webpack_require__("bOhj");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/tap.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_noop,_util_isFunction PURE_IMPORTS_END */




/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */
function tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new DoOperator(nextOrObserver, error, complete));
    };
}
var DoOperator = /*@__PURE__*/ (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new tap_TapSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var tap_TapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](TapSubscriber, _super);
    function TapSubscriber(destination, observerOrNext, error, complete) {
        var _this = _super.call(this, destination) || this;
        _this._tapNext = noop["a" /* noop */];
        _this._tapError = noop["a" /* noop */];
        _this._tapComplete = noop["a" /* noop */];
        _this._tapError = error || noop["a" /* noop */];
        _this._tapComplete = complete || noop["a" /* noop */];
        if (Object(isFunction["a" /* isFunction */])(observerOrNext)) {
            _this._context = _this;
            _this._tapNext = observerOrNext;
        }
        else if (observerOrNext) {
            _this._context = observerOrNext;
            _this._tapNext = observerOrNext.next || noop["a" /* noop */];
            _this._tapError = observerOrNext.error || noop["a" /* noop */];
            _this._tapComplete = observerOrNext.complete || noop["a" /* noop */];
        }
        return _this;
    }
    TapSubscriber.prototype._next = function (value) {
        try {
            this._tapNext.call(this._context, value);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(value);
    };
    TapSubscriber.prototype._error = function (err) {
        try {
            this._tapError.call(this._context, err);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.error(err);
    };
    TapSubscriber.prototype._complete = function () {
        try {
            this._tapComplete.call(this._context);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        return this.destination.complete();
    };
    return TapSubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/EmptyError.js
var EmptyError = __webpack_require__("/Nc3");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/throwIfEmpty.js
/** PURE_IMPORTS_START _tap,_util_EmptyError PURE_IMPORTS_END */


/**
 * If the source observable completes without emitting a value, it will emit
 * an error. The error will be created at that time by the optional
 * `errorFactory` argument, otherwise, the error will be {@link ErrorEmpty}.
 *
 * @example
 *
 * const click$ = fromEvent(button, 'click');
 *
 * clicks$.pipe(
 *   takeUntil(timer(1000)),
 *   throwIfEmpty(
 *     () => new Error('the button was not clicked within 1 second')
 *   ),
 * )
 * .subscribe({
 *   next() { console.log('The button was clicked'); },
 *   error(err) { console.error(err); },
 * });
 * @param {Function} [errorFactory] A factory function called to produce the
 * error to be thrown when the source observable completes without emitting a
 * value.
 */
var throwIfEmpty = function (errorFactory) {
    if (errorFactory === void 0) {
        errorFactory = defaultErrorFactory;
    }
    return tap({
        hasValue: false,
        next: function () { this.hasValue = true; },
        complete: function () {
            if (!this.hasValue) {
                throw errorFactory();
            }
        }
    });
};
function defaultErrorFactory() {
    return new EmptyError["a" /* EmptyError */]();
}
//# sourceMappingURL=throwIfEmpty.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/empty.js
var empty = __webpack_require__("w5lW");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/take.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    return function (source) {
        if (count === 0) {
            return Object(empty["b" /* empty */])();
        }
        else {
            return source.lift(new take_TakeOperator(count));
        }
    };
}
var take_TakeOperator = /*@__PURE__*/ (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */];
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new take_TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var take_TakeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/elementAt.js
/** PURE_IMPORTS_START _util_ArgumentOutOfRangeError,_filter,_throwIfEmpty,_defaultIfEmpty,_take PURE_IMPORTS_END */





/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */
function elementAt(index, defaultValue) {
    if (index < 0) {
        throw new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */]();
    }
    var hasDefaultValue = arguments.length >= 2;
    return function (source) {
        return source.pipe(filter(function (v, i) { return i === index; }), take(1), hasDefaultValue
            ? defaultIfEmpty(defaultValue)
            : throwIfEmpty(function () { return new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */](); }));
    };
}
//# sourceMappingURL=elementAt.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/every.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */
function every(predicate, thisArg) {
    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
}
var EveryOperator = /*@__PURE__*/ (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new every_EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var every_EverySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.source = source;
        _this.index = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/exhaust.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */
function exhaust() {
    return function (source) { return source.lift(new SwitchFirstOperator()); };
}
var SwitchFirstOperator = /*@__PURE__*/ (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new exhaust_SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var exhaust_SwitchFirstSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasCompleted = false;
        _this.hasSubscription = false;
        return _this;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/map.js
var map = __webpack_require__("rylm");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/exhaustMap.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */





/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */
function exhaustMap(project, resultSelector) {
    if (resultSelector) {
        // DEPRECATED PATH
        return function (source) { return source.pipe(exhaustMap(function (a, i) { return Object(from["a" /* from */])(project(a, i)).pipe(Object(map["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) {
        return source.lift(new ExhauseMapOperator(project));
    };
}
var ExhauseMapOperator = /*@__PURE__*/ (function () {
    function ExhauseMapOperator(project) {
        this.project = project;
    }
    ExhauseMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new exhaustMap_ExhaustMapSubscriber(subscriber, this.project));
    };
    return ExhauseMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var exhaustMap_ExhaustMapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](ExhaustMapSubscriber, _super);
    function ExhaustMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.hasSubscription = false;
        _this.hasCompleted = false;
        _this.index = 0;
        return _this;
    }
    ExhaustMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    ExhaustMapSubscriber.prototype.tryNext = function (value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, result, value, index));
        }
        catch (err) {
            destination.error(err);
        }
    };
    ExhaustMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    ExhaustMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    ExhaustMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    ExhaustMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return ExhaustMapSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/expand.js
/** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





/* tslint:enable:max-line-length */
/**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (scheduler === void 0) {
        scheduler = undefined;
    }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
}
var ExpandOperator = /*@__PURE__*/ (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new expand_ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var expand_ExpandSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.scheduler = scheduler;
        _this.index = 0;
        _this.active = 0;
        _this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            _this.buffer = [];
        }
        return _this;
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = Object(tryCatch["a" /* tryCatch */])(this.project)(value, index);
            if (result === errorObject["a" /* errorObject */]) {
                destination.error(errorObject["a" /* errorObject */].e);
            }
            else if (!this.scheduler) {
                this.subscribeToProjection(result, value, index);
            }
            else {
                var state = { subscriber: this, result: result, value: value, index: index };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        this.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/finalize.js
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription PURE_IMPORTS_END */



/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */
function finalize(callback) {
    return function (source) { return source.lift(new FinallyOperator(callback)); };
}
var FinallyOperator = /*@__PURE__*/ (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new finalize_FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var finalize_FinallySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        var _this = _super.call(this, destination) || this;
        _this.add(new Subscription["a" /* Subscription */](callback));
        return _this;
    }
    return FinallySubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/find.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */
function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
}
var FindValueOperator = /*@__PURE__*/ (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new find_FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var find_FindValueSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.yieldIndex = yieldIndex;
        _this.thisArg = thisArg;
        _this.index = 0;
        return _this;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(Subscriber["a" /* Subscriber */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/findIndex.js
/** PURE_IMPORTS_START _operators_find PURE_IMPORTS_END */

/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */
function findIndex(predicate, thisArg) {
    return function (source) { return source.lift(new FindValueOperator(predicate, source, true, thisArg)); };
}
//# sourceMappingURL=findIndex.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/identity.js
var identity = __webpack_require__("92UZ");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/first.js
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */






/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? filter(function (v, i) { return predicate(v, i, source); }) : identity["a" /* identity */], take(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError["a" /* EmptyError */](); })); };
}
//# sourceMappingURL=first.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/groupBy.js
var groupBy = __webpack_require__("SYCm");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/ignoreElements.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */
function ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new IgnoreElementsOperator());
    };
}
var IgnoreElementsOperator = /*@__PURE__*/ (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ignoreElements_IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ignoreElements_IgnoreElementsSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
        // Do nothing
    };
    return IgnoreElementsSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/isEmpty.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


function isEmpty() {
    return function (source) { return source.lift(new IsEmptyOperator()); };
}
var IsEmptyOperator = /*@__PURE__*/ (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new isEmpty_IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var isEmpty_IsEmptySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/takeLast.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */




/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.pipe(takeLast(3));
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */
function takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) {
            return Object(empty["b" /* empty */])();
        }
        else {
            return source.lift(new takeLast_TakeLastOperator(count));
        }
    };
}
var takeLast_TakeLastOperator = /*@__PURE__*/ (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */];
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new takeLast_TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var takeLast_TakeLastSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.ring = new Array();
        _this.count = 0;
        return _this;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/last.js
/** PURE_IMPORTS_START _util_EmptyError,_filter,_takeLast,_throwIfEmpty,_defaultIfEmpty,_util_identity PURE_IMPORTS_END */






/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} [predicate] - The condition any source emitted item has to satisfy.
 * @param {any} [defaultValue] - An optional default value to provide if last
 * predicate isn't met or no values were emitted.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 */
function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function (source) { return source.pipe(predicate ? filter(function (v, i) { return predicate(v, i, source); }) : identity["a" /* identity */], takeLast(1), hasDefaultValue ? defaultIfEmpty(defaultValue) : throwIfEmpty(function () { return new EmptyError["a" /* EmptyError */](); })); };
}
//# sourceMappingURL=last.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/mapTo.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
    return function (source) { return source.lift(new MapToOperator(value)); };
}
var MapToOperator = /*@__PURE__*/ (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new mapTo_MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var mapTo_MapToSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        var _this = _super.call(this, destination) || this;
        _this.value = value;
        return _this;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/materialize.js
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */
function materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new MaterializeOperator());
    };
}
var MaterializeOperator = /*@__PURE__*/ (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new materialize_MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var materialize_MaterializeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(Notification["a" /* Notification */].createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(Notification["a" /* Notification */].createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(Notification["a" /* Notification */].createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/scan.js
var scan = __webpack_require__("Td+O");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/pipe.js
var pipe = __webpack_require__("eYUY");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/reduce.js
/** PURE_IMPORTS_START _scan,_takeLast,_defaultIfEmpty,_util_pipe PURE_IMPORTS_END */




/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */
function reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        return function reduceOperatorFunctionWithSeed(source) {
            return Object(pipe["a" /* pipe */])(Object(scan["a" /* scan */])(accumulator, seed), takeLast(1), defaultIfEmpty(seed))(source);
        };
    }
    return function reduceOperatorFunction(source) {
        return Object(pipe["a" /* pipe */])(Object(scan["a" /* scan */])(function (acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), takeLast(1))(source);
    };
}
//# sourceMappingURL=reduce.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/max.js
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */
function max_max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return reduce(max);
}
//# sourceMappingURL=max.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/merge.js
var merge = __webpack_require__("im1K");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/merge.js
/** PURE_IMPORTS_START _observable_merge PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * @deprecated Deprecated in favor of static merge.
 */
function merge_merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function (source) { return source.lift.call(merge["a" /* merge */].apply(void 0, [source].concat(observables))); };
}
//# sourceMappingURL=merge.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/mergeAll.js
var mergeAll = __webpack_require__("4jp/");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/mergeMapTo.js
/** PURE_IMPORTS_START _mergeMap PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable`
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return Object(mergeMap["a" /* mergeMap */])(function () { return innerObservable; }, resultSelector, concurrent);
    }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return Object(mergeMap["a" /* mergeMap */])(function () { return innerObservable; }, concurrent);
}
//# sourceMappingURL=mergeMapTo.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/mergeScan.js
/** PURE_IMPORTS_START tslib,_util_tryCatch,_util_errorObject,_util_subscribeToResult,_OuterSubscriber PURE_IMPORTS_END */





/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
}
var MergeScanOperator = /*@__PURE__*/ (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new mergeScan_MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var mergeScan_MergeScanSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this.acc = acc;
        _this.concurrent = concurrent;
        _this.hasValue = false;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = Object(tryCatch["a" /* tryCatch */])(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === errorObject["a" /* errorObject */]) {
                destination.error(errorObject["a" /* errorObject */].e);
            }
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/min.js
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */
function min_min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return reduce(min);
}
//# sourceMappingURL=min.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/ConnectableObservable.js
var ConnectableObservable = __webpack_require__("gne3");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/multicast.js
/** PURE_IMPORTS_START _observable_ConnectableObservable PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') {
            subjectFactory = subjectOrSubjectFactory;
        }
        else {
            subjectFactory = function subjectFactory() {
                return subjectOrSubjectFactory;
            };
        }
        if (typeof selector === 'function') {
            return source.lift(new MulticastOperator(subjectFactory, selector));
        }
        var connectable = Object.create(source, ConnectableObservable["a" /* connectableObservableDescriptor */]);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
var MulticastOperator = /*@__PURE__*/ (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());





// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/observeOn.js
var observeOn = __webpack_require__("XtZC");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/onErrorResumeNext.js
/** PURE_IMPORTS_START tslib,_observable_from,_util_isArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





/* tslint:enable:max-line-length */
/**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */
function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    if (nextSources.length === 1 && Object(isArray["a" /* isArray */])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
}
/* tslint:enable:max-line-length */
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    var source = null;
    if (nextSources.length === 1 && Object(isArray["a" /* isArray */])(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return Object(from["a" /* from */])(source, null).lift(new OnErrorResumeNextOperator(nextSources));
}
var OnErrorResumeNextOperator = /*@__PURE__*/ (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new onErrorResumeNext_OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var onErrorResumeNext_OnErrorResumeNextSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.nextSources = nextSources;
        return _this;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (next) {
            this.add(Object(subscribeToResult["a" /* subscribeToResult */])(this, next));
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/pairwise.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return function (source) { return source.lift(new PairwiseOperator()); };
}
var PairwiseOperator = /*@__PURE__*/ (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new pairwise_PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var pairwise_PairwiseSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasPrev = false;
        return _this;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        if (this.hasPrev) {
            this.destination.next([this.prev, value]);
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
    };
    return PairwiseSubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/not.js
var not = __webpack_require__("8LP5");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/partition.js
/** PURE_IMPORTS_START _util_not,_filter PURE_IMPORTS_END */


/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */
function partition(predicate, thisArg) {
    return function (source) {
        return [
            filter(predicate, thisArg)(source),
            filter(Object(not["a" /* not */])(predicate, thisArg))(source)
        ];
    };
}
//# sourceMappingURL=partition.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/pluck.js
/** PURE_IMPORTS_START _map PURE_IMPORTS_END */

/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return function (source) { return Object(map["a" /* map */])(plucker(properties, length))(source); };
}
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subject.js
var Subject = __webpack_require__("tUzZ");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/publish.js
/** PURE_IMPORTS_START _Subject,_multicast PURE_IMPORTS_END */


/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
function publish(selector) {
    return selector ?
        multicast(function () { return new Subject["b" /* Subject */](); }, selector) :
        multicast(new Subject["b" /* Subject */]());
}
//# sourceMappingURL=publish.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/BehaviorSubject.js
var BehaviorSubject = __webpack_require__("0snD");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/publishBehavior.js
/** PURE_IMPORTS_START _BehaviorSubject,_multicast PURE_IMPORTS_END */


/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return function (source) { return multicast(new BehaviorSubject["a" /* BehaviorSubject */](value))(source); };
}
//# sourceMappingURL=publishBehavior.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/AsyncSubject.js
var AsyncSubject = __webpack_require__("0uOn");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/publishLast.js
/** PURE_IMPORTS_START _AsyncSubject,_multicast PURE_IMPORTS_END */


function publishLast() {
    return function (source) { return multicast(new AsyncSubject["a" /* AsyncSubject */]())(source); };
}
//# sourceMappingURL=publishLast.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/ReplaySubject.js
var ReplaySubject = __webpack_require__("NG/L");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/publishReplay.js
/** PURE_IMPORTS_START _ReplaySubject,_multicast PURE_IMPORTS_END */


/* tslint:enable:max-line-length */
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
        scheduler = selectorOrScheduler;
    }
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new ReplaySubject["a" /* ReplaySubject */](bufferSize, windowTime, scheduler);
    return function (source) { return multicast(function () { return subject; }, selector)(source); };
}
//# sourceMappingURL=publishReplay.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/race.js
var race = __webpack_require__("v38c");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/race.js
/** PURE_IMPORTS_START _util_isArray,_observable_race PURE_IMPORTS_END */


/* tslint:enable:max-line-length */
/**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */
function race_race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && Object(isArray["a" /* isArray */])(observables[0])) {
            observables = observables[0];
        }
        return source.lift.call(race["a" /* race */].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=race.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/repeat.js
/** PURE_IMPORTS_START tslib,_Subscriber,_observable_empty PURE_IMPORTS_END */



/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */
function repeat(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) {
        if (count === 0) {
            return Object(empty["b" /* empty */])();
        }
        else if (count < 0) {
            return source.lift(new RepeatOperator(-1, source));
        }
        else {
            return source.lift(new RepeatOperator(count - 1, source));
        }
    };
}
var RepeatOperator = /*@__PURE__*/ (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new repeat_RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var repeat_RepeatSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/repeatWhen.js
/** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
function repeatWhen(notifier) {
    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
}
var RepeatWhenOperator = /*@__PURE__*/ (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new repeatWhen_RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var repeatWhen_RepeatWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        _this.sourceIsBeingSubscribedTo = true;
        return _this;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            if (!this.retriesSubscription || this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this._unsubscribe = _unsubscribe;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new Subject["b" /* Subject */]();
        var retries = Object(tryCatch["a" /* tryCatch */])(this.notifier)(this.notifications);
        if (retries === errorObject["a" /* errorObject */]) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, retries);
    };
    return RepeatWhenSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/retry.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */
function retry(count) {
    if (count === void 0) {
        count = -1;
    }
    return function (source) { return source.lift(new RetryOperator(count, source)); };
}
var RetryOperator = /*@__PURE__*/ (function () {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new retry_RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var retry_RetrySubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        var _this = _super.call(this, destination) || this;
        _this.count = count;
        _this.source = source;
        return _this;
    }
    RetrySubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.error.call(this, err);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/retryWhen.js
/** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */
function retryWhen(notifier) {
    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
}
var RetryWhenOperator = /*@__PURE__*/ (function () {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new retryWhen_RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var retryWhen_RetryWhenSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        var _this = _super.call(this, destination) || this;
        _this.notifier = notifier;
        _this.source = source;
        return _this;
    }
    RetryWhenSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new Subject["b" /* Subject */]();
                retries = Object(tryCatch["a" /* tryCatch */])(this.notifier)(errors);
                if (retries === errorObject["a" /* errorObject */]) {
                    return _super.prototype.error.call(this, errorObject["a" /* errorObject */].e);
                }
                retriesSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, retries);
            }
            else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    RetryWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _unsubscribe = this._unsubscribe;
        this._unsubscribe = null;
        this._unsubscribeAndRecycle();
        this._unsubscribe = _unsubscribe;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/refCount.js
var operators_refCount = __webpack_require__("/qTI");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/sample.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */
function sample(notifier) {
    return function (source) { return source.lift(new sample_SampleOperator(notifier)); };
}
var sample_SampleOperator = /*@__PURE__*/ (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new sample_SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(Object(subscribeToResult["a" /* subscribeToResult */])(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var sample_SampleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SampleSubscriber, _super);
    function SampleSubscriber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasValue = false;
        return _this;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/sampleTime.js
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async PURE_IMPORTS_END */



/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
}
var SampleTimeOperator = /*@__PURE__*/ (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new sampleTime_SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var sampleTime_SampleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.period = period;
        _this.scheduler = scheduler;
        _this.hasValue = false;
        _this.add(scheduler.schedule(dispatchNotification, period, { subscriber: _this, period: period }));
        return _this;
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/sequenceEqual.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_tryCatch,_util_errorObject PURE_IMPORTS_END */




/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */
function sequenceEqual(compareTo, comparor) {
    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparor)); };
}
var SequenceEqualOperator = /*@__PURE__*/ (function () {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new sequenceEqual_SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var sequenceEqual_SequenceEqualSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        var _this = _super.call(this, destination) || this;
        _this.compareTo = compareTo;
        _this.comparor = comparor;
        _this._a = [];
        _this._b = [];
        _this._oneComplete = false;
        _this.add(compareTo.subscribe(new sequenceEqual_SequenceEqualCompareToSubscriber(destination, _this)));
        return _this;
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = Object(tryCatch["a" /* tryCatch */])(comparor)(a, b);
                if (areEqual === errorObject["a" /* errorObject */]) {
                    this.destination.error(errorObject["a" /* errorObject */].e);
                }
            }
            else {
                areEqual = a === b;
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}(Subscriber["a" /* Subscriber */]));

var sequenceEqual_SequenceEqualCompareToSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        return _this;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/share.js
/** PURE_IMPORTS_START _multicast,_refCount,_Subject PURE_IMPORTS_END */



function shareSubjectFactory() {
    return new Subject["b" /* Subject */]();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */
function share() {
    return function (source) { return Object(operators_refCount["a" /* refCount */])()(multicast(shareSubjectFactory)(source)); };
}
//# sourceMappingURL=share.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/shareReplay.js
/** PURE_IMPORTS_START _ReplaySubject PURE_IMPORTS_END */

/**
 * @method shareReplay
 * @owner Observable
 */
function shareReplay(bufferSize, windowTime, scheduler) {
    return function (source) { return source.lift(shareReplayOperator(bufferSize, windowTime, scheduler)); };
}
function shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new ReplaySubject["a" /* ReplaySubject */](bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function (value) { subject.next(value); },
                error: function (err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function () {
                    isComplete = true;
                    subject.complete();
                },
            });
        }
        var innerSub = subject.subscribe(this);
        return function () {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) {
                subscription.unsubscribe();
            }
        };
    };
}
//# sourceMappingURL=shareReplay.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/single.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_EmptyError PURE_IMPORTS_END */



/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * items, notify of an IllegalArgumentException or NoSuchElementException respectively. If the source Observable
 * emits items but none match the specified predicate then `undefined` is emiited.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate or `undefined` when no items match.
 *
 * @method single
 * @owner Observable
 */
function single(predicate) {
    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
}
var SingleOperator = /*@__PURE__*/ (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new single_SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var single_SingleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.source = source;
        _this.seenValue = false;
        _this.index = 0;
        return _this;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new EmptyError["a" /* EmptyError */]);
        }
    };
    return SingleSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/skip.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */
function skip(count) {
    return function (source) { return source.lift(new SkipOperator(count)); };
}
var SkipOperator = /*@__PURE__*/ (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new skip_SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var skip_SkipSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/skipLast.js
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError PURE_IMPORTS_END */



/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */
function skipLast(count) {
    return function (source) { return source.lift(new skipLast_SkipLastOperator(count)); };
}
var skipLast_SkipLastOperator = /*@__PURE__*/ (function () {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) {
            throw new ArgumentOutOfRangeError["a" /* ArgumentOutOfRangeError */];
        }
    }
    SkipLastOperator.prototype.call = function (subscriber, source) {
        if (this._skipCount === 0) {
            // If we don't want to skip any values then just subscribe
            // to Subscriber without any further logic.
            return source.subscribe(new Subscriber["a" /* Subscriber */](subscriber));
        }
        else {
            return source.subscribe(new skipLast_SkipLastSubscriber(subscriber, this._skipCount));
        }
    };
    return SkipLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var skipLast_SkipLastSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        var _this = _super.call(this, destination) || this;
        _this._skipCount = _skipCount;
        _this._count = 0;
        _this._ring = new Array(_skipCount);
        return _this;
    }
    SkipLastSubscriber.prototype._next = function (value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) {
            this._ring[count] = value;
        }
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}(Subscriber["a" /* Subscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/skipUntil.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
}
var SkipUntilOperator = /*@__PURE__*/ (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (destination, source) {
        return source.subscribe(new skipUntil_SkipUntilSubscriber(destination, this.notifier));
    };
    return SkipUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var skipUntil_SkipUntilSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        var _this = _super.call(this, destination) || this;
        _this.hasValue = false;
        _this.add(_this.innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(_this, notifier));
        return _this;
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
        this.innerSubscription.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
        /* do nothing */
    };
    return SkipUntilSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/skipWhile.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */
function skipWhile(predicate) {
    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
}
var SkipWhileOperator = /*@__PURE__*/ (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new skipWhile_SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var skipWhile_SkipWhileSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.skipping = true;
        _this.index = 0;
        return _this;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromArray.js
var fromArray = __webpack_require__("b2EL");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/scalar.js
var scalar = __webpack_require__("9vdN");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/startWith.js
/** PURE_IMPORTS_START _observable_fromArray,_observable_scalar,_observable_empty,_observable_concat,_util_isScheduler PURE_IMPORTS_END */





/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    return function (source) {
        var scheduler = array[array.length - 1];
        if (Object(isScheduler["a" /* isScheduler */])(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len === 1 && !scheduler) {
            return Object(concat["a" /* concat */])(Object(scalar["a" /* scalar */])(array[0]), source);
        }
        else if (len > 0) {
            return Object(concat["a" /* concat */])(Object(fromArray["a" /* fromArray */])(array, scheduler), source);
        }
        else {
            return Object(concat["a" /* concat */])(Object(empty["b" /* empty */])(scheduler), source);
        }
    };
}
//# sourceMappingURL=startWith.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/SubscribeOnObservable.js
var SubscribeOnObservable = __webpack_require__("Y9kR");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/subscribeOn.js
/** PURE_IMPORTS_START _observable_SubscribeOnObservable PURE_IMPORTS_END */

/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new subscribeOn_SubscribeOnOperator(scheduler, delay));
    };
}
var subscribeOn_SubscribeOnOperator = /*@__PURE__*/ (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new SubscribeOnObservable["a" /* SubscribeOnObservable */](source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/switchMap.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult,_map,_observable_from PURE_IMPORTS_END */





/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(switchMap(function (a, i) { return Object(from["a" /* from */])(project(a, i)).pipe(Object(map["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })); })); };
    }
    return function (source) { return source.lift(new SwitchMapOperator(project)); };
}
var SwitchMapOperator = /*@__PURE__*/ (function () {
    function SwitchMapOperator(project) {
        this.project = project;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new switchMap_SwitchMapSubscriber(subscriber, this.project));
    };
    return SwitchMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var switchMap_SwitchMapSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.index = 0;
        return _this;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    return SwitchMapSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/switchAll.js
/** PURE_IMPORTS_START _switchMap,_util_identity PURE_IMPORTS_END */


function switchAll() {
    return switchMap(identity["a" /* identity */]);
}
//# sourceMappingURL=switchAll.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/switchMapTo.js
/** PURE_IMPORTS_START _switchMap PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */
function switchMapTo(innerObservable, resultSelector) {
    return resultSelector ? switchMap(function () { return innerObservable; }, resultSelector) : switchMap(function () { return innerObservable; });
}
//# sourceMappingURL=switchMapTo.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/takeUntil.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits a value. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value, the output Observable stops mirroring the source Observable
 * and completes. If the `notifier` doesn't emit any value and completes
 * then `takeUntil` will pass all values.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return function (source) { return source.lift(new takeUntil_TakeUntilOperator(notifier)); };
}
var takeUntil_TakeUntilOperator = /*@__PURE__*/ (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        var takeUntilSubscriber = new takeUntil_TakeUntilSubscriber(subscriber);
        var notifierSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(takeUntilSubscriber, this.notifier);
        if (notifierSubscription && !notifierSubscription.closed) {
            takeUntilSubscriber.add(notifierSubscription);
            return source.subscribe(takeUntilSubscriber);
        }
        return takeUntilSubscriber;
    };
    return TakeUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var takeUntil_TakeUntilSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination) {
        return _super.call(this, destination) || this;
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    return TakeUntilSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/takeWhile.js
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */
function takeWhile(predicate) {
    return function (source) { return source.lift(new TakeWhileOperator(predicate)); };
}
var TakeWhileOperator = /*@__PURE__*/ (function () {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new takeWhile_TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var takeWhile_TakeWhileSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.index = 0;
        return _this;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/throttle.js
var throttle = __webpack_require__("QFiC");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/throttleTime.js
/** PURE_IMPORTS_START tslib,_Subscriber,_scheduler_async,_throttle PURE_IMPORTS_END */




/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @param {Object} config a configuration object to define `leading` and
 * `trailing` behavior. Defaults to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    if (config === void 0) {
        config = throttle["a" /* defaultThrottleConfig */];
    }
    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
}
var ThrottleTimeOperator = /*@__PURE__*/ (function () {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new throttleTime_ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var throttleTime_ThrottleTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        var _this = _super.call(this, destination) || this;
        _this.duration = duration;
        _this.scheduler = scheduler;
        _this.leading = leading;
        _this.trailing = trailing;
        _this._hasTrailingValue = false;
        _this._trailingValue = null;
        return _this;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        }
        else {
            this.add(this.throttled = this.scheduler.schedule(throttleTime_dispatchNext, this.duration, { subscriber: this }));
            if (this.leading) {
                this.destination.next(value);
            }
        }
    };
    ThrottleTimeSubscriber.prototype._complete = function () {
        if (this._hasTrailingValue) {
            this.destination.next(this._trailingValue);
            this.destination.complete();
        }
        else {
            this.destination.complete();
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function throttleTime_dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/timeInterval.js
var timeInterval = __webpack_require__("VHBj");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/TimeoutError.js
var TimeoutError = __webpack_require__("7mk3");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/timeoutWith.js
/** PURE_IMPORTS_START tslib,_scheduler_async,_util_isDate,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





/* tslint:enable:max-line-length */
/**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return function (source) {
        var absoluteTimeout = Object(isDate["a" /* isDate */])(due);
        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
var TimeoutWithOperator = /*@__PURE__*/ (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new timeoutWith_TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var timeoutWith_TimeoutWithSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.absoluteTimeout = absoluteTimeout;
        _this.waitFor = waitFor;
        _this.withObservable = withObservable;
        _this.scheduler = scheduler;
        _this.action = null;
        _this.scheduleTimeout();
        return _this;
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(Object(subscribeToResult["a" /* subscribeToResult */])(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/throwError.js
var throwError = __webpack_require__("G0Bs");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/timeout.js
/** PURE_IMPORTS_START _scheduler_async,_util_TimeoutError,_timeoutWith,_observable_throwError PURE_IMPORTS_END */




/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */
function timeout(due, scheduler) {
    if (scheduler === void 0) {
        scheduler = scheduler_async["a" /* async */];
    }
    return timeoutWith(due, Object(throwError["a" /* throwError */])(new TimeoutError["a" /* TimeoutError */]()), scheduler);
}
//# sourceMappingURL=timeout.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/timestamp.js
var timestamp = __webpack_require__("Fv6v");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/toArray.js
/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */

function toArrayReducer(arr, item, index) {
    if (index === 0) {
        return [item];
    }
    arr.push(item);
    return arr;
}
function toArray() {
    return reduce(toArrayReducer, []);
}
//# sourceMappingURL=toArray.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/window.js
/** PURE_IMPORTS_START tslib,_Subject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */




/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */
function window_window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new window_WindowOperator(windowBoundaries));
    };
}
var window_WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new window_WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(Object(subscribeToResult["a" /* subscribeToResult */])(windowSubscriber, this.windowBoundaries));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var window_WindowSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.window = new Subject["b" /* Subject */]();
        destination.next(_this.window);
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new Subject["b" /* Subject */]();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/windowCount.js
/** PURE_IMPORTS_START tslib,_Subscriber,_Subject PURE_IMPORTS_END */



/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) {
        startWindowEvery = 0;
    }
    return function windowCountOperatorFunction(source) {
        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
    };
}
var WindowCountOperator = /*@__PURE__*/ (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new windowCount_WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var windowCount_WindowCountSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowSize = windowSize;
        _this.startWindowEvery = startWindowEvery;
        _this.windows = [new Subject["b" /* Subject */]()];
        _this.count = 0;
        destination.next(_this.windows[0]);
        return _this;
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new Subject["b" /* Subject */]();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(Subscriber["a" /* Subscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isNumeric.js
var isNumeric = __webpack_require__("03ca");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/windowTime.js
/** PURE_IMPORTS_START tslib,_Subject,_scheduler_async,_Subscriber,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */






function windowTime_windowTime(windowTimeSpan) {
    var scheduler = scheduler_async["a" /* async */];
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (Object(isScheduler["a" /* isScheduler */])(arguments[3])) {
        scheduler = arguments[3];
    }
    if (Object(isScheduler["a" /* isScheduler */])(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (Object(isNumeric["a" /* isNumeric */])(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (Object(isScheduler["a" /* isScheduler */])(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (Object(isNumeric["a" /* isNumeric */])(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return function windowTimeOperatorFunction(source) {
        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
var WindowTimeOperator = /*@__PURE__*/ (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new windowTime_WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var windowTime_CountedSubject = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](CountedSubject, _super);
    function CountedSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._numberOfNextedValues = 0;
        return _this;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(Subject["b" /* Subject */]));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var windowTime_WindowTimeSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.windowTimeSpan = windowTimeSpan;
        _this.windowCreationInterval = windowCreationInterval;
        _this.maxWindowSize = maxWindowSize;
        _this.scheduler = scheduler;
        _this.windows = [];
        var window = _this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: _this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: _this, scheduler: scheduler };
            _this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            _this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: _this, window: window, windowTimeSpan: windowTimeSpan };
            _this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
        return _this;
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new windowTime_CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(Subscriber["a" /* Subscriber */]));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/windowToggle.js
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */







/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */
function windowToggle(openings, closingSelector) {
    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
}
var WindowToggleOperator = /*@__PURE__*/ (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new windowToggle_WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var windowToggle_WindowToggleSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.openings = openings;
        _this.closingSelector = closingSelector;
        _this.contexts = [];
        _this.add(_this.openSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(_this, openings, openings));
        return _this;
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_1 = contexts[index];
                context_1.window.error(err);
                context_1.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_2 = contexts[index];
                context_2.window.complete();
                context_2.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context_3 = contexts[index];
                context_3.window.unsubscribe();
                context_3.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = Object(tryCatch["a" /* tryCatch */])(closingSelector)(innerValue);
            if (closingNotifier === errorObject["a" /* errorObject */]) {
                return this.error(errorObject["a" /* errorObject */].e);
            }
            else {
                var window_1 = new Subject["b" /* Subject */]();
                var subscription = new Subscription["a" /* Subscription */]();
                var context_4 = { window: window_1, subscription: subscription };
                this.contexts.push(context_4);
                var innerSubscription = Object(subscribeToResult["a" /* subscribeToResult */])(this, closingNotifier, context_4);
                if (innerSubscription.closed) {
                    this.closeWindow(this.contexts.length - 1);
                }
                else {
                    innerSubscription.context = context_4;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/windowWhen.js
/** PURE_IMPORTS_START tslib,_Subject,_util_tryCatch,_util_errorObject,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */






/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */
function windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new windowWhen_WindowOperator(closingSelector));
    };
}
var windowWhen_WindowOperator = /*@__PURE__*/ (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new windowWhen_WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var windowWhen_WindowSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.closingSelector = closingSelector;
        _this.openWindow();
        return _this;
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) {
            innerSub = null;
        }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new Subject["b" /* Subject */]();
        this.destination.next(window);
        var closingNotifier = Object(tryCatch["a" /* tryCatch */])(this.closingSelector)();
        if (closingNotifier === errorObject["a" /* errorObject */]) {
            var err = errorObject["a" /* errorObject */].e;
            this.destination.error(err);
            this.window.error(err);
        }
        else {
            this.add(this.closingNotification = Object(subscribeToResult["a" /* subscribeToResult */])(this, closingNotifier));
        }
    };
    return WindowSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/withLatestFrom.js
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



/* tslint:enable:max-line-length */
/**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */
function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (source) {
        var project;
        if (typeof args[args.length - 1] === 'function') {
            project = args.pop();
        }
        var observables = args;
        return source.lift(new WithLatestFromOperator(observables, project));
    };
}
var WithLatestFromOperator = /*@__PURE__*/ (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new withLatestFrom_WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var withLatestFrom_WithLatestFromSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        var _this = _super.call(this, destination) || this;
        _this.observables = observables;
        _this.project = project;
        _this.toRespond = [];
        var len = observables.length;
        _this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            _this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            _this.add(Object(subscribeToResult["a" /* subscribeToResult */])(_this, observable, observable, i));
        }
        return _this;
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(OuterSubscriber["a" /* OuterSubscriber */]));




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/zip.js
var zip = __webpack_require__("lyWU");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/zip.js
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
/**
 * @deprecated Deprecated in favor of static zip.
 */
function zip_zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return function zipOperatorFunction(source) {
        return source.lift.call(zip["b" /* zip */].apply(void 0, [source].concat(observables)));
    };
}
//# sourceMappingURL=zip.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/operators/zipAll.js
/** PURE_IMPORTS_START _observable_zip PURE_IMPORTS_END */

function zipAll(project) {
    return function (source) { return source.lift(new zip["a" /* ZipOperator */](project)); };
}
//# sourceMappingURL=zipAll.js.map

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/operators/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "audit", function() { return audit; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "auditTime", function() { return auditTime; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "buffer", function() { return buffer_buffer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bufferCount", function() { return bufferCount; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bufferTime", function() { return bufferTime; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bufferToggle", function() { return bufferToggle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bufferWhen", function() { return bufferWhen; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "catchError", function() { return catchError; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "combineAll", function() { return combineAll; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "combineLatest", function() { return combineLatest_combineLatest; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "concat", function() { return concat_concat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "concatAll", function() { return concatAll["a" /* concatAll */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "concatMap", function() { return concatMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "concatMapTo", function() { return concatMapTo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "count", function() { return count_count; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "debounce", function() { return debounce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "debounceTime", function() { return debounceTime; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "defaultIfEmpty", function() { return defaultIfEmpty; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "delay", function() { return delay_delay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "delayWhen", function() { return delayWhen; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "dematerialize", function() { return dematerialize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "distinct", function() { return distinct; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "distinctUntilChanged", function() { return distinctUntilChanged; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "distinctUntilKeyChanged", function() { return distinctUntilKeyChanged; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "elementAt", function() { return elementAt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "every", function() { return every; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "exhaust", function() { return exhaust; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "exhaustMap", function() { return exhaustMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "expand", function() { return expand; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "finalize", function() { return finalize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "findIndex", function() { return findIndex; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "first", function() { return first; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "groupBy", function() { return groupBy["a" /* groupBy */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "ignoreElements", function() { return ignoreElements; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "last", function() { return last; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "map", function() { return map["a" /* map */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mapTo", function() { return mapTo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "materialize", function() { return materialize; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "max", function() { return max_max; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "merge", function() { return merge_merge; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mergeAll", function() { return mergeAll["a" /* mergeAll */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mergeMap", function() { return mergeMap["a" /* mergeMap */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "flatMap", function() { return mergeMap["a" /* mergeMap */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mergeMapTo", function() { return mergeMapTo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "mergeScan", function() { return mergeScan; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "min", function() { return min_min; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "multicast", function() { return multicast; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "observeOn", function() { return observeOn["b" /* observeOn */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "onErrorResumeNext", function() { return onErrorResumeNext; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pairwise", function() { return pairwise; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "partition", function() { return partition; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "pluck", function() { return pluck; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "publish", function() { return publish; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "publishBehavior", function() { return publishBehavior; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "publishLast", function() { return publishLast; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "publishReplay", function() { return publishReplay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "race", function() { return race_race; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "reduce", function() { return reduce; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "repeat", function() { return repeat; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "repeatWhen", function() { return repeatWhen; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "retry", function() { return retry; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "retryWhen", function() { return retryWhen; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "refCount", function() { return operators_refCount["a" /* refCount */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sample", function() { return sample; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sampleTime", function() { return sampleTime; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "scan", function() { return scan["a" /* scan */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "sequenceEqual", function() { return sequenceEqual; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "share", function() { return share; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "shareReplay", function() { return shareReplay; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "single", function() { return single; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "skip", function() { return skip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "skipLast", function() { return skipLast; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "skipUntil", function() { return skipUntil; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "skipWhile", function() { return skipWhile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "startWith", function() { return startWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "subscribeOn", function() { return subscribeOn; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "switchAll", function() { return switchAll; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "switchMap", function() { return switchMap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "switchMapTo", function() { return switchMapTo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "take", function() { return take; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "takeLast", function() { return takeLast; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "takeUntil", function() { return takeUntil; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "takeWhile", function() { return takeWhile; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "tap", function() { return tap; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "throttle", function() { return throttle["b" /* throttle */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "throttleTime", function() { return throttleTime; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "throwIfEmpty", function() { return throwIfEmpty; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "timeInterval", function() { return timeInterval["a" /* timeInterval */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "timeout", function() { return timeout; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "timeoutWith", function() { return timeoutWith; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "timestamp", function() { return timestamp["a" /* timestamp */]; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "toArray", function() { return toArray; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "window", function() { return window_window; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "windowCount", function() { return windowCount; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "windowTime", function() { return windowTime_windowTime; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "windowToggle", function() { return windowToggle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "windowWhen", function() { return windowWhen; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withLatestFrom", function() { return withLatestFrom; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "zip", function() { return zip_zip; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "zipAll", function() { return zipAll; });
/* Operator exports */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */







































































































//# sourceMappingURL=index.js.map


/***/ }),

/***/ "Nzt2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        ss : '%d שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),

/***/ "O1jc":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("nw3t"),
    eq = __webpack_require__("22B7");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "O4Lo":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF"),
    now = __webpack_require__("RVHk"),
    toNumber = __webpack_require__("kxzG");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "O83F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@angular/core/fesm5/core.js
var core = __webpack_require__("TdOr");

// EXTERNAL MODULE: ./node_modules/@angular/router/fesm5/router.js
var fesm5_router = __webpack_require__("yZfy");

// EXTERNAL MODULE: ./node_modules/@angularclass/hmr/dist/index.js
var dist = __webpack_require__("NTqS");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/@angular/common/fesm5/common.js
var common = __webpack_require__("wTuo");

// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/util/util.js
function toInteger(value) {
    return parseInt("" + value, 10);
}
function util_toString(value) {
    return (value !== undefined && value !== null) ? "" + value : '';
}
function getValueInRange(value, max, min) {
    if (min === void 0) { min = 0; }
    return Math.max(Math.min(value, max), min);
}
function isString(value) {
    return typeof value === 'string';
}
function isNumber(value) {
    return !isNaN(toInteger(value));
}
function isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function padNumber(value) {
    if (isNumber(value)) {
        return ("0" + value).slice(-2);
    }
    else {
        return '';
    }
}
function regExpEscape(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
//# sourceMappingURL=util.js.map
// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion-config.js

/**
 * Configuration service for the NgbAccordion component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the accordions used in the application.
 */
var NgbAccordionConfig = /*@__PURE__*/ (function () {
    function NgbAccordionConfig() {
        this.closeOthers = false;
    }
    return NgbAccordionConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion.js



var nextId = 0;
/**
 * This directive should be used to wrap accordion panel titles that need to contain HTML markup or other directives.
 */
var NgbPanelTitle = /*@__PURE__*/ (function () {
    function NgbPanelTitle(templateRef) {
        this.templateRef = templateRef;
    }
    return NgbPanelTitle;
}());

/**
 * This directive must be used to wrap accordion panel content.
 */
var NgbPanelContent = /*@__PURE__*/ (function () {
    function NgbPanelContent(templateRef) {
        this.templateRef = templateRef;
    }
    return NgbPanelContent;
}());

/**
 * The NgbPanel directive represents an individual panel with the title and collapsible
 * content
 */
var NgbPanel = /*@__PURE__*/ (function () {
    function NgbPanel() {
        /**
           *  A flag determining whether the panel is disabled or not.
           *  When disabled, the panel cannot be toggled.
           */
        this.disabled = false;
        /**
           *  An optional id for the panel. The id should be unique.
           *  If not provided, it will be auto-generated.
           */
        this.id = "ngb-panel-" + nextId++;
        /**
           * A flag telling if the panel is currently open
           */
        this.isOpen = false;
    }
    NgbPanel.prototype.ngAfterContentChecked = function () {
        // We are using @ContentChildren instead of @ContantChild as in the Angular version being used
        // only @ContentChildren allows us to specify the {descendants: false} option.
        // Without {descendants: false} we are hitting bugs described in:
        // https://github.com/ng-bootstrap/ng-bootstrap/issues/2240
        this.titleTpl = this.titleTpls.first;
        this.contentTpl = this.contentTpls.first;
    };
    return NgbPanel;
}());

/**
 * The NgbAccordion directive is a collection of panels.
 * It can assure that only one panel can be opened at a time.
 */
var accordion_NgbAccordion = /*@__PURE__*/ (function () {
    function NgbAccordion(config) {
        /**
           * An array or comma separated strings of panel identifiers that should be opened
           */
        this.activeIds = [];
        /**
           * Whether the closed panels should be hidden without destroying them
           */
        this.destroyOnHide = true;
        /**
           * A panel change event fired right before the panel toggle happens. See NgbPanelChangeEvent for payload details
           */
        this.panelChange = new core["EventEmitter"]();
        this.type = config.type;
        this.closeOtherPanels = config.closeOthers;
    }
    /**
     * Programmatically toggle a panel with a given id.
     */
    /**
       * Programmatically toggle a panel with a given id.
       */
    NgbAccordion.prototype.toggle = /**
       * Programmatically toggle a panel with a given id.
       */
        function (panelId) {
            var panel = this.panels.find(function (p) { return p.id === panelId; });
            if (panel && !panel.disabled) {
                var defaultPrevented_1 = false;
                this.panelChange.emit({ panelId: panelId, nextState: !panel.isOpen, preventDefault: function () { defaultPrevented_1 = true; } });
                if (!defaultPrevented_1) {
                    panel.isOpen = !panel.isOpen;
                    if (this.closeOtherPanels) {
                        this._closeOthers(panelId);
                    }
                    this._updateActiveIds();
                }
            }
        };
    NgbAccordion.prototype.ngAfterContentChecked = function () {
        var _this = this;
        // active id updates
        if (isString(this.activeIds)) {
            this.activeIds = this.activeIds.split(/\s*,\s*/);
        }
        // update panels open states
        this.panels.forEach(function (panel) { return panel.isOpen = !panel.disabled && _this.activeIds.indexOf(panel.id) > -1; });
        // closeOthers updates
        if (this.activeIds.length > 1 && this.closeOtherPanels) {
            this._closeOthers(this.activeIds[0]);
            this._updateActiveIds();
        }
    };
    NgbAccordion.prototype._closeOthers = function (panelId) {
        this.panels.forEach(function (panel) {
            if (panel.id !== panelId) {
                panel.isOpen = false;
            }
        });
    };
    NgbAccordion.prototype._updateActiveIds = function () {
        this.activeIds = this.panels.filter(function (panel) { return panel.isOpen && !panel.disabled; }).map(function (panel) { return panel.id; });
    };
    return NgbAccordion;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion.module.js






var NGB_ACCORDION_DIRECTIVES = [accordion_NgbAccordion, NgbPanel, NgbPanelTitle, NgbPanelContent];
var accordion_module_NgbAccordionModule = /*@__PURE__*/ (function () {
    function NgbAccordionModule() {
    }
    NgbAccordionModule.forRoot = function () { return { ngModule: NgbAccordionModule, providers: [NgbAccordionConfig] }; };
    return NgbAccordionModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert-config.js

/**
 * Configuration service for the NgbAlert component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the alerts used in the application.
 */
var NgbAlertConfig = /*@__PURE__*/ (function () {
    function NgbAlertConfig() {
        this.dismissible = true;
        this.type = 'warning';
    }
    return NgbAlertConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert.js


/**
 * Alerts can be used to provide feedback messages.
 */
var alert_NgbAlert = /*@__PURE__*/ (function () {
    function NgbAlert(config) {
        /**
           * An event emitted when the close button is clicked. This event has no payload. Only relevant for dismissible alerts.
           */
        this.close = new core["EventEmitter"]();
        this.dismissible = config.dismissible;
        this.type = config.type;
    }
    NgbAlert.prototype.closeHandler = function () { this.close.emit(null); };
    return NgbAlert;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert.module.js






var alert_module_NgbAlertModule = /*@__PURE__*/ (function () {
    function NgbAlertModule() {
    }
    NgbAlertModule.forRoot = function () { return { ngModule: NgbAlertModule, providers: [NgbAlertConfig] }; };
    return NgbAlertModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/buttons/label.js

var NgbButtonLabel = /*@__PURE__*/ (function () {
    function NgbButtonLabel() {
    }
    return NgbButtonLabel;
}());





// EXTERNAL MODULE: ./node_modules/@angular/forms/fesm5/forms.js
var fesm5_forms = __webpack_require__("B+Nj");

// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/buttons/checkbox.js



var NGB_CHECKBOX_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    useExisting: Object(core["forwardRef"])(function () { return NgbCheckBox; }),
    multi: true
};
/**
 * Easily create Bootstrap-style checkbox buttons. A value of a checked button is bound to a variable
 * specified via ngModel.
 */
var NgbCheckBox = /*@__PURE__*/ (function () {
    function NgbCheckBox(_label) {
        this._label = _label;
        /**
           * A flag indicating if a given checkbox button is disabled.
           */
        this.disabled = false;
        /**
           * Value to be propagated as model when the checkbox is checked.
           */
        this.valueChecked = true;
        /**
           * Value to be propagated as model when the checkbox is unchecked.
           */
        this.valueUnChecked = false;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    Object.defineProperty(NgbCheckBox.prototype, "focused", {
        set: function (isFocused) {
            this._label.focused = isFocused;
            if (!isFocused) {
                this.onTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    NgbCheckBox.prototype.onInputChange = function ($event) {
        var modelToPropagate = $event.target.checked ? this.valueChecked : this.valueUnChecked;
        this.onChange(modelToPropagate);
        this.onTouched();
        this.writeValue(modelToPropagate);
    };
    NgbCheckBox.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbCheckBox.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbCheckBox.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this._label.disabled = isDisabled;
    };
    NgbCheckBox.prototype.writeValue = function (value) {
        this.checked = value === this.valueChecked;
        this._label.active = this.checked;
    };
    return NgbCheckBox;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/buttons/radio.js



var NGB_RADIO_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    useExisting: Object(core["forwardRef"])(function () { return NgbRadioGroup; }),
    multi: true
};
var radio_nextId = 0;
/**
 * Easily create Bootstrap-style radio buttons. A value of a selected button is bound to a variable
 * specified via ngModel.
 */
var NgbRadioGroup = /*@__PURE__*/ (function () {
    function NgbRadioGroup() {
        this._radios = new Set();
        this._value = null;
        /**
           * The name of the group. Unless enclosed inputs specify a name, this name is used as the name of the
           * enclosed inputs. If not specified, a name is generated automatically.
           */
        this.name = "ngb-radio-" + radio_nextId++;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    Object.defineProperty(NgbRadioGroup.prototype, "disabled", {
        get: function () { return this._disabled; },
        set: function (isDisabled) { this.setDisabledState(isDisabled); },
        enumerable: true,
        configurable: true
    });
    NgbRadioGroup.prototype.onRadioChange = function (radio) {
        this.writeValue(radio.value);
        this.onChange(radio.value);
    };
    NgbRadioGroup.prototype.onRadioValueUpdate = function () { this._updateRadiosValue(); };
    NgbRadioGroup.prototype.register = function (radio) { this._radios.add(radio); };
    NgbRadioGroup.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbRadioGroup.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbRadioGroup.prototype.setDisabledState = function (isDisabled) {
        this._disabled = isDisabled;
        this._updateRadiosDisabled();
    };
    NgbRadioGroup.prototype.unregister = function (radio) { this._radios.delete(radio); };
    NgbRadioGroup.prototype.writeValue = function (value) {
        this._value = value;
        this._updateRadiosValue();
    };
    NgbRadioGroup.prototype._updateRadiosValue = function () {
        var _this = this;
        this._radios.forEach(function (radio) { return radio.updateValue(_this._value); });
    };
    NgbRadioGroup.prototype._updateRadiosDisabled = function () { this._radios.forEach(function (radio) { return radio.updateDisabled(); }); };
    return NgbRadioGroup;
}());

/**
 * Marks an input of type "radio" as part of the NgbRadioGroup.
 */
var NgbRadio = /*@__PURE__*/ (function () {
    function NgbRadio(_group, _label, _renderer, _element) {
        this._group = _group;
        this._label = _label;
        this._renderer = _renderer;
        this._element = _element;
        this._value = null;
        this._group.register(this);
    }
    Object.defineProperty(NgbRadio.prototype, "value", {
        get: function () { return this._value; },
        set: /**
           * You can specify model value of a given radio by binding to the value property.
           */ function (value) {
            this._value = value;
            var stringValue = value ? value.toString() : '';
            this._renderer.setProperty(this._element.nativeElement, 'value', stringValue);
            this._group.onRadioValueUpdate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbRadio.prototype, "disabled", {
        get: function () { return this._group.disabled || this._disabled; },
        set: /**
           * A flag indicating if a given radio button is disabled.
           */ function (isDisabled) {
            this._disabled = isDisabled !== false;
            this.updateDisabled();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbRadio.prototype, "focused", {
        set: function (isFocused) {
            if (this._label) {
                this._label.focused = isFocused;
            }
            if (!isFocused) {
                this._group.onTouched();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbRadio.prototype, "checked", {
        get: function () { return this._checked; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbRadio.prototype, "nameAttr", {
        get: function () { return this.name || this._group.name; },
        enumerable: true,
        configurable: true
    });
    NgbRadio.prototype.ngOnDestroy = function () { this._group.unregister(this); };
    NgbRadio.prototype.onChange = function () { this._group.onRadioChange(this); };
    NgbRadio.prototype.updateValue = function (value) {
        this._checked = this.value === value;
        this._label.active = this._checked;
    };
    NgbRadio.prototype.updateDisabled = function () { this._label.disabled = this.disabled; };
    return NgbRadio;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/buttons/buttons.module.js







var NGB_BUTTON_DIRECTIVES = [NgbButtonLabel, NgbCheckBox, NgbRadioGroup, NgbRadio];
var NgbButtonsModule = /*@__PURE__*/ (function () {
    function NgbButtonsModule() {
    }
    NgbButtonsModule.forRoot = function () { return { ngModule: NgbButtonsModule, providers: [] }; };
    return NgbButtonsModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel-config.js

/**
 * Configuration service for the NgbCarousel component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the carousels used in the application.
 */
var NgbCarouselConfig = /*@__PURE__*/ (function () {
    function NgbCarouselConfig() {
        this.interval = 5000;
        this.wrap = true;
        this.keyboard = true;
        this.pauseOnHover = true;
        this.showNavigationArrows = true;
        this.showNavigationIndicators = true;
    }
    return NgbCarouselConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel.js


var carousel_nextId = 0;
/**
 * Represents an individual slide to be used within a carousel.
 */
var NgbSlide = /*@__PURE__*/ (function () {
    function NgbSlide(tplRef) {
        this.tplRef = tplRef;
        /**
           * Unique slide identifier. Must be unique for the entire document for proper accessibility support.
           * Will be auto-generated if not provided.
           */
        this.id = "ngb-slide-" + carousel_nextId++;
    }
    return NgbSlide;
}());

/**
 * Directive to easily create carousels based on Bootstrap's markup.
 */
var carousel_NgbCarousel = /*@__PURE__*/ (function () {
    function NgbCarousel(config) {
        /**
           * A carousel slide event fired when the slide transition is completed.
           * See NgbSlideEvent for payload details
           */
        this.slide = new core["EventEmitter"]();
        this.interval = config.interval;
        this.wrap = config.wrap;
        this.keyboard = config.keyboard;
        this.pauseOnHover = config.pauseOnHover;
        this.showNavigationArrows = config.showNavigationArrows;
        this.showNavigationIndicators = config.showNavigationIndicators;
    }
    NgbCarousel.prototype.ngAfterContentChecked = function () {
        var activeSlide = this._getSlideById(this.activeId);
        this.activeId = activeSlide ? activeSlide.id : (this.slides.length ? this.slides.first.id : null);
    };
    NgbCarousel.prototype.ngOnInit = function () { this._startTimer(); };
    NgbCarousel.prototype.ngOnChanges = function (changes) {
        if ('interval' in changes && !changes['interval'].isFirstChange()) {
            this._restartTimer();
        }
    };
    NgbCarousel.prototype.ngOnDestroy = function () { clearInterval(this._slideChangeInterval); };
    /**
     * Navigate to a slide with the specified identifier.
     */
    /**
       * Navigate to a slide with the specified identifier.
       */
    NgbCarousel.prototype.select = /**
       * Navigate to a slide with the specified identifier.
       */
        function (slideId) {
            this.cycleToSelected(slideId, this.getSlideEventDirection(this.activeId, slideId));
            this._restartTimer();
        };
    /**
     * Navigate to the next slide.
     */
    /**
       * Navigate to the next slide.
       */
    NgbCarousel.prototype.prev = /**
       * Navigate to the next slide.
       */
        function () {
            this.cycleToPrev();
            this._restartTimer();
        };
    /**
     * Navigate to the next slide.
     */
    /**
       * Navigate to the next slide.
       */
    NgbCarousel.prototype.next = /**
       * Navigate to the next slide.
       */
        function () {
            this.cycleToNext();
            this._restartTimer();
        };
    /**
     * Stops the carousel from cycling through items.
     */
    /**
       * Stops the carousel from cycling through items.
       */
    NgbCarousel.prototype.pause = /**
       * Stops the carousel from cycling through items.
       */
        function () { this._stopTimer(); };
    /**
     * Restarts cycling through the carousel slides from left to right.
     */
    /**
       * Restarts cycling through the carousel slides from left to right.
       */
    NgbCarousel.prototype.cycle = /**
       * Restarts cycling through the carousel slides from left to right.
       */
        function () { this._startTimer(); };
    NgbCarousel.prototype.cycleToNext = function () { this.cycleToSelected(this._getNextSlide(this.activeId), NgbSlideEventDirection.LEFT); };
    NgbCarousel.prototype.cycleToPrev = function () { this.cycleToSelected(this._getPrevSlide(this.activeId), NgbSlideEventDirection.RIGHT); };
    NgbCarousel.prototype.cycleToSelected = function (slideIdx, direction) {
        var selectedSlide = this._getSlideById(slideIdx);
        if (selectedSlide) {
            if (selectedSlide.id !== this.activeId) {
                this.slide.emit({ prev: this.activeId, current: selectedSlide.id, direction: direction });
            }
            this.activeId = selectedSlide.id;
        }
    };
    NgbCarousel.prototype.getSlideEventDirection = function (currentActiveSlideId, nextActiveSlideId) {
        var currentActiveSlideIdx = this._getSlideIdxById(currentActiveSlideId);
        var nextActiveSlideIdx = this._getSlideIdxById(nextActiveSlideId);
        return currentActiveSlideIdx > nextActiveSlideIdx ? NgbSlideEventDirection.RIGHT : NgbSlideEventDirection.LEFT;
    };
    NgbCarousel.prototype.keyPrev = function () {
        if (this.keyboard) {
            this.prev();
        }
    };
    NgbCarousel.prototype.keyNext = function () {
        if (this.keyboard) {
            this.next();
        }
    };
    NgbCarousel.prototype.onMouseEnter = function () {
        if (this.pauseOnHover) {
            this.pause();
        }
    };
    NgbCarousel.prototype.onMouseLeave = function () {
        if (this.pauseOnHover) {
            this.cycle();
        }
    };
    NgbCarousel.prototype._restartTimer = function () {
        this._stopTimer();
        this._startTimer();
    };
    NgbCarousel.prototype._startTimer = function () {
        var _this = this;
        if (this.interval > 0) {
            this._slideChangeInterval = setInterval(function () { _this.cycleToNext(); }, this.interval);
        }
    };
    NgbCarousel.prototype._stopTimer = function () { clearInterval(this._slideChangeInterval); };
    NgbCarousel.prototype._getSlideById = function (slideId) {
        var slideWithId = this.slides.filter(function (slide) { return slide.id === slideId; });
        return slideWithId.length ? slideWithId[0] : null;
    };
    NgbCarousel.prototype._getSlideIdxById = function (slideId) {
        return this.slides.toArray().indexOf(this._getSlideById(slideId));
    };
    NgbCarousel.prototype._getNextSlide = function (currentSlideId) {
        var slideArr = this.slides.toArray();
        var currentSlideIdx = this._getSlideIdxById(currentSlideId);
        var isLastSlide = currentSlideIdx === slideArr.length - 1;
        return isLastSlide ? (this.wrap ? slideArr[0].id : slideArr[slideArr.length - 1].id) :
            slideArr[currentSlideIdx + 1].id;
    };
    NgbCarousel.prototype._getPrevSlide = function (currentSlideId) {
        var slideArr = this.slides.toArray();
        var currentSlideIdx = this._getSlideIdxById(currentSlideId);
        var isFirstSlide = currentSlideIdx === 0;
        return isFirstSlide ? (this.wrap ? slideArr[slideArr.length - 1].id : slideArr[0].id) :
            slideArr[currentSlideIdx - 1].id;
    };
    return NgbCarousel;
}());

/**
 * Enum to define the carousel slide event direction
 */
/**
 * Enum to define the carousel slide event direction
 */
var NgbSlideEventDirection;
/**
 * Enum to define the carousel slide event direction
 */
(function (NgbSlideEventDirection) {
    NgbSlideEventDirection[NgbSlideEventDirection["LEFT"] = 'left'] = "LEFT";
    NgbSlideEventDirection[NgbSlideEventDirection["RIGHT"] = 'right'] = "RIGHT";
})(NgbSlideEventDirection || (NgbSlideEventDirection = {}));
var NGB_CAROUSEL_DIRECTIVES = [carousel_NgbCarousel, NgbSlide];




// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/carousel/carousel.module.js






var carousel_module_NgbCarouselModule = /*@__PURE__*/ (function () {
    function NgbCarouselModule() {
    }
    NgbCarouselModule.forRoot = function () { return { ngModule: NgbCarouselModule, providers: [NgbCarouselConfig] }; };
    return NgbCarouselModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/collapse/collapse.js

/**
 * The NgbCollapse directive provides a simple way to hide and show an element with animations.
 */
var NgbCollapse = /*@__PURE__*/ (function () {
    function NgbCollapse() {
        /**
           * A flag indicating collapsed (true) or open (false) state.
           */
        this.collapsed = false;
    }
    return NgbCollapse;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/collapse/collapse.module.js



var NgbCollapseModule = /*@__PURE__*/ (function () {
    function NgbCollapseModule() {
    }
    NgbCollapseModule.forRoot = function () { return { ngModule: NgbCollapseModule, providers: [] }; };
    return NgbCollapseModule;
}());





// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/operators/index.js + 91 modules
var operators = __webpack_require__("Nyrq");

// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date.js
var NgbDate = /*@__PURE__*/ (function () {
    function NgbDate(year, month, day) {
        this.year = year;
        this.month = month;
        this.day = day;
    }
    NgbDate.from = function (date) {
        return date ? new NgbDate(date.year, date.month, date.day ? date.day : 1) : null;
    };
    NgbDate.prototype.equals = function (other) {
        return other && this.year === other.year && this.month === other.month && this.day === other.day;
    };
    NgbDate.prototype.before = function (other) {
        if (!other) {
            return false;
        }
        if (this.year === other.year) {
            if (this.month === other.month) {
                return this.day === other.day ? false : this.day < other.day;
            }
            else {
                return this.month < other.month;
            }
        }
        else {
            return this.year < other.year;
        }
    };
    NgbDate.prototype.after = function (other) {
        if (!other) {
            return false;
        }
        if (this.year === other.year) {
            if (this.month === other.month) {
                return this.day === other.day ? false : this.day > other.day;
            }
            else {
                return this.month > other.month;
            }
        }
        else {
            return this.year > other.year;
        }
    };
    NgbDate.prototype.toStruct = function () { return { year: this.year, month: this.month, day: this.day }; };
    NgbDate.prototype.toString = function () { return this.year + "-" + this.month + "-" + this.day; };
    return NgbDate;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar.js
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



function fromJSDate(jsDate) {
    return new NgbDate(jsDate.getFullYear(), jsDate.getMonth() + 1, jsDate.getDate());
}
function toJSDate(date) {
    var jsDate = new Date(date.year, date.month - 1, date.day, 12);
    // this is done avoid 30 -> 1930 conversion
    if (!isNaN(jsDate.getTime())) {
        jsDate.setFullYear(date.year);
    }
    return jsDate;
}
var NgbCalendar = /*@__PURE__*/ (function () {
    function NgbCalendar() {
    }
    return NgbCalendar;
}());

var ngb_calendar_NgbCalendarGregorian = /*@__PURE__*/ (function (_super) {
    __extends(NgbCalendarGregorian, _super);
    function NgbCalendarGregorian() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbCalendarGregorian.prototype.getDaysPerWeek = function () { return 7; };
    NgbCalendarGregorian.prototype.getMonths = function () { return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; };
    NgbCalendarGregorian.prototype.getWeeksPerMonth = function () { return 6; };
    NgbCalendarGregorian.prototype.getNext = function (date, period, number) {
        if (period === void 0) {
            period = 'd';
        }
        if (number === void 0) {
            number = 1;
        }
        var jsDate = toJSDate(date);
        switch (period) {
            case 'y':
                return new NgbDate(date.year + number, 1, 1);
            case 'm':
                jsDate = new Date(date.year, date.month + number - 1, 1, 12);
                break;
            case 'd':
                jsDate.setDate(jsDate.getDate() + number);
                break;
            default:
                return date;
        }
        return fromJSDate(jsDate);
    };
    NgbCalendarGregorian.prototype.getPrev = function (date, period, number) {
        if (period === void 0) {
            period = 'd';
        }
        if (number === void 0) {
            number = 1;
        }
        return this.getNext(date, period, -number);
    };
    NgbCalendarGregorian.prototype.getWeekday = function (date) {
        var jsDate = toJSDate(date);
        var day = jsDate.getDay();
        // in JS Date Sun=0, in ISO 8601 Sun=7
        return day === 0 ? 7 : day;
    };
    NgbCalendarGregorian.prototype.getWeekNumber = function (week, firstDayOfWeek) {
        // in JS Date Sun=0, in ISO 8601 Sun=7
        if (firstDayOfWeek === 7) {
            firstDayOfWeek = 0;
        }
        var thursdayIndex = (4 + 7 - firstDayOfWeek) % 7;
        var date = week[thursdayIndex];
        var jsDate = toJSDate(date);
        jsDate.setDate(jsDate.getDate() + 4 - (jsDate.getDay() || 7)); // Thursday
        var time = jsDate.getTime();
        jsDate.setMonth(0); // Compare with Jan 1
        jsDate.setDate(1);
        return Math.floor(Math.round((time - jsDate.getTime()) / 86400000) / 7) + 1;
    };
    NgbCalendarGregorian.prototype.getToday = function () { return fromJSDate(new Date()); };
    NgbCalendarGregorian.prototype.isValid = function (date) {
        if (!date || !isInteger(date.year) || !isInteger(date.month) || !isInteger(date.day)) {
            return false;
        }
        var jsDate = toJSDate(date);
        return !isNaN(jsDate.getTime()) && jsDate.getFullYear() === date.year && jsDate.getMonth() + 1 === date.month &&
            jsDate.getDate() === date.day;
    };
    return NgbCalendarGregorian;
}(NgbCalendar));





// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/index.js + 16 modules
var _esm5 = __webpack_require__("0nHL");

// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-tools.js


function isChangedDate(prev, next) {
    return !dateComparator(prev, next);
}
function dateComparator(prev, next) {
    return (!prev && !next) || (!!prev && !!next && prev.equals(next));
}
function checkMinBeforeMax(minDate, maxDate) {
    if (maxDate && minDate && maxDate.before(minDate)) {
        throw new Error("'maxDate' " + maxDate + " should be greater than 'minDate' " + minDate);
    }
}
function checkDateInRange(date, minDate, maxDate) {
    if (date && minDate && date.before(minDate)) {
        return NgbDate.from(minDate);
    }
    if (date && maxDate && date.after(maxDate)) {
        return NgbDate.from(maxDate);
    }
    return date;
}
function isDateSelectable(date, state) {
    var minDate = state.minDate, maxDate = state.maxDate, disabled = state.disabled, markDisabled = state.markDisabled;
    // clang-format off
    return !(!isDefined(date) ||
        disabled ||
        (markDisabled && markDisabled(date, { year: date.year, month: date.month })) ||
        (minDate && date.before(minDate)) ||
        (maxDate && date.after(maxDate)));
    // clang-format on
}
function generateSelectBoxMonths(calendar, date, minDate, maxDate) {
    if (!date) {
        return [];
    }
    var months = calendar.getMonths();
    if (minDate && date.year === minDate.year) {
        var index = months.findIndex(function (month) { return month === minDate.month; });
        months = months.slice(index);
    }
    if (maxDate && date.year === maxDate.year) {
        var index = months.findIndex(function (month) { return month === maxDate.month; });
        months = months.slice(0, index + 1);
    }
    return months;
}
function generateSelectBoxYears(date, minDate, maxDate) {
    if (!date) {
        return [];
    }
    var start = minDate && minDate.year || date.year - 10;
    var end = maxDate && maxDate.year || date.year + 10;
    return Array.from({ length: end - start + 1 }, function (e, i) { return start + i; });
}
function nextMonthDisabled(calendar, date, maxDate) {
    return maxDate && calendar.getNext(date, 'm').after(maxDate);
}
function prevMonthDisabled(calendar, date, minDate) {
    var prevDate = calendar.getPrev(date, 'm');
    return minDate && (prevDate.year === minDate.year && prevDate.month < minDate.month ||
        prevDate.year < minDate.year && minDate.month === 1);
}
function buildMonths(calendar, date, state, i18n, force) {
    var displayMonths = state.displayMonths, months = state.months;
    // move old months to a temporary array
    var monthsToReuse = months.splice(0, months.length);
    // generate new first dates, nullify or reuse months
    var firstDates = Array.from({ length: displayMonths }, function (_, i) {
        var firstDate = calendar.getNext(date, 'm', i);
        months[i] = null;
        if (!force) {
            var reusedIndex = monthsToReuse.findIndex(function (month) { return month.firstDate.equals(firstDate); });
            // move reused month back to months
            if (reusedIndex !== -1) {
                months[i] = monthsToReuse.splice(reusedIndex, 1)[0];
            }
        }
        return firstDate;
    });
    // rebuild nullified months
    firstDates.forEach(function (firstDate, i) {
        if (months[i] === null) {
            months[i] = buildMonth(calendar, firstDate, state, i18n, monthsToReuse.shift() || {});
        }
    });
    return months;
}
function buildMonth(calendar, date, state, i18n, month) {
    if (month === void 0) { month = {}; }
    var minDate = state.minDate, maxDate = state.maxDate, firstDayOfWeek = state.firstDayOfWeek, markDisabled = state.markDisabled, outsideDays = state.outsideDays;
    month.firstDate = null;
    month.lastDate = null;
    month.number = date.month;
    month.year = date.year;
    month.weeks = month.weeks || [];
    month.weekdays = month.weekdays || [];
    date = getFirstViewDate(calendar, date, firstDayOfWeek);
    // month has weeks
    for (var week = 0; week < calendar.getWeeksPerMonth(); week++) {
        var weekObject = month.weeks[week];
        if (!weekObject) {
            weekObject = month.weeks[week] = { number: 0, days: [], collapsed: true };
        }
        var days = weekObject.days;
        // week has days
        for (var day = 0; day < calendar.getDaysPerWeek(); day++) {
            if (week === 0) {
                month.weekdays[day] = calendar.getWeekday(date);
            }
            var newDate = new NgbDate(date.year, date.month, date.day);
            var nextDate = calendar.getNext(newDate);
            var ariaLabel = i18n.getDayAriaLabel(newDate);
            // marking date as disabled
            var disabled = !!((minDate && newDate.before(minDate)) || (maxDate && newDate.after(maxDate)));
            if (!disabled && markDisabled) {
                disabled = markDisabled(newDate, { month: month.number, year: month.year });
            }
            // saving first date of the month
            if (month.firstDate === null && newDate.month === month.number) {
                month.firstDate = newDate;
            }
            // saving last date of the month
            if (newDate.month === month.number && nextDate.month !== month.number) {
                month.lastDate = newDate;
            }
            var dayObject = days[day];
            if (!dayObject) {
                dayObject = days[day] = {};
            }
            dayObject.date = newDate;
            dayObject.context = Object.assign(dayObject.context || {}, {
                date: { year: newDate.year, month: newDate.month, day: newDate.day },
                currentMonth: month.number, disabled: disabled,
                focused: false,
                selected: false
            });
            dayObject.tabindex = -1;
            dayObject.ariaLabel = ariaLabel;
            dayObject.hidden = false;
            date = nextDate;
        }
        weekObject.number = calendar.getWeekNumber(days.map(function (day) { return NgbDate.from(day.date); }), firstDayOfWeek);
        // marking week as collapsed
        weekObject.collapsed = outsideDays === 'collapsed' && days[0].date.month !== month.number &&
            days[days.length - 1].date.month !== month.number;
    }
    return month;
}
function getFirstViewDate(calendar, date, firstDayOfWeek) {
    var daysPerWeek = calendar.getDaysPerWeek();
    var firstMonthDate = new NgbDate(date.year, date.month, 1);
    var dayOfWeek = calendar.getWeekday(firstMonthDate) % daysPerWeek;
    return calendar.getPrev(firstMonthDate, 'd', (daysPerWeek + dayOfWeek - firstDayOfWeek) % daysPerWeek);
}
//# sourceMappingURL=datepicker-tools.js.map
// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n.js
var datepicker_i18n___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * Type of the service supplying month and weekday names to to NgbDatepicker component.
 * The default implementation of this service honors the Angular locale, and uses the registered locale data,
 * as explained in the Angular i18n guide.
 * See the i18n demo for how to extend this class and define a custom provider for i18n.
 */
var NgbDatepickerI18n = /*@__PURE__*/ (function () {
    function NgbDatepickerI18n() {
    }
    return NgbDatepickerI18n;
}());

var datepicker_i18n_NgbDatepickerI18nDefault = /*@__PURE__*/ (function (_super) {
    datepicker_i18n___extends(NgbDatepickerI18nDefault, _super);
    function NgbDatepickerI18nDefault(_locale, _datePipe) {
        var _this = _super.call(this) || this;
        _this._locale = _locale;
        _this._datePipe = _datePipe;
        var weekdaysStartingOnSunday = Object(common["getLocaleDayNames"])(_locale, common["FormStyle"].Standalone, common["TranslationWidth"].Short);
        _this._weekdaysShort = weekdaysStartingOnSunday.map(function (day, index) { return weekdaysStartingOnSunday[(index + 1) % 7]; });
        _this._monthsShort = Object(common["getLocaleMonthNames"])(_locale, common["FormStyle"].Standalone, common["TranslationWidth"].Abbreviated);
        _this._monthsFull = Object(common["getLocaleMonthNames"])(_locale, common["FormStyle"].Standalone, common["TranslationWidth"].Wide);
        return _this;
    }
    NgbDatepickerI18nDefault.prototype.getWeekdayShortName = function (weekday) { return this._weekdaysShort[weekday - 1]; };
    NgbDatepickerI18nDefault.prototype.getMonthShortName = function (month) { return this._monthsShort[month - 1]; };
    NgbDatepickerI18nDefault.prototype.getMonthFullName = function (month) { return this._monthsFull[month - 1]; };
    NgbDatepickerI18nDefault.prototype.getDayAriaLabel = function (date) {
        var jsDate = new Date(date.year, date.month - 1, date.day);
        return this._datePipe.transform(jsDate, 'fullDate', null, this._locale);
    };
    return NgbDatepickerI18nDefault;
}(NgbDatepickerI18n));





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-service.js








var datepicker_service_NgbDatepickerService = /*@__PURE__*/ (function () {
    function NgbDatepickerService(_calendar, _i18n) {
        this._calendar = _calendar;
        this._i18n = _i18n;
        this._model$ = new _esm5["e" /* Subject */]();
        this._select$ = new _esm5["e" /* Subject */]();
        this._state = {
            disabled: false,
            displayMonths: 1,
            firstDayOfWeek: 1,
            focusVisible: false,
            months: [],
            navigation: 'select',
            outsideDays: 'visible',
            prevDisabled: false,
            nextDisabled: false,
            selectBoxes: { years: [], months: [] },
            selectedDate: null
        };
    }
    Object.defineProperty(NgbDatepickerService.prototype, "model$", {
        get: function () { return this._model$.pipe(Object(operators["filter"])(function (model) { return model.months.length > 0; })); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "select$", {
        get: function () { return this._select$.pipe(Object(operators["filter"])(function (date) { return date !== null; })); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "disabled", {
        set: function (disabled) {
            if (this._state.disabled !== disabled) {
                this._nextState({ disabled: disabled });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "displayMonths", {
        set: function (displayMonths) {
            displayMonths = toInteger(displayMonths);
            if (isInteger(displayMonths) && displayMonths > 0 && this._state.displayMonths !== displayMonths) {
                this._nextState({ displayMonths: displayMonths });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "firstDayOfWeek", {
        set: function (firstDayOfWeek) {
            firstDayOfWeek = toInteger(firstDayOfWeek);
            if (isInteger(firstDayOfWeek) && firstDayOfWeek >= 0 && this._state.firstDayOfWeek !== firstDayOfWeek) {
                this._nextState({ firstDayOfWeek: firstDayOfWeek });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "focusVisible", {
        set: function (focusVisible) {
            if (this._state.focusVisible !== focusVisible && !this._state.disabled) {
                this._nextState({ focusVisible: focusVisible });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "maxDate", {
        set: function (date) {
            var maxDate = this.toValidDate(date, null);
            if (isChangedDate(this._state.maxDate, maxDate)) {
                this._nextState({ maxDate: maxDate });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "markDisabled", {
        set: function (markDisabled) {
            if (this._state.markDisabled !== markDisabled) {
                this._nextState({ markDisabled: markDisabled });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "minDate", {
        set: function (date) {
            var minDate = this.toValidDate(date, null);
            if (isChangedDate(this._state.minDate, minDate)) {
                this._nextState({ minDate: minDate });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "navigation", {
        set: function (navigation) {
            if (this._state.navigation !== navigation) {
                this._nextState({ navigation: navigation });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgbDatepickerService.prototype, "outsideDays", {
        set: function (outsideDays) {
            if (this._state.outsideDays !== outsideDays) {
                this._nextState({ outsideDays: outsideDays });
            }
        },
        enumerable: true,
        configurable: true
    });
    NgbDatepickerService.prototype.focus = function (date) {
        if (!this._state.disabled && this._calendar.isValid(date) && isChangedDate(this._state.focusDate, date)) {
            this._nextState({ focusDate: date });
        }
    };
    NgbDatepickerService.prototype.focusMove = function (period, number) {
        this.focus(this._calendar.getNext(this._state.focusDate, period, number));
    };
    NgbDatepickerService.prototype.focusSelect = function () {
        if (isDateSelectable(this._state.focusDate, this._state)) {
            this.select(this._state.focusDate, { emitEvent: true });
        }
    };
    NgbDatepickerService.prototype.open = function (date) {
        var firstDate = this.toValidDate(date, this._calendar.getToday());
        if (!this._state.disabled) {
            this._nextState({ firstDate: firstDate });
        }
    };
    NgbDatepickerService.prototype.select = function (date, options) {
        if (options === void 0) {
            options = {};
        }
        var selectedDate = this.toValidDate(date, null);
        if (!this._state.disabled) {
            if (isChangedDate(this._state.selectedDate, selectedDate)) {
                this._nextState({ selectedDate: selectedDate });
            }
            if (options.emitEvent && isDateSelectable(selectedDate, this._state)) {
                this._select$.next(selectedDate);
            }
        }
    };
    NgbDatepickerService.prototype.toValidDate = function (date, defaultValue) {
        var ngbDate = NgbDate.from(date);
        if (defaultValue === undefined) {
            defaultValue = this._calendar.getToday();
        }
        return this._calendar.isValid(ngbDate) ? ngbDate : defaultValue;
    };
    NgbDatepickerService.prototype._nextState = function (patch) {
        var newState = this._updateState(patch);
        this._patchContexts(newState);
        this._state = newState;
        this._model$.next(this._state);
    };
    NgbDatepickerService.prototype._patchContexts = function (state) {
        var months = state.months, displayMonths = state.displayMonths, selectedDate = state.selectedDate, focusDate = state.focusDate, focusVisible = state.focusVisible, disabled = state.disabled, outsideDays = state.outsideDays;
        state.months.forEach(function (month) {
            month.weeks.forEach(function (week) {
                week.days.forEach(function (day) {
                    // patch focus flag
                    if (focusDate) {
                        day.context.focused = focusDate.equals(day.date) && focusVisible;
                    }
                    // calculating tabindex
                    day.tabindex = !disabled && day.date.equals(focusDate) && focusDate.month === month.number ? 0 : -1;
                    // override context disabled
                    if (disabled === true) {
                        day.context.disabled = true;
                    }
                    // patch selection flag
                    if (selectedDate !== undefined) {
                        day.context.selected = selectedDate !== null && selectedDate.equals(day.date);
                    }
                    // visibility
                    if (month.number !== day.date.month) {
                        day.hidden = outsideDays === 'hidden' || outsideDays === 'collapsed' ||
                            (displayMonths > 1 && day.date.after(months[0].firstDate) &&
                                day.date.before(months[displayMonths - 1].lastDate));
                    }
                });
            });
        });
    };
    NgbDatepickerService.prototype._updateState = function (patch) {
        // patching fields
        var state = Object.assign({}, this._state, patch);
        var startDate = state.firstDate;
        // min/max dates changed
        if ('minDate' in patch || 'maxDate' in patch) {
            checkMinBeforeMax(state.minDate, state.maxDate);
            state.focusDate = checkDateInRange(state.focusDate, state.minDate, state.maxDate);
            state.firstDate = checkDateInRange(state.firstDate, state.minDate, state.maxDate);
            startDate = state.focusDate;
        }
        // disabled
        if ('disabled' in patch) {
            state.focusVisible = false;
        }
        // initial rebuild via 'select()'
        if ('selectedDate' in patch && this._state.months.length === 0) {
            startDate = state.selectedDate;
        }
        // focus date changed
        if ('focusDate' in patch) {
            state.focusDate = checkDateInRange(state.focusDate, state.minDate, state.maxDate);
            startDate = state.focusDate;
            // nothing to rebuild if only focus changed and it is still visible
            if (state.months.length !== 0 && !state.focusDate.before(state.firstDate) &&
                !state.focusDate.after(state.lastDate)) {
                return state;
            }
        }
        // first date changed
        if ('firstDate' in patch) {
            state.firstDate = checkDateInRange(state.firstDate, state.minDate, state.maxDate);
            startDate = state.firstDate;
        }
        // rebuilding months
        if (startDate) {
            var forceRebuild = 'firstDayOfWeek' in patch || 'markDisabled' in patch || 'minDate' in patch ||
                'maxDate' in patch || 'disabled' in patch || 'outsideDays' in patch;
            var months = buildMonths(this._calendar, startDate, state, this._i18n, forceRebuild);
            // updating months and boundary dates
            state.months = months;
            state.firstDate = months.length > 0 ? months[0].firstDate : undefined;
            state.lastDate = months.length > 0 ? months[months.length - 1].lastDate : undefined;
            // reset selected date if 'markDisabled' returns true
            if ('selectedDate' in patch && !isDateSelectable(state.selectedDate, state)) {
                state.selectedDate = null;
            }
            // adjusting focus after months were built
            if ('firstDate' in patch) {
                if (state.focusDate === undefined || state.focusDate.before(state.firstDate) ||
                    state.focusDate.after(state.lastDate)) {
                    state.focusDate = startDate;
                }
            }
            // adjusting months/years for the select box navigation
            var yearChanged = !this._state.firstDate || this._state.firstDate.year !== state.firstDate.year;
            var monthChanged = !this._state.firstDate || this._state.firstDate.month !== state.firstDate.month;
            if (state.navigation === 'select') {
                // years ->  boundaries (min/max were changed)
                if ('minDate' in patch || 'maxDate' in patch || state.selectBoxes.years.length === 0 || yearChanged) {
                    state.selectBoxes.years = generateSelectBoxYears(state.firstDate, state.minDate, state.maxDate);
                }
                // months -> when current year or boundaries change
                if ('minDate' in patch || 'maxDate' in patch || state.selectBoxes.months.length === 0 || yearChanged) {
                    state.selectBoxes.months =
                        generateSelectBoxMonths(this._calendar, state.firstDate, state.minDate, state.maxDate);
                }
            }
            else {
                state.selectBoxes = { years: [], months: [] };
            }
            // updating navigation arrows -> boundaries change (min/max) or month/year changes
            if ((state.navigation === 'arrows' || state.navigation === 'select') &&
                (monthChanged || yearChanged || 'minDate' in patch || 'maxDate' in patch || 'disabled' in patch)) {
                state.prevDisabled = state.disabled || prevMonthDisabled(this._calendar, state.firstDate, state.minDate);
                state.nextDisabled = state.disabled || nextMonthDisabled(this._calendar, state.lastDate, state.maxDate);
            }
        }
        return state;
    };
    return NgbDatepickerService;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/util/key.js
var Key;
(function (Key) {
    Key[Key["Tab"] = 9] = "Tab";
    Key[Key["Enter"] = 13] = "Enter";
    Key[Key["Escape"] = 27] = "Escape";
    Key[Key["Space"] = 32] = "Space";
    Key[Key["PageUp"] = 33] = "PageUp";
    Key[Key["PageDown"] = 34] = "PageDown";
    Key[Key["End"] = 35] = "End";
    Key[Key["Home"] = 36] = "Home";
    Key[Key["ArrowLeft"] = 37] = "ArrowLeft";
    Key[Key["ArrowUp"] = 38] = "ArrowUp";
    Key[Key["ArrowRight"] = 39] = "ArrowRight";
    Key[Key["ArrowDown"] = 40] = "ArrowDown";
})(Key || (Key = {}));
//# sourceMappingURL=key.js.map
// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-keymap-service.js





var datepicker_keymap_service_NgbDatepickerKeyMapService = /*@__PURE__*/ (function () {
    function NgbDatepickerKeyMapService(_service, _calendar) {
        var _this = this;
        this._service = _service;
        this._calendar = _calendar;
        _service.model$.subscribe(function (model) {
            _this._minDate = model.minDate;
            _this._maxDate = model.maxDate;
            _this._firstViewDate = model.firstDate;
            _this._lastViewDate = model.lastDate;
        });
    }
    NgbDatepickerKeyMapService.prototype.processKey = function (event) {
        if (Key[util_toString(event.which)]) {
            switch (event.which) {
                case Key.PageUp:
                    this._service.focusMove(event.shiftKey ? 'y' : 'm', -1);
                    break;
                case Key.PageDown:
                    this._service.focusMove(event.shiftKey ? 'y' : 'm', 1);
                    break;
                case Key.End:
                    this._service.focus(event.shiftKey ? this._maxDate : this._lastViewDate);
                    break;
                case Key.Home:
                    this._service.focus(event.shiftKey ? this._minDate : this._firstViewDate);
                    break;
                case Key.ArrowLeft:
                    this._service.focusMove('d', -1);
                    break;
                case Key.ArrowUp:
                    this._service.focusMove('d', -this._calendar.getDaysPerWeek());
                    break;
                case Key.ArrowRight:
                    this._service.focusMove('d', 1);
                    break;
                case Key.ArrowDown:
                    this._service.focusMove('d', this._calendar.getDaysPerWeek());
                    break;
                case Key.Enter:
                case Key.Space:
                    this._service.focusSelect();
                    break;
                default:
                    return;
            }
            event.preventDefault();
            event.stopPropagation();
        }
    };
    return NgbDatepickerKeyMapService;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model.js
// clang-format on
// clang-format on
var NavigationEvent;
// clang-format on
(function (NavigationEvent) {
    NavigationEvent[NavigationEvent["PREV"] = 0] = "PREV";
    NavigationEvent[NavigationEvent["NEXT"] = 1] = "NEXT";
})(NavigationEvent || (NavigationEvent = {}));
//# sourceMappingURL=datepicker-view-model.js.map
// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-config.js

/**
 * Configuration service for the NgbDatepicker component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the datepickers used in the application.
 */
var NgbDatepickerConfig = /*@__PURE__*/ (function () {
    function NgbDatepickerConfig() {
        this.displayMonths = 1;
        this.firstDayOfWeek = 1;
        this.navigation = 'select';
        this.outsideDays = 'visible';
        this.showWeekdays = true;
        this.showWeekNumbers = false;
    }
    return NgbDatepickerConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/adapters/ngb-date-adapter.js
var ngb_date_adapter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * Abstract type serving as a DI token for the service converting from your application Date model to internal
 * NgbDateStruct model.
 * A default implementation converting from and to NgbDateStruct is provided for retro-compatibility,
 * but you can provide another implementation to use an alternative format, ie for using with native Date Object.
 */
var NgbDateAdapter = /*@__PURE__*/ (function () {
    function NgbDateAdapter() {
    }
    return NgbDateAdapter;
}());

var NgbDateStructAdapter = /*@__PURE__*/ (function (_super) {
    ngb_date_adapter___extends(NgbDateStructAdapter, _super);
    function NgbDateStructAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Converts a NgbDateStruct value into NgbDateStruct value
     * @param  {NgbDateStruct} value
     * @return {NgbDateStruct}
     */
    /**
       * Converts a NgbDateStruct value into NgbDateStruct value
       * @param  {NgbDateStruct} value
       * @return {NgbDateStruct}
       */
    NgbDateStructAdapter.prototype.fromModel = /**
       * Converts a NgbDateStruct value into NgbDateStruct value
       * @param  {NgbDateStruct} value
       * @return {NgbDateStruct}
       */
        function (date) {
            return (date && date.year && date.month && date.day) ? { year: date.year, month: date.month, day: date.day } : null;
        };
    /**
     * Converts a NgbDateStruct value into NgbDateStruct value
     * @param  {NgbDateStruct} value
     * @return {NgbDateStruct}
     */
    /**
       * Converts a NgbDateStruct value into NgbDateStruct value
       * @param  {NgbDateStruct} value
       * @return {NgbDateStruct}
       */
    NgbDateStructAdapter.prototype.toModel = /**
       * Converts a NgbDateStruct value into NgbDateStruct value
       * @param  {NgbDateStruct} value
       * @return {NgbDateStruct}
       */
        function (date) {
            return (date && date.year && date.month && date.day) ? { year: date.year, month: date.month, day: date.day } : null;
        };
    return NgbDateStructAdapter;
}(NgbDateAdapter));





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker.js












var NGB_DATEPICKER_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    useExisting: Object(core["forwardRef"])(function () { return datepicker_NgbDatepicker; }),
    multi: true
};
/**
 * A lightweight and highly configurable datepicker directive
 */
var datepicker_NgbDatepicker = /*@__PURE__*/ (function () {
    function NgbDatepicker(_keyMapService, _service, _calendar, i18n, config, _cd, _elementRef, _ngbDateAdapter, _ngZone) {
        var _this = this;
        this._keyMapService = _keyMapService;
        this._service = _service;
        this._calendar = _calendar;
        this.i18n = i18n;
        this._cd = _cd;
        this._elementRef = _elementRef;
        this._ngbDateAdapter = _ngbDateAdapter;
        this._ngZone = _ngZone;
        /**
           * An event fired when navigation happens and currently displayed month changes.
           * See NgbDatepickerNavigateEvent for the payload info.
           */
        this.navigate = new core["EventEmitter"]();
        /**
           * An event fired when user selects a date using keyboard or mouse.
           * The payload of the event is currently selected NgbDateStruct.
           */
        this.select = new core["EventEmitter"]();
        this.onChange = function (_) { };
        this.onTouched = function () { };
        ['dayTemplate', 'displayMonths', 'firstDayOfWeek', 'markDisabled', 'minDate', 'maxDate', 'navigation',
            'outsideDays', 'showWeekdays', 'showWeekNumbers', 'startDate']
            .forEach(function (input) { return _this[input] = config[input]; });
        this._selectSubscription = _service.select$.subscribe(function (date) { _this.select.emit(date.toStruct()); });
        this._subscription = _service.model$.subscribe(function (model) {
            var newDate = model.firstDate;
            var oldDate = _this.model ? _this.model.firstDate : null;
            var newSelectedDate = model.selectedDate;
            var oldSelectedDate = _this.model ? _this.model.selectedDate : null;
            var newFocusedDate = model.focusDate;
            var oldFocusedDate = _this.model ? _this.model.focusDate : null;
            _this.model = model;
            // handling selection change
            if (isChangedDate(newSelectedDate, oldSelectedDate)) {
                _this.onTouched();
                _this.onChange(_this._ngbDateAdapter.toModel(newSelectedDate));
            }
            // handling focus change
            if (isChangedDate(newFocusedDate, oldFocusedDate) && oldFocusedDate && model.focusVisible) {
                _this.focus();
            }
            // emitting navigation event if the first month changes
            if (!newDate.equals(oldDate)) {
                _this.navigate.emit({
                    current: oldDate ? { year: oldDate.year, month: oldDate.month } : null,
                    next: { year: newDate.year, month: newDate.month }
                });
            }
            _cd.markForCheck();
        });
    }
    /**
     * Manually focus the focusable day in the datepicker
     */
    /**
       * Manually focus the focusable day in the datepicker
       */
    NgbDatepicker.prototype.focus = /**
       * Manually focus the focusable day in the datepicker
       */
        function () {
            var _this = this;
            this._ngZone.onStable.asObservable().pipe(Object(operators["take"])(1)).subscribe(function () {
                var elementToFocus = _this._elementRef.nativeElement.querySelector('div.ngb-dp-day[tabindex="0"]');
                if (elementToFocus) {
                    elementToFocus.focus();
                }
            });
        };
    /**
     * Navigates current view to provided date.
     * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
     * If nothing or invalid date provided calendar will open current month.
     * Use 'startDate' input as an alternative
     */
    /**
       * Navigates current view to provided date.
       * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
       * If nothing or invalid date provided calendar will open current month.
       * Use 'startDate' input as an alternative
       */
    NgbDatepicker.prototype.navigateTo = /**
       * Navigates current view to provided date.
       * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
       * If nothing or invalid date provided calendar will open current month.
       * Use 'startDate' input as an alternative
       */
        function (date) { this._service.open(NgbDate.from(date)); };
    NgbDatepicker.prototype.ngOnDestroy = function () {
        this._subscription.unsubscribe();
        this._selectSubscription.unsubscribe();
    };
    NgbDatepicker.prototype.ngOnInit = function () {
        var _this = this;
        if (this.model === undefined) {
            ['displayMonths', 'markDisabled', 'firstDayOfWeek', 'navigation', 'minDate', 'maxDate', 'outsideDays'].forEach(function (input) { return _this._service[input] = _this[input]; });
            this.navigateTo(this.startDate);
        }
    };
    NgbDatepicker.prototype.ngOnChanges = function (changes) {
        var _this = this;
        ['displayMonths', 'markDisabled', 'firstDayOfWeek', 'navigation', 'minDate', 'maxDate', 'outsideDays']
            .filter(function (input) { return input in changes; })
            .forEach(function (input) { return _this._service[input] = _this[input]; });
        if ('startDate' in changes) {
            this.navigateTo(this.startDate);
        }
    };
    NgbDatepicker.prototype.onDateSelect = function (date) {
        this._service.focus(date);
        this._service.select(date, { emitEvent: true });
    };
    NgbDatepicker.prototype.onKeyDown = function (event) { this._keyMapService.processKey(event); };
    NgbDatepicker.prototype.onNavigateDateSelect = function (date) { this._service.open(date); };
    NgbDatepicker.prototype.onNavigateEvent = function (event) {
        switch (event) {
            case NavigationEvent.PREV:
                this._service.open(this._calendar.getPrev(this.model.firstDate, 'm', 1));
                break;
            case NavigationEvent.NEXT:
                this._service.open(this._calendar.getNext(this.model.firstDate, 'm', 1));
                break;
        }
    };
    NgbDatepicker.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbDatepicker.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbDatepicker.prototype.setDisabledState = function (isDisabled) { this._service.disabled = isDisabled; };
    NgbDatepicker.prototype.showFocus = function (focusVisible) { this._service.focusVisible = focusVisible; };
    NgbDatepicker.prototype.writeValue = function (value) { this._service.select(NgbDate.from(this._ngbDateAdapter.fromModel(value))); };
    return NgbDatepicker;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-month-view.js



var datepicker_month_view_NgbDatepickerMonthView = /*@__PURE__*/ (function () {
    function NgbDatepickerMonthView(i18n) {
        this.i18n = i18n;
        this.select = new core["EventEmitter"]();
    }
    NgbDatepickerMonthView.prototype.doSelect = function (day) {
        if (!day.context.disabled && !day.hidden) {
            this.select.emit(NgbDate.from(day.date));
        }
    };
    return NgbDatepickerMonthView;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation.js



// The -ms- and -webkit- element for the CSS can be removed if we are generating the CSS using SASS.
var datepicker_navigation_NgbDatepickerNavigation = /*@__PURE__*/ (function () {
    function NgbDatepickerNavigation(i18n) {
        this.i18n = i18n;
        this.navigation = NavigationEvent;
        this.months = [];
        this.navigate = new core["EventEmitter"]();
        this.select = new core["EventEmitter"]();
    }
    return NgbDatepickerNavigation;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-parser-formatter.js
var ngb_date_parser_formatter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * Abstract type serving as a DI token for the service parsing and formatting dates for the NgbInputDatepicker
 * directive. A default implementation using the ISO 8601 format is provided, but you can provide another implementation
 * to use an alternative format.
 */
var /**
 * Abstract type serving as a DI token for the service parsing and formatting dates for the NgbInputDatepicker
 * directive. A default implementation using the ISO 8601 format is provided, but you can provide another implementation
 * to use an alternative format.
 */ NgbDateParserFormatter = /*@__PURE__*/ (function () {
    function NgbDateParserFormatter() {
    }
    return NgbDateParserFormatter;
}());
/**
 * Abstract type serving as a DI token for the service parsing and formatting dates for the NgbInputDatepicker
 * directive. A default implementation using the ISO 8601 format is provided, but you can provide another implementation
 * to use an alternative format.
 */

var ngb_date_parser_formatter_NgbDateISOParserFormatter = /*@__PURE__*/ (function (_super) {
    ngb_date_parser_formatter___extends(NgbDateISOParserFormatter, _super);
    function NgbDateISOParserFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbDateISOParserFormatter.prototype.parse = function (value) {
        if (value) {
            var dateParts = value.trim().split('-');
            if (dateParts.length === 1 && isNumber(dateParts[0])) {
                return { year: toInteger(dateParts[0]), month: null, day: null };
            }
            else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
                return { year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: null };
            }
            else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
                return { year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: toInteger(dateParts[2]) };
            }
        }
        return null;
    };
    NgbDateISOParserFormatter.prototype.format = function (date) {
        return date ?
            date.year + "-" + (isNumber(date.month) ? padNumber(date.month) : '') + "-" + (isNumber(date.day) ? padNumber(date.day) : '') :
            '';
    };
    return NgbDateISOParserFormatter;
}(NgbDateParserFormatter));





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/util/positioning.js
// previous version:
// https://github.com/angular-ui/bootstrap/blob/07c31d0731f7cb068a1932b8e01d2312b796b4ec/src/position/position.js
var 
// previous version:
// https://github.com/angular-ui/bootstrap/blob/07c31d0731f7cb068a1932b8e01d2312b796b4ec/src/position/position.js
Positioning = /** @class */ (function () {
    function Positioning() {
    }
    Positioning.prototype.getAllStyles = function (element) { return window.getComputedStyle(element); };
    Positioning.prototype.getStyle = function (element, prop) { return this.getAllStyles(element)[prop]; };
    Positioning.prototype.isStaticPositioned = function (element) {
        return (this.getStyle(element, 'position') || 'static') === 'static';
    };
    Positioning.prototype.offsetParent = function (element) {
        var offsetParentEl = element.offsetParent || document.documentElement;
        while (offsetParentEl && offsetParentEl !== document.documentElement && this.isStaticPositioned(offsetParentEl)) {
            offsetParentEl = offsetParentEl.offsetParent;
        }
        return offsetParentEl || document.documentElement;
    };
    Positioning.prototype.position = function (element, round) {
        if (round === void 0) { round = true; }
        var elPosition;
        var parentOffset = { width: 0, height: 0, top: 0, bottom: 0, left: 0, right: 0 };
        if (this.getStyle(element, 'position') === 'fixed') {
            elPosition = element.getBoundingClientRect();
        }
        else {
            var offsetParentEl = this.offsetParent(element);
            elPosition = this.offset(element, false);
            if (offsetParentEl !== document.documentElement) {
                parentOffset = this.offset(offsetParentEl, false);
            }
            parentOffset.top += offsetParentEl.clientTop;
            parentOffset.left += offsetParentEl.clientLeft;
        }
        elPosition.top -= parentOffset.top;
        elPosition.bottom -= parentOffset.top;
        elPosition.left -= parentOffset.left;
        elPosition.right -= parentOffset.left;
        if (round) {
            elPosition.top = Math.round(elPosition.top);
            elPosition.bottom = Math.round(elPosition.bottom);
            elPosition.left = Math.round(elPosition.left);
            elPosition.right = Math.round(elPosition.right);
        }
        return elPosition;
    };
    Positioning.prototype.offset = function (element, round) {
        if (round === void 0) { round = true; }
        var elBcr = element.getBoundingClientRect();
        var viewportOffset = {
            top: window.pageYOffset - document.documentElement.clientTop,
            left: window.pageXOffset - document.documentElement.clientLeft
        };
        var elOffset = {
            height: elBcr.height || element.offsetHeight,
            width: elBcr.width || element.offsetWidth,
            top: elBcr.top + viewportOffset.top,
            bottom: elBcr.bottom + viewportOffset.top,
            left: elBcr.left + viewportOffset.left,
            right: elBcr.right + viewportOffset.left
        };
        if (round) {
            elOffset.height = Math.round(elOffset.height);
            elOffset.width = Math.round(elOffset.width);
            elOffset.top = Math.round(elOffset.top);
            elOffset.bottom = Math.round(elOffset.bottom);
            elOffset.left = Math.round(elOffset.left);
            elOffset.right = Math.round(elOffset.right);
        }
        return elOffset;
    };
    Positioning.prototype.positionElements = function (hostElement, targetElement, placement, appendToBody) {
        var hostElPosition = appendToBody ? this.offset(hostElement, false) : this.position(hostElement, false);
        var targetElStyles = this.getAllStyles(targetElement);
        var targetElBCR = targetElement.getBoundingClientRect();
        var placementPrimary = placement.split('-')[0] || 'top';
        var placementSecondary = placement.split('-')[1] || 'center';
        var targetElPosition = {
            'height': targetElBCR.height || targetElement.offsetHeight,
            'width': targetElBCR.width || targetElement.offsetWidth,
            'top': 0,
            'bottom': targetElBCR.height || targetElement.offsetHeight,
            'left': 0,
            'right': targetElBCR.width || targetElement.offsetWidth
        };
        switch (placementPrimary) {
            case 'top':
                targetElPosition.top =
                    hostElPosition.top - (targetElement.offsetHeight + parseFloat(targetElStyles.marginBottom));
                break;
            case 'bottom':
                targetElPosition.top = hostElPosition.top + hostElPosition.height;
                break;
            case 'left':
                targetElPosition.left =
                    hostElPosition.left - (targetElement.offsetWidth + parseFloat(targetElStyles.marginRight));
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width;
                break;
        }
        switch (placementSecondary) {
            case 'top':
                targetElPosition.top = hostElPosition.top;
                break;
            case 'bottom':
                targetElPosition.top = hostElPosition.top + hostElPosition.height - targetElement.offsetHeight;
                break;
            case 'left':
                targetElPosition.left = hostElPosition.left;
                break;
            case 'right':
                targetElPosition.left = hostElPosition.left + hostElPosition.width - targetElement.offsetWidth;
                break;
            case 'center':
                if (placementPrimary === 'top' || placementPrimary === 'bottom') {
                    targetElPosition.left = hostElPosition.left + hostElPosition.width / 2 - targetElement.offsetWidth / 2;
                }
                else {
                    targetElPosition.top = hostElPosition.top + hostElPosition.height / 2 - targetElement.offsetHeight / 2;
                }
                break;
        }
        targetElPosition.top = Math.round(targetElPosition.top);
        targetElPosition.bottom = Math.round(targetElPosition.bottom);
        targetElPosition.left = Math.round(targetElPosition.left);
        targetElPosition.right = Math.round(targetElPosition.right);
        return targetElPosition;
    };
    // get the availble placements of the target element in the viewport dependeing on the host element
    // get the availble placements of the target element in the viewport dependeing on the host element
    Positioning.prototype.getAvailablePlacements = 
    // get the availble placements of the target element in the viewport dependeing on the host element
    function (hostElement, targetElement) {
        var availablePlacements = [];
        var hostElemClientRect = hostElement.getBoundingClientRect();
        var targetElemClientRect = targetElement.getBoundingClientRect();
        var html = document.documentElement;
        var windowHeight = window.innerHeight || html.clientHeight;
        var windowWidth = window.innerWidth || html.clientWidth;
        var hostElemClientRectHorCenter = hostElemClientRect.left + hostElemClientRect.width / 2;
        var hostElemClientRectVerCenter = hostElemClientRect.top + hostElemClientRect.height / 2;
        // left: check if target width can be placed between host left and viewport start and also height of target is
        // inside viewport
        if (targetElemClientRect.width < hostElemClientRect.left) {
            // check for left only
            if (hostElemClientRectVerCenter > targetElemClientRect.height / 2 &&
                windowHeight - hostElemClientRectVerCenter > targetElemClientRect.height / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'left');
            }
            // check for left-top and left-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'left', availablePlacements);
        }
        // top: target height is less than host top
        if (targetElemClientRect.height < hostElemClientRect.top) {
            if (hostElemClientRectHorCenter > targetElemClientRect.width / 2 &&
                windowWidth - hostElemClientRectHorCenter > targetElemClientRect.width / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'top');
            }
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'top', availablePlacements);
        }
        // right: check if target width can be placed between host right and viewport end and also height of target is
        // inside viewport
        if (windowWidth - hostElemClientRect.right > targetElemClientRect.width) {
            // check for right only
            if (hostElemClientRectVerCenter > targetElemClientRect.height / 2 &&
                windowHeight - hostElemClientRectVerCenter > targetElemClientRect.height / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'right');
            }
            // check for right-top and right-bottom
            this.setSecondaryPlacementForLeftRight(hostElemClientRect, targetElemClientRect, 'right', availablePlacements);
        }
        // bottom: check if there is enough space between host bottom and viewport end for target height
        if (windowHeight - hostElemClientRect.bottom > targetElemClientRect.height) {
            if (hostElemClientRectHorCenter > targetElemClientRect.width / 2 &&
                windowWidth - hostElemClientRectHorCenter > targetElemClientRect.width / 2) {
                availablePlacements.splice(availablePlacements.length, 1, 'bottom');
            }
            this.setSecondaryPlacementForTopBottom(hostElemClientRect, targetElemClientRect, 'bottom', availablePlacements);
        }
        return availablePlacements;
    };
    /**
     * check if secondary placement for left and right are available i.e. left-top, left-bottom, right-top, right-bottom
     * primaryplacement: left|right
     * availablePlacementArr: array in which available placemets to be set
     */
    /**
       * check if secondary placement for left and right are available i.e. left-top, left-bottom, right-top, right-bottom
       * primaryplacement: left|right
       * availablePlacementArr: array in which available placemets to be set
       */
    Positioning.prototype.setSecondaryPlacementForLeftRight = /**
       * check if secondary placement for left and right are available i.e. left-top, left-bottom, right-top, right-bottom
       * primaryplacement: left|right
       * availablePlacementArr: array in which available placemets to be set
       */
    function (hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        var html = document.documentElement;
        // check for left-bottom
        if (targetElemClientRect.height <= hostElemClientRect.bottom) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-bottom');
        }
        if ((window.innerHeight || html.clientHeight) - hostElemClientRect.top >= targetElemClientRect.height) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-top');
        }
    };
    /**
     * check if secondary placement for top and bottom are available i.e. top-left, top-right, bottom-left, bottom-right
     * primaryplacement: top|bottom
     * availablePlacementArr: array in which available placemets to be set
     */
    /**
       * check if secondary placement for top and bottom are available i.e. top-left, top-right, bottom-left, bottom-right
       * primaryplacement: top|bottom
       * availablePlacementArr: array in which available placemets to be set
       */
    Positioning.prototype.setSecondaryPlacementForTopBottom = /**
       * check if secondary placement for top and bottom are available i.e. top-left, top-right, bottom-left, bottom-right
       * primaryplacement: top|bottom
       * availablePlacementArr: array in which available placemets to be set
       */
    function (hostElemClientRect, targetElemClientRect, primaryPlacement, availablePlacementArr) {
        var html = document.documentElement;
        // check for left-bottom
        if ((window.innerWidth || html.clientWidth) - hostElemClientRect.left >= targetElemClientRect.width) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-left');
        }
        if (targetElemClientRect.width <= hostElemClientRect.right) {
            availablePlacementArr.splice(availablePlacementArr.length, 1, primaryPlacement + '-right');
        }
    };
    return Positioning;
}());
// previous version:
// https://github.com/angular-ui/bootstrap/blob/07c31d0731f7cb068a1932b8e01d2312b796b4ec/src/position/position.js

var positionService = new Positioning();
/*
 * Accept the placement array and applies the appropriate placement dependent on the viewport.
 * Returns the applied placement.
 * In case of auto placement, placements are selected in order
 *   'top', 'bottom', 'left', 'right',
 *   'top-left', 'top-right',
 *   'bottom-left', 'bottom-right',
 *   'left-top', 'left-bottom',
 *   'right-top', 'right-bottom'.
 * */
function positionElements(hostElement, targetElement, placement, appendToBody) {
    var placementVals = Array.isArray(placement) ? placement : [placement];
    // replace auto placement with other placements
    var hasAuto = placementVals.findIndex(function (val) { return val === 'auto'; });
    if (hasAuto >= 0) {
        ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'left-top',
            'left-bottom', 'right-top', 'right-bottom',
        ].forEach(function (obj) {
            if (placementVals.find(function (val) { return val.search('^' + obj) !== -1; }) == null) {
                placementVals.splice(hasAuto++, 1, obj);
            }
        });
    }
    // coordinates where to position
    var topVal = 0, leftVal = 0;
    var appliedPlacement;
    // get available placements
    var availablePlacements = positionService.getAvailablePlacements(hostElement, targetElement);
    var _loop_1 = function (item, index) {
        // check if passed placement is present in the available placement or otherwise apply the last placement in the
        // passed placement list
        if ((availablePlacements.find(function (val) { return val === item; }) != null) || (placementVals.length === index + 1)) {
            appliedPlacement = item;
            var pos = positionService.positionElements(hostElement, targetElement, item, appendToBody);
            topVal = pos.top;
            leftVal = pos.left;
            return "break";
        }
    };
    // iterate over all the passed placements
    for (var _i = 0, _a = toItemIndexes(placementVals); _i < _a.length; _i++) {
        var _b = _a[_i], item = _b.item, index = _b.index;
        var state_1 = _loop_1(item, index);
        if (state_1 === "break")
            break;
    }
    targetElement.style.top = topVal + "px";
    targetElement.style.left = leftVal + "px";
    return appliedPlacement;
}
// function to get index and item of an array
function toItemIndexes(a) {
    return a.map(function (item, index) { return ({ item: item, index: index }); });
}
//# sourceMappingURL=positioning.js.map
// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/util/focus-trap.js



var FOCUSABLE_ELEMENTS_SELECTOR = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])', 'select:not([disabled])',
    'textarea:not([disabled])', '[contenteditable]', '[tabindex]:not([tabindex="-1"])'
].join(', ');
/**
 * Returns first and last focusable elements inside of a given element based on specific CSS selector
 */
function getFocusableBoundaryElements(element) {
    var list = element.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR);
    return [list[0], list[list.length - 1]];
}
/**
 * Function that enforces browser focus to be trapped inside a DOM element.
 *
 * Works only for clicks inside the element and navigation with 'Tab', ignoring clicks outside of the element
 *
 * @param element The element around which focus will be trapped inside
 * @param stopFocusTrap$ The observable stream. When completed the focus trap will clean up listeners
 * and free internal resources
 */
var ngbFocusTrap = function (element, stopFocusTrap$) {
    // last focused element
    var lastFocusedElement$ = Object(_esm5["r" /* fromEvent */])(element, 'focusin').pipe(Object(operators["takeUntil"])(stopFocusTrap$), Object(operators["map"])(function (e) { return e.target; }));
    // 'tab' / 'shift+tab' stream
    Object(_esm5["r" /* fromEvent */])(element, 'keydown')
        .pipe(Object(operators["takeUntil"])(stopFocusTrap$), Object(operators["filter"])(function (e) { return e.which === Key.Tab; }), Object(operators["withLatestFrom"])(lastFocusedElement$))
        .subscribe(function (_a) {
        var tabEvent = _a[0], focusedElement = _a[1];
        var _b = getFocusableBoundaryElements(element), first = _b[0], last = _b[1];
        if (focusedElement === first && tabEvent.shiftKey) {
            last.focus();
            tabEvent.preventDefault();
        }
        if (focusedElement === last && !tabEvent.shiftKey) {
            first.focus();
            tabEvent.preventDefault();
        }
    });
    // inside click
    Object(_esm5["r" /* fromEvent */])(element, 'click')
        .pipe(Object(operators["takeUntil"])(stopFocusTrap$), Object(operators["withLatestFrom"])(lastFocusedElement$), Object(operators["map"])(function (arr) { return arr[1]; }))
        .subscribe(function (lastFocusedElement) { return lastFocusedElement.focus(); });
};
//# sourceMappingURL=focus-trap.js.map
// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-input.js














var datepicker_input_NGB_DATEPICKER_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    useExisting: Object(core["forwardRef"])(function () { return datepicker_input_NgbInputDatepicker; }),
    multi: true
};
var NGB_DATEPICKER_VALIDATOR = {
    provide: fesm5_forms["NG_VALIDATORS"],
    useExisting: Object(core["forwardRef"])(function () { return datepicker_input_NgbInputDatepicker; }),
    multi: true
};
/**
 * A directive that makes it possible to have datepickers on input fields.
 * Manages integration with the input field itself (data entry) and ngModel (validation etc.).
 */
var datepicker_input_NgbInputDatepicker = /*@__PURE__*/ (function () {
    function NgbInputDatepicker(_parserFormatter, _elRef, _vcRef, _renderer, _cfr, ngZone, _service, _calendar, _ngbDateAdapter, _document) {
        var _this = this;
        this._parserFormatter = _parserFormatter;
        this._elRef = _elRef;
        this._vcRef = _vcRef;
        this._renderer = _renderer;
        this._cfr = _cfr;
        this._service = _service;
        this._calendar = _calendar;
        this._ngbDateAdapter = _ngbDateAdapter;
        this._document = _document;
        this._closed$ = new _esm5["e" /* Subject */]();
        this._cRef = null;
        this._disabled = false;
        /**
           * Indicates whether the datepicker popup should be closed automatically after date selection or not.
           * If the value is 'false', the popup can be closed via 'close()' or 'toggle()' methods.
           *
           * @since 1.1.0
           */
        this.autoClose = true;
        /**
           * Placement of a datepicker popup accepts:
           *    "top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right",
           *    "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"
           * and array of above values.
           */
        this.placement = 'bottom-left';
        /**
           * An event fired when user selects a date using keyboard or mouse.
           * The payload of the event is currently selected NgbDateStruct.
           *
           * @since 1.1.1
           */
        this.dateSelect = new core["EventEmitter"]();
        /**
           * An event fired when navigation happens and currently displayed month changes.
           * See NgbDatepickerNavigateEvent for the payload info.
           */
        this.navigate = new core["EventEmitter"]();
        this._onChange = function (_) { };
        this._onTouched = function () { };
        this._validatorChange = function () { };
        this._zoneSubscription = ngZone.onStable.subscribe(function () {
            if (_this._cRef) {
                positionElements(_this._elRef.nativeElement, _this._cRef.location.nativeElement, _this.placement, _this.container === 'body');
            }
        });
    }
    Object.defineProperty(NgbInputDatepicker.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            this._disabled = value === '' || (value && value !== 'false');
            if (this.isOpen()) {
                this._cRef.instance.setDisabledState(this._disabled);
            }
        },
        enumerable: true,
        configurable: true
    });
    NgbInputDatepicker.prototype.registerOnChange = function (fn) { this._onChange = fn; };
    NgbInputDatepicker.prototype.registerOnTouched = function (fn) { this._onTouched = fn; };
    NgbInputDatepicker.prototype.registerOnValidatorChange = function (fn) { this._validatorChange = fn; };
    ;
    NgbInputDatepicker.prototype.setDisabledState = function (isDisabled) { this.disabled = isDisabled; };
    NgbInputDatepicker.prototype.validate = function (c) {
        var value = c.value;
        if (value === null || value === undefined) {
            return null;
        }
        var ngbDate = this._fromDateStruct(this._ngbDateAdapter.fromModel(value));
        if (!this._calendar.isValid(ngbDate)) {
            return { 'ngbDate': { invalid: c.value } };
        }
        if (this.minDate && ngbDate.before(NgbDate.from(this.minDate))) {
            return { 'ngbDate': { requiredBefore: this.minDate } };
        }
        if (this.maxDate && ngbDate.after(NgbDate.from(this.maxDate))) {
            return { 'ngbDate': { requiredAfter: this.maxDate } };
        }
    };
    NgbInputDatepicker.prototype.writeValue = function (value) {
        this._model = this._fromDateStruct(this._ngbDateAdapter.fromModel(value));
        this._writeModelValue(this._model);
    };
    NgbInputDatepicker.prototype.manualDateChange = function (value, updateView) {
        if (updateView === void 0) {
            updateView = false;
        }
        this._model = this._fromDateStruct(this._parserFormatter.parse(value));
        this._onChange(this._model ? this._ngbDateAdapter.toModel(this._model) : (value === '' ? null : value));
        if (updateView && this._model) {
            this._writeModelValue(this._model);
        }
    };
    NgbInputDatepicker.prototype.isOpen = function () { return !!this._cRef; };
    /**
     * Opens the datepicker with the selected date indicated by the ngModel value.
     */
    /**
       * Opens the datepicker with the selected date indicated by the ngModel value.
       */
    NgbInputDatepicker.prototype.open = /**
       * Opens the datepicker with the selected date indicated by the ngModel value.
       */
        function () {
            var _this = this;
            if (!this.isOpen()) {
                var cf = this._cfr.resolveComponentFactory(datepicker_NgbDatepicker);
                this._cRef = this._vcRef.createComponent(cf);
                this._applyPopupStyling(this._cRef.location.nativeElement);
                this._applyDatepickerInputs(this._cRef.instance);
                this._subscribeForDatepickerOutputs(this._cRef.instance);
                this._cRef.instance.ngOnInit();
                this._cRef.instance.writeValue(this._ngbDateAdapter.toModel(this._model));
                // date selection event handling
                this._cRef.instance.registerOnChange(function (selectedDate) {
                    _this.writeValue(selectedDate);
                    _this._onChange(selectedDate);
                });
                this._cRef.changeDetectorRef.detectChanges();
                this._cRef.instance.setDisabledState(this.disabled);
                if (this.container === 'body') {
                    window.document.querySelector(this.container).appendChild(this._cRef.location.nativeElement);
                }
                // focus handling
                ngbFocusTrap(this._cRef.location.nativeElement, this._closed$);
                this._cRef.instance.focus();
                // closing on ESC
                Object(_esm5["r" /* fromEvent */])(this._document, 'keyup')
                    .pipe(Object(operators["takeUntil"])(this._closed$), Object(operators["filter"])(function (e) { return e.which === Key.Escape; }))
                    .subscribe(function () { return _this.close(); });
            }
        };
    /**
     * Closes the datepicker popup.
     */
    /**
       * Closes the datepicker popup.
       */
    NgbInputDatepicker.prototype.close = /**
       * Closes the datepicker popup.
       */
        function () {
            if (this.isOpen()) {
                this._vcRef.remove(this._vcRef.indexOf(this._cRef.hostView));
                this._cRef = null;
                this._closed$.next();
            }
        };
    /**
     * Toggles the datepicker popup (opens when closed and closes when opened).
     */
    /**
       * Toggles the datepicker popup (opens when closed and closes when opened).
       */
    NgbInputDatepicker.prototype.toggle = /**
       * Toggles the datepicker popup (opens when closed and closes when opened).
       */
        function () {
            if (this.isOpen()) {
                this.close();
            }
            else {
                this.open();
            }
        };
    /**
     * Navigates current view to provided date.
     * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
     * If nothing or invalid date provided calendar will open current month.
     * Use 'startDate' input as an alternative
     */
    /**
       * Navigates current view to provided date.
       * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
       * If nothing or invalid date provided calendar will open current month.
       * Use 'startDate' input as an alternative
       */
    NgbInputDatepicker.prototype.navigateTo = /**
       * Navigates current view to provided date.
       * With default calendar we use ISO 8601: 'month' is 1=Jan ... 12=Dec.
       * If nothing or invalid date provided calendar will open current month.
       * Use 'startDate' input as an alternative
       */
        function (date) {
            if (this.isOpen()) {
                this._cRef.instance.navigateTo(date);
            }
        };
    NgbInputDatepicker.prototype.onBlur = function () { this._onTouched(); };
    NgbInputDatepicker.prototype.ngOnChanges = function (changes) {
        if (changes['minDate'] || changes['maxDate']) {
            this._validatorChange();
        }
    };
    NgbInputDatepicker.prototype.ngOnDestroy = function () {
        this.close();
        this._zoneSubscription.unsubscribe();
    };
    NgbInputDatepicker.prototype._applyDatepickerInputs = function (datepickerInstance) {
        var _this = this;
        ['dayTemplate', 'displayMonths', 'firstDayOfWeek', 'markDisabled', 'minDate', 'maxDate', 'navigation',
            'outsideDays', 'showNavigation', 'showWeekdays', 'showWeekNumbers']
            .forEach(function (optionName) {
            if (_this[optionName] !== undefined) {
                datepickerInstance[optionName] = _this[optionName];
            }
        });
        datepickerInstance.startDate = this.startDate || this._model;
    };
    NgbInputDatepicker.prototype._applyPopupStyling = function (nativeElement) {
        this._renderer.addClass(nativeElement, 'dropdown-menu');
        this._renderer.setStyle(nativeElement, 'padding', '0');
        this._renderer.addClass(nativeElement, 'show');
    };
    NgbInputDatepicker.prototype._subscribeForDatepickerOutputs = function (datepickerInstance) {
        var _this = this;
        datepickerInstance.navigate.subscribe(function (date) { return _this.navigate.emit(date); });
        datepickerInstance.select.subscribe(function (date) {
            _this.dateSelect.emit(date);
            if (_this.autoClose) {
                _this.close();
            }
        });
    };
    NgbInputDatepicker.prototype._writeModelValue = function (model) {
        this._renderer.setProperty(this._elRef.nativeElement, 'value', this._parserFormatter.format(model));
        if (this.isOpen()) {
            this._cRef.instance.writeValue(this._ngbDateAdapter.toModel(model));
            this._onTouched();
        }
    };
    NgbInputDatepicker.prototype._fromDateStruct = function (date) {
        var ngbDate = date ? new NgbDate(date.year, date.month, date.day) : null;
        return this._calendar.isValid(ngbDate) ? ngbDate : null;
    };
    return NgbInputDatepicker;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-day-view.js

var NgbDatepickerDayView = /*@__PURE__*/ (function () {
    function NgbDatepickerDayView() {
    }
    NgbDatepickerDayView.prototype.isMuted = function () { return !this.selected && (this.date.month !== this.currentMonth || this.disabled); };
    return NgbDatepickerDayView;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation-select.js




var datepicker_navigation_select_NgbDatepickerNavigationSelect = /*@__PURE__*/ (function () {
    function NgbDatepickerNavigationSelect(i18n) {
        this.i18n = i18n;
        this.select = new core["EventEmitter"]();
    }
    NgbDatepickerNavigationSelect.prototype.changeMonth = function (month) { this.select.emit(new NgbDate(this.date.year, toInteger(month), 1)); };
    NgbDatepickerNavigationSelect.prototype.changeYear = function (year) { this.select.emit(new NgbDate(toInteger(year), this.date.month, 1)); };
    return NgbDatepickerNavigationSelect;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-hijri.js
var ngb_calendar_hijri___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var ngb_calendar_hijri_NgbCalendarHijri = /*@__PURE__*/ (function (_super) {
    ngb_calendar_hijri___extends(NgbCalendarHijri, _super);
    function NgbCalendarHijri() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbCalendarHijri.prototype.getDaysPerWeek = function () { return 7; };
    NgbCalendarHijri.prototype.getMonths = function () { return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; };
    NgbCalendarHijri.prototype.getWeeksPerMonth = function () { return 6; };
    NgbCalendarHijri.prototype.isValid = function (date) {
        return date && isNumber(date.year) && isNumber(date.month) && isNumber(date.day) &&
            !isNaN(this.toGregorian(date).getTime());
    };
    NgbCalendarHijri.prototype.setDay = function (date, day) {
        day = +day;
        var mDays = this.getDaysInIslamicMonth(date.month, date.year);
        if (day <= 0) {
            while (day <= 0) {
                date = this.setMonth(date, date.month - 1);
                mDays = this.getDaysInIslamicMonth(date.month, date.year);
                day += mDays;
            }
        }
        else if (day > mDays) {
            while (day > mDays) {
                day -= mDays;
                date = this.setMonth(date, date.month + 1);
                mDays = this.getDaysInIslamicMonth(date.month, date.year);
            }
        }
        date.day = day;
        return date;
    };
    NgbCalendarHijri.prototype.setMonth = function (date, month) {
        month = +month;
        date.year = date.year + Math.floor((month - 1) / 12);
        date.month = Math.floor(((month - 1) % 12 + 12) % 12) + 1;
        return date;
    };
    NgbCalendarHijri.prototype.setYear = function (date, yearValue) {
        date.year = +yearValue;
        return date;
    };
    NgbCalendarHijri.prototype._isIslamicLeapYear = function (year) { return (14 + 11 * year) % 30 < 11; };
    /**
     * Returns the start of Hijri Month.
     * `month` is 0 for Muharram, 1 for Safar, etc.
     * `year` is any Hijri year.
     */
    /**
       * Returns the start of Hijri Month.
       * `month` is 0 for Muharram, 1 for Safar, etc.
       * `year` is any Hijri year.
       */
    NgbCalendarHijri.prototype._getMonthStart = /**
       * Returns the start of Hijri Month.
       * `month` is 0 for Muharram, 1 for Safar, etc.
       * `year` is any Hijri year.
       */
        function (year, month) {
            return Math.ceil(29.5 * month) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30.0);
        };
    /**
     * Returns the start of Hijri year.
     * `year` is any Hijri year.
     */
    /**
       * Returns the start of Hijri year.
       * `year` is any Hijri year.
       */
    NgbCalendarHijri.prototype._getYearStart = /**
       * Returns the start of Hijri year.
       * `year` is any Hijri year.
       */
        function (year) { return (year - 1) * 354 + Math.floor((3 + 11 * year) / 30.0); };
    return NgbCalendarHijri;
}(NgbCalendar));





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-islamic-civil.js
var ngb_calendar_islamic_civil___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



function isGregorianLeapYear(date) {
    var year = date.getFullYear();
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function mod(a, b) {
    return a - b * Math.floor(a / b);
}
/**
 * The civil calendar is one type of Hijri calendars used in islamic countries.
 * Uses a fixed cycle of alternating 29- and 30-day months,
 * with a leap day added to the last month of 11 out of every 30 years.
 * http://cldr.unicode.org/development/development-process/design-proposals/islamic-calendar-types
 * All the calculations here are based on the equations from "Calendrical Calculations" By Edward M. Reingold, Nachum
 * Dershowitz.
 */
var GREGORIAN_EPOCH = 1721425.5;
var ISLAMIC_EPOCH = 1948439.5;
var ngb_calendar_islamic_civil_NgbCalendarIslamicCivil = /*@__PURE__*/ (function (_super) {
    ngb_calendar_islamic_civil___extends(NgbCalendarIslamicCivil, _super);
    function NgbCalendarIslamicCivil() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the equivalent islamic(civil) date value for a give input Gregorian date.
     * `gdate` is a JS Date to be converted to Hijri.
     */
    /**
       * Returns the equivalent islamic(civil) date value for a give input Gregorian date.
       * `gdate` is a JS Date to be converted to Hijri.
       */
    NgbCalendarIslamicCivil.prototype.fromGregorian = /**
       * Returns the equivalent islamic(civil) date value for a give input Gregorian date.
       * `gdate` is a JS Date to be converted to Hijri.
       */
        function (gdate) {
            var date = new Date(gdate);
            var gYear = date.getFullYear(), gMonth = date.getMonth(), gDay = date.getDate();
            var julianDay = GREGORIAN_EPOCH - 1 + 365 * (gYear - 1) + Math.floor((gYear - 1) / 4) +
                -Math.floor((gYear - 1) / 100) + Math.floor((gYear - 1) / 400) +
                Math.floor((367 * (gMonth + 1) - 362) / 12 + (gMonth + 1 <= 2 ? 0 : isGregorianLeapYear(date) ? -1 : -2) + gDay);
            julianDay = Math.floor(julianDay) + 0.5;
            var days = julianDay - ISLAMIC_EPOCH;
            var hYear = Math.floor((30 * days + 10646) / 10631.0);
            var hMonth = Math.ceil((days - 29 - this._getYearStart(hYear)) / 29.5);
            hMonth = Math.min(hMonth, 11);
            var hDay = Math.ceil(days - this._getMonthStart(hYear, hMonth)) + 1;
            return new NgbDate(hYear, hMonth + 1, hDay);
        };
    /**
     * Returns the equivalent JS date value for a give input islamic(civil) date.
     * `hijriDate` is an islamic(civil) date to be converted to Gregorian.
     */
    /**
       * Returns the equivalent JS date value for a give input islamic(civil) date.
       * `hijriDate` is an islamic(civil) date to be converted to Gregorian.
       */
    NgbCalendarIslamicCivil.prototype.toGregorian = /**
       * Returns the equivalent JS date value for a give input islamic(civil) date.
       * `hijriDate` is an islamic(civil) date to be converted to Gregorian.
       */
        function (hijriDate) {
            var hYear = hijriDate.year;
            var hMonth = hijriDate.month - 1;
            var hDate = hijriDate.day;
            var julianDay = hDate + Math.ceil(29.5 * hMonth) + (hYear - 1) * 354 + Math.floor((3 + 11 * hYear) / 30) + ISLAMIC_EPOCH - 1;
            var wjd = Math.floor(julianDay - 0.5) + 0.5, depoch = wjd - GREGORIAN_EPOCH, quadricent = Math.floor(depoch / 146097), dqc = mod(depoch, 146097), cent = Math.floor(dqc / 36524), dcent = mod(dqc, 36524), quad = Math.floor(dcent / 1461), dquad = mod(dcent, 1461), yindex = Math.floor(dquad / 365);
            var year = quadricent * 400 + cent * 100 + quad * 4 + yindex;
            if (!(cent === 4 || yindex === 4)) {
                year++;
            }
            var gYearStart = GREGORIAN_EPOCH + 365 * (year - 1) + Math.floor((year - 1) / 4) - Math.floor((year - 1) / 100) +
                Math.floor((year - 1) / 400);
            var yearday = wjd - gYearStart;
            var tjd = GREGORIAN_EPOCH - 1 + 365 * (year - 1) + Math.floor((year - 1) / 4) - Math.floor((year - 1) / 100) +
                Math.floor((year - 1) / 400) + Math.floor(739 / 12 + (isGregorianLeapYear(new Date(year, 3, 1)) ? -1 : -2) + 1);
            var leapadj = wjd < tjd ? 0 : isGregorianLeapYear(new Date(year, 3, 1)) ? 1 : 2;
            var month = Math.floor(((yearday + leapadj) * 12 + 373) / 367);
            var tjd2 = GREGORIAN_EPOCH - 1 + 365 * (year - 1) + Math.floor((year - 1) / 4) - Math.floor((year - 1) / 100) +
                Math.floor((year - 1) / 400) +
                Math.floor((367 * month - 362) / 12 + (month <= 2 ? 0 : isGregorianLeapYear(new Date(year, month - 1, 1)) ? -1 : -2) +
                    1);
            var day = wjd - tjd2 + 1;
            return new Date(year, month - 1, day);
        };
    /**
     * Returns the number of days in a specific Hijri month.
     * `month` is 1 for Muharram, 2 for Safar, etc.
     * `year` is any Hijri year.
     */
    /**
       * Returns the number of days in a specific Hijri month.
       * `month` is 1 for Muharram, 2 for Safar, etc.
       * `year` is any Hijri year.
       */
    NgbCalendarIslamicCivil.prototype.getDaysInIslamicMonth = /**
       * Returns the number of days in a specific Hijri month.
       * `month` is 1 for Muharram, 2 for Safar, etc.
       * `year` is any Hijri year.
       */
        function (month, year) {
            year = year + Math.floor(month / 13);
            month = ((month - 1) % 12) + 1;
            var length = 29 + month % 2;
            if (month === 12 && this._isIslamicLeapYear(year)) {
                length++;
            }
            return length;
        };
    NgbCalendarIslamicCivil.prototype.getNext = function (date, period, number) {
        if (period === void 0) {
            period = 'd';
        }
        if (number === void 0) {
            number = 1;
        }
        date = NgbDate.from(date);
        switch (period) {
            case 'y':
                date = this.setYear(date, date.year + number);
                date.month = 1;
                date.day = 1;
                return date;
            case 'm':
                date = this.setMonth(date, date.month + number);
                date.day = 1;
                return date;
            case 'd':
                return this.setDay(date, date.day + number);
            default:
                return date;
        }
    };
    NgbCalendarIslamicCivil.prototype.getPrev = function (date, period, number) {
        if (period === void 0) {
            period = 'd';
        }
        if (number === void 0) {
            number = 1;
        }
        return this.getNext(date, period, -number);
    };
    NgbCalendarIslamicCivil.prototype.getWeekday = function (date) {
        var day = this.toGregorian(date).getDay();
        // in JS Date Sun=0, in ISO 8601 Sun=7
        return day === 0 ? 7 : day;
    };
    NgbCalendarIslamicCivil.prototype.getWeekNumber = function (week, firstDayOfWeek) {
        // in JS Date Sun=0, in ISO 8601 Sun=7
        if (firstDayOfWeek === 7) {
            firstDayOfWeek = 0;
        }
        var thursdayIndex = (4 + 7 - firstDayOfWeek) % 7;
        var date = week[thursdayIndex];
        var jsDate = this.toGregorian(date);
        jsDate.setDate(jsDate.getDate() + 4 - (jsDate.getDay() || 7)); // Thursday
        var time = jsDate.getTime();
        var MuhDate = this.toGregorian(new NgbDate(date.year, 1, 1)); // Compare with Muharram 1
        return Math.floor(Math.round((time - MuhDate.getTime()) / 86400000) / 7) + 1;
    };
    NgbCalendarIslamicCivil.prototype.getToday = function () { return this.fromGregorian(new Date()); };
    return NgbCalendarIslamicCivil;
}(ngb_calendar_hijri_NgbCalendarHijri));





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/hijri/ngb-calendar-islamic-umalqura.js
var ngb_calendar_islamic_umalqura___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * Umalqura calendar is one type of Hijri calendars used in islamic countries.
 * This Calendar is used by Saudi Arabia for administrative purpose.
 * Unlike tabular calendars, the algorithm involves astronomical calculation, but it's still deterministic.
 * http://cldr.unicode.org/development/development-process/design-proposals/islamic-calendar-types
 */
var GREGORIAN_FIRST_DATE = new Date(1882, 10, 12);
var GREGORIAN_LAST_DATE = new Date(2174, 10, 25);
var HIJRI_BEGIN = 1300;
var HIJRI_END = 1600;
var ONE_DAY = 1000 * 60 * 60 * 24;
var ISLAMIC_CIVIL = new ngb_calendar_islamic_civil_NgbCalendarIslamicCivil();
var MONTH_LENGTH = [
    '101010101010', '110101010100', '111011001001', '011011010100', '011011101010',
    '001101101100', '101010101101', '010101010101', '011010101001', '011110010010',
    '101110101001', '010111010100', '101011011010', '010101011100', '110100101101',
    '011010010101', '011101001010', '101101010100', '101101101010', '010110101101',
    '010010101110', '101001001111', '010100010111', '011010001011', '011010100101',
    '101011010101', '001011010110', '100101011011', '010010011101', '101001001101',
    '110100100110', '110110010101', '010110101100', '100110110110', '001010111010',
    '101001011011', '010100101011', '101010010101', '011011001010', '101011101001',
    '001011110100', '100101110110', '001010110110', '100101010110', '101011001010',
    '101110100100', '101111010010', '010111011001', '001011011100', '100101101101',
    '010101001101', '101010100101', '101101010010', '101110100101', '010110110100',
    '100110110110', '010101010111', '001010010111', '010101001011', '011010100011',
    '011101010010', '101101100101', '010101101010', '101010101011', '010100101011',
    '110010010101', '110101001010', '110110100101', '010111001010', '101011010110',
    '100101010111', '010010101011', '100101001011', '101010100101', '101101010010',
    '101101101010', '010101110101', '001001110110', '100010110111', '010001011011',
    '010101010101', '010110101001', '010110110100', '100111011010', '010011011101',
    '001001101110', '100100110110', '101010101010', '110101010100', '110110110010',
    '010111010101', '001011011010', '100101011011', '010010101011', '101001010101',
    '101101001001', '101101100100', '101101110001', '010110110100', '101010110101',
    '101001010101', '110100100101', '111010010010', '111011001001', '011011010100',
    '101011101001', '100101101011', '010010101011', '101010010011', '110101001001',
    '110110100100', '110110110010', '101010111001', '010010111010', '101001011011',
    '010100101011', '101010010101', '101100101010', '101101010101', '010101011100',
    '010010111101', '001000111101', '100100011101', '101010010101', '101101001010',
    '101101011010', '010101101101', '001010110110', '100100111011', '010010011011',
    '011001010101', '011010101001', '011101010100', '101101101010', '010101101100',
    '101010101101', '010101010101', '101100101001', '101110010010', '101110101001',
    '010111010100', '101011011010', '010101011010', '101010101011', '010110010101',
    '011101001001', '011101100100', '101110101010', '010110110101', '001010110110',
    '101001010110', '111001001101', '101100100101', '101101010010', '101101101010',
    '010110101101', '001010101110', '100100101111', '010010010111', '011001001011',
    '011010100101', '011010101100', '101011010110', '010101011101', '010010011101',
    '101001001101', '110100010110', '110110010101', '010110101010', '010110110101',
    '001011011010', '100101011011', '010010101101', '010110010101', '011011001010',
    '011011100100', '101011101010', '010011110101', '001010110110', '100101010110',
    '101010101010', '101101010100', '101111010010', '010111011001', '001011101010',
    '100101101101', '010010101101', '101010010101', '101101001010', '101110100101',
    '010110110010', '100110110101', '010011010110', '101010010111', '010101000111',
    '011010010011', '011101001001', '101101010101', '010101101010', '101001101011',
    '010100101011', '101010001011', '110101000110', '110110100011', '010111001010',
    '101011010110', '010011011011', '001001101011', '100101001011', '101010100101',
    '101101010010', '101101101001', '010101110101', '000101110110', '100010110111',
    '001001011011', '010100101011', '010101100101', '010110110100', '100111011010',
    '010011101101', '000101101101', '100010110110', '101010100110', '110101010010',
    '110110101001', '010111010100', '101011011010', '100101011011', '010010101011',
    '011001010011', '011100101001', '011101100010', '101110101001', '010110110010',
    '101010110101', '010101010101', '101100100101', '110110010010', '111011001001',
    '011011010010', '101011101001', '010101101011', '010010101011', '101001010101',
    '110100101001', '110101010100', '110110101010', '100110110101', '010010111010',
    '101000111011', '010010011011', '101001001101', '101010101010', '101011010101',
    '001011011010', '100101011101', '010001011110', '101000101110', '110010011010',
    '110101010101', '011010110010', '011010111001', '010010111010', '101001011101',
    '010100101101', '101010010101', '101101010010', '101110101000', '101110110100',
    '010110111001', '001011011010', '100101011010', '101101001010', '110110100100',
    '111011010001', '011011101000', '101101101010', '010101101101', '010100110101',
    '011010010101', '110101001010', '110110101000', '110111010100', '011011011010',
    '010101011011', '001010011101', '011000101011', '101100010101', '101101001010',
    '101110010101', '010110101010', '101010101110', '100100101110', '110010001111',
    '010100100111', '011010010101', '011010101010', '101011010110', '010101011101',
    '001010011101'
];
function getDaysDiff(date1, date2) {
    var diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.round(diff / ONE_DAY);
}
var ngb_calendar_islamic_umalqura_NgbCalendarIslamicUmalqura = /*@__PURE__*/ (function (_super) {
    ngb_calendar_islamic_umalqura___extends(NgbCalendarIslamicUmalqura, _super);
    function NgbCalendarIslamicUmalqura() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
    * Returns the equivalent islamic(Umalqura) date value for a give input Gregorian date.
    * `gdate` is s JS Date to be converted to Hijri.
    */
    /**
      * Returns the equivalent islamic(Umalqura) date value for a give input Gregorian date.
      * `gdate` is s JS Date to be converted to Hijri.
      */
    NgbCalendarIslamicUmalqura.prototype.fromGregorian = /**
      * Returns the equivalent islamic(Umalqura) date value for a give input Gregorian date.
      * `gdate` is s JS Date to be converted to Hijri.
      */
        function (gDate) {
            var hDay = 1, hMonth = 0, hYear = 1300;
            var daysDiff = getDaysDiff(gDate, GREGORIAN_FIRST_DATE);
            if (gDate.getTime() - GREGORIAN_FIRST_DATE.getTime() >= 0 && gDate.getTime() - GREGORIAN_LAST_DATE.getTime() <= 0) {
                var year = 1300;
                for (var i = 0; i < MONTH_LENGTH.length; i++, year++) {
                    for (var j = 0; j < 12; j++) {
                        var numOfDays = +MONTH_LENGTH[i][j] + 29;
                        if (daysDiff <= numOfDays) {
                            hDay = daysDiff + 1;
                            if (hDay > numOfDays) {
                                hDay = 1;
                                j++;
                            }
                            if (j > 11) {
                                j = 0;
                                year++;
                            }
                            hMonth = j;
                            hYear = year;
                            return new NgbDate(hYear, hMonth + 1, hDay);
                        }
                        daysDiff = daysDiff - numOfDays;
                    }
                }
            }
            else {
                return ISLAMIC_CIVIL.fromGregorian(gDate);
            }
        };
    /**
    * Converts the current Hijri date to Gregorian.
    */
    /**
      * Converts the current Hijri date to Gregorian.
      */
    NgbCalendarIslamicUmalqura.prototype.toGregorian = /**
      * Converts the current Hijri date to Gregorian.
      */
        function (hijriDate) {
            var hYear = hijriDate.year;
            var hMonth = hijriDate.month - 1;
            var hDay = hijriDate.day;
            var gDate = new Date(GREGORIAN_FIRST_DATE);
            var dayDiff = hDay - 1;
            if (hYear >= HIJRI_BEGIN && hYear <= HIJRI_END) {
                for (var y = 0; y < hYear - HIJRI_BEGIN; y++) {
                    for (var m = 0; m < 12; m++) {
                        dayDiff += +MONTH_LENGTH[y][m] + 29;
                    }
                }
                for (var m = 0; m < hMonth; m++) {
                    dayDiff += +MONTH_LENGTH[hYear - HIJRI_BEGIN][m] + 29;
                }
                gDate.setDate(GREGORIAN_FIRST_DATE.getDate() + dayDiff);
            }
            else {
                gDate = ISLAMIC_CIVIL.toGregorian(hijriDate);
            }
            return gDate;
        };
    /**
    * Returns the number of days in a specific Hijri month.
    * `month` is 1 for Muharram, 2 for Safar, etc.
    * `year` is any Hijri year.
    */
    /**
      * Returns the number of days in a specific Hijri month.
      * `month` is 1 for Muharram, 2 for Safar, etc.
      * `year` is any Hijri year.
      */
    NgbCalendarIslamicUmalqura.prototype.getDaysInIslamicMonth = /**
      * Returns the number of days in a specific Hijri month.
      * `month` is 1 for Muharram, 2 for Safar, etc.
      * `year` is any Hijri year.
      */
        function (month, year) {
            if (year >= HIJRI_BEGIN && year <= HIJRI_END) {
                var pos = year - HIJRI_BEGIN;
                return MONTH_LENGTH[pos].charAt(month - 1) === '1' ? 30 : 29;
            }
            return ISLAMIC_CIVIL.getDaysInIslamicMonth(month, year);
        };
    NgbCalendarIslamicUmalqura.prototype.getNext = function (date, period, number) {
        if (period === void 0) {
            period = 'd';
        }
        if (number === void 0) {
            number = 1;
        }
        date = NgbDate.from(date);
        switch (period) {
            case 'y':
                date = this.setYear(date, date.year + number);
                date.month = 1;
                date.day = 1;
                return date;
            case 'm':
                date = this.setMonth(date, date.month + number);
                date.day = 1;
                return date;
            case 'd':
                return this.setDay(date, date.day + number);
            default:
                return date;
        }
    };
    NgbCalendarIslamicUmalqura.prototype.getPrev = function (date, period, number) {
        if (period === void 0) {
            period = 'd';
        }
        if (number === void 0) {
            number = 1;
        }
        return this.getNext(date, period, -number);
    };
    NgbCalendarIslamicUmalqura.prototype.getWeekday = function (date) {
        var day = this.toGregorian(date).getDay();
        // in JS Date Sun=0, in ISO 8601 Sun=7
        return day === 0 ? 7 : day;
    };
    NgbCalendarIslamicUmalqura.prototype.getWeekNumber = function (week, firstDayOfWeek) {
        // in JS Date Sun=0, in ISO 8601 Sun=7
        if (firstDayOfWeek === 7) {
            firstDayOfWeek = 0;
        }
        var thursdayIndex = (4 + 7 - firstDayOfWeek) % 7;
        var date = week[thursdayIndex];
        var jsDate = this.toGregorian(date);
        jsDate.setDate(jsDate.getDate() + 4 - (jsDate.getDay() || 7)); // Thursday
        var time = jsDate.getTime();
        var MuhDate = this.toGregorian(new NgbDate(date.year, 1, 1)); // Compare with Muharram 1
        return Math.floor(Math.round((time - MuhDate.getTime()) / ONE_DAY) / 7) + 1;
    };
    NgbCalendarIslamicUmalqura.prototype.getToday = function () { return this.fromGregorian(new Date()); };
    return NgbCalendarIslamicUmalqura;
}(ngb_calendar_hijri_NgbCalendarHijri));





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/adapters/ngb-date-native-adapter.js
var ngb_date_native_adapter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var NgbDateNativeAdapter = /*@__PURE__*/ (function (_super) {
    ngb_date_native_adapter___extends(NgbDateNativeAdapter, _super);
    function NgbDateNativeAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbDateNativeAdapter.prototype.fromModel = function (date) {
        return (date && date.getFullYear) ? { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } :
            null;
    };
    NgbDateNativeAdapter.prototype.toModel = function (date) {
        return date && date.year && date.month ? new Date(date.year, date.month - 1, date.day) : null;
    };
    return NgbDateNativeAdapter;
}(NgbDateAdapter));





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker.module.js




























var datepicker_module_NgbDatepickerModule = /*@__PURE__*/ (function () {
    function NgbDatepickerModule() {
    }
    NgbDatepickerModule.forRoot = function () {
        return {
            ngModule: NgbDatepickerModule,
            providers: [
                { provide: NgbCalendar, useClass: ngb_calendar_NgbCalendarGregorian },
                { provide: NgbDatepickerI18n, useClass: datepicker_i18n_NgbDatepickerI18nDefault },
                { provide: NgbDateParserFormatter, useClass: ngb_date_parser_formatter_NgbDateISOParserFormatter },
                { provide: NgbDateAdapter, useClass: NgbDateStructAdapter }, NgbDatepickerConfig, common["DatePipe"]
            ]
        };
    };
    return NgbDatepickerModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown-config.js

/**
 * Configuration service for the NgbDropdown directive.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the dropdowns used in the application.
 */
var NgbDropdownConfig = /*@__PURE__*/ (function () {
    function NgbDropdownConfig() {
        this.autoClose = true;
        this.placement = 'bottom-left';
    }
    return NgbDropdownConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown.js
var dropdown___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 */
var dropdown_NgbDropdownMenu = /*@__PURE__*/ (function () {
    function NgbDropdownMenu(dropdown, _elementRef, _renderer) {
        this.dropdown = dropdown;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this.placement = 'bottom';
        this.isOpen = false;
    }
    NgbDropdownMenu.prototype.isEventFrom = function ($event) { return this._elementRef.nativeElement.contains($event.target); };
    NgbDropdownMenu.prototype.position = function (triggerEl, placement) {
        this.applyPlacement(positionElements(triggerEl, this._elementRef.nativeElement, placement));
    };
    NgbDropdownMenu.prototype.applyPlacement = function (_placement) {
        // remove the current placement classes
        this._renderer.removeClass(this._elementRef.nativeElement.parentNode, 'dropup');
        this._renderer.removeClass(this._elementRef.nativeElement.parentNode, 'dropdown');
        this.placement = _placement;
        /**
             * apply the new placement
             * in case of top use up-arrow or down-arrow otherwise
             */
        if (_placement.search('^top') !== -1) {
            this._renderer.addClass(this._elementRef.nativeElement.parentNode, 'dropup');
        }
        else {
            this._renderer.addClass(this._elementRef.nativeElement.parentNode, 'dropdown');
        }
    };
    return NgbDropdownMenu;
}());

/**
 * Marks an element to which dropdown menu will be anchored. This is a simple version
 * of the NgbDropdownToggle directive. It plays the same role as NgbDropdownToggle but
 * doesn't listen to click events to toggle dropdown menu thus enabling support for
 * events other than click.
 *
 * @since 1.1.0
 */
var NgbDropdownAnchor = /*@__PURE__*/ (function () {
    function NgbDropdownAnchor(dropdown, _elementRef) {
        this.dropdown = dropdown;
        this._elementRef = _elementRef;
        this.anchorEl = _elementRef.nativeElement;
    }
    NgbDropdownAnchor.prototype.isEventFrom = function ($event) { return this._elementRef.nativeElement.contains($event.target); };
    return NgbDropdownAnchor;
}());

/**
 * Allows the dropdown to be toggled via click. This directive is optional: you can use NgbDropdownAnchor as an
 * alternative.
 */
var NgbDropdownToggle = /*@__PURE__*/ (function (_super) {
    dropdown___extends(NgbDropdownToggle, _super);
    function NgbDropdownToggle(dropdown, elementRef) {
        return _super.call(this, dropdown, elementRef) || this;
    }
    NgbDropdownToggle.prototype.toggleOpen = function () { this.dropdown.toggle(); };
    return NgbDropdownToggle;
}(NgbDropdownAnchor));

/**
 * Transforms a node into a dropdown.
 */
var dropdown_NgbDropdown = /*@__PURE__*/ (function () {
    function NgbDropdown(_changeDetector, config, _document, _ngZone) {
        var _this = this;
        this._changeDetector = _changeDetector;
        this._document = _document;
        this._ngZone = _ngZone;
        this._closed$ = new _esm5["e" /* Subject */]();
        /**
           *  Defines whether or not the dropdown-menu is open initially.
           */
        this._open = false;
        /**
           *  An event fired when the dropdown is opened or closed.
           *  Event's payload equals whether dropdown is open.
           */
        this.openChange = new core["EventEmitter"]();
        this.placement = config.placement;
        this.autoClose = config.autoClose;
        this._zoneSubscription = _ngZone.onStable.subscribe(function () { _this._positionMenu(); });
    }
    NgbDropdown.prototype.ngOnInit = function () {
        if (this._menu) {
            this._menu.applyPlacement(Array.isArray(this.placement) ? (this.placement[0]) : this.placement);
        }
        if (this._open) {
            this._setCloseHandlers();
        }
    };
    /**
     * Checks if the dropdown menu is open or not.
     */
    /**
       * Checks if the dropdown menu is open or not.
       */
    NgbDropdown.prototype.isOpen = /**
       * Checks if the dropdown menu is open or not.
       */
        function () { return this._open; };
    /**
     * Opens the dropdown menu of a given navbar or tabbed navigation.
     */
    /**
       * Opens the dropdown menu of a given navbar or tabbed navigation.
       */
    NgbDropdown.prototype.open = /**
       * Opens the dropdown menu of a given navbar or tabbed navigation.
       */
        function () {
            if (!this._open) {
                this._open = true;
                this._positionMenu();
                this.openChange.emit(true);
                this._setCloseHandlers();
            }
        };
    NgbDropdown.prototype._setCloseHandlers = function () {
        var _this = this;
        if (this.autoClose) {
            this._ngZone.runOutsideAngular(function () {
                var escapes$ = Object(_esm5["r" /* fromEvent */])(_this._document, 'keyup')
                    .pipe(Object(operators["takeUntil"])(_this._closed$), Object(operators["filter"])(function (event) { return event.which === Key.Escape; }));
                var clicks$ = Object(_esm5["r" /* fromEvent */])(_this._document, 'click')
                    .pipe(Object(operators["takeUntil"])(_this._closed$), Object(operators["filter"])(function (event) { return _this._shouldCloseFromClick(event); }));
                Object(_esm5["B" /* race */])([escapes$, clicks$]).pipe(Object(operators["takeUntil"])(_this._closed$)).subscribe(function () {
                    return _this._ngZone.run(function () {
                        _this.close();
                        _this._changeDetector.markForCheck();
                    });
                });
            });
        }
    };
    /**
     * Closes the dropdown menu of a given navbar or tabbed navigation.
     */
    /**
       * Closes the dropdown menu of a given navbar or tabbed navigation.
       */
    NgbDropdown.prototype.close = /**
       * Closes the dropdown menu of a given navbar or tabbed navigation.
       */
        function () {
            if (this._open) {
                this._open = false;
                this._closed$.next();
                this.openChange.emit(false);
            }
        };
    /**
     * Toggles the dropdown menu of a given navbar or tabbed navigation.
     */
    /**
       * Toggles the dropdown menu of a given navbar or tabbed navigation.
       */
    NgbDropdown.prototype.toggle = /**
       * Toggles the dropdown menu of a given navbar or tabbed navigation.
       */
        function () {
            if (this.isOpen()) {
                this.close();
            }
            else {
                this.open();
            }
        };
    NgbDropdown.prototype._shouldCloseFromClick = function (event) {
        if (event.button !== 2 && !this._isEventFromToggle(event)) {
            if (this.autoClose === true) {
                return true;
            }
            else if (this.autoClose === 'inside' && this._isEventFromMenu(event)) {
                return true;
            }
            else if (this.autoClose === 'outside' && !this._isEventFromMenu(event)) {
                return true;
            }
        }
        return false;
    };
    NgbDropdown.prototype.ngOnDestroy = function () {
        this._closed$.next();
        this._zoneSubscription.unsubscribe();
    };
    NgbDropdown.prototype._isEventFromToggle = function ($event) { return this._anchor.isEventFrom($event); };
    NgbDropdown.prototype._isEventFromMenu = function ($event) { return this._menu ? this._menu.isEventFrom($event) : false; };
    NgbDropdown.prototype._positionMenu = function () {
        if (this.isOpen() && this._menu) {
            this._menu.position(this._anchor.anchorEl, this.placement);
        }
    };
    return NgbDropdown;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/dropdown/dropdown.module.js





var NGB_DROPDOWN_DIRECTIVES = [dropdown_NgbDropdown, NgbDropdownAnchor, NgbDropdownToggle, dropdown_NgbDropdownMenu];
var dropdown_module_NgbDropdownModule = /*@__PURE__*/ (function () {
    function NgbDropdownModule() {
    }
    NgbDropdownModule.forRoot = function () { return { ngModule: NgbDropdownModule, providers: [NgbDropdownConfig] }; };
    return NgbDropdownModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-backdrop.js

var NgbModalBackdrop = /*@__PURE__*/ (function () {
    function NgbModalBackdrop() {
    }
    return NgbModalBackdrop;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-dismiss-reasons.js
var ModalDismissReasons = /*@__PURE__*/ (function (ModalDismissReasons) {
    ModalDismissReasons[ModalDismissReasons["BACKDROP_CLICK"] = 0] = "BACKDROP_CLICK";
    ModalDismissReasons[ModalDismissReasons["ESC"] = 1] = "ESC";
    return ModalDismissReasons;
})({});




// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-window.js




var modal_window_NgbModalWindow = /*@__PURE__*/ (function () {
    function NgbModalWindow(document, _elRef, _renderer) {
        this._elRef = _elRef;
        this._renderer = _renderer;
        this.backdrop = true;
        this.keyboard = true;
        this.dismissEvent = new core["EventEmitter"]();
        this._document = document;
        ngbFocusTrap(this._elRef.nativeElement, this.dismissEvent);
    }
    NgbModalWindow.prototype.backdropClick = function ($event) {
        if (this.backdrop === true && this._elRef.nativeElement === $event.target) {
            this.dismiss(ModalDismissReasons.BACKDROP_CLICK);
        }
    };
    NgbModalWindow.prototype.escKey = function ($event) {
        if (this.keyboard && !$event.defaultPrevented) {
            this.dismiss(ModalDismissReasons.ESC);
        }
    };
    NgbModalWindow.prototype.dismiss = function (reason) { this.dismissEvent.emit(reason); };
    NgbModalWindow.prototype.ngOnInit = function () {
        this._elWithFocus = this._document.activeElement;
        this._renderer.addClass(this._document.body, 'modal-open');
    };
    NgbModalWindow.prototype.ngAfterViewInit = function () {
        if (!this._elRef.nativeElement.contains(document.activeElement)) {
            this._elRef.nativeElement['focus'].apply(this._elRef.nativeElement, []);
        }
    };
    NgbModalWindow.prototype.ngOnDestroy = function () {
        var body = this._document.body;
        var elWithFocus = this._elWithFocus;
        var elementToFocus;
        if (elWithFocus && elWithFocus['focus'] && body.contains(elWithFocus)) {
            elementToFocus = elWithFocus;
        }
        else {
            elementToFocus = body;
        }
        elementToFocus['focus'].apply(elementToFocus, []);
        this._elWithFocus = null;
        this._renderer.removeClass(body, 'modal-open');
    };
    return NgbModalWindow;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/util/popup.js

var ContentRef = /*@__PURE__*/ (function () {
    function ContentRef(nodes, viewRef, componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
    return ContentRef;
}());

var popup_PopupService = /*@__PURE__*/ (function () {
    function PopupService(_type, _injector, _viewContainerRef, _renderer, _componentFactoryResolver) {
        this._type = _type;
        this._injector = _injector;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._componentFactoryResolver = _componentFactoryResolver;
    }
    PopupService.prototype.open = function (content, context) {
        if (!this._windowRef) {
            this._contentRef = this._getContentRef(content, context);
            this._windowRef = this._viewContainerRef.createComponent(this._componentFactoryResolver.resolveComponentFactory(this._type), 0, this._injector, this._contentRef.nodes);
        }
        return this._windowRef;
    };
    PopupService.prototype.close = function () {
        if (this._windowRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._windowRef.hostView));
            this._windowRef = null;
            if (this._contentRef.viewRef) {
                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._contentRef.viewRef));
                this._contentRef = null;
            }
        }
    };
    PopupService.prototype._getContentRef = function (content, context) {
        if (!content) {
            return new ContentRef([]);
        }
        else if (content instanceof core["TemplateRef"]) {
            var viewRef = this._viewContainerRef.createEmbeddedView(content, context);
            return new ContentRef([viewRef.rootNodes], viewRef);
        }
        else {
            return new ContentRef([[this._renderer.createText("" + content)]]);
        }
    };
    return PopupService;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/util/scrollbar.js


var noop = function () { };
var ɵ0 = noop;
/**
 * Utility to handle the scrollbar.
 *
 * It allows to compensate the lack of a vertical scrollbar by adding an
 * equivalent padding on the right of the body, and to remove this compensation.
 */
var ScrollBar = /*@__PURE__*/ (function () {
    function ScrollBar(_document) {
        this._document = _document;
    }
    /**
     * Detects if a scrollbar is present and if yes, already compensates for its
     * removal by adding an equivalent padding on the right of the body.
     *
     * @return a callback used to revert the compensation (noop if there was none,
     * otherwise a function removing the padding)
     */
    /**
       * Detects if a scrollbar is present and if yes, already compensates for its
       * removal by adding an equivalent padding on the right of the body.
       *
       * @return a callback used to revert the compensation (noop if there was none,
       * otherwise a function removing the padding)
       */
    ScrollBar.prototype.compensate = /**
       * Detects if a scrollbar is present and if yes, already compensates for its
       * removal by adding an equivalent padding on the right of the body.
       *
       * @return a callback used to revert the compensation (noop if there was none,
       * otherwise a function removing the padding)
       */
        function () { return !this._isPresent() ? noop : this._adjustBody(this._getWidth()); };
    /**
     * Adds a padding of the given width on the right of the body.
     *
     * @return a callback used to revert the padding to its previous value
     */
    /**
       * Adds a padding of the given width on the right of the body.
       *
       * @return a callback used to revert the padding to its previous value
       */
    ScrollBar.prototype._adjustBody = /**
       * Adds a padding of the given width on the right of the body.
       *
       * @return a callback used to revert the padding to its previous value
       */
        function (width) {
            var body = this._document.body;
            var userSetPadding = body.style.paddingRight;
            var paddingAmount = parseFloat(window.getComputedStyle(body)['padding-right']);
            body.style['padding-right'] = paddingAmount + width + "px";
            return function () { return body.style['padding-right'] = userSetPadding; };
        };
    /**
     * Tells whether a scrollbar is currently present on the body.
     *
     * @return true if scrollbar is present, false otherwise
     */
    /**
       * Tells whether a scrollbar is currently present on the body.
       *
       * @return true if scrollbar is present, false otherwise
       */
    ScrollBar.prototype._isPresent = /**
       * Tells whether a scrollbar is currently present on the body.
       *
       * @return true if scrollbar is present, false otherwise
       */
        function () {
            var rect = this._document.body.getBoundingClientRect();
            return rect.left + rect.right < window.innerWidth;
        };
    /**
     * Calculates and returns the width of a scrollbar.
     *
     * @return the width of a scrollbar on this page
     */
    /**
       * Calculates and returns the width of a scrollbar.
       *
       * @return the width of a scrollbar on this page
       */
    ScrollBar.prototype._getWidth = /**
       * Calculates and returns the width of a scrollbar.
       *
       * @return the width of a scrollbar on this page
       */
        function () {
            var measurer = this._document.createElement('div');
            measurer.className = 'modal-scrollbar-measure';
            var body = this._document.body;
            body.appendChild(measurer);
            var width = measurer.getBoundingClientRect().width - measurer.clientWidth;
            body.removeChild(measurer);
            return width;
        };
    return ScrollBar;
}());






// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-ref.js
/**
 * A reference to an active (currently opened) modal. Instances of this class
 * can be injected into components passed as modal content.
 */
var /**
 * A reference to an active (currently opened) modal. Instances of this class
 * can be injected into components passed as modal content.
 */
NgbActiveModal = /** @class */ (function () {
    function NgbActiveModal() {
    }
    /**
     * Can be used to close a modal, passing an optional result.
     */
    /**
       * Can be used to close a modal, passing an optional result.
       */
    NgbActiveModal.prototype.close = /**
       * Can be used to close a modal, passing an optional result.
       */
    function (result) { };
    /**
     * Can be used to dismiss a modal, passing an optional reason.
     */
    /**
       * Can be used to dismiss a modal, passing an optional reason.
       */
    NgbActiveModal.prototype.dismiss = /**
       * Can be used to dismiss a modal, passing an optional reason.
       */
    function (reason) { };
    return NgbActiveModal;
}());
/**
 * A reference to an active (currently opened) modal. Instances of this class
 * can be injected into components passed as modal content.
 */

/**
 * A reference to a newly opened modal.
 */
var /**
 * A reference to a newly opened modal.
 */
NgbModalRef = /** @class */ (function () {
    function NgbModalRef(_windowCmptRef, _contentRef, _backdropCmptRef, _beforeDismiss) {
        var _this = this;
        this._windowCmptRef = _windowCmptRef;
        this._contentRef = _contentRef;
        this._backdropCmptRef = _backdropCmptRef;
        this._beforeDismiss = _beforeDismiss;
        _windowCmptRef.instance.dismissEvent.subscribe(function (reason) { _this.dismiss(reason); });
        this.result = new Promise(function (resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this.result.then(null, function () { });
    }
    Object.defineProperty(NgbModalRef.prototype, "componentInstance", {
        /**
         * The instance of component used as modal's content.
         * Undefined when a TemplateRef is used as modal's content.
         */
        get: /**
           * The instance of component used as modal's content.
           * Undefined when a TemplateRef is used as modal's content.
           */
        function () {
            if (this._contentRef.componentRef) {
                return this._contentRef.componentRef.instance;
            }
        },
        // only needed to keep TS1.8 compatibility
        set: 
        // only needed to keep TS1.8 compatibility
        function (instance) { },
        enumerable: true,
        configurable: true
    });
    /**
     * Can be used to close a modal, passing an optional result.
     */
    /**
       * Can be used to close a modal, passing an optional result.
       */
    NgbModalRef.prototype.close = /**
       * Can be used to close a modal, passing an optional result.
       */
    function (result) {
        if (this._windowCmptRef) {
            this._resolve(result);
            this._removeModalElements();
        }
    };
    NgbModalRef.prototype._dismiss = function (reason) {
        this._reject(reason);
        this._removeModalElements();
    };
    /**
     * Can be used to dismiss a modal, passing an optional reason.
     */
    /**
       * Can be used to dismiss a modal, passing an optional reason.
       */
    NgbModalRef.prototype.dismiss = /**
       * Can be used to dismiss a modal, passing an optional reason.
       */
    function (reason) {
        var _this = this;
        if (this._windowCmptRef) {
            if (!this._beforeDismiss) {
                this._dismiss(reason);
            }
            else {
                var dismiss = this._beforeDismiss();
                if (dismiss && dismiss.then) {
                    dismiss.then(function (result) {
                        if (result !== false) {
                            _this._dismiss(reason);
                        }
                    }, function () { });
                }
                else if (dismiss !== false) {
                    this._dismiss(reason);
                }
            }
        }
    };
    NgbModalRef.prototype._removeModalElements = function () {
        var windowNativeEl = this._windowCmptRef.location.nativeElement;
        windowNativeEl.parentNode.removeChild(windowNativeEl);
        this._windowCmptRef.destroy();
        if (this._backdropCmptRef) {
            var backdropNativeEl = this._backdropCmptRef.location.nativeElement;
            backdropNativeEl.parentNode.removeChild(backdropNativeEl);
            this._backdropCmptRef.destroy();
        }
        if (this._contentRef && this._contentRef.viewRef) {
            this._contentRef.viewRef.destroy();
        }
        this._windowCmptRef = null;
        this._backdropCmptRef = null;
        this._contentRef = null;
    };
    return NgbModalRef;
}());
/**
 * A reference to a newly opened modal.
 */

//# sourceMappingURL=modal-ref.js.map
// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-stack.js








var modal_stack_NgbModalStack = /*@__PURE__*/ (function () {
    function NgbModalStack(_applicationRef, _injector, _componentFactoryResolver, _document, _scrollBar) {
        this._applicationRef = _applicationRef;
        this._injector = _injector;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._document = _document;
        this._scrollBar = _scrollBar;
        this._windowAttributes = ['ariaLabelledBy', 'backdrop', 'centered', 'keyboard', 'size', 'windowClass'];
        this._backdropAttributes = ['backdropClass'];
    }
    NgbModalStack.prototype.open = function (moduleCFR, contentInjector, content, options) {
        var containerEl = isDefined(options.container) ? this._document.querySelector(options.container) : this._document.body;
        var revertPaddingForScrollBar = this._scrollBar.compensate();
        if (!containerEl) {
            throw new Error("The specified modal container \"" + (options.container || 'body') + "\" was not found in the DOM.");
        }
        var activeModal = new NgbActiveModal();
        var contentRef = this._getContentRef(moduleCFR, options.injector || contentInjector, content, activeModal);
        var backdropCmptRef = options.backdrop !== false ? this._attachBackdrop(containerEl) : null;
        var windowCmptRef = this._attachWindowComponent(containerEl, contentRef);
        var ngbModalRef = new NgbModalRef(windowCmptRef, contentRef, backdropCmptRef, options.beforeDismiss);
        ngbModalRef.result.then(revertPaddingForScrollBar, revertPaddingForScrollBar);
        activeModal.close = function (result) { ngbModalRef.close(result); };
        activeModal.dismiss = function (reason) { ngbModalRef.dismiss(reason); };
        this._applyWindowOptions(windowCmptRef.instance, options);
        if (backdropCmptRef && backdropCmptRef.instance) {
            this._applyBackdropOptions(backdropCmptRef.instance, options);
        }
        return ngbModalRef;
    };
    NgbModalStack.prototype._attachBackdrop = function (containerEl) {
        var backdropFactory = this._componentFactoryResolver.resolveComponentFactory(NgbModalBackdrop);
        var backdropCmptRef = backdropFactory.create(this._injector);
        this._applicationRef.attachView(backdropCmptRef.hostView);
        containerEl.appendChild(backdropCmptRef.location.nativeElement);
        return backdropCmptRef;
    };
    NgbModalStack.prototype._attachWindowComponent = function (containerEl, contentRef) {
        var windowFactory = this._componentFactoryResolver.resolveComponentFactory(modal_window_NgbModalWindow);
        var windowCmptRef = windowFactory.create(this._injector, contentRef.nodes);
        this._applicationRef.attachView(windowCmptRef.hostView);
        containerEl.appendChild(windowCmptRef.location.nativeElement);
        return windowCmptRef;
    };
    NgbModalStack.prototype._applyWindowOptions = function (windowInstance, options) {
        this._windowAttributes.forEach(function (optionName) {
            if (isDefined(options[optionName])) {
                windowInstance[optionName] = options[optionName];
            }
        });
    };
    NgbModalStack.prototype._applyBackdropOptions = function (backdropInstance, options) {
        this._backdropAttributes.forEach(function (optionName) {
            if (isDefined(options[optionName])) {
                backdropInstance[optionName] = options[optionName];
            }
        });
    };
    NgbModalStack.prototype._getContentRef = function (moduleCFR, contentInjector, content, context) {
        if (!content) {
            return new ContentRef([]);
        }
        else if (content instanceof core["TemplateRef"]) {
            return this._createFromTemplateRef(content, context);
        }
        else if (isString(content)) {
            return this._createFromString(content);
        }
        else {
            return this._createFromComponent(moduleCFR, contentInjector, content, context);
        }
    };
    NgbModalStack.prototype._createFromTemplateRef = function (content, context) {
        var viewRef = content.createEmbeddedView(context);
        this._applicationRef.attachView(viewRef);
        return new ContentRef([viewRef.rootNodes], viewRef);
    };
    NgbModalStack.prototype._createFromString = function (content) {
        var component = this._document.createTextNode("" + content);
        return new ContentRef([[component]]);
    };
    NgbModalStack.prototype._createFromComponent = function (moduleCFR, contentInjector, content, context) {
        var contentCmptFactory = moduleCFR.resolveComponentFactory(content);
        var modalContentInjector = core["Injector"].create([{ provide: NgbActiveModal, useValue: context }], contentInjector);
        var componentRef = contentCmptFactory.create(modalContentInjector);
        this._applicationRef.attachView(componentRef.hostView);
        return new ContentRef([[componentRef.location.nativeElement]], componentRef.hostView, componentRef);
    };
    return NgbModalStack;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal.js


/**
 * A service to open modal windows. Creating a modal is straightforward: create a template and pass it as an argument to
 * the "open" method!
 */
var NgbModal = /*@__PURE__*/ (function () {
    function NgbModal(_moduleCFR, _injector, _modalStack) {
        this._moduleCFR = _moduleCFR;
        this._injector = _injector;
        this._modalStack = _modalStack;
    }
    /**
     * Opens a new modal window with the specified content and using supplied options. Content can be provided
     * as a TemplateRef or a component type. If you pass a component type as content than instances of those
     * components can be injected with an instance of the NgbActiveModal class. You can use methods on the
     * NgbActiveModal class to close / dismiss modals from "inside" of a component.
     */
    /**
       * Opens a new modal window with the specified content and using supplied options. Content can be provided
       * as a TemplateRef or a component type. If you pass a component type as content than instances of those
       * components can be injected with an instance of the NgbActiveModal class. You can use methods on the
       * NgbActiveModal class to close / dismiss modals from "inside" of a component.
       */
    NgbModal.prototype.open = /**
       * Opens a new modal window with the specified content and using supplied options. Content can be provided
       * as a TemplateRef or a component type. If you pass a component type as content than instances of those
       * components can be injected with an instance of the NgbActiveModal class. You can use methods on the
       * NgbActiveModal class to close / dismiss modals from "inside" of a component.
       */
        function (content, options) {
            if (options === void 0) {
                options = {};
            }
            return this._modalStack.open(this._moduleCFR, this._injector, content, options);
        };
    return NgbModal;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal.module.js









var modal_module_NgbModalModule = /*@__PURE__*/ (function () {
    function NgbModalModule() {
    }
    NgbModalModule.forRoot = function () {
        return { ngModule: NgbModalModule, providers: [NgbModal, modal_stack_NgbModalStack, ScrollBar] };
    };
    return NgbModalModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination-config.js

/**
 * Configuration service for the NgbPagination component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the paginations used in the application.
 */
var NgbPaginationConfig = /*@__PURE__*/ (function () {
    function NgbPaginationConfig() {
        this.disabled = false;
        this.boundaryLinks = false;
        this.directionLinks = true;
        this.ellipses = true;
        this.maxSize = 0;
        this.pageSize = 10;
        this.rotate = false;
    }
    return NgbPaginationConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination.js



/**
 * A directive that will take care of visualising a pagination bar and enable / disable buttons correctly!
 */
var pagination_NgbPagination = /*@__PURE__*/ (function () {
    function NgbPagination(config) {
        this.pageCount = 0;
        this.pages = [];
        /**
           *  Current page. Page numbers start with 1
           */
        this.page = 1;
        /**
           *  An event fired when the page is changed.
           *  Event's payload equals to the newly selected page.
           *  Will fire only if collection size is set and all values are valid.
           *  Page numbers start with 1
           */
        this.pageChange = new core["EventEmitter"](true);
        this.disabled = config.disabled;
        this.boundaryLinks = config.boundaryLinks;
        this.directionLinks = config.directionLinks;
        this.ellipses = config.ellipses;
        this.maxSize = config.maxSize;
        this.pageSize = config.pageSize;
        this.rotate = config.rotate;
        this.size = config.size;
    }
    NgbPagination.prototype.hasPrevious = function () { return this.page > 1; };
    NgbPagination.prototype.hasNext = function () { return this.page < this.pageCount; };
    NgbPagination.prototype.selectPage = function (pageNumber) { this._updatePages(pageNumber); };
    NgbPagination.prototype.ngOnChanges = function (changes) { this._updatePages(this.page); };
    NgbPagination.prototype.isEllipsis = function (pageNumber) { return pageNumber === -1; };
    /**
     * Appends ellipses and first/last page number to the displayed pages
     */
    /**
       * Appends ellipses and first/last page number to the displayed pages
       */
    NgbPagination.prototype._applyEllipses = /**
       * Appends ellipses and first/last page number to the displayed pages
       */
        function (start, end) {
            if (this.ellipses) {
                if (start > 0) {
                    if (start > 1) {
                        this.pages.unshift(-1);
                    }
                    this.pages.unshift(1);
                }
                if (end < this.pageCount) {
                    if (end < (this.pageCount - 1)) {
                        this.pages.push(-1);
                    }
                    this.pages.push(this.pageCount);
                }
            }
        };
    /**
     * Rotates page numbers based on maxSize items visible.
     * Currently selected page stays in the middle:
     *
     * Ex. for selected page = 6:
     * [5,*6*,7] for maxSize = 3
     * [4,5,*6*,7] for maxSize = 4
     */
    /**
       * Rotates page numbers based on maxSize items visible.
       * Currently selected page stays in the middle:
       *
       * Ex. for selected page = 6:
       * [5,*6*,7] for maxSize = 3
       * [4,5,*6*,7] for maxSize = 4
       */
    NgbPagination.prototype._applyRotation = /**
       * Rotates page numbers based on maxSize items visible.
       * Currently selected page stays in the middle:
       *
       * Ex. for selected page = 6:
       * [5,*6*,7] for maxSize = 3
       * [4,5,*6*,7] for maxSize = 4
       */
        function () {
            var start = 0;
            var end = this.pageCount;
            var leftOffset = Math.floor(this.maxSize / 2);
            var rightOffset = this.maxSize % 2 === 0 ? leftOffset - 1 : leftOffset;
            if (this.page <= leftOffset) {
                // very beginning, no rotation -> [0..maxSize]
                end = this.maxSize;
            }
            else if (this.pageCount - this.page < leftOffset) {
                // very end, no rotation -> [len-maxSize..len]
                start = this.pageCount - this.maxSize;
            }
            else {
                // rotate
                start = this.page - leftOffset - 1;
                end = this.page + rightOffset;
            }
            return [start, end];
        };
    /**
     * Paginates page numbers based on maxSize items per page
     */
    /**
       * Paginates page numbers based on maxSize items per page
       */
    NgbPagination.prototype._applyPagination = /**
       * Paginates page numbers based on maxSize items per page
       */
        function () {
            var page = Math.ceil(this.page / this.maxSize) - 1;
            var start = page * this.maxSize;
            var end = start + this.maxSize;
            return [start, end];
        };
    NgbPagination.prototype._setPageInRange = function (newPageNo) {
        var prevPageNo = this.page;
        this.page = getValueInRange(newPageNo, this.pageCount, 1);
        if (this.page !== prevPageNo && isNumber(this.collectionSize)) {
            this.pageChange.emit(this.page);
        }
    };
    NgbPagination.prototype._updatePages = function (newPage) {
        this.pageCount = Math.ceil(this.collectionSize / this.pageSize);
        if (!isNumber(this.pageCount)) {
            this.pageCount = 0;
        }
        // fill-in model needed to render pages
        this.pages.length = 0;
        for (var i = 1; i <= this.pageCount; i++) {
            this.pages.push(i);
        }
        // set page within 1..max range
        this._setPageInRange(newPage);
        // apply maxSize if necessary
        if (this.maxSize > 0 && this.pageCount > this.maxSize) {
            var start = 0;
            var end = this.pageCount;
            // either paginating or rotating page numbers
            if (this.rotate) {
                _a = this._applyRotation(), start = _a[0], end = _a[1];
            }
            else {
                _b = this._applyPagination(), start = _b[0], end = _b[1];
            }
            this.pages = this.pages.slice(start, end);
            // adding ellipses
            this._applyEllipses(start, end);
        }
        var _a, _b;
    };
    return NgbPagination;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination.module.js






var pagination_module_NgbPaginationModule = /*@__PURE__*/ (function () {
    function NgbPaginationModule() {
    }
    NgbPaginationModule.forRoot = function () { return { ngModule: NgbPaginationModule, providers: [NgbPaginationConfig] }; };
    return NgbPaginationModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/util/triggers.js
var Trigger = /*@__PURE__*/ (function () {
    function Trigger(open, close) {
        this.open = open;
        this.close = close;
        if (!close) {
            this.close = open;
        }
    }
    Trigger.prototype.isManual = function () { return this.open === 'manual' || this.close === 'manual'; };
    return Trigger;
}());

var DEFAULT_ALIASES = {
    'hover': ['mouseenter', 'mouseleave']
};
function parseTriggers(triggers, aliases) {
    if (aliases === void 0) {
        aliases = DEFAULT_ALIASES;
    }
    var trimmedTriggers = (triggers || '').trim();
    if (trimmedTriggers.length === 0) {
        return [];
    }
    var parsedTriggers = trimmedTriggers.split(/\s+/).map(function (trigger) { return trigger.split(':'); }).map(function (triggerPair) {
        var alias = aliases[triggerPair[0]] || triggerPair;
        return new Trigger(alias[0], alias[1]);
    });
    var manualTriggers = parsedTriggers.filter(function (triggerPair) { return triggerPair.isManual(); });
    if (manualTriggers.length > 1) {
        throw 'Triggers parse error: only one manual trigger is allowed';
    }
    if (manualTriggers.length === 1 && parsedTriggers.length > 1) {
        throw 'Triggers parse error: manual trigger can\'t be mixed with other triggers';
    }
    return parsedTriggers;
}
var noopFn = function () { };
var triggers__0 = noopFn;
function listenToTriggers(renderer, nativeElement, triggers, openFn, closeFn, toggleFn) {
    var parsedTriggers = parseTriggers(triggers);
    var listeners = [];
    if (parsedTriggers.length === 1 && parsedTriggers[0].isManual()) {
        return noopFn;
    }
    parsedTriggers.forEach(function (trigger) {
        if (trigger.open === trigger.close) {
            listeners.push(renderer.listen(nativeElement, trigger.open, toggleFn));
        }
        else {
            listeners.push(renderer.listen(nativeElement, trigger.open, openFn), renderer.listen(nativeElement, trigger.close, closeFn));
        }
    });
    return function () { listeners.forEach(function (unsubscribeFn) { return unsubscribeFn(); }); };
}





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover-config.js

/**
 * Configuration service for the NgbPopover directive.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the popovers used in the application.
 */
var NgbPopoverConfig = /*@__PURE__*/ (function () {
    function NgbPopoverConfig() {
        this.placement = 'top';
        this.triggers = 'click';
        this.disablePopover = false;
    }
    return NgbPopoverConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover.js





var popover_nextId = 0;
var NgbPopoverWindow = /*@__PURE__*/ (function () {
    function NgbPopoverWindow(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.placement = 'top';
    }
    NgbPopoverWindow.prototype.applyPlacement = function (_placement) {
        // remove the current placement classes
        this._renderer.removeClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString().split('-')[0]);
        this._renderer.removeClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString());
        // set the new placement classes
        this.placement = _placement;
        // apply the new placement
        this._renderer.addClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString().split('-')[0]);
        this._renderer.addClass(this._element.nativeElement, 'bs-popover-' + this.placement.toString());
    };
    return NgbPopoverWindow;
}());

/**
 * A lightweight, extensible directive for fancy popover creation.
 */
var popover_NgbPopover = /*@__PURE__*/ (function () {
    function NgbPopover(_elementRef, _renderer, injector, componentFactoryResolver, viewContainerRef, config, ngZone) {
        var _this = this;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /**
           * Emits an event when the popover is shown
           */
        this.shown = new core["EventEmitter"]();
        /**
           * Emits an event when the popover is hidden
           */
        this.hidden = new core["EventEmitter"]();
        this._ngbPopoverWindowId = "ngb-popover-" + popover_nextId++;
        this.placement = config.placement;
        this.triggers = config.triggers;
        this.container = config.container;
        this.disablePopover = config.disablePopover;
        this.popoverClass = config.popoverClass;
        this._popupService = new popup_PopupService(NgbPopoverWindow, injector, viewContainerRef, _renderer, componentFactoryResolver);
        this._zoneSubscription = ngZone.onStable.subscribe(function () {
            if (_this._windowRef) {
                _this._windowRef.instance.applyPlacement(positionElements(_this._elementRef.nativeElement, _this._windowRef.location.nativeElement, _this.placement, _this.container === 'body'));
            }
        });
    }
    NgbPopover.prototype._isDisabled = function () {
        if (this.disablePopover) {
            return true;
        }
        if (!this.ngbPopover && !this.popoverTitle) {
            return true;
        }
        return false;
    };
    /**
     * Opens an element’s popover. This is considered a “manual” triggering of the popover.
     * The context is an optional value to be injected into the popover template when it is created.
     */
    /**
       * Opens an element’s popover. This is considered a “manual” triggering of the popover.
       * The context is an optional value to be injected into the popover template when it is created.
       */
    NgbPopover.prototype.open = /**
       * Opens an element’s popover. This is considered a “manual” triggering of the popover.
       * The context is an optional value to be injected into the popover template when it is created.
       */
        function (context) {
            if (!this._windowRef && !this._isDisabled()) {
                this._windowRef = this._popupService.open(this.ngbPopover, context);
                this._windowRef.instance.title = this.popoverTitle;
                this._windowRef.instance.popoverClass = this.popoverClass;
                this._windowRef.instance.id = this._ngbPopoverWindowId;
                this._renderer.setAttribute(this._elementRef.nativeElement, 'aria-describedby', this._ngbPopoverWindowId);
                if (this.container === 'body') {
                    window.document.querySelector(this.container).appendChild(this._windowRef.location.nativeElement);
                }
                // apply styling to set basic css-classes on target element, before going for positioning
                this._windowRef.changeDetectorRef.detectChanges();
                this._windowRef.changeDetectorRef.markForCheck();
                // position popover along the element
                this._windowRef.instance.applyPlacement(positionElements(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
                this.shown.emit();
            }
        };
    /**
     * Closes an element’s popover. This is considered a “manual” triggering of the popover.
     */
    /**
       * Closes an element’s popover. This is considered a “manual” triggering of the popover.
       */
    NgbPopover.prototype.close = /**
       * Closes an element’s popover. This is considered a “manual” triggering of the popover.
       */
        function () {
            if (this._windowRef) {
                this._renderer.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
                this._popupService.close();
                this._windowRef = null;
                this.hidden.emit();
            }
        };
    /**
     * Toggles an element’s popover. This is considered a “manual” triggering of the popover.
     */
    /**
       * Toggles an element’s popover. This is considered a “manual” triggering of the popover.
       */
    NgbPopover.prototype.toggle = /**
       * Toggles an element’s popover. This is considered a “manual” triggering of the popover.
       */
        function () {
            if (this._windowRef) {
                this.close();
            }
            else {
                this.open();
            }
        };
    /**
     * Returns whether or not the popover is currently being shown
     */
    /**
       * Returns whether or not the popover is currently being shown
       */
    NgbPopover.prototype.isOpen = /**
       * Returns whether or not the popover is currently being shown
       */
        function () { return this._windowRef != null; };
    NgbPopover.prototype.ngOnInit = function () {
        this._unregisterListenersFn = listenToTriggers(this._renderer, this._elementRef.nativeElement, this.triggers, this.open.bind(this), this.close.bind(this), this.toggle.bind(this));
    };
    NgbPopover.prototype.ngOnChanges = function (changes) {
        // close popover if title and content become empty, or disablePopover set to true
        if ((changes['ngbPopover'] || changes['popoverTitle'] || changes['disablePopover']) && this._isDisabled()) {
            this.close();
        }
    };
    NgbPopover.prototype.ngOnDestroy = function () {
        this.close();
        this._unregisterListenersFn();
        this._zoneSubscription.unsubscribe();
    };
    return NgbPopover;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover.module.js





var popover_module_NgbPopoverModule = /*@__PURE__*/ (function () {
    function NgbPopoverModule() {
    }
    NgbPopoverModule.forRoot = function () { return { ngModule: NgbPopoverModule, providers: [NgbPopoverConfig] }; };
    return NgbPopoverModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar-config.js

/**
 * Configuration service for the NgbProgressbar component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the progress bars used in the application.
 */
var NgbProgressbarConfig = /*@__PURE__*/ (function () {
    function NgbProgressbarConfig() {
        this.max = 100;
        this.animated = false;
        this.striped = false;
        this.showValue = false;
    }
    return NgbProgressbarConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar.js



/**
 * Directive that can be used to provide feedback on the progress of a workflow or an action.
 */
var progressbar_NgbProgressbar = /*@__PURE__*/ (function () {
    function NgbProgressbar(config) {
        /**
           * Current value to be displayed in the progressbar. Should be smaller or equal to "max" value.
           */
        this.value = 0;
        this.max = config.max;
        this.animated = config.animated;
        this.striped = config.striped;
        this.type = config.type;
        this.showValue = config.showValue;
        this.height = config.height;
    }
    NgbProgressbar.prototype.getValue = function () { return getValueInRange(this.value, this.max); };
    NgbProgressbar.prototype.getPercentValue = function () { return 100 * this.getValue() / this.max; };
    return NgbProgressbar;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/progressbar/progressbar.module.js






var progressbar_module_NgbProgressbarModule = /*@__PURE__*/ (function () {
    function NgbProgressbarModule() {
    }
    NgbProgressbarModule.forRoot = function () { return { ngModule: NgbProgressbarModule, providers: [NgbProgressbarConfig] }; };
    return NgbProgressbarModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating-config.js

/**
 * Configuration service for the NgbRating component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the ratings used in the application.
 */
var NgbRatingConfig = /*@__PURE__*/ (function () {
    function NgbRatingConfig() {
        this.max = 10;
        this.readonly = false;
        this.resettable = false;
    }
    return NgbRatingConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating.js





var NGB_RATING_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    useExisting: Object(core["forwardRef"])(function () { return rating_NgbRating; }),
    multi: true
};
/**
 * Rating directive that will take care of visualising a star rating bar.
 */
var rating_NgbRating = /*@__PURE__*/ (function () {
    function NgbRating(config, _changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this.contexts = [];
        this.disabled = false;
        /**
           * An event fired when a user is hovering over a given rating.
           * Event's payload equals to the rating being hovered over.
           */
        this.hover = new core["EventEmitter"]();
        /**
           * An event fired when a user stops hovering over a given rating.
           * Event's payload equals to the rating of the last item being hovered over.
           */
        this.leave = new core["EventEmitter"]();
        /**
           * An event fired when a user selects a new rating.
           * Event's payload equals to the newly selected rating.
           */
        this.rateChange = new core["EventEmitter"](true);
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this.max = config.max;
        this.readonly = config.readonly;
    }
    NgbRating.prototype.ariaValueText = function () { return this.nextRate + " out of " + this.max; };
    NgbRating.prototype.enter = function (value) {
        if (!this.readonly && !this.disabled) {
            this._updateState(value);
        }
        this.hover.emit(value);
    };
    NgbRating.prototype.handleBlur = function () { this.onTouched(); };
    NgbRating.prototype.handleClick = function (value) { this.update(this.resettable && this.rate === value ? 0 : value); };
    NgbRating.prototype.handleKeyDown = function (event) {
        if (Key[util_toString(event.which)]) {
            event.preventDefault();
            switch (event.which) {
                case Key.ArrowDown:
                case Key.ArrowLeft:
                    this.update(this.rate - 1);
                    break;
                case Key.ArrowUp:
                case Key.ArrowRight:
                    this.update(this.rate + 1);
                    break;
                case Key.Home:
                    this.update(0);
                    break;
                case Key.End:
                    this.update(this.max);
                    break;
            }
        }
    };
    NgbRating.prototype.ngOnChanges = function (changes) {
        if (changes['rate']) {
            this.update(this.rate);
        }
    };
    NgbRating.prototype.ngOnInit = function () {
        this.contexts = Array.from({ length: this.max }, function (v, k) { return ({ fill: 0, index: k }); });
        this._updateState(this.rate);
    };
    NgbRating.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbRating.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbRating.prototype.reset = function () {
        this.leave.emit(this.nextRate);
        this._updateState(this.rate);
    };
    NgbRating.prototype.setDisabledState = function (isDisabled) { this.disabled = isDisabled; };
    NgbRating.prototype.update = function (value, internalChange) {
        if (internalChange === void 0) {
            internalChange = true;
        }
        var newRate = getValueInRange(value, this.max, 0);
        if (!this.readonly && !this.disabled && this.rate !== newRate) {
            this.rate = newRate;
            this.rateChange.emit(this.rate);
        }
        if (internalChange) {
            this.onChange(this.rate);
            this.onTouched();
        }
        this._updateState(this.rate);
    };
    NgbRating.prototype.writeValue = function (value) {
        this.update(value, false);
        this._changeDetectorRef.markForCheck();
    };
    NgbRating.prototype._getFillValue = function (index) {
        var diff = this.nextRate - index;
        if (diff >= 1) {
            return 100;
        }
        if (diff < 1 && diff > 0) {
            return Number.parseInt((diff * 100).toFixed(2));
        }
        return 0;
    };
    NgbRating.prototype._updateState = function (nextValue) {
        var _this = this;
        this.nextRate = nextValue;
        this.contexts.forEach(function (context, index) { return context.fill = _this._getFillValue(index); });
    };
    return NgbRating;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/rating/rating.module.js






var rating_module_NgbRatingModule = /*@__PURE__*/ (function () {
    function NgbRatingModule() {
    }
    NgbRatingModule.forRoot = function () { return { ngModule: NgbRatingModule, providers: [NgbRatingConfig] }; };
    return NgbRatingModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset-config.js

/**
 * Configuration service for the NgbTabset component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the tabsets used in the application.
 */
var NgbTabsetConfig = /*@__PURE__*/ (function () {
    function NgbTabsetConfig() {
        this.justify = 'start';
        this.orientation = 'horizontal';
        this.type = 'tabs';
    }
    return NgbTabsetConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset.js


var tabset_nextId = 0;
/**
 * This directive should be used to wrap tab titles that need to contain HTML markup or other directives.
 */
var NgbTabTitle = /*@__PURE__*/ (function () {
    function NgbTabTitle(templateRef) {
        this.templateRef = templateRef;
    }
    return NgbTabTitle;
}());

/**
 * This directive must be used to wrap content to be displayed in a tab.
 */
var NgbTabContent = /*@__PURE__*/ (function () {
    function NgbTabContent(templateRef) {
        this.templateRef = templateRef;
    }
    return NgbTabContent;
}());

/**
 * A directive representing an individual tab.
 */
var NgbTab = /*@__PURE__*/ (function () {
    function NgbTab() {
        /**
           * Unique tab identifier. Must be unique for the entire document for proper accessibility support.
           */
        this.id = "ngb-tab-" + tabset_nextId++;
        /**
           * Allows toggling disabled state of a given state. Disabled tabs can't be selected.
           */
        this.disabled = false;
    }
    NgbTab.prototype.ngAfterContentChecked = function () {
        // We are using @ContentChildren instead of @ContantChild as in the Angular version being used
        // only @ContentChildren allows us to specify the {descendants: false} option.
        // Without {descendants: false} we are hitting bugs described in:
        // https://github.com/ng-bootstrap/ng-bootstrap/issues/2240
        this.titleTpl = this.titleTpls.first;
        this.contentTpl = this.contentTpls.first;
    };
    return NgbTab;
}());

/**
 * A component that makes it easy to create tabbed interface.
 */
var tabset_NgbTabset = /*@__PURE__*/ (function () {
    function NgbTabset(config) {
        /**
           * Whether the closed tabs should be hidden without destroying them
           */
        this.destroyOnHide = true;
        /**
           * A tab change event fired right before the tab selection happens. See NgbTabChangeEvent for payload details
           */
        this.tabChange = new core["EventEmitter"]();
        this.type = config.type;
        this.justify = config.justify;
        this.orientation = config.orientation;
    }
    Object.defineProperty(NgbTabset.prototype, "justify", {
        set: /**
           * The horizontal alignment of the nav with flexbox utilities. Can be one of 'start', 'center', 'end', 'fill' or
           * 'justified'
           * The default value is 'start'.
           */ function (className) {
            if (className === 'fill' || className === 'justified') {
                this.justifyClass = "nav-" + className;
            }
            else {
                this.justifyClass = "justify-content-" + className;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects the tab with the given id and shows its associated pane.
     * Any other tab that was previously selected becomes unselected and its associated pane is hidden.
     */
    /**
       * Selects the tab with the given id and shows its associated pane.
       * Any other tab that was previously selected becomes unselected and its associated pane is hidden.
       */
    NgbTabset.prototype.select = /**
       * Selects the tab with the given id and shows its associated pane.
       * Any other tab that was previously selected becomes unselected and its associated pane is hidden.
       */
        function (tabId) {
            var selectedTab = this._getTabById(tabId);
            if (selectedTab && !selectedTab.disabled && this.activeId !== selectedTab.id) {
                var defaultPrevented_1 = false;
                this.tabChange.emit({ activeId: this.activeId, nextId: selectedTab.id, preventDefault: function () { defaultPrevented_1 = true; } });
                if (!defaultPrevented_1) {
                    this.activeId = selectedTab.id;
                }
            }
        };
    NgbTabset.prototype.ngAfterContentChecked = function () {
        // auto-correct activeId that might have been set incorrectly as input
        var activeTab = this._getTabById(this.activeId);
        this.activeId = activeTab ? activeTab.id : (this.tabs.length ? this.tabs.first.id : null);
    };
    NgbTabset.prototype._getTabById = function (id) {
        var tabsWithId = this.tabs.filter(function (tab) { return tab.id === id; });
        return tabsWithId.length ? tabsWithId[0] : null;
    };
    return NgbTabset;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset.module.js






var NGB_TABSET_DIRECTIVES = [tabset_NgbTabset, NgbTab, NgbTabContent, NgbTabTitle];
var tabset_module_NgbTabsetModule = /*@__PURE__*/ (function () {
    function NgbTabsetModule() {
    }
    NgbTabsetModule.forRoot = function () { return { ngModule: NgbTabsetModule, providers: [NgbTabsetConfig] }; };
    return NgbTabsetModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/ngb-time.js

var ngb_time_NgbTime = /*@__PURE__*/ (function () {
    function NgbTime(hour, minute, second) {
        this.hour = toInteger(hour);
        this.minute = toInteger(minute);
        this.second = toInteger(second);
    }
    NgbTime.prototype.changeHour = function (step) {
        if (step === void 0) {
            step = 1;
        }
        this.updateHour((isNaN(this.hour) ? 0 : this.hour) + step);
    };
    NgbTime.prototype.updateHour = function (hour) {
        if (isNumber(hour)) {
            this.hour = (hour < 0 ? 24 + hour : hour) % 24;
        }
        else {
            this.hour = NaN;
        }
    };
    NgbTime.prototype.changeMinute = function (step) {
        if (step === void 0) {
            step = 1;
        }
        this.updateMinute((isNaN(this.minute) ? 0 : this.minute) + step);
    };
    NgbTime.prototype.updateMinute = function (minute) {
        if (isNumber(minute)) {
            this.minute = minute % 60 < 0 ? 60 + minute % 60 : minute % 60;
            this.changeHour(Math.floor(minute / 60));
        }
        else {
            this.minute = NaN;
        }
    };
    NgbTime.prototype.changeSecond = function (step) {
        if (step === void 0) {
            step = 1;
        }
        this.updateSecond((isNaN(this.second) ? 0 : this.second) + step);
    };
    NgbTime.prototype.updateSecond = function (second) {
        if (isNumber(second)) {
            this.second = second < 0 ? 60 + second % 60 : second % 60;
            this.changeMinute(Math.floor(second / 60));
        }
        else {
            this.second = NaN;
        }
    };
    NgbTime.prototype.isValid = function (checkSecs) {
        if (checkSecs === void 0) {
            checkSecs = true;
        }
        return isNumber(this.hour) && isNumber(this.minute) && (checkSecs ? isNumber(this.second) : true);
    };
    NgbTime.prototype.toString = function () { return (this.hour || 0) + ":" + (this.minute || 0) + ":" + (this.second || 0); };
    return NgbTime;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker-config.js

/**
 * Configuration service for the NgbTimepicker component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the timepickers used in the application.
 */
var NgbTimepickerConfig = /*@__PURE__*/ (function () {
    function NgbTimepickerConfig() {
        this.meridian = false;
        this.spinners = true;
        this.seconds = false;
        this.hourStep = 1;
        this.minuteStep = 1;
        this.secondStep = 1;
        this.disabled = false;
        this.readonlyInputs = false;
        this.size = 'medium';
    }
    return NgbTimepickerConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/ngb-time-adapter.js
var ngb_time_adapter___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Abstract type serving as a DI token for the service converting from your application Time model to internal
 * NgbTimeStruct model.
 * A default implementation converting from and to NgbTimeStruct is provided for retro-compatibility,
 * but you can provide another implementation to use an alternative format, ie for using with native Date Object.
 *
 * @since 2.2.0
 */
var NgbTimeAdapter = /*@__PURE__*/ (function () {
    function NgbTimeAdapter() {
    }
    return NgbTimeAdapter;
}());

var ngb_time_adapter_NgbTimeStructAdapter = /*@__PURE__*/ (function (_super) {
    ngb_time_adapter___extends(NgbTimeStructAdapter, _super);
    function NgbTimeStructAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Converts a NgbTimeStruct value into NgbTimeStruct value
     * @param  {NgbTimeStruct} value
     * @return {NgbTimeStruct}
     */
    /**
       * Converts a NgbTimeStruct value into NgbTimeStruct value
       * @param  {NgbTimeStruct} value
       * @return {NgbTimeStruct}
       */
    NgbTimeStructAdapter.prototype.fromModel = /**
       * Converts a NgbTimeStruct value into NgbTimeStruct value
       * @param  {NgbTimeStruct} value
       * @return {NgbTimeStruct}
       */
        function (time) {
            return (time && isInteger(time.hour) && isInteger(time.minute)) ?
                { hour: time.hour, minute: time.minute, second: isInteger(time.second) ? time.second : null } :
                null;
        };
    /**
     * Converts a NgbTimeStruct value into NgbTimeStruct value
     * @param  {NgbTimeStruct} value
     * @return {NgbTimeStruct}
     */
    /**
       * Converts a NgbTimeStruct value into NgbTimeStruct value
       * @param  {NgbTimeStruct} value
       * @return {NgbTimeStruct}
       */
    NgbTimeStructAdapter.prototype.toModel = /**
       * Converts a NgbTimeStruct value into NgbTimeStruct value
       * @param  {NgbTimeStruct} value
       * @return {NgbTimeStruct}
       */
        function (time) {
            return (time && isInteger(time.hour) && isInteger(time.minute)) ?
                { hour: time.hour, minute: time.minute, second: isInteger(time.second) ? time.second : null } :
                null;
        };
    return NgbTimeStructAdapter;
}(NgbTimeAdapter));





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker.js






var NGB_TIMEPICKER_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    useExisting: Object(core["forwardRef"])(function () { return timepicker_NgbTimepicker; }),
    multi: true
};
/**
 * A lightweight & configurable timepicker directive.
 */
var timepicker_NgbTimepicker = /*@__PURE__*/ (function () {
    function NgbTimepicker(config, _ngbTimeAdapter) {
        this._ngbTimeAdapter = _ngbTimeAdapter;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this.meridian = config.meridian;
        this.spinners = config.spinners;
        this.seconds = config.seconds;
        this.hourStep = config.hourStep;
        this.minuteStep = config.minuteStep;
        this.secondStep = config.secondStep;
        this.disabled = config.disabled;
        this.readonlyInputs = config.readonlyInputs;
        this.size = config.size;
    }
    NgbTimepicker.prototype.writeValue = function (value) {
        var structValue = this._ngbTimeAdapter.fromModel(value);
        this.model = structValue ? new ngb_time_NgbTime(structValue.hour, structValue.minute, structValue.second) : new ngb_time_NgbTime();
        if (!this.seconds && (!structValue || !isNumber(structValue.second))) {
            this.model.second = 0;
        }
    };
    NgbTimepicker.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    NgbTimepicker.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    NgbTimepicker.prototype.setDisabledState = function (isDisabled) { this.disabled = isDisabled; };
    NgbTimepicker.prototype.changeHour = function (step) {
        this.model.changeHour(step);
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.changeMinute = function (step) {
        this.model.changeMinute(step);
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.changeSecond = function (step) {
        this.model.changeSecond(step);
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.updateHour = function (newVal) {
        var isPM = this.model.hour >= 12;
        var enteredHour = toInteger(newVal);
        if (this.meridian && (isPM && enteredHour < 12 || !isPM && enteredHour === 12)) {
            this.model.updateHour(enteredHour + 12);
        }
        else {
            this.model.updateHour(enteredHour);
        }
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.updateMinute = function (newVal) {
        this.model.updateMinute(toInteger(newVal));
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.updateSecond = function (newVal) {
        this.model.updateSecond(toInteger(newVal));
        this.propagateModelChange();
    };
    NgbTimepicker.prototype.toggleMeridian = function () {
        if (this.meridian) {
            this.changeHour(12);
        }
    };
    NgbTimepicker.prototype.formatHour = function (value) {
        if (isNumber(value)) {
            if (this.meridian) {
                return padNumber(value % 12 === 0 ? 12 : value % 12);
            }
            else {
                return padNumber(value % 24);
            }
        }
        else {
            return padNumber(NaN);
        }
    };
    NgbTimepicker.prototype.formatMinSec = function (value) { return padNumber(value); };
    NgbTimepicker.prototype.setFormControlSize = function () { return { 'form-control-sm': this.size === 'small', 'form-control-lg': this.size === 'large' }; };
    NgbTimepicker.prototype.setButtonSize = function () { return { 'btn-sm': this.size === 'small', 'btn-lg': this.size === 'large' }; };
    NgbTimepicker.prototype.ngOnChanges = function (changes) {
        if (changes['seconds'] && !this.seconds && this.model && !isNumber(this.model.second)) {
            this.model.second = 0;
            this.propagateModelChange(false);
        }
    };
    NgbTimepicker.prototype.propagateModelChange = function (touched) {
        if (touched === void 0) {
            touched = true;
        }
        if (touched) {
            this.onTouched();
        }
        if (this.model.isValid(this.seconds)) {
            this.onChange(this._ngbTimeAdapter.toModel({ hour: this.model.hour, minute: this.model.minute, second: this.model.second }));
        }
        else {
            this.onChange(this._ngbTimeAdapter.toModel(null));
        }
    };
    return NgbTimepicker;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker.module.js








var timepicker_module_NgbTimepickerModule = /*@__PURE__*/ (function () {
    function NgbTimepickerModule() {
    }
    NgbTimepickerModule.forRoot = function () {
        return {
            ngModule: NgbTimepickerModule,
            providers: [NgbTimepickerConfig, { provide: NgbTimeAdapter, useClass: ngb_time_adapter_NgbTimeStructAdapter }]
        };
    };
    return NgbTimepickerModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip-config.js

/**
 * Configuration service for the NgbTooltip directive.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the tooltips used in the application.
 */
var NgbTooltipConfig = /*@__PURE__*/ (function () {
    function NgbTooltipConfig() {
        this.placement = 'top';
        this.triggers = 'hover';
        this.disableTooltip = false;
    }
    return NgbTooltipConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.js





var tooltip_nextId = 0;
var NgbTooltipWindow = /*@__PURE__*/ (function () {
    function NgbTooltipWindow(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.placement = 'top';
    }
    NgbTooltipWindow.prototype.applyPlacement = function (_placement) {
        // remove the current placement classes
        this._renderer.removeClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString().split('-')[0]);
        this._renderer.removeClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString());
        // set the new placement classes
        this.placement = _placement;
        // apply the new placement
        this._renderer.addClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString().split('-')[0]);
        this._renderer.addClass(this._element.nativeElement, 'bs-tooltip-' + this.placement.toString());
    };
    return NgbTooltipWindow;
}());

/**
 * A lightweight, extensible directive for fancy tooltip creation.
 */
var tooltip_NgbTooltip = /*@__PURE__*/ (function () {
    function NgbTooltip(_elementRef, _renderer, injector, componentFactoryResolver, viewContainerRef, config, ngZone) {
        var _this = this;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /**
           * Emits an event when the tooltip is shown
           */
        this.shown = new core["EventEmitter"]();
        /**
           * Emits an event when the tooltip is hidden
           */
        this.hidden = new core["EventEmitter"]();
        this._ngbTooltipWindowId = "ngb-tooltip-" + tooltip_nextId++;
        this.placement = config.placement;
        this.triggers = config.triggers;
        this.container = config.container;
        this.disableTooltip = config.disableTooltip;
        this._popupService = new popup_PopupService(NgbTooltipWindow, injector, viewContainerRef, _renderer, componentFactoryResolver);
        this._zoneSubscription = ngZone.onStable.subscribe(function () {
            if (_this._windowRef) {
                _this._windowRef.instance.applyPlacement(positionElements(_this._elementRef.nativeElement, _this._windowRef.location.nativeElement, _this.placement, _this.container === 'body'));
            }
        });
    }
    Object.defineProperty(NgbTooltip.prototype, "ngbTooltip", {
        get: function () { return this._ngbTooltip; },
        set: /**
           * Content to be displayed as tooltip. If falsy, the tooltip won't open.
           */ function (value) {
            this._ngbTooltip = value;
            if (!value && this._windowRef) {
                this.close();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Opens an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * The context is an optional value to be injected into the tooltip template when it is created.
     */
    /**
       * Opens an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       * The context is an optional value to be injected into the tooltip template when it is created.
       */
    NgbTooltip.prototype.open = /**
       * Opens an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       * The context is an optional value to be injected into the tooltip template when it is created.
       */
        function (context) {
            if (!this._windowRef && this._ngbTooltip && !this.disableTooltip) {
                this._windowRef = this._popupService.open(this._ngbTooltip, context);
                this._windowRef.instance.id = this._ngbTooltipWindowId;
                this._renderer.setAttribute(this._elementRef.nativeElement, 'aria-describedby', this._ngbTooltipWindowId);
                if (this.container === 'body') {
                    window.document.querySelector(this.container).appendChild(this._windowRef.location.nativeElement);
                }
                this._windowRef.instance.placement = Array.isArray(this.placement) ? this.placement[0] : this.placement;
                // apply styling to set basic css-classes on target element, before going for positioning
                this._windowRef.changeDetectorRef.detectChanges();
                this._windowRef.changeDetectorRef.markForCheck();
                // position tooltip along the element
                this._windowRef.instance.applyPlacement(positionElements(this._elementRef.nativeElement, this._windowRef.location.nativeElement, this.placement, this.container === 'body'));
                this.shown.emit();
            }
        };
    /**
     * Closes an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     */
    /**
       * Closes an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       */
    NgbTooltip.prototype.close = /**
       * Closes an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       */
        function () {
            if (this._windowRef != null) {
                this._renderer.removeAttribute(this._elementRef.nativeElement, 'aria-describedby');
                this._popupService.close();
                this._windowRef = null;
                this.hidden.emit();
            }
        };
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     */
    /**
       * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       */
    NgbTooltip.prototype.toggle = /**
       * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
       */
        function () {
            if (this._windowRef) {
                this.close();
            }
            else {
                this.open();
            }
        };
    /**
     * Returns whether or not the tooltip is currently being shown
     */
    /**
       * Returns whether or not the tooltip is currently being shown
       */
    NgbTooltip.prototype.isOpen = /**
       * Returns whether or not the tooltip is currently being shown
       */
        function () { return this._windowRef != null; };
    NgbTooltip.prototype.ngOnInit = function () {
        this._unregisterListenersFn = listenToTriggers(this._renderer, this._elementRef.nativeElement, this.triggers, this.open.bind(this), this.close.bind(this), this.toggle.bind(this));
    };
    NgbTooltip.prototype.ngOnDestroy = function () {
        this.close();
        // This check is needed as it might happen that ngOnDestroy is called before ngOnInit
        // under certain conditions, see: https://github.com/ng-bootstrap/ng-bootstrap/issues/2199
        if (this._unregisterListenersFn) {
            this._unregisterListenersFn();
        }
        this._zoneSubscription.unsubscribe();
    };
    return NgbTooltip;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.module.js





var tooltip_module_NgbTooltipModule = /*@__PURE__*/ (function () {
    function NgbTooltipModule() {
    }
    NgbTooltipModule.forRoot = function () { return { ngModule: NgbTooltipModule, providers: [NgbTooltipConfig] }; };
    return NgbTooltipModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/highlight.js


var highlight_NgbHighlight = /*@__PURE__*/ (function () {
    function NgbHighlight() {
        this.highlightClass = 'ngb-highlight';
    }
    NgbHighlight.prototype.ngOnChanges = function (changes) {
        var resultStr = util_toString(this.result);
        var resultLC = resultStr.toLowerCase();
        var termLC = util_toString(this.term).toLowerCase();
        var currentIdx = 0;
        if (termLC.length > 0) {
            this.parts = resultLC.split(new RegExp("(" + regExpEscape(termLC) + ")")).map(function (part) {
                var originalPart = resultStr.substr(currentIdx, part.length);
                currentIdx += part.length;
                return originalPart;
            });
        }
        else {
            this.parts = [resultStr];
        }
    };
    return NgbHighlight;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-window.js


var typeahead_window_NgbTypeaheadWindow = /*@__PURE__*/ (function () {
    function NgbTypeaheadWindow() {
        this.activeIdx = 0;
        /**
           * Flag indicating if the first row should be active initially
           */
        this.focusFirst = true;
        /**
           * A function used to format a given result before display. This function should return a formatted string without any
           * HTML markup
           */
        this.formatter = util_toString;
        /**
           * Event raised when user selects a particular result row
           */
        this.selectEvent = new core["EventEmitter"]();
        this.activeChangeEvent = new core["EventEmitter"]();
    }
    NgbTypeaheadWindow.prototype.hasActive = function () { return this.activeIdx > -1 && this.activeIdx < this.results.length; };
    NgbTypeaheadWindow.prototype.getActive = function () { return this.results[this.activeIdx]; };
    NgbTypeaheadWindow.prototype.markActive = function (activeIdx) {
        this.activeIdx = activeIdx;
        this._activeChanged();
    };
    NgbTypeaheadWindow.prototype.next = function () {
        if (this.activeIdx === this.results.length - 1) {
            this.activeIdx = this.focusFirst ? (this.activeIdx + 1) % this.results.length : -1;
        }
        else {
            this.activeIdx++;
        }
        this._activeChanged();
    };
    NgbTypeaheadWindow.prototype.prev = function () {
        if (this.activeIdx < 0) {
            this.activeIdx = this.results.length - 1;
        }
        else if (this.activeIdx === 0) {
            this.activeIdx = this.focusFirst ? this.results.length - 1 : -1;
        }
        else {
            this.activeIdx--;
        }
        this._activeChanged();
    };
    NgbTypeaheadWindow.prototype.resetActive = function () {
        this.activeIdx = this.focusFirst ? 0 : -1;
        this._activeChanged();
    };
    NgbTypeaheadWindow.prototype.select = function (item) { this.selectEvent.emit(item); };
    NgbTypeaheadWindow.prototype.ngOnInit = function () { this.resetActive(); };
    NgbTypeaheadWindow.prototype._activeChanged = function () {
        this.activeChangeEvent.emit(this.activeIdx >= 0 ? this.id + '-' + this.activeIdx : undefined);
    };
    return NgbTypeaheadWindow;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/util/accessibility/live.js


var ARIA_LIVE_DELAY = new core["InjectionToken"]('live announcer delay');
var DEFAULT_ARIA_LIVE_DELAY = 100;
function getLiveElement(document, lazyCreate) {
    if (lazyCreate === void 0) {
        lazyCreate = false;
    }
    var element = document.body.querySelector('#ngb-live');
    if (element == null && lazyCreate) {
        element = document.createElement('div');
        element.setAttribute('id', 'ngb-live');
        element.setAttribute('aria-live', 'polite');
        element.setAttribute('aria-atomic', 'true');
        element.classList.add('sr-only');
        document.body.appendChild(element);
    }
    return element;
}
var Live = /*@__PURE__*/ (function () {
    function Live(_document, _delay) {
        this._document = _document;
        this._delay = _delay;
    }
    Live.prototype.ngOnDestroy = function () {
        var element = getLiveElement(this._document);
        if (element) {
            element.parentElement.removeChild(element);
        }
    };
    Live.prototype.say = function (message) {
        var element = getLiveElement(this._document, true);
        var delay = this._delay;
        element.textContent = '';
        var setText = function () { return element.textContent = message; };
        if (delay === null) {
            setText();
        }
        else {
            setTimeout(setText, delay);
        }
    };
    return Live;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-config.js

/**
 * Configuration service for the NgbTypeahead component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the typeaheads used in the application.
 */
var NgbTypeaheadConfig = /*@__PURE__*/ (function () {
    function NgbTypeaheadConfig() {
        this.editable = true;
        this.focusFirst = true;
        this.showHint = false;
        this.placement = 'bottom-left';
    }
    return NgbTypeaheadConfig;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead.js











var NGB_TYPEAHEAD_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    useExisting: Object(core["forwardRef"])(function () { return typeahead_NgbTypeahead; }),
    multi: true
};
var nextWindowId = 0;
/**
 * NgbTypeahead directive provides a simple way of creating powerful typeaheads from any text input
 */
var typeahead_NgbTypeahead = /*@__PURE__*/ (function () {
    function NgbTypeahead(_elementRef, _viewContainerRef, _renderer, _injector, componentFactoryResolver, config, ngZone, _live) {
        var _this = this;
        this._elementRef = _elementRef;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._injector = _injector;
        this._live = _live;
        /**
           * Value for the configurable autocomplete attribute.
           * Defaults to 'off' to disable the native browser autocomplete, but this standard value does not seem
           * to be always correctly taken into account.
           *
           * @since 2.1.0
           */
        this.autocomplete = 'off';
        /** Placement of a typeahead accepts:
           *    "top", "top-left", "top-right", "bottom", "bottom-left", "bottom-right",
           *    "left", "left-top", "left-bottom", "right", "right-top", "right-bottom"
           * and array of above values.
          */
        this.placement = 'bottom-left';
        /**
           * An event emitted when a match is selected. Event payload is of type NgbTypeaheadSelectItemEvent.
           */
        this.selectItem = new core["EventEmitter"]();
        this.popupId = "ngb-typeahead-" + nextWindowId++;
        this._onTouched = function () { };
        this._onChange = function (_) { };
        this.container = config.container;
        this.editable = config.editable;
        this.focusFirst = config.focusFirst;
        this.showHint = config.showHint;
        this.placement = config.placement;
        this._valueChanges = Object(_esm5["r" /* fromEvent */])(_elementRef.nativeElement, 'input')
            .pipe(Object(operators["map"])(function ($event) { return $event.target.value; }));
        this._resubscribeTypeahead = new _esm5["a" /* BehaviorSubject */](null);
        this._popupService = new popup_PopupService(typeahead_window_NgbTypeaheadWindow, _injector, _viewContainerRef, _renderer, componentFactoryResolver);
        this._zoneSubscription = ngZone.onStable.subscribe(function () {
            if (_this.isPopupOpen()) {
                positionElements(_this._elementRef.nativeElement, _this._windowRef.location.nativeElement, _this.placement, _this.container === 'body');
            }
        });
    }
    NgbTypeahead.prototype.ngOnInit = function () {
        var _this = this;
        var inputValues$ = this._valueChanges.pipe(Object(operators["tap"])(function (value) {
            _this._inputValueBackup = value;
            if (_this.editable) {
                _this._onChange(value);
            }
        }));
        var results$ = inputValues$.pipe(this.ngbTypeahead);
        var processedResults$ = results$.pipe(Object(operators["tap"])(function () {
            if (!_this.editable) {
                _this._onChange(undefined);
            }
        }));
        var userInput$ = this._resubscribeTypeahead.pipe(Object(operators["switchMap"])(function () { return processedResults$; }));
        this._subscription = this._subscribeToUserInput(userInput$);
    };
    NgbTypeahead.prototype.ngOnDestroy = function () {
        this._closePopup();
        this._unsubscribeFromUserInput();
        this._zoneSubscription.unsubscribe();
    };
    NgbTypeahead.prototype.registerOnChange = function (fn) { this._onChange = fn; };
    NgbTypeahead.prototype.registerOnTouched = function (fn) { this._onTouched = fn; };
    NgbTypeahead.prototype.writeValue = function (value) { this._writeInputValue(this._formatItemForInput(value)); };
    NgbTypeahead.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    NgbTypeahead.prototype.onDocumentClick = function (event) {
        if (event.target !== this._elementRef.nativeElement) {
            this.dismissPopup();
        }
    };
    /**
     * Dismisses typeahead popup window
     */
    /**
       * Dismisses typeahead popup window
       */
    NgbTypeahead.prototype.dismissPopup = /**
       * Dismisses typeahead popup window
       */
        function () {
            if (this.isPopupOpen()) {
                this._closePopup();
                this._writeInputValue(this._inputValueBackup);
            }
        };
    /**
     * Returns true if the typeahead popup window is displayed
     */
    /**
       * Returns true if the typeahead popup window is displayed
       */
    NgbTypeahead.prototype.isPopupOpen = /**
       * Returns true if the typeahead popup window is displayed
       */
        function () { return this._windowRef != null; };
    NgbTypeahead.prototype.handleBlur = function () {
        this._resubscribeTypeahead.next(null);
        this._onTouched();
    };
    NgbTypeahead.prototype.handleKeyDown = function (event) {
        if (!this.isPopupOpen()) {
            return;
        }
        if (Key[util_toString(event.which)]) {
            switch (event.which) {
                case Key.ArrowDown:
                    event.preventDefault();
                    this._windowRef.instance.next();
                    this._showHint();
                    break;
                case Key.ArrowUp:
                    event.preventDefault();
                    this._windowRef.instance.prev();
                    this._showHint();
                    break;
                case Key.Enter:
                case Key.Tab:
                    var result = this._windowRef.instance.getActive();
                    if (isDefined(result)) {
                        event.preventDefault();
                        event.stopPropagation();
                        this._selectResult(result);
                    }
                    this._closePopup();
                    break;
                case Key.Escape:
                    event.preventDefault();
                    this._resubscribeTypeahead.next(null);
                    this.dismissPopup();
                    break;
            }
        }
    };
    NgbTypeahead.prototype._openPopup = function () {
        var _this = this;
        if (!this.isPopupOpen()) {
            this._inputValueBackup = this._elementRef.nativeElement.value;
            this._windowRef = this._popupService.open();
            this._windowRef.instance.id = this.popupId;
            this._windowRef.instance.selectEvent.subscribe(function (result) { return _this._selectResultClosePopup(result); });
            this._windowRef.instance.activeChangeEvent.subscribe(function (activeId) { return _this.activeDescendant = activeId; });
            if (this.container === 'body') {
                window.document.querySelector(this.container).appendChild(this._windowRef.location.nativeElement);
            }
        }
    };
    NgbTypeahead.prototype._closePopup = function () {
        this._popupService.close();
        this._windowRef = null;
        this.activeDescendant = undefined;
    };
    NgbTypeahead.prototype._selectResult = function (result) {
        var defaultPrevented = false;
        this.selectItem.emit({ item: result, preventDefault: function () { defaultPrevented = true; } });
        this._resubscribeTypeahead.next(null);
        if (!defaultPrevented) {
            this.writeValue(result);
            this._onChange(result);
        }
    };
    NgbTypeahead.prototype._selectResultClosePopup = function (result) {
        this._selectResult(result);
        this._closePopup();
    };
    NgbTypeahead.prototype._showHint = function () {
        if (this.showHint && this._windowRef.instance.hasActive() && this._inputValueBackup != null) {
            var userInputLowerCase = this._inputValueBackup.toLowerCase();
            var formattedVal = this._formatItemForInput(this._windowRef.instance.getActive());
            if (userInputLowerCase === formattedVal.substr(0, this._inputValueBackup.length).toLowerCase()) {
                this._writeInputValue(this._inputValueBackup + formattedVal.substr(this._inputValueBackup.length));
                this._elementRef.nativeElement['setSelectionRange'].apply(this._elementRef.nativeElement, [this._inputValueBackup.length, formattedVal.length]);
            }
            else {
                this.writeValue(this._windowRef.instance.getActive());
            }
        }
    };
    NgbTypeahead.prototype._formatItemForInput = function (item) {
        return item != null && this.inputFormatter ? this.inputFormatter(item) : util_toString(item);
    };
    NgbTypeahead.prototype._writeInputValue = function (value) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', util_toString(value));
    };
    NgbTypeahead.prototype._subscribeToUserInput = function (userInput$) {
        var _this = this;
        return userInput$.subscribe(function (results) {
            if (!results || results.length === 0) {
                _this._closePopup();
            }
            else {
                _this._openPopup();
                _this._windowRef.instance.focusFirst = _this.focusFirst;
                _this._windowRef.instance.results = results;
                _this._windowRef.instance.term = _this._elementRef.nativeElement.value;
                if (_this.resultFormatter) {
                    _this._windowRef.instance.formatter = _this.resultFormatter;
                }
                if (_this.resultTemplate) {
                    _this._windowRef.instance.resultTemplate = _this.resultTemplate;
                }
                _this._windowRef.instance.resetActive();
                // The observable stream we are subscribing to might have async steps
                // and if a component containing typeahead is using the OnPush strategy
                // the change detection turn wouldn't be invoked automatically.
                // The observable stream we are subscribing to might have async steps
                // and if a component containing typeahead is using the OnPush strategy
                // the change detection turn wouldn't be invoked automatically.
                _this._windowRef.changeDetectorRef.detectChanges();
                _this._showHint();
            }
            // live announcer
            var count = results ? results.length : 0;
            _this._live.say(count === 0 ? 'No results available' : count + " result" + (count === 1 ? '' : 's') + " available");
        });
    };
    NgbTypeahead.prototype._unsubscribeFromUserInput = function () {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
        this._subscription = null;
    };
    return NgbTypeahead;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead.module.js











var typeahead_module_NgbTypeaheadModule = /*@__PURE__*/ (function () {
    function NgbTypeaheadModule() {
    }
    NgbTypeaheadModule.forRoot = function () {
        return {
            ngModule: NgbTypeaheadModule,
            providers: [Live, NgbTypeaheadConfig, { provide: ARIA_LIVE_DELAY, useValue: DEFAULT_ARIA_LIVE_DELAY }]
        };
    };
    return NgbTypeaheadModule;
}());





// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/index.js

































var NGB_MODULES = [
    accordion_module_NgbAccordionModule, alert_module_NgbAlertModule, NgbButtonsModule, carousel_module_NgbCarouselModule, NgbCollapseModule, datepicker_module_NgbDatepickerModule,
    dropdown_module_NgbDropdownModule, modal_module_NgbModalModule, pagination_module_NgbPaginationModule, popover_module_NgbPopoverModule, progressbar_module_NgbProgressbarModule, rating_module_NgbRatingModule,
    tabset_module_NgbTabsetModule, timepicker_module_NgbTimepickerModule, tooltip_module_NgbTooltipModule, typeahead_module_NgbTypeaheadModule
];
var NgbRootModule = /*@__PURE__*/ (function () {
    function NgbRootModule() {
    }
    return NgbRootModule;
}());

var NgbModule = /*@__PURE__*/ (function () {
    function NgbModule() {
    }
    NgbModule.forRoot = function () { return { ngModule: NgbRootModule }; };
    return NgbModule;
}());





// EXTERNAL MODULE: ./node_modules/angular-froala-wysiwyg/editor/editor.directive.js
var editor_directive = __webpack_require__("15xe");

// CONCATENATED MODULE: ./node_modules/angular-froala-wysiwyg/editor/editor.module.js


var FroalaEditorModule = /*@__PURE__*/ (function () {
    function FroalaEditorModule() {
    }
    FroalaEditorModule.forRoot = function () {
        return { ngModule: FroalaEditorModule, providers: [] };
    };
    return FroalaEditorModule;
}());





// CONCATENATED MODULE: ./node_modules/angular-froala-wysiwyg/editor/index.js


//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/angular-froala-wysiwyg/view/view.directive.js

var FroalaViewDirective = /*@__PURE__*/ (function () {
    function FroalaViewDirective(renderer, element) {
        this.renderer = renderer;
        this._element = element.nativeElement;
    }
    Object.defineProperty(FroalaViewDirective.prototype, "froalaView", {
        set: 
        // update content model as it comes
        function (content) {
            this._element.innerHTML = content;
        },
        enumerable: true,
        configurable: true
    });
    FroalaViewDirective.prototype.ngAfterViewInit = function () {
        this.renderer.setElementClass(this._element, "fr-view", true);
    };
    return FroalaViewDirective;
}());





// CONCATENATED MODULE: ./node_modules/angular-froala-wysiwyg/view/view.module.js


var FroalaViewModule = /*@__PURE__*/ (function () {
    function FroalaViewModule() {
    }
    FroalaViewModule.forRoot = function () {
        return { ngModule: FroalaViewModule, providers: [] };
    };
    return FroalaViewModule;
}());





// CONCATENATED MODULE: ./node_modules/angular-froala-wysiwyg/view/index.js


//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/angular-froala-wysiwyg/index.js





var MODULES = [
    FroalaEditorModule,
    FroalaViewModule
];
var FERootModule = /*@__PURE__*/ (function () {
    function FERootModule() {
    }
    return FERootModule;
}());





// EXTERNAL MODULE: ./node_modules/froala-editor/js/froala_editor.pkgd.min.js
var froala_editor_pkgd_min = __webpack_require__("sXnP");
var froala_editor_pkgd_min_default = /*#__PURE__*/__webpack_require__.n(froala_editor_pkgd_min);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/dropdown.directive.js


var dropdown_directive_DropdownDirective = /*@__PURE__*/ (function () {
    function DropdownDirective() {
        // tslint:disable-next-line:no-input-rename
        this.internalOpen = false;
        this.openChange = new core["EventEmitter"]();
    }
    Object.defineProperty(DropdownDirective.prototype, "isOpen", {
        get: function () {
            return this.internalOpen;
        },
        enumerable: true,
        configurable: true
    });
    DropdownDirective.prototype.onKeyupEsc = function () {
        this.close();
    };
    DropdownDirective.prototype.onDocumentClick = function (event) {
        if (event.button !== 2 && !this.isEventFromToggle(event)) {
            this.close();
        }
    };
    DropdownDirective.prototype.open = function () {
        if (!this.internalOpen) {
            this.internalOpen = true;
            this.openChange.emit(true);
        }
    };
    DropdownDirective.prototype.close = function () {
        if (this.internalOpen) {
            this.internalOpen = false;
            this.openChange.emit(false);
        }
    };
    DropdownDirective.prototype.toggle = function () {
        if (this.isOpen) {
            this.close();
        }
        else {
            this.open();
        }
    };
    DropdownDirective.prototype.isEventFromToggle = function (event) {
        return !Object(lodash["isNil"])(this.toggleElement) && this.toggleElement.contains(event.target);
    };
    return DropdownDirective;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/dropdown-menu.directive.js


var DropdownMenuDirective = /*@__PURE__*/ (function () {
    function DropdownMenuDirective(dropdown) {
        this.dropdown = dropdown;
    }
    return DropdownMenuDirective;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/dropdown-toggle.directive.js


var DropdownToggleDirective = /*@__PURE__*/ (function () {
    function DropdownToggleDirective(dropdown, elementRef) {
        this.dropdown = dropdown;
        dropdown.toggleElement = elementRef.nativeElement;
    }
    return DropdownToggleDirective;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview-i18n.js
var treeview_i18n___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var TreeviewI18n = /*@__PURE__*/ (function () {
    function TreeviewI18n() {
    }
    return TreeviewI18n;
}());

var TreeviewI18nDefault = /*@__PURE__*/ (function (_super) {
    treeview_i18n___extends(TreeviewI18nDefault, _super);
    function TreeviewI18nDefault() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TreeviewI18nDefault.prototype.getText = function (selection) {
        if (selection.uncheckedItems.length === 0) {
            return this.getAllCheckboxText();
        }
        switch (selection.checkedItems.length) {
            case 0:
                return 'Select options';
            case 1:
                return selection.checkedItems[0].text;
            default:
                return selection.checkedItems.length + " options selected";
        }
    };
    TreeviewI18nDefault.prototype.getAllCheckboxText = function () {
        return 'All';
    };
    TreeviewI18nDefault.prototype.getFilterPlaceholder = function () {
        return 'Filter';
    };
    TreeviewI18nDefault.prototype.getFilterNoItemsFoundText = function () {
        return 'No items found';
    };
    TreeviewI18nDefault.prototype.getTooltipCollapseExpandText = function (isCollapse) {
        return isCollapse ? 'Expand' : 'Collapse';
    };
    return TreeviewI18nDefault;
}(TreeviewI18n));





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview-config.js

var TreeviewConfig = /*@__PURE__*/ (function () {
    function TreeviewConfig() {
        this.hasAllCheckBox = true;
        this.hasFilter = false;
        this.hasCollapseExpand = false;
        this.decoupleChildFromParent = false;
        this.maxHeight = 500;
    }
    Object.defineProperty(TreeviewConfig.prototype, "hasDivider", {
        get: function () {
            return this.hasFilter || this.hasAllCheckBox || this.hasCollapseExpand;
        },
        enumerable: true,
        configurable: true
    });
    TreeviewConfig.create = function (fields) {
        var config = new TreeviewConfig();
        Object.assign(config, fields);
        return config;
    };
    return TreeviewConfig;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview-helper.js

var TreeviewHelper = {
    findItem: findItem,
    findItemInList: findItemInList,
    findParent: findParent,
    removeItem: removeItem,
    concatSelection: concatSelection
};
function findItem(root, value) {
    if (Object(lodash["isNil"])(root)) {
        return undefined;
    }
    if (root.value === value) {
        return root;
    }
    if (root.children) {
        for (var _i = 0, _a = root.children; _i < _a.length; _i++) {
            var child = _a[_i];
            var foundItem = findItem(child, value);
            if (foundItem) {
                return foundItem;
            }
        }
    }
    return undefined;
}
function findItemInList(list, value) {
    if (Object(lodash["isNil"])(list)) {
        return undefined;
    }
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var item = list_1[_i];
        var foundItem = findItem(item, value);
        if (foundItem) {
            return foundItem;
        }
    }
    return undefined;
}
function findParent(root, item) {
    if (Object(lodash["isNil"])(root) || Object(lodash["isNil"])(root.children)) {
        return undefined;
    }
    for (var _i = 0, _a = root.children; _i < _a.length; _i++) {
        var child = _a[_i];
        if (child === item) {
            return root;
        }
        else {
            var parent_1 = findParent(child, item);
            if (parent_1) {
                return parent_1;
            }
        }
    }
    return undefined;
}
function removeItem(root, item) {
    var parent = findParent(root, item);
    if (parent) {
        Object(lodash["pull"])(parent.children, item);
        if (parent.children.length === 0) {
            parent.children = undefined;
        }
        else {
            parent.correctChecked();
        }
        return true;
    }
    return false;
}
function concatSelection(items, checked, unchecked) {
    var checkedItems = checked.slice();
    var uncheckedItems = unchecked.slice();
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var item = items_1[_i];
        var selection = item.getSelection();
        checkedItems = Object(lodash["concat"])(checkedItems, selection.checkedItems);
        uncheckedItems = Object(lodash["concat"])(uncheckedItems, selection.uncheckedItems);
    }
    return {
        checked: checkedItems,
        unchecked: uncheckedItems
    };
}
//# sourceMappingURL=treeview-helper.js.map
// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview-item.js


var treeview_item_TreeviewItem = /*@__PURE__*/ (function () {
    function TreeviewItem(item, autoCorrectChecked) {
        if (autoCorrectChecked === void 0) {
            autoCorrectChecked = false;
        }
        var _this = this;
        this.internalDisabled = false;
        this.internalChecked = true;
        this.internalCollapsed = false;
        if (Object(lodash["isNil"])(item)) {
            throw new Error('Item must be defined');
        }
        if (Object(lodash["isString"])(item.text)) {
            this.text = item.text;
        }
        else {
            throw new Error('A text of item must be string object');
        }
        this.value = item.value;
        if (Object(lodash["isBoolean"])(item.checked)) {
            this.checked = item.checked;
        }
        if (Object(lodash["isBoolean"])(item.collapsed)) {
            this.collapsed = item.collapsed;
        }
        if (Object(lodash["isBoolean"])(item.disabled)) {
            this.disabled = item.disabled;
        }
        if (!Object(lodash["isNil"])(item.children) && item.children.length > 0) {
            this.children = item.children.map(function (child) {
                if (_this.disabled === true) {
                    child.disabled = true;
                }
                return new TreeviewItem(child);
            });
        }
        if (autoCorrectChecked) {
            this.correctChecked();
        }
    }
    Object.defineProperty(TreeviewItem.prototype, "checked", {
        get: function () {
            return this.internalChecked;
        },
        set: function (value) {
            if (!this.internalDisabled) {
                if (this.internalChecked !== value) {
                    this.internalChecked = value;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeviewItem.prototype, "indeterminate", {
        get: function () {
            return this.checked === undefined;
        },
        enumerable: true,
        configurable: true
    });
    TreeviewItem.prototype.setCheckedRecursive = function (value) {
        if (!this.internalDisabled) {
            this.internalChecked = value;
            if (!Object(lodash["isNil"])(this.internalChildren)) {
                this.internalChildren.forEach(function (child) { return child.setCheckedRecursive(value); });
            }
        }
    };
    Object.defineProperty(TreeviewItem.prototype, "disabled", {
        get: function () {
            return this.internalDisabled;
        },
        set: function (value) {
            if (this.internalDisabled !== value) {
                this.internalDisabled = value;
                if (!Object(lodash["isNil"])(this.internalChildren)) {
                    this.internalChildren.forEach(function (child) { return child.disabled = value; });
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeviewItem.prototype, "collapsed", {
        get: function () {
            return this.internalCollapsed;
        },
        set: function (value) {
            if (this.internalCollapsed !== value) {
                this.internalCollapsed = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    TreeviewItem.prototype.setCollapsedRecursive = function (value) {
        this.internalCollapsed = value;
        if (!Object(lodash["isNil"])(this.internalChildren)) {
            this.internalChildren.forEach(function (child) { return child.setCollapsedRecursive(value); });
        }
    };
    Object.defineProperty(TreeviewItem.prototype, "children", {
        get: function () {
            return this.internalChildren;
        },
        set: function (value) {
            if (this.internalChildren !== value) {
                if (!Object(lodash["isNil"])(value) && value.length === 0) {
                    throw new Error('Children must be not an empty array');
                }
                this.internalChildren = value;
                if (!Object(lodash["isNil"])(this.internalChildren)) {
                    var checked_1 = null;
                    this.internalChildren.forEach(function (child) {
                        if (checked_1 === null) {
                            checked_1 = child.checked;
                        }
                        else {
                            if (child.checked !== checked_1) {
                                checked_1 = undefined;
                                return;
                            }
                        }
                    });
                    this.internalChecked = checked_1;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    TreeviewItem.prototype.getSelection = function () {
        var checkedItems = [];
        var uncheckedItems = [];
        if (Object(lodash["isNil"])(this.internalChildren)) {
            if (this.internalChecked) {
                checkedItems.push(this);
            }
            else {
                uncheckedItems.push(this);
            }
        }
        else {
            var selection = TreeviewHelper.concatSelection(this.internalChildren, checkedItems, uncheckedItems);
            checkedItems = selection.checked;
            uncheckedItems = selection.unchecked;
        }
        return {
            checkedItems: checkedItems,
            uncheckedItems: uncheckedItems
        };
    };
    TreeviewItem.prototype.correctChecked = function () {
        this.internalChecked = this.getCorrectChecked();
    };
    TreeviewItem.prototype.getCorrectChecked = function () {
        var checked = null;
        if (!Object(lodash["isNil"])(this.internalChildren)) {
            for (var _i = 0, _a = this.internalChildren; _i < _a.length; _i++) {
                var child = _a[_i];
                child.internalChecked = child.getCorrectChecked();
                if (checked === null) {
                    checked = child.internalChecked;
                }
                else if (checked !== child.internalChecked) {
                    checked = undefined;
                    break;
                }
            }
        }
        else {
            checked = this.checked;
        }
        return checked;
    };
    return TreeviewItem;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview-event-parser.js
var treeview_event_parser___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var TreeviewEventParser = /*@__PURE__*/ (function () {
    function TreeviewEventParser() {
    }
    return TreeviewEventParser;
}());

var treeview_event_parser_DefaultTreeviewEventParser = /*@__PURE__*/ (function (_super) {
    treeview_event_parser___extends(DefaultTreeviewEventParser, _super);
    function DefaultTreeviewEventParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultTreeviewEventParser.prototype.getSelectedChange = function (component) {
        var checkedItems = component.selection.checkedItems;
        if (!Object(lodash["isNil"])(checkedItems)) {
            return checkedItems.map(function (item) { return item.value; });
        }
        return [];
    };
    return DefaultTreeviewEventParser;
}(TreeviewEventParser));

var treeview_event_parser_DownlineTreeviewEventParser = /*@__PURE__*/ (function (_super) {
    treeview_event_parser___extends(DownlineTreeviewEventParser, _super);
    function DownlineTreeviewEventParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DownlineTreeviewEventParser.prototype.getSelectedChange = function (component) {
        var _this = this;
        var items = component.items;
        if (!Object(lodash["isNil"])(items)) {
            var result_1 = [];
            items.forEach(function (item) {
                var links = _this.getLinks(item, null);
                if (!Object(lodash["isNil"])(links)) {
                    result_1 = result_1.concat(links);
                }
            });
            return result_1;
        }
        return [];
    };
    DownlineTreeviewEventParser.prototype.getLinks = function (item, parent) {
        var _this = this;
        if (!Object(lodash["isNil"])(item.children)) {
            var link_1 = {
                item: item,
                parent: parent
            };
            var result_2 = [];
            item.children.forEach(function (child) {
                var links = _this.getLinks(child, link_1);
                if (!Object(lodash["isNil"])(links)) {
                    result_2 = result_2.concat(links);
                }
            });
            return result_2;
        }
        if (item.checked) {
            return [{
                    item: item,
                    parent: parent
                }];
        }
        return null;
    };
    return DownlineTreeviewEventParser;
}(TreeviewEventParser));

var OrderDownlineTreeviewEventParser = /*@__PURE__*/ (function (_super) {
    treeview_event_parser___extends(OrderDownlineTreeviewEventParser, _super);
    function OrderDownlineTreeviewEventParser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentDownlines = [];
        _this.parser = new treeview_event_parser_DownlineTreeviewEventParser();
        return _this;
    }
    OrderDownlineTreeviewEventParser.prototype.getSelectedChange = function (component) {
        var newDownlines = this.parser.getSelectedChange(component);
        if (this.currentDownlines.length === 0) {
            this.currentDownlines = newDownlines;
        }
        else {
            var intersectDownlines_1 = [];
            this.currentDownlines.forEach(function (downline) {
                var foundIndex = -1;
                var length = newDownlines.length;
                for (var i = 0; i < length; i++) {
                    if (downline.item.value === newDownlines[i].item.value) {
                        foundIndex = i;
                        break;
                    }
                }
                if (foundIndex !== -1) {
                    intersectDownlines_1.push(newDownlines[foundIndex]);
                    newDownlines.splice(foundIndex, 1);
                }
            });
            this.currentDownlines = intersectDownlines_1.concat(newDownlines);
        }
        return this.currentDownlines;
    };
    return OrderDownlineTreeviewEventParser;
}(TreeviewEventParser));





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview.component.js
var treeview_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var FilterTreeviewItem = /*@__PURE__*/ (function (_super) {
    treeview_component___extends(FilterTreeviewItem, _super);
    function FilterTreeviewItem(item) {
        var _this = _super.call(this, {
            text: item.text,
            value: item.value,
            disabled: item.disabled,
            checked: item.checked,
            collapsed: item.collapsed,
            children: item.children
        }) || this;
        _this.refItem = item;
        return _this;
    }
    FilterTreeviewItem.prototype.updateRefChecked = function () {
        this.children.forEach(function (child) {
            if (child instanceof FilterTreeviewItem) {
                child.updateRefChecked();
            }
        });
        var refChecked = this.checked;
        if (refChecked) {
            for (var _i = 0, _a = this.refItem.children; _i < _a.length; _i++) {
                var refChild = _a[_i];
                if (!refChild.checked) {
                    refChecked = false;
                    break;
                }
            }
        }
        this.refItem.checked = refChecked;
    };
    return FilterTreeviewItem;
}(treeview_item_TreeviewItem));
var treeview_component_TreeviewComponent = /*@__PURE__*/ (function () {
    function TreeviewComponent(i18n, defaultConfig, eventParser) {
        this.i18n = i18n;
        this.defaultConfig = defaultConfig;
        this.eventParser = eventParser;
        this.selectedChange = new core["EventEmitter"]();
        this.filterChange = new core["EventEmitter"]();
        this.filterText = '';
        this.config = this.defaultConfig;
        this.allItem = new treeview_item_TreeviewItem({ text: 'All', value: undefined });
        this.createHeaderTemplateContext();
    }
    Object.defineProperty(TreeviewComponent.prototype, "hasFilterItems", {
        get: function () {
            return !Object(lodash["isNil"])(this.filterItems) && this.filterItems.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeviewComponent.prototype, "maxHeight", {
        get: function () {
            return "" + this.config.maxHeight;
        },
        enumerable: true,
        configurable: true
    });
    TreeviewComponent.prototype.ngOnChanges = function (changes) {
        var itemsSimpleChange = changes['items'];
        if (!Object(lodash["isNil"])(itemsSimpleChange)) {
            if (!Object(lodash["isNil"])(this.items)) {
                this.updateFilterItems();
                this.updateCollapsedOfAll();
                this.raiseSelectedChange();
            }
        }
        this.createHeaderTemplateContext();
    };
    TreeviewComponent.prototype.onAllCollapseExpand = function () {
        var _this = this;
        this.allItem.collapsed = !this.allItem.collapsed;
        this.filterItems.forEach(function (item) { return item.setCollapsedRecursive(_this.allItem.collapsed); });
    };
    TreeviewComponent.prototype.onFilterTextChange = function (text) {
        this.filterText = text;
        this.filterChange.emit(text);
        this.updateFilterItems();
    };
    TreeviewComponent.prototype.onAllCheckedChange = function () {
        var checked = this.allItem.checked;
        this.filterItems.forEach(function (item) {
            item.setCheckedRecursive(checked);
            if (item instanceof FilterTreeviewItem) {
                item.updateRefChecked();
            }
        });
        this.raiseSelectedChange();
    };
    TreeviewComponent.prototype.onItemCheckedChange = function (item, checked) {
        if (item instanceof FilterTreeviewItem) {
            item.updateRefChecked();
        }
        this.updateCheckedOfAll();
        this.raiseSelectedChange();
    };
    TreeviewComponent.prototype.raiseSelectedChange = function () {
        this.generateSelection();
        var values = this.eventParser.getSelectedChange(this);
        this.selectedChange.emit(values);
    };
    TreeviewComponent.prototype.createHeaderTemplateContext = function () {
        var _this = this;
        this.headerTemplateContext = {
            config: this.config,
            item: this.allItem,
            onCheckedChange: function () { return _this.onAllCheckedChange(); },
            onCollapseExpand: function () { return _this.onAllCollapseExpand(); },
            onFilterTextChange: function (text) { return _this.onFilterTextChange(text); }
        };
    };
    TreeviewComponent.prototype.generateSelection = function () {
        var checkedItems = [];
        var uncheckedItems = [];
        if (!Object(lodash["isNil"])(this.items)) {
            var selection = TreeviewHelper.concatSelection(this.items, checkedItems, uncheckedItems);
            checkedItems = selection.checked;
            uncheckedItems = selection.unchecked;
        }
        this.selection = {
            checkedItems: checkedItems,
            uncheckedItems: uncheckedItems
        };
    };
    TreeviewComponent.prototype.updateFilterItems = function () {
        var _this = this;
        if (this.filterText !== '') {
            var filterItems_1 = [];
            var filterText_1 = this.filterText.toLowerCase();
            this.items.forEach(function (item) {
                var newItem = _this.filterItem(item, filterText_1);
                if (!Object(lodash["isNil"])(newItem)) {
                    filterItems_1.push(newItem);
                }
            });
            this.filterItems = filterItems_1;
        }
        else {
            this.filterItems = this.items;
        }
        this.updateCheckedOfAll();
    };
    TreeviewComponent.prototype.filterItem = function (item, filterText) {
        var _this = this;
        var isMatch = Object(lodash["includes"])(item.text.toLowerCase(), filterText);
        if (isMatch) {
            return item;
        }
        else {
            if (!Object(lodash["isNil"])(item.children)) {
                var children_1 = [];
                item.children.forEach(function (child) {
                    var newChild = _this.filterItem(child, filterText);
                    if (!Object(lodash["isNil"])(newChild)) {
                        children_1.push(newChild);
                    }
                });
                if (children_1.length > 0) {
                    var newItem = new FilterTreeviewItem(item);
                    newItem.collapsed = false;
                    newItem.children = children_1;
                    return newItem;
                }
            }
        }
        return undefined;
    };
    TreeviewComponent.prototype.updateCheckedOfAll = function () {
        var itemChecked = null;
        for (var _i = 0, _a = this.filterItems; _i < _a.length; _i++) {
            var filterItem = _a[_i];
            if (itemChecked === null) {
                itemChecked = filterItem.checked;
            }
            else if (itemChecked !== filterItem.checked) {
                itemChecked = undefined;
                break;
            }
        }
        if (itemChecked === null) {
            itemChecked = false;
        }
        this.allItem.checked = itemChecked;
    };
    TreeviewComponent.prototype.updateCollapsedOfAll = function () {
        var hasItemExpanded = false;
        for (var _i = 0, _a = this.filterItems; _i < _a.length; _i++) {
            var filterItem = _a[_i];
            if (!filterItem.collapsed) {
                hasItemExpanded = true;
                break;
            }
        }
        this.allItem.collapsed = !hasItemExpanded;
    };
    return TreeviewComponent;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/dropdown-treeview.component.js





var dropdown_treeview_component_DropdownTreeviewComponent = /*@__PURE__*/ (function () {
    function DropdownTreeviewComponent(i18n, defaultConfig) {
        this.i18n = i18n;
        this.defaultConfig = defaultConfig;
        this.buttonClass = 'btn-outline-secondary';
        this.selectedChange = new core["EventEmitter"](true);
        this.filterChange = new core["EventEmitter"]();
        this.config = this.defaultConfig;
    }
    DropdownTreeviewComponent.prototype.getText = function () {
        return this.i18n.getText(this.treeviewComponent.selection);
    };
    DropdownTreeviewComponent.prototype.onSelectedChange = function (values) {
        this.selectedChange.emit(values);
    };
    DropdownTreeviewComponent.prototype.onFilterChange = function (text) {
        this.filterChange.emit(text);
    };
    return DropdownTreeviewComponent;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview-item.component.js



var treeview_item_component_TreeviewItemComponent = /*@__PURE__*/ (function () {
    function TreeviewItemComponent(defaultConfig) {
        var _this = this;
        this.defaultConfig = defaultConfig;
        this.checkedChange = new core["EventEmitter"]();
        this.onCollapseExpand = function () {
            _this.item.collapsed = !_this.item.collapsed;
        };
        this.onCheckedChange = function () {
            var checked = _this.item.checked;
            if (!Object(lodash["isNil"])(_this.item.children) && !_this.config.decoupleChildFromParent) {
                _this.item.children.forEach(function (child) { return child.setCheckedRecursive(checked); });
            }
            _this.checkedChange.emit(checked);
        };
        this.config = this.defaultConfig;
    }
    TreeviewItemComponent.prototype.onChildCheckedChange = function (child, checked) {
        if (!this.config.decoupleChildFromParent) {
            var itemChecked = null;
            for (var _i = 0, _a = this.item.children; _i < _a.length; _i++) {
                var childItem = _a[_i];
                if (itemChecked === null) {
                    itemChecked = childItem.checked;
                }
                else if (itemChecked !== childItem.checked) {
                    itemChecked = undefined;
                    break;
                }
            }
            if (itemChecked === null) {
                itemChecked = false;
            }
            if (this.item.checked !== itemChecked) {
                this.item.checked = itemChecked;
            }
        }
        this.checkedChange.emit(checked);
    };
    return TreeviewItemComponent;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview.pipe.js



var treeview_pipe_TreeviewPipe = /*@__PURE__*/ (function () {
    function TreeviewPipe() {
    }
    TreeviewPipe.prototype.transform = function (objects, textField) {
        if (Object(lodash["isNil"])(objects)) {
            return undefined;
        }
        return objects.map(function (object) { return new treeview_item_TreeviewItem({ text: object[textField], value: object }); });
    };
    return TreeviewPipe;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/treeview.module.js













var treeview_module_TreeviewModule = /*@__PURE__*/ (function () {
    function TreeviewModule() {
    }
    TreeviewModule.forRoot = function () {
        return {
            ngModule: TreeviewModule,
            providers: [
                TreeviewConfig,
                { provide: TreeviewI18n, useClass: TreeviewI18nDefault },
                { provide: TreeviewEventParser, useClass: treeview_event_parser_DefaultTreeviewEventParser }
            ]
        };
    };
    return TreeviewModule;
}());





// CONCATENATED MODULE: ./node_modules/ngx-treeview/src/index.js











//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./src/styles/headings.css
var headings = __webpack_require__("F9S/");
var headings_default = /*#__PURE__*/__webpack_require__.n(headings);

// EXTERNAL MODULE: ./src/styles/styles.scss
var styles_styles = __webpack_require__("B+PI");
var styles_default = /*#__PURE__*/__webpack_require__.n(styles_styles);

// EXTERNAL MODULE: ./node_modules/rxjs-compat/_esm5/Observable.js
var Observable = __webpack_require__("H0JA");

// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/of.js

_esm5["d" /* Observable */].of = _esm5["x" /* of */];
//# sourceMappingURL=of.js.map
// CONCATENATED MODULE: ./src/app/app.resolver.ts


// import { of } from 'rxjs/observable/of';
var app_resolver_DataResolver = /*@__PURE__*/ (function () {
    function DataResolver() {
    }
    DataResolver.prototype.resolve = function (route, state) {
        return Observable["a" /* Observable */].of({ res: 'I am data' });
    };
    return DataResolver;
}());

/**
 * An array of services to resolve routes with data.
 */
var APP_RESOLVER_PROVIDERS = [
    app_resolver_DataResolver
];


// CONCATENATED MODULE: ./src/app/bi/admin/controller/adminPage.component.ts
var AdminPage = /*@__PURE__*/ (function () {
    function AdminPage(router, adminService) {
        this.router = router;
        this.adminService = adminService;
        this.accessDenied = false;
        this.mainPage = true;
    }
    AdminPage.prototype.ngOnInit = function () {
        var _this = this;
        this.adminService.roleCheck().then(function () {
            if (_this.adminService.isBIAdmin) {
                _this.router.navigate(['biAdmin/wizard']);
            }
            else {
                _this.accessDenied = true;
            }
        });
    };
    AdminPage.prototype.enableActive = function (activeClass) {
        if (activeClass == 'uom')
            this.router.navigate(['biAdmin/uom']);
        if (activeClass == 'scope')
            this.router.navigate(['biAdmin/scope']);
        if (activeClass == 'dimension')
            this.router.navigate(['biAdmin/dimension']);
        if (activeClass == 'measure')
            this.router.navigate(['biAdmin/measure']);
        if (activeClass == 'dataSource')
            this.router.navigate(['biAdmin/dataSource']);
        if (activeClass == 'valueStream')
            this.router.navigate(['biAdmin/valueStream']);
        if (activeClass == 'cube')
            this.router.navigate(['biAdmin/cube']);
        if (activeClass == 'recordFormat')
            this.router.navigate(['biAdmin/recordFormat']);
        if (activeClass == 'dataEngine')
            this.router.navigate(['biAdmin/dataEngine']);
        if (activeClass == 'pageAuthorization')
            this.router.navigate(['biAdmin/pageAuthorization']);
        if (activeClass == 'dimLvlPermissions')
            this.router.navigate(['biAdmin/dimLvlPermissions']);
        if (activeClass == 'target')
            this.router.navigate(['biAdmin/target']);
        if (activeClass == 'tenantConfiguration')
            this.router.navigate(['biAdmin/tenantConfiguration']);
    };
    return AdminPage;
}());



// CONCATENATED MODULE: ./src/app/bi/biUrls.ts
var BiUrls = /*@__PURE__*/ (function () {
    function BiUrls() {
    }
    // Operations
    BiUrls.GET_OPERATIONS_FOR_USER = 'hub/getBIUserOperations';
    // Roles
    BiUrls.BIADMIN = 'biAdmin';
    // BI-ADMIN
    BiUrls.CUBE = 'cube';
    BiUrls.DIMENSION = 'dimension';
    BiUrls.BI_DIMENSION = 'bi/dimension';
    BiUrls.MEASURE = 'measure';
    BiUrls.BI_MEASURE = 'bi/measure';
    BiUrls.DATASOURCE = 'ds';
    BiUrls.DATAENGINE = 'de';
    BiUrls.UOM = 'uom';
    BiUrls.SCOPE = 'scope';
    BiUrls.RECORDFORMAT = 'recordFormat';
    BiUrls.VALUESTREAM = 'vs';
    BiUrls.DIM_LVL_PERMISSION = 'dimension/empOrgDimRel';
    BiUrls.TARGET = 'target';
    BiUrls.TENANT_CONFIG = 'tc';
    BiUrls.CACHE = 'cache';
    BiUrls.ANALYTICAL_SERVICE = 'adhoc';
    BiUrls.PAGE = 'page';
    BiUrls.DASHBOARD_PAGES = 'page/type/dashboard';
    BiUrls.ALL_DASHBOARDS = 'page/allDashboards';
    // Search
    BiUrls.SEARCH = '/search/';
    BiUrls.SEARCH_P_CUBE = '/searchPCube?cubeReg=';
    BiUrls.SEARCH_P_DIMENSION = '/searchPDim?dimRegex=';
    BiUrls.SEARCH_DIMENSION = '/searchDim?dimRegex=';
    BiUrls.SEARCH_P_MEASURE = '/searchPMeasure?measureRegex=';
    BiUrls.SEARCH_P_UOM = '/searchPUom?uomReg=';
    BiUrls.SEARCH_P_SCOPE = '/searchPScope?scopeReg=';
    BiUrls.SEARCH_P_DATASOURCE = '/searchPDataSource?dataSourceReg=';
    BiUrls.SEARCH_P_DATAENGINE = '/searchPDataEngine?dataEngineReg=';
    BiUrls.SEARCH_P_RECORDFORMAT = '/searchPRecordFormat?recordFormatReg=';
    BiUrls.SEARCH_P_VALUESTREAM = '/searchPValueStream?valueStreamReg=';
    BiUrls.SEARCH_P_TARGET = '/searchPTarget?trgReg=';
    // BulkUpload
    BiUrls.BULKUPLOAD_PAGE_AUTH = '/authorization/bulkUpload';
    BiUrls.BULKUPLOAD_DIM_LVL_PERMISSION = '/empOrgDimRelation/bulkUpload';
    BiUrls.BULKUPLOAD_TARGET = '/bulkUpload';
    // Miscellaneous
    BiUrls.MEASURES_BY_CUBEMEASURES = '/getAllByCubeMeasure';
    BiUrls.DIMENSION_BY_MEASURES = '/getDimensions/';
    BiUrls.GET_ROLES = '/getRoles';
    BiUrls.GET_ROLES_BY_EMP_INFO = '/getUsrRoleRelByEmpInfo';
    BiUrls.ALL_P_EMPLOYEES = '/allPEmployee';
    BiUrls.GET_ENGINE_BY_TYPE = '/type/';
    BiUrls.GET_SECTIONS_BY_PAGE = '/sections';
    BiUrls.TEST_CONNECTION = '/testConnection';
    BiUrls.GET_PAGE_AUTH_BY_USER_AND_PAGE = '/pageAuthFrUsrs?pageId=';
    BiUrls.GET_PAGE_AUTH_BY_ROLE = '/authorizationByRole';
    BiUrls.GET_ALL = '/getAll';
    BiUrls.SAVE_ROLE_AUTH = '/save';
    BiUrls.REMOVE_ROLE_AUTH = '/remove';
    BiUrls.GET_ALL_WIDGET = '/getWidgetsCount';
    BiUrls.SAVE_MULTIPLE_PAGE_AUTH = '/pageAuth/saveMultiple';
    BiUrls.GET_P_MAS_TRGS = 'target/paginatedMasTrgs/';
    BiUrls.GET_TRGS_WITHOUT_HIERARCHY = 'target/withoutHierarchy/';
    BiUrls.REMOVE_MULTIPLE_DIM_LVL_PERMSSIONS = '/removeMultipleEmpOrgDimRel';
    BiUrls.SYNC_DATASOURCE = 'ads/sync/';
    BiUrls.SYNC_ALL_RF_DATASOURCE = 'ads/syncAll/rf/';
    BiUrls.SYNC_RECORD_FORMAT = 'ads/sync/rf/';
    BiUrls.GET_DIM_LVL_VALUE = 'ads/dimension';
    BiUrls.UPLOAD_DRILL_FILE = 'ads/uploadDrillFile';
    BiUrls.REUPLOAD_DRILL_FILE = 'ads/reUploadFile';
    BiUrls.DOWNLOAD_DRILL_FILE = 'ads/downloadFile';
    BiUrls.NEW_ANALYTICAL_MODEL = 'ads/analyticalMod/new';
    BiUrls.NEW_ANALYTICAL_MODEL_PRESTO = 'ads/analyticalMod/';
    BiUrls.MATERIALIZED_PRESTO = 'ads/analyticalMod/newMaterialized/presto';
    BiUrls.STARSCHEMA_PRESTO = 'ads/analyticalMod/newStarSchema/presto';
    BiUrls.SAVE_ANALYTICAL_MODEL = 'ads/analyticalMod/save';
    BiUrls.EDIT_ANALYTICAL_MODEL = 'ads/analyticalMod/edit';
    BiUrls.UPDATE_ANALYTICAL_MODEL = 'ads/analyticalMod/update';
    BiUrls.SYNC_ANALYTICAL_MODEL = 'ads/analyticalMod/sync';
    BiUrls.DELETE_ANALYTICAL_MODEL = 'ads/analyticalMod/delete';
    BiUrls.PREVIEW_ANALYTICAL_MODEL = 'ads/analyticalMod/preview';
    BiUrls.SYNC_CURRENT_TENANT_PAGE_CACHE = '/syncCurrentTenantPageCache';
    BiUrls.FLUSH_CURRENT_TENANT_PAGE_CACHE = '/flushCurrentTenantPageCache';
    BiUrls.SYNC_CURRENT_TENANT_DATA_VS = '/syncCurrentTenantDataVersion';
    BiUrls.SYNC_CURRENT_TENANT_CUBE_META = '/syncCurrentTenantCubeMeta';
    BiUrls.DATA_POINT = 'dataPoint/';
    BiUrls.ODATA = 'OData';
    BiUrls.RF_ODATA = '/getRFDataList';
    BiUrls.GET_AM_ODATA = '/getAMDataList';
    BiUrls.SAVE_AM_ODATA = '/saveAMDataList';
    BiUrls.REBUILD_DASH_SNAPSHOT = 'ads/refreshAllSnapshotDashboards';
    return BiUrls;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/cube.component.ts

var cube_component_CubeComponent = /*@__PURE__*/ (function () {
    function CubeComponent(cubeService, toastr, ngbDataConv, vcr) {
        this.cubeService = cubeService;
        this.toastr = toastr;
        this.ngbDataConv = ngbDataConv;
        this.vcr = vcr;
        this.pageNo = 0;
        this.pageSize = 10;
        this.totalCubes = 0;
        this.sPage = 0;
        this.cubeReg = '';
        this.lastRegex = '';
        this.cubeData = { id: null, name: '', description: '', deleted: 0, dataSourceId: null };
        this.mainPage = true;
        this.cubePage = false;
        this.datePicker = false;
        this.currentPage = 1;
        this.startingPage = 0;
        this.endingPage = 0;
        this.entityOpsFlag = false;
        this.cubeList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.dataSourceList = [];
        this.isEdit = false;
        this.dimensionList = [];
        this.recordList = [];
        this.recordObject = {};
        this.measureList = [];
        this.measIndex = -1;
        this.dimInd = -1;
        this.cubeMeasureDataList = [];
        this.filteredMeasureMap = new Map();
        this.filteredDimensionMap = new Map();
        this.measurePage = false;
        this.dimensionPage = false;
        this.dataVersionType = '';
        this.cubeMeasureData = {
            measureId: 'none', measureData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
        };
        this.cubeDimensionUsageData = {
            dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none', name: null,
            recordFormatField: null, cubeId: null, deleted: 0
        };
        this.cubeDimensionUsageList = [];
        this.referencevariable = 'none';
        this.loader = false;
        this.totalPages = 0;
        this.dataVersionDate = { day: null, month: null, year: null };
        this.toastr.setViewRef(vcr);
    }
    CubeComponent.prototype.ngOnInit = function () {
        if (this.cubeService.isBIAdmin) {
            this.loadCube();
        }
        else {
            this.accessDenied = true;
        }
    };
    CubeComponent.prototype.entityOps = function (event) {
        if (this.selectedCubeId == null) {
            this.selectedCubeId = event.target.id;
        }
        else {
            this.selectedCubeId = null;
        }
    };
    CubeComponent.prototype.closeDropDown = function (event) {
        this.selectedCubeId = null;
    };
    CubeComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.cubeReg != '') {
            this.searchPCube();
        }
        else {
            this.loadCube();
        }
        this.setEndingPage(this.totalCubes);
    };
    CubeComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalCubes / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadCube();
    };
    CubeComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    CubeComponent.prototype.loadCube = function () {
        var _this = this;
        var self = this;
        return new Promise(function (resolve) {
            self.loader = true;
            _this.cubeService.getDataByPage(BiUrls.CUBE, self.pageNo, self.pageSize).then(function (res) {
                self.cubeList = [];
                self.totalCubes = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.cubeList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements : [];
                    self.totalCubes = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.parseDataVersionDates();
                self.setEndingPage(self.totalCubes);
                self.loader = false;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    CubeComponent.prototype.parseDataVersionDates = function () {
        var self = this;
        for (var _i = 0, _a = self.cubeList; _i < _a.length; _i++) {
            var cb = _a[_i];
            cb.dataVersion = new Date(cb.dataVersion);
        }
    };
    // By Lalu
    CubeComponent.prototype.searchPCube = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.mainPage = true;
            self.loader = true;
            self.cubeList = [];
            if (self.cubeReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.cubeReg;
            var resu = self.cubeService.search(BiUrls.CUBE, BiUrls.SEARCH_P_CUBE, self.cubeReg, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedPCube(res);
                self.loader = false;
            }, function (err) {
                console.error(err);
            });
            resolve('completed');
        });
    };
    // By Lalu
    CubeComponent.prototype.loadSearchedPCube = function (res) {
        var self = this;
        self.cubeList = (res != undefined) ? res.data.pageElements : [];
        self.totalCubes = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalCubes);
    };
    CubeComponent.prototype.loadRecordFormat = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.cubeService.onStartUp(BiUrls.RECORDFORMAT).then(function (res) {
                self.recordList = res.data;
                self.loadMeasures();
                self.loadDimensions();
                resolve('completed');
            });
        });
    };
    CubeComponent.prototype.loadDimensions = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.cubeService.onStartUp(BiUrls.DIMENSION).then(function (res) {
                self.dimensionList = res != undefined && res.data != undefined ? res.data : [];
                for (var _i = 0, _a = self.dimensionList; _i < _a.length; _i++) {
                    var d = _a[_i];
                    var _loop_1 = function (cdu) {
                        if (d.id == cdu.dimensionId) {
                            var filtered = d.dimHierarchyData[0]
                                .dimHierarchyLevelData.filter(function (item) { return cdu.dimHierarchyLevelData && (cdu.dimHierarchyLevelData.id == item.id); });
                            for (var _i = 0, filtered_1 = filtered; _i < filtered_1.length; _i++) {
                                var lvl = filtered_1[_i];
                                self.filteredDimensionMap.set(lvl.id, lvl);
                                self.dimInd = d.dimHierarchyData[0]
                                    .dimHierarchyLevelData.indexOf(lvl);
                                d.dimHierarchyData[0]
                                    .dimHierarchyLevelData.splice(self.dimInd, 1);
                            }
                            //d.dimHierarchyData[0].dimHierarchyLevelData = filtered;
                        }
                    };
                    for (var _b = 0, _c = self.cubeDimensionUsageList; _b < _c.length; _b++) {
                        var cdu = _c[_b];
                        _loop_1(cdu);
                    }
                }
                resolve('completed');
            });
        });
    };
    CubeComponent.prototype.loadMeasures = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.cubeService.onStartUp(BiUrls.MEASURE).then(function (res) {
                self.measureList = res != undefined && res.data != undefined ? res.data : [];
                for (var _i = 0, _a = self.cubeMeasureDataList; _i < _a.length; _i++) {
                    var cm = _a[_i];
                    for (var _b = 0, _c = self.measureList; _b < _c.length; _b++) {
                        var m = _c[_b];
                        if (m.id == cm.measureId) {
                            self.filteredMeasureMap.set(m.id, m);
                            self.measIndex = self.measureList.indexOf(m);
                            self.measureList.splice(self.measIndex, 1);
                        }
                    }
                }
                resolve('completed');
            });
        });
    };
    CubeComponent.prototype.addNewCube = function () {
        console.log('On Add Controller ...');
        var self = this;
        self.mainPage = false;
        self.cubePage = true;
        this.cubeData = { id: null, name: '', description: null, dataSourceId: '', deleted: 0 };
    };
    CubeComponent.prototype.onSave = function () {
        console.log('On Save Controller ...');
        var self = this;
        self.processDataVersion('save');
        var validate = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        }
        else {
            self.saveButton = true;
            self.loader = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.cubeService.update(BiUrls.CUBE, self.cubeData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                self.cubeService.save(BiUrls.CUBE, self.cubeData).then(function (res) {
                    console.log(self.pageNo);
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    };
    CubeComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalCubes / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            this.totalPages;
        self.currentPage = self.pageNo + 1;
        var text = type == 'new' ? 'Cube saved successfully' : 'Changes saved successfully';
        if (self.cubeReg != '') {
            self.searchPCube().then(function (res) {
                self.loaderAfterSaveOrUpdate();
            });
        }
        else {
            self.loadCube().then(function (res) {
                self.loaderAfterSaveOrUpdate();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else if (result.status != 500) {
                    self.toastr.showError(result.statusText);
                }
            });
        }
        self.currentPage = self.pageNo + 1;
    };
    CubeComponent.prototype.loaderAfterSaveOrUpdate = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.cubePage = false;
        self.isEdit = false;
        self.cubeMeasureDataList = [];
        self.cubeMeasureData = {
            measureId: 'none', measureData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
        };
        self.cubeDimensionUsageData = {
            dimensionId: 'none', dimensionData: null,
            recordFormatFieldId: 'none', recordFormatField: null, cubeId: null, deleted: 0
        };
        self.referencevariable = 'none';
        self.cubeDimensionUsageList = [];
        self.loader = false;
    };
    CubeComponent.prototype.clickEdit = function (cubeData) {
        var self = this;
        self.loader = true;
        self.selectedCubeId = null;
        self.cubeService.getDataById(BiUrls.CUBE, cubeData.id).then(function (res) {
            console.log(res.data);
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load Cube');
                self.mainPage = true;
            }
            else {
                self.loadRecordFormat();
                self.isEdit = true;
                self.mainPage = false;
                self.cubePage = true;
                self.cubeData = JSON.parse(JSON.stringify(res.data));
                self.processDataVersion('edit');
                console.log(self.cubeData);
                self.cubeMeasureDataList = self.cubeData.cubeMeasureData;
                self.cubeDimensionUsageList = self.cubeData.cubeDimensionUsageData;
                if (self.cubeData.recordFormatId != undefined &&
                    self.cubeData.recordFormatId != null) {
                    self.recordFormatId = self.cubeData.recordFormatId;
                    self.onSelectRecord(self.cubeData.recordFormatId);
                }
                else {
                    self.recordFormatId = 'none';
                }
                delete self.cubeData.schema;
                delete self.cubeData.facts;
                delete self.cubeData.schemaName;
                delete self.cubeData.status;
                delete self.cubeData.factNames;
                delete self.cubeData.dataSourceName;
            }
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
    };
    CubeComponent.prototype.onBack = function () {
        this.referencevariable = 'none';
        this.mainPage = true;
        this.cubePage = false;
        this.selectedCubeId = null;
        this.isEdit = false;
        this.recordObject = {};
        this.cubeMeasureDataList = [];
        this.filteredMeasureMap.clear();
        this.filteredDimensionMap.clear();
        this.cubeDimensionUsageList = [];
        this.cubeMeasureData = {
            measureId: 'none', measureData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
        };
        this.cubeDimensionUsageData = {
            dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none',
            recordFormatField: null, cubeId: null, deleted: 0
        };
    };
    CubeComponent.prototype.delete = function (cube, removeDim, removeMeasure) {
        var self = this;
        self.loader = true;
        self.cubeService.delete(BiUrls.CUBE, cube.id + "/" + removeDim + "/" + removeMeasure).then(function (response) {
            self.toastr.showSuccess(cube.name + ' removed successfully');
            self.pageNo = self.cubeList.length == 1 ? self.totalCubes == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadCube();
            self.loader = false;
        }, function (err) {
            self.toastr.showError('Unable to remove Cube : ' + err.errorCode);
        });
    };
    CubeComponent.prototype.removeCube = function (cube) {
        var r = confirm('Are you sure you want to delete the cube ' + cube.name + '?');
        if (r == true) {
            this.delete(cube, 0, 0);
        }
    };
    CubeComponent.prototype.removeCubeWithDimsAndMeasures = function (cube) {
        var r = confirm('Are you sure you want to delete the cube ' + cube.name + ' along with dimensions and measures associated with it?');
        if (r == true) {
            this.delete(cube, 1, 1);
        }
    };
    CubeComponent.prototype.validater = function () {
        if (this.cubeData.name == undefined || this.cubeData.name.trim() == '') {
            return 'Please enter the name for cube';
        }
        else {
            this.cubeData.name = this.cubeData.name.trim();
            this.cubeData.description = this.cubeData.description != undefined ?
                this.cubeData.description.trim() : null;
            this.cubeData.recordFormatId = this.recordFormatId == 'none' ? null
                : this.recordFormatId;
            this.cubeData.cubeMeasureData = this.cubeMeasureDataList;
            this.cubeData.cubeDimensionUsageData = this.cubeDimensionUsageList;
            return '';
        }
    };
    CubeComponent.prototype.onSelectRecord = function (id) {
        var _this = this;
        var self = this;
        self.recordFormatId = id;
        return new Promise(function (resolve) {
            _this.cubeService.getObjectById(BiUrls.RECORDFORMAT + '/' + self.recordFormatId).then(function (res) {
                self.recordObject = res.data;
                if (self.recordObject.dataSourceData) {
                    self.cubeData['dataSourceData'] = self.recordObject.dataSourceData;
                }
                else {
                    delete self.cubeData['dataSourceData'];
                }
            }, function (err) {
                delete self.cubeData['dataSourceData'];
            });
            resolve('completed');
        });
    };
    CubeComponent.prototype.confirmChangeOfRecordFormat = function (event) {
        var r = this.recordFormatId == 'none' ? true :
            confirm('Are you sure you want to change the Record Format? ' +
                'It will erase all the Mappings of Measure and Dimension.');
        if (r) {
            this.cubeDimensionUsageList = [];
            this.cubeMeasureDataList = [];
            this.recordObject = {};
            delete this.cubeData['dataSourceData'];
            if (event.target.value != 'none') {
                this.toastr.showSuccess(this.recordFormatId == 'none' ? 'Record Format added' :
                    'Record Format changed');
                this.onSelectRecord(event.target.value);
            }
            else {
                this.toastr.showWarning('Record Format removed');
                this.recordFormatId = 'none';
            }
        }
        else {
            event.target.value = this.recordFormatId;
        }
    };
    CubeComponent.prototype.onSelectMeasure = function (event) {
        for (var _i = 0, _a = this.measureList; _i < _a.length; _i++) {
            var measure = _a[_i];
            if (measure.id == Number(event.target.value)) {
                this.cubeMeasureData['measureData'] = measure;
                this.filteredMeasureMap.set(measure.id, measure);
                this.measIndex = this.measureList.indexOf(measure);
            }
        }
    };
    CubeComponent.prototype.onSelectDimenasion = function (event) {
        var ids = event.target.value.split('_');
        for (var _i = 0, _a = this.dimensionList; _i < _a.length; _i++) {
            var dim = _a[_i];
            if (dim.id == Number(ids[0])) {
                for (var _b = 0, _c = dim.dimHierarchyData[0].dimHierarchyLevelData; _b < _c.length; _b++) {
                    var levels = _c[_b];
                    if (levels.id == Number(ids[1])) {
                        this.cubeDimensionUsageData['dimensionData'] = dim;
                        this.cubeDimensionUsageData['dimensionId'] = dim.id;
                        this.cubeDimensionUsageData['dimHierarchyLevelId'] = levels.id;
                        this.cubeDimensionUsageData['dimHierarchyLevelData'] = levels;
                        this.filteredDimensionMap.set(levels.id, levels);
                        this.dimInd = dim.dimHierarchyData[0].dimHierarchyLevelData.indexOf(levels);
                        this.selectedDim = dim;
                        //dim.dimHierarchyData[0].dimHierarchyLevelData.splice(index, 1);
                    }
                }
            }
        }
    };
    CubeComponent.prototype.onSelectField = function (event, param) {
        for (var _i = 0, _a = this.recordList; _i < _a.length; _i++) {
            var record = _a[_i];
            if (record.id == this.recordFormatId && record.recordFormatFieldData != undefined) {
                for (var _b = 0, _c = record.recordFormatFieldData; _b < _c.length; _b++) {
                    var field = _c[_b];
                    if (field.id == Number(event.target.value)) {
                        if (param == 'measure') {
                            this.cubeMeasureData['recordFormatField'] = field;
                        }
                        else {
                            this.cubeDimensionUsageData['recordFormatField'] = field;
                        }
                    }
                }
            }
        }
    };
    CubeComponent.prototype.addFieldForMeasure = function () {
        var validate = this.validaterMeasureRecordFormat();
        if (validate != '') {
            this.toastr.showError(validate);
            console.error(validate);
        }
        else {
            this.measureList.splice(this.measIndex, 1);
            this.cubeMeasureData.cubeId = this.cubeData.id;
            this.cubeMeasureDataList.push(this.cubeMeasureData);
            this.cubeMeasureData = {
                measureId: 'none', measureData: null, recordFormatFieldId: 'none',
                recordFormatField: null, cubeId: null, deleted: 0, measureNodeType: 'ACTUAL'
            };
            this.toastr.showSuccess('Measure linked');
            this.measIndex = -1;
        }
    };
    CubeComponent.prototype.addFieldForDimension = function () {
        var validate = this.validaterDimensionRecordFormat();
        if (validate != '') {
            this.toastr.showError(validate);
            console.error(validate);
        }
        else {
            this.selectedDim.dimHierarchyData[0].dimHierarchyLevelData.splice(this.dimInd, 1);
            this.cubeDimensionUsageData.cubeId = this.cubeData.id;
            this.cubeDimensionUsageList.push(this.cubeDimensionUsageData);
            this.cubeDimensionUsageData = {
                dimensionId: 'none', dimensionData: null, recordFormatFieldId: 'none',
                recordFormatField: null, cubeId: null, deleted: 0
            };
            this.toastr.showSuccess('Dimension linked');
        }
        this.referencevariable = 'none';
    };
    CubeComponent.prototype.removeCubeMeasure = function (event, cubeMeasure) {
        var r = confirm('Are you sure you want to remove this field ' +
            cubeMeasure.measureData.name + ' ?');
        if (r == true) {
            this.toastr.showSuccess('Linking of measure removed successfully');
            this.measureList.push(this.filteredMeasureMap.get(cubeMeasure.measureData.id));
            var index = this.cubeMeasureDataList.indexOf(cubeMeasure);
            this.cubeMeasureDataList.splice(index, 1);
        }
    };
    CubeComponent.prototype.removeCubeDimension = function (event, cubeDimension) {
        var r = confirm('Are you sure you want to remove this field ' +
            cubeDimension.dimHierarchyLevelData.displayName + ' ?');
        if (r == true) {
            this.toastr.showSuccess('Linking of dimension removed successfully');
            console.log(cubeDimension);
            var dimIndex = this.dimensionList.indexOf(cubeDimension.dimensionData);
            for (var _i = 0, _a = this.dimensionList; _i < _a.length; _i++) {
                var d = _a[_i];
                if (d.id == cubeDimension.dimensionId) {
                    d.dimHierarchyData[0].dimHierarchyLevelData.push(this.filteredDimensionMap.get(cubeDimension.dimHierarchyLevelId));
                }
            }
            var index = this.cubeDimensionUsageList.indexOf(cubeDimension);
            this.cubeDimensionUsageList.splice(index, 1);
        }
    };
    CubeComponent.prototype.validaterMeasureRecordFormat = function () {
        if (this.cubeMeasureData.measureId == 'none' ||
            this.cubeMeasureData.recordFormatFieldId == 'none') {
            return 'Please select both measure and record format field to add';
        }
        else {
            return '';
        }
    };
    CubeComponent.prototype.validaterDimensionRecordFormat = function () {
        if (this.cubeDimensionUsageData['dimensionId'] == 'none' ||
            this.cubeDimensionUsageData['recordFormatFieldId'] == 'none') {
            return 'Please select both dimension and record format field to add';
        }
        else {
            return '';
        }
    };
    CubeComponent.prototype.editMeasure = function (cubeMeasure) {
        this.cubePage = false;
        this.measurePage = true;
        this.measureData = cubeMeasure.measureData;
    };
    CubeComponent.prototype.comingBackFromMeasureScreen = function () {
        this.cubePage = true;
        this.measurePage = false;
        this.openMeasureMapping = "measure";
        this.openDimensionMapping = '';
    };
    CubeComponent.prototype.afterSavingMeasure = function (event) {
        var self = this;
        this.cubePage = true;
        this.measurePage = false;
        this.cubeMeasureDataList.forEach(function (measure) {
            if (measure.measureData.id == event.data.id) {
                measure.measureData = event.data;
            }
        });
        this.openMeasureMapping = "measure";
        this.openDimensionMapping = '';
    };
    CubeComponent.prototype.afterSavingDimension = function (event) {
        var self = this;
        this.cubePage = true;
        this.dimensionPage = false;
        this.cubeDimensionUsageList.forEach(function (dim) {
            if (dim.dimensionData.id == event.data.id) {
                dim.dimensionData = event.data;
            }
        });
        this.openDimensionMapping = 'dimension';
        this.openMeasureMapping = '';
    };
    CubeComponent.prototype.comingBackFromDimensionScreen = function () {
        this.openDimensionMapping = 'dimension';
        this.openMeasureMapping = '';
        this.cubePage = true;
        this.dimensionPage = false;
    };
    CubeComponent.prototype.editDimension = function (cubeMeasure) {
        this.cubePage = false;
        this.dimensionPage = true;
        this.dimensionData = cubeMeasure.dimensionData;
    };
    CubeComponent.prototype.clearCacheForCube = function (cube) {
        var self = this;
        self.cubeService.clearCache('ads/clearDataCache/' + cube.id).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess("Cube Cache cleared successfully!");
            }
            else {
                self.toastr.showError("Unable To Clear Cube Cache!");
            }
        });
    };
    CubeComponent.prototype.clearCache = function () {
        var self = this;
        self.cubeService.clearCache('ads/clearDataCache').then(function (res) {
            if (res.success) {
                self.toastr.showSuccess("Cache cleared successfully!");
            }
            else {
                self.toastr.showError("Unable To Clear Cache!");
            }
        });
    };
    CubeComponent.prototype.getTitle = function (type) {
        var self = this;
        if (type == 'measure') {
            return 'Cube Measure Mapping ( ' + self.cubeMeasureDataList.length + ' )';
        }
        else {
            return 'Cube Dimension Mapping ( ' + self.cubeDimensionUsageList.length + ' )';
        }
    };
    CubeComponent.prototype.processDataVersion = function (action) {
        var self = this;
        if (action == 'save') {
            var date = Date.parse(self.ngbDataConv.toModel(self.dataVersionDate));
            self.cubeData.dataVersion = self.dataVersionType == 'Static' ? date : null;
            self.cubeData.dataVersionType = self.dataVersionType;
        }
        else {
            if (self.cubeData.dataVersionType != undefined && self.cubeData.dataVersionType == 'Static') {
                self.dataVersionType = 'Static';
                var dateTime = new Date(self.cubeData.dataVersion);
                var strDate = dateTime.getUTCDate() + '-' +
                    (dateTime.getUTCMonth() + 1) + '-' + dateTime.getUTCFullYear();
                self.dataVersionDate = self.ngbDataConv.fromModel(strDate);
            }
            else {
                self.dataVersionType = 'Dynamic';
            }
        }
    };
    return CubeComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/dataEngine.component.ts

var dataEngine_component_DataEngine = /*@__PURE__*/ (function () {
    function DataEngine(dataEngineService, toastr, vcr) {
        this.dataEngineService = dataEngineService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.engineOptions = [
            'DRILL', 'PRESTO', 'KYLIN', 'DRUID',
            'OLAP', 'IMPALA', 'SPARK', 'Clickhouse'
        ];
        this.dataEngineReg = '';
        this.sPage = 0;
        this.lastRegex = '';
        this.dataEngineData = {
            id: null, name: '', dataEngineCode: null,
            server: '', port: '', username: '', type: '', password: '', deleted: 0
        };
        this.mainPage = true;
        this.dataEnginePage = false;
        this.dataEngineList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.onStart = false;
        this.isEdit = false;
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.currentPage = 1;
        this.selectedEngineType = null;
        this.totalEngines = 0;
        this.totalPages = 0;
        this.loader = false;
        this.clusterList = [];
        this.toastr.setViewRef(vcr);
    }
    DataEngine.prototype.ngOnInit = function () {
        if (this.dataEngineService.isBIAdmin) {
            this.loadEngine();
        }
        else {
            this.accessDenied = true;
        }
    };
    DataEngine.prototype.entityOps = function (event) {
        if (this.selectedEngineId == null) {
            this.selectedEngineId = event.target.id;
        }
        else {
            this.selectedEngineId = null;
        }
    };
    DataEngine.prototype.closeDropDown = function (event) {
        this.selectedEngineId = null;
    };
    // For Pagination
    DataEngine.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.dataEngineReg != '') {
            this.searchPDataEngine();
        }
        else {
            this.loadEngine();
        }
        this.setEndingPage(this.totalEngines);
    };
    DataEngine.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    // For Pagination
    DataEngine.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalEngines / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadEngine();
    };
    DataEngine.prototype.loadEngine = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            _this.dataEngineService.getDataByPage(BiUrls.DATAENGINE, self.pageNo, self.pageSize).then(function (res) {
                self.dataEngineList = [];
                self.totalEngines = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.dataEngineList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalEngines = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.setEndingPage(self.totalEngines);
                self.loader = false;
                resolve('completed');
            }, function (error) {
                console.error(error);
            });
        });
    };
    // By Lalu
    DataEngine.prototype.searchPDataEngine = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.mainPage = true;
            self.dataEngineList = [];
            if (self.dataEngineReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.dataEngineReg;
            self.dataEngineService.search(BiUrls.DATAENGINE, BiUrls.SEARCH_P_DATAENGINE, self.dataEngineReg, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedPDataEngine(res).then(function (res) {
                    self.loader = false;
                }, function (err) {
                    console.error(err);
                });
            });
            resolve('completed');
        });
    };
    // By Lalu
    DataEngine.prototype.loadSearchedPDataEngine = function (res) {
        var self = this;
        return new Promise(function (resolve) {
            if (res != undefined) {
                self.dataEngineList = res.data.pageElements;
                self.totalEngines = res.data.total;
            }
            else {
                self.totalEngines = 0;
            }
            self.setEndingPage(self.totalEngines);
            resolve('resolved');
        });
    };
    DataEngine.prototype.addNewDataEngine = function (type) {
        this.mainPage = false;
        this.dataEnginePage = true;
        this.dataEngineData = {
            id: null, name: '', server: '', port: '',
            username: '', type: type, password: '', deleted: 0
        };
        this.clusterList = type == 'DRILL' ? [{ ip: '', port: '' }] : [];
    };
    DataEngine.prototype.onSave = function () {
        var self = this;
        if (self.dataEngineData.type == 'DRILL') {
            this.setDataForDrill();
        }
        var validate = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        }
        else {
            self.saveButton = true;
            if (self.isEdit) {
                self.dataEngineService.update(BiUrls.DATAENGINE, self.dataEngineData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                self.dataEngineService.save(BiUrls.DATAENGINE, self.dataEngineData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    };
    DataEngine.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalEngines / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        var text = type == 'new' ? 'Data Engine saved successfully' : 'Changes saved successfully';
        if (this.dataEngineReg != '') {
            self.searchPDataEngine().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Unable to save Data Engine');
                }
            });
        }
        else {
            self.loadEngine().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Unable to save Data Engine');
                }
            }, function (error) {
                console.error(error);
            });
        }
        self.currentPage = self.pageNo + 1;
    };
    DataEngine.prototype.setPageFieldsAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.dataEnginePage = false;
        self.isEdit = false;
    };
    DataEngine.prototype.clickEdit = function (engine) {
        var self = this;
        self.loader = true;
        self.dataEngineService.getDataById(BiUrls.DATAENGINE, engine.id).then(function (res) {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Engines');
            }
            else {
                engine = res.data;
                self.selectedEngineType = engine.type;
                self.isEdit = true;
                self.mainPage = false;
                self.dataEnginePage = true;
                self.selectedEngineId = null;
                self.dataEngineData = JSON.parse(JSON.stringify(engine));
                engine.type == 'DRILL' ? self.getDataForDrill() : null;
            }
            self.loader = false;
        }, function (error) {
            console.error(error);
        });
    };
    DataEngine.prototype.onSelectEngineType = function (event) {
        this.selectedEngineType = event.target.value;
    };
    DataEngine.prototype.onBack = function () {
        this.mainPage = true;
        this.dataEnginePage = false;
        this.dataEngineData = {};
        this.selectedEngineId = null;
        this.isEdit = false;
    };
    DataEngine.prototype.delete = function (engine) {
        var self = this;
        self.dataEngineService.delete(BiUrls.DATAENGINE, engine.id).then(function (response) {
            if (response.error == undefined) {
                self.toastr.showSuccess(engine.name + ' removed successfully');
            }
            else {
                self.toastr.showError('Unable to remove Data Engine');
            }
            self.pageNo = self.dataEngineList.length == 1 ?
                self.totalEngines == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadEngine();
        }, function (error) {
            console.error(error);
        });
    };
    DataEngine.prototype.removeEngine = function (engine) {
        var r = confirm('Are you sure you want to remove the Data Engine ' + engine.name + ' ?');
        if (r == true) {
            this.delete(engine);
        }
    };
    DataEngine.prototype.validater = function () {
        if (this.dataEngineData.name == undefined || this.dataEngineData.name.trim() == '') {
            return 'Please enter the name for Data Engine';
        }
        if (this.dataEngineData.server == undefined || this.dataEngineData.server.trim() == '') {
            return 'Please enter the server for Data Engine';
        }
        if (this.dataEngineData.type == 'DRILL' && this.clusterList.length != (this.dataEngineData.server.split(',').length)) {
            return 'Please enter the server IP for Cluster';
        }
        //if (this.dataEngineData.port == undefined || this.dataEngineData.port.trim() == '') {
        if (this.dataEngineData.port == undefined) {
            return 'Please enter the port for Data Engine';
        }
        if (this.dataEngineData.port > 65535) {
            return 'Please enter the port value between 0 to 65535';
        }
        if (!(this.dataEngineData.type == 'SSAS' && this.dataEngineData.customParameter1)) {
            if (this.dataEngineData.username == undefined ||
                this.dataEngineData.username.trim() == '') {
                return 'Please enter the username for Data Engine';
            }
            if (!this.isEdit) {
                if (this.dataEngineData.newPassword == undefined ||
                    this.dataEngineData.newPassword.trim() == '') {
                    return 'Please enter the password for Data Engine';
                }
            }
            this.dataEngineData.username = this.dataEngineData.username.trim();
        }
        this.dataEngineData.name = this.dataEngineData.name.trim();
        this.dataEngineData.server = this.dataEngineData.server.trim();
        this.dataEngineData.port = this.dataEngineData.port.toString();
        //this.dataEngineData.type = this.dataEngineData.type.trim();
        return '';
    };
    DataEngine.prototype.getDataForDrill = function () {
        if (this.dataEngineData.server && this.dataEngineData.server.match(/,/g)) {
            var clusters = this.dataEngineData.server.split(',');
            this.dataEngineData['customParameter2'] = !!this.dataEngineData['customParameter2'] ?
                this.dataEngineData.customParameter2 : clusters[0].split(':')[0];
            this.dataEngineData['customParameter1'] = !!this.dataEngineData['customParameter1'] ?
                this.dataEngineData.customParameter1 : '';
            var clusterList_1 = [];
            if (clusters && clusters.length > 1) {
                clusters.forEach(function (cluster) {
                    var clusterDet;
                    if (cluster && cluster.match(/:/g)) {
                        clusterDet = cluster.split(':');
                        clusterList_1.push({ ip: clusterDet[0], port: clusterDet[1] });
                    }
                    else {
                        clusterList_1.push({ ip: cluster, port: '' });
                    }
                });
            }
            this.clusterList = clusterList_1;
        }
        else if (this.dataEngineData.server && !this.dataEngineData.server.match(/,/)) {
            this.dataEngineData['customParameter2'] = this.dataEngineData.server;
            this.clusterList = [{ ip: this.dataEngineData.server, port: '' }];
        }
    };
    DataEngine.prototype.setDataForDrill = function () {
        var serverList = [];
        this.clusterList.forEach(function (cluster) {
            if (cluster.ip && cluster.ip.trim() != '') {
                var str = cluster.ip;
                str += (cluster.port && cluster.port != '') ? ':' + cluster.port : '';
                serverList.push(str);
            }
        });
        this.dataEngineData.server = serverList.join();
    };
    DataEngine.prototype.enableWinAuthAction = function (event) {
        if (event.target.checked) {
            this.dataEngineData.username = "";
            this.dataEngineData.newPassword = "";
        }
    };
    DataEngine.prototype.addCluster = function () {
        this.clusterList.push({ ip: '', port: '' });
    };
    DataEngine.prototype.removeCluster = function (index) {
        this.clusterList.splice(+index, 1);
    };
    return DataEngine;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/service.ts
var CubeMeasure = /*@__PURE__*/ (function () {
    function CubeMeasure() {
    }
    return CubeMeasure;
}());

var CubeDimension = /*@__PURE__*/ (function () {
    function CubeDimension() {
        this.dimensionData = new service_DimensionData();
        this.recordFormatField = new RecordFormatFieldData();
        this.dimHierarchyLevelData = new DimHierarchyLevelData();
    }
    return CubeDimension;
}());

var service_DimensionData = /*@__PURE__*/ (function () {
    function DimensionData() {
        this.dimHierarchyData = [];
    }
    return DimensionData;
}());

var MeasureData = /*@__PURE__*/ (function () {
    function MeasureData() {
        this.field = new RecordFormatFieldData();
        this.measureStatusIndicator = [];
        this.measureTarget = [];
    }
    return MeasureData;
}());

var DimHierarchyData = /*@__PURE__*/ (function () {
    function DimHierarchyData() {
        this.dimHierarchyLevelData = [];
    }
    return DimHierarchyData;
}());

var DimHierarchyLevelData = /*@__PURE__*/ (function () {
    function DimHierarchyLevelData() {
    }
    return DimHierarchyLevelData;
}());

var RecordFormatData = /*@__PURE__*/ (function () {
    function RecordFormatData() {
        this.recordFormatFieldData = [];
    }
    return RecordFormatData;
}());

var RecordFormatFieldData = /*@__PURE__*/ (function () {
    function RecordFormatFieldData() {
    }
    return RecordFormatFieldData;
}());

var DataSourceStorageType = /*@__PURE__*/ (function () {
    function DataSourceStorageType() {
        this.FILE_S3 = {
            connection: '',
            customParameter: ['Access Key', 'Secret Key', 'Location', 'End Point Url', 'Region'],
            engineType: 'DRILL'
        };
        this.FILE_SFTP = {
            connection: '',
            customParameter: ['Location', 'Host', 'Port'],
            engineType: 'DRILL'
        };
        this.FILE_DFS = {
            connection: '',
            customParameter: ['Location'],
            engineType: 'DRILL'
        };
        this.MONGO = {
            connection: '',
            engineType: 'DRILL'
        };
        // public DRILL_HIVE = {
        //     type: 'HIVE',
        //     connection: '',
        //     customParameter : ['Default file location', 'sasl Enabled'],
        //     engineType: 'DRILL'
        // };
        // public DRILL_HBASE = {
        //     type: 'HBASE',
        //     connection: 'Zookeeper Quorum',
        //     customParameter : ['Default file location', 'sasl Enabled'],
        //     engineType: 'DRILL'
        // };
        // public PRESTO_HIVE = { 
        //     type: 'HIVE',        
        //     engineType: 'PRESTO'
        // };
        this.HIVE = { engineType: 'PRESTO' };
        this.MYSQL = { engineType: 'PRESTO' };
        this.REDIS = { engineType: 'PRESTO' };
        this.REDSHIFT = { engineType: 'PRESTO' };
        this.KAFKA = { engineType: 'PRESTO' };
        this.MONGODB = { engineType: 'PRESTO' };
        this.POSTGRESQL = { engineType: 'PRESTO' };
        this.CASSANDRA = { engineType: 'PRESTO' };
        this.SQLSERVER = { engineType: ['PRESTO', 'SSAS'] };
        this.HBASE = { engineType: 'KYLIN' };
        this.CLICK_HOUSE = { engineType: 'CLICK_HOUSE' };
    }
    return DataSourceStorageType;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/dataSource.component.ts


var dataSource_component_DataSourceComponent = /*@__PURE__*/ (function () {
    function DataSourceComponent(dataSourceService, toastr, vcr) {
        this.dataSourceService = dataSourceService;
        this.toastr = toastr;
        this.vcr = vcr;
        // public storageOptions: string[] = [
        //     'FILE_DFS', 'FILE_S3', 'MONGO',
        //     'HIVE', 'HBASE', 'CLASSPATH', 'MYSQL',
        //     'REDIS', 'ORACLE', 'REDSHIFT'];
        this.dataSourceData = {
            id: null, name: '', catalog: '', schema: '', dataSourceCode: '',
            username: '', newPassword: '', type: '', deleted: 0
        };
        this.mainPage = true;
        this.dataSourceReg = '';
        this.lastRegex = '';
        this.sPage = 0;
        this.dataSourcePage = false;
        this.dataSourceList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.isEdit = false;
        this.noServerName = false;
        this.dataEngineList = [];
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.currentPage = 1;
        this.totalSource = 0;
        this.totalPages = 0;
        this.loader = false;
        this.isConnection = false;
        this.isSSaSS = false;
        this.toastr.setViewRef(vcr);
    }
    DataSourceComponent.prototype.ngOnInit = function () {
        if (this.dataSourceService.isBIAdmin) {
            this.loadDataSource();
        }
        else {
            this.accessDenied = true;
        }
    };
    DataSourceComponent.prototype.entityOps = function (event) {
        if (this.selectedSourceId == null) {
            this.selectedSourceId = event.target.id;
        }
        else {
            this.selectedSourceId = null;
        }
    };
    DataSourceComponent.prototype.closeDropDown = function (event) {
        this.selectedSourceId = null;
    };
    // For Pagination
    DataSourceComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.dataSourceReg != '') {
            this.searchPDataSource();
        }
        else {
            this.loadDataSource();
        }
        this.setEndingPage(this.totalSource);
    };
    DataSourceComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    // For Pagination
    DataSourceComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalSource / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadDataSource();
    };
    DataSourceComponent.prototype.loadDataSource = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            _this.dataSourceService.getDataByPage(BiUrls.DATASOURCE, self.pageNo, self.pageSize).then(function (res) {
                self.dataSourceList = [];
                self.totalPages = 0;
                self.totalSource = 0;
                if (res != undefined) {
                    self.dataSourceList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalSource = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.setEndingPage(self.totalSource);
                self.loader = false;
                // self.loadEngine();
                resolve('completed');
            }, function (error) {
                console.error(error);
            });
        });
    };
    // By Lalu
    DataSourceComponent.prototype.searchPDataSource = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.mainPage = true;
            self.dataSourceList = [];
            if (self.dataSourceReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.dataSourceReg;
            self.dataSourceService.search(BiUrls.DATASOURCE, BiUrls.SEARCH_P_DATASOURCE, self.dataSourceReg, self.pageNo, self.pageSize).then(function (res) {
                self.loadSearchedPDataSource(res);
                self.loader = false;
            }, function (error) {
                console.error(error);
            });
            resolve('completed');
        });
    };
    // By Lalu
    DataSourceComponent.prototype.loadSearchedPDataSource = function (res) {
        var self = this;
        if (res != undefined) {
            self.dataSourceList = res.data.pageElements;
            self.totalSource = res.data.total;
        }
        else {
            self.totalSource = 0;
        }
        self.setEndingPage(self.totalSource);
    };
    DataSourceComponent.prototype.loadEngineByType = function (dataEngine) {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.dataSourceService.onStartUp(BiUrls.DATAENGINE + BiUrls.GET_ENGINE_BY_TYPE + dataEngine).then(function (res) {
                res != undefined && res.data != undefined ? (_a = self.dataEngineList).push.apply(_a, res.data) : null;
                resolve('completed');
                var _a;
            });
        });
    };
    DataSourceComponent.prototype.addNewDataSource = function (dsType) {
        var _this = this;
        var storageType = new DataSourceStorageType();
        this.mainPage = false;
        this.dataSourcePage = true;
        var type = storageType[dsType].engineType;
        this.dataEngineList = [];
        if (typeof type == 'string') {
            this.loadEngineByType(storageType[dsType].engineType);
        }
        else {
            type.forEach(function (t) {
                _this.loadEngineByType(t);
            });
        }
        this.parameters = storageType[dsType].customParameter ? storageType[dsType].customParameter : null;
        this.dataSourceData = {
            id: null, name: '', catalog: '', schema: '',
            username: '', newPassword: '', type: '', deleted: 0,
            connection: null,
            customParameter1: null,
            customParameter2: null,
            customParameter3: null,
            customParameter4: null,
            customParameter5: null,
            location: null,
            storageType: dsType,
            dataEngine: null, dataEngineId: null
        };
        // storageType[dsType].type ? storageType[dsType].type :
        this.isConnection = storageType[dsType].connection != undefined ? true : false;
        this.connectionLabel = (this.isConnection && storageType[dsType].connection != '') ?
            storageType[dsType].connection : 'Connection';
    };
    DataSourceComponent.prototype.onSave = function () {
        var self = this;
        var validate = this.validator();
        if (validate != '') {
            self.toastr.showError(validate);
        }
        else {
            self.saveButton = true;
            self.loader = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.dataSourceService.update(BiUrls.DATASOURCE, self.dataSourceData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                self.dataSourceService.save(BiUrls.DATASOURCE, self.dataSourceData).then(function (res) {
                    var result = res;
                    self.loadAfterSaveOrEdit(result, 'new');
                });
            }
        }
    };
    DataSourceComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalSource / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        var text = type == 'new' ? 'Data Source saved successfully' : 'Changes saved successfully';
        if (self.dataSourceReg != '') {
            self.searchPDataSource().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Unable to save Data Source');
                }
            });
        }
        else {
            self.setPageFieldsAfterLoading();
            self.loadDataSource().then(function (res) {
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Unable to save Data Source');
                }
            }, function (error) {
                console.error(error);
            });
        }
        self.currentPage = self.pageNo + 1;
    };
    DataSourceComponent.prototype.setPageFieldsAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.selectedSourceId = null;
        self.dataSourcePage = false;
        self.isEdit = false;
        self.loader = false;
    };
    DataSourceComponent.prototype.clickEdit = function (dataSource) {
        var _this = this;
        var self = this;
        self.loader = true;
        self.selectedSourceId = null;
        self.dataSourceService.getDataById(BiUrls.DATASOURCE, dataSource.id).then(function (res) {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Data Source');
            }
            else {
                dataSource = res.data;
                _this.isSSaSS = res.data.storageType == 'SQLSERVER' && res.data.dataEngine.type != 'PRESTO';
                self.isEdit = true;
                self.mainPage = false;
                self.dataSourcePage = true;
                self.dataSourceData = JSON.parse(JSON.stringify(dataSource));
            }
            self.setParams();
            self.loader = false;
        }, function (error) {
            console.error(error);
        });
    };
    DataSourceComponent.prototype.setParams = function () {
        if (this.dataSourceData) {
            this.parameters = [];
            this.dataEngineList = [];
            this.dataSourceData.dataEngine.type == 'SSAS' ? this.loadEngineByType('PRESTO') : null;
            this.loadEngineByType(this.dataSourceData.dataEngine.type);
            var DStype = this.dataSourceData.storageType;
            var storageType = new DataSourceStorageType();
            this.isConnection = storageType[DStype].hasOwnProperty('connection') ? true : false;
            if (storageType[DStype]) {
                this.parameters = storageType[DStype].customParameter ? storageType[DStype].customParameter : null;
                this.connectionLabel = (this.isConnection && storageType[DStype].connection != '') ?
                    storageType[DStype].connection : 'Connection';
            }
        }
    };
    // public onSelectStorageType(event) {
    //     let self = this;
    //     self.selectedStorageType = event.target.value;
    //
    // }
    DataSourceComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.dataSourcePage = false;
        this.selectedSourceId = null;
        this.isEdit = false;
    };
    DataSourceComponent.prototype.onTest = function () {
        var self = this;
        var validate = this.validator();
        if (validate != '') {
            self.toastr.showError(validate);
        }
        else {
            self.loader = true;
            self.dataSourceService.testConnection(BiUrls.ANALYTICAL_SERVICE + BiUrls.TEST_CONNECTION, self.dataSourceData).then(function (res) {
                if (res.success && res.message) {
                    self.toastr.showSuccess(res.message);
                }
                else if (res.success) {
                    self.toastr.showSuccess('Data Source Connected successfully');
                }
                else if (res.success == false && res.message != undefined) {
                    self.toastr.showError(res.message);
                }
                else {
                    self.toastr.showError('Failed to Test Data Source Connection');
                }
                self.loader = false;
            });
        }
    };
    DataSourceComponent.prototype.delete = function (dataSource) {
        var self = this;
        self.loader = true;
        self.dataSourceService.delete(BiUrls.DATASOURCE, dataSource.id).then(function (response) {
            if (response.error == undefined) {
                self.toastr.showSuccess(dataSource.name + ' removed successfully');
            }
            else {
                self.toastr.showError('Unable to remove Data Source');
            }
            self.pageNo = self.dataSourceList.length == 1 ?
                self.totalSource == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadDataSource();
        }, function (error) {
            console.error(error);
        });
    };
    DataSourceComponent.prototype.removeDataSource = function (dataSource) {
        var r = confirm('Are you sure you want to remove the data source '
            + dataSource.name + ' ?');
        if (r == true) {
            this.delete(dataSource);
        }
    };
    DataSourceComponent.prototype.validator = function () {
        var _this = this;
        if (this.dataSourceData.name == undefined || this.dataSourceData.name.trim() == '') {
            return 'Please enter the name it cannot be empty';
        }
        if (this.dataSourceData.dataEngineId == undefined ||
            this.dataSourceData.dataEngineId == null) {
            return 'Please enter the dataEngine it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.catalog == undefined || this.dataSourceData.catalog.trim() == '')) {
            return 'Please enter the catalog it cannot be empty';
        }
        if (this.dataSourceData.schema == undefined || this.dataSourceData.schema.trim() == '') {
            return 'Please enter the schema it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.location == undefined || this.dataSourceData.location.trim() == '')) {
            return 'Please enter the location it cannot be empty';
        }
        if (!this.isSSaSS && (this.dataSourceData.username == undefined ||
            this.dataSourceData.username.trim() == '')) {
            return 'Please enter the username it cannot be empty';
        }
        if (!this.isSSaSS && this.dataSourceData.id == undefined &&
            (this.dataSourceData.newPassword == undefined ||
                this.dataSourceData.newPassword.trim() == '')) {
            return 'Please enter the password it cannot be empty';
        }
        if (this.parameters && this.parameters.length != 0) {
            var msg_1 = '';
            this.parameters.forEach(function (param, i) {
                if (msg_1 == '') {
                    var dsData = _this.dataSourceData['customParameter' + (i + 1)];
                    if (dsData == undefined || dsData == null || dsData.trim() == '') {
                        msg_1 = 'Please enter the ' + param + ' Parameter it cannot be empty';
                    }
                    else {
                        msg_1 = '';
                    }
                }
                else
                    return;
            });
            return msg_1;
        }
        this.dataSourceData.catalog = this.dataSourceData.catalog != undefined ?
            this.dataSourceData.catalog.trim() : null;
        this.dataSourceData.schema = this.dataSourceData.schema.trim();
        this.dataSourceData.type = this.dataSourceData.type != undefined ?
            this.dataSourceData.type.trim() : null;
        this.dataSourceData.username = this.dataSourceData.username.trim();
        return '';
    };
    DataSourceComponent.prototype.syncDataSource = function (dataSource) {
        var self = this;
        if (dataSource.dataEngine != null && (dataSource.dataEngine.type == 'PRESTO' || dataSource.dataEngine.type == 'SSAS')) {
            var r = confirm('Are you sure you want to sync all record formats for ' + dataSource.name + ' ?');
            if (r) {
                self.dataSourceService.syncAllRecordFormatsInDataSource(dataSource.id).then(function (res) {
                    var msg = res.success == true ? self.toastr.showSuccess('Record formats are synced successfully') :
                        self.toastr.showError('Unable to sync record formats of "' + dataSource.name + '"');
                });
            }
        }
        else {
            var r = confirm('Are you sure you want to sync ' + dataSource.name + ' ?');
            if (r) {
                self.dataSourceService.syncDataSource(dataSource.id).then(function (res) {
                    var msg = res.success == true ? self.toastr.showSuccess('Sync was successful') :
                        self.toastr.showError('Unable to Sync');
                });
            }
        }
    };
    DataSourceComponent.prototype.confirmChangeOfEngine = function (event) {
        if (event.target.value != 'none') {
            if (this.dataSourceData.storageType && this.dataSourceData.storageType == 'SQLSERVER') {
                var ind = this.dataEngineList.findIndex(function (x) { return x.id == +event.target.value; });
                this.isSSaSS = this.dataEngineList[ind].type != 'PRESTO';
                if (this.isSSaSS) {
                    this.dataSourceData.catalog = '';
                    this.dataSourceData.location = '';
                }
            }
            this.dataSourceData.dataEngineId = +event.target.value;
        }
        else {
            this.dataSourceData.dataEngineId = null;
        }
    };
    return DataSourceComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/dimension.component.ts

var dimension_component_DimensionComponent = /*@__PURE__*/ (function () {
    function DimensionComponent(dimesionService, toaster, vcr) {
        this.dimesionService = dimesionService;
        this.toaster = toaster;
        this.vcr = vcr;
        this.dimRegex = '';
        this.searchButton = false;
        this.mainPage = true;
        this.dimensionPage = false;
        this.dimensionList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.dataSourceList = [];
        this.isEdit = false;
        this.dimHierarchyLevelData = [];
        this.isDimTime = false;
        this.recordFormatList = [];
        this.loader = false;
        this.levelError = '';
        this.dimensionData = {
            id: null, name: '', description: null, dimTime: null, deleted: 0, dimHierarchyData: []
        };
        this.dimHierarchyDataObject = { id: null, name: '', dimHierarchLevelData: [] };
        this.dimHierarchyLevelDataObject = {
            id: null, displayName: '', levelNumber: null, levelType: 'selectOne'
        };
        this.pageNo = 0;
        this.currentPage = 1;
        this.startingPage = 0;
        this.pageSize = 10;
        this.endingPage = 0;
        this.totalDimensions = 0;
        this.totalPages = 0;
        this.lastRegex = '';
        this.sPage = 0;
        this.toaster.setViewRef(vcr);
    }
    DimensionComponent.prototype.ngOnInit = function () {
        if (this.dimesionService.isBIAdmin) {
            this.loadDimensions();
        }
        else {
            this.accessDenied = true;
        }
    };
    DimensionComponent.prototype.entityOps = function (event) {
        if (this.selectedDimId == null) {
            this.selectedDimId = event.target.id;
        }
        else {
            this.selectedDimId = null;
        }
    };
    DimensionComponent.prototype.closeDropDown = function (event) {
        this.selectedDimId = null;
    };
    DimensionComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.dimRegex != '') {
            this.searchPDim();
        }
        else {
            this.loadDimensions();
        }
        this.setEndingPage(this.totalDimensions);
    };
    DimensionComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            self.startingPage = 0;
            if (total > self.pageSize) {
                self.endingPage = self.pageSize;
            }
            else {
                self.endingPage = total;
            }
        }
        else {
            self.startingPage = 0 + ((self.currentPage - 1) * +self.pageSize);
            self.endingPage = +self.pageSize + ((self.currentPage - 1) * +self.pageSize);
            if (self.endingPage > total) {
                self.endingPage = total;
            }
        }
    };
    DimensionComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalDimensions / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadDimensions();
    };
    DimensionComponent.prototype.loadDimensions = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            _this.dimesionService.getDataByPage(BiUrls.DIMENSION, self.pageNo, self.pageSize).then(function (res) {
                self.dimensionList = [];
                self.totalDimensions = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.dimensionList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toaster.showError('No results found');
                    self.totalDimensions = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.setEndingPage(self.totalDimensions);
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    //ByLalu
    DimensionComponent.prototype.searchPDim = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.mainPage = true;
            self.loader = true;
            self.dimensionList = [];
            if (self.dimRegex != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.dimRegex;
            self.dimesionService.search(BiUrls.DIMENSION, BiUrls.SEARCH_P_DIMENSION, self.dimRegex, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedPDimension(res);
                self.loader = false;
            }, function (err) {
                console.error(err);
            });
            resolve('completed');
        });
    };
    //ByLalu
    DimensionComponent.prototype.loadSearchedPDimension = function (res) {
        var self = this;
        self.dimensionList = (res != undefined) ? res.data.pageElements : [];
        self.totalDimensions = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalDimensions);
    };
    DimensionComponent.prototype.loadRecordFormat = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.dimesionService.onStartUp(BiUrls.RECORDFORMAT).then(function (res) {
                self.recordFormatList = res != undefined && res.data != undefined ? res.data : [];
            }, function (err) {
                console.error(err);
            });
            resolve('completed');
        });
    };
    DimensionComponent.prototype.addNewDimension = function () {
        this.mainPage = false;
        this.dimensionPage = true;
        this.dimensionData = {
            id: null, name: '', description: '', dimTime: false, deleted: 0,
            dimHierarchyData: []
        };
        this.dimHierarchyDataObject = { id: null, name: '', dimHierarchyLevelData: [], deleted: 0 };
        this.isDimTime = null;
    };
    DimensionComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.toaster.setViewRef(this.vcr);
        self.totalPages = Math.floor(self.totalDimensions / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        var text = type == 'new' ? 'Dimension added successfully' : 'Changes saved successfully';
        if (self.dimRegex != '') {
            self.searchPDim().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toaster.showSuccess(text);
                }
                else {
                    self.toaster.showError(result.statusText);
                }
            });
        }
        else {
            self.loadDimensions().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toaster.showSuccess(text);
                }
                else {
                    self.toaster.showError(result.statusText);
                }
            });
        }
        self.currentPage = self.pageNo + 1;
    };
    DimensionComponent.prototype.setPageFieldsAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.dimensionPage = false;
        self.isEdit = false;
        self.selectedRFF = null;
        self.dimHierarchyLevelData = [];
    };
    DimensionComponent.prototype.editDimension = function (dimension) {
        var self = this;
        self.dimensionData = dimension;
        self.selectedDimId = null;
        self.isEdit = true;
        self.mainPage = false;
        self.dimensionPage = true;
    };
    DimensionComponent.prototype.removeDimension = function (dimension) {
        var r = confirm('Are you sure you want to remove the dimension ' + dimension.name + ' ?');
        if (r == true) {
            this.delete(dimension);
        }
    };
    DimensionComponent.prototype.delete = function (dimension) {
        var self = this;
        self.loader = true;
        self.dimesionService.delete(BiUrls.DIMENSION, dimension.id).then(function (response) {
            if (response == undefined || response.data == undefined) {
                self.toaster.showError('Unable to remove Dimenison');
            }
            else {
                self.pageNo = self.dimensionList.length == 1 ?
                    self.totalDimensions == 1 ? 0 : --self.pageNo : self.pageNo;
                self.loadDimensions();
                self.loader = false;
                self.toaster.showSuccess(dimension.name + ' removed successfully');
            }
        }, function (error) {
            console.error(error);
        });
    };
    DimensionComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.dimensionPage = false;
        this.selectedDimId = null;
        this.isEdit = false;
        this.dimHierarchyLevelData = [];
        this.dimensionData = {};
        this.dimHierarchyDataObject = {};
        this.selectedRFF = null;
    };
    return DimensionComponent;
}());



// EXTERNAL MODULE: ./node_modules/file-saver/FileSaver.js
var FileSaver = __webpack_require__("lDdF");
var FileSaver_default = /*#__PURE__*/__webpack_require__.n(FileSaver);

// CONCATENATED MODULE: ./src/app/bi/admin/controller/dimLvlPermissions.component.ts



var dimLvlPermissions_component_dimLvlPermComponent = /*@__PURE__*/ (function () {
    function dimLvlPermComponent(dimLvlPermService, _sanitizer, toastr, vcr) {
        var _this = this;
        this.dimLvlPermService = dimLvlPermService;
        this._sanitizer = _sanitizer;
        this.toastr = toastr;
        this.vcr = vcr;
        this.mainPage = true;
        this.searchButton = false;
        this.accessDenied = false;
        this.saveButton = false;
        this.isEdit = false;
        this.loader = false;
        this.uploadSucess = false;
        this.add = false;
        this.uploadedDataList = [];
        this.removedDataList = [];
        this.nonExistentDimensions = [];
        this.nonExistentDimLevels = [];
        this.nonExistentUsers = [];
        this.nonExistentScopes = [];
        this.nonExistentAccess = [];
        this.file = null;
        this.totalEODR = 0;
        this.totalPages = 0;
        this.totalEmps = 0;
        this.totalLevels = 0;
        this.totalDimLevel = 0;
        this.page = 0;
        this.size = 10;
        this.currentPage = 1;
        this.startingPage = 0;
        this.endingPage = 0;
        this.pageSize = 10;
        this.dimList = [];
        this.employeeList = [];
        this.employeePageData = [];
        this.empIdList = [];
        this.employeeOrg = [];
        this.values = "";
        this.dimLevels = [];
        this.selectedDimension = "selectOne";
        this.filteredDimensionMap = new Map();
        this.deleteArray = [];
        this.filteredList = [];
        this.employeeOrgRelations = [];
        this.empOrgList = [];
        this.dimPermList = [];
        this.referencevariable = 'none';
        this.dimLvlValList = [];
        this.scopeList = [];
        this.dimensionMap = new Map();
        this.dimensionData = {
            id: null, name: '', description: '', dimTime: null, deleted: 0, dimHierarchyData: []
        };
        this.progress = 0;
        this.isProgress = false;
        this.count = 0;
        this.scopeMap = new Map();
        this.empOrgData = {
            employeeId: null,
            orgDimension: null,
            orgDimensionValue: "",
            scope: null,
            orgDimensionLevel: null,
            orgDimensionLevelName: "",
        };
        this.tabs = ['Individual', 'Bulk'];
        this.selectedTab = this.tabs[0];
        this.searchData = {
            "nameOrCodeOrEmail": "",
            "employeeCodes": [],
            "excludedEmployeeCodes": [],
            "includeEmpIds": [],
            "excludeEmpIds": [],
            "gradeIds": [],
            "mgrLevelIds": [],
            "designationIds": [],
            "categoryIds": [],
            "includeOrgIds": [],
            "excludeOrgIds": [],
            "supervisorIds": [],
            "primarySupervisorIds": [],
            "primarySupervisorNameOrCode": null,
            "primarySupervisorCods": [],
            "employeeStatus": null,
            "employeesWithOutSupervisor": null,
            "scorecardStates": null,
            "memberShipState": null,
            "programId": null,
            "pageSize": 10,
            "page": 1,
            "fetchSupervisorLevels": 0
        };
        // public dimensionHierachyData: any = {
        //     id: null,
        //     dimName: "",
        //     dimLevelName: "",
        //     dimValues: "",
        //     scope: "",
        //     dimId: "",
        // };
        // public scopeArray: any = [
        //     { value: 1, name: 'Team' },
        //     { value: 2, name: 'Individual' },
        //     { value: 3, name: 'All' },
        //     { value: 4, name: 'Custom 4' },
        //     { value: 5, name: 'Custom 5' },
        //     { value: 6, name: 'Custom 6' },
        //     { value: 7, name: 'Custom 7' },
        //     { value: 8, name: 'Custom 8' },
        //     { value: 9, name: 'Custom 9' },
        //     { value: 10, name: 'Custom 10' }
        // ];
        this.authPageNo = 0;
        this.authPageSize = 10;
        this.authStartingPage = 0;
        this.authEndingPage = 10;
        this.authCurrentPage = 1;
        this.authTotalRecs = 0;
        this.tableData = [];
        this.comment = '';
        this.fileNameToUpload = null;
        this.getDimLvlVal = function (keyword) {
            var self = _this;
            var request = { trendNeeded: false };
            request.dimensionYAxis = [{ "dimension": { "id": self.selectedDimension.dimId ? self.selectedDimension.dimId : self.selectedDimension.id }, "level": { "id": self.selectedDimLevel } }];
            if (self.selectedDimension == 'selectOne') {
                self.toastr.showError("Select Dimension to add values!");
                return;
            }
            if (keyword) {
                request.keyword = keyword;
                request.limit = 50;
                return _esm5["d" /* Observable */].create(function (observer) {
                    self.dimLvlPermService.dimensionData(request).then(function (res) {
                        if (res.response) {
                            observer.next(res.response.data);
                        }
                        else {
                            observer.next([]);
                        }
                        observer.complete();
                    }, function (err) {
                        observer.next([]);
                        observer.complete();
                    });
                });
            }
            else {
                return _esm5["d" /* Observable */].of([]);
            }
            // if (keyword != '') {
            //     self.filteredList = self.dimLvlValList.filter((dlv) => dlv.name.toLowerCase().includes(keyword.toLowerCase()));
            // } else {
            //     self.filteredList = [];
            // }
            // return Observable.of(self.filteredList);
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            //let html = `<span> ${data.dimName} -- ${data.dimCode}</span>`;
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.dimListFormatter = function (data) {
            var name = data.name ? data.name : data.dimHierarchyLevelName ? data.dimHierarchyLevelName : data.dimName;
            // let code = data.metadata ? data.metadata.d_l_id : data.dimHierarchyLevelId ? data.dimHierarchyLevelId : data.dimCode;
            var html = "<span>" + name + " -- " + data.dimCode + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.dimValueFormatter = function (data) {
            var name = data.name ? data.name : data.dimHierarchyLevelName ? data.dimHierarchyLevelName : data.dimName;
            var html = "" + name;
            return html;
        };
        this.searchDim = function (keyword) {
            var self = _this;
            if (keyword) {
                return self.dimLvlPermService.search1(BiUrls.BI_DIMENSION, BiUrls.SEARCH_DIMENSION, keyword);
            }
            else {
                return _esm5["d" /* Observable */].create(function (observer) {
                    observer.next([]);
                    observer.complete();
                });
            }
        };
        this.toastr.setViewRef(vcr);
    }
    dimLvlPermComponent.prototype.ngOnInit = function () {
        if (this.dimLvlPermService.isBIAdmin) {
            this.mainPage = true;
            this.loadScopes();
            this.loadDimensions();
            this.loadEmployees();
        }
        else {
            this.accessDenied = true;
        }
    };
    dimLvlPermComponent.prototype.loadScopes = function () {
        var _this = this;
        var self = this;
        self.dimLvlPermService.onStartUp(BiUrls.SCOPE).then(function (res) {
            if (res != undefined) {
                self.scopeList = res.data;
                _this.loadScopesIntoMap();
            }
        });
    };
    dimLvlPermComponent.prototype.loadScopesIntoMap = function () {
        var _this = this;
        this.scopeList.forEach(function (scope) {
            _this.scopeMap.set(scope.id, scope.name);
        });
    };
    // scopeData(num) {
    //     for (let scopes of this.scopeArray) {
    //         if (scopes.value == num) {
    //             return scopes.name;
    //         }
    //     }
    //     return '';
    // }
    dimLvlPermComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.isEdit = false;
    };
    dimLvlPermComponent.prototype.bulkUpload = function (event) {
        var self = this;
        if (self.validateFile(self.file)) {
            var formdata1 = new FormData();
            self.loader = true;
            formdata1.append("file", self.file);
            self.dimLvlPermService.bulkUpload(BiUrls.PAGE, BiUrls.BULKUPLOAD_DIM_LVL_PERMISSION, formdata1).then(function (res) {
                if (res) {
                    if (!(res instanceof Object)) {
                        res = JSON.parse(res);
                    }
                    if (res.success) {
                        self.token = res.data;
                        if (self.token) {
                            self.isProgress = true;
                            setTimeout(function () {
                                self.checkProgress();
                            }, self.timeInterval * 1000);
                        }
                    }
                    else {
                        self.toastr.showError(res.errorMessage);
                    }
                    self.loadScopes();
                    // self.loadDimensions();
                    self.loadEmployees();
                }
                self.loader = false;
            }, function (error) {
                console.log(error);
            });
        }
        else {
            self.toastr.showError('Please Attach An Excel File');
        }
    };
    dimLvlPermComponent.prototype.validateFile = function (file) {
        var ext;
        if (file != null) {
            ext = file.name.split('.', 2);
        }
        else {
            ext = undefined;
        }
        if (ext == undefined || !(ext[1].toLowerCase() == 'xls' || ext[1].toLowerCase() == 'xlsx')) {
            return false;
        }
        else {
            return true;
        }
    };
    dimLvlPermComponent.prototype.checkProgress = function () {
        var self = this;
        if (self.count == 10) {
            self.count = 0;
            self.progress = 0;
            self.isProgress = false;
            self.toastr.showError("Bulk Upload Failed");
            return;
        }
        this.dimLvlPermService.getProgress(self.token, 'trackProgress/bi_bulk_dimLvlPerm_/').then(function (res) {
            if (res && res.success) {
                if (Math.round(+res.data) == self.progress) {
                    self.count += 1;
                }
                self.progress = Math.round(+res.data);
                if (self.progress < 100) {
                    setTimeout(function () {
                        self.checkProgress();
                    }, self.timeInterval * 1000);
                }
                else if (self.progress == 100) {
                    self.isProgress = false;
                    self.dimLvlPermService.getProgress(self.token, 'statusReport/bi_bulk_dimLvlPerm_/').then(function (res) {
                        self.progress = 0;
                        self.uploadSucess = true;
                        self.file = null;
                        self.fileInput.nativeElement.value = null;
                        self.toastr.showSuccess("Bulk Upload Successful");
                        self.loadUploadReport(res);
                    });
                }
            }
        });
    };
    dimLvlPermComponent.prototype.loadUploadReport = function (result) {
        var self = this;
        var statusMap = this.jsonToMap(result);
        this.nonExistentUsers = statusMap.get("NON_EXISTENT_EMPLOYEES");
        this.nonExistentDimensions = statusMap.get("NON_EXISTENT_DIMENSIONS");
        this.nonExistentDimLevels = statusMap.get("NON_EXISTENT_DIM_LEVELS");
        this.nonExistentScopes = statusMap.get("NON_EXISTENT_SCOPES");
        this.nonExistentAccess = statusMap.get("NON_EXISTENT_ACCESS");
        this.uploadedDataList = statusMap.get("UPLOADED_DATA");
        this.removedDataList = statusMap.get("REMOVED_DATA");
    };
    dimLvlPermComponent.prototype.jsonToMap = function (result) {
        var res = result;
        var jsonObj = JSON.parse(JSON.stringify(res.data));
        var map = new Map();
        for (var _i = 0, _a = Object.keys(jsonObj); _i < _a.length; _i++) {
            var k = _a[_i];
            map.set(k, jsonObj[k]);
        }
        return map;
    };
    dimLvlPermComponent.prototype.onScopeSelect = function (event) {
        this.scope = event.target.value;
    };
    dimLvlPermComponent.prototype.fileChange = function (event) {
        var size = +event.target.files[0].size / (1024 * 1024);
        if (size < 1) {
            this.timeInterval = 1; // less then 1 MB
        }
        else if (size < 5) {
            this.timeInterval = 2; // less then 5 MB
        }
        else if (size < 10) {
            this.timeInterval = 3; // less then 10 MB
        }
        else if (size > 10) {
            this.timeInterval = 5; // greater then 10 MB
        }
        this.file = event.target.files[0];
    };
    dimLvlPermComponent.prototype.loadDimensions = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.dimLvlPermService.onStartUp(BiUrls.DIMENSION).then(function (res) {
                self.dimList = [];
                self.totalPages = 0;
                if (res != undefined) {
                    self.dimList = res.data != undefined &&
                        res.data != undefined ? res.data :
                        self.toastr.showError('No results found');
                }
                if (self.dimList && self.dimList.length > 0) {
                    self.dimList.forEach(function (dim) {
                        self.dimensionMap.set(dim.id, dim);
                    });
                }
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    dimLvlPermComponent.prototype.loadEmpOrgDim = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.dimLvlPermService.onStartUp(BiUrls.DIM_LVL_PERMISSION + '/' + self.employeeId).then(function (res) {
                self.empOrgList = res != undefined && res.data != undefined ? res.data : [];
                self.setEmpOrgList();
                self.saveButton = false;
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    dimLvlPermComponent.prototype.setEmpOrgList = function () {
        var self = this;
        self.dimPermList = [];
        var _loop_1 = function (eodr) {
            var dimPermData = { id: '', dimName: '', dimLvlName: '', dimLvlVal: '', scope: '' };
            var dimLvlVal = eodr.orgDimensionValue;
            var dim = self.dimList.filter(function (d) { return d.id == eodr.orgDimension; });
            //let dimLvlId = self.getDimDataParts(dimLvlVal, 'dimLvlId');
            if (!dim[0]) {
                return "continue";
            }
            var dimLvl = dim[0].dimHierarchyData[0].dimHierarchyLevelData.filter(function (dl) { return dl.id == Number(eodr.orgDimensionLevel); });
            if (dimLvl[0] != undefined) {
                dimPermData.dimName = dim[0].displayName;
                dimPermData.dimLvlName = dimLvl[0].displayName;
                dimPermData.dimLvlVal = self.getDimDataParts(dimLvlVal, 'dimLvlVal');
                var scope = self.scopeList.filter(function (scp) { return scp.id == eodr.scope; });
                dimPermData.scope = scope[0] ? scope[0].name : '';
                dimPermData.id = eodr.id;
                self.dimPermList.push(dimPermData);
            }
        };
        for (var _i = 0, _a = self.empOrgList; _i < _a.length; _i++) {
            var eodr = _a[_i];
            _loop_1(eodr);
        }
    };
    dimLvlPermComponent.prototype.getDimDataParts = function (dimStr, type) {
        var self = this;
        var dimParts = dimStr.split('].[');
        if (type == 'dim') {
            return dimParts[0].substr(1);
        }
        else if (type == 'dimLvlVal') {
            return dimParts[2].slice(0, -1);
        }
        else {
            return dimParts[1];
        }
    };
    dimLvlPermComponent.prototype.loadEmployees = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            var url = BiUrls.PAGE + BiUrls.ALL_P_EMPLOYEES;
            self.employeeId = null;
            self.dimPermList = [];
            self.dimLvlPermService.getDataByPage(url, self.page, self.pageSize).then(function (res) {
                self.employeeList = [];
                self.empIdList = [];
                if (res == undefined) {
                    self.toastr.showError('Cannot load the Employee Data');
                }
                else {
                    self.employeeList = res.data.pageElements != undefined ?
                        res.data.pageElements.length == 0 ?
                            self.toastr.showWarning('No Employees to load') :
                            res.data.pageElements :
                        self.toastr.showError('No Employees found');
                    self.totalEmps = res.data.total;
                    self.setEndingPage(self.totalEmps);
                    for (var _i = 0, _a = self.employeeList; _i < _a.length; _i++) {
                        var emp = _a[_i];
                        self.empIdList.push(emp.id);
                    }
                }
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    dimLvlPermComponent.prototype.onDimensionSelection = function (event) {
        var value = event.dimId ? event.dimId : event.id;
        var self = this;
        self.dim = value;
        self.selectedDimLevel = event.dimHierarchyLevelId;
        // this.dimLevels = [];
        // this.dimLvlValList = [];
        // if (this.levelName != null) {
        //     this.levelName = "";
        // }
        this.selectedDimension = event;
        // if (this.selectedDimension != "selectOne") {
        //     self.dimLevels = self.dimensionMap.get(+value).dimHierarchyData[0].dimHierarchyLevelData
        //     self.selectedDimensionName = event.name;
        //     self.dimLevels = _.sortBy(self.dimLevels, function (s) {
        //         return self.getDecodedValue(s.displayName).charCodeAt();
        //     });
        // }
        // this.onDimensionLevelSelect(event.dimHierarchyLevelId);
        this.dimAutoComplete.nativeElement.value = '';
    };
    dimLvlPermComponent.prototype.onDimensionLevelSelect = function (event) {
        console.log("inside dimension level select");
        var self = this;
        // let value = event.target.value;
        var value = event;
        this.elementDiv.nativeElement.value = null;
        self.filteredList = [];
        self.dimLvlValList = [];
        self.selectedDimLevel = value;
        if (self.selectedDimLevel != 'selectOne') {
            self.dimLevels.filter(function (item) {
                if (item.id == value) {
                    self.selectedDimensionLevelName = item.displayName;
                }
            });
            var dimValObj = {
                "trendNeeded": false,
                "dimensionYAxis": [
                    { "dimension": { "id": self.dim }, "level": { "id": self.selectedDimLevel } }
                ]
            };
            self.dimLvlPermService.getDimLevelValues(dimValObj).then(function (res) {
                self.dimLvlValList = (res.response != undefined && res.response.data != undefined) ? res.response.data : [];
            });
        }
        else {
            self.toastr.showError('Please Select Dimension Level');
        }
    };
    dimLvlPermComponent.prototype.orgNameValueFormatter = function (data) {
        return "" + data.name;
    };
    dimLvlPermComponent.prototype.onSelectDimLvlVal = function (event) {
        var self = this;
        self.selecteDimensionValue = event;
        self.dimValue = event.key;
        self.elementDiv.nativeElement.value = '';
    };
    dimLvlPermComponent.prototype.getDecodedValue = function (encodedText) {
        if (!encodedText)
            return "";
        var x;
        x = document.createElement("TEXTAREA");
        x.innerHTML = encodedText;
        return x.value;
    };
    dimLvlPermComponent.prototype.loaderControl = function (event) {
        this.loader = event;
    };
    dimLvlPermComponent.prototype.employeesFound = function (event) {
        this.employeeList = event;
    };
    dimLvlPermComponent.prototype.pageDataControl = function (event) {
        this.employeePageData = event;
        this.totalEmps = event.totalElements;
        this.setEndingPage(this.totalEmps);
    };
    dimLvlPermComponent.prototype.onSelectEmployee = function (event) {
        this.employeeId = event.target.id;
        this.loadEmpOrgDim();
    };
    dimLvlPermComponent.prototype.onPageChange = function (event) {
        console.log('On Page Change Controller ...');
        this.currentPage = event;
        this.page = this.currentPage - 1;
        this.searchData.page = event;
        this.getEmployee();
        this.setEndingPage(this.totalEmps);
    };
    dimLvlPermComponent.prototype.OnPageSizeChanged = function (event) {
        console.log('On Page-Size Change Controller ...');
        this.pageSize = event.target.value;
        this.searchData.pageSize = this.pageSize;
        this.getEmployee();
        this.setEndingPage(this.totalEmps);
    };
    dimLvlPermComponent.prototype.onClickOfAdd = function () {
        var self = this;
        var validate = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        }
        else {
            if (this.isDuplicateDimensionFilter()) {
                this.toastr.showError("Dimension Filter Already Exists");
                return;
            }
            self.saveButton = true;
            self.loader = true;
            self.empOrgData.employeeId = self.employeeId;
            self.empOrgData.orgDimension = self.selectedDimension.dimId ? self.selectedDimension.dimId : self.selectedDimension.id;
            self.empOrgData.scope = self.scope;
            self.empOrgData.orgDimensionLevel = Number(self.selectedDimLevel);
            self.empOrgData.orgDimensionValue = self.dimValue;
            self.dimLvlPermService.save(BiUrls.DIM_LVL_PERMISSION, self.empOrgData).then(function (success) {
                if ((success.errorMessage != null || success.errorMessage != undefined)) {
                    console.log(success.errorMessage);
                    self.mainPage = false;
                    self.accessDenied = true;
                    self.add = false;
                    return;
                }
                if (success.message) {
                    console.log(success.message);
                    self.toastr.showError(success.message);
                    self.resetDimLvlValues();
                    self.saveButton = false;
                    self.loader = false;
                    return;
                }
                self.toastr.showSuccess('Dimension Filter Added successfully');
                self.loadEmpOrgDim();
                self.employeeOrgRelations = success;
                self.resetDimLvlValues();
                self.loader = false;
            }, function (error) {
                self.toastr.showError('Failed to add Dimension Filter');
                console.log(error);
            });
        }
    };
    dimLvlPermComponent.prototype.resetDimLvlValues = function () {
        var self = this;
        // self.employeeId = null;
        self.selectedDimension = "selectOne";
        self.selectedDimLevel = undefined;
        self.dimValue = undefined;
        self.filteredList = [];
        self.dimLevels = [];
        self.scope = null;
        self.elementDiv.nativeElement.value = null;
        self.selecteDimensionValue = null;
    };
    dimLvlPermComponent.prototype.validater = function () {
        //if (this.employeeOrgRelations.length == 0 || this.selectedEmployee == null || this.selectedEmployee == "selectOne") {
        if (this.employeeId == undefined) {
            return 'Please select the Employee for further actions';
        }
        //if (this.dimArray == null || this.dimArray == undefined || this.selectedDimension == "selectOne") {
        if (this.selectedDimension == "selectOne") {
            return 'Please select dimension to add the permission';
        }
        if (this.selectedDimLevel == undefined) {
            return 'Please select dimension level to add the permission';
        }
        if (this.dimValue == undefined || this.dimValue.trim() == '') {
            return 'Please select dimension level value to add the permission';
        }
        if (this.scope == undefined) {
            return 'Please select scope to add the permission';
        }
        return '';
    };
    dimLvlPermComponent.prototype.isDuplicateDimensionFilter = function () {
        var self = this;
        var isDuplicate = false;
        for (var _i = 0, _a = self.dimPermList; _i < _a.length; _i++) {
            var dimPerm = _a[_i];
            if (dimPerm.dimName == self.selectedDimension.dimDisplayName &&
                dimPerm.dimLvlName == self.selectedDimension.dimHierarchyLevelName &&
                dimPerm.dimLvlVal == self.selecteDimensionValue.name &&
                dimPerm.scope == self.scopeMap.get(Number(self.scope))) {
                isDuplicate = true;
                break;
            }
        }
        return isDuplicate;
    };
    // setOrgData() {
    //     let orgData = this.empOrgData;
    //     orgData.employeeId = this.selectedEmployee;
    //     orgData.orgDimensionValue = this.values;
    //     //orgData.orgDimension = this.dimArray.id;
    //     orgData.scope = this.scope;
    //     orgData.orgDimensionLevel = this.dimensionLevelId;
    //     orgData.orgDimensionLevelName = this.levelName;
    //     return orgData;
    // }
    dimLvlPermComponent.prototype.validationBeforeSaving = function (orgData, levelName, values) {
        var msg = "Please Select all the fields to add the permission";
        if (orgData.employeeId == null) {
            return msg;
        }
        if (orgData.orgDimension == "") {
            return msg;
        }
        if (levelName == undefined || levelName == "" || levelName == "selectOne") {
            return msg;
        }
        if (values == "selectOne" || values == "") {
            return msg;
        }
        if (orgData.scope == undefined || orgData.scope == 0 || orgData.scope == "selectOne") {
            return msg;
        }
        return "";
    };
    // getEmployeeOrgRelation(event) {
    //     let self = this;
    //     self.employeeOrg = [];
    //     if (typeof event != 'object') {
    //         self.selectedEmployee = event;
    //     } else {
    //         self.selectedEmployee = event.target.value;
    //     }
    //     if (self.selectedEmployee == "selectOne") {
    //         return;
    //     }
    //     if (self.selectedEmployee != "selectOne") {
    //         self.dimLvlPermService.getDataById(BiUrls.DIM_LVL_PERMISSION, this.selectedEmployee).then((res) => {
    //             for (let employee of self.employeeOrgRelations) {
    //                 if (employee.orgDimensionValue != undefined || employee.orgDimensionValue != null) {
    //                     let dimLevels = employee.orgDimensionValue.split('].[')
    //                     let dimensionHierachyData = self.empOrgData
    //                     dimensionHierachyData.id = employee.id;
    //                     dimensionHierachyData.scope = self.scopeData(employee.scope);
    //                     dimensionHierachyData.dimName = dimLevels[0].slice(1);
    //                     dimensionHierachyData.dimLevelName = employee.orgDimensionLevelName;
    //                     dimensionHierachyData.dimValues = dimLevels[dimLevels.length - 1].slice(0, dimLevels[dimLevels.length - 1].length - 1);
    //                     self.employeeOrg.push(dimensionHierachyData);
    //                 }
    //             }
    //         },
    //             function (error) {
    //                 console.log(error);
    //             }
    //         );
    //     }
    // }
    dimLvlPermComponent.prototype.onSelectToDelete = function (event) {
        if (event.target.checked == true) {
            this.deleteArray.push(Number(event.target.id));
        }
        else if (event.target.checked == false) {
            var index = this.deleteArray.indexOf(Number(event.target.id));
            this.deleteArray.splice(index, 1);
        }
        return this.deleteArray;
    };
    dimLvlPermComponent.prototype.deleteConfirm = function (event) {
        if (this.deleteArray.length == 0) {
            return;
        }
        var decision = confirm('Do you want remove this permission?');
        if (decision == true) {
            this.onDelete(event);
        }
    };
    dimLvlPermComponent.prototype.onDelete = function (event) {
        var self = this;
        self.loader = true;
        var url = BiUrls.DIM_LVL_PERMISSION + BiUrls.REMOVE_MULTIPLE_DIM_LVL_PERMSSIONS;
        self.dimLvlPermService.deleteEmpOrgDimRel(url, self.deleteArray).then(function (response) {
            self.toastr.showSuccess('Dimension level permissions removed successfully');
            self.deleteArray = [];
            self.loadEmpOrgDim();
            self.loader = false;
        }, function (err) {
            self.toastr.showError('Unable to remove dimension level permissions : ' + err.errorCode);
        });
    };
    dimLvlPermComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    dimLvlPermComponent.prototype.showSearchFilter = function (event) {
        this.searchData = event;
        this.searchData.page = 1;
        this.getEmployee();
    };
    dimLvlPermComponent.prototype.getEmployee = function () {
        try {
            var self_1 = this;
            self_1.loader = true;
            self_1.dimLvlPermService.getEmployee(this.searchData).then(function (result) {
                self_1.empIdList = [];
                self_1.employeeList = result.content;
                self_1.employeePageData = result;
                self_1.totalEmps = result.totalElements;
                self_1.setEndingPage(self_1.totalEmps);
                self_1.loader = false;
            });
        }
        catch (e) {
            console.log("getAllEmployeeData error catch", e);
        }
    };
    dimLvlPermComponent.prototype.removeDimSelected = function () {
        this.selectedDimension = 'selectOne';
        this.selecteDimensionValue = null;
    };
    dimLvlPermComponent.prototype.removeDimValue = function () {
        this.selecteDimensionValue = null;
    };
    dimLvlPermComponent.prototype.beforeChange = function (event) {
        if (event.nextId == 'individual') {
            this.selectedTab = event.nextId;
        }
        else if (event.nextId == 'bulk') {
            this.selectedTab = event.nextId;
            this.getUserDimRelsHistory();
        }
    };
    dimLvlPermComponent.prototype.chooseFile = function (event) {
        if (event.target.files && event.target.files.length > 0) {
            var self_2 = this;
            this.file = event.target.files[0];
            self_2.fileNameToUpload = event.target.files[0].name;
            event.srcElement.value = null;
        }
    };
    dimLvlPermComponent.prototype.validateBulkOpInput = function () {
        var self = this;
        var ext = self.file.name.split('.', 2);
        var isValid = true;
        if (ext[1].toLowerCase() != 'xlsx') {
            this.toastr.showError("Please Attach An Excel File");
            isValid = false;
        }
        if (self.comment.trim() === '') {
            this.toastr.showError("Comment is mandatory");
            isValid = false;
        }
        return isValid;
    };
    dimLvlPermComponent.prototype.initBulkUserDimRels = function (event) {
        var self = this;
        var formdata = new FormData();
        if (self.validateBulkOpInput()) {
            self.loader = true;
            formdata.append('file', self.file);
            formdata.append('comment', self.comment);
            self.dimLvlPermService.bulkUpload('auth/', 'processBulkUserDimRel', formdata).then(function (res) {
                if (res) {
                    if (res.status == 409) {
                        self.toastr.showError(JSON.parse(res.error).message);
                    }
                    else {
                        if (!(res instanceof Object)) {
                            res = JSON.parse(res);
                        }
                        if (res.success) {
                            self.uploadSucess = true;
                            self.file = null;
                            self.fileInput.nativeElement.value = null;
                            self.token = res.data;
                            self.isProgress = true;
                        }
                        else {
                            self.toastr.showError(res.errorMessage);
                        }
                    }
                    self.getUserDimRelsHistory();
                }
                self.loader = false;
                self.resetBulkOperationParams();
            }, function (err) {
                console.error(err);
                self.resetBulkOperationParams();
                self.loader = false;
            });
        }
    };
    dimLvlPermComponent.prototype.resetBulkOperationParams = function () {
        this.comment = '';
        this.fileNameToUpload = null;
    };
    dimLvlPermComponent.prototype.downloadFiles = function (url) {
        var _this = this;
        try {
            this.dimLvlPermService.mdmService.getBlob(url).subscribe(function (result) {
                var name = _this.getFileNameFromHeader(result.headers);
                FileSaver["saveAs"](result.body, name);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    dimLvlPermComponent.prototype.downloadTemplate = function () {
        var url = this.dimLvlPermService.base_url + 'biAdmin/auth/downloadTemplate/USER_DIMENSION_FILTER_TEMPLATE';
        this.downloadFiles(url);
    };
    dimLvlPermComponent.prototype.downloadUserDimRelsFiles = function (filePath) {
        var url = this.dimLvlPermService.base_url + 'biAdmin/auth/downloadFile/' + filePath;
        this.downloadFiles(url);
    };
    dimLvlPermComponent.prototype.getFileNameFromHeader = function (headers) {
        var header = headers.get('Content-Disposition');
        if (header == null) {
            return 'User_Dimension_Filter_Template.xlxs';
        }
        else {
            if (!header) {
                return null;
            }
            var result = header.split(';')[1].trim().split('=')[1];
            return result.replace(/'/g, '');
        }
    };
    dimLvlPermComponent.prototype.getUserDimRelsHistory = function () {
        var _this = this;
        var self = this;
        try {
            var url = self.dimLvlPermService.base_url +
                'biAdmin/auth/getAllUploadStatus/?processType=BI_USER_DIM_FILTER_UPLOAD&' +
                'page=' + self.authCurrentPage + '&pageSize=' + self.authPageSize;
            self.dimLvlPermService.mdmService.get(url).subscribe(function (response) {
                _this.handleUserDimRelsHistoryResponse(response);
            });
        }
        catch (e) {
            console.log('Error: getUserDimRelsHistory', e);
        }
    };
    dimLvlPermComponent.prototype.handleUserDimRelsHistoryResponse = function (response) {
        if (response && response.content) {
            this.authTotalRecs = response.totalElements;
            this.tableData = response.content;
            this.setPaginationParams();
        }
    };
    dimLvlPermComponent.prototype.setPaginationParams = function () {
        var self = this;
        if (self.authCurrentPage == 1) {
            self.authStartingPage = 0;
            if (self.authTotalRecs > self.authPageSize) {
                self.authEndingPage = self.authPageSize;
            }
            else {
                self.authEndingPage = self.authTotalRecs;
            }
        }
        else {
            self.authStartingPage = 0 + ((self.authCurrentPage - 1) * +self.authPageSize);
            self.authEndingPage = +self.authPageSize + ((self.authCurrentPage - 1) * +self.authPageSize);
            if (self.authEndingPage > self.authTotalRecs) {
                self.authEndingPage = self.authTotalRecs;
            }
        }
    };
    dimLvlPermComponent.prototype.onAuthHistoryPageSizeChanged = function (event) {
        this.authPageSize = event.target.value;
        this.getUserDimRelsHistory();
    };
    dimLvlPermComponent.prototype.onAuthHistoryPageChange = function (event) {
        if (typeof event == 'number' && !isNaN(event)) {
            this.authCurrentPage = event;
            this.getUserDimRelsHistory();
        }
    };
    return dimLvlPermComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/measure.component.ts

var measure_component_MeasureComponent = /*@__PURE__*/ (function () {
    function MeasureComponent(measureService, toastr, vcr, ngbDateConv, ngbTimeConv) {
        this.measureService = measureService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.ngbDateConv = ngbDateConv;
        this.ngbTimeConv = ngbTimeConv;
        this.measureReg = '';
        this.searchButton = false;
        this.mainPage = true;
        this.measurePage = false;
        this.measureList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.isEdit = false;
        this.datePicker = false;
        this.trgType = '';
        this.measureData = {
            name: null, measureCode: null, targetType: null, description: null, aggregator: null,
            uomId: null, formulaExpression: null, staticValue: null, formatString: null,
            dataVersion: null, dataVersionTime: null, startDataVersion: null, startDataVersionTime: null
        };
        this.indicators = [];
        this.measureTargets = [];
        this.trgMeasures = [];
        this.staticMts = [];
        this.dynamicMts = [];
        this.coreMts = [];
        this.corTrgList = [];
        this.target = false;
        this.measureTargetData = {
            id: null, measureId: null, name: '',
            corTargetId: null, deleted: 0, corTargetData: null
        };
        this.uomList = [];
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.endingPage = 0;
        this.currentPage = 1;
        this.totalMeasures = 0;
        this.totalPages = 0;
        this.loader = false;
        this.lastRegex = '';
        this.sPage = 0;
        this.toastr.setViewRef(vcr);
    }
    MeasureComponent.prototype.ngOnInit = function () {
        if (this.measureService.isBIAdmin) {
            this.loadMeasure();
        }
        else {
            this.accessDenied = true;
        }
    };
    MeasureComponent.prototype.entityOps = function (event) {
        if (this.selectedMeasureId == null) {
            this.selectedMeasureId = event.target.id;
        }
        else {
            this.selectedMeasureId = null;
        }
    };
    MeasureComponent.prototype.closeDropDown = function () {
        this.selectedMeasureId = null;
    };
    MeasureComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.measureReg != '') {
            this.searchPMeasure();
        }
        else {
            this.loadMeasure();
        }
        this.setEndingPage(this.totalMeasures);
    };
    MeasureComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    // For Pagination
    MeasureComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalMeasures / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadMeasure();
    };
    MeasureComponent.prototype.loadMeasure = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            _this.measureService.getDataByPage(BiUrls.MEASURE, self.pageNo, self.pageSize).then(function (res) {
                self.measureList = [];
                self.totalMeasures = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.measureList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalMeasures = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                // self.loadUom();
                self.setEndingPage(self.totalMeasures);
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    MeasureComponent.prototype.loadTargets = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.measureService.onStartUp(BiUrls.TARGET).then(function (res) {
                self.corTrgList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    };
    // ByLalu
    MeasureComponent.prototype.searchPMeasure = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.mainPage = true;
            self.loader = true;
            self.measureList = [];
            if (self.measureReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.measureReg;
            var resu = self.measureService.search(BiUrls.MEASURE, BiUrls.SEARCH_P_MEASURE, self.measureReg, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedPMeasure(res);
                self.loader = false;
            });
            resolve('completed');
        });
    };
    // ByLalu
    MeasureComponent.prototype.loadSearchedPMeasure = function (res) {
        var self = this;
        self.measureList = (res != undefined) ? res.data.pageElements : [];
        self.totalMeasures = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalMeasures);
    };
    // public loadUom() {
    //     return new Promise((resolve) => {
    //         let self = this;
    //         this.measureService.onStartUp(BiUrls.UOM).then((res) => {
    //             self.uomList = res != undefined && res.data != undefined ? res.data : [];
    //         });
    //         resolve('completed');
    //     });
    // }
    MeasureComponent.prototype.editMeasure = function (measure) {
        var self = this;
        self.isEdit = true;
        self.mainPage = false;
        self.measurePage = true;
        self.measureData = measure;
        // self.loader = true;
    };
    // public loadTrgMeasures(mearureId) {
    //     let self = this;
    //     let url = BiUrls.MEASURE + BiUrls.MEASURES_BY_CUBEMEASURES;
    //     self.measureService.getDataById(url, mearureId).then((res) => {
    //         if (res == undefined || (res.error != undefined && res.status != true)) {
    //             self.toastr.showError('Unable to fetch measures for target');
    //         } else {
    //             let list = res.data.sort((obj1, obj2) => {
    //                 let str1 = obj1['measureDisplayName'].toLowerCase();
    //                 let str2 = obj2['measureDisplayName'].toLowerCase();
    //                 if (str1 < str2) {
    //                     return -1;
    //                 } else if (str1 > str2) {
    //                     return 1;
    //                 } else {
    //                     return 0;
    //                 }
    //             });
    //             self.trgMeasures = list;
    //         }
    //     });
    // }
    MeasureComponent.prototype.hasTarget = function (event) {
        if (event.target.checked == true) {
            this.target = true;
        }
        else if (event.target.checked == false) {
            this.target = false;
        }
    };
    // public save(measureData) {
    //     console.log("------------")
    //     console.log(measureData);
    //     this.measureData = measureData;
    //     let self = this;
    // //    else {
    //         self.saveButton = true;
    //         if (self.isEdit) {
    //             console.log('ON EDIT');
    //             self.measureService.update(BiUrls.MEASURE, self.measureData).then(res => {
    //                 let result = res;
    //                 self.loadAfterSaveOrEdit(result, 'edit');
    //             });
    //         } else {
    //             console.log('ON SAVE');
    //             self.measureService.save(BiUrls.MEASURE, self.measureData).then(res => {
    //                 let result = res;
    //                 self.loadAfterSaveOrEdit(result, 'new');
    //             });
    //         }
    //     // }
    // }
    MeasureComponent.prototype.loadAfterSaveOrEdit = function (result) {
        var self = this;
        self.toastr.setViewRef(self.vcr);
        self.totalPages = Math.floor(self.totalMeasures / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        var text = result.type == 'new' ? 'Measure saved successfully' : 'Changes saved successfully';
        if (self.measureReg != '') {
            self.searchPMeasure().then(function (res) {
                self.setPageFieldSAfterLoading();
                if (result.error == undefined && result.success == true) {
                    console.log(text);
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError(result.statusText);
                }
            });
        }
        else {
            self.loadMeasure().then(function (res) {
                self.setPageFieldSAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError(result.statusText);
                }
            }, function (err) {
                console.error(err);
            });
        }
        self.currentPage = self.pageNo + 1;
    };
    MeasureComponent.prototype.setPageFieldSAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.measurePage = false;
        self.isEdit = false;
        self.selectedMeasureId = null;
        self.indicators = [];
        self.target = false;
    };
    MeasureComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.measurePage = false;
        this.measureData = {};
        this.target = false;
        this.indicators = [];
        this.isEdit = false;
        this.selectedMeasureId = null;
    };
    MeasureComponent.prototype.addNewMeasure = function () {
        this.mainPage = false;
        this.measurePage = true;
        this.measureData = {
            id: null, name: '', description: '', targetType: 'max',
            aggregator: 'sum', measureDisplayName: '', deleted: 0
        };
    };
    MeasureComponent.prototype.removeMeasure = function (measure) {
        var r = confirm('Are you sure you want to remove the measure ' + measure.name + ' ?');
        if (r == true) {
            this.delete(measure);
        }
    };
    MeasureComponent.prototype.delete = function (measure) {
        var self = this;
        self.loader = true;
        self.measureService.delete(BiUrls.MEASURE, measure.id).then(function (response) {
            self.pageNo = self.measureList.length == 1 ?
                self.totalMeasures == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadMeasure();
            if (response.success) {
                self.toastr.showSuccess(measure.name + ' removed successfully');
            }
            else {
                self.toastr.showError('Unable to remove measure');
            }
        });
    };
    return MeasureComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/pageAuthorization.component.ts


var pageAuthorization_component_pageAuthorizationComponent = /*@__PURE__*/ (function () {
    function pageAuthorizationComponent(pageAuthorizationService, toastr, vcr) {
        this.pageAuthorizationService = pageAuthorizationService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.paData = { id: null, userId: null, pageSectionId: null, deleted: 0 };
        this.pageInfo = { id: null, name: null, pageCode: null };
        this.empData = { id: null, empCode: null };
        this.mainPage = true;
        this.paPage = false;
        this.uploadSucess = false;
        this.pageList = [];
        this.pageSectionList = [];
        this.pageAuthList = [];
        this.modifiedPAList = [];
        this.empList = [];
        this.empIdList = [];
        this.paMap = new Map();
        this.paModifiedMap = new Map();
        this.paCntMap = new Map();
        this.uploadedDataList = [];
        this.removedDataList = [];
        //public nonExistentPages: any = [];
        this.nonExistentAccess = [];
        this.nonExistentPageSections = [];
        this.nonExistentUsers = [];
        this.saveChangesButton = false;
        this.selectedAll = [];
        this.accessDenied = false;
        this.onStart = false;
        this.file = null;
        this.selectedPaged = 1;
        this.progress = 0;
        this.pageNo = 1;
        this.pageSize = 10;
        this.startingPage = 0;
        this.endingPage = 10;
        this.currentPage = 1;
        this.totalEmps = 0;
        this.totalPA = 0;
        this.totalPages = 0;
        this.loader = false;
        this.employeePageData = [];
        this.isProgress = false;
        this.count = 0;
        this.tabs = ['Individual', 'Bulk'];
        this.selectedTab = this.tabs[0];
        //public isSearchUsed: boolean;
        this.searchData = {
            "nameOrCodeOrEmail": "",
            "employeeCodes": [],
            "excludedEmployeeCodes": [],
            "includeEmpIds": [],
            "excludeEmpIds": [],
            "gradeIds": [],
            "mgrLevelIds": [],
            "designationIds": [],
            "categoryIds": [],
            "includeOrgIds": [],
            "excludeOrgIds": [],
            "supervisorIds": [],
            "primarySupervisorIds": [],
            "primarySupervisorNameOrCode": null,
            "primarySupervisorCods": [],
            "employeeStatus": null,
            "employeesWithOutSupervisor": null,
            "scorecardStates": null,
            "memberShipState": null,
            "programId": null,
            "pageSize": 10,
            "page": 1,
            "fetchSupervisorLevels": 0
        };
        this.authPageNo = 0;
        this.authPageSize = 10;
        this.authStartingPage = 0;
        this.authEndingPage = 10;
        this.authCurrentPage = 1;
        this.authTotalRecs = 0;
        this.tableData = [];
        this.comment = '';
        this.fileNameToUpload = null;
        this.toastr.setViewRef(this.vcr);
    }
    pageAuthorizationComponent.prototype.ngOnInit = function () {
        if (this.pageAuthorizationService.isBIAdmin) {
            this.loadData();
        }
        else {
            this.accessDenied = true;
        }
    };
    pageAuthorizationComponent.prototype.onPageChange = function (event) {
        console.log('On Page Change Controller ...');
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        this.isSearchUsed() ? this.getEmployee() : this.loadData();
    };
    // public employeesFound(event) {
    //     this.empList = event;
    // }
    pageAuthorizationComponent.prototype.isSearchUsed = function () {
        var flag = false;
        if (this.searchData.nameOrCodeOrEmail != "") {
            flag = true;
        }
        else if (this.searchData.employeeCodes != []) {
            flag = true;
        }
        else if (this.searchData.excludedEmployeeCodes != []) {
            flag = true;
        }
        else if (this.searchData.includeEmpIds != []) {
            flag = true;
        }
        else if (this.searchData.excludeEmpIds != []) {
            flag = true;
        }
        else if (this.searchData.gradeIds != []) {
            flag = true;
        }
        else if (this.searchData.mgrLevelIds != []) {
            flag = true;
        }
        else if (this.searchData.designationIds != []) {
            flag = true;
        }
        else if (this.searchData.categoryIds != []) {
            flag = true;
        }
        else if (this.searchData.includeOrgIds != []) {
            flag = true;
        }
        else if (this.searchData.excludeOrgIds != []) {
            flag = true;
        }
        else if (this.searchData.supervisorIds != []) {
            flag = true;
        }
        else if (this.searchData.primarySupervisorIds != []) {
            flag = true;
        }
        else if (this.searchData.primarySupervisorCods != []) {
            flag = true;
        }
        else if (this.searchData.primarySupervisorNameOrCode != null) {
            flag = true;
        }
        else if (this.searchData.employeeStatus != null) {
            flag = true;
        }
        else if (this.searchData.employeesWithOutSupervisor != null) {
            flag = true;
        }
        else if (this.searchData.scorecardStates != null) {
            flag = true;
        }
        else if (this.searchData.memberShipState != null) {
            flag = true;
        }
        else if (this.searchData.programId != null) {
            flag = true;
        }
        else if (this.searchData.fetchSupervisorLevels != 0) {
            flag = true;
        }
        return flag;
    };
    pageAuthorizationComponent.prototype.OnPageSizeChanged = function (event) {
        var _this = this;
        console.log('On Page-Size Change Controller ...');
        this.pageSize = event.target.value;
        this.setMaxPage().then(function (res) {
            _this.isSearchUsed() ? _this.getEmployee() : _this.loadData();
        });
        //this.loadData();
    };
    pageAuthorizationComponent.prototype.setMaxPage = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var maxPage = Math.floor(_this.totalEmps / _this.pageSize);
            if (maxPage < _this.pageNo) {
                _this.pageNo = maxPage;
            }
            resolve('Completed');
        });
    };
    pageAuthorizationComponent.prototype.loadData = function () {
        var self = this;
        self.loadPages().then(function (res) {
            if (self.selectedPaged != undefined) {
                self.getEmployee().then(function () {
                    self.loadPageSections().then(function () {
                        self.loadPageAuthorizations();
                    });
                });
            }
            else {
                self.pageSectionList = [];
            }
        }, function (err) {
            console.error(err);
        });
    };
    pageAuthorizationComponent.prototype.bulkUpload = function (event) {
        // console.log(event);
        var self = this;
        var formdata1 = new FormData();
        if (self.validateFile(self.file)) {
            self.loader = true;
            formdata1.append('file', self.file);
            self.pageAuthorizationService.bulkUpload(BiUrls.PAGE, BiUrls.BULKUPLOAD_PAGE_AUTH, formdata1).then(function (res) {
                if (res) {
                    if (!(res instanceof Object)) {
                        res = JSON.parse(res);
                    }
                    if (res.success) {
                        self.uploadSucess = true;
                        self.file = null;
                        self.fileInput.nativeElement.value = null;
                        self.token = res.data;
                        if (self.token) {
                            self.isProgress = true;
                            setTimeout(function () {
                                self.checkProgress();
                            }, self.timeInterval * 1000);
                        }
                    }
                    else {
                        self.toastr.showError(res.errorMessage);
                    }
                    self.loadData();
                }
                self.loader = false;
            }, function (err) {
                console.error(err);
            });
        }
        else {
            self.toastr.showError('Please Attach An Excel File');
        }
    };
    pageAuthorizationComponent.prototype.validateFile = function (file) {
        var ext;
        if (file != null) {
            ext = file.name.split('.', 2);
        }
        else {
            ext = undefined;
        }
        if (ext == undefined || !(ext[1].toLowerCase() == 'xls' || ext[1].toLowerCase() == 'xlsx')) {
            return false;
        }
        else {
            return true;
        }
    };
    pageAuthorizationComponent.prototype.checkProgress = function () {
        var self = this;
        if (self.count == 10) {
            self.count = 0;
            self.progress = 0;
            self.isProgress = false;
            self.toastr.showError("Bulk Upload Failed");
            return;
        }
        this.pageAuthorizationService.getProgress(self.token, 'trackProgress/bi_bulk_pa_/').then(function (res) {
            // if(res && res.success){
            if (Math.round(+res.data) == self.progress) {
                self.count += 1;
            }
            self.progress = Math.round(+res.data);
            if (self.progress < 100) {
                setTimeout(function () {
                    self.checkProgress();
                }, self.timeInterval * 1000);
            }
            else if (self.progress == 100) {
                self.isProgress = false;
                self.pageAuthorizationService.getProgress(self.token, 'statusReport/bi_bulk_pa_/').then(function (res) {
                    self.progress = 0;
                    self.toastr.showSuccess("Bulk Upload Successful");
                    self.loadUploadReport(res);
                });
            }
            // }
        });
    };
    pageAuthorizationComponent.prototype.loadUploadReport = function (result) {
        var self = this;
        var statusMap = this.jsonToMap(result);
        this.nonExistentUsers = statusMap.get('NON_EXISTENT_USERS');
        //this.nonExistentPages = statusMap.get('NON_EXISTENT_PAGES');
        this.nonExistentAccess = statusMap.get('NON_EXISTENT_ACCESS');
        this.nonExistentPageSections = statusMap.get('NON_EXISTENT_PAGE_SECTIONS');
        this.uploadedDataList = statusMap.get('UPLOADED_PA_DATA');
        this.removedDataList = statusMap.get('REMOVED_PA_DATA');
    };
    pageAuthorizationComponent.prototype.jsonToMap = function (res) {
        var jsonObj = JSON.parse(JSON.stringify(res.data));
        var map = new Map();
        for (var _i = 0, _a = Object.keys(jsonObj); _i < _a.length; _i++) {
            var k = _a[_i];
            map.set(k, jsonObj[k]);
        }
        return map;
    };
    pageAuthorizationComponent.prototype.fileChange = function (event) {
        var size = +event.target.files[0].size / (1024 * 1024);
        if (size < 1) {
            this.timeInterval = 1; // less then 1 MB
        }
        else if (size < 5) {
            this.timeInterval = 2; // less then 5 MB
        }
        else if (size < 10) {
            this.timeInterval = 3; // less then 10 MB
        }
        else if (size > 10) {
            this.timeInterval = 5; // greater then 10 MB
        }
        // console.log(event);
        this.file = event.target.files[0];
    };
    pageAuthorizationComponent.prototype.onSelectPage = function (event) {
        var _this = this;
        this.loader = true;
        this.pageList.filter(function (item) {
            if (event.target.value == item.id) {
                _this.selectedPaged = item.id;
                _this.loadPageSections().then(function (res) {
                    _this.mainPage = true;
                    _this.loadPageAuthorizations();
                    _this.loader = false;
                    console.log('Selected Page : ' + item.id);
                }, function (err) {
                    console.error(err);
                });
            }
        });
    };
    pageAuthorizationComponent.prototype.loadPages = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.pageAuthorizationService.onStartUp('../' + BiUrls.BIADMIN + '/' + BiUrls.ALL_DASHBOARDS)
                .then(function (res) {
                //this.pageAuthorizationService.onStartUp(BiUrls.PAGE).then((res) => {
                //this.pageAuthorizationService.onStartUp(BiUrls.DASHBOARD_PAGES).then((res) => {
                if (res != undefined) {
                    self.pageList = res.data != null ? res.data : [];
                    if (self.pageList.length > 0) {
                        self.selectedPaged = self.pageList[0] != undefined ?
                            self.pageList[0].id : null;
                    }
                }
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    pageAuthorizationComponent.prototype.loadEmployees = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            var url = BiUrls.PAGE + BiUrls.ALL_P_EMPLOYEES;
            self.pageAuthorizationService.getDataByPage(url, self.pageNo, self.pageSize).then(function (res) {
                self.empList = [];
                self.empIdList = [];
                if (res == undefined) {
                    self.toastr.showError('Cannot load the Employee Data');
                }
                else {
                    self.empList = res.data.pageElements != undefined ?
                        res.data.pageElements.length == 0 ?
                            self.toastr.showWarning('No Employees to load') :
                            res.data.pageElements :
                        self.toastr.showError('No Employees found');
                    self.totalEmps = res.data.total;
                    self.setEndingPage(self.totalEmps);
                    self.setEmpIdList(self.empList);
                }
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    pageAuthorizationComponent.prototype.setEmpIdList = function (empList) {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            for (var _i = 0, empList_1 = empList; _i < empList_1.length; _i++) {
                var emp = empList_1[_i];
                self.empIdList.push(emp.id);
            }
            resolve('Completed');
        });
    };
    pageAuthorizationComponent.prototype.loadPageSections = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.pageSectionList = [];
            var url = BiUrls.PAGE + BiUrls.GET_SECTIONS_BY_PAGE;
            _this.pageAuthorizationService.getDataById(url, self.selectedPaged).then(function (res) {
                if (res != undefined) {
                    self.pageSectionList = res.data != null ? res.data : [];
                }
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    pageAuthorizationComponent.prototype.loadPageAuthorizations = function () {
        var self = this;
        self.loader = true;
        self.selectedAll = [];
        self.paCntMap.clear();
        self.paMap.clear();
        self.paModifiedMap.clear();
        self.modifiedPAList = [];
        self.pageAuthList = [];
        return new Promise(function (resolve, reject) {
            self.pageAuthorizationService.loadPageAuthorizations(BiUrls.PAGE + BiUrls.GET_PAGE_AUTH_BY_USER_AND_PAGE, self.empIdList, self.selectedPaged).then(function (res) {
                if (res != undefined) {
                    self.pageAuthList = res.data != null ? res.data : [];
                }
                self.setPA_paCntMap();
                for (var i = 0; i < self.empIdList.length; i++) {
                    self.setSelectedAll(i, self.empIdList[i]);
                }
                self.loader = false;
                self.mainPage = true;
                resolve('Completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    pageAuthorizationComponent.prototype.setSelectedAll = function (index, empId) {
        var self = this;
        // console.log(self.paCntMap.get(empId));       
        if (self.pageSectionList.length == self.paCntMap.get(empId)) {
            var enable = [];
            var disable = [];
            var lock = [];
            var flag = false;
            for (var j = 0; j < self.pageSectionList.length; j++) {
                if (self.paMap.get(empId + '_' + self.pageSectionList[j].id) == 0) {
                    enable.push(0);
                }
                else if (self.paMap.get(empId + '_' + self.pageSectionList[j].id) == 1) {
                    disable.push(1);
                }
                else if (self.paMap.get(empId + '_' + self.pageSectionList[j].id) == 2) {
                    lock.push(2);
                }
            }
            if (self.pageSectionList.length == enable.length) {
                self.selectedAll[index] = 0;
            }
            else if (self.pageSectionList.length == disable.length) {
                self.selectedAll[index] = 1;
            }
            else if (self.pageSectionList.length == lock.length) {
                self.selectedAll[index] = 2;
            }
            else {
                self.selectedAll[index] = 3;
            }
        }
        else {
            self.selectedAll[index] = 3;
        }
        if (!self.paCntMap.has(empId) || self.paCntMap.get(empId) == 0) {
            self.selectedAll[index] = 1;
        }
    };
    pageAuthorizationComponent.prototype.setPA_paCntMap = function () {
        var self = this;
        for (var _i = 0, _a = self.pageAuthList; _i < _a.length; _i++) {
            var paData = _a[_i];
            if (!self.paMap.has(paData.userId + '_' + paData.pageSectionId)) {
                self.paMap.set(paData.userId + '_' + paData.pageSectionId, paData.state);
                if (!self.paCntMap.has(paData.userId)) {
                    self.paCntMap.set(paData.userId, 1);
                }
                else if (self.paCntMap.has(paData.userId)) {
                    var value = self.paCntMap.get(paData.userId);
                    self.paCntMap.set(paData.userId, value + 1);
                }
            }
        }
        // console.log(self.paCntMap);     
    };
    pageAuthorizationComponent.prototype.selectAll = function (empId, index, currState) {
        var self = this;
        self.selectedAll[index] = currState;
        self.saveChangesButton = true;
        var paData;
        for (var _i = 0, _a = self.pageSectionList; _i < _a.length; _i++) {
            var ps = _a[_i];
            self.paMap.set(empId + '_' + ps.id, currState);
            paData = {
                id: null, userId: empId, state: currState,
                pageSectionId: ps.id, deleted: currState == 1 ? true : false
            };
            self.paModifiedMap.set(empId + '_' + ps.id, paData);
        }
    };
    // public onChange1(event, index) {
    //     let self = this;
    //     let empId = event.target.id;
    //     let psId = event.target.value;
    //     let chbox = event.target.checked;
    //     self.saveChangesButton = true;
    //     console.log('( ' + empId + ' , ' + psId + ' ) = ' + chbox);
    //     self.paMap.set(empId + '_' + psId, chbox);
    //     let paData = {
    //         id: null, userId: empId,
    //         pageSectionId: psId, deleted: !chbox
    //     };
    //     let value = self.paCntMap.get(paData.userId);
    //     if (chbox) {
    //         self.paCntMap.set(paData.userId, value + 1);
    //     } else {
    //         self.paCntMap.set(paData.userId, value - 1);
    //     }
    //     self.setSelectedAll(index);
    //     self.paModifiedMap.set(empId + '_' + psId, paData);
    // }
    pageAuthorizationComponent.prototype.onCloseSummary = function (event) {
        this.uploadSucess = false;
    };
    pageAuthorizationComponent.prototype.onSaveChanges = function (event) {
        var self = this;
        self.modifiedPAList = Array.from(self.paModifiedMap.values());
        self.setPaIdForModifiedEntries();
        self.cleanModifiedPAList();
        var url = BiUrls.PAGE + BiUrls.SAVE_MULTIPLE_PAGE_AUTH;
        self.loader = true;
        self.pageAuthorizationService.onSaveOrUpdate(url, self.modifiedPAList).then(function (success) {
            if ((success.errorMessage != null || success.errorMessage != undefined)) {
                console.log(success.errorMessage);
                self.mainPage = false;
                self.accessDenied = true;
                self.saveChangesButton = false;
                return;
            }
            else {
                self.toastr.showSuccess('Changes saved successsfully');
            }
            // self.loadData();
            //self.loadPageAuthorizations();
            self.saveChangesButton = false;
            self.loader = false;
        }, function (error) {
            self.toastr.showError('Failed to save changes');
            console.log(error);
        });
    };
    pageAuthorizationComponent.prototype.setPaIdForModifiedEntries = function () {
        var self = this;
        for (var _i = 0, _a = self.modifiedPAList; _i < _a.length; _i++) {
            var paData = _a[_i];
            for (var _b = 0, _c = self.pageAuthList; _b < _c.length; _b++) {
                var item = _c[_b];
                if (item.userId == paData.userId && item.pageSectionId == paData.pageSectionId) {
                    paData.id = item.id;
                }
            }
        }
    };
    pageAuthorizationComponent.prototype.cleanModifiedPAList = function () {
        var self = this;
        for (var _i = 0, _a = self.modifiedPAList; _i < _a.length; _i++) {
            var paData = _a[_i];
            if (paData.id == null) {
                if (paData.deleted == false) {
                    paData.deleted = null;
                }
                else {
                    var index = self.modifiedPAList.indexOf(paData);
                    self.modifiedPAList.splice(index, 1);
                }
            }
        }
    };
    // public loaderControl(event) {
    //     this.loader = event;
    // }
    // public pageDataControl(event) {
    //     this.employeePageData = event;
    //     this.totalEmps = event.totalElements;
    //     this.setEndingPage(this.totalEmps);
    // }
    pageAuthorizationComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            self.startingPage = 0;
            if (total > self.pageSize) {
                self.endingPage = self.pageSize;
            }
            else {
                self.endingPage = total;
            }
        }
        else {
            self.startingPage = 0 + ((self.currentPage - 1) * +self.pageSize);
            self.endingPage = +self.pageSize + ((self.currentPage - 1) * +self.pageSize);
            if (self.endingPage > total) {
                self.endingPage = total;
            }
        }
    };
    pageAuthorizationComponent.prototype.showSearchFilter = function (event) {
        this.searchData = event;
        this.getEmployee();
    };
    pageAuthorizationComponent.prototype.getEmployee = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.searchData.page = self.currentPage;
            self.searchData.pageSize = self.pageSize;
            self.pageAuthorizationService.getEmployee(self.searchData).then(function (result) {
                self.empList = [];
                self.empIdList = [];
                self.empList = result.content;
                self.employeePageData = result;
                //self.loadData();
                self.totalEmps = result.totalElements;
                if (self.empList != undefined && self.empList.length != 0) {
                    self.setEmpIdList(self.empList).then(function (res) {
                        if (res != undefined) {
                            self.loadPageAuthorizations();
                        }
                    });
                    resolve('');
                    self.setEndingPage(self.totalEmps);
                }
                self.loader = false;
            }, function (err) {
                self.toastr.showError('Failed to get employee details..');
                console.error(err);
            });
        });
    };
    pageAuthorizationComponent.prototype.onChange = function (empId, psId, index, chbox) {
        var self = this;
        self.saveChangesButton = true;
        console.log('( ' + empId + ' , ' + psId + ' ) = ' + chbox);
        var paData = {
            id: null, userId: empId,
            pageSectionId: psId, deleted: chbox == 1 ? true : false,
            state: chbox
        };
        var prevState = self.paMap.has(empId + '_' + psId) ? self.paMap.get(empId + '_' + psId) : chbox;
        self.paMap.set(empId + '_' + psId, chbox);
        var value = self.paCntMap.has(paData.userId) ? self.paCntMap.get(paData.userId) : 0;
        if (prevState == 1 && chbox != 1) {
            self.paCntMap.set(paData.userId, value + 1);
        }
        else if (prevState != 1 && chbox == 1) {
            self.paCntMap.set(paData.userId, value - 1);
        }
        else if (prevState == chbox && chbox != 1) {
            self.paCntMap.set(paData.userId, value + 1);
        }
        self.setSelectedAll(index, empId);
        self.paModifiedMap.set(empId + '_' + psId, paData);
    };
    pageAuthorizationComponent.prototype.beforeChange = function (event) {
        if (event.nextId == 'individual') {
            this.selectedTab = event.nextId;
        }
        else if (event.nextId == 'bulk') {
            this.selectedTab = event.nextId;
            this.getPageAuthHistory();
        }
    };
    pageAuthorizationComponent.prototype.chooseFile = function (event) {
        if (event.target.files && event.target.files.length > 0) {
            var self_1 = this;
            this.file = event.target.files[0];
            self_1.fileNameToUpload = event.target.files[0].name;
            event.srcElement.value = null;
        }
    };
    pageAuthorizationComponent.prototype.validateBulkOpInput = function () {
        var self = this;
        var ext = self.file.name.split('.', 2);
        var isValid = true;
        if (ext[1].toLowerCase() != 'xlsx') {
            this.toastr.showError("Please Attach An Excel File");
            isValid = false;
        }
        if (self.comment.trim() === '') {
            this.toastr.showError("Comment is mandatory");
            isValid = false;
        }
        return isValid;
    };
    pageAuthorizationComponent.prototype.initBulkPageAuth = function (event) {
        var self = this;
        var formdata = new FormData();
        if (self.validateBulkOpInput()) {
            self.loader = true;
            formdata.append('file', self.file);
            formdata.append('comment', self.comment);
            self.pageAuthorizationService.bulkUpload('auth/', 'processBulkPageAuth', formdata).then(function (res) {
                if (res) {
                    if (res.status == 409) {
                        self.toastr.showError(JSON.parse(res.error).message);
                    }
                    else {
                        if (!(res instanceof Object)) {
                            res = JSON.parse(res);
                        }
                        if (res.success) {
                            self.uploadSucess = true;
                            self.file = null;
                            self.fileInput.nativeElement.value = null;
                            self.token = res.data;
                            self.isProgress = true;
                        }
                        else {
                            self.toastr.showError(res.errorMessage);
                        }
                    }
                    self.getPageAuthHistory();
                }
                self.loader = false;
                self.resetBulkOperationParams();
            }, function (err) {
                console.error(err);
                self.resetBulkOperationParams();
                self.loader = false;
            });
        }
    };
    pageAuthorizationComponent.prototype.resetBulkOperationParams = function () {
        this.comment = '';
        this.fileNameToUpload = null;
    };
    pageAuthorizationComponent.prototype.downloadFiles = function (url) {
        var _this = this;
        try {
            this.pageAuthorizationService.mdmService.getBlob(url).subscribe(function (result) {
                var name = _this.getFileNameFromHeader(result.headers);
                FileSaver["saveAs"](result.body, name);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    pageAuthorizationComponent.prototype.downloadTemplate = function () {
        var url = this.pageAuthorizationService.base_url + 'biAdmin/auth/downloadTemplate/PAGE_AUTH_TEMPLATE';
        this.downloadFiles(url);
    };
    pageAuthorizationComponent.prototype.downloadPageAuthFiles = function (filePath) {
        var url = this.pageAuthorizationService.base_url + 'biAdmin/auth/downloadFile/' + filePath;
        this.downloadFiles(url);
    };
    pageAuthorizationComponent.prototype.getFileNameFromHeader = function (headers) {
        var header = headers.get('Content-Disposition');
        if (header == null) {
            return 'Page_Authorization_Template.xlxs';
        }
        else {
            if (!header) {
                return null;
            }
            var result = header.split(';')[1].trim().split('=')[1];
            return result.replace(/'/g, '');
        }
    };
    pageAuthorizationComponent.prototype.getPageAuthHistory = function () {
        var _this = this;
        var self = this;
        try {
            var url = self.pageAuthorizationService.base_url +
                'biAdmin/auth/getAllUploadStatus/?processType=BI_PAGE_AUTH_UPLOAD&' +
                'page=' + self.authCurrentPage + '&pageSize=' + self.authPageSize;
            self.pageAuthorizationService.mdmService.get(url).subscribe(function (response) {
                _this.handlePageAuthHistoryResponse(response);
            });
        }
        catch (e) {
            console.log('Error: getPageAuthHistory', e);
        }
    };
    pageAuthorizationComponent.prototype.handlePageAuthHistoryResponse = function (response) {
        if (response && response.content) {
            this.authTotalRecs = response.totalElements;
            this.tableData = response.content;
            this.setPaginationParams();
        }
    };
    pageAuthorizationComponent.prototype.setPaginationParams = function () {
        var self = this;
        if (self.authCurrentPage == 1) {
            self.authStartingPage = 0;
            if (self.authTotalRecs > self.authPageSize) {
                self.authEndingPage = self.authPageSize;
            }
            else {
                self.authEndingPage = self.authTotalRecs;
            }
        }
        else {
            self.authStartingPage = 0 + ((self.authCurrentPage - 1) * +self.authPageSize);
            self.authEndingPage = +self.authPageSize + ((self.authCurrentPage - 1) * +self.authPageSize);
            if (self.authEndingPage > self.authTotalRecs) {
                self.authEndingPage = self.authTotalRecs;
            }
        }
    };
    pageAuthorizationComponent.prototype.onAuthHistoryPageSizeChanged = function (event) {
        this.authPageSize = event.target.value;
        this.getPageAuthHistory();
    };
    pageAuthorizationComponent.prototype.onAuthHistoryPageChange = function (event) {
        if (typeof event == 'number' && !isNaN(event)) {
            this.authCurrentPage = event;
            this.getPageAuthHistory();
        }
    };
    return pageAuthorizationComponent;
}());



// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// CONCATENATED MODULE: ./src/app/bi/admin/controller/roleAuthorization.component.ts

var roleAuthorization_component_roleAuthorizationComponent = /*@__PURE__*/ (function () {
    function roleAuthorizationComponent(roleAuthService, MDMAuthService, toastr, vcr) {
        this.roleAuthService = roleAuthService;
        this.MDMAuthService = MDMAuthService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.accessDenied = false;
        this.loader = true;
        this.mainPage = true;
        this.isEdit = false;
        this.roleList = [];
        this.roleIdList = [];
        this.countMap = new Map();
        this.trackHides = null;
        this.roleId = [];
        this.pageNo = 1;
        this.pageSize = 10;
        this.toastr.setViewRef(this.vcr);
    }
    roleAuthorizationComponent.prototype.ngOnInit = function () {
        if (this.MDMAuthService.isBIAdmin) {
            this.loadData();
        }
        else {
            this.accessDenied = true;
        }
    };
    roleAuthorizationComponent.prototype.loadData = function () {
        var self = this;
        self.loadRoles().then(function () {
            //self.loadWidgetCounts();
        }, function (err) {
            console.error(err);
        });
    };
    roleAuthorizationComponent.prototype.loadRoles = function () {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var res;
            return tslib_es6["__generator"](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader = true;
                        // let pageNo = 1;
                        // let pageSize = 10;
                        this.roleList = [];
                        this.roleIdList = [];
                        return [4 /*yield*/, this.roleAuthService.getRoleList(this.pageNo, this.pageSize)];
                    case 1:
                        res = _a.sent();
                        // res = JSON.parse(JSON.stringify(res));
                        this.roleList = res && res.content ? res.content : null;
                        this.totalPages = res.totalPages;
                        this.totalRoles = res.totalElements;
                        this.loader = false;
                        this.mainPage = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    // async loadWidgetCounts(){
    //     this.roleList.forEach(element => {
    //         this.roleIdList.push(element.id);
    //     });
    //     this.loader = true;
    //     this.roleCounts = await this.roleAuthService.getWidgetCount(this.roleIdList);
    //     this.setCountMap();
    //     this.loader = false;
    // }
    roleAuthorizationComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        this.loadRoles();
    };
    roleAuthorizationComponent.prototype.onPageChange = function (event) {
        this.pageNo = event;
        this.loadRoles();
    };
    roleAuthorizationComponent.prototype.setCountMap = function () {
        var _this = this;
        if (this.roleCounts) {
            var countArr = this.roleCounts;
            countArr.forEach(function (countObj) {
                _this.countMap.set(countObj.roleId, countObj.count);
            });
        }
    };
    roleAuthorizationComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    roleAuthorizationComponent.prototype.tableActions = function (value) {
        this.trackHides = (this.trackHides == value) ? null : value;
    };
    roleAuthorizationComponent.prototype.editRoles = function (id, name) {
        this.trackHides = null;
        //this.roleAuthService.setRoleId(id,name);
        this.roleId[0] = id;
        this.roleName = name;
        this.roleList = [];
        this.isEdit = true;
    };
    roleAuthorizationComponent.prototype.onEdit = function (event) {
        // this.toastr.setViewRef(this.vcr);
        this.loadData();
        this.isEdit = false;
    };
    return roleAuthorizationComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/editRoleAuthorization.component.ts


var editRoleAuthorization_component_editRoleAuthorizationComponent = /*@__PURE__*/ (function () {
    function editRoleAuthorizationComponent(mdmService, roleAuthService, toastr, location, vcr) {
        this.mdmService = mdmService;
        this.roleAuthService = roleAuthService;
        this.toastr = toastr;
        this.location = location;
        this.vcr = vcr;
        this.showChild = [];
        this.accessDenied = false;
        this.loader = true;
        this.saveChangesButton = false;
        this.pageList = [];
        this.pageSectionMap = new Map;
        this.mainPage = true;
        this.selectedAll = [];
        this.roleAuthList = [];
        this.raMap = new Map();
        this.raModifiedMap = new Map();
        this.paCntMap = new Map();
        this.selectedpsList = [];
        this.changes = false;
        this.roleId = [];
        this.onEdit = new core["EventEmitter"];
        this.toastr.setViewRef(this.vcr);
    }
    editRoleAuthorizationComponent.prototype.ngOnChanges = function () {
        this.loadData();
    };
    editRoleAuthorizationComponent.prototype.loadData = function () {
        var self = this;
        self.loadPages().then(function (res) {
            self.loadRoleAuthorizations();
        }, function (err) {
            console.error(err);
        });
    };
    editRoleAuthorizationComponent.prototype.loadPages = function () {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var _a;
            return tslib_es6["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loader = true;
                        _a = this;
                        return [4 /*yield*/, this.roleAuthService.getPages()];
                    case 1:
                        _a.pageList = _b.sent();
                        this.loader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    editRoleAuthorizationComponent.prototype.loadRoleAuthorizations = function () {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var _a, e_1, i;
            return tslib_es6["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loagPageSection();
                        this.loader = true;
                        this.selectedAll = [];
                        this.roleAuthList = [];
                        this.raModifiedMap.clear();
                        this.raMap.clear();
                        this.paCntMap.clear();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.roleAuthService.getRoleAuth(this.roleId)];
                    case 2:
                        _a.roleAuthList = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        this.roleAuthList = null;
                        return [3 /*break*/, 4];
                    case 4:
                        this.setRoleAuth();
                        for (i = 0; i < this.pageList.length; i++) {
                            this.setSelectedAll(i);
                        }
                        this.loader = false;
                        this.mainPage = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    editRoleAuthorizationComponent.prototype.loagPageSection = function () {
        var self = this;
        var secId = [];
        var pageId = [];
        self.pageList.forEach(function (page) {
            pageId.push(page.id);
            page.sections.forEach(function (section) {
                secId.push(section.id);
                self.pageSectionMap.set(page.id, secId);
            });
            secId = [];
        });
    };
    editRoleAuthorizationComponent.prototype.setRoleAuth = function () {
        var self = this;
        if (!self.roleAuthList)
            return;
        for (var _i = 0, _a = self.roleAuthList; _i < _a.length; _i++) {
            var raData = _a[_i];
            if (!self.raMap.has(raData.pageSectionId)) {
                self.raMap.set(raData.pageSectionId, raData.state);
                for (var _b = 0, _c = self.pageList; _b < _c.length; _b++) {
                    var paData = _c[_b];
                    for (var _d = 0, _e = paData.sections; _d < _e.length; _d++) {
                        var psData = _e[_d];
                        if (psData.id == raData.pageSectionId) {
                            if (!self.paCntMap.has(paData.id)) {
                                self.paCntMap.set(paData.id, 1);
                            }
                            else {
                                var value = self.paCntMap.get(paData.id);
                                self.paCntMap.set(paData.id, value + 1);
                            }
                        }
                    }
                }
            }
        }
    };
    editRoleAuthorizationComponent.prototype.selectAll = function (pageId, index, state) {
        var self = this;
        self.saveChangesButton = true;
        var raData;
        var psList = self.pageSectionMap.get(pageId);
        self.selectedAll[index] = state;
        for (var _i = 0, psList_1 = psList; _i < psList_1.length; _i++) {
            var psId = psList_1[_i];
            state != 1 ? self.raMap.set(psId, state) && self.paCntMap.set(pageId, psList.length) :
                self.raMap.set(psId, state) && self.paCntMap.set(pageId, 0);
            raData = { pageId: pageId, pageSectionId: psId, state: state };
            self.raModifiedMap.set(psId, raData);
        }
        self.selectedpsList[index] = null;
    };
    editRoleAuthorizationComponent.prototype.onChange = function (pageId, psId, index, chbox) {
        var self = this;
        // let pageId = +event.target.value;
        // let psId = +event.target.id;
        // let chbox = event.target.checked;
        self.saveChangesButton = true;
        var raData = { pageId: pageId, pageSectionId: psId, state: chbox, deleted: chbox == 1 ? true : false };
        // let value = 0;
        // if (self.paCntMap.has(raData.pageId)) {
        //     value = self.paCntMap.get(raData.pageId);
        // }
        // chbox ? self.paCntMap.set(raData.pageId, value + 1) :
        //     self.paCntMap.set(raData.pageId, value - 1);
        var prevState = self.raMap.has(psId) ? self.raMap.get(psId) : chbox;
        self.raMap.set(psId, chbox);
        var value = self.paCntMap.has(pageId) ? self.paCntMap.get(pageId) : 0;
        if (prevState == 1 && chbox != 1) {
            self.paCntMap.set(pageId, value + 1);
        }
        else if (prevState != 1 && chbox == 1) {
            self.paCntMap.set(pageId, value - 1);
        }
        else if (prevState == chbox && chbox != 1) {
            self.paCntMap.set(pageId, value + 1);
        }
        self.setSelectedAll(index);
        self.raModifiedMap.set(psId, raData);
    };
    editRoleAuthorizationComponent.prototype.SaveChanges = function () {
        var self = this;
        self.OnSaveChanges().then(function (res) {
            if (res) {
                self.rolesBack();
            }
        }, function (err) {
            self.changes = false;
        });
    };
    editRoleAuthorizationComponent.prototype.OnSaveChanges = function () {
        var self = this;
        var psIdList_save = [];
        var psIdList_del = [];
        self.pageSectionMap.forEach(function (page) {
            if (page != undefined) {
                page.forEach(function (psId) {
                    var data = self.raModifiedMap.has(psId) ? self.raModifiedMap.get(psId) : null;
                    if (data != null) {
                        var authData = { pageSectionId: data.pageSectionId, state: data.state };
                        (data.state != 1) ? psIdList_save.push(authData) :
                            psIdList_del.push(authData);
                    }
                });
            }
        });
        var IdList_del = [];
        if (self.roleAuthList != null) {
            if (psIdList_del && psIdList_del.length) {
                psIdList_del.forEach(function (ele) {
                    var psId;
                    self.roleAuthList.forEach(function (prevAuth) {
                        if (ele.pageSectionId == prevAuth.pageSectionId && ele.state != prevAuth.state) {
                            psId = ele;
                        }
                    });
                    psId ? IdList_del.push(psId) : null;
                });
            }
        }
        if (self.roleAuthList != null) {
            if (psIdList_save && psIdList_save.length) {
                self.roleAuthList.forEach(function (prevAuth) {
                    psIdList_save.forEach(function (ele, i) {
                        if (ele.pageSectionId == prevAuth.pageSectionId && ele.state == prevAuth.state) {
                            psIdList_save.splice(i, 1);
                        }
                    });
                });
            }
        }
        var finalList = IdList_del && IdList_del.length ? IdList_del.concat(psIdList_save) : psIdList_save;
        return new Promise(function (resolve, reject) {
            if (finalList && finalList.length) {
                self.loader = true;
                self.roleAuthService.editOrSave('/save', finalList, self.roleId).then(function (res) {
                    if (res && res.success) {
                        self.changes = true;
                        self.loader = false;
                        self.toastr.showSuccess('Changes saved successsfully');
                        resolve('success');
                    }
                    else if (res && !res.success) {
                        self.loader = false;
                        self.toastr.showError('Failed to save changes');
                        resolve('error');
                    }
                });
            }
            else {
                resolve('null');
            }
        });
        // console.log(psIdList_save);
        // console.log(psIdList_del);           
        // return;
        // if (psIdList_del.length || psIdList_save.length) {
        //     self.loader = true;
        //     self.roleAuthList == null ? psIdList_del = [] : null;
        //     self.removeAuth(psIdList_del).then((res) => {
        //         self.addAuth(psIdList_save).then((res) => {
        //             self.changes = true;
        //             self.loader = false;
        //             resolve();
        //         });
        //     });
        // } else {
        //     self.loader = false;
        //     resolve();
        // };   
    };
    // removeAuth(psIdList) {
    //     let self = this;
    //     let npsIdList = [];
    //     return new Promise((resolve) => {
    //         if (!psIdList.length) resolve('');
    //         if (self.roleAuthList != null){
    //             psIdList.forEach(ele => {
    //                 let psId;
    //                 self.roleAuthList.forEach(prevAuth => {
    //                     if(ele.id == prevAuth.pageSectionId){
    //                         psId = ele;
    //                     }
    //                 });
    //                 psId ? npsIdList.push(psId) : null;
    //             });
    //         }else npsIdList = psIdList;
    //         if(npsIdList.length){
    //             self.roleAuthService.editOrSave('/remove', npsIdList, self.roleId).then((res) => {
    //                 resolve(res);
    //             });
    //         }else resolve('');
    //     });
    // }
    // addAuth(psIdList) {
    //     let self = this;
    //     return new Promise((resolve) => {
    //         if (!psIdList.length) resolve('');
    //         if (self.roleAuthList != null){
    //             self.roleAuthList.forEach(prevAuth => {
    //                 psIdList.forEach((ele,i) => {
    //                     if(ele.id == prevAuth.pageSectionId && ele.state == prevAuth.state){
    //                         psIdList.splice(i,1);
    //                     }
    //                 });
    //             });
    //         }
    //         if(psIdList.length){
    //             self.roleAuthService.editOrSave('/save', psIdList, self.roleId).then((res) => {
    //                 resolve(res);
    //             });
    //         }else resolve('');
    //     });
    // }
    editRoleAuthorizationComponent.prototype.toggleChild = function (i) {
        var self = this;
        self.showChild[i] = !self.showChild[i];
    };
    editRoleAuthorizationComponent.prototype.setSelectedAll = function (index) {
        var self = this;
        var enable = [];
        var disable = [];
        var lock = [];
        var flag = false;
        var i = index;
        // for (let i = 0; i < self.pageList.length; i++) {
        var psList = self.pageSectionMap.get(self.pageList[i].id);
        if (psList && psList.length == self.paCntMap.get(self.pageList[i].id)) {
            for (var j = 0; j < psList.length; j++) {
                if (self.raMap.get(psList[j]) == 0) {
                    enable.push(0);
                }
                else if (self.raMap.get(psList[j]) == 1) {
                    disable.push(1);
                }
                else if (self.raMap.get(psList[j]) == 2) {
                    lock.push(2);
                }
                this.selectedpsList[i] = null;
            }
            if (psList.length == enable.length) {
                self.selectedAll[index] = 0;
            }
            else if (psList.length == disable.length) {
                self.selectedAll[index] = 1;
            }
            else if (psList.length == lock.length) {
                self.selectedAll[index] = 2;
            }
            else {
                self.selectedAll[index] = 3;
            }
        }
        else {
            self.selectedAll[i] = 3;
            this.selectedpsList[i] = self.paCntMap.get(self.pageList[i].id);
        }
        if (!self.paCntMap.has(self.pageList[i].id) || self.paCntMap.get(self.pageList[i].id) == 0) {
            self.selectedAll[index] = 1;
        }
        // }
    };
    editRoleAuthorizationComponent.prototype.hasChilds = function () {
        return this.pageList.sections != null && this.pageList.sections.length > 0;
    };
    editRoleAuthorizationComponent.prototype.rolesBack = function () {
        this.onEdit.emit(this.changes);
    };
    return editRoleAuthorizationComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/fileUploadModal.ts

var fileUploadModal_FileUploader = /*@__PURE__*/ (function () {
    function FileUploader(activeModal, service) {
        this.activeModal = activeModal;
        this.service = service;
        this.dataSourceList = [];
        this.saveButton = false;
        this.reUpload = false;
        this.typeList = ['csv', 'psv', 'tsv', 'json', 'xlsx'];
        this.getDataSourceForDrill();
    }
    FileUploader.prototype.getDataSourceForDrill = function () {
        var self = this;
        self.service.getAll('ds/type/DRILL').then(function (res) {
            self.dataSourceList = res.data != null ? res.data : [];
            if (self.dataSourceList && self.dataSourceList.length == 1) {
                self.selectedDataSource = self.dataSourceList[0].id;
            }
        });
    };
    FileUploader.prototype.saveFile = function () {
        var self = this;
        if (!self.reUpload) {
            var msg = self.validator();
            if (msg != '') {
                self.parent.toastr.showError(msg);
            }
            else {
                self.saveButton = true;
                var formdata1 = new FormData();
                formdata1.append('file', self.file);
                self.activeModal.close();
                self.parent.loader = true;
                self.service.uploadFileToDrill(BiUrls.UPLOAD_DRILL_FILE, formdata1, self.selectedDataSource).then(function (res) {
                    self.saveButton = false;
                    if (res.success) {
                        self.parent.toastr.showSuccess("File upload successful");
                    }
                    else if (res.message != null) {
                        self.parent.toastr.showError(res.message);
                    }
                    else if (res.errorMessage != null) {
                        self.parent.toastr.showError(res.errorMessage);
                    }
                    else {
                        self.parent.toastr.showError("File upload failed");
                    }
                    self.parent.loadRecords();
                    self.parent.loader = false;
                }, function (err) {
                    console.error(err);
                });
            }
        }
        else {
            self.reUploadFile();
        }
    };
    FileUploader.prototype.validator = function () {
        if (this.selectedDataSource == undefined || this.selectedDataSource == 'none') {
            return 'Please select Data-Source to upload a file !';
        }
        if (this.file == undefined) {
            return 'Please select a file to upload !';
        }
        var msg = this.fileValidator();
        if (msg) {
            return msg;
        }
        return '';
    };
    FileUploader.prototype.fileValidator = function () {
        if (this.file) {
            var name_1 = this.file.name.split('.');
            var ext = name_1[name_1.length - 1];
            if (this.typeList.indexOf(ext) == -1) {
                return 'Please select ' + this.typeList.map(function (a) { return a.toUpperCase(); }).join(', ') + ' type file to upload';
            }
            var maxSize = 26214400; // 25MB
            var maxSizeInMB = maxSize / 1048576;
            if (this.file.size > maxSize) {
                return 'File size should not exceed ' + maxSizeInMB + 'MB';
            }
            return false;
        }
        return 'Please select a file to upload !';
    };
    FileUploader.prototype.fileChange = function (event) {
        if (!this.reUpload && (this.selectedDataSource == undefined || this.selectedDataSource == 'none')) {
            this.parent.toastr.showError('Please select Data-Source to upload a file !');
            this.fileDiv.nativeElement.value = null;
        }
        else {
            this.file = event.target.files[0];
        }
    };
    FileUploader.prototype.selectDataSource = function (event) {
        if (event != 'none') {
            this.selectedDataSource = event.target.value;
        }
    };
    FileUploader.prototype.reUploadFile = function () {
        var self = this;
        if (!self.recordFormat) {
            self.parent.toastr.showError("Cannot re-upload!");
        }
        var validate = self.fileValidator();
        if (validate) {
            self.parent.toastr.showError(validate);
            self.fileDiv.nativeElement.value = null;
        }
        else {
            var formdata1 = new FormData();
            self.saveButton = true;
            formdata1.append('file', self.file);
            self.service.reUploadDrillFile(BiUrls.REUPLOAD_DRILL_FILE, formdata1, self.recordFormat).then(function (res) {
                self.saveButton = false;
                if (res.success) {
                    self.parent.toastr.showSuccess("File re-uploaded successfull");
                }
                else {
                    self.parent.toastr.showError("File re-upload failed");
                }
                self.parent.loadRecords();
                self.parent.loader = false;
            }, function (err) {
                console.error(err);
            });
            self.activeModal.close();
        }
    };
    return FileUploader;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/recordFormat.component.ts


var recordFormat_component_RecordFormatComponent = /*@__PURE__*/ (function () {
    function RecordFormatComponent(recordService, toastr, fileService, vcr, modal, _global) {
        this.recordService = recordService;
        this.toastr = toastr;
        this.fileService = fileService;
        this.vcr = vcr;
        this.modal = modal;
        this._global = _global;
        this.downloadUrl = this._global.get('EPMS_BASE_URL') + "v1/biAdmin/" + BiUrls.DOWNLOAD_DRILL_FILE;
        this.recordFormatReg = '';
        this.sPage = 0;
        this.lastRegex = '';
        this.recordData = {
            id: null, name: '', recordFormatCode: null,
            description: '', deleted: 0
        };
        this.mainPage = true;
        this.recordPage = false;
        this.recordList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.onStart = false;
        this.isEdit = false;
        this.recordFormatFieldData = [];
        this.recordFormatData = {};
        this.showField = false;
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.currentPage = 1;
        this.totalRecords = 0;
        this.totalPages = 0;
        this.loader = false;
        this.dataSourceList = [];
        this.isFieldEdit = [];
        this.toastr.setViewRef(vcr);
    }
    RecordFormatComponent.prototype.ngOnInit = function () {
        if (this.recordService.isBIAdmin) {
            this.loadRecords();
        }
        else {
            this.accessDenied = true;
        }
    };
    RecordFormatComponent.prototype.entityOps = function (event) {
        if (this.selectedRFId == null) {
            this.selectedRFId = event.target.id;
        }
        else {
            this.selectedRFId = null;
        }
    };
    RecordFormatComponent.prototype.closeDropDown = function (event) {
        this.selectedRFId = null;
    };
    RecordFormatComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.recordFormatReg != '') {
            this.searchPRecordFormat();
        }
        else {
            this.loadRecords();
        }
        this.setEndingPage(this.totalRecords);
    };
    RecordFormatComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    RecordFormatComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalRecords / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadRecords();
    };
    RecordFormatComponent.prototype.loadRecords = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            _this.recordService.getDataByPage(BiUrls.RECORDFORMAT, self.pageNo, self.pageSize).then(function (res) {
                self.recordList = [];
                self.totalPages = 0;
                self.totalRecords = 0;
                if (res != undefined) {
                    self.recordList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalRecords = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.setEndingPage(self.totalRecords);
                self.loadDataSource();
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (error) {
                console.error(error);
            });
        });
    };
    // By Lalu
    RecordFormatComponent.prototype.searchPRecordFormat = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.mainPage = true;
            self.recordList = [];
            if (self.recordFormatReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.pageNo = 0;
            self.lastRegex = self.recordFormatReg;
            self.recordService.search(BiUrls.RECORDFORMAT, BiUrls.SEARCH_P_RECORDFORMAT, self.recordFormatReg, self.pageNo, self.pageSize).then(function (res) {
                self.loadSearchedPRecordFormat(res);
                self.loader = false;
            }, function (error) {
                console.error(error);
            });
            resolve('completed');
        });
    };
    // By Lalu
    RecordFormatComponent.prototype.loadSearchedPRecordFormat = function (res) {
        var self = this;
        if (res != undefined) {
            self.recordList = res.data.pageElements;
            self.totalRecords = res.data.total;
        }
        else {
            self.totalRecords = 0;
        }
        self.setEndingPage(self.totalRecords);
    };
    RecordFormatComponent.prototype.addNewRecord = function () {
        this.mainPage = false;
        this.recordPage = true;
        this.recordData = { id: null, name: '', description: '', deleted: 0 };
    };
    RecordFormatComponent.prototype.loadDataSource = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.recordService.onStartUp(BiUrls.DATASOURCE).then(function (res) {
                self.dataSourceList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    };
    RecordFormatComponent.prototype.onSave = function () {
        var validate = this.validater();
        if (validate != '' || this.errorIndexD != null || this.errorIndexF != null) {
            this.toastr.showError(validate);
        }
        else {
            var self_1 = this;
            self_1.isFieldEdit = [];
            self_1.saveButton = true;
            self_1.loader = true;
            self_1.recordData.recordFormatFieldData = self_1.recordFormatFieldData;
            if (self_1.isEdit) {
                console.log('ON EDIT');
                self_1.recordService.update(BiUrls.RECORDFORMAT, self_1.recordData).then(function (res) {
                    self_1.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                self_1.recordService.save(BiUrls.RECORDFORMAT, self_1.recordData).then(function (res) {
                    self_1.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    };
    RecordFormatComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalRecords / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        var text = type == 'new' ?
            'Record Format saved successfully' :
            'Changes saved successfully';
        if (self.recordFormatReg != '') {
            self.searchPRecordFormat().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Unable to save Record Format');
                }
            });
        }
        else {
            self.loadRecords().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Unable to save Record Format');
                }
            }, function (error) {
                console.error(error);
            });
        }
        self.currentPage = self.pageNo + 1;
    };
    RecordFormatComponent.prototype.setPageFieldsAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.recordPage = false;
        self.isEdit = false;
        self.showField = false;
        self.loader = false;
        self.recordFormatFieldData = [];
    };
    RecordFormatComponent.prototype.clickEdit = function (recordData) {
        var self = this;
        self.loader = true;
        self.selectedRFId = null;
        self.recordService.getDataById(BiUrls.RECORDFORMAT, recordData.id).then(function (res) {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Record Format');
            }
            else {
                recordData = res.data;
                self.isEdit = true;
                self.mainPage = false;
                self.recordPage = true;
                self.recordData = JSON.parse(JSON.stringify(recordData));
                self.recordFormatFieldData = self.recordData.recordFormatFieldData;
            }
            self.loader = false;
        }, function (error) {
            console.error(error);
        });
    };
    RecordFormatComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.recordPage = false;
        this.recordData = {};
        this.isEdit = false;
        this.selectedRFId = null;
        this.recordFormatFieldData = [];
        this.showField = false;
        this.isFieldEdit = [];
        this.errorIndexD = null;
        this.errorIndexF = null;
    };
    RecordFormatComponent.prototype.delete = function (record) {
        var self = this;
        self.loader = true;
        self.recordService.delete(BiUrls.RECORDFORMAT, record.id).then(function (response) {
            self.pageNo = self.recordList.length == 1 ?
                self.totalRecords == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadRecords();
            self.loader = false;
            if (response.success) {
                self.toastr.showSuccess(record.name + ' removed successfully');
            }
            else {
                self.toastr.showError(!!response.message ? response.message : 'Unable to remove record format');
            }
        });
    };
    RecordFormatComponent.prototype.removeRecord = function (record) {
        var r = confirm('Are you sure you want to remove the record format ' + record.name + ' ?');
        if (r == true) {
            this.delete(record);
        }
    };
    RecordFormatComponent.prototype.validater = function () {
        if (this.recordData.name == undefined ||
            this.recordData.name.trim() == '') {
            return 'Please enter the name for record format';
        }
        else if (this.recordData.displayName == undefined ||
            this.recordData.displayName.trim() == '') {
            return 'Please enter the Display Name for record format';
        }
        else {
            this.recordData.name = this.recordData.name.trim();
            this.recordData.description = this.recordData.description != undefined ?
                this.recordData.description.trim() : null;
            this.recordData.recordFormatFieldData = this.recordFormatFieldData;
            return '';
        }
    };
    RecordFormatComponent.prototype.addRecordFormatFields = function () {
        console.log('On Add Record Fields Controller ...');
        this.showField = true;
        this.recordFormatData = {
            fieldName: '', displayName: '', fieldDatatype: 'String',
            recordFormatId: null, deleted: 0
        };
        this.recordFormatData.recordFormatId = this.recordData.id;
    };
    RecordFormatComponent.prototype.fieldValidater = function () {
        if (this.recordFormatData.fieldName == '' || this.recordFormatData.displayName == '' ||
            this.recordFormatData.fieldDatatype == '') {
            return 'Please enter values for all the fields';
        }
        else {
            return '';
        }
    };
    RecordFormatComponent.prototype.addField = function () {
        var validate = this.fieldValidater();
        if (validate != '') {
            this.toastr.showError(validate);
        }
        else {
            this.recordFormatFieldData.push(this.recordFormatData);
            this.showField = false;
            this.recordFormatData = {};
        }
    };
    RecordFormatComponent.prototype.onDeleteField = function (event, recordField) {
        console.log('On Delete Field COntroller ...');
        var r = confirm('Are you sure you want to delete this filed ' +
            recordField.displayName + ' ?');
        if (r == true) {
            this.toastr.showSuccess('Field removed successfully');
            var index = this.recordFormatFieldData.indexOf(recordField);
            this.recordFormatFieldData.splice(index, 1);
        }
    };
    RecordFormatComponent.prototype.selectDataSource = function (event) {
        if (event.target.value != undefined && event.target.value != 'none') {
            this.recordData['dataSourceId'] = event.target.value;
        }
        else {
            this.recordData['dataSourceId'] = null;
        }
    };
    RecordFormatComponent.prototype.syncRecordFormat = function (rf) {
        var self = this;
        self.selectedRFId = null;
        var r = confirm('Are you sure you want to sync ' + rf.name + ' ?');
        if (r) {
            self.recordService.syncRecordFormat(rf.id).then(function (res) {
                if (res.success && res.message) {
                    self.toastr.showSuccess(res.message);
                }
                else if (res.success) {
                    self.toastr.showSuccess('Sync was successful');
                }
                else if (res.message) {
                    self.toastr.showError(res.message);
                }
                else if (res.errorMessage != undefined) {
                    self.toastr.showError(res.errorMessage);
                }
                else {
                    self.toastr.showError('Unable to sync data with model');
                }
            });
        }
    };
    RecordFormatComponent.prototype.uploadFile = function (type, recordFormat) {
        var activeModal = this.modal.open(fileUploadModal_FileUploader);
        activeModal.componentInstance.parent = this;
        if (type == 'reUpLoad') {
            this.selectedRFId = null;
            activeModal.componentInstance.reUpload = true;
            activeModal.componentInstance.recordFormat = recordFormat.id;
        }
    };
    RecordFormatComponent.prototype.closeActionsMenu = function (e) {
        this.selectedRFId = null;
    };
    RecordFormatComponent.prototype.selectPrimaryKey = function (isPk, rffId) {
        this.recordFormatFieldData.forEach(function (rff) {
            if (rff.id == rffId) {
                rff.isPK = isPk;
            }
            else {
                rff.isPK = false;
            }
        });
    };
    RecordFormatComponent.prototype.onEditPrevField = function (rff, i) {
        if (this.errorIndexD != null || this.errorIndexF != null) {
            this.toastr.showError('Please enter values for all the fields');
            return;
        }
        this.isFieldEdit = Array(this.recordFormatFieldData.length).fill(false);
        this.isFieldEdit[i] = !this.isFieldEdit[i];
        var index = this.recordFormatFieldData.indexOf(rff);
        this.recordFormatData = {
            fieldName: rff.fieldName, displayName: rff.displayName, fieldDatatype: rff.fieldDatatype,
            deleted: 0, fieldSize: rff.fieldSize, id: rff.id, isPK: rff.isPK, recordFormatId: rff.recordFormatId,
            refId: rff.refId
        };
        if (rff.fieldDatatype == 'DATE' || rff.fieldDatatype == 'date') {
            this.recordFormatData.dateFormat = rff.dateFormat ? rff.dateFormat : 'YYYY-MM-DD';
        }
        else if (rff.fieldDatatype == 'DATETIME') {
            this.recordFormatData.dateFormat = rff.dateFormat ? rff.dateFormat : 'YYYY-MM-DD HH:MM:SS';
        }
        else {
            delete this.recordFormatData.dateFormat;
        }
        this.recordFormatFieldData[index] = this.recordFormatData;
        this.recordFormatData = {};
    };
    RecordFormatComponent.prototype.onValidateEdit = function (rff, i) {
        this.errorIndexD = rff.displayName == '' ? i : null;
        this.errorIndexF = rff.fieldName == '' ? i : null;
    };
    RecordFormatComponent.prototype.setFieldDatatype = function (fieldDatatype, rff) {
        var index = this.recordFormatFieldData.indexOf(rff);
        this.recordFormatFieldData[index].fieldDatatype = fieldDatatype;
        if (rff.fieldDatatype == 'DATE' || rff.fieldDatatype == 'date') {
            this.recordFormatFieldData[index].dateFormat = 'YYYY-MM-DD';
        }
        else if (rff.fieldDatatype == 'DATETIME') {
            this.recordFormatFieldData[index].dateFormat = 'YYYY-MM-DD HH:MM:SS';
        }
        else {
            delete this.recordFormatFieldData[index].dateFormat;
        }
    };
    RecordFormatComponent.prototype.downloadFile = function (rf) {
        this.selectedRFId = null;
        var type = rf.recordFormatType ? rf.recordFormatType : "csv";
        this.fileService.download(this.downloadUrl + "/" + rf.id, rf.name + '.' + type, type);
    };
    return RecordFormatComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/scope.component.ts

var scope_component_ScopeComponent = /*@__PURE__*/ (function () {
    function ScopeComponent(scopeService, toastr, vcr) {
        this.scopeService = scopeService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.scopeReg = '';
        this.sPage = 0;
        this.lastRegex = '';
        this.scopeData = { id: null, name: '', scopeDesc: '', deleted: 0 };
        this.mainPage = true;
        this.scopePage = false;
        this.scopeList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.onStart = false;
        this.isEdit = false;
        this.oldName = 'oldName';
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.currentPage = 1;
        this.totalScope = 0;
        this.totalPages = 0;
        this.loader = false;
        this.toastr.setViewRef(vcr);
    }
    ScopeComponent.prototype.ngOnInit = function () {
        if (this.scopeService.isBIAdmin) {
            this.loadScope();
        }
        else {
            this.accessDenied = true;
        }
    };
    ScopeComponent.prototype.entityOps = function (event) {
        if (this.selectedScopeId == null) {
            this.selectedScopeId = event.target.id;
        }
        else {
            this.selectedScopeId = null;
        }
    };
    ScopeComponent.prototype.closeDropDown = function (event) {
        this.selectedScopeId = null;
    };
    ScopeComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        this.setEndingPage();
        if (this.scopeReg != '') {
            this.searchPScope();
        }
        else {
            this.loadScope();
        }
    };
    ScopeComponent.prototype.setEndingPage = function () {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (this.totalScope > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = this.totalScope;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > this.totalScope) {
                this.endingPage = this.totalScope;
            }
        }
    };
    // For Pagination
    ScopeComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalScope / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadScope();
    };
    ScopeComponent.prototype.loadScope = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.mainPage = true;
            _this.scopeService.getDataByPage(BiUrls.SCOPE, self.pageNo, self.pageSize).then(function (res) {
                self.scopeList = [];
                self.totalPages = 0;
                self.totalScope = 0;
                if (res != undefined) {
                    self.scopeList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalScope = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                    self.setEndingPage();
                    resolve('completed');
                }
                self.loader = false;
            }, function (error) {
                console.error(error);
            });
        });
    };
    ScopeComponent.prototype.addNewScope = function () {
        this.mainPage = false;
        this.scopePage = true;
        this.scopeData = { id: null, name: '', scopeDesc: '', deleted: 0 };
    };
    // By Lalu
    ScopeComponent.prototype.searchPScope = function () {
        var self = this;
        self.loader = true;
        self.mainPage = true;
        self.scopeList = [];
        if (self.scopeReg != self.lastRegex) {
            self.sPage = 0;
        }
        else {
            self.sPage = self.currentPage - 1;
            self.currentPage = 1;
        }
        self.lastRegex = self.scopeReg;
        self.scopeService.search(BiUrls.SCOPE, BiUrls.SEARCH_P_SCOPE, self.scopeReg, self.sPage, self.pageSize).then(function (res) {
            self.loadSearchedPScope(res);
            self.loader = false;
        }, function (error) {
            console.error(error);
        });
    };
    // By Lalu
    ScopeComponent.prototype.loadSearchedPScope = function (res) {
        var self = this;
        self.scopeList = (res != undefined) ? res.data.pageElements : [];
        self.totalScope = (res != undefined) ? res.data.total : 0;
        self.setEndingPage();
    };
    ScopeComponent.prototype.onSave = function () {
        var self = this;
        self.scopeData.name = self.scopeData.name.trim();
        var validate = self.validater();
        if (validate != '') {
            self.toastr.showError(validate);
        }
        else {
            self.loader = true;
            self.saveButton = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.scopeService.update(BiUrls.SCOPE, self.scopeData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                self.scopeService.save(BiUrls.SCOPE, self.scopeData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
            self.oldName = 'oldName';
        }
    };
    ScopeComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalScope / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            self.totalPages;
        self.currentPage = self.pageNo + 1;
        var text = type == 'new' ? 'Scope saved successfully' : 'Changes saved successfully';
        if (result.error == undefined && result.success == true) {
            self.toastr.showSuccess(text);
            self.loadScope().then(function (res) {
                self.saveButton = false;
                self.mainPage = true;
                self.scopePage = false;
                self.isEdit = false;
                self.loader = false;
            }, function (error) {
                console.error(error);
            });
        }
        else {
            self.toastr.showError(result.errorMessage ? result.errorMessage : 'Failed to save Scope');
            self.saveButton = false;
            self.loader = false;
        }
    };
    ScopeComponent.prototype.clickEdit = function (scope) {
        console.log('On Edit Controller ...');
        var self = this;
        self.loader = true;
        self.selectedScopeId = null;
        self.scopeService.getDataById(BiUrls.SCOPE, scope.id).then(function (res) {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Scope');
                self.loadScope();
            }
            else {
                scope = res.data;
                self.isEdit = true;
                self.loader = false;
                self.mainPage = false;
                self.scopePage = true;
                self.scopeData = JSON.parse(JSON.stringify(scope));
                self.oldName = self.scopeData.name;
            }
            self.loader = false;
        }, function (error) {
            console.error(error);
        });
    };
    ScopeComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.scopePage = false;
        this.selectedScopeId = null;
        this.scopeData = {};
        this.oldName = 'oldName';
        this.isEdit = false;
    };
    ScopeComponent.prototype.delete = function (scope) {
        var self = this;
        self.scopeService.delete(BiUrls.SCOPE, scope.id).then(function (response) {
            self.loader = false;
            self.pageNo = self.scopeList.length == 1 ?
                self.totalScope == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadScope();
            if (response == undefined || response.data == undefined) {
                self.toastr.showError('Unable to remove Scope');
            }
            else {
                self.toastr.showSuccess(scope.name + ' removed successfully');
            }
        }, function (error) {
            console.error(error);
        });
    };
    ScopeComponent.prototype.removeScope = function (scope) {
        var r = confirm('Are you sure you want to remove the Scope ' + scope.name + ' ?');
        if (r == true) {
            this.delete(scope);
        }
    };
    ScopeComponent.prototype.validater = function () {
        if (this.scopeData.name == undefined || this.scopeData.name == '') {
            return 'Please enter the name for Scope';
        }
        else if (this.oldName != this.scopeData.name) {
            this.scopeData.name = this.scopeData.name.trim();
            this.scopeData.scopeDesc = this.scopeData.scopeDesc != undefined ?
                this.scopeData.scopeDesc.trim() : null;
            return '';
        }
        else {
            this.scopeData.name = this.scopeData.name.trim();
            this.scopeData.scopeDesc = this.scopeData.scopeDesc != undefined ?
                this.scopeData.scopeDesc.trim() : null;
            return '';
        }
    };
    return ScopeComponent;
}());



// CONCATENATED MODULE: ./src/app/shared/services/logger.service.ts
var LogManager = /*@__PURE__*/ (function () {
    function LogManager() {
    }
    LogManager.prototype.debug = function (message) {
        console.log(message);
    };
    LogManager.prototype.warn = function (message) {
        console.warn(message);
    };
    LogManager.prototype.error = function (message) {
        console.error(message);
    };
    LogManager.prototype.info = function (message) {
        console.log(message);
    };
    return LogManager;
}());



// CONCATENATED MODULE: ./node_modules/@angular/common/fesm5/http.js
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START tslib,_angular_core,rxjs,rxjs_operators,_angular_common PURE_IMPORTS_END */





/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Transforms an `HttpRequest` into a stream of `HttpEvent`s, one of which will likely be a
 * `HttpResponse`.
 *
 * `HttpHandler` is injectable. When injected, the handler instance dispatches requests to the
 * first interceptor in the chain, which dispatches to the second, etc, eventually reaching the
 * `HttpBackend`.
 *
 * In an `HttpInterceptor`, the `HttpHandler` parameter is the next interceptor in the chain.
 *
 *
 */
var HttpHandler = /*@__PURE__*/ (function () {
    function HttpHandler() {
    }
    return HttpHandler;
}());
/**
 * A final `HttpHandler` which will dispatch the request via browser HTTP APIs to a backend.
 *
 * Interceptors sit between the `HttpClient` interface and the `HttpBackend`.
 *
 * When injected, `HttpBackend` dispatches requests directly to the backend, without going
 * through the interceptor chain.
 *
 *
 */
var HttpBackend = /*@__PURE__*/ (function () {
    function HttpBackend() {
    }
    return HttpBackend;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Immutable set of Http headers, with lazy parsing.
 *
 */
var http_HttpHeaders = /*@__PURE__*/ (function () {
    function HttpHeaders(headers) {
        var _this = this;
        /**
         * Internal map of lowercased header names to the normalized
         * form of the name (the form seen first).
         */
        this.normalizedNames = new Map();
        /**
         * Queued updates to be materialized the next initialization.
         */
        this.lazyUpdate = null;
        if (!headers) {
            this.headers = new Map();
        }
        else if (typeof headers === 'string') {
            this.lazyInit = function () {
                _this.headers = new Map();
                headers.split('\n').forEach(function (line) {
                    var index = line.indexOf(':');
                    if (index > 0) {
                        var name_1 = line.slice(0, index);
                        var key = name_1.toLowerCase();
                        var value = line.slice(index + 1).trim();
                        _this.maybeSetNormalizedName(name_1, key);
                        if (_this.headers.has(key)) {
                            _this.headers.get(key).push(value);
                        }
                        else {
                            _this.headers.set(key, [value]);
                        }
                    }
                });
            };
        }
        else {
            this.lazyInit = function () {
                _this.headers = new Map();
                Object.keys(headers).forEach(function (name) {
                    var values = headers[name];
                    var key = name.toLowerCase();
                    if (typeof values === 'string') {
                        values = [values];
                    }
                    if (values.length > 0) {
                        _this.headers.set(key, values);
                        _this.maybeSetNormalizedName(name, key);
                    }
                });
            };
        }
    }
    /**
     * Checks for existence of header by given name.
     */
    HttpHeaders.prototype.has = function (name) {
        this.init();
        return this.headers.has(name.toLowerCase());
    };
    /**
     * Returns first header that matches given name.
     */
    HttpHeaders.prototype.get = function (name) {
        this.init();
        var values = this.headers.get(name.toLowerCase());
        return values && values.length > 0 ? values[0] : null;
    };
    /**
     * Returns the names of the headers
     */
    HttpHeaders.prototype.keys = function () {
        this.init();
        return Array.from(this.normalizedNames.values());
    };
    /**
     * Returns list of header values for a given name.
     */
    HttpHeaders.prototype.getAll = function (name) {
        this.init();
        return this.headers.get(name.toLowerCase()) || null;
    };
    HttpHeaders.prototype.append = function (name, value) {
        return this.clone({ name: name, value: value, op: 'a' });
    };
    HttpHeaders.prototype.set = function (name, value) {
        return this.clone({ name: name, value: value, op: 's' });
    };
    HttpHeaders.prototype.delete = function (name, value) {
        return this.clone({ name: name, value: value, op: 'd' });
    };
    HttpHeaders.prototype.maybeSetNormalizedName = function (name, lcName) {
        if (!this.normalizedNames.has(lcName)) {
            this.normalizedNames.set(lcName, name);
        }
    };
    HttpHeaders.prototype.init = function () {
        var _this = this;
        if (!!this.lazyInit) {
            if (this.lazyInit instanceof HttpHeaders) {
                this.copyFrom(this.lazyInit);
            }
            else {
                this.lazyInit();
            }
            this.lazyInit = null;
            if (!!this.lazyUpdate) {
                this.lazyUpdate.forEach(function (update) { return _this.applyUpdate(update); });
                this.lazyUpdate = null;
            }
        }
    };
    HttpHeaders.prototype.copyFrom = function (other) {
        var _this = this;
        other.init();
        Array.from(other.headers.keys()).forEach(function (key) {
            _this.headers.set(key, other.headers.get(key));
            _this.normalizedNames.set(key, other.normalizedNames.get(key));
        });
    };
    HttpHeaders.prototype.clone = function (update) {
        var clone = new HttpHeaders();
        clone.lazyInit =
            (!!this.lazyInit && this.lazyInit instanceof HttpHeaders) ? this.lazyInit : this;
        clone.lazyUpdate = (this.lazyUpdate || []).concat([update]);
        return clone;
    };
    HttpHeaders.prototype.applyUpdate = function (update) {
        var key = update.name.toLowerCase();
        switch (update.op) {
            case 'a':
            case 's':
                var value = update.value;
                if (typeof value === 'string') {
                    value = [value];
                }
                if (value.length === 0) {
                    return;
                }
                this.maybeSetNormalizedName(update.name, key);
                var base = (update.op === 'a' ? this.headers.get(key) : undefined) || [];
                base.push.apply(base, Object(tslib_es6["__spread"])(value));
                this.headers.set(key, base);
                break;
            case 'd':
                var toDelete_1 = update.value;
                if (!toDelete_1) {
                    this.headers.delete(key);
                    this.normalizedNames.delete(key);
                }
                else {
                    var existing = this.headers.get(key);
                    if (!existing) {
                        return;
                    }
                    existing = existing.filter(function (value) { return toDelete_1.indexOf(value) === -1; });
                    if (existing.length === 0) {
                        this.headers.delete(key);
                        this.normalizedNames.delete(key);
                    }
                    else {
                        this.headers.set(key, existing);
                    }
                }
                break;
        }
    };
    /**
     * @internal
     */
    HttpHeaders.prototype.forEach = function (fn) {
        var _this = this;
        this.init();
        Array.from(this.normalizedNames.keys())
            .forEach(function (key) { return fn(_this.normalizedNames.get(key), _this.headers.get(key)); });
    };
    return HttpHeaders;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A `HttpParameterCodec` that uses `encodeURIComponent` and `decodeURIComponent` to
 * serialize and parse URL parameter keys and values.
 *
 *
 */
var HttpUrlEncodingCodec = /*@__PURE__*/ (function () {
    function HttpUrlEncodingCodec() {
    }
    HttpUrlEncodingCodec.prototype.encodeKey = function (key) { return standardEncoding(key); };
    HttpUrlEncodingCodec.prototype.encodeValue = function (value) { return standardEncoding(value); };
    HttpUrlEncodingCodec.prototype.decodeKey = function (key) { return decodeURIComponent(key); };
    HttpUrlEncodingCodec.prototype.decodeValue = function (value) { return decodeURIComponent(value); };
    return HttpUrlEncodingCodec;
}());
function paramParser(rawParams, codec) {
    var map$$1 = new Map();
    if (rawParams.length > 0) {
        var params = rawParams.split('&');
        params.forEach(function (param) {
            var eqIdx = param.indexOf('=');
            var _a = Object(tslib_es6["__read"])(eqIdx == -1 ?
                [codec.decodeKey(param), ''] :
                [codec.decodeKey(param.slice(0, eqIdx)), codec.decodeValue(param.slice(eqIdx + 1))], 2), key = _a[0], val = _a[1];
            var list = map$$1.get(key) || [];
            list.push(val);
            map$$1.set(key, list);
        });
    }
    return map$$1;
}
function standardEncoding(v) {
    return encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%2B/gi, '+')
        .replace(/%3D/gi, '=')
        .replace(/%3F/gi, '?')
        .replace(/%2F/gi, '/');
}
/**
 * An HTTP request/response body that represents serialized parameters,
 * per the MIME type `application/x-www-form-urlencoded`.
 *
 * This class is immutable - all mutation operations return a new instance.
 *
 *
 */
var HttpParams = /*@__PURE__*/ (function () {
    function HttpParams(options) {
        if (options === void 0) {
            options = {};
        }
        var _this = this;
        this.updates = null;
        this.cloneFrom = null;
        this.encoder = options.encoder || new HttpUrlEncodingCodec();
        if (!!options.fromString) {
            if (!!options.fromObject) {
                throw new Error("Cannot specify both fromString and fromObject.");
            }
            this.map = paramParser(options.fromString, this.encoder);
        }
        else if (!!options.fromObject) {
            this.map = new Map();
            Object.keys(options.fromObject).forEach(function (key) {
                var value = options.fromObject[key];
                _this.map.set(key, Array.isArray(value) ? value : [value]);
            });
        }
        else {
            this.map = null;
        }
    }
    /**
     * Check whether the body has one or more values for the given parameter name.
     */
    HttpParams.prototype.has = function (param) {
        this.init();
        return this.map.has(param);
    };
    /**
     * Get the first value for the given parameter name, or `null` if it's not present.
     */
    HttpParams.prototype.get = function (param) {
        this.init();
        var res = this.map.get(param);
        return !!res ? res[0] : null;
    };
    /**
     * Get all values for the given parameter name, or `null` if it's not present.
     */
    HttpParams.prototype.getAll = function (param) {
        this.init();
        return this.map.get(param) || null;
    };
    /**
     * Get all the parameter names for this body.
     */
    HttpParams.prototype.keys = function () {
        this.init();
        return Array.from(this.map.keys());
    };
    /**
     * Construct a new body with an appended value for the given parameter name.
     */
    HttpParams.prototype.append = function (param, value) { return this.clone({ param: param, value: value, op: 'a' }); };
    /**
     * Construct a new body with a new value for the given parameter name.
     */
    HttpParams.prototype.set = function (param, value) { return this.clone({ param: param, value: value, op: 's' }); };
    /**
     * Construct a new body with either the given value for the given parameter
     * removed, if a value is given, or all values for the given parameter removed
     * if not.
     */
    HttpParams.prototype.delete = function (param, value) { return this.clone({ param: param, value: value, op: 'd' }); };
    /**
     * Serialize the body to an encoded string, where key-value pairs (separated by `=`) are
     * separated by `&`s.
     */
    HttpParams.prototype.toString = function () {
        var _this = this;
        this.init();
        return this.keys()
            .map(function (key) {
            var eKey = _this.encoder.encodeKey(key);
            return _this.map.get(key).map(function (value) { return eKey + '=' + _this.encoder.encodeValue(value); })
                .join('&');
        })
            .join('&');
    };
    HttpParams.prototype.clone = function (update) {
        var clone = new HttpParams({ encoder: this.encoder });
        clone.cloneFrom = this.cloneFrom || this;
        clone.updates = (this.updates || []).concat([update]);
        return clone;
    };
    HttpParams.prototype.init = function () {
        var _this = this;
        if (this.map === null) {
            this.map = new Map();
        }
        if (this.cloneFrom !== null) {
            this.cloneFrom.init();
            this.cloneFrom.keys().forEach(function (key) { return _this.map.set(key, _this.cloneFrom.map.get(key)); });
            this.updates.forEach(function (update) {
                switch (update.op) {
                    case 'a':
                    case 's':
                        var base = (update.op === 'a' ? _this.map.get(update.param) : undefined) || [];
                        base.push(update.value);
                        _this.map.set(update.param, base);
                        break;
                    case 'd':
                        if (update.value !== undefined) {
                            var base_1 = _this.map.get(update.param) || [];
                            var idx = base_1.indexOf(update.value);
                            if (idx !== -1) {
                                base_1.splice(idx, 1);
                            }
                            if (base_1.length > 0) {
                                _this.map.set(update.param, base_1);
                            }
                            else {
                                _this.map.delete(update.param);
                            }
                        }
                        else {
                            _this.map.delete(update.param);
                            break;
                        }
                }
            });
            this.cloneFrom = null;
        }
    };
    return HttpParams;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Determine whether the given HTTP method may include a body.
 */
function mightHaveBody(method) {
    switch (method) {
        case 'DELETE':
        case 'GET':
        case 'HEAD':
        case 'OPTIONS':
        case 'JSONP':
            return false;
        default:
            return true;
    }
}
/**
 * Safely assert whether the given value is an ArrayBuffer.
 *
 * In some execution environments ArrayBuffer is not defined.
 */
function isArrayBuffer(value) {
    return typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer;
}
/**
 * Safely assert whether the given value is a Blob.
 *
 * In some execution environments Blob is not defined.
 */
function isBlob(value) {
    return typeof Blob !== 'undefined' && value instanceof Blob;
}
/**
 * Safely assert whether the given value is a FormData instance.
 *
 * In some execution environments FormData is not defined.
 */
function isFormData(value) {
    return typeof FormData !== 'undefined' && value instanceof FormData;
}
/**
 * An outgoing HTTP request with an optional typed body.
 *
 * `HttpRequest` represents an outgoing request, including URL, method,
 * headers, body, and other request configuration options. Instances should be
 * assumed to be immutable. To modify a `HttpRequest`, the `clone`
 * method should be used.
 *
 *
 */
var HttpRequest = /*@__PURE__*/ (function () {
    function HttpRequest(method, url, third, fourth) {
        this.url = url;
        /**
         * The request body, or `null` if one isn't set.
         *
         * Bodies are not enforced to be immutable, as they can include a reference to any
         * user-defined data type. However, interceptors should take care to preserve
         * idempotence by treating them as such.
         */
        this.body = null;
        /**
         * Whether this request should be made in a way that exposes progress events.
         *
         * Progress events are expensive (change detection runs on each event) and so
         * they should only be requested if the consumer intends to monitor them.
         */
        this.reportProgress = false;
        /**
         * Whether this request should be sent with outgoing credentials (cookies).
         */
        this.withCredentials = false;
        /**
         * The expected response type of the server.
         *
         * This is used to parse the response appropriately before returning it to
         * the requestee.
         */
        this.responseType = 'json';
        this.method = method.toUpperCase();
        // Next, need to figure out which argument holds the HttpRequestInit
        // options, if any.
        var options;
        // Check whether a body argument is expected. The only valid way to omit
        // the body argument is to use a known no-body method like GET.
        if (mightHaveBody(this.method) || !!fourth) {
            // Body is the third argument, options are the fourth.
            this.body = (third !== undefined) ? third : null;
            options = fourth;
        }
        else {
            // No body required, options are the third argument. The body stays null.
            options = third;
        }
        // If options have been passed, interpret them.
        if (options) {
            // Normalize reportProgress and withCredentials.
            this.reportProgress = !!options.reportProgress;
            this.withCredentials = !!options.withCredentials;
            // Override default response type of 'json' if one is provided.
            if (!!options.responseType) {
                this.responseType = options.responseType;
            }
            // Override headers if they're provided.
            if (!!options.headers) {
                this.headers = options.headers;
            }
            if (!!options.params) {
                this.params = options.params;
            }
        }
        // If no headers have been passed in, construct a new HttpHeaders instance.
        if (!this.headers) {
            this.headers = new http_HttpHeaders();
        }
        // If no parameters have been passed in, construct a new HttpUrlEncodedParams instance.
        if (!this.params) {
            this.params = new HttpParams();
            this.urlWithParams = url;
        }
        else {
            // Encode the parameters to a string in preparation for inclusion in the URL.
            var params = this.params.toString();
            if (params.length === 0) {
                // No parameters, the visible URL is just the URL given at creation time.
                this.urlWithParams = url;
            }
            else {
                // Does the URL already have query parameters? Look for '?'.
                var qIdx = url.indexOf('?');
                // There are 3 cases to handle:
                // 1) No existing parameters -> append '?' followed by params.
                // 2) '?' exists and is followed by existing query string ->
                //    append '&' followed by params.
                // 3) '?' exists at the end of the url -> append params directly.
                // This basically amounts to determining the character, if any, with
                // which to join the URL and parameters.
                var sep = qIdx === -1 ? '?' : (qIdx < url.length - 1 ? '&' : '');
                this.urlWithParams = url + sep + params;
            }
        }
    }
    /**
     * Transform the free-form body into a serialized format suitable for
     * transmission to the server.
     */
    HttpRequest.prototype.serializeBody = function () {
        // If no body is present, no need to serialize it.
        if (this.body === null) {
            return null;
        }
        // Check whether the body is already in a serialized form. If so,
        // it can just be returned directly.
        if (isArrayBuffer(this.body) || isBlob(this.body) || isFormData(this.body) ||
            typeof this.body === 'string') {
            return this.body;
        }
        // Check whether the body is an instance of HttpUrlEncodedParams.
        if (this.body instanceof HttpParams) {
            return this.body.toString();
        }
        // Check whether the body is an object or array, and serialize with JSON if so.
        if (typeof this.body === 'object' || typeof this.body === 'boolean' ||
            Array.isArray(this.body)) {
            return JSON.stringify(this.body);
        }
        // Fall back on toString() for everything else.
        return this.body.toString();
    };
    /**
     * Examine the body and attempt to infer an appropriate MIME type
     * for it.
     *
     * If no such type can be inferred, this method will return `null`.
     */
    HttpRequest.prototype.detectContentTypeHeader = function () {
        // An empty body has no content type.
        if (this.body === null) {
            return null;
        }
        // FormData bodies rely on the browser's content type assignment.
        if (isFormData(this.body)) {
            return null;
        }
        // Blobs usually have their own content type. If it doesn't, then
        // no type can be inferred.
        if (isBlob(this.body)) {
            return this.body.type || null;
        }
        // Array buffers have unknown contents and thus no type can be inferred.
        if (isArrayBuffer(this.body)) {
            return null;
        }
        // Technically, strings could be a form of JSON data, but it's safe enough
        // to assume they're plain strings.
        if (typeof this.body === 'string') {
            return 'text/plain';
        }
        // `HttpUrlEncodedParams` has its own content-type.
        if (this.body instanceof HttpParams) {
            return 'application/x-www-form-urlencoded;charset=UTF-8';
        }
        // Arrays, objects, and numbers will be encoded as JSON.
        if (typeof this.body === 'object' || typeof this.body === 'number' ||
            Array.isArray(this.body)) {
            return 'application/json';
        }
        // No type could be inferred.
        return null;
    };
    HttpRequest.prototype.clone = function (update) {
        if (update === void 0) {
            update = {};
        }
        // For method, url, and responseType, take the current value unless
        // it is overridden in the update hash.
        var method = update.method || this.method;
        var url = update.url || this.url;
        var responseType = update.responseType || this.responseType;
        // The body is somewhat special - a `null` value in update.body means
        // whatever current body is present is being overridden with an empty
        // body, whereas an `undefined` value in update.body implies no
        // override.
        var body = (update.body !== undefined) ? update.body : this.body;
        // Carefully handle the boolean options to differentiate between
        // `false` and `undefined` in the update args.
        var withCredentials = (update.withCredentials !== undefined) ? update.withCredentials : this.withCredentials;
        var reportProgress = (update.reportProgress !== undefined) ? update.reportProgress : this.reportProgress;
        // Headers and params may be appended to if `setHeaders` or
        // `setParams` are used.
        var headers = update.headers || this.headers;
        var params = update.params || this.params;
        // Check whether the caller has asked to add headers.
        if (update.setHeaders !== undefined) {
            // Set every requested header.
            headers =
                Object.keys(update.setHeaders)
                    .reduce(function (headers, name) { return headers.set(name, update.setHeaders[name]); }, headers);
        }
        // Check whether the caller has asked to set params.
        if (update.setParams) {
            // Set every requested param.
            params = Object.keys(update.setParams)
                .reduce(function (params, param) { return params.set(param, update.setParams[param]); }, params);
        }
        // Finally, construct the new HttpRequest using the pieces from above.
        return new HttpRequest(method, url, body, {
            params: params, headers: headers, reportProgress: reportProgress, responseType: responseType, withCredentials: withCredentials,
        });
    };
    return HttpRequest;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Type enumeration for the different kinds of `HttpEvent`.
 *
 *
 */
var HttpEventType;
/*@__PURE__*/ (function (HttpEventType) {
    /**
     * The request was sent out over the wire.
     */
    HttpEventType[HttpEventType["Sent"] = 0] = "Sent";
    /**
     * An upload progress event was received.
     */
    HttpEventType[HttpEventType["UploadProgress"] = 1] = "UploadProgress";
    /**
     * The response status code and headers were received.
     */
    HttpEventType[HttpEventType["ResponseHeader"] = 2] = "ResponseHeader";
    /**
     * A download progress event was received.
     */
    HttpEventType[HttpEventType["DownloadProgress"] = 3] = "DownloadProgress";
    /**
     * The full response including the body was received.
     */
    HttpEventType[HttpEventType["Response"] = 4] = "Response";
    /**
     * A custom event from an interceptor or a backend.
     */
    HttpEventType[HttpEventType["User"] = 5] = "User";
})(HttpEventType || (HttpEventType = {}));
/**
 * Base class for both `HttpResponse` and `HttpHeaderResponse`.
 *
 *
 */
var HttpResponseBase = /*@__PURE__*/ (function () {
    /**
     * Super-constructor for all responses.
     *
     * The single parameter accepted is an initialization hash. Any properties
     * of the response passed there will override the default values.
     */
    function HttpResponseBase(init, defaultStatus, defaultStatusText) {
        if (defaultStatus === void 0) {
            defaultStatus = 200;
        }
        if (defaultStatusText === void 0) {
            defaultStatusText = 'OK';
        }
        // If the hash has values passed, use them to initialize the response.
        // Otherwise use the default values.
        this.headers = init.headers || new http_HttpHeaders();
        this.status = init.status !== undefined ? init.status : defaultStatus;
        this.statusText = init.statusText || defaultStatusText;
        this.url = init.url || null;
        // Cache the ok value to avoid defining a getter.
        this.ok = this.status >= 200 && this.status < 300;
    }
    return HttpResponseBase;
}());
/**
 * A partial HTTP response which only includes the status and header data,
 * but no response body.
 *
 * `HttpHeaderResponse` is a `HttpEvent` available on the response
 * event stream, only when progress events are requested.
 *
 *
 */
var http_HttpHeaderResponse = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(HttpHeaderResponse, _super);
    /**
     * Create a new `HttpHeaderResponse` with the given parameters.
     */
    function HttpHeaderResponse(init) {
        if (init === void 0) {
            init = {};
        }
        var _this = _super.call(this, init) || this;
        _this.type = HttpEventType.ResponseHeader;
        return _this;
    }
    /**
     * Copy this `HttpHeaderResponse`, overriding its contents with the
     * given parameter hash.
     */
    HttpHeaderResponse.prototype.clone = function (update) {
        if (update === void 0) {
            update = {};
        }
        // Perform a straightforward initialization of the new HttpHeaderResponse,
        // overriding the current parameters with new ones if given.
        return new HttpHeaderResponse({
            headers: update.headers || this.headers,
            status: update.status !== undefined ? update.status : this.status,
            statusText: update.statusText || this.statusText,
            url: update.url || this.url || undefined,
        });
    };
    return HttpHeaderResponse;
}(HttpResponseBase));
/**
 * A full HTTP response, including a typed response body (which may be `null`
 * if one was not returned).
 *
 * `HttpResponse` is a `HttpEvent` available on the response event
 * stream.
 *
 *
 */
var http_HttpResponse = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(HttpResponse, _super);
    /**
     * Construct a new `HttpResponse`.
     */
    function HttpResponse(init) {
        if (init === void 0) {
            init = {};
        }
        var _this = _super.call(this, init) || this;
        _this.type = HttpEventType.Response;
        _this.body = init.body !== undefined ? init.body : null;
        return _this;
    }
    HttpResponse.prototype.clone = function (update) {
        if (update === void 0) {
            update = {};
        }
        return new HttpResponse({
            body: (update.body !== undefined) ? update.body : this.body,
            headers: update.headers || this.headers,
            status: (update.status !== undefined) ? update.status : this.status,
            statusText: update.statusText || this.statusText,
            url: update.url || this.url || undefined,
        });
    };
    return HttpResponse;
}(HttpResponseBase));
/**
 * A response that represents an error or failure, either from a
 * non-successful HTTP status, an error while executing the request,
 * or some other failure which occurred during the parsing of the response.
 *
 * Any error returned on the `Observable` response stream will be
 * wrapped in an `HttpErrorResponse` to provide additional context about
 * the state of the HTTP layer when the error occurred. The error property
 * will contain either a wrapped Error object or the error response returned
 * from the server.
 *
 *
 */
var http_HttpErrorResponse = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(HttpErrorResponse, _super);
    function HttpErrorResponse(init) {
        var _this = 
        // Initialize with a default status of 0 / Unknown Error.
        _super.call(this, init, 0, 'Unknown Error') || this;
        _this.name = 'HttpErrorResponse';
        /**
         * Errors are never okay, even when the status code is in the 2xx success range.
         */
        _this.ok = false;
        // If the response was successful, then this was a parse error. Otherwise, it was
        // a protocol-level failure of some sort. Either the request failed in transit
        // or the server returned an unsuccessful status code.
        if (_this.status >= 200 && _this.status < 300) {
            _this.message = "Http failure during parsing for " + (init.url || '(unknown url)');
        }
        else {
            _this.message =
                "Http failure response for " + (init.url || '(unknown url)') + ": " + init.status + " " + init.statusText;
        }
        _this.error = init.error || null;
        return _this;
    }
    return HttpErrorResponse;
}(HttpResponseBase));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Construct an instance of `HttpRequestOptions<T>` from a source `HttpMethodOptions` and
 * the given `body`. Basically, this clones the object and adds the body.
 */
function addBody(options, body) {
    return {
        body: body,
        headers: options.headers,
        observe: options.observe,
        params: options.params,
        reportProgress: options.reportProgress,
        responseType: options.responseType,
        withCredentials: options.withCredentials,
    };
}
/**
 * Perform HTTP requests.
 *
 * `HttpClient` is available as an injectable class, with methods to perform HTTP requests.
 * Each request method has multiple signatures, and the return type varies according to which
 * signature is called (mainly the values of `observe` and `responseType`).
 *
 *
 */
var http_HttpClient = /*@__PURE__*/ (function () {
    function HttpClient(handler) {
        this.handler = handler;
    }
    /**
     * Constructs an `Observable` for a particular HTTP request that, when subscribed,
     * fires the request through the chain of registered interceptors and on to the
     * server.
     *
     * This method can be called in one of two ways. Either an `HttpRequest`
     * instance can be passed directly as the only parameter, or a method can be
     * passed as the first parameter, a string URL as the second, and an
     * options hash as the third.
     *
     * If a `HttpRequest` object is passed directly, an `Observable` of the
     * raw `HttpEvent` stream will be returned.
     *
     * If a request is instead built by providing a URL, the options object
     * determines the return type of `request()`. In addition to configuring
     * request parameters such as the outgoing headers and/or the body, the options
     * hash specifies two key pieces of information about the request: the
     * `responseType` and what to `observe`.
     *
     * The `responseType` value determines how a successful response body will be
     * parsed. If `responseType` is the default `json`, a type interface for the
     * resulting object may be passed as a type parameter to `request()`.
     *
     * The `observe` value determines the return type of `request()`, based on what
     * the consumer is interested in observing. A value of `events` will return an
     * `Observable<HttpEvent>` representing the raw `HttpEvent` stream,
     * including progress events by default. A value of `response` will return an
     * `Observable<HttpResponse<T>>` where the `T` parameter of `HttpResponse`
     * depends on the `responseType` and any optionally provided type parameter.
     * A value of `body` will return an `Observable<T>` with the same `T` body type.
     */
    HttpClient.prototype.request = function (first, url, options) {
        var _this = this;
        if (options === void 0) {
            options = {};
        }
        var req;
        // Firstly, check whether the primary argument is an instance of `HttpRequest`.
        if (first instanceof HttpRequest) {
            // It is. The other arguments must be undefined (per the signatures) and can be
            // ignored.
            req = first;
        }
        else {
            // It's a string, so it represents a URL. Construct a request based on it,
            // and incorporate the remaining arguments (assuming GET unless a method is
            // provided.
            // Figure out the headers.
            var headers = undefined;
            if (options.headers instanceof http_HttpHeaders) {
                headers = options.headers;
            }
            else {
                headers = new http_HttpHeaders(options.headers);
            }
            // Sort out parameters.
            var params = undefined;
            if (!!options.params) {
                if (options.params instanceof HttpParams) {
                    params = options.params;
                }
                else {
                    params = new HttpParams({ fromObject: options.params });
                }
            }
            // Construct the request.
            req = new HttpRequest(first, url, (options.body !== undefined ? options.body : null), {
                headers: headers,
                params: params,
                reportProgress: options.reportProgress,
                // By default, JSON is assumed to be returned for all calls.
                responseType: options.responseType || 'json',
                withCredentials: options.withCredentials,
            });
        }
        // Start with an Observable.of() the initial request, and run the handler (which
        // includes all interceptors) inside a concatMap(). This way, the handler runs
        // inside an Observable chain, which causes interceptors to be re-run on every
        // subscription (this also makes retries re-run the handler, including interceptors).
        var events$ = Object(_esm5["x" /* of */])(req).pipe(Object(operators["concatMap"])(function (req) { return _this.handler.handle(req); }));
        // If coming via the API signature which accepts a previously constructed HttpRequest,
        // the only option is to get the event stream. Otherwise, return the event stream if
        // that is what was requested.
        if (first instanceof HttpRequest || options.observe === 'events') {
            return events$;
        }
        // The requested stream contains either the full response or the body. In either
        // case, the first step is to filter the event stream to extract a stream of
        // responses(s).
        var res$ = events$.pipe(Object(operators["filter"])(function (event) { return event instanceof http_HttpResponse; }));
        // Decide which stream to return.
        switch (options.observe || 'body') {
            case 'body':
                // The requested stream is the body. Map the response stream to the response
                // body. This could be done more simply, but a misbehaving interceptor might
                // transform the response body into a different format and ignore the requested
                // responseType. Guard against this by validating that the response is of the
                // requested type.
                switch (req.responseType) {
                    case 'arraybuffer':
                        return res$.pipe(Object(operators["map"])(function (res) {
                            // Validate that the body is an ArrayBuffer.
                            if (res.body !== null && !(res.body instanceof ArrayBuffer)) {
                                throw new Error('Response is not an ArrayBuffer.');
                            }
                            return res.body;
                        }));
                    case 'blob':
                        return res$.pipe(Object(operators["map"])(function (res) {
                            // Validate that the body is a Blob.
                            if (res.body !== null && !(res.body instanceof Blob)) {
                                throw new Error('Response is not a Blob.');
                            }
                            return res.body;
                        }));
                    case 'text':
                        return res$.pipe(Object(operators["map"])(function (res) {
                            // Validate that the body is a string.
                            if (res.body !== null && typeof res.body !== 'string') {
                                throw new Error('Response is not a string.');
                            }
                            return res.body;
                        }));
                    case 'json':
                    default:
                        // No validation needed for JSON responses, as they can be of any type.
                        return res$.pipe(Object(operators["map"])(function (res) { return res.body; }));
                }
            case 'response':
                // The response stream was requested directly, so return it.
                return res$;
            default:
                // Guard against new future observe types being added.
                throw new Error("Unreachable: unhandled observe type " + options.observe + "}");
        }
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * DELETE request to be executed on the server. See the individual overloads for
     * details of `delete()`'s return type based on the provided options.
     */
    HttpClient.prototype.delete = function (url, options) {
        if (options === void 0) {
            options = {};
        }
        return this.request('DELETE', url, options);
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * GET request to be executed on the server. See the individual overloads for
     * details of `get()`'s return type based on the provided options.
     */
    HttpClient.prototype.get = function (url, options) {
        if (options === void 0) {
            options = {};
        }
        return this.request('GET', url, options);
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * HEAD request to be executed on the server. See the individual overloads for
     * details of `head()`'s return type based on the provided options.
     */
    HttpClient.prototype.head = function (url, options) {
        if (options === void 0) {
            options = {};
        }
        return this.request('HEAD', url, options);
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause a request
     * with the special method `JSONP` to be dispatched via the interceptor pipeline.
     *
     * A suitable interceptor must be installed (e.g. via the `HttpClientJsonpModule`).
     * If no such interceptor is reached, then the `JSONP` request will likely be
     * rejected by the configured backend.
     */
    HttpClient.prototype.jsonp = function (url, callbackParam) {
        return this.request('JSONP', url, {
            params: new HttpParams().append(callbackParam, 'JSONP_CALLBACK'),
            observe: 'body',
            responseType: 'json',
        });
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * OPTIONS request to be executed on the server. See the individual overloads for
     * details of `options()`'s return type based on the provided options.
     */
    HttpClient.prototype.options = function (url, options) {
        if (options === void 0) {
            options = {};
        }
        return this.request('OPTIONS', url, options);
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * PATCH request to be executed on the server. See the individual overloads for
     * details of `patch()`'s return type based on the provided options.
     */
    HttpClient.prototype.patch = function (url, body, options) {
        if (options === void 0) {
            options = {};
        }
        return this.request('PATCH', url, addBody(options, body));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * POST request to be executed on the server. See the individual overloads for
     * details of `post()`'s return type based on the provided options.
     */
    HttpClient.prototype.post = function (url, body, options) {
        if (options === void 0) {
            options = {};
        }
        return this.request('POST', url, addBody(options, body));
    };
    /**
     * Constructs an `Observable` which, when subscribed, will cause the configured
     * PUT request to be executed on the server. See the individual overloads for
     * details of `put()`'s return type based on the provided options.
     */
    HttpClient.prototype.put = function (url, body, options) {
        if (options === void 0) {
            options = {};
        }
        return this.request('PUT', url, addBody(options, body));
    };
    return HttpClient;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * `HttpHandler` which applies an `HttpInterceptor` to an `HttpRequest`.
 *
 *
 */
var HttpInterceptorHandler = /*@__PURE__*/ (function () {
    function HttpInterceptorHandler(next, interceptor) {
        this.next = next;
        this.interceptor = interceptor;
    }
    HttpInterceptorHandler.prototype.handle = function (req) {
        return this.interceptor.intercept(req, this.next);
    };
    return HttpInterceptorHandler;
}());
/**
 * A multi-provider token which represents the array of `HttpInterceptor`s that
 * are registered.
 *
 *
 */
var HTTP_INTERCEPTORS = /*@__PURE__*/ new core["InjectionToken"]('HTTP_INTERCEPTORS');
var NoopInterceptor = /*@__PURE__*/ (function () {
    function NoopInterceptor() {
    }
    NoopInterceptor.prototype.intercept = function (req, next) {
        return next.handle(req);
    };
    return NoopInterceptor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Every request made through JSONP needs a callback name that's unique across the
// whole page. Each request is assigned an id and the callback name is constructed
// from that. The next id to be assigned is tracked in a global variable here that
// is shared among all applications on the page.
var nextRequestId = 0;
// Error text given when a JSONP script is injected, but doesn't invoke the callback
// passed in its URL.
var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
// Error text given when a request is passed to the JsonpClientBackend that doesn't
// have a request method JSONP.
var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use JSONP request method.';
var JSONP_ERR_WRONG_RESPONSE_TYPE = 'JSONP requests must use Json response type.';
/**
 * DI token/abstract type representing a map of JSONP callbacks.
 *
 * In the browser, this should always be the `window` object.
 *
 *
 */
var JsonpCallbackContext = /*@__PURE__*/ (function () {
    function JsonpCallbackContext() {
    }
    return JsonpCallbackContext;
}());
/**
 * `HttpBackend` that only processes `HttpRequest` with the JSONP method,
 * by performing JSONP style requests.
 *
 *
 */
var http_JsonpClientBackend = /*@__PURE__*/ (function () {
    function JsonpClientBackend(callbackMap, document) {
        this.callbackMap = callbackMap;
        this.document = document;
    }
    /**
     * Get the name of the next callback method, by incrementing the global `nextRequestId`.
     */
    JsonpClientBackend.prototype.nextCallback = function () { return "ng_jsonp_callback_" + nextRequestId++; };
    /**
     * Process a JSONP request and return an event stream of the results.
     */
    JsonpClientBackend.prototype.handle = function (req) {
        var _this = this;
        // Firstly, check both the method and response type. If either doesn't match
        // then the request was improperly routed here and cannot be handled.
        if (req.method !== 'JSONP') {
            throw new Error(JSONP_ERR_WRONG_METHOD);
        }
        else if (req.responseType !== 'json') {
            throw new Error(JSONP_ERR_WRONG_RESPONSE_TYPE);
        }
        // Everything else happens inside the Observable boundary.
        return new _esm5["d" /* Observable */](function (observer) {
            // The first step to make a request is to generate the callback name, and replace the
            // callback placeholder in the URL with the name. Care has to be taken here to ensure
            // a trailing &, if matched, gets inserted back into the URL in the correct place.
            var callback = _this.nextCallback();
            var url = req.urlWithParams.replace(/=JSONP_CALLBACK(&|$)/, "=" + callback + "$1");
            // Construct the <script> tag and point it at the URL.
            var node = _this.document.createElement('script');
            node.src = url;
            // A JSONP request requires waiting for multiple callbacks. These variables
            // are closed over and track state across those callbacks.
            // The response object, if one has been received, or null otherwise.
            var body = null;
            // Whether the response callback has been called.
            var finished = false;
            // Whether the request has been cancelled (and thus any other callbacks)
            // should be ignored.
            var cancelled = false;
            // Set the response callback in this.callbackMap (which will be the window
            // object in the browser. The script being loaded via the <script> tag will
            // eventually call this callback.
            _this.callbackMap[callback] = function (data) {
                // Data has been received from the JSONP script. Firstly, delete this callback.
                delete _this.callbackMap[callback];
                // Next, make sure the request wasn't cancelled in the meantime.
                if (cancelled) {
                    return;
                }
                // Set state to indicate data was received.
                body = data;
                finished = true;
            };
            // cleanup() is a utility closure that removes the <script> from the page and
            // the response callback from the window. This logic is used in both the
            // success, error, and cancellation paths, so it's extracted out for convenience.
            var cleanup = function () {
                // Remove the <script> tag if it's still on the page.
                if (node.parentNode) {
                    node.parentNode.removeChild(node);
                }
                // Remove the response callback from the callbackMap (window object in the
                // browser).
                delete _this.callbackMap[callback];
            };
            // onLoad() is the success callback which runs after the response callback
            // if the JSONP script loads successfully. The event itself is unimportant.
            // If something went wrong, onLoad() may run without the response callback
            // having been invoked.
            var onLoad = function (event) {
                // Do nothing if the request has been cancelled.
                if (cancelled) {
                    return;
                }
                // Cleanup the page.
                cleanup();
                // Check whether the response callback has run.
                if (!finished) {
                    // It hasn't, something went wrong with the request. Return an error via
                    // the Observable error path. All JSONP errors have status 0.
                    observer.error(new http_HttpErrorResponse({
                        url: url,
                        status: 0,
                        statusText: 'JSONP Error',
                        error: new Error(JSONP_ERR_NO_CALLBACK),
                    }));
                    return;
                }
                // Success. body either contains the response body or null if none was
                // returned.
                observer.next(new http_HttpResponse({
                    body: body,
                    status: 200,
                    statusText: 'OK', url: url,
                }));
                // Complete the stream, the response is over.
                observer.complete();
            };
            // onError() is the error callback, which runs if the script returned generates
            // a Javascript error. It emits the error via the Observable error channel as
            // a HttpErrorResponse.
            var onError = function (error) {
                // If the request was already cancelled, no need to emit anything.
                if (cancelled) {
                    return;
                }
                cleanup();
                // Wrap the error in a HttpErrorResponse.
                observer.error(new http_HttpErrorResponse({
                    error: error,
                    status: 0,
                    statusText: 'JSONP Error', url: url,
                }));
            };
            // Subscribe to both the success (load) and error events on the <script> tag,
            // and add it to the page.
            node.addEventListener('load', onLoad);
            node.addEventListener('error', onError);
            _this.document.body.appendChild(node);
            // The request has now been successfully sent.
            observer.next({ type: HttpEventType.Sent });
            // Cancellation handler.
            return function () {
                // Track the cancellation so event listeners won't do anything even if already scheduled.
                cancelled = true;
                // Remove the event listeners so they won't run if the events later fire.
                node.removeEventListener('load', onLoad);
                node.removeEventListener('error', onError);
                // And finally, clean up the page.
                cleanup();
            };
        });
    };
    JsonpClientBackend = Object(tslib_es6["__decorate"])([
        Object(tslib_es6["__param"])(1, Object(core["Inject"])(common["DOCUMENT"]))
    ], JsonpClientBackend);
    return JsonpClientBackend;
}());
/**
 * An `HttpInterceptor` which identifies requests with the method JSONP and
 * shifts them to the `JsonpClientBackend`.
 *
 *
 */
var JsonpInterceptor = /*@__PURE__*/ (function () {
    function JsonpInterceptor(jsonp) {
        this.jsonp = jsonp;
    }
    JsonpInterceptor.prototype.intercept = function (req, next) {
        if (req.method === 'JSONP') {
            return this.jsonp.handle(req);
        }
        // Fall through for normal HTTP requests.
        return next.handle(req);
    };
    return JsonpInterceptor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XSSI_PREFIX = /^\)\]\}',?\n/;
/**
 * Determine an appropriate URL for the response, by checking either
 * XMLHttpRequest.responseURL or the X-Request-URL header.
 */
function getResponseUrl(xhr) {
    if ('responseURL' in xhr && xhr.responseURL) {
        return xhr.responseURL;
    }
    if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
        return xhr.getResponseHeader('X-Request-URL');
    }
    return null;
}
/**
 * A wrapper around the `XMLHttpRequest` constructor.
 *
 *
 */
var XhrFactory = /*@__PURE__*/ (function () {
    function XhrFactory() {
    }
    return XhrFactory;
}());
/**
 * A factory for @{link HttpXhrBackend} that uses the `XMLHttpRequest` browser API.
 *
 *
 */
var BrowserXhr = /*@__PURE__*/ (function () {
    function BrowserXhr() {
    }
    BrowserXhr.prototype.build = function () { return (new XMLHttpRequest()); };
    return BrowserXhr;
}());
/**
 * An `HttpBackend` which uses the XMLHttpRequest API to send
 * requests to a backend server.
 *
 *
 */
var http_HttpXhrBackend = /*@__PURE__*/ (function () {
    function HttpXhrBackend(xhrFactory) {
        this.xhrFactory = xhrFactory;
    }
    /**
     * Process a request and return a stream of response events.
     */
    HttpXhrBackend.prototype.handle = function (req) {
        var _this = this;
        // Quick check to give a better error message when a user attempts to use
        // HttpClient.jsonp() without installing the JsonpClientModule
        if (req.method === 'JSONP') {
            throw new Error("Attempted to construct Jsonp request without JsonpClientModule installed.");
        }
        // Everything happens on Observable subscription.
        return new _esm5["d" /* Observable */](function (observer) {
            // Start by setting up the XHR object with request method, URL, and withCredentials flag.
            var xhr = _this.xhrFactory.build();
            xhr.open(req.method, req.urlWithParams);
            if (!!req.withCredentials) {
                xhr.withCredentials = true;
            }
            // Add all the requested headers.
            req.headers.forEach(function (name, values) { return xhr.setRequestHeader(name, values.join(',')); });
            // Add an Accept header if one isn't present already.
            if (!req.headers.has('Accept')) {
                xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
            }
            // Auto-detect the Content-Type header if one isn't present already.
            if (!req.headers.has('Content-Type')) {
                var detectedType = req.detectContentTypeHeader();
                // Sometimes Content-Type detection fails.
                if (detectedType !== null) {
                    xhr.setRequestHeader('Content-Type', detectedType);
                }
            }
            // Set the responseType if one was requested.
            if (req.responseType) {
                var responseType = req.responseType.toLowerCase();
                // JSON responses need to be processed as text. This is because if the server
                // returns an XSSI-prefixed JSON response, the browser will fail to parse it,
                // xhr.response will be null, and xhr.responseText cannot be accessed to
                // retrieve the prefixed JSON data in order to strip the prefix. Thus, all JSON
                // is parsed by first requesting text and then applying JSON.parse.
                xhr.responseType = ((responseType !== 'json') ? responseType : 'text');
            }
            // Serialize the request body if one is present. If not, this will be set to null.
            var reqBody = req.serializeBody();
            // If progress events are enabled, response headers will be delivered
            // in two events - the HttpHeaderResponse event and the full HttpResponse
            // event. However, since response headers don't change in between these
            // two events, it doesn't make sense to parse them twice. So headerResponse
            // caches the data extracted from the response whenever it's first parsed,
            // to ensure parsing isn't duplicated.
            var headerResponse = null;
            // partialFromXhr extracts the HttpHeaderResponse from the current XMLHttpRequest
            // state, and memoizes it into headerResponse.
            var partialFromXhr = function () {
                if (headerResponse !== null) {
                    return headerResponse;
                }
                // Read status and normalize an IE9 bug (http://bugs.jquery.com/ticket/1450).
                var status = xhr.status === 1223 ? 204 : xhr.status;
                var statusText = xhr.statusText || 'OK';
                // Parse headers from XMLHttpRequest - this step is lazy.
                var headers = new http_HttpHeaders(xhr.getAllResponseHeaders());
                // Read the response URL from the XMLHttpResponse instance and fall back on the
                // request URL.
                var url = getResponseUrl(xhr) || req.url;
                // Construct the HttpHeaderResponse and memoize it.
                headerResponse = new http_HttpHeaderResponse({ headers: headers, status: status, statusText: statusText, url: url });
                return headerResponse;
            };
            // Next, a few closures are defined for the various events which XMLHttpRequest can
            // emit. This allows them to be unregistered as event listeners later.
            // First up is the load event, which represents a response being fully available.
            var onLoad = function () {
                // Read response state from the memoized partial data.
                var _a = partialFromXhr(), headers = _a.headers, status = _a.status, statusText = _a.statusText, url = _a.url;
                // The body will be read out if present.
                var body = null;
                if (status !== 204) {
                    // Use XMLHttpRequest.response if set, responseText otherwise.
                    body = (typeof xhr.response === 'undefined') ? xhr.responseText : xhr.response;
                }
                // Normalize another potential bug (this one comes from CORS).
                if (status === 0) {
                    status = !!body ? 200 : 0;
                }
                // ok determines whether the response will be transmitted on the event or
                // error channel. Unsuccessful status codes (not 2xx) will always be errors,
                // but a successful status code can still result in an error if the user
                // asked for JSON data and the body cannot be parsed as such.
                var ok = status >= 200 && status < 300;
                // Check whether the body needs to be parsed as JSON (in many cases the browser
                // will have done that already).
                if (req.responseType === 'json' && typeof body === 'string') {
                    // Save the original body, before attempting XSSI prefix stripping.
                    var originalBody = body;
                    body = body.replace(XSSI_PREFIX, '');
                    try {
                        // Attempt the parse. If it fails, a parse error should be delivered to the user.
                        body = body !== '' ? JSON.parse(body) : null;
                    }
                    catch (error) {
                        // Since the JSON.parse failed, it's reasonable to assume this might not have been a
                        // JSON response. Restore the original body (including any XSSI prefix) to deliver
                        // a better error response.
                        body = originalBody;
                        // If this was an error request to begin with, leave it as a string, it probably
                        // just isn't JSON. Otherwise, deliver the parsing error to the user.
                        if (ok) {
                            // Even though the response status was 2xx, this is still an error.
                            ok = false;
                            // The parse error contains the text of the body that failed to parse.
                            body = { error: error, text: body };
                        }
                    }
                }
                if (ok) {
                    // A successful response is delivered on the event stream.
                    observer.next(new http_HttpResponse({
                        body: body,
                        headers: headers,
                        status: status,
                        statusText: statusText,
                        url: url || undefined,
                    }));
                    // The full body has been received and delivered, no further events
                    // are possible. This request is complete.
                    observer.complete();
                }
                else {
                    // An unsuccessful request is delivered on the error channel.
                    observer.error(new http_HttpErrorResponse({
                        // The error in this case is the response body (error from the server).
                        error: body,
                        headers: headers,
                        status: status,
                        statusText: statusText,
                        url: url || undefined,
                    }));
                }
            };
            // The onError callback is called when something goes wrong at the network level.
            // Connection timeout, DNS error, offline, etc. These are actual errors, and are
            // transmitted on the error channel.
            var onError = function (error) {
                var res = new http_HttpErrorResponse({
                    error: error,
                    status: xhr.status || 0,
                    statusText: xhr.statusText || 'Unknown Error',
                });
                observer.error(res);
            };
            // The sentHeaders flag tracks whether the HttpResponseHeaders event
            // has been sent on the stream. This is necessary to track if progress
            // is enabled since the event will be sent on only the first download
            // progerss event.
            var sentHeaders = false;
            // The download progress event handler, which is only registered if
            // progress events are enabled.
            var onDownProgress = function (event) {
                // Send the HttpResponseHeaders event if it hasn't been sent already.
                if (!sentHeaders) {
                    observer.next(partialFromXhr());
                    sentHeaders = true;
                }
                // Start building the download progress event to deliver on the response
                // event stream.
                var progressEvent = {
                    type: HttpEventType.DownloadProgress,
                    loaded: event.loaded,
                };
                // Set the total number of bytes in the event if it's available.
                if (event.lengthComputable) {
                    progressEvent.total = event.total;
                }
                // If the request was for text content and a partial response is
                // available on XMLHttpRequest, include it in the progress event
                // to allow for streaming reads.
                if (req.responseType === 'text' && !!xhr.responseText) {
                    progressEvent.partialText = xhr.responseText;
                }
                // Finally, fire the event.
                observer.next(progressEvent);
            };
            // The upload progress event handler, which is only registered if
            // progress events are enabled.
            var onUpProgress = function (event) {
                // Upload progress events are simpler. Begin building the progress
                // event.
                var progress = {
                    type: HttpEventType.UploadProgress,
                    loaded: event.loaded,
                };
                // If the total number of bytes being uploaded is available, include
                // it.
                if (event.lengthComputable) {
                    progress.total = event.total;
                }
                // Send the event.
                observer.next(progress);
            };
            // By default, register for load and error events.
            xhr.addEventListener('load', onLoad);
            xhr.addEventListener('error', onError);
            // Progress events are only enabled if requested.
            if (req.reportProgress) {
                // Download progress is always enabled if requested.
                xhr.addEventListener('progress', onDownProgress);
                // Upload progress depends on whether there is a body to upload.
                if (reqBody !== null && xhr.upload) {
                    xhr.upload.addEventListener('progress', onUpProgress);
                }
            }
            // Fire the request, and notify the event stream that it was fired.
            xhr.send(reqBody);
            observer.next({ type: HttpEventType.Sent });
            // This is the return from the Observable function, which is the
            // request cancellation handler.
            return function () {
                // On a cancellation, remove all registered event listeners.
                xhr.removeEventListener('error', onError);
                xhr.removeEventListener('load', onLoad);
                if (req.reportProgress) {
                    xhr.removeEventListener('progress', onDownProgress);
                    if (reqBody !== null && xhr.upload) {
                        xhr.upload.removeEventListener('progress', onUpProgress);
                    }
                }
                // Finally, abort the in-flight request.
                xhr.abort();
            };
        });
    };
    return HttpXhrBackend;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XSRF_COOKIE_NAME = /*@__PURE__*/ new core["InjectionToken"]('XSRF_COOKIE_NAME');
var XSRF_HEADER_NAME = /*@__PURE__*/ new core["InjectionToken"]('XSRF_HEADER_NAME');
/**
 * Retrieves the current XSRF token to use with the next outgoing request.
 *
 *
 */
var HttpXsrfTokenExtractor = /*@__PURE__*/ (function () {
    function HttpXsrfTokenExtractor() {
    }
    return HttpXsrfTokenExtractor;
}());
/**
 * `HttpXsrfTokenExtractor` which retrieves the token from a cookie.
 */
var http_HttpXsrfCookieExtractor = /*@__PURE__*/ (function () {
    function HttpXsrfCookieExtractor(doc, platform, cookieName) {
        this.doc = doc;
        this.platform = platform;
        this.cookieName = cookieName;
        this.lastCookieString = '';
        this.lastToken = null;
        /**
         * @internal for testing
         */
        this.parseCount = 0;
    }
    HttpXsrfCookieExtractor.prototype.getToken = function () {
        if (this.platform === 'server') {
            return null;
        }
        var cookieString = this.doc.cookie || '';
        if (cookieString !== this.lastCookieString) {
            this.parseCount++;
            this.lastToken = Object(common["ɵparseCookieValue"])(cookieString, this.cookieName);
            this.lastCookieString = cookieString;
        }
        return this.lastToken;
    };
    HttpXsrfCookieExtractor = Object(tslib_es6["__decorate"])([
        Object(tslib_es6["__param"])(0, Object(core["Inject"])(common["DOCUMENT"])), Object(tslib_es6["__param"])(1, Object(core["Inject"])(core["PLATFORM_ID"])),
        Object(tslib_es6["__param"])(2, Object(core["Inject"])(XSRF_COOKIE_NAME))
    ], HttpXsrfCookieExtractor);
    return HttpXsrfCookieExtractor;
}());
/**
 * `HttpInterceptor` which adds an XSRF token to eligible outgoing requests.
 */
var http_HttpXsrfInterceptor = /*@__PURE__*/ (function () {
    function HttpXsrfInterceptor(tokenService, headerName) {
        this.tokenService = tokenService;
        this.headerName = headerName;
    }
    HttpXsrfInterceptor.prototype.intercept = function (req, next) {
        var lcUrl = req.url.toLowerCase();
        // Skip both non-mutating requests and absolute URLs.
        // Non-mutating requests don't require a token, and absolute URLs require special handling
        // anyway as the cookie set
        // on our origin is not the same as the token expected by another origin.
        if (req.method === 'GET' || req.method === 'HEAD' || lcUrl.startsWith('http://') ||
            lcUrl.startsWith('https://')) {
            return next.handle(req);
        }
        var token = this.tokenService.getToken();
        // Be careful not to overwrite an existing header of the same name.
        if (token !== null && !req.headers.has(this.headerName)) {
            req = req.clone({ headers: req.headers.set(this.headerName, token) });
        }
        return next.handle(req);
    };
    HttpXsrfInterceptor = Object(tslib_es6["__decorate"])([
        Object(tslib_es6["__param"])(1, Object(core["Inject"])(XSRF_HEADER_NAME))
    ], HttpXsrfInterceptor);
    return HttpXsrfInterceptor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An injectable `HttpHandler` that applies multiple interceptors
 * to a request before passing it to the given `HttpBackend`.
 *
 * The interceptors are loaded lazily from the injector, to allow
 * interceptors to themselves inject classes depending indirectly
 * on `HttpInterceptingHandler` itself.
 * @see `HttpInterceptor`
 */
var HttpInterceptingHandler = /*@__PURE__*/ (function () {
    function HttpInterceptingHandler(backend, injector) {
        this.backend = backend;
        this.injector = injector;
        this.chain = null;
    }
    HttpInterceptingHandler.prototype.handle = function (req) {
        if (this.chain === null) {
            var interceptors = this.injector.get(HTTP_INTERCEPTORS, []);
            this.chain = interceptors.reduceRight(function (next, interceptor) { return new HttpInterceptorHandler(next, interceptor); }, this.backend);
        }
        return this.chain.handle(req);
    };
    return HttpInterceptingHandler;
}());
/**
 * Factory function that determines where to store JSONP callbacks.
 *
 * Ordinarily JSONP callbacks are stored on the `window` object, but this may not exist
 * in test environments. In that case, callbacks are stored on an anonymous object instead.
 *
 *
 */
function jsonpCallbackContext() {
    if (typeof window === 'object') {
        return window;
    }
    return {};
}
/**
 * Configures XSRF protection support for outgoing requests.
 *
 * For a server that supports a cookie-based XSRF protection system,
 * use directly to configure XSRF protection with the correct
 * cookie and header names.
 *
 * If no names are supplied, the default cookie name is `XSRF-TOKEN`
 * and the default header name is `X-XSRF-TOKEN`.
 *
 *
 */
var HttpClientXsrfModule = /*@__PURE__*/ (function () {
    function HttpClientXsrfModule() {
    }
    HttpClientXsrfModule_1 = HttpClientXsrfModule;
    /**
     * Disable the default XSRF protection.
     */
    HttpClientXsrfModule.disable = function () {
        return {
            ngModule: HttpClientXsrfModule_1,
            providers: [
                { provide: http_HttpXsrfInterceptor, useClass: NoopInterceptor },
            ],
        };
    };
    /**
     * Configure XSRF protection.
     * @param options An object that can specify either or both
     * cookie name or header name.
     * - Cookie name default is `XSRF-TOKEN`.
     * - Header name default is `X-XSRF-TOKEN`.
     *
     */
    HttpClientXsrfModule.withOptions = function (options) {
        if (options === void 0) {
            options = {};
        }
        return {
            ngModule: HttpClientXsrfModule_1,
            providers: [
                options.cookieName ? { provide: XSRF_COOKIE_NAME, useValue: options.cookieName } : [],
                options.headerName ? { provide: XSRF_HEADER_NAME, useValue: options.headerName } : [],
            ],
        };
    };
    var HttpClientXsrfModule_1;
    return HttpClientXsrfModule;
}());
/**
 * Configures the [dependency injector](guide/glossary#injector) for `HttpClient`
 * with supporting services for XSRF. Automatically imported by `HttpClientModule`.
 *
 * You can add interceptors to the chain behind `HttpClient` by binding them to the
 * multiprovider for built-in [DI token](guide/glossary#di-token) `HTTP_INTERCEPTORS`.
 *
 *
 */
var HttpClientModule = /*@__PURE__*/ (function () {
    function HttpClientModule() {
    }
    return HttpClientModule;
}());
/**
 * Configures the [dependency injector](guide/glossary#injector) for `HttpClient`
 * with supporting services for JSONP.
 * Without this module, Jsonp requests reach the backend
 * with method JSONP, where they are rejected.
 *
 * You can add interceptors to the chain behind `HttpClient` by binding them to the
 * multiprovider for built-in [DI token](guide/glossary#di-token) `HTTP_INTERCEPTORS`.
 *
 *
 */
var HttpClientJsonpModule = /*@__PURE__*/ (function () {
    function HttpClientJsonpModule() {
    }
    return HttpClientJsonpModule;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */





// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/catch.js

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */
function _catch(selector) {
    return Object(operators["catchError"])(selector)(this);
}
//# sourceMappingURL=catch.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/catch.js


_esm5["d" /* Observable */].prototype.catch = _catch;
_esm5["d" /* Observable */].prototype._catch = _catch;
//# sourceMappingURL=catch.js.map
// EXTERNAL MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/map.js + 1 modules
var map = __webpack_require__("8QP5");

// CONCATENATED MODULE: ./src/app/shared/services/http.client.ts



var http_client_HttpClientCustom = /*@__PURE__*/ (function () {
    function HttpClientCustom(http, router, _toaster) {
        this.http = http;
        this.router = router;
        this._toaster = _toaster;
        this.httpClient = http;
    }
    HttpClientCustom.prototype.get = function (url, options) {
        return this.http.get(url, options);
    };
    HttpClientCustom.prototype.getBlob = function (url, options) {
        options = {};
        options.responseType = "blob";
        options.observe = 'response';
        return this.http.get(url, options);
    };
    HttpClientCustom.prototype.postBlob = function (url, data, options) {
        console.log("called POst Blob");
        options = {};
        options.responseType = "blob";
        options.observe = 'response';
        return this.http.post(url, data, options);
    };
    HttpClientCustom.prototype.filePost = function (url, data, options) {
        options = {};
        options = { headers: new http_HttpHeaders() };
        options.headers.append('Content-Type', 'multipart/form-data');
        options.responseType = 'text';
        return this.http.post(url, data, options);
    };
    HttpClientCustom.prototype.filePostString = function (url, data, options) {
        options = {};
        options = { headers: new http_HttpHeaders() };
        options.headers.append('Content-Type', 'multipart/form-data');
        return this.http.post(url, data, options);
    };
    HttpClientCustom.prototype.post = function (url, data, options) {
        return this.http.post(url, data, options);
    };
    HttpClientCustom.prototype.put = function (url, data, options) {
        return this.http.put(url, data, options);
    };
    HttpClientCustom.prototype.delete = function (url, options) {
        return this.http.delete(url, options);
    };
    return HttpClientCustom;
}());



// CONCATENATED MODULE: ./src/app/shared/services/configuration.ts


var Configuration = /*@__PURE__*/ (function () {
    function Configuration() {
        this.properties = {
            BI_BASE_URL: '/bi',
            EPMS_BASE_URL: '/epms/',
            USER_APP_URL: '/home',
            BUILU_NUMBER: ' kea-8.0-11072023021910-d0c620607c305066f823a67677c97368892e649e-master'
        };
    }
    Configuration.prototype.get = function (key) {
        return this.properties && this.properties[key] ? this.properties[key] : '';
    };
    return Configuration;
}());



// CONCATENATED MODULE: ./src/app/shared/services/number.utils.ts


var NumberUtils = /*@__PURE__*/ (function () {
    function NumberUtils() {
        this.properties = { BI_BASE_URL: '/bi', EPMS_BASE_URL: '/home' };
    }
    Object.defineProperty(NumberUtils, "MILLION", {
        get: function () { return 1000000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "BILLION", {
        get: function () { return 1000000000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "LAKHS", {
        get: function () { return 10000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "THOUSANDS", {
        get: function () { return 1000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    NumberUtils.prototype.autoScale = function (value) {
        var suffix = '';
        try {
            var x = parseFloat(value);
            var opr = x > 0 ? 1 : -1;
            x = Math.abs(x);
            if (x > NumberUtils.BILLION) {
                value = x / (NumberUtils.BILLION);
                suffix = 'Bil';
            }
            else if (x > NumberUtils.MILLION) {
                value = x / (NumberUtils.MILLION);
                suffix = 'Mil';
            }
            else if (x > NumberUtils.LAKHS) {
                value = x / (NumberUtils.THOUSANDS);
                suffix = 'K';
            }
            value = opr == -1 ? -Math.abs(value) : value;
        }
        catch (e) { }
        return { value: value, suffix: suffix };
    };
    NumberUtils.prototype.autoFormat = function (x) {
        try {
            var val = this.autoScale(x);
            return this.numberWithCommas(val.value) + " " + val.suffix;
        }
        catch (e) {
            return '';
        }
    };
    NumberUtils.prototype.numberWithCommas = function (val) {
        try {
            var x = Math.round(val * 100) / 100;
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }
        catch (e) {
            return 0;
        }
    };
    NumberUtils.prototype.checkDecimalPoints = function (event, dp) {
        var val = event.target.value.trim();
        var dec = val.split('.');
        var decimals = "";
        if (!(/^[-]?[0-9]+(?:\.[0-9]*)?$/.test(val))) {
            event.target.value = val.slice(0, -1);
            return;
        }
        else {
            if (dec.length > 1) {
                decimals = dec[1];
            }
            else {
                return;
            }
            if (val != "" && (decimals && decimals.length > dp)) {
                console.log("Initial ", val);
                var f = parseFloat(val);
                var np = f.toFixed(dp);
                event.target.value = np;
                console.log("Changed ", event.target.value);
            }
        }
    };
    return NumberUtils;
}());



// EXTERNAL MODULE: ./node_modules/@angular/http/fesm5/http.js
var fesm5_http = __webpack_require__("T3q3");

// EXTERNAL MODULE: ./node_modules/html-entities/index.js
var html_entities = __webpack_require__("pqjY");
var html_entities_default = /*#__PURE__*/__webpack_require__.n(html_entities);

// CONCATENATED MODULE: ./src/app/shared/services/auth.ts







var auth_Auth = /*@__PURE__*/ (function () {
    function Auth(httpClient, _global, router) {
        this.httpClient = httpClient;
        this._global = _global;
        this.router = router;
        this.updateProfilePic = new core["EventEmitter"]();
        this.closeFilterValue = new core["EventEmitter"]();
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._biUrl = _global.get('BI_BASE_URL');
        this._appUrl = _global.get('USER_APP_URL');
    }
    Object.defineProperty(Auth.prototype, "isAuthenticated", {
        get: function () {
            if (window.localStorage.getItem('activeToken')) {
                return true;
            }
            else {
                this._userInfo = '';
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "userInfo", {
        get: function () {
            return this._userInfo;
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line:member-access
    Auth.prototype.login = function (username, password) {
        var _this = this;
        var headers = new fesm5_http["Headers"]();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        return this.httpClient.post(this._baseUrl + 'login?username='
            + username + '&password=' + password, {}, { headers: headers }).subscribe(function (response) {
            // login successful if there's a jwt token in the response
            if (window.localStorage.getItem('activeToken')) {
                _this.router.navigate(['/hub']);
            }
            return true;
        }, function (err) {
            //  this.translate.get('incorrectValues').subscribe((msg)=>{
            alert('incorrectValues');
            // })
        });
    };
    // tslint:disable-next-line:member-access
    Auth.prototype.user = function () {
        if (this._userInfo) {
            return this.createObservable(this._userInfo);
        }
        var self = this;
        return this.httpClient.get(this._baseUrl + 'v1/hub/employeeInfo').map(function (result) {
            self._userInfo = result;
            window.localStorage.setItem('userInfo', JSON.stringify(result));
            return self._userInfo;
        });
    };
    // tslint:disable-next-line:member-access
    Auth.prototype.logout = function () {
        // window.localStorage.removeItem('userInfo');
        // window.localStorage.removeItem('activeToken');
        // let url = this._baseUrl + 'v1/hub/logout';
        // this.httpClient.post(url, {}).subscribe();
        // window.location.href = this._appUrl;
        var _this = this;
        this._userInfo = '';
        var url = this._baseUrl + 'v1/hub/logout';
        this.httpClient.get(url).subscribe(function (result) {
            _this.clearLocalStorage();
            window.location.href = _this._appUrl + "/";
        }, function (err) {
            _this.clearLocalStorage();
            if (err.status == 200) {
                window.location.href = err.headers.get("location");
            }
            else {
                window.location.href = _this._appUrl + "/";
            }
        });
    };
    Auth.prototype.clearLocalStorage = function () {
        window.localStorage.clear();
    };
    Auth.prototype.createObservable = function (data) {
        return Observable["a" /* Observable */].create(function (observer) {
            observer.next(data);
            observer.complete();
        });
    };
    Auth.prototype.handleError = function (error) {
        console.log(error);
        // return false;
        return Observable["a" /* Observable */].throw(error || 'Server error');
    };
    Object.defineProperty(Auth.prototype, "userImage", {
        get: function () {
            return (this._userInfo && this._userInfo.imageUrl) ? this._userInfo.imageUrl : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "tenantImage", {
        get: function () {
            var self = this;
            if (!this._tenantLogo) {
                return this.httpClient.get(this._baseUrl + 'v1/hub/tenantLogo')
                    .map(function (res) {
                    var img = res;
                    if (img && img.id) {
                        self._tenantLogo = img.id;
                    }
                    return self._tenantLogo;
                }).catch(self.handleError);
            }
            else {
                return self.createObservable(self._tenantLogo);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "tenant", {
        get: function () {
            var self = this;
            if (!this._tenant) {
                return this.httpClient.get(this._baseUrl + '/v2/tenant/getBiLogo')
                    .map(function (res) {
                    self._tenant = res;
                    return self._tenant;
                }).catch(self.handleError);
            }
            else {
                return self.createObservable(self._tenant);
            }
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line:member-ordering
    Auth.prototype.htmlEntitiesDecode = function (message) {
        try {
            var entities = new html_entities["AllHtmlEntities"]();
            return entities.decode(message);
        }
        catch (e) {
            console.log('Error in htmlEntitiesDecode::', e);
        }
    };
    Auth.prototype.closeFilter = function () {
        this.closeFilterValue.emit();
    };
    Auth.prototype.updateUser = function (userInfo) {
        this._userInfo = userInfo;
        console.log(this._userInfo);
        this.setUserInfo(this._userInfo);
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
        this.updateProfilePic.emit(userInfo);
    };
    Auth.prototype.setUserInfo = function (data) {
        window.localStorage.setItem('userInfo', JSON.stringify(data));
    };
    return Auth;
}());



// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/app/shared/services/date-utils.ts



var date_utils_DateTimeUtils = /** @class */ (function () {
    // tslint:disable-next-line:no-empty
    function DateTimeUtils() {
    }
    DateTimeUtils.dateLabel = function (date, filter) {
        var prefix = filter.range.toUpperCase();
        if (prefix == 'FY') {
            prefix = 'Last Updated';
        }
        else if (filter && filter.psd) {
            var psd = filter.psd;
            if (psd.charAt(0) == '-') {
                // tslint:disable-next-line:max-line-length
                prefix = 'Past ' + psd.charAt(1) + ' ' + (psd.charAt(2) === 'W' ? 'Weeks' : 'Months') + ' as ';
            }
            // tslint:disable-next-line:quotemark
        }
        else if (prefix == "DAY") {
            prefix = "";
        }
        else {
            prefix += ' as ';
        }
        return prefix.concat(' on ').concat(moment(date).format('DD MMM YYYY'));
    };
    DateTimeUtils.relativeDate = function (filter, oper) {
        try {
            var ped = this.fromymd(filter.ped);
            var period = oper.charAt(0);
            var operand = oper.charAt(1).toUpperCase();
            var count = oper.charAt(2);
            var base_date = moment(ped);
            var to_date = void 0;
            var from_date = void 0;
            // TODO make M dynamic
            if (operand == '-') {
                to_date = moment(ped).subtract(count, 'M');
            }
            else {
                to_date = moment(ped).add(count, 'M');
            }
            filter.fped = to_date.format('YYYYMMDD');
            from_date = to_date.startOf('M');
            filter.fsed = from_date.format('YYYYMMDD');
        }
        catch (e) {
            console.error(e);
        }
    };
    DateTimeUtils.toymd = function (date) {
        return moment["utc"](date).format('YYYYMMDD');
    };
    DateTimeUtils.toDate = function (date) {
        return moment["utc"](date, 'YYYYMMDD').toDate();
        ;
    };
    DateTimeUtils.formatDate = function (date) {
        return moment["utc"](date).format('MM/DD/YYYY');
    };
    DateTimeUtils.fromymd = function (date) {
        return moment["utc"](date, 'YYYYMMDD');
    };
    DateTimeUtils.strToIMyDate = function (item) {
        return this.dateToIMyDate(DateTimeUtils.toDate(item));
    };
    DateTimeUtils.dateToIMyDate = function (curr) {
        return {
            year: curr.getFullYear(),
            month: curr.getMonth() + 1,
            day: curr.getDate()
        };
    };
    DateTimeUtils.intToIMyDate = function (curr) {
        return {
            year: parseInt(curr.substring(0, 4)),
            month: parseInt(curr.substring(4, 6)),
            day: parseInt(curr.substring(6, 8))
        };
    };
    DateTimeUtils.imyDateToInt = function (curr) {
        if (curr && !!curr.year) {
            return Number(curr.year + this.padLeft(curr.month, '0', 2) + this.padLeft(curr.day, '0', 2));
        }
        else {
            return Number(moment["utc"](new Date()).format('YYYYMMDD'));
        }
    };
    DateTimeUtils.imyDateToDate = function (curr) {
        // if (curr && !isNaN(curr.year)) {
        if (curr && !!curr.year) {
            return curr.year + '-' + this.padLeft(curr.month, '0', 2) + '-' + this.padLeft(curr.day, '0', 2);
        }
        else {
            return moment["utc"](new Date()).format('YYYY-MM-DD');
        }
    };
    DateTimeUtils.padLeft = function (text, padChar, size) {
        return (String(padChar).repeat(size) + text).substr((size * -1), size);
    };
    return DateTimeUtils;
}());


// CONCATENATED MODULE: ./src/app/shared/services/theme-service.ts



var ThemeService = /*@__PURE__*/ (function () {
    function ThemeService() {
    }
    ThemeService.prototype.loadTenantCSS = function (url) {
        url = url ? url : "default";
        try {
            var link = document.getElementById('link_theme');
            var found = false;
            // Create link
            if (!link) {
                link = document.createElement('link');
            }
            else {
                found = true;
            }
            link.href = 'assets/theme/' + url + ".css";
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.id = 'link_theme';
            var head = document.getElementsByTagName('head')[0];
            var links = head.getElementsByTagName('link');
            var style = head.getElementsByTagName('style')[0];
            // Check if the same style sheet has been loaded already.
            var isLoaded = false;
            for (var i = 0; i < links.length; i++) {
                var node = links[i];
                if (node.href.indexOf(link.href) > -1) {
                    isLoaded = true;
                }
            }
            if (isLoaded)
                return;
            if (!found) {
                head.insertBefore(link, style);
            }
        }
        catch (e) {
            console.error(e);
        }
    };
    ThemeService.THEMES = [{ id: "default", value: "Default" }, { id: "sp", value: "Green" }, { id: "tm", value: "Blue" }];
    return ThemeService;
}());



// CONCATENATED MODULE: ./src/app/shared/index.ts








// CONCATENATED MODULE: ./src/app/bi/admin/controller/target.component.ts



var target_component_targetComponent = /*@__PURE__*/ (function () {
    function targetComponent(_sanitizer, targetService, toastr, ngbDataConv, vcr) {
        var _this = this;
        this._sanitizer = _sanitizer;
        this.targetService = targetService;
        this.toastr = toastr;
        this.ngbDataConv = ngbDataConv;
        this.vcr = vcr;
        this.trgData = { id: null, userId: null, pageSectionId: null, deleted: false };
        this.mainPage = true;
        this.trgPage = false;
        this.trgList = [];
        this.corMasTrgList = [];
        this.corDetTrgList = [];
        this.dimLvlList = [];
        this.dimList = [];
        this.datePickerList = [];
        this.filteredDimList = [];
        this.uploadedDataList = [];
        this.nonExistentTargets = [];
        this.dimGroupIndexArray = [];
        this.nonExistentDimensions = [];
        this.nonExistentDimLevels = [];
        this.saveButton = false;
        this.saveFlag = false;
        this.searchBar = [];
        this.accessDenied = false;
        this.onStart = false;
        this.isEdit = false;
        this.dimGroupExists = false;
        this.totalDimGroups = 0;
        this.trgReg = '';
        this.lastRegex = '';
        this.file = null;
        this.measureList = [];
        this.selectedMeasureId = 1;
        this.totalPages = 0;
        this.loader = false;
        this.uploadSucess = false;
        this.trgAdd = false;
        this.corTrgData = { id: '', name: '', corTrgCode: '', value: '', corMasTargets: [] };
        this.selectedCorTarget = { id: '', name: '', corTrgCode: '', value: '', corMasTargets: [] };
        this.corMasTargetData = { id: '', date: '', value: 0, corDetTargets: [] };
        this.dimRegex = '';
        this.selectedDimMap = new Map();
        this.dimTree = {
            id: null,
            name: null,
            children: null,
            trgValue: null
        };
        this.trgTree = {
            id: null,
            name: null,
            children: null,
            trgValue: null,
            dateId: null,
            dmLvlId: null,
            dmLvlVal: null
        };
        this.nodes = [];
        this.options = { displayField: 'trgValue' };
        this.totalComb = 0;
        this.sPage = 0;
        this.pageNo = 0;
        this.pageSize = 10;
        this.totalCorTrgs = 0;
        this.currentPage = 1;
        this.startingPage = 0;
        this.endingPage = 10;
        this.mPageNo = 0;
        this.mSize = 10;
        this.startingMPage = 0;
        this.endingMPage = 10;
        this.currentMPage = 1;
        this.totalMasTrgs = 0;
        this.searchDim = function (keyword) {
            var self = _this;
            _this.targetService.isBIAdmin = false;
            _this.targetService.search(BiUrls.BI_DIMENSION, BiUrls.SEARCH_DIMENSION, keyword).then(function (res) {
                self.totalPages = 0;
                if (res != undefined) {
                    self.dimList = res.data != undefined ? res.data : [];
                }
            }, function (err) {
                console.error(err);
            });
            _this.targetService.isBIAdmin = true;
            //this.elementDiv.nativeElement.value = '';
            return Observable["a" /* Observable */].of(self.dimList);
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.dimHierarchyLevelName + "-" + data.dimName + "-" + data.dimCode + "</span>";
            //let html = `<span> ${data.dimName} -- ${data.dimCode}</span>`;
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.toastr.setViewRef(vcr);
    }
    targetComponent.prototype.ngOnInit = function () {
        //this.mainPage = true;
        if (this.targetService.isBIAdmin) {
            this.loadTargets();
        }
        else {
            this.accessDenied = true;
        }
    };
    targetComponent.prototype.entityOps = function (event) {
        if (this.selectedCorTrgId == null) {
            this.selectedCorTrgId = event.target.id;
        }
        else {
            this.selectedCorTrgId = null;
        }
    };
    targetComponent.prototype.closeDropDown = function (event) {
        this.selectedCorTrgId = null;
    };
    targetComponent.prototype.onPageChange = function (event) {
        console.log('On Page Change Controller ...');
        if (this.isEdit) {
            this.currentMPage = event;
            this.mPageNo = this.currentMPage - 1;
            this.loadMasTrgsById(this.selectedCorTarget.id);
            this.setEndingPage(this.currentMPage, this.mSize, this.startingMPage, this.endingMPage, this.totalMasTrgs);
        }
        else {
            this.currentPage = event;
            this.pageNo = this.currentPage - 1;
            if (this.trgReg != '') {
                this.searchPTarget();
            }
            else {
                this.loadTargets();
            }
            this.setEndingPage(this.currentPage, this.pageSize, this.startingPage, this.endingPage, this.totalCorTrgs);
        }
    };
    targetComponent.prototype.OnPageSizeChanged = function (event) {
        console.log('On Page-Size Change Controller ...');
        if (this.isEdit) {
            this.mSize = event.target.value;
            var maxPage = Math.floor(this.totalMasTrgs / this.mSize);
            if (maxPage < this.mPageNo) {
                this.mPageNo = maxPage;
            }
            this.loadMasTrgsById(this.corTrgData.id);
        }
        else {
            this.pageSize = event.target.value;
            var maxPage = Math.floor(this.totalCorTrgs / this.pageSize);
            if (maxPage < this.pageNo || maxPage < this.sPage) {
                this.pageNo = maxPage;
                this.sPage = this.pageNo;
            }
            this.loadTargets();
        }
    };
    targetComponent.prototype.setEndingPage = function (currPage, size, startPage, endPage, total) {
        var self = this;
        if (currPage == 1) {
            startPage = 0;
            if (total > size) {
                endPage = size;
            }
            else {
                endPage = total;
            }
        }
        else {
            startPage = 0 + ((currPage - 1) * +size);
            endPage = +size + ((currPage - 1) * +size);
            if (endPage > total) {
                endPage = total;
            }
        }
        if (self.isEdit) {
            self.currentMPage = currPage;
            self.startingMPage = startPage;
            self.endingMPage = endPage;
        }
        else {
            self.currentPage = currPage;
            self.startingPage = startPage;
            self.endingPage = endPage;
        }
    };
    targetComponent.prototype.searchPTarget = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.mainPage = true;
            self.loader = true;
            self.trgList = [];
            if (self.trgReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
                //self.currentPage = 1;
            }
            self.lastRegex = self.trgReg;
            var resu = self.targetService.search(BiUrls.TARGET, BiUrls.SEARCH_P_TARGET, self.trgReg, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedPTargets(res);
                self.loader = false;
            }, function (err) {
                console.error(err);
            });
            resolve('completed');
        });
    };
    // By Lalu
    targetComponent.prototype.loadSearchedPTargets = function (res) {
        var self = this;
        self.trgList = (res != undefined) ? res.data.pageElements : [];
        self.totalCorTrgs = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.currentPage, self.pageSize, self.startingPage, self.endingPage, self.totalCorTrgs);
    };
    targetComponent.prototype.loadTargets = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            _this.targetService.getDataByPage(BiUrls.TARGET, self.pageNo, self.pageSize).then(function (res) {
                self.trgList = [];
                if (res == undefined || res.data == undefined) {
                    self.toastr.showError('No Targets to load');
                }
                else {
                    self.trgList = res.data.pageElements != undefined ? res.data.pageElements : [];
                    self.selectedCorTarget = self.trgList[0];
                    self.totalCorTrgs = res.data.total;
                }
                self.loader = false;
                self.mainPage = true;
                self.setEndingPage(self.currentPage, self.pageSize, self.startingPage, self.endingPage, self.totalCorTrgs);
                resolve('completed');
            }, function (error) {
                if (error.status == 204) {
                    self.toastr.showError('Cannot load the targets');
                }
            });
        });
    };
    targetComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.trgPage = false;
        this.trgData = {};
        this.isEdit = false;
        this.corMasTrgList = [];
        this.corDetTrgList = [];
        this.dimLvlList = [];
        this.searchBar = [];
    };
    targetComponent.prototype.bulkUpload = function (event) {
        var self = this;
        self.dimGroupIndexArray = [];
        self.dimGroupExists = false;
        self.totalDimGroups = 0;
        self.nonExistentDimensions = [];
        self.nonExistentDimLevels = [];
        self.nonExistentTargets = [];
        self.uploadedDataList = [];
        if (self.validateFile(self.file)) {
            var formdata1 = new FormData();
            formdata1.append('file', self.file);
            self.targetService.bulkUpload(BiUrls.TARGET, BiUrls.BULKUPLOAD_TARGET, formdata1).then(function (res) {
                if (res.success) {
                    self.toastr.showSuccess("Bulk Upload Successful");
                    self.uploadSucess = true;
                    self.file = null;
                    self.fileInput.nativeElement.value = null;
                    self.loadUploadReport(res);
                    self.loadTargets();
                }
                else {
                    self.toastr.showError(res.errorMessage);
                }
            }, function (error) {
                self.toastr.showError('Bulk Upload Failed');
            });
        }
        else {
            self.toastr.showError('Please Attach An Excel File');
        }
    };
    targetComponent.prototype.validateFile = function (file) {
        var ext;
        if (file != null) {
            ext = file.name.split('.', 2);
        }
        else {
            ext = undefined;
        }
        if (ext == undefined || !(ext[1] == 'xls' || ext[1] == 'xlsx')) {
            return false;
        }
        else {
            return true;
        }
    };
    targetComponent.prototype.loadUploadReport = function (result) {
        var self = this;
        var statusMap = this.jsonToMap(result);
        this.nonExistentTargets = statusMap.get('NON_EXISTENT_TRG_CODE');
        if (statusMap.size > 2) {
            this.dimGroupExists = true;
            this.totalDimGroups = statusMap.size / 2 - 1;
        }
        for (var i = 0; i < this.totalDimGroups; i++) {
            this.dimGroupIndexArray[i] = i + 1;
            this.nonExistentDimensions[i] = statusMap.get('NON_EXISTENT_DIM_CODE_' + (i + 1));
            this.nonExistentDimLevels[i] = statusMap.get('NON_EXISTENT_DIM_LVL_NAME_' + (i + 1));
        }
        this.uploadedDataList = statusMap.get('UPLOADED_DATA');
    };
    targetComponent.prototype.jsonToMap = function (result) {
        var res = result;
        var jsonObj = JSON.parse(JSON.stringify(res.data));
        var map = new Map();
        for (var _i = 0, _a = Object.keys(jsonObj); _i < _a.length; _i++) {
            var k = _a[_i];
            map.set(k, jsonObj[k]);
        }
        return map;
    };
    targetComponent.prototype.fileChange = function (event) {
        this.file = event.target.files[0];
        console.log(this.file.name);
    };
    // strToDateId(dateStr): number {
    //     let dateArr = dateStr.split("-", 3);
    //     let dateIdStr = dateArr[0] + dateArr[1] + dateArr[2];
    //     let dateId = parseInt(dateIdStr);
    //     return dateId;
    // }
    targetComponent.prototype.dateIdToStr = function (dateId) {
        var dstr = dateId.toString();
        var date = date_utils_DateTimeUtils.toDate(dstr);
        var d = date.getUTCDate();
        var m = date.getUTCMonth() + 1;
        var y = date.getUTCFullYear();
        var dateStr = d + "-" + m + "-" + y;
        return dateStr;
    };
    // public onDateChange(event, corMasTrgInd) {
    //     //this.corMasTrgList[corMasTrgInd]['date'] = this.strToDateId(event.target.value);
    //     this.corMasTrgList[corMasTrgInd]['date'] = this.strToDateId(event.target.value);
    //     this.datePickerList[corMasTrgInd] = false;
    // }
    targetComponent.prototype.removeSelectedDate = function (corMasInd) {
        this.datePickerList[corMasInd] = true;
    };
    targetComponent.prototype.orgNameValueFormatter = function (data) {
        return "" + data.dimHierachyLevelName;
    };
    targetComponent.prototype.onSelectDim = function (event, corDetTrg, corMasInd, corDetInd) {
        this.searchBar[corMasInd][corDetInd] = false;
        corDetTrg.dimId = event.dimId;
        corDetTrg.dimLvlId = event.dimHierarchyLevelId;
        this.dimLvlList[corMasInd][corDetInd] = event.dimHierarchyLevelName;
        this.dimList = [];
    };
    targetComponent.prototype.removeSelectedDim = function (corMasInd, corDetInd) {
        this.searchBar[corMasInd][corDetInd] = true;
    };
    // genTrgTree() {
    //     let self = this;
    //     let msTrgs = self.selectedCorTarget.corMasTargets;
    //     let node = null;
    //     let mtNodeList = [];
    //     let detNodeList = [];
    //     let trgList = [];
    //     for (let mt of msTrgs) {
    //         let detTrgs = mt.corDetTargets;
    //         let mtNode;
    //         detNodeList = [];
    //         for (let dt of detTrgs) {
    //             let detNode = {
    //                 id: dt.id,
    //                 children: [],
    //                 dmLvlId: dt.dimLvlId,
    //                 dmLvlValue: dt.dimLvlValue
    //             }
    //             detNodeList.push(detNode);
    //         }
    //         mtNode = {
    //             id: mt.id,
    //             dateId: mt.date,
    //             trgValue: mt.value,
    //             children: detNodeList
    //         }
    //         mtNodeList.push(mtNode);
    //     }
    //     this.trgTree = {
    //         id: this.selectedCorTarget.id,
    //         name: this.selectedCorTarget.name + " ( " + this.selectedCorTarget.corTrgCode + " )",
    //         dateId: null,
    //         dmLvlId: null,
    //         dmLvlVal: null,
    //         children: mtNodeList,
    //         trgValue: null
    //     }
    //     trgList.push(this.trgTree);
    //     this.nodes = trgList;
    // }
    targetComponent.prototype.onCloseSummary = function (event) {
        this.uploadSucess = false;
        //this.loadTargets();
    };
    targetComponent.prototype.addCorTarget = function (event) {
        var self = this;
        self.mainPage = false;
        self.trgPage = true;
        self.corTrgData = { id: null, name: '', deleted: false, corMasTargets: [] };
    };
    targetComponent.prototype.onSave = function () {
        var self = this;
        self.saveFlag = true;
        var validate = self.validater();
        if (validate != '') {
            self.toastr.showError(validate);
        }
        else {
            self.loader = true;
            self.saveButton = true;
            self.parseMasTrgDates();
            if (self.isEdit) {
                console.log('ON EDIT');
                for (var i = 0; i < self.corMasTrgList.length; i++) {
                    self.corMasTrgList[i].corDetTargets = self.corDetTrgList[i];
                }
                self.selectedCorTarget.corMasTargets = self.corMasTrgList;
                self.targetService.update(BiUrls.TARGET, self.selectedCorTarget).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                for (var i = 0; i < self.corMasTrgList.length; i++) {
                    self.corMasTrgList[i].corDetTargets = self.corDetTrgList[i];
                }
                self.corTrgData.corMasTargets = self.corMasTrgList;
                self.targetService.save(BiUrls.TARGET, self.corTrgData).then(function (res) {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    };
    targetComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalCorTrgs / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            self.totalPages;
        self.currentPage = self.pageNo + 1;
        var text = type == 'new' ? 'Cor-Target saved successfully' : 'Changes saved successfully';
        if (self.trgReg != '') {
            self.searchPTarget().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Failed to save Cor-Target');
                }
            });
        }
        else {
            self.loadTargets().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError('Failed to save Cor-Target');
                }
            }, function (error) {
                console.error(error);
            });
        }
    };
    targetComponent.prototype.setPageFieldsAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.saveFlag = false;
        self.mainPage = true;
        self.corMasTrgList = [];
        self.corDetTrgList = [];
        self.dimLvlList = [];
        self.searchBar = [];
        self.trgPage = false;
        self.isEdit = false;
        self.loader = false;
    };
    targetComponent.prototype.setTrgComponentFields = function (corTrgData) {
        var self = this;
        self.isEdit = true;
        self.loader = false;
        self.mainPage = false;
        self.trgPage = true;
        self.selectedCorTarget = corTrgData;
        self.corMasTrgList = self.selectedCorTarget.corMasTargets;
        self.parseMasTrgDates();
        for (var i = 0; i < self.corMasTrgList.length; i++) {
            self.searchBar.push([]);
            self.dimLvlList.push([]);
            //self.datePickerList[i] = false;
            self.corDetTrgList.push(self.corMasTrgList[i].corDetTargets);
            for (var j = 0; j < self.corDetTrgList[i].length; j++) {
                self.searchBar[i][j] = false;
                self.dimLvlList[i][j] = self.corDetTrgList[i][j].dimLvlId;
            }
        }
    };
    targetComponent.prototype.loadMasTrgsById = function (corTrgId) {
        var self = this;
        var url = BiUrls.GET_P_MAS_TRGS + corTrgId;
        self.targetService.getDataByPage(url, self.mPageNo, self.mSize).then(function (res) {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Cor-Target');
                self.loadTargets();
            }
            else {
                self.corTrgData.corMasTargets = JSON.parse(JSON.stringify(res.data.pageElements));
                self.setTrgComponentFields(self.corTrgData);
                //self.genTrgTree();
                self.totalMasTrgs = res.data.total;
                self.setEndingPage(self.currentMPage, self.mSize, self.startingMPage, self.endingMPage, self.totalMasTrgs);
            }
        }, function (err) {
            console.error(err);
        });
    };
    targetComponent.prototype.parseMasTrgDates = function () {
        var self = this;
        if (self.saveFlag == true) {
            for (var _i = 0, _a = self.corMasTrgList; _i < _a.length; _i++) {
                var cmt = _a[_i];
                var strMon = cmt.date.month.toString();
                var month = strMon.length == 1 ? ('0' + strMon) : strMon;
                var strDay = cmt.date.day.toString();
                var day = strDay.length == 1 ? ('0' + strDay) : strDay;
                var strDate = cmt.date.year.toString() + month + day;
                cmt.date = parseInt(strDate);
            }
        }
        else {
            for (var _b = 0, _c = self.corMasTrgList; _b < _c.length; _b++) {
                var cmt = _c[_b];
                var strDate = self.dateIdToStr(cmt.date);
                cmt.date = this.ngbDataConv.fromModel(strDate);
            }
        }
    };
    targetComponent.prototype.editCorTarget = function (corTrg) {
        console.log('On Edit Controller ...');
        var self = this;
        self.mainPage = false;
        self.trgPage = true;
        self.isEdit = true;
        self.loader = true;
        self.selectedCorTrgId = null;
        var url = BiUrls.GET_TRGS_WITHOUT_HIERARCHY + corTrg.id;
        self.targetService.getDataByPage(url, self.pageNo, self.pageSize).then(function (res) {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the Cor-Target');
                self.loadTargets();
            }
            else {
                self.corTrgData = res.data;
                self.loadMasTrgsById(corTrg.id);
                self.setEndingPage(self.currentMPage, self.mSize, self.startingMPage, self.endingMPage, self.totalMasTrgs);
            }
            self.loader = false;
        }, function (error) {
            console.error(error);
        });
    };
    targetComponent.prototype.addMasTarget = function (corTrg) {
        var corMasTrg = {
            id: null, date: null, value: null,
            corTargetId: 0, corDetTargets: [], deleted: false
        };
        corMasTrg.corTargetId = corTrg.id;
        this.corMasTrgList.push(corMasTrg);
        this.corDetTrgList.push(corMasTrg.corDetTargets);
        this.searchBar.push([]);
        this.datePickerList.push(true);
        this.dimLvlList.push([]);
    };
    targetComponent.prototype.addDetTarget = function (corMasInd) {
        var corDetTrg = {
            id: null, dimLvlId: 0, dimLvlValue: '',
            corMasTrgId: this.corMasTrgList[corMasInd]['id'], deleted: false
        };
        this.searchBar[corMasInd].push(true);
        this.corDetTrgList[corMasInd].push(corDetTrg);
    };
    targetComponent.prototype.searchBarVisibility = function (corMasInd, corDetInd) {
        return this.searchBar[corMasInd][corDetInd];
    };
    targetComponent.prototype.removeCorTrg = function (corTrg) {
        var r = confirm('Are you sure you want to remove the Cor-Target ' + corTrg.name + ' ?');
        if (r == true) {
            this.delete(corTrg);
        }
    };
    targetComponent.prototype.delete = function (corTrg) {
        var self = this;
        self.targetService.delete(BiUrls.TARGET, corTrg.id).then(function (response) {
            self.loader = false;
            self.pageNo = self.trgList.length == 1 ?
                self.totalCorTrgs == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadTargets();
            if (response == undefined || response.data == undefined) {
                self.toastr.showError('Unable to remove Cor-Target');
            }
            else {
                self.toastr.showSuccess(corTrg.name + ' removed successfully');
            }
        }, function (error) {
            console.error(error);
        });
    };
    targetComponent.prototype.removeMasTarget = function (corMasTrg) {
        var index = this.corMasTrgList.indexOf(corMasTrg);
        this.corMasTrgList.splice(index, 1);
        this.corDetTrgList.splice(index, 1);
        this.searchBar.splice(index, 1);
        this.dimLvlList.splice(index, 1);
    };
    targetComponent.prototype.removeDetTarget = function (corDetTrg, corMasInd) {
        var index = this.corDetTrgList[corMasInd].indexOf(corDetTrg);
        this.corDetTrgList[corMasInd].splice(index, 1);
        this.searchBar[corMasInd].splice(index, 1);
        this.dimLvlList[corMasInd].splice(index, 1);
    };
    targetComponent.prototype.validater = function () {
        if (this.corTrgData.name == undefined || this.corTrgData.name.trim() == '') {
            return 'Please enter the name for Cor-Target';
        }
        else if (this.corMasTrgList.length > 0) {
            return this.masTrgValidator();
        }
        else {
            this.corTrgData.name = this.corTrgData.name.trim();
            return '';
        }
    };
    targetComponent.prototype.masTrgValidator = function () {
        var msg = '';
        for (var i = 0; i < this.corMasTrgList.length; i++) {
            var cmt = this.corMasTrgList[i];
            if (cmt.date == null) {
                return 'Please Select Mas Target Date';
            }
            if (cmt.value == undefined) {
                return 'Please Specify Target Value';
            }
            if (this.corDetTrgList[i].length > 0) {
                msg = this.detTrgValidator(this.corDetTrgList[i]);
            }
            if (msg != '') {
                return msg;
            }
        }
        return msg;
    };
    targetComponent.prototype.detTrgValidator = function (detTrgList) {
        for (var _i = 0, detTrgList_1 = detTrgList; _i < detTrgList_1.length; _i++) {
            var cdt = detTrgList_1[_i];
            if (cdt.dimId == undefined) {
                return 'Please Select Dimension';
            }
            else if (cdt.dimLvlValue == undefined || cdt.dimLvlValue.trim() == '') {
                return 'Please Specify Dimension Level Value';
            }
        }
        return '';
    };
    return targetComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/tenantConfiguration.component.ts

var tenantConfiguration_component_tenantConfigComponent = /*@__PURE__*/ (function () {
    function tenantConfigComponent(tenantConfigService, toastr, vcr) {
        this.tenantConfigService = tenantConfigService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.resetDefaultsUrl = 'reset';
        this.tntConfData = {
            tenantConfigDataList: [],
            customScaleList: [],
            measureStatusIndicatorData: [],
            measureColorData: []
        };
        this.weekDayList = [
            'Monday', 'Tuesday', 'Wednesday',
            'Thursday', 'Friday', 'Saturday', 'Sunday'
        ];
        this.loader = false;
        this.mainPage = true;
        this.isEdit = false;
        this.accessDenied = false;
        this.xErrorMsg = '';
        this.xErrorMsg1 = '';
        this.tenantConfigList = [];
        this.customScaleList = [];
        this.measureColorData = [];
        this.colorPaletevalue = [];
        this.toastr.setViewRef(vcr);
    }
    tenantConfigComponent.prototype.ngOnInit = function () {
        if (this.tenantConfigService.isBIAdmin) {
            this.loadTenantConfigs();
        }
        else {
            this.accessDenied = true;
        }
    };
    tenantConfigComponent.prototype.loadTenantConfigs = function () {
        var self = this;
        self.loader = true;
        return new Promise(function (resolve) {
            self.tenantConfigService.onStartUp(BiUrls.TENANT_CONFIG).then(function (res) {
                if (res == undefined) {
                    self.toastr.showError('No Tenant Configurations to load');
                }
                self.tntConfData = res;
                self.setConfigList();
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (error) {
                if (error.status == 204) {
                    self.toastr.showError('Cannot load the tenant configurations');
                }
            });
        });
    };
    tenantConfigComponent.prototype.editTenantConfig = function (event) {
        var self = this;
        self.mainPage = false;
        self.isEdit = true;
    };
    tenantConfigComponent.prototype.setConfigList = function () {
        var _this = this;
        this.customScaleList = [];
        this.tenantConfigList = [];
        this.measureColorData = [];
        var data = this.tntConfData.tenantConfigDataList;
        data.forEach(function (val) {
            if (val.type && val.type == 'SCALE') {
                if (typeof val.value == 'string') {
                    val.value = JSON.parse(val.value);
                }
                _this.customScaleList.push(val);
            }
            else if (val.key == "COLOR_PALETTE") {
                val.value = JSON.parse(val.value);
                _this.colorPaletevalue = [];
                val.value.forEach(function (value1) {
                    _this.colorPaletevalue.push(value1);
                });
                _this.measureColorData.push(_this.colorPaletevalue);
            }
            else if (val.key == "PAGE_SNAPSHOT_EXPIRY") {
                _this.dashboardExpiry = val;
            }
            else {
                _this.tenantConfigList.push(val);
            }
        });
        this.customScaleList.sort(function (a, b) {
            return +a.value.value - +b.value.value;
        });
    };
    tenantConfigComponent.prototype.getConfigType = function (config) {
        if (config.key == "WEEK_START_DAY") {
            return 1;
        }
        else if (config.key == "MONTH_START_DATE") {
            return 2;
        }
        else if (config.key == "YEAR_START_MONTH") {
            return 5;
        }
        else if (config.key == "FONT_SIZE") {
            return 6;
        }
        else if (config.key == "NEGATIVE"
            || config.key == "NEUTRAL"
            || config.key == "POSITIVE") {
            return 4;
        }
        else {
            return 3;
        }
    };
    tenantConfigComponent.prototype.addIndicators = function () {
        var self = this;
        var msrIndData = { name: '', value: null, code: '' };
        self.tntConfData.measureStatusIndicatorData.push(msrIndData);
    };
    tenantConfigComponent.prototype.addColorPalette = function () {
        var self = this;
        var value1 = { startcolor: '', endcolor: '' };
        this.colorPaletevalue.push(value1);
    };
    tenantConfigComponent.prototype.addColorPaletteToConfig = function () {
        // let self = this;
        this.measureColorData = {};
        var value = JSON.stringify(this.colorPaletevalue);
        this.measureColorData['key'] = "COLOR_PALETTE";
        this.measureColorData['displayName'] = "Color Palette";
        this.measureColorData['value'] = value;
    };
    tenantConfigComponent.prototype.addScales = function () {
        var self = this;
        var value = { code: "", value: "", type: "SCALE" };
        var scaleData = { displayName: '', key: '', type: 'SCALE', value: value, valueData: null, new: true };
        self.customScaleList.push(scaleData);
    };
    tenantConfigComponent.prototype.onIndicatorDelete = function (configIndex) {
        var self = this;
        self.tntConfData.measureStatusIndicatorData.splice(configIndex, 1);
    };
    tenantConfigComponent.prototype.onColorPaletteDelete = function (configIndex) {
        this.colorPaletevalue.splice(configIndex, 1);
    };
    tenantConfigComponent.prototype.onScaleDelete = function (configIndex) {
        this.customScaleList.splice(configIndex, 1);
    };
    tenantConfigComponent.prototype.onSave = function () {
        var self = this;
        self.loader = true;
        var validatedRes = self.validator();
        if (validatedRes != '') {
            self.toastr.showError(validatedRes);
            self.loader = false;
            self.isEdit = true;
        }
        else {
            self.setScaleKey();
            self.addColorPaletteToConfig();
            self.addPageConfig();
            self.tntConfData.tenantConfigDataList = self.tenantConfigList;
            self.tntConfData.tenantConfigDataList.push(self.measureColorData);
            (_a = self.tntConfData.tenantConfigDataList).push.apply(_a, self.customScaleList);
            self.tenantConfigService.save(BiUrls.TENANT_CONFIG, self.tntConfData).then(function (res) {
                if (res == undefined) {
                    self.toastr.showError('Unable to save tenant configurations.');
                }
                else {
                    self.toastr.showSuccess('Changes saved successfully.');
                }
                self.loader = false;
                self.mainPage = true;
                self.isEdit = false;
                self.loadTenantConfigs();
            });
        }
        var _a;
    };
    tenantConfigComponent.prototype.onResetDefaults = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            var url = BiUrls.TENANT_CONFIG + '/' + self.resetDefaultsUrl;
            _this.tenantConfigService.onStartUp(url).then(function (res) {
                if (res == undefined) {
                    self.toastr.showError('No Tenant Configurations to load');
                }
                else {
                    self.toastr.showSuccess('Default configurations restored successfully');
                }
                self.tntConfData = res;
                self.setConfigList();
                self.loader = false;
                self.mainPage = true;
                self.isEdit = false;
                resolve('completed');
            }, function (error) {
                if (error.status == 204) {
                    self.toastr.showError('Cannot load the tenant configurations');
                }
            });
        });
    };
    tenantConfigComponent.prototype.validateDay = function (event, ind) {
        var self = this;
        var value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0 || value > 31) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg = 'Date should be from 1 to 31.';
        }
        else {
            self.xErrorMsg = '';
            this.tenantConfigList[ind].value = value;
        }
    };
    tenantConfigComponent.prototype.validateNumber = function (event, ind) {
        var self = this;
        var value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg = '';
        }
        else {
            self.xErrorMsg = '';
            this.tenantConfigList[ind].value = value;
        }
    };
    tenantConfigComponent.prototype.validateMonth = function (event, ind) {
        var self = this;
        var value = event.target.value != '' ? +event.target.value : 1;
        if (value <= 0 || value > 12) {
            this.tenantConfigList[ind].value = 1;
            event.target.value = 1;
            self.xErrorMsg1 = 'Month should be from 1 to 12.';
        }
        else {
            self.xErrorMsg1 = '';
            this.tenantConfigList[ind].value = value;
        }
    };
    tenantConfigComponent.prototype.validator = function () {
        var self = this;
        var flag = false;
        var nameList = [];
        for (var _i = 0, _a = self.tenantConfigList; _i < _a.length; _i++) {
            var conf = _a[_i];
            if (conf.value === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            }
            else {
            }
        }
        for (var _b = 0, _c = self.customScaleList; _b < _c.length; _b++) {
            var conf = _c[_b];
            if (conf.displayName === '') {
                flag = true;
                return 'Scale display name cannot be empty.';
            }
            else if (conf.value.value === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            }
            else if (conf.value.code === '') {
                flag = true;
                return conf.displayName + ' field cannot be empty.';
            }
            else if (nameList.includes(conf.displayName.trim())) {
                flag = true;
                return ' Display name cannot be same.';
            }
            else {
                nameList.push(conf.displayName);
            }
        }
        for (var _d = 0, _e = self.tntConfData.measureStatusIndicatorData; _d < _e.length; _d++) {
            var indicator = _e[_d];
            if (indicator.name === '') {
                flag = true;
                return 'Indicator scale field cannot be empty.';
            }
            else if (indicator.value === '') {
                flag = true;
                return indicator.name + ' value field cannot be empty.';
            }
            else {
            }
        }
        for (var _f = 0, _g = self.colorPaletevalue; _f < _g.length; _f++) {
            var colorpalette = _g[_f];
            if (colorpalette.startcolor === '') {
                flag = true;
                return 'start color value field cannot be empty.';
            }
            else if (colorpalette.endcolor === '') {
                flag = true;
                return 'end color value field cannot be empty.';
            }
            else {
            }
        }
        if (flag == false) {
            return '';
        }
    };
    tenantConfigComponent.prototype.onBack = function () {
        var self = this;
        self.loadTenantConfigs();
        self.mainPage = true;
        self.isEdit = false;
        //self.tntConfData = null;
    };
    tenantConfigComponent.prototype.setScaleKey = function () {
        var self = this;
        self.customScaleList.forEach(function (scale) {
            var key = scale.displayName.toUpperCase();
            if (scale.hasOwnProperty('new')) {
                if (key.match(/\s/g)) {
                    key = key.replace(/\s/g, '_');
                }
                key = 'NF_' + key;
                scale.key = key;
                delete scale.new;
            }
            else {
                key = 'NF_' + key;
                scale.key = key;
            }
            scale.value = JSON.stringify(scale.value);
        });
    };
    tenantConfigComponent.prototype.onSyncDash = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_PAGE_CACHE).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Cache Synced');
            }
            else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.onFlushDash = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.flushCacheConfig(BiUrls.FLUSH_CURRENT_TENANT_PAGE_CACHE).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Cache Flushed');
            }
            else {
                self.toastr.showError('Failed to Flush Cache');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.onSyncData = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_DATA_VS).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Data Version Cache Synced');
            }
            else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.onSyncCube = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.syncCacheConfig(BiUrls.SYNC_CURRENT_TENANT_CUBE_META).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Cube Meta Cache Synced');
            }
            else {
                self.toastr.showError('Failed to Sync Cache');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.getWeekName = function (day) {
        return day[0].toUpperCase() + day.slice(1);
    };
    tenantConfigComponent.prototype.changeWeekStartDay = function (event, config) {
        config.value = event.target.value;
    };
    tenantConfigComponent.prototype.reBuildDashboardSnaphot = function () {
        var self = this;
        self.loader = true;
        self.tenantConfigService.reBuildDashboardSnaphot(BiUrls.REBUILD_DASH_SNAPSHOT).then(function (res) {
            if (res.success) {
                self.toastr.showSuccess('Dashboard Snapshot Rebuilded Successfully');
            }
            else {
                self.toastr.showError('Dashboard Snapshot Rebuilded Failed');
            }
            self.loader = false;
        });
    };
    tenantConfigComponent.prototype.setExpiry = function (event) {
        if (this.dashboardExpiry) {
            this.dashboardExpiry.value = event.target.value;
        }
        else {
            this.dashboardExpiry = {
                displayName: "Page Snapshot Expiry",
                key: "PAGE_SNAPSHOT_EXPIRY",
                type: null,
                value: event.target.value
            };
        }
    };
    tenantConfigComponent.prototype.getValueFor = function () {
        if (this.dashboardExpiry) {
            return this.dashboardExpiry.value != undefined && this.dashboardExpiry.value != '' ? this.dashboardExpiry.value : 30;
        }
        else {
            return 30;
        }
    };
    tenantConfigComponent.prototype.addPageConfig = function () {
        var _this = this;
        if (this.dashboardExpiry) {
            var check_1 = false;
            this.tenantConfigList.forEach(function (config) {
                if (config.key == 'PAGE_SNAPSHOT_EXPIRY') {
                    check_1 = true;
                    config = {};
                    config = _this.dashboardExpiry;
                }
            });
            if (!check_1) {
                this.tenantConfigList.push(this.dashboardExpiry);
            }
        }
    };
    tenantConfigComponent.prototype.validateDuration = function (event) {
        if (event.charCode > 31 && (event.charCode < 48 || event.charCode > 57)) {
            return false;
        }
        if (event.target.value.length >= 3) {
            return false;
        }
    };
    return tenantConfigComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/uom.component.ts

var uom_component_UomComponent = /*@__PURE__*/ (function () {
    function UomComponent(uomService, toastr, vcr) {
        this.uomService = uomService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.uomReg = '';
        this.sPage = 0;
        this.lastRegex = '';
        this.uomData = { id: null, name: '', uomCode: null, uomDesc: '', deleted: 0 };
        this.mainPage = true;
        this.uomPage = false;
        this.uomList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.onStart = false;
        this.isEdit = false;
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.currentPage = 1;
        this.totalUom = 0;
        this.totalPages = 0;
        this.loader = false;
        this.toastr.setViewRef(vcr);
    }
    UomComponent.prototype.ngOnInit = function () {
        if (this.uomService.isBIAdmin) {
            this.loadUom();
        }
        else {
            this.accessDenied = true;
        }
    };
    UomComponent.prototype.entityOps = function (event) {
        if (this.selectedUomId == null) {
            this.selectedUomId = event.target.id;
        }
        else {
            this.selectedUomId = null;
        }
    };
    UomComponent.prototype.closeDropDown = function (event) {
        this.selectedUomId = null;
    };
    UomComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.uomReg != '') {
            this.searchPUom();
        }
        else {
            this.loadUom();
        }
        this.setEndingPage(this.totalUom);
    };
    UomComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    // For Pagination
    UomComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalUom / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadUom();
    };
    UomComponent.prototype.loadUom = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.mainPage = true;
            _this.uomService.getDataByPage(BiUrls.UOM, self.pageNo, self.pageSize).then(function (res) {
                self.uomList = [];
                self.totalPages = 0;
                self.totalUom = 0;
                if (res != undefined) {
                    self.uomList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalUom = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                    self.setEndingPage(self.totalUom);
                    resolve('completed');
                }
                self.loader = false;
            }, function (error) {
                console.error(error);
            });
        });
    };
    UomComponent.prototype.addNewUom = function () {
        this.mainPage = false;
        this.uomPage = true;
        this.uomData = { id: null, name: '', uomDesc: '', deleted: 0 };
    };
    // By Lalu
    UomComponent.prototype.searchPUom = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.mainPage = true;
            self.uomList = [];
            if (self.uomReg != self.lastRegex) {
                self.sPage = 0;
            }
            else {
                self.sPage = self.currentPage - 1;
                self.currentPage = 1;
            }
            self.lastRegex = self.uomReg;
            self.uomService.search(BiUrls.UOM, BiUrls.SEARCH_P_UOM, self.uomReg, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedPUom(res);
                self.loader = false;
            }, function (error) {
                console.error(error);
            });
            resolve('completed');
        });
    };
    // By Lalu
    UomComponent.prototype.loadSearchedPUom = function (res) {
        var self = this;
        self.uomList = (res != undefined) ? res.data.pageElements : [];
        self.totalUom = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalUom);
    };
    UomComponent.prototype.onSave = function () {
        var validate = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        }
        else {
            var self_1 = this;
            self_1.loader = true;
            self_1.saveButton = true;
            if (self_1.isEdit) {
                console.log('ON EDIT');
                self_1.uomService.update(BiUrls.UOM, self_1.uomData).then(function (res) {
                    self_1.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                self_1.uomService.save(BiUrls.UOM, self_1.uomData).then(function (res) {
                    self_1.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    };
    UomComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalUom / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            self.totalPages;
        var text = type == 'new' ? 'UOM saved successfully' : 'Changes saved successfully';
        if (result.error == undefined && result.success == true) {
            self.toastr.showSuccess(text);
            try {
                if (self.uomReg != '') {
                    self.searchPUom().then(function (res) {
                        self.setPageFieldsAfterLoading();
                    });
                }
                else {
                    self.loadUom().then(function (res) {
                        self.setPageFieldsAfterLoading();
                    });
                }
            }
            catch (e) {
                console.log(e);
                self.setPageFieldsAfterLoading();
            }
        }
        else {
            self.toastr.showError(result.errorMessage ? result.errorMessage : 'Failed to save UOM');
            self.saveButton = false;
            self.loader = false;
        }
        self.currentPage = self.pageNo + 1;
    };
    UomComponent.prototype.setPageFieldsAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.uomPage = false;
        self.isEdit = false;
        self.loader = false;
    };
    UomComponent.prototype.clickEdit = function (uom) {
        console.log('On Edit Controller ...');
        var self = this;
        self.loader = true;
        self.selectedUomId = null;
        self.uomService.getDataById(BiUrls.UOM, uom.id).then(function (res) {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the UOM');
                self.loadUom();
            }
            else {
                uom = res.data;
                self.isEdit = true;
                self.loader = false;
                self.mainPage = false;
                self.uomPage = true;
                self.uomData = JSON.parse(JSON.stringify(uom));
            }
            self.loader = false;
        }, function (error) {
            console.error(error);
        });
    };
    UomComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.uomPage = false;
        this.selectedUomId = null;
        this.uomData = {};
        this.isEdit = false;
    };
    UomComponent.prototype.delete = function (uom) {
        var self = this;
        self.uomService.delete(BiUrls.UOM, uom.id).then(function (response) {
            self.loader = false;
            self.pageNo = self.uomList.length == 1 ?
                self.totalUom == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadUom();
            if (response == undefined || response.data == undefined) {
                self.toastr.showError('Unable to remove UOM');
            }
            else {
                self.toastr.showSuccess(uom.name + ' removed successfully');
            }
        }, function (error) {
            console.error(error);
        });
    };
    UomComponent.prototype.removeUom = function (uom) {
        var r = confirm('Are you sure you want to remove the UOM ' + uom.name + ' ?');
        if (r == true) {
            this.delete(uom);
        }
    };
    UomComponent.prototype.validater = function () {
        if (this.uomData.name == undefined || this.uomData.name.trim() == '') {
            return 'Please enter the name for UOM';
        }
        else {
            this.uomData.name = this.uomData.name.trim();
            this.uomData.uomDesc = this.uomData.uomDesc != undefined ?
                this.uomData.uomDesc.trim() : null;
            return '';
        }
    };
    return UomComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/valueStream.component.ts

var valueStream_component_ValueStreamComponent = /*@__PURE__*/ (function () {
    function ValueStreamComponent(vsService, toastr, vcr) {
        this.vsService = vsService;
        this.toastr = toastr;
        this.vcr = vcr;
        this.lastRegex = '';
        this.sPage = 0;
        this.vsReg = '';
        this.vsData = {
            id: null, name: '', valueStreamCode: null,
            shortDesc: '', longDesc: '', deleted: 0
        };
        this.mainPage = true;
        this.vsPage = false;
        this.vsList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.onStart = false;
        this.isEdit = false;
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.currentPage = 1;
        this.totalvs = 0;
        this.totalPages = 0;
        this.loader = false;
        this.toastr.setViewRef(vcr);
    }
    ValueStreamComponent.prototype.ngOnInit = function () {
        if (this.vsService.isBIAdmin) {
            this.loadVs();
        }
        else {
            this.accessDenied = true;
        }
    };
    ValueStreamComponent.prototype.entityOps = function (event) {
        if (this.selectedVSId == null) {
            this.selectedVSId = event.target.id;
        }
        else {
            this.selectedVSId = null;
        }
    };
    ValueStreamComponent.prototype.closeDropDown = function (event) {
        this.selectedVSId = null;
    };
    // For Pagination
    ValueStreamComponent.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.vsReg != '') {
            this.searchPValueStream();
        }
        else {
            this.loadVs();
        }
        this.setEndingPage(this.totalvs);
    };
    ValueStreamComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    // For Pagination
    ValueStreamComponent.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalvs / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadVs();
    };
    ValueStreamComponent.prototype.loadVs = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            _this.vsService.getDataByPage(BiUrls.VALUESTREAM, self.pageNo, self.pageSize).then(function (res) {
                self.vsList = [];
                self.totalPages = 0;
                self.totalvs = 0;
                if (res != undefined) {
                    self.vsList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalvs = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.setEndingPage(self.totalvs);
                self.mainPage = true;
                self.loader = false;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    ValueStreamComponent.prototype.addNewVs = function () {
        this.mainPage = false;
        this.vsPage = true;
        this.vsData = { id: null, name: '', shortDesc: '', longDesc: '', deleted: 0 };
    };
    ValueStreamComponent.prototype.searchPValueStream = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.mainPage = true;
            self.vsList = [];
            if (self.vsReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.vsReg;
            self.vsService.search(BiUrls.VALUESTREAM, BiUrls.SEARCH_P_VALUESTREAM, self.vsReg, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedData(res);
                self.loader = false;
            }, function (error) {
                console.error(error);
            });
            resolve('completed');
        });
    };
    ValueStreamComponent.prototype.loadSearchedData = function (res) {
        var self = this;
        self.vsList = (res != undefined) ? res.data.pageElements : [];
        self.totalvs = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalvs);
    };
    ValueStreamComponent.prototype.onSave = function () {
        var validate = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        }
        else {
            var self_1 = this;
            self_1.saveButton = true;
            if (self_1.isEdit) {
                console.log('ON EDIT');
                self_1.vsService.update(BiUrls.VALUESTREAM, self_1.vsData).then(function (res) {
                    self_1.loadAfterSaveOrEdit(res, 'edit');
                });
            }
            else {
                console.log('ON SAVE');
                self_1.vsService.save(BiUrls.VALUESTREAM, self_1.vsData).then(function (res) {
                    self_1.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    };
    ValueStreamComponent.prototype.loadAfterSaveOrEdit = function (result, type) {
        var self = this;
        self.totalPages = Math.floor(self.totalvs / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        self.currentPage = self.pageNo + 1;
        var text = type == 'new' ?
            'Value Stream saved successfully' :
            'Changes saved successfully';
        if (self.vsReg != '') {
            self.searchPValueStream().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError(result.statusText);
                }
            });
        }
        else {
            self.loadVs().then(function (res) {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toastr.showSuccess(text);
                }
                else {
                    self.toastr.showError(result.statusText);
                }
            });
        }
    };
    ValueStreamComponent.prototype.setPageFieldsAfterLoading = function () {
        var self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.vsPage = false;
        self.isEdit = false;
    };
    ValueStreamComponent.prototype.clickEdit = function (vs) {
        console.log('On Edit Controller ...');
        var self = this;
        self.loader = true;
        self.selectedVSId = null;
        self.vsService.getDataById(BiUrls.VALUESTREAM, vs.id).then(function (res) {
            if (res == undefined || (res.error != undefined && res.status != true)) {
                self.toastr.showError('Cannot load Value stream');
                self.mainPage = true;
            }
            else {
                vs = res.data;
                self.isEdit = true;
                self.mainPage = false;
                self.vsPage = true;
                self.vsData = JSON.parse(JSON.stringify(vs));
            }
            self.loader = false;
        });
    };
    ValueStreamComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.vsPage = false;
        this.vsData = {};
        this.isEdit = false;
        this.selectedVSId = null;
    };
    ValueStreamComponent.prototype.delete = function (vs) {
        var self = this;
        self.vsService.delete(BiUrls.VALUESTREAM, vs.id).then(function (response) {
            self.loader = false;
            self.pageNo = self.vsList.length == 1 ?
                self.totalvs == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadVs();
            if (response != undefined) {
                self.toastr.showSuccess(vs.name + ' removed successfully');
            }
            else {
                self.toastr.showError('Unable to remove Value Stream ');
            }
        }, function (error) {
            console.log(error);
        });
    };
    ValueStreamComponent.prototype.removeVs = function (vs) {
        var r = confirm('Are you sure you want to remove the value stream ' + vs.name + ' ?');
        if (r == true) {
            this.delete(vs);
        }
        this.selectedVSId = null;
    };
    ValueStreamComponent.prototype.validater = function () {
        if (this.vsData.name == undefined ||
            this.vsData.name.trim() == '') {
            return 'Please enter the name for Value Stream';
        }
        else {
            this.vsData.name = this.vsData.name.trim();
            this.vsData.shortDesc = this.vsData.shortDesc != undefined ?
                this.vsData.shortDesc.trim() : null;
            this.vsData.longDesc = this.vsData.longDesc ? this.vsData.longDesc.trim() : null;
            return '';
        }
    };
    return ValueStreamComponent;
}());



// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/config.js
var internal_config = __webpack_require__("lKpf");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/InnerSubscriber.js
var InnerSubscriber = __webpack_require__("pHYG");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/OuterSubscriber.js
var OuterSubscriber = __webpack_require__("1E73");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Scheduler.js
var Scheduler = __webpack_require__("Wubi");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subject.js
var Subject = __webpack_require__("tUzZ");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/SubjectSubscription.js
var SubjectSubscription = __webpack_require__("7HNm");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscriber.js
var Subscriber = __webpack_require__("p1Bo");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromPromise.js
var fromPromise = __webpack_require__("CPX7");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/fromIterable.js
var fromIterable = __webpack_require__("qpVq");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/root.js
var util_root = __webpack_require__("Dovw");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/tryCatch.js
var tryCatch = __webpack_require__("H74/");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/errorObject.js
var errorObject = __webpack_require__("SQxw");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Observable.js
var internal_Observable = __webpack_require__("lWPP");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/map.js
var operators_map = __webpack_require__("rylm");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/dom/AjaxObservable.js
/** PURE_IMPORTS_START tslib,_.._util_root,_.._util_tryCatch,_.._util_errorObject,_.._Observable,_.._Subscriber,_.._operators_map PURE_IMPORTS_END */







function getCORSRequest() {
    if (util_root["a" /* root */].XMLHttpRequest) {
        return new util_root["a" /* root */].XMLHttpRequest();
    }
    else if (!!util_root["a" /* root */].XDomainRequest) {
        return new util_root["a" /* root */].XDomainRequest();
    }
    else {
        throw new Error('CORS is not supported by your browser');
    }
}
function getXMLHttpRequest() {
    if (util_root["a" /* root */].XMLHttpRequest) {
        return new util_root["a" /* root */].XMLHttpRequest();
    }
    else {
        var progId = void 0;
        try {
            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
            for (var i = 0; i < 3; i++) {
                try {
                    progId = progIds[i];
                    if (new util_root["a" /* root */].ActiveXObject(progId)) {
                        break;
                    }
                }
                catch (e) {
                    //suppress exceptions
                }
            }
            return new util_root["a" /* root */].ActiveXObject(progId);
        }
        catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function ajaxGet(url, headers) {
    if (headers === void 0) {
        headers = null;
    }
    return new AjaxObservable_AjaxObservable({ method: 'GET', url: url, headers: headers });
}
function ajaxPost(url, body, headers) {
    return new AjaxObservable_AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
}
function ajaxDelete(url, headers) {
    return new AjaxObservable_AjaxObservable({ method: 'DELETE', url: url, headers: headers });
}
function ajaxPut(url, body, headers) {
    return new AjaxObservable_AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
}
function ajaxPatch(url, body, headers) {
    return new AjaxObservable_AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
}
var mapResponse = Object(operators_map["a" /* map */])(function (x, index) { return x.response; });
function ajaxGetJSON(url, headers) {
    return mapResponse(new AjaxObservable_AjaxObservable({
        method: 'GET',
        url: url,
        responseType: 'json',
        headers: headers
    }));
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var AjaxObservable_AjaxObservable = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        var _this = _super.call(this) || this;
        var request = {
            async: true,
            createXHR: function () {
                return this.crossDomain ? getCORSRequest() : getXMLHttpRequest();
            },
            crossDomain: true,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') {
            request.url = urlOrRequest;
        }
        else {
            for (var prop in urlOrRequest) {
                if (urlOrRequest.hasOwnProperty(prop)) {
                    request[prop] = urlOrRequest[prop];
                }
            }
        }
        _this.request = request;
        return _this;
    }
    /** @deprecated This is an internal implementation detail, do not use. */
    AjaxObservable.prototype._subscribe = function (subscriber) {
        return new AjaxObservable_AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
     * @nocollapse
    */
    AjaxObservable.create = (function () {
        var create = function (urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = ajaxGet;
        create.post = ajaxPost;
        create.delete = ajaxDelete;
        create.put = ajaxPut;
        create.patch = ajaxPatch;
        create.getJSON = ajaxGetJSON;
        return create;
    })();
    return AjaxObservable;
}(internal_Observable["a" /* Observable */]));

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AjaxObservable_AjaxSubscriber = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        var _this = _super.call(this, destination) || this;
        _this.request = request;
        _this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) {
            headers['X-Requested-With'] = 'XMLHttpRequest';
        }
        // ensure content type is set
        if (!('Content-Type' in headers) && !(util_root["a" /* root */].FormData && request.body instanceof util_root["a" /* root */].FormData) && typeof request.body !== 'undefined') {
            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        }
        // properly serialize body
        request.body = _this.serializeBody(request.body, request.headers['Content-Type']);
        _this.send();
        return _this;
    }
    AjaxSubscriber.prototype.next = function (e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function () {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = Object(tryCatch["a" /* tryCatch */])(createXHR).call(request);
        if (xhr === errorObject["a" /* errorObject */]) {
            this.error(errorObject["a" /* errorObject */].e);
        }
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) {
                result = Object(tryCatch["a" /* tryCatch */])(xhr.open).call(xhr, method, url, async, user, password);
            }
            else {
                result = Object(tryCatch["a" /* tryCatch */])(xhr.open).call(xhr, method, url, async);
            }
            if (result === errorObject["a" /* errorObject */]) {
                this.error(errorObject["a" /* errorObject */].e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) {
                xhr.withCredentials = !!request.withCredentials;
            }
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? Object(tryCatch["a" /* tryCatch */])(xhr.send).call(xhr, body) : Object(tryCatch["a" /* tryCatch */])(xhr.send).call(xhr);
            if (result === errorObject["a" /* errorObject */]) {
                this.error(errorObject["a" /* errorObject */].e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
        if (!body || typeof body === 'string') {
            return body;
        }
        else if (util_root["a" /* root */].FormData && body instanceof util_root["a" /* root */].FormData) {
            return body;
        }
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) {
                contentType = contentType.substring(0, splitIndex);
            }
        }
        switch (contentType) {
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]); }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
        for (var key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    };
    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) {
                progressSubscriber.error(e);
            }
            subscriber.error(new AjaxObservable_AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function (e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if (util_root["a" /* root */].XDomainRequest) {
                    xhr.onprogress = xhrProgress_1;
                }
                else {
                    xhr.upload.onprogress = xhrProgress_1;
                }
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function (e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) {
                    progressSubscriber.error(e);
                }
                subscriber.error(new AjaxObservable_AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) {
                    status_1 = response ? 200 : 0;
                }
                // 4xx and 5xx should error (https://www.w3.org/Protocols/rfc2616/rfc2616-sec10.html)
                if (status_1 < 400) {
                    if (progressSubscriber) {
                        progressSubscriber.complete();
                    }
                    subscriber.next(e);
                    subscriber.complete();
                }
                else {
                    if (progressSubscriber) {
                        progressSubscriber.error(e);
                    }
                    subscriber.error(new AjaxObservable_AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function () {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
            xhr.abort();
        }
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}(Subscriber["a" /* Subscriber */]));

/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */
var AjaxResponse = /*@__PURE__*/ (function () {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}());

/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */
var AjaxObservable_AjaxError = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AjaxError, _super);
    function AjaxError(message, xhr, request) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.xhr = xhr;
        _this.request = request;
        _this.status = xhr.status;
        _this.responseType = xhr.responseType || request.responseType;
        _this.response = parseXhrResponse(_this.responseType, xhr);
        _this.name = 'AjaxError';
        Object.setPrototypeOf(_this, AjaxError.prototype);
        return _this;
    }
    return AjaxError;
}(Error));

function parseXhrResponse(responseType, xhr) {
    switch (responseType) {
        case 'json':
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any XMLHttpRequest is defined to always have 'response' inferring xhr as never for the else clause.
            if ('response' in xhr) {
                //IE does not support json as responseType, parse it internally
                return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
            }
            else {
                return JSON.parse(xhr.responseText || 'null');
            }
        case 'xml':
            return xhr.responseXML;
        case 'text':
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any XMLHttpRequest is defined to always have 'response' inferring xhr as never for the else sub-expression.
            return ('response' in xhr) ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */
var AjaxObservable_AjaxTimeoutError = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        var _this = _super.call(this, 'ajax timeout', xhr, request) || this;
        Object.setPrototypeOf(_this, AjaxTimeoutError.prototype);
        return _this;
    }
    return AjaxTimeoutError;
}(AjaxObservable_AjaxError));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/dom/ajax.js
/** PURE_IMPORTS_START _AjaxObservable PURE_IMPORTS_END */

var ajax = AjaxObservable_AjaxObservable.create;
//# sourceMappingURL=ajax.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Subscription.js
var Subscription = __webpack_require__("HC03");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/ReplaySubject.js
var ReplaySubject = __webpack_require__("NG/L");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/dom/WebSocketSubject.js
/** PURE_IMPORTS_START tslib,_.._Subject,_.._Subscriber,_.._Observable,_.._Subscription,_.._ReplaySubject,_.._util_tryCatch,_.._util_errorObject PURE_IMPORTS_END */








var DEFAULT_WEBSOCKET_CONFIG = {
    url: '',
    deserializer: function (e) { return JSON.parse(e.data); },
    serializer: function (value) { return JSON.stringify(value); },
};
var WEBSOCKETSUBJECT_INVALID_ERROR_OBJECT = 'WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }';
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var WebSocketSubject_WebSocketSubject = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        var _this = _super.call(this) || this;
        if (urlConfigOrSource instanceof internal_Observable["a" /* Observable */]) {
            _this.destination = destination;
            _this.source = urlConfigOrSource;
        }
        else {
            var config = _this._config = tslib_es6["__assign"]({}, DEFAULT_WEBSOCKET_CONFIG);
            config.WebSocketCtor = WebSocket;
            _this._output = new Subject["b" /* Subject */]();
            if (typeof urlConfigOrSource === 'string') {
                config.url = urlConfigOrSource;
            }
            else {
                for (var key in urlConfigOrSource) {
                    if (urlConfigOrSource.hasOwnProperty(key)) {
                        config[key] = urlConfigOrSource[key];
                    }
                }
            }
            if (!config.WebSocketCtor) {
                throw new Error('no WebSocket constructor can be found');
            }
            _this.destination = new ReplaySubject["a" /* ReplaySubject */]();
        }
        return _this;
    }
    WebSocketSubject.prototype.lift = function (operator) {
        var sock = new WebSocketSubject(this._config, this.destination);
        sock.operator = operator;
        sock.source = this;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function () {
        this._socket = null;
        if (!this.source) {
            this.destination = new ReplaySubject["a" /* ReplaySubject */]();
        }
        this._output = new Subject["b" /* Subject */]();
    };
    /**
     * Creates an {@link Observable}, that when subscribed to, sends a message,
     * defined be the `subMsg` function, to the server over the socket to begin a
     * subscription to data over that socket. Once data arrives, the
     * `messageFilter` argument will be used to select the appropriate data for
     * the resulting Observable. When teardown occurs, either due to
     * unsubscription, completion or error, a message defined by the `unsubMsg`
     * argument will be send to the server over the WebSocketSubject.
     *
     * @param subMsg A function to generate the subscription message to be sent to
     * the server. This will still be processed by the serializer in the
     * WebSocketSubject's config. (Which defaults to JSON serialization)
     * @param unsubMsg A function to generate the unsubscription message to be
     * sent to the server at teardown. This will still be processed by the
     * serializer in the WebSocketSubject's config.
     * @param messageFilter A predicate for selecting the appropriate messages
     * from the server for the output stream.
     */
    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new internal_Observable["a" /* Observable */](function (observer) {
            var result = Object(tryCatch["a" /* tryCatch */])(subMsg)();
            if (result === errorObject["a" /* errorObject */]) {
                observer.error(errorObject["a" /* errorObject */].e);
            }
            else {
                self.next(result);
            }
            var subscription = self.subscribe(function (x) {
                var result = Object(tryCatch["a" /* tryCatch */])(messageFilter)(x);
                if (result === errorObject["a" /* errorObject */]) {
                    observer.error(errorObject["a" /* errorObject */].e);
                }
                else if (result) {
                    observer.next(x);
                }
            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
            return function () {
                var result = Object(tryCatch["a" /* tryCatch */])(unsubMsg)();
                if (result === errorObject["a" /* errorObject */]) {
                    observer.error(errorObject["a" /* errorObject */].e);
                }
                else {
                    self.next(result);
                }
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function () {
        var _this = this;
        var _a = this._config, WebSocketCtor = _a.WebSocketCtor, protocol = _a.protocol, url = _a.url, binaryType = _a.binaryType;
        var observer = this._output;
        var socket = null;
        try {
            socket = protocol ?
                new WebSocketCtor(url, protocol) :
                new WebSocketCtor(url);
            this._socket = socket;
            if (binaryType) {
                this._socket.binaryType = binaryType;
            }
        }
        catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new Subscription["a" /* Subscription */](function () {
            _this._socket = null;
            if (socket && socket.readyState === 1) {
                socket.close();
            }
        });
        socket.onopen = function (e) {
            var openObserver = _this._config.openObserver;
            if (openObserver) {
                openObserver.next(e);
            }
            var queue = _this.destination;
            _this.destination = Subscriber["a" /* Subscriber */].create(function (x) {
                if (socket.readyState === 1) {
                    var serializer = _this._config.serializer;
                    var msg = Object(tryCatch["a" /* tryCatch */])(serializer)(x);
                    if (msg === errorObject["a" /* errorObject */]) {
                        _this.destination.error(errorObject["a" /* errorObject */].e);
                        return;
                    }
                    socket.send(msg);
                }
            }, function (e) {
                var closingObserver = _this._config.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                if (e && e.code) {
                    socket.close(e.code, e.reason);
                }
                else {
                    observer.error(new TypeError(WEBSOCKETSUBJECT_INVALID_ERROR_OBJECT));
                }
                _this._resetState();
            }, function () {
                var closingObserver = _this._config.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof ReplaySubject["a" /* ReplaySubject */]) {
                subscription.add(queue.subscribe(_this.destination));
            }
        };
        socket.onerror = function (e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function (e) {
            _this._resetState();
            var closeObserver = _this._config.closeObserver;
            if (closeObserver) {
                closeObserver.next(e);
            }
            if (e.wasClean) {
                observer.complete();
            }
            else {
                observer.error(e);
            }
        };
        socket.onmessage = function (e) {
            var deserializer = _this._config.deserializer;
            var result = Object(tryCatch["a" /* tryCatch */])(deserializer)(e);
            if (result === errorObject["a" /* errorObject */]) {
                observer.error(errorObject["a" /* errorObject */].e);
            }
            else {
                observer.next(result);
            }
        };
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    WebSocketSubject.prototype._subscribe = function (subscriber) {
        var _this = this;
        var source = this.source;
        if (source) {
            return source.subscribe(subscriber);
        }
        if (!this._socket) {
            this._connectSocket();
        }
        var subscription = new Subscription["a" /* Subscription */]();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function () {
            var _socket = _this._socket;
            if (_this._output.observers.length === 0) {
                if (_socket && _socket.readyState === 1) {
                    _socket.close();
                }
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function () {
        var _a = this, source = _a.source, _socket = _a._socket;
        if (_socket && _socket.readyState === 1) {
            _socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) {
            this.destination = new ReplaySubject["a" /* ReplaySubject */]();
        }
    };
    return WebSocketSubject;
}(Subject["a" /* AnonymousSubject */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/observable/dom/webSocket.js
/** PURE_IMPORTS_START _WebSocketSubject PURE_IMPORTS_END */

/**
 * Wrapper around the w3c-compatible WebSocket object provided by the browser.
 *
 * @example <caption>Wraps browser WebSocket</caption>
 *
 * import { webSocket } from 'rxjs/webSocket';
 *
 * let socket$ = webSocket('ws://localhost:8081');
 *
 * socket$.subscribe(
 *   (msg) => console.log('message received: ' + msg),
 *   (err) => console.log(err),
 *   () => console.log('complete')
 * );
 *
 * socket$.next(JSON.stringify({ op: 'hello' }));
 *
 * @example <caption>Wraps WebSocket from nodejs-webSocket (using node.js)</caption>
 *
 * import { webSocket } from 'rxjs/webSocket';
 * import { w3cwebSocket } from 'webSocket';
 *
 * let socket$ = webSocket({
 *   url: 'ws://localhost:8081',
 *   WebSocketCtor: w3cwebSocket
 * });
 *
 * socket$.subscribe(
 *   (msg) => console.log('message received: ' + msg),
 *   (err) => console.log(err),
 *   () => console.log('complete')
 * );
 *
 * socket$.next(JSON.stringify({ op: 'hello' }));
 *
 * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the webSocket as an url or a structure defining the webSocket object
 * @return {WebSocketSubject}
 */
function webSocket(urlConfigOrSource) {
    return new WebSocketSubject_WebSocketSubject(urlConfigOrSource);
}
//# sourceMappingURL=webSocket.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/combineLatest.js
var combineLatest = __webpack_require__("jAXq");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/range.js
var range = __webpack_require__("j+ls");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/observable/SubscribeOnObservable.js
var SubscribeOnObservable = __webpack_require__("Y9kR");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/timestamp.js
var timestamp = __webpack_require__("Fv6v");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/timeInterval.js
var timeInterval = __webpack_require__("VHBj");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/groupBy.js
var groupBy = __webpack_require__("SYCm");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/throttle.js
var throttle = __webpack_require__("QFiC");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/rxSubscriber.js
var rxSubscriber = __webpack_require__("Egod");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/iterator.js
var iterator = __webpack_require__("uOsm");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/symbol/observable.js
var symbol_observable = __webpack_require__("V9Cg");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js
var ArgumentOutOfRangeError = __webpack_require__("uxTV");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/EmptyError.js
var EmptyError = __webpack_require__("/Nc3");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/Immediate.js
var Immediate = __webpack_require__("bdRZ");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/ObjectUnsubscribedError.js
var ObjectUnsubscribedError = __webpack_require__("LHMe");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/TimeoutError.js
var TimeoutError = __webpack_require__("7mk3");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/UnsubscriptionError.js
var UnsubscriptionError = __webpack_require__("kk5+");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/util/applyMixins.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function applyMixins(derivedCtor, baseCtors) {
    for (var i = 0, len = baseCtors.length; i < len; i++) {
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
//# sourceMappingURL=applyMixins.js.map

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/hostReportError.js
var hostReportError = __webpack_require__("BdDE");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/identity.js
var identity = __webpack_require__("92UZ");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArray.js
var isArray = __webpack_require__("YgML");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isArrayLike.js
var isArrayLike = __webpack_require__("6iAM");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isDate.js
var isDate = __webpack_require__("1SoI");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isFunction.js
var isFunction = __webpack_require__("bOhj");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isIterable.js
var isIterable = __webpack_require__("I6Lf");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isNumeric.js
var isNumeric = __webpack_require__("03ca");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isObject.js
var isObject = __webpack_require__("ai7y");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isInteropObservable.js
var isInteropObservable = __webpack_require__("CmsN");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isPromise.js
var isPromise = __webpack_require__("XTlk");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/isScheduler.js
var isScheduler = __webpack_require__("5eyr");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/noop.js
var util_noop = __webpack_require__("VWaN");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/not.js
var not = __webpack_require__("8LP5");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/pipe.js
var pipe = __webpack_require__("eYUY");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeTo.js
var subscribeTo = __webpack_require__("dfzL");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToArray.js
var subscribeToArray = __webpack_require__("9hho");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToIterable.js
var subscribeToIterable = __webpack_require__("alQS");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToObservable.js
var subscribeToObservable = __webpack_require__("JzXe");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToPromise.js
var subscribeToPromise = __webpack_require__("bqNY");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/subscribeToResult.js
var subscribeToResult = __webpack_require__("3SjU");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/toSubscriber.js
var toSubscriber = __webpack_require__("SAuu");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal-compatibility/index.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */























































//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/bindCallback.js

_esm5["d" /* Observable */].bindCallback = _esm5["j" /* bindCallback */];
//# sourceMappingURL=bindCallback.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/bindNodeCallback.js

_esm5["d" /* Observable */].bindNodeCallback = _esm5["k" /* bindNodeCallback */];
//# sourceMappingURL=bindNodeCallback.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/combineLatest.js

_esm5["d" /* Observable */].combineLatest = _esm5["l" /* combineLatest */];
//# sourceMappingURL=combineLatest.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/concat.js

_esm5["d" /* Observable */].concat = _esm5["m" /* concat */];
//# sourceMappingURL=concat.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/defer.js

_esm5["d" /* Observable */].defer = _esm5["n" /* defer */];
//# sourceMappingURL=defer.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/empty.js

_esm5["d" /* Observable */].empty = _esm5["o" /* empty */];
//# sourceMappingURL=empty.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/forkJoin.js

_esm5["d" /* Observable */].forkJoin = _esm5["p" /* forkJoin */];
//# sourceMappingURL=forkJoin.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/from.js

_esm5["d" /* Observable */].from = _esm5["q" /* from */];
//# sourceMappingURL=from.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/fromEvent.js

_esm5["d" /* Observable */].fromEvent = _esm5["r" /* fromEvent */];
//# sourceMappingURL=fromEvent.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/fromEventPattern.js

_esm5["d" /* Observable */].fromEventPattern = _esm5["s" /* fromEventPattern */];
//# sourceMappingURL=fromEventPattern.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/fromPromise.js

_esm5["d" /* Observable */].fromPromise = _esm5["q" /* from */];
//# sourceMappingURL=fromPromise.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/generate.js

_esm5["d" /* Observable */].generate = _esm5["t" /* generate */];
//# sourceMappingURL=generate.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/if.js

_esm5["d" /* Observable */].if = _esm5["u" /* iif */];
//# sourceMappingURL=if.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/interval.js

_esm5["d" /* Observable */].interval = _esm5["v" /* interval */];
//# sourceMappingURL=interval.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/merge.js

_esm5["d" /* Observable */].merge = _esm5["w" /* merge */];
//# sourceMappingURL=merge.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/race.js

_esm5["d" /* Observable */].race = _esm5["B" /* race */];
//# sourceMappingURL=race.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/never.js

function staticNever() {
    return _esm5["c" /* NEVER */];
}
_esm5["d" /* Observable */].never = staticNever;
//# sourceMappingURL=never.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/onErrorResumeNext.js

_esm5["d" /* Observable */].onErrorResumeNext = _esm5["y" /* onErrorResumeNext */];
//# sourceMappingURL=onErrorResumeNext.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/pairs.js

_esm5["d" /* Observable */].pairs = _esm5["z" /* pairs */];
//# sourceMappingURL=pairs.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/range.js

_esm5["d" /* Observable */].range = _esm5["C" /* range */];
//# sourceMappingURL=range.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/using.js

_esm5["d" /* Observable */].using = _esm5["F" /* using */];
//# sourceMappingURL=using.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/throw.js

_esm5["d" /* Observable */].throw = _esm5["D" /* throwError */];
_esm5["d" /* Observable */].throwError = _esm5["D" /* throwError */];
//# sourceMappingURL=throw.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/timer.js

_esm5["d" /* Observable */].timer = _esm5["E" /* timer */];
//# sourceMappingURL=timer.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/zip.js

_esm5["d" /* Observable */].zip = _esm5["G" /* zip */];
//# sourceMappingURL=zip.js.map
// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/ajax/index.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/dom/ajax.js


_esm5["d" /* Observable */].ajax = ajax;
//# sourceMappingURL=ajax.js.map
// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/webSocket/index.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */


//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/observable/dom/webSocket.js


_esm5["d" /* Observable */].webSocket = webSocket;
//# sourceMappingURL=webSocket.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/buffer.js

/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */
function buffer_buffer(closingNotifier) {
    return Object(operators["buffer"])(closingNotifier)(this);
}
//# sourceMappingURL=buffer.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/buffer.js


_esm5["d" /* Observable */].prototype.buffer = buffer_buffer;
//# sourceMappingURL=buffer.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/bufferCount.js

/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    return Object(operators["bufferCount"])(bufferSize, startBufferEvery)(this);
}
//# sourceMappingURL=bufferCount.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/bufferCount.js


_esm5["d" /* Observable */].prototype.bufferCount = bufferCount;
//# sourceMappingURL=bufferCount.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/bufferTime.js



/* tslint:enable:max-line-length */
/**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=asyncScheduler] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = _esm5["i" /* asyncScheduler */];
    if (Object(isScheduler["a" /* isScheduler */])(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return Object(operators["bufferTime"])(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
}
//# sourceMappingURL=bufferTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/bufferTime.js


_esm5["d" /* Observable */].prototype.bufferTime = bufferTime;
//# sourceMappingURL=bufferTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/bufferToggle.js

/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */
function bufferToggle(openings, closingSelector) {
    return Object(operators["bufferToggle"])(openings, closingSelector)(this);
}
//# sourceMappingURL=bufferToggle.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/bufferToggle.js


_esm5["d" /* Observable */].prototype.bufferToggle = bufferToggle;
//# sourceMappingURL=bufferToggle.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/bufferWhen.js

/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return Object(operators["bufferWhen"])(closingSelector)(this);
}
//# sourceMappingURL=bufferWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/bufferWhen.js


_esm5["d" /* Observable */].prototype.bufferWhen = bufferWhen;
//# sourceMappingURL=bufferWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/combineAll.js

/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */
function combineAll(project) {
    return Object(operators["combineAll"])(project)(this);
}
//# sourceMappingURL=combineAll.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/combineAll.js


_esm5["d" /* Observable */].prototype.combineAll = combineAll;
//# sourceMappingURL=combineAll.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/combineLatest.js


/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */
function combineLatest_combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && Object(isArray["a" /* isArray */])(observables[0])) {
        observables = observables[0].slice();
    }
    return this.lift.call(_esm5["x" /* of */].apply(void 0, [this].concat(observables)), new combineLatest["a" /* CombineLatestOperator */](project));
}
//# sourceMappingURL=combineLatest.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/combineLatest.js


_esm5["d" /* Observable */].prototype.combineLatest = combineLatest_combineLatest;
//# sourceMappingURL=combineLatest.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/concat.js

/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return this.lift.call(_esm5["m" /* concat */].apply(void 0, [this].concat(observables)));
}
//# sourceMappingURL=concat.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/concat.js


_esm5["d" /* Observable */].prototype.concat = concat;
//# sourceMappingURL=concat.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/concatAll.js

/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return Object(operators["concatAll"])()(this);
}
//# sourceMappingURL=concatAll.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/concatAll.js


_esm5["d" /* Observable */].prototype.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/concatMap.js

/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project) {
    return Object(operators["concatMap"])(project)(this);
}
//# sourceMappingURL=concatMap.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/concatMap.js


_esm5["d" /* Observable */].prototype.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/concatMapTo.js

/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable) {
    return Object(operators["concatMapTo"])(innerObservable)(this);
}
//# sourceMappingURL=concatMapTo.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/concatMapTo.js


_esm5["d" /* Observable */].prototype.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/count.js

/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */
function count_count(predicate) {
    return Object(operators["count"])(predicate)(this);
}
//# sourceMappingURL=count.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/count.js


_esm5["d" /* Observable */].prototype.count = count_count;
//# sourceMappingURL=count.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/dematerialize.js

/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */
function dematerialize() {
    return Object(operators["dematerialize"])()(this);
}
//# sourceMappingURL=dematerialize.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/dematerialize.js


_esm5["d" /* Observable */].prototype.dematerialize = dematerialize;
//# sourceMappingURL=dematerialize.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/debounce.js

/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */
function debounce(durationSelector) {
    return Object(operators["debounce"])(durationSelector)(this);
}
//# sourceMappingURL=debounce.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/debounce.js


_esm5["d" /* Observable */].prototype.debounce = debounce;
//# sourceMappingURL=debounce.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/debounceTime.js


/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=asyncScheduler] The {@link SchedulerLike} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    return Object(operators["debounceTime"])(dueTime, scheduler)(this);
}
//# sourceMappingURL=debounceTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/debounceTime.js


_esm5["d" /* Observable */].prototype.debounceTime = debounceTime;
//# sourceMappingURL=debounceTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/defaultIfEmpty.js

/* tslint:enable:max-line-length */
/**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return Object(operators["defaultIfEmpty"])(defaultValue)(this);
}
//# sourceMappingURL=defaultIfEmpty.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/defaultIfEmpty.js


_esm5["d" /* Observable */].prototype.defaultIfEmpty = defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/delay.js


/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=asyncScheduler] The SchedulerLike to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay_delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    return Object(operators["delay"])(delay, scheduler)(this);
}
//# sourceMappingURL=delay.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/delay.js


_esm5["d" /* Observable */].prototype.delay = delay_delay;
//# sourceMappingURL=delay.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/delayWhen.js

/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    return Object(operators["delayWhen"])(delayDurationSelector, subscriptionDelay)(this);
}
//# sourceMappingURL=delayWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/delayWhen.js


_esm5["d" /* Observable */].prototype.delayWhen = delayWhen;
//# sourceMappingURL=delayWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/distinct.js

/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */
function distinct(keySelector, flushes) {
    return Object(operators["distinct"])(keySelector, flushes)(this);
}
//# sourceMappingURL=distinct.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/distinct.js


_esm5["d" /* Observable */].prototype.distinct = distinct;
//# sourceMappingURL=distinct.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/distinctUntilChanged.js

/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return Object(operators["distinctUntilChanged"])(compare, keySelector)(this);
}
//# sourceMappingURL=distinctUntilChanged.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/distinctUntilChanged.js


_esm5["d" /* Observable */].prototype.distinctUntilChanged = distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/distinctUntilKeyChanged.js

/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */
function distinctUntilKeyChanged(key, compare) {
    return Object(operators["distinctUntilKeyChanged"])(key, compare)(this);
}
//# sourceMappingURL=distinctUntilKeyChanged.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/distinctUntilKeyChanged.js


_esm5["d" /* Observable */].prototype.distinctUntilKeyChanged = distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/do.js

/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */
function _do(nextOrObserver, error, complete) {
    return Object(operators["tap"])(nextOrObserver, error, complete)(this);
}
//# sourceMappingURL=do.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/do.js


_esm5["d" /* Observable */].prototype.do = _do;
_esm5["d" /* Observable */].prototype._do = _do;
//# sourceMappingURL=do.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/exhaust.js

/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 */
function exhaust() {
    return Object(operators["exhaust"])()(this);
}
//# sourceMappingURL=exhaust.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/exhaust.js


_esm5["d" /* Observable */].prototype.exhaust = exhaust;
//# sourceMappingURL=exhaust.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/exhaustMap.js

/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = fromEvent(document, 'click');
 * var result = clicks.pipe(exhaustMap((ev) => Rx.Observable.interval(1000).take(5)));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 */
function exhaustMap(project) {
    return Object(operators["exhaustMap"])(project)(this);
}
//# sourceMappingURL=exhaustMap.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/exhaustMap.js


_esm5["d" /* Observable */].prototype.exhaustMap = exhaustMap;
//# sourceMappingURL=exhaustMap.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/expand.js

/* tslint:enable:max-line-length */
/**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (scheduler === void 0) { scheduler = undefined; }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return Object(operators["expand"])(project, concurrent, scheduler)(this);
}
//# sourceMappingURL=expand.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/expand.js


_esm5["d" /* Observable */].prototype.expand = expand;
//# sourceMappingURL=expand.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/elementAt.js

/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */
function elementAt(index, defaultValue) {
    return operators["elementAt"].apply(undefined, arguments)(this);
}
//# sourceMappingURL=elementAt.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/elementAt.js


_esm5["d" /* Observable */].prototype.elementAt = elementAt;
//# sourceMappingURL=elementAt.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/filter.js

/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter_filter(predicate, thisArg) {
    return Object(operators["filter"])(predicate, thisArg)(this);
}
//# sourceMappingURL=filter.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/filter.js


_esm5["d" /* Observable */].prototype.filter = filter_filter;
//# sourceMappingURL=filter.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/finally.js

/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete, error or unsubscribe.
 *
 * <span class="informal">Ensure a given function will be called when a stream ends, no matter why it ended.</span>
 *
 * `finally` method accepts as a single parameter a function. This function does not accept any parameters and
 * should not return anything. It will be called whenever source Observable completes, errors or is unsubscribed,
 * which makes it good candidate to perform any necessary clean up or side effects when Observable terminates,
 * no matter how or why it terminated.
 *
 * Observable returned by `finally` will simply mirror source Observable - each time it is subscribed, source
 * Observable will be subscribed underneath.
 *
 * Note that behavior of `finally` will be repeated per every subscription, so if resulting Observable has
 * many subscribers, function passed to `finally` might be potentially called multiple times.
 *
 * Remember also that `finally` differs quite a lot from passing complete or error handler to {@link subscribe}. It will
 * return an Observable which can be further chained, while `subscribe` returns Subscription, basically ending Observable
 * chain. Function passed to `finally` will be called also when consumer of resulting Observable unsubscribes from it,
 * while handlers passed to `subscribe` will not (even complete handler). But most importantly, `finally` does not start
 * an execution of source Observable, like `subscribe` does, allowing you to set up all necessary hooks before
 * passing Observable further, even without specific knowledge how or when it will be used.
 *
 *
 * @example <caption>Call finally after complete notification</caption>
 * Rx.Observable.of(1, 2, 3)
 * .finally(() => console.log('I was finalized!'))
 * .map(x => x * 2) // `finally` returns an Observable, so we still can chain operators.
 * .subscribe(
 *   val => console.log(val),
 *   err => {},
 *   () => console.log('I completed!')
 * );
 *
 * // Logs:
 * // 1
 * // 2
 * // 3
 * // "I completed!"
 * // "I was finalized!"
 *
 *
 *
 * @example <caption>Call finally after consumer unsubscribes</caption>
 * const o = Rx.Observable.interval(1000)
 * .finally(() => console.log('Timer stopped'));
 *
 * const subscription = o.subscribe(
 *   val => console.log(val),
 *   err => {},
 *   () => console.log('Complete!') // Will not be called, since complete handler
 * );                               // does not react to unsubscription, just to
 *                                  // complete notification sent by the Observable itself.
 *
 * setTimeout(() => subscription.unsubscribe(), 2500);
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // "Timer stopped" after 2.5s
 *
 * @see {@link using}
 *
 * @param {function} callback Function to be called when source terminates (completes, errors or is unsubscribed).
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @name finally
 * @owner Observable
 */
function _finally(callback) {
    return Object(operators["finalize"])(callback)(this);
}
//# sourceMappingURL=finally.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/finally.js


_esm5["d" /* Observable */].prototype.finally = _finally;
_esm5["d" /* Observable */].prototype._finally = _finally;
//# sourceMappingURL=finally.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/find.js

/* tslint:enable:max-line-length */
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */
function find(predicate, thisArg) {
    return Object(operators["find"])(predicate, thisArg)(this);
}
//# sourceMappingURL=find.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/find.js


_esm5["d" /* Observable */].prototype.find = find;
//# sourceMappingURL=find.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/findIndex.js

/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */
function findIndex(predicate, thisArg) {
    return Object(operators["findIndex"])(predicate, thisArg)(this);
}
//# sourceMappingURL=findIndex.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/findIndex.js


_esm5["d" /* Observable */].prototype.findIndex = findIndex;
//# sourceMappingURL=findIndex.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/first.js

/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {T} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first_first() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return operators["first"].apply(void 0, args)(this);
}
//# sourceMappingURL=first.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/first.js


_esm5["d" /* Observable */].prototype.first = first_first;
//# sourceMappingURL=first.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/groupBy.js

/* tslint:enable:max-line-length */
/**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */
function groupBy_groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return Object(operators["groupBy"])(keySelector, elementSelector, durationSelector, subjectSelector)(this);
}
//# sourceMappingURL=groupBy.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/groupBy.js


_esm5["d" /* Observable */].prototype.groupBy = groupBy_groupBy;
//# sourceMappingURL=groupBy.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/ignoreElements.js

/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */
function ignoreElements() {
    return Object(operators["ignoreElements"])()(this);
}
//# sourceMappingURL=ignoreElements.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/ignoreElements.js


_esm5["d" /* Observable */].prototype.ignoreElements = ignoreElements;
//# sourceMappingURL=ignoreElements.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/isEmpty.js

/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */
function isEmpty_isEmpty() {
    return Object(operators["isEmpty"])()(this);
}
//# sourceMappingURL=isEmpty.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/isEmpty.js


_esm5["d" /* Observable */].prototype.isEmpty = isEmpty_isEmpty;
//# sourceMappingURL=isEmpty.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/audit.js

/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */
function audit(durationSelector) {
    return Object(operators["audit"])(durationSelector)(this);
}
//# sourceMappingURL=audit.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/audit.js


_esm5["d" /* Observable */].prototype.audit = audit;
//# sourceMappingURL=audit.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/auditTime.js


/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */
function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    return Object(operators["auditTime"])(duration, scheduler)(this);
}
//# sourceMappingURL=auditTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/auditTime.js


_esm5["d" /* Observable */].prototype.auditTime = auditTime;
//# sourceMappingURL=auditTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/last.js

/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} [predicate] - The condition any source emitted item has to satisfy.
 * @param {any} [defaultValue] - The default value to use if the predicate isn't
 * satisfied, or no values were emitted (if no predicate).
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */
function last() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return operators["last"].apply(void 0, args)(this);
}
//# sourceMappingURL=last.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/last.js


_esm5["d" /* Observable */].prototype.last = last;
//# sourceMappingURL=last.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/let.js
/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
function letProto(func) {
    return func(this);
}
//# sourceMappingURL=let.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/let.js


_esm5["d" /* Observable */].prototype.let = letProto;
_esm5["d" /* Observable */].prototype.letBind = letProto;
//# sourceMappingURL=let.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/every.js

/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */
function every(predicate, thisArg) {
    return Object(operators["every"])(predicate, thisArg)(this);
}
//# sourceMappingURL=every.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/every.js


_esm5["d" /* Observable */].prototype.every = every;
//# sourceMappingURL=every.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/mapTo.js

/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
    return Object(operators["mapTo"])(value)(this);
}
//# sourceMappingURL=mapTo.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/mapTo.js


_esm5["d" /* Observable */].prototype.mapTo = mapTo;
//# sourceMappingURL=mapTo.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/materialize.js

/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */
function materialize() {
    return Object(operators["materialize"])()(this);
}
//# sourceMappingURL=materialize.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/materialize.js


_esm5["d" /* Observable */].prototype.materialize = materialize;
//# sourceMappingURL=materialize.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/max.js

/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */
function max(comparer) {
    return Object(operators["max"])(comparer)(this);
}
//# sourceMappingURL=max.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/max.js


_esm5["d" /* Observable */].prototype.max = max;
//# sourceMappingURL=max.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/merge.js

/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return this.lift.call(_esm5["w" /* merge */].apply(void 0, [this].concat(observables)));
}
//# sourceMappingURL=merge.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/merge.js


_esm5["d" /* Observable */].prototype.merge = merge;
//# sourceMappingURL=merge.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/mergeAll.js

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return Object(operators["mergeAll"])(concurrent)(this);
}
//# sourceMappingURL=mergeAll.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/mergeAll.js


_esm5["d" /* Observable */].prototype.mergeAll = mergeAll;
//# sourceMappingURL=mergeAll.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/mergeMap.js

/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return Object(operators["mergeMap"])(project, concurrent)(this);
}
//# sourceMappingURL=mergeMap.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/mergeMap.js


_esm5["d" /* Observable */].prototype.mergeMap = mergeMap;
_esm5["d" /* Observable */].prototype.flatMap = mergeMap;
//# sourceMappingURL=mergeMap.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/mergeMapTo.js

/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable`.
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return Object(operators["mergeMapTo"])(innerObservable, concurrent)(this);
}
//# sourceMappingURL=mergeMapTo.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/mergeMapTo.js


_esm5["d" /* Observable */].prototype.flatMapTo = mergeMapTo;
_esm5["d" /* Observable */].prototype.mergeMapTo = mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/mergeScan.js

/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return Object(operators["mergeScan"])(accumulator, seed, concurrent)(this);
}
//# sourceMappingURL=mergeScan.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/mergeScan.js


_esm5["d" /* Observable */].prototype.mergeScan = mergeScan;
//# sourceMappingURL=mergeScan.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/min.js

/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */
function min_min(comparer) {
    return Object(operators["min"])(comparer)(this);
}
//# sourceMappingURL=min.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/min.js


_esm5["d" /* Observable */].prototype.min = min_min;
//# sourceMappingURL=min.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/multicast.js

/* tslint:enable:max-line-length */
/**
 * Allows source Observable to be subscribed only once with a Subject of choice,
 * while still sharing its values between multiple subscribers.
 *
 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * `multicast` is an operator that works in two modes.
 *
 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
 *
 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
 * ConnectableObservable, use `refCount`.
 *
 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
 * as well, which should be the input stream modified by any operators you want. Note that in this
 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
 * but you want to subscribe to that Observable only once, this is the mode you would use.
 *
 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
 *
 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
 *
 * @example <caption>Use ConnectableObservable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const connectableSeconds = seconds.multicast(new Subject());
 *
 * connectableSeconds.subscribe(value => console.log('first: ' + value));
 * connectableSeconds.subscribe(value => console.log('second: ' + value));
 *
 * // At this point still nothing happens, even though we subscribed twice.
 *
 * connectableSeconds.connect();
 *
 * // From now on `seconds` are being logged to the console,
 * // twice per every second. `seconds` Observable was however only subscribed once,
 * // so under the hood Observable.interval had only one clock started.
 *
 * @example <caption>Use selector</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds
 *     .multicast(
 *         () => new Subject(),
 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
 *                                         // Because we are inside selector, `seconds` is subscribed once,
 *     )                                   // thus starting only one clock used internally by Observable.interval.
 *     .subscribe();
 *
 * @see {@link publish}
 * @see {@link publishLast}
 * @see {@link publishBehavior}
 * @see {@link publishReplay}
 * @see {@link share}
 * @see {@link shareReplay}
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
 * which the source sequence's elements will be multicast to the selector function input Observable or
 * ConnectableObservable returned by the operator.
 * @param {Function} [selector] - Optional selector function that can use the input stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the input source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
 *
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    return Object(operators["multicast"])(subjectOrSubjectFactory, selector)(this);
}
//# sourceMappingURL=multicast.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/multicast.js


_esm5["d" /* Observable */].prototype.multicast = multicast;
//# sourceMappingURL=multicast.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/observeOn.js

/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {SchedulerLike} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return Object(operators["observeOn"])(scheduler, delay)(this);
}
//# sourceMappingURL=observeOn.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/observeOn.js


_esm5["d" /* Observable */].prototype.observeOn = observeOn;
//# sourceMappingURL=observeOn.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/onErrorResumeNext.js

/* tslint:enable:max-line-length */
/**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */
function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i] = arguments[_i];
    }
    return operators["onErrorResumeNext"].apply(void 0, nextSources)(this);
}
//# sourceMappingURL=onErrorResumeNext.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/onErrorResumeNext.js


_esm5["d" /* Observable */].prototype.onErrorResumeNext = onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/pairwise.js

/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return Object(operators["pairwise"])()(this);
}
//# sourceMappingURL=pairwise.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/pairwise.js


_esm5["d" /* Observable */].prototype.pairwise = pairwise;
//# sourceMappingURL=pairwise.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/partition.js

/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */
function partition(predicate, thisArg) {
    return Object(operators["partition"])(predicate, thisArg)(this);
}
//# sourceMappingURL=partition.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/partition.js


_esm5["d" /* Observable */].prototype.partition = partition;
//# sourceMappingURL=partition.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/pluck.js

/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    return operators["pluck"].apply(void 0, properties)(this);
}
//# sourceMappingURL=pluck.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/pluck.js


_esm5["d" /* Observable */].prototype.pluck = pluck;
//# sourceMappingURL=pluck.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/publish.js

/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
function publish(selector) {
    return Object(operators["publish"])(selector)(this);
}
//# sourceMappingURL=publish.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/publish.js


_esm5["d" /* Observable */].prototype.publish = publish;
//# sourceMappingURL=publish.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/publishBehavior.js

/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return Object(operators["publishBehavior"])(value)(this);
}
//# sourceMappingURL=publishBehavior.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/publishBehavior.js


_esm5["d" /* Observable */].prototype.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/publishReplay.js

/* tslint:enable:max-line-length */
/**
 * @param bufferSize
 * @param windowTime
 * @param selectorOrScheduler
 * @param scheduler
 * @return {Observable<T> | ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */
function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return Object(operators["publishReplay"])(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
}
//# sourceMappingURL=publishReplay.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/publishReplay.js


_esm5["d" /* Observable */].prototype.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/publishLast.js

/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */
function publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return Object(operators["publishLast"])()(this);
}
//# sourceMappingURL=publishLast.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/publishLast.js


_esm5["d" /* Observable */].prototype.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/race.js

/* tslint:enable:max-line-length */
/**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return operators["race"].apply(void 0, observables)(this);
}
//# sourceMappingURL=race.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/race.js


_esm5["d" /* Observable */].prototype.race = race;
//# sourceMappingURL=race.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/reduce.js

/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */
function reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        return Object(operators["reduce"])(accumulator, seed)(this);
    }
    return Object(operators["reduce"])(accumulator)(this);
}
//# sourceMappingURL=reduce.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/reduce.js


_esm5["d" /* Observable */].prototype.reduce = reduce;
//# sourceMappingURL=reduce.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/repeat.js

/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */
function repeat(count) {
    if (count === void 0) { count = -1; }
    return Object(operators["repeat"])(count)(this);
}
//# sourceMappingURL=repeat.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/repeat.js


_esm5["d" /* Observable */].prototype.repeat = repeat;
//# sourceMappingURL=repeat.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/repeatWhen.js

/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
function repeatWhen(notifier) {
    return Object(operators["repeatWhen"])(notifier)(this);
}
//# sourceMappingURL=repeatWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/repeatWhen.js


_esm5["d" /* Observable */].prototype.repeatWhen = repeatWhen;
//# sourceMappingURL=repeatWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/retry.js

/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */
function retry(count) {
    if (count === void 0) { count = -1; }
    return Object(operators["retry"])(count)(this);
}
//# sourceMappingURL=retry.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/retry.js


_esm5["d" /* Observable */].prototype.retry = retry;
//# sourceMappingURL=retry.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/retryWhen.js

/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */
function retryWhen(notifier) {
    return Object(operators["retryWhen"])(notifier)(this);
}
//# sourceMappingURL=retryWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/retryWhen.js


_esm5["d" /* Observable */].prototype.retryWhen = retryWhen;
//# sourceMappingURL=retryWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/sample.js

/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */
function sample(notifier) {
    return Object(operators["sample"])(notifier)(this);
}
//# sourceMappingURL=sample.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/sample.js


_esm5["d" /* Observable */].prototype.sample = sample;
//# sourceMappingURL=sample.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/sampleTime.js


/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=asyncScheduler] The {@link SchedulerLike} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    return Object(operators["sampleTime"])(period, scheduler)(this);
}
//# sourceMappingURL=sampleTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/sampleTime.js


_esm5["d" /* Observable */].prototype.sampleTime = sampleTime;
//# sourceMappingURL=sampleTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/scan.js

/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */
function scan(accumulator, seed) {
    if (arguments.length >= 2) {
        return Object(operators["scan"])(accumulator, seed)(this);
    }
    return Object(operators["scan"])(accumulator)(this);
}
//# sourceMappingURL=scan.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/scan.js


_esm5["d" /* Observable */].prototype.scan = scan;
//# sourceMappingURL=scan.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/sequenceEqual.js

/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */
function sequenceEqual(compareTo, comparor) {
    return Object(operators["sequenceEqual"])(compareTo, comparor)(this);
}
//# sourceMappingURL=sequenceEqual.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/sequenceEqual.js


_esm5["d" /* Observable */].prototype.sequenceEqual = sequenceEqual;
//# sourceMappingURL=sequenceEqual.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/share.js

/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */
function share_share() {
    return Object(operators["share"])()(this);
}
//# sourceMappingURL=share.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/share.js


_esm5["d" /* Observable */].prototype.share = share_share;
//# sourceMappingURL=share.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/shareReplay.js

/**
 * @method shareReplay
 * @owner Observable
 */
function shareReplay(bufferSize, windowTime, scheduler) {
    return Object(operators["shareReplay"])(bufferSize, windowTime, scheduler)(this);
}
//# sourceMappingURL=shareReplay.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/shareReplay.js


_esm5["d" /* Observable */].prototype.shareReplay = shareReplay;
//# sourceMappingURL=shareReplay.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/single.js

/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */
function single(predicate) {
    return Object(operators["single"])(predicate)(this);
}
//# sourceMappingURL=single.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/single.js


_esm5["d" /* Observable */].prototype.single = single;
//# sourceMappingURL=single.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/skip.js

/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */
function skip(count) {
    return Object(operators["skip"])(count)(this);
}
//# sourceMappingURL=skip.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/skip.js


_esm5["d" /* Observable */].prototype.skip = skip;
//# sourceMappingURL=skip.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/skipLast.js

/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */
function skipLast(count) {
    return Object(operators["skipLast"])(count)(this);
}
//# sourceMappingURL=skipLast.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/skipLast.js


_esm5["d" /* Observable */].prototype.skipLast = skipLast;
//# sourceMappingURL=skipLast.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/skipUntil.js

/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
    return Object(operators["skipUntil"])(notifier)(this);
}
//# sourceMappingURL=skipUntil.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/skipUntil.js


_esm5["d" /* Observable */].prototype.skipUntil = skipUntil;
//# sourceMappingURL=skipUntil.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/skipWhile.js

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */
function skipWhile(predicate) {
    return Object(operators["skipWhile"])(predicate)(this);
}
//# sourceMappingURL=skipWhile.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/skipWhile.js


_esm5["d" /* Observable */].prototype.skipWhile = skipWhile;
//# sourceMappingURL=skipWhile.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/startWith.js

/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i] = arguments[_i];
    }
    return operators["startWith"].apply(void 0, array)(this);
}
//# sourceMappingURL=startWith.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/startWith.js


_esm5["d" /* Observable */].prototype.startWith = startWith;
//# sourceMappingURL=startWith.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/subscribeOn.js

/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return Object(operators["subscribeOn"])(scheduler, delay)(this);
}
//# sourceMappingURL=subscribeOn.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/subscribeOn.js


_esm5["d" /* Observable */].prototype.subscribeOn = subscribeOn;
//# sourceMappingURL=subscribeOn.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/switch.js

/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */
function _switch() {
    return Object(operators["switchAll"])()(this);
}
//# sourceMappingURL=switch.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/switch.js


_esm5["d" /* Observable */].prototype.switch = _switch;
_esm5["d" /* Observable */].prototype._switch = _switch;
//# sourceMappingURL=switch.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/switchMap.js

/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project) {
    return Object(operators["switchMap"])(project)(this);
}
//# sourceMappingURL=switchMap.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/switchMap.js


_esm5["d" /* Observable */].prototype.switchMap = switchMap;
//# sourceMappingURL=switchMap.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/switchMapTo.js

/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */
function switchMapTo(innerObservable) {
    return Object(operators["switchMapTo"])(innerObservable)(this);
}
//# sourceMappingURL=switchMapTo.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/switchMapTo.js


_esm5["d" /* Observable */].prototype.switchMapTo = switchMapTo;
//# sourceMappingURL=switchMapTo.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/take.js

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    return Object(operators["take"])(count)(this);
}
//# sourceMappingURL=take.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/take.js


_esm5["d" /* Observable */].prototype.take = take;
//# sourceMappingURL=take.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/takeLast.js

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */
function takeLast(count) {
    return Object(operators["takeLast"])(count)(this);
}
//# sourceMappingURL=takeLast.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/takeLast.js


_esm5["d" /* Observable */].prototype.takeLast = takeLast;
//# sourceMappingURL=takeLast.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/takeUntil.js

/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits a value. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value, the output Observable stops mirroring the source Observable
 * and completes. If the `notifier` doesn't emit any value and completes
 * then `takeUntil` will pass all values.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return Object(operators["takeUntil"])(notifier)(this);
}
//# sourceMappingURL=takeUntil.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/takeUntil.js


_esm5["d" /* Observable */].prototype.takeUntil = takeUntil;
//# sourceMappingURL=takeUntil.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/takeWhile.js

/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */
function takeWhile(predicate) {
    return Object(operators["takeWhile"])(predicate)(this);
}
//# sourceMappingURL=takeWhile.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/takeWhile.js


_esm5["d" /* Observable */].prototype.takeWhile = takeWhile;
//# sourceMappingURL=takeWhile.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/throttle.js


/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */
function throttle_throttle(durationSelector, config) {
    if (config === void 0) { config = throttle["a" /* defaultThrottleConfig */]; }
    return Object(operators["throttle"])(durationSelector, config)(this);
}
//# sourceMappingURL=throttle.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/throttle.js


_esm5["d" /* Observable */].prototype.throttle = throttle_throttle;
//# sourceMappingURL=throttle.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/throttleTime.js



/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=asyncScheduler] The {@link SchedulerLike} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */
function throttleTime_throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    if (config === void 0) { config = throttle["a" /* defaultThrottleConfig */]; }
    return Object(operators["throttleTime"])(duration, scheduler, config)(this);
}
//# sourceMappingURL=throttleTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/throttleTime.js


_esm5["d" /* Observable */].prototype.throttleTime = throttleTime_throttleTime;
//# sourceMappingURL=throttleTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/timeInterval.js


/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */
function timeInterval_timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    return Object(operators["timeInterval"])(scheduler)(this);
}
//# sourceMappingURL=timeInterval.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/timeInterval.js


_esm5["d" /* Observable */].prototype.timeInterval = timeInterval_timeInterval;
//# sourceMappingURL=timeInterval.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/timeout.js


/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */
function timeout(due, scheduler) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    return Object(operators["timeout"])(due, scheduler)(this);
}
//# sourceMappingURL=timeout.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/timeout.js


_esm5["d" /* Observable */].prototype.timeout = timeout;
//# sourceMappingURL=timeout.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/timeoutWith.js


/* tslint:enable:max-line-length */
/**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    return Object(operators["timeoutWith"])(due, withObservable, scheduler)(this);
}
//# sourceMappingURL=timeoutWith.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/timeoutWith.js


_esm5["d" /* Observable */].prototype.timeoutWith = timeoutWith;
//# sourceMappingURL=timeoutWith.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/timestamp.js


/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp_timestamp(scheduler) {
    if (scheduler === void 0) { scheduler = _esm5["i" /* asyncScheduler */]; }
    return Object(operators["timestamp"])(scheduler)(this);
}
//# sourceMappingURL=timestamp.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/timestamp.js


_esm5["d" /* Observable */].prototype.timestamp = timestamp_timestamp;
//# sourceMappingURL=timestamp.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/toArray.js

/**
 * Collects all source emissions and emits them as an array when the source completes.
 *
 * <span class="informal">Get all values inside an array when the source completes</span>
 *
 * <img src="./img/toArray.png" width="100%">
 *
 * `toArray` will wait until the source Observable completes
 * before emitting the array containing all emissions.
 * When the source Observable errors no array will be emitted.
 *
 * @example <caption>Create array from input</caption>
 * const input = Rx.Observable.interval(100).take(4);
 *
 * input.toArray()
 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
 *
 * @see {@link buffer}
 *
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */
function toArray() {
    return Object(operators["toArray"])()(this);
}
//# sourceMappingURL=toArray.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/toArray.js


_esm5["d" /* Observable */].prototype.toArray = toArray;
//# sourceMappingURL=toArray.js.map
// EXTERNAL MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/toPromise.js
var toPromise = __webpack_require__("HETl");
var toPromise_default = /*#__PURE__*/__webpack_require__.n(toPromise);

// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/window.js

/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */
function window_window(windowBoundaries) {
    return Object(operators["window"])(windowBoundaries)(this);
}
//# sourceMappingURL=window.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/window.js


_esm5["d" /* Observable */].prototype.window = window_window;
//# sourceMappingURL=window.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/windowCount.js

/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    return Object(operators["windowCount"])(windowSize, startWindowEvery)(this);
}
//# sourceMappingURL=windowCount.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/windowCount.js


_esm5["d" /* Observable */].prototype.windowCount = windowCount;
//# sourceMappingURL=windowCount.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/windowTime.js



function windowTime_windowTime(windowTimeSpan) {
    var scheduler = _esm5["i" /* asyncScheduler */];
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (Object(isScheduler["a" /* isScheduler */])(arguments[3])) {
        scheduler = arguments[3];
    }
    if (Object(isScheduler["a" /* isScheduler */])(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (Object(isNumeric["a" /* isNumeric */])(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (Object(isScheduler["a" /* isScheduler */])(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (Object(isNumeric["a" /* isNumeric */])(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return Object(operators["windowTime"])(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
}
//# sourceMappingURL=windowTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/windowTime.js


_esm5["d" /* Observable */].prototype.windowTime = windowTime_windowTime;
//# sourceMappingURL=windowTime.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/windowToggle.js

/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */
function windowToggle(openings, closingSelector) {
    return Object(operators["windowToggle"])(openings, closingSelector)(this);
}
//# sourceMappingURL=windowToggle.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/windowToggle.js


_esm5["d" /* Observable */].prototype.windowToggle = windowToggle;
//# sourceMappingURL=windowToggle.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/windowWhen.js

/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */
function windowWhen(closingSelector) {
    return Object(operators["windowWhen"])(closingSelector)(this);
}
//# sourceMappingURL=windowWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/windowWhen.js


_esm5["d" /* Observable */].prototype.windowWhen = windowWhen;
//# sourceMappingURL=windowWhen.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/withLatestFrom.js

/* tslint:enable:max-line-length */
/**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */
function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return operators["withLatestFrom"].apply(void 0, args)(this);
}
//# sourceMappingURL=withLatestFrom.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/withLatestFrom.js


_esm5["d" /* Observable */].prototype.withLatestFrom = withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/zip.js

/* tslint:enable:max-line-length */
/**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */
function zipProto() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return this.lift.call(_esm5["G" /* zip */].apply(void 0, [this].concat(observables)));
}
//# sourceMappingURL=zip.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/zip.js


_esm5["d" /* Observable */].prototype.zip = zipProto;
//# sourceMappingURL=zip.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/operator/zipAll.js

/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */
function zipAll(project) {
    return Object(operators["zipAll"])(project)(this);
}
//# sourceMappingURL=zipAll.js.map
// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/add/operator/zipAll.js


_esm5["d" /* Observable */].prototype.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/Notification.js
var Notification = __webpack_require__("NGRO");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/testing/SubscriptionLog.js
var SubscriptionLog = /*@__PURE__*/ (function () {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) {
            unsubscribedFrame = Number.POSITIVE_INFINITY;
        }
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}());





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/testing/SubscriptionLoggable.js
/** PURE_IMPORTS_START _SubscriptionLog PURE_IMPORTS_END */

var SubscriptionLoggable_SubscriptionLoggable = /*@__PURE__*/ (function () {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
        this.subscriptions.push(new SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}());





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/testing/ColdObservable.js
/** PURE_IMPORTS_START tslib,_Observable,_Subscription,_SubscriptionLoggable,_util_applyMixins PURE_IMPORTS_END */





/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ColdObservable_ColdObservable = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        var _this = _super.call(this, function (subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new Subscription["a" /* Subscription */](function () {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        }) || this;
        _this.messages = messages;
        _this.subscriptions = [];
        _this.scheduler = scheduler;
        return _this;
    }
    ColdObservable.prototype.scheduleMessages = function (subscriber) {
        var messagesLength = this.messages.length;
        for (var i = 0; i < messagesLength; i++) {
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function (_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, { message: message, subscriber: subscriber }));
        }
    };
    return ColdObservable;
}(internal_Observable["a" /* Observable */]));

/*@__PURE__*/ applyMixins(ColdObservable_ColdObservable, [SubscriptionLoggable_SubscriptionLoggable]);




// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/testing/HotObservable.js
/** PURE_IMPORTS_START tslib,_Subject,_Subscription,_SubscriptionLoggable,_util_applyMixins PURE_IMPORTS_END */





/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var HotObservable_HotObservable = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](HotObservable, _super);
    function HotObservable(messages, scheduler) {
        var _this = _super.call(this) || this;
        _this.messages = messages;
        _this.subscriptions = [];
        _this.scheduler = scheduler;
        return _this;
    }
    /** @deprecated This is an internal implementation detail, do not use. */
    HotObservable.prototype._subscribe = function (subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new Subscription["a" /* Subscription */](function () {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function () {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */
        for (var i = 0; i < messagesLength; i++) {
            (function () {
                var message = subject.messages[i];
                /* tslint:enable */
                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
            })();
        }
    };
    return HotObservable;
}(Subject["b" /* Subject */]));

/*@__PURE__*/ applyMixins(HotObservable_HotObservable, [SubscriptionLoggable_SubscriptionLoggable]);




// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/VirtualTimeScheduler.js
var VirtualTimeScheduler = __webpack_require__("0Dfv");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js
var AsyncScheduler = __webpack_require__("g8cW");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/testing/TestScheduler.js
/** PURE_IMPORTS_START tslib,_Observable,_Notification,_ColdObservable,_HotObservable,_SubscriptionLog,_scheduler_VirtualTimeScheduler,_scheduler_AsyncScheduler PURE_IMPORTS_END */








var defaultMaxFrame = 750;
var TestScheduler_TestScheduler = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        var _this = _super.call(this, VirtualTimeScheduler["a" /* VirtualAction */], defaultMaxFrame) || this;
        _this.assertDeepEqual = assertDeepEqual;
        _this.hotObservables = [];
        _this.coldObservables = [];
        _this.flushTests = [];
        _this.runMode = false;
        return _this;
    }
    TestScheduler.prototype.createTime = function (marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) {
            throw new Error('marble diagram for time should have a completion marker "|"');
        }
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
        if (marbles.indexOf('^') !== -1) {
            throw new Error('cold observable cannot have subscription offset "^"');
        }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('cold observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error, undefined, this.runMode);
        var cold = new ColdObservable_ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
        if (marbles.indexOf('!') !== -1) {
            throw new Error('hot observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error, undefined, this.runMode);
        var subject = new HotObservable_HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function (value) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification["a" /* Notification */].createNext(value) });
        }, function (err) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification["a" /* Notification */].createError(err) });
        }, function () {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification["a" /* Notification */].createComplete() });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) {
            unsubscriptionMarbles = null;
        }
        var actual = [];
        var flushTest = { actual: actual, ready: false };
        var unsubscriptionFrame = TestScheduler
            .parseMarblesAsSubscriptions(unsubscriptionMarbles, this.runMode).unsubscribedFrame;
        var subscription;
        this.schedule(function () {
            subscription = observable.subscribe(function (x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof internal_Observable["a" /* Observable */]) {
                    value = _this.materializeInnerObservable(value, _this.frame);
                }
                actual.push({ frame: _this.frame, notification: Notification["a" /* Notification */].createNext(value) });
            }, function (err) {
                actual.push({ frame: _this.frame, notification: Notification["a" /* Notification */].createError(err) });
            }, function () {
                actual.push({ frame: _this.frame, notification: Notification["a" /* Notification */].createComplete() });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
        }
        this.flushTests.push(flushTest);
        var runMode = this.runMode;
        return {
            toBe: function (marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true, runMode);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
        var flushTest = { actual: actualSubscriptionLogs, ready: false };
        this.flushTests.push(flushTest);
        var runMode = this.runMode;
        return {
            toBe: function (marbles) {
                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function (marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles, runMode);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function () {
        var hotObservables = this.hotObservables;
        while (hotObservables.length > 0) {
            hotObservables.shift().setup();
        }
        _super.prototype.flush.call(this);
        var flushTests = this.flushTests;
        var flushTestsCopy = flushTests.slice();
        for (var i = 0, l = flushTests.length; i < l; i++) {
            var test_1 = flushTestsCopy[i];
            if (test_1.ready) {
                // remove it from the original array, not our copy
                flushTests.splice(i, 1);
                this.assertDeepEqual(test_1.actual, test_1.expected);
            }
        }
    };
    /** @nocollapse */
    TestScheduler.parseMarblesAsSubscriptions = function (marbles, runMode) {
        var _this = this;
        if (runMode === void 0) {
            runMode = false;
        }
        if (typeof marbles !== 'string') {
            return new SubscriptionLog(Number.POSITIVE_INFINITY);
        }
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        var frame = 0;
        var _loop_1 = function (i) {
            var nextFrame = frame;
            var advanceFrameBy = function (count) {
                nextFrame += count * _this.frameTimeFactor;
            };
            var c = marbles[i];
            switch (c) {
                case ' ':
                    // Whitespace no longer advances time
                    if (!runMode) {
                        advanceFrameBy(1);
                    }
                    break;
                case '-':
                    advanceFrameBy(1);
                    break;
                case '(':
                    groupStart = frame;
                    advanceFrameBy(1);
                    break;
                case ')':
                    groupStart = -1;
                    advanceFrameBy(1);
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    advanceFrameBy(1);
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    // time progression syntax
                    if (runMode && c.match(/^[0-9]$/)) {
                        // Time progression must be preceeded by at least one space
                        // if it's not at the beginning of the diagram
                        if (i === 0 || marbles[i - 1] === ' ') {
                            var buffer = marbles.slice(i);
                            var match = buffer.match(/^([0-9]+(?:\.[0-9]+)?)(ms|s|m) /);
                            if (match) {
                                i += match[0].length - 1;
                                var duration = parseFloat(match[1]);
                                var unit = match[2];
                                var durationInMs = void 0;
                                switch (unit) {
                                    case 'ms':
                                        durationInMs = duration;
                                        break;
                                    case 's':
                                        durationInMs = duration * 1000;
                                        break;
                                    case 'm':
                                        durationInMs = duration * 1000 * 60;
                                        break;
                                    default:
                                        break;
                                }
                                advanceFrameBy(durationInMs / this_1.frameTimeFactor);
                                break;
                            }
                        }
                    }
                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
                        'subscription marble diagram. Found instead \'' + c + '\'.');
            }
            frame = nextFrame;
            out_i_1 = i;
        };
        var this_1 = this, out_i_1;
        for (var i = 0; i < len; i++) {
            _loop_1(i);
            i = out_i_1;
        }
        if (unsubscriptionFrame < 0) {
            return new SubscriptionLog(subscriptionFrame);
        }
        else {
            return new SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
        }
    };
    /** @nocollapse */
    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables, runMode) {
        var _this = this;
        if (materializeInnerObservables === void 0) {
            materializeInnerObservables = false;
        }
        if (runMode === void 0) {
            runMode = false;
        }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('conventional marble diagrams cannot have the ' +
                'unsubscription marker "!"');
        }
        var len = marbles.length;
        var testMessages = [];
        var subIndex = runMode ? marbles.replace(/^[ ]+/, '').indexOf('^') : marbles.indexOf('^');
        var frame = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
        var getValue = typeof values !== 'object' ?
            function (x) { return x; } :
            function (x) {
                // Support Observable-of-Observables
                if (materializeInnerObservables && values[x] instanceof ColdObservable_ColdObservable) {
                    return values[x].messages;
                }
                return values[x];
            };
        var groupStart = -1;
        var _loop_2 = function (i) {
            var nextFrame = frame;
            var advanceFrameBy = function (count) {
                nextFrame += count * _this.frameTimeFactor;
            };
            var notification = void 0;
            var c = marbles[i];
            switch (c) {
                case ' ':
                    // Whitespace no longer advances time
                    if (!runMode) {
                        advanceFrameBy(1);
                    }
                    break;
                case '-':
                    advanceFrameBy(1);
                    break;
                case '(':
                    groupStart = frame;
                    advanceFrameBy(1);
                    break;
                case ')':
                    groupStart = -1;
                    advanceFrameBy(1);
                    break;
                case '|':
                    notification = Notification["a" /* Notification */].createComplete();
                    advanceFrameBy(1);
                    break;
                case '^':
                    advanceFrameBy(1);
                    break;
                case '#':
                    notification = Notification["a" /* Notification */].createError(errorValue || 'error');
                    advanceFrameBy(1);
                    break;
                default:
                    // Might be time progression syntax, or a value literal
                    if (runMode && c.match(/^[0-9]$/)) {
                        // Time progression must be preceeded by at least one space
                        // if it's not at the beginning of the diagram
                        if (i === 0 || marbles[i - 1] === ' ') {
                            var buffer = marbles.slice(i);
                            var match = buffer.match(/^([0-9]+(?:\.[0-9]+)?)(ms|s|m) /);
                            if (match) {
                                i += match[0].length - 1;
                                var duration = parseFloat(match[1]);
                                var unit = match[2];
                                var durationInMs = void 0;
                                switch (unit) {
                                    case 'ms':
                                        durationInMs = duration;
                                        break;
                                    case 's':
                                        durationInMs = duration * 1000;
                                        break;
                                    case 'm':
                                        durationInMs = duration * 1000 * 60;
                                        break;
                                    default:
                                        break;
                                }
                                advanceFrameBy(durationInMs / this_2.frameTimeFactor);
                                break;
                            }
                        }
                    }
                    notification = Notification["a" /* Notification */].createNext(getValue(c));
                    advanceFrameBy(1);
                    break;
            }
            if (notification) {
                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
            }
            frame = nextFrame;
            out_i_2 = i;
        };
        var this_2 = this, out_i_2;
        for (var i = 0; i < len; i++) {
            _loop_2(i);
            i = out_i_2;
        }
        return testMessages;
    };
    TestScheduler.prototype.run = function (callback) {
        var prevFrameTimeFactor = TestScheduler.frameTimeFactor;
        var prevMaxFrames = this.maxFrames;
        TestScheduler.frameTimeFactor = 1;
        this.maxFrames = Number.POSITIVE_INFINITY;
        this.runMode = true;
        AsyncScheduler["a" /* AsyncScheduler */].delegate = this;
        var helpers = {
            cold: this.createColdObservable.bind(this),
            hot: this.createHotObservable.bind(this),
            flush: this.flush.bind(this),
            expectObservable: this.expectObservable.bind(this),
            expectSubscriptions: this.expectSubscriptions.bind(this),
        };
        var ret = callback(helpers);
        this.flush();
        TestScheduler.frameTimeFactor = prevFrameTimeFactor;
        this.maxFrames = prevMaxFrames;
        this.runMode = false;
        AsyncScheduler["a" /* AsyncScheduler */].delegate = undefined;
        return ret;
    };
    return TestScheduler;
}(VirtualTimeScheduler["b" /* VirtualTimeScheduler */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/testing/index.js
/** PURE_IMPORTS_START  PURE_IMPORTS_END */

//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/Rx.js
/* tslint:disable:no-unused-variable */
// Subject imported before Observable to bypass circular dependency issue since
// Subject extends Observable and Observable references Subject in it's
// definition


/* tslint:enable:no-unused-variable */

// statics
/* tslint:disable:no-use-before-declare */

























//dom


//internal/operators






































































































/* tslint:disable:no-unused-variable */








var Rx_operators = operators;
/* tslint:enable:no-unused-variable */
/**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */
var Rx_Scheduler = {
    asap: _esm5["h" /* asapScheduler */],
    queue: _esm5["A" /* queueScheduler */],
    animationFrame: _esm5["g" /* animationFrameScheduler */],
    async: _esm5["i" /* asyncScheduler */]
};
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */
var Symbol = {
    rxSubscriber: rxSubscriber["a" /* rxSubscriber */],
    observable: symbol_observable["a" /* observable */],
    iterator: iterator["a" /* iterator */]
};

//# sourceMappingURL=Rx.js.map
// CONCATENATED MODULE: ./src/app/bi/admin/services/mdmService.service.ts



var mdmService_service_MDMService = /*@__PURE__*/ (function () {
    function MDMService(mdmService, _global) {
        this.mdmService = mdmService;
        this._global = _global;
        this.base_url = this._global.get('EPMS_BASE_URL') + 'v1/';
        this.pageAuthList = [];
        this.roles = [];
        this.isBIAdmin = false;
        this.roleId = [];
    }
    MDMService.prototype.onStartUp = function (path) {
        console.log('ON STARTUP---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        var objectList = [];
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/';
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.save = function (path, objectData) {
        console.log('ON SAVE---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/';
            self.mdmService.post(url, objectData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.search = function (path, searchUrlPath, regexData, page, size) {
        console.log('ON SEARCH --- SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        var url;
        if (page == undefined && size == undefined) {
            url = self.base_url + path + searchUrlPath + regexData;
        }
        else {
            url = self.base_url + path + searchUrlPath + regexData + '&page=' + page + '&size=' + size;
        }
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.search1 = function (path, searchUrlPath, regexData) {
        var self = this;
        // let path1 = path;
        // path = self.updatePath(path1);
        var url = self.base_url + path + searchUrlPath + regexData;
        // self.isBIAdmin = false;
        return _esm5["d" /* Observable */].create(function (observer) {
            var obs = _esm5["d" /* Observable */].forkJoin([self.mdmService.post(url, null)]);
            obs.subscribe(function (response) {
                if (response[0] != undefined && response[0].success && response[0].data != undefined) {
                    observer.next(response[0].data);
                }
                else {
                    observer.next([]);
                }
                observer.complete();
            });
        });
    };
    MDMService.prototype.bulkUpload = function (path, bulkUploadUrlPath, formData) {
        console.log('ON BULK UPLOAD --- SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + bulkUploadUrlPath;
            self.mdmService.filePost(url, formData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.delete = function (path, id) {
        console.log('ON DELETE---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/' + id;
            self.mdmService.delete(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.deleteModel = function (path, cubeId, recFormatId, dataSourceId) {
        console.log('ON DELETE---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?cId=' + cubeId + "&rId=" + recFormatId + "&dId=" + dataSourceId;
            self.mdmService.delete(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.update = function (path, objectData) {
        console.log('ON EDIT---SERVICE');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/';
            self.mdmService.put(url, objectData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.testConnection = function (path, DSdata) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, DSdata).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getObjectById = function (path) {
        var object = {};
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.get(url).subscribe(function (res) {
                // object = res;
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.syncDataSource = function (id) {
        var _this = this;
        var self = this;
        var path1 = BiUrls.SYNC_DATASOURCE + id;
        var path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise(function (resolve, reject) {
            _this.mdmService.get(path).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.syncAllRecordFormatsInDataSource = function (id) {
        var _this = this;
        var self = this;
        var path1 = BiUrls.SYNC_ALL_RF_DATASOURCE + id;
        var path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise(function (resolve, reject) {
            _this.mdmService.get(path).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.syncRecordFormat = function (id) {
        var _this = this;
        var self = this;
        var path1 = BiUrls.SYNC_RECORD_FORMAT + id;
        var path = self.updatePath(path1);
        path = self.base_url + path;
        return new Promise(function (resolve, reject) {
            _this.mdmService.get(path).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.updatePath = function (path) {
        var self = this;
        if (self.isBIAdmin) {
            return BiUrls.BIADMIN + '/' + path;
        }
        else {
            return path;
        }
    };
    MDMService.prototype.getDataByPage = function (path, page, size) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?page=' + page + '&size=' + size;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getRoleData = function (url) {
        var self = this;
        return new Promise(function (resolve) {
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getDataById = function (path, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/' + id;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getDimensionByMeasureId = function (path, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + id;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.loadPageAuthorizations = function (path, empIdList, pageId) {
        console.log('ON LOAD PAGE AUTHORIZATION SERVICE ----------');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        self.pageAuthList = [];
        var url = self.base_url + path + pageId;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, empIdList).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                resolve(err);
                console.log(err);
            });
        });
    };
    MDMService.prototype.loadRoleAuthorizations = function (url, roleId) {
        var self = this;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, roleId).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                resolve(err);
                console.log(err);
            });
        });
    };
    MDMService.prototype.getRoleWidgets = function (url, roleIdList) {
        var self = this;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, roleIdList).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                resolve(err);
                console.log(err);
            });
        });
    };
    MDMService.prototype.setRoleId = function (id, name) {
        this.roleId.push(id);
        this.roleName = name;
    };
    MDMService.prototype.onSaveOrUpdate = function (path, pageAuthList) {
        console.log('ON SAVE OR UPDATE SERVICE ------------------');
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        var toBeAdded = [];
        var toBeUpdated = [];
        var url = self.base_url + path;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, pageAuthList).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                //resolve(err);
                reject(err);
                console.log(err);
            });
        });
    };
    MDMService.prototype.onUpdateRoleAuth = function (url, psIdList) {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var self;
            return tslib_es6["__generator"](this, function (_a) {
                self = this;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        self.mdmService.post(url, psIdList).subscribe(function (res) {
                            if (res) {
                                resolve(res);
                            }
                        }, function (err) {
                            reject(err);
                            console.log(err);
                        });
                    })];
            });
        });
    };
    MDMService.prototype.getDimLevelValues = function (dimLvlObj) {
        var self = this;
        var path1 = String('../' + BiUrls.GET_DIM_LVL_VALUE);
        var path = self.updatePath(path1);
        path = self.base_url + path;
        console.log('GET DIMENSION LEVEL VALUE SERVICE .....');
        return new Promise(function (resolve, reject) {
            self.mdmService.post(path, dimLvlObj).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                reject(err);
            });
        });
    };
    MDMService.prototype.deleteEmpOrgDimRel = function (path, data) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        var url = self.base_url + path;
        return new Promise(function (resolve, reject) {
            self.mdmService.post(url, data).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                reject(err);
            });
        });
    };
    MDMService.prototype.roleCheck = function () {
        return tslib_es6["__awaiter"](this, void 0, void 0, function () {
            var self, _a;
            return tslib_es6["__generator"](this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log('ROLE CHECK SERVICE ......');
                        self = this;
                        _a = self;
                        return [4 /*yield*/, self.getObjectById(BiUrls.GET_OPERATIONS_FOR_USER)];
                    case 1:
                        _a.roles = _b.sent();
                        self.isBIAdmin = self.roles.includes('ROLE_BI_ADMIN');
                        console.log('BI-ADMIN : ' + self.isBIAdmin);
                        return [2 /*return*/];
                }
            });
        });
    };
    MDMService.prototype.getAll = function (path) {
        var self = this;
        path = self.updatePath(path);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/';
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.uploadFileToDrill = function (path, formData, dataSource) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?dataSourceId=' + dataSource;
            self.mdmService.filePost(url, formData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.clearCache = function (path) {
        var self = this;
        path = self.updatePath(path);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.put(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.reUploadDrillFile = function (path, formData, dataSource) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?recordFormatId=' + dataSource;
            self.mdmService.filePost(url, formData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getEmployee = function (searchData) {
        var _this = this;
        return new Promise(function (resolve) {
            try {
                var self_1 = _this;
                var url = self_1.base_url + "webAdmin/employee";
                //let path1 = "page/getSearchedEmp";
                //let path = self.updatePath(path1);
                //let url = self.base_url + path;
                //let url = self.base_url + "biAdmin/empSearch";
                self_1.mdmService.post(url, searchData).subscribe(function (result) {
                    resolve(result);
                });
            }
            catch (e) {
                console.log("getAllEmployeeData error catch", e);
            }
        });
    };
    MDMService.prototype.uploadFileToDrillForWizard = function (path, formData, dataSource, uploadType) {
        var type = uploadType == true ? '?cubeId=' : '?dataSourceId=';
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + type + dataSource;
            self.mdmService.filePost(url, formData).subscribe(function (res) {
                resolve(res instanceof Object ? res : JSON.parse(res));
            }, function (err) {
                console.log(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.syncPrestoData = function (path, cubeId) {
        var type = '?cubeId=';
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + type + cubeId;
            self.mdmService.post(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.uploadDataSourceForPresto = function (path, dataSource) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + dataSource;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.createAnalyticalModelPresto = function (path, rfData) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, rfData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.saveFileForDesigner = function (path, cubeData) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, cubeData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.analyticalModelPreview = function (path, ModelData) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve) {
            var url = self.base_url + path;
            self.mdmService.post(url, ModelData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.syncCacheConfig = function (path) {
        var self = this;
        var path1 = BiUrls.CACHE + path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.put(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.flushCacheConfig = function (path) {
        var self = this;
        var path1 = BiUrls.CACHE + path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.delete(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.dimensionData = function (dimensionData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var url = _this.base_url + 'bi/adhoc/dimension';
            _this.mdmService.post(url, dimensionData).toPromise().then(function (res) {
                resolve(res);
            }, function (err) {
                console.error(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.getProgress = function (token, path) {
        var _this = this;
        var url = 'page/bulkUpload/' + path + token;
        url = this.updatePath(url);
        url = this.base_url + url;
        return new Promise(function (resolve, reject) {
            _this.mdmService.get(url).toPromise().then(function (res) {
                resolve(res);
            }, function (err) {
                console.error(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.getTimeDimension = function (measureIdList) {
        var self = this;
        return new Promise(function (resolve, reject) {
            var url = self.base_url + 'bi/dimension/getDim?isDimTime=true';
            self.mdmService.post(url, measureIdList).toPromise().then(function (res) {
                resolve(res);
            }), function (err) {
                reject(err);
            };
        });
    };
    MDMService.prototype.createDataPoint = function (path, oData, type) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService[type](url, oData).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getAllDataPointsByDSid = function (path, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '/' + id;
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.getRFfromDataPointId = function (path, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?dataPointId=' + id + '&createTemporary=true';
            self.mdmService.get(url).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                reject(err);
            });
        });
    };
    MDMService.prototype.createAnalyticalModelOdata = function (path, rfList, id) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path + '?dataPointId=' + id + '&createTemporary=true';
            self.mdmService.post(url, rfList).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.saveAnalyticalModelOdata = function (path, Odata) {
        var self = this;
        var path1 = path;
        path = self.updatePath(path1);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, Odata).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.prototype.reBuildDashboardSnaphot = function (path) {
        var self = this;
        path = self.updatePath(path);
        return new Promise(function (resolve, reject) {
            var url = self.base_url + path;
            self.mdmService.post(url, null).subscribe(function (res) {
                resolve(res);
            }, function (err) {
                console.log(err);
                resolve(err);
            });
        });
    };
    MDMService.ERROR = 'error';
    MDMService.SUCCESS = 'success';
    MDMService.WARNING = 'warning';
    return MDMService;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/pocWizard.component.ts




var pocWizard_component_POCWizard = /*@__PURE__*/ (function () {
    function POCWizard(service, toaster, vcr, ngbDataConv, ngbTimeConv, _sanitizer) {
        this.service = service;
        this.toaster = toaster;
        this.vcr = vcr;
        this.ngbDataConv = ngbDataConv;
        this.ngbTimeConv = ngbTimeConv;
        this._sanitizer = _sanitizer;
        this.accessDenied = false;
        this.loader = false;
        this.cubeScreen = true;
        this.wizardScreen = false;
        this.prestoValidation = true;
        this.mapperScreen = false;
        this.measureMap = new Map();
        this.dimensionMap = new Map();
        this.dimensionPage = false;
        this.measurePage = false;
        this.editDimensionPage = false;
        this.editMeasurePage = false;
        this.uploadScreen = false;
        this.activeScreen = "upload";
        this.dataSourceList = [];
        this.dimensionList = [];
        this.typeList = ['csv', 'psv', 'tsv', 'json', 'xlsx'];
        this.saveButton = false;
        this.editScreen = false;
        this.dataVersionDate = { day: null, month: null, year: null };
        this.isEdit = false;
        this.isFormulaMeasure = false;
        this.inMesEdit = false;
        this.isnewFormulaMeasure = false;
        this.warning = "Please type to select";
        this.pageSize = 10;
        this.pageNo = 0;
        this.dropdownSettings = {
            singleSelection: false,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            id: 'refId',
            itemName: 'displayName',
            text: "Search Dimension",
            //itemsShowLimit: 0,
            allowSearchFilter: true,
        };
        this.dataVersionTime = { hour: null, minute: null, second: null };
        this.startDataVersion = { day: null, month: null, year: null };
        this.startDataVersionTime = { hour: null, minute: null, second: null };
        this.toaster.setViewRef(vcr);
    }
    POCWizard.prototype.ngOnInit = function () {
        if (!this.service.isBIAdmin) {
            this.accessDenied = true;
        }
        else {
            this.getDataSourceForDrill();
        }
    };
    POCWizard.prototype.ngOnDestroy = function () {
        // this.service.referencePage = null;
    };
    POCWizard.prototype.callToaster = function (type, msg) {
        this.toaster.setViewRef(this.vcr);
        switch (type) {
            case mdmService_service_MDMService.ERROR:
                return this.toaster.showError(msg);
            case mdmService_service_MDMService.SUCCESS:
                return this.toaster.showSuccess(msg);
            case mdmService_service_MDMService.WARNING:
                return this.toaster.showWarning(msg);
        }
    };
    POCWizard.prototype.getDataSourceForDrill = function () {
        var self = this;
        self.service.getAll('ds').then(function (res) {
            self.dataSourceList = res.data != null ? res.data : [];
        });
    };
    POCWizard.prototype.selectDataSource = function (event) {
        var _this = this;
        if (event != 'none') {
            this.selectedDataSourceId = +event.target.value;
            this.dataSourceList.forEach(function (ds) {
                if (ds.id == event.target.value) {
                    _this.selectedDataSource = ds;
                }
            });
        }
    };
    POCWizard.prototype.setCubeForEdit = function (event) {
        var self = this;
        self.cubeId = event.cube.refId;
        self.isEdit = event.cube.id != undefined;
        self.analyticalModel = event;
        self.isStarSchema = event.isStarSchema;
        self.selectedType = self.isStarSchema ? 'Star Schema' : 'Materialized';
        if (self.analyticalModel.cube.dataVersionType != undefined && self.analyticalModel.cube.dataVersionType == 'Static') {
            self.dataVersionType = 'Static';
            var dateTime = new Date(self.analyticalModel.cube.dataVersion);
            var dvDate = dateTime.getUTCDate() + '-' + (dateTime.getUTCMonth() + 1) + '-' + dateTime.getUTCFullYear();
            self.dataVersionDate = self.ngbDataConv.fromModel(dvDate);
            var endDvTime = dateTime.getUTCHours() + ":" + dateTime.getUTCMinutes() + ":" + dateTime.getUTCSeconds();
            self.dataVersionTime = self.ngbTimeConv.fromModel(endDvTime);
        }
        else {
            self.dataVersionType = 'Dynamic';
        }
        if (self.analyticalModel.cube.startDataVersion) {
            var startDate = new Date(self.analyticalModel.cube.startDataVersion);
            self.startDataVersion = self.ngbDataConv.fromModel(startDate.getUTCDate() + '-' + (startDate.getUTCMonth() + 1) + '-' + startDate.getUTCFullYear());
            var startDvTime = self.ngbTimeConv.fromModel(startDate.getUTCHours() + ":" + startDate.getUTCMinutes() + ":" + startDate.getUTCSeconds());
            if (!!startDvTime.hour && !!startDvTime.minute) {
                self.startDataVersionTime = startDvTime;
            }
            else if (self.analyticalModel.cube["startDataVersionTime"]) {
                self.startDataVersionTime = self.ngbTimeConv.fromModel(self.analyticalModel.cube["startDataVersionTime"]);
            }
            else {
                self.startDataVersionTime = self.ngbTimeConv.fromModel(0 + ":" + 0 + ":" + 0);
            }
        }
        self.activeScreen = "mapper";
        self.selectedDataSource = event.cube.dataSourceData;
        self.selectedDataSourceId = event.cube.dataSourceId;
        self.isStarSchema ? self.loadDimensions() : null;
    };
    POCWizard.prototype.fileChange = function (event) {
        this.saveButton = false;
        this.file = event.target.files[0];
    };
    POCWizard.prototype.uploadFile = function () {
        var self = this;
        var msg = self.validator();
        if (msg != '') {
            self.callToaster(mdmService_service_MDMService.ERROR, msg);
        }
        else {
            self.saveButton = true;
            self.loader = true;
            var formdata1 = new FormData();
            formdata1.append('file', self.file);
            if (self.isEdit) {
                self.reUpload(formdata1);
            }
            else {
                self.newUpload(formdata1);
            }
        }
    };
    POCWizard.prototype.scanPresto = function (dataSourceId) {
        var self = this;
        self.loader = true;
        self.service.uploadDataSourceForPresto(BiUrls.NEW_ANALYTICAL_MODEL_PRESTO, dataSourceId).then(function (res) {
            self.prestoData = res.data;
            self.loader = false;
        });
    };
    POCWizard.prototype.reSyncPresto = function () {
        var _this = this;
        var self = this;
        if (!this.analyticalModel)
            return null;
        this.loader = true;
        var cubeId = this.analyticalModel.cube.refId;
        self.service.syncPrestoData(BiUrls.SYNC_ANALYTICAL_MODEL, cubeId).then(function (res) {
            if (res.success) {
                self.analyticalModel = res.data;
                self.callToaster(mdmService_service_MDMService.SUCCESS, "Scanned cube " + _this.analyticalModel.cube.cubeCode + " successfully.");
            }
            else if (res.message != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(mdmService_service_MDMService.ERROR, "Something went wrong while trying to scan changes in cube " + _this.analyticalModel.cube.cubeCode);
            }
            self.activeScreen = "mapper";
            self.resetPreviewPageDetails();
            self.cubeScreen = false;
            self.isEdit = true;
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
        this.loadDimensions();
    };
    POCWizard.prototype.selectType = function (event) {
        var self = this;
        self.isStarSchema = event.target.value == 'starschema';
    };
    POCWizard.prototype.selectFact = function (event) {
        var self = this;
        self.selectedFact = +event.target.value;
        self.prestoDimData = self.prestoData;
        if (self.isStarSchema == false) {
            self.saveButton = false;
        }
    };
    POCWizard.prototype.uploadPresto = function () {
        var self = this;
        for (var _i = 0, _a = self.prestoData; _i < _a.length; _i++) {
            var data = _a[_i];
            if (data.refId == self.selectedFact) {
                self.RecordFormatData = data;
            }
        }
        if (self.isStarSchema == true) {
            self.createStarSchemaPresto();
            self.loadDimensions();
        }
        else {
            self.createMaterializedPresto();
        }
    };
    POCWizard.prototype.createStarSchemaPresto = function () {
        var self = this;
        var DimensionData = [];
        self.AnalyticalModelData = {
            fact: self.RecordFormatData,
            dimensions: DimensionData,
            isStarSchema: true
        };
        self.loader = true;
        self.service.createAnalyticalModelPresto(BiUrls.STARSCHEMA_PRESTO, self.AnalyticalModelData).then(function (res) {
            if (res.success) {
                self.activeScreen = "mapper";
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(mdmService_service_MDMService.SUCCESS, "Data upload successful");
            }
            else if (res.message != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(mdmService_service_MDMService.ERROR, "Data upload failed");
            }
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
    };
    POCWizard.prototype.loadDimensions = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.service.onStartUp(BiUrls.DIMENSION + BiUrls.SEARCH + _this.selectedDataSourceId).then(function (res) {
                self.dimensionList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    };
    POCWizard.prototype.createMaterializedPresto = function () {
        var self = this;
        self.loader = true;
        self.service.createAnalyticalModelPresto(BiUrls.MATERIALIZED_PRESTO, self.RecordFormatData).then(function (res) {
            if (res.success) {
                self.activeScreen = "mapper";
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(mdmService_service_MDMService.SUCCESS, "Data upload successful");
            }
            else if (res.message != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(mdmService_service_MDMService.ERROR, "Data upload failed");
            }
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
    };
    POCWizard.prototype.newUpload = function (formdata1) {
        var self = this;
        self.service.uploadFileToDrillForWizard(BiUrls.NEW_ANALYTICAL_MODEL, formdata1, self.selectedDataSource.id, false).then(function (res) {
            self.saveButton = false;
            if (res.success) {
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(mdmService_service_MDMService.SUCCESS, "File upload successful");
            }
            else if (res.message != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(mdmService_service_MDMService.ERROR, "File upload failed");
            }
            self.activeScreen = "mapper";
            self.loader = false;
            self.file = null;
        }, function (err) {
            console.error(err);
        });
    };
    POCWizard.prototype.reUpload = function (formdata1) {
        var self = this;
        self.service.uploadFileToDrillForWizard(BiUrls.SYNC_ANALYTICAL_MODEL, formdata1, self.analyticalModel.cube.id, true).then(function (res) {
            self.saveButton = false;
            if (res.success) {
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(mdmService_service_MDMService.SUCCESS, "File re-upload successful");
            }
            else if (res.message != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.message);
            }
            else if (res.errorMessage != undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(mdmService_service_MDMService.ERROR, "File re-upload failed");
            }
            self.resetPreviewPageDetails();
            self.activeScreen = "mapper";
            self.loader = false;
            self.file = null;
        }, function (err) {
            console.error(err);
        });
    };
    POCWizard.prototype.loadPreview = function (event) {
        var _this = this;
        var self = this;
        if (event) {
            self.getPreviewForDrill().then(function (res) {
                return tslib_es6["__awaiter"](_this, void 0, void 0, function () {
                    return tslib_es6["__generator"](this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, res];
                            case 1:
                                _a.sent();
                                self.loadTenantConfigs();
                                self.cubeScreen = false;
                                self.activeScreen = "preview";
                                return [2 /*return*/];
                        }
                    });
                });
            });
        }
    };
    POCWizard.prototype.getPreviewForDrill = function () {
        var self = this;
        self.modelData = {
            page: self.pageNo, size: self.pageSize,
            recordFormatData: JSON.parse(JSON.stringify(self.analyticalModel.fact))
        };
        self.modelData.recordFormatData.recordFormatFieldData = null;
        return new Promise(function (resolve) {
            self.service.analyticalModelPreview(BiUrls.PREVIEW_ANALYTICAL_MODEL, self.modelData).then(function (res) {
                if (res.success == true) {
                    self.previewAnalyticalModel = res.data;
                    resolve('complete');
                }
                else if (res.success == false && res.message != undefined) {
                    self.callToaster(mdmService_service_MDMService.ERROR, res.message);
                    self.previewAnalyticalModel = 'error';
                    resolve('error');
                }
                else {
                    self.callToaster(mdmService_service_MDMService.ERROR, "Failed to Load Preview");
                    self.previewAnalyticalModel = 'error';
                    resolve('error');
                }
            });
        });
    };
    POCWizard.prototype.loadTenantConfigs = function () {
        var self = this;
        return new Promise(function (resolve) {
            self.service.onStartUp(BiUrls.TENANT_CONFIG).then(function (res) {
                if (res == undefined) {
                    self.callToaster(mdmService_service_MDMService.ERROR, 'No Tenant Configurations to load');
                    resolve('error');
                }
                self.tntConfData = res;
                resolve('completed');
            }, function (error) {
                if (error.status == 204) {
                    self.callToaster(mdmService_service_MDMService.ERROR, 'Cannot load the tenant configurations');
                    resolve('error');
                }
            });
        });
    };
    POCWizard.prototype.getPreviewPageDetails = function (event) {
        var self = this;
        self.pageNo = event.pageNo;
        self.pageSize = event.pageSize;
        self.getPreviewForDrill().then(function () {
            self.activeScreen = "preview";
        });
    };
    POCWizard.prototype.validator = function () {
        if (this.selectedDataSource == undefined || this.selectedDataSource == 'none') {
            return 'Please select Data-Source to upload a file !';
        }
        if (this.file == undefined) {
            return 'Please select a file to upload !';
        }
        var msg = this.fileValidator();
        if (msg) {
            return msg;
        }
        return '';
    };
    POCWizard.prototype.fileValidator = function () {
        if (this.file) {
            var name_1 = this.file.name.split('.');
            var ext = name_1[name_1.length - 1];
            if (this.typeList.indexOf(ext) == -1) {
                return 'Please select ' + this.typeList.map(function (a) { return a.toUpperCase(); }).join(', ') + ' type file to upload';
            }
            var maxSize = 26214400; // 25MB
            var maxSizeInMB = maxSize / 1048576;
            if (this.file.size > maxSize) {
                return 'File size should not exceed ' + maxSizeInMB + 'MB';
            }
            return false;
        }
        return 'Please select a file to upload !';
    };
    POCWizard.prototype.setMapperScreen = function (event) {
        this.editScreen = event;
        this.activeScreen = "upload";
    };
    POCWizard.prototype.next = function () {
        this.cubeScreen = false;
        this.mapperScreen = false;
        this.dimensionPage = true;
        this.setDimensionAndMeasureLinkage();
    };
    POCWizard.prototype.setMeasureList = function (event) {
        this.measureMap = event;
        this.setDimensionAndMeasureLinkage();
    };
    POCWizard.prototype.setDimensionList = function (event) {
        this.dimensionMap = event;
        this.setDimensionAndMeasureLinkage();
    };
    POCWizard.prototype.setDimensionAndMeasureLinkage = function () {
        var _this = this;
        this.analyticalModel.isStarSchema = this.isStarSchema;
        this.analyticalModel.cube.cubeMeasureData = [];
        this.analyticalModel.cube.cubeDimensionUsageData = [];
        this.measureMap.forEach(function (ele) { _this.analyticalModel.cube.cubeMeasureData.push(ele); });
        this.dimensionMap.forEach(function (ele) { _this.analyticalModel.cube.cubeDimensionUsageData.push(ele); });
    };
    POCWizard.prototype.prestoDimValidation = function (event) {
        this.prestoValidation = event;
    };
    POCWizard.prototype.entityOpsDimension = function (event) {
        if (this.selectedDim == null) {
            this.selectedDim = event.target.id;
        }
        else {
            this.selectedDim = null;
        }
    };
    POCWizard.prototype.editDimension = function (dim) {
        this.dimensionData = JSON.parse(JSON.stringify(dim));
        this.editDimensionPage = true;
    };
    POCWizard.prototype.onBackFromDimEdit = function () {
        this.editDimensionPage = false;
        this.selectedDim = null;
    };
    POCWizard.prototype.afterDim = function () {
        this.dimensionPage = false;
        this.editDimensionPage = false;
        this.measurePage = true;
    };
    POCWizard.prototype.setdataVersionType = function (value) {
        if (value != 'Static') {
            this.dataVersionDate = null;
            this.dataVersionTime = null;
        }
        this.dataVersionType = value;
        this.startDataVersion = null;
        this.startDataVersionTime = null;
    };
    POCWizard.prototype.saveAnalyticalModel = function () {
        var self = this;
        self.analyticalModel.isStarSchema = self.isStarSchema;
        var validate = self.cubeValidator();
        if (validate != '') {
            self.callToaster(mdmService_service_MDMService.ERROR, validate);
            return;
        }
        var validate2 = self.dateValidator();
        if (validate2 != '') {
            self.callToaster(mdmService_service_MDMService.ERROR, validate2);
            return;
        }
        if (!this.prestoValidation && this.isStarSchema) {
            self.callToaster(mdmService_service_MDMService.ERROR, 'Please select the Dimension!');
            return;
        }
        self.loader = true;
        self.analyticalModel.cube["startDataVersion"] = self.startDataVersion ? Date.parse(self.ngbDataConv.toModel(self.startDataVersion)) : null;
        self.analyticalModel.cube["startDataVersionTime"] = self.startDataVersionTime ? self.ngbTimeConv.toModel(self.startDataVersionTime) : null;
        self.analyticalModel.cube["dataVersion"] = self.dataVersionDate ? Date.parse(self.ngbDataConv.toModel(self.dataVersionDate)) : null;
        self.analyticalModel.cube["dataVersionTime"] = self.dataVersionTime ? self.ngbTimeConv.toModel(self.dataVersionTime) : null;
        if (self.dataVersionType) {
            self.analyticalModel.cube.dataVersionType = self.dataVersionType;
        }
        self.loader = true;
        if (self.analyticalModel.cube.id != undefined) {
            self.service.saveFileForDesigner(BiUrls.UPDATE_ANALYTICAL_MODEL, self.analyticalModel).then(function (res) {
                if (res.success) {
                    self.callToaster(mdmService_service_MDMService.SUCCESS, "Changes Saved Successfully");
                }
                else if (res.message != undefined) {
                    self.callToaster(mdmService_service_MDMService.ERROR, res.message);
                }
                else if (res.errorMessage != undefined) {
                    self.callToaster(mdmService_service_MDMService.ERROR, res.errorMessage);
                }
                self.afterSave();
            });
        }
        else {
            self.service.saveFileForDesigner(BiUrls.SAVE_ANALYTICAL_MODEL, self.analyticalModel).then(function (res) {
                self.setPageNumberAfterCreatingNew();
                if (res.success) {
                    self.callToaster(mdmService_service_MDMService.SUCCESS, "Analytical Model Saved");
                }
                else if (res.message != undefined) {
                    self.callToaster(mdmService_service_MDMService.ERROR, res.message);
                }
                else if (res.errorMessage != undefined) {
                    self.callToaster(mdmService_service_MDMService.ERROR, res.errorMessage);
                }
                self.afterSave();
            });
        }
    };
    POCWizard.prototype.setPageNumberAfterCreatingNew = function () {
        var self = this;
        if (self.service.referenceLastPage) {
            self.service.referencePage = self.service.referenceLastPage - 1;
        }
        self.service.referenceLastPage = null;
    };
    POCWizard.prototype.afterSave = function () {
        var self = this;
        self.cubeScreen = true;
        self.editScreen = false;
        self.loader = false;
        self.isEdit = false;
        self.analyticalModel = null;
        self.prestoData = null;
        self.inMesEdit = false;
        self.previewAnalyticalModel = null;
        self.startDataVersion = null;
    };
    POCWizard.prototype.afterEditDim = function (event) {
        var self = this;
        self.analyticalModel.cube.cubeDimensionUsageData.forEach(function (dim) {
            if (dim.dimensionId == event.refId) {
                dim.dimensionData = event;
            }
        });
        this.editDimensionPage = false;
        this.selectedDim = null;
    };
    POCWizard.prototype.getFormulaMes = function (measureId) {
        var _this = this;
        this.analyticalModel.cube.cubeMeasureData.forEach(function (mesData) {
            if (mesData.measureId == measureId && mesData.recordFormatFieldId == null) {
                _this.isFormulaMeasure = true;
                return;
            }
        });
    };
    POCWizard.prototype.editMeasure = function (measure) {
        this.measureData = JSON.parse(JSON.stringify(measure));
        this.editMeasurePage = true;
        this.isnewFormulaMeasure = false;
        if (!this.isFormulaMeasure) {
            this.getFormulaMes(measure.refId);
        }
    };
    POCWizard.prototype.afterEditMeasure = function (event) {
        var self = this;
        if (!self.isnewFormulaMeasure) {
            self.analyticalModel.cube.cubeMeasureData.forEach(function (measure) {
                if (measure.measureId == event.refId) {
                    measure.measureData = event;
                }
            });
        }
        else {
            self.constructMeasureForFormula(event);
        }
        self.measureData = JSON.parse(JSON.stringify(event));
        self.inMesEdit = true;
        self.isFormulaMeasure = false;
        self.editMeasurePage = false;
        self.selectedMeasureId = null;
    };
    POCWizard.prototype.entityOpsMeasure = function (event) {
        if (this.selectedMeasureId == null) {
            this.selectedMeasureId = event.target.id;
            this.getFormulaMes(this.selectedMeasureId);
        }
        else {
            this.selectedMeasureId = null;
        }
    };
    POCWizard.prototype.onBackFromMeasureEdit = function () {
        this.editMeasurePage = false;
        this.selectedMeasureId = null;
        this.isFormulaMeasure = false;
        this.isnewFormulaMeasure = false;
        this.inMesEdit = false;
    };
    POCWizard.prototype.cancelDesigner = function () {
        if (this.cubeScreen) {
            this.childComponent.onBack();
        }
        this.selectedDataSource = null;
        this.cubeScreen = true;
        this.editScreen = false;
        this.uploadScreen = false;
        this.dimensionPage = false;
        this.measurePage = false;
        this.analyticalModel = null;
        this.inMesEdit = false;
        this.isEdit = false;
        this.file = null;
        this.isStarSchema = null;
        this.selectedFact = null;
        this.prestoData = null;
        this.startDataVersion = null;
        this.resetPreviewPageDetails();
    };
    POCWizard.prototype.resetPreviewPageDetails = function () {
        this.pageNo = 0;
        this.pageSize = 10;
        this.previewAnalyticalModel = null;
    };
    POCWizard.prototype.createNew = function () {
        this.selectedDataSource = null;
        this.childComponent.onBack();
        this.activeScreen = 'upload';
        this.cubeScreen = false;
    };
    POCWizard.prototype.beforeChange = function (event) {
        this.activeScreen == event.nextId;
        this.editDimensionPage = false;
        this.editMeasurePage = false;
        this.selectedDim = null;
        this.selectedMeasureId = null;
        this.file = null;
    };
    POCWizard.prototype.cubeValidator = function () {
        if (this.analyticalModel.cube.name != undefined && this.analyticalModel.cube.name.trim() == '') {
            return 'Please enter the name for Cube!';
        }
        return '';
    };
    POCWizard.prototype.addFormulaMeasure = function () {
        this.isFormulaMeasure = true;
        this.isnewFormulaMeasure = true;
        this.isEdit = false;
        var measure = new MeasureData();
        measure.targetType = 'max';
        measure.aggregator = 'sum';
        this.editMeasure(measure);
        this.isnewFormulaMeasure = true;
    };
    POCWizard.prototype.constructMeasureForFormula = function (measure) {
        var cubeMeasureData = new CubeMeasure();
        cubeMeasureData.refId = Math.floor(100000 + Math.random() * 90);
        cubeMeasureData.name = measure.displayName;
        cubeMeasureData.deleted = false;
        cubeMeasureData.measureData = measure;
        cubeMeasureData.measureData.refId = Math.floor(100000 + Math.random() * 90);
        cubeMeasureData.measureId = cubeMeasureData.measureData.refId;
        cubeMeasureData.measureData.targetType = measure.targetType;
        cubeMeasureData.measureData.aggregator = measure.aggregator;
        cubeMeasureData.measureData.deleted = false;
        cubeMeasureData.measureData.measureStatusIndicator = [];
        cubeMeasureData.measureData.measureTarget = [];
        cubeMeasureData.measureData.formulaExpression = measure.formulaExpression;
        this.analyticalModel.cube.cubeMeasureData.push(cubeMeasureData);
        this.isFormulaMeasure = false;
    };
    POCWizard.prototype.closeDropDown = function (event) {
        this.selectedMeasureId = null;
        this.selectedDim = null;
        this.isFormulaMeasure = false;
    };
    POCWizard.prototype.setFormulaList = function (event) {
        var _this = this;
        event.forEach(function (ele) {
            _this.analyticalModel.cube.cubeMeasureData.push(ele);
        });
    };
    POCWizard.prototype.removeMeasure = function (measure) {
        var r = confirm('Are you sure you want to remove the measure ' + measure.name + ' ?');
        if (r == true) {
            var index = this.analyticalModel.cube.cubeMeasureData.indexOf(measure);
            this.analyticalModel.cube.cubeMeasureData.splice(index, 1);
        }
    };
    POCWizard.prototype.clearCache = function () {
        var self = this;
        self.service.clearCache('ads/clearDataCache').then(function (res) {
            if (res.success) {
                self.toaster.showSuccess("Cache cleared successfully!");
            }
            else {
                self.toaster.showError("Unable To Clear Cache!");
            }
        });
    };
    POCWizard.prototype.dateValidator = function () {
        var self = this;
        if (this.startDataVersion && this.dataVersionDate) {
            var startDateMillisecond = (new Date(self.startDataVersion.year + "-" +
                self.startDataVersion.month + "-" + self.startDataVersion.day + " " +
                self.startDataVersionTime.hour + ":" + self.startDataVersionTime.minute).getTime());
            var endDateMillisecond = (new Date(self.dataVersionDate.year + "-" +
                self.dataVersionDate.month + "-" + self.dataVersionDate.day + " " +
                self.dataVersionTime.hour + ":" + self.dataVersionTime.minute).getTime());
            if (startDateMillisecond > endDateMillisecond) {
                return 'Start-Date cannot be greater than End-Date !';
            }
        }
        return '';
    };
    POCWizard.prototype.setStartDvTime = function (time) {
        this.startDataVersionTime = time;
    };
    POCWizard.prototype.setDvTime = function (time) {
        this.dataVersionTime = time;
    };
    POCWizard.prototype.clearStartDate = function () {
        this.startDataVersion = { day: null, month: null, year: null };
        this.startDataVersionTime = { hour: null, minute: null, second: null };
    };
    return POCWizard;
}());



// CONCATENATED MODULE: ./src/app/bulkUpload/bulkUpload.ts

var bulkUpload_BulkUploadComponent = /*@__PURE__*/ (function () {
    function BulkUploadComponent(route, activeModal, _location, _toast, viewContainerRef, _http, _global, translate, _share) {
        this.route = route;
        this.activeModal = activeModal;
        this._location = _location;
        this._toast = _toast;
        this.viewContainerRef = viewContainerRef;
        this._http = _http;
        this._global = _global;
        this.translate = translate;
        this._share = _share;
        this.uploadDoc = false;
        this.allData = [];
        this.allPageData = [];
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.showGrid = false;
        this.selectedProcess = 'Select';
        this.fileNameToUpload = null;
        this.fileType = false;
        this.uploadButtonDisable = false;
        this.comments = '';
        this.downloadUrl = {
            kpiUpload: 'downloadKpiUploadTemplate',
            scoreUpload: 'downloadKpiScoreUploadTemplate',
            approversUpload: 'downloadApproverUploadTemplate',
            bulkPublish: 'downloadBulkPublishTemplate',
            bulkRuleUpload: 'downloadProgramRulesUploadTemplate',
            bulkKpiDelete: 'downloadBulkKpiDeleteTemplate'
        };
        this.uploadUrls = {
            kpiUpload: 'uploadKpiData',
            scoreUpload: 'uploadKpiScoreData',
            approversUpload: 'uploadApproverData',
            bulkPublish: 'uploadBulkPublishData',
            bulkRuleUpload: 'uploadProgramRules',
            bulkKpiDelete: 'bulkKpiDelete'
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        _toast.setViewRef(viewContainerRef);
        var programData = this._share.getData();
        if (!programData.id) {
            this._location.back();
        }
        this.programId = programData.id;
        this.programName = programData.name;
        this.getAll();
    }
    BulkUploadComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    BulkUploadComponent.prototype.handleChange = function ($event) {
        this.uploadDoc = true;
    };
    BulkUploadComponent.prototype.downloadTemplate = function (process) {
        if (process === 'kpiUpload') {
            this.downloadKpiTemplate();
        }
        else if (process === 'bulkKpiDelete') {
            this.downloadKpiDeleteTemplate();
        }
        else {
            this.downloadAllTemplate(this.downloadUrl[process]);
        }
    };
    BulkUploadComponent.prototype.downloadAllTemplate = function (processType) {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/performance/' + processType + '/' + this.fileType;
            this._http.getBlob(url).subscribe(function (result) {
                var name = _this.getFileNameFromHeader(result.headers);
                FileSaver["saveAs"](result.body, name);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    BulkUploadComponent.prototype.downloadKpiTemplate = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/performance/downloadKpiUploadTemplate/'
                + this.programId + '/' + this.fileType;
            this._http.getBlob(url).subscribe(function (result) {
                var name = _this.getFileNameFromHeader(result.headers);
                FileSaver["saveAs"](result.body, name);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    BulkUploadComponent.prototype.downloadKpiDeleteTemplate = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/performance/downloadBulkKpiDeleteTemplate/'
                + this.programId + '/' + this.fileType;
            this._http.getBlob(url).subscribe(function (result) {
                var name = _this.getFileNameFromHeader(result.headers);
                FileSaver["saveAs"](result.body, name);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    BulkUploadComponent.prototype.getFileNameFromHeader = function (headers) {
        var header = headers.get('Content-Disposition');
        if (header == null) {
            return 'test.xlxs';
        }
        else {
            if (!header) {
                return null;
            }
            var result = header.split(';')[1].trim().split('=')[1];
            return result.replace(/'/g, '');
        }
    };
    BulkUploadComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAll();
    };
    BulkUploadComponent.prototype.onPageChange = function (event) {
        if (event === 1) {
            this.startingPage = 1;
            this.endingPage = 10;
        }
        else {
            this.startingPage = 1 + this.pageSize;
            if (this.collectionSize > this.endingPage) {
                this.endingPage = event + this.endingPage;
            }
            else {
                this.endingPage = this.collectionSize;
            }
        }
        this.page = event;
        this.getAll();
    };
    BulkUploadComponent.prototype.onProcessChange = function () {
        this.fileNameToUpload = null;
    };
    BulkUploadComponent.prototype.chooseFile = function (event) {
        if (event.target.files && event.target.files.length > 0) {
            var self_1 = this;
            self_1.attachmentFile = event.target.files[0];
            self_1.fileNameToUpload = event.target.files[0].name;
            event.srcElement.value = null;
        }
    };
    BulkUploadComponent.prototype.validate = function () {
        var _this = this;
        if (this.comments.trim() === '') {
            this.translate.get('commentsMandatory').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        else {
            return true;
        }
    };
    BulkUploadComponent.prototype.uploadFile = function (process) {
        this.uploadAllTemplate(this.uploadUrls[process]);
    };
    BulkUploadComponent.prototype.uploadAllTemplate = function (processType) {
        var _this = this;
        if (this.validate()) {
            this.uploadButtonDisable = true;
            var formData = new FormData();
            formData.append('file', this.attachmentFile);
            formData.append('programId', this.programId);
            formData.append('comment', this.comments);
            var url = this._baseUrl + 'v1/webAdmin/performance/' + processType;
            var options = { responseType: 'text' };
            this._http.filePost(url, formData, options).subscribe(function (res) {
                if (res != null) {
                    _this.translate.get('fileUpdatedSuccessfully').subscribe(function (msg) {
                        _this._toast.showSuccess(msg);
                    });
                    _this.getAll();
                    _this.fileNameToUpload = null;
                    _this.comments = '';
                    _this.selectedProcess = 'Select';
                    _this.uploadButtonDisable = false;
                }
                else {
                    _this.translate.get('fileUploadFailed').subscribe(function (msg) {
                        _this._toast.showError(msg);
                    });
                    _this.getAll();
                    _this.fileNameToUpload = null;
                    _this.comments = '';
                    _this.selectedProcess = 'Select';
                    _this.uploadButtonDisable = false;
                }
            }, function (error) {
                _this.translate.get('fileUpdateFailed').subscribe(function (msg) {
                    _this._toast.showError(msg);
                    _this.uploadButtonDisable = false;
                });
            });
        }
    };
    BulkUploadComponent.prototype.getAll = function () {
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/uploadProcess/getAllByGroup?group=PERFORMANCE'
            + '&page=' + self.page + '&pageSize=' + self.pageSize;
        self._http.get(url).subscribe(function (result) {
            self.allData = result.content;
            self.allPageData = result;
            self.collectionSize = result.totalElements;
            if (self.collectionSize < self.pageSize) {
                self.endingPage = self.collectionSize;
            }
            self.showGrid = true;
        }, function (error) {
            console.log(error);
        });
    };
    BulkUploadComponent.prototype.getDateFormat = function (date) {
        var dateCreated = new Date(date);
        return dateCreated.toString().substring(4, 15);
    };
    BulkUploadComponent.prototype.getExtension = function (fileName) {
        this.fileExtension = fileName.split('.').pop();
        return this.fileExtension.toLowerCase();
    };
    BulkUploadComponent.prototype.downloadValidationFile = function (path) {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/uploadProcess/downloadFile/' + path;
        this._http.getBlob(url).subscribe(function (result) {
            var name = _this.getFileNameFromHeader(result.headers);
            FileSaver["saveAs"](result.body, name);
        }, function (error) {
            console.log(error);
        });
    };
    BulkUploadComponent.prototype.clearSelection = function () {
        this.showGrid = false;
    };
    BulkUploadComponent.prototype.onFileTypeChange = function (event) {
        if (event === 'xlsx' || event === 'XLSX') {
            this.fileType = false;
        }
        else {
            this.fileType = true;
        }
    };
    return BulkUploadComponent;
}());



// CONCATENATED MODULE: ./src/app/cob/cob.component.ts

var cob_component_CobComponent = /*@__PURE__*/ (function () {
    function CobComponent(route, activeModal, _location, _toast, viewContainerRef, _http, eRef, _global, translate, _share) {
        this.route = route;
        this.activeModal = activeModal;
        this._location = _location;
        this._toast = _toast;
        this.viewContainerRef = viewContainerRef;
        this._http = _http;
        this.eRef = eRef;
        this._global = _global;
        this.translate = translate;
        this._share = _share;
        this.uploadDoc = false;
        this.allData = [];
        this.allPageData = [];
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.showGrid = false;
        this.fileNameToUpload = null;
        this.fileType = false;
        this.uploadButtonDisable = false;
        this.trackHides = null;
        this.comments = '';
        this._baseUrl = _global.get('EPMS_BASE_URL');
        _toast.setViewRef(viewContainerRef);
        this.getAll();
    }
    CobComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    CobComponent.prototype.handleChange = function ($event) {
        this.uploadDoc = true;
    };
    CobComponent.prototype.downloadTemplate = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/cob/downloadTemplate/type/ALL'
                + '/isOlderExcelFormat/' + this.fileType;
            this._http.getBlob(url).subscribe(function (result) {
                var name = _this.getFileNameFromHeader(result.headers);
                FileSaver["saveAs"](result.body, name);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    CobComponent.prototype.getFileNameFromHeader = function (headers) {
        var header = headers.get('Content-Disposition');
        if (header == null) {
            return 'CobUploadTemplate.xlxs';
        }
        else {
            if (!header) {
                return null;
            }
            var result = header.split(';')[1].trim().split('=')[1];
            return result.replace(/'/g, '');
        }
    };
    CobComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAll();
    };
    CobComponent.prototype.onPageChange = function (event) {
        if (event === 1) {
            this.startingPage = 1;
            this.endingPage = 10;
        }
        else {
            this.startingPage = 1 + this.pageSize;
            if (this.collectionSize > this.endingPage) {
                this.endingPage = event + this.endingPage;
            }
            else {
                this.endingPage = this.collectionSize;
            }
        }
        this.page = event;
        this.getAll();
    };
    CobComponent.prototype.chooseFile = function (event) {
        if (event.target.files && event.target.files.length > 0) {
            var self_1 = this;
            self_1.attachmentFile = event.target.files[0];
            self_1.fileNameToUpload = event.target.files[0].name;
            event.srcElement.value = null;
        }
    };
    CobComponent.prototype.validate = function () {
        var _this = this;
        if (this.comments.trim() === '') {
            this.translate.get('commentsMandatory').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        else {
            return true;
        }
    };
    CobComponent.prototype.processCob = function () {
        var _this = this;
        if (this.validate()) {
            var self_2 = this;
            self_2.uploadButtonDisable = true;
            var formData = new FormData();
            formData.append('file', self_2.attachmentFile);
            formData.append('comment', self_2.comments);
            var url = self_2._baseUrl + 'v1/webAdmin/cob/process';
            self_2._http.filePost(url, formData).subscribe(function (res) {
                _this.translate.get('fileUpdatedSuccessfully').subscribe(function (msg) {
                    _this._toast.showSuccess(msg);
                });
                self_2.getAll();
                self_2.fileNameToUpload = null;
                self_2.comments = '';
                self_2.uploadButtonDisable = false;
            }, function (error) {
                self_2.handelUploadError(error);
            });
        }
    };
    CobComponent.prototype.handelUploadError = function (error) {
        var _this = this;
        if (error.status === 409) {
            this.translate.get('canNotUploadCob').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
        }
        else {
            this.translate.get('fileUploadFailed').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
        }
        this.getAll();
        this.fileNameToUpload = null;
        this.comments = '';
        this.uploadButtonDisable = false;
    };
    CobComponent.prototype.uploadConfirm = function (processId) {
        var self = this;
        self.uploadButtonDisable = true;
        var url = this._baseUrl + 'v1/webAdmin/cob/upload?processId=' + processId;
        self._http.post(url, processId).subscribe(function (result) {
            self.uploadFileConfirm = result;
            self.translate.get('fileUploaded').subscribe(function (msg) {
                self._toast.showSuccess(msg);
            });
            self.getAll();
            self.uploadButtonDisable = false;
        }, function (error) {
            self.handelUploadError(error);
        });
    };
    CobComponent.prototype.conTanActions = function (value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    CobComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 10);
        }
    };
    CobComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    CobComponent.prototype.cancelProcess = function (processId) {
        var self = this;
        self.uploadButtonDisable = true;
        var url = this._baseUrl + 'v1/webAdmin/cob/cancelProcess?processId='
            + processId + '&reason=Force closed';
        self._http.post(url, processId).subscribe(function (result) {
            self.uploadFileConfirm = result;
            self.translate.get('cancelFileUpload').subscribe(function (msg) {
                self._toast.showSuccess(msg);
            });
            self.getAll();
            self.uploadButtonDisable = false;
        }, function (error) {
            self.handelUploadError(error);
        });
    };
    CobComponent.prototype.getAll = function () {
        var _this = this;
        var self = this;
        self.uploadButtonDisable = true;
        var url = self._baseUrl + 'v1/webAdmin/uploadProcess/getAllByGroup?group=HRIS'
            + '&page=' + self.page + '&pageSize=' + self.pageSize;
        self._http.get(url).subscribe(function (result) {
            self.allData = result.content;
            self.allPageData = result;
            self.collectionSize = result.totalElements;
            if (self.collectionSize < self.pageSize) {
                self.endingPage = self.collectionSize;
            }
            self.showGrid = true;
            _this.uploadButtonDisable = false;
        }, function (error) {
            console.log(error);
        });
    };
    CobComponent.prototype.getExtension = function (fileName) {
        this.fileExtension = fileName.split('.').pop();
        return this.fileExtension.toLowerCase();
    };
    CobComponent.prototype.getDateFormat = function (date) {
        var dateCreated = new Date(date);
        return dateCreated.toString().substring(4, 15);
    };
    CobComponent.prototype.downloadValidationFile = function (path) {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/uploadProcess/downloadFile/' + path;
        this._http.getBlob(url).subscribe(function (result) {
            var name = _this.getFileNameFromHeader(result.headers);
            FileSaver["saveAs"](result.body, name);
        }, function (error) {
            console.log(error);
        });
    };
    CobComponent.prototype.clearSelection = function () {
        this.showGrid = false;
    };
    CobComponent.prototype.onFileTypeChange = function (event) {
        if (event === 'xlsx' || event === 'XLSX') {
            this.fileType = false;
        }
        else {
            this.fileType = true;
        }
    };
    CobComponent.prototype.onRefresh = function () {
        this.getAll();
    };
    return CobComponent;
}());



// EXTERNAL MODULE: ./node_modules/timers-browserify/main.js
var main = __webpack_require__("162o");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/underscore/underscore.js
var underscore = __webpack_require__("rdLu");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/point.js
var Point = /*@__PURE__*/ (function () {
    function Point(x, y) {
        if (x === void 0) {
            x = 0;
        }
        if (y === void 0) {
            y = 0;
        }
        this.x = x;
        this.y = y;
    }
    Object.defineProperty(Point.prototype, "next", {
        get: function () {
            return this._next;
        },
        set: function (p) {
            this._next = p;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Point.prototype, "prev", {
        get: function () {
            return this._prev;
        },
        set: function (p) {
            this._prev = p;
        },
        enumerable: true,
        configurable: true
    });
    return Point;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/pointPool.js

var pointPool_PointPool = /*@__PURE__*/ (function () {
    function PointPool(initialSize) {
        PointPool._instance = this;
        var prev = this.firstAvailable = new Point();
        for (var i = 1; i < initialSize; i++) {
            var p = new Point();
            prev.next = p;
            prev = p;
        }
    }
    Object.defineProperty(PointPool, "instance", {
        get: function () {
            return PointPool._instance;
        },
        enumerable: true,
        configurable: true
    });
    PointPool.prototype.borrow = function (x, y) {
        if (this.firstAvailable == null) {
            throw 'Pool exhausted';
        }
        this.borrowed++;
        var p = this.firstAvailable;
        this.firstAvailable = p.next;
        p.x = x;
        p.y = y;
        return p;
    };
    ;
    PointPool.prototype.returnPoint = function (p) {
        this.borrowed--;
        p.x = 0;
        p.y = 0;
        p.next = this.firstAvailable;
        this.firstAvailable = p;
    };
    ;
    return PointPool;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/bounds.js

var bounds_Bounds = /*@__PURE__*/ (function () {
    function Bounds(x, y, width, height) {
        if (x === void 0) {
            x = 0;
        }
        if (y === void 0) {
            y = 0;
        }
        if (width === void 0) {
            width = 0;
        }
        if (height === void 0) {
            height = 0;
        }
        this.left = x;
        this.right = x + width;
        this.top = y;
        this.bottom = y + height;
    }
    Object.defineProperty(Bounds.prototype, "width", {
        get: function () {
            return this.right - this.left;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Bounds.prototype, "height", {
        get: function () {
            return this.bottom - this.top;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Bounds.prototype.getCentre = function () {
        var w = this.width;
        var h = this.height;
        return pointPool_PointPool.instance.borrow(this.left + (w / 2), this.top + (h / 2));
    };
    ;
    return Bounds;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/cropperDrawSettings.js
var CropperDrawSettings = /*@__PURE__*/ (function () {
    function CropperDrawSettings() {
        this.strokeWidth = 1;
        this.strokeColor = 'rgba(255,255,255,1)';
        this.dragIconStrokeWidth = 1;
        this.dragIconStrokeColor = 'rgba(0,0,0,1)';
        this.dragIconFillColor = 'rgba(255,255,255,1)';
    }
    return CropperDrawSettings;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/cropperSettings.js

var cropperSettings_CropperSettings = /*@__PURE__*/ (function () {
    function CropperSettings() {
        this.canvasWidth = 300;
        this.canvasHeight = 300;
        this.dynamicSizing = false;
        this.width = 200;
        this.height = 200;
        this.minWidth = 50;
        this.minHeight = 50;
        this.minWithRelativeToResolution = true;
        this.croppedWidth = 100;
        this.croppedHeight = 100;
        this.cropperDrawSettings = new CropperDrawSettings();
        this.touchRadius = 20;
        this.noFileInput = false;
        this.allowedFilesRegex = /\.(jpe?g|png|gif)$/i;
        this.cropOnResize = true;
        this.preserveSize = false;
        this.compressRatio = 1.0;
        this._rounded = false;
        this._keepAspect = true;
        // init
    }
    Object.defineProperty(CropperSettings.prototype, "rounded", {
        get: function () {
            return this._rounded;
        },
        set: function (val) {
            this._rounded = val;
            if (val) {
                this._keepAspect = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CropperSettings.prototype, "keepAspect", {
        get: function () {
            return this._keepAspect;
        },
        set: function (val) {
            if (val === false && this._rounded) {
                throw new Error('Cannot set keep aspect to false on rounded cropper. Ellipsis not supported');
            }
            this._keepAspect = val;
        },
        enumerable: true,
        configurable: true
    });
    return CropperSettings;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/handle.js


var handle_Handle = /*@__PURE__*/ (function () {
    function Handle(x, y, radius, settings) {
        this.cropperSettings = new cropperSettings_CropperSettings();
        this.over = false;
        this.drag = false;
        this._position = new Point(x, y);
        this.offset = new Point(0, 0);
        this.radius = radius;
        this.cropperSettings = settings;
    }
    Handle.prototype.setDrag = function (value) {
        this.drag = value;
        this.setOver(value);
    };
    Handle.prototype.draw = function (ctx) {
        // this should't be empty
    };
    Handle.prototype.setOver = function (over) {
        this.over = over;
    };
    Handle.prototype.touchInBounds = function (x, y) {
        return (x > this.position.x - this.radius + this.offset.x) &&
            (x < this.position.x + this.radius + this.offset.x) &&
            (y > this.position.y - this.radius + this.offset.y) &&
            (y < this.position.y + this.radius + this.offset.y);
    };
    Object.defineProperty(Handle.prototype, "position", {
        get: function () {
            return this._position;
        },
        enumerable: true,
        configurable: true
    });
    Handle.prototype.setPosition = function (x, y) {
        this._position.x = x;
        this._position.y = y;
    };
    return Handle;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/cornerMarker.js
var cornerMarker___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CornerMarker = /*@__PURE__*/ (function (_super) {
    cornerMarker___extends(CornerMarker, _super);
    function CornerMarker(x, y, radius, cropperSettings) {
        return _super.call(this, x, y, radius, cropperSettings) || this;
    }
    CornerMarker.prototype.drawCornerBorder = function (ctx) {
        var sideLength = 10;
        if (this.over || this.drag) {
            sideLength = 12;
        }
        var hDirection = 1;
        var vDirection = 1;
        if (this.horizontalNeighbour.position.x < this.position.x) {
            hDirection = -1;
        }
        if (this.verticalNeighbour.position.y < this.position.y) {
            vDirection = -1;
        }
        if (this.cropperSettings.rounded) {
            var width = this.position.x - this.horizontalNeighbour.position.x;
            var height = this.position.y - this.verticalNeighbour.position.y;
            var offX = Math.round(Math.sin(Math.PI / 2) * Math.abs(width / 2)) / 4;
            var offY = Math.round(Math.sin(Math.PI / 2) * Math.abs(height / 2)) / 4;
            this.offset.x = hDirection > 0 ? offX : -offX;
            this.offset.y = vDirection > 0 ? offY : -offY;
        }
        else {
            this.offset.x = 0;
            this.offset.y = 0;
        }
        ctx.beginPath();
        ctx.lineJoin = 'miter';
        ctx.moveTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
        ctx.lineTo(this.position.x + this.offset.x + (sideLength * hDirection), this.position.y + this.offset.y);
        ctx.lineTo(this.position.x + this.offset.x + (sideLength * hDirection), this.position.y + this.offset.y +
            (sideLength * vDirection));
        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y + (sideLength * vDirection));
        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
        ctx.closePath();
        ctx.lineWidth = this.cropperSettings.cropperDrawSettings.strokeWidth;
        ctx.strokeStyle = this.cropperSettings.cropperDrawSettings.strokeColor;
        ctx.stroke();
    };
    CornerMarker.prototype.drawCornerFill = function (ctx) {
        var sideLength = 10;
        if (this.over || this.drag) {
            sideLength = 12;
        }
        var hDirection = 1;
        var vDirection = 1;
        if (this.horizontalNeighbour.position.x < this.position.x) {
            hDirection = -1;
        }
        if (this.verticalNeighbour.position.y < this.position.y) {
            vDirection = -1;
        }
        ctx.beginPath();
        ctx.moveTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
        ctx.lineTo(this.position.x + this.offset.x + (sideLength * hDirection), this.position.y + this.offset.y);
        ctx.lineTo(this.position.x + this.offset.x + (sideLength * hDirection), this.position.y + this.offset.y +
            (sideLength * vDirection));
        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y + (sideLength * vDirection));
        ctx.lineTo(this.position.x + this.offset.x, this.position.y + this.offset.y);
        ctx.closePath();
        ctx.fillStyle = 'rgba(255,255,255,.7)';
        ctx.fill();
    };
    CornerMarker.prototype.moveX = function (x) {
        this.setPosition(x, this.position.y);
    };
    CornerMarker.prototype.moveY = function (y) {
        this.setPosition(this.position.x, y);
    };
    CornerMarker.prototype.move = function (x, y) {
        this.setPosition(x, y);
        this.verticalNeighbour.moveX(x);
        this.horizontalNeighbour.moveY(y);
    };
    CornerMarker.prototype.addHorizontalNeighbour = function (neighbour) {
        this.horizontalNeighbour = neighbour;
    };
    CornerMarker.prototype.addVerticalNeighbour = function (neighbour) {
        this.verticalNeighbour = neighbour;
    };
    CornerMarker.prototype.getHorizontalNeighbour = function () {
        return this.horizontalNeighbour;
    };
    CornerMarker.prototype.getVerticalNeighbour = function () {
        return this.verticalNeighbour;
    };
    CornerMarker.prototype.draw = function (ctx) {
        this.drawCornerFill(ctx);
        this.drawCornerBorder(ctx);
    };
    return CornerMarker;
}(handle_Handle));





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/cropTouch.js
var CropTouch = /*@__PURE__*/ (function () {
    function CropTouch(x, y, id) {
        if (x === void 0) {
            x = 0;
        }
        if (y === void 0) {
            y = 0;
        }
        if (id === void 0) {
            id = 0;
        }
        this.id = id;
        this.x = x;
        this.y = y;
    }
    return CropTouch;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/dragMarker.js
var dragMarker___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var dragMarker_DragMarker = /*@__PURE__*/ (function (_super) {
    dragMarker___extends(DragMarker, _super);
    function DragMarker(x, y, radius, cropperSettings) {
        var _this = _super.call(this, x, y, radius, cropperSettings) || this;
        _this.iconPoints = [];
        _this.scaledIconPoints = [];
        _this.getDragIconPoints(_this.iconPoints, 1);
        _this.getDragIconPoints(_this.scaledIconPoints, 1.2);
        return _this;
    }
    DragMarker.prototype.draw = function (ctx) {
        if (this.over || this.drag) {
            this.drawIcon(ctx, this.scaledIconPoints);
        }
        else {
            this.drawIcon(ctx, this.iconPoints);
        }
    };
    DragMarker.prototype.getDragIconPoints = function (arr, scale) {
        var maxLength = 17 * scale;
        var arrowWidth = 14 * scale;
        var arrowLength = 8 * scale;
        var connectorThroat = 4 * scale;
        arr.push(pointPool_PointPool.instance.borrow(-connectorThroat / 2, maxLength - arrowLength));
        arr.push(pointPool_PointPool.instance.borrow(-arrowWidth / 2, maxLength - arrowLength));
        arr.push(pointPool_PointPool.instance.borrow(0, maxLength));
        arr.push(pointPool_PointPool.instance.borrow(arrowWidth / 2, maxLength - arrowLength));
        arr.push(pointPool_PointPool.instance.borrow(connectorThroat / 2, maxLength - arrowLength));
        arr.push(pointPool_PointPool.instance.borrow(connectorThroat / 2, connectorThroat / 2));
        arr.push(pointPool_PointPool.instance.borrow(maxLength - arrowLength, connectorThroat / 2));
        arr.push(pointPool_PointPool.instance.borrow(maxLength - arrowLength, arrowWidth / 2));
        arr.push(pointPool_PointPool.instance.borrow(maxLength, 0));
        arr.push(pointPool_PointPool.instance.borrow(maxLength - arrowLength, -arrowWidth / 2));
        arr.push(pointPool_PointPool.instance.borrow(maxLength - arrowLength, -connectorThroat / 2));
        arr.push(pointPool_PointPool.instance.borrow(connectorThroat / 2, -connectorThroat / 2));
        arr.push(pointPool_PointPool.instance.borrow(connectorThroat / 2, -maxLength + arrowLength));
        arr.push(pointPool_PointPool.instance.borrow(arrowWidth / 2, -maxLength + arrowLength));
        arr.push(pointPool_PointPool.instance.borrow(0, -maxLength));
        arr.push(pointPool_PointPool.instance.borrow(-arrowWidth / 2, -maxLength + arrowLength));
        arr.push(pointPool_PointPool.instance.borrow(-connectorThroat / 2, -maxLength + arrowLength));
        arr.push(pointPool_PointPool.instance.borrow(-connectorThroat / 2, -connectorThroat / 2));
        arr.push(pointPool_PointPool.instance.borrow(-maxLength + arrowLength, -connectorThroat / 2));
        arr.push(pointPool_PointPool.instance.borrow(-maxLength + arrowLength, -arrowWidth / 2));
        arr.push(pointPool_PointPool.instance.borrow(-maxLength, 0));
        arr.push(pointPool_PointPool.instance.borrow(-maxLength + arrowLength, arrowWidth / 2));
        arr.push(pointPool_PointPool.instance.borrow(-maxLength + arrowLength, connectorThroat / 2));
        arr.push(pointPool_PointPool.instance.borrow(-connectorThroat / 2, connectorThroat / 2));
    };
    DragMarker.prototype.drawIcon = function (ctx, points) {
        ctx.beginPath();
        ctx.moveTo(points[0].x + this.position.x, points[0].y + this.position.y);
        for (var k = 0; k < points.length; k++) {
            var p = points[k];
            ctx.lineTo(p.x + this.position.x, p.y + this.position.y);
        }
        ctx.closePath();
        ctx.fillStyle = this.cropperSettings.cropperDrawSettings.dragIconFillColor;
        ctx.fill();
        ctx.lineWidth = this.cropperSettings.cropperDrawSettings.dragIconStrokeWidth;
        ctx.strokeStyle = this.cropperSettings.cropperDrawSettings.dragIconStrokeColor;
        ctx.stroke();
    };
    DragMarker.prototype.recalculatePosition = function (bounds) {
        var c = bounds.getCentre();
        this.setPosition(c.x, c.y);
        pointPool_PointPool.instance.returnPoint(c);
    };
    return DragMarker;
}(handle_Handle));





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/imageCropperModel.js
var ImageCropperModel = /*@__PURE__*/ (function () {
    function ImageCropperModel() {
    }
    return ImageCropperModel;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/imageCropperDataShare.js
var ImageCropperDataShare = /*@__PURE__*/ (function () {
    function ImageCropperDataShare() {
    }
    ImageCropperDataShare.setPressed = function (canvas) {
        this.pressed = canvas;
    };
    ;
    ImageCropperDataShare.setReleased = function (canvas) {
        if (canvas === this.pressed) {
            //  this.pressed = undefined;
        }
    };
    ;
    ImageCropperDataShare.setOver = function (canvas) {
        this.over = canvas;
    };
    ;
    ImageCropperDataShare.setStyle = function (canvas, style) {
        if (this.pressed !== undefined) {
            if (this.pressed === canvas) {
                // TODO: check this
                // angular.element(document.documentElement).css('cursor', style);
            }
        }
        else {
            if (canvas === this.over) {
                // TODO: check this
                // angular.element(document.documentElement).css('cursor', style);
            }
        }
    };
    ;
    ImageCropperDataShare.share = {};
    return ImageCropperDataShare;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/imageCropper.js
var imageCropper___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







var imageCropper_ImageCropper = /*@__PURE__*/ (function (_super) {
    imageCropper___extends(ImageCropper, _super);
    function ImageCropper(cropperSettings) {
        var _this = _super.call(this) || this;
        var x = 0;
        var y = 0;
        var width = cropperSettings.width;
        var height = cropperSettings.height;
        var keepAspect = cropperSettings.keepAspect;
        var touchRadius = cropperSettings.touchRadius;
        var minWidth = cropperSettings.minWidth;
        var minHeight = cropperSettings.minHeight;
        var croppedWidth = cropperSettings.croppedWidth;
        var croppedHeight = cropperSettings.croppedHeight;
        _this.cropperSettings = cropperSettings;
        _this.crop = _this;
        _this.x = x;
        _this.y = y;
        if (width === void 0) {
            _this.width = 100;
        }
        if (height === void 0) {
            _this.height = 50;
        }
        if (keepAspect === void 0) {
            _this.keepAspect = true;
        }
        if (touchRadius === void 0) {
            _this.touchRadius = 20;
        }
        _this.minWidth = minWidth;
        _this.minHeight = minHeight;
        _this.keepAspect = false;
        _this.aspectRatio = 0;
        _this.currentDragTouches = [];
        _this.isMouseDown = false;
        _this.ratioW = 1;
        _this.ratioH = 1;
        _this.fileType = cropperSettings.fileType;
        _this.imageSet = false;
        _this.pointPool = new pointPool_PointPool(200);
        _this.tl = new CornerMarker(x, y, touchRadius, _this.cropperSettings);
        _this.tr = new CornerMarker(x + width, y, touchRadius, _this.cropperSettings);
        _this.bl = new CornerMarker(x, y + height, touchRadius, _this.cropperSettings);
        _this.br = new CornerMarker(x + width, y + height, touchRadius, _this.cropperSettings);
        _this.tl.addHorizontalNeighbour(_this.tr);
        _this.tl.addVerticalNeighbour(_this.bl);
        _this.tr.addHorizontalNeighbour(_this.tl);
        _this.tr.addVerticalNeighbour(_this.br);
        _this.bl.addHorizontalNeighbour(_this.br);
        _this.bl.addVerticalNeighbour(_this.tl);
        _this.br.addHorizontalNeighbour(_this.bl);
        _this.br.addVerticalNeighbour(_this.tr);
        _this.markers = [_this.tl, _this.tr, _this.bl, _this.br];
        _this.center = new dragMarker_DragMarker(x + (width / 2), y + (height / 2), touchRadius, _this.cropperSettings);
        _this.keepAspect = keepAspect;
        _this.aspectRatio = height / width;
        _this.croppedImage = new Image();
        _this.currentlyInteracting = false;
        _this.cropWidth = croppedWidth;
        _this.cropHeight = croppedHeight;
        return _this;
    }
    ImageCropper.sign = function (x) {
        if (+x === x) {
            return (x === 0) ? x : (x > 0) ? 1 : -1;
        }
        return NaN;
    };
    ImageCropper.getMousePos = function (canvas, evt) {
        var rect = canvas.getBoundingClientRect();
        return pointPool_PointPool.instance.borrow(evt.clientX - rect.left, evt.clientY - rect.top);
    };
    ImageCropper.getTouchPos = function (canvas, touch) {
        var rect = canvas.getBoundingClientRect();
        return pointPool_PointPool.instance.borrow(touch.clientX - rect.left, touch.clientY - rect.top);
    };
    ImageCropper.detectVerticalSquash = function (img) {
        var ih = img.height;
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = ih;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var imageData = ctx.getImageData(0, 0, 1, ih);
        if (imageData) {
            var data = imageData.data;
            // search image edge pixel position in case it is squashed vertically.
            var sy = 0;
            var ey = ih;
            var py = ih;
            while (py > sy) {
                var alpha = data[(py - 1) * 4 + 3];
                if (alpha === 0) {
                    ey = py;
                }
                else {
                    sy = py;
                }
                py = (ey + sy) >> 1;
            }
            var ratio = (py / ih);
            return (ratio === 0) ? 1 : ratio;
        }
        else {
            return 1;
        }
    };
    ImageCropper.prototype.getDataUriMimeType = function (dataUri) {
        // Get a substring because the regex does not perform well on very large strings. Cater for optional charset. Length 50 shoould be enough.
        var dataUriSubstring = dataUri.substring(0, 50);
        var mimeType = 'image/png';
        // data-uri scheme
        // data:[<media type>][;charset=<character set>][;base64],<data>
        var regEx = RegExp(/^(data:)([\w\/\+]+);(charset=[\w-]+|base64).*,(.*)/gi);
        var matches = regEx.exec(dataUriSubstring);
        if (matches && matches[2]) {
            mimeType = matches[2];
            if (mimeType == 'image/jpg') {
                mimeType = 'image/jpeg';
            }
        }
        return mimeType;
    };
    ImageCropper.prototype.prepare = function (canvas) {
        this.buffer = document.createElement('canvas');
        this.cropCanvas = document.createElement('canvas');
        // todo get more reliable parent width value.
        var responsiveWidth = canvas.parentElement ? canvas.parentElement.clientWidth : 0;
        if (responsiveWidth > 0 && this.cropperSettings.dynamicSizing) {
            this.cropCanvas.width = responsiveWidth;
            this.buffer.width = responsiveWidth;
            canvas.width = responsiveWidth;
        }
        else {
            this.cropCanvas.width = this.cropWidth;
            this.buffer.width = canvas.width;
        }
        this.cropCanvas.height = this.cropHeight;
        this.buffer.height = canvas.height;
        this.canvas = canvas;
        this.ctx = this.canvas.getContext('2d');
        this.draw(this.ctx);
    };
    ImageCropper.prototype.resizeCanvas = function (width, height, setImage) {
        if (setImage === void 0) {
            setImage = false;
        }
        this.canvas.width = this.cropCanvas.width = this.width = this.canvasWidth = this.buffer.width = width;
        this.canvas.height = this.cropCanvas.height = this.height = this.canvasHeight = this.buffer.height = height;
        if (setImage) {
            this.setImage(this.srcImage);
        }
    };
    ImageCropper.prototype.reset = function () {
        this.setImage(undefined);
    };
    ImageCropper.prototype.draw = function (ctx) {
        var bounds = this.getBounds();
        if (this.srcImage) {
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            var sourceAspect = this.srcImage.height / this.srcImage.width;
            var canvasAspect = this.canvasHeight / this.canvasWidth;
            var w = this.canvasWidth;
            var h = this.canvasHeight;
            if (canvasAspect > sourceAspect) {
                w = this.canvasWidth;
                h = this.canvasWidth * sourceAspect;
            }
            else {
                h = this.canvasHeight;
                w = this.canvasHeight / sourceAspect;
            }
            this.ratioW = w / this.srcImage.width;
            this.ratioH = h / this.srcImage.height;
            if (canvasAspect < sourceAspect) {
                this.drawImageIOSFix(ctx, this.srcImage, 0, 0, this.srcImage.width, this.srcImage.height, this.buffer.width / 2 - w / 2, 0, w, h);
            }
            else {
                this.drawImageIOSFix(ctx, this.srcImage, 0, 0, this.srcImage.width, this.srcImage.height, 0, this.buffer.height / 2 - h / 2, w, h);
            }
            this.buffer.getContext('2d')
                .drawImage(this.canvas, 0, 0, this.canvasWidth, this.canvasHeight);
            ctx.lineWidth = this.cropperSettings.cropperDrawSettings.strokeWidth;
            ctx.strokeStyle = this.cropperSettings.cropperDrawSettings.strokeColor; // 'rgba(255,228,0,1)';
            if (!this.cropperSettings.rounded) {
                ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
                ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
                ctx.drawImage(this.buffer, bounds.left, bounds.top, Math.max(bounds.width, 1), Math.max(bounds.height, 1), bounds.left, bounds.top, bounds.width, bounds.height);
                ctx.strokeRect(bounds.left, bounds.top, bounds.width, bounds.height);
            }
            else {
                ctx.beginPath();
                ctx.arc(bounds.left + bounds.width / 2, bounds.top + bounds.height / 2, bounds.width / 2, 0, Math.PI * 2, true);
                ctx.closePath();
                ctx.stroke();
            }
            var marker = void 0;
            for (var i = 0; i < this.markers.length; i++) {
                marker = this.markers[i];
                marker.draw(ctx);
            }
            this.center.draw(ctx);
        }
        else {
            ctx.fillStyle = 'rgba(192,192,192,1)';
            ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        }
    };
    ImageCropper.prototype.dragCenter = function (x, y, marker) {
        var bounds = this.getBounds();
        var left = x - (bounds.width / 2);
        var right = x + (bounds.width / 2);
        var top = y - (bounds.height / 2);
        var bottom = y + (bounds.height / 2);
        if (right >= this.maxXClamp) {
            x = this.maxXClamp - bounds.width / 2;
        }
        if (left <= this.minXClamp) {
            x = bounds.width / 2 + this.minXClamp;
        }
        if (top < this.minYClamp) {
            y = bounds.height / 2 + this.minYClamp;
        }
        if (bottom >= this.maxYClamp) {
            y = this.maxYClamp - bounds.height / 2;
        }
        this.tl.moveX(x - (bounds.width / 2));
        this.tl.moveY(y - (bounds.height / 2));
        this.tr.moveX(x + (bounds.width / 2));
        this.tr.moveY(y - (bounds.height / 2));
        this.bl.moveX(x - (bounds.width / 2));
        this.bl.moveY(y + (bounds.height / 2));
        this.br.moveX(x + (bounds.width / 2));
        this.br.moveY(y + (bounds.height / 2));
        marker.setPosition(x, y);
    };
    ImageCropper.prototype.enforceMinSize = function (x, y, marker) {
        var xLength = x - marker.getHorizontalNeighbour().position.x;
        var yLength = y - marker.getVerticalNeighbour().position.y;
        var xOver = this.minWidth - Math.abs(xLength);
        var yOver = this.minHeight - Math.abs(yLength);
        if (xLength === 0 || yLength === 0) {
            x = marker.position.x;
            y = marker.position.y;
            return pointPool_PointPool.instance.borrow(x, y);
        }
        if (this.keepAspect) {
            if (xOver > 0 && (yOver / this.aspectRatio) > 0) {
                if (xOver > (yOver / this.aspectRatio)) {
                    if (xLength < 0) {
                        x -= xOver;
                        if (yLength < 0) {
                            y -= xOver * this.aspectRatio;
                        }
                        else {
                            y += xOver * this.aspectRatio;
                        }
                    }
                    else {
                        x += xOver;
                        if (yLength < 0) {
                            y -= xOver * this.aspectRatio;
                        }
                        else {
                            y += xOver * this.aspectRatio;
                        }
                    }
                }
                else {
                    if (yLength < 0) {
                        y -= yOver;
                        if (xLength < 0) {
                            x -= yOver / this.aspectRatio;
                        }
                        else {
                            x += yOver / this.aspectRatio;
                        }
                    }
                    else {
                        y += yOver;
                        if (xLength < 0) {
                            x -= yOver / this.aspectRatio;
                        }
                        else {
                            x += yOver / this.aspectRatio;
                        }
                    }
                }
            }
            else {
                if (xOver > 0) {
                    if (xLength < 0) {
                        x -= xOver;
                        if (yLength < 0) {
                            y -= xOver * this.aspectRatio;
                        }
                        else {
                            y += xOver * this.aspectRatio;
                        }
                    }
                    else {
                        x += xOver;
                        if (yLength < 0) {
                            y -= xOver * this.aspectRatio;
                        }
                        else {
                            y += xOver * this.aspectRatio;
                        }
                    }
                }
                else {
                    if (yOver > 0) {
                        if (yLength < 0) {
                            y -= yOver;
                            if (xLength < 0) {
                                x -= yOver / this.aspectRatio;
                            }
                            else {
                                x += yOver / this.aspectRatio;
                            }
                        }
                        else {
                            y += yOver;
                            if (xLength < 0) {
                                x -= yOver / this.aspectRatio;
                            }
                            else {
                                x += yOver / this.aspectRatio;
                            }
                        }
                    }
                }
            }
        }
        else {
            if (xOver > 0) {
                if (xLength < 0) {
                    x -= xOver;
                }
                else {
                    x += xOver;
                }
            }
            if (yOver > 0) {
                if (yLength < 0) {
                    y -= yOver;
                }
                else {
                    y += yOver;
                }
            }
        }
        if (x < this.minXClamp || x > this.maxXClamp || y < this.minYClamp || y > this.maxYClamp) {
            x = marker.position.x;
            y = marker.position.y;
        }
        return pointPool_PointPool.instance.borrow(x, y);
    };
    ImageCropper.prototype.dragCorner = function (x, y, marker) {
        var iX = 0;
        var iY = 0;
        var ax = 0;
        var ay = 0;
        var newHeight = 0;
        var newWidth = 0;
        var newY = 0;
        var newX = 0;
        var anchorMarker;
        var fold = 0;
        if (this.keepAspect) {
            anchorMarker = marker.getHorizontalNeighbour().getVerticalNeighbour();
            ax = anchorMarker.position.x;
            ay = anchorMarker.position.y;
            if (x <= anchorMarker.position.x) {
                if (y <= anchorMarker.position.y) {
                    iX = ax - (100 / this.aspectRatio);
                    iY = ay - (100 / this.aspectRatio * this.aspectRatio);
                    fold = this.getSide(pointPool_PointPool.instance.borrow(iX, iY), anchorMarker.position, pointPool_PointPool.instance.borrow(x, y));
                    if (fold > 0) {
                        newHeight = Math.abs(anchorMarker.position.y - y);
                        newWidth = newHeight / this.aspectRatio;
                        newY = anchorMarker.position.y - newHeight;
                        newX = anchorMarker.position.x - newWidth;
                        var min = this.enforceMinSize(newX, newY, marker);
                        marker.move(min.x, min.y);
                        pointPool_PointPool.instance.returnPoint(min);
                    }
                    else {
                        if (fold < 0) {
                            newWidth = Math.abs(anchorMarker.position.x - x);
                            newHeight = newWidth * this.aspectRatio;
                            newY = anchorMarker.position.y - newHeight;
                            newX = anchorMarker.position.x - newWidth;
                            var min = this.enforceMinSize(newX, newY, marker);
                            marker.move(min.x, min.y);
                            pointPool_PointPool.instance.returnPoint(min);
                        }
                    }
                }
                else {
                    iX = ax - (100 / this.aspectRatio);
                    iY = ay + (100 / this.aspectRatio * this.aspectRatio);
                    fold = this.getSide(pointPool_PointPool.instance.borrow(iX, iY), anchorMarker.position, pointPool_PointPool.instance.borrow(x, y));
                    if (fold > 0) {
                        newWidth = Math.abs(anchorMarker.position.x - x);
                        newHeight = newWidth * this.aspectRatio;
                        newY = anchorMarker.position.y + newHeight;
                        newX = anchorMarker.position.x - newWidth;
                        var min = this.enforceMinSize(newX, newY, marker);
                        marker.move(min.x, min.y);
                        pointPool_PointPool.instance.returnPoint(min);
                    }
                    else {
                        if (fold < 0) {
                            newHeight = Math.abs(anchorMarker.position.y - y);
                            newWidth = newHeight / this.aspectRatio;
                            newY = anchorMarker.position.y + newHeight;
                            newX = anchorMarker.position.x - newWidth;
                            var min = this.enforceMinSize(newX, newY, marker);
                            marker.move(min.x, min.y);
                            pointPool_PointPool.instance.returnPoint(min);
                        }
                    }
                }
            }
            else {
                if (y <= anchorMarker.position.y) {
                    iX = ax + (100 / this.aspectRatio);
                    iY = ay - (100 / this.aspectRatio * this.aspectRatio);
                    fold = this.getSide(pointPool_PointPool.instance.borrow(iX, iY), anchorMarker.position, pointPool_PointPool.instance.borrow(x, y));
                    if (fold < 0) {
                        newHeight = Math.abs(anchorMarker.position.y - y);
                        newWidth = newHeight / this.aspectRatio;
                        newY = anchorMarker.position.y - newHeight;
                        newX = anchorMarker.position.x + newWidth;
                        var min = this.enforceMinSize(newX, newY, marker);
                        marker.move(min.x, min.y);
                        pointPool_PointPool.instance.returnPoint(min);
                    }
                    else {
                        if (fold > 0) {
                            newWidth = Math.abs(anchorMarker.position.x - x);
                            newHeight = newWidth * this.aspectRatio;
                            newY = anchorMarker.position.y - newHeight;
                            newX = anchorMarker.position.x + newWidth;
                            var min = this.enforceMinSize(newX, newY, marker);
                            marker.move(min.x, min.y);
                            pointPool_PointPool.instance.returnPoint(min);
                        }
                    }
                }
                else {
                    iX = ax + (100 / this.aspectRatio);
                    iY = ay + (100 / this.aspectRatio * this.aspectRatio);
                    fold = this.getSide(pointPool_PointPool.instance.borrow(iX, iY), anchorMarker.position, pointPool_PointPool.instance.borrow(x, y));
                    if (fold < 0) {
                        newWidth = Math.abs(anchorMarker.position.x - x);
                        newHeight = newWidth * this.aspectRatio;
                        newY = anchorMarker.position.y + newHeight;
                        newX = anchorMarker.position.x + newWidth;
                        var min = this.enforceMinSize(newX, newY, marker);
                        marker.move(min.x, min.y);
                        pointPool_PointPool.instance.returnPoint(min);
                    }
                    else {
                        if (fold > 0) {
                            newHeight = Math.abs(anchorMarker.position.y - y);
                            newWidth = newHeight / this.aspectRatio;
                            newY = anchorMarker.position.y + newHeight;
                            newX = anchorMarker.position.x + newWidth;
                            var min = this.enforceMinSize(newX, newY, marker);
                            marker.move(min.x, min.y);
                            pointPool_PointPool.instance.returnPoint(min);
                        }
                    }
                }
            }
        }
        else {
            var min = this.enforceMinSize(x, y, marker);
            marker.move(min.x, min.y);
            pointPool_PointPool.instance.returnPoint(min);
        }
        this.center.recalculatePosition(this.getBounds());
    };
    ImageCropper.prototype.getSide = function (a, b, c) {
        var n = ImageCropper.sign((b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x));
        // TODO move the return of the pools to outside of this function
        pointPool_PointPool.instance.returnPoint(a);
        pointPool_PointPool.instance.returnPoint(c);
        return n;
    };
    ImageCropper.prototype.handleRelease = function (newCropTouch) {
        if (newCropTouch == null) {
            return;
        }
        var index = 0;
        for (var k = 0; k < this.currentDragTouches.length; k++) {
            if (newCropTouch.id === this.currentDragTouches[k].id) {
                this.currentDragTouches[k].dragHandle.setDrag(false);
                index = k;
            }
        }
        this.currentDragTouches.splice(index, 1);
        this.draw(this.ctx);
    };
    ImageCropper.prototype.handleMove = function (newCropTouch) {
        var matched = false;
        for (var k = 0; k < this.currentDragTouches.length; k++) {
            if (newCropTouch.id === this.currentDragTouches[k].id && this.currentDragTouches[k].dragHandle != null) {
                var dragTouch = this.currentDragTouches[k];
                var clampedPositions = this.clampPosition(newCropTouch.x - dragTouch.dragHandle.offset.x, newCropTouch.y - dragTouch.dragHandle.offset.y);
                newCropTouch.x = clampedPositions.x;
                newCropTouch.y = clampedPositions.y;
                pointPool_PointPool.instance.returnPoint(clampedPositions);
                if (dragTouch.dragHandle instanceof CornerMarker) {
                    this.dragCorner(newCropTouch.x, newCropTouch.y, dragTouch.dragHandle);
                }
                else {
                    this.dragCenter(newCropTouch.x, newCropTouch.y, dragTouch.dragHandle);
                }
                this.currentlyInteracting = true;
                matched = true;
                ImageCropperDataShare.setPressed(this.canvas);
                break;
            }
        }
        if (!matched) {
            for (var i = 0; i < this.markers.length; i++) {
                var marker = this.markers[i];
                if (marker.touchInBounds(newCropTouch.x, newCropTouch.y)) {
                    newCropTouch.dragHandle = marker;
                    this.currentDragTouches.push(newCropTouch);
                    marker.setDrag(true);
                    newCropTouch.dragHandle.offset.x = newCropTouch.x - newCropTouch.dragHandle.position.x;
                    newCropTouch.dragHandle.offset.y = newCropTouch.y - newCropTouch.dragHandle.position.y;
                    this.dragCorner(newCropTouch.x - newCropTouch.dragHandle.offset.x, newCropTouch.y - newCropTouch.dragHandle.offset.y, newCropTouch.dragHandle);
                    break;
                }
            }
            if (newCropTouch.dragHandle === null || typeof newCropTouch.dragHandle === 'undefined') {
                if (this.center.touchInBounds(newCropTouch.x, newCropTouch.y)) {
                    newCropTouch.dragHandle = this.center;
                    this.currentDragTouches.push(newCropTouch);
                    newCropTouch.dragHandle.setDrag(true);
                    newCropTouch.dragHandle.offset.x = newCropTouch.x - newCropTouch.dragHandle.position.x;
                    newCropTouch.dragHandle.offset.y = newCropTouch.y - newCropTouch.dragHandle.position.y;
                    this.dragCenter(newCropTouch.x - newCropTouch.dragHandle.offset.x, newCropTouch.y - newCropTouch.dragHandle.offset.y, newCropTouch.dragHandle);
                }
            }
        }
    };
    ImageCropper.prototype.updateClampBounds = function () {
        var sourceAspect = this.srcImage.height / this.srcImage.width;
        var canvasAspect = this.canvas.height / this.canvas.width;
        var w = this.canvas.width;
        var h = this.canvas.height;
        if (canvasAspect > sourceAspect) {
            w = this.canvas.width;
            h = this.canvas.width * sourceAspect;
        }
        else {
            h = this.canvas.height;
            w = this.canvas.height / sourceAspect;
        }
        this.minXClamp = this.canvas.width / 2 - w / 2;
        this.minYClamp = this.canvas.height / 2 - h / 2;
        this.maxXClamp = this.canvas.width / 2 + w / 2;
        this.maxYClamp = this.canvas.height / 2 + h / 2;
    };
    ImageCropper.prototype.getCropBounds = function () {
        var bounds = this.getBounds();
        bounds.top = Math.round((bounds.top - this.minYClamp) / this.ratioH);
        bounds.bottom = Math.round((bounds.bottom - this.minYClamp) / this.ratioH);
        bounds.left = Math.round((bounds.left - this.minXClamp) / this.ratioW);
        bounds.right = Math.round((bounds.right - this.minXClamp) / this.ratioW);
        return bounds;
    };
    ImageCropper.prototype.clampPosition = function (x, y) {
        if (x < this.minXClamp) {
            x = this.minXClamp;
        }
        if (x > this.maxXClamp) {
            x = this.maxXClamp;
        }
        if (y < this.minYClamp) {
            y = this.minYClamp;
        }
        if (y > this.maxYClamp) {
            y = this.maxYClamp;
        }
        return pointPool_PointPool.instance.borrow(x, y);
    };
    ImageCropper.prototype.isImageSet = function () {
        return this.imageSet;
    };
    ImageCropper.prototype.setImage = function (img) {
        this.srcImage = img;
        if (!img) {
            this.imageSet = false;
            this.draw(this.ctx);
        }
        else {
            this.imageSet = true;
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            var bufferContext = this.buffer.getContext('2d');
            bufferContext.clearRect(0, 0, this.buffer.width, this.buffer.height);
            if (!this.cropperSettings.fileType)
                this.fileType = this.getDataUriMimeType(img.src);
            if (this.cropperSettings.minWithRelativeToResolution) {
                this.minWidth = (this.canvas.width * this.cropperSettings.minWidth / this.srcImage.width);
                this.minHeight = (this.canvas.height * this.cropperSettings.minHeight / this.srcImage.height);
            }
            this.updateClampBounds();
            this.canvasWidth = this.canvas.width;
            this.canvasHeight = this.canvas.height;
            var cropPosition = this.getCropPositionFromMarkers();
            this.setCropPosition(cropPosition);
        }
    };
    ImageCropper.prototype.updateCropPosition = function (cropBounds) {
        var cropPosition = this.getCropPositionFromBounds(cropBounds);
        this.setCropPosition(cropPosition);
    };
    ImageCropper.prototype.setCropPosition = function (cropPosition) {
        this.tl.setPosition(cropPosition[0].x, cropPosition[0].y);
        this.tr.setPosition(cropPosition[1].x, cropPosition[1].y);
        this.bl.setPosition(cropPosition[2].x, cropPosition[2].y);
        this.br.setPosition(cropPosition[3].x, cropPosition[3].y);
        this.center.setPosition(cropPosition[4].x, cropPosition[4].y);
        for (var _i = 0, cropPosition_1 = cropPosition; _i < cropPosition_1.length; _i++) {
            var position = cropPosition_1[_i];
            pointPool_PointPool.instance.returnPoint(position);
        }
        this.vertSquashRatio = ImageCropper.detectVerticalSquash(this.srcImage);
        this.draw(this.ctx);
        this.croppedImage = this.getCroppedImageHelper(false, this.cropWidth, this.cropHeight);
    };
    ImageCropper.prototype.getCropPositionFromMarkers = function () {
        var w = this.canvas.width;
        var h = this.canvas.height;
        var tlPos, trPos, blPos, brPos, center;
        var sourceAspect = this.srcImage.height / this.srcImage.width;
        var cropBounds = this.getBounds();
        var cropAspect = cropBounds.height / cropBounds.width;
        var cX = this.canvas.width / 2;
        var cY = this.canvas.height / 2;
        if (cropAspect > sourceAspect) {
            var imageH = Math.min(w * sourceAspect, h);
            var cropW = imageH / cropAspect;
            tlPos = pointPool_PointPool.instance.borrow(cX - cropW / 2, cY + imageH / 2);
            trPos = pointPool_PointPool.instance.borrow(cX + cropW / 2, cY + imageH / 2);
            blPos = pointPool_PointPool.instance.borrow(cX - cropW / 2, cY - imageH / 2);
            brPos = pointPool_PointPool.instance.borrow(cX + cropW / 2, cY - imageH / 2);
        }
        else {
            var imageW = Math.min(h / sourceAspect, w);
            var cropH = imageW * cropAspect;
            tlPos = pointPool_PointPool.instance.borrow(cX - imageW / 2, cY + cropH / 2);
            trPos = pointPool_PointPool.instance.borrow(cX + imageW / 2, cY + cropH / 2);
            blPos = pointPool_PointPool.instance.borrow(cX - imageW / 2, cY - cropH / 2);
            brPos = pointPool_PointPool.instance.borrow(cX + imageW / 2, cY - cropH / 2);
        }
        center = pointPool_PointPool.instance.borrow(cX, cY);
        var positions = [tlPos, trPos, blPos, brPos, center];
        return positions;
    };
    ImageCropper.prototype.getCropPositionFromBounds = function (cropPosition) {
        var marginTop = 0;
        var marginLeft = 0;
        var canvasAspect = this.canvasHeight / this.canvasWidth;
        var sourceAspect = this.srcImage.height / this.srcImage.width;
        if (canvasAspect > sourceAspect) {
            marginTop = this.buffer.height / 2 - (this.canvasWidth * sourceAspect) / 2;
        }
        else {
            marginLeft = this.buffer.width / 2 - (this.canvasHeight / sourceAspect) / 2;
        }
        var ratioW = (this.canvasWidth - marginLeft * 2) / this.srcImage.width;
        var ratioH = (this.canvasHeight - marginTop * 2) / this.srcImage.height;
        var actualH = cropPosition.height * ratioH;
        var actualW = cropPosition.width * ratioW;
        var actualX = cropPosition.left * ratioW + marginLeft;
        var actualY = cropPosition.top * ratioH + marginTop;
        if (this.keepAspect) {
            var scaledW = actualH / this.aspectRatio;
            var scaledH = actualW * this.aspectRatio;
            if (this.getCropBounds().height === cropPosition.height) {
                actualH = scaledH;
            }
            else if (this.getCropBounds().width === cropPosition.width) {
                actualW = scaledW;
            }
            else {
                if (Math.abs(scaledH - actualH) < Math.abs(scaledW - actualW)) {
                    actualW = scaledW;
                }
                else {
                    actualH = scaledH;
                }
            }
        }
        var tlPos = pointPool_PointPool.instance.borrow(actualX, actualY + actualH);
        var trPos = pointPool_PointPool.instance.borrow(actualX + actualW, actualY + actualH);
        var blPos = pointPool_PointPool.instance.borrow(actualX, actualY);
        var brPos = pointPool_PointPool.instance.borrow(actualX + actualW, actualY);
        var center = pointPool_PointPool.instance.borrow(actualX + actualW / 2, actualY + actualH / 2);
        var positions = [tlPos, trPos, blPos, brPos, center];
        return positions;
    };
    ImageCropper.prototype.getCroppedImageHelper = function (preserveSize, fillWidth, fillHeight) {
        if (this.cropperSettings.cropOnResize) {
            return this.getCroppedImage(preserveSize, fillWidth, fillHeight);
        }
        return this.croppedImage ? this.croppedImage : document.createElement('img');
    };
    // todo: Unused parameters?
    ImageCropper.prototype.getCroppedImage = function (preserveSize, fillWidth, fillHeight) {
        var bounds = this.getBounds();
        if (!this.srcImage) {
            return document.createElement('img');
        }
        else {
            var sourceAspect = this.srcImage.height / this.srcImage.width;
            var canvasAspect = this.canvas.height / this.canvas.width;
            var w = this.canvas.width;
            var h = this.canvas.height;
            if (canvasAspect > sourceAspect) {
                w = this.canvas.width;
                h = this.canvas.width * sourceAspect;
            }
            else {
                if (canvasAspect < sourceAspect) {
                    h = this.canvas.height;
                    w = this.canvas.height / sourceAspect;
                }
                else {
                    h = this.canvas.height;
                    w = this.canvas.width;
                }
            }
            this.ratioW = w / this.srcImage.width;
            this.ratioH = h / this.srcImage.height;
            var offsetH = (this.buffer.height - h) / 2 / this.ratioH;
            var offsetW = (this.buffer.width - w) / 2 / this.ratioW;
            var ctx = this.cropCanvas.getContext('2d');
            if (this.cropperSettings.preserveSize || preserveSize) {
                var width = Math.round(bounds.right / this.ratioW - bounds.left / this.ratioW);
                var height = Math.round(bounds.bottom / this.ratioH - bounds.top / this.ratioH);
                this.cropCanvas.width = width;
                this.cropCanvas.height = height;
                this.cropperSettings.croppedWidth = this.cropCanvas.width;
                this.cropperSettings.croppedHeight = this.cropCanvas.height;
            }
            else {
                this.cropCanvas.width = this.cropWidth;
                this.cropCanvas.height = this.cropHeight;
            }
            ctx.clearRect(0, 0, this.cropCanvas.width, this.cropCanvas.height);
            this.drawImageIOSFix(ctx, this.srcImage, Math.max(Math.round((bounds.left) / this.ratioW - offsetW), 0), Math.max(Math.round(bounds.top / this.ratioH - offsetH), 0), Math.max(Math.round(bounds.width / this.ratioW), 1), Math.max(Math.round(bounds.height / this.ratioH), 1), 0, 0, this.cropCanvas.width, this.cropCanvas.height);
            if (this.cropperSettings.resampleFn) {
                this.cropperSettings.resampleFn(this.cropCanvas);
            }
            this.croppedImage.width = this.cropCanvas.width;
            this.croppedImage.height = this.cropCanvas.height;
            this.croppedImage.src = this.cropCanvas.toDataURL(this.fileType, this.cropperSettings.compressRatio);
            return this.croppedImage;
        }
    };
    ImageCropper.prototype.getBounds = function () {
        var minX = Number.MAX_VALUE;
        var minY = Number.MAX_VALUE;
        var maxX = -Number.MAX_VALUE;
        var maxY = -Number.MAX_VALUE;
        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            if (marker.position.x < minX) {
                minX = marker.position.x;
            }
            if (marker.position.x > maxX) {
                maxX = marker.position.x;
            }
            if (marker.position.y < minY) {
                minY = marker.position.y;
            }
            if (marker.position.y > maxY) {
                maxY = marker.position.y;
            }
        }
        var bounds = new bounds_Bounds();
        bounds.left = minX;
        bounds.right = maxX;
        bounds.top = minY;
        bounds.bottom = maxY;
        return bounds;
    };
    ImageCropper.prototype.setBounds = function (bounds) {
        var topLeft;
        var topRight;
        var bottomLeft;
        var bottomRight;
        var currentBounds = this.getBounds();
        for (var i = 0; i < this.markers.length; i++) {
            var marker = this.markers[i];
            if (marker.position.x === currentBounds.left) {
                if (marker.position.y === currentBounds.top) {
                    marker.setPosition(bounds.left, bounds.top);
                }
                else {
                    marker.setPosition(bounds.left, bounds.bottom);
                }
            }
            else {
                if (marker.position.y === currentBounds.top) {
                    marker.setPosition(bounds.right, bounds.top);
                }
                else {
                    marker.setPosition(bounds.right, bounds.bottom);
                }
            }
        }
        this.center.recalculatePosition(bounds);
        this.center.draw(this.ctx);
        this.draw(this.ctx); // we need to redraw all canvas if we have changed bounds
    };
    ImageCropper.prototype.onTouchMove = function (event) {
        if (this.crop.isImageSet()) {
            event.preventDefault();
            if (event.touches.length === 1) {
                for (var i = 0; i < event.touches.length; i++) {
                    var touch = event.touches[i];
                    var touchPosition = ImageCropper.getTouchPos(this.canvas, touch);
                    var cropTouch = new CropTouch(touchPosition.x, touchPosition.y, touch.identifier);
                    pointPool_PointPool.instance.returnPoint(touchPosition);
                    this.move(cropTouch);
                }
            }
            else {
                if (event.touches.length === 2) {
                    var distance = ((event.touches[0].clientX - event.touches[1].clientX) * (event.touches[0].clientX - event.touches[1].clientX)) + ((event.touches[0].clientY - event.touches[1].clientY) * (event.touches[0].clientY - event.touches[1].clientY));
                    if (this.previousDistance && this.previousDistance !== distance) {
                        var bounds = this.getBounds();
                        if (distance < this.previousDistance) {
                            bounds.top += 1;
                            bounds.left += 1;
                            bounds.right -= 1;
                            bounds.bottom -= 1;
                        }
                        if (distance > this.previousDistance) {
                            if (bounds.top !== this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left !== this.minXClamp && bounds.right !== this.maxXClamp) {
                                bounds.top -= 1;
                                bounds.left -= 1;
                                bounds.right += 1;
                                bounds.bottom += 1;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left === this.minXClamp && bounds.right !== this.maxXClamp) {
                                bounds.top -= 1;
                                bounds.right += 2;
                                bounds.bottom += 1;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left !== this.minXClamp && bounds.right === this.maxXClamp) {
                                bounds.top -= 1;
                                bounds.left -= 2;
                                bounds.bottom += 1;
                            }
                            else if (bounds.top === this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left !== this.minXClamp && bounds.right !== this.maxXClamp) {
                                bounds.left -= 1;
                                bounds.right += 1;
                                bounds.bottom += 2;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom === this.maxYClamp && bounds.left !== this.minXClamp && bounds.right !== this.maxXClamp) {
                                bounds.top -= 2;
                                bounds.left -= 1;
                                bounds.right += 1;
                            }
                            else if (bounds.top === this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left === this.minXClamp && bounds.right !== this.maxXClamp) {
                                bounds.right += 2;
                                bounds.bottom += 2;
                            }
                            else if (bounds.top === this.minYClamp && bounds.bottom !== this.maxYClamp && bounds.left !== this.minXClamp && bounds.right === this.maxXClamp) {
                                bounds.left -= 2;
                                bounds.bottom += 2;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom === this.maxYClamp && bounds.left === this.minXClamp && bounds.right !== this.maxXClamp) {
                                bounds.top -= 2;
                                bounds.right += 2;
                            }
                            else if (bounds.top !== this.minYClamp && bounds.bottom === this.maxYClamp && bounds.left !== this.minXClamp && bounds.right === this.maxXClamp) {
                                bounds.top -= 2;
                                bounds.left -= 2;
                            }
                        }
                        if (bounds.top < this.minYClamp)
                            bounds.top = this.minYClamp;
                        if (bounds.bottom > this.maxYClamp)
                            bounds.bottom = this.maxYClamp;
                        if (bounds.left < this.minXClamp)
                            bounds.left = this.minXClamp;
                        if (bounds.right > this.maxXClamp)
                            bounds.right = this.maxXClamp;
                        this.setBounds(bounds);
                    }
                    this.previousDistance = distance;
                }
            }
            this.draw(this.ctx);
        }
    };
    ImageCropper.prototype.onMouseMove = function (e) {
        if (this.crop.isImageSet() && this.isMouseDown) {
            var mousePosition = ImageCropper.getMousePos(this.canvas, e);
            this.move(new CropTouch(mousePosition.x, mousePosition.y, 0));
            var dragTouch = this.getDragTouchForID(0);
            if (dragTouch) {
                dragTouch.x = mousePosition.x;
                dragTouch.y = mousePosition.y;
            }
            else {
                dragTouch = new CropTouch(mousePosition.x, mousePosition.y, 0);
            }
            pointPool_PointPool.instance.returnPoint(mousePosition);
            this.drawCursors(dragTouch);
            this.draw(this.ctx);
        }
    };
    ImageCropper.prototype.move = function (cropTouch) {
        if (this.isMouseDown) {
            this.handleMove(cropTouch);
        }
    };
    ImageCropper.prototype.getDragTouchForID = function (id) {
        for (var i = 0; i < this.currentDragTouches.length; i++) {
            if (id === this.currentDragTouches[i].id) {
                return this.currentDragTouches[i];
            }
        }
        return undefined;
    };
    ImageCropper.prototype.drawCursors = function (cropTouch) {
        var cursorDrawn = false;
        if (cropTouch != null) {
            if (cropTouch.dragHandle === this.center) {
                ImageCropperDataShare.setStyle(this.canvas, 'move');
                cursorDrawn = true;
            }
            if (cropTouch.dragHandle !== null && cropTouch.dragHandle instanceof CornerMarker) {
                this.drawCornerCursor(cropTouch.dragHandle, cropTouch.dragHandle.position.x, cropTouch.dragHandle.position.y);
                cursorDrawn = true;
            }
        }
        var didDraw = false;
        if (!cursorDrawn) {
            for (var i = 0; i < this.markers.length; i++) {
                didDraw = didDraw || this.drawCornerCursor(this.markers[i], cropTouch.x, cropTouch.y);
            }
            if (!didDraw) {
                ImageCropperDataShare.setStyle(this.canvas, 'initial');
            }
        }
        if (!didDraw && !cursorDrawn && this.center.touchInBounds(cropTouch.x, cropTouch.y)) {
            this.center.setOver(true);
            ImageCropperDataShare.setOver(this.canvas);
            ImageCropperDataShare.setStyle(this.canvas, 'move');
        }
        else {
            this.center.setOver(false);
        }
    };
    ImageCropper.prototype.drawCornerCursor = function (marker, x, y) {
        if (marker.touchInBounds(x, y)) {
            marker.setOver(true);
            if (marker.getHorizontalNeighbour().position.x > marker.position.x) {
                if (marker.getVerticalNeighbour().position.y > marker.position.y) {
                    ImageCropperDataShare.setOver(this.canvas);
                    ImageCropperDataShare.setStyle(this.canvas, 'nwse-resize');
                }
                else {
                    ImageCropperDataShare.setOver(this.canvas);
                    ImageCropperDataShare.setStyle(this.canvas, 'nesw-resize');
                }
            }
            else {
                if (marker.getVerticalNeighbour().position.y > marker.position.y) {
                    ImageCropperDataShare.setOver(this.canvas);
                    ImageCropperDataShare.setStyle(this.canvas, 'nesw-resize');
                }
                else {
                    ImageCropperDataShare.setOver(this.canvas);
                    ImageCropperDataShare.setStyle(this.canvas, 'nwse-resize');
                }
            }
            return true;
        }
        marker.setOver(false);
        return false;
    };
    // todo: Unused param
    ImageCropper.prototype.onTouchStart = function (event) {
        if (this.crop.isImageSet()) {
            this.isMouseDown = true;
        }
    };
    ImageCropper.prototype.onTouchEnd = function (event) {
        if (this.crop.isImageSet()) {
            for (var i = 0; i < event.changedTouches.length; i++) {
                var touch = event.changedTouches[i];
                var dragTouch = this.getDragTouchForID(touch.identifier);
                if (dragTouch && dragTouch !== undefined) {
                    if (dragTouch.dragHandle instanceof CornerMarker || dragTouch.dragHandle instanceof dragMarker_DragMarker) {
                        dragTouch.dragHandle.setOver(false);
                    }
                    this.handleRelease(dragTouch);
                }
            }
            if (this.currentDragTouches.length === 0) {
                this.isMouseDown = false;
                this.currentlyInteracting = false;
            }
        }
    };
    // http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
    ImageCropper.prototype.drawImageIOSFix = function (ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
        // Works only if whole image is displayed:
        // ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
        // The following works correct also when only a part of the image is displayed:
        // ctx.drawImage(img, sx * this.vertSquashRatio, sy * this.vertSquashRatio, sw * this.vertSquashRatio, sh *
        // this.vertSquashRatio, dx, dy, dw, dh);
        ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh);
    };
    ImageCropper.prototype.onMouseDown = function (event) {
        if (this.crop.isImageSet()) {
            this.isMouseDown = true;
        }
    };
    ImageCropper.prototype.onMouseUp = function (event) {
        if (this.crop.isImageSet()) {
            ImageCropperDataShare.setReleased(this.canvas);
            this.isMouseDown = false;
            this.handleRelease(new CropTouch(0, 0, 0));
        }
    };
    return ImageCropper;
}(ImageCropperModel));





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/exif.js
var exif___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fraction = /*@__PURE__*/ (function (_super) {
    exif___extends(Fraction, _super);
    function Fraction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Fraction;
}(Number));

// Console debug wrapper that makes code looks a little bit cleaner
var Debug = /*@__PURE__*/ (function () {
    function Debug() {
    }
    Debug.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (Exif.debug) {
            console.log(args);
        }
    };
    return Debug;
}());

var Exif = /*@__PURE__*/ (function () {
    function Exif() {
    }
    Exif.addEvent = function (element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        }
        else {
            // Hello, IE!
            if (element.attachEvent) {
                element.attachEvent('on' + event, handler);
            }
        }
    };
    Exif.imageHasData = function (img) {
        return !!(img.exifdata);
    };
    Exif.base64ToArrayBuffer = function (base64) {
        base64 = base64.replace(/^data:([^;]+);base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    };
    Exif.objectURLToBlob = function (url, callback) {
        var http = new XMLHttpRequest();
        http.open('GET', url, true);
        http.responseType = 'blob';
        http.onload = function () {
            if (http.status === 200 || http.status === 0) {
                callback(http.response);
            }
        };
        http.send();
    };
    Exif.getImageData = function (img, callback) {
        function handleBinaryFile(binFile) {
            var data = Exif.findEXIFinJPEG(binFile);
            var iptcdata = Exif.findIPTCinJPEG(binFile);
            img.exifdata = data || {};
            img.iptcdata = iptcdata || {};
            if (callback) {
                callback.call(img);
            }
        }
        if ('src' in img && img.src) {
            if (/^data:/i.test(img.src)) {
                var arrayBuffer = Exif.base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);
            }
            else {
                if (/^blob:/i.test(img.src)) {
                    var fileReader_1 = new FileReader();
                    fileReader_1.onload = function (e) {
                        handleBinaryFile(e.target.result);
                    };
                    Exif.objectURLToBlob(img.src, function (blob) {
                        fileReader_1.readAsArrayBuffer(blob);
                    });
                }
                else {
                    var http_1 = new XMLHttpRequest();
                    http_1.onload = function () {
                        if (http_1.status === 200 || http_1.status === 0) {
                            handleBinaryFile(http_1.response);
                        }
                        else {
                            throw 'Could not load image';
                        }
                    };
                    http_1.open('GET', img.src, true);
                    http_1.responseType = 'arraybuffer';
                    http_1.send(null);
                }
            }
        }
        else {
            if (FileReader && (img instanceof Blob || img instanceof File)) {
                var fileReader = new FileReader();
                fileReader.onload = function (e) {
                    Debug.log('Got file of length ' + e.target.result.byteLength);
                    handleBinaryFile(e.target.result);
                };
                fileReader.readAsArrayBuffer(img);
            }
        }
    };
    Exif.findEXIFinJPEG = function (file) {
        var dataView = new DataView(file);
        Debug.log('Got file of length ' + file.byteLength);
        if ((dataView.getUint8(0) !== 0xFF) || (dataView.getUint8(1) !== 0xD8)) {
            Debug.log('Not a valid JPEG');
            return false; // not a valid jpeg
        }
        var offset = 2;
        var length = file.byteLength;
        var marker;
        while (offset < length) {
            if (dataView.getUint8(offset) !== 0xFF) {
                Debug.log('Not a valid marker at offset ' + offset + ', found: ' + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }
            marker = dataView.getUint8(offset + 1);
            Debug.log(marker);
            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data
            if (marker === 225) {
                Debug.log('Found 0xFFE1 marker');
                return Exif.readEXIFData(dataView, offset + 4); // , dataView.getUint16(offset + 2) - 2);
                // offset += 2 + file.getShortAt(offset+2, true);
            }
            else {
                offset += 2 + dataView.getUint16(offset + 2);
            }
        }
    };
    Exif.findIPTCinJPEG = function (file) {
        var dataView = new DataView(file);
        Debug.log('Got file of length ' + file.byteLength);
        if ((dataView.getUint8(0) !== 0xFF) || (dataView.getUint8(1) !== 0xD8)) {
            Debug.log('Not a valid JPEG');
            return false; // not a valid jpeg
        }
        var offset = 2;
        var length = file.byteLength;
        var isFieldSegmentStart = function (_dataView, _offset) {
            return (_dataView.getUint8(_offset) === 0x38 && _dataView.getUint8(_offset + 1) === 0x42 && _dataView.getUint8(_offset + 2) === 0x49 && _dataView.getUint8(_offset + 3) === 0x4D && _dataView.getUint8(_offset + 4) === 0x04 && _dataView.getUint8(_offset + 5) === 0x04);
        };
        while (offset < length) {
            if (isFieldSegmentStart(dataView, offset)) {
                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0) {
                    nameHeaderLength += 1;
                }
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }
                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);
                return Exif.readIPTCData(file, startOffset, sectionLength);
            }
            // Not the marker, continue searching
            offset++;
        }
    };
    Exif.readIPTCData = function (file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while (segmentStartPos < startOffset + sectionLength) {
            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in Exif.IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    segmentSize = dataSize + 5;
                    fieldName = Exif.IptcFieldMap[segmentType];
                    fieldValue = Exif.getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }
            }
            segmentStartPos++;
        }
        return data;
    };
    Exif.readTags = function (file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd);
        var tags = {};
        var entryOffset;
        var tag;
        for (var i = 0; i < entries; i++) {
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag) {
                Debug.log('Unknown tag: ' + file.getUint16(entryOffset, !bigEnd));
            }
            tags[tag] = Exif.readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    };
    Exif.readTagValue = function (file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd);
        var numValues = file.getUint32(entryOffset + 4, !bigEnd);
        var valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart;
        var offset;
        var vals, val, n;
        var numerator;
        var denominator;
        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7:// undefined, 8-bit byte, value depending on field
                if (numValues === 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                }
                else {
                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }
            case 2:// ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return Exif.getStringFromDB(file, offset, numValues - 1);
            case 3:// short, 16 bit int
                if (numValues === 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                }
                else {
                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                    }
                    return vals;
                }
            case 4:// long, 32 bit int
                if (numValues === 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }
            case 5:// rational = two long values, first is numerator, second is denominator
                if (numValues === 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = new Fraction(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                        vals[n] = new Fraction(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }
            case 9:// slong, 32 bit signed int
                if (numValues === 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }
            case 10:// signed rational, two slongs, first is numerator, second is denominator
                if (numValues === 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                }
                else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                    }
                    return vals;
                }
            default:
                break;
        }
    };
    Exif.getStringFromDB = function (buffer, start, length) {
        var outstr = '';
        for (var n = start; n < start + length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    };
    Exif.readEXIFData = function (file, start) {
        if (Exif.getStringFromDB(file, start, 4) !== 'Exif') {
            Debug.log('Not valid EXIF data! ' + Exif.getStringFromDB(file, start, 4));
            return false;
        }
        var bigEnd, tags, tag, exifData, gpsData, tiffOffset = start + 6;
        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) === 0x4949) {
            bigEnd = false;
        }
        else {
            if (file.getUint16(tiffOffset) === 0x4D4D) {
                bigEnd = true;
            }
            else {
                Debug.log('Not valid TIFF data! (no 0x4949 or 0x4D4D)');
                return false;
            }
        }
        if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002A) {
            Debug.log('Not valid TIFF data! (no 0x002A)');
            return false;
        }
        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);
        if (firstIFDOffset < 0x00000008) {
            Debug.log('Not valid TIFF data! (First offset less than 8)', file.getUint32(tiffOffset + 4, !bigEnd));
            return false;
        }
        tags = Exif.readTags(file, tiffOffset, tiffOffset + firstIFDOffset, Exif.TiffTags, bigEnd);
        if (tags.ExifIFDPointer) {
            exifData = Exif.readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, Exif.Tags, bigEnd);
            for (tag in exifData) {
                if ({}.hasOwnProperty.call(exifData, tag)) {
                    switch (tag) {
                        case 'LightSource':
                        case 'Flash':
                        case 'MeteringMode':
                        case 'ExposureProgram':
                        case 'SensingMethod':
                        case 'SceneCaptureType':
                        case 'SceneType':
                        case 'CustomRendered':
                        case 'WhiteBalance':
                        case 'GainControl':
                        case 'Contrast':
                        case 'Saturation':
                        case 'Sharpness':
                        case 'SubjectDistanceRange':
                        case 'FileSource':
                            exifData[tag] = Exif.StringValues[tag][exifData[tag]];
                            break;
                        case 'ExifVersion':
                        case 'FlashpixVersion':
                            exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                            break;
                        case 'ComponentsConfiguration':
                            var compopents = 'Components';
                            exifData[tag] = Exif.StringValues[compopents][exifData[tag][0]] + Exif.StringValues[compopents][exifData[tag][1]] + Exif.StringValues[compopents][exifData[tag][2]] + Exif.StringValues[compopents][exifData[tag][3]];
                            break;
                        default:
                            break;
                    }
                    tags[tag] = exifData[tag];
                }
            }
        }
        if (tags.GPSInfoIFDPointer) {
            gpsData = Exif.readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, Exif.GPSTags, bigEnd);
            for (tag in gpsData) {
                if ({}.hasOwnProperty.call(gpsData, tag)) {
                    switch (tag) {
                        case 'GPSVersionID':
                            gpsData[tag] = gpsData[tag][0] + '.' + gpsData[tag][1] + '.' + gpsData[tag][2] + '.' + gpsData[tag][3];
                            break;
                        default:
                            break;
                    }
                    tags[tag] = gpsData[tag];
                }
            }
        }
        return tags;
    };
    Exif.getData = function (img, callback) {
        if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) {
            return false;
        }
        if (!Exif.imageHasData(img)) {
            Exif.getImageData(img, callback);
        }
        else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    };
    Exif.getTag = function (img, tag) {
        if (!Exif.imageHasData(img)) {
            return;
        }
        return img.exifdata[tag];
    };
    ;
    Exif.getAllTags = function (img) {
        if (!Exif.imageHasData(img)) {
            return {};
        }
        var a, data = img.exifdata, tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    };
    ;
    Exif.pretty = function (img) {
        if (!Exif.imageHasData(img)) {
            return '';
        }
        var a, data = img.exifdata, strPretty = '';
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] === 'object') {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    }
                    else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                }
                else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    };
    Exif.readFromBinaryFile = function (file) {
        return Exif.findEXIFinJPEG(file);
    };
    Exif.debug = false;
    Exif.IptcFieldMap = {
        0x78: 'caption',
        0x6E: 'credit',
        0x19: 'keywords',
        0x37: 'dateCreated',
        0x50: 'byline',
        0x55: 'bylineTitle',
        0x7A: 'captionWriter',
        0x69: 'headline',
        0x74: 'copyright',
        0x0F: 'category'
    };
    Exif.Tags = {
        // version tags
        0x9000: 'ExifVersion',
        0xA000: 'FlashpixVersion',
        // colorspace tags
        0xA001: 'ColorSpace',
        // image configuration
        0xA002: 'PixelXDimension',
        0xA003: 'PixelYDimension',
        0x9101: 'ComponentsConfiguration',
        0x9102: 'CompressedBitsPerPixel',
        // user information
        0x927C: 'MakerNote',
        0x9286: 'UserComment',
        // related file
        0xA004: 'RelatedSoundFile',
        // date and time
        0x9003: 'DateTimeOriginal',
        0x9004: 'DateTimeDigitized',
        0x9290: 'SubsecTime',
        0x9291: 'SubsecTimeOriginal',
        0x9292: 'SubsecTimeDigitized',
        // picture-taking conditions
        0x829A: 'ExposureTime',
        0x829D: 'FNumber',
        0x8822: 'ExposureProgram',
        0x8824: 'SpectralSensitivity',
        0x8827: 'ISOSpeedRatings',
        0x8828: 'OECF',
        0x9201: 'ShutterSpeedValue',
        0x9202: 'ApertureValue',
        0x9203: 'BrightnessValue',
        0x9204: 'ExposureBias',
        0x9205: 'MaxApertureValue',
        0x9206: 'SubjectDistance',
        0x9207: 'MeteringMode',
        0x9208: 'LightSource',
        0x9209: 'Flash',
        0x9214: 'SubjectArea',
        0x920A: 'FocalLength',
        0xA20B: 'FlashEnergy',
        0xA20C: 'SpatialFrequencyResponse',
        0xA20E: 'FocalPlaneXResolution',
        0xA20F: 'FocalPlaneYResolution',
        0xA210: 'FocalPlaneResolutionUnit',
        0xA214: 'SubjectLocation',
        0xA215: 'ExposureIndex',
        0xA217: 'SensingMethod',
        0xA300: 'FileSource',
        0xA301: 'SceneType',
        0xA302: 'CFAPattern',
        0xA401: 'CustomRendered',
        0xA402: 'ExposureMode',
        0xA403: 'WhiteBalance',
        0xA404: 'DigitalZoomRation',
        0xA405: 'FocalLengthIn35mmFilm',
        0xA406: 'SceneCaptureType',
        0xA407: 'GainControl',
        0xA408: 'Contrast',
        0xA409: 'Saturation',
        0xA40A: 'Sharpness',
        0xA40B: 'DeviceSettingDescription',
        0xA40C: 'SubjectDistanceRange',
        // other tags
        0xA005: 'InteroperabilityIFDPointer', 0xA420: 'ImageUniqueID' // Identifier assigned uniquely to each image
    };
    Exif.TiffTags = {
        0x0100: 'ImageWidth',
        0x0101: 'ImageHeight',
        0x8769: 'ExifIFDPointer',
        0x8825: 'GPSInfoIFDPointer',
        0xA005: 'InteroperabilityIFDPointer',
        0x0102: 'BitsPerSample',
        0x0103: 'Compression',
        0x0106: 'PhotometricInterpretation',
        0x0112: 'Orientation',
        0x0115: 'SamplesPerPixel',
        0x011C: 'PlanarConfiguration',
        0x0212: 'YCbCrSubSampling',
        0x0213: 'YCbCrPositioning',
        0x011A: 'XResolution',
        0x011B: 'YResolution',
        0x0128: 'ResolutionUnit',
        0x0111: 'StripOffsets',
        0x0116: 'RowsPerStrip',
        0x0117: 'StripByteCounts',
        0x0201: 'JPEGInterchangeFormat',
        0x0202: 'JPEGInterchangeFormatLength',
        0x012D: 'TransferFunction',
        0x013E: 'WhitePoint',
        0x013F: 'PrimaryChromaticities',
        0x0211: 'YCbCrCoefficients',
        0x0214: 'ReferenceBlackWhite',
        0x0132: 'DateTime',
        0x010E: 'ImageDescription',
        0x010F: 'Make',
        0x0110: 'Model',
        0x0131: 'Software',
        0x013B: 'Artist',
        0x8298: 'Copyright'
    };
    Exif.GPSTags = {
        0x0000: 'GPSVersionID',
        0x0001: 'GPSLatitudeRef',
        0x0002: 'GPSLatitude',
        0x0003: 'GPSLongitudeRef',
        0x0004: 'GPSLongitude',
        0x0005: 'GPSAltitudeRef',
        0x0006: 'GPSAltitude',
        0x0007: 'GPSTimeStamp',
        0x0008: 'GPSSatellites',
        0x0009: 'GPSStatus',
        0x000A: 'GPSMeasureMode',
        0x000B: 'GPSDOP',
        0x000C: 'GPSSpeedRef',
        0x000D: 'GPSSpeed',
        0x000E: 'GPSTrackRef',
        0x000F: 'GPSTrack',
        0x0010: 'GPSImgDirectionRef',
        0x0011: 'GPSImgDirection',
        0x0012: 'GPSMapDatum',
        0x0013: 'GPSDestLatitudeRef',
        0x0014: 'GPSDestLatitude',
        0x0015: 'GPSDestLongitudeRef',
        0x0016: 'GPSDestLongitude',
        0x0017: 'GPSDestBearingRef',
        0x0018: 'GPSDestBearing',
        0x0019: 'GPSDestDistanceRef',
        0x001A: 'GPSDestDistance',
        0x001B: 'GPSProcessingMethod',
        0x001C: 'GPSAreaInformation',
        0x001D: 'GPSDateStamp',
        0x001E: 'GPSDifferential'
    };
    Exif.StringValues = {
        ExposureProgram: {
            0: 'Not defined',
            1: 'Manual',
            2: 'Normal program',
            3: 'Aperture priority',
            4: 'Shutter priority',
            5: 'Creative program',
            6: 'Action program',
            7: 'Portrait mode',
            8: 'Landscape mode'
        }, MeteringMode: {
            0: 'Unknown',
            1: 'Average',
            2: 'CenterWeightedAverage',
            3: 'Spot',
            4: 'MultiSpot',
            5: 'Pattern',
            6: 'Partial',
            255: 'Other'
        }, LightSource: {
            0: 'Unknown',
            1: 'Daylight',
            2: 'Fluorescent',
            3: 'Tungsten (incandescent light)',
            4: 'Flash',
            9: 'Fine weather',
            10: 'Cloudy weather',
            11: 'Shade',
            12: 'Daylight fluorescent (D 5700 - 7100K)',
            13: 'Day white fluorescent (N 4600 - 5400K)',
            14: 'Cool white fluorescent (W 3900 - 4500K)',
            15: 'White fluorescent (WW 3200 - 3700K)',
            17: 'Standard light A',
            18: 'Standard light B',
            19: 'Standard light C',
            20: 'D55',
            21: 'D65',
            22: 'D75',
            23: 'D50',
            24: 'ISO studio tungsten',
            255: 'Other'
        }, Flash: {
            0x0000: 'Flash did not fire',
            0x0001: 'Flash fired',
            0x0005: 'Strobe return light not detected',
            0x0007: 'Strobe return light detected',
            0x0009: 'Flash fired, compulsory flash mode',
            0x000D: 'Flash fired, compulsory flash mode, return light not detected',
            0x000F: 'Flash fired, compulsory flash mode, return light detected',
            0x0010: 'Flash did not fire, compulsory flash mode',
            0x0018: 'Flash did not fire, auto mode',
            0x0019: 'Flash fired, auto mode',
            0x001D: 'Flash fired, auto mode, return light not detected',
            0x001F: 'Flash fired, auto mode, return light detected',
            0x0020: 'No flash function',
            0x0041: 'Flash fired, red-eye reduction mode',
            0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
            0x0047: 'Flash fired, red-eye reduction mode, return light detected',
            0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
            0x004D: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
            0x004F: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
            0x0059: 'Flash fired, auto mode, red-eye reduction mode',
            0x005D: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
            0x005F: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
        }, SensingMethod: {
            1: 'Not defined',
            2: 'One-chip color area sensor',
            3: 'Two-chip color area sensor',
            4: 'Three-chip color area sensor',
            5: 'Color sequential area sensor',
            7: 'Trilinear sensor',
            8: 'Color sequential linear sensor'
        }, SceneCaptureType: {
            0: 'Standard', 1: 'Landscape', 2: 'Portrait', 3: 'Night scene'
        }, SceneType: {
            1: 'Directly photographed'
        }, CustomRendered: {
            0: 'Normal process', 1: 'Custom process'
        }, WhiteBalance: {
            0: 'Auto white balance', 1: 'Manual white balance'
        }, GainControl: {
            0: 'None', 1: 'Low gain up', 2: 'High gain up', 3: 'Low gain down', 4: 'High gain down'
        }, Contrast: {
            0: 'Normal', 1: 'Soft', 2: 'Hard'
        }, Saturation: {
            0: 'Normal', 1: 'Low saturation', 2: 'High saturation'
        }, Sharpness: {
            0: 'Normal', 1: 'Soft', 2: 'Hard'
        }, SubjectDistanceRange: {
            0: 'Unknown', 1: 'Macro', 2: 'Close view', 3: 'Distant view'
        }, FileSource: {
            3: 'DSC'
        },
        Components: {
            0: '', 1: 'Y', 2: 'Cb', 3: 'Cr', 4: 'R', 5: 'G', 6: 'B'
        }
    };
    return Exif;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/model/cropPosition.js

var cropPosition_CropPosition = /*@__PURE__*/ (function () {
    function CropPosition(x, y, w, h) {
        if (x === void 0) {
            x = 0;
        }
        if (y === void 0) {
            y = 0;
        }
        if (w === void 0) {
            w = 0;
        }
        if (h === void 0) {
            h = 0;
        }
        this.x = +x;
        this.y = +y;
        this.w = +w;
        this.h = +h;
    }
    CropPosition.prototype.toBounds = function () {
        return new bounds_Bounds(this.x, this.y, this.w, this.h);
    };
    CropPosition.prototype.isInitialized = function () {
        return this.x !== 0 && this.y !== 0 && this.w !== 0 && this.h !== 0;
    };
    return CropPosition;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/imageCropperComponent.js





var imageCropperComponent_ImageCropperComponent = /*@__PURE__*/ (function () {
    function ImageCropperComponent(renderer) {
        this.cropPositionChange = new core["EventEmitter"]();
        this.onCrop = new core["EventEmitter"]();
        this.renderer = renderer;
    }
    ImageCropperComponent.prototype.ngAfterViewInit = function () {
        var canvas = this.cropcanvas.nativeElement;
        if (!this.settings) {
            this.settings = new cropperSettings_CropperSettings();
        }
        this.renderer.setElementAttribute(canvas, 'class', this.settings.cropperClass);
        if (!this.settings.dynamicSizing) {
            this.renderer.setElementAttribute(canvas, 'width', this.settings.canvasWidth.toString());
            this.renderer.setElementAttribute(canvas, 'height', this.settings.canvasHeight.toString());
        }
        else {
            this.windowListener = this.resize.bind(this);
            window.addEventListener('resize', this.windowListener);
        }
        if (!this.cropper) {
            this.cropper = new imageCropper_ImageCropper(this.settings);
        }
        this.cropper.prepare(canvas);
    };
    ImageCropperComponent.prototype.ngOnChanges = function (changes) {
        if (this.isCropPositionChanged(changes)) {
            this.cropper.updateCropPosition(this.cropPosition.toBounds());
            if (this.cropper.isImageSet()) {
                var bounds = this.cropper.getCropBounds();
                this.image.image = this.cropper.getCroppedImageHelper().src;
                this.onCrop.emit(bounds);
            }
            this.updateCropBounds();
        }
        if (changes.inputImage) {
            this.setImage(changes.inputImage.currentValue);
        }
    };
    ImageCropperComponent.prototype.ngOnDestroy = function () {
        if (this.settings.dynamicSizing && this.windowListener) {
            window.removeEventListener('resize', this.windowListener);
        }
    };
    ImageCropperComponent.prototype.onTouchMove = function (event) {
        this.cropper.onTouchMove(event);
    };
    ImageCropperComponent.prototype.onTouchStart = function (event) {
        this.cropper.onTouchStart(event);
    };
    ImageCropperComponent.prototype.onTouchEnd = function (event) {
        this.cropper.onTouchEnd(event);
        if (this.cropper.isImageSet()) {
            this.image.image = this.cropper.getCroppedImageHelper().src;
            this.onCrop.emit(this.cropper.getCropBounds());
            this.updateCropBounds();
        }
    };
    ImageCropperComponent.prototype.onMouseDown = function (event) {
        this.cropper.onMouseDown(event);
    };
    ImageCropperComponent.prototype.onMouseUp = function (event) {
        if (this.cropper.isImageSet()) {
            this.cropper.onMouseUp(event);
            this.image.image = this.cropper.getCroppedImageHelper().src;
            this.onCrop.emit(this.cropper.getCropBounds());
            this.updateCropBounds();
        }
    };
    ImageCropperComponent.prototype.onMouseMove = function (event) {
        this.cropper.onMouseMove(event);
    };
    ImageCropperComponent.prototype.fileChangeListener = function ($event) {
        if ($event.target.files.length === 0)
            return;
        var file = $event.target.files[0];
        if (this.settings.allowedFilesRegex.test(file.name)) {
            var image_1 = new Image();
            var fileReader = new FileReader();
            var that_1 = this;
            fileReader.addEventListener('loadend', function (loadEvent) {
                image_1.addEventListener('load', function () {
                    that_1.setImage(image_1);
                });
                image_1.src = loadEvent.target.result;
            });
            fileReader.readAsDataURL(file);
        }
    };
    ImageCropperComponent.prototype.resize = function () {
        var canvas = this.cropcanvas.nativeElement;
        this.settings.canvasWidth = canvas.offsetWidth;
        this.settings.canvasHeight = canvas.offsetHeight;
        this.cropper.resizeCanvas(canvas.offsetWidth, canvas.offsetHeight, true);
    };
    ImageCropperComponent.prototype.reset = function () {
        this.cropper.reset();
        this.renderer.setElementAttribute(this.cropcanvas.nativeElement, 'class', this.settings.cropperClass);
        this.image.image = this.cropper.getCroppedImageHelper().src;
    };
    ImageCropperComponent.prototype.setImage = function (image, newBounds) {
        var _this = this;
        if (newBounds === void 0) {
            newBounds = null;
        }
        var self = this;
        this.renderer.setElementAttribute(this.cropcanvas.nativeElement, 'class', this.settings.cropperClass + " " + this.settings.croppingClass);
        this.raf = window.requestAnimationFrame(function () {
            if (self.raf) {
                window.cancelAnimationFrame(self.raf);
            }
            if (image.naturalHeight > 0 && image.naturalWidth > 0) {
                image.height = image.naturalHeight;
                image.width = image.naturalWidth;
                window.cancelAnimationFrame(self.raf);
                self.getOrientedImage(image, function (img) {
                    if (_this.settings.dynamicSizing) {
                        var canvas = _this.cropcanvas.nativeElement;
                        _this.settings.canvasWidth = canvas.offsetWidth;
                        _this.settings.canvasHeight = canvas.offsetHeight;
                        _this.cropper.resizeCanvas(canvas.offsetWidth, canvas.offsetHeight, false);
                    }
                    self.cropper.setImage(img);
                    if (self.cropPosition && self.cropPosition.isInitialized()) {
                        self.cropper.updateCropPosition(self.cropPosition.toBounds());
                    }
                    self.image.original = img;
                    var bounds = self.cropper.getCropBounds();
                    self.image.image = self.cropper.getCroppedImageHelper().src;
                    if (newBounds != null) {
                        bounds = newBounds;
                        self.cropper.setBounds(bounds);
                        _this.cropper.updateCropPosition(bounds);
                    }
                    self.onCrop.emit(bounds);
                });
            }
        });
    };
    ImageCropperComponent.prototype.isCropPositionChanged = function (changes) {
        if (this.cropper && changes['cropPosition'] && this.isCropPositionUpdateNeeded) {
            return true;
        }
        else {
            this.isCropPositionUpdateNeeded = true;
            return false;
        }
    };
    ImageCropperComponent.prototype.updateCropBounds = function () {
        var cropBound = this.cropper.getCropBounds();
        this.cropPositionChange.emit(new cropPosition_CropPosition(cropBound.left, cropBound.top, cropBound.width, cropBound.height));
        this.isCropPositionUpdateNeeded = false;
    };
    ImageCropperComponent.prototype.getOrientedImage = function (image, callback) {
        var img;
        Exif.getData(image, function () {
            var orientation = Exif.getTag(image, 'Orientation');
            if ([3, 6, 8].indexOf(orientation) > -1) {
                var canvas = document.createElement('canvas'), ctx = canvas.getContext('2d'), cw = image.width, ch = image.height, cx = 0, cy = 0, deg = 0;
                switch (orientation) {
                    case 3:
                        cx = -image.width;
                        cy = -image.height;
                        deg = 180;
                        break;
                    case 6:
                        cw = image.height;
                        ch = image.width;
                        cy = -image.height;
                        deg = 90;
                        break;
                    case 8:
                        cw = image.height;
                        ch = image.width;
                        cx = -image.width;
                        deg = 270;
                        break;
                    default:
                        break;
                }
                canvas.width = cw;
                canvas.height = ch;
                ctx.rotate(deg * Math.PI / 180);
                ctx.drawImage(image, cx, cy);
                img = document.createElement('img');
                img.width = cw;
                img.height = ch;
                img.addEventListener('load', function () {
                    callback(img);
                });
                img.src = canvas.toDataURL('image/png');
            }
            else {
                img = image;
                callback(img);
            }
        });
    };
    return ImageCropperComponent;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/imageCropperModule.js



var ImageCropperModule = /*@__PURE__*/ (function () {
    function ImageCropperModule() {
    }
    return ImageCropperModule;
}());





// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/index.js
// core


// extra classes



// models


//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./src/app/imageCropper/imageCropper.ts

var imageCropper_CropImageComponent = /*@__PURE__*/ (function () {
    function CropImageComponent(route, activeModal, _global, http, translate, share) {
        this.route = route;
        this.activeModal = activeModal;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this.share = share;
        this.imageChangedEvent = '';
        this.croppedImage = '';
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.cropperSettings = new cropperSettings_CropperSettings();
        this.cropperSettings.noFileInput = true;
        this.cropperSettings.rounded = true;
        // minWithRelativeToResolution=false preserveSize=true compressRatio=0 dynamicSizing=true
        this.cropperSettings.minWithRelativeToResolution = true;
        this.cropperSettings.preserveSize = true;
        this.cropperSettings.dynamicSizing = true;
        // this.cropperSettings.preserveSize = true;
        // this.cropperSettings.canvasWidth = 600;
        // this.cropperSettings.canvasHeight = 400;
        this.data = {};
        this.fileChangeListener(this.share.getData());
    }
    CropImageComponent.prototype.fileChangeListener = function ($event) {
        var image = new Image();
        var file = $event.target.files[0];
        var myReader = new FileReader();
        var that = this;
        myReader.onloadend = function (loadEvent) {
            image.src = loadEvent.target.result;
            that.cropper.setImage(image);
        };
        myReader.readAsDataURL(file);
    };
    CropImageComponent.prototype.confirmCrop = function () {
        this.activeModal.close(this.data);
    };
    return CropImageComponent;
}());



// CONCATENATED MODULE: ./src/app/employee/addEmployees.ts





var addEmployees_AddEmployeesComponent = /*@__PURE__*/ (function () {
    function AddEmployeesComponent(route, modalService, _global, http, _sanitizer, builder, _auth, router, translate, _location, share, _toaster, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this.http = http;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this.translate = translate;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.maxDate = { year: null, month: null, day: null };
        this.minDate = { year: null, month: null, day: null };
        this.gradeData = [];
        this.orgData = [];
        this.designationData = [];
        this.managementLevelData = [];
        this.isSecondarySupervisorRequired = false;
        this.type = 'ADD';
        this.oldValue = null;
        this.empdisplayName = '';
        this.verDisplayName = '';
        this.secSupDisplayName = null;
        this.catName = '';
        this.managementName = '';
        this.designationName = '';
        this.gradeName = '';
        this.orgName = '';
        this.disableSave = true;
        this.isUpdateImage = false;
        this.orgFormData = null;
        this.primarySupervisorModel = {
            id: null,
            displayName: ''
        };
        this.secondarySupervisorModel = [{
                id: null,
                displayName: ''
            }];
        this.verifierModel = {
            id: null,
            displayName: ''
        };
        this.categoryModel = {
            id: null,
            type: ''
        };
        this.gradeModel = {
            id: null,
            name: ''
        };
        this.organizationModel = {
            id: null,
            orgName: ''
        };
        //changing object from any to Object to use ng model effectivly 
        this.designationModel = {
            id: null,
            name: ''
        };
        this.managementModel = {
            id: null,
            name: ''
        };
        this.warning = 'Please type to select';
        this.showButtonLoading = false;
        this.payload = {
            searchString: '',
            excludeEmpIds: []
        };
        // this is going to be final PayLoad for save call
        this.employeeData = {
            id: null,
            firstName: null,
            lastName: null,
            middleName: null,
            displayName: null,
            userName: null,
            email: null,
            empCode: null,
            status: 'ACTIVE',
            image: null,
            imageHeight: null,
            imageWidth: null,
            fileExtension: null,
            joiningDate: null,
            gradeId: null,
            gradeName: null,
            managementLevelId: null,
            managementLevelName: null,
            designationId: null,
            designationName: null,
            categoryId: null,
            categoryName: null,
            orgId: null,
            primarySupervisorId: null,
            verifierId: null,
            secSupervisorIds: [],
            imageUrl: null,
            orgName: null,
            licenceNumber: null,
            dateOfBirth: null,
            phoneNumber: null,
            gender: null,
            userRole: null
        };
        this.errorMsg = {
            USER_NAME_EXISTS: 'User name already exists',
            EMAIL_EXISTS: 'Email id already exists',
            EMPCODE_EXISTS: 'Employee code already exists',
        };
        this.loading = true;
        this.roles = [
            'ROLE_USER', 'ROLE_VACCINE_ADMIN',
            'ROLE_VACCINE_SEARCH_ADMIN', 'ROLE_LAB_ADMIN', 'ROLE_TRACE_HUB_ADMIN'
        ];
        // To get list of designation based on keyword
        this.designationObservableSource = function (keyword) {
            if (keyword) {
                var encodedKeyword = encodeURIComponent(keyword);
                var url = _this._baseUrl + 'v1/webAdmin/employee/designationSearch';
                url += '?searchString=' + encodedKeyword;
                if (keyword.trim()) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    }, function (error) {
                        console.log(error);
                        return Observable["a" /* Observable */].of([]);
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        // To get list of grade based on keyword  try{}catch(e){}
        this.gradeObservableSource = function (keyword) {
            if (keyword) {
                var url = _this._baseUrl + 'v1/webAdmin/employee/gradeSearch';
                url += '?searchString=' + keyword;
                if (keyword.trim()) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    }, function (error) {
                        console.log(error);
                        return Observable["a" /* Observable */].of([]);
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        // To get list of category based on keyword
        this.categoryObservableSource = function (keyword) {
            if (keyword) {
                var url = _this._baseUrl + 'v1/webAdmin/employee/categorySearch';
                url += '?searchString=' + keyword;
                if (keyword.trim()) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    }, function (error) {
                        console.log(error);
                        return Observable["a" /* Observable */].of([]);
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        // To get list of managerLevel based on keyword
        this.managementLevelObservableSource = function (keyword) {
            if (keyword) {
                var url = _this._baseUrl + 'v1/webAdmin/employee/managerLevelSearch';
                url += '?searchString=' + keyword;
                if (keyword.trim()) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    }, function (error) {
                        console.log(error);
                        return Observable["a" /* Observable */].of([]);
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        // To get list of Organization based on keyword
        this.organizationObservableSource = function (keyword) {
            if (keyword) {
                var url = _this._baseUrl + 'v1/webAdmin/employee/orgSearch';
                url += '?searchString=' + keyword;
                if (keyword.trim()) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    }, function (error) {
                        console.log(error);
                        return Observable["a" /* Observable */].of([]);
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this.orgNameValueFormatter = function (data) {
            var html = "" + data.orgName;
            return html;
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<p class=\"p-0 m-0\">" + data.displayName + " (" + data.empCode + ")</p><small class=\"grey-color\">" + data.email + "</small>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListFormatterType = function (data) {
            var html = "<span>" + data.type + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListNameFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListOrgFormatter = function (data) {
            var html = "<span>" + data.orgName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        this._toaster.setViewRef(vcr);
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; // January is 0!
        var yyyy = today.getFullYear();
        this.maxDate.day = dd;
        this.maxDate.month = mm;
        this.maxDate.year = yyyy;
        this.minDate.day = 1;
        this.minDate.month = 1;
        this.minDate.year = 1900;
        if (data.type === 'ADD') {
            this.currentEmployee = JSON.parse(localStorage.getItem('userInfo'));
            this.employeeId = this.currentEmployee.employeeId;
            this.generateEmployeeCode();
            this.loading = false;
        }
        if (data.type === 'EDIT' || data.type === 'ACTIVATE') {
            this.employeeId = data.employeeId;
            this.type = data.type;
            this.getEmployeeById();
        }
        this.data = {};
    }
    // temporary fixes for cal close
    AddEmployeesComponent.prototype.openDatePicker = function (id) {
        this.dynamicId = id;
    };
    // temporary fixes for cal close
    AddEmployeesComponent.prototype.onClick = function (event, targetElement) {
        if (!(targetElement.tagName === 'BUTTON'
            || targetElement.tagName === 'I' || targetElement.tagName === 'SELECT'
            || targetElement.tagName === 'SPAN')) {
            var self_1 = this;
            if (self_1.dynamicId) {
                if (self_1.dynamicId.isOpen()) {
                    Object(main["setTimeout"])(function () {
                        this.trackHides = null;
                    }, 10);
                }
            }
        }
    };
    //delete employee profile page
    AddEmployeesComponent.prototype.removeImage = function () {
        this.employeeData.image = null;
        this.employeeData.fileExtension = null;
        this.employeeData.imageUrl = null;
        this.data = {};
        this.isUpdateImage = false;
    };
    //date format in string
    AddEmployeesComponent.prototype.onDateChange = function (e) {
        this.employeeData.joiningDate = e.year + '-' + e.month + '-' + e.day;
    };
    //used to resize the image by cropping
    AddEmployeesComponent.prototype.cropImage = function ($event) {
        var _this = this;
        this.share.saveData($event);
        var fileExtension = this.getFileExtension($event.target.value);
        this.employeeData.fileExtension = fileExtension[0];
        if ((this.employeeData.fileExtension == 'jpg') || (this.employeeData.fileExtension == 'jpeg') || (this.employeeData.fileExtension == 'png') || (this.employeeData.fileExtension == 'svg') || (this.employeeData.fileExtension == 'svgz')) {
            this.modalService.open(imageCropper_CropImageComponent, { windowClass: 'min-modal' }).result.then(function (result) {
                _this.closeResult = "Closed with: " + result;
                _this.isUpdateImage = true;
                _this.data = result;
                _this.employeeData.image = btoa(result.image.split('base64,')[1]);
            }, function (reason) {
                _this.closeResult = "Dismissed " + _this.getDismissReason(reason);
            });
        }
        else {
            this.translate.get('fileUploadFailed').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
    };
    AddEmployeesComponent.prototype.getFileExtension = function (fullPath) {
        var filename = fullPath.replace(/^.*[\\\/]/, '');
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename) : undefined;
    };
    AddEmployeesComponent.prototype.getDismissReason = function (reason) {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        }
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        }
        else {
            return "with: " + reason;
        }
    };
    AddEmployeesComponent.prototype.getIdsWithPayload = function (keyword) {
        var payload = {
            searchString: null,
            excludeEmpIds: []
        };
        payload.searchString = keyword;
        if (this.type === 'EDIT') {
            payload.excludeEmpIds.push(this.employeeId);
        }
        if (this.employeeData.primarySupervisorId) {
            payload.excludeEmpIds.push(this.employeeData.primarySupervisorId);
        }
        if (this.employeeData.verifierId) {
            payload.excludeEmpIds.push(this.employeeData.verifierId);
        }
        if (this.employeeData.secSupervisorIds.length > 0) {
            underscore["each"](this.employeeData.secSupervisorIds, function (key, val) {
                if (!underscore["isObject"](key) && (key != null)) {
                    payload.excludeEmpIds.push(key);
                }
            });
        }
        var everythingButTheNulls = underscore["compact"](payload.excludeEmpIds);
        payload.excludeEmpIds = [];
        payload.excludeEmpIds = everythingButTheNulls;
        return payload;
    };
    // ObservableSource
    // to get list of supervisor based on keyword
    AddEmployeesComponent.prototype.primarySupervisorObservableSource = function (keyword) {
        if (keyword) {
            var url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
            if (keyword.trim()) {
                var payload = this.getIdsWithPayload(keyword);
                return this.http.post(url, payload)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    console.log(error);
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        }
        else {
            return Observable["a" /* Observable */].of([]);
        }
    };
    // secondarySupervisorObservableSource
    AddEmployeesComponent.prototype.secondarySupervisorObservableSource = function (keyword) {
        if (keyword) {
            var url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
            if (keyword.trim()) {
                var payload = this.getIdsWithPayload(keyword);
                return this.http.post(url, payload)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    console.log(error);
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        }
        else {
            return Observable["a" /* Observable */].of([]);
        }
    };
    // To get list of supervisor based on keyword
    AddEmployeesComponent.prototype.primaryVerifierObservableSource = function (keyword) {
        if (keyword) {
            var url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
            if (keyword.trim()) {
                var payload = this.getIdsWithPayload(keyword);
                return this.http.post(url, payload)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    console.log(error);
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        }
        else {
            return Observable["a" /* Observable */].of([]);
        }
    };
    // Formatter
    AddEmployeesComponent.prototype.nameValueFormatter = function (data) {
        return "" + data.name;
    };
    AddEmployeesComponent.prototype.typeValueFormatter = function (data) {
        return "" + data.type;
    };
    // get employee code
    AddEmployeesComponent.prototype.generateEmployeeCode = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/employee/generateEmployeeCode';
            this.http.get(url).subscribe(function (result) {
                _this.employeeData.empCode = result.data;
            });
        }
        catch (e) {
            console.log('getAllEmployeeData error catch', e);
        }
    };
    AddEmployeesComponent.prototype.checkLastSecSupervisorIsExists = function (secSupList) {
        // console.log(secSupList);
        var isSecSupAviable = true;
        underscore["each"](secSupList, function (sup) {
            if (sup == null) {
                isSecSupAviable = false;
            }
        });
        return isSecSupAviable;
    };
    // add secondary supervisor
    AddEmployeesComponent.prototype.addSecondarySupervisor = function () {
        var _this = this;
        if (this.employeeData.primarySupervisorId) {
            if (this.employeeData.secSupervisorIds.length > 4) {
                this.translate.get('maxSupervisor').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
            }
            else {
                if (this.checkLastSecSupervisorIsExists(this.employeeData.secSupervisorIds)) {
                    this.employeeData.secSupervisorIds.push(null);
                    this.secondarySupervisorModel.push(null);
                }
                else {
                    this.translate.get('selectSecondarySupervisor').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
            }
        }
        else {
            this.translate.get('selectPrimarySupervisor').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
        }
    };
    // deleting secondary supervisor from UI
    AddEmployeesComponent.prototype.deleteSecondarySupervisor = function (e, i) {
        this.employeeData.secSupervisorIds.splice(i, 1);
        this.secondarySupervisorModel.splice(i, 1);
    };
    // navigate back
    AddEmployeesComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    AddEmployeesComponent.prototype.copyToUsername = function (e) {
        this.employeeData.userName = e;
    };
    AddEmployeesComponent.prototype.formatDate = function (formatDate) {
        if (!formatDate) {
            return;
        }
        var changeDate = formatDate.split('-');
        var formatedDate = {
            year: +changeDate[0],
            month: +changeDate[1],
            day: +changeDate[2]
        };
        this.joiningDate = formatedDate;
        this.onDateChange(this.joiningDate);
    };
    AddEmployeesComponent.prototype.formatDOBDate = function (formatDate) {
        if (!formatDate) {
            return;
        }
        var changeDate = formatDate.split('-');
        var formatedDate = {
            year: +changeDate[0],
            month: +changeDate[1],
            day: +changeDate[2]
        };
        this.dateOfBirth = formatedDate;
        this.onDateofBirthChange(this.dateOfBirth);
    };
    // get employee by id
    AddEmployeesComponent.prototype.getEmployeeById = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/employee/getEmployee'
                + '?employeeId=' + this.employeeId;
            this.http.get(url).subscribe(function (result) {
                _this.employeeData.id = result.id;
                _this.employeeData.empCode = result.empCode;
                _this.employeeData.displayName = result.displayName;
                _this.employeeData.userName = result.userName;
                _this.employeeData.email = result.email;
                _this.employeeData.phoneNumber = result.phoneNumber;
                _this.employeeData.gender = result.gender;
                _this.formatDate(result.joiningDate);
                _this.formatDOBDate(result.dateOfBirth);
                if (result.designationName) {
                    _this.designationModel.name = result.designationName;
                    _this.designationName = result.designationName;
                    _this.designationModel.id = result.designationId;
                    _this.employeeData.designationId = result.designationId;
                }
                if (result.gradeId) {
                    _this.gradeModel.name = result.gradeName;
                    _this.gradeModel.id = result.gradeId;
                    _this.gradeName = result.gradeName;
                    _this.employeeData.gradeId = result.gradeId;
                }
                if (result.managementLevelId) {
                    _this.managementModel.name = result.managementLevelName;
                    _this.managementName = result.managementLevelName;
                    _this.managementModel.id = result.managementLevelId;
                    _this.employeeData.managementLevelId = result.managementLevelId;
                }
                if (result.categoryId) {
                    _this.categoryModel.id = result.categoryId;
                    _this.categoryModel.type = result.categoryName;
                    _this.catName = result.categoryName;
                    _this.employeeData.categoryId = result.categoryId;
                }
                _this.employeeData.orgId = result.orgId;
                if (_this.type === 'EDIT') {
                    _this.oldOrgID = result.orgId;
                }
                if (_this.type === 'ACTIVATE') {
                    _this.employeeData.userName = _this.employeeData.userName.replace("RESIGN_", "");
                    if (result.email) {
                        _this.employeeData.email = result.email.replace("RESIGN_", "");
                    }
                    _this.employeeData.status = 'ACTIVE';
                }
                _this.orgName = result.orgName;
                _this.organizationModel = result.orgName;
                //should add this condition to check if value is null or undefined, if not checked it will show null in ngmodel
                if (result.primarySupervisorName) {
                    _this.primarySupervisorModel.displayName = result.primarySupervisorName;
                }
                //should add this condition to check if value is null or undefined, if not checked it will show null in ngmodel
                if (result.verifierName) {
                    _this.verifierModel.displayName = result.verifierName;
                }
                _this.primarySupervisorModel.id = result.primarySupervisorId;
                _this.empdisplayName = result.primarySupervisorName;
                _this.employeeData.primarySupervisorId = result.primarySupervisorId;
                _this.verDisplayName = result.verifierName;
                _this.verifierModel.id = result.verifierId;
                _this.employeeData.verifierId = result.verifierId;
                _this.employeeData.licenceNumber = result.licenceNumber;
                _this.employeeData.userRole = result.userRole;
                var sampleSupIds = [];
                var sampleNames = [];
                var self = _this;
                if (result.secSupData != null && result.secSupData.length > 0) {
                    underscore["each"](result.secSupData, function (val, key) {
                        sampleSupIds[key] = val.empId;
                        sampleNames[key] = val.empName;
                    });
                    self.employeeData.secSupervisorIds = sampleSupIds;
                    self.secondarySupervisorModel = sampleNames;
                }
                if (result.imageUrl == null) {
                    _this.data = {};
                }
                else {
                    _this.employeeData.imageUrl = result.imageUrl;
                    _this.data.image = true;
                }
                _this.oldEmpSupData = result;
                _this.loading = false;
            });
        }
        catch (e) {
            console.log('saveEmployee error caught', e);
        }
    };
    AddEmployeesComponent.prototype.validateSup = function () {
        var _this = this;
        if (this.employeeData.primarySupervisorId == null) {
            if (this.employeeData.verifierId != null) {
                this.translate.get('pleaseSelectSupervisor').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                return false;
            }
            else if (underscore["isArray"](this.employeeData.secSupervisorIds)
                && this.employeeData.secSupervisorIds.length > 0) {
                if (this.employeeData.secSupervisorIds[0] != null) {
                    this.translate.get('pleaseSelectSupervisor').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    return false;
                }
            }
            else {
                return true;
            }
        }
        else {
            return true;
        }
    };
    // save employee
    AddEmployeesComponent.prototype.saveEmployeeData = function () {
        var _this = this;
        try {
            var that = this;
            if (this.validateSup()) {
                var data = that.employeeData;
                if (data.orgId == null) {
                    this.translate.get('pleaseSelectOrgUnit').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    return;
                }
                if (this.joiningDate == null) {
                    this.translate.get('pleaseSelectDateOfHire').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    return;
                }
                that.saveEmpData();
            }
        }
        catch (e) {
            console.log('saveEmployee error caught', e);
        }
    };
    AddEmployeesComponent.prototype.saveEmpData = function () {
        var _this = this;
        try {
            var self_2 = this;
            self_2.showButtonLoading = true;
            var url = self_2._baseUrl + 'v1/webAdmin/employee/saveEmployee';
            // remove all null values
            var data_1 = self_2.employeeData;
            underscore["map"](data_1, function (val, key) {
                if (underscore["isArray"](val)) {
                    if (underscore["isEmpty"](val)) {
                        delete data_1[key];
                    }
                }
                if (val == null) {
                    delete data_1[key];
                }
            });
            self_2.http.post(url, data_1).subscribe(function (result) {
                if (result.success) {
                    if (underscore["isArray"](result.data)) {
                        self_2.showButtonLoading = false;
                        Object(main["setTimeout"])(function () { return _this.goToBackPage(); }, 3000);
                    }
                    else {
                        Object(main["setTimeout"])(function () { return _this.goToBackPage(); }, 1000);
                        if (self_2.type === 'EDIT') {
                            self_2.translate.get('empUpdated').subscribe(function (msg) {
                                self_2._toaster.showSuccess(msg);
                            });
                        }
                        else if (self_2.type === 'ACTIVATE') {
                            self_2.translate.get('empActivated').subscribe(function (msg) {
                                self_2._toaster.showSuccess(msg);
                            });
                        }
                        else {
                            self_2.translate.get('empSaved').subscribe(function (msg) {
                                self_2._toaster.showSuccess(msg);
                            });
                        }
                    }
                }
                else {
                    self_2.showButtonLoading = false;
                    underscore["each"](result.data, function (element) {
                        self_2.translate.get(element).subscribe(function (msg) {
                            self_2._toaster.showError(msg);
                        });
                    });
                }
            });
        }
        catch (e) {
            console.log('saveEmployee error caught', e);
        }
    };
    AddEmployeesComponent.prototype.validateEmpSupRelationChange = function () {
        var self = this;
        var flag = false;
        if (self.oldEmpSupData.primarySupervisorId !== self.employeeData.primarySupervisorId) {
            flag = true;
        }
        else if (self.oldEmpSupData.verifierId !== this.employeeData.verifierId) {
            flag = true;
        }
        else if (underscore["isArray"](self.employeeData.secSupervisorIds) &&
            underscore["isArray"](self.oldEmpSupData.secSupData)) {
            if (self.employeeData.secSupervisorIds.length === self.oldEmpSupData.secSupData.length) {
                underscore["each"](self.employeeData.secSupervisorIds, function (val) {
                    var index = self.employeeData.secSupervisorIds.indexOf(val);
                    if (val !== self.oldEmpSupData.secSupData[index].empId) {
                        flag = true;
                    }
                });
            }
            else {
                flag = true;
            }
        }
        else {
            flag = false;
        }
        return flag;
    };
    AddEmployeesComponent.prototype.supChange = function (e) {
        this.empdisplayName = e.target.value;
    };
    AddEmployeesComponent.prototype.supSelected = function () {
        if (!this.empdisplayName) {
            this.primarySupervisorModel = {
                id: null,
                displayName: ''
            };
            this.employeeData.primarySupervisorId = null;
        }
        else {
            this.employeeData.primarySupervisorId = this.primarySupervisorModel.id;
        }
    };
    AddEmployeesComponent.prototype.verifierChange = function (e) {
        this.verDisplayName = e.target.value;
    };
    AddEmployeesComponent.prototype.verifierSelected = function () {
        if (this.verDisplayName === '') {
            this.verifierModel = {
                id: null,
                displayName: ''
            };
            this.employeeData.verifierId = null;
        }
        else {
            this.employeeData.verifierId = this.verifierModel.id;
        }
    };
    AddEmployeesComponent.prototype.secSupChange = function (e) {
        this.secSupDisplayName = e.target.value;
    };
    AddEmployeesComponent.prototype.secSupSelected = function (i) {
        if (this.secSupDisplayName === '') {
            this.secondarySupervisorModel.splice(i, 1);
            this.employeeData.secSupervisorIds.splice(i, 1);
        }
        else {
            if (this.secSupDisplayName != null) {
                if (this.secondarySupervisorModel[i].id) {
                    this.employeeData.secSupervisorIds[i] = this.secondarySupervisorModel[i].id;
                }
            }
        }
    };
    AddEmployeesComponent.prototype.empTypeChange = function (e) {
        this.catName = e.target.value;
    };
    AddEmployeesComponent.prototype.empTypeSelected = function () {
        if (this.catName === '') {
            this.categoryModel = {
                id: null,
                type: ''
            };
            this.employeeData.categoryId = null;
        }
        else {
            this.employeeData.categoryId = this.categoryModel.id;
        }
    };
    AddEmployeesComponent.prototype.categoryTypeChange = function (e) {
        this.managementName = e.target.value;
    };
    AddEmployeesComponent.prototype.categoryTypeSelected = function () {
        if (this.managementName === '') {
            this.managementModel = {
                id: null,
                name: ''
            };
            this.employeeData.managementLevelId = null;
        }
        else {
            this.employeeData.managementLevelId = this.managementModel.id;
        }
    };
    AddEmployeesComponent.prototype.designationChange = function (e) {
        this.designationName = e.target.value;
    };
    AddEmployeesComponent.prototype.designationSelected = function () {
        if (this.designationName === '') {
            this.designationModel = {
                id: null,
                name: ''
            };
            this.employeeData.designationId = null;
        }
        else {
            this.employeeData.designationId = this.designationModel.id;
        }
    };
    AddEmployeesComponent.prototype.gradeChange = function (e) {
        this.gradeName = e.target.value;
    };
    AddEmployeesComponent.prototype.gradeSelected = function () {
        if (this.gradeName === '') {
            this.gradeModel = {
                id: null,
                name: ''
            };
            this.employeeData.gradeId = null;
        }
        else {
            this.employeeData.gradeId = this.gradeModel.id;
        }
    };
    AddEmployeesComponent.prototype.orgChange = function (e) {
        this.orgName = e.target.value;
        this.orgFormData = this.orgName;
    };
    AddEmployeesComponent.prototype.orgSelected = function () {
        if (this.orgName === '') {
            this.organizationModel = {
                id: null,
                orgName: ''
            };
            this.disableSave = true;
            this.employeeData.orgId = null;
        }
        else {
            this.disableSave = false;
            this.employeeData.orgId = this.organizationModel.id ? this.organizationModel.id : this.employeeData.orgId;
            this.orgFormData = this.employeeData.orgId;
        }
    };
    AddEmployeesComponent.prototype.onDateofBirthChange = function (e) {
        this.employeeData.dateOfBirth = e.year + '-' + e.month + '-' + e.day;
    };
    AddEmployeesComponent.prototype.getRoleLabel = function (value) {
        switch (value) {
            case 'ROLE_USER':
                return 'User';
            case 'ROLE_VACCINE_ADMIN':
                return 'Vaccine Admin';
            case 'ROLE_VACCINE_SEARCH_ADMIN':
                return 'Vaccine Search';
            case 'ROLE_LAB_ADMIN':
                return 'Lab Admin';
            case 'ROLE_TRACE_HUB_ADMIN':
                return 'TraceHub';
            default:
                return 'None';
        }
    };
    return AddEmployeesComponent;
}());



// CONCATENATED MODULE: ./src/app/confirmation/confirmation.ts

var confirmation_ConfirmationComponent = /*@__PURE__*/ (function () {
    function ConfirmationComponent(route, activeModal, _global, http, _auth, share, _toaster, translate) {
        var _this = this;
        this.route = route;
        this.activeModal = activeModal;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.employeeCodes = [];
        this.forceResign = false;
        this.bulkResign = false;
        this.ccConversion = false;
        this.disabledButton = false;
        this.maxDate = { year: null, month: null, day: null };
        this.minDate = { year: null, month: null, day: null };
        this.translate.get('areYouSure').subscribe(function (msg) {
            _this.confirmationMessage = msg;
        });
        var data = this.share.getData();
        this.type = data.type;
        this.id = data.program;
        this._baseUrl = _global.get("EPMS_BASE_URL");
        if (this.type == 'Stop') {
            this.program = data.program;
            this.translate.get('areYouSureYouWantToStopTheProgram', { programName: this.program.name }).subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'Force_close') {
            this.translate.get('sureWantToForceClose').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'logOut') {
            this.translate.get('sureWantToLogOut').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'Resign') {
            this.translate.get('sureWantToResign').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'ResetDay0') {
            this.id = data.employeeId;
            this.translate.get('sureWantToResetDay0').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'ReloadEmp') {
            this.translate.get('sureWantToReloadEmployee').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'addLocationAssessment') {
            this.id = data.employeeId;
            this.translate.get('sureWantToAddLocationAssessment').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'convertToLowRisk') {
            this.id = data.employeeId;
            this.translate.get('sureWantToConvertToLowRisk').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'resolveCertErrors') {
            this.id = data.employeeId;
            this.translate.get('sureWantToResolve').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'convertToConfirmedCase') {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; // January is 0!
            var yyyy = today.getFullYear();
            this.maxDate.day = dd;
            this.maxDate.month = mm;
            this.maxDate.year = yyyy;
            var prior = new Date(new Date().getTime() - (9 * 24 * 60 * 60 * 1000));
            var dd1 = prior.getDate();
            var mm1 = prior.getMonth() + 1; // January is 0!
            var yyyy1 = prior.getFullYear();
            this.minDate.day = dd1;
            this.minDate.month = mm1;
            this.minDate.year = yyyy1;
            this.ccConversion = true;
            this.id = data.employeeId;
            this.translate.get('sureWantToConvertToConfirmedCase').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'revertICVerification') {
            this.id = data.employeeId;
            this.translate.get('sureWantToRevertICVerification').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'revertNonVaccineAccount') {
            this.id = data.employeeId;
            this.confirmationMessage = "Are you sure you want to revert Non vaccination account";
        }
        if (this.type == 'addMentalAssessment') {
            this.id = data.employeeId;
            this.translate.get('sureWantToAddMentalAssessment').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'Bulk_Resign') {
            this.bulkResign = true;
            this.forceResign = true;
            this.translate.get('Sure WantTo do Bulk  Resign').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'Delete') {
            this.translate.get('sureWantToDelete').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'publish_score') {
            this.translate.get('sureWantToPublishScore').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'publishStartegy') {
            this.translate.get('sureWantToPublishStrategy').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'deleteStartegy') {
            this.translate.get('sureWantToDelete').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'announcement') {
            this.translate.get('areYouSureYouWantToAnnouncementEmployees').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
        if (this.type == 'sendBulkInvitation') {
            this.translate.get('areYouSureYouWantToSendBulKInvitation').subscribe(function (msg) {
                _this.confirmationMessage = msg;
            });
        }
    }
    ConfirmationComponent.prototype.confirm = function () {
        if (this.type == 'Resign') {
            this.actionResignConfirmed();
        }
        else if (this.type == 'ResetDay0') {
            this.resetDay0Assessment();
        }
        else if (this.type == 'addLocationAssessment') {
            this.addLocationAssessment();
        }
        else if (this.type == 'convertToLowRisk') {
            this.convertToLowRisk();
        }
        else if (this.type == 'convertToConfirmedCase') {
            console.log(this.ccDate.sampleReceivedDate);
            this.convertToConfirmedCase();
        }
        else if (this.type == 'revertICVerification') {
            this.revertICVerification();
        }
        else if (this.type == 'revertNonVaccineAccount') {
            this.revertNonVaccineAccount();
        }
        else if (this.type == 'addMentalAssessment') {
            this.addMentalAssessment();
        }
        else if (this.type == 'ReloadEmp') {
            this.reloadEmployee();
        }
        else if (this.type == 'resolveCertErrors') {
            this.resolveCertErrors();
        }
        else if (this.type == 'Delete') {
            this.actionDeleteConfirmed();
        }
        else if (this.type == 'changeRole') {
            this.changeRoleConfirmed();
        }
        else if (this.type == 'removeLabTest') {
            this.removeLabTest();
        }
        else if (this.type == 'removeHSOBadge') {
            this.removeHSOBadge();
        }
        else {
            this.activeModal.close('confirmed');
        }
    };
    ConfirmationComponent.prototype.forceResignConfirmed = function () {
        this.activeModal.close('forceResign');
    };
    ConfirmationComponent.prototype.resetDay0Assessment = function () {
        var that = this;
        var url = that._baseUrl + "v1/webAdmin/assessment/resetEmployeeToDay0ByAdmin/" + that.id;
        that.http.get(url).subscribe(function (result) {
            if (result) {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('employeeReset').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.addLocationAssessment = function () {
        var that = this;
        var url = that._baseUrl + "v1/webAdmin/assessment/addLocationAssessment/" + that.id;
        that.http.get(url).subscribe(function (result) {
            if (result) {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('locAssessmentSuccess').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.convertToLowRisk = function () {
        var that = this;
        var url = that._baseUrl + "v1/webAdmin/assessment/markAsLowRisk/" + that.id;
        that.http.get(url).subscribe(function (result) {
            if (result) {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('lRSuccess').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.resolveCertErrors = function () {
        var that = this;
        var url = that._baseUrl + "v1/webAdmin/employee/resolveCertError/" + that.id;
        that.http.get(url).subscribe(function (result) {
            if (result) {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('resolveSuccess').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.convertToConfirmedCase = function () {
        var that = this;
        var url = that._baseUrl + "v1/webAdmin/assessment/markAsConfirmedCase/" + that.id;
        var payload = { id: this.ccDate.sampleReceivedDate };
        that.http.post(url, payload).subscribe(function (result) {
            if (result != null && result.status == "SUCCESS") {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('confirmedCaseSuccess').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
            else {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('confirmedCaseFailed').subscribe(function (msg) {
                    that._toaster.showError(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.revertICVerification = function () {
        var that = this;
        var url = that._baseUrl + "v1/webAdmin/assessment/revertICVerification/" + that.id;
        that.http.get(url).subscribe(function (result) {
            if (result) {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('revertICSuccess').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.revertNonVaccineAccount = function () {
        var that = this;
        var url = that._baseUrl + "v1/webAdmin/assessment/revertNonVaccineAccount/" + that.id;
        that.http.get(url).subscribe(function (result) {
            if (result) {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('empUpdated').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.addMentalAssessment = function () {
        var that = this;
        var url = that._baseUrl + "v1/webAdmin/assessment/addMentalAssessment/" + that.id;
        that.http.get(url).subscribe(function (result) {
            if (result) {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('mhAssessmentSuccess').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.reloadEmployee = function () {
        var that = this;
        var sd = this.share.getData();
        var url = that._baseUrl + "v1/webAdmin/employee/reloadEmployee/" + sd.employeeId;
        that.http.get(url).subscribe(function (result) {
            if (result) {
                setTimeout(function () { that.activeModal.close('confirmed'); }, 1000);
                that.translate.get('reloadEmployeeSuccess').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
            }
        });
    };
    ConfirmationComponent.prototype.actionResignConfirmed = function () {
        if (this.type == 'Bulk_Resign') {
            this.activeModal.close('not_confirmed');
        }
        else {
            try {
                var that_1 = this;
                var errors = void 0;
                var payload = {
                    employeeIds: [that_1.id],
                    forceResign: that_1.forceResign
                };
                if (that_1.forceResign) {
                    that_1.disabledButton = true;
                }
                var url = that_1._baseUrl + "v1/webAdmin/employee/resignEmployees";
                that_1.http.post(url, payload).subscribe(function (result) {
                    if (result.success == false) {
                        underscore["each"](result.errorMessages, function (value) {
                            that_1.translate.get('wantToContinue', { key: value }).subscribe(function (msg) {
                                that_1.confirmationMessage = msg;
                            });
                            that_1.forceResign = true;
                        });
                    }
                    else {
                        setTimeout(function () { that_1.activeModal.close('confirmed'); }, 1000);
                        that_1.translate.get('employeeResigned').subscribe(function (msg) {
                            that_1._toaster.showSuccess(msg);
                        });
                    }
                });
            }
            catch (e) {
                console.log("saveEmployee error caught", e);
            }
        }
    };
    //date format in string
    ConfirmationComponent.prototype.onDateChange = function (e) {
        if (e.day < 10) {
            if (e.month < 10) {
                this.ccDate.sampleReceivedDate = e.year + '-0' + e.month + '-0' + e.day;
            }
            else {
                this.ccDate.sampleReceivedDate = e.year + '-' + e.month + '-0' + e.day;
            }
        }
        else {
            if (e.month < 10) {
                this.ccDate.sampleReceivedDate = e.year + '-0' + e.month + '-' + e.day;
            }
            else {
                this.ccDate.sampleReceivedDate = e.year + '-' + e.month + '-' + e.day;
            }
        }
    };
    // temporary fixes for cal close
    ConfirmationComponent.prototype.openDatePicker = function (id) {
        this.dynamicId = id;
    };
    // temporary fixes for cal close
    ConfirmationComponent.prototype.onClick = function (event, targetElement) {
        if (!(targetElement.tagName === 'BUTTON'
            || targetElement.tagName === 'I' || targetElement.tagName === 'SELECT'
            || targetElement.tagName === 'SPAN')) {
            var self_1 = this;
            if (self_1.dynamicId) {
                if (self_1.dynamicId.isOpen()) {
                    setTimeout(function () {
                        this.trackHides = null;
                    }, 10);
                }
            }
        }
    };
    ConfirmationComponent.prototype.changeRoleConfirmed = function () {
        try {
            var sd = this.share.getData();
            var _self_1 = this;
            _self_1.disabledButton = true;
            var url = _self_1._baseUrl + "v1/webAdmin/role/changeRoleByEmpId/" + sd.employeeId + "/role/" + sd.data;
            _self_1.http.post(url, {}).subscribe(function (result) {
                setTimeout(function () { _self_1.activeModal.close('confirmed'); }, 1000);
                if (result.success == true) {
                    _self_1._toaster.showSuccess('Employee role changed successfully');
                }
            });
        }
        catch (e) {
            console.log("change employee role error caught", e);
        }
    };
    ConfirmationComponent.prototype.removeLabTest = function () {
        try {
            var sd = this.share.getData();
            var _self_2 = this;
            _self_2.disabledButton = true;
            var url = _self_2._baseUrl + "v1/webAdmin/employee/clearLabTestResultsByIC";
            _self_2.http.post(url, { id: sd.data }).subscribe(function (result) {
                setTimeout(function () { _self_2.activeModal.close('confirmed'); }, 1000);
                if (result.success == true) {
                    _self_2._toaster.showSuccess('Lab test result removed from profile');
                }
            });
        }
        catch (e) {
            console.log("change employee role error caught", e);
        }
    };
    ConfirmationComponent.prototype.removeHSOBadge = function () {
        try {
            var sd = this.share.getData();
            var _self_3 = this;
            _self_3.disabledButton = true;
            var url = _self_3._baseUrl + "v1/webAdmin/employee/removeHSOBadge";
            _self_3.http.post(url, { id: sd.data }).subscribe(function (result) {
                setTimeout(function () { _self_3.activeModal.close('confirmed'); }, 1000);
                if (result.success == true) {
                    _self_3._toaster.showSuccess('HSO badge removed from profile');
                }
            });
        }
        catch (e) {
            console.log("change employee role error caught", e);
        }
    };
    ConfirmationComponent.prototype.actionDeleteConfirmed = function () {
        try {
            var that_2 = this;
            that_2.disabledButton = true;
            var url = that_2._baseUrl + "v1/webAdmin/employee/deactivateAccount?username=" + that_2.id;
            that_2.http.get(url).subscribe(function (result) {
                if (result.success == false) {
                    underscore["each"](result.errorMessages, function (value) {
                        that_2.translate.get('wantToContinue', { key: value }).subscribe(function (msg) {
                            that_2.confirmationMessage = msg;
                        });
                        that_2.forceResign = true;
                    });
                }
                else {
                    setTimeout(function () { that_2.activeModal.close('confirmed'); }, 1000);
                    that_2.translate.get('employeeDeleted').subscribe(function (msg) {
                        that_2._toaster.showSuccess(msg);
                    });
                }
            });
        }
        catch (e) {
            console.log("Delete employee error caught", e);
        }
    };
    return ConfirmationComponent;
}());



// CONCATENATED MODULE: ./src/app/employee/employeeActions/actionSuspend.ts
var ActionSuspend = /*@__PURE__*/ (function () {
    function ActionSuspend(route, activeModal, translate, _global, http, _auth, share, _toaster, vcr) {
        this.route = route;
        this.activeModal = activeModal;
        this.translate = translate;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.share = share;
        this._toaster = _toaster;
        this.vcr = vcr;
        this.type = {};
        this.showButtonLoading = false;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        this.employeeId = data.employeeId;
        this.type = data.type;
    }
    ActionSuspend.prototype.suspendOrActiveEmployee = function () {
        var that = this;
        that.showButtonLoading = true;
        var url = that._baseUrl + 'v1/webAdmin/employee/updateEmployeeStatus';
        url += '?employeeId=' + that.employeeId;
        url += '&employeeStatus=' + that.type;
        that.http.get(url).subscribe(function (result) {
            if (result.data) {
                if (that.type === 'ACTIVE') {
                    that.translate.get('employeeActivatedAlert').subscribe(function (msg) {
                        that._toaster.showSuccess(msg);
                    });
                }
                if (that.type === 'SUSPEND') {
                    that.translate.get('employeeSuspendedAlert').subscribe(function (msg) {
                        that._toaster.showSuccess(msg);
                    });
                }
                setTimeout(function () { that.activeModal.close('confirm'); }, 1000);
            }
            else {
                that.showButtonLoading = false;
                that.translate.get('employeeActionFailed').subscribe(function (msg) {
                    that._toaster.showError(msg);
                });
            }
        }, function (error) {
            console.log(error);
        });
    };
    return ActionSuspend;
}());



// CONCATENATED MODULE: ./src/app/employee/employeeActions/resetPasswordByAdmin.ts
var ResetPasswordPage = /*@__PURE__*/ (function () {
    function ResetPasswordPage(route, 
    // public translate: TranslateService,
    activeModal, translate, _global, _http, _auth, _share, _toaster) {
        this.route = route;
        this.activeModal = activeModal;
        this.translate = translate;
        this._global = _global;
        this._http = _http;
        this._auth = _auth;
        this._share = _share;
        this._toaster = _toaster;
        this.showButtonLoading = false;
        this.passwordToken = undefined;
        this._baseUrl = _global.get("EPMS_BASE_URL");
    }
    ResetPasswordPage.prototype.resetPassword = function () {
        try {
            var self_1 = this;
            self_1.employeeId = self_1._share.getData();
            self_1.showButtonLoading = true;
            var url = self_1._baseUrl + "v1/webAdmin/employee/resetPassword/" + self_1.employeeId;
            self_1._http.get(url).subscribe(function (result) {
                if (result.data) {
                    self_1.translate.get('resetPasswordMailSent').subscribe(function (msg) {
                        self_1._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { self_1.activeModal.close(); }, 1000);
                }
                else {
                    self_1.translate.get('failedWhileResettingPassword').subscribe(function (msg) {
                        self_1._toaster.showError(msg);
                    });
                    self_1.showButtonLoading = false;
                }
            });
        }
        catch (e) {
            console.log('Error in resetPassword', e);
        }
    };
    ResetPasswordPage.prototype.notify = function (event) {
        this._toaster.showInfo("copied '" + event + "' To clipboard");
    };
    ResetPasswordPage.prototype.getPasswordToken = function () {
        try {
            var self_2 = this;
            self_2.employeeId = self_2._share.getData();
            self_2.showButtonLoading = true;
            var url = self_2._baseUrl + "v1/webAdmin/employee/getResetPasswordToken/" + self_2.employeeId;
            self_2._http.get(url).subscribe(function (result) {
                if (result.data) {
                    self_2.passwordToken = result.data;
                    self_2.showButtonLoading = false;
                }
                else {
                    self_2._toaster.showError("Reset password token not found");
                    self_2.showButtonLoading = false;
                }
            });
        }
        catch (e) {
            console.log('Error in resetPassword', e);
        }
    };
    return ResetPasswordPage;
}());



// EXTERNAL MODULE: ./src/app/environment.ts
var environment = __webpack_require__("S/3E");

// CONCATENATED MODULE: ./src/app/employee/employeeList.ts





var employeeList_EmployeesListingPage = /*@__PURE__*/ (function () {
    function EmployeesListingPage(route, modalService, activeModal, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this.activeModal = activeModal;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this.vcr = vcr;
        this.page = 5;
        this.endingPage = 0;
        this.startingPage = 0;
        this.localState = { value: '' };
        this.employeeData = [];
        this.employeePageData = [];
        this.trackHides = null;
        this.designationModel = {
            id: null,
            name: ''
        };
        this.organizationModel = {
            id: null,
            orgName: ''
        };
        this.orgName = '';
        this.desigName = '';
        this.displayName = '';
        this.primarySupervisorModel = {
            id: null,
            displayName: ''
        };
        this.showAdvanceSearch = false;
        this.pageSize = 10;
        this.showLoading = false;
        this.searchData = {
            nameOrCodeOrEmail: '',
            employeeCodes: [],
            excludedEmployeeCodes: [],
            includeEmpIds: [],
            excludeEmpIds: [],
            gradeIds: [],
            mgrLevelIds: [],
            designationIds: [],
            categoryIds: [],
            includeOrgIds: [],
            excludeOrgIds: [],
            supervisorIds: [],
            primarySupervisorIds: [],
            primarySupervisorNameOrCode: null,
            primarySupervisorCods: [],
            employeeStatus: null,
            employeesWithOutSupervisor: null,
            scorecardStates: null,
            memberShipState: null,
            programId: null,
            licenceNumber: '',
            pageSize: 10,
            page: 1,
            fetchSupervisorLevels: 0
        };
        this.roles = [
            'ROLE_USER', 'ROLE_VACCINE_ADMIN',
            'ROLE_VACCINE_SEARCH_ADMIN', 'ROLE_LAB_ADMIN',
            'ROLE_TRACE_HUB_ADMIN', 'ROLE_NIP_ADMIN',
            'ROLE_NIP_SEARCH_ADMIN', 'ROLE_VMS_RESOLVER_ADMIN'
        ];
        this._newMYSJType = 1;
        this._newMYSJCounCode = '60';
        this._newMYSJContact = '';
        this._newMYSJEmail = '';
        this.regexEmail = new RegExp('[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\.[a-zA-Z]{2,3}$');
        this.employeeModal = {};
        this.states = [];
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.displayName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListGradeFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListOrgFormatter = function (data) {
            var html = "<span>" + data.orgName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this.getStates();
        this.getEmployee();
        this._toaster.setViewRef(vcr);
        this.currentPage = 1;
        this.data = JSON.parse(localStorage.userInfo);
        this.empInfo = this.data;
        this.client = environment["a" /* environment */].client;
    }
    EmployeesListingPage.prototype.chage = function () {
        if (this.empInfo.localeName == null) {
            this.empInfo.localeName = 'en_US';
        }
        document.documentElement.setAttribute('lang', this.empInfo.localeName);
    };
    EmployeesListingPage.prototype.addEmployees = function () {
        this.share.saveData({ employeeId: null, type: 'ADD' });
        this.router.navigate(['menu/addEmployee']);
    };
    // Patch for pop-over issue
    EmployeesListingPage.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 10);
        }
    };
    EmployeesListingPage.prototype.clicked = function () {
        this.trackHides = null;
    };
    EmployeesListingPage.prototype.closeEmployeeFilter = function () {
        this._auth.closeFilter();
    };
    // show and hide Advance Search option
    EmployeesListingPage.prototype.showAdvanced = function (e) {
        this.showAdvanceSearch = e;
    };
    EmployeesListingPage.prototype.onStatusChange = function (e) {
        if (!e || !e.trim()) {
            this.searchData.employeeStatus = null;
            return;
        }
        else {
            this.searchData.employeeStatus = e;
        }
    };
    EmployeesListingPage.prototype.getEmployee = function () {
        var self = this;
        if (this.searchData.nameOrCodeOrEmail != '' || this.searchData.licenceNumber != '') {
            self.showLoading = true;
            var url = self._baseUrl + 'v1/webAdmin/employee';
            self.http.post(url, this.searchData).subscribe(function (result) {
                self.employeeData = [];
                self.employeeData = result.content;
                self.employeePageData = result;
                self.showLoading = false;
            }, function (error) {
                self.showLoading = false;
            });
        }
    };
    EmployeesListingPage.prototype.showSearchFilter = function (event) {
        this.searchData = event;
        this.getEmployee();
    };
    EmployeesListingPage.prototype.onPageSizeChange = function () {
        this.searchData.page = 1;
        this.getEmployee();
    };
    EmployeesListingPage.prototype.empTableActions = function (value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    EmployeesListingPage.prototype.empTableResetPwd = function (id) {
        this.trackHides = null;
        this.share.saveData(id);
        var modalRef = this.modalService.open(ResetPasswordPage, { windowClass: 'min-modal' });
    };
    EmployeesListingPage.prototype.actionSuspend = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'SUSPEND' });
        var modalRef = this.modalService.open(ActionSuspend, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirm') {
                _this.getEmployee();
            }
            else {
                // this.saveUpdateEmpRules(result);
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.resetToDay0 = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'ResetDay0',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.reloadEmployee = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'ReloadEmp',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.addLocationAssessment = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'addLocationAssessment',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.revertICVerification = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'revertICVerification',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.revertNonVaccineAccount = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'revertNonVaccineAccount',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.resolveCertErrors = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'resolveCertErrors',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.convertToConfirmedCase = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'convertToConfirmedCase',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.convertToLowRisk = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'convertToLowRisk',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.addMentalAssessment = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'addMentalAssessment',
            employeeId: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.actionResign = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'Resign',
            program: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.editEmployeeProfile = function (id) {
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'EDIT' });
        this.router.navigate(['menu/addEmployee']);
    };
    EmployeesListingPage.prototype.activateEmployeeProfile = function (id) {
        debugger;
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'ACTIVATE' });
        this.router.navigate(['menu/addEmployee']);
    };
    EmployeesListingPage.prototype.actionSwitchUser = function (employee) {
        this.trackHides = null;
        this.share.saveData({
            employee: employee,
            type: 'SWITCH'
        });
        this.router.navigate(['menu/switch']);
    };
    EmployeesListingPage.prototype.onRefresh = function () {
        this.getEmployee();
    };
    EmployeesListingPage.prototype.notify = function (event) {
        this._toaster.showInfo("copied '" + event + "' To clipboard");
    };
    EmployeesListingPage.prototype.actionRemoveEmployee = function (username) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'Delete',
            program: username
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.openRoleModal = function (targetModal, id) {
        this._activeUserId = id;
        this._newRole = '';
        this.roleModelRef = this.modalService.open(targetModal);
        this.roleModelRef.result.then(function (result) {
        }, function (reason) {
        });
    };
    EmployeesListingPage.prototype.changeRole = function () {
        var _this = this;
        if (this._newRole == '') {
            return;
        }
        var closeResult;
        this.closeRoleModal();
        var confirmData = {
            type: 'changeRole',
            employeeId: this._activeUserId,
            data: this._newRole
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.closeRoleModal = function () {
        this.roleModelRef.dismiss('');
    };
    EmployeesListingPage.prototype.getStates = function () {
        this.states = [{ "id": "F2E9FBDEBC37B34B837554B13B031629", "orgName": "Perlis", "orgNameLocale": "Perlis", "orgUnitCode": "Perlis", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B5BE732B4F14B74DD", "orgName": "Kedah", "orgNameLocale": "Kedah", "orgUnitCode": "Kedah", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BC5A4EB1F39D06BD1", "orgName": "Perak", "orgNameLocale": "Perak", "orgUnitCode": "Perak", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B3D13C2BCE0D20CDD", "orgName": "Pulau Pinang", "orgNameLocale": "Pulau Pinang", "orgUnitCode": "Pulau Pinang", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B4BDA5B11108D587D", "orgName": "Selangor", "orgNameLocale": "Selangor", "orgUnitCode": "Selangor", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BFCAC6EB02A19356A", "orgName": "Negeri Sembilan", "orgNameLocale": "Negeri Sembilan", "orgUnitCode": "Negeri Sembilan", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BD098B033D39AE184", "orgName": "Melaka", "orgNameLocale": "Melaka", "orgUnitCode": "Melaka", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B6280AA618C717510", "orgName": "Johor", "orgNameLocale": "Johor", "orgUnitCode": "Johor", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BB6A592F0CC41A2E7", "orgName": "Terengganu", "orgNameLocale": "Terengganu", "orgUnitCode": "Terengganu", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B0A228FAC69C5C809", "orgName": "Pahang", "orgNameLocale": "Pahang", "orgUnitCode": "Pahang", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BDF1E8862862ED39F", "orgName": "Kelantan", "orgNameLocale": "Kelantan", "orgUnitCode": "Kelantan", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B062F6DA2A7133810", "orgName": "Sabah", "orgNameLocale": "Sabah", "orgUnitCode": "Sabah", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B83EDC1DC3E5E2E63", "orgName": "Sarawak", "orgNameLocale": "Sarawak", "orgUnitCode": "Sarawak", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34B1EDFFC755BC57AE6", "orgName": "WP Kuala Lumpur", "orgNameLocale": "WP Kuala Lumpur", "orgUnitCode": "WP Kuala Lumpur", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BFA7DBEF29D554EEA", "orgName": "WP Labuan", "orgNameLocale": "WP Labuan", "orgUnitCode": "WP Labuan", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }, { "id": "F2E9FBDEBC37B34BB7D41137BFE09A99", "orgName": "WP Putrajaya", "orgNameLocale": "WP Putrajaya", "orgUnitCode": "WP Putrajaya", "orgTypeId": "4144F272454433D08B060DC7D148A1EC575662796951C081" }];
    };
    EmployeesListingPage.prototype.openEditModal = function (targetModal, emp) {
        this._activeUserId = emp.id;
        this._activeEmployee = emp;
        this._newRole = '';
        this._activeEmployee.bkPassportNumber = this._activeEmployee.passportNumber;
        if (this._activeEmployee.dateOfBirth) {
            this._activeEmployee.dateOfBirth = date_utils_DateTimeUtils.strToIMyDate(this._activeEmployee.dateOfBirth);
        }
        this.roleModelRef = this.modalService.open(targetModal);
        this.roleModelRef.result.then(function (result) {
        }, function (reason) {
        });
    };
    EmployeesListingPage.prototype.updateEmployee = function () {
        if (this._activeEmployee.reason == undefined || this._activeEmployee.reason == '') {
            return;
        }
        var data = {
            state: this._activeEmployee.orgCode,
            nationality: this._activeEmployee.nationality,
            justification: this._activeEmployee.reason,
            address: this._activeEmployee.address,
            passportNumber: this._activeEmployee.passportNumber,
            postcode: this._activeEmployee.postcode,
        };
        if (this._activeEmployee.dateOfBirth) {
            data.dateOfBirth = date_utils_DateTimeUtils.imyDateToDate(this._activeEmployee.dateOfBirth);
        }
        var _self = this;
        var url = _self._baseUrl + "v1/webAdmin/employee/updateProfile?employeeId=" + this._activeEmployee.id;
        _self.http.put(url, data).subscribe(function (result) {
            setTimeout(function () { _self.activeModal.close('confirmed'); }, 1000);
            if (result.success == true) {
                _self._toaster.showSuccess('Profile updated successfully');
                _self.getEmployee();
            }
            else {
                _self._toaster.showError('Profile update failes');
            }
        });
        this.closeRoleModal();
    };
    EmployeesListingPage.prototype.openChangeIdModal = function (targetModal, emp) {
        this._activeUserId = emp.id;
        this._activeEmployee = emp;
        this._newRole = '';
        this.roleModelRef = this.modalService.open(targetModal);
        this.roleModelRef.result.then(function (result) {
        }, function (reason) {
        });
    };
    EmployeesListingPage.prototype.changeMYSJId = function () {
        var newMYSJId = this._newMYSJCounCode + '' + this._newMYSJContact;
        if (this._newMYSJType == 1 && this._newMYSJContact != '') {
            newMYSJId = this._newMYSJCounCode + '' + this._newMYSJContact;
        }
        else {
            newMYSJId = this._newMYSJEmail;
        }
        if (newMYSJId == '') {
            return;
        }
        if (this._newMYSJType == 2 && !this.regexEmail.test(newMYSJId)) {
            return;
        }
        var _self = this;
        var url = _self._baseUrl + "v1/webAdmin/employee/transferAccount/" + this._activeEmployee.id;
        _self.http.post(url, { id: newMYSJId }).subscribe(function (result) {
            setTimeout(function () { _self.activeModal.close('confirmed'); }, 1000);
            if (result.success == true) {
                _self._toaster.showSuccess('Change MySJ ID: SMS / Mail sent successfully​');
            }
            else {
                _self._toaster.showError('Change MySJ ID: SMS / Mail  unsuccessful​');
            }
        });
        this.closeRoleModal();
    };
    EmployeesListingPage.prototype.toggleIdType = function () {
        this._newMYSJType = this._newMYSJType == 1 ? 2 : 1;
    };
    EmployeesListingPage.prototype.onNationalityChange = function () {
        if (this._activeEmployee && this._activeEmployee.nationality != 'Malaysian') {
            this._activeEmployee.passportNumber = this._activeEmployee.licenceNumber;
        }
        else if (this._activeEmployee.bkPassportNumber) {
            this._activeEmployee.passportNumber = this._activeEmployee.bkPassportNumber;
        }
    };
    EmployeesListingPage.prototype.removeLabTest = function (ic) {
        var _this = this;
        if (ic == '') {
            return;
        }
        var closeResult;
        var confirmData = {
            type: 'removeLabTest',
            employeeId: this._activeUserId,
            data: ic
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.removeHSOBadge = function (ic) {
        var _this = this;
        if (ic == '') {
            return;
        }
        var closeResult;
        var confirmData = {
            type: 'removeHSOBadge',
            employeeId: this._activeUserId,
            data: ic
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'confirmed') {
                _this.getEmployee();
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeesListingPage.prototype.getRoleLabel = function (value) {
        switch (value) {
            case 'ROLE_USER':
                return 'User';
            case 'ROLE_VACCINE_ADMIN':
                return 'Vaccine Admin';
            case 'ROLE_VACCINE_SEARCH_ADMIN':
                return 'Vaccine Search';
            case 'ROLE_LAB_ADMIN':
                return 'Lab Admin';
            case 'ROLE_TRACE_HUB_ADMIN':
                return 'TraceHub';
            case 'ROLE_ADMIN':
                return 'Administrator';
            case 'ROLE_NIP_ADMIN':
                return 'NIP Admin';
            case 'ROLE_NIP_SEARCH_ADMIN':
                return 'NIP Search';
            case 'ROLE_VMS_RESOLVER_ADMIN':
                return 'VMS Resolver';
            default:
                return 'None';
        }
    };
    return EmployeesListingPage;
}());



// CONCATENATED MODULE: ./src/app/programManagement/announcements/scheduleAnnouncement.ts

var scheduleAnnouncement_ScheduleAnnouncement = /*@__PURE__*/ (function () {
    function ScheduleAnnouncement(route, activeModal, _global, http, _auth, share, translate, _toaster, vcr, _eref) {
        this.route = route;
        this.activeModal = activeModal;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.share = share;
        this.translate = translate;
        this._toaster = _toaster;
        this._eref = _eref;
        this.meridian = true;
        this.spinners = false;
        this.announcementData = {};
        this.minStartDate = {};
        this.activationTime = {
            "hour": null,
            "minute": null
        };
        this.buttonStatus = false;
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.setMinStartDate();
        this.announcementData = this.share.getData();
        this.now = new Date();
        this.activationTime.hour = this.now.getHours();
        this.activationTime.minute = this.now.getMinutes();
        this.activationTime.second = this.now.getSeconds();
        this.announcementData.activationDate = { year: this.now.getFullYear(), month: this.now.getMonth() + 1, day: this.now.getDate() };
    }
    // temporary fixes for cal close
    ScheduleAnnouncement.prototype.openDatePicker = function (id) {
        this.dynamicId = id;
    };
    // temporary fixes for cal close
    ScheduleAnnouncement.prototype.onClick = function (event) {
        if (event.target.tagName == 'BUTTON' || event.target.tagName == 'I' || event.target.tagName == 'SELECT' || event.target.tagName == 'SPAN') {
        }
        else {
            var self_1 = this;
            if (self_1.dynamicId.isOpen()) {
                setTimeout(function () {
                    self_1.dynamicId.close();
                }, 10);
            }
        }
    };
    ScheduleAnnouncement.prototype.setMinStartDate = function () {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth();
        month = month + 1;
        var day = date.getDate();
        var endDateObj = {
            year: year,
            month: month,
            day: day
        };
        this.minStartDate = endDateObj;
    };
    ScheduleAnnouncement.prototype.toggleMeridian = function () {
        this.meridian = !this.meridian;
    };
    ScheduleAnnouncement.prototype.schedule = function () {
        var _this = this;
        if (this.announcementData.activationDate != null && this.activationTime != null) {
            if (this.announcementData.activationDate.day <= this.now.getDate()) {
                if (this.activationTime.hour != null) {
                    var hour = this.now.getHours();
                    if (this.activationTime.hour < hour) {
                        this.translate.get('selectedTimeNotValidForDate').subscribe(function (msg) {
                            _this._toaster.showError(msg);
                        });
                        return false;
                    }
                    else if (this.activationTime.hour == hour) {
                        var minute = this.now.getMinutes();
                        if (this.activationTime.minute < minute) {
                            this.translate.get('minNotValidForDateTime').subscribe(function (msg) {
                                _this._toaster.showError(msg);
                            });
                            return false;
                        }
                    }
                }
            }
            var self_2 = this;
            if (underscore["isObject"](this.announcementData.activationDate)) {
                this.onStartDateChange(this.announcementData.activationDate);
            }
            if (underscore["isObject"](this.announcementData)) {
                this.onActivationTimeChange(this.announcementData.activationDate, this.activationTime);
            }
            this.announcementData.activationDate = new Date(this.announcementData.activationDate);
            try {
                this.buttonStatus = true;
                var url = self_2._baseUrl + "v1/webAdmin/announcement/triggerAnnouncement";
                self_2.http.post(url, self_2.announcementData).subscribe(function (result) {
                    if (result.data != null) {
                        self_2.translate.get('checkEmpCode').subscribe(function (msg) {
                            self_2._toaster.showError(msg);
                        });
                        self_2.announcementData.contentData.extensions = [];
                        self_2.announcementData.groupIds = [];
                        self_2.announcementData.contentData.imgURL = [];
                        self_2.announcementData.contentData.videoURL = [];
                        self_2.announcementData.contentData.imageURL = [];
                        self_2.announcementData.employeeSearchFilter = null;
                    }
                    else {
                        if (result.success) {
                            setTimeout(function () { return self_2.goToBackPage(); }, 1000);
                            self_2.translate.get('announcementSuccessfull').subscribe(function (msg) {
                                self_2._toaster.showSuccess(msg);
                            });
                        }
                        else {
                            setTimeout(function () { return self_2.goToBackPage(); }, 1000);
                            self_2.translate.get('errorWhileAnnouncement').subscribe(function (msg) {
                                self_2._toaster.showError(msg);
                            });
                        }
                    }
                });
            }
            catch (e) {
                console.log("getAllEmployeeData error catch", e);
            }
        }
        else {
            this.translate.get('activationDateTime').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
        }
    };
    ScheduleAnnouncement.prototype.onStartDateChange = function (e) {
        this.announcementData.activationDate = e.year + '-' + e.month + '-' + e.day;
    };
    ScheduleAnnouncement.prototype.onActivationTimeChange = function (e, f) {
        this.announcementData.activationDate = e + " " + f.hour + ':' + f.minute + ':' + f.second;
    };
    ScheduleAnnouncement.prototype.goToBackPage = function () {
        this.activeModal.close('confirmed');
    };
    return ScheduleAnnouncement;
}());



// CONCATENATED MODULE: ./src/app/employee/employeeSearch.ts








var employeeSearch_EmployeeSearch = /*@__PURE__*/ (function () {
    function EmployeeSearch(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, _location, vcr, translate) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this._location = _location;
        this.vcr = vcr;
        this.translate = translate;
        this.showButtonLoading = false;
        this.displayType = "";
        this.type = "";
        this.programId = "";
        this.option = "";
        this.notValidForTrigger = [];
        this.startpayload = {
            programId: null,
            employeeSearchFilter: null,
            participantsType: null
        };
        this.triggerPayload = {
            reviewEndDate: null,
            programId: null,
            isFinal: false,
            employeeSearchFilter: null,
            reviewTriggerId: null
        };
        this.announcementData = {
            employeeSearchFilter: null,
            participantsType: null,
            contentData: {
                text: null,
                imgURL: [],
                videoURL: [],
                imageURL: [],
                extensions: [],
                imgWebAddress: null
            },
            groupIds: [],
            title: null,
            activationDate: null
        };
        this.switchEmployeeDetails = {};
        this.invalidEmp = [];
        this.userGroupdata = {
            id: null,
            name: null,
            description: null,
            version: null,
            roleGroups: [],
            userGroups: [],
        };
        this.enrollProgramId = [];
        this.enrollEmployeesPayload = {
            programId: null,
            employeeSearchFilter: null,
            participantsType: null
        };
        this.enrollProgramData = {};
        this.empCodeValues = '';
        this.excludeEmpCodeValues = '';
        this.page = 5;
        this.endingPage = 0;
        this.startingPage = 0;
        this.localState = { value: '' };
        this.employeeData = [];
        this.employeePageData = [];
        this.trackHides = null;
        this.designationModel = {
            id: null,
            name: ''
        };
        this.organizationModel = {
            id: null,
            orgName: ''
        };
        this.orgName = '';
        this.desigName = '';
        this.displayName = '';
        this.primarySupervisorModel = {
            id: null,
            displayName: ''
        };
        this.showAdvanceSearch = false;
        this.pageSize = 10;
        this.showLoading = false;
        this.searchData = {
            "nameOrCodeOrEmail": "",
            "employeeCodes": [],
            "excludedEmployeeCodes": [],
            "includeEmpIds": [],
            "excludeEmpIds": [],
            "gradeIds": [],
            "mgrLevelIds": [],
            "designationIds": [],
            "categoryIds": [],
            "includeOrgIds": [],
            "excludeOrgIds": [],
            "supervisorIds": [],
            "primarySupervisorIds": [],
            "primarySupervisorNameOrCode": null,
            "primarySupervisorCods": [],
            "employeeStatus": null,
            "employeesWithOutSupervisor": null,
            "scorecardStates": null,
            "memberShipState": null,
            "programId": null,
            "pageSize": 10,
            "page": 1,
            "fetchSupervisorLevels": 0
        };
        this.enrollCompetency = {
            employeeIdList: [],
            employeeSearchFilter: this.searchData,
            programId: null,
            type: "Enroll"
        };
        //to get list of Organization based on keyword
        this.organizationObservableSource = function (keyword) {
            try {
                var url = _this._baseUrl + "v1/webAdmin/employee/orgSearch";
                url += "?searchString=" + keyword;
                if (keyword) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            catch (e) { }
        };
        //to get list of designation based on keyword
        this.designationObservableSource = function (keyword) {
            try {
                var url = _this._baseUrl + "v1/webAdmin/employee/designationSearch";
                url += "?searchString=" + keyword;
                if (keyword) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            catch (e) { }
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.displayName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListGradeFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListOrgFormatter = function (data) {
            var html = "<span>" + data.orgName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.getEmployee();
        this._toaster.setViewRef(vcr);
        this.currentPage = 1;
        this.enrollProgramData = this.share.getMapValues('enrollData');
        if (this.enrollProgramData != undefined) {
            this.enrollProgramId = this.enrollProgramData.programId;
            this.enrollProgramType = this.enrollProgramData.type;
        }
        var startData = this.share.getMapValues('startProgramData');
        var triggerData = this.share.getMapValues('triggerReview');
        var announcementInfo = this.share.getMapValues('announcement');
        var roleInfo = this.share.getMapValues('Role');
        var userInfo = this.share.getMapValues('UserGroup');
        if (underscore["isEmpty"](startData) && underscore["isEmpty"](triggerData) && underscore["isEmpty"](announcementInfo) && !(roleInfo) && !(userInfo) && underscore["isEmpty"](this.enrollProgramId)) {
            this._location.back();
        }
        else {
            if (startData != null) {
                if (startData.type == 'SWITCH') {
                    this.type = startData.type;
                    this.switchEmployeeDetails = startData.employee;
                    this.displayType = "SWITCH";
                }
                else {
                    this.type = startData.type;
                    this.programId = startData.programId;
                    this.displayType = "Start";
                }
            }
            if (this.enrollProgramId != null && this.enrollProgramType == 'PERFORMANCE_PROGRAM') {
                this.enrollEmployeesPayload.programId = this.enrollProgramId;
                this.programId = this.enrollProgramId;
                this.displayType = "EnrollPerformance";
                this.type = "PERFORMANCE_PROGRAM";
            }
            if (this.enrollProgramId != null && this.enrollProgramType == 'COMPETENCY_PROGRAM') {
                this.programId = this.enrollProgramId;
                this.enrollCompetency.programId = this.enrollProgramId;
                this.displayType = "EnrollCompetency";
                this.type = "COMPETENCY_PROGRAM";
            }
            if (this.enrollProgramId != null && this.enrollProgramType == 'CHECKIN_PROGRAM') {
                this.programId = this.enrollProgramId;
                this.enrollCompetency.programId = this.enrollProgramId;
                this.displayType = "EnrollCheckin";
                this.type = "CHECKIN_PROGRAM";
            }
            if (triggerData != null) {
                this.triggerPayload = triggerData.payload;
                this.programId = triggerData.payload.programId;
                this.option = triggerData.option;
                this.type = "Trigger Review";
                this.displayType = "Trigger";
            }
            if (announcementInfo != null) {
                this.announcementData = announcementInfo;
                this.type = "Announcement";
                this.displayType = "Announcement";
            }
            if (roleInfo != null) {
                this.roleId = roleInfo;
                this.type = "Role";
                this.displayType = "Role";
            }
            if (userInfo != null) {
                this.groupId = userInfo;
                this.type = "UserGroup";
                this.displayType = "UserGroup";
            }
        }
    }
    EmployeeSearch.prototype.finalAddRole = function (option) {
        var _this = this;
        var that = this;
        var flag = false;
        option = 'assignRolesIncludeEmployeeCodes';
        var url = that._baseUrl + 'v1/webAdmin/role/' + option + '/' + that.roleId;
        that.http.post(url, that.searchData).subscribe(function (result) {
            if (result.status) {
                _this.translate.get('usersAdded').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 3000);
            }
            else {
                _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                    that._toaster.showError(msg);
                });
            }
        });
    };
    EmployeeSearch.prototype.finalAddUsers = function (option) {
        var _this = this;
        var that = this;
        var flag = false;
        option = 'assignGroupIncludeEmployeeCodes';
        var url = that._baseUrl + 'v1/hub/userGroup/' + option + '/' + that.groupId;
        that.http.post(url, that.searchData).subscribe(function (result) {
            if (result.status) {
                _this.translate.get('usersAdded').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 3000);
            }
            else {
                _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                    that._toaster.showError(msg);
                });
            }
        });
    };
    EmployeeSearch.prototype.triggerAnnouncement = function () {
        var _this = this;
        var self = this;
        this.showButtonLoading = true;
        var url = self._baseUrl + "v1/webAdmin/announcement/triggerAnnouncement";
        self.check(url).subscribe(function (result) {
            if (result[0].success) {
                _this.translate.get('announcementSuccessfull').subscribe(function (msg) {
                    self._toaster.showSuccess(msg);
                });
                _this.searchData.employeeCodes = [];
                _this.searchData.excludedEmployeeCodes = [];
                _this.announcementData.employeeSearchFilter = null;
                setTimeout(function () { return self.goToBackPage(); }, 1000);
            }
            else {
                _this.translate.get('invalidEmpCodeRequest').subscribe(function (msg) {
                    self._toaster.showError(msg);
                });
                _this.empCodeValues = '';
                _this.searchData.employeeCodes = [];
                _this.searchData.excludedEmployeeCodes = [];
                _this.announcementData.employeeSearchFilter = null;
                /* setTimeout(() => self.goToBackPage(), 1000); */
            }
        }, function (error) {
            _this.translate.get('errorWhileAnnouncement').subscribe(function (msg) {
                self._toaster.showError(msg);
            });
            setTimeout(function () { return self.goToBackPage(); }, 1000);
        });
    };
    EmployeeSearch.prototype.check = function (url) {
        var self = this;
        try {
            return Observable["a" /* Observable */].create(function (observer) {
                self.announcementData.employeeSearchFilter = self.searchData;
                var obs = Object(_esm5["p" /* forkJoin */])([self.http.post(url, self.announcementData)]);
                obs.subscribe(function (response) {
                    observer.next(response);
                    observer.complete();
                });
            });
        }
        catch (e) {
            console.log("getAllEmployeeData error catch", e);
        }
    };
    EmployeeSearch.prototype.validateEmps = function (flag) {
        if (flag == 1) {
            this.triggerAnnouncement();
        }
        else {
            this.scheduleAnnouncement(this.announcementData);
        }
    };
    EmployeeSearch.prototype.scheduleAnnouncement = function (announcementData) {
        var _this = this;
        announcementData.employeeSearchFilter = this.searchData;
        this.share.saveData(announcementData);
        var modalRef = this.modalService.open(scheduleAnnouncement_ScheduleAnnouncement).result.then(function (result) {
            _this.closeResult = "Closed with: " + result;
            if (result == 'confirmed') {
                _this.goToBackPage();
            }
        }, function (reason) {
            _this.closeResult = "Dismissed " + _this.getDismissReason(reason);
        });
    };
    EmployeeSearch.prototype.validateAndTrigger = function () {
        if (this.option == 'existing') {
            this.validateTriggerReview();
        }
        if (this.option == 'new') {
            this.triggerReview('new');
        }
    };
    EmployeeSearch.prototype.goToBackPage = function () {
        if (this.type == 'CHECKINS_PROGRAM') {
            this.router.navigate(['menu/Checkins']);
            this.share.saveAsMap('startProgramData', null);
        }
        else if (this.type == 'PERFORMANCE_PROGRAM') {
            this.router.navigate(['menu/performanceProgram']);
            this.share.saveAsMap('startProgramData', null);
        }
        else if (this.type == 'COMPETENCY_PROGRAM') {
            this.router.navigate(['menu/competencyProgram']);
            this.share.saveAsMap('startProgramData', null);
        }
        else if (this.type == 'CHECKIN_PROGRAM') {
            this.router.navigate(['menu/Checkins']);
            this.share.saveAsMap('startProgramData', null);
        }
        else if (this.type == 'Trigger Review') {
            this.share.saveAsMap('triggerReview', null);
            this.router.navigate(['menu/performanceProgram']);
        }
        else if (this.type == 'Announcement') {
            this.share.saveAsMap('announcement', null);
            this.router.navigate(['menu/announcementProgram']);
        }
        else if (this.type == 'Role') {
            this.share.saveAsMap('Role', null);
            this.router.navigate(['menu/rolesAndPermission']);
        }
        else if (this.type == 'UserGroup') {
            this.share.saveAsMap('UserGroup', null);
            this.router.navigate(['menu/userGroup']);
        }
        else if (this.type == "Enroll") {
            this.share.saveAsMap('enrollProgramId', null);
            this.router.navigate(['menu/performanceProgram']);
        }
    };
    EmployeeSearch.prototype.validateTriggerReview = function () {
        var _this = this;
        try {
            this.showButtonLoading = true;
            this.triggerPayload.programId = this.programId;
            this.triggerPayload.employeeSearchFilter = this.searchData;
            var url = this._baseUrl + 'v1/webAdmin/performance/validateTriggerReview';
            this.http.post(url, this.triggerPayload).subscribe(function (result) {
                if (result.length > 0) {
                    _this.getOnlyValidEmpCode(result);
                }
                else {
                    _this.translate.get('reviewTriggerFailed').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    _this.showButtonLoading = false;
                }
            });
        }
        catch (e) {
            console.log('validateTriggerReview error catch', e);
        }
    };
    EmployeeSearch.prototype.getOnlyValidEmpCode = function (data) {
        var validEmpCode = [];
        var notExistEmp = [];
        var errorMessage;
        var allreadyTriggerEmp = [];
        var isVaidEmp = false;
        var self = this;
        underscore["each"](data, function (val) {
            if (val.validationMessage == 'VALID') {
                validEmpCode.push(val.empCodes);
            }
            if (val.validationMessage == 'NOT_EXIST_IN_SYSTEM') {
                notExistEmp.push(val.empCodes);
                self.translate.get(val.validationMessage).subscribe(function (msg) {
                    errorMessage = msg;
                });
                self.goToBackPage();
            }
            if (val.validationMessage == 'REVIEW_ALREADY_TRIGGERED') {
                notExistEmp.push(val.empCodes);
                self.translate.get(val.validationMessage).subscribe(function (msg) {
                    errorMessage = msg;
                });
                self.goToBackPage();
            }
        });
        self.notValidForTrigger = notExistEmp;
        if (notExistEmp.length > 0) {
            isVaidEmp = false;
        }
        else {
            if (validEmpCode.length > 0) {
                isVaidEmp = true;
            }
        }
        if (isVaidEmp) {
            self.triggerReview('existing');
        }
        else {
            self.showButtonLoading = false;
            self._toaster.showError(errorMessage);
        }
    };
    EmployeeSearch.prototype.triggerReview = function (option) {
        var _this = this;
        try {
            this.showButtonLoading = true;
            this.triggerPayload.programId = this.programId;
            this.triggerPayload.employeeSearchFilter = this.searchData;
            var url = this._baseUrl + 'v1/webAdmin/performance/triggerReview';
            this.http.post(url, this.triggerPayload).subscribe(function (result) {
                if (result) {
                    if (option == 'existing') {
                        _this.translate.get('reviewTriggeredForValidEmp').subscribe(function (msg) {
                            _this._toaster.showSuccess(msg);
                        });
                    }
                    else {
                        _this.translate.get('reviewTriggered').subscribe(function (msg) {
                            _this._toaster.showSuccess(msg);
                        });
                    }
                }
                else {
                    _this.translate.get('reviewAlreadyTriggered').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
                setTimeout(function () { return _this.goToBackPage(); }, 3000);
            });
        }
        catch (e) {
            console.log('triggerReview error catch', e);
        }
    };
    EmployeeSearch.prototype.startProgram = function (program) {
        var _this = this;
        this.showButtonLoading = true;
        var confirmData = {
            type: 'Start',
            program: program
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            _this.closeResult = "Closed with: " + result;
            if (result == 'confirmed') {
                _this.confirmStart();
            }
        }, function (reason) {
            _this.showButtonLoading = false;
            _this.closeResult = "Dismissed " + _this.getDismissReason(reason);
        });
    };
    EmployeeSearch.prototype.confirmStart = function () {
        var self = this;
        if (this.type == 'CHECKINS_PROGRAM') {
            self.startCheckinProgram();
        }
        else if (this.type == 'PERFORMANCE_PROGRAM') {
            self.startPerformanceProgram();
        }
        else if (this.type == 'COMPETENCY_PROGRAM') {
            self.startCompetencyProgram();
        }
    };
    EmployeeSearch.prototype.goToValBackPage = function () {
        this._location.back();
    };
    EmployeeSearch.prototype.showSearchFilter = function (event) {
        this.searchData = event;
        this.getEmployee();
    };
    EmployeeSearch.prototype.startPerformanceProgram = function () {
        var _this = this;
        try {
            var data = this.share.getMapValues('startProgramData');
            this.startpayload.programId = data.programId;
            this.startpayload.participantsType = 'INCLUDE_EVERYONE_IN';
            this.startpayload.employeeSearchFilter = this.searchData;
            var url = this._baseUrl + 'v1/webAdmin/performance/startPerformanceProgram';
            this.http.post(url, this.startpayload).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('progStarted').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 3000);
                }
                else {
                    _this.translate.get('errorWhileStartingProg').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    _this.showButtonLoading = false;
                }
            });
        }
        catch (e) {
            console.log('start program error catch', e);
        }
    };
    EmployeeSearch.prototype.startCompetencyProgram = function () {
        var _this = this;
        try {
            var data = this.share.getMapValues('startProgramData');
            this.startpayload.programId = data.programId;
            this.startpayload.participantsType = 'INCLUDE_EVERYONE_IN';
            this.startpayload.employeeSearchFilter = this.searchData;
            var url = this._baseUrl + 'v1/webAdmin/competency/startCompetencyProgram';
            this.http.post(url, this.startpayload).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('progStarted').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 3000);
                }
                else {
                    _this.translate.get('errorWhileStartingProg').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    _this.showButtonLoading = false;
                    // setTimeout(() => this.goToBackPage(), 3000);
                }
            });
        }
        catch (e) {
            console.log('start program error catch', e);
        }
    };
    EmployeeSearch.prototype.startCheckinProgram = function () {
        var _this = this;
        try {
            var data = this.share.getMapValues('startProgramData');
            this.startpayload.programId = data.id;
            this.startpayload.participantsType = 'INCLUDE_EVERYONE_IN';
            this.startpayload.employeeSearchFilter = this.searchData;
            var url = this._baseUrl + 'v1/webAdmin/checkins/activateCheckin';
            this.http.post(url, this.startpayload).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('progStarted').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 3000);
                }
                else {
                    _this.translate.get('errorWhileStartingProg').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 3000);
                }
            });
        }
        catch (e) {
            console.log('start program error catch', e);
        }
    };
    EmployeeSearch.prototype.getDismissReason = function (reason) {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        }
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        }
        else {
            return "with: " + reason;
        }
    };
    EmployeeSearch.prototype.ngOnInit = function () {
    };
    EmployeeSearch.prototype.addEmployees = function () {
        this.share.saveData({ employeeId: null, type: 'ADD' });
        this.router.navigate(['menu/addEmployee']);
    };
    //patch for pop-over issue
    EmployeeSearch.prototype.clickOut = function (event) {
        var _this = this;
        if (this.eRef.nativeElement.contains(event.target)) {
        }
        else {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    EmployeeSearch.prototype.clicked = function () {
        this.trackHides = null;
    };
    EmployeeSearch.prototype.closeEmployeeFilter = function () {
        this._auth.closeFilter();
    };
    //Show Advance Search 
    EmployeeSearch.prototype.showAdvanced = function (e) {
        this.showAdvanceSearch = e;
    };
    EmployeeSearch.prototype.searchEmployeeCods = function (e) {
        if (e == "") {
            this.searchData.employeeCodes = [];
        }
        else {
            this.searchData.employeeCodes[0] = e;
        }
    };
    //to get list of supervisor based on keyword
    EmployeeSearch.prototype.primarySupervisorObservableSource = function (keyword) {
        try {
            var payload = {
                searchString: null,
                excludeEmpIds: []
            };
            payload.searchString = keyword;
            var url = this._baseUrl + "v1/webAdmin/employee/supervisorSearch";
            if (keyword) {
                return this.http.post(url, payload)
                    .map(function (res) {
                    return res;
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        }
        catch (e) {
        }
    };
    EmployeeSearch.prototype.orgChange = function (e) {
        this.orgName = e.target.value;
    };
    EmployeeSearch.prototype.orgSelected = function () {
        if (this.orgName === '') {
            this.organizationModel = {
                id: null,
                orgName: ''
            };
            this.searchData.includeOrgIds = [];
        }
        else {
            if (this.organizationModel != '') {
                this.searchData.includeOrgIds = [this.organizationModel.id];
            }
            else {
                this.searchData.includeOrgIds = [];
            }
        }
    };
    EmployeeSearch.prototype.desigChange = function (e) {
        this.desigName = e.target.value;
    };
    EmployeeSearch.prototype.desigSelected = function () {
        if (this.desigName === '') {
            this.designationModel = {
                id: null,
                name: ''
            };
            this.searchData.designationIds = [];
        }
        else {
            if (this.designationModel != '') {
                this.searchData.designationIds = [this.designationModel.id];
            }
            else {
                this.searchData.designationIds = [];
            }
        }
    };
    EmployeeSearch.prototype.supChange = function (e) {
        this.displayName = e.target.value;
    };
    EmployeeSearch.prototype.supSelected = function () {
        if (this.displayName === '') {
            this.primarySupervisorModel = {
                id: null,
                displayName: ''
            };
            this.searchData.supervisorIds = [];
        }
        else {
            if (this.primarySupervisorModel != '') {
                this.searchData.supervisorIds = [this.primarySupervisorModel.id];
            }
            else {
                this.searchData.supervisorIds = [];
            }
        }
    };
    EmployeeSearch.prototype.gotNewValue = function (e, type) {
        var d;
        if (e.id != undefined) {
            d = (e.id.toString());
        }
        if (type == 'designation') {
            if (this.designationModel == "") {
                this.searchData.designationIds = [];
                return;
            }
            this.searchData.designationIds[0] = d;
        }
        if (type == 'organization') {
            if (this.organizationModel == "") {
                this.searchData.includeOrgIds = [];
                return;
            }
            this.searchData.includeOrgIds[0] = d;
        }
        if (type == 'primary') {
            if (this.primarySupervisorModel == "") {
                this.searchData.supervisorIds = [];
                return;
            }
            this.searchData.supervisorIds[0] = d;
        }
    };
    EmployeeSearch.prototype.onStatusChange = function (e) {
        if (e == "") {
            this.searchData.employeeStatus = null;
            return;
        }
        else {
            this.searchData.employeeStatus = e;
        }
    };
    EmployeeSearch.prototype.getEmployeeDataByKeywords = function () {
        var self = this;
        self.showLoading = true;
        var url = self._baseUrl + "v1/webAdmin/employee/searchEmployee";
        self.http.post(url, this.searchData).subscribe(function (result) {
            self.employeeData = [];
            self.employeeData = result.content;
            self.employeePageData = result;
            self.showLoading = false;
        }, function (error) {
            console.log("getAllEmployeeData error catch", error);
        });
    };
    EmployeeSearch.prototype.getEmployee = function () {
        try {
            var self_1 = this;
            self_1.showLoading = true;
            var url = self_1._baseUrl + "v1/webAdmin/employee/searchActiveEmployee";
            this.searchData.employeeStatus = 1;
            self_1.http.post(url, this.searchData).subscribe(function (result) {
                self_1.employeeData = [];
                self_1.employeeData = result.content;
                self_1.employeePageData = result;
                self_1.showLoading = false;
            });
        }
        catch (e) {
            console.log("getAllEmployeeData error catch", e);
        }
    };
    EmployeeSearch.prototype.onPageSizeChange = function () {
        this.searchData.page = 1;
        this.getEmployee();
    };
    EmployeeSearch.prototype.empTableActions = function (value) {
        if (this.trackHides == value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    EmployeeSearch.prototype.empTableResetPwd = function (id) {
        this.trackHides = null;
        this.share.saveData(id);
        var modalRef = this.modalService.open(ResetPasswordPage, { windowClass: 'min-modal' });
    };
    EmployeeSearch.prototype.actionSuspend = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'SUSPEND' });
        var modalRef = this.modalService.open(ActionSuspend, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result == 'confirm') {
                _this.getEmployee();
            }
            else {
                // this.saveUpdateEmpRules(result);
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeeSearch.prototype.actionActive = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'ACTIVE' });
        var modalRef = this.modalService.open(ActionSuspend, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result == 'confirm') {
                _this.getEmployee();
            }
            else {
                // this.saveUpdateEmpRules(result);
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeeSearch.prototype.actionResign = function (id) {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'Resign',
            program: id
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result == 'confirmed') {
                _this.getEmployee();
            }
            else {
                // this.saveUpdateEmpRules(result);
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    EmployeeSearch.prototype.editEmployeeProfile = function (id) {
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'EDIT' });
        this.router.navigate(['menu/addEmployee']);
    };
    EmployeeSearch.prototype.assignSwitchUserPermission = function () {
        var _this = this;
        try {
            var payload = {};
            payload.employeeSearchFilter = this.searchData;
            payload.employeeSearchFilter.pageSize = null;
            var url = this._baseUrl + 'v1/webAdmin/switchEmpAccess/employeeId/' + this.switchEmployeeDetails.id;
            this.http.post(url, this.searchData).subscribe(function (result) {
                _this.translate.get('addedUser').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                    _this.router.navigate(['menu/employeesList']);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 500);
            });
        }
        catch (e) {
            console.log('start program error catch', e);
        }
    };
    EmployeeSearch.prototype.enrollEmployeesConfirm = function () {
        var _this = this;
        var confirmData = {
            type: 'Enroll'
        };
        this.share.saveData(confirmData);
        this.modalService.open(confirmation_ConfirmationComponent).result.then(function (result) {
            if (result == 'confirmed') {
                if (_this.enrollProgramType == 'PERFORMANCE_PROGRAM') {
                    _this.enrollEmployeesForPerformance();
                }
                if (_this.enrollProgramType == 'COMPETENCY_PROGRAM') {
                    _this.enrollEmployeesForCompetency();
                }
                if (_this.enrollProgramType == 'CHECKIN_PROGRAM') {
                    _this.enrollEmployeesForCheckin();
                }
            }
        }, function (reason) {
            _this.showButtonLoading = false;
            _this.closeResult = "Dismissed " + _this.getDismissReason(reason);
        });
    };
    EmployeeSearch.prototype.announcementEmployeeConfirm = function () {
        var _this = this;
        var confirmData = {
            type: 'announcement'
        };
        this.share.saveData(confirmData);
        this.modalService.open(confirmation_ConfirmationComponent).result.then(function (result) {
            if (result == 'confirmed') {
                if (_this.type == 'Announcement') {
                    _this.triggerAnnouncement();
                }
            }
        }, function (reason) {
            _this.showButtonLoading = false;
            _this.closeResult = "Dismissed " + _this.getDismissReason(reason);
        });
    };
    EmployeeSearch.prototype.enrollEmployeesForPerformance = function () {
        var _this = this;
        this.showButtonLoading = true;
        this.enrollEmployeesPayload.employeeSearchFilter = this.searchData;
        this.enrollEmployeesPayload.programId = this.enrollProgramId;
        delete this.enrollEmployeesPayload['type'];
        var url = this._baseUrl + 'v1/webAdmin/performance/enroll';
        this.http.post(url, this.enrollEmployeesPayload).subscribe(function (result) {
            var notExistEmp = [];
            if (result.success) {
                _this.translate.get('enrolledForValidEmployees').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 500);
            }
            else {
                var data = result.data;
                underscore["each"](data, function (val) {
                    if (val.validationMessage === 'NOT_EXIST_IN_SYSTEM') {
                        notExistEmp.push(val.empCodes);
                    }
                });
                _this.invalidEmp = notExistEmp;
                if (result.data[0].validationMessage === 'EMPLOYEES_ALREADY_INCLUDED_IN_PROGRAM') {
                    _this.translate.get('empIncludedAlready').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    return false;
                }
            }
        });
        this.showButtonLoading = false;
    };
    EmployeeSearch.prototype.enrollEmployeesForCompetency = function () {
        var _this = this;
        this.showButtonLoading = true;
        this.enrollCompetency.employeeSearchFilter = this.searchData;
        this.enrollCompetency.programId = this.enrollProgramId;
        // delete this.enrollEmployeesPayload['type'];
        var url = this._baseUrl + 'v1/webAdmin/competency/enroll';
        var data = {
            employeeCodes: this.empCodeValues.split(','),
            programId: this.programId
        };
        this.http.post(url, this.enrollCompetency).subscribe(function (result) {
            var notExistEmp = [];
            if (result.success) {
                _this.translate.get('enrolledForValidEmployees').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 500);
            }
            else {
                var data_1 = result.data;
                underscore["each"](data_1, function (val) {
                    if (val.validationMessage === 'NOT_EXIST_IN_SYSTEM') {
                        notExistEmp.push(val.empCodes);
                    }
                });
                _this.invalidEmp = notExistEmp;
                if (result.data[0].validationMessage === 'EMPLOYEES_ALREADY_INCLUDED_IN_PROGRAM') {
                    _this.translate.get('empIncludedAlready').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    return false;
                }
            }
        });
        this.showButtonLoading = false;
    };
    EmployeeSearch.prototype.enrollEmployeesForCheckin = function () {
        var _this = this;
        this.showButtonLoading = true;
        this.enrollCompetency.employeeSearchFilter = this.searchData;
        this.enrollCompetency.programId = this.enrollProgramId;
        // delete this.enrollEmployeesPayload['type'];
        var url = this._baseUrl + 'v1/webAdmin/checkins/enroll';
        var data = {
            employeeCodes: this.empCodeValues.split(','),
            programId: this.programId
        };
        this.http.post(url, this.enrollCompetency).subscribe(function (result) {
            var notExistEmp = [];
            if (result.success) {
                _this.translate.get('enrolledForValidEmployees').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 500);
            }
            else {
                var data_2 = result.data;
                underscore["each"](data_2, function (val) {
                    if (val.validationMessage === 'NOT_EXIST_IN_SYSTEM') {
                        notExistEmp.push(val.empCodes);
                    }
                });
                _this.invalidEmp = notExistEmp;
                if (result.data[0].validationMessage === 'EMPLOYEES_ALREADY_INCLUDED_IN_PROGRAM') {
                    _this.translate.get('empIncludedAlready').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    return false;
                }
            }
        });
        this.showButtonLoading = false;
    };
    return EmployeeSearch;
}());



// CONCATENATED MODULE: ./src/app/menu/menu.ts

var menu_MenuComponent = /*@__PURE__*/ (function () {
    function MenuComponent(router, _per, translate) {
        var _this = this;
        this.router = router;
        this._per = _per;
        this.translate = translate;
        this.loaderEnable = false;
        this.router.events.subscribe(function (event) {
            if (event instanceof fesm5_router["d" /* NavigationStart */]) {
                if (event.url === "/menu") {
                    _this.loaderEnable = true;
                    _this.navToHome();
                }
            }
        });
    }
    MenuComponent.prototype.ngOnInit = function () {
        var location = window.location.href.split('#');
        if (location.length > 1 && location[1] !== "/menu") {
            this.router.navigate([location[1]]);
        }
        else if (this._per.checkForPermission('EMPLOYEE_ADMIN')) {
            this.router.navigate(['menu/employeesList']);
        }
        else if (this._per.checkForPermission('ORG_ADMIN')) {
            this.router.navigate(['menu/organizationList']);
        }
        else if (this._per.checkForPermission('GRADE_ADMIN')) {
            this.router.navigate(['menu/gradeList']);
        }
        else if (this._per.checkForPermission('MANAGERLEVEL_ADMIN')) {
            this.router.navigate(['menu/mgrLevelList']);
        }
        else if (this._per.checkForPermission('DESIGNATION_ADMIN')) {
            this.router.navigate(['menu/designationList']);
        }
        else if (this._per.checkForPermission('CATEGORY_ADMIN')) {
            this.router.navigate(['menu/empTypeList']);
        }
        else if (this._per.checkForPermission('ROLE_ADMIN')) {
            this.router.navigate(['menu/rolesAndPermission']);
        }
        else if (this._per.checkForPermission('COB_ADMIN')) {
            this.router.navigate(['menu/cob']);
        }
        else if (this._per.checkForPermission('ANNOUNCEMENT_ADMIN')) {
            this.router.navigate(['menu/announcementProgram']);
        }
        else if (this._per.checkForPermission('TENANT_CONFIG')) {
            this.router.navigate(['menu/tenantPreference']);
        }
        else if (this._per.checkForPermission('TENANT_MANAGEMENT')) {
            this.router.navigate(['menu/tenantManagement']);
        }
        else if (this._per.checkForPermission('USER_GROUP')) {
            this.router.navigate(['menu/userGroup']);
        }
        else if (this._per.checkForPermission('passwordPolicy')) {
            this.router.navigate(['menu/passwordPolicy']);
        }
        else if (this._per.checkForPermission('EMP_BULK_EMPLOYEE_RESIGN')) {
            this.router.navigate(['menu/bulkResignUpload']);
        }
    };
    MenuComponent.prototype.navToBusinessRakingUint = function () {
        window.location.href = "../home/#/admin-component/moderation/businessUnitListModule/businessUnitList";
    };
    MenuComponent.prototype.navToStrategyMap = function () {
        window.location.href = "../home/#/admin-component/strategyModule/strategyListModule/strategyList";
    };
    MenuComponent.prototype.navToTaskManagementConfig = function () {
        window.location.href = "../home/#/admin-component/taskManagementConfigModule/taskManagementConfig";
    };
    MenuComponent.prototype.navToHome = function () {
        window.location.href = "../home/#/hub";
    };
    return MenuComponent;
}());



// CONCATENATED MODULE: ./src/app/no-content/no-content.component.ts
var NoContentComponent = /*@__PURE__*/ (function () {
    function NoContentComponent() {
    }
    return NoContentComponent;
}());



// CONCATENATED MODULE: ./src/app/no-content/index.ts


// CONCATENATED MODULE: ./src/app/programManagement/announcements/announcements.ts





var announcements_Announcements = /*@__PURE__*/ (function () {
    function Announcements(route, modalService, activeModal, router, _global, http, share, _location, translate, _toaster, vcr, quill) {
        this.route = route;
        this.modalService = modalService;
        this.activeModal = activeModal;
        this.router = router;
        this._global = _global;
        this.http = http;
        this.share = share;
        this._location = _location;
        this.translate = translate;
        this._toaster = _toaster;
        this.vcr = vcr;
        this.quill = quill;
        this.selected = [];
        this.filteredList = [];
        this.query = "";
        this.sendEmail = false;
        this.announcementData = {
            videoURL: [],
            textContent: null,
            attachmentList: [],
            title: null,
            triggerDtm: null
        };
        this.safe = true;
        this.selectEmployeeOption = 1;
        this.disabledTextarea = true;
        this.disTextArea = true;
        this.buttonStatus = false;
        this.scheduleButton = false;
        this.validate = 1;
        this.payload = {
            programId: null,
            employeeCodes: null,
            participantsType: null
        };
        this.showButtonLoading = false;
        this.empCodeValues = "";
        this.empCodeList = [];
        this.searchData = {
            nameOrCodeOrEmail: "",
            employeeCodes: [],
            excludedEmployeeCodes: [],
            includeEmpIds: [],
            excludeEmpIds: [],
            gradeIds: [],
            mgrLevelIds: [],
            designationIds: [],
            categoryIds: [],
            includeOrgIds: [],
            excludeOrgIds: [],
            supervisorIds: [],
            primarySupervisorIds: [],
            primarySupervisorNameOrCode: null,
            primarySupervisorCods: [],
            employeeStatus: null,
            employeesWithOutSupervisor: null,
            scorecardStates: null,
            memberShipState: null,
            programId: null,
            pageSize: 10,
            page: 1,
            fetchSupervisorLevels: 0
        };
        this.minStartDate = {};
        this.savedImages = [];
        this.announcementContent = [];
        this.allurl = [];
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this._toaster.setViewRef(vcr);
        if (this.share.getMapValues("announcement")) {
            this.announcementData = this.share.getMapValues("announcement");
        }
        if (this.share.getMapValues("allurlImageData")) {
            this.allurl = this.share.getMapValues("allurlImageData");
        }
        if (this.share.getMapValues("videoLink")) {
            this.videoLink = this.share.getMapValues("videoLink");
        }
    }
    Announcements.prototype.onEmployeeSelectionChange = function (option) {
        if (option == 1) {
            this.disabledTextarea = true;
            this.disTextArea = true;
        }
        else if (option == 2) {
            this.disabledTextarea = false;
            this.disTextArea = true;
        }
        else {
            this.disabledTextarea = false;
            this.disTextArea = false;
            this.share.saveData(this.announcementData);
        }
        this.selectEmployeeOption = option;
    };
    Announcements.prototype.validateEmps = function (flag) {
        if (flag == 1) {
            if (!this.getAnnouncementData()) {
                if (this.validateData()) {
                    this.triggerAnnouncement();
                }
            }
        }
        else {
            if (!this.getAnnouncementData()) {
                if (this.validateData()) {
                    this.scheduleAnnouncement(this.announcementData);
                }
            }
        }
    };
    Announcements.prototype.validateData = function () {
        var _this = this;
        if (!this.announcementData.title) {
            this.translate.get("enterAnnouncementTitle").subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    };
    Announcements.prototype.select = function (item) {
        this.selected.push(item);
        this.query = "";
        this.filteredList = [];
    };
    Announcements.prototype.remove = function (item) {
        var fList = this.filteredList;
        underscore["each"](fList, function (key, val) {
            if (fList[val].id == item.id) {
                fList[val].checked = false;
            }
        });
        this.filteredList = [];
        this.filteredList = fList;
        this.selected.splice(this.selected.indexOf(item), 1);
    };
    Announcements.prototype.filter = function (keyword) {
        var _this = this;
        this.filteredList = [];
        var url = this._baseUrl + "v1/webAdmin/announcement/groupSearch";
        if (keyword.trim()) {
            url += "?searchString=" + keyword;
            this.http.get(url).subscribe(function (res) {
                _this.formatList(res);
            });
        }
        else {
            this.filteredList = [];
        }
    };
    Announcements.prototype.formatList = function (newArray) {
        var demo = [];
        var alreadySelected = this.selected;
        underscore["map"](newArray, function (key, val) {
            newArray[val].checked = false;
            demo.push(newArray[val]);
        });
        if (alreadySelected.length > 0) {
            underscore["each"](newArray, function (newkey, newval) {
                underscore["each"](alreadySelected, function (key, val) {
                    if (newArray[newval].id === alreadySelected[val].id) {
                        newArray[newval].checked = true;
                    }
                });
            });
        }
        this.filteredList = demo;
    };
    Announcements.prototype.change = function (event, item) {
        if (event.target.checked) {
            this.selected.push(item);
        }
        else {
            this.selected.splice(this.selected.indexOf(item), 1);
        }
    };
    Announcements.prototype.editorContent = function () {
        if (document.getElementsByClassName("ql-editor").length > 0 &&
            document.getElementsByClassName("ql-editor")[0].innerHTML != "<p><br></p>") {
            return true;
        }
        return false;
    };
    Announcements.prototype.getAnnouncementData = function () {
        var _this = this;
        if (this.allurl.length > 0 ||
            this.editorContent() || this.videoLink) {
            if (this.getTextOrLinkData()) {
                return true;
            }
        }
        else {
            this.showButtonLoading = true;
            this.translate.get("fillToProceedAnnouncement").subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return true;
        }
        this.showButtonLoading = false;
    };
    Announcements.prototype.getTextOrLinkData = function () {
        var _this = this;
        var documentElement = document.getElementsByClassName("ql-editor")[0].innerHTML;
        if (documentElement.trim() != "") {
            if (documentElement.search("<img") != -1) {
                var innerText = document.getElementsByClassName("ql-editor")[0].children;
                this.announcementContent = [];
                for (var i = 0; i < innerText.length; i++) {
                    var nodeText = innerText[i].childNodes;
                    for (var j = 0; j < nodeText.length; j++) {
                        if (nodeText[j].textContent !== '') {
                            this.announcementContent.push(nodeText[j].textContent);
                        }
                    }
                }
                this.announcementData.textContent = this.announcementContent.toString();
            }
            else if (documentElement.search("iframe") != -1) {
                this.announcementData.textContent = documentElement.split("<iframe")[0];
            }
            else {
                this.announcementData.textContent = documentElement;
            }
            if (documentElement.search("<img") != -1 && documentElement.search("iframe") != -1) {
                if (documentElement.search("<img") != -1) {
                    this.announcementData.textContent = documentElement.split("<img")[0];
                }
                if (this.announcementData.textContent.search("iframe") != -1) {
                    this.announcementData.textContent = this.announcementData.textContent.split("<iframe")[0];
                }
            }
            return false;
        }
        else {
            this.translate.get("fillToProceedAnnouncement").subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return true;
        }
    };
    Announcements.prototype.triggerAnnouncement = function () {
        var _this = this;
        if (this.safe == true) {
            var self_1 = this;
            this.buttonStatus = true;
            this.scheduleButton = true;
            var url = self_1._baseUrl + "v1/webAdmin/announcement/postAnnouncement";
            if (this.videoLink) {
                var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                var match = this.videoLink.match(regExp);
                if (match && match[2].length == 11) {
                    this.videoLink = "https://www.youtube.com/embed/" + match[2] + "?rel=0&modestbranding=1&autohide=1&autoplay=0";
                }
                this.announcementData.videoURL.push(this.videoLink);
            }
            if (this.announcementData.textContent.length > 5000) {
                this.translate.get("charLimitExceed").subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                this.buttonStatus = false;
            }
            else if (this.announcementData.title.length > 500) {
                this.translate.get("titleLimitExceed").subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                this.buttonStatus = false;
            }
            else {
                self_1.check(url).subscribe(function (result) {
                    _this.translate.get("announcementSuccessfull").subscribe(function (msg) {
                        console.log(result);
                        _this._toaster.showSuccess(msg);
                        _this.buttonStatus = false;
                        _this.goToBackPage();
                    });
                    _this.searchData.employeeCodes = [];
                    _this.searchData.excludedEmployeeCodes = [];
                }, function (error) {
                    _this.translate.get("errorWhileAnnouncement").subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    setTimeout(function () { return self_1.goToBackPage(); }, 1000);
                });
            }
        }
        else {
            this.translate.get("invalidVideoUrl").subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
        }
    };
    Announcements.prototype.check = function (url) {
        var self = this;
        try {
            return Observable["a" /* Observable */].create(function (observer) {
                self.announcementData.triggerDtm = null;
                var obs = Object(_esm5["p" /* forkJoin */])([
                    self.http.post(url, self.announcementData)
                ]);
                obs.subscribe(function (response) {
                    observer.next(response);
                    observer.complete();
                });
            });
        }
        catch (e) {
            console.log("getAllEmployeeData error catch", e);
        }
    };
    Announcements.prototype.showAdvanced = function () {
        var _this = this;
        if (!this.getAnnouncementData()) {
            if (this.announcementData.title == null ||
                this.announcementData.title == "") {
                this.translate.get("enterMandatoryFields").subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                return false;
            }
            else {
                this.share.saveAsMap("announcement", this.announcementData);
                this.share.saveAsMap("allurlImageData", this.allurl);
                this.share.saveAsMap("videoLink", this.videoLink);
                this.router.navigate(["menu/employeeSearch"]);
            }
        }
    };
    Announcements.prototype.showError = function (data) {
        var self = this;
        self._toaster.showError("Invalid input/employee codes : " + data[0]);
        self.buttonStatus = false;
        self.scheduleButton = false;
        self.announcementData.videoURL = [];
        self.announcementData.attachmentList = [];
    };
    Announcements.prototype.goToBackPage = function () {
        this.announcementData.title = null;
        this.announcementData.attachmentList = [];
        this.announcementData.textContent = null;
        this.announcementData.videoURL = [];
        this.videoLink = '';
        this.allurl = [];
        this.empCodeValues = "";
        if (document.getElementsByClassName("ql-editor").length != 0) {
            document.getElementsByClassName("ql-editor")[0].innerHTML = "<p><br></p>";
        }
        this.buttonStatus = false;
        this.scheduleButton = false;
        this.query = "";
        this.selected.length = 0;
        this.filteredList = [];
    };
    Announcements.prototype.scheduleAnnouncement = function (announcementData) {
        var _this = this;
        announcementData.employeeSearchFilter = this.searchData;
        this.share.saveData(announcementData);
        this.modalService.open(scheduleAnnouncement_ScheduleAnnouncement).result.then(function (result) {
            _this.closeResult = "Closed with: " + result;
            if (result == "confirmed") {
                _this.goToBackPage();
            }
        }, function (reason) {
            _this.closeResult = "Dismissed " + _this.getDismissReason(reason);
        });
    };
    Announcements.prototype.getDismissReason = function (reason) {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        }
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        }
        else {
            return "with: " + reason;
        }
    };
    Announcements.prototype.disableKey = function () {
        document.onkeydown = function (e) {
            return false;
        };
    };
    Announcements.prototype.enableKey = function () {
        document.onkeydown = function (e) {
            return true;
        };
    };
    Announcements.prototype.fileChange = function (event) {
        var _this = this;
        debugger;
        var fileList = event.target.files;
        var result;
        if (fileList.length > 0) {
            var mimeType = fileList[0].type;
            if (mimeType.match(/image\/*/) == null) {
                this.translate.get("ImageInvalid").subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                return;
            }
            var file = fileList[0];
            var reader = new FileReader();
            var fileName_1 = file.name;
            var path_1 = event.target.value;
            reader.onloadend = function (e) {
                result = e.target.result;
                _this.getAllData(path_1, fileName_1, result);
            };
            reader.readAsBinaryString(file);
        }
    };
    Announcements.prototype.getAllData = function (path, fileName, result) {
        var ext = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
        var attachmentJson = {
            docName: fileName,
            docType: ext,
            document: window.btoa(result)
        };
        this.announcementData.attachmentList.push(attachmentJson);
    };
    Announcements.prototype.readUrl = function (event) {
        var _this = this;
        console.log(event.target.files);
        if (event.target.files && event.target.files[0]) {
            var mimeType = event.target.files[0].type;
            if (mimeType.match(/image\/*/) == null) {
                return;
            }
            var reader = new FileReader();
            reader.onload = function (ProgressEvent) {
                _this.url = ProgressEvent.target.result;
                _this.allurl.push(ProgressEvent.target.result);
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    };
    Announcements.prototype.deletepic = function (index) {
        this.announcementData.attachmentList.splice(index, 1);
        this.allurl.splice(index, 1);
    };
    Announcements.prototype.onBlurMethod = function (vid) {
        var _this = this;
        this.invalidURL = false;
        if (vid != undefined) {
            var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
            if (!vid.match(p)) {
                this.videoLink = '';
                this.invalidURL = true;
                this.translate.get("invalidVideoUrl").subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                return false;
            }
        }
    };
    return Announcements;
}());



// CONCATENATED MODULE: ./src/app/superAdmin/createTenant.ts

var createTenant_CreateTenantComponent = /*@__PURE__*/ (function () {
    function CreateTenantComponent(router, _per, _global, http, translate, _toaster, vcr, _location) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this._toaster = _toaster;
        this._location = _location;
        this.lang = [];
        this.modules = [];
        this.buttonDisabled = false;
        this.urlExt = '.entomo.co';
        this.itemLangList = [];
        this.selectedLangItems = [];
        this.langSettings = {};
        this.createNewTenantData = {
            orgName: null,
            shortName: null,
            appName: null,
            baseUrl: null,
            firstName: null,
            lastName: null,
            displayName: null,
            email: null,
            userName: null,
            languageIds: [],
            fireBaseServerKey: null,
            timeZone: 'GMT+05:30'
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllApps();
    }
    CreateTenantComponent.prototype.getAllApps = function () {
        var self = this;
        var url = self._baseUrl + 'v1/superAdmin/mobAppManagement/getAllMobileApp';
        self.http.post(url, { page: 0, pageSize: 100 }).subscribe(function (result) {
            self.apps = result.content;
        }, function (error) {
            console.log('Error:', error);
        });
    };
    CreateTenantComponent.prototype.ngOnInit = function () {
        this.getLanguage();
        this.loadTenantModules();
        this.langSettings = { text: 'Select Language',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: '',
            primaryKey: 'id',
            labelKey: 'name',
        };
    };
    CreateTenantComponent.prototype.createNewTenant = function () {
        var _this = this;
        var that = this;
        that.buttonDisabled = true;
        that.populateSelectedModules();
        that.addLanguage();
        if (this.selectedApp) {
            this.apps.forEach(function (app) {
                if (_this.selectedApp === app.id) {
                    _this.createNewTenantData.appName = app.mobileAppKey;
                    _this.createNewTenantData.fireBaseServerKey = app.fireBaseKey;
                }
            });
        }
        if (that.validateNewTenant() && that.validateSelectedModules()) {
            that.createNewTenantData.baseUrl = that.beforeAppending + that.urlExt;
            var url = that._baseUrl + 'v1/superAdmin/tenant/createTenant';
            that.http.post(url, that.createNewTenantData).subscribe(function (result) {
                _this.translate.get('tenantCreated').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                that.buttonDisabled = false;
                setTimeout(function () { that.goBack(); }, 500);
            }, function (error) {
                for (var i = 0; i < error.error.length; i++) {
                    if (error.error[i].defaultMessage == 'SHOULD_NOT_EMPTY') {
                        _this.translate.get('mandNotEmpty').subscribe(function (msg) {
                            _this._toaster.showError(msg);
                        });
                    }
                    else if (error.error[i].defaultMessage == 'BASE_URL_NOT_AVAILABLE') {
                        _this.translate.get('baseUrlNotAvailable').subscribe(function (msg) {
                            _this._toaster.showError(msg);
                        });
                    }
                    else if (error.error[i].defaultMessage == 'EMAIL_OR_USERNAME_NOT_EXIST') {
                        _this.translate.get('emailOrUserDifferent').subscribe(function (msg) {
                            _this._toaster.showError(msg);
                        });
                    }
                    that.buttonDisabled = false;
                    //   break;
                }
            });
        }
    };
    CreateTenantComponent.prototype.populateSelectedModules = function () {
        this.createNewTenantData.selectedModules = [];
        var mod;
        for (var _i = 0, _a = this.modules; _i < _a.length; _i++) {
            mod = _a[_i];
            if (mod.assigned) {
                this.createNewTenantData.selectedModules.push(mod.operation);
            }
        }
    };
    CreateTenantComponent.prototype.validateSelectedModules = function () {
        var _this = this;
        if (this.createNewTenantData.selectedModules.length === 0) {
            this.translate.get('selectOneModule').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        else {
            return true;
        }
    };
    CreateTenantComponent.prototype.validateNewTenant = function () {
        var _this = this;
        var that = this;
        if (!that.createNewTenantData.orgName) {
            this.translate.get('pleaseEnterTenantName').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        if (!that.createNewTenantData.shortName) {
            this.translate.get('pleaseEnterTenantShortName').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        if (!that.createNewTenantData.appName) {
            this.translate.get('pleaseSelectAppName').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        if (!that.beforeAppending) {
            this.translate.get('pleaseEnterBaseUrl').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        if (!that.createNewTenantData.displayName) {
            this.translate.get('pleaseEnterDisplayName').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        if (!that.createNewTenantData.userName) {
            this.translate.get('pleaseEnterUserName').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        if (!that.createNewTenantData.email) {
            this.translate.get('pleaseEnterEmail').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        if (!that.createNewTenantData.timeZone) {
            this.translate.get('selectTimeZone').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        if (that.createNewTenantData.languageIds.length == 0) {
            this.translate.get('selectLanguage').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            that.buttonDisabled = false;
            return false;
        }
        return true;
    };
    CreateTenantComponent.prototype.loadTenantModules = function () {
        var that = this;
        var url = that._baseUrl + 'v1/superAdmin/tenant/loadTenantModules';
        that.http.get(url).subscribe(function (result) {
            that.modules = result;
        }, function (error) {
            that.modules = [];
        });
    };
    CreateTenantComponent.prototype.omit_special_char = function (event) {
        var k;
        k = event.charCode; //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || (k >= 48 && k <= 57));
    };
    CreateTenantComponent.prototype.getLanguage = function () {
        var _this = this;
        var that = this;
        var url = that._baseUrl + 'v1/hub/sys/getAllLang';
        that.http.get(url).subscribe(function (result) {
            that.lang = result;
            that.itemLangList = that.lang;
            underscore["each"](_this.lang, function (key, value) {
                if (key.name == 'ENGLISH') {
                    that.createNewTenantData.languageId = key.id;
                }
            });
        }, function (error) {
            that.lang = [];
            console.log(error);
        });
    };
    CreateTenantComponent.prototype.goBack = function () {
        this._location.back();
    };
    CreateTenantComponent.prototype.copyToUsername = function (e) {
        this.createNewTenantData.userName = e;
    };
    CreateTenantComponent.prototype.onBlurEmailExist = function (userName, email) {
        var self = this;
        var url = self._baseUrl + "v1/superAdmin/tenant/isUsernameAvailable/userName/" + userName + "/email/" + email;
        self.http.get(url).subscribe(function (result) {
            self.emailExist = result;
            if (self.emailExist) {
                self.createNewTenantData.email = null;
                self.translate.get('emailExist').subscribe(function (msg) {
                    self._toaster.showError(msg);
                });
            }
        }, (function (error) {
            self.emailExist;
            console.log(error);
        }));
    };
    CreateTenantComponent.prototype.onBlurTenantBaseUrl = function (tenantBaseUrl) {
        var self = this;
        var tenantKpiUrl = tenantBaseUrl + '.kpisoft.com';
        var url = self._baseUrl + "v1/superAdmin/tenant/tenantBaseUrlExist?tenantBaseUrl=" + tenantKpiUrl;
        self.http.get(url).subscribe(function (result) {
            self.tenantBaseUrlExist = result;
            if (self.tenantBaseUrlExist) {
                self.createNewTenantData.baseUrl = null;
                self.translate.get('baseUrlExist').subscribe(function (msg) {
                    self._toaster.showError(msg);
                });
            }
        }, (function (error) {
            self.tenantBaseUrlExist;
            console.log(error);
        }));
    };
    CreateTenantComponent.prototype.addLanguage = function () {
        for (var i = 0; i < this.selectedLangItems.length; i++) {
            this.createNewTenantData.languageIds.push(this.selectedLangItems[i].id);
        }
    };
    return CreateTenantComponent;
}());



// CONCATENATED MODULE: ./src/app/superAdmin/tenantManagement.ts
var TenantManagementComponent = /*@__PURE__*/ (function () {
    function TenantManagementComponent(router, _per, _global, translate, http) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.translate = translate;
        this.http = http;
        this.tenantData = [];
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this._baseUrl = _global.get('EPMS_BASE_URL');
    }
    TenantManagementComponent.prototype.ngOnInit = function () {
        this.getAllTenantData();
    };
    TenantManagementComponent.prototype.newTenant = function () {
        this.router.navigate(['./menu/createTenant']);
    };
    TenantManagementComponent.prototype.editTenant = function (tenantId) {
        localStorage.setItem('tenantId', tenantId);
        this.router.navigate(['./menu/updateTenant']);
    };
    TenantManagementComponent.prototype.tableActions = function (i) {
        this.trackHides = i;
    };
    TenantManagementComponent.prototype.getAllTenantData = function () {
        var that = this;
        var url = that._baseUrl + 'v1/superAdmin/tenant/search';
        that.http.post(url, { page: that.page, pageSize: that.pageSize })
            .subscribe(function (result) {
            that.tenantData = result.content;
            that.collectionSize = result.totalElements;
            if (result.last) {
                that.endingPage = that.collectionSize;
            }
        }, function (error) {
            console.log('Not able to load tenant data');
        });
    };
    // pagination functions
    TenantManagementComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllTenantData();
    };
    TenantManagementComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllTenantData();
    };
    return TenantManagementComponent;
}());



// CONCATENATED MODULE: ./src/app/superAdmin/updateTenant.ts

var updateTenant_UpdateTenantComponent = /*@__PURE__*/ (function () {
    function UpdateTenantComponent(router, _per, _global, http, _toaster, vcr, _location, translate, _sanitizer) {
        var _this = this;
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this._toaster = _toaster;
        this._location = _location;
        this.translate = translate;
        this._sanitizer = _sanitizer;
        this.lang = [];
        this.modules = [];
        this.buttonDisabled = false;
        this.selectedLangItems = [];
        this.itemLangList = [];
        this.langSettings = {};
        this.languages = [];
        this.apps = [
            { name: 'Dev Update', value: 'DEV_UPDATE' },
            { name: 'Dev skylark', value: 'DEV_SKYLARK' },
            {}
        ];
        this.primaryAdmin = null;
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.displayName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.tenantId = localStorage.getItem('tenantId');
        this.getAllApps();
    }
    UpdateTenantComponent.prototype.ngOnInit = function () {
        this.getLanguage();
        this.loadTenantInfo();
        this.langSettings = {
            text: 'Select Language',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: '',
            primaryKey: 'id',
            labelKey: 'name',
        };
    };
    UpdateTenantComponent.prototype.getAllApps = function () {
        var self = this;
        var url = self._baseUrl + 'v1/superAdmin/mobAppManagement/getAllMobileApp';
        self.http.post(url, { page: 0, pageSize: 100 }).subscribe(function (result) {
            self.apps = result.content;
        }, function (error) {
            console.log('Error:', error);
        });
    };
    UpdateTenantComponent.prototype.loadTenantInfo = function () {
        var _this = this;
        var that = this;
        var url = that._baseUrl + 'v1/superAdmin/tenant/loadTenantToEdit/' + this.tenantId;
        that.http.get(url).subscribe(function (result) {
            that.editTenantData = result;
            that.modules = that.editTenantData.modules;
            that.editTenantData.modules = [];
            if (that.primaryAdmin == null) {
                that.primaryAdmin = {};
            }
            that.primaryAdmin.id = that.editTenantData.primaryAdminId;
            that.primaryAdmin.displayName = that.editTenantData.primaryAdminName;
            _this.setTenantLang();
        }, function (error) {
            _this.translate.get('notAbleToLoad').subscribe(function (msg) {
                that._toaster.showError(msg);
            });
            that.goBack();
        });
    };
    UpdateTenantComponent.prototype.setTenantLang = function () {
        for (var i = 0; i < this.editTenantData.languages.length; i++) {
            this.selectedLangItems.push(this.editTenantData.languages[i].sysLang);
        }
        this.languages = this.editTenantData.languages;
    };
    UpdateTenantComponent.prototype.primaryAdminSource = function (keyword) {
        var url = this._baseUrl + 'v1/superAdmin/tenant/searchEmployee/' + this.tenantId;
        if (keyword.trim()) {
            var payload = { searchString: keyword };
            return this.http.post(url, payload)
                .map(function (res) {
                return res;
            }, function (error) {
                console.log(error);
                return Observable["a" /* Observable */].of([]);
            });
        }
        else {
            return Observable["a" /* Observable */].of([]);
        }
    };
    UpdateTenantComponent.prototype.adminSelected = function () {
        if (this.primaryAdmin != null) {
            this.editTenantData.primaryAdminId = this.primaryAdmin.id;
        }
        else {
            this.editTenantData.primaryAdminId = null;
        }
    };
    UpdateTenantComponent.prototype.adminChanged = function (event) {
        if (typeof this.primaryAdmin === 'string' || this.primaryAdmin instanceof String) {
            this.tenantForm.control.setErrors({ incorrect: true });
        }
    };
    UpdateTenantComponent.prototype.updateTenant = function () {
        var _this = this;
        var that = this;
        this.populateSelectedModules();
        that.addLanguage();
        if (that.validateNewTenant() && that.validateSelectedModules()) {
            that.buttonDisabled = true;
            var url = that._baseUrl + 'v1/superAdmin/tenant/updateTenant';
            that.http.post(url, that.editTenantData).subscribe(function (result) {
                _this.translate.get('tenantUpdated').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
                that.buttonDisabled = false;
                setTimeout(function () { that.goBack(); }, 500);
            }, function (error) {
                that.buttonDisabled = false;
            });
        }
    };
    UpdateTenantComponent.prototype.validateSelectedModules = function () {
        var _this = this;
        if (this.editTenantData.selectedModules.length === 0) {
            this.translate.get('selectOneModule').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        else {
            return true;
        }
    };
    UpdateTenantComponent.prototype.populateSelectedModules = function () {
        this.editTenantData.selectedModules = [];
        var mod;
        for (var _i = 0, _a = this.modules; _i < _a.length; _i++) {
            mod = _a[_i];
            if (mod.assigned) {
                this.editTenantData.selectedModules.push(mod.operation);
            }
        }
    };
    UpdateTenantComponent.prototype.validateNewTenant = function () {
        var _this = this;
        var that = this;
        if (that.editTenantData.timeZone.trim() === '') {
            this.translate.get('selectTimeZone').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (typeof this.primaryAdmin === 'string' || this.primaryAdmin instanceof String) {
            this.translate.get('selectPrimeAdmin').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (that.editTenantData.languages.length == 0 && that.editTenantData.languageId.length == 0) {
            this.translate.get('selectLanguage').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    };
    UpdateTenantComponent.prototype.getLanguage = function () {
        var that = this;
        var url = that._baseUrl + 'v1/hub/sys/getAllLang';
        that.http.get(url).subscribe(function (result) {
            that.lang = result;
            that.itemLangList = that.lang;
        }, function (error) {
            that.lang = [];
            console.log(error);
        });
    };
    UpdateTenantComponent.prototype.goBack = function () {
        this._location.back();
    };
    UpdateTenantComponent.prototype.setTenantLanguage = function () {
        for (var i = 0; i < this.editTenantData.languageIds.length; i++) {
            for (var j = 0; j < this.lang.length; j++) {
                if (this.editTenantData.languageIds[i] == this.lang[j].id) {
                    this.selectedLangItems.push(this.lang[j]);
                }
            }
        }
    };
    UpdateTenantComponent.prototype.addLanguage = function () {
        this.editTenantData.languages = [];
        this.editTenantData.languageId = [];
        var added = false;
        for (var i = 0; i < this.selectedLangItems.length; i++) {
            added = false;
            for (var j = 0; j < this.languages.length; j++) {
                if (this.selectedLangItems[i].id == this.languages[j].sysLang.id) {
                    added = true;
                    this.editTenantData.languages.push(this.languages[j]);
                    break;
                }
            }
            if (!added) {
                this.editTenantData.languageId.push(this.selectedLangItems[i].id);
            }
        }
    };
    return UpdateTenantComponent;
}());



// CONCATENATED MODULE: ./src/app/switchUser/switchUser.ts

var switchUser_SwitchUserComponent = /*@__PURE__*/ (function () {
    function SwitchUserComponent(router, _per, _global, http, _toaster, vcr, _auth, eRef, _location, _translate, _shareData) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this._toaster = _toaster;
        this.vcr = vcr;
        this._auth = _auth;
        this.eRef = eRef;
        this._location = _location;
        this._translate = _translate;
        this._shareData = _shareData;
        this.isHavingEmpCodes = true;
        this.showLoading = false;
        this.switchableUsers = [];
        this.switchableUsersCount = 0;
        this.employeeDetails = {};
        this.switchPage = 'selectSwitchableUsers';
        this.employeeIdStrList = [];
        this.page = 1;
        this.startCount = 0;
        this.endCount = 10;
        this.pageSize = 10;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        var data = this._shareData.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            if (data.employee == undefined) {
                this._location.back();
            }
            else {
                this.employeeDetails = data.employee;
                this.employeeId = this.employeeDetails.id;
                this.getEverySwitchableUsersData();
            }
        }
    }
    SwitchUserComponent.prototype.ngOnInit = function () {
    };
    SwitchUserComponent.prototype.showSearchFilter = function (event) {
        var searchData = event;
        this.clicked();
        this.searchInSwitchableUsers(searchData);
    };
    SwitchUserComponent.prototype.everyOneIn = function () {
        this.empArea = 3;
    };
    SwitchUserComponent.prototype.everyone = function () {
        this.empArea = null;
    };
    SwitchUserComponent.prototype.getEveryEmployee = function (isEmpCodeAvailable) {
        this.isHavingEmpCodes = isEmpCodeAvailable;
    };
    SwitchUserComponent.prototype.onPageChange = function (event) {
        this.page = event;
        this.selectedAllSwitchAble = false;
        if (event == 1) {
            this.startCount = 0;
            this.endCount = this.pageSize;
            if (this.endCount > this.totalCount) {
                this.endCount = this.totalCount;
            }
        }
        if (event > 1) {
            this.startCount = this.pageSize * (event - 1);
            this.endCount = this.startCount + this.pageSize;
            if (this.endCount > this.totalCount) {
                this.endCount = this.totalCount;
            }
        }
        this.getEverySwitchableUsersData();
    };
    SwitchUserComponent.prototype.getEverySwitchableUsersData = function () {
        var self = this;
        self.switchableUsers = [];
        self.employeeIdStrList = [];
        self.switchableUsersCount = 0;
        // self.totalCount = 0;
        if (this.employeeId) {
            var url = self._baseUrl + "v1/webAdmin/switchEmpAccess/employeeId/" + this.employeeId
                + '?page=' + this.page + '&pageSize=' + 10;
            self.http.get(url).subscribe(function (result) {
                if (result.dataList != null) {
                    self.switchableUsers = result.dataList;
                    self.switchableUsersCount = self.switchableUsers.length;
                }
                if (result.totalCount != null) {
                    self.totalCount = result.totalCount;
                }
                self.prepareDataForCheck(self.switchableUsers);
                self.showLoading = true;
            }, function (error) {
                console.log("getAllEmployeeData error catch", error);
            });
        }
    };
    SwitchUserComponent.prototype.prepareDataForCheck = function (switchableUsers) {
        underscore["each"](switchableUsers, function (user) {
            user['isChecked'] = false;
        });
    };
    SwitchUserComponent.prototype.selectAll = function () {
        var self = this;
        self.employeeIdStrList = [];
        underscore["each"](self.switchableUsers, function (user) {
            user.isChecked = !self.selectedAllSwitchAble;
            if (user.isChecked) {
                self.employeeIdStrList.push(user.employeeId);
            }
        });
    };
    SwitchUserComponent.prototype.unSelect = function (event, user) {
        user.isChecked = event.target.checked;
        this.getSelectedEmpCodes();
        this.selectedAllSwitchAble = this.switchableUsers.every(function (item) {
            return item.isChecked == true;
        });
    };
    SwitchUserComponent.prototype.getSelectedEmpCodes = function () {
        var self = this;
        self.employeeIdStrList = [];
        underscore["each"](self.switchableUsers, function (user) {
            if (user.isChecked) {
                self.employeeIdStrList.push(user.employeeId);
            }
        });
    };
    SwitchUserComponent.prototype.searchInSwitchableUsers = function (searchData) {
        var self = this;
        if (this.employeeId) {
            var url = self._baseUrl + "v1/webAdmin/switchEmpAccess/searchEmployees/employeeId/" + this.employeeId;
            self.http.post(url, searchData).subscribe(function (result) {
                if (result.dataList != null) {
                    self.switchableUsers = result.dataList;
                    self.switchableUsersCount = self.switchableUsers.length;
                }
                if (result.totalCount != null) {
                    self.totalCount = result.totalCount;
                }
                self.prepareDataForCheck(self.switchableUsers);
            }, function (error) {
                console.log("getAllEmployeeData error catch", error);
            });
        }
    };
    SwitchUserComponent.prototype.getSingleEmployeeData = function () {
        var self = this;
        self.showLoading = true;
        var url = self._baseUrl + "v1/switch/view";
        self.http.post(url, {}).subscribe(function (result) {
            self.switchableUsers = result.content;
            self.showLoading = false;
        }, function (error) {
            console.log("getAllEmployeeData error catch", error);
        });
    };
    SwitchUserComponent.prototype.changeEmployeeData = function () {
        var self = this;
        self.showLoading = true;
        var url = self._baseUrl + "v1/switch/change";
        self.http.post(url, {}).subscribe(function (result) {
            self.switchableUsers = result.content;
            self.showLoading = false;
        }, function (error) {
            console.log("getAllEmployeeData error catch", error);
        });
    };
    SwitchUserComponent.prototype.switchToAddSwitchableUsers = function () {
        // this.switchPage = 'getSwitchableUsers';
        this._shareData.saveData({ employee: this.employeeDetails, type: 'SWITCH' });
        this.router.navigate(['menu/addSwitchableUser']);
    };
    SwitchUserComponent.prototype.removeSelectedEmpPermission = function () {
        var self = this;
        if (self.employeeId) {
            var url = self._baseUrl + "v1/webAdmin/switchEmpAccess/deleteMultiple/employeeId/" + self.employeeId;
            self.http.post(url, self.employeeIdStrList).subscribe(function (result) {
                console.log('removeSelectedEmpPermission', result);
                self.selectedAllSwitchAble = false;
                self._translate.get('removedPermission').subscribe(function (msg) {
                    self._toaster.showSuccess(msg);
                });
                self.getEverySwitchableUsersData();
            }, function (error) {
                console.log("getAllEmployeeData error catch", error);
            });
        }
    };
    SwitchUserComponent.prototype.removeAllEmpPermission = function () {
        var _this = this;
        var self = this;
        if (self.employeeId) {
            var url = self._baseUrl + "v1/webAdmin/switchEmpAccess/deleteAll/employeeId/" + this.employeeId;
            self.http.delete(url).subscribe(function (result) {
                self._translate.get('removedPermission').subscribe(function (msg) {
                    self._toaster.showSuccess(msg);
                });
                setTimeout(function () { _this._location.back(); }, 300);
            }, function (error) {
                console.log("getAllEmployeeData error catch", error);
            });
        }
    };
    // Patch for pop-over issue
    SwitchUserComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 10);
        }
    };
    SwitchUserComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    SwitchUserComponent.prototype.closeEmployeeFilter = function () {
        this._auth.closeFilter();
    };
    return SwitchUserComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/addDesignation.ts




var addDesignation_AddDesignationComponent = /*@__PURE__*/ (function () {
    function AddDesignationComponent(route, modalService, _global, http, _sanitizer, builder, _auth, router, _location, share, _toaster, translate, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this.http = http;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.addOrgEvent = new core["EventEmitter"]();
        this.cancelEvent = new core["EventEmitter"]();
        this.arrayOfStrings = [];
        this.categoryData = [];
        this.oldValue = null;
        this.desgdata = {};
        this.type = 'ADD';
        this.empPresent = false;
        // tslint:disable-next-line:member-ordering
        this.payload = {
            searchString: '',
            excludeEmpIds: []
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListFormatterType = function (data) {
            var html = "<span>" + data.type + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        // To get list of designation based on keyword
        this.designationObservableSource = function (keyword) {
            if (keyword.trim()) {
                var url = _this._baseUrl + 'v1/webAdmin/designation/designationSearch';
                url += '?searchString=' + keyword.trim() + '&id=' + _this.desgdata.id;
                return _this.http.get(url)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this.autoCompleteListOrgTypeFormatter = function (data) {
            var html = "<span>" + data.orgUnitTypeName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            if (data.type === 'ADD') {
                this.data = {};
                this.type = 'ADD';
            }
            else if (data.type === 'EDIT') {
                this.desgdata = data.desgData;
                this.type = 'EDIT';
            }
            else {
                this.desgdata = data.desgData;
                this.type = 'DELETE';
                var url = this._baseUrl + 'v1/webAdmin/designation/check/' + this.desgdata.id;
                this.http.get(url).subscribe(function (result) {
                    if (result.success) {
                        _this.empPresent = true;
                    }
                    else {
                        _this.empPresent = false;
                    }
                });
            }
            this._toaster.setViewRef(vcr);
        }
    }
    // when auto-complete value is selected this method fires and payload create
    AddDesignationComponent.prototype.gotNewValue = function (e, type) {
        this.designationModel = e;
    };
    // Formatter
    AddDesignationComponent.prototype.nameValueFormatter = function (data) {
        return "" + data.name;
    };
    AddDesignationComponent.prototype.orgNameValueFormatter = function (data) {
        return "" + data.orgName;
    };
    // Navigate back
    AddDesignationComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    AddDesignationComponent.prototype.saveDesgData = function () {
        var _this = this;
        if (this.validateDesignation()) {
            var url = this._baseUrl + 'v1/webAdmin/designation/save';
            this.http.post(url, this.desgdata).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('designationSaved').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 1000);
                }
                else {
                    // this._toaster.showError('Error while adding Designation');
                    _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
            }, function (error) {
                _this.translate.get('errorWhileSavingDesignation').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
            });
        }
    };
    AddDesignationComponent.prototype.rangeLimit = function (event) {
        if (event.target.value.length > 11) {
            event.target.value.slice(0, 10);
        }
    };
    AddDesignationComponent.prototype.isEmpty = function (val) {
        return !val
            || (isString(val) && !val.trim());
    };
    AddDesignationComponent.prototype.deleteDesgData = function () {
        var _this = this;
        if (this.empPresent && this.isEmpty(this.designationModel)) {
            this.translate.get('altDesigToContinue').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        var url;
        if (this.empPresent) {
            url = this._baseUrl + 'v1/webAdmin/designation/' + this.desgdata.id
                + '?alternateId=' + this.designationModel.id;
        }
        else {
            url = this._baseUrl + 'v1/webAdmin/designation/' + this.desgdata.id;
        }
        this.http.delete(url).subscribe(function (result) {
            if (result.success) {
                _this.translate.get('desigDeletedSuccessfully').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 1000);
            }
            else {
                _this.translate.get('erroeWhileDeteleDesig').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                    var val = _a[_i];
                    _this._toaster.showError(val);
                }
            }
        });
    };
    AddDesignationComponent.prototype.validateDesignation = function () {
        var _this = this;
        if (!this.desgdata.name || !this.desgdata.name.trim()) {
            this.translate.get('pleaseEnterNameToContinue').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.desgdata.code || !this.desgdata.code.trim()) {
            this.translate.get('pleaseEnterDesigCodeToContinue').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.desgdata.level || this.desgdata.level < 1) {
            this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (this.desgdata.level > 100) {
            this.translate.get('pleaseEnterLevelLessHund').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    };
    return AddDesignationComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/organizationUnit/organizationUnit.ts

var organizationUnit_AddOrgUnitTypeComponent = /*@__PURE__*/ (function () {
    function AddOrgUnitTypeComponent(route, 
    //   public modalService: NgbModal,
    _global, http, 
    //   public _sanitizer: DomSanitizer,
    //   public builder: FormBuilder,
    //   public _auth: Auth,
    //   public router: Router,
    _location, share, _toaster, translate, vcr) {
        this.route = route;
        this._global = _global;
        this.http = http;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.OrganizationUnitTypeData = {
            id: null,
            orgUnitTypeCode: null,
            orgUnitTypeName: null,
            orgUnitTypeNameLocale: null,
            description: null,
            descriptionLocale: null,
            level: null
        };
        this._toaster.setViewRef(vcr);
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            if (data.type === 'ADD') {
                this.data = {};
                this.type = 'ADD';
            }
            else if (data.type === 'EDIT') {
                this.OrganizationUnitTypeData = data.OrganizationUnitTypeData;
                this.type = 'EDIT';
            }
            else {
                this.OrganizationUnitTypeData = data.OrganizationUnitTypeData;
                this.type = 'DELETE';
            }
            this._toaster.setViewRef(vcr);
        }
    }
    // when auto-complete value is selected this method fires and payload create
    // public gotNewValue(e, type) {
    //   this.designationModel = e;
    // }
    // Formatter
    // public nameValueFormatter(data: any): string {
    //   return `${data.name}`;
    // }
    // public orgNameValueFormatter(data: any): string {
    //   return `${data.orgName}`;
    // }
    // public autoCompleteListFormatter = (data: any): SafeHtml => {
    //   let html = `<span>${data.name}</span>`;
    //   return this._sanitizer.bypassSecurityTrustHtml(html);
    // }
    // public autoCompleteListFormatterType = (data: any): SafeHtml => {
    //   let html = `<span>${data.type}</span>`;
    //   return this._sanitizer.bypassSecurityTrustHtml(html);
    // }
    // // To get list of designation based on keyword
    // public designationObservableSource = (keyword: any): Observable<any[]> => {
    //   if (keyword.trim()) {
    //     let url = this._baseUrl + 'v1/webAdmin/designation/designationSearch';
    //     url += '?searchString=' + keyword.trim() + '&id=' + this.OrganizationUnitTypeData.id;
    //     return this.http.get(url)
    //       .map((res) => {
    //         return res;
    //       }, (error) => {
    //         return Observable.of([]);
    //       });
    //   } else {
    //     return Observable.of([]);
    //   }
    // }
    // public autoCompleteListOrgTypeFormatter = (data: any): SafeHtml => {
    //   let html = `<span>${data.orgUnitTypeName}</span>`;
    //   return this._sanitizer.bypassSecurityTrustHtml(html);
    // }
    // // Navigate back
    AddOrgUnitTypeComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    AddOrgUnitTypeComponent.prototype.deleteOrgUnitType = function () {
        var _this = this;
        var url = this._baseUrl + 'v1/webAdmin/orgUnitType/delete/' + this.OrganizationUnitTypeData.id;
        this.http.delete(url).subscribe(function (result) {
            if (result.success) {
                _this.translate.get('orgUnitTypeDelete').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this._location.back(); }, 1000);
            }
            else {
                var self_1 = _this;
                if (result.errorMessages.length > 0) {
                    underscore["each"](result.errorMessages, function (key) {
                        self_1.translate.get(key).subscribe(function (msg) {
                            self_1._toaster.showError(msg);
                        });
                    });
                }
            }
        });
    };
    AddOrgUnitTypeComponent.prototype.saveOrgUnitType = function () {
        var _this = this;
        if (this.validateDesignation()) {
            var url = this._baseUrl + 'v1/webAdmin/orgUnitType/save';
            this.http.post(url, this.OrganizationUnitTypeData).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('orgUnitTypeSave').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this._location.back(); }, 1000);
                }
                else {
                    _this.translate.get(result.errorMessage).subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
            }, function (error) {
                console.log(error);
            });
        }
    };
    AddOrgUnitTypeComponent.prototype.updateOrgUnitType = function () {
        var _this = this;
        if (this.validateDesignation()) {
            var url = this._baseUrl + 'v1/webAdmin/orgUnitType/' + this.OrganizationUnitTypeData.id;
            this.http.put(url, this.OrganizationUnitTypeData).subscribe(function (result) {
                if (result) {
                    _this.translate.get('OrgUnitSaved').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this._location.back(); }, 1000);
                }
                else {
                    // this._toaster.showError('Error while adding Designation');
                    _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
            }, function (error) {
                _this.translate.get('errorWhileSavingDesignation').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
            });
        }
    };
    // public rangeLimit(event) {
    //   if (event.target.value.length > 11) {
    //     event.target.value.slice(0, 10);
    //   }
    // }
    // public isEmpty(val) {
    //   return !val
    //     || (isString(val) && !val.trim());
    // }
    // public deleteDesgData() {
    //   if (this.empPresent && this.isEmpty(this.designationModel)) {
    //     this.translate.get('altDesigToContinue').subscribe((msg) => {
    //       this._toaster.showError(msg);
    //     });
    //     return false;
    //   }
    //   let url;
    //   if (this.empPresent) {
    //     url = this._baseUrl + 'v1/webAdmin/designation/' + this.OrganizationUnitTypeData.id
    //       + '?alternateId=' + this.designationModel.id;
    //   } else {
    //     url = this._baseUrl + 'v1/webAdmin/designation/' + this.OrganizationUnitTypeData.id;
    //   }
    //   this.http.delete(url).subscribe((result) => {
    //     if (result.success) {
    //       this.translate.get('desigDeletedSuccessfully').subscribe((msg) => {
    //         this._toaster.showSuccess(msg);
    //       });
    //       setTimeout(() => this.goToBackPage(), 1000);
    //     } else {
    //       this.translate.get('erroeWhileDeteleDesig').subscribe((msg) => {
    //         this._toaster.showError(msg);
    //       });
    //       for (let val of result.errorMessages) {
    //         this._toaster.showError(val);
    //       }
    //     }
    //   });
    // }
    AddOrgUnitTypeComponent.prototype.validateDesignation = function () {
        var _this = this;
        if (!this.OrganizationUnitTypeData.orgUnitTypeName || !this.OrganizationUnitTypeData.orgUnitTypeName.trim()) {
            this.translate.get('enterUnitName').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.OrganizationUnitTypeData.orgUnitTypeCode || !this.OrganizationUnitTypeData.orgUnitTypeCode.trim()) {
            this.translate.get('enterUnitCode').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.OrganizationUnitTypeData.level || this.OrganizationUnitTypeData.level < 1) {
            this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (this.OrganizationUnitTypeData.level > 100) {
            this.translate.get('pleaseEnterLevelLessHund').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    };
    return AddOrgUnitTypeComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/organizationUnit/organizationUnitList.ts

var organizationUnitList_OrgUnitTypePageComponent = /*@__PURE__*/ (function () {
    function OrgUnitTypePageComponent(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this.translate = translate;
        this.vcr = vcr;
        this.updateRate = new core["EventEmitter"]();
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 0;
        this.endingPage = 10;
        this.orgData = [];
        this.trackHides = null;
        this.orgUnitTypeData = [];
        this.orgUnitTypePageData = [];
        this.showLoading = false;
        this.orgUnitTypeFilter = {
            nameOrCode: null,
            codeList: [],
            nameList: [],
            ids: [],
            level: [],
            pageSize: 10,
            page: 1
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllOrgUnitType();
    }
    // pagination functions
    OrgUnitTypePageComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllOrgUnitType();
    };
    OrgUnitTypePageComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllOrgUnitType();
    };
    OrgUnitTypePageComponent.prototype.addOrganizationUnitType = function () {
        this.share.saveData({ OrganizationUnitTypeData: null, type: 'ADD' });
        this.router.navigate(['menu/addOrgUnitType']);
    };
    OrgUnitTypePageComponent.prototype.editOrgUnitType = function (val) {
        this.share.saveData({ OrganizationUnitTypeData: val, type: 'EDIT' });
        this.router.navigate(['menu/addOrgUnitType']);
    };
    OrgUnitTypePageComponent.prototype.deleteOrgUnitType = function (val) {
        this.share.saveData({ OrganizationUnitTypeData: val, type: 'DELETE' });
        this.router.navigate(['menu/addOrgUnitType']);
    };
    OrgUnitTypePageComponent.prototype.getAllOrgUnitType = function () {
        var self = this;
        self.showLoading = true;
        var url = self._baseUrl + 'v1/webAdmin/orgUnitType/search';
        // let url = self._baseUrl + 'v1/webAdmin/orgUnitType/getAll';
        self.http.post(url, self.orgUnitTypeFilter).subscribe(function (result) {
            self.orgUnitTypeData = result.content;
            self.orgUnitTypePageData = result;
            if (self.orgUnitTypeData.length === 0) {
                self.showLoading = false;
            }
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, function (error) {
            self.showLoading = false;
            console.log('getAllOrgUnitType error catch', error);
        });
    };
    OrgUnitTypePageComponent.prototype.empActions = function (val) {
        // this.hide = val;
    };
    OrgUnitTypePageComponent.prototype.empTableActions = function (value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    OrgUnitTypePageComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    OrgUnitTypePageComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    OrgUnitTypePageComponent.prototype.onRefresh = function () {
        //showing loading here
        this.getAllOrgUnitType();
    };
    return OrgUnitTypePageComponent;
}());



// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/app/tools/addEmpType.ts




var addEmpType_AddEmployementTypeComponent = /*@__PURE__*/ (function () {
    function AddEmployementTypeComponent(route, modalService, _global, http, _sanitizer, builder, _auth, router, _location, share, _toaster, translate, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this.http = http;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.addOrgEvent = new core["EventEmitter"]();
        this.empTypedata = {};
        this.type = 'ADD';
        this.empPresent = false;
        this.autoCompleteListCategoryFormatter = function (data) {
            var html = "<span>" + data.type + "(" + data.code + ")</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        // to get list of designation based on keyword
        this.categoryObservableSource = function (keyword) {
            var url = _this._baseUrl + 'v1/webAdmin/category/categorySearch';
            url += '?searchString=' + keyword + '&id=' + _this.empTypedata.id;
            if (keyword.trim()) {
                return _this.http.get(url)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            if (data.type === 'ADD') {
                this.data = {};
                this.type = 'ADD';
            }
            else if (data.type === 'EDIT') {
                this.empTypedata = data.empTypedata;
                this.type = 'EDIT';
            }
            else {
                this.empTypedata = data.empTypedata;
                this.type = 'DELETE';
                var url = this._baseUrl + 'v1/webAdmin/category/check/' + this.empTypedata.id;
                this.http.get(url).subscribe(function (result) {
                    if (result.success) {
                        _this.empPresent = true;
                    }
                    else {
                        _this.empPresent = false;
                    }
                });
            }
        }
        this._toaster.setViewRef(vcr);
    }
    // when auto-complete value is selected this method fires and payload create
    AddEmployementTypeComponent.prototype.gotNewValue = function (e, type) {
        this.categoryModel = e;
    };
    // Formatter
    AddEmployementTypeComponent.prototype.nameValueFormatter = function (data) {
        return "" + data.type + ("(" + data.code + ")");
    };
    // navigate back
    AddEmployementTypeComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    AddEmployementTypeComponent.prototype.isEmpty = function (val) {
        return !val
            || (Object(util["isString"])(val) && !val.trim());
    };
    AddEmployementTypeComponent.prototype.saveCategory = function () {
        var _this = this;
        if (this.validateEmployeetype()) {
            var url = this._baseUrl + 'v1/webAdmin/category/save';
            this.http.post(url, this.empTypedata).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('jobCatSaved').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 1000);
                }
                else {
                    _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
            }, function (error) {
                _this.translate.get('errorWhileSavingJobCategory').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
            });
        }
    };
    AddEmployementTypeComponent.prototype.deleteCategory = function () {
        var _this = this;
        if (this.empPresent && this.isEmpty(this.categoryModel)) {
            this.translate.get('pleaseSelectAlternateEmploymentJobCategoryToContinue').subscribe(function (msg) {
                _this._toaster.showError(msg);
                return false;
            });
        }
        var url;
        if (this.empPresent) {
            url = this._baseUrl + 'v1/webAdmin/category/' + this.empTypedata.id + '?alternateId' +
                this.categoryModel.id;
        }
        else {
            url = this._baseUrl + 'v1/webAdmin/category/' + this.empTypedata.id;
        }
        this.http.delete(url).subscribe(function (result) {
            if (result.success) {
                _this.translate.get('jobCatDeleted').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 500);
            }
            else {
                for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                    var val = _a[_i];
                    _this.translate.get(val).subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                }
            }
        }, function (error) {
            _this.translate.get('errorWhileDeletingJobCategory').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
        });
    };
    AddEmployementTypeComponent.prototype.validateEmployeetype = function () {
        var _this = this;
        if (!this.empTypedata.code || !this.empTypedata.code.trim()) {
            this.translate.get('pleaseEnterCodeToContinue').subscribe(function (msg) {
                _this._toaster.showError(msg);
                return false;
            });
        }
        if (!this.empTypedata.type || !this.empTypedata.type.trim()) {
            this.translate.get('enterJobCatToContinue').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.empTypedata.level || this.empTypedata.level < 1) {
            this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (this.empTypedata.level > 100) {
            this.translate.get('pleaseEnterLevelLessHund').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    };
    return AddEmployementTypeComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/addGrade.ts




var addGrade_AddGradeComponent = /*@__PURE__*/ (function () {
    function AddGradeComponent(route, modalService, _global, http, _sanitizer, builder, _auth, router, _location, translate, share, _toaster, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this.http = http;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this._location = _location;
        this.translate = translate;
        this.share = share;
        this._toaster = _toaster;
        this.addOrgEvent = new core["EventEmitter"]();
        this.type = 'ADD';
        this.empPresent = false;
        this.gradedata = {};
        this.disabled = false;
        this.autoCompleteListGradeFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        // To get list of designation based on keyword
        this.gradeObservableSource = function (keyword) {
            var url = _this._baseUrl + 'v1/webAdmin/grade/gradeSearch';
            url += '?searchString=' + keyword + '&id=' + _this.gradedata.id;
            if (keyword.trim()) {
                return _this.http.get(url)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            if (data.type === 'ADD') {
                this.data = {};
                this.type = 'ADD';
            }
            else if (data.type === 'EDIT') {
                this.gradedata = data.gradedata;
                this.type = 'EDIT';
            }
            else {
                this.gradedata = data.gradedata;
                this.type = 'DELETE';
                var url = this._baseUrl + 'v1/webAdmin/grade/check/' + this.gradedata.id;
                this.http.get(url).subscribe(function (result) {
                    if (result.success) {
                        _this.empPresent = true;
                    }
                    else {
                        _this.empPresent = false;
                    }
                });
            }
        }
        this._toaster.setViewRef(vcr);
    }
    // Formatter
    AddGradeComponent.prototype.nameValueFormatter = function (data) {
        return "" + data.name;
    };
    AddGradeComponent.prototype.gotNewValue = function (e, type) {
        this.gradeModel = e;
    };
    // Navigate back
    AddGradeComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    AddGradeComponent.prototype.saveGrade = function () {
        var _this = this;
        if (this.validateGrade()) {
            this.disabled = true;
            var url = this._baseUrl + 'v1/webAdmin/grade/save';
            this.http.post(url, this.gradedata).subscribe(function (result) {
                _this.disabled = false;
                if (result.success) {
                    _this.translate.get('jobGradeSaved').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 1000);
                }
                else {
                    _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
            }, function (error) {
                _this.translate.get('errorWhileSavingJobGrade').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                    _this.disabled = false;
                });
            });
        }
    };
    AddGradeComponent.prototype.deleteGrade = function () {
        var _this = this;
        if (this.empPresent && this.isEmpty(this.gradeModel)) {
            this.translate.get('selectAltJobGrade').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        var url = null;
        if (this.empPresent) {
            url = this._baseUrl + 'v1/webAdmin/grade/' + this.gradedata.id
                + '?alternateId=' + this.gradeModel.id;
        }
        else {
            url = this._baseUrl + 'v1/webAdmin/grade/' + this.gradedata.id;
        }
        this.http.delete(url).subscribe(function (result) {
            if (result.success) {
                _this.translate.get('jobGradeDeleted').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 1000);
            }
            else {
                _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
            }
        }, function (error) {
            _this.translate.get('errorWhileDeletingJobGrade').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
        });
    };
    AddGradeComponent.prototype.isEmpty = function (val) {
        return !val
            || (isString(val) && !val.trim());
    };
    AddGradeComponent.prototype.validateGrade = function () {
        var _this = this;
        if (!this.gradedata.name || !this.gradedata.name.trim()) {
            this.translate.get('enterJobGradeNameToContinue').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.gradedata.gradeCode || !this.gradedata.gradeCode.trim()) {
            this.translate.get('enterJobGradeCode').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.gradedata.level || this.gradedata.level < 1) {
            this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (this.gradedata.level > 100) {
            this.translate.get('pleaseEnterLevelLessHund').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    };
    return AddGradeComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/addMgrLevel.ts



var addMgrLevel_AddManagerLevelComponent = /*@__PURE__*/ (function () {
    function AddManagerLevelComponent(route, modalService, _global, http, _sanitizer, builder, _auth, router, _location, share, _toaster, translate, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this.http = http;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.type = 'ADD';
        this.empPresent = false;
        this.mgrdata = {};
        this.autoCompleteListMgrLevelFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        // T0 get list of designation based on keyword
        this.mgrLevelObservableSource = function (keyword) {
            var url = _this._baseUrl + 'v1/webAdmin/managerLevel/managerLevelSearch';
            url += '?searchString=' + keyword + '&id=' + _this.mgrdata.id;
            if (keyword.trim()) {
                return _this.http.get(url)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            if (data.type === 'ADD') {
                this.data = {};
                this.type = 'ADD';
            }
            else if (data.type === 'EDIT') {
                this.mgrdata = data.mgrdata;
                this.type = 'EDIT';
            }
            else {
                this.mgrdata = data.mgrdata;
                this.type = 'DELETE';
                var url = this._baseUrl + 'v1/webAdmin/managerLevel/check/' + this.mgrdata.id;
                this.http.get(url).subscribe(function (result) {
                    if (result.success) {
                        _this.empPresent = true;
                    }
                    else {
                        _this.empPresent = false;
                    }
                });
            }
        }
        this._toaster.setViewRef(vcr);
    }
    // Formatter
    AddManagerLevelComponent.prototype.nameValueFormatter = function (data) {
        return "" + data.name;
    };
    AddManagerLevelComponent.prototype.typeValueFormatter = function (data) {
        return "" + data.type;
    };
    // when auto-complete value is 
    // selected this method fires and payload create
    AddManagerLevelComponent.prototype.gotNewValue = function (e) {
        this.mgrLevelModel = e;
    };
    // navigate back
    AddManagerLevelComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    AddManagerLevelComponent.prototype.saveDesgData = function () {
        var _this = this;
        if (this.validateManagerLevel()) {
            var url = this._baseUrl + 'v1/webAdmin/managerLevel/save';
            this.http.post(url, this.mgrdata).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('empTypeSaved').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 1000);
                }
                else {
                    _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
            }, function (error) {
                _this.translate.get('errorWhileSavingEmployeeType').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
            });
        }
    };
    AddManagerLevelComponent.prototype.isEmpty = function (val) {
        return !val
            || (Object(util["isString"])(val) && !val.trim());
    };
    AddManagerLevelComponent.prototype.deleteDesgData = function () {
        var _this = this;
        if (this.empPresent) {
            if (this.empPresent && this.isEmpty(this.mgrLevelModel)) {
                this.translate.get('selectAltEmpType').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                return false;
            }
        }
        var url;
        if (this.empPresent) {
            url = this._baseUrl + 'v1/webAdmin/managerLevel/'
                + this.mgrdata.id + '?alternateId=' + this.mgrLevelModel.id;
        }
        else {
            url = this._baseUrl + 'v1/webAdmin/managerLevel/' + this.mgrdata.id;
        }
        this.http.delete(url).subscribe(function (result) {
            if (result.success) {
                _this.translate.get('empTypeDeleted').subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
                setTimeout(function () { return _this.goToBackPage(); }, 1000);
            }
            else {
                _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
            }
        }, function (error) {
            _this.translate.get('errorWhileDeleteEmployeeType').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
        });
    };
    AddManagerLevelComponent.prototype.validateManagerLevel = function () {
        var _this = this;
        if (!this.mgrdata.name || !this.mgrdata.name.trim()) {
            this.translate.get('enterEmpTypeName').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.mgrdata.code || !this.mgrdata.code.trim()) {
            this.translate.get('enterEmpTypeCode').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.mgrdata.level || this.mgrdata.level < 1) {
            this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (this.mgrdata.level > 100) {
            this.translate.get('pleaseEnterLevelLessHund').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    };
    return AddManagerLevelComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/designationList.ts

var designationList_DesignationPageComponent = /*@__PURE__*/ (function () {
    function DesignationPageComponent(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this.translate = translate;
        this.vcr = vcr;
        this.updateRate = new core["EventEmitter"]();
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.orgData = [];
        this.trackHides = null;
        this.desgData = [];
        this.desgPageData = [];
        this.showLoading = false;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllDesignation();
    }
    // pagination functions
    DesignationPageComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllDesignation();
    };
    DesignationPageComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllDesignation();
    };
    DesignationPageComponent.prototype.addDesignation = function () {
        this.share.saveData({ desgId: null, type: 'ADD' });
        this.router.navigate(['menu/addDesignation']);
    };
    DesignationPageComponent.prototype.editDesignation = function (val) {
        this.share.saveData({ desgData: val, type: 'EDIT' });
        this.router.navigate(['menu/addDesignation']);
    };
    DesignationPageComponent.prototype.deleteDesg = function (val) {
        this.share.saveData({ desgData: val, type: 'DELETE' });
        this.router.navigate(['menu/addDesignation']);
    };
    DesignationPageComponent.prototype.getAllDesignation = function () {
        var self = this;
        self.showLoading = true;
        var url = self._baseUrl + 'v1/webAdmin/designation';
        self.http.post(url, { page: self.page, pageSize: self.pageSize }).subscribe(function (result) {
            self.desgData = result.content;
            self.desgPageData = result;
            if (self.desgData.length === 0) {
                self.showLoading = false;
            }
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, function (error) {
            self.showLoading = false;
        });
    };
    DesignationPageComponent.prototype.empActions = function (val) {
        // this.hide = val;
    };
    DesignationPageComponent.prototype.empTableActions = function (value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    DesignationPageComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    DesignationPageComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    DesignationPageComponent.prototype.onRefresh = function () {
        var _this = this;
        setTimeout(function () {
            _this.getAllDesignation();
        }, 2000);
    };
    return DesignationPageComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/empTypeList.ts
var EmployementTypePageComponent = /*@__PURE__*/ (function () {
    function EmployementTypePageComponent(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this.translate = translate;
        this.vcr = vcr;
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.trackHides = null;
        this.empTypedata = [];
        this.empTypePageData = [];
        this.showLoading = false;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllCategory();
    }
    // pagination functions
    EmployementTypePageComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllCategory();
    };
    EmployementTypePageComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllCategory();
    };
    EmployementTypePageComponent.prototype.addCategory = function () {
        this.share.saveData({ empTypeid: null, type: 'ADD' });
        this.router.navigate(['menu/addEmpType']);
    };
    EmployementTypePageComponent.prototype.editCategory = function (val) {
        this.share.saveData({ empTypedata: val, type: 'EDIT' });
        this.router.navigate(['menu/addEmpType']);
    };
    EmployementTypePageComponent.prototype.deleteCategory = function (val) {
        this.share.saveData({ empTypedata: val, type: 'DELETE' });
        this.router.navigate(['menu/addEmpType']);
    };
    EmployementTypePageComponent.prototype.getAllCategory = function () {
        var self = this;
        self.showLoading = true;
        var url = self._baseUrl + 'v1/webAdmin/category';
        self.http.post(url, { page: self.page, pageSize: self.pageSize }).subscribe(function (result) {
            self.empTypedata = result.content;
            self.empTypePageData = result;
            if (self.empTypedata.length === 0) {
                self.showLoading = false;
            }
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, function (error) {
            self.empTypedata = [];
            self.showLoading = false;
        });
    };
    EmployementTypePageComponent.prototype.empActions = function (val) {
        // this.hide = val;
    };
    EmployementTypePageComponent.prototype.empTableActions = function (value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    EmployementTypePageComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    EmployementTypePageComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    EmployementTypePageComponent.prototype.onRefresh = function () {
        this.getAllCategory();
    };
    return EmployementTypePageComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/gradeList.ts
var GradePageComponent = /*@__PURE__*/ (function () {
    function GradePageComponent(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this.translate = translate;
        this.vcr = vcr;
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.trackHides = null;
        this.gradedata = [];
        this.gradePageData = [];
        this.showLoading = false;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllDesignation();
    }
    // pagination functions
    GradePageComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllDesignation();
    };
    GradePageComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllDesignation();
    };
    GradePageComponent.prototype.addDesignation = function () {
        this.share.saveData({ gradeId: null, type: 'ADD' });
        this.router.navigate(['menu/addGrade']);
    };
    GradePageComponent.prototype.editDesignation = function (val) {
        this.share.saveData({ gradedata: val, type: 'EDIT' });
        this.router.navigate(['menu/addGrade']);
    };
    GradePageComponent.prototype.deleteDesg = function (val) {
        this.share.saveData({ gradedata: val, type: 'DELETE' });
        this.router.navigate(['menu/addGrade']);
    };
    GradePageComponent.prototype.getAllDesignation = function () {
        var self = this;
        self.showLoading = true;
        var url = self._baseUrl + 'v1/webAdmin/grade';
        self.http.post(url, { page: self.page, pageSize: self.pageSize }).subscribe(function (result) {
            self.gradedata = result.content;
            self.gradePageData = result;
            if (self.gradedata.length === 0) {
                self.showLoading = false;
            }
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, function (error) {
            console.log('getAllgrade error catch', error);
        });
    };
    GradePageComponent.prototype.empActions = function (val) {
        // this.hide = val;
    };
    GradePageComponent.prototype.empTableActions = function (value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    GradePageComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    GradePageComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    GradePageComponent.prototype.onRefresh = function () {
        this.getAllDesignation();
    };
    return GradePageComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/mgrLevelList.ts

var mgrLevelList_ManagerLevelComponent = /*@__PURE__*/ (function () {
    function ManagerLevelComponent(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, vcr) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this.vcr = vcr;
        this.updateRate = new core["EventEmitter"]();
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.trackHides = null;
        this.mgrdata = [];
        this.mgrPageData = [];
        this.showLoading = false;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllDesignation();
    }
    // pagination functions
    ManagerLevelComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllDesignation();
    };
    ManagerLevelComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllDesignation();
    };
    ManagerLevelComponent.prototype.addDesignation = function () {
        this.share.saveData({ mgrId: null, type: 'ADD' });
        this.router.navigate(['menu/addMgrLevel']);
    };
    ManagerLevelComponent.prototype.editDesignation = function (val) {
        this.share.saveData({ mgrdata: val, type: 'EDIT' });
        this.router.navigate(['menu/addMgrLevel']);
    };
    ManagerLevelComponent.prototype.deleteDesg = function (val) {
        this.share.saveData({ mgrdata: val, type: 'DELETE' });
        this.router.navigate(['menu/addMgrLevel']);
    };
    ManagerLevelComponent.prototype.getAllDesignation = function () {
        var self = this;
        self.showLoading = true;
        var url = self._baseUrl + 'v1/webAdmin/managerLevel';
        self.http.post(url, { page: self.page, pageSize: self.pageSize }).subscribe(function (result) {
            self.mgrdata = result.content;
            self.mgrPageData = result;
            if (self.mgrdata.length === 0) {
                self.showLoading = false;
            }
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, function (error) {
            self.showLoading = false;
            console.log('getAllmgrdata error catch', error);
        });
    };
    ManagerLevelComponent.prototype.empActions = function (val) {
        // this.hide = val;
    };
    ManagerLevelComponent.prototype.empTableActions = function (value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    ManagerLevelComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    ManagerLevelComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    ManagerLevelComponent.prototype.onRefresh = function () {
        this.getAllDesignation();
    };
    return ManagerLevelComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/org/addParentOrganization.ts



var addParentOrganization_AddParentOrganizationComponent = /*@__PURE__*/ (function () {
    function AddParentOrganizationComponent(route, modalService, activeModal, _global, http, _sanitizer, builder, router, _location, share, _toaster, translate, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this.activeModal = activeModal;
        this._global = _global;
        this.http = http;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this.router = router;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.addOrgEvent = new core["EventEmitter"]();
        this.orgTypeData = [];
        this.type = 'ADD';
        this.asl = false;
        this.cancelEvent = new core["EventEmitter"]();
        this.arrayOfStrings = [];
        this.categoryData = [];
        this.warning = 'Please type to select';
        this.oldValue = null;
        this.orgCat = null;
        // tslint:disable-next-line:member-ordering
        this.payload = {
            searchString: '',
            excludeEmpIds: []
        };
        this.disableButton = false;
        this.orgData = {
            id: null,
            level: null,
            orgName: "",
            orgUnitCode: "",
            houEmployeeId: null,
            hrSpocId: null,
            orgType: null,
            parentId: null,
            description: null,
            mission: null,
            vision: null,
            status: null,
            orgTypeMappings: [],
            ccAdminId: null,
            ccManagerId: null,
            leaveAdministratorId: null,
            category: { code: null },
            childIds: [],
            parentOrgName: null,
            orgNameLocale: null,
            descriptionLocale: null
        };
        this.orgFilter = {
            nameOrCode: null,
            excludedIds: [],
            page: 1,
            pageSize: 10
        };
        // To get list of Organization based on keyword
        this.orgTypeObservableSource = function (keyword) {
            if (keyword) {
                var url = _this._baseUrl + 'v1/webAdmin/orgUnit/orgType/autoComplete';
                url += '?name=' + keyword;
                if (keyword) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    }, function (error) {
                        console.log('catch orgUnitType Error' + error);
                        return Observable["a" /* Observable */].of([]);
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this.autoCompleteListOrgTypeFormatter = function (data) {
            var html = "<span>" + data.orgUnitTypeName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.displayName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteOrgCat = function (data) {
            var html = "<span>" + data.code + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteOrgName = function (data) {
            var html = "<span>" + data.orgName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        // To get list of Organization based on keyword
        this.organisationUnitObservable = function (keyword) {
            if (keyword && keyword.trim()) {
                //let encodedKeyword = encodeURIComponent(keyword);
                var url = _this._baseUrl + 'v1/webAdmin/orgUnit/searchOrg';
                _this.orgFilter.nameOrCode = keyword;
                console.log(_this.orgFilter);
                return _this.http.post(url, _this.orgFilter)
                    .map(function (res) {
                    console.log(res);
                    if (res != null && res.length > 0) {
                        return res;
                    }
                    else {
                        _this.translate.get('noParentOrg').subscribe(function (msg) {
                            _this._toaster.showWarning(msg);
                        });
                        res = [];
                        return res;
                    }
                }, function (error) {
                    console.log('catch orgUnitType Error' + error);
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        this.type = data.type;
        this.share.saveData({ mainOrg: this.share.getData(), type: 'Edit' });
        if (this.type === 'EDIT') {
            this.getOrgDataToUpdate(data);
        }
        else {
            this.data = {};
        }
    }
    //Get OrgData to edit
    AddParentOrganizationComponent.prototype.getOrgDataToUpdate = function (data) {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/orgUnit/' + data.org.id;
        self.http.get(url).subscribe(function (result) {
            _this.orgData = result.data;
            if (_this.orgData.houEmployeeId != null) {
                _this.getEmployeeById(_this.orgData.houEmployeeId, 'hou');
            }
            if (_this.orgData.hrSpocId != null) {
                _this.getEmployeeById(_this.orgData.hrSpocId, 'hrSpoc');
            }
            if (_this.orgData.ccAdminId != null) {
                _this.getEmployeeById(_this.orgData.ccAdminId, 'ccAdmin');
            }
            if (_this.orgData.ccManagerId != null) {
                _this.getEmployeeById(_this.orgData.ccManagerId, 'ccManager');
            }
            if (_this.orgData.leaveAdministratorId != null) {
                _this.getEmployeeById(_this.orgData.leaveAdministratorId, 'leaveAdministrator');
            }
            if (_this.orgData.category != null) {
                _this.orgCat = _this.orgData.category.code;
            }
            if (_this.orgData.childIds != null) {
                _this.orgFilter.excludedIds = _this.orgData.childIds;
                _this.orgFilter.excludedIds.push(data.org.id);
            }
            if (_this.orgData.parentOrgName != null) {
                _this.parent = _this.orgData.parentOrgName;
            }
            if (result.data.orgType != null) {
                url = self._baseUrl + 'v1/webAdmin/orgUnit/orgType/' + result.data.orgType.id;
                self.http.get(url).subscribe(function (res) {
                    _this.orgTypeModel = res.data.orgUnitTypeName;
                }, function (error) {
                    console.log('Error while fetching org type');
                });
            }
        });
    };
    // Get employee by id
    AddParentOrganizationComponent.prototype.getEmployeeById = function (parm, type) {
        var _this = this;
        var url = this._baseUrl + 'v1/webAdmin/employee/getEmployee' + '?employeeId=' + parm;
        this.http.get(url).subscribe(function (result) {
            if (type === 'hou') {
                _this.primarySupervisorModel = result.displayName;
            }
            if (type === 'hrSpoc') {
                _this.hrSpocModel = result.displayName;
            }
            if (type === 'ccAdmin') {
                _this.ccAdmin = result.displayName;
            }
            if (type === 'ccManager') {
                _this.ccManager = result.displayName;
            }
            if (type === 'leaveAdministrator') {
                _this.leaveAdministrator = result.displayName;
            }
        }, function (error) {
            console.log('saveEmployee error caught', error);
        });
    };
    AddParentOrganizationComponent.prototype.getOrgTree = function () {
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/orgUnit';
        self.http.get(url).subscribe(function (result) {
            self.orgData = result.data;
        }, function (error) {
            console.log('Org Tree error catch', error);
        });
    };
    AddParentOrganizationComponent.prototype.getIdsWithPayload = function (keyword) {
        var payload = {
            searchString: null,
            excludeEmpIds: []
        };
        payload.searchString = keyword;
        var everythingButTheNulls = underscore["compact"](payload.excludeEmpIds);
        payload.excludeEmpIds = [];
        payload.excludeEmpIds = everythingButTheNulls;
        return payload;
    };
    // ObservableSource
    // To get list of supervisor based on keyword
    AddParentOrganizationComponent.prototype.employeeObservableSource = function (keyword) {
        if (keyword) {
            var url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
            var payload = this.getIdsWithPayload(keyword);
            return this.http.post(url, payload)
                .map(function (res) {
                return res;
            }, function (error) {
                console.log('error while seaching employee' + error);
            });
        }
        else {
            return Observable["a" /* Observable */].of([]);
        }
    };
    AddParentOrganizationComponent.prototype.hrrObservableSource = function (keyword) {
        if (keyword) {
            var url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
            var payload = this.getIdsWithPayload(keyword);
            return this.http.post(url, payload)
                .map(function (res) {
                return res;
            }, function (error) {
                return Observable["a" /* Observable */].of([]);
            });
        }
        else {
            return Observable["a" /* Observable */].of([]);
        }
    };
    // orgCatObservableSource
    AddParentOrganizationComponent.prototype.orgCatObservableSource = function (keyword) {
        if (keyword && keyword.trim()) {
            var url = this._baseUrl + 'v1/webAdmin/orgUnit/orgCategory/autoComplete';
            url += '?codeOrName=' + keyword;
            // let payload: any = this.getIdsWithPayload(keyword);
            return this.http.get(url)
                .map(function (res) {
                return res.content;
            }, function (error) {
                return Observable["a" /* Observable */].of([]);
            });
        }
        else {
            return Observable["a" /* Observable */].of([]);
        }
    };
    // Formatter
    AddParentOrganizationComponent.prototype.orgTypeFormatter = function (data) {
        return "" + data.orgUnitTypeName;
    };
    AddParentOrganizationComponent.prototype.changeOldValue = function () {
        var self = this;
        self.oldValue = null;
    };
    // when auto-complete value is selected this method fires and payload create
    AddParentOrganizationComponent.prototype.gotNewValue = function (e, type) {
        var _this = this;
        setTimeout(function () {
            _this.changeOldValue();
        }, 1000);
        if (underscore["isObject"](e)) {
            if (this.oldValue === type) {
                return;
            }
        }
        else if (e === '') {
            e = { id: null, name: null };
            this.oldValue = type;
        }
        else {
            return;
        }
        if (type === 'orgType') {
            if (this.orgData.orgType == null) {
                this.orgData.orgType = {};
            }
            this.orgData.orgType.id = e.id;
            this.orgData.level = e.level;
        }
        if (type === 'primary') {
            this.orgData.houEmployeeId = e.id;
        }
        if (type === 'hrSpoc') {
            this.orgData.hrSpocId = e.id;
        }
        if (type === 'ccAdmin') {
            this.orgData.ccAdminId = e.id;
        }
        if (type === 'ccManager') {
            this.orgData.ccManagerId = e.id;
        }
        if (type === 'leaveAdministrator') {
            this.orgData.leaveAdministratorId = e.id;
        }
        if (type === "orgCat") {
            this.orgData.category = e;
        }
        if (type === "parent") {
            this.orgData.parentId = e.id;
        }
    };
    AddParentOrganizationComponent.prototype.isString = function (value) {
        return typeof value === 'string' || value instanceof String;
    };
    AddParentOrganizationComponent.prototype.getSelectedOrgTypeName = function () {
        if (this.isString(this.orgTypeModel)) {
            return this.orgTypeModel;
        }
        else {
            return this.orgTypeModel.orgUnitTypeName;
        }
    };
    // Save organization
    AddParentOrganizationComponent.prototype.saveOrgData = function () {
        var _this = this;
        if (!this.orgData.orgUnitCode || !this.orgData.orgUnitCode.trim()) {
            this.translate.get('PLEASE_ENTER_ORGANIZATION_CODE_TO_CONTINUE').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.orgData.orgName || !this.orgData.orgName.trim()) {
            this.translate.get('PLEASE_ENTER_ORGANIZATION_NAME_TO_CONTINUE').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (!this.orgTypeModel) {
            this.translate.get('PLEASE_SELECT_ORG_TYPE').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        this.disableButton = true;
        if (this.type === 'ADD') {
            var url = this._baseUrl + 'v1/webAdmin/orgUnit';
            if (this.orgData.category.code == null) {
                this.orgData.category = null;
            }
            this.http.post(url, this.orgData).subscribe(function (result) {
                if (result.success) {
                    _this.activeModal.close({ data: result.data, orgTypeName: _this.getSelectedOrgTypeName() });
                }
                else {
                    _this.translate.get('errorWhileAddingOrg').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                        var val = _a[_i];
                        _this._toaster.showError(val);
                    }
                    _this.disableButton = false;
                }
            }, function (error) {
                console.log('saveOrg error caught', error);
                _this.disableButton = false;
            });
        }
        else {
            var url = this._baseUrl + 'v1/webAdmin/orgUnit/' + this.orgData.id;
            this.http.put(url, this.orgData).subscribe(function (result) {
                if (result.success) {
                    _this.activeModal.close({ data: result.data, orgTypeName: _this.getSelectedOrgTypeName() });
                }
                else {
                    _this.translate.get('errorWhileUpdateOrg').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                        var val = _a[_i];
                        _this._toaster.showError(val);
                    }
                    _this.disableButton = false;
                }
            }, function (error) {
                console.log('saveOrg error caught', error);
                _this.disableButton = false;
            });
        }
    };
    return AddParentOrganizationComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/org/organizationList.ts


var organizationList_OrganizationPage = /*@__PURE__*/ (function () {
    function OrganizationPage(route, modalService, router, _global, http, eRef, share, _sanitizer, builder, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this.translate = translate;
        this.vcr = vcr;
        this.updateRate = new core["EventEmitter"]();
        this.page = 5;
        this.endingPage = 0;
        this.startingPage = 0;
        this.asl = false;
        this.showChild = false;
        this.localState = { value: '' };
        this.orgData = [];
        this.trackHides = null;
        this.showAdvanceSearch = false;
        this.pageSize = 10;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getOrgTree();
    }
    OrganizationPage.prototype.getOrgtype = function () {
        if (this.orgData.orgTypeName == undefined) {
            return this.share.getMapValues('' + this.orgData.orgType + '');
        }
        else {
            return this.orgData.orgTypeName;
        }
    };
    OrganizationPage.prototype.orgAdd = function () {
        var _this = this;
        this.share.saveData({ orgId: null, type: 'ADD' });
        var modalRef = this.modalService.open(addParentOrganization_AddParentOrganizationComponent)
            .result.then(function (result) {
            _this.addChildTree(result);
        }, function (reason) {
            ;
        });
    };
    OrganizationPage.prototype.editOrg = function (param) {
        var _this = this;
        var self = this;
        this.share.saveData({ org: param, type: 'EDIT' });
        var modalRef = this.modalService.open(addParentOrganization_AddParentOrganizationComponent)
            .result.then(function (result) {
            _this.addToParent(result);
        }, function (reason) {
            ;
        });
    };
    OrganizationPage.prototype.addOrganization = function () {
        this.share.saveData({ orgId: null, type: 'ADD' });
        this.router.navigate(['menu/addOrganization']);
    };
    OrganizationPage.prototype.refreshLocal = function (param) {
        this.getOrgTree();
    };
    OrganizationPage.prototype.addSubLevels = function (evn) {
        this.asl = evn;
    };
    OrganizationPage.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    OrganizationPage.prototype.clicked = function () {
        this.trackHides = null;
    };
    OrganizationPage.prototype.showAdvanced = function (e) {
        this.showAdvanceSearch = e;
    };
    OrganizationPage.prototype.getOrgTree = function () {
        try {
            var self_1 = this;
            var url = self_1._baseUrl + 'v1/webAdmin/orgUnit/';
            self_1.http.get(url).subscribe(function (result) {
                self_1.orgData = result.data;
            });
        }
        catch (e) {
            console.log('Org Tree error catch', e);
        }
    };
    OrganizationPage.prototype.toggleChild = function () {
        this.showChild = !this.showChild;
    };
    OrganizationPage.prototype.removeFromChild = function (id) {
        var self = this;
        var index;
        for (var i in self.orgData) {
            if (self.orgData[i].id === id) {
                index = i;
            }
        }
        self.orgData.splice(index, 1);
        self.translate.get('orgDeleted').subscribe(function (msg) {
            self._toaster.showSuccess(msg);
        });
    };
    OrganizationPage.prototype.addChildTree = function (event) {
        var _this = this;
        this.share.saveAsMap('' + event.data.orgType + '', event.orgTypeName);
        /* console.log("Org Data::",this.orgData)
        console.log("Event Data::",event.data)
        if (this.orgData != null) {
            this.orgData.push(event.data);
        } else {
            this.orgData = new Array(0);
            this.orgData.push(event.data);
        } */
        this.getOrgTree();
        this.translate.get('orgSaved').subscribe(function (msg) {
            _this._toaster.showSuccess(msg);
        });
    };
    OrganizationPage.prototype.addToParent = function (event) {
        var _this = this;
        this.share.saveAsMap('' + event.data.orgType + '', event.orgTypeName);
        var parorgData = event.data;
        if (this.orgData != null) {
            for (var i in this.orgData) {
                if (this.orgData[i].id === parorgData.id) {
                    this.orgData[i] = parorgData;
                    break;
                }
            }
        }
        else {
            this.orgData = new Array(0);
            this.orgData.push(parorgData);
        }
        this.translate.get('orgUpdated').subscribe(function (msg) {
            _this._toaster.showSuccess(msg);
        });
        this.router.navigate(['menu/organizationList']);
    };
    return OrganizationPage;
}());



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/addUsersToRole.ts

var addUsersToRole_AddUsersToRolesComponent = /*@__PURE__*/ (function () {
    function AddUsersToRolesComponent(_global, http, router, _toaster, modalService, activeModal, share, _http, _location, translate, vcr) {
        this._global = _global;
        this.http = http;
        this.router = router;
        this._toaster = _toaster;
        this.modalService = modalService;
        this.activeModal = activeModal;
        this.share = share;
        this._http = _http;
        this._location = _location;
        this.translate = translate;
        this.selectedOption = 'everyone';
        this.empCodes = '';
        this.deleteEmpCodes = [];
        this.invalidEmployeeCodes = [];
        this.disableButton = false;
        this.type = "";
        this.showLoading = true;
        //pagination variables  and default values
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.trackHides = null;
        this.roles = 1;
        this.employeeData = [];
        this.disabledButton = false;
        this.employeePageData = {};
        this.searchData = {
            "nameOrCodeOrEmail": "",
            "employeeCodes": [],
            "excludedEmployeeCodes": [],
            "includeEmpIds": [],
            "excludeEmpIds": [],
            "gradeIds": [],
            "mgrLevelIds": [],
            "designationIds": [],
            "categoryIds": [],
            "includeOrgIds": [],
            "excludeOrgIds": [],
            "supervisorIds": [],
            "primarySupervisorIds": [],
            "primarySupervisorNameOrCode": null,
            "primarySupervisorCods": [],
            "employeeStatus": null,
            "employeesWithOutSupervisor": null,
            "scorecardStates": null,
            "memberShipState": null,
            "programId": null,
            "pageSize": 10,
            "page": 1,
            "fetchSupervisorLevels": 0
        };
        this._baseUrl = _global.get("EPMS_BASE_URL");
        var data = this.share.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            this.roleId = data.id;
            this.type = data.type;
            if (this.type == "DELETEROLE") {
                this.getEmployeeDetails();
            }
            this._toaster.setViewRef(vcr);
        }
    }
    //show and hide Advance Search option
    AddUsersToRolesComponent.prototype.showAdvanced = function () {
        this.share.saveAsMap('Role', this.roleId);
        this.router.navigate(['menu/employeeSearch']);
    };
    AddUsersToRolesComponent.prototype.rolesBack = function () {
        this._location.back();
    };
    AddUsersToRolesComponent.prototype.addUsers = function () {
        this.invalidEmployeeCodes = [];
        if (this.selectedOption == 'everyone') {
            this.finalAddUsers('assignRoleToAllEmployees');
        }
        if (this.selectedOption == 'except') {
            this.searchData.excludedEmployeeCodes = [];
            if (this.validateEmpCodes()) {
                this.finalAddUsers('assignRolesExcludeEmployeeCodes');
            }
        }
        if (this.selectedOption == 'everyoneIn') {
            this.searchData.employeeCodes = [];
            if (this.validateEmpCodes()) {
                this.finalAddUsers('assignRolesIncludeEmployeeCodes');
            }
        }
    };
    AddUsersToRolesComponent.prototype.removeUsers = function () {
        this.invalidEmployeeCodes = [];
        this.deleteEmpCodes = [];
        if (this.validateEmpCodes()) {
            this.finalRemoveUsers();
        }
    };
    AddUsersToRolesComponent.prototype.finalRemoveUsers = function () {
        var _this = this;
        var that = this;
        that.disableButton = true;
        var url = that._baseUrl + 'v1/webAdmin/role/' + that.roleId;
        that.http.post(url, that.deleteEmpCodes).subscribe(function (result) {
            that.disableButton = false;
            if (result.success) {
                _this.translate.get('usersRoleRemoved').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                    setTimeout(function () { that.rolesBack(); }, 1000);
                });
            }
            else {
                that._toaster.showError(result.errorMessages[0]);
                if (result.invalidEmployeeCodes.length > 0) {
                    that.getInvalidEmpCode(result.invalidEmployeeCodes);
                }
            }
        });
    };
    AddUsersToRolesComponent.prototype.clicked = function () {
    };
    //pagination functions
    AddUsersToRolesComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event == 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getEmployeeDetails();
    };
    AddUsersToRolesComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getEmployeeDetails();
    };
    AddUsersToRolesComponent.prototype.getEmployeeDetails = function () {
        try {
            var that_1 = this;
            var url = that_1._baseUrl + 'v1/webAdmin/role/getEmployeeInfoByRoleId/' + this.roleId;
            that_1._http.post(url, this.searchData).subscribe(function (result) {
                that_1.disabledButton = false;
                that_1.employeeData = result.content;
                that_1.employeePageData = result;
                if (that_1.employeeData.length == 0) {
                    that_1.showLoading = false;
                }
                that_1.collectionSize = result.totalElements;
                if (result.last) {
                    that_1.endingPage = that_1.collectionSize;
                }
            });
        }
        catch (e) {
            console.log('caught error in getCompleteRolesAndPermissionDetails', e);
        }
    };
    AddUsersToRolesComponent.prototype.finalAddUsers = function (option) {
        var _this = this;
        var that = this;
        var flag = false;
        that.disableButton = true;
        var url = that._baseUrl + 'v1/webAdmin/role/' + option + '/' + that.roleId;
        that.http.post(url, that.searchData).subscribe(function (result) {
            that.disableButton = false;
            if (option == 'assignRoleToAllEmployees') {
                if (result) {
                    flag = true;
                }
            }
            else {
                if (result.status) {
                    flag = true;
                }
            }
            if (flag) {
                _this.translate.get('addedUser').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
                setTimeout(function () { that.rolesBack(); }, 1000);
            }
            else {
                that._toaster.showError(result.errorMessages[0]);
                if (result.invalidEmployeeCodes.length > 0) {
                    that.getInvalidEmpCode(result.invalidEmployeeCodes);
                }
            }
        });
    };
    AddUsersToRolesComponent.prototype.validateEmpCodes = function () {
        var that = this;
        if (that.empCodes.trim() == '' || that.empCodes.length == 0) {
            this.translate.get('pleaseEnterEmpToContinue').subscribe(function (msg) {
                that._toaster.showError(msg);
            });
            return false;
        }
        else {
            var empCode = that.empCodes.split(',');
            underscore["each"](empCode, function (key, val) {
                if (that.selectedOption == 'everyoneIn') {
                    that.searchData.employeeCodes.push(key.trim());
                }
                if (that.selectedOption == 'except') {
                    that.searchData.excludedEmployeeCodes.push(key.trim());
                }
                if (that.selectedOption == 'everyone') {
                    that.deleteEmpCodes.push(key.trim());
                }
            });
        }
        return true;
    };
    AddUsersToRolesComponent.prototype.getInvalidEmpCode = function (invalidEmployeeCodes) {
        var that = this;
        underscore["each"](invalidEmployeeCodes, function (val, key) {
            that.invalidEmployeeCodes.push(val);
        });
    };
    AddUsersToRolesComponent.prototype.selectOption = function (option) {
        this.selectedOption = option;
        this.invalidEmployeeCodes = [];
    };
    return AddUsersToRolesComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/createRolesAndPermission.ts

var createRolesAndPermission_CreateRolesAndPermissionComponent = /*@__PURE__*/ (function () {
    function CreateRolesAndPermissionComponent(route, modalService, _global, _http, builder, _auth, router, _location, share, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this._http = _http;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.roleData = {};
        this.selectedOperation = [];
        this.type = 'CREATE';
        this.buttonDisabled = false;
        this.rolePayload = {
            id: null,
            code: null,
            name: null,
            description: null,
            operations: null
        };
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.roleData = this.share.getMapValues('roleData');
        this.type = this.share.getMapValues('type');
        if (underscore["isEmpty"](this.roleData)) {
            this._location.back();
        }
        else {
            if (this.type == 'EDIT') {
                this.checkForSelectedRole();
            }
            this._toaster.setViewRef(vcr);
        }
    }
    CreateRolesAndPermissionComponent.prototype.selected = function (p) {
        var that = this;
        if (p.assigned) {
            that.selectedOperation.push(p.operation);
        }
        else {
            underscore["each"](that.selectedOperation, function (key, val) {
                if (p.operation == key) {
                    that.selectedOperation.splice(val, 1);
                }
            });
        }
    };
    CreateRolesAndPermissionComponent.prototype.checkForSelectedRole = function () {
        var that = this;
        underscore["each"](that.roleData.operations, function (key, val) {
            if (key.assigned) {
                that.selectedOperation.push(key.operation);
            }
            if (key.childOperations.length > 0) {
                that.checkForSelectedChildRole(key.childOperations);
            }
        });
    };
    CreateRolesAndPermissionComponent.prototype.checkForSelectedChildRole = function (childOperations) {
        var that = this;
        underscore["each"](childOperations, function (key, val) {
            if (key.assigned) {
                that.selectedOperation.push(key.operation);
            }
        });
    };
    CreateRolesAndPermissionComponent.prototype.getPayload = function () {
        var that = this;
        that.rolePayload.id = that.roleData.id;
        that.rolePayload.description = that.roleData.description;
        that.rolePayload.code = that.roleData.code;
        that.rolePayload.name = that.roleData.name;
        that.rolePayload.operations = that.selectedOperation;
        return that.rolePayload;
    };
    CreateRolesAndPermissionComponent.prototype.validateRoles = function () {
        var _this = this;
        var that = this;
        if (that.roleData.name == null) {
            this.translate.get('nameShouldNotEmpty').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        else if (that.roleData.name.trim() == '') {
            this.translate.get('nameShouldNotEmpty').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (that.roleData.code == null) {
            this.translate.get('codeShouldNotEmpty').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        else if (that.roleData.code.trim() == '') {
            this.translate.get('codeShouldNotEmpty').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        if (that.selectedOperation.length == 0) {
            this.translate.get('pleaseSelectOperation').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        return true;
    };
    CreateRolesAndPermissionComponent.prototype.editOrSave = function () {
        var _this = this;
        try {
            var that_1 = this;
            if (this.validateRoles()) {
                that_1.buttonDisabled = true;
                var url = that_1._baseUrl + 'v1/webAdmin/role';
                that_1._http.post(url, that_1.getPayload()).subscribe(function (result) {
                    that_1.buttonDisabled = false;
                    if (result.success) {
                        _this.translate.get('savedRolesAndOperations').subscribe(function (msg) {
                            _this._toaster.showSuccess(msg);
                        });
                        setTimeout(function () { that_1._location.back(); }, 1000);
                    }
                    else {
                        _this.translate.get(result.errorMessage).subscribe(function (msg) {
                            _this._toaster.showError(msg);
                        });
                    }
                });
            }
        }
        catch (e) {
            console.log('editOrSave roles', e);
        }
    };
    CreateRolesAndPermissionComponent.prototype.rolesBack = function () {
        this._location.back();
    };
    return CreateRolesAndPermissionComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/employeesInRole.ts

var employeesInRole_EmployeeInRoleComponent = /*@__PURE__*/ (function () {
    function EmployeeInRoleComponent(route, modalService, _global, _http, builder, _auth, router, _location, share, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this._http = _http;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.showLoading = true;
        this.disabledButton = false;
        //pagination variables  and default values
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.allSelectedEmplUserIds = [];
        this.employeeData = [];
        this.employeePageData = {};
        this.searchData = {
            "nameOrCodeOrEmail": "",
            "employeeCodes": [],
            "excludedEmployeeCodes": [],
            "includeEmpIds": [],
            "excludeEmpIds": [],
            "gradeIds": [],
            "mgrLevelIds": [],
            "designationIds": [],
            "categoryIds": [],
            "includeOrgIds": [],
            "excludeOrgIds": [],
            "supervisorIds": [],
            "primarySupervisorIds": [],
            "primarySupervisorNameOrCode": null,
            "primarySupervisorCods": [],
            "employeeStatus": null,
            "employeesWithOutSupervisor": null,
            "scorecardStates": null,
            "memberShipState": null,
            "programId": null,
            "pageSize": 10,
            "page": 1,
            "fetchSupervisorLevels": 0
        };
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.id = this.share.getData();
        if (isNaN(this.id)) {
            this._location.back();
        }
        else {
            this._toaster.setViewRef(vcr);
            this.getEmployeeDetails();
        }
    }
    EmployeeInRoleComponent.prototype.getData = function () {
        underscore["each"](this.employeeData, function (key, val) {
            key.selected = false;
        });
    };
    EmployeeInRoleComponent.prototype.showSearchFilter = function (event) {
        ;
        this.searchData = event;
        this.getEmployeeDetails();
    };
    //pagination functions
    EmployeeInRoleComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event == 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getEmployeeDetails();
    };
    EmployeeInRoleComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getEmployeeDetails();
    };
    EmployeeInRoleComponent.prototype.deleteEmployee = function () {
        var _this = this;
        try {
            var that_1 = this;
            that_1.disabledButton = true;
            var url = that_1._baseUrl + 'v1/webAdmin/role/deleterRoleUserRelation/' + that_1.id;
            that_1._http.post(url, that_1.allSelectedEmplUserIds).subscribe(function (result) {
                if (result) {
                    _this.translate.get('deleted').subscribe(function (msg) {
                        that_1._toaster.showSuccess(msg);
                    });
                    that_1.getEmployeeDetails();
                }
                else {
                    _this.translate.get('failedDelete').subscribe(function (msg) {
                        that_1._toaster.showError(msg);
                    });
                    that_1.disabledButton = false;
                }
            });
        }
        catch (e) {
            console.log('error', e);
        }
    };
    EmployeeInRoleComponent.prototype.clicked = function () {
    };
    EmployeeInRoleComponent.prototype.getEmployeeDetails = function () {
        try {
            var that_2 = this;
            var url = that_2._baseUrl + 'v1/webAdmin/role/getEmployeeInfoByRoleId/' + that_2.id;
            this.searchData.page = this.page;
            this.searchData.pageSize = this.pageSize;
            that_2._http.post(url, this.searchData).subscribe(function (result) {
                that_2.selectedAll = false;
                that_2.disabledButton = false;
                that_2.employeeData = result.content;
                that_2.employeePageData = result;
                that_2.getData();
                if (that_2.employeeData.length == 0) {
                    that_2.showLoading = false;
                }
                that_2.collectionSize = result.totalElements;
                if (result.last) {
                    that_2.endingPage = that_2.collectionSize;
                }
            });
        }
        catch (e) {
            console.log('error', e);
        }
    };
    EmployeeInRoleComponent.prototype.selectAll = function (event) {
        for (var i = 0; i < this.employeeData.length; i++) {
            this.employeeData[i].selected = this.selectedAll;
            this.getAllSelectedEmployee(this.employeeData[i], event);
        }
    };
    EmployeeInRoleComponent.prototype.checkIfAllSelected = function (employee, $event) {
        this.selectedAll = this.employeeData.every(function (item) {
            return item.selected == true;
        });
        this.getAllSelectedEmployee(employee, $event);
    };
    EmployeeInRoleComponent.prototype.getAllSelectedEmployee = function (emp, event) {
        var that = this;
        if (event.target.checked) {
            that.allSelectedEmplUserIds.push(emp.userId);
        }
        else {
            underscore["each"](that.allSelectedEmplUserIds, function (key, val) {
                if (emp.userId == key) {
                    that.allSelectedEmplUserIds.splice(val, 1);
                }
            });
        }
    };
    EmployeeInRoleComponent.prototype.goBack = function () {
        this._location.back();
    };
    return EmployeeInRoleComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/rolesAndPermission.ts

var rolesAndPermission_RolesAndPermissionComponent = /*@__PURE__*/ (function () {
    function RolesAndPermissionComponent(route, modalService, _global, _http, builder, _auth, router, _location, share, translate, _toaster, vcr) {
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this._http = _http;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this._location = _location;
        this.share = share;
        this.translate = translate;
        this._toaster = _toaster;
        this.showLoading = true;
        //pagination variables  and default values
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.trackHides = null;
        this.roles = 1;
        this.completeRolesAndPermissionData = [];
        this.rolePageData = [];
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.getCompleteRolesAndPermissionDetails();
        this._toaster.setViewRef(vcr);
    }
    //pagination functions
    RolesAndPermissionComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event == 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getCompleteRolesAndPermissionDetails();
    };
    RolesAndPermissionComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getCompleteRolesAndPermissionDetails();
    };
    //cal to get all the roles 
    RolesAndPermissionComponent.prototype.getCompleteRolesAndPermissionDetails = function () {
        var _this = this;
        try {
            var that = this;
            var url = that._baseUrl + 'v1/webAdmin/role';
            that._http.put(url, { page: that.page, pageSize: that.pageSize }).subscribe(function (result) {
                var self = _this;
                self.completeRolesAndPermissionData = result.content;
                self.rolePageData = result;
                if (self.completeRolesAndPermissionData.length == 0) {
                    self.showLoading = false;
                }
                self.collectionSize = result.totalElements;
                if (result.last) {
                    self.endingPage = self.collectionSize;
                }
            });
        }
        catch (e) {
            console.log('caught error in getCompleteRolesAndPermissionDetails', e);
        }
    };
    RolesAndPermissionComponent.prototype.createRoles = function () {
        try {
            var that_1 = this;
            var url = that_1._baseUrl + 'v1/webAdmin/role';
            that_1._http.get(url).subscribe(function (result) {
                that_1.share.saveAsMap('roleData', result);
                that_1.share.saveAsMap('type', 'CREATE');
                that_1.router.navigate(['/menu/createRoles']);
            });
        }
        catch (e) {
        }
    };
    RolesAndPermissionComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    //roles actions hide/show and functions
    RolesAndPermissionComponent.prototype.empTableActions = function (value) {
        if (this.trackHides == value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    RolesAndPermissionComponent.prototype.editRoles = function (id) {
        try {
            var that_2 = this;
            that_2.trackHides = null;
            var url = that_2._baseUrl + 'v1/webAdmin/role/getEditRoleById' + '?roleId=' + id;
            ;
            that_2._http.get(url).subscribe(function (result) {
                that_2.share.saveAsMap('roleData', result);
                that_2.share.saveAsMap('type', 'EDIT');
                that_2.router.navigate(['/menu/createRoles']);
            });
        }
        catch (e) {
            console.log('caught in edit Roles', e);
        }
    };
    RolesAndPermissionComponent.prototype.addUserRoles = function (id) {
        this.share.saveData({ id: id, type: 'ADDROLE' });
        this.router.navigate(['/menu/addUsers']);
    };
    RolesAndPermissionComponent.prototype.removeUserRoles = function (id) {
        this.share.saveData({ id: id, type: 'DELETEROLE' });
        this.router.navigate(['/menu/addUsers']);
    };
    RolesAndPermissionComponent.prototype.viewDetails = function (id) {
        this.share.saveData(id);
        this.router.navigate(['/menu/EmployeeInRole']);
    };
    RolesAndPermissionComponent.prototype.deleteUser = function (id) {
        this.trackHides = null;
        var closeResult;
        this.share.saveData(id);
        var confirmData = {
            type: 'Delete',
            program: id
        };
        var self = this;
        self.share.saveData(confirmData);
        var modalRef = self.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result == 'confirmed') {
                var url = self._baseUrl + 'v1/webAdmin/role' + '?roleId=' + id;
                self._http.delete(url).subscribe(function (result) {
                    if (result.success) {
                        self.translate.get('roleDelete').subscribe(function (msg) {
                            self._toaster.showSuccess(msg);
                            self.onRefresh();
                        });
                    }
                    else {
                        self.translate.get('roleCouldNotDelete').subscribe(function (msg) {
                            self._toaster.showError(msg);
                        });
                    }
                });
            }
        }, function (reason) {
            closeResult = "Dismissed " + reason;
        });
    };
    RolesAndPermissionComponent.prototype.confirmDelete = function (id) {
        try {
            var that = this;
            var url = that._baseUrl + 'v1/webAdmin/role/getEmployeeInfoByRoleId/' + id;
            that._http.post(url, {}).subscribe(function (result) {
            });
        }
        catch (e) {
            console.log('error', e);
        }
    };
    RolesAndPermissionComponent.prototype.onRefresh = function () {
        this.getCompleteRolesAndPermissionDetails();
    };
    return RolesAndPermissionComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/tenantPreference.ts


var tenantPreference_TenantPreferenceComponent = /*@__PURE__*/ (function () {
    function TenantPreferenceComponent(route, activeModal, _location, _toast, viewContainerRef, _http, _global, translate, _share, _auth) {
        this.route = route;
        this.activeModal = activeModal;
        this._location = _location;
        this._toast = _toast;
        this.viewContainerRef = viewContainerRef;
        this._http = _http;
        this._global = _global;
        this.translate = translate;
        this._share = _share;
        this._auth = _auth;
        this.displayPreferences = 2;
        this.tenantFont = null;
        this.num = 123;
        this.numberOfMonthsDateTargetCanExceed = 0;
        this.arr = [];
        this.payloadArray = [];
        this.tenantImageDataHolder = {
            attachment: { docName: null, docType: null, document: null, docId: null },
            biAttachment: { docName: null, docType: null, document: null, docId: null },
            isTenantImage: true,
        };
        this.tenantLoginLogoDataHolder = {
            attachment: { docName: null, docType: null, document: null, docId: null },
            biAttachment: { docName: null, docType: null, document: null, docId: null },
            isTenantImage: true,
        };
        this.tenantLoaderDataHolder = {
            attachment: { docName: null, docType: null, document: null, docId: null },
            biAttachment: { docName: null, docType: null, document: null, docId: null },
            isTenantImage: true,
        };
        this.allow = false;
        this.client = 'KEA';
        this.isScorecardHistoryEnabled = true;
        this.isDisplayTenantLogoInUserPicture = false;
        this.changedConfigData = [];
        this.changeRelationship = true;
        this.resetToCreated = true;
        this.reflectChanges = true;
        this.changeAndReset = true;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        _toast.setViewRef(viewContainerRef);
        this.getAll();
        this.onInputChange();
        this.client = environment["a" /* environment */].client;
        this.getTenantFont();
    }
    TenantPreferenceComponent.prototype.getAll = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/tenantConfig/getConfigData';
            this._http.get(url).subscribe(function (result) {
                _this.formatData(result);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    TenantPreferenceComponent.prototype.saveTenantConfigData = function (changedConfigData) {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/tenantConfig/saveTenantConfigurations';
            this._http.post(url, changedConfigData).subscribe(function (result) {
                if (result.data == null && result.success) {
                    _this.translate.get('tenantConfigSaved').subscribe(function (msg) {
                        _this._toast.showSuccess(msg);
                        _this.payloadArray = [];
                        _this.arr = [];
                        _this.getAll();
                        _this.onInputChange();
                        _this.client = environment["a" /* environment */].client;
                        _this.getTenantFont();
                    });
                }
                else {
                    _this.translate.get('errorUpdateTenantConfig').subscribe(function (msg) {
                        _this._toast.showError(msg);
                    });
                }
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    TenantPreferenceComponent.prototype.onInputChange = function () {
        var n = 123;
        this.num = n.toFixed(this.displayPreferences);
    };
    TenantPreferenceComponent.prototype.formatData = function (data) {
        var self = this;
        underscore["each"](data, function (key, val) {
            self.getDefaultValues(key.key, key.value, key.id);
        });
    };
    TenantPreferenceComponent.prototype.getDefaultValues = function (key, value, id) {
        var self = this;
        if (key == 'UPLOAD_PHOTO') {
            this.allow = value;
        }
        if (key == 'ANNOUNCEMENT_PERMISSION') {
            this.userCanShareWith = value;
        }
        if (key == 'WEIGHTAGE_VIEW_DF') {
            self.displayPreferences = value;
        }
        if (key == 'PAGINATION_VALUE') {
            self.paginationValue = value;
        }
        if (key == 'SCD_COLLABORATION') {
            self.scd = value;
            var val = value.split(',');
            if (val.length > 0) {
                underscore["each"](val, function (k, v) {
                    if (k == 'SHARE') {
                        self.share = true;
                    }
                    if (k == 'COMMENT') {
                        self.comment = true;
                    }
                    if (k == 'DISCUSSION') {
                        self.discuss = true;
                    }
                    if (k == 'LIKE') {
                        self.like = true;
                    }
                });
            }
        }
        if (key == 'SHARE_CONFIGURATION') {
            self.shareWith = value;
        }
        if (key == 'AGGREGATE_APPLICABLE_UOMS') {
            self.applicableUOMValue = value;
        }
        if (key == 'ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM') {
            self.enableAverageOption = (value == 'true');
        }
        if (key == 'ENABLE_ANALYTICS') {
            self.enableAnalytics = (value == 'true');
        }
        if (key == 'ANALYTICS_TOKEN') {
            self.analyticsToken = value;
        }
        if (key == 'MONTH_START') {
            self.monthStartDay = value;
        }
        if (key == 'WK_START') {
            self.weekStartDay = value;
        }
        if (key == 'PAGINATION_VALUE_PER_GRID') {
            self.paginationValueGrid = value;
        }
        if (key == 'EMAIL_DOMAIN_ALLOWED') {
            self.emailDomain = value;
        }
        if (key == 'MAX_EXTRA_MONTHS_CAN_SHOW_FOR_DATE_BASED_KPI') {
            self.numberOfMonthsDateTargetCanExceed = value;
        }
        if (key == 'MOBILE_SESSION_TIMEOUT') {
            self.logoutVal = value;
        }
        if (key == 'DATE_FORMAT') {
            self.dateFormat = value;
        }
        if (key == 'PRIMARY_COLOR') {
            self.primaryColor = value;
        }
        if (key == 'THINGS_TO_DO') {
            self.isToDoEnabled = value;
        }
        if (key == 'PUSH_KPI_OPTION_ENABLED') {
            self.pushKpiEnabled = value;
        }
        if (key == 'SCORECARD_HISTORY') {
            self.isScorecardHistoryEnabled = value;
        }
        if (key == 'SHOW_DISPLAY_PICTURE_AS_TENANT_LOGO') {
            if (value == 'true') {
                self.isDisplayTenantLogoInUserPicture = true;
            }
            else {
                self.isDisplayTenantLogoInUserPicture = false;
            }
        }
        if (key == 'COMMENT_ON_ADMIN_POST') {
            this.isCommentDisableForAdminPost = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'CAN_SELECT_MULTIPLE_USERS_TO_COACH') {
            this.canCoachMultipleUsers = value;
        }
        if (key == 'SHOW_OVERALL_SCORE_AS_DESCRIPTION') {
            if (value == 'true') {
                self.isOverallScoreAsDescription = true;
            }
            else {
                self.isOverallScoreAsDescription = false;
            }
        }
        if (key == 'TO_DO_CARD_FOR_TASK_ASSIGNED') {
            if (value == 'true') {
                self.isToDoTaskAssigned = true;
            }
            else {
                self.isToDoTaskAssigned = false;
            }
        }
        if (key == 'HEADER_COLOR') {
            self.headerColor = value;
        }
        if (key == 'ALLOW_MULTIPLE_STRATEGY') {
            self.allowMultipleStrategy = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'ROUNDOFF_OVERALL_SCORE') {
            self.isRoundOffOverallScore = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'SUPERVISOR_CAN_VIEW_ANNUAL_SCORE') {
            self.canSuperviosrViewAnnualScore = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'SWITCH_USER_CAN_VIEW_ANNUAL_SCORE') {
            self.canSwitchViewAnnualScore = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'EMPLOYEE_CAN_VIEW_ANNUAL_SCORE') {
            self.canEmployeeViewAnnualScore = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'IN_REPORT_CAN_VIEW_ANNUAL_SCORE') {
            self.canReportViewAnnualScore = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'CHANGE_SUBORD_KPI') {
            self.reflectChanges = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'CHANGE_RELATIONSHIP_AS_TRANSLATE') {
            self.changeRelationship = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'RESET_SUBORD_SC_TO_CREATED') {
            self.resetToCreated = value.toLowerCase() == 'true' ? true : false;
        }
        if (key == 'CHANGE_SUBORD_KPI_TO_INDIVIDUAL_AND_RESET') {
            self.changeAndReset = value.toLowerCase() == 'true' ? true : false;
        }
        self.arr.push({ id: id, configKey: key, value: value });
    };
    TenantPreferenceComponent.prototype.allowPicture = function (event) {
        this.allow = event.target.checked;
    };
    TenantPreferenceComponent.prototype.disableTodo = function (event) {
        this.isToDoEnabled = !event.target.checked;
    };
    TenantPreferenceComponent.prototype.updatePushKpiOption = function (event) {
        this.pushKpiEnabled = event.target.checked;
    };
    TenantPreferenceComponent.prototype.disableCoachMultipleUsers = function (event) {
        this.canCoachMultipleUsers = event.target.checked;
    };
    TenantPreferenceComponent.prototype.disableScorecardHistory = function (event) {
        this.isScorecardHistoryEnabled = !event.target.checked;
    };
    TenantPreferenceComponent.prototype.formatPayload = function () {
        var _this = this;
        var flag = false;
        var self = this;
        this.saveImage();
        this.saveLogoImage();
        this.saveLoaderImage();
        if (this.tenantFont != null && this.tenantFont != 'null') {
            this.saveTenantFont();
        }
        if (this.displayPreferences === '' || this.displayPreferences == null) {
            this.translate.get('displayPrefMandatory').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        if (this.paginationValue === '' || this.paginationValue == null) {
            this.translate.get('recordMandatoryHub').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        if (this.paginationValue < 1) {
            this.translate.get('recordCanNotBeZero').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        if (this.paginationValue > 100) {
            this.translate.get('recordCanNotBeGrtHun').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        if (this.paginationValueGrid === '' || this.paginationValueGrid == null) {
            this.translate.get('displayGridMand').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        if (this.paginationValueGrid < 1) {
            this.translate.get('displayGridZero').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        if (this.paginationValueGrid > 100) {
            this.translate.get('gridGreaterThanHund').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        if (!(this.changeRelationship || this.reflectChanges || this.resetToCreated)) {
            this.translate.get('selectSubordinateScorecardOption').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        for (var i = 0; i < self.arr.length; i++) {
            flag = self.getPayload(self.arr[i].id, self.arr[i].configKey, self.arr[i].value);
            if (!flag) {
                return;
            }
        }
        if (flag) {
            this.changedData(this.payloadArray);
        }
    };
    TenantPreferenceComponent.prototype.changedData = function (configPayload) {
        var self = this;
        self.changedConfigData = [];
        underscore["each"](self.arr, function (element, index) {
            if (configPayload[index].configKey == element.configKey) {
                if (configPayload[index].value != element.value) {
                    self.changedConfigData.push(configPayload[index]);
                }
            }
        });
        self.saveTenantConfigData(self.changedConfigData);
    };
    TenantPreferenceComponent.prototype.getPayload = function (id, key, value) {
        if (key == 'WEIGHTAGE_VIEW_DF' ||
            key == 'WEIGHTAGE_DF' ||
            key == 'TARGET_ACTUAL_DF' ||
            key == 'PERF_SCORE_DF') {
            value = this.displayPreferences;
        }
        if (key == 'PAGINATION_VALUE') {
            value = this.paginationValue;
        }
        if (key == 'SCD_COLLABORATION') {
            var val = [];
            if (this.share) {
                val.push('SHARE');
            }
            if (this.comment) {
                val.push('COMMENT');
            }
            if (this.discuss) {
                val.push('DISCUSSION');
            }
            if (this.like) {
                val.push('LIKE');
            }
            value = val.join();
        }
        if (key == 'SHARE_CONFIGURATION') {
            value = this.shareWith;
        }
        if (key == 'AGGREGATE_APPLICABLE_UOMS') {
            value = this.applicableUOMValue;
        }
        if (key == 'MONTH_START') {
            value = this.monthStartDay;
        }
        if (key == 'WK_START') {
            value = this.weekStartDay;
        }
        if (key == 'PAGINATION_VALUE_PER_GRID') {
            value = this.paginationValueGrid;
        }
        if (key == 'EMAIL_DOMAIN_ALLOWED') {
            value = this.emailDomain;
        }
        if (key == 'ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM') {
            value = JSON.stringify(this.enableAverageOption);
        }
        if (key == 'MAX_EXTRA_MONTHS_CAN_SHOW_FOR_DATE_BASED_KPI') {
            value = this.numberOfMonthsDateTargetCanExceed;
        }
        if (key == 'ENABLE_ANALYTICS') {
            value = JSON.stringify(this.enableAnalytics);
        }
        if (key == 'ANALYTICS_TOKEN') {
            value = this.analyticsToken;
        }
        if (key == 'MOBILE_SESSION_TIMEOUT') {
            value = this.logoutVal;
        }
        if (key == 'DATE_FORMAT') {
            value = this.dateFormat;
        }
        if (key == 'UPLOAD_PHOTO') {
            value = this.allow;
        }
        if (key == 'ANNOUNCEMENT_PERMISSION') {
            value = this.userCanShareWith;
        }
        if (key == 'PRIMARY_COLOR') {
            value = this.primaryColor;
        }
        if (key == 'THINGS_TO_DO') {
            value = this.isToDoEnabled;
        }
        if (key == 'PUSH_KPI_OPTION_ENABLED') {
            value = this.pushKpiEnabled;
        }
        if (key == 'SCORECARD_HISTORY') {
            value = this.isScorecardHistoryEnabled;
        }
        if (key == 'SHOW_DISPLAY_PICTURE_AS_TENANT_LOGO') {
            value = JSON.stringify(this.isDisplayTenantLogoInUserPicture);
        }
        if (key == 'COMMENT_ON_ADMIN_POST') {
            value = JSON.stringify(this.isCommentDisableForAdminPost);
        }
        if (key == 'CAN_SELECT_MULTIPLE_USERS_TO_COACH') {
            value = this.canCoachMultipleUsers;
        }
        if (key == 'SHOW_OVERALL_SCORE_AS_DESCRIPTION') {
            value = JSON.stringify(this.isOverallScoreAsDescription);
        }
        if (key == 'HEADER_COLOR') {
            value = this.headerColor;
        }
        if (key == 'ALLOW_MULTIPLE_STRATEGY') {
            value = JSON.stringify(this.allowMultipleStrategy);
        }
        if (key == 'ROUNDOFF_OVERALL_SCORE') {
            value = JSON.stringify(this.isRoundOffOverallScore);
        }
        if (key == 'TO_DO_CARD_FOR_TASK_ASSIGNED') {
            value = this.isToDoTaskAssigned;
        }
        if (key == 'SUPERVISOR_CAN_VIEW_ANNUAL_SCORE') {
            value = this.canSuperviosrViewAnnualScore;
        }
        if (key == 'SWITCH_USER_CAN_VIEW_ANNUAL_SCORE') {
            value = this.canSwitchViewAnnualScore;
        }
        if (key == 'EMPLOYEE_CAN_VIEW_ANNUAL_SCORE') {
            value = this.canEmployeeViewAnnualScore;
        }
        if (key == 'IN_REPORT_CAN_VIEW_ANNUAL_SCORE') {
            value = this.canReportViewAnnualScore;
        }
        if (key == 'CHANGE_SUBORD_KPI') {
            value = this.reflectChanges;
        }
        if (key == 'CHANGE_RELATIONSHIP_AS_TRANSLATE') {
            value = this.changeRelationship;
        }
        if (key == 'RESET_SUBORD_SC_TO_CREATED') {
            value = this.resetToCreated;
        }
        if (key == 'CHANGE_SUBORD_KPI_TO_INDIVIDUAL_AND_RESET') {
            value = this.changeAndReset;
        }
        this.payloadArray.push({ id: id, configKey: key, value: value });
        return true;
    };
    TenantPreferenceComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    TenantPreferenceComponent.prototype.onSelectionChange = function ($event) {
    };
    TenantPreferenceComponent.prototype.fileChange = function (event) {
        var _this = this;
        console.log(event);
        var fileList = event.target.files;
        var result;
        if (fileList.length > 0) {
            var file = fileList[0];
            var fileName_1 = file.name;
            var path_1 = event.target.value;
            var reader = new FileReader();
            reader.onloadend = function (e) {
                result = e.target.result;
                _this.getAllData(path_1, fileName_1, result);
            };
            reader.readAsBinaryString(file);
        }
    };
    TenantPreferenceComponent.prototype.BIFileChange = function (event) {
        var _this = this;
        var fileList = event.target.files;
        var result;
        if (fileList.length > 0) {
            var file = fileList[0];
            var fileName_2 = file.name;
            var path_2 = event.target.value;
            var reader = new FileReader();
            reader.onloadend = function (e) {
                result = e.target.result;
                _this.getAllBIData(path_2, fileName_2, result);
            };
            reader.readAsBinaryString(file);
        }
    };
    TenantPreferenceComponent.prototype.getAllBIData = function (path, fileNames, result) {
        var a = path.split('/');
        var fileName = a.pop();
        var fileNameArray = fileName.split('.');
        var onlyName = fileNameArray[0];
        var ext = fileNameArray[1];
        this.tenantImageDataHolder.biAttachment = {
            docName: fileNames,
            docType: ext,
            document: window.btoa(result),
            docId: null
        };
    };
    TenantPreferenceComponent.prototype.getAllData = function (path, fileNames, result) {
        var a = path.split('/');
        var fileName = a.pop();
        var fileNameArray = fileName.split('.');
        var onlyName = fileNameArray[0];
        var ext = fileNameArray[1];
        this.tenantImageDataHolder.attachment = {
            docName: fileNames,
            docType: ext,
            document: window.btoa(result),
            docId: null
        };
    };
    TenantPreferenceComponent.prototype.saveImage = function () {
        var _this = this;
        try {
            console.log(this.tenantImageDataHolder);
            var url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantImage';
            this._http.put(url, this.tenantImageDataHolder).subscribe(function (result) {
                _this.getEmployeeDetail();
            });
        }
        catch (e) {
            console.log('Upload error', e);
        }
    };
    TenantPreferenceComponent.prototype.saveTenantFont = function () {
        try {
            var url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantFont/' + this.tenantFont;
            this._http.post(url, {}).subscribe(function (result) {
            });
        }
        catch (e) {
            console.log('tenant font error', e);
        }
    };
    TenantPreferenceComponent.prototype.getTenantFont = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantFont';
            this._http.get(url).subscribe(function (result) {
                if (result.data != null) {
                    _this.tenantFont = result.data;
                }
            });
        }
        catch (e) {
            console.log('Upload error', e);
        }
    };
    TenantPreferenceComponent.prototype.logoFileChange = function (event) {
        var _this = this;
        console.log(event);
        var fileList = event.target.files;
        var result;
        if (fileList.length > 0) {
            var file = fileList[0];
            var fileName_3 = file.name;
            var path_3 = event.target.value;
            var reader = new FileReader();
            reader.onloadend = function (e) {
                result = e.target.result;
                _this.getAllLogonLogoData(path_3, fileName_3, result);
            };
            reader.readAsBinaryString(file);
        }
    };
    TenantPreferenceComponent.prototype.loaderFileChange = function (event) {
        var _this = this;
        console.log(event);
        var fileList = event.target.files;
        var result;
        if (fileList.length > 0) {
            var file = fileList[0];
            var fileName_4 = file.name;
            var path_4 = event.target.value;
            var reader = new FileReader();
            reader.onloadend = function (e) {
                result = e.target.result;
                _this.getAllLoaderData(path_4, fileName_4, result);
            };
            reader.readAsBinaryString(file);
        }
    };
    TenantPreferenceComponent.prototype.getAllLogonLogoData = function (path, fileNames, result) {
        var a = path.split('/');
        var fileName = a.pop();
        var fileNameArray = fileName.split('.');
        var onlyName = fileNameArray[0];
        var ext = fileNameArray[1];
        this.tenantLoginLogoDataHolder.attachment = {
            docName: fileNames,
            docType: ext,
            document: window.btoa(result),
            docId: null
        };
    };
    TenantPreferenceComponent.prototype.getAllLoaderData = function (path, fileNames, result) {
        var _this = this;
        var a = path.split('/');
        var fileName = a.pop();
        var fileNameArray = fileName.split('.');
        var onlyName = fileNameArray[0];
        var ext = fileNameArray[1];
        if (ext != 'gif') {
            this.translate.get('Please Select Gif File').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        else {
            this.tenantLoaderDataHolder.attachment = {
                docName: fileNames,
                docType: ext,
                document: window.btoa(result),
                docId: null
            };
        }
    };
    TenantPreferenceComponent.prototype.saveLogoImage = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantLogo';
            this._http.put(url, this.tenantLoginLogoDataHolder).subscribe(function (result) {
                _this.getEmployeeDetail();
            });
        }
        catch (e) {
            console.log('Upload error', e);
        }
    };
    TenantPreferenceComponent.prototype.saveLoaderImage = function () {
        var _this = this;
        try {
            console.log('logo data::' + this.tenantLoaderDataHolder);
            var url = this._baseUrl + 'v1/webAdmin/tenantConfig/tenantLoader';
            this._http.put(url, this.tenantLoaderDataHolder).subscribe(function (result) {
                _this.getEmployeeDetail();
            });
        }
        catch (e) {
            console.log('Upload error', e);
        }
    };
    TenantPreferenceComponent.prototype.allowSameLogo = function (event) {
        if (event.target.checked == true) {
            this.allowBI = false;
            this.tenantImageDataHolder.isTenantImage = true;
        }
        else {
            this.allowBI = true;
            this.tenantImageDataHolder.isTenantImage = false;
        }
    };
    TenantPreferenceComponent.prototype.getEmployeeDetail = function () {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/hub/employeeInfo';
        return self._http.get(url).subscribe(function (result) {
            _this._auth.updateUser(result);
        });
    };
    return TenantPreferenceComponent;
}());



// CONCATENATED MODULE: ./node_modules/rxjs-compat/_esm5/Subject.js

//# sourceMappingURL=Subject.js.map
// CONCATENATED MODULE: ./src/app/tools/userGroup/addUserGroup.ts





var addUserGroup_AddUserGroupComponent = /*@__PURE__*/ (function () {
    function AddUserGroupComponent(route, modalService, _global, http, _sanitizer, builder, router, _location, share, translate, _toaster, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this.http = http;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this.router = router;
        this._location = _location;
        this.share = share;
        this.translate = translate;
        this._toaster = _toaster;
        this.addOrgEvent = new core["EventEmitter"]();
        this.orgTypeData = [];
        this.type = 'ADD';
        this.asl = false;
        this.oldValue = null;
        this.empPresent = false;
        this.cancelEvent = new core["EventEmitter"]();
        this.arrayOfStrings = [];
        this.categoryData = [];
        this._failure = new _esm5["e" /* Subject */]();
        this._success = new _esm5["e" /* Subject */]();
        this.warning = "Please type to select";
        // tslint:disable-next-line:member-ordering
        this.payload = {
            searchString: "",
            excludeEmpIds: []
        };
        this.userGroupdata = {
            id: null,
            name: null,
            description: null,
            version: null,
            roleGroups: [],
            userGroups: [],
            userCount: null,
        };
        this.errorMsg = {
            "USER_NAME_EXISTS": "User name already exists",
            "EMAIL_EXISTS": "Email id already exists",
            "EMPCODE_EXISTS": "Employee code already exists"
        };
        //to get list of Organization based on keyword
        this.orgTypeObservableSource = function (keyword) {
            try {
                var url = _this._baseUrl + "v1/webAdmin/orgUnitType/autoComplete";
                url += '?name=' + keyword;
                if (keyword) {
                    return _this.http.get(url)
                        .map(function (res) {
                        var json = res.data;
                        return json;
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            catch (e) {
                console.log('catch orgUnitType Error');
            }
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.displayName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListFormatterType = function (data) {
            var html = "<span>" + data.type + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListGradeFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListOrgFormatter = function (data) {
            var html = "<span>" + data.orgName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        //to get list of designation based on keyword
        this.designationObservableSource = function (keyword) {
            try {
                var url = _this._baseUrl + "v1/webAdmin/designation/designationSearch";
                url += "?searchString=" + keyword + "&id=" + _this.userGroupdata.id;
                if (keyword.trim()) {
                    return _this.http.get(url)
                        .map(function (res) {
                        var json = res;
                        return json;
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            catch (e) { }
        };
        this.autoCompleteListOrgTypeFormatter = function (data) {
            var html = "<span>" + data.orgUnitTypeName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this._baseUrl = _global.get("EPMS_BASE_URL");
        var data = this.share.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            if (data.type == "ADD") {
                this.data = {};
                this.type = "ADD";
            }
            else if (data.type == "EDIT") {
                this.userGroupdata = data.userGroup;
                this.type = "EDIT";
            }
            else {
                this.userGroupdata = data.userGroup;
                this.type = "DELETE";
                var url = this._baseUrl + 'v1/webAdmin/designation/check/' + this.userGroupdata.id;
                this.http.get(url).subscribe(function (result) {
                    if (result.success) {
                        _this.empPresent = true;
                    }
                    else {
                        _this.empPresent = false;
                    }
                });
            }
        }
        this._toaster.setViewRef(vcr);
    }
    //when auto-complete value is selected this method fires and payload create
    AddUserGroupComponent.prototype.gotNewValue = function (e, type) {
        var _this = this;
        setTimeout(function () { _this.changeOldValue(); }, 1000);
        if (type == 'designation') {
        }
    };
    AddUserGroupComponent.prototype.changeOldValue = function () {
        var self = this;
        self.oldValue = null;
    };
    AddUserGroupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._failure.subscribe(function (message) { return _this.errorMessage = message; });
        debounceTime.call(this._failure, 5000).subscribe(function () { return _this.errorMessage = null; });
        this._success.subscribe(function (message) { return _this.successMessage = message; });
        debounceTime.call(this._success, 5000).subscribe(function () { return _this.successMessage = null; });
    };
    //Formatter
    AddUserGroupComponent.prototype.nameValueFormatter = function (data) {
        return "" + data.name;
    };
    AddUserGroupComponent.prototype.typeValueFormatter = function (data) {
        return "" + data.type;
    };
    AddUserGroupComponent.prototype.orgNameValueFormatter = function (data) {
        return "" + data.orgName;
    };
    //navigate back
    AddUserGroupComponent.prototype.goToBackPage = function () {
        this._location.back();
    };
    AddUserGroupComponent.prototype.editOrSave = function () {
        var _this = this;
        if (this.userGroupdata.name == null || this.userGroupdata.name == "") {
            this.translate.get('pleaseEnterNameToContinue').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
            return false;
        }
        delete this.userGroupdata.userCount;
        if (this.type == "ADD") {
            var url = this._baseUrl + 'v1/hub/userGroup/save';
            this.http.post(url, this.userGroupdata).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('userGroupSaved').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    setTimeout(function () { return _this.goToBackPage(); }, 1000);
                }
                else {
                    _this.translate.get('userGroupSaved').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                        var val = _a[_i];
                        _this._toaster.showError(val);
                    }
                }
            });
        }
        if (this.type == "EDIT") {
            var url = this._baseUrl + 'v1/hub/userGroup/' + this.userGroupdata.id;
            this.http.put(url, this.userGroupdata).subscribe(function (result) {
                if (result.success) {
                    _this.translate.get('userGroupUpdatedSuccessfully').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                        setTimeout(function () { return _this.goToBackPage(); }, 1000);
                    });
                }
                else {
                    _this.translate.get('userGroupSaved').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                    for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                        var val = _a[_i];
                        _this._toaster.showError(val);
                    }
                }
            });
        }
    };
    AddUserGroupComponent.prototype.closeinputs = function () {
        this.cancelEvent.emit(true);
    };
    return AddUserGroupComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/userGroup/addUsersToGroup.ts


var addUsersToGroup_AddUsersToGroupComponent = /*@__PURE__*/ (function () {
    function AddUsersToGroupComponent(_global, http, router, _toaster, modalService, activeModal, share, _location, translate, vcr) {
        this._global = _global;
        this.http = http;
        this.router = router;
        this._toaster = _toaster;
        this.modalService = modalService;
        this.activeModal = activeModal;
        this.share = share;
        this._location = _location;
        this.translate = translate;
        this.selectedOption = 'everyone';
        this.deleteEmpCodes = [];
        this.empCodes = '';
        this.invalidEmployeeCodes = [];
        this.disableButton = false;
        this.type = "";
        this.disabledButton = false;
        //pagination variables  and default values
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.searchData = {
            "nameOrCodeOrEmail": "",
            "employeeCodes": [],
            "excludedEmployeeCodes": [],
            "includeEmpIds": [],
            "excludeEmpIds": [],
            "gradeIds": [],
            "mgrLevelIds": [],
            "designationIds": [],
            "categoryIds": [],
            "includeOrgIds": [],
            "excludeOrgIds": [],
            "supervisorIds": [],
            "primarySupervisorIds": [],
            "primarySupervisorNameOrCode": null,
            "primarySupervisorCods": [],
            "employeeStatus": null,
            "employeesWithOutSupervisor": null,
            "scorecardStates": null,
            "memberShipState": null,
            "programId": null,
            "pageSize": 10,
            "page": 1,
            "fetchSupervisorLevels": 0
        };
        this.allSelectedEmplUserIds = [];
        this.employeeData = [];
        this.employeePageData = {};
        this.updateRate = new core["EventEmitter"]();
        this.asl = false;
        this.showChild = false;
        this.localState = { value: '' };
        this.orgData = [];
        this.trackHides = null;
        this.showAdvanceSearch = false;
        this.showLoading = false;
        this._baseUrl = _global.get("EPMS_BASE_URL");
        var data = this.share.getData();
        if (underscore["isEmpty"](data)) {
            this._location.back();
        }
        else {
            this.type = data.type;
            this.groupId = data.userGroup;
            if (this.type == "DELETEUSERS") {
                this.getEmployeeDetails();
            }
            this._toaster.setViewRef(vcr);
        }
    }
    AddUsersToGroupComponent.prototype.rolesBack = function () {
        this._location.back();
    };
    AddUsersToGroupComponent.prototype.showAdvanced = function () {
        this.share.saveAsMap('UserGroup', this.groupId);
        this.router.navigate(['menu/employeeSearch']);
    };
    AddUsersToGroupComponent.prototype.getEmployeeDetails = function () {
        try {
            var that_1 = this;
            var url = that_1._baseUrl + 'v1/hub/userGroup/getEmployeeInfoByGroupId/' + that_1.groupId;
            that_1.http.post(url, this.searchData).subscribe(function (result) {
                that_1.selectedAll = false;
                that_1.disabledButton = false;
                that_1.employeeData = result.content;
                that_1.employeePageData = result;
                that_1.allSelectedEmplUserIds.length = 0;
                if (that_1.employeeData.length == 0) {
                    that_1.showLoading = false;
                }
                that_1.collectionSize = result.totalElements;
                if (result.last) {
                    that_1.endingPage = that_1.collectionSize;
                }
            });
        }
        catch (e) {
            console.log('error', e);
        }
    };
    AddUsersToGroupComponent.prototype.removeUsers = function () {
        this.invalidEmployeeCodes = [];
        this.deleteEmpCodes = [];
        if (this.validateEmpCodes()) {
            this.finalRemoveUsers();
        }
    };
    AddUsersToGroupComponent.prototype.addUsers = function () {
        this.invalidEmployeeCodes = [];
        if (this.selectedOption == 'everyone') {
            this.finalAddUsers('assignGroupToAllEmployees');
        }
        if (this.selectedOption == 'except') {
            this.searchData.excludedEmployeeCodes = [];
            if (this.validateEmpCodes()) {
                this.finalAddUsers('assignGroupExcludeEmployeeCodes');
            }
        }
        if (this.selectedOption == 'everyoneIn') {
            this.searchData.employeeCodes = [];
            if (this.validateEmpCodes()) {
                this.finalAddUsers('assignGroupIncludeEmployeeCodes');
            }
        }
    };
    AddUsersToGroupComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.onPageChange(1);
    };
    AddUsersToGroupComponent.prototype.clicked = function () {
    };
    AddUsersToGroupComponent.prototype.onPageChange = function (event) {
        if (event == 1) {
            this.startingPage = 0;
            if (this.employeeData.length > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = this.employeeData.length;
            }
        }
        else {
            this.startingPage = 0 + ((event - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((event - 1) * +this.pageSize);
            if (this.endingPage > this.employeeData.length) {
                this.endingPage = this.employeeData.length;
            }
        }
    };
    AddUsersToGroupComponent.prototype.finalRemoveUsers = function () {
        var _this = this;
        var that = this;
        that.disableButton = true;
        var url = that._baseUrl + 'v1/hub/userGroup/removeGroupUsers/' + that.groupId;
        that.http.post(url, that.deleteEmpCodes).subscribe(function (result) {
            that.disableButton = false;
            if (result.success) {
                _this.translate.get('userRemoved').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
                setTimeout(function () { that.rolesBack(); }, 1000);
            }
            else {
                _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                    that._toaster.showError(msg);
                });
            }
        });
    };
    AddUsersToGroupComponent.prototype.finalAddUsers = function (option) {
        var _this = this;
        var that = this;
        var flag = false;
        that.disableButton = true;
        var url = that._baseUrl + 'v1/hub/userGroup/' + option + '/' + that.groupId;
        that.http.post(url, that.searchData).subscribe(function (result) {
            that.disableButton = false;
            if (option == 'assignGroupToAllEmployees') {
                if (result) {
                    flag = true;
                }
            }
            else {
                if (result.status) {
                    flag = true;
                }
            }
            if (flag) {
                _this.translate.get('usersAdded').subscribe(function (msg) {
                    that._toaster.showSuccess(msg);
                });
                setTimeout(function () { that.rolesBack(); }, 1000);
            }
            else {
                _this.translate.get(result.errorMessages[0]).subscribe(function (msg) {
                    that._toaster.showError(msg);
                });
                if (result.invalidEmployeeCodes.length > 0) {
                    that.getInvalidEmpCode(result.invalidEmployeeCodes);
                }
            }
        });
    };
    AddUsersToGroupComponent.prototype.validateEmpCodes = function () {
        var that = this;
        if (that.empCodes.trim() == '' || that.empCodes.length == 0) {
            this.translate.get('pleaseEnterEmpToContinue').subscribe(function (msg) {
                that._toaster.showError(msg);
            });
            return false;
        }
        else {
            var empCode = that.empCodes.split(',');
            underscore["each"](empCode, function (key, val) {
                if (that.selectedOption == 'everyoneIn') {
                    that.searchData.employeeCodes.push(key.trim());
                }
                if (that.selectedOption == 'except') {
                    that.searchData.excludedEmployeeCodes.push(key.trim());
                }
                if (that.selectedOption == 'everyone') {
                    that.deleteEmpCodes.push(key.trim());
                }
            });
        }
        return true;
    };
    AddUsersToGroupComponent.prototype.getInvalidEmpCode = function (invalidEmployeeCodes) {
        var that = this;
        underscore["each"](invalidEmployeeCodes, function (val, key) {
            that.invalidEmployeeCodes.push(val);
        });
    };
    AddUsersToGroupComponent.prototype.selectOption = function (option) {
        this.selectedOption = option;
        this.invalidEmployeeCodes = [];
    };
    return AddUsersToGroupComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/userGroup/employeesInGroup.ts

var employeesInGroup_EmployeeInGroupComponent = /*@__PURE__*/ (function () {
    function EmployeeInGroupComponent(route, modalService, _global, _http, builder, _auth, router, _location, share, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this._http = _http;
        this.builder = builder;
        this._auth = _auth;
        this.router = router;
        this._location = _location;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.showLoading = true;
        this.disabledButton = false;
        //pagination variables  and default values
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.searchData = {
            "nameOrCodeOrEmail": "",
            "employeeCodes": [],
            "excludedEmployeeCodes": [],
            "includeEmpIds": [],
            "excludeEmpIds": [],
            "gradeIds": [],
            "mgrLevelIds": [],
            "designationIds": [],
            "categoryIds": [],
            "includeOrgIds": [],
            "excludeOrgIds": [],
            "supervisorIds": [],
            "primarySupervisorIds": [],
            "primarySupervisorNameOrCode": null,
            "primarySupervisorCods": [],
            "employeeStatus": null,
            "employeesWithOutSupervisor": null,
            "scorecardStates": null,
            "memberShipState": null,
            "programId": null,
            "pageSize": 10,
            "page": 1,
            "fetchSupervisorLevels": 0
        };
        this.allSelectedEmplUserIds = [];
        this.employeeData = [];
        this.employeePageData = {};
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.id = this.share.getData();
        if (isNaN(this.id)) {
            this._location.back();
        }
        else {
            this._toaster.setViewRef(vcr);
            this.getEmployeeDetails();
        }
    }
    EmployeeInGroupComponent.prototype.getData = function () {
        underscore["each"](this.employeeData, function (key, val) {
            key.selected = false;
        });
    };
    EmployeeInGroupComponent.prototype.showSearchFilter = function (event) {
        ;
        this.searchData = event;
        this.getEmployeeDetails();
    };
    //pagination functions
    EmployeeInGroupComponent.prototype.onPageChange = function (event) {
        var that = this;
        if (event == 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getEmployeeDetails();
    };
    EmployeeInGroupComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getEmployeeDetails();
    };
    EmployeeInGroupComponent.prototype.deleteEmployee = function () {
        try {
            var that_1 = this;
            that_1.disabledButton = true;
            var url = that_1._baseUrl + 'v1/webAdmin/role/deleterRoleUserRelation/' + that_1.id;
            that_1._http.post(url, that_1.allSelectedEmplUserIds).subscribe(function (result) {
                if (result) {
                    that_1.translate.get('deleted').subscribe(function (msg) {
                        that_1._toaster.showSuccess(msg);
                    });
                    that_1.getEmployeeDetails();
                }
                else {
                    that_1.translate.get('failedDelete').subscribe(function (msg) {
                        that_1._toaster.showError(msg);
                    });
                    that_1.disabledButton = false;
                }
            });
        }
        catch (e) {
            console.log('error', e);
        }
    };
    EmployeeInGroupComponent.prototype.getEmployeeDetails = function () {
        try {
            var that_2 = this;
            var url = that_2._baseUrl + 'v1/hub/userGroup/getEmployeeInfoByGroupId/' + that_2.id;
            this.searchData.page = this.page;
            this.searchData.pageSize = this.pageSize;
            that_2._http.post(url, this.searchData).subscribe(function (result) {
                that_2.selectedAll = false;
                that_2.disabledButton = false;
                that_2.employeeData = result.content;
                that_2.employeePageData = result;
                that_2.allSelectedEmplUserIds.length = 0;
                that_2.getData();
                if (that_2.employeeData.length == 0) {
                    that_2.showLoading = false;
                }
                that_2.collectionSize = result.totalElements;
                if (result.last) {
                    that_2.endingPage = that_2.collectionSize;
                }
            });
        }
        catch (e) {
            console.log('error', e);
        }
    };
    EmployeeInGroupComponent.prototype.selectAll = function (event) {
        for (var i = 0; i < this.employeeData.length; i++) {
            this.employeeData[i].selected = this.selectedAll;
            this.getAllSelectedEmployee(this.employeeData[i], event);
        }
    };
    EmployeeInGroupComponent.prototype.checkIfAllSelected = function (employee, $event) {
        this.selectedAll = this.employeeData.every(function (item) {
            return item.selected == true;
        });
        this.getAllSelectedEmployee(employee, $event);
    };
    EmployeeInGroupComponent.prototype.getAllSelectedEmployee = function (emp, event) {
        var that = this;
        if (event.target.checked) {
            that.allSelectedEmplUserIds.push(emp.userId);
        }
        else {
            underscore["each"](that.allSelectedEmplUserIds, function (key, val) {
                if (emp.userId == key) {
                    that.allSelectedEmplUserIds.splice(val, 1);
                }
            });
        }
    };
    EmployeeInGroupComponent.prototype.goBack = function () {
        this._location.back();
    };
    return EmployeeInGroupComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/userGroup/userGroup.ts



var userGroup_UserGroupPage = /*@__PURE__*/ (function () {
    function UserGroupPage(route, modalService, router, _global, http, share, _sanitizer, builder, _toaster, translate, vcr) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this.translate = translate;
        this.vcr = vcr;
        this.updateRate = new core["EventEmitter"]();
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this.asl = false;
        this.showChild = false;
        this.localState = { value: '' };
        this.orgData = [];
        this.trackHides = null;
        this.showAdvanceSearch = false;
        this.userGroup = [];
        this.userPageData = [];
        this.showLoading = false;
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this._toaster.setViewRef(vcr);
        this.getAllUSergroup();
    }
    //pagination functions
    UserGroupPage.prototype.onPageChange = function (event) {
        var that = this;
        if (event == 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        }
        else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            }
            else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllUSergroup();
    };
    UserGroupPage.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllUSergroup();
    };
    UserGroupPage.prototype.addUserGrp = function () {
        this.share.saveData({ desgId: null, type: 'ADD' });
        this.router.navigate(['menu/addUserGroup']);
    };
    UserGroupPage.prototype.addUsers = function (val) {
        this.share.saveData({ userGroup: val, type: 'ADDUSERS' });
        this.router.navigate(['menu/addUsersToGroup']);
    };
    UserGroupPage.prototype.deleteUsers = function (val) {
        this.share.saveData({ userGroup: val, type: 'DELETEUSERS' });
        this.router.navigate(['menu/addUsersToGroup']);
    };
    UserGroupPage.prototype.editUserGrp = function (val) {
        this.share.saveData({ userGroup: val, type: 'EDIT' });
        this.router.navigate(['menu/addUserGroup']);
    };
    UserGroupPage.prototype.deleteUserGrp = function (val) {
        var _this = this;
        this.userGroup = val;
        this.share.saveData({ type: 'scaleRemove' });
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            _this.closeResult = "Closed with: " + result;
            if (result == 'confirmed') {
                _this.deleteGroup();
            }
        }, function (reason) {
            _this.closeResult = "Dismissed " + _this.getDismissReason(reason);
            _this.getAllUSergroup();
        });
    };
    UserGroupPage.prototype.viewDetails = function (id) {
        this.share.saveData(id);
        this.router.navigate(['/menu/EmployeeInGroup']);
    };
    UserGroupPage.prototype.clicked = function () {
        this.trackHides = null;
    };
    UserGroupPage.prototype.getDismissReason = function (reason) {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        }
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        }
        else {
            return "with: " + reason;
        }
    };
    UserGroupPage.prototype.deleteGroup = function () {
        var _this = this;
        var self = this;
        try {
            var url = self._baseUrl + "v1/hub/userGroup/" + self.userGroup.id;
            self.http.delete(url).subscribe(function (result) {
                if (result.success) {
                    self.translate.get('userGroupDeleted').subscribe(function (msg) {
                        self._toaster.showSuccess(msg);
                    });
                    _this.getAllUSergroup();
                }
                else {
                    for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                        var val = _a[_i];
                        self._toaster.showError(val);
                    }
                }
            });
        }
        catch (e) {
            self.translate.get('internalServerError').subscribe(function (msg) {
                self._toaster.showError(msg);
            });
        }
    };
    UserGroupPage.prototype.getAllUSergroup = function () {
        var self = this;
        try {
            self.showLoading = true;
            var url = self._baseUrl + "v1/hub/userGroup";
            // url += "?employeeId=" + 102;
            self.http.put(url, { page: self.page, pageSize: self.pageSize }).subscribe(function (result) {
                self.userGroup = result.content;
                self.userPageData = result;
                if (self.userGroup.length == 0) {
                    self.showLoading = false;
                }
                self.collectionSize = result.totalElements;
                if (result.last) {
                    self.endingPage = self.collectionSize;
                }
            });
        }
        catch (e) {
            console.log("getAllUserGroup error catch", e);
        }
    };
    UserGroupPage.prototype.empActions = function (val) {
        // this.hide = val;
    };
    UserGroupPage.prototype.empTableActions = function (value) {
        if (this.trackHides == value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    UserGroupPage.prototype.onRefresh = function () {
        this.getAllUSergroup();
    };
    return UserGroupPage;
}());



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/notificationFilter.ts
var NotificationFilter = /*@__PURE__*/ (function () {
    function NotificationFilter() {
        this.notificationChannels = ['Email', 'Stream'];
        this.notificationGroups = [];
        this.notificationTypes = [];
        this.page = 1;
        this.pageSize = 10;
    }
    return NotificationFilter;
}());



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/notificationGridComponent.ts


var notificationGridComponent_NotificationGridComponent = /*@__PURE__*/ (function () {
    function NotificationGridComponent(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, _location, vcr, translate) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this._location = _location;
        this.vcr = vcr;
        this.translate = translate;
        this.selectedNotificationTypeItems = [];
        this.showSearchFilter = false;
        this.notificationChannels = [
            {
                key: 'Email',
                value: 'Email'
            },
            {
                key: 'Stream',
                value: 'Stream'
            }
        ];
        this.notificationChannelsFiltered = [
            {
                key: 'Email',
                value: 'Email'
            },
            {
                key: 'Stream',
                value: 'Stream'
            }
        ];
        this.selectedNotificationChannels = [
            {
                key: 'Email',
                value: 'Email'
            },
            {
                key: 'Stream',
                value: 'Stream'
            }
        ];
        this.notificationFilter = new NotificationFilter();
        this.notifications = {
            content: [],
            numberOfElements: 0,
            totalElements: 0
        };
        this.notificationTypesTranslate = [];
        this.notificationTypes = [];
        this.notificationTypesTranslated = [];
        this.notificationTypesList = [];
        this.selectedNotificationGroup = null;
        this.allNotificationGroups = [];
        this.allNotificationTypes = [];
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.currentPage = 1;
        this.fetchNotifications();
        this.getNotificationTypes();
        this.getNotificationGroups();
        // this.prepareNotificationGroups();
        this.notificationTypesSettings = {
            text: 'Select Notification Types',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: '',
            primaryKey: 'key',
            labelKey: 'value',
            noDataLabel: 'Search  Notification Type',
            enableSearchFilter: true,
            badgeShowLimit: 3,
            searchBy: ['key', 'value']
        };
    }
    NotificationGridComponent.prototype.fetchNotifications = function () {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/notification/search';
        self.showLoading = false;
        self.http.post(url, this.notificationFilter).subscribe(function (result) {
            self.notifications = result;
            self.showLoading = false;
        }, function (error) {
            _this._toaster.showError('Can not load notifications');
            self.showLoading = false;
        });
    };
    NotificationGridComponent.prototype.editNotification = function (notification) {
        this.share.saveData({ notificationId: notification.id, eventId: notification.eventId });
        this.router.navigate(['menu/editNotifications']);
    };
    NotificationGridComponent.prototype.tableActions = function (index) {
        this.trackHides = index;
    };
    NotificationGridComponent.prototype.onPageSizeChanged = function () {
        this.fetchNotifications();
    };
    // Pagination functions
    NotificationGridComponent.prototype.onPageChange = function () {
        this.fetchNotifications();
    };
    NotificationGridComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    NotificationGridComponent.prototype.clicked = function () {
        this.trackHides = null;
        this.showSearchFilter = false;
    };
    NotificationGridComponent.prototype.toggleSearch = function () {
        this.showSearchFilter = this.showSearchFilter ? false : true;
    };
    NotificationGridComponent.prototype.getNotificationTypes = function () {
        var _this = this;
        var url = this._baseUrl + 'v1/webAdmin/notification/notificationTypes';
        this.http.post(url, {}).subscribe(function (result) {
            _this.allNotificationTypes = result;
            _this.prepareNotificationTypes();
        });
    };
    NotificationGridComponent.prototype.getNotificationGroups = function () {
        var _this = this;
        var url = this._baseUrl + 'v1/webAdmin/notification/notificationGroups';
        this.http.post(url, {}).subscribe(function (result) {
            _this.allNotificationGroups = result;
            // this.prepareNotificationGroups();
        });
    };
    // write a function where looks each element in array and tranlate it and push new array
    NotificationGridComponent.prototype.prepareNotificationTypes = function () {
        var self = this;
        underscore["each"](self.allNotificationTypes, function (key) {
            var obj = {};
            self.translate.get(key).subscribe(function (val) {
                obj['key'] = key;
                obj['value'] = val;
            });
            self.notificationTypesTranslated.push(obj);
            self.notificationTypesList.push(obj);
        });
    };
    NotificationGridComponent.prototype.searchAndFetchNotificationByFilterData = function () {
        if (this.selectedNotificationGroup) {
            if (this.notificationFilter.notificationGroups.indexOf(this.selectedNotificationGroup) == -1) {
                this.notificationFilter.notificationGroups = [];
                this.notificationFilter.notificationGroups.push(this.selectedNotificationGroup);
            }
        }
        this.notificationFilter.notificationTypes
            = this.getKeys(this.selectedNotificationTypeItems);
        this.notificationFilter.notificationChannels
            = this.getKeys(this.selectedNotificationChannels);
        this.fetchNotifications();
    };
    NotificationGridComponent.prototype.reset = function () {
        this.selectedNotificationGroup = null;
        this.selectedNotificationTypeItems = [];
        this.notificationFilter = new NotificationFilter();
        this.fetchNotifications();
    };
    NotificationGridComponent.prototype.searchStrategy = function (searchKey) {
        searchKey = searchKey.toLowerCase();
        var filteredArray = underscore["filter"](this.notificationTypesList, function (key) {
            var name = key.value.toLowerCase();
            if (name.match(searchKey)) {
                return key;
            }
        });
        this.notificationTypesTranslated = filteredArray;
    };
    NotificationGridComponent.prototype.searchStrategyChannel = function (searchKey) {
        searchKey = searchKey.toLowerCase();
        var filteredArray = underscore["filter"](this.notificationChannels, function (key) {
            var name = key.value.toLowerCase();
            if (name.match(searchKey)) {
                return key;
            }
        });
        this.notificationChannelsFiltered = filteredArray;
    };
    NotificationGridComponent.prototype.getKeys = function (data) {
        var keys = [];
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var t = data_1[_i];
            keys.push(t.key);
        }
        return keys;
    };
    NotificationGridComponent.prototype.onRefresh = function () {
    };
    return NotificationGridComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/editNotificationComponent.ts
var EditNotificationComponent = /*@__PURE__*/ (function () {
    function EditNotificationComponent(route, modalService, router, _global, _http, _auth, eRef, share, _sanitizer, builder, _toaster, _location, vcr, translate) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this._http = _http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this._location = _location;
        this.vcr = vcr;
        this.translate = translate;
        this.notification = {};
        this.variables = [];
        this.hideNotificationFlag = false;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        var data = this.share.getData();
        if (data && data.notificationId && data.eventId) {
            this.notificationId = data.notificationId;
            this.eventId = data.eventId;
            this.loadEventVariableByEventId();
            this.fetchNotification();
        }
    }
    EditNotificationComponent.prototype.fetchNotification = function () {
        var _this = this;
        var url = this._baseUrl + 'v1/webAdmin/notification/' + this.notificationId;
        var self = this;
        self._http.get(url).subscribe(function (result) {
            self.notification = result;
        }, function (error) {
            _this._toaster.showError('Not able to fetch notification');
        });
    };
    EditNotificationComponent.prototype.loadEventVariableByEventId = function () {
        var _this = this;
        var url = this._baseUrl + 'v1/webAdmin/notification/loadVariables/' + this.eventId;
        var self = this;
        self._http.get(url).subscribe(function (result) {
            self.variables = result;
        }, function (error) {
            _this._toaster.showError('Not able to fetch notification');
        });
    };
    EditNotificationComponent.prototype.validate = function () {
        if (!this.notification.name || !this.notification.name.trim()) {
            this._toaster.showError('Name should not be empty');
            return false;
        }
        if (this.notification.notificationChannel === 'Email') {
            if (!this.notification.messageTemplate
                || !this.notification.messageTemplate.trim()) {
                this._toaster.showError('Message template should not be empty');
                return false;
            }
            if (!this.notification.subjectTemplate || !this.notification.subjectTemplate.trim()) {
                this._toaster.showError('Subject template should not be empty');
                return false;
            }
        }
        return true;
    };
    EditNotificationComponent.prototype.save = function () {
        var _this = this;
        if (this.validate()) {
            var url = this._baseUrl + 'v1/webAdmin/notification';
            var self_1 = this;
            self_1._http.post(url, self_1.notification).subscribe(function (result) {
                _this._toaster.showSuccess('Notification updated');
                setTimeout(function () {
                    self_1.cancel();
                }, 500);
            }, function (error) {
                _this._toaster.showError('Somthing went wrog Notification update failed');
                console.log(error);
            });
        }
    };
    EditNotificationComponent.prototype.addNewRecipient = function () {
        this.notification.notificationRecipients.push({ recipientType: 'VARIABLE' });
    };
    EditNotificationComponent.prototype.hideNotification = function (event) {
        this.hideNotificationFlag = event;
    };
    EditNotificationComponent.prototype.cancel = function () {
        this.router.navigate(['menu/notifications']);
    };
    return EditNotificationComponent;
}());



// CONCATENATED MODULE: ./src/app/superAdmin/buildDetailsComponent.ts
var BuildDetailsComponent = /*@__PURE__*/ (function () {
    function BuildDetailsComponent(router, _per, _global, http, translate, _toaster, vcr, _location) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this._toaster = _toaster;
        this._location = _location;
        this.buildNumber = '0';
        this.backEndbuildNumber = '0';
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this.buildNumber = _global.get('BUILU_NUMBER');
        this._toaster.setViewRef(vcr);
    }
    BuildDetailsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.http.get(this._baseUrl + 'noAuth/buildNumber', { responseType: 'text' })
            .subscribe(function (response) {
            _this.backEndbuildNumber = response;
        });
    };
    return BuildDetailsComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/clearComponent/clearComponent.ts
var ClearCacheComponent = /*@__PURE__*/ (function () {
    function ClearCacheComponent(router, activeModal, _per, _global, http, share, modalService, translate, _toaster, vcr, _location) {
        this.router = router;
        this.activeModal = activeModal;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this.share = share;
        this.modalService = modalService;
        this.translate = translate;
        this._toaster = _toaster;
        this._location = _location;
        this.dropdownList = [];
        this.selectedItems = [];
        this.dropdownSettings = {};
        this.weeklyDropDownSettings = {};
        this.dynamicDataList = {};
        this.dynamicSelectedData = {};
        this.fileType = false;
        this.scheduleReport = {
            reportFrequencyEnum: null,
            startDate: null,
            scheduleTime: null,
            data: null,
            toEmails: null,
            ccEmails: null,
            bccEmails: null,
            olderExcelFormat: false
        };
        this.validateEmails = {
            toEmails: null,
            ccEmails: null,
            bccEmails: null
        };
        this.showValidateButtonLoading = false;
        this.showSendMailButtonLoading = false;
        this.showSendButton = true;
        this.showValidButton = false;
        this.weekDaysList = [];
        this.frequenciesList = [];
        this.selectedMonthIds = [];
        this.shareValue = 'Select';
        this.weeks = [];
        this.selectedItemArray = [];
        this.monthDays = [];
        this.scheduledReports = [];
        this.pageSize = 10;
        this.page = 1;
        this.startingPage = 1;
        this.endingPage = 10;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
    }
    ClearCacheComponent.prototype.ngOnInit = function () { };
    return ClearCacheComponent;
}());



// CONCATENATED MODULE: ./src/app/programManagement/emailNotification/emailPreview.ts
var EmailPreview = /*@__PURE__*/ (function () {
    function EmailPreview(route, activeModal, share) {
        this.route = route;
        this.activeModal = activeModal;
        this.share = share;
        var self = this;
        self.emailData = self.share.getData();
        console.log("Mail data::", self.emailData);
    }
    return EmailPreview;
}());



// CONCATENATED MODULE: ./src/app/programManagement/emailNotification/emailNotification.ts

var emailNotification_EmailNotification = /*@__PURE__*/ (function () {
    function EmailNotification(_global, http, share, _location, _toaster, _sanitizer, vcr, translate, modalService) {
        this._global = _global;
        this.http = http;
        this.share = share;
        this._location = _location;
        this._toaster = _toaster;
        this._sanitizer = _sanitizer;
        this.vcr = vcr;
        this.translate = translate;
        this.modalService = modalService;
        this.page = 1;
        this.pageSize = 10;
        this.emailFilter = {
            to: [],
            cc: [],
            bcc: [],
            body: '',
            notificationTypes: [],
            notificationGroups: [],
            emailStatuses: [],
            moduleList: [],
            eventIds: [],
            page: 1,
            pageSize: 10,
        };
        this.emailNotificationData = [];
        this.emailPageData = [];
        this.endingPage = 0;
        this.startingPage = 0;
        this.showLoading = false;
        this.notificationTypes = [];
        this.notificationGroups = [];
        this.notificationStatus = [];
        this.isCollapsed = false;
        this.trackHides = null;
        var self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self.getMails();
        self.getNotificationGroups();
        self.getNotificationtypes();
        self.getNotificationStatus();
    }
    EmailNotification.prototype.resetFilter = function () {
        var self = this;
        self.emailFilter = {
            to: [],
            cc: [],
            bcc: [],
            body: '',
            notificationTypes: [],
            notificationGroups: [],
            emailStatuses: [],
            moduleList: [],
            eventIds: [],
            page: 1,
            pageSize: 10,
        };
        self.selectedGroup = null;
        self.selectedStatus = null;
        self.selectedTypes = null;
        self.searchTo = null;
        self.searchCc = null;
        self.searchSubject = null;
        self.searchBody = null;
        self.getMails();
    };
    EmailNotification.prototype.applyFilter = function () {
        var self = this;
        self.isCollapsed = !self.isCollapsed;
        self.getMails();
    };
    EmailNotification.prototype.getMails = function () {
        try {
            var self_1 = this;
            self_1.emailFilter.page = self_1.page;
            self_1.emailFilter.pageSize = self_1.pageSize;
            if (self_1.searchCc) {
                self_1.emailFilter.cc = [];
                self_1.emailFilter.cc.push(self_1.searchCc);
            }
            if (self_1.searchTo) {
                self_1.emailFilter.to = [];
                self_1.emailFilter.to.push(self_1.searchTo);
            }
            if (self_1.searchSubject) {
                self_1.emailFilter.subject = self_1.searchSubject;
            }
            if (self_1.selectedGroup) {
                self_1.emailFilter.notificationGroups = [];
                self_1.emailFilter.notificationGroups.push(self_1.selectedGroup);
            }
            if (self_1.selectedStatus) {
                self_1.emailFilter.emailStatuses = [];
                self_1.emailFilter.emailStatuses.push(self_1.selectedStatus);
            }
            if (self_1.selectedTypes) {
                self_1.emailFilter.notificationTypes = [];
                self_1.emailFilter.notificationTypes.push(self_1.selectedTypes);
            }
            if (self_1.searchBodyOrSubject) {
                self_1.emailFilter.subjectOrBody = self_1.searchBodyOrSubject;
            }
            self_1.showLoading = true;
            var url = self_1._baseUrl + 'v1/webAdmin/mailMongo/find';
            self_1.http.post(url, self_1.emailFilter).subscribe(function (result) {
                self_1.emailNotificationData = result.data.content;
                self_1.emailPageData = result;
                if (self_1.emailNotificationData.length === 0) {
                    self_1.showLoading = false;
                }
                self_1.collectionSize = result.data.totalElements;
                if (result.last) {
                    self_1.endingPage = self_1.collectionSize;
                }
            });
        }
        catch (e) {
            console.log('getSkeleton error catch', e);
        }
    };
    EmailNotification.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getMails();
    };
    EmailNotification.prototype.clicked = function () {
        this.trackHides = null;
    };
    EmailNotification.prototype.getNotificationtypes = function () {
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/mailMongo/notificationTypes';
        self.http.get(url).subscribe(function (result) {
            self.notificationTypes = result;
        });
    };
    EmailNotification.prototype.getNotificationGroups = function () {
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/mailMongo/notificationGroups';
        self.http.get(url).subscribe(function (result) {
            self.notificationGroups = result;
        });
    };
    EmailNotification.prototype.getNotificationStatus = function () {
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/mailMongo/notificationStatus';
        self.http.get(url).subscribe(function (result) {
            self.notificationStatus = result;
        });
    };
    EmailNotification.prototype.previewEmail = function (email) {
        var self = this;
        this.share.saveData({ email: email });
        var modalRef = this.modalService.open(EmailPreview)
            .result.then(function (result) { }, function (reason) { });
    };
    EmailNotification.prototype.searchBodyOrSubjectFunc = function () {
        var self = this;
        self.getMails();
    };
    EmailNotification.prototype.onRefresh = function () {
        this.getMails();
    };
    return EmailNotification;
}());



// CONCATENATED MODULE: ./src/app/superAdmin/createMobileApplication.ts

var createMobileApplication_CreateMobileComponent = /*@__PURE__*/ (function () {
    function CreateMobileComponent(router, _per, _global, http, translate, _toaster, vcr, _location, activeModal, share) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this._toaster = _toaster;
        this._location = _location;
        this.activeModal = activeModal;
        this.share = share;
        this.mobileApps = [];
        this.isUpdate = false;
        var self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
        var shareData = self.share.getData();
        if (shareData.hasOwnProperty('mobileApp')) {
            var mobileAppData = shareData['mobileApp'];
            if (underscore["has"](mobileAppData, 'mobileAppName')) {
                self.mobileAppData = mobileAppData;
                self.isUpdate = true;
            }
            else {
                self.mobileAppData = {
                    mobileAppName: '',
                    versionAndroid: '',
                    versionIos: '',
                    fireBaseKey: '',
                    mobileAppKey: '',
                    redirectUrlAndroid: '',
                    redirectUrlIos: '',
                    isDefault: false
                };
                self.isUpdate = false;
            }
        }
        else {
            self.mobileAppData = {
                mobileAppName: '',
                versionAndroid: '',
                versionIos: '',
                fireBaseKey: '',
                mobileAppKey: '',
                redirectUrlAndroid: '',
                redirectUrlIos: '',
                isDefault: false
            };
            self.isUpdate = false;
        }
    }
    CreateMobileComponent.prototype.checkForValidData = function () {
        var self = this;
        if (underscore["isEmpty"](self.mobileAppData.mobileAppName) || underscore["isNull"](self.mobileAppData.mobileAppName) || underscore["isUndefined"](self.mobileAppData.mobileAppName)) {
            return false;
        }
        else if (underscore["isEmpty"](self.mobileAppData.mobileAppKey) || underscore["isNull"](self.mobileAppData.mobileAppKey) || underscore["isUndefined"](self.mobileAppData.mobileAppKey)) {
            return false;
        }
        else {
            return true;
        }
    };
    CreateMobileComponent.prototype.save = function () {
        var self = this;
        var isValid = self.checkForValidData();
        if (isValid && !self.isUpdate) {
            var url = self._baseUrl + 'v1/superAdmin/mobAppManagement/createMobileApp';
            self.http.post(url, self.mobileAppData).subscribe(function (result) {
                if (!result.errorMessage) {
                    self.translate.get('mobileAppCreated').subscribe(function (msg) {
                        self._toaster.showSuccess(msg);
                        self.activeModal.close();
                    });
                }
                else {
                    self.translate.get('mobileAppAlreadyCreated').subscribe(function (msg) {
                        self._toaster.showError(msg);
                        self.activeModal.close();
                    });
                }
            }, function (error) {
                self.translate.get('mandNotEmpty').subscribe(function (msg) {
                    self._toaster.showError(msg);
                });
            });
        }
        else if (isValid && self.isUpdate) {
            var url = self._baseUrl + 'v1/superAdmin/mobAppManagement/updateMobileApp';
            self.http.post(url, self.mobileAppData).subscribe(function (result) {
                self.translate.get('mobileAppUpdated').subscribe(function (msg) {
                    self._toaster.showSuccess(msg);
                    self.activeModal.close();
                });
            }, function (error) {
                self.translate.get('mandNotEmpty').subscribe(function (msg) {
                    self._toaster.showError(msg);
                });
            });
        }
        else {
            self.translate.get('mandNotEmpty').subscribe(function (msg) {
                self._toaster.showError(msg);
            });
        }
    };
    CreateMobileComponent.prototype.cancel = function () {
        var self = this;
        self.activeModal.close();
    };
    return CreateMobileComponent;
}());



// CONCATENATED MODULE: ./src/app/superAdmin/deleteMobileApplication.ts
var DeleteMobileComponent = /*@__PURE__*/ (function () {
    function DeleteMobileComponent(router, _per, _global, http, translate, _toaster, vcr, _location, activeModal, share) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this._toaster = _toaster;
        this._location = _location;
        this.activeModal = activeModal;
        this.share = share;
        var self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
    }
    DeleteMobileComponent.prototype.close = function (booleanValue) {
        var self = this;
        self.activeModal.close(booleanValue);
    };
    return DeleteMobileComponent;
}());



// CONCATENATED MODULE: ./src/app/superAdmin/mobileAppManagement.ts


var mobileAppManagement_MobileAppManagementComponent = /*@__PURE__*/ (function () {
    function MobileAppManagementComponent(router, _per, _global, http, translate, _toaster, vcr, _location, modalService, share) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this._toaster = _toaster;
        this._location = _location;
        this.modalService = modalService;
        this.share = share;
        this.mobileApps = [];
        this.pageSize = 10;
        this.page = 0;
        this.startingPage = 1;
        this.endingPage = 10;
        var self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
        self.getAllApps();
    }
    MobileAppManagementComponent.prototype.getAllApps = function () {
        var self = this;
        var url = self._baseUrl + 'v1/superAdmin/mobAppManagement/getAllMobileApp';
        self.http.post(url, { page: self.page, pageSize: self.pageSize }).subscribe(function (result) {
            self.mobileApps = result.content;
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, function (error) {
            console.log('Error:', error);
        });
    };
    MobileAppManagementComponent.prototype.createMobileApp = function () {
        var self = this;
        self.share.saveData({ mobileApp: null });
        var modalRef = this.modalService.open(createMobileApplication_CreateMobileComponent)
            .result.then(function (result) {
            self.getAllApps();
        }, function (reason) { });
    };
    MobileAppManagementComponent.prototype.updateMobileApp = function (mobileApp) {
        var self = this;
        self.share.saveData({ mobileApp: mobileApp });
        var modalRef = this.modalService.open(createMobileApplication_CreateMobileComponent)
            .result.then(function (result) {
            self.getAllApps();
        }, function (reason) { });
    };
    MobileAppManagementComponent.prototype.deleteMobileApp = function (mobileApp) {
        var self = this;
        var modalRef = this.modalService.open(DeleteMobileComponent)
            .result.then(function (result) {
            console.log('result::', result);
            if (result) {
                var url = self._baseUrl + 'v1/superAdmin/mobAppManagement/delete/' + mobileApp.id;
                self.http.delete(url).subscribe(function (result) {
                    self.getAllApps();
                }, function (error) {
                    console.log('Error:', error);
                });
            }
        }, function (reason) { });
    };
    // pagination functions
    MobileAppManagementComponent.prototype.onPageChange = function (event) {
        var self = this;
        if (event === 1) {
            self.startingPage = 1;
            self.endingPage = 10;
        }
        else {
            self.startingPage = 1 + self.pageSize;
            if (self.collectionSize > self.endingPage) {
                self.endingPage = event + self.endingPage;
            }
            else {
                self.endingPage = self.collectionSize;
            }
        }
        self.page = event - 1;
        self.getAllApps();
    };
    MobileAppManagementComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllApps();
    };
    return MobileAppManagementComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/passwordPolicy/passwordPolicy.ts
var PasswordPolicyComponent = /*@__PURE__*/ (function () {
    function PasswordPolicyComponent(route, activeModal, _location, _toast, viewContainerRef, _http, _global, translate, _share, _auth) {
        this.route = route;
        this.activeModal = activeModal;
        this._location = _location;
        this._toast = _toast;
        this.viewContainerRef = viewContainerRef;
        this._http = _http;
        this._global = _global;
        this.translate = translate;
        this._share = _share;
        this._auth = _auth;
        this.displayPreferences = 2;
        var self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self.getPasswordPolicy();
    }
    PasswordPolicyComponent.prototype.getPasswordPolicy = function () {
        try {
            var self_1 = this;
            var url = self_1._baseUrl + 'v1/webAdmin/passwordPolicy';
            self_1._http.get(url).subscribe(function (passwordPolicyData) {
                self_1.passwordPolicyData = passwordPolicyData.data;
            }, function (error) {
                console.log('Password Policy Get Error', error);
            });
        }
        catch (e) {
            console.log('Password Policy Get Error', e);
        }
    };
    PasswordPolicyComponent.prototype.validatepasswordPolicy = function () {
        var self = this;
        if (self.passwordPolicyData['minLength'] != null && self.passwordPolicyData['minLength'] != 0) {
            if (self.passwordPolicyData['maxLength'] != null && self.passwordPolicyData['maxLength'] != 0) {
                self.saveTenantConfigData();
            }
            else {
                self._toast.showError("Not a valid password policy, Please add valid min and max length");
            }
        }
        else {
            self._toast.showError("Not a valid password policy, Please add valid min and max length");
        }
    };
    PasswordPolicyComponent.prototype.saveTenantConfigData = function () {
        try {
            var self_2 = this;
            var url = self_2._baseUrl + 'v1/webAdmin/passwordPolicy';
            self_2._http.post(url, self_2.passwordPolicyData).subscribe(function (result) {
                if (result.data.id) {
                    self_2.translate.get('updatedSuccessfully').subscribe(function (msg) {
                        self_2._toast.showSuccess(msg);
                    });
                }
                else {
                    self_2.translate.get('errorWhileSaving').subscribe(function (msg) {
                        self_2._toast.showError(msg);
                    });
                }
            });
        }
        catch (error) {
            console.log('Password Policy Save Error', error);
        }
    };
    return PasswordPolicyComponent;
}());



// CONCATENATED MODULE: ./src/app/bulkResign/bulkResign.component.ts


var bulkResign_component_BulkResignComponent = /*@__PURE__*/ (function () {
    function BulkResignComponent(route, share, modalService, activeModal, _location, _toast, viewContainerRef, _http, _global, translate, _share) {
        this.route = route;
        this.share = share;
        this.modalService = modalService;
        this.activeModal = activeModal;
        this._location = _location;
        this._toast = _toast;
        this.viewContainerRef = viewContainerRef;
        this._http = _http;
        this._global = _global;
        this.translate = translate;
        this._share = _share;
        this.fileNameToUpload = null;
        this.fileType = false;
        this.comments = '';
        this.uploadButtonDisable = false;
        this.page = 1;
        this.pageSize = 10;
        this.allData = [];
        this.allPageData = [];
        this.endingPage = 10;
        this.showGrid = false;
        this.selectedProcess = 'Select';
        this.startingPage = 1;
        this.trackHides = null;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this.getAll();
    }
    BulkResignComponent.prototype.chooseFile = function (event) {
        if (event.target.files && event.target.files.length > 0) {
            var self_1 = this;
            self_1.attachmentFile = event.target.files[0];
            self_1.fileNameToUpload = event.target.files[0].name;
            event.srcElement.value = null;
        }
    };
    BulkResignComponent.prototype.downloadKpiTemplate = function () {
        var _this = this;
        try {
            var url = this._baseUrl + 'v1/webAdmin/employee/downloadEmpResignTemplate/'
                + this.fileType;
            this._http.getBlob(url).subscribe(function (result) {
                var name = _this.getFileNameFromHeader(result.headers);
                FileSaver["saveAs"](result.body, name);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    BulkResignComponent.prototype.downloadTemplate = function () {
        this.downloadKpiTemplate();
    };
    BulkResignComponent.prototype.onFileTypeChange = function (event) {
        if (event === 'xlsx' || event === 'XLSX') {
            this.fileType = false;
        }
        else {
            this.fileType = true;
        }
    };
    BulkResignComponent.prototype.getFileNameFromHeader = function (headers) {
        var header = headers.get('Content-Disposition');
        if (header == null) {
            return 'test.xlxs';
        }
        else {
            if (!header) {
                return null;
            }
            var result = header.split(';')[1].trim().split('=')[1];
            return result.replace(/'/g, '');
        }
    };
    BulkResignComponent.prototype.uploadFile = function () {
        this.actionResign();
    };
    BulkResignComponent.prototype.uploadAllTemplate = function (booleanValue) {
        var _this = this;
        if (this.validate()) {
            this.uploadButtonDisable = true;
            var formData = new FormData();
            formData.append('file', this.attachmentFile);
            formData.append('comment', this.comments);
            formData.append('forceResign', booleanValue);
            var url = this._baseUrl + 'v1/webAdmin/employee/uploadEmpResign/';
            { }
            var options = { responseType: 'text' };
            this._http.filePost(url, formData, options).subscribe(function (res) {
                if (res != null) {
                    _this.translate.get('fileUpdatedSuccessfully').subscribe(function (msg) {
                        _this._toast.showSuccess(msg);
                    });
                    _this.getAll();
                    _this.fileNameToUpload = null;
                    _this.comments = '';
                    _this.selectedProcess = 'Select';
                    _this.uploadButtonDisable = false;
                }
                else {
                    _this.translate.get('fileUploadFailed').subscribe(function (msg) {
                        _this._toast.showError(msg);
                    });
                    _this.getAll();
                    _this.fileNameToUpload = null;
                    _this.comments = '';
                    _this.selectedProcess = 'Select';
                    _this.uploadButtonDisable = false;
                }
            }, function (error) {
                _this.translate.get('fileUpdateFailed').subscribe(function (msg) {
                    _this._toast.showError(msg);
                    _this.uploadButtonDisable = false;
                });
            });
        }
    };
    BulkResignComponent.prototype.validate = function () {
        var _this = this;
        if (this.comments.trim() === '') {
            this.translate.get('commentsMandatory').subscribe(function (msg) {
                _this._toast.showError(msg);
            });
            return false;
        }
        else {
            return true;
        }
    };
    BulkResignComponent.prototype.getAll = function () {
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/uploadProcess/getAllByGroup?group=EMP_RESIGN'
            + '&page=' + self.page + '&pageSize=' + self.pageSize;
        self._http.get(url).subscribe(function (result) {
            self.allData = result.content;
            self.allPageData = result;
            self.collectionSize = result.totalElements;
            if (self.collectionSize < self.pageSize) {
                self.endingPage = self.collectionSize;
            }
            self.showGrid = true;
        }, function (error) {
            console.log(error);
        });
    };
    BulkResignComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAll();
    };
    BulkResignComponent.prototype.onPageChange = function (event) {
        if (event === 1) {
            this.startingPage = 1;
            this.endingPage = 10;
        }
        else {
            this.startingPage = 1 + this.pageSize;
            if (this.collectionSize > this.endingPage) {
                this.endingPage = event + this.endingPage;
            }
            else {
                this.endingPage = this.collectionSize;
            }
        }
        this.page = event;
        this.getAll();
    };
    BulkResignComponent.prototype.onProcessChange = function () {
        this.fileNameToUpload = null;
    };
    BulkResignComponent.prototype.getDateFormat = function (date) {
        var dateCreated = new Date(date);
        return dateCreated.toString().substring(4, 15);
    };
    BulkResignComponent.prototype.getExtension = function (fileName) {
        this.fileExtension = fileName.split('.').pop();
        return this.fileExtension.toLowerCase();
    };
    BulkResignComponent.prototype.downloadValidationFile = function (path) {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/uploadProcess/downloadFile/' + path;
        this._http.getBlob(url).subscribe(function (result) {
            var name = _this.getFileNameFromHeader(result.headers);
            FileSaver["saveAs"](result.body, name);
        }, function (error) {
            console.log(error);
        });
    };
    BulkResignComponent.prototype.actionResign = function () {
        var _this = this;
        var closeResult;
        this.trackHides = null;
        var confirmData = {
            type: 'Bulk_Resign'
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            closeResult = "Closed with: " + result;
            if (result === 'forceResign') {
                _this.uploadAllTemplate(true);
            }
            else {
                _this.uploadAllTemplate(false);
            }
        }, function (reason) {
            closeResult = "Dismissed";
        });
    };
    return BulkResignComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/operations/addOperation.component.ts
var AddOperationComponent = /*@__PURE__*/ (function () {
    function AddOperationComponent(router, _per, _global, http, translate, _toaster, vcr, activeModal, share) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this._toaster = _toaster;
        this.activeModal = activeModal;
        this.share = share;
        this.isUpdate = false;
        var self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
        var shareData = self.share.getData();
        if (shareData.hasOwnProperty('operationDetailsData')) {
            this.operationDetailsData = shareData['operationDetailsData'];
        }
        self.getOperationList();
    }
    AddOperationComponent.prototype.getOperationList = function () {
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/operationDetails/operationList';
        self.http.get(url).subscribe(function (result) {
            self.operationList = result;
        }, function (error) {
            console.log('Error:', error);
        });
    };
    AddOperationComponent.prototype.save = function () {
        var _this = this;
        if (!this.operationDetailsData.name.trim() || !this.operationDetailsData.externalURL.trim()) {
            this.translate.get('mandNotEmpty').subscribe(function (msg) {
                _this._toaster.showError(msg);
            });
        }
        else {
            var self_1 = this;
            var url = self_1._baseUrl + 'v1/webAdmin/operationDetails';
            self_1.http.post(url, self_1.operationDetailsData).subscribe(function (result) {
                if (result.success) {
                    self_1.translate.get('operationDetailsSaved').subscribe(function (msg) {
                        self_1._toaster.showSuccess(msg);
                        self_1.activeModal.close();
                    });
                }
                else {
                    self_1.translate.get(result.errorMessage).subscribe(function (msg) {
                        self_1._toaster.showError(msg);
                        self_1.activeModal.close();
                    });
                }
            });
        }
    };
    AddOperationComponent.prototype.fileChange = function (event) {
        var _this = this;
        console.log(event);
        var fileList = event.target.files;
        var result;
        if (fileList.length > 0) {
            var file = fileList[0];
            var fileName_1 = file.name;
            var path_1 = event.target.value;
            var reader = new FileReader();
            reader.onloadend = function (e) {
                result = e.target.result;
                _this.getAllData(path_1, fileName_1, result);
            };
            reader.readAsBinaryString(file);
        }
    };
    AddOperationComponent.prototype.getAllData = function (path, fileNames, result) {
        var a = path.split("/");
        var fileName = a.pop();
        var fileNameArray = fileName.split(".");
        var ext = fileNameArray[1];
        this.operationDetailsData.attachment = {
            docName: fileNames,
            docType: ext,
            document: window.btoa(result),
            docId: null
        };
    };
    AddOperationComponent.prototype.cancel = function () {
        var self = this;
        self.activeModal.close();
    };
    return AddOperationComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/operations/manageOperation.component.ts

var manageOperation_component_ManageOperationComponent = /*@__PURE__*/ (function () {
    function ManageOperationComponent(router, _per, _global, http, translate, _toaster, vcr, modalService, share) {
        this.router = router;
        this._per = _per;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this._toaster = _toaster;
        this.modalService = modalService;
        this.share = share;
        this.pageSize = 10;
        this.page = 0;
        this.startingPage = 1;
        this.endingPage = 10;
        var self = this;
        self._baseUrl = _global.get('EPMS_BASE_URL');
        self._toaster.setViewRef(vcr);
    }
    ManageOperationComponent.prototype.getAllOperations = function () {
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/operationDetails';
        self.http.get(url).subscribe(function (result) {
            self.operationList = result;
            self.collectionSize = result.length;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, function (error) {
            console.log('Error:', error);
        });
    };
    ManageOperationComponent.prototype.addOperation = function () {
        var self = this;
        self.share.saveData({ operationDetailsData: { operation: "LEARNING_MANAGEMENT", "name": "", "externalURL": "" } });
        var modalRef = this.modalService.open(AddOperationComponent)
            .result.then(function (result) {
            self.getAllOperations();
        }, function (reason) { });
    };
    ManageOperationComponent.prototype.updateOperation = function (operationData) {
        var self = this;
        self.share.saveData({ operationDetailsData: operationData });
        var modalRef = this.modalService.open(AddOperationComponent)
            .result.then(function (result) {
            self.getAllOperations();
        }, function (reason) { });
    };
    // pagination functions
    ManageOperationComponent.prototype.onPageChange = function (event) {
        var self = this;
        if (event === 1) {
            self.startingPage = 1;
            self.endingPage = 10;
        }
        else {
            self.startingPage = 1 + self.pageSize;
            if (self.collectionSize > self.endingPage) {
                self.endingPage = event + self.endingPage;
            }
            else {
                self.endingPage = self.collectionSize;
            }
        }
        self.page = event - 1;
        self.getAllOperations();
    };
    ManageOperationComponent.prototype.OnPageSizeChanged = function (val) {
        this.pageSize = val;
        this.getAllOperations();
    };
    return ManageOperationComponent;
}());



// CONCATENATED MODULE: ./src/app/app.routes.ts

// BI-ADMIN


















// employee





//  Announcements



































var ROUTES = [
    { path: '', redirectTo: '/menu', pathMatch: 'full' },
    {
        path: 'biAdmin', component: AdminPage,
        children: [
            // BI-MDM
            { path: 'pageAuthorization', component: pageAuthorization_component_pageAuthorizationComponent },
            {
                path: 'roleAuthorization', component: roleAuthorization_component_roleAuthorizationComponent,
                children: []
            },
            { path: 'editRoleAuth', component: editRoleAuthorization_component_editRoleAuthorizationComponent },
            { path: 'dimLvlPermissions', component: dimLvlPermissions_component_dimLvlPermComponent },
            { path: 'tenantConfiguration', component: tenantConfiguration_component_tenantConfigComponent },
            { path: 'target', component: target_component_targetComponent },
            { path: 'cube', component: cube_component_CubeComponent },
            { path: 'measure', component: measure_component_MeasureComponent },
            { path: 'uom', component: uom_component_UomComponent },
            { path: 'scope', component: scope_component_ScopeComponent },
            { path: 'dimension', component: dimension_component_DimensionComponent },
            { path: 'valueStream', component: valueStream_component_ValueStreamComponent },
            { path: 'dataSource', component: dataSource_component_DataSourceComponent },
            { path: 'recordFormat', component: recordFormat_component_RecordFormatComponent },
            { path: 'dataEngine', component: dataEngine_component_DataEngine },
            { path: 'wizard', component: pocWizard_component_POCWizard }
        ]
    },
    {
        path: 'menu', component: menu_MenuComponent,
        children: [
            { path: 'employeesList', component: employeeList_EmployeesListingPage },
            { path: 'employeeSearch', component: employeeSearch_EmployeeSearch },
            { path: 'addEmployee', component: addEmployees_AddEmployeesComponent },
            { path: 'switch', component: switchUser_SwitchUserComponent },
            { path: 'designationList', component: designationList_DesignationPageComponent },
            { path: 'organizationUnitType', component: organizationUnitList_OrgUnitTypePageComponent },
            { path: 'userGroup', component: userGroup_UserGroupPage },
            { path: 'addDesignation', component: addDesignation_AddDesignationComponent },
            { path: 'addOrgUnitType', component: organizationUnit_AddOrgUnitTypeComponent },
            { path: 'addUserGroup', component: addUserGroup_AddUserGroupComponent },
            { path: 'addUsersToGroup', component: addUsersToGroup_AddUsersToGroupComponent },
            { path: 'empTypeList', component: EmployementTypePageComponent },
            { path: 'addEmpType', component: addEmpType_AddEmployementTypeComponent },
            { path: 'gradeList', component: GradePageComponent },
            { path: 'addGrade', component: addGrade_AddGradeComponent },
            { path: 'mgrLevelList', component: mgrLevelList_ManagerLevelComponent },
            { path: 'addMgrLevel', component: addMgrLevel_AddManagerLevelComponent },
            { path: 'addParentOrganization', component: addParentOrganization_AddParentOrganizationComponent },
            { path: 'rolesAndPermission', component: rolesAndPermission_RolesAndPermissionComponent },
            { path: 'manageOperations', component: manageOperation_component_ManageOperationComponent },
            { path: 'cob', component: cob_component_CobComponent },
            { path: 'bulkResignUpload', component: bulkResign_component_BulkResignComponent },
            { path: 'createRoles', component: createRolesAndPermission_CreateRolesAndPermissionComponent },
            { path: 'addUsers', component: addUsersToRole_AddUsersToRolesComponent },
            { path: 'organizationList', component: organizationList_OrganizationPage },
            { path: 'EmployeeInRole', component: employeesInRole_EmployeeInRoleComponent },
            { path: 'EmployeeInGroup', component: employeesInGroup_EmployeeInGroupComponent },
            { path: 'announcementProgram', component: announcements_Announcements },
            { path: 'bulkupload', component: bulkUpload_BulkUploadComponent },
            { path: 'tenantPreference', component: tenantPreference_TenantPreferenceComponent },
            { path: 'buildDetails', component: BuildDetailsComponent },
            { path: 'tenantManagement', component: TenantManagementComponent },
            { path: 'createTenant', component: createTenant_CreateTenantComponent },
            { path: 'updateTenant', component: updateTenant_UpdateTenantComponent },
            { path: 'notifications', component: notificationGridComponent_NotificationGridComponent },
            { path: 'editNotifications', component: EditNotificationComponent },
            { path: 'cache', component: ClearCacheComponent },
            { path: 'emailNotification', component: emailNotification_EmailNotification },
            { path: 'mobileAppManagement', component: mobileAppManagement_MobileAppManagementComponent },
            { path: 'passwordPolicy', component: PasswordPolicyComponent }
        ]
    },
    { path: '**', component: NoContentComponent },
];

// CONCATENATED MODULE: ./src/app/app.service.ts
var AppState = /*@__PURE__*/ (function () {
    function AppState() {
        this._state = {};
    }
    Object.defineProperty(AppState.prototype, "state", {
        /**
         * Already return a clone of the current state.
         */
        get: function () {
            return this._state = this._clone(this._state);
        },
        /**
         * Never allow mutation
         */
        set: function (value) {
            throw new Error('do not mutate the `.state` directly');
        },
        enumerable: true,
        configurable: true
    });
    AppState.prototype.get = function (prop) {
        /**
         * Use our state getter for the clone.
         */
        var state = this.state;
        return state.hasOwnProperty(prop) ? state[prop] : state;
    };
    AppState.prototype.set = function (prop, value) {
        /**
         * Internally mutate our state.
         */
        return this._state[prop] = value;
    };
    AppState.prototype._clone = function (object) {
        /**
         * Simple object clone.
         */
        return JSON.parse(JSON.stringify(object));
    };
    return AppState;
}());



// CONCATENATED MODULE: ./src/app/image-upload/image-upload/image.service.ts

var image_service_ImageService = /*@__PURE__*/ (function () {
    function ImageService(http) {
        this.http = http;
    }
    ImageService.prototype.postImage = function (url, image, headers, partName, customFormData, withCredentials) {
        if (partName === void 0) {
            partName = 'image';
        }
        if (!url || url === '') {
            throw new Error('Url is not set! Please set it before doing queries');
        }
        var options = new fesm5_http["RequestOptions"]();
        if (withCredentials) {
            options.withCredentials = withCredentials;
        }
        if (headers) {
            options.headers = new fesm5_http["Headers"](headers);
        }
        // add custom form data
        var formData = new FormData();
        for (var key in customFormData) {
            formData.append(key, customFormData[key]);
        }
        formData.append(partName, image);
        return this.http.post(url, formData, options);
    };
    return ImageService;
}());



// CONCATENATED MODULE: ./src/app/image-upload/image-upload.module.ts

var image_upload_module_ImageUploadModule = /*@__PURE__*/ (function () {
    function ImageUploadModule() {
    }
    ImageUploadModule.forRoot = function () {
        return {
            ngModule: ImageUploadModule,
            providers: [image_service_ImageService]
        };
    };
    return ImageUploadModule;
}());



// CONCATENATED MODULE: ./node_modules/ng2-dnd/src/dnd.utils.js
/**
 * Check and return true if an object is type of string
 */
/**
 * Check and return true if an object is type of string
 */ function dnd_utils_isString(obj) {
    return typeof obj === "string";
}
/**
 * Check and return true if an object not undefined or null
 */
function isPresent(obj) {
    return obj !== undefined && obj !== null;
}
/**
 * Check and return true if an object is type of Function
 */
function dnd_utils_isFunction(obj) {
    return typeof obj === "function";
}
/**
 * Create Image element with specified url string
 */
function createImage(src) {
    var img = new HTMLImageElement();
    img.src = src;
    return img;
}
/**
 * Call the function
 */
function callFun(fun) {
    return fun();
}

// CONCATENATED MODULE: ./node_modules/ng2-dnd/src/dnd.config.js
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd

var DataTransferEffect = /*@__PURE__*/ (function () {
    function DataTransferEffect(name) {
        this.name = name;
    }
    return DataTransferEffect;
}());

DataTransferEffect.COPY = new DataTransferEffect('copy');
DataTransferEffect.LINK = new DataTransferEffect('link');
DataTransferEffect.MOVE = new DataTransferEffect('move');
DataTransferEffect.NONE = new DataTransferEffect('none');
var dnd_config_DragImage = /*@__PURE__*/ (function () {
    function DragImage(imageElement, x_offset, y_offset) {
        if (x_offset === void 0) {
            x_offset = 0;
        }
        if (y_offset === void 0) {
            y_offset = 0;
        }
        this.imageElement = imageElement;
        this.x_offset = x_offset;
        this.y_offset = y_offset;
        if (dnd_utils_isString(this.imageElement)) {
            // Create real image from string source
            var imgScr = this.imageElement;
            this.imageElement = new HTMLImageElement();
            this.imageElement.src = imgScr;
        }
    }
    return DragImage;
}());

var DragDropConfig = /*@__PURE__*/ (function () {
    function DragDropConfig() {
        this.onDragStartClass = "dnd-drag-start";
        this.onDragEnterClass = "dnd-drag-enter";
        this.onDragOverClass = "dnd-drag-over";
        this.onSortableDragClass = "dnd-sortable-drag";
        this.dragEffect = DataTransferEffect.MOVE;
        this.dropEffect = DataTransferEffect.MOVE;
        this.dragCursor = "move";
        this.defaultCursor = "pointer";
    }
    return DragDropConfig;
}());



// CONCATENATED MODULE: ./node_modules/ng2-dnd/src/dnd.service.js
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd



var DragDropData = /*@__PURE__*/ (function () {
    function DragDropData() {
    }
    return DragDropData;
}());

function dragDropServiceFactory() {
    return new DragDropService();
}
var DragDropService = /*@__PURE__*/ (function () {
    function DragDropService() {
        this.allowedDropZones = [];
    }
    return DragDropService;
}());

function dragDropSortableServiceFactory(config) {
    return new dnd_service_DragDropSortableService(config);
}
var dnd_service_DragDropSortableService = /*@__PURE__*/ (function () {
    function DragDropSortableService(_config) {
        this._config = _config;
    }
    Object.defineProperty(DragDropSortableService.prototype, "elem", {
        get: function () {
            return this._elem;
        },
        enumerable: true,
        configurable: true
    });
    DragDropSortableService.prototype.markSortable = function (elem) {
        if (isPresent(this._elem)) {
            this._elem.classList.remove(this._config.onSortableDragClass);
        }
        if (isPresent(elem)) {
            this._elem = elem;
            this._elem.classList.add(this._config.onSortableDragClass);
        }
    };
    return DragDropSortableService;
}());



// CONCATENATED MODULE: ./node_modules/ng2-dnd/src/abstract.component.js
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd





var abstract_component_AbstractComponent = /*@__PURE__*/ (function () {
    function AbstractComponent(elemRef, _dragDropService, _config, _cdr) {
        var _this = this;
        this._dragDropService = _dragDropService;
        this._config = _config;
        this._cdr = _cdr;
        /**
         * Whether the object is draggable. Default is true.
         */
        this._dragEnabled = false;
        /**
         * Allows drop on this element
         */
        this.dropEnabled = false;
        this.dropZones = [];
        this.cloneItem = false;
        // Assign default cursor unless overridden
        this._defaultCursor = _config.defaultCursor;
        this._elem = elemRef.nativeElement;
        this._elem.style.cursor = this._defaultCursor; // set default cursor on our element
        //
        // DROP events
        //
        this._elem.ondragenter = function (event) {
            _this._onDragEnter(event);
        };
        this._elem.ondragover = function (event) {
            _this._onDragOver(event);
            //
            if (event.dataTransfer != null) {
                event.dataTransfer.dropEffect = _this._config.dropEffect.name;
            }
            return false;
        };
        this._elem.ondragleave = function (event) {
            _this._onDragLeave(event);
        };
        this._elem.ondrop = function (event) {
            _this._onDrop(event);
        };
        //
        // Drag events
        //
        this._elem.onmousedown = function (event) {
            _this._target = event.target;
        };
        this._elem.ondragstart = function (event) {
            if (_this._dragHandle) {
                if (!_this._dragHandle.contains(_this._target)) {
                    event.preventDefault();
                    return;
                }
            }
            _this._onDragStart(event);
            //
            if (event.dataTransfer != null) {
                event.dataTransfer.setData('text', '');
                // Change drag effect
                event.dataTransfer.effectAllowed = _this.effectAllowed || _this._config.dragEffect.name;
                // Change drag image
                if (isPresent(_this.dragImage)) {
                    if (dnd_utils_isString(_this.dragImage)) {
                        event.dataTransfer.setDragImage(createImage(_this.dragImage));
                    }
                    else if (dnd_utils_isFunction(_this.dragImage)) {
                        event.dataTransfer.setDragImage(callFun(_this.dragImage));
                    }
                    else {
                        var img = _this.dragImage;
                        event.dataTransfer.setDragImage(img.imageElement, img.x_offset, img.y_offset);
                    }
                }
                else if (isPresent(_this._config.dragImage)) {
                    var dragImage = _this._config.dragImage;
                    event.dataTransfer.setDragImage(dragImage.imageElement, dragImage.x_offset, dragImage.y_offset);
                }
                else if (_this.cloneItem) {
                    _this._dragHelper = _this._elem.cloneNode(true);
                    _this._dragHelper.classList.add('dnd-drag-item');
                    _this._dragHelper.style.position = "absolute";
                    _this._dragHelper.style.top = "0px";
                    _this._dragHelper.style.left = "-1000px";
                    _this._elem.parentElement.appendChild(_this._dragHelper);
                    event.dataTransfer.setDragImage(_this._dragHelper, event.offsetX, event.offsetY);
                }
                // Change drag cursor
                var cursorelem = (_this._dragHandle) ? _this._dragHandle : _this._elem;
                if (_this._dragEnabled) {
                    cursorelem.style.cursor = _this.effectCursor ? _this.effectCursor : _this._config.dragCursor;
                }
                else {
                    cursorelem.style.cursor = _this._defaultCursor;
                }
            }
        };
        this._elem.ondragend = function (event) {
            if (_this._elem.parentElement && _this._dragHelper) {
                _this._elem.parentElement.removeChild(_this._dragHelper);
            }
            // console.log('ondragend', event.target);
            _this._onDragEnd(event);
            // Restore style of dragged element
            var cursorelem = (_this._dragHandle) ? _this._dragHandle : _this._elem;
            cursorelem.style.cursor = _this._defaultCursor;
        };
    }
    Object.defineProperty(AbstractComponent.prototype, "dragEnabled", {
        get: function () {
            return this._dragEnabled;
        },
        set: function (enabled) {
            this._dragEnabled = !!enabled;
            this._elem.draggable = this._dragEnabled;
        },
        enumerable: true,
        configurable: true
    });
    AbstractComponent.prototype.setDragHandle = function (elem) {
        this._dragHandle = elem;
    };
    /******* Change detection ******/
    AbstractComponent.prototype.detectChanges = function () {
        var _this = this;
        // Programmatically run change detection to fix issue in Safari
        setTimeout(function () {
            _this._cdr.detectChanges();
        }, 250);
    };
    //****** Droppable *******//
    AbstractComponent.prototype._onDragEnter = function (event) {
        // console.log('ondragenter._isDropAllowed', this._isDropAllowed);
        if (this._isDropAllowed(event)) {
            // event.preventDefault();
            this._onDragEnterCallback(event);
        }
    };
    AbstractComponent.prototype._onDragOver = function (event) {
        // // console.log('ondragover._isDropAllowed', this._isDropAllowed);
        if (this._isDropAllowed(event)) {
            // The element is over the same source element - do nothing
            if (event.preventDefault) {
                // Necessary. Allows us to drop.
                event.preventDefault();
            }
            this._onDragOverCallback(event);
        }
    };
    AbstractComponent.prototype._onDragLeave = function (event) {
        // console.log('ondragleave._isDropAllowed', this._isDropAllowed);
        if (this._isDropAllowed(event)) {
            // event.preventDefault();
            this._onDragLeaveCallback(event);
        }
    };
    AbstractComponent.prototype._onDrop = function (event) {
        // Necessary. Allows us to drop.
        this._preventAndStop(event);
        // console.log('ondrop._isDropAllowed', this._isDropAllowed);
        if (this._isDropAllowed(event)) {
            this._onDropCallback(event);
            this.detectChanges();
        }
    };
    AbstractComponent.prototype._isDropAllowed = function (event) {
        if ((this._dragDropService.isDragged || (event.dataTransfer && event.dataTransfer.files)) && this.dropEnabled) {
            // First, if `allowDrop` is set, call it to determine whether the
            // dragged element can be dropped here.
            if (this.allowDrop) {
                return this.allowDrop(this._dragDropService.dragData);
            }
            // Otherwise, use dropZones if they are set.
            if (this.dropZones.length === 0 && this._dragDropService.allowedDropZones.length === 0) {
                return true;
            }
            for (var i = 0; i < this._dragDropService.allowedDropZones.length; i++) {
                var dragZone = this._dragDropService.allowedDropZones[i];
                if (this.dropZones.indexOf(dragZone) !== -1) {
                    return true;
                }
            }
        }
        return false;
    };
    AbstractComponent.prototype._preventAndStop = function (event) {
        if (event.preventDefault) {
            event.preventDefault();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
    };
    //*********** Draggable **********//
    AbstractComponent.prototype._onDragStart = function (event) {
        //console.log('ondragstart.dragEnabled', this._dragEnabled);
        if (this._dragEnabled) {
            this._dragDropService.allowedDropZones = this.dropZones;
            // console.log('ondragstart.allowedDropZones', this._dragDropService.allowedDropZones);
            this._onDragStartCallback(event);
        }
    };
    AbstractComponent.prototype._onDragEnd = function (event) {
        this._dragDropService.allowedDropZones = [];
        // console.log('ondragend.allowedDropZones', this._dragDropService.allowedDropZones);
        this._onDragEndCallback(event);
    };
    //**** Drop Callbacks ****//
    AbstractComponent.prototype._onDragEnterCallback = function (event) { };
    AbstractComponent.prototype._onDragOverCallback = function (event) { };
    AbstractComponent.prototype._onDragLeaveCallback = function (event) { };
    AbstractComponent.prototype._onDropCallback = function (event) { };
    //**** Drag Callbacks ****//
    AbstractComponent.prototype._onDragStartCallback = function (event) { };
    AbstractComponent.prototype._onDragEndCallback = function (event) { };
    return AbstractComponent;
}());

var AbstractHandleComponent = /*@__PURE__*/ (function () {
    function AbstractHandleComponent(elemRef, _dragDropService, _config, _Component, _cdr) {
        this._dragDropService = _dragDropService;
        this._config = _config;
        this._Component = _Component;
        this._cdr = _cdr;
        this._elem = elemRef.nativeElement;
        this._Component.setDragHandle(this._elem);
    }
    return AbstractHandleComponent;
}());



// CONCATENATED MODULE: ./node_modules/ng2-dnd/src/draggable.component.js
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var draggable_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var draggable_component_DraggableComponent = /*@__PURE__*/ (function (_super) {
    draggable_component___extends(DraggableComponent, _super);
    function DraggableComponent(elemRef, dragDropService, config, cdr) {
        var _this = _super.call(this, elemRef, dragDropService, config, cdr) || this;
        /**
         * Callback function called when the drag actions happened.
         */
        _this.onDragStart = new core["EventEmitter"]();
        _this.onDragEnd = new core["EventEmitter"]();
        /**
         * Callback function called when the drag action ends with a valid drop action.
         * It is activated after the on-drop-success callback
         */
        _this.onDragSuccessCallback = new core["EventEmitter"]();
        _this._defaultCursor = _this._elem.style.cursor;
        _this.dragEnabled = true;
        return _this;
    }
    Object.defineProperty(DraggableComponent.prototype, "draggable", {
        set: function (value) {
            this.dragEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggableComponent.prototype, "dropzones", {
        set: function (value) {
            this.dropZones = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggableComponent.prototype, "effectallowed", {
        /**
         * Drag allowed effect
         */
        set: function (value) {
            this.effectAllowed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggableComponent.prototype, "effectcursor", {
        /**
         * Drag effect cursor
         */
        set: function (value) {
            this.effectCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    DraggableComponent.prototype._onDragStartCallback = function (event) {
        this._dragDropService.isDragged = true;
        this._dragDropService.dragData = this.dragData;
        this._dragDropService.onDragSuccessCallback = this.onDragSuccessCallback;
        this._elem.classList.add(this._config.onDragStartClass);
        //
        this.onDragStart.emit({ dragData: this.dragData, mouseEvent: event });
    };
    DraggableComponent.prototype._onDragEndCallback = function (event) {
        this._dragDropService.isDragged = false;
        this._dragDropService.dragData = null;
        this._dragDropService.onDragSuccessCallback = null;
        this._elem.classList.remove(this._config.onDragStartClass);
        //
        this.onDragEnd.emit({ dragData: this.dragData, mouseEvent: event });
    };
    return DraggableComponent;
}(abstract_component_AbstractComponent));

var DraggableHandleComponent = /*@__PURE__*/ (function (_super) {
    draggable_component___extends(DraggableHandleComponent, _super);
    function DraggableHandleComponent(elemRef, dragDropService, config, _Component, cdr) {
        return _super.call(this, elemRef, dragDropService, config, _Component, cdr) || this;
    }
    return DraggableHandleComponent;
}(AbstractHandleComponent));



// CONCATENATED MODULE: ./node_modules/ng2-dnd/src/droppable.component.js
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var droppable_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var droppable_component_DroppableComponent = /*@__PURE__*/ (function (_super) {
    droppable_component___extends(DroppableComponent, _super);
    function DroppableComponent(elemRef, dragDropService, config, cdr) {
        var _this = _super.call(this, elemRef, dragDropService, config, cdr) || this;
        /**
         * Callback function called when the drop action completes correctly.
         * It is activated before the on-drag-success callback.
         */
        _this.onDropSuccess = new core["EventEmitter"]();
        _this.onDragEnter = new core["EventEmitter"]();
        _this.onDragOver = new core["EventEmitter"]();
        _this.onDragLeave = new core["EventEmitter"]();
        _this.dropEnabled = true;
        return _this;
    }
    Object.defineProperty(DroppableComponent.prototype, "droppable", {
        set: function (value) {
            this.dropEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableComponent.prototype, "allowdrop", {
        set: function (value) {
            this.allowDrop = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableComponent.prototype, "dropzones", {
        set: function (value) {
            this.dropZones = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableComponent.prototype, "effectallowed", {
        /**
         * Drag allowed effect
         */
        set: function (value) {
            this.effectAllowed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DroppableComponent.prototype, "effectcursor", {
        /**
         * Drag effect cursor
         */
        set: function (value) {
            this.effectCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    DroppableComponent.prototype._onDragEnterCallback = function (event) {
        if (this._dragDropService.isDragged) {
            this._elem.classList.add(this._config.onDragEnterClass);
            this.onDragEnter.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
        }
    };
    DroppableComponent.prototype._onDragOverCallback = function (event) {
        if (this._dragDropService.isDragged) {
            this._elem.classList.add(this._config.onDragOverClass);
            this.onDragOver.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
        }
    };
    ;
    DroppableComponent.prototype._onDragLeaveCallback = function (event) {
        if (this._dragDropService.isDragged) {
            this._elem.classList.remove(this._config.onDragOverClass);
            this._elem.classList.remove(this._config.onDragEnterClass);
            this.onDragLeave.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
        }
    };
    ;
    DroppableComponent.prototype._onDropCallback = function (event) {
        var dataTransfer = event.dataTransfer;
        if (this._dragDropService.isDragged || (dataTransfer && dataTransfer.files)) {
            this.onDropSuccess.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
            if (this._dragDropService.onDragSuccessCallback) {
                this._dragDropService.onDragSuccessCallback.emit({ dragData: this._dragDropService.dragData, mouseEvent: event });
            }
            this._elem.classList.remove(this._config.onDragOverClass);
            this._elem.classList.remove(this._config.onDragEnterClass);
        }
    };
    return DroppableComponent;
}(abstract_component_AbstractComponent));



// CONCATENATED MODULE: ./node_modules/ng2-dnd/src/sortable.component.js
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd
var sortable_component___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var SortableContainer = /*@__PURE__*/ (function (_super) {
    sortable_component___extends(SortableContainer, _super);
    function SortableContainer(elemRef, dragDropService, config, cdr, _sortableDataService) {
        var _this = _super.call(this, elemRef, dragDropService, config, cdr) || this;
        _this._sortableDataService = _sortableDataService;
        _this._sortableData = [];
        _this.dragEnabled = false;
        return _this;
    }
    Object.defineProperty(SortableContainer.prototype, "draggable", {
        set: function (value) {
            this.dragEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableContainer.prototype, "sortableData", {
        get: function () {
            return this._sortableData;
        },
        set: function (sortableData) {
            this._sortableData = sortableData;
            //
            this.dropEnabled = !!this._sortableData;
            // console.log("collection is changed, drop enabled: " + this.dropEnabled);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableContainer.prototype, "dropzones", {
        set: function (value) {
            this.dropZones = value;
        },
        enumerable: true,
        configurable: true
    });
    SortableContainer.prototype._onDragEnterCallback = function (event) {
        if (this._sortableDataService.isDragged) {
            var item = this._sortableDataService.sortableContainer._sortableData[this._sortableDataService.index];
            // Check does element exist in sortableData of this Container
            if (this._sortableData.indexOf(item) === -1) {
                // Let's add it
                // console.log('Container._onDragEnterCallback. drag node [' + this._sortableDataService.index.toString() + '] over parent node');
                // Remove item from previouse list
                this._sortableDataService.sortableContainer._sortableData.splice(this._sortableDataService.index, 1);
                if (this._sortableDataService.sortableContainer._sortableData.length === 0) {
                    this._sortableDataService.sortableContainer.dropEnabled = true;
                }
                // Add item to new list
                this._sortableData.unshift(item);
                this._sortableDataService.sortableContainer = this;
                this._sortableDataService.index = 0;
            }
            // Refresh changes in properties of container component
            this.detectChanges();
        }
    };
    return SortableContainer;
}(abstract_component_AbstractComponent));

var sortable_component_SortableComponent = /*@__PURE__*/ (function (_super) {
    sortable_component___extends(SortableComponent, _super);
    function SortableComponent(elemRef, dragDropService, config, _sortableContainer, _sortableDataService, cdr) {
        var _this = _super.call(this, elemRef, dragDropService, config, cdr) || this;
        _this._sortableContainer = _sortableContainer;
        _this._sortableDataService = _sortableDataService;
        /**
         * Callback function called when the drag action ends with a valid drop action.
         * It is activated after the on-drop-success callback
         */
        _this.onDragSuccessCallback = new core["EventEmitter"]();
        _this.onDragStartCallback = new core["EventEmitter"]();
        _this.onDragOverCallback = new core["EventEmitter"]();
        _this.onDragEndCallback = new core["EventEmitter"]();
        _this.onDropSuccessCallback = new core["EventEmitter"]();
        _this.dropZones = _this._sortableContainer.dropZones;
        _this.dragEnabled = true;
        _this.dropEnabled = true;
        return _this;
    }
    Object.defineProperty(SortableComponent.prototype, "draggable", {
        set: function (value) {
            this.dragEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableComponent.prototype, "droppable", {
        set: function (value) {
            this.dropEnabled = !!value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableComponent.prototype, "effectallowed", {
        /**
         * Drag allowed effect
         */
        set: function (value) {
            this.effectAllowed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SortableComponent.prototype, "effectcursor", {
        /**
         * Drag effect cursor
         */
        set: function (value) {
            this.effectCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    SortableComponent.prototype._onDragStartCallback = function (event) {
        // console.log('_onDragStartCallback. dragging elem with index ' + this.index);
        this._sortableDataService.isDragged = true;
        this._sortableDataService.sortableContainer = this._sortableContainer;
        this._sortableDataService.index = this.index;
        this._sortableDataService.markSortable(this._elem);
        // Add dragData
        this._dragDropService.isDragged = true;
        this._dragDropService.dragData = this.dragData;
        this._dragDropService.onDragSuccessCallback = this.onDragSuccessCallback;
        //
        this.onDragStartCallback.emit(this._dragDropService.dragData);
    };
    SortableComponent.prototype._onDragOverCallback = function (event) {
        if (this._sortableDataService.isDragged && this._elem !== this._sortableDataService.elem) {
            // console.log('_onDragOverCallback. dragging elem with index ' + this.index);
            this._sortableDataService.sortableContainer = this._sortableContainer;
            this._sortableDataService.index = this.index;
            this._sortableDataService.markSortable(this._elem);
            this.onDragOverCallback.emit(this._dragDropService.dragData);
        }
    };
    SortableComponent.prototype._onDragEndCallback = function (event) {
        // console.log('_onDragEndCallback. end dragging elem with index ' + this.index);
        this._sortableDataService.isDragged = false;
        this._sortableDataService.sortableContainer = null;
        this._sortableDataService.index = null;
        this._sortableDataService.markSortable(null);
        // Add dragGata
        this._dragDropService.isDragged = false;
        this._dragDropService.dragData = null;
        this._dragDropService.onDragSuccessCallback = null;
        //
        this.onDragEndCallback.emit(this._dragDropService.dragData);
    };
    SortableComponent.prototype._onDragEnterCallback = function (event) {
        if (this._sortableDataService.isDragged) {
            this._sortableDataService.markSortable(this._elem);
            if ((this.index !== this._sortableDataService.index) ||
                (this._sortableDataService.sortableContainer.sortableData !== this._sortableContainer.sortableData)) {
                // console.log('Component._onDragEnterCallback. drag node [' + this.index + '] over node [' + this._sortableDataService.index + ']');
                // Get item
                var item = this._sortableDataService.sortableContainer.sortableData[this._sortableDataService.index];
                // Remove item from previouse list
                this._sortableDataService.sortableContainer.sortableData.splice(this._sortableDataService.index, 1);
                if (this._sortableDataService.sortableContainer.sortableData.length === 0) {
                    this._sortableDataService.sortableContainer.dropEnabled = true;
                }
                // Add item to new list
                this._sortableContainer.sortableData.splice(this.index, 0, item);
                if (this._sortableContainer.dropEnabled) {
                    this._sortableContainer.dropEnabled = false;
                }
                this._sortableDataService.sortableContainer = this._sortableContainer;
                this._sortableDataService.index = this.index;
            }
        }
    };
    SortableComponent.prototype._onDropCallback = function (event) {
        if (this._sortableDataService.isDragged) {
            // console.log('onDropCallback.onDropSuccessCallback.dragData', this._dragDropService.dragData);
            this.onDropSuccessCallback.emit(this._dragDropService.dragData);
            if (this._dragDropService.onDragSuccessCallback) {
                // console.log('onDropCallback.onDragSuccessCallback.dragData', this._dragDropService.dragData);
                this._dragDropService.onDragSuccessCallback.emit(this._dragDropService.dragData);
            }
            // Refresh changes in properties of container component
            this._sortableContainer.detectChanges();
        }
    };
    return SortableComponent;
}(abstract_component_AbstractComponent));

var SortableHandleComponent = /*@__PURE__*/ (function (_super) {
    sortable_component___extends(SortableHandleComponent, _super);
    function SortableHandleComponent(elemRef, dragDropService, config, _Component, cdr) {
        return _super.call(this, elemRef, dragDropService, config, _Component, cdr) || this;
    }
    return SortableHandleComponent;
}(AbstractHandleComponent));



// CONCATENATED MODULE: ./node_modules/ng2-dnd/index.js
// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-dnd












var providers = [
    DragDropConfig,
    { provide: DragDropService, useFactory: dragDropServiceFactory },
    { provide: dnd_service_DragDropSortableService, useFactory: dragDropSortableServiceFactory, deps: [DragDropConfig] }
];
var DndModule = /*@__PURE__*/ (function () {
    function DndModule() {
    }
    DndModule.forRoot = function () {
        return {
            ngModule: DndModule,
            providers: providers
        };
    };
    return DndModule;
}());



// CONCATENATED MODULE: ./src/app/app.module.ts













var APP_PROVIDERS = APP_RESOLVER_PROVIDERS.concat([
    AppState
]);
var dndModule = DndModule.forRoot();
var treeviewModule = treeview_module_TreeviewModule.forRoot();
var imageUploadModule = image_upload_module_ImageUploadModule.forRoot();
var ngbModule = NgbModule.forRoot();
var froalaEditorModule = FroalaEditorModule.forRoot();
var froalaViewModule = FroalaViewModule.forRoot();
var routerModule = fesm5_router["o" /* RouterModule */].forRoot(ROUTES, {
    useHash: true,
    preloadingStrategy: fesm5_router["f" /* PreloadAllModules */]
});
// export function highchartsFactory() {
//     const hc = require('highcharts');
//     return hc;
// }
var app_module_AppModule = /*@__PURE__*/ (function () {
    function AppModule(appRef, appState) {
        this.appRef = appRef;
        this.appState = appState;
    }
    AppModule.prototype.hmrOnInit = function (store) {
        if (!store || !store.state) {
            return;
        }
        console.log('HMR store', JSON.stringify(store, null, 2));
        this.appState._state = store.state;
        if ('restoreInputValues' in store) {
            var restoreInputValues = store.restoreInputValues;
            setTimeout(restoreInputValues);
        }
        this.appRef.tick();
        delete store.state;
        delete store.restoreInputValues;
    };
    AppModule.prototype.hmrOnDestroy = function (store) {
        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
        var state = this.appState._state;
        store.state = state;
        store.disposeOldHosts = Object(dist["createNewHosts"])(cmpLocation);
        store.restoreInputValues = Object(dist["createInputTransfer"])();
        Object(dist["removeNgStyles"])();
    };
    AppModule.prototype.hmrAfterDestroy = function (store) {
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    };
    return AppModule;
}());



// CONCATENATED MODULE: ./src/app/app.component.ts



var app_component_AppComponent = /*@__PURE__*/ (function () {
    function AppComponent(appState, _auth, _global, _http, _per, translate) {
        this.appState = appState;
        this._auth = _auth;
        this._global = _global;
        this._http = _http;
        this._per = _per;
        this.angularclassLogo = 'assets/img/angularclass-avatar.png';
        this.name = 'Angular 2 Webpack Starter';
        this.url = 'https://twitter.com/AngularClass';
        this.showLoading = false;
        this.loadTabs = false;
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = JSON.parse(localStorage.userInfo);
        if (data.localeName == null) {
            data.localeName = 'en_US';
        }
        document.documentElement.setAttribute('lang', data.localeName);
        translate.setDefaultLang(data.localeName);
        document.title = environment["a" /* environment */].appTitle;
        document.documentElement.setAttribute('client', environment["a" /* environment */].client);
    }
    Object.defineProperty(AppComponent.prototype, "isAuthenticated", {
        get: function () {
            return this._auth.isAuthenticated;
        },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.ngOnInit = function () {
        this.getAllPermission();
    };
    AppComponent.prototype.loader = function (option) {
        this.showLoading = option;
    };
    AppComponent.prototype.getAllPermission = function () {
        var that = this;
        var permission = [];
        if (that.isAuthenticated) {
            var url = that._baseUrl + 'v1/hub/getAdminOperations';
            that._http.get(url).subscribe(function (result) {
                if (result.length > 0) {
                    underscore["each"](result, function (key, val) {
                        if (key.childOperations.length > 0) {
                            permission.push(key.operation);
                            underscore["each"](key.childOperations, function (k, e) {
                                permission.push(k.operation);
                            });
                        }
                    });
                }
                that._per.savePermission(permission);
                that.loadTabs = true;
            });
        }
    };
    AppComponent.prototype.unloadHandler = function (event) {
    };
    AppComponent.prototype.beforeUnloadHander = function (event) {
    };
    return AppComponent;
}());



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/alert/alert.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_alert,_alert_config PURE_IMPORTS_END */




var styles_NgbAlert = [];
var RenderType_NgbAlert = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NgbAlert, data: {} });

function View_NgbAlert_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeHandler() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"]))], null, null);
}
function View_NgbAlert_0(_l) { return core["ɵvid"](2, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["role", "alert"]], [[8, "className", 0]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbAlert_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), core["ɵncd"](null, 0)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.dismissible; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (("alert alert-" + _co.type) + (_co.dismissible ? " alert-dismissible" : "")); _ck(_v, 0, 0, currVal_0); }); }
function View_NgbAlert_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-alert", [], null, null, null, View_NgbAlert_0, RenderType_NgbAlert)), core["ɵdid"](1, 49152, null, 0, alert_NgbAlert, [NgbAlertConfig], null, null)], null, null); }
var NgbAlertNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-alert", alert_NgbAlert, View_NgbAlert_Host_0, { dismissible: "dismissible", type: "type" }, { close: "close" }, ["*"]);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-day-view.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_datepicker_day_view PURE_IMPORTS_END */


var styles_NgbDatepickerDayView = ["[_nghost-%COMP%] {\n      text-align: center;\n      width: 2rem;\n      height: 2rem;\n      line-height: 2rem;\n      border-radius: 0.25rem;\n      background: transparent;\n    }\n    .outside[_nghost-%COMP%] {\n      opacity: 0.5;\n    }"];
var RenderType_NgbDatepickerDayView = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbDatepickerDayView, data: {} });

function View_NgbDatepickerDayView_0(_l) { return core["ɵvid"](2, [(_l()(), core["ɵted"](0, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.date.day; _ck(_v, 0, 0, currVal_0); }); }
function View_NgbDatepickerDayView_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "btn-light"], ["ngbDatepickerDayView", ""]], [[2, "bg-primary", null], [2, "text-white", null], [2, "text-muted", null], [2, "outside", null], [2, "active", null]], null, null, View_NgbDatepickerDayView_0, RenderType_NgbDatepickerDayView)), core["ɵdid"](1, 49152, null, 0, NgbDatepickerDayView, [], null, null)], null, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 1).selected; var currVal_1 = core["ɵnov"](_v, 1).selected; var currVal_2 = core["ɵnov"](_v, 1).isMuted(); var currVal_3 = core["ɵnov"](_v, 1).isMuted(); var currVal_4 = core["ɵnov"](_v, 1).focused; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4); }); }
var NgbDatepickerDayViewNgFactory = /*@__PURE__*/ core["ɵccf"]("[ngbDatepickerDayView]", NgbDatepickerDayView, View_NgbDatepickerDayView_Host_0, { currentMonth: "currentMonth", date: "date", disabled: "disabled", focused: "focused", selected: "selected" }, {}, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation-select.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_angular_common,_datepicker_navigation_select,_datepicker_i18n PURE_IMPORTS_END */





var styles_NgbDatepickerNavigationSelect = ["[_nghost-%COMP%] > select[_ngcontent-%COMP%] {\n      display: flex;\n      display: -ms-flexbox;\n      -ms-flex: 1 1 auto;\n      width: 100%;\n      padding: 0 0.5rem;\n      font-size: 0.875rem;\n      height: 1.85rem;\n    }"];
var RenderType_NgbDatepickerNavigationSelect = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbDatepickerNavigationSelect, data: {} });

function View_NgbDatepickerNavigationSelect_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "aria-label", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", ""]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.i18n.getMonthFullName(_v.context.$implicit); _ck(_v, 0, 0, currVal_0); var currVal_3 = _co.i18n.getMonthShortName(_v.context.$implicit); _ck(_v, 3, 0, currVal_3); }); }
function View_NgbDatepickerNavigationSelect_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", ""]))], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit; _ck(_v, 3, 0, currVal_2); }); }
function View_NgbDatepickerNavigationSelect_0(_l) {
    return core["ɵvid"](2, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "select", [["class", "custom-select"]], [[8, "disabled", 0], [8, "value", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.changeMonth($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerNavigationSelect_1)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 2, "select", [["class", "custom-select"]], [[8, "disabled", 0], [8, "value", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.changeYear($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerNavigationSelect_2)), core["ɵdid"](5, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = _co.months; _ck(_v, 2, 0, currVal_2); var currVal_5 = _co.years; _ck(_v, 5, 0, currVal_5); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = ((_co.date == null) ? null : _co.date.month); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_3 = _co.disabled; var currVal_4 = ((_co.date == null) ? null : _co.date.year); _ck(_v, 3, 0, currVal_3, currVal_4); });
}
function View_NgbDatepickerNavigationSelect_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-datepicker-navigation-select", [], null, null, null, View_NgbDatepickerNavigationSelect_0, RenderType_NgbDatepickerNavigationSelect)), core["ɵdid"](1, 49152, null, 0, datepicker_navigation_select_NgbDatepickerNavigationSelect, [NgbDatepickerI18n], null, null)], null, null); }
var NgbDatepickerNavigationSelectNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-datepicker-navigation-select", datepicker_navigation_select_NgbDatepickerNavigationSelect, View_NgbDatepickerNavigationSelect_Host_0, { date: "date", disabled: "disabled", months: "months", years: "years" }, { select: "select" }, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-navigation.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_datepicker_navigation_select.ngfactory,_datepicker_navigation_select,_datepicker_i18n,_angular_common,_datepicker_navigation PURE_IMPORTS_END */






var styles_NgbDatepickerNavigation = ["[_nghost-%COMP%] {\n      display: -ms-flexbox;\n      display: flex;\n      align-items: center;\n    }\n    .ngb-dp-navigation-chevron[_ngcontent-%COMP%] {\n      border-style: solid;\n      border-width: 0.2em 0.2em 0 0;\n      display: inline-block;\n      width: 0.75em;\n      height: 0.75em;\n      margin-left: 0.25em;\n      margin-right: 0.15em;\n      transform: rotate(-135deg);\n      -ms-transform: rotate(-135deg);\n    }\n    .right[_ngcontent-%COMP%]   .ngb-dp-navigation-chevron[_ngcontent-%COMP%] {\n      -ms-transform: rotate(45deg);\n      transform: rotate(45deg);\n      margin-left: 0.15em;\n      margin-right: 0.25em;\n    }\n    .ngb-dp-arrow[_ngcontent-%COMP%] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex: 1 1 auto;\n      flex-grow: 1;\n      padding-right: 0;\n      padding-left: 0;\n      margin: 0;\n      width: 2rem;\n      height: 2rem;\n    }\n    .ngb-dp-arrow.right[_ngcontent-%COMP%] {\n      -ms-flex-pack: end;\n      justify-content: flex-end;\n    }\n    .ngb-dp-arrow-btn[_ngcontent-%COMP%] {\n      padding: 0 0.25rem;\n      margin: 0 0.5rem;\n      border: none;\n      background-color: transparent;\n      z-index: 1;\n    }\n    .ngb-dp-arrow-btn[_ngcontent-%COMP%]:focus {\n      outline: auto 1px;\n    }\n    .ngb-dp-month-name[_ngcontent-%COMP%] {\n      font-size: larger;\n      height: 2rem;\n      line-height: 2rem;\n      text-align: center;\n    }\n    .ngb-dp-navigation-select[_ngcontent-%COMP%] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex: 1 1 9rem;\n      flex-grow: 1;\n      flex-basis: 9rem;\n    }"];
var RenderType_NgbDatepickerNavigation = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbDatepickerNavigation, data: {} });

function View_NgbDatepickerNavigation_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-datepicker-navigation-select", [["class", "ngb-dp-navigation-select"]], null, [[null, "select"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("select" === en)) {
                var pd_0 = (_co.select.emit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NgbDatepickerNavigationSelect_0, RenderType_NgbDatepickerNavigationSelect)), core["ɵdid"](1, 49152, null, 0, datepicker_navigation_select_NgbDatepickerNavigationSelect, [NgbDatepickerI18n], { date: [0, "date"], disabled: [1, "disabled"], months: [2, "months"], years: [3, "years"] }, { select: "select" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.date; var currVal_1 = _co.disabled; var currVal_2 = _co.selectBoxes.months; var currVal_3 = _co.selectBoxes.years; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3); }, null);
}
function View_NgbDatepickerNavigation_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["class", "ngb-dp-arrow"]], null, null, null, null, null))], null, null); }
function View_NgbDatepickerNavigation_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["class", "ngb-dp-arrow"]], null, null, null, null, null))], null, null); }
function View_NgbDatepickerNavigation_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerNavigation_4)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "div", [["class", "ngb-dp-month-name"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " ", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerNavigation_5)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_v.context.index > 0); _ck(_v, 1, 0, currVal_0); var currVal_3 = (_v.context.index !== (_co.months.length - 1)); _ck(_v, 5, 0, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.i18n.getMonthFullName(_v.context.$implicit.number); var currVal_2 = _v.context.$implicit.year; _ck(_v, 3, 0, currVal_1, currVal_2); }); }
function View_NgbDatepickerNavigation_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerNavigation_3)), core["ɵdid"](1, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.months; _ck(_v, 1, 0, currVal_0); }, null); }
function View_NgbDatepickerNavigation_0(_l) {
    return core["ɵvid"](2, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "ngb-dp-arrow"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["aria-label", "Previous month"], ["class", "btn btn-link ngb-dp-arrow-btn"], ["title", "Previous month"], ["type", "button"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.navigate.emit(_co.navigation.PREV) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "span", [["class", "ngb-dp-navigation-chevron"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerNavigation_1)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerNavigation_2)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "ngb-dp-arrow right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "button", [["aria-label", "Next month"], ["class", "btn btn-link ngb-dp-arrow-btn"], ["title", "Next month"], ["type", "button"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.navigate.emit(_co.navigation.NEXT) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "span", [["class", "ngb-dp-navigation-chevron"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.showSelect; _ck(_v, 4, 0, currVal_1); var currVal_2 = !_co.showSelect; _ck(_v, 6, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.prevDisabled; _ck(_v, 1, 0, currVal_0); var currVal_3 = _co.nextDisabled; _ck(_v, 8, 0, currVal_3); });
}
function View_NgbDatepickerNavigation_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-datepicker-navigation", [], null, null, null, View_NgbDatepickerNavigation_0, RenderType_NgbDatepickerNavigation)), core["ɵdid"](1, 49152, null, 0, datepicker_navigation_NgbDatepickerNavigation, [NgbDatepickerI18n], null, null)], null, null); }
var NgbDatepickerNavigationNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-datepicker-navigation", datepicker_navigation_NgbDatepickerNavigation, View_NgbDatepickerNavigation_Host_0, { date: "date", disabled: "disabled", months: "months", showSelect: "showSelect", prevDisabled: "prevDisabled", nextDisabled: "nextDisabled", selectBoxes: "selectBoxes" }, { navigate: "navigate", select: "select" }, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-month-view.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_datepicker_month_view,_datepicker_i18n PURE_IMPORTS_END */




var styles_NgbDatepickerMonthView = ["[_nghost-%COMP%] {\n      display: block;\n    }\n    .ngb-dp-weekday[_ngcontent-%COMP%], .ngb-dp-week-number[_ngcontent-%COMP%] {\n      line-height: 2rem;\n      text-align: center;\n      font-style: italic;\n    }\n    .ngb-dp-weekday[_ngcontent-%COMP%] {\n      color: #5bc0de;\n      color: var(--info);\n    }\n    .ngb-dp-week[_ngcontent-%COMP%] {\n      border-radius: 0.25rem;\n      display: -ms-flexbox;\n      display: flex;\n    }\n    .ngb-dp-weekdays[_ngcontent-%COMP%] {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n      border-radius: 0;\n    }\n    .ngb-dp-day[_ngcontent-%COMP%], .ngb-dp-weekday[_ngcontent-%COMP%], .ngb-dp-week-number[_ngcontent-%COMP%] {\n      width: 2rem;\n      height: 2rem;\n    }\n    .ngb-dp-day[_ngcontent-%COMP%] {\n      cursor: pointer;\n    }\n    .ngb-dp-day.disabled[_ngcontent-%COMP%], .ngb-dp-day.hidden[_ngcontent-%COMP%] {\n      cursor: default;\n    }"];
var RenderType_NgbDatepickerMonthView = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbDatepickerMonthView, data: {} });

function View_NgbDatepickerMonthView_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["class", "ngb-dp-weekday ngb-dp-showweek"]], null, null, null, null, null))], null, null); }
function View_NgbDatepickerMonthView_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "ngb-dp-weekday small"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.i18n.getWeekdayShortName(_v.context.$implicit); _ck(_v, 1, 0, currVal_0); }); }
function View_NgbDatepickerMonthView_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "ngb-dp-week ngb-dp-weekdays bg-light"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_3)), core["ɵdid"](4, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showWeekNumbers; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.month.weekdays; _ck(_v, 4, 0, currVal_1); }, null); }
function View_NgbDatepickerMonthView_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "ngb-dp-week-number small text-muted"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.parent.parent.context.$implicit.number; _ck(_v, 1, 0, currVal_0); }); }
function View_NgbDatepickerMonthView_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](0, null, null, 0))], null, null); }
function View_NgbDatepickerMonthView_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_9)), core["ɵdid"](1, 540672, null, 0, common["NgTemplateOutlet"], [core["ViewContainerRef"]], { ngTemplateOutletContext: [0, "ngTemplateOutletContext"], ngTemplateOutlet: [1, "ngTemplateOutlet"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.parent.context.$implicit.context; var currVal_1 = _co.dayTemplate; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
function View_NgbDatepickerMonthView_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "ngb-dp-day"], ["role", "gridcell"]], [[2, "disabled", null], [8, "tabIndex", 0], [2, "hidden", null], [1, "aria-label", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.doSelect(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_8)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_4 = !_v.context.$implicit.hidden; _ck(_v, 2, 0, currVal_4); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.context.disabled; var currVal_1 = _v.context.$implicit.tabindex; var currVal_2 = _v.context.$implicit.hidden; var currVal_3 = _v.context.$implicit.ariaLabel; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3); });
}
function View_NgbDatepickerMonthView_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "ngb-dp-week"], ["role", "row"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_6)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_7)), core["ɵdid"](4, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showWeekNumbers; _ck(_v, 2, 0, currVal_0); var currVal_1 = _v.parent.context.$implicit.days; _ck(_v, 4, 0, currVal_1); }, null); }
function View_NgbDatepickerMonthView_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_5)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = !_v.context.$implicit.collapsed; _ck(_v, 1, 0, currVal_0); }, null); }
function View_NgbDatepickerMonthView_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepickerMonthView_4)), core["ɵdid"](3, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showWeekdays; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.month.weeks; _ck(_v, 3, 0, currVal_1); }, null); }
function View_NgbDatepickerMonthView_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-datepicker-month-view", [["role", "grid"]], null, null, null, View_NgbDatepickerMonthView_0, RenderType_NgbDatepickerMonthView)), core["ɵdid"](1, 49152, null, 0, datepicker_month_view_NgbDatepickerMonthView, [NgbDatepickerI18n], null, null)], null, null); }
var NgbDatepickerMonthViewNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-datepicker-month-view", datepicker_month_view_NgbDatepickerMonthView, View_NgbDatepickerMonthView_Host_0, { dayTemplate: "dayTemplate", month: "month", showWeekdays: "showWeekdays", showWeekNumbers: "showWeekNumbers" }, { select: "select" }, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_datepicker_day_view.ngfactory,_datepicker_day_view,_datepicker_navigation.ngfactory,_datepicker_navigation,_datepicker_i18n,_angular_common,_datepicker_month_view.ngfactory,_datepicker_month_view,_angular_forms,_datepicker,_datepicker_service,_ngb_calendar,_datepicker_keymap_service,_datepicker_config,_adapters_ngb_date_adapter PURE_IMPORTS_END */
















var styles_NgbDatepicker = ["[_nghost-%COMP%] {\n      border: 1px solid #dfdfdf;\n      border-radius: 0.25rem;\n      display: inline-block;\n    }\n    .ngb-dp-month[_ngcontent-%COMP%] {\n      pointer-events: none;\n    }\n    .ngb-dp-header[_ngcontent-%COMP%] {\n      border-bottom: 0;\n      border-radius: 0.25rem 0.25rem 0 0;\n      padding-top: 0.25rem;\n    }\n    ngb-datepicker-month-view[_ngcontent-%COMP%] {\n      pointer-events: auto;\n    }\n    .ngb-dp-month-name[_ngcontent-%COMP%] {\n      font-size: larger;\n      height: 2rem;\n      line-height: 2rem;\n      text-align: center;\n    }\n      .ngb-dp-month + .ngb-dp-month > ngb-datepicker-month-view > .ngb-dp-week {\n      padding-left: 1rem;\n    }\n      .ngb-dp-month + .ngb-dp-month > .ngb-dp-month-name {\n      padding-left: 1rem;\n    }\n      .ngb-dp-month:last-child .ngb-dp-week {\n      padding-right: .25rem;\n    }\n      .ngb-dp-month:first-child .ngb-dp-week {\n      padding-left: .25rem;\n    }\n      .ngb-dp-month > ngb-datepicker-month-view > .ngb-dp-week:last-child {\n      padding-bottom: .25rem;\n    }\n    .ngb-dp-months[_ngcontent-%COMP%] {\n      display: -ms-flexbox;\n      display: flex;\n    }"];
var RenderType_NgbDatepicker = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbDatepicker, data: {} });

function View_NgbDatepicker_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "btn-light"], ["ngbDatepickerDayView", ""]], [[2, "bg-primary", null], [2, "text-white", null], [2, "text-muted", null], [2, "outside", null], [2, "active", null]], null, null, View_NgbDatepickerDayView_0, RenderType_NgbDatepickerDayView)), core["ɵdid"](1, 49152, null, 0, NgbDatepickerDayView, [], { currentMonth: [0, "currentMonth"], date: [1, "date"], disabled: [2, "disabled"], focused: [3, "focused"], selected: [4, "selected"] }, null)], function (_ck, _v) { var currVal_5 = _v.context.currentMonth; var currVal_6 = _v.context.date; var currVal_7 = _v.context.disabled; var currVal_8 = _v.context.focused; var currVal_9 = _v.context.selected; _ck(_v, 1, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 1).selected; var currVal_1 = core["ɵnov"](_v, 1).selected; var currVal_2 = core["ɵnov"](_v, 1).isMuted(); var currVal_3 = core["ɵnov"](_v, 1).isMuted(); var currVal_4 = core["ɵnov"](_v, 1).focused; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4); }); }
function View_NgbDatepicker_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-datepicker-navigation", [], null, [[null, "navigate"], [null, "select"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("navigate" === en)) {
                var pd_0 = (_co.onNavigateEvent($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("select" === en)) {
                var pd_1 = (_co.onNavigateDateSelect($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbDatepickerNavigation_0, RenderType_NgbDatepickerNavigation)), core["ɵdid"](1, 49152, null, 0, datepicker_navigation_NgbDatepickerNavigation, [NgbDatepickerI18n], { date: [0, "date"], disabled: [1, "disabled"], months: [2, "months"], showSelect: [3, "showSelect"], prevDisabled: [4, "prevDisabled"], nextDisabled: [5, "nextDisabled"], selectBoxes: [6, "selectBoxes"] }, { navigate: "navigate", select: "select" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.model.firstDate; var currVal_1 = _co.model.disabled; var currVal_2 = _co.model.months; var currVal_3 = (_co.model.navigation === "select"); var currVal_4 = _co.model.prevDisabled; var currVal_5 = _co.model.nextDisabled; var currVal_6 = _co.model.selectBoxes; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_NgbDatepicker_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "ngb-dp-month-name bg-light"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.i18n.getMonthFullName(_v.parent.context.$implicit.number); var currVal_1 = _v.parent.context.$implicit.year; _ck(_v, 1, 0, currVal_0, currVal_1); }); }
function View_NgbDatepicker_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "ngb-dp-month"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepicker_4)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "ngb-datepicker-month-view", [["role", "grid"]], null, [[null, "select"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("select" === en)) {
                var pd_0 = (_co.onDateSelect($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NgbDatepickerMonthView_0, RenderType_NgbDatepickerMonthView)), core["ɵdid"](4, 49152, null, 0, datepicker_month_view_NgbDatepickerMonthView, [NgbDatepickerI18n], { dayTemplate: [0, "dayTemplate"], month: [1, "month"], showWeekdays: [2, "showWeekdays"], showWeekNumbers: [3, "showWeekNumbers"] }, { select: "select" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.navigation === "none") || ((_co.displayMonths > 1) && (_co.navigation === "select"))); _ck(_v, 2, 0, currVal_0); var currVal_1 = (_co.dayTemplate || core["ɵnov"](_v.parent, 0)); var currVal_2 = _v.context.$implicit; var currVal_3 = _co.showWeekdays; var currVal_4 = _co.showWeekNumbers; _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4); }, null);
}
function View_NgbDatepicker_0(_l) {
    return core["ɵvid"](2, [(_l()(), core["ɵand"](0, [["dt", 2]], null, 0, null, View_NgbDatepicker_1)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "ngb-dp-header bg-light"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepicker_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "ngb-dp-months"]], null, [[null, "keydown"], [null, "focusin"], [null, "focusout"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("keydown" === en)) {
                var pd_0 = (_co.onKeyDown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("focusin" === en)) {
                var pd_1 = (_co.showFocus(true) !== false);
                ad = (pd_1 && ad);
            }
            if (("focusout" === en)) {
                var pd_2 = (_co.showFocus(false) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbDatepicker_3)), core["ɵdid"](6, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.navigation !== "none"); _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.model.months; _ck(_v, 6, 0, currVal_1); }, null);
}
function View_NgbDatepicker_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "ngb-datepicker", [], null, null, null, View_NgbDatepicker_0, RenderType_NgbDatepicker)), core["ɵprd"](5120, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [datepicker_NgbDatepicker]), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵprd"](512, null, datepicker_keymap_service_NgbDatepickerKeyMapService, datepicker_keymap_service_NgbDatepickerKeyMapService, [datepicker_service_NgbDatepickerService, NgbCalendar]), core["ɵdid"](4, 770048, null, 0, datepicker_NgbDatepicker, [datepicker_keymap_service_NgbDatepickerKeyMapService, datepicker_service_NgbDatepickerService, NgbCalendar, NgbDatepickerI18n, NgbDatepickerConfig, core["ChangeDetectorRef"], core["ElementRef"], NgbDateAdapter, core["NgZone"]], null, null)], function (_ck, _v) { _ck(_v, 4, 0); }, null); }
var NgbDatepickerNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-datepicker", datepicker_NgbDatepicker, View_NgbDatepicker_Host_0, { dayTemplate: "dayTemplate", displayMonths: "displayMonths", firstDayOfWeek: "firstDayOfWeek", markDisabled: "markDisabled", maxDate: "maxDate", minDate: "minDate", navigation: "navigation", outsideDays: "outsideDays", showWeekdays: "showWeekdays", showWeekNumbers: "showWeekNumbers", startDate: "startDate" }, { navigate: "navigate", select: "select" }, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-backdrop.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_modal_backdrop PURE_IMPORTS_END */


var styles_NgbModalBackdrop = [];
var RenderType_NgbModalBackdrop = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NgbModalBackdrop, data: {} });

function View_NgbModalBackdrop_0(_l) { return core["ɵvid"](0, [], null, null); }
function View_NgbModalBackdrop_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-modal-backdrop", [], [[8, "className", 0]], null, null, View_NgbModalBackdrop_0, RenderType_NgbModalBackdrop)), core["ɵdid"](1, 49152, null, 0, NgbModalBackdrop, [], null, null)], null, function (_ck, _v) { var currVal_0 = ("modal-backdrop fade show" + (core["ɵnov"](_v, 1).backdropClass ? (" " + core["ɵnov"](_v, 1).backdropClass) : "")); _ck(_v, 0, 0, currVal_0); }); }
var NgbModalBackdropNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-modal-backdrop", NgbModalBackdrop, View_NgbModalBackdrop_Host_0, { backdropClass: "backdropClass" }, {}, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-window.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_modal_window,_angular_common PURE_IMPORTS_END */



var styles_NgbModalWindow = [];
var RenderType_NgbModalWindow = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NgbModalWindow, data: {} });

function View_NgbModalWindow_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["role", "document"]], [[8, "className", 0]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "modal-content"]], null, null, null, null, null)), core["ɵncd"](null, 0)], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (("modal-dialog" + (_co.size ? (" modal-" + _co.size) : "")) + (_co.centered ? " modal-dialog-centered" : "")); _ck(_v, 0, 0, currVal_0); }); }
function View_NgbModalWindow_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-modal-window", [["role", "dialog"], ["tabindex", "-1"]], [[8, "className", 0], [1, "aria-labelledby", 0]], [[null, "keyup.esc"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("keyup.esc" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).escKey($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("click" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).backdropClick($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbModalWindow_0, RenderType_NgbModalWindow)), core["ɵdid"](1, 4440064, null, 0, modal_window_NgbModalWindow, [common["DOCUMENT"], core["ElementRef"], core["Renderer2"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = ("modal fade show d-block" + (core["ɵnov"](_v, 1).windowClass ? (" " + core["ɵnov"](_v, 1).windowClass) : "")); var currVal_1 = core["ɵnov"](_v, 1).ariaLabelledBy; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
var NgbModalWindowNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-modal-window", modal_window_NgbModalWindow, View_NgbModalWindow_Host_0, { ariaLabelledBy: "ariaLabelledBy", backdrop: "backdrop", centered: "centered", keyboard: "keyboard", size: "size", windowClass: "windowClass" }, { dismissEvent: "dismiss" }, ["*"]);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/popover/popover.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_popover PURE_IMPORTS_END */


var styles_NgbPopoverWindow = [".bs-popover-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: 50%;\n      margin-left: -5px;\n    }\n\n    .bs-popover-top-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-bottom-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: 2em;\n    }\n\n    .bs-popover-top-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-bottom-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: auto;\n      right: 2em;\n    }\n\n    .bs-popover-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: 50%;\n      margin-top: -5px;\n    }\n\n    .bs-popover-left-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-right-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: 0.7em;\n    }\n\n    .bs-popover-left-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-popover-right-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: auto;\n      bottom: 0.7em;\n    }"];
var RenderType_NgbPopoverWindow = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbPopoverWindow, data: {} });

function View_NgbPopoverWindow_0(_l) { return core["ɵvid"](2, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["class", "arrow"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h3", [["class", "popover-header"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵeld"](3, 0, null, null, 1, "div", [["class", "popover-body"]], null, null, null, null, null)), core["ɵncd"](null, 0)], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.title; _ck(_v, 2, 0, currVal_0); }); }
function View_NgbPopoverWindow_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-popover-window", [["role", "tooltip"]], [[8, "className", 0], [8, "id", 0]], null, null, View_NgbPopoverWindow_0, RenderType_NgbPopoverWindow)), core["ɵdid"](1, 49152, null, 0, NgbPopoverWindow, [core["ElementRef"], core["Renderer2"]], null, null)], null, function (_ck, _v) { var currVal_0 = (((("popover bs-popover-" + core["ɵnov"](_v, 1).placement.split("-")[0]) + " bs-popover-") + core["ɵnov"](_v, 1).placement) + (core["ɵnov"](_v, 1).popoverClass ? (" " + core["ɵnov"](_v, 1).popoverClass) : "")); var currVal_1 = core["ɵnov"](_v, 1).id; _ck(_v, 0, 0, currVal_0, currVal_1); }); }
var NgbPopoverWindowNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-popover-window", NgbPopoverWindow, View_NgbPopoverWindow_Host_0, { placement: "placement", title: "title", id: "id", popoverClass: "popoverClass" }, {}, ["*"]);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/tooltip/tooltip.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_tooltip PURE_IMPORTS_END */


var styles_NgbTooltipWindow = [".bs-tooltip-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: calc(50% - 0.4rem);\n    }\n\n    .bs-tooltip-top-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-bottom-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: 1em;\n    }\n\n    .bs-tooltip-top-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-bottom-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: auto;\n      right: 0.8rem;\n    }\n\n    .bs-tooltip-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: calc(50% - 0.4rem);\n    }\n\n    .bs-tooltip-left-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: 0.4rem;\n    }\n\n    .bs-tooltip-left-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: auto;\n      bottom: 0.4rem;\n    }"];
var RenderType_NgbTooltipWindow = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbTooltipWindow, data: {} });

function View_NgbTooltipWindow_0(_l) { return core["ɵvid"](2, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["class", "arrow"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "tooltip-inner"]], null, null, null, null, null)), core["ɵncd"](null, 0)], null, null); }
function View_NgbTooltipWindow_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-tooltip-window", [["role", "tooltip"]], [[8, "className", 0], [8, "id", 0]], null, null, View_NgbTooltipWindow_0, RenderType_NgbTooltipWindow)), core["ɵdid"](1, 49152, null, 0, NgbTooltipWindow, [core["ElementRef"], core["Renderer2"]], null, null)], null, function (_ck, _v) { var currVal_0 = ((("tooltip show bs-tooltip-" + core["ɵnov"](_v, 1).placement.split("-")[0]) + " bs-tooltip-") + core["ɵnov"](_v, 1).placement); var currVal_1 = core["ɵnov"](_v, 1).id; _ck(_v, 0, 0, currVal_0, currVal_1); }); }
var NgbTooltipWindowNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-tooltip-window", NgbTooltipWindow, View_NgbTooltipWindow_Host_0, { placement: "placement", id: "id" }, {}, ["*"]);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/highlight.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_highlight PURE_IMPORTS_END */



var styles_NgbHighlight = [".ngb-highlight[_ngcontent-%COMP%] {\n      font-weight: bold;\n    }"];
var RenderType_NgbHighlight = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbHighlight, data: {} });

function View_NgbHighlight_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [], [[8, "className", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _co.highlightClass, ""); _ck(_v, 0, 0, currVal_0); var currVal_1 = _v.parent.context.$implicit; _ck(_v, 1, 0, currVal_1); }); }
function View_NgbHighlight_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵted"](0, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit; _ck(_v, 0, 0, currVal_0); }); }
function View_NgbHighlight_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbHighlight_2)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbHighlight_3)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = _v.context.odd; _ck(_v, 1, 0, currVal_0); var currVal_1 = !_v.context.odd; _ck(_v, 3, 0, currVal_1); }, null); }
function View_NgbHighlight_0(_l) { return core["ɵvid"](2, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbHighlight_1)), core["ɵdid"](1, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.parts; _ck(_v, 1, 0, currVal_0); }, null); }
function View_NgbHighlight_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-highlight", [], null, null, null, View_NgbHighlight_0, RenderType_NgbHighlight)), core["ɵdid"](1, 573440, null, 0, highlight_NgbHighlight, [], null, null)], null, null); }
var NgbHighlightNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-highlight", highlight_NgbHighlight, View_NgbHighlight_Host_0, { highlightClass: "highlightClass", result: "result", term: "term" }, {}, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/typeahead/typeahead-window.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_highlight.ngfactory,_highlight,_angular_common,_typeahead_window PURE_IMPORTS_END */





var styles_NgbTypeaheadWindow = [];
var RenderType_NgbTypeaheadWindow = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NgbTypeaheadWindow, data: {} });

function View_NgbTypeaheadWindow_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-highlight", [], null, null, null, View_NgbHighlight_0, RenderType_NgbHighlight)), core["ɵdid"](1, 573440, null, 0, highlight_NgbHighlight, [], { result: [0, "result"], term: [1, "term"] }, null)], function (_ck, _v) { var currVal_0 = _v.context.formatter(_v.context.result); var currVal_1 = _v.context.term; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
function View_NgbTypeaheadWindow_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](0, null, null, 0))], null, null); }
function View_NgbTypeaheadWindow_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "button", [["class", "dropdown-item"], ["role", "option"], ["type", "button"]], [[8, "id", 0], [2, "active", null]], [[null, "mouseenter"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.markActive(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            if (("click" === en)) {
                var pd_1 = (_co.select(_v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_NgbTypeaheadWindow_3)), core["ɵdid"](2, 540672, null, 0, common["NgTemplateOutlet"], [core["ViewContainerRef"]], { ngTemplateOutletContext: [0, "ngTemplateOutletContext"], ngTemplateOutlet: [1, "ngTemplateOutlet"] }, null), core["ɵpod"](3, { result: 0, term: 1, formatter: 2 })], function (_ck, _v) { var _co = _v.component; var currVal_2 = _ck(_v, 3, 0, _v.context.$implicit, _co.term, _co.formatter); var currVal_3 = (_co.resultTemplate || core["ɵnov"](_v.parent, 0)); _ck(_v, 2, 0, currVal_2, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.id + "-") + _v.context.index); var currVal_1 = (_v.context.index === _co.activeIdx); _ck(_v, 0, 0, currVal_0, currVal_1); });
}
function View_NgbTypeaheadWindow_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](0, [["rt", 2]], null, 0, null, View_NgbTypeaheadWindow_1)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTypeaheadWindow_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.results; _ck(_v, 2, 0, currVal_0); }, null); }
function View_NgbTypeaheadWindow_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-typeahead-window", [["class", "dropdown-menu show"], ["role", "listbox"]], [[8, "id", 0]], null, null, View_NgbTypeaheadWindow_0, RenderType_NgbTypeaheadWindow)), core["ɵdid"](1, 114688, null, 0, typeahead_window_NgbTypeaheadWindow, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 1).id; _ck(_v, 0, 0, currVal_0); }); }
var NgbTypeaheadWindowNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-typeahead-window", typeahead_window_NgbTypeaheadWindow, View_NgbTypeaheadWindow_Host_0, { id: "id", focusFirst: "focusFirst", results: "results", term: "term", formatter: "formatter", resultTemplate: "resultTemplate" }, { selectEvent: "select", activeChangeEvent: "activeChange" }, []);



// EXTERNAL MODULE: ./node_modules/@angular/router/router.ngfactory.js
var router_ngfactory = __webpack_require__("OvSy");

// EXTERNAL MODULE: ./node_modules/ng2-auto-complete/dist/ng2-auto-complete.js
var ng2_auto_complete = __webpack_require__("Hoss");
var ng2_auto_complete_default = /*#__PURE__*/__webpack_require__.n(ng2_auto_complete);

// EXTERNAL MODULE: ./node_modules/ng2-auto-complete/dist/ng2-auto-complete.component.js
var ng2_auto_complete_component = __webpack_require__("BUs8");
var ng2_auto_complete_component_default = /*#__PURE__*/__webpack_require__.n(ng2_auto_complete_component);

// CONCATENATED MODULE: ./node_modules/ng2-auto-complete/dist/ng2-auto-complete.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_angular_common,_ng2_auto_complete,_angular_http,_ng2_auto_complete.component PURE_IMPORTS_END */






var styles_Ng2AutoCompleteComponent = ["\n  @keyframes slideDown {\n    0% {\n      transform:  translateY(-10px);\n    }\n    100% {\n      transform: translateY(0px);\n    }\n  }\n  .ng2-auto-complete {\n    background-color: transparent;\n  }\n  .ng2-auto-complete > input {\n    outline: none;\n    border: 0;\n    padding: 2px; \n    box-sizing: border-box;\n    background-clip: content-box;\n  }\n\n  .ng2-auto-complete > ul {\n    background-color: #fff;\n    margin: 0;\n    width : 100%;\n    overflow-y: auto;\n    list-style-type: none;\n    padding: 0;\n    border: 1px solid #ccc;\n    box-sizing: border-box;\n    animation: slideDown 0.1s;\n  }\n  .ng2-auto-complete > ul.empty {\n    display: none;\n  }\n\n  .ng2-auto-complete > ul li {\n    padding: 2px 5px;\n    border-bottom: 1px solid #eee;\n  }\n\n  .ng2-auto-complete > ul li.selected {\n    background-color: #ccc;\n  }\n\n  .ng2-auto-complete > ul li:last-child {\n    border-bottom: none;\n  }\n\n  .ng2-auto-complete > ul li:hover {\n    background-color: #ccc;\n  }"];
var RenderType_Ng2AutoCompleteComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_Ng2AutoCompleteComponent, data: {} });

function View_Ng2AutoCompleteComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, [[1, 0], ["autoCompleteInput", 1]], null, 5, "input", [["class", "keyword"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "focus"], [null, "blur"], [null, "keydown"], [null, "input"], [null, "ngModelChange"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 1)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("focus" === en)) {
                var pd_4 = (_co.showDropdownList($event) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (_co.hideDropdownList() !== false);
                ad = (pd_5 && ad);
            }
            if (("keydown" === en)) {
                var pd_6 = (_co.inputElKeyHandler($event) !== false);
                ad = (pd_6 && ad);
            }
            if (("input" === en)) {
                var pd_7 = (_co.reloadListInDelay($event) !== false);
                ad = (pd_7 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_8 = ((_co.keyword = $event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](3, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = _co.keyword; _ck(_v, 3, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _co.placeholder, ""); var currVal_1 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 5).ngClassValid; var currVal_6 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_Ng2AutoCompleteComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "li", [["class", "loading"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.loadingText; _ck(_v, 1, 0, currVal_0); }); }
function View_Ng2AutoCompleteComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "li", [["class", "no-match-found"]], null, [[null, "mousedown"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mousedown" === en)) {
                var pd_0 = (_co.selectOne("") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.noMatchFoundText || "No Result Found"); _ck(_v, 1, 0, currVal_0); });
}
function View_Ng2AutoCompleteComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "li", [["class", "blank-item"]], null, [[null, "mousedown"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mousedown" === en)) {
                var pd_0 = (_co.selectOne("") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.blankOptionText; _ck(_v, 1, 0, currVal_0); });
}
function View_Ng2AutoCompleteComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [["class", "item"]], [[8, "innerHTML", 1]], [[null, "mousedown"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mousedown" === en)) {
                var pd_0 = (_co.selectOne(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵpod"](2, { selected: 0 })], function (_ck, _v) { var _co = _v.component; var currVal_1 = "item"; var currVal_2 = _ck(_v, 2, 0, (_v.context.index === _co.itemIndex)); _ck(_v, 1, 0, currVal_1, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.autoComplete.getFormattedListItem(_v.context.$implicit); _ck(_v, 0, 0, currVal_0); });
}
function View_Ng2AutoCompleteComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "ul", [], [[2, "empty", null]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Ng2AutoCompleteComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Ng2AutoCompleteComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Ng2AutoCompleteComponent_5)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Ng2AutoCompleteComponent_6)), core["ɵdid"](8, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.isLoading; _ck(_v, 2, 0, currVal_1); var currVal_2 = ((_co.minCharsEntered && !_co.isLoading) && !_co.filteredList.length); _ck(_v, 4, 0, currVal_2); var currVal_3 = (_co.blankOptionText && _co.filteredList.length); _ck(_v, 6, 0, currVal_3); var currVal_4 = _co.filteredList; _ck(_v, 8, 0, currVal_4); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.emptyList; _ck(_v, 0, 0, currVal_0); }); }
function View_Ng2AutoCompleteComponent_0(_l) { return core["ɵvid"](0, [core["ɵqud"](671088640, 1, { autoCompleteInput: 0 }), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "ng2-auto-complete"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Ng2AutoCompleteComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Ng2AutoCompleteComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showInputTag; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.dropdownVisible; _ck(_v, 5, 0, currVal_1); }, null); }
function View_Ng2AutoCompleteComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "ng2-auto-complete", [], null, null, null, View_Ng2AutoCompleteComponent_0, RenderType_Ng2AutoCompleteComponent)), core["ɵprd"](512, null, ng2_auto_complete["Ng2AutoComplete"], ng2_auto_complete["Ng2AutoComplete"], [[2, fesm5_http["Http"]]]), core["ɵdid"](2, 114688, null, 0, ng2_auto_complete_component["Ng2AutoCompleteComponent"], [core["ElementRef"], ng2_auto_complete["Ng2AutoComplete"]], null, null)], function (_ck, _v) { _ck(_v, 2, 0); }, null); }
var Ng2AutoCompleteComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("ng2-auto-complete", ng2_auto_complete_component["Ng2AutoCompleteComponent"], View_Ng2AutoCompleteComponent_Host_0, { listFormatter: "list-formatter", source: "source", pathToData: "path-to-data", minChars: "min-chars", placeholder: "placeholder", blankOptionText: "blank-option-text", noMatchFoundText: "no-match-found-text", acceptUserInput: "accept-user-input", loadingText: "loading-text", maxNumList: "max-num-list", showInputTag: "show-input-tag", showDropdownOnInit: "show-dropdown-on-init", tabToSelect: "tab-to-select", matchFormatted: "match-formatted" }, { valueSelected: "valueSelected" }, []);



// EXTERNAL MODULE: ./node_modules/angular-mentions/mention/mention-list.component.js
var mention_list_component = __webpack_require__("vFoO");
var mention_list_component_default = /*#__PURE__*/__webpack_require__.n(mention_list_component);

// CONCATENATED MODULE: ./node_modules/angular-mentions/mention/mention-list.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_mention_list.component PURE_IMPORTS_END */



var styles_MentionListComponent = [".scrollable-menu[_ngcontent-%COMP%] {\n        display: block;\n        height: auto;\n        max-height: 300px;\n        overflow: auto;\n      }", "[hidden][_ngcontent-%COMP%] {\n        display: none;\n      }", "li.active[_ngcontent-%COMP%] {\n        background-color: #f7f7f9;\n      }"];
var RenderType_MentionListComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_MentionListComponent, data: {} });

function View_MentionListComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵted"](0, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.item[_co.labelKey]; _ck(_v, 0, 0, currVal_0); }); }
function View_MentionListComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](0, null, null, 0))], null, null); }
function View_MentionListComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "li", [], [[2, "active", null]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "a", [["class", "dropdown-item"]], null, [[null, "mousedown"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mousedown" === en)) {
                _co.activeIndex = _v.context.index;
                _co.itemClick.emit();
                var pd_0 = ($event.preventDefault() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_MentionListComponent_3)), core["ɵdid"](3, 540672, null, 0, common["NgTemplateOutlet"], [core["ViewContainerRef"]], { ngTemplateOutletContext: [0, "ngTemplateOutletContext"], ngTemplateOutlet: [1, "ngTemplateOutlet"] }, null), core["ɵpod"](4, { "item": 0 })], function (_ck, _v) { var _co = _v.component; var currVal_1 = _ck(_v, 4, 0, _v.context.$implicit); var currVal_2 = _co.itemTemplate; _ck(_v, 3, 0, currVal_1, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.activeIndex == _v.context.index); _ck(_v, 0, 0, currVal_0); });
}
function View_MentionListComponent_0(_l) { return core["ɵvid"](0, [core["ɵqud"](402653184, 1, { list: 0 }), core["ɵqud"](402653184, 2, { defaultItemTemplate: 0 }), (_l()(), core["ɵand"](0, [[2, 2], ["defaultItemTemplate", 2]], null, 0, null, View_MentionListComponent_1)), (_l()(), core["ɵeld"](3, 0, [[1, 0], ["list", 1]], null, 2, "ul", [["class", "dropdown-menu scrollable-menu"]], [[8, "hidden", 0]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MentionListComponent_2)), core["ɵdid"](5, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.items; _ck(_v, 5, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.hidden; _ck(_v, 3, 0, currVal_0); }); }
function View_MentionListComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "mention-list", [], null, null, null, View_MentionListComponent_0, RenderType_MentionListComponent)), core["ɵdid"](1, 114688, null, 0, mention_list_component["MentionListComponent"], [core["ElementRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MentionListComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("mention-list", mention_list_component["MentionListComponent"], View_MentionListComponent_Host_0, { labelKey: "labelKey", itemTemplate: "itemTemplate" }, { itemClick: "itemClick" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/adminPage.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_router,_angular_common,_adminPage.component,_services_mdmService.service PURE_IMPORTS_END */





var styles_AdminPage = [];
var RenderType_AdminPage = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AdminPage, data: {} });

function View_AdminPage_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 112, "div", [["class", "col-lg-2 col-md-3 col-sm-12 col-xs-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "menu-headers"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" SETUP "])), (_l()(), core["ɵeld"](3, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](5, 671744, [[2, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](6, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 1, { links: 1 }), core["ɵqud"](603979776, 2, { linksWithHrefs: 1 }), core["ɵpad"](9, 2), (_l()(), core["ɵted"](-1, null, ["Data Engine"])), (_l()(), core["ɵeld"](11, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 13).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](13, 671744, [[4, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](14, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 3, { links: 1 }), core["ɵqud"](603979776, 4, { linksWithHrefs: 1 }), core["ɵpad"](17, 2), (_l()(), core["ɵted"](-1, null, ["Data Location"])), (_l()(), core["ɵeld"](19, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 21).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](21, 671744, [[6, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](22, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 5, { links: 1 }), core["ɵqud"](603979776, 6, { linksWithHrefs: 1 }), core["ɵpad"](25, 2), (_l()(), core["ɵted"](-1, null, ["Data Mart"])), (_l()(), core["ɵeld"](27, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 29).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](29, 671744, [[8, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](30, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 7, { links: 1 }), core["ɵqud"](603979776, 8, { linksWithHrefs: 1 }), core["ɵpad"](33, 2), (_l()(), core["ɵted"](-1, null, ["Designer"])), (_l()(), core["ɵeld"](35, 0, null, null, 1, "h6", [["class", "menu-headers"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" ANALYTICAL MODEL "])), (_l()(), core["ɵeld"](37, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 39).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](39, 671744, [[10, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](40, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 9, { links: 1 }), core["ɵqud"](603979776, 10, { linksWithHrefs: 1 }), core["ɵpad"](43, 2), (_l()(), core["ɵted"](-1, null, ["Cube"])), (_l()(), core["ɵeld"](45, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 47).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](47, 671744, [[12, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](48, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 11, { links: 1 }), core["ɵqud"](603979776, 12, { linksWithHrefs: 1 }), core["ɵpad"](51, 2), (_l()(), core["ɵted"](-1, null, ["Dimension"])), (_l()(), core["ɵeld"](53, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 55).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](55, 671744, [[14, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](56, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 13, { links: 1 }), core["ɵqud"](603979776, 14, { linksWithHrefs: 1 }), core["ɵpad"](59, 2), (_l()(), core["ɵted"](-1, null, ["Measure"])), (_l()(), core["ɵeld"](61, 0, null, null, 1, "h6", [["class", "menu-headers"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" AUTHORIZATION "])), (_l()(), core["ɵeld"](63, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](64, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 65).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](65, 671744, [[16, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](66, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 15, { links: 1 }), core["ɵqud"](603979776, 16, { linksWithHrefs: 1 }), core["ɵpad"](69, 2), (_l()(), core["ɵted"](-1, null, ["Scope"])), (_l()(), core["ɵeld"](71, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](72, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 73).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](73, 671744, [[18, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](74, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 17, { links: 1 }), core["ɵqud"](603979776, 18, { linksWithHrefs: 1 }), core["ɵpad"](77, 2), (_l()(), core["ɵted"](-1, null, ["Page Authorization"])), (_l()(), core["ɵeld"](79, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](80, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 81).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](81, 671744, [[20, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](82, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 19, { links: 1 }), core["ɵqud"](603979776, 20, { linksWithHrefs: 1 }), core["ɵpad"](85, 2), (_l()(), core["ɵted"](-1, null, ["Role Authorization"])), (_l()(), core["ɵeld"](87, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](88, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 89).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](89, 671744, [[22, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](90, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 21, { links: 1 }), core["ɵqud"](603979776, 22, { linksWithHrefs: 1 }), core["ɵpad"](93, 2), (_l()(), core["ɵted"](-1, null, ["Dimension Level Permissions "])), (_l()(), core["ɵeld"](95, 0, null, null, 1, "h6", [["class", "menu-headers"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" CONFIGURATION "])), (_l()(), core["ɵeld"](97, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](98, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 99).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](99, 671744, [[24, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](100, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 23, { links: 1 }), core["ɵqud"](603979776, 24, { linksWithHrefs: 1 }), core["ɵpad"](103, 2), (_l()(), core["ɵted"](-1, null, ["Tenant Configuration"])), (_l()(), core["ɵeld"](105, 0, null, null, 7, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](106, 0, null, null, 6, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 107).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](107, 671744, [[26, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵdid"](108, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 25, { links: 1 }), core["ɵqud"](603979776, 26, { linksWithHrefs: 1 }), core["ɵpad"](111, 2), (_l()(), core["ɵted"](-1, null, ["UOM"]))], function (_ck, _v) { var currVal_2 = "dataEngine"; _ck(_v, 5, 0, currVal_2); var currVal_3 = _ck(_v, 9, 0, "lt-black", "medium"); _ck(_v, 6, 0, currVal_3); var currVal_6 = "dataSource"; _ck(_v, 13, 0, currVal_6); var currVal_7 = _ck(_v, 17, 0, "lt-black", "medium"); _ck(_v, 14, 0, currVal_7); var currVal_10 = "recordFormat"; _ck(_v, 21, 0, currVal_10); var currVal_11 = _ck(_v, 25, 0, "lt-black", "medium"); _ck(_v, 22, 0, currVal_11); var currVal_14 = "wizard"; _ck(_v, 29, 0, currVal_14); var currVal_15 = _ck(_v, 33, 0, "lt-black", "medium"); _ck(_v, 30, 0, currVal_15); var currVal_18 = "cube"; _ck(_v, 39, 0, currVal_18); var currVal_19 = _ck(_v, 43, 0, "lt-black", "medium"); _ck(_v, 40, 0, currVal_19); var currVal_22 = "dimension"; _ck(_v, 47, 0, currVal_22); var currVal_23 = _ck(_v, 51, 0, "lt-black", "medium"); _ck(_v, 48, 0, currVal_23); var currVal_26 = "measure"; _ck(_v, 55, 0, currVal_26); var currVal_27 = _ck(_v, 59, 0, "lt-black", "medium"); _ck(_v, 56, 0, currVal_27); var currVal_30 = "scope"; _ck(_v, 65, 0, currVal_30); var currVal_31 = _ck(_v, 69, 0, "lt-black", "medium"); _ck(_v, 66, 0, currVal_31); var currVal_34 = "pageAuthorization"; _ck(_v, 73, 0, currVal_34); var currVal_35 = _ck(_v, 77, 0, "lt-black", "medium"); _ck(_v, 74, 0, currVal_35); var currVal_38 = "roleAuthorization"; _ck(_v, 81, 0, currVal_38); var currVal_39 = _ck(_v, 85, 0, "lt-black", "medium"); _ck(_v, 82, 0, currVal_39); var currVal_42 = "dimLvlPermissions"; _ck(_v, 89, 0, currVal_42); var currVal_43 = _ck(_v, 93, 0, "lt-black", "medium"); _ck(_v, 90, 0, currVal_43); var currVal_46 = "tenantConfiguration"; _ck(_v, 99, 0, currVal_46); var currVal_47 = _ck(_v, 103, 0, "lt-black", "medium"); _ck(_v, 100, 0, currVal_47); var currVal_50 = "uom"; _ck(_v, 107, 0, currVal_50); var currVal_51 = _ck(_v, 111, 0, "lt-black", "medium"); _ck(_v, 108, 0, currVal_51); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 5).target; var currVal_1 = core["ɵnov"](_v, 5).href; _ck(_v, 4, 0, currVal_0, currVal_1); var currVal_4 = core["ɵnov"](_v, 13).target; var currVal_5 = core["ɵnov"](_v, 13).href; _ck(_v, 12, 0, currVal_4, currVal_5); var currVal_8 = core["ɵnov"](_v, 21).target; var currVal_9 = core["ɵnov"](_v, 21).href; _ck(_v, 20, 0, currVal_8, currVal_9); var currVal_12 = core["ɵnov"](_v, 29).target; var currVal_13 = core["ɵnov"](_v, 29).href; _ck(_v, 28, 0, currVal_12, currVal_13); var currVal_16 = core["ɵnov"](_v, 39).target; var currVal_17 = core["ɵnov"](_v, 39).href; _ck(_v, 38, 0, currVal_16, currVal_17); var currVal_20 = core["ɵnov"](_v, 47).target; var currVal_21 = core["ɵnov"](_v, 47).href; _ck(_v, 46, 0, currVal_20, currVal_21); var currVal_24 = core["ɵnov"](_v, 55).target; var currVal_25 = core["ɵnov"](_v, 55).href; _ck(_v, 54, 0, currVal_24, currVal_25); var currVal_28 = core["ɵnov"](_v, 65).target; var currVal_29 = core["ɵnov"](_v, 65).href; _ck(_v, 64, 0, currVal_28, currVal_29); var currVal_32 = core["ɵnov"](_v, 73).target; var currVal_33 = core["ɵnov"](_v, 73).href; _ck(_v, 72, 0, currVal_32, currVal_33); var currVal_36 = core["ɵnov"](_v, 81).target; var currVal_37 = core["ɵnov"](_v, 81).href; _ck(_v, 80, 0, currVal_36, currVal_37); var currVal_40 = core["ɵnov"](_v, 89).target; var currVal_41 = core["ɵnov"](_v, 89).href; _ck(_v, 88, 0, currVal_40, currVal_41); var currVal_44 = core["ɵnov"](_v, 99).target; var currVal_45 = core["ɵnov"](_v, 99).href; _ck(_v, 98, 0, currVal_44, currVal_45); var currVal_48 = core["ɵnov"](_v, 107).target; var currVal_49 = core["ɵnov"](_v, 107).href; _ck(_v, 106, 0, currVal_48, currVal_49); });
}
function View_AdminPage_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h1", [["class", "medium text-center"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Access Denied !!!"]))], null, null); }
function View_AdminPage_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "menu", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AdminPage_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AdminPage_2)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](5, 0, null, null, 2, "div", [["class", "col-lg-10 col-md-9 col-sm-12 col-xs-12 float-left b-l"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, fesm5_router["p" /* RouterOutlet */], [fesm5_router["b" /* ChildrenOutletContexts */], core["ViewContainerRef"], core["ComponentFactoryResolver"], [8, null], core["ChangeDetectorRef"]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.accessDenied; _ck(_v, 4, 0, currVal_1); _ck(_v, 7, 0); }, null); }
function View_AdminPage_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "adminPage", [], null, null, null, View_AdminPage_0, RenderType_AdminPage)), core["ɵdid"](1, 114688, null, 0, AdminPage, [fesm5_router["l" /* Router */], mdmService_service_MDMService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AdminPageNgFactory = /*@__PURE__*/ core["ɵccf"]("adminPage", AdminPage, View_AdminPage_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/biAdminStyles.css.shim.ngstyle.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var biAdminStyles_css_shim_ngstyle_styles = [".overflow-x[_ngcontent-%COMP%] {\n    overflow-x: scroll;\n}"];



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/pagination/pagination.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_pagination,_pagination_config PURE_IMPORTS_END */




var styles_NgbPagination = [];
var RenderType_NgbPagination = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NgbPagination, data: {} });

function View_NgbPagination_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [["class", "page-item"]], [[2, "disabled", null]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "a", [["aria-label", "First"], ["class", "page-link"], ["href", ""]], [[1, "tabindex", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.selectPage(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00AB\u00AB"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (!_co.hasPrevious() || _co.disabled); _ck(_v, 0, 0, currVal_0); var currVal_1 = (_co.hasPrevious() ? null : "-1"); _ck(_v, 1, 0, currVal_1); });
}
function View_NgbPagination_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [["class", "page-item"]], [[2, "disabled", null]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "a", [["aria-label", "Previous"], ["class", "page-link"], ["href", ""]], [[1, "tabindex", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.selectPage((_co.page - 1)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00AB"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (!_co.hasPrevious() || _co.disabled); _ck(_v, 0, 0, currVal_0); var currVal_1 = (_co.hasPrevious() ? null : "-1"); _ck(_v, 1, 0, currVal_1); });
}
function View_NgbPagination_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "a", [["class", "page-link"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["..."]))], null, null); }
function View_NgbPagination_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [["class", "sr-only"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["(current)"]))], null, null); }
function View_NgbPagination_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "a", [["class", "page-link"], ["href", ""]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.selectPage(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbPagination_6)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = (_v.parent.context.$implicit === _co.page); _ck(_v, 3, 0, currVal_1); }, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit; _ck(_v, 1, 0, currVal_0); });
}
function View_NgbPagination_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "li", [["class", "page-item"]], [[2, "active", null], [2, "disabled", null]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbPagination_4)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbPagination_5)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = _co.isEllipsis(_v.context.$implicit); _ck(_v, 2, 0, currVal_2); var currVal_3 = !_co.isEllipsis(_v.context.$implicit); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_v.context.$implicit === _co.page); var currVal_1 = (_co.isEllipsis(_v.context.$implicit) || _co.disabled); _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_NgbPagination_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [["class", "page-item"]], [[2, "disabled", null]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "a", [["aria-label", "Next"], ["class", "page-link"], ["href", ""]], [[1, "tabindex", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.selectPage((_co.page + 1)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00BB"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (!_co.hasNext() || _co.disabled); _ck(_v, 0, 0, currVal_0); var currVal_1 = (_co.hasNext() ? null : "-1"); _ck(_v, 1, 0, currVal_1); });
}
function View_NgbPagination_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [["class", "page-item"]], [[2, "disabled", null]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "a", [["aria-label", "Last"], ["class", "page-link"], ["href", ""]], [[1, "tabindex", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.selectPage(_co.pageCount) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00BB\u00BB"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (!_co.hasNext() || _co.disabled); _ck(_v, 0, 0, currVal_0); var currVal_1 = (_co.hasNext() ? null : "-1"); _ck(_v, 1, 0, currVal_1); });
}
function View_NgbPagination_0(_l) { return core["ɵvid"](2, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "ul", [], [[8, "className", 0]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbPagination_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbPagination_2)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbPagination_3)), core["ɵdid"](6, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbPagination_7)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbPagination_8)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.boundaryLinks; _ck(_v, 2, 0, currVal_1); var currVal_2 = _co.directionLinks; _ck(_v, 4, 0, currVal_2); var currVal_3 = _co.pages; _ck(_v, 6, 0, currVal_3); var currVal_4 = _co.directionLinks; _ck(_v, 8, 0, currVal_4); var currVal_5 = _co.boundaryLinks; _ck(_v, 10, 0, currVal_5); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = ("pagination" + (_co.size ? (" pagination-" + _co.size) : "")); _ck(_v, 0, 0, currVal_0); }); }
function View_NgbPagination_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["role", "navigation"]], null, null, null, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], null, null)], null, null); }
var NgbPaginationNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-pagination", pagination_NgbPagination, View_NgbPagination_Host_0, { disabled: "disabled", boundaryLinks: "boundaryLinks", directionLinks: "directionLinks", ellipses: "ellipses", rotate: "rotate", collectionSize: "collectionSize", maxSize: "maxSize", page: "page", pageSize: "pageSize", size: "size" }, { pageChange: "pageChange" }, []);



// EXTERNAL MODULE: ./node_modules/@ngx-translate/core/@ngx-translate/core.es5.js
var core_es5 = __webpack_require__("YKDW");

// CONCATENATED MODULE: ./src/app/employee/employeeFilter.ts




var employeeFilter_EmployeeFilter = /*@__PURE__*/ (function () {
    function EmployeeFilter(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, _location, vcr, _translate) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this._location = _location;
        this.vcr = vcr;
        this._translate = _translate;
        this.isCollapsed = false;
        this.searchEmp = new core["EventEmitter"]();
        this.showButtonLoading = false;
        this.type = '';
        this.programId = '';
        // tree
        this.orgData = [];
        this.showOrg = false;
        this.dropDownEnabled = true;
        this.config = TreeviewConfig.create({
            hasAllCheckBox: true,
            hasFilter: true,
            hasCollapseExpand: true,
            decoupleChildFromParent: false,
            maxHeight: 400
        });
        this.buttonClasses = [
            'btn-outline-primary',
            'btn-outline-secondary',
            'btn-outline-success',
            'btn-outline-danger',
            'btn-outline-warning',
            'btn-outline-info',
            'btn-outline-light',
            'btn-outline-dark'
        ];
        this.buttonClass = this.buttonClasses[6];
        this.empCodeValues = '';
        this.excludeEmpCodeValues = '';
        /// multiSelect
        this.itemDesignationList = [];
        this.itemGradeList = [];
        this.itemManagerList = [];
        this.itemCatList = [];
        this.itemPositionList = [];
        this.itemPayBasisList = [];
        this.itemNationalityGroupList = [];
        this.itemStaffCategoryList = [];
        this.itemWorkingSpecialtyList = [];
        this.itemAssignmentStatusTypeList = [];
        this.itemStatusList = [];
        this.itemSuperList = [];
        this.selectedDesignationItems = [];
        this.selectedPositions = [];
        this.selectedPayBasis = [];
        this.selectedNationalityGroup = [];
        this.selectedStaffCategory = [];
        this.selectedWorkingSpecialty = [];
        this.selectedAssignmentStatusType = [];
        this.selectedGradeItems = [];
        this.selectedManagerItems = [];
        this.selectedCatItems = [];
        this.selectedStatusItems = [];
        this.selectedSuperItems = [];
        this.designationSettings = {};
        this.gradeSettings = {};
        this.managerSettings = {};
        this.catSettings = {};
        this.positionSettings = {};
        this.workingSpecialtySettings = {};
        this.assignmentStatusTypeSettings = {};
        this.staffCategorySettings = {};
        this.nationalityGroupSettings = {};
        this.PayBasisSettings = {};
        this.statusSettings = {};
        this.superSettings = {};
        this.page = 5;
        this.endingPage = 0;
        this.startingPage = 0;
        this.localState = { value: '' };
        this.employeeData = [];
        this.employeePageData = [];
        this.trackHides = null;
        this.designationModel = {
            id: null,
            name: ''
        };
        this.organizationModel = {
            id: null,
            orgName: ''
        };
        this.orgName = '';
        this.designationName = '';
        this.displayName = '';
        this.primarySupervisorModel = {
            id: null,
            displayName: ''
        };
        this.statusData = '';
        this.showAdvanceSearch = false;
        this.pageSize = 10;
        this.showLoading = false;
        this.searchData = {
            nameOrCodeOrEmail: '',
            employeeCodes: [],
            excludedEmployeeCodes: [],
            includeEmpIds: [],
            excludeEmpIds: [],
            gradeIds: [],
            mgrLevelIds: [],
            designationIds: [],
            categoryIds: [],
            includeOrgIds: [],
            excludeOrgIds: [],
            supervisorIds: [],
            primarySupervisorIds: [],
            primarySupervisorNameOrCode: null,
            primarySupervisorCods: [],
            positionIds: [],
            payBasisIds: [],
            nationalityGroupIds: [],
            staffCategoryIds: [],
            workingSpecialtyIds: [],
            entityIds: [],
            employeeStatus: null,
            employeesWithOutSupervisor: null,
            scorecardStates: null,
            memberShipState: null,
            programId: null,
            pageSize: 10,
            page: 1,
            fetchSupervisorLevels: 0,
            licenceNumber: null
        };
        // To get list of Organization based on keyword
        this.organizationObservableSource = function (keyword) {
            var url = _this._baseUrl + 'v1/webAdmin/employee/orgSearch';
            url += '?searchString=' + keyword;
            if (keyword) {
                return _this.http.get(url)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        // To get list of designation based on keyword
        this.designationObservableSource = function (keyword) {
            var url = _this._baseUrl + 'v1/webAdmin/employee/designationSearch';
            url += '?searchString=' + keyword;
            if (keyword) {
                return _this.http.get(url)
                    .map(function (res) {
                    return res;
                }, function (error) {
                    return Observable["a" /* Observable */].of([]);
                });
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.currentPage = 1;
        this._auth.closeFilterValue.subscribe(function () {
            _this.isCollapsed = false;
        });
        this.translateFilterLabels();
    }
    EmployeeFilter.prototype.translateFilterLabels = function () {
        var _this = this;
        this._translate.get('seletDesignation').subscribe(function (res) {
            _this.designationText = res;
        });
        this._translate.get('selectBasicPay').subscribe(function (res) {
            _this.basicPayText = res;
        });
        this._translate.get('selectJobGrade').subscribe(function (res) {
            _this.jobGradeText = res;
        });
        this._translate.get('selectEmpType').subscribe(function (res) {
            _this.empTypeText = res;
        });
        this._translate.get('selectJobCategory').subscribe(function (res) {
            _this.jobCatText = res;
        });
        this._translate.get('selectPosition').subscribe(function (res) {
            _this.positionText = res;
        });
        this._translate.get('selectNationality').subscribe(function (res) {
            _this.nationalityText = res;
        });
        this._translate.get('selectStaffCategory').subscribe(function (res) {
            _this.staffCatogoryText = res;
        });
        this._translate.get('selectWorkingSpecialty').subscribe(function (res) {
            _this.workSpecialtyText = res;
        });
        this._translate.get('selectAssignmentStatus').subscribe(function (res) {
            _this.assignmentStatusText = res;
        });
        this._translate.get('selectSupervisor').subscribe(function (res) {
            _this.supervisorText = res;
        });
        this._translate.get('selectAll').subscribe(function (res) {
            _this.selectAllLabel = res;
        });
        this._translate.get('unSelectAll').subscribe(function (res) {
            _this.unSelectAllLabel = res;
        });
        this._translate.get('searchDesignation').subscribe(function (res) {
            _this.searchDesignation = res;
        });
        this._translate.get('searchPayBasis').subscribe(function (res) {
            _this.searchPayBasis = res;
        });
        this._translate.get('searchJobGrade').subscribe(function (res) {
            _this.searchJobGrade = res;
        });
        this._translate.get('searchEmpType').subscribe(function (res) {
            _this.searchEmpType = res;
        });
        this._translate.get('searchJobCategory').subscribe(function (res) {
            _this.searchJobCategory = res;
        });
        this._translate.get('searchPosition').subscribe(function (res) {
            _this.searchPosition = res;
        });
        this._translate.get('searchNationality').subscribe(function (res) {
            _this.searchNationality = res;
        });
        this._translate.get('searchWorkSpecialty').subscribe(function (res) {
            _this.searchWorkSpecialty = res;
        });
        this._translate.get('searchAssignmentStatus').subscribe(function (res) {
            _this.searchAssignmentStatus = res;
        });
        this._translate.get('searchSupervisor').subscribe(function (res) {
            _this.searchSupervisor = res;
            //As we need the translated text we are calling defautFilterSettings at last.
            _this.defaultFilterSettings();
        });
    };
    EmployeeFilter.prototype.defaultFilterSettings = function () {
        this.superSettings = {
            text: this.supervisorText,
            selectAllText: this.selectAllLabel,
            unSelectAllText: this.unSelectAllLabel,
            classes: '',
            primaryKey: 'id',
            labelKey: 'displayName',
            noDataLabel: this.searchSupervisor,
            enableSearchFilter: true,
            badgeShowLimit: 3,
            searchBy: ['id', 'displayName']
        };
    };
    EmployeeFilter.prototype.ngOnInit = function () {
    };
    EmployeeFilter.prototype.reset = function () {
        this.searchData.gradeIds = [];
        this.selectedGradeItems = [];
        this.searchData.mgrLevelIds = [];
        this.selectedManagerItems = [];
        this.searchData.categoryIds = [];
        this.selectedCatItems = [];
        this.searchData.designationIds = [];
        this.selectedDesignationItems = [];
        this.selectedPositions = [];
        this.selectedPayBasis = [];
        this.selectedNationalityGroup = [];
        this.selectedStaffCategory = [];
        this.selectedWorkingSpecialty = [];
        this.selectedAssignmentStatusType = [];
        this.searchData.includeOrgIds = [];
        this.searchData.employeeCodes = [];
        this.empCodeValues = '';
        this.searchData.excludedEmployeeCodes = [];
        this.excludeEmpCodeValues = '';
        this.searchData.positionIds = [];
        this.values = [];
        this.searchData.nameOrCodeOrEmail = '';
        this.searchData.employeeStatus = null;
        this.selectedStatusItems = [
            { id: '', itemName: 'All' }
        ];
        this.searchData.supervisorIds = [];
        this.selectedSuperItems = [];
    };
    EmployeeFilter.prototype.populateData = function (val) {
        if (this.empCodeValues.trim() !== '') {
            this.searchData.employeeCodes = this.empCodeValues.split(',');
        }
        else {
            this.searchData.employeeCodes = [];
        }
        if (this.excludeEmpCodeValues.trim() !== '') {
            this.searchData.excludedEmployeeCodes = this.excludeEmpCodeValues.split(',');
        }
        else {
            this.searchData.excludedEmployeeCodes = [];
        }
        this.searchData.gradeIds = this.getIds(this.selectedGradeItems);
        this.searchData.mgrLevelIds = this.getIds(this.selectedManagerItems);
        this.searchData.categoryIds = this.getIds(this.selectedCatItems);
        this.searchData.designationIds = this.getIds(this.selectedDesignationItems);
        this.searchData.positionIds = this.getIds(this.selectedPositions);
        this.searchData.payBasisIds = this.getIds(this.selectedPayBasis);
        this.searchData.nationalityGroupIds = this.getIds(this.selectedNationalityGroup);
        this.searchData.staffCategoryIds = this.getIds(this.selectedStaffCategory);
        this.searchData.workingSpecialtyIds = this.getIds(this.selectedWorkingSpecialty);
        this.searchData.entityIds = this.getIds(this.selectedAssignmentStatusType);
        this.searchData.employeeStatus = null;
        this.searchData.supervisorIds = this.getIds(this.selectedSuperItems);
        this.searchData.includeOrgIds = [];
        this.searchEmp.emit(this.searchData);
    };
    EmployeeFilter.prototype.getIds = function (data) {
        var ids = [];
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var t = data_1[_i];
            ids.push(t.id);
        }
        return ids;
    };
    // Patch for pop-over issue
    EmployeeFilter.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    EmployeeFilter.prototype.clicked = function () {
        this.trackHides = null;
    };
    // show and hide Advance Search option
    EmployeeFilter.prototype.showAdvanced = function (e) {
        this.showAdvanceSearch = e;
    };
    EmployeeFilter.prototype.searchEmployeeCods = function (e) {
        if (e === '') {
            this.searchData.employeeCodes = [];
        }
        else {
            this.searchData.employeeCodes[0] = e;
        }
    };
    EmployeeFilter.prototype.gotNewValue = function (e, type) {
        var d;
        if (e.id !== undefined) {
            d = (e.id.toString());
        }
        if (type === 'designation') {
            if (this.designationModel === '') {
                this.searchData.designationIds = [];
                return;
            }
            this.searchData.designationIds[0] = d;
        }
        if (type === 'organization') {
            if (this.organizationModel === '') {
                this.searchData.includeOrgIds = [];
                return;
            }
            this.searchData.includeOrgIds[0] = d;
        }
        if (type === 'primary') {
            if (this.primarySupervisorModel === '') {
                this.searchData.supervisorIds = [];
                return;
            }
            this.searchData.supervisorIds[0] = d;
        }
    };
    EmployeeFilter.prototype.empTableActions = function (value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        }
        else {
            this.trackHides = value;
        }
    };
    EmployeeFilter.prototype.empTableResetPwd = function (id) {
        this.trackHides = null;
        this.share.saveData(id);
        var modalRef = this.modalService.open(ResetPasswordPage, { windowClass: 'min-modal' });
    };
    EmployeeFilter.prototype.isSearchToggle = function () {
        this.isCollapsed = this.isCollapsed ? false : true;
    };
    return EmployeeFilter;
}());



// CONCATENATED MODULE: ./src/app/shared/sharedData.ts
var SharedData = /*@__PURE__*/ (function () {
    function SharedData() {
        this.sharingData = {};
        this.sharingArrayData = [];
        this.map = new Map();
    }
    SharedData.prototype.saveData = function (str) {
        this.sharingData = str;
    };
    SharedData.prototype.getData = function () {
        return this.sharingData;
    };
    SharedData.prototype.saveArray = function (str) {
        this.sharingArrayData = str;
    };
    SharedData.prototype.getArray = function () {
        return this.sharingArrayData;
    };
    SharedData.prototype.getNextPageData = function (data) {
        this.nextPageData = data;
    };
    SharedData.prototype.getCurrentPageData = function (data) {
        this.nextPageData = data;
    };
    SharedData.prototype.getPerviousPageData = function (data) {
        this.nextPageData = data;
    };
    SharedData.prototype.saveAsMap = function (key, value) {
        this.map.set(key, value);
    };
    SharedData.prototype.getMapValues = function (key) {
        return this.map.get(key);
    };
    SharedData.prototype.clear = function () {
        return this.map = new Map();
    };
    return SharedData;
}());



// EXTERNAL MODULE: ./node_modules/@angular/platform-browser/fesm5/platform-browser.js
var platform_browser = __webpack_require__("5D2H");

// CONCATENATED MODULE: ./src/app/toasterComponent/toasterComponent.ts
var ToasterComponent = /*@__PURE__*/ (function () {
    function ToasterComponent(toastr) {
        this.toastr = toastr;
    }
    ToasterComponent.prototype.setViewRef = function (vcr) {
        // this.toastr.setRootViewContainerRef(vcr);
    };
    ToasterComponent.prototype.showSuccess = function (msg) {
        this.toastr.success('<span style="color: white">' + msg + '</span>', null);
    };
    ToasterComponent.prototype.showError = function (msg) {
        this.toastr.error('<span style="color: white">' + msg + '</span>', null);
    };
    ToasterComponent.prototype.showWarning = function (msg) {
        this.toastr.warning('<span style="color: white">' + msg + '</span>', null, { enableHtml: true });
    };
    ToasterComponent.prototype.showInfo = function (msg) {
        this.toastr.info('<span style="color: white">' + msg + '</span>', null, { enableHtml: true });
    };
    return ToasterComponent;
}());



// CONCATENATED MODULE: ./src/app/employee/employeeFilter.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_ngx_translate_core,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_ng_bootstrap_ng_bootstrap_collapse_collapse,_employeeFilter,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_angular_platform_browser,_toasterComponent_toasterComponent PURE_IMPORTS_END */
















var styles_EmployeeFilter = [];
var RenderType_EmployeeFilter = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmployeeFilter, data: {} });

function View_EmployeeFilter_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "input", [["class", "form-control"], ["readonly", ""], ["type", "text"]], null, null, null, null, null))], null, null); }
function View_EmployeeFilter_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "input", [["class", "form-control"], ["name", "emplSearch"], ["type", "text"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "keyup.enter"], [null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 1)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("keyup.enter" === en)) {
                var pd_4 = (_co.populateData("Search") !== false);
                ad = (pd_4 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_5 = ((_co.searchData.nameOrCodeOrEmail = $event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](3, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_8 = "emplSearch"; var currVal_9 = _co.searchData.nameOrCodeOrEmail; _ck(_v, 3, 0, currVal_8, currVal_9); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 0, 0, core["ɵnov"](_v, 6).transform("enterUserName")), ""); var currVal_1 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 5).ngClassValid; var currVal_6 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_EmployeeFilter_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 6, "input", [["class", "w-100 float-left form-control"], ["id", "userName"], ["name", "nameOrCodeOrEmail"], ["type", "text"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.searchData.nameOrCodeOrEmail = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = "nameOrCodeOrEmail"; var currVal_10 = _co.searchData.nameOrCodeOrEmail; _ck(_v, 8, 0, currVal_9, currVal_10); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("userName")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 11).transform("enterUserName")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); });
}
function View_EmployeeFilter_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 6, "input", [["class", "w-100 float-left form-control"], ["id", "licenceNumber"], ["name", "licenceNumber"], ["type", "text"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.searchData.licenceNumber = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = "licenceNumber"; var currVal_10 = _co.searchData.licenceNumber; _ck(_v, 8, 0, currVal_9, currVal_10); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("icOrPassport")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 11).transform("enterIcOrPassport")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); });
}
function View_EmployeeFilter_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 33, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "medium mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 29, "div", [["class", "form-group mt-2 w-75 d-inline-flex relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 8, "div", [["class", "relative w-75"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeFilter_1)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeFilter_2)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "c-p"], ["placement", "bottom-right"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { placement: [0, "placement"], ngbTooltip: [1, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](13, 0, null, null, 0, "i", [["aria-controls", "collapseExample"], ["class", "fa fa-caret-down tr-0 cursor"]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.isSearchToggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "button", [["class", "btn btn-primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.populateData("Search") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](15, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](17, 0, null, null, 16, "div", [["class", "w-75 absolute top-100 left-0 p-3 white-bg z-i shadow"], ["id", "collapseExample"]], [[2, "collapse", null], [2, "show", null]], null, null, null, null)), core["ɵdid"](18, 16384, null, 0, NgbCollapse, [], { collapsed: [0, "collapsed"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 14, "div", [["class", "row"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeFilter_3)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeFilter_4)), core["ɵdid"](23, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 9, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "button", [["class", "btn btn-link float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.reset() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](26, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](28, 0, null, null, 2, "button", [["aria-controls", "collapseExample"], ["class", "btn btn-primary float-right ml-3"]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = ((_co.isCollapsed = !_co.isCollapsed) !== false);
                ad = (pd_0 && ad);
            }
            if (("click" === en)) {
                var pd_1 = (_co.populateData("Search") !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](29, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](31, 0, null, null, 2, "button", [["aria-controls", "collapseExample"], ["class", "btn btn-light float-right"]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = ((_co.isCollapsed = !_co.isCollapsed) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](32, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_1 = (_co.displayTab == "startProgram"); _ck(_v, 7, 0, currVal_1); var currVal_2 = (_co.displayTab != "startProgram"); _ck(_v, 9, 0, currVal_2); var currVal_3 = "bottom-right"; var currVal_4 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 11, 1, core["ɵnov"](_v, 12).transform("showSearchOption")), ""); _ck(_v, 11, 0, currVal_3, currVal_4); var currVal_9 = !_co.isCollapsed; _ck(_v, 18, 0, currVal_9); var currVal_10 = (_co.displayTab != "startProgram"); _ck(_v, 21, 0, currVal_10); var currVal_11 = (_co.displayTab != "startProgram"); _ck(_v, 23, 0, currVal_11); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("filters")); _ck(_v, 2, 0, currVal_0); var currVal_5 = !_co.isCollapsed; _ck(_v, 13, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("search")); _ck(_v, 15, 0, currVal_6); var currVal_7 = true; var currVal_8 = !core["ɵnov"](_v, 18).collapsed; _ck(_v, 17, 0, currVal_7, currVal_8); var currVal_12 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("resetKey")); _ck(_v, 26, 0, currVal_12); var currVal_13 = !_co.isCollapsed; _ck(_v, 28, 0, currVal_13); var currVal_14 = core["ɵunv"](_v, 29, 0, core["ɵnov"](_v, 30).transform("apply")); _ck(_v, 29, 0, currVal_14); var currVal_15 = !_co.isCollapsed; _ck(_v, 31, 0, currVal_15); var currVal_16 = core["ɵunv"](_v, 32, 0, core["ɵnov"](_v, 33).transform("close")); _ck(_v, 32, 0, currVal_16); });
}
function View_EmployeeFilter_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "employeeFilter", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_EmployeeFilter_0, RenderType_EmployeeFilter)), core["ɵdid"](1, 114688, null, 0, employeeFilter_EmployeeFilter, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null);
}
var EmployeeFilterNgFactory = /*@__PURE__*/ core["ɵccf"]("employeeFilter", employeeFilter_EmployeeFilter, View_EmployeeFilter_Host_0, { displayTab: "displayTab" }, { searchEmp: "searchEmp" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/loader.component.ts
var Loader = /*@__PURE__*/ (function () {
    function Loader() {
        // console.log("-----------loading-------------")
    }
    return Loader;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/loader.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_loader.component PURE_IMPORTS_END */


var styles_Loader = [];
var RenderType_Loader = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_Loader, data: {} });

function View_Loader_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["style", "position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "img", [["alt", "loading"], ["src", "./assets/img/load.gif"], ["width", "80px"]], null, null, null, null, null))], null, null); }
function View_Loader_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](1, 49152, null, 0, Loader, [], null, null)], null, null); }
var LoaderNgFactory = /*@__PURE__*/ core["ɵccf"]("loader", Loader, View_Loader_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/tabset/tabset.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_tabset,_tabset_config PURE_IMPORTS_END */




var styles_NgbTabset = [];
var RenderType_NgbTabset = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NgbTabset, data: {} });

function View_NgbTabset_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](0, null, null, 0))], null, null); }
function View_NgbTabset_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "li", [["class", "nav-item"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "a", [["class", "nav-link"], ["href", ""], ["role", "tab"]], [[8, "id", 0], [2, "active", null], [2, "disabled", null], [1, "tabindex", 0], [1, "aria-controls", 0], [1, "aria-expanded", 0], [1, "aria-disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.select(_v.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](2, null, [" ", ""])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTabset_2)), core["ɵdid"](4, 540672, null, 0, common["NgTemplateOutlet"], [core["ViewContainerRef"]], { ngTemplateOutlet: [0, "ngTemplateOutlet"] }, null)], function (_ck, _v) { var currVal_8 = ((_v.context.$implicit.titleTpl == null) ? null : _v.context.$implicit.titleTpl.templateRef); _ck(_v, 4, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.id; var currVal_1 = (_v.context.$implicit.id === _co.activeId); var currVal_2 = _v.context.$implicit.disabled; var currVal_3 = (_v.context.$implicit.disabled ? "-1" : undefined); var currVal_4 = ((!_co.destroyOnHide || (_v.context.$implicit.id === _co.activeId)) ? (_v.context.$implicit.id + "-panel") : null); var currVal_5 = (_v.context.$implicit.id === _co.activeId); var currVal_6 = _v.context.$implicit.disabled; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_7 = _v.context.$implicit.title; _ck(_v, 2, 0, currVal_7); });
}
function View_NgbTabset_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](0, null, null, 0))], null, null); }
function View_NgbTabset_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["role", "tabpanel"]], [[8, "className", 0], [1, "aria-labelledby", 0], [8, "id", 0], [1, "aria-expanded", 0]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTabset_5)), core["ɵdid"](2, 540672, null, 0, common["NgTemplateOutlet"], [core["ViewContainerRef"]], { ngTemplateOutlet: [0, "ngTemplateOutlet"] }, null)], function (_ck, _v) { var currVal_4 = ((_v.parent.context.$implicit.contentTpl == null) ? null : _v.parent.context.$implicit.contentTpl.templateRef); _ck(_v, 2, 0, currVal_4); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "tab-pane ", ((_v.parent.context.$implicit.id === _co.activeId) ? "active" : null), ""); var currVal_1 = _v.parent.context.$implicit.id; var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.parent.context.$implicit.id, "-panel"); var currVal_3 = (_v.parent.context.$implicit.id === _co.activeId); _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3); }); }
function View_NgbTabset_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTabset_4)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (!_co.destroyOnHide || (_v.context.$implicit.id === _co.activeId)); _ck(_v, 1, 0, currVal_0); }, null); }
function View_NgbTabset_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "ul", [["role", "tablist"]], [[8, "className", 0]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTabset_1)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 2, "div", [["class", "tab-content"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTabset_3)), core["ɵdid"](5, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.tabs; _ck(_v, 2, 0, currVal_1); var currVal_2 = _co.tabs; _ck(_v, 5, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (("nav nav-" + _co.type) + ((_co.orientation == "horizontal") ? (" " + _co.justifyClass) : " flex-column")); _ck(_v, 0, 0, currVal_0); }); }
function View_NgbTabset_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "ngb-tabset", [], null, null, null, View_NgbTabset_0, RenderType_NgbTabset)), core["ɵdid"](1, 2146304, null, 1, tabset_NgbTabset, [NgbTabsetConfig], null, null), core["ɵqud"](603979776, 1, { tabs: 1 })], null, null); }
var NgbTabsetNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-tabset", tabset_NgbTabset, View_NgbTabset_Host_0, { activeId: "activeId", destroyOnHide: "destroyOnHide", justify: "justify", orientation: "orientation", type: "type" }, { tabChange: "tabChange" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/pageAuthorization.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _.._biAdminStyles.css.shim.ngstyle,_angular_core,_angular_forms,_angular_common,_ng_bootstrap_ng_bootstrap_dropdown_dropdown,_ng_bootstrap_ng_bootstrap_dropdown_dropdown_config,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_.._.._employee_employeeFilter.ngfactory,_.._.._employee_employeeFilter,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._.._shared_services_configuration,_.._.._shared_services_http.client,_.._.._shared_services_auth,_.._.._shared_sharedData,_angular_platform_browser,_.._.._toasterComponent_toasterComponent,_ngx_translate_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_loader.component.ngfactory,_loader.component,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_tabset_tabset.ngfactory,_ng_bootstrap_ng_bootstrap_tabset_tabset,_ng_bootstrap_ng_bootstrap_tabset_tabset_config,_pageAuthorization.component,_services_mdmService.service PURE_IMPORTS_END */





























var styles_pageAuthorizationComponent = [biAdminStyles_css_shim_ngstyle_styles];
var RenderType_pageAuthorizationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_pageAuthorizationComponent, data: {} });

function View_pageAuthorizationComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["PAGE-AUTHORIZATION"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null))], null, null); }
function View_pageAuthorizationComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "div", [["class", "col-lg-12 col-md-12 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 7, "form", [["class", ""], ["enctype", "multipart/form-data"], ["method", "POST"], ["novalidate", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "submit"], [null, "reset"]], function (_v, en, $event) {
            var ad = true;
            if (("submit" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("reset" === en)) {
                var pd_1 = (core["ɵnov"](_v, 5).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bg"], [], null, null), core["ɵdid"](5, 4210688, null, 0, fesm5_forms["NgForm"], [[8, null], [8, null]], null, null), core["ɵprd"](2048, null, fesm5_forms["ControlContainer"], null, [fesm5_forms["NgForm"]]), core["ɵdid"](7, 16384, null, 0, fesm5_forms["NgControlStatusGroup"], [[4, fesm5_forms["ControlContainer"]]], null, null), (_l()(), core["ɵeld"](8, 0, [[1, 0], ["file", 1]], null, 0, "input", [["accept", ".xls,.xlsx"], ["class", "pull-left next-btn r mt-smd m-r-smd m-b-smd"], ["multipart", "true"], ["name", "file"], ["placeholder", "No File Chosen."], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.fileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "bulkUpload"], ["type", "submit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.bulkUpload($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Bulk Upload "]))], null, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 7).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 7).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 7).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 7).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 7).ngClassValid; var currVal_5 = core["ɵnov"](_v, 7).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 7).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_pageAuthorizationComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 4, "div", [["class", "progress"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "div", [["aria-valuemax", "100"], ["aria-valuemin", "0"], ["class", "progress-bar"], ["role", "progressbar"]], [[1, "aria-valuenow", 0]], null, null, null, null)), core["ɵdid"](4, 278528, null, 0, common["NgStyle"], [core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngStyle: [0, "ngStyle"] }, null), core["ɵpod"](5, { "width": 0 }), (_l()(), core["ɵted"](6, null, [" ", "% "]))], function (_ck, _v) { var _co = _v.component; var currVal_1 = _ck(_v, 5, 0, (_co.progress + "%")); _ck(_v, 4, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.progress; _ck(_v, 3, 0, currVal_0); var currVal_2 = _co.progress; _ck(_v, 6, 0, currVal_2); }); }
function View_pageAuthorizationComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", " (", ") "]))], function (_ck, _v) { var currVal_0 = _v.context.$implicit.id; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit.id; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.name; var currVal_3 = _v.context.$implicit.pageCode; _ck(_v, 3, 0, currVal_2, currVal_3); }); }
function View_pageAuthorizationComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "th", [["scope", "col"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " (", ") "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.name; var currVal_1 = _v.context.$implicit.pageSectionCode; _ck(_v, 2, 0, currVal_0, currVal_1); }); }
function View_pageAuthorizationComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 21, "td", [["scope", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 20, "div", [["class", "p-initial dropdown"], ["ngbDropdown", ""], ["placement", "bottom-right"]], [[2, "show", null]], null, null, null, null)), core["ɵdid"](2, 212992, null, 2, dropdown_NgbDropdown, [core["ChangeDetectorRef"], NgbDropdownConfig, common["DOCUMENT"], core["NgZone"]], { placement: [0, "placement"] }, null), core["ɵqud"](335544320, 7, { _menu: 0 }), core["ɵqud"](335544320, 8, { _anchor: 0 }), (_l()(), core["ɵeld"](5, 0, null, null, 5, "a", [["aria-haspopup", "true"], ["class", "dropdown-toggle"], ["ngbDropdownToggle", ""]], [[8, "id", 0], [1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6).toggleOpen() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, NgbDropdownToggle, [dropdown_NgbDropdown, core["ElementRef"]], null, null), core["ɵprd"](2048, [[8, 4]], NgbDropdownAnchor, null, [NgbDropdownToggle]), (_l()(), core["ɵeld"](8, 0, null, null, 2, "i", [["class", "fa"]], null, null, null, null, null)), core["ɵdid"](9, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵpod"](10, { "fa-check-circle text-success": 0, "fa-times-circle text-danger": 1, "fa-lock": 2 }), (_l()(), core["ɵeld"](11, 0, null, null, 10, "div", [["ngbDropdownMenu", ""]], [[1, "aria-labelledby", 0], [2, "dropdown-menu", null], [2, "show", null], [1, "x-placement", 0]], null, null, null, null)), core["ɵdid"](12, 16384, [[7, 4]], 0, dropdown_NgbDropdownMenu, [dropdown_NgbDropdown, core["ElementRef"], core["Renderer2"]], null, null), (_l()(), core["ɵeld"](13, 0, null, null, 2, "a", [["class", "dropdown-item text-truncate"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onChange(_v.parent.context.$implicit.id, _v.context.$implicit.id, _v.parent.context.index, 0) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 0, "i", [["class", "fa fa-check-circle text-success mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Active"])), (_l()(), core["ɵeld"](16, 0, null, null, 2, "a", [["class", "dropdown-item text-truncate"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onChange(_v.parent.context.$implicit.id, _v.context.$implicit.id, _v.parent.context.index, 1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 0, "i", [["class", "fa fa-times-circle text-danger mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Inactive"])), (_l()(), core["ɵeld"](19, 0, null, null, 2, "a", [["class", "dropdown-item text-truncate"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onChange(_v.parent.context.$implicit.id, _v.context.$implicit.id, _v.parent.context.index, 2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 0, "i", [["class", "fa fa-lock mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Lock"]))], function (_ck, _v) { var _co = _v.component; var currVal_1 = "bottom-right"; _ck(_v, 2, 0, currVal_1); var currVal_4 = "fa"; var currVal_5 = ((_co.paMap.get(((_v.parent.context.$implicit.id + "_") + _v.context.$implicit.id)) != undefined) ? _ck(_v, 10, 0, (_co.paMap.get(((_v.parent.context.$implicit.id + "_") + _v.context.$implicit.id)) == 0), (_co.paMap.get(((_v.parent.context.$implicit.id + "_") + _v.context.$implicit.id)) == 1), (_co.paMap.get(((_v.parent.context.$implicit.id + "_") + _v.context.$implicit.id)) == 2)) : "fa-times-circle text-danger"); _ck(_v, 9, 0, currVal_4, currVal_5); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).isOpen(); _ck(_v, 1, 0, currVal_0); var currVal_2 = ((_v.parent.context.$implicit.id + "_") + _v.context.$implicit.id); var currVal_3 = core["ɵnov"](_v, 6).dropdown.isOpen(); _ck(_v, 5, 0, currVal_2, currVal_3); var currVal_6 = ((_v.parent.context.$implicit.id + "_") + _v.context.$implicit.id); var currVal_7 = true; var currVal_8 = core["ɵnov"](_v, 12).dropdown.isOpen(); var currVal_9 = core["ɵnov"](_v, 12).placement; _ck(_v, 11, 0, currVal_6, currVal_7, currVal_8, currVal_9); });
}
function View_pageAuthorizationComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 30, "tr", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "td", [["scope", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "td", [["scope", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 21, "td", [["scope", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 20, "div", [["class", "p-initial dropdown"], ["ngbDropdown", ""], ["placement", "bottom-right"]], [[2, "show", null]], null, null, null, null)), core["ɵdid"](9, 212992, null, 2, dropdown_NgbDropdown, [core["ChangeDetectorRef"], NgbDropdownConfig, common["DOCUMENT"], core["NgZone"]], { placement: [0, "placement"] }, null), core["ɵqud"](335544320, 5, { _menu: 0 }), core["ɵqud"](335544320, 6, { _anchor: 0 }), (_l()(), core["ɵeld"](12, 0, null, null, 5, "a", [["aria-haspopup", "true"], ["class", "dropdown-toggle"], ["ngbDropdownToggle", ""]], [[8, "id", 0], [1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 13).toggleOpen() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](13, 16384, null, 0, NgbDropdownToggle, [dropdown_NgbDropdown, core["ElementRef"]], null, null), core["ɵprd"](2048, [[6, 4]], NgbDropdownAnchor, null, [NgbDropdownToggle]), (_l()(), core["ɵeld"](15, 0, null, null, 2, "i", [["class", "fa"]], null, null, null, null, null)), core["ɵdid"](16, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵpod"](17, { "fa-check-circle text-success": 0, "fa-times-circle text-danger": 1, "fa-lock": 2, "fa-circle-o": 3 }), (_l()(), core["ɵeld"](18, 0, null, null, 10, "div", [["ngbDropdownMenu", ""]], [[1, "aria-labelledby", 0], [2, "dropdown-menu", null], [2, "show", null], [1, "x-placement", 0]], null, null, null, null)), core["ɵdid"](19, 16384, [[5, 4]], 0, dropdown_NgbDropdownMenu, [dropdown_NgbDropdown, core["ElementRef"], core["Renderer2"]], null, null), (_l()(), core["ɵeld"](20, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectAll(_v.context.$implicit.id, _v.context.index, 0) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 0, "i", [["class", "fa fa-check-circle text-success mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Active"])), (_l()(), core["ɵeld"](23, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectAll(_v.context.$implicit.id, _v.context.index, 1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 0, "i", [["class", "fa fa-times-circle text-danger mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Inactive"])), (_l()(), core["ɵeld"](26, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectAll(_v.context.$implicit.id, _v.context.index, 2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 0, "i", [["class", "fa fa-lock mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Lock"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_11)), core["ɵdid"](30, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_3 = "bottom-right"; _ck(_v, 9, 0, currVal_3); var currVal_6 = "fa"; var currVal_7 = ((_co.selectedAll[_v.context.index] != undefined) ? _ck(_v, 17, 0, (_co.selectedAll[_v.context.index] == 0), (_co.selectedAll[_v.context.index] == 1), (_co.selectedAll[_v.context.index] == 2), (_co.selectedAll[_v.context.index] == 3)) : "fa-circle"); _ck(_v, 16, 0, currVal_6, currVal_7); var currVal_12 = _co.pageSectionList; _ck(_v, 30, 0, currVal_12); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.empCode; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 6, 0, currVal_1); var currVal_2 = core["ɵnov"](_v, 9).isOpen(); _ck(_v, 8, 0, currVal_2); var currVal_4 = _v.context.$implicit.id; var currVal_5 = core["ɵnov"](_v, 13).dropdown.isOpen(); _ck(_v, 12, 0, currVal_4, currVal_5); var currVal_8 = _v.context.$implicit.id; var currVal_9 = true; var currVal_10 = core["ɵnov"](_v, 19).dropdown.isOpen(); var currVal_11 = core["ɵnov"](_v, 19).placement; _ck(_v, 18, 0, currVal_8, currVal_9, currVal_10, currVal_11); });
}
function View_pageAuthorizationComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "table-responsive text-nowrap"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 16, "table", [["class", "table table-bordered table-hover table-striped"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 12, "thead", [["class", "thead-dark"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 11, "tr", [], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "th", [["scope", "col"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Employee Code "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "th", [["scope", "col"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Employee Name "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "th", [["scope", "col"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Select All "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_9)), core["ɵdid"](14, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 2, "tbody", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_10)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.pageSectionList; _ck(_v, 14, 0, currVal_0); var currVal_1 = _co.empList; _ck(_v, 17, 0, currVal_1); }, null); }
function View_pageAuthorizationComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left  mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Employee to Show"]))], null, null); }
function View_pageAuthorizationComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_13)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_pageAuthorizationComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left  mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Page Section to Load"]))], null, null); }
function View_pageAuthorizationComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_15)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_pageAuthorizationComponent_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " items of ", " "])), (_l()(), core["ɵeld"](3, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](6, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](13, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](14, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](16, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](17, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](18, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](20, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](21, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](22, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](24, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](26, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_10 = _co.pageSize; _ck(_v, 9, 0, currVal_10); var currVal_11 = "10"; _ck(_v, 13, 0, currVal_11); var currVal_12 = "10"; _ck(_v, 14, 0, currVal_12); var currVal_13 = "20"; _ck(_v, 17, 0, currVal_13); var currVal_14 = "20"; _ck(_v, 18, 0, currVal_14); var currVal_15 = "30"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "30"; _ck(_v, 22, 0, currVal_16); var currVal_17 = true; var currVal_18 = false; var currVal_19 = true; var currVal_20 = _co.totalEmps; var currVal_21 = 5; var currVal_22 = _co.currentPage; var currVal_23 = _co.pageSize; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.startingPage + 1); var currVal_1 = _co.endingPage; var currVal_2 = _co.totalEmps; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2); var currVal_3 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 11).ngClassValid; var currVal_8 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 6, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); });
}
function View_pageAuthorizationComponent_18(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); }); }
function View_pageAuthorizationComponent_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); }); }
function View_pageAuthorizationComponent_20(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); }); }
function View_pageAuthorizationComponent_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 30, "div", [["class", "info"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Bulk Upload Summary"])), (_l()(), core["ɵeld"](5, 0, null, null, 9, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" NON EXISTENT USERS "])), (_l()(), core["ɵeld"](9, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" NON EXISTENT PAGE SECTIONS "])), (_l()(), core["ɵeld"](12, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" NON EXISTENT ACCESS "])), (_l()(), core["ɵeld"](15, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "ul", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_18)), core["ɵdid"](19, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "ul", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_19)), core["ɵdid"](23, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "ul", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_20)), core["ɵdid"](27, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](28, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 1, "button", [["class", "float-right btn btn-primary"], ["id", "onSaveChanges"], ["type", "submit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onCloseSummary($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Close Summary "]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.nonExistentUsers; _ck(_v, 19, 0, currVal_0); var currVal_1 = _co.nonExistentPageSections; _ck(_v, 23, 0, currVal_1); var currVal_2 = _co.nonExistentAccess; _ck(_v, 27, 0, currVal_2); }, null);
}
function View_pageAuthorizationComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 53, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 4, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "div", [["class", "col-lg-12 col-md-12 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Operations"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_5)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_6)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 16777216, null, null, 1, "employeeFilter", [], null, [[null, "searchEmp"], ["window", "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 13).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("searchEmp" === en)) {
                var pd_1 = (_co.showSearchFilter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EmployeeFilter_0, RenderType_EmployeeFilter)), core["ɵdid"](13, 114688, null, 0, employeeFilter_EmployeeFilter, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { displayTab: [0, "displayTab"] }, { searchEmp: "searchEmp" }), (_l()(), core["ɵeld"](14, 0, null, null, 39, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 4, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Select DashBoard"])), (_l()(), core["ɵeld"](20, 0, null, null, 4, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 3, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 2, "select", [["class", "form-control light-bg"], ["name", "pageList"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectPage($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_7)), core["ɵdid"](24, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](25, 0, null, null, 15, "div", [["class", "w-100 mb-3 align-v-center justify-content-between"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "h5", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Page-Authorization Contents"])), (_l()(), core["ɵeld"](28, 0, null, null, 12, "div", [["class", "align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 3, "div", [["class", "mr-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 0, "i", [["class", "fa fa-check-circle text-success"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 1, "span", [["class", "ml-2 text-14x"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Active"])), (_l()(), core["ɵeld"](33, 0, null, null, 3, "div", [["class", "mr-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 0, "i", [["class", "fa fa-times-circle text-danger"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 1, "span", [["class", "ml-2 text-14x"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Inactive"])), (_l()(), core["ɵeld"](37, 0, null, null, 3, "div", [["class", "mr-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 0, "i", [["class", "fa fa-lock"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 1, "span", [["class", "ml-2 text-14x"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Lock"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_8)), core["ɵdid"](42, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_12)), core["ɵdid"](44, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_14)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_16)), core["ɵdid"](48, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](49, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 1, "button", [["class", "float-right btn btn-primary"], ["id", "onSaveChanges"], ["type", "submit"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSaveChanges($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save Changes "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_17)), core["ɵdid"](53, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isProgress; _ck(_v, 8, 0, currVal_0); var currVal_1 = _co.isProgress; _ck(_v, 10, 0, currVal_1); var currVal_2 = "employeeSearch"; _ck(_v, 13, 0, currVal_2); var currVal_3 = _co.pageList; _ck(_v, 24, 0, currVal_3); var currVal_4 = (((_co.empList && _co.empList.length) && (_co.empList.length > 0)) && (_co.pageSectionList && _co.pageSectionList.length)); _ck(_v, 42, 0, currVal_4); var currVal_5 = !((_co.empList && _co.empList.length) && (_co.empList.length > 0)); _ck(_v, 44, 0, currVal_5); var currVal_6 = (((_co.empList && _co.empList.length) && (_co.empList.length > 0)) && !(_co.pageSectionList && _co.pageSectionList.length)); _ck(_v, 46, 0, currVal_6); var currVal_7 = (_co.pageSectionList && _co.pageSectionList.length); _ck(_v, 48, 0, currVal_7); var currVal_9 = _co.uploadSucess; _ck(_v, 53, 0, currVal_9); }, function (_ck, _v) { var _co = _v.component; var currVal_8 = !_co.saveChangesButton; _ck(_v, 50, 0, currVal_8); });
}
function View_pageAuthorizationComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_4)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 1, 0, currVal_0); }, null); }
function View_pageAuthorizationComponent_22(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["class", "mb-0 ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.fileNameToUpload; _ck(_v, 1, 0, currVal_0); }); }
function View_pageAuthorizationComponent_23(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "label", [["class", "medium col-4"], ["for", "comments"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Comments: "])), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](6, 0, null, null, 7, "textarea", [["class", "form-control col-6 ml-3"], ["name", "comment"], ["placeholder", "Enter Comments"], ["required", ""], ["rows", "2"]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.comment = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 3, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "label", [["class", "medium col-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 1, "button", [["class", "btn btn-primary ml-3"], ["id", "bulkUpload"], ["type", "submit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.initBulkPageAuth($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Upload "]))], function (_ck, _v) { var _co = _v.component; var currVal_8 = ""; _ck(_v, 8, 0, currVal_8); var currVal_9 = "comment"; var currVal_10 = _co.comment; _ck(_v, 11, 0, currVal_9, currVal_10); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 8).required ? "" : null); var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_pageAuthorizationComponent_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "a", [["class", "mb-0 small"], ["href", "#/biAdmin/pageAuthorization"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadPageAuthFiles(_v.parent.context.$implicit.attachedFiles[0].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", "clickToDownload", ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.context.$implicit.attachedFiles[0].name; _ck(_v, 2, 0, currVal_1); });
}
function View_pageAuthorizationComponent_27(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "a", [["class", "mb-0 small"], ["href", "#/biAdmin/pageAuthorization"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadPageAuthFiles(_v.parent.context.$implicit.attachedFiles[1].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", "clickToDownload", ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.context.$implicit.attachedFiles[1].name; _ck(_v, 2, 0, currVal_1); });
}
function View_pageAuthorizationComponent_25(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, "div", [["class", "w-100 p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", ""])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, ["", ""])), (_l()(), core["ɵeld"](13, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_26)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_27)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_4 = (_v.context.$implicit.attachedFiles.length > 0); _ck(_v, 15, 0, currVal_4); var currVal_5 = (_v.context.$implicit.attachedFiles.length > 1); _ck(_v, 18, 0, currVal_5); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.comment; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.startDate; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.state; _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.failureReason; _ck(_v, 12, 0, currVal_3); }); }
function View_pageAuthorizationComponent_28(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.authCurrentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onAuthHistoryPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.authTotalRecs; var currVal_4 = 5; var currVal_5 = _co.authCurrentPage; var currVal_6 = _co.authPageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_pageAuthorizationComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 55, "div", [["class", "w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "w-100 float-left align-v-center mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"], ["name", "pageAuthHistoryRefresh"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.getPageAuthHistory() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-refresh mr-2 text-white"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Refresh "])), (_l()(), core["ɵeld"](6, 0, null, null, 22, "div", [["class", "col-lg-12 col-md-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 18, "div", [["class", "light-bg w-100 p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Comments"])), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Start Date"])), (_l()(), core["ɵeld"](14, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Status"])), (_l()(), core["ɵeld"](17, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Failure Reason"])), (_l()(), core["ɵeld"](20, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Attached File"])), (_l()(), core["ɵeld"](23, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Response File"])), (_l()(), core["ɵeld"](26, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_25)), core["ɵdid"](28, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](32, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](35, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 36).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 36).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.authPageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onAuthHistoryPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](36, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](38, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](40, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](41, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](42, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](43, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](45, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](46, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](47, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](49, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](50, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](51, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](53, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_28)), core["ɵdid"](55, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.tableData; _ck(_v, 28, 0, currVal_1); var currVal_12 = _co.authPageSize; _ck(_v, 38, 0, currVal_12); var currVal_13 = "10"; _ck(_v, 42, 0, currVal_13); var currVal_14 = "10"; _ck(_v, 43, 0, currVal_14); var currVal_15 = "20"; _ck(_v, 46, 0, currVal_15); var currVal_16 = "20"; _ck(_v, 47, 0, currVal_16); var currVal_17 = "30"; _ck(_v, 50, 0, currVal_17); var currVal_18 = "30"; _ck(_v, 51, 0, currVal_18); var currVal_19 = (_co.tableData && _co.tableData.length); _ck(_v, 55, 0, currVal_19); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.uploadButtonDisable; _ck(_v, 3, 0, currVal_0); var currVal_2 = _co.authStartingPage; var currVal_3 = _co.authEndingPage; var currVal_4 = _co.authTotalRecs; _ck(_v, 31, 0, currVal_2, currVal_3, currVal_4); var currVal_5 = core["ɵnov"](_v, 40).ngClassUntouched; var currVal_6 = core["ɵnov"](_v, 40).ngClassTouched; var currVal_7 = core["ɵnov"](_v, 40).ngClassPristine; var currVal_8 = core["ɵnov"](_v, 40).ngClassDirty; var currVal_9 = core["ɵnov"](_v, 40).ngClassValid; var currVal_10 = core["ɵnov"](_v, 40).ngClassInvalid; var currVal_11 = core["ɵnov"](_v, 40).ngClassPending; _ck(_v, 35, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11); });
}
function View_pageAuthorizationComponent_21(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 19, "div", [["class", "w-100 float-left mb-4 b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 18, "div", [["class", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 13, "div", [["class", "col-lg-8 col-md-8"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 10, "div", [["class", "form-group align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "label", [["class", "medium col-4"], ["for", "excelTypeSelect"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Browse File To Upload: "])), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](8, 0, null, null, 3, "div", [["class", "relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, [[1, 0], ["file", 1]], null, 0, "input", [["accept", ".xlsx"], ["class", "fileInput"], ["multipart", "true"], ["name", "file"], ["placeholder", "No File Chosen."], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.chooseFile($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "button", [["class", "btn btn-primary ml-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Browse"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_22)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_23)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "div", [["class", "form-group align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "a", [["class", ""], ["href", "javascript:void(0)"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadTemplate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Download Template"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_24)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.fileNameToUpload != null); _ck(_v, 13, 0, currVal_0); var currVal_1 = (_co.fileNameToUpload != null); _ck(_v, 15, 0, currVal_1); var currVal_2 = (_co.tableData.length > 0); _ck(_v, 21, 0, currVal_2); }, null);
}
function View_pageAuthorizationComponent_29(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_pageAuthorizationComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 20, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 17, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 14, "ngb-tabset", [["type", "pills"]], null, [[null, "tabChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("tabChange" === en)) {
                var pd_0 = (_co.beforeChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NgbTabset_0, RenderType_NgbTabset)), core["ɵdid"](5, 2146304, null, 1, tabset_NgbTabset, [NgbTabsetConfig], { activeId: [0, "activeId"], type: [1, "type"] }, { tabChange: "tabChange" }), core["ɵqud"](603979776, 2, { tabs: 1 }), (_l()(), core["ɵeld"](7, 0, null, null, 5, "ngb-tab", [["id", "individual"], ["title", "Individual"]], null, null, null, null, null)), core["ɵdid"](8, 2113536, [[2, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 3, { titleTpls: 1 }), core["ɵqud"](603979776, 4, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_pageAuthorizationComponent_3)), core["ɵdid"](12, 16384, [[4, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null), (_l()(), core["ɵeld"](13, 0, null, null, 5, "ngb-tab", [["id", "bulk"], ["title", "Bulk"]], null, null, null, null, null)), core["ɵdid"](14, 2113536, [[2, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 9, { titleTpls: 1 }), core["ɵqud"](603979776, 10, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_pageAuthorizationComponent_21)), core["ɵdid"](18, 16384, [[10, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_29)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", _co.selectedTab, ""); var currVal_2 = "pills"; _ck(_v, 5, 0, currVal_1, currVal_2); var currVal_3 = "individual"; var currVal_4 = "Individual"; _ck(_v, 8, 0, currVal_3, currVal_4); var currVal_5 = "bulk"; var currVal_6 = "Bulk"; _ck(_v, 14, 0, currVal_5, currVal_6); var currVal_7 = _co.loader; _ck(_v, 20, 0, currVal_7); }, null);
}
function View_pageAuthorizationComponent_0(_l) { return core["ɵvid"](0, [core["ɵqud"](671088640, 1, { fileInput: 0 }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_pageAuthorizationComponent_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 2, 0, currVal_0); }, null); }
function View_pageAuthorizationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "pageAuthorization", [], null, null, null, View_pageAuthorizationComponent_0, RenderType_pageAuthorizationComponent)), core["ɵdid"](1, 114688, null, 0, pageAuthorization_component_pageAuthorizationComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var pageAuthorizationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("pageAuthorization", pageAuthorization_component_pageAuthorizationComponent, View_pageAuthorizationComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/services/roleAuthService.service.ts

var roleAuthService_service_RoleAuthService = /*@__PURE__*/ (function () {
    function RoleAuthService(mdmService, toastr, _global) {
        this.mdmService = mdmService;
        this.toastr = toastr;
        this._global = _global;
        this.updateURL = this._global.get('EPMS_BASE_URL') + 'v1/' + BiUrls.BIADMIN + '/' + BiUrls.PAGE;
    }
    RoleAuthService.prototype.getRoleList = function (page, size) {
        var self = this;
        var url = self.updateURL + BiUrls.GET_ROLES + '/' + page + '/' + size;
        return new Promise(function (resolve) {
            self.mdmService.getRoleData(url).then(function (res) {
                if (res == undefined) {
                    self.toastr.showError('Cannot load the Role Data');
                }
                else {
                    var result = res.content != undefined ?
                        res.content.length == 0 ?
                            self.toastr.showWarning('No Roles to load') :
                            res :
                        self.toastr.showError('No Roles found');
                    resolve(result);
                }
            }, function (err) {
                console.error(err);
            });
        });
    };
    RoleAuthService.prototype.getWidgetCount = function (roleIdList) {
        var self = this;
        return new Promise(function (resolve) {
            var url = self.updateURL + BiUrls.GET_PAGE_AUTH_BY_ROLE + BiUrls.GET_ALL_WIDGET;
            self.mdmService.getRoleWidgets(url, roleIdList).then(function (res) {
                if (res == undefined) {
                    self.toastr.showError('Cannot load the Count Data');
                }
                else {
                    resolve(res.data);
                }
            }, function (err) {
                console.error(err);
            });
        });
    };
    RoleAuthService.prototype.getPages = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.mdmService.onStartUp('../' + BiUrls.BIADMIN + '/' + BiUrls.DASHBOARD_PAGES).then(function (res) {
                if (res != undefined) {
                    var page = res.data != null ? res.data : [];
                    resolve(page);
                }
                else {
                    resolve('completed');
                }
            }, function (err) {
                console.error(err);
            });
        });
    };
    RoleAuthService.prototype.getRoleAuth = function (roleId) {
        var self = this;
        return new Promise(function (resolve, reject) {
            var url = self.updateURL + BiUrls.GET_PAGE_AUTH_BY_ROLE + BiUrls.GET_ALL;
            self.mdmService.loadRoleAuthorizations(url, roleId).then(function (res) {
                if (res != undefined) {
                    var result = res.data != null ? res.data : [];
                    resolve(result);
                }
                else {
                    resolve(null);
                }
            }, function (err) {
                console.error(err);
            });
        });
    };
    RoleAuthService.prototype.editOrSave = function (path, psIdList, roleId) {
        var self = this;
        var url = self.updateURL + BiUrls.GET_PAGE_AUTH_BY_ROLE + path + '/' + roleId;
        return new Promise(function (resolve, reject) {
            self.mdmService.onUpdateRoleAuth(url, psIdList).then(function (res) {
                if (res) {
                    resolve(res);
                }
            });
        });
    };
    return RoleAuthService;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/editRoleAuthorization.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _.._biAdminStyles.css.shim.ngstyle,_angular_core,_ng_bootstrap_ng_bootstrap_dropdown_dropdown,_ng_bootstrap_ng_bootstrap_dropdown_dropdown_config,_angular_common,_loader.component.ngfactory,_loader.component,_editRoleAuthorization.component,_services_mdmService.service,_services_roleAuthService.service,_.._.._toasterComponent_toasterComponent PURE_IMPORTS_END */











var styles_editRoleAuthorizationComponent = [biAdminStyles_css_shim_ngstyle_styles];
var RenderType_editRoleAuthorizationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_editRoleAuthorizationComponent, data: {} });

function View_editRoleAuthorizationComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [["class", "float-left text-12x m-0 "]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["\u00A0(+", ")"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedpsList[_v.parent.context.index]; _ck(_v, 1, 0, currVal_0); }); }
function View_editRoleAuthorizationComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 27, "div", [["class", "w-100 float-left pl-5"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 26, "div", [["class", "w-100 float-left mb-3 hidden-actions"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 21, "div", [["class", "float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 20, "div", [["class", "dropdown"], ["ngbDropdown", ""], ["placement", "bottom-right"]], [[2, "show", null]], null, null, null, null)), core["ɵdid"](4, 212992, null, 2, dropdown_NgbDropdown, [core["ChangeDetectorRef"], NgbDropdownConfig, common["DOCUMENT"], core["NgZone"]], { placement: [0, "placement"] }, null), core["ɵqud"](335544320, 3, { _menu: 0 }), core["ɵqud"](335544320, 4, { _anchor: 0 }), (_l()(), core["ɵeld"](7, 0, null, null, 5, "a", [["aria-haspopup", "true"], ["class", "dropdown-toggle"], ["ngbDropdownToggle", ""]], [[8, "id", 0], [1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8).toggleOpen() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 16384, null, 0, NgbDropdownToggle, [dropdown_NgbDropdown, core["ElementRef"]], null, null), core["ɵprd"](2048, [[4, 4]], NgbDropdownAnchor, null, [NgbDropdownToggle]), (_l()(), core["ɵeld"](10, 0, null, null, 2, "i", [["class", "fa"]], null, null, null, null, null)), core["ɵdid"](11, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵpod"](12, { "fa-check-circle text-success": 0, "fa-times-circle text-danger": 1, "fa-lock": 2 }), (_l()(), core["ɵeld"](13, 0, null, null, 10, "div", [["ngbDropdownMenu", ""]], [[1, "aria-labelledby", 0], [2, "dropdown-menu", null], [2, "show", null], [1, "x-placement", 0]], null, null, null, null)), core["ɵdid"](14, 16384, [[3, 4]], 0, dropdown_NgbDropdownMenu, [dropdown_NgbDropdown, core["ElementRef"], core["Renderer2"]], null, null), (_l()(), core["ɵeld"](15, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onChange(_v.parent.parent.context.$implicit.id, _v.context.$implicit.id, _v.parent.parent.context.index, 0) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 0, "i", [["class", "fa fa-check-circle text-success"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Active"])), (_l()(), core["ɵeld"](18, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onChange(_v.parent.parent.context.$implicit.id, _v.context.$implicit.id, _v.parent.parent.context.index, 1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 0, "i", [["class", "fa fa-times-circle text-danger"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Inactive"])), (_l()(), core["ɵeld"](21, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onChange(_v.parent.parent.context.$implicit.id, _v.context.$implicit.id, _v.parent.parent.context.index, 2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 0, "i", [["class", "fa fa-lock"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Lock"])), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 0, "label", [["class", "mb-md-0 float-left mr-2 mt-1"], ["for", "user1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "p", [["class", "float-left text-14x m-0 "]], null, null, null, null, null)), (_l()(), core["ɵted"](27, null, ["", " (", ")"]))], function (_ck, _v) { var _co = _v.component; var currVal_1 = "bottom-right"; _ck(_v, 4, 0, currVal_1); var currVal_4 = "fa"; var currVal_5 = ((_co.raMap.get(_v.context.$implicit.id) != undefined) ? _ck(_v, 12, 0, (_co.raMap.get(_v.context.$implicit.id) == 0), (_co.raMap.get(_v.context.$implicit.id) == 1), (_co.raMap.get(_v.context.$implicit.id) == 2)) : "fa-times-circle text-danger"); _ck(_v, 11, 0, currVal_4, currVal_5); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 4).isOpen(); _ck(_v, 3, 0, currVal_0); var currVal_2 = _v.context.$implicit.id; var currVal_3 = core["ɵnov"](_v, 8).dropdown.isOpen(); _ck(_v, 7, 0, currVal_2, currVal_3); var currVal_6 = _v.context.$implicit.id; var currVal_7 = true; var currVal_8 = core["ɵnov"](_v, 14).dropdown.isOpen(); var currVal_9 = core["ɵnov"](_v, 14).placement; _ck(_v, 13, 0, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_10 = _v.context.$implicit.name; var currVal_11 = _v.context.$implicit.pageSectionCode; _ck(_v, 27, 0, currVal_10, currVal_11); });
}
function View_editRoleAuthorizationComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_editRoleAuthorizationComponent_5)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.sections; _ck(_v, 2, 0, currVal_0); }, null); }
function View_editRoleAuthorizationComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 35, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 34, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 31, "div", [["class", "w-100 float-left mb-3 hidden-actions"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "div", [["class", "float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "i", [["class", "fa float-left mr-3 text-20x"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleChild(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](5, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 21, "div", [["class", "float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 20, "div", [["class", "dropdown"], ["ngbDropdown", ""], ["placement", "bottom-right"]], [[2, "show", null]], null, null, null, null)), core["ɵdid"](8, 212992, null, 2, dropdown_NgbDropdown, [core["ChangeDetectorRef"], NgbDropdownConfig, common["DOCUMENT"], core["NgZone"]], { placement: [0, "placement"] }, null), core["ɵqud"](335544320, 1, { _menu: 0 }), core["ɵqud"](335544320, 2, { _anchor: 0 }), (_l()(), core["ɵeld"](11, 0, null, null, 5, "a", [["aria-haspopup", "true"], ["class", "dropdown-toggle"], ["ngbDropdownToggle", ""]], [[8, "id", 0], [1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 12).toggleOpen() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](12, 16384, null, 0, NgbDropdownToggle, [dropdown_NgbDropdown, core["ElementRef"]], null, null), core["ɵprd"](2048, [[2, 4]], NgbDropdownAnchor, null, [NgbDropdownToggle]), (_l()(), core["ɵeld"](14, 0, null, null, 2, "i", [["class", "fa"]], null, null, null, null, null)), core["ɵdid"](15, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵpod"](16, { "fa-check-circle text-success": 0, "fa-times-circle text-danger": 1, "fa-lock": 2, "fa-circle-o": 3 }), (_l()(), core["ɵeld"](17, 0, null, null, 10, "div", [["ngbDropdownMenu", ""]], [[1, "aria-labelledby", 0], [2, "dropdown-menu", null], [2, "show", null], [1, "x-placement", 0]], null, null, null, null)), core["ɵdid"](18, 16384, [[1, 4]], 0, dropdown_NgbDropdownMenu, [dropdown_NgbDropdown, core["ElementRef"], core["Renderer2"]], null, null), (_l()(), core["ɵeld"](19, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectAll(_v.context.$implicit.id, _v.context.index, 0) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 0, "i", [["class", "fa fa-check-circle text-success"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Active"])), (_l()(), core["ɵeld"](22, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectAll(_v.context.$implicit.id, _v.context.index, 1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 0, "i", [["class", "fa fa-times-circle text-danger"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Inactive"])), (_l()(), core["ɵeld"](25, 0, null, null, 2, "a", [["class", "dropdown-item"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectAll(_v.context.$implicit.id, _v.context.index, 2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 0, "i", [["class", "fa fa-lock"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Lock"])), (_l()(), core["ɵeld"](28, 0, null, null, 5, "div", [["class", "float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 0, "label", [["class", "mb-md-0 float-left mr-2 mt-1"], ["for", "user1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 1, "p", [["class", "float-left text-14x m-0 "]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, ["", ""])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_editRoleAuthorizationComponent_3)), core["ɵdid"](33, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_editRoleAuthorizationComponent_4)), core["ɵdid"](35, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "fa float-left mr-3 text-20x"; var currVal_1 = (_co.showChild[_v.context.index] ? "fa-caret-down" : "fa-caret-right"); _ck(_v, 5, 0, currVal_0, currVal_1); var currVal_3 = "bottom-right"; _ck(_v, 8, 0, currVal_3); var currVal_6 = "fa"; var currVal_7 = ((_co.selectedAll[_v.context.index] != undefined) ? _ck(_v, 16, 0, (_co.selectedAll[_v.context.index] == 0), (_co.selectedAll[_v.context.index] == 1), (_co.selectedAll[_v.context.index] == 2), (_co.selectedAll[_v.context.index] == 3)) : "fa-times-circle text-danger"); _ck(_v, 15, 0, currVal_6, currVal_7); var currVal_13 = _co.selectedpsList[_v.context.index]; _ck(_v, 33, 0, currVal_13); var currVal_14 = _co.showChild[_v.context.index]; _ck(_v, 35, 0, currVal_14); }, function (_ck, _v) { var currVal_2 = core["ɵnov"](_v, 8).isOpen(); _ck(_v, 7, 0, currVal_2); var currVal_4 = _v.context.$implicit.pageCode; var currVal_5 = core["ɵnov"](_v, 12).dropdown.isOpen(); _ck(_v, 11, 0, currVal_4, currVal_5); var currVal_8 = _v.context.$implicit.pageCode; var currVal_9 = true; var currVal_10 = core["ɵnov"](_v, 18).dropdown.isOpen(); var currVal_11 = core["ɵnov"](_v, 18).placement; _ck(_v, 17, 0, currVal_8, currVal_9, currVal_10, currVal_11); var currVal_12 = _v.context.$implicit.name; _ck(_v, 31, 0, currVal_12); });
}
function View_editRoleAuthorizationComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 33, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Selected Role"])), (_l()(), core["ɵted"](-1, null, ["\u00A0 "])), (_l()(), core["ɵeld"](5, 0, null, null, 2, "span", [], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](7, null, [" - ", ""])), (_l()(), core["ɵeld"](8, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mb-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Back "])), (_l()(), core["ɵeld"](12, 0, null, null, 15, "div", [["class", "w-100 mb-2 mt -2 align-v-center justify-content-between"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h5", [["class", "mb-3 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Permissions"])), (_l()(), core["ɵeld"](15, 0, null, null, 12, "div", [["class", "align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "mr-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 0, "i", [["class", "fa fa-check-circle text-success"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "span", [["class", "ml-2 text-14x"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Active"])), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "mr-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 0, "i", [["class", "fa fa-times-circle text-danger"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 1, "span", [["class", "ml-2 text-14x"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Inactive"])), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "mr-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 0, "i", [["class", "fa fa-lock"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "span", [["class", "ml-2 text-14x"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Lock"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_editRoleAuthorizationComponent_2)), core["ɵdid"](29, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](30, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.SaveChanges() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Update "])), (_l()(), core["ɵeld"](32, 0, null, null, 1, "button", [["class", "btn btn-secondary float-right mr-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Cancel"]))], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.pageList; _ck(_v, 29, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.roleName; _ck(_v, 7, 0, currVal_0); var currVal_2 = !_co.saveChangesButton; _ck(_v, 30, 0, currVal_2); });
}
function View_editRoleAuthorizationComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_editRoleAuthorizationComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_editRoleAuthorizationComponent_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_editRoleAuthorizationComponent_6)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_editRoleAuthorizationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "editRoleAuthorization", [], null, null, null, View_editRoleAuthorizationComponent_0, RenderType_editRoleAuthorizationComponent)), core["ɵdid"](1, 573440, null, 0, editRoleAuthorization_component_editRoleAuthorizationComponent, [mdmService_service_MDMService, roleAuthService_service_RoleAuthService, ToasterComponent, common["Location"], core["ViewContainerRef"]], null, null)], null, null); }
var editRoleAuthorizationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("editRoleAuthorization", editRoleAuthorization_component_editRoleAuthorizationComponent, View_editRoleAuthorizationComponent_Host_0, { roleId: "roleId", roleName: "roleName" }, { onEdit: "onEdit" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/roleAuthorization.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _.._biAdminStyles.css.shim.ngstyle,_angular_core,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_forms,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_editRoleAuthorization.component.ngfactory,_editRoleAuthorization.component,_services_mdmService.service,_services_roleAuthService.service,_.._.._toasterComponent_toasterComponent,_loader.component.ngfactory,_loader.component,_roleAuthorization.component PURE_IMPORTS_END */

















var styles_roleAuthorizationComponent = [biAdminStyles_css_shim_ngstyle_styles];
var RenderType_roleAuthorizationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_roleAuthorizationComponent, data: {} });

function View_roleAuthorizationComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["ROLE-AUTHORIZATION"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null))], null, null);
}
function View_roleAuthorizationComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.description; _ck(_v, 2, 0, currVal_0); }); }
function View_roleAuthorizationComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" NA "]))], null, null); }
function View_roleAuthorizationComponent_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editRoles(_v.parent.context.$implicit.id, _v.parent.context.$implicit.name) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Edit "]))], null, null);
}
function View_roleAuthorizationComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_7)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_8)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 5, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 16777216, null, null, 2, "h6", [["class", "mb-lg-0"], ["ngbTooltip", "Click for more options"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.tableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_9)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _v.context.$implicit.description; _ck(_v, 5, 0, currVal_1); var currVal_2 = !_v.context.$implicit.description; _ck(_v, 7, 0, currVal_2); var currVal_3 = "Click for more options"; _ck(_v, 10, 0, currVal_3); var currVal_4 = (_v.context.index == _co.trackHides); _ck(_v, 13, 0, currVal_4); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_0); });
}
function View_roleAuthorizationComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " items of ", " "])), (_l()(), core["ɵeld"](3, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](6, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](13, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](14, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](16, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](17, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](18, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](20, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](21, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](22, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](24, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.pageNo = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](26, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_10 = _co.pageSize; _ck(_v, 9, 0, currVal_10); var currVal_11 = "10"; _ck(_v, 13, 0, currVal_11); var currVal_12 = "10"; _ck(_v, 14, 0, currVal_12); var currVal_13 = "20"; _ck(_v, 17, 0, currVal_13); var currVal_14 = "20"; _ck(_v, 18, 0, currVal_14); var currVal_15 = "30"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "30"; _ck(_v, 22, 0, currVal_16); var currVal_17 = true; var currVal_18 = false; var currVal_19 = true; var currVal_20 = _co.totalRoles; var currVal_21 = _co.totalPages; var currVal_22 = _co.pageNo; var currVal_23 = _co.pageSize; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (((_co.pageNo - 1) * _co.pageSize) + 1); var currVal_1 = (((_co.pageNo - 1) * _co.pageSize) + _co.roleList.length); var currVal_2 = _co.totalRoles; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2); var currVal_3 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 11).ngClassValid; var currVal_8 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 6, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); });
}
function View_roleAuthorizationComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [["class", " overflow:hidden pos-relative diff-table"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "w-100 float-left mt-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 9, "div", [["class", "w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left light-bg p-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Role "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left light-bg p-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](9, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left light-bg p-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_6)), core["ɵdid"](13, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_10)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.roleList; _ck(_v, 13, 0, currVal_0); var currVal_1 = (_co.roleList && _co.roleList.length); _ck(_v, 15, 0, currVal_1); }, null);
}
function View_roleAuthorizationComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left  mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Roles to Load"]))], null, null); }
function View_roleAuthorizationComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_12)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_roleAuthorizationComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "form-group"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Role-Authorization Contents"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_5)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_11)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.roleList && _co.roleList.length); _ck(_v, 7, 0, currVal_0); var currVal_1 = (_co.roleList && !_co.roleList.length); _ck(_v, 9, 0, currVal_1); }, null);
}
function View_roleAuthorizationComponent_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "editRoleAuthorization", [], null, [[null, "onEdit"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("onEdit" === en)) {
                var pd_0 = (_co.onEdit($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_editRoleAuthorizationComponent_0, RenderType_editRoleAuthorizationComponent)), core["ɵdid"](2, 573440, null, 0, editRoleAuthorization_component_editRoleAuthorizationComponent, [mdmService_service_MDMService, roleAuthService_service_RoleAuthService, ToasterComponent, common["Location"], core["ViewContainerRef"]], { roleId: [0, "roleId"], roleName: [1, "roleName"] }, { onEdit: "onEdit" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.roleId; var currVal_1 = _co.roleName; _ck(_v, 2, 0, currVal_0, currVal_1); }, null);
}
function View_roleAuthorizationComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_4)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_13)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 4, 0, currVal_1); }, null); }
function View_roleAuthorizationComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_roleAuthorizationComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_3)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_14)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 5, 0, currVal_1); var currVal_2 = _co.loader; _ck(_v, 7, 0, currVal_2); }, null); }
function View_roleAuthorizationComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_roleAuthorizationComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 1, 0, currVal_0); }, null); }
function View_roleAuthorizationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "roleAuthorization", [], null, null, null, View_roleAuthorizationComponent_0, RenderType_roleAuthorizationComponent)), core["ɵdid"](1, 114688, null, 0, roleAuthorization_component_roleAuthorizationComponent, [roleAuthService_service_RoleAuthService, mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var roleAuthorizationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("roleAuthorization", roleAuthorization_component_roleAuthorizationComponent, View_roleAuthorizationComponent_Host_0, {}, {}, []);



// EXTERNAL MODULE: ./node_modules/ng2-auto-complete/dist/ng2-auto-complete.directive.js
var ng2_auto_complete_directive = __webpack_require__("/lQQ");
var ng2_auto_complete_directive_default = /*#__PURE__*/__webpack_require__.n(ng2_auto_complete_directive);

// CONCATENATED MODULE: ./src/app/bi/admin/controller/dimLvlPermissions.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_.._.._employee_employeeFilter.ngfactory,_.._.._employee_employeeFilter,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._.._shared_services_configuration,_.._.._shared_services_http.client,_.._.._shared_services_auth,_.._.._shared_sharedData,_angular_platform_browser,_.._.._toasterComponent_toasterComponent,_ngx_translate_core,ng2_auto_complete_dist_ng2_auto_complete.directive,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_tabset_tabset.ngfactory,_ng_bootstrap_ng_bootstrap_tabset_tabset,_ng_bootstrap_ng_bootstrap_tabset_tabset_config,_dimLvlPermissions.component,_services_mdmService.service PURE_IMPORTS_END */

























var styles_dimLvlPermComponent = [];
var RenderType_dimLvlPermComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_dimLvlPermComponent, data: {} });

function View_dimLvlPermComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["DIM-LEVEL-PERMISSION"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null))], null, null); }
function View_dimLvlPermComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "div", [["class", "col-lg-12 col-md-12 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 7, "form", [["class", ""], ["enctype", "multipart/form-data"], ["method", "POST"], ["novalidate", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "submit"], [null, "reset"]], function (_v, en, $event) {
            var ad = true;
            if (("submit" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("reset" === en)) {
                var pd_1 = (core["ɵnov"](_v, 5).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bg"], [], null, null), core["ɵdid"](5, 4210688, null, 0, fesm5_forms["NgForm"], [[8, null], [8, null]], null, null), core["ɵprd"](2048, null, fesm5_forms["ControlContainer"], null, [fesm5_forms["NgForm"]]), core["ɵdid"](7, 16384, null, 0, fesm5_forms["NgControlStatusGroup"], [[4, fesm5_forms["ControlContainer"]]], null, null), (_l()(), core["ɵeld"](8, 0, [[1, 0], ["file", 1]], null, 0, "input", [["accept", ".xls,.xlsx"], ["class", "pull-left next-btn r mt-smd m-r-smd m-b-smd"], ["multipart", "true"], ["name", "file"], ["placeholder", "No File Chosen."], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.fileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "bulkUpload"], ["type", "submit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.bulkUpload($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Bulk Upload "]))], null, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 7).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 7).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 7).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 7).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 7).ngClassValid; var currVal_5 = core["ɵnov"](_v, 7).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 7).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_dimLvlPermComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 4, "div", [["class", "progress"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "div", [["aria-valuemax", "100"], ["aria-valuemin", "0"], ["class", "progress-bar"], ["role", "progressbar"]], [[1, "aria-valuenow", 0]], null, null, null, null)), core["ɵdid"](4, 278528, null, 0, common["NgStyle"], [core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngStyle: [0, "ngStyle"] }, null), core["ɵpod"](5, { "width": 0 }), (_l()(), core["ɵted"](6, null, ["", "% "]))], function (_ck, _v) { var _co = _v.component; var currVal_1 = _ck(_v, 5, 0, (_co.progress + "%")); _ck(_v, 4, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.progress; _ck(_v, 3, 0, currVal_0); var currVal_2 = _co.progress; _ck(_v, 6, 0, currVal_2); }); }
function View_dimLvlPermComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "span", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](0, common["SlicePipe"], [])], null, function (_ck, _v) { var currVal_0 = (core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform(_v.parent.context.$implicit.displayName, 0, 20)) + ".."); _ck(_v, 1, 0, currVal_0); }); }
function View_dimLvlPermComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.displayName; _ck(_v, 1, 0, currVal_0); }); }
function View_dimLvlPermComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 6, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 4, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_8)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_9)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 0, "input", [["type", "radio"]], [[8, "id", 0], [8, "name", 0], [8, "value", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectEmployee($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "label", [], [[8, "htmlFor", 0]], null, null, null, null))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.empCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.displayName, ""); _ck(_v, 6, 0, currVal_2); var currVal_3 = (_v.context.$implicit.displayName.length > 20); _ck(_v, 9, 0, currVal_3); var currVal_4 = (_v.context.$implicit.displayName.length <= 20); _ck(_v, 11, 0, currVal_4); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _v.context.$implicit.empCode; _ck(_v, 4, 0, currVal_1); var currVal_5 = _v.context.$implicit.id; var currVal_6 = _co.one; var currVal_7 = _v.context.$implicit.id; _ck(_v, 14, 0, currVal_5, currVal_6, currVal_7); var currVal_8 = _v.context.$implicit.id; _ck(_v, 15, 0, currVal_8); });
}
function View_dimLvlPermComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "w-100 float-left  mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_dimLvlPermComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " items of ", " "])), (_l()(), core["ɵeld"](3, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](6, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](13, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](14, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](16, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](17, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](18, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](20, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](21, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](22, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](24, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](26, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_10 = _co.pageSize; _ck(_v, 9, 0, currVal_10); var currVal_11 = "10"; _ck(_v, 13, 0, currVal_11); var currVal_12 = "10"; _ck(_v, 14, 0, currVal_12); var currVal_13 = "20"; _ck(_v, 17, 0, currVal_13); var currVal_14 = "20"; _ck(_v, 18, 0, currVal_14); var currVal_15 = "30"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "30"; _ck(_v, 22, 0, currVal_16); var currVal_17 = true; var currVal_18 = false; var currVal_19 = true; var currVal_20 = _co.totalEmps; var currVal_21 = 5; var currVal_22 = _co.currentPage; var currVal_23 = _co.pageSize; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.startingPage + 1); var currVal_1 = _co.endingPage; var currVal_2 = _co.totalEmps; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2); var currVal_3 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 11).ngClassValid; var currVal_8 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 6, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); });
}
function View_dimLvlPermComponent_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), (_l()(), core["ɵeld"](2, 0, null, null, 0, "i", [["class", "fa fa-times"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeDimSelected() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.selectedDimension.name ? _co.selectedDimension.name : (_co.selectedDimension.dimHierarchyLevelName ? _co.selectedDimension.dimHierarchyLevelName : _co.selectedDimension.dimName)); _ck(_v, 1, 0, currVal_0); });
}
function View_dimLvlPermComponent_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), (_l()(), core["ɵeld"](2, 0, null, null, 0, "i", [["class", "fa fa-times"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeDimValue() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selecteDimensionValue.name; _ck(_v, 1, 0, currVal_0); });
}
function View_dimLvlPermComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_0 = _v.context.$implicit.id; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit.id; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_dimLvlPermComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 20, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Dimension"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Dimension "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Dimension Level"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Dimension Level "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Dimension Values"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Dimension Values"])), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Scope"]], null, null, null, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Scope"])), (_l()(), core["ɵeld"](17, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Delete"]], null, null, null, null, null)), core["ɵdid"](18, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete"]))], function (_ck, _v) { var currVal_0 = "Dimension"; _ck(_v, 2, 0, currVal_0); var currVal_1 = "Dimension Level"; _ck(_v, 6, 0, currVal_1); var currVal_2 = "Dimension Values"; _ck(_v, 10, 0, currVal_2); var currVal_3 = "Scope"; _ck(_v, 14, 0, currVal_3); var currVal_4 = "Delete"; _ck(_v, 18, 0, currVal_4); }, null); }
function View_dimLvlPermComponent_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 20, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, [" ", " "])), (_l()(), core["ɵeld"](17, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 0, "input", [["type", "checkbox"]], [[8, "id", 0], [8, "name", 0], [8, "value", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectToDelete($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 0, "label", [], [[8, "htmlFor", 0]], null, null, null, null))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dimName, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dimLvlName, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dimLvlVal, ""); _ck(_v, 10, 0, currVal_4); var currVal_6 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.scope, ""); _ck(_v, 14, 0, currVal_6); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _v.context.$implicit.dimName; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.dimLvlName; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.dimLvlVal; _ck(_v, 12, 0, currVal_5); var currVal_7 = _v.context.$implicit.scope; _ck(_v, 16, 0, currVal_7); var currVal_8 = _v.context.$implicit.id; var currVal_9 = _co.one; var currVal_10 = _v.context.$implicit.id; _ck(_v, 19, 0, currVal_8, currVal_9, currVal_10); var currVal_11 = _v.context.$implicit.id; _ck(_v, 20, 0, currVal_11); });
}
function View_dimLvlPermComponent_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3 p-2"], ["id", "bulkUpload"], ["type", "submit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteConfirm($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete Permissions "]))], null, null);
}
function View_dimLvlPermComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 77, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 76, "div", [["class", "w-full pull-left no-padding-top pos-relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 13, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 9, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 4, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 3, "div", [["class", "col-lg-12 col-md-12 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Operations"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_5)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_6)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](13, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 16777216, null, null, 1, "employeeFilter", [], null, [[null, "searchEmp"], ["window", "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 15).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("searchEmp" === en)) {
                var pd_1 = (_co.showSearchFilter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EmployeeFilter_0, RenderType_EmployeeFilter)), core["ɵdid"](15, 114688, null, 0, employeeFilter_EmployeeFilter, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { displayTab: [0, "displayTab"] }, { searchEmp: "searchEmp" }), (_l()(), core["ɵeld"](16, 0, null, null, 16, "div", [["class", " overflow-x pos-relative diff-table"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 13, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 16777216, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["ngbTooltip", "Employee Code"]], null, null, null, null, null)), core["ɵdid"](20, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Employee Code "])), (_l()(), core["ɵeld"](23, 16777216, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["ngbTooltip", "Employee Name"]], null, null, null, null, null)), core["ɵdid"](24, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](25, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Employee Name "])), (_l()(), core["ɵeld"](27, 16777216, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["ngbTooltip", "Select Employee"]], null, null, null, null, null)), core["ɵdid"](28, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Select Employee"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_7)), core["ɵdid"](32, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_10)), core["ɵdid"](34, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_11)), core["ɵdid"](36, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](37, 0, null, null, 18, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 8, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-xs-12 pull-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 3, "label", [["for", "Name"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Dimension "])), (_l()(), core["ɵeld"](41, 0, null, null, 1, "span", [["class", "rq "], ["style", "color: red "]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](43, 16777216, [[2, 0], ["dimAutoComplete", 1]], null, 1, "input", [["auto-complete", ""], ["autocomplete", "off"], ["class", "form-control"], ["name", "orgTypeModel"], ["placeholder", "Select Dimension"], ["required", ""]], null, [[null, "valueChanged"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("valueChanged" === en)) {
                var pd_0 = (_co.onDimensionSelection($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](44, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], acceptUserInput: [1, "acceptUserInput"], listFormatter: [2, "listFormatter"], valueFormatter: [3, "valueFormatter"] }, { valueChanged: "valueChanged" }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_12)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](47, 0, null, null, 8, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-xs-12 pull-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](48, 0, null, null, 3, "label", [["for", "Name"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Dimension Value "])), (_l()(), core["ɵeld"](50, 0, null, null, 1, "span", [["class", "rq "], ["style", "color: red "]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](52, 16777216, [[3, 0], ["autoCompletediv", 1]], null, 1, "input", [["auto-complete", ""], ["autocomplete", "off"], ["class", "flex-grow:1 drop-down form-control"], ["id", "dimLvlVal"], ["placeholder", "Dimension Level Value "], ["type", "text"]], null, [[null, "valueChanged"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("valueChanged" === en)) {
                var pd_0 = (_co.onSelectDimLvlVal($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](53, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], acceptUserInput: [1, "acceptUserInput"], listFormatter: [2, "listFormatter"], valueFormatter: [3, "valueFormatter"] }, { valueChanged: "valueChanged" }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_13)), core["ɵdid"](55, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](56, 0, null, null, 12, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-xs-12 pull-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 3, "label", [["for", "Name"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Scope "])), (_l()(), core["ɵeld"](60, 0, null, null, 1, "span", [["class", "rq "], ["style", "color: red "]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](62, 0, null, null, 6, "select", [["class", "w-full form-control"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onScopeSelect($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 3, "option", [["value", "selectOne"]], [[8, "disabled", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](64, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](65, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Select One "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_14)), core["ɵdid"](68, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](69, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left  mt-3 form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 1, "button", [["class", "btn btn-primary mr-3 float-right"], ["id", "add"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onClickOfAdd() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_15)), core["ɵdid"](73, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_16)), core["ɵdid"](75, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_17)), core["ɵdid"](77, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isProgress; _ck(_v, 10, 0, currVal_0); var currVal_1 = _co.isProgress; _ck(_v, 12, 0, currVal_1); var currVal_2 = "employeeSearch"; _ck(_v, 15, 0, currVal_2); var currVal_3 = "Employee Code"; _ck(_v, 20, 0, currVal_3); var currVal_4 = "Employee Name"; _ck(_v, 24, 0, currVal_4); var currVal_5 = "Select Employee"; _ck(_v, 28, 0, currVal_5); var currVal_6 = _co.employeeList; _ck(_v, 32, 0, currVal_6); var currVal_7 = !(_co.employeeList && _co.employeeList.length); _ck(_v, 34, 0, currVal_7); var currVal_8 = (_co.employeeList && _co.employeeList.length); _ck(_v, 36, 0, currVal_8); var currVal_9 = _co.searchDim.bind(_co); var currVal_10 = true; var currVal_11 = _co.dimListFormatter; var currVal_12 = _co.dimValueFormatter; _ck(_v, 44, 0, currVal_9, currVal_10, currVal_11, currVal_12); var currVal_13 = (_co.selectedDimension != "selectOne"); _ck(_v, 46, 0, currVal_13); var currVal_14 = _co.getDimLvlVal.bind(_co); var currVal_15 = true; var currVal_16 = _co.autoCompleteListFormatter; var currVal_17 = _co.orgNameValueFormatter; _ck(_v, 53, 0, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_18 = _co.selecteDimensionValue; _ck(_v, 55, 0, currVal_18); var currVal_21 = "selectOne"; _ck(_v, 64, 0, currVal_21); var currVal_22 = "selectOne"; _ck(_v, 65, 0, currVal_22); var currVal_23 = _co.scopeList; _ck(_v, 68, 0, currVal_23); var currVal_25 = (_co.dimPermList.length > 0); _ck(_v, 73, 0, currVal_25); var currVal_26 = _co.dimPermList; _ck(_v, 75, 0, currVal_26); var currVal_27 = (_co.dimPermList.length > 0); _ck(_v, 77, 0, currVal_27); }, function (_ck, _v) { var _co = _v.component; var currVal_19 = true; var currVal_20 = ((_co.scope == undefined) ? true : null); _ck(_v, 63, 0, currVal_19, currVal_20); var currVal_24 = _co.saveButton; _ck(_v, 70, 0, currVal_24); });
}
function View_dimLvlPermComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_4)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 1, 0, currVal_0); }, null); }
function View_dimLvlPermComponent_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["class", "mb-0 ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.fileNameToUpload; _ck(_v, 1, 0, currVal_0); }); }
function View_dimLvlPermComponent_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "label", [["class", "medium col-4"], ["for", "comments"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Comments: "])), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](6, 0, null, null, 7, "textarea", [["class", "form-control col-6 ml-3"], ["name", "comment"], ["placeholder", "Enter Comments"], ["required", ""], ["rows", "2"]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.comment = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 3, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "label", [["class", "medium col-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 1, "button", [["class", "btn btn-primary ml-3"], ["id", "bulkUpload"], ["type", "submit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.initBulkUserDimRels($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Upload "]))], function (_ck, _v) { var _co = _v.component; var currVal_8 = ""; _ck(_v, 8, 0, currVal_8); var currVal_9 = "comment"; var currVal_10 = _co.comment; _ck(_v, 11, 0, currVal_9, currVal_10); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 8).required ? "" : null); var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_dimLvlPermComponent_23(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "a", [["class", "mb-0 small"], ["href", "#/biAdmin/dimLvlPermissions"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadUserDimRelsFiles(_v.parent.context.$implicit.attachedFiles[0].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", "clickToDownload", ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.context.$implicit.attachedFiles[0].name; _ck(_v, 2, 0, currVal_1); });
}
function View_dimLvlPermComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "a", [["class", "mb-0 small"], ["href", "#/biAdmin/dimLvlPermissions"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadUserDimRelsFiles(_v.parent.context.$implicit.attachedFiles[1].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", "clickToDownload", ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.context.$implicit.attachedFiles[1].name; _ck(_v, 2, 0, currVal_1); });
}
function View_dimLvlPermComponent_22(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, "div", [["class", "w-100 p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", ""])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, ["", ""])), (_l()(), core["ɵeld"](13, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_23)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_24)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_4 = (_v.context.$implicit.attachedFiles.length > 0); _ck(_v, 15, 0, currVal_4); var currVal_5 = (_v.context.$implicit.attachedFiles.length > 1); _ck(_v, 18, 0, currVal_5); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.comment; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.startDate; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.state; _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.failureReason; _ck(_v, 12, 0, currVal_3); }); }
function View_dimLvlPermComponent_25(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.authCurrentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onAuthHistoryPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.authTotalRecs; var currVal_4 = 5; var currVal_5 = _co.authCurrentPage; var currVal_6 = _co.authPageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_dimLvlPermComponent_21(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 55, "div", [["class", "w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "w-100 float-left align-v-center mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"], ["name", "userDimRelsHistoryRefresh"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.getUserDimRelsHistory() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-refresh mr-2 text-white"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Refresh "])), (_l()(), core["ɵeld"](6, 0, null, null, 22, "div", [["class", "col-lg-12 col-md-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 18, "div", [["class", "light-bg w-100 p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Comments"])), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Start Date"])), (_l()(), core["ɵeld"](14, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Status"])), (_l()(), core["ɵeld"](17, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Failure Reason"])), (_l()(), core["ɵeld"](20, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Attached File"])), (_l()(), core["ɵeld"](23, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Response File"])), (_l()(), core["ɵeld"](26, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_22)), core["ɵdid"](28, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](32, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](35, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 36).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 36).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.authPageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onAuthHistoryPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](36, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](38, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](40, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](41, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](42, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](43, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](45, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](46, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](47, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](49, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](50, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](51, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](53, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_25)), core["ɵdid"](55, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.tableData; _ck(_v, 28, 0, currVal_1); var currVal_12 = _co.authPageSize; _ck(_v, 38, 0, currVal_12); var currVal_13 = "10"; _ck(_v, 42, 0, currVal_13); var currVal_14 = "10"; _ck(_v, 43, 0, currVal_14); var currVal_15 = "20"; _ck(_v, 46, 0, currVal_15); var currVal_16 = "20"; _ck(_v, 47, 0, currVal_16); var currVal_17 = "30"; _ck(_v, 50, 0, currVal_17); var currVal_18 = "30"; _ck(_v, 51, 0, currVal_18); var currVal_19 = (_co.tableData && _co.tableData.length); _ck(_v, 55, 0, currVal_19); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.uploadButtonDisable; _ck(_v, 3, 0, currVal_0); var currVal_2 = _co.authStartingPage; var currVal_3 = _co.authEndingPage; var currVal_4 = _co.authTotalRecs; _ck(_v, 31, 0, currVal_2, currVal_3, currVal_4); var currVal_5 = core["ɵnov"](_v, 40).ngClassUntouched; var currVal_6 = core["ɵnov"](_v, 40).ngClassTouched; var currVal_7 = core["ɵnov"](_v, 40).ngClassPristine; var currVal_8 = core["ɵnov"](_v, 40).ngClassDirty; var currVal_9 = core["ɵnov"](_v, 40).ngClassValid; var currVal_10 = core["ɵnov"](_v, 40).ngClassInvalid; var currVal_11 = core["ɵnov"](_v, 40).ngClassPending; _ck(_v, 35, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11); });
}
function View_dimLvlPermComponent_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 19, "div", [["class", "w-100 float-left mb-4 b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 18, "div", [["class", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 13, "div", [["class", "col-lg-8 col-md-8"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 10, "div", [["class", "form-group align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "label", [["class", "medium col-4"], ["for", "excelTypeSelect"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Browse File To Upload: "])), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](8, 0, null, null, 3, "div", [["class", "relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, [[1, 0], ["file", 1]], null, 0, "input", [["accept", ".xlsx"], ["class", "fileInput"], ["multipart", "true"], ["name", "file"], ["placeholder", "No File Chosen."], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.chooseFile($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "button", [["class", "btn btn-primary ml-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Browse"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_19)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_20)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "div", [["class", "form-group align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "a", [["class", ""], ["href", "javascript:void(0)"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadTemplate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Download Template"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_21)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.fileNameToUpload != null); _ck(_v, 13, 0, currVal_0); var currVal_1 = (_co.fileNameToUpload != null); _ck(_v, 15, 0, currVal_1); var currVal_2 = (_co.tableData.length > 0); _ck(_v, 21, 0, currVal_2); }, null);
}
function View_dimLvlPermComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 17, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 14, "ngb-tabset", [["type", "pills"]], null, [[null, "tabChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("tabChange" === en)) {
                var pd_0 = (_co.beforeChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NgbTabset_0, RenderType_NgbTabset)), core["ɵdid"](5, 2146304, null, 1, tabset_NgbTabset, [NgbTabsetConfig], { activeId: [0, "activeId"], type: [1, "type"] }, { tabChange: "tabChange" }), core["ɵqud"](603979776, 4, { tabs: 1 }), (_l()(), core["ɵeld"](7, 0, null, null, 5, "ngb-tab", [["id", "individual"], ["title", "Individual"]], null, null, null, null, null)), core["ɵdid"](8, 2113536, [[4, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 5, { titleTpls: 1 }), core["ɵqud"](603979776, 6, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_dimLvlPermComponent_3)), core["ɵdid"](12, 16384, [[6, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null), (_l()(), core["ɵeld"](13, 0, null, null, 5, "ngb-tab", [["id", "bulk"], ["title", "Bulk"]], null, null, null, null, null)), core["ɵdid"](14, 2113536, [[4, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 7, { titleTpls: 1 }), core["ɵqud"](603979776, 8, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_dimLvlPermComponent_18)), core["ɵdid"](18, 16384, [[8, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", _co.selectedTab, ""); var currVal_2 = "pills"; _ck(_v, 5, 0, currVal_1, currVal_2); var currVal_3 = "individual"; var currVal_4 = "Individual"; _ck(_v, 8, 0, currVal_3, currVal_4); var currVal_5 = "bulk"; var currVal_6 = "Bulk"; _ck(_v, 14, 0, currVal_5, currVal_6); }, null);
}
function View_dimLvlPermComponent_0(_l) { return core["ɵvid"](0, [core["ɵqud"](671088640, 1, { fileInput: 0 }), core["ɵqud"](671088640, 2, { dimAutoComplete: 0 }), core["ɵqud"](671088640, 3, { elementDiv: 0 }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_dimLvlPermComponent_1)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 4, 0, currVal_0); }, null); }
function View_dimLvlPermComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "dimLvlPermissions", [], null, null, null, View_dimLvlPermComponent_0, RenderType_dimLvlPermComponent)), core["ɵdid"](1, 114688, null, 0, dimLvlPermissions_component_dimLvlPermComponent, [mdmService_service_MDMService, platform_browser["c" /* DomSanitizer */], ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var dimLvlPermComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("dimLvlPermissions", dimLvlPermissions_component_dimLvlPermComponent, View_dimLvlPermComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/tenantConfiguration.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_angular_forms,_loader.component.ngfactory,_loader.component,_tenantConfiguration.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent PURE_IMPORTS_END */










var styles_tenantConfigComponent = [];
var RenderType_tenantConfigComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_tenantConfigComponent, data: {} });

function View_tenantConfigComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["TENANT CONFIGURATION"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "edit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editTenantConfig($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Edit "]))], null, null);
}
function View_tenantConfigComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "input", [["disabled", ""], ["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0]], null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 0, "input", [["maxlength", "7"], ["readonly", ""], ["type", "text"]], [[8, "value", 0], [1, "id", 0]], null, null, null, null))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.value; var currVal_1 = _v.parent.context.index; _ck(_v, 2, 0, currVal_0, currVal_1); var currVal_2 = ((_v.parent.context.$implicit.value != undefined) ? _v.parent.context.$implicit.value : ""); var currVal_3 = _v.parent.context.index; _ck(_v, 3, 0, currVal_2, currVal_3); }); }
function View_tenantConfigComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.value; _ck(_v, 2, 0, currVal_0); }); }
function View_tenantConfigComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 4, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), (_l()(), core["ɵeld"](6, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](10, 16777216, null, null, 5, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_6)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_7)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.displayName, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.value, ""); _ck(_v, 11, 0, currVal_2); var currVal_3 = ((_co.getConfigType(_v.context.$implicit) == 4) ? true : false); _ck(_v, 13, 0, currVal_3); var currVal_4 = ((_co.getConfigType(_v.context.$implicit) != 4) ? true : false); _ck(_v, 15, 0, currVal_4); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 5, 0, currVal_1); }); }
function View_tenantConfigComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "]))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.displayName, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.value.code, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.value.value, ""); _ck(_v, 10, 0, currVal_4); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.value.code; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.value.value; _ck(_v, 12, 0, currVal_5); }); }
function View_tenantConfigComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 4, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 0, "input", [["disabled", ""], ["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0]], null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 0, "input", [["maxlength", "7"], ["readonly", ""], ["type", "text"]], [[8, "value", 0], [1, "id", 0]], null, null, null, null))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.value, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.code, ""); _ck(_v, 10, 0, currVal_4); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.name; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.value; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.code; var currVal_6 = _v.context.index; _ck(_v, 12, 0, currVal_5, currVal_6); var currVal_7 = ((_v.context.$implicit.code != undefined) ? _v.context.$implicit.code : ""); var currVal_8 = _v.context.index; _ck(_v, 13, 0, currVal_7, currVal_8); }); }
function View_tenantConfigComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 4, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "input", [["disabled", ""], ["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0]], null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, "input", [["maxlength", "7"], ["readonly", ""], ["type", "text"]], [[8, "value", 0], [1, "id", 0]], null, null, null, null)), (_l()(), core["ɵeld"](6, 16777216, null, null, 4, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "input", [["disabled", ""], ["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0]], null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 0, "input", [["maxlength", "7"], ["readonly", ""], ["type", "text"]], [[8, "value", 0], [1, "id", 0]], null, null, null, null))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.startcolor, ""); _ck(_v, 2, 0, currVal_0); var currVal_5 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.endcolor, ""); _ck(_v, 7, 0, currVal_5); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.startcolor; var currVal_2 = _v.context.index; _ck(_v, 4, 0, currVal_1, currVal_2); var currVal_3 = ((_v.context.$implicit.startcolor != undefined) ? _v.context.$implicit.startcolor : ""); var currVal_4 = _v.context.index; _ck(_v, 5, 0, currVal_3, currVal_4); var currVal_6 = _v.context.$implicit.endcolor; var currVal_7 = _v.context.index; _ck(_v, 9, 0, currVal_6, currVal_7); var currVal_8 = ((_v.context.$implicit.endcolor != undefined) ? _v.context.$implicit.endcolor : ""); var currVal_9 = _v.context.index; _ck(_v, 10, 0, currVal_8, currVal_9); }); }
function View_tenantConfigComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_tenantConfigComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_12)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_tenantConfigComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 74, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_5)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 18, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Custom Scales "])), (_l()(), core["ɵeld"](7, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Scale"]], null, null, null, null, null)), core["ɵdid"](9, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Scale "])), (_l()(), core["ɵeld"](12, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Value"]], null, null, null, null, null)), core["ɵdid"](13, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text=text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](16, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Colour"]], null, null, null, null, null)), core["ɵdid"](17, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](18, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Value "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_8)), core["ɵdid"](21, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](22, 0, null, null, 18, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Indicators "])), (_l()(), core["ɵeld"](26, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Scale"]], null, null, null, null, null)), core["ɵdid"](28, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Scale "])), (_l()(), core["ɵeld"](31, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Value"]], null, null, null, null, null)), core["ɵdid"](32, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](33, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text=text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Value "])), (_l()(), core["ɵeld"](35, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Colour"]], null, null, null, null, null)), core["ɵdid"](36, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](37, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Colour "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_9)), core["ɵdid"](40, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](41, 0, null, null, 16, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](42, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](43, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Page Config "])), (_l()(), core["ɵeld"](45, 0, null, null, 12, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Page Snapshot Expiry"]], null, null, null, null, null)), core["ɵdid"](47, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](48, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Page Snapshot Expiry"])), (_l()(), core["ɵeld"](50, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](52, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](54, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](55, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](56, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](57, null, [" ", " Days "])), (_l()(), core["ɵeld"](58, 0, null, null, 14, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](60, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Color Palette "])), (_l()(), core["ɵeld"](62, 0, null, null, 8, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](63, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "startcolor"]], null, null, null, null, null)), core["ɵdid"](64, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](65, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Start Colour "])), (_l()(), core["ɵeld"](67, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "endcolour"]], null, null, null, null, null)), core["ɵdid"](68, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](69, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" End Colour "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_10)), core["ɵdid"](72, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_11)), core["ɵdid"](74, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.tenantConfigList; _ck(_v, 2, 0, currVal_0); var currVal_1 = "Scale"; _ck(_v, 9, 0, currVal_1); var currVal_2 = "Value"; _ck(_v, 13, 0, currVal_2); var currVal_3 = "Colour"; _ck(_v, 17, 0, currVal_3); var currVal_4 = _co.customScaleList; _ck(_v, 21, 0, currVal_4); var currVal_5 = "Scale"; _ck(_v, 28, 0, currVal_5); var currVal_6 = "Value"; _ck(_v, 32, 0, currVal_6); var currVal_7 = "Colour"; _ck(_v, 36, 0, currVal_7); var currVal_8 = _co.tntConfData.measureStatusIndicatorData; _ck(_v, 40, 0, currVal_8); var currVal_9 = "Page Snapshot Expiry"; _ck(_v, 47, 0, currVal_9); var currVal_10 = core["ɵinlineInterpolate"](1, "", (_co.dashboardExpiry ? _co.dashboardExpiry.value : ""), ""); _ck(_v, 55, 0, currVal_10); var currVal_12 = "startcolor"; _ck(_v, 64, 0, currVal_12); var currVal_13 = "endcolour"; _ck(_v, 68, 0, currVal_13); var currVal_14 = _co.colorPaletevalue; _ck(_v, 72, 0, currVal_14); var currVal_15 = (_co.tntConfData == undefined); _ck(_v, 74, 0, currVal_15); }, function (_ck, _v) { var _co = _v.component; var currVal_11 = (_co.dashboardExpiry ? _co.dashboardExpiry.value : 30); _ck(_v, 57, 0, currVal_11); }); }
function View_tenantConfigComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit Tenant Configuration"]))], null, null); }
function View_tenantConfigComponent_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit; var currVal_1 = ((_v.parent.parent.context.$implicit.value.toLowerCase() == _v.context.$implicit.toLowerCase()) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _co.getWeekName(_v.context.$implicit); _ck(_v, 4, 0, currVal_2); }); }
function View_tenantConfigComponent_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "select", [["class", "form-control"], ["id", "weekStartDay"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.changeWeekStartDay($event, _v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_17)), core["ɵdid"](3, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.weekDayList; _ck(_v, 3, 0, currVal_0); }, null);
}
function View_tenantConfigComponent_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "p", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.xErrorMsg; _ck(_v, 1, 0, currVal_0); }); }
function View_tenantConfigComponent_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "input", [["class", "w-100 p-sm b-a"], ["id", "monthStartDay"], ["max", "31"], ["min", "1"], ["placeholder", "Value"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "blur"], [null, "keyup"], [null, "input"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 2)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 2)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 3).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 3).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("blur" === en)) {
                var pd_7 = (_co.validateDay($event, _v.parent.context.index) !== false);
                ad = (pd_7 && ad);
            }
            if (("keyup" === en)) {
                var pd_8 = (_co.validateDay($event, _v.parent.context.index) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](3, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](5, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, null), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](7, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_19)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = _v.parent.context.$implicit.value; _ck(_v, 5, 0, currVal_7); var currVal_8 = ((_co.xErrorMsg != "") ? true : false); _ck(_v, 9, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 7).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 7).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 7).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 7).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 7).ngClassValid; var currVal_5 = core["ɵnov"](_v, 7).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 7).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_tenantConfigComponent_21(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "p", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.xErrorMsg; _ck(_v, 1, 0, currVal_0); }); }
function View_tenantConfigComponent_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "input", [["class", "w-100 p-sm b-a"], ["id", "fontsize"], ["placeholder", "Value"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "blur"], [null, "keyup"], [null, "input"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 2)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 2)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 3).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 3).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("blur" === en)) {
                var pd_7 = (_co.validateNumber($event, _v.parent.context.index) !== false);
                ad = (pd_7 && ad);
            }
            if (("keyup" === en)) {
                var pd_8 = (_co.validateNumber($event, _v.parent.context.index) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](3, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](5, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, null), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](7, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_21)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = _v.parent.context.$implicit.value; _ck(_v, 5, 0, currVal_7); var currVal_8 = ((_co.xErrorMsg != "") ? true : false); _ck(_v, 9, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 7).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 7).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 7).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 7).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 7).ngClassValid; var currVal_5 = core["ɵnov"](_v, 7).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 7).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_tenantConfigComponent_23(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "p", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.xErrorMsg1; _ck(_v, 1, 0, currVal_0); }); }
function View_tenantConfigComponent_22(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "input", [["class", "w-100 p-sm b-a"], ["id", "yearStartMonth"], ["max", "12"], ["min", "1"], ["placeholder", "Value"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "blur"], [null, "keyup"], [null, "input"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 2)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 2)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 3).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 3).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("blur" === en)) {
                var pd_7 = (_co.validateMonth($event, _v.parent.context.index) !== false);
                ad = (pd_7 && ad);
            }
            if (("keyup" === en)) {
                var pd_8 = (_co.validateMonth($event, _v.parent.context.index) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](3, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](5, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, null), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](7, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_23)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = _v.parent.context.$implicit.value; _ck(_v, 5, 0, currVal_7); var currVal_8 = ((_co.xErrorMsg1 != "") ? true : false); _ck(_v, 9, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 7).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 7).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 7).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 7).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 7).ngClassValid; var currVal_5 = core["ɵnov"](_v, 7).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 7).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_tenantConfigComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "input", [["class", "w-100 p-sm b-a"], ["placeholder", "Value"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 2)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 2)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.parent.context.$implicit.value = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var currVal_7 = _v.parent.context.$implicit.value; _ck(_v, 4, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 6).ngClassValid; var currVal_5 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_tenantConfigComponent_25(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 14, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "input", [["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[1, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 2)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 2)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.parent.context.$implicit.value = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](7, 0, null, null, 7, "input", [["maxlength", "7"], ["type", "text"]], [[1, "id", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 8)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 8)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.parent.context.$implicit.value = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](9, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](12, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](14, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var currVal_8 = _v.parent.context.$implicit.value; _ck(_v, 4, 0, currVal_8); var currVal_18 = "7"; _ck(_v, 9, 0, currVal_18); var currVal_19 = _v.parent.context.$implicit.value; _ck(_v, 12, 0, currVal_19); }, function (_ck, _v) { var currVal_0 = _v.parent.context.index; var currVal_1 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 6).ngClassValid; var currVal_6 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_9 = _v.parent.context.index; var currVal_10 = (core["ɵnov"](_v, 9).maxlength ? core["ɵnov"](_v, 9).maxlength : null); var currVal_11 = core["ɵnov"](_v, 14).ngClassUntouched; var currVal_12 = core["ɵnov"](_v, 14).ngClassTouched; var currVal_13 = core["ɵnov"](_v, 14).ngClassPristine; var currVal_14 = core["ɵnov"](_v, 14).ngClassDirty; var currVal_15 = core["ɵnov"](_v, 14).ngClassValid; var currVal_16 = core["ɵnov"](_v, 14).ngClassInvalid; var currVal_17 = core["ɵnov"](_v, 14).ngClassPending; _ck(_v, 7, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17); });
}
function View_tenantConfigComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 23, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 4, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), (_l()(), core["ɵeld"](6, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](10, 16777216, null, null, 13, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_16)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_18)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_20)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_22)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_24)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_25)), core["ɵdid"](23, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.displayName, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.value, ""); _ck(_v, 11, 0, currVal_2); var currVal_3 = ((_co.getConfigType(_v.context.$implicit) == 1) ? true : false); _ck(_v, 13, 0, currVal_3); var currVal_4 = ((_co.getConfigType(_v.context.$implicit) == 2) ? true : false); _ck(_v, 15, 0, currVal_4); var currVal_5 = ((_co.getConfigType(_v.context.$implicit) == 6) ? true : false); _ck(_v, 17, 0, currVal_5); var currVal_6 = ((_co.getConfigType(_v.context.$implicit) == 5) ? true : false); _ck(_v, 19, 0, currVal_6); var currVal_7 = ((_co.getConfigType(_v.context.$implicit) == 3) ? true : false); _ck(_v, 21, 0, currVal_7); var currVal_8 = ((_co.getConfigType(_v.context.$implicit) == 4) ? true : false); _ck(_v, 23, 0, currVal_8); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 5, 0, currVal_1); }); }
function View_tenantConfigComponent_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 37, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 10, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 8, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 7, "input", [["class", "w-100 p-sm b-a"], ["maxlength", "200"], ["placeholder", "scale"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](5, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](6, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 16777216, null, null, 10, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](13, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 8, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 7, "input", [["class", "w-100 p-sm b-a"], ["maxlength", "200"], ["placeholder", "code"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 16)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 16).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 16)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 16)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.value.code = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](16, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](17, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](20, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](22, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](23, 16777216, null, null, 10, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](24, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](25, 0, null, null, 8, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 7, "input", [["class", "w-100 p-sm b-a"], ["maxlength", "200"], ["placeholder", "code"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 27)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 27)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.value.value = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](28, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](31, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](33, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](34, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"], ["id", "delete"]], [[1, "id", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onScaleDelete(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.displayName, ""); _ck(_v, 2, 0, currVal_0); var currVal_9 = "200"; _ck(_v, 6, 0, currVal_9); var currVal_10 = _v.context.$implicit.displayName; _ck(_v, 9, 0, currVal_10); var currVal_11 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.value.code, ""); _ck(_v, 13, 0, currVal_11); var currVal_20 = "200"; _ck(_v, 17, 0, currVal_20); var currVal_21 = _v.context.$implicit.value.code; _ck(_v, 20, 0, currVal_21); var currVal_22 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.value.value, ""); _ck(_v, 24, 0, currVal_22); var currVal_31 = "200"; _ck(_v, 28, 0, currVal_31); var currVal_32 = _v.context.$implicit.value.value; _ck(_v, 31, 0, currVal_32); }, function (_ck, _v) { var currVal_1 = (core["ɵnov"](_v, 6).maxlength ? core["ɵnov"](_v, 6).maxlength : null); var currVal_2 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 11).ngClassValid; var currVal_7 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_12 = (core["ɵnov"](_v, 17).maxlength ? core["ɵnov"](_v, 17).maxlength : null); var currVal_13 = core["ɵnov"](_v, 22).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 22).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 22).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 22).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 22).ngClassValid; var currVal_18 = core["ɵnov"](_v, 22).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 22).ngClassPending; _ck(_v, 15, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_23 = (core["ɵnov"](_v, 28).maxlength ? core["ɵnov"](_v, 28).maxlength : null); var currVal_24 = core["ɵnov"](_v, 33).ngClassUntouched; var currVal_25 = core["ɵnov"](_v, 33).ngClassTouched; var currVal_26 = core["ɵnov"](_v, 33).ngClassPristine; var currVal_27 = core["ɵnov"](_v, 33).ngClassDirty; var currVal_28 = core["ɵnov"](_v, 33).ngClassValid; var currVal_29 = core["ɵnov"](_v, 33).ngClassInvalid; var currVal_30 = core["ɵnov"](_v, 33).ngClassPending; _ck(_v, 26, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30); var currVal_33 = _v.context.index; _ck(_v, 36, 0, currVal_33); });
}
function View_tenantConfigComponent_27(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 44, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 10, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 8, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 7, "input", [["class", "w-100 p-sm b-a"], ["maxlength", "250"], ["placeholder", "scale"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](5, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](6, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 16777216, null, null, 11, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](13, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 9, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 8, "input", [["class", "w-100 p-sm b-a"], ["maxlength", "200"], ["placeholder", "value"], ["type", "number"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 16)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 16).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 16)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 16)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 17).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 17).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 17).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_v.context.$implicit.value = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](16, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](17, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](18, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](21, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](23, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](24, 16777216, null, null, 16, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](25, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](26, 0, null, null, 14, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 5, "input", [["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 28)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 28).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 28)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 28)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.code = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](28, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](30, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](32, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](33, 0, null, null, 7, "input", [["class", "w-100 p-sm b-a"], ["maxlength", "7"], ["type", "text"]], [[8, "value", 0], [1, "id", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 34)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 34).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 34)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 34)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.code = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](34, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](35, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](38, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](40, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](41, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](42, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](43, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"], ["id", "delete"]], [[1, "id", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onIndicatorDelete(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 2, 0, currVal_0); var currVal_9 = "250"; _ck(_v, 6, 0, currVal_9); var currVal_10 = _v.context.$implicit.name; _ck(_v, 9, 0, currVal_10); var currVal_11 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.value, ""); _ck(_v, 13, 0, currVal_11); var currVal_20 = "200"; _ck(_v, 18, 0, currVal_20); var currVal_21 = _v.context.$implicit.value; _ck(_v, 21, 0, currVal_21); var currVal_22 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.code, ""); _ck(_v, 25, 0, currVal_22); var currVal_32 = _v.context.$implicit.code; _ck(_v, 30, 0, currVal_32); var currVal_43 = "7"; _ck(_v, 35, 0, currVal_43); var currVal_44 = _v.context.$implicit.code; _ck(_v, 38, 0, currVal_44); }, function (_ck, _v) { var currVal_1 = (core["ɵnov"](_v, 6).maxlength ? core["ɵnov"](_v, 6).maxlength : null); var currVal_2 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 11).ngClassValid; var currVal_7 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_12 = (core["ɵnov"](_v, 18).maxlength ? core["ɵnov"](_v, 18).maxlength : null); var currVal_13 = core["ɵnov"](_v, 23).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 23).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 23).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 23).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 23).ngClassValid; var currVal_18 = core["ɵnov"](_v, 23).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 23).ngClassPending; _ck(_v, 15, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_23 = _v.context.$implicit.code; var currVal_24 = _v.context.index; var currVal_25 = core["ɵnov"](_v, 32).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 32).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 32).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 32).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 32).ngClassValid; var currVal_30 = core["ɵnov"](_v, 32).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 32).ngClassPending; _ck(_v, 27, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); var currVal_33 = _v.context.$implicit.code; var currVal_34 = _v.context.index; var currVal_35 = (core["ɵnov"](_v, 35).maxlength ? core["ɵnov"](_v, 35).maxlength : null); var currVal_36 = core["ɵnov"](_v, 40).ngClassUntouched; var currVal_37 = core["ɵnov"](_v, 40).ngClassTouched; var currVal_38 = core["ɵnov"](_v, 40).ngClassPristine; var currVal_39 = core["ɵnov"](_v, 40).ngClassDirty; var currVal_40 = core["ɵnov"](_v, 40).ngClassValid; var currVal_41 = core["ɵnov"](_v, 40).ngClassInvalid; var currVal_42 = core["ɵnov"](_v, 40).ngClassPending; _ck(_v, 33, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42); var currVal_45 = _v.context.index; _ck(_v, 43, 0, currVal_45); });
}
function View_tenantConfigComponent_28(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 38, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 16, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 14, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 5, "input", [["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.startcolor = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](5, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](7, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](9, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](10, 0, null, null, 7, "input", [["class", "w-100 p-sm b-a"], ["maxlength", "7"], ["type", "text"]], [[8, "value", 0], [1, "id", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 11)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 11).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 11)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 11)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.startcolor = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](11, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](12, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](15, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](17, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](18, 16777216, null, null, 16, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](19, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 14, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 5, "input", [["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.endcolor = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](24, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](26, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](27, 0, null, null, 7, "input", [["class", "w-100 p-sm b-a"], ["maxlength", "7"], ["type", "text"]], [[8, "value", 0], [1, "id", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 28)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 28).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 28)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 28)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.endcolor = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](28, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](29, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](32, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](34, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](35, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"], ["id", "delete"]], [[1, "id", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onColorPaletteDelete(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.startcolor, ""); _ck(_v, 2, 0, currVal_0); var currVal_10 = _v.context.$implicit.startcolor; _ck(_v, 7, 0, currVal_10); var currVal_21 = "7"; _ck(_v, 12, 0, currVal_21); var currVal_22 = _v.context.$implicit.startcolor; _ck(_v, 15, 0, currVal_22); var currVal_23 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.endcolor, ""); _ck(_v, 19, 0, currVal_23); var currVal_33 = _v.context.$implicit.endcolor; _ck(_v, 24, 0, currVal_33); var currVal_44 = "7"; _ck(_v, 29, 0, currVal_44); var currVal_45 = _v.context.$implicit.endcolor; _ck(_v, 32, 0, currVal_45); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.startcolor; var currVal_2 = _v.context.index; var currVal_3 = core["ɵnov"](_v, 9).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 9).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 9).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 9).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 9).ngClassValid; var currVal_8 = core["ɵnov"](_v, 9).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 9).ngClassPending; _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_11 = _v.context.$implicit.startcolor; var currVal_12 = _v.context.index; var currVal_13 = (core["ɵnov"](_v, 12).maxlength ? core["ɵnov"](_v, 12).maxlength : null); var currVal_14 = core["ɵnov"](_v, 17).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 17).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 17).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 17).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 17).ngClassValid; var currVal_19 = core["ɵnov"](_v, 17).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 17).ngClassPending; _ck(_v, 10, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_24 = _v.context.$implicit.endcolor; var currVal_25 = _v.context.index; var currVal_26 = core["ɵnov"](_v, 26).ngClassUntouched; var currVal_27 = core["ɵnov"](_v, 26).ngClassTouched; var currVal_28 = core["ɵnov"](_v, 26).ngClassPristine; var currVal_29 = core["ɵnov"](_v, 26).ngClassDirty; var currVal_30 = core["ɵnov"](_v, 26).ngClassValid; var currVal_31 = core["ɵnov"](_v, 26).ngClassInvalid; var currVal_32 = core["ɵnov"](_v, 26).ngClassPending; _ck(_v, 21, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32); var currVal_34 = _v.context.$implicit.endcolor; var currVal_35 = _v.context.index; var currVal_36 = (core["ɵnov"](_v, 29).maxlength ? core["ɵnov"](_v, 29).maxlength : null); var currVal_37 = core["ɵnov"](_v, 34).ngClassUntouched; var currVal_38 = core["ɵnov"](_v, 34).ngClassTouched; var currVal_39 = core["ɵnov"](_v, 34).ngClassPristine; var currVal_40 = core["ɵnov"](_v, 34).ngClassDirty; var currVal_41 = core["ɵnov"](_v, 34).ngClassValid; var currVal_42 = core["ɵnov"](_v, 34).ngClassInvalid; var currVal_43 = core["ɵnov"](_v, 34).ngClassPending; _ck(_v, 27, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43); var currVal_46 = _v.context.index; _ck(_v, 37, 0, currVal_46); });
}
function View_tenantConfigComponent_30(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_tenantConfigComponent_29(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_30)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_tenantConfigComponent_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 107, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_14)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_15)), core["ɵdid"](10, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 8, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 7, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Custom Scales "])), (_l()(), core["ɵeld"](17, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addScales() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Scales "])), (_l()(), core["ɵeld"](20, 0, null, null, 15, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Scale"]], null, null, null, null, null)), core["ɵdid"](23, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Scale "])), (_l()(), core["ɵeld"](26, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Value"]], null, null, null, null, null)), core["ɵdid"](27, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](28, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](30, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Colour"]], null, null, null, null, null)), core["ɵdid"](31, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](32, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Value "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_26)), core["ɵdid"](35, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](36, 0, null, null, 8, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 7, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Indicators "])), (_l()(), core["ɵeld"](42, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](43, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addIndicators() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Indicators "])), (_l()(), core["ɵeld"](45, 0, null, null, 15, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](47, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Scale"]], null, null, null, null, null)), core["ɵdid"](48, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](49, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Scale "])), (_l()(), core["ɵeld"](51, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Value"]], null, null, null, null, null)), core["ɵdid"](52, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](53, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Value "])), (_l()(), core["ɵeld"](55, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Colour"]], null, null, null, null, null)), core["ɵdid"](56, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](57, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Colour "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_27)), core["ɵdid"](60, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](61, 0, null, null, 15, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](62, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Page Config "])), (_l()(), core["ɵeld"](65, 0, null, null, 11, "div", [["class", "w-100 float-left p-md-2 light-bg grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](66, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Page Snapshot Expiry"]], null, null, null, null, null)), core["ɵdid"](67, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](68, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Page Snapshot Expiry "])), (_l()(), core["ɵeld"](70, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](72, 0, null, null, 0, "input", [["autocomplete", "off"], ["class", "form-control hideArrow"], ["id", "expiryDay"], ["max", "99"], ["min", "1"], ["placeholder", " "], ["size", "100"], ["type", "number"]], [[8, "value", 0]], [[null, "blur"], [null, "keypress"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("blur" === en)) {
                var pd_0 = (_co.setExpiry($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("keypress" === en)) {
                var pd_1 = (_co.validateDuration($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](73, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](74, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](75, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Days"])), (_l()(), core["ɵeld"](77, 0, null, null, 8, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](78, 0, null, null, 7, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](79, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](80, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](81, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Colour Palette "])), (_l()(), core["ɵeld"](83, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](84, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addColorPalette() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Colour Palette "])), (_l()(), core["ɵeld"](86, 0, null, null, 11, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 0, null, null, 8, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](88, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "startcolor"]], null, null, null, null, null)), core["ɵdid"](89, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](90, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Start Colour "])), (_l()(), core["ɵeld"](92, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "endcolor"]], null, null, null, null, null)), core["ɵdid"](93, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](94, 0, null, null, 1, "h5", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" End Colour "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_28)), core["ɵdid"](97, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](98, 0, null, null, 7, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](99, 0, null, null, 6, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](100, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](101, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "save"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Save Changes "])), (_l()(), core["ɵeld"](103, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](104, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "reset"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onResetDefaults($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Reset Defaults "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_29)), core["ɵdid"](107, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.tenantConfigList; _ck(_v, 10, 0, currVal_1); var currVal_2 = "Scale"; _ck(_v, 23, 0, currVal_2); var currVal_3 = "Value"; _ck(_v, 27, 0, currVal_3); var currVal_4 = "Colour"; _ck(_v, 31, 0, currVal_4); var currVal_5 = _co.customScaleList; _ck(_v, 35, 0, currVal_5); var currVal_6 = "Scale"; _ck(_v, 48, 0, currVal_6); var currVal_7 = "Value"; _ck(_v, 52, 0, currVal_7); var currVal_8 = "Colour"; _ck(_v, 56, 0, currVal_8); var currVal_9 = _co.tntConfData.measureStatusIndicatorData; _ck(_v, 60, 0, currVal_9); var currVal_10 = "Page Snapshot Expiry"; _ck(_v, 67, 0, currVal_10); var currVal_12 = "startcolor"; _ck(_v, 89, 0, currVal_12); var currVal_13 = "endcolor"; _ck(_v, 93, 0, currVal_13); var currVal_14 = _co.colorPaletevalue; _ck(_v, 97, 0, currVal_14); var currVal_15 = (_co.tntConfData == 0); _ck(_v, 107, 0, currVal_15); }, function (_ck, _v) { var _co = _v.component; var currVal_11 = _co.getValueFor(); _ck(_v, 72, 0, currVal_11); });
}
function View_tenantConfigComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_13)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 18, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Cache Management "])), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [["class", "w-100 float-none p-md-2 light-bg text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary center-block"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSyncCube() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Sync Cube Meta Cache "])), (_l()(), core["ɵeld"](14, 0, null, null, 2, "div", [["class", "w-100 float-none p-md-2 light-bg text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "button", [["class", "btn btn-primary center-block"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSyncData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Sync Data Version Cache "])), (_l()(), core["ɵeld"](17, 0, null, null, 2, "div", [["class", "w-100 float-none p-md-2 light-bg text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "button", [["class", "btn btn-primary center-block"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onFlushDash() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Flush Dashboard Cache "])), (_l()(), core["ɵeld"](20, 0, null, null, 2, "div", [["class", "w-100 float-none p-md-2 light-bg text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "button", [["class", "btn btn-primary center-block"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSyncDash() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Sync Dashboard Cache "])), (_l()(), core["ɵeld"](23, 0, null, null, 2, "div", [["class", "w-100 float-none p-md-2 light-bg text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "button", [["class", "btn btn-primary center-block"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.reBuildDashboardSnaphot() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Rebuild Dashboard Snapshots "]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.isEdit; _ck(_v, 6, 0, currVal_2); }, null);
}
function View_tenantConfigComponent_31(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_tenantConfigComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_31)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_tenantConfigComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_tenantConfigComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 1, 0, currVal_0); }, null); }
function View_tenantConfigComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "tenantConfiguration", [], null, null, null, View_tenantConfigComponent_0, RenderType_tenantConfigComponent)), core["ɵdid"](1, 114688, null, 0, tenantConfiguration_component_tenantConfigComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var tenantConfigComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("tenantConfiguration", tenantConfiguration_component_tenantConfigComponent, View_tenantConfigComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/accordion/accordion.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_accordion,_accordion_config PURE_IMPORTS_END */




var styles_NgbAccordion = [];
var RenderType_NgbAccordion = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NgbAccordion, data: {} });

function View_NgbAccordion_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](0, null, null, 0))], null, null); }
function View_NgbAccordion_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](0, null, null, 0))], null, null); }
function View_NgbAccordion_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "card-body collapse"], ["role", "tabpanel"]], [[8, "id", 0], [1, "aria-labelledby", 0], [2, "show", null]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbAccordion_4)), core["ɵdid"](2, 540672, null, 0, common["NgTemplateOutlet"], [core["ViewContainerRef"]], { ngTemplateOutlet: [0, "ngTemplateOutlet"] }, null)], function (_ck, _v) { var currVal_3 = ((_v.parent.context.$implicit.contentTpl == null) ? null : _v.parent.context.$implicit.contentTpl.templateRef); _ck(_v, 2, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.context.$implicit.id, ""); var currVal_1 = (_v.parent.context.$implicit.id + "-header"); var currVal_2 = _v.parent.context.$implicit.isOpen; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2); }); }
function View_NgbAccordion_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "card"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["role", "tab"]], [[8, "id", 0], [8, "className", 0]], null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 4, "h5", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "button", [["class", "btn btn-link"]], [[8, "disabled", 0], [2, "collapsed", null], [1, "aria-expanded", 0], [1, "aria-controls", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (!!_co.toggle(_v.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](4, null, [" ", ""])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbAccordion_2)), core["ɵdid"](6, 540672, null, 0, common["NgTemplateOutlet"], [core["ViewContainerRef"]], { ngTemplateOutlet: [0, "ngTemplateOutlet"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbAccordion_3)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = ((_v.context.$implicit.titleTpl == null) ? null : _v.context.$implicit.titleTpl.templateRef); _ck(_v, 6, 0, currVal_7); var currVal_8 = (!_co.destroyOnHide || _v.context.$implicit.isOpen); _ck(_v, 8, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.id, "-header"); var currVal_1 = ("card-header " + (_v.context.$implicit.type ? ("bg-" + _v.context.$implicit.type) : (_co.type ? ("bg-" + _co.type) : ""))); _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.disabled; var currVal_3 = _v.context.$implicit.isOpen; var currVal_4 = _v.context.$implicit.isOpen; var currVal_5 = _v.context.$implicit.id; _ck(_v, 3, 0, currVal_2, currVal_3, currVal_4, currVal_5); var currVal_6 = _v.context.$implicit.title; _ck(_v, 4, 0, currVal_6); });
}
function View_NgbAccordion_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbAccordion_1)), core["ɵdid"](1, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.panels; _ck(_v, 1, 0, currVal_0); }, null); }
function View_NgbAccordion_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "ngb-accordion", [["class", "accordion"], ["role", "tablist"]], [[1, "aria-multiselectable", 0]], null, null, View_NgbAccordion_0, RenderType_NgbAccordion)), core["ɵdid"](1, 2146304, null, 1, accordion_NgbAccordion, [NgbAccordionConfig], null, null), core["ɵqud"](603979776, 1, { panels: 1 })], null, function (_ck, _v) { var currVal_0 = !core["ɵnov"](_v, 1).closeOtherPanels; _ck(_v, 0, 0, currVal_0); }); }
var NgbAccordionNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-accordion", accordion_NgbAccordion, View_NgbAccordion_Host_0, { activeIds: "activeIds", closeOtherPanels: "closeOthers", destroyOnHide: "destroyOnHide", type: "type" }, { panelChange: "panelChange" }, []);



// CONCATENATED MODULE: ./src/app/bi/common/service/ngbDateConverter.utils.ts


/**
 * Example of a String Time adapter
 */
var ngbDateConverter_utils_NgbDateConverter = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](NgbDateConverter, _super);
    function NgbDateConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbDateConverter.prototype.fromModel = function (value) {
        if (!value) {
            return null;
        }
        var split = value.split('-', 3);
        return {
            day: parseInt(split[0], 10),
            month: parseInt(split[1], 10),
            year: parseInt(split[2], 10)
        };
    };
    NgbDateConverter.prototype.toModel = function (date) {
        if (!date) {
            return null;
        }
        return this.pad(date.year) + "-" + this.pad(date.month) + "-" + this.pad(date.day);
    };
    NgbDateConverter.prototype.pad = function (i) {
        return i < 10 ? "0" + i : "" + i;
    };
    return NgbDateConverter;
}(NgbDateAdapter));



// CONCATENATED MODULE: ./src/app/bi/admin/controller/target.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,ng2_auto_complete_dist_ng2_auto_complete.directive,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_accordion_accordion.ngfactory,_ng_bootstrap_ng_bootstrap_accordion_accordion,_ng_bootstrap_ng_bootstrap_accordion_accordion_config,_loader.component.ngfactory,_loader.component,_target.component,_angular_platform_browser,_services_mdmService.service,_.._.._toasterComponent_toasterComponent,_.._common_service_ngbDateConverter.utils PURE_IMPORTS_END */

























var styles_targetComponent = [];
var RenderType_targetComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_targetComponent, data: {} });

function View_targetComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["TARGET"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addCorTarget($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Cor Target "]))], null, null);
}
function View_targetComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editCorTarget(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeCorTrg(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], null, null);
}
function View_targetComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_6)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.corTrgCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 6, 0, currVal_2); var currVal_5 = ((_co.selectedCorTrgId == _v.context.$implicit.id) ? true : false); _ck(_v, 13, 0, currVal_5); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.corTrgCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.name; _ck(_v, 8, 0, currVal_3); var currVal_4 = _v.context.$implicit.id; _ck(_v, 9, 0, currVal_4); });
}
function View_targetComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_targetComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_8)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_targetComponent_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalCorTrgs; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_targetComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" NON EXISTENT DIMENSIONS ", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "NON EXISTENT DIMENSIONS ", (_v.context.index + 1), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = (_v.context.index + 1); _ck(_v, 3, 0, currVal_1); }); }
function View_targetComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" NON EXISTENT DIMENSION LEVELS ", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "NON EXISTENT DIMENSION LEVELS ", (_v.context.index + 1), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = (_v.context.index + 1); _ck(_v, 3, 0, currVal_1); }); }
function View_targetComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "li", [], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit; _ck(_v, 2, 0, currVal_1); }); }
function View_targetComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "li", [], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit; _ck(_v, 2, 0, currVal_1); }); }
function View_targetComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "ul", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_15)), core["ɵdid"](3, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 3, 0, currVal_0); }, null); }
function View_targetComponent_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "li", [], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit; _ck(_v, 2, 0, currVal_1); }); }
function View_targetComponent_16(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "ul", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_17)), core["ɵdid"](3, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 3, 0, currVal_0); }, null); }
function View_targetComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "info"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Bulk Upload Summary"])), (_l()(), core["ɵeld"](5, 0, null, null, 8, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "NON EXISTENT TARGETS"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" NON EXISTENT TARGETS "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_11)), core["ɵdid"](11, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_12)), core["ɵdid"](13, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 8, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "ul", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_13)), core["ɵdid"](18, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_14)), core["ɵdid"](20, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_16)), core["ɵdid"](22, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](23, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "button", [["class", "float-right btn btn-primary"], ["id", "onCloseSummary"], ["type", "submit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onCloseSummary($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Close Summary "]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = "NON EXISTENT TARGETS"; _ck(_v, 7, 0, currVal_0); var currVal_1 = _co.nonExistentDimensions; _ck(_v, 11, 0, currVal_1); var currVal_2 = _co.nonExistentDimLevels; _ck(_v, 13, 0, currVal_2); var currVal_3 = _co.nonExistentTargets; _ck(_v, 18, 0, currVal_3); var currVal_4 = _co.nonExistentDimensions; _ck(_v, 20, 0, currVal_4); var currVal_5 = _co.nonExistentDimLevels; _ck(_v, 22, 0, currVal_5); }, null);
}
function View_targetComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 76, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 15, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 4, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "div", [["class", "col-lg-12 col-md-12 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Operations"])), (_l()(), core["ɵeld"](7, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 8, "div", [["class", "col-lg-12 col-md-12 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 7, "form", [["class", ""], ["enctype", "multipart/form-data"], ["method", "POST"], ["novalidate", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "submit"], [null, "reset"]], function (_v, en, $event) {
            var ad = true;
            if (("submit" === en)) {
                var pd_0 = (core["ɵnov"](_v, 11).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("reset" === en)) {
                var pd_1 = (core["ɵnov"](_v, 11).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](10, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bg"], [], null, null), core["ɵdid"](11, 4210688, null, 0, fesm5_forms["NgForm"], [[8, null], [8, null]], null, null), core["ɵprd"](2048, null, fesm5_forms["ControlContainer"], null, [fesm5_forms["NgForm"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatusGroup"], [[4, fesm5_forms["ControlContainer"]]], null, null), (_l()(), core["ɵeld"](14, 0, [[1, 0], ["file", 1]], null, 0, "input", [["accept", ".xls,.xlsx"], ["class", "pull-left next-btn r mt-smd m-r-smd m-b-smd"], ["multipart", "true"], ["name", "file"], ["placeholder", "No File Chosen."], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.fileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "bulkUpload"], ["type", "submit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.bulkUpload($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Bulk Upload "])), (_l()(), core["ɵeld"](17, 0, null, null, 12, "div", [["class", "w-100 float-left mt-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 20)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 20).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 20)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 20)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.trgReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](20, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](21, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](24, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](26, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](27, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPTarget() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search"])), (_l()(), core["ɵeld"](30, 0, null, null, 13, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Target Code"]], null, null, null, null, null)), core["ɵdid"](33, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](34, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Target Code "])), (_l()(), core["ɵeld"](36, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Target Name"]], null, null, null, null, null)), core["ɵdid"](37, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](38, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Target Name "])), (_l()(), core["ɵeld"](40, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](41, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](42, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_5)), core["ɵdid"](45, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_7)), core["ɵdid"](47, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](48, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](49, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](51, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](52, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](54, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 55).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 55).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](55, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](57, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](59, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](60, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](61, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](62, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](64, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](65, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](66, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](68, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](69, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](70, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](72, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_9)), core["ɵdid"](74, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_10)), core["ɵdid"](76, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_15 = "100"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "searchBox"; var currVal_17 = _co.trgReg; _ck(_v, 24, 0, currVal_16, currVal_17); var currVal_18 = "Target Code"; _ck(_v, 33, 0, currVal_18); var currVal_19 = "Target Name"; _ck(_v, 37, 0, currVal_19); var currVal_20 = "Actions"; _ck(_v, 41, 0, currVal_20); var currVal_21 = _co.trgList; _ck(_v, 45, 0, currVal_21); var currVal_22 = (_co.trgList.length == 0); _ck(_v, 47, 0, currVal_22); var currVal_33 = _co.pageSize; _ck(_v, 57, 0, currVal_33); var currVal_34 = "10"; _ck(_v, 61, 0, currVal_34); var currVal_35 = "10"; _ck(_v, 62, 0, currVal_35); var currVal_36 = "20"; _ck(_v, 65, 0, currVal_36); var currVal_37 = "20"; _ck(_v, 66, 0, currVal_37); var currVal_38 = "30"; _ck(_v, 69, 0, currVal_38); var currVal_39 = "30"; _ck(_v, 70, 0, currVal_39); var currVal_40 = _co.trgList.length; _ck(_v, 74, 0, currVal_40); var currVal_41 = _co.uploadSucess; _ck(_v, 76, 0, currVal_41); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 13).ngClassValid; var currVal_5 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 9, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_7 = (core["ɵnov"](_v, 21).maxlength ? core["ɵnov"](_v, 21).maxlength : null); var currVal_8 = core["ɵnov"](_v, 26).ngClassUntouched; var currVal_9 = core["ɵnov"](_v, 26).ngClassTouched; var currVal_10 = core["ɵnov"](_v, 26).ngClassPristine; var currVal_11 = core["ɵnov"](_v, 26).ngClassDirty; var currVal_12 = core["ɵnov"](_v, 26).ngClassValid; var currVal_13 = core["ɵnov"](_v, 26).ngClassInvalid; var currVal_14 = core["ɵnov"](_v, 26).ngClassPending; _ck(_v, 19, 0, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14); var currVal_23 = _co.startingPage; var currVal_24 = _co.endingPage; var currVal_25 = _co.totalCorTrgs; _ck(_v, 50, 0, currVal_23, currVal_24, currVal_25); var currVal_26 = core["ɵnov"](_v, 59).ngClassUntouched; var currVal_27 = core["ɵnov"](_v, 59).ngClassTouched; var currVal_28 = core["ɵnov"](_v, 59).ngClassPristine; var currVal_29 = core["ɵnov"](_v, 59).ngClassDirty; var currVal_30 = core["ɵnov"](_v, 59).ngClassValid; var currVal_31 = core["ɵnov"](_v, 59).ngClassInvalid; var currVal_32 = core["ɵnov"](_v, 59).ngClassPending; _ck(_v, 54, 0, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32); });
}
function View_targetComponent_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Cor Target "]))], null, null); }
function View_targetComponent_20(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Cor Target - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.corTrgData.corTrgCode; _ck(_v, 1, 0, currVal_0); }); }
function View_targetComponent_22(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Mas Targets"]))], null, null); }
function View_targetComponent_23(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Target Date"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Target Date "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Target Value"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Target Value "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Mas-Target Actions"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Mas-Target Actions "])), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "div", [["class", "col-lg-5 col-md-5 col-sm-5 col-xs-5 float-left"], ["ngbTooltip", "Det-Target Details"]], null, null, null, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Det-Targets Details "]))], function (_ck, _v) { var currVal_0 = "Target Date"; _ck(_v, 2, 0, currVal_0); var currVal_1 = "Target Value"; _ck(_v, 6, 0, currVal_1); var currVal_2 = "Mas-Target Actions"; _ck(_v, 10, 0, currVal_2); var currVal_3 = "Det-Target Details"; _ck(_v, 14, 0, currVal_3); }, null); }
function View_targetComponent_28(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, [[2, 0], ["autoCompletediv", 1]], null, 1, "input", [["auto-complete", ""], ["autocomplete", "off"], ["class", "flex-grow:1 drop-down form-control"], ["id", "dimSearch"], ["placeholder", "Dimension Level"]], null, [[null, "valueChanged"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("valueChanged" === en)) {
                var pd_0 = (_co.onSelectDim($event, _v.parent.parent.context.$implicit, _v.parent.parent.parent.parent.context.index, _v.parent.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], acceptUserInput: [1, "acceptUserInput"], listFormatter: [2, "listFormatter"], valueFormatter: [3, "valueFormatter"] }, { valueChanged: "valueChanged" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.searchDim.bind(_co); var currVal_1 = true; var currVal_2 = _co.autoCompleteListFormatter; var currVal_3 = _co.orgNameValueFormatter; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3); }, null);
}
function View_targetComponent_29(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "selectedItem"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), (_l()(), core["ɵeld"](2, 0, null, null, 0, "i", [["class", "fa fa-close mr-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeSelectedDim(_v.parent.parent.parent.parent.context.index, _v.parent.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.dimLvlList[_v.parent.parent.parent.parent.context.index][_v.parent.parent.context.index]; _ck(_v, 1, 0, currVal_0); });
}
function View_targetComponent_27(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_28)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_29)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.searchBarVisibility(_v.parent.parent.parent.context.index, _v.parent.context.index); _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.searchBarVisibility(_v.parent.parent.parent.context.index, _v.parent.context.index); _ck(_v, 4, 0, currVal_1); }, null); }
function View_targetComponent_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 14, "div", [["class", "w-100 float-left p-md-2 grid-details table-custom"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_27)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 7, "div", [["class", "col-lg-5 col-md-5 col-sm-5 col-xs-5 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 6, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 5, "input", [["class", "w-full p-sm b-a"], ["placeholder", "Dimension Level Value"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.dimLvlValue = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2 iga-left"], ["id", " delete "]], [[1, "id", 0], [1, "value", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeDetTarget(_v.context.$implicit, _v.parent.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], function (_ck, _v) { var currVal_0 = (_v.context.$implicit.id == null); _ck(_v, 3, 0, currVal_0); var currVal_8 = _v.context.$implicit.dimLvlValue; _ck(_v, 9, 0, currVal_8); }, function (_ck, _v) { var currVal_1 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 11).ngClassValid; var currVal_6 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 6, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_9 = _v.parent.parent.context.index; var currVal_10 = _v.context.index; _ck(_v, 14, 0, currVal_9, currVal_10); });
}
function View_targetComponent_25(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_26)), core["ɵdid"](1, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.corDetTrgList[_v.parent.context.index]; _ck(_v, 1, 0, currVal_0); }, null); }
function View_targetComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 38, "div", [["class", "w-100 float-left p-md-2 grid-details table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 13, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 9, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 16777216, null, null, 8, "input", [["class", "form-control light-bg"], ["name", "targetDate"], ["ngbDatepicker", ""], ["placeholder", "YYYYMMDD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("input" === en)) {
                var pd_4 = (core["ɵnov"](_v, 6).manualDateChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("change" === en)) {
                var pd_5 = (core["ɵnov"](_v, 6).manualDateChange($event.target.value, true) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 6).onBlur() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_v.context.$implicit.date = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](6, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], datepicker_input_NgbInputDatepicker]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 0, null, null, 2, "div", [["class", "col-sx-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "button", [["class", "iga-left form-control light-bg"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6).toggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 7, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 6, "input", [["class", "w-full p-sm b-a"], ["placeholder", "Target Value"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 17)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 17).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 17)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 17)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 18).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 18).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 18).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_v.context.$implicit.value = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](17, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](18, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](20, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](22, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](23, 0, null, null, 5, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 4, "h5", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 1, "i", [["class", "fa fa-plus mr-2 float-left"], ["id", " insert "]], [[1, "id", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addDetTarget(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Det-Target "])), (_l()(), core["ɵeld"](27, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2 float-left"], ["id", " delete "]], [[1, "id", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeMasTarget(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "])), (_l()(), core["ɵeld"](29, 0, null, null, 9, "div", [["class", "col-lg-5 col-md-5 col-sm-5 col-xs-5 float-left accordionss"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 8, "ngb-accordion", [["class", "w-100 accordion"], ["role", "tablist"]], [[1, "aria-multiselectable", 0]], null, null, View_NgbAccordion_0, RenderType_NgbAccordion)), core["ɵdid"](31, 2146304, null, 1, accordion_NgbAccordion, [NgbAccordionConfig], null, null), core["ɵqud"](603979776, 3, { panels: 1 }), (_l()(), core["ɵeld"](33, 0, null, null, 5, "ngb-panel", [["id", "corMasTrg.id"], ["title", "View-Dimensions"]], null, null, null, null, null)), core["ɵdid"](34, 2113536, [[3, 4]], 2, NgbPanel, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 4, { titleTpls: 1 }), core["ɵqud"](603979776, 5, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_targetComponent_25)), core["ɵdid"](38, 16384, [[5, 4]], 0, NgbPanelContent, [core["TemplateRef"]], null, null)], function (_ck, _v) { var currVal_8 = "targetDate"; var currVal_9 = _v.context.$implicit.date; _ck(_v, 9, 0, currVal_8, currVal_9); var currVal_17 = _v.context.$implicit.value; _ck(_v, 20, 0, currVal_17); var currVal_21 = "corMasTrg.id"; var currVal_22 = "View-Dimensions"; _ck(_v, 34, 0, currVal_21, currVal_22); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 6).disabled; var currVal_1 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 11).ngClassValid; var currVal_6 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = core["ɵnov"](_v, 22).ngClassUntouched; var currVal_11 = core["ɵnov"](_v, 22).ngClassTouched; var currVal_12 = core["ɵnov"](_v, 22).ngClassPristine; var currVal_13 = core["ɵnov"](_v, 22).ngClassDirty; var currVal_14 = core["ɵnov"](_v, 22).ngClassValid; var currVal_15 = core["ɵnov"](_v, 22).ngClassInvalid; var currVal_16 = core["ɵnov"](_v, 22).ngClassPending; _ck(_v, 16, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16); var currVal_18 = _v.context.index; _ck(_v, 25, 0, currVal_18); var currVal_19 = _v.context.index; _ck(_v, 27, 0, currVal_19); var currVal_20 = !core["ɵnov"](_v, 31).closeOtherPanels; _ck(_v, 30, 0, currVal_20); });
}
function View_targetComponent_31(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Mas Targets Found"]))], null, null); }
function View_targetComponent_30(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_31)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_targetComponent_33(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentMPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalMasTrgs; var currVal_4 = 5; var currVal_5 = _co.currentMPage; var currVal_6 = _co.mSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_targetComponent_32(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](3, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](6, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.mSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](13, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](14, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](16, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](17, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](18, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](20, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](21, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](22, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](24, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_33)), core["ɵdid"](26, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_10 = _co.mSize; _ck(_v, 9, 0, currVal_10); var currVal_11 = "10"; _ck(_v, 13, 0, currVal_11); var currVal_12 = "10"; _ck(_v, 14, 0, currVal_12); var currVal_13 = "20"; _ck(_v, 17, 0, currVal_13); var currVal_14 = "20"; _ck(_v, 18, 0, currVal_14); var currVal_15 = "30"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "30"; _ck(_v, 22, 0, currVal_16); var currVal_17 = _co.corMasTrgList.length; _ck(_v, 26, 0, currVal_17); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.startingMPage; var currVal_1 = _co.endingMPage; var currVal_2 = _co.totalMasTrgs; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2); var currVal_3 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 11).ngClassValid; var currVal_8 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 6, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); });
}
function View_targetComponent_21(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 14, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "button", [["class", " btn btn-primary float-left"], ["id", "addMasTrg"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addMasTarget(_co.corTrgData) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Mas Targets "])), (_l()(), core["ɵeld"](4, 0, null, null, 6, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_22)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_23)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_24)), core["ɵdid"](10, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_30)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_32)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.corMasTrgList.length > 0); _ck(_v, 6, 0, currVal_0); var currVal_1 = (_co.corMasTrgList.length > 0); _ck(_v, 8, 0, currVal_1); var currVal_2 = _co.corMasTrgList; _ck(_v, 10, 0, currVal_2); var currVal_3 = (_co.corMasTrgList.length == 0); _ck(_v, 12, 0, currVal_3); var currVal_4 = (_co.corMasTrgList.length > 0); _ck(_v, 14, 0, currVal_4); }, null);
}
function View_targetComponent_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 31, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_19)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_20)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 20, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 14, "div", [], null, null, null, null, null)), core["ɵdid"](13, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngClass: [0, "ngClass"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](17, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](19, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 20)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 20).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 20)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 20)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.corTrgData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](20, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](21, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](24, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](26, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](27, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_21)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_2 = (!_co.isEdit ? "col-lg-6 col-md-6 left-clear" : "col-lg-6 col-md-6 float-left"); _ck(_v, 13, 0, currVal_2); var currVal_11 = "200"; _ck(_v, 21, 0, currVal_11); var currVal_12 = "name"; var currVal_13 = _co.corTrgData.name; _ck(_v, 24, 0, currVal_12, currVal_13); var currVal_15 = _co.isEdit; _ck(_v, 31, 0, currVal_15); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = (core["ɵnov"](_v, 21).maxlength ? core["ɵnov"](_v, 21).maxlength : null); var currVal_4 = core["ɵnov"](_v, 26).ngClassUntouched; var currVal_5 = core["ɵnov"](_v, 26).ngClassTouched; var currVal_6 = core["ɵnov"](_v, 26).ngClassPristine; var currVal_7 = core["ɵnov"](_v, 26).ngClassDirty; var currVal_8 = core["ɵnov"](_v, 26).ngClassValid; var currVal_9 = core["ɵnov"](_v, 26).ngClassInvalid; var currVal_10 = core["ɵnov"](_v, 26).ngClassPending; _ck(_v, 19, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10); var currVal_14 = _co.saveButton; _ck(_v, 28, 0, currVal_14); });
}
function View_targetComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_18)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.trgPage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_targetComponent_34(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_targetComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_34)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_targetComponent_0(_l) { return core["ɵvid"](0, [core["ɵqud"](671088640, 1, { fileInput: 0 }), core["ɵqud"](671088640, 2, { elementDiv: 0 }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_targetComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 3, 0, currVal_0); }, null); }
function View_targetComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "target", [], null, null, null, View_targetComponent_0, RenderType_targetComponent)), core["ɵdid"](1, 114688, null, 0, target_component_targetComponent, [platform_browser["c" /* DomSanitizer */], mdmService_service_MDMService, ToasterComponent, ngbDateConverter_utils_NgbDateConverter, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var targetComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("target", target_component_targetComponent, View_targetComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./node_modules/angular2-multiselect-dropdown/multiselect.model.js
var MyException = /*@__PURE__*/ (function () {
    function MyException(status, body) {
        this.status = status;
        this.body = body;
    }
    return MyException;
}());





// CONCATENATED MODULE: ./node_modules/angular2-multiselect-dropdown/clickOutside.js

var clickOutside_ClickOutsideDirective = /*@__PURE__*/ (function () {
    function ClickOutsideDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.clickOutside = new core["EventEmitter"]();
    }
    ClickOutsideDirective.prototype.onClick = function (event, targetElement) {
        if (!targetElement) {
            return;
        }
        var clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(event);
        }
    };
    return ClickOutsideDirective;
}());

var clickOutside_ScrollDirective = /*@__PURE__*/ (function () {
    function ScrollDirective(_elementRef) {
        this._elementRef = _elementRef;
        this.scroll = new core["EventEmitter"]();
    }
    ScrollDirective.prototype.onClick = function (event, targetElement) {
        this.scroll.emit(event);
    };
    return ScrollDirective;
}());

var styleDirective = /*@__PURE__*/ (function () {
    function styleDirective(el) {
        this.el = el;
    }
    styleDirective.prototype.ngOnInit = function () {
        this.el.nativeElement.style.top = this.styleVal;
    };
    styleDirective.prototype.ngOnChanges = function () {
        this.el.nativeElement.style.top = this.styleVal;
    };
    return styleDirective;
}());

var setPosition = /*@__PURE__*/ (function () {
    function setPosition(el) {
        this.el = el;
    }
    setPosition.prototype.ngOnInit = function () {
        if (this.height) {
            this.el.nativeElement.style.bottom = parseInt(this.height + 15 + "") + 'px';
        }
    };
    setPosition.prototype.ngOnChanges = function () {
        if (this.height) {
            this.el.nativeElement.style.bottom = parseInt(this.height + 15 + "") + 'px';
        }
    };
    return setPosition;
}());





// CONCATENATED MODULE: ./node_modules/angular2-multiselect-dropdown/list-filter.js

var ListFilterPipe = /*@__PURE__*/ (function () {
    function ListFilterPipe() {
    }
    ListFilterPipe.prototype.transform = function (items, filter, searchBy) {
        var _this = this;
        if (!items || !filter) {
            return items;
        }
        return items.filter(function (item) { return _this.applyFilter(item, filter, searchBy); });
    };
    ListFilterPipe.prototype.applyFilter = function (item, filter, searchBy) {
        var found = false;
        if (searchBy.length > 0) {
            for (var t = 0; t < searchBy.length; t++) {
                if (filter && item[searchBy[t]] && item[searchBy[t]] != "") {
                    if (item[searchBy[t]].toString().toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
                        found = true;
                    }
                }
            }
        }
        else {
            for (var prop in item) {
                if (filter && item[prop]) {
                    if (item[prop].toString().toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
                        found = true;
                    }
                }
            }
        }
        return found;
    };
    return ListFilterPipe;
}());





// CONCATENATED MODULE: ./node_modules/angular2-multiselect-dropdown/menu-item.js

var Item = /*@__PURE__*/ (function () {
    function Item() {
    }
    return Item;
}());

var Badge = /*@__PURE__*/ (function () {
    function Badge() {
    }
    return Badge;
}());

var Search = /*@__PURE__*/ (function () {
    function Search() {
    }
    return Search;
}());

var TemplateRenderer = /*@__PURE__*/ (function () {
    function TemplateRenderer(viewContainer) {
        this.viewContainer = viewContainer;
    }
    TemplateRenderer.prototype.ngOnInit = function () {
        this.view = this.viewContainer.createEmbeddedView(this.data.template, {
            '\$implicit': this.data,
            'item': this.item
        });
    };
    TemplateRenderer.prototype.ngOnDestroy = function () {
        this.view.destroy();
    };
    return TemplateRenderer;
}());





// CONCATENATED MODULE: ./node_modules/angular2-multiselect-dropdown/multiselect.component.js







var DROPDOWN_CONTROL_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    useExisting: Object(core["forwardRef"])(function () { return multiselect_component_AngularMultiSelect; }),
    multi: true
};
var DROPDOWN_CONTROL_VALIDATION = {
    provide: fesm5_forms["NG_VALIDATORS"],
    useExisting: Object(core["forwardRef"])(function () { return multiselect_component_AngularMultiSelect; }),
    multi: true,
};
var multiselect_component_noop = function () {
};
var multiselect_component_AngularMultiSelect = /*@__PURE__*/ (function () {
    function AngularMultiSelect(_elementRef, cdr) {
        this._elementRef = _elementRef;
        this.cdr = cdr;
        this.onSelect = new core["EventEmitter"]();
        this.onDeSelect = new core["EventEmitter"]();
        this.onSelectAll = new core["EventEmitter"]();
        this.onDeSelectAll = new core["EventEmitter"]();
        this.onOpen = new core["EventEmitter"]();
        this.onClose = new core["EventEmitter"]();
        this.isActive = false;
        this.isSelectAll = false;
        this.chunkIndex = [];
        this.cachedItems = [];
        this.itemHeight = 41.6;
        this.defaultSettings = {
            singleSelection: false,
            text: 'Select',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: false,
            searchBy: [],
            maxHeight: 300,
            badgeShowLimit: 999999999999,
            classes: '',
            disabled: false,
            searchPlaceholderText: 'Search',
            showCheckbox: true,
            noDataLabel: 'No Data Available',
            searchAutofocus: true,
            lazyLoading: false,
            labelKey: 'itemName',
            primaryKey: 'id',
            position: 'bottom'
        };
        this.onTouchedCallback = multiselect_component_noop;
        this.onChangeCallback = multiselect_component_noop;
    }
    AngularMultiSelect.prototype.ngOnInit = function () {
        var _this = this;
        this.settings = Object.assign(this.defaultSettings, this.settings);
        if (this.settings.groupBy) {
            this.groupedData = this.transformData(this.data, this.settings.groupBy);
        }
        this.totalRows = (this.data && this.data.length);
        this.cachedItems = this.data;
        this.screenItemsLen = Math.ceil(this.settings.maxHeight / this.itemHeight);
        this.cachedItemsLen = this.screenItemsLen * 3;
        this.totalHeight = this.itemHeight * this.totalRows;
        this.maxBuffer = this.screenItemsLen * this.itemHeight;
        this.lastScrolled = 0;
        this.renderChunk(0, this.cachedItemsLen / 2);
        if (this.settings.position == 'top') {
            setTimeout(function () {
                _this.selectedListHeight = { val: 0 };
                _this.selectedListHeight.val = _this.selectedListElem.nativeElement.clientHeight;
            });
        }
    };
    AngularMultiSelect.prototype.ngOnChanges = function (changes) {
        if (changes.data && !changes.data.firstChange) {
            if (this.settings.groupBy) {
                this.groupedData = this.transformData(this.data, this.settings.groupBy);
                if (this.data.length == 0) {
                    this.selectedItems = [];
                }
            }
        }
        if (changes.settings && !changes.settings.firstChange) {
            this.settings = Object.assign(this.defaultSettings, this.settings);
        }
    };
    AngularMultiSelect.prototype.ngDoCheck = function () {
        if (this.selectedItems) {
            if (this.selectedItems.length == 0 || this.data.length == 0 || this.selectedItems.length < this.data.length) {
                this.isSelectAll = false;
            }
        }
    };
    AngularMultiSelect.prototype.ngAfterViewInit = function () {
        if (this.settings.lazyLoading) {
            this._elementRef.nativeElement.getElementsByClassName("lazyContainer")[0].addEventListener('scroll', this.onScroll.bind(this));
        }
    };
    AngularMultiSelect.prototype.ngAfterViewChecked = function () {
        if (this.selectedListElem.nativeElement.clientHeight && this.settings.position == 'top' && this.selectedListHeight) {
            this.selectedListHeight.val = this.selectedListElem.nativeElement.clientHeight;
            this.cdr.detectChanges();
        }
    };
    AngularMultiSelect.prototype.onItemClick = function (item, index, evt) {
        if (this.settings.disabled) {
            return false;
        }
        var found = this.isSelected(item);
        var limit = this.selectedItems.length < this.settings.limitSelection ? true : false;
        if (!found) {
            if (this.settings.limitSelection) {
                if (limit) {
                    this.addSelected(item);
                    this.onSelect.emit(item);
                }
            }
            else {
                this.addSelected(item);
                this.onSelect.emit(item);
            }
        }
        else {
            this.removeSelected(item);
            this.onDeSelect.emit(item);
        }
        if (this.isSelectAll || this.data.length > this.selectedItems.length) {
            this.isSelectAll = false;
        }
        if (this.data.length == this.selectedItems.length) {
            this.isSelectAll = true;
        }
    };
    AngularMultiSelect.prototype.validate = function (c) {
        return null;
    };
    AngularMultiSelect.prototype.writeValue = function (value) {
        if (value !== undefined && value !== null) {
            if (this.settings.singleSelection) {
                try {
                    if (value.length > 1) {
                        this.selectedItems = [value[0]];
                        throw new MyException(404, { "msg": "Single Selection Mode, Selected Items cannot have more than one item." });
                    }
                    else {
                        this.selectedItems = value;
                    }
                }
                catch (e) {
                    console.error(e.body.msg);
                }
            }
            else {
                if (this.settings.limitSelection) {
                    this.selectedItems = value.splice(0, this.settings.limitSelection);
                }
                else {
                    this.selectedItems = value;
                }
                if (this.selectedItems.length === this.data.length && this.data.length > 0) {
                    this.isSelectAll = true;
                }
            }
        }
        else {
            this.selectedItems = [];
        }
    };
    //From ControlValueAccessor interface
    AngularMultiSelect.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    //From ControlValueAccessor interface
    AngularMultiSelect.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    AngularMultiSelect.prototype.trackByFn = function (index, item) {
        return item[this.settings.primaryKey];
    };
    AngularMultiSelect.prototype.isSelected = function (clickedItem) {
        var _this = this;
        var found = false;
        this.selectedItems && this.selectedItems.forEach(function (item) {
            if (clickedItem[_this.settings.primaryKey] === item[_this.settings.primaryKey]) {
                found = true;
            }
        });
        return found;
    };
    AngularMultiSelect.prototype.addSelected = function (item) {
        if (this.settings.singleSelection) {
            this.selectedItems = [];
            this.selectedItems.push(item);
            this.closeDropdown();
        }
        else
            this.selectedItems.push(item);
        this.onChangeCallback(this.selectedItems);
        this.onTouchedCallback(this.selectedItems);
    };
    AngularMultiSelect.prototype.removeSelected = function (clickedItem) {
        var _this = this;
        this.selectedItems && this.selectedItems.forEach(function (item) {
            if (clickedItem[_this.settings.primaryKey] === item[_this.settings.primaryKey]) {
                _this.selectedItems.splice(_this.selectedItems.indexOf(item), 1);
            }
        });
        this.onChangeCallback(this.selectedItems);
        this.onTouchedCallback(this.selectedItems);
    };
    AngularMultiSelect.prototype.toggleDropdown = function (evt) {
        var _this = this;
        if (this.settings.disabled) {
            return false;
        }
        this.isActive = !this.isActive;
        if (this.isActive) {
            if (this.settings.searchAutofocus && this.settings.enableSearchFilter && !this.searchTempl) {
                setTimeout(function () {
                    _this.searchInput.nativeElement.focus();
                }, 0);
            }
            this.onOpen.emit(true);
        }
        else {
            this.onClose.emit(false);
        }
        evt.preventDefault();
    };
    AngularMultiSelect.prototype.closeDropdown = function () {
        if (this.searchInput && this.settings.lazyLoading) {
            this.searchInput.nativeElement.value = "";
            this.data = [];
            this.data = this.cachedItems;
            this.totalHeight = this.itemHeight * this.data.length;
            this.totalRows = this.data.length;
            this.updateView(this.scrollTop);
        }
        if (this.searchInput) {
            this.searchInput.nativeElement.value = "";
        }
        this.filter = "";
        this.isActive = false;
        this.onClose.emit(false);
    };
    AngularMultiSelect.prototype.toggleSelectAll = function () {
        if (!this.isSelectAll) {
            this.selectedItems = [];
            this.selectedItems = this.data.slice();
            this.isSelectAll = true;
            this.onChangeCallback(this.selectedItems);
            this.onTouchedCallback(this.selectedItems);
            this.onSelectAll.emit(this.selectedItems);
        }
        else {
            this.selectedItems = [];
            this.isSelectAll = false;
            this.onChangeCallback(this.selectedItems);
            this.onTouchedCallback(this.selectedItems);
            this.onDeSelectAll.emit(this.selectedItems);
        }
    };
    AngularMultiSelect.prototype.transformData = function (arr, field) {
        var groupedObj = arr.reduce(function (prev, cur) {
            if (!prev[cur[field]]) {
                prev[cur[field]] = [cur];
            }
            else {
                prev[cur[field]].push(cur);
            }
            return prev;
        }, {});
        var tempArr = [];
        Object.keys(groupedObj).map(function (x) {
            tempArr.push({ key: x, value: groupedObj[x] });
        });
        return tempArr;
    };
    AngularMultiSelect.prototype.renderChunk = function (fromPos, howMany) {
        this.chunkArray = [];
        this.chunkIndex = [];
        var finalItem = fromPos + howMany;
        if (finalItem > this.totalRows)
            finalItem = this.totalRows;
        for (var i = fromPos; i < finalItem; i++) {
            this.chunkIndex.push((i * this.itemHeight) + 'px');
            this.chunkArray.push(this.data[i]);
        }
    };
    AngularMultiSelect.prototype.onScroll = function (e) {
        this.scrollTop = e.target.scrollTop;
        this.updateView(this.scrollTop);
    };
    AngularMultiSelect.prototype.updateView = function (scrollTop) {
        var scrollPos = scrollTop ? scrollTop : 0;
        var first = (scrollPos / this.itemHeight) - this.screenItemsLen;
        var firstTemp = "" + first;
        first = parseInt(firstTemp) < 0 ? 0 : parseInt(firstTemp);
        this.renderChunk(first, this.cachedItemsLen);
        this.lastRepaintY = scrollPos;
    };
    AngularMultiSelect.prototype.filterInfiniteList = function (evt) {
        var filteredElems = [];
        this.data = this.cachedItems.slice();
        if (evt.target.value.toString() != '') {
            this.data.filter(function (el) {
                for (var prop in el) {
                    if (el[prop].toString().toLowerCase().indexOf(evt.target.value.toString().toLowerCase()) >= 0) {
                        filteredElems.push(el);
                        break;
                    }
                }
            });
            //this.cachedItems = this.data;
            this.totalHeight = this.itemHeight * filteredElems.length;
            this.totalRows = filteredElems.length;
            this.data = [];
            this.data = filteredElems;
            this.updateView(this.scrollTop);
        }
        else if (evt.target.value.toString() == '' && this.cachedItems.length > 0) {
            this.data = [];
            this.data = this.cachedItems;
            this.totalHeight = this.itemHeight * this.data.length;
            this.totalRows = this.data.length;
            this.updateView(this.scrollTop);
        }
    };
    return AngularMultiSelect;
}());

var AngularMultiSelectModule = /*@__PURE__*/ (function () {
    function AngularMultiSelectModule() {
    }
    return AngularMultiSelectModule;
}());





// CONCATENATED MODULE: ./node_modules/angular2-multiselect-dropdown/menu-item.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_menu_item PURE_IMPORTS_END */


var styles_Item = [];
var RenderType_Item = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_Item, data: {} });

function View_Item_0(_l) { return core["ɵvid"](0, [], null, null); }
function View_Item_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "c-item", [], null, null, null, View_Item_0, RenderType_Item)), core["ɵdid"](1, 49152, null, 1, Item, [], null, null), core["ɵqud"](335544320, 1, { template: 0 })], null, null); }
var ItemNgFactory = /*@__PURE__*/ core["ɵccf"]("c-item", Item, View_Item_Host_0, {}, {}, []);

var styles_Badge = [];
var RenderType_Badge = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_Badge, data: {} });

function View_Badge_0(_l) { return core["ɵvid"](0, [], null, null); }
function View_Badge_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "c-badge", [], null, null, null, View_Badge_0, RenderType_Badge)), core["ɵdid"](1, 49152, null, 1, Badge, [], null, null), core["ɵqud"](335544320, 1, { template: 0 })], null, null); }
var BadgeNgFactory = /*@__PURE__*/ core["ɵccf"]("c-badge", Badge, View_Badge_Host_0, {}, {}, []);

var styles_Search = [];
var RenderType_Search = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_Search, data: {} });

function View_Search_0(_l) { return core["ɵvid"](0, [], null, null); }
function View_Search_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "c-search", [], null, null, null, View_Search_0, RenderType_Search)), core["ɵdid"](1, 49152, null, 1, Search, [], null, null), core["ɵqud"](335544320, 1, { template: 0 })], null, null); }
var SearchNgFactory = /*@__PURE__*/ core["ɵccf"]("c-search", Search, View_Search_Host_0, {}, {}, []);

var styles_TemplateRenderer = [];
var RenderType_TemplateRenderer = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_TemplateRenderer, data: {} });

function View_TemplateRenderer_0(_l) { return core["ɵvid"](0, [], null, null); }
function View_TemplateRenderer_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "c-templateRenderer", [], null, null, null, View_TemplateRenderer_0, RenderType_TemplateRenderer)), core["ɵdid"](1, 245760, null, 0, TemplateRenderer, [core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var TemplateRendererNgFactory = /*@__PURE__*/ core["ɵccf"]("c-templateRenderer", TemplateRenderer, View_TemplateRenderer_Host_0, { data: "data", item: "item" }, {}, []);



// CONCATENATED MODULE: ./node_modules/angular2-multiselect-dropdown/multiselect.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_multiselect.component,_angular_common,_angular_forms,_menu_item.ngfactory,_menu_item,_list_filter,_clickOutside PURE_IMPORTS_END */








var AngularMultiSelectModuleNgFactory = /*@__PURE__*/ core["ɵcmf"](AngularMultiSelectModule, [], function (_l) { return core["ɵmod"]([core["ɵmpd"](512, core["ComponentFactoryResolver"], core["ɵCodegenComponentFactoryResolver"], [[8, []], [3, core["ComponentFactoryResolver"]], core["NgModuleRef"]]), core["ɵmpd"](4608, common["NgLocalization"], common["NgLocaleLocalization"], [core["LOCALE_ID"], [2, common["ɵangular_packages_common_common_a"]]]), core["ɵmpd"](4608, fesm5_forms["ɵangular_packages_forms_forms_i"], fesm5_forms["ɵangular_packages_forms_forms_i"], []), core["ɵmpd"](1073742336, common["CommonModule"], common["CommonModule"], []), core["ɵmpd"](1073742336, fesm5_forms["ɵangular_packages_forms_forms_bb"], fesm5_forms["ɵangular_packages_forms_forms_bb"], []), core["ɵmpd"](1073742336, fesm5_forms["FormsModule"], fesm5_forms["FormsModule"], []), core["ɵmpd"](1073742336, AngularMultiSelectModule, AngularMultiSelectModule, [])]); });

var styles_AngularMultiSelect = [".cuppa-dropdown[_ngcontent-%COMP%]{position:relative}.c-btn[_ngcontent-%COMP%]{display:inline-block;background:#fff;border:1px solid #ccc;border-radius:3px;font-size:14px;color:#333}.c-btn.disabled[_ngcontent-%COMP%]{background:#ccc}.c-btn[_ngcontent-%COMP%]:focus{outline:none}.selected-list[_ngcontent-%COMP%]   .c-list[_ngcontent-%COMP%]{float:left;padding:0px;margin:0px;width:calc(100% - 20px)}.selected-list[_ngcontent-%COMP%]   .c-list[_ngcontent-%COMP%]   .c-token[_ngcontent-%COMP%]{list-style:none;padding:2px 8px;background:#0079FE;color:#fff;border-radius:2px;margin-right:4px;margin-top:2px;float:left;position:relative;padding-right:25px}.selected-list[_ngcontent-%COMP%]   .c-list[_ngcontent-%COMP%]   .c-token[_ngcontent-%COMP%]   .c-label[_ngcontent-%COMP%]{display:block;float:left}.selected-list[_ngcontent-%COMP%]   .c-list[_ngcontent-%COMP%]   .c-token[_ngcontent-%COMP%]   .c-remove[_ngcontent-%COMP%]{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:10px}.selected-list[_ngcontent-%COMP%]   .c-list[_ngcontent-%COMP%]   .c-token[_ngcontent-%COMP%]   .c-remove[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#fff}.selected-list[_ngcontent-%COMP%]   .fa-angle-down[_ngcontent-%COMP%], .selected-list[_ngcontent-%COMP%]   .fa-angle-up[_ngcontent-%COMP%]{font-size:15pt;position:absolute;right:10px;top:50%;transform:translateY(-50%)}.selected-list[_ngcontent-%COMP%]   .c-angle-down[_ngcontent-%COMP%], .selected-list[_ngcontent-%COMP%]   .c-angle-up[_ngcontent-%COMP%]{width:15px;height:15px;position:absolute;right:10px;top:50%;transform:translateY(-50%);pointer-events:none}.selected-list[_ngcontent-%COMP%]   .c-angle-down[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%], .selected-list[_ngcontent-%COMP%]   .c-angle-up[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#333}.selected-list[_ngcontent-%COMP%]   .countplaceholder[_ngcontent-%COMP%]{position:absolute;right:30px;top:50%;transform:translateY(-50%)}.selected-list[_ngcontent-%COMP%]   .c-btn[_ngcontent-%COMP%]{width:100%;box-shadow:0px 1px 5px #959595;padding:10px;cursor:pointer;display:flex;position:relative}.selected-list[_ngcontent-%COMP%]   .c-btn[_ngcontent-%COMP%]   .c-icon[_ngcontent-%COMP%]{position:absolute;right:5px;top:50%;transform:translateY(-50%)}.dropdown-list[_ngcontent-%COMP%]{position:absolute;padding-top:14px;width:100%;z-index:9999}.dropdown-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0px;list-style:none;overflow:auto;margin:0px}.dropdown-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:10px 10px;cursor:pointer;text-align:left}.dropdown-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:first-child{padding-top:10px}.dropdown-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:last-child{padding-bottom:10px}.dropdown-list[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background:#f5f5f5}.dropdown-list[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-scrollbar{width:8px}.dropdown-list[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#cccccc;border-radius:5px}.dropdown-list[_ngcontent-%COMP%]   [_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#f2f2f2}.arrow-up[_ngcontent-%COMP%], .arrow-down[_ngcontent-%COMP%]{width:0;height:0;border-left:13px solid transparent;border-right:13px solid transparent;border-bottom:15px solid #fff;margin-left:15px;position:absolute;top:0}.arrow-down[_ngcontent-%COMP%]{bottom:-14px;top:unset;transform:rotate(180deg)}.arrow-2[_ngcontent-%COMP%]{border-bottom:15px solid #ccc;top:-1px}.arrow-down.arrow-2[_ngcontent-%COMP%]{top:unset;bottom:-16px}.list-area[_ngcontent-%COMP%]{border:1px solid #ccc;border-radius:3px;background:#fff;margin:0px;box-shadow:0px 1px 5px #959595}.select-all[_ngcontent-%COMP%]{padding:10px;border-bottom:1px solid #ccc;text-align:left}.list-filter[_ngcontent-%COMP%]{border-bottom:1px solid #ccc;position:relative;padding-left:35px;height:35px}.list-filter[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border:0px;width:100%;height:100%;padding:0px}.list-filter[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{outline:none}.list-filter[_ngcontent-%COMP%]   .c-search[_ngcontent-%COMP%]{position:absolute;top:9px;left:10px;width:15px;height:15px}.list-filter[_ngcontent-%COMP%]   .c-search[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#888}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]:before, .pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:hover + label[_ngcontent-%COMP%]:before{border-color:#0079FE;background-color:#f2f2f2}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:active + label[_ngcontent-%COMP%]:before{transition-duration:0s}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]{position:relative;padding-left:2em;vertical-align:middle;user-select:none;cursor:pointer;margin:0px;color:#000;font-weight:300}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before{box-sizing:content-box;content:'';color:#0079FE;position:absolute;top:50%;left:0;width:14px;height:14px;margin-top:-9px;border:2px solid #0079FE;text-align:center;transition:all 0.4s ease}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:after{box-sizing:content-box;content:'';background-color:#0079FE;position:absolute;top:50%;left:4px;width:10px;height:10px;margin-top:-5px;transform:scale(0);transform-origin:50%;transition:transform 200ms ease-out}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:disabled + label[_ngcontent-%COMP%]:before{border-color:#cccccc}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:disabled:focus + label[_ngcontent-%COMP%]:before   .pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:disabled:hover + label[_ngcontent-%COMP%]:before{background-color:inherit}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:disabled:checked + label[_ngcontent-%COMP%]:before{background-color:#cccccc}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:after{background-color:transparent;top:50%;left:4px;width:8px;height:3px;margin-top:-4px;border-style:solid;border-color:#ffffff;border-width:0 0 3px 3px;border-image:none;transform:rotate(-45deg) scale(0)}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:after{content:'';transform:rotate(-45deg) scale(1);transition:transform 200ms ease-out}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"radio\"][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:before{background-color:white}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"radio\"][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:after{transform:scale(1)}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"radio\"][_ngcontent-%COMP%] + label[_ngcontent-%COMP%]:before{border-radius:50%}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:before{background:#0079FE}.pure-checkbox[_ngcontent-%COMP%]   input[type=\"checkbox\"][_ngcontent-%COMP%]:checked + label[_ngcontent-%COMP%]:after{transform:rotate(-45deg) scale(1)}.list-message[_ngcontent-%COMP%]{text-align:center;margin:0px;padding:15px 0px;font-size:initial}.list-grp[_ngcontent-%COMP%]{padding:0 15px !important}.list-grp[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{text-transform:capitalize;margin:15px 0px 0px 0px;font-size:14px;font-weight:700}.list-grp[_ngcontent-%COMP%] > li[_ngcontent-%COMP%]{padding-left:15px !important}"];
var RenderType_AngularMultiSelect = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_AngularMultiSelect, data: {} });

function View_AngularMultiSelect_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.text; _ck(_v, 1, 0, currVal_0); }); }
function View_AngularMultiSelect_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit[_co.settings.labelKey]; _ck(_v, 1, 0, currVal_0); }); }
function View_AngularMultiSelect_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "span", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_3)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"], ngForTrackBy: [1, "ngForTrackBy"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedItems; var currVal_1 = _co.trackByFn.bind(_co); _ck(_v, 2, 0, currVal_0, currVal_1); }, null); }
function View_AngularMultiSelect_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [["class", "c-label"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.parent.context.$implicit[_co.settings.labelKey]; _ck(_v, 1, 0, currVal_0); }); }
function View_AngularMultiSelect_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "span", [["class", "c-label"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "c-templateRenderer", [], null, null, null, View_TemplateRenderer_0, RenderType_TemplateRenderer)), core["ɵdid"](2, 245760, null, 0, TemplateRenderer, [core["ViewContainerRef"]], { data: [0, "data"], item: [1, "item"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.badgeTempl; var currVal_1 = _v.parent.context.$implicit; _ck(_v, 2, 0, currVal_0, currVal_1); }, null); }
function View_AngularMultiSelect_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "c-token"]], [[8, "hidden", 0]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_6)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_7)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](5, 0, null, null, 3, "span", [["class", "c-remove"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onItemClick(_v.context.$implicit, _v.context.index, $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, ":svg:svg", [[":xml:space", "preserve"], [":xmlns:xlink", "http://www.w3.org/1999/xlink"], ["height", "100%"], ["id", "Capa_1"], ["style", "enable-background:new 0 0 47.971 47.971;"], ["version", "1.1"], ["viewBox", "0 0 47.971 47.971"], ["width", "100%"], ["x", "0px"], ["xmlns", "http://www.w3.org/2000/svg"], ["y", "0px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, ":svg:g", [], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, ":svg:path", [["d", "M28.228,23.986L47.092,5.122c1.172-1.171,1.172-3.071,0-4.242c-1.172-1.172-3.07-1.172-4.242,0L23.986,19.744L5.121,0.88\n      \t\tc-1.172-1.172-3.07-1.172-4.242,0c-1.172,1.171-1.172,3.071,0,4.242l18.865,18.864L0.879,42.85c-1.172,1.171-1.172,3.071,0,4.242\n      \t\tC1.465,47.677,2.233,47.97,3,47.97s1.535-0.293,2.121-0.879l18.865-18.864L42.85,47.091c0.586,0.586,1.354,0.879,2.121,0.879\n      \t\ts1.535-0.293,2.121-0.879c1.172-1.171,1.172-3.071,0-4.242L28.228,23.986z"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_1 = !_co.badgeTempl; _ck(_v, 2, 0, currVal_1); var currVal_2 = _co.badgeTempl; _ck(_v, 4, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_v.context.index > (_co.settings.badgeShowLimit - 1)); _ck(_v, 0, 0, currVal_0); });
}
function View_AngularMultiSelect_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "c-list"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_5)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"], ngForTrackBy: [1, "ngForTrackBy"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedItems; var currVal_1 = _co.trackByFn.bind(_co); _ck(_v, 2, 0, currVal_0, currVal_1); }, null); }
function View_AngularMultiSelect_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [["class", "countplaceholder"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["+", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (((_co.selectedItems == null) ? null : _co.selectedItems.length) - _co.settings.badgeShowLimit); _ck(_v, 1, 0, currVal_0); }); }
function View_AngularMultiSelect_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "span", [["class", "c-angle-down"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, ":svg:svg", [[":xml:space", "preserve"], [":xmlns:xlink", "http://www.w3.org/1999/xlink"], ["height", "100%"], ["id", "Capa_1"], ["style", "enable-background:new 0 0 612 612;"], ["version", "1.1"], ["viewBox", "0 0 612 612"], ["width", "100%"], ["x", "0px"], ["xmlns", "http://www.w3.org/2000/svg"], ["y", "0px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, ":svg:g", [], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, ":svg:g", [["id", "_x31_0_34_"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, ":svg:g", [], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, ":svg:path", [["d", "M604.501,134.782c-9.999-10.05-26.222-10.05-36.221,0L306.014,422.558L43.721,134.782\n      \t\t\t\tc-9.999-10.05-26.223-10.05-36.222,0s-9.999,26.35,0,36.399l279.103,306.241c5.331,5.357,12.422,7.652,19.386,7.296\n      \t\t\t\tc6.988,0.356,14.055-1.939,19.386-7.296l279.128-306.268C614.5,161.106,614.5,144.832,604.501,134.782z"]], null, null, null, null, null))], null, null); }
function View_AngularMultiSelect_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "span", [["class", "c-angle-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, ":svg:svg", [[":xml:space", "preserve"], [":xmlns:xlink", "http://www.w3.org/1999/xlink"], ["height", "100%"], ["id", "Capa_1"], ["style", "enable-background:new 0 0 612 612;"], ["version", "1.1"], ["viewBox", "0 0 612 612"], ["width", "100%"], ["x", "0px"], ["xmlns", "http://www.w3.org/2000/svg"], ["y", "0px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, ":svg:g", [], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, ":svg:g", [["id", "_x39__30_"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, ":svg:g", [], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, ":svg:path", [["d", "M604.501,440.509L325.398,134.956c-5.331-5.357-12.423-7.627-19.386-7.27c-6.989-0.357-14.056,1.913-19.387,7.27\n      \t\t\t\tL7.499,440.509c-9.999,10.024-9.999,26.298,0,36.323s26.223,10.024,36.222,0l262.293-287.164L568.28,476.832\n      \t\t\t\tc9.999,10.024,26.222,10.024,36.221,0C614.5,466.809,614.5,450.534,604.501,440.509z"]], null, null, null, null, null))], null, null); }
function View_AngularMultiSelect_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "input", [["type", "checkbox"]], [[8, "checked", 0], [8, "disabled", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isSelectAll; var currVal_1 = (_co.settings.limitSelection == ((_co.selectedItems == null) ? null : _co.selectedItems.length)); _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_AngularMultiSelect_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "pure-checkbox select-all"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleSelectAll() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_12)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [], [[8, "hidden", 0]], null, null, null, null)), (_l()(), core["ɵted"](5, null, ["", ""])), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [], [[8, "hidden", 0]], null, null, null, null)), (_l()(), core["ɵted"](7, null, ["", ""]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.showCheckbox; _ck(_v, 2, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.isSelectAll; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.settings.selectAllText; _ck(_v, 5, 0, currVal_2); var currVal_3 = !_co.isSelectAll; _ck(_v, 6, 0, currVal_3); var currVal_4 = _co.settings.unSelectAllText; _ck(_v, 7, 0, currVal_4); });
}
function View_AngularMultiSelect_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, [[1, 0], ["searchInput", 1]], null, 5, "input", [["class", "c-input"], ["type", "text"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 1)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.filter = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](3, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = _co.filter; _ck(_v, 3, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.searchPlaceholderText; var currVal_1 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 5).ngClassValid; var currVal_6 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_AngularMultiSelect_15(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, [[1, 0], ["searchInput", 1]], null, 0, "input", [["class", "c-input"], ["type", "text"]], [[8, "placeholder", 0]], [[null, "keyup"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("keyup" === en)) {
                var pd_0 = (_co.filterInfiniteList($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.searchPlaceholderText; _ck(_v, 0, 0, currVal_0); });
}
function View_AngularMultiSelect_16(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "c-templateRenderer", [], null, null, null, View_TemplateRenderer_0, RenderType_TemplateRenderer)), core["ɵdid"](1, 245760, null, 0, TemplateRenderer, [core["ViewContainerRef"]], { data: [0, "data"], item: [1, "item"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.searchTempl; var currVal_1 = _co.item; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
function View_AngularMultiSelect_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "list-filter"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "span", [["class", "c-search"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 5, ":svg:svg", [[":xml:space", "preserve"], [":xmlns:xlink", "http://www.w3.org/1999/xlink"], ["height", "100%"], ["id", "Capa_1"], ["style", "enable-background:new 0 0 615.52 615.52;"], ["version", "1.1"], ["viewBox", "0 0 615.52 615.52"], ["width", "100%"], ["x", "0px"], ["xmlns", "http://www.w3.org/2000/svg"], ["y", "0px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 4, ":svg:g", [], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, ":svg:g", [], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, ":svg:g", [["id", "Search__x28_and_thou_shall_find_x29_"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, ":svg:g", [], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, ":svg:path", [["d", "M602.531,549.736l-184.31-185.368c26.679-37.72,42.528-83.729,42.528-133.548C460.75,103.35,357.997,0,231.258,0\n      \t\t\t\t\tC104.518,0,1.765,103.35,1.765,230.82c0,127.47,102.753,230.82,229.493,230.82c49.53,0,95.271-15.944,132.78-42.777\n      \t\t\t\t\tl184.31,185.366c7.482,7.521,17.292,11.291,27.102,11.291c9.812,0,19.62-3.77,27.083-11.291\n      \t\t\t\t\tC617.496,589.188,617.496,564.777,602.531,549.736z M355.9,319.763l-15.042,21.273L319.7,356.174\n      \t\t\t\t\tc-26.083,18.658-56.667,28.526-88.442,28.526c-84.365,0-152.995-69.035-152.995-153.88c0-84.846,68.63-153.88,152.995-153.88\n      \t\t\t\t\ts152.996,69.034,152.996,153.88C384.271,262.769,374.462,293.526,355.9,319.763z"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_14)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_15)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_16)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (!_co.settings.lazyLoading && !_co.searchTempl); _ck(_v, 9, 0, currVal_0); var currVal_1 = (_co.settings.lazyLoading && !_co.searchTempl); _ck(_v, 11, 0, currVal_1); var currVal_2 = _co.searchTempl; _ck(_v, 13, 0, currVal_2); }, null); }
function View_AngularMultiSelect_20(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "input", [["type", "checkbox"]], [[8, "checked", 0], [8, "disabled", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isSelected(_v.parent.context.$implicit); var currVal_1 = ((_co.settings.limitSelection == ((_co.selectedItems == null) ? null : _co.selectedItems.length)) && !_co.isSelected(_v.parent.context.$implicit)); _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_AngularMultiSelect_19(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "li", [["class", "pure-checkbox"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onItemClick(_v.context.$implicit, _v.context.index, $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_20)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 0, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 16777216, null, null, 1, "c-templateRenderer", [], null, null, null, View_TemplateRenderer_0, RenderType_TemplateRenderer)), core["ɵdid"](5, 245760, null, 0, TemplateRenderer, [core["ViewContainerRef"]], { data: [0, "data"], item: [1, "item"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.showCheckbox; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.itemTempl; var currVal_2 = _v.context.$implicit; _ck(_v, 5, 0, currVal_1, currVal_2); }, null);
}
function View_AngularMultiSelect_18(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "span", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_AngularMultiSelect_19)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), core["ɵpid"](0, ListFilterPipe, [])], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_co.data, _co.filter, _co.settings.searchBy)); _ck(_v, 2, 0, currVal_0); }, null); }
function View_AngularMultiSelect_23(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "input", [["type", "checkbox"]], [[8, "checked", 0], [8, "disabled", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isSelected(_v.parent.context.$implicit); var currVal_1 = ((_co.settings.limitSelection == ((_co.selectedItems == null) ? null : _co.selectedItems.length)) && !_co.isSelected(_v.parent.context.$implicit)); _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_AngularMultiSelect_22(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "li", [["class", "pure-checkbox"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onItemClick(_v.context.$implicit, _v.context.index, $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_23)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.showCheckbox; _ck(_v, 2, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _v.context.$implicit[_co.settings.labelKey]; _ck(_v, 4, 0, currVal_1); });
}
function View_AngularMultiSelect_21(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "span", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_AngularMultiSelect_22)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), core["ɵpid"](0, ListFilterPipe, [])], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_co.data, _co.filter, _co.settings.searchBy)); _ck(_v, 2, 0, currVal_0); }, null); }
function View_AngularMultiSelect_26(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "input", [["type", "checkbox"]], [[8, "checked", 0], [8, "disabled", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isSelected(_v.parent.context.$implicit); var currVal_1 = ((_co.settings.limitSelection == ((_co.selectedItems == null) ? null : _co.selectedItems.length)) && !_co.isSelected(_v.parent.context.$implicit)); _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_AngularMultiSelect_25(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "li", [["class", "pure-checkbox"], ["style", "position: absolute;width: 100%;"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onItemClick(_v.context.$implicit, _v.context.index, $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 606208, null, 0, styleDirective, [core["ElementRef"]], { styleVal: [0, "styleVal"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_26)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, ["", ""]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.chunkIndex[_v.context.index]; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.settings.showCheckbox; _ck(_v, 3, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = _v.context.$implicit[_co.settings.labelKey]; _ck(_v, 5, 0, currVal_2); });
}
function View_AngularMultiSelect_24(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "span", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["style", "position: relative;"]], null, null, null, null, null)), core["ɵdid"](2, 278528, null, 0, common["NgStyle"], [core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngStyle: [0, "ngStyle"] }, null), core["ɵpod"](3, { "height": 0 }), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_AngularMultiSelect_25)), core["ɵdid"](5, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), core["ɵpid"](0, ListFilterPipe, [])], function (_ck, _v) { var _co = _v.component; var currVal_0 = _ck(_v, 3, 0, (_co.totalHeight + "px")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform(_co.chunkArray, _co.filter, _co.settings.searchBy)); _ck(_v, 5, 0, currVal_1); }, null); }
function View_AngularMultiSelect_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "ul", [["class", "lazyContainer"]], [[4, "maxHeight", null]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_18)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_21)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_24)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.itemTempl; _ck(_v, 2, 0, currVal_1); var currVal_2 = (!_co.itemTempl && !_co.settings.lazyLoading); _ck(_v, 4, 0, currVal_2); var currVal_3 = (!_co.itemTempl && _co.settings.lazyLoading); _ck(_v, 6, 0, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.settings.maxHeight + "px"); _ck(_v, 0, 0, currVal_0); }); }
function View_AngularMultiSelect_29(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h4", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.key; _ck(_v, 1, 0, currVal_0); }); }
function View_AngularMultiSelect_32(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "input", [["type", "checkbox"]], [[8, "checked", 0], [8, "disabled", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isSelected(_v.parent.context.$implicit); var currVal_1 = ((_co.settings.limitSelection == ((_co.selectedItems == null) ? null : _co.selectedItems.length)) && !_co.isSelected(_v.parent.context.$implicit)); _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_AngularMultiSelect_31(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "li", [["class", "pure-checkbox"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onItemClick(_v.context.$implicit, _v.context.index, $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_32)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 0, "label", [], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 16777216, null, null, 1, "c-templateRenderer", [], null, null, null, View_TemplateRenderer_0, RenderType_TemplateRenderer)), core["ɵdid"](5, 245760, null, 0, TemplateRenderer, [core["ViewContainerRef"]], { data: [0, "data"], item: [1, "item"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.showCheckbox; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.itemTempl; var currVal_2 = _v.context.$implicit; _ck(_v, 5, 0, currVal_1, currVal_2); }, null);
}
function View_AngularMultiSelect_30(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "span", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_AngularMultiSelect_31)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), core["ɵpid"](0, ListFilterPipe, [])], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_v.parent.context.$implicit.value, _co.filter, _co.settings.searchBy)); _ck(_v, 2, 0, currVal_0); }, null); }
function View_AngularMultiSelect_35(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "input", [["type", "checkbox"]], [[8, "checked", 0], [8, "disabled", 0]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isSelected(_v.parent.context.$implicit); var currVal_1 = ((_co.settings.limitSelection == ((_co.selectedItems == null) ? null : _co.selectedItems.length)) && !_co.isSelected(_v.parent.context.$implicit)); _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_AngularMultiSelect_34(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "li", [["class", "pure-checkbox"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onItemClick(_v.context.$implicit, _v.context.index, $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_35)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.showCheckbox; _ck(_v, 2, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _v.context.$implicit[_co.settings.labelKey]; _ck(_v, 4, 0, currVal_1); });
}
function View_AngularMultiSelect_33(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "span", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_AngularMultiSelect_34)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), core["ɵpid"](0, ListFilterPipe, [])], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_v.parent.context.$implicit.value, _co.filter, _co.settings.searchBy)); _ck(_v, 2, 0, currVal_0); }, null); }
function View_AngularMultiSelect_28(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "ul", [["class", "list-grp"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_AngularMultiSelect_29)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), core["ɵpid"](0, ListFilterPipe, []), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_30)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_33)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_v.context.$implicit.value, _co.filter, _co.settings.searchBy)).length > 0); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.itemTempl; _ck(_v, 5, 0, currVal_1); var currVal_2 = !_co.itemTempl; _ck(_v, 7, 0, currVal_2); }, null); }
function View_AngularMultiSelect_27(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["style", "overflow: auto;"]], [[4, "maxHeight", null]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_28)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.groupedData; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.settings.maxHeight + "px"); _ck(_v, 0, 0, currVal_0); }); }
function View_AngularMultiSelect_36(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "list-message"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.settings.noDataLabel; _ck(_v, 1, 0, currVal_0); }); }
function View_AngularMultiSelect_0(_l) {
    return core["ɵvid"](0, [core["ɵqud"](671088640, 1, { searchInput: 0 }), core["ɵqud"](402653184, 2, { selectedListElem: 0 }), (_l()(), core["ɵeld"](2, 0, null, null, 38, "div", [["class", "cuppa-dropdown"]], null, [[null, "clickOutside"], ["document", "click"], ["document", "touchstart"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("document:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 3).onClick($event, $event.target) !== false);
                ad = (pd_0 && ad);
            }
            if (("document:touchstart" === en)) {
                var pd_1 = (core["ɵnov"](_v, 3).onClick($event, $event.target) !== false);
                ad = (pd_1 && ad);
            }
            if (("clickOutside" === en)) {
                var pd_2 = (_co.closeDropdown() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](3, 16384, null, 0, clickOutside_ClickOutsideDirective, [core["ElementRef"]], null, { clickOutside: "clickOutside" }), (_l()(), core["ɵeld"](4, 0, [[2, 0], ["selectedList", 1]], null, 15, "div", [["class", "selected-list"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 14, "div", [["class", "c-btn"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleDropdown($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵpod"](7, { "disabled": 0 }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_1)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_2)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_4)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_8)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_9)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_10)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 20, "div", [["class", "dropdown-list"]], [[8, "hidden", 0]], null, null, null, null)), core["ɵdid"](21, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵpod"](22, { "dropdown-list-top": 0 }), core["ɵdid"](23, 606208, null, 0, setPosition, [core["ElementRef"]], { height: [0, "height"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 2, "div", [["class", "arrow-2"]], null, null, null, null, null)), core["ɵdid"](25, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵpod"](26, { "arrow-up": 0, "arrow-down": 1 }), (_l()(), core["ɵeld"](27, 0, null, null, 2, "div", [], null, null, null, null, null)), core["ɵdid"](28, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngClass: [0, "ngClass"] }, null), core["ɵpod"](29, { "arrow-up": 0, "arrow-down": 1 }), (_l()(), core["ɵeld"](30, 0, null, null, 10, "div", [["class", "list-area"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_11)), core["ɵdid"](32, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_13)), core["ɵdid"](34, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_17)), core["ɵdid"](36, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_27)), core["ɵdid"](38, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AngularMultiSelect_36)), core["ɵdid"](40, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "c-btn"; var currVal_1 = _ck(_v, 7, 0, _co.settings.disabled); _ck(_v, 6, 0, currVal_0, currVal_1); var currVal_2 = (((_co.selectedItems == null) ? null : _co.selectedItems.length) == 0); _ck(_v, 9, 0, currVal_2); var currVal_3 = _co.settings.singleSelection; _ck(_v, 11, 0, currVal_3); var currVal_4 = ((((_co.selectedItems == null) ? null : _co.selectedItems.length) > 0) && !_co.settings.singleSelection); _ck(_v, 13, 0, currVal_4); var currVal_5 = (((_co.selectedItems == null) ? null : _co.selectedItems.length) > _co.settings.badgeShowLimit); _ck(_v, 15, 0, currVal_5); var currVal_6 = !_co.isActive; _ck(_v, 17, 0, currVal_6); var currVal_7 = _co.isActive; _ck(_v, 19, 0, currVal_7); var currVal_9 = "dropdown-list"; var currVal_10 = _ck(_v, 22, 0, (_co.settings.position == "top")); _ck(_v, 21, 0, currVal_9, currVal_10); var currVal_11 = ((_co.selectedListHeight == null) ? null : _co.selectedListHeight.val); _ck(_v, 23, 0, currVal_11); var currVal_12 = "arrow-2"; var currVal_13 = _ck(_v, 26, 0, (_co.settings.position == "bottom"), (_co.settings.position == "top")); _ck(_v, 25, 0, currVal_12, currVal_13); var currVal_14 = _ck(_v, 29, 0, (_co.settings.position == "bottom"), (_co.settings.position == "top")); _ck(_v, 28, 0, currVal_14); var currVal_15 = ((_co.settings.enableCheckAll && !_co.settings.singleSelection) && !_co.settings.limitSelection); _ck(_v, 32, 0, currVal_15); var currVal_16 = _co.settings.enableSearchFilter; _ck(_v, 34, 0, currVal_16); var currVal_17 = !_co.settings.groupBy; _ck(_v, 36, 0, currVal_17); var currVal_18 = _co.settings.groupBy; _ck(_v, 38, 0, currVal_18); var currVal_19 = (((_co.data == null) ? null : _co.data.length) == 0); _ck(_v, 40, 0, currVal_19); }, function (_ck, _v) { var _co = _v.component; var currVal_8 = !_co.isActive; _ck(_v, 20, 0, currVal_8); });
}
function View_AngularMultiSelect_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "angular2-multiselect", [], [[8, "className", 0]], null, null, View_AngularMultiSelect_0, RenderType_AngularMultiSelect)), core["ɵprd"](5120, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵprd"](5120, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵdid"](3, 13484032, null, 3, multiselect_component_AngularMultiSelect, [core["ElementRef"], core["ChangeDetectorRef"]], null, null), core["ɵqud"](335544320, 1, { itemTempl: 0 }), core["ɵqud"](335544320, 2, { badgeTempl: 0 }), core["ɵqud"](335544320, 3, { searchTempl: 0 })], function (_ck, _v) { _ck(_v, 3, 0); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 3).defaultSettings.classes; _ck(_v, 0, 0, currVal_0); }); }
var AngularMultiSelectNgFactory = /*@__PURE__*/ core["ɵccf"]("angular2-multiselect", multiselect_component_AngularMultiSelect, View_AngularMultiSelect_Host_0, { data: "data", settings: "settings" }, { onSelect: "onSelect", onDeSelect: "onDeSelect", onSelectAll: "onSelectAll", onDeSelectAll: "onDeSelectAll", onOpen: "onOpen", onClose: "onClose" }, []);



// CONCATENATED MODULE: ./node_modules/@ng-bootstrap/ng-bootstrap/timepicker/timepicker.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_angular_forms,_timepicker,_timepicker_config,_ngb_time_adapter PURE_IMPORTS_END */






var styles_NgbTimepicker = ["[_nghost-%COMP%] {\n      font-size: 1rem;\n    }\n\n    .ngb-tp[_ngcontent-%COMP%] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-align: center;\n      align-items: center;\n    }\n\n    .ngb-tp-input-container[_ngcontent-%COMP%] {\n      width: 4em;\n    }\n\n    .ngb-tp-hour[_ngcontent-%COMP%], .ngb-tp-minute[_ngcontent-%COMP%], .ngb-tp-second[_ngcontent-%COMP%], .ngb-tp-meridian[_ngcontent-%COMP%] {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-direction: column;\n      flex-direction: column;\n      -ms-flex-align: center;\n      align-items: center;\n      -ms-flex-pack: distribute;\n      justify-content: space-around;\n    }\n\n    .ngb-tp-spacer[_ngcontent-%COMP%] {\n      width: 1em;\n      text-align: center;\n    }\n\n    .chevron[_ngcontent-%COMP%]::before {\n      border-style: solid;\n      border-width: 0.29em 0.29em 0 0;\n      content: '';\n      display: inline-block;\n      height: 0.69em;\n      left: 0.05em;\n      position: relative;\n      top: 0.15em;\n      transform: rotate(-45deg);\n      -webkit-transform: rotate(-45deg);\n      -ms-transform: rotate(-45deg);\n      vertical-align: middle;\n      width: 0.71em;\n    }\n\n    .chevron.bottom[_ngcontent-%COMP%]:before {\n      top: -.3em;\n      -webkit-transform: rotate(135deg);\n      -ms-transform: rotate(135deg);\n      transform: rotate(135deg);\n    }\n\n    input[_ngcontent-%COMP%] {\n      text-align: center;\n    }"];
var RenderType_NgbTimepicker = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_NgbTimepicker, data: {} });

function View_NgbTimepicker_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-link"], ["type", "button"]], [[8, "disabled", 0], [2, "disabled", null]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeHour(_co.hourStep) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 0, "span", [["class", "chevron"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "span", [["class", "sr-only"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Increment hours"]))], function (_ck, _v) { var _co = _v.component; var currVal_2 = "btn btn-link"; var currVal_3 = _co.setButtonSize(); _ck(_v, 1, 0, currVal_2, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = _co.disabled; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
function View_NgbTimepicker_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-link"], ["type", "button"]], [[8, "disabled", 0], [2, "disabled", null]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeHour((0 - _co.hourStep)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 0, "span", [["class", "chevron bottom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "span", [["class", "sr-only"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Decrement hours"]))], function (_ck, _v) { var _co = _v.component; var currVal_2 = "btn btn-link"; var currVal_3 = _co.setButtonSize(); _ck(_v, 1, 0, currVal_2, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = _co.disabled; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
function View_NgbTimepicker_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-link"], ["type", "button"]], [[8, "disabled", 0], [2, "disabled", null]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeMinute(_co.minuteStep) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 0, "span", [["class", "chevron"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "span", [["class", "sr-only"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Increment minutes"]))], function (_ck, _v) { var _co = _v.component; var currVal_2 = "btn btn-link"; var currVal_3 = _co.setButtonSize(); _ck(_v, 1, 0, currVal_2, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = _co.disabled; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
function View_NgbTimepicker_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-link"], ["type", "button"]], [[8, "disabled", 0], [2, "disabled", null]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeMinute((0 - _co.minuteStep)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 0, "span", [["class", "chevron bottom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "span", [["class", "sr-only"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Decrement minutes"]))], function (_ck, _v) { var _co = _v.component; var currVal_2 = "btn btn-link"; var currVal_3 = _co.setButtonSize(); _ck(_v, 1, 0, currVal_2, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = _co.disabled; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
function View_NgbTimepicker_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "ngb-tp-spacer"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [":"]))], null, null); }
function View_NgbTimepicker_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-link"], ["type", "button"]], [[8, "disabled", 0], [2, "disabled", null]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeSecond(_co.secondStep) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 0, "span", [["class", "chevron"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "span", [["class", "sr-only"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Increment seconds"]))], function (_ck, _v) { var _co = _v.component; var currVal_2 = "btn btn-link"; var currVal_3 = _co.setButtonSize(); _ck(_v, 1, 0, currVal_2, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = _co.disabled; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
function View_NgbTimepicker_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-link"], ["type", "button"]], [[8, "disabled", 0], [2, "disabled", null]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeSecond((0 - _co.secondStep)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 0, "span", [["class", "chevron bottom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "span", [["class", "sr-only"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Decrement seconds"]))], function (_ck, _v) { var _co = _v.component; var currVal_2 = "btn btn-link"; var currVal_3 = _co.setButtonSize(); _ck(_v, 1, 0, currVal_2, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = _co.disabled; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
function View_NgbTimepicker_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "ngb-tp-input-container ngb-tp-second"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_7)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "input", [["aria-label", "Seconds"], ["class", "form-control"], ["maxlength", "2"], ["placeholder", "SS"], ["type", "text"]], [[8, "value", 0], [8, "readOnly", 0], [8, "disabled", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.updateSecond($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_8)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.spinners; _ck(_v, 2, 0, currVal_0); var currVal_4 = "form-control"; var currVal_5 = _co.setFormControlSize(); _ck(_v, 4, 0, currVal_4, currVal_5); var currVal_6 = _co.spinners; _ck(_v, 6, 0, currVal_6); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.formatMinSec(((_co.model == null) ? null : _co.model.second)); var currVal_2 = _co.readonlyInputs; var currVal_3 = _co.disabled; _ck(_v, 3, 0, currVal_1, currVal_2, currVal_3); });
}
function View_NgbTimepicker_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["class", "ngb-tp-spacer"]], null, null, null, null, null))], null, null); }
function View_NgbTimepicker_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, null, null, null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["PM"]))], null, null); }
function View_NgbTimepicker_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵted"](-1, null, ["AM"]))], null, null); }
function View_NgbTimepicker_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "div", [["class", "ngb-tp-meridian"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "button", [["class", "btn btn-outline-primary"], ["type", "button"]], [[8, "disabled", 0], [2, "disabled", null]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleMeridian() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_11)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"], ngIfElse: [1, "ngIfElse"] }, null), (_l()(), core["ɵand"](0, [["am", 2]], null, 0, null, View_NgbTimepicker_12))], function (_ck, _v) { var _co = _v.component; var currVal_2 = "btn btn-outline-primary"; var currVal_3 = _co.setButtonSize(); _ck(_v, 2, 0, currVal_2, currVal_3); var currVal_4 = (((_co.model == null) ? null : _co.model.hour) >= 12); var currVal_5 = core["ɵnov"](_v, 5); _ck(_v, 4, 0, currVal_4, currVal_5); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = _co.disabled; _ck(_v, 1, 0, currVal_0, currVal_1); });
}
function View_NgbTimepicker_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "fieldset", [], [[8, "disabled", 0], [2, "disabled", null]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 24, "div", [["class", "ngb-tp"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "div", [["class", "ngb-tp-input-container ngb-tp-hour"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_1)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](5, 0, null, null, 1, "input", [["aria-label", "Hours"], ["class", "form-control"], ["maxlength", "2"], ["placeholder", "HH"], ["type", "text"]], [[8, "value", 0], [8, "readOnly", 0], [8, "disabled", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.updateHour($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_2)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](9, 0, null, null, 1, "div", [["class", "ngb-tp-spacer"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](11, 0, null, null, 6, "div", [["class", "ngb-tp-input-container ngb-tp-minute"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_3)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 1, "input", [["aria-label", "Minutes"], ["class", "form-control"], ["maxlength", "2"], ["placeholder", "MM"], ["type", "text"]], [[8, "value", 0], [8, "readOnly", 0], [8, "disabled", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.updateMinute($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](15, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_4)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_5)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_6)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_9)), core["ɵdid"](23, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NgbTimepicker_10)), core["ɵdid"](25, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = _co.spinners; _ck(_v, 4, 0, currVal_2); var currVal_6 = "form-control"; var currVal_7 = _co.setFormControlSize(); _ck(_v, 6, 0, currVal_6, currVal_7); var currVal_8 = _co.spinners; _ck(_v, 8, 0, currVal_8); var currVal_9 = _co.spinners; _ck(_v, 13, 0, currVal_9); var currVal_13 = "form-control"; var currVal_14 = _co.setFormControlSize(); _ck(_v, 15, 0, currVal_13, currVal_14); var currVal_15 = _co.spinners; _ck(_v, 17, 0, currVal_15); var currVal_16 = _co.seconds; _ck(_v, 19, 0, currVal_16); var currVal_17 = _co.seconds; _ck(_v, 21, 0, currVal_17); var currVal_18 = _co.meridian; _ck(_v, 23, 0, currVal_18); var currVal_19 = _co.meridian; _ck(_v, 25, 0, currVal_19); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabled; var currVal_1 = _co.disabled; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_3 = _co.formatHour(((_co.model == null) ? null : _co.model.hour)); var currVal_4 = _co.readonlyInputs; var currVal_5 = _co.disabled; _ck(_v, 5, 0, currVal_3, currVal_4, currVal_5); var currVal_10 = _co.formatMinSec(((_co.model == null) ? null : _co.model.minute)); var currVal_11 = _co.readonlyInputs; var currVal_12 = _co.disabled; _ck(_v, 14, 0, currVal_10, currVal_11, currVal_12); });
}
function View_NgbTimepicker_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "ngb-timepicker", [], null, null, null, View_NgbTimepicker_0, RenderType_NgbTimepicker)), core["ɵprd"](5120, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [timepicker_NgbTimepicker]), core["ɵdid"](2, 573440, null, 0, timepicker_NgbTimepicker, [NgbTimepickerConfig, NgbTimeAdapter], null, null)], null, null); }
var NgbTimepickerNgFactory = /*@__PURE__*/ core["ɵccf"]("ngb-timepicker", timepicker_NgbTimepicker, View_NgbTimepicker_Host_0, { meridian: "meridian", spinners: "spinners", seconds: "seconds", hourStep: "hourStep", minuteStep: "minuteStep", secondStep: "secondStep", readonlyInputs: "readonlyInputs", size: "size" }, {}, []);



// EXTERNAL MODULE: ./node_modules/angular-mentions/mention/mention.directive.js
var mention_directive = __webpack_require__("54GR");
var mention_directive_default = /*#__PURE__*/__webpack_require__.n(mention_directive);

// CONCATENATED MODULE: ./src/app/bi/admin/controller/measureEdit.component.ts



var measureEdit_component_MeasureEditComponent = /*@__PURE__*/ (function () {
    function MeasureEditComponent(measureService, toaster, vcr, _sanitizer, ngbDateConv, ngbTimeConv) {
        this.measureService = measureService;
        this.toaster = toaster;
        this._sanitizer = _sanitizer;
        this.ngbDateConv = ngbDateConv;
        this.ngbTimeConv = ngbTimeConv;
        this.isEdit = false;
        this.isStarSchema = false;
        this.triggerSave = new core["EventEmitter"]();
        this.triggerBack = new core["EventEmitter"]();
        this.saveButtonDisable = false;
        this.trgMeasures = [];
        this.trgDimension = [];
        this.trgValues = [];
        this.copyDim = [];
        this.corTrgList = [];
        this.trgType = 'Static';
        this.indicators = [];
        this.measureTargets = [];
        this.datePicker = false;
        this.loader = false;
        this.dataVersionType = '';
        this.uomList = [];
        this.dimLevelMap = new Map();
        this.dimLevelIdMap = new Map();
        this.mentionConfig = {};
        this.filterType = null;
        this.filterValue = [];
        this.dimensionFilterList = [];
        this.levelMap = new Map();
        this.dimFilterSettings = {};
        this.spinner = true;
        this.selectedDimLvlId = [];
        this.timeDimensionMap = new Map();
        this.timeDimensionKey = [];
        // public mentionConfig: any = { triggerChar: '`', labelKey: 'name', mentionSelect: this.getDimensionData.bind(this)}
        this.dataVersionTime = { hour: null, minute: null, second: null };
        this.startDataVersion = { day: null, month: null, year: null };
        this.startDataVersionTime = { hour: null, minute: null, second: null };
        this.targetMeasureList = [];
        this.targetDimensionList = [];
        this.toaster.setViewRef(vcr);
        this.dimFilterSettings = {
            singleSelection: false,
            text: "Select Values",
            // enableSearchFilter: true,
            labelKey: 'name',
            primaryKey: 'name',
            enableCheckAll: false,
            noDataLabel: 'Empty dimension value',
        };
    }
    MeasureEditComponent.prototype.ngOnChanges = function () {
        // if (this.isEdit) {
        // this.getMeasureById();
        // this.loadUom();
        // }
        this.initializer();
    };
    MeasureEditComponent.prototype.initializer = function () {
        var _this = this;
        var self = this;
        this.loadUom().then(function (res) {
            if (self.parent == 'wizard') {
                if (self.isEdit) {
                    _this.getDataFromMeasure();
                }
                self.targetMeasureList.forEach(function (ele) {
                    self.trgMeasures.push(ele.measureData);
                });
                self.setDimensionDataMap();
                self.dimensionFilterList = self.measureData.dimensionFilterList ? self.measureData.dimensionFilterList : [];
                // self.setMentionConfig();
                self.copyDim = self.trgDimension;
                self.loadTargets();
                // self.sortTargets();
            }
            else {
                _this.getMeasureById();
                _this.getDimensionByMesId();
            }
            _this.getTimeDimension();
        });
    };
    MeasureEditComponent.prototype.getDimensionByMesId = function () {
        var self = this;
        var url = BiUrls.DIMENSION + BiUrls.DIMENSION_BY_MEASURES;
        if (self.measureData.id) {
            self.measureService.getDimensionByMeasureId(url, self.measureData.id).then(function (res) {
                if (res == undefined || (res.error != undefined && res.status != true)) {
                    self.toaster.showError('This Measure is not linked to any cube.');
                }
                else if (res.data && res.data.length) {
                    self.targetDimensionList = res.data;
                    self.setDimensionDataMap();
                }
            });
        }
    };
    MeasureEditComponent.prototype.setDimensionDataMap = function () {
        var self = this;
        self.targetDimensionList.forEach(function (dim) {
            var levelMap = new Map;
            // self.trgDimension.push(dim.dimensionData);
            var dimData = self.parent == 'wizard' ? dim.dimensionData : dim;
            var dimId = self.parent == 'wizard' ? +dim.dimensionId : +dim.refId;
            if (!dimData.dimTime) {
                dimData.allDimHierarchyLevel.forEach(function (level) {
                    if (level.field) {
                        self.trgDimension.push(level);
                        self.levelMap.set(+level.id, level);
                        self.dimLevelIdMap.set(level.displayName ? level.displayName : level.field.fieldName, [dimId, +level.id]);
                    }
                });
            }
        });
    };
    MeasureEditComponent.prototype.getDataFromMeasure = function () {
        var self = this;
        self.processDataVersion('edit');
        self.indicators = self.measureData.measureStatusIndicator;
        self.measureTargets = self.measureData.measureTarget;
        if (self.measureTargets != undefined && self.measureTargets.length > 0) {
            self.trgType = self.measureTargets[0].type;
        }
        else {
            self.trgType = 'Static';
        }
        for (var i = 0; i < self.indicators.length; i++) {
            self.indicators[i].code = '#' + this.indicators[i].code;
        }
        self.measureTargets = underscore["sortBy"](self.measureTargets, function (s) {
            return s.targetOrder;
        });
    };
    MeasureEditComponent.prototype.getMeasureById = function () {
        var self = this;
        self.loader = true;
        if (self.measureData.id) {
            self.measureService.getDataById('../' + BiUrls.MEASURE, self.measureData.id).then(function (res) {
                self.isEdit = true;
                self.measureData = res.data;
                // self.dimensionFilterList = self.measureData.dimensionFilterList;
                self.selectedDimLvlId = res.data.dimLevels ? res.data.dimLevels : [];
                self.getDataFromMeasure();
                self.loadMeasureTargets(self.measureData.id);
                self.loadTargets();
            });
        }
        self.loader = false;
    };
    MeasureEditComponent.prototype.loadMeasureTargets = function (measureId) {
        var self = this;
        var url = BiUrls.MEASURE + BiUrls.MEASURES_BY_CUBEMEASURES;
        self.measureService.getDataById(url, measureId).then(function (res) {
            if (res == undefined || (res.error != undefined && res.status != true)) {
                self.toaster.showError('This Measure is not linked to any cube.');
            }
            else {
                res.data = res.data.filter(function (x) { return x.id != +measureId; });
                self.trgMeasures = res.data;
                self.sortTargets();
            }
        });
    };
    MeasureEditComponent.prototype.sortTargets = function () {
        this.trgMeasures.sort(function (obj1, obj2) {
            var str1 = obj1['measureDisplayName'].toLowerCase();
            var str2 = obj2['measureDisplayName'].toLowerCase();
            if (str1 < str2) {
                return -1;
            }
            else if (str1 > str2) {
                return 1;
            }
            else {
                return 0;
            }
        });
    };
    MeasureEditComponent.prototype.loadTargets = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.measureService.getAll(BiUrls.TARGET).then(function (res) {
                self.corTrgList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    };
    MeasureEditComponent.prototype.onDateChange = function (event) {
        this.measureData.dataVersion = event.target.value;
        this.datePicker = false;
    };
    MeasureEditComponent.prototype.removeSelectedDate = function (event) {
        this.datePicker = true;
    };
    MeasureEditComponent.prototype.addIndicators = function () {
        var obj = { id: null, name: '', value: null, code: '#000000', measureId: null, deleted: 0 };
        if (this.isEdit) {
            obj.measureId = this.measureData.id;
        }
        this.indicators.push((obj));
    };
    MeasureEditComponent.prototype.onSelectColor = function (event, str) {
        if (str == 'indicator') {
            for (var _i = 0, _a = this.indicators; _i < _a.length; _i++) {
                var indicator = _a[_i];
                if (event.target.id == this.indicators.indexOf(indicator)) {
                    indicator.code = event.target.value;
                }
            }
        }
        else if (str == 'target') {
            for (var _b = 0, _c = this.measureTargets; _b < _c.length; _b++) {
                var target = _c[_b];
                if (event.target.id == this.measureTargets.indexOf(target)) {
                    target.color = event.target.value;
                }
            }
        }
        return;
    };
    MeasureEditComponent.prototype.onIndicatorDelete = function (event, indicator) {
        var r = confirm('Are you sure you want to remove the indicator ' + indicator.name + ' ?');
        if (r == true) {
            this.toaster.showSuccess('Indicator removed successfully');
            this.indicators.splice(event.target.id, 1);
        }
    };
    MeasureEditComponent.prototype.addTarget = function () {
        var self = this;
        var obj = {
            id: null, measureId: null, name: '', trgMeasureId: null, type: self.trgType, value: null,
            corTargetId: null, targetOrder: null, color: null, deleted: 0
        };
        if (self.isEdit) {
            obj.measureId = self.measureData.id;
        }
        self.measureTargets.push(obj);
    };
    MeasureEditComponent.prototype.onSelectTrgType = function (event) {
        var self = this;
        var oldValue = self.trgType;
        self.trgType = event.target.value;
        if (self.measureTargets.length > 0) {
            var decision = confirm('Are you sure you want to change Target-Type ?' +
                '( All Previous Target data will be lost )');
            if (decision == true) {
                self.measureTargets = [];
            }
            else {
                self.trgType = oldValue;
            }
        }
    };
    MeasureEditComponent.prototype.onSelectTarget = function (event, trgInd) {
        this.measureTargets[trgInd]['corTargetId'] = event.target.value != "None" ? Number(event.target.value) : null;
    };
    MeasureEditComponent.prototype.onSelectTrgMeasure = function (event, trgInd) {
        this.measureTargets[trgInd]['trgMeasureId'] = event.target.value != "None" ? Number(event.target.value) : null;
    };
    MeasureEditComponent.prototype.onTargetDelete = function (event, measureTarget) {
        var r = confirm('Are you sure you want to remove this target ' +
            measureTarget.name + ' ?');
        if (r == true) {
            this.toaster.showSuccess('Linking of Target removed successfully');
            var index = this.measureTargets.indexOf(measureTarget);
            this.measureTargets.splice(index, 1);
        }
    };
    MeasureEditComponent.prototype.save = function () {
        var self = this;
        self.processDataVersion('save');
        var validate = this.validator();
        this.saveButtonDisable = true;
        if (validate != '') {
            this.toaster.showError(validate);
            this.saveButtonDisable = false;
        }
        else {
            if (this.measureData.rollup) {
                this.measureData.dimLevels = this.selectedDimLvlId;
            }
            else {
                this.measureData.dimLevels = [];
                this.measureData.aggType = null;
            }
            this.saveButtonDisable = false;
            if (this.parent == 'wizard') {
                this.triggerSave.emit(this.measureData);
            }
            else {
                this.saveCall();
            }
        }
    };
    MeasureEditComponent.prototype.validator = function () {
        if (this.measureData.name == undefined || this.measureData.name.trim() == '') {
            return 'Please enter the name for measure';
        }
        if (this.measureData.measureDisplayName == undefined
            || this.measureData.measureDisplayName.trim() == '') {
            return 'Please enter the display name for measure';
        }
        if (this.formulaMeasure && (this.measureData.formulaExpression == undefined
            || this.measureData.formulaExpression.trim() == '')) {
            return 'Please enter the Formula Expression for measure';
        }
        if (this.measureData.rollup && (this.measureData.aggType == undefined
            || this.measureData.aggType.trim() == '')) {
            return 'Please select the aggregation type for Roll Up';
        }
        if (this.measureData.rollup && !this.selectedDimLvlId.length) {
            return 'Please select the dimension for Roll Up';
        }
        var msg = this.dateValidator();
        if (msg != '') {
            return msg;
        }
        msg = this.indicatorValidator();
        if (msg != '') {
            return msg;
        }
        msg = this.targetValidator();
        if (msg != '') {
            return msg;
        }
        msg = this.dimFilterValidator();
        if (msg != '') {
            return msg;
        }
        this.setMeasure();
        return '';
    };
    MeasureEditComponent.prototype.dateValidator = function () {
        var self = this;
        if (this.startDataVersion && this.dataVersionDate) {
            var startDateMillisecond = (new Date(self.startDataVersion.year + "-" +
                self.startDataVersion.month + "-" + self.startDataVersion.day + " " +
                (self.startDataVersionTime ? self.startDataVersionTime.hour : 0) + ":" + (self.startDataVersionTime ? self.startDataVersionTime.minute : 0)).getTime());
            var endDateMillisecond = (new Date(self.dataVersionDate.year + "-" +
                self.dataVersionDate.month + "-" + self.dataVersionDate.day + " " +
                (self.dataVersionTime ? self.dataVersionTime.hour : 0) + ":" + (self.dataVersionTime ? self.dataVersionTime.minute : 0)).getTime());
            if (startDateMillisecond > endDateMillisecond) {
                return 'Start-Date cannot be greater than End-Date !';
            }
        }
        return '';
    };
    MeasureEditComponent.prototype.indicatorValidator = function () {
        for (var _i = 0, _a = this.indicators; _i < _a.length; _i++) {
            var indicator = _a[_i];
            if (indicator.name == undefined || indicator.name.trim() == '') {
                return 'Please enter details for the indicators';
            }
            if (indicator.value == null) {
                return 'Please enter details for the indicators';
            }
            if (!(/^#[A-Fa-f0-9]{6}$/i.test(indicator.code))) {
                return 'Please enter valid hexadecimal value for indicator color';
            }
        }
        return '';
    };
    MeasureEditComponent.prototype.targetValidator = function () {
        var _this = this;
        this.measureTargets.forEach(function (mt, i) {
            if (mt.name == '') {
                return 'Target Name is required';
            }
            if (_this.trgType == 'Static') {
                if (mt.value == null) {
                    return 'Please Enter Target Value';
                }
                mt.value = mt.value.toString();
            }
            if (_this.trgType == 'Dynamic') {
                if (mt.trgMeasureId == null) {
                    return 'Please Select the target-measure';
                }
            }
            if (_this.trgType == 'Core') {
                if (mt.corTargetId == null) {
                    return 'Please Select the Cor-Target';
                }
            }
            _this.measureTargets[i].targetOrder = i;
        });
        if (this.trgType == 'Dynamic') {
            var trgMeaIdList = this.measureTargets.map(function (mt) { return mt.trgMeasureId; });
            if (this.hasDuplicates(trgMeaIdList)) {
                return 'Attached target-measures should not be repeated !!!';
            }
        }
        if (this.trgType == 'Core') {
            var trgIdList = this.measureTargets.map(function (mt) { return mt.corTargetId; });
            if (this.hasDuplicates(trgIdList)) {
                return 'Attached targets should not be repeated !!!';
            }
        }
        return '';
    };
    MeasureEditComponent.prototype.setMeasure = function () {
        for (var _i = 0, _a = this.indicators; _i < _a.length; _i++) {
            var indicator = _a[_i];
            indicator.code = indicator.code.slice(1);
        }
        this.measureData.measureStatusIndicator = this.indicators;
        this.measureData.measureTarget = this.measureTargets;
    };
    MeasureEditComponent.prototype.hasDuplicates = function (array) {
        return (new Set(array)).size !== array.length;
    };
    MeasureEditComponent.prototype.onBack = function () {
        this.triggerBack.emit();
    };
    MeasureEditComponent.prototype.saveCall = function () {
        var self = this;
        if (self.isEdit) {
            self.measureService.update(BiUrls.MEASURE, self.measureData).then(function (res) {
                res['type'] = 'edit';
                self.triggerSave.emit(res);
            });
        }
        else {
            self.measureService.save(BiUrls.MEASURE, self.measureData).then(function (res) {
                res['type'] = 'new';
                self.triggerSave.emit(res);
            });
        }
        self.setPageFieldSAfterLoading();
    };
    MeasureEditComponent.prototype.setPageFieldSAfterLoading = function () {
        var self = this;
        self.saveButtonDisable = false;
        self.indicators = [];
        self.target = false;
    };
    MeasureEditComponent.prototype.loadUom = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.measureService.onStartUp(BiUrls.UOM).then(function (res) {
                self.uomList = res != undefined && res.data != undefined ? res.data : [];
            });
            resolve('completed');
        });
    };
    MeasureEditComponent.prototype.onSelectUom = function (event) {
        if ((typeof event.target.value != 'string') && (event.target.value != 'none')) {
            this.measureData.uomId = null;
        }
        else {
            var id = Number.parseInt(event.target.value);
            if (typeof id == 'number') {
                this.measureData.uomId = id;
                for (var _i = 0, _a = this.uomList; _i < _a.length; _i++) {
                    var x = _a[_i];
                    if (id == x.id) {
                        this.measureData['uomId'] = x.id;
                    }
                }
            }
        }
    };
    MeasureEditComponent.prototype.processDataVersion = function (action) {
        var self = this;
        if (action == 'save') {
            // let date = Date.parse(self.ngbDateConv.toModel(self.dataVersionDate));
            self.measureData.dataVersionType = self.dataVersionType;
            self.measureData["startDataVersion"] = self.startDataVersion && self.startDataVersion.day ? Date.parse(self.ngbDateConv.toModel(self.startDataVersion)) : null;
            self.measureData["startDataVersionTime"] = self.startDataVersionTime ? self.ngbTimeConv.toModel(self.startDataVersionTime) : null;
            if (self.measureData.dataVersionType == 'Static') {
                self.measureData["dataVersion"] = self.dataVersionDate && self.dataVersionDate.day ? Date.parse(self.ngbDateConv.toModel(self.dataVersionDate)) : null;
                self.measureData["dataVersionTime"] = self.dataVersionTime ? self.ngbTimeConv.toModel(self.dataVersionTime) : null;
            }
            else {
                self.measureData["dataVersion"] = null;
                delete self.measureData["dataVersionTime"];
            }
        }
        else {
            if (self.measureData.dataVersionType != undefined && self.measureData.dataVersionType == 'Static' && self.measureData.dataVersion) {
                self.dataVersionType = 'Static';
                var dateTime = new Date(self.measureData.dataVersion);
                var dvDate = dateTime.getUTCDate() + '-' + (dateTime.getUTCMonth() + 1) + '-' + dateTime.getUTCFullYear();
                self.dataVersionDate = self.ngbDateConv.fromModel(dvDate);
                var endDvTime = self.ngbTimeConv.fromModel(dateTime.getUTCHours() + ":" + dateTime.getUTCMinutes() + ":" + dateTime.getUTCSeconds());
                if (!!endDvTime.hour || !!endDvTime.minute) {
                    self.dataVersionTime = endDvTime;
                }
                else if (self.measureData["dataVersionTime"]) {
                    self.dataVersionTime = self.ngbTimeConv.fromModel(self.measureData["dataVersionTime"]);
                }
            }
            else {
                self.dataVersionType = 'Dynamic';
            }
            if (self.measureData.startDataVersion) {
                var startDate = new Date(self.measureData.startDataVersion);
                self.startDataVersion = self.ngbDateConv.fromModel(startDate.getUTCDate() + '-' + (startDate.getUTCMonth() + 1) + '-' + startDate.getUTCFullYear());
                var startDvTime = self.ngbTimeConv.fromModel(startDate.getUTCHours() + ":" + startDate.getUTCMinutes() + ":" + startDate.getUTCSeconds());
                if (!!startDvTime.hour || !!startDvTime.minute) {
                    self.startDataVersionTime = startDvTime;
                }
                else if (self.measureData["startDataVersionTime"]) {
                    self.startDataVersionTime = self.ngbTimeConv.fromModel(self.measureData["startDataVersionTime"]);
                }
                else {
                    self.startDataVersionTime = self.ngbTimeConv.fromModel(0 + ":" + 0 + ":" + 0);
                }
            }
        }
    };
    MeasureEditComponent.prototype.changeDataVersionType = function (event) {
        if (event.target.value == 'Dynamic') {
            this.dataVersionDate = null;
        }
    };
    MeasureEditComponent.prototype.onMentionSelect = function (mention) {
        return '`' + mention.name + '`';
    };
    MeasureEditComponent.prototype.addDimensionFilter = function () {
        var filterDim = this.filterDim;
        if (filterDim && this.filterType && this.filterValue && this.filterValue.length > 0) {
            try {
                var value_1 = [];
                this.filterValue.forEach(function (ele) {
                    value_1.push(ele.name);
                });
                var expression = {
                    'dimensionId': this.dimLevelIdMap.get(filterDim)[0],
                    'dimensionLevelId': this.dimLevelIdMap.get(filterDim)[1], "values": value_1,
                    "deleted": false, "filterType": this.filterType, "measureId": this.measureData.id
                };
                this.dimensionFilterList.push(expression);
                this.measureData.dimensionFilterList = this.dimensionFilterList;
            }
            catch (e) {
                console.log(e);
            }
        }
    };
    MeasureEditComponent.prototype.getDimensionValue = function (dimData, dim) {
        var _this = this;
        var self = this;
        self.spinner = false;
        self.measureService.dimensionData(dimData).then(function (res) {
            if (res && res.response && res.response.data && res.response.data.length) {
                self.trgValues = res.response.data;
                if (dim) {
                    var value_2 = [];
                    _this.trgValues.forEach(function (ele) {
                        dim.values.forEach(function (val) {
                            if (ele.name == val) {
                                value_2.push(ele);
                            }
                        });
                    });
                    _this.filterValue = value_2;
                }
                // self.setMentionConfig('`');
            }
            else {
                self.trgValues = [];
            }
            self.spinner = true;
        });
    };
    MeasureEditComponent.prototype.addfilterDim = function (event) {
        if (event && event != '') {
            var dimName = event;
            // .field.fieldName;
            this.filterDim = dimName;
            var dimData = {
                "dimensionYAxis": [{
                        "dimension": { "id": this.dimLevelIdMap.get(dimName)[0] },
                        "level": { "id": this.dimLevelIdMap.get(dimName)[1] }
                    }]
            };
            this.getDimensionValue(dimData);
        }
        else {
            this.filterDim = null;
        }
        this.getExistingFilter();
    };
    // public dimListFormatter = (data: any): SafeHtml => {
    //     let html = `<span>${data.field.fieldName}</span>`;
    //     return this._sanitizer.bypassSecurityTrustHtml(html);
    // }
    // public dimValueFormatter = (data: any): string => {
    //     let html = `${data.field.fieldName}`;
    //     return html;
    // }
    MeasureEditComponent.prototype.addfilterValue = function (event) {
        var _this = this;
        if (event.name != '') {
            // event = event.name;
            var ind_1 = -1;
            if (this.filterDim && this.dimensionFilterList) {
                var dimensionId_1 = this.dimLevelIdMap.get(this.filterDim)[0];
                var dimLvlId_1 = this.dimLevelIdMap.get(this.filterDim)[1];
                this.dimensionFilterList.forEach(function (dim, i) {
                    if (dim.dimensionId == dimensionId_1 && dim.dimensionLevelId == dimLvlId_1 && dim.filterType == _this.filterType) {
                        ind_1 = i;
                    }
                });
            }
            if (ind_1 != -1) {
                // this.filterValue = [];
                !this.dimensionFilterList[ind_1].values.includes(event.name) ? this.dimensionFilterList[ind_1].values.push(event.name) : null;
            }
            else {
                !this.filterValue.includes(event) ? this.filterValue.push(event) : null;
                this.addDimensionFilter();
            }
        }
    };
    MeasureEditComponent.prototype.OnItemDeSelect = function (event) {
        var _this = this;
        if (this.filterDim) {
            var ind_2 = -1;
            var dimensionId_2 = this.dimLevelIdMap.get(this.filterDim)[0];
            var dimLvlId_2 = this.dimLevelIdMap.get(this.filterDim)[1];
            this.dimensionFilterList.forEach(function (dim, i) {
                if (dim.dimensionId == dimensionId_2 && +dim.dimensionLevelId == +dimLvlId_2 && dim.filterType == _this.filterType) {
                    ind_2 = i;
                }
            });
            if (ind_2 != -1) {
                this.dimensionFilterList[ind_2].values.splice(this.dimensionFilterList[ind_2].values.indexOf(event.name), 1);
            }
        }
    };
    MeasureEditComponent.prototype.removeDimFilter = function (event, dim) {
        event.stopPropagation();
        if (dim.hasOwnProperty('id')) {
            this.dimensionFilterList[this.dimensionFilterList.indexOf(dim)].deleted = true;
        }
        else {
            this.dimensionFilterList.splice(this.dimensionFilterList.indexOf(dim), 1);
        }
        this.filterDim = null;
        this.filterType = null;
        this.filterValue = [];
    };
    MeasureEditComponent.prototype.selectDimFilter = function (dim) {
        var val = this.levelMap.get(+dim.dimensionLevelId).displayName ? this.levelMap.get(+dim.dimensionLevelId).displayName : this.levelMap.get(+dim.dimensionLevelId).field.fieldName;
        this.filterDim = val;
        this.filterType = dim.filterType;
        var dimData = {
            "dimensionYAxis": [{
                    "dimension": { "id": this.dimLevelIdMap.get(this.filterDim)[0] },
                    "level": { "id": this.dimLevelIdMap.get(this.filterDim)[1] }
                }]
        };
        this.getDimensionValue(dimData, dim);
    };
    MeasureEditComponent.prototype.reorder = function () {
        for (var k = 0; k < this.measureTargets.length; k++) {
            this.measureTargets[k].targetOrder = k;
        }
    };
    MeasureEditComponent.prototype.dimFilterValidator = function () {
        var msg = '';
        if (this.dimensionFilterList && this.dimensionFilterList.length) {
            for (var _i = 0, _a = this.dimensionFilterList; _i < _a.length; _i++) {
                var filter = _a[_i];
                if (filter.values && !filter.values.length) {
                    msg = 'Please select value for dimension filter!';
                    this.selectDimFilter(filter);
                    break;
                }
            }
        }
        return msg;
    };
    MeasureEditComponent.prototype.getExistingFilter = function () {
        var self = this;
        this.filterValue = [];
        if (self.filterDim && self.filterType) {
            try {
                for (var _i = 0, _a = self.dimensionFilterList; _i < _a.length; _i++) {
                    var filter = _a[_i];
                    var val = self.levelMap.get(+filter.dimensionLevelId).displayName ? self.levelMap.get(+filter.dimensionLevelId).displayName : self.levelMap.get(+filter.dimensionLevelId).field.fieldName;
                    if (self.filterDim == val && self.filterType.toLowerCase() == filter.filterType.toLowerCase()) {
                        self.selectDimFilter(filter);
                        break;
                    }
                }
            }
            catch (e) { }
        }
    };
    MeasureEditComponent.prototype.selectAggDimLevels = function (event) {
        var id = event.target.value;
        if (id && id != '' && !this.selectedDimLvlId.includes(id)) {
            this.selectedDimLvlId.push(id);
        }
    };
    MeasureEditComponent.prototype.removeAggDimLevels = function (dimId) {
        var ind = this.selectedDimLvlId.indexOf(dimId);
        if (ind != -1) {
            this.selectedDimLvlId.splice(ind, 1);
        }
    };
    MeasureEditComponent.prototype.getDimName = function (dimId) {
        var dimData = this.levelMap.get(+dimId);
        if (dimData && dimData.field) {
            return dimData.field.displayName;
        }
    };
    MeasureEditComponent.prototype.getTimeDimension = function () {
        var _this = this;
        var id = this.measureData.id ? this.measureData.id : this.trgMeasures[0] ? this.trgMeasures[0].id : null;
        this.measureService.getTimeDimension([id]).then(function (res) {
            var cubeId = new Map();
            if (res && res.data) {
                res.data.forEach(function (re) {
                    if (!cubeId.has(re.cubeId)) {
                        cubeId.set(re.cubeId, [re]);
                    }
                    else {
                        cubeId.get(re.cubeId).push(re);
                    }
                });
                _this.timeDimensionMap = cubeId;
                _this.timeDimensionKey = Array.from(cubeId.keys());
            }
        });
    };
    MeasureEditComponent.prototype.setTimeFilter = function (dimId, typeCheck) {
        var type = typeCheck ? 'rangeStartDate' : 'rangeEndDate';
        if (dimId) {
            this.measureData[type] = +dimId;
        }
        else {
            this.measureData[type] = null;
        }
    };
    MeasureEditComponent.prototype.setStartDvTime = function (time) {
        this.startDataVersionTime = time;
    };
    MeasureEditComponent.prototype.setDvTime = function (time) {
        this.dataVersionTime = time;
    };
    MeasureEditComponent.prototype.clearStartDate = function () {
        this.startDataVersion = { day: null, month: null, year: null };
        this.startDataVersionTime = { hour: null, minute: null, second: null };
    };
    return MeasureEditComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/common/service/ngbTimeConverter.utils.ts


var ngbTimeConverter_utils_NgbTimeConverter = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](NgbTimeConverter, _super);
    function NgbTimeConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbTimeConverter.prototype.fromModel = function (timeString) {
        if (!timeString) {
            return null;
        }
        var parts = timeString.split(':', 3);
        return {
            hour: parseInt(parts[0], 10),
            minute: parseInt(parts[1], 10),
            second: parseInt(parts[2], 10)
        };
    };
    NgbTimeConverter.prototype.toModel = function (time) {
        if (!time) {
            return null;
        }
        time.hour = (time.hour) ? time.hour : 0;
        time.minute = (time.minute) ? time.minute : 0;
        time.second = (time.second) ? time.second : 0;
        return this.pad(time.hour) + ":" + this.pad(time.minute) + ":" + this.pad(time.second);
    };
    NgbTimeConverter.prototype.pad = function (number) {
        return number < 10 ? "0" + number : number;
    };
    return NgbTimeConverter;
}(NgbTimeAdapter));



// CONCATENATED MODULE: ./src/app/bi/admin/controller/measureEdit.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_.._.._.._.._node_modules_angular2_multiselect_dropdown_multiselect.component.ngfactory,angular2_multiselect_dropdown_multiselect.component,_.._.._.._.._node_modules_angular2_multiselect_dropdown_menu_item.ngfactory,angular2_multiselect_dropdown_menu_item,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_timepicker_timepicker.ngfactory,_ng_bootstrap_ng_bootstrap_timepicker_timepicker,_ng_bootstrap_ng_bootstrap_timepicker_timepicker_config,_ng_bootstrap_ng_bootstrap_timepicker_ngb_time_adapter,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,ng2_dnd_src_sortable.component,ng2_dnd_src_dnd.service,ng2_dnd_src_dnd.config,_loader.component.ngfactory,_loader.component,angular_mentions_mention_mention.directive,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_accordion_accordion.ngfactory,_ng_bootstrap_ng_bootstrap_accordion_accordion,_ng_bootstrap_ng_bootstrap_accordion_accordion_config,_measureEdit.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent,_angular_platform_browser,_.._common_service_ngbDateConverter.utils,_.._common_service_ngbTimeConverter.utils PURE_IMPORTS_END */


































var styles_MeasureEditComponent = [];
var RenderType_MeasureEditComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_MeasureEditComponent, data: {} });

function View_MeasureEditComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Measure "]))], null, null); }
function View_MeasureEditComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Measure - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.measureData.measureCode; _ck(_v, 1, 0, currVal_0); }); }
function View_MeasureEditComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, ["", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.id; var currVal_1 = ((_co.measureData.uomId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_MeasureEditComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"]))], null, null); }
function View_MeasureEditComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [["ng-disabled", "!val.field"]], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_0 = _v.context.$implicit.refId; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit.refId; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = _co.getDimName(_v.context.$implicit.refId); _ck(_v, 3, 0, currVal_2); }); }
function View_MeasureEditComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 52, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 36, "div", [["class", "col-lg-4 col-md-4 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Aggregation Type"])), (_l()(), core["ɵeld"](4, 0, null, null, 33, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.measureData.aggType = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](5, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](7, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](9, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](10, 0, null, null, 3, "option", [["value", ""]], null, null, null, null, null)), core["ɵdid"](11, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](12, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵeld"](14, 0, null, null, 3, "option", [["value", "sum"]], null, null, null, null, null)), core["ɵdid"](15, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](16, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sum"])), (_l()(), core["ɵeld"](18, 0, null, null, 3, "option", [["value", "avg"]], null, null, null, null, null)), core["ɵdid"](19, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](20, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Average"])), (_l()(), core["ɵeld"](22, 0, null, null, 3, "option", [["value", "max"]], null, null, null, null, null)), core["ɵdid"](23, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](24, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Maximum"])), (_l()(), core["ɵeld"](26, 0, null, null, 3, "option", [["value", "min"]], null, null, null, null, null)), core["ɵdid"](27, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](28, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Minimum"])), (_l()(), core["ɵeld"](30, 0, null, null, 3, "option", [["value", "count"]], null, null, null, null, null)), core["ɵdid"](31, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](32, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Count"])), (_l()(), core["ɵeld"](34, 0, null, null, 3, "option", [["value", "distinct-count"]], null, null, null, null, null)), core["ɵdid"](35, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](36, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Distinct-Count"])), (_l()(), core["ɵeld"](38, 0, null, null, 14, "div", [["class", "col-lg-4 col-md-4 float-left pl-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 1, "label", [["for", "measureData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Select Dimension Levels"])), (_l()(), core["ɵeld"](41, 0, null, null, 11, "select", [["class", "form-control light-bg"], ["value", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 42).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 42).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("change" === en)) {
                var pd_2 = (_co.selectAggDimLevels($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](42, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](44, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, null), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](46, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](47, 0, null, null, 3, "option", [["value", ""]], null, null, null, null, null)), core["ɵdid"](48, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](49, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_6)), core["ɵdid"](52, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = (_co.measureData.aggType ? _co.measureData.aggType : ""); _ck(_v, 7, 0, currVal_7); var currVal_8 = ""; _ck(_v, 11, 0, currVal_8); var currVal_9 = ""; _ck(_v, 12, 0, currVal_9); var currVal_10 = "sum"; _ck(_v, 15, 0, currVal_10); var currVal_11 = "sum"; _ck(_v, 16, 0, currVal_11); var currVal_12 = "avg"; _ck(_v, 19, 0, currVal_12); var currVal_13 = "avg"; _ck(_v, 20, 0, currVal_13); var currVal_14 = "max"; _ck(_v, 23, 0, currVal_14); var currVal_15 = "max"; _ck(_v, 24, 0, currVal_15); var currVal_16 = "min"; _ck(_v, 27, 0, currVal_16); var currVal_17 = "min"; _ck(_v, 28, 0, currVal_17); var currVal_18 = "count"; _ck(_v, 31, 0, currVal_18); var currVal_19 = "count"; _ck(_v, 32, 0, currVal_19); var currVal_20 = "distinct-count"; _ck(_v, 35, 0, currVal_20); var currVal_21 = "distinct-count"; _ck(_v, 36, 0, currVal_21); var currVal_29 = ""; _ck(_v, 44, 0, currVal_29); var currVal_30 = ""; _ck(_v, 48, 0, currVal_30); var currVal_31 = ""; _ck(_v, 49, 0, currVal_31); var currVal_32 = _co.trgDimension; _ck(_v, 52, 0, currVal_32); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 9).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 9).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 9).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 9).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 9).ngClassValid; var currVal_5 = core["ɵnov"](_v, 9).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 9).ngClassPending; _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_22 = core["ɵnov"](_v, 46).ngClassUntouched; var currVal_23 = core["ɵnov"](_v, 46).ngClassTouched; var currVal_24 = core["ɵnov"](_v, 46).ngClassPristine; var currVal_25 = core["ɵnov"](_v, 46).ngClassDirty; var currVal_26 = core["ɵnov"](_v, 46).ngClassValid; var currVal_27 = core["ɵnov"](_v, 46).ngClassInvalid; var currVal_28 = core["ɵnov"](_v, 46).ngClassPending; _ck(_v, 41, 0, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28); });
}
function View_MeasureEditComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "card-body"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), (_l()(), core["ɵted"](-1, null, ["\u00A0 "])), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, "i", [["class", "fa fa-times"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeAggDimLevels(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.getDimName(_v.context.$implicit); _ck(_v, 2, 0, currVal_0); });
}
function View_MeasureEditComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "label", [["for", "measureData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Selected Dimension Levels"])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_8)), core["ɵdid"](6, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedDimLvlId; _ck(_v, 6, 0, currVal_0); }, null); }
function View_MeasureEditComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [["ng-disabled", "!val.field"], ["ng-selected", "(val.displayName ? val.displayName : val.field.fieldName) == filterDim"], ["ng-value", "val"]], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = (_v.context.$implicit.displayName ? _v.context.$implicit.displayName : (_v.context.$implicit.field ? _v.context.$implicit.field.displayName : "")); _ck(_v, 3, 0, currVal_0); }); }
function View_MeasureEditComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "span", [], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](0, common["SlicePipe"], []), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = _v.parent.context.item.name; _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = (core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_v.parent.context.item.name, 0, 20)) + ".."); _ck(_v, 2, 0, currVal_1); }); }
function View_MeasureEditComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.item.name; _ck(_v, 1, 0, currVal_0); }); }
function View_MeasureEditComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, [[4, 2]], null, 1, null, View_MeasureEditComponent_12)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, [[4, 2]], null, 1, null, View_MeasureEditComponent_13)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = (_v.context.item.name.length > 20); _ck(_v, 2, 0, currVal_0); var currVal_1 = (_v.context.item.name.length <= 20); _ck(_v, 4, 0, currVal_1); }, null); }
function View_MeasureEditComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "span", [], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](0, common["SlicePipe"], []), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = _v.parent.context.item.name; _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = (core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_v.parent.context.item.name, 0, 20)) + ".."); _ck(_v, 2, 0, currVal_1); }); }
function View_MeasureEditComponent_16(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.item.name; _ck(_v, 1, 0, currVal_0); }); }
function View_MeasureEditComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, [[5, 2]], null, 1, null, View_MeasureEditComponent_15)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, [[5, 2]], null, 1, null, View_MeasureEditComponent_16)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = (_v.context.item.name.length > 20); _ck(_v, 2, 0, currVal_0); var currVal_1 = (_v.context.item.name.length <= 20); _ck(_v, 4, 0, currVal_1); }, null); }
function View_MeasureEditComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "angular2-multiselect", [], [[8, "className", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "onSelect"], [null, "onDeSelect"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("onSelect" === en)) {
                var pd_0 = (_co.addfilterValue($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("onDeSelect" === en)) {
                var pd_1 = (_co.OnItemDeSelect($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_AngularMultiSelect_0, RenderType_AngularMultiSelect)), core["ɵdid"](1, 13484032, null, 3, multiselect_component_AngularMultiSelect, [core["ElementRef"], core["ChangeDetectorRef"]], { data: [0, "data"], settings: [1, "settings"] }, { onSelect: "onSelect", onDeSelect: "onDeSelect" }), core["ɵqud"](335544320, 1, { itemTempl: 0 }), core["ɵqud"](335544320, 2, { badgeTempl: 0 }), core["ɵqud"](335544320, 3, { searchTempl: 0 }), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵdid"](7, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, null), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](9, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](10, 0, null, null, 3, "c-item", [], null, null, null, View_Item_0, RenderType_Item)), core["ɵdid"](11, 49152, [[1, 4]], 1, Item, [], null, null), core["ɵqud"](603979776, 4, { template: 0 }), (_l()(), core["ɵand"](0, [[4, 2]], null, 0, null, View_MeasureEditComponent_11)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "c-badge", [], null, null, null, View_Badge_0, RenderType_Badge)), core["ɵdid"](15, 49152, [[2, 4]], 1, Badge, [], null, null), core["ɵqud"](603979776, 5, { template: 0 }), (_l()(), core["ɵand"](0, [[5, 2]], null, 0, null, View_MeasureEditComponent_14))], function (_ck, _v) { var _co = _v.component; var currVal_8 = _co.trgValues; var currVal_9 = _co.dimFilterSettings; _ck(_v, 1, 0, currVal_8, currVal_9); var currVal_10 = _co.filterValue; _ck(_v, 7, 0, currVal_10); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 1).defaultSettings.classes; var currVal_1 = core["ɵnov"](_v, 9).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 9).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 9).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 9).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 9).ngClassValid; var currVal_6 = core["ɵnov"](_v, 9).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 9).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_MeasureEditComponent_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin"]], null, null, null, null, null))], null, null); }
function View_MeasureEditComponent_22(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "span", [], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](0, common["SlicePipe"], []), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit; _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = (core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_v.parent.context.$implicit, 0, 20)) + ".."); _ck(_v, 2, 0, currVal_1); }); }
function View_MeasureEditComponent_23(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "span", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit; _ck(_v, 1, 0, currVal_0); }); }
function View_MeasureEditComponent_21(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_22)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_23)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵted"](-1, null, ["\u00A0\u00A0 "]))], function (_ck, _v) { var currVal_0 = (_v.context.$implicit.length > 20); _ck(_v, 2, 0, currVal_0); var currVal_1 = (_v.context.$implicit.length <= 20); _ck(_v, 4, 0, currVal_1); }, null); }
function View_MeasureEditComponent_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 11, "div", [["class", "light-bg col-lg-3 col-md-3 float-left rounded p-2 mt-2 mr-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectDimFilter(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "div", [["class", "d-flex align-items-center justify-content-between mb-2 position-relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 0, "p", [["class", "text-truncate"]], [[8, "innerHTML", 1]], null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["class", "fa fa-times c-p"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeDimFilter($event, _v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["Filter Type : ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 5, "p", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Values: "])), (_l()(), core["ɵeld"](9, 0, null, null, 3, "b", [], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 2, "p", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_21)), core["ɵdid"](12, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var currVal_2 = _v.parent.context.$implicit.values; _ck(_v, 12, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.levelMap.get(_v.parent.context.$implicit.dimensionLevelId).displayName ? _co.levelMap.get(_v.parent.context.$implicit.dimensionLevelId).displayName : ((_co.levelMap.get(_v.parent.context.$implicit.dimensionLevelId).field == null) ? null : _co.levelMap.get(_v.parent.context.$implicit.dimensionLevelId).field.fieldName)); _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.parent.context.$implicit.filterType.toUpperCase(); _ck(_v, 6, 0, currVal_1); });
}
function View_MeasureEditComponent_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_20)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = ((_v.context.$implicit.deleted == undefined) || (_v.context.$implicit.deleted == false)); _ck(_v, 2, 0, currVal_0); }, null); }
function View_MeasureEditComponent_18(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "card-body col-lg-9 col-md-9 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_19)), core["ɵdid"](3, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.dimensionFilterList; _ck(_v, 3, 0, currVal_0); }, null); }
function View_MeasureEditComponent_27(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.dimId; var currVal_1 = ((_co.measureData && (_v.context.$implicit.dimId == _co.measureData.rangeStartDate)) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = ((_v.context.$implicit.dimDisplayName && (_v.context.$implicit.dimDisplayName != "")) ? _v.context.$implicit.dimDisplayName : _v.context.$implicit.dimName); _ck(_v, 3, 0, currVal_2); }); }
function View_MeasureEditComponent_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "col-lg-4 col-md-4 float-left left-clear pl-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "select", [["class", "form-control light-bg"]], [[8, "id", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.setTimeFilter($event.target.value, "startDate") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "option", [["value", ""]], null, null, null, null, null)), core["ɵdid"](4, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](5, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Default"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_27)), core["ɵdid"](8, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = ""; _ck(_v, 4, 0, currVal_1); var currVal_2 = ""; _ck(_v, 5, 0, currVal_2); var currVal_3 = _co.timeDimensionMap.get(_v.context.$implicit); _ck(_v, 8, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = ((_v.context.$implicit + "_") + "key"); _ck(_v, 2, 0, currVal_0); });
}
function View_MeasureEditComponent_29(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.dimId; var currVal_1 = ((_co.measureData && (_v.context.$implicit.dimId == _co.measureData.rangeEndDate)) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = ((_v.context.$implicit.dimDisplayName && (_v.context.$implicit.dimDisplayName != "")) ? _v.context.$implicit.dimDisplayName : _v.context.$implicit.dimName); _ck(_v, 3, 0, currVal_2); }); }
function View_MeasureEditComponent_28(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "col-lg-4 col-md-4 float-left pl-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "select", [["class", "form-control light-bg"]], [[8, "id", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.setTimeFilter($event.target.value, null) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "option", [["value", ""]], null, null, null, null, null)), core["ɵdid"](4, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](5, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Default"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_29)), core["ɵdid"](8, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = ""; _ck(_v, 4, 0, currVal_1); var currVal_2 = ""; _ck(_v, 5, 0, currVal_2); var currVal_3 = _co.timeDimensionMap.get(_v.context.$implicit); _ck(_v, 8, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = ((_v.context.$implicit + "_") + "key"); _ck(_v, 2, 0, currVal_0); });
}
function View_MeasureEditComponent_25(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "col-lg-9 col-md-9 float-left left-clear mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 float-left left-clear pl-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Range Start date"])), (_l()(), core["ɵeld"](5, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 float-left pl-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Range End date"])), (_l()(), core["ɵeld"](8, 0, null, null, 4, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_26)), core["ɵdid"](10, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_28)), core["ɵdid"](12, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.timeDimensionKey; _ck(_v, 10, 0, currVal_0); var currVal_1 = _co.timeDimensionKey; _ck(_v, 12, 0, currVal_1); }, null); }
function View_MeasureEditComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "col-lg-4 col-md-4 float-left mt-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "label", [["for", "measureData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Enable Range : "])), (_l()(), core["ɵeld"](4, 0, null, null, 7, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 6, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 5, "input", [["class", "checkbox"], ["name", "enablerange"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.measureData.range = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_25)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_7 = "enablerange"; var currVal_8 = _co.measureData.range; _ck(_v, 9, 0, currVal_7, currVal_8); var currVal_9 = _co.measureData.range; _ck(_v, 13, 0, currVal_9); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 11).ngClassValid; var currVal_5 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_MeasureEditComponent_30(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "ngb-timepicker", [], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = (_co.setStartDvTime($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NgbTimepicker_0, RenderType_NgbTimepicker)), core["ɵdid"](1, 573440, null, 0, timepicker_NgbTimepicker, [NgbTimepickerConfig, NgbTimeAdapter], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [timepicker_NgbTimepicker]), core["ɵdid"](3, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.startDataVersionTime; _ck(_v, 3, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 5).ngClassValid; var currVal_5 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_MeasureEditComponent_32(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "ngb-timepicker", [], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.dataVersionTime = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_1 = (_co.setDvTime($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbTimepicker_0, RenderType_NgbTimepicker)), core["ɵdid"](1, 573440, null, 0, timepicker_NgbTimepicker, [NgbTimepickerConfig, NgbTimeAdapter], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [timepicker_NgbTimepicker]), core["ɵdid"](3, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.dataVersionTime; _ck(_v, 3, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 5).ngClassValid; var currVal_5 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_MeasureEditComponent_31(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [["for", "measureData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["End Data Version"])), (_l()(), core["ɵeld"](3, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 11, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 16777216, null, null, 8, "input", [["class", "form-control light-bg"], ["name", "DataVersionDate"], ["ngbDatepicker", ""], ["placeholder", "YYYYMMDD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("input" === en)) {
                var pd_4 = (core["ɵnov"](_v, 8).manualDateChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("change" === en)) {
                var pd_5 = (core["ɵnov"](_v, 8).manualDateChange($event.target.value, true) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 8).onBlur() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.dataVersionDate = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](8, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], datepicker_input_NgbInputDatepicker]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_32)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 2, "div", [["class", "col-sx-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 1, "button", [["class", "iga-left form-control light-bg"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8).toggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_8 = "DataVersionDate"; var currVal_9 = _co.dataVersionDate; _ck(_v, 11, 0, currVal_8, currVal_9); var currVal_10 = (_co.dataVersionDate && (_co.dataVersionDate.day != undefined)); _ck(_v, 15, 0, currVal_10); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 8).disabled; var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_MeasureEditComponent_34(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Scale"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Scale "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Value"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Value "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Colour"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Colour "])), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Scale"; _ck(_v, 2, 0, currVal_0); var currVal_1 = "Value"; _ck(_v, 6, 0, currVal_1); var currVal_2 = "Colour"; _ck(_v, 10, 0, currVal_2); var currVal_3 = "Actions"; _ck(_v, 14, 0, currVal_3); }, null); }
function View_MeasureEditComponent_36(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "input", [["style", "width: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectColor($event, "indicator") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 0, "input", [["maxlength", "7"], ["type", "text"]], [[8, "value", 0], [1, "id", 0]], [[null, "keyup"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("keyup" === en)) {
                var pd_0 = (_co.onSelectColor($event, "indicator") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.code; var currVal_1 = _v.parent.context.index; _ck(_v, 2, 0, currVal_0, currVal_1); var currVal_2 = ((_v.parent.context.$implicit.code != undefined) ? _v.parent.context.$implicit.code : ""); var currVal_3 = _v.parent.context.index; _ck(_v, 3, 0, currVal_2, currVal_3); });
}
function View_MeasureEditComponent_35(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 27, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 7, "input", [["class", "w-full p-sm b-a"], ["maxlength", "250"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 10, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 9, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 8, "input", [["class", "w-full p-sm b-a"], ["maxlength", "200"], ["type", "number"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 14)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 14).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 14)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 14)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 15).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 15).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 15).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_v.context.$implicit.value = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](14, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](15, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](16, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](19, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](21, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_36)), core["ɵdid"](23, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"], ["id", "delete"]], [[1, "id", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onIndicatorDelete($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], function (_ck, _v) { var _co = _v.component; var currVal_8 = "250"; _ck(_v, 5, 0, currVal_8); var currVal_9 = _v.context.$implicit.name; _ck(_v, 8, 0, currVal_9); var currVal_18 = "200"; _ck(_v, 16, 0, currVal_18); var currVal_19 = _v.context.$implicit.value; _ck(_v, 19, 0, currVal_19); var currVal_20 = !_co.isDimTime; _ck(_v, 23, 0, currVal_20); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = (core["ɵnov"](_v, 16).maxlength ? core["ɵnov"](_v, 16).maxlength : null); var currVal_11 = core["ɵnov"](_v, 21).ngClassUntouched; var currVal_12 = core["ɵnov"](_v, 21).ngClassTouched; var currVal_13 = core["ɵnov"](_v, 21).ngClassPristine; var currVal_14 = core["ɵnov"](_v, 21).ngClassDirty; var currVal_15 = core["ɵnov"](_v, 21).ngClassValid; var currVal_16 = core["ɵnov"](_v, 21).ngClassInvalid; var currVal_17 = core["ɵnov"](_v, 21).ngClassPending; _ck(_v, 13, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_21 = _v.context.index; _ck(_v, 26, 0, currVal_21); });
}
function View_MeasureEditComponent_33(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 float-right form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "addIndicator"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addIndicators() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add New Indicator "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_34)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_35)), core["ɵdid"](7, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.indicators.length > 0); _ck(_v, 5, 0, currVal_0); var currVal_1 = _co.indicators; _ck(_v, 7, 0, currVal_1); }, null);
}
function View_MeasureEditComponent_39(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["ngbTooltip", "Target Value"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Target Value "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Target Value"; _ck(_v, 2, 0, currVal_0); }, null); }
function View_MeasureEditComponent_40(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["ngbTooltip", "Measure"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Measure "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Measure"; _ck(_v, 2, 0, currVal_0); }, null); }
function View_MeasureEditComponent_41(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["ngbTooltip", "Target"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Target "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Target"; _ck(_v, 2, 0, currVal_0); }, null); }
function View_MeasureEditComponent_38(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Target Name"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Target Name "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_39)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_40)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_41)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](11, 16777216, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ngbTooltip", "Colour"]], null, null, null, null, null)), core["ɵdid"](12, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Colour "])), (_l()(), core["ɵeld"](15, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](16, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](17, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = "Target Name"; _ck(_v, 2, 0, currVal_0); var currVal_1 = (_co.trgType == "Static"); _ck(_v, 6, 0, currVal_1); var currVal_2 = (_co.trgType == "Dynamic"); _ck(_v, 8, 0, currVal_2); var currVal_3 = (_co.trgType == "Core"); _ck(_v, 10, 0, currVal_3); var currVal_4 = "Colour"; _ck(_v, 12, 0, currVal_4); var currVal_5 = "Actions"; _ck(_v, 16, 0, currVal_5); }, null); }
function View_MeasureEditComponent_44(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "input", [["class", "form-control"], ["id", "targetValue"], ["maxlength", "250"], ["placeholder", "measure target value"], ["type", "number"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 1)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_v.parent.parent.context.$implicit.value = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](2, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](3, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var currVal_8 = "250"; _ck(_v, 3, 0, currVal_8); var currVal_9 = _v.parent.parent.context.$implicit.value; _ck(_v, 6, 0, currVal_9); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 3).maxlength ? core["ɵnov"](_v, 3).maxlength : null); var currVal_1 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 8).ngClassValid; var currVal_6 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_MeasureEditComponent_43(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_44)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit; _ck(_v, 3, 0, currVal_0); }, null); }
function View_MeasureEditComponent_46(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " (", ") "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.id; var currVal_1 = ((_v.parent.parent.context.$implicit.corTargetId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; var currVal_3 = _v.context.$implicit.corTrgCode; _ck(_v, 3, 0, currVal_2, currVal_3); }); }
function View_MeasureEditComponent_45(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 6, "select", [["class", "form-control"], ["id", "measureTrg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectTarget($event, _v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](5, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](6, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_46)), core["ɵdid"](9, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.corTrgList; _ck(_v, 9, 0, currVal_0); }, null);
}
function View_MeasureEditComponent_49(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " (", ") "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.id; var currVal_1 = ((_v.parent.parent.parent.context.$implicit.trgMeasureId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.measureDisplayName; var currVal_3 = _v.context.$implicit.measureCode; _ck(_v, 3, 0, currVal_2, currVal_3); }); }
function View_MeasureEditComponent_48(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_49)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.trgMeasures; _ck(_v, 2, 0, currVal_0); }, null); }
function View_MeasureEditComponent_51(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " (", ") "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.measureData.refId; var currVal_1 = ((_v.parent.parent.parent.context.$implicit.trgMeasureId == _v.context.$implicit.measureData.refId) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.measureData.measureDisplayName; var currVal_3 = _v.context.$implicit.measureData.measureCode; _ck(_v, 3, 0, currVal_2, currVal_3); }); }
function View_MeasureEditComponent_50(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_51)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.targetMeasureList; _ck(_v, 2, 0, currVal_0); }, null); }
function View_MeasureEditComponent_47(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 9, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 8, "select", [["class", "form-control"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectTrgMeasure($event, _v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](5, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](6, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_48)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_50)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.parent != "wizard"); _ck(_v, 9, 0, currVal_0); var currVal_1 = (_co.parent == "wizard"); _ck(_v, 11, 0, currVal_1); }, null);
}
function View_MeasureEditComponent_42(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 27, "div", [["dnd-sortable-container", ""]], null, null, null, null, null)), core["ɵdid"](1, 16384, null, 0, SortableContainer, [core["ElementRef"], DragDropService, DragDropConfig, core["ChangeDetectorRef"], dnd_service_DragDropSortableService], { sortableData: [0, "sortableData"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 25, "div", [["class", "w-100 float-left p-md-2 grid-details"], ["dnd-sortable", ""]], null, [[null, "onDropSuccess"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("onDropSuccess" === en)) {
                var pd_0 = (_co.reorder() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](3, 16384, null, 0, sortable_component_SortableComponent, [core["ElementRef"], DragDropService, DragDropConfig, SortableContainer, dnd_service_DragDropSortableService, core["ChangeDetectorRef"]], { index: [0, "index"] }, { onDropSuccessCallback: "onDropSuccess" }), (_l()(), core["ɵeld"](4, 0, null, null, 9, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 8, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "250"], ["placeholder", "Target Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_43)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_45)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_47)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 0, "input", [["style", "width: 30px; height: 30px; padding: 0 !important;"], ["type", "color"]], [[8, "value", 0], [1, "id", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectColor($event, "target") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 0, "input", [["maxlength", "7"], ["type", "text"]], [[8, "value", 0], [1, "id", 0]], [[null, "keyup"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("keyup" === en)) {
                var pd_0 = (_co.onSelectColor($event, "target") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"], ["id", "delete"]], [[1, "id", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onTargetDelete($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.measureTargets; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.index; _ck(_v, 3, 0, currVal_1); var currVal_10 = "250"; _ck(_v, 8, 0, currVal_10); var currVal_11 = _v.context.$implicit.name; _ck(_v, 11, 0, currVal_11); var currVal_12 = (_co.trgType == "Static"); _ck(_v, 15, 0, currVal_12); var currVal_13 = (_co.trgType == "Core"); _ck(_v, 17, 0, currVal_13); var currVal_14 = (_co.trgType == "Dynamic"); _ck(_v, 19, 0, currVal_14); }, function (_ck, _v) { var currVal_2 = (core["ɵnov"](_v, 8).maxlength ? core["ɵnov"](_v, 8).maxlength : null); var currVal_3 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 13).ngClassValid; var currVal_8 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 6, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_15 = _v.context.$implicit.color; var currVal_16 = _v.context.index; _ck(_v, 22, 0, currVal_15, currVal_16); var currVal_17 = ((_v.context.$implicit.color != undefined) ? _v.context.$implicit.color : ""); var currVal_18 = _v.context.index; _ck(_v, 23, 0, currVal_17, currVal_18); var currVal_19 = _v.context.index; _ck(_v, 26, 0, currVal_19); });
}
function View_MeasureEditComponent_37(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 23, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-8 col-md-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "addTarget"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addTarget() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add New Target "])), (_l()(), core["ɵeld"](4, 0, null, null, 19, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 18, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Target Type "])), (_l()(), core["ɵeld"](8, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](10, 0, null, null, 13, "select", [["class", "form-control"], ["id", "trgType"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 11).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 11).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("change" === en)) {
                var pd_2 = (_co.onSelectTrgType($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](11, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](13, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, null), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](15, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](16, 0, null, null, 3, "option", [["value", "Static"]], null, null, null, null, null)), core["ɵdid"](17, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](18, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Static"])), (_l()(), core["ɵeld"](20, 0, null, null, 3, "option", [["value", "Dynamic"]], null, null, null, null, null)), core["ɵdid"](21, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](22, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Dynamic"])), (_l()(), core["ɵeld"](24, 0, null, null, 2, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_38)), core["ɵdid"](26, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_42)), core["ɵdid"](28, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.trgType; _ck(_v, 13, 0, currVal_7); var currVal_8 = "Static"; _ck(_v, 17, 0, currVal_8); var currVal_9 = "Static"; _ck(_v, 18, 0, currVal_9); var currVal_10 = "Dynamic"; _ck(_v, 21, 0, currVal_10); var currVal_11 = "Dynamic"; _ck(_v, 22, 0, currVal_11); var currVal_12 = (_co.measureTargets.length > 0); _ck(_v, 26, 0, currVal_12); var currVal_13 = _co.measureTargets; _ck(_v, 28, 0, currVal_13); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 15).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 15).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 15).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 15).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 15).ngClassValid; var currVal_5 = core["ɵnov"](_v, 15).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 15).ngClassPending; _ck(_v, 10, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_MeasureEditComponent_52(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_MeasureEditComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 268, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 257, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.measureData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 17, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 16, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Type"])), (_l()(), core["ɵeld"](30, 0, null, null, 13, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 31).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.measureData.targetType = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](31, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](33, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](35, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "max"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Higher is better"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "min"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Lower is better"])), (_l()(), core["ɵeld"](44, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](48, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](49, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["rows", "1"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 50)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 50).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 50)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 50)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.measureData.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](50, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](51, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](54, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](56, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](57, 0, null, null, 33, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 32, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Aggregation"])), (_l()(), core["ɵeld"](61, 0, null, null, 29, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 62).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 62).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.measureData.aggregator = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](62, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](64, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](66, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](67, 0, null, null, 3, "option", [["value", "sum"]], null, null, null, null, null)), core["ɵdid"](68, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](69, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sum"])), (_l()(), core["ɵeld"](71, 0, null, null, 3, "option", [["value", "avg"]], null, null, null, null, null)), core["ɵdid"](72, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](73, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Average"])), (_l()(), core["ɵeld"](75, 0, null, null, 3, "option", [["value", "max"]], null, null, null, null, null)), core["ɵdid"](76, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](77, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Maximum"])), (_l()(), core["ɵeld"](79, 0, null, null, 3, "option", [["value", "min"]], null, null, null, null, null)), core["ɵdid"](80, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](81, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Minimum"])), (_l()(), core["ɵeld"](83, 0, null, null, 3, "option", [["value", "count"]], null, null, null, null, null)), core["ɵdid"](84, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](85, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Count"])), (_l()(), core["ɵeld"](87, 0, null, null, 3, "option", [["value", "distinct-count"]], null, null, null, null, null)), core["ɵdid"](88, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](89, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Distinct-Count"])), (_l()(), core["ɵeld"](91, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](92, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](93, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Display Name "])), (_l()(), core["ɵeld"](95, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](97, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 98)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 98).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 98)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 98)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.measureData.measureDisplayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](98, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](99, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](102, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](104, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](105, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](106, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](107, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["UOM Relation"])), (_l()(), core["ɵeld"](109, 0, null, null, 6, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectUom($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](110, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](111, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](112, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_3)), core["ɵdid"](115, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](116, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](117, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](118, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Number Format"])), (_l()(), core["ɵeld"](120, 0, null, null, 7, "input", [["class", "form-control"], ["id", "formula"], ["maxlength", "250"], ["placeholder", "###,###,###"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 121)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 121).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 121)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 121)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.measureData.formatString = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](121, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](122, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](125, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](127, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](128, 0, null, null, 15, "div", [["class", "col-lg-9 col-md-9 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](129, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](130, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Formula Expression "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_4)), core["ɵdid"](133, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](134, 16777216, null, null, 9, "input", [["autocomplete", "off"], ["class", "form-control"], ["id", "formula"], ["maxlength", "2000"], ["placeholder", "Formula"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "keydown"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 135)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 135).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 135)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 135)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("keydown" === en)) {
                var pd_4 = (core["ɵnov"](_v, 142).keyHandler($event) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (core["ɵnov"](_v, 142).blurHandler($event) !== false);
                ad = (pd_5 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_6 = ((_co.measureData.formulaExpression = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](135, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](136, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](139, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](141, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](142, 540672, null, 0, mention_directive["MentionDirective"], [core["ElementRef"], core["ComponentFactoryResolver"], core["ViewContainerRef"]], { mention: [0, "mention"], mentionConfig: [1, "mentionConfig"] }, null), core["ɵpod"](143, { triggerChar: 0, maxItems: 1, labelKey: 2, mentionSelect: 3 }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_5)), core["ɵdid"](145, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_7)), core["ɵdid"](147, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](148, 0, null, null, 40, "div", [["class", "col-lg-9 col-md-9 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](149, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Dimension Filter"])), (_l()(), core["ɵeld"](151, 0, null, null, 37, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](152, 0, null, null, 12, "div", [["class", "col-lg-4 col-md-4 float-left left-clear pl-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](153, 0, null, null, 11, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 154).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 154).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = (_co.addfilterDim($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](154, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](156, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](158, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](159, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](160, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { ngValue: [0, "ngValue"] }, null), core["ɵdid"](161, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { ngValue: [0, "ngValue"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_9)), core["ɵdid"](164, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](165, 0, null, null, 18, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](166, 0, null, null, 17, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 167).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 167).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.filterType = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.getExistingFilter() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](167, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](169, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](171, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](172, 0, null, null, 3, "option", [["ng-selected", "filterType == null"]], null, null, null, null, null)), core["ɵdid"](173, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { ngValue: [0, "ngValue"] }, null), core["ɵdid"](174, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { ngValue: [0, "ngValue"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵeld"](176, 0, null, null, 3, "option", [["ng-selected", "filterType == 'inclusion'"], ["ng-value", "inclusion"]], null, null, null, null, null)), core["ɵdid"](177, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](178, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](-1, null, ["Inclusion"])), (_l()(), core["ɵeld"](180, 0, null, null, 3, "option", [["ng-selected", "filterType == 'exclusion'"], ["ng-value", "exclusion"]], null, null, null, null, null)), core["ɵdid"](181, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](182, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](-1, null, ["Exclusion"])), (_l()(), core["ɵeld"](184, 0, null, null, 4, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_10)), core["ɵdid"](186, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_17)), core["ɵdid"](188, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_18)), core["ɵdid"](190, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_24)), core["ɵdid"](192, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](193, 0, null, null, 10, "div", [["class", "col-lg-4 col-md-4 float-left mt-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](194, 0, null, null, 1, "label", [["for", "measureData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Closing Period : "])), (_l()(), core["ɵeld"](196, 0, null, null, 7, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](197, 0, null, null, 6, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](198, 0, null, null, 5, "input", [["class", "checkbox"], ["name", "closingPeriod"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 199).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 199).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.measureData.closingPeriod = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](199, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](201, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](203, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](204, 0, null, null, 17, "div", [["class", "col-lg-8 col-md-8 float-left left-clear mt-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](205, 0, null, null, 16, "div", [["class", "col-lg-6 col-md-6 float-left left-clear pl-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](206, 0, null, null, 1, "label", [["for", "measureData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Version Type"])), (_l()(), core["ɵeld"](208, 0, null, null, 13, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 209).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 209).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.dataVersionType = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.changeDataVersionType($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](209, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](211, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](213, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](214, 0, null, null, 3, "option", [["ng-selected", "dataVersionType=='Dynamic'"], ["ng-value", "Dynamic"]], null, null, null, null, null)), core["ɵdid"](215, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](216, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](-1, null, ["Dynamic"])), (_l()(), core["ɵeld"](218, 0, null, null, 3, "option", [["ng-selected", "dataVersionType=='Static'"], ["ng-value", "Static"]], null, null, null, null, null)), core["ɵdid"](219, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](220, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](-1, null, ["Static"])), (_l()(), core["ɵeld"](222, 0, null, null, 23, "div", [["class", "col-lg-8 col-md-8 float-left left-clear mt-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](223, 0, null, null, 20, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](224, 0, null, null, 1, "label", [["for", "cubeStartDate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Start Data Version"])), (_l()(), core["ɵeld"](226, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](227, 0, null, null, 11, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](228, 16777216, null, null, 8, "input", [["class", "form-control light-bg"], ["name", "startDate"], ["ngbDatepicker", ""], ["placeholder", "YYYYMMDD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 229)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 229).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 229)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 229)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("input" === en)) {
                var pd_4 = (core["ɵnov"](_v, 231).manualDateChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("change" === en)) {
                var pd_5 = (core["ɵnov"](_v, 231).manualDateChange($event.target.value, true) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 231).onBlur() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.startDataVersion = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](229, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](231, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], datepicker_input_NgbInputDatepicker]), core["ɵdid"](234, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](236, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_30)), core["ɵdid"](238, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](239, 0, null, null, 2, "div", [["class", "col-sx-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](240, 0, null, null, 1, "button", [["class", "iga-left form-control light-bg"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 231).toggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](241, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](242, 0, null, null, 1, "button", [["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clearStartDate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](243, 0, null, null, 0, "i", [["class", "fa fa-times"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_31)), core["ɵdid"](245, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](246, 0, null, null, 9, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 float-left my-4 form-group accordionss"]], null, null, null, null, null)), (_l()(), core["ɵeld"](247, 0, null, null, 8, "ngb-accordion", [["class", "w-100 accordion"], ["role", "tablist"]], [[1, "aria-multiselectable", 0]], null, null, View_NgbAccordion_0, RenderType_NgbAccordion)), core["ɵdid"](248, 2146304, null, 1, accordion_NgbAccordion, [NgbAccordionConfig], null, null), core["ɵqud"](603979776, 6, { panels: 1 }), (_l()(), core["ɵeld"](250, 0, null, null, 5, "ngb-panel", [["id", "someId"], ["title", "Indicators"]], null, null, null, null, null)), core["ɵdid"](251, 2113536, [[6, 4]], 2, NgbPanel, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 7, { titleTpls: 1 }), core["ɵqud"](603979776, 8, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_MeasureEditComponent_33)), core["ɵdid"](255, 16384, [[8, 4]], 0, NgbPanelContent, [core["TemplateRef"]], null, null), (_l()(), core["ɵeld"](256, 0, null, null, 9, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-6 float-left my-4 form-group accordionss"]], null, null, null, null, null)), (_l()(), core["ɵeld"](257, 0, null, null, 8, "ngb-accordion", [["class", "w-100 accordion"], ["role", "tablist"]], [[1, "aria-multiselectable", 0]], null, null, View_NgbAccordion_0, RenderType_NgbAccordion)), core["ɵdid"](258, 2146304, null, 1, accordion_NgbAccordion, [NgbAccordionConfig], null, null), core["ɵqud"](603979776, 9, { panels: 1 }), (_l()(), core["ɵeld"](260, 0, null, null, 5, "ngb-panel", [["id", "someId"], ["title", "Targets"]], null, null, null, null, null)), core["ɵdid"](261, 2113536, [[9, 4]], 2, NgbPanel, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 10, { titleTpls: 1 }), core["ɵqud"](603979776, 11, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_MeasureEditComponent_37)), core["ɵdid"](265, 16384, [[11, 4]], 0, NgbPanelContent, [core["TemplateRef"]], null, null), (_l()(), core["ɵeld"](266, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](267, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.save() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureEditComponent_52)), core["ɵdid"](270, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.measureData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_20 = _co.measureData.targetType; _ck(_v, 33, 0, currVal_20); var currVal_21 = "max"; _ck(_v, 37, 0, currVal_21); var currVal_22 = "max"; _ck(_v, 38, 0, currVal_22); var currVal_23 = "min"; _ck(_v, 41, 0, currVal_23); var currVal_24 = "min"; _ck(_v, 42, 0, currVal_24); var currVal_33 = "350"; _ck(_v, 51, 0, currVal_33); var currVal_34 = "description"; var currVal_35 = _co.measureData.description; _ck(_v, 54, 0, currVal_34, currVal_35); var currVal_43 = _co.measureData.aggregator; _ck(_v, 64, 0, currVal_43); var currVal_44 = "sum"; _ck(_v, 68, 0, currVal_44); var currVal_45 = "sum"; _ck(_v, 69, 0, currVal_45); var currVal_46 = "avg"; _ck(_v, 72, 0, currVal_46); var currVal_47 = "avg"; _ck(_v, 73, 0, currVal_47); var currVal_48 = "max"; _ck(_v, 76, 0, currVal_48); var currVal_49 = "max"; _ck(_v, 77, 0, currVal_49); var currVal_50 = "min"; _ck(_v, 80, 0, currVal_50); var currVal_51 = "min"; _ck(_v, 81, 0, currVal_51); var currVal_52 = "count"; _ck(_v, 84, 0, currVal_52); var currVal_53 = "count"; _ck(_v, 85, 0, currVal_53); var currVal_54 = "distinct-count"; _ck(_v, 88, 0, currVal_54); var currVal_55 = "distinct-count"; _ck(_v, 89, 0, currVal_55); var currVal_64 = "200"; _ck(_v, 99, 0, currVal_64); var currVal_65 = "name"; var currVal_66 = _co.measureData.measureDisplayName; _ck(_v, 102, 0, currVal_65, currVal_66); var currVal_67 = "none"; _ck(_v, 111, 0, currVal_67); var currVal_68 = "none"; _ck(_v, 112, 0, currVal_68); var currVal_69 = _co.uomList; _ck(_v, 115, 0, currVal_69); var currVal_78 = "250"; _ck(_v, 122, 0, currVal_78); var currVal_79 = _co.measureData.formatString; _ck(_v, 125, 0, currVal_79); var currVal_80 = _co.formulaMeasure; _ck(_v, 133, 0, currVal_80); var currVal_89 = "2000"; _ck(_v, 136, 0, currVal_89); var currVal_90 = _co.measureData.formulaExpression; _ck(_v, 139, 0, currVal_90); var currVal_91 = _co.trgMeasures; var currVal_92 = _ck(_v, 143, 0, "`", 50, "name", _co.onMentionSelect); _ck(_v, 142, 0, currVal_91, currVal_92); var currVal_93 = _co.measureData.rollup; _ck(_v, 145, 0, currVal_93); var currVal_94 = (_co.measureData.rollup && _co.selectedDimLvlId.length); _ck(_v, 147, 0, currVal_94); var currVal_102 = _co.filterDim; _ck(_v, 156, 0, currVal_102); var currVal_103 = null; _ck(_v, 160, 0, currVal_103); var currVal_104 = null; _ck(_v, 161, 0, currVal_104); var currVal_105 = _co.trgDimension; _ck(_v, 164, 0, currVal_105); var currVal_113 = _co.filterType; _ck(_v, 169, 0, currVal_113); var currVal_114 = null; _ck(_v, 173, 0, currVal_114); var currVal_115 = null; _ck(_v, 174, 0, currVal_115); var currVal_116 = _co.spinner; _ck(_v, 186, 0, currVal_116); var currVal_117 = !_co.spinner; _ck(_v, 188, 0, currVal_117); var currVal_118 = ((_co.dimensionFilterList && _co.dimensionFilterList.length) && (_co.dimensionFilterList.length > 0)); _ck(_v, 190, 0, currVal_118); var currVal_119 = _co.isStarSchema; _ck(_v, 192, 0, currVal_119); var currVal_127 = "closingPeriod"; var currVal_128 = _co.measureData.closingPeriod; _ck(_v, 201, 0, currVal_127, currVal_128); var currVal_136 = _co.dataVersionType; _ck(_v, 211, 0, currVal_136); var currVal_145 = "startDate"; var currVal_146 = _co.startDataVersion; _ck(_v, 234, 0, currVal_145, currVal_146); var currVal_147 = (_co.startDataVersion && (_co.startDataVersion.day != undefined)); _ck(_v, 238, 0, currVal_147); var currVal_148 = ((_co.dataVersionType == "Static") ? true : false); _ck(_v, 245, 0, currVal_148); var currVal_150 = "someId"; var currVal_151 = "Indicators"; _ck(_v, 251, 0, currVal_150, currVal_151); var currVal_153 = "someId"; var currVal_154 = "Targets"; _ck(_v, 261, 0, currVal_153, currVal_154); var currVal_156 = _co.loader; _ck(_v, 270, 0, currVal_156); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_13 = core["ɵnov"](_v, 35).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 35).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 35).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 35).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 35).ngClassValid; var currVal_18 = core["ɵnov"](_v, 35).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 35).ngClassPending; _ck(_v, 30, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_25 = (core["ɵnov"](_v, 51).maxlength ? core["ɵnov"](_v, 51).maxlength : null); var currVal_26 = core["ɵnov"](_v, 56).ngClassUntouched; var currVal_27 = core["ɵnov"](_v, 56).ngClassTouched; var currVal_28 = core["ɵnov"](_v, 56).ngClassPristine; var currVal_29 = core["ɵnov"](_v, 56).ngClassDirty; var currVal_30 = core["ɵnov"](_v, 56).ngClassValid; var currVal_31 = core["ɵnov"](_v, 56).ngClassInvalid; var currVal_32 = core["ɵnov"](_v, 56).ngClassPending; _ck(_v, 49, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32); var currVal_36 = core["ɵnov"](_v, 66).ngClassUntouched; var currVal_37 = core["ɵnov"](_v, 66).ngClassTouched; var currVal_38 = core["ɵnov"](_v, 66).ngClassPristine; var currVal_39 = core["ɵnov"](_v, 66).ngClassDirty; var currVal_40 = core["ɵnov"](_v, 66).ngClassValid; var currVal_41 = core["ɵnov"](_v, 66).ngClassInvalid; var currVal_42 = core["ɵnov"](_v, 66).ngClassPending; _ck(_v, 61, 0, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42); var currVal_56 = (core["ɵnov"](_v, 99).maxlength ? core["ɵnov"](_v, 99).maxlength : null); var currVal_57 = core["ɵnov"](_v, 104).ngClassUntouched; var currVal_58 = core["ɵnov"](_v, 104).ngClassTouched; var currVal_59 = core["ɵnov"](_v, 104).ngClassPristine; var currVal_60 = core["ɵnov"](_v, 104).ngClassDirty; var currVal_61 = core["ɵnov"](_v, 104).ngClassValid; var currVal_62 = core["ɵnov"](_v, 104).ngClassInvalid; var currVal_63 = core["ɵnov"](_v, 104).ngClassPending; _ck(_v, 97, 0, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63); var currVal_70 = (core["ɵnov"](_v, 122).maxlength ? core["ɵnov"](_v, 122).maxlength : null); var currVal_71 = core["ɵnov"](_v, 127).ngClassUntouched; var currVal_72 = core["ɵnov"](_v, 127).ngClassTouched; var currVal_73 = core["ɵnov"](_v, 127).ngClassPristine; var currVal_74 = core["ɵnov"](_v, 127).ngClassDirty; var currVal_75 = core["ɵnov"](_v, 127).ngClassValid; var currVal_76 = core["ɵnov"](_v, 127).ngClassInvalid; var currVal_77 = core["ɵnov"](_v, 127).ngClassPending; _ck(_v, 120, 0, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75, currVal_76, currVal_77); var currVal_81 = (core["ɵnov"](_v, 136).maxlength ? core["ɵnov"](_v, 136).maxlength : null); var currVal_82 = core["ɵnov"](_v, 141).ngClassUntouched; var currVal_83 = core["ɵnov"](_v, 141).ngClassTouched; var currVal_84 = core["ɵnov"](_v, 141).ngClassPristine; var currVal_85 = core["ɵnov"](_v, 141).ngClassDirty; var currVal_86 = core["ɵnov"](_v, 141).ngClassValid; var currVal_87 = core["ɵnov"](_v, 141).ngClassInvalid; var currVal_88 = core["ɵnov"](_v, 141).ngClassPending; _ck(_v, 134, 0, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88); var currVal_95 = core["ɵnov"](_v, 158).ngClassUntouched; var currVal_96 = core["ɵnov"](_v, 158).ngClassTouched; var currVal_97 = core["ɵnov"](_v, 158).ngClassPristine; var currVal_98 = core["ɵnov"](_v, 158).ngClassDirty; var currVal_99 = core["ɵnov"](_v, 158).ngClassValid; var currVal_100 = core["ɵnov"](_v, 158).ngClassInvalid; var currVal_101 = core["ɵnov"](_v, 158).ngClassPending; _ck(_v, 153, 0, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101); var currVal_106 = core["ɵnov"](_v, 171).ngClassUntouched; var currVal_107 = core["ɵnov"](_v, 171).ngClassTouched; var currVal_108 = core["ɵnov"](_v, 171).ngClassPristine; var currVal_109 = core["ɵnov"](_v, 171).ngClassDirty; var currVal_110 = core["ɵnov"](_v, 171).ngClassValid; var currVal_111 = core["ɵnov"](_v, 171).ngClassInvalid; var currVal_112 = core["ɵnov"](_v, 171).ngClassPending; _ck(_v, 166, 0, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111, currVal_112); var currVal_120 = core["ɵnov"](_v, 203).ngClassUntouched; var currVal_121 = core["ɵnov"](_v, 203).ngClassTouched; var currVal_122 = core["ɵnov"](_v, 203).ngClassPristine; var currVal_123 = core["ɵnov"](_v, 203).ngClassDirty; var currVal_124 = core["ɵnov"](_v, 203).ngClassValid; var currVal_125 = core["ɵnov"](_v, 203).ngClassInvalid; var currVal_126 = core["ɵnov"](_v, 203).ngClassPending; _ck(_v, 198, 0, currVal_120, currVal_121, currVal_122, currVal_123, currVal_124, currVal_125, currVal_126); var currVal_129 = core["ɵnov"](_v, 213).ngClassUntouched; var currVal_130 = core["ɵnov"](_v, 213).ngClassTouched; var currVal_131 = core["ɵnov"](_v, 213).ngClassPristine; var currVal_132 = core["ɵnov"](_v, 213).ngClassDirty; var currVal_133 = core["ɵnov"](_v, 213).ngClassValid; var currVal_134 = core["ɵnov"](_v, 213).ngClassInvalid; var currVal_135 = core["ɵnov"](_v, 213).ngClassPending; _ck(_v, 208, 0, currVal_129, currVal_130, currVal_131, currVal_132, currVal_133, currVal_134, currVal_135); var currVal_137 = core["ɵnov"](_v, 231).disabled; var currVal_138 = core["ɵnov"](_v, 236).ngClassUntouched; var currVal_139 = core["ɵnov"](_v, 236).ngClassTouched; var currVal_140 = core["ɵnov"](_v, 236).ngClassPristine; var currVal_141 = core["ɵnov"](_v, 236).ngClassDirty; var currVal_142 = core["ɵnov"](_v, 236).ngClassValid; var currVal_143 = core["ɵnov"](_v, 236).ngClassInvalid; var currVal_144 = core["ɵnov"](_v, 236).ngClassPending; _ck(_v, 228, 0, currVal_137, currVal_138, currVal_139, currVal_140, currVal_141, currVal_142, currVal_143, currVal_144); var currVal_149 = !core["ɵnov"](_v, 248).closeOtherPanels; _ck(_v, 247, 0, currVal_149); var currVal_152 = !core["ɵnov"](_v, 258).closeOtherPanels; _ck(_v, 257, 0, currVal_152); var currVal_155 = _co.saveButtonDisable; _ck(_v, 267, 0, currVal_155); });
}
function View_MeasureEditComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "measureEditor", [], null, null, null, View_MeasureEditComponent_0, RenderType_MeasureEditComponent)), core["ɵdid"](1, 573440, null, 0, measureEdit_component_MeasureEditComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"], platform_browser["c" /* DomSanitizer */], ngbDateConverter_utils_NgbDateConverter, ngbTimeConverter_utils_NgbTimeConverter], null, null)], null, null); }
var MeasureEditComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("measureEditor", measureEdit_component_MeasureEditComponent, View_MeasureEditComponent_Host_0, { parent: "parent", measureData: "measureData", isEdit: "isEdit", inEdit: "inEdit", isStarSchema: "isStarSchema", targetMeasureList: "targetMeasureList", targetDimensionList: "targetDimensionList", formulaMeasure: "formulaMeasure" }, { triggerSave: "triggerSave", triggerBack: "triggerBack" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/dimensionEdit.component.ts



var dimensionEdit_component_DimensionEditComponent = /*@__PURE__*/ (function () {
    function DimensionEditComponent(dimensionService, toaster, vcr) {
        this.dimensionService = dimensionService;
        this.toaster = toaster;
        this.isEdit = false;
        this.triggerSave = new core["EventEmitter"]();
        this.triggerBack = new core["EventEmitter"]();
        this.saveButtonDisable = false;
        this.loader = false;
        this.isDimTime = false;
        this.dimHierarchyLevelData = [];
        this.dimHierarchyDataObject = { id: null, name: '', dimHierarchyLevelData: [] };
        this.recordFormatList = [];
        this.prevDimHierarchyLevelData = [];
        this.saveButton = false;
        this.toaster.setViewRef(vcr);
    }
    DimensionEditComponent.prototype.ngOnChanges = function () {
        if (this.parent == 'wizard') {
            this.editWizardDimension();
        }
        else {
            this.getDimensionById();
        }
    };
    DimensionEditComponent.prototype.editWizardDimension = function () {
        var self = this;
        // se.dimensionData
        // self.loadRecordFormat().then(res => {
        self.isEdit = true;
        self.getDimensionData();
        self.selectedRFF = self.recordFormat;
        // });
    };
    DimensionEditComponent.prototype.getDimensionData = function () {
        var self = this;
        self.isDimTime = self.dimensionData.dimTime;
        self.dimHierarchyDataObject = self.dimensionData.dimHierarchyData[0];
        for (var _i = 0, _a = self.recordFormatList; _i < _a.length; _i++) {
            var record = _a[_i];
            if (self.dimensionData.dimHierarchyData[0].recordFormatId == record.id) {
                self.selectedRFF = record;
                self.currentDimId = record.id;
                break;
            }
        }
        self.dimHierarchyLevelData = self.dimensionData.dimHierarchyData[0].dimHierarchyLevelData;
        self.dimHierarchyLevelData = underscore["sortBy"](self.dimHierarchyLevelData, function (s) {
            return s.levelNumber;
        });
        self.prevDimHierarchyLevelData = self.dimHierarchyLevelData;
    };
    DimensionEditComponent.prototype.getDimensionById = function () {
        var self = this;
        self.loader = true;
        self.loadRecordFormat().then(function (res) {
            if (self.dimensionData.id) {
                self.isEdit = true;
                self.dimensionService.getDataById('../' + BiUrls.BI_DIMENSION, self.dimensionData.id).then(function (res) {
                    if (res == undefined || res.data == undefined) {
                        self.toaster.showError('Cannot load the Dimension');
                    }
                    else {
                        self.dimensionData = res.data;
                        self.getDimensionData();
                    }
                    self.loader = false;
                }, function (error) {
                    console.error(error);
                });
            }
            self.loader = false;
        });
    };
    DimensionEditComponent.prototype.onTypeSelection = function (event) {
        if (event.target.value == 'time') {
            this.isDimTime = true;
            this.dimensionData.dimTime = true;
        }
        else {
            this.dimHierarchyLevelData.forEach(function (data) {
                data.levelType = null;
            });
            this.isDimTime = false;
            this.dimensionData.dimTime = false;
        }
    };
    DimensionEditComponent.prototype.onSelectOfRecord = function (event) {
        var _this = this;
        if (event.target.value == 'selectOne') {
            this.selectedRFF = null;
            this.dimHierarchyDataObject.recordFormatId = null;
            for (var _i = 0, _a = this.dimHierarchyLevelData; _i < _a.length; _i++) {
                var level = _a[_i];
                level.recordFormatFieldId = null;
                level.nameFieldId = null;
                delete level.field;
                delete level.nameField;
            }
        }
        else {
            this.dimHierarchyDataObject.recordFormatId = null;
            this.recordFormatList.filter(function (item) {
                if (event.target.value == item.id) {
                    _this.selectedRFF = item;
                    _this.dimHierarchyDataObject.recordFormatId = item.id;
                }
            });
        }
        if (this.dimHierarchyDataObject.recordFormatId != this.currentDimId) {
            this.dimHierarchyLevelData = [];
            this.setDimensionLevels();
        }
        else {
            this.dimHierarchyLevelData = this.prevDimHierarchyLevelData;
        }
    };
    DimensionEditComponent.prototype.setDimensionLevels = function () {
        var _this = this;
        var dimHierarchyLevelData;
        this.recordFormatList.filter(function (item) {
            if (_this.dimHierarchyDataObject.recordFormatId == item.id) {
                dimHierarchyLevelData = item.recordFormatFieldData;
                return;
            }
        });
        dimHierarchyLevelData.forEach(function (dimLevel) {
            if (dimLevel.fieldDatatype == "STRING") {
                var level = {
                    id: null, displayName: dimLevel.displayName, levelNumber: null, levelType: null, deleted: 0,
                    dimHierarchyId: _this.dimHierarchyDataObject.id, recordFormatFieldId: dimLevel.id, nameFieldId: null,
                    ordinalFieldId: null
                };
                _this.dimHierarchyLevelData.push(level);
            }
        });
    };
    // public onSelectHierarchyType(event) {
    //     for (let level of this.dimHierarchyLevelData) {
    //         if (event.target.id == this.dimHierarchyLevelData.indexOf(level)) {
    //             level.levelType = event.target.value;
    //         }
    //     }
    //     return;
    // }
    DimensionEditComponent.prototype.OnSelectRFFields = function (event, fieldName) {
        var _this = this;
        var pos;
        var text = 'Please select field for the level';
        if (event.target.value == 'selectOne' && fieldName == 'field1') {
            this.dimHierarchyLevelData.forEach(function (item1) {
                if (event.target.id == _this.dimHierarchyLevelData.indexOf(item1)) {
                    item1['recordFormatFieldId'] = null;
                }
            });
            return;
        }
        else if (fieldName == 'field1') {
            this.dimHierarchyLevelData.forEach(function (item1) {
                if (event.target.id == _this.dimHierarchyLevelData.indexOf(item1)) {
                    item1['recordFormatFieldId'] = +event.target.value;
                    return;
                }
            });
        }
        if (fieldName == 'field2') {
            for (var _i = 0, _a = this.dimHierarchyLevelData; _i < _a.length; _i++) {
                var level = _a[_i];
                if (event.target.id == this.dimHierarchyLevelData.indexOf(level)) {
                    if (fieldName == 'field1') {
                        level['recordFormatFieldId'] = event.target.value;
                    }
                    else {
                        level.nameFieldId = event.target.value == 'selectOne' ?
                            null : event.target.value;
                    }
                }
            }
        }
        if (fieldName == 'field3') {
            for (var _b = 0, _c = this.dimHierarchyLevelData; _b < _c.length; _b++) {
                var level = _c[_b];
                if (event.target.id == this.dimHierarchyLevelData.indexOf(level)) {
                    if (fieldName == 'field1') {
                        level['recordFormatFieldId'] = event.target.value;
                    }
                    else {
                        level.ordinalFieldId = event.target.value == 'selectOne' ?
                            null : event.target.value;
                    }
                }
            }
        }
    };
    DimensionEditComponent.prototype.onLevelDelete = function (event, name) {
        var self = this;
        var r = confirm('Are you sure you want to remove this level ' + name + ' ?');
        if (r == true) {
            self.toaster.showSuccess('level ' + name + ' removed successfully');
            this.dimHierarchyLevelData.splice(event.target.id, 1);
        }
    };
    DimensionEditComponent.prototype.addLevels = function () {
        var level = {
            id: null, displayName: null, levelNumber: null, levelType: null, deleted: 0
        };
        if (this.isEdit) {
            level['dimHierarchyId'] = this.dimHierarchyDataObject.id;
        }
        this.dimHierarchyLevelData.push(level);
    };
    DimensionEditComponent.prototype.save = function () {
        var self = this;
        var validate = this.validator();
        if (validate != '') {
            self.toaster.showError(validate);
        }
        else {
            if (this.parent == 'wizard') {
                self.triggerSave.emit(self.dimensionData);
            }
            else {
                self.saveButtonDisable = true;
                if (self.isEdit) {
                    self.dimensionService.update(BiUrls.DIMENSION, self.dimensionData).then(function (res) {
                        res['type'] = 'edit';
                        self.triggerSave.emit(res);
                    });
                }
                else {
                    self.dimensionService.save(BiUrls.DIMENSION, self.dimensionData).then(function (res) {
                        res['type'] = 'new';
                        self.triggerSave.emit(res);
                    });
                }
            }
        }
    };
    DimensionEditComponent.prototype.validator = function () {
        if (this.dimensionData.name == undefined || this.dimensionData.name == '') {
            return 'please enter name for the dimension';
        }
        if (this.dimHierarchyDataObject.name == undefined ||
            this.dimHierarchyDataObject.name == '') {
            return 'please enter the name for hierarchy';
        }
        this.dimensionData.dimHierarchyData[0] = this.dimHierarchyDataObject;
        this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData = this.dimHierarchyLevelData;
        var str = this.levelValidator();
        if (str != '') {
            return str;
        }
        this.trimer();
        return '';
    };
    DimensionEditComponent.prototype.trimer = function () {
        this.dimensionData.name = this.dimensionData.name.trim();
        this.dimensionData.description = this.dimensionData.description != undefined ? this.dimensionData.description.trim() :
            this.dimensionData.description;
        this.dimensionData.dimHierarchyData[0].name = this.dimensionData
            .dimHierarchyData[0].name.trim();
    };
    DimensionEditComponent.prototype.levelValidator = function () {
        for (var i = 0; i < this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData.length; i++) {
            if (this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].displayName == undefined ||
                this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].displayName.trim() == '') {
                return 'Please enter name for all the levels';
            }
            this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].displayName =
                this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].displayName.trim();
            this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].levelNumber = i;
            delete this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].field;
            delete this.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[i].nameField;
        }
        var msg = this.checkForDuplicateNameInLevels();
        if (msg != '') {
            return msg;
        }
        return '';
    };
    DimensionEditComponent.prototype.checkForDuplicateNameInLevels = function () {
        for (var _i = 0, _a = this.dimHierarchyLevelData; _i < _a.length; _i++) {
            var level = _a[_i];
            for (var _b = 0, _c = this.dimHierarchyLevelData; _b < _c.length; _b++) {
                var copy = _c[_b];
                if (copy.displayName == level.displayName && copy.levelNumber != level.levelNumber) {
                    return 'Name cannot be same for different levels';
                }
            }
        }
        return '';
    };
    DimensionEditComponent.prototype.loadRecordFormat = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            _this.dimensionService.onStartUp(BiUrls.RECORDFORMAT).then(function (res) {
                self.recordFormatList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            }, function (err) {
                console.error(err);
                resolve('conpleted');
            });
        });
    };
    DimensionEditComponent.prototype.onBack = function () {
        this.triggerBack.emit();
    };
    DimensionEditComponent.prototype.reorder = function () {
        for (var k = 0; k < this.dimHierarchyLevelData.length; k++) {
            this.dimHierarchyLevelData[k].levelNumber = k;
        }
    };
    return DimensionEditComponent;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/dimensionEdit.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,ng2_dnd_src_sortable.component,ng2_dnd_src_dnd.service,ng2_dnd_src_dnd.config,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_accordion_accordion.ngfactory,_ng_bootstrap_ng_bootstrap_accordion_accordion,_ng_bootstrap_ng_bootstrap_accordion_accordion_config,_loader.component.ngfactory,_loader.component,_dimensionEdit.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent PURE_IMPORTS_END */
















var styles_DimensionEditComponent = [];
var RenderType_DimensionEditComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_DimensionEditComponent, data: {} });

function View_DimensionEditComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Dimension "]))], null, null); }
function View_DimensionEditComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Dimension - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.dimensionData.dimCode; _ck(_v, 1, 0, currVal_0); }); }
function View_DimensionEditComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", " "]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit.id; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit.id; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.dimHierarchyDataObject.recordFormatId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0); var currVal_3 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_3); }); }
function View_DimensionEditComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectOfRecord($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "option", [["value", "selectOne"]], null, null, null, null, null)), core["ɵdid"](2, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](3, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Select One"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_4)), core["ɵdid"](6, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "selectOne"; _ck(_v, 2, 0, currVal_0); var currVal_1 = "selectOne"; _ck(_v, 3, 0, currVal_1); var currVal_2 = _co.recordFormatList; _ck(_v, 6, 0, currVal_2); }, null);
}
function View_DimensionEditComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "input", [["class", "form-control"], ["id", "recordFormatName"], ["maxlength", "100"], ["readonly", ""], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 1)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.recordFormat.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](2, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](5, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](7, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 2, 0, currVal_8); var currVal_9 = _co.recordFormat.displayName; _ck(_v, 5, 0, currVal_9); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 2).maxlength ? core["ɵnov"](_v, 2).maxlength : null); var currVal_1 = core["ɵnov"](_v, 7).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 7).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 7).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 7).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 7).ngClassValid; var currVal_6 = core["ɵnov"](_v, 7).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 7).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_DimensionEditComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Type"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Type "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Type"; _ck(_v, 1, 0, currVal_0); }, null); }
function View_DimensionEditComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Record Format Field"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Record Format Field "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Record Format Field"; _ck(_v, 1, 0, currVal_0); }, null); }
function View_DimensionEditComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name Field"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name Field "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Name Field"; _ck(_v, 1, 0, currVal_0); }, null); }
function View_DimensionEditComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Ordinal Column"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Ordinal Column "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Ordinal Column"; _ck(_v, 1, 0, currVal_0); }, null); }
function View_DimensionEditComponent_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 30, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 29, "select", [["class", "w-full p-sm b-a"]], [[1, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.parent.context.$implicit.levelType = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](7, 0, null, null, 3, "option", [["value", "null"]], [[8, "disabled", 0]], null, null, null, null)), core["ɵdid"](8, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](9, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Select One"])), (_l()(), core["ɵeld"](11, 0, null, null, 3, "option", [["value", "TimeDays"]], null, null, null, null, null)), core["ɵdid"](12, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](13, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Day"])), (_l()(), core["ɵeld"](15, 0, null, null, 3, "option", [["value", "TimeWeeks"]], null, null, null, null, null)), core["ɵdid"](16, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](17, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Week"])), (_l()(), core["ɵeld"](19, 0, null, null, 3, "option", [["value", "TimeMonths"]], null, null, null, null, null)), core["ɵdid"](20, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](21, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Month"])), (_l()(), core["ɵeld"](23, 0, null, null, 3, "option", [["value", "TimeYears"]], null, null, null, null, null)), core["ɵdid"](24, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](25, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Year"])), (_l()(), core["ɵeld"](27, 0, null, null, 3, "option", [["value", "TimeQuarters"]], null, null, null, null, null)), core["ɵdid"](28, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](29, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Quarter"]))], function (_ck, _v) { var currVal_8 = _v.parent.context.$implicit.levelType; _ck(_v, 4, 0, currVal_8); var currVal_10 = "null"; _ck(_v, 8, 0, currVal_10); var currVal_11 = "null"; _ck(_v, 9, 0, currVal_11); var currVal_12 = "TimeDays"; _ck(_v, 12, 0, currVal_12); var currVal_13 = "TimeDays"; _ck(_v, 13, 0, currVal_13); var currVal_14 = "TimeWeeks"; _ck(_v, 16, 0, currVal_14); var currVal_15 = "TimeWeeks"; _ck(_v, 17, 0, currVal_15); var currVal_16 = "TimeMonths"; _ck(_v, 20, 0, currVal_16); var currVal_17 = "TimeMonths"; _ck(_v, 21, 0, currVal_17); var currVal_18 = "TimeYears"; _ck(_v, 24, 0, currVal_18); var currVal_19 = "TimeYears"; _ck(_v, 25, 0, currVal_19); var currVal_20 = "TimeQuarters"; _ck(_v, 28, 0, currVal_20); var currVal_21 = "TimeQuarters"; _ck(_v, 29, 0, currVal_21); }, function (_ck, _v) { var currVal_0 = _v.parent.context.index; var currVal_1 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 6).ngClassValid; var currVal_6 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_9 = true; _ck(_v, 7, 0, currVal_9); });
}
function View_DimensionEditComponent_16(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit.id; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit.id; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = ((_v.parent.parent.parent.context.$implicit.recordFormatFieldId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0); var currVal_3 = _v.context.$implicit.fieldName; _ck(_v, 3, 0, currVal_3); }); }
function View_DimensionEditComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_16)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedRFF.recordFormatFieldData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DimensionEditComponent_18(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit.refId; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit.refId; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = ((_v.parent.parent.parent.context.$implicit.recordFormatFieldId == _v.context.$implicit.refId) ? true : null); _ck(_v, 0, 0, currVal_0); var currVal_3 = _v.context.$implicit.fieldName; _ck(_v, 3, 0, currVal_3); }); }
function View_DimensionEditComponent_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_18)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedRFF.recordFormatFieldData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DimensionEditComponent_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "select", [["class", "col-12 p-sm b-a"]], [[1, "id", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.OnSelectRFFields($event, "field1") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "option", [["value", "selectOne"]], null, null, null, null, null)), core["ɵdid"](3, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](4, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Select One"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_15)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_17)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = "selectOne"; _ck(_v, 3, 0, currVal_1); var currVal_2 = "selectOne"; _ck(_v, 4, 0, currVal_2); var currVal_3 = (_co.parent != "wizard"); _ck(_v, 7, 0, currVal_3); var currVal_4 = (_co.parent == "wizard"); _ck(_v, 9, 0, currVal_4); }, function (_ck, _v) { var currVal_0 = _v.parent.context.index; _ck(_v, 1, 0, currVal_0); });
}
function View_DimensionEditComponent_21(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit.id; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit.id; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = ((_v.parent.parent.parent.context.$implicit.nameFieldId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0); var currVal_3 = _v.context.$implicit.fieldName; _ck(_v, 3, 0, currVal_3); }); }
function View_DimensionEditComponent_20(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_21)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedRFF.recordFormatFieldData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DimensionEditComponent_23(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit.refId; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit.refId; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = ((_v.parent.parent.parent.context.$implicit.nameFieldId == _v.context.$implicit.refId) ? true : null); _ck(_v, 0, 0, currVal_0); var currVal_3 = _v.context.$implicit.fieldName; _ck(_v, 3, 0, currVal_3); }); }
function View_DimensionEditComponent_22(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_23)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedRFF.recordFormatFieldData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DimensionEditComponent_19(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "select", [["class", "col-12 p-sm b-a"]], [[1, "id", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.OnSelectRFFields($event, "field2") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "option", [["value", "selectOne"]], null, null, null, null, null)), core["ɵdid"](3, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](4, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Select One"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_20)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_22)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = "selectOne"; _ck(_v, 3, 0, currVal_1); var currVal_2 = "selectOne"; _ck(_v, 4, 0, currVal_2); var currVal_3 = (_co.parent != "wizard"); _ck(_v, 7, 0, currVal_3); var currVal_4 = (_co.parent == "wizard"); _ck(_v, 9, 0, currVal_4); }, function (_ck, _v) { var currVal_0 = _v.parent.context.index; _ck(_v, 1, 0, currVal_0); });
}
function View_DimensionEditComponent_26(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit.id; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit.id; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = ((_v.parent.parent.parent.context.$implicit.ordinalFieldId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0); var currVal_3 = _v.context.$implicit.fieldName; _ck(_v, 3, 0, currVal_3); }); }
function View_DimensionEditComponent_25(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_26)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedRFF.recordFormatFieldData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DimensionEditComponent_28(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit.refId; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit.refId; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = ((_v.parent.parent.parent.context.$implicit.ordinalFieldId == _v.context.$implicit.refId) ? true : null); _ck(_v, 0, 0, currVal_0); var currVal_3 = _v.context.$implicit.fieldName; _ck(_v, 3, 0, currVal_3); }); }
function View_DimensionEditComponent_27(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_28)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.selectedRFF.recordFormatFieldData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DimensionEditComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "select", [["class", "col-12 p-sm b-a"]], [[1, "id", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.OnSelectRFFields($event, "field3") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "option", [["value", "selectOne"]], null, null, null, null, null)), core["ɵdid"](3, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](4, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Select One"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_25)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_27)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = "selectOne"; _ck(_v, 3, 0, currVal_1); var currVal_2 = "selectOne"; _ck(_v, 4, 0, currVal_2); var currVal_3 = (_co.parent != "wizard"); _ck(_v, 7, 0, currVal_3); var currVal_4 = (_co.parent == "wizard"); _ck(_v, 9, 0, currVal_4); }, function (_ck, _v) { var currVal_0 = _v.parent.context.index; _ck(_v, 1, 0, currVal_0); });
}
function View_DimensionEditComponent_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["dnd-sortable-container", ""]], null, null, null, null, null)), core["ɵdid"](1, 16384, null, 0, SortableContainer, [core["ElementRef"], DragDropService, DragDropConfig, core["ChangeDetectorRef"], dnd_service_DragDropSortableService], { sortableData: [0, "sortableData"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 23, "div", [["class", "w-100 float-left p-md-2 grid-details"], ["dnd-sortable", ""]], null, [[null, "onDropSuccess"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("onDropSuccess" === en)) {
                var pd_0 = (_co.reorder() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](3, 16384, null, 0, sortable_component_SortableComponent, [core["ElementRef"], DragDropService, DragDropConfig, SortableContainer, dnd_service_DragDropSortableService, core["ChangeDetectorRef"]], { index: [0, "index"] }, { onDropSuccessCallback: "onDropSuccess" }), (_l()(), core["ɵeld"](4, 0, null, null, 9, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 8, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 7, "input", [["class", "w-full p-sm b-a"], ["maxlength", "200"], ["type", "text "]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_13)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_14)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_19)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_24)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](22, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"], ["id", " delete "]], [[1, "id", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onLevelDelete($event, _v.context.$implicit.displayName) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.dimHierarchyLevelData; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.index; _ck(_v, 3, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 8, 0, currVal_10); var currVal_11 = _v.context.$implicit.displayName; _ck(_v, 11, 0, currVal_11); var currVal_12 = _co.isDimTime; _ck(_v, 15, 0, currVal_12); var currVal_13 = (_co.selectedRFF != undefined); _ck(_v, 17, 0, currVal_13); var currVal_14 = (_co.selectedRFF != undefined); _ck(_v, 19, 0, currVal_14); var currVal_15 = (_co.selectedRFF != undefined); _ck(_v, 21, 0, currVal_15); }, function (_ck, _v) { var currVal_2 = (core["ɵnov"](_v, 8).maxlength ? core["ɵnov"](_v, 8).maxlength : null); var currVal_3 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 13).ngClassValid; var currVal_8 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 6, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_16 = _v.context.index; _ck(_v, 24, 0, currVal_16); });
}
function View_DimensionEditComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Level Name"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Level Name "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_8)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_9)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_10)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_11)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_12)), core["ɵdid"](19, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = "Level Name"; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isDimTime; _ck(_v, 7, 0, currVal_1); var currVal_2 = (_co.selectedRFF != undefined); _ck(_v, 9, 0, currVal_2); var currVal_3 = (_co.selectedRFF != undefined); _ck(_v, 11, 0, currVal_3); var currVal_4 = (_co.selectedRFF != undefined); _ck(_v, 13, 0, currVal_4); var currVal_5 = "Actions"; _ck(_v, 15, 0, currVal_5); var currVal_6 = _co.dimHierarchyLevelData; _ck(_v, 19, 0, currVal_6); }, null); }
function View_DimensionEditComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group accordionss"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "ngb-accordion", [["class", "w-100 accordion"], ["role", "tablist"]], [[1, "aria-multiselectable", 0]], null, null, View_NgbAccordion_0, RenderType_NgbAccordion)), core["ɵdid"](2, 2146304, null, 1, accordion_NgbAccordion, [NgbAccordionConfig], null, null), core["ɵqud"](603979776, 1, { panels: 1 }), (_l()(), core["ɵeld"](4, 0, null, null, 5, "ngb-panel", [["id", "someId"], ["title", "View Dimension Levels"]], null, null, null, null, null)), core["ɵdid"](5, 2113536, [[1, 4]], 2, NgbPanel, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 2, { titleTpls: 1 }), core["ɵqud"](603979776, 3, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_DimensionEditComponent_7)), core["ɵdid"](9, 16384, [[3, 4]], 0, NgbPanelContent, [core["TemplateRef"]], null, null)], function (_ck, _v) { var currVal_1 = "someId"; var currVal_2 = "View Dimension Levels"; _ck(_v, 5, 0, currVal_1, currVal_2); }, function (_ck, _v) { var currVal_0 = !core["ɵnov"](_v, 2).closeOtherPanels; _ck(_v, 1, 0, currVal_0); }); }
function View_DimensionEditComponent_29(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_DimensionEditComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 92, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 79, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dimensionData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Display Name "])), (_l()(), core["ɵeld"](30, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dimensionData.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](31, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](32, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](35, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](37, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](38, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Type"])), (_l()(), core["ɵeld"](41, 0, null, null, 8, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onTypeSelection($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](42, 0, null, null, 3, "option", [["value", "custom"]], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](43, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](44, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Custom"])), (_l()(), core["ɵeld"](46, 0, null, null, 3, "option", [["value", "time"]], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](47, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](48, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Time"])), (_l()(), core["ɵeld"](50, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](53, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["rows", "1"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 55)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 55).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 55)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 55)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dimensionData.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](55, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](56, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](59, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](61, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](62, 0, null, null, 6, "div", [["class", "col-lg-6 col-md-6 float-left  left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Record Format For Hierarchy Level "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_3)), core["ɵdid"](66, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_5)), core["ɵdid"](68, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](69, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Dimension Hierarchy Name "])), (_l()(), core["ɵeld"](73, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](75, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 76)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 76).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 76)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 76)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dimHierarchyDataObject.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](76, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](77, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](80, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](82, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](83, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](84, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "addLevels"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addLevels() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Levels"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_6)), core["ɵdid"](87, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](88, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](89, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.save() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionEditComponent_29)), core["ɵdid"](92, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.dimensionData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_21 = "200"; _ck(_v, 32, 0, currVal_21); var currVal_22 = "name"; var currVal_23 = _co.dimensionData.displayName; _ck(_v, 35, 0, currVal_22, currVal_23); var currVal_25 = "custom"; _ck(_v, 43, 0, currVal_25); var currVal_26 = "custom"; _ck(_v, 44, 0, currVal_26); var currVal_28 = "time"; _ck(_v, 47, 0, currVal_28); var currVal_29 = "time"; _ck(_v, 48, 0, currVal_29); var currVal_38 = "350"; _ck(_v, 56, 0, currVal_38); var currVal_39 = "description"; var currVal_40 = _co.dimensionData.description; _ck(_v, 59, 0, currVal_39, currVal_40); var currVal_41 = (_co.parent != "wizard"); _ck(_v, 66, 0, currVal_41); var currVal_42 = (_co.parent == "wizard"); _ck(_v, 68, 0, currVal_42); var currVal_51 = "200"; _ck(_v, 77, 0, currVal_51); var currVal_52 = "name"; var currVal_53 = _co.dimHierarchyDataObject.name; _ck(_v, 80, 0, currVal_52, currVal_53); var currVal_54 = (_co.dimHierarchyLevelData && (_co.dimHierarchyLevelData.length > 0)); _ck(_v, 87, 0, currVal_54); var currVal_56 = _co.loader; _ck(_v, 92, 0, currVal_56); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_13 = (core["ɵnov"](_v, 32).maxlength ? core["ɵnov"](_v, 32).maxlength : null); var currVal_14 = core["ɵnov"](_v, 37).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 37).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 37).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 37).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 37).ngClassValid; var currVal_19 = core["ɵnov"](_v, 37).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 37).ngClassPending; _ck(_v, 30, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_24 = ((_co.isDimTime == false) ? true : null); _ck(_v, 42, 0, currVal_24); var currVal_27 = ((_co.isDimTime == true) ? true : null); _ck(_v, 46, 0, currVal_27); var currVal_30 = (core["ɵnov"](_v, 56).maxlength ? core["ɵnov"](_v, 56).maxlength : null); var currVal_31 = core["ɵnov"](_v, 61).ngClassUntouched; var currVal_32 = core["ɵnov"](_v, 61).ngClassTouched; var currVal_33 = core["ɵnov"](_v, 61).ngClassPristine; var currVal_34 = core["ɵnov"](_v, 61).ngClassDirty; var currVal_35 = core["ɵnov"](_v, 61).ngClassValid; var currVal_36 = core["ɵnov"](_v, 61).ngClassInvalid; var currVal_37 = core["ɵnov"](_v, 61).ngClassPending; _ck(_v, 54, 0, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37); var currVal_43 = (core["ɵnov"](_v, 77).maxlength ? core["ɵnov"](_v, 77).maxlength : null); var currVal_44 = core["ɵnov"](_v, 82).ngClassUntouched; var currVal_45 = core["ɵnov"](_v, 82).ngClassTouched; var currVal_46 = core["ɵnov"](_v, 82).ngClassPristine; var currVal_47 = core["ɵnov"](_v, 82).ngClassDirty; var currVal_48 = core["ɵnov"](_v, 82).ngClassValid; var currVal_49 = core["ɵnov"](_v, 82).ngClassInvalid; var currVal_50 = core["ɵnov"](_v, 82).ngClassPending; _ck(_v, 75, 0, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50); var currVal_55 = _co.saveButton; _ck(_v, 89, 0, currVal_55); });
}
function View_DimensionEditComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "dimensionEditor", [], null, null, null, View_DimensionEditComponent_0, RenderType_DimensionEditComponent)), core["ɵdid"](1, 573440, null, 0, dimensionEdit_component_DimensionEditComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], null, null); }
var DimensionEditComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("dimensionEditor", dimensionEdit_component_DimensionEditComponent, View_DimensionEditComponent_Host_0, { parent: "parent", dimensionData: "dimensionData", recordFormat: "recordFormat", isEdit: "isEdit" }, { triggerSave: "triggerSave", triggerBack: "triggerBack" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/cube.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_loader.component.ngfactory,_loader.component,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_accordion_accordion.ngfactory,_ng_bootstrap_ng_bootstrap_accordion_accordion,_ng_bootstrap_ng_bootstrap_accordion_accordion_config,_measureEdit.component.ngfactory,_measureEdit.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent,_angular_platform_browser,_.._common_service_ngbDateConverter.utils,_.._common_service_ngbTimeConverter.utils,_dimensionEdit.component.ngfactory,_dimensionEdit.component,angular2_multiselect_dropdown_clickOutside,_cube.component PURE_IMPORTS_END */






























var styles_CubeComponent = [];
var RenderType_CubeComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_CubeComponent, data: {} });

function View_CubeComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["CUBE"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clearCache() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Clear All Cube Cache "])), (_l()(), core["ɵeld"](7, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewCube() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Cube"]))], null, null);
}
function View_CubeComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 29, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 28, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "DataSource"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" DataSource "])), (_l()(), core["ɵeld"](18, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Record Format"]], null, null, null, null, null)), core["ɵdid"](19, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Record Format "])), (_l()(), core["ɵeld"](22, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Data Version"]], null, null, null, null, null)), core["ɵdid"](23, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Data Version "])), (_l()(), core["ɵeld"](26, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](27, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](28, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Code"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Description"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "DataSource"; _ck(_v, 15, 0, currVal_3); var currVal_4 = "Record Format"; _ck(_v, 19, 0, currVal_4); var currVal_5 = "Data Version"; _ck(_v, 23, 0, currVal_5); var currVal_6 = "Actions"; _ck(_v, 27, 0, currVal_6); }, null); }
function View_CubeComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](1, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_CubeComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.context.$implicit.dataSourceName, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.context.$implicit.dataSourceName; _ck(_v, 3, 0, currVal_1); }); }
function View_CubeComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "N/A"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" N/A "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "N/A"; _ck(_v, 1, 0, currVal_0); }, null); }
function View_CubeComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.parent.context.$implicit.recordFormatData.displayName; _ck(_v, 2, 0, currVal_0); }); }
function View_CubeComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, null, null, null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.parent.context.$implicit.recordFormatData.name, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.parent.context.$implicit.recordFormatData.name; _ck(_v, 3, 0, currVal_1); }); }
function View_CubeComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 5, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_11)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_12)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.context.$implicit.recordFormatData.displayName, ""); _ck(_v, 1, 0, currVal_0); var currVal_1 = ((_v.parent.context.$implicit.recordFormatData.displayName != undefined) ? true : false); _ck(_v, 3, 0, currVal_1); var currVal_2 = ((_v.parent.context.$implicit.recordFormatData.displayName != undefined) ? false : true); _ck(_v, 5, 0, currVal_2); }, null); }
function View_CubeComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "None"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" None "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "None"; _ck(_v, 1, 0, currVal_0); }, null); }
function View_CubeComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 5, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵppd"](2, 2), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), core["ɵppd"](5, 2), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 1, 0, _ck(_v, 2, 0, core["ɵnov"](_v.parent.parent.parent.parent.parent, 0), _v.parent.context.$implicit.dataVersion, _co.mediumDate)), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 4, 0, _ck(_v, 5, 0, core["ɵnov"](_v.parent.parent.parent.parent.parent, 0), _v.parent.context.$implicit.dataVersion, _co.mediumDate)); _ck(_v, 4, 0, currVal_1); }); }
function View_CubeComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null))], null, null); }
function View_CubeComponent_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clearCacheForCube(_v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Clear Cache "]))], null, null);
}
function View_CubeComponent_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clickEdit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_17)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeCube(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "])), (_l()(), core["ɵeld"](11, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeCubeWithDimsAndMeasures(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete All "]))], function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.enableCache; _ck(_v, 7, 0, currVal_0); }, null);
}
function View_CubeComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 31, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_7)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), core["ɵdid"](4, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](8, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, [" ", " "])), (_l()(), core["ɵeld"](11, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](12, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_8)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_9)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_10)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_13)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_14)), core["ɵdid"](24, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_15)), core["ɵdid"](26, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](27, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_16)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.cubeCode, ""); _ck(_v, 4, 0, currVal_1); var currVal_3 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 8, 0, currVal_3); var currVal_5 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.description, ""); _ck(_v, 12, 0, currVal_5); var currVal_7 = (_v.context.$implicit.dataSourceName != undefined); _ck(_v, 16, 0, currVal_7); var currVal_8 = (_v.context.$implicit.dataSourceName == undefined); _ck(_v, 18, 0, currVal_8); var currVal_9 = ((_v.context.$implicit.recordFormatData != undefined) ? true : false); _ck(_v, 20, 0, currVal_9); var currVal_10 = ((_v.context.$implicit.recordFormatData != undefined) ? false : true); _ck(_v, 22, 0, currVal_10); var currVal_11 = ((_v.context.$implicit.dataVersionType != undefined) && (_v.context.$implicit.dataVersionType == "Static")); _ck(_v, 24, 0, currVal_11); var currVal_12 = ((_v.context.$implicit.dataVersionType == undefined) || (_v.context.$implicit.dataVersionType == "Dynamic")); _ck(_v, 26, 0, currVal_12); var currVal_14 = ((_co.selectedCubeId == _v.context.$implicit.id) ? true : false); _ck(_v, 31, 0, currVal_14); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.cubeCode; _ck(_v, 6, 0, currVal_2); var currVal_4 = _v.context.$implicit.name; _ck(_v, 10, 0, currVal_4); var currVal_6 = _v.context.$implicit.description; _ck(_v, 14, 0, currVal_6); var currVal_13 = _v.context.$implicit.id; _ck(_v, 27, 0, currVal_13); });
}
function View_CubeComponent_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_CubeComponent_18(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_19)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_CubeComponent_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalCubes; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_CubeComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPCube() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_5)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_6)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_18)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](23, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](26, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_20)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.cubeReg; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = (_co.cubeList && _co.cubeList.length); _ck(_v, 15, 0, currVal_11); var currVal_12 = _co.cubeList; _ck(_v, 17, 0, currVal_12); var currVal_13 = (_co.cubeList.length == 0); _ck(_v, 19, 0, currVal_13); var currVal_24 = _co.pageSize; _ck(_v, 29, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 33, 0, currVal_25); var currVal_26 = "10"; _ck(_v, 34, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 37, 0, currVal_27); var currVal_28 = "20"; _ck(_v, 38, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 41, 0, currVal_29); var currVal_30 = "30"; _ck(_v, 42, 0, currVal_30); var currVal_31 = (_co.cubeList && _co.cubeList.length); _ck(_v, 46, 0, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_14 = _co.startingPage; var currVal_15 = _co.endingPage; var currVal_16 = _co.totalCubes; _ck(_v, 22, 0, currVal_14, currVal_15, currVal_16); var currVal_17 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 31).ngClassValid; var currVal_22 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); });
}
function View_CubeComponent_22(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Cube "]))], null, null); }
function View_CubeComponent_23(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Cube - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.cubeData.cubeCode; _ck(_v, 1, 0, currVal_0); }); }
function View_CubeComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Source"])), (_l()(), core["ɵeld"](3, 0, null, null, 7, "input", [["class", "form-control"], ["id", "dataSource"], ["maxlength", "100"], ["placeholder", " Data Source Name"], ["readonly", ""], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeData.dataSourceData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = _co.cubeData.dataSourceData.name; _ck(_v, 8, 0, currVal_9); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_CubeComponent_25(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.saveButton; _ck(_v, 1, 0, currVal_0); });
}
function View_CubeComponent_27(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.id; var currVal_1 = ((_co.cubeData.recordFormatId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_CubeComponent_28(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [["for", "cubeData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Version"])), (_l()(), core["ɵeld"](3, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 9, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 16777216, null, null, 8, "input", [["class", "form-control light-bg"], ["name", "DataVersionDate"], ["ngbDatepicker", ""], ["placeholder", "YYYYMMDD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("input" === en)) {
                var pd_4 = (core["ɵnov"](_v, 8).manualDateChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("change" === en)) {
                var pd_5 = (core["ɵnov"](_v, 8).manualDateChange($event.target.value, true) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 8).onBlur() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.dataVersionDate = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](8, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], datepicker_input_NgbInputDatepicker]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 2, "div", [["class", "col-sx-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "button", [["class", "iga-left form-control light-bg"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8).toggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_8 = "DataVersionDate"; var currVal_9 = _co.dataVersionDate; _ck(_v, 11, 0, currVal_8, currVal_9); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 8).disabled; var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_CubeComponent_30(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, ["", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.id; _ck(_v, 0, 0, currVal_0); var currVal_1 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_1); }); }
function View_CubeComponent_31(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, ["", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.id; _ck(_v, 0, 0, currVal_0); var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 3, 0, currVal_1); }); }
function View_CubeComponent_32(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 19, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 18, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](5, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](8, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Record Format Field "])), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Type "])), (_l()(), core["ɵeld"](14, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Edit "])), (_l()(), core["ɵeld"](17, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], null, null); }
function View_CubeComponent_33(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 20, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "i", [["class", "fa fa-pencil mr-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editMeasure(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Edit "])), (_l()(), core["ɵeld"](17, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeCubeMeasure($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.measureData.measureCode; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.measureData.name; _ck(_v, 6, 0, currVal_1); var currVal_2 = ((_v.context.$implicit.recordFormatField && _v.context.$implicit.recordFormatField.displayName) ? _v.context.$implicit.recordFormatField.displayName : ""); _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.measureNodeType; _ck(_v, 12, 0, currVal_3); });
}
function View_CubeComponent_29(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 50, "div", [["class", "w-100 float-left p-md-2 grid-details table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 15, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 14, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [["for", "measure"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Measure"])), (_l()(), core["ɵeld"](5, 0, null, null, 11, "select", [["class", "form-control float-left"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.cubeMeasureData.measureId = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onSelectMeasure($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](12, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](13, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_30)), core["ɵdid"](16, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](17, 0, null, null, 17, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 16, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 1, "label", [["for", "measure"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Type"])), (_l()(), core["ɵeld"](21, 0, null, null, 13, "select", [["class", "w-100 float-left form-control"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.cubeMeasureData.measureNodeType = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](24, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](26, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](27, 0, null, null, 3, "option", [["value", "ACTUAL"]], null, null, null, null, null)), core["ɵdid"](28, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](29, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Actual"])), (_l()(), core["ɵeld"](31, 0, null, null, 3, "option", [["value", "TARGET"]], null, null, null, null, null)), core["ɵdid"](32, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](33, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Target"])), (_l()(), core["ɵeld"](35, 0, null, null, 15, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 14, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 1, "label", [["for", "recordFormatMes"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Record Format field"])), (_l()(), core["ɵeld"](39, 0, null, null, 11, "select", [["class", "w-100 float-left form-control"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 40).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 40).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.cubeMeasureData.recordFormatFieldId = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onSelectField($event, "measure") !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](40, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](42, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](44, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](45, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](46, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](47, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_31)), core["ɵdid"](50, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](51, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](52, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "addMeasureField"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addFieldForMeasure() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Cube Measure "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_32)), core["ɵdid"](55, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_33)), core["ɵdid"](57, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.cubeMeasureData.measureId; _ck(_v, 8, 0, currVal_7); var currVal_8 = "none"; _ck(_v, 12, 0, currVal_8); var currVal_9 = "none"; _ck(_v, 13, 0, currVal_9); var currVal_10 = _co.measureList; _ck(_v, 16, 0, currVal_10); var currVal_18 = _co.cubeMeasureData.measureNodeType; _ck(_v, 24, 0, currVal_18); var currVal_19 = "ACTUAL"; _ck(_v, 28, 0, currVal_19); var currVal_20 = "ACTUAL"; _ck(_v, 29, 0, currVal_20); var currVal_21 = "TARGET"; _ck(_v, 32, 0, currVal_21); var currVal_22 = "TARGET"; _ck(_v, 33, 0, currVal_22); var currVal_30 = _co.cubeMeasureData.recordFormatFieldId; _ck(_v, 42, 0, currVal_30); var currVal_31 = "none"; _ck(_v, 46, 0, currVal_31); var currVal_32 = "none"; _ck(_v, 47, 0, currVal_32); var currVal_33 = _co.recordObject.recordFormatFieldData; _ck(_v, 50, 0, currVal_33); var currVal_34 = (_co.cubeMeasureDataList && (_co.cubeMeasureDataList.length > 0)); _ck(_v, 55, 0, currVal_34); var currVal_35 = _co.cubeMeasureDataList; _ck(_v, 57, 0, currVal_35); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 10).ngClassValid; var currVal_5 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_11 = core["ɵnov"](_v, 26).ngClassUntouched; var currVal_12 = core["ɵnov"](_v, 26).ngClassTouched; var currVal_13 = core["ɵnov"](_v, 26).ngClassPristine; var currVal_14 = core["ɵnov"](_v, 26).ngClassDirty; var currVal_15 = core["ɵnov"](_v, 26).ngClassValid; var currVal_16 = core["ɵnov"](_v, 26).ngClassInvalid; var currVal_17 = core["ɵnov"](_v, 26).ngClassPending; _ck(_v, 21, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_23 = core["ɵnov"](_v, 44).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 44).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 44).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 44).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 44).ngClassValid; var currVal_28 = core["ɵnov"](_v, 44).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 44).ngClassPending; _ck(_v, 39, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); });
}
function View_CubeComponent_36(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = ((_v.parent.context.$implicit.id + "_") + _v.context.$implicit.id); _ck(_v, 0, 0, currVal_0); var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 3, 0, currVal_1); }); }
function View_CubeComponent_35(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "optgroup", [], [[8, "label", 0]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_36)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var currVal_1 = _v.context.$implicit.dimHierarchyData[0].dimHierarchyLevelData; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 0, 0, currVal_0); }); }
function View_CubeComponent_37(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, ["", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.id; _ck(_v, 0, 0, currVal_0); var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 3, 0, currVal_1); }); }
function View_CubeComponent_38(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "error-msg text-center"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.errorName; _ck(_v, 2, 0, currVal_0); }); }
function View_CubeComponent_39(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 22, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 21, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](5, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Mapping Name "])), (_l()(), core["ɵeld"](8, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Dimension Name "])), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Dimension Level Name "])), (_l()(), core["ɵeld"](14, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Record Format Field "])), (_l()(), core["ɵeld"](17, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Edit "])), (_l()(), core["ɵeld"](20, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], null, null); }
function View_CubeComponent_40(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 23, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, [" ", " "])), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "i", [["class", "fa fa-pencil mr-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editDimension(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Edit "])), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeCubeDimension($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.dimensionData.dimCode; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.name; _ck(_v, 6, 0, currVal_1); var currVal_2 = (_v.context.$implicit.dimensionData ? _v.context.$implicit.dimensionData.name : ""); _ck(_v, 9, 0, currVal_2); var currVal_3 = (_v.context.$implicit.dimHierarchyLevelData ? _v.context.$implicit.dimHierarchyLevelData.displayName : ""); _ck(_v, 12, 0, currVal_3); var currVal_4 = _v.context.$implicit.recordFormatField.displayName; _ck(_v, 15, 0, currVal_4); });
}
function View_CubeComponent_34(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 48, "div", [["class", "w-100 float-left p-md-2 grid-details table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 13, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Mapping Name "])), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](7, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "mappingName"], ["placeholder", " Mapping Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 8)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 8)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeDimensionUsageData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](9, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](12, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](14, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](15, 0, null, null, 15, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 14, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 1, "label", [["for", "dim"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Dimension"])), (_l()(), core["ɵeld"](19, 0, null, null, 11, "select", [["class", "form-control"], ["id", "dimcube"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 20).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 20).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.referencevariable = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onSelectDimenasion($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](20, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](22, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](24, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](25, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](26, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](27, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_35)), core["ɵdid"](30, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](31, 0, null, null, 15, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 1, "label", [["for", "recordFormatDim"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Record Format field"])), (_l()(), core["ɵeld"](35, 0, null, null, 11, "select", [["class", "form-control"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 36).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 36).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.cubeDimensionUsageData.recordFormatFieldId = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onSelectField($event, "dimension") !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](36, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](38, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](40, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](41, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](42, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](43, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_37)), core["ɵdid"](46, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_38)), core["ɵdid"](48, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](49, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left mt-3 form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "addDimField"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addFieldForDimension() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Cube Dimension "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_39)), core["ɵdid"](53, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_40)), core["ɵdid"](55, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_8 = "200"; _ck(_v, 9, 0, currVal_8); var currVal_9 = "mappingName"; var currVal_10 = _co.cubeDimensionUsageData.name; _ck(_v, 12, 0, currVal_9, currVal_10); var currVal_18 = _co.referencevariable; _ck(_v, 22, 0, currVal_18); var currVal_19 = "none"; _ck(_v, 26, 0, currVal_19); var currVal_20 = "none"; _ck(_v, 27, 0, currVal_20); var currVal_21 = _co.dimensionList; _ck(_v, 30, 0, currVal_21); var currVal_29 = _co.cubeDimensionUsageData.recordFormatFieldId; _ck(_v, 38, 0, currVal_29); var currVal_30 = "none"; _ck(_v, 42, 0, currVal_30); var currVal_31 = "none"; _ck(_v, 43, 0, currVal_31); var currVal_32 = _co.recordObject.recordFormatFieldData; _ck(_v, 46, 0, currVal_32); var currVal_33 = _co.emptyDimensionRecord; _ck(_v, 48, 0, currVal_33); var currVal_34 = (_co.cubeDimensionUsageList && (_co.cubeDimensionUsageList.length > 0)); _ck(_v, 53, 0, currVal_34); var currVal_35 = _co.cubeDimensionUsageList; _ck(_v, 55, 0, currVal_35); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 9).maxlength ? core["ɵnov"](_v, 9).maxlength : null); var currVal_1 = core["ɵnov"](_v, 14).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 14).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 14).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 14).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 14).ngClassValid; var currVal_6 = core["ɵnov"](_v, 14).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 14).ngClassPending; _ck(_v, 7, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_11 = core["ɵnov"](_v, 24).ngClassUntouched; var currVal_12 = core["ɵnov"](_v, 24).ngClassTouched; var currVal_13 = core["ɵnov"](_v, 24).ngClassPristine; var currVal_14 = core["ɵnov"](_v, 24).ngClassDirty; var currVal_15 = core["ɵnov"](_v, 24).ngClassValid; var currVal_16 = core["ɵnov"](_v, 24).ngClassInvalid; var currVal_17 = core["ɵnov"](_v, 24).ngClassPending; _ck(_v, 19, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_22 = core["ɵnov"](_v, 40).ngClassUntouched; var currVal_23 = core["ɵnov"](_v, 40).ngClassTouched; var currVal_24 = core["ɵnov"](_v, 40).ngClassPristine; var currVal_25 = core["ɵnov"](_v, 40).ngClassDirty; var currVal_26 = core["ɵnov"](_v, 40).ngClassValid; var currVal_27 = core["ɵnov"](_v, 40).ngClassInvalid; var currVal_28 = core["ɵnov"](_v, 40).ngClassPending; _ck(_v, 35, 0, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28); });
}
function View_CubeComponent_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 68, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 9, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [["for", "recordFormat"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Record Format"])), (_l()(), core["ɵeld"](5, 0, null, null, 6, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.confirmChangeOfRecordFormat($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](7, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](8, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_27)), core["ɵdid"](11, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 19, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 16, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "label", [["for", "cubeData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Version Type"])), (_l()(), core["ɵeld"](16, 0, null, null, 13, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 17).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 17).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.dataVersionType = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](17, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](19, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](21, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](22, 0, null, null, 3, "option", [["ng-selected", "dataVersionType=='Dynamic'"], ["ng-value", "Dynamic"]], null, null, null, null, null)), core["ɵdid"](23, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](24, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](-1, null, ["Dynamic"])), (_l()(), core["ɵeld"](26, 0, null, null, 3, "option", [["ng-selected", "dataVersionType=='Static'"], ["ng-value", "Static"]], null, null, null, null, null)), core["ɵdid"](27, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](28, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](-1, null, ["Static"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_28)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](32, 0, null, null, 9, "div", [["class", "col-lg-6 col-md-6 float-left left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 8, "div", [["class", "w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 1, "label", [["class", "mb-0 mr-3"], ["for", "enableCache"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Enable Cache"])), (_l()(), core["ɵeld"](36, 0, null, null, 5, "input", [["id", "enableCache"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 37).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 37).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.cubeData.enableCache = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](37, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](39, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](41, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](42, 0, null, null, 11, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](43, 0, null, null, 10, "div", [["class", "light-bg col-lg-12 col-md-12 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](44, 0, null, null, 9, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group accordionss"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 8, "ngb-accordion", [["class", "w-100 accordion"], ["role", "tablist"]], [[1, "aria-multiselectable", 0]], null, null, View_NgbAccordion_0, RenderType_NgbAccordion)), core["ɵdid"](46, 2146304, null, 1, accordion_NgbAccordion, [NgbAccordionConfig], { activeIds: [0, "activeIds"] }, null), core["ɵqud"](603979776, 1, { panels: 1 }), (_l()(), core["ɵeld"](48, 0, null, null, 5, "ngb-panel", [["id", "measure"]], null, null, null, null, null)), core["ɵdid"](49, 2113536, [[1, 4]], 2, NgbPanel, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 2, { titleTpls: 1 }), core["ɵqud"](603979776, 3, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_CubeComponent_29)), core["ɵdid"](53, 16384, [[3, 4]], 0, NgbPanelContent, [core["TemplateRef"]], null, null), (_l()(), core["ɵeld"](54, 0, null, null, 11, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](55, 0, null, null, 10, "div", [["class", "light-bg col-lg-12 col-md-12 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](56, 0, null, null, 9, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group accordionss"]], null, null, null, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 8, "ngb-accordion", [["class", "w-100 accordion"], ["role", "tablist"]], [[1, "aria-multiselectable", 0]], null, null, View_NgbAccordion_0, RenderType_NgbAccordion)), core["ɵdid"](58, 2146304, null, 1, accordion_NgbAccordion, [NgbAccordionConfig], { activeIds: [0, "activeIds"] }, null), core["ɵqud"](603979776, 4, { panels: 1 }), (_l()(), core["ɵeld"](60, 0, null, null, 5, "ngb-panel", [["id", "dimension"]], null, null, null, null, null)), core["ɵdid"](61, 2113536, [[4, 4]], 2, NgbPanel, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 5, { titleTpls: 1 }), core["ɵqud"](603979776, 6, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_CubeComponent_34)), core["ɵdid"](65, 16384, [[6, 4]], 0, NgbPanelContent, [core["TemplateRef"]], null, null), (_l()(), core["ɵeld"](66, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](67, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"], ["id", "save "]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save "]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = "none"; _ck(_v, 7, 0, currVal_0); var currVal_1 = "none"; _ck(_v, 8, 0, currVal_1); var currVal_2 = _co.recordList; _ck(_v, 11, 0, currVal_2); var currVal_10 = _co.dataVersionType; _ck(_v, 19, 0, currVal_10); var currVal_11 = ((_co.dataVersionType == "Static") ? true : false); _ck(_v, 31, 0, currVal_11); var currVal_19 = _co.cubeData.enableCache; _ck(_v, 39, 0, currVal_19); var currVal_21 = core["ɵinlineInterpolate"](1, "", _co.openMeasureMapping, ""); _ck(_v, 46, 0, currVal_21); var currVal_22 = "measure"; var currVal_23 = _co.getTitle("measure"); _ck(_v, 49, 0, currVal_22, currVal_23); var currVal_25 = core["ɵinlineInterpolate"](1, "", _co.openDimensionMapping, ""); _ck(_v, 58, 0, currVal_25); var currVal_26 = "dimension"; var currVal_27 = _co.getTitle("dimension"); _ck(_v, 61, 0, currVal_26, currVal_27); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵnov"](_v, 21).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 21).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 21).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 21).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 21).ngClassValid; var currVal_8 = core["ɵnov"](_v, 21).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 21).ngClassPending; _ck(_v, 16, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_12 = core["ɵnov"](_v, 41).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 41).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 41).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 41).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 41).ngClassValid; var currVal_17 = core["ɵnov"](_v, 41).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 41).ngClassPending; _ck(_v, 36, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); var currVal_20 = !core["ɵnov"](_v, 46).closeOtherPanels; _ck(_v, 45, 0, currVal_20); var currVal_24 = !core["ɵnov"](_v, 58).closeOtherPanels; _ck(_v, 57, 0, currVal_24); var currVal_28 = _co.saveButton; _ck(_v, 67, 0, currVal_28); });
}
function View_CubeComponent_21(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 45, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_22)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_23)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 34, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["placeholder", " Cube Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 2, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_24)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](33, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["placeholder", "Description (Optional)"], ["rows", "1"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 35)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 35).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 35)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 35)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeData.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](35, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](36, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](39, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](41, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_25)), core["ɵdid"](43, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_26)), core["ɵdid"](45, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.cubeData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_13 = _co.cubeData.dataSourceData; _ck(_v, 28, 0, currVal_13); var currVal_22 = "350"; _ck(_v, 36, 0, currVal_22); var currVal_23 = "description"; var currVal_24 = _co.cubeData.description; _ck(_v, 39, 0, currVal_23, currVal_24); var currVal_25 = !_co.isEdit; _ck(_v, 43, 0, currVal_25); var currVal_26 = _co.isEdit; _ck(_v, 45, 0, currVal_26); }, function (_ck, _v) { var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_14 = (core["ɵnov"](_v, 36).maxlength ? core["ɵnov"](_v, 36).maxlength : null); var currVal_15 = core["ɵnov"](_v, 41).ngClassUntouched; var currVal_16 = core["ɵnov"](_v, 41).ngClassTouched; var currVal_17 = core["ɵnov"](_v, 41).ngClassPristine; var currVal_18 = core["ɵnov"](_v, 41).ngClassDirty; var currVal_19 = core["ɵnov"](_v, 41).ngClassValid; var currVal_20 = core["ɵnov"](_v, 41).ngClassInvalid; var currVal_21 = core["ɵnov"](_v, 41).ngClassPending; _ck(_v, 34, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21); });
}
function View_CubeComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_21)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.cubePage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_CubeComponent_41(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "measureEditor", [], null, [[null, "triggerSave"], [null, "triggerBack"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("triggerSave" === en)) {
                var pd_0 = (_co.afterSavingMeasure($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("triggerBack" === en)) {
                var pd_1 = (_co.comingBackFromMeasureScreen() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_MeasureEditComponent_0, RenderType_MeasureEditComponent)), core["ɵdid"](1, 573440, null, 0, measureEdit_component_MeasureEditComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"], platform_browser["c" /* DomSanitizer */], ngbDateConverter_utils_NgbDateConverter, ngbTimeConverter_utils_NgbTimeConverter], { measureData: [0, "measureData"] }, { triggerSave: "triggerSave", triggerBack: "triggerBack" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.measureData; _ck(_v, 1, 0, currVal_0); }, null);
}
function View_CubeComponent_42(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "dimensionEditor", [], null, [[null, "triggerSave"], [null, "triggerBack"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("triggerSave" === en)) {
                var pd_0 = (_co.afterSavingDimension($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("triggerBack" === en)) {
                var pd_1 = (_co.comingBackFromDimensionScreen() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DimensionEditComponent_0, RenderType_DimensionEditComponent)), core["ɵdid"](1, 573440, null, 0, dimensionEdit_component_DimensionEditComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], { dimensionData: [0, "dimensionData"] }, { triggerSave: "triggerSave", triggerBack: "triggerBack" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.dimensionData; _ck(_v, 1, 0, currVal_0); }, null);
}
function View_CubeComponent_43(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_CubeComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, null, null, null, null, function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("scroll" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("scroll" === en)) {
                var pd_1 = (_co.windowPosition() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, clickOutside_ScrollDirective, [core["ElementRef"]], null, { scroll: "scroll" }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_41)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_42)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_43)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.measurePage; _ck(_v, 5, 0, currVal_1); var currVal_2 = _co.dimensionPage; _ck(_v, 7, 0, currVal_2); var currVal_3 = _co.loader; _ck(_v, 9, 0, currVal_3); }, null);
}
function View_CubeComponent_0(_l) { return core["ɵvid"](0, [core["ɵpid"](0, common["DatePipe"], [core["LOCALE_ID"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CubeComponent_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 2, 0, currVal_0); }, null); }
function View_CubeComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "cube", [], null, null, null, View_CubeComponent_0, RenderType_CubeComponent)), core["ɵdid"](1, 114688, null, 0, cube_component_CubeComponent, [mdmService_service_MDMService, ToasterComponent, ngbDateConverter_utils_NgbDateConverter, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CubeComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("cube", cube_component_CubeComponent, View_CubeComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/measure.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_measureEdit.component.ngfactory,_measureEdit.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent,_angular_platform_browser,_.._common_service_ngbDateConverter.utils,_.._common_service_ngbTimeConverter.utils,_loader.component.ngfactory,_loader.component,_measure.component PURE_IMPORTS_END */


















var styles_MeasureComponent = [];
var RenderType_MeasureComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_MeasureComponent, data: {} });

function View_MeasureComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["MEASURE"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewMeasure() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Measure "]))], null, null);
}
function View_MeasureComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editMeasure(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeMeasure(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], null, null);
}
function View_MeasureComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 31, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, [" ", " "])), (_l()(), core["ɵeld"](17, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](18, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](20, null, [" ", " "])), (_l()(), core["ɵeld"](21, 16777216, null, null, 5, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](22, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵppd"](23, 2), (_l()(), core["ɵeld"](24, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](25, null, [" ", " "])), core["ɵppd"](26, 2), (_l()(), core["ɵeld"](27, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_6)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.measureCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.measureDisplayName, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.description, ""); _ck(_v, 10, 0, currVal_4); var currVal_6 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.cubeName, ""); _ck(_v, 14, 0, currVal_6); var currVal_8 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.recordFormatName, ""); _ck(_v, 18, 0, currVal_8); var currVal_10 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 22, 0, _ck(_v, 23, 0, core["ɵnov"](_v.parent.parent.parent.parent, 0), _v.context.$implicit.dataVersion, _co.mediumDate)), ""); _ck(_v, 22, 0, currVal_10); var currVal_13 = ((_co.selectedMeasureId == _v.context.$implicit.id) ? true : false); _ck(_v, 31, 0, currVal_13); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _v.context.$implicit.measureCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.measureDisplayName; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.description; _ck(_v, 12, 0, currVal_5); var currVal_7 = _v.context.$implicit.cubeName; _ck(_v, 16, 0, currVal_7); var currVal_9 = _v.context.$implicit.recordFormatName; _ck(_v, 20, 0, currVal_9); var currVal_11 = core["ɵunv"](_v, 25, 0, _ck(_v, 26, 0, core["ɵnov"](_v.parent.parent.parent.parent, 0), _v.context.$implicit.dataVersion, _co.mediumDate)); _ck(_v, 25, 0, currVal_11); var currVal_12 = _v.context.$implicit.id; _ck(_v, 27, 0, currVal_12); });
}
function View_MeasureComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_MeasureComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_8)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_MeasureComponent_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalMeasures; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_MeasureComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 74, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.measureReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPMeasure() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search "])), (_l()(), core["ɵeld"](14, 0, null, null, 29, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 28, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](17, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](18, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](20, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](21, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](22, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](24, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](25, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](26, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](28, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Cube Name"]], null, null, null, null, null)), core["ɵdid"](29, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](30, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Cube Name "])), (_l()(), core["ɵeld"](32, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Record Format Name"]], null, null, null, null, null)), core["ɵdid"](33, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](34, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Record Format Name "])), (_l()(), core["ɵeld"](36, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Data Version"]], null, null, null, null, null)), core["ɵdid"](37, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](38, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Data Version "])), (_l()(), core["ɵeld"](40, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](41, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](42, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_5)), core["ɵdid"](45, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_7)), core["ɵdid"](47, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](48, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](49, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](51, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](52, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](54, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 55).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 55).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](55, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](57, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](59, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](60, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](61, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](62, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](64, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](65, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](66, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](68, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](69, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](70, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](72, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_9)), core["ɵdid"](74, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.measureReg; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = "Code"; _ck(_v, 17, 0, currVal_11); var currVal_12 = "Name"; _ck(_v, 21, 0, currVal_12); var currVal_13 = "Description"; _ck(_v, 25, 0, currVal_13); var currVal_14 = "Cube Name"; _ck(_v, 29, 0, currVal_14); var currVal_15 = "Record Format Name"; _ck(_v, 33, 0, currVal_15); var currVal_16 = "Data Version"; _ck(_v, 37, 0, currVal_16); var currVal_17 = "Actions"; _ck(_v, 41, 0, currVal_17); var currVal_18 = _co.measureList; _ck(_v, 45, 0, currVal_18); var currVal_19 = (_co.measureList.length == 0); _ck(_v, 47, 0, currVal_19); var currVal_30 = _co.pageSize; _ck(_v, 57, 0, currVal_30); var currVal_31 = "10"; _ck(_v, 61, 0, currVal_31); var currVal_32 = "10"; _ck(_v, 62, 0, currVal_32); var currVal_33 = "20"; _ck(_v, 65, 0, currVal_33); var currVal_34 = "20"; _ck(_v, 66, 0, currVal_34); var currVal_35 = "30"; _ck(_v, 69, 0, currVal_35); var currVal_36 = "30"; _ck(_v, 70, 0, currVal_36); var currVal_37 = (_co.measureList && _co.measureList.length); _ck(_v, 74, 0, currVal_37); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_20 = _co.startingPage; var currVal_21 = _co.endingPage; var currVal_22 = _co.totalMeasures; _ck(_v, 50, 0, currVal_20, currVal_21, currVal_22); var currVal_23 = core["ɵnov"](_v, 59).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 59).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 59).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 59).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 59).ngClassValid; var currVal_28 = core["ɵnov"](_v, 59).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 59).ngClassPending; _ck(_v, 54, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); });
}
function View_MeasureComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "measureEditor", [], null, [[null, "triggerSave"], [null, "triggerBack"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("triggerSave" === en)) {
                var pd_0 = (_co.loadAfterSaveOrEdit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("triggerBack" === en)) {
                var pd_1 = (_co.onBack() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_MeasureEditComponent_0, RenderType_MeasureEditComponent)), core["ɵdid"](1, 573440, null, 0, measureEdit_component_MeasureEditComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"], platform_browser["c" /* DomSanitizer */], ngbDateConverter_utils_NgbDateConverter, ngbTimeConverter_utils_NgbTimeConverter], { measureData: [0, "measureData"], isEdit: [1, "isEdit"] }, { triggerSave: "triggerSave", triggerBack: "triggerBack" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.measureData; var currVal_1 = _co.isEdit; _ck(_v, 1, 0, currVal_0, currVal_1); }, null);
}
function View_MeasureComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_10)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.measurePage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_MeasureComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_MeasureComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_11)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_MeasureComponent_0(_l) { return core["ɵvid"](0, [core["ɵpid"](0, common["DatePipe"], [core["LOCALE_ID"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MeasureComponent_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 2, 0, currVal_0); }, null); }
function View_MeasureComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "measure", [], null, null, null, View_MeasureComponent_0, RenderType_MeasureComponent)), core["ɵdid"](1, 114688, null, 0, measure_component_MeasureComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"], ngbDateConverter_utils_NgbDateConverter, ngbTimeConverter_utils_NgbTimeConverter], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MeasureComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("measure", measure_component_MeasureComponent, View_MeasureComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/uom.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_loader.component.ngfactory,_loader.component,_uom.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent PURE_IMPORTS_END */













var styles_UomComponent = [];
var RenderType_UomComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_UomComponent, data: {} });

function View_UomComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["UOM"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewUom() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add UOM"]))], null, null);
}
function View_UomComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Code"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Description"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "Actions"; _ck(_v, 15, 0, currVal_3); }, null); }
function View_UomComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up mr-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clickEdit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeUom(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], null, null);
}
function View_UomComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_7)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.uomCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.uomDesc, ""); _ck(_v, 10, 0, currVal_4); var currVal_7 = ((_co.selectedUomId == _v.context.$implicit.id) ? true : false); _ck(_v, 17, 0, currVal_7); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.uomCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.name; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.uomDesc; _ck(_v, 12, 0, currVal_5); var currVal_6 = _v.context.$implicit.id; _ck(_v, 13, 0, currVal_6); });
}
function View_UomComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_UomComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_9)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_UomComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalUom; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_UomComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.uomReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPUom() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_5)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_6)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_8)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](23, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](26, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_10)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.uomReg; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = (_co.uomList && _co.uomList.length); _ck(_v, 15, 0, currVal_11); var currVal_12 = _co.uomList; _ck(_v, 17, 0, currVal_12); var currVal_13 = (_co.uomList.length == 0); _ck(_v, 19, 0, currVal_13); var currVal_24 = _co.pageSize; _ck(_v, 29, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 33, 0, currVal_25); var currVal_26 = "10"; _ck(_v, 34, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 37, 0, currVal_27); var currVal_28 = "20"; _ck(_v, 38, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 41, 0, currVal_29); var currVal_30 = "30"; _ck(_v, 42, 0, currVal_30); var currVal_31 = (_co.uomList && _co.uomList.length); _ck(_v, 46, 0, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_14 = _co.startingPage; var currVal_15 = _co.endingPage; var currVal_16 = _co.totalUom; _ck(_v, 22, 0, currVal_14, currVal_15, currVal_16); var currVal_17 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 31).ngClassValid; var currVal_22 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); });
}
function View_UomComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add UOM "]))], null, null); }
function View_UomComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit UOM - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.uomData.uomCode; _ck(_v, 1, 0, currVal_0); }); }
function View_UomComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 41, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_12)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_13)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 30, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["placeholder", " UOM Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.uomData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](30, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["placeholder", "Description (Optional)"], ["rows", "3"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 32)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 32).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 32)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 32)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.uomData.uomDesc = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](32, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](33, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](36, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](38, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](39, 0, null, null, 2, "div", [["class", "col-lg-6 col-md-6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.uomData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_21 = "350"; _ck(_v, 33, 0, currVal_21); var currVal_22 = "description"; var currVal_23 = _co.uomData.uomDesc; _ck(_v, 36, 0, currVal_22, currVal_23); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_13 = (core["ɵnov"](_v, 33).maxlength ? core["ɵnov"](_v, 33).maxlength : null); var currVal_14 = core["ɵnov"](_v, 38).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 38).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 38).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 38).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 38).ngClassValid; var currVal_19 = core["ɵnov"](_v, 38).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 38).ngClassPending; _ck(_v, 31, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_24 = _co.saveButton; _ck(_v, 40, 0, currVal_24); });
}
function View_UomComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_11)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.uomPage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_UomComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_UomComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_14)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_UomComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_UomComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 1, 0, currVal_0); }, null); }
function View_UomComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "uom", [], null, null, null, View_UomComponent_0, RenderType_UomComponent)), core["ɵdid"](1, 114688, null, 0, uom_component_UomComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var UomComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("uom", uom_component_UomComponent, View_UomComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/scope.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_loader.component.ngfactory,_loader.component,_scope.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent PURE_IMPORTS_END */













var styles_ScopeComponent = [];
var RenderType_ScopeComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ScopeComponent, data: {} });

function View_ScopeComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["SCOPE"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewScope() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Scope"]))], null, null);
}
function View_ScopeComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Name"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Description"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Actions"; _ck(_v, 11, 0, currVal_2); }, null); }
function View_ScopeComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clickEdit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeScope(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], null, null);
}
function View_ScopeComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_7)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.scopeDesc, ""); _ck(_v, 6, 0, currVal_2); var currVal_5 = ((_co.selectedScopeId == _v.context.$implicit.id) ? true : false); _ck(_v, 13, 0, currVal_5); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.name; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.scopeDesc; _ck(_v, 8, 0, currVal_3); var currVal_4 = _v.context.$implicit.id; _ck(_v, 9, 0, currVal_4); });
}
function View_ScopeComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_ScopeComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_9)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_ScopeComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalScope; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_ScopeComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 33, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_5)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_6)), core["ɵdid"](4, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_8)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](10, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](13, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 14).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 14).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](14, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](16, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](18, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](19, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](20, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](21, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](23, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](24, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](25, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](27, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](28, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](29, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](31, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_10)), core["ɵdid"](33, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.scopeList && _co.scopeList.length); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.scopeList; _ck(_v, 4, 0, currVal_1); var currVal_2 = (_co.scopeList.length == 0); _ck(_v, 6, 0, currVal_2); var currVal_13 = _co.pageSize; _ck(_v, 16, 0, currVal_13); var currVal_14 = "10"; _ck(_v, 20, 0, currVal_14); var currVal_15 = "10"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "20"; _ck(_v, 24, 0, currVal_16); var currVal_17 = "20"; _ck(_v, 25, 0, currVal_17); var currVal_18 = "30"; _ck(_v, 28, 0, currVal_18); var currVal_19 = "30"; _ck(_v, 29, 0, currVal_19); var currVal_20 = (_co.scopeList && _co.scopeList.length); _ck(_v, 33, 0, currVal_20); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = _co.startingPage; var currVal_4 = _co.endingPage; var currVal_5 = _co.totalScope; _ck(_v, 9, 0, currVal_3, currVal_4, currVal_5); var currVal_6 = core["ɵnov"](_v, 18).ngClassUntouched; var currVal_7 = core["ɵnov"](_v, 18).ngClassTouched; var currVal_8 = core["ɵnov"](_v, 18).ngClassPristine; var currVal_9 = core["ɵnov"](_v, 18).ngClassDirty; var currVal_10 = core["ɵnov"](_v, 18).ngClassValid; var currVal_11 = core["ɵnov"](_v, 18).ngClassInvalid; var currVal_12 = core["ɵnov"](_v, 18).ngClassPending; _ck(_v, 13, 0, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12); });
}
function View_ScopeComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Scope "]))], null, null); }
function View_ScopeComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit Scope "]))], null, null); }
function View_ScopeComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 41, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_12)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_13)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 30, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["placeholder", " Scope Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.scopeData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](30, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["placeholder", "Description (Optional)"], ["rows", "3"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 32)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 32).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 32)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 32)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.scopeData.scopeDesc = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](32, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](33, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](36, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](38, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](39, 0, null, null, 2, "div", [["class", "col-lg-6 col-md-6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.scopeData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_21 = "350"; _ck(_v, 33, 0, currVal_21); var currVal_22 = "description"; var currVal_23 = _co.scopeData.scopeDesc; _ck(_v, 36, 0, currVal_22, currVal_23); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_13 = (core["ɵnov"](_v, 33).maxlength ? core["ɵnov"](_v, 33).maxlength : null); var currVal_14 = core["ɵnov"](_v, 38).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 38).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 38).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 38).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 38).ngClassValid; var currVal_19 = core["ɵnov"](_v, 38).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 38).ngClassPending; _ck(_v, 31, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_24 = _co.saveButton; _ck(_v, 40, 0, currVal_24); });
}
function View_ScopeComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_11)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.scopePage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_ScopeComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 2, 0, currVal_0); }, null); }
function View_ScopeComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_ScopeComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ScopeComponent_14)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 3, 0, currVal_1); }, null); }
function View_ScopeComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "scope", [], null, null, null, View_ScopeComponent_0, RenderType_ScopeComponent)), core["ɵdid"](1, 114688, null, 0, scope_component_ScopeComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ScopeComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("scope", scope_component_ScopeComponent, View_ScopeComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/dimension.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_dimensionEdit.component.ngfactory,_dimensionEdit.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent,_loader.component.ngfactory,_loader.component,_dimension.component PURE_IMPORTS_END */















var styles_DimensionComponent = [];
var RenderType_DimensionComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_DimensionComponent, data: {} });

function View_DimensionComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["DIMENSION"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDimension() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Dimension "]))], null, null);
}
function View_DimensionComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Code"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Description"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "Actions"; _ck(_v, 15, 0, currVal_3); }, null); }
function View_DimensionComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editDimension(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeDimension(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], null, null);
}
function View_DimensionComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 0, "h6", [["class", "mb-lg-0 text-truncate"]], [[8, "innerHTML", 1]], null, null, null, null)), (_l()(), core["ɵeld"](8, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](9, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), (_l()(), core["ɵeld"](12, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_7)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dimCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.description, ""); _ck(_v, 9, 0, currVal_4); var currVal_7 = ((_co.selectedDimId == _v.context.$implicit.id) ? true : false); _ck(_v, 16, 0, currVal_7); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.dimCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = (!!_v.context.$implicit.displayName ? _v.context.$implicit.displayName : _v.context.$implicit.name); _ck(_v, 7, 0, currVal_3); var currVal_5 = _v.context.$implicit.description; _ck(_v, 11, 0, currVal_5); var currVal_6 = _v.context.$implicit.id; _ck(_v, 12, 0, currVal_6); });
}
function View_DimensionComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_DimensionComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_9)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DimensionComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalDimensions; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_DimensionComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dimRegex = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPDim() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_5)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_6)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_8)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](23, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](26, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_10)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.dimRegex; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = (_co.dimensionList && _co.dimensionList.length); _ck(_v, 15, 0, currVal_11); var currVal_12 = _co.dimensionList; _ck(_v, 17, 0, currVal_12); var currVal_13 = (_co.dimensionList.length == 0); _ck(_v, 19, 0, currVal_13); var currVal_24 = _co.pageSize; _ck(_v, 29, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 33, 0, currVal_25); var currVal_26 = "10"; _ck(_v, 34, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 37, 0, currVal_27); var currVal_28 = "20"; _ck(_v, 38, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 41, 0, currVal_29); var currVal_30 = "30"; _ck(_v, 42, 0, currVal_30); var currVal_31 = (_co.dimensionList && _co.dimensionList.length); _ck(_v, 46, 0, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_14 = _co.startingPage; var currVal_15 = _co.endingPage; var currVal_16 = _co.totalDimensions; _ck(_v, 22, 0, currVal_14, currVal_15, currVal_16); var currVal_17 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 31).ngClassValid; var currVal_22 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); });
}
function View_DimensionComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "dimensionEditor", [], null, [[null, "triggerSave"], [null, "triggerBack"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("triggerSave" === en)) {
                var pd_0 = (_co.loadAfterSaveOrEdit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("triggerBack" === en)) {
                var pd_1 = (_co.onBack() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DimensionEditComponent_0, RenderType_DimensionEditComponent)), core["ɵdid"](1, 573440, null, 0, dimensionEdit_component_DimensionEditComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], { dimensionData: [0, "dimensionData"], isEdit: [1, "isEdit"] }, { triggerSave: "triggerSave", triggerBack: "triggerBack" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.dimensionData; var currVal_1 = _co.isEdit; _ck(_v, 1, 0, currVal_0, currVal_1); }, null);
}
function View_DimensionComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_11)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.dimensionPage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_DimensionComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_DimensionComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_12)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_DimensionComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_DimensionComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 1, 0, currVal_0); }, null); }
function View_DimensionComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "dimension", [], null, null, null, View_DimensionComponent_0, RenderType_DimensionComponent)), core["ɵdid"](1, 114688, null, 0, dimension_component_DimensionComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DimensionComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("dimension", dimension_component_DimensionComponent, View_DimensionComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/valueStream.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_loader.component.ngfactory,_loader.component,_valueStream.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent PURE_IMPORTS_END */













var styles_ValueStreamComponent = [];
var RenderType_ValueStreamComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ValueStreamComponent, data: {} });

function View_ValueStreamComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["VALUE STREAM"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewVs() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Value Stream "]))], null, null);
}
function View_ValueStreamComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Code"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Description"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "Actions"; _ck(_v, 15, 0, currVal_3); }, null); }
function View_ValueStreamComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up mr-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clickEdit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeUom(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], null, null);
}
function View_ValueStreamComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_7)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.valueStreamCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.shortDesc, ""); _ck(_v, 10, 0, currVal_4); var currVal_7 = ((_co.selectedVSId == _v.context.$implicit.id) ? true : false); _ck(_v, 17, 0, currVal_7); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.valueStreamCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.name; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.shortDesc; _ck(_v, 12, 0, currVal_5); var currVal_6 = _v.context.$implicit.id; _ck(_v, 13, 0, currVal_6); });
}
function View_ValueStreamComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_ValueStreamComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_9)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_ValueStreamComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalvs; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_ValueStreamComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.vsReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPValueStream() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_5)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_6)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_8)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](23, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](26, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_10)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.vsReg; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = (_co.vsList && _co.vsList.length); _ck(_v, 15, 0, currVal_11); var currVal_12 = _co.vsList; _ck(_v, 17, 0, currVal_12); var currVal_13 = (_co.vsList.length == 0); _ck(_v, 19, 0, currVal_13); var currVal_24 = _co.pageSize; _ck(_v, 29, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 33, 0, currVal_25); var currVal_26 = "10"; _ck(_v, 34, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 37, 0, currVal_27); var currVal_28 = "20"; _ck(_v, 38, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 41, 0, currVal_29); var currVal_30 = "30"; _ck(_v, 42, 0, currVal_30); var currVal_31 = (_co.vsList && _co.vsList.length); _ck(_v, 46, 0, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_14 = _co.startingPage; var currVal_15 = _co.endingPage; var currVal_16 = _co.totalvs; _ck(_v, 22, 0, currVal_14, currVal_15, currVal_16); var currVal_17 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 31).ngClassValid; var currVal_22 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); });
}
function View_ValueStreamComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Value Stream "]))], null, null); }
function View_ValueStreamComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Value Stream - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.vsData.valueStreamCode; _ck(_v, 1, 0, currVal_0); }); }
function View_ValueStreamComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 54, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_12)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_13)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 43, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["placeholder", " Value Stream Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.vsData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Short Description "])), (_l()(), core["ɵeld"](30, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "200"], ["name", "shortDescription"], ["placeholder", "Short Description (Optional)"], ["rows", "3"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 32)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 32).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 32)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 32)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.vsData.shortDesc = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](32, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](33, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](36, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](38, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](39, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Long Description "])), (_l()(), core["ɵeld"](43, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](44, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "longDescription"], ["placeholder", "Long Description (Optional)"], ["rows", "3"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 45)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 45).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 45)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 45)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.vsData.longDesc = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](45, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](46, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](49, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](51, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](52, 0, null, null, 2, "div", [["class", "col-lg-6 col-md-6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](53, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.vsData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_21 = "200"; _ck(_v, 33, 0, currVal_21); var currVal_22 = "shortDescription"; var currVal_23 = _co.vsData.shortDesc; _ck(_v, 36, 0, currVal_22, currVal_23); var currVal_32 = "350"; _ck(_v, 46, 0, currVal_32); var currVal_33 = "longDescription"; var currVal_34 = _co.vsData.longDesc; _ck(_v, 49, 0, currVal_33, currVal_34); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_13 = (core["ɵnov"](_v, 33).maxlength ? core["ɵnov"](_v, 33).maxlength : null); var currVal_14 = core["ɵnov"](_v, 38).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 38).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 38).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 38).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 38).ngClassValid; var currVal_19 = core["ɵnov"](_v, 38).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 38).ngClassPending; _ck(_v, 31, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_24 = (core["ɵnov"](_v, 46).maxlength ? core["ɵnov"](_v, 46).maxlength : null); var currVal_25 = core["ɵnov"](_v, 51).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 51).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 51).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 51).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 51).ngClassValid; var currVal_30 = core["ɵnov"](_v, 51).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 51).ngClassPending; _ck(_v, 44, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); var currVal_35 = _co.saveButton; _ck(_v, 53, 0, currVal_35); });
}
function View_ValueStreamComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_11)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.vsPage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_ValueStreamComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_ValueStreamComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_14)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_ValueStreamComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_ValueStreamComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 1, 0, currVal_0); }, null); }
function View_ValueStreamComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "valueStream", [], null, null, null, View_ValueStreamComponent_0, RenderType_ValueStreamComponent)), core["ɵdid"](1, 114688, null, 0, valueStream_component_ValueStreamComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ValueStreamComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("valueStream", valueStream_component_ValueStreamComponent, View_ValueStreamComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/dataSource.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_dropdown_dropdown,_ng_bootstrap_ng_bootstrap_dropdown_dropdown_config,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_loader.component.ngfactory,_loader.component,_dataSource.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent PURE_IMPORTS_END */















var styles_DataSourceComponent = [];
var RenderType_DataSourceComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_DataSourceComponent, data: {} });

function View_DataSourceComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 44, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 43, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["DATA SOURCE"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 39, "div", [["aria-label", "Button group with nested dropdown"], ["class", "btn-group"], ["ngbDropdown", ""], ["role", "group"]], [[2, "show", null]], null, null, null, null)), core["ɵdid"](6, 212992, null, 2, dropdown_NgbDropdown, [core["ChangeDetectorRef"], NgbDropdownConfig, common["DOCUMENT"], core["NgZone"]], null, null), core["ɵqud"](335544320, 1, { _menu: 0 }), core["ɵqud"](335544320, 2, { _anchor: 0 }), (_l()(), core["ɵeld"](9, 0, null, null, 3, "button", [["aria-haspopup", "true"], ["class", "btn btn-primary dropdown-toggle-split dropdown-toggle"], ["ngbDropdownToggle", ""]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 10).toggleOpen() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](10, 16384, null, 0, NgbDropdownToggle, [dropdown_NgbDropdown, core["ElementRef"]], null, null), core["ɵprd"](2048, [[2, 4]], NgbDropdownAnchor, null, [NgbDropdownToggle]), (_l()(), core["ɵted"](-1, null, [" Add Connection To"])), (_l()(), core["ɵeld"](13, 0, null, null, 31, "div", [["class", "dropdown-menu"], ["ngbDropdownMenu", ""]], [[2, "dropdown-menu", null], [2, "show", null], [1, "x-placement", 0]], null, null, null, null)), core["ɵdid"](14, 16384, [[1, 4]], 0, dropdown_NgbDropdownMenu, [dropdown_NgbDropdown, core["ElementRef"], core["Renderer2"]], null, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("FILE_S3") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["S3 Storage"])), (_l()(), core["ɵeld"](17, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("FILE_SFTP") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["SFTP"])), (_l()(), core["ɵeld"](19, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("FILE_DFS") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["File System"])), (_l()(), core["ɵeld"](21, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("MONGO") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Mongo"])), (_l()(), core["ɵeld"](23, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("MYSQL") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["MYSQL"])), (_l()(), core["ɵeld"](25, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("HIVE") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Hive"])), (_l()(), core["ɵeld"](27, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("REDIS") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Redis"])), (_l()(), core["ɵeld"](29, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("REDSHIFT") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Redshift"])), (_l()(), core["ɵeld"](31, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("KAFKA") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Kafka"])), (_l()(), core["ɵeld"](33, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("MONGODB") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["MongoDB"])), (_l()(), core["ɵeld"](35, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("POSTGRESQL") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["PostgreSQL"])), (_l()(), core["ɵeld"](37, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("CASSANDRA") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Cassandra"])), (_l()(), core["ɵeld"](39, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("SQLSERVER") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["SQL Server"])), (_l()(), core["ɵeld"](41, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("HBASE") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Project in Kylin"])), (_l()(), core["ɵeld"](43, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataSource("CLICK_HOUSE") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Clickhouse"]))], function (_ck, _v) { _ck(_v, 6, 0); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 6).isOpen(); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵnov"](_v, 10).dropdown.isOpen(); _ck(_v, 9, 0, currVal_1); var currVal_2 = true; var currVal_3 = core["ɵnov"](_v, 14).dropdown.isOpen(); var currVal_4 = core["ɵnov"](_v, 14).placement; _ck(_v, 13, 0, currVal_2, currVal_3, currVal_4); });
}
function View_DataSourceComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 24, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Catalog"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Catalog "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Schema"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Schema "])), (_l()(), core["ɵeld"](18, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Username"]], null, null, null, null, null)), core["ɵdid"](19, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Username "])), (_l()(), core["ɵeld"](22, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](23, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Code"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Catalog"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "Schema"; _ck(_v, 15, 0, currVal_3); var currVal_4 = "Username"; _ck(_v, 19, 0, currVal_4); var currVal_5 = "Actions"; _ck(_v, 23, 0, currVal_5); }, null); }
function View_DataSourceComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.syncDataSource(_v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-refresh mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Sync Record Format "]))], null, null);
}
function View_DataSourceComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clickEdit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_8)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeDataSource(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], function (_ck, _v) { var currVal_0 = (_v.parent.context.$implicit.dataEngine && (((_v.parent.context.$implicit.dataEngine.type == "PRESTO") || (_v.parent.context.$implicit.dataEngine.type == "SSAS")) || (_v.parent.context.$implicit.dataEngine.type == "CLICK_HOUSE"))); _ck(_v, 7, 0, currVal_0); }, null);
}
function View_DataSourceComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, [" ", " "])), (_l()(), core["ɵeld"](17, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](18, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](20, null, [" ", " "])), (_l()(), core["ɵeld"](21, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_7)), core["ɵdid"](25, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dataSourceCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.catalog, ""); _ck(_v, 10, 0, currVal_4); var currVal_6 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.schema, ""); _ck(_v, 14, 0, currVal_6); var currVal_8 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.username, ""); _ck(_v, 18, 0, currVal_8); var currVal_11 = ((_co.selectedSourceId == _v.context.$implicit.id) ? true : false); _ck(_v, 25, 0, currVal_11); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.dataSourceCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.name; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.catalog; _ck(_v, 12, 0, currVal_5); var currVal_7 = _v.context.$implicit.schema; _ck(_v, 16, 0, currVal_7); var currVal_9 = _v.context.$implicit.username; _ck(_v, 20, 0, currVal_9); var currVal_10 = _v.context.$implicit.id; _ck(_v, 21, 0, currVal_10); });
}
function View_DataSourceComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_DataSourceComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_10)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DataSourceComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalSource; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_DataSourceComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPDataSource() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_5)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_6)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_9)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](23, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](26, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_11)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.dataSourceReg; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = (_co.dataSourceList && _co.dataSourceList.length); _ck(_v, 15, 0, currVal_11); var currVal_12 = _co.dataSourceList; _ck(_v, 17, 0, currVal_12); var currVal_13 = (_co.dataSourceList.length == 0); _ck(_v, 19, 0, currVal_13); var currVal_24 = _co.pageSize; _ck(_v, 29, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 33, 0, currVal_25); var currVal_26 = "10"; _ck(_v, 34, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 37, 0, currVal_27); var currVal_28 = "20"; _ck(_v, 38, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 41, 0, currVal_29); var currVal_30 = "30"; _ck(_v, 42, 0, currVal_30); var currVal_31 = (_co.dataSourceList && _co.dataSourceList.length); _ck(_v, 46, 0, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_14 = _co.startingPage; var currVal_15 = _co.endingPage; var currVal_16 = _co.totalSource; _ck(_v, 22, 0, currVal_14, currVal_15, currVal_16); var currVal_17 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 31).ngClassValid; var currVal_22 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); });
}
function View_DataSourceComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Data Source "]))], null, null); }
function View_DataSourceComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Data Source - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.dataSourceData.dataSourceCode; _ck(_v, 1, 0, currVal_0); }); }
function View_DataSourceComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.id; var currVal_1 = ((_co.dataSourceData.dataEngineId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_DataSourceComponent_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Catalog "])), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](6, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "catalog"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.catalog = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "200"; _ck(_v, 8, 0, currVal_8); var currVal_9 = "catalog"; var currVal_10 = _co.dataSourceData.catalog; _ck(_v, 11, 0, currVal_9, currVal_10); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 8).maxlength ? core["ɵnov"](_v, 8).maxlength : null); var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_DataSourceComponent_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Location "])), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](6, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "location"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.location = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "200"; _ck(_v, 8, 0, currVal_8); var currVal_9 = "location"; var currVal_10 = _co.dataSourceData.location; _ck(_v, 11, 0, currVal_9, currVal_10); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 8).maxlength ? core["ɵnov"](_v, 8).maxlength : null); var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_DataSourceComponent_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.connectionLabel; _ck(_v, 1, 0, currVal_0); }); }
function View_DataSourceComponent_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_19)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "Connection"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.connection = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](5, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](6, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.connectionLabel; _ck(_v, 3, 0, currVal_0); var currVal_9 = "200"; _ck(_v, 6, 0, currVal_9); var currVal_10 = "Connection"; var currVal_11 = _co.dataSourceData.connection; _ck(_v, 9, 0, currVal_10, currVal_11); }, function (_ck, _v) { var currVal_1 = (core["ɵnov"](_v, 6).maxlength ? core["ɵnov"](_v, 6).maxlength : null); var currVal_2 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 11).ngClassValid; var currVal_7 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 4, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); });
}
function View_DataSourceComponent_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Username "])), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](6, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "username"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.username = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "200"; _ck(_v, 8, 0, currVal_8); var currVal_9 = "username"; var currVal_10 = _co.dataSourceData.username; _ck(_v, 11, 0, currVal_9, currVal_10); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 8).maxlength ? core["ɵnov"](_v, 8).maxlength : null); var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_DataSourceComponent_21(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Password "])), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](6, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "password"], ["type", "password"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.newPassword = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "200"; _ck(_v, 8, 0, currVal_8); var currVal_9 = "password"; var currVal_10 = _co.dataSourceData.newPassword; _ck(_v, 11, 0, currVal_9, currVal_10); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 8).maxlength ? core["ɵnov"](_v, 8).maxlength : null); var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_DataSourceComponent_23(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 14, "div", [["class", "col-lg-6 col-md-6 "]], null, null, null, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", " "])), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](7, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "customParameter"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 8)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 8)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData[("customParameter" + (_v.context.index + 1))] = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](9, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](12, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](14, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "col-lg-6 col-md-6 "; var currVal_1 = ((((_v.context.index + 1) % 2) == 0) ? "float-left " : "float-left left-clear"); _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_11 = "200"; _ck(_v, 9, 0, currVal_11); var currVal_12 = "customParameter"; var currVal_13 = _co.dataSourceData[("customParameter" + (_v.context.index + 1))]; _ck(_v, 12, 0, currVal_12, currVal_13); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit; _ck(_v, 4, 0, currVal_2); var currVal_3 = (core["ɵnov"](_v, 9).maxlength ? core["ɵnov"](_v, 9).maxlength : null); var currVal_4 = core["ɵnov"](_v, 14).ngClassUntouched; var currVal_5 = core["ɵnov"](_v, 14).ngClassTouched; var currVal_6 = core["ɵnov"](_v, 14).ngClassPristine; var currVal_7 = core["ɵnov"](_v, 14).ngClassDirty; var currVal_8 = core["ɵnov"](_v, 14).ngClassValid; var currVal_9 = core["ɵnov"](_v, 14).ngClassInvalid; var currVal_10 = core["ɵnov"](_v, 14).ngClassPending; _ck(_v, 7, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10); });
}
function View_DataSourceComponent_22(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "w-100"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_23)), core["ɵdid"](3, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.parameters; _ck(_v, 3, 0, currVal_0); }, null); }
function View_DataSourceComponent_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 93, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_13)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_14)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 82, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Type"])), (_l()(), core["ɵeld"](30, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "type"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.type = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](31, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](32, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](35, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](37, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](38, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 11, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 3, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Engine "])), (_l()(), core["ɵeld"](42, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](44, 0, null, null, 6, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.confirmChangeOfEngine($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](46, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](47, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_15)), core["ɵdid"](50, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_16)), core["ɵdid"](52, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](53, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](55, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Schema "])), (_l()(), core["ɵeld"](57, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](59, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "schema"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 60)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 60).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 60)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 60)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.schema = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](60, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](61, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](64, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](66, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](67, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](68, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](69, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Storage Type"])), (_l()(), core["ɵeld"](71, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "storageType"], ["readonly", ""], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 72)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 72).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 72)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 72)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataSourceData.storageType = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](72, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](73, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](76, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](78, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_17)), core["ɵdid"](80, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_18)), core["ɵdid"](82, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_20)), core["ɵdid"](84, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_21)), core["ɵdid"](86, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_22)), core["ɵdid"](88, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](89, 0, null, null, 4, "div", [["class", "col-lg-3 col-md-3 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](90, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"])), (_l()(), core["ɵeld"](92, 0, null, null, 1, "button", [["class", "btn btn-primary v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onTest() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Test Connection"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.dataSourceData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_21 = "200"; _ck(_v, 32, 0, currVal_21); var currVal_22 = "type"; var currVal_23 = _co.dataSourceData.type; _ck(_v, 35, 0, currVal_22, currVal_23); var currVal_24 = "none"; _ck(_v, 46, 0, currVal_24); var currVal_25 = "none"; _ck(_v, 47, 0, currVal_25); var currVal_26 = _co.dataEngineList; _ck(_v, 50, 0, currVal_26); var currVal_27 = !_co.isSSaSS; _ck(_v, 52, 0, currVal_27); var currVal_36 = "200"; _ck(_v, 61, 0, currVal_36); var currVal_37 = "schema"; var currVal_38 = _co.dataSourceData.schema; _ck(_v, 64, 0, currVal_37, currVal_38); var currVal_47 = "200"; _ck(_v, 73, 0, currVal_47); var currVal_48 = "storageType"; var currVal_49 = _co.dataSourceData.storageType; _ck(_v, 76, 0, currVal_48, currVal_49); var currVal_50 = !_co.isSSaSS; _ck(_v, 80, 0, currVal_50); var currVal_51 = _co.isConnection; _ck(_v, 82, 0, currVal_51); var currVal_52 = !_co.isSSaSS; _ck(_v, 84, 0, currVal_52); var currVal_53 = !_co.isSSaSS; _ck(_v, 86, 0, currVal_53); var currVal_54 = (_co.parameters && (_co.parameters.length != 0)); _ck(_v, 88, 0, currVal_54); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_13 = (core["ɵnov"](_v, 32).maxlength ? core["ɵnov"](_v, 32).maxlength : null); var currVal_14 = core["ɵnov"](_v, 37).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 37).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 37).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 37).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 37).ngClassValid; var currVal_19 = core["ɵnov"](_v, 37).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 37).ngClassPending; _ck(_v, 30, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_28 = (core["ɵnov"](_v, 61).maxlength ? core["ɵnov"](_v, 61).maxlength : null); var currVal_29 = core["ɵnov"](_v, 66).ngClassUntouched; var currVal_30 = core["ɵnov"](_v, 66).ngClassTouched; var currVal_31 = core["ɵnov"](_v, 66).ngClassPristine; var currVal_32 = core["ɵnov"](_v, 66).ngClassDirty; var currVal_33 = core["ɵnov"](_v, 66).ngClassValid; var currVal_34 = core["ɵnov"](_v, 66).ngClassInvalid; var currVal_35 = core["ɵnov"](_v, 66).ngClassPending; _ck(_v, 59, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35); var currVal_39 = (core["ɵnov"](_v, 73).maxlength ? core["ɵnov"](_v, 73).maxlength : null); var currVal_40 = core["ɵnov"](_v, 78).ngClassUntouched; var currVal_41 = core["ɵnov"](_v, 78).ngClassTouched; var currVal_42 = core["ɵnov"](_v, 78).ngClassPristine; var currVal_43 = core["ɵnov"](_v, 78).ngClassDirty; var currVal_44 = core["ɵnov"](_v, 78).ngClassValid; var currVal_45 = core["ɵnov"](_v, 78).ngClassInvalid; var currVal_46 = core["ɵnov"](_v, 78).ngClassPending; _ck(_v, 71, 0, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46); var currVal_55 = _co.saveButton; _ck(_v, 90, 0, currVal_55); });
}
function View_DataSourceComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_12)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.dataSourcePage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_DataSourceComponent_24(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_DataSourceComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_24)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_DataSourceComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataSourceComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 1, 0, currVal_0); }, null); }
function View_DataSourceComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "dataSource", [], null, null, null, View_DataSourceComponent_0, RenderType_DataSourceComponent)), core["ɵdid"](1, 114688, null, 0, dataSource_component_DataSourceComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DataSourceComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("dataSource", dataSource_component_DataSourceComponent, View_DataSourceComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/shared/services/fileService.ts




var fileService_FileService = /*@__PURE__*/ (function () {
    function FileService(http, _global, router, _toaster) {
        this.http = http;
        this._global = _global;
        this.router = router;
        this._toaster = _toaster;
        this._baseUrl = _global.get('EPMS_BASE_URL');
    }
    FileService.prototype.download = function (url, filename, type) {
        var self = this;
        try {
            self.http.get(url, { responseType: 'arraybuffer' }).subscribe(function (response) {
                var blob = new Blob([response], { type: type });
                FileSaver["saveAs"](blob, filename);
            }, function (err) {
                self._toaster.showError('Download Failed');
            });
        }
        catch (e) {
            console.log('Error in downloadFile::', e);
        }
    };
    FileService.prototype.downloadFile = function (fileDetails) {
        var _this = this;
        try {
            // loading
            var url = this._baseUrl + 'v1/hub/scorecard/downloadDoc/' + fileDetails.docId;
            this.http.get(url).subscribe(function (res) {
                var downloadedFileDate = res;
                var FileName = downloadedFileDate.docName + '.' + downloadedFileDate.docType;
                if (downloadedFileDate.docName == null) {
                    _this.showToast('errDownload');
                    return;
                }
                var byteCharacters = atob(downloadedFileDate.document);
                var byteNumbers = new Array(byteCharacters.length);
                var byteArray = new Uint8Array(byteNumbers);
                for (var i = 0; i < byteCharacters.length; i++) {
                    byteArray[i] = byteCharacters.charCodeAt(i);
                }
                var blob = new Blob([byteArray], { type: downloadedFileDate.docType });
                FileSaver["saveAs"](blob, FileName);
            }, function (err) {
                // this.dismissLoading();
                _this.showToast('downloadFailed');
            });
        }
        catch (e) {
            console.log('Error in downloadFile::', e);
        }
    };
    FileService.prototype.downloadPdfByScorecard = function (scorecardId, reviewId) {
        var _this = this;
        var self = this;
        var url = this._baseUrl +
            'v1/hub/scorecard/downloadReportByScorecard?reportFormat=PDF&scorecardId='
            + scorecardId;
        if (reviewId != null) {
            url += '&reviewId=' + reviewId;
        }
        this.http.get(url).subscribe(function (result) {
            setTimeout(window.open(_this._baseUrl +
                'noAuth/downloadScorecardPdf/' + result.text()), 1000);
        }, function (err) {
            console.log(err);
        });
    };
    FileService.prototype.downloadPdfBySnapshot = function (snapshotId, reviewId) {
        var _this = this;
        var self = this;
        var url = this._baseUrl + 'v1/hub/scorecard/downloadReportBySnapshot?'
            + 'reportFormat=PDF&snapshotId=' + snapshotId;
        if (reviewId != null) {
            url += '&reviewId=' + reviewId;
        }
        this.http.get(url).subscribe(function (result) {
            setTimeout(window.open(_this._baseUrl
                + 'noAuth/downloadScorecardPdf/' + result.text()), 1000);
        }, function (err) {
            console.log(err);
        });
    };
    FileService.prototype.showToast = function (err) {
        alert('msg');
    };
    FileService.prototype.downloadScorecardSummary = function (entitiName, programId, format) {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/performance/getSummaryBasedScorecard/' + entitiName + "/" + programId + "/" + format;
        return self.http.getBlob(url).subscribe(function (result) {
            if (result.status == 204) {
                _this._toaster.showError("No Records found to generate report");
            }
            else {
                var blob = result.body;
                var filename = result.headers.get("content-disposition").split("=")[1];
                FileSaver["saveAs"](blob, filename);
            }
        }), function (err) {
            console.log("TTTTTTTTTTTTTTTTtttt");
        };
    };
    return FileService;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/recordFormat.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_loader.component.ngfactory,_loader.component,_recordFormat.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent,_.._.._shared_services_fileService,_ng_bootstrap_ng_bootstrap_modal_modal,_.._.._shared_services_configuration PURE_IMPORTS_END */
















var styles_RecordFormatComponent = [];
var RenderType_RecordFormatComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_RecordFormatComponent, data: {} });

function View_RecordFormatComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["RECORD FORMAT"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.uploadFile() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Upload File"])), (_l()(), core["ɵeld"](7, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "add"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewRecord() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Record Format "]))], null, null);
}
function View_RecordFormatComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Code"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Description"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "Actions"; _ck(_v, 15, 0, currVal_3); }, null); }
function View_RecordFormatComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.syncRecordFormat(_v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-refresh mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Sync Cube "]))], null, null);
}
function View_RecordFormatComponent_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.uploadFile("reUpLoad", _v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-upload mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Re Upload "]))], null, null);
}
function View_RecordFormatComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadFile(_v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "a", [["class", "link"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "i", [["class", "fa fa-download mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Download"]))], null, null);
}
function View_RecordFormatComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 14, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 12, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clickEdit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_8)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_9)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_10)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeRecord(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], function (_ck, _v) { var currVal_0 = (_v.parent.context.$implicit.dataEngineType && (_v.parent.context.$implicit.dataEngineType == "DRILL")); _ck(_v, 7, 0, currVal_0); var currVal_1 = _v.parent.context.$implicit.uploadAllowed; _ck(_v, 9, 0, currVal_1); var currVal_2 = ((_v.parent.context.$implicit && _v.parent.context.$implicit.id) && _v.parent.context.$implicit.downloadable); _ck(_v, 11, 0, currVal_2); }, null);
}
function View_RecordFormatComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_7)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.recordFormatCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.displayName, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.description, ""); _ck(_v, 10, 0, currVal_4); var currVal_7 = ((_co.selectedRFId == _v.context.$implicit.id) ? true : false); _ck(_v, 17, 0, currVal_7); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.recordFormatCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.displayName; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.description; _ck(_v, 12, 0, currVal_5); var currVal_6 = _v.context.$implicit.id; _ck(_v, 13, 0, currVal_6); });
}
function View_RecordFormatComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_RecordFormatComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_12)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_RecordFormatComponent_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalRecords; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_RecordFormatComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.recordFormatReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPRecordFormat() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_5)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_6)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_11)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center mb-5"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](23, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](26, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_13)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.recordFormatReg; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = (_co.recordList && _co.recordList.length); _ck(_v, 15, 0, currVal_11); var currVal_12 = _co.recordList; _ck(_v, 17, 0, currVal_12); var currVal_13 = (_co.recordList.length == 0); _ck(_v, 19, 0, currVal_13); var currVal_24 = _co.pageSize; _ck(_v, 29, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 33, 0, currVal_25); var currVal_26 = "10"; _ck(_v, 34, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 37, 0, currVal_27); var currVal_28 = "20"; _ck(_v, 38, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 41, 0, currVal_29); var currVal_30 = "30"; _ck(_v, 42, 0, currVal_30); var currVal_31 = (_co.recordList && _co.recordList.length); _ck(_v, 46, 0, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_14 = (_co.startingPage + 1); var currVal_15 = _co.endingPage; var currVal_16 = _co.totalRecords; _ck(_v, 22, 0, currVal_14, currVal_15, currVal_16); var currVal_17 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 31).ngClassValid; var currVal_22 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); });
}
function View_RecordFormatComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Record Format "]))], null, null); }
function View_RecordFormatComponent_16(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Record Format - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.recordData.recordFormatCode; _ck(_v, 1, 0, currVal_0); }); }
function View_RecordFormatComponent_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.id; var currVal_1 = ((_co.recordData.dataSourceId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_RecordFormatComponent_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "addRecordFields"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addRecordFormatFields() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Record Format Fields "]))], null, null);
}
function View_RecordFormatComponent_19(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 73, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 13, "div", [], null, null, null, null, null)), core["ɵdid"](2, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngClass: [0, "ngClass"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Field Name "])), (_l()(), core["ɵeld"](6, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 7, "input", [["class", "form-control"], ["id", "fieldName"], ["maxlength", "100"], ["placeholder", "Record Format Field Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 8)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 8)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.recordFormatData.fieldName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](9, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](12, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](14, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](15, 0, null, null, 13, "div", [], null, null, null, null, null)), core["ɵdid"](16, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngClass: [0, "ngClass"] }, null), (_l()(), core["ɵeld"](17, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Field Display Name "])), (_l()(), core["ɵeld"](20, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 7, "input", [["class", "form-control"], ["id", "fieldDisplayName"], ["maxlength", "100"], ["placeholder", "Record Format Field Display Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.recordFormatData.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](26, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](28, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](29, 0, null, null, 31, "div", [], null, null, null, null, null)), core["ɵdid"](30, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngClass: [0, "ngClass"] }, null), (_l()(), core["ɵeld"](31, 0, null, null, 29, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Field Data Type "])), (_l()(), core["ɵeld"](34, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 25, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 36).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 36).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.recordFormatData.fieldDatatype = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](36, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](38, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](40, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](41, 0, null, null, 3, "option", [["value", "STRING"]], null, null, null, null, null)), core["ɵdid"](42, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](43, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["STRING"])), (_l()(), core["ɵeld"](45, 0, null, null, 3, "option", [["value", "DOUBLE"]], null, null, null, null, null)), core["ɵdid"](46, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](47, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DOUBLE"])), (_l()(), core["ɵeld"](49, 0, null, null, 3, "option", [["value", "DATE"]], null, null, null, null, null)), core["ɵdid"](50, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](51, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DATE"])), (_l()(), core["ɵeld"](53, 0, null, null, 3, "option", [["value", "DATETIME"]], null, null, null, null, null)), core["ɵdid"](54, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](55, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DATE TIME"])), (_l()(), core["ɵeld"](57, 0, null, null, 3, "option", [["value", "LONG"]], null, null, null, null, null)), core["ɵdid"](58, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](59, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["LONG"])), (_l()(), core["ɵeld"](61, 0, null, null, 9, "div", [["class", "col-lg-6 col-md-6 float-left left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](62, 0, null, null, 8, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 1, "p", [["class", "mb-0 mr-3"], ["for", "enableCache"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Is primary key"])), (_l()(), core["ɵeld"](65, 0, null, null, 5, "input", [["id", "enableCache"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 66).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 66).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.recordFormatData.isPK = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](66, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](68, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](70, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](71, 0, null, null, 2, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](72, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "addField"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addField() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add "]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (!_co.isEdit ? "col-lg-6 col-md-6  left-clear" : "col-lg-6 col-md-6 float-left"); _ck(_v, 2, 0, currVal_0); var currVal_9 = "100"; _ck(_v, 9, 0, currVal_9); var currVal_10 = _co.recordFormatData.fieldName; _ck(_v, 12, 0, currVal_10); var currVal_11 = (!_co.isEdit ? "col-lg-6 col-md-6  left-clear" : "col-lg-6 col-md-6 float-left"); _ck(_v, 16, 0, currVal_11); var currVal_20 = "100"; _ck(_v, 23, 0, currVal_20); var currVal_21 = _co.recordFormatData.displayName; _ck(_v, 26, 0, currVal_21); var currVal_22 = (!_co.isEdit ? "col-lg-6 col-md-6  left-clear" : "col-lg-6 col-md-6 float-left"); _ck(_v, 30, 0, currVal_22); var currVal_30 = _co.recordFormatData.fieldDatatype; _ck(_v, 38, 0, currVal_30); var currVal_31 = "STRING"; _ck(_v, 42, 0, currVal_31); var currVal_32 = "STRING"; _ck(_v, 43, 0, currVal_32); var currVal_33 = "DOUBLE"; _ck(_v, 46, 0, currVal_33); var currVal_34 = "DOUBLE"; _ck(_v, 47, 0, currVal_34); var currVal_35 = "DATE"; _ck(_v, 50, 0, currVal_35); var currVal_36 = "DATE"; _ck(_v, 51, 0, currVal_36); var currVal_37 = "DATETIME"; _ck(_v, 54, 0, currVal_37); var currVal_38 = "DATETIME"; _ck(_v, 55, 0, currVal_38); var currVal_39 = "LONG"; _ck(_v, 58, 0, currVal_39); var currVal_40 = "LONG"; _ck(_v, 59, 0, currVal_40); var currVal_48 = _co.recordFormatData.isPK; _ck(_v, 68, 0, currVal_48); }, function (_ck, _v) { var currVal_1 = (core["ɵnov"](_v, 9).maxlength ? core["ɵnov"](_v, 9).maxlength : null); var currVal_2 = core["ɵnov"](_v, 14).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 14).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 14).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 14).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 14).ngClassValid; var currVal_7 = core["ɵnov"](_v, 14).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 14).ngClassPending; _ck(_v, 7, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_12 = (core["ɵnov"](_v, 23).maxlength ? core["ɵnov"](_v, 23).maxlength : null); var currVal_13 = core["ɵnov"](_v, 28).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 28).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 28).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 28).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 28).ngClassValid; var currVal_18 = core["ɵnov"](_v, 28).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 28).ngClassPending; _ck(_v, 21, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_23 = core["ɵnov"](_v, 40).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 40).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 40).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 40).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 40).ngClassValid; var currVal_28 = core["ɵnov"](_v, 40).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 40).ngClassPending; _ck(_v, 35, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); var currVal_41 = core["ɵnov"](_v, 70).ngClassUntouched; var currVal_42 = core["ɵnov"](_v, 70).ngClassTouched; var currVal_43 = core["ɵnov"](_v, 70).ngClassPristine; var currVal_44 = core["ɵnov"](_v, 70).ngClassDirty; var currVal_45 = core["ɵnov"](_v, 70).ngClassValid; var currVal_46 = core["ɵnov"](_v, 70).ngClassInvalid; var currVal_47 = core["ɵnov"](_v, 70).ngClassPending; _ck(_v, 65, 0, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47); });
}
function View_RecordFormatComponent_20(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 21, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 20, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Field Name"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Field Name "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Field Display Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Field Display Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["ngbTooltip", "Data Type"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Data Type "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Is primary key"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Is primary key "])), (_l()(), core["ɵeld"](18, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](19, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Field Name"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Field Display Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Data Type"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "Is primary key"; _ck(_v, 15, 0, currVal_3); var currVal_4 = "Actions"; _ck(_v, 19, 0, currVal_4); }, null); }
function View_RecordFormatComponent_23(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "span", [["class", "pl-2 mb-lg-0 float-left"], ["ngbTooltip", "Date Format"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "form-control mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Date Format"; _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.parent.context.$implicit.dateFormat; _ck(_v, 3, 0, currVal_1); }); }
function View_RecordFormatComponent_22(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "form-control col-lg-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵppd"](4, 1), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_23)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_1 = ((((_v.parent.context.$implicit.fieldDatatype == "DATE") || (_v.parent.context.$implicit.fieldDatatype == "date")) || (_v.parent.context.$implicit.fieldDatatype == "DATETIME")) && _v.parent.context.$implicit.dateFormat); _ck(_v, 6, 0, currVal_1); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, _ck(_v, 4, 0, core["ɵnov"](_v.parent.parent.parent.parent.parent, 0), _v.parent.context.$implicit.fieldDatatype)); _ck(_v, 3, 0, currVal_0); }); }
function View_RecordFormatComponent_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 34, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 33, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.parent.parent.parent.context.$implicit.dateFormat = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](7, 0, null, null, 3, "option", [["value", "YYYY-MM-DD"]], null, null, null, null, null)), core["ɵdid"](8, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](9, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["YYYY-MM-DD"])), (_l()(), core["ɵeld"](11, 0, null, null, 3, "option", [["value", "YYYY/MM/DD"]], null, null, null, null, null)), core["ɵdid"](12, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](13, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["YYYY/MM/DD"])), (_l()(), core["ɵeld"](15, 0, null, null, 3, "option", [["value", "DD-MM-YYYY"]], null, null, null, null, null)), core["ɵdid"](16, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](17, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DD-MM-YYYY"])), (_l()(), core["ɵeld"](19, 0, null, null, 3, "option", [["value", "DD/MM/YYYY"]], null, null, null, null, null)), core["ɵdid"](20, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](21, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DD/MM/YYYY"])), (_l()(), core["ɵeld"](23, 0, null, null, 3, "option", [["value", "MM-DD-YY"]], null, null, null, null, null)), core["ɵdid"](24, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](25, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["MM-DD-YY"])), (_l()(), core["ɵeld"](27, 0, null, null, 3, "option", [["value", "MM/DD/YY"]], null, null, null, null, null)), core["ɵdid"](28, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](29, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["MM/DD/YY"])), (_l()(), core["ɵeld"](31, 0, null, null, 3, "option", [["value", "DATEVALUE"]], null, null, null, null, null)), core["ɵdid"](32, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](33, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DATE VALUE"]))], function (_ck, _v) { var currVal_7 = _v.parent.parent.parent.context.$implicit.dateFormat; _ck(_v, 4, 0, currVal_7); var currVal_8 = "YYYY-MM-DD"; _ck(_v, 8, 0, currVal_8); var currVal_9 = "YYYY-MM-DD"; _ck(_v, 9, 0, currVal_9); var currVal_10 = "YYYY/MM/DD"; _ck(_v, 12, 0, currVal_10); var currVal_11 = "YYYY/MM/DD"; _ck(_v, 13, 0, currVal_11); var currVal_12 = "DD-MM-YYYY"; _ck(_v, 16, 0, currVal_12); var currVal_13 = "DD-MM-YYYY"; _ck(_v, 17, 0, currVal_13); var currVal_14 = "DD/MM/YYYY"; _ck(_v, 20, 0, currVal_14); var currVal_15 = "DD/MM/YYYY"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "MM-DD-YY"; _ck(_v, 24, 0, currVal_16); var currVal_17 = "MM-DD-YY"; _ck(_v, 25, 0, currVal_17); var currVal_18 = "MM/DD/YY"; _ck(_v, 28, 0, currVal_18); var currVal_19 = "MM/DD/YY"; _ck(_v, 29, 0, currVal_19); var currVal_20 = "DATEVALUE"; _ck(_v, 32, 0, currVal_20); var currVal_21 = "DATEVALUE"; _ck(_v, 33, 0, currVal_21); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 6).ngClassValid; var currVal_5 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_RecordFormatComponent_27(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 34, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 33, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.parent.parent.parent.context.$implicit.dateFormat = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](7, 0, null, null, 3, "option", [["value", "YYYY-MM-DD HH:MM:SS"]], null, null, null, null, null)), core["ɵdid"](8, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](9, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["YYYY-MM-DD HH:MM:SS"])), (_l()(), core["ɵeld"](11, 0, null, null, 3, "option", [["value", "YYYY/MM/DD HH:MM:SS"]], null, null, null, null, null)), core["ɵdid"](12, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](13, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["YYYY/MM/DD HH:MM:SS"])), (_l()(), core["ɵeld"](15, 0, null, null, 3, "option", [["value", "DD-MM-YYYY HH:MM:SS"]], null, null, null, null, null)), core["ɵdid"](16, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](17, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DD-MM-YYYY HH:MM:SS"])), (_l()(), core["ɵeld"](19, 0, null, null, 3, "option", [["value", "DD/MM/YYYY HH:MM:SS"]], null, null, null, null, null)), core["ɵdid"](20, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](21, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DD/MM/YYYY HH:MM:SS"])), (_l()(), core["ɵeld"](23, 0, null, null, 3, "option", [["value", "MM-DD-YY HH:MM:SS"]], null, null, null, null, null)), core["ɵdid"](24, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](25, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["MM-DD-YY HH:MM:SS"])), (_l()(), core["ɵeld"](27, 0, null, null, 3, "option", [["value", "MM/DD/YY HH:MM:SS"]], null, null, null, null, null)), core["ɵdid"](28, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](29, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["MM/DD/YY HH:MM:SS"])), (_l()(), core["ɵeld"](31, 0, null, null, 3, "option", [["value", "DATETIMEVALUE"]], null, null, null, null, null)), core["ɵdid"](32, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](33, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DATE TIME VALUE"]))], function (_ck, _v) { var currVal_7 = _v.parent.parent.parent.context.$implicit.dateFormat; _ck(_v, 4, 0, currVal_7); var currVal_8 = "YYYY-MM-DD HH:MM:SS"; _ck(_v, 8, 0, currVal_8); var currVal_9 = "YYYY-MM-DD HH:MM:SS"; _ck(_v, 9, 0, currVal_9); var currVal_10 = "YYYY/MM/DD HH:MM:SS"; _ck(_v, 12, 0, currVal_10); var currVal_11 = "YYYY/MM/DD HH:MM:SS"; _ck(_v, 13, 0, currVal_11); var currVal_12 = "DD-MM-YYYY HH:MM:SS"; _ck(_v, 16, 0, currVal_12); var currVal_13 = "DD-MM-YYYY HH:MM:SS"; _ck(_v, 17, 0, currVal_13); var currVal_14 = "DD/MM/YYYY HH:MM:SS"; _ck(_v, 20, 0, currVal_14); var currVal_15 = "DD/MM/YYYY HH:MM:SS"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "MM-DD-YY HH:MM:SS"; _ck(_v, 24, 0, currVal_16); var currVal_17 = "MM-DD-YY HH:MM:SS"; _ck(_v, 25, 0, currVal_17); var currVal_18 = "MM/DD/YY HH:MM:SS"; _ck(_v, 28, 0, currVal_18); var currVal_19 = "MM/DD/YY HH:MM:SS"; _ck(_v, 29, 0, currVal_19); var currVal_20 = "DATETIMEVALUE"; _ck(_v, 32, 0, currVal_20); var currVal_21 = "DATETIMEVALUE"; _ck(_v, 33, 0, currVal_21); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 6).ngClassValid; var currVal_5 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_RecordFormatComponent_25(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 5, "span", [["class", "float-left pl-2"], ["ngbTooltip", "Date Format"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_26)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_27)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Date Format"; _ck(_v, 1, 0, currVal_0); var currVal_1 = ((_v.parent.parent.context.$implicit.fieldDatatype == "DATE") || (_v.parent.parent.context.$implicit.fieldDatatype == "date")); _ck(_v, 3, 0, currVal_1); var currVal_2 = (_v.parent.parent.context.$implicit.fieldDatatype == "DATETIME"); _ck(_v, 5, 0, currVal_2); }, null); }
function View_RecordFormatComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 34, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 31, "div", [["class", "float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 30, "select", [["class", "form-control light-bg mb-lg-0 text-truncate"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 3).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = (_co.setFieldDatatype($event, _v.parent.context.$implicit) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](3, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](5, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵppd"](6, 1), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 3, "option", [["value", "STRING"]], null, null, null, null, null)), core["ɵdid"](10, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](11, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["STRING"])), (_l()(), core["ɵeld"](13, 0, null, null, 3, "option", [["value", "DOUBLE"]], null, null, null, null, null)), core["ɵdid"](14, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](15, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DOUBLE"])), (_l()(), core["ɵeld"](17, 0, null, null, 3, "option", [["value", "DATE"]], null, null, null, null, null)), core["ɵdid"](18, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](19, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DATE"])), (_l()(), core["ɵeld"](21, 0, null, null, 3, "option", [["value", "DATETIME"]], null, null, null, null, null)), core["ɵdid"](22, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](23, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["DATE TIME"])), (_l()(), core["ɵeld"](25, 0, null, null, 3, "option", [["value", "TIMESTAMP"]], null, null, null, null, null)), core["ɵdid"](26, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](27, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["TIMESTAMP"])), (_l()(), core["ɵeld"](29, 0, null, null, 3, "option", [["value", "LONG"]], null, null, null, null, null)), core["ɵdid"](30, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](31, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["LONG"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_25)), core["ɵdid"](34, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = core["ɵunv"](_v, 5, 0, _ck(_v, 6, 0, core["ɵnov"](_v.parent.parent.parent.parent.parent, 0), _v.parent.context.$implicit.fieldDatatype)); _ck(_v, 5, 0, currVal_7); var currVal_8 = "STRING"; _ck(_v, 10, 0, currVal_8); var currVal_9 = "STRING"; _ck(_v, 11, 0, currVal_9); var currVal_10 = "DOUBLE"; _ck(_v, 14, 0, currVal_10); var currVal_11 = "DOUBLE"; _ck(_v, 15, 0, currVal_11); var currVal_12 = "DATE"; _ck(_v, 18, 0, currVal_12); var currVal_13 = "DATE"; _ck(_v, 19, 0, currVal_13); var currVal_14 = "DATETIME"; _ck(_v, 22, 0, currVal_14); var currVal_15 = "DATETIME"; _ck(_v, 23, 0, currVal_15); var currVal_16 = "TIMESTAMP"; _ck(_v, 26, 0, currVal_16); var currVal_17 = "TIMESTAMP"; _ck(_v, 27, 0, currVal_17); var currVal_18 = "LONG"; _ck(_v, 30, 0, currVal_18); var currVal_19 = "LONG"; _ck(_v, 31, 0, currVal_19); var currVal_20 = _co.isFieldEdit[_v.parent.context.index]; _ck(_v, 34, 0, currVal_20); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 8).ngClassValid; var currVal_5 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_RecordFormatComponent_28(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "i", [["class", "fa fa-pencil mr-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onEditPrevField(_v.parent.context.$implicit, _v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Edit "]))], null, null);
}
function View_RecordFormatComponent_21(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 37, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "input", [["class", "form-control border"], ["id", "fieldName"], ["maxlength", "100"], ["type", "text"]], [[8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "blur"], [null, "input"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.fieldName = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (_co.onValidateEdit(_v.context.$implicit, _v.context.index) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](3, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 9, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 8, "input", [["class", "form-control border"], ["id", "fieldDisplayName"], ["maxlength", "100"], ["type", "text"]], [[8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "blur"], [null, "input"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 14)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 14).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 14)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 14)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (_co.onValidateEdit(_v.context.$implicit, _v.context.index) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](13, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null), core["ɵdid"](14, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](15, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](18, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](20, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_22)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_24)), core["ɵdid"](24, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](25, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, [["isPk", 1]], null, 5, "input", [["class", "float-left"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.context.$implicit.isPK = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.selectPrimaryKey(core["ɵnov"](_v, 26).checked, _v.context.$implicit.id) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 5, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 4, "h6", [["class", "mb-lg-0 text-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_28)), core["ɵdid"](35, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](36, 0, null, null, 1, "i", [["class", "fa fa-trash mr-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onDeleteField($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Delete "]))], function (_ck, _v) { var _co = _v.component; var currVal_9 = "form-control border"; var currVal_10 = ((_co.errorIndexF == _v.context.index) ? "border-danger" : ""); _ck(_v, 3, 0, currVal_9, currVal_10); var currVal_11 = "100"; _ck(_v, 5, 0, currVal_11); var currVal_12 = _v.context.$implicit.fieldName; _ck(_v, 8, 0, currVal_12); var currVal_22 = "form-control border"; var currVal_23 = ((_co.errorIndexD == _v.context.index) ? "border-danger" : ""); _ck(_v, 13, 0, currVal_22, currVal_23); var currVal_24 = "100"; _ck(_v, 15, 0, currVal_24); var currVal_25 = _v.context.$implicit.displayName; _ck(_v, 18, 0, currVal_25); var currVal_26 = !_co.isFieldEdit[_v.context.index]; _ck(_v, 22, 0, currVal_26); var currVal_27 = _co.isFieldEdit[_v.context.index]; _ck(_v, 24, 0, currVal_27); var currVal_35 = _v.context.$implicit.isPK; _ck(_v, 29, 0, currVal_35); var currVal_36 = !_co.valBu; _ck(_v, 35, 0, currVal_36); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isFieldEdit[_v.context.index]; var currVal_1 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_13 = !_co.isFieldEdit[_v.context.index]; var currVal_14 = (core["ɵnov"](_v, 15).maxlength ? core["ɵnov"](_v, 15).maxlength : null); var currVal_15 = core["ɵnov"](_v, 20).ngClassUntouched; var currVal_16 = core["ɵnov"](_v, 20).ngClassTouched; var currVal_17 = core["ɵnov"](_v, 20).ngClassPristine; var currVal_18 = core["ɵnov"](_v, 20).ngClassDirty; var currVal_19 = core["ɵnov"](_v, 20).ngClassValid; var currVal_20 = core["ɵnov"](_v, 20).ngClassInvalid; var currVal_21 = core["ɵnov"](_v, 20).ngClassPending; _ck(_v, 12, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21); var currVal_28 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_29 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_30 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_31 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_32 = core["ɵnov"](_v, 31).ngClassValid; var currVal_33 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_34 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34); });
}
function View_RecordFormatComponent_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 89, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_15)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_16)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 78, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["placeholder", " Record Format Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.recordData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](30, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["placeholder", "Description (Optional)"], ["rows", "1"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 32)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 32).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 32)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 32)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.recordData.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](32, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](33, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](36, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](38, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](39, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Display Name "])), (_l()(), core["ɵeld"](43, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](45, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["placeholder", " Display Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 46)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 46).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 46)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 46)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.recordData.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](46, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](47, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](50, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](52, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](53, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](55, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Type "])), (_l()(), core["ɵeld"](57, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["placeholder", "Type"], ["rows", "1"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 59)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 59).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 59)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 59)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.recordData.recordFormatType = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](59, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](60, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](63, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](65, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](66, 0, null, null, 20, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](67, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left  left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](68, 0, null, null, 9, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](69, 0, null, null, 1, "label", [["for", "dataSource"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Source"])), (_l()(), core["ɵeld"](71, 0, null, null, 6, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.selectDataSource($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](72, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](73, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](74, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_17)), core["ɵdid"](77, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](78, 0, null, null, 8, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group accordionss"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_18)), core["ɵdid"](80, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_19)), core["ɵdid"](82, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_20)), core["ɵdid"](84, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_21)), core["ɵdid"](86, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](87, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](88, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.recordData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_21 = "350"; _ck(_v, 33, 0, currVal_21); var currVal_22 = "description"; var currVal_23 = _co.recordData.description; _ck(_v, 36, 0, currVal_22, currVal_23); var currVal_32 = "200"; _ck(_v, 47, 0, currVal_32); var currVal_33 = "name"; var currVal_34 = _co.recordData.displayName; _ck(_v, 50, 0, currVal_33, currVal_34); var currVal_43 = "350"; _ck(_v, 60, 0, currVal_43); var currVal_44 = "description"; var currVal_45 = _co.recordData.recordFormatType; _ck(_v, 63, 0, currVal_44, currVal_45); var currVal_46 = "none"; _ck(_v, 73, 0, currVal_46); var currVal_47 = "none"; _ck(_v, 74, 0, currVal_47); var currVal_48 = _co.dataSourceList; _ck(_v, 77, 0, currVal_48); var currVal_49 = _co.isEdit; _ck(_v, 80, 0, currVal_49); var currVal_50 = _co.showField; _ck(_v, 82, 0, currVal_50); var currVal_51 = (_co.recordFormatFieldData && (_co.recordFormatFieldData.length > 0)); _ck(_v, 84, 0, currVal_51); var currVal_52 = _co.recordFormatFieldData; _ck(_v, 86, 0, currVal_52); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_13 = (core["ɵnov"](_v, 33).maxlength ? core["ɵnov"](_v, 33).maxlength : null); var currVal_14 = core["ɵnov"](_v, 38).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 38).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 38).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 38).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 38).ngClassValid; var currVal_19 = core["ɵnov"](_v, 38).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 38).ngClassPending; _ck(_v, 31, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_24 = (core["ɵnov"](_v, 47).maxlength ? core["ɵnov"](_v, 47).maxlength : null); var currVal_25 = core["ɵnov"](_v, 52).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 52).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 52).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 52).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 52).ngClassValid; var currVal_30 = core["ɵnov"](_v, 52).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 52).ngClassPending; _ck(_v, 45, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); var currVal_35 = (core["ɵnov"](_v, 60).maxlength ? core["ɵnov"](_v, 60).maxlength : null); var currVal_36 = core["ɵnov"](_v, 65).ngClassUntouched; var currVal_37 = core["ɵnov"](_v, 65).ngClassTouched; var currVal_38 = core["ɵnov"](_v, 65).ngClassPristine; var currVal_39 = core["ɵnov"](_v, 65).ngClassDirty; var currVal_40 = core["ɵnov"](_v, 65).ngClassValid; var currVal_41 = core["ɵnov"](_v, 65).ngClassInvalid; var currVal_42 = core["ɵnov"](_v, 65).ngClassPending; _ck(_v, 58, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42); var currVal_53 = _co.saveButton; _ck(_v, 88, 0, currVal_53); });
}
function View_RecordFormatComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_14)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.recordPage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_RecordFormatComponent_29(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_RecordFormatComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_29)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_RecordFormatComponent_0(_l) { return core["ɵvid"](0, [core["ɵpid"](0, common["UpperCasePipe"], []), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RecordFormatComponent_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 2, 0, currVal_0); }, null); }
function View_RecordFormatComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "recordFormat", [], null, null, null, View_RecordFormatComponent_0, RenderType_RecordFormatComponent)), core["ɵdid"](1, 114688, null, 0, recordFormat_component_RecordFormatComponent, [mdmService_service_MDMService, ToasterComponent, fileService_FileService, core["ViewContainerRef"], NgbModal, Configuration], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var RecordFormatComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("recordFormat", recordFormat_component_RecordFormatComponent, View_RecordFormatComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/dataEngine.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_dropdown_dropdown,_ng_bootstrap_ng_bootstrap_dropdown_dropdown_config,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_loader.component.ngfactory,_loader.component,_dataEngine.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent PURE_IMPORTS_END */















var styles_DataEngine = [];
var RenderType_DataEngine = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_DataEngine, data: {} });

function View_DataEngine_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 32, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 31, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["DATA ENGINE"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 27, "div", [["aria-label", "Button group with nested dropdown"], ["class", "btn-group"], ["ngbDropdown", ""], ["role", "group"]], [[2, "show", null]], null, null, null, null)), core["ɵdid"](6, 212992, null, 2, dropdown_NgbDropdown, [core["ChangeDetectorRef"], NgbDropdownConfig, common["DOCUMENT"], core["NgZone"]], null, null), core["ɵqud"](335544320, 1, { _menu: 0 }), core["ɵqud"](335544320, 2, { _anchor: 0 }), (_l()(), core["ɵeld"](9, 0, null, null, 3, "button", [["aria-haspopup", "true"], ["class", "btn btn-primary dropdown-toggle-split dropdown-toggle"], ["ngbDropdownToggle", ""]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 10).toggleOpen() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](10, 16384, null, 0, NgbDropdownToggle, [dropdown_NgbDropdown, core["ElementRef"]], null, null), core["ɵprd"](2048, [[2, 4]], NgbDropdownAnchor, null, [NgbDropdownToggle]), (_l()(), core["ɵted"](-1, null, [" Add Data Engine"])), (_l()(), core["ɵeld"](13, 0, null, null, 19, "div", [["class", "dropdown-menu"], ["ngbDropdownMenu", ""]], [[2, "dropdown-menu", null], [2, "show", null], [1, "x-placement", 0]], null, null, null, null)), core["ɵdid"](14, 16384, [[1, 4]], 0, dropdown_NgbDropdownMenu, [dropdown_NgbDropdown, core["ElementRef"], core["Renderer2"]], null, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("DRILL") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["DRILL"])), (_l()(), core["ɵeld"](17, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("PRESTO") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["PRESTO"])), (_l()(), core["ɵeld"](19, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("SSAS") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["SSAS"])), (_l()(), core["ɵeld"](21, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("KYLIN") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["KYLIN"])), (_l()(), core["ɵeld"](23, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("DRUID") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["DRUID"])), (_l()(), core["ɵeld"](25, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("OLAP") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["OLAP"])), (_l()(), core["ɵeld"](27, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("IMPALA") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["IMPALA"])), (_l()(), core["ɵeld"](29, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("SPARK") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["SPARK"])), (_l()(), core["ɵeld"](31, 0, null, null, 1, "a", [["class", "dropdown-item primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewDataEngine("CLICK_HOUSE") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Clickhouse"]))], function (_ck, _v) { _ck(_v, 6, 0); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 6).isOpen(); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵnov"](_v, 10).dropdown.isOpen(); _ck(_v, 9, 0, currVal_1); var currVal_2 = true; var currVal_3 = core["ɵnov"](_v, 14).dropdown.isOpen(); var currVal_4 = core["ɵnov"](_v, 14).placement; _ck(_v, 13, 0, currVal_2, currVal_3, currVal_4); });
}
function View_DataEngine_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 29, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 28, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Server"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Server "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Port"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Port "])), (_l()(), core["ɵeld"](18, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"], ["ngbTooltip", "Type"]], null, null, null, null, null)), core["ɵdid"](19, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Type "])), (_l()(), core["ɵeld"](22, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Username"]], null, null, null, null, null)), core["ɵdid"](23, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Username "])), (_l()(), core["ɵeld"](26, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](27, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](28, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Code"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Server"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "Port"; _ck(_v, 15, 0, currVal_3); var currVal_4 = "Type"; _ck(_v, 19, 0, currVal_4); var currVal_5 = "Username"; _ck(_v, 23, 0, currVal_5); var currVal_6 = "Actions"; _ck(_v, 27, 0, currVal_6); }, null); }
function View_DataEngine_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.context.$implicit.server, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.context.$implicit.server; _ck(_v, 3, 0, currVal_1); }); }
function View_DataEngine_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", (_v.parent.context.$implicit.customParameter2 ? _v.parent.context.$implicit.customParameter2 : _v.parent.context.$implicit.server), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = (_v.parent.context.$implicit.customParameter2 ? _v.parent.context.$implicit.customParameter2 : _v.parent.context.$implicit.server); _ck(_v, 3, 0, currVal_1); }); }
function View_DataEngine_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 6, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clickEdit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeEngine(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], null, null);
}
function View_DataEngine_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 29, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_7)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_8)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, [" ", " "])), (_l()(), core["ɵeld"](17, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), core["ɵdid"](18, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](20, null, [" ", " "])), (_l()(), core["ɵeld"](21, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](22, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](23, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](24, null, [" ", " "])), (_l()(), core["ɵeld"](25, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_9)), core["ɵdid"](29, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dataEngineCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = (_v.context.$implicit.type != "DRILL"); _ck(_v, 10, 0, currVal_4); var currVal_5 = (_v.context.$implicit.type == "DRILL"); _ck(_v, 12, 0, currVal_5); var currVal_6 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.port, ""); _ck(_v, 14, 0, currVal_6); var currVal_8 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.type, ""); _ck(_v, 18, 0, currVal_8); var currVal_10 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.username, ""); _ck(_v, 22, 0, currVal_10); var currVal_13 = ((_co.selectedEngineId == _v.context.$implicit.id) ? true : false); _ck(_v, 29, 0, currVal_13); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.dataEngineCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.name; _ck(_v, 8, 0, currVal_3); var currVal_7 = _v.context.$implicit.port; _ck(_v, 16, 0, currVal_7); var currVal_9 = _v.context.$implicit.type; _ck(_v, 20, 0, currVal_9); var currVal_11 = _v.context.$implicit.username; _ck(_v, 24, 0, currVal_11); var currVal_12 = _v.context.$implicit.id; _ck(_v, 25, 0, currVal_12); });
}
function View_DataEngine_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_DataEngine_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_11)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DataEngine_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalEngines; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_DataEngine_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataEngineReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPDataEngine() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_5)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_6)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_10)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](23, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](26, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_12)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.dataEngineReg; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = (_co.dataEngineList && _co.dataEngineList.length); _ck(_v, 15, 0, currVal_11); var currVal_12 = _co.dataEngineList; _ck(_v, 17, 0, currVal_12); var currVal_13 = (_co.dataEngineList.length == 0); _ck(_v, 19, 0, currVal_13); var currVal_24 = _co.pageSize; _ck(_v, 29, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 33, 0, currVal_25); var currVal_26 = "10"; _ck(_v, 34, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 37, 0, currVal_27); var currVal_28 = "20"; _ck(_v, 38, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 41, 0, currVal_29); var currVal_30 = "30"; _ck(_v, 42, 0, currVal_30); var currVal_31 = (_co.dataEngineList && _co.dataEngineList.length); _ck(_v, 46, 0, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_14 = _co.startingPage; var currVal_15 = _co.endingPage; var currVal_16 = _co.totalEngines; _ck(_v, 22, 0, currVal_14, currVal_15, currVal_16); var currVal_17 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 31).ngClassValid; var currVal_22 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); });
}
function View_DataEngine_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Data Engine "]))], null, null); }
function View_DataEngine_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Data Engine - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.dataEngineData.dataEngineCode; _ck(_v, 1, 0, currVal_0); }); }
function View_DataEngine_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 29, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Server "])), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](7, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "server"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 8)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 8)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataEngineData.server = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](9, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](12, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](14, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](15, 0, null, null, 14, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Port "])), (_l()(), core["ɵeld"](19, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](21, 0, null, null, 8, "input", [["class", "form-control"], ["max", "65535"], ["maxlength", "5"], ["name", "port"], ["type", "number"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 23).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 23).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 23).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.dataEngineData.port = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](24, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](27, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](29, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "200"; _ck(_v, 9, 0, currVal_8); var currVal_9 = "server"; var currVal_10 = _co.dataEngineData.server; _ck(_v, 12, 0, currVal_9, currVal_10); var currVal_19 = "5"; _ck(_v, 24, 0, currVal_19); var currVal_20 = "port"; var currVal_21 = _co.dataEngineData.port; _ck(_v, 27, 0, currVal_20, currVal_21); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 9).maxlength ? core["ɵnov"](_v, 9).maxlength : null); var currVal_1 = core["ɵnov"](_v, 14).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 14).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 14).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 14).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 14).ngClassValid; var currVal_6 = core["ɵnov"](_v, 14).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 14).ngClassPending; _ck(_v, 7, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_11 = (core["ɵnov"](_v, 24).maxlength ? core["ɵnov"](_v, 24).maxlength : null); var currVal_12 = core["ɵnov"](_v, 29).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 29).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 29).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 29).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 29).ngClassValid; var currVal_17 = core["ɵnov"](_v, 29).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 29).ngClassPending; _ck(_v, 21, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); });
}
function View_DataEngine_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 32, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 31, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 14, "div", [["class", "col-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, ["Server ", " "])), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](8, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "server"], ["required", ""], ["type", "text"]], [[1, "required", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.context.$implicit.ip = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](10, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵdid"](11, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["RequiredValidator"], fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](14, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](16, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](17, 0, null, null, 12, "div", [["class", "col-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](20, null, ["Port ", ""])), (_l()(), core["ɵeld"](21, 0, null, null, 8, "input", [["class", "form-control"], ["max", "65535"], ["maxlength", "5"], ["name", "port"], ["type", "number"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 23).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 23).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 23).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_v.context.$implicit.port = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](24, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](27, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](29, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](30, 0, null, null, 2, "div", [["class", "col-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 1, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 0, "i", [["class", "fa fa-times"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeCluster(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], function (_ck, _v) { var currVal_10 = ""; _ck(_v, 10, 0, currVal_10); var currVal_11 = "200"; _ck(_v, 11, 0, currVal_11); var currVal_12 = "server"; var currVal_13 = _v.context.$implicit.ip; _ck(_v, 14, 0, currVal_12, currVal_13); var currVal_23 = "5"; _ck(_v, 24, 0, currVal_23); var currVal_24 = "port"; var currVal_25 = _v.context.$implicit.port; _ck(_v, 27, 0, currVal_24, currVal_25); }, function (_ck, _v) { var currVal_0 = (_v.context.index + 1); _ck(_v, 5, 0, currVal_0); var currVal_1 = (core["ɵnov"](_v, 10).required ? "" : null); var currVal_2 = (core["ɵnov"](_v, 11).maxlength ? core["ɵnov"](_v, 11).maxlength : null); var currVal_3 = core["ɵnov"](_v, 16).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 16).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 16).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 16).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 16).ngClassValid; var currVal_8 = core["ɵnov"](_v, 16).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 16).ngClassPending; _ck(_v, 8, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_14 = (_v.context.index + 1); _ck(_v, 20, 0, currVal_14); var currVal_15 = (core["ɵnov"](_v, 24).maxlength ? core["ɵnov"](_v, 24).maxlength : null); var currVal_16 = core["ɵnov"](_v, 29).ngClassUntouched; var currVal_17 = core["ɵnov"](_v, 29).ngClassTouched; var currVal_18 = core["ɵnov"](_v, 29).ngClassPristine; var currVal_19 = core["ɵnov"](_v, 29).ngClassDirty; var currVal_20 = core["ɵnov"](_v, 29).ngClassValid; var currVal_21 = core["ɵnov"](_v, 29).ngClassInvalid; var currVal_22 = core["ɵnov"](_v, 29).ngClassPending; _ck(_v, 21, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22); });
}
function View_DataEngine_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 14, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Drill IP "])), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](7, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "server"], ["required", ""], ["type", "text"]], [[1, "required", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 8)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 8)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataEngineData.customParameter2 = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](9, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵdid"](10, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["RequiredValidator"], fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](13, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](15, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](16, 0, null, null, 14, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Port "])), (_l()(), core["ɵeld"](20, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](22, 0, null, null, 8, "input", [["class", "form-control"], ["max", "65535"], ["maxlength", "5"], ["name", "port"], ["type", "number"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 23)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 23).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 23)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 23)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 24).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 24).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 24).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.dataEngineData.port = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](23, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](24, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](25, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](28, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](30, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](31, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Cluster ID"])), (_l()(), core["ɵeld"](35, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "port"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 36)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 36).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 36)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 36)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataEngineData.customParameter1 = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](36, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](37, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](40, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](42, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_18)), core["ɵdid"](44, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](45, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addCluster() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add Cluster "]))], function (_ck, _v) { var _co = _v.component; var currVal_9 = ""; _ck(_v, 9, 0, currVal_9); var currVal_10 = "200"; _ck(_v, 10, 0, currVal_10); var currVal_11 = "server"; var currVal_12 = _co.dataEngineData.customParameter2; _ck(_v, 13, 0, currVal_11, currVal_12); var currVal_21 = "5"; _ck(_v, 25, 0, currVal_21); var currVal_22 = "port"; var currVal_23 = _co.dataEngineData.port; _ck(_v, 28, 0, currVal_22, currVal_23); var currVal_32 = "200"; _ck(_v, 37, 0, currVal_32); var currVal_33 = "port"; var currVal_34 = _co.dataEngineData.customParameter1; _ck(_v, 40, 0, currVal_33, currVal_34); var currVal_35 = _co.clusterList; _ck(_v, 44, 0, currVal_35); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 9).required ? "" : null); var currVal_1 = (core["ɵnov"](_v, 10).maxlength ? core["ɵnov"](_v, 10).maxlength : null); var currVal_2 = core["ɵnov"](_v, 15).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 15).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 15).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 15).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 15).ngClassValid; var currVal_7 = core["ɵnov"](_v, 15).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 15).ngClassPending; _ck(_v, 7, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_13 = (core["ɵnov"](_v, 25).maxlength ? core["ɵnov"](_v, 25).maxlength : null); var currVal_14 = core["ɵnov"](_v, 30).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 30).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 30).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 30).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 30).ngClassValid; var currVal_19 = core["ɵnov"](_v, 30).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 30).ngClassPending; _ck(_v, 22, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_24 = (core["ɵnov"](_v, 37).maxlength ? core["ɵnov"](_v, 37).maxlength : null); var currVal_25 = core["ɵnov"](_v, 42).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 42).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 42).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 42).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 42).ngClassValid; var currVal_30 = core["ɵnov"](_v, 42).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 42).ngClassPending; _ck(_v, 35, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); });
}
function View_DataEngine_19(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 10, "div", [["class", "align-v-center w-100 pt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 5, "input", [["checked", ""], ["id", "isWinAuth"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.dataEngineData.customParameter1 = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.enableWinAuthAction($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 0, "label", [["class", "mb-md-0"], ["for", "isWinAuth"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "label", [["class", "ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Enable Windows Authentication"]))], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.dataEngineData.customParameter1; _ck(_v, 8, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 10).ngClassValid; var currVal_5 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_DataEngine_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 28, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Username "])), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](7, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "username"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 8)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 8)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataEngineData.username = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](9, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](12, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](14, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](15, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Password "])), (_l()(), core["ɵeld"](19, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](21, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "password"], ["type", "password"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataEngineData.newPassword = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](26, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](28, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "200"; _ck(_v, 9, 0, currVal_8); var currVal_9 = "username"; var currVal_10 = _co.dataEngineData.username; _ck(_v, 12, 0, currVal_9, currVal_10); var currVal_19 = "200"; _ck(_v, 23, 0, currVal_19); var currVal_20 = "password"; var currVal_21 = _co.dataEngineData.newPassword; _ck(_v, 26, 0, currVal_20, currVal_21); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 9).maxlength ? core["ɵnov"](_v, 9).maxlength : null); var currVal_1 = core["ɵnov"](_v, 14).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 14).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 14).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 14).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 14).ngClassValid; var currVal_6 = core["ɵnov"](_v, 14).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 14).ngClassPending; _ck(_v, 7, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_11 = (core["ɵnov"](_v, 23).maxlength ? core["ɵnov"](_v, 23).maxlength : null); var currVal_12 = core["ɵnov"](_v, 28).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 28).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 28).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 28).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 28).ngClassValid; var currVal_17 = core["ɵnov"](_v, 28).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 28).ngClassPending; _ck(_v, 21, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); });
}
function View_DataEngine_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_14)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_15)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 35, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataEngineData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 9, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 8, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Type"])), (_l()(), core["ɵeld"](30, 0, null, null, 5, "input", [["class", "form-control"], ["name", "engineType"], ["readonly", ""], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.dataEngineData.type = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](31, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](33, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](35, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_16)), core["ɵdid"](37, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_17)), core["ɵdid"](39, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_19)), core["ɵdid"](41, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_20)), core["ɵdid"](43, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](44, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.dataEngineData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_20 = "engineType"; var currVal_21 = _co.dataEngineData.type; _ck(_v, 33, 0, currVal_20, currVal_21); var currVal_22 = (_co.dataEngineData.type != "DRILL"); _ck(_v, 37, 0, currVal_22); var currVal_23 = (_co.dataEngineData.type == "DRILL"); _ck(_v, 39, 0, currVal_23); var currVal_24 = (_co.dataEngineData.type == "SSAS"); _ck(_v, 41, 0, currVal_24); var currVal_25 = !((_co.dataEngineData.type == "SSAS") && _co.dataEngineData.customParameter1); _ck(_v, 43, 0, currVal_25); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_13 = core["ɵnov"](_v, 35).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 35).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 35).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 35).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 35).ngClassValid; var currVal_18 = core["ɵnov"](_v, 35).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 35).ngClassPending; _ck(_v, 30, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_26 = _co.saveButton; _ck(_v, 45, 0, currVal_26); });
}
function View_DataEngine_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_4)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_13)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.mainPage; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.dataEnginePage; _ck(_v, 6, 0, currVal_2); }, null); }
function View_DataEngine_21(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_DataEngine_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_2)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_21)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 4, 0, currVal_1); }, null); }
function View_DataEngine_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataEngine_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 1, 0, currVal_0); }, null); }
function View_DataEngine_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "dataEngine", [], null, null, null, View_DataEngine_0, RenderType_DataEngine)), core["ɵdid"](1, 114688, null, 0, dataEngine_component_DataEngine, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DataEngineNgFactory = /*@__PURE__*/ core["ɵccf"]("dataEngine", dataEngine_component_DataEngine, View_DataEngine_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/designerCube.component.ts



var designerCube_component_DesignerCube = /*@__PURE__*/ (function () {
    function DesignerCube(cubeService, toaster, ngbDataConv, vcr) {
        this.cubeService = cubeService;
        this.toaster = toaster;
        this.ngbDataConv = ngbDataConv;
        this.vcr = vcr;
        this.pageNo = 0;
        this.pageSize = 10;
        this.totalCubes = 0;
        this.sPage = 0;
        this.cubeReg = '';
        this.lastRegex = '';
        this.cubeData = { id: null, name: '', description: '', deleted: 0, dataSourceId: null };
        this.mainPage = true;
        this.cubePage = false;
        this.datePicker = false;
        this.currentPage = 1;
        this.startingPage = 0;
        this.endingPage = 0;
        this.entityOpsFlag = false;
        this.cubeList = [];
        this.saveButton = false;
        this.accessDenied = false;
        this.dataSourceList = [];
        this.isEdit = false;
        this.dimensionList = [];
        this.recordList = [];
        this.recordObject = {};
        this.measureList = [];
        this.measIndex = -1;
        this.dimInd = -1;
        this.cubeMeasureDataList = [];
        this.filteredMeasureMap = new Map();
        this.filteredDimensionMap = new Map();
        this.measurePage = false;
        this.dimensionPage = false;
        this.emitEdit = new core["EventEmitter"]();
        this.emitCubeData = new core["EventEmitter"]();
        this.dataVersionType = '';
        this.cubeDimensionUsageList = [];
        this.referencevariable = 'none';
        this.loader = false;
        this.totalPages = 0;
        this.dataVersionDate = { day: null, month: null, year: null };
        this.toaster.setViewRef(vcr);
    }
    DesignerCube.prototype.ngOnInit = function () {
        if (this.cubeService.isBIAdmin) {
            this.loadCube();
        }
        else {
            this.accessDenied = true;
        }
    };
    DesignerCube.prototype.ngOnChanges = function () {
        this.onBack();
    };
    DesignerCube.prototype.entityOps = function (event) {
        if (this.selectedCubeId == null) {
            this.selectedCubeId = event.target.id;
        }
        else {
            this.selectedCubeId = null;
        }
    };
    DesignerCube.prototype.closeDropDown = function (event) {
        this.selectedCubeId = null;
    };
    DesignerCube.prototype.callToaster = function (type, msg) {
        this.toaster.setViewRef(this.vcr);
        switch (type) {
            case mdmService_service_MDMService.ERROR:
                return this.toaster.showError(msg);
            case mdmService_service_MDMService.SUCCESS:
                return this.toaster.showSuccess(msg);
            case mdmService_service_MDMService.WARNING:
                return this.toaster.showWarning(msg);
        }
    };
    DesignerCube.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        this.cubeService.referenceLastPage = this.pageNo;
        if (this.cubeReg != '') {
            this.searchPCube();
        }
        else {
            this.loadCube();
        }
        this.setEndingPage(this.totalCubes);
    };
    DesignerCube.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.totalCubes / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.cubeService.referencePageSize = this.pageSize;
        this.loadCube();
    };
    DesignerCube.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
        self.cubeService.referenceLastPage = Math.floor(self.totalCubes / this.pageSize);
        if (self.totalCubes > self.cubeService.referenceLastPage * this.pageSize) {
            self.cubeService.referenceLastPage += 1;
        }
    };
    DesignerCube.prototype.loadCube = function () {
        var _this = this;
        var self = this;
        if (self.cubeService.referencePage != undefined) {
            self.pageNo = self.cubeService.referencePage;
            self.currentPage = self.pageNo + 1;
            self.pageSize = self.cubeService.referencePageSize == undefined ? 10 : self.cubeService.referencePageSize;
        }
        return new Promise(function (resolve) {
            self.loader = true;
            _this.cubeService.getDataByPage(BiUrls.CUBE, self.pageNo, self.pageSize).then(function (res) {
                self.cubeList = [];
                self.totalCubes = 0;
                self.totalPages = 0;
                if (res != undefined) {
                    self.cubeList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements : [];
                    self.totalCubes = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                }
                self.cubeService.referencePage = null;
                self.parseDataVersionDates();
                self.setEndingPage(self.totalCubes);
                self.loader = false;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    DesignerCube.prototype.parseDataVersionDates = function () {
        var self = this;
        for (var _i = 0, _a = self.cubeList; _i < _a.length; _i++) {
            var cb = _a[_i];
            var dv = new Date(cb.dataVersion);
            cb.dataVersion = new Date(dv.getUTCFullYear(), dv.getUTCMonth(), dv.getUTCDate());
        }
    };
    DesignerCube.prototype.searchPCube = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.mainPage = true;
            self.loader = true;
            self.cubeList = [];
            if (self.cubeReg != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            }
            else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.cubeReg;
            var resu = self.cubeService.search(BiUrls.CUBE, BiUrls.SEARCH_P_CUBE, self.cubeReg, self.sPage, self.pageSize).then(function (res) {
                self.loadSearchedPCube(res);
                self.loader = false;
            }, function (err) {
                console.error(err);
            });
            resolve('completed');
        });
    };
    // By Lalu
    DesignerCube.prototype.loadSearchedPCube = function (res) {
        var self = this;
        self.cubeList = (res != undefined) ? res.data.pageElements : [];
        self.totalCubes = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalCubes);
    };
    DesignerCube.prototype.clickEdit = function (cubeData) {
        var self = this;
        self.loader = true;
        self.selectedCubeId = null;
        self.cubeService.getDataById(BiUrls.EDIT_ANALYTICAL_MODEL, cubeData.id).then(function (res) {
            console.log(res.data);
            if (res == undefined || res.data == undefined) {
                self.callToaster(mdmService_service_MDMService.ERROR, 'Cannot load Cube');
                self.mainPage = true;
            }
            else {
                self.mainPage = false;
                self.emitEdit.emit(true);
                self.isEdit = true;
                self.cubeData = JSON.parse(JSON.stringify(res.data));
                console.log(self.cubeData);
                self.cubeMeasureDataList = self.cubeData.cubeMeasureData;
                self.cubeDimensionUsageList = self.cubeData.cubeDimensionUsageData;
                delete self.cubeData.schema;
                delete self.cubeData.facts;
                delete self.cubeData.schemaName;
                delete self.cubeData.status;
                delete self.cubeData.factNames;
                delete self.cubeData.dataSourceName;
                self.cubeService.referencePage = self.pageNo;
                self.emitCubeData.emit(self.cubeData);
            }
            self.loader = false;
        }, function (err) {
            console.error(err);
        });
    };
    DesignerCube.prototype.onBack = function () {
        this.referencevariable = 'none';
        this.mainPage = true;
        this.cubePage = false;
        this.selectedCubeId = null;
        this.isEdit = false;
        this.recordObject = {};
        this.cubeMeasureDataList = [];
        this.filteredMeasureMap.clear();
        this.filteredDimensionMap.clear();
        this.cubeDimensionUsageList = [];
        this.emitEdit.emit(false);
        this.measurePage = false;
        this.dimensionPage = false;
        this.reload = null;
    };
    DesignerCube.prototype.deleteModel = function (cube) {
        var self = this;
        self.loader = true;
        self.cubeService.deleteModel(BiUrls.DELETE_ANALYTICAL_MODEL, cube.id, cube.recordFormatId, cube.dataSourceId).then(function (res) {
            if (res.success) {
                self.callToaster(mdmService_service_MDMService.SUCCESS, cube.name + ' removed successfully');
            }
            else if (res.message) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.message);
            }
            else if (res.errorMessage) {
                self.callToaster(mdmService_service_MDMService.ERROR, res.errorMessage);
            }
            else {
                self.callToaster(mdmService_service_MDMService.ERROR, 'Unable to remove analytical model');
            }
            self.pageNo = self.cubeList.length == 1 ?
                self.totalCubes == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadCube();
            self.loader = false;
        }, function (err) {
            self.callToaster(mdmService_service_MDMService.ERROR, 'Unable to remove analytical model : ' + err.errorCode);
        });
    };
    DesignerCube.prototype.removeModel = function (cube) {
        var self = this;
        if (!cube.recordFormatId) {
            self.callToaster(mdmService_service_MDMService.ERROR, 'Delete cube directly. No record format associated with this model.');
        }
        else if (!cube.dataSourceId) {
            self.callToaster(mdmService_service_MDMService.ERROR, 'Delete cube directly. No data source associated with this model.');
        }
        else {
            // let r = confirm('Are you sure you want to delete the cube ' + cube.name + '?');
            var r = false;
            var msg = 'Are you sure you want to delete the cube ' + cube.name;
            if (cube.isStarSchema) {
                r = confirm(msg + '?\nNo dimension will be deleted as it\'s a star schema model.');
            }
            else {
                r = confirm(msg + '?\nAll dimensions associated with this cube will be deleted.');
            }
            if (r == true) {
                this.deleteModel(cube);
            }
        }
    };
    DesignerCube.prototype.clearCacheForCube = function (cube) {
        var self = this;
        self.cubeService.clearCache('ads/clearDataCache/' + cube.id).then(function (res) {
            if (res.success) {
                self.callToaster(mdmService_service_MDMService.SUCCESS, "Cube Cache cleared successfully!");
            }
            else {
                self.callToaster(mdmService_service_MDMService.ERROR, "Unable To Clear Cube Cache!");
            }
        });
    };
    DesignerCube.prototype.clearCache = function () {
        var self = this;
        self.cubeService.clearCache('ads/clearDataCache').then(function (res) {
            if (res.success) {
                self.callToaster(mdmService_service_MDMService.SUCCESS, "Cache cleared successfully!");
            }
            else {
                self.callToaster(mdmService_service_MDMService.ERROR, "Unable To Clear Cache!");
            }
        });
    };
    return DesignerCube;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/designerCube.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_controller_loader.component.ngfactory,_controller_loader.component,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_angular_forms,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,angular2_multiselect_dropdown_clickOutside,_designerCube.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent,_.._common_service_ngbDateConverter.utils PURE_IMPORTS_END */





















var styles_DesignerCube = [];
var RenderType_DesignerCube = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_DesignerCube, data: {} });

function View_DesignerCube_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 24, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "DataSource"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" DataSource "])), (_l()(), core["ɵeld"](18, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Data Version"]], null, null, null, null, null)), core["ɵdid"](19, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Data Version "])), (_l()(), core["ɵeld"](22, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](23, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_0 = "Code"; _ck(_v, 3, 0, currVal_0); var currVal_1 = "Name"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Description"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "DataSource"; _ck(_v, 15, 0, currVal_3); var currVal_4 = "Data Version"; _ck(_v, 19, 0, currVal_4); var currVal_5 = "Actions"; _ck(_v, 23, 0, currVal_5); }, null); }
function View_DesignerCube_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](1, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_DesignerCube_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clearCacheForCube(_v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Clear Cache "]))], null, null);
}
function View_DesignerCube_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clickEdit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_8)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeModel(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.enableCache; _ck(_v, 7, 0, currVal_0); }, null);
}
function View_DesignerCube_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 28, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_6)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](4, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](8, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, [" ", " "])), (_l()(), core["ɵeld"](11, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](12, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), (_l()(), core["ɵeld"](15, 16777216, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](16, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](17, 0, null, null, 0, "h6", [["class", "mb-lg-0 text-truncate"]], [[8, "innerHTML", 1]], null, null, null, null)), (_l()(), core["ɵeld"](18, 16777216, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](19, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵppd"](20, 2), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], [[8, "innerHTML", 1]], null, null, null, null)), core["ɵppd"](22, 2), (_l()(), core["ɵeld"](23, 0, null, null, 5, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOps($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 2, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 1, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00A0\u00A0\u00A0\u00A0\u00A0"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_7)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.loader; _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.cubeCode, ""); _ck(_v, 4, 0, currVal_1); var currVal_3 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.name, ""); _ck(_v, 8, 0, currVal_3); var currVal_5 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.description, ""); _ck(_v, 12, 0, currVal_5); var currVal_7 = core["ɵinlineInterpolate"](1, "", (_v.context.$implicit.dataSourceName ? _v.context.$implicit.dataSourceName : "N/A"), ""); _ck(_v, 16, 0, currVal_7); var currVal_9 = core["ɵinlineInterpolate"](1, "", ((_v.context.$implicit.dataVersionType == "Dynamic") ? "Dynamic" : core["ɵunv"](_v, 19, 0, _ck(_v, 20, 0, core["ɵnov"](_v.parent.parent.parent.parent, 0), _v.context.$implicit.dataVersion, _co.mediumDate))), ""); _ck(_v, 19, 0, currVal_9); var currVal_12 = ((_co.selectedCubeId == _v.context.$implicit.id) ? true : false); _ck(_v, 28, 0, currVal_12); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = _v.context.$implicit.cubeCode; _ck(_v, 6, 0, currVal_2); var currVal_4 = _v.context.$implicit.name; _ck(_v, 10, 0, currVal_4); var currVal_6 = _v.context.$implicit.description; _ck(_v, 14, 0, currVal_6); var currVal_8 = (_v.context.$implicit.dataSourceName ? _v.context.$implicit.dataSourceName : "N/A"); _ck(_v, 17, 0, currVal_8); var currVal_10 = ((_v.context.$implicit.dataVersionType == "Dynamic") ? "Dynamic" : core["ɵunv"](_v, 21, 0, _ck(_v, 22, 0, core["ɵnov"](_v.parent.parent.parent.parent, 0), _v.context.$implicit.dataVersion, _co.mediumDate))); _ck(_v, 21, 0, currVal_10); var currVal_11 = _v.context.$implicit.id; _ck(_v, 23, 0, currVal_11); });
}
function View_DesignerCube_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Results Found"]))], null, null); }
function View_DesignerCube_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_10)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DesignerCube_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](1, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = true; var currVal_1 = false; var currVal_2 = true; var currVal_3 = _co.totalCubes; var currVal_4 = 5; var currVal_5 = _co.currentPage; var currVal_6 = _co.pageSize; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); }, null);
}
function View_DesignerCube_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 46, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left p-3 light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, [["searchBox", 1]], null, 7, "input", [["class", "w-50 float-left form-control"], ["id", "searchBox"], ["maxlength", "100"], ["name", "searchBox"], ["ng-reflect-maxlength", "100"], ["ng-reflect-model", ""], ["placeholder", "Keywords"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeReg = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "button", [["class", "btn btn-primary float-left"], ["id", "Search"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchPCube() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Search"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_4)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_5)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_9)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " - ", " of ", " items "])), (_l()(), core["ɵeld"](23, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](26, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](40, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_11)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = "searchBox"; var currVal_10 = _co.cubeReg; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = (_co.cubeList && _co.cubeList.length); _ck(_v, 15, 0, currVal_11); var currVal_12 = _co.cubeList; _ck(_v, 17, 0, currVal_12); var currVal_13 = (_co.cubeList.length == 0); _ck(_v, 19, 0, currVal_13); var currVal_24 = _co.pageSize; _ck(_v, 29, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 33, 0, currVal_25); var currVal_26 = "10"; _ck(_v, 34, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 37, 0, currVal_27); var currVal_28 = "20"; _ck(_v, 38, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 41, 0, currVal_29); var currVal_30 = "30"; _ck(_v, 42, 0, currVal_30); var currVal_31 = (_co.cubeList && _co.cubeList.length); _ck(_v, 46, 0, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_14 = _co.startingPage; var currVal_15 = _co.endingPage; var currVal_16 = _co.totalCubes; _ck(_v, 22, 0, currVal_14, currVal_15, currVal_16); var currVal_17 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 31).ngClassValid; var currVal_22 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); });
}
function View_DesignerCube_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Cube "]))], null, null); }
function View_DesignerCube_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["Edit Cube - ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.cubeData.cubeCode; _ck(_v, 1, 0, currVal_0); }); }
function View_DesignerCube_15(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Source"])), (_l()(), core["ɵeld"](3, 0, null, null, 7, "input", [["class", "form-control"], ["id", "dataSource"], ["maxlength", "100"], ["placeholder", " Data Source Name"], ["readonly", ""], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeData.dataSourceData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = _co.cubeData.dataSourceData.name; _ck(_v, 8, 0, currVal_9); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_DesignerCube_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.saveButton; _ck(_v, 1, 0, currVal_0); });
}
function View_DesignerCube_18(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.id; var currVal_1 = ((_co.cubeData.recordFormatId == _v.context.$implicit.id) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_DesignerCube_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 38, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 9, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [["for", "recordFormat"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Record Format"])), (_l()(), core["ɵeld"](5, 0, null, null, 6, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.confirmChangeOfRecordFormat($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](7, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](8, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_18)), core["ɵdid"](11, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 16, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "label", [["for", "cubeData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Version"])), (_l()(), core["ɵeld"](15, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 9, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 16777216, null, null, 8, "input", [["class", "form-control light-bg"], ["name", "DataVersionDate"], ["ngbDatepicker", ""], ["placeholder", "YYYYMMDD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 18)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 18).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 18)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 18)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("input" === en)) {
                var pd_4 = (core["ɵnov"](_v, 20).manualDateChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("change" === en)) {
                var pd_5 = (core["ɵnov"](_v, 20).manualDateChange($event.target.value, true) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 20).onBlur() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.dataVersionDate = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](18, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](20, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], datepicker_input_NgbInputDatepicker]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 2, "div", [["class", "col-sx-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 1, "button", [["class", "iga-left form-control light-bg"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 20).toggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 9, "div", [["class", "col-lg-6 col-md-6 float-left left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 8, "div", [["class", "w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 1, "label", [["class", "mb-0 mr-3"], ["for", "enableCache"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Enable Cache"])), (_l()(), core["ɵeld"](33, 0, null, null, 5, "input", [["id", "enableCache"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 34).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 34).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.cubeData.enableCache = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](34, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](36, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](38, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "none"; _ck(_v, 7, 0, currVal_0); var currVal_1 = "none"; _ck(_v, 8, 0, currVal_1); var currVal_2 = _co.recordList; _ck(_v, 11, 0, currVal_2); var currVal_11 = "DataVersionDate"; var currVal_12 = _co.dataVersionDate; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_20 = _co.cubeData.enableCache; _ck(_v, 36, 0, currVal_20); }, function (_ck, _v) { var currVal_3 = core["ɵnov"](_v, 20).disabled; var currVal_4 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_6 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_7 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_8 = core["ɵnov"](_v, 25).ngClassValid; var currVal_9 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_10 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 17, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10); var currVal_13 = core["ɵnov"](_v, 38).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 38).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 38).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 38).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 38).ngClassValid; var currVal_18 = core["ɵnov"](_v, 38).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 38).ngClassPending; _ck(_v, 33, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); });
}
function View_DesignerCube_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 45, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_13)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_14)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](11, 0, null, null, 34, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["placeholder", " Cube Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](23, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](25, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](26, 0, null, null, 2, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_15)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](33, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["placeholder", "Description (Optional)"], ["rows", "1"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 35)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 35).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 35)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 35)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.cubeData.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](35, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](36, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](39, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](41, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_16)), core["ɵdid"](43, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_17)), core["ɵdid"](45, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.isEdit; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.isEdit; _ck(_v, 5, 0, currVal_1); var currVal_10 = "200"; _ck(_v, 20, 0, currVal_10); var currVal_11 = "name"; var currVal_12 = _co.cubeData.name; _ck(_v, 23, 0, currVal_11, currVal_12); var currVal_13 = _co.cubeData.dataSourceData; _ck(_v, 28, 0, currVal_13); var currVal_22 = "350"; _ck(_v, 36, 0, currVal_22); var currVal_23 = "description"; var currVal_24 = _co.cubeData.description; _ck(_v, 39, 0, currVal_23, currVal_24); var currVal_25 = !_co.isEdit; _ck(_v, 43, 0, currVal_25); var currVal_26 = _co.isEdit; _ck(_v, 45, 0, currVal_26); }, function (_ck, _v) { var currVal_2 = (core["ɵnov"](_v, 20).maxlength ? core["ɵnov"](_v, 20).maxlength : null); var currVal_3 = core["ɵnov"](_v, 25).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 25).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 25).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 25).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 25).ngClassValid; var currVal_8 = core["ɵnov"](_v, 25).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 25).ngClassPending; _ck(_v, 18, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_14 = (core["ɵnov"](_v, 36).maxlength ? core["ɵnov"](_v, 36).maxlength : null); var currVal_15 = core["ɵnov"](_v, 41).ngClassUntouched; var currVal_16 = core["ɵnov"](_v, 41).ngClassTouched; var currVal_17 = core["ɵnov"](_v, 41).ngClassPristine; var currVal_18 = core["ɵnov"](_v, 41).ngClassDirty; var currVal_19 = core["ɵnov"](_v, 41).ngClassValid; var currVal_20 = core["ɵnov"](_v, 41).ngClassInvalid; var currVal_21 = core["ɵnov"](_v, 41).ngClassPending; _ck(_v, 34, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21); });
}
function View_DesignerCube_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_3)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_12)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mainPage; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.cubePage; _ck(_v, 4, 0, currVal_1); }, null); }
function View_DesignerCube_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_DesignerCube_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, null, null, null, null, function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("scroll" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("scroll" === en)) {
                var pd_1 = (_co.windowPosition() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, clickOutside_ScrollDirective, [core["ElementRef"]], null, { scroll: "scroll" }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_19)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 5, 0, currVal_1); }, null);
}
function View_DesignerCube_0(_l) { return core["ɵvid"](0, [core["ɵpid"](0, common["DatePipe"], [core["LOCALE_ID"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignerCube_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DesignerCube_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "designerCube", [], null, null, null, View_DesignerCube_0, RenderType_DesignerCube)), core["ɵdid"](1, 638976, null, 0, designerCube_component_DesignerCube, [mdmService_service_MDMService, ToasterComponent, ngbDateConverter_utils_NgbDateConverter, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DesignerCubeNgFactory = /*@__PURE__*/ core["ɵccf"]("designerCube", designerCube_component_DesignerCube, View_DesignerCube_Host_0, { reload: "reload" }, { emitEdit: "emitEdit", emitCubeData: "emitCubeData" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/dataMapper.ts


var dataMapper_DataMapper = /*@__PURE__*/ (function () {
    function DataMapper(cubeService) {
        this.cubeService = cubeService;
        this.analyticalModelData = {};
        this.dimensionList = [];
        this.cubeMesMap = new Map();
        this.cubeDimMap = new Map();
        this.isDimMap = new Map();
        this.dimMap = new Map();
        this.rffIndexMap = new Map();
        this.selectDimMap = new Map();
        this.PkExistsMap = new Map();
        this.isDimTime = false;
        this.dimTimeMap = new Map();
        // public measureHistory = new Map();
        // public dimensionHistory = new Map();
        this.dimValidationSender = new core["EventEmitter"]();
        this.measureListSender = new core["EventEmitter"]();
        this.dimensionListSender = new core["EventEmitter"]();
        this.formulaMeasureEmitter = new core["EventEmitter"]();
        this.formualMeasureMap = new Map();
    }
    DataMapper.prototype.ngOnChanges = function () {
        this.separateDimensionAndMeasure();
        if (this.isStarSchema === true || this.analyticalModelData.isStarSchema === true) {
            this.isStarSchema = true;
            this.setType();
            this.setSelectedDimensions();
        }
    };
    DataMapper.prototype.separateDimensionAndMeasure = function () {
        var _this = this;
        this.analyticalModelData.cube.cubeMeasureData.forEach(function (measure) {
            if (measure.recordFormatFieldId) {
                _this.cubeMesMap.set(measure.recordFormatFieldId, measure);
            }
            else {
                _this.formualMeasureMap.set(measure.measureId, measure);
            }
        });
        this.analyticalModelData.cube.cubeDimensionUsageData.forEach(function (cdu) {
            _this.cubeDimMap.set(cdu.recordFormatFieldId, cdu);
            if (cdu.defaultTimeFilter === true) {
                _this.defaultTimeFilter = cdu.recordFormatFieldId;
            }
            if (cdu.dimensionData.dimTime === true) {
                _this.dimTimeMap.set(cdu.recordFormatFieldId, true);
            }
        });
        this.triggerChanges();
    };
    DataMapper.prototype.setType = function () {
        var _this = this;
        this.analyticalModelData.fact.recordFormatFieldData.forEach(function (rff, i) {
            _this.isDimMap.set(i, rff.isDim);
        });
    };
    DataMapper.prototype.setSelectedDimensions = function () {
        var self = this;
        self.setRFFIndexMap();
        self.rffIndexMap.forEach(function (index, rffId) {
            if (self.isDimMap.get(index)) {
                var cduData = self.cubeDimMap.get(rffId);
                if (cduData) {
                    self.dimMap.set(rffId, cduData.dimensionId);
                    self.selectDimMap.set(index, rffId);
                }
            }
        });
        self.getPKexists();
        self.dimValidation = self.analyticalModelData.cube.id !== undefined;
        this.dimValidationSender.emit(this.dimValidation);
    };
    DataMapper.prototype.setRFFIndexMap = function () {
        var _this = this;
        this.analyticalModelData.fact.recordFormatFieldData.forEach(function (rff, index) {
            _this.rffIndexMap.set(rff.refId, index);
        });
    };
    DataMapper.prototype.randomIdGenerator = function () {
        return Math.floor(100000 + Math.random() * 90);
    };
    DataMapper.prototype.onChangeOfType = function (event, rf, i) {
        var value = event.target.value;
        if (value === 'dimension') {
            this.dimValidation = false;
            this.cubeMesMap.delete(rf.refId);
            this.isDimMap.set(i, true);
            this.removeFromMeasureMap(rf.refId, value);
        }
        else if (value === 'measure') {
            this.selectDimMap.delete(i);
            this.dimMap.delete(rf.refId);
            this.cubeDimMap.delete(rf.refId);
            this.isDimMap.set(i, false);
            this.setDimValidation();
            this.dimTimeMap.delete(rf.refId);
            this.removeFromDimensionMap(rf.refId, value);
        }
        else {
            this.dimTimeMap.delete(rf.refId);
            this.selectDimMap.delete(i);
            this.dimMap.delete(rf.refId);
            this.isDimMap.set(i, false);
            this.cubeMesMap.delete(rf.refId);
            this.cubeDimMap.delete(rf.refId);
            this.setDimValidation();
            this.analyticalModelData.fact.recordFormatFieldData.forEach(function (recordFormatField) {
                if (recordFormatField.refId === rf.refId) {
                    recordFormatField.isDim = null;
                }
            });
        }
        this.triggerChanges();
    };
    DataMapper.prototype.setDimValidation = function () {
        this.dimValidation = (this.selectDimMap.size === this.cubeDimMap.size);
    };
    DataMapper.prototype.onSelectDimension = function (event, rff, i) {
        var rffId = rff.refId;
        var dimension;
        if (event.target.value !== '') {
            this.dimensionList.forEach(function (dim) {
                if (dim.refId === +event.target.value) {
                    dimension = dim;
                }
            });
            (!this.cubeDimMap.has(rffId)) ? this.createCubeDimensionUsage(rffId) : null;
            this.cubeDimMap.get(rffId).dimensionData = dimension;
            this.cubeDimMap.get(rffId).name = dimension.displayName;
            this.cubeDimMap.get(rffId).dimensionId = dimension.refId;
            this.cubeDimMap.get(rffId).dimHierarchyLevelId = null;
            this.cubeDimMap.get(rffId).recordFormatFieldId = rffId;
            this.selectDimMap.set(i, rffId);
            this.dimMap.set(rffId, +event.target.value);
            this.dimTimeMap.set(rffId, true);
            this.setDimValidation();
        }
        this.triggerChanges();
    };
    DataMapper.prototype.getPKexists = function () {
        var self = this;
        this.dimensionList.forEach(function (dim) {
            if (dim.isPkExists === true) {
                self.PkExistsMap.set(dim.refId, true);
            }
        });
    };
    DataMapper.prototype.selectDefaultDim = function (isdefaultDim, rffId) {
        this.cubeDimMap.forEach(function (value) {
            value.defaultTimeFilter = false;
        });
        this.cubeDimMap.get(rffId).defaultTimeFilter = isdefaultDim;
        this.defaultTimeFilter = rffId;
        this.triggerChanges();
    };
    DataMapper.prototype.removeFromMeasureMap = function (id, type) {
        this.analyticalModelData.cube.cubeMeasureData.some(function (element) {
            if (element.refId === id) {
                element.deleted = true;
                return true;
            }
        });
        this.analyticalModelData.fact.recordFormatFieldData.some(function (rf) {
            if (rf.refId === id) {
                rf.isDim = true;
            }
        });
        if (type !== 'none') {
            // if (this.dimensionHistory.has(id)) {
            // this.dimensionHistory.set(id, this.dimensionHistory.get(id))
            // } else {
            this.createCubeDimensionUsage(id);
            // }
        }
    };
    DataMapper.prototype.createCubeDimensionUsage = function (id) {
        var cubeDimension = new CubeDimension();
        cubeDimension.refId = this.randomIdGenerator();
        var rff = this.analyticalModelData.fact.recordFormatFieldData.filter(function (element) {
            return element.refId === id;
        });
        cubeDimension.deleted = false;
        cubeDimension.recordFormatField = rff[0];
        cubeDimension.recordFormatFieldId = rff[0].refId;
        cubeDimension.name = cubeDimension.recordFormatField.fieldName;
        cubeDimension.dimensionData.displayName = cubeDimension.recordFormatField.displayName;
        cubeDimension.dimensionData.name = cubeDimension.recordFormatField.fieldName;
        cubeDimension.dimensionData.refId = this.randomIdGenerator();
        cubeDimension.dimensionId = cubeDimension.dimensionData.refId;
        cubeDimension.dimensionData.dimTime = false;
        cubeDimension.dimensionData.deleted = false;
        cubeDimension.dimensionData.dimHierarchyData[0] = new DimHierarchyData();
        cubeDimension.dimensionData.dimHierarchyData[0].name = cubeDimension.name;
        cubeDimension.dimensionData.dimHierarchyData[0].dimId = cubeDimension.dimensionData.refId;
        cubeDimension.dimensionData.dimHierarchyData[0].refId = this.randomIdGenerator();
        cubeDimension.dimensionData.dimHierarchyData[0].recordFormatFieldId = rff[0].refId;
        cubeDimension.dimensionData.dimHierarchyData[0].recordFormatId = rff[0].recordFormatId;
        cubeDimension.dimensionData.dimHierarchyData[0].deleted = false;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0] = new DimHierarchyLevelData();
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].refId = this.randomIdGenerator();
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].displayName = cubeDimension.dimensionData.displayName;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].dimHierarchyId = cubeDimension.dimensionData.dimHierarchyData[0].id;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].field = cubeDimension.recordFormatField;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].recordFormatFieldId = cubeDimension.recordFormatField.refId;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].deleted = false;
        rff[0].sysCreated = false;
        cubeDimension.dimHierarchyLevelId = cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].refId;
        this.cubeDimension = cubeDimension;
        if (!this.cubeDimMap.has(id)) {
            this.cubeDimMap.set(id, Object.assign({}, this.cubeDimension));
        }
        console.log(this.cubeDimMap.get(id));
    };
    DataMapper.prototype.removeFromDimensionMap = function (id, type) {
        this.analyticalModelData.cube.cubeDimensionUsageData.some(function (element) {
            if (element.refId === id) {
                element.deleted = true;
                return true;
            }
        });
        this.analyticalModelData.fact.recordFormatFieldData.some(function (rf) {
            if (rf.refId === id) {
                rf.isDim = false;
            }
        });
        if (type !== 'none') {
            this.createCubeMeasureData(id);
        }
    };
    DataMapper.prototype.createCubeMeasureData = function (id) {
        var cubeMeasureData = new CubeMeasure();
        var rff = this.analyticalModelData.fact.recordFormatFieldData.filter(function (element) {
            return element.refId === id;
        });
        cubeMeasureData.recordFormatField = rff[0];
        cubeMeasureData.recordFormatFieldId = cubeMeasureData.recordFormatField.refId;
        cubeMeasureData.name = cubeMeasureData.recordFormatField.fieldName;
        cubeMeasureData.deleted = false;
        cubeMeasureData.measureData = new MeasureData();
        cubeMeasureData.measureData.refId = this.randomIdGenerator();
        cubeMeasureData.measureId = cubeMeasureData.measureData.refId;
        cubeMeasureData.measureData.name = cubeMeasureData.name;
        cubeMeasureData.measureData.targetType = 'max';
        cubeMeasureData.measureData.aggregator = 'sum';
        cubeMeasureData.measureData.measureDisplayName = cubeMeasureData.recordFormatField.displayName;
        cubeMeasureData.measureData.deleted = false;
        cubeMeasureData.measureData.measureStatusIndicator = [];
        cubeMeasureData.measureData.measureTarget = [];
        rff[0].sysCreated = false;
        if (!this.cubeMesMap.has(id)) {
            this.cubeMesMap.set(id, Object.assign({}, cubeMeasureData));
        }
    };
    DataMapper.prototype.triggerChanges = function () {
        this.dimValidationSender.emit(this.dimValidation);
        this.dimensionListSender.emit(this.cubeDimMap);
        this.measureListSender.emit(this.cubeMesMap);
        this.formulaMeasureEmitter.emit(this.formualMeasureMap);
    };
    return DataMapper;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/dataMapper.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_dataMapper,_services_mdmService.service PURE_IMPORTS_END */







var styles_DataMapper = [];
var RenderType_DataMapper = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_DataMapper, data: {} });

function View_DataMapper_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Dimension "]))], null, null); }
function View_DataMapper_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0], [1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, [" ", " (", ") "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.dimMap.get(_v.parent.parent.context.$implicit.refId) == _v.context.$implicit.refId) ? true : null); var currVal_1 = _v.context.$implicit.refId; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; var currVal_3 = _v.context.$implicit.dimCode; _ck(_v, 3, 0, currVal_2, currVal_3); }); }
function View_DataMapper_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "select", [["class", "form-control p-1"], ["id", "dimcube"], ["required", ""]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onSelectDimension($event, _v.parent.context.$implicit, _v.parent.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "option", [["disabled", ""], ["hidden", ""], ["selected", ""], ["value", ""]], null, null, null, null, null)), core["ɵdid"](3, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](4, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Select here"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataMapper_4)), core["ɵdid"](7, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = ""; _ck(_v, 3, 0, currVal_0); var currVal_1 = ""; _ck(_v, 4, 0, currVal_1); var currVal_2 = _co.dimensionList; _ck(_v, 7, 0, currVal_2); }, null);
}
function View_DataMapper_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, [["isdefaultDim", 1]], null, 5, "input", [["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("change" === en)) {
                var pd_2 = (_co.selectDefaultDim(core["ɵnov"](_v, 0).checked, _v.parent.context.$implicit.refId) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](3, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, null), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = ((_co.defaultTimeFilter == _v.parent.context.$implicit.refId) ? true : null); _ck(_v, 3, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 5).ngClassValid; var currVal_5 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_DataMapper_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-exclamation-circle mr-2"], ["style", "pointer-events: none;color:red"]], null, null, null, null, null))], null, null); }
function View_DataMapper_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-2 col-xs-2 text-danger float-right"], ["ngbTooltip", "No Primary Key found"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataMapper_7)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = "No Primary Key found"; _ck(_v, 1, 0, currVal_0); var currVal_1 = !_co.PkExistsMap.get(_co.dimMap.get(_v.parent.context.$implicit.refId)); _ck(_v, 3, 0, currVal_1); }, null); }
function View_DataMapper_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 27, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), (_l()(), core["ɵeld"](7, 0, null, null, 13, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 12, "select", [["class", "form-control p-1"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onChangeOfType($event, _v.context.$implicit, _v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 3, "option", [["value", "none"]], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](10, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](11, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None "])), (_l()(), core["ɵeld"](13, 0, null, null, 3, "option", [["value", "measure"]], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](14, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](15, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Measure "])), (_l()(), core["ɵeld"](17, 0, null, null, 3, "option", [["value", "dimension"]], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](18, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](19, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Dimension "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataMapper_3)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](23, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataMapper_5)), core["ɵdid"](25, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataMapper_6)), core["ɵdid"](27, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_3 = "none"; _ck(_v, 10, 0, currVal_3); var currVal_4 = "none"; _ck(_v, 11, 0, currVal_4); var currVal_6 = "measure"; _ck(_v, 14, 0, currVal_6); var currVal_7 = "measure"; _ck(_v, 15, 0, currVal_7); var currVal_9 = "dimension"; _ck(_v, 18, 0, currVal_9); var currVal_10 = "dimension"; _ck(_v, 19, 0, currVal_10); var currVal_11 = (_co.isStarSchema && _co.isDimMap.get(_v.context.index)); _ck(_v, 22, 0, currVal_11); var currVal_12 = _co.dimTimeMap.get(_v.context.$implicit.refId); _ck(_v, 25, 0, currVal_12); var currVal_13 = (_co.isStarSchema && _co.isDimMap.get(_v.context.index)); _ck(_v, 27, 0, currVal_13); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.fieldName; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 6, 0, currVal_1); var currVal_2 = ((!_co.cubeMesMap.has(_v.context.$implicit.refId) || !_co.cubeDimMap.has(_v.context.$implicit.refId)) ? true : ((_v.context.$implicit.isDim == undefined) ? true : null)); _ck(_v, 9, 0, currVal_2); var currVal_5 = (((_co.cubeMesMap.has(_v.context.$implicit.refId) || _co.cubeDimMap.has(_v.context.$implicit.refId)) && (_v.context.$implicit.isDim == false)) ? true : null); _ck(_v, 13, 0, currVal_5); var currVal_8 = (((_co.cubeMesMap.has(_v.context.$implicit.refId) || _co.cubeDimMap.has(_v.context.$implicit.refId)) && (_v.context.$implicit.isDim == true)) ? true : null); _ck(_v, 17, 0, currVal_8); });
}
function View_DataMapper_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 19, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 18, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 15, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 14, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Column Header "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Display Name "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Type "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataMapper_1)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Default Time Filter "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataMapper_2)), core["ɵdid"](19, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isStarSchema; _ck(_v, 14, 0, currVal_0); var currVal_1 = _co.analyticalModelData.fact.recordFormatFieldData; _ck(_v, 19, 0, currVal_1); }, null); }
function View_DataMapper_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "dataMapper", [], null, null, null, View_DataMapper_0, RenderType_DataMapper)), core["ɵdid"](1, 573440, null, 0, dataMapper_DataMapper, [mdmService_service_MDMService], null, null)], null, null); }
var DataMapperNgFactory = /*@__PURE__*/ core["ɵccf"]("dataMapper", dataMapper_DataMapper, View_DataMapper_Host_0, { analyticalModelData: "analyticalModelData", isStarSchema: "isStarSchema", dimensionList: "dimensionList" }, { dimValidationSender: "dimValidationSender", measureListSender: "measureListSender", dimensionListSender: "dimensionListSender", formulaMeasureEmitter: "formulaMeasureEmitter" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/dataPreview.ts

// import { NumberUtils } from './../../common/service/number.utils';
var dataPreview_DataPreview = /*@__PURE__*/ (function () {
    function DataPreview() {
        this.previewAnalyticalModel = {};
        this.tntConfData = {};
        this.pageDetailsSender = new core["EventEmitter"]();
        this.loadPreviewSender = new core["EventEmitter"]();
        this.loader = false;
        this.pageNo = 0;
        this.pageSize = 10;
        this.startingPage = 0;
        this.endingPage = 10;
        this.currentPage = 1;
        this.total = 0;
    }
    // constructor() { }
    DataPreview.prototype.ngOnChanges = function () {
        if (this.previewAnalyticalModel && this.previewAnalyticalModel != 'error') {
            this.setPagination();
            // this.setConfigs();
            // this.setValue();
            this.loader = false;
        }
        else if (this.previewAnalyticalModel == 'error') {
            this.loader = false;
        }
        else {
            this.loader = true;
            this.loadPreviewSender.emit(true);
        }
    };
    DataPreview.prototype.setConfigs = function () {
        var _this = this;
        if (!this.tntConfData)
            return;
        this.tntConfData.tenantConfigDataList.forEach(function (conf) {
            if (conf.key == 'NUMBER_FORMAT') {
                _this.numFormat = conf.value;
                return;
            }
        });
        this.decFormat = this.numFormat.length - this.numFormat.indexOf(".") - 1;
    };
    DataPreview.prototype.setValue = function () {
        var _this = this;
        var self = this;
        self.previewAnalyticalModel.rows.forEach(function (row, i) {
            var rowData = [];
            row.forEach(function (val) {
                var numVal = Number(val);
                if (!Number.isNaN(numVal) && numVal != 0) {
                    val = numVal.toFixed(_this.decFormat).toString();
                    numVal = val.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                    numVal = numVal.toString().split(".");
                    numVal = Number(numVal[1]) != 0 ? numVal.join(".") : numVal[0];
                    rowData.push(numVal);
                }
                else {
                    rowData.push(val);
                }
            });
            self.previewAnalyticalModel.rows[i] = rowData;
        });
    };
    DataPreview.prototype.setPagination = function () {
        this.total = this.previewAnalyticalModel.total;
        this.currentPage = this.previewAnalyticalModel.page + 1;
        this.pageSize = this.previewAnalyticalModel.size;
        this.startingPage = Math.floor(this.pageSize * (this.currentPage - 1));
        this.endingPage = this.startingPage + this.pageSize;
        (this.endingPage > this.total) ? this.endingPage = this.total : null;
    };
    DataPreview.prototype.OnPageSizeChanged = function (event) {
        this.pageSize = event.target.value;
        var maxPage = Math.floor(this.total / this.pageSize);
        if (maxPage < this.pageNo) {
            this.pageNo = maxPage;
        }
        this.setPageDetails();
        this.loader = true;
        this.previewAnalyticalModel = null;
        this.pageDetailsSender.emit(this.pageDetails);
    };
    DataPreview.prototype.onPageChange = function (event) {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        this.setPageDetails();
        this.loader = true;
        this.previewAnalyticalModel = null;
        this.pageDetailsSender.emit(this.pageDetails);
    };
    DataPreview.prototype.setPageDetails = function () {
        this.pageDetails = {
            pageNo: this.pageNo, pageSize: this.pageSize,
        };
    };
    return DataPreview;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/dataPreview.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _.._biAdminStyles.css.shim.ngstyle,_angular_core,_angular_common,_angular_forms,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_controller_loader.component.ngfactory,_controller_loader.component,_dataPreview PURE_IMPORTS_END */










var styles_DataPreview = [biAdminStyles_css_shim_ngstyle_styles];
var RenderType_DataPreview = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_DataPreview, data: {} });

function View_DataPreview_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" No Data for preview"]))], null, null); }
function View_DataPreview_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "th", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 2, 0, currVal_0); }); }
function View_DataPreview_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "td", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit[_v.context.index]; _ck(_v, 2, 0, currVal_0); }); }
function View_DataPreview_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "tr", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataPreview_5)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.previewAnalyticalModel.headers; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DataPreview_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 26, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "float-left mb-0 mr-4"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " items of ", " "])), (_l()(), core["ɵeld"](3, 0, null, null, 20, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Show items per page"])), (_l()(), core["ɵeld"](6, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](12, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](13, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](14, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](16, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](17, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](18, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](20, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](21, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](22, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](24, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.currentPage = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](26, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_10 = _co.pageSize; _ck(_v, 9, 0, currVal_10); var currVal_11 = "10"; _ck(_v, 13, 0, currVal_11); var currVal_12 = "10"; _ck(_v, 14, 0, currVal_12); var currVal_13 = "20"; _ck(_v, 17, 0, currVal_13); var currVal_14 = "20"; _ck(_v, 18, 0, currVal_14); var currVal_15 = "30"; _ck(_v, 21, 0, currVal_15); var currVal_16 = "30"; _ck(_v, 22, 0, currVal_16); var currVal_17 = true; var currVal_18 = false; var currVal_19 = true; var currVal_20 = _co.total; var currVal_21 = 5; var currVal_22 = _co.currentPage; var currVal_23 = _co.pageSize; _ck(_v, 26, 0, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.startingPage + 1); var currVal_1 = _co.endingPage; var currVal_2 = _co.total; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2); var currVal_3 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 11).ngClassValid; var currVal_8 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 6, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); });
}
function View_DataPreview_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "main-table table-custom"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 11, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "div", [["class", "table-responsive text-nowrap"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 7, "table", [["class", "table table-bordered table-hover table-striped"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "thead", [["class", "thead-dark"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "tr", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataPreview_3)), core["ɵdid"](7, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 2, "tbody", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataPreview_4)), core["ɵdid"](10, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataPreview_6)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.previewAnalyticalModel.headers; _ck(_v, 7, 0, currVal_0); var currVal_1 = _co.previewAnalyticalModel.rows; _ck(_v, 10, 0, currVal_1); var currVal_2 = (_co.previewAnalyticalModel.headers.length && _co.previewAnalyticalModel.rows.length); _ck(_v, 12, 0, currVal_2); }, null); }
function View_DataPreview_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_DataPreview_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataPreview_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataPreview_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DataPreview_7)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.previewAnalyticalModel && (_co.previewAnalyticalModel == "error")) && !_co.loader); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.previewAnalyticalModel && (_co.previewAnalyticalModel != "error")); _ck(_v, 5, 0, currVal_1); var currVal_2 = _co.loader; _ck(_v, 7, 0, currVal_2); }, null); }
function View_DataPreview_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "dataPreview", [], null, null, null, View_DataPreview_0, RenderType_DataPreview)), core["ɵdid"](1, 573440, null, 0, dataPreview_DataPreview, [], null, null)], null, null); }
var DataPreviewNgFactory = /*@__PURE__*/ core["ɵccf"]("dataPreview", dataPreview_DataPreview, View_DataPreview_Host_0, { previewAnalyticalModel: "previewAnalyticalModel", tntConfData: "tntConfData" }, { pageDetailsSender: "pageDetailsSender", loadPreviewSender: "loadPreviewSender" }, []);



// CONCATENATED MODULE: ./src/app/bi/admin/pocdesigner/pocWizard.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_designerCube.component.ngfactory,_designerCube.component,_services_mdmService.service,_.._.._toasterComponent_toasterComponent,_.._common_service_ngbDateConverter.utils,_angular_forms,_angular_common,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_timepicker_timepicker.ngfactory,_ng_bootstrap_ng_bootstrap_timepicker_timepicker,_ng_bootstrap_ng_bootstrap_timepicker_timepicker_config,_ng_bootstrap_ng_bootstrap_timepicker_ngb_time_adapter,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_dataMapper.ngfactory,_dataMapper,_ng_bootstrap_ng_bootstrap_tabset_tabset,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_controller_dimensionEdit.component.ngfactory,_controller_dimensionEdit.component,_controller_measureEdit.component.ngfactory,_controller_measureEdit.component,_angular_platform_browser,_.._common_service_ngbTimeConverter.utils,_dataPreview.ngfactory,_dataPreview,_.._.._.._.._node_modules__ng_bootstrap_ng_bootstrap_tabset_tabset.ngfactory,_ng_bootstrap_ng_bootstrap_tabset_tabset_config,_controller_loader.component.ngfactory,_controller_loader.component,angular2_multiselect_dropdown_clickOutside,_pocWizard.component PURE_IMPORTS_END */





































var styles_POCWizard = [];
var RenderType_POCWizard = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_POCWizard, data: {} });

function View_POCWizard_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "clear"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clearCache() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Clear All Cube Cache "]))], null, null);
}
function View_POCWizard_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "upload"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.createNew() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Create New "]))], null, null);
}
function View_POCWizard_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"], ["id", "nextMeasure "]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveAnalyticalModel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save Analytical Model "]))], null, null);
}
function View_POCWizard_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "button", [["class", "btn btn-primary float-right mr-3"], ["id", "cancelAll"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancelDesigner() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Cancel "]))], null, null);
}
function View_POCWizard_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "designerCube", [], null, [[null, "emitEdit"], [null, "emitCubeData"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("emitEdit" === en)) {
                var pd_0 = (_co.setMapperScreen($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("emitCubeData" === en)) {
                var pd_1 = (_co.setCubeForEdit($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DesignerCube_0, RenderType_DesignerCube)), core["ɵdid"](1, 638976, [[2, 4]], 0, designerCube_component_DesignerCube, [mdmService_service_MDMService, ToasterComponent, ngbDateConverter_utils_NgbDateConverter, core["ViewContainerRef"]], null, { emitEdit: "emitEdit", emitCubeData: "emitCubeData" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { _ck(_v, 1, 0); }, null);
}
function View_POCWizard_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "form-group w-100 float-left text-center mt-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Reupload"]))], null, null); }
function View_POCWizard_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0], [1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, ["", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.selectedDataSource && (_co.selectedDataSource.id == _v.context.$implicit.id)) ? true : null); var currVal_1 = _v.context.$implicit.id; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_POCWizard_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [["for", "dataSourceId"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Source"])), (_l()(), core["ɵeld"](3, 0, null, null, 6, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.selectDataSource($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](5, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](6, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_12)), core["ɵdid"](9, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "none"; _ck(_v, 5, 0, currVal_0); var currVal_1 = "none"; _ck(_v, 6, 0, currVal_1); var currVal_2 = _co.dataSourceList; _ck(_v, 9, 0, currVal_2); }, null);
}
function View_POCWizard_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, [[1, 0], ["fileHolder", 1]], null, 0, "input", [["class", "mt-4 ml-2"], ["multipart", "true"], ["name", "file"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.fileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, null);
}
function View_POCWizard_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "modal-footer border-top-0 p-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.uploadFile() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Upload "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.saveButton; _ck(_v, 1, 0, currVal_0); });
}
function View_POCWizard_15(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "modal-footer border-top-0 p-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.scanPresto(_co.selectedDataSource.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Scan "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.saveButton; _ck(_v, 1, 0, currVal_0); });
}
function View_POCWizard_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "modal-footer border-top-0 p-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.reSyncPresto() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Re-Scan"]))], null, null);
}
function View_POCWizard_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0], [1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, ["", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.selectedFact && (_co.selectedFact == _v.context.$implicit.refId)) ? true : null); var currVal_1 = _v.context.$implicit.refId; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.displayName; _ck(_v, 3, 0, currVal_2); }); }
function View_POCWizard_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "form-group w-30 w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Fact"])), (_l()(), core["ɵeld"](3, 0, null, null, 6, "select", [["class", "form-control light-bg p-1"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.selectFact($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](5, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](6, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_19)), core["ɵdid"](9, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "none"; _ck(_v, 5, 0, currVal_0); var currVal_1 = "none"; _ck(_v, 6, 0, currVal_1); var currVal_2 = _co.prestoData; _ck(_v, 9, 0, currVal_2); }, null);
}
function View_POCWizard_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "modal-footer border-top-0 p-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-primary"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.uploadPresto() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Next "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.saveButton; _ck(_v, 1, 0, currVal_0); });
}
function View_POCWizard_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 20, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 15, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "label", [["for", "dataSourceId"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Type"])), (_l()(), core["ɵeld"](4, 0, null, null, 12, "select", [["class", "form-control light-bg p-1"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.selectType($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 3, "option", [["value", "none"]], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](6, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](7, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None "])), (_l()(), core["ɵeld"](9, 0, null, null, 3, "option", [["value", "materialized"]], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](10, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](11, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Materialized "])), (_l()(), core["ɵeld"](13, 0, null, null, 3, "option", [["value", "starschema"]], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](14, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](15, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, [" Star Schema "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_18)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_20)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = "none"; _ck(_v, 6, 0, currVal_1); var currVal_2 = "none"; _ck(_v, 7, 0, currVal_2); var currVal_4 = "materialized"; _ck(_v, 10, 0, currVal_4); var currVal_5 = "materialized"; _ck(_v, 11, 0, currVal_5); var currVal_7 = "starschema"; _ck(_v, 14, 0, currVal_7); var currVal_8 = "starschema"; _ck(_v, 15, 0, currVal_8); var currVal_9 = (_co.isStarSchema != undefined); _ck(_v, 18, 0, currVal_9); var currVal_10 = (_co.isStarSchema != undefined); _ck(_v, 20, 0, currVal_10); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.isStarSchema == null) ? true : null); _ck(_v, 5, 0, currVal_0); var currVal_3 = ((_co.isStarSchema == false) ? true : null); _ck(_v, 9, 0, currVal_3); var currVal_6 = ((_co.isStarSchema == true) ? true : null); _ck(_v, 13, 0, currVal_6); });
}
function View_POCWizard_22(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [["for", "dropDown"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Source"])), (_l()(), core["ɵeld"](3, 0, null, null, 7, "input", [["class", "form-control"], ["id", "dataSource"], ["maxlength", "100"], ["placeholder", " Data Source Name"], ["readonly", ""], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.selectedDataSource.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 5, 0, currVal_8); var currVal_9 = _co.selectedDataSource.name; _ck(_v, 8, 0, currVal_9); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 5).maxlength ? core["ɵnov"](_v, 5).maxlength : null); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_POCWizard_23(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "label", [["for", "type"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Type"])), (_l()(), core["ɵeld"](4, 0, null, null, 7, "input", [["class", "form-control"], ["id", "prestotype"], ["maxlength", "100"], ["readonly", ""], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 5)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 5).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 5)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 5)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.selectedType = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](5, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](6, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](9, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](11, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "100"; _ck(_v, 6, 0, currVal_8); var currVal_9 = _co.selectedType; _ck(_v, 9, 0, currVal_9); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 6).maxlength ? core["ɵnov"](_v, 6).maxlength : null); var currVal_1 = core["ɵnov"](_v, 11).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 11).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 11).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 11).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 11).ngClassValid; var currVal_6 = core["ɵnov"](_v, 11).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 11).ngClassPending; _ck(_v, 4, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_POCWizard_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "ngb-timepicker", [], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.startDataVersionTime = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_1 = (_co.setStartDvTime($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbTimepicker_0, RenderType_NgbTimepicker)), core["ɵdid"](1, 573440, null, 0, timepicker_NgbTimepicker, [NgbTimepickerConfig, NgbTimeAdapter], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [timepicker_NgbTimepicker]), core["ɵdid"](3, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.startDataVersionTime; _ck(_v, 3, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 5).ngClassValid; var currVal_5 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_POCWizard_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "ngb-timepicker", [], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.dataVersionTime = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_1 = (_co.setDvTime($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbTimepicker_0, RenderType_NgbTimepicker)), core["ɵdid"](1, 573440, null, 0, timepicker_NgbTimepicker, [NgbTimepickerConfig, NgbTimeAdapter], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [timepicker_NgbTimepicker]), core["ɵdid"](3, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.dataVersionTime; _ck(_v, 3, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 5).ngClassValid; var currVal_5 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_POCWizard_25(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [["for", "cubeDataVersion"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["End Data Version"])), (_l()(), core["ɵeld"](3, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 11, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 16777216, null, null, 8, "input", [["class", "form-control light-bg"], ["name", "DataVersionDate"], ["ngbDatepicker", ""], ["placeholder", "YYYYMMDD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("input" === en)) {
                var pd_4 = (core["ɵnov"](_v, 8).manualDateChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("change" === en)) {
                var pd_5 = (core["ɵnov"](_v, 8).manualDateChange($event.target.value, true) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 8).onBlur() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.dataVersionDate = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](8, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], datepicker_input_NgbInputDatepicker]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_26)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 2, "div", [["class", "col-sx-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 1, "button", [["class", "iga-left form-control light-bg"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 8).toggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_8 = "DataVersionDate"; var currVal_9 = _co.dataVersionDate; _ck(_v, 11, 0, currVal_8, currVal_9); var currVal_10 = (_co.dataVersionDate && (_co.dataVersionDate.day != undefined)); _ck(_v, 15, 0, currVal_10); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 8).disabled; var currVal_1 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 13).ngClassValid; var currVal_6 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 5, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_POCWizard_21(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 96, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 54, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](8, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["placeholder", " Cube Name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.analyticalModel.cube.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](10, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](13, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](15, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](16, 0, null, null, 2, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_22)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 11, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](23, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "350"], ["name", "description"], ["placeholder", "Description (Optional)"], ["rows", "1"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 25)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 25).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 25)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 25)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.analyticalModel.cube.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](25, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](26, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 10, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 1, "label", [["for", "recordFormat"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Record Format"])), (_l()(), core["ɵeld"](36, 0, null, null, 7, "input", [["class", "form-control"], ["id", "dataSource"], ["maxlength", "100"], ["readonly", ""], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 37)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 37).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 37)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 37)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.analyticalModel.fact.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](37, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](38, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](41, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](43, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](44, 0, null, null, 9, "div", [["class", "col-lg-6 col-md-6 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 8, "div", [["class", "w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 1, "label", [["class", "mb-0 mr-3"], ["for", "enableCache"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Enable Cache"])), (_l()(), core["ɵeld"](48, 0, null, null, 5, "input", [["id", "enableCache"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 49).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 49).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.analyticalModel.cube.enableCache = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](49, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](51, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](53, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_23)), core["ɵdid"](55, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](56, 0, null, null, 40, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 16, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 1, "label", [["for", "cubeData"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Version Type"])), (_l()(), core["ɵeld"](60, 0, null, null, 13, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 61).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 61).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("change" === en)) {
                var pd_2 = (_co.setdataVersionType($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](61, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](63, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, null), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](65, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](66, 0, null, null, 3, "option", [["value", "Dynamic"]], null, null, null, null, null)), core["ɵdid"](67, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](68, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Dynamic"])), (_l()(), core["ɵeld"](70, 0, null, null, 3, "option", [["value", "Static"]], null, null, null, null, null)), core["ɵdid"](71, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](72, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Static"])), (_l()(), core["ɵeld"](74, 0, null, null, 20, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](75, 0, null, null, 1, "label", [["for", "cubeStartDate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Start Data Version"])), (_l()(), core["ɵeld"](77, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](78, 0, null, null, 11, "div", [["class", "col-sx-8 float-left left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](79, 16777216, null, null, 8, "input", [["class", "form-control light-bg"], ["name", "startDate"], ["ngbDatepicker", ""], ["placeholder", "YYYYMMDD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 80)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 80).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 80)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 80)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("input" === en)) {
                var pd_4 = (core["ɵnov"](_v, 82).manualDateChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("change" === en)) {
                var pd_5 = (core["ɵnov"](_v, 82).manualDateChange($event.target.value, true) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 82).onBlur() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.startDataVersion = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](80, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](82, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], datepicker_input_NgbInputDatepicker]), core["ɵdid"](85, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](87, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_24)), core["ɵdid"](89, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](90, 0, null, null, 2, "div", [["class", "col-sx-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](91, 0, null, null, 1, "button", [["class", "iga-left form-control light-bg"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 82).toggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](92, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](93, 0, null, null, 1, "button", [["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clearStartDate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](94, 0, null, null, 0, "i", [["class", "fa fa-times"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_25)), core["ɵdid"](96, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "200"; _ck(_v, 10, 0, currVal_8); var currVal_9 = "name"; var currVal_10 = _co.analyticalModel.cube.name; _ck(_v, 13, 0, currVal_9, currVal_10); var currVal_11 = _co.analyticalModel.cube.dataSourceData; _ck(_v, 18, 0, currVal_11); var currVal_20 = "350"; _ck(_v, 26, 0, currVal_20); var currVal_21 = "description"; var currVal_22 = _co.analyticalModel.cube.description; _ck(_v, 29, 0, currVal_21, currVal_22); var currVal_31 = "100"; _ck(_v, 38, 0, currVal_31); var currVal_32 = _co.analyticalModel.fact.name; _ck(_v, 41, 0, currVal_32); var currVal_40 = _co.analyticalModel.cube.enableCache; _ck(_v, 51, 0, currVal_40); var currVal_41 = (_co.isStarSchema != null); _ck(_v, 55, 0, currVal_41); var currVal_49 = _co.dataVersionType; _ck(_v, 63, 0, currVal_49); var currVal_50 = "Dynamic"; _ck(_v, 67, 0, currVal_50); var currVal_51 = "Dynamic"; _ck(_v, 68, 0, currVal_51); var currVal_52 = "Static"; _ck(_v, 71, 0, currVal_52); var currVal_53 = "Static"; _ck(_v, 72, 0, currVal_53); var currVal_62 = "startDate"; var currVal_63 = _co.startDataVersion; _ck(_v, 85, 0, currVal_62, currVal_63); var currVal_64 = (_co.startDataVersion && (_co.startDataVersion.day != undefined)); _ck(_v, 89, 0, currVal_64); var currVal_65 = (_co.dataVersionType == "Static"); _ck(_v, 96, 0, currVal_65); }, function (_ck, _v) { var currVal_0 = (core["ɵnov"](_v, 10).maxlength ? core["ɵnov"](_v, 10).maxlength : null); var currVal_1 = core["ɵnov"](_v, 15).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 15).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 15).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 15).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 15).ngClassValid; var currVal_6 = core["ɵnov"](_v, 15).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 15).ngClassPending; _ck(_v, 8, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_12 = (core["ɵnov"](_v, 26).maxlength ? core["ɵnov"](_v, 26).maxlength : null); var currVal_13 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 31).ngClassValid; var currVal_18 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 24, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_23 = (core["ɵnov"](_v, 38).maxlength ? core["ɵnov"](_v, 38).maxlength : null); var currVal_24 = core["ɵnov"](_v, 43).ngClassUntouched; var currVal_25 = core["ɵnov"](_v, 43).ngClassTouched; var currVal_26 = core["ɵnov"](_v, 43).ngClassPristine; var currVal_27 = core["ɵnov"](_v, 43).ngClassDirty; var currVal_28 = core["ɵnov"](_v, 43).ngClassValid; var currVal_29 = core["ɵnov"](_v, 43).ngClassInvalid; var currVal_30 = core["ɵnov"](_v, 43).ngClassPending; _ck(_v, 36, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30); var currVal_33 = core["ɵnov"](_v, 53).ngClassUntouched; var currVal_34 = core["ɵnov"](_v, 53).ngClassTouched; var currVal_35 = core["ɵnov"](_v, 53).ngClassPristine; var currVal_36 = core["ɵnov"](_v, 53).ngClassDirty; var currVal_37 = core["ɵnov"](_v, 53).ngClassValid; var currVal_38 = core["ɵnov"](_v, 53).ngClassInvalid; var currVal_39 = core["ɵnov"](_v, 53).ngClassPending; _ck(_v, 48, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39); var currVal_42 = core["ɵnov"](_v, 65).ngClassUntouched; var currVal_43 = core["ɵnov"](_v, 65).ngClassTouched; var currVal_44 = core["ɵnov"](_v, 65).ngClassPristine; var currVal_45 = core["ɵnov"](_v, 65).ngClassDirty; var currVal_46 = core["ɵnov"](_v, 65).ngClassValid; var currVal_47 = core["ɵnov"](_v, 65).ngClassInvalid; var currVal_48 = core["ɵnov"](_v, 65).ngClassPending; _ck(_v, 60, 0, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48); var currVal_54 = core["ɵnov"](_v, 82).disabled; var currVal_55 = core["ɵnov"](_v, 87).ngClassUntouched; var currVal_56 = core["ɵnov"](_v, 87).ngClassTouched; var currVal_57 = core["ɵnov"](_v, 87).ngClassPristine; var currVal_58 = core["ɵnov"](_v, 87).ngClassDirty; var currVal_59 = core["ɵnov"](_v, 87).ngClassValid; var currVal_60 = core["ɵnov"](_v, 87).ngClassInvalid; var currVal_61 = core["ɵnov"](_v, 87).ngClassPending; _ck(_v, 79, 0, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60, currVal_61); });
}
function View_POCWizard_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_10)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_11)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_13)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_14)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_15)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_16)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_17)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_21)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.isEdit && (_co.selectedDataSource.dataEngine.type == "DRILL")); _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.isEdit; _ck(_v, 4, 0, currVal_1); var currVal_2 = ((_co.selectedDataSource != undefined) && (_co.selectedDataSource.dataEngine.type == "DRILL")); _ck(_v, 6, 0, currVal_2); var currVal_3 = ((_co.selectedDataSource != undefined) && (_co.selectedDataSource.dataEngine.type == "DRILL")); _ck(_v, 8, 0, currVal_3); var currVal_4 = ((!_co.isEdit && (_co.selectedDataSource != undefined)) && ((_co.selectedDataSource.dataEngine.type == "PRESTO") || (_co.selectedDataSource.dataEngine.type == "CLICK_HOUSE"))); _ck(_v, 10, 0, currVal_4); var currVal_5 = ((_co.isEdit && (_co.selectedDataSource != undefined)) && ((_co.selectedDataSource.dataEngine.type == "PRESTO") || (_co.selectedDataSource.dataEngine.type == "CLICK_HOUSE"))); _ck(_v, 12, 0, currVal_5); var currVal_6 = ((!_co.isEdit && (_co.prestoData != undefined)) && ((_co.selectedDataSource.dataEngine.type == "PRESTO") || (_co.selectedDataSource.dataEngine.type == "CLICK_HOUSE"))); _ck(_v, 14, 0, currVal_6); var currVal_7 = _co.editScreen; _ck(_v, 16, 0, currVal_7); }, null); }
function View_POCWizard_29(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" No Data to setup"]))], null, null); }
function View_POCWizard_31(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "dataMapper", [], null, [[null, "measureListSender"], [null, "dimensionListSender"], [null, "dimValidationSender"], [null, "formulaMeasureEmitter"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("measureListSender" === en)) {
                var pd_0 = (_co.setMeasureList($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("dimensionListSender" === en)) {
                var pd_1 = (_co.setDimensionList($event) !== false);
                ad = (pd_1 && ad);
            }
            if (("dimValidationSender" === en)) {
                var pd_2 = (_co.prestoDimValidation($event) !== false);
                ad = (pd_2 && ad);
            }
            if (("formulaMeasureEmitter" === en)) {
                var pd_3 = (_co.setFormulaList($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, View_DataMapper_0, RenderType_DataMapper)), core["ɵdid"](1, 573440, null, 0, dataMapper_DataMapper, [mdmService_service_MDMService], { analyticalModelData: [0, "analyticalModelData"], isStarSchema: [1, "isStarSchema"], dimensionList: [2, "dimensionList"] }, { dimValidationSender: "dimValidationSender", measureListSender: "measureListSender", dimensionListSender: "dimensionListSender", formulaMeasureEmitter: "formulaMeasureEmitter" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.analyticalModel; var currVal_1 = _co.isStarSchema; var currVal_2 = _co.dimensionList; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2); }, null);
}
function View_POCWizard_30(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", " fields found, "])), (_l()(), core["ɵted"](3, null, [" Measures - ", ", Dimensions - ", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_31)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_3 = !!_co.analyticalModel; _ck(_v, 5, 0, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.analyticalModel.fact.recordFormatFieldData.length; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.analyticalModel.cube.cubeMeasureData.length; var currVal_2 = _co.analyticalModel.cube.cubeDimensionUsageData.length; _ck(_v, 3, 0, currVal_1, currVal_2); }); }
function View_POCWizard_28(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_29)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_30)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.analyticalModel == undefined); _ck(_v, 1, 0, currVal_0); var currVal_1 = ((_co.analyticalModel != undefined) && _co.analyticalModel.fact); _ck(_v, 3, 0, currVal_1); }, null); }
function View_POCWizard_27(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "ngb-tab", [["id", "mapper"], ["title", "Step 2: Setup Columns"]], null, null, null, null, null)), core["ɵdid"](1, 2113536, [[3, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 6, { titleTpls: 1 }), core["ɵqud"](603979776, 7, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_POCWizard_28)), core["ɵdid"](5, 16384, [[7, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null)], function (_ck, _v) { var currVal_0 = "mapper"; var currVal_1 = "Step 2: Setup Columns"; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
function View_POCWizard_35(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h4", [], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Dimensions to setup"]))], null, null); }
function View_POCWizard_38(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = "Actions"; _ck(_v, 1, 0, currVal_0); }, null); }
function View_POCWizard_37(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["Number of Dimensions - ", ""])), (_l()(), core["ɵeld"](3, 0, null, null, 14, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](5, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](8, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](9, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](12, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](13, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_38)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = "Code"; _ck(_v, 5, 0, currVal_1); var currVal_2 = "Name"; _ck(_v, 9, 0, currVal_2); var currVal_3 = "Description"; _ck(_v, 13, 0, currVal_3); var currVal_4 = (_co.isStarSchema != true); _ck(_v, 17, 0, currVal_4); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.analyticalModel.cube.cubeDimensionUsageData.length; _ck(_v, 2, 0, currVal_0); }); }
function View_POCWizard_41(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editDimension(_v.parent.parent.context.$implicit.dimensionData) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "]))], null, null);
}
function View_POCWizard_40(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOpsDimension($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_41)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = (_co.selectedDim == _v.parent.context.$implicit.dimensionData.refId); _ck(_v, 4, 0, currVal_1); }, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.dimensionData.refId; _ck(_v, 0, 0, currVal_0); });
}
function View_POCWizard_39(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 0, "h6", [["class", "mb-lg-0 text-truncate"]], [[8, "innerHTML", 1]], null, null, null, null)), (_l()(), core["ɵeld"](8, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](9, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_40)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dimensionData.dimCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dimensionData.name, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.dimensionData.description, ""); _ck(_v, 9, 0, currVal_4); var currVal_6 = (_co.isStarSchema != true); _ck(_v, 13, 0, currVal_6); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.dimensionData.dimCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = (!!_v.context.$implicit.dimensionData.displayName ? _v.context.$implicit.dimensionData.displayName : _v.context.$implicit.dimensionData.name); _ck(_v, 7, 0, currVal_3); var currVal_5 = _v.context.$implicit.dimensionData.description; _ck(_v, 11, 0, currVal_5); }); }
function View_POCWizard_36(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_37)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_39)), core["ɵdid"](4, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.analyticalModel && _co.analyticalModel.cube.cubeDimensionUsageData) && _co.analyticalModel.cube.cubeDimensionUsageData.length); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.analyticalModel.cube.cubeDimensionUsageData; _ck(_v, 4, 0, currVal_1); }, null); }
function View_POCWizard_34(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_35)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_36)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.analyticalModel && (_co.analyticalModel.cube.cubeDimensionUsageData.length == 0)); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.analyticalModel; _ck(_v, 4, 0, currVal_1); }, null); }
function View_POCWizard_42(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "dimensionEditor", [], null, [[null, "triggerSave"], [null, "triggerBack"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("triggerSave" === en)) {
                var pd_0 = (_co.afterEditDim($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("triggerBack" === en)) {
                var pd_1 = (_co.onBackFromDimEdit() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DimensionEditComponent_0, RenderType_DimensionEditComponent)), core["ɵdid"](2, 573440, null, 0, dimensionEdit_component_DimensionEditComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"]], { parent: [0, "parent"], dimensionData: [1, "dimensionData"], recordFormat: [2, "recordFormat"], isEdit: [3, "isEdit"] }, { triggerSave: "triggerSave", triggerBack: "triggerBack" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = "wizard"; var currVal_1 = _co.dimensionData; var currVal_2 = _co.analyticalModel.fact; var currVal_3 = _co.isEdit; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3); }, null);
}
function View_POCWizard_33(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_34)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_42)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.editDimensionPage; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.editDimensionPage; _ck(_v, 3, 0, currVal_1); }, null); }
function View_POCWizard_32(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "ngb-tab", [["id", "dimEdit"], ["title", "Step 3: Setup Dimension"]], null, null, null, null, null)), core["ɵdid"](1, 2113536, [[3, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 8, { titleTpls: 1 }), core["ɵqud"](603979776, 9, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_POCWizard_33)), core["ɵdid"](5, 16384, [[9, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null)], function (_ck, _v) { var currVal_0 = "dimEdit"; var currVal_1 = "Step 3: Setup Dimension"; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
function View_POCWizard_46(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h4", [], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["No Measures to setup"]))], null, null); }
function View_POCWizard_48(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["Number of Measures - ", ""])), (_l()(), core["ɵeld"](3, 0, null, null, 1, "button", [["class", "btn btn-primary float-right"], ["id", "addFormulaMeasure"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addFormulaMeasure() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add Formula Measure "])), (_l()(), core["ɵeld"](5, 0, null, null, 20, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Code"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Code "])), (_l()(), core["ɵeld"](10, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Name"]], null, null, null, null, null)), core["ɵdid"](11, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Name "])), (_l()(), core["ɵeld"](14, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Description"]], null, null, null, null, null)), core["ɵdid"](15, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Description "])), (_l()(), core["ɵeld"](18, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"], ["ngbTooltip", "Data Version"]], null, null, null, null, null)), core["ɵdid"](19, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Data Version "])), (_l()(), core["ɵeld"](22, 16777216, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"], ["ngbTooltip", "Actions"]], null, null, null, null, null)), core["ɵdid"](23, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Actions "]))], function (_ck, _v) { var currVal_1 = "Code"; _ck(_v, 7, 0, currVal_1); var currVal_2 = "Name"; _ck(_v, 11, 0, currVal_2); var currVal_3 = "Description"; _ck(_v, 15, 0, currVal_3); var currVal_4 = "Data Version"; _ck(_v, 19, 0, currVal_4); var currVal_5 = "Actions"; _ck(_v, 23, 0, currVal_5); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.analyticalModel.cube.cubeMeasureData.length; _ck(_v, 2, 0, currVal_0); });
}
function View_POCWizard_51(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeMeasure(_v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Delete "]))], null, null);
}
function View_POCWizard_50(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "empActions m-t-nsmd"], ["style", "top:29px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 5, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editMeasure(_v.parent.context.$implicit.measureData) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_51)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.isFormulaMeasure; _ck(_v, 7, 0, currVal_0); }, null);
}
function View_POCWizard_49(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 23, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](2, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](6, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 16777216, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](10, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 16777216, null, null, 5, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵppd"](15, 2), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵppd"](18, 2), (_l()(), core["ɵeld"](19, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], [[8, "id", 0]], [[null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mouseenter" === en)) {
                var pd_0 = (_co.entityOpsMeasure($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_1 = (_co.closeDropDown($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-lg-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_50)), core["ɵdid"](23, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.measureData.measureCode, ""); _ck(_v, 2, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.measureData.measureDisplayName, ""); _ck(_v, 6, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.measureData.description, ""); _ck(_v, 10, 0, currVal_4); var currVal_6 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 14, 0, _ck(_v, 15, 0, core["ɵnov"](_v.parent.parent.parent.parent.parent.parent.parent.parent, 0), _v.context.$implicit.measureData.dataVersion, _co.mediumDate)), ""); _ck(_v, 14, 0, currVal_6); var currVal_9 = (_co.selectedMeasureId == _v.context.$implicit.measureData.refId); _ck(_v, 23, 0, currVal_9); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _v.context.$implicit.measureData.measureCode; _ck(_v, 4, 0, currVal_1); var currVal_3 = _v.context.$implicit.measureData.measureDisplayName; _ck(_v, 8, 0, currVal_3); var currVal_5 = _v.context.$implicit.measureData.description; _ck(_v, 12, 0, currVal_5); var currVal_7 = core["ɵunv"](_v, 17, 0, _ck(_v, 18, 0, core["ɵnov"](_v.parent.parent.parent.parent.parent.parent.parent.parent, 0), _v.context.$implicit.measureData.dataVersion, _co.mediumDate)); _ck(_v, 17, 0, currVal_7); var currVal_8 = _v.context.$implicit.measureData.refId; _ck(_v, 19, 0, currVal_8); });
}
function View_POCWizard_47(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_48)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_49)), core["ɵdid"](4, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.analyticalModel && _co.analyticalModel.cube.cubeMeasureData) && _co.analyticalModel.cube.cubeMeasureData.length); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.analyticalModel.cube.cubeMeasureData; _ck(_v, 4, 0, currVal_1); }, null); }
function View_POCWizard_45(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_46)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_47)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.analyticalModel && (_co.analyticalModel.cube.cubeMeasureData.length == 0)); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.analyticalModel; _ck(_v, 4, 0, currVal_1); }, null); }
function View_POCWizard_52(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "measureEditor", [], null, [[null, "triggerSave"], [null, "triggerBack"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("triggerSave" === en)) {
                var pd_0 = (_co.afterEditMeasure($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("triggerBack" === en)) {
                var pd_1 = (_co.onBackFromMeasureEdit() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_MeasureEditComponent_0, RenderType_MeasureEditComponent)), core["ɵdid"](2, 573440, null, 0, measureEdit_component_MeasureEditComponent, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"], platform_browser["c" /* DomSanitizer */], ngbDateConverter_utils_NgbDateConverter, ngbTimeConverter_utils_NgbTimeConverter], { parent: [0, "parent"], measureData: [1, "measureData"], isEdit: [2, "isEdit"], inEdit: [3, "inEdit"], isStarSchema: [4, "isStarSchema"], targetMeasureList: [5, "targetMeasureList"], targetDimensionList: [6, "targetDimensionList"], formulaMeasure: [7, "formulaMeasure"] }, { triggerSave: "triggerSave", triggerBack: "triggerBack" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = "wizard"; var currVal_1 = _co.measureData; var currVal_2 = _co.isEdit; var currVal_3 = _co.inMesEdit; var currVal_4 = _co.isStarSchema; var currVal_5 = _co.analyticalModel.cube.cubeMeasureData; var currVal_6 = _co.analyticalModel.cube.cubeDimensionUsageData; var currVal_7 = _co.isFormulaMeasure; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); }, null);
}
function View_POCWizard_44(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_45)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_52)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.editMeasurePage; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.editMeasurePage; _ck(_v, 3, 0, currVal_1); }, null); }
function View_POCWizard_43(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "ngb-tab", [["id", "measureEdit"], ["title", "Step 4: Setup Measure"]], null, null, null, null, null)), core["ɵdid"](1, 2113536, [[3, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 10, { titleTpls: 1 }), core["ɵqud"](603979776, 11, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_POCWizard_44)), core["ɵdid"](5, 16384, [[11, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null)], function (_ck, _v) { var currVal_0 = "measureEdit"; var currVal_1 = "Step 4: Setup Measure"; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
function View_POCWizard_54(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "dataPreview", [], null, [[null, "pageDetailsSender"], [null, "loadPreviewSender"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageDetailsSender" === en)) {
                var pd_0 = (_co.getPreviewPageDetails($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("loadPreviewSender" === en)) {
                var pd_1 = (_co.loadPreview($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_DataPreview_0, RenderType_DataPreview)), core["ɵdid"](2, 573440, null, 0, dataPreview_DataPreview, [], { previewAnalyticalModel: [0, "previewAnalyticalModel"], tntConfData: [1, "tntConfData"] }, { pageDetailsSender: "pageDetailsSender", loadPreviewSender: "loadPreviewSender" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.previewAnalyticalModel; var currVal_1 = _co.tntConfData; _ck(_v, 2, 0, currVal_0, currVal_1); }, null);
}
function View_POCWizard_53(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "ngb-tab", [["id", "preview"], ["title", "Step 5: Preview"]], null, null, null, null, null)), core["ɵdid"](1, 2113536, [[3, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 12, { titleTpls: 1 }), core["ɵqud"](603979776, 13, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_POCWizard_54)), core["ɵdid"](5, 16384, [[13, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null)], function (_ck, _v) { var currVal_0 = "preview"; var currVal_1 = "Step 5: Preview"; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
function View_POCWizard_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 17, "div", [["class", "feedback-pills"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 16, "ngb-tabset", [["type", "pills"]], null, [[null, "tabChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("tabChange" === en)) {
                var pd_0 = (_co.beforeChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NgbTabset_0, RenderType_NgbTabset)), core["ɵdid"](3, 2146304, null, 1, tabset_NgbTabset, [NgbTabsetConfig], { activeId: [0, "activeId"], type: [1, "type"] }, { tabChange: "tabChange" }), core["ɵqud"](603979776, 3, { tabs: 1 }), (_l()(), core["ɵeld"](5, 0, null, null, 5, "ngb-tab", [["id", "upload"], ["title", "Step 1: Setup"]], null, null, null, null, null)), core["ɵdid"](6, 2113536, [[3, 4]], 2, NgbTab, [], { id: [0, "id"], title: [1, "title"] }, null), core["ɵqud"](603979776, 4, { titleTpls: 1 }), core["ɵqud"](603979776, 5, { contentTpls: 1 }), (_l()(), core["ɵand"](0, null, null, 1, null, View_POCWizard_9)), core["ɵdid"](10, 16384, [[5, 4]], 0, NgbTabContent, [core["TemplateRef"]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_27)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_32)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_43)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_53)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _co.activeScreen, ""); var currVal_1 = "pills"; _ck(_v, 3, 0, currVal_0, currVal_1); var currVal_2 = "upload"; var currVal_3 = "Step 1: Setup"; _ck(_v, 6, 0, currVal_2, currVal_3); var currVal_4 = (_co.analyticalModel != undefined); _ck(_v, 12, 0, currVal_4); var currVal_5 = (_co.analyticalModel != undefined); _ck(_v, 14, 0, currVal_5); var currVal_6 = (_co.analyticalModel != undefined); _ck(_v, 16, 0, currVal_6); var currVal_7 = (_co.analyticalModel != undefined); _ck(_v, 18, 0, currVal_7); }, null);
}
function View_POCWizard_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 11, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["ANALYTICAL MODELLER"])), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_3)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_4)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_5)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_6)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_7)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_8)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.cubeScreen && !_co.editScreen); _ck(_v, 7, 0, currVal_0); var currVal_1 = (_co.cubeScreen && !_co.editScreen); _ck(_v, 9, 0, currVal_1); var currVal_2 = !!_co.analyticalModel; _ck(_v, 11, 0, currVal_2); var currVal_3 = (!_co.cubeScreen || _co.editScreen); _ck(_v, 13, 0, currVal_3); var currVal_4 = _co.cubeScreen; _ck(_v, 15, 0, currVal_4); var currVal_5 = (!_co.cubeScreen || _co.editScreen); _ck(_v, 17, 0, currVal_5); }, null); }
function View_POCWizard_55(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "loader", [], null, null, null, View_Loader_0, RenderType_Loader)), core["ɵdid"](2, 49152, null, 0, Loader, [], null, null)], null, null); }
function View_POCWizard_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, null, null, null, null, function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("scroll" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("scroll" === en)) {
                var pd_1 = (_co.windowPosition() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, clickOutside_ScrollDirective, [core["ElementRef"]], null, { scroll: "scroll" }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_55)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.loader; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.loader; _ck(_v, 5, 0, currVal_1); }, null);
}
function View_POCWizard_0(_l) { return core["ɵvid"](0, [core["ɵpid"](0, common["DatePipe"], [core["LOCALE_ID"]]), core["ɵqud"](671088640, 1, { fileDiv: 0 }), core["ɵqud"](671088640, 2, { childComponent: 0 }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_POCWizard_1)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.accessDenied; _ck(_v, 4, 0, currVal_0); }, null); }
function View_POCWizard_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "pocWizard", [], null, null, null, View_POCWizard_0, RenderType_POCWizard)), core["ɵdid"](1, 245760, null, 0, pocWizard_component_POCWizard, [mdmService_service_MDMService, ToasterComponent, core["ViewContainerRef"], ngbDateConverter_utils_NgbDateConverter, ngbTimeConverter_utils_NgbTimeConverter, platform_browser["c" /* DomSanitizer */]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var POCWizardNgFactory = /*@__PURE__*/ core["ɵccf"]("pocWizard", pocWizard_component_POCWizard, View_POCWizard_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/shared/permissions/permissions.ts


var PermissionHelper = /*@__PURE__*/ (function () {
    function PermissionHelper() {
        this.permission = [];
    }
    PermissionHelper.prototype.savePermission = function (permissions) {
        this.permission = permissions;
    };
    PermissionHelper.prototype.getPermission = function () {
        return this.permission;
    };
    PermissionHelper.prototype.checkForPermission = function (permission) {
        if (this.permission.length > 0) {
            for (var i = 0; i < this.permission.length; i++) {
                if (this.permission[i] === permission) {
                    return true;
                }
            }
        }
    };
    return PermissionHelper;
}());



// CONCATENATED MODULE: ./src/app/menu/menu.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_router,_angular_common,_menu,_shared_permissions_permissions PURE_IMPORTS_END */






var styles_MenuComponent = [];
var RenderType_MenuComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_MenuComponent, data: {} });

function View_MenuComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "menu-headers"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("manageUsers")); _ck(_v, 1, 0, currVal_0); }); }
function View_MenuComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[2, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 1, { links: 1 }), core["ɵqud"](603979776, 2, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "employeesList"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("users")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[4, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 3, { links: 1 }), core["ɵqud"](603979776, 4, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "organizationList"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("orgUnit")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[6, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 5, { links: 1 }), core["ɵqud"](603979776, 6, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "organizationUnitType"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("orgUnitType")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[8, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 7, { links: 1 }), core["ɵqud"](603979776, 8, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "designationList"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("designation")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[10, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 9, { links: 1 }), core["ɵqud"](603979776, 10, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "mgrLevelList"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("empType")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[12, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 11, { links: 1 }), core["ɵqud"](603979776, 12, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "empTypeList"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("jobCat")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[14, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 13, { links: 1 }), core["ɵqud"](603979776, 14, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "gradeList"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("jobGrade")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[16, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 15, { links: 1 }), core["ɵqud"](603979776, 16, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "manageOperations"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("manageOperations")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[18, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 17, { links: 1 }), core["ɵqud"](603979776, 18, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "rolesAndPermission"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("rolesAndPermission")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[20, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 19, { links: 1 }), core["ɵqud"](603979776, 20, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "cob"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("customerOnBoarding")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[22, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 21, { links: 1 }), core["ɵqud"](603979776, 22, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "bulkResignUpload"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("bulkResign")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[24, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 23, { links: 1 }), core["ɵqud"](603979776, 24, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "notifications"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("notificationEditor")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "menu-headers"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("progManagement")); _ck(_v, 1, 0, currVal_0); }); }
function View_MenuComponent_15(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[26, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 25, { links: 1 }), core["ɵqud"](603979776, 26, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "announcementProgram"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("announce")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[28, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 27, { links: 1 }), core["ɵqud"](603979776, 28, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "emailNotification"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("emailNotification")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "menu-headers"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("TOOLS")); _ck(_v, 1, 0, currVal_0); }); }
function View_MenuComponent_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[30, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 29, { links: 1 }), core["ɵqud"](603979776, 30, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "tenantPreference"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("tenantPreference")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_19(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[32, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 31, { links: 1 }), core["ɵqud"](603979776, 32, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "userGroup"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("userGroup")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[34, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 33, { links: 1 }), core["ɵqud"](603979776, 34, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "passwordPolicy"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("passwordPolicy")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_21(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "menu-headers"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("superAdmin")); _ck(_v, 1, 0, currVal_0); }); }
function View_MenuComponent_22(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[36, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 35, { links: 1 }), core["ɵqud"](603979776, 36, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "tenantManagement"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("tenant")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_23(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[38, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 37, { links: 1 }), core["ɵqud"](603979776, 38, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "mobileAppManagement"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("mobileAppManagement")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "h6", [["class", "cus-menus"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "a", [], [[1, "target", 0], [8, "href", 4]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 671744, [[40, 4]], 0, fesm5_router["n" /* RouterLinkWithHref */], [fesm5_router["l" /* Router */], fesm5_router["a" /* ActivatedRoute */], common["LocationStrategy"]], { routerLink: [0, "routerLink"] }, null), core["ɵpad"](3, 1), core["ɵdid"](4, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 39, { links: 1 }), core["ɵqud"](603979776, 40, { linksWithHrefs: 1 }), core["ɵpad"](7, 2), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = _ck(_v, 3, 0, "buildDetails"); _ck(_v, 2, 0, currVal_2); var currVal_3 = _ck(_v, 7, 0, "lt-black", "medium"); _ck(_v, 4, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 2).target; var currVal_1 = core["ɵnov"](_v, 2).href; _ck(_v, 1, 0, currVal_0, currVal_1); var currVal_4 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("buildDetails")); _ck(_v, 8, 0, currVal_4); });
}
function View_MenuComponent_25(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_MenuComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 48, "div", [["class", "col-lg-2 col-md-3 col-sm-12 col-xs-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_2)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_3)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_4)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_5)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_6)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_7)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_8)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_9)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_10)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_11)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_12)), core["ɵdid"](24, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_13)), core["ɵdid"](26, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_14)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_15)), core["ɵdid"](30, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_16)), core["ɵdid"](32, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_17)), core["ɵdid"](34, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_18)), core["ɵdid"](36, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_19)), core["ɵdid"](38, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_20)), core["ɵdid"](40, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_21)), core["ɵdid"](42, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_22)), core["ɵdid"](44, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_23)), core["ɵdid"](46, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_24)), core["ɵdid"](48, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](49, 0, null, null, 4, "div", [["class", "col-lg-10 col-md-9 col-sm-12 col-xs-12 float-left b-l"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), core["ɵdid"](51, 212992, null, 0, fesm5_router["p" /* RouterOutlet */], [fesm5_router["b" /* ChildrenOutletContexts */], core["ViewContainerRef"], core["ComponentFactoryResolver"], [8, null], core["ChangeDetectorRef"]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MenuComponent_25)), core["ɵdid"](53, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co._per.checkForPermission("USER_MANAGEMENT"); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co._per.checkForPermission("EMPLOYEE_ADMIN"); _ck(_v, 4, 0, currVal_1); var currVal_2 = _co._per.checkForPermission("ORG_ADMIN"); _ck(_v, 6, 0, currVal_2); var currVal_3 = _co._per.checkForPermission("ORG_TYPE_ADMIN"); _ck(_v, 8, 0, currVal_3); var currVal_4 = _co._per.checkForPermission("DESIGNATION_ADMIN"); _ck(_v, 10, 0, currVal_4); var currVal_5 = _co._per.checkForPermission("MANAGERLEVEL_ADMIN"); _ck(_v, 12, 0, currVal_5); var currVal_6 = _co._per.checkForPermission("CATEGORY_ADMIN"); _ck(_v, 14, 0, currVal_6); var currVal_7 = _co._per.checkForPermission("GRADE_ADMIN"); _ck(_v, 16, 0, currVal_7); var currVal_8 = _co._per.checkForPermission("OPERATION_DETAILS_ADMIN"); _ck(_v, 18, 0, currVal_8); var currVal_9 = _co._per.checkForPermission("ROLE_ADMIN"); _ck(_v, 20, 0, currVal_9); var currVal_10 = _co._per.checkForPermission("COB_ADMIN"); _ck(_v, 22, 0, currVal_10); var currVal_11 = _co._per.checkForPermission("EMP_BULK_EMPLOYEE_RESIGN"); _ck(_v, 24, 0, currVal_11); var currVal_12 = _co._per.checkForPermission("NOTIFICATION_EDITOR"); _ck(_v, 26, 0, currVal_12); var currVal_13 = _co._per.checkForPermission("PROGRAM_MANAGEMENT"); _ck(_v, 28, 0, currVal_13); var currVal_14 = _co._per.checkForPermission("ANNOUNCEMENT_ADMIN"); _ck(_v, 30, 0, currVal_14); var currVal_15 = _co._per.checkForPermission("EMAIL_NOTIFICATION"); _ck(_v, 32, 0, currVal_15); var currVal_16 = _co._per.checkForPermission("TOOLS"); _ck(_v, 34, 0, currVal_16); var currVal_17 = _co._per.checkForPermission("TENANT_CONFIG"); _ck(_v, 36, 0, currVal_17); var currVal_18 = _co._per.checkForPermission("USER_GROUP"); _ck(_v, 38, 0, currVal_18); var currVal_19 = _co._per.checkForPermission("PASSWORD_POLICY"); _ck(_v, 40, 0, currVal_19); var currVal_20 = _co._per.checkForPermission("SUPER_ADMIN"); _ck(_v, 42, 0, currVal_20); var currVal_21 = _co._per.checkForPermission("TENANT_MANAGEMENT"); _ck(_v, 44, 0, currVal_21); var currVal_22 = _co._per.checkForPermission("MOBILE_APP_MANAGEMENT"); _ck(_v, 46, 0, currVal_22); var currVal_23 = _co._per.checkForPermission("SUPER_ADMIN"); _ck(_v, 48, 0, currVal_23); _ck(_v, 51, 0); var currVal_24 = _co.loaderEnable; _ck(_v, 53, 0, currVal_24); }, null); }
function View_MenuComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "menu", [], null, null, null, View_MenuComponent_0, RenderType_MenuComponent)), core["ɵdid"](1, 114688, null, 0, menu_MenuComponent, [fesm5_router["l" /* Router */], PermissionHelper, core_es5["j" /* TranslateService */]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MenuComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("menu", menu_MenuComponent, View_MenuComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/directives/copy-to-clipboard-directive.ts

var copy_to_clipboard_directive_CopyClipboardDirective = /*@__PURE__*/ (function () {
    function CopyClipboardDirective() {
        this.copied = new core["EventEmitter"]();
    }
    CopyClipboardDirective.prototype.onClick = function (event) {
        var _this = this;
        event.preventDefault();
        if (!this.payload)
            return;
        var listener = function (e) {
            var clipboard = e.clipboardData || window["clipboardData"];
            clipboard.setData("text", _this.payload.toString());
            e.preventDefault();
            _this.copied.emit(_this.payload);
        };
        document.addEventListener("copy", listener, false);
        document.execCommand("copy");
        document.removeEventListener("copy", listener, false);
    };
    return CopyClipboardDirective;
}());



// CONCATENATED MODULE: ./src/app/employee/statusPipe.ts

var statusPipe_EmployeeStatus = /*@__PURE__*/ (function () {
    function EmployeeStatus() {
        this.empStatusDetails = [{
                status: 1,
                value: "ACTIVE"
            },
            {
                status: 2,
                value: "SUSPEND"
            },
            {
                status: 3,
                value: "RESIGN"
            },
            {
                status: 4,
                value: "INACTIVE"
            }
        ];
    }
    EmployeeStatus.prototype.transform = function (value) {
        var self = this;
        underscore["each"](this.empStatusDetails, function (element) {
            if (value == element.status) {
                self.assignValue = element.value;
            }
        });
        return self.assignValue;
    };
    return EmployeeStatus;
}());



// CONCATENATED MODULE: ./src/app/employee/employeeList.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_directives_copy_to_clipboard_directive,_ngx_translate_core,_angular_common,_angular_forms,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_statusPipe,_employeeFilter.ngfactory,_employeeFilter,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_angular_platform_browser,_toasterComponent_toasterComponent,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_employeeList,_ng_bootstrap_ng_bootstrap_modal_modal_ref PURE_IMPORTS_END */





























var styles_EmployeesListingPage = [];
var RenderType_EmployeesListingPage = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmployeesListingPage, data: {} });

function View_EmployeesListingPage_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "img", [["class", "w-16 mr-2"]], [[8, "src", 4]], null, null, null, null))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.imageUrl; _ck(_v, 0, 0, currVal_0); }); }
function View_EmployeesListingPage_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "img", [["class", "w-16 mr-2"], ["src", "assets/img/profilePic.png"]], null, null, null, null, null))], null, null); }
function View_EmployeesListingPage_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "h6", [["class", "mb-lg-0 text-truncate"]], null, [[null, "copied"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("copied" === en)) {
                var pd_1 = (_co.notify($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵdid"](2, 16384, null, 0, copy_to_clipboard_directive_CopyClipboardDirective, [], { payload: [0, "payload"] }, { copied: "copied" }), (_l()(), core["ɵted"](3, null, [" ", " (", ") "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.context.$implicit.orgName, ""); _ck(_v, 1, 0, currVal_0); var currVal_1 = (((_v.parent.context.$implicit.orgName + "(") + _v.parent.context.$implicit.orgCode) + ")"); _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.parent.context.$implicit.orgName; var currVal_3 = _v.parent.context.$implicit.orgCode; _ck(_v, 3, 0, currVal_2, currVal_3); });
}
function View_EmployeesListingPage_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeesListingPage_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "h6", [["class", "mb-lg-0 text-truncate"]], null, [[null, "copied"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("copied" === en)) {
                var pd_1 = (_co.notify($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵdid"](2, 16384, null, 0, copy_to_clipboard_directive_CopyClipboardDirective, [], { payload: [0, "payload"] }, { copied: "copied" }), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.context.$implicit.designationName, ""); _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.parent.context.$implicit.designationName; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.parent.context.$implicit.designationName; _ck(_v, 3, 0, currVal_2); });
}
function View_EmployeesListingPage_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeesListingPage_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 3, "h6", [["class", "mb-lg-0 text-truncate"]], null, [[null, "copied"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("copied" === en)) {
                var pd_1 = (_co.notify($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵdid"](2, 16384, null, 0, copy_to_clipboard_directive_CopyClipboardDirective, [], { payload: [0, "payload"] }, { copied: "copied" }), (_l()(), core["ɵted"](3, null, [" ", "(", ")"])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](2, "", _v.parent.context.$implicit.supervisorName, "(", _v.parent.context.$implicit.supervisorUserName, ")"); _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.parent.context.$implicit.supervisorUserName; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.parent.context.$implicit.supervisorName; var currVal_3 = _v.parent.context.$implicit.supervisorUserName; _ck(_v, 3, 0, currVal_2, currVal_3); });
}
function View_EmployeesListingPage_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeesListingPage_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editEmployeeProfile(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("edit")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.openEditModal(core["ɵnov"](_v.parent.parent.parent.parent, 89), _v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("editProfile")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.reloadEmployee(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-refresh mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("reloadEmployee")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_15(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.openChangeIdModal(core["ɵnov"](_v.parent.parent.parent.parent, 88), _v.parent.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-id-badge mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("changeId")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.resolveCertErrors(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("resolveCertErrors")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.openRoleModal(core["ɵnov"](_v.parent.parent.parent.parent, 87), _v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-user mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Change Role "]))], null, null);
}
function View_EmployeesListingPage_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeLabTest(_v.parent.parent.context.$implicit.licenceNumber) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-address-card mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Remove LabTest "]))], null, null);
}
function View_EmployeesListingPage_19(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeHSOBadge(_v.parent.parent.context.$implicit.userName) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-unlock mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Remove HSO badge "]))], null, null);
}
function View_EmployeesListingPage_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableResetPwd(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-key mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("resetPassword")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_21(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.actionSuspend(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-power-off mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("suspend")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_22(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.actionResign(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-sign-out mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("resign")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_23(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.actionRemoveEmployee(_v.parent.parent.context.$implicit.userName) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-times mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("delete")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.resetToDay0(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-repeat mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("resetToDay0")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_25(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addLocationAssessment(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-repeat mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("addLocationAssessment")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.convertToLowRisk(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-repeat mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("convertToLowRisk")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_27(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.convertToConfirmedCase(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-repeat mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("convertToConfirmedCase")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_28(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.revertICVerification(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-repeat mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("revertICVerification")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_29(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.revertNonVaccineAccount(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-repeat mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Revert Non Vaccine account "]))], null, null);
}
function View_EmployeesListingPage_30(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addMentalAssessment(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-repeat mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("addMentalAssessment")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_31(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activateEmployeeProfile(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-check-circle mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("ACTIVE")); _ck(_v, 2, 0, currVal_0); });
}
function View_EmployeesListingPage_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 42, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 40, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_12)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_13)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_14)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_15)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_16)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_17)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_18)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_19)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_20)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_21)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_22)), core["ɵdid"](24, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_23)), core["ɵdid"](26, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_24)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_25)), core["ɵdid"](30, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_26)), core["ɵdid"](32, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_27)), core["ɵdid"](34, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_28)), core["ɵdid"](36, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_29)), core["ɵdid"](38, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_30)), core["ɵdid"](40, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_31)), core["ɵdid"](42, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = (_v.parent.context.$implicit.status == 1); _ck(_v, 4, 0, currVal_0); var currVal_1 = (_v.parent.context.$implicit.status == 1); _ck(_v, 6, 0, currVal_1); var currVal_2 = (_v.parent.context.$implicit.status == 1); _ck(_v, 8, 0, currVal_2); var currVal_3 = (_v.parent.context.$implicit.status == 1); _ck(_v, 10, 0, currVal_3); var currVal_4 = ((_v.parent.context.$implicit.status == 1) && _v.parent.context.$implicit.icVerified); _ck(_v, 12, 0, currVal_4); var currVal_5 = (_v.parent.context.$implicit.status == 1); _ck(_v, 14, 0, currVal_5); var currVal_6 = (_v.parent.context.$implicit.status == 1); _ck(_v, 16, 0, currVal_6); var currVal_7 = (_v.parent.context.$implicit.status == 1); _ck(_v, 18, 0, currVal_7); var currVal_8 = (_v.parent.context.$implicit.status == 1); _ck(_v, 20, 0, currVal_8); var currVal_9 = (_v.parent.context.$implicit.status == 1); _ck(_v, 22, 0, currVal_9); var currVal_10 = (_v.parent.context.$implicit.status == 1); _ck(_v, 24, 0, currVal_10); var currVal_11 = (_v.parent.context.$implicit.status == 1); _ck(_v, 26, 0, currVal_11); var currVal_12 = (_v.parent.context.$implicit.status == 1); _ck(_v, 28, 0, currVal_12); var currVal_13 = ((_v.parent.context.$implicit.status == 1) && ((_v.parent.context.$implicit.gradeName == null) || (_v.parent.context.$implicit.gradeName == ""))); _ck(_v, 30, 0, currVal_13); var currVal_14 = ((_v.parent.context.$implicit.status == 1) && ((_v.parent.context.$implicit.designationCode == null) || (_v.parent.context.$implicit.designationCode != "LOW_RISK_NS"))); _ck(_v, 32, 0, currVal_14); var currVal_15 = ((_v.parent.context.$implicit.status == 1) && (_v.parent.context.$implicit.transferredDate == null)); _ck(_v, 34, 0, currVal_15); var currVal_16 = ((_v.parent.context.$implicit.status == 1) && _v.parent.context.$implicit.icVerified); _ck(_v, 36, 0, currVal_16); var currVal_17 = ((_v.parent.context.$implicit.status == 1) && _v.parent.context.$implicit.nonVaccineAccount); _ck(_v, 38, 0, currVal_17); var currVal_18 = ((_v.parent.context.$implicit.status == 1) && ((_v.parent.context.$implicit.gradeName == null) || (_v.parent.context.$implicit.gradeName == ""))); _ck(_v, 40, 0, currVal_18); var currVal_19 = (_v.parent.context.$implicit.status != 1); _ck(_v, 42, 0, currVal_19); }, null); }
function View_EmployeesListingPage_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 49, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 3, "h6", [["class", "mb-lg-0 text-truncate text-primary"]], null, [[null, "copied"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("copied" === en)) {
                var pd_1 = (_co.notify($event) !== false);
                ad = (pd_1 && ad);
            }
            if (("click" === en)) {
                var pd_2 = (_co.editEmployeeProfile(_v.context.$implicit.id) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵdid"](4, 16384, null, 0, copy_to_clipboard_directive_CopyClipboardDirective, [], { payload: [0, "payload"] }, { copied: "copied" }), (_l()(), core["ɵted"](5, null, [" ", " "])), (_l()(), core["ɵeld"](6, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 16777216, null, null, 3, "h6", [["class", "mb-lg-0 text-truncate"]], null, [[null, "copied"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("copied" === en)) {
                var pd_1 = (_co.notify($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](8, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵdid"](9, 16384, null, 0, copy_to_clipboard_directive_CopyClipboardDirective, [], { payload: [0, "payload"] }, { copied: "copied" }), (_l()(), core["ɵted"](10, null, [" ", " "])), (_l()(), core["ɵeld"](11, 0, null, null, 8, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_3)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_4)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](16, 16777216, null, null, 3, "h6", [["class", "mb-lg-0 text-truncate"]], null, [[null, "copied"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 18).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("copied" === en)) {
                var pd_1 = (_co.notify($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](17, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵdid"](18, 16384, null, 0, copy_to_clipboard_directive_CopyClipboardDirective, [], { payload: [0, "payload"] }, { copied: "copied" }), (_l()(), core["ɵted"](19, null, [" ", " "])), (_l()(), core["ɵeld"](20, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_5)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_6)), core["ɵdid"](24, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](25, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_7)), core["ɵdid"](27, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_8)), core["ɵdid"](29, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](30, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_9)), core["ɵdid"](32, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_10)), core["ɵdid"](34, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](35, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](37, null, ["", ""])), (_l()(), core["ɵeld"](38, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 3, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](40, null, ["", ""])), core["ɵppd"](41, 1), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](43, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](44, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](45, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](47, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_11)), core["ɵdid"](49, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.userName, ""); _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.userName; _ck(_v, 4, 0, currVal_1); var currVal_3 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.licenceNumber, ""); _ck(_v, 8, 0, currVal_3); var currVal_4 = _v.context.$implicit.licenceNumber; _ck(_v, 9, 0, currVal_4); var currVal_6 = _v.context.$implicit.imageUrl; _ck(_v, 13, 0, currVal_6); var currVal_7 = !_v.context.$implicit.imageUrl; _ck(_v, 15, 0, currVal_7); var currVal_8 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.displayName, ""); _ck(_v, 17, 0, currVal_8); var currVal_9 = _v.context.$implicit.displayName; _ck(_v, 18, 0, currVal_9); var currVal_11 = (_v.context.$implicit.orgId != null); _ck(_v, 22, 0, currVal_11); var currVal_12 = (_v.context.$implicit.orgId == null); _ck(_v, 24, 0, currVal_12); var currVal_13 = (_v.context.$implicit.designationName != null); _ck(_v, 27, 0, currVal_13); var currVal_14 = (_v.context.$implicit.designationName == null); _ck(_v, 29, 0, currVal_14); var currVal_15 = _v.context.$implicit.supervisorName; _ck(_v, 32, 0, currVal_15); var currVal_16 = !_v.context.$implicit.supervisorName; _ck(_v, 34, 0, currVal_16); var currVal_19 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 45, 0, core["ɵnov"](_v, 46).transform("clickForMoreOption")), ""); _ck(_v, 45, 0, currVal_19); var currVal_20 = (_v.context.index == _co.trackHides); _ck(_v, 49, 0, currVal_20); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.userName; _ck(_v, 5, 0, currVal_2); var currVal_5 = _v.context.$implicit.licenceNumber; _ck(_v, 10, 0, currVal_5); var currVal_10 = _v.context.$implicit.displayName; _ck(_v, 19, 0, currVal_10); var currVal_17 = (_v.context.$implicit.nonVaccineAccount ? "Non Vaccine Account" : (_v.context.$implicit.icVerified ? "Yes" : "No")); _ck(_v, 37, 0, currVal_17); var currVal_18 = core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 42).transform(core["ɵunv"](_v, 40, 0, _ck(_v, 41, 0, core["ɵnov"](_v.parent.parent, 0), _v.context.$implicit.status)))); _ck(_v, 40, 0, currVal_18); });
}
function View_EmployeesListingPage_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_EmployeesListingPage_33(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_EmployeesListingPage_34(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_EmployeesListingPage_32(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_33)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_34)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_EmployeesListingPage_36(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "option", [], [[1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit; _ck(_v, 0, 0, currVal_0); var currVal_1 = _co.getRoleLabel(_v.context.$implicit); _ck(_v, 4, 0, currVal_1); }); }
function View_EmployeesListingPage_35(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 21, "div", [["id", "divdata"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Change role"])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeRoleModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 11, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [["class", "mb-2 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Please select a role *"])), (_l()(), core["ɵeld"](11, 0, null, null, 7, "select", [["aria-label", ""], ["class", "form-select"], ["id", "role_list"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 12).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 12).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co._newRole = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](12, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](14, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](16, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_36)), core["ɵdid"](18, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 2, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 1, "button", [["class", "btn btn-primary"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeRole(_co.confirmationModal) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Change"]))], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co._newRole; _ck(_v, 14, 0, currVal_7); var currVal_8 = _co.roles; _ck(_v, 18, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 16).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 16).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 16).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 16).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 16).ngClassValid; var currVal_5 = core["ɵnov"](_v, 16).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 16).ngClassPending; _ck(_v, 11, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_EmployeesListingPage_38(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1051, "div", [["class", "form-group"], ["style", "margin:0px;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1050, "div", [["class", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1039, "div", [["class", "col-5 form-group has-float-label required"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1038, "select", [["class", "form-control custom-select"], ["id", "countryCode"], ["name", "countryCode"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co._newMYSJCounCode = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 3, "option", [["data-countrycode", "MY"], ["value", "60"]], null, null, null, null, null)), core["ɵdid"](10, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](11, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Malaysia (+60)"])), (_l()(), core["ɵeld"](13, 0, null, null, 3, "option", [["data-countrycode", "CN"], ["value", "86"]], null, null, null, null, null)), core["ɵdid"](14, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](15, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["China (+86)"])), (_l()(), core["ɵeld"](17, 0, null, null, 3, "option", [["data-countrycode", "JP"], ["value", "81"]], null, null, null, null, null)), core["ɵdid"](18, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](19, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Japan (+81)"])), (_l()(), core["ɵeld"](21, 0, null, null, 3, "option", [["data-countrycode", "KR"], ["value", "82"]], null, null, null, null, null)), core["ɵdid"](22, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](23, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["South Korea (+82)"])), (_l()(), core["ɵeld"](25, 0, null, null, 3, "option", [["data-countrycode", "IR"], ["value", "98"]], null, null, null, null, null)), core["ɵdid"](26, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](27, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Iran (+98)"])), (_l()(), core["ɵeld"](29, 0, null, null, 3, "option", [["data-countrycode", "IT"], ["value", "39"]], null, null, null, null, null)), core["ɵdid"](30, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](31, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Italy (+39)"])), (_l()(), core["ɵeld"](33, 0, null, null, 3, "option", [["data-countrycode", "SG"], ["value", "65"]], null, null, null, null, null)), core["ɵdid"](34, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](35, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Singapore (+65)"])), (_l()(), core["ɵeld"](37, 0, null, null, 3, "option", [["data-countrycode", "AU"], ["value", "61"]], null, null, null, null, null)), core["ɵdid"](38, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](39, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Australia (+61)"])), (_l()(), core["ɵeld"](41, 0, null, null, 3, "option", [["data-countrycode", "IN"], ["value", "91"]], null, null, null, null, null)), core["ɵdid"](42, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](43, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["India (+91)"])), (_l()(), core["ɵeld"](45, 0, null, null, 3, "option", [["data-countrycode", "TH"], ["value", "66"]], null, null, null, null, null)), core["ɵdid"](46, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](47, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Thailand (+66)"])), (_l()(), core["ɵeld"](49, 0, null, null, 992, "optgroup", [["label", "Other countries"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 3, "option", [["data-countrycode", "AFG"], ["value", "93"]], null, null, null, null, null)), core["ɵdid"](51, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](52, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Afghanistan (+93)"])), (_l()(), core["ɵeld"](54, 0, null, null, 3, "option", [["data-countrycode", "ALB"], ["value", "355"]], null, null, null, null, null)), core["ɵdid"](55, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](56, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Albania (+355)"])), (_l()(), core["ɵeld"](58, 0, null, null, 3, "option", [["data-countrycode", "DZ"], ["value", "213"]], null, null, null, null, null)), core["ɵdid"](59, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](60, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Algeria (+213)"])), (_l()(), core["ɵeld"](62, 0, null, null, 3, "option", [["data-countrycode", "ALA"], ["value", "35818"]], null, null, null, null, null)), core["ɵdid"](63, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](64, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["\u00C5land Islands (+35818)"])), (_l()(), core["ɵeld"](66, 0, null, null, 3, "option", [["data-countrycode", "ASM"], ["value", "684"]], null, null, null, null, null)), core["ɵdid"](67, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](68, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["American Samoa (+684)"])), (_l()(), core["ɵeld"](70, 0, null, null, 3, "option", [["data-countrycode", "AD"], ["value", "376"]], null, null, null, null, null)), core["ɵdid"](71, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](72, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Andorra (+376)"])), (_l()(), core["ɵeld"](74, 0, null, null, 3, "option", [["data-countrycode", "AO"], ["value", "244"]], null, null, null, null, null)), core["ɵdid"](75, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](76, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Angola (+244)"])), (_l()(), core["ɵeld"](78, 0, null, null, 3, "option", [["data-countrycode", "AI"], ["value", "1264"]], null, null, null, null, null)), core["ɵdid"](79, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](80, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Anguilla (+1264)"])), (_l()(), core["ɵeld"](82, 0, null, null, 3, "option", [["data-countrycode", "ATA"], ["value", "672"]], null, null, null, null, null)), core["ɵdid"](83, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](84, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Antarctica (+672)"])), (_l()(), core["ɵeld"](86, 0, null, null, 3, "option", [["data-countrycode", "AG"], ["value", "1268"]], null, null, null, null, null)), core["ɵdid"](87, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](88, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Antigua & Barbuda (+1268) "])), (_l()(), core["ɵeld"](90, 0, null, null, 3, "option", [["data-countrycode", "AR"], ["value", "54"]], null, null, null, null, null)), core["ɵdid"](91, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](92, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Argentina (+54)"])), (_l()(), core["ɵeld"](94, 0, null, null, 3, "option", [["data-countrycode", "AM"], ["value", "374"]], null, null, null, null, null)), core["ɵdid"](95, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](96, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Armenia (+374)"])), (_l()(), core["ɵeld"](98, 0, null, null, 3, "option", [["data-countrycode", "AW"], ["value", "297"]], null, null, null, null, null)), core["ɵdid"](99, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](100, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Aruba (+297)"])), (_l()(), core["ɵeld"](102, 0, null, null, 3, "option", [["data-countrycode", "SHAC"], ["value", "247"]], null, null, null, null, null)), core["ɵdid"](103, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](104, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ascension island (+247)"])), (_l()(), core["ɵeld"](106, 0, null, null, 3, "option", [["data-countrycode", "AT"], ["value", "43"]], null, null, null, null, null)), core["ɵdid"](107, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](108, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Austria (+43)"])), (_l()(), core["ɵeld"](110, 0, null, null, 3, "option", [["data-countrycode", "AQ"], ["value", "672"]], null, null, null, null, null)), core["ɵdid"](111, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](112, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Australian Antarctic Territory (+672) "])), (_l()(), core["ɵeld"](114, 0, null, null, 3, "option", [["data-countrycode", "AT"], ["value", "672"]], null, null, null, null, null)), core["ɵdid"](115, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](116, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Australian External Territories (+672) "])), (_l()(), core["ɵeld"](118, 0, null, null, 3, "option", [["data-countrycode", "AZ"], ["value", "994"]], null, null, null, null, null)), core["ɵdid"](119, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](120, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Azerbaijan (+994)"])), (_l()(), core["ɵeld"](122, 0, null, null, 3, "option", [["data-countrycode", "BS"], ["value", "1242"]], null, null, null, null, null)), core["ɵdid"](123, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](124, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bahamas (+1242)"])), (_l()(), core["ɵeld"](126, 0, null, null, 3, "option", [["data-countrycode", "BH"], ["value", "973"]], null, null, null, null, null)), core["ɵdid"](127, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](128, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bahrain (+973)"])), (_l()(), core["ɵeld"](130, 0, null, null, 3, "option", [["data-countrycode", "BD"], ["value", "880"]], null, null, null, null, null)), core["ɵdid"](131, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](132, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bangladesh (+880)"])), (_l()(), core["ɵeld"](134, 0, null, null, 3, "option", [["data-countrycode", "BB"], ["value", "1246"]], null, null, null, null, null)), core["ɵdid"](135, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](136, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Barbados (+1246)"])), (_l()(), core["ɵeld"](138, 0, null, null, 3, "option", [["data-countrycode", "AG"], ["value", "1268"]], null, null, null, null, null)), core["ɵdid"](139, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](140, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Barbuda (+1268)"])), (_l()(), core["ɵeld"](142, 0, null, null, 3, "option", [["data-countrycode", "BY"], ["value", "375"]], null, null, null, null, null)), core["ɵdid"](143, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](144, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Belarus (+375)"])), (_l()(), core["ɵeld"](146, 0, null, null, 3, "option", [["data-countrycode", "BE"], ["value", "32"]], null, null, null, null, null)), core["ɵdid"](147, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](148, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Belgium (+32)"])), (_l()(), core["ɵeld"](150, 0, null, null, 3, "option", [["data-countrycode", "BZ"], ["value", "501"]], null, null, null, null, null)), core["ɵdid"](151, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](152, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Belize (+501)"])), (_l()(), core["ɵeld"](154, 0, null, null, 3, "option", [["data-countrycode", "BJ"], ["value", "229"]], null, null, null, null, null)), core["ɵdid"](155, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](156, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Benin (+229)"])), (_l()(), core["ɵeld"](158, 0, null, null, 3, "option", [["data-countrycode", "BM"], ["value", "1441"]], null, null, null, null, null)), core["ɵdid"](159, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](160, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bermuda (+1441)"])), (_l()(), core["ɵeld"](162, 0, null, null, 3, "option", [["data-countrycode", "BT"], ["value", "975"]], null, null, null, null, null)), core["ɵdid"](163, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](164, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bhutan (+975)"])), (_l()(), core["ɵeld"](166, 0, null, null, 3, "option", [["data-countrycode", "BO"], ["value", "591"]], null, null, null, null, null)), core["ɵdid"](167, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](168, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bolivia (+591)"])), (_l()(), core["ɵeld"](170, 0, null, null, 3, "option", [["data-countrycode", "BN"], ["value", "5997"]], null, null, null, null, null)), core["ɵdid"](171, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](172, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bonaire (+5997)"])), (_l()(), core["ɵeld"](174, 0, null, null, 3, "option", [["data-countrycode", "BA"], ["value", "387"]], null, null, null, null, null)), core["ɵdid"](175, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](176, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bosnia Herzegovina (+387)"])), (_l()(), core["ɵeld"](178, 0, null, null, 3, "option", [["data-countrycode", "BW"], ["value", "267"]], null, null, null, null, null)), core["ɵdid"](179, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](180, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Botswana (+267)"])), (_l()(), core["ɵeld"](182, 0, null, null, 3, "option", [["data-countrycode", "BR"], ["value", "55"]], null, null, null, null, null)), core["ɵdid"](183, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](184, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Brazil (+55)"])), (_l()(), core["ɵeld"](186, 0, null, null, 3, "option", [["data-countrycode", "IOT"], ["value", "246"]], null, null, null, null, null)), core["ɵdid"](187, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](188, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["British Indian Ocean Territory (+246) "])), (_l()(), core["ɵeld"](190, 0, null, null, 3, "option", [["data-countrycode", "VGB"], ["value", "284"]], null, null, null, null, null)), core["ɵdid"](191, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](192, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["British Virgin Islands (+284) "])), (_l()(), core["ɵeld"](194, 0, null, null, 3, "option", [["data-countrycode", "BN"], ["value", "673"]], null, null, null, null, null)), core["ɵdid"](195, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](196, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Brunei (+673)"])), (_l()(), core["ɵeld"](198, 0, null, null, 3, "option", [["data-countrycode", "BG"], ["value", "359"]], null, null, null, null, null)), core["ɵdid"](199, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](200, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bulgaria (+359)"])), (_l()(), core["ɵeld"](202, 0, null, null, 3, "option", [["data-countrycode", "BF"], ["value", "226"]], null, null, null, null, null)), core["ɵdid"](203, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](204, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Burkina Faso (+226)"])), (_l()(), core["ɵeld"](206, 0, null, null, 3, "option", [["data-countrycode", "BI"], ["value", "257"]], null, null, null, null, null)), core["ɵdid"](207, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](208, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Burundi (+257)"])), (_l()(), core["ɵeld"](210, 0, null, null, 3, "option", [["data-countrycode", "BI"], ["value", "5993"]], null, null, null, null, null)), core["ɵdid"](211, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](212, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Caribbean Netherlands (+5993) "])), (_l()(), core["ɵeld"](214, 0, null, null, 3, "option", [["data-countrycode", "KH"], ["value", "855"]], null, null, null, null, null)), core["ɵdid"](215, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](216, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cambodia (+855)"])), (_l()(), core["ɵeld"](218, 0, null, null, 3, "option", [["data-countrycode", "CM"], ["value", "237"]], null, null, null, null, null)), core["ɵdid"](219, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](220, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cameroon (+237)"])), (_l()(), core["ɵeld"](222, 0, null, null, 3, "option", [["data-countrycode", "CA"], ["value", "1"]], null, null, null, null, null)), core["ɵdid"](223, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](224, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Canada (+1)"])), (_l()(), core["ɵeld"](226, 0, null, null, 3, "option", [["data-countrycode", "CV"], ["value", "238"]], null, null, null, null, null)), core["ɵdid"](227, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](228, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cape Verde Islands (+238)"])), (_l()(), core["ɵeld"](230, 0, null, null, 3, "option", [["data-countrycode", "KY"], ["value", "1345"]], null, null, null, null, null)), core["ɵdid"](231, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](232, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cayman Islands (+1345)"])), (_l()(), core["ɵeld"](234, 0, null, null, 3, "option", [["data-countrycode", "KY"], ["value", "243"]], null, null, null, null, null)), core["ɵdid"](235, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](236, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Congo, Democratic Republic of the (Zaire) (+243) "])), (_l()(), core["ɵeld"](238, 0, null, null, 3, "option", [["data-countrycode", "CF"], ["value", "236"]], null, null, null, null, null)), core["ɵdid"](239, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](240, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Central African Republic (+236) "])), (_l()(), core["ɵeld"](242, 0, null, null, 3, "option", [["data-countrycode", "TCD"], ["value", "235"]], null, null, null, null, null)), core["ɵdid"](243, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](244, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Chad (+235)"])), (_l()(), core["ɵeld"](246, 0, null, null, 3, "option", [["data-countrycode", "CL"], ["value", "56"]], null, null, null, null, null)), core["ɵdid"](247, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](248, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Chile (+56)"])), (_l()(), core["ɵeld"](250, 0, null, null, 3, "option", [["data-countrycode", "CXR"], ["value", "61"]], null, null, null, null, null)), core["ɵdid"](251, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](252, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Christmas Island (+61)"])), (_l()(), core["ɵeld"](254, 0, null, null, 3, "option", [["data-countrycode", "CCK"], ["value", "61"]], null, null, null, null, null)), core["ɵdid"](255, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](256, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cocos Islands (+61)"])), (_l()(), core["ɵeld"](258, 0, null, null, 3, "option", [["data-countrycode", "CO"], ["value", "57"]], null, null, null, null, null)), core["ɵdid"](259, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](260, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Colombia (+57)"])), (_l()(), core["ɵeld"](262, 0, null, null, 3, "option", [["data-countrycode", "KM"], ["value", "269"]], null, null, null, null, null)), core["ɵdid"](263, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](264, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Comoros (+269)"])), (_l()(), core["ɵeld"](266, 0, null, null, 3, "option", [["data-countrycode", "CG"], ["value", "242"]], null, null, null, null, null)), core["ɵdid"](267, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](268, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Congo (+242)"])), (_l()(), core["ɵeld"](270, 0, null, null, 3, "option", [["data-countrycode", "CK"], ["value", "682"]], null, null, null, null, null)), core["ɵdid"](271, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](272, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cook Islands (+682)"])), (_l()(), core["ɵeld"](274, 0, null, null, 3, "option", [["data-countrycode", "CR"], ["value", "506"]], null, null, null, null, null)), core["ɵdid"](275, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](276, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Costa Rica (+506)"])), (_l()(), core["ɵeld"](278, 0, null, null, 3, "option", [["data-countrycode", "HR"], ["value", "385"]], null, null, null, null, null)), core["ɵdid"](279, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](280, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Croatia (+385)"])), (_l()(), core["ɵeld"](282, 0, null, null, 3, "option", [["data-countrycode", "CU"], ["value", "53"]], null, null, null, null, null)), core["ɵdid"](283, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](284, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cuba (+53)"])), (_l()(), core["ɵeld"](286, 0, null, null, 3, "option", [["data-countrycode", "CUW"], ["value", "599"]], null, null, null, null, null)), core["ɵdid"](287, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](288, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Curacao (+599)"])), (_l()(), core["ɵeld"](290, 0, null, null, 3, "option", [["data-countrycode", "CY"], ["value", "90392"]], null, null, null, null, null)), core["ɵdid"](291, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](292, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cyprus North (+90392)"])), (_l()(), core["ɵeld"](294, 0, null, null, 3, "option", [["data-countrycode", "CY"], ["value", "357"]], null, null, null, null, null)), core["ɵdid"](295, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](296, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cyprus South (+357)"])), (_l()(), core["ɵeld"](298, 0, null, null, 3, "option", [["data-countrycode", "CZ"], ["value", "42"]], null, null, null, null, null)), core["ɵdid"](299, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](300, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Czech Republic (+42)"])), (_l()(), core["ɵeld"](302, 0, null, null, 3, "option", [["data-countrycode", "DK"], ["value", "246"]], null, null, null, null, null)), core["ɵdid"](303, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](304, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Diego Garcia (+246)"])), (_l()(), core["ɵeld"](306, 0, null, null, 3, "option", [["data-countrycode", "DK"], ["value", "45"]], null, null, null, null, null)), core["ɵdid"](307, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](308, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Denmark (+45)"])), (_l()(), core["ɵeld"](310, 0, null, null, 3, "option", [["data-countrycode", "DJ"], ["value", "253"]], null, null, null, null, null)), core["ɵdid"](311, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](312, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Djibouti (+253)"])), (_l()(), core["ɵeld"](314, 0, null, null, 3, "option", [["data-countrycode", "DM"], ["value", "1809"]], null, null, null, null, null)), core["ɵdid"](315, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](316, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Dominica (+1809)"])), (_l()(), core["ɵeld"](318, 0, null, null, 3, "option", [["data-countrycode", "DO"], ["value", "1809"]], null, null, null, null, null)), core["ɵdid"](319, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](320, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Dominican Republic (+1809) "])), (_l()(), core["ɵeld"](322, 0, null, null, 3, "option", [["data-countrycode", "TLS"], ["value", "670"]], null, null, null, null, null)), core["ɵdid"](323, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](324, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["East Timor (+670)"])), (_l()(), core["ɵeld"](326, 0, null, null, 3, "option", [["data-countrycode", "TLS"], ["value", "56"]], null, null, null, null, null)), core["ɵdid"](327, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](328, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Easter Island (+56)"])), (_l()(), core["ɵeld"](330, 0, null, null, 3, "option", [["data-countrycode", "EC"], ["value", "593"]], null, null, null, null, null)), core["ɵdid"](331, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](332, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ecuador (+593)"])), (_l()(), core["ɵeld"](334, 0, null, null, 3, "option", [["data-countrycode", "EG"], ["value", "20"]], null, null, null, null, null)), core["ɵdid"](335, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](336, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Egypt (+20)"])), (_l()(), core["ɵeld"](338, 0, null, null, 3, "option", [["data-countrycode", "SV"], ["value", "503"]], null, null, null, null, null)), core["ɵdid"](339, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](340, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["El Salvador (+503)"])), (_l()(), core["ɵeld"](342, 0, null, null, 3, "option", [["data-countrycode", "GQ"], ["value", "240"]], null, null, null, null, null)), core["ɵdid"](343, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](344, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Equatorial Guinea (+240)"])), (_l()(), core["ɵeld"](346, 0, null, null, 3, "option", [["data-countrycode", "ER"], ["value", "291"]], null, null, null, null, null)), core["ɵdid"](347, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](348, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Eritrea (+291)"])), (_l()(), core["ɵeld"](350, 0, null, null, 3, "option", [["data-countrycode", "EE"], ["value", "372"]], null, null, null, null, null)), core["ɵdid"](351, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](352, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Estonia (+372)"])), (_l()(), core["ɵeld"](354, 0, null, null, 3, "option", [["data-countrycode", "ET"], ["value", "251"]], null, null, null, null, null)), core["ɵdid"](355, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](356, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ethiopia (+251)"])), (_l()(), core["ɵeld"](358, 0, null, null, 3, "option", [["data-countrycode", "FK"], ["value", "500"]], null, null, null, null, null)), core["ɵdid"](359, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](360, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Falkland Islands (+500)"])), (_l()(), core["ɵeld"](362, 0, null, null, 3, "option", [["data-countrycode", "FO"], ["value", "298"]], null, null, null, null, null)), core["ɵdid"](363, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](364, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Faroe Islands (+298)"])), (_l()(), core["ɵeld"](366, 0, null, null, 3, "option", [["data-countrycode", "FJ"], ["value", "679"]], null, null, null, null, null)), core["ɵdid"](367, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](368, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Fiji (+679)"])), (_l()(), core["ɵeld"](370, 0, null, null, 3, "option", [["data-countrycode", "FI"], ["value", "358"]], null, null, null, null, null)), core["ɵdid"](371, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](372, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Finland (+358)"])), (_l()(), core["ɵeld"](374, 0, null, null, 3, "option", [["data-countrycode", "FR"], ["value", "33"]], null, null, null, null, null)), core["ɵdid"](375, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](376, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["France (+33)"])), (_l()(), core["ɵeld"](378, 0, null, null, 3, "option", [["data-countrycode", "GF"], ["value", "596"]], null, null, null, null, null)), core["ɵdid"](379, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](380, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["French Antilles (+596)"])), (_l()(), core["ɵeld"](382, 0, null, null, 3, "option", [["data-countrycode", "GF"], ["value", "594"]], null, null, null, null, null)), core["ɵdid"](383, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](384, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["French Guiana (+594)"])), (_l()(), core["ɵeld"](386, 0, null, null, 3, "option", [["data-countrycode", "PF"], ["value", "689"]], null, null, null, null, null)), core["ɵdid"](387, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](388, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["French Polynesia (+689)"])), (_l()(), core["ɵeld"](390, 0, null, null, 3, "option", [["data-countrycode", "GA"], ["value", "241"]], null, null, null, null, null)), core["ɵdid"](391, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](392, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Gabon (+241)"])), (_l()(), core["ɵeld"](394, 0, null, null, 3, "option", [["data-countrycode", "GM"], ["value", "220"]], null, null, null, null, null)), core["ɵdid"](395, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](396, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Gambia (+220)"])), (_l()(), core["ɵeld"](398, 0, null, null, 3, "option", [["data-countrycode", "GE"], ["value", "7880"]], null, null, null, null, null)), core["ɵdid"](399, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](400, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Georgia (+7880)"])), (_l()(), core["ɵeld"](402, 0, null, null, 3, "option", [["data-countrycode", "DE"], ["value", "49"]], null, null, null, null, null)), core["ɵdid"](403, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](404, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Germany (+49)"])), (_l()(), core["ɵeld"](406, 0, null, null, 3, "option", [["data-countrycode", "GH"], ["value", "233"]], null, null, null, null, null)), core["ɵdid"](407, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](408, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ghana (+233)"])), (_l()(), core["ɵeld"](410, 0, null, null, 3, "option", [["data-countrycode", "GI"], ["value", "350"]], null, null, null, null, null)), core["ɵdid"](411, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](412, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Gibraltar (+350)"])), (_l()(), core["ɵeld"](414, 0, null, null, 3, "option", [["data-countrycode", "GR"], ["value", "30"]], null, null, null, null, null)), core["ɵdid"](415, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](416, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Greece (+30)"])), (_l()(), core["ɵeld"](418, 0, null, null, 3, "option", [["data-countrycode", "GL"], ["value", "299"]], null, null, null, null, null)), core["ɵdid"](419, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](420, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Greenland (+299)"])), (_l()(), core["ɵeld"](422, 0, null, null, 3, "option", [["data-countrycode", "GD"], ["value", "1473"]], null, null, null, null, null)), core["ɵdid"](423, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](424, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Grenada (+1473)"])), (_l()(), core["ɵeld"](426, 0, null, null, 3, "option", [["data-countrycode", "GP"], ["value", "590"]], null, null, null, null, null)), core["ɵdid"](427, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](428, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guadeloupe (+590)"])), (_l()(), core["ɵeld"](430, 0, null, null, 3, "option", [["data-countrycode", "GU"], ["value", "671"]], null, null, null, null, null)), core["ɵdid"](431, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](432, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guam (+671)"])), (_l()(), core["ɵeld"](434, 0, null, null, 3, "option", [["data-countrycode", "GT"], ["value", "502"]], null, null, null, null, null)), core["ɵdid"](435, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](436, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guatemala (+502)"])), (_l()(), core["ɵeld"](438, 0, null, null, 3, "option", [["data-countrycode", "GGY"], ["value", "44"]], null, null, null, null, null)), core["ɵdid"](439, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](440, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guernsey (+44)"])), (_l()(), core["ɵeld"](442, 0, null, null, 3, "option", [["data-countrycode", "GN"], ["value", "224"]], null, null, null, null, null)), core["ɵdid"](443, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](444, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guinea (+224)"])), (_l()(), core["ɵeld"](446, 0, null, null, 3, "option", [["data-countrycode", "GW"], ["value", "245"]], null, null, null, null, null)), core["ɵdid"](447, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](448, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guinea - Bissau (+245)"])), (_l()(), core["ɵeld"](450, 0, null, null, 3, "option", [["data-countrycode", "GY"], ["value", "592"]], null, null, null, null, null)), core["ɵdid"](451, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](452, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guyana (+592)"])), (_l()(), core["ɵeld"](454, 0, null, null, 3, "option", [["data-countrycode", "HT"], ["value", "509"]], null, null, null, null, null)), core["ɵdid"](455, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](456, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Haiti (+509)"])), (_l()(), core["ɵeld"](458, 0, null, null, 3, "option", [["data-countrycode", "HN"], ["value", "504"]], null, null, null, null, null)), core["ɵdid"](459, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](460, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Honduras (+504)"])), (_l()(), core["ɵeld"](462, 0, null, null, 3, "option", [["data-countrycode", "HK"], ["value", "852"]], null, null, null, null, null)), core["ɵdid"](463, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](464, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Hong Kong (+852)"])), (_l()(), core["ɵeld"](466, 0, null, null, 3, "option", [["data-countrycode", "HU"], ["value", "36"]], null, null, null, null, null)), core["ɵdid"](467, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](468, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Hungary (+36)"])), (_l()(), core["ɵeld"](470, 0, null, null, 3, "option", [["data-countrycode", "IS"], ["value", "354"]], null, null, null, null, null)), core["ɵdid"](471, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](472, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Iceland (+354)"])), (_l()(), core["ɵeld"](474, 0, null, null, 3, "option", [["data-countrycode", "ID"], ["value", "62"]], null, null, null, null, null)), core["ɵdid"](475, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](476, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Indonesia (+62)"])), (_l()(), core["ɵeld"](478, 0, null, null, 3, "option", [["data-countrycode", "IQ"], ["value", "964"]], null, null, null, null, null)), core["ɵdid"](479, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](480, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Iraq (+964)"])), (_l()(), core["ɵeld"](482, 0, null, null, 3, "option", [["data-countrycode", "IE"], ["value", "353"]], null, null, null, null, null)), core["ɵdid"](483, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](484, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ireland (+353)"])), (_l()(), core["ɵeld"](486, 0, null, null, 3, "option", [["data-countrycode", "IMN"], ["value", "44"]], null, null, null, null, null)), core["ɵdid"](487, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](488, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Isle of Man (+44)"])), (_l()(), core["ɵeld"](490, 0, null, null, 3, "option", [["data-countrycode", "IL"], ["value", "972"]], null, null, null, null, null)), core["ɵdid"](491, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](492, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Israel (+972)"])), (_l()(), core["ɵeld"](494, 0, null, null, 3, "option", [["data-countrycode", "CIV"], ["value", "225"]], null, null, null, null, null)), core["ɵdid"](495, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](496, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ivory Coast (+225)"])), (_l()(), core["ɵeld"](498, 0, null, null, 3, "option", [["data-countrycode", "JM"], ["value", "1876"]], null, null, null, null, null)), core["ɵdid"](499, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](500, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Jamaica (+1876)"])), (_l()(), core["ɵeld"](502, 0, null, null, 3, "option", [["data-countrycode", "JEY"], ["value", "44"]], null, null, null, null, null)), core["ɵdid"](503, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](504, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Jersey (+44)"])), (_l()(), core["ɵeld"](506, 0, null, null, 3, "option", [["data-countrycode", "JO"], ["value", "962"]], null, null, null, null, null)), core["ɵdid"](507, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](508, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Jordan (+962)"])), (_l()(), core["ɵeld"](510, 0, null, null, 3, "option", [["data-countrycode", "KZ"], ["value", "7"]], null, null, null, null, null)), core["ɵdid"](511, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](512, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kazakhstan (+7)"])), (_l()(), core["ɵeld"](514, 0, null, null, 3, "option", [["data-countrycode", "KE"], ["value", "254"]], null, null, null, null, null)), core["ɵdid"](515, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](516, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kenya (+254)"])), (_l()(), core["ɵeld"](518, 0, null, null, 3, "option", [["data-countrycode", "KI"], ["value", "686"]], null, null, null, null, null)), core["ɵdid"](519, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](520, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kiribati (+686)"])), (_l()(), core["ɵeld"](522, 0, null, null, 3, "option", [["data-countrycode", "XKX"], ["value", "383"]], null, null, null, null, null)), core["ɵdid"](523, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](524, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kosovo (+383)"])), (_l()(), core["ɵeld"](526, 0, null, null, 3, "option", [["data-countrycode", "KW"], ["value", "965"]], null, null, null, null, null)), core["ɵdid"](527, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](528, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kuwait (+965)"])), (_l()(), core["ɵeld"](530, 0, null, null, 3, "option", [["data-countrycode", "KG"], ["value", "996"]], null, null, null, null, null)), core["ɵdid"](531, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](532, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kyrgyzstan (+996)"])), (_l()(), core["ɵeld"](534, 0, null, null, 3, "option", [["data-countrycode", "LA"], ["value", "856"]], null, null, null, null, null)), core["ɵdid"](535, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](536, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Laos (+856)"])), (_l()(), core["ɵeld"](538, 0, null, null, 3, "option", [["data-countrycode", "LV"], ["value", "371"]], null, null, null, null, null)), core["ɵdid"](539, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](540, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Latvia (+371)"])), (_l()(), core["ɵeld"](542, 0, null, null, 3, "option", [["data-countrycode", "LB"], ["value", "961"]], null, null, null, null, null)), core["ɵdid"](543, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](544, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Lebanon (+961)"])), (_l()(), core["ɵeld"](546, 0, null, null, 3, "option", [["data-countrycode", "LS"], ["value", "266"]], null, null, null, null, null)), core["ɵdid"](547, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](548, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Lesotho (+266)"])), (_l()(), core["ɵeld"](550, 0, null, null, 3, "option", [["data-countrycode", "LR"], ["value", "231"]], null, null, null, null, null)), core["ɵdid"](551, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](552, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Liberia (+231)"])), (_l()(), core["ɵeld"](554, 0, null, null, 3, "option", [["data-countrycode", "LY"], ["value", "218"]], null, null, null, null, null)), core["ɵdid"](555, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](556, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Libya (+218)"])), (_l()(), core["ɵeld"](558, 0, null, null, 3, "option", [["data-countrycode", "LI"], ["value", "417"]], null, null, null, null, null)), core["ɵdid"](559, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](560, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Liechtenstein (+417)"])), (_l()(), core["ɵeld"](562, 0, null, null, 3, "option", [["data-countrycode", "LT"], ["value", "370"]], null, null, null, null, null)), core["ɵdid"](563, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](564, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Lithuania (+370)"])), (_l()(), core["ɵeld"](566, 0, null, null, 3, "option", [["data-countrycode", "LU"], ["value", "352"]], null, null, null, null, null)), core["ɵdid"](567, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](568, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Luxembourg (+352)"])), (_l()(), core["ɵeld"](570, 0, null, null, 3, "option", [["data-countrycode", "MO"], ["value", "853"]], null, null, null, null, null)), core["ɵdid"](571, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](572, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Macao (+853)"])), (_l()(), core["ɵeld"](574, 0, null, null, 3, "option", [["data-countrycode", "MK"], ["value", "389"]], null, null, null, null, null)), core["ɵdid"](575, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](576, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Macedonia (+389)"])), (_l()(), core["ɵeld"](578, 0, null, null, 3, "option", [["data-countrycode", "MG"], ["value", "261"]], null, null, null, null, null)), core["ɵdid"](579, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](580, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Madagascar (+261)"])), (_l()(), core["ɵeld"](582, 0, null, null, 3, "option", [["data-countrycode", "MW"], ["value", "265"]], null, null, null, null, null)), core["ɵdid"](583, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](584, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Malawi (+265)"])), (_l()(), core["ɵeld"](586, 0, null, null, 3, "option", [["data-countrycode", "MY"], ["value", "60"]], null, null, null, null, null)), core["ɵdid"](587, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](588, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Malaysia (+60)"])), (_l()(), core["ɵeld"](590, 0, null, null, 3, "option", [["data-countrycode", "MV"], ["value", "960"]], null, null, null, null, null)), core["ɵdid"](591, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](592, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Maldives (+960)"])), (_l()(), core["ɵeld"](594, 0, null, null, 3, "option", [["data-countrycode", "ML"], ["value", "223"]], null, null, null, null, null)), core["ɵdid"](595, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](596, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mali (+223)"])), (_l()(), core["ɵeld"](598, 0, null, null, 3, "option", [["data-countrycode", "MT"], ["value", "356"]], null, null, null, null, null)), core["ɵdid"](599, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](600, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Malta (+356)"])), (_l()(), core["ɵeld"](602, 0, null, null, 3, "option", [["data-countrycode", "MH"], ["value", "692"]], null, null, null, null, null)), core["ɵdid"](603, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](604, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Marshall Islands (+692)"])), (_l()(), core["ɵeld"](606, 0, null, null, 3, "option", [["data-countrycode", "MQ"], ["value", "596"]], null, null, null, null, null)), core["ɵdid"](607, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](608, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Martinique (+596)"])), (_l()(), core["ɵeld"](610, 0, null, null, 3, "option", [["data-countrycode", "MR"], ["value", "222"]], null, null, null, null, null)), core["ɵdid"](611, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](612, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mauritania (+222)"])), (_l()(), core["ɵeld"](614, 0, null, null, 3, "option", [["data-countrycode", "MUS"], ["value", "230"]], null, null, null, null, null)), core["ɵdid"](615, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](616, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mauritius (+230)"])), (_l()(), core["ɵeld"](618, 0, null, null, 3, "option", [["data-countrycode", "YT"], ["value", "269"]], null, null, null, null, null)), core["ɵdid"](619, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](620, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mayotte (+269)"])), (_l()(), core["ɵeld"](622, 0, null, null, 3, "option", [["data-countrycode", "MX"], ["value", "52"]], null, null, null, null, null)), core["ɵdid"](623, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](624, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mexico (+52)"])), (_l()(), core["ɵeld"](626, 0, null, null, 3, "option", [["data-countrycode", "FM"], ["value", "691"]], null, null, null, null, null)), core["ɵdid"](627, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](628, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Micronesia (+691)"])), (_l()(), core["ɵeld"](630, 0, null, null, 3, "option", [["data-countrycode", "MD"], ["value", "373"]], null, null, null, null, null)), core["ɵdid"](631, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](632, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Moldova (+373)"])), (_l()(), core["ɵeld"](634, 0, null, null, 3, "option", [["data-countrycode", "MC"], ["value", "377"]], null, null, null, null, null)), core["ɵdid"](635, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](636, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Monaco (+377)"])), (_l()(), core["ɵeld"](638, 0, null, null, 3, "option", [["data-countrycode", "MN"], ["value", "976"]], null, null, null, null, null)), core["ɵdid"](639, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](640, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mongolia (+976)"])), (_l()(), core["ɵeld"](642, 0, null, null, 3, "option", [["data-countrycode", "MS"], ["value", "1664"]], null, null, null, null, null)), core["ɵdid"](643, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](644, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Montserrat (+1664)"])), (_l()(), core["ɵeld"](646, 0, null, null, 3, "option", [["data-countrycode", "MNE"], ["value", "382"]], null, null, null, null, null)), core["ɵdid"](647, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](648, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Montenegro (+382)"])), (_l()(), core["ɵeld"](650, 0, null, null, 3, "option", [["data-countrycode", "MA"], ["value", "212"]], null, null, null, null, null)), core["ɵdid"](651, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](652, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Morocco (+212)"])), (_l()(), core["ɵeld"](654, 0, null, null, 3, "option", [["data-countrycode", "MZ"], ["value", "258"]], null, null, null, null, null)), core["ɵdid"](655, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](656, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mozambique (+258)"])), (_l()(), core["ɵeld"](658, 0, null, null, 3, "option", [["data-countrycode", "MN"], ["value", "95"]], null, null, null, null, null)), core["ɵdid"](659, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](660, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Myanmar (+95)"])), (_l()(), core["ɵeld"](662, 0, null, null, 3, "option", [["data-countrycode", "NA"], ["value", "264"]], null, null, null, null, null)), core["ɵdid"](663, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](664, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Namibia (+264)"])), (_l()(), core["ɵeld"](666, 0, null, null, 3, "option", [["data-countrycode", "NR"], ["value", "674"]], null, null, null, null, null)), core["ɵdid"](667, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](668, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Nauru (+674)"])), (_l()(), core["ɵeld"](670, 0, null, null, 3, "option", [["data-countrycode", "NP"], ["value", "977"]], null, null, null, null, null)), core["ɵdid"](671, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](672, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Nepal (+977)"])), (_l()(), core["ɵeld"](674, 0, null, null, 3, "option", [["data-countrycode", "NL"], ["value", "31"]], null, null, null, null, null)), core["ɵdid"](675, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](676, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Netherlands (+31)"])), (_l()(), core["ɵeld"](678, 0, null, null, 3, "option", [["data-countrycode", "ANT"], ["value", "599"]], null, null, null, null, null)), core["ɵdid"](679, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](680, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Netherlands Antilles (+599) "])), (_l()(), core["ɵeld"](682, 0, null, null, 3, "option", [["data-countrycode", "NC"], ["value", "687"]], null, null, null, null, null)), core["ɵdid"](683, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](684, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["New Caledonia (+687)"])), (_l()(), core["ɵeld"](686, 0, null, null, 3, "option", [["data-countrycode", "NZ"], ["value", "64"]], null, null, null, null, null)), core["ɵdid"](687, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](688, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["New Zealand (+64)"])), (_l()(), core["ɵeld"](690, 0, null, null, 3, "option", [["data-countrycode", "NI"], ["value", "505"]], null, null, null, null, null)), core["ɵdid"](691, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](692, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Nicaragua (+505)"])), (_l()(), core["ɵeld"](694, 0, null, null, 3, "option", [["data-countrycode", "NE"], ["value", "227"]], null, null, null, null, null)), core["ɵdid"](695, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](696, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Niger (+227)"])), (_l()(), core["ɵeld"](698, 0, null, null, 3, "option", [["data-countrycode", "NG"], ["value", "234"]], null, null, null, null, null)), core["ɵdid"](699, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](700, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Nigeria (+234)"])), (_l()(), core["ɵeld"](702, 0, null, null, 3, "option", [["data-countrycode", "NU"], ["value", "683"]], null, null, null, null, null)), core["ɵdid"](703, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](704, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Niue (+683)"])), (_l()(), core["ɵeld"](706, 0, null, null, 3, "option", [["data-countrycode", "NF"], ["value", "672"]], null, null, null, null, null)), core["ɵdid"](707, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](708, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Norfolk Islands (+672)"])), (_l()(), core["ɵeld"](710, 0, null, null, 3, "option", [["data-countrycode", "KP"], ["value", "850"]], null, null, null, null, null)), core["ɵdid"](711, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](712, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["North Korea (+850)"])), (_l()(), core["ɵeld"](714, 0, null, null, 3, "option", [["data-countrycode", "NP"], ["value", "670"]], null, null, null, null, null)), core["ɵdid"](715, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](716, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Northern Marianas (+670)"])), (_l()(), core["ɵeld"](718, 0, null, null, 3, "option", [["data-countrycode", "NO"], ["value", "47"]], null, null, null, null, null)), core["ɵdid"](719, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](720, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Norway (+47)"])), (_l()(), core["ɵeld"](722, 0, null, null, 3, "option", [["data-countrycode", "OM"], ["value", "968"]], null, null, null, null, null)), core["ɵdid"](723, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](724, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Oman (+968)"])), (_l()(), core["ɵeld"](726, 0, null, null, 3, "option", [["data-countrycode", "PK"], ["value", "92"]], null, null, null, null, null)), core["ɵdid"](727, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](728, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Pakistan (+92)"])), (_l()(), core["ɵeld"](730, 0, null, null, 3, "option", [["data-countrycode", "PW"], ["value", "680"]], null, null, null, null, null)), core["ɵdid"](731, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](732, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Palau (+680)"])), (_l()(), core["ɵeld"](734, 0, null, null, 3, "option", [["data-countrycode", "PSE"], ["value", "970"]], null, null, null, null, null)), core["ɵdid"](735, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](736, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Palestine (+970)"])), (_l()(), core["ɵeld"](738, 0, null, null, 3, "option", [["data-countrycode", "PA"], ["value", "507"]], null, null, null, null, null)), core["ɵdid"](739, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](740, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Panama (+507)"])), (_l()(), core["ɵeld"](742, 0, null, null, 3, "option", [["data-countrycode", "PG"], ["value", "675"]], null, null, null, null, null)), core["ɵdid"](743, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](744, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Papua New Guinea (+675)"])), (_l()(), core["ɵeld"](746, 0, null, null, 3, "option", [["data-countrycode", "PY"], ["value", "595"]], null, null, null, null, null)), core["ɵdid"](747, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](748, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Paraguay (+595)"])), (_l()(), core["ɵeld"](750, 0, null, null, 3, "option", [["data-countrycode", "PE"], ["value", "51"]], null, null, null, null, null)), core["ɵdid"](751, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](752, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Peru (+51)"])), (_l()(), core["ɵeld"](754, 0, null, null, 3, "option", [["data-countrycode", "PH"], ["value", "63"]], null, null, null, null, null)), core["ɵdid"](755, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](756, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Philippines (+63)"])), (_l()(), core["ɵeld"](758, 0, null, null, 3, "option", [["data-countrycode", "PCN"], ["value", "64"]], null, null, null, null, null)), core["ɵdid"](759, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](760, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Pitcairn (+64)"])), (_l()(), core["ɵeld"](762, 0, null, null, 3, "option", [["data-countrycode", "PL"], ["value", "48"]], null, null, null, null, null)), core["ɵdid"](763, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](764, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Poland (+48)"])), (_l()(), core["ɵeld"](766, 0, null, null, 3, "option", [["data-countrycode", "PT"], ["value", "351"]], null, null, null, null, null)), core["ɵdid"](767, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](768, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Portugal (+351)"])), (_l()(), core["ɵeld"](770, 0, null, null, 3, "option", [["data-countrycode", "PR"], ["value", "1787"]], null, null, null, null, null)), core["ɵdid"](771, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](772, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Puerto Rico (+1787)"])), (_l()(), core["ɵeld"](774, 0, null, null, 3, "option", [["data-countrycode", "QA"], ["value", "974"]], null, null, null, null, null)), core["ɵdid"](775, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](776, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Qatar (+974)"])), (_l()(), core["ɵeld"](778, 0, null, null, 3, "option", [["data-countrycode", "RE"], ["value", "262"]], null, null, null, null, null)), core["ɵdid"](779, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](780, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Reunion (+262)"])), (_l()(), core["ɵeld"](782, 0, null, null, 3, "option", [["data-countrycode", "RO"], ["value", "40"]], null, null, null, null, null)), core["ɵdid"](783, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](784, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Romania (+40)"])), (_l()(), core["ɵeld"](786, 0, null, null, 3, "option", [["data-countrycode", "RU"], ["value", "7"]], null, null, null, null, null)), core["ɵdid"](787, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](788, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Russia (+7)"])), (_l()(), core["ɵeld"](790, 0, null, null, 3, "option", [["data-countrycode", "RW"], ["value", "250"]], null, null, null, null, null)), core["ɵdid"](791, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](792, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Rwanda (+250)"])), (_l()(), core["ɵeld"](794, 0, null, null, 3, "option", [["data-countrycode", "WSM"], ["value", "685"]], null, null, null, null, null)), core["ɵdid"](795, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](796, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Samoa (+685)"])), (_l()(), core["ɵeld"](798, 0, null, null, 3, "option", [["data-countrycode", "SM"], ["value", "378"]], null, null, null, null, null)), core["ɵdid"](799, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](800, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["San Marino (+378)"])), (_l()(), core["ɵeld"](802, 0, null, null, 3, "option", [["data-countrycode", "ST"], ["value", "239"]], null, null, null, null, null)), core["ɵdid"](803, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](804, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sao Tome & Principe (+239) "])), (_l()(), core["ɵeld"](806, 0, null, null, 3, "option", [["data-countrycode", "SA"], ["value", "966"]], null, null, null, null, null)), core["ɵdid"](807, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](808, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Saudi Arabia (+966)"])), (_l()(), core["ɵeld"](810, 0, null, null, 3, "option", [["data-countrycode", "SN"], ["value", "221"]], null, null, null, null, null)), core["ɵdid"](811, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](812, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Senegal (+221)"])), (_l()(), core["ɵeld"](814, 0, null, null, 3, "option", [["data-countrycode", "CS"], ["value", "381"]], null, null, null, null, null)), core["ɵdid"](815, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](816, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Serbia (+381)"])), (_l()(), core["ɵeld"](818, 0, null, null, 3, "option", [["data-countrycode", "SC"], ["value", "248"]], null, null, null, null, null)), core["ɵdid"](819, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](820, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Seychelles (+248)"])), (_l()(), core["ɵeld"](822, 0, null, null, 3, "option", [["data-countrycode", "SL"], ["value", "232"]], null, null, null, null, null)), core["ɵdid"](823, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](824, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sierra Leone (+232)"])), (_l()(), core["ɵeld"](826, 0, null, null, 3, "option", [["data-countrycode", "SXM"], ["value", "1721"]], null, null, null, null, null)), core["ɵdid"](827, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](828, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sint Maarten (+1721)"])), (_l()(), core["ɵeld"](830, 0, null, null, 3, "option", [["data-countrycode", "SK"], ["value", "421"]], null, null, null, null, null)), core["ɵdid"](831, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](832, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Slovak Republic (+421)"])), (_l()(), core["ɵeld"](834, 0, null, null, 3, "option", [["data-countrycode", "SI"], ["value", "386"]], null, null, null, null, null)), core["ɵdid"](835, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](836, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Slovenia (+386)"])), (_l()(), core["ɵeld"](838, 0, null, null, 3, "option", [["data-countrycode", "SB"], ["value", "677"]], null, null, null, null, null)), core["ɵdid"](839, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](840, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Solomon Islands (+677)"])), (_l()(), core["ɵeld"](842, 0, null, null, 3, "option", [["data-countrycode", "SO"], ["value", "252"]], null, null, null, null, null)), core["ɵdid"](843, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](844, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Somalia (+252)"])), (_l()(), core["ɵeld"](846, 0, null, null, 3, "option", [["data-countrycode", "ZA"], ["value", "27"]], null, null, null, null, null)), core["ɵdid"](847, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](848, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["South Africa (+27)"])), (_l()(), core["ɵeld"](850, 0, null, null, 3, "option", [["data-countrycode", "ES"], ["value", "34"]], null, null, null, null, null)), core["ɵdid"](851, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](852, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Spain (+34)"])), (_l()(), core["ɵeld"](854, 0, null, null, 3, "option", [["data-countrycode", "LK"], ["value", "94"]], null, null, null, null, null)), core["ɵdid"](855, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](856, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sri Lanka (+94)"])), (_l()(), core["ɵeld"](858, 0, null, null, 3, "option", [["data-countrycode", "BLM"], ["value", "590"]], null, null, null, null, null)), core["ɵdid"](859, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](860, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St. Barthelemy (+590)"])), (_l()(), core["ɵeld"](862, 0, null, null, 3, "option", [["data-countrycode", "SH"], ["value", "290"]], null, null, null, null, null)), core["ɵdid"](863, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](864, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St. Helena (+290)"])), (_l()(), core["ɵeld"](866, 0, null, null, 3, "option", [["data-countrycode", "KN"], ["value", "1869"]], null, null, null, null, null)), core["ɵdid"](867, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](868, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St. Kitts (+1869)"])), (_l()(), core["ɵeld"](870, 0, null, null, 3, "option", [["data-countrycode", "SC"], ["value", "1758"]], null, null, null, null, null)), core["ɵdid"](871, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](872, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St. Lucia (+1758)"])), (_l()(), core["ɵeld"](874, 0, null, null, 3, "option", [["data-countrycode", "MAF"], ["value", "590"]], null, null, null, null, null)), core["ɵdid"](875, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](876, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St. Martin (+590)"])), (_l()(), core["ɵeld"](878, 0, null, null, 3, "option", [["data-countrycode", "SPM"], ["value", "508"]], null, null, null, null, null)), core["ɵdid"](879, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](880, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St. Pierre and Miquelon (+508) "])), (_l()(), core["ɵeld"](882, 0, null, null, 3, "option", [["data-countrycode", "VCT"], ["value", "1784"]], null, null, null, null, null)), core["ɵdid"](883, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](884, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St. Vincent and the Grenadines (+1784) "])), (_l()(), core["ɵeld"](886, 0, null, null, 3, "option", [["data-countrycode", "SD"], ["value", "249"]], null, null, null, null, null)), core["ɵdid"](887, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](888, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sudan (+249)"])), (_l()(), core["ɵeld"](890, 0, null, null, 3, "option", [["data-countrycode", "SR"], ["value", "597"]], null, null, null, null, null)), core["ɵdid"](891, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](892, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Suriname (+597)"])), (_l()(), core["ɵeld"](894, 0, null, null, 3, "option", [["data-countrycode", "SJM"], ["value", "47"]], null, null, null, null, null)), core["ɵdid"](895, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](896, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Svalbard and Jan Mayen (+47) "])), (_l()(), core["ɵeld"](898, 0, null, null, 3, "option", [["data-countrycode", "SZ"], ["value", "268"]], null, null, null, null, null)), core["ɵdid"](899, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](900, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Swaziland (+268)"])), (_l()(), core["ɵeld"](902, 0, null, null, 3, "option", [["data-countrycode", "SE"], ["value", "46"]], null, null, null, null, null)), core["ɵdid"](903, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](904, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sweden (+46)"])), (_l()(), core["ɵeld"](906, 0, null, null, 3, "option", [["data-countrycode", "CH"], ["value", "41"]], null, null, null, null, null)), core["ɵdid"](907, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](908, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Switzerland (+41)"])), (_l()(), core["ɵeld"](910, 0, null, null, 3, "option", [["data-countrycode", "SI"], ["value", "963"]], null, null, null, null, null)), core["ɵdid"](911, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](912, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Syria (+963)"])), (_l()(), core["ɵeld"](914, 0, null, null, 3, "option", [["data-countrycode", "TW"], ["value", "886"]], null, null, null, null, null)), core["ɵdid"](915, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](916, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Taiwan (+886)"])), (_l()(), core["ɵeld"](918, 0, null, null, 3, "option", [["data-countrycode", "TJ"], ["value", "7"]], null, null, null, null, null)), core["ɵdid"](919, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](920, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tajikstan (+7)"])), (_l()(), core["ɵeld"](922, 0, null, null, 3, "option", [["data-countrycode", "TZA"], ["value", "255"]], null, null, null, null, null)), core["ɵdid"](923, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](924, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tanzania (+255)"])), (_l()(), core["ɵeld"](926, 0, null, null, 3, "option", [["data-countrycode", "TG"], ["value", "228"]], null, null, null, null, null)), core["ɵdid"](927, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](928, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Togo (+228)"])), (_l()(), core["ɵeld"](930, 0, null, null, 3, "option", [["data-countrycode", "TO"], ["value", "676"]], null, null, null, null, null)), core["ɵdid"](931, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](932, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tonga (+676)"])), (_l()(), core["ɵeld"](934, 0, null, null, 3, "option", [["data-countrycode", "TKL"], ["value", "690"]], null, null, null, null, null)), core["ɵdid"](935, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](936, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tokelau (+690)"])), (_l()(), core["ɵeld"](938, 0, null, null, 3, "option", [["data-countrycode", "TT"], ["value", "1868"]], null, null, null, null, null)), core["ɵdid"](939, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](940, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Trinidad & Tobago (+1868) "])), (_l()(), core["ɵeld"](942, 0, null, null, 3, "option", [["data-countrycode", "TN"], ["value", "216"]], null, null, null, null, null)), core["ɵdid"](943, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](944, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tunisia (+216)"])), (_l()(), core["ɵeld"](946, 0, null, null, 3, "option", [["data-countrycode", "TR"], ["value", "90"]], null, null, null, null, null)), core["ɵdid"](947, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](948, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Turkey (+90)"])), (_l()(), core["ɵeld"](950, 0, null, null, 3, "option", [["data-countrycode", "TM"], ["value", "7"]], null, null, null, null, null)), core["ɵdid"](951, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](952, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Turkmenistan (+7)"])), (_l()(), core["ɵeld"](954, 0, null, null, 3, "option", [["data-countrycode", "TM"], ["value", "993"]], null, null, null, null, null)), core["ɵdid"](955, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](956, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Turkmenistan (+993)"])), (_l()(), core["ɵeld"](958, 0, null, null, 3, "option", [["data-countrycode", "TC"], ["value", "1649"]], null, null, null, null, null)), core["ɵdid"](959, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](960, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Turks & Caicos Islands (+1649) "])), (_l()(), core["ɵeld"](962, 0, null, null, 3, "option", [["data-countrycode", "TV"], ["value", "688"]], null, null, null, null, null)), core["ɵdid"](963, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](964, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tuvalu (+688)"])), (_l()(), core["ɵeld"](966, 0, null, null, 3, "option", [["data-countrycode", "UG"], ["value", "256"]], null, null, null, null, null)), core["ɵdid"](967, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](968, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Uganda (+256)"])), (_l()(), core["ɵeld"](970, 0, null, null, 3, "option", [["data-countrycode", "GB"], ["value", "44"]], null, null, null, null, null)), core["ɵdid"](971, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](972, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["UK (+44)"])), (_l()(), core["ɵeld"](974, 0, null, null, 3, "option", [["data-countrycode", "UA"], ["value", "380"]], null, null, null, null, null)), core["ɵdid"](975, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](976, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ukraine (+380)"])), (_l()(), core["ɵeld"](978, 0, null, null, 3, "option", [["data-countrycode", "AE"], ["value", "971"]], null, null, null, null, null)), core["ɵdid"](979, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](980, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["United Arab Emirates (+971) "])), (_l()(), core["ɵeld"](982, 0, null, null, 3, "option", [["data-countrycode", "UY"], ["value", "598"]], null, null, null, null, null)), core["ɵdid"](983, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](984, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Uruguay (+598)"])), (_l()(), core["ɵeld"](986, 0, null, null, 3, "option", [["data-countrycode", "US"], ["value", "1"]], null, null, null, null, null)), core["ɵdid"](987, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](988, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["USA (+1)"])), (_l()(), core["ɵeld"](990, 0, null, null, 3, "option", [["data-countrycode", "UZ"], ["value", "7"]], null, null, null, null, null)), core["ɵdid"](991, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](992, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Uzbekistan (+7)"])), (_l()(), core["ɵeld"](994, 0, null, null, 3, "option", [["data-countrycode", "VU"], ["value", "678"]], null, null, null, null, null)), core["ɵdid"](995, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](996, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Vanuatu (+678)"])), (_l()(), core["ɵeld"](998, 0, null, null, 3, "option", [["data-countrycode", "VA"], ["value", "379"]], null, null, null, null, null)), core["ɵdid"](999, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1000, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Vatican City (+379)"])), (_l()(), core["ɵeld"](1002, 0, null, null, 3, "option", [["data-countrycode", "VE"], ["value", "58"]], null, null, null, null, null)), core["ɵdid"](1003, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1004, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Venezuela (+58)"])), (_l()(), core["ɵeld"](1006, 0, null, null, 3, "option", [["data-countrycode", "VN"], ["value", "84"]], null, null, null, null, null)), core["ɵdid"](1007, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1008, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Vietnam (+84)"])), (_l()(), core["ɵeld"](1010, 0, null, null, 3, "option", [["data-countrycode", "VG"], ["value", "84"]], null, null, null, null, null)), core["ɵdid"](1011, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1012, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Virgin Islands - British (+1284) "])), (_l()(), core["ɵeld"](1014, 0, null, null, 3, "option", [["data-countrycode", "VI"], ["value", "84"]], null, null, null, null, null)), core["ɵdid"](1015, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1016, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Virgin Islands - US (+1340) "])), (_l()(), core["ɵeld"](1018, 0, null, null, 3, "option", [["data-countrycode", "WF"], ["value", "681"]], null, null, null, null, null)), core["ɵdid"](1019, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1020, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Wallis & Futuna (+681) "])), (_l()(), core["ɵeld"](1022, 0, null, null, 3, "option", [["data-countrycode", "ESH"], ["value", "212"]], null, null, null, null, null)), core["ɵdid"](1023, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1024, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Western Sahara (+212)"])), (_l()(), core["ɵeld"](1026, 0, null, null, 3, "option", [["data-countrycode", "YE"], ["value", "969"]], null, null, null, null, null)), core["ɵdid"](1027, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1028, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Yemen (North)(+969)"])), (_l()(), core["ɵeld"](1030, 0, null, null, 3, "option", [["data-countrycode", "YE"], ["value", "967"]], null, null, null, null, null)), core["ɵdid"](1031, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1032, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Yemen (South)(+967)"])), (_l()(), core["ɵeld"](1034, 0, null, null, 3, "option", [["data-countrycode", "ZM"], ["value", "260"]], null, null, null, null, null)), core["ɵdid"](1035, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1036, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Zambia (+260)"])), (_l()(), core["ɵeld"](1038, 0, null, null, 3, "option", [["data-countrycode", "ZW"], ["value", "263"]], null, null, null, null, null)), core["ɵdid"](1039, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](1040, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Zimbabwe (+263)"])), (_l()(), core["ɵeld"](1042, 0, null, null, 9, "div", [["class", "col form-label-group required"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1043, 0, null, null, 8, "input", [["autocomplete", "off"], ["class", "form-control"], ["maxlength", "15"], ["minlength", "7"], ["name", "contactNumber"], ["oninput", "this.value=this.value.replace(/[^\\d]/,'')"], ["placeholder", "Mobile No."], ["type", "tel"], ["value", ""]], [[1, "minlength", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1044)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1044).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1044)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 1044)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co._newMYSJContact = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1044, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](1045, 540672, null, 0, fesm5_forms["MinLengthValidator"], [], { minlength: [0, "minlength"] }, null), core["ɵdid"](1046, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["MinLengthValidator"], fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](1049, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](1051, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = "countryCode"; var currVal_8 = _co._newMYSJCounCode; _ck(_v, 6, 0, currVal_7, currVal_8); var currVal_9 = "60"; _ck(_v, 10, 0, currVal_9); var currVal_10 = "60"; _ck(_v, 11, 0, currVal_10); var currVal_11 = "86"; _ck(_v, 14, 0, currVal_11); var currVal_12 = "86"; _ck(_v, 15, 0, currVal_12); var currVal_13 = "81"; _ck(_v, 18, 0, currVal_13); var currVal_14 = "81"; _ck(_v, 19, 0, currVal_14); var currVal_15 = "82"; _ck(_v, 22, 0, currVal_15); var currVal_16 = "82"; _ck(_v, 23, 0, currVal_16); var currVal_17 = "98"; _ck(_v, 26, 0, currVal_17); var currVal_18 = "98"; _ck(_v, 27, 0, currVal_18); var currVal_19 = "39"; _ck(_v, 30, 0, currVal_19); var currVal_20 = "39"; _ck(_v, 31, 0, currVal_20); var currVal_21 = "65"; _ck(_v, 34, 0, currVal_21); var currVal_22 = "65"; _ck(_v, 35, 0, currVal_22); var currVal_23 = "61"; _ck(_v, 38, 0, currVal_23); var currVal_24 = "61"; _ck(_v, 39, 0, currVal_24); var currVal_25 = "91"; _ck(_v, 42, 0, currVal_25); var currVal_26 = "91"; _ck(_v, 43, 0, currVal_26); var currVal_27 = "66"; _ck(_v, 46, 0, currVal_27); var currVal_28 = "66"; _ck(_v, 47, 0, currVal_28); var currVal_29 = "93"; _ck(_v, 51, 0, currVal_29); var currVal_30 = "93"; _ck(_v, 52, 0, currVal_30); var currVal_31 = "355"; _ck(_v, 55, 0, currVal_31); var currVal_32 = "355"; _ck(_v, 56, 0, currVal_32); var currVal_33 = "213"; _ck(_v, 59, 0, currVal_33); var currVal_34 = "213"; _ck(_v, 60, 0, currVal_34); var currVal_35 = "35818"; _ck(_v, 63, 0, currVal_35); var currVal_36 = "35818"; _ck(_v, 64, 0, currVal_36); var currVal_37 = "684"; _ck(_v, 67, 0, currVal_37); var currVal_38 = "684"; _ck(_v, 68, 0, currVal_38); var currVal_39 = "376"; _ck(_v, 71, 0, currVal_39); var currVal_40 = "376"; _ck(_v, 72, 0, currVal_40); var currVal_41 = "244"; _ck(_v, 75, 0, currVal_41); var currVal_42 = "244"; _ck(_v, 76, 0, currVal_42); var currVal_43 = "1264"; _ck(_v, 79, 0, currVal_43); var currVal_44 = "1264"; _ck(_v, 80, 0, currVal_44); var currVal_45 = "672"; _ck(_v, 83, 0, currVal_45); var currVal_46 = "672"; _ck(_v, 84, 0, currVal_46); var currVal_47 = "1268"; _ck(_v, 87, 0, currVal_47); var currVal_48 = "1268"; _ck(_v, 88, 0, currVal_48); var currVal_49 = "54"; _ck(_v, 91, 0, currVal_49); var currVal_50 = "54"; _ck(_v, 92, 0, currVal_50); var currVal_51 = "374"; _ck(_v, 95, 0, currVal_51); var currVal_52 = "374"; _ck(_v, 96, 0, currVal_52); var currVal_53 = "297"; _ck(_v, 99, 0, currVal_53); var currVal_54 = "297"; _ck(_v, 100, 0, currVal_54); var currVal_55 = "247"; _ck(_v, 103, 0, currVal_55); var currVal_56 = "247"; _ck(_v, 104, 0, currVal_56); var currVal_57 = "43"; _ck(_v, 107, 0, currVal_57); var currVal_58 = "43"; _ck(_v, 108, 0, currVal_58); var currVal_59 = "672"; _ck(_v, 111, 0, currVal_59); var currVal_60 = "672"; _ck(_v, 112, 0, currVal_60); var currVal_61 = "672"; _ck(_v, 115, 0, currVal_61); var currVal_62 = "672"; _ck(_v, 116, 0, currVal_62); var currVal_63 = "994"; _ck(_v, 119, 0, currVal_63); var currVal_64 = "994"; _ck(_v, 120, 0, currVal_64); var currVal_65 = "1242"; _ck(_v, 123, 0, currVal_65); var currVal_66 = "1242"; _ck(_v, 124, 0, currVal_66); var currVal_67 = "973"; _ck(_v, 127, 0, currVal_67); var currVal_68 = "973"; _ck(_v, 128, 0, currVal_68); var currVal_69 = "880"; _ck(_v, 131, 0, currVal_69); var currVal_70 = "880"; _ck(_v, 132, 0, currVal_70); var currVal_71 = "1246"; _ck(_v, 135, 0, currVal_71); var currVal_72 = "1246"; _ck(_v, 136, 0, currVal_72); var currVal_73 = "1268"; _ck(_v, 139, 0, currVal_73); var currVal_74 = "1268"; _ck(_v, 140, 0, currVal_74); var currVal_75 = "375"; _ck(_v, 143, 0, currVal_75); var currVal_76 = "375"; _ck(_v, 144, 0, currVal_76); var currVal_77 = "32"; _ck(_v, 147, 0, currVal_77); var currVal_78 = "32"; _ck(_v, 148, 0, currVal_78); var currVal_79 = "501"; _ck(_v, 151, 0, currVal_79); var currVal_80 = "501"; _ck(_v, 152, 0, currVal_80); var currVal_81 = "229"; _ck(_v, 155, 0, currVal_81); var currVal_82 = "229"; _ck(_v, 156, 0, currVal_82); var currVal_83 = "1441"; _ck(_v, 159, 0, currVal_83); var currVal_84 = "1441"; _ck(_v, 160, 0, currVal_84); var currVal_85 = "975"; _ck(_v, 163, 0, currVal_85); var currVal_86 = "975"; _ck(_v, 164, 0, currVal_86); var currVal_87 = "591"; _ck(_v, 167, 0, currVal_87); var currVal_88 = "591"; _ck(_v, 168, 0, currVal_88); var currVal_89 = "5997"; _ck(_v, 171, 0, currVal_89); var currVal_90 = "5997"; _ck(_v, 172, 0, currVal_90); var currVal_91 = "387"; _ck(_v, 175, 0, currVal_91); var currVal_92 = "387"; _ck(_v, 176, 0, currVal_92); var currVal_93 = "267"; _ck(_v, 179, 0, currVal_93); var currVal_94 = "267"; _ck(_v, 180, 0, currVal_94); var currVal_95 = "55"; _ck(_v, 183, 0, currVal_95); var currVal_96 = "55"; _ck(_v, 184, 0, currVal_96); var currVal_97 = "246"; _ck(_v, 187, 0, currVal_97); var currVal_98 = "246"; _ck(_v, 188, 0, currVal_98); var currVal_99 = "284"; _ck(_v, 191, 0, currVal_99); var currVal_100 = "284"; _ck(_v, 192, 0, currVal_100); var currVal_101 = "673"; _ck(_v, 195, 0, currVal_101); var currVal_102 = "673"; _ck(_v, 196, 0, currVal_102); var currVal_103 = "359"; _ck(_v, 199, 0, currVal_103); var currVal_104 = "359"; _ck(_v, 200, 0, currVal_104); var currVal_105 = "226"; _ck(_v, 203, 0, currVal_105); var currVal_106 = "226"; _ck(_v, 204, 0, currVal_106); var currVal_107 = "257"; _ck(_v, 207, 0, currVal_107); var currVal_108 = "257"; _ck(_v, 208, 0, currVal_108); var currVal_109 = "5993"; _ck(_v, 211, 0, currVal_109); var currVal_110 = "5993"; _ck(_v, 212, 0, currVal_110); var currVal_111 = "855"; _ck(_v, 215, 0, currVal_111); var currVal_112 = "855"; _ck(_v, 216, 0, currVal_112); var currVal_113 = "237"; _ck(_v, 219, 0, currVal_113); var currVal_114 = "237"; _ck(_v, 220, 0, currVal_114); var currVal_115 = "1"; _ck(_v, 223, 0, currVal_115); var currVal_116 = "1"; _ck(_v, 224, 0, currVal_116); var currVal_117 = "238"; _ck(_v, 227, 0, currVal_117); var currVal_118 = "238"; _ck(_v, 228, 0, currVal_118); var currVal_119 = "1345"; _ck(_v, 231, 0, currVal_119); var currVal_120 = "1345"; _ck(_v, 232, 0, currVal_120); var currVal_121 = "243"; _ck(_v, 235, 0, currVal_121); var currVal_122 = "243"; _ck(_v, 236, 0, currVal_122); var currVal_123 = "236"; _ck(_v, 239, 0, currVal_123); var currVal_124 = "236"; _ck(_v, 240, 0, currVal_124); var currVal_125 = "235"; _ck(_v, 243, 0, currVal_125); var currVal_126 = "235"; _ck(_v, 244, 0, currVal_126); var currVal_127 = "56"; _ck(_v, 247, 0, currVal_127); var currVal_128 = "56"; _ck(_v, 248, 0, currVal_128); var currVal_129 = "61"; _ck(_v, 251, 0, currVal_129); var currVal_130 = "61"; _ck(_v, 252, 0, currVal_130); var currVal_131 = "61"; _ck(_v, 255, 0, currVal_131); var currVal_132 = "61"; _ck(_v, 256, 0, currVal_132); var currVal_133 = "57"; _ck(_v, 259, 0, currVal_133); var currVal_134 = "57"; _ck(_v, 260, 0, currVal_134); var currVal_135 = "269"; _ck(_v, 263, 0, currVal_135); var currVal_136 = "269"; _ck(_v, 264, 0, currVal_136); var currVal_137 = "242"; _ck(_v, 267, 0, currVal_137); var currVal_138 = "242"; _ck(_v, 268, 0, currVal_138); var currVal_139 = "682"; _ck(_v, 271, 0, currVal_139); var currVal_140 = "682"; _ck(_v, 272, 0, currVal_140); var currVal_141 = "506"; _ck(_v, 275, 0, currVal_141); var currVal_142 = "506"; _ck(_v, 276, 0, currVal_142); var currVal_143 = "385"; _ck(_v, 279, 0, currVal_143); var currVal_144 = "385"; _ck(_v, 280, 0, currVal_144); var currVal_145 = "53"; _ck(_v, 283, 0, currVal_145); var currVal_146 = "53"; _ck(_v, 284, 0, currVal_146); var currVal_147 = "599"; _ck(_v, 287, 0, currVal_147); var currVal_148 = "599"; _ck(_v, 288, 0, currVal_148); var currVal_149 = "90392"; _ck(_v, 291, 0, currVal_149); var currVal_150 = "90392"; _ck(_v, 292, 0, currVal_150); var currVal_151 = "357"; _ck(_v, 295, 0, currVal_151); var currVal_152 = "357"; _ck(_v, 296, 0, currVal_152); var currVal_153 = "42"; _ck(_v, 299, 0, currVal_153); var currVal_154 = "42"; _ck(_v, 300, 0, currVal_154); var currVal_155 = "246"; _ck(_v, 303, 0, currVal_155); var currVal_156 = "246"; _ck(_v, 304, 0, currVal_156); var currVal_157 = "45"; _ck(_v, 307, 0, currVal_157); var currVal_158 = "45"; _ck(_v, 308, 0, currVal_158); var currVal_159 = "253"; _ck(_v, 311, 0, currVal_159); var currVal_160 = "253"; _ck(_v, 312, 0, currVal_160); var currVal_161 = "1809"; _ck(_v, 315, 0, currVal_161); var currVal_162 = "1809"; _ck(_v, 316, 0, currVal_162); var currVal_163 = "1809"; _ck(_v, 319, 0, currVal_163); var currVal_164 = "1809"; _ck(_v, 320, 0, currVal_164); var currVal_165 = "670"; _ck(_v, 323, 0, currVal_165); var currVal_166 = "670"; _ck(_v, 324, 0, currVal_166); var currVal_167 = "56"; _ck(_v, 327, 0, currVal_167); var currVal_168 = "56"; _ck(_v, 328, 0, currVal_168); var currVal_169 = "593"; _ck(_v, 331, 0, currVal_169); var currVal_170 = "593"; _ck(_v, 332, 0, currVal_170); var currVal_171 = "20"; _ck(_v, 335, 0, currVal_171); var currVal_172 = "20"; _ck(_v, 336, 0, currVal_172); var currVal_173 = "503"; _ck(_v, 339, 0, currVal_173); var currVal_174 = "503"; _ck(_v, 340, 0, currVal_174); var currVal_175 = "240"; _ck(_v, 343, 0, currVal_175); var currVal_176 = "240"; _ck(_v, 344, 0, currVal_176); var currVal_177 = "291"; _ck(_v, 347, 0, currVal_177); var currVal_178 = "291"; _ck(_v, 348, 0, currVal_178); var currVal_179 = "372"; _ck(_v, 351, 0, currVal_179); var currVal_180 = "372"; _ck(_v, 352, 0, currVal_180); var currVal_181 = "251"; _ck(_v, 355, 0, currVal_181); var currVal_182 = "251"; _ck(_v, 356, 0, currVal_182); var currVal_183 = "500"; _ck(_v, 359, 0, currVal_183); var currVal_184 = "500"; _ck(_v, 360, 0, currVal_184); var currVal_185 = "298"; _ck(_v, 363, 0, currVal_185); var currVal_186 = "298"; _ck(_v, 364, 0, currVal_186); var currVal_187 = "679"; _ck(_v, 367, 0, currVal_187); var currVal_188 = "679"; _ck(_v, 368, 0, currVal_188); var currVal_189 = "358"; _ck(_v, 371, 0, currVal_189); var currVal_190 = "358"; _ck(_v, 372, 0, currVal_190); var currVal_191 = "33"; _ck(_v, 375, 0, currVal_191); var currVal_192 = "33"; _ck(_v, 376, 0, currVal_192); var currVal_193 = "596"; _ck(_v, 379, 0, currVal_193); var currVal_194 = "596"; _ck(_v, 380, 0, currVal_194); var currVal_195 = "594"; _ck(_v, 383, 0, currVal_195); var currVal_196 = "594"; _ck(_v, 384, 0, currVal_196); var currVal_197 = "689"; _ck(_v, 387, 0, currVal_197); var currVal_198 = "689"; _ck(_v, 388, 0, currVal_198); var currVal_199 = "241"; _ck(_v, 391, 0, currVal_199); var currVal_200 = "241"; _ck(_v, 392, 0, currVal_200); var currVal_201 = "220"; _ck(_v, 395, 0, currVal_201); var currVal_202 = "220"; _ck(_v, 396, 0, currVal_202); var currVal_203 = "7880"; _ck(_v, 399, 0, currVal_203); var currVal_204 = "7880"; _ck(_v, 400, 0, currVal_204); var currVal_205 = "49"; _ck(_v, 403, 0, currVal_205); var currVal_206 = "49"; _ck(_v, 404, 0, currVal_206); var currVal_207 = "233"; _ck(_v, 407, 0, currVal_207); var currVal_208 = "233"; _ck(_v, 408, 0, currVal_208); var currVal_209 = "350"; _ck(_v, 411, 0, currVal_209); var currVal_210 = "350"; _ck(_v, 412, 0, currVal_210); var currVal_211 = "30"; _ck(_v, 415, 0, currVal_211); var currVal_212 = "30"; _ck(_v, 416, 0, currVal_212); var currVal_213 = "299"; _ck(_v, 419, 0, currVal_213); var currVal_214 = "299"; _ck(_v, 420, 0, currVal_214); var currVal_215 = "1473"; _ck(_v, 423, 0, currVal_215); var currVal_216 = "1473"; _ck(_v, 424, 0, currVal_216); var currVal_217 = "590"; _ck(_v, 427, 0, currVal_217); var currVal_218 = "590"; _ck(_v, 428, 0, currVal_218); var currVal_219 = "671"; _ck(_v, 431, 0, currVal_219); var currVal_220 = "671"; _ck(_v, 432, 0, currVal_220); var currVal_221 = "502"; _ck(_v, 435, 0, currVal_221); var currVal_222 = "502"; _ck(_v, 436, 0, currVal_222); var currVal_223 = "44"; _ck(_v, 439, 0, currVal_223); var currVal_224 = "44"; _ck(_v, 440, 0, currVal_224); var currVal_225 = "224"; _ck(_v, 443, 0, currVal_225); var currVal_226 = "224"; _ck(_v, 444, 0, currVal_226); var currVal_227 = "245"; _ck(_v, 447, 0, currVal_227); var currVal_228 = "245"; _ck(_v, 448, 0, currVal_228); var currVal_229 = "592"; _ck(_v, 451, 0, currVal_229); var currVal_230 = "592"; _ck(_v, 452, 0, currVal_230); var currVal_231 = "509"; _ck(_v, 455, 0, currVal_231); var currVal_232 = "509"; _ck(_v, 456, 0, currVal_232); var currVal_233 = "504"; _ck(_v, 459, 0, currVal_233); var currVal_234 = "504"; _ck(_v, 460, 0, currVal_234); var currVal_235 = "852"; _ck(_v, 463, 0, currVal_235); var currVal_236 = "852"; _ck(_v, 464, 0, currVal_236); var currVal_237 = "36"; _ck(_v, 467, 0, currVal_237); var currVal_238 = "36"; _ck(_v, 468, 0, currVal_238); var currVal_239 = "354"; _ck(_v, 471, 0, currVal_239); var currVal_240 = "354"; _ck(_v, 472, 0, currVal_240); var currVal_241 = "62"; _ck(_v, 475, 0, currVal_241); var currVal_242 = "62"; _ck(_v, 476, 0, currVal_242); var currVal_243 = "964"; _ck(_v, 479, 0, currVal_243); var currVal_244 = "964"; _ck(_v, 480, 0, currVal_244); var currVal_245 = "353"; _ck(_v, 483, 0, currVal_245); var currVal_246 = "353"; _ck(_v, 484, 0, currVal_246); var currVal_247 = "44"; _ck(_v, 487, 0, currVal_247); var currVal_248 = "44"; _ck(_v, 488, 0, currVal_248); var currVal_249 = "972"; _ck(_v, 491, 0, currVal_249); var currVal_250 = "972"; _ck(_v, 492, 0, currVal_250); var currVal_251 = "225"; _ck(_v, 495, 0, currVal_251); var currVal_252 = "225"; _ck(_v, 496, 0, currVal_252); var currVal_253 = "1876"; _ck(_v, 499, 0, currVal_253); var currVal_254 = "1876"; _ck(_v, 500, 0, currVal_254); var currVal_255 = "44"; _ck(_v, 503, 0, currVal_255); var currVal_256 = "44"; _ck(_v, 504, 0, currVal_256); var currVal_257 = "962"; _ck(_v, 507, 0, currVal_257); var currVal_258 = "962"; _ck(_v, 508, 0, currVal_258); var currVal_259 = "7"; _ck(_v, 511, 0, currVal_259); var currVal_260 = "7"; _ck(_v, 512, 0, currVal_260); var currVal_261 = "254"; _ck(_v, 515, 0, currVal_261); var currVal_262 = "254"; _ck(_v, 516, 0, currVal_262); var currVal_263 = "686"; _ck(_v, 519, 0, currVal_263); var currVal_264 = "686"; _ck(_v, 520, 0, currVal_264); var currVal_265 = "383"; _ck(_v, 523, 0, currVal_265); var currVal_266 = "383"; _ck(_v, 524, 0, currVal_266); var currVal_267 = "965"; _ck(_v, 527, 0, currVal_267); var currVal_268 = "965"; _ck(_v, 528, 0, currVal_268); var currVal_269 = "996"; _ck(_v, 531, 0, currVal_269); var currVal_270 = "996"; _ck(_v, 532, 0, currVal_270); var currVal_271 = "856"; _ck(_v, 535, 0, currVal_271); var currVal_272 = "856"; _ck(_v, 536, 0, currVal_272); var currVal_273 = "371"; _ck(_v, 539, 0, currVal_273); var currVal_274 = "371"; _ck(_v, 540, 0, currVal_274); var currVal_275 = "961"; _ck(_v, 543, 0, currVal_275); var currVal_276 = "961"; _ck(_v, 544, 0, currVal_276); var currVal_277 = "266"; _ck(_v, 547, 0, currVal_277); var currVal_278 = "266"; _ck(_v, 548, 0, currVal_278); var currVal_279 = "231"; _ck(_v, 551, 0, currVal_279); var currVal_280 = "231"; _ck(_v, 552, 0, currVal_280); var currVal_281 = "218"; _ck(_v, 555, 0, currVal_281); var currVal_282 = "218"; _ck(_v, 556, 0, currVal_282); var currVal_283 = "417"; _ck(_v, 559, 0, currVal_283); var currVal_284 = "417"; _ck(_v, 560, 0, currVal_284); var currVal_285 = "370"; _ck(_v, 563, 0, currVal_285); var currVal_286 = "370"; _ck(_v, 564, 0, currVal_286); var currVal_287 = "352"; _ck(_v, 567, 0, currVal_287); var currVal_288 = "352"; _ck(_v, 568, 0, currVal_288); var currVal_289 = "853"; _ck(_v, 571, 0, currVal_289); var currVal_290 = "853"; _ck(_v, 572, 0, currVal_290); var currVal_291 = "389"; _ck(_v, 575, 0, currVal_291); var currVal_292 = "389"; _ck(_v, 576, 0, currVal_292); var currVal_293 = "261"; _ck(_v, 579, 0, currVal_293); var currVal_294 = "261"; _ck(_v, 580, 0, currVal_294); var currVal_295 = "265"; _ck(_v, 583, 0, currVal_295); var currVal_296 = "265"; _ck(_v, 584, 0, currVal_296); var currVal_297 = "60"; _ck(_v, 587, 0, currVal_297); var currVal_298 = "60"; _ck(_v, 588, 0, currVal_298); var currVal_299 = "960"; _ck(_v, 591, 0, currVal_299); var currVal_300 = "960"; _ck(_v, 592, 0, currVal_300); var currVal_301 = "223"; _ck(_v, 595, 0, currVal_301); var currVal_302 = "223"; _ck(_v, 596, 0, currVal_302); var currVal_303 = "356"; _ck(_v, 599, 0, currVal_303); var currVal_304 = "356"; _ck(_v, 600, 0, currVal_304); var currVal_305 = "692"; _ck(_v, 603, 0, currVal_305); var currVal_306 = "692"; _ck(_v, 604, 0, currVal_306); var currVal_307 = "596"; _ck(_v, 607, 0, currVal_307); var currVal_308 = "596"; _ck(_v, 608, 0, currVal_308); var currVal_309 = "222"; _ck(_v, 611, 0, currVal_309); var currVal_310 = "222"; _ck(_v, 612, 0, currVal_310); var currVal_311 = "230"; _ck(_v, 615, 0, currVal_311); var currVal_312 = "230"; _ck(_v, 616, 0, currVal_312); var currVal_313 = "269"; _ck(_v, 619, 0, currVal_313); var currVal_314 = "269"; _ck(_v, 620, 0, currVal_314); var currVal_315 = "52"; _ck(_v, 623, 0, currVal_315); var currVal_316 = "52"; _ck(_v, 624, 0, currVal_316); var currVal_317 = "691"; _ck(_v, 627, 0, currVal_317); var currVal_318 = "691"; _ck(_v, 628, 0, currVal_318); var currVal_319 = "373"; _ck(_v, 631, 0, currVal_319); var currVal_320 = "373"; _ck(_v, 632, 0, currVal_320); var currVal_321 = "377"; _ck(_v, 635, 0, currVal_321); var currVal_322 = "377"; _ck(_v, 636, 0, currVal_322); var currVal_323 = "976"; _ck(_v, 639, 0, currVal_323); var currVal_324 = "976"; _ck(_v, 640, 0, currVal_324); var currVal_325 = "1664"; _ck(_v, 643, 0, currVal_325); var currVal_326 = "1664"; _ck(_v, 644, 0, currVal_326); var currVal_327 = "382"; _ck(_v, 647, 0, currVal_327); var currVal_328 = "382"; _ck(_v, 648, 0, currVal_328); var currVal_329 = "212"; _ck(_v, 651, 0, currVal_329); var currVal_330 = "212"; _ck(_v, 652, 0, currVal_330); var currVal_331 = "258"; _ck(_v, 655, 0, currVal_331); var currVal_332 = "258"; _ck(_v, 656, 0, currVal_332); var currVal_333 = "95"; _ck(_v, 659, 0, currVal_333); var currVal_334 = "95"; _ck(_v, 660, 0, currVal_334); var currVal_335 = "264"; _ck(_v, 663, 0, currVal_335); var currVal_336 = "264"; _ck(_v, 664, 0, currVal_336); var currVal_337 = "674"; _ck(_v, 667, 0, currVal_337); var currVal_338 = "674"; _ck(_v, 668, 0, currVal_338); var currVal_339 = "977"; _ck(_v, 671, 0, currVal_339); var currVal_340 = "977"; _ck(_v, 672, 0, currVal_340); var currVal_341 = "31"; _ck(_v, 675, 0, currVal_341); var currVal_342 = "31"; _ck(_v, 676, 0, currVal_342); var currVal_343 = "599"; _ck(_v, 679, 0, currVal_343); var currVal_344 = "599"; _ck(_v, 680, 0, currVal_344); var currVal_345 = "687"; _ck(_v, 683, 0, currVal_345); var currVal_346 = "687"; _ck(_v, 684, 0, currVal_346); var currVal_347 = "64"; _ck(_v, 687, 0, currVal_347); var currVal_348 = "64"; _ck(_v, 688, 0, currVal_348); var currVal_349 = "505"; _ck(_v, 691, 0, currVal_349); var currVal_350 = "505"; _ck(_v, 692, 0, currVal_350); var currVal_351 = "227"; _ck(_v, 695, 0, currVal_351); var currVal_352 = "227"; _ck(_v, 696, 0, currVal_352); var currVal_353 = "234"; _ck(_v, 699, 0, currVal_353); var currVal_354 = "234"; _ck(_v, 700, 0, currVal_354); var currVal_355 = "683"; _ck(_v, 703, 0, currVal_355); var currVal_356 = "683"; _ck(_v, 704, 0, currVal_356); var currVal_357 = "672"; _ck(_v, 707, 0, currVal_357); var currVal_358 = "672"; _ck(_v, 708, 0, currVal_358); var currVal_359 = "850"; _ck(_v, 711, 0, currVal_359); var currVal_360 = "850"; _ck(_v, 712, 0, currVal_360); var currVal_361 = "670"; _ck(_v, 715, 0, currVal_361); var currVal_362 = "670"; _ck(_v, 716, 0, currVal_362); var currVal_363 = "47"; _ck(_v, 719, 0, currVal_363); var currVal_364 = "47"; _ck(_v, 720, 0, currVal_364); var currVal_365 = "968"; _ck(_v, 723, 0, currVal_365); var currVal_366 = "968"; _ck(_v, 724, 0, currVal_366); var currVal_367 = "92"; _ck(_v, 727, 0, currVal_367); var currVal_368 = "92"; _ck(_v, 728, 0, currVal_368); var currVal_369 = "680"; _ck(_v, 731, 0, currVal_369); var currVal_370 = "680"; _ck(_v, 732, 0, currVal_370); var currVal_371 = "970"; _ck(_v, 735, 0, currVal_371); var currVal_372 = "970"; _ck(_v, 736, 0, currVal_372); var currVal_373 = "507"; _ck(_v, 739, 0, currVal_373); var currVal_374 = "507"; _ck(_v, 740, 0, currVal_374); var currVal_375 = "675"; _ck(_v, 743, 0, currVal_375); var currVal_376 = "675"; _ck(_v, 744, 0, currVal_376); var currVal_377 = "595"; _ck(_v, 747, 0, currVal_377); var currVal_378 = "595"; _ck(_v, 748, 0, currVal_378); var currVal_379 = "51"; _ck(_v, 751, 0, currVal_379); var currVal_380 = "51"; _ck(_v, 752, 0, currVal_380); var currVal_381 = "63"; _ck(_v, 755, 0, currVal_381); var currVal_382 = "63"; _ck(_v, 756, 0, currVal_382); var currVal_383 = "64"; _ck(_v, 759, 0, currVal_383); var currVal_384 = "64"; _ck(_v, 760, 0, currVal_384); var currVal_385 = "48"; _ck(_v, 763, 0, currVal_385); var currVal_386 = "48"; _ck(_v, 764, 0, currVal_386); var currVal_387 = "351"; _ck(_v, 767, 0, currVal_387); var currVal_388 = "351"; _ck(_v, 768, 0, currVal_388); var currVal_389 = "1787"; _ck(_v, 771, 0, currVal_389); var currVal_390 = "1787"; _ck(_v, 772, 0, currVal_390); var currVal_391 = "974"; _ck(_v, 775, 0, currVal_391); var currVal_392 = "974"; _ck(_v, 776, 0, currVal_392); var currVal_393 = "262"; _ck(_v, 779, 0, currVal_393); var currVal_394 = "262"; _ck(_v, 780, 0, currVal_394); var currVal_395 = "40"; _ck(_v, 783, 0, currVal_395); var currVal_396 = "40"; _ck(_v, 784, 0, currVal_396); var currVal_397 = "7"; _ck(_v, 787, 0, currVal_397); var currVal_398 = "7"; _ck(_v, 788, 0, currVal_398); var currVal_399 = "250"; _ck(_v, 791, 0, currVal_399); var currVal_400 = "250"; _ck(_v, 792, 0, currVal_400); var currVal_401 = "685"; _ck(_v, 795, 0, currVal_401); var currVal_402 = "685"; _ck(_v, 796, 0, currVal_402); var currVal_403 = "378"; _ck(_v, 799, 0, currVal_403); var currVal_404 = "378"; _ck(_v, 800, 0, currVal_404); var currVal_405 = "239"; _ck(_v, 803, 0, currVal_405); var currVal_406 = "239"; _ck(_v, 804, 0, currVal_406); var currVal_407 = "966"; _ck(_v, 807, 0, currVal_407); var currVal_408 = "966"; _ck(_v, 808, 0, currVal_408); var currVal_409 = "221"; _ck(_v, 811, 0, currVal_409); var currVal_410 = "221"; _ck(_v, 812, 0, currVal_410); var currVal_411 = "381"; _ck(_v, 815, 0, currVal_411); var currVal_412 = "381"; _ck(_v, 816, 0, currVal_412); var currVal_413 = "248"; _ck(_v, 819, 0, currVal_413); var currVal_414 = "248"; _ck(_v, 820, 0, currVal_414); var currVal_415 = "232"; _ck(_v, 823, 0, currVal_415); var currVal_416 = "232"; _ck(_v, 824, 0, currVal_416); var currVal_417 = "1721"; _ck(_v, 827, 0, currVal_417); var currVal_418 = "1721"; _ck(_v, 828, 0, currVal_418); var currVal_419 = "421"; _ck(_v, 831, 0, currVal_419); var currVal_420 = "421"; _ck(_v, 832, 0, currVal_420); var currVal_421 = "386"; _ck(_v, 835, 0, currVal_421); var currVal_422 = "386"; _ck(_v, 836, 0, currVal_422); var currVal_423 = "677"; _ck(_v, 839, 0, currVal_423); var currVal_424 = "677"; _ck(_v, 840, 0, currVal_424); var currVal_425 = "252"; _ck(_v, 843, 0, currVal_425); var currVal_426 = "252"; _ck(_v, 844, 0, currVal_426); var currVal_427 = "27"; _ck(_v, 847, 0, currVal_427); var currVal_428 = "27"; _ck(_v, 848, 0, currVal_428); var currVal_429 = "34"; _ck(_v, 851, 0, currVal_429); var currVal_430 = "34"; _ck(_v, 852, 0, currVal_430); var currVal_431 = "94"; _ck(_v, 855, 0, currVal_431); var currVal_432 = "94"; _ck(_v, 856, 0, currVal_432); var currVal_433 = "590"; _ck(_v, 859, 0, currVal_433); var currVal_434 = "590"; _ck(_v, 860, 0, currVal_434); var currVal_435 = "290"; _ck(_v, 863, 0, currVal_435); var currVal_436 = "290"; _ck(_v, 864, 0, currVal_436); var currVal_437 = "1869"; _ck(_v, 867, 0, currVal_437); var currVal_438 = "1869"; _ck(_v, 868, 0, currVal_438); var currVal_439 = "1758"; _ck(_v, 871, 0, currVal_439); var currVal_440 = "1758"; _ck(_v, 872, 0, currVal_440); var currVal_441 = "590"; _ck(_v, 875, 0, currVal_441); var currVal_442 = "590"; _ck(_v, 876, 0, currVal_442); var currVal_443 = "508"; _ck(_v, 879, 0, currVal_443); var currVal_444 = "508"; _ck(_v, 880, 0, currVal_444); var currVal_445 = "1784"; _ck(_v, 883, 0, currVal_445); var currVal_446 = "1784"; _ck(_v, 884, 0, currVal_446); var currVal_447 = "249"; _ck(_v, 887, 0, currVal_447); var currVal_448 = "249"; _ck(_v, 888, 0, currVal_448); var currVal_449 = "597"; _ck(_v, 891, 0, currVal_449); var currVal_450 = "597"; _ck(_v, 892, 0, currVal_450); var currVal_451 = "47"; _ck(_v, 895, 0, currVal_451); var currVal_452 = "47"; _ck(_v, 896, 0, currVal_452); var currVal_453 = "268"; _ck(_v, 899, 0, currVal_453); var currVal_454 = "268"; _ck(_v, 900, 0, currVal_454); var currVal_455 = "46"; _ck(_v, 903, 0, currVal_455); var currVal_456 = "46"; _ck(_v, 904, 0, currVal_456); var currVal_457 = "41"; _ck(_v, 907, 0, currVal_457); var currVal_458 = "41"; _ck(_v, 908, 0, currVal_458); var currVal_459 = "963"; _ck(_v, 911, 0, currVal_459); var currVal_460 = "963"; _ck(_v, 912, 0, currVal_460); var currVal_461 = "886"; _ck(_v, 915, 0, currVal_461); var currVal_462 = "886"; _ck(_v, 916, 0, currVal_462); var currVal_463 = "7"; _ck(_v, 919, 0, currVal_463); var currVal_464 = "7"; _ck(_v, 920, 0, currVal_464); var currVal_465 = "255"; _ck(_v, 923, 0, currVal_465); var currVal_466 = "255"; _ck(_v, 924, 0, currVal_466); var currVal_467 = "228"; _ck(_v, 927, 0, currVal_467); var currVal_468 = "228"; _ck(_v, 928, 0, currVal_468); var currVal_469 = "676"; _ck(_v, 931, 0, currVal_469); var currVal_470 = "676"; _ck(_v, 932, 0, currVal_470); var currVal_471 = "690"; _ck(_v, 935, 0, currVal_471); var currVal_472 = "690"; _ck(_v, 936, 0, currVal_472); var currVal_473 = "1868"; _ck(_v, 939, 0, currVal_473); var currVal_474 = "1868"; _ck(_v, 940, 0, currVal_474); var currVal_475 = "216"; _ck(_v, 943, 0, currVal_475); var currVal_476 = "216"; _ck(_v, 944, 0, currVal_476); var currVal_477 = "90"; _ck(_v, 947, 0, currVal_477); var currVal_478 = "90"; _ck(_v, 948, 0, currVal_478); var currVal_479 = "7"; _ck(_v, 951, 0, currVal_479); var currVal_480 = "7"; _ck(_v, 952, 0, currVal_480); var currVal_481 = "993"; _ck(_v, 955, 0, currVal_481); var currVal_482 = "993"; _ck(_v, 956, 0, currVal_482); var currVal_483 = "1649"; _ck(_v, 959, 0, currVal_483); var currVal_484 = "1649"; _ck(_v, 960, 0, currVal_484); var currVal_485 = "688"; _ck(_v, 963, 0, currVal_485); var currVal_486 = "688"; _ck(_v, 964, 0, currVal_486); var currVal_487 = "256"; _ck(_v, 967, 0, currVal_487); var currVal_488 = "256"; _ck(_v, 968, 0, currVal_488); var currVal_489 = "44"; _ck(_v, 971, 0, currVal_489); var currVal_490 = "44"; _ck(_v, 972, 0, currVal_490); var currVal_491 = "380"; _ck(_v, 975, 0, currVal_491); var currVal_492 = "380"; _ck(_v, 976, 0, currVal_492); var currVal_493 = "971"; _ck(_v, 979, 0, currVal_493); var currVal_494 = "971"; _ck(_v, 980, 0, currVal_494); var currVal_495 = "598"; _ck(_v, 983, 0, currVal_495); var currVal_496 = "598"; _ck(_v, 984, 0, currVal_496); var currVal_497 = "1"; _ck(_v, 987, 0, currVal_497); var currVal_498 = "1"; _ck(_v, 988, 0, currVal_498); var currVal_499 = "7"; _ck(_v, 991, 0, currVal_499); var currVal_500 = "7"; _ck(_v, 992, 0, currVal_500); var currVal_501 = "678"; _ck(_v, 995, 0, currVal_501); var currVal_502 = "678"; _ck(_v, 996, 0, currVal_502); var currVal_503 = "379"; _ck(_v, 999, 0, currVal_503); var currVal_504 = "379"; _ck(_v, 1000, 0, currVal_504); var currVal_505 = "58"; _ck(_v, 1003, 0, currVal_505); var currVal_506 = "58"; _ck(_v, 1004, 0, currVal_506); var currVal_507 = "84"; _ck(_v, 1007, 0, currVal_507); var currVal_508 = "84"; _ck(_v, 1008, 0, currVal_508); var currVal_509 = "84"; _ck(_v, 1011, 0, currVal_509); var currVal_510 = "84"; _ck(_v, 1012, 0, currVal_510); var currVal_511 = "84"; _ck(_v, 1015, 0, currVal_511); var currVal_512 = "84"; _ck(_v, 1016, 0, currVal_512); var currVal_513 = "681"; _ck(_v, 1019, 0, currVal_513); var currVal_514 = "681"; _ck(_v, 1020, 0, currVal_514); var currVal_515 = "212"; _ck(_v, 1023, 0, currVal_515); var currVal_516 = "212"; _ck(_v, 1024, 0, currVal_516); var currVal_517 = "969"; _ck(_v, 1027, 0, currVal_517); var currVal_518 = "969"; _ck(_v, 1028, 0, currVal_518); var currVal_519 = "967"; _ck(_v, 1031, 0, currVal_519); var currVal_520 = "967"; _ck(_v, 1032, 0, currVal_520); var currVal_521 = "260"; _ck(_v, 1035, 0, currVal_521); var currVal_522 = "260"; _ck(_v, 1036, 0, currVal_522); var currVal_523 = "263"; _ck(_v, 1039, 0, currVal_523); var currVal_524 = "263"; _ck(_v, 1040, 0, currVal_524); var currVal_534 = "7"; _ck(_v, 1045, 0, currVal_534); var currVal_535 = "15"; _ck(_v, 1046, 0, currVal_535); var currVal_536 = "contactNumber"; var currVal_537 = _co._newMYSJContact; _ck(_v, 1049, 0, currVal_536, currVal_537); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 8).ngClassValid; var currVal_5 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_525 = (core["ɵnov"](_v, 1045).minlength ? core["ɵnov"](_v, 1045).minlength : null); var currVal_526 = (core["ɵnov"](_v, 1046).maxlength ? core["ɵnov"](_v, 1046).maxlength : null); var currVal_527 = core["ɵnov"](_v, 1051).ngClassUntouched; var currVal_528 = core["ɵnov"](_v, 1051).ngClassTouched; var currVal_529 = core["ɵnov"](_v, 1051).ngClassPristine; var currVal_530 = core["ɵnov"](_v, 1051).ngClassDirty; var currVal_531 = core["ɵnov"](_v, 1051).ngClassValid; var currVal_532 = core["ɵnov"](_v, 1051).ngClassInvalid; var currVal_533 = core["ɵnov"](_v, 1051).ngClassPending; _ck(_v, 1043, 0, currVal_525, currVal_526, currVal_527, currVal_528, currVal_529, currVal_530, currVal_531, currVal_532, currVal_533); });
}
function View_EmployeesListingPage_39(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "input", [["id", "email"], ["name", "email"], ["ng-reflect-model", "1"], ["placeholder", "Email"], ["size", "50"], ["type", "email"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 2)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 2)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co._newMYSJEmail = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = "email"; var currVal_8 = _co._newMYSJEmail; _ck(_v, 4, 0, currVal_7, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 6).ngClassValid; var currVal_5 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_EmployeesListingPage_37(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 28, "div", [["id", "divdata"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Change MySJ ID\u200B"])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeRoleModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 16, "div", [["class", "w-100 float-left modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 4, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ng-reflect-ngb-tooltip", "Current MySJ ID"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Current MySJ ID: "])), (_l()(), core["ɵeld"](12, 0, null, null, 1, "div", [["class", "col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"], ["id", "currentMYSJId"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), (_l()(), core["ɵeld"](14, 0, null, null, 6, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"], ["ng-reflect-ngb-tooltip", "New MySJ ID"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" New MySJ ID: "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_38)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_39)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](21, 0, null, null, 2, "div", [["class", "w-100 float-left"], ["style", "text-align: center;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate text-primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleIdType() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](23, null, [" ", " "])), (_l()(), core["ɵeld"](24, 0, null, null, 4, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 1, "button", [["class", "btn btn-secondary"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeRoleModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Cancel"])), (_l()(), core["ɵeld"](27, 0, null, null, 1, "button", [["class", "btn btn-primary"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeMYSJId(_co.confirmationModal) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Confirm"]))], function (_ck, _v) { var _co = _v.component; var currVal_1 = (_co._newMYSJType == 1); _ck(_v, 18, 0, currVal_1); var currVal_2 = (_co._newMYSJType == 2); _ck(_v, 20, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co._activeEmployee ? _co._activeEmployee.userName : "-"); _ck(_v, 13, 0, currVal_0); var currVal_3 = ((_co._newMYSJType == 2) ? "New MySJ ID is a phone number\u200B" : "New MySJ ID is an Email"); _ck(_v, 23, 0, currVal_3); });
}
function View_EmployeesListingPage_41(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "]))], function (_ck, _v) { var currVal_1 = _v.context.$implicit.orgUnitCode; _ck(_v, 1, 0, currVal_1); var currVal_2 = _v.context.$implicit.orgUnitCode; _ck(_v, 2, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co._activeEmployee.orgCode == _v.context.$implicit.orgUnitCode); _ck(_v, 0, 0, currVal_0); var currVal_3 = _v.context.$implicit.orgName; _ck(_v, 3, 0, currVal_3); }); }
function View_EmployeesListingPage_40(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 996, "div", [["id", "divdata"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit Employee\u200B"])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeRoleModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 984, "div", [["class", "w-100 float-left modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 983, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 17, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "div", [["class", "col-lg-3 float-left text-right"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Date of birth: "])), (_l()(), core["ɵeld"](12, 0, null, null, 14, "div", [["class", "col-lg-8  float-left"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 13, "div", [["class", "w-100 float-left relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 16777216, null, null, 10, "input", [["class", "form-control"], ["name", "dateOfBirth"], ["ngbDatepicker", ""], ["placeholder", "YYYY-MM-DD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "change"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 18).manualDateChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("change" === en)) {
                var pd_1 = (core["ɵnov"](_v, 18).manualDateChange($event.target.value, true) !== false);
                ad = (pd_1 && ad);
            }
            if (("blur" === en)) {
                var pd_2 = (core["ɵnov"](_v, 18).onBlur() !== false);
                ad = (pd_2 && ad);
            }
            if (("input" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("blur" === en)) {
                var pd_4 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_4 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_5 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_5 && ad);
            }
            if (("compositionend" === en)) {
                var pd_6 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co._activeEmployee.dateOfBirth = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](15, 278528, null, 0, common["NgStyle"], [core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngStyle: [0, "ngStyle"] }, null), core["ɵpod"](16, { "background-color": 0 }), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](18, 671744, [["dob", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], null, null), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](22, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](24, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](25, 0, null, null, 1, "button", [["class", "iga-right"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                core["ɵnov"](_v, 18).toggle();
                var pd_0 = (_co.openDatePicker(core["ɵnov"](_v, 18)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 9, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "div", [["class", "col-lg-3 float-left text-right"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Passport: "])), (_l()(), core["ɵeld"](30, 0, null, null, 6, "div", [["class", "col-lg-8  float-left"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 5, "input", [["class", "form-control"], ["id", "passportNumber"], ["name", "passportNumber"], ["ng-reflect-model", "1"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 32)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 32).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 32)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 32)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co._activeEmployee.passportNumber = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](32, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](34, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], isDisabled: [1, "isDisabled"], model: [2, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](36, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](37, 0, null, null, 10, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 1, "div", [["class", "col-lg-3 float-left text-right"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Address: "])), (_l()(), core["ɵeld"](40, 0, null, null, 7, "div", [["class", "col-lg-8  float-left"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 6, "textarea", [["class", "form-control"], ["cols", "70"], ["id", "address"], ["name", "address"], ["ng-reflect-model", "1"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 42)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 42).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 42)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 42)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co._activeEmployee.address = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](42, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](44, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](46, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵted"](-1, null, ["                        "])), (_l()(), core["ɵeld"](48, 0, null, null, 9, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](49, 0, null, null, 1, "div", [["class", "col-lg-3 float-left text-right"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Area: "])), (_l()(), core["ɵeld"](51, 0, null, null, 6, "div", [["class", "col-lg-8  float-left"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](52, 0, null, null, 5, "input", [["class", "form-control"], ["id", "postcode"], ["name", "postcode"], ["ng-reflect-model", "1"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 53)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 53).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 53)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 53)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co._activeEmployee.postcode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](53, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](55, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](57, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](58, 0, null, null, 11, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 1, "div", [["class", "col-lg-3 float-left text-right"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" State: "])), (_l()(), core["ɵeld"](61, 0, null, null, 8, "div", [["class", "col-lg-8  float-left"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](62, 0, null, null, 7, "select", [["class", "form-control custom-select"], ["id", "state"], ["name", "state"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 63).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 63).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co._activeEmployee.orgCode = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](63, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](65, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](67, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_41)), core["ɵdid"](69, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](70, 0, null, null, 909, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 1, "div", [["class", "col-lg-3 float-left text-right"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Nationality: "])), (_l()(), core["ɵeld"](73, 0, null, null, 906, "div", [["class", "col-lg-8  float-left"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](74, 0, null, null, 905, "select", [["class", "form-control custom-select"], ["id", "nationality"], ["name", "nationality"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 75).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 75).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co._activeEmployee.nationality = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onNationalityChange() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](75, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](77, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](79, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](80, 0, null, null, 3, "option", [["value", "Malaysian"]], null, null, null, null, null)), core["ɵdid"](81, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](82, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Malaysian"])), (_l()(), core["ɵeld"](84, 0, null, null, 3, "option", [["value", "Afghan"]], null, null, null, null, null)), core["ɵdid"](85, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](86, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Afghan"])), (_l()(), core["ɵeld"](88, 0, null, null, 3, "option", [["value", "Albanian"]], null, null, null, null, null)), core["ɵdid"](89, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](90, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Albanian"])), (_l()(), core["ɵeld"](92, 0, null, null, 3, "option", [["value", "Algerian"]], null, null, null, null, null)), core["ɵdid"](93, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](94, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Algerian"])), (_l()(), core["ɵeld"](96, 0, null, null, 3, "option", [["value", "American"]], null, null, null, null, null)), core["ɵdid"](97, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](98, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["American"])), (_l()(), core["ɵeld"](100, 0, null, null, 3, "option", [["value", "Andorran"]], null, null, null, null, null)), core["ɵdid"](101, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](102, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Andorran"])), (_l()(), core["ɵeld"](104, 0, null, null, 3, "option", [["value", "Angolan"]], null, null, null, null, null)), core["ɵdid"](105, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](106, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Angolan"])), (_l()(), core["ɵeld"](108, 0, null, null, 3, "option", [["value", "Anguillan"]], null, null, null, null, null)), core["ɵdid"](109, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](110, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Anguillan"])), (_l()(), core["ɵeld"](112, 0, null, null, 3, "option", [["value", "Argentine"]], null, null, null, null, null)), core["ɵdid"](113, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](114, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Argentine"])), (_l()(), core["ɵeld"](116, 0, null, null, 3, "option", [["value", "Armenian"]], null, null, null, null, null)), core["ɵdid"](117, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](118, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Armenian"])), (_l()(), core["ɵeld"](120, 0, null, null, 3, "option", [["value", "Australian"]], null, null, null, null, null)), core["ɵdid"](121, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](122, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Australian"])), (_l()(), core["ɵeld"](124, 0, null, null, 3, "option", [["value", "Austrian"]], null, null, null, null, null)), core["ɵdid"](125, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](126, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Austrian"])), (_l()(), core["ɵeld"](128, 0, null, null, 3, "option", [["value", "Azerbaijani"]], null, null, null, null, null)), core["ɵdid"](129, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](130, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Azerbaijani"])), (_l()(), core["ɵeld"](132, 0, null, null, 3, "option", [["value", "Bahamian"]], null, null, null, null, null)), core["ɵdid"](133, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](134, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bahamian"])), (_l()(), core["ɵeld"](136, 0, null, null, 3, "option", [["value", "Bahraini"]], null, null, null, null, null)), core["ɵdid"](137, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](138, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bahraini"])), (_l()(), core["ɵeld"](140, 0, null, null, 3, "option", [["value", "Bangladeshi"]], null, null, null, null, null)), core["ɵdid"](141, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](142, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bangladeshi"])), (_l()(), core["ɵeld"](144, 0, null, null, 3, "option", [["value", "Barbadian"]], null, null, null, null, null)), core["ɵdid"](145, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](146, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Barbadian"])), (_l()(), core["ɵeld"](148, 0, null, null, 3, "option", [["value", "Belarusian"]], null, null, null, null, null)), core["ɵdid"](149, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](150, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Belarusian"])), (_l()(), core["ɵeld"](152, 0, null, null, 3, "option", [["value", "Belgian"]], null, null, null, null, null)), core["ɵdid"](153, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](154, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Belgian"])), (_l()(), core["ɵeld"](156, 0, null, null, 3, "option", [["value", "Belizean"]], null, null, null, null, null)), core["ɵdid"](157, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](158, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Belizean"])), (_l()(), core["ɵeld"](160, 0, null, null, 3, "option", [["value", "Beninese"]], null, null, null, null, null)), core["ɵdid"](161, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](162, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Beninese"])), (_l()(), core["ɵeld"](164, 0, null, null, 3, "option", [["value", "Bhutanese"]], null, null, null, null, null)), core["ɵdid"](165, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](166, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bhutanese"])), (_l()(), core["ɵeld"](168, 0, null, null, 3, "option", [["value", "Bolivian"]], null, null, null, null, null)), core["ɵdid"](169, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](170, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bolivian"])), (_l()(), core["ɵeld"](172, 0, null, null, 3, "option", [["value", "Botswanan"]], null, null, null, null, null)), core["ɵdid"](173, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](174, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Botswanan"])), (_l()(), core["ɵeld"](176, 0, null, null, 3, "option", [["value", "Brazilian"]], null, null, null, null, null)), core["ɵdid"](177, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](178, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Brazilian"])), (_l()(), core["ɵeld"](180, 0, null, null, 3, "option", [["value", "British"]], null, null, null, null, null)), core["ɵdid"](181, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](182, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["British"])), (_l()(), core["ɵeld"](184, 0, null, null, 3, "option", [["value", "British Virgin Islander"]], null, null, null, null, null)), core["ɵdid"](185, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](186, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["British Virgin Islander"])), (_l()(), core["ɵeld"](188, 0, null, null, 3, "option", [["value", "Bruneian"]], null, null, null, null, null)), core["ɵdid"](189, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](190, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bruneian"])), (_l()(), core["ɵeld"](192, 0, null, null, 3, "option", [["value", "Bulgarian"]], null, null, null, null, null)), core["ɵdid"](193, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](194, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bulgarian"])), (_l()(), core["ɵeld"](196, 0, null, null, 3, "option", [["value", "Burkinan"]], null, null, null, null, null)), core["ɵdid"](197, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](198, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Burkinan"])), (_l()(), core["ɵeld"](200, 0, null, null, 3, "option", [["value", "Burmese"]], null, null, null, null, null)), core["ɵdid"](201, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](202, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Burmese"])), (_l()(), core["ɵeld"](204, 0, null, null, 3, "option", [["value", "Bermudian"]], null, null, null, null, null)), core["ɵdid"](205, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](206, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Bermudian"])), (_l()(), core["ɵeld"](208, 0, null, null, 3, "option", [["value", "Burundian"]], null, null, null, null, null)), core["ɵdid"](209, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](210, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Burundian"])), (_l()(), core["ɵeld"](212, 0, null, null, 3, "option", [["value", "Cambodian"]], null, null, null, null, null)), core["ɵdid"](213, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](214, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cambodian"])), (_l()(), core["ɵeld"](216, 0, null, null, 3, "option", [["value", "Cameroonian"]], null, null, null, null, null)), core["ɵdid"](217, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](218, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cameroonian"])), (_l()(), core["ɵeld"](220, 0, null, null, 3, "option", [["value", "Canadian"]], null, null, null, null, null)), core["ɵdid"](221, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](222, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Canadian"])), (_l()(), core["ɵeld"](224, 0, null, null, 3, "option", [["value", "Cape Verdean"]], null, null, null, null, null)), core["ɵdid"](225, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](226, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cape Verdean"])), (_l()(), core["ɵeld"](228, 0, null, null, 3, "option", [["value", "Cayman Islander"]], null, null, null, null, null)), core["ɵdid"](229, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](230, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cayman Islander"])), (_l()(), core["ɵeld"](232, 0, null, null, 3, "option", [["value", "Central African"]], null, null, null, null, null)), core["ɵdid"](233, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](234, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Central African"])), (_l()(), core["ɵeld"](236, 0, null, null, 3, "option", [["value", "Chadian"]], null, null, null, null, null)), core["ɵdid"](237, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](238, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Chadian"])), (_l()(), core["ɵeld"](240, 0, null, null, 3, "option", [["value", "Chilean"]], null, null, null, null, null)), core["ɵdid"](241, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](242, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Chilean"])), (_l()(), core["ɵeld"](244, 0, null, null, 3, "option", [["value", "Chinese"]], null, null, null, null, null)), core["ɵdid"](245, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](246, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Chinese"])), (_l()(), core["ɵeld"](248, 0, null, null, 3, "option", [["value", "Citizen of Antigua and Barbuda"]], null, null, null, null, null)), core["ɵdid"](249, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](250, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Citizen of Antigua and Barbuda"])), (_l()(), core["ɵeld"](252, 0, null, null, 3, "option", [["value", "Citizen of Bosnia and Herzegovina"]], null, null, null, null, null)), core["ɵdid"](253, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](254, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Citizen of Bosnia and Herzegovina"])), (_l()(), core["ɵeld"](256, 0, null, null, 3, "option", [["value", "Citizen of the Dominican Republic"]], null, null, null, null, null)), core["ɵdid"](257, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](258, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Citizen of the Dominican Republic"])), (_l()(), core["ɵeld"](260, 0, null, null, 3, "option", [["value", "Citizen of Guinea-Bissau"]], null, null, null, null, null)), core["ɵdid"](261, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](262, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Citizen of Guinea-Bissau"])), (_l()(), core["ɵeld"](264, 0, null, null, 3, "option", [["value", "Citizen of Kiribati"]], null, null, null, null, null)), core["ɵdid"](265, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](266, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Citizen of Kiribati"])), (_l()(), core["ɵeld"](268, 0, null, null, 3, "option", [["value", "Citizen of Seychelles"]], null, null, null, null, null)), core["ɵdid"](269, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](270, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Citizen of Seychelles"])), (_l()(), core["ɵeld"](272, 0, null, null, 3, "option", [["value", "Citizen of Vanuatu"]], null, null, null, null, null)), core["ɵdid"](273, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](274, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Citizen of Vanuatu"])), (_l()(), core["ɵeld"](276, 0, null, null, 3, "option", [["value", "Colombian"]], null, null, null, null, null)), core["ɵdid"](277, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](278, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Colombian"])), (_l()(), core["ɵeld"](280, 0, null, null, 3, "option", [["value", "Comoran"]], null, null, null, null, null)), core["ɵdid"](281, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](282, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Comoran"])), (_l()(), core["ɵeld"](284, 0, null, null, 3, "option", [["value", "Congolese (Congo)"]], null, null, null, null, null)), core["ɵdid"](285, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](286, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Congolese (Congo)"])), (_l()(), core["ɵeld"](288, 0, null, null, 3, "option", [["value", "Congolese (DRC)"]], null, null, null, null, null)), core["ɵdid"](289, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](290, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Congolese (DRC)"])), (_l()(), core["ɵeld"](292, 0, null, null, 3, "option", [["value", "Cook Islander"]], null, null, null, null, null)), core["ɵdid"](293, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](294, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cook Islander"])), (_l()(), core["ɵeld"](296, 0, null, null, 3, "option", [["value", "Costa Rican"]], null, null, null, null, null)), core["ɵdid"](297, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](298, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Costa Rican"])), (_l()(), core["ɵeld"](300, 0, null, null, 3, "option", [["value", "Croatian"]], null, null, null, null, null)), core["ɵdid"](301, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](302, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Croatian"])), (_l()(), core["ɵeld"](304, 0, null, null, 3, "option", [["value", "Cuban"]], null, null, null, null, null)), core["ɵdid"](305, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](306, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cuban"])), (_l()(), core["ɵeld"](308, 0, null, null, 3, "option", [["value", "Cymraes"]], null, null, null, null, null)), core["ɵdid"](309, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](310, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cymraes"])), (_l()(), core["ɵeld"](312, 0, null, null, 3, "option", [["value", "Cymro"]], null, null, null, null, null)), core["ɵdid"](313, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](314, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cymro"])), (_l()(), core["ɵeld"](316, 0, null, null, 3, "option", [["value", "Cypriot"]], null, null, null, null, null)), core["ɵdid"](317, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](318, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Cypriot"])), (_l()(), core["ɵeld"](320, 0, null, null, 3, "option", [["value", "Czech"]], null, null, null, null, null)), core["ɵdid"](321, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](322, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Czech"])), (_l()(), core["ɵeld"](324, 0, null, null, 3, "option", [["value", "Danish"]], null, null, null, null, null)), core["ɵdid"](325, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](326, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Danish"])), (_l()(), core["ɵeld"](328, 0, null, null, 3, "option", [["value", "Djiboutian"]], null, null, null, null, null)), core["ɵdid"](329, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](330, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Djiboutian"])), (_l()(), core["ɵeld"](332, 0, null, null, 3, "option", [["value", "Dominican"]], null, null, null, null, null)), core["ɵdid"](333, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](334, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Dominican"])), (_l()(), core["ɵeld"](336, 0, null, null, 3, "option", [["value", "Dutch"]], null, null, null, null, null)), core["ɵdid"](337, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](338, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Dutch"])), (_l()(), core["ɵeld"](340, 0, null, null, 3, "option", [["value", "East Timorese"]], null, null, null, null, null)), core["ɵdid"](341, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](342, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["East Timorese"])), (_l()(), core["ɵeld"](344, 0, null, null, 3, "option", [["value", "Ecuadorean"]], null, null, null, null, null)), core["ɵdid"](345, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](346, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ecuadorean"])), (_l()(), core["ɵeld"](348, 0, null, null, 3, "option", [["value", "Egyptian"]], null, null, null, null, null)), core["ɵdid"](349, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](350, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Egyptian"])), (_l()(), core["ɵeld"](352, 0, null, null, 3, "option", [["value", "Emirati"]], null, null, null, null, null)), core["ɵdid"](353, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](354, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Emirati"])), (_l()(), core["ɵeld"](356, 0, null, null, 3, "option", [["value", "English"]], null, null, null, null, null)), core["ɵdid"](357, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](358, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["English"])), (_l()(), core["ɵeld"](360, 0, null, null, 3, "option", [["value", "Equatorial Guinean"]], null, null, null, null, null)), core["ɵdid"](361, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](362, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Equatorial Guinean"])), (_l()(), core["ɵeld"](364, 0, null, null, 3, "option", [["value", "Eritrean"]], null, null, null, null, null)), core["ɵdid"](365, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](366, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Eritrean"])), (_l()(), core["ɵeld"](368, 0, null, null, 3, "option", [["value", "Estonian"]], null, null, null, null, null)), core["ɵdid"](369, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](370, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Estonian"])), (_l()(), core["ɵeld"](372, 0, null, null, 3, "option", [["value", "Ethiopian"]], null, null, null, null, null)), core["ɵdid"](373, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](374, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ethiopian"])), (_l()(), core["ɵeld"](376, 0, null, null, 3, "option", [["value", "Faroese"]], null, null, null, null, null)), core["ɵdid"](377, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](378, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Faroese"])), (_l()(), core["ɵeld"](380, 0, null, null, 3, "option", [["value", "Fijian"]], null, null, null, null, null)), core["ɵdid"](381, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](382, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Fijian"])), (_l()(), core["ɵeld"](384, 0, null, null, 3, "option", [["value", "Filipino"]], null, null, null, null, null)), core["ɵdid"](385, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](386, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Filipino"])), (_l()(), core["ɵeld"](388, 0, null, null, 3, "option", [["value", "Finnish"]], null, null, null, null, null)), core["ɵdid"](389, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](390, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Finnish"])), (_l()(), core["ɵeld"](392, 0, null, null, 3, "option", [["value", "French"]], null, null, null, null, null)), core["ɵdid"](393, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](394, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["French"])), (_l()(), core["ɵeld"](396, 0, null, null, 3, "option", [["value", "Gabonese"]], null, null, null, null, null)), core["ɵdid"](397, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](398, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Gabonese"])), (_l()(), core["ɵeld"](400, 0, null, null, 3, "option", [["value", "Gambian"]], null, null, null, null, null)), core["ɵdid"](401, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](402, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Gambian"])), (_l()(), core["ɵeld"](404, 0, null, null, 3, "option", [["value", "Georgian"]], null, null, null, null, null)), core["ɵdid"](405, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](406, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Georgian"])), (_l()(), core["ɵeld"](408, 0, null, null, 3, "option", [["value", "German"]], null, null, null, null, null)), core["ɵdid"](409, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](410, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["German"])), (_l()(), core["ɵeld"](412, 0, null, null, 3, "option", [["value", "Ghanaian"]], null, null, null, null, null)), core["ɵdid"](413, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](414, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ghanaian"])), (_l()(), core["ɵeld"](416, 0, null, null, 3, "option", [["value", "Gibraltarian"]], null, null, null, null, null)), core["ɵdid"](417, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](418, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Gibraltarian"])), (_l()(), core["ɵeld"](420, 0, null, null, 3, "option", [["value", "Greek"]], null, null, null, null, null)), core["ɵdid"](421, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](422, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Greek"])), (_l()(), core["ɵeld"](424, 0, null, null, 3, "option", [["value", "Greenlandic"]], null, null, null, null, null)), core["ɵdid"](425, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](426, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Greenlandic"])), (_l()(), core["ɵeld"](428, 0, null, null, 3, "option", [["value", "Grenadian"]], null, null, null, null, null)), core["ɵdid"](429, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](430, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Grenadian"])), (_l()(), core["ɵeld"](432, 0, null, null, 3, "option", [["value", "Guamanian"]], null, null, null, null, null)), core["ɵdid"](433, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](434, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guamanian"])), (_l()(), core["ɵeld"](436, 0, null, null, 3, "option", [["value", "Guatemalan"]], null, null, null, null, null)), core["ɵdid"](437, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](438, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guatemalan"])), (_l()(), core["ɵeld"](440, 0, null, null, 3, "option", [["value", "Guinean"]], null, null, null, null, null)), core["ɵdid"](441, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](442, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guinean"])), (_l()(), core["ɵeld"](444, 0, null, null, 3, "option", [["value", "Guyanese"]], null, null, null, null, null)), core["ɵdid"](445, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](446, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Guyanese"])), (_l()(), core["ɵeld"](448, 0, null, null, 3, "option", [["value", "Haitian"]], null, null, null, null, null)), core["ɵdid"](449, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](450, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Haitian"])), (_l()(), core["ɵeld"](452, 0, null, null, 3, "option", [["value", "Honduran"]], null, null, null, null, null)), core["ɵdid"](453, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](454, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Honduran"])), (_l()(), core["ɵeld"](456, 0, null, null, 3, "option", [["value", "Hong Konger"]], null, null, null, null, null)), core["ɵdid"](457, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](458, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Hong Konger"])), (_l()(), core["ɵeld"](460, 0, null, null, 3, "option", [["value", "Hungarian"]], null, null, null, null, null)), core["ɵdid"](461, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](462, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Hungarian"])), (_l()(), core["ɵeld"](464, 0, null, null, 3, "option", [["value", "Icelandic"]], null, null, null, null, null)), core["ɵdid"](465, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](466, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Icelandic"])), (_l()(), core["ɵeld"](468, 0, null, null, 3, "option", [["value", "Indian"]], null, null, null, null, null)), core["ɵdid"](469, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](470, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Indian"])), (_l()(), core["ɵeld"](472, 0, null, null, 3, "option", [["value", "Indonesian"]], null, null, null, null, null)), core["ɵdid"](473, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](474, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Indonesian"])), (_l()(), core["ɵeld"](476, 0, null, null, 3, "option", [["value", "Irish"]], null, null, null, null, null)), core["ɵdid"](477, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](478, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Irish"])), (_l()(), core["ɵeld"](480, 0, null, null, 3, "option", [["value", "Iraqi"]], null, null, null, null, null)), core["ɵdid"](481, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](482, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Iraqi"])), (_l()(), core["ɵeld"](484, 0, null, null, 3, "option", [["value", "Iranian"]], null, null, null, null, null)), core["ɵdid"](485, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](486, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Iranian"])), (_l()(), core["ɵeld"](488, 0, null, null, 3, "option", [["value", "Israeli"]], null, null, null, null, null)), core["ɵdid"](489, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](490, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Israeli"])), (_l()(), core["ɵeld"](492, 0, null, null, 3, "option", [["value", "Italian"]], null, null, null, null, null)), core["ɵdid"](493, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](494, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Italian"])), (_l()(), core["ɵeld"](496, 0, null, null, 3, "option", [["value", "Ivorian"]], null, null, null, null, null)), core["ɵdid"](497, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](498, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ivorian"])), (_l()(), core["ɵeld"](500, 0, null, null, 3, "option", [["value", "Jamaican"]], null, null, null, null, null)), core["ɵdid"](501, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](502, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Jamaican"])), (_l()(), core["ɵeld"](504, 0, null, null, 3, "option", [["value", "Japanese"]], null, null, null, null, null)), core["ɵdid"](505, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](506, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Japanese"])), (_l()(), core["ɵeld"](508, 0, null, null, 3, "option", [["value", "Jordanian"]], null, null, null, null, null)), core["ɵdid"](509, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](510, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Jordanian"])), (_l()(), core["ɵeld"](512, 0, null, null, 3, "option", [["value", "Kazakh"]], null, null, null, null, null)), core["ɵdid"](513, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](514, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kazakh"])), (_l()(), core["ɵeld"](516, 0, null, null, 3, "option", [["value", "Kenyan"]], null, null, null, null, null)), core["ɵdid"](517, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](518, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kenyan"])), (_l()(), core["ɵeld"](520, 0, null, null, 3, "option", [["value", "Kittitian"]], null, null, null, null, null)), core["ɵdid"](521, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](522, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kittitian"])), (_l()(), core["ɵeld"](524, 0, null, null, 3, "option", [["value", "Kosovan"]], null, null, null, null, null)), core["ɵdid"](525, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](526, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kosovan"])), (_l()(), core["ɵeld"](528, 0, null, null, 3, "option", [["value", "Kuwaiti"]], null, null, null, null, null)), core["ɵdid"](529, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](530, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kuwaiti"])), (_l()(), core["ɵeld"](532, 0, null, null, 3, "option", [["value", "Kyrgyz"]], null, null, null, null, null)), core["ɵdid"](533, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](534, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Kyrgyz"])), (_l()(), core["ɵeld"](536, 0, null, null, 3, "option", [["value", "Lao"]], null, null, null, null, null)), core["ɵdid"](537, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](538, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Lao"])), (_l()(), core["ɵeld"](540, 0, null, null, 3, "option", [["value", "Latvian"]], null, null, null, null, null)), core["ɵdid"](541, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](542, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Latvian"])), (_l()(), core["ɵeld"](544, 0, null, null, 3, "option", [["value", "Lebanese"]], null, null, null, null, null)), core["ɵdid"](545, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](546, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Lebanese"])), (_l()(), core["ɵeld"](548, 0, null, null, 3, "option", [["value", "Liberian"]], null, null, null, null, null)), core["ɵdid"](549, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](550, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Liberian"])), (_l()(), core["ɵeld"](552, 0, null, null, 3, "option", [["value", "Libyan"]], null, null, null, null, null)), core["ɵdid"](553, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](554, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Libyan"])), (_l()(), core["ɵeld"](556, 0, null, null, 3, "option", [["value", "Liechtenstein citizen"]], null, null, null, null, null)), core["ɵdid"](557, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](558, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Liechtenstein citizen"])), (_l()(), core["ɵeld"](560, 0, null, null, 3, "option", [["value", "Lithuanian"]], null, null, null, null, null)), core["ɵdid"](561, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](562, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Lithuanian"])), (_l()(), core["ɵeld"](564, 0, null, null, 3, "option", [["value", "Luxembourger"]], null, null, null, null, null)), core["ɵdid"](565, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](566, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Luxembourger"])), (_l()(), core["ɵeld"](568, 0, null, null, 3, "option", [["value", "Macanese"]], null, null, null, null, null)), core["ɵdid"](569, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](570, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Macanese"])), (_l()(), core["ɵeld"](572, 0, null, null, 3, "option", [["value", "Macedonian"]], null, null, null, null, null)), core["ɵdid"](573, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](574, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Macedonian"])), (_l()(), core["ɵeld"](576, 0, null, null, 3, "option", [["value", "Malagasy"]], null, null, null, null, null)), core["ɵdid"](577, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](578, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Malagasy"])), (_l()(), core["ɵeld"](580, 0, null, null, 3, "option", [["value", "Malawian"]], null, null, null, null, null)), core["ɵdid"](581, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](582, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Malawian"])), (_l()(), core["ɵeld"](584, 0, null, null, 3, "option", [["value", "Maldivian"]], null, null, null, null, null)), core["ɵdid"](585, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](586, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Maldivian"])), (_l()(), core["ɵeld"](588, 0, null, null, 3, "option", [["value", "Malian"]], null, null, null, null, null)), core["ɵdid"](589, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](590, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Malian"])), (_l()(), core["ɵeld"](592, 0, null, null, 3, "option", [["value", "Maltese"]], null, null, null, null, null)), core["ɵdid"](593, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](594, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Maltese"])), (_l()(), core["ɵeld"](596, 0, null, null, 3, "option", [["value", "Marshallese"]], null, null, null, null, null)), core["ɵdid"](597, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](598, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Marshallese"])), (_l()(), core["ɵeld"](600, 0, null, null, 3, "option", [["value", "Martiniquais"]], null, null, null, null, null)), core["ɵdid"](601, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](602, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Martiniquais"])), (_l()(), core["ɵeld"](604, 0, null, null, 3, "option", [["value", "Mauritanian"]], null, null, null, null, null)), core["ɵdid"](605, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](606, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mauritanian"])), (_l()(), core["ɵeld"](608, 0, null, null, 3, "option", [["value", "Mauritian"]], null, null, null, null, null)), core["ɵdid"](609, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](610, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mauritian"])), (_l()(), core["ɵeld"](612, 0, null, null, 3, "option", [["value", "Mexican"]], null, null, null, null, null)), core["ɵdid"](613, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](614, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mexican"])), (_l()(), core["ɵeld"](616, 0, null, null, 3, "option", [["value", "Micronesian"]], null, null, null, null, null)), core["ɵdid"](617, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](618, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Micronesian"])), (_l()(), core["ɵeld"](620, 0, null, null, 3, "option", [["value", "Moldovan"]], null, null, null, null, null)), core["ɵdid"](621, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](622, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Moldovan"])), (_l()(), core["ɵeld"](624, 0, null, null, 3, "option", [["value", "Monegasque"]], null, null, null, null, null)), core["ɵdid"](625, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](626, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Monegasque"])), (_l()(), core["ɵeld"](628, 0, null, null, 3, "option", [["value", "Mongolian"]], null, null, null, null, null)), core["ɵdid"](629, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](630, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mongolian"])), (_l()(), core["ɵeld"](632, 0, null, null, 3, "option", [["value", "Montenegrin"]], null, null, null, null, null)), core["ɵdid"](633, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](634, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Montenegrin"])), (_l()(), core["ɵeld"](636, 0, null, null, 3, "option", [["value", "Montserratian"]], null, null, null, null, null)), core["ɵdid"](637, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](638, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Montserratian"])), (_l()(), core["ɵeld"](640, 0, null, null, 3, "option", [["value", "Moroccan"]], null, null, null, null, null)), core["ɵdid"](641, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](642, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Moroccan"])), (_l()(), core["ɵeld"](644, 0, null, null, 3, "option", [["value", "Mosotho"]], null, null, null, null, null)), core["ɵdid"](645, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](646, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mosotho"])), (_l()(), core["ɵeld"](648, 0, null, null, 3, "option", [["value", "Mozambican"]], null, null, null, null, null)), core["ɵdid"](649, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](650, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Mozambican"])), (_l()(), core["ɵeld"](652, 0, null, null, 3, "option", [["value", "Namibian"]], null, null, null, null, null)), core["ɵdid"](653, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](654, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Namibian"])), (_l()(), core["ɵeld"](656, 0, null, null, 3, "option", [["value", "Nauruan"]], null, null, null, null, null)), core["ɵdid"](657, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](658, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Nauruan"])), (_l()(), core["ɵeld"](660, 0, null, null, 3, "option", [["value", "Nepalese"]], null, null, null, null, null)), core["ɵdid"](661, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](662, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Nepalese"])), (_l()(), core["ɵeld"](664, 0, null, null, 3, "option", [["value", "New Zealander"]], null, null, null, null, null)), core["ɵdid"](665, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](666, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["New Zealander"])), (_l()(), core["ɵeld"](668, 0, null, null, 3, "option", [["value", "Nicaraguan"]], null, null, null, null, null)), core["ɵdid"](669, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](670, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Nicaraguan"])), (_l()(), core["ɵeld"](672, 0, null, null, 3, "option", [["value", "Nigerien"]], null, null, null, null, null)), core["ɵdid"](673, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](674, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Nigerien"])), (_l()(), core["ɵeld"](676, 0, null, null, 3, "option", [["value", "Niger Republic"]], null, null, null, null, null)), core["ɵdid"](677, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](678, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Niger Republic"])), (_l()(), core["ɵeld"](680, 0, null, null, 3, "option", [["value", "Niuean"]], null, null, null, null, null)), core["ɵdid"](681, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](682, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Niuean"])), (_l()(), core["ɵeld"](684, 0, null, null, 3, "option", [["value", "North Korean"]], null, null, null, null, null)), core["ɵdid"](685, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](686, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["North Korean"])), (_l()(), core["ɵeld"](688, 0, null, null, 3, "option", [["value", "Northern Irish"]], null, null, null, null, null)), core["ɵdid"](689, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](690, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Northern Irish"])), (_l()(), core["ɵeld"](692, 0, null, null, 3, "option", [["value", "Norwegian"]], null, null, null, null, null)), core["ɵdid"](693, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](694, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Norwegian"])), (_l()(), core["ɵeld"](696, 0, null, null, 3, "option", [["value", "Omani"]], null, null, null, null, null)), core["ɵdid"](697, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](698, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Omani"])), (_l()(), core["ɵeld"](700, 0, null, null, 3, "option", [["value", "Pakistani"]], null, null, null, null, null)), core["ɵdid"](701, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](702, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Pakistani"])), (_l()(), core["ɵeld"](704, 0, null, null, 3, "option", [["value", "Palauan"]], null, null, null, null, null)), core["ɵdid"](705, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](706, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Palauan"])), (_l()(), core["ɵeld"](708, 0, null, null, 3, "option", [["value", "Palestinian"]], null, null, null, null, null)), core["ɵdid"](709, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](710, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Palestinian"])), (_l()(), core["ɵeld"](712, 0, null, null, 3, "option", [["value", "Panamanian"]], null, null, null, null, null)), core["ɵdid"](713, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](714, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Panamanian"])), (_l()(), core["ɵeld"](716, 0, null, null, 3, "option", [["value", "Papua New Guinean"]], null, null, null, null, null)), core["ɵdid"](717, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](718, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Papua New Guinean"])), (_l()(), core["ɵeld"](720, 0, null, null, 3, "option", [["value", "Paraguayan"]], null, null, null, null, null)), core["ɵdid"](721, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](722, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Paraguayan"])), (_l()(), core["ɵeld"](724, 0, null, null, 3, "option", [["value", "Peruvian"]], null, null, null, null, null)), core["ɵdid"](725, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](726, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Peruvian"])), (_l()(), core["ɵeld"](728, 0, null, null, 3, "option", [["value", "Pitcairn Islander"]], null, null, null, null, null)), core["ɵdid"](729, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](730, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Pitcairn Islander"])), (_l()(), core["ɵeld"](732, 0, null, null, 3, "option", [["value", "Polish"]], null, null, null, null, null)), core["ɵdid"](733, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](734, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Polish"])), (_l()(), core["ɵeld"](736, 0, null, null, 3, "option", [["value", "Portuguese"]], null, null, null, null, null)), core["ɵdid"](737, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](738, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Portuguese"])), (_l()(), core["ɵeld"](740, 0, null, null, 3, "option", [["value", "Prydeinig"]], null, null, null, null, null)), core["ɵdid"](741, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](742, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Prydeinig"])), (_l()(), core["ɵeld"](744, 0, null, null, 3, "option", [["value", "Puerto Rican"]], null, null, null, null, null)), core["ɵdid"](745, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](746, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Puerto Rican"])), (_l()(), core["ɵeld"](748, 0, null, null, 3, "option", [["value", "Qatari"]], null, null, null, null, null)), core["ɵdid"](749, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](750, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Qatari"])), (_l()(), core["ɵeld"](752, 0, null, null, 3, "option", [["value", "Romanian"]], null, null, null, null, null)), core["ɵdid"](753, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](754, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Romanian"])), (_l()(), core["ɵeld"](756, 0, null, null, 3, "option", [["value", "Russian"]], null, null, null, null, null)), core["ɵdid"](757, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](758, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Russian"])), (_l()(), core["ɵeld"](760, 0, null, null, 3, "option", [["value", "Rwandan"]], null, null, null, null, null)), core["ɵdid"](761, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](762, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Rwandan"])), (_l()(), core["ɵeld"](764, 0, null, null, 3, "option", [["value", "Salvadorean"]], null, null, null, null, null)), core["ɵdid"](765, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](766, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Salvadorean"])), (_l()(), core["ɵeld"](768, 0, null, null, 3, "option", [["value", "Samoan"]], null, null, null, null, null)), core["ɵdid"](769, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](770, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Samoan"])), (_l()(), core["ɵeld"](772, 0, null, null, 3, "option", [["value", "Sammarinese"]], null, null, null, null, null)), core["ɵdid"](773, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](774, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sammarinese"])), (_l()(), core["ɵeld"](776, 0, null, null, 3, "option", [["value", "Sao Tomean"]], null, null, null, null, null)), core["ɵdid"](777, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](778, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sao Tomean"])), (_l()(), core["ɵeld"](780, 0, null, null, 3, "option", [["value", "Saudi Arabian"]], null, null, null, null, null)), core["ɵdid"](781, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](782, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Saudi Arabian"])), (_l()(), core["ɵeld"](784, 0, null, null, 3, "option", [["value", "Scottish"]], null, null, null, null, null)), core["ɵdid"](785, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](786, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Scottish"])), (_l()(), core["ɵeld"](788, 0, null, null, 3, "option", [["value", "Senegalese"]], null, null, null, null, null)), core["ɵdid"](789, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](790, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Senegalese"])), (_l()(), core["ɵeld"](792, 0, null, null, 3, "option", [["value", "Serbian"]], null, null, null, null, null)), core["ɵdid"](793, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](794, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Serbian"])), (_l()(), core["ɵeld"](796, 0, null, null, 3, "option", [["value", "Sierra Leonean"]], null, null, null, null, null)), core["ɵdid"](797, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](798, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sierra Leonean"])), (_l()(), core["ɵeld"](800, 0, null, null, 3, "option", [["value", "Singaporean"]], null, null, null, null, null)), core["ɵdid"](801, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](802, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Singaporean"])), (_l()(), core["ɵeld"](804, 0, null, null, 3, "option", [["value", "Slovak"]], null, null, null, null, null)), core["ɵdid"](805, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](806, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Slovak"])), (_l()(), core["ɵeld"](808, 0, null, null, 3, "option", [["value", "Slovenian"]], null, null, null, null, null)), core["ɵdid"](809, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](810, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Slovenian"])), (_l()(), core["ɵeld"](812, 0, null, null, 3, "option", [["value", "Solomon Islander"]], null, null, null, null, null)), core["ɵdid"](813, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](814, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Solomon Islander"])), (_l()(), core["ɵeld"](816, 0, null, null, 3, "option", [["value", "Somali"]], null, null, null, null, null)), core["ɵdid"](817, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](818, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Somali"])), (_l()(), core["ɵeld"](820, 0, null, null, 3, "option", [["value", "South African"]], null, null, null, null, null)), core["ɵdid"](821, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](822, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["South African"])), (_l()(), core["ɵeld"](824, 0, null, null, 3, "option", [["value", "South Korean"]], null, null, null, null, null)), core["ɵdid"](825, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](826, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["South Korean"])), (_l()(), core["ɵeld"](828, 0, null, null, 3, "option", [["value", "South Sudanese"]], null, null, null, null, null)), core["ɵdid"](829, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](830, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["South Sudanese"])), (_l()(), core["ɵeld"](832, 0, null, null, 3, "option", [["value", "Spanish"]], null, null, null, null, null)), core["ɵdid"](833, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](834, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Spanish"])), (_l()(), core["ɵeld"](836, 0, null, null, 3, "option", [["value", "Sri Lankan"]], null, null, null, null, null)), core["ɵdid"](837, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](838, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sri Lankan"])), (_l()(), core["ɵeld"](840, 0, null, null, 3, "option", [["value", "St Helenian"]], null, null, null, null, null)), core["ɵdid"](841, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](842, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St Helenian"])), (_l()(), core["ɵeld"](844, 0, null, null, 3, "option", [["value", "St Lucian"]], null, null, null, null, null)), core["ɵdid"](845, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](846, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["St Lucian"])), (_l()(), core["ɵeld"](848, 0, null, null, 3, "option", [["value", "Stateless"]], null, null, null, null, null)), core["ɵdid"](849, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](850, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Stateless"])), (_l()(), core["ɵeld"](852, 0, null, null, 3, "option", [["value", "Sudanese"]], null, null, null, null, null)), core["ɵdid"](853, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](854, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Sudanese"])), (_l()(), core["ɵeld"](856, 0, null, null, 3, "option", [["value", "Surinamese"]], null, null, null, null, null)), core["ɵdid"](857, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](858, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Surinamese"])), (_l()(), core["ɵeld"](860, 0, null, null, 3, "option", [["value", "Swazi"]], null, null, null, null, null)), core["ɵdid"](861, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](862, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Swazi"])), (_l()(), core["ɵeld"](864, 0, null, null, 3, "option", [["value", "Swedish"]], null, null, null, null, null)), core["ɵdid"](865, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](866, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Swedish"])), (_l()(), core["ɵeld"](868, 0, null, null, 3, "option", [["value", "Swiss"]], null, null, null, null, null)), core["ɵdid"](869, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](870, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Swiss"])), (_l()(), core["ɵeld"](872, 0, null, null, 3, "option", [["value", "Syrian"]], null, null, null, null, null)), core["ɵdid"](873, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](874, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Syrian"])), (_l()(), core["ɵeld"](876, 0, null, null, 3, "option", [["value", "Taiwanese"]], null, null, null, null, null)), core["ɵdid"](877, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](878, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Taiwanese"])), (_l()(), core["ɵeld"](880, 0, null, null, 3, "option", [["value", "Tajik"]], null, null, null, null, null)), core["ɵdid"](881, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](882, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tajik"])), (_l()(), core["ɵeld"](884, 0, null, null, 3, "option", [["value", "Tanzanian"]], null, null, null, null, null)), core["ɵdid"](885, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](886, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tanzanian"])), (_l()(), core["ɵeld"](888, 0, null, null, 3, "option", [["value", "Thai"]], null, null, null, null, null)), core["ɵdid"](889, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](890, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Thai"])), (_l()(), core["ɵeld"](892, 0, null, null, 3, "option", [["value", "Togolese"]], null, null, null, null, null)), core["ɵdid"](893, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](894, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Togolese"])), (_l()(), core["ɵeld"](896, 0, null, null, 3, "option", [["value", "Tongan"]], null, null, null, null, null)), core["ɵdid"](897, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](898, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tongan"])), (_l()(), core["ɵeld"](900, 0, null, null, 3, "option", [["value", "Trinidadian"]], null, null, null, null, null)), core["ɵdid"](901, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](902, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Trinidadian"])), (_l()(), core["ɵeld"](904, 0, null, null, 3, "option", [["value", "Tristanian"]], null, null, null, null, null)), core["ɵdid"](905, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](906, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tristanian"])), (_l()(), core["ɵeld"](908, 0, null, null, 3, "option", [["value", "Tunisian"]], null, null, null, null, null)), core["ɵdid"](909, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](910, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tunisian"])), (_l()(), core["ɵeld"](912, 0, null, null, 3, "option", [["value", "Turkish"]], null, null, null, null, null)), core["ɵdid"](913, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](914, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Turkish"])), (_l()(), core["ɵeld"](916, 0, null, null, 3, "option", [["value", "Turkmen"]], null, null, null, null, null)), core["ɵdid"](917, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](918, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Turkmen"])), (_l()(), core["ɵeld"](920, 0, null, null, 3, "option", [["value", "Turks and Caicos Islander"]], null, null, null, null, null)), core["ɵdid"](921, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](922, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Turks and Caicos Islander"])), (_l()(), core["ɵeld"](924, 0, null, null, 3, "option", [["value", "Tuvaluan"]], null, null, null, null, null)), core["ɵdid"](925, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](926, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Tuvaluan"])), (_l()(), core["ɵeld"](928, 0, null, null, 3, "option", [["value", "Ugandan"]], null, null, null, null, null)), core["ɵdid"](929, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](930, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ugandan"])), (_l()(), core["ɵeld"](932, 0, null, null, 3, "option", [["value", "Ukrainian"]], null, null, null, null, null)), core["ɵdid"](933, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](934, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Ukrainian"])), (_l()(), core["ɵeld"](936, 0, null, null, 3, "option", [["value", "Uruguayan"]], null, null, null, null, null)), core["ɵdid"](937, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](938, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Uruguayan"])), (_l()(), core["ɵeld"](940, 0, null, null, 3, "option", [["value", "Uzbek"]], null, null, null, null, null)), core["ɵdid"](941, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](942, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Uzbek"])), (_l()(), core["ɵeld"](944, 0, null, null, 3, "option", [["value", "Vatican citizen"]], null, null, null, null, null)), core["ɵdid"](945, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](946, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Vatican citizen"])), (_l()(), core["ɵeld"](948, 0, null, null, 3, "option", [["value", "Venezuelan"]], null, null, null, null, null)), core["ɵdid"](949, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](950, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Venezuelan"])), (_l()(), core["ɵeld"](952, 0, null, null, 3, "option", [["value", "Vietnamese"]], null, null, null, null, null)), core["ɵdid"](953, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](954, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Vietnamese"])), (_l()(), core["ɵeld"](956, 0, null, null, 3, "option", [["value", "Vincentian"]], null, null, null, null, null)), core["ɵdid"](957, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](958, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Vincentian"])), (_l()(), core["ɵeld"](960, 0, null, null, 3, "option", [["value", "Wallisian"]], null, null, null, null, null)), core["ɵdid"](961, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](962, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Wallisian"])), (_l()(), core["ɵeld"](964, 0, null, null, 3, "option", [["value", "Welsh"]], null, null, null, null, null)), core["ɵdid"](965, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](966, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Welsh"])), (_l()(), core["ɵeld"](968, 0, null, null, 3, "option", [["value", "Yemeni"]], null, null, null, null, null)), core["ɵdid"](969, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](970, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Yemeni"])), (_l()(), core["ɵeld"](972, 0, null, null, 3, "option", [["value", "Zambian"]], null, null, null, null, null)), core["ɵdid"](973, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](974, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Zambian"])), (_l()(), core["ɵeld"](976, 0, null, null, 3, "option", [["value", "Zimbabwean"]], null, null, null, null, null)), core["ɵdid"](977, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](978, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Zimbabwean"])), (_l()(), core["ɵeld"](980, 0, null, null, 11, "div", [["class", "w-100 float-left p-md-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](981, 0, null, null, 3, "div", [["class", "col-lg-3 float-left text-right"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Reason: "])), (_l()(), core["ɵeld"](983, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](985, 0, null, null, 6, "div", [["class", "col-lg-8  float-left"], ["ng-reflect-ngb-tooltip", "1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](986, 0, null, null, 5, "input", [["class", "form-control"], ["id", "reason"], ["name", "reason"], ["ng-reflect-model", "1"], ["size", "60"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 987)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 987).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 987)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 987)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co._activeEmployee.reason = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](987, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](989, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](991, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](992, 0, null, null, 4, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](993, 0, null, null, 1, "button", [["class", "btn btn-secondary"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeRoleModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Cancel"])), (_l()(), core["ɵeld"](995, 0, null, null, 1, "button", [["class", "btn btn-primary"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.updateEmployee(_co.confirmationModal) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Update"]))], function (_ck, _v) { var _co = _v.component; var currVal_8 = _ck(_v, 16, 0, "white"); _ck(_v, 15, 0, currVal_8); var currVal_9 = "dateOfBirth"; var currVal_10 = _co._activeEmployee.dateOfBirth; _ck(_v, 22, 0, currVal_9, currVal_10); var currVal_18 = "passportNumber"; var currVal_19 = (_co._activeEmployee.nationality != "Malaysian"); var currVal_20 = _co._activeEmployee.passportNumber; _ck(_v, 34, 0, currVal_18, currVal_19, currVal_20); var currVal_28 = "address"; var currVal_29 = _co._activeEmployee.address; _ck(_v, 44, 0, currVal_28, currVal_29); var currVal_37 = "postcode"; var currVal_38 = _co._activeEmployee.postcode; _ck(_v, 55, 0, currVal_37, currVal_38); var currVal_46 = "state"; var currVal_47 = _co._activeEmployee.orgCode; _ck(_v, 65, 0, currVal_46, currVal_47); var currVal_48 = _co.states; _ck(_v, 69, 0, currVal_48); var currVal_56 = "nationality"; var currVal_57 = _co._activeEmployee.nationality; _ck(_v, 77, 0, currVal_56, currVal_57); var currVal_58 = "Malaysian"; _ck(_v, 81, 0, currVal_58); var currVal_59 = "Malaysian"; _ck(_v, 82, 0, currVal_59); var currVal_60 = "Afghan"; _ck(_v, 85, 0, currVal_60); var currVal_61 = "Afghan"; _ck(_v, 86, 0, currVal_61); var currVal_62 = "Albanian"; _ck(_v, 89, 0, currVal_62); var currVal_63 = "Albanian"; _ck(_v, 90, 0, currVal_63); var currVal_64 = "Algerian"; _ck(_v, 93, 0, currVal_64); var currVal_65 = "Algerian"; _ck(_v, 94, 0, currVal_65); var currVal_66 = "American"; _ck(_v, 97, 0, currVal_66); var currVal_67 = "American"; _ck(_v, 98, 0, currVal_67); var currVal_68 = "Andorran"; _ck(_v, 101, 0, currVal_68); var currVal_69 = "Andorran"; _ck(_v, 102, 0, currVal_69); var currVal_70 = "Angolan"; _ck(_v, 105, 0, currVal_70); var currVal_71 = "Angolan"; _ck(_v, 106, 0, currVal_71); var currVal_72 = "Anguillan"; _ck(_v, 109, 0, currVal_72); var currVal_73 = "Anguillan"; _ck(_v, 110, 0, currVal_73); var currVal_74 = "Argentine"; _ck(_v, 113, 0, currVal_74); var currVal_75 = "Argentine"; _ck(_v, 114, 0, currVal_75); var currVal_76 = "Armenian"; _ck(_v, 117, 0, currVal_76); var currVal_77 = "Armenian"; _ck(_v, 118, 0, currVal_77); var currVal_78 = "Australian"; _ck(_v, 121, 0, currVal_78); var currVal_79 = "Australian"; _ck(_v, 122, 0, currVal_79); var currVal_80 = "Austrian"; _ck(_v, 125, 0, currVal_80); var currVal_81 = "Austrian"; _ck(_v, 126, 0, currVal_81); var currVal_82 = "Azerbaijani"; _ck(_v, 129, 0, currVal_82); var currVal_83 = "Azerbaijani"; _ck(_v, 130, 0, currVal_83); var currVal_84 = "Bahamian"; _ck(_v, 133, 0, currVal_84); var currVal_85 = "Bahamian"; _ck(_v, 134, 0, currVal_85); var currVal_86 = "Bahraini"; _ck(_v, 137, 0, currVal_86); var currVal_87 = "Bahraini"; _ck(_v, 138, 0, currVal_87); var currVal_88 = "Bangladeshi"; _ck(_v, 141, 0, currVal_88); var currVal_89 = "Bangladeshi"; _ck(_v, 142, 0, currVal_89); var currVal_90 = "Barbadian"; _ck(_v, 145, 0, currVal_90); var currVal_91 = "Barbadian"; _ck(_v, 146, 0, currVal_91); var currVal_92 = "Belarusian"; _ck(_v, 149, 0, currVal_92); var currVal_93 = "Belarusian"; _ck(_v, 150, 0, currVal_93); var currVal_94 = "Belgian"; _ck(_v, 153, 0, currVal_94); var currVal_95 = "Belgian"; _ck(_v, 154, 0, currVal_95); var currVal_96 = "Belizean"; _ck(_v, 157, 0, currVal_96); var currVal_97 = "Belizean"; _ck(_v, 158, 0, currVal_97); var currVal_98 = "Beninese"; _ck(_v, 161, 0, currVal_98); var currVal_99 = "Beninese"; _ck(_v, 162, 0, currVal_99); var currVal_100 = "Bhutanese"; _ck(_v, 165, 0, currVal_100); var currVal_101 = "Bhutanese"; _ck(_v, 166, 0, currVal_101); var currVal_102 = "Bolivian"; _ck(_v, 169, 0, currVal_102); var currVal_103 = "Bolivian"; _ck(_v, 170, 0, currVal_103); var currVal_104 = "Botswanan"; _ck(_v, 173, 0, currVal_104); var currVal_105 = "Botswanan"; _ck(_v, 174, 0, currVal_105); var currVal_106 = "Brazilian"; _ck(_v, 177, 0, currVal_106); var currVal_107 = "Brazilian"; _ck(_v, 178, 0, currVal_107); var currVal_108 = "British"; _ck(_v, 181, 0, currVal_108); var currVal_109 = "British"; _ck(_v, 182, 0, currVal_109); var currVal_110 = "British Virgin Islander"; _ck(_v, 185, 0, currVal_110); var currVal_111 = "British Virgin Islander"; _ck(_v, 186, 0, currVal_111); var currVal_112 = "Bruneian"; _ck(_v, 189, 0, currVal_112); var currVal_113 = "Bruneian"; _ck(_v, 190, 0, currVal_113); var currVal_114 = "Bulgarian"; _ck(_v, 193, 0, currVal_114); var currVal_115 = "Bulgarian"; _ck(_v, 194, 0, currVal_115); var currVal_116 = "Burkinan"; _ck(_v, 197, 0, currVal_116); var currVal_117 = "Burkinan"; _ck(_v, 198, 0, currVal_117); var currVal_118 = "Burmese"; _ck(_v, 201, 0, currVal_118); var currVal_119 = "Burmese"; _ck(_v, 202, 0, currVal_119); var currVal_120 = "Bermudian"; _ck(_v, 205, 0, currVal_120); var currVal_121 = "Bermudian"; _ck(_v, 206, 0, currVal_121); var currVal_122 = "Burundian"; _ck(_v, 209, 0, currVal_122); var currVal_123 = "Burundian"; _ck(_v, 210, 0, currVal_123); var currVal_124 = "Cambodian"; _ck(_v, 213, 0, currVal_124); var currVal_125 = "Cambodian"; _ck(_v, 214, 0, currVal_125); var currVal_126 = "Cameroonian"; _ck(_v, 217, 0, currVal_126); var currVal_127 = "Cameroonian"; _ck(_v, 218, 0, currVal_127); var currVal_128 = "Canadian"; _ck(_v, 221, 0, currVal_128); var currVal_129 = "Canadian"; _ck(_v, 222, 0, currVal_129); var currVal_130 = "Cape Verdean"; _ck(_v, 225, 0, currVal_130); var currVal_131 = "Cape Verdean"; _ck(_v, 226, 0, currVal_131); var currVal_132 = "Cayman Islander"; _ck(_v, 229, 0, currVal_132); var currVal_133 = "Cayman Islander"; _ck(_v, 230, 0, currVal_133); var currVal_134 = "Central African"; _ck(_v, 233, 0, currVal_134); var currVal_135 = "Central African"; _ck(_v, 234, 0, currVal_135); var currVal_136 = "Chadian"; _ck(_v, 237, 0, currVal_136); var currVal_137 = "Chadian"; _ck(_v, 238, 0, currVal_137); var currVal_138 = "Chilean"; _ck(_v, 241, 0, currVal_138); var currVal_139 = "Chilean"; _ck(_v, 242, 0, currVal_139); var currVal_140 = "Chinese"; _ck(_v, 245, 0, currVal_140); var currVal_141 = "Chinese"; _ck(_v, 246, 0, currVal_141); var currVal_142 = "Citizen of Antigua and Barbuda"; _ck(_v, 249, 0, currVal_142); var currVal_143 = "Citizen of Antigua and Barbuda"; _ck(_v, 250, 0, currVal_143); var currVal_144 = "Citizen of Bosnia and Herzegovina"; _ck(_v, 253, 0, currVal_144); var currVal_145 = "Citizen of Bosnia and Herzegovina"; _ck(_v, 254, 0, currVal_145); var currVal_146 = "Citizen of the Dominican Republic"; _ck(_v, 257, 0, currVal_146); var currVal_147 = "Citizen of the Dominican Republic"; _ck(_v, 258, 0, currVal_147); var currVal_148 = "Citizen of Guinea-Bissau"; _ck(_v, 261, 0, currVal_148); var currVal_149 = "Citizen of Guinea-Bissau"; _ck(_v, 262, 0, currVal_149); var currVal_150 = "Citizen of Kiribati"; _ck(_v, 265, 0, currVal_150); var currVal_151 = "Citizen of Kiribati"; _ck(_v, 266, 0, currVal_151); var currVal_152 = "Citizen of Seychelles"; _ck(_v, 269, 0, currVal_152); var currVal_153 = "Citizen of Seychelles"; _ck(_v, 270, 0, currVal_153); var currVal_154 = "Citizen of Vanuatu"; _ck(_v, 273, 0, currVal_154); var currVal_155 = "Citizen of Vanuatu"; _ck(_v, 274, 0, currVal_155); var currVal_156 = "Colombian"; _ck(_v, 277, 0, currVal_156); var currVal_157 = "Colombian"; _ck(_v, 278, 0, currVal_157); var currVal_158 = "Comoran"; _ck(_v, 281, 0, currVal_158); var currVal_159 = "Comoran"; _ck(_v, 282, 0, currVal_159); var currVal_160 = "Congolese (Congo)"; _ck(_v, 285, 0, currVal_160); var currVal_161 = "Congolese (Congo)"; _ck(_v, 286, 0, currVal_161); var currVal_162 = "Congolese (DRC)"; _ck(_v, 289, 0, currVal_162); var currVal_163 = "Congolese (DRC)"; _ck(_v, 290, 0, currVal_163); var currVal_164 = "Cook Islander"; _ck(_v, 293, 0, currVal_164); var currVal_165 = "Cook Islander"; _ck(_v, 294, 0, currVal_165); var currVal_166 = "Costa Rican"; _ck(_v, 297, 0, currVal_166); var currVal_167 = "Costa Rican"; _ck(_v, 298, 0, currVal_167); var currVal_168 = "Croatian"; _ck(_v, 301, 0, currVal_168); var currVal_169 = "Croatian"; _ck(_v, 302, 0, currVal_169); var currVal_170 = "Cuban"; _ck(_v, 305, 0, currVal_170); var currVal_171 = "Cuban"; _ck(_v, 306, 0, currVal_171); var currVal_172 = "Cymraes"; _ck(_v, 309, 0, currVal_172); var currVal_173 = "Cymraes"; _ck(_v, 310, 0, currVal_173); var currVal_174 = "Cymro"; _ck(_v, 313, 0, currVal_174); var currVal_175 = "Cymro"; _ck(_v, 314, 0, currVal_175); var currVal_176 = "Cypriot"; _ck(_v, 317, 0, currVal_176); var currVal_177 = "Cypriot"; _ck(_v, 318, 0, currVal_177); var currVal_178 = "Czech"; _ck(_v, 321, 0, currVal_178); var currVal_179 = "Czech"; _ck(_v, 322, 0, currVal_179); var currVal_180 = "Danish"; _ck(_v, 325, 0, currVal_180); var currVal_181 = "Danish"; _ck(_v, 326, 0, currVal_181); var currVal_182 = "Djiboutian"; _ck(_v, 329, 0, currVal_182); var currVal_183 = "Djiboutian"; _ck(_v, 330, 0, currVal_183); var currVal_184 = "Dominican"; _ck(_v, 333, 0, currVal_184); var currVal_185 = "Dominican"; _ck(_v, 334, 0, currVal_185); var currVal_186 = "Dutch"; _ck(_v, 337, 0, currVal_186); var currVal_187 = "Dutch"; _ck(_v, 338, 0, currVal_187); var currVal_188 = "East Timorese"; _ck(_v, 341, 0, currVal_188); var currVal_189 = "East Timorese"; _ck(_v, 342, 0, currVal_189); var currVal_190 = "Ecuadorean"; _ck(_v, 345, 0, currVal_190); var currVal_191 = "Ecuadorean"; _ck(_v, 346, 0, currVal_191); var currVal_192 = "Egyptian"; _ck(_v, 349, 0, currVal_192); var currVal_193 = "Egyptian"; _ck(_v, 350, 0, currVal_193); var currVal_194 = "Emirati"; _ck(_v, 353, 0, currVal_194); var currVal_195 = "Emirati"; _ck(_v, 354, 0, currVal_195); var currVal_196 = "English"; _ck(_v, 357, 0, currVal_196); var currVal_197 = "English"; _ck(_v, 358, 0, currVal_197); var currVal_198 = "Equatorial Guinean"; _ck(_v, 361, 0, currVal_198); var currVal_199 = "Equatorial Guinean"; _ck(_v, 362, 0, currVal_199); var currVal_200 = "Eritrean"; _ck(_v, 365, 0, currVal_200); var currVal_201 = "Eritrean"; _ck(_v, 366, 0, currVal_201); var currVal_202 = "Estonian"; _ck(_v, 369, 0, currVal_202); var currVal_203 = "Estonian"; _ck(_v, 370, 0, currVal_203); var currVal_204 = "Ethiopian"; _ck(_v, 373, 0, currVal_204); var currVal_205 = "Ethiopian"; _ck(_v, 374, 0, currVal_205); var currVal_206 = "Faroese"; _ck(_v, 377, 0, currVal_206); var currVal_207 = "Faroese"; _ck(_v, 378, 0, currVal_207); var currVal_208 = "Fijian"; _ck(_v, 381, 0, currVal_208); var currVal_209 = "Fijian"; _ck(_v, 382, 0, currVal_209); var currVal_210 = "Filipino"; _ck(_v, 385, 0, currVal_210); var currVal_211 = "Filipino"; _ck(_v, 386, 0, currVal_211); var currVal_212 = "Finnish"; _ck(_v, 389, 0, currVal_212); var currVal_213 = "Finnish"; _ck(_v, 390, 0, currVal_213); var currVal_214 = "French"; _ck(_v, 393, 0, currVal_214); var currVal_215 = "French"; _ck(_v, 394, 0, currVal_215); var currVal_216 = "Gabonese"; _ck(_v, 397, 0, currVal_216); var currVal_217 = "Gabonese"; _ck(_v, 398, 0, currVal_217); var currVal_218 = "Gambian"; _ck(_v, 401, 0, currVal_218); var currVal_219 = "Gambian"; _ck(_v, 402, 0, currVal_219); var currVal_220 = "Georgian"; _ck(_v, 405, 0, currVal_220); var currVal_221 = "Georgian"; _ck(_v, 406, 0, currVal_221); var currVal_222 = "German"; _ck(_v, 409, 0, currVal_222); var currVal_223 = "German"; _ck(_v, 410, 0, currVal_223); var currVal_224 = "Ghanaian"; _ck(_v, 413, 0, currVal_224); var currVal_225 = "Ghanaian"; _ck(_v, 414, 0, currVal_225); var currVal_226 = "Gibraltarian"; _ck(_v, 417, 0, currVal_226); var currVal_227 = "Gibraltarian"; _ck(_v, 418, 0, currVal_227); var currVal_228 = "Greek"; _ck(_v, 421, 0, currVal_228); var currVal_229 = "Greek"; _ck(_v, 422, 0, currVal_229); var currVal_230 = "Greenlandic"; _ck(_v, 425, 0, currVal_230); var currVal_231 = "Greenlandic"; _ck(_v, 426, 0, currVal_231); var currVal_232 = "Grenadian"; _ck(_v, 429, 0, currVal_232); var currVal_233 = "Grenadian"; _ck(_v, 430, 0, currVal_233); var currVal_234 = "Guamanian"; _ck(_v, 433, 0, currVal_234); var currVal_235 = "Guamanian"; _ck(_v, 434, 0, currVal_235); var currVal_236 = "Guatemalan"; _ck(_v, 437, 0, currVal_236); var currVal_237 = "Guatemalan"; _ck(_v, 438, 0, currVal_237); var currVal_238 = "Guinean"; _ck(_v, 441, 0, currVal_238); var currVal_239 = "Guinean"; _ck(_v, 442, 0, currVal_239); var currVal_240 = "Guyanese"; _ck(_v, 445, 0, currVal_240); var currVal_241 = "Guyanese"; _ck(_v, 446, 0, currVal_241); var currVal_242 = "Haitian"; _ck(_v, 449, 0, currVal_242); var currVal_243 = "Haitian"; _ck(_v, 450, 0, currVal_243); var currVal_244 = "Honduran"; _ck(_v, 453, 0, currVal_244); var currVal_245 = "Honduran"; _ck(_v, 454, 0, currVal_245); var currVal_246 = "Hong Konger"; _ck(_v, 457, 0, currVal_246); var currVal_247 = "Hong Konger"; _ck(_v, 458, 0, currVal_247); var currVal_248 = "Hungarian"; _ck(_v, 461, 0, currVal_248); var currVal_249 = "Hungarian"; _ck(_v, 462, 0, currVal_249); var currVal_250 = "Icelandic"; _ck(_v, 465, 0, currVal_250); var currVal_251 = "Icelandic"; _ck(_v, 466, 0, currVal_251); var currVal_252 = "Indian"; _ck(_v, 469, 0, currVal_252); var currVal_253 = "Indian"; _ck(_v, 470, 0, currVal_253); var currVal_254 = "Indonesian"; _ck(_v, 473, 0, currVal_254); var currVal_255 = "Indonesian"; _ck(_v, 474, 0, currVal_255); var currVal_256 = "Irish"; _ck(_v, 477, 0, currVal_256); var currVal_257 = "Irish"; _ck(_v, 478, 0, currVal_257); var currVal_258 = "Iraqi"; _ck(_v, 481, 0, currVal_258); var currVal_259 = "Iraqi"; _ck(_v, 482, 0, currVal_259); var currVal_260 = "Iranian"; _ck(_v, 485, 0, currVal_260); var currVal_261 = "Iranian"; _ck(_v, 486, 0, currVal_261); var currVal_262 = "Israeli"; _ck(_v, 489, 0, currVal_262); var currVal_263 = "Israeli"; _ck(_v, 490, 0, currVal_263); var currVal_264 = "Italian"; _ck(_v, 493, 0, currVal_264); var currVal_265 = "Italian"; _ck(_v, 494, 0, currVal_265); var currVal_266 = "Ivorian"; _ck(_v, 497, 0, currVal_266); var currVal_267 = "Ivorian"; _ck(_v, 498, 0, currVal_267); var currVal_268 = "Jamaican"; _ck(_v, 501, 0, currVal_268); var currVal_269 = "Jamaican"; _ck(_v, 502, 0, currVal_269); var currVal_270 = "Japanese"; _ck(_v, 505, 0, currVal_270); var currVal_271 = "Japanese"; _ck(_v, 506, 0, currVal_271); var currVal_272 = "Jordanian"; _ck(_v, 509, 0, currVal_272); var currVal_273 = "Jordanian"; _ck(_v, 510, 0, currVal_273); var currVal_274 = "Kazakh"; _ck(_v, 513, 0, currVal_274); var currVal_275 = "Kazakh"; _ck(_v, 514, 0, currVal_275); var currVal_276 = "Kenyan"; _ck(_v, 517, 0, currVal_276); var currVal_277 = "Kenyan"; _ck(_v, 518, 0, currVal_277); var currVal_278 = "Kittitian"; _ck(_v, 521, 0, currVal_278); var currVal_279 = "Kittitian"; _ck(_v, 522, 0, currVal_279); var currVal_280 = "Kosovan"; _ck(_v, 525, 0, currVal_280); var currVal_281 = "Kosovan"; _ck(_v, 526, 0, currVal_281); var currVal_282 = "Kuwaiti"; _ck(_v, 529, 0, currVal_282); var currVal_283 = "Kuwaiti"; _ck(_v, 530, 0, currVal_283); var currVal_284 = "Kyrgyz"; _ck(_v, 533, 0, currVal_284); var currVal_285 = "Kyrgyz"; _ck(_v, 534, 0, currVal_285); var currVal_286 = "Lao"; _ck(_v, 537, 0, currVal_286); var currVal_287 = "Lao"; _ck(_v, 538, 0, currVal_287); var currVal_288 = "Latvian"; _ck(_v, 541, 0, currVal_288); var currVal_289 = "Latvian"; _ck(_v, 542, 0, currVal_289); var currVal_290 = "Lebanese"; _ck(_v, 545, 0, currVal_290); var currVal_291 = "Lebanese"; _ck(_v, 546, 0, currVal_291); var currVal_292 = "Liberian"; _ck(_v, 549, 0, currVal_292); var currVal_293 = "Liberian"; _ck(_v, 550, 0, currVal_293); var currVal_294 = "Libyan"; _ck(_v, 553, 0, currVal_294); var currVal_295 = "Libyan"; _ck(_v, 554, 0, currVal_295); var currVal_296 = "Liechtenstein citizen"; _ck(_v, 557, 0, currVal_296); var currVal_297 = "Liechtenstein citizen"; _ck(_v, 558, 0, currVal_297); var currVal_298 = "Lithuanian"; _ck(_v, 561, 0, currVal_298); var currVal_299 = "Lithuanian"; _ck(_v, 562, 0, currVal_299); var currVal_300 = "Luxembourger"; _ck(_v, 565, 0, currVal_300); var currVal_301 = "Luxembourger"; _ck(_v, 566, 0, currVal_301); var currVal_302 = "Macanese"; _ck(_v, 569, 0, currVal_302); var currVal_303 = "Macanese"; _ck(_v, 570, 0, currVal_303); var currVal_304 = "Macedonian"; _ck(_v, 573, 0, currVal_304); var currVal_305 = "Macedonian"; _ck(_v, 574, 0, currVal_305); var currVal_306 = "Malagasy"; _ck(_v, 577, 0, currVal_306); var currVal_307 = "Malagasy"; _ck(_v, 578, 0, currVal_307); var currVal_308 = "Malawian"; _ck(_v, 581, 0, currVal_308); var currVal_309 = "Malawian"; _ck(_v, 582, 0, currVal_309); var currVal_310 = "Maldivian"; _ck(_v, 585, 0, currVal_310); var currVal_311 = "Maldivian"; _ck(_v, 586, 0, currVal_311); var currVal_312 = "Malian"; _ck(_v, 589, 0, currVal_312); var currVal_313 = "Malian"; _ck(_v, 590, 0, currVal_313); var currVal_314 = "Maltese"; _ck(_v, 593, 0, currVal_314); var currVal_315 = "Maltese"; _ck(_v, 594, 0, currVal_315); var currVal_316 = "Marshallese"; _ck(_v, 597, 0, currVal_316); var currVal_317 = "Marshallese"; _ck(_v, 598, 0, currVal_317); var currVal_318 = "Martiniquais"; _ck(_v, 601, 0, currVal_318); var currVal_319 = "Martiniquais"; _ck(_v, 602, 0, currVal_319); var currVal_320 = "Mauritanian"; _ck(_v, 605, 0, currVal_320); var currVal_321 = "Mauritanian"; _ck(_v, 606, 0, currVal_321); var currVal_322 = "Mauritian"; _ck(_v, 609, 0, currVal_322); var currVal_323 = "Mauritian"; _ck(_v, 610, 0, currVal_323); var currVal_324 = "Mexican"; _ck(_v, 613, 0, currVal_324); var currVal_325 = "Mexican"; _ck(_v, 614, 0, currVal_325); var currVal_326 = "Micronesian"; _ck(_v, 617, 0, currVal_326); var currVal_327 = "Micronesian"; _ck(_v, 618, 0, currVal_327); var currVal_328 = "Moldovan"; _ck(_v, 621, 0, currVal_328); var currVal_329 = "Moldovan"; _ck(_v, 622, 0, currVal_329); var currVal_330 = "Monegasque"; _ck(_v, 625, 0, currVal_330); var currVal_331 = "Monegasque"; _ck(_v, 626, 0, currVal_331); var currVal_332 = "Mongolian"; _ck(_v, 629, 0, currVal_332); var currVal_333 = "Mongolian"; _ck(_v, 630, 0, currVal_333); var currVal_334 = "Montenegrin"; _ck(_v, 633, 0, currVal_334); var currVal_335 = "Montenegrin"; _ck(_v, 634, 0, currVal_335); var currVal_336 = "Montserratian"; _ck(_v, 637, 0, currVal_336); var currVal_337 = "Montserratian"; _ck(_v, 638, 0, currVal_337); var currVal_338 = "Moroccan"; _ck(_v, 641, 0, currVal_338); var currVal_339 = "Moroccan"; _ck(_v, 642, 0, currVal_339); var currVal_340 = "Mosotho"; _ck(_v, 645, 0, currVal_340); var currVal_341 = "Mosotho"; _ck(_v, 646, 0, currVal_341); var currVal_342 = "Mozambican"; _ck(_v, 649, 0, currVal_342); var currVal_343 = "Mozambican"; _ck(_v, 650, 0, currVal_343); var currVal_344 = "Namibian"; _ck(_v, 653, 0, currVal_344); var currVal_345 = "Namibian"; _ck(_v, 654, 0, currVal_345); var currVal_346 = "Nauruan"; _ck(_v, 657, 0, currVal_346); var currVal_347 = "Nauruan"; _ck(_v, 658, 0, currVal_347); var currVal_348 = "Nepalese"; _ck(_v, 661, 0, currVal_348); var currVal_349 = "Nepalese"; _ck(_v, 662, 0, currVal_349); var currVal_350 = "New Zealander"; _ck(_v, 665, 0, currVal_350); var currVal_351 = "New Zealander"; _ck(_v, 666, 0, currVal_351); var currVal_352 = "Nicaraguan"; _ck(_v, 669, 0, currVal_352); var currVal_353 = "Nicaraguan"; _ck(_v, 670, 0, currVal_353); var currVal_354 = "Nigerien"; _ck(_v, 673, 0, currVal_354); var currVal_355 = "Nigerien"; _ck(_v, 674, 0, currVal_355); var currVal_356 = "Niger Republic"; _ck(_v, 677, 0, currVal_356); var currVal_357 = "Niger Republic"; _ck(_v, 678, 0, currVal_357); var currVal_358 = "Niuean"; _ck(_v, 681, 0, currVal_358); var currVal_359 = "Niuean"; _ck(_v, 682, 0, currVal_359); var currVal_360 = "North Korean"; _ck(_v, 685, 0, currVal_360); var currVal_361 = "North Korean"; _ck(_v, 686, 0, currVal_361); var currVal_362 = "Northern Irish"; _ck(_v, 689, 0, currVal_362); var currVal_363 = "Northern Irish"; _ck(_v, 690, 0, currVal_363); var currVal_364 = "Norwegian"; _ck(_v, 693, 0, currVal_364); var currVal_365 = "Norwegian"; _ck(_v, 694, 0, currVal_365); var currVal_366 = "Omani"; _ck(_v, 697, 0, currVal_366); var currVal_367 = "Omani"; _ck(_v, 698, 0, currVal_367); var currVal_368 = "Pakistani"; _ck(_v, 701, 0, currVal_368); var currVal_369 = "Pakistani"; _ck(_v, 702, 0, currVal_369); var currVal_370 = "Palauan"; _ck(_v, 705, 0, currVal_370); var currVal_371 = "Palauan"; _ck(_v, 706, 0, currVal_371); var currVal_372 = "Palestinian"; _ck(_v, 709, 0, currVal_372); var currVal_373 = "Palestinian"; _ck(_v, 710, 0, currVal_373); var currVal_374 = "Panamanian"; _ck(_v, 713, 0, currVal_374); var currVal_375 = "Panamanian"; _ck(_v, 714, 0, currVal_375); var currVal_376 = "Papua New Guinean"; _ck(_v, 717, 0, currVal_376); var currVal_377 = "Papua New Guinean"; _ck(_v, 718, 0, currVal_377); var currVal_378 = "Paraguayan"; _ck(_v, 721, 0, currVal_378); var currVal_379 = "Paraguayan"; _ck(_v, 722, 0, currVal_379); var currVal_380 = "Peruvian"; _ck(_v, 725, 0, currVal_380); var currVal_381 = "Peruvian"; _ck(_v, 726, 0, currVal_381); var currVal_382 = "Pitcairn Islander"; _ck(_v, 729, 0, currVal_382); var currVal_383 = "Pitcairn Islander"; _ck(_v, 730, 0, currVal_383); var currVal_384 = "Polish"; _ck(_v, 733, 0, currVal_384); var currVal_385 = "Polish"; _ck(_v, 734, 0, currVal_385); var currVal_386 = "Portuguese"; _ck(_v, 737, 0, currVal_386); var currVal_387 = "Portuguese"; _ck(_v, 738, 0, currVal_387); var currVal_388 = "Prydeinig"; _ck(_v, 741, 0, currVal_388); var currVal_389 = "Prydeinig"; _ck(_v, 742, 0, currVal_389); var currVal_390 = "Puerto Rican"; _ck(_v, 745, 0, currVal_390); var currVal_391 = "Puerto Rican"; _ck(_v, 746, 0, currVal_391); var currVal_392 = "Qatari"; _ck(_v, 749, 0, currVal_392); var currVal_393 = "Qatari"; _ck(_v, 750, 0, currVal_393); var currVal_394 = "Romanian"; _ck(_v, 753, 0, currVal_394); var currVal_395 = "Romanian"; _ck(_v, 754, 0, currVal_395); var currVal_396 = "Russian"; _ck(_v, 757, 0, currVal_396); var currVal_397 = "Russian"; _ck(_v, 758, 0, currVal_397); var currVal_398 = "Rwandan"; _ck(_v, 761, 0, currVal_398); var currVal_399 = "Rwandan"; _ck(_v, 762, 0, currVal_399); var currVal_400 = "Salvadorean"; _ck(_v, 765, 0, currVal_400); var currVal_401 = "Salvadorean"; _ck(_v, 766, 0, currVal_401); var currVal_402 = "Samoan"; _ck(_v, 769, 0, currVal_402); var currVal_403 = "Samoan"; _ck(_v, 770, 0, currVal_403); var currVal_404 = "Sammarinese"; _ck(_v, 773, 0, currVal_404); var currVal_405 = "Sammarinese"; _ck(_v, 774, 0, currVal_405); var currVal_406 = "Sao Tomean"; _ck(_v, 777, 0, currVal_406); var currVal_407 = "Sao Tomean"; _ck(_v, 778, 0, currVal_407); var currVal_408 = "Saudi Arabian"; _ck(_v, 781, 0, currVal_408); var currVal_409 = "Saudi Arabian"; _ck(_v, 782, 0, currVal_409); var currVal_410 = "Scottish"; _ck(_v, 785, 0, currVal_410); var currVal_411 = "Scottish"; _ck(_v, 786, 0, currVal_411); var currVal_412 = "Senegalese"; _ck(_v, 789, 0, currVal_412); var currVal_413 = "Senegalese"; _ck(_v, 790, 0, currVal_413); var currVal_414 = "Serbian"; _ck(_v, 793, 0, currVal_414); var currVal_415 = "Serbian"; _ck(_v, 794, 0, currVal_415); var currVal_416 = "Sierra Leonean"; _ck(_v, 797, 0, currVal_416); var currVal_417 = "Sierra Leonean"; _ck(_v, 798, 0, currVal_417); var currVal_418 = "Singaporean"; _ck(_v, 801, 0, currVal_418); var currVal_419 = "Singaporean"; _ck(_v, 802, 0, currVal_419); var currVal_420 = "Slovak"; _ck(_v, 805, 0, currVal_420); var currVal_421 = "Slovak"; _ck(_v, 806, 0, currVal_421); var currVal_422 = "Slovenian"; _ck(_v, 809, 0, currVal_422); var currVal_423 = "Slovenian"; _ck(_v, 810, 0, currVal_423); var currVal_424 = "Solomon Islander"; _ck(_v, 813, 0, currVal_424); var currVal_425 = "Solomon Islander"; _ck(_v, 814, 0, currVal_425); var currVal_426 = "Somali"; _ck(_v, 817, 0, currVal_426); var currVal_427 = "Somali"; _ck(_v, 818, 0, currVal_427); var currVal_428 = "South African"; _ck(_v, 821, 0, currVal_428); var currVal_429 = "South African"; _ck(_v, 822, 0, currVal_429); var currVal_430 = "South Korean"; _ck(_v, 825, 0, currVal_430); var currVal_431 = "South Korean"; _ck(_v, 826, 0, currVal_431); var currVal_432 = "South Sudanese"; _ck(_v, 829, 0, currVal_432); var currVal_433 = "South Sudanese"; _ck(_v, 830, 0, currVal_433); var currVal_434 = "Spanish"; _ck(_v, 833, 0, currVal_434); var currVal_435 = "Spanish"; _ck(_v, 834, 0, currVal_435); var currVal_436 = "Sri Lankan"; _ck(_v, 837, 0, currVal_436); var currVal_437 = "Sri Lankan"; _ck(_v, 838, 0, currVal_437); var currVal_438 = "St Helenian"; _ck(_v, 841, 0, currVal_438); var currVal_439 = "St Helenian"; _ck(_v, 842, 0, currVal_439); var currVal_440 = "St Lucian"; _ck(_v, 845, 0, currVal_440); var currVal_441 = "St Lucian"; _ck(_v, 846, 0, currVal_441); var currVal_442 = "Stateless"; _ck(_v, 849, 0, currVal_442); var currVal_443 = "Stateless"; _ck(_v, 850, 0, currVal_443); var currVal_444 = "Sudanese"; _ck(_v, 853, 0, currVal_444); var currVal_445 = "Sudanese"; _ck(_v, 854, 0, currVal_445); var currVal_446 = "Surinamese"; _ck(_v, 857, 0, currVal_446); var currVal_447 = "Surinamese"; _ck(_v, 858, 0, currVal_447); var currVal_448 = "Swazi"; _ck(_v, 861, 0, currVal_448); var currVal_449 = "Swazi"; _ck(_v, 862, 0, currVal_449); var currVal_450 = "Swedish"; _ck(_v, 865, 0, currVal_450); var currVal_451 = "Swedish"; _ck(_v, 866, 0, currVal_451); var currVal_452 = "Swiss"; _ck(_v, 869, 0, currVal_452); var currVal_453 = "Swiss"; _ck(_v, 870, 0, currVal_453); var currVal_454 = "Syrian"; _ck(_v, 873, 0, currVal_454); var currVal_455 = "Syrian"; _ck(_v, 874, 0, currVal_455); var currVal_456 = "Taiwanese"; _ck(_v, 877, 0, currVal_456); var currVal_457 = "Taiwanese"; _ck(_v, 878, 0, currVal_457); var currVal_458 = "Tajik"; _ck(_v, 881, 0, currVal_458); var currVal_459 = "Tajik"; _ck(_v, 882, 0, currVal_459); var currVal_460 = "Tanzanian"; _ck(_v, 885, 0, currVal_460); var currVal_461 = "Tanzanian"; _ck(_v, 886, 0, currVal_461); var currVal_462 = "Thai"; _ck(_v, 889, 0, currVal_462); var currVal_463 = "Thai"; _ck(_v, 890, 0, currVal_463); var currVal_464 = "Togolese"; _ck(_v, 893, 0, currVal_464); var currVal_465 = "Togolese"; _ck(_v, 894, 0, currVal_465); var currVal_466 = "Tongan"; _ck(_v, 897, 0, currVal_466); var currVal_467 = "Tongan"; _ck(_v, 898, 0, currVal_467); var currVal_468 = "Trinidadian"; _ck(_v, 901, 0, currVal_468); var currVal_469 = "Trinidadian"; _ck(_v, 902, 0, currVal_469); var currVal_470 = "Tristanian"; _ck(_v, 905, 0, currVal_470); var currVal_471 = "Tristanian"; _ck(_v, 906, 0, currVal_471); var currVal_472 = "Tunisian"; _ck(_v, 909, 0, currVal_472); var currVal_473 = "Tunisian"; _ck(_v, 910, 0, currVal_473); var currVal_474 = "Turkish"; _ck(_v, 913, 0, currVal_474); var currVal_475 = "Turkish"; _ck(_v, 914, 0, currVal_475); var currVal_476 = "Turkmen"; _ck(_v, 917, 0, currVal_476); var currVal_477 = "Turkmen"; _ck(_v, 918, 0, currVal_477); var currVal_478 = "Turks and Caicos Islander"; _ck(_v, 921, 0, currVal_478); var currVal_479 = "Turks and Caicos Islander"; _ck(_v, 922, 0, currVal_479); var currVal_480 = "Tuvaluan"; _ck(_v, 925, 0, currVal_480); var currVal_481 = "Tuvaluan"; _ck(_v, 926, 0, currVal_481); var currVal_482 = "Ugandan"; _ck(_v, 929, 0, currVal_482); var currVal_483 = "Ugandan"; _ck(_v, 930, 0, currVal_483); var currVal_484 = "Ukrainian"; _ck(_v, 933, 0, currVal_484); var currVal_485 = "Ukrainian"; _ck(_v, 934, 0, currVal_485); var currVal_486 = "Uruguayan"; _ck(_v, 937, 0, currVal_486); var currVal_487 = "Uruguayan"; _ck(_v, 938, 0, currVal_487); var currVal_488 = "Uzbek"; _ck(_v, 941, 0, currVal_488); var currVal_489 = "Uzbek"; _ck(_v, 942, 0, currVal_489); var currVal_490 = "Vatican citizen"; _ck(_v, 945, 0, currVal_490); var currVal_491 = "Vatican citizen"; _ck(_v, 946, 0, currVal_491); var currVal_492 = "Venezuelan"; _ck(_v, 949, 0, currVal_492); var currVal_493 = "Venezuelan"; _ck(_v, 950, 0, currVal_493); var currVal_494 = "Vietnamese"; _ck(_v, 953, 0, currVal_494); var currVal_495 = "Vietnamese"; _ck(_v, 954, 0, currVal_495); var currVal_496 = "Vincentian"; _ck(_v, 957, 0, currVal_496); var currVal_497 = "Vincentian"; _ck(_v, 958, 0, currVal_497); var currVal_498 = "Wallisian"; _ck(_v, 961, 0, currVal_498); var currVal_499 = "Wallisian"; _ck(_v, 962, 0, currVal_499); var currVal_500 = "Welsh"; _ck(_v, 965, 0, currVal_500); var currVal_501 = "Welsh"; _ck(_v, 966, 0, currVal_501); var currVal_502 = "Yemeni"; _ck(_v, 969, 0, currVal_502); var currVal_503 = "Yemeni"; _ck(_v, 970, 0, currVal_503); var currVal_504 = "Zambian"; _ck(_v, 973, 0, currVal_504); var currVal_505 = "Zambian"; _ck(_v, 974, 0, currVal_505); var currVal_506 = "Zimbabwean"; _ck(_v, 977, 0, currVal_506); var currVal_507 = "Zimbabwean"; _ck(_v, 978, 0, currVal_507); var currVal_515 = "reason"; var currVal_516 = _co._activeEmployee.reason; _ck(_v, 989, 0, currVal_515, currVal_516); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 18).disabled; var currVal_1 = core["ɵnov"](_v, 24).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 24).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 24).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 24).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 24).ngClassValid; var currVal_6 = core["ɵnov"](_v, 24).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 24).ngClassPending; _ck(_v, 14, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_11 = core["ɵnov"](_v, 36).ngClassUntouched; var currVal_12 = core["ɵnov"](_v, 36).ngClassTouched; var currVal_13 = core["ɵnov"](_v, 36).ngClassPristine; var currVal_14 = core["ɵnov"](_v, 36).ngClassDirty; var currVal_15 = core["ɵnov"](_v, 36).ngClassValid; var currVal_16 = core["ɵnov"](_v, 36).ngClassInvalid; var currVal_17 = core["ɵnov"](_v, 36).ngClassPending; _ck(_v, 31, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_21 = core["ɵnov"](_v, 46).ngClassUntouched; var currVal_22 = core["ɵnov"](_v, 46).ngClassTouched; var currVal_23 = core["ɵnov"](_v, 46).ngClassPristine; var currVal_24 = core["ɵnov"](_v, 46).ngClassDirty; var currVal_25 = core["ɵnov"](_v, 46).ngClassValid; var currVal_26 = core["ɵnov"](_v, 46).ngClassInvalid; var currVal_27 = core["ɵnov"](_v, 46).ngClassPending; _ck(_v, 41, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27); var currVal_30 = core["ɵnov"](_v, 57).ngClassUntouched; var currVal_31 = core["ɵnov"](_v, 57).ngClassTouched; var currVal_32 = core["ɵnov"](_v, 57).ngClassPristine; var currVal_33 = core["ɵnov"](_v, 57).ngClassDirty; var currVal_34 = core["ɵnov"](_v, 57).ngClassValid; var currVal_35 = core["ɵnov"](_v, 57).ngClassInvalid; var currVal_36 = core["ɵnov"](_v, 57).ngClassPending; _ck(_v, 52, 0, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36); var currVal_39 = core["ɵnov"](_v, 67).ngClassUntouched; var currVal_40 = core["ɵnov"](_v, 67).ngClassTouched; var currVal_41 = core["ɵnov"](_v, 67).ngClassPristine; var currVal_42 = core["ɵnov"](_v, 67).ngClassDirty; var currVal_43 = core["ɵnov"](_v, 67).ngClassValid; var currVal_44 = core["ɵnov"](_v, 67).ngClassInvalid; var currVal_45 = core["ɵnov"](_v, 67).ngClassPending; _ck(_v, 62, 0, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45); var currVal_49 = core["ɵnov"](_v, 79).ngClassUntouched; var currVal_50 = core["ɵnov"](_v, 79).ngClassTouched; var currVal_51 = core["ɵnov"](_v, 79).ngClassPristine; var currVal_52 = core["ɵnov"](_v, 79).ngClassDirty; var currVal_53 = core["ɵnov"](_v, 79).ngClassValid; var currVal_54 = core["ɵnov"](_v, 79).ngClassInvalid; var currVal_55 = core["ɵnov"](_v, 79).ngClassPending; _ck(_v, 74, 0, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55); var currVal_508 = core["ɵnov"](_v, 991).ngClassUntouched; var currVal_509 = core["ɵnov"](_v, 991).ngClassTouched; var currVal_510 = core["ɵnov"](_v, 991).ngClassPristine; var currVal_511 = core["ɵnov"](_v, 991).ngClassDirty; var currVal_512 = core["ɵnov"](_v, 991).ngClassValid; var currVal_513 = core["ɵnov"](_v, 991).ngClassInvalid; var currVal_514 = core["ɵnov"](_v, 991).ngClassPending; _ck(_v, 986, 0, currVal_508, currVal_509, currVal_510, currVal_511, currVal_512, currVal_513, currVal_514); });
}
function View_EmployeesListingPage_0(_l) {
    return core["ɵvid"](0, [core["ɵpid"](0, statusPipe_EmployeeStatus, []), (_l()(), core["ɵeld"](1, 0, null, null, 85, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                _co.clicked();
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addEmployees() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 16777216, null, null, 1, "employeeFilter", [], null, [[null, "searchEmp"], ["window", "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 13).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("searchEmp" === en)) {
                var pd_1 = (_co.showSearchFilter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EmployeeFilter_0, RenderType_EmployeeFilter)), core["ɵdid"](13, 114688, null, 0, employeeFilter_EmployeeFilter, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { displayTab: [0, "displayTab"] }, { searchEmp: "searchEmp" }), (_l()(), core["ɵeld"](14, 0, null, null, 41, "div", [["class", "w-100 float-left mt-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 36, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](28, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](30, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](32, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](38, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](40, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](42, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](44, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](46, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](48, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](49, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_1)), core["ɵdid"](53, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeesListingPage_32)), core["ɵdid"](55, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](56, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                _co.clicked();
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 2, "h6", [["class", "float-left mb-0 mr-4"]], null, null, null, null, null)), (_l()(), core["ɵted"](58, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](60, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](61, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](62, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](64, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 65).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 65).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.searchData.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onPageSizeChange() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](65, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](67, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](69, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](70, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](71, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](72, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](74, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](75, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](76, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](78, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](79, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](80, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](82, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](83, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.searchData.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.getEmployee() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](84, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](85, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](86, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null)), (_l()(), core["ɵand"](0, [["changeRoleModal", 2]], null, 0, null, View_EmployeesListingPage_35)), (_l()(), core["ɵand"](0, [["changeIdModal", 2]], null, 0, null, View_EmployeesListingPage_37)), (_l()(), core["ɵand"](0, [["employeeModal", 2]], null, 0, null, View_EmployeesListingPage_40))], function (_ck, _v) { var _co = _v.component; var currVal_2 = "employeeSearch"; _ck(_v, 13, 0, currVal_2); var currVal_12 = (_co.employeeData.length > 0); _ck(_v, 53, 0, currVal_12); var currVal_13 = (_co.employeeData.length == 0); _ck(_v, 55, 0, currVal_13); var currVal_26 = _co.searchData.pageSize; _ck(_v, 67, 0, currVal_26); var currVal_27 = "10"; _ck(_v, 71, 0, currVal_27); var currVal_28 = "10"; _ck(_v, 72, 0, currVal_28); var currVal_29 = "20"; _ck(_v, 75, 0, currVal_29); var currVal_30 = "20"; _ck(_v, 76, 0, currVal_30); var currVal_31 = "30"; _ck(_v, 79, 0, currVal_31); var currVal_32 = "30"; _ck(_v, 80, 0, currVal_32); var currVal_33 = true; var currVal_34 = false; var currVal_35 = true; var currVal_36 = _co.employeePageData.totalElements; var currVal_37 = 5; var currVal_38 = _co.searchData.page; var currVal_39 = _co.searchData.pageSize; _ck(_v, 84, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("users")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("addUsers")); _ck(_v, 9, 0, currVal_1); var currVal_3 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("userId")); _ck(_v, 18, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("licenceNumber")); _ck(_v, 22, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("name")); _ck(_v, 26, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 30, 0, core["ɵnov"](_v, 31).transform("orgUit")); _ck(_v, 30, 0, currVal_6); var currVal_7 = core["ɵunv"](_v, 34, 0, core["ɵnov"](_v, 35).transform("designation")); _ck(_v, 34, 0, currVal_7); var currVal_8 = core["ɵunv"](_v, 38, 0, core["ɵnov"](_v, 39).transform("supervisor")); _ck(_v, 38, 0, currVal_8); var currVal_9 = core["ɵunv"](_v, 42, 0, core["ɵnov"](_v, 43).transform("icVerified")); _ck(_v, 42, 0, currVal_9); var currVal_10 = core["ɵunv"](_v, 46, 0, core["ɵnov"](_v, 47).transform("status")); _ck(_v, 46, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("actions")); _ck(_v, 50, 0, currVal_11); var currVal_14 = (((_co.searchData.page - 1) * _co.searchData.pageSize) + 1); var currVal_15 = ((_co.searchData.pageSize * (_co.searchData.page - 1)) + _co.employeePageData.numberOfElements); var currVal_16 = core["ɵunv"](_v, 58, 2, core["ɵnov"](_v, 59).transform("itemsOf")); var currVal_17 = _co.employeePageData.totalElements; _ck(_v, 58, 0, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_18 = core["ɵunv"](_v, 62, 0, core["ɵnov"](_v, 63).transform("showItemsPerPage")); _ck(_v, 62, 0, currVal_18); var currVal_19 = core["ɵnov"](_v, 69).ngClassUntouched; var currVal_20 = core["ɵnov"](_v, 69).ngClassTouched; var currVal_21 = core["ɵnov"](_v, 69).ngClassPristine; var currVal_22 = core["ɵnov"](_v, 69).ngClassDirty; var currVal_23 = core["ɵnov"](_v, 69).ngClassValid; var currVal_24 = core["ɵnov"](_v, 69).ngClassInvalid; var currVal_25 = core["ɵnov"](_v, 69).ngClassPending; _ck(_v, 64, 0, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25); });
}
function View_EmployeesListingPage_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "EmployeesMenu", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_EmployeesListingPage_0, RenderType_EmployeesListingPage)), core["ɵdid"](1, 49152, null, 0, employeeList_EmployeesListingPage, [fesm5_router["a" /* ActivatedRoute */], NgbModal, NgbActiveModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, core["ViewContainerRef"]], null, null)], null, null);
}
var EmployeesListingPageNgFactory = /*@__PURE__*/ core["ɵccf"]("EmployeesMenu", employeeList_EmployeesListingPage, View_EmployeesListingPage_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/employee/employeeSearch.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_employeeFilter.ngfactory,_employeeFilter,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_angular_platform_browser,_angular_forms,_toasterComponent_toasterComponent,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_employeeSearch PURE_IMPORTS_END */


















var styles_EmployeeSearch = [];
var RenderType_EmployeeSearch = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmployeeSearch, data: {} });

function View_EmployeeSearch_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " (", ") "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.orgName; var currVal_1 = _v.parent.context.$implicit.orgCode; _ck(_v, 1, 0, currVal_0, currVal_1); }); }
function View_EmployeeSearch_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeeSearch_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.gradeName; _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeeSearch_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeeSearch_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.designationName; _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeeSearch_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeeSearch_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 21, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_3)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_4)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_5)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_6)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](17, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_7)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_8)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_2 = (_v.context.$implicit.orgId != null); _ck(_v, 9, 0, currVal_2); var currVal_3 = (_v.context.$implicit.orgId == null); _ck(_v, 11, 0, currVal_3); var currVal_4 = (_v.context.$implicit.gradeName != null); _ck(_v, 14, 0, currVal_4); var currVal_5 = (_v.context.$implicit.gradeName == null); _ck(_v, 16, 0, currVal_5); var currVal_6 = (_v.context.$implicit.designationName != null); _ck(_v, 19, 0, currVal_6); var currVal_7 = (_v.context.$implicit.designationName == null); _ck(_v, 21, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.empCode; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.displayName; _ck(_v, 6, 0, currVal_1); }); }
function View_EmployeeSearch_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_EmployeeSearch_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_EmployeeSearch_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_EmployeeSearch_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_10)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_11)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_EmployeeSearch_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_EmployeeSearch_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-primary float-right mb-4"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.startProgram() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_13)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.showButtonLoading; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showButtonLoading; _ck(_v, 0, 0, currVal_0); var currVal_2 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("startProg")); _ck(_v, 3, 0, currVal_2); });
}
function View_EmployeeSearch_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_EmployeeSearch_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-primary float-right mb-4"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.assignSwitchUserPermission() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_15)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.showButtonLoading; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showButtonLoading; _ck(_v, 0, 0, currVal_0); var currVal_2 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("addEmployee")); _ck(_v, 3, 0, currVal_2); });
}
function View_EmployeeSearch_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_EmployeeSearch_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-primary float-right mb-4"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.validateAndTrigger() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_17)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.showButtonLoading; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showButtonLoading; _ck(_v, 0, 0, currVal_0); var currVal_2 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("triggerReview")); _ck(_v, 3, 0, currVal_2); });
}
function View_EmployeeSearch_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_EmployeeSearch_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-primary float-right mb-4"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.enrollEmployeesConfirm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_19)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.showButtonLoading; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showButtonLoading; _ck(_v, 0, 0, currVal_0); var currVal_2 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("enrollEmployees")); _ck(_v, 3, 0, currVal_2); });
}
function View_EmployeeSearch_21(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_EmployeeSearch_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-primary float-right mb-4"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.announcementEmployeeConfirm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_21)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.showButtonLoading; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showButtonLoading; _ck(_v, 0, 0, currVal_0); var currVal_2 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("makeAnnouncementNow")); _ck(_v, 3, 0, currVal_2); });
}
function View_EmployeeSearch_22(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.finalAddRole() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disableButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_1); });
}
function View_EmployeeSearch_23(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.finalAddUsers() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disableButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_1); });
}
function View_EmployeeSearch_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 83, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                _co.clicked();
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 3, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToValBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 16777216, null, null, 1, "employeeFilter", [], null, [[null, "searchEmp"], ["window", "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 13).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("searchEmp" === en)) {
                var pd_1 = (_co.showSearchFilter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EmployeeFilter_0, RenderType_EmployeeFilter)), core["ɵdid"](13, 114688, null, 0, employeeFilter_EmployeeFilter, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { displayTab: [0, "displayTab"] }, { searchEmp: "searchEmp" }), (_l()(), core["ɵeld"](14, 0, null, null, 25, "div", [["class", "w-100 float-left mt-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 20, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](28, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](30, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](32, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_1)), core["ɵdid"](37, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_9)), core["ɵdid"](39, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](40, 0, null, null, 28, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                _co.clicked();
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 2, "h6", [["class", "float-left mb-0 mr-4"]], null, null, null, null, null)), (_l()(), core["ɵted"](42, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](44, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](46, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](48, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 49).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 49).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.searchData.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onPageSizeChange() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](49, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](51, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](53, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](54, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](55, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](56, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](58, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](59, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](60, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](62, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](63, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](64, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](66, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](67, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.searchData.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.getEmployee() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](68, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](69, 0, null, null, 14, "div", [["class", "w-100 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_12)), core["ɵdid"](71, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_14)), core["ɵdid"](73, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_16)), core["ɵdid"](75, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_18)), core["ɵdid"](77, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_20)), core["ɵdid"](79, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_22)), core["ɵdid"](81, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeSearch_23)), core["ɵdid"](83, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = "startProgram"; _ck(_v, 13, 0, currVal_2); var currVal_8 = (_co.employeeData.length > 0); _ck(_v, 37, 0, currVal_8); var currVal_9 = (_co.employeeData.length == 0); _ck(_v, 39, 0, currVal_9); var currVal_22 = _co.searchData.pageSize; _ck(_v, 51, 0, currVal_22); var currVal_23 = "10"; _ck(_v, 55, 0, currVal_23); var currVal_24 = "10"; _ck(_v, 56, 0, currVal_24); var currVal_25 = "20"; _ck(_v, 59, 0, currVal_25); var currVal_26 = "20"; _ck(_v, 60, 0, currVal_26); var currVal_27 = "30"; _ck(_v, 63, 0, currVal_27); var currVal_28 = "30"; _ck(_v, 64, 0, currVal_28); var currVal_29 = true; var currVal_30 = false; var currVal_31 = true; var currVal_32 = _co.employeePageData.totalElements; var currVal_33 = 5; var currVal_34 = _co.searchData.page; var currVal_35 = _co.searchData.pageSize; _ck(_v, 68, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35); var currVal_36 = ((_co.employeeData.length > 0) && (_co.displayType == "Start")); _ck(_v, 71, 0, currVal_36); var currVal_37 = ((_co.employeeData.length > 0) && (_co.displayType == "SWITCH")); _ck(_v, 73, 0, currVal_37); var currVal_38 = ((_co.employeeData.length > 0) && (_co.displayType == "Trigger")); _ck(_v, 75, 0, currVal_38); var currVal_39 = ((_co.employeeData.length > 0) && (((_co.displayType == "EnrollPerformance") || (_co.displayType == "EnrollCompetency")) || (_co.displayType == "EnrollCheckin"))); _ck(_v, 77, 0, currVal_39); var currVal_40 = ((_co.employeeData.length > 0) && (_co.displayType == "Announcement")); _ck(_v, 79, 0, currVal_40); var currVal_41 = ((_co.employeeData.length > 0) && (_co.displayType == "Role")); _ck(_v, 81, 0, currVal_41); var currVal_42 = ((_co.employeeData.length > 0) && (_co.displayType == "UserGroup")); _ck(_v, 83, 0, currVal_42); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("empAdvSearch")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("back")); _ck(_v, 9, 0, currVal_1); var currVal_3 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("employeeId")); _ck(_v, 18, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("name")); _ck(_v, 22, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("orgUit")); _ck(_v, 26, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 30, 0, core["ɵnov"](_v, 31).transform("selectGrade")); _ck(_v, 30, 0, currVal_6); var currVal_7 = core["ɵunv"](_v, 34, 0, core["ɵnov"](_v, 35).transform("designation")); _ck(_v, 34, 0, currVal_7); var currVal_10 = (((_co.searchData.page - 1) * _co.searchData.pageSize) + 1); var currVal_11 = ((_co.searchData.pageSize * (_co.searchData.page - 1)) + _co.employeePageData.numberOfElements); var currVal_12 = core["ɵunv"](_v, 42, 2, core["ɵnov"](_v, 43).transform("itemsOf")); var currVal_13 = _co.employeePageData.totalElements; _ck(_v, 42, 0, currVal_10, currVal_11, currVal_12, currVal_13); var currVal_14 = core["ɵunv"](_v, 46, 0, core["ɵnov"](_v, 47).transform("showItemsPerPage")); _ck(_v, 46, 0, currVal_14); var currVal_15 = core["ɵnov"](_v, 53).ngClassUntouched; var currVal_16 = core["ɵnov"](_v, 53).ngClassTouched; var currVal_17 = core["ɵnov"](_v, 53).ngClassPristine; var currVal_18 = core["ɵnov"](_v, 53).ngClassDirty; var currVal_19 = core["ɵnov"](_v, 53).ngClassValid; var currVal_20 = core["ɵnov"](_v, 53).ngClassInvalid; var currVal_21 = core["ɵnov"](_v, 53).ngClassPending; _ck(_v, 48, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21); });
}
function View_EmployeeSearch_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "EmployeeSearch", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_EmployeeSearch_0, RenderType_EmployeeSearch)), core["ɵdid"](1, 114688, null, 0, employeeSearch_EmployeeSearch, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null);
}
var EmployeeSearchNgFactory = /*@__PURE__*/ core["ɵccf"]("EmployeeSearch", employeeSearch_EmployeeSearch, View_EmployeeSearch_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/employee/addEmployees.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_angular_forms,ng2_auto_complete_dist_ng2_auto_complete.directive,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_addEmployees,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_angular_platform_browser,_shared_services_auth,_shared_sharedData,_toasterComponent_toasterComponent PURE_IMPORTS_END */




















var styles_AddEmployeesComponent = [];
var RenderType_AddEmployeesComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddEmployeesComponent, data: {} });

function View_AddEmployeesComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addEmployee")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployeesComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("editEmployee")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployeesComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_AddEmployeesComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("empCodeRequired")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployeesComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "info-text alertMsg alert-danger"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_6)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = core["ɵnov"](_v.parent, 24).errors.required; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddEmployeesComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("invalidEmail")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployeesComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "info-text alertMsg alert-danger"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_8)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = core["ɵnov"](_v.parent, 44).errors.pattern; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddEmployeesComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("userNameRequired")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployeesComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "info-text alertMsg alert-danger"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_10)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = core["ɵnov"](_v.parent, 65).errors.required; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddEmployeesComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("displayNameRequired")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployeesComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "alertMsg info-text alert-danger"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_12)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = core["ɵnov"](_v.parent, 108).errors.required; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddEmployeesComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("selectOrgUnit")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployeesComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "info-text alertMsg alert-danger"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_14)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = core["ɵnov"](_v.parent, 129).errors.required; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddEmployeesComponent_16(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "img", [["class", "w-100 rounded-circle"]], [[8, "src", 4]], null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 9, "div", [["class", "w-100 float-left mt-4 text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "button", [["class", "btn btn-danger m-1"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeImage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-close mr-1 text-white"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 4, "button", [["class", "btn btn-success m-1 relative"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.cropImage($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "input", [["accept", ".jpg,.png,.svg,.svgz"], ["class", "upload-pic"], ["name", "myFile"], ["type", "file"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-plus ml-1 text-white"]], null, null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData.imageUrl; _ck(_v, 1, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("remove")); _ck(_v, 5, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("add")); _ck(_v, 9, 0, currVal_2); });
}
function View_AddEmployeesComponent_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "img", [["class", "w-100 rounded-circle"], ["src", "./assets/img/profilePic.png"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "input", [["accept", ".jpg,.png,.svg,.svgz"], ["class", "upload-pic"], ["name", "myFile"], ["onclick", "value = null"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.cropImage($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 6, "div", [["class", "profile-text"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 5, "span", [], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 0, "br", [], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("changeYour")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("profilePic")); _ck(_v, 8, 0, currVal_1); });
}
function View_AddEmployeesComponent_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_18)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.data.image; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddEmployeesComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_16)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_17)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData.imageUrl; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.employeeData.imageUrl; _ck(_v, 4, 0, currVal_1); }, null); }
function View_AddEmployeesComponent_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "img", [["class", "w-100 rounded-circle"]], [[8, "src", 4]], null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 9, "div", [["class", "w-100 float-left mt-4 text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "button", [["class", "btn btn-danger m-1"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeImage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-close mr-1 text-white"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 4, "button", [["class", "btn btn-success m-1 relative"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.cropImage($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "input", [["accept", "image/*"], ["class", "upload-pic"], ["name", "myFile"], ["type", "file"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-plus ml-1 text-white"]], null, null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.data.image; _ck(_v, 1, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("remove")); _ck(_v, 5, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("add")); _ck(_v, 9, 0, currVal_2); });
}
function View_AddEmployeesComponent_19(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_20)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.data.image; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddEmployeesComponent_22(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [["class", "col-lg-6 col-md-6 form-group float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "label", [["for", "sup"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 9, "div", [["class", "col-lg-11 col-md-11 col-sm-11 col-xs-11 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "sup"], ["max-num-list", "5"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.secondarySupervisorModel[_v.context.index] = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.secSupSelected(_v.context.index) !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.secSupChange($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](11, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](13, 0, null, null, 0, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left p-2"], ["title", "Add secondary supervisor"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "i", [["class", "fa fa-close text-20x"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteSecondarySupervisor(_co.secondarySupervisorModel, _v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_9 = core["ɵinlineInterpolate"](1, "secondarySupervisorModel", _v.context.index, ""); var currVal_10 = _co.secondarySupervisorModel[_v.context.index]; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = _co.secondarySupervisorObservableSource.bind(_co); var currVal_12 = "displayName"; var currVal_13 = false; var currVal_14 = "5"; var currVal_15 = _co.autoCompleteListFormatter; var currVal_16 = "Select"; var currVal_17 = _co.warning; var currVal_18 = _co.secondarySupervisorModel[_v.context.index]; _ck(_v, 11, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("secondarySupervisor")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 12).transform("typeChooseSupervisor")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); });
}
function View_AddEmployeesComponent_21(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_22)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData.secSupervisorIds; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddEmployeesComponent_23(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mb-4 ml-4"], ["type", "submit"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveEmployeeData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v.parent, 2).invalid || _co.disableSave); _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("updateEmp")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddEmployeesComponent_25(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_AddEmployeesComponent_24(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "button", [["class", "btn btn-primary float-right mb-4 ml-4"], ["type", "submit"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveEmployeeData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_25)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = _co.showButtonLoading; _ck(_v, 4, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v.parent, 2).invalid || _co.disableSave); _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("saveEmp")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddEmployeesComponent_26(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mb-4 ml-4"], ["type", "submit"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveEmployeeData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (core["ɵnov"](_v.parent, 2).invalid || _co.disableSave); _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("activateEmployee")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddEmployeesComponent_27(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "button", [["class", "btn btn-primary float-right mb-4 ml-4"]], [[8, "disabled", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](3, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showButtonLoading; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("updating")); _ck(_v, 1, 0, currVal_1); }); }
function View_AddEmployeesComponent_28(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "button", [["class", "btn btn-primary float-right mb-4 ml-4"]], [[8, "disabled", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](3, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showButtonLoading; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("saving")); _ck(_v, 1, 0, currVal_1); }); }
function View_AddEmployeesComponent_29(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "button", [["class", "btn btn-primary float-right mb-4 ml-4"]], [[8, "disabled", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](3, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showButtonLoading; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("activating")); _ck(_v, 1, 0, currVal_1); }); }
function View_AddEmployeesComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 306, "form", [["novalidate", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "submit"], [null, "reset"]], function (_v, en, $event) {
            var ad = true;
            if (("submit" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("reset" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bg"], [], null, null), core["ɵdid"](2, 4210688, [["userForm", 4]], 0, fesm5_forms["NgForm"], [[8, null], [8, null]], null, null), core["ɵprd"](2048, null, fesm5_forms["ControlContainer"], null, [fesm5_forms["NgForm"]]), core["ɵdid"](4, 16384, null, 0, fesm5_forms["NgControlStatusGroup"], [[4, fesm5_forms["ControlContainer"]]], null, null), (_l()(), core["ɵeld"](5, 0, null, null, 182, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 174, "div", [["class", "col-lg-9 col-md-9 col-sm-12 col-xs-12 float-left p-0 mb-sm-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "h6", [["class", "medium mb-sm-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 170, "div", [["class", "w-100 float-left light-bg p-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 83, "div", [["class", "col-lg-6 col-md-12 col-sm-12 col-xs-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 21, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 4, "label", [["for", "empCode"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](18, 0, null, null, 8, "input", [["autocomplete", "off"], ["class", "form-control"], ["id", "empCode"], ["maxlength", "50"], ["name", "empCode"], ["placeholder", "Eg: 22456"], ["required", ""], ["type", "text"]], [[1, "required", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.employeeData.empCode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵdid"](21, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["RequiredValidator"], fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](24, 671744, [["empCode", 4]], 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](26, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_5)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 4, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](30, null, [" ", " (", " ", ") "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](34, 0, null, null, 18, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 2, "label", [["for", "email"]], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 8, "input", [["autocomplete", "off"], ["class", "form-control"], ["id", "email"], ["maxlength", "250"], ["name", "email"], ["pattern", "[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\\.[a-zA-Z]{2,3}$"], ["placeholder", "Eg: jack@oracle.com"], ["type", "email"]], [[1, "maxlength", 0], [1, "pattern", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 39)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 39).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 39)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 39)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.employeeData.email = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_5 = (_co.copyToUsername($event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](39, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](40, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵdid"](41, 540672, null, 0, fesm5_forms["PatternValidator"], [], { pattern: [0, "pattern"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["MaxLengthValidator"], fesm5_forms["PatternValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](44, 671744, [["email", 4]], 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](46, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_7)), core["ɵdid"](48, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](49, 0, null, null, 3, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, [" ", " (", ") "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](53, 0, null, null, 20, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 4, "label", [["for", "Username"]], null, null, null, null, null)), (_l()(), core["ɵted"](55, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](57, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](59, 0, null, null, 8, "input", [["autocomplete", "off"], ["class", "form-control"], ["id", "Username"], ["maxlength", "250"], ["name", "Username"], ["placeholder", "Eg: jack"], ["required", ""], ["type", "email"]], [[1, "required", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 60)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 60).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 60)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 60)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.employeeData.userName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](60, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](61, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵdid"](62, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["RequiredValidator"], fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](65, 671744, [["Username", 4]], 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](67, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_9)), core["ɵdid"](69, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](70, 0, null, null, 3, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](71, null, [" ", " (", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](74, 0, null, null, 15, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](75, 0, null, null, 2, "label", [["for", "licenceNumber"]], null, null, null, null, null)), (_l()(), core["ɵted"](76, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](78, 0, null, null, 7, "input", [["autocomplete", "off"], ["class", "form-control"], ["id", "licenceNumber"], ["maxlength", "250"], ["name", "licenceNumber"], ["placeholder", " "], ["type", "licenceNumber"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 79)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 79).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 79)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 79)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.employeeData.licenceNumber = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](79, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](80, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](83, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](85, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](86, 0, null, null, 3, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](87, null, [" ", " (", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](90, 0, null, null, 4, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](91, 0, null, null, 2, "label", [["for", "rl"]], null, null, null, null, null)), (_l()(), core["ɵted"](92, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](94, 0, null, null, 0, "input", [["autocomplete", "off"], ["class", "form-control"], ["disabled", "true"], ["id", "rl"], ["maxlength", "250"], ["name", "rl"], ["placeholder", " "], ["type", "role"]], [[1, "value", 0]], null, null, null, null)), (_l()(), core["ɵeld"](95, 0, null, null, 85, "div", [["class", "col-lg-6 col-md-12 col-sm-12 col-xs-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](96, 0, null, null, 21, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](97, 0, null, null, 4, "label", [["for", "dname"]], null, null, null, null, null)), (_l()(), core["ɵted"](98, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](100, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](102, 0, null, null, 9, "input", [["autocomplete", "off"], ["class", "form-control"], ["id", "dname"], ["maxlength", "250"], ["name", "dName"], ["required", ""], ["type", "text"]], [[8, "placeholder", 0], [1, "required", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 103)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 103).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 103)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 103)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.employeeData.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](103, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](104, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵdid"](105, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["RequiredValidator"], fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](108, 671744, [["dname", 4]], 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](110, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_11)), core["ɵdid"](113, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](114, 0, null, null, 3, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](115, null, [" ", " (", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](118, 0, null, null, 20, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](119, 0, null, null, 4, "label", [["for", "org"]], null, null, null, null, null)), (_l()(), core["ɵted"](120, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](122, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](124, 16777216, null, null, 9, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["name", "organizationModel"], ["ng2-auto-complete", ""], ["required", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 125)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 125).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 125)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 125)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.organizationModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.orgSelected() !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.orgChange($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](125, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](126, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](129, 671744, [["org", 4]], 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](131, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](132, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], listFormatter: [3, "listFormatter"], blankOptionText: [4, "blankOptionText"], noMatchFoundText: [5, "noMatchFoundText"], valueFormatter: [6, "valueFormatter"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_13)), core["ɵdid"](135, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](136, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](137, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](139, 0, null, null, 23, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](140, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](141, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](143, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](145, 0, null, null, 14, "div", [["class", "w-100 float-left relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](146, 16777216, null, null, 11, "input", [["class", "form-control"], ["name", "JoinDate"], ["ngbDatepicker", ""], ["placeholder", "YYYY-MM-DD"], ["readonly", ""], ["required", ""]], [[8, "disabled", 0], [1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "change"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 150).manualDateChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("change" === en)) {
                var pd_1 = (core["ɵnov"](_v, 150).manualDateChange($event.target.value, true) !== false);
                ad = (pd_1 && ad);
            }
            if (("blur" === en)) {
                var pd_2 = (core["ɵnov"](_v, 150).onBlur() !== false);
                ad = (pd_2 && ad);
            }
            if (("input" === en)) {
                var pd_3 = (core["ɵnov"](_v, 151)._handleInput($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("blur" === en)) {
                var pd_4 = (core["ɵnov"](_v, 151).onTouched() !== false);
                ad = (pd_4 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_5 = (core["ɵnov"](_v, 151)._compositionStart() !== false);
                ad = (pd_5 && ad);
            }
            if (("compositionend" === en)) {
                var pd_6 = (core["ɵnov"](_v, 151)._compositionEnd($event.target.value) !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.joiningDate = $event) !== false);
                ad = (pd_7 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_8 = (_co.onDateChange($event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](147, 278528, null, 0, common["NgStyle"], [core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngStyle: [0, "ngStyle"] }, null), core["ɵpod"](148, { "background-color": 0 }), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](150, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], { minDate: [0, "minDate"], maxDate: [1, "maxDate"] }, null), core["ɵdid"](151, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](152, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](155, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](157, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](158, 0, null, null, 1, "button", [["class", "iga-right"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                core["ɵnov"](_v, 150).toggle();
                var pd_0 = (_co.openDatePicker(core["ɵnov"](_v, 150)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](159, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](160, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](161, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](163, 0, null, null, 17, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](164, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](165, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](167, 0, null, null, 13, "div", [["class", "w-100 float-left relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](168, 16777216, null, null, 10, "input", [["class", "form-control"], ["name", "dateOfBirth"], ["ngbDatepicker", ""], ["placeholder", "YYYY-MM-DD"], ["readonly", ""]], [[8, "disabled", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "change"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 172).manualDateChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("change" === en)) {
                var pd_1 = (core["ɵnov"](_v, 172).manualDateChange($event.target.value, true) !== false);
                ad = (pd_1 && ad);
            }
            if (("blur" === en)) {
                var pd_2 = (core["ɵnov"](_v, 172).onBlur() !== false);
                ad = (pd_2 && ad);
            }
            if (("input" === en)) {
                var pd_3 = (core["ɵnov"](_v, 173)._handleInput($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("blur" === en)) {
                var pd_4 = (core["ɵnov"](_v, 173).onTouched() !== false);
                ad = (pd_4 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_5 = (core["ɵnov"](_v, 173)._compositionStart() !== false);
                ad = (pd_5 && ad);
            }
            if (("compositionend" === en)) {
                var pd_6 = (core["ɵnov"](_v, 173)._compositionEnd($event.target.value) !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.dateOfBirth = $event) !== false);
                ad = (pd_7 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_8 = (_co.onDateofBirthChange($event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](169, 278528, null, 0, common["NgStyle"], [core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngStyle: [0, "ngStyle"] }, null), core["ɵpod"](170, { "background-color": 0 }), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](172, 671744, [["dob", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], { minDate: [0, "minDate"], maxDate: [1, "maxDate"] }, null), core["ɵdid"](173, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [datepicker_input_NgbInputDatepicker]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](176, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](178, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](179, 0, null, null, 1, "button", [["class", "iga-right"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                core["ɵnov"](_v, 172).toggle();
                var pd_0 = (_co.openDatePicker(core["ɵnov"](_v, 150)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](180, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](181, 0, null, null, 6, "div", [["class", "col-lg-3 col-md-3 col-sm-12 col-xs-12 float-left mb-sm-3 text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](182, 0, null, null, 0, "h6", [["class", "medium mb-sm-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](183, 0, null, null, 4, "div", [["class", "w-75 relative auto-m"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_15)), core["ɵdid"](185, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_19)), core["ɵdid"](187, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](188, 0, null, null, 66, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](189, 0, null, null, 2, "h6", [["class", "medium mb-sm-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](190, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](192, 0, null, null, 62, "div", [["class", "w-100 float-left light-bg p-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](193, 0, null, null, 30, "div", [["class", "col-lg-6 col-md-12 col-sm-12 col-xs-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](194, 0, null, null, 14, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](195, 0, null, null, 2, "label", [["for", "categoryModel"]], null, null, null, null, null)), (_l()(), core["ɵted"](196, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](198, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "None"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "categoryModel"], ["name", "categoryModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 199)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 199).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 199)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 199)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.categoryModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.empTypeSelected() !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.empTypeChange($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](199, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](201, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](203, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](204, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], listFormatter: [3, "listFormatter"], blankOptionText: [4, "blankOptionText"], valueFormatter: [5, "valueFormatter"], ngModel: [6, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](206, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](207, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](209, 0, null, null, 14, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](210, 0, null, null, 2, "label", [["for", "managementModel"]], null, null, null, null, null)), (_l()(), core["ɵted"](211, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](213, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "managementModel"], ["name", "managementModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 214)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 214).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 214)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 214)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.managementModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.categoryTypeSelected() !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.categoryTypeChange($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](214, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](216, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](218, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](219, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], listFormatter: [3, "listFormatter"], blankOptionText: [4, "blankOptionText"], noMatchFoundText: [5, "noMatchFoundText"], valueFormatter: [6, "valueFormatter"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](221, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](222, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](224, 0, null, null, 30, "div", [["class", "col-lg-6 col-md-12 col-sm-12 col-xs-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](225, 0, null, null, 14, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](226, 0, null, null, 2, "label", [["for", "designationModel"]], null, null, null, null, null)), (_l()(), core["ɵted"](227, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](229, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "designationModel"], ["max-num-list", "5"], ["name", "designationModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 230)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 230).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 230)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 230)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.designationModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.designationSelected() !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.designationChange($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](230, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](232, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](234, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](235, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], valueFormatter: [7, "valueFormatter"], ngModel: [8, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](237, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](238, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](240, 0, null, null, 14, "div", [["class", "form-group float-left w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](241, 0, null, null, 2, "label", [["for", "gradeModel"]], null, null, null, null, null)), (_l()(), core["ɵted"](242, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](244, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "gradeModel"], ["name", "gradeModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 245)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 245).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 245)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 245)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.gradeModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gradeSelected() !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.gradeChange($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](245, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](247, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](249, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](250, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], listFormatter: [3, "listFormatter"], blankOptionText: [4, "blankOptionText"], noMatchFoundText: [5, "noMatchFoundText"], valueFormatter: [6, "valueFormatter"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](252, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](253, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](255, 0, null, null, 39, "div", [["class", "w-100 float-left mt-3 mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](256, 0, null, null, 2, "h6", [["class", "medium mb-sm-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](257, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](259, 0, null, null, 35, "div", [["class", "w-100 float-left light-bg p-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](260, 0, null, null, 17, "div", [["class", "col-lg-6 col-md-6 form-group float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](261, 0, null, null, 2, "label", [["for", "sup"]], null, null, null, null, null)), (_l()(), core["ɵted"](262, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](264, 0, null, null, 11, "div", [["class", "col-lg-11 col-md-11 col-sm-11 col-xs-11 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](265, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "sup"], ["max-num-list", "5"], ["name", "primarySupervisorModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 266)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 266).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 266)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 266)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.primarySupervisorModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.supSelected() !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.supChange($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](266, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](268, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](270, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](271, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](273, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](274, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](276, 0, null, null, 1, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left p-2"], ["title", "Add secondary supervisor(s)"]], null, null, null, null, null)), (_l()(), core["ɵeld"](277, 0, null, null, 0, "i", [["class", "fa fa-plus text-20x"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addSecondarySupervisor() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](278, 0, null, null, 14, "div", [["class", "col-lg-6 col-md-6 form-group float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](279, 0, null, null, 2, "label", [["for", "verifier"]], null, null, null, null, null)), (_l()(), core["ɵted"](280, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](282, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "verifier"], ["max-num-list", "5"], ["name", "verifierModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 283)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 283).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 283)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 283)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.verifierModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.verifierSelected() !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.verifierChange($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](283, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](285, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](287, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](288, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](290, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](291, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_21)), core["ɵdid"](294, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_23)), core["ɵdid"](296, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_24)), core["ɵdid"](298, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_26)), core["ɵdid"](300, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_27)), core["ɵdid"](302, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_28)), core["ɵdid"](304, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_29)), core["ɵdid"](306, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_18 = ""; _ck(_v, 20, 0, currVal_18); var currVal_19 = "50"; _ck(_v, 21, 0, currVal_19); var currVal_20 = "empCode"; var currVal_21 = _co.employeeData.empCode; _ck(_v, 24, 0, currVal_20, currVal_21); var currVal_22 = (core["ɵnov"](_v, 24).invalid && (core["ɵnov"](_v, 24).dirty || core["ɵnov"](_v, 24).touched)); _ck(_v, 28, 0, currVal_22); var currVal_36 = "250"; _ck(_v, 40, 0, currVal_36); var currVal_37 = "[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\\.[a-zA-Z]{2,3}$"; _ck(_v, 41, 0, currVal_37); var currVal_38 = "email"; var currVal_39 = _co.employeeData.email; _ck(_v, 44, 0, currVal_38, currVal_39); var currVal_40 = (core["ɵnov"](_v, 44).invalid && (core["ɵnov"](_v, 44).dirty || core["ɵnov"](_v, 44).touched)); _ck(_v, 48, 0, currVal_40); var currVal_53 = ""; _ck(_v, 61, 0, currVal_53); var currVal_54 = "250"; _ck(_v, 62, 0, currVal_54); var currVal_55 = "Username"; var currVal_56 = _co.employeeData.userName; _ck(_v, 65, 0, currVal_55, currVal_56); var currVal_57 = (core["ɵnov"](_v, 65).invalid && (core["ɵnov"](_v, 65).dirty || core["ɵnov"](_v, 65).touched)); _ck(_v, 69, 0, currVal_57); var currVal_69 = "250"; _ck(_v, 80, 0, currVal_69); var currVal_70 = "licenceNumber"; var currVal_71 = _co.employeeData.licenceNumber; _ck(_v, 83, 0, currVal_70, currVal_71); var currVal_87 = ""; _ck(_v, 104, 0, currVal_87); var currVal_88 = "250"; _ck(_v, 105, 0, currVal_88); var currVal_89 = "dName"; var currVal_90 = _co.employeeData.displayName; _ck(_v, 108, 0, currVal_89, currVal_90); var currVal_91 = (core["ɵnov"](_v, 108).invalid && (core["ɵnov"](_v, 108).dirty || core["ɵnov"](_v, 108).touched)); _ck(_v, 113, 0, currVal_91); var currVal_104 = ""; _ck(_v, 126, 0, currVal_104); var currVal_105 = "organizationModel"; var currVal_106 = _co.organizationModel; _ck(_v, 129, 0, currVal_105, currVal_106); var currVal_107 = _co.organizationObservableSource.bind(_co); var currVal_108 = "displayName"; var currVal_109 = false; var currVal_110 = _co.autoCompleteListOrgFormatter; var currVal_111 = "Select"; var currVal_112 = _co.warning; var currVal_113 = _co.orgNameValueFormatter; var currVal_114 = _co.organizationModel; _ck(_v, 132, 0, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111, currVal_112, currVal_113, currVal_114); var currVal_115 = (core["ɵnov"](_v, 129).invalid && (core["ɵnov"](_v, 129).dirty || core["ɵnov"](_v, 129).touched)); _ck(_v, 135, 0, currVal_115); var currVal_127 = _ck(_v, 148, 0, "white"); _ck(_v, 147, 0, currVal_127); var currVal_128 = _co.minDate; var currVal_129 = _co.maxDate; _ck(_v, 150, 0, currVal_128, currVal_129); var currVal_130 = ""; _ck(_v, 152, 0, currVal_130); var currVal_131 = "JoinDate"; var currVal_132 = _co.joiningDate; _ck(_v, 155, 0, currVal_131, currVal_132); var currVal_143 = _ck(_v, 170, 0, "white"); _ck(_v, 169, 0, currVal_143); var currVal_144 = _co.minDate; var currVal_145 = _co.maxDate; _ck(_v, 172, 0, currVal_144, currVal_145); var currVal_146 = "dateOfBirth"; var currVal_147 = _co.dateOfBirth; _ck(_v, 176, 0, currVal_146, currVal_147); var currVal_148 = !_co.isUpdateImage; _ck(_v, 185, 0, currVal_148); var currVal_149 = _co.isUpdateImage; _ck(_v, 187, 0, currVal_149); var currVal_160 = "categoryModel"; var currVal_161 = _co.categoryModel; _ck(_v, 201, 0, currVal_160, currVal_161); var currVal_162 = _co.categoryObservableSource.bind(_co); var currVal_163 = "displayName"; var currVal_164 = false; var currVal_165 = _co.autoCompleteListFormatterType; var currVal_166 = "None"; var currVal_167 = _co.typeValueFormatter; var currVal_168 = _co.categoryModel; _ck(_v, 204, 0, currVal_162, currVal_163, currVal_164, currVal_165, currVal_166, currVal_167, currVal_168); var currVal_179 = "managementModel"; var currVal_180 = _co.managementModel; _ck(_v, 216, 0, currVal_179, currVal_180); var currVal_181 = _co.managementLevelObservableSource.bind(_co); var currVal_182 = "displayName"; var currVal_183 = false; var currVal_184 = _co.autoCompleteListNameFormatter; var currVal_185 = "Select"; var currVal_186 = _co.warning; var currVal_187 = _co.nameValueFormatter; var currVal_188 = _co.managementModel; _ck(_v, 219, 0, currVal_181, currVal_182, currVal_183, currVal_184, currVal_185, currVal_186, currVal_187, currVal_188); var currVal_199 = "designationModel"; var currVal_200 = _co.designationModel; _ck(_v, 232, 0, currVal_199, currVal_200); var currVal_201 = _co.designationObservableSource.bind(_co); var currVal_202 = "displayName"; var currVal_203 = false; var currVal_204 = "5"; var currVal_205 = _co.autoCompleteListNameFormatter; var currVal_206 = "Select"; var currVal_207 = _co.warning; var currVal_208 = _co.nameValueFormatter; var currVal_209 = _co.designationModel; _ck(_v, 235, 0, currVal_201, currVal_202, currVal_203, currVal_204, currVal_205, currVal_206, currVal_207, currVal_208, currVal_209); var currVal_220 = "gradeModel"; var currVal_221 = _co.gradeModel; _ck(_v, 247, 0, currVal_220, currVal_221); var currVal_222 = _co.gradeObservableSource.bind(_co); var currVal_223 = "displayName"; var currVal_224 = false; var currVal_225 = _co.autoCompleteListNameFormatter; var currVal_226 = "Select"; var currVal_227 = _co.warning; var currVal_228 = _co.nameValueFormatter; var currVal_229 = _co.gradeModel; _ck(_v, 250, 0, currVal_222, currVal_223, currVal_224, currVal_225, currVal_226, currVal_227, currVal_228, currVal_229); var currVal_241 = "primarySupervisorModel"; var currVal_242 = _co.primarySupervisorModel; _ck(_v, 268, 0, currVal_241, currVal_242); var currVal_243 = _co.primarySupervisorObservableSource.bind(_co); var currVal_244 = "displayName"; var currVal_245 = false; var currVal_246 = "5"; var currVal_247 = _co.autoCompleteListFormatter; var currVal_248 = "Select"; var currVal_249 = _co.warning; var currVal_250 = _co.primarySupervisorModel; _ck(_v, 271, 0, currVal_243, currVal_244, currVal_245, currVal_246, currVal_247, currVal_248, currVal_249, currVal_250); var currVal_261 = "verifierModel"; var currVal_262 = _co.verifierModel; _ck(_v, 285, 0, currVal_261, currVal_262); var currVal_263 = _co.primaryVerifierObservableSource.bind(_co); var currVal_264 = "displayName"; var currVal_265 = false; var currVal_266 = "5"; var currVal_267 = _co.autoCompleteListFormatter; var currVal_268 = "Select"; var currVal_269 = _co.warning; var currVal_270 = _co.verifierModel; _ck(_v, 288, 0, currVal_263, currVal_264, currVal_265, currVal_266, currVal_267, currVal_268, currVal_269, currVal_270); var currVal_272 = (_co.employeeData.secSupervisorIds && (_co.employeeData.secSupervisorIds.length > 0)); _ck(_v, 294, 0, currVal_272); var currVal_273 = ((_co.type == "EDIT") && !_co.showButtonLoading); _ck(_v, 296, 0, currVal_273); var currVal_274 = ((_co.type == "ADD") && !_co.showButtonLoading); _ck(_v, 298, 0, currVal_274); var currVal_275 = ((_co.type == "ACTIVATE") && !_co.showButtonLoading); _ck(_v, 300, 0, currVal_275); var currVal_276 = ((_co.type == "EDIT") && _co.showButtonLoading); _ck(_v, 302, 0, currVal_276); var currVal_277 = ((_co.type == "ADD") && _co.showButtonLoading); _ck(_v, 304, 0, currVal_277); var currVal_278 = ((_co.type == "ACTIVATE") && _co.showButtonLoading); _ck(_v, 306, 0, currVal_278); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵnov"](_v, 4).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 4).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 4).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 4).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 4).ngClassValid; var currVal_5 = core["ɵnov"](_v, 4).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 4).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_7 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("employeeDetails")); _ck(_v, 8, 0, currVal_7); var currVal_8 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("employeeId")); _ck(_v, 14, 0, currVal_8); var currVal_9 = (core["ɵnov"](_v, 20).required ? "" : null); var currVal_10 = (core["ɵnov"](_v, 21).maxlength ? core["ɵnov"](_v, 21).maxlength : null); var currVal_11 = core["ɵnov"](_v, 26).ngClassUntouched; var currVal_12 = core["ɵnov"](_v, 26).ngClassTouched; var currVal_13 = core["ɵnov"](_v, 26).ngClassPristine; var currVal_14 = core["ɵnov"](_v, 26).ngClassDirty; var currVal_15 = core["ɵnov"](_v, 26).ngClassValid; var currVal_16 = core["ɵnov"](_v, 26).ngClassInvalid; var currVal_17 = core["ɵnov"](_v, 26).ngClassPending; _ck(_v, 18, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_23 = core["ɵunv"](_v, 30, 0, core["ɵnov"](_v, 31).transform("empCodeUnique")); var currVal_24 = core["ɵunv"](_v, 30, 1, core["ɵnov"](_v, 32).transform("maxFifty")); var currVal_25 = core["ɵunv"](_v, 30, 2, core["ɵnov"](_v, 33).transform("character")); _ck(_v, 30, 0, currVal_23, currVal_24, currVal_25); var currVal_26 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("empEmail")); _ck(_v, 36, 0, currVal_26); var currVal_27 = (core["ɵnov"](_v, 40).maxlength ? core["ɵnov"](_v, 40).maxlength : null); var currVal_28 = (core["ɵnov"](_v, 41).pattern ? core["ɵnov"](_v, 41).pattern : null); var currVal_29 = core["ɵnov"](_v, 46).ngClassUntouched; var currVal_30 = core["ɵnov"](_v, 46).ngClassTouched; var currVal_31 = core["ɵnov"](_v, 46).ngClassPristine; var currVal_32 = core["ɵnov"](_v, 46).ngClassDirty; var currVal_33 = core["ɵnov"](_v, 46).ngClassValid; var currVal_34 = core["ɵnov"](_v, 46).ngClassInvalid; var currVal_35 = core["ɵnov"](_v, 46).ngClassPending; _ck(_v, 38, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35); var currVal_41 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("empEmailUnique")); var currVal_42 = core["ɵunv"](_v, 50, 1, core["ɵnov"](_v, 52).transform("maxTwoFifty")); _ck(_v, 50, 0, currVal_41, currVal_42); var currVal_43 = core["ɵunv"](_v, 55, 0, core["ɵnov"](_v, 56).transform("empUserName")); _ck(_v, 55, 0, currVal_43); var currVal_44 = (core["ɵnov"](_v, 61).required ? "" : null); var currVal_45 = (core["ɵnov"](_v, 62).maxlength ? core["ɵnov"](_v, 62).maxlength : null); var currVal_46 = core["ɵnov"](_v, 67).ngClassUntouched; var currVal_47 = core["ɵnov"](_v, 67).ngClassTouched; var currVal_48 = core["ɵnov"](_v, 67).ngClassPristine; var currVal_49 = core["ɵnov"](_v, 67).ngClassDirty; var currVal_50 = core["ɵnov"](_v, 67).ngClassValid; var currVal_51 = core["ɵnov"](_v, 67).ngClassInvalid; var currVal_52 = core["ɵnov"](_v, 67).ngClassPending; _ck(_v, 59, 0, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52); var currVal_58 = core["ɵunv"](_v, 71, 0, core["ɵnov"](_v, 72).transform("empUser")); var currVal_59 = core["ɵunv"](_v, 71, 1, core["ɵnov"](_v, 73).transform("maxTwoFifty")); _ck(_v, 71, 0, currVal_58, currVal_59); var currVal_60 = core["ɵunv"](_v, 76, 0, core["ɵnov"](_v, 77).transform("licenceNumber")); _ck(_v, 76, 0, currVal_60); var currVal_61 = (core["ɵnov"](_v, 80).maxlength ? core["ɵnov"](_v, 80).maxlength : null); var currVal_62 = core["ɵnov"](_v, 85).ngClassUntouched; var currVal_63 = core["ɵnov"](_v, 85).ngClassTouched; var currVal_64 = core["ɵnov"](_v, 85).ngClassPristine; var currVal_65 = core["ɵnov"](_v, 85).ngClassDirty; var currVal_66 = core["ɵnov"](_v, 85).ngClassValid; var currVal_67 = core["ɵnov"](_v, 85).ngClassInvalid; var currVal_68 = core["ɵnov"](_v, 85).ngClassPending; _ck(_v, 78, 0, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68); var currVal_72 = core["ɵunv"](_v, 87, 0, core["ɵnov"](_v, 88).transform("licenceNumber")); var currVal_73 = core["ɵunv"](_v, 87, 1, core["ɵnov"](_v, 89).transform("maxTwoFifty")); _ck(_v, 87, 0, currVal_72, currVal_73); var currVal_74 = core["ɵunv"](_v, 92, 0, core["ɵnov"](_v, 93).transform("role")); _ck(_v, 92, 0, currVal_74); var currVal_75 = _co.getRoleLabel(_co.employeeData.userRole); _ck(_v, 94, 0, currVal_75); var currVal_76 = core["ɵunv"](_v, 98, 0, core["ɵnov"](_v, 99).transform("empDisplayName")); _ck(_v, 98, 0, currVal_76); var currVal_77 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 102, 0, core["ɵnov"](_v, 111).transform("displayName")), ""); var currVal_78 = (core["ɵnov"](_v, 104).required ? "" : null); var currVal_79 = (core["ɵnov"](_v, 105).maxlength ? core["ɵnov"](_v, 105).maxlength : null); var currVal_80 = core["ɵnov"](_v, 110).ngClassUntouched; var currVal_81 = core["ɵnov"](_v, 110).ngClassTouched; var currVal_82 = core["ɵnov"](_v, 110).ngClassPristine; var currVal_83 = core["ɵnov"](_v, 110).ngClassDirty; var currVal_84 = core["ɵnov"](_v, 110).ngClassValid; var currVal_85 = core["ɵnov"](_v, 110).ngClassInvalid; var currVal_86 = core["ɵnov"](_v, 110).ngClassPending; _ck(_v, 102, 0, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86); var currVal_92 = core["ɵunv"](_v, 115, 0, core["ɵnov"](_v, 116).transform("nameAllOver")); var currVal_93 = core["ɵunv"](_v, 115, 1, core["ɵnov"](_v, 117).transform("maxTwoFifty")); _ck(_v, 115, 0, currVal_92, currVal_93); var currVal_94 = core["ɵunv"](_v, 120, 0, core["ɵnov"](_v, 121).transform("orgUit")); _ck(_v, 120, 0, currVal_94); var currVal_95 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 124, 0, core["ɵnov"](_v, 133).transform("typeAndChooseEmpOrg")), ""); var currVal_96 = (core["ɵnov"](_v, 126).required ? "" : null); var currVal_97 = core["ɵnov"](_v, 131).ngClassUntouched; var currVal_98 = core["ɵnov"](_v, 131).ngClassTouched; var currVal_99 = core["ɵnov"](_v, 131).ngClassPristine; var currVal_100 = core["ɵnov"](_v, 131).ngClassDirty; var currVal_101 = core["ɵnov"](_v, 131).ngClassValid; var currVal_102 = core["ɵnov"](_v, 131).ngClassInvalid; var currVal_103 = core["ɵnov"](_v, 131).ngClassPending; _ck(_v, 124, 0, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103); var currVal_116 = core["ɵunv"](_v, 137, 0, core["ɵnov"](_v, 138).transform("selectOrgUnit")); _ck(_v, 137, 0, currVal_116); var currVal_117 = core["ɵunv"](_v, 141, 0, core["ɵnov"](_v, 142).transform("dOfHire")); _ck(_v, 141, 0, currVal_117); var currVal_118 = core["ɵnov"](_v, 150).disabled; var currVal_119 = (core["ɵnov"](_v, 152).required ? "" : null); var currVal_120 = core["ɵnov"](_v, 157).ngClassUntouched; var currVal_121 = core["ɵnov"](_v, 157).ngClassTouched; var currVal_122 = core["ɵnov"](_v, 157).ngClassPristine; var currVal_123 = core["ɵnov"](_v, 157).ngClassDirty; var currVal_124 = core["ɵnov"](_v, 157).ngClassValid; var currVal_125 = core["ɵnov"](_v, 157).ngClassInvalid; var currVal_126 = core["ɵnov"](_v, 157).ngClassPending; _ck(_v, 146, 0, currVal_118, currVal_119, currVal_120, currVal_121, currVal_122, currVal_123, currVal_124, currVal_125, currVal_126); var currVal_133 = core["ɵunv"](_v, 161, 0, core["ɵnov"](_v, 162).transform("dOfHire")); _ck(_v, 161, 0, currVal_133); var currVal_134 = core["ɵunv"](_v, 165, 0, core["ɵnov"](_v, 166).transform("dateOfBirth")); _ck(_v, 165, 0, currVal_134); var currVal_135 = core["ɵnov"](_v, 172).disabled; var currVal_136 = core["ɵnov"](_v, 178).ngClassUntouched; var currVal_137 = core["ɵnov"](_v, 178).ngClassTouched; var currVal_138 = core["ɵnov"](_v, 178).ngClassPristine; var currVal_139 = core["ɵnov"](_v, 178).ngClassDirty; var currVal_140 = core["ɵnov"](_v, 178).ngClassValid; var currVal_141 = core["ɵnov"](_v, 178).ngClassInvalid; var currVal_142 = core["ɵnov"](_v, 178).ngClassPending; _ck(_v, 168, 0, currVal_135, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140, currVal_141, currVal_142); var currVal_150 = core["ɵunv"](_v, 190, 0, core["ɵnov"](_v, 191).transform("dptDetails")); _ck(_v, 190, 0, currVal_150); var currVal_151 = core["ɵunv"](_v, 196, 0, core["ɵnov"](_v, 197).transform("jobCat")); _ck(_v, 196, 0, currVal_151); var currVal_152 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 198, 0, core["ɵnov"](_v, 205).transform("typeChooseJob")), ""); var currVal_153 = core["ɵnov"](_v, 203).ngClassUntouched; var currVal_154 = core["ɵnov"](_v, 203).ngClassTouched; var currVal_155 = core["ɵnov"](_v, 203).ngClassPristine; var currVal_156 = core["ɵnov"](_v, 203).ngClassDirty; var currVal_157 = core["ɵnov"](_v, 203).ngClassValid; var currVal_158 = core["ɵnov"](_v, 203).ngClassInvalid; var currVal_159 = core["ɵnov"](_v, 203).ngClassPending; _ck(_v, 198, 0, currVal_152, currVal_153, currVal_154, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159); var currVal_169 = core["ɵunv"](_v, 207, 0, core["ɵnov"](_v, 208).transform("selectJobCat")); _ck(_v, 207, 0, currVal_169); var currVal_170 = core["ɵunv"](_v, 211, 0, core["ɵnov"](_v, 212).transform("empType")); _ck(_v, 211, 0, currVal_170); var currVal_171 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 213, 0, core["ɵnov"](_v, 220).transform("typeChooseEmp")), ""); var currVal_172 = core["ɵnov"](_v, 218).ngClassUntouched; var currVal_173 = core["ɵnov"](_v, 218).ngClassTouched; var currVal_174 = core["ɵnov"](_v, 218).ngClassPristine; var currVal_175 = core["ɵnov"](_v, 218).ngClassDirty; var currVal_176 = core["ɵnov"](_v, 218).ngClassValid; var currVal_177 = core["ɵnov"](_v, 218).ngClassInvalid; var currVal_178 = core["ɵnov"](_v, 218).ngClassPending; _ck(_v, 213, 0, currVal_171, currVal_172, currVal_173, currVal_174, currVal_175, currVal_176, currVal_177, currVal_178); var currVal_189 = core["ɵunv"](_v, 222, 0, core["ɵnov"](_v, 223).transform("empBelongs")); _ck(_v, 222, 0, currVal_189); var currVal_190 = core["ɵunv"](_v, 227, 0, core["ɵnov"](_v, 228).transform("employeeDesignation")); _ck(_v, 227, 0, currVal_190); var currVal_191 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 229, 0, core["ɵnov"](_v, 236).transform("typeChooseDesignation")), ""); var currVal_192 = core["ɵnov"](_v, 234).ngClassUntouched; var currVal_193 = core["ɵnov"](_v, 234).ngClassTouched; var currVal_194 = core["ɵnov"](_v, 234).ngClassPristine; var currVal_195 = core["ɵnov"](_v, 234).ngClassDirty; var currVal_196 = core["ɵnov"](_v, 234).ngClassValid; var currVal_197 = core["ɵnov"](_v, 234).ngClassInvalid; var currVal_198 = core["ɵnov"](_v, 234).ngClassPending; _ck(_v, 229, 0, currVal_191, currVal_192, currVal_193, currVal_194, currVal_195, currVal_196, currVal_197, currVal_198); var currVal_210 = core["ɵunv"](_v, 238, 0, core["ɵnov"](_v, 239).transform("selectDesignation")); _ck(_v, 238, 0, currVal_210); var currVal_211 = core["ɵunv"](_v, 242, 0, core["ɵnov"](_v, 243).transform("selectGrade")); _ck(_v, 242, 0, currVal_211); var currVal_212 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 244, 0, core["ɵnov"](_v, 251).transform("typeChooseGrade")), ""); var currVal_213 = core["ɵnov"](_v, 249).ngClassUntouched; var currVal_214 = core["ɵnov"](_v, 249).ngClassTouched; var currVal_215 = core["ɵnov"](_v, 249).ngClassPristine; var currVal_216 = core["ɵnov"](_v, 249).ngClassDirty; var currVal_217 = core["ɵnov"](_v, 249).ngClassValid; var currVal_218 = core["ɵnov"](_v, 249).ngClassInvalid; var currVal_219 = core["ɵnov"](_v, 249).ngClassPending; _ck(_v, 244, 0, currVal_212, currVal_213, currVal_214, currVal_215, currVal_216, currVal_217, currVal_218, currVal_219); var currVal_230 = core["ɵunv"](_v, 253, 0, core["ɵnov"](_v, 254).transform("selectEmpJobGrade")); _ck(_v, 253, 0, currVal_230); var currVal_231 = core["ɵunv"](_v, 257, 0, core["ɵnov"](_v, 258).transform("managementDetails")); _ck(_v, 257, 0, currVal_231); var currVal_232 = core["ɵunv"](_v, 262, 0, core["ɵnov"](_v, 263).transform("supervisor")); _ck(_v, 262, 0, currVal_232); var currVal_233 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 265, 0, core["ɵnov"](_v, 272).transform("typeChooseSupervisor")), ""); var currVal_234 = core["ɵnov"](_v, 270).ngClassUntouched; var currVal_235 = core["ɵnov"](_v, 270).ngClassTouched; var currVal_236 = core["ɵnov"](_v, 270).ngClassPristine; var currVal_237 = core["ɵnov"](_v, 270).ngClassDirty; var currVal_238 = core["ɵnov"](_v, 270).ngClassValid; var currVal_239 = core["ɵnov"](_v, 270).ngClassInvalid; var currVal_240 = core["ɵnov"](_v, 270).ngClassPending; _ck(_v, 265, 0, currVal_233, currVal_234, currVal_235, currVal_236, currVal_237, currVal_238, currVal_239, currVal_240); var currVal_251 = core["ɵunv"](_v, 274, 0, core["ɵnov"](_v, 275).transform("empSupervisor")); _ck(_v, 274, 0, currVal_251); var currVal_252 = core["ɵunv"](_v, 280, 0, core["ɵnov"](_v, 281).transform("verifier")); _ck(_v, 280, 0, currVal_252); var currVal_253 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 282, 0, core["ɵnov"](_v, 289).transform("typeChooseVerifier")), ""); var currVal_254 = core["ɵnov"](_v, 287).ngClassUntouched; var currVal_255 = core["ɵnov"](_v, 287).ngClassTouched; var currVal_256 = core["ɵnov"](_v, 287).ngClassPristine; var currVal_257 = core["ɵnov"](_v, 287).ngClassDirty; var currVal_258 = core["ɵnov"](_v, 287).ngClassValid; var currVal_259 = core["ɵnov"](_v, 287).ngClassInvalid; var currVal_260 = core["ɵnov"](_v, 287).ngClassPending; _ck(_v, 282, 0, currVal_253, currVal_254, currVal_255, currVal_256, currVal_257, currVal_258, currVal_259, currVal_260); var currVal_271 = core["ɵunv"](_v, 291, 0, core["ɵnov"](_v, 292).transform("empVerifier")); _ck(_v, 291, 0, currVal_271); });
}
function View_AddEmployeesComponent_0(_l) {
    return core["ɵvid"](0, [core["ɵqud"](402653184, 1, { cropper: 0 }), (_l()(), core["ɵeld"](1, 0, null, null, 18, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 10, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_1)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_2)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 3, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_3)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployeesComponent_4)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](17, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mb-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](18, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADD"); _ck(_v, 4, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 6, 0, currVal_1); var currVal_3 = _co.loading; _ck(_v, 14, 0, currVal_3); var currVal_4 = !_co.loading; _ck(_v, 16, 0, currVal_4); }, function (_ck, _v) { var currVal_2 = core["ɵunv"](_v, 11, 0, core["ɵnov"](_v, 12).transform("back")); _ck(_v, 11, 0, currVal_2); var currVal_5 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("cancel")); _ck(_v, 18, 0, currVal_5); });
}
function View_AddEmployeesComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddEmployees", [], null, [["document", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("document:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).onClick($event, $event.target) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AddEmployeesComponent_0, RenderType_AddEmployeesComponent)), core["ɵdid"](1, 49152, null, 0, addEmployees_AddEmployeesComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], core_es5["j" /* TranslateService */], common["Location"], SharedData, ToasterComponent, core["ViewContainerRef"]], null, null)], null, null);
}
var AddEmployeesComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddEmployees", addEmployees_AddEmployeesComponent, View_AddEmployeesComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/switchUser/switchUser.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_employee_employeeFilter.ngfactory,_employee_employeeFilter,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_angular_platform_browser,_angular_forms,_toasterComponent_toasterComponent,_angular_common,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_switchUser,_shared_permissions_permissions PURE_IMPORTS_END */



















var styles_SwitchUserComponent = [];
var RenderType_SwitchUserComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_SwitchUserComponent, data: {} });

function View_SwitchUserComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mr-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeSelectedEmpPermission() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("removePermission")); _ck(_v, 1, 0, currVal_0); });
}
function View_SwitchUserComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "button", [["class", "btn btn-secondary float-right mr-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeAllEmpPermission() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("remove")); var currVal_1 = _co.totalCount; var currVal_2 = core["ɵunv"](_v, 1, 2, core["ɵnov"](_v, 3).transform("userPermission")); _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2); });
}
function View_SwitchUserComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "employeeFilter", [], null, [[null, "searchEmp"], ["window", "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("searchEmp" === en)) {
                var pd_1 = (_co.showSearchFilter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EmployeeFilter_0, RenderType_EmployeeFilter)), core["ɵdid"](2, 114688, null, 0, employeeFilter_EmployeeFilter, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { displayTab: [0, "displayTab"] }, { searchEmp: "searchEmp" })], function (_ck, _v) { var currVal_0 = "employeeSearch"; _ck(_v, 2, 0, currVal_0); }, null);
}
function View_SwitchUserComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectAll() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 5, "input", [["id", "selectedAllSwitchAble"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.selectedAllSwitchAble = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 0, "label", [["class", "mb-md-0"], ["for", "selectedAllSwitchAble"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](18, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](20, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](22, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](24, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.selectedAllSwitchAble; _ck(_v, 6, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 8).ngClassValid; var currVal_5 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_8 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("empID")); _ck(_v, 12, 0, currVal_8); var currVal_9 = core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 17).transform("name")); _ck(_v, 16, 0, currVal_9); var currVal_10 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("orgUnit")); _ck(_v, 20, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 24, 0, core["ɵnov"](_v, 25).transform("designation")); _ck(_v, 24, 0, currVal_11); });
}
function View_SwitchUserComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.employeeCode; _ck(_v, 1, 0, currVal_0); }); }
function View_SwitchUserComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_SwitchUserComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.displayName; _ck(_v, 1, 0, currVal_0); }); }
function View_SwitchUserComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_SwitchUserComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.organizationName; _ck(_v, 1, 0, currVal_0); }); }
function View_SwitchUserComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_SwitchUserComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.designation; _ck(_v, 1, 0, currVal_0); }); }
function View_SwitchUserComponent_16(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_SwitchUserComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 29, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 5, "input", [["type", "checkbox"]], [[8, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "click"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.context.$implicit.isChecked = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("click" === en)) {
                var pd_3 = (_co.unSelect($event, _v.context.$implicit) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 0, "label", [["class", "mb-md-0"]], [[8, "htmlFor", 0]], null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 4, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_9)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_10)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_11)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_12)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_13)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_14)), core["ɵdid"](24, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](25, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_15)), core["ɵdid"](27, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_16)), core["ɵdid"](29, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_8 = _v.context.$implicit.isChecked; _ck(_v, 6, 0, currVal_8); var currVal_10 = (_v.context.$implicit.employeeCode != null); _ck(_v, 12, 0, currVal_10); var currVal_11 = (_v.context.$implicit.employeeCode == null); _ck(_v, 14, 0, currVal_11); var currVal_12 = (_v.context.$implicit.employeeCode != null); _ck(_v, 17, 0, currVal_12); var currVal_13 = (_v.context.$implicit.employeeCode == null); _ck(_v, 19, 0, currVal_13); var currVal_14 = (_v.context.$implicit.employeeCode != null); _ck(_v, 22, 0, currVal_14); var currVal_15 = (_v.context.$implicit.employeeCode == null); _ck(_v, 24, 0, currVal_15); var currVal_16 = (_v.context.$implicit.employeeCode != null); _ck(_v, 27, 0, currVal_16); var currVal_17 = (_v.context.$implicit.employeeCode == null); _ck(_v, 29, 0, currVal_17); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "checkbox", _v.context.index, ""); var currVal_1 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 8).ngClassValid; var currVal_6 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_9 = core["ɵinlineInterpolate"](1, "checkbox", _v.context.index, ""); _ck(_v, 9, 0, currVal_9); });
}
function View_SwitchUserComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_8)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.switchableUsers; _ck(_v, 2, 0, currVal_0); }, null); }
function View_SwitchUserComponent_17(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noEmployeeFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_SwitchUserComponent_18(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                _co.clicked();
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "float-left mb-0 mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", "- ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](6, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_4 = true; var currVal_5 = false; var currVal_6 = true; var currVal_7 = _co.totalCount; var currVal_8 = 5; var currVal_9 = _co.page; _ck(_v, 6, 0, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.startCount; var currVal_1 = _co.endCount; var currVal_2 = core["ɵunv"](_v, 2, 2, core["ɵnov"](_v, 3).transform("itemsOf")); var currVal_3 = _co.totalCount; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3); });
}
function View_SwitchUserComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "div", [["class", "w-100 float-left mt-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_6)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_7)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_17)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_18)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.switchableUsersCount > 0); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.switchableUsersCount > 0); _ck(_v, 5, 0, currVal_1); var currVal_2 = (_co.switchableUsersCount == 0); _ck(_v, 7, 0, currVal_2); var currVal_3 = (_co.switchableUsersCount > 0); _ck(_v, 9, 0, currVal_3); }, null);
}
function View_SwitchUserComponent_20(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "col-lg-10 col-md-10 float-left mb-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-primary float-right pl-3 m-0 cursor"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.getEveryEmployee(false) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 0, "textarea", [["class", "form-control w-100"], ["rows", "5"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "span", [["class", "text-12x"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("doNotEmpCode")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("enterEmpCodeWithSeparator")); _ck(_v, 6, 0, currVal_1); });
}
function View_SwitchUserComponent_19(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 36, "div", [["class", "w-100 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "w-100 float-left d-flex align-items-center b-b pb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 3, "button", [["class", "btn btn-secondary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 20, "div", [["class", "w-100 float-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 2, "h6", [["class", "medium mb-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.everyone() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "input", [["checked", ""], ["id", "everyone"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "label", [["class", "normal"], ["for", "everyone"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.everyOneIn() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 0, "input", [["id", "except"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "label", [["class", "normal"], ["for", "except"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.everyOneIn() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 0, "input", [["id", "everyOneIn"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 2, "label", [["class", "normal"], ["for", "everyOneIn"]], null, null, null, null, null)), (_l()(), core["ɵted"](27, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_20)), core["ɵdid"](30, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](31, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, null, null, null, null)), (_l()(), core["ɵted"](32, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](34, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mr-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](35, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_6 = (_co.empArea == 3); _ck(_v, 30, 0, currVal_6); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("addEmployees")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("back")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("chooseEmpAdd")); _ck(_v, 12, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("includeEveryOne")); _ck(_v, 17, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("includeEveryOneExpect")); _ck(_v, 22, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 27, 0, core["ɵnov"](_v, 28).transform("includeEveryoneIn")); _ck(_v, 27, 0, currVal_5); var currVal_7 = core["ɵunv"](_v, 32, 0, core["ɵnov"](_v, 33).transform("add")); _ck(_v, 32, 0, currVal_7); var currVal_8 = core["ɵunv"](_v, 35, 0, core["ɵnov"](_v, 36).transform("cancel")); _ck(_v, 35, 0, currVal_8); });
}
function View_SwitchUserComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 22, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 15, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                _co.clicked();
                var pd_0 = (_co.closeEmployeeFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 14, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", " (", ")"])), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 3, "button", [["class", "btn btn-secondary float-right mr-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co._location.back() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-4 "]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.switchToAddSwitchableUsers() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_2)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_3)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_4)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_5)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_19)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_4 = (_co.employeeIdStrList.length > 0); _ck(_v, 14, 0, currVal_4); var currVal_5 = ((_co.employeeIdStrList.length > 0) && (_co.totalCount > 10)); _ck(_v, 16, 0, currVal_5); var currVal_6 = (_co.switchableUsersCount > 0); _ck(_v, 18, 0, currVal_6); var currVal_7 = (_co.switchPage == "selectSwitchableUsers"); _ck(_v, 20, 0, currVal_7); var currVal_8 = (_co.switchPage == "getSwitchableUsers"); _ck(_v, 22, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeDetails.displayName; var currVal_1 = _co.employeeDetails.empCode; _ck(_v, 4, 0, currVal_0, currVal_1); var currVal_2 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("back")); _ck(_v, 8, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 11, 0, core["ɵnov"](_v, 12).transform("addUsers")); _ck(_v, 11, 0, currVal_3); });
}
function View_SwitchUserComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_SwitchUserComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 1, 0, currVal_0); }, null); }
function View_SwitchUserComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "switch-user", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_SwitchUserComponent_0, RenderType_SwitchUserComponent)), core["ɵdid"](1, 114688, null, 0, switchUser_SwitchUserComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, ToasterComponent, core["ViewContainerRef"], auth_Auth, core["ElementRef"], common["Location"], core_es5["j" /* TranslateService */], SharedData], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null);
}
var SwitchUserComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("switch-user", switchUser_SwitchUserComponent, View_SwitchUserComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/designationList.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_angular_forms,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_designationList,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_angular_platform_browser,_toasterComponent_toasterComponent PURE_IMPORTS_END */


















var styles_DesignationPageComponent = [];
var RenderType_DesignationPageComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_DesignationPageComponent, data: {} });

function View_DesignationPageComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editDesignation(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteDesg(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("edit")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("delete")); _ck(_v, 9, 0, currVal_1); });
}
function View_DesignationPageComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](12, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignationPageComponent_3)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("clickForMoreOption")), ""); _ck(_v, 12, 0, currVal_3); var currVal_4 = (_v.context.index == _co.trackHides); _ck(_v, 16, 0, currVal_4); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.code; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.level; _ck(_v, 9, 0, currVal_2); });
}
function View_DesignationPageComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignationPageComponent_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.desgData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_DesignationPageComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_DesignationPageComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_DesignationPageComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignationPageComponent_5)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignationPageComponent_6)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_DesignationPageComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 62, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-3"], ["name", "addDesignation"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addDesignation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 52, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignationPageComponent_1)), core["ɵdid"](29, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_DesignationPageComponent_4)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](32, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](38, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](40, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSizeMainDes"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](43, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](45, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](46, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](47, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](48, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](50, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](51, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](52, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](54, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](55, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](56, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](58, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](60, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](61, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](62, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_6 = (_co.desgData.length > 0); _ck(_v, 29, 0, currVal_6); var currVal_7 = (_co.desgData.length == 0); _ck(_v, 31, 0, currVal_7); var currVal_20 = "pageSizeMainDes"; var currVal_21 = _co.pageSize; _ck(_v, 43, 0, currVal_20, currVal_21); var currVal_22 = "10"; _ck(_v, 47, 0, currVal_22); var currVal_23 = "10"; _ck(_v, 48, 0, currVal_23); var currVal_24 = "20"; _ck(_v, 51, 0, currVal_24); var currVal_25 = "20"; _ck(_v, 52, 0, currVal_25); var currVal_26 = "30"; _ck(_v, 55, 0, currVal_26); var currVal_27 = "30"; _ck(_v, 56, 0, currVal_27); var currVal_28 = true; var currVal_29 = false; var currVal_30 = true; var currVal_31 = _co.collectionSize; var currVal_32 = 5; var currVal_33 = _co.page; var currVal_34 = _co.pageSize; _ck(_v, 60, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("designation")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("addDesig")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("name")); _ck(_v, 14, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("code")); _ck(_v, 18, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("level")); _ck(_v, 22, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("action")); _ck(_v, 26, 0, currVal_5); var currVal_8 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_9 = ((_co.pageSize * (_co.page - 1)) + _co.desgPageData.numberOfElements); var currVal_10 = core["ɵunv"](_v, 34, 2, core["ɵnov"](_v, 35).transform("itemsOf")); var currVal_11 = _co.desgPageData.totalElements; _ck(_v, 34, 0, currVal_8, currVal_9, currVal_10, currVal_11); var currVal_12 = core["ɵunv"](_v, 38, 0, core["ɵnov"](_v, 39).transform("showItemsPerPage")); _ck(_v, 38, 0, currVal_12); var currVal_13 = core["ɵnov"](_v, 45).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 45).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 45).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 45).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 45).ngClassValid; var currVal_18 = core["ɵnov"](_v, 45).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 45).ngClassPending; _ck(_v, 40, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); });
}
function View_DesignationPageComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "ToolsMenu", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_DesignationPageComponent_0, RenderType_DesignationPageComponent)), core["ɵdid"](1, 49152, null, 0, designationList_DesignationPageComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null);
}
var DesignationPageComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("ToolsMenu", designationList_DesignationPageComponent, View_DesignationPageComponent_Host_0, {}, { updateRate: "updateRate" }, []);



// CONCATENATED MODULE: ./src/app/tools/organizationUnit/organizationUnitList.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_organizationUnitList,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_angular_platform_browser,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */


















var styles_OrgUnitTypePageComponent = [];
var RenderType_OrgUnitTypePageComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_OrgUnitTypePageComponent, data: {} });

function View_OrgUnitTypePageComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editOrgUnitType(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteOrgUnitType(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("edit")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("delete")); _ck(_v, 9, 0, currVal_1); });
}
function View_OrgUnitTypePageComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](12, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrgUnitTypePageComponent_3)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("clickForMoreOption")), ""); _ck(_v, 12, 0, currVal_3); var currVal_4 = (_v.context.index == _co.trackHides); _ck(_v, 16, 0, currVal_4); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.orgUnitTypeName; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.orgUnitTypeCode; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.level; _ck(_v, 9, 0, currVal_2); });
}
function View_OrgUnitTypePageComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 2, null, View_OrgUnitTypePageComponent_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), core["ɵpid"](0, common["SlicePipe"], []), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_co.orgUnitTypeData, _co.startingPage, _co.endingPage)); _ck(_v, 2, 0, currVal_0); }, null); }
function View_OrgUnitTypePageComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_OrgUnitTypePageComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_OrgUnitTypePageComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrgUnitTypePageComponent_5)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrgUnitTypePageComponent_6)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_OrgUnitTypePageComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 63, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 3, "button", [["class", "btn btn-primary float-right mr-3"], ["name", "addOrgUnit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addOrganizationUnitType() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](8, null, [" ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 52, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](17, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](19, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](21, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](23, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](25, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](27, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrgUnitTypePageComponent_1)), core["ɵdid"](30, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrgUnitTypePageComponent_4)), core["ɵdid"](32, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](33, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](35, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](37, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](39, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](41, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSizeOrgCat"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 42).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 42).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.orgUnitTypeFilter.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](42, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](44, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](46, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](47, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](48, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](49, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](51, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](52, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](53, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](55, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](56, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](57, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](59, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](60, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.orgUnitTypeFilter.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.getAllOrgUnitType() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](61, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](62, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_7 = (_co.orgUnitTypeData.length > 0); _ck(_v, 30, 0, currVal_7); var currVal_8 = (_co.orgUnitTypeData.length == 0); _ck(_v, 32, 0, currVal_8); var currVal_21 = "pageSizeOrgCat"; var currVal_22 = _co.orgUnitTypeFilter.pageSize; _ck(_v, 44, 0, currVal_21, currVal_22); var currVal_23 = "10"; _ck(_v, 48, 0, currVal_23); var currVal_24 = "10"; _ck(_v, 49, 0, currVal_24); var currVal_25 = "20"; _ck(_v, 52, 0, currVal_25); var currVal_26 = "20"; _ck(_v, 53, 0, currVal_26); var currVal_27 = "30"; _ck(_v, 56, 0, currVal_27); var currVal_28 = "30"; _ck(_v, 57, 0, currVal_28); var currVal_29 = true; var currVal_30 = false; var currVal_31 = true; var currVal_32 = _co.collectionSize; var currVal_33 = 5; var currVal_34 = _co.orgUnitTypeFilter.page; var currVal_35 = _co.orgUnitTypeFilter.pageSize; _ck(_v, 61, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("orgUnitType")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("add")); var currVal_2 = core["ɵunv"](_v, 8, 1, core["ɵnov"](_v, 10).transform("orgUnitType")); _ck(_v, 8, 0, currVal_1, currVal_2); var currVal_3 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("name")); _ck(_v, 15, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 19, 0, core["ɵnov"](_v, 20).transform("code")); _ck(_v, 19, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 23, 0, core["ɵnov"](_v, 24).transform("level")); _ck(_v, 23, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 27, 0, core["ɵnov"](_v, 28).transform("action")); _ck(_v, 27, 0, currVal_6); var currVal_9 = (((_co.orgUnitTypeFilter.page - 1) * _co.orgUnitTypeFilter.pageSize) + 1); var currVal_10 = ((_co.orgUnitTypeFilter.pageSize * (_co.orgUnitTypeFilter.page - 1)) + _co.orgUnitTypePageData.numberOfElements); var currVal_11 = core["ɵunv"](_v, 35, 2, core["ɵnov"](_v, 36).transform("itemsOf")); var currVal_12 = _co.orgUnitTypePageData.totalElements; _ck(_v, 35, 0, currVal_9, currVal_10, currVal_11, currVal_12); var currVal_13 = core["ɵunv"](_v, 39, 0, core["ɵnov"](_v, 40).transform("showItemsPerPage")); _ck(_v, 39, 0, currVal_13); var currVal_14 = core["ɵnov"](_v, 46).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 46).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 46).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 46).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 46).ngClassValid; var currVal_19 = core["ɵnov"](_v, 46).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 46).ngClassPending; _ck(_v, 41, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); });
}
function View_OrgUnitTypePageComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "org-unit-type", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_OrgUnitTypePageComponent_0, RenderType_OrgUnitTypePageComponent)), core["ɵdid"](1, 49152, null, 0, organizationUnitList_OrgUnitTypePageComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null);
}
var OrgUnitTypePageComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("org-unit-type", organizationUnitList_OrgUnitTypePageComponent, View_OrgUnitTypePageComponent_Host_0, {}, { updateRate: "updateRate" }, []);



// CONCATENATED MODULE: ./src/app/tools/userGroup/userGroup.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_userGroup,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_sharedData,_angular_platform_browser,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */

















var styles_UserGroupPage = [];
var RenderType_UserGroupPage = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_UserGroupPage, data: {} });

function View_UserGroupPage_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate text-primary"], ["ngb-tooltip", "Click for more Info"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.viewDetails(_v.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.name; _ck(_v, 1, 0, currVal_0); });
}
function View_UserGroupPage_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.name; _ck(_v, 1, 0, currVal_0); }); }
function View_UserGroupPage_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteUsers(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-user-times mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("removeUsers")); _ck(_v, 2, 0, currVal_0); });
}
function View_UserGroupPage_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 14, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editUserGrp(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteUserGrp(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addUsers(_v.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 0, "i", [["class", "fa fa-users mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_6)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_3 = (_v.parent.context.$implicit.userCount > 0); _ck(_v, 16, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("editUserGroup")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("deleteUserGroup")); _ck(_v, 9, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("addUsers")); _ck(_v, 13, 0, currVal_2); });
}
function View_UserGroupPage_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_3)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_4)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), (_l()(), core["ɵeld"](12, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_5)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_v.context.$implicit.userCount > 0); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_v.context.$implicit.userCount == 0); _ck(_v, 5, 0, currVal_1); var currVal_4 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("clickForMoreOption")), ""); _ck(_v, 14, 0, currVal_4); var currVal_5 = (_v.context.index == _co.trackHides); _ck(_v, 18, 0, currVal_5); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.description; _ck(_v, 8, 0, currVal_2); var currVal_3 = _v.context.$implicit.userCount; _ck(_v, 11, 0, currVal_3); });
}
function View_UserGroupPage_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.userGroup; _ck(_v, 2, 0, currVal_0); }, null); }
function View_UserGroupPage_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_UserGroupPage_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_UserGroupPage_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_8)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_9)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_UserGroupPage_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 62, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-3"], ["name", "addUserGrp"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addUserGrp() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 52, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_1)), core["ɵdid"](29, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UserGroupPage_7)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](32, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, [" ", " - ", " ", " ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](38, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](40, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSizeUG"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](43, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](45, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](46, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](47, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](48, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](50, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](51, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](52, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](54, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](55, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](56, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](58, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](60, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](61, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](62, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_6 = (_co.userGroup.length > 0); _ck(_v, 29, 0, currVal_6); var currVal_7 = (_co.userGroup.length == 0); _ck(_v, 31, 0, currVal_7); var currVal_20 = "pageSizeUG"; var currVal_21 = _co.pageSize; _ck(_v, 43, 0, currVal_20, currVal_21); var currVal_22 = "10"; _ck(_v, 47, 0, currVal_22); var currVal_23 = "10"; _ck(_v, 48, 0, currVal_23); var currVal_24 = "20"; _ck(_v, 51, 0, currVal_24); var currVal_25 = "20"; _ck(_v, 52, 0, currVal_25); var currVal_26 = "30"; _ck(_v, 55, 0, currVal_26); var currVal_27 = "30"; _ck(_v, 56, 0, currVal_27); var currVal_28 = true; var currVal_29 = false; var currVal_30 = true; var currVal_31 = _co.collectionSize; var currVal_32 = 5; var currVal_33 = _co.page; var currVal_34 = _co.pageSize; _ck(_v, 60, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("USER_GROUP_ADMIN")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("createUserGroup")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("name")); _ck(_v, 14, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("description")); _ck(_v, 18, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("count")); _ck(_v, 22, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("actions")); _ck(_v, 26, 0, currVal_5); var currVal_8 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_9 = ((_co.pageSize * (_co.page - 1)) + _co.userPageData.numberOfElements); var currVal_10 = core["ɵunv"](_v, 34, 2, core["ɵnov"](_v, 35).transform("itemsOf")); var currVal_11 = _co.userPageData.totalElements; _ck(_v, 34, 0, currVal_8, currVal_9, currVal_10, currVal_11); var currVal_12 = core["ɵunv"](_v, 38, 0, core["ɵnov"](_v, 39).transform("showItemsPerPage")); _ck(_v, 38, 0, currVal_12); var currVal_13 = core["ɵnov"](_v, 45).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 45).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 45).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 45).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 45).ngClassValid; var currVal_18 = core["ɵnov"](_v, 45).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 45).ngClassPending; _ck(_v, 40, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); });
}
function View_UserGroupPage_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "ToolsMenu", [], null, null, null, View_UserGroupPage_0, RenderType_UserGroupPage)), core["ɵdid"](1, 49152, null, 0, userGroup_UserGroupPage, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var UserGroupPageNgFactory = /*@__PURE__*/ core["ɵccf"]("ToolsMenu", userGroup_UserGroupPage, View_UserGroupPage_Host_0, {}, { updateRate: "hideMe" }, []);



// CONCATENATED MODULE: ./src/app/tools/addDesignation.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,ng2_auto_complete_dist_ng2_auto_complete.directive,_angular_common,_addDesignation,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_angular_platform_browser,_shared_services_auth,_shared_sharedData,_toasterComponent_toasterComponent PURE_IMPORTS_END */














var styles_AddDesignationComponent = [];
var RenderType_AddDesignationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddDesignationComponent, data: {} });

function View_AddDesignationComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addDesig")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddDesignationComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("editDesig")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddDesignationComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("deleteDesig")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddDesignationComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 14, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["for", "designation"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 16777216, null, null, 6, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["max-num-list", "5"], ["name", "designationModel"], ["ng2-auto-complete", ""], ["placeholder", "Type and choose the designation"], ["value-property-name", "id"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.designationModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](11, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], valueFormatter: [7, "valueFormatter"], ngModel: [8, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), (_l()(), core["ɵeld"](12, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_8 = "designationModel"; var currVal_9 = _co.designationModel; _ck(_v, 8, 0, currVal_8, currVal_9); var currVal_10 = _co.designationObservableSource.bind(_co); var currVal_11 = "displayName"; var currVal_12 = false; var currVal_13 = "5"; var currVal_14 = _co.autoCompleteListFormatter; var currVal_15 = "Select"; var currVal_16 = _co.warning; var currVal_17 = _co.nameValueFormatter; var currVal_18 = _co.designationModel; _ck(_v, 11, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("altDesig")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_19 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("selectDesig")); _ck(_v, 13, 0, currVal_19); });
}
function View_AddDesignationComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "desAdd"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveDesgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddDesignationComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "desEdit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveDesgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("updateChanges")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddDesignationComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "desDelete"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteDesgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("delete")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddDesignationComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 129, "div", [["id", "divdata"], ["style", "display:show"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddDesignationComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddDesignationComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddDesignationComponent_3)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 3, "button", [["class", "btn btn-secondary"], ["name", "backFromDesignation"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](21, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "desCode"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.desgdata.code = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](26, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](28, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](33, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](40, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "desName"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.desgdata.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](42, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](45, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](47, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](49, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](52, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](53, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](55, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](57, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "desNameLoc"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 58)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 58).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 58)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 58)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.desgdata.nameLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](58, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](59, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](62, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](64, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](66, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](67, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](69, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](72, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](74, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["name", "desDesc"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 75)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 75).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 75)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 75)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.desgdata.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](75, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](76, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](79, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](81, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](83, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](84, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](86, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](88, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](89, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](91, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "desDescLoc"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 92)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 92).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 92)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 92)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.desgdata.descriptionLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](92, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](93, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](96, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](98, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](100, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](101, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](103, 0, null, null, 14, "div", [["class", "col-lg-8 col-md-3 "]], null, null, null, null, null)), (_l()(), core["ɵeld"](104, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](105, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](106, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](108, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](110, 0, null, null, 7, "input", [["class", "form-control"], ["max", "100"], ["min", "1"], ["name", "desLevel"], ["onkeypress", "return event.charCode >= 48  && event.charCode != 69 && event.charCode != 101"], ["type", "number"]], [[8, "placeholder", 0], [8, "readOnly", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 111)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 111).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 111)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 111)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 112).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 112).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 112).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.desgdata.level = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](111, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](112, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](114, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](116, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddDesignationComponent_4)), core["ɵdid"](119, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](120, 0, null, null, 9, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddDesignationComponent_5)), core["ɵdid"](122, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddDesignationComponent_6)), core["ɵdid"](124, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddDesignationComponent_7)), core["ɵdid"](126, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](127, 0, null, null, 2, "button", [["class", "btn btn-secondary float-left mt-4 ml-1"], ["name", "desCancel"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](128, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADD"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 5, 0, currVal_1); var currVal_2 = (_co.type == "DELETE"); _ck(_v, 7, 0, currVal_2); var currVal_15 = "250"; _ck(_v, 23, 0, currVal_15); var currVal_16 = "desCode"; var currVal_17 = _co.desgdata.code; _ck(_v, 26, 0, currVal_16, currVal_17); var currVal_30 = "250"; _ck(_v, 42, 0, currVal_30); var currVal_31 = "desName"; var currVal_32 = _co.desgdata.name; _ck(_v, 45, 0, currVal_31, currVal_32); var currVal_45 = "250"; _ck(_v, 59, 0, currVal_45); var currVal_46 = "desNameLoc"; var currVal_47 = _co.desgdata.nameLocale; _ck(_v, 62, 0, currVal_46, currVal_47); var currVal_60 = "500"; _ck(_v, 76, 0, currVal_60); var currVal_61 = "desDesc"; var currVal_62 = _co.desgdata.description; _ck(_v, 79, 0, currVal_61, currVal_62); var currVal_75 = "250"; _ck(_v, 93, 0, currVal_75); var currVal_76 = "desDescLoc"; var currVal_77 = _co.desgdata.descriptionLocale; _ck(_v, 96, 0, currVal_76, currVal_77); var currVal_89 = "desLevel"; var currVal_90 = _co.desgdata.level; _ck(_v, 114, 0, currVal_89, currVal_90); var currVal_91 = ((_co.type == "DELETE") && _co.empPresent); _ck(_v, 119, 0, currVal_91); var currVal_92 = (_co.type == "ADD"); _ck(_v, 122, 0, currVal_92); var currVal_93 = (_co.type == "EDIT"); _ck(_v, 124, 0, currVal_93); var currVal_94 = (_co.type == "DELETE"); _ck(_v, 126, 0, currVal_94); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("back")); _ck(_v, 12, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("code")); _ck(_v, 17, 0, currVal_4); var currVal_5 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 29).transform("code")), ""); var currVal_6 = (_co.type == "DELETE"); var currVal_7 = (core["ɵnov"](_v, 23).maxlength ? core["ɵnov"](_v, 23).maxlength : null); var currVal_8 = core["ɵnov"](_v, 28).ngClassUntouched; var currVal_9 = core["ɵnov"](_v, 28).ngClassTouched; var currVal_10 = core["ɵnov"](_v, 28).ngClassPristine; var currVal_11 = core["ɵnov"](_v, 28).ngClassDirty; var currVal_12 = core["ɵnov"](_v, 28).ngClassValid; var currVal_13 = core["ɵnov"](_v, 28).ngClassInvalid; var currVal_14 = core["ɵnov"](_v, 28).ngClassPending; _ck(_v, 21, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14); var currVal_18 = core["ɵunv"](_v, 31, 0, core["ɵnov"](_v, 32).transform("maxTwoFifty")); _ck(_v, 31, 0, currVal_18); var currVal_19 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("name")); _ck(_v, 36, 0, currVal_19); var currVal_20 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 48).transform("name")), ""); var currVal_21 = (_co.type == "DELETE"); var currVal_22 = (core["ɵnov"](_v, 42).maxlength ? core["ɵnov"](_v, 42).maxlength : null); var currVal_23 = core["ɵnov"](_v, 47).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 47).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 47).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 47).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 47).ngClassValid; var currVal_28 = core["ɵnov"](_v, 47).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 47).ngClassPending; _ck(_v, 40, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); var currVal_33 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("maxTwoFifty")); _ck(_v, 50, 0, currVal_33); var currVal_34 = core["ɵunv"](_v, 55, 0, core["ɵnov"](_v, 56).transform("nameLocale")); _ck(_v, 55, 0, currVal_34); var currVal_35 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 57, 0, core["ɵnov"](_v, 65).transform("nameLocale")), ""); var currVal_36 = (_co.type == "DELETE"); var currVal_37 = (core["ɵnov"](_v, 59).maxlength ? core["ɵnov"](_v, 59).maxlength : null); var currVal_38 = core["ɵnov"](_v, 64).ngClassUntouched; var currVal_39 = core["ɵnov"](_v, 64).ngClassTouched; var currVal_40 = core["ɵnov"](_v, 64).ngClassPristine; var currVal_41 = core["ɵnov"](_v, 64).ngClassDirty; var currVal_42 = core["ɵnov"](_v, 64).ngClassValid; var currVal_43 = core["ɵnov"](_v, 64).ngClassInvalid; var currVal_44 = core["ɵnov"](_v, 64).ngClassPending; _ck(_v, 57, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); var currVal_48 = core["ɵunv"](_v, 67, 0, core["ɵnov"](_v, 68).transform("maxTwoFifty")); _ck(_v, 67, 0, currVal_48); var currVal_49 = core["ɵunv"](_v, 72, 0, core["ɵnov"](_v, 73).transform("description")); _ck(_v, 72, 0, currVal_49); var currVal_50 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 74, 0, core["ɵnov"](_v, 82).transform("description")), ""); var currVal_51 = (_co.type == "DELETE"); var currVal_52 = (core["ɵnov"](_v, 76).maxlength ? core["ɵnov"](_v, 76).maxlength : null); var currVal_53 = core["ɵnov"](_v, 81).ngClassUntouched; var currVal_54 = core["ɵnov"](_v, 81).ngClassTouched; var currVal_55 = core["ɵnov"](_v, 81).ngClassPristine; var currVal_56 = core["ɵnov"](_v, 81).ngClassDirty; var currVal_57 = core["ɵnov"](_v, 81).ngClassValid; var currVal_58 = core["ɵnov"](_v, 81).ngClassInvalid; var currVal_59 = core["ɵnov"](_v, 81).ngClassPending; _ck(_v, 74, 0, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59); var currVal_63 = core["ɵunv"](_v, 84, 0, core["ɵnov"](_v, 85).transform("maxFiveHundred")); _ck(_v, 84, 0, currVal_63); var currVal_64 = core["ɵunv"](_v, 89, 0, core["ɵnov"](_v, 90).transform("descriptionLocale")); _ck(_v, 89, 0, currVal_64); var currVal_65 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 91, 0, core["ɵnov"](_v, 99).transform("descriptionLocale")), ""); var currVal_66 = (_co.type == "DELETE"); var currVal_67 = (core["ɵnov"](_v, 93).maxlength ? core["ɵnov"](_v, 93).maxlength : null); var currVal_68 = core["ɵnov"](_v, 98).ngClassUntouched; var currVal_69 = core["ɵnov"](_v, 98).ngClassTouched; var currVal_70 = core["ɵnov"](_v, 98).ngClassPristine; var currVal_71 = core["ɵnov"](_v, 98).ngClassDirty; var currVal_72 = core["ɵnov"](_v, 98).ngClassValid; var currVal_73 = core["ɵnov"](_v, 98).ngClassInvalid; var currVal_74 = core["ɵnov"](_v, 98).ngClassPending; _ck(_v, 91, 0, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74); var currVal_78 = core["ɵunv"](_v, 101, 0, core["ɵnov"](_v, 102).transform("maxTwoFifty")); _ck(_v, 101, 0, currVal_78); var currVal_79 = core["ɵunv"](_v, 106, 0, core["ɵnov"](_v, 107).transform("level")); _ck(_v, 106, 0, currVal_79); var currVal_80 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 110, 0, core["ɵnov"](_v, 117).transform("level")), ""); var currVal_81 = (_co.type == "DELETE"); var currVal_82 = core["ɵnov"](_v, 116).ngClassUntouched; var currVal_83 = core["ɵnov"](_v, 116).ngClassTouched; var currVal_84 = core["ɵnov"](_v, 116).ngClassPristine; var currVal_85 = core["ɵnov"](_v, 116).ngClassDirty; var currVal_86 = core["ɵnov"](_v, 116).ngClassValid; var currVal_87 = core["ɵnov"](_v, 116).ngClassInvalid; var currVal_88 = core["ɵnov"](_v, 116).ngClassPending; _ck(_v, 110, 0, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88); var currVal_95 = core["ɵunv"](_v, 128, 0, core["ɵnov"](_v, 129).transform("cancel")); _ck(_v, 128, 0, currVal_95); });
}
function View_AddDesignationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddDesignation", [], null, null, null, View_AddDesignationComponent_0, RenderType_AddDesignationComponent)), core["ɵdid"](1, 49152, null, 0, addDesignation_AddDesignationComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], common["Location"], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var AddDesignationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddDesignation", addDesignation_AddDesignationComponent, View_AddDesignationComponent_Host_0, { parentOrg: "parentOrg" }, { addOrgEvent: "addOrgEvent" }, []);



// CONCATENATED MODULE: ./src/app/tools/organizationUnit/organizationUnit.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_angular_forms,_organizationUnit,_angular_router,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */










var styles_AddOrgUnitTypeComponent = [];
var RenderType_AddOrgUnitTypeComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddOrgUnitTypeComponent, data: {} });

function View_AddOrgUnitTypeComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addOrgUnitType")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddOrgUnitTypeComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("edit")); var currVal_1 = core["ɵunv"](_v, 1, 1, core["ɵnov"](_v, 3).transform("orgUnitType")); _ck(_v, 1, 0, currVal_0, currVal_1); }); }
function View_AddOrgUnitTypeComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("deleteOrganization")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddOrgUnitTypeComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "saveOrgUnit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveOrgUnitType() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddOrgUnitTypeComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "editOrgUnit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveOrgUnitType() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("updateChanges")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddOrgUnitTypeComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "delOrgUnit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteOrgUnitType() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("delete")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddOrgUnitTypeComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 127, "div", [["id", "divdata"], ["style", "display:show"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddOrgUnitTypeComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddOrgUnitTypeComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddOrgUnitTypeComponent_3)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 3, "button", [["class", "btn btn-secondary"], ["name", "backOrgUnit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](21, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "codeOrgUnit"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.OrganizationUnitTypeData.orgUnitTypeCode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](26, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](28, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](33, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](40, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "nameOrgUnit"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.OrganizationUnitTypeData.orgUnitTypeName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](42, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](45, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](47, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](49, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](52, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](53, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](55, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](57, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "nameLocOrgUnit"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 58)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 58).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 58)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 58)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.OrganizationUnitTypeData.orgUnitTypeNameLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](58, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](59, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](62, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](64, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](66, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](67, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](69, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](72, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](74, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["name", "descOrgUnit"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 75)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 75).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 75)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 75)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.OrganizationUnitTypeData.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](75, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](76, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](79, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](81, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](83, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](84, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](86, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](88, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](89, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](91, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["name", "descLocOrgUnit"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 92)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 92).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 92)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 92)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.OrganizationUnitTypeData.descriptionLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](92, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](93, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](96, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](98, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](100, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](101, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](103, 0, null, null, 14, "div", [["class", "col-lg-8 col-md-3 "]], null, null, null, null, null)), (_l()(), core["ɵeld"](104, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](105, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](106, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](108, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](110, 0, null, null, 7, "input", [["class", "form-control"], ["max", "100"], ["min", "1"], ["name", "levOrgUnit"], ["onkeypress", "return event.charCode >= 48  && event.charCode != 69 && event.charCode != 101"], ["type", "number"]], [[8, "placeholder", 0], [8, "readOnly", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 111)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 111).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 111)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 111)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 112).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 112).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 112).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.OrganizationUnitTypeData.level = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](111, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](112, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](114, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](116, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](118, 0, null, null, 9, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddOrgUnitTypeComponent_4)), core["ɵdid"](120, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddOrgUnitTypeComponent_5)), core["ɵdid"](122, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddOrgUnitTypeComponent_6)), core["ɵdid"](124, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](125, 0, null, null, 2, "button", [["class", "btn btn-secondary float-left mt-4 ml-1"], ["name", "canOrgUnit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](126, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADD"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 5, 0, currVal_1); var currVal_2 = (_co.type == "DELETE"); _ck(_v, 7, 0, currVal_2); var currVal_15 = "250"; _ck(_v, 23, 0, currVal_15); var currVal_16 = "codeOrgUnit"; var currVal_17 = _co.OrganizationUnitTypeData.orgUnitTypeCode; _ck(_v, 26, 0, currVal_16, currVal_17); var currVal_30 = "250"; _ck(_v, 42, 0, currVal_30); var currVal_31 = "nameOrgUnit"; var currVal_32 = _co.OrganizationUnitTypeData.orgUnitTypeName; _ck(_v, 45, 0, currVal_31, currVal_32); var currVal_45 = "250"; _ck(_v, 59, 0, currVal_45); var currVal_46 = "nameLocOrgUnit"; var currVal_47 = _co.OrganizationUnitTypeData.orgUnitTypeNameLocale; _ck(_v, 62, 0, currVal_46, currVal_47); var currVal_60 = "500"; _ck(_v, 76, 0, currVal_60); var currVal_61 = "descOrgUnit"; var currVal_62 = _co.OrganizationUnitTypeData.description; _ck(_v, 79, 0, currVal_61, currVal_62); var currVal_75 = "500"; _ck(_v, 93, 0, currVal_75); var currVal_76 = "descLocOrgUnit"; var currVal_77 = _co.OrganizationUnitTypeData.descriptionLocale; _ck(_v, 96, 0, currVal_76, currVal_77); var currVal_89 = "levOrgUnit"; var currVal_90 = _co.OrganizationUnitTypeData.level; _ck(_v, 114, 0, currVal_89, currVal_90); var currVal_91 = (_co.type == "ADD"); _ck(_v, 120, 0, currVal_91); var currVal_92 = (_co.type == "EDIT"); _ck(_v, 122, 0, currVal_92); var currVal_93 = (_co.type == "DELETE"); _ck(_v, 124, 0, currVal_93); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("back")); _ck(_v, 12, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("code")); _ck(_v, 17, 0, currVal_4); var currVal_5 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 29).transform("code")), ""); var currVal_6 = (_co.type == "DELETE"); var currVal_7 = (core["ɵnov"](_v, 23).maxlength ? core["ɵnov"](_v, 23).maxlength : null); var currVal_8 = core["ɵnov"](_v, 28).ngClassUntouched; var currVal_9 = core["ɵnov"](_v, 28).ngClassTouched; var currVal_10 = core["ɵnov"](_v, 28).ngClassPristine; var currVal_11 = core["ɵnov"](_v, 28).ngClassDirty; var currVal_12 = core["ɵnov"](_v, 28).ngClassValid; var currVal_13 = core["ɵnov"](_v, 28).ngClassInvalid; var currVal_14 = core["ɵnov"](_v, 28).ngClassPending; _ck(_v, 21, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14); var currVal_18 = core["ɵunv"](_v, 31, 0, core["ɵnov"](_v, 32).transform("maxTwoFifty")); _ck(_v, 31, 0, currVal_18); var currVal_19 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("name")); _ck(_v, 36, 0, currVal_19); var currVal_20 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 48).transform("name")), ""); var currVal_21 = (_co.type == "DELETE"); var currVal_22 = (core["ɵnov"](_v, 42).maxlength ? core["ɵnov"](_v, 42).maxlength : null); var currVal_23 = core["ɵnov"](_v, 47).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 47).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 47).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 47).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 47).ngClassValid; var currVal_28 = core["ɵnov"](_v, 47).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 47).ngClassPending; _ck(_v, 40, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); var currVal_33 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("maxTwoFifty")); _ck(_v, 50, 0, currVal_33); var currVal_34 = core["ɵunv"](_v, 55, 0, core["ɵnov"](_v, 56).transform("nameLocale")); _ck(_v, 55, 0, currVal_34); var currVal_35 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 57, 0, core["ɵnov"](_v, 65).transform("nameLocale")), ""); var currVal_36 = (_co.type == "DELETE"); var currVal_37 = (core["ɵnov"](_v, 59).maxlength ? core["ɵnov"](_v, 59).maxlength : null); var currVal_38 = core["ɵnov"](_v, 64).ngClassUntouched; var currVal_39 = core["ɵnov"](_v, 64).ngClassTouched; var currVal_40 = core["ɵnov"](_v, 64).ngClassPristine; var currVal_41 = core["ɵnov"](_v, 64).ngClassDirty; var currVal_42 = core["ɵnov"](_v, 64).ngClassValid; var currVal_43 = core["ɵnov"](_v, 64).ngClassInvalid; var currVal_44 = core["ɵnov"](_v, 64).ngClassPending; _ck(_v, 57, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); var currVal_48 = core["ɵunv"](_v, 67, 0, core["ɵnov"](_v, 68).transform("maxTwoFifty")); _ck(_v, 67, 0, currVal_48); var currVal_49 = core["ɵunv"](_v, 72, 0, core["ɵnov"](_v, 73).transform("description")); _ck(_v, 72, 0, currVal_49); var currVal_50 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 74, 0, core["ɵnov"](_v, 82).transform("description")), ""); var currVal_51 = (_co.type == "DELETE"); var currVal_52 = (core["ɵnov"](_v, 76).maxlength ? core["ɵnov"](_v, 76).maxlength : null); var currVal_53 = core["ɵnov"](_v, 81).ngClassUntouched; var currVal_54 = core["ɵnov"](_v, 81).ngClassTouched; var currVal_55 = core["ɵnov"](_v, 81).ngClassPristine; var currVal_56 = core["ɵnov"](_v, 81).ngClassDirty; var currVal_57 = core["ɵnov"](_v, 81).ngClassValid; var currVal_58 = core["ɵnov"](_v, 81).ngClassInvalid; var currVal_59 = core["ɵnov"](_v, 81).ngClassPending; _ck(_v, 74, 0, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59); var currVal_63 = core["ɵunv"](_v, 84, 0, core["ɵnov"](_v, 85).transform("maxFiveHundred")); _ck(_v, 84, 0, currVal_63); var currVal_64 = core["ɵunv"](_v, 89, 0, core["ɵnov"](_v, 90).transform("descriptionLocale")); _ck(_v, 89, 0, currVal_64); var currVal_65 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 91, 0, core["ɵnov"](_v, 99).transform("descriptionLocale")), ""); var currVal_66 = (_co.type == "DELETE"); var currVal_67 = (core["ɵnov"](_v, 93).maxlength ? core["ɵnov"](_v, 93).maxlength : null); var currVal_68 = core["ɵnov"](_v, 98).ngClassUntouched; var currVal_69 = core["ɵnov"](_v, 98).ngClassTouched; var currVal_70 = core["ɵnov"](_v, 98).ngClassPristine; var currVal_71 = core["ɵnov"](_v, 98).ngClassDirty; var currVal_72 = core["ɵnov"](_v, 98).ngClassValid; var currVal_73 = core["ɵnov"](_v, 98).ngClassInvalid; var currVal_74 = core["ɵnov"](_v, 98).ngClassPending; _ck(_v, 91, 0, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74); var currVal_78 = core["ɵunv"](_v, 101, 0, core["ɵnov"](_v, 102).transform("maxFiveHundred")); _ck(_v, 101, 0, currVal_78); var currVal_79 = core["ɵunv"](_v, 106, 0, core["ɵnov"](_v, 107).transform("level")); _ck(_v, 106, 0, currVal_79); var currVal_80 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 110, 0, core["ɵnov"](_v, 117).transform("level")), ""); var currVal_81 = (_co.type == "DELETE"); var currVal_82 = core["ɵnov"](_v, 116).ngClassUntouched; var currVal_83 = core["ɵnov"](_v, 116).ngClassTouched; var currVal_84 = core["ɵnov"](_v, 116).ngClassPristine; var currVal_85 = core["ɵnov"](_v, 116).ngClassDirty; var currVal_86 = core["ɵnov"](_v, 116).ngClassValid; var currVal_87 = core["ɵnov"](_v, 116).ngClassInvalid; var currVal_88 = core["ɵnov"](_v, 116).ngClassPending; _ck(_v, 110, 0, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88); var currVal_94 = core["ɵunv"](_v, 126, 0, core["ɵnov"](_v, 127).transform("cancel")); _ck(_v, 126, 0, currVal_94); });
}
function View_AddOrgUnitTypeComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddOrgUnitType", [], null, null, null, View_AddOrgUnitTypeComponent_0, RenderType_AddOrgUnitTypeComponent)), core["ɵdid"](1, 49152, null, 0, organizationUnit_AddOrgUnitTypeComponent, [fesm5_router["a" /* ActivatedRoute */], Configuration, http_client_HttpClientCustom, common["Location"], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var AddOrgUnitTypeComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddOrgUnitType", organizationUnit_AddOrgUnitTypeComponent, View_AddOrgUnitTypeComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/userGroup/addUserGroup.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_angular_forms,_addUserGroup,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_angular_platform_browser,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */












var styles_AddUserGroupComponent = [];
var RenderType_AddUserGroupComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddUserGroupComponent, data: {} });

function View_AddUserGroupComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("createUserGroup")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddUserGroupComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("editGroup")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddUserGroupComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editOrSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.buttonDisabled; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("create")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddUserGroupComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editOrSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.buttonDisabled; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("Update")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddUserGroupComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 53, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUserGroupComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUserGroupComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 3, "button", [["class", "btn btn-secondary float-right mb-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 34, "div", [["class", "w-50 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 33, "form", [["action", ""], ["novalidate", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "submit"], [null, "reset"]], function (_v, en, $event) {
            var ad = true;
            if (("submit" === en)) {
                var pd_0 = (core["ɵnov"](_v, 14).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("reset" === en)) {
                var pd_1 = (core["ɵnov"](_v, 14).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](13, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bg"], [], null, null), core["ɵdid"](14, 4210688, null, 0, fesm5_forms["NgForm"], [[8, null], [8, null]], null, null), core["ɵprd"](2048, null, fesm5_forms["ControlContainer"], null, [fesm5_forms["NgForm"]]), core["ɵdid"](16, 16384, null, 0, fesm5_forms["NgControlStatusGroup"], [[4, fesm5_forms["ControlContainer"]]], null, null), (_l()(), core["ɵeld"](17, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](19, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](21, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](23, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "200"], ["name", "name"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 24)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 24).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 24)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 24)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.userGroupdata.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](24, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](25, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](28, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](30, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](31, 0, null, null, 3, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](32, null, [" (", ". 200 ", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](35, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](37, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](39, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 5, "textarea", [["class", "form-control"], ["name", "description"], ["rows", "5"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.userGroupdata.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](43, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](45, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](46, 0, null, null, 7, "div", [["class", "col-lg-3 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUserGroupComponent_3)), core["ɵdid"](48, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUserGroupComponent_4)), core["ɵdid"](50, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](51, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mr-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](52, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADD"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 5, 0, currVal_1); var currVal_19 = "200"; _ck(_v, 25, 0, currVal_19); var currVal_20 = "name"; var currVal_21 = _co.userGroupdata.name; _ck(_v, 28, 0, currVal_20, currVal_21); var currVal_32 = "description"; var currVal_33 = _co.userGroupdata.description; _ck(_v, 43, 0, currVal_32, currVal_33); var currVal_34 = (_co.type == "ADD"); _ck(_v, 48, 0, currVal_34); var currVal_35 = (_co.type == "EDIT"); _ck(_v, 50, 0, currVal_35); }, function (_ck, _v) { var currVal_2 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("back")); _ck(_v, 9, 0, currVal_2); var currVal_3 = core["ɵnov"](_v, 16).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 16).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 16).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 16).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 16).ngClassValid; var currVal_8 = core["ɵnov"](_v, 16).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 16).ngClassPending; _ck(_v, 12, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_10 = core["ɵunv"](_v, 19, 0, core["ɵnov"](_v, 20).transform("name")); _ck(_v, 19, 0, currVal_10); var currVal_11 = (core["ɵnov"](_v, 25).maxlength ? core["ɵnov"](_v, 25).maxlength : null); var currVal_12 = core["ɵnov"](_v, 30).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 30).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 30).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 30).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 30).ngClassValid; var currVal_17 = core["ɵnov"](_v, 30).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 30).ngClassPending; _ck(_v, 23, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); var currVal_22 = core["ɵunv"](_v, 32, 0, core["ɵnov"](_v, 33).transform("Max")); var currVal_23 = core["ɵunv"](_v, 32, 1, core["ɵnov"](_v, 34).transform("character")); _ck(_v, 32, 0, currVal_22, currVal_23); var currVal_24 = core["ɵunv"](_v, 37, 0, core["ɵnov"](_v, 38).transform("description")); _ck(_v, 37, 0, currVal_24); var currVal_25 = core["ɵnov"](_v, 45).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 45).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 45).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 45).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 45).ngClassValid; var currVal_30 = core["ɵnov"](_v, 45).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 45).ngClassPending; _ck(_v, 40, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); var currVal_36 = core["ɵunv"](_v, 52, 0, core["ɵnov"](_v, 53).transform("cancel")); _ck(_v, 52, 0, currVal_36); });
}
function View_AddUserGroupComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddUserGroup", [], null, null, null, View_AddUserGroupComponent_0, RenderType_AddUserGroupComponent)), core["ɵdid"](1, 114688, null, 0, addUserGroup_AddUserGroupComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], fesm5_router["l" /* Router */], common["Location"], SharedData, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AddUserGroupComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddUserGroup", addUserGroup_AddUserGroupComponent, View_AddUserGroupComponent_Host_0, { parentOrg: "parentOrg" }, { addOrgEvent: "addOrgEvent" }, []);



// CONCATENATED MODULE: ./src/app/tools/userGroup/addUsersToGroup.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_addUsersToGroup,_.._shared_services_configuration,_.._shared_services_http.client,_angular_router,_.._toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_sharedData PURE_IMPORTS_END */















var styles_AddUsersToGroupComponent = [];
var RenderType_AddUsersToGroupComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddUsersToGroupComponent, data: {} });

function View_AddUsersToGroupComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addEmployees")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddUsersToGroupComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("removeEmp")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddUsersToGroupComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "p", [["class", "text-primary float-right pl-3 m-0 cursor"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.showAdvanced() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("doNotEmpCode")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddUsersToGroupComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-10 float-left mb-2"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_5)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 5, "textarea", [["class", "form-control w-100"], ["name", "empCodeUG"], ["rows", "5"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empCodes = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 2, "span", [["class", "text-12x"]], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.selectedOption === "everyoneIn"); _ck(_v, 2, 0, currVal_0); var currVal_8 = "empCodeUG"; var currVal_9 = _co.empCodes; _ck(_v, 6, 0, currVal_8, currVal_9); }, function (_ck, _v) { var currVal_1 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 8).ngClassValid; var currVal_6 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = core["ɵunv"](_v, 10, 0, core["ɵnov"](_v, 11).transform("enterEmpCodeWithSeparator")); _ck(_v, 10, 0, currVal_10); });
}
function View_AddUsersToGroupComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 0, "p", [["class", "text-danger  rounded p-2"]], [[8, "innerHTML", 1]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("invalidEmpCodes")); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.invalidEmployeeCodes; _ck(_v, 4, 0, currVal_1); }); }
function View_AddUsersToGroupComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 22, "div", [["class", "w-100 float-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "medium mb-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectOption("everyone") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, "input", [["checked", ""], ["id", "everyone"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "label", [["class", "normal"], ["for", "everyone"]], null, null, null, null, null)), (_l()(), core["ɵted"](7, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectOption("except") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 0, "input", [["id", "except"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 2, "label", [["class", "normal"], ["for", "except"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectOption("everyoneIn") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "input", [["id", "everyonein"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "label", [["class", "normal"], ["for", "everyonein"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_4)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_6)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_4 = (_co.selectedOption != "everyone"); _ck(_v, 20, 0, currVal_4); var currVal_5 = (_co.invalidEmployeeCodes.length > 0); _ck(_v, 22, 0, currVal_5); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("chooseEmpAdd")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform("includeEveryOne")); _ck(_v, 7, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("includeEveryOneExpect")); _ck(_v, 12, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("includeEveryoneIn")); _ck(_v, 17, 0, currVal_3); });
}
function View_AddUsersToGroupComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.employeeCode; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.employeeName; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.email; _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.userName; _ck(_v, 12, 0, currVal_3); }); }
function View_AddUsersToGroupComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_9)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddUsersToGroupComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_AddUsersToGroupComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_AddUsersToGroupComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_11)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_12)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_AddUsersToGroupComponent_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 28, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](8, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSizeAddUTG"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.searchData.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onPageSizeChange() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](15, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](16, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](18, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](19, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](20, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](22, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](23, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](24, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](26, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.searchData.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.getEmployeeDetails() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](28, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_12 = "pageSizeAddUTG"; var currVal_13 = _co.searchData.pageSize; _ck(_v, 11, 0, currVal_12, currVal_13); var currVal_14 = "10"; _ck(_v, 15, 0, currVal_14); var currVal_15 = "10"; _ck(_v, 16, 0, currVal_15); var currVal_16 = "20"; _ck(_v, 19, 0, currVal_16); var currVal_17 = "20"; _ck(_v, 20, 0, currVal_17); var currVal_18 = "30"; _ck(_v, 23, 0, currVal_18); var currVal_19 = "30"; _ck(_v, 24, 0, currVal_19); var currVal_20 = true; var currVal_21 = false; var currVal_22 = true; var currVal_23 = _co.employeePageData.totalElements; var currVal_24 = 5; var currVal_25 = _co.searchData.page; var currVal_26 = _co.searchData.pageSize; _ck(_v, 28, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (((_co.searchData.page - 1) * _co.searchData.pageSize) + 1); var currVal_1 = ((_co.searchData.pageSize * (_co.searchData.page - 1)) + _co.employeePageData.numberOfElements); var currVal_2 = core["ɵunv"](_v, 2, 2, core["ɵnov"](_v, 3).transform("itemsOf")); var currVal_3 = _co.employeePageData.totalElements; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3); var currVal_4 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("showItemsPerPage")); _ck(_v, 6, 0, currVal_4); var currVal_5 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_6 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_7 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_8 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_9 = core["ɵnov"](_v, 13).ngClassValid; var currVal_10 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_11 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 8, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11); });
}
function View_AddUsersToGroupComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 43, "div", [["class", "w-100 float-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "medium mb-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 9, "div", [["class", "col-lg-10 col-md-10 float-left mb-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 5, "textarea", [["class", "form-control w-100"], ["name", "removeEmpCodeUG"], ["rows", "5"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empCodes = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "span", [["class", "text-12x"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 5, "div", [["class", "w-100 float-left mt-3 "]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 4, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 21, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](24, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](26, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](28, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](32, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](34, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_8)), core["ɵdid"](39, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_10)), core["ɵdid"](41, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_13)), core["ɵdid"](43, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "removeEmpCodeUG"; var currVal_9 = _co.empCodes; _ck(_v, 8, 0, currVal_8, currVal_9); var currVal_16 = (_co.employeeData.length != 0); _ck(_v, 39, 0, currVal_16); var currVal_17 = (_co.employeeData.length == 0); _ck(_v, 41, 0, currVal_17); var currVal_18 = (_co.employeeData.length > 0); _ck(_v, 43, 0, currVal_18); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("chooseToRemove")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("enterEmpCodeWithSeparator")); _ck(_v, 12, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("includedList")); _ck(_v, 18, 0, currVal_11); var currVal_12 = core["ɵunv"](_v, 24, 0, core["ɵnov"](_v, 25).transform("code")); _ck(_v, 24, 0, currVal_12); var currVal_13 = core["ɵunv"](_v, 28, 0, core["ɵnov"](_v, 29).transform("name")); _ck(_v, 28, 0, currVal_13); var currVal_14 = core["ɵunv"](_v, 32, 0, core["ɵnov"](_v, 33).transform("email")); _ck(_v, 32, 0, currVal_14); var currVal_15 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("userName")); _ck(_v, 36, 0, currVal_15); });
}
function View_AddUsersToGroupComponent_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"], ["name", "addEmpUTG"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addUsers() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disableButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddUsersToGroupComponent_15(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"], ["name", "deleteEmpUTG"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeUsers() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disableButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("remove")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddUsersToGroupComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 21, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 3, "button", [["class", "btn btn-secondary float-right mb-2"], ["name", "backToUserG"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_3)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_7)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_14)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToGroupComponent_15)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mr-4"], ["name", "cancelInUTG"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](20, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADDUSERS"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "DELETEUSERS"); _ck(_v, 5, 0, currVal_1); var currVal_3 = (_co.type == "ADDUSERS"); _ck(_v, 12, 0, currVal_3); var currVal_4 = (_co.type == "DELETEUSERS"); _ck(_v, 14, 0, currVal_4); var currVal_5 = (_co.type == "ADDUSERS"); _ck(_v, 16, 0, currVal_5); var currVal_6 = (_co.type == "DELETEUSERS"); _ck(_v, 18, 0, currVal_6); }, function (_ck, _v) { var currVal_2 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("back")); _ck(_v, 9, 0, currVal_2); var currVal_7 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("cancel")); _ck(_v, 20, 0, currVal_7); });
}
function View_AddUsersToGroupComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "addUsersToGroup", [], null, null, null, View_AddUsersToGroupComponent_0, RenderType_AddUsersToGroupComponent)), core["ɵdid"](1, 49152, null, 0, addUsersToGroup_AddUsersToGroupComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, NgbModal, NgbActiveModal, SharedData, common["Location"], core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var AddUsersToGroupComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("addUsersToGroup", addUsersToGroup_AddUsersToGroupComponent, View_AddUsersToGroupComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/empTypeList.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_angular_forms,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_empTypeList,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_angular_platform_browser,_toasterComponent_toasterComponent PURE_IMPORTS_END */


















var styles_EmployementTypePageComponent = [];
var RenderType_EmployementTypePageComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmployementTypePageComponent, data: {} });

function View_EmployementTypePageComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editCategory(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteCategory(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("edit")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("delete")); _ck(_v, 9, 0, currVal_1); });
}
function View_EmployementTypePageComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 13, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 6, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployementTypePageComponent_3)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("clickForMoreOption")), ""); _ck(_v, 9, 0, currVal_2); var currVal_3 = (_v.context.index == _co.trackHides); _ck(_v, 13, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.type; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.level; _ck(_v, 6, 0, currVal_1); });
}
function View_EmployementTypePageComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployementTypePageComponent_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.empTypedata; _ck(_v, 2, 0, currVal_0); }, null); }
function View_EmployementTypePageComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_EmployementTypePageComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_EmployementTypePageComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployementTypePageComponent_5)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployementTypePageComponent_6)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_EmployementTypePageComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 58, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-3"], ["name", "addJobCat"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addCategory() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 48, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployementTypePageComponent_1)), core["ɵdid"](25, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployementTypePageComponent_4)), core["ɵdid"](27, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](28, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](30, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](32, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSizeJC"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 37).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 37).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](37, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](39, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](41, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](42, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](43, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](44, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](46, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](47, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](48, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](50, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](51, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](52, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](54, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](55, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](56, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](57, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_5 = (_co.empTypedata.length > 0); _ck(_v, 25, 0, currVal_5); var currVal_6 = (_co.empTypedata.length == 0); _ck(_v, 27, 0, currVal_6); var currVal_19 = "pageSizeJC"; var currVal_20 = _co.pageSize; _ck(_v, 39, 0, currVal_19, currVal_20); var currVal_21 = "10"; _ck(_v, 43, 0, currVal_21); var currVal_22 = "10"; _ck(_v, 44, 0, currVal_22); var currVal_23 = "20"; _ck(_v, 47, 0, currVal_23); var currVal_24 = "20"; _ck(_v, 48, 0, currVal_24); var currVal_25 = "30"; _ck(_v, 51, 0, currVal_25); var currVal_26 = "30"; _ck(_v, 52, 0, currVal_26); var currVal_27 = true; var currVal_28 = false; var currVal_29 = true; var currVal_30 = _co.collectionSize; var currVal_31 = 5; var currVal_32 = _co.page; var currVal_33 = _co.pageSize; _ck(_v, 56, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("jobCat")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("addJobCat")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("type")); _ck(_v, 14, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("level")); _ck(_v, 18, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("action")); _ck(_v, 22, 0, currVal_4); var currVal_7 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_8 = ((_co.pageSize * (_co.page - 1)) + _co.empTypePageData.numberOfElements); var currVal_9 = core["ɵunv"](_v, 30, 2, core["ɵnov"](_v, 31).transform("itemsOf")); var currVal_10 = _co.empTypePageData.totalElements; _ck(_v, 30, 0, currVal_7, currVal_8, currVal_9, currVal_10); var currVal_11 = core["ɵunv"](_v, 34, 0, core["ɵnov"](_v, 35).transform("showItemsPerPage")); _ck(_v, 34, 0, currVal_11); var currVal_12 = core["ɵnov"](_v, 41).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 41).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 41).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 41).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 41).ngClassValid; var currVal_17 = core["ɵnov"](_v, 41).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 41).ngClassPending; _ck(_v, 36, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); });
}
function View_EmployementTypePageComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "ToolsMenu", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_EmployementTypePageComponent_0, RenderType_EmployementTypePageComponent)), core["ɵdid"](1, 49152, null, 0, EmployementTypePageComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null);
}
var EmployementTypePageComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("ToolsMenu", EmployementTypePageComponent, View_EmployementTypePageComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/addEmpType.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,ng2_auto_complete_dist_ng2_auto_complete.directive,_angular_common,_addEmpType,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_angular_platform_browser,_shared_services_auth,_shared_sharedData,_toasterComponent_toasterComponent PURE_IMPORTS_END */














var styles_AddEmployementTypeComponent = [];
var RenderType_AddEmployementTypeComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddEmployementTypeComponent, data: {} });

function View_AddEmployementTypeComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addJobCat")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployementTypeComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("editJobCat")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployementTypeComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("deleteJobCat")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddEmployementTypeComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["for", "empTypeModel"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["max-num-list", "5"], ["name", "empTypeModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empTypeModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](11, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], valueFormatter: [7, "valueFormatter"], ngModel: [8, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](13, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = "empTypeModel"; var currVal_10 = _co.empTypeModel; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = _co.categoryObservableSource.bind(_co); var currVal_12 = "displayName"; var currVal_13 = false; var currVal_14 = "5"; var currVal_15 = _co.autoCompleteListCategoryFormatter; var currVal_16 = "Select"; var currVal_17 = _co.warning; var currVal_18 = _co.nameValueFormatter; var currVal_19 = _co.empTypeModel; _ck(_v, 11, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("altJobCat")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 12).transform("typeChooseJobCat")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_20 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("selectJobCat")); _ck(_v, 14, 0, currVal_20); });
}
function View_AddEmployementTypeComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "addEmpTyp"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveCategory() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddEmployementTypeComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "editEmpTyp"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveCategory() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("updateChanges")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddEmployementTypeComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "deleteEmpType"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteCategory() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("delete")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddEmployementTypeComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 129, "div", [["id", "divdata"], ["style", "display:show"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployementTypeComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployementTypeComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployementTypeComponent_3)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 3, "button", [["class", "btn btn-secondary"], ["name", "backFrmEmpType"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](21, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "empTypeCode"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empTypedata.code = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](26, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](28, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](33, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](40, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "empTypeName"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empTypedata.type = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](42, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](45, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](47, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](49, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](52, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](53, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](55, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](57, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "empTypeNameLoc"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 58)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 58).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 58)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 58)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empTypedata.typeLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](58, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](59, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](62, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](64, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](66, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](67, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](69, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](72, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](74, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["name", "empTypeDes"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 75)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 75).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 75)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 75)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empTypedata.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](75, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](76, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](79, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](81, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](83, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](84, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](86, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](88, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](89, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](91, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["name", "empTypeDesLoc"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 92)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 92).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 92)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 92)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empTypedata.descriptionLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](92, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](93, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](96, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](98, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](100, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](101, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](103, 0, null, null, 14, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](104, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](105, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](106, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](108, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](110, 0, null, null, 7, "input", [["class", "form-control"], ["max", "100"], ["min", "1"], ["name", "empTypeLev"], ["onkeypress", "return event.charCode >= 48  && event.charCode != 69 && event.charCode != 101"], ["type", "number"]], [[8, "placeholder", 0], [8, "readOnly", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 111)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 111).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 111)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 111)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 112).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 112).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 112).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.empTypedata.level = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](111, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](112, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](114, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](116, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployementTypeComponent_4)), core["ɵdid"](119, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](120, 0, null, null, 9, "div", [["class", "col-lg-3 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployementTypeComponent_5)), core["ɵdid"](122, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployementTypeComponent_6)), core["ɵdid"](124, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddEmployementTypeComponent_7)), core["ɵdid"](126, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](127, 0, null, null, 2, "button", [["class", "btn btn-secondary float-left mt-4 ml-1"], ["name", "empTypeCancel"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](128, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADD"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 5, 0, currVal_1); var currVal_2 = (_co.type == "DELETE"); _ck(_v, 7, 0, currVal_2); var currVal_15 = "250"; _ck(_v, 23, 0, currVal_15); var currVal_16 = "empTypeCode"; var currVal_17 = _co.empTypedata.code; _ck(_v, 26, 0, currVal_16, currVal_17); var currVal_30 = "250"; _ck(_v, 42, 0, currVal_30); var currVal_31 = "empTypeName"; var currVal_32 = _co.empTypedata.type; _ck(_v, 45, 0, currVal_31, currVal_32); var currVal_45 = "250"; _ck(_v, 59, 0, currVal_45); var currVal_46 = "empTypeNameLoc"; var currVal_47 = _co.empTypedata.typeLocale; _ck(_v, 62, 0, currVal_46, currVal_47); var currVal_60 = "500"; _ck(_v, 76, 0, currVal_60); var currVal_61 = "empTypeDes"; var currVal_62 = _co.empTypedata.description; _ck(_v, 79, 0, currVal_61, currVal_62); var currVal_75 = "500"; _ck(_v, 93, 0, currVal_75); var currVal_76 = "empTypeDesLoc"; var currVal_77 = _co.empTypedata.descriptionLocale; _ck(_v, 96, 0, currVal_76, currVal_77); var currVal_89 = "empTypeLev"; var currVal_90 = _co.empTypedata.level; _ck(_v, 114, 0, currVal_89, currVal_90); var currVal_91 = ((_co.type == "DELETE") && _co.empPresent); _ck(_v, 119, 0, currVal_91); var currVal_92 = (_co.type == "ADD"); _ck(_v, 122, 0, currVal_92); var currVal_93 = (_co.type == "EDIT"); _ck(_v, 124, 0, currVal_93); var currVal_94 = (_co.type == "DELETE"); _ck(_v, 126, 0, currVal_94); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("back")); _ck(_v, 12, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("code")); _ck(_v, 17, 0, currVal_4); var currVal_5 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 29).transform("code")), ""); var currVal_6 = (_co.type == "DELETE"); var currVal_7 = (core["ɵnov"](_v, 23).maxlength ? core["ɵnov"](_v, 23).maxlength : null); var currVal_8 = core["ɵnov"](_v, 28).ngClassUntouched; var currVal_9 = core["ɵnov"](_v, 28).ngClassTouched; var currVal_10 = core["ɵnov"](_v, 28).ngClassPristine; var currVal_11 = core["ɵnov"](_v, 28).ngClassDirty; var currVal_12 = core["ɵnov"](_v, 28).ngClassValid; var currVal_13 = core["ɵnov"](_v, 28).ngClassInvalid; var currVal_14 = core["ɵnov"](_v, 28).ngClassPending; _ck(_v, 21, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14); var currVal_18 = core["ɵunv"](_v, 31, 0, core["ɵnov"](_v, 32).transform("maxTwoFifty")); _ck(_v, 31, 0, currVal_18); var currVal_19 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("name")); _ck(_v, 36, 0, currVal_19); var currVal_20 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 48).transform("name")), ""); var currVal_21 = (_co.type == "DELETE"); var currVal_22 = (core["ɵnov"](_v, 42).maxlength ? core["ɵnov"](_v, 42).maxlength : null); var currVal_23 = core["ɵnov"](_v, 47).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 47).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 47).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 47).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 47).ngClassValid; var currVal_28 = core["ɵnov"](_v, 47).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 47).ngClassPending; _ck(_v, 40, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); var currVal_33 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("maxTwoFifty")); _ck(_v, 50, 0, currVal_33); var currVal_34 = core["ɵunv"](_v, 55, 0, core["ɵnov"](_v, 56).transform("nameLocale")); _ck(_v, 55, 0, currVal_34); var currVal_35 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 57, 0, core["ɵnov"](_v, 65).transform("nameLocale")), ""); var currVal_36 = (_co.type == "DELETE"); var currVal_37 = (core["ɵnov"](_v, 59).maxlength ? core["ɵnov"](_v, 59).maxlength : null); var currVal_38 = core["ɵnov"](_v, 64).ngClassUntouched; var currVal_39 = core["ɵnov"](_v, 64).ngClassTouched; var currVal_40 = core["ɵnov"](_v, 64).ngClassPristine; var currVal_41 = core["ɵnov"](_v, 64).ngClassDirty; var currVal_42 = core["ɵnov"](_v, 64).ngClassValid; var currVal_43 = core["ɵnov"](_v, 64).ngClassInvalid; var currVal_44 = core["ɵnov"](_v, 64).ngClassPending; _ck(_v, 57, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); var currVal_48 = core["ɵunv"](_v, 67, 0, core["ɵnov"](_v, 68).transform("maxTwoFifty")); _ck(_v, 67, 0, currVal_48); var currVal_49 = core["ɵunv"](_v, 72, 0, core["ɵnov"](_v, 73).transform("description")); _ck(_v, 72, 0, currVal_49); var currVal_50 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 74, 0, core["ɵnov"](_v, 82).transform("description")), ""); var currVal_51 = (_co.type == "DELETE"); var currVal_52 = (core["ɵnov"](_v, 76).maxlength ? core["ɵnov"](_v, 76).maxlength : null); var currVal_53 = core["ɵnov"](_v, 81).ngClassUntouched; var currVal_54 = core["ɵnov"](_v, 81).ngClassTouched; var currVal_55 = core["ɵnov"](_v, 81).ngClassPristine; var currVal_56 = core["ɵnov"](_v, 81).ngClassDirty; var currVal_57 = core["ɵnov"](_v, 81).ngClassValid; var currVal_58 = core["ɵnov"](_v, 81).ngClassInvalid; var currVal_59 = core["ɵnov"](_v, 81).ngClassPending; _ck(_v, 74, 0, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59); var currVal_63 = core["ɵunv"](_v, 84, 0, core["ɵnov"](_v, 85).transform("maxFiveHundred")); _ck(_v, 84, 0, currVal_63); var currVal_64 = core["ɵunv"](_v, 89, 0, core["ɵnov"](_v, 90).transform("descriptionLocale")); _ck(_v, 89, 0, currVal_64); var currVal_65 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 91, 0, core["ɵnov"](_v, 99).transform("descriptionLocale")), ""); var currVal_66 = (_co.type == "DELETE"); var currVal_67 = (core["ɵnov"](_v, 93).maxlength ? core["ɵnov"](_v, 93).maxlength : null); var currVal_68 = core["ɵnov"](_v, 98).ngClassUntouched; var currVal_69 = core["ɵnov"](_v, 98).ngClassTouched; var currVal_70 = core["ɵnov"](_v, 98).ngClassPristine; var currVal_71 = core["ɵnov"](_v, 98).ngClassDirty; var currVal_72 = core["ɵnov"](_v, 98).ngClassValid; var currVal_73 = core["ɵnov"](_v, 98).ngClassInvalid; var currVal_74 = core["ɵnov"](_v, 98).ngClassPending; _ck(_v, 91, 0, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74); var currVal_78 = core["ɵunv"](_v, 101, 0, core["ɵnov"](_v, 102).transform("maxFiveHundred")); _ck(_v, 101, 0, currVal_78); var currVal_79 = core["ɵunv"](_v, 106, 0, core["ɵnov"](_v, 107).transform("level")); _ck(_v, 106, 0, currVal_79); var currVal_80 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 110, 0, core["ɵnov"](_v, 117).transform("level")), ""); var currVal_81 = (_co.type == "DELETE"); var currVal_82 = core["ɵnov"](_v, 116).ngClassUntouched; var currVal_83 = core["ɵnov"](_v, 116).ngClassTouched; var currVal_84 = core["ɵnov"](_v, 116).ngClassPristine; var currVal_85 = core["ɵnov"](_v, 116).ngClassDirty; var currVal_86 = core["ɵnov"](_v, 116).ngClassValid; var currVal_87 = core["ɵnov"](_v, 116).ngClassInvalid; var currVal_88 = core["ɵnov"](_v, 116).ngClassPending; _ck(_v, 110, 0, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88); var currVal_95 = core["ɵunv"](_v, 128, 0, core["ɵnov"](_v, 129).transform("cancel")); _ck(_v, 128, 0, currVal_95); });
}
function View_AddEmployementTypeComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddEmpType", [], null, null, null, View_AddEmployementTypeComponent_0, RenderType_AddEmployementTypeComponent)), core["ɵdid"](1, 49152, null, 0, addEmpType_AddEmployementTypeComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], common["Location"], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var AddEmployementTypeComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddEmpType", addEmpType_AddEmployementTypeComponent, View_AddEmployementTypeComponent_Host_0, { parentOrg: "parentOrg" }, { addOrgEvent: "addOrgEvent" }, []);



// CONCATENATED MODULE: ./src/app/tools/gradeList.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_forms,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_gradeList,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_angular_platform_browser,_toasterComponent_toasterComponent PURE_IMPORTS_END */


















var styles_GradePageComponent = [];
var RenderType_GradePageComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_GradePageComponent, data: {} });

function View_GradePageComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.description; _ck(_v, 1, 0, currVal_0); }); }
function View_GradePageComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_GradePageComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editDesignation(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteDesg(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("edit")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("delete")); _ck(_v, 9, 0, currVal_1); });
}
function View_GradePageComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 21, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 4, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_GradePageComponent_3)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_GradePageComponent_4)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](9, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), (_l()(), core["ɵeld"](12, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), (_l()(), core["ɵeld"](15, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](17, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_GradePageComponent_5)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = (_v.context.$implicit.description != null); _ck(_v, 6, 0, currVal_1); var currVal_2 = (_v.context.$implicit.description == null); _ck(_v, 8, 0, currVal_2); var currVal_5 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("clickForMoreOption")), ""); _ck(_v, 17, 0, currVal_5); var currVal_6 = (_v.context.index == _co.trackHides); _ck(_v, 21, 0, currVal_6); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_0); var currVal_3 = _v.context.$implicit.gradeCode; _ck(_v, 11, 0, currVal_3); var currVal_4 = _v.context.$implicit.level; _ck(_v, 14, 0, currVal_4); });
}
function View_GradePageComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_GradePageComponent_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.gradedata; _ck(_v, 2, 0, currVal_0); }, null); }
function View_GradePageComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_GradePageComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_GradePageComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_GradePageComponent_7)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_GradePageComponent_8)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_GradePageComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 66, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-3"], ["name", "addJobGra"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addDesignation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 56, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 20, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](28, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](30, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_GradePageComponent_1)), core["ɵdid"](33, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_GradePageComponent_6)), core["ɵdid"](35, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](36, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](38, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](40, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](42, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](44, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSizeJG"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 45).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 45).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](45, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](47, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](49, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](50, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](51, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](52, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](54, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](55, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](56, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](58, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](59, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](60, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](62, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](64, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](65, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](66, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_7 = (_co.gradedata.length > 0); _ck(_v, 33, 0, currVal_7); var currVal_8 = (_co.gradedata.length == 0); _ck(_v, 35, 0, currVal_8); var currVal_21 = "pageSizeJG"; var currVal_22 = _co.pageSize; _ck(_v, 47, 0, currVal_21, currVal_22); var currVal_23 = "10"; _ck(_v, 51, 0, currVal_23); var currVal_24 = "10"; _ck(_v, 52, 0, currVal_24); var currVal_25 = "20"; _ck(_v, 55, 0, currVal_25); var currVal_26 = "20"; _ck(_v, 56, 0, currVal_26); var currVal_27 = "30"; _ck(_v, 59, 0, currVal_27); var currVal_28 = "30"; _ck(_v, 60, 0, currVal_28); var currVal_29 = true; var currVal_30 = false; var currVal_31 = true; var currVal_32 = _co.collectionSize; var currVal_33 = 5; var currVal_34 = _co.page; var currVal_35 = _co.pageSize; _ck(_v, 64, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("selectGrade")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("addJobGrade")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("name")); _ck(_v, 14, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("description")); _ck(_v, 18, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("code")); _ck(_v, 22, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("level")); _ck(_v, 26, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 30, 0, core["ɵnov"](_v, 31).transform("action")); _ck(_v, 30, 0, currVal_6); var currVal_9 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_10 = ((_co.pageSize * (_co.page - 1)) + _co.gradePageData.numberOfElements); var currVal_11 = core["ɵunv"](_v, 38, 2, core["ɵnov"](_v, 39).transform("itemsOf")); var currVal_12 = _co.gradePageData.totalElements; _ck(_v, 38, 0, currVal_9, currVal_10, currVal_11, currVal_12); var currVal_13 = core["ɵunv"](_v, 42, 0, core["ɵnov"](_v, 43).transform("showItemsPerPage")); _ck(_v, 42, 0, currVal_13); var currVal_14 = core["ɵnov"](_v, 49).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 49).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 49).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 49).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 49).ngClassValid; var currVal_19 = core["ɵnov"](_v, 49).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 49).ngClassPending; _ck(_v, 44, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); });
}
function View_GradePageComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "ToolsMenu", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_GradePageComponent_0, RenderType_GradePageComponent)), core["ɵdid"](1, 49152, null, 0, GradePageComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null);
}
var GradePageComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("ToolsMenu", GradePageComponent, View_GradePageComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/addGrade.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,ng2_auto_complete_dist_ng2_auto_complete.directive,_angular_common,_addGrade,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_angular_platform_browser,_shared_services_auth,_shared_sharedData,_toasterComponent_toasterComponent PURE_IMPORTS_END */














var styles_AddGradeComponent = [];
var RenderType_AddGradeComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddGradeComponent, data: {} });

function View_AddGradeComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addJobGrade")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddGradeComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("editJobGrade")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddGradeComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("deleteJobGrade")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddGradeComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["for", "gradeAutoComplete"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "gradeAutoComplete"], ["max-num-list", "5"], ["name", "gradeModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.gradeModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](11, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], valueFormatter: [7, "valueFormatter"], ngModel: [8, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](13, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = "gradeModel"; var currVal_10 = _co.gradeModel; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = _co.gradeObservableSource.bind(_co); var currVal_12 = "displayName"; var currVal_13 = false; var currVal_14 = "5"; var currVal_15 = _co.autoCompleteListGradeFormatter; var currVal_16 = "Select"; var currVal_17 = _co.warning; var currVal_18 = _co.nameValueFormatter; var currVal_19 = _co.gradeModel; _ck(_v, 11, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("altJobGrade")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 12).transform("typeChooseJObGrade")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_20 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("selectJobGrade")); _ck(_v, 14, 0, currVal_20); });
}
function View_AddGradeComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "jobGradeSave"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveGrade() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddGradeComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "jobGradeEdit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveGrade() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("updateChanges")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddGradeComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"], ["name", "jobGradeDel"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteGrade() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("delete")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddGradeComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 148, "div", [["id", "divdata"], ["style", "display:show"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddGradeComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddGradeComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddGradeComponent_3)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 3, "button", [["class", "btn btn-secondary"], ["name", "backJobGrade"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](21, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "jobGradeCode"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.gradedata.gradeCode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](26, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](28, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](33, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](40, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "jobGradeName"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.gradedata.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](42, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](45, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](47, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](49, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](52, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](53, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](55, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](57, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](59, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "jobGradeNameLoc"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 60)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 60).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 60)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 60)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.gradedata.nameLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](60, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](61, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](64, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](66, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](68, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](69, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](71, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](72, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](73, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](74, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](76, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["name", "jobGradeCat"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 77)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 77).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 77)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 77)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.gradedata.category = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](77, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](78, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](81, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](83, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](85, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](86, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](88, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](89, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](90, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](91, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](93, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["name", "jobGradeDesc"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 94)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 94).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 94)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 94)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.gradedata.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](94, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](95, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](98, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](100, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](102, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](103, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](105, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](106, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](107, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](108, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](110, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["name", "jobGradeDescLoc"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 111)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 111).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 111)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 111)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.gradedata.descriptionLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](111, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](112, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](115, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](117, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](119, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](120, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](122, 0, null, null, 14, "div", [["class", "col-lg-8 col-md-3 "]], null, null, null, null, null)), (_l()(), core["ɵeld"](123, 0, null, null, 13, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](124, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](125, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](127, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](129, 0, null, null, 7, "input", [["class", "form-control"], ["min", "1"], ["name", "jobGradeLev"], ["type", "number"]], [[8, "placeholder", 0], [8, "readOnly", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 130)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 130).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 130)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 130)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 131).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 131).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 131).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.gradedata.level = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](130, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](131, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](133, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](135, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddGradeComponent_4)), core["ɵdid"](138, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](139, 0, null, null, 9, "div", [["class", "col-lg-3 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddGradeComponent_5)), core["ɵdid"](141, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddGradeComponent_6)), core["ɵdid"](143, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddGradeComponent_7)), core["ɵdid"](145, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](146, 0, null, null, 2, "button", [["class", "btn btn-secondary float-left mt-4 ml-1"], ["name", "jobGradeCan"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](147, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADD"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 5, 0, currVal_1); var currVal_2 = (_co.type == "DELETE"); _ck(_v, 7, 0, currVal_2); var currVal_15 = "250"; _ck(_v, 23, 0, currVal_15); var currVal_16 = "jobGradeCode"; var currVal_17 = _co.gradedata.gradeCode; _ck(_v, 26, 0, currVal_16, currVal_17); var currVal_30 = "250"; _ck(_v, 42, 0, currVal_30); var currVal_31 = "jobGradeName"; var currVal_32 = _co.gradedata.name; _ck(_v, 45, 0, currVal_31, currVal_32); var currVal_45 = "250"; _ck(_v, 61, 0, currVal_45); var currVal_46 = "jobGradeNameLoc"; var currVal_47 = _co.gradedata.nameLocale; _ck(_v, 64, 0, currVal_46, currVal_47); var currVal_60 = "250"; _ck(_v, 78, 0, currVal_60); var currVal_61 = "jobGradeCat"; var currVal_62 = _co.gradedata.category; _ck(_v, 81, 0, currVal_61, currVal_62); var currVal_75 = "500"; _ck(_v, 95, 0, currVal_75); var currVal_76 = "jobGradeDesc"; var currVal_77 = _co.gradedata.description; _ck(_v, 98, 0, currVal_76, currVal_77); var currVal_90 = "500"; _ck(_v, 112, 0, currVal_90); var currVal_91 = "jobGradeDescLoc"; var currVal_92 = _co.gradedata.descriptionLocale; _ck(_v, 115, 0, currVal_91, currVal_92); var currVal_104 = "jobGradeLev"; var currVal_105 = _co.gradedata.level; _ck(_v, 133, 0, currVal_104, currVal_105); var currVal_106 = ((_co.type == "DELETE") && _co.empPresent); _ck(_v, 138, 0, currVal_106); var currVal_107 = (_co.type == "ADD"); _ck(_v, 141, 0, currVal_107); var currVal_108 = (_co.type == "EDIT"); _ck(_v, 143, 0, currVal_108); var currVal_109 = (_co.type == "DELETE"); _ck(_v, 145, 0, currVal_109); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("back")); _ck(_v, 12, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("code")); _ck(_v, 17, 0, currVal_4); var currVal_5 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 29).transform("code")), ""); var currVal_6 = (_co.type == "DELETE"); var currVal_7 = (core["ɵnov"](_v, 23).maxlength ? core["ɵnov"](_v, 23).maxlength : null); var currVal_8 = core["ɵnov"](_v, 28).ngClassUntouched; var currVal_9 = core["ɵnov"](_v, 28).ngClassTouched; var currVal_10 = core["ɵnov"](_v, 28).ngClassPristine; var currVal_11 = core["ɵnov"](_v, 28).ngClassDirty; var currVal_12 = core["ɵnov"](_v, 28).ngClassValid; var currVal_13 = core["ɵnov"](_v, 28).ngClassInvalid; var currVal_14 = core["ɵnov"](_v, 28).ngClassPending; _ck(_v, 21, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14); var currVal_18 = core["ɵunv"](_v, 31, 0, core["ɵnov"](_v, 32).transform("maxTwoFifty")); _ck(_v, 31, 0, currVal_18); var currVal_19 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("name")); _ck(_v, 36, 0, currVal_19); var currVal_20 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 48).transform("name")), ""); var currVal_21 = (_co.type == "DELETE"); var currVal_22 = (core["ɵnov"](_v, 42).maxlength ? core["ɵnov"](_v, 42).maxlength : null); var currVal_23 = core["ɵnov"](_v, 47).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 47).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 47).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 47).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 47).ngClassValid; var currVal_28 = core["ɵnov"](_v, 47).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 47).ngClassPending; _ck(_v, 40, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); var currVal_33 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("maxTwoFifty")); _ck(_v, 50, 0, currVal_33); var currVal_34 = core["ɵunv"](_v, 55, 0, core["ɵnov"](_v, 56).transform("nameLocale")); _ck(_v, 55, 0, currVal_34); var currVal_35 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 59, 0, core["ɵnov"](_v, 67).transform("nameLocale")), ""); var currVal_36 = (_co.type == "DELETE"); var currVal_37 = (core["ɵnov"](_v, 61).maxlength ? core["ɵnov"](_v, 61).maxlength : null); var currVal_38 = core["ɵnov"](_v, 66).ngClassUntouched; var currVal_39 = core["ɵnov"](_v, 66).ngClassTouched; var currVal_40 = core["ɵnov"](_v, 66).ngClassPristine; var currVal_41 = core["ɵnov"](_v, 66).ngClassDirty; var currVal_42 = core["ɵnov"](_v, 66).ngClassValid; var currVal_43 = core["ɵnov"](_v, 66).ngClassInvalid; var currVal_44 = core["ɵnov"](_v, 66).ngClassPending; _ck(_v, 59, 0, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); var currVal_48 = core["ɵunv"](_v, 69, 0, core["ɵnov"](_v, 70).transform("maxTwoFifty")); _ck(_v, 69, 0, currVal_48); var currVal_49 = core["ɵunv"](_v, 74, 0, core["ɵnov"](_v, 75).transform("category")); _ck(_v, 74, 0, currVal_49); var currVal_50 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 76, 0, core["ɵnov"](_v, 84).transform("category")), ""); var currVal_51 = (_co.type == "DELETE"); var currVal_52 = (core["ɵnov"](_v, 78).maxlength ? core["ɵnov"](_v, 78).maxlength : null); var currVal_53 = core["ɵnov"](_v, 83).ngClassUntouched; var currVal_54 = core["ɵnov"](_v, 83).ngClassTouched; var currVal_55 = core["ɵnov"](_v, 83).ngClassPristine; var currVal_56 = core["ɵnov"](_v, 83).ngClassDirty; var currVal_57 = core["ɵnov"](_v, 83).ngClassValid; var currVal_58 = core["ɵnov"](_v, 83).ngClassInvalid; var currVal_59 = core["ɵnov"](_v, 83).ngClassPending; _ck(_v, 76, 0, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59); var currVal_63 = core["ɵunv"](_v, 86, 0, core["ɵnov"](_v, 87).transform("maxTwoFifty")); _ck(_v, 86, 0, currVal_63); var currVal_64 = core["ɵunv"](_v, 91, 0, core["ɵnov"](_v, 92).transform("description")); _ck(_v, 91, 0, currVal_64); var currVal_65 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 93, 0, core["ɵnov"](_v, 101).transform("description")), ""); var currVal_66 = (_co.type == "DELETE"); var currVal_67 = (core["ɵnov"](_v, 95).maxlength ? core["ɵnov"](_v, 95).maxlength : null); var currVal_68 = core["ɵnov"](_v, 100).ngClassUntouched; var currVal_69 = core["ɵnov"](_v, 100).ngClassTouched; var currVal_70 = core["ɵnov"](_v, 100).ngClassPristine; var currVal_71 = core["ɵnov"](_v, 100).ngClassDirty; var currVal_72 = core["ɵnov"](_v, 100).ngClassValid; var currVal_73 = core["ɵnov"](_v, 100).ngClassInvalid; var currVal_74 = core["ɵnov"](_v, 100).ngClassPending; _ck(_v, 93, 0, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73, currVal_74); var currVal_78 = core["ɵunv"](_v, 103, 0, core["ɵnov"](_v, 104).transform("maxFiveHundred")); _ck(_v, 103, 0, currVal_78); var currVal_79 = core["ɵunv"](_v, 108, 0, core["ɵnov"](_v, 109).transform("descriptionLocale")); _ck(_v, 108, 0, currVal_79); var currVal_80 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 110, 0, core["ɵnov"](_v, 118).transform("descriptionLocale")), ""); var currVal_81 = (_co.type == "DELETE"); var currVal_82 = (core["ɵnov"](_v, 112).maxlength ? core["ɵnov"](_v, 112).maxlength : null); var currVal_83 = core["ɵnov"](_v, 117).ngClassUntouched; var currVal_84 = core["ɵnov"](_v, 117).ngClassTouched; var currVal_85 = core["ɵnov"](_v, 117).ngClassPristine; var currVal_86 = core["ɵnov"](_v, 117).ngClassDirty; var currVal_87 = core["ɵnov"](_v, 117).ngClassValid; var currVal_88 = core["ɵnov"](_v, 117).ngClassInvalid; var currVal_89 = core["ɵnov"](_v, 117).ngClassPending; _ck(_v, 110, 0, currVal_80, currVal_81, currVal_82, currVal_83, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88, currVal_89); var currVal_93 = core["ɵunv"](_v, 120, 0, core["ɵnov"](_v, 121).transform("maxFiveHundred")); _ck(_v, 120, 0, currVal_93); var currVal_94 = core["ɵunv"](_v, 125, 0, core["ɵnov"](_v, 126).transform("level")); _ck(_v, 125, 0, currVal_94); var currVal_95 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 129, 0, core["ɵnov"](_v, 136).transform("level")), ""); var currVal_96 = (_co.type == "DELETE"); var currVal_97 = core["ɵnov"](_v, 135).ngClassUntouched; var currVal_98 = core["ɵnov"](_v, 135).ngClassTouched; var currVal_99 = core["ɵnov"](_v, 135).ngClassPristine; var currVal_100 = core["ɵnov"](_v, 135).ngClassDirty; var currVal_101 = core["ɵnov"](_v, 135).ngClassValid; var currVal_102 = core["ɵnov"](_v, 135).ngClassInvalid; var currVal_103 = core["ɵnov"](_v, 135).ngClassPending; _ck(_v, 129, 0, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103); var currVal_110 = core["ɵunv"](_v, 147, 0, core["ɵnov"](_v, 148).transform("cancel")); _ck(_v, 147, 0, currVal_110); });
}
function View_AddGradeComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddGrade", [], null, null, null, View_AddGradeComponent_0, RenderType_AddGradeComponent)), core["ɵdid"](1, 49152, null, 0, addGrade_AddGradeComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], common["Location"], core_es5["j" /* TranslateService */], SharedData, ToasterComponent, core["ViewContainerRef"]], null, null)], null, null); }
var AddGradeComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddGrade", addGrade_AddGradeComponent, View_AddGradeComponent_Host_0, {}, { addOrgEvent: "addOrgEvent" }, []);



// CONCATENATED MODULE: ./src/app/tools/mgrLevelList.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_angular_forms,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_mgrLevelList,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_angular_platform_browser,_toasterComponent_toasterComponent PURE_IMPORTS_END */


















var styles_ManagerLevelComponent = [];
var RenderType_ManagerLevelComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ManagerLevelComponent, data: {} });

function View_ManagerLevelComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 8, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editDesignation(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteDesg(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("edit")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("delete")); _ck(_v, 9, 0, currVal_1); });
}
function View_ManagerLevelComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](12, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ManagerLevelComponent_3)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("clickForMoreOption")), ""); _ck(_v, 12, 0, currVal_3); var currVal_4 = (_v.context.index == _co.trackHides); _ck(_v, 16, 0, currVal_4); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.code; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.level; _ck(_v, 9, 0, currVal_2); });
}
function View_ManagerLevelComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ManagerLevelComponent_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.mgrdata; _ck(_v, 2, 0, currVal_0); }, null); }
function View_ManagerLevelComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_ManagerLevelComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_ManagerLevelComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ManagerLevelComponent_5)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ManagerLevelComponent_6)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_ManagerLevelComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 62, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-3"], ["name", "addEmpType"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addDesignation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 52, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ManagerLevelComponent_1)), core["ɵdid"](29, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ManagerLevelComponent_4)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](32, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](38, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](40, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSizeEmpType"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](43, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](45, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](46, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](47, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](48, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](50, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](51, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](52, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](54, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](55, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](56, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](58, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](60, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](61, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](62, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_6 = (_co.mgrdata.length > 0); _ck(_v, 29, 0, currVal_6); var currVal_7 = (_co.mgrdata.length == 0); _ck(_v, 31, 0, currVal_7); var currVal_20 = "pageSizeEmpType"; var currVal_21 = _co.pageSize; _ck(_v, 43, 0, currVal_20, currVal_21); var currVal_22 = "10"; _ck(_v, 47, 0, currVal_22); var currVal_23 = "10"; _ck(_v, 48, 0, currVal_23); var currVal_24 = "20"; _ck(_v, 51, 0, currVal_24); var currVal_25 = "20"; _ck(_v, 52, 0, currVal_25); var currVal_26 = "30"; _ck(_v, 55, 0, currVal_26); var currVal_27 = "30"; _ck(_v, 56, 0, currVal_27); var currVal_28 = true; var currVal_29 = false; var currVal_30 = true; var currVal_31 = _co.collectionSize; var currVal_32 = 5; var currVal_33 = _co.page; var currVal_34 = _co.pageSize; _ck(_v, 60, 0, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("empType")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("addEmpType")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("name")); _ck(_v, 14, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("code")); _ck(_v, 18, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("level")); _ck(_v, 22, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("action")); _ck(_v, 26, 0, currVal_5); var currVal_8 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_9 = ((_co.pageSize * (_co.page - 1)) + _co.mgrPageData.numberOfElements); var currVal_10 = core["ɵunv"](_v, 34, 2, core["ɵnov"](_v, 35).transform("itemsOf")); var currVal_11 = _co.mgrPageData.totalElements; _ck(_v, 34, 0, currVal_8, currVal_9, currVal_10, currVal_11); var currVal_12 = core["ɵunv"](_v, 38, 0, core["ɵnov"](_v, 39).transform("showItemsPerPage")); _ck(_v, 38, 0, currVal_12); var currVal_13 = core["ɵnov"](_v, 45).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 45).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 45).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 45).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 45).ngClassValid; var currVal_18 = core["ɵnov"](_v, 45).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 45).ngClassPending; _ck(_v, 40, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); });
}
function View_ManagerLevelComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "ToolsMenu", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ManagerLevelComponent_0, RenderType_ManagerLevelComponent)), core["ɵdid"](1, 49152, null, 0, mgrLevelList_ManagerLevelComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, core["ViewContainerRef"]], null, null)], null, null);
}
var ManagerLevelComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("ToolsMenu", mgrLevelList_ManagerLevelComponent, View_ManagerLevelComponent_Host_0, {}, { updateRate: "hideMe" }, []);



// CONCATENATED MODULE: ./src/app/tools/addMgrLevel.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,ng2_auto_complete_dist_ng2_auto_complete.directive,_angular_common,_addMgrLevel,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_angular_platform_browser,_shared_services_auth,_shared_sharedData,_toasterComponent_toasterComponent PURE_IMPORTS_END */














var styles_AddManagerLevelComponent = [];
var RenderType_AddManagerLevelComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddManagerLevelComponent, data: {} });

function View_AddManagerLevelComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addEmpType")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddManagerLevelComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("editEmpType")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddManagerLevelComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("deleteEmpType")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddManagerLevelComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "input", [["class", "form-control"], ["min", "1"], ["onkeypress", "return event.charCode >= 48  && event.charCode != 69 && event.charCode != 101"], ["type", "number"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 1)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.mgrdata.level = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](2, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_8 = _co.mgrdata.level; _ck(_v, 4, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 0, 0, core["ɵnov"](_v, 7).transform("level")), ""); var currVal_1 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 6).ngClassValid; var currVal_6 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_AddManagerLevelComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "input", [["class", "form-control"], ["min", "1"], ["readonly", ""], ["type", "number"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 1)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.mgrdata.level = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](2, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_8 = _co.mgrdata.level; _ck(_v, 4, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 0, 0, core["ɵnov"](_v, 7).transform("level")), ""); var currVal_1 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 6).ngClassValid; var currVal_6 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 0, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_AddManagerLevelComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["for", "mgrLevelModel"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["max-num-list", "5"], ["name", "mgrLevelModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mgrLevelModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](11, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], valueFormatter: [7, "valueFormatter"], ngModel: [8, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](13, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = "mgrLevelModel"; var currVal_10 = _co.mgrLevelModel; _ck(_v, 8, 0, currVal_9, currVal_10); var currVal_11 = _co.mgrLevelObservableSource.bind(_co); var currVal_12 = "displayName"; var currVal_13 = false; var currVal_14 = "5"; var currVal_15 = _co.autoCompleteListMgrLevelFormatter; var currVal_16 = "Select"; var currVal_17 = _co.warning; var currVal_18 = _co.nameValueFormatter; var currVal_19 = _co.mgrLevelModel; _ck(_v, 11, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("altEmpType")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 12).transform("typeAndChooseEmpType")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_20 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("selectEmpType")); _ck(_v, 14, 0, currVal_20); });
}
function View_AddManagerLevelComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveDesgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddManagerLevelComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveDesgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("updateChanges")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddManagerLevelComponent_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteDesgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("delete")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddManagerLevelComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 125, "div", [["id", "divdata"], ["style", "display:show"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 12, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_3)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](8, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 3, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](21, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 22)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 22)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mgrdata.code = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](23, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](26, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](28, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](33, 0, null, null, 18, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 17, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](40, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mgrdata.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](42, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](45, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](47, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](49, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](52, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](53, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](55, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](57, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 58)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 58).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 58)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 58)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mgrdata.nameLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](58, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](59, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](62, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](64, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](66, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](67, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](69, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](72, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](74, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 75)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 75).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 75)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 75)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mgrdata.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](75, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](76, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](79, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](81, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](83, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](84, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](86, 0, null, null, 16, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](88, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](89, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](91, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "500"], ["type", "text"]], [[8, "placeholder", 0], [8, "readOnly", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 92)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 92).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 92)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 92)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mgrdata.descriptionLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](92, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](93, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](96, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](98, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](100, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](101, null, ["(", ")"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](103, 0, null, null, 10, "div", [["class", "col-lg-8 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](104, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](105, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](106, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](108, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_4)), core["ɵdid"](111, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_5)), core["ɵdid"](113, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_6)), core["ɵdid"](115, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](116, 0, null, null, 9, "div", [["class", "col-lg-3 col-md-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_7)), core["ɵdid"](118, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_8)), core["ɵdid"](120, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddManagerLevelComponent_9)), core["ɵdid"](122, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](123, 0, null, null, 2, "button", [["class", "btn btn-secondary float-left mt-4 ml-1"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](124, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADD"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 5, 0, currVal_1); var currVal_2 = (_co.type == "DELETE"); _ck(_v, 7, 0, currVal_2); var currVal_15 = "250"; _ck(_v, 23, 0, currVal_15); var currVal_16 = _co.mgrdata.code; _ck(_v, 26, 0, currVal_16); var currVal_29 = "250"; _ck(_v, 42, 0, currVal_29); var currVal_30 = _co.mgrdata.name; _ck(_v, 45, 0, currVal_30); var currVal_43 = "250"; _ck(_v, 59, 0, currVal_43); var currVal_44 = _co.mgrdata.nameLocale; _ck(_v, 62, 0, currVal_44); var currVal_57 = "500"; _ck(_v, 76, 0, currVal_57); var currVal_58 = _co.mgrdata.description; _ck(_v, 79, 0, currVal_58); var currVal_71 = "500"; _ck(_v, 93, 0, currVal_71); var currVal_72 = _co.mgrdata.descriptionLocale; _ck(_v, 96, 0, currVal_72); var currVal_75 = (_co.type != "DELETE"); _ck(_v, 111, 0, currVal_75); var currVal_76 = (_co.type == "DELETE"); _ck(_v, 113, 0, currVal_76); var currVal_77 = ((_co.type == "DELETE") && _co.empPresent); _ck(_v, 115, 0, currVal_77); var currVal_78 = (_co.type == "ADD"); _ck(_v, 118, 0, currVal_78); var currVal_79 = (_co.type == "EDIT"); _ck(_v, 120, 0, currVal_79); var currVal_80 = (_co.type == "DELETE"); _ck(_v, 122, 0, currVal_80); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("back")); _ck(_v, 12, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("code")); _ck(_v, 17, 0, currVal_4); var currVal_5 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 29).transform("code")), ""); var currVal_6 = (_co.type == "DELETE"); var currVal_7 = (core["ɵnov"](_v, 23).maxlength ? core["ɵnov"](_v, 23).maxlength : null); var currVal_8 = core["ɵnov"](_v, 28).ngClassUntouched; var currVal_9 = core["ɵnov"](_v, 28).ngClassTouched; var currVal_10 = core["ɵnov"](_v, 28).ngClassPristine; var currVal_11 = core["ɵnov"](_v, 28).ngClassDirty; var currVal_12 = core["ɵnov"](_v, 28).ngClassValid; var currVal_13 = core["ɵnov"](_v, 28).ngClassInvalid; var currVal_14 = core["ɵnov"](_v, 28).ngClassPending; _ck(_v, 21, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14); var currVal_17 = core["ɵunv"](_v, 31, 0, core["ɵnov"](_v, 32).transform("maxTwoFifty")); _ck(_v, 31, 0, currVal_17); var currVal_18 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("name")); _ck(_v, 36, 0, currVal_18); var currVal_19 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 48).transform("name")), ""); var currVal_20 = (_co.type == "DELETE"); var currVal_21 = (core["ɵnov"](_v, 42).maxlength ? core["ɵnov"](_v, 42).maxlength : null); var currVal_22 = core["ɵnov"](_v, 47).ngClassUntouched; var currVal_23 = core["ɵnov"](_v, 47).ngClassTouched; var currVal_24 = core["ɵnov"](_v, 47).ngClassPristine; var currVal_25 = core["ɵnov"](_v, 47).ngClassDirty; var currVal_26 = core["ɵnov"](_v, 47).ngClassValid; var currVal_27 = core["ɵnov"](_v, 47).ngClassInvalid; var currVal_28 = core["ɵnov"](_v, 47).ngClassPending; _ck(_v, 40, 0, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28); var currVal_31 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("maxTwoFifty")); _ck(_v, 50, 0, currVal_31); var currVal_32 = core["ɵunv"](_v, 55, 0, core["ɵnov"](_v, 56).transform("nameLocale")); _ck(_v, 55, 0, currVal_32); var currVal_33 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 57, 0, core["ɵnov"](_v, 65).transform("nameLocale")), ""); var currVal_34 = (_co.type == "DELETE"); var currVal_35 = (core["ɵnov"](_v, 59).maxlength ? core["ɵnov"](_v, 59).maxlength : null); var currVal_36 = core["ɵnov"](_v, 64).ngClassUntouched; var currVal_37 = core["ɵnov"](_v, 64).ngClassTouched; var currVal_38 = core["ɵnov"](_v, 64).ngClassPristine; var currVal_39 = core["ɵnov"](_v, 64).ngClassDirty; var currVal_40 = core["ɵnov"](_v, 64).ngClassValid; var currVal_41 = core["ɵnov"](_v, 64).ngClassInvalid; var currVal_42 = core["ɵnov"](_v, 64).ngClassPending; _ck(_v, 57, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42); var currVal_45 = core["ɵunv"](_v, 67, 0, core["ɵnov"](_v, 68).transform("maxTwoFifty")); _ck(_v, 67, 0, currVal_45); var currVal_46 = core["ɵunv"](_v, 72, 0, core["ɵnov"](_v, 73).transform("description")); _ck(_v, 72, 0, currVal_46); var currVal_47 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 74, 0, core["ɵnov"](_v, 82).transform("description")), ""); var currVal_48 = (_co.type == "DELETE"); var currVal_49 = (core["ɵnov"](_v, 76).maxlength ? core["ɵnov"](_v, 76).maxlength : null); var currVal_50 = core["ɵnov"](_v, 81).ngClassUntouched; var currVal_51 = core["ɵnov"](_v, 81).ngClassTouched; var currVal_52 = core["ɵnov"](_v, 81).ngClassPristine; var currVal_53 = core["ɵnov"](_v, 81).ngClassDirty; var currVal_54 = core["ɵnov"](_v, 81).ngClassValid; var currVal_55 = core["ɵnov"](_v, 81).ngClassInvalid; var currVal_56 = core["ɵnov"](_v, 81).ngClassPending; _ck(_v, 74, 0, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56); var currVal_59 = core["ɵunv"](_v, 84, 0, core["ɵnov"](_v, 85).transform("maxFiveHundred")); _ck(_v, 84, 0, currVal_59); var currVal_60 = core["ɵunv"](_v, 89, 0, core["ɵnov"](_v, 90).transform("descriptionLocale")); _ck(_v, 89, 0, currVal_60); var currVal_61 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 91, 0, core["ɵnov"](_v, 99).transform("descriptionLocale")), ""); var currVal_62 = (_co.type == "DELETE"); var currVal_63 = (core["ɵnov"](_v, 93).maxlength ? core["ɵnov"](_v, 93).maxlength : null); var currVal_64 = core["ɵnov"](_v, 98).ngClassUntouched; var currVal_65 = core["ɵnov"](_v, 98).ngClassTouched; var currVal_66 = core["ɵnov"](_v, 98).ngClassPristine; var currVal_67 = core["ɵnov"](_v, 98).ngClassDirty; var currVal_68 = core["ɵnov"](_v, 98).ngClassValid; var currVal_69 = core["ɵnov"](_v, 98).ngClassInvalid; var currVal_70 = core["ɵnov"](_v, 98).ngClassPending; _ck(_v, 91, 0, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70); var currVal_73 = core["ɵunv"](_v, 101, 0, core["ɵnov"](_v, 102).transform("maxFiveHundred")); _ck(_v, 101, 0, currVal_73); var currVal_74 = core["ɵunv"](_v, 106, 0, core["ɵnov"](_v, 107).transform("level")); _ck(_v, 106, 0, currVal_74); var currVal_81 = core["ɵunv"](_v, 124, 0, core["ɵnov"](_v, 125).transform("cancel")); _ck(_v, 124, 0, currVal_81); });
}
function View_AddManagerLevelComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddMgrLevel", [], null, null, null, View_AddManagerLevelComponent_0, RenderType_AddManagerLevelComponent)), core["ɵdid"](1, 49152, null, 0, addMgrLevel_AddManagerLevelComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], common["Location"], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var AddManagerLevelComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddMgrLevel", addMgrLevel_AddManagerLevelComponent, View_AddManagerLevelComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/org/addParentOrganization.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_angular_forms,ng2_auto_complete_dist_ng2_auto_complete.directive,_addParentOrganization,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_services_configuration,_.._shared_services_http.client,_angular_platform_browser,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */














var styles_AddParentOrganizationComponent = [];
var RenderType_AddParentOrganizationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddParentOrganizationComponent, data: {} });

function View_AddParentOrganizationComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addOrgUnit")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddParentOrganizationComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("editOrgUnit")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddParentOrganizationComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveOrgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disableButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddParentOrganizationComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveOrgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disableButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("updateChanges")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddParentOrganizationComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 217, "div", [["id", "divdata"], ["style", "display:show"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddParentOrganizationComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddParentOrganizationComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](9, 0, null, null, 15, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](16, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 17)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 17).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 17)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 17)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgData.orgUnitCode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](17, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](18, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](21, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](23, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](25, 0, null, null, 16, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](28, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](32, 16777216, null, null, 9, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "orgUnitTypeName"], ["name", "orgTypeModel"], ["ng2-auto-complete", ""], ["required", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 33)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 33).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 33)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 33)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgTypeModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "orgType") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](33, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](34, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](37, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](39, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](40, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], listFormatter: [3, "listFormatter"], blankOptionText: [4, "blankOptionText"], noMatchFoundText: [5, "noMatchFoundText"], valueFormatter: [6, "valueFormatter"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](42, 0, null, null, 15, "div", [["class", " col-lg-6 col-md-1 float-left "]], null, null, null, null, null)), (_l()(), core["ɵeld"](43, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](44, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](45, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](47, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](49, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 50)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 50).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 50)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 50)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgData.orgName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](50, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](51, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](54, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](56, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](58, 0, null, null, 13, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](60, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](61, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](63, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 64)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 64).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 64)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 64)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgData.orgNameLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](64, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](65, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](68, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](70, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](72, 0, null, null, 13, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](73, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](74, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](75, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](77, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 78)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 78).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 78)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 78)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgData.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](78, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](79, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](82, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](84, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](86, 0, null, null, 13, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 0, null, null, 12, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](88, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](89, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](91, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 92)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 92).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 92)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 92)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgData.descriptionLocale = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](92, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](93, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](96, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](98, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](100, 0, null, null, 15, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](101, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](102, 0, null, null, 2, "label", [["for", "sup"]], null, null, null, null, null)), (_l()(), core["ɵted"](103, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](105, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "sup"], ["max-num-list", "5"], ["name", "primarySupervisorModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 106)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 106).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 106)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 106)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.primarySupervisorModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "primary") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](106, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](108, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](110, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](111, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](113, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](114, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](116, 0, null, null, 15, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](117, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](118, 0, null, null, 2, "label", [["for", "spoc"]], null, null, null, null, null)), (_l()(), core["ɵted"](119, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](121, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "spoc"], ["max-num-list", "5"], ["name", "hrSpocModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 122)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 122).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 122)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 122)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.hrSpocModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "hrSpoc") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](122, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](124, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](126, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](127, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](129, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](130, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](132, 0, null, null, 15, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](133, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](134, 0, null, null, 2, "label", [["for", "spoc"]], null, null, null, null, null)), (_l()(), core["ɵted"](135, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](137, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "spoc"], ["max-num-list", "5"], ["name", "ccAdmin"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 138)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 138).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 138)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 138)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.ccAdmin = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "ccAdmin") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](138, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](140, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](142, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](143, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](145, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](146, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](148, 0, null, null, 15, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](149, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](150, 0, null, null, 2, "label", [["for", "spoc"]], null, null, null, null, null)), (_l()(), core["ɵted"](151, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](153, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "spoc"], ["max-num-list", "5"], ["name", "ccManager"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 154)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 154).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 154)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 154)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.ccManager = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "ccManager") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](154, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](156, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](158, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](159, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](161, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](162, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](164, 0, null, null, 15, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](165, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](166, 0, null, null, 2, "label", [["for", "spoc"]], null, null, null, null, null)), (_l()(), core["ɵted"](167, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](169, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "spoc"], ["max-num-list", "5"], ["name", "leaveAdministrator"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 170)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 170).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 170)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 170)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.leaveAdministrator = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "leaveAdministrator") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](170, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](172, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](174, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](175, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](177, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](178, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](180, 0, null, null, 15, "div", [["class", " col-lg-6 col-md-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](181, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](182, 0, null, null, 2, "label", [["for", "spoc"]], null, null, null, null, null)), (_l()(), core["ɵted"](183, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](185, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "code"], ["id", "spoc"], ["max-num-list", "5"], ["name", "orgCat"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 186)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 186).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 186)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 186)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgCat = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "orgCat") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](186, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](188, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](190, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](191, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](193, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](194, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](196, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](197, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](198, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](199, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](201, 16777216, null, null, 6, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "orgName"], ["id", "spoc"], ["max-num-list", "5"], ["name", "parent"], ["ng2-auto-complete", ""], ["placeholder", "Select Parent"], ["value-property-name", "id"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 202)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 202).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 202)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 202)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.parent = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "parent") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](202, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](204, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](206, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](207, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), (_l()(), core["ɵeld"](208, 0, null, null, 9, "div", [["class", "col-lg-12 col-md-12 float-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](209, 0, null, null, 8, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](210, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](211, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](212, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddParentOrganizationComponent_3)), core["ɵdid"](215, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddParentOrganizationComponent_4)), core["ɵdid"](217, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADD"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 5, 0, currVal_1); var currVal_12 = "250"; _ck(_v, 18, 0, currVal_12); var currVal_13 = _co.orgData.orgUnitCode; _ck(_v, 21, 0, currVal_13); var currVal_24 = ""; _ck(_v, 34, 0, currVal_24); var currVal_25 = "orgTypeModel"; var currVal_26 = _co.orgTypeModel; _ck(_v, 37, 0, currVal_25, currVal_26); var currVal_27 = _co.orgTypeObservableSource.bind(_co); var currVal_28 = "orgUnitTypeName"; var currVal_29 = false; var currVal_30 = _co.autoCompleteListOrgTypeFormatter; var currVal_31 = "Select"; var currVal_32 = _co.warning; var currVal_33 = _co.orgTypeFormatter; var currVal_34 = _co.orgTypeModel; _ck(_v, 40, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34); var currVal_45 = "250"; _ck(_v, 51, 0, currVal_45); var currVal_46 = _co.orgData.orgName; _ck(_v, 54, 0, currVal_46); var currVal_57 = "250"; _ck(_v, 65, 0, currVal_57); var currVal_58 = _co.orgData.orgNameLocale; _ck(_v, 68, 0, currVal_58); var currVal_69 = "250"; _ck(_v, 79, 0, currVal_69); var currVal_70 = _co.orgData.description; _ck(_v, 82, 0, currVal_70); var currVal_81 = "250"; _ck(_v, 93, 0, currVal_81); var currVal_82 = _co.orgData.descriptionLocale; _ck(_v, 96, 0, currVal_82); var currVal_92 = "primarySupervisorModel"; var currVal_93 = _co.primarySupervisorModel; _ck(_v, 108, 0, currVal_92, currVal_93); var currVal_94 = _co.employeeObservableSource.bind(_co); var currVal_95 = "displayName"; var currVal_96 = false; var currVal_97 = "5"; var currVal_98 = _co.autoCompleteListFormatter; var currVal_99 = "Select"; var currVal_100 = _co.warning; var currVal_101 = _co.primarySupervisorModel; _ck(_v, 111, 0, currVal_94, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101); var currVal_112 = "hrSpocModel"; var currVal_113 = _co.hrSpocModel; _ck(_v, 124, 0, currVal_112, currVal_113); var currVal_114 = _co.hrrObservableSource.bind(_co); var currVal_115 = "displayName"; var currVal_116 = false; var currVal_117 = "5"; var currVal_118 = _co.autoCompleteListFormatter; var currVal_119 = "Select"; var currVal_120 = _co.warning; var currVal_121 = _co.hrSpocModel; _ck(_v, 127, 0, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118, currVal_119, currVal_120, currVal_121); var currVal_132 = "ccAdmin"; var currVal_133 = _co.ccAdmin; _ck(_v, 140, 0, currVal_132, currVal_133); var currVal_134 = _co.hrrObservableSource.bind(_co); var currVal_135 = "displayName"; var currVal_136 = false; var currVal_137 = "5"; var currVal_138 = _co.autoCompleteListFormatter; var currVal_139 = "Select"; var currVal_140 = _co.warning; var currVal_141 = _co.ccAdmin; _ck(_v, 143, 0, currVal_134, currVal_135, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140, currVal_141); var currVal_152 = "ccManager"; var currVal_153 = _co.ccManager; _ck(_v, 156, 0, currVal_152, currVal_153); var currVal_154 = _co.hrrObservableSource.bind(_co); var currVal_155 = "displayName"; var currVal_156 = false; var currVal_157 = "5"; var currVal_158 = _co.autoCompleteListFormatter; var currVal_159 = "Select"; var currVal_160 = _co.warning; var currVal_161 = _co.ccManager; _ck(_v, 159, 0, currVal_154, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159, currVal_160, currVal_161); var currVal_172 = "leaveAdministrator"; var currVal_173 = _co.leaveAdministrator; _ck(_v, 172, 0, currVal_172, currVal_173); var currVal_174 = _co.hrrObservableSource.bind(_co); var currVal_175 = "displayName"; var currVal_176 = false; var currVal_177 = "5"; var currVal_178 = _co.autoCompleteListFormatter; var currVal_179 = "Select"; var currVal_180 = _co.warning; var currVal_181 = _co.leaveAdministrator; _ck(_v, 175, 0, currVal_174, currVal_175, currVal_176, currVal_177, currVal_178, currVal_179, currVal_180, currVal_181); var currVal_192 = "orgCat"; var currVal_193 = _co.orgCat; _ck(_v, 188, 0, currVal_192, currVal_193); var currVal_194 = _co.orgCatObservableSource.bind(_co); var currVal_195 = "code"; var currVal_196 = false; var currVal_197 = "5"; var currVal_198 = _co.autoCompleteOrgCat; var currVal_199 = "Select"; var currVal_200 = _co.warning; var currVal_201 = _co.orgCat; _ck(_v, 191, 0, currVal_194, currVal_195, currVal_196, currVal_197, currVal_198, currVal_199, currVal_200, currVal_201); var currVal_211 = "parent"; var currVal_212 = _co.parent; _ck(_v, 204, 0, currVal_211, currVal_212); var currVal_213 = _co.organisationUnitObservable.bind(_co); var currVal_214 = "orgName"; var currVal_215 = false; var currVal_216 = "5"; var currVal_217 = _co.autoCompleteOrgName; var currVal_218 = "Select"; var currVal_219 = _co.warning; var currVal_220 = _co.parent; _ck(_v, 207, 0, currVal_213, currVal_214, currVal_215, currVal_216, currVal_217, currVal_218, currVal_219, currVal_220); var currVal_222 = (_co.type == "ADD"); _ck(_v, 215, 0, currVal_222); var currVal_223 = (_co.type == "EDIT"); _ck(_v, 217, 0, currVal_223); }, function (_ck, _v) { var currVal_2 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("code")); _ck(_v, 12, 0, currVal_2); var currVal_3 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 24).transform("orgCode")), ""); var currVal_4 = (core["ɵnov"](_v, 18).maxlength ? core["ɵnov"](_v, 18).maxlength : null); var currVal_5 = core["ɵnov"](_v, 23).ngClassUntouched; var currVal_6 = core["ɵnov"](_v, 23).ngClassTouched; var currVal_7 = core["ɵnov"](_v, 23).ngClassPristine; var currVal_8 = core["ɵnov"](_v, 23).ngClassDirty; var currVal_9 = core["ɵnov"](_v, 23).ngClassValid; var currVal_10 = core["ɵnov"](_v, 23).ngClassInvalid; var currVal_11 = core["ɵnov"](_v, 23).ngClassPending; _ck(_v, 16, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11); var currVal_14 = core["ɵunv"](_v, 28, 0, core["ɵnov"](_v, 29).transform("orgUnitType")); _ck(_v, 28, 0, currVal_14); var currVal_15 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 32, 0, core["ɵnov"](_v, 41).transform("typeChooseOrgUnitType")), ""); var currVal_16 = (core["ɵnov"](_v, 34).required ? "" : null); var currVal_17 = core["ɵnov"](_v, 39).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 39).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 39).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 39).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 39).ngClassValid; var currVal_22 = core["ɵnov"](_v, 39).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 39).ngClassPending; _ck(_v, 32, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); var currVal_35 = core["ɵunv"](_v, 45, 0, core["ɵnov"](_v, 46).transform("name")); _ck(_v, 45, 0, currVal_35); var currVal_36 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 49, 0, core["ɵnov"](_v, 57).transform("name")), ""); var currVal_37 = (core["ɵnov"](_v, 51).maxlength ? core["ɵnov"](_v, 51).maxlength : null); var currVal_38 = core["ɵnov"](_v, 56).ngClassUntouched; var currVal_39 = core["ɵnov"](_v, 56).ngClassTouched; var currVal_40 = core["ɵnov"](_v, 56).ngClassPristine; var currVal_41 = core["ɵnov"](_v, 56).ngClassDirty; var currVal_42 = core["ɵnov"](_v, 56).ngClassValid; var currVal_43 = core["ɵnov"](_v, 56).ngClassInvalid; var currVal_44 = core["ɵnov"](_v, 56).ngClassPending; _ck(_v, 49, 0, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); var currVal_47 = core["ɵunv"](_v, 61, 0, core["ɵnov"](_v, 62).transform("nameLocale")); _ck(_v, 61, 0, currVal_47); var currVal_48 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 63, 0, core["ɵnov"](_v, 71).transform("nameLocale")), ""); var currVal_49 = (core["ɵnov"](_v, 65).maxlength ? core["ɵnov"](_v, 65).maxlength : null); var currVal_50 = core["ɵnov"](_v, 70).ngClassUntouched; var currVal_51 = core["ɵnov"](_v, 70).ngClassTouched; var currVal_52 = core["ɵnov"](_v, 70).ngClassPristine; var currVal_53 = core["ɵnov"](_v, 70).ngClassDirty; var currVal_54 = core["ɵnov"](_v, 70).ngClassValid; var currVal_55 = core["ɵnov"](_v, 70).ngClassInvalid; var currVal_56 = core["ɵnov"](_v, 70).ngClassPending; _ck(_v, 63, 0, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56); var currVal_59 = core["ɵunv"](_v, 75, 0, core["ɵnov"](_v, 76).transform("description")); _ck(_v, 75, 0, currVal_59); var currVal_60 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 77, 0, core["ɵnov"](_v, 85).transform("description")), ""); var currVal_61 = (core["ɵnov"](_v, 79).maxlength ? core["ɵnov"](_v, 79).maxlength : null); var currVal_62 = core["ɵnov"](_v, 84).ngClassUntouched; var currVal_63 = core["ɵnov"](_v, 84).ngClassTouched; var currVal_64 = core["ɵnov"](_v, 84).ngClassPristine; var currVal_65 = core["ɵnov"](_v, 84).ngClassDirty; var currVal_66 = core["ɵnov"](_v, 84).ngClassValid; var currVal_67 = core["ɵnov"](_v, 84).ngClassInvalid; var currVal_68 = core["ɵnov"](_v, 84).ngClassPending; _ck(_v, 77, 0, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68); var currVal_71 = core["ɵunv"](_v, 89, 0, core["ɵnov"](_v, 90).transform("descriptionLocale")); _ck(_v, 89, 0, currVal_71); var currVal_72 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 91, 0, core["ɵnov"](_v, 99).transform("descriptionLocale")), ""); var currVal_73 = (core["ɵnov"](_v, 93).maxlength ? core["ɵnov"](_v, 93).maxlength : null); var currVal_74 = core["ɵnov"](_v, 98).ngClassUntouched; var currVal_75 = core["ɵnov"](_v, 98).ngClassTouched; var currVal_76 = core["ɵnov"](_v, 98).ngClassPristine; var currVal_77 = core["ɵnov"](_v, 98).ngClassDirty; var currVal_78 = core["ɵnov"](_v, 98).ngClassValid; var currVal_79 = core["ɵnov"](_v, 98).ngClassInvalid; var currVal_80 = core["ɵnov"](_v, 98).ngClassPending; _ck(_v, 91, 0, currVal_72, currVal_73, currVal_74, currVal_75, currVal_76, currVal_77, currVal_78, currVal_79, currVal_80); var currVal_83 = core["ɵunv"](_v, 103, 0, core["ɵnov"](_v, 104).transform("headOfUnit")); _ck(_v, 103, 0, currVal_83); var currVal_84 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 105, 0, core["ɵnov"](_v, 112).transform("typeChooseHOU")), ""); var currVal_85 = core["ɵnov"](_v, 110).ngClassUntouched; var currVal_86 = core["ɵnov"](_v, 110).ngClassTouched; var currVal_87 = core["ɵnov"](_v, 110).ngClassPristine; var currVal_88 = core["ɵnov"](_v, 110).ngClassDirty; var currVal_89 = core["ɵnov"](_v, 110).ngClassValid; var currVal_90 = core["ɵnov"](_v, 110).ngClassInvalid; var currVal_91 = core["ɵnov"](_v, 110).ngClassPending; _ck(_v, 105, 0, currVal_84, currVal_85, currVal_86, currVal_87, currVal_88, currVal_89, currVal_90, currVal_91); var currVal_102 = core["ɵunv"](_v, 114, 0, core["ɵnov"](_v, 115).transform("headOfUnit")); _ck(_v, 114, 0, currVal_102); var currVal_103 = core["ɵunv"](_v, 119, 0, core["ɵnov"](_v, 120).transform("hrSpoc")); _ck(_v, 119, 0, currVal_103); var currVal_104 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 121, 0, core["ɵnov"](_v, 128).transform("typeChooseCcAdmin")), ""); var currVal_105 = core["ɵnov"](_v, 126).ngClassUntouched; var currVal_106 = core["ɵnov"](_v, 126).ngClassTouched; var currVal_107 = core["ɵnov"](_v, 126).ngClassPristine; var currVal_108 = core["ɵnov"](_v, 126).ngClassDirty; var currVal_109 = core["ɵnov"](_v, 126).ngClassValid; var currVal_110 = core["ɵnov"](_v, 126).ngClassInvalid; var currVal_111 = core["ɵnov"](_v, 126).ngClassPending; _ck(_v, 121, 0, currVal_104, currVal_105, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111); var currVal_122 = core["ɵunv"](_v, 130, 0, core["ɵnov"](_v, 131).transform("hrSinglePointOfCont")); _ck(_v, 130, 0, currVal_122); var currVal_123 = core["ɵunv"](_v, 135, 0, core["ɵnov"](_v, 136).transform("ccAdmin")); _ck(_v, 135, 0, currVal_123); var currVal_124 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 137, 0, core["ɵnov"](_v, 144).transform("typeChooseCcAdmin")), ""); var currVal_125 = core["ɵnov"](_v, 142).ngClassUntouched; var currVal_126 = core["ɵnov"](_v, 142).ngClassTouched; var currVal_127 = core["ɵnov"](_v, 142).ngClassPristine; var currVal_128 = core["ɵnov"](_v, 142).ngClassDirty; var currVal_129 = core["ɵnov"](_v, 142).ngClassValid; var currVal_130 = core["ɵnov"](_v, 142).ngClassInvalid; var currVal_131 = core["ɵnov"](_v, 142).ngClassPending; _ck(_v, 137, 0, currVal_124, currVal_125, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131); var currVal_142 = core["ɵunv"](_v, 146, 0, core["ɵnov"](_v, 147).transform("ccAdmin")); _ck(_v, 146, 0, currVal_142); var currVal_143 = core["ɵunv"](_v, 151, 0, core["ɵnov"](_v, 152).transform("ccManager")); _ck(_v, 151, 0, currVal_143); var currVal_144 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 153, 0, core["ɵnov"](_v, 160).transform("typeChooseCcManager")), ""); var currVal_145 = core["ɵnov"](_v, 158).ngClassUntouched; var currVal_146 = core["ɵnov"](_v, 158).ngClassTouched; var currVal_147 = core["ɵnov"](_v, 158).ngClassPristine; var currVal_148 = core["ɵnov"](_v, 158).ngClassDirty; var currVal_149 = core["ɵnov"](_v, 158).ngClassValid; var currVal_150 = core["ɵnov"](_v, 158).ngClassInvalid; var currVal_151 = core["ɵnov"](_v, 158).ngClassPending; _ck(_v, 153, 0, currVal_144, currVal_145, currVal_146, currVal_147, currVal_148, currVal_149, currVal_150, currVal_151); var currVal_162 = core["ɵunv"](_v, 162, 0, core["ɵnov"](_v, 163).transform("ccManager")); _ck(_v, 162, 0, currVal_162); var currVal_163 = core["ɵunv"](_v, 167, 0, core["ɵnov"](_v, 168).transform("leaveAdministrator")); _ck(_v, 167, 0, currVal_163); var currVal_164 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 169, 0, core["ɵnov"](_v, 176).transform("typeChooseLeaveAdministrator")), ""); var currVal_165 = core["ɵnov"](_v, 174).ngClassUntouched; var currVal_166 = core["ɵnov"](_v, 174).ngClassTouched; var currVal_167 = core["ɵnov"](_v, 174).ngClassPristine; var currVal_168 = core["ɵnov"](_v, 174).ngClassDirty; var currVal_169 = core["ɵnov"](_v, 174).ngClassValid; var currVal_170 = core["ɵnov"](_v, 174).ngClassInvalid; var currVal_171 = core["ɵnov"](_v, 174).ngClassPending; _ck(_v, 169, 0, currVal_164, currVal_165, currVal_166, currVal_167, currVal_168, currVal_169, currVal_170, currVal_171); var currVal_182 = core["ɵunv"](_v, 178, 0, core["ɵnov"](_v, 179).transform("leaveAdministrator")); _ck(_v, 178, 0, currVal_182); var currVal_183 = core["ɵunv"](_v, 183, 0, core["ɵnov"](_v, 184).transform("orgCat")); _ck(_v, 183, 0, currVal_183); var currVal_184 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 185, 0, core["ɵnov"](_v, 192).transform("typeChooseOrgCat")), ""); var currVal_185 = core["ɵnov"](_v, 190).ngClassUntouched; var currVal_186 = core["ɵnov"](_v, 190).ngClassTouched; var currVal_187 = core["ɵnov"](_v, 190).ngClassPristine; var currVal_188 = core["ɵnov"](_v, 190).ngClassDirty; var currVal_189 = core["ɵnov"](_v, 190).ngClassValid; var currVal_190 = core["ɵnov"](_v, 190).ngClassInvalid; var currVal_191 = core["ɵnov"](_v, 190).ngClassPending; _ck(_v, 185, 0, currVal_184, currVal_185, currVal_186, currVal_187, currVal_188, currVal_189, currVal_190, currVal_191); var currVal_202 = core["ɵunv"](_v, 194, 0, core["ɵnov"](_v, 195).transform("orgCat")); _ck(_v, 194, 0, currVal_202); var currVal_203 = core["ɵunv"](_v, 199, 0, core["ɵnov"](_v, 200).transform("selectParent")); _ck(_v, 199, 0, currVal_203); var currVal_204 = core["ɵnov"](_v, 206).ngClassUntouched; var currVal_205 = core["ɵnov"](_v, 206).ngClassTouched; var currVal_206 = core["ɵnov"](_v, 206).ngClassPristine; var currVal_207 = core["ɵnov"](_v, 206).ngClassDirty; var currVal_208 = core["ɵnov"](_v, 206).ngClassValid; var currVal_209 = core["ɵnov"](_v, 206).ngClassInvalid; var currVal_210 = core["ɵnov"](_v, 206).ngClassPending; _ck(_v, 201, 0, currVal_204, currVal_205, currVal_206, currVal_207, currVal_208, currVal_209, currVal_210); var currVal_221 = core["ɵunv"](_v, 212, 0, core["ɵnov"](_v, 213).transform("close")); _ck(_v, 212, 0, currVal_221); });
}
function View_AddParentOrganizationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddParentOrganization", [], null, null, null, View_AddParentOrganizationComponent_0, RenderType_AddParentOrganizationComponent)), core["ɵdid"](1, 49152, null, 0, addParentOrganization_AddParentOrganizationComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, NgbActiveModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], fesm5_router["l" /* Router */], common["Location"], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var AddParentOrganizationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddParentOrganization", addParentOrganization_AddParentOrganizationComponent, View_AddParentOrganizationComponent_Host_0, {}, { cancelEvent: "cancelEvent", addOrgEvent: "addOrgEvent" }, []);



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/rolesAndPermission.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_rolesAndPermission,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */

















var styles_RolesAndPermissionComponent = [];
var RenderType_RolesAndPermissionComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_RolesAndPermissionComponent, data: {} });

function View_RolesAndPermissionComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.description; _ck(_v, 1, 0, currVal_0); }); }
function View_RolesAndPermissionComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_RolesAndPermissionComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeUserRoles(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-user-times mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("removeUsers")); _ck(_v, 2, 0, currVal_0); });
}
function View_RolesAndPermissionComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 14, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editRoles(_v.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addUserRoles(_v.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-users mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_7)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](13, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteUser(_v.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 0, "i", [["class", "fa fa-trash mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_2 = (_v.parent.context.$implicit.userCount > 0); _ck(_v, 12, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("edit")); _ck(_v, 5, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("addUsers")); _ck(_v, 9, 0, currVal_1); var currVal_3 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("delete")); _ck(_v, 15, 0, currVal_3); });
}
function View_RolesAndPermissionComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 4, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_4)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_5)), core["ɵdid"](8, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](9, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), (_l()(), core["ɵeld"](12, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.empTableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](14, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_6)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = (_v.context.$implicit.description != null); _ck(_v, 6, 0, currVal_1); var currVal_2 = (_v.context.$implicit.description == null); _ck(_v, 8, 0, currVal_2); var currVal_4 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("clickForMoreOption")), ""); _ck(_v, 14, 0, currVal_4); var currVal_5 = (_v.context.index == _co.trackHides); _ck(_v, 18, 0, currVal_5); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_0); var currVal_3 = _v.context.$implicit.userCount; _ck(_v, 11, 0, currVal_3); });
}
function View_RolesAndPermissionComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_3)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.completeRolesAndPermissionData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_RolesAndPermissionComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_RolesAndPermissionComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_RolesAndPermissionComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_9)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_10)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_RolesAndPermissionComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 61, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "w-100 float-left v-align relative b-b"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mb-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.createRoles() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](7, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 21, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](15, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](21, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](23, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](25, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_2)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_8)), core["ɵdid"](30, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](31, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](33, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](35, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](37, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](39, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 40).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 40).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](40, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](42, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](44, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](45, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](46, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](47, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](49, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](50, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](51, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](53, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](54, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](55, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](57, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](59, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](60, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](61, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_6 = (_co.completeRolesAndPermissionData.length != 0); _ck(_v, 28, 0, currVal_6); var currVal_7 = (_co.completeRolesAndPermissionData.length == 0); _ck(_v, 30, 0, currVal_7); var currVal_20 = _co.pageSize; _ck(_v, 42, 0, currVal_20); var currVal_21 = "10"; _ck(_v, 46, 0, currVal_21); var currVal_22 = "10"; _ck(_v, 47, 0, currVal_22); var currVal_23 = "20"; _ck(_v, 50, 0, currVal_23); var currVal_24 = "20"; _ck(_v, 51, 0, currVal_24); var currVal_25 = "30"; _ck(_v, 54, 0, currVal_25); var currVal_26 = "30"; _ck(_v, 55, 0, currVal_26); var currVal_27 = true; var currVal_28 = false; var currVal_29 = true; var currVal_30 = _co.collectionSize; var currVal_31 = 5; var currVal_32 = _co.page; var currVal_33 = _co.pageSize; _ck(_v, 59, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("rolesAndPermissions")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform("createRole")); _ck(_v, 7, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("role")); _ck(_v, 13, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("description")); _ck(_v, 17, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 22).transform("count")); _ck(_v, 21, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 25, 0, core["ɵnov"](_v, 26).transform("actions")); _ck(_v, 25, 0, currVal_5); var currVal_8 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_9 = ((_co.pageSize * (_co.page - 1)) + _co.rolePageData.numberOfElements); var currVal_10 = core["ɵunv"](_v, 33, 2, core["ɵnov"](_v, 34).transform("itemsOf")); var currVal_11 = _co.rolePageData.totalElements; _ck(_v, 33, 0, currVal_8, currVal_9, currVal_10, currVal_11); var currVal_12 = core["ɵunv"](_v, 37, 0, core["ɵnov"](_v, 38).transform("showItemsPerPage")); _ck(_v, 37, 0, currVal_12); var currVal_13 = core["ɵnov"](_v, 44).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 44).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 44).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 44).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 44).ngClassValid; var currVal_18 = core["ɵnov"](_v, 44).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 44).ngClassPending; _ck(_v, 39, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); });
}
function View_RolesAndPermissionComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_RolesAndPermissionComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.roles == 1); _ck(_v, 1, 0, currVal_0); }, null); }
function View_RolesAndPermissionComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "Roles-Permission", [], null, null, null, View_RolesAndPermissionComponent_0, RenderType_RolesAndPermissionComponent)), core["ɵdid"](1, 49152, null, 0, rolesAndPermission_RolesAndPermissionComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], common["Location"], SharedData, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"]], null, null)], null, null); }
var RolesAndPermissionComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("Roles-Permission", rolesAndPermission_RolesAndPermissionComponent, View_RolesAndPermissionComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/operations/manageOperation.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_manageOperation.component,_angular_router,_.._shared_permissions_permissions,_.._shared_services_configuration,_.._shared_services_http.client,_.._toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_sharedData PURE_IMPORTS_END */















var styles_ManageOperationComponent = [];
var RenderType_ManageOperationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ManageOperationComponent, data: {} });

function View_ManageOperationComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 0, "em", [["class", "fa fa-edit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.updateOperation(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.operation; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.name; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.externalURL; _ck(_v, 9, 0, currVal_2); });
}
function View_ManageOperationComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 56, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h5", [["class", "b-b pb-3 medium mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 3, "div", [["class", "w-100 float-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addOperation() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](8, 0, null, null, 48, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 19, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](15, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](21, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](23, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](25, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ManageOperationComponent_1)), core["ɵdid"](28, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 27, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 1, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](31, null, [" ", " - ", " ", " ", " "])), (_l()(), core["ɵeld"](32, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 37).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 37).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](37, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](39, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](41, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](42, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](43, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](44, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](46, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](47, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](48, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](50, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](51, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](52, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](54, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](55, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](56, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_6 = _co.operationList; _ck(_v, 28, 0, currVal_6); var currVal_19 = _co.pageSize; _ck(_v, 39, 0, currVal_19); var currVal_20 = "10"; _ck(_v, 43, 0, currVal_20); var currVal_21 = "10"; _ck(_v, 44, 0, currVal_21); var currVal_22 = "20"; _ck(_v, 47, 0, currVal_22); var currVal_23 = "20"; _ck(_v, 48, 0, currVal_23); var currVal_24 = "30"; _ck(_v, 51, 0, currVal_24); var currVal_25 = "30"; _ck(_v, 52, 0, currVal_25); var currVal_26 = true; var currVal_27 = false; var currVal_28 = true; var currVal_29 = _co.collectionSize; var currVal_30 = 5; var currVal_31 = _co.page; var currVal_32 = _co.pageSize; _ck(_v, 56, 0, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("manageOperations")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("addOperation")); _ck(_v, 6, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("operation")); _ck(_v, 13, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("name")); _ck(_v, 17, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 22).transform("externalURL")); _ck(_v, 21, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 25, 0, core["ɵnov"](_v, 26).transform("action")); _ck(_v, 25, 0, currVal_5); var currVal_7 = _co.startingPage; var currVal_8 = _co.endingPage; var currVal_9 = "itemsOf"; var currVal_10 = _co.collectionSize; _ck(_v, 31, 0, currVal_7, currVal_8, currVal_9, currVal_10); var currVal_11 = core["ɵunv"](_v, 34, 0, core["ɵnov"](_v, 35).transform("showItemsPerPage")); _ck(_v, 34, 0, currVal_11); var currVal_12 = core["ɵnov"](_v, 41).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 41).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 41).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 41).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 41).ngClassValid; var currVal_17 = core["ɵnov"](_v, 41).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 41).ngClassPending; _ck(_v, 36, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); });
}
function View_ManageOperationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "manage-operation", [], null, null, null, View_ManageOperationComponent_0, RenderType_ManageOperationComponent)), core["ɵdid"](1, 49152, null, 0, manageOperation_component_ManageOperationComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], NgbModal, SharedData], null, null)], null, null); }
var ManageOperationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("manage-operation", manageOperation_component_ManageOperationComponent, View_ManageOperationComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/cob/cob.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_cob.component,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_toasterComponent_toasterComponent,_shared_services_http.client,_shared_services_configuration,_shared_sharedData PURE_IMPORTS_END */
















var styles_CobComponent = [];
var RenderType_CobComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_CobComponent, data: {} });

function View_CobComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["class", "mb-0 ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.fileNameToUpload; _ck(_v, 1, 0, currVal_0); }); }
function View_CobComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "form-group w-100 float-left align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "comments"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 6, "textarea", [["class", "form-control w-25 ml-3"], ["id", "comments"], ["name", "cobComments"], ["rows", "2"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.comments = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](12, 0, null, null, 4, "div", [["class", "form-group w-100 float-left align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 0, "label", [["class", "medium col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "button", [["class", "btn btn-primary ml-3"], ["name", "cobUpload"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.processCob() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](15, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = "cobComments"; var currVal_10 = _co.comments; _ck(_v, 8, 0, currVal_9, currVal_10); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("comments")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 11).transform("enterComments")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_11 = _co.uploadButtonDisable; _ck(_v, 14, 0, currVal_11); var currVal_12 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("upload")); _ck(_v, 15, 0, currVal_12); });
}
function View_CobComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 4, "a", [["class", "mb-0 small"], ["href", "#/menu/cob"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadValidationFile(_v.parent.context.$implicit.attachedFiles[0].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](3, null, ["", ".", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("clickToDownload")), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.parent.context.$implicit.attachedFiles[0].fileType)); var currVal_2 = _co.getExtension(_v.parent.context.$implicit.attachedFiles[0].name); _ck(_v, 3, 0, currVal_1, currVal_2); });
}
function View_CobComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 4, "a", [["class", "mb-0 small"], ["href", "#/menu/cob"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadValidationFile(_v.parent.context.$implicit.attachedFiles[1].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](3, null, ["", ".", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("clickToDownload")), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.parent.context.$implicit.attachedFiles[1].fileType)); var currVal_2 = _co.getExtension(_v.parent.context.$implicit.attachedFiles[1].name); _ck(_v, 3, 0, currVal_1, currVal_2); });
}
function View_CobComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.uploadConfirm(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 0, "i", [["class", "fa fa-upload  mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancelProcess(_v.parent.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa fa-times mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("confirmUpload")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("cancelProcess")); _ck(_v, 8, 0, currVal_1); });
}
function View_CobComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("noActions")); _ck(_v, 3, 0, currVal_0); }); }
function View_CobComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CobComponent_7)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CobComponent_8)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = (_v.parent.context.$implicit.state == "VALIDATED"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_v.parent.context.$implicit.state != "VALIDATED"); _ck(_v, 5, 0, currVal_1); }, null); }
function View_CobComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 26, "div", [["class", "w-100 p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), (_l()(), core["ɵeld"](7, 0, null, null, 3, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, ["", ""])), (_l()(), core["ɵeld"](14, 0, null, null, 5, "div", [["class", "col-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CobComponent_4)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](17, 0, null, null, 0, "br", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CobComponent_5)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 6, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.conTanActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CobComponent_6)), core["ɵdid"](26, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_4 = (_v.context.$implicit.attachedFiles.length > 0); _ck(_v, 16, 0, currVal_4); var currVal_5 = (_v.context.$implicit.attachedFiles.length > 1); _ck(_v, 19, 0, currVal_5); var currVal_6 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("clickForMoreOption")), ""); _ck(_v, 22, 0, currVal_6); var currVal_7 = (_v.context.index == _co.trackHides); _ck(_v, 26, 0, currVal_7); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit.comment; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.getDateFormat(_v.context.$implicit.startDate); _ck(_v, 6, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform(_v.context.$implicit.state)); _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.failureReason; _ck(_v, 13, 0, currVal_3); });
}
function View_CobComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 3, "button", [["class", "btn btn-secondary"], ["name", "cobBack"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 34, "div", [["class", "w-100 float-left mb-4 b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 20, "div", [["class", "row container"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 19, "div", [["class", "col-lg-8 col-md-8"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 18, "div", [["class", "form-group align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "label", [["class", "medium nowrap mr-3"], ["for", "excelTypeSelect"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](17, 0, null, null, 10, "select", [["class", "form-control"], ["id", "excelTypeSelect"], ["name", "cobExcelTypeSelect"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onFileTypeChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 4, "option", [], null, null, null, null, null)), core["ɵdid"](19, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](20, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](21, null, [".", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](23, 0, null, null, 4, "option", [], null, null, null, null, null)), core["ɵdid"](24, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](25, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](26, null, [".", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](28, 0, null, null, 3, "a", [["class", "btn ml-3"], ["href", "javascript:void(0)"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadTemplate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](29, null, ["", " ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](32, 0, null, null, 10, "div", [["class", "form-group align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "excelTypeSelect"]], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 4, "div", [["class", "relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 0, "input", [["accept", ".xlsx,.xls,.XLSX,.XLS"], ["class", "fileInput"], ["name", "cobFileBrowse"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.chooseFile($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 2, "button", [["class", "btn btn-primary ml-3"], ["name", "cobFileBrowseBtn"]], null, null, null, null, null)), (_l()(), core["ɵted"](39, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CobComponent_1)), core["ɵdid"](42, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CobComponent_2)), core["ɵdid"](44, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](45, 0, null, null, 66, "div", [["class", "w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 5, "div", [["class", "w-100 float-left align-v-center mb-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](47, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](48, 0, null, null, 3, "button", [["class", "btn btn-primary float-right"], ["name", "cobRefreshGrid"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.getAll() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](49, 0, null, null, 0, "i", [["class", "fa fa-refresh mr-2 text-white"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](52, 0, null, null, 28, "div", [["class", "col-lg-12 col-md-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](53, 0, null, null, 24, "div", [["class", "light-bg w-100 p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 3, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](55, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](56, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](58, 0, null, null, 3, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](60, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](62, 0, null, null, 3, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](64, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](66, 0, null, null, 3, "div", [["class", "col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](67, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](68, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](70, 0, null, null, 3, "div", [["class", "col-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](72, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](74, 0, null, null, 3, "div", [["class", "col-1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](75, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](76, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](78, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CobComponent_3)), core["ɵdid"](80, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](81, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](82, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](83, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](85, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](86, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](87, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](89, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "cobItemsPerPage"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 90).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 90).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](90, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](92, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](94, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](95, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](96, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](97, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](99, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](100, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](101, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](103, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](104, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](105, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](107, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](108, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](109, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](110, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](111, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_9 = (_co.fileNameToUpload != null); _ck(_v, 42, 0, currVal_9); var currVal_10 = (_co.fileNameToUpload != null); _ck(_v, 44, 0, currVal_10); var currVal_19 = _co.allData; _ck(_v, 80, 0, currVal_19); var currVal_32 = "cobItemsPerPage"; var currVal_33 = _co.pageSize; _ck(_v, 92, 0, currVal_32, currVal_33); var currVal_34 = "10"; _ck(_v, 96, 0, currVal_34); var currVal_35 = "10"; _ck(_v, 97, 0, currVal_35); var currVal_36 = "20"; _ck(_v, 100, 0, currVal_36); var currVal_37 = "20"; _ck(_v, 101, 0, currVal_37); var currVal_38 = "30"; _ck(_v, 104, 0, currVal_38); var currVal_39 = "30"; _ck(_v, 105, 0, currVal_39); var currVal_40 = true; var currVal_41 = false; var currVal_42 = true; var currVal_43 = _co.collectionSize; var currVal_44 = 5; var currVal_45 = _co.page; var currVal_46 = _co.pageSize; _ck(_v, 109, 0, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("customerOnBoarding")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("back")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("chooseTemplate")); _ck(_v, 15, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 22).transform("xlsx")); _ck(_v, 21, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("xls")); _ck(_v, 26, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 29, 0, core["ɵnov"](_v, 30).transform("download")); var currVal_6 = core["ɵunv"](_v, 29, 1, core["ɵnov"](_v, 31).transform("template")); _ck(_v, 29, 0, currVal_5, currVal_6); var currVal_7 = core["ɵunv"](_v, 34, 0, core["ɵnov"](_v, 35).transform("selectFileUpload")); _ck(_v, 34, 0, currVal_7); var currVal_8 = core["ɵunv"](_v, 39, 0, core["ɵnov"](_v, 40).transform("browse")); _ck(_v, 39, 0, currVal_8); var currVal_11 = _co.uploadButtonDisable; _ck(_v, 48, 0, currVal_11); var currVal_12 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("refreshGrid")); _ck(_v, 50, 0, currVal_12); var currVal_13 = core["ɵunv"](_v, 56, 0, core["ɵnov"](_v, 57).transform("comments")); _ck(_v, 56, 0, currVal_13); var currVal_14 = core["ɵunv"](_v, 60, 0, core["ɵnov"](_v, 61).transform("startDate")); _ck(_v, 60, 0, currVal_14); var currVal_15 = core["ɵunv"](_v, 64, 0, core["ɵnov"](_v, 65).transform("status")); _ck(_v, 64, 0, currVal_15); var currVal_16 = core["ɵunv"](_v, 68, 0, core["ɵnov"](_v, 69).transform("failureReason")); _ck(_v, 68, 0, currVal_16); var currVal_17 = core["ɵunv"](_v, 72, 0, core["ɵnov"](_v, 73).transform("attachFiles")); _ck(_v, 72, 0, currVal_17); var currVal_18 = core["ɵunv"](_v, 76, 0, core["ɵnov"](_v, 77).transform("action")); _ck(_v, 76, 0, currVal_18); var currVal_20 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_21 = ((_co.pageSize * (_co.page - 1)) + _co.allPageData.numberOfElements); var currVal_22 = core["ɵunv"](_v, 83, 2, core["ɵnov"](_v, 84).transform("itemsOf")); var currVal_23 = _co.allPageData.totalElements; _ck(_v, 83, 0, currVal_20, currVal_21, currVal_22, currVal_23); var currVal_24 = core["ɵunv"](_v, 87, 0, core["ɵnov"](_v, 88).transform("showItemsPerPage")); _ck(_v, 87, 0, currVal_24); var currVal_25 = core["ɵnov"](_v, 94).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 94).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 94).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 94).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 94).ngClassValid; var currVal_30 = core["ɵnov"](_v, 94).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 94).ngClassPending; _ck(_v, 89, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); });
}
function View_CobComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "cob", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_CobComponent_0, RenderType_CobComponent)), core["ɵdid"](1, 49152, null, 0, cob_component_CobComponent, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, common["Location"], ToasterComponent, core["ViewContainerRef"], http_client_HttpClientCustom, core["ElementRef"], Configuration, core_es5["j" /* TranslateService */], SharedData], null, null)], null, null);
}
var CobComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("cob", cob_component_CobComponent, View_CobComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bulkResign/bulkResign.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_bulkResign.component,_angular_router,_shared_sharedData,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_toasterComponent_toasterComponent,_shared_services_http.client,_shared_services_configuration PURE_IMPORTS_END */

















var styles_BulkResignComponent = [];
var RenderType_BulkResignComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_BulkResignComponent, data: {} });

function View_BulkResignComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["class", "mb-0 ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.fileNameToUpload; _ck(_v, 1, 0, currVal_0); }); }
function View_BulkResignComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "exampleSelect1"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 6, "textarea", [["class", "form-control w-25 ml-3"], ["name", "bulkUploadComments"], ["rows", "2"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.comments = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](12, 0, null, null, 4, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 0, "label", [["class", "medium col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "button", [["class", "btn btn-primary ml-3"], ["name", "uploadFiles"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.uploadFile() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](15, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = "bulkUploadComments"; var currVal_10 = _co.comments; _ck(_v, 8, 0, currVal_9, currVal_10); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("comments")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 11).transform("enterComments")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_11 = _co.uploadButtonDisable; _ck(_v, 14, 0, currVal_11); var currVal_12 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("upload")); _ck(_v, 15, 0, currVal_12); });
}
function View_BulkResignComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "h6", [["class", "mb-0 text-truncate"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.parent.context.$implicit.referenceName, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.parent.context.$implicit.referenceName; _ck(_v, 2, 0, currVal_1); }); }
function View_BulkResignComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "h6", [["class", "mb-0 text-truncate"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.parent.context.$implicit.referenceName, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.parent.context.$implicit.referenceName; _ck(_v, 2, 0, currVal_1); }); }
function View_BulkResignComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkResignComponent_5)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkResignComponent_6)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = (_v.parent.context.$implicit.referenceName.length < 15); _ck(_v, 2, 0, currVal_0); var currVal_1 = (_v.parent.context.$implicit.referenceName.length >= 15); _ck(_v, 4, 0, currVal_1); }, null); }
function View_BulkResignComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 4, "a", [["class", "mb-0 small"], ["href", "#/menu/bulkupload"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadValidationFile(_v.parent.context.$implicit.attachedFiles[0].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](3, null, ["", ".", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("clickToDownload")), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.parent.context.$implicit.attachedFiles[0].fileType)); var currVal_2 = _co.getExtension(_v.parent.context.$implicit.attachedFiles[0].name); _ck(_v, 3, 0, currVal_1, currVal_2); });
}
function View_BulkResignComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 4, "a", [["class", "mb-0 small"], ["href", "#/menu/bulkupload"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadValidationFile(_v.parent.context.$implicit.attachedFiles[1].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](3, null, ["", ".", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("clickToDownload")), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.parent.context.$implicit.attachedFiles[1].fileType)); var currVal_2 = _co.getExtension(_v.parent.context.$implicit.attachedFiles[1].name); _ck(_v, 3, 0, currVal_1, currVal_2); });
}
function View_BulkResignComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 28, "div", [["class", "w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 4, "h6", [["class", "mb-0 text-truncate"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](5, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkResignComponent_4)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, ["", ""])), (_l()(), core["ɵeld"](15, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 2, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](21, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](23, 0, null, null, 5, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkResignComponent_7)), core["ɵdid"](25, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](26, 0, null, null, 0, "br", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkResignComponent_8)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.context.$implicit.uploadProcessType)), ""); _ck(_v, 3, 0, currVal_0); var currVal_3 = (_v.context.$implicit.referenceName != null); _ck(_v, 11, 0, currVal_3); var currVal_7 = (_v.context.$implicit.attachedFiles.length > 0); _ck(_v, 25, 0, currVal_7); var currVal_8 = (_v.context.$implicit.attachedFiles.length > 1); _ck(_v, 28, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform(_v.context.$implicit.uploadProcessType)); _ck(_v, 5, 0, currVal_1); var currVal_2 = _v.context.$implicit.comment; _ck(_v, 9, 0, currVal_2); var currVal_4 = _co.getDateFormat(_v.context.$implicit.startDate); _ck(_v, 14, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform(_v.context.$implicit.state)); _ck(_v, 17, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 22).transform(_v.context.$implicit.failureReason)); _ck(_v, 21, 0, currVal_6); }); }
function View_BulkResignComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 32, "div", [["class", "w-100 float-left mb-4 b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 18, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "excelTypeSelect"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 10, "select", [["class", "form-control w-25 float-left ml-3"], ["id", "excelTypeSelect"], ["name", "fileType"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onFileTypeChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 4, "option", [], null, null, null, null, null)), core["ɵdid"](13, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](14, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](15, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](17, 0, null, null, 4, "option", [], null, null, null, null, null)), core["ɵdid"](18, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](19, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](20, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](22, 0, null, null, 3, "a", [["class", "btn float-left ml-3"], ["href", "javascript:void(0)"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadTemplate() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](23, null, [" ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](26, 0, null, null, 10, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "excelTypeSelect"]], null, null, null, null, null)), (_l()(), core["ɵted"](28, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 4, "div", [["class", "relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 0, "input", [["accept", ".xlsx,.xls,.XLSX,.XLS"], ["class", "fileInput"], ["name", "browseFile"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.chooseFile($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 2, "button", [["class", "btn btn-primary ml-3"], ["name", "browseFileBtn"]], null, null, null, null, null)), (_l()(), core["ɵted"](33, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkResignComponent_1)), core["ɵdid"](36, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkResignComponent_2)), core["ɵdid"](38, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](39, 0, null, null, 63, "div", [["class", "w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 4, "div", [["class", "w-100 float-left align-v-center mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 2, "h6", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](42, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](44, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 28, "div", [["class", "col-lg-12 col-md-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 24, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](47, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](48, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](49, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](51, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](52, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](53, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](55, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](56, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](57, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](59, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](60, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](61, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](63, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](64, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](65, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](67, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](68, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](69, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](71, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkResignComponent_3)), core["ɵdid"](73, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](74, 0, null, null, 28, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](75, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](76, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](78, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](79, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](80, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](82, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "UploadedItemsPerPage"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 83).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 83).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](83, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](85, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](87, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](88, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](89, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](90, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](92, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](93, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](94, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](96, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](97, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](98, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](100, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](101, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](102, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_8 = (_co.fileNameToUpload != null); _ck(_v, 36, 0, currVal_8); var currVal_9 = (_co.fileNameToUpload != null); _ck(_v, 38, 0, currVal_9); var currVal_17 = _co.allData; _ck(_v, 73, 0, currVal_17); var currVal_30 = "UploadedItemsPerPage"; var currVal_31 = _co.pageSize; _ck(_v, 85, 0, currVal_30, currVal_31); var currVal_32 = "10"; _ck(_v, 89, 0, currVal_32); var currVal_33 = "10"; _ck(_v, 90, 0, currVal_33); var currVal_34 = "20"; _ck(_v, 93, 0, currVal_34); var currVal_35 = "20"; _ck(_v, 94, 0, currVal_35); var currVal_36 = "30"; _ck(_v, 97, 0, currVal_36); var currVal_37 = "30"; _ck(_v, 98, 0, currVal_37); var currVal_38 = true; var currVal_39 = false; var currVal_40 = true; var currVal_41 = _co.collectionSize; var currVal_42 = 5; var currVal_43 = _co.page; var currVal_44 = _co.pageSize; _ck(_v, 102, 0, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("bulkResign")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("excelFileType")); _ck(_v, 9, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("xlsx")); _ck(_v, 15, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("xls")); _ck(_v, 20, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 23, 0, core["ɵnov"](_v, 24).transform("download")); var currVal_5 = core["ɵunv"](_v, 23, 1, core["ɵnov"](_v, 25).transform("template")); _ck(_v, 23, 0, currVal_4, currVal_5); var currVal_6 = core["ɵunv"](_v, 28, 0, core["ɵnov"](_v, 29).transform("selectFile")); _ck(_v, 28, 0, currVal_6); var currVal_7 = core["ɵunv"](_v, 33, 0, core["ɵnov"](_v, 34).transform("browse")); _ck(_v, 33, 0, currVal_7); var currVal_10 = core["ɵunv"](_v, 42, 0, core["ɵnov"](_v, 43).transform("processGrid")); _ck(_v, 42, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 49, 0, core["ɵnov"](_v, 50).transform("uploadProcess")); _ck(_v, 49, 0, currVal_11); var currVal_12 = core["ɵunv"](_v, 53, 0, core["ɵnov"](_v, 54).transform("title")); _ck(_v, 53, 0, currVal_12); var currVal_13 = core["ɵunv"](_v, 57, 0, core["ɵnov"](_v, 58).transform("startDate")); _ck(_v, 57, 0, currVal_13); var currVal_14 = core["ɵunv"](_v, 61, 0, core["ɵnov"](_v, 62).transform("status")); _ck(_v, 61, 0, currVal_14); var currVal_15 = core["ɵunv"](_v, 65, 0, core["ɵnov"](_v, 66).transform("failureReason")); _ck(_v, 65, 0, currVal_15); var currVal_16 = core["ɵunv"](_v, 69, 0, core["ɵnov"](_v, 70).transform("attachFiles")); _ck(_v, 69, 0, currVal_16); var currVal_18 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_19 = ((_co.pageSize * (_co.page - 1)) + _co.allPageData.numberOfElements); var currVal_20 = core["ɵunv"](_v, 76, 2, core["ɵnov"](_v, 77).transform("itemsOf")); var currVal_21 = _co.allPageData.totalElements; _ck(_v, 76, 0, currVal_18, currVal_19, currVal_20, currVal_21); var currVal_22 = core["ɵunv"](_v, 80, 0, core["ɵnov"](_v, 81).transform("showItemsPerPage")); _ck(_v, 80, 0, currVal_22); var currVal_23 = core["ɵnov"](_v, 87).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 87).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 87).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 87).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 87).ngClassValid; var currVal_28 = core["ɵnov"](_v, 87).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 87).ngClassPending; _ck(_v, 82, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); });
}
function View_BulkResignComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "bulkResign", [], null, null, null, View_BulkResignComponent_0, RenderType_BulkResignComponent)), core["ɵdid"](1, 49152, null, 0, bulkResign_component_BulkResignComponent, [fesm5_router["a" /* ActivatedRoute */], SharedData, NgbModal, NgbActiveModal, common["Location"], ToasterComponent, core["ViewContainerRef"], http_client_HttpClientCustom, Configuration, core_es5["j" /* TranslateService */], SharedData], null, null)], null, null); }
var BulkResignComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("bulkResign", bulkResign_component_BulkResignComponent, View_BulkResignComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/operationComponent.ts


var operationComponent_OperationComponent = /*@__PURE__*/ (function () {
    function OperationComponent(_global, http, router, _toaster, modalService, activeModal, share, translate, vcr) {
        this._global = _global;
        this.http = http;
        this.router = router;
        this._toaster = _toaster;
        this.modalService = modalService;
        this.activeModal = activeModal;
        this.share = share;
        this.translate = translate;
        this.showChild = false;
        this.hasChild = true;
        this.asl = false;
        this.pushEvent = { isSelected: null, selectedOperation: null };
        this.deleteOrgEvent = new core["EventEmitter"]();
        this.selected = new core["EventEmitter"]();
        this._baseUrl = _global.get("EPMS_BASE_URL");
    }
    OperationComponent.prototype.hasChilds = function () {
        return this.operation.childOperations != null && this.operation.childOperations.length > 0;
    };
    OperationComponent.prototype.toggleChild = function () {
        var self = this;
        if (self.operation.childOperations) {
            self.showChild = !self.showChild;
        }
    };
    OperationComponent.prototype.checkIfAllSelected = function (i, e) {
        var that = this;
        that.selected.emit(i);
        if (i.childOperations.length > 0) {
            underscore["each"](i.childOperations, function (key, val) {
                key.assigned = e;
                that.selected.emit(key);
            });
        }
        else {
            that.selected.emit(i);
        }
    };
    OperationComponent.prototype.select = function (i) {
        this.selected.emit(i);
    };
    return OperationComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/childOperations.ts

var childOperations_ChildOperationComponent = /*@__PURE__*/ (function () {
    function ChildOperationComponent(_global, http, router, _toaster, share, modalService, vcr) {
        this._global = _global;
        this.http = http;
        this.router = router;
        this._toaster = _toaster;
        this.share = share;
        this.modalService = modalService;
        this.showChild = false;
        this.childOperation = [];
        this.selected = new core["EventEmitter"]();
        this._baseUrl = _global.get("EPMS_BASE_URL");
    }
    ChildOperationComponent.prototype.select = function (e, i) {
        this.selected.emit(e);
    };
    return ChildOperationComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/childOperations.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_operationComponent.ngfactory,_operationComponent,_.._shared_services_configuration,_.._shared_services_http.client,_angular_router,_.._toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_sharedData,_ngx_translate_core,_angular_common,_childOperations PURE_IMPORTS_END */













var styles_ChildOperationComponent = [];
var RenderType_ChildOperationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ChildOperationComponent, data: {} });

function View_ChildOperationComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left pl-5"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "operation", [], null, [[null, "selected"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("selected" === en)) {
                var pd_0 = (_co.select($event, _v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_OperationComponent_0, RenderType_OperationComponent)), core["ɵdid"](2, 49152, null, 0, operationComponent_OperationComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, NgbModal, NgbActiveModal, SharedData, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], { operation: [0, "operation"], i: [1, "i"] }, { selected: "selected" })], function (_ck, _v) { var currVal_0 = _v.context.$implicit; var currVal_1 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.operation, ""); _ck(_v, 2, 0, currVal_0, currVal_1); }, null);
}
function View_ChildOperationComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_ChildOperationComponent_1)), core["ɵdid"](1, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.childOperation; _ck(_v, 1, 0, currVal_0); }, null); }
function View_ChildOperationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "child-operations", [], null, null, null, View_ChildOperationComponent_0, RenderType_ChildOperationComponent)), core["ɵdid"](1, 49152, null, 0, childOperations_ChildOperationComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, SharedData, NgbModal, core["ViewContainerRef"]], null, null)], null, null); }
var ChildOperationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("child-operations", childOperations_ChildOperationComponent, View_ChildOperationComponent_Host_0, { childOperation: "childOperation" }, { selected: "selected" }, []);



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/operationComponent.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_childOperations.ngfactory,_childOperations,_.._shared_services_configuration,_.._shared_services_http.client,_angular_router,_.._toasterComponent_toasterComponent,_.._shared_sharedData,_ng_bootstrap_ng_bootstrap_modal_modal,_angular_forms,_ngx_translate_core,_operationComponent,_ng_bootstrap_ng_bootstrap_modal_modal_ref PURE_IMPORTS_END */














var styles_OperationComponent = [];
var RenderType_OperationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_OperationComponent, data: {} });

function View_OperationComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "i", [["class", "fa float-left mr-3 text-20x"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleChild() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "fa float-left mr-3 text-20x"; var currVal_1 = (_co.showChild ? "fa-caret-down" : "fa-caret-right"); _ck(_v, 1, 0, currVal_0, currVal_1); }, null);
}
function View_OperationComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "child-operations", [], null, [[null, "selected"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("selected" === en)) {
                var pd_0 = (_co.select($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ChildOperationComponent_0, RenderType_ChildOperationComponent)), core["ɵdid"](1, 49152, null, 0, childOperations_ChildOperationComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, SharedData, NgbModal, core["ViewContainerRef"]], { childOperation: [0, "childOperation"] }, { selected: "selected" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.operation.childOperations; _ck(_v, 1, 0, currVal_0); }, null);
}
function View_OperationComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 22, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 21, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 20, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 17, "div", [["class", "w-100 float-left mb-3 hidden-actions"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OperationComponent_1)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 8, "div", [["class", "float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 5, "input", [["type", "checkbox"]], [[8, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "change"], [null, "ngModelChange"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 10).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 10).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("change" === en)) {
                var pd_2 = (_co.checkIfAllSelected(_co.operation, $event.target.checked) !== false);
                ad = (pd_2 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_3 = ((_co.operation.assigned = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](10, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](12, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](14, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](15, 0, null, null, 0, "label", [["class", "mb-0"]], [[8, "htmlFor", 0]], null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 4, "div", [["class", "float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 0, "label", [["class", "mb-md-0 float-left mr-2 mt-1"], ["for", "user1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 2, "p", [["class", "float-left text-14x m-0 "]], null, null, null, null, null)), (_l()(), core["ɵted"](19, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OperationComponent_2)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.hasChilds(); _ck(_v, 6, 0, currVal_0); var currVal_9 = _co.operation.assigned; _ck(_v, 12, 0, currVal_9); var currVal_12 = (_co.operation.childOperations && _co.showChild); _ck(_v, 22, 0, currVal_12); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.i; var currVal_2 = core["ɵnov"](_v, 14).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 14).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 14).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 14).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 14).ngClassValid; var currVal_7 = core["ɵnov"](_v, 14).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 14).ngClassPending; _ck(_v, 9, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_10 = _co.i; _ck(_v, 15, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 19, 0, core["ɵnov"](_v, 20).transform(_co.operation.operation)); _ck(_v, 19, 0, currVal_11); });
}
function View_OperationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "operation", [], null, null, null, View_OperationComponent_0, RenderType_OperationComponent)), core["ɵdid"](1, 49152, null, 0, operationComponent_OperationComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, NgbModal, NgbActiveModal, SharedData, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var OperationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("operation", operationComponent_OperationComponent, View_OperationComponent_Host_0, { operation: "operation", i: "i" }, { deleteOrgEvent: "deleteOrgEvent", selected: "selected" }, []);



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/createRolesAndPermission.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_operationComponent.ngfactory,_operationComponent,_.._shared_services_configuration,_.._shared_services_http.client,_angular_router,_.._toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_sharedData,_angular_common,_angular_forms,_createRolesAndPermission,_.._shared_services_auth PURE_IMPORTS_END */















var styles_CreateRolesAndPermissionComponent = [];
var RenderType_CreateRolesAndPermissionComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_CreateRolesAndPermissionComponent, data: {} });

function View_CreateRolesAndPermissionComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("createRoles")); _ck(_v, 1, 0, currVal_0); }); }
function View_CreateRolesAndPermissionComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("editRoles")); _ck(_v, 1, 0, currVal_0); }); }
function View_CreateRolesAndPermissionComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "operation", [], null, [[null, "selected"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("selected" === en)) {
                var pd_0 = (_co.selected($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_OperationComponent_0, RenderType_OperationComponent)), core["ɵdid"](2, 49152, null, 0, operationComponent_OperationComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, NgbModal, NgbActiveModal, SharedData, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], { operation: [0, "operation"], i: [1, "i"] }, { selected: "selected" })], function (_ck, _v) { var currVal_0 = _v.context.$implicit; var currVal_1 = _v.context.$implicit.operation; _ck(_v, 2, 0, currVal_0, currVal_1); }, null);
}
function View_CreateRolesAndPermissionComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"], ["name", "createInR&P"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editOrSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.buttonDisabled; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("create")); _ck(_v, 1, 0, currVal_1); });
}
function View_CreateRolesAndPermissionComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"], ["name", "updateInR&P"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editOrSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.buttonDisabled; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("Update")); _ck(_v, 1, 0, currVal_1); });
}
function View_CreateRolesAndPermissionComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 80, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateRolesAndPermissionComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateRolesAndPermissionComponent_3)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 3, "button", [["class", "btn btn-secondary float-right mb-2"], ["name", "backToR&P"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 55, "div", [["class", "w-50 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 54, "form", [["action", ""], ["novalidate", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "submit"], [null, "reset"]], function (_v, en, $event) {
            var ad = true;
            if (("submit" === en)) {
                var pd_0 = (core["ɵnov"](_v, 14).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("reset" === en)) {
                var pd_1 = (core["ɵnov"](_v, 14).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](13, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bg"], [], null, null), core["ɵdid"](14, 4210688, null, 0, fesm5_forms["NgForm"], [[8, null], [8, null]], null, null), core["ɵprd"](2048, null, fesm5_forms["ControlContainer"], null, [fesm5_forms["NgForm"]]), core["ɵdid"](16, 16384, null, 0, fesm5_forms["NgControlStatusGroup"], [[4, fesm5_forms["ControlContainer"]]], null, null), (_l()(), core["ɵeld"](17, 0, null, null, 16, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](19, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](21, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](23, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "100"], ["name", "nameInR&P"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 24)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 24).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 24)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 24)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.roleData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](24, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](25, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](28, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](30, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](31, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](32, null, [" ", ". 100 "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](34, 0, null, null, 16, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](40, 0, null, null, 7, "input", [["class", "form-control"], ["maxlength", "100"], ["name", "codeInR&P"], ["type", "text"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.roleData.code = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](42, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](45, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](47, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](48, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](49, null, [" ", ". 100 "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](51, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](52, 0, null, null, 3, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](53, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](55, 0, null, null, 0, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵeld"](56, 0, null, null, 7, "textarea", [["class", "form-control"], ["maxlength", "100"], ["name", "descriptionInR&P"], ["rows", "5"]], [[1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 57)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 57).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 57)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 57)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.roleData.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](57, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](58, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](61, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](63, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](64, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](65, null, [" ", ". 100 "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](67, 0, null, null, 3, "div", [["class", "w-100 float-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](68, 0, null, null, 2, "h5", [["class", "medium float-left w-100 mb-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](69, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](71, 0, null, null, 2, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateRolesAndPermissionComponent_4)), core["ɵdid"](73, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateRolesAndPermissionComponent_5)), core["ɵdid"](75, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateRolesAndPermissionComponent_6)), core["ɵdid"](77, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](78, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mr-4"], ["name", "cancelInR&P"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](79, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "CREATE"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "EDIT"); _ck(_v, 5, 0, currVal_1); var currVal_19 = "100"; _ck(_v, 25, 0, currVal_19); var currVal_20 = "nameInR&P"; var currVal_21 = _co.roleData.name; _ck(_v, 28, 0, currVal_20, currVal_21); var currVal_32 = "100"; _ck(_v, 42, 0, currVal_32); var currVal_33 = "codeInR&P"; var currVal_34 = _co.roleData.code; _ck(_v, 45, 0, currVal_33, currVal_34); var currVal_45 = "100"; _ck(_v, 58, 0, currVal_45); var currVal_46 = "descriptionInR&P"; var currVal_47 = _co.roleData.description; _ck(_v, 61, 0, currVal_46, currVal_47); var currVal_50 = _co.roleData.operations; _ck(_v, 73, 0, currVal_50); var currVal_51 = (_co.type == "CREATE"); _ck(_v, 75, 0, currVal_51); var currVal_52 = (_co.type == "EDIT"); _ck(_v, 77, 0, currVal_52); }, function (_ck, _v) { var currVal_2 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("back")); _ck(_v, 9, 0, currVal_2); var currVal_3 = core["ɵnov"](_v, 16).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 16).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 16).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 16).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 16).ngClassValid; var currVal_8 = core["ɵnov"](_v, 16).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 16).ngClassPending; _ck(_v, 12, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_10 = core["ɵunv"](_v, 19, 0, core["ɵnov"](_v, 20).transform("name")); _ck(_v, 19, 0, currVal_10); var currVal_11 = (core["ɵnov"](_v, 25).maxlength ? core["ɵnov"](_v, 25).maxlength : null); var currVal_12 = core["ɵnov"](_v, 30).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 30).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 30).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 30).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 30).ngClassValid; var currVal_17 = core["ɵnov"](_v, 30).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 30).ngClassPending; _ck(_v, 23, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); var currVal_22 = core["ɵunv"](_v, 32, 0, core["ɵnov"](_v, 33).transform("Max")); _ck(_v, 32, 0, currVal_22); var currVal_23 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("code")); _ck(_v, 36, 0, currVal_23); var currVal_24 = (core["ɵnov"](_v, 42).maxlength ? core["ɵnov"](_v, 42).maxlength : null); var currVal_25 = core["ɵnov"](_v, 47).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 47).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 47).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 47).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 47).ngClassValid; var currVal_30 = core["ɵnov"](_v, 47).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 47).ngClassPending; _ck(_v, 40, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); var currVal_35 = core["ɵunv"](_v, 49, 0, core["ɵnov"](_v, 50).transform("Max")); _ck(_v, 49, 0, currVal_35); var currVal_36 = core["ɵunv"](_v, 53, 0, core["ɵnov"](_v, 54).transform("description")); _ck(_v, 53, 0, currVal_36); var currVal_37 = (core["ɵnov"](_v, 58).maxlength ? core["ɵnov"](_v, 58).maxlength : null); var currVal_38 = core["ɵnov"](_v, 63).ngClassUntouched; var currVal_39 = core["ɵnov"](_v, 63).ngClassTouched; var currVal_40 = core["ɵnov"](_v, 63).ngClassPristine; var currVal_41 = core["ɵnov"](_v, 63).ngClassDirty; var currVal_42 = core["ɵnov"](_v, 63).ngClassValid; var currVal_43 = core["ɵnov"](_v, 63).ngClassInvalid; var currVal_44 = core["ɵnov"](_v, 63).ngClassPending; _ck(_v, 56, 0, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); var currVal_48 = core["ɵunv"](_v, 65, 0, core["ɵnov"](_v, 66).transform("Max")); _ck(_v, 65, 0, currVal_48); var currVal_49 = core["ɵunv"](_v, 69, 0, core["ɵnov"](_v, 70).transform("permissions")); _ck(_v, 69, 0, currVal_49); var currVal_53 = core["ɵunv"](_v, 79, 0, core["ɵnov"](_v, 80).transform("cancel")); _ck(_v, 79, 0, currVal_53); });
}
function View_CreateRolesAndPermissionComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateRolesAndPermissionComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.roleData; _ck(_v, 1, 0, currVal_0); }, null); }
function View_CreateRolesAndPermissionComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "Create-Roles-Permission", [], null, null, null, View_CreateRolesAndPermissionComponent_0, RenderType_CreateRolesAndPermissionComponent)), core["ɵdid"](1, 49152, null, 0, createRolesAndPermission_CreateRolesAndPermissionComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], common["Location"], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var CreateRolesAndPermissionComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("Create-Roles-Permission", createRolesAndPermission_CreateRolesAndPermissionComponent, View_CreateRolesAndPermissionComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/addUsersToRole.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_addUsersToRole,_.._shared_services_configuration,_.._shared_services_http.client,_angular_router,_.._toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_sharedData PURE_IMPORTS_END */















var styles_AddUsersToRolesComponent = [];
var RenderType_AddUsersToRolesComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddUsersToRolesComponent, data: {} });

function View_AddUsersToRolesComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("addEmployees")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddUsersToRolesComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("removeEmp")); _ck(_v, 1, 0, currVal_0); }); }
function View_AddUsersToRolesComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "p", [["class", "text-primary float-right pl-3 m-0 cursor"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.showAdvanced() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("doNotEmpCode")); _ck(_v, 1, 0, currVal_0); });
}
function View_AddUsersToRolesComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [["class", "col-lg-10 col-md-10 float-left mb-2"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_5)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 0, null, null, 5, "textarea", [["class", "form-control w-100"], ["name", "enterCodeR&P"], ["rows", "5"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empCodes = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 2, "span", [["class", "text-12x"]], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.selectedOption === "everyoneIn"); _ck(_v, 2, 0, currVal_0); var currVal_8 = "enterCodeR&P"; var currVal_9 = _co.empCodes; _ck(_v, 6, 0, currVal_8, currVal_9); }, function (_ck, _v) { var currVal_1 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 8).ngClassValid; var currVal_6 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = core["ɵunv"](_v, 10, 0, core["ɵnov"](_v, 11).transform("enterEmpCodeWithSeparator")); _ck(_v, 10, 0, currVal_10); });
}
function View_AddUsersToRolesComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 0, "p", [["class", "text-danger  rounded p-2"]], [[8, "innerHTML", 1]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("invalidEmpCodes")); _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.invalidEmployeeCodes; _ck(_v, 4, 0, currVal_1); }); }
function View_AddUsersToRolesComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 22, "div", [["class", "w-100 float-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "medium mb-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectOption("everyone") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, "input", [["checked", ""], ["id", "everyone"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "label", [["class", "normal"], ["for", "everyone"]], null, null, null, null, null)), (_l()(), core["ɵted"](7, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectOption("except") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 0, "input", [["id", "except"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 2, "label", [["class", "normal"], ["for", "except"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 4, "div", [["class", "form-group col-lg-3 col-md-3 float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectOption("everyoneIn") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "input", [["id", "everyone_In"], ["name", "radio-group"], ["type", "radio"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "label", [["class", "normal"], ["for", "everyone_In"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_4)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_6)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_4 = (_co.selectedOption != "everyone"); _ck(_v, 20, 0, currVal_4); var currVal_5 = (_co.invalidEmployeeCodes.length > 0); _ck(_v, 22, 0, currVal_5); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("chooseEmpAdd")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform("includeEveryOne")); _ck(_v, 7, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("includeEveryOneExpect")); _ck(_v, 12, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("includeEveryoneIn")); _ck(_v, 17, 0, currVal_3); });
}
function View_AddUsersToRolesComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.employeeCode; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.employeeName; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.email; _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.userName; _ck(_v, 12, 0, currVal_3); }); }
function View_AddUsersToRolesComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_9)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_AddUsersToRolesComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_AddUsersToRolesComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_AddUsersToRolesComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_11)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_12)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_AddUsersToRolesComponent_13(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 28, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](8, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "perPageR&P"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.searchData.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onPageSizeChange() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](15, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](16, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](18, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](19, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](20, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](22, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](23, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](24, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](26, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.searchData.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.getEmployeeDetails() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](28, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_12 = "perPageR&P"; var currVal_13 = _co.searchData.pageSize; _ck(_v, 11, 0, currVal_12, currVal_13); var currVal_14 = "10"; _ck(_v, 15, 0, currVal_14); var currVal_15 = "10"; _ck(_v, 16, 0, currVal_15); var currVal_16 = "20"; _ck(_v, 19, 0, currVal_16); var currVal_17 = "20"; _ck(_v, 20, 0, currVal_17); var currVal_18 = "30"; _ck(_v, 23, 0, currVal_18); var currVal_19 = "30"; _ck(_v, 24, 0, currVal_19); var currVal_20 = true; var currVal_21 = false; var currVal_22 = true; var currVal_23 = _co.employeePageData.totalElements; var currVal_24 = 5; var currVal_25 = _co.searchData.page; var currVal_26 = _co.searchData.pageSize; _ck(_v, 28, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (((_co.searchData.page - 1) * _co.searchData.pageSize) + 1); var currVal_1 = ((_co.searchData.pageSize * (_co.searchData.page - 1)) + _co.employeePageData.numberOfElements); var currVal_2 = core["ɵunv"](_v, 2, 2, core["ɵnov"](_v, 3).transform("itemsOf")); var currVal_3 = _co.employeePageData.totalElements; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3); var currVal_4 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("showItemsPerPage")); _ck(_v, 6, 0, currVal_4); var currVal_5 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_6 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_7 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_8 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_9 = core["ɵnov"](_v, 13).ngClassValid; var currVal_10 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_11 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 8, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11); });
}
function View_AddUsersToRolesComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 43, "div", [["class", "w-100 float-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "medium mb-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 9, "div", [["class", "col-lg-10 col-md-10 float-left mb-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 5, "textarea", [["class", "form-control w-100"], ["name", "codeToRemoveR&P"], ["rows", "5"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.empCodes = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 2, "span", [["class", "text-12x"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 5, "div", [["class", "w-100 float-left mt-3 "]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 4, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 21, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](24, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](26, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](28, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](32, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](34, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_8)), core["ɵdid"](39, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_10)), core["ɵdid"](41, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_13)), core["ɵdid"](43, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "codeToRemoveR&P"; var currVal_9 = _co.empCodes; _ck(_v, 8, 0, currVal_8, currVal_9); var currVal_16 = (_co.employeeData.length != 0); _ck(_v, 39, 0, currVal_16); var currVal_17 = (_co.employeeData.length == 0); _ck(_v, 41, 0, currVal_17); var currVal_18 = (_co.employeeData.length > 0); _ck(_v, 43, 0, currVal_18); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("chooseToRemove")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 10).ngClassValid; var currVal_6 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("enterEmpCodeWithSeparator")); _ck(_v, 12, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("includedList")); _ck(_v, 18, 0, currVal_11); var currVal_12 = core["ɵunv"](_v, 24, 0, core["ɵnov"](_v, 25).transform("code")); _ck(_v, 24, 0, currVal_12); var currVal_13 = core["ɵunv"](_v, 28, 0, core["ɵnov"](_v, 29).transform("name")); _ck(_v, 28, 0, currVal_13); var currVal_14 = core["ɵunv"](_v, 32, 0, core["ɵnov"](_v, 33).transform("email")); _ck(_v, 32, 0, currVal_14); var currVal_15 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("userName")); _ck(_v, 36, 0, currVal_15); });
}
function View_AddUsersToRolesComponent_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"], ["name", "addRoleR&P"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addUsers() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", "\n"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disableButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("add")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddUsersToRolesComponent_15(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"], ["name", "deleteRoleR&P"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removeUsers() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", "\n"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disableButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("remove")); _ck(_v, 1, 0, currVal_1); });
}
function View_AddUsersToRolesComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 14, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 3, "button", [["class", "btn btn-secondary float-right mb-2"], ["name", "add&RemoveBack"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_3)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_7)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_14)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddUsersToRolesComponent_15)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mr-4"], ["name", "cancelAddOrDelete"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.rolesBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](20, null, ["", "\n"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "ADDROLE"); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_co.type == "DELETEROLE"); _ck(_v, 5, 0, currVal_1); var currVal_3 = (_co.type == "ADDROLE"); _ck(_v, 12, 0, currVal_3); var currVal_4 = (_co.type == "DELETEROLE"); _ck(_v, 14, 0, currVal_4); var currVal_5 = (_co.type == "ADDROLE"); _ck(_v, 16, 0, currVal_5); var currVal_6 = (_co.type == "DELETEROLE"); _ck(_v, 18, 0, currVal_6); }, function (_ck, _v) { var currVal_2 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("back")); _ck(_v, 9, 0, currVal_2); var currVal_7 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("cancel")); _ck(_v, 20, 0, currVal_7); });
}
function View_AddUsersToRolesComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "add-Users-To-Roles-Component", [], null, null, null, View_AddUsersToRolesComponent_0, RenderType_AddUsersToRolesComponent)), core["ɵdid"](1, 49152, null, 0, addUsersToRole_AddUsersToRolesComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, NgbModal, NgbActiveModal, SharedData, http_client_HttpClientCustom, common["Location"], core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var AddUsersToRolesComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("add-Users-To-Roles-Component", addUsersToRole_AddUsersToRolesComponent, View_AddUsersToRolesComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/org/addOrganization.ts



var addOrganization_AddOrganizationComponent = /*@__PURE__*/ (function () {
    function AddOrganizationComponent(route, modalService, _global, http, _sanitizer, builder, router, share, _toaster, translate, vcr) {
        var _this = this;
        this.route = route;
        this.modalService = modalService;
        this._global = _global;
        this.http = http;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this.router = router;
        this.share = share;
        this._toaster = _toaster;
        this.translate = translate;
        this.addOrgEvent = new core["EventEmitter"]();
        this.type = 'ADD';
        this.cancelEvent = new core["EventEmitter"]();
        this.oldValue = null;
        this.disableButton = false;
        this.warning = "No Org";
        this.primarySupervisorModel = '';
        this.primarySupervisor = '';
        this.hrSpocModel = '';
        this.ccAdmin = '';
        this.ccManager = '';
        this.leaveAdministrator = '';
        this.orgCat = '';
        this.orgData = {
            id: null,
            level: null,
            orgName: null,
            orgUnitCode: null,
            houEmployeeId: null,
            hrSpocId: null,
            orgType: null,
            parentId: null,
            description: null,
            mission: null,
            vision: null,
            status: null,
            noParent: null,
            ccAdminId: null,
            ccManagerId: null,
            leaveAdministratorId: null
        };
        this.autoCompleteOrgCat = function (data) {
            var html = "<span>" + data.code + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.displayName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        // To get list of Organization based on keyword
        this.orgTypeObservableSource = function (keyword) {
            if (keyword && keyword.trim() && keyword) {
                var url = _this._baseUrl + 'v1/webAdmin/orgUnit/orgType/autoComplete';
                url += '?name=' + keyword;
                if (keyword) {
                    return _this.http.get(url)
                        .map(function (res) {
                        return res;
                    }, function (error) {
                        console.log('catch orgUnitType Error' + error);
                        return Observable["a" /* Observable */].of([]);
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        };
        this.autoCompleteListOrgTypeFormatter = function (data) {
            var html = "<span>" + data.orgUnitTypeName + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        var data = this.share.getData();
        this.data = {};
    }
    AddOrganizationComponent.prototype.getOrgTree = function () {
        try {
            var self_1 = this;
            var url = self_1._baseUrl + 'v1/webAdmin/orgUnit/';
            self_1.http.get(url).subscribe(function (result) {
                self_1.orgData = result.data;
            });
        }
        catch (e) {
            console.log('Org Tree error catch', e);
        }
    };
    // Formatter
    AddOrganizationComponent.prototype.orgTypeFormatter = function (data) {
        return "" + data.orgUnitTypeName;
    };
    AddOrganizationComponent.prototype.getIdsWithPayload = function (keyword) {
        var payload = {
            searchString: null,
            excludeEmpIds: []
        };
        payload.searchString = keyword;
        var everythingButTheNulls = underscore["compact"](payload.excludeEmpIds);
        payload.excludeEmpIds = [];
        payload.excludeEmpIds = everythingButTheNulls;
        return payload;
    };
    // ObservableSource
    // to get list of supervisor based on keyword
    AddOrganizationComponent.prototype.primarySupervisorObservableSource = function (keyword) {
        try {
            if (keyword) {
                var url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
                if (keyword.trim()) {
                    var payload = this.getIdsWithPayload(keyword);
                    return this.http.post(url, payload)
                        .map(function (res) {
                        return res;
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        }
        catch (e) {
            console.log(e);
            return Observable["a" /* Observable */].of([]);
        }
    };
    AddOrganizationComponent.prototype.hrrObservableSource = function (keyword) {
        try {
            if (keyword) {
                var url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
                if (keyword.trim()) {
                    var payload = this.getIdsWithPayload(keyword);
                    return this.http.post(url, payload)
                        .map(function (res) {
                        return res;
                    });
                }
                else {
                    return Observable["a" /* Observable */].of([]);
                }
            }
            else {
                return Observable["a" /* Observable */].of([]);
            }
        }
        catch (e) {
            return Observable["a" /* Observable */].of([]);
        }
    };
    AddOrganizationComponent.prototype.changeOldValue = function () {
        var self = this;
        self.oldValue = null;
    };
    // when auto-complete value is selected this method fires and payload create
    AddOrganizationComponent.prototype.gotNewValue = function (e, type) {
        var _this = this;
        setTimeout(function () {
            _this.changeOldValue();
        }, 1000);
        if (underscore["isObject"](e)) {
            if (this.oldValue === type) {
                return;
            }
        }
        else if (e === '') {
            e = { id: null, name: null };
            this.oldValue = type;
        }
        else {
            return;
        }
        if (type === 'orgType') {
            this.orgData.orgType.id = e.id;
            this.orgData.level = e.level;
        }
        if (e) {
            if (type === 'primary') {
                this.orgData.houEmployeeId = e.id;
            }
            if (type === 'hrSpoc') {
                this.orgData.hrSpocId = e.id;
            }
            if (type === 'ccAdmin') {
                this.orgData.ccAdminId = e.id;
            }
            if (type === 'ccManager') {
                this.orgData.ccManagerId = e.id;
            }
            if (type === 'leaveAdministrator') {
                this.orgData.leaveAdministratorId = e.id;
            }
        }
    };
    // save organization
    AddOrganizationComponent.prototype.saveOrgData = function () {
        var _this = this;
        try {
            if (this.parentOrg != null) {
                this.orgData.parentId = this.parentOrg;
            }
            if (this.orgData.orgName == null || this.orgData.orgName === '') {
                this.translate.get('PLEASE_ENTER_ORGANIZATION_NAME_TO_CONTINUE')
                    .subscribe(function (res) {
                    _this._toaster.showError(res);
                });
                return false;
            }
            if (this.orgData.orgUnitCode == null || this.orgData.orgUnitCode === '') {
                this.translate.get('PLEASE_ENTER_ORGANIZATION_CODE_TO_CONTINUE')
                    .subscribe(function (res) {
                    _this._toaster.showError(res);
                });
                return false;
            }
            if (this.orgTypeModel == null) {
                this.translate.get('PLEASE_SELECT_ORG_TYPE').subscribe(function (res) {
                    _this._toaster.showError(res);
                });
                return false;
            }
            debugger;
            if (!this.orgTypeModel.id) {
                if (this.orgTypeModel.trim() === '') {
                    this.translate.get('PLEASE_SELECT_ORG_TYPE').subscribe(function (res) {
                        _this._toaster.showError(res);
                    });
                    return false;
                }
                else {
                    this.orgData.orgType = {};
                    this.orgData.orgType["id"] = this.orgTypeModel.id;
                }
            }
            this.disableButton = true;
            var url = this._baseUrl + 'v1/webAdmin/orgUnit';
            this.http.post(url, this.orgData).subscribe(function (result) {
                if (result.success) {
                    _this.addOrgEvent.emit({ data: result.data, orgName: _this.orgData.orgName });
                    _this.cancelEvent.emit(true);
                    _this.disableButton = false;
                }
                else {
                    for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                        var val = _a[_i];
                        _this.translate.get(val)
                            .subscribe(function (res) {
                            _this._toaster.showError(res);
                        });
                    }
                    _this.disableButton = false;
                }
            });
        }
        catch (e) {
            console.log('saveOrg error caught', e);
        }
    };
    AddOrganizationComponent.prototype.closeInputs = function () {
        this.cancelEvent.emit(true);
    };
    return AddOrganizationComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/org/addOrganization.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,ng2_auto_complete_dist_ng2_auto_complete.directive,_addOrganization,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_angular_platform_browser,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */












var styles_AddOrganizationComponent = [];
var RenderType_AddOrganizationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddOrganizationComponent, data: {} });

function View_AddOrganizationComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 136, "div", [["id", "divdata"], ["style", "display:show"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 15, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](8, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgData.orgName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](10, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](13, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](15, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](17, 0, null, null, 15, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 14, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](20, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](22, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](24, 0, null, null, 8, "input", [["class", "form-control"], ["maxlength", "250"], ["type", "text"]], [[8, "placeholder", 0], [1, "maxlength", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 25)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 25).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 25)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 25)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgData.orgUnitCode = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](25, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](26, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["MaxLengthValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](33, 0, null, null, 16, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 15, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](40, 16777216, null, null, 9, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "orgUnitTypeName"], ["name", "orgTypeModel"], ["ng2-auto-complete", ""], ["required", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.orgTypeModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "orgType") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](42, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](45, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](47, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](48, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], listFormatter: [3, "listFormatter"], blankOptionText: [4, "blankOptionText"], noMatchFoundText: [5, "noMatchFoundText"], valueFormatter: [6, "valueFormatter"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](50, 0, null, null, 15, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 2, "label", [["for", "sup"]], null, null, null, null, null)), (_l()(), core["ɵted"](52, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](54, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](55, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "sup"], ["max-num-list", "5"], ["name", "primarySupervisorModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 56)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 56).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 56)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 56)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.primarySupervisorModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "primary") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](56, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](58, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](60, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](61, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](63, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](64, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](66, 0, null, null, 15, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](67, 0, null, null, 2, "label", [["for", "hrSpoc"]], null, null, null, null, null)), (_l()(), core["ɵted"](68, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](70, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "hrSpoc"], ["max-num-list", "5"], ["name", "hrSpocModel"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 72)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 72).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 72)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 72)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.hrSpocModel = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "hrSpoc") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](72, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](74, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](76, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](77, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](79, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](80, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](82, 0, null, null, 15, "div", [["class", "col-lg-4 col-md-4 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](83, 0, null, null, 2, "label", [["for", "ccAdmin"]], null, null, null, null, null)), (_l()(), core["ɵted"](84, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](86, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "ccAdmin"], ["max-num-list", "5"], ["name", "ccAdmin"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 88)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 88).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 88)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 88)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.ccAdmin = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "ccAdmin") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](88, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](90, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](92, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](93, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](95, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](96, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](98, 0, null, null, 15, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](99, 0, null, null, 2, "label", [["for", "ccManager"]], null, null, null, null, null)), (_l()(), core["ɵted"](100, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](102, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](103, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "ccManager"], ["max-num-list", "5"], ["name", "ccManager"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 104)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 104).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 104)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 104)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.ccManager = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "ccManager") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](104, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](106, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](108, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](109, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](111, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](112, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](114, 0, null, null, 15, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](115, 0, null, null, 2, "label", [["for", "leaveAdministrator"]], null, null, null, null, null)), (_l()(), core["ɵted"](116, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](118, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-11 col-xs-11 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](119, 16777216, null, null, 7, "input", [["autocomplete", "off"], ["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "leaveAdministrator"], ["max-num-list", "5"], ["name", "leaveAdministrator"], ["ng2-auto-complete", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 120)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 120).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 120)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 120)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.leaveAdministrator = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.gotNewValue($event, "leaveAdministrator") !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](120, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](122, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](124, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](125, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [8, null]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], acceptUserInput: [2, "acceptUserInput"], maxNumList: [3, "maxNumList"], listFormatter: [4, "listFormatter"], blankOptionText: [5, "blankOptionText"], noMatchFoundText: [6, "noMatchFoundText"], ngModel: [7, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](127, 0, null, null, 2, "span", [["class", "info-text"]], null, null, null, null, null)), (_l()(), core["ɵted"](128, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](130, 0, null, null, 6, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](131, 0, null, null, 2, "button", [["class", "btn btn-primary float-left mt-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveOrgData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](132, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](134, 0, null, null, 2, "button", [["class", "btn btn-secondary float-left mt-4 ml-1"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.closeInputs() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](135, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_10 = "250"; _ck(_v, 10, 0, currVal_10); var currVal_11 = _co.orgData.orgName; _ck(_v, 13, 0, currVal_11); var currVal_22 = "250"; _ck(_v, 26, 0, currVal_22); var currVal_23 = _co.orgData.orgUnitCode; _ck(_v, 29, 0, currVal_23); var currVal_34 = ""; _ck(_v, 42, 0, currVal_34); var currVal_35 = "orgTypeModel"; var currVal_36 = _co.orgTypeModel; _ck(_v, 45, 0, currVal_35, currVal_36); var currVal_37 = _co.orgTypeObservableSource.bind(_co); var currVal_38 = "orgUnitTypeName"; var currVal_39 = false; var currVal_40 = _co.autoCompleteListOrgTypeFormatter; var currVal_41 = "Select"; var currVal_42 = _co.warning; var currVal_43 = _co.orgTypeFormatter; var currVal_44 = _co.orgTypeModel; _ck(_v, 48, 0, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); var currVal_54 = "primarySupervisorModel"; var currVal_55 = _co.primarySupervisorModel; _ck(_v, 58, 0, currVal_54, currVal_55); var currVal_56 = _co.primarySupervisorObservableSource.bind(_co); var currVal_57 = "displayName"; var currVal_58 = false; var currVal_59 = "5"; var currVal_60 = _co.autoCompleteListFormatter; var currVal_61 = "Select"; var currVal_62 = _co.warning; var currVal_63 = _co.primarySupervisorModel; _ck(_v, 61, 0, currVal_56, currVal_57, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63); var currVal_74 = "hrSpocModel"; var currVal_75 = _co.hrSpocModel; _ck(_v, 74, 0, currVal_74, currVal_75); var currVal_76 = _co.hrrObservableSource.bind(_co); var currVal_77 = "displayName"; var currVal_78 = false; var currVal_79 = "5"; var currVal_80 = _co.autoCompleteListFormatter; var currVal_81 = "Select"; var currVal_82 = _co.warning; var currVal_83 = _co.hrSpocModel; _ck(_v, 77, 0, currVal_76, currVal_77, currVal_78, currVal_79, currVal_80, currVal_81, currVal_82, currVal_83); var currVal_94 = "ccAdmin"; var currVal_95 = _co.ccAdmin; _ck(_v, 90, 0, currVal_94, currVal_95); var currVal_96 = _co.hrrObservableSource.bind(_co); var currVal_97 = "displayName"; var currVal_98 = false; var currVal_99 = "5"; var currVal_100 = _co.autoCompleteListFormatter; var currVal_101 = "Select"; var currVal_102 = _co.warning; var currVal_103 = _co.ccAdmin; _ck(_v, 93, 0, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101, currVal_102, currVal_103); var currVal_114 = "ccManager"; var currVal_115 = _co.ccManager; _ck(_v, 106, 0, currVal_114, currVal_115); var currVal_116 = _co.hrrObservableSource.bind(_co); var currVal_117 = "displayName"; var currVal_118 = false; var currVal_119 = "5"; var currVal_120 = _co.autoCompleteListFormatter; var currVal_121 = "Select"; var currVal_122 = _co.warning; var currVal_123 = _co.ccManager; _ck(_v, 109, 0, currVal_116, currVal_117, currVal_118, currVal_119, currVal_120, currVal_121, currVal_122, currVal_123); var currVal_134 = "leaveAdministrator"; var currVal_135 = _co.leaveAdministrator; _ck(_v, 122, 0, currVal_134, currVal_135); var currVal_136 = _co.hrrObservableSource.bind(_co); var currVal_137 = "displayName"; var currVal_138 = false; var currVal_139 = "5"; var currVal_140 = _co.autoCompleteListFormatter; var currVal_141 = "Select"; var currVal_142 = _co.warning; var currVal_143 = _co.leaveAdministrator; _ck(_v, 125, 0, currVal_136, currVal_137, currVal_138, currVal_139, currVal_140, currVal_141, currVal_142, currVal_143); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("name")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 16).transform("orgName")), ""); var currVal_2 = (core["ɵnov"](_v, 10).maxlength ? core["ɵnov"](_v, 10).maxlength : null); var currVal_3 = core["ɵnov"](_v, 15).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 15).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 15).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 15).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 15).ngClassValid; var currVal_8 = core["ɵnov"](_v, 15).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 15).ngClassPending; _ck(_v, 8, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_12 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("code")); _ck(_v, 20, 0, currVal_12); var currVal_13 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 24, 0, core["ɵnov"](_v, 32).transform("orgCode")), ""); var currVal_14 = (core["ɵnov"](_v, 26).maxlength ? core["ɵnov"](_v, 26).maxlength : null); var currVal_15 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_16 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_17 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_18 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_19 = core["ɵnov"](_v, 31).ngClassValid; var currVal_20 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_21 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 24, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21); var currVal_24 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("orgType")); _ck(_v, 36, 0, currVal_24); var currVal_25 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 49).transform("typeChooseOrgType")), ""); var currVal_26 = (core["ɵnov"](_v, 42).required ? "" : null); var currVal_27 = core["ɵnov"](_v, 47).ngClassUntouched; var currVal_28 = core["ɵnov"](_v, 47).ngClassTouched; var currVal_29 = core["ɵnov"](_v, 47).ngClassPristine; var currVal_30 = core["ɵnov"](_v, 47).ngClassDirty; var currVal_31 = core["ɵnov"](_v, 47).ngClassValid; var currVal_32 = core["ɵnov"](_v, 47).ngClassInvalid; var currVal_33 = core["ɵnov"](_v, 47).ngClassPending; _ck(_v, 40, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33); var currVal_45 = core["ɵunv"](_v, 52, 0, core["ɵnov"](_v, 53).transform("headOfUnit")); _ck(_v, 52, 0, currVal_45); var currVal_46 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 55, 0, core["ɵnov"](_v, 62).transform("typeChooseHOU")), ""); var currVal_47 = core["ɵnov"](_v, 60).ngClassUntouched; var currVal_48 = core["ɵnov"](_v, 60).ngClassTouched; var currVal_49 = core["ɵnov"](_v, 60).ngClassPristine; var currVal_50 = core["ɵnov"](_v, 60).ngClassDirty; var currVal_51 = core["ɵnov"](_v, 60).ngClassValid; var currVal_52 = core["ɵnov"](_v, 60).ngClassInvalid; var currVal_53 = core["ɵnov"](_v, 60).ngClassPending; _ck(_v, 55, 0, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53); var currVal_64 = core["ɵunv"](_v, 64, 0, core["ɵnov"](_v, 65).transform("headOfUnit")); _ck(_v, 64, 0, currVal_64); var currVal_65 = core["ɵunv"](_v, 68, 0, core["ɵnov"](_v, 69).transform("hrSpoc")); _ck(_v, 68, 0, currVal_65); var currVal_66 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 71, 0, core["ɵnov"](_v, 78).transform("typeChooseHrSpoc")), ""); var currVal_67 = core["ɵnov"](_v, 76).ngClassUntouched; var currVal_68 = core["ɵnov"](_v, 76).ngClassTouched; var currVal_69 = core["ɵnov"](_v, 76).ngClassPristine; var currVal_70 = core["ɵnov"](_v, 76).ngClassDirty; var currVal_71 = core["ɵnov"](_v, 76).ngClassValid; var currVal_72 = core["ɵnov"](_v, 76).ngClassInvalid; var currVal_73 = core["ɵnov"](_v, 76).ngClassPending; _ck(_v, 71, 0, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72, currVal_73); var currVal_84 = core["ɵunv"](_v, 80, 0, core["ɵnov"](_v, 81).transform("hrSinglePointOfCont")); _ck(_v, 80, 0, currVal_84); var currVal_85 = core["ɵunv"](_v, 84, 0, core["ɵnov"](_v, 85).transform("ccAdmin")); _ck(_v, 84, 0, currVal_85); var currVal_86 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 87, 0, core["ɵnov"](_v, 94).transform("typeChooseCcAdmin")), ""); var currVal_87 = core["ɵnov"](_v, 92).ngClassUntouched; var currVal_88 = core["ɵnov"](_v, 92).ngClassTouched; var currVal_89 = core["ɵnov"](_v, 92).ngClassPristine; var currVal_90 = core["ɵnov"](_v, 92).ngClassDirty; var currVal_91 = core["ɵnov"](_v, 92).ngClassValid; var currVal_92 = core["ɵnov"](_v, 92).ngClassInvalid; var currVal_93 = core["ɵnov"](_v, 92).ngClassPending; _ck(_v, 87, 0, currVal_86, currVal_87, currVal_88, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93); var currVal_104 = core["ɵunv"](_v, 96, 0, core["ɵnov"](_v, 97).transform("ccAdmin")); _ck(_v, 96, 0, currVal_104); var currVal_105 = core["ɵunv"](_v, 100, 0, core["ɵnov"](_v, 101).transform("ccManager")); _ck(_v, 100, 0, currVal_105); var currVal_106 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 103, 0, core["ɵnov"](_v, 110).transform("typeChooseCcManager")), ""); var currVal_107 = core["ɵnov"](_v, 108).ngClassUntouched; var currVal_108 = core["ɵnov"](_v, 108).ngClassTouched; var currVal_109 = core["ɵnov"](_v, 108).ngClassPristine; var currVal_110 = core["ɵnov"](_v, 108).ngClassDirty; var currVal_111 = core["ɵnov"](_v, 108).ngClassValid; var currVal_112 = core["ɵnov"](_v, 108).ngClassInvalid; var currVal_113 = core["ɵnov"](_v, 108).ngClassPending; _ck(_v, 103, 0, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111, currVal_112, currVal_113); var currVal_124 = core["ɵunv"](_v, 112, 0, core["ɵnov"](_v, 113).transform("ccManager")); _ck(_v, 112, 0, currVal_124); var currVal_125 = core["ɵunv"](_v, 116, 0, core["ɵnov"](_v, 117).transform("leaveAdministrator")); _ck(_v, 116, 0, currVal_125); var currVal_126 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 119, 0, core["ɵnov"](_v, 126).transform("typeChooseLeaveAdministrator")), ""); var currVal_127 = core["ɵnov"](_v, 124).ngClassUntouched; var currVal_128 = core["ɵnov"](_v, 124).ngClassTouched; var currVal_129 = core["ɵnov"](_v, 124).ngClassPristine; var currVal_130 = core["ɵnov"](_v, 124).ngClassDirty; var currVal_131 = core["ɵnov"](_v, 124).ngClassValid; var currVal_132 = core["ɵnov"](_v, 124).ngClassInvalid; var currVal_133 = core["ɵnov"](_v, 124).ngClassPending; _ck(_v, 119, 0, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131, currVal_132, currVal_133); var currVal_144 = core["ɵunv"](_v, 128, 0, core["ɵnov"](_v, 129).transform("leaveAdministrator")); _ck(_v, 128, 0, currVal_144); var currVal_145 = core["ɵunv"](_v, 132, 0, core["ɵnov"](_v, 133).transform("add")); _ck(_v, 132, 0, currVal_145); var currVal_146 = core["ɵunv"](_v, 135, 0, core["ɵnov"](_v, 136).transform("cancel")); _ck(_v, 135, 0, currVal_146); });
}
function View_AddOrganizationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddOrganization", [], null, null, null, View_AddOrganizationComponent_0, RenderType_AddOrganizationComponent)), core["ɵdid"](1, 49152, null, 0, addOrganization_AddOrganizationComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], fesm5_router["l" /* Router */], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var AddOrganizationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("AddOrganization", addOrganization_AddOrganizationComponent, View_AddOrganizationComponent_Host_0, { parentOrg: "parentOrg" }, { addOrgEvent: "addOrgEvent", cancelEvent: "cancelEvent" }, []);



// CONCATENATED MODULE: ./src/app/tools/org/org.ts


var org_OrgComponent = /*@__PURE__*/ (function () {
    function OrgComponent(_global, http, router, _toaster, modalService, activeModal, share, translate, vcr) {
        this._global = _global;
        this.http = http;
        this.router = router;
        this._toaster = _toaster;
        this.modalService = modalService;
        this.activeModal = activeModal;
        this.share = share;
        this.translate = translate;
        this.showChild = false;
        this.hasChild = true;
        this.asl = false;
        this.deleteOrgEvent = new core["EventEmitter"]();
        this.editOrgEvent = new core["EventEmitter"]();
        this.refresh = new core["EventEmitter"]();
        this._baseUrl = _global.get('EPMS_BASE_URL');
    }
    OrgComponent.prototype.hasChilds = function () {
        return this.org.childOrgs != null && this.org.childOrgs.length > 0;
    };
    OrgComponent.prototype.toggleChild = function () {
        var self = this;
        if (self.org.childOrgs) {
            self.showChild = !self.showChild;
        }
    };
    OrgComponent.prototype.getOrgtype = function () {
        if (!this.org.orgTypeName) {
            return this.share.getMapValues('' + this.org.orgType + '');
        }
        else {
            return this.org.orgTypeName;
        }
    };
    OrgComponent.prototype.addSubLevels = function (evn) {
        this.asl = evn;
    };
    OrgComponent.prototype.addChildTree = function (event) {
        var _this = this;
        if (!event.orgName.orgUnitTypeName) {
            this.orgTypeName = event.orgName;
        }
        else {
            this.orgTypeName = event.orgName.orgUnitTypeName;
        }
        this.share.saveAsMap('' + event.data.orgType + '', this.orgTypeName);
        if (this.org.childOrgs != null) {
            this.org.childOrgs.push(event.data);
        }
        else {
            this.org.childOrgs = new Array(0);
            this.org.childOrgs.push(event.data);
        }
        this.translate.get('orgSaved').subscribe(function (msg) {
            _this._toaster.showSuccess(msg);
        });
    };
    OrgComponent.prototype.closeSubLevels = function (evn) {
        this.asl = evn;
    };
    OrgComponent.prototype.deleteOrgModal = function () {
        var _this = this;
        this.share.saveData({ orgId: null, type: 'scaleRemove' });
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            if (result == 'confirmed') {
                _this.deleteOrg();
            }
        }, function (reason) {
            console.log(reason);
        });
    };
    OrgComponent.prototype.deleteOrg = function () {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/orgUnit/' + self.org.id;
        self.http.delete(url).subscribe(function (result) {
            if (result.success) {
                self.deleteOrgEvent.emit(self.org.id);
            }
            else {
                for (var _i = 0, _a = result.errorMessages; _i < _a.length; _i++) {
                    var val = _a[_i];
                    self._toaster.showError(val);
                }
            }
        }, function (error) {
            _this.translate.get('internalServerError').subscribe(function (msg) {
                self._toaster.showError(msg);
            });
        });
    };
    OrgComponent.prototype.editOrg = function (param) {
        var self = this;
        self.editOrgEvent.emit(param);
    };
    OrgComponent.prototype.refreshLocal = function (param) {
        this.refresh.emit("");
    };
    return OrgComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/org/childOrgs.ts


var childOrgs_ChildOrgComponent = /*@__PURE__*/ (function () {
    function ChildOrgComponent(_global, http, router, _toaster, share, modalService, translate, vcr) {
        this._global = _global;
        this.http = http;
        this.router = router;
        this._toaster = _toaster;
        this.share = share;
        this.modalService = modalService;
        this.translate = translate;
        this.refresh = new core["EventEmitter"]();
        this.showChild = false;
        this.asl = false;
        this.parentMatch = false;
        this.orgData = [];
        // this._toaster.setViewRef(vcr);
        this._baseUrl = _global.get('EPMS_BASE_URL');
    }
    ChildOrgComponent.prototype.toggleChild = function () {
        var self = this;
        if (self.childOrgs) {
            self.showChild = !self.showChild;
        }
    };
    ChildOrgComponent.prototype.addSubLevels = function (evn) {
        this.asl = evn;
    };
    ChildOrgComponent.prototype.removeFromChild = function (id) {
        var self = this;
        var index;
        for (var i in self.childOrgs) {
            if (self.childOrgs[i].id === id) {
                index = i;
            }
        }
        self.childOrgs.splice(index, 1);
        self.translate.get('orgDeleted').subscribe(function (msg) {
            self._toaster.showSuccess(msg);
        });
    };
    ChildOrgComponent.prototype.editOrg = function (param) {
        var _this = this;
        var self = this;
        this.share.saveData({ org: param, type: 'EDIT' });
        var modalRef = this.modalService
            .open(addParentOrganization_AddParentOrganizationComponent).result.then(function (result) {
            _this.addToParent(result);
        }, function (reason) {
            ;
        });
    };
    ChildOrgComponent.prototype.addToParent = function (event) {
        var _this = this;
        this.share.saveAsMap('' + event.data.orgType + '', event.orgTypeName);
        var parentOrg = this.share.getData();
        var mainOrgChilds = parentOrg.mainOrg.org.childOrgs;
        var parOrgData = event.data;
        for (var i in this.childOrgs) {
            if (this.childOrgs[i].id === parOrgData.id) {
                this.childOrgs[i] = parOrgData;
                this.childOrgs[i].childOrgs = mainOrgChilds;
            }
        }
        this.translate.get('orgUpdated').subscribe(function (msg) {
            _this._toaster.showSuccess(msg);
        });
        this.refresh.emit("");
        //this.router.navigate(['menu/organizationList']);
    };
    ChildOrgComponent.prototype.refreshLocal = function (param) {
        this.refresh.emit("");
    };
    return ChildOrgComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/org/childOrgs.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_org.ngfactory,_org,_.._shared_services_configuration,_.._shared_services_http.client,_angular_router,_.._toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_sharedData,_ngx_translate_core,_angular_common,_childOrgs PURE_IMPORTS_END */













var styles_ChildOrgComponent = [];
var RenderType_ChildOrgComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ChildOrgComponent, data: {} });

function View_ChildOrgComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left pl-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "org", [], null, [[null, "deleteOrgEvent"], [null, "editOrgEvent"], [null, "refresh"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("deleteOrgEvent" === en)) {
                var pd_0 = (_co.removeFromChild($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("editOrgEvent" === en)) {
                var pd_1 = (_co.editOrg($event) !== false);
                ad = (pd_1 && ad);
            }
            if (("refresh" === en)) {
                var pd_2 = (_co.refreshLocal($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_OrgComponent_0, RenderType_OrgComponent)), core["ɵdid"](2, 49152, null, 0, org_OrgComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, NgbModal, NgbActiveModal, SharedData, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], { org: [0, "org"] }, { deleteOrgEvent: "deleteOrgEvent", editOrgEvent: "editOrgEvent", refresh: "refresh" })], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 2, 0, currVal_0); }, null);
}
function View_ChildOrgComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_ChildOrgComponent_1)), core["ɵdid"](1, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.childOrgs; _ck(_v, 1, 0, currVal_0); }, null); }
function View_ChildOrgComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "child-orgs", [], null, null, null, View_ChildOrgComponent_0, RenderType_ChildOrgComponent)), core["ɵdid"](1, 49152, null, 0, childOrgs_ChildOrgComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, SharedData, NgbModal, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var ChildOrgComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("child-orgs", childOrgs_ChildOrgComponent, View_ChildOrgComponent_Host_0, { childOrgs: "childOrgs" }, { refresh: "refresh" }, []);



// CONCATENATED MODULE: ./src/app/tools/org/org.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_ngx_translate_core,_addOrganization.ngfactory,_addOrganization,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_angular_platform_browser,_angular_forms,_.._shared_sharedData,_.._toasterComponent_toasterComponent,_childOrgs.ngfactory,_childOrgs,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_org,_ng_bootstrap_ng_bootstrap_modal_modal_ref PURE_IMPORTS_END */



















var styles_OrgComponent = [];
var RenderType_OrgComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_OrgComponent, data: {} });

function View_OrgComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "i", [["class", "fa float-left mr-3 mt-1 text-20x"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleChild() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 278528, null, 0, common["NgClass"], [core["IterableDiffers"], core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { klass: [0, "klass"], ngClass: [1, "ngClass"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "fa float-left mr-3 mt-1 text-20x"; var currVal_1 = (_co.showChild ? "fa-caret-down" : "fa-caret-right"); _ck(_v, 1, 0, currVal_0, currVal_1); }, null);
}
function View_OrgComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵted"](0, null, [" ", " : ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](2, 0, null, null, 0, "br", [], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", " : ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "br", [], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", " : ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 0, 0, core["ɵnov"](_v, 1).transform("orgName")); var currVal_1 = _co.org.orgName; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("orgCode")); var currVal_3 = _co.org.orgUnitCode; _ck(_v, 3, 0, currVal_2, currVal_3); var currVal_4 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("orgType")); var currVal_5 = _co.getOrgtype(); _ck(_v, 6, 0, currVal_4, currVal_5); }); }
function View_OrgComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddOrganization", [], null, [[null, "cancelEvent"], [null, "addOrgEvent"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("cancelEvent" === en)) {
                var pd_0 = (_co.closeSubLevels(!_co.asl) !== false);
                ad = (pd_0 && ad);
            }
            if (("addOrgEvent" === en)) {
                var pd_1 = (_co.addChildTree($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_AddOrganizationComponent_0, RenderType_AddOrganizationComponent)), core["ɵdid"](1, 49152, null, 0, addOrganization_AddOrganizationComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], fesm5_router["l" /* Router */], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], { parentOrg: [0, "parentOrg"] }, { addOrgEvent: "addOrgEvent", cancelEvent: "cancelEvent" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.org.id; _ck(_v, 1, 0, currVal_0); }, null);
}
function View_OrgComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "child-orgs", [], null, [[null, "refresh"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("refresh" === en)) {
                var pd_0 = (_co.refreshLocal($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ChildOrgComponent_0, RenderType_ChildOrgComponent)), core["ɵdid"](1, 49152, null, 0, childOrgs_ChildOrgComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, SharedData, NgbModal, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], { childOrgs: [0, "childOrgs"] }, { refresh: "refresh" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.org.childOrgs; _ck(_v, 1, 0, currVal_0); }, null);
}
function View_OrgComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 31, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 30, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 29, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 24, "div", [["class", "w-100 float-left mb-3 hidden-actions"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrgComponent_1)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 0, "label", [["class", "mb-md-0 float-left mr-2 mt-1"], ["for", "user1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 20, "p", [["class", "float-left text-14x m-0 "]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 0, null, null, 18, "span", [["class", "show-actions float-right"], ["style", "display: none;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 3, "i", [["class", "fa fa-plus cursor ml-4 pointer text-10x p-1 rounded text-primary border-primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addSubLevels(!_co.asl) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 2, "span", [["class", "medium text-primary pl-1"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 3, "i", [["class", "fa fa-edit cursor ml-1 pointer text-10x p-1 rounded text-primary border-primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editOrg(_co.org) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 2, "span", [["class", "medium text-primary pl-1"]], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](18, 0, null, null, 3, "i", [["class", "fa fa-close cursor ml-1 pointer text-10x text-danger border-danger p-1 rounded"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deleteOrgModal() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 2, "span", [["class", "medium text-danger pl-1"]], null, null, null, null, null)), (_l()(), core["ɵted"](20, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](0, [["tipContent", 2]], null, 0, null, View_OrgComponent_2)), (_l()(), core["ɵeld"](23, 16777216, null, null, 4, "i", [["class", "fa fa-info cursor ml-1 pointer text-10x text-success border-success p-1 rounded"]], null, null, null, null, null)), core["ɵdid"](24, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](25, 0, null, null, 2, "span", [["class", "medium text-success pl-1"], ["placement", "top"]], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrgComponent_3)), core["ɵdid"](29, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrgComponent_4)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.hasChilds(); _ck(_v, 5, 0, currVal_0); var currVal_5 = core["ɵnov"](_v, 22); _ck(_v, 24, 0, currVal_5); var currVal_7 = _co.asl; _ck(_v, 29, 0, currVal_7); var currVal_8 = (_co.org.childOrgs && _co.showChild); _ck(_v, 31, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.org.orgName; _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("addChild")); _ck(_v, 12, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 17).transform("edit")); _ck(_v, 16, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("delete")); _ck(_v, 20, 0, currVal_4); var currVal_6 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("info")); _ck(_v, 26, 0, currVal_6); });
}
function View_OrgComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "org", [], null, null, null, View_OrgComponent_0, RenderType_OrgComponent)), core["ɵdid"](1, 49152, null, 0, org_OrgComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, NgbModal, NgbActiveModal, SharedData, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var OrgComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("org", org_OrgComponent, View_OrgComponent_Host_0, { org: "org" }, { deleteOrgEvent: "deleteOrgEvent", editOrgEvent: "editOrgEvent", refresh: "refresh" }, []);



// CONCATENATED MODULE: ./src/app/tools/org/organizationList.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_org.ngfactory,_org,_.._shared_services_configuration,_.._shared_services_http.client,_angular_router,_.._toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_sharedData,_ngx_translate_core,_angular_common,_organizationList,_angular_platform_browser,_angular_forms PURE_IMPORTS_END */















var styles_OrganizationPage = [];
var RenderType_OrganizationPage = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_OrganizationPage, data: {} });

function View_OrganizationPage_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "org", [], null, [[null, "deleteOrgEvent"], [null, "editOrgEvent"], [null, "refresh"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("deleteOrgEvent" === en)) {
                var pd_0 = (_co.removeFromChild($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("editOrgEvent" === en)) {
                var pd_1 = (_co.editOrg($event) !== false);
                ad = (pd_1 && ad);
            }
            if (("refresh" === en)) {
                var pd_2 = (_co.refreshLocal($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_OrgComponent_0, RenderType_OrgComponent)), core["ɵdid"](2, 49152, null, 0, org_OrgComponent, [Configuration, http_client_HttpClientCustom, fesm5_router["l" /* Router */], ToasterComponent, NgbModal, NgbActiveModal, SharedData, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], { org: [0, "org"] }, { deleteOrgEvent: "deleteOrgEvent", editOrgEvent: "editOrgEvent", refresh: "refresh" })], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 2, 0, currVal_0); }, null);
}
function View_OrganizationPage_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.orgAdd() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](7, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 2, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_OrganizationPage_1)), core["ɵdid"](11, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = _co.orgData; _ck(_v, 11, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("OrgUnits")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform("addOrg")); _ck(_v, 7, 0, currVal_1); });
}
function View_OrganizationPage_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "organizationList", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_OrganizationPage_0, RenderType_OrganizationPage)), core["ɵdid"](1, 49152, null, 0, organizationList_OrganizationPage, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null);
}
var OrganizationPageNgFactory = /*@__PURE__*/ core["ɵccf"]("organizationList", organizationList_OrganizationPage, View_OrganizationPage_Host_0, {}, { updateRate: "hideMe" }, []);



// CONCATENATED MODULE: ./src/app/tools/rolesAndPermission/employeesInRole.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_ngx_translate_core,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_.._employee_employeeFilter.ngfactory,_.._employee_employeeFilter,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_angular_platform_browser,_.._toasterComponent_toasterComponent,_employeesInRole PURE_IMPORTS_END */


















var styles_EmployeeInRoleComponent = [];
var RenderType_EmployeeInRoleComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmployeeInRoleComponent, data: {} });

function View_EmployeeInRoleComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.employeeCode; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.employeeName; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.email; _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.userName; _ck(_v, 12, 0, currVal_3); }); }
function View_EmployeeInRoleComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInRoleComponent_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_EmployeeInRoleComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_EmployeeInRoleComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_EmployeeInRoleComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInRoleComponent_4)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInRoleComponent_5)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_EmployeeInRoleComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 28, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " ", " ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](8, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](15, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](16, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](18, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](19, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](20, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](22, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](23, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](24, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](26, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](28, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_12 = _co.pageSize; _ck(_v, 11, 0, currVal_12); var currVal_13 = "10"; _ck(_v, 15, 0, currVal_13); var currVal_14 = "10"; _ck(_v, 16, 0, currVal_14); var currVal_15 = "20"; _ck(_v, 19, 0, currVal_15); var currVal_16 = "20"; _ck(_v, 20, 0, currVal_16); var currVal_17 = "30"; _ck(_v, 23, 0, currVal_17); var currVal_18 = "30"; _ck(_v, 24, 0, currVal_18); var currVal_19 = true; var currVal_20 = false; var currVal_21 = true; var currVal_22 = _co.collectionSize; var currVal_23 = 5; var currVal_24 = _co.page; var currVal_25 = _co.pageSize; _ck(_v, 28, 0, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_1 = ((_co.pageSize * (_co.page - 1)) + _co.employeePageData.numberOfElements); var currVal_2 = core["ɵunv"](_v, 2, 2, core["ɵnov"](_v, 3).transform("itemsOf")); var currVal_3 = _co.employeePageData.totalElements; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3); var currVal_4 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("showItemsPerPage")); _ck(_v, 6, 0, currVal_4); var currVal_5 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_6 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_7 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_8 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_9 = core["ɵnov"](_v, 13).ngClassValid; var currVal_10 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_11 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 8, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11); });
}
function View_EmployeeInRoleComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 34, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["class", "btn float-left mb-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Back"])), (_l()(), core["ɵeld"](9, 16777216, null, null, 1, "employeeFilter", [], null, [[null, "searchEmp"], ["window", "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 10).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("searchEmp" === en)) {
                var pd_1 = (_co.showSearchFilter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EmployeeFilter_0, RenderType_EmployeeFilter)), core["ɵdid"](10, 114688, null, 0, employeeFilter_EmployeeFilter, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { displayTab: [0, "displayTab"] }, { searchEmp: "searchEmp" }), (_l()(), core["ɵeld"](11, 0, null, null, 21, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](17, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](19, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](21, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](23, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](25, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](27, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInRoleComponent_1)), core["ɵdid"](30, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInRoleComponent_3)), core["ɵdid"](32, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInRoleComponent_6)), core["ɵdid"](34, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = "emprole"; _ck(_v, 10, 0, currVal_1); var currVal_6 = (_co.employeeData.length != 0); _ck(_v, 30, 0, currVal_6); var currVal_7 = (_co.employeeData.length == 0); _ck(_v, 32, 0, currVal_7); var currVal_8 = (_co.employeeData.length > 0); _ck(_v, 34, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("employees")); _ck(_v, 3, 0, currVal_0); var currVal_2 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("code")); _ck(_v, 15, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 19, 0, core["ɵnov"](_v, 20).transform("name")); _ck(_v, 19, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 23, 0, core["ɵnov"](_v, 24).transform("email")); _ck(_v, 23, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 27, 0, core["ɵnov"](_v, 28).transform("userName")); _ck(_v, 27, 0, currVal_5); });
}
function View_EmployeeInRoleComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "employee-Roles-Permission", [], null, null, null, View_EmployeeInRoleComponent_0, RenderType_EmployeeInRoleComponent)), core["ɵdid"](1, 49152, null, 0, employeesInRole_EmployeeInRoleComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], common["Location"], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var EmployeeInRoleComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("employee-Roles-Permission", employeesInRole_EmployeeInRoleComponent, View_EmployeeInRoleComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/userGroup/employeesInGroup.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_ngx_translate_core,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_.._employee_employeeFilter.ngfactory,_.._employee_employeeFilter,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_angular_platform_browser,_.._toasterComponent_toasterComponent,_employeesInGroup PURE_IMPORTS_END */


















var styles_EmployeeInGroupComponent = [];
var RenderType_EmployeeInGroupComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmployeeInGroupComponent, data: {} });

function View_EmployeeInGroupComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.employeeCode; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.employeeName; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.email; _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.userName; _ck(_v, 12, 0, currVal_3); }); }
function View_EmployeeInGroupComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInGroupComponent_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.employeeData; _ck(_v, 2, 0, currVal_0); }, null); }
function View_EmployeeInGroupComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_EmployeeInGroupComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_EmployeeInGroupComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInGroupComponent_4)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInGroupComponent_5)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_EmployeeInGroupComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 28, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, [" ", " - ", " ", " ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](8, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](15, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](16, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](18, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](19, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](20, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](22, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](23, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](24, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](26, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](28, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_12 = _co.pageSize; _ck(_v, 11, 0, currVal_12); var currVal_13 = "10"; _ck(_v, 15, 0, currVal_13); var currVal_14 = "10"; _ck(_v, 16, 0, currVal_14); var currVal_15 = "20"; _ck(_v, 19, 0, currVal_15); var currVal_16 = "20"; _ck(_v, 20, 0, currVal_16); var currVal_17 = "30"; _ck(_v, 23, 0, currVal_17); var currVal_18 = "30"; _ck(_v, 24, 0, currVal_18); var currVal_19 = true; var currVal_20 = false; var currVal_21 = true; var currVal_22 = _co.collectionSize; var currVal_23 = 5; var currVal_24 = _co.page; var currVal_25 = _co.pageSize; _ck(_v, 28, 0, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_1 = ((_co.pageSize * (_co.page - 1)) + _co.employeePageData.numberOfElements); var currVal_2 = core["ɵunv"](_v, 2, 2, core["ɵnov"](_v, 3).transform("itemsOf")); var currVal_3 = _co.employeePageData.totalElements; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3); var currVal_4 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("showItemsPerPage")); _ck(_v, 6, 0, currVal_4); var currVal_5 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_6 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_7 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_8 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_9 = core["ɵnov"](_v, 13).ngClassValid; var currVal_10 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_11 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 8, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11); });
}
function View_EmployeeInGroupComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 35, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 3, "button", [["class", "btn float-left mb-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 16777216, null, null, 1, "employeeFilter", [], null, [[null, "searchEmp"], ["window", "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 11).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("searchEmp" === en)) {
                var pd_1 = (_co.showSearchFilter($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EmployeeFilter_0, RenderType_EmployeeFilter)), core["ɵdid"](11, 114688, null, 0, employeeFilter_EmployeeFilter, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { displayTab: [0, "displayTab"] }, { searchEmp: "searchEmp" }), (_l()(), core["ɵeld"](12, 0, null, null, 21, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 16, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](18, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](20, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](22, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](24, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](26, 0, null, null, 3, "div", [["class", "col-lg-4 col-md-4 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](28, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInGroupComponent_1)), core["ɵdid"](31, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInGroupComponent_3)), core["ɵdid"](33, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeInGroupComponent_6)), core["ɵdid"](35, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = "empgroup"; _ck(_v, 11, 0, currVal_2); var currVal_7 = (_co.employeeData.length != 0); _ck(_v, 31, 0, currVal_7); var currVal_8 = (_co.employeeData.length == 0); _ck(_v, 33, 0, currVal_8); var currVal_9 = (_co.employeeData.length > 0); _ck(_v, 35, 0, currVal_9); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("employees")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("back")); _ck(_v, 8, 0, currVal_1); var currVal_3 = core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 17).transform("code")); _ck(_v, 16, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("name")); _ck(_v, 20, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 24, 0, core["ɵnov"](_v, 25).transform("email")); _ck(_v, 24, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 28, 0, core["ɵnov"](_v, 29).transform("userName")); _ck(_v, 28, 0, currVal_6); });
}
function View_EmployeeInGroupComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "employee-Group-Permission", [], null, null, null, View_EmployeeInGroupComponent_0, RenderType_EmployeeInGroupComponent)), core["ɵdid"](1, 49152, null, 0, employeesInGroup_EmployeeInGroupComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, Configuration, http_client_HttpClientCustom, fesm5_forms["FormBuilder"], auth_Auth, fesm5_router["l" /* Router */], common["Location"], SharedData, ToasterComponent, core_es5["j" /* TranslateService */], core["ViewContainerRef"]], null, null)], null, null); }
var EmployeeInGroupComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("employee-Group-Permission", employeesInGroup_EmployeeInGroupComponent, View_EmployeeInGroupComponent_Host_0, {}, {}, []);



// EXTERNAL MODULE: ./node_modules/quill/dist/quill.js
var quill = __webpack_require__("yPE/");
var quill_default = /*#__PURE__*/__webpack_require__.n(quill);

// CONCATENATED MODULE: ./node_modules/ngx-quill/src/quill-editor.component.js





var Quill = quill;
var quill_editor_component_QuillEditorComponent = /*@__PURE__*/ (function () {
    function QuillEditorComponent(elementRef, doc, renderer) {
        this.elementRef = elementRef;
        this.doc = doc;
        this.renderer = renderer;
        this.emptyArray = [];
        this.defaultModules = {
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                // toggled buttons
                ['blockquote', 'code-block'],
                [{ 'header': 1 }, { 'header': 2 }],
                // custom button values
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'script': 'sub' }, { 'script': 'super' }],
                // superscript/subscript
                [{ 'indent': '-1' }, { 'indent': '+1' }],
                // outdent/indent
                [{ 'direction': 'rtl' }],
                // text direction
                [{ 'size': ['small', false, 'large', 'huge'] }],
                // custom dropdown
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                [{ 'color': this.emptyArray.slice() }, { 'background': this.emptyArray.slice() }],
                // dropdown with defaults from theme
                [{ 'font': this.emptyArray.slice() }],
                [{ 'align': this.emptyArray.slice() }],
                ['clean'],
                // remove formatting button
                ['link', 'image', 'video'] // link and image, video
            ]
        };
        this.style = {};
        this.strict = true;
        this.customOptions = [];
        this.onEditorCreated = new core["EventEmitter"]();
        this.onContentChanged = new core["EventEmitter"]();
        this.onSelectionChanged = new core["EventEmitter"]();
        this.onModelChange = function () { };
        this.onModelTouched = function () { };
    }
    QuillEditorComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var toolbarElem = this.elementRef.nativeElement.querySelector('[quill-editor-toolbar]');
        var modules = this.modules || this.defaultModules;
        var placeholder = 'Insert text here ...';
        if (this.placeholder !== null && this.placeholder !== undefined) {
            placeholder = this.placeholder.trim();
        }
        if (toolbarElem) {
            modules['toolbar'] = toolbarElem;
        }
        this.elementRef.nativeElement.insertAdjacentHTML('beforeend', '<div quill-editor-element></div>');
        this.editorElem = this.elementRef.nativeElement.querySelector('[quill-editor-element]');
        if (this.style) {
            Object.keys(this.style).forEach(function (key) {
                _this.renderer.setStyle(_this.editorElem, key, _this.style[key]);
            });
        }
        this.customOptions.forEach(function (customOption) {
            var newCustomOption = Quill.import(customOption.import);
            newCustomOption.whitelist = customOption.whitelist;
            Quill.register(newCustomOption, true);
        });
        this.quillEditor = new Quill(this.editorElem, {
            modules: modules,
            placeholder: placeholder,
            readOnly: this.readOnly || false,
            theme: this.theme || 'snow',
            formats: this.formats,
            bounds: this.bounds || this.doc.body,
            strict: this.strict,
            scrollingContainer: this.scrollingContainer
        });
        if (this.content) {
            var contents = this.quillEditor.clipboard.convert(this.content);
            this.quillEditor.setContents(contents);
            this.quillEditor.history.clear();
        }
        this.onEditorCreated.emit(this.quillEditor);
        // mark model as touched if editor lost focus
        this.quillEditor.on('selection-change', function (range, oldRange, source) {
            _this.onSelectionChanged.emit({
                editor: _this.quillEditor,
                range: range,
                oldRange: oldRange,
                source: source
            });
            if (!range) {
                _this.onModelTouched();
            }
        });
        // update model if text changes
        this.quillEditor.on('text-change', function (delta, oldDelta, source) {
            var html = _this.editorElem.children[0].innerHTML;
            var text = _this.quillEditor.getText();
            if (html === '<p><br></p>') {
                html = null;
            }
            _this.onModelChange(html);
            _this.onContentChanged.emit({
                editor: _this.quillEditor,
                html: html,
                text: text,
                delta: delta,
                oldDelta: oldDelta,
                source: source
            });
        });
    };
    QuillEditorComponent.prototype.ngOnChanges = function (changes) {
        if (changes['readOnly'] && this.quillEditor) {
            this.quillEditor.enable(!changes['readOnly'].currentValue);
        }
    };
    QuillEditorComponent.prototype.writeValue = function (currentValue) {
        this.content = currentValue;
        if (this.quillEditor) {
            if (currentValue) {
                this.quillEditor.setContents(this.quillEditor.clipboard.convert(this.content));
                return;
            }
            this.quillEditor.setText('');
        }
    };
    QuillEditorComponent.prototype.registerOnChange = function (fn) {
        this.onModelChange = fn;
    };
    QuillEditorComponent.prototype.registerOnTouched = function (fn) {
        this.onModelTouched = fn;
    };
    QuillEditorComponent.prototype.validate = function () {
        if (!this.quillEditor) {
            return null;
        }
        var err = {}, valid = true;
        var textLength = this.quillEditor.getText().trim().length;
        if (this.minLength && textLength && textLength < this.minLength) {
            err.minLengthError = {
                given: textLength,
                minLength: this.minLength
            };
            valid = false;
        }
        if (this.maxLength && textLength > this.maxLength) {
            err.maxLengthError = {
                given: textLength,
                maxLength: this.maxLength
            };
            valid = false;
        }
        if (this.required && !textLength) {
            err.requiredError = {
                empty: true
            };
            valid = false;
        }
        return valid ? null : err;
    };
    return QuillEditorComponent;
}());





// CONCATENATED MODULE: ./node_modules/ngx-quill/src/quill-editor.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_quill_editor.component,_angular_platform_browser PURE_IMPORTS_END */




var styles_QuillEditorComponent = [];
var RenderType_QuillEditorComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_QuillEditorComponent, data: {} });

function View_QuillEditorComponent_0(_l) { return core["ɵvid"](0, [core["ɵncd"](null, 0)], null, null); }
function View_QuillEditorComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "quill-editor", [], null, null, null, View_QuillEditorComponent_0, RenderType_QuillEditorComponent)), core["ɵprd"](5120, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [quill_editor_component_QuillEditorComponent]), core["ɵprd"](5120, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [quill_editor_component_QuillEditorComponent]), core["ɵdid"](3, 4767744, null, 0, quill_editor_component_QuillEditorComponent, [core["ElementRef"], platform_browser["b" /* DOCUMENT */], core["Renderer2"]], null, null)], null, null); }
var QuillEditorComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("quill-editor", quill_editor_component_QuillEditorComponent, View_QuillEditorComponent_Host_0, { theme: "theme", modules: "modules", readOnly: "readOnly", placeholder: "placeholder", maxLength: "maxLength", minLength: "minLength", required: "required", formats: "formats", style: "style", strict: "strict", scrollingContainer: "scrollingContainer", bounds: "bounds", customOptions: "customOptions" }, { onEditorCreated: "onEditorCreated", onContentChanged: "onContentChanged", onSelectionChanged: "onSelectionChanged" }, ["[quill-editor-toolbar]"]);



// CONCATENATED MODULE: ./node_modules/ngx-quill/src/quill.module.js


var QuillModule = /*@__PURE__*/ (function () {
    function QuillModule() {
    }
    return QuillModule;
}());





// CONCATENATED MODULE: ./src/app/programManagement/announcements/announcements.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_ngx_translate_core,_angular_forms,_.._.._.._node_modules_ngx_quill_src_quill_editor.component.ngfactory,ngx_quill_src_quill_editor.component,_angular_platform_browser,_announcements,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_sharedData,_.._toasterComponent_toasterComponent,ngx_quill_src_quill.module PURE_IMPORTS_END */
















var styles_Announcements = [];
var RenderType_Announcements = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_Announcements, data: {} });

function View_Announcements_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "col-md-2 mt-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "adminAuuouncement"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "div", [["class", "deleteImg"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.deletepic(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "img", [["class", "img-fluid text-center"]], [[8, "src", 4]], null, null, null, null))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 4, 0, currVal_0); });
}
function View_Announcements_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "row"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Announcements_2)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.allurl; _ck(_v, 2, 0, currVal_0); }, null); }
function View_Announcements_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_Announcements_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 224, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "w-100 float-left v-align relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 194, "div", [["class", "w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 12, "div", [["class", "form-group w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 4, "label", [["for", "f_name"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](13, 0, null, null, 6, "input", [["autocomplete", "off"], ["autofocus", ""], ["class", "form-control w-100"], ["name", "announceTitle"], ["type", "text"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 14)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 14).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 14)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 14)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.announcementData.title = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](14, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](16, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](18, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 162, "div", [["class", "w-100 float-left rich-text-editor mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "label", [["for", "content"]], null, null, null, null, null)), (_l()(), core["ɵted"](22, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 158, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 157, "quill-editor", [], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.announcementData.textContent = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_QuillEditorComponent_0, RenderType_QuillEditorComponent)), core["ɵdid"](26, 4767744, null, 0, quill_editor_component_QuillEditorComponent, [core["ElementRef"], platform_browser["b" /* DOCUMENT */], core["Renderer2"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [quill_editor_component_QuillEditorComponent]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [quill_editor_component_QuillEditorComponent]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, 0, 150, "div", [["quill-editor-toolbar", ""]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 0, "button", [["class", "ql-bold"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 0, "button", [["class", "ql-italic"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 0, "button", [["class", "ql-underline"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "ordered"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](42, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "bullet"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](43, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](44, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "check"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 0, "button", [["class", "ql-header"], ["value", "1"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](47, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](48, 0, null, null, 0, "button", [["class", "ql-header"], ["value", "2"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](49, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 0, "button", [["class", "ql-blockquote"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](52, 0, null, null, 0, "button", [["class", "ql-formula"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](53, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 0, "button", [["class", "ql-link"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](55, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](56, 0, null, null, 0, "button", [["class", "ql-code-block"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 10, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 9, "select", [["class", "ql-font"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 2, "option", [["selected", ""], ["value", "sans serif"]], null, null, null, null, null)), core["ɵdid"](60, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](61, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](62, 0, null, null, 2, "option", [["value", "serif"]], null, null, null, null, null)), core["ɵdid"](63, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](64, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](65, 0, null, null, 2, "option", [["value", "monospace"]], null, null, null, null, null)), core["ɵdid"](66, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](67, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](68, 0, null, null, 43, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](69, 0, null, null, 42, "select", [["class", "ql-color"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 2, "option", [["value", "white"]], null, null, null, null, null)), core["ɵdid"](71, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](72, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](73, 0, null, null, 2, "option", [["value", "black"]], null, null, null, null, null)), core["ɵdid"](74, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](75, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](76, 0, null, null, 2, "option", [["value", "red"]], null, null, null, null, null)), core["ɵdid"](77, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](78, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](79, 0, null, null, 2, "option", [["value", "blue"]], null, null, null, null, null)), core["ɵdid"](80, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](81, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](82, 0, null, null, 2, "option", [["value", "green"]], null, null, null, null, null)), core["ɵdid"](83, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](84, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](85, 0, null, null, 2, "option", [["value", "lightblue"]], null, null, null, null, null)), core["ɵdid"](86, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](87, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](88, 0, null, null, 2, "option", [["value", "orange"]], null, null, null, null, null)), core["ɵdid"](89, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](90, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](91, 0, null, null, 2, "option", [["value", "pink"]], null, null, null, null, null)), core["ɵdid"](92, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](93, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](94, 0, null, null, 2, "option", [["value", "yellow"]], null, null, null, null, null)), core["ɵdid"](95, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](96, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](97, 0, null, null, 2, "option", [["value", "purple"]], null, null, null, null, null)), core["ɵdid"](98, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](99, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](100, 0, null, null, 2, "option", [["value", "grey"]], null, null, null, null, null)), core["ɵdid"](101, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](102, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](103, 0, null, null, 2, "option", [["value", "lightgreen"]], null, null, null, null, null)), core["ɵdid"](104, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](105, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](106, 0, null, null, 2, "option", [["value", "lightyellow"]], null, null, null, null, null)), core["ɵdid"](107, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](108, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](109, 0, null, null, 2, "option", [["value", "magenta"]], null, null, null, null, null)), core["ɵdid"](110, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](111, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](112, 0, null, null, 43, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](113, 0, null, null, 42, "select", [["class", "ql-background"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](114, 0, null, null, 2, "option", [["value", "white"]], null, null, null, null, null)), core["ɵdid"](115, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](116, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](117, 0, null, null, 2, "option", [["value", "black"]], null, null, null, null, null)), core["ɵdid"](118, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](119, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](120, 0, null, null, 2, "option", [["value", "red"]], null, null, null, null, null)), core["ɵdid"](121, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](122, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](123, 0, null, null, 2, "option", [["value", "blue"]], null, null, null, null, null)), core["ɵdid"](124, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](125, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](126, 0, null, null, 2, "option", [["value", "green"]], null, null, null, null, null)), core["ɵdid"](127, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](128, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](129, 0, null, null, 2, "option", [["value", "lightblue"]], null, null, null, null, null)), core["ɵdid"](130, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](131, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](132, 0, null, null, 2, "option", [["value", "orange"]], null, null, null, null, null)), core["ɵdid"](133, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](134, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](135, 0, null, null, 2, "option", [["value", "pink"]], null, null, null, null, null)), core["ɵdid"](136, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](137, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](138, 0, null, null, 2, "option", [["value", "yellow"]], null, null, null, null, null)), core["ɵdid"](139, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](140, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](141, 0, null, null, 2, "option", [["value", "purple"]], null, null, null, null, null)), core["ɵdid"](142, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](143, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](144, 0, null, null, 2, "option", [["value", "grey"]], null, null, null, null, null)), core["ɵdid"](145, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](146, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](147, 0, null, null, 2, "option", [["value", "lightgreen"]], null, null, null, null, null)), core["ɵdid"](148, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](149, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](150, 0, null, null, 2, "option", [["value", "lightyellow"]], null, null, null, null, null)), core["ɵdid"](151, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](152, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](153, 0, null, null, 2, "option", [["value", "magenta"]], null, null, null, null, null)), core["ɵdid"](154, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](155, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](156, 0, null, null, 10, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](157, 0, null, null, 9, "select", [["class", "ql-size"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](158, 0, null, null, 2, "option", [["value", "small"]], null, null, null, null, null)), core["ɵdid"](159, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](160, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](161, 0, null, null, 2, "option", [["value", "large"]], null, null, null, null, null)), core["ɵdid"](162, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](163, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](164, 0, null, null, 2, "option", [["value", "huge"]], null, null, null, null, null)), core["ɵdid"](165, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](166, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](167, 0, null, null, 13, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](168, 0, null, null, 12, "select", [["class", "ql-align"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](169, 0, null, null, 2, "option", [["selected", ""]], null, null, null, null, null)), core["ɵdid"](170, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](171, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵeld"](172, 0, null, null, 2, "option", [["value", "center"]], null, null, null, null, null)), core["ɵdid"](173, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](174, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](175, 0, null, null, 2, "option", [["value", "right"]], null, null, null, null, null)), core["ɵdid"](176, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](177, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](178, 0, null, null, 2, "option", [["value", "justify"]], null, null, null, null, null)), core["ɵdid"](179, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](180, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](181, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](182, 0, null, null, 0, "button", [["class", "ql-strike"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](183, 0, null, null, 8, "div", [["class", "form-group w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](184, 0, null, null, 1, "label", [["for", "f_name"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Video Link"])), (_l()(), core["ɵeld"](186, 0, null, null, 5, "input", [["autocomplete", "off"], ["autosize", ""], ["class", "form-control"], ["id", "announcementVid"], ["name", "announcementVid"], ["placeholder", " "], ["rows", "1"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "blur"], [null, "input"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 187)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 187).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 187)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 187)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.videoLink = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (_co.onBlurMethod(_co.videoLink) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](187, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](189, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](191, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](192, 0, null, null, 5, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](193, 0, null, null, 4, "div", [["class", "w-100 float-left mt-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](194, 0, null, null, 3, "button", [["class", "btn btn-primary relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](195, 0, [["fileInput", 1]], null, 0, "input", [["accept", "image/*"], ["class", "upload-pic"], ["name", "myFile"], ["onclick", "this.value = null"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                _co.fileChange($event);
                var pd_0 = (_co.readUrl($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Attach Images "])), (_l()(), core["ɵeld"](197, 0, null, null, 0, "i", [["class", "fa fa-plus ml-1 text-white"]], null, null, null, null, null)), (_l()(), core["ɵeld"](198, 0, null, null, 2, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Announcements_1)), core["ɵdid"](200, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](201, 0, null, null, 23, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](202, 0, null, null, 8, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](203, 0, null, null, 2, "h6", [["class", "medium mb-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](204, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](206, 0, null, null, 4, "div", [["class", "form-group w-100 float-left mb-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](207, 0, null, null, 0, "input", [["id", "everyone"], ["name", "radio-group"], ["type", "radio"]], [[8, "checked", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onEmployeeSelectionChange(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](208, 0, null, null, 2, "label", [["class", "normal"], ["for", "everyone"]], null, null, null, null, null)), (_l()(), core["ɵted"](209, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](211, 0, null, null, 13, "div", [["class", "btn-group float-right mt-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](212, 0, null, null, 5, "button", [["class", "btn btn-primary"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.validateEmps(1) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](213, 0, null, null, 0, "i", [["class", "fa fa-floppy-o text-white mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](214, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Announcements_3)), core["ɵdid"](217, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](218, 0, null, null, 3, "button", [["class", "btn btn-primary ml-4"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.validateEmps(2) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](219, 0, null, null, 0, "i", [["class", "fa fa-floppy-o text-white mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](220, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](222, 0, null, null, 2, "button", [["class", "btn btn-secondary ml-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](223, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_10 = "announceTitle"; var currVal_11 = _co.announcementData.title; _ck(_v, 16, 0, currVal_10, currVal_11); var currVal_20 = _co.announcementData.textContent; _ck(_v, 29, 0, currVal_20); var currVal_34 = "sans serif"; _ck(_v, 60, 0, currVal_34); var currVal_35 = "sans serif"; _ck(_v, 61, 0, currVal_35); var currVal_36 = "serif"; _ck(_v, 63, 0, currVal_36); var currVal_37 = "serif"; _ck(_v, 64, 0, currVal_37); var currVal_38 = "monospace"; _ck(_v, 66, 0, currVal_38); var currVal_39 = "monospace"; _ck(_v, 67, 0, currVal_39); var currVal_41 = "white"; _ck(_v, 71, 0, currVal_41); var currVal_42 = "white"; _ck(_v, 72, 0, currVal_42); var currVal_43 = "black"; _ck(_v, 74, 0, currVal_43); var currVal_44 = "black"; _ck(_v, 75, 0, currVal_44); var currVal_45 = "red"; _ck(_v, 77, 0, currVal_45); var currVal_46 = "red"; _ck(_v, 78, 0, currVal_46); var currVal_47 = "blue"; _ck(_v, 80, 0, currVal_47); var currVal_48 = "blue"; _ck(_v, 81, 0, currVal_48); var currVal_49 = "green"; _ck(_v, 83, 0, currVal_49); var currVal_50 = "green"; _ck(_v, 84, 0, currVal_50); var currVal_51 = "lightblue"; _ck(_v, 86, 0, currVal_51); var currVal_52 = "lightblue"; _ck(_v, 87, 0, currVal_52); var currVal_53 = "orange"; _ck(_v, 89, 0, currVal_53); var currVal_54 = "orange"; _ck(_v, 90, 0, currVal_54); var currVal_55 = "pink"; _ck(_v, 92, 0, currVal_55); var currVal_56 = "pink"; _ck(_v, 93, 0, currVal_56); var currVal_57 = "yellow"; _ck(_v, 95, 0, currVal_57); var currVal_58 = "yellow"; _ck(_v, 96, 0, currVal_58); var currVal_59 = "purple"; _ck(_v, 98, 0, currVal_59); var currVal_60 = "purple"; _ck(_v, 99, 0, currVal_60); var currVal_61 = "grey"; _ck(_v, 101, 0, currVal_61); var currVal_62 = "grey"; _ck(_v, 102, 0, currVal_62); var currVal_63 = "lightgreen"; _ck(_v, 104, 0, currVal_63); var currVal_64 = "lightgreen"; _ck(_v, 105, 0, currVal_64); var currVal_65 = "lightyellow"; _ck(_v, 107, 0, currVal_65); var currVal_66 = "lightyellow"; _ck(_v, 108, 0, currVal_66); var currVal_67 = "magenta"; _ck(_v, 110, 0, currVal_67); var currVal_68 = "magenta"; _ck(_v, 111, 0, currVal_68); var currVal_70 = "white"; _ck(_v, 115, 0, currVal_70); var currVal_71 = "white"; _ck(_v, 116, 0, currVal_71); var currVal_72 = "black"; _ck(_v, 118, 0, currVal_72); var currVal_73 = "black"; _ck(_v, 119, 0, currVal_73); var currVal_74 = "red"; _ck(_v, 121, 0, currVal_74); var currVal_75 = "red"; _ck(_v, 122, 0, currVal_75); var currVal_76 = "blue"; _ck(_v, 124, 0, currVal_76); var currVal_77 = "blue"; _ck(_v, 125, 0, currVal_77); var currVal_78 = "green"; _ck(_v, 127, 0, currVal_78); var currVal_79 = "green"; _ck(_v, 128, 0, currVal_79); var currVal_80 = "lightblue"; _ck(_v, 130, 0, currVal_80); var currVal_81 = "lightblue"; _ck(_v, 131, 0, currVal_81); var currVal_82 = "orange"; _ck(_v, 133, 0, currVal_82); var currVal_83 = "orange"; _ck(_v, 134, 0, currVal_83); var currVal_84 = "pink"; _ck(_v, 136, 0, currVal_84); var currVal_85 = "pink"; _ck(_v, 137, 0, currVal_85); var currVal_86 = "yellow"; _ck(_v, 139, 0, currVal_86); var currVal_87 = "yellow"; _ck(_v, 140, 0, currVal_87); var currVal_88 = "purple"; _ck(_v, 142, 0, currVal_88); var currVal_89 = "purple"; _ck(_v, 143, 0, currVal_89); var currVal_90 = "grey"; _ck(_v, 145, 0, currVal_90); var currVal_91 = "grey"; _ck(_v, 146, 0, currVal_91); var currVal_92 = "lightgreen"; _ck(_v, 148, 0, currVal_92); var currVal_93 = "lightgreen"; _ck(_v, 149, 0, currVal_93); var currVal_94 = "lightyellow"; _ck(_v, 151, 0, currVal_94); var currVal_95 = "lightyellow"; _ck(_v, 152, 0, currVal_95); var currVal_96 = "magenta"; _ck(_v, 154, 0, currVal_96); var currVal_97 = "magenta"; _ck(_v, 155, 0, currVal_97); var currVal_99 = "small"; _ck(_v, 159, 0, currVal_99); var currVal_100 = "small"; _ck(_v, 160, 0, currVal_100); var currVal_101 = "large"; _ck(_v, 162, 0, currVal_101); var currVal_102 = "large"; _ck(_v, 163, 0, currVal_102); var currVal_103 = "huge"; _ck(_v, 165, 0, currVal_103); var currVal_104 = "huge"; _ck(_v, 166, 0, currVal_104); var currVal_106 = "center"; _ck(_v, 173, 0, currVal_106); var currVal_107 = "center"; _ck(_v, 174, 0, currVal_107); var currVal_108 = "right"; _ck(_v, 176, 0, currVal_108); var currVal_109 = "right"; _ck(_v, 177, 0, currVal_109); var currVal_110 = "justify"; _ck(_v, 179, 0, currVal_110); var currVal_111 = "justify"; _ck(_v, 180, 0, currVal_111); var currVal_120 = "announcementVid"; var currVal_121 = _co.videoLink; _ck(_v, 189, 0, currVal_120, currVal_121); var currVal_122 = (_co.allurl.length > 0); _ck(_v, 200, 0, currVal_122); var currVal_128 = _co.buttonStatus; _ck(_v, 217, 0, currVal_128); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("ANNOUNCEMENT_ADMIN_MODULE")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("title")); _ck(_v, 9, 0, currVal_1); var currVal_2 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 19).transform("enterAnnouncementTitle")), ""); var currVal_3 = core["ɵnov"](_v, 18).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 18).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 18).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 18).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 18).ngClassValid; var currVal_8 = core["ɵnov"](_v, 18).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 18).ngClassPending; _ck(_v, 13, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_12 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("description")); _ck(_v, 22, 0, currVal_12); var currVal_13 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 31).ngClassValid; var currVal_18 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 25, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_21 = "Bold"; _ck(_v, 34, 0, currVal_21); var currVal_22 = "italic"; _ck(_v, 36, 0, currVal_22); var currVal_23 = "Underline"; _ck(_v, 38, 0, currVal_23); var currVal_24 = "list"; _ck(_v, 40, 0, currVal_24); var currVal_25 = "list"; _ck(_v, 42, 0, currVal_25); var currVal_26 = "list"; _ck(_v, 44, 0, currVal_26); var currVal_27 = "header"; _ck(_v, 46, 0, currVal_27); var currVal_28 = "header"; _ck(_v, 48, 0, currVal_28); var currVal_29 = "blockquote"; _ck(_v, 50, 0, currVal_29); var currVal_30 = "formula"; _ck(_v, 52, 0, currVal_30); var currVal_31 = "link"; _ck(_v, 54, 0, currVal_31); var currVal_32 = "code-block"; _ck(_v, 56, 0, currVal_32); var currVal_33 = "font"; _ck(_v, 58, 0, currVal_33); var currVal_40 = "color"; _ck(_v, 69, 0, currVal_40); var currVal_69 = "background"; _ck(_v, 113, 0, currVal_69); var currVal_98 = "font"; _ck(_v, 157, 0, currVal_98); var currVal_105 = "Aligment"; _ck(_v, 168, 0, currVal_105); var currVal_112 = "strike"; _ck(_v, 182, 0, currVal_112); var currVal_113 = core["ɵnov"](_v, 191).ngClassUntouched; var currVal_114 = core["ɵnov"](_v, 191).ngClassTouched; var currVal_115 = core["ɵnov"](_v, 191).ngClassPristine; var currVal_116 = core["ɵnov"](_v, 191).ngClassDirty; var currVal_117 = core["ɵnov"](_v, 191).ngClassValid; var currVal_118 = core["ɵnov"](_v, 191).ngClassInvalid; var currVal_119 = core["ɵnov"](_v, 191).ngClassPending; _ck(_v, 186, 0, currVal_113, currVal_114, currVal_115, currVal_116, currVal_117, currVal_118, currVal_119); var currVal_123 = core["ɵunv"](_v, 204, 0, core["ɵnov"](_v, 205).transform("chooseEmpToAnnounce")); _ck(_v, 204, 0, currVal_123); var currVal_124 = (_co.selectEmployeeOption === 1); _ck(_v, 207, 0, currVal_124); var currVal_125 = core["ɵunv"](_v, 209, 0, core["ɵnov"](_v, 210).transform("includeEveryOne")); _ck(_v, 209, 0, currVal_125); var currVal_126 = _co.buttonStatus; _ck(_v, 212, 0, currVal_126); var currVal_127 = core["ɵunv"](_v, 214, 0, core["ɵnov"](_v, 215).transform("makeAnnouncementNow")); _ck(_v, 214, 0, currVal_127); var currVal_129 = _co.buttonStatus; _ck(_v, 218, 0, currVal_129); var currVal_130 = core["ɵunv"](_v, 220, 0, core["ɵnov"](_v, 221).transform("scheduleAnnouncement")); _ck(_v, 220, 0, currVal_130); var currVal_131 = core["ɵunv"](_v, 223, 0, core["ɵnov"](_v, 224).transform("clear")); _ck(_v, 223, 0, currVal_131); });
}
function View_Announcements_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "Announcements", [], null, null, null, View_Announcements_0, RenderType_Announcements)), core["ɵdid"](1, 49152, null, 0, announcements_Announcements, [fesm5_router["a" /* ActivatedRoute */], NgbModal, NgbActiveModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, SharedData, common["Location"], core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], QuillModule], null, null)], null, null); }
var AnnouncementsNgFactory = /*@__PURE__*/ core["ɵccf"]("Announcements", announcements_Announcements, View_Announcements_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bulkUpload/bulkUpload.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_ngx_translate_core,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_bulkUpload,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_toasterComponent_toasterComponent,_shared_services_http.client,_shared_services_configuration,_shared_sharedData PURE_IMPORTS_END */
















var styles_BulkUploadComponent = [];
var RenderType_BulkUploadComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_BulkUploadComponent, data: {} });

function View_BulkUploadComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "select", [["class", "form-control w-25 float-left ml-3"], ["id", "excelTypeSelect"], ["name", "fileType"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.onFileTypeChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "option", [], null, null, null, null, null)), core["ɵdid"](2, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](3, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 4, "option", [], null, null, null, null, null)), core["ɵdid"](7, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](8, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](9, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("xlsx")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("xls")); _ck(_v, 9, 0, currVal_1); });
}
function View_BulkUploadComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["class", "mb-0 ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.fileNameToUpload; _ck(_v, 1, 0, currVal_0); }); }
function View_BulkUploadComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "exampleSelect1"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 6, "textarea", [["class", "form-control w-25 ml-3"], ["name", "bulkUploadComments"], ["rows", "2"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 6)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.comments = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](6, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](12, 0, null, null, 4, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 0, "label", [["class", "medium col-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "button", [["class", "btn btn-primary ml-3"], ["name", "uploadFiles"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.uploadFile(_co.selectedProcess) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](15, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = "bulkUploadComments"; var currVal_10 = _co.comments; _ck(_v, 8, 0, currVal_9, currVal_10); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("comments")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 11).transform("enterComments")), ""); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 5, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_11 = _co.uploadButtonDisable; _ck(_v, 14, 0, currVal_11); var currVal_12 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("upload")); _ck(_v, 15, 0, currVal_12); });
}
function View_BulkUploadComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 24, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "excelTypeSelect"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_2)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 4, "a", [["class", "btn float-left ml-3"], ["href", "javascript:void(0)"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadTemplate(_co.selectedProcess) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](8, null, [" ", " '", "' ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](12, 0, null, null, 10, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "excelTypeSelect"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](16, 0, null, null, 4, "div", [["class", "relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 0, "input", [["accept", ".xlsx,.xls,.XLSX,.XLS"], ["class", "fileInput"], ["name", "browseFile"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.chooseFile($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 2, "button", [["class", "btn btn-primary ml-3"], ["name", "browseFileBtn"]], null, null, null, null, null)), (_l()(), core["ɵted"](19, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_3)), core["ɵdid"](22, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_4)), core["ɵdid"](24, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_1 = (_co.selectedProcess != "Select"); _ck(_v, 6, 0, currVal_1); var currVal_7 = (_co.fileNameToUpload != null); _ck(_v, 22, 0, currVal_7); var currVal_8 = (_co.fileNameToUpload != null); _ck(_v, 24, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("excelFileType")); _ck(_v, 3, 0, currVal_0); var currVal_2 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("download")); var currVal_3 = core["ɵunv"](_v, 8, 1, core["ɵnov"](_v, 10).transform(_co.selectedProcess)); var currVal_4 = core["ɵunv"](_v, 8, 2, core["ɵnov"](_v, 11).transform("template")); _ck(_v, 8, 0, currVal_2, currVal_3, currVal_4); var currVal_5 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("selectFile")); _ck(_v, 14, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 19, 0, core["ɵnov"](_v, 20).transform("browse")); _ck(_v, 19, 0, currVal_6); });
}
function View_BulkUploadComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "h6", [["class", "mb-0 text-truncate"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.parent.context.$implicit.referenceName, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.parent.context.$implicit.referenceName; _ck(_v, 2, 0, currVal_1); }); }
function View_BulkUploadComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 2, "h6", [["class", "mb-0 text-truncate"]], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.parent.parent.context.$implicit.referenceName, ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var currVal_1 = _v.parent.parent.context.$implicit.referenceName; _ck(_v, 2, 0, currVal_1); }); }
function View_BulkUploadComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_7)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_8)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = (_v.parent.context.$implicit.referenceName.length < 15); _ck(_v, 2, 0, currVal_0); var currVal_1 = (_v.parent.context.$implicit.referenceName.length >= 15); _ck(_v, 4, 0, currVal_1); }, null); }
function View_BulkUploadComponent_9(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 4, "a", [["class", "mb-0 small"], ["href", "#/menu/bulkupload"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadValidationFile(_v.parent.context.$implicit.attachedFiles[0].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](3, null, ["", ".", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("clickToDownload")), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.parent.context.$implicit.attachedFiles[0].fileType)); var currVal_2 = _co.getExtension(_v.parent.context.$implicit.attachedFiles[0].name); _ck(_v, 3, 0, currVal_1, currVal_2); });
}
function View_BulkUploadComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 4, "a", [["class", "mb-0 small"], ["href", "#/menu/bulkupload"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.downloadValidationFile(_v.parent.context.$implicit.attachedFiles[1].filePath) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](3, null, ["", ".", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("clickToDownload")), ""); _ck(_v, 1, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.parent.context.$implicit.attachedFiles[1].fileType)); var currVal_2 = _co.getExtension(_v.parent.context.$implicit.attachedFiles[1].name); _ck(_v, 3, 0, currVal_1, currVal_2); });
}
function View_BulkUploadComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 27, "div", [["class", "w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 4, "h6", [["class", "mb-0 text-truncate"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](5, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_6)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](14, null, ["", ""])), (_l()(), core["ɵeld"](15, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](21, null, ["", ""])), (_l()(), core["ɵeld"](22, 0, null, null, 5, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_9)), core["ɵdid"](24, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](25, 0, null, null, 0, "br", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_10)), core["ɵdid"](27, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.context.$implicit.uploadProcessType)), ""); _ck(_v, 3, 0, currVal_0); var currVal_3 = (_v.context.$implicit.referenceName != null); _ck(_v, 11, 0, currVal_3); var currVal_7 = (_v.context.$implicit.attachedFiles.length > 0); _ck(_v, 24, 0, currVal_7); var currVal_8 = (_v.context.$implicit.attachedFiles.length > 1); _ck(_v, 27, 0, currVal_8); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform(_v.context.$implicit.uploadProcessType)); _ck(_v, 5, 0, currVal_1); var currVal_2 = _v.context.$implicit.comment; _ck(_v, 9, 0, currVal_2); var currVal_4 = _co.getDateFormat(_v.context.$implicit.startDate); _ck(_v, 14, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform(_v.context.$implicit.state)); _ck(_v, 17, 0, currVal_5); var currVal_6 = _v.context.$implicit.failureReason; _ck(_v, 21, 0, currVal_6); }); }
function View_BulkUploadComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 3, "button", [["class", "btn btn-secondary"], ["name", "bulkUploadBack"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goToBackPage() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-sm-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 53, "div", [["class", "w-100 float-left mb-4 b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 5, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "exampleSelect1"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](15, 0, null, null, 1, "span", [["class", " ml-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, ["", ""])), (_l()(), core["ɵeld"](17, 0, null, null, 44, "div", [["class", "form-group w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 2, "label", [["class", "medium col-2"], ["for", "exampleSelect1"]], null, null, null, null, null)), (_l()(), core["ɵted"](19, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](21, 0, null, null, 40, "select", [["class", "form-control w-25 ml-3"], ["id", "exampleSelect1"], ["name", "selectProcess"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.selectedProcess = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_3 = (_co.onProcessChange() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](24, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](26, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](27, 0, null, null, 4, "option", [["value", "Select"]], null, null, null, null, null)), core["ɵdid"](28, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](29, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](30, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](32, 0, null, null, 4, "option", [["value", "scoreUpload"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](35, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](37, 0, null, null, 4, "option", [["value", "kpiUpload"]], null, null, null, null, null)), core["ɵdid"](38, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](39, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](40, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](42, 0, null, null, 4, "option", [["value", "approversUpload"]], null, null, null, null, null)), core["ɵdid"](43, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](44, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](45, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](47, 0, null, null, 4, "option", [["value", "bulkPublish"]], null, null, null, null, null)), core["ɵdid"](48, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](49, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](50, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](52, 0, null, null, 4, "option", [["value", "bulkRuleUpload"]], null, null, null, null, null)), core["ɵdid"](53, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](54, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](55, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](57, 0, null, null, 4, "option", [["value", "bulkKpiDelete"]], null, null, null, null, null)), core["ɵdid"](58, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](59, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](60, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_1)), core["ɵdid"](63, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](64, 0, null, null, 71, "div", [["class", "w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](65, 0, null, null, 8, "div", [["class", "w-100 float-left align-v-center mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](66, 0, null, null, 2, "h6", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](67, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](69, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 3, "button", [["class", "btn btn-primary float-right"], ["name", "refreshGrid"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.getAll() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 0, "i", [["class", "fa fa-refresh mr-2 text-white"]], null, null, null, null, null)), (_l()(), core["ɵted"](72, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](74, 0, null, null, 32, "div", [["class", "col-lg-12 col-md-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](75, 0, null, null, 28, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](76, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](77, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](78, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](80, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](81, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](82, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](84, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](85, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](86, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](88, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](89, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](90, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](92, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](93, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](94, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](96, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](97, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](98, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](100, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](101, 0, null, null, 2, "h6", [["class", "mb-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](102, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](104, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_BulkUploadComponent_5)), core["ɵdid"](106, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](107, 0, null, null, 28, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](108, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](109, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](111, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](112, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](113, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](115, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "UploadedItemsPerPage"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 116).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 116).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](116, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](118, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](120, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](121, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](122, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](123, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](125, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](126, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](127, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](129, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](130, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](131, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](133, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](134, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](135, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_12 = "selectProcess"; var currVal_13 = _co.selectedProcess; _ck(_v, 24, 0, currVal_12, currVal_13); var currVal_14 = "Select"; _ck(_v, 28, 0, currVal_14); var currVal_15 = "Select"; _ck(_v, 29, 0, currVal_15); var currVal_17 = "scoreUpload"; _ck(_v, 33, 0, currVal_17); var currVal_18 = "scoreUpload"; _ck(_v, 34, 0, currVal_18); var currVal_20 = "kpiUpload"; _ck(_v, 38, 0, currVal_20); var currVal_21 = "kpiUpload"; _ck(_v, 39, 0, currVal_21); var currVal_23 = "approversUpload"; _ck(_v, 43, 0, currVal_23); var currVal_24 = "approversUpload"; _ck(_v, 44, 0, currVal_24); var currVal_26 = "bulkPublish"; _ck(_v, 48, 0, currVal_26); var currVal_27 = "bulkPublish"; _ck(_v, 49, 0, currVal_27); var currVal_29 = "bulkRuleUpload"; _ck(_v, 53, 0, currVal_29); var currVal_30 = "bulkRuleUpload"; _ck(_v, 54, 0, currVal_30); var currVal_32 = "bulkKpiDelete"; _ck(_v, 58, 0, currVal_32); var currVal_33 = "bulkKpiDelete"; _ck(_v, 59, 0, currVal_33); var currVal_35 = (_co.selectedProcess != "Select"); _ck(_v, 63, 0, currVal_35); var currVal_45 = _co.allData; _ck(_v, 106, 0, currVal_45); var currVal_58 = "UploadedItemsPerPage"; var currVal_59 = _co.pageSize; _ck(_v, 118, 0, currVal_58, currVal_59); var currVal_60 = "10"; _ck(_v, 122, 0, currVal_60); var currVal_61 = "10"; _ck(_v, 123, 0, currVal_61); var currVal_62 = "20"; _ck(_v, 126, 0, currVal_62); var currVal_63 = "20"; _ck(_v, 127, 0, currVal_63); var currVal_64 = "30"; _ck(_v, 130, 0, currVal_64); var currVal_65 = "30"; _ck(_v, 131, 0, currVal_65); var currVal_66 = true; var currVal_67 = false; var currVal_68 = true; var currVal_69 = _co.collectionSize; var currVal_70 = 5; var currVal_71 = _co.page; var currVal_72 = _co.pageSize; _ck(_v, 135, 0, currVal_66, currVal_67, currVal_68, currVal_69, currVal_70, currVal_71, currVal_72); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("uploadBulk")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("back")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("programName")); _ck(_v, 13, 0, currVal_2); var currVal_3 = _co.programName; _ck(_v, 16, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 19, 0, core["ɵnov"](_v, 20).transform("chooseProcess")); _ck(_v, 19, 0, currVal_4); var currVal_5 = core["ɵnov"](_v, 26).ngClassUntouched; var currVal_6 = core["ɵnov"](_v, 26).ngClassTouched; var currVal_7 = core["ɵnov"](_v, 26).ngClassPristine; var currVal_8 = core["ɵnov"](_v, 26).ngClassDirty; var currVal_9 = core["ɵnov"](_v, 26).ngClassValid; var currVal_10 = core["ɵnov"](_v, 26).ngClassInvalid; var currVal_11 = core["ɵnov"](_v, 26).ngClassPending; _ck(_v, 21, 0, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10, currVal_11); var currVal_16 = core["ɵunv"](_v, 30, 0, core["ɵnov"](_v, 31).transform("select")); _ck(_v, 30, 0, currVal_16); var currVal_19 = core["ɵunv"](_v, 35, 0, core["ɵnov"](_v, 36).transform("scoreUpload")); _ck(_v, 35, 0, currVal_19); var currVal_22 = core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 41).transform("kpiUpload")); _ck(_v, 40, 0, currVal_22); var currVal_25 = core["ɵunv"](_v, 45, 0, core["ɵnov"](_v, 46).transform("approversUpload")); _ck(_v, 45, 0, currVal_25); var currVal_28 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("bulkPublish")); _ck(_v, 50, 0, currVal_28); var currVal_31 = core["ɵunv"](_v, 55, 0, core["ɵnov"](_v, 56).transform("bulkRuleUpload")); _ck(_v, 55, 0, currVal_31); var currVal_34 = core["ɵunv"](_v, 60, 0, core["ɵnov"](_v, 61).transform("bulkKpiDelete")); _ck(_v, 60, 0, currVal_34); var currVal_36 = core["ɵunv"](_v, 67, 0, core["ɵnov"](_v, 68).transform("processGrid")); _ck(_v, 67, 0, currVal_36); var currVal_37 = core["ɵunv"](_v, 72, 0, core["ɵnov"](_v, 73).transform("refreshGrid")); _ck(_v, 72, 0, currVal_37); var currVal_38 = core["ɵunv"](_v, 78, 0, core["ɵnov"](_v, 79).transform("uploadProcess")); _ck(_v, 78, 0, currVal_38); var currVal_39 = core["ɵunv"](_v, 82, 0, core["ɵnov"](_v, 83).transform("title")); _ck(_v, 82, 0, currVal_39); var currVal_40 = core["ɵunv"](_v, 86, 0, core["ɵnov"](_v, 87).transform("programName")); _ck(_v, 86, 0, currVal_40); var currVal_41 = core["ɵunv"](_v, 90, 0, core["ɵnov"](_v, 91).transform("startDate")); _ck(_v, 90, 0, currVal_41); var currVal_42 = core["ɵunv"](_v, 94, 0, core["ɵnov"](_v, 95).transform("status")); _ck(_v, 94, 0, currVal_42); var currVal_43 = core["ɵunv"](_v, 98, 0, core["ɵnov"](_v, 99).transform("failureReason")); _ck(_v, 98, 0, currVal_43); var currVal_44 = core["ɵunv"](_v, 102, 0, core["ɵnov"](_v, 103).transform("attachFiles")); _ck(_v, 102, 0, currVal_44); var currVal_46 = (((_co.page - 1) * _co.pageSize) + 1); var currVal_47 = ((_co.pageSize * (_co.page - 1)) + _co.allPageData.numberOfElements); var currVal_48 = core["ɵunv"](_v, 109, 2, core["ɵnov"](_v, 110).transform("itemsOf")); var currVal_49 = _co.allPageData.totalElements; _ck(_v, 109, 0, currVal_46, currVal_47, currVal_48, currVal_49); var currVal_50 = core["ɵunv"](_v, 113, 0, core["ɵnov"](_v, 114).transform("showItemsPerPage")); _ck(_v, 113, 0, currVal_50); var currVal_51 = core["ɵnov"](_v, 120).ngClassUntouched; var currVal_52 = core["ɵnov"](_v, 120).ngClassTouched; var currVal_53 = core["ɵnov"](_v, 120).ngClassPristine; var currVal_54 = core["ɵnov"](_v, 120).ngClassDirty; var currVal_55 = core["ɵnov"](_v, 120).ngClassValid; var currVal_56 = core["ɵnov"](_v, 120).ngClassInvalid; var currVal_57 = core["ɵnov"](_v, 120).ngClassPending; _ck(_v, 115, 0, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57); });
}
function View_BulkUploadComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "bulk-upload", [], null, null, null, View_BulkUploadComponent_0, RenderType_BulkUploadComponent)), core["ɵdid"](1, 49152, null, 0, bulkUpload_BulkUploadComponent, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, common["Location"], ToasterComponent, core["ViewContainerRef"], http_client_HttpClientCustom, Configuration, core_es5["j" /* TranslateService */], SharedData], null, null)], null, null); }
var BulkUploadComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("bulk-upload", bulkUpload_BulkUploadComponent, View_BulkUploadComponent_Host_0, {}, {}, []);



// EXTERNAL MODULE: ./node_modules/ngx-color-picker/dist/lib/color-picker.directive.js
var color_picker_directive = __webpack_require__("M96w");
var color_picker_directive_default = /*#__PURE__*/__webpack_require__.n(color_picker_directive);

// EXTERNAL MODULE: ./node_modules/ngx-color-picker/dist/lib/color-picker.service.js
var color_picker_service = __webpack_require__("RlMM");
var color_picker_service_default = /*#__PURE__*/__webpack_require__.n(color_picker_service);

// CONCATENATED MODULE: ./src/app/tools/tenantPreference.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,ngx_color_picker_dist_lib_color_picker.directive,ngx_color_picker_dist_lib_color_picker.service,_angular_common,_tenantPreference,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_toasterComponent_toasterComponent,_shared_services_http.client,_shared_services_configuration,_shared_sharedData,_shared_services_auth PURE_IMPORTS_END */














var styles_TenantPreferenceComponent = [];
var RenderType_TenantPreferenceComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_TenantPreferenceComponent, data: {} });

function View_TenantPreferenceComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Upload BI logo:"]))], null, null); }
function View_TenantPreferenceComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, [["fileInput", 1]], null, 0, "input", [["accept", ".jpg,.png,.svg,.svgz"], ["class", "form-control"], ["name", "pic"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.BIFileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 4, "div", [["class", "align-v-center justify-content-end"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "small", [["class", "text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Resolution: 160*40px; "])), (_l()(), core["ɵeld"](6, 0, null, null, 1, "small", [["class", "ml-2 text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["size limit: 5mb"]))], null, null);
}
function View_TenantPreferenceComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 56, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 10, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Upload Tenant Login logo:"])), (_l()(), core["ɵeld"](5, 0, null, null, 7, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 6, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, [["fileInput", 1]], null, 0, "input", [["accept", ".jpg,.png,.svg,.svgz"], ["class", "form-control"], ["name", "pic"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.logoFileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 4, "div", [["class", "align-v-center justify-content-end"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "small", [["class", "text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Resolution: 180*60px; "])), (_l()(), core["ɵeld"](11, 0, null, null, 1, "small", [["class", "ml-2 text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["size limit: 5mb"])), (_l()(), core["ɵeld"](13, 0, null, null, 43, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 42, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](18, 0, null, null, 26, "select", [["class", "form-control w-100"], ["name", "tenantFont"], ["ngDefaultControl", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 20).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (core["ɵnov"](_v, 20).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_6 = ((_co.tenantFont = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](22, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](24, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](25, 0, null, null, 4, "option", [["value", "null"]], null, null, null, null, null)), core["ɵdid"](26, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](27, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](28, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 4, "option", [["value", "Avenir-Regular"]], null, null, null, null, null)), core["ɵdid"](31, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](32, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](33, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](35, 0, null, null, 4, "option", [["value", "GothamBookRegular"]], null, null, null, null, null)), core["ɵdid"](36, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](37, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](38, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](40, 0, null, null, 4, "option", [["value", "Heavent"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](43, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](45, 0, null, null, 11, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 2, "label", [["class", "mr-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](47, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](49, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 5, "input", [["id", "id_ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM"], ["name", "id_ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 51).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 51).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.enableAverageOption = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](51, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](53, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](55, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](56, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id_ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_8 = "tenantFont"; var currVal_9 = _co.tenantFont; _ck(_v, 22, 0, currVal_8, currVal_9); var currVal_10 = "null"; _ck(_v, 26, 0, currVal_10); var currVal_11 = "null"; _ck(_v, 27, 0, currVal_11); var currVal_13 = "Avenir-Regular"; _ck(_v, 31, 0, currVal_13); var currVal_14 = "Avenir-Regular"; _ck(_v, 32, 0, currVal_14); var currVal_16 = "GothamBookRegular"; _ck(_v, 36, 0, currVal_16); var currVal_17 = "GothamBookRegular"; _ck(_v, 37, 0, currVal_17); var currVal_19 = "Heavent"; _ck(_v, 41, 0, currVal_19); var currVal_20 = "Heavent"; _ck(_v, 42, 0, currVal_20); var currVal_30 = "id_ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM"; var currVal_31 = _co.enableAverageOption; _ck(_v, 53, 0, currVal_30, currVal_31); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 17).transform("font")); _ck(_v, 16, 0, currVal_0); var currVal_1 = core["ɵnov"](_v, 24).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 24).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 24).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 24).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 24).ngClassValid; var currVal_6 = core["ɵnov"](_v, 24).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 24).ngClassPending; _ck(_v, 18, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_12 = core["ɵunv"](_v, 28, 0, core["ɵnov"](_v, 29).transform("select")); _ck(_v, 28, 0, currVal_12); var currVal_15 = core["ɵunv"](_v, 33, 0, core["ɵnov"](_v, 34).transform("Avenir")); _ck(_v, 33, 0, currVal_15); var currVal_18 = core["ɵunv"](_v, 38, 0, core["ɵnov"](_v, 39).transform("Gotham Book")); _ck(_v, 38, 0, currVal_18); var currVal_21 = core["ɵunv"](_v, 43, 0, core["ɵnov"](_v, 44).transform("Heavent")); _ck(_v, 43, 0, currVal_21); var currVal_22 = core["ɵunv"](_v, 47, 0, core["ɵnov"](_v, 48).transform("ENABLE_AVERAGE_OPTION_FOR_YTD_PROGRAM")); _ck(_v, 47, 0, currVal_22); var currVal_23 = core["ɵnov"](_v, 55).ngClassUntouched; var currVal_24 = core["ɵnov"](_v, 55).ngClassTouched; var currVal_25 = core["ɵnov"](_v, 55).ngClassPristine; var currVal_26 = core["ɵnov"](_v, 55).ngClassDirty; var currVal_27 = core["ɵnov"](_v, 55).ngClassValid; var currVal_28 = core["ɵnov"](_v, 55).ngClassInvalid; var currVal_29 = core["ɵnov"](_v, 55).ngClassPending; _ck(_v, 50, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29); });
}
function View_TenantPreferenceComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 35, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 10, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Upload Tenant Loader:"])), (_l()(), core["ɵeld"](5, 0, null, null, 7, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 6, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, [["fileInput", 1]], null, 0, "input", [["accept", ".gif"], ["class", "form-control"], ["name", "pic"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.loaderFileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 4, "div", [["class", "align-v-center justify-content-end"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "small", [["class", "text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Only gif image: "])), (_l()(), core["ɵeld"](11, 0, null, null, 1, "small", [["class", "ml-2 text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["size limit: 5mb"])), (_l()(), core["ɵeld"](13, 0, null, null, 22, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 21, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Analytics Token:"])), (_l()(), core["ɵeld"](17, 0, null, null, 18, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 17, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 5, "input", [["class", "form-control"], ["name", "token"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 20)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 20).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 20)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 20)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.analyticsToken = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](20, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](22, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](24, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](25, 0, null, null, 10, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "label", [["class", "mr-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Enable Analytics:"])), (_l()(), core["ɵeld"](28, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 5, "input", [["id", "id_ENABLE_ANALYTICS"], ["name", "id_ENABLE_ANALYTICS"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 30).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 30).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.enableAnalytics = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](30, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](32, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](34, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](35, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id_ENABLE_ANALYTICS"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_7 = "token"; var currVal_8 = _co.analyticsToken; _ck(_v, 22, 0, currVal_7, currVal_8); var currVal_16 = "id_ENABLE_ANALYTICS"; var currVal_17 = _co.enableAnalytics; _ck(_v, 32, 0, currVal_16, currVal_17); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 24).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 24).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 24).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 24).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 24).ngClassValid; var currVal_5 = core["ɵnov"](_v, 24).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 24).ngClassPending; _ck(_v, 19, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_9 = core["ɵnov"](_v, 34).ngClassUntouched; var currVal_10 = core["ɵnov"](_v, 34).ngClassTouched; var currVal_11 = core["ɵnov"](_v, 34).ngClassPristine; var currVal_12 = core["ɵnov"](_v, 34).ngClassDirty; var currVal_13 = core["ɵnov"](_v, 34).ngClassValid; var currVal_14 = core["ɵnov"](_v, 34).ngClassInvalid; var currVal_15 = core["ɵnov"](_v, 34).ngClassPending; _ck(_v, 29, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15); });
}
function View_TenantPreferenceComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 11, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Theme Settings"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 5, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Primary Color:"])), (_l()(), core["ɵeld"](10, 16777216, null, null, 1, "input", [], [[4, "background", null]], [[null, "colorPickerChange"], [null, "click"], [null, "focus"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 11).inputFocus() !== false);
                ad = (pd_0 && ad);
            }
            if (("focus" === en)) {
                var pd_1 = (core["ɵnov"](_v, 11).inputFocus() !== false);
                ad = (pd_1 && ad);
            }
            if (("input" === en)) {
                var pd_2 = (core["ɵnov"](_v, 11).inputChange($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            if (("colorPickerChange" === en)) {
                var pd_3 = ((_co.primaryColor = $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](11, 737280, null, 0, color_picker_directive["ColorPickerDirective"], [core["Injector"], core["ComponentFactoryResolver"], core["ApplicationRef"], core["ViewContainerRef"], core["ElementRef"], color_picker_service["ColorPickerService"]], { colorPicker: [0, "colorPicker"], cpOutputFormat: [1, "cpOutputFormat"], cpAlphaChannel: [2, "cpAlphaChannel"] }, { colorPickerChange: "colorPickerChange" })], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.primaryColor; var currVal_2 = "rgba"; var currVal_3 = "disabled"; _ck(_v, 11, 0, currVal_1, currVal_2, currVal_3); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.primaryColor; _ck(_v, 10, 0, currVal_0); });
}
function View_TenantPreferenceComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 683, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 304, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](12, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 186, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 18, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](22, 0, null, null, 11, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 7, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 6, "input", [["class", "form-control"], ["min", "0"], ["name", "displayPref"], ["onkeypress", "return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 25)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 25).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 25)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 25)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 26).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 26).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 26).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.displayPreferences = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](25, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](26, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](28, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](30, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](31, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 1, "p", [["class", "m-0 text-danger text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](33, null, ["", ""])), (_l()(), core["ɵeld"](34, 0, null, null, 136, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](36, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](38, 0, null, null, 132, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 131, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 130, "select", [["class", "form-control w-100"], ["name", "monthStartDay"], ["ngDefaultControl", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 41)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 41)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 42).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (core["ɵnov"](_v, 42).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_6 = ((_co.monthStartDay = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](42, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](44, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](46, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](47, 0, null, null, 3, "option", [["value", "1"]], null, null, null, null, null)), core["ɵdid"](48, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](49, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["1"])), (_l()(), core["ɵeld"](51, 0, null, null, 3, "option", [["value", "2"]], null, null, null, null, null)), core["ɵdid"](52, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](53, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["2"])), (_l()(), core["ɵeld"](55, 0, null, null, 3, "option", [["value", "3"]], null, null, null, null, null)), core["ɵdid"](56, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](57, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["3"])), (_l()(), core["ɵeld"](59, 0, null, null, 3, "option", [["value", "4"]], null, null, null, null, null)), core["ɵdid"](60, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](61, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["4"])), (_l()(), core["ɵeld"](63, 0, null, null, 3, "option", [["value", "5"]], null, null, null, null, null)), core["ɵdid"](64, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](65, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["5"])), (_l()(), core["ɵeld"](67, 0, null, null, 3, "option", [["value", "6"]], null, null, null, null, null)), core["ɵdid"](68, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](69, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["6"])), (_l()(), core["ɵeld"](71, 0, null, null, 3, "option", [["value", "7"]], null, null, null, null, null)), core["ɵdid"](72, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](73, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["7"])), (_l()(), core["ɵeld"](75, 0, null, null, 3, "option", [["value", "8"]], null, null, null, null, null)), core["ɵdid"](76, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](77, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["8"])), (_l()(), core["ɵeld"](79, 0, null, null, 3, "option", [["value", "9"]], null, null, null, null, null)), core["ɵdid"](80, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](81, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["9"])), (_l()(), core["ɵeld"](83, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](84, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](85, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](87, 0, null, null, 3, "option", [["value", "11"]], null, null, null, null, null)), core["ɵdid"](88, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](89, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["11"])), (_l()(), core["ɵeld"](91, 0, null, null, 3, "option", [["value", "12"]], null, null, null, null, null)), core["ɵdid"](92, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](93, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["12"])), (_l()(), core["ɵeld"](95, 0, null, null, 3, "option", [["value", "13"]], null, null, null, null, null)), core["ɵdid"](96, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](97, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["13"])), (_l()(), core["ɵeld"](99, 0, null, null, 3, "option", [["value", "14"]], null, null, null, null, null)), core["ɵdid"](100, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](101, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["14"])), (_l()(), core["ɵeld"](103, 0, null, null, 3, "option", [["value", "15"]], null, null, null, null, null)), core["ɵdid"](104, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](105, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["15"])), (_l()(), core["ɵeld"](107, 0, null, null, 3, "option", [["value", "16"]], null, null, null, null, null)), core["ɵdid"](108, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](109, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["16"])), (_l()(), core["ɵeld"](111, 0, null, null, 3, "option", [["value", "17"]], null, null, null, null, null)), core["ɵdid"](112, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](113, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["17"])), (_l()(), core["ɵeld"](115, 0, null, null, 3, "option", [["value", "18"]], null, null, null, null, null)), core["ɵdid"](116, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](117, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["18"])), (_l()(), core["ɵeld"](119, 0, null, null, 3, "option", [["value", "19"]], null, null, null, null, null)), core["ɵdid"](120, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](121, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["19"])), (_l()(), core["ɵeld"](123, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](124, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](125, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](127, 0, null, null, 3, "option", [["value", "21"]], null, null, null, null, null)), core["ɵdid"](128, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](129, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["21"])), (_l()(), core["ɵeld"](131, 0, null, null, 3, "option", [["value", "22"]], null, null, null, null, null)), core["ɵdid"](132, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](133, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["22"])), (_l()(), core["ɵeld"](135, 0, null, null, 3, "option", [["value", "23"]], null, null, null, null, null)), core["ɵdid"](136, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](137, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["23"])), (_l()(), core["ɵeld"](139, 0, null, null, 3, "option", [["value", "24"]], null, null, null, null, null)), core["ɵdid"](140, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](141, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["24"])), (_l()(), core["ɵeld"](143, 0, null, null, 3, "option", [["value", "25"]], null, null, null, null, null)), core["ɵdid"](144, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](145, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["25"])), (_l()(), core["ɵeld"](147, 0, null, null, 3, "option", [["value", "26"]], null, null, null, null, null)), core["ɵdid"](148, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](149, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["26"])), (_l()(), core["ɵeld"](151, 0, null, null, 3, "option", [["value", "27"]], null, null, null, null, null)), core["ɵdid"](152, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](153, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["27"])), (_l()(), core["ɵeld"](155, 0, null, null, 3, "option", [["value", "28"]], null, null, null, null, null)), core["ɵdid"](156, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](157, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["28"])), (_l()(), core["ɵeld"](159, 0, null, null, 3, "option", [["value", "29"]], null, null, null, null, null)), core["ɵdid"](160, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](161, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["29"])), (_l()(), core["ɵeld"](163, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](164, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](165, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](167, 0, null, null, 3, "option", [["value", "31"]], null, null, null, null, null)), core["ɵdid"](168, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](169, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["31"])), (_l()(), core["ɵeld"](171, 0, null, null, 11, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](172, 0, null, null, 5, "label", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](173, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](175, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](178, 0, null, null, 4, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](179, 0, null, null, 0, "input", [["id", "id_all"], ["name", "allow"], ["type", "checkbox"]], [[8, "checked", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.allowPicture($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](180, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id_all"]], null, null, null, null, null)), (_l()(), core["ɵted"](181, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](183, 0, null, null, 8, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](184, 0, null, null, 2, "label", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](185, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](187, 0, null, null, 4, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](188, 0, null, null, 0, "input", [["id", "id_thingstodo"], ["name", "allow"], ["type", "checkbox"]], [[8, "checked", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.disableTodo($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](189, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id_thingstodo"]], null, null, null, null, null)), (_l()(), core["ɵted"](190, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](192, 0, null, null, 8, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](193, 0, null, null, 2, "label", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](194, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](196, 0, null, null, 4, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](197, 0, null, null, 0, "input", [["id", "PUSH_KPI_OPTION_ENABLED_ID"], ["name", "PUSH_KPI_OPTION_ENABLED_ID"], ["type", "checkbox"]], [[8, "checked", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.updatePushKpiOption($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](198, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "PUSH_KPI_OPTION_ENABLED_ID"]], null, null, null, null, null)), (_l()(), core["ɵted"](199, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](201, 0, null, null, 110, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](202, 0, null, null, 45, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](203, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](204, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](206, 0, null, null, 41, "select", [["class", "form-control w-100"], ["name", "weekStartDay"], ["ngDefaultControl", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 207)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 207).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 207)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 207)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 208).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (core["ɵnov"](_v, 208).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_6 = ((_co.weekStartDay = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](207, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](208, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](210, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](212, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](213, 0, null, null, 4, "option", [["value", "Sunday"]], null, null, null, null, null)), core["ɵdid"](214, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](215, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](216, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](218, 0, null, null, 4, "option", [["value", "Monday"]], null, null, null, null, null)), core["ɵdid"](219, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](220, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](221, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](223, 0, null, null, 4, "option", [["value", "Tuesday"]], null, null, null, null, null)), core["ɵdid"](224, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](225, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](226, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](228, 0, null, null, 4, "option", [["value", "Wednesday"]], null, null, null, null, null)), core["ɵdid"](229, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](230, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](231, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](233, 0, null, null, 4, "option", [["value", "Thursday"]], null, null, null, null, null)), core["ɵdid"](234, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](235, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](236, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](238, 0, null, null, 4, "option", [["value", "Friday"]], null, null, null, null, null)), core["ɵdid"](239, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](240, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](241, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](243, 0, null, null, 4, "option", [["value", "Saturday"]], null, null, null, null, null)), core["ɵdid"](244, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](245, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](246, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](248, 0, null, null, 22, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](249, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](250, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](252, 0, null, null, 18, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](253, 0, null, null, 17, "div", [["class", "col-lg-12 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](254, 0, null, null, 16, "select", [["class", "form-control w-100"], ["name", "userCanShareWith"], ["ngDefaultControl", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 255)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 255).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 255)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 255)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 256).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (core["ɵnov"](_v, 256).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_6 = ((_co.userCanShareWith = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](255, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](256, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](258, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](260, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](261, 0, null, null, 4, "option", [["value", "EVERYONE"]], null, null, null, null, null)), core["ɵdid"](262, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](263, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](264, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](266, 0, null, null, 4, "option", [["value", "MY_TEAM"]], null, null, null, null, null)), core["ɵdid"](267, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](268, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](269, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](271, 0, null, null, 33, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](272, 0, null, null, 2, "label", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](273, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](275, 0, null, null, 9, "div", [["class", "form-group float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](276, 0, null, null, 6, "input", [["checked", ""], ["id", "1"], ["name", "radio-group"], ["type", "radio"], ["value", "yyyy-MM-dd"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 277)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 277).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 277)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 277)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 278).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (core["ɵnov"](_v, 278).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_6 = ((_co.dateFormat = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](277, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](278, 212992, null, 0, fesm5_forms["RadioControlValueAccessor"], [core["Renderer2"], core["ElementRef"], fesm5_forms["ɵangular_packages_forms_forms_i"], core["Injector"]], { name: [0, "name"], value: [1, "value"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["RadioControlValueAccessor"]]), core["ɵdid"](280, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](282, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](283, 0, null, null, 1, "label", [["class", "normal"], ["for", "1"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" YYYY-MM-DD "])), (_l()(), core["ɵeld"](285, 0, null, null, 9, "div", [["class", "float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](286, 0, null, null, 6, "input", [["id", "2"], ["name", "radio-group"], ["type", "radio"], ["value", "MM-yyyy-dd"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 287)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 287).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 287)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 287)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 288).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (core["ɵnov"](_v, 288).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_6 = ((_co.dateFormat = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](287, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](288, 212992, null, 0, fesm5_forms["RadioControlValueAccessor"], [core["Renderer2"], core["ElementRef"], fesm5_forms["ɵangular_packages_forms_forms_i"], core["Injector"]], { name: [0, "name"], value: [1, "value"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["RadioControlValueAccessor"]]), core["ɵdid"](290, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](292, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](293, 0, null, null, 1, "label", [["class", "normal"], ["for", "2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" MM-YYYY-DD "])), (_l()(), core["ɵeld"](295, 0, null, null, 9, "div", [["class", "float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](296, 0, null, null, 6, "input", [["id", "3"], ["name", "radio-group"], ["type", "radio"], ["value", "dd-MM-yyyy"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 297)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 297).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 297)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 297)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 298).onChange() !== false);
                ad = (pd_4 && ad);
            }
            if (("blur" === en)) {
                var pd_5 = (core["ɵnov"](_v, 298).onTouched() !== false);
                ad = (pd_5 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_6 = ((_co.dateFormat = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](297, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](298, 212992, null, 0, fesm5_forms["RadioControlValueAccessor"], [core["Renderer2"], core["ElementRef"], fesm5_forms["ɵangular_packages_forms_forms_i"], core["Injector"]], { name: [0, "name"], value: [1, "value"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["RadioControlValueAccessor"]]), core["ɵdid"](300, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](302, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](303, 0, null, null, 1, "label", [["class", "normal"], ["for", "3"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" DD-MM-YYYY "])), (_l()(), core["ɵeld"](305, 0, null, null, 6, "div", [["class", "float-left form-group d-flex align-items-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](306, 0, null, null, 2, "label", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](307, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](309, 0, null, null, 2, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](310, 0, null, null, 0, "input", [["id", "id_canCoachMultipleUsers"], ["name", "allow"], ["type", "checkbox"]], [[8, "checked", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.disableCoachMultipleUsers($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](311, 0, null, null, 0, "label", [["class", "ml-2"], ["for", "id_canCoachMultipleUsers"]], null, null, null, null, null)), (_l()(), core["ɵeld"](312, 0, null, null, 100, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](313, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](314, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](315, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](317, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](318, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](319, 0, null, null, 46, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](320, 0, null, null, 32, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](321, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](322, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](324, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](327, 0, null, null, 25, "select", [["class", "form-control w-100"], ["name", "shareWith"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 328).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 328).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.shareWith = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](328, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](330, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](332, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](333, 0, null, null, 4, "option", [["value", "EVERYONE"]], null, null, null, null, null)), core["ɵdid"](334, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](335, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](336, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](338, 0, null, null, 4, "option", [["value", "MY_TEAM"]], null, null, null, null, null)), core["ɵdid"](339, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](340, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](341, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](343, 0, null, null, 4, "option", [["value", "MY_WORK_CIRCLE"]], null, null, null, null, null)), core["ɵdid"](344, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](345, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](346, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](348, 0, null, null, 4, "option", [["value", "MY_IMMEDIATE_WORK_CIRCLE"]], null, null, null, null, null)), core["ɵdid"](349, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](350, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](351, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](353, 0, null, null, 12, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](354, 0, null, null, 11, "div", [["class", "d-flex align-items-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](355, 0, null, null, 2, "p", [["class", "mb-0 mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](356, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](358, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](359, 0, null, null, 5, "input", [["id", "id4"], ["name", "isCommentDisableForAdminPost"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 360).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 360).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.isCommentDisableForAdminPost = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](360, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](362, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](364, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](365, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](366, 0, null, null, 46, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](367, 0, null, null, 5, "label", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](368, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](370, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](373, 0, null, null, 9, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](374, 0, null, null, 5, "input", [["id", "id1"], ["name", "share"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 375).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 375).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.share = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](375, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](377, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](379, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](380, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id1"]], null, null, null, null, null)), (_l()(), core["ɵted"](381, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](383, 0, null, null, 9, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](384, 0, null, null, 5, "input", [["id", "likeId"], ["name", "like"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 385).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 385).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.like = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](385, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](387, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](389, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](390, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "likeId"]], null, null, null, null, null)), (_l()(), core["ɵted"](391, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](393, 0, null, null, 9, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](394, 0, null, null, 5, "input", [["id", "id2"], ["name", "comment"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 395).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 395).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.comment = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](395, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](397, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](399, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](400, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id2"]], null, null, null, null, null)), (_l()(), core["ɵted"](401, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](403, 0, null, null, 9, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](404, 0, null, null, 5, "input", [["id", "id3"], ["name", "discuss"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 405).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 405).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.discuss = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](405, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](407, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](409, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](410, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id3"]], null, null, null, null, null)), (_l()(), core["ɵted"](411, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](413, 0, null, null, 34, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](414, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](415, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](416, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](418, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](419, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](420, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](421, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](422, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](424, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](427, 0, null, null, 6, "input", [["class", "form-control"], ["max", "100"], ["min", "1"], ["name", "recordsPerPage"], ["onkeypress", "return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 428)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 428).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 428)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 428)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 429).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 429).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 429).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.paginationValue = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](428, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](429, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](431, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](433, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](434, 0, null, null, 13, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](435, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](436, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](438, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [" :"])), (_l()(), core["ɵeld"](441, 0, null, null, 6, "input", [["class", "form-control"], ["max", "100"], ["min", "1"], ["name", "noPageGridDis"], ["onkeypress", "return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 442)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 442).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 442)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 442)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 443).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 443).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 443).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.paginationValueGrid = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](442, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](443, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](445, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](447, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](448, 0, null, null, 39, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](449, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](450, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](451, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](453, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](454, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](455, 0, null, null, 21, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](456, 0, null, null, 9, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](457, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](458, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](460, 0, null, null, 5, "input", [["class", "form-control"], ["name", "uoms"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 461)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 461).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 461)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 461)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.applicableUOMValue = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](461, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](463, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](465, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](466, 0, null, null, 10, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](467, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](468, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](470, 0, null, null, 6, "input", [["class", "form-control"], ["min", "0"], ["name", "logoutMD"], ["onkeypress", "return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 471)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 471).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 471)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 471)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 472).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 472).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 472).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.logoutVal = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](471, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](472, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](474, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](476, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](477, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](478, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](479, null, ["", " :"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](481, 0, null, null, 6, "input", [["class", "form-control"], ["max", "6"], ["min", "0"], ["name", "allowedEmail"], ["onkeypress", "return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 482)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 482).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 482)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 482)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 483).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 483).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 483).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.numberOfMonthsDateTargetCanExceed = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](482, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](483, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](485, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](487, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](488, 0, null, null, 195, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](489, 0, null, null, 4, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](490, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Configuration Settings"])), (_l()(), core["ɵeld"](492, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](493, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](494, 0, null, null, 22, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](495, 0, null, null, 21, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](496, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Upload Tenant logo:"])), (_l()(), core["ɵeld"](498, 0, null, null, 7, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](499, 0, null, null, 6, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](500, 0, [["fileInput", 1]], null, 0, "input", [["accept", ".jpg,.png,.svg,.svgz"], ["class", "form-control"], ["name", "pic"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.fileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](501, 0, null, null, 4, "div", [["class", "align-v-center justify-content-end"]], null, null, null, null, null)), (_l()(), core["ɵeld"](502, 0, null, null, 1, "small", [["class", "text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Resolution: 160*40px; "])), (_l()(), core["ɵeld"](504, 0, null, null, 1, "small", [["class", "ml-2 text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["size limit: 5mb"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantPreferenceComponent_1)), core["ɵdid"](507, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantPreferenceComponent_2)), core["ɵdid"](509, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](510, 0, null, null, 6, "div", [["class", "align-v-center w-100 pt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](511, 0, null, null, 2, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](512, 0, null, null, 0, "input", [["checked", ""], ["id", "checkbox6"], ["type", "checkbox"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.allowSameLogo($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](513, 0, null, null, 0, "label", [["class", "mb-md-0"], ["for", "checkbox6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](514, 0, null, null, 2, "label", [["class", "ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](515, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](517, 0, null, null, 57, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](518, 0, null, null, 8, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](519, 0, null, null, 2, "label", [["class", "mr-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](520, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](522, 0, null, null, 4, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](523, 0, null, null, 0, "input", [["id", "id_scorecardhistory"], ["name", "allow"], ["type", "checkbox"]], [[8, "checked", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.disableScorecardHistory($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](524, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id_scorecardhistory"]], null, null, null, null, null)), (_l()(), core["ɵted"](525, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](527, 0, null, null, 11, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](528, 0, null, null, 2, "label", [["class", "mr-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](529, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](531, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](532, 0, null, null, 5, "input", [["id", "id_showTenantLogoAsDisplayPicture"], ["name", "showTenantLogoAsDisplayPicture"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 533).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 533).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.isDisplayTenantLogoInUserPicture = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](533, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](535, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](537, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](538, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id_showTenantLogoAsDisplayPicture"]], null, null, null, null, null)), (_l()(), core["ɵeld"](539, 0, null, null, 11, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](540, 0, null, null, 2, "label", [["class", "mr-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](541, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](543, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](544, 0, null, null, 5, "input", [["id", "id_OverallScoreAsDescription"], ["name", "id_OverallScoreAsDescription"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 545).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 545).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.isOverallScoreAsDescription = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](545, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](547, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](549, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](550, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id_OverallScoreAsDescription"]], null, null, null, null, null)), (_l()(), core["ɵeld"](551, 0, null, null, 11, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](552, 0, null, null, 2, "label", [["class", "mr-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](553, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](555, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](556, 0, null, null, 5, "input", [["id", "round_off_overallScore"], ["name", "round_off_overallScore"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 557).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 557).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.isRoundOffOverallScore = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](557, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](559, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](561, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](562, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "round_off_overallScore"]], null, null, null, null, null)), (_l()(), core["ɵeld"](563, 0, null, null, 11, "div", [["class", "float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](564, 0, null, null, 2, "label", [["class", "mr-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](565, null, ["", ":"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](567, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](568, 0, null, null, 5, "input", [["id", "id_TO_DO_TASK_ASSIGNED"], ["name", "id_TO_DO_TASK_ASSIGNED"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 569).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 569).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.isToDoTaskAssigned = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](569, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](571, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](573, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](574, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "id_TO_DO_TASK_ASSIGNED"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantPreferenceComponent_3)), core["ɵdid"](576, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantPreferenceComponent_4)), core["ɵdid"](578, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](579, 0, null, null, 34, "div", [["class", "w-100 float-left mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](580, 0, null, null, 33, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](581, 0, null, null, 2, "p", [], null, null, null, null, null)), (_l()(), core["ɵted"](582, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](584, 0, null, null, 9, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](585, 0, null, null, 5, "input", [["id", "employeeCheckbox"], ["name", "employeeCheckbox"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 586).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 586).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.canEmployeeViewAnnualScore = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](586, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](588, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](590, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](591, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "employeeCheckbox"]], null, null, null, null, null)), (_l()(), core["ɵted"](592, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](594, 0, null, null, 9, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](595, 0, null, null, 5, "input", [["id", "supervisorCheckbox"], ["name", "supervisorCheckbox"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 596).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 596).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.canSuperviosrViewAnnualScore = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](596, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](598, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](600, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](601, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "supervisorCheckbox"]], null, null, null, null, null)), (_l()(), core["ɵted"](602, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](604, 0, null, null, 9, "div", [["class", "checkbox checkbox-primary float-left mr-4 align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](605, 0, null, null, 5, "input", [["id", "switchUserCheckbox"], ["name", "switchUserCheckbox"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 606).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 606).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.canSwitchViewAnnualScore = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](606, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](608, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](610, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](611, 0, null, null, 0, "label", [["class", "mb-0 mr-1"], ["for", "switchUserCheckbox"]], null, null, null, null, null)), (_l()(), core["ɵted"](612, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantPreferenceComponent_5)), core["ɵdid"](615, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](616, 0, null, null, 17, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](617, 0, null, null, 4, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](618, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Strategy"])), (_l()(), core["ɵeld"](620, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](621, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](622, 0, null, null, 11, "div", [["class", "align-v-center w-100 pt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](623, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](624, 0, null, null, 5, "input", [["id", "statCheckbox1"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 625).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 625).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.allowMultipleStrategy = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](625, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](627, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](629, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](630, 0, null, null, 0, "label", [["class", "mb-md-0"], ["for", "statCheckbox1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](631, 0, null, null, 2, "label", [["class", "ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](632, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](634, 0, null, null, 45, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](635, 0, null, null, 4, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](636, 0, null, null, 1, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["KPI Settings"])), (_l()(), core["ɵeld"](638, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](639, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](640, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](641, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](643, 0, null, null, 36, "div", [["class", " w-100 pt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](644, 0, null, null, 11, "div", [["class", "align-v-center mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](645, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](646, 0, null, null, 5, "input", [["id", "changeCheckBox1"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 647).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 647).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.reflectChanges = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](647, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](649, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](651, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](652, 0, null, null, 0, "label", [["class", "mb-md-0"], ["for", "changeCheckBox1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](653, 0, null, null, 2, "label", [["class", "ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](654, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](656, 0, null, null, 11, "div", [["class", "align-v-center mb-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](657, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](658, 0, null, null, 5, "input", [["id", "changeCheckBox2"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 659).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 659).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.changeRelationship = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](659, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](661, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](663, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](664, 0, null, null, 0, "label", [["class", "mb-md-0"], ["for", "changeCheckBox2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](665, 0, null, null, 2, "label", [["class", "ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](666, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](668, 0, null, null, 11, "div", [["class", "align-v-center mb-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](669, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary float-left align-v-center text-14x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](670, 0, null, null, 5, "input", [["id", "changeCheckBox3"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 671).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 671).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.resetToCreated = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](671, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](673, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](675, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](676, 0, null, null, 0, "label", [["class", "mb-md-0"], ["for", "changeCheckBox3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](677, 0, null, null, 2, "label", [["class", "ml-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](678, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](680, 0, null, null, 3, "div", [["class", "w-100 float-right p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](681, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.formatPayload() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](682, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_10 = "displayPref"; var currVal_11 = _co.displayPreferences; _ck(_v, 28, 0, currVal_10, currVal_11); var currVal_21 = "monthStartDay"; var currVal_22 = _co.monthStartDay; _ck(_v, 44, 0, currVal_21, currVal_22); var currVal_23 = "1"; _ck(_v, 48, 0, currVal_23); var currVal_24 = "1"; _ck(_v, 49, 0, currVal_24); var currVal_25 = "2"; _ck(_v, 52, 0, currVal_25); var currVal_26 = "2"; _ck(_v, 53, 0, currVal_26); var currVal_27 = "3"; _ck(_v, 56, 0, currVal_27); var currVal_28 = "3"; _ck(_v, 57, 0, currVal_28); var currVal_29 = "4"; _ck(_v, 60, 0, currVal_29); var currVal_30 = "4"; _ck(_v, 61, 0, currVal_30); var currVal_31 = "5"; _ck(_v, 64, 0, currVal_31); var currVal_32 = "5"; _ck(_v, 65, 0, currVal_32); var currVal_33 = "6"; _ck(_v, 68, 0, currVal_33); var currVal_34 = "6"; _ck(_v, 69, 0, currVal_34); var currVal_35 = "7"; _ck(_v, 72, 0, currVal_35); var currVal_36 = "7"; _ck(_v, 73, 0, currVal_36); var currVal_37 = "8"; _ck(_v, 76, 0, currVal_37); var currVal_38 = "8"; _ck(_v, 77, 0, currVal_38); var currVal_39 = "9"; _ck(_v, 80, 0, currVal_39); var currVal_40 = "9"; _ck(_v, 81, 0, currVal_40); var currVal_41 = "10"; _ck(_v, 84, 0, currVal_41); var currVal_42 = "10"; _ck(_v, 85, 0, currVal_42); var currVal_43 = "11"; _ck(_v, 88, 0, currVal_43); var currVal_44 = "11"; _ck(_v, 89, 0, currVal_44); var currVal_45 = "12"; _ck(_v, 92, 0, currVal_45); var currVal_46 = "12"; _ck(_v, 93, 0, currVal_46); var currVal_47 = "13"; _ck(_v, 96, 0, currVal_47); var currVal_48 = "13"; _ck(_v, 97, 0, currVal_48); var currVal_49 = "14"; _ck(_v, 100, 0, currVal_49); var currVal_50 = "14"; _ck(_v, 101, 0, currVal_50); var currVal_51 = "15"; _ck(_v, 104, 0, currVal_51); var currVal_52 = "15"; _ck(_v, 105, 0, currVal_52); var currVal_53 = "16"; _ck(_v, 108, 0, currVal_53); var currVal_54 = "16"; _ck(_v, 109, 0, currVal_54); var currVal_55 = "17"; _ck(_v, 112, 0, currVal_55); var currVal_56 = "17"; _ck(_v, 113, 0, currVal_56); var currVal_57 = "18"; _ck(_v, 116, 0, currVal_57); var currVal_58 = "18"; _ck(_v, 117, 0, currVal_58); var currVal_59 = "19"; _ck(_v, 120, 0, currVal_59); var currVal_60 = "19"; _ck(_v, 121, 0, currVal_60); var currVal_61 = "20"; _ck(_v, 124, 0, currVal_61); var currVal_62 = "20"; _ck(_v, 125, 0, currVal_62); var currVal_63 = "21"; _ck(_v, 128, 0, currVal_63); var currVal_64 = "21"; _ck(_v, 129, 0, currVal_64); var currVal_65 = "22"; _ck(_v, 132, 0, currVal_65); var currVal_66 = "22"; _ck(_v, 133, 0, currVal_66); var currVal_67 = "23"; _ck(_v, 136, 0, currVal_67); var currVal_68 = "23"; _ck(_v, 137, 0, currVal_68); var currVal_69 = "24"; _ck(_v, 140, 0, currVal_69); var currVal_70 = "24"; _ck(_v, 141, 0, currVal_70); var currVal_71 = "25"; _ck(_v, 144, 0, currVal_71); var currVal_72 = "25"; _ck(_v, 145, 0, currVal_72); var currVal_73 = "26"; _ck(_v, 148, 0, currVal_73); var currVal_74 = "26"; _ck(_v, 149, 0, currVal_74); var currVal_75 = "27"; _ck(_v, 152, 0, currVal_75); var currVal_76 = "27"; _ck(_v, 153, 0, currVal_76); var currVal_77 = "28"; _ck(_v, 156, 0, currVal_77); var currVal_78 = "28"; _ck(_v, 157, 0, currVal_78); var currVal_79 = "29"; _ck(_v, 160, 0, currVal_79); var currVal_80 = "29"; _ck(_v, 161, 0, currVal_80); var currVal_81 = "30"; _ck(_v, 164, 0, currVal_81); var currVal_82 = "30"; _ck(_v, 165, 0, currVal_82); var currVal_83 = "31"; _ck(_v, 168, 0, currVal_83); var currVal_84 = "31"; _ck(_v, 169, 0, currVal_84); var currVal_102 = "weekStartDay"; var currVal_103 = _co.weekStartDay; _ck(_v, 210, 0, currVal_102, currVal_103); var currVal_104 = "Sunday"; _ck(_v, 214, 0, currVal_104); var currVal_105 = "Sunday"; _ck(_v, 215, 0, currVal_105); var currVal_107 = "Monday"; _ck(_v, 219, 0, currVal_107); var currVal_108 = "Monday"; _ck(_v, 220, 0, currVal_108); var currVal_110 = "Tuesday"; _ck(_v, 224, 0, currVal_110); var currVal_111 = "Tuesday"; _ck(_v, 225, 0, currVal_111); var currVal_113 = "Wednesday"; _ck(_v, 229, 0, currVal_113); var currVal_114 = "Wednesday"; _ck(_v, 230, 0, currVal_114); var currVal_116 = "Thursday"; _ck(_v, 234, 0, currVal_116); var currVal_117 = "Thursday"; _ck(_v, 235, 0, currVal_117); var currVal_119 = "Friday"; _ck(_v, 239, 0, currVal_119); var currVal_120 = "Friday"; _ck(_v, 240, 0, currVal_120); var currVal_122 = "Saturday"; _ck(_v, 244, 0, currVal_122); var currVal_123 = "Saturday"; _ck(_v, 245, 0, currVal_123); var currVal_133 = "userCanShareWith"; var currVal_134 = _co.userCanShareWith; _ck(_v, 258, 0, currVal_133, currVal_134); var currVal_135 = "EVERYONE"; _ck(_v, 262, 0, currVal_135); var currVal_136 = "EVERYONE"; _ck(_v, 263, 0, currVal_136); var currVal_138 = "MY_TEAM"; _ck(_v, 267, 0, currVal_138); var currVal_139 = "MY_TEAM"; _ck(_v, 268, 0, currVal_139); var currVal_149 = "radio-group"; var currVal_150 = "yyyy-MM-dd"; _ck(_v, 278, 0, currVal_149, currVal_150); var currVal_151 = "radio-group"; var currVal_152 = _co.dateFormat; _ck(_v, 280, 0, currVal_151, currVal_152); var currVal_160 = "radio-group"; var currVal_161 = "MM-yyyy-dd"; _ck(_v, 288, 0, currVal_160, currVal_161); var currVal_162 = "radio-group"; var currVal_163 = _co.dateFormat; _ck(_v, 290, 0, currVal_162, currVal_163); var currVal_171 = "radio-group"; var currVal_172 = "dd-MM-yyyy"; _ck(_v, 298, 0, currVal_171, currVal_172); var currVal_173 = "radio-group"; var currVal_174 = _co.dateFormat; _ck(_v, 300, 0, currVal_173, currVal_174); var currVal_186 = "shareWith"; var currVal_187 = _co.shareWith; _ck(_v, 330, 0, currVal_186, currVal_187); var currVal_188 = "EVERYONE"; _ck(_v, 334, 0, currVal_188); var currVal_189 = "EVERYONE"; _ck(_v, 335, 0, currVal_189); var currVal_191 = "MY_TEAM"; _ck(_v, 339, 0, currVal_191); var currVal_192 = "MY_TEAM"; _ck(_v, 340, 0, currVal_192); var currVal_194 = "MY_WORK_CIRCLE"; _ck(_v, 344, 0, currVal_194); var currVal_195 = "MY_WORK_CIRCLE"; _ck(_v, 345, 0, currVal_195); var currVal_197 = "MY_IMMEDIATE_WORK_CIRCLE"; _ck(_v, 349, 0, currVal_197); var currVal_198 = "MY_IMMEDIATE_WORK_CIRCLE"; _ck(_v, 350, 0, currVal_198); var currVal_208 = "isCommentDisableForAdminPost"; var currVal_209 = _co.isCommentDisableForAdminPost; _ck(_v, 362, 0, currVal_208, currVal_209); var currVal_218 = "share"; var currVal_219 = _co.share; _ck(_v, 377, 0, currVal_218, currVal_219); var currVal_228 = "like"; var currVal_229 = _co.like; _ck(_v, 387, 0, currVal_228, currVal_229); var currVal_238 = "comment"; var currVal_239 = _co.comment; _ck(_v, 397, 0, currVal_238, currVal_239); var currVal_248 = "discuss"; var currVal_249 = _co.discuss; _ck(_v, 407, 0, currVal_248, currVal_249); var currVal_260 = "recordsPerPage"; var currVal_261 = _co.paginationValue; _ck(_v, 431, 0, currVal_260, currVal_261); var currVal_270 = "noPageGridDis"; var currVal_271 = _co.paginationValueGrid; _ck(_v, 445, 0, currVal_270, currVal_271); var currVal_281 = "uoms"; var currVal_282 = _co.applicableUOMValue; _ck(_v, 463, 0, currVal_281, currVal_282); var currVal_291 = "logoutMD"; var currVal_292 = _co.logoutVal; _ck(_v, 474, 0, currVal_291, currVal_292); var currVal_301 = "allowedEmail"; var currVal_302 = _co.numberOfMonthsDateTargetCanExceed; _ck(_v, 485, 0, currVal_301, currVal_302); var currVal_303 = _co.allowBI; _ck(_v, 507, 0, currVal_303); var currVal_304 = _co.allowBI; _ck(_v, 509, 0, currVal_304); var currVal_317 = "showTenantLogoAsDisplayPicture"; var currVal_318 = _co.isDisplayTenantLogoInUserPicture; _ck(_v, 535, 0, currVal_317, currVal_318); var currVal_327 = "id_OverallScoreAsDescription"; var currVal_328 = _co.isOverallScoreAsDescription; _ck(_v, 547, 0, currVal_327, currVal_328); var currVal_337 = "round_off_overallScore"; var currVal_338 = _co.isRoundOffOverallScore; _ck(_v, 559, 0, currVal_337, currVal_338); var currVal_347 = "id_TO_DO_TASK_ASSIGNED"; var currVal_348 = _co.isToDoTaskAssigned; _ck(_v, 571, 0, currVal_347, currVal_348); var currVal_349 = (_co.client == "KEA"); _ck(_v, 576, 0, currVal_349); var currVal_350 = (_co.client == "SKYLARK"); _ck(_v, 578, 0, currVal_350); var currVal_359 = "employeeCheckbox"; var currVal_360 = _co.canEmployeeViewAnnualScore; _ck(_v, 588, 0, currVal_359, currVal_360); var currVal_369 = "supervisorCheckbox"; var currVal_370 = _co.canSuperviosrViewAnnualScore; _ck(_v, 598, 0, currVal_369, currVal_370); var currVal_379 = "switchUserCheckbox"; var currVal_380 = _co.canSwitchViewAnnualScore; _ck(_v, 608, 0, currVal_379, currVal_380); var currVal_382 = (_co.client == "KEA"); _ck(_v, 615, 0, currVal_382); var currVal_390 = _co.allowMultipleStrategy; _ck(_v, 627, 0, currVal_390); var currVal_400 = _co.reflectChanges; _ck(_v, 649, 0, currVal_400); var currVal_409 = _co.changeRelationship; _ck(_v, 661, 0, currVal_409); var currVal_418 = _co.resetToCreated; _ck(_v, 673, 0, currVal_418); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("tenantPreference")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 10, 0, core["ɵnov"](_v, 11).transform("genSettings")); _ck(_v, 10, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("displayPreference")); _ck(_v, 17, 0, currVal_2); var currVal_3 = core["ɵnov"](_v, 30).ngClassUntouched; var currVal_4 = core["ɵnov"](_v, 30).ngClassTouched; var currVal_5 = core["ɵnov"](_v, 30).ngClassPristine; var currVal_6 = core["ɵnov"](_v, 30).ngClassDirty; var currVal_7 = core["ɵnov"](_v, 30).ngClassValid; var currVal_8 = core["ɵnov"](_v, 30).ngClassInvalid; var currVal_9 = core["ɵnov"](_v, 30).ngClassPending; _ck(_v, 24, 0, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9); var currVal_12 = _co.num; _ck(_v, 33, 0, currVal_12); var currVal_13 = core["ɵunv"](_v, 36, 0, core["ɵnov"](_v, 37).transform("monthStartDay")); _ck(_v, 36, 0, currVal_13); var currVal_14 = core["ɵnov"](_v, 46).ngClassUntouched; var currVal_15 = core["ɵnov"](_v, 46).ngClassTouched; var currVal_16 = core["ɵnov"](_v, 46).ngClassPristine; var currVal_17 = core["ɵnov"](_v, 46).ngClassDirty; var currVal_18 = core["ɵnov"](_v, 46).ngClassValid; var currVal_19 = core["ɵnov"](_v, 46).ngClassInvalid; var currVal_20 = core["ɵnov"](_v, 46).ngClassPending; _ck(_v, 40, 0, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20); var currVal_85 = core["ɵunv"](_v, 173, 0, core["ɵnov"](_v, 174).transform("updateEmpDisPic")); _ck(_v, 173, 0, currVal_85); var currVal_86 = (_co.allow == true); _ck(_v, 179, 0, currVal_86); var currVal_87 = core["ɵunv"](_v, 181, 0, core["ɵnov"](_v, 182).transform("allow")); _ck(_v, 181, 0, currVal_87); var currVal_88 = core["ɵunv"](_v, 185, 0, core["ɵnov"](_v, 186).transform("THINGS_TO_DO")); _ck(_v, 185, 0, currVal_88); var currVal_89 = (_co.isToDoEnabled == "false"); _ck(_v, 188, 0, currVal_89); var currVal_90 = core["ɵunv"](_v, 190, 0, core["ɵnov"](_v, 191).transform("disabled")); _ck(_v, 190, 0, currVal_90); var currVal_91 = core["ɵunv"](_v, 194, 0, core["ɵnov"](_v, 195).transform("PUSH_KPI_OPTION_ENABLED")); _ck(_v, 194, 0, currVal_91); var currVal_92 = (_co.pushKpiEnabled == "true"); _ck(_v, 197, 0, currVal_92); var currVal_93 = core["ɵunv"](_v, 199, 0, core["ɵnov"](_v, 200).transform("enabled")); _ck(_v, 199, 0, currVal_93); var currVal_94 = core["ɵunv"](_v, 204, 0, core["ɵnov"](_v, 205).transform("weekStartDay")); _ck(_v, 204, 0, currVal_94); var currVal_95 = core["ɵnov"](_v, 212).ngClassUntouched; var currVal_96 = core["ɵnov"](_v, 212).ngClassTouched; var currVal_97 = core["ɵnov"](_v, 212).ngClassPristine; var currVal_98 = core["ɵnov"](_v, 212).ngClassDirty; var currVal_99 = core["ɵnov"](_v, 212).ngClassValid; var currVal_100 = core["ɵnov"](_v, 212).ngClassInvalid; var currVal_101 = core["ɵnov"](_v, 212).ngClassPending; _ck(_v, 206, 0, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100, currVal_101); var currVal_106 = core["ɵunv"](_v, 216, 0, core["ɵnov"](_v, 217).transform("sunday")); _ck(_v, 216, 0, currVal_106); var currVal_109 = core["ɵunv"](_v, 221, 0, core["ɵnov"](_v, 222).transform("monday")); _ck(_v, 221, 0, currVal_109); var currVal_112 = core["ɵunv"](_v, 226, 0, core["ɵnov"](_v, 227).transform("tuesday")); _ck(_v, 226, 0, currVal_112); var currVal_115 = core["ɵunv"](_v, 231, 0, core["ɵnov"](_v, 232).transform("wednesday")); _ck(_v, 231, 0, currVal_115); var currVal_118 = core["ɵunv"](_v, 236, 0, core["ɵnov"](_v, 237).transform("thursday")); _ck(_v, 236, 0, currVal_118); var currVal_121 = core["ɵunv"](_v, 241, 0, core["ɵnov"](_v, 242).transform("friday")); _ck(_v, 241, 0, currVal_121); var currVal_124 = core["ɵunv"](_v, 246, 0, core["ɵnov"](_v, 247).transform("saturday")); _ck(_v, 246, 0, currVal_124); var currVal_125 = core["ɵunv"](_v, 250, 0, core["ɵnov"](_v, 251).transform("userCanShareAnnWith")); _ck(_v, 250, 0, currVal_125); var currVal_126 = core["ɵnov"](_v, 260).ngClassUntouched; var currVal_127 = core["ɵnov"](_v, 260).ngClassTouched; var currVal_128 = core["ɵnov"](_v, 260).ngClassPristine; var currVal_129 = core["ɵnov"](_v, 260).ngClassDirty; var currVal_130 = core["ɵnov"](_v, 260).ngClassValid; var currVal_131 = core["ɵnov"](_v, 260).ngClassInvalid; var currVal_132 = core["ɵnov"](_v, 260).ngClassPending; _ck(_v, 254, 0, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130, currVal_131, currVal_132); var currVal_137 = core["ɵunv"](_v, 264, 0, core["ɵnov"](_v, 265).transform("everyone")); _ck(_v, 264, 0, currVal_137); var currVal_140 = core["ɵunv"](_v, 269, 0, core["ɵnov"](_v, 270).transform("myTeam")); _ck(_v, 269, 0, currVal_140); var currVal_141 = core["ɵunv"](_v, 273, 0, core["ɵnov"](_v, 274).transform("preferDate")); _ck(_v, 273, 0, currVal_141); var currVal_142 = core["ɵnov"](_v, 282).ngClassUntouched; var currVal_143 = core["ɵnov"](_v, 282).ngClassTouched; var currVal_144 = core["ɵnov"](_v, 282).ngClassPristine; var currVal_145 = core["ɵnov"](_v, 282).ngClassDirty; var currVal_146 = core["ɵnov"](_v, 282).ngClassValid; var currVal_147 = core["ɵnov"](_v, 282).ngClassInvalid; var currVal_148 = core["ɵnov"](_v, 282).ngClassPending; _ck(_v, 276, 0, currVal_142, currVal_143, currVal_144, currVal_145, currVal_146, currVal_147, currVal_148); var currVal_153 = core["ɵnov"](_v, 292).ngClassUntouched; var currVal_154 = core["ɵnov"](_v, 292).ngClassTouched; var currVal_155 = core["ɵnov"](_v, 292).ngClassPristine; var currVal_156 = core["ɵnov"](_v, 292).ngClassDirty; var currVal_157 = core["ɵnov"](_v, 292).ngClassValid; var currVal_158 = core["ɵnov"](_v, 292).ngClassInvalid; var currVal_159 = core["ɵnov"](_v, 292).ngClassPending; _ck(_v, 286, 0, currVal_153, currVal_154, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159); var currVal_164 = core["ɵnov"](_v, 302).ngClassUntouched; var currVal_165 = core["ɵnov"](_v, 302).ngClassTouched; var currVal_166 = core["ɵnov"](_v, 302).ngClassPristine; var currVal_167 = core["ɵnov"](_v, 302).ngClassDirty; var currVal_168 = core["ɵnov"](_v, 302).ngClassValid; var currVal_169 = core["ɵnov"](_v, 302).ngClassInvalid; var currVal_170 = core["ɵnov"](_v, 302).ngClassPending; _ck(_v, 296, 0, currVal_164, currVal_165, currVal_166, currVal_167, currVal_168, currVal_169, currVal_170); var currVal_175 = core["ɵunv"](_v, 307, 0, core["ɵnov"](_v, 308).transform("canCoachMultipleUsers")); _ck(_v, 307, 0, currVal_175); var currVal_176 = (_co.canCoachMultipleUsers == "true"); _ck(_v, 310, 0, currVal_176); var currVal_177 = core["ɵunv"](_v, 315, 0, core["ɵnov"](_v, 316).transform("sharingOption")); _ck(_v, 315, 0, currVal_177); var currVal_178 = core["ɵunv"](_v, 322, 0, core["ɵnov"](_v, 323).transform("userCanShare")); _ck(_v, 322, 0, currVal_178); var currVal_179 = core["ɵnov"](_v, 332).ngClassUntouched; var currVal_180 = core["ɵnov"](_v, 332).ngClassTouched; var currVal_181 = core["ɵnov"](_v, 332).ngClassPristine; var currVal_182 = core["ɵnov"](_v, 332).ngClassDirty; var currVal_183 = core["ɵnov"](_v, 332).ngClassValid; var currVal_184 = core["ɵnov"](_v, 332).ngClassInvalid; var currVal_185 = core["ɵnov"](_v, 332).ngClassPending; _ck(_v, 327, 0, currVal_179, currVal_180, currVal_181, currVal_182, currVal_183, currVal_184, currVal_185); var currVal_190 = core["ɵunv"](_v, 336, 0, core["ɵnov"](_v, 337).transform("everyone")); _ck(_v, 336, 0, currVal_190); var currVal_193 = core["ɵunv"](_v, 341, 0, core["ɵnov"](_v, 342).transform("myTeam")); _ck(_v, 341, 0, currVal_193); var currVal_196 = core["ɵunv"](_v, 346, 0, core["ɵnov"](_v, 347).transform("myCircle")); _ck(_v, 346, 0, currVal_196); var currVal_199 = core["ɵunv"](_v, 351, 0, core["ɵnov"](_v, 352).transform("myImmediateWorkCircle")); _ck(_v, 351, 0, currVal_199); var currVal_200 = core["ɵunv"](_v, 356, 0, core["ɵnov"](_v, 357).transform("CommentOnAdminAnnouncement")); _ck(_v, 356, 0, currVal_200); var currVal_201 = core["ɵnov"](_v, 364).ngClassUntouched; var currVal_202 = core["ɵnov"](_v, 364).ngClassTouched; var currVal_203 = core["ɵnov"](_v, 364).ngClassPristine; var currVal_204 = core["ɵnov"](_v, 364).ngClassDirty; var currVal_205 = core["ɵnov"](_v, 364).ngClassValid; var currVal_206 = core["ɵnov"](_v, 364).ngClassInvalid; var currVal_207 = core["ɵnov"](_v, 364).ngClassPending; _ck(_v, 359, 0, currVal_201, currVal_202, currVal_203, currVal_204, currVal_205, currVal_206, currVal_207); var currVal_210 = core["ɵunv"](_v, 368, 0, core["ɵnov"](_v, 369).transform("shareCommentDiscuss")); _ck(_v, 368, 0, currVal_210); var currVal_211 = core["ɵnov"](_v, 379).ngClassUntouched; var currVal_212 = core["ɵnov"](_v, 379).ngClassTouched; var currVal_213 = core["ɵnov"](_v, 379).ngClassPristine; var currVal_214 = core["ɵnov"](_v, 379).ngClassDirty; var currVal_215 = core["ɵnov"](_v, 379).ngClassValid; var currVal_216 = core["ɵnov"](_v, 379).ngClassInvalid; var currVal_217 = core["ɵnov"](_v, 379).ngClassPending; _ck(_v, 374, 0, currVal_211, currVal_212, currVal_213, currVal_214, currVal_215, currVal_216, currVal_217); var currVal_220 = core["ɵunv"](_v, 381, 0, core["ɵnov"](_v, 382).transform("share")); _ck(_v, 381, 0, currVal_220); var currVal_221 = core["ɵnov"](_v, 389).ngClassUntouched; var currVal_222 = core["ɵnov"](_v, 389).ngClassTouched; var currVal_223 = core["ɵnov"](_v, 389).ngClassPristine; var currVal_224 = core["ɵnov"](_v, 389).ngClassDirty; var currVal_225 = core["ɵnov"](_v, 389).ngClassValid; var currVal_226 = core["ɵnov"](_v, 389).ngClassInvalid; var currVal_227 = core["ɵnov"](_v, 389).ngClassPending; _ck(_v, 384, 0, currVal_221, currVal_222, currVal_223, currVal_224, currVal_225, currVal_226, currVal_227); var currVal_230 = core["ɵunv"](_v, 391, 0, core["ɵnov"](_v, 392).transform("like")); _ck(_v, 391, 0, currVal_230); var currVal_231 = core["ɵnov"](_v, 399).ngClassUntouched; var currVal_232 = core["ɵnov"](_v, 399).ngClassTouched; var currVal_233 = core["ɵnov"](_v, 399).ngClassPristine; var currVal_234 = core["ɵnov"](_v, 399).ngClassDirty; var currVal_235 = core["ɵnov"](_v, 399).ngClassValid; var currVal_236 = core["ɵnov"](_v, 399).ngClassInvalid; var currVal_237 = core["ɵnov"](_v, 399).ngClassPending; _ck(_v, 394, 0, currVal_231, currVal_232, currVal_233, currVal_234, currVal_235, currVal_236, currVal_237); var currVal_240 = core["ɵunv"](_v, 401, 0, core["ɵnov"](_v, 402).transform("comment")); _ck(_v, 401, 0, currVal_240); var currVal_241 = core["ɵnov"](_v, 409).ngClassUntouched; var currVal_242 = core["ɵnov"](_v, 409).ngClassTouched; var currVal_243 = core["ɵnov"](_v, 409).ngClassPristine; var currVal_244 = core["ɵnov"](_v, 409).ngClassDirty; var currVal_245 = core["ɵnov"](_v, 409).ngClassValid; var currVal_246 = core["ɵnov"](_v, 409).ngClassInvalid; var currVal_247 = core["ɵnov"](_v, 409).ngClassPending; _ck(_v, 404, 0, currVal_241, currVal_242, currVal_243, currVal_244, currVal_245, currVal_246, currVal_247); var currVal_250 = core["ɵunv"](_v, 411, 0, core["ɵnov"](_v, 412).transform("discuss")); _ck(_v, 411, 0, currVal_250); var currVal_251 = core["ɵunv"](_v, 416, 0, core["ɵnov"](_v, 417).transform("recordPerPage")); _ck(_v, 416, 0, currVal_251); var currVal_252 = core["ɵunv"](_v, 422, 0, core["ɵnov"](_v, 423).transform("noPageToDisplayHub")); _ck(_v, 422, 0, currVal_252); var currVal_253 = core["ɵnov"](_v, 433).ngClassUntouched; var currVal_254 = core["ɵnov"](_v, 433).ngClassTouched; var currVal_255 = core["ɵnov"](_v, 433).ngClassPristine; var currVal_256 = core["ɵnov"](_v, 433).ngClassDirty; var currVal_257 = core["ɵnov"](_v, 433).ngClassValid; var currVal_258 = core["ɵnov"](_v, 433).ngClassInvalid; var currVal_259 = core["ɵnov"](_v, 433).ngClassPending; _ck(_v, 427, 0, currVal_253, currVal_254, currVal_255, currVal_256, currVal_257, currVal_258, currVal_259); var currVal_262 = core["ɵunv"](_v, 436, 0, core["ɵnov"](_v, 437).transform("noPageGrid")); _ck(_v, 436, 0, currVal_262); var currVal_263 = core["ɵnov"](_v, 447).ngClassUntouched; var currVal_264 = core["ɵnov"](_v, 447).ngClassTouched; var currVal_265 = core["ɵnov"](_v, 447).ngClassPristine; var currVal_266 = core["ɵnov"](_v, 447).ngClassDirty; var currVal_267 = core["ɵnov"](_v, 447).ngClassValid; var currVal_268 = core["ɵnov"](_v, 447).ngClassInvalid; var currVal_269 = core["ɵnov"](_v, 447).ngClassPending; _ck(_v, 441, 0, currVal_263, currVal_264, currVal_265, currVal_266, currVal_267, currVal_268, currVal_269); var currVal_272 = core["ɵunv"](_v, 451, 0, core["ɵnov"](_v, 452).transform("otherSettings")); _ck(_v, 451, 0, currVal_272); var currVal_273 = core["ɵunv"](_v, 458, 0, core["ɵnov"](_v, 459).transform("applicableUmo")); _ck(_v, 458, 0, currVal_273); var currVal_274 = core["ɵnov"](_v, 465).ngClassUntouched; var currVal_275 = core["ɵnov"](_v, 465).ngClassTouched; var currVal_276 = core["ɵnov"](_v, 465).ngClassPristine; var currVal_277 = core["ɵnov"](_v, 465).ngClassDirty; var currVal_278 = core["ɵnov"](_v, 465).ngClassValid; var currVal_279 = core["ɵnov"](_v, 465).ngClassInvalid; var currVal_280 = core["ɵnov"](_v, 465).ngClassPending; _ck(_v, 460, 0, currVal_274, currVal_275, currVal_276, currVal_277, currVal_278, currVal_279, currVal_280); var currVal_283 = core["ɵunv"](_v, 468, 0, core["ɵnov"](_v, 469).transform("logoutFromMobile")); _ck(_v, 468, 0, currVal_283); var currVal_284 = core["ɵnov"](_v, 476).ngClassUntouched; var currVal_285 = core["ɵnov"](_v, 476).ngClassTouched; var currVal_286 = core["ɵnov"](_v, 476).ngClassPristine; var currVal_287 = core["ɵnov"](_v, 476).ngClassDirty; var currVal_288 = core["ɵnov"](_v, 476).ngClassValid; var currVal_289 = core["ɵnov"](_v, 476).ngClassInvalid; var currVal_290 = core["ɵnov"](_v, 476).ngClassPending; _ck(_v, 470, 0, currVal_284, currVal_285, currVal_286, currVal_287, currVal_288, currVal_289, currVal_290); var currVal_293 = core["ɵunv"](_v, 479, 0, core["ɵnov"](_v, 480).transform("howManyExtraMonthsCanShowForDateBased")); _ck(_v, 479, 0, currVal_293); var currVal_294 = core["ɵnov"](_v, 487).ngClassUntouched; var currVal_295 = core["ɵnov"](_v, 487).ngClassTouched; var currVal_296 = core["ɵnov"](_v, 487).ngClassPristine; var currVal_297 = core["ɵnov"](_v, 487).ngClassDirty; var currVal_298 = core["ɵnov"](_v, 487).ngClassValid; var currVal_299 = core["ɵnov"](_v, 487).ngClassInvalid; var currVal_300 = core["ɵnov"](_v, 487).ngClassPending; _ck(_v, 481, 0, currVal_294, currVal_295, currVal_296, currVal_297, currVal_298, currVal_299, currVal_300); var currVal_305 = core["ɵunv"](_v, 515, 0, core["ɵnov"](_v, 516).transform("sameLogoToBI")); _ck(_v, 515, 0, currVal_305); var currVal_306 = core["ɵunv"](_v, 520, 0, core["ɵnov"](_v, 521).transform("SCORECARD_HISTORY")); _ck(_v, 520, 0, currVal_306); var currVal_307 = (_co.isScorecardHistoryEnabled == "false"); _ck(_v, 523, 0, currVal_307); var currVal_308 = core["ɵunv"](_v, 525, 0, core["ɵnov"](_v, 526).transform("disabled")); _ck(_v, 525, 0, currVal_308); var currVal_309 = core["ɵunv"](_v, 529, 0, core["ɵnov"](_v, 530).transform("SHOW_DISPLAY_PICTURE_AS_TENANT_LOGO")); _ck(_v, 529, 0, currVal_309); var currVal_310 = core["ɵnov"](_v, 537).ngClassUntouched; var currVal_311 = core["ɵnov"](_v, 537).ngClassTouched; var currVal_312 = core["ɵnov"](_v, 537).ngClassPristine; var currVal_313 = core["ɵnov"](_v, 537).ngClassDirty; var currVal_314 = core["ɵnov"](_v, 537).ngClassValid; var currVal_315 = core["ɵnov"](_v, 537).ngClassInvalid; var currVal_316 = core["ɵnov"](_v, 537).ngClassPending; _ck(_v, 532, 0, currVal_310, currVal_311, currVal_312, currVal_313, currVal_314, currVal_315, currVal_316); var currVal_319 = core["ɵunv"](_v, 541, 0, core["ɵnov"](_v, 542).transform("SHOW_OVERALL_SCORE_AS_DESCRIPTION")); _ck(_v, 541, 0, currVal_319); var currVal_320 = core["ɵnov"](_v, 549).ngClassUntouched; var currVal_321 = core["ɵnov"](_v, 549).ngClassTouched; var currVal_322 = core["ɵnov"](_v, 549).ngClassPristine; var currVal_323 = core["ɵnov"](_v, 549).ngClassDirty; var currVal_324 = core["ɵnov"](_v, 549).ngClassValid; var currVal_325 = core["ɵnov"](_v, 549).ngClassInvalid; var currVal_326 = core["ɵnov"](_v, 549).ngClassPending; _ck(_v, 544, 0, currVal_320, currVal_321, currVal_322, currVal_323, currVal_324, currVal_325, currVal_326); var currVal_329 = core["ɵunv"](_v, 553, 0, core["ɵnov"](_v, 554).transform("ROUND_OFF_OVERALLSCORE")); _ck(_v, 553, 0, currVal_329); var currVal_330 = core["ɵnov"](_v, 561).ngClassUntouched; var currVal_331 = core["ɵnov"](_v, 561).ngClassTouched; var currVal_332 = core["ɵnov"](_v, 561).ngClassPristine; var currVal_333 = core["ɵnov"](_v, 561).ngClassDirty; var currVal_334 = core["ɵnov"](_v, 561).ngClassValid; var currVal_335 = core["ɵnov"](_v, 561).ngClassInvalid; var currVal_336 = core["ɵnov"](_v, 561).ngClassPending; _ck(_v, 556, 0, currVal_330, currVal_331, currVal_332, currVal_333, currVal_334, currVal_335, currVal_336); var currVal_339 = core["ɵunv"](_v, 565, 0, core["ɵnov"](_v, 566).transform("TO_DO_CARD_FOR_TASK_ASSIGNED")); _ck(_v, 565, 0, currVal_339); var currVal_340 = core["ɵnov"](_v, 573).ngClassUntouched; var currVal_341 = core["ɵnov"](_v, 573).ngClassTouched; var currVal_342 = core["ɵnov"](_v, 573).ngClassPristine; var currVal_343 = core["ɵnov"](_v, 573).ngClassDirty; var currVal_344 = core["ɵnov"](_v, 573).ngClassValid; var currVal_345 = core["ɵnov"](_v, 573).ngClassInvalid; var currVal_346 = core["ɵnov"](_v, 573).ngClassPending; _ck(_v, 568, 0, currVal_340, currVal_341, currVal_342, currVal_343, currVal_344, currVal_345, currVal_346); var currVal_351 = core["ɵunv"](_v, 582, 0, core["ɵnov"](_v, 583).transform("showAnnualScore")); _ck(_v, 582, 0, currVal_351); var currVal_352 = core["ɵnov"](_v, 590).ngClassUntouched; var currVal_353 = core["ɵnov"](_v, 590).ngClassTouched; var currVal_354 = core["ɵnov"](_v, 590).ngClassPristine; var currVal_355 = core["ɵnov"](_v, 590).ngClassDirty; var currVal_356 = core["ɵnov"](_v, 590).ngClassValid; var currVal_357 = core["ɵnov"](_v, 590).ngClassInvalid; var currVal_358 = core["ɵnov"](_v, 590).ngClassPending; _ck(_v, 585, 0, currVal_352, currVal_353, currVal_354, currVal_355, currVal_356, currVal_357, currVal_358); var currVal_361 = core["ɵunv"](_v, 592, 0, core["ɵnov"](_v, 593).transform("EMPLOYEE_ADMIN")); _ck(_v, 592, 0, currVal_361); var currVal_362 = core["ɵnov"](_v, 600).ngClassUntouched; var currVal_363 = core["ɵnov"](_v, 600).ngClassTouched; var currVal_364 = core["ɵnov"](_v, 600).ngClassPristine; var currVal_365 = core["ɵnov"](_v, 600).ngClassDirty; var currVal_366 = core["ɵnov"](_v, 600).ngClassValid; var currVal_367 = core["ɵnov"](_v, 600).ngClassInvalid; var currVal_368 = core["ɵnov"](_v, 600).ngClassPending; _ck(_v, 595, 0, currVal_362, currVal_363, currVal_364, currVal_365, currVal_366, currVal_367, currVal_368); var currVal_371 = core["ɵunv"](_v, 602, 0, core["ɵnov"](_v, 603).transform("Supervisor")); _ck(_v, 602, 0, currVal_371); var currVal_372 = core["ɵnov"](_v, 610).ngClassUntouched; var currVal_373 = core["ɵnov"](_v, 610).ngClassTouched; var currVal_374 = core["ɵnov"](_v, 610).ngClassPristine; var currVal_375 = core["ɵnov"](_v, 610).ngClassDirty; var currVal_376 = core["ɵnov"](_v, 610).ngClassValid; var currVal_377 = core["ɵnov"](_v, 610).ngClassInvalid; var currVal_378 = core["ɵnov"](_v, 610).ngClassPending; _ck(_v, 605, 0, currVal_372, currVal_373, currVal_374, currVal_375, currVal_376, currVal_377, currVal_378); var currVal_381 = core["ɵunv"](_v, 612, 0, core["ɵnov"](_v, 613).transform("empWithSwitchUserAccess")); _ck(_v, 612, 0, currVal_381); var currVal_383 = core["ɵnov"](_v, 629).ngClassUntouched; var currVal_384 = core["ɵnov"](_v, 629).ngClassTouched; var currVal_385 = core["ɵnov"](_v, 629).ngClassPristine; var currVal_386 = core["ɵnov"](_v, 629).ngClassDirty; var currVal_387 = core["ɵnov"](_v, 629).ngClassValid; var currVal_388 = core["ɵnov"](_v, 629).ngClassInvalid; var currVal_389 = core["ɵnov"](_v, 629).ngClassPending; _ck(_v, 624, 0, currVal_383, currVal_384, currVal_385, currVal_386, currVal_387, currVal_388, currVal_389); var currVal_391 = core["ɵunv"](_v, 632, 0, core["ɵnov"](_v, 633).transform("allowMultipleStrategy")); _ck(_v, 632, 0, currVal_391); var currVal_392 = core["ɵunv"](_v, 641, 0, core["ɵnov"](_v, 642).transform("subordinateScorecardChangeOption")); _ck(_v, 641, 0, currVal_392); var currVal_393 = core["ɵnov"](_v, 651).ngClassUntouched; var currVal_394 = core["ɵnov"](_v, 651).ngClassTouched; var currVal_395 = core["ɵnov"](_v, 651).ngClassPristine; var currVal_396 = core["ɵnov"](_v, 651).ngClassDirty; var currVal_397 = core["ɵnov"](_v, 651).ngClassValid; var currVal_398 = core["ɵnov"](_v, 651).ngClassInvalid; var currVal_399 = core["ɵnov"](_v, 651).ngClassPending; _ck(_v, 646, 0, currVal_393, currVal_394, currVal_395, currVal_396, currVal_397, currVal_398, currVal_399); var currVal_401 = core["ɵunv"](_v, 654, 0, core["ɵnov"](_v, 655).transform("reflectChanges")); _ck(_v, 654, 0, currVal_401); var currVal_402 = core["ɵnov"](_v, 663).ngClassUntouched; var currVal_403 = core["ɵnov"](_v, 663).ngClassTouched; var currVal_404 = core["ɵnov"](_v, 663).ngClassPristine; var currVal_405 = core["ɵnov"](_v, 663).ngClassDirty; var currVal_406 = core["ɵnov"](_v, 663).ngClassValid; var currVal_407 = core["ɵnov"](_v, 663).ngClassInvalid; var currVal_408 = core["ɵnov"](_v, 663).ngClassPending; _ck(_v, 658, 0, currVal_402, currVal_403, currVal_404, currVal_405, currVal_406, currVal_407, currVal_408); var currVal_410 = core["ɵunv"](_v, 666, 0, core["ɵnov"](_v, 667).transform("changeRelationship")); _ck(_v, 666, 0, currVal_410); var currVal_411 = core["ɵnov"](_v, 675).ngClassUntouched; var currVal_412 = core["ɵnov"](_v, 675).ngClassTouched; var currVal_413 = core["ɵnov"](_v, 675).ngClassPristine; var currVal_414 = core["ɵnov"](_v, 675).ngClassDirty; var currVal_415 = core["ɵnov"](_v, 675).ngClassValid; var currVal_416 = core["ɵnov"](_v, 675).ngClassInvalid; var currVal_417 = core["ɵnov"](_v, 675).ngClassPending; _ck(_v, 670, 0, currVal_411, currVal_412, currVal_413, currVal_414, currVal_415, currVal_416, currVal_417); var currVal_419 = core["ɵunv"](_v, 678, 0, core["ɵnov"](_v, 679).transform("resetToCreated")); _ck(_v, 678, 0, currVal_419); var currVal_420 = core["ɵunv"](_v, 682, 0, core["ɵnov"](_v, 683).transform("Save")); _ck(_v, 682, 0, currVal_420); });
}
function View_TenantPreferenceComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "ToolsMenu", [], null, null, null, View_TenantPreferenceComponent_0, RenderType_TenantPreferenceComponent)), core["ɵdid"](1, 49152, null, 0, tenantPreference_TenantPreferenceComponent, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, common["Location"], ToasterComponent, core["ViewContainerRef"], http_client_HttpClientCustom, Configuration, core_es5["j" /* TranslateService */], SharedData, auth_Auth], null, null)], null, null); }
var TenantPreferenceComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("ToolsMenu", tenantPreference_TenantPreferenceComponent, View_TenantPreferenceComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/superAdmin/buildDetailsComponent.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_buildDetailsComponent,_angular_router,_shared_permissions_permissions,_shared_services_configuration,_shared_services_http.client,_ngx_translate_core,_toasterComponent_toasterComponent,_angular_common PURE_IMPORTS_END */









var styles_BuildDetailsComponent = [];
var RenderType_BuildDetailsComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_BuildDetailsComponent, data: {} });

function View_BuildDetailsComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Build details"])), (_l()(), core["ɵeld"](4, 0, null, null, 6, "div", [["class", " w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Build number UI:"])), (_l()(), core["ɵeld"](8, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-6 col-sm-6 col-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, ["", ""])), (_l()(), core["ɵeld"](11, 0, null, null, 6, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Build number Backend:"])), (_l()(), core["ɵeld"](15, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 1, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.buildNumber; _ck(_v, 10, 0, currVal_0); var currVal_1 = _co.backEndbuildNumber; _ck(_v, 17, 0, currVal_1); }); }
function View_BuildDetailsComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "build-details", [], null, null, null, View_BuildDetailsComponent_0, RenderType_BuildDetailsComponent)), core["ɵdid"](1, 114688, null, 0, BuildDetailsComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], common["Location"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var BuildDetailsComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("build-details", BuildDetailsComponent, View_BuildDetailsComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/superAdmin/tenantManagement.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_forms,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_tenantManagement,_angular_router,_shared_permissions_permissions,_shared_services_configuration,_shared_services_http.client PURE_IMPORTS_END */














var styles_TenantManagementComponent = [];
var RenderType_TenantManagementComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_TenantManagementComponent, data: {} });

function View_TenantManagementComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.appName; _ck(_v, 1, 0, currVal_0); }); }
function View_TenantManagementComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_TenantManagementComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.timeZone; _ck(_v, 1, 0, currVal_0); }); }
function View_TenantManagementComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_TenantManagementComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.status; _ck(_v, 1, 0, currVal_0); }); }
function View_TenantManagementComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("notAvailable")); _ck(_v, 1, 0, currVal_0); }); }
function View_TenantManagementComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "div", [["class", "empActions m-t-nsmd"], ["style", "right:75px !important"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editTenant(_v.parent.context.$implicit.id) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("edit")); _ck(_v, 4, 0, currVal_0); });
}
function View_TenantManagementComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantManagementComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantManagementComponent_3)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), (_l()(), core["ɵeld"](9, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantManagementComponent_4)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantManagementComponent_5)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantManagementComponent_6)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantManagementComponent_7)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 6, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 16777216, null, null, 3, "h6", [["class", "mb-lg-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.tableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](21, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](23, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantManagementComponent_8)), core["ɵdid"](25, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_v.context.$implicit.appName != null); _ck(_v, 3, 0, currVal_0); var currVal_1 = (_v.context.$implicit.appName == null); _ck(_v, 5, 0, currVal_1); var currVal_3 = (_v.context.$implicit.timeZone != null); _ck(_v, 11, 0, currVal_3); var currVal_4 = (_v.context.$implicit.timeZone == null); _ck(_v, 13, 0, currVal_4); var currVal_5 = (_v.context.$implicit.status != null); _ck(_v, 16, 0, currVal_5); var currVal_6 = (_v.context.$implicit.status == null); _ck(_v, 18, 0, currVal_6); var currVal_7 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 22).transform("clickForMoreOption")), ""); _ck(_v, 21, 0, currVal_7); var currVal_8 = (_v.context.index == _co.trackHides); _ck(_v, 25, 0, currVal_8); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.orgName; _ck(_v, 8, 0, currVal_2); });
}
function View_TenantManagementComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 60, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mb-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.newTenant() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](7, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 51, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 20, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](15, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](21, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](23, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](25, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](27, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](29, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_TenantManagementComponent_1)), core["ɵdid"](32, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](33, 0, null, null, 27, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 1, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](35, null, [" ", " - ", " ", " ", " "])), (_l()(), core["ɵeld"](36, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](38, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](40, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 41).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 41).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](41, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](43, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](45, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](46, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](47, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](48, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](50, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](51, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](52, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](54, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](55, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](56, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](58, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](59, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](60, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.tenantData; _ck(_v, 32, 0, currVal_7); var currVal_20 = _co.pageSize; _ck(_v, 43, 0, currVal_20); var currVal_21 = "10"; _ck(_v, 47, 0, currVal_21); var currVal_22 = "10"; _ck(_v, 48, 0, currVal_22); var currVal_23 = "20"; _ck(_v, 51, 0, currVal_23); var currVal_24 = "20"; _ck(_v, 52, 0, currVal_24); var currVal_25 = "30"; _ck(_v, 55, 0, currVal_25); var currVal_26 = "30"; _ck(_v, 56, 0, currVal_26); var currVal_27 = true; var currVal_28 = false; var currVal_29 = true; var currVal_30 = _co.collectionSize; var currVal_31 = 5; var currVal_32 = _co.page; var currVal_33 = _co.pageSize; _ck(_v, 60, 0, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("manageTenant")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform("addTenant")); _ck(_v, 7, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("mobAppName")); _ck(_v, 13, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("tenantName")); _ck(_v, 17, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 22).transform("timeZone")); _ck(_v, 21, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 25, 0, core["ɵnov"](_v, 26).transform("status")); _ck(_v, 25, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 29, 0, core["ɵnov"](_v, 30).transform("action")); _ck(_v, 29, 0, currVal_6); var currVal_8 = _co.startingPage; var currVal_9 = _co.endingPage; var currVal_10 = "itemsOf"; var currVal_11 = _co.collectionSize; _ck(_v, 35, 0, currVal_8, currVal_9, currVal_10, currVal_11); var currVal_12 = core["ɵunv"](_v, 38, 0, core["ɵnov"](_v, 39).transform("showItemsPerPage")); _ck(_v, 38, 0, currVal_12); var currVal_13 = core["ɵnov"](_v, 45).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 45).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 45).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 45).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 45).ngClassValid; var currVal_18 = core["ɵnov"](_v, 45).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 45).ngClassPending; _ck(_v, 40, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); });
}
function View_TenantManagementComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "tenant-management", [], null, null, null, View_TenantManagementComponent_0, RenderType_TenantManagementComponent)), core["ɵdid"](1, 114688, null, 0, TenantManagementComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, core_es5["j" /* TranslateService */], http_client_HttpClientCustom], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var TenantManagementComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("tenant-management", TenantManagementComponent, View_TenantManagementComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/superAdmin/createTenant.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_ngx_translate_core,_angular_common,_.._.._node_modules_angular2_multiselect_dropdown_multiselect.component.ngfactory,angular2_multiselect_dropdown_multiselect.component,_.._.._node_modules_angular2_multiselect_dropdown_menu_item.ngfactory,angular2_multiselect_dropdown_menu_item,_createTenant,_angular_router,_shared_permissions_permissions,_shared_services_configuration,_shared_services_http.client,_toasterComponent_toasterComponent PURE_IMPORTS_END */














var styles_CreateTenantComponent = [];
var RenderType_CreateTenantComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_CreateTenantComponent, data: {} });

function View_CreateTenantComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["style", "color: #333;width: 150px;"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.context.item.name; _ck(_v, 1, 0, currVal_0); }); }
function View_CreateTenantComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", ""]))], function (_ck, _v) { var currVal_0 = _v.context.$implicit.id; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit.id; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.mobileAppName; _ck(_v, 3, 0, currVal_2); }); }
function View_CreateTenantComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("empEmailRequired")); _ck(_v, 1, 0, currVal_0); }); }
function View_CreateTenantComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("invalidEmail")); _ck(_v, 1, 0, currVal_0); }); }
function View_CreateTenantComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "info-text  alert-danger"], ["style", "padding:5px"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateTenantComponent_4)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateTenantComponent_5)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_0 = core["ɵnov"](_v.parent, 259).errors.required; _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵnov"](_v.parent, 259).errors.pattern; _ck(_v, 4, 0, currVal_1); }, null); }
function View_CreateTenantComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 11, "div", [["class", "float-left text-center mb-1 mt-1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 10, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 5, "input", [["type", "checkbox"]], [[8, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.context.$implicit.assigned = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 0, "label", [["class", "mb-0 float-left mr-2"]], [[8, "htmlFor", 0]], null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 2, "p", [["class", "float-left text-13x mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_8 = core["ɵinlineInterpolate"](1, "", _v.context.index, ""); var currVal_9 = _v.context.$implicit.assigned; _ck(_v, 6, 0, currVal_8, currVal_9); }, function (_ck, _v) { var currVal_0 = _v.context.index; var currVal_1 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 8).ngClassValid; var currVal_6 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = _v.context.index; _ck(_v, 9, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 11, 0, core["ɵnov"](_v, 12).transform((_v.context.$implicit.operation + "_MODULE"))); _ck(_v, 11, 0, currVal_11); });
}
function View_CreateTenantComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 294, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["class", "btn float-left mb-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](7, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 285, "form", [["novalidate", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "submit"], [null, "reset"]], function (_v, en, $event) {
            var ad = true;
            if (("submit" === en)) {
                var pd_0 = (core["ɵnov"](_v, 11).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("reset" === en)) {
                var pd_1 = (core["ɵnov"](_v, 11).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](10, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bg"], [], null, null), core["ɵdid"](11, 4210688, [["tenantForm", 4]], 0, fesm5_forms["NgForm"], [[8, null], [8, null]], null, null), core["ɵprd"](2048, null, fesm5_forms["ControlContainer"], null, [fesm5_forms["NgForm"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatusGroup"], [[4, fesm5_forms["ControlContainer"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 203, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h5", [["class", "m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 41, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 16, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](24, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](26, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](29, 0, null, null, 9, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 8, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 7, "input", [["autocomplete", "off"], ["class", "form-control"], ["min", "0"], ["name", "orgName"], ["required", ""], ["type", "text"]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 32)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 32).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 32)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 32)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.createNewTenantData.orgName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](32, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](33, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](36, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](38, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](39, 0, null, null, 23, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 5, "label", [["for", "lanId"]], null, null, null, null, null)), (_l()(), core["ɵted"](41, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](43, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](46, 0, null, null, 16, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](47, 0, null, null, 15, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](48, 0, null, null, 14, "angular2-multiselect", [], [[8, "className", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.selectedLangItems = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AngularMultiSelect_0, RenderType_AngularMultiSelect)), core["ɵdid"](49, 13484032, null, 3, multiselect_component_AngularMultiSelect, [core["ElementRef"], core["ChangeDetectorRef"]], { data: [0, "data"], settings: [1, "settings"] }, null), core["ɵqud"](335544320, 1, { itemTempl: 0 }), core["ɵqud"](335544320, 2, { badgeTempl: 0 }), core["ɵqud"](335544320, 3, { searchTempl: 0 }), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵdid"](55, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"], options: [1, "options"] }, { update: "ngModelChange" }), core["ɵpod"](56, { standalone: 0 }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](58, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](59, 0, null, null, 3, "c-item", [], null, null, null, View_Item_0, RenderType_Item)), core["ɵdid"](60, 49152, [[1, 4]], 1, Item, [], null, null), core["ɵqud"](335544320, 4, { template: 0 }), (_l()(), core["ɵand"](0, [[4, 2]], null, 0, null, View_CreateTenantComponent_1)), (_l()(), core["ɵeld"](63, 0, null, null, 110, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](64, 0, null, null, 16, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](65, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](66, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](68, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](71, 0, null, null, 9, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](72, 0, null, null, 8, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](73, 0, null, null, 7, "input", [["autocomplete", "off"], ["class", "form-control"], ["name", "shortName"], ["required", ""], ["type", "text"]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 74)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 74).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 74)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 74)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.createNewTenantData.shortName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](74, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](75, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](78, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](80, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](81, 0, null, null, 92, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](82, 0, null, null, 5, "label", [["for", "timeZone"]], null, null, null, null, null)), (_l()(), core["ɵted"](83, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](85, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](88, 0, null, null, 85, "select", [["class", "form-control col-lg-9 col-md-9"], ["id", "timeZone"], ["name", "timeZone"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 89).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 89).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.createNewTenantData.timeZone = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](89, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](91, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](93, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](94, 0, null, null, 4, "option", [["disabled", ""], ["selected", ""], ["value", ""]], null, null, null, null, null)), core["ɵdid"](95, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](96, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](97, null, ["--", "--"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](99, 0, null, null, 4, "option", [["value", "GMT+01:00"]], null, null, null, null, null)), core["ɵdid"](100, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](101, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](102, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](104, 0, null, null, 4, "option", [["value", "GMT+08:00"]], null, null, null, null, null)), core["ɵdid"](105, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](106, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](107, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](109, 0, null, null, 4, "option", [["value", "GMT+05:30"]], null, null, null, null, null)), core["ɵdid"](110, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](111, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](112, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](114, 0, null, null, 4, "option", [["value", "GMT+07:00"]], null, null, null, null, null)), core["ɵdid"](115, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](116, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](117, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](119, 0, null, null, 4, "option", [["value", "GMT+08:00"]], null, null, null, null, null)), core["ɵdid"](120, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](121, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](122, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](124, 0, null, null, 4, "option", [["value", "GMT+09:00"]], null, null, null, null, null)), core["ɵdid"](125, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](126, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](127, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](129, 0, null, null, 4, "option", [["value", "GMT+08:00"]], null, null, null, null, null)), core["ɵdid"](130, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](131, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](132, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](134, 0, null, null, 4, "option", [["value", "GMT+05:30"]], null, null, null, null, null)), core["ɵdid"](135, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](136, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](137, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](139, 0, null, null, 4, "option", [["value", "GMT+04:00"]], null, null, null, null, null)), core["ɵdid"](140, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](141, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](142, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](144, 0, null, null, 4, "option", [["value", "GMT-05:00"]], null, null, null, null, null)), core["ɵdid"](145, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](146, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](147, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](149, 0, null, null, 4, "option", [["value", "GMT-06:00"]], null, null, null, null, null)), core["ɵdid"](150, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](151, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](152, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](154, 0, null, null, 4, "option", [["value", "GMT-07:00"]], null, null, null, null, null)), core["ɵdid"](155, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](156, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](157, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](159, 0, null, null, 4, "option", [["value", "GMT-08:00"]], null, null, null, null, null)), core["ɵdid"](160, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](161, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](162, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](164, 0, null, null, 4, "option", [["value", "GMT-09:00"]], null, null, null, null, null)), core["ɵdid"](165, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](166, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](167, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](169, 0, null, null, 4, "option", [["value", "GMT-10:00"]], null, null, null, null, null)), core["ɵdid"](170, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](171, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](172, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](174, 0, null, null, 22, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](175, 0, null, null, 21, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](176, 0, null, null, 5, "label", [["for", "lanId"]], null, null, null, null, null)), (_l()(), core["ɵted"](177, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](179, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](182, 0, null, null, 14, "select", [["class", "form-control col-lg-9 col-md-9"], ["id", "lanId"], ["name", "lanId"], ["required", ""]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 183).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 183).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.selectedApp = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](183, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](184, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](187, 671744, [["lange", 4]], 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](189, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](190, 0, null, null, 4, "option", [["disabled", ""], ["selected", ""], ["value", ""]], null, null, null, null, null)), core["ɵdid"](191, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](192, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](193, null, ["--", "--"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateTenantComponent_2)), core["ɵdid"](196, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](197, 0, null, null, 20, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](198, 0, null, null, 5, "label", [["class", "w-100"]], null, null, null, null, null)), (_l()(), core["ɵted"](199, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](201, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](204, 0, null, null, 13, "div", [["class", "w-75 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](205, 0, null, null, 12, "div", [["class", "input-group mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](206, 0, null, null, 8, "input", [["aria-describedby", "basic-addon2"], ["aria-label", "Recipient's username"], ["autocomplete", "off"], ["class", "form-control"], ["name", "baseUrl"], ["pattern", "\\b((?=[a-z0-9-]{1,63}\\.)[a-z0-9]+(-[a-z0-9]+)*\\.)+[a-z]{2,63}\\b"], ["required", ""], ["type", "text"]], [[1, "required", 0], [1, "pattern", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "keypress"], [null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 207)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 207).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 207)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 207)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("keypress" === en)) {
                var pd_4 = (_co.omit_special_char($event) !== false);
                ad = (pd_4 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_5 = ((_co.beforeAppending = $event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](207, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](208, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵdid"](209, 540672, null, 0, fesm5_forms["PatternValidator"], [], { pattern: [0, "pattern"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["RequiredValidator"], fesm5_forms["PatternValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](212, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](214, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](215, 0, null, null, 2, "div", [["class", "input-group-append"]], null, null, null, null, null)), (_l()(), core["ɵeld"](216, 0, null, null, 1, "span", [["class", "input-group-text"], ["id", "basic-addon2"]], null, null, null, null, null)), (_l()(), core["ɵted"](217, null, ["", ""])), (_l()(), core["ɵeld"](218, 0, null, null, 63, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](219, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](220, 0, null, null, 2, "h5", [["class", "m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](221, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](223, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](224, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](225, 0, null, null, 38, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](226, 0, null, null, 16, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](227, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](228, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](230, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](233, 0, null, null, 9, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](234, 0, null, null, 8, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](235, 0, null, null, 7, "input", [["autocomplete", "off"], ["class", "form-control"], ["min", "0"], ["name", "displayName"], ["required", ""], ["type", "text"]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 236)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 236).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 236)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 236)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.createNewTenantData.displayName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](236, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](237, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](240, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](242, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](243, 0, null, null, 20, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](244, 0, null, null, 5, "label", [["for", "email"]], null, null, null, null, null)), (_l()(), core["ɵted"](245, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](247, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](250, 0, null, null, 13, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](251, 0, null, null, 12, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](252, 0, null, null, 9, "input", [["autocomplete", "off"], ["class", "form-control"], ["id", "email"], ["maxlength", "80"], ["name", "email"], ["pattern", "[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\\.[a-zA-Z]{2,3}$"], ["placeholder", "Eg: jack@oracle.com"], ["required", ""], ["type", "email"]], [[1, "required", 0], [1, "maxlength", 0], [1, "pattern", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 253)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 253).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 253)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 253)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.createNewTenantData.email = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_5 = (_co.copyToUsername($event) !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](253, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](254, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵdid"](255, 540672, null, 0, fesm5_forms["MaxLengthValidator"], [], { maxlength: [0, "maxlength"] }, null), core["ɵdid"](256, 540672, null, 0, fesm5_forms["PatternValidator"], [], { pattern: [0, "pattern"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0, p2_0) { return [p0_0, p1_0, p2_0]; }, [fesm5_forms["RequiredValidator"], fesm5_forms["MaxLengthValidator"], fesm5_forms["PatternValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](259, 671744, [["email", 4]], 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](261, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateTenantComponent_3)), core["ɵdid"](263, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](264, 0, null, null, 17, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](265, 0, null, null, 16, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](266, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](267, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](269, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](272, 0, null, null, 9, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](273, 0, null, null, 8, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](274, 0, null, null, 7, "input", [["autocomplete", "off"], ["class", "form-control"], ["name", "username"], ["required", ""], ["type", "text"]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 275)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 275).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 275)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 275)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.createNewTenantData.userName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](275, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](276, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](279, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](281, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](282, 0, null, null, 9, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](283, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](284, 0, null, null, 2, "h5", [["class", "m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](285, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](287, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](288, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](289, 0, null, null, 2, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_CreateTenantComponent_6)), core["ɵdid"](291, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](292, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mb-4 ml-4"], ["type", "submit"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.createNewTenant() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](293, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_19 = ""; _ck(_v, 33, 0, currVal_19); var currVal_20 = "orgName"; var currVal_21 = _co.createNewTenantData.orgName; _ck(_v, 36, 0, currVal_20, currVal_21); var currVal_31 = _co.itemLangList; var currVal_32 = _co.langSettings; _ck(_v, 49, 0, currVal_31, currVal_32); var currVal_33 = _co.selectedLangItems; var currVal_34 = _ck(_v, 56, 0, true); _ck(_v, 55, 0, currVal_33, currVal_34); var currVal_44 = ""; _ck(_v, 75, 0, currVal_44); var currVal_45 = "shortName"; var currVal_46 = _co.createNewTenantData.shortName; _ck(_v, 78, 0, currVal_45, currVal_46); var currVal_55 = "timeZone"; var currVal_56 = _co.createNewTenantData.timeZone; _ck(_v, 91, 0, currVal_55, currVal_56); var currVal_57 = ""; _ck(_v, 95, 0, currVal_57); var currVal_58 = ""; _ck(_v, 96, 0, currVal_58); var currVal_60 = "GMT+01:00"; _ck(_v, 100, 0, currVal_60); var currVal_61 = "GMT+01:00"; _ck(_v, 101, 0, currVal_61); var currVal_63 = "GMT+08:00"; _ck(_v, 105, 0, currVal_63); var currVal_64 = "GMT+08:00"; _ck(_v, 106, 0, currVal_64); var currVal_66 = "GMT+05:30"; _ck(_v, 110, 0, currVal_66); var currVal_67 = "GMT+05:30"; _ck(_v, 111, 0, currVal_67); var currVal_69 = "GMT+07:00"; _ck(_v, 115, 0, currVal_69); var currVal_70 = "GMT+07:00"; _ck(_v, 116, 0, currVal_70); var currVal_72 = "GMT+08:00"; _ck(_v, 120, 0, currVal_72); var currVal_73 = "GMT+08:00"; _ck(_v, 121, 0, currVal_73); var currVal_75 = "GMT+09:00"; _ck(_v, 125, 0, currVal_75); var currVal_76 = "GMT+09:00"; _ck(_v, 126, 0, currVal_76); var currVal_78 = "GMT+08:00"; _ck(_v, 130, 0, currVal_78); var currVal_79 = "GMT+08:00"; _ck(_v, 131, 0, currVal_79); var currVal_81 = "GMT+05:30"; _ck(_v, 135, 0, currVal_81); var currVal_82 = "GMT+05:30"; _ck(_v, 136, 0, currVal_82); var currVal_84 = "GMT+04:00"; _ck(_v, 140, 0, currVal_84); var currVal_85 = "GMT+04:00"; _ck(_v, 141, 0, currVal_85); var currVal_87 = "GMT-05:00"; _ck(_v, 145, 0, currVal_87); var currVal_88 = "GMT-05:00"; _ck(_v, 146, 0, currVal_88); var currVal_90 = "GMT-06:00"; _ck(_v, 150, 0, currVal_90); var currVal_91 = "GMT-06:00"; _ck(_v, 151, 0, currVal_91); var currVal_93 = "GMT-07:00"; _ck(_v, 155, 0, currVal_93); var currVal_94 = "GMT-07:00"; _ck(_v, 156, 0, currVal_94); var currVal_96 = "GMT-08:00"; _ck(_v, 160, 0, currVal_96); var currVal_97 = "GMT-08:00"; _ck(_v, 161, 0, currVal_97); var currVal_99 = "GMT-09:00"; _ck(_v, 165, 0, currVal_99); var currVal_100 = "GMT-09:00"; _ck(_v, 166, 0, currVal_100); var currVal_102 = "GMT-10:00"; _ck(_v, 170, 0, currVal_102); var currVal_103 = "GMT-10:00"; _ck(_v, 171, 0, currVal_103); var currVal_114 = ""; _ck(_v, 184, 0, currVal_114); var currVal_115 = "lanId"; var currVal_116 = _co.selectedApp; _ck(_v, 187, 0, currVal_115, currVal_116); var currVal_117 = ""; _ck(_v, 191, 0, currVal_117); var currVal_118 = ""; _ck(_v, 192, 0, currVal_118); var currVal_120 = _co.apps; _ck(_v, 196, 0, currVal_120); var currVal_131 = ""; _ck(_v, 208, 0, currVal_131); var currVal_132 = "\\b((?=[a-z0-9-]{1,63}\\.)[a-z0-9]+(-[a-z0-9]+)*\\.)+[a-z]{2,63}\\b"; _ck(_v, 209, 0, currVal_132); var currVal_133 = "baseUrl"; var currVal_134 = _co.beforeAppending; _ck(_v, 212, 0, currVal_133, currVal_134); var currVal_146 = ""; _ck(_v, 237, 0, currVal_146); var currVal_147 = "displayName"; var currVal_148 = _co.createNewTenantData.displayName; _ck(_v, 240, 0, currVal_147, currVal_148); var currVal_160 = ""; _ck(_v, 254, 0, currVal_160); var currVal_161 = "80"; _ck(_v, 255, 0, currVal_161); var currVal_162 = "[a-z0-9A-Z._%+-]+@[a-z0-9A-Z.-]+\\.[a-zA-Z]{2,3}$"; _ck(_v, 256, 0, currVal_162); var currVal_163 = "email"; var currVal_164 = _co.createNewTenantData.email; _ck(_v, 259, 0, currVal_163, currVal_164); var currVal_165 = (core["ɵnov"](_v, 259).invalid && (core["ɵnov"](_v, 259).dirty || core["ɵnov"](_v, 259).touched)); _ck(_v, 263, 0, currVal_165); var currVal_175 = ""; _ck(_v, 276, 0, currVal_175); var currVal_176 = "username"; var currVal_177 = _co.createNewTenantData.userName; _ck(_v, 279, 0, currVal_176, currVal_177); var currVal_179 = _co.modules; _ck(_v, 291, 0, currVal_179); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("createTenant")); _ck(_v, 3, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform("back")); _ck(_v, 7, 0, currVal_1); var currVal_2 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 13).ngClassValid; var currVal_7 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 9, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_9 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("tenantDetails")); _ck(_v, 17, 0, currVal_9); var currVal_10 = core["ɵunv"](_v, 24, 0, core["ɵnov"](_v, 25).transform("tenantName")); _ck(_v, 24, 0, currVal_10); var currVal_11 = (core["ɵnov"](_v, 33).required ? "" : null); var currVal_12 = core["ɵnov"](_v, 38).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 38).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 38).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 38).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 38).ngClassValid; var currVal_17 = core["ɵnov"](_v, 38).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 38).ngClassPending; _ck(_v, 31, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); var currVal_22 = core["ɵunv"](_v, 41, 0, core["ɵnov"](_v, 42).transform("language")); _ck(_v, 41, 0, currVal_22); var currVal_23 = core["ɵnov"](_v, 49).defaultSettings.classes; var currVal_24 = core["ɵnov"](_v, 58).ngClassUntouched; var currVal_25 = core["ɵnov"](_v, 58).ngClassTouched; var currVal_26 = core["ɵnov"](_v, 58).ngClassPristine; var currVal_27 = core["ɵnov"](_v, 58).ngClassDirty; var currVal_28 = core["ɵnov"](_v, 58).ngClassValid; var currVal_29 = core["ɵnov"](_v, 58).ngClassInvalid; var currVal_30 = core["ɵnov"](_v, 58).ngClassPending; _ck(_v, 48, 0, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30); var currVal_35 = core["ɵunv"](_v, 66, 0, core["ɵnov"](_v, 67).transform("tenantShortName")); _ck(_v, 66, 0, currVal_35); var currVal_36 = (core["ɵnov"](_v, 75).required ? "" : null); var currVal_37 = core["ɵnov"](_v, 80).ngClassUntouched; var currVal_38 = core["ɵnov"](_v, 80).ngClassTouched; var currVal_39 = core["ɵnov"](_v, 80).ngClassPristine; var currVal_40 = core["ɵnov"](_v, 80).ngClassDirty; var currVal_41 = core["ɵnov"](_v, 80).ngClassValid; var currVal_42 = core["ɵnov"](_v, 80).ngClassInvalid; var currVal_43 = core["ɵnov"](_v, 80).ngClassPending; _ck(_v, 73, 0, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43); var currVal_47 = core["ɵunv"](_v, 83, 0, core["ɵnov"](_v, 84).transform("timeZone")); _ck(_v, 83, 0, currVal_47); var currVal_48 = core["ɵnov"](_v, 93).ngClassUntouched; var currVal_49 = core["ɵnov"](_v, 93).ngClassTouched; var currVal_50 = core["ɵnov"](_v, 93).ngClassPristine; var currVal_51 = core["ɵnov"](_v, 93).ngClassDirty; var currVal_52 = core["ɵnov"](_v, 93).ngClassValid; var currVal_53 = core["ɵnov"](_v, 93).ngClassInvalid; var currVal_54 = core["ɵnov"](_v, 93).ngClassPending; _ck(_v, 88, 0, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54); var currVal_59 = core["ɵunv"](_v, 97, 0, core["ɵnov"](_v, 98).transform("select")); _ck(_v, 97, 0, currVal_59); var currVal_62 = core["ɵunv"](_v, 102, 0, core["ɵnov"](_v, 103).transform("UTCCETGermany")); _ck(_v, 102, 0, currVal_62); var currVal_65 = core["ɵunv"](_v, 107, 0, core["ɵnov"](_v, 108).transform("UTCMSTMalaysia")); _ck(_v, 107, 0, currVal_65); var currVal_68 = core["ɵunv"](_v, 112, 0, core["ɵnov"](_v, 113).transform("UTCISTIndia")); _ck(_v, 112, 0, currVal_68); var currVal_71 = core["ɵunv"](_v, 117, 0, core["ɵnov"](_v, 118).transform("UTCIWSTIndonesia")); _ck(_v, 117, 0, currVal_71); var currVal_74 = core["ɵunv"](_v, 122, 0, core["ɵnov"](_v, 123).transform("UTCICSTIndonesia")); _ck(_v, 122, 0, currVal_74); var currVal_77 = core["ɵunv"](_v, 127, 0, core["ɵnov"](_v, 128).transform("UTCIESTIndonesia")); _ck(_v, 127, 0, currVal_77); var currVal_80 = core["ɵunv"](_v, 132, 0, core["ɵnov"](_v, 133).transform("UTCSSTSingapore")); _ck(_v, 132, 0, currVal_80); var currVal_83 = core["ɵunv"](_v, 137, 0, core["ɵnov"](_v, 138).transform("UTCSLSTSriLanka")); _ck(_v, 137, 0, currVal_83); var currVal_86 = core["ɵunv"](_v, 142, 0, core["ɵnov"](_v, 143).transform("UTCGSTUAE")); _ck(_v, 142, 0, currVal_86); var currVal_89 = core["ɵunv"](_v, 147, 0, core["ɵnov"](_v, 148).transform("UTCESTUSA")); _ck(_v, 147, 0, currVal_89); var currVal_92 = core["ɵunv"](_v, 152, 0, core["ɵnov"](_v, 153).transform("UTCCSTUSA")); _ck(_v, 152, 0, currVal_92); var currVal_95 = core["ɵunv"](_v, 157, 0, core["ɵnov"](_v, 158).transform("UTCMSTUSA")); _ck(_v, 157, 0, currVal_95); var currVal_98 = core["ɵunv"](_v, 162, 0, core["ɵnov"](_v, 163).transform("UTCPSTUSA")); _ck(_v, 162, 0, currVal_98); var currVal_101 = core["ɵunv"](_v, 167, 0, core["ɵnov"](_v, 168).transform("UTCASTUSA")); _ck(_v, 167, 0, currVal_101); var currVal_104 = core["ɵunv"](_v, 172, 0, core["ɵnov"](_v, 173).transform("UTCHSTUSA")); _ck(_v, 172, 0, currVal_104); var currVal_105 = core["ɵunv"](_v, 177, 0, core["ɵnov"](_v, 178).transform("app")); _ck(_v, 177, 0, currVal_105); var currVal_106 = (core["ɵnov"](_v, 184).required ? "" : null); var currVal_107 = core["ɵnov"](_v, 189).ngClassUntouched; var currVal_108 = core["ɵnov"](_v, 189).ngClassTouched; var currVal_109 = core["ɵnov"](_v, 189).ngClassPristine; var currVal_110 = core["ɵnov"](_v, 189).ngClassDirty; var currVal_111 = core["ɵnov"](_v, 189).ngClassValid; var currVal_112 = core["ɵnov"](_v, 189).ngClassInvalid; var currVal_113 = core["ɵnov"](_v, 189).ngClassPending; _ck(_v, 182, 0, currVal_106, currVal_107, currVal_108, currVal_109, currVal_110, currVal_111, currVal_112, currVal_113); var currVal_119 = core["ɵunv"](_v, 193, 0, core["ɵnov"](_v, 194).transform("select")); _ck(_v, 193, 0, currVal_119); var currVal_121 = core["ɵunv"](_v, 199, 0, core["ɵnov"](_v, 200).transform("tenantBaseUrl")); _ck(_v, 199, 0, currVal_121); var currVal_122 = (core["ɵnov"](_v, 208).required ? "" : null); var currVal_123 = (core["ɵnov"](_v, 209).pattern ? core["ɵnov"](_v, 209).pattern : null); var currVal_124 = core["ɵnov"](_v, 214).ngClassUntouched; var currVal_125 = core["ɵnov"](_v, 214).ngClassTouched; var currVal_126 = core["ɵnov"](_v, 214).ngClassPristine; var currVal_127 = core["ɵnov"](_v, 214).ngClassDirty; var currVal_128 = core["ɵnov"](_v, 214).ngClassValid; var currVal_129 = core["ɵnov"](_v, 214).ngClassInvalid; var currVal_130 = core["ɵnov"](_v, 214).ngClassPending; _ck(_v, 206, 0, currVal_122, currVal_123, currVal_124, currVal_125, currVal_126, currVal_127, currVal_128, currVal_129, currVal_130); var currVal_135 = _co.urlExt; _ck(_v, 217, 0, currVal_135); var currVal_136 = core["ɵunv"](_v, 221, 0, core["ɵnov"](_v, 222).transform("primeContactDetails")); _ck(_v, 221, 0, currVal_136); var currVal_137 = core["ɵunv"](_v, 228, 0, core["ɵnov"](_v, 229).transform("displayName")); _ck(_v, 228, 0, currVal_137); var currVal_138 = (core["ɵnov"](_v, 237).required ? "" : null); var currVal_139 = core["ɵnov"](_v, 242).ngClassUntouched; var currVal_140 = core["ɵnov"](_v, 242).ngClassTouched; var currVal_141 = core["ɵnov"](_v, 242).ngClassPristine; var currVal_142 = core["ɵnov"](_v, 242).ngClassDirty; var currVal_143 = core["ɵnov"](_v, 242).ngClassValid; var currVal_144 = core["ɵnov"](_v, 242).ngClassInvalid; var currVal_145 = core["ɵnov"](_v, 242).ngClassPending; _ck(_v, 235, 0, currVal_138, currVal_139, currVal_140, currVal_141, currVal_142, currVal_143, currVal_144, currVal_145); var currVal_149 = core["ɵunv"](_v, 245, 0, core["ɵnov"](_v, 246).transform("email")); _ck(_v, 245, 0, currVal_149); var currVal_150 = (core["ɵnov"](_v, 254).required ? "" : null); var currVal_151 = (core["ɵnov"](_v, 255).maxlength ? core["ɵnov"](_v, 255).maxlength : null); var currVal_152 = (core["ɵnov"](_v, 256).pattern ? core["ɵnov"](_v, 256).pattern : null); var currVal_153 = core["ɵnov"](_v, 261).ngClassUntouched; var currVal_154 = core["ɵnov"](_v, 261).ngClassTouched; var currVal_155 = core["ɵnov"](_v, 261).ngClassPristine; var currVal_156 = core["ɵnov"](_v, 261).ngClassDirty; var currVal_157 = core["ɵnov"](_v, 261).ngClassValid; var currVal_158 = core["ɵnov"](_v, 261).ngClassInvalid; var currVal_159 = core["ɵnov"](_v, 261).ngClassPending; _ck(_v, 252, 0, currVal_150, currVal_151, currVal_152, currVal_153, currVal_154, currVal_155, currVal_156, currVal_157, currVal_158, currVal_159); var currVal_166 = core["ɵunv"](_v, 267, 0, core["ɵnov"](_v, 268).transform("userName")); _ck(_v, 267, 0, currVal_166); var currVal_167 = (core["ɵnov"](_v, 276).required ? "" : null); var currVal_168 = core["ɵnov"](_v, 281).ngClassUntouched; var currVal_169 = core["ɵnov"](_v, 281).ngClassTouched; var currVal_170 = core["ɵnov"](_v, 281).ngClassPristine; var currVal_171 = core["ɵnov"](_v, 281).ngClassDirty; var currVal_172 = core["ɵnov"](_v, 281).ngClassValid; var currVal_173 = core["ɵnov"](_v, 281).ngClassInvalid; var currVal_174 = core["ɵnov"](_v, 281).ngClassPending; _ck(_v, 274, 0, currVal_167, currVal_168, currVal_169, currVal_170, currVal_171, currVal_172, currVal_173, currVal_174); var currVal_178 = core["ɵunv"](_v, 285, 0, core["ɵnov"](_v, 286).transform("selectModuleDetails")); _ck(_v, 285, 0, currVal_178); var currVal_180 = _co.buttonDisabled; _ck(_v, 292, 0, currVal_180); var currVal_181 = core["ɵunv"](_v, 293, 0, core["ɵnov"](_v, 294).transform("createTenant")); _ck(_v, 293, 0, currVal_181); });
}
function View_CreateTenantComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "tenant-create", [], null, null, null, View_CreateTenantComponent_0, RenderType_CreateTenantComponent)), core["ɵdid"](1, 114688, null, 0, createTenant_CreateTenantComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], common["Location"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var CreateTenantComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("tenant-create", createTenant_CreateTenantComponent, View_CreateTenantComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/superAdmin/updateTenant.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,_.._.._node_modules_angular2_multiselect_dropdown_multiselect.component.ngfactory,angular2_multiselect_dropdown_multiselect.component,_.._.._node_modules_angular2_multiselect_dropdown_menu_item.ngfactory,angular2_multiselect_dropdown_menu_item,ng2_auto_complete_dist_ng2_auto_complete.directive,_angular_common,_updateTenant,_angular_router,_shared_permissions_permissions,_shared_services_configuration,_shared_services_http.client,_toasterComponent_toasterComponent,_angular_platform_browser PURE_IMPORTS_END */
















var styles_UpdateTenantComponent = [];
var RenderType_UpdateTenantComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_UpdateTenantComponent, data: {} });

function View_UpdateTenantComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["style", "color: #333;width: 150px;"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.context.item.name; _ck(_v, 1, 0, currVal_0); }); }
function View_UpdateTenantComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("selectPrimeAdmin")); _ck(_v, 1, 0, currVal_0); }); }
function View_UpdateTenantComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", ""]))], function (_ck, _v) { var currVal_0 = _v.context.$implicit.mobileAppKey; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit.mobileAppKey; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.mobileAppName; _ck(_v, 3, 0, currVal_2); }); }
function View_UpdateTenantComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 11, "div", [["class", "float-left text-center mb-1 mt-1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 10, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 5, "input", [["type", "checkbox"]], [[8, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.context.$implicit.assigned = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 0, "label", [["class", "mb-0 float-left mr-2"]], [[8, "htmlFor", 0]], null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 2, "p", [["class", "float-left text-13x mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_8 = core["ɵinlineInterpolate"](1, "", _v.context.index, ""); var currVal_9 = _v.context.$implicit.assigned; _ck(_v, 6, 0, currVal_8, currVal_9); }, function (_ck, _v) { var currVal_0 = _v.context.index; var currVal_1 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 8).ngClassValid; var currVal_6 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = _v.context.index; _ck(_v, 9, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 11, 0, core["ɵnov"](_v, 12).transform((_v.context.$implicit.operation + "_MODULE"))); _ck(_v, 11, 0, currVal_11); });
}
function View_UpdateTenantComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 253, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 252, "form", [["novalidate", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "submit"], [null, "reset"]], function (_v, en, $event) {
            var ad = true;
            if (("submit" === en)) {
                var pd_0 = (core["ɵnov"](_v, 3).onSubmit($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("reset" === en)) {
                var pd_1 = (core["ɵnov"](_v, 3).onReset() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bg"], [], null, null), core["ɵdid"](3, 4210688, [[1, 4], ["tenantForm", 4]], 0, fesm5_forms["NgForm"], [[8, null], [8, null]], null, null), core["ɵprd"](2048, null, fesm5_forms["ControlContainer"], null, [fesm5_forms["NgForm"]]), core["ɵdid"](5, 16384, null, 0, fesm5_forms["NgControlStatusGroup"], [[4, fesm5_forms["ControlContainer"]]], null, null), (_l()(), core["ɵeld"](6, 0, null, null, 234, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "h5", [["class", "m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 82, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 16, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](18, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](21, 0, null, null, 9, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 8, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 7, "input", [["class", "form-control"], ["min", "0"], ["name", "orgName"], ["required", ""], ["type", "text"]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 24)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 24).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 24)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 24)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.editTenantData.orgName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](24, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](25, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](28, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](30, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](31, 0, null, null, 23, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 5, "label", [["for", "lange"]], null, null, null, null, null)), (_l()(), core["ɵted"](33, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](35, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](38, 0, null, null, 16, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 15, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 14, "angular2-multiselect", [], [[8, "className", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.selectedLangItems = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AngularMultiSelect_0, RenderType_AngularMultiSelect)), core["ɵdid"](41, 13484032, null, 3, multiselect_component_AngularMultiSelect, [core["ElementRef"], core["ChangeDetectorRef"]], { data: [0, "data"], settings: [1, "settings"] }, null), core["ɵqud"](335544320, 2, { itemTempl: 0 }), core["ɵqud"](335544320, 3, { badgeTempl: 0 }), core["ɵqud"](335544320, 4, { searchTempl: 0 }), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵdid"](47, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"], options: [1, "options"] }, { update: "ngModelChange" }), core["ɵpod"](48, { standalone: 0 }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](50, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](51, 0, null, null, 3, "c-item", [], null, null, null, View_Item_0, RenderType_Item)), core["ɵdid"](52, 49152, [[2, 4]], 1, Item, [], null, null), core["ɵqud"](335544320, 5, { template: 0 }), (_l()(), core["ɵand"](0, [[5, 2]], null, 0, null, View_UpdateTenantComponent_2)), (_l()(), core["ɵeld"](55, 0, null, null, 20, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](56, 0, null, null, 19, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 18, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 5, "label", [["for", "primaryAdminInput"]], null, null, null, null, null)), (_l()(), core["ɵted"](59, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](61, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](64, 16777216, null, null, 9, "input", [["blank-option-text", "Select"], ["class", "form-control"], ["display-property-name", "displayName"], ["id", "sup"], ["max-num-list", "5"], ["name", "primaryAdminInput"], ["ng2-auto-complete", ""], ["required", ""], ["value-property-name", "id"]], [[8, "placeholder", 0], [1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "valueChanged"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 65)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 65).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 65)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 65)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.primaryAdmin = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("valueChanged" === en)) {
                var pd_5 = (_co.adminSelected() !== false);
                ad = (pd_5 && ad);
            }
            if (("input" === en)) {
                var pd_6 = (_co.adminChanged($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](65, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](66, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](69, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](71, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵdid"](72, 4931584, null, 0, ng2_auto_complete_directive["Ng2AutoCompleteDirective"], [core["ComponentFactoryResolver"], core["Renderer"], core["ViewContainerRef"], [3, fesm5_forms["ControlContainer"]]], { source: [0, "source"], displayPropertyName: [1, "displayPropertyName"], maxNumList: [2, "maxNumList"], listFormatter: [3, "listFormatter"], blankOptionText: [4, "blankOptionText"], noMatchFoundText: [5, "noMatchFoundText"], ngModel: [6, "ngModel"] }, { ngModelChange: "ngModelChange", valueChanged: "valueChanged" }), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UpdateTenantComponent_3)), core["ɵdid"](75, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](76, 0, null, null, 9, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](77, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](78, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](80, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](83, 0, null, null, 2, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](84, 0, null, null, 1, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](85, 0, null, null, 0, "input", [["class", "form-control"], ["disabled", ""], ["min", "0"], ["name", "orgName"], ["type", "text"]], [[8, "value", 0]], null, null, null, null)), (_l()(), core["ɵeld"](86, 0, null, null, 9, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](88, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](90, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](93, 0, null, null, 2, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](94, 0, null, null, 1, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](95, 0, null, null, 0, "input", [["class", "form-control"], ["disabled", ""], ["min", "0"], ["name", "orgName"], ["type", "text"]], [[8, "value", 0]], null, null, null, null)), (_l()(), core["ɵeld"](96, 0, null, null, 144, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](97, 0, null, null, 16, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](98, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](99, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](101, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](104, 0, null, null, 9, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](105, 0, null, null, 8, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](106, 0, null, null, 7, "input", [["class", "form-control"], ["name", "shortName"], ["required", ""], ["type", "text"]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 107)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 107).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 107)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 107)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.editTenantData.shortName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](107, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](108, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](111, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](113, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](114, 0, null, null, 94, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](115, 0, null, null, 5, "label", [["for", "timeZone"]], null, null, null, null, null)), (_l()(), core["ɵted"](116, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](118, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](121, 0, null, null, 87, "select", [["class", "form-control col-lg-9 col-md-9"], ["id", "timeZone"], ["name", "timeZone"], ["required", ""]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 122).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 122).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.editTenantData.timeZone = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](122, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](123, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](126, 671744, null, 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](128, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](129, 0, null, null, 4, "option", [["disabled", ""], ["selected", ""], ["value", ""]], null, null, null, null, null)), core["ɵdid"](130, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](131, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](132, null, ["--", "--"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](134, 0, null, null, 4, "option", [["value", "GMT+01:00"]], null, null, null, null, null)), core["ɵdid"](135, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](136, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](137, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](139, 0, null, null, 4, "option", [["value", "GMT+08:00"]], null, null, null, null, null)), core["ɵdid"](140, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](141, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](142, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](144, 0, null, null, 4, "option", [["value", "GMT+05:30"]], null, null, null, null, null)), core["ɵdid"](145, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](146, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](147, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](149, 0, null, null, 4, "option", [["value", "GMT+07:00"]], null, null, null, null, null)), core["ɵdid"](150, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](151, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](152, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](154, 0, null, null, 4, "option", [["value", "GMT+08:00"]], null, null, null, null, null)), core["ɵdid"](155, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](156, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](157, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](159, 0, null, null, 4, "option", [["value", "GMT+09:00"]], null, null, null, null, null)), core["ɵdid"](160, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](161, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](162, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](164, 0, null, null, 4, "option", [["value", "GMT+08:00"]], null, null, null, null, null)), core["ɵdid"](165, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](166, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](167, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](169, 0, null, null, 4, "option", [["value", "GMT+05:30"]], null, null, null, null, null)), core["ɵdid"](170, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](171, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](172, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](174, 0, null, null, 4, "option", [["value", "GMT+04:00"]], null, null, null, null, null)), core["ɵdid"](175, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](176, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](177, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](179, 0, null, null, 4, "option", [["value", "GMT-05:00"]], null, null, null, null, null)), core["ɵdid"](180, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](181, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](182, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](184, 0, null, null, 4, "option", [["value", "GMT-06:00"]], null, null, null, null, null)), core["ɵdid"](185, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](186, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](187, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](189, 0, null, null, 4, "option", [["value", "GMT-07:00"]], null, null, null, null, null)), core["ɵdid"](190, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](191, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](192, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](194, 0, null, null, 4, "option", [["value", "GMT-08:00"]], null, null, null, null, null)), core["ɵdid"](195, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](196, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](197, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](199, 0, null, null, 4, "option", [["value", "GMT-09:00"]], null, null, null, null, null)), core["ɵdid"](200, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](201, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](202, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](204, 0, null, null, 4, "option", [["value", "GMT-10:00"]], null, null, null, null, null)), core["ɵdid"](205, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](206, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](207, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](209, 0, null, null, 21, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](210, 0, null, null, 5, "label", [["for", "appName"]], null, null, null, null, null)), (_l()(), core["ɵted"](211, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](213, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](216, 0, null, null, 14, "select", [["class", "form-control col-lg-9 col-md-9"], ["id", "appName"], ["name", "appName"], ["required", ""]], [[1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 217).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 217).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.editTenantData.appName = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](217, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵdid"](218, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](221, 671744, [["appName", 4]], 0, fesm5_forms["NgModel"], [[2, fesm5_forms["ControlContainer"]], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](223, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](224, 0, null, null, 4, "option", [["disabled", ""], ["selected", ""], ["value", ""]], null, null, null, null, null)), core["ɵdid"](225, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](226, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](227, null, ["--", "--"])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UpdateTenantComponent_4)), core["ɵdid"](230, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](231, 0, null, null, 9, "div", [["class", "w-100 float-left form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](232, 0, null, null, 5, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](233, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](235, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵted"](-1, null, [":"])), (_l()(), core["ɵeld"](238, 0, null, null, 2, "div", [["class", "align-v-center w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](239, 0, null, null, 1, "div", [["class", "col-lg-9 col-md-9 col-sm-6 col-12 float-left p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](240, 0, null, null, 0, "input", [["class", "form-control"], ["disabled", ""], ["min", "0"], ["name", "orgName"], ["type", "text"]], [[8, "value", 0]], null, null, null, null)), (_l()(), core["ɵeld"](241, 0, null, null, 9, "div", [["class", "w-100 float-left light-bg p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](242, 0, null, null, 5, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](243, 0, null, null, 2, "h5", [["class", "m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](244, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](246, 0, null, null, 0, "div", [["class", "ml-alert"]], null, null, null, null, null)), (_l()(), core["ɵeld"](247, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](248, 0, null, null, 2, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UpdateTenantComponent_5)), core["ɵdid"](250, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](251, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mb-4 ml-4"], ["type", "submit"]], [[8, "disabled", 0], [8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.updateTenant() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](252, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_17 = ""; _ck(_v, 25, 0, currVal_17); var currVal_18 = "orgName"; var currVal_19 = _co.editTenantData.orgName; _ck(_v, 28, 0, currVal_18, currVal_19); var currVal_29 = _co.itemLangList; var currVal_30 = _co.langSettings; _ck(_v, 41, 0, currVal_29, currVal_30); var currVal_31 = _co.selectedLangItems; var currVal_32 = _ck(_v, 48, 0, true); _ck(_v, 47, 0, currVal_31, currVal_32); var currVal_43 = ""; _ck(_v, 66, 0, currVal_43); var currVal_44 = "primaryAdminInput"; var currVal_45 = _co.primaryAdmin; _ck(_v, 69, 0, currVal_44, currVal_45); var currVal_46 = _co.primaryAdminSource.bind(_co); var currVal_47 = "displayName"; var currVal_48 = "5"; var currVal_49 = _co.autoCompleteListFormatter; var currVal_50 = "Select"; var currVal_51 = _co.warning; var currVal_52 = _co.primaryAdmin; _ck(_v, 72, 0, currVal_46, currVal_47, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52); var currVal_53 = (_co.primaryAdminInput && _co.primaryAdminInput.notSelected); _ck(_v, 75, 0, currVal_53); var currVal_67 = ""; _ck(_v, 108, 0, currVal_67); var currVal_68 = "shortName"; var currVal_69 = _co.editTenantData.shortName; _ck(_v, 111, 0, currVal_68, currVal_69); var currVal_79 = ""; _ck(_v, 123, 0, currVal_79); var currVal_80 = "timeZone"; var currVal_81 = _co.editTenantData.timeZone; _ck(_v, 126, 0, currVal_80, currVal_81); var currVal_82 = ""; _ck(_v, 130, 0, currVal_82); var currVal_83 = ""; _ck(_v, 131, 0, currVal_83); var currVal_85 = "GMT+01:00"; _ck(_v, 135, 0, currVal_85); var currVal_86 = "GMT+01:00"; _ck(_v, 136, 0, currVal_86); var currVal_88 = "GMT+08:00"; _ck(_v, 140, 0, currVal_88); var currVal_89 = "GMT+08:00"; _ck(_v, 141, 0, currVal_89); var currVal_91 = "GMT+05:30"; _ck(_v, 145, 0, currVal_91); var currVal_92 = "GMT+05:30"; _ck(_v, 146, 0, currVal_92); var currVal_94 = "GMT+07:00"; _ck(_v, 150, 0, currVal_94); var currVal_95 = "GMT+07:00"; _ck(_v, 151, 0, currVal_95); var currVal_97 = "GMT+08:00"; _ck(_v, 155, 0, currVal_97); var currVal_98 = "GMT+08:00"; _ck(_v, 156, 0, currVal_98); var currVal_100 = "GMT+09:00"; _ck(_v, 160, 0, currVal_100); var currVal_101 = "GMT+09:00"; _ck(_v, 161, 0, currVal_101); var currVal_103 = "GMT+08:00"; _ck(_v, 165, 0, currVal_103); var currVal_104 = "GMT+08:00"; _ck(_v, 166, 0, currVal_104); var currVal_106 = "GMT+05:30"; _ck(_v, 170, 0, currVal_106); var currVal_107 = "GMT+05:30"; _ck(_v, 171, 0, currVal_107); var currVal_109 = "GMT+04:00"; _ck(_v, 175, 0, currVal_109); var currVal_110 = "GMT+04:00"; _ck(_v, 176, 0, currVal_110); var currVal_112 = "GMT-05:00"; _ck(_v, 180, 0, currVal_112); var currVal_113 = "GMT-05:00"; _ck(_v, 181, 0, currVal_113); var currVal_115 = "GMT-06:00"; _ck(_v, 185, 0, currVal_115); var currVal_116 = "GMT-06:00"; _ck(_v, 186, 0, currVal_116); var currVal_118 = "GMT-07:00"; _ck(_v, 190, 0, currVal_118); var currVal_119 = "GMT-07:00"; _ck(_v, 191, 0, currVal_119); var currVal_121 = "GMT-08:00"; _ck(_v, 195, 0, currVal_121); var currVal_122 = "GMT-08:00"; _ck(_v, 196, 0, currVal_122); var currVal_124 = "GMT-09:00"; _ck(_v, 200, 0, currVal_124); var currVal_125 = "GMT-09:00"; _ck(_v, 201, 0, currVal_125); var currVal_127 = "GMT-10:00"; _ck(_v, 205, 0, currVal_127); var currVal_128 = "GMT-10:00"; _ck(_v, 206, 0, currVal_128); var currVal_139 = ""; _ck(_v, 218, 0, currVal_139); var currVal_140 = "appName"; var currVal_141 = _co.editTenantData.appName; _ck(_v, 221, 0, currVal_140, currVal_141); var currVal_142 = ""; _ck(_v, 225, 0, currVal_142); var currVal_143 = ""; _ck(_v, 226, 0, currVal_143); var currVal_145 = _co.apps; _ck(_v, 230, 0, currVal_145); var currVal_149 = _co.modules; _ck(_v, 250, 0, currVal_149); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵnov"](_v, 5).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 5).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 5).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 5).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 5).ngClassValid; var currVal_5 = core["ɵnov"](_v, 5).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 5).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_7 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("tenantDetails")); _ck(_v, 9, 0, currVal_7); var currVal_8 = core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 17).transform("tenantName")); _ck(_v, 16, 0, currVal_8); var currVal_9 = (core["ɵnov"](_v, 25).required ? "" : null); var currVal_10 = core["ɵnov"](_v, 30).ngClassUntouched; var currVal_11 = core["ɵnov"](_v, 30).ngClassTouched; var currVal_12 = core["ɵnov"](_v, 30).ngClassPristine; var currVal_13 = core["ɵnov"](_v, 30).ngClassDirty; var currVal_14 = core["ɵnov"](_v, 30).ngClassValid; var currVal_15 = core["ɵnov"](_v, 30).ngClassInvalid; var currVal_16 = core["ɵnov"](_v, 30).ngClassPending; _ck(_v, 23, 0, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16); var currVal_20 = core["ɵunv"](_v, 33, 0, core["ɵnov"](_v, 34).transform("language")); _ck(_v, 33, 0, currVal_20); var currVal_21 = core["ɵnov"](_v, 41).defaultSettings.classes; var currVal_22 = core["ɵnov"](_v, 50).ngClassUntouched; var currVal_23 = core["ɵnov"](_v, 50).ngClassTouched; var currVal_24 = core["ɵnov"](_v, 50).ngClassPristine; var currVal_25 = core["ɵnov"](_v, 50).ngClassDirty; var currVal_26 = core["ɵnov"](_v, 50).ngClassValid; var currVal_27 = core["ɵnov"](_v, 50).ngClassInvalid; var currVal_28 = core["ɵnov"](_v, 50).ngClassPending; _ck(_v, 40, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28); var currVal_33 = core["ɵunv"](_v, 59, 0, core["ɵnov"](_v, 60).transform("primeAdmin")); _ck(_v, 59, 0, currVal_33); var currVal_34 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 64, 0, core["ɵnov"](_v, 73).transform("typeAndChooseThePrimaryAdmin")), ""); var currVal_35 = (core["ɵnov"](_v, 66).required ? "" : null); var currVal_36 = core["ɵnov"](_v, 71).ngClassUntouched; var currVal_37 = core["ɵnov"](_v, 71).ngClassTouched; var currVal_38 = core["ɵnov"](_v, 71).ngClassPristine; var currVal_39 = core["ɵnov"](_v, 71).ngClassDirty; var currVal_40 = core["ɵnov"](_v, 71).ngClassValid; var currVal_41 = core["ɵnov"](_v, 71).ngClassInvalid; var currVal_42 = core["ɵnov"](_v, 71).ngClassPending; _ck(_v, 64, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42); var currVal_54 = core["ɵunv"](_v, 78, 0, core["ɵnov"](_v, 79).transform("tenantBaseUrl")); _ck(_v, 78, 0, currVal_54); var currVal_55 = core["ɵinlineInterpolate"](1, "", _co.editTenantData.baseUrl, ""); _ck(_v, 85, 0, currVal_55); var currVal_56 = core["ɵunv"](_v, 88, 0, core["ɵnov"](_v, 89).transform("email")); _ck(_v, 88, 0, currVal_56); var currVal_57 = core["ɵinlineInterpolate"](1, "", _co.editTenantData.primaryAdminEmail, ""); _ck(_v, 95, 0, currVal_57); var currVal_58 = core["ɵunv"](_v, 99, 0, core["ɵnov"](_v, 100).transform("tenantShortName")); _ck(_v, 99, 0, currVal_58); var currVal_59 = (core["ɵnov"](_v, 108).required ? "" : null); var currVal_60 = core["ɵnov"](_v, 113).ngClassUntouched; var currVal_61 = core["ɵnov"](_v, 113).ngClassTouched; var currVal_62 = core["ɵnov"](_v, 113).ngClassPristine; var currVal_63 = core["ɵnov"](_v, 113).ngClassDirty; var currVal_64 = core["ɵnov"](_v, 113).ngClassValid; var currVal_65 = core["ɵnov"](_v, 113).ngClassInvalid; var currVal_66 = core["ɵnov"](_v, 113).ngClassPending; _ck(_v, 106, 0, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66); var currVal_70 = core["ɵunv"](_v, 116, 0, core["ɵnov"](_v, 117).transform("timeZone")); _ck(_v, 116, 0, currVal_70); var currVal_71 = (core["ɵnov"](_v, 123).required ? "" : null); var currVal_72 = core["ɵnov"](_v, 128).ngClassUntouched; var currVal_73 = core["ɵnov"](_v, 128).ngClassTouched; var currVal_74 = core["ɵnov"](_v, 128).ngClassPristine; var currVal_75 = core["ɵnov"](_v, 128).ngClassDirty; var currVal_76 = core["ɵnov"](_v, 128).ngClassValid; var currVal_77 = core["ɵnov"](_v, 128).ngClassInvalid; var currVal_78 = core["ɵnov"](_v, 128).ngClassPending; _ck(_v, 121, 0, currVal_71, currVal_72, currVal_73, currVal_74, currVal_75, currVal_76, currVal_77, currVal_78); var currVal_84 = core["ɵunv"](_v, 132, 0, core["ɵnov"](_v, 133).transform("select")); _ck(_v, 132, 0, currVal_84); var currVal_87 = core["ɵunv"](_v, 137, 0, core["ɵnov"](_v, 138).transform("UTCCETGermany")); _ck(_v, 137, 0, currVal_87); var currVal_90 = core["ɵunv"](_v, 142, 0, core["ɵnov"](_v, 143).transform("UTCMSTMalaysia")); _ck(_v, 142, 0, currVal_90); var currVal_93 = core["ɵunv"](_v, 147, 0, core["ɵnov"](_v, 148).transform("UTCISTIndia")); _ck(_v, 147, 0, currVal_93); var currVal_96 = core["ɵunv"](_v, 152, 0, core["ɵnov"](_v, 153).transform("UTCIWSTIndonesia")); _ck(_v, 152, 0, currVal_96); var currVal_99 = core["ɵunv"](_v, 157, 0, core["ɵnov"](_v, 158).transform("UTCICSTIndonesia")); _ck(_v, 157, 0, currVal_99); var currVal_102 = core["ɵunv"](_v, 162, 0, core["ɵnov"](_v, 163).transform("UTCIESTIndonesia")); _ck(_v, 162, 0, currVal_102); var currVal_105 = core["ɵunv"](_v, 167, 0, core["ɵnov"](_v, 168).transform("UTCSSTSingapore")); _ck(_v, 167, 0, currVal_105); var currVal_108 = core["ɵunv"](_v, 172, 0, core["ɵnov"](_v, 173).transform("UTCSLSTSriLanka")); _ck(_v, 172, 0, currVal_108); var currVal_111 = core["ɵunv"](_v, 177, 0, core["ɵnov"](_v, 178).transform("UTCGSTUAE")); _ck(_v, 177, 0, currVal_111); var currVal_114 = core["ɵunv"](_v, 182, 0, core["ɵnov"](_v, 183).transform("UTCESTUSA")); _ck(_v, 182, 0, currVal_114); var currVal_117 = core["ɵunv"](_v, 187, 0, core["ɵnov"](_v, 188).transform("UTCCSTUSA")); _ck(_v, 187, 0, currVal_117); var currVal_120 = core["ɵunv"](_v, 192, 0, core["ɵnov"](_v, 193).transform("UTCMSTUSA")); _ck(_v, 192, 0, currVal_120); var currVal_123 = core["ɵunv"](_v, 197, 0, core["ɵnov"](_v, 198).transform("UTCPSTUSA")); _ck(_v, 197, 0, currVal_123); var currVal_126 = core["ɵunv"](_v, 202, 0, core["ɵnov"](_v, 203).transform("UTCASTUSA")); _ck(_v, 202, 0, currVal_126); var currVal_129 = core["ɵunv"](_v, 207, 0, core["ɵnov"](_v, 208).transform("UTCHSTUSA")); _ck(_v, 207, 0, currVal_129); var currVal_130 = core["ɵunv"](_v, 211, 0, core["ɵnov"](_v, 212).transform("app")); _ck(_v, 211, 0, currVal_130); var currVal_131 = (core["ɵnov"](_v, 218).required ? "" : null); var currVal_132 = core["ɵnov"](_v, 223).ngClassUntouched; var currVal_133 = core["ɵnov"](_v, 223).ngClassTouched; var currVal_134 = core["ɵnov"](_v, 223).ngClassPristine; var currVal_135 = core["ɵnov"](_v, 223).ngClassDirty; var currVal_136 = core["ɵnov"](_v, 223).ngClassValid; var currVal_137 = core["ɵnov"](_v, 223).ngClassInvalid; var currVal_138 = core["ɵnov"](_v, 223).ngClassPending; _ck(_v, 216, 0, currVal_131, currVal_132, currVal_133, currVal_134, currVal_135, currVal_136, currVal_137, currVal_138); var currVal_144 = core["ɵunv"](_v, 227, 0, core["ɵnov"](_v, 228).transform("select")); _ck(_v, 227, 0, currVal_144); var currVal_146 = core["ɵunv"](_v, 233, 0, core["ɵnov"](_v, 234).transform("userName")); _ck(_v, 233, 0, currVal_146); var currVal_147 = core["ɵinlineInterpolate"](1, "", _co.editTenantData.primaryAdminUserName, ""); _ck(_v, 240, 0, currVal_147); var currVal_148 = core["ɵunv"](_v, 244, 0, core["ɵnov"](_v, 245).transform("selectModuleDetails")); _ck(_v, 244, 0, currVal_148); var currVal_150 = core["ɵnov"](_v, 3).invalid; var currVal_151 = _co.buttonDisabled; _ck(_v, 251, 0, currVal_150, currVal_151); var currVal_152 = core["ɵunv"](_v, 252, 0, core["ɵnov"](_v, 253).transform("updateTenant")); _ck(_v, 252, 0, currVal_152); });
}
function View_UpdateTenantComponent_0(_l) {
    return core["ɵvid"](0, [core["ɵqud"](671088640, 1, { tenantForm: 0 }), (_l()(), core["ɵeld"](1, 0, null, null, 10, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "button", [["class", "btn float-left mb-2"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.goBack() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](8, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_UpdateTenantComponent_1)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = _co.editTenantData; _ck(_v, 11, 0, currVal_2); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("createTenant")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("back")); _ck(_v, 8, 0, currVal_1); });
}
function View_UpdateTenantComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "update-tenant", [], null, null, null, View_UpdateTenantComponent_0, RenderType_UpdateTenantComponent)), core["ɵdid"](1, 114688, null, 0, updateTenant_UpdateTenantComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, ToasterComponent, core["ViewContainerRef"], common["Location"], core_es5["j" /* TranslateService */], platform_browser["c" /* DomSanitizer */]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var UpdateTenantComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("update-tenant", updateTenant_UpdateTenantComponent, View_UpdateTenantComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/notificationGridComponent.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_ng_bootstrap_ng_bootstrap_collapse_collapse,_.._.._.._node_modules_angular2_multiselect_dropdown_multiselect.component.ngfactory,angular2_multiselect_dropdown_multiselect.component,_.._.._.._node_modules_angular2_multiselect_dropdown_menu_item.ngfactory,angular2_multiselect_dropdown_menu_item,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_notificationGridComponent,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_angular_platform_browser,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */























var styles_NotificationGridComponent = [];
var RenderType_NotificationGridComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NotificationGridComponent, data: {} });

function View_NotificationGridComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "input", [["style", "border: none;width: 100%; height: 100%;outline: none;"], ["type", "text"]], [[8, "placeholder", 0]], [[null, "keyup"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("keyup" === en)) {
                var pd_0 = (_co.searchStrategy($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 0, 0, core["ɵnov"](_v, 1).transform("search")), ""); _ck(_v, 0, 0, currVal_0); });
}
function View_NotificationGridComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["style", "color: #333;"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.context.item.value; _ck(_v, 1, 0, currVal_0); }); }
function View_NotificationGridComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "input", [["style", "border: none;width: 100%; height: 100%;outline: none;"], ["type", "text"]], [[8, "placeholder", 0]], [[null, "keyup"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("keyup" === en)) {
                var pd_0 = (_co.searchStrategyChannel($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 0, 0, core["ɵnov"](_v, 1).transform("search")), ""); _ck(_v, 0, 0, currVal_0); });
}
function View_NotificationGridComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "label", [["style", "color: #333;"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var currVal_0 = _v.context.item.value; _ck(_v, 1, 0, currVal_0); }); }
function View_NotificationGridComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.context.$implicit)); _ck(_v, 3, 0, currVal_2); }); }
function View_NotificationGridComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 4, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.editNotification(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("edit")); _ck(_v, 5, 0, currVal_0); });
}
function View_NotificationGridComponent_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 21, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, [" ", " "])), (_l()(), core["ɵeld"](16, 0, null, null, 5, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 16777216, null, null, 2, "h6", [["class", "mb-lg-0"], ["ngbTooltip", "Click for more options"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.tableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](18, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](19, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationGridComponent_8)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_5 = "Click for more options"; _ck(_v, 18, 0, currVal_5); var currVal_6 = (_v.context.index == _co.trackHides); _ck(_v, 21, 0, currVal_6); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.notificationId; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.name; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.description; _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.notificationChannel; _ck(_v, 12, 0, currVal_3); var currVal_4 = _v.context.$implicit.isDisabled; _ck(_v, 15, 0, currVal_4); });
}
function View_NotificationGridComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationGridComponent_7)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.notifications.content; _ck(_v, 2, 0, currVal_0); }, null); }
function View_NotificationGridComponent_10(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_NotificationGridComponent_11(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_NotificationGridComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationGridComponent_10)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationGridComponent_11)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_NotificationGridComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 186, "div", [["class", "w-100 float-left text-13x"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "w-100 float-left v-align relative"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 3, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 119, "div", [["class", "w-100 float-left p-3 light-bg mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 2, "h6", [["class", "medium mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](8, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](10, 0, null, null, 115, "div", [["class", "form-group mt-2 w-75 d-inline-flex relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 7, "div", [["class", "relative w-75"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "keyup.enter"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 13)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 13).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 13)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 13)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notificationFilter.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("keyup.enter" === en)) {
                var pd_5 = (_co.searchAndFetchNotificationByFilterData() !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](13, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](15, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](17, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](18, 0, null, null, 0, "i", [["aria-controls", "collapseExample"], ["class", "fa fa-caret-down tr-0"]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleSearch() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 2, "button", [["class", "btn btn-primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchAndFetchNotificationByFilterData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](20, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](22, 0, null, null, 103, "div", [["class", "w-75 absolute top-100 left-0 p-3 white-bg z-i shadow"], ["id", "collapseExample"]], [[2, "collapse", null], [2, "show", null]], null, null, null, null)), core["ɵdid"](23, 16384, null, 0, NgbCollapse, [], { collapsed: [0, "collapsed"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 101, "div", [["class", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 10, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](28, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 6, "input", [["class", "form-control"], ["type", "text"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "keyup.enter"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notificationFilter.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("keyup.enter" === en)) {
                _co.searchAndFetchNotificationByFilterData();
                var pd_5 = (_co.toggleSearch() !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](31, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](33, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](35, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](37, 0, null, null, 11, "div", [["class", "col-lg-12 col-md-12 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 10, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](40, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](42, 0, null, null, 6, "input", [["class", "form-control"], ["type", "text"]], [[8, "placeholder", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "keyup.enter"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 43)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 43).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 43)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 43)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notificationFilter.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("keyup.enter" === en)) {
                _co.searchAndFetchNotificationByFilterData();
                var pd_5 = (_co.toggleSearch() !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](43, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](45, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](47, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](49, 0, null, null, 23, "div", [["class", "col-lg-12 col-md-12 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 22, "div", [["class", "form-group w-100"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchStrategy("") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 3, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](52, null, [" ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](55, 0, null, null, 17, "angular2-multiselect", [], [[8, "className", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.selectedNotificationTypeItems = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AngularMultiSelect_0, RenderType_AngularMultiSelect)), core["ɵdid"](56, 13484032, null, 3, multiselect_component_AngularMultiSelect, [core["ElementRef"], core["ChangeDetectorRef"]], { data: [0, "data"], settings: [1, "settings"] }, null), core["ɵqud"](335544320, 1, { itemTempl: 0 }), core["ɵqud"](335544320, 2, { badgeTempl: 0 }), core["ɵqud"](335544320, 3, { searchTempl: 0 }), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵdid"](62, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](64, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](65, 0, null, null, 3, "c-search", [], null, null, null, View_Search_0, RenderType_Search)), core["ɵdid"](66, 49152, [[3, 4]], 1, Search, [], null, null), core["ɵqud"](335544320, 4, { template: 0 }), (_l()(), core["ɵand"](0, [[4, 2]], null, 0, null, View_NotificationGridComponent_1)), (_l()(), core["ɵeld"](69, 0, null, null, 3, "c-item", [], null, null, null, View_Item_0, RenderType_Item)), core["ɵdid"](70, 49152, [[1, 4]], 1, Item, [], null, null), core["ɵqud"](335544320, 5, { template: 0 }), (_l()(), core["ɵand"](0, [[5, 2]], null, 0, null, View_NotificationGridComponent_2)), (_l()(), core["ɵeld"](73, 0, null, null, 22, "div", [["class", "col-lg-12 col-md-12 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](74, 0, null, null, 21, "div", [["class", "form-group w-100"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchStrategy("") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](75, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](76, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](78, 0, null, null, 17, "angular2-multiselect", [], [[8, "className", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.selectedNotificationChannels = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_AngularMultiSelect_0, RenderType_AngularMultiSelect)), core["ɵdid"](79, 13484032, null, 3, multiselect_component_AngularMultiSelect, [core["ElementRef"], core["ChangeDetectorRef"]], { data: [0, "data"], settings: [1, "settings"] }, null), core["ɵqud"](335544320, 6, { itemTempl: 0 }), core["ɵqud"](335544320, 7, { badgeTempl: 0 }), core["ɵqud"](335544320, 8, { searchTempl: 0 }), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [multiselect_component_AngularMultiSelect]), core["ɵdid"](85, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](87, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](88, 0, null, null, 3, "c-search", [], null, null, null, View_Search_0, RenderType_Search)), core["ɵdid"](89, 49152, [[8, 4]], 1, Search, [], null, null), core["ɵqud"](335544320, 9, { template: 0 }), (_l()(), core["ɵand"](0, [[9, 2]], null, 0, null, View_NotificationGridComponent_3)), (_l()(), core["ɵeld"](92, 0, null, null, 3, "c-item", [], null, null, null, View_Item_0, RenderType_Item)), core["ɵdid"](93, 49152, [[6, 4]], 1, Item, [], null, null), core["ɵqud"](335544320, 10, { template: 0 }), (_l()(), core["ɵand"](0, [[10, 2]], null, 0, null, View_NotificationGridComponent_4)), (_l()(), core["ɵeld"](96, 0, null, null, 19, "div", [["class", "col-lg-12 col-md-12 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](97, 0, null, null, 3, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](98, null, [" ", " ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](101, 0, null, null, 14, "select", [["class", "form-control w-100"], ["name", "selectedNotificationGroup"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 102).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 102).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.selectedNotificationGroup = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](102, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](104, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](106, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](107, 0, null, null, 6, "option", [["disabled", ""], ["selected", ""], ["value", "null"]], null, null, null, null, null)), core["ɵdid"](108, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](109, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](110, null, ["", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationGridComponent_5)), core["ɵdid"](115, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](116, 0, null, null, 9, "div", [["class", "col-12 mt "]], null, null, null, null, null)), (_l()(), core["ɵeld"](117, 0, null, null, 2, "button", [["class", "btn btn-link float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.reset() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](118, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](120, 0, null, null, 2, "button", [["class", "btn btn-primary float-right ml-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                _co.searchAndFetchNotificationByFilterData();
                var pd_0 = (_co.toggleSearch() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](121, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](123, 0, null, null, 2, "button", [["aria-controls", "collapseExample"], ["class", "btn btn-light float-right"]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.toggleSearch() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](124, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](126, 0, null, null, 60, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](127, 0, null, null, 24, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](128, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](129, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](130, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](132, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](133, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](134, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](136, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](137, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](138, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](140, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](141, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](142, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](144, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](145, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](146, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](148, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](149, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](150, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationGridComponent_6)), core["ɵdid"](153, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationGridComponent_9)), core["ɵdid"](155, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](156, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](157, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](158, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](160, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](161, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](162, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](164, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSize"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 165).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 165).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.notificationFilter.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.onPageSizeChanged() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](165, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](167, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](169, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](170, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](171, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](172, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](174, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](175, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](176, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](178, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](179, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](180, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](182, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](183, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.notificationFilter.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](184, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](185, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](186, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_9 = _co.notificationFilter.name; _ck(_v, 15, 0, currVal_9); var currVal_14 = !_co.showSearchFilter; _ck(_v, 23, 0, currVal_14); var currVal_24 = _co.notificationFilter.name; _ck(_v, 33, 0, currVal_24); var currVal_34 = _co.notificationFilter.description; _ck(_v, 45, 0, currVal_34); var currVal_45 = _co.notificationTypesTranslated; var currVal_46 = _co.notificationTypesSettings; _ck(_v, 56, 0, currVal_45, currVal_46); var currVal_47 = _co.selectedNotificationTypeItems; _ck(_v, 62, 0, currVal_47); var currVal_57 = _co.notificationChannelsFiltered; var currVal_58 = _co.notificationTypesSettings; _ck(_v, 79, 0, currVal_57, currVal_58); var currVal_59 = _co.selectedNotificationChannels; _ck(_v, 85, 0, currVal_59); var currVal_69 = "selectedNotificationGroup"; var currVal_70 = _co.selectedNotificationGroup; _ck(_v, 104, 0, currVal_69, currVal_70); var currVal_71 = "null"; _ck(_v, 108, 0, currVal_71); var currVal_72 = "null"; _ck(_v, 109, 0, currVal_72); var currVal_76 = _co.allNotificationGroups; _ck(_v, 115, 0, currVal_76); var currVal_87 = (_co.notifications && (_co.notifications.content.length > 0)); _ck(_v, 153, 0, currVal_87); var currVal_88 = (_co.notifications && (_co.notifications.content.length == 0)); _ck(_v, 155, 0, currVal_88); var currVal_101 = "pageSize"; var currVal_102 = _co.notificationFilter.pageSize; _ck(_v, 167, 0, currVal_101, currVal_102); var currVal_103 = "10"; _ck(_v, 171, 0, currVal_103); var currVal_104 = "10"; _ck(_v, 172, 0, currVal_104); var currVal_105 = "20"; _ck(_v, 175, 0, currVal_105); var currVal_106 = "20"; _ck(_v, 176, 0, currVal_106); var currVal_107 = "30"; _ck(_v, 179, 0, currVal_107); var currVal_108 = "30"; _ck(_v, 180, 0, currVal_108); var currVal_109 = true; var currVal_110 = false; var currVal_111 = true; var currVal_112 = _co.notifications.totalElements; var currVal_113 = 5; var currVal_114 = _co.notificationFilter.page; var currVal_115 = _co.notificationFilter.pageSize; _ck(_v, 184, 0, currVal_109, currVal_110, currVal_111, currVal_112, currVal_113, currVal_114, currVal_115); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("notificationEditor")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 8, 0, core["ɵnov"](_v, 9).transform("filters")); _ck(_v, 8, 0, currVal_1); var currVal_2 = core["ɵnov"](_v, 17).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 17).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 17).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 17).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 17).ngClassValid; var currVal_7 = core["ɵnov"](_v, 17).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 17).ngClassPending; _ck(_v, 12, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_10 = !_co.showSearchFilter; _ck(_v, 18, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("search")); _ck(_v, 20, 0, currVal_11); var currVal_12 = true; var currVal_13 = !core["ɵnov"](_v, 23).collapsed; _ck(_v, 22, 0, currVal_12, currVal_13); var currVal_15 = core["ɵunv"](_v, 28, 0, core["ɵnov"](_v, 29).transform("name")); _ck(_v, 28, 0, currVal_15); var currVal_16 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 30, 0, core["ɵnov"](_v, 36).transform("name")), " "); var currVal_17 = core["ɵnov"](_v, 35).ngClassUntouched; var currVal_18 = core["ɵnov"](_v, 35).ngClassTouched; var currVal_19 = core["ɵnov"](_v, 35).ngClassPristine; var currVal_20 = core["ɵnov"](_v, 35).ngClassDirty; var currVal_21 = core["ɵnov"](_v, 35).ngClassValid; var currVal_22 = core["ɵnov"](_v, 35).ngClassInvalid; var currVal_23 = core["ɵnov"](_v, 35).ngClassPending; _ck(_v, 30, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22, currVal_23); var currVal_25 = core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 41).transform("description")); _ck(_v, 40, 0, currVal_25); var currVal_26 = core["ɵinlineInterpolate"](1, " ", core["ɵunv"](_v, 42, 0, core["ɵnov"](_v, 48).transform("description")), ""); var currVal_27 = core["ɵnov"](_v, 47).ngClassUntouched; var currVal_28 = core["ɵnov"](_v, 47).ngClassTouched; var currVal_29 = core["ɵnov"](_v, 47).ngClassPristine; var currVal_30 = core["ɵnov"](_v, 47).ngClassDirty; var currVal_31 = core["ɵnov"](_v, 47).ngClassValid; var currVal_32 = core["ɵnov"](_v, 47).ngClassInvalid; var currVal_33 = core["ɵnov"](_v, 47).ngClassPending; _ck(_v, 42, 0, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33); var currVal_35 = core["ɵunv"](_v, 52, 0, core["ɵnov"](_v, 53).transform("notification")); var currVal_36 = core["ɵunv"](_v, 52, 1, core["ɵnov"](_v, 54).transform("types")); _ck(_v, 52, 0, currVal_35, currVal_36); var currVal_37 = core["ɵnov"](_v, 56).defaultSettings.classes; var currVal_38 = core["ɵnov"](_v, 64).ngClassUntouched; var currVal_39 = core["ɵnov"](_v, 64).ngClassTouched; var currVal_40 = core["ɵnov"](_v, 64).ngClassPristine; var currVal_41 = core["ɵnov"](_v, 64).ngClassDirty; var currVal_42 = core["ɵnov"](_v, 64).ngClassValid; var currVal_43 = core["ɵnov"](_v, 64).ngClassInvalid; var currVal_44 = core["ɵnov"](_v, 64).ngClassPending; _ck(_v, 55, 0, currVal_37, currVal_38, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44); var currVal_48 = core["ɵunv"](_v, 76, 0, core["ɵnov"](_v, 77).transform("notificationChannels")); _ck(_v, 76, 0, currVal_48); var currVal_49 = core["ɵnov"](_v, 79).defaultSettings.classes; var currVal_50 = core["ɵnov"](_v, 87).ngClassUntouched; var currVal_51 = core["ɵnov"](_v, 87).ngClassTouched; var currVal_52 = core["ɵnov"](_v, 87).ngClassPristine; var currVal_53 = core["ɵnov"](_v, 87).ngClassDirty; var currVal_54 = core["ɵnov"](_v, 87).ngClassValid; var currVal_55 = core["ɵnov"](_v, 87).ngClassInvalid; var currVal_56 = core["ɵnov"](_v, 87).ngClassPending; _ck(_v, 78, 0, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56); var currVal_60 = core["ɵunv"](_v, 98, 0, core["ɵnov"](_v, 99).transform("notification")); var currVal_61 = core["ɵunv"](_v, 98, 1, core["ɵnov"](_v, 100).transform("groups")); _ck(_v, 98, 0, currVal_60, currVal_61); var currVal_62 = core["ɵnov"](_v, 106).ngClassUntouched; var currVal_63 = core["ɵnov"](_v, 106).ngClassTouched; var currVal_64 = core["ɵnov"](_v, 106).ngClassPristine; var currVal_65 = core["ɵnov"](_v, 106).ngClassDirty; var currVal_66 = core["ɵnov"](_v, 106).ngClassValid; var currVal_67 = core["ɵnov"](_v, 106).ngClassInvalid; var currVal_68 = core["ɵnov"](_v, 106).ngClassPending; _ck(_v, 101, 0, currVal_62, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68); var currVal_73 = core["ɵunv"](_v, 110, 0, core["ɵnov"](_v, 111).transform("select")); var currVal_74 = core["ɵunv"](_v, 110, 1, core["ɵnov"](_v, 112).transform("notification")); var currVal_75 = core["ɵunv"](_v, 110, 2, core["ɵnov"](_v, 113).transform("groups")); _ck(_v, 110, 0, currVal_73, currVal_74, currVal_75); var currVal_77 = core["ɵunv"](_v, 118, 0, core["ɵnov"](_v, 119).transform("resetKey")); _ck(_v, 118, 0, currVal_77); var currVal_78 = core["ɵunv"](_v, 121, 0, core["ɵnov"](_v, 122).transform("apply")); _ck(_v, 121, 0, currVal_78); var currVal_79 = !_co.showSearchFilter; _ck(_v, 123, 0, currVal_79); var currVal_80 = core["ɵunv"](_v, 124, 0, core["ɵnov"](_v, 125).transform("close")); _ck(_v, 124, 0, currVal_80); var currVal_81 = core["ɵunv"](_v, 130, 0, core["ɵnov"](_v, 131).transform("notificationId")); _ck(_v, 130, 0, currVal_81); var currVal_82 = core["ɵunv"](_v, 134, 0, core["ɵnov"](_v, 135).transform("name")); _ck(_v, 134, 0, currVal_82); var currVal_83 = core["ɵunv"](_v, 138, 0, core["ɵnov"](_v, 139).transform("description")); _ck(_v, 138, 0, currVal_83); var currVal_84 = core["ɵunv"](_v, 142, 0, core["ɵnov"](_v, 143).transform("notificationChannel")); _ck(_v, 142, 0, currVal_84); var currVal_85 = core["ɵunv"](_v, 146, 0, core["ɵnov"](_v, 147).transform("disabled")); _ck(_v, 146, 0, currVal_85); var currVal_86 = core["ɵunv"](_v, 150, 0, core["ɵnov"](_v, 151).transform("action")); _ck(_v, 150, 0, currVal_86); var currVal_89 = (((_co.notificationFilter.page - 1) * _co.notificationFilter.pageSize) + 1); var currVal_90 = ((_co.notificationFilter.pageSize * (_co.notificationFilter.page - 1)) + _co.notifications.numberOfElements); var currVal_91 = core["ɵunv"](_v, 158, 2, core["ɵnov"](_v, 159).transform("itemsOf")); var currVal_92 = _co.notifications.totalElements; _ck(_v, 158, 0, currVal_89, currVal_90, currVal_91, currVal_92); var currVal_93 = core["ɵunv"](_v, 162, 0, core["ɵnov"](_v, 163).transform("showItemsPerPage")); _ck(_v, 162, 0, currVal_93); var currVal_94 = core["ɵnov"](_v, 169).ngClassUntouched; var currVal_95 = core["ɵnov"](_v, 169).ngClassTouched; var currVal_96 = core["ɵnov"](_v, 169).ngClassPristine; var currVal_97 = core["ɵnov"](_v, 169).ngClassDirty; var currVal_98 = core["ɵnov"](_v, 169).ngClassValid; var currVal_99 = core["ɵnov"](_v, 169).ngClassInvalid; var currVal_100 = core["ɵnov"](_v, 169).ngClassPending; _ck(_v, 164, 0, currVal_94, currVal_95, currVal_96, currVal_97, currVal_98, currVal_99, currVal_100); });
}
function View_NotificationGridComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "NotificationGrid", [], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NotificationGridComponent_0, RenderType_NotificationGridComponent)), core["ɵdid"](1, 49152, null, 0, notificationGridComponent_NotificationGridComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], null, null)], null, null);
}
var NotificationGridComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("NotificationGrid", notificationGridComponent_NotificationGridComponent, View_NotificationGridComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/directives/scroll-top-on-condition.ts
var ScrollTopDirective = /*@__PURE__*/ (function () {
    function ScrollTopDirective(elRef) {
        this.elRef = elRef;
    }
    ScrollTopDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            var element = _this.elRef.nativeElement;
            element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        });
    };
    return ScrollTopDirective;
}());



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/editNotificationLangComponent.ts

var editNotificationLangComponent_EditNotificationLangComponent = /*@__PURE__*/ (function () {
    function EditNotificationLangComponent(route, modalService, router, _global, _http, _auth, eRef, share, _sanitizer, builder, _toaster, _location, vcr, translate) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this._http = _http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this._location = _location;
        this.vcr = vcr;
        this.translate = translate;
        this.notificationLang = {};
        this.variables = [];
        this.locals = [];
        this.triggerSave = new core["EventEmitter"]();
        this.cancel = new core["EventEmitter"]();
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllLang();
    }
    EditNotificationLangComponent.prototype.loadEventVariableByEventId = function () {
        var _this = this;
        if (this.eventId) {
            var url = this._baseUrl + 'v1/webAdmin/notification/loadVariables/' + this.eventId;
            var self_1 = this;
            self_1._http.get(url).subscribe(function (result) {
                self_1.variables = result;
            }, function (error) {
                _this._toaster.showError("Not able to fetch notification");
            });
        }
    };
    EditNotificationLangComponent.prototype.getAllLang = function () {
        var url = this._baseUrl + 'v1/hub/settings/getAllLang';
        var self = this;
        self._http.get(url).subscribe(function (result) {
            self.locals = result;
        }, function (error) {
        });
    };
    EditNotificationLangComponent.prototype.saveData = function () {
        if (!this.notificationLang.locale || !this.notificationLang.locale.trim()) {
            this._toaster.showError("Select locale");
            return;
        }
        if (!this.notificationLang.messageTemplate
            || !this.notificationLang.messageTemplate.trim()) {
            this._toaster.showError("Message template should not be empty");
            return;
        }
        if (!this.notificationLang.name || !this.notificationLang.name.trim()) {
            this._toaster.showError("Name should not be empty");
            return;
        }
        if (!this.notificationLang.subjectTemplate || !this.notificationLang.subjectTemplate.trim()) {
            this._toaster.showError("Subject template should not be empty");
            return;
        }
        this.triggerSave.emit();
    };
    EditNotificationLangComponent.prototype.cancelEdit = function () {
        this.cancel.emit();
    };
    return EditNotificationLangComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/editNotificationLangComponent.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_.._directives_scroll_top_on_condition,_angular_common,_.._.._.._node_modules_ngx_quill_src_quill_editor.component.ngfactory,ngx_quill_src_quill_editor.component,_angular_platform_browser,_editNotificationLangComponent,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_.._toasterComponent_toasterComponent,_ngx_translate_core PURE_IMPORTS_END */
















var styles_EditNotificationLangComponent = [];
var RenderType_EditNotificationLangComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EditNotificationLangComponent, data: {} });

function View_EditNotificationLangComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", ""]))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.locale, ""); _ck(_v, 1, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.locale, ""); _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_EditNotificationLangComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "px-4 b-b pb-2 mb-4"], ["scroll-top-on-condition", "true"]], null, null, null, null, null)), core["ɵdid"](1, 4210688, null, 0, ScrollTopDirective, [core["ElementRef"]], null, null), (_l()(), core["ɵeld"](2, 0, null, null, 5, "div", [["class", "row justify-content-between align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "h5", [["class", "medium mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Edit Notification lang"])), (_l()(), core["ɵeld"](5, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancelEdit() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "])), (_l()(), core["ɵeld"](8, 0, null, null, 209, "div", [["class", "card mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "div", [["class", "card-header"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Basic details"])), (_l()(), core["ɵeld"](11, 0, null, null, 206, "div", [["class", "card-body p-3 row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 9, "div", [["class", "col-6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 8, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Name"])), (_l()(), core["ɵeld"](16, 0, null, null, 5, "input", [["class", "form-control"], ["rows", "5"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 17)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 17).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 17)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 17)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notificationLang.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](17, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](19, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](21, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](22, 0, null, null, 9, "div", [["class", "col-6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 8, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Description"])), (_l()(), core["ɵeld"](26, 0, null, null, 5, "input", [["class", "form-control"], ["rows", "5"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 27)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 27)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notificationLang.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 10, "div", [["class", "col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Subject template"])), (_l()(), core["ɵeld"](36, 0, null, null, 6, "textarea", [["class", "form-control"], ["rows", "2"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 37)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 37).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 37)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 37)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notificationLang.subjectTemplate = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](37, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](39, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](41, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵted"](-1, null, ["                "])), (_l()(), core["ɵeld"](43, 0, null, null, 11, "div", [["class", "col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](44, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Locale"])), (_l()(), core["ɵeld"](47, 0, null, null, 7, "select", [["class", "form-control"], ["id", "locale"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 48).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 48).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.notificationLang.locale = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](48, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](50, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](52, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationLangComponent_1)), core["ɵdid"](54, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](55, 0, null, null, 162, "div", [["class", "col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](56, 0, null, null, 161, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Message template"])), (_l()(), core["ɵeld"](59, 0, null, null, 158, "div", [["class", "w-100 float-left rich-text-editor"]], null, null, null, null, null)), (_l()(), core["ɵeld"](60, 0, null, null, 157, "quill-editor", [], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.notificationLang.messageTemplate = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_QuillEditorComponent_0, RenderType_QuillEditorComponent)), core["ɵdid"](61, 4767744, null, 0, quill_editor_component_QuillEditorComponent, [core["ElementRef"], platform_browser["b" /* DOCUMENT */], core["Renderer2"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [quill_editor_component_QuillEditorComponent]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [quill_editor_component_QuillEditorComponent]), core["ɵdid"](64, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](66, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](67, 0, null, 0, 150, "div", [["quill-editor-toolbar", ""]], null, null, null, null, null)), (_l()(), core["ɵeld"](68, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](69, 0, null, null, 0, "button", [["class", "ql-bold"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 0, "button", [["class", "ql-italic"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](72, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](73, 0, null, null, 0, "button", [["class", "ql-underline"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](74, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](75, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "ordered"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](76, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](77, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "bullet"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](78, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](79, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "check"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](80, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](81, 0, null, null, 0, "button", [["class", "ql-header"], ["value", "1"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](82, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](83, 0, null, null, 0, "button", [["class", "ql-header"], ["value", "2"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](84, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](85, 0, null, null, 0, "button", [["class", "ql-blockquote"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](86, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](87, 0, null, null, 0, "button", [["class", "ql-formula"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](88, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](89, 0, null, null, 0, "button", [["class", "ql-link"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](90, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](91, 0, null, null, 0, "button", [["class", "ql-code-block"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](92, 0, null, null, 10, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](93, 0, null, null, 9, "select", [["class", "ql-font"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](94, 0, null, null, 2, "option", [["value", "sans serif"]], null, null, null, null, null)), core["ɵdid"](95, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](96, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](97, 0, null, null, 2, "option", [["value", "serif"]], null, null, null, null, null)), core["ɵdid"](98, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](99, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](100, 0, null, null, 2, "option", [["value", "monospace"]], null, null, null, null, null)), core["ɵdid"](101, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](102, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](103, 0, null, null, 43, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](104, 0, null, null, 42, "select", [["class", "ql-color"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](105, 0, null, null, 2, "option", [["value", "white"]], null, null, null, null, null)), core["ɵdid"](106, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](107, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](108, 0, null, null, 2, "option", [["value", "black"]], null, null, null, null, null)), core["ɵdid"](109, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](110, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](111, 0, null, null, 2, "option", [["value", "red"]], null, null, null, null, null)), core["ɵdid"](112, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](113, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](114, 0, null, null, 2, "option", [["value", "blue"]], null, null, null, null, null)), core["ɵdid"](115, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](116, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](117, 0, null, null, 2, "option", [["value", "green"]], null, null, null, null, null)), core["ɵdid"](118, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](119, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](120, 0, null, null, 2, "option", [["value", "lightblue"]], null, null, null, null, null)), core["ɵdid"](121, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](122, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](123, 0, null, null, 2, "option", [["value", "orange"]], null, null, null, null, null)), core["ɵdid"](124, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](125, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](126, 0, null, null, 2, "option", [["value", "pink"]], null, null, null, null, null)), core["ɵdid"](127, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](128, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](129, 0, null, null, 2, "option", [["value", "yellow"]], null, null, null, null, null)), core["ɵdid"](130, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](131, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](132, 0, null, null, 2, "option", [["value", "purple"]], null, null, null, null, null)), core["ɵdid"](133, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](134, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](135, 0, null, null, 2, "option", [["value", "grey"]], null, null, null, null, null)), core["ɵdid"](136, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](137, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](138, 0, null, null, 2, "option", [["value", "lightgreen"]], null, null, null, null, null)), core["ɵdid"](139, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](140, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](141, 0, null, null, 2, "option", [["value", "lightyellow"]], null, null, null, null, null)), core["ɵdid"](142, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](143, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](144, 0, null, null, 2, "option", [["value", "magenta"]], null, null, null, null, null)), core["ɵdid"](145, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](146, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](147, 0, null, null, 43, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](148, 0, null, null, 42, "select", [["class", "ql-background"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](149, 0, null, null, 2, "option", [["value", "white"]], null, null, null, null, null)), core["ɵdid"](150, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](151, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](152, 0, null, null, 2, "option", [["value", "black"]], null, null, null, null, null)), core["ɵdid"](153, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](154, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](155, 0, null, null, 2, "option", [["value", "red"]], null, null, null, null, null)), core["ɵdid"](156, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](157, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](158, 0, null, null, 2, "option", [["value", "blue"]], null, null, null, null, null)), core["ɵdid"](159, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](160, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](161, 0, null, null, 2, "option", [["value", "green"]], null, null, null, null, null)), core["ɵdid"](162, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](163, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](164, 0, null, null, 2, "option", [["value", "lightblue"]], null, null, null, null, null)), core["ɵdid"](165, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](166, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](167, 0, null, null, 2, "option", [["value", "orange"]], null, null, null, null, null)), core["ɵdid"](168, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](169, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](170, 0, null, null, 2, "option", [["value", "pink"]], null, null, null, null, null)), core["ɵdid"](171, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](172, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](173, 0, null, null, 2, "option", [["value", "yellow"]], null, null, null, null, null)), core["ɵdid"](174, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](175, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](176, 0, null, null, 2, "option", [["value", "purple"]], null, null, null, null, null)), core["ɵdid"](177, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](178, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](179, 0, null, null, 2, "option", [["value", "grey"]], null, null, null, null, null)), core["ɵdid"](180, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](181, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](182, 0, null, null, 2, "option", [["value", "lightgreen"]], null, null, null, null, null)), core["ɵdid"](183, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](184, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](185, 0, null, null, 2, "option", [["value", "lightyellow"]], null, null, null, null, null)), core["ɵdid"](186, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](187, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](188, 0, null, null, 2, "option", [["value", "magenta"]], null, null, null, null, null)), core["ɵdid"](189, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](190, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](191, 0, null, null, 10, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](192, 0, null, null, 9, "select", [["class", "ql-size"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](193, 0, null, null, 2, "option", [["value", "small"]], null, null, null, null, null)), core["ɵdid"](194, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](195, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](196, 0, null, null, 2, "option", [["value", "large"]], null, null, null, null, null)), core["ɵdid"](197, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](198, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](199, 0, null, null, 2, "option", [["value", "huge"]], null, null, null, null, null)), core["ɵdid"](200, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](201, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](202, 0, null, null, 13, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](203, 0, null, null, 12, "select", [["class", "ql-align"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](204, 0, null, null, 2, "option", [["selected", ""]], null, null, null, null, null)), core["ɵdid"](205, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](206, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵeld"](207, 0, null, null, 2, "option", [["value", "center"]], null, null, null, null, null)), core["ɵdid"](208, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](209, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](210, 0, null, null, 2, "option", [["value", "right"]], null, null, null, null, null)), core["ɵdid"](211, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](212, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](213, 0, null, null, 2, "option", [["value", "justify"]], null, null, null, null, null)), core["ɵdid"](214, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](215, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](216, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](217, 0, null, null, 0, "button", [["class", "ql-strike"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](218, 0, null, null, 4, "div", [["class", "px-3 mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](219, 0, null, null, 1, "button", [["class", "btn btn-success float-right ml-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveData() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"])), (_l()(), core["ɵeld"](221, 0, null, null, 1, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancelEdit() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Cancel"]))], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.notificationLang.name; _ck(_v, 19, 0, currVal_7); var currVal_15 = _co.notificationLang.description; _ck(_v, 29, 0, currVal_15); var currVal_23 = _co.notificationLang.subjectTemplate; _ck(_v, 39, 0, currVal_23); var currVal_31 = _co.notificationLang.locale; _ck(_v, 50, 0, currVal_31); var currVal_32 = _co.locals; _ck(_v, 54, 0, currVal_32); var currVal_40 = _co.notificationLang.messageTemplate; _ck(_v, 64, 0, currVal_40); var currVal_54 = "sans serif"; _ck(_v, 95, 0, currVal_54); var currVal_55 = "sans serif"; _ck(_v, 96, 0, currVal_55); var currVal_56 = "serif"; _ck(_v, 98, 0, currVal_56); var currVal_57 = "serif"; _ck(_v, 99, 0, currVal_57); var currVal_58 = "monospace"; _ck(_v, 101, 0, currVal_58); var currVal_59 = "monospace"; _ck(_v, 102, 0, currVal_59); var currVal_61 = "white"; _ck(_v, 106, 0, currVal_61); var currVal_62 = "white"; _ck(_v, 107, 0, currVal_62); var currVal_63 = "black"; _ck(_v, 109, 0, currVal_63); var currVal_64 = "black"; _ck(_v, 110, 0, currVal_64); var currVal_65 = "red"; _ck(_v, 112, 0, currVal_65); var currVal_66 = "red"; _ck(_v, 113, 0, currVal_66); var currVal_67 = "blue"; _ck(_v, 115, 0, currVal_67); var currVal_68 = "blue"; _ck(_v, 116, 0, currVal_68); var currVal_69 = "green"; _ck(_v, 118, 0, currVal_69); var currVal_70 = "green"; _ck(_v, 119, 0, currVal_70); var currVal_71 = "lightblue"; _ck(_v, 121, 0, currVal_71); var currVal_72 = "lightblue"; _ck(_v, 122, 0, currVal_72); var currVal_73 = "orange"; _ck(_v, 124, 0, currVal_73); var currVal_74 = "orange"; _ck(_v, 125, 0, currVal_74); var currVal_75 = "pink"; _ck(_v, 127, 0, currVal_75); var currVal_76 = "pink"; _ck(_v, 128, 0, currVal_76); var currVal_77 = "yellow"; _ck(_v, 130, 0, currVal_77); var currVal_78 = "yellow"; _ck(_v, 131, 0, currVal_78); var currVal_79 = "purple"; _ck(_v, 133, 0, currVal_79); var currVal_80 = "purple"; _ck(_v, 134, 0, currVal_80); var currVal_81 = "grey"; _ck(_v, 136, 0, currVal_81); var currVal_82 = "grey"; _ck(_v, 137, 0, currVal_82); var currVal_83 = "lightgreen"; _ck(_v, 139, 0, currVal_83); var currVal_84 = "lightgreen"; _ck(_v, 140, 0, currVal_84); var currVal_85 = "lightyellow"; _ck(_v, 142, 0, currVal_85); var currVal_86 = "lightyellow"; _ck(_v, 143, 0, currVal_86); var currVal_87 = "magenta"; _ck(_v, 145, 0, currVal_87); var currVal_88 = "magenta"; _ck(_v, 146, 0, currVal_88); var currVal_90 = "white"; _ck(_v, 150, 0, currVal_90); var currVal_91 = "white"; _ck(_v, 151, 0, currVal_91); var currVal_92 = "black"; _ck(_v, 153, 0, currVal_92); var currVal_93 = "black"; _ck(_v, 154, 0, currVal_93); var currVal_94 = "red"; _ck(_v, 156, 0, currVal_94); var currVal_95 = "red"; _ck(_v, 157, 0, currVal_95); var currVal_96 = "blue"; _ck(_v, 159, 0, currVal_96); var currVal_97 = "blue"; _ck(_v, 160, 0, currVal_97); var currVal_98 = "green"; _ck(_v, 162, 0, currVal_98); var currVal_99 = "green"; _ck(_v, 163, 0, currVal_99); var currVal_100 = "lightblue"; _ck(_v, 165, 0, currVal_100); var currVal_101 = "lightblue"; _ck(_v, 166, 0, currVal_101); var currVal_102 = "orange"; _ck(_v, 168, 0, currVal_102); var currVal_103 = "orange"; _ck(_v, 169, 0, currVal_103); var currVal_104 = "pink"; _ck(_v, 171, 0, currVal_104); var currVal_105 = "pink"; _ck(_v, 172, 0, currVal_105); var currVal_106 = "yellow"; _ck(_v, 174, 0, currVal_106); var currVal_107 = "yellow"; _ck(_v, 175, 0, currVal_107); var currVal_108 = "purple"; _ck(_v, 177, 0, currVal_108); var currVal_109 = "purple"; _ck(_v, 178, 0, currVal_109); var currVal_110 = "grey"; _ck(_v, 180, 0, currVal_110); var currVal_111 = "grey"; _ck(_v, 181, 0, currVal_111); var currVal_112 = "lightgreen"; _ck(_v, 183, 0, currVal_112); var currVal_113 = "lightgreen"; _ck(_v, 184, 0, currVal_113); var currVal_114 = "lightyellow"; _ck(_v, 186, 0, currVal_114); var currVal_115 = "lightyellow"; _ck(_v, 187, 0, currVal_115); var currVal_116 = "magenta"; _ck(_v, 189, 0, currVal_116); var currVal_117 = "magenta"; _ck(_v, 190, 0, currVal_117); var currVal_119 = "small"; _ck(_v, 194, 0, currVal_119); var currVal_120 = "small"; _ck(_v, 195, 0, currVal_120); var currVal_121 = "large"; _ck(_v, 197, 0, currVal_121); var currVal_122 = "large"; _ck(_v, 198, 0, currVal_122); var currVal_123 = "huge"; _ck(_v, 200, 0, currVal_123); var currVal_124 = "huge"; _ck(_v, 201, 0, currVal_124); var currVal_126 = "center"; _ck(_v, 208, 0, currVal_126); var currVal_127 = "center"; _ck(_v, 209, 0, currVal_127); var currVal_128 = "right"; _ck(_v, 211, 0, currVal_128); var currVal_129 = "right"; _ck(_v, 212, 0, currVal_129); var currVal_130 = "justify"; _ck(_v, 214, 0, currVal_130); var currVal_131 = "justify"; _ck(_v, 215, 0, currVal_131); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 21).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 21).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 21).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 21).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 21).ngClassValid; var currVal_5 = core["ɵnov"](_v, 21).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 21).ngClassPending; _ck(_v, 16, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_8 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_9 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_10 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_11 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_12 = core["ɵnov"](_v, 31).ngClassValid; var currVal_13 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_14 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14); var currVal_16 = core["ɵnov"](_v, 41).ngClassUntouched; var currVal_17 = core["ɵnov"](_v, 41).ngClassTouched; var currVal_18 = core["ɵnov"](_v, 41).ngClassPristine; var currVal_19 = core["ɵnov"](_v, 41).ngClassDirty; var currVal_20 = core["ɵnov"](_v, 41).ngClassValid; var currVal_21 = core["ɵnov"](_v, 41).ngClassInvalid; var currVal_22 = core["ɵnov"](_v, 41).ngClassPending; _ck(_v, 36, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22); var currVal_24 = core["ɵnov"](_v, 52).ngClassUntouched; var currVal_25 = core["ɵnov"](_v, 52).ngClassTouched; var currVal_26 = core["ɵnov"](_v, 52).ngClassPristine; var currVal_27 = core["ɵnov"](_v, 52).ngClassDirty; var currVal_28 = core["ɵnov"](_v, 52).ngClassValid; var currVal_29 = core["ɵnov"](_v, 52).ngClassInvalid; var currVal_30 = core["ɵnov"](_v, 52).ngClassPending; _ck(_v, 47, 0, currVal_24, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30); var currVal_33 = core["ɵnov"](_v, 66).ngClassUntouched; var currVal_34 = core["ɵnov"](_v, 66).ngClassTouched; var currVal_35 = core["ɵnov"](_v, 66).ngClassPristine; var currVal_36 = core["ɵnov"](_v, 66).ngClassDirty; var currVal_37 = core["ɵnov"](_v, 66).ngClassValid; var currVal_38 = core["ɵnov"](_v, 66).ngClassInvalid; var currVal_39 = core["ɵnov"](_v, 66).ngClassPending; _ck(_v, 60, 0, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39); var currVal_41 = "Bold"; _ck(_v, 69, 0, currVal_41); var currVal_42 = "italic"; _ck(_v, 71, 0, currVal_42); var currVal_43 = "Underline"; _ck(_v, 73, 0, currVal_43); var currVal_44 = "list"; _ck(_v, 75, 0, currVal_44); var currVal_45 = "list"; _ck(_v, 77, 0, currVal_45); var currVal_46 = "list"; _ck(_v, 79, 0, currVal_46); var currVal_47 = "header"; _ck(_v, 81, 0, currVal_47); var currVal_48 = "header"; _ck(_v, 83, 0, currVal_48); var currVal_49 = "blockquote"; _ck(_v, 85, 0, currVal_49); var currVal_50 = "formula"; _ck(_v, 87, 0, currVal_50); var currVal_51 = "link"; _ck(_v, 89, 0, currVal_51); var currVal_52 = "code-block"; _ck(_v, 91, 0, currVal_52); var currVal_53 = "font"; _ck(_v, 93, 0, currVal_53); var currVal_60 = "color"; _ck(_v, 104, 0, currVal_60); var currVal_89 = "background"; _ck(_v, 148, 0, currVal_89); var currVal_118 = "font"; _ck(_v, 192, 0, currVal_118); var currVal_125 = "Aligment"; _ck(_v, 203, 0, currVal_125); var currVal_132 = "strike"; _ck(_v, 217, 0, currVal_132); });
}
function View_EditNotificationLangComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "editNotificationLang", [], null, null, null, View_EditNotificationLangComponent_0, RenderType_EditNotificationLangComponent)), core["ɵdid"](1, 49152, null, 0, editNotificationLangComponent_EditNotificationLangComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], null, null)], null, null); }
var EditNotificationLangComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("editNotificationLang", editNotificationLangComponent_EditNotificationLangComponent, View_EditNotificationLangComponent_Host_0, { notificationLang: "notificationLang", eventId: "eventId" }, { triggerSave: "triggerSave", cancel: "cancel" }, []);



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/notificationLangGridComponent.ts

var notificationLangGridComponent_NotificationLangGridComponent = /*@__PURE__*/ (function () {
    function NotificationLangGridComponent(route, modalService, router, _global, http, _auth, eRef, share, _sanitizer, builder, _toaster, _location, vcr, translate) {
        this.route = route;
        this.modalService = modalService;
        this.router = router;
        this._global = _global;
        this.http = http;
        this._auth = _auth;
        this.eRef = eRef;
        this.share = share;
        this._sanitizer = _sanitizer;
        this.builder = builder;
        this._toaster = _toaster;
        this._location = _location;
        this.vcr = vcr;
        this.translate = translate;
        this.notificationLangPageData = [];
        this.editLang = false;
        this.editLangFlag = new core["EventEmitter"]();
        this.search = {
            page: 1,
            pageSize: 10,
        };
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
    }
    NotificationLangGridComponent.prototype.ngOnChanges = function () {
        if (this.notification && this.notification.id) {
            this.search.notificationId = this.notification.id;
            this.fetchNotificationLang();
        }
    };
    NotificationLangGridComponent.prototype.fetchNotificationLang = function () {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/notification/lang/search';
        self.showLoading = false;
        self.http.post(url, this.search).subscribe(function (result) {
            self.notificationLangPageData = result;
            self.showLoading = false;
        }, function (error) {
            _this._toaster.showError("Can not load notification language data");
            self.showLoading = false;
        });
    };
    NotificationLangGridComponent.prototype.cloneNotification = function () {
        return {
            name: this.notification.name,
            description: this.notification.description,
            messageTemplate: this.notification.messageTemplate,
            subjectTemplate: this.notification.subjectTemplate,
            notificationId: this.notification.id
        };
    };
    NotificationLangGridComponent.prototype.tableActions = function (index) {
        this.trackHides = index;
    };
    NotificationLangGridComponent.prototype.edit = function (notificationLang) {
        this.editLangFlag.emit(true);
        this.editingLang = notificationLang;
        this.editLang = true;
    };
    NotificationLangGridComponent.prototype.add = function () {
        this.editLangFlag.emit(true);
        this.editingLang = this.cloneNotification();
        this.editLang = true;
    };
    NotificationLangGridComponent.prototype.save = function () {
        var _this = this;
        var self = this;
        var url = self._baseUrl + 'v1/webAdmin/notification/lang/save';
        self.http.post(url, this.editingLang).subscribe(function (result) {
            _this._toaster.showError("Notification lang saved");
            _this.editLang = false;
            _this.fetchNotificationLang();
            _this.editLangFlag.emit(false);
        }, function (error) {
            if (error.error && error.error.status == 'CONFLICT') {
                _this._toaster.showError("Can not save. same language exists with notification");
            }
            else {
                _this._toaster.showError("Not able to save lang .Some thing went wrong .");
                self.showLoading = false;
            }
        });
    };
    NotificationLangGridComponent.prototype.cancel = function () {
        this.editLang = false;
        this.editingLang = null;
        this.editLangFlag.emit(false);
    };
    NotificationLangGridComponent.prototype.clickOut = function (event) {
        var _this = this;
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(function () {
                _this.trackHides = null;
            }, 100);
        }
    };
    NotificationLangGridComponent.prototype.clicked = function () {
        this.trackHides = null;
    };
    return NotificationLangGridComponent;
}());



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/notificationLangGridComponent.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_editNotificationLangComponent.ngfactory,_editNotificationLangComponent,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_angular_platform_browser,_.._toasterComponent_toasterComponent,_notificationLangGridComponent PURE_IMPORTS_END */




















var styles_NotificationLangGridComponent = [];
var RenderType_NotificationLangGridComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NotificationLangGridComponent, data: {} });

function View_NotificationLangGridComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "empActions m-t-nsmd"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-caret-up caret-up"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 4, "ul", [["class", "m-0 p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "li", [], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.edit(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "i", [["class", "fa fa-pencil mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 5, 0, core["ɵnov"](_v, 6).transform("edit")); _ck(_v, 5, 0, currVal_0); });
}
function View_NotificationLangGridComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "w-100 float-left p-2 grid-details collapse"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 5, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 16777216, null, null, 2, "h6", [["class", "mb-lg-0"], ["ngbTooltip", "Click for more options"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.tableActions(_v.context.index) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵeld"](10, 0, null, null, 0, "i", [["class", "fa fa-ellipsis-h"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationLangGridComponent_4)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_2 = "Click for more options"; _ck(_v, 9, 0, currVal_2); var currVal_3 = (_v.context.index == _co.trackHides); _ck(_v, 12, 0, currVal_3); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.locale; _ck(_v, 6, 0, currVal_1); });
}
function View_NotificationLangGridComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationLangGridComponent_3)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.notificationLangPageData.content; _ck(_v, 2, 0, currVal_0); }, null); }
function View_NotificationLangGridComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_NotificationLangGridComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_NotificationLangGridComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationLangGridComponent_6)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationLangGridComponent_7)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_NotificationLangGridComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 51, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "row justify-content-end pr-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "button", [["class", "btn btn-success mb-3"], ["data-target", "#demo"], ["data-toggle", "collapse"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.add() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Add new"])), (_l()(), core["ɵeld"](4, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](7, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](13, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationLangGridComponent_2)), core["ɵdid"](18, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationLangGridComponent_5)), core["ɵdid"](20, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](21, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](23, null, [" ", " - ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](25, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](27, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](29, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSize"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 30).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 30).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.search.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.fetchNotificationLang() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](30, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](32, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](34, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](35, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](36, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](37, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](39, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](40, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](41, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](43, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](44, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](45, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](47, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](48, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.search.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.fetchNotificationLang() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](49, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](50, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_3 = (_co.notificationLangPageData.content && (_co.notificationLangPageData.content.length > 0)); _ck(_v, 18, 0, currVal_3); var currVal_4 = (_co.notificationLangPageData.content && (_co.notificationLangPageData.content.length == 0)); _ck(_v, 20, 0, currVal_4); var currVal_17 = "pageSize"; var currVal_18 = _co.search.pageSize; _ck(_v, 32, 0, currVal_17, currVal_18); var currVal_19 = "10"; _ck(_v, 36, 0, currVal_19); var currVal_20 = "10"; _ck(_v, 37, 0, currVal_20); var currVal_21 = "20"; _ck(_v, 40, 0, currVal_21); var currVal_22 = "20"; _ck(_v, 41, 0, currVal_22); var currVal_23 = "30"; _ck(_v, 44, 0, currVal_23); var currVal_24 = "30"; _ck(_v, 45, 0, currVal_24); var currVal_25 = true; var currVal_26 = false; var currVal_27 = true; var currVal_28 = _co.notificationLangPageData.totalElements; var currVal_29 = 5; var currVal_30 = _co.search.page; var currVal_31 = _co.search.pageSize; _ck(_v, 49, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform("name")); _ck(_v, 7, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 11, 0, core["ɵnov"](_v, 12).transform("locale")); _ck(_v, 11, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("action")); _ck(_v, 15, 0, currVal_2); var currVal_5 = (((_co.search.page - 1) * _co.search.pageSize) + 1); var currVal_6 = ((_co.search.pageSize * (_co.search.page - 1)) + _co.notificationLangPageData.numberOfElements); var currVal_7 = core["ɵunv"](_v, 23, 2, core["ɵnov"](_v, 24).transform("itemsOf")); var currVal_8 = _co.notificationLangPageData.totalElements; _ck(_v, 23, 0, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_9 = core["ɵunv"](_v, 27, 0, core["ɵnov"](_v, 28).transform("showItemsPerPage")); _ck(_v, 27, 0, currVal_9); var currVal_10 = core["ɵnov"](_v, 34).ngClassUntouched; var currVal_11 = core["ɵnov"](_v, 34).ngClassTouched; var currVal_12 = core["ɵnov"](_v, 34).ngClassPristine; var currVal_13 = core["ɵnov"](_v, 34).ngClassDirty; var currVal_14 = core["ɵnov"](_v, 34).ngClassValid; var currVal_15 = core["ɵnov"](_v, 34).ngClassInvalid; var currVal_16 = core["ɵnov"](_v, 34).ngClassPending; _ck(_v, 29, 0, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16); });
}
function View_NotificationLangGridComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 1, "editNotificationLang", [], null, [[null, "triggerSave"], [null, "cancel"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("triggerSave" === en)) {
                var pd_0 = (_co.save() !== false);
                ad = (pd_0 && ad);
            }
            if (("cancel" === en)) {
                var pd_1 = (_co.cancel() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_EditNotificationLangComponent_0, RenderType_EditNotificationLangComponent)), core["ɵdid"](2, 49152, null, 0, editNotificationLangComponent_EditNotificationLangComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { notificationLang: [0, "notificationLang"] }, { triggerSave: "triggerSave", cancel: "cancel" }), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.editingLang; _ck(_v, 2, 0, currVal_0); }, null);
}
function View_NotificationLangGridComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationLangGridComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_NotificationLangGridComponent_8)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.editLang; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.editLang; _ck(_v, 3, 0, currVal_1); }, null); }
function View_NotificationLangGridComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "div", [["notificationLangGrid", ""]], null, [["window", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NotificationLangGridComponent_0, RenderType_NotificationLangGridComponent)), core["ɵdid"](1, 573440, null, 0, notificationLangGridComponent_NotificationLangGridComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], null, null)], null, null);
}
var NotificationLangGridComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("[notificationLangGrid]", notificationLangGridComponent_NotificationLangGridComponent, View_NotificationLangGridComponent_Host_0, { notification: "notification" }, { editLangFlag: "editLangFlag" }, []);



// CONCATENATED MODULE: ./src/app/tools/notificationEditor/editNotificationComponent.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_.._.._.._node_modules_ngx_quill_src_quill_editor.component.ngfactory,ngx_quill_src_quill_editor.component,_angular_platform_browser,_angular_common,_notificationLangGridComponent.ngfactory,_notificationLangGridComponent,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_.._toasterComponent_toasterComponent,_ngx_translate_core,_editNotificationComponent PURE_IMPORTS_END */

















var styles_EditNotificationComponent = [];
var RenderType_EditNotificationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EditNotificationComponent, data: {} });

function View_EditNotificationComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "px-4 b-b pb-2 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "div", [["class", "row justify-content-between align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Notification Rule Editor"])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["class", "btn btn-secondary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, "i", [["class", "fa fa-arrow-left mr-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Back "]))], null, null);
}
function View_EditNotificationComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Default Subject template"])), (_l()(), core["ɵeld"](3, 0, null, null, 6, "textarea", [["class", "form-control"], ["rows", "5"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notification.subjectTemplate = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵted"](-1, null, ["                    "]))], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.notification.subjectTemplate; _ck(_v, 6, 0, currVal_7); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 8).ngClassValid; var currVal_5 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); });
}
function View_EditNotificationComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 163, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 162, "div", [["class", "col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 161, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Default Message template"])), (_l()(), core["ɵeld"](5, 0, null, null, 158, "div", [["class", "w-100 float-left rich-text-editor basicEditor.editor.enable(false)"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 157, "quill-editor", [], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.notification.messageTemplate = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_QuillEditorComponent_0, RenderType_QuillEditorComponent)), core["ɵdid"](7, 4767744, null, 0, quill_editor_component_QuillEditorComponent, [core["ElementRef"], platform_browser["b" /* DOCUMENT */], core["Renderer2"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0) { return [p0_0]; }, [quill_editor_component_QuillEditorComponent]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [quill_editor_component_QuillEditorComponent]), core["ɵdid"](10, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](12, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](13, 0, null, 0, 150, "div", [["quill-editor-toolbar", ""]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "button", [["class", "ql-bold"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 0, "button", [["class", "ql-italic"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 0, "button", [["class", "ql-underline"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "ordered"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "bullet"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 0, "button", [["class", "ql-list"], ["value", "check"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 0, "button", [["class", "ql-header"], ["value", "1"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](29, 0, null, null, 0, "button", [["class", "ql-header"], ["value", "2"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](30, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 0, "button", [["class", "ql-blockquote"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 0, "button", [["class", "ql-formula"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](34, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 0, "button", [["class", "ql-link"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 0, "button", [["class", "ql-code-block"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 10, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 9, "select", [["class", "ql-font"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 2, "option", [["value", "sans serif"]], null, null, null, null, null)), core["ɵdid"](41, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](42, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](43, 0, null, null, 2, "option", [["value", "serif"]], null, null, null, null, null)), core["ɵdid"](44, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](45, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](46, 0, null, null, 2, "option", [["value", "monospace"]], null, null, null, null, null)), core["ɵdid"](47, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](48, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](49, 0, null, null, 43, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 42, "select", [["class", "ql-color"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 2, "option", [["value", "white"]], null, null, null, null, null)), core["ɵdid"](52, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](53, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](54, 0, null, null, 2, "option", [["value", "black"]], null, null, null, null, null)), core["ɵdid"](55, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](56, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](57, 0, null, null, 2, "option", [["value", "red"]], null, null, null, null, null)), core["ɵdid"](58, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](59, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](60, 0, null, null, 2, "option", [["value", "blue"]], null, null, null, null, null)), core["ɵdid"](61, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](62, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](63, 0, null, null, 2, "option", [["value", "green"]], null, null, null, null, null)), core["ɵdid"](64, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](65, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](66, 0, null, null, 2, "option", [["value", "lightblue"]], null, null, null, null, null)), core["ɵdid"](67, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](68, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](69, 0, null, null, 2, "option", [["value", "orange"]], null, null, null, null, null)), core["ɵdid"](70, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](71, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](72, 0, null, null, 2, "option", [["value", "pink"]], null, null, null, null, null)), core["ɵdid"](73, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](74, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](75, 0, null, null, 2, "option", [["value", "yellow"]], null, null, null, null, null)), core["ɵdid"](76, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](77, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](78, 0, null, null, 2, "option", [["value", "purple"]], null, null, null, null, null)), core["ɵdid"](79, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](80, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](81, 0, null, null, 2, "option", [["value", "grey"]], null, null, null, null, null)), core["ɵdid"](82, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](83, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](84, 0, null, null, 2, "option", [["value", "lightgreen"]], null, null, null, null, null)), core["ɵdid"](85, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](86, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](87, 0, null, null, 2, "option", [["value", "lightyellow"]], null, null, null, null, null)), core["ɵdid"](88, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](89, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](90, 0, null, null, 2, "option", [["value", "magenta"]], null, null, null, null, null)), core["ɵdid"](91, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](92, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](93, 0, null, null, 43, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](94, 0, null, null, 42, "select", [["class", "ql-background"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](95, 0, null, null, 2, "option", [["value", "white"]], null, null, null, null, null)), core["ɵdid"](96, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](97, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](98, 0, null, null, 2, "option", [["value", "black"]], null, null, null, null, null)), core["ɵdid"](99, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](100, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](101, 0, null, null, 2, "option", [["value", "red"]], null, null, null, null, null)), core["ɵdid"](102, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](103, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](104, 0, null, null, 2, "option", [["value", "blue"]], null, null, null, null, null)), core["ɵdid"](105, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](106, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](107, 0, null, null, 2, "option", [["value", "green"]], null, null, null, null, null)), core["ɵdid"](108, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](109, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](110, 0, null, null, 2, "option", [["value", "lightblue"]], null, null, null, null, null)), core["ɵdid"](111, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](112, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](113, 0, null, null, 2, "option", [["value", "orange"]], null, null, null, null, null)), core["ɵdid"](114, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](115, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](116, 0, null, null, 2, "option", [["value", "pink"]], null, null, null, null, null)), core["ɵdid"](117, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](118, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](119, 0, null, null, 2, "option", [["value", "yellow"]], null, null, null, null, null)), core["ɵdid"](120, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](121, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](122, 0, null, null, 2, "option", [["value", "purple"]], null, null, null, null, null)), core["ɵdid"](123, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](124, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](125, 0, null, null, 2, "option", [["value", "grey"]], null, null, null, null, null)), core["ɵdid"](126, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](127, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](128, 0, null, null, 2, "option", [["value", "lightgreen"]], null, null, null, null, null)), core["ɵdid"](129, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](130, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](131, 0, null, null, 2, "option", [["value", "lightyellow"]], null, null, null, null, null)), core["ɵdid"](132, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](133, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](134, 0, null, null, 2, "option", [["value", "magenta"]], null, null, null, null, null)), core["ɵdid"](135, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](136, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](137, 0, null, null, 10, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](138, 0, null, null, 9, "select", [["class", "ql-size"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](139, 0, null, null, 2, "option", [["value", "small"]], null, null, null, null, null)), core["ɵdid"](140, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](141, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](142, 0, null, null, 2, "option", [["value", "large"]], null, null, null, null, null)), core["ɵdid"](143, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](144, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](145, 0, null, null, 2, "option", [["value", "huge"]], null, null, null, null, null)), core["ɵdid"](146, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](147, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](148, 0, null, null, 13, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](149, 0, null, null, 12, "select", [["class", "ql-align"]], [[8, "title", 0]], null, null, null, null)), (_l()(), core["ɵeld"](150, 0, null, null, 2, "option", [["selected", ""]], null, null, null, null, null)), core["ɵdid"](151, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](152, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵeld"](153, 0, null, null, 2, "option", [["value", "center"]], null, null, null, null, null)), core["ɵdid"](154, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](155, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](156, 0, null, null, 2, "option", [["value", "right"]], null, null, null, null, null)), core["ɵdid"](157, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](158, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](159, 0, null, null, 2, "option", [["value", "justify"]], null, null, null, null, null)), core["ɵdid"](160, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](161, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵeld"](162, 0, null, null, 1, "span", [["class", "ql-formats"]], null, null, null, null, null)), (_l()(), core["ɵeld"](163, 0, null, null, 0, "button", [["class", "ql-strike"]], [[8, "title", 0]], null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.notification.messageTemplate; _ck(_v, 10, 0, currVal_7); var currVal_21 = "sans serif"; _ck(_v, 41, 0, currVal_21); var currVal_22 = "sans serif"; _ck(_v, 42, 0, currVal_22); var currVal_23 = "serif"; _ck(_v, 44, 0, currVal_23); var currVal_24 = "serif"; _ck(_v, 45, 0, currVal_24); var currVal_25 = "monospace"; _ck(_v, 47, 0, currVal_25); var currVal_26 = "monospace"; _ck(_v, 48, 0, currVal_26); var currVal_28 = "white"; _ck(_v, 52, 0, currVal_28); var currVal_29 = "white"; _ck(_v, 53, 0, currVal_29); var currVal_30 = "black"; _ck(_v, 55, 0, currVal_30); var currVal_31 = "black"; _ck(_v, 56, 0, currVal_31); var currVal_32 = "red"; _ck(_v, 58, 0, currVal_32); var currVal_33 = "red"; _ck(_v, 59, 0, currVal_33); var currVal_34 = "blue"; _ck(_v, 61, 0, currVal_34); var currVal_35 = "blue"; _ck(_v, 62, 0, currVal_35); var currVal_36 = "green"; _ck(_v, 64, 0, currVal_36); var currVal_37 = "green"; _ck(_v, 65, 0, currVal_37); var currVal_38 = "lightblue"; _ck(_v, 67, 0, currVal_38); var currVal_39 = "lightblue"; _ck(_v, 68, 0, currVal_39); var currVal_40 = "orange"; _ck(_v, 70, 0, currVal_40); var currVal_41 = "orange"; _ck(_v, 71, 0, currVal_41); var currVal_42 = "pink"; _ck(_v, 73, 0, currVal_42); var currVal_43 = "pink"; _ck(_v, 74, 0, currVal_43); var currVal_44 = "yellow"; _ck(_v, 76, 0, currVal_44); var currVal_45 = "yellow"; _ck(_v, 77, 0, currVal_45); var currVal_46 = "purple"; _ck(_v, 79, 0, currVal_46); var currVal_47 = "purple"; _ck(_v, 80, 0, currVal_47); var currVal_48 = "grey"; _ck(_v, 82, 0, currVal_48); var currVal_49 = "grey"; _ck(_v, 83, 0, currVal_49); var currVal_50 = "lightgreen"; _ck(_v, 85, 0, currVal_50); var currVal_51 = "lightgreen"; _ck(_v, 86, 0, currVal_51); var currVal_52 = "lightyellow"; _ck(_v, 88, 0, currVal_52); var currVal_53 = "lightyellow"; _ck(_v, 89, 0, currVal_53); var currVal_54 = "magenta"; _ck(_v, 91, 0, currVal_54); var currVal_55 = "magenta"; _ck(_v, 92, 0, currVal_55); var currVal_57 = "white"; _ck(_v, 96, 0, currVal_57); var currVal_58 = "white"; _ck(_v, 97, 0, currVal_58); var currVal_59 = "black"; _ck(_v, 99, 0, currVal_59); var currVal_60 = "black"; _ck(_v, 100, 0, currVal_60); var currVal_61 = "red"; _ck(_v, 102, 0, currVal_61); var currVal_62 = "red"; _ck(_v, 103, 0, currVal_62); var currVal_63 = "blue"; _ck(_v, 105, 0, currVal_63); var currVal_64 = "blue"; _ck(_v, 106, 0, currVal_64); var currVal_65 = "green"; _ck(_v, 108, 0, currVal_65); var currVal_66 = "green"; _ck(_v, 109, 0, currVal_66); var currVal_67 = "lightblue"; _ck(_v, 111, 0, currVal_67); var currVal_68 = "lightblue"; _ck(_v, 112, 0, currVal_68); var currVal_69 = "orange"; _ck(_v, 114, 0, currVal_69); var currVal_70 = "orange"; _ck(_v, 115, 0, currVal_70); var currVal_71 = "pink"; _ck(_v, 117, 0, currVal_71); var currVal_72 = "pink"; _ck(_v, 118, 0, currVal_72); var currVal_73 = "yellow"; _ck(_v, 120, 0, currVal_73); var currVal_74 = "yellow"; _ck(_v, 121, 0, currVal_74); var currVal_75 = "purple"; _ck(_v, 123, 0, currVal_75); var currVal_76 = "purple"; _ck(_v, 124, 0, currVal_76); var currVal_77 = "grey"; _ck(_v, 126, 0, currVal_77); var currVal_78 = "grey"; _ck(_v, 127, 0, currVal_78); var currVal_79 = "lightgreen"; _ck(_v, 129, 0, currVal_79); var currVal_80 = "lightgreen"; _ck(_v, 130, 0, currVal_80); var currVal_81 = "lightyellow"; _ck(_v, 132, 0, currVal_81); var currVal_82 = "lightyellow"; _ck(_v, 133, 0, currVal_82); var currVal_83 = "magenta"; _ck(_v, 135, 0, currVal_83); var currVal_84 = "magenta"; _ck(_v, 136, 0, currVal_84); var currVal_86 = "small"; _ck(_v, 140, 0, currVal_86); var currVal_87 = "small"; _ck(_v, 141, 0, currVal_87); var currVal_88 = "large"; _ck(_v, 143, 0, currVal_88); var currVal_89 = "large"; _ck(_v, 144, 0, currVal_89); var currVal_90 = "huge"; _ck(_v, 146, 0, currVal_90); var currVal_91 = "huge"; _ck(_v, 147, 0, currVal_91); var currVal_93 = "center"; _ck(_v, 154, 0, currVal_93); var currVal_94 = "center"; _ck(_v, 155, 0, currVal_94); var currVal_95 = "right"; _ck(_v, 157, 0, currVal_95); var currVal_96 = "right"; _ck(_v, 158, 0, currVal_96); var currVal_97 = "justify"; _ck(_v, 160, 0, currVal_97); var currVal_98 = "justify"; _ck(_v, 161, 0, currVal_98); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵnov"](_v, 12).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 12).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 12).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 12).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 12).ngClassValid; var currVal_5 = core["ɵnov"](_v, 12).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 12).ngClassPending; _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_8 = "Bold"; _ck(_v, 15, 0, currVal_8); var currVal_9 = _co.italic; _ck(_v, 17, 0, currVal_9); var currVal_10 = "Underline"; _ck(_v, 19, 0, currVal_10); var currVal_11 = "list"; _ck(_v, 21, 0, currVal_11); var currVal_12 = "list"; _ck(_v, 23, 0, currVal_12); var currVal_13 = "list"; _ck(_v, 25, 0, currVal_13); var currVal_14 = "header"; _ck(_v, 27, 0, currVal_14); var currVal_15 = "header"; _ck(_v, 29, 0, currVal_15); var currVal_16 = "blockquote"; _ck(_v, 31, 0, currVal_16); var currVal_17 = "formula"; _ck(_v, 33, 0, currVal_17); var currVal_18 = "link"; _ck(_v, 35, 0, currVal_18); var currVal_19 = "code-block"; _ck(_v, 37, 0, currVal_19); var currVal_20 = "font"; _ck(_v, 39, 0, currVal_20); var currVal_27 = "color"; _ck(_v, 50, 0, currVal_27); var currVal_56 = "background"; _ck(_v, 94, 0, currVal_56); var currVal_85 = "font"; _ck(_v, 138, 0, currVal_85); var currVal_92 = "Aligment"; _ck(_v, 149, 0, currVal_92); var currVal_99 = "strike"; _ck(_v, 163, 0, currVal_99); });
}
function View_EditNotificationComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 30, "div", [["class", "card mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "card-header"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Basic details"])), (_l()(), core["ɵeld"](3, 0, null, null, 27, "div", [["class", "card-body p-3 row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 10, "div", [["class", "col-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Name"])), (_l()(), core["ɵeld"](8, 0, null, null, 6, "textarea", [["class", "form-control"], ["rows", "5"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 9)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 9)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notification.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵted"](-1, null, ["                "])), (_l()(), core["ɵeld"](15, 0, null, null, 10, "div", [["class", "col-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 9, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Description"])), (_l()(), core["ɵeld"](19, 0, null, null, 6, "textarea", [["class", "form-control"], ["rows", "5"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 20)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 20).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 20)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 20)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.notification.description = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](20, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](22, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](24, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵted"](-1, null, ["                "])), (_l()(), core["ɵeld"](26, 0, null, null, 2, "div", [["class", "col-4"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_3)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_4)), core["ɵdid"](30, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_7 = _co.notification.name; _ck(_v, 11, 0, currVal_7); var currVal_15 = _co.notification.description; _ck(_v, 22, 0, currVal_15); var currVal_16 = (_co.notification.notificationChannel == "Email"); _ck(_v, 28, 0, currVal_16); var currVal_17 = (_co.notification.notificationChannel == "Email"); _ck(_v, 30, 0, currVal_17); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 13).ngClassValid; var currVal_5 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 8, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_8 = core["ɵnov"](_v, 24).ngClassUntouched; var currVal_9 = core["ɵnov"](_v, 24).ngClassTouched; var currVal_10 = core["ɵnov"](_v, 24).ngClassPristine; var currVal_11 = core["ɵnov"](_v, 24).ngClassDirty; var currVal_12 = core["ɵnov"](_v, 24).ngClassValid; var currVal_13 = core["ɵnov"](_v, 24).ngClassInvalid; var currVal_14 = core["ɵnov"](_v, 24).ngClassPending; _ck(_v, 19, 0, currVal_8, currVal_9, currVal_10, currVal_11, currVal_12, currVal_13, currVal_14); });
}
function View_EditNotificationComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 51, "div", [["class", "card mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "card-header"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["SETTINGS"])), (_l()(), core["ɵeld"](3, 0, null, null, 48, "div", [["class", "card-body p-3 row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 17, "div", [["class", "col-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 16, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Notifation channel"])), (_l()(), core["ɵeld"](8, 0, null, null, 13, "select", [["class", "form-control"], ["disabled", ""]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 9).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 9).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.notification.notificationChannel = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](9, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { isDisabled: [0, "isDisabled"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 3, "option", [["value", "Email"]], null, null, null, null, null)), core["ɵdid"](15, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](16, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Email"])), (_l()(), core["ɵeld"](18, 0, null, null, 3, "option", [["value", "Stream"]], null, null, null, null, null)), core["ɵdid"](19, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](20, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Stream"])), (_l()(), core["ɵeld"](22, 0, null, null, 17, "div", [["class", "col-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 16, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Event handling mechanism"])), (_l()(), core["ɵeld"](26, 0, null, null, 13, "select", [["class", "form-control"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 27).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.notification.eventHandlingMechanism = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 3, "option", [["value", "sync"]], null, null, null, null, null)), core["ɵdid"](33, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](34, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Synchronous"])), (_l()(), core["ɵeld"](36, 0, null, null, 3, "option", [["value", "async"]], null, null, null, null, null)), core["ɵdid"](37, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](38, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Asynchronous"])), (_l()(), core["ɵeld"](40, 0, null, null, 11, "div", [["class", "col-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](41, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](42, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Disabled"])), (_l()(), core["ɵeld"](44, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 5, "input", [["id", "self"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 46).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 46).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.notification.disabled = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](46, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](48, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](50, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](51, 0, null, null, 0, "label", [["class", "mb-0 float-left mr-2"], ["for", "self"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_7 = ""; var currVal_8 = _co.notification.notificationChannel; _ck(_v, 11, 0, currVal_7, currVal_8); var currVal_9 = "Email"; _ck(_v, 15, 0, currVal_9); var currVal_10 = "Email"; _ck(_v, 16, 0, currVal_10); var currVal_11 = "Stream"; _ck(_v, 19, 0, currVal_11); var currVal_12 = "Stream"; _ck(_v, 20, 0, currVal_12); var currVal_20 = _co.notification.eventHandlingMechanism; _ck(_v, 29, 0, currVal_20); var currVal_21 = "sync"; _ck(_v, 33, 0, currVal_21); var currVal_22 = "sync"; _ck(_v, 34, 0, currVal_22); var currVal_23 = "async"; _ck(_v, 37, 0, currVal_23); var currVal_24 = "async"; _ck(_v, 38, 0, currVal_24); var currVal_32 = _co.notification.disabled; _ck(_v, 48, 0, currVal_32); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_1 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_2 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_3 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_4 = core["ɵnov"](_v, 13).ngClassValid; var currVal_5 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_6 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 8, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6); var currVal_13 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 31).ngClassValid; var currVal_18 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_25 = core["ɵnov"](_v, 50).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 50).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 50).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 50).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 50).ngClassValid; var currVal_30 = core["ɵnov"](_v, 50).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 50).ngClassPending; _ck(_v, 45, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); });
}
function View_EditNotificationComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["class", "card-header"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Notification languages"]))], null, null); }
function View_EditNotificationComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "card mb-4"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_7)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](3, 16777216, null, null, 1, "div", [["class", "card-body p-3 mb-4"], ["notificationLangGrid", ""]], null, [[null, "editLangFlag"], ["window", "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("window:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4).clickOut($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("editLangFlag" === en)) {
                var pd_1 = (_co.hideNotification($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NotificationLangGridComponent_0, RenderType_NotificationLangGridComponent)), core["ɵdid"](4, 573440, null, 0, notificationLangGridComponent_NotificationLangGridComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], { notification: [0, "notification"] }, { editLangFlag: "editLangFlag" })], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.hideNotificationFlag; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.notification; _ck(_v, 4, 0, currVal_1); }, null);
}
function View_EditNotificationComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "col-lg-3 col-md-3 float-left"]], [[8, "id", 0]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 5, "input", [["class", "form-control rounded"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 2)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 2)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_v.parent.context.$implicit.recipient = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var currVal_8 = _v.parent.context.$implicit.recipient; _ck(_v, 4, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", (_v.parent.context.$implicit.id + "_R"), ""); _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 6).ngClassValid; var currVal_6 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 1, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_EditNotificationComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", " "]))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.variableName, ""); _ck(_v, 1, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.variableName, ""); _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit.variableName; _ck(_v, 3, 0, currVal_2); }); }
function View_EditNotificationComponent_12(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 8, "div", [["class", "col-lg-3 col-md-3 float-left"]], [[8, "id", 0]], null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "select", [["class", "form-control"]], [[8, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 2).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.parent.context.$implicit.recipient = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](4, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](6, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_13)), core["ɵdid"](8, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_9 = _v.parent.context.$implicit.recipient; _ck(_v, 4, 0, currVal_9); var currVal_10 = _co.variables; _ck(_v, 8, 0, currVal_10); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", (_v.parent.context.$implicit.id + "_R"), ""); _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "", (_v.parent.context.$implicit.id + "_R"), ""); var currVal_2 = core["ɵnov"](_v, 6).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 6).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 6).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 6).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 6).ngClassValid; var currVal_7 = core["ɵnov"](_v, 6).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 6).ngClassPending; _ck(_v, 1, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); });
}
function View_EditNotificationComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 19, "div", [["class", "w-100 float-left p-2 grid-details collapse"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 14, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 13, "select", [["class", "form-control"]], [[8, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 3).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 3).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.context.$implicit.recipientType = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](3, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](5, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](7, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](8, 0, null, null, 3, "option", [["value", "MANUAL"]], null, null, null, null, null)), core["ɵdid"](9, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](10, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Manual"])), (_l()(), core["ɵeld"](12, 0, null, null, 3, "option", [["value", "VARIABLE"]], null, null, null, null, null)), core["ɵdid"](13, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](14, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["Variable"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_11)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_12)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var currVal_8 = _v.context.$implicit.recipientType; _ck(_v, 5, 0, currVal_8); var currVal_9 = "MANUAL"; _ck(_v, 9, 0, currVal_9); var currVal_10 = "MANUAL"; _ck(_v, 10, 0, currVal_10); var currVal_11 = "VARIABLE"; _ck(_v, 13, 0, currVal_11); var currVal_12 = "VARIABLE"; _ck(_v, 14, 0, currVal_12); var currVal_13 = (_v.context.$implicit.recipientType == "MANUAL"); _ck(_v, 17, 0, currVal_13); var currVal_14 = (_v.context.$implicit.recipientType == "VARIABLE"); _ck(_v, 19, 0, currVal_14); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", (_v.context.$implicit.id + "_RT"), ""); var currVal_1 = core["ɵnov"](_v, 7).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 7).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 7).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 7).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 7).ngClassValid; var currVal_6 = core["ɵnov"](_v, 7).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 7).ngClassPending; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); });
}
function View_EditNotificationComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_10)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.notification.notificationRecipients; _ck(_v, 2, 0, currVal_0); }, null); }
function View_EditNotificationComponent_15(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left min-h2 relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_EditNotificationComponent_16(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "p", [["class", "text-center m-0 w-100 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("noResultFound")); _ck(_v, 2, 0, currVal_0); }); }
function View_EditNotificationComponent_14(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, null, null, null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_15)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_16)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.showLoading; _ck(_v, 2, 0, currVal_0); var currVal_1 = !_co.showLoading; _ck(_v, 4, 0, currVal_1); }, null); }
function View_EditNotificationComponent_8(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 17, "div", [["class", "card mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["class", "card-header"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Notification Recipients"])), (_l()(), core["ɵeld"](3, 0, null, null, 14, "div", [["class", "card-body p-3 mb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "row justify-content-end pr-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "button", [["class", "btn btn-success mb-3"], ["data-target", "#demo"], ["data-toggle", "collapse"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addNewRecipient() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Add new "])), (_l()(), core["ɵeld"](7, 0, null, null, 6, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Recipient Type "])), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" Recipient "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_9)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_14)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.notification.notificationRecipients && (_co.notification.notificationRecipients.length > 0)); _ck(_v, 15, 0, currVal_0); var currVal_1 = (_co.notification.notificationRecipients && (_co.notification.notificationRecipients.length == 0)); _ck(_v, 17, 0, currVal_1); }, null);
}
function View_EditNotificationComponent_17(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "px-3 mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "button", [["class", "btn btn-success float-right ml-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.save() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"])), (_l()(), core["ɵeld"](3, 0, null, null, 1, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Cancel"]))], null, null);
}
function View_EditNotificationComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_5)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_6)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_8)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EditNotificationComponent_17)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.hideNotificationFlag; _ck(_v, 1, 0, currVal_0); var currVal_1 = !_co.hideNotificationFlag; _ck(_v, 3, 0, currVal_1); var currVal_2 = !_co.hideNotificationFlag; _ck(_v, 5, 0, currVal_2); var currVal_3 = (_co.notification.notificationChannel == "Email"); _ck(_v, 7, 0, currVal_3); var currVal_4 = (!_co.hideNotificationFlag && (_co.notification.notificationChannel == "Email")); _ck(_v, 9, 0, currVal_4); var currVal_5 = !_co.hideNotificationFlag; _ck(_v, 11, 0, currVal_5); }, null); }
function View_EditNotificationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "EditNotification", [], null, null, null, View_EditNotificationComponent_0, RenderType_EditNotificationComponent)), core["ɵdid"](1, 49152, null, 0, EditNotificationComponent, [fesm5_router["a" /* ActivatedRoute */], NgbModal, fesm5_router["l" /* Router */], Configuration, http_client_HttpClientCustom, auth_Auth, core["ElementRef"], SharedData, platform_browser["c" /* DomSanitizer */], fesm5_forms["FormBuilder"], ToasterComponent, common["Location"], core["ViewContainerRef"], core_es5["j" /* TranslateService */]], null, null)], null, null); }
var EditNotificationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("EditNotification", EditNotificationComponent, View_EditNotificationComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/clearComponent/clearComponent.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_clearComponent,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_permissions_permissions,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_sharedData,_ng_bootstrap_ng_bootstrap_modal_modal,_.._toasterComponent_toasterComponent,_angular_common PURE_IMPORTS_END */












var styles_ClearCacheComponent = [];
var RenderType_ClearCacheComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ClearCacheComponent, data: {} });

function View_ClearCacheComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 16, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 6, "div", [["class", "w-100 float-left v-align relative b-b"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h5", [["class", "medium float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Cache Settings"])), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right mb-2"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](8, 0, null, null, 2, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "div", [["class", "btn btn-link"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Clear Cache"])), (_l()(), core["ɵeld"](11, 0, null, null, 2, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 1, "div", [["class", "btn btn-link"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Clear Memory"])), (_l()(), core["ɵeld"](14, 0, null, null, 2, "div", [["class", "w-100 float-left mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 1, "div", [["class", "btn btn-link"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Clear Dump"]))], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("back")); _ck(_v, 6, 0, currVal_0); }); }
function View_ClearCacheComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "clear-Component", [], null, null, null, View_ClearCacheComponent_0, RenderType_ClearCacheComponent)), core["ɵdid"](1, 114688, null, 0, ClearCacheComponent, [fesm5_router["l" /* Router */], NgbActiveModal, PermissionHelper, Configuration, http_client_HttpClientCustom, SharedData, NgbModal, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], common["Location"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ClearCacheComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("clear-Component", ClearCacheComponent, View_ClearCacheComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/programManagement/emailNotification/emailNotification.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_ngx_translate_core,_ng_bootstrap_ng_bootstrap_tooltip_tooltip,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_angular_common,_ng_bootstrap_ng_bootstrap_collapse_collapse,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_emailNotification,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_sharedData,_.._toasterComponent_toasterComponent,_angular_platform_browser,_ng_bootstrap_ng_bootstrap_modal_modal PURE_IMPORTS_END */

















var styles_EmailNotification = [];
var RenderType_EmailNotification = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmailNotification, data: {} });

function View_EmailNotification_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", ""]))], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit; _ck(_v, 3, 0, currVal_2); }); }
function View_EmailNotification_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform(_v.context.$implicit)); _ck(_v, 3, 0, currVal_2); }); }
function View_EmailNotification_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], null, null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](3, null, ["", ""]))], function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 1, 0, currVal_0); var currVal_1 = _v.context.$implicit; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_2 = _v.context.$implicit; _ck(_v, 3, 0, currVal_2); }); }
function View_EmailNotification_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "]))], null, function (_ck, _v) { var currVal_0 = _v.parent.context.$implicit.to[0]; _ck(_v, 1, 0, currVal_0); }); }
function View_EmailNotification_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("NA")); _ck(_v, 1, 0, currVal_0); }); }
function View_EmailNotification_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 25, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate text-primary"]], null, null, null, null, null)), core["ɵdid"](3, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), (_l()(), core["ɵted"](4, null, [" ", " "])), (_l()(), core["ɵeld"](5, 0, null, null, 5, "div", [["class", "col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 16777216, null, null, 4, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), core["ɵdid"](7, 212992, null, 0, tooltip_NgbTooltip, [core["ElementRef"], core["Renderer2"], core["Injector"], core["ComponentFactoryResolver"], core["ViewContainerRef"], NgbTooltipConfig, core["NgZone"]], { ngbTooltip: [0, "ngbTooltip"] }, null), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](15, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 4, "div", [["class", "col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmailNotification_5)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmailNotification_6)), core["ɵdid"](23, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](24, 0, null, null, 1, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 0, "i", [["class", "fa fa-envelope"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.previewEmail(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "", _v.context.$implicit.subject, ""); _ck(_v, 3, 0, currVal_0); var currVal_2 = core["ɵinlineInterpolate"](1, "", core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform(_v.context.$implicit.notificationType)), ""); _ck(_v, 7, 0, currVal_2); var currVal_6 = _v.context.$implicit.to[0]; _ck(_v, 21, 0, currVal_6); var currVal_7 = !_v.context.$implicit.to[0]; _ck(_v, 23, 0, currVal_7); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.subject; _ck(_v, 4, 0, currVal_1); var currVal_3 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform(_v.context.$implicit.notificationType)); _ck(_v, 9, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform(_v.context.$implicit.status)); _ck(_v, 13, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform(_v.context.$implicit.date)); _ck(_v, 17, 0, currVal_5); });
}
function View_EmailNotification_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 164, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h5", [["class", "b-b pb-3 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 100, "div", [["class", "w-100 float-left p-3 light-bg mt-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "h6", [["class", "medium mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](8, 0, null, null, 96, "div", [["class", "form-group mt-2 w-75 d-inline-flex relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 7, "div", [["class", "relative w-75"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "keyup.enter"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 11)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 11).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 11)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 11)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.searchBodyOrSubject = $event) !== false);
                ad = (pd_4 && ad);
            }
            if (("keyup.enter" === en)) {
                var pd_5 = (_co.searchBodyOrSubjectFunc() !== false);
                ad = (pd_5 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](11, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](13, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](15, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](16, 0, null, null, 0, "i", [["aria-controls", "collapseExample"], ["class", "fa fa-caret-down tr-0"]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = ((_co.isCollapsed = !_co.isCollapsed) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 2, "button", [["class", "btn btn-primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.searchBodyOrSubjectFunc() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](18, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](20, 0, null, null, 84, "div", [["class", "w-75 absolute top-100 left-0 p-3 white-bg z-i shadow"], ["id", "collapseExample"]], [[2, "collapse", null], [2, "show", null]], null, null, null, null)), core["ɵdid"](21, 16384, null, 0, NgbCollapse, [], { collapsed: [0, "collapsed"] }, null), (_l()(), core["ɵeld"](22, 0, null, null, 82, "div", [["class", "row"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 9, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](28, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 29)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 29).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 29)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 29)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.searchTo = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](29, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](31, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](33, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](34, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 9, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](37, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](39, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 40)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 40).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 40)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 40)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.searchCc = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](40, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](42, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](44, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](45, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 9, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](47, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](48, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](50, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 51)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 51).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 51)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 51)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.searchSubject = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](51, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](53, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](55, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](56, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 11, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](59, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](61, 0, null, null, 7, "select", [["class", "form-control"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 62).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 62).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.selectedGroup = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](62, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](64, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](66, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmailNotification_1)), core["ɵdid"](68, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](69, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](70, 0, null, null, 11, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](72, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](74, 0, null, null, 7, "select", [["class", "form-control"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 75).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 75).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.selectedStatus = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](75, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](77, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](79, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmailNotification_2)), core["ɵdid"](81, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](82, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](83, 0, null, null, 11, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](84, 0, null, null, 2, "label", [["class", "medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](85, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](87, 0, null, null, 7, "select", [["class", "form-control"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 88).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 88).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.selectedTypes = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](88, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](90, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](92, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmailNotification_3)), core["ɵdid"](94, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](95, 0, null, null, 9, "div", [["class", "col-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](96, 0, null, null, 2, "button", [["class", "btn btn-link float-left"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.resetFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](97, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](99, 0, null, null, 2, "button", [["class", "btn btn-primary float-right ml-3"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.applyFilter() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](100, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](102, 0, null, null, 2, "button", [["aria-controls", "collapseExample"], ["class", "btn btn-light float-right"]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = ((_co.isCollapsed = !_co.isCollapsed) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](103, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](105, 0, null, null, 59, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](106, 0, null, null, 27, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](107, 0, null, null, 24, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](108, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](109, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](110, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](112, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](113, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](114, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](116, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](117, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](118, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](120, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](121, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](122, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](124, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](125, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](126, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](128, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](129, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](130, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmailNotification_4)), core["ɵdid"](133, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](134, 0, null, null, 30, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.clicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](135, 0, null, null, 2, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](136, null, [" ", "-", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](138, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](139, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](140, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](142, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"], ["name", "pageSize"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 143).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 143).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.emailFilter.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](143, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](145, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](147, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](148, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](149, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](150, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](152, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](153, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](154, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](156, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](157, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](158, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](160, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](161, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.emailFilter.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.getMails() !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](162, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" }), (_l()(), core["ɵeld"](163, 0, null, null, 1, "div", [["data-placement", "bottom"], ["data-toggle", "tooltip"], ["style", "margin-right:1px; margin-left:10px;cursor: pointer;"], ["title", "Refresh"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.onRefresh() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](164, 0, null, null, 0, "i", [["aria-hidden", "true"], ["class", "fa fa-refresh"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_9 = _co.searchBodyOrSubject; _ck(_v, 13, 0, currVal_9); var currVal_14 = !_co.isCollapsed; _ck(_v, 21, 0, currVal_14); var currVal_23 = _co.searchTo; _ck(_v, 31, 0, currVal_23); var currVal_32 = _co.searchCc; _ck(_v, 42, 0, currVal_32); var currVal_41 = _co.searchSubject; _ck(_v, 53, 0, currVal_41); var currVal_50 = _co.selectedGroup; _ck(_v, 64, 0, currVal_50); var currVal_51 = _co.notificationGroups; _ck(_v, 68, 0, currVal_51); var currVal_60 = _co.selectedStatus; _ck(_v, 77, 0, currVal_60); var currVal_61 = _co.notificationStatus; _ck(_v, 81, 0, currVal_61); var currVal_70 = _co.selectedTypes; _ck(_v, 90, 0, currVal_70); var currVal_71 = _co.notificationTypes; _ck(_v, 94, 0, currVal_71); var currVal_82 = _co.emailNotificationData; _ck(_v, 133, 0, currVal_82); var currVal_95 = "pageSize"; var currVal_96 = _co.emailFilter.pageSize; _ck(_v, 145, 0, currVal_95, currVal_96); var currVal_97 = "10"; _ck(_v, 149, 0, currVal_97); var currVal_98 = "10"; _ck(_v, 150, 0, currVal_98); var currVal_99 = "20"; _ck(_v, 153, 0, currVal_99); var currVal_100 = "20"; _ck(_v, 154, 0, currVal_100); var currVal_101 = "30"; _ck(_v, 157, 0, currVal_101); var currVal_102 = "30"; _ck(_v, 158, 0, currVal_102); var currVal_103 = true; var currVal_104 = false; var currVal_105 = true; var currVal_106 = _co.collectionSize; var currVal_107 = 5; var currVal_108 = _co.emailFilter.page; var currVal_109 = _co.emailFilter.pageSize; _ck(_v, 162, 0, currVal_103, currVal_104, currVal_105, currVal_106, currVal_107, currVal_108, currVal_109); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("emailHistory")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("filters")); _ck(_v, 6, 0, currVal_1); var currVal_2 = core["ɵnov"](_v, 15).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 15).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 15).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 15).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 15).ngClassValid; var currVal_7 = core["ɵnov"](_v, 15).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 15).ngClassPending; _ck(_v, 10, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_10 = !_co.isCollapsed; _ck(_v, 16, 0, currVal_10); var currVal_11 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("search")); _ck(_v, 18, 0, currVal_11); var currVal_12 = true; var currVal_13 = !core["ɵnov"](_v, 21).collapsed; _ck(_v, 20, 0, currVal_12, currVal_13); var currVal_15 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("To")); _ck(_v, 26, 0, currVal_15); var currVal_16 = core["ɵnov"](_v, 33).ngClassUntouched; var currVal_17 = core["ɵnov"](_v, 33).ngClassTouched; var currVal_18 = core["ɵnov"](_v, 33).ngClassPristine; var currVal_19 = core["ɵnov"](_v, 33).ngClassDirty; var currVal_20 = core["ɵnov"](_v, 33).ngClassValid; var currVal_21 = core["ɵnov"](_v, 33).ngClassInvalid; var currVal_22 = core["ɵnov"](_v, 33).ngClassPending; _ck(_v, 28, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22); var currVal_24 = core["ɵunv"](_v, 37, 0, core["ɵnov"](_v, 38).transform("CC")); _ck(_v, 37, 0, currVal_24); var currVal_25 = core["ɵnov"](_v, 44).ngClassUntouched; var currVal_26 = core["ɵnov"](_v, 44).ngClassTouched; var currVal_27 = core["ɵnov"](_v, 44).ngClassPristine; var currVal_28 = core["ɵnov"](_v, 44).ngClassDirty; var currVal_29 = core["ɵnov"](_v, 44).ngClassValid; var currVal_30 = core["ɵnov"](_v, 44).ngClassInvalid; var currVal_31 = core["ɵnov"](_v, 44).ngClassPending; _ck(_v, 39, 0, currVal_25, currVal_26, currVal_27, currVal_28, currVal_29, currVal_30, currVal_31); var currVal_33 = core["ɵunv"](_v, 48, 0, core["ɵnov"](_v, 49).transform("subject")); _ck(_v, 48, 0, currVal_33); var currVal_34 = core["ɵnov"](_v, 55).ngClassUntouched; var currVal_35 = core["ɵnov"](_v, 55).ngClassTouched; var currVal_36 = core["ɵnov"](_v, 55).ngClassPristine; var currVal_37 = core["ɵnov"](_v, 55).ngClassDirty; var currVal_38 = core["ɵnov"](_v, 55).ngClassValid; var currVal_39 = core["ɵnov"](_v, 55).ngClassInvalid; var currVal_40 = core["ɵnov"](_v, 55).ngClassPending; _ck(_v, 50, 0, currVal_34, currVal_35, currVal_36, currVal_37, currVal_38, currVal_39, currVal_40); var currVal_42 = core["ɵunv"](_v, 59, 0, core["ɵnov"](_v, 60).transform("Group")); _ck(_v, 59, 0, currVal_42); var currVal_43 = core["ɵnov"](_v, 66).ngClassUntouched; var currVal_44 = core["ɵnov"](_v, 66).ngClassTouched; var currVal_45 = core["ɵnov"](_v, 66).ngClassPristine; var currVal_46 = core["ɵnov"](_v, 66).ngClassDirty; var currVal_47 = core["ɵnov"](_v, 66).ngClassValid; var currVal_48 = core["ɵnov"](_v, 66).ngClassInvalid; var currVal_49 = core["ɵnov"](_v, 66).ngClassPending; _ck(_v, 61, 0, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47, currVal_48, currVal_49); var currVal_52 = core["ɵunv"](_v, 72, 0, core["ɵnov"](_v, 73).transform("status")); _ck(_v, 72, 0, currVal_52); var currVal_53 = core["ɵnov"](_v, 79).ngClassUntouched; var currVal_54 = core["ɵnov"](_v, 79).ngClassTouched; var currVal_55 = core["ɵnov"](_v, 79).ngClassPristine; var currVal_56 = core["ɵnov"](_v, 79).ngClassDirty; var currVal_57 = core["ɵnov"](_v, 79).ngClassValid; var currVal_58 = core["ɵnov"](_v, 79).ngClassInvalid; var currVal_59 = core["ɵnov"](_v, 79).ngClassPending; _ck(_v, 74, 0, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57, currVal_58, currVal_59); var currVal_62 = core["ɵunv"](_v, 85, 0, core["ɵnov"](_v, 86).transform("type")); _ck(_v, 85, 0, currVal_62); var currVal_63 = core["ɵnov"](_v, 92).ngClassUntouched; var currVal_64 = core["ɵnov"](_v, 92).ngClassTouched; var currVal_65 = core["ɵnov"](_v, 92).ngClassPristine; var currVal_66 = core["ɵnov"](_v, 92).ngClassDirty; var currVal_67 = core["ɵnov"](_v, 92).ngClassValid; var currVal_68 = core["ɵnov"](_v, 92).ngClassInvalid; var currVal_69 = core["ɵnov"](_v, 92).ngClassPending; _ck(_v, 87, 0, currVal_63, currVal_64, currVal_65, currVal_66, currVal_67, currVal_68, currVal_69); var currVal_72 = core["ɵunv"](_v, 97, 0, core["ɵnov"](_v, 98).transform("resetKey")); _ck(_v, 97, 0, currVal_72); var currVal_73 = core["ɵunv"](_v, 100, 0, core["ɵnov"](_v, 101).transform("apply")); _ck(_v, 100, 0, currVal_73); var currVal_74 = !_co.isCollapsed; _ck(_v, 102, 0, currVal_74); var currVal_75 = core["ɵunv"](_v, 103, 0, core["ɵnov"](_v, 104).transform("close")); _ck(_v, 103, 0, currVal_75); var currVal_76 = core["ɵunv"](_v, 110, 0, core["ɵnov"](_v, 111).transform("notificationDesc")); _ck(_v, 110, 0, currVal_76); var currVal_77 = core["ɵunv"](_v, 114, 0, core["ɵnov"](_v, 115).transform("notificationType")); _ck(_v, 114, 0, currVal_77); var currVal_78 = core["ɵunv"](_v, 118, 0, core["ɵnov"](_v, 119).transform("notificationStatus")); _ck(_v, 118, 0, currVal_78); var currVal_79 = core["ɵunv"](_v, 122, 0, core["ɵnov"](_v, 123).transform("createdOn")); _ck(_v, 122, 0, currVal_79); var currVal_80 = core["ɵunv"](_v, 126, 0, core["ɵnov"](_v, 127).transform("empEmail")); _ck(_v, 126, 0, currVal_80); var currVal_81 = core["ɵunv"](_v, 130, 0, core["ɵnov"](_v, 131).transform("preview")); _ck(_v, 130, 0, currVal_81); var currVal_83 = (((_co.emailFilter.page - 1) * _co.emailFilter.pageSize) + 1); var currVal_84 = ((_co.emailFilter.pageSize * (_co.emailFilter.page - 1)) + ((_co.emailPageData.data == null) ? null : _co.emailPageData.data.numberOfElements)); var currVal_85 = core["ɵunv"](_v, 136, 2, core["ɵnov"](_v, 137).transform("itemsOf")); var currVal_86 = ((_co.emailPageData.data == null) ? null : _co.emailPageData.data.totalElements); _ck(_v, 136, 0, currVal_83, currVal_84, currVal_85, currVal_86); var currVal_87 = core["ɵunv"](_v, 140, 0, core["ɵnov"](_v, 141).transform("showItemsPerPage")); _ck(_v, 140, 0, currVal_87); var currVal_88 = core["ɵnov"](_v, 147).ngClassUntouched; var currVal_89 = core["ɵnov"](_v, 147).ngClassTouched; var currVal_90 = core["ɵnov"](_v, 147).ngClassPristine; var currVal_91 = core["ɵnov"](_v, 147).ngClassDirty; var currVal_92 = core["ɵnov"](_v, 147).ngClassValid; var currVal_93 = core["ɵnov"](_v, 147).ngClassInvalid; var currVal_94 = core["ɵnov"](_v, 147).ngClassPending; _ck(_v, 142, 0, currVal_88, currVal_89, currVal_90, currVal_91, currVal_92, currVal_93, currVal_94); });
}
function View_EmailNotification_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "email-notification", [], null, null, null, View_EmailNotification_0, RenderType_EmailNotification)), core["ɵdid"](1, 49152, null, 0, emailNotification_EmailNotification, [Configuration, http_client_HttpClientCustom, SharedData, common["Location"], ToasterComponent, platform_browser["c" /* DomSanitizer */], core["ViewContainerRef"], core_es5["j" /* TranslateService */], NgbModal], null, null)], null, null); }
var EmailNotificationNgFactory = /*@__PURE__*/ core["ɵccf"]("email-notification", emailNotification_EmailNotification, View_EmailNotification_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/superAdmin/mobileAppManagement.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_angular_forms,_.._.._node_modules__ng_bootstrap_ng_bootstrap_pagination_pagination.ngfactory,_ng_bootstrap_ng_bootstrap_pagination_pagination,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_mobileAppManagement,_angular_router,_shared_permissions_permissions,_shared_services_configuration,_shared_services_http.client,_toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_sharedData PURE_IMPORTS_END */















var styles_MobileAppManagementComponent = [];
var RenderType_MobileAppManagementComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_MobileAppManagementComponent, data: {} });

function View_MobileAppManagementComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 24, "div", [["class", "w-100 float-left p-md-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, [" ", " "])), (_l()(), core["ɵeld"](4, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate text-primary"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.viewPerformanceTable() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](6, null, [" ", " "])), (_l()(), core["ɵeld"](7, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), (_l()(), core["ɵeld"](13, 0, null, null, 2, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, ["", " "])), (_l()(), core["ɵeld"](16, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](18, null, ["", " "])), (_l()(), core["ɵeld"](19, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 1, "h6", [["class", "mb-lg-0 text-truncate"]], null, null, null, null, null)), (_l()(), core["ɵted"](21, null, ["", " "])), (_l()(), core["ɵeld"](22, 0, null, null, 2, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 0, "i", [["class", "fa fa-edit"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.updateMobileApp(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.mobileAppName; _ck(_v, 3, 0, currVal_0); var currVal_1 = _v.context.$implicit.mobileAppKey; _ck(_v, 6, 0, currVal_1); var currVal_2 = _v.context.$implicit.versionAndroid; _ck(_v, 9, 0, currVal_2); var currVal_3 = _v.context.$implicit.versionIos; _ck(_v, 12, 0, currVal_3); var currVal_4 = _v.context.$implicit.fireBaseKey; _ck(_v, 15, 0, currVal_4); var currVal_5 = _v.context.$implicit.redirectUrlAndroid; _ck(_v, 18, 0, currVal_5); var currVal_6 = _v.context.$implicit.redirectUrlIos; _ck(_v, 21, 0, currVal_6); });
}
function View_MobileAppManagementComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 72, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h5", [["class", "b-b pb-3 medium mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 3, "div", [["class", "w-100 float-left my-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.createMobileApp() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](6, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](8, 0, null, null, 64, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 35, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 32, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 3, "div", [["class", "col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](15, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](19, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](21, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](23, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](25, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](27, 0, null, null, 3, "div", [["class", "col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](28, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](29, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](31, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](33, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](35, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](37, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](39, 0, null, null, 3, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](40, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](41, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_MobileAppManagementComponent_1)), core["ɵdid"](44, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](45, 0, null, null, 27, "div", [["class", "w-100 float-left my-4 light-bg p-3 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 1, "h6", [["class", "float-left mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](47, null, [" ", " - ", " ", " ", " "])), (_l()(), core["ɵeld"](48, 0, null, null, 21, "div", [["class", "float-left ml-2 align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](49, 0, null, null, 2, "label", [["class", "m-0 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](50, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](52, 0, null, null, 17, "select", [["class", "form-control float-left w-auto ml-2 mb-0"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 53).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 53).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.pageSize = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.OnPageSizeChanged($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](53, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](55, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](57, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](58, 0, null, null, 3, "option", [["value", "10"]], null, null, null, null, null)), core["ɵdid"](59, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](60, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["10"])), (_l()(), core["ɵeld"](62, 0, null, null, 3, "option", [["value", "20"]], null, null, null, null, null)), core["ɵdid"](63, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](64, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["20"])), (_l()(), core["ɵeld"](66, 0, null, null, 3, "option", [["value", "30"]], null, null, null, null, null)), core["ɵdid"](67, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], { value: [0, "value"] }, null), core["ɵdid"](68, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["30"])), (_l()(), core["ɵeld"](70, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](71, 0, null, null, 1, "ngb-pagination", [["class", "float-right"], ["role", "navigation"]], null, [[null, "pageChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("pageChange" === en)) {
                var pd_0 = ((_co.page = $event) !== false);
                ad = (pd_0 && ad);
            }
            if (("pageChange" === en)) {
                var pd_1 = (_co.onPageChange($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_NgbPagination_0, RenderType_NgbPagination)), core["ɵdid"](72, 573440, null, 0, pagination_NgbPagination, [NgbPaginationConfig], { boundaryLinks: [0, "boundaryLinks"], ellipses: [1, "ellipses"], rotate: [2, "rotate"], collectionSize: [3, "collectionSize"], maxSize: [4, "maxSize"], page: [5, "page"], pageSize: [6, "pageSize"] }, { pageChange: "pageChange" })], function (_ck, _v) { var _co = _v.component; var currVal_10 = _co.mobileApps; _ck(_v, 44, 0, currVal_10); var currVal_23 = _co.pageSize; _ck(_v, 55, 0, currVal_23); var currVal_24 = "10"; _ck(_v, 59, 0, currVal_24); var currVal_25 = "10"; _ck(_v, 60, 0, currVal_25); var currVal_26 = "20"; _ck(_v, 63, 0, currVal_26); var currVal_27 = "20"; _ck(_v, 64, 0, currVal_27); var currVal_28 = "30"; _ck(_v, 67, 0, currVal_28); var currVal_29 = "30"; _ck(_v, 68, 0, currVal_29); var currVal_30 = true; var currVal_31 = false; var currVal_32 = true; var currVal_33 = _co.collectionSize; var currVal_34 = 5; var currVal_35 = _co.page; var currVal_36 = _co.pageSize; _ck(_v, 72, 0, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("mobileAppManagement")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 6, 0, core["ɵnov"](_v, 7).transform("createMobileApp")); _ck(_v, 6, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("appName")); _ck(_v, 13, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform("appKey")); _ck(_v, 17, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 21, 0, core["ɵnov"](_v, 22).transform("androidVer")); _ck(_v, 21, 0, currVal_4); var currVal_5 = core["ɵunv"](_v, 25, 0, core["ɵnov"](_v, 26).transform("iosVer")); _ck(_v, 25, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 29, 0, core["ɵnov"](_v, 30).transform("firebaseKey")); _ck(_v, 29, 0, currVal_6); var currVal_7 = core["ɵunv"](_v, 33, 0, core["ɵnov"](_v, 34).transform("redirectUrlAndroid")); _ck(_v, 33, 0, currVal_7); var currVal_8 = core["ɵunv"](_v, 37, 0, core["ɵnov"](_v, 38).transform("redirectUrliOS")); _ck(_v, 37, 0, currVal_8); var currVal_9 = core["ɵunv"](_v, 41, 0, core["ɵnov"](_v, 42).transform("action")); _ck(_v, 41, 0, currVal_9); var currVal_11 = _co.startingPage; var currVal_12 = _co.endingPage; var currVal_13 = "itemsOf"; var currVal_14 = _co.collectionSize; _ck(_v, 47, 0, currVal_11, currVal_12, currVal_13, currVal_14); var currVal_15 = core["ɵunv"](_v, 50, 0, core["ɵnov"](_v, 51).transform("showItemsPerPage")); _ck(_v, 50, 0, currVal_15); var currVal_16 = core["ɵnov"](_v, 57).ngClassUntouched; var currVal_17 = core["ɵnov"](_v, 57).ngClassTouched; var currVal_18 = core["ɵnov"](_v, 57).ngClassPristine; var currVal_19 = core["ɵnov"](_v, 57).ngClassDirty; var currVal_20 = core["ɵnov"](_v, 57).ngClassValid; var currVal_21 = core["ɵnov"](_v, 57).ngClassInvalid; var currVal_22 = core["ɵnov"](_v, 57).ngClassPending; _ck(_v, 52, 0, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21, currVal_22); });
}
function View_MobileAppManagementComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "mobile-app-management", [], null, null, null, View_MobileAppManagementComponent_0, RenderType_MobileAppManagementComponent)), core["ɵdid"](1, 49152, null, 0, mobileAppManagement_MobileAppManagementComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], common["Location"], NgbModal, SharedData], null, null)], null, null); }
var MobileAppManagementComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("mobile-app-management", mobileAppManagement_MobileAppManagementComponent, View_MobileAppManagementComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/passwordPolicy/passwordPolicy.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,_angular_common,_passwordPolicy,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._toasterComponent_toasterComponent,_.._shared_services_http.client,_.._shared_services_configuration,_.._shared_sharedData,_.._shared_services_auth PURE_IMPORTS_END */












var styles_PasswordPolicyComponent = [];
var RenderType_PasswordPolicyComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_PasswordPolicyComponent, data: {} });

function View_PasswordPolicyComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 72, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 6, "input", [["class", "w-100"], ["name", "displayPref"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 8).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 8).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 8).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.passwordPolicyData.minLength = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](10, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](12, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](13, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](16, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](18, 0, null, null, 6, "input", [["class", "w-100"], ["name", "displayPref"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 19)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 19)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 20).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 20).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 20).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.passwordPolicyData.maxLength = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](20, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](22, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](24, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](25, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](27, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](28, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](30, 0, null, null, 6, "input", [["class", "w-100"], ["name", "displayPref"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 32).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 32).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 32).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.passwordPolicyData.minNumbers = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](31, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](32, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](34, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](36, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](37, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](40, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](42, 0, null, null, 6, "input", [["class", "w-100"], ["name", "displayPref"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 43)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 43).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 43)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 43)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 44).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 44).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 44).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.passwordPolicyData.minCaps = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](43, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](44, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](46, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](48, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](49, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](52, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](54, 0, null, null, 6, "input", [["class", "w-100"], ["name", "displayPref"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 55)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 55).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 55)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 55)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 56).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 56).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 56).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.passwordPolicyData.minLowers = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](55, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](56, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](58, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](60, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](61, 0, null, null, 11, "div", [["class", "col-lg-6 col-md-6 col-sm-6 col-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](62, 0, null, null, 10, "div", [["class", "form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](64, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](66, 0, null, null, 6, "input", [["class", "w-100"], ["name", "displayPref"], ["type", "number"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"], [null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 67)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 67).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 67)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 67)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("change" === en)) {
                var pd_4 = (core["ɵnov"](_v, 68).onChange($event.target.value) !== false);
                ad = (pd_4 && ad);
            }
            if (("input" === en)) {
                var pd_5 = (core["ɵnov"](_v, 68).onChange($event.target.value) !== false);
                ad = (pd_5 && ad);
            }
            if (("blur" === en)) {
                var pd_6 = (core["ɵnov"](_v, 68).onTouched() !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.passwordPolicyData.minSpecial = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](67, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](68, 16384, null, 0, fesm5_forms["ɵangular_packages_forms_forms_bd"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_forms["DefaultValueAccessor"], fesm5_forms["ɵangular_packages_forms_forms_bd"]]), core["ɵdid"](70, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](72, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null)], function (_ck, _v) { var _co = _v.component; var currVal_8 = "displayPref"; var currVal_9 = _co.passwordPolicyData.minLength; _ck(_v, 10, 0, currVal_8, currVal_9); var currVal_18 = "displayPref"; var currVal_19 = _co.passwordPolicyData.maxLength; _ck(_v, 22, 0, currVal_18, currVal_19); var currVal_28 = "displayPref"; var currVal_29 = _co.passwordPolicyData.minNumbers; _ck(_v, 34, 0, currVal_28, currVal_29); var currVal_38 = "displayPref"; var currVal_39 = _co.passwordPolicyData.minCaps; _ck(_v, 46, 0, currVal_38, currVal_39); var currVal_48 = "displayPref"; var currVal_49 = _co.passwordPolicyData.minLowers; _ck(_v, 58, 0, currVal_48, currVal_49); var currVal_58 = "displayPref"; var currVal_59 = _co.passwordPolicyData.minSpecial; _ck(_v, 70, 0, currVal_58, currVal_59); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("minPasswordLength")); _ck(_v, 4, 0, currVal_0); var currVal_1 = core["ɵnov"](_v, 12).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 12).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 12).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 12).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 12).ngClassValid; var currVal_6 = core["ɵnov"](_v, 12).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 12).ngClassPending; _ck(_v, 6, 0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_10 = core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 17).transform("maxPasswordLength")); _ck(_v, 16, 0, currVal_10); var currVal_11 = core["ɵnov"](_v, 24).ngClassUntouched; var currVal_12 = core["ɵnov"](_v, 24).ngClassTouched; var currVal_13 = core["ɵnov"](_v, 24).ngClassPristine; var currVal_14 = core["ɵnov"](_v, 24).ngClassDirty; var currVal_15 = core["ɵnov"](_v, 24).ngClassValid; var currVal_16 = core["ɵnov"](_v, 24).ngClassInvalid; var currVal_17 = core["ɵnov"](_v, 24).ngClassPending; _ck(_v, 18, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_20 = core["ɵunv"](_v, 28, 0, core["ɵnov"](_v, 29).transform("minNumberLength")); _ck(_v, 28, 0, currVal_20); var currVal_21 = core["ɵnov"](_v, 36).ngClassUntouched; var currVal_22 = core["ɵnov"](_v, 36).ngClassTouched; var currVal_23 = core["ɵnov"](_v, 36).ngClassPristine; var currVal_24 = core["ɵnov"](_v, 36).ngClassDirty; var currVal_25 = core["ɵnov"](_v, 36).ngClassValid; var currVal_26 = core["ɵnov"](_v, 36).ngClassInvalid; var currVal_27 = core["ɵnov"](_v, 36).ngClassPending; _ck(_v, 30, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27); var currVal_30 = core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 41).transform("minCapsLength")); _ck(_v, 40, 0, currVal_30); var currVal_31 = core["ɵnov"](_v, 48).ngClassUntouched; var currVal_32 = core["ɵnov"](_v, 48).ngClassTouched; var currVal_33 = core["ɵnov"](_v, 48).ngClassPristine; var currVal_34 = core["ɵnov"](_v, 48).ngClassDirty; var currVal_35 = core["ɵnov"](_v, 48).ngClassValid; var currVal_36 = core["ɵnov"](_v, 48).ngClassInvalid; var currVal_37 = core["ɵnov"](_v, 48).ngClassPending; _ck(_v, 42, 0, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36, currVal_37); var currVal_40 = core["ɵunv"](_v, 52, 0, core["ɵnov"](_v, 53).transform("minLowerLength")); _ck(_v, 52, 0, currVal_40); var currVal_41 = core["ɵnov"](_v, 60).ngClassUntouched; var currVal_42 = core["ɵnov"](_v, 60).ngClassTouched; var currVal_43 = core["ɵnov"](_v, 60).ngClassPristine; var currVal_44 = core["ɵnov"](_v, 60).ngClassDirty; var currVal_45 = core["ɵnov"](_v, 60).ngClassValid; var currVal_46 = core["ɵnov"](_v, 60).ngClassInvalid; var currVal_47 = core["ɵnov"](_v, 60).ngClassPending; _ck(_v, 54, 0, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45, currVal_46, currVal_47); var currVal_50 = core["ɵunv"](_v, 64, 0, core["ɵnov"](_v, 65).transform("minSpecialLength")); _ck(_v, 64, 0, currVal_50); var currVal_51 = core["ɵnov"](_v, 72).ngClassUntouched; var currVal_52 = core["ɵnov"](_v, 72).ngClassTouched; var currVal_53 = core["ɵnov"](_v, 72).ngClassPristine; var currVal_54 = core["ɵnov"](_v, 72).ngClassDirty; var currVal_55 = core["ɵnov"](_v, 72).ngClassValid; var currVal_56 = core["ɵnov"](_v, 72).ngClassInvalid; var currVal_57 = core["ɵnov"](_v, 72).ngClassPending; _ck(_v, 66, 0, currVal_51, currVal_52, currVal_53, currVal_54, currVal_55, currVal_56, currVal_57); });
}
function View_PasswordPolicyComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 3, "div", [["class", "b-b pb-2 w-100 mb-3 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h5", [["class", "medium m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_PasswordPolicyComponent_1)), core["ɵdid"](6, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](7, 0, null, null, 3, "div", [["class", "w-100 float-left mt-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "button", [["class", "btn btn-primary float-right mr-4"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.validatepasswordPolicy() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](9, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.passwordPolicyData; _ck(_v, 6, 0, currVal_1); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("passwordPolicy")); _ck(_v, 3, 0, currVal_0); var currVal_2 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("Save")); _ck(_v, 9, 0, currVal_2); });
}
function View_PasswordPolicyComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "password-policy", [], null, null, null, View_PasswordPolicyComponent_0, RenderType_PasswordPolicyComponent)), core["ɵdid"](1, 49152, null, 0, PasswordPolicyComponent, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, common["Location"], ToasterComponent, core["ViewContainerRef"], http_client_HttpClientCustom, Configuration, core_es5["j" /* TranslateService */], SharedData, auth_Auth], null, null)], null, null); }
var PasswordPolicyComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("password-policy", PasswordPolicyComponent, View_PasswordPolicyComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/no-content/no-content.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_no_content.component PURE_IMPORTS_END */


var styles_NoContentComponent = [];
var RenderType_NoContentComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_NoContentComponent, data: {} });

function View_NoContentComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h1", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["404: page missing"]))], null, null); }
function View_NoContentComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "no-content", [], null, null, null, View_NoContentComponent_0, RenderType_NoContentComponent)), core["ɵdid"](1, 49152, null, 0, NoContentComponent, [], null, null)], null, null); }
var NoContentComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("no-content", NoContentComponent, View_NoContentComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/bi/admin/controller/fileUploadModal.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_angular_common,_fileUploadModal,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_services_mdmService.service PURE_IMPORTS_END */






var styles_FileUploader = [];
var RenderType_FileUploader = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_FileUploader, data: {} });

function View_FileUploader_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "text-xmd text-black bold m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" FILE UPLOAD"]))], null, null); }
function View_FileUploader_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "h5", [["class", "text-xmd text-black bold m-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, [" RE UPLOAD FILE"]))], null, null); }
function View_FileUploader_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "selected", 0], [1, "value", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.selectedDataSource == _v.context.$implicit.id) ? true : null); var currVal_1 = _v.context.$implicit.id; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit.name; _ck(_v, 3, 0, currVal_2); }); }
function View_FileUploader_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 9, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "label", [["for", "recordFormat"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Data Source"])), (_l()(), core["ɵeld"](4, 0, null, null, 6, "select", [["class", "form-control light-bg"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.selectDataSource($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 3, "option", [["value", "none"]], null, null, null, null, null)), core["ɵdid"](6, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), core["ɵdid"](7, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], { value: [0, "value"] }, null), (_l()(), core["ɵted"](-1, null, ["None"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_FileUploader_4)), core["ɵdid"](10, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = "none"; _ck(_v, 6, 0, currVal_0); var currVal_1 = "none"; _ck(_v, 7, 0, currVal_1); var currVal_2 = _co.dataSourceList; _ck(_v, 10, 0, currVal_2); }, null);
}
function View_FileUploader_0(_l) {
    return core["ɵvid"](0, [core["ɵqud"](402653184, 1, { fileDiv: 0 }), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "modal-header border-bottom-0 px-4 pt-4 pb-3"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_FileUploader_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_FileUploader_2)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.close() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_FileUploader_3)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](11, 0, [[1, 0], ["fileHolder", 1]], null, 0, "input", [["class", "mt-4 ml-2"], ["multipart", "true"], ["name", "file"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.fileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "div", [["class", "modal-footer border-top-0 p-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 1, "button", [["class", "btn btn-primary"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.saveFile() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, ["Save"]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.reUpload; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.reUpload; _ck(_v, 5, 0, currVal_1); var currVal_2 = !_co.reUpload; _ck(_v, 10, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_3 = _co.saveButton; _ck(_v, 13, 0, currVal_3); });
}
function View_FileUploader_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "fileUpload", [], null, null, null, View_FileUploader_0, RenderType_FileUploader)), core["ɵdid"](1, 49152, null, 0, fileUploadModal_FileUploader, [NgbActiveModal, mdmService_service_MDMService], null, null)], null, null); }
var FileUploaderNgFactory = /*@__PURE__*/ core["ɵccf"]("fileUpload", fileUploadModal_FileUploader, View_FileUploader_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./node_modules/ngx-color-picker/dist/lib/color-picker.component.css.shim.ngstyle.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var color_picker_component_css_shim_ngstyle_styles = [".color-picker[_ngcontent-%COMP%]   *[_ngcontent-%COMP%] {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  margin: 0;\n  font-size: 11px; }\n\n.color-picker[_ngcontent-%COMP%] {\n  cursor: default;\n  width: 230px;\n  height: auto;\n  border: #777 solid 1px;\n  position: absolute;\n  z-index: 100000;\n  background-color: #fff;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n  .color-picker[_ngcontent-%COMP%]   i[_ngcontent-%COMP%] {\n    cursor: default;\n    position: relative; }\n  .color-picker[_ngcontent-%COMP%]   input[_ngcontent-%COMP%] {\n    text-align: center;\n    font-size: 13px;\n    height: 26px;\n    min-width: 0;\n    -moz-appearance: textfield; }\n    .color-picker[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:invalid {\n      box-shadow: none; }\n    .color-picker[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-moz-submit-invalid {\n      box-shadow: none; }\n    .color-picker[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:-moz-ui-invalid {\n      box-shadow: none; }\n    .color-picker[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-inner-spin-button, .color-picker[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]::-webkit-outer-spin-button {\n      -webkit-appearance: none;\n      margin: 0; }\n  .color-picker[_ngcontent-%COMP%]   .button-area[_ngcontent-%COMP%] {\n    padding: 0 16px 16px 16px;\n    text-align: right; }\n  .color-picker[_ngcontent-%COMP%]   .preset-area[_ngcontent-%COMP%] {\n    padding: 4px 15px; }\n    .color-picker[_ngcontent-%COMP%]   .preset-area[_ngcontent-%COMP%]   .preset-label[_ngcontent-%COMP%] {\n      width: 100%;\n      padding: 4px;\n      font-size: 11px;\n      text-align: left;\n      color: #555; }\n    .color-picker[_ngcontent-%COMP%]   .preset-area[_ngcontent-%COMP%]   .preset-color[_ngcontent-%COMP%] {\n      -moz-border-radius: 25%;\n      -webkit-border-radius: 25%;\n      border-radius: 25%;\n      -khtml-border-radius: 25%;\n      border: #a9a9a9 solid 1px;\n      cursor: pointer;\n      display: inline-block;\n      height: 18px;\n      margin: 4px 6px 8px 6px;\n      position: relative;\n      width: 18px; }\n    .color-picker[_ngcontent-%COMP%]   .preset-area[_ngcontent-%COMP%]   .preset-empty-message[_ngcontent-%COMP%] {\n      font-style: italic;\n      margin-bottom: 8px;\n      margin-top: 4px;\n      min-height: 18px;\n      text-align: center; }\n  .color-picker[_ngcontent-%COMP%]   .arrow[_ngcontent-%COMP%] {\n    height: 0;\n    width: 0;\n    border-style: solid;\n    position: absolute;\n    z-index: 999999; }\n  .color-picker[_ngcontent-%COMP%]   .arrow-right[_ngcontent-%COMP%] {\n    border-width: 5px 10px;\n    border-color: transparent #777 transparent transparent;\n    top: 10px;\n    left: -20px; }\n  .color-picker[_ngcontent-%COMP%]   .arrow-left[_ngcontent-%COMP%] {\n    border-width: 5px 10px;\n    border-color: transparent transparent transparent #777;\n    top: 10px;\n    left: 100%; }\n  .color-picker[_ngcontent-%COMP%]   .arrow-bottom[_ngcontent-%COMP%] {\n    border-width: 10px 5px;\n    border-color: transparent transparent #777 transparent;\n    top: -20px;\n    left: 10px; }\n  .color-picker[_ngcontent-%COMP%]   .arrow-top[_ngcontent-%COMP%] {\n    border-width: 10px 5px;\n    border-color: #777 transparent transparent transparent;\n    left: 10px; }\n  .color-picker[_ngcontent-%COMP%]   div.cursor-sv[_ngcontent-%COMP%] {\n    cursor: default;\n    position: relative;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    -khtml-border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    border: #ddd solid 1px; }\n  .color-picker[_ngcontent-%COMP%]   div.cursor[_ngcontent-%COMP%] {\n    cursor: default;\n    position: relative;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    -khtml-border-radius: 50%;\n    width: 16px;\n    height: 16px;\n    border: #222 solid 2px; }\n  .color-picker[_ngcontent-%COMP%]   .saturation-lightness[_ngcontent-%COMP%] {\n    cursor: pointer;\n    width: 100%;\n    height: 130px;\n    border: none;\n    background-size: 100% 100%;\n    background-image: url(\"data:image/png;base64,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\"); }\n  .color-picker[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%] {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 4px 8px; }\n    .color-picker[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   .left[_ngcontent-%COMP%] {\n      position: relative;\n      padding: 16px 8px; }\n    .color-picker[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   .right[_ngcontent-%COMP%] {\n      -webkit-flex: 1 1 auto;\n      -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n      padding: 12px 8px; }\n  .color-picker[_ngcontent-%COMP%]   .hue[_ngcontent-%COMP%] {\n    cursor: pointer;\n    width: 100%;\n    height: 16px;\n    border: none;\n    margin-bottom: 16px;\n    background-size: 100% 100%;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAQCAYAAAD06IYnAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AIWDwkUFWbCCAAAAFxJREFUaN7t0kEKg0AQAME2x83/n2qu5qCgD1iDhCoYdpnbQC9bbY1qVO/jvc6k3ad91s7/7F1/csgPrujuQ17BDYSFsBAWwgJhISyEBcJCWAgLhIWwEBYIi2f7Ar/1TCgFH2X9AAAAAElFTkSuQmCC\"); }\n  .color-picker[_ngcontent-%COMP%]   .alpha[_ngcontent-%COMP%] {\n    cursor: pointer;\n    width: 100%;\n    height: 16px;\n    border: none;\n    background-size: 100% 100%;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAQCAYAAAD06IYnAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AIWDwYQlZMa3gAAAWVJREFUaN7tmEGO6jAQRCsOArHgBpyAJYGjcGocxAm4A2IHpmoWE0eBH+ezmFlNvU06shJ3W6VEelWMUQAIIF9f6qZpimsA1LYtS2uF51/u27YVAFZVRUkEoGHdPV/sIcbIEIIkUdI/9Xa7neyv61+SWFUVAVCSct00TWn2fv6u3+Ecfd3tXzy/0+nEUu+SPjo/kqzrmiQpScN6v98XewfA8/lMkiLJ2WxGSUopcT6fM6U0NX9/frfbjev1WtfrlZfLhYfDQQHG/AIOlnGwjINlHCxjHCzjYJm/TJWdCwquJXseFFzGwDNNeiKMOJTO8xQdDQaeB29+K9efeLaBo9J7vdvtJj1RjFFjfiv7qv95tjx/7leSQgh93e1ffMeIp6O+YQjho/N791t1XVOSSI7N//K+4/GoxWLBx+PB5/Op5XLJ+/3OlJJWqxU3m83ovv5iGf8KjYNlHCxjHCzjYBkHy5gf5gusvQU7U37jTAAAAABJRU5ErkJggg==\"); }\n  .color-picker[_ngcontent-%COMP%]   .selected-color[_ngcontent-%COMP%] {\n    width: 40px;\n    height: 40px;\n    top: 16px;\n    left: 8px;\n    position: absolute;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    -khtml-border-radius: 50%;\n    border: 1px solid #a9a9a9; }\n  .color-picker[_ngcontent-%COMP%]   .selected-color-background[_ngcontent-%COMP%] {\n    width: 40px;\n    height: 40px;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    -khtml-border-radius: 50%;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAh0lEQVRYR+2W0QlAMQgD60zdfwOdqa8TmI/wQMr5K0I5bZLIzLOa2nt37VVVbd+dDx5obgCC3KBLwJ2ff4PnVidkf+ucIhw80HQaCLo3DMH3CRK3iFsmAWVl6hPNDwt8EvNE5q+YuEXcMgkonVM6SdyCoEvAnZ8v1Hjx817MilmxSUB5rdLJDycZgUAZUch/AAAAAElFTkSuQmCC\"); }\n  .color-picker[_ngcontent-%COMP%]   .type-policy[_ngcontent-%COMP%] {\n    position: absolute;\n    top: 215px;\n    right: 12px;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAgCAYAAAAffCjxAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACewAAAnsB01CO3AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAIASURBVEiJ7ZY9axRRFIafsxMStrLQJpAgpBFhi+C9w1YSo00I6RZ/g9vZpBf/QOr4GyRgkSKNSrAadsZqQGwCkuAWyRZJsySwvhZ7N/vhzrgbLH3Ld8597jlzz50zJokyxXH8DqDVar0qi6v8BbItqSGpEcfxdlmsFWXkvX8AfAVWg3UKPEnT9GKujMzsAFgZsVaCN1VTQd77XUnrgE1kv+6935268WRpzrnHZvYRWC7YvC3pRZZl3wozqtVqiyH9IgjAspkd1Gq1xUJQtVrdB9ZKIAOthdg/Qc65LUk7wNIMoCVJO865rYFhkqjX6/d7vV4GPJwBMqofURS5JEk6FYBer/eeYb/Mo9WwFnPOvQbeAvfuAAK4BN4sAJtAG/gJIElmNuiJyba3EGNmZiPeZuEVmVell/Y/6N+CzDn3AXhEOOo7Hv/3BeAz8IzQkMPnJbuPx1wC+yYJ7/0nYIP5S/0FHKdp+rwCEEXRS/rf5Hl1Gtb2M0iSpCOpCZzPATmX1EySpHMLAsiy7MjMDoHrGSDXZnaYZdnRwBh7J91utwmczAA6CbG3GgPleX4jqUH/a1CktqRGnuc3hSCAMB32gKspkCtgb3KCQMmkjeP4WNJThrNNZval1WptTIsv7JtQ4tmIdRa8qSoEpWl6YWZNoAN0zKxZNPehpLSBZv2t+Q0CJ9lLnARQLAAAAABJRU5ErkJggg==\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 8px 16px;\n    -moz-background-size: 8px 16px;\n    -webkit-background-size: 8px 16px;\n    -o-background-size: 8px 16px;\n    width: 16px;\n    height: 24px; }\n  .color-picker[_ngcontent-%COMP%]   .hsla-text[_ngcontent-%COMP%], .color-picker[_ngcontent-%COMP%]   .rgba-text[_ngcontent-%COMP%] {\n    width: 100%;\n    font-size: 11px;\n    padding: 4px 8px; }\n    .color-picker[_ngcontent-%COMP%]   .hsla-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%], .color-picker[_ngcontent-%COMP%]   .rgba-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%] {\n      padding: 0 24px 8px 8px; }\n      .color-picker[_ngcontent-%COMP%]   .hsla-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%], .color-picker[_ngcontent-%COMP%]   .rgba-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%] {\n        min-width: 0;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin: 0;\n        float: left;\n        margin-right: 8px;\n        border: #a9a9a9 solid 1px;\n        padding: 1px; }\n        .color-picker[_ngcontent-%COMP%]   .hsla-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:last-child, .color-picker[_ngcontent-%COMP%]   .rgba-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:last-child {\n          margin-right: 0; }\n      .color-picker[_ngcontent-%COMP%]   .hsla-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   div[_ngcontent-%COMP%], .color-picker[_ngcontent-%COMP%]   .rgba-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   div[_ngcontent-%COMP%] {\n        -webkit-flex: 1 1 auto;\n        -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n        text-align: center;\n        color: #555;\n        margin-right: 8px; }\n        .color-picker[_ngcontent-%COMP%]   .hsla-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-child, .color-picker[_ngcontent-%COMP%]   .rgba-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:last-child {\n          margin-right: 0; }\n  .color-picker[_ngcontent-%COMP%]   .hex-text[_ngcontent-%COMP%] {\n    width: 100%;\n    font-size: 11px;\n    padding: 4px 8px; }\n    .color-picker[_ngcontent-%COMP%]   .hex-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%] {\n      padding: 0 24px 8px 8px; }\n      .color-picker[_ngcontent-%COMP%]   .hex-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   input[_ngcontent-%COMP%] {\n        -webkit-flex: 1 1 auto;\n        -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n        border: #a9a9a9 solid 1px;\n        padding: 1px; }\n      .color-picker[_ngcontent-%COMP%]   .hex-text[_ngcontent-%COMP%]   .box[_ngcontent-%COMP%]   div[_ngcontent-%COMP%] {\n        -webkit-flex: 1 1 auto;\n        -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n        text-align: center;\n        color: #555;\n        float: left;\n        clear: left; }\n  .color-picker[_ngcontent-%COMP%]   .cp-add-color-button-class[_ngcontent-%COMP%] {\n    background: transparent;\n    border: 0;\n    cursor: pointer;\n    display: inline;\n    margin-left: -3px;\n    margin-top: 3px;\n    padding: 0;\n    position: absolute; }\n    .color-picker[_ngcontent-%COMP%]   .cp-add-color-button-class[_ngcontent-%COMP%]:hover {\n      text-decoration: underline; }\n    .color-picker[_ngcontent-%COMP%]   .cp-add-color-button-class[_ngcontent-%COMP%]:disabled {\n      color: #999;\n      cursor: not-allowed; }\n      .color-picker[_ngcontent-%COMP%]   .cp-add-color-button-class[_ngcontent-%COMP%]:disabled:hover {\n        text-decoration: none; }\n  .color-picker[_ngcontent-%COMP%]   .cp-remove-color-button-class[_ngcontent-%COMP%] {\n    background: #fff;\n    border-radius: 50%;\n    box-shadow: 1px 1px 5px #333;\n    cursor: pointer;\n    display: block;\n    height: 10px;\n    position: absolute;\n    right: -5px;\n    text-align: center;\n    top: -5px;\n    width: 10px; }\n    .color-picker[_ngcontent-%COMP%]   .cp-remove-color-button-class[_ngcontent-%COMP%]:before {\n      bottom: 3.5px;\n      content: 'x';\n      display: inline-block;\n      font-size: 10px;\n      position: relative; }"];



// EXTERNAL MODULE: ./node_modules/ngx-color-picker/dist/lib/helpers.js
var lib_helpers = __webpack_require__("/mv9");
var helpers_default = /*#__PURE__*/__webpack_require__.n(lib_helpers);

// EXTERNAL MODULE: ./node_modules/ngx-color-picker/dist/lib/color-picker.component.js
var color_picker_component = __webpack_require__("yCRx");
var color_picker_component_default = /*#__PURE__*/__webpack_require__.n(color_picker_component);

// CONCATENATED MODULE: ./node_modules/ngx-color-picker/dist/lib/color-picker.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _color_picker.component.css.shim.ngstyle,_angular_core,_helpers,_angular_common,_color_picker.component,_color_picker.service PURE_IMPORTS_END */






var styles_ColorPickerComponent = [color_picker_component_css_shim_ngstyle_styles];
var RenderType_ColorPickerComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 0, styles: styles_ColorPickerComponent, data: {} });

function View_ColorPickerComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [], [[8, "className", 0], [4, "top", "px"]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "arrow arrow-", _co.cpPosition, ""); var currVal_1 = _co.arrowTop; _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_ColorPickerComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "button", [], [[8, "className", 0], [8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.addPresetColor($event, _co.selectedColor) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _co.cpAddColorButtonClass, ""); var currVal_1 = (_co.cpPresetColors && (_co.cpPresetColors.length >= _co.cpMaxPresetColorsLength)); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _co.cpAddColorButtonText; _ck(_v, 1, 0, currVal_2); });
}
function View_ColorPickerComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["style", "height: 16px;"]], null, null, null, null, null))], null, null); }
function View_ColorPickerComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "input", [["max", "1"], ["min", "0"], ["pattern", "[0-9]+([\\.,][0-9]{1,2})?"], ["step", "0.1"], ["type", "number"]], [[8, "value", 0]], [[null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("newValue" === en)) {
                var pd_1 = (_co.setA($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, lib_helpers["TextDirective"], [], { rg: [0, "rg"] }, { newValue: "newValue" })], function (_ck, _v) { var currVal_1 = 1; _ck(_v, 1, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.hslaText.a; _ck(_v, 0, 0, currVal_0); });
}
function View_ColorPickerComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["A"]))], null, null); }
function View_ColorPickerComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "input", [["max", "1"], ["min", "0"], ["pattern", "[0-9]+([\\.,][0-9]{1,2})?"], ["step", "0.1"], ["type", "number"]], [[8, "value", 0]], [[null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("newValue" === en)) {
                var pd_1 = (_co.setA($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](1, 16384, null, 0, lib_helpers["TextDirective"], [], { rg: [0, "rg"] }, { newValue: "newValue" })], function (_ck, _v) { var currVal_1 = 1; _ck(_v, 1, 0, currVal_1); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.rgbaText.a; _ck(_v, 0, 0, currVal_0); });
}
function View_ColorPickerComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["A"]))], null, null); }
function View_ColorPickerComponent_11(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "span", [], [[8, "className", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.removePresetColor($event, _v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _co.cpRemoveColorButtonClass, ""); _ck(_v, 0, 0, currVal_0); });
}
function View_ColorPickerComponent_10(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "preset-color"]], [[4, "backgroundColor", null]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.setColorFromString(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_11)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.cpAddColorButton; _ck(_v, 2, 0, currVal_1); }, function (_ck, _v) { var currVal_0 = _v.context.$implicit; _ck(_v, 0, 0, currVal_0); });
}
function View_ColorPickerComponent_9(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_10)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.cpPresetColors; _ck(_v, 2, 0, currVal_0); }, null); }
function View_ColorPickerComponent_12(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [], [[8, "className", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _co.cpPresetEmptyMessageClass, ""); _ck(_v, 0, 0, currVal_0); var currVal_1 = _co.cpPresetEmptyMessage; _ck(_v, 1, 0, currVal_1); }); }
function View_ColorPickerComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "preset-area"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "hr", [], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 1, "div", [["class", "preset-label"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_9)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_12)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.cpPresetColors.length; _ck(_v, 5, 0, currVal_1); var currVal_2 = (!_co.cpPresetColors.length && _co.cpAddColorButton); _ck(_v, 7, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.cpPresetLabel; _ck(_v, 3, 0, currVal_0); }); }
function View_ColorPickerComponent_14(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "button", [["type", "button"]], [[8, "className", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.oKColor($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _co.cpOKButtonClass, ""); _ck(_v, 0, 0, currVal_0); var currVal_1 = _co.cpOKButtonText; _ck(_v, 1, 0, currVal_1); });
}
function View_ColorPickerComponent_15(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "button", [["type", "button"]], [[8, "className", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancelColor($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵinlineInterpolate"](1, "", _co.cpCancelButtonClass, ""); _ck(_v, 0, 0, currVal_0); var currVal_1 = _co.cpCancelButtonText; _ck(_v, 1, 0, currVal_1); });
}
function View_ColorPickerComponent_13(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "button-area"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_14)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_15)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.cpOKButton; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.cpCancelButton; _ck(_v, 4, 0, currVal_1); }, null); }
function View_ColorPickerComponent_0(_l) {
    return core["ɵvid"](0, [core["ɵqud"](402653184, 1, { hueSlider: 0 }), core["ɵqud"](402653184, 2, { alphaSlider: 0 }), core["ɵqud"](402653184, 3, { dialogElement: 0 }), (_l()(), core["ɵeld"](3, 0, [[3, 0], ["dialogPopup", 1]], null, 70, "div", [["class", "color-picker"]], [[4, "visibility", null], [4, "height", "px"], [4, "width", "px"], [4, "top", "px"], [4, "left", "px"], [4, "position", null]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_1)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 2, "div", [["class", "saturation-lightness"]], [[4, "background-color", null]], [[null, "newValue"], [null, "dragStart"], [null, "dragEnd"], [null, "mousedown"], [null, "touchstart"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mousedown" === en)) {
                var pd_0 = (core["ɵnov"](_v, 7).start($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("touchstart" === en)) {
                var pd_1 = (core["ɵnov"](_v, 7).start($event) !== false);
                ad = (pd_1 && ad);
            }
            if (("newValue" === en)) {
                var pd_2 = (_co.setSaturationAndBrightness($event) !== false);
                ad = (pd_2 && ad);
            }
            if (("dragStart" === en)) {
                var pd_3 = (_co.onDragStart("saturation-lightness") !== false);
                ad = (pd_3 && ad);
            }
            if (("dragEnd" === en)) {
                var pd_4 = (_co.onDragEnd("saturation-lightness") !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](7, 16384, null, 0, lib_helpers["SliderDirective"], [core["ElementRef"]], { rgX: [0, "rgX"], rgY: [1, "rgY"] }, { newValue: "newValue", dragStart: "dragStart", dragEnd: "dragEnd" }), (_l()(), core["ɵeld"](8, 0, null, null, 0, "div", [["class", "cursor"]], [[4, "left", "px"], [4, "top", "px"]], null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 14, "div", [["class", "box"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 4, "div", [["class", "left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 0, "div", [["class", "selected-color-background"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 0, "div", [["class", "selected-color"]], [[4, "background-color", null]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_2)), core["ɵdid"](14, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 8, "div", [["class", "right"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_3)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](18, 0, [[1, 0], ["hueSlider", 1]], null, 2, "div", [["class", "hue"]], null, [[null, "newValue"], [null, "dragStart"], [null, "dragEnd"], [null, "mousedown"], [null, "touchstart"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mousedown" === en)) {
                var pd_0 = (core["ɵnov"](_v, 19).start($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("touchstart" === en)) {
                var pd_1 = (core["ɵnov"](_v, 19).start($event) !== false);
                ad = (pd_1 && ad);
            }
            if (("newValue" === en)) {
                var pd_2 = (_co.setHue($event) !== false);
                ad = (pd_2 && ad);
            }
            if (("dragStart" === en)) {
                var pd_3 = (_co.onDragStart("hue") !== false);
                ad = (pd_3 && ad);
            }
            if (("dragEnd" === en)) {
                var pd_4 = (_co.onDragEnd("hue") !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](19, 16384, null, 0, lib_helpers["SliderDirective"], [core["ElementRef"]], { rgX: [0, "rgX"] }, { newValue: "newValue", dragStart: "dragStart", dragEnd: "dragEnd" }), (_l()(), core["ɵeld"](20, 0, null, null, 0, "div", [["class", "cursor"]], [[4, "left", "px"]], null, null, null, null)), (_l()(), core["ɵeld"](21, 0, [[2, 0], ["alphaSlider", 1]], null, 2, "div", [["class", "alpha"]], [[4, "display", null], [4, "background-color", null]], [[null, "newValue"], [null, "dragStart"], [null, "dragEnd"], [null, "mousedown"], [null, "touchstart"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mousedown" === en)) {
                var pd_0 = (core["ɵnov"](_v, 22).start($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("touchstart" === en)) {
                var pd_1 = (core["ɵnov"](_v, 22).start($event) !== false);
                ad = (pd_1 && ad);
            }
            if (("newValue" === en)) {
                var pd_2 = (_co.setAlpha($event) !== false);
                ad = (pd_2 && ad);
            }
            if (("dragStart" === en)) {
                var pd_3 = (_co.onDragStart("alpha") !== false);
                ad = (pd_3 && ad);
            }
            if (("dragEnd" === en)) {
                var pd_4 = (_co.onDragEnd("alpha") !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](22, 16384, null, 0, lib_helpers["SliderDirective"], [core["ElementRef"]], { rgX: [0, "rgX"] }, { newValue: "newValue", dragStart: "dragStart", dragEnd: "dragEnd" }), (_l()(), core["ɵeld"](23, 0, null, null, 0, "div", [["class", "cursor"]], [[4, "left", "px"]], null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 18, "div", [["class", "hsla-text"]], [[4, "display", null]], null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 8, "div", [["class", "box"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 1, "input", [["max", "360"], ["min", "0"], ["pattern", "[0-9]*"], ["type", "number"]], [[8, "value", 0]], [[null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 27).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("newValue" === en)) {
                var pd_1 = (_co.setHue($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](27, 16384, null, 0, lib_helpers["TextDirective"], [], { rg: [0, "rg"] }, { newValue: "newValue" }), (_l()(), core["ɵeld"](28, 0, null, null, 1, "input", [["max", "100"], ["min", "0"], ["pattern", "[0-9]*"], ["type", "number"]], [[8, "value", 0]], [[null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 29).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("newValue" === en)) {
                var pd_1 = (_co.setSaturation($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](29, 16384, null, 0, lib_helpers["TextDirective"], [], { rg: [0, "rg"] }, { newValue: "newValue" }), (_l()(), core["ɵeld"](30, 0, null, null, 1, "input", [["max", "100"], ["min", "0"], ["pattern", "[0-9]*"], ["type", "number"]], [[8, "value", 0]], [[null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 31).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("newValue" === en)) {
                var pd_1 = (_co.setLightness($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](31, 16384, null, 0, lib_helpers["TextDirective"], [], { rg: [0, "rg"] }, { newValue: "newValue" }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_4)), core["ɵdid"](33, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](34, 0, null, null, 8, "div", [["class", "box"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["H"])), (_l()(), core["ɵeld"](37, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["S"])), (_l()(), core["ɵeld"](39, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["L"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_5)), core["ɵdid"](42, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](43, 0, null, null, 18, "div", [["class", "rgba-text"]], [[4, "display", null]], null, null, null, null)), (_l()(), core["ɵeld"](44, 0, null, null, 8, "div", [["class", "box"]], null, null, null, null, null)), (_l()(), core["ɵeld"](45, 0, null, null, 1, "input", [["max", "255"], ["min", "0"], ["pattern", "[0-9]*"], ["type", "number"]], [[8, "value", 0]], [[null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 46).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("newValue" === en)) {
                var pd_1 = (_co.setR($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](46, 16384, null, 0, lib_helpers["TextDirective"], [], { rg: [0, "rg"] }, { newValue: "newValue" }), (_l()(), core["ɵeld"](47, 0, null, null, 1, "input", [["max", "255"], ["min", "0"], ["pattern", "[0-9]*"], ["type", "number"]], [[8, "value", 0]], [[null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 48).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("newValue" === en)) {
                var pd_1 = (_co.setG($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](48, 16384, null, 0, lib_helpers["TextDirective"], [], { rg: [0, "rg"] }, { newValue: "newValue" }), (_l()(), core["ɵeld"](49, 0, null, null, 1, "input", [["max", "255"], ["min", "0"], ["pattern", "[0-9]*"], ["type", "number"]], [[8, "value", 0]], [[null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 50).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("newValue" === en)) {
                var pd_1 = (_co.setB($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](50, 16384, null, 0, lib_helpers["TextDirective"], [], { rg: [0, "rg"] }, { newValue: "newValue" }), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_6)), core["ɵdid"](52, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](53, 0, null, null, 8, "div", [["class", "box"]], null, null, null, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["R"])), (_l()(), core["ɵeld"](56, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["G"])), (_l()(), core["ɵeld"](58, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["B"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_7)), core["ɵdid"](61, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](62, 0, null, null, 6, "div", [["class", "hex-text"]], [[4, "display", null]], null, null, null, null)), (_l()(), core["ɵeld"](63, 0, null, null, 2, "div", [["class", "box"]], null, null, null, null, null)), (_l()(), core["ɵeld"](64, 0, null, null, 1, "input", [], [[8, "value", 0]], [[null, "blur"], [null, "newValue"], [null, "input"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 65).changeInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (_co.setHex(null) !== false);
                ad = (pd_1 && ad);
            }
            if (("newValue" === en)) {
                var pd_2 = (_co.setHex($event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](65, 16384, null, 0, lib_helpers["TextDirective"], [], null, { newValue: "newValue" }), (_l()(), core["ɵeld"](66, 0, null, null, 2, "div", [["class", "box"]], null, null, null, null, null)), (_l()(), core["ɵeld"](67, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Hex"])), (_l()(), core["ɵeld"](69, 0, null, null, 0, "div", [["class", "type-policy"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.formatPolicy() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_8)), core["ɵdid"](71, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ColorPickerComponent_13)), core["ɵdid"](73, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_6 = (_co.cpDialogDisplay == "popup"); _ck(_v, 5, 0, currVal_6); var currVal_8 = 1; var currVal_9 = 1; _ck(_v, 7, 0, currVal_8, currVal_9); var currVal_13 = _co.cpAddColorButton; _ck(_v, 14, 0, currVal_13); var currVal_14 = (_co.cpAlphaChannel === "disabled"); _ck(_v, 17, 0, currVal_14); var currVal_15 = 1; _ck(_v, 19, 0, currVal_15); var currVal_19 = 1; _ck(_v, 22, 0, currVal_19); var currVal_23 = 360; _ck(_v, 27, 0, currVal_23); var currVal_25 = 100; _ck(_v, 29, 0, currVal_25); var currVal_27 = 100; _ck(_v, 31, 0, currVal_27); var currVal_28 = (_co.cpAlphaChannel !== "disabled"); _ck(_v, 33, 0, currVal_28); var currVal_29 = (_co.cpAlphaChannel !== "disabled"); _ck(_v, 42, 0, currVal_29); var currVal_32 = 255; _ck(_v, 46, 0, currVal_32); var currVal_34 = 255; _ck(_v, 48, 0, currVal_34); var currVal_36 = 255; _ck(_v, 50, 0, currVal_36); var currVal_37 = (_co.cpAlphaChannel !== "disabled"); _ck(_v, 52, 0, currVal_37); var currVal_38 = (_co.cpAlphaChannel !== "disabled"); _ck(_v, 61, 0, currVal_38); var currVal_41 = _co.cpPresetColors; _ck(_v, 71, 0, currVal_41); var currVal_42 = (_co.cpOKButton || _co.cpCancelButton); _ck(_v, 73, 0, currVal_42); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = ((_co.hidden || !_co.show) ? "hidden" : "visible"); var currVal_1 = _co.cpHeight; var currVal_2 = _co.cpWidth; var currVal_3 = _co.top; var currVal_4 = _co.left; var currVal_5 = _co.position; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5); var currVal_7 = _co.hueSliderColor; _ck(_v, 6, 0, currVal_7); var currVal_10 = _co.slider.s; var currVal_11 = _co.slider.v; _ck(_v, 8, 0, currVal_10, currVal_11); var currVal_12 = _co.selectedColor; _ck(_v, 12, 0, currVal_12); var currVal_16 = _co.slider.h; _ck(_v, 20, 0, currVal_16); var currVal_17 = ((_co.cpAlphaChannel === "disabled") ? "none" : "block"); var currVal_18 = _co.alphaSliderColor; _ck(_v, 21, 0, currVal_17, currVal_18); var currVal_20 = _co.slider.a; _ck(_v, 23, 0, currVal_20); var currVal_21 = ((_co.format !== 2) ? "none" : "block"); _ck(_v, 24, 0, currVal_21); var currVal_22 = _co.hslaText.h; _ck(_v, 26, 0, currVal_22); var currVal_24 = _co.hslaText.s; _ck(_v, 28, 0, currVal_24); var currVal_26 = _co.hslaText.l; _ck(_v, 30, 0, currVal_26); var currVal_30 = ((_co.format !== 1) ? "none" : "block"); _ck(_v, 43, 0, currVal_30); var currVal_31 = _co.rgbaText.r; _ck(_v, 45, 0, currVal_31); var currVal_33 = _co.rgbaText.g; _ck(_v, 47, 0, currVal_33); var currVal_35 = _co.rgbaText.b; _ck(_v, 49, 0, currVal_35); var currVal_39 = ((_co.format !== 0) ? "none" : "block"); _ck(_v, 62, 0, currVal_39); var currVal_40 = _co.hexText; _ck(_v, 64, 0, currVal_40); });
}
function View_ColorPickerComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "color-picker", [], null, null, null, View_ColorPickerComponent_0, RenderType_ColorPickerComponent)), core["ɵdid"](1, 4308992, null, 0, color_picker_component["ColorPickerComponent"], [core["ElementRef"], core["ChangeDetectorRef"], color_picker_service["ColorPickerService"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ColorPickerComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("color-picker", color_picker_component["ColorPickerComponent"], View_ColorPickerComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./node_modules/@angular/animations/fesm5/animations.js
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/**
 * An injectable service that produces an animation sequence programmatically within an
 * Angular component or directive.
 * Provided by the `BrowserAnimationsModule` or `NoopAnimationsModule`.
 *
 * @usageNotes
 *
 * To use this service, add it to your component or directive as a dependency.
 * The service is instantiated along with your component.
 *
 * Apps do not typically need to create their own animation players, but if you
 * do need to, follow these steps:
 *
 * 1. Use the `build()` method to create a programmatic animation using the
 * `animate()` function. The method returns an `AnimationFactory` instance.
 *
 * 2. Use the factory object to create an `AnimationPlayer` and attach it to a DOM element.
 *
 * 3. Use the player object to control the animation programmatically.
 *
 * For example:
 *
 * ```ts
 * // import the service from BrowserAnimationsModule
 * import {AnimationBuilder} from '@angular/animations';
 * // require the service as a dependency
 * class MyCmp {
 *   constructor(private _builder: AnimationBuilder) {}
 *
 *   makeAnimation(element: any) {
 *     // first define a reusable animation
 *     const myAnimation = this._builder.build([
 *       style({ width: 0 }),
 *       animate(1000, style({ width: '100px' }))
 *     ]);
 *
 *     // use the returned factory object to create a player
 *     const player = myAnimation.create(element);
 *
 *     player.play();
 *   }
 * }
 * ```
 *
 */
var AnimationBuilder = /*@__PURE__*/ (function () {
    function AnimationBuilder() {
    }
    return AnimationBuilder;
}());
/**
 * A factory object returned from the `AnimationBuilder`.`build()` method.
 *
 */
var AnimationFactory = /*@__PURE__*/ (function () {
    function AnimationFactory() {
    }
    return AnimationFactory;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Specifies automatic styling.
 */
var AUTO_STYLE = '*';
/**
 * Creates a named animation trigger, containing a  list of `state()`
 * and `transition()` entries to be evaluated when the expression
 * bound to the trigger changes.
 *
 * @param name An identifying string.
 * @param definitions  An animation definition object, containing an array of `state()`
 * and `transition()` declarations.
 *
 * @return An object that encapsulates the trigger data.
 *
 * @usageNotes
 * Define an animation trigger in the `animations` section of `@Component` metadata.
 * In the template, reference the trigger by name and bind it to a trigger expression that
 * evaluates to a defined animation state, using the following format:
 *
 * `[@triggerName]="expression"`
 *
 * Animation trigger bindings convert all values to strings, and then match the
 * previous and current values against any linked transitions.
 * Booleans can be specified as `1` or `true` and `0` or `false`.
 *
 * ### Usage Example
 *
 * The following example creates an animation trigger reference based on the provided
 * name value.
 * The provided animation value is expected to be an array consisting of state and
 * transition declarations.
 *
 * ```typescript
 * @Component({
 *   selector: "my-component",
 *   templateUrl: "my-component-tpl.html",
 *   animations: [
 *     trigger("myAnimationTrigger", [
 *       state(...),
 *       state(...),
 *       transition(...),
 *       transition(...)
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   myStatusExp = "something";
 * }
 * ```
 *
 * The template associated with this component makes use of the defined trigger
 * by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * ### Using an inline function
 * The `transition` animation method also supports reading an inline function which can decide
 * if its associated animation should be run.
 *
 * ```typescript
 * // this method is run each time the `myAnimationTrigger` trigger value changes.
 * function myInlineMatcherFn(fromState: string, toState: string, element: any, params: {[key:
 string]: any}): boolean {
 *   // notice that `element` and `params` are also available here
 *   return toState == 'yes-please-animate';
 * }
 *
 * @Component({
 *   selector: 'my-component',
 *   templateUrl: 'my-component-tpl.html',
 *   animations: [
 *     trigger('myAnimationTrigger', [
 *       transition(myInlineMatcherFn, [
 *         // the animation sequence code
 *       ]),
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   myStatusExp = "yes-please-animate";
 * }
 * ```
 *
 * ### Disabling Animations
 * When true, the special animation control binding `@.disabled` binding prevents
 * all animations from rendering.
 * Place the  `@.disabled` binding on an element to disable
 * animations on the element itself, as well as any inner animation triggers
 * within the element.
 *
 * The following example shows how to use this feature:
 *
 * ```typescript
 * @Component({
 *   selector: 'my-component',
 *   template: `
 *     <div [@.disabled]="isDisabled">
 *       <div [@childAnimation]="exp"></div>
 *     </div>
 *   `,
 *   animations: [
 *     trigger("childAnimation", [
 *       // ...
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   isDisabled = true;
 *   exp = '...';
 * }
 * ```
 *
 * When `@.disabled` is true, it prevents the `@childAnimation` trigger from animating,
 * along with any inner animations.
 *
 * ### Disable animations application-wide
 * When an area of the template is set to have animations disabled,
 * **all** inner components have their animations disabled as well.
 * This means that you can disable all animations for an app
 * by placing a host binding set on `@.disabled` on the topmost Angular component.
 *
 * ```typescript
 * import {Component, HostBinding} from '@angular/core';
 *
 * @Component({
 *   selector: 'app-component',
 *   templateUrl: 'app.component.html',
 * })
 * class AppComponent {
 *   @HostBinding('@.disabled')
 *   public animationsDisabled = true;
 * }
 * ```
 *
 * ### Overriding disablement of inner animations
 * Despite inner animations being disabled, a parent animation can `query()`
 * for inner elements located in disabled areas of the template and still animate
 * them if needed. This is also the case for when a sub animation is
 * queried by a parent and then later animated using `animateChild()`.
 *
 * ### Detecting when an animation is disabled
 * If a region of the DOM (or the entire application) has its animations disabled, the animation
 * trigger callbacks still fire, but for zero seconds. When the callback fires, it provides
 * an instance of an `AnimationEvent`. If animations are disabled,
 * the `.disabled` flag on the event is true.
 *
 * @experimental Animation support is experimental.
 */
function trigger(name, definitions) {
    return { type: 7 /* Trigger */, name: name, definitions: definitions, options: {} };
}
/**
 * Defines an animation step that combines styling information with timing information.
 *
 * @param timings Sets `AnimateTimings` for the parent animation.
 * A string in the format "duration [delay] [easing]".
 *  - Duration and delay are expressed as a number and optional time unit,
 * such as "1s" or "10ms" for one second and 10 milliseconds, respectively.
 * The default unit is milliseconds.
 *  - The easing value controls how the animation accelerates and decelerates
 * during its runtime. Value is one of  `ease`, `ease-in`, `ease-out`,
 * `ease-in-out`, or a `cubic-bezier()` function call.
 * If not supplied, no easing is applied.
 *
 * For example, the string "1s 100ms ease-out" specifies a duration of
 * 1000 milliseconds, and delay of 100 ms, and the "ease-out" easing style,
 * which decelerates near the end of the duration.
 * @param styles Sets AnimationStyles for the parent animation.
 * A function call to either `style()` or `keyframes()`
 * that returns a collection of CSS style entries to be applied to the parent animation.
 * When null, uses the styles from the destination state.
 * This is useful when describing an animation step that will complete an animation;
 * see "Animating to the final state" in `transitions()`.
 * @returns An object that encapsulates the animation step.
 *
 * @usageNotes
 * Call within an animation `sequence()`, `{@link animations/group group()}`, or
 * `transition()` call to specify an animation step
 * that applies given style data to the parent animation for a given amount of time.
 *
 * ### Syntax Examples
 * **Timing examples**
 *
 * The following examples show various `timings` specifications.
 * - `animate(500)` : Duration is 500 milliseconds.
 * - `animate("1s")` : Duration is 1000 milliseconds.
 * - `animate("100ms 0.5s")` : Duration is 100 milliseconds, delay is 500 milliseconds.
 * - `animate("5s ease-in")` : Duration is 5000 milliseconds, easing in.
 * - `animate("5s 10ms cubic-bezier(.17,.67,.88,.1)")` : Duration is 5000 milliseconds, delay is 10
 * milliseconds, easing according to a bezier curve.
 *
 * **Style examples**
 *
 * The following example calls `style()` to set a single CSS style.
 * ```typescript
 * animate(500, style({ background: "red" }))
 * ```
 * The following example calls `keyframes()` to set a CSS style
 * to different values for successive keyframes.
 * ```typescript
 * animate(500, keyframes(
 *  [
 *   style({ background: "blue" })),
 *   style({ background: "red" }))
 *  ])
 * ```
 */
function animate(timings, styles) {
    if (styles === void 0) {
        styles = null;
    }
    return { type: 4 /* Animate */, styles: styles, timings: timings };
}
/**
 * @description Defines a list of animation steps to be run in parallel.
 *
 * @param steps An array of animation step objects.
 * - When steps are defined by `style()` or `animate()`
 * function calls, each call within the group is executed instantly.
 * - To specify offset styles to be applied at a later time, define steps with
 * `keyframes()`, or use `animate()` calls with a delay value.
 * For example:
 *
 * ```typescript
 * group([
 *   animate("1s", { background: "black" }))
 *   animate("2s", { color: "white" }))
 * ])
 * ```
 *
 * @param options An options object containing a delay and
 * developer-defined parameters that provide styling defaults and
 * can be overridden on invocation.
 *
 * @return An object that encapsulates the group data.
 *
 * @usageNotes
 * Grouped animations are useful when a series of styles must be
 * animated at different starting times and closed off at different ending times.
 *
 * When called within a `sequence()` or a
 * `transition()` call, does not continue to the next
 * instruction until all of the inner animation steps have completed.
 */
function animations_group(steps, options) {
    if (options === void 0) {
        options = null;
    }
    return { type: 3 /* Group */, steps: steps, options: options };
}
/**
 * Defines a list of animation steps to be run sequentially, one by one.
 *
 * @param steps An array of animation step objects.
 * - Steps defined by `style()` calls apply the styling data immediately.
 * - Steps defined by `animate()` calls apply the styling data over time
 *   as specified by the timing data.
 *
 * ```typescript
 * sequence([
 *   style({ opacity: 0 })),
 *   animate("1s", { opacity: 1 }))
 * ])
 * ```
 *
 * @param options An options object containing a delay and
 * developer-defined parameters that provide styling defaults and
 * can be overridden on invocation.
 *
 * @return An object that encapsulates the sequence data.
 *
 * @usageNotes
 * When you pass an array of steps to a
 * `transition()` call, the steps run sequentially by default.
 * Compare this to the `{@link animations/group group()}` call, which runs animation steps in parallel.
 *
 * When a sequence is used within a `{@link animations/group group()}` or a `transition()` call,
 * execution continues to the next instruction only after each of the inner animation
 * steps have completed.
 *
 **/
function sequence(steps, options) {
    if (options === void 0) {
        options = null;
    }
    return { type: 2 /* Sequence */, steps: steps, options: options };
}
/**
 * Declares a key/value object containing CSS properties/styles that
 * can then be used for an animation `state`, within an animation `sequence`,
 * or as styling data for calls to `animate()` and `keyframes()`.
 *
 * @param tokens A set of CSS styles or HTML styles associated with an animation state.
 * The value can be any of the following:
 * - A key-value style pair associating a CSS property with a value.
 * - An array of key-value style pairs.
 * - An asterisk (*), to use auto-styling, where styles are derived from the element
 * being animated and applied to the animation when it starts.
 *
 * Auto-styling can be used to define a state that depends on layout or other
 * environmental factors.
 *
 * @return An object that encapsulates the style data.
 *
 * @usageNotes
 * The following examples create animation styles that collect a set of
 * CSS property values:
 *
 * ```typescript
 * // string values for CSS properties
 * style({ background: "red", color: "blue" })
 *
 * // numerical pixel values
 * style({ width: 100, height: 0 })
 * ```
 *
 * The following example uses auto-styling to allow a component to animate from
 * a height of 0 up to the height of the parent element:
 *
 * ```
 * style({ height: 0 }),
 * animate("1s", style({ height: "*" }))
 * ```
 *
 **/
function animations_style(tokens) {
    return { type: 6 /* Style */, styles: tokens, offset: null };
}
/**
 * Declares an animation state within a trigger attached to an element.
 *
 * @param name One or more names for the defined state in a comma-separated string.
 * The following reserved state names can be supplied to define a style for specific use
 * cases:
 *
 * - `void` You can associate styles with this name to be used when
 * the element is detached from the application. For example, when an `ngIf` evaluates
 * to false, the state of the associated element is void.
 *  - `*` (asterisk) Indicates the default state. You can associate styles with this name
 * to be used as the fallback when the state that is being animated is not declared
 * within the trigger.
 *
 * @param styles A set of CSS styles associated with this state, created using the
 * `style()` function.
 * This set of styles persists on the element once the state has been reached.
 * @param options Parameters that can be passed to the state when it is invoked.
 * 0 or more key-value pairs.
 * @return An object that encapsulates the new state data.
 *
 * @usageNotes
 * Use the `trigger()` function to register states to an animation trigger.
 * Use the `transition()` function to animate between states.
 * When a state is active within a component, its associated styles persist on the element,
 * even when the animation ends.
 **/
function animations_state(name, styles, options) {
    return { type: 0 /* State */, name: name, styles: styles, options: options };
}
/**
 * Defines a set of animation styles, associating each style with an optional `offset` value.
 *
 * @param steps A set of animation styles with optional offset data.
 * The optional `offset` value for a style specifies a percentage of the total animation
 * time at which that style is applied.
 * @returns An object that encapsulates the keyframes data.
 *
 * @usageNotes
 * Use with the `animate()` call. Instead of applying animations
 * from the current state
 * to the destination state, keyframes describe how each style entry is applied and at what point
 * within the animation arc.
 * Compare [CSS Keyframe Animations](https://www.w3schools.com/css/css3_animations.asp).
 *
 * ### Usage
 *
 * In the following example, the offset values describe
 * when each `backgroundColor` value is applied. The color is red at the start, and changes to
 * blue when 20% of the total time has elapsed.
 *
 * ```typescript
 * // the provided offset values
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red", offset: 0 }),
 *   style({ backgroundColor: "blue", offset: 0.2 }),
 *   style({ backgroundColor: "orange", offset: 0.3 }),
 *   style({ backgroundColor: "black", offset: 1 })
 * ]))
 * ```
 *
 * If there are no `offset` values specified in the style entries, the offsets
 * are calculated automatically.
 *
 * ```typescript
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red" }) // offset = 0
 *   style({ backgroundColor: "blue" }) // offset = 0.33
 *   style({ backgroundColor: "orange" }) // offset = 0.66
 *   style({ backgroundColor: "black" }) // offset = 1
 * ]))
 *```
 */
function animations_keyframes(steps) {
    return { type: 5 /* Keyframes */, steps: steps };
}
/**
 * Declares an animation transition as a sequence of animation steps to run when a given
 * condition is satisfied. The condition is a Boolean expression or function that compares
 * the previous and current animation states, and returns true if this transition should occur.
 * When the state criteria of a defined transition are met, the associated animation is
 * triggered.
 *
 * @param stateChangeExpr A Boolean expression or function that compares the previous and current
 * animation states, and returns true if this transition should occur. Note that  "true" and "false"
 * match 1 and 0, respectively. An expression is evaluated each time a state change occurs in the
 * animation trigger element.
 * The animation steps run when the expression evaluates to true.
 *
 * - A state-change string takes the form "state1 => state2", where each side is a defined animation
 * state, or an asterix (*) to refer to a dynamic start or end state.
 *   - The expression string can contain multiple comma-separated statements;
 * for example "state1 => state2, state3 => state4".
 *   - Special values `:enter` and `:leave` initiate a transition on the entry and exit states,
 * equivalent to  "void => *"  and "* => void".
 *   - Special values `:increment` and `:decrement` initiate a transition when a numeric value has
 * increased or decreased in value.
 * - A function is executed each time a state change occurs in the animation trigger element.
 * The animation steps run when the function returns true.
 *
 * @param steps One or more animation objects, as returned by the `animate()` or
 * `sequence()` function, that form a transformation from one state to another.
 * A sequence is used by default when you pass an array.
 * @param options An options object that can contain a delay value for the start of the animation,
 * and additional developer-defined parameters. Provided values for additional parameters are used
 * as defaults, and override values can be passed to the caller on invocation.
 * @returns An object that encapsulates the transition data.
 *
 * @usageNotes
 * The template associated with a component binds an animation trigger to an element.
 *
 * ```HTML
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * All transitions are defined within an animation trigger,
 * along with named states that the transitions change to and from.
 *
 * ```typescript
 * trigger("myAnimationTrigger", [
 *  // define states
 *  state("on", style({ background: "green" })),
 *  state("off", style({ background: "grey" })),
 *  ...]
 * ```
 *
 * Note that when you call the `sequence()` function within a `{@link animations/group group()}`
 * or a `transition()` call, execution does not continue to the next instruction
 * until each of the inner animation steps have completed.
 *
 * ### Syntax examples
 *
 * The following examples define transitions between the two defined states (and default states),
 * using various options:
 *
 * ```typescript
 * // Transition occurs when the state value
 * // bound to "myAnimationTrigger" changes from "on" to "off"
 * transition("on => off", animate(500))
 * // Run the same animation for both directions
 * transition("on <=> off", animate(500))
 * // Define multiple state-change pairs separated by commas
 * transition("on => off, off => void", animate(500))
 * ```
 *
 * ### Special values for state-change expressions
 *
 * - Catch-all state change for when an element is inserted into the page and the
 * destination state is unknown:
 *
 * ```typescript
 * transition("void => *", [
 *  style({ opacity: 0 }),
 *  animate(500)
 *  ])
 * ```
 *
 * - Capture a state change between any states:
 *
 *  `transition("* => *", animate("1s 0s"))`
 *
 * - Entry and exit transitions:
 *
 * ```typescript
 * transition(":enter", [
 *   style({ opacity: 0 }),
 *   animate(500, style({ opacity: 1 }))
 *   ]),
 * transition(":leave", [
 *   animate(500, style({ opacity: 0 }))
 *   ])
 * ```
 *
 * - Use `:increment` and `:decrement` to initiate transitions:
 *
 * ```typescript
 * transition(":increment", group([
 *  query(':enter', [
 *     style({ left: '100%' }),
 *     animate('0.5s ease-out', style('*'))
 *   ]),
 *  query(':leave', [
 *     animate('0.5s ease-out', style({ left: '-100%' }))
 *  ])
 * ]))
 *
 * transition(":decrement", group([
 *  query(':enter', [
 *     style({ left: '100%' }),
 *     animate('0.5s ease-out', style('*'))
 *   ]),
 *  query(':leave', [
 *     animate('0.5s ease-out', style({ left: '-100%' }))
 *  ])
 * ]))
 * ```
 *
 * ### State-change functions
 *
 * Here is an example of a `fromState` specified as a state-change function that invokes an
 * animation when true:
 *
 * ```typescript
 * transition((fromState, toState) =>
 *  {
 *   return fromState == "off" && toState == "on";
 *  },
 *  animate("1s 0s"))
 * ```
 *
 * ### Animating to the final state
 *
 * If the final step in a transition is a call to `animate()` that uses a timing value
 * with no style data, that step is automatically considered the final animation arc,
 * for the element to reach the final state. Angular automatically adds or removes
 * CSS styles to ensure that the element is in the correct final state.
 *
 * The following example defines a transition that starts by hiding the element,
 * then makes sure that it animates properly to whatever state is currently active for trigger:
 *
 * ```typescript
 * transition("void => *", [
 *   style({ opacity: 0 }),
 *   animate(500)
 *  ])
 * ```
 * ### Boolean value matching
 * If a trigger binding value is a Boolean, it can be matched using a transition expression
 * that compares true and false or 1 and 0. For example:
 *
 * ```
 * // in the template
 * <div [@openClose]="open ? true : false">...</div>
 * // in the component metadata
 * trigger('openClose', [
 *   state('true', style({ height: '*' })),
 *   state('false', style({ height: '0px' })),
 *   transition('false <=> true', animate(500))
 * ])
 * ```
 **/
function transition(stateChangeExpr, steps, options) {
    if (options === void 0) {
        options = null;
    }
    return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps, options: options };
}
/**
 * Produces a reusable animation that can be invoked in another animation or sequence,
 * by calling the `useAnimation()` function.
 *
 * @param steps One or more animation objects, as returned by the `animate()`
 * or `sequence()` function, that form a transformation from one state to another.
 * A sequence is used by default when you pass an array.
 * @param options An options object that can contain a delay value for the start of the
 * animation, and additional developer-defined parameters.
 * Provided values for additional parameters are used as defaults,
 * and override values can be passed to the caller on invocation.
 * @returns An object that encapsulates the animation data.
 *
 * @usageNotes
 * The following example defines a reusable animation, providing some default parameter
 * values.
 *
 * ```typescript
 * var fadeAnimation = animation([
 *   style({ opacity: '{{ start }}' }),
 *   animate('{{ time }}',
 *   style({ opacity: '{{ end }}'}))
 *   ],
 *   { params: { time: '1000ms', start: 0, end: 1 }});
 * ```
 *
 * The following invokes the defined animation with a call to `useAnimation()`,
 * passing in override parameter values.
 *
 * ```js
 * useAnimation(fadeAnimation, {
 *   params: {
 *     time: '2s',
 *     start: 1,
 *     end: 0
 *   }
 * })
 * ```
 *
 * If any of the passed-in parameter values are missing from this call,
 * the default values are used. If one or more parameter values are missing before a step is
 * animated, `useAnimation()` throws an error.
 */
function animations_animation(steps, options) {
    if (options === void 0) {
        options = null;
    }
    return { type: 8 /* Reference */, animation: steps, options: options };
}
/**
 * Executes a queried inner animation element within an animation sequence.
 *
 * @param options An options object that can contain a delay value for the start of the
 * animation, and additional override values for developer-defined parameters.
 * @return An object that encapsulates the child animation data.
 *
 * @usageNotes
 * Each time an animation is triggered in Angular, the parent animation
 * has priority and any child animations are blocked. In order
 * for a child animation to run, the parent animation must query each of the elements
 * containing child animations, and run them using this function.
 *
 * Note that this feature designed to be used with `query()` and it will only work
 * with animations that are assigned using the Angular animation library. CSS keyframes
 * and transitions are not handled by this API.
 */
function animateChild(options) {
    if (options === void 0) {
        options = null;
    }
    return { type: 9 /* AnimateChild */, options: options };
}
/**
 * Starts a reusable animation that is created using the `animation()` function.
 *
 * @param animation The reusable animation to start.
 * @param options An options object that can contain a delay value for the start of
 * the animation, and additional override values for developer-defined parameters.
 * @return An object that contains the animation parameters.
 */
function useAnimation(animation, options) {
    if (options === void 0) {
        options = null;
    }
    return { type: 10 /* AnimateRef */, animation: animation, options: options };
}
/**
 * Finds one or more inner elements within the current element that is
 * being animated within a sequence. Use with `animateChild()`.
 *
 * @param selector The element to query, or a set of elements that contain Angular-specific
 * characteristics, specified with one or more of the following tokens.
 *  - `query(":enter")` or `query(":leave")` : Query for newly inserted/removed elements.
 *  - `query(":animating")` : Query all currently animating elements.
 *  - `query("@triggerName")` : Query elements that contain an animation trigger.
 *  - `query("@*")` : Query all elements that contain an animation triggers.
 *  - `query(":self")` : Include the current element into the animation sequence.
 *
 * @param animation One or more animation steps to apply to the queried element or elements.
 * An array is treated as an animation sequence.
 * @param options An options object. Use the 'limit' field to limit the total number of
 * items to collect.
 * @return An object that encapsulates the query data.
 *
 * @usageNotes
 * Tokens can be merged into a combined query selector string. For example:
 *
 * ```typescript
 *  query(':self, .record:enter, .record:leave, @subTrigger', [...])
 * ```
 *
 * The `query()` function collects multiple elements and works internally by using
 * `element.querySelectorAll`. Use the `limit` field of an options object to limit
 * the total number of items to be collected. For example:
 *
 * ```js
 * query('div', [
 *   animate(...),
 *   animate(...)
 * ], { limit: 1 })
 * ```
 *
 * By default, throws an error when zero items are found. Set the
 * `optional` flag to ignore this error. For example:
 *
 * ```js
 * query('.some-element-that-may-not-be-there', [
 *   animate(...),
 *   animate(...)
 * ], { optional: true })
 * ```
 *
 * ### Usage Example
 *
 * The following example queries for inner elements and animates them
 * individually using `animateChild()`.
 *
 * ```typescript
 * @Component({
 *   selector: 'inner',
 *   template: `
 *     <div [@queryAnimation]="exp">
 *       <h1>Title</h1>
 *       <div class="content">
 *         Blah blah blah
 *       </div>
 *     </div>
 *   `,
 *   animations: [
 *    trigger('queryAnimation', [
 *      transition('* => goAnimate', [
 *        // hide the inner elements
 *        query('h1', style({ opacity: 0 })),
 *        query('.content', style({ opacity: 0 })),
 *
 *        // animate the inner elements in, one by one
 *        query('h1', animate(1000, style({ opacity: 1 })),
 *        query('.content', animate(1000, style({ opacity: 1 })),
 *      ])
 *    ])
 *  ]
 * })
 * class Cmp {
 *   exp = '';
 *
 *   goAnimate() {
 *     this.exp = 'goAnimate';
 *   }
 * }
 * ```
 */
function query(selector, animation, options) {
    if (options === void 0) {
        options = null;
    }
    return { type: 11 /* Query */, selector: selector, animation: animation, options: options };
}
/**
 * Use within an animation `query()` call to issue a timing gap after
 * each queried item is animated.
 *
 * @param timings A delay value.
 * @param animation One ore more animation steps.
 * @returns An object that encapsulates the stagger data.
 *
 * @usageNotes
 * In the following example, a container element wraps a list of items stamped out
 * by an `ngFor`. The container element contains an animation trigger that will later be set
 * to query for each of the inner items.
 *
 * Each time items are added, the opacity fade-in animation runs,
 * and each removed item is faded out.
 * When either of these animations occur, the stagger effect is
 * applied after each item's animation is started.
 *
 * ```html
 * <!-- list.component.html -->
 * <button (click)="toggle()">Show / Hide Items</button>
 * <hr />
 * <div [@listAnimation]="items.length">
 *   <div *ngFor="let item of items">
 *     {{ item }}
 *   </div>
 * </div>
 * ```
 *
 * Here is the component code:
 *
 * ```typescript
 * import {trigger, transition, style, animate, query, stagger} from '@angular/animations';
 * @Component({
 *   templateUrl: 'list.component.html',
 *   animations: [
 *     trigger('listAnimation', [
 *     ...
 *     ])
 *   ]
 * })
 * class ListComponent {
 *   items = [];
 *
 *   showItems() {
 *     this.items = [0,1,2,3,4];
 *   }
 *
 *   hideItems() {
 *     this.items = [];
 *   }
 *
 *   toggle() {
 *     this.items.length ? this.hideItems() : this.showItems();
 *    }
 *  }
 * ```
 *
 * Here is the animation trigger code:
 *
 * ```typescript
 * trigger('listAnimation', [
 *   transition('* => *', [ // each time the binding value changes
 *     query(':leave', [
 *       stagger(100, [
 *         animate('0.5s', style({ opacity: 0 }))
 *       ])
 *     ]),
 *     query(':enter', [
 *       style({ opacity: 0 }),
 *       stagger(100, [
 *         animate('0.5s', style({ opacity: 1 }))
 *       ])
 *     ])
 *   ])
 * ])
 * ```
 */
function stagger(timings, animation) {
    return { type: 12 /* Stagger */, timings: timings, animation: animation };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function scheduleMicroTask(cb) {
    Promise.resolve(null).then(cb);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An empty programmatic controller for reusable animations.
 * Used internally when animations are disabled, to avoid
 * checking for the null case when an animation player is expected.
 *
 * @see `animate()`
 * @see `AnimationPlayer`
 * @see `GroupPlayer`
 *
 */
var NoopAnimationPlayer = /*@__PURE__*/ (function () {
    function NoopAnimationPlayer(duration, delay) {
        if (duration === void 0) {
            duration = 0;
        }
        if (delay === void 0) {
            delay = 0;
        }
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._started = false;
        this._destroyed = false;
        this._finished = false;
        this.parentPlayer = null;
        this.totalTime = duration + delay;
    }
    NoopAnimationPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    NoopAnimationPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    NoopAnimationPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    NoopAnimationPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    NoopAnimationPlayer.prototype.hasStarted = function () { return this._started; };
    NoopAnimationPlayer.prototype.init = function () { };
    NoopAnimationPlayer.prototype.play = function () {
        if (!this.hasStarted()) {
            this._onStart();
            this.triggerMicrotask();
        }
        this._started = true;
    };
    /** @internal */
    NoopAnimationPlayer.prototype.triggerMicrotask = function () {
        var _this = this;
        scheduleMicroTask(function () { return _this._onFinish(); });
    };
    NoopAnimationPlayer.prototype._onStart = function () {
        this._onStartFns.forEach(function (fn) { return fn(); });
        this._onStartFns = [];
    };
    NoopAnimationPlayer.prototype.pause = function () { };
    NoopAnimationPlayer.prototype.restart = function () { };
    NoopAnimationPlayer.prototype.finish = function () { this._onFinish(); };
    NoopAnimationPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            if (!this.hasStarted()) {
                this._onStart();
            }
            this.finish();
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    NoopAnimationPlayer.prototype.reset = function () { };
    NoopAnimationPlayer.prototype.setPosition = function (position) { };
    NoopAnimationPlayer.prototype.getPosition = function () { return 0; };
    /** @internal */
    NoopAnimationPlayer.prototype.triggerCallback = function (phaseName) {
        var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
        methods.forEach(function (fn) { return fn(); });
        methods.length = 0;
    };
    return NoopAnimationPlayer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A programmatic controller for a group of reusable animations.
 * Used internally to control animations.
 *
 * @see `AnimationPlayer`
 * @see `{@link animations/group group()}`
 *
 */
var AnimationGroupPlayer = /*@__PURE__*/ (function () {
    function AnimationGroupPlayer(_players) {
        var _this = this;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._finished = false;
        this._started = false;
        this._destroyed = false;
        this._onDestroyFns = [];
        this.parentPlayer = null;
        this.totalTime = 0;
        this.players = _players;
        var doneCount = 0;
        var destroyCount = 0;
        var startCount = 0;
        var total = this.players.length;
        if (total == 0) {
            scheduleMicroTask(function () { return _this._onFinish(); });
        }
        else {
            this.players.forEach(function (player) {
                player.onDone(function () {
                    if (++doneCount == total) {
                        _this._onFinish();
                    }
                });
                player.onDestroy(function () {
                    if (++destroyCount == total) {
                        _this._onDestroy();
                    }
                });
                player.onStart(function () {
                    if (++startCount == total) {
                        _this._onStart();
                    }
                });
            });
        }
        this.totalTime = this.players.reduce(function (time, player) { return Math.max(time, player.totalTime); }, 0);
    }
    AnimationGroupPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    AnimationGroupPlayer.prototype.init = function () { this.players.forEach(function (player) { return player.init(); }); };
    AnimationGroupPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    AnimationGroupPlayer.prototype._onStart = function () {
        if (!this.hasStarted()) {
            this._started = true;
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
        }
    };
    AnimationGroupPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    AnimationGroupPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    AnimationGroupPlayer.prototype.hasStarted = function () { return this._started; };
    AnimationGroupPlayer.prototype.play = function () {
        if (!this.parentPlayer) {
            this.init();
        }
        this._onStart();
        this.players.forEach(function (player) { return player.play(); });
    };
    AnimationGroupPlayer.prototype.pause = function () { this.players.forEach(function (player) { return player.pause(); }); };
    AnimationGroupPlayer.prototype.restart = function () { this.players.forEach(function (player) { return player.restart(); }); };
    AnimationGroupPlayer.prototype.finish = function () {
        this._onFinish();
        this.players.forEach(function (player) { return player.finish(); });
    };
    AnimationGroupPlayer.prototype.destroy = function () { this._onDestroy(); };
    AnimationGroupPlayer.prototype._onDestroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            this._onFinish();
            this.players.forEach(function (player) { return player.destroy(); });
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    AnimationGroupPlayer.prototype.reset = function () {
        this.players.forEach(function (player) { return player.reset(); });
        this._destroyed = false;
        this._finished = false;
        this._started = false;
    };
    AnimationGroupPlayer.prototype.setPosition = function (p) {
        var timeAtPosition = p * this.totalTime;
        this.players.forEach(function (player) {
            var position = player.totalTime ? Math.min(1, timeAtPosition / player.totalTime) : 1;
            player.setPosition(position);
        });
    };
    AnimationGroupPlayer.prototype.getPosition = function () {
        var min = 0;
        this.players.forEach(function (player) {
            var p = player.getPosition();
            min = Math.min(p, min);
        });
        return min;
    };
    AnimationGroupPlayer.prototype.beforeDestroy = function () {
        this.players.forEach(function (player) {
            if (player.beforeDestroy) {
                player.beforeDestroy();
            }
        });
    };
    /** @internal */
    AnimationGroupPlayer.prototype.triggerCallback = function (phaseName) {
        var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
        methods.forEach(function (fn) { return fn(); });
        methods.length = 0;
    };
    return AnimationGroupPlayer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ɵPRE_STYLE = '!';
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */





// CONCATENATED MODULE: ./node_modules/ngx-toastr/fesm5/ngx-toastr.js






/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ToastContainerDirective = /*@__PURE__*/ (function () {
    function ToastContainerDirective(el) {
        this.el = el;
    }
    /**
     * @return {?}
     */
    ToastContainerDirective.prototype.getContainerElement = /**
     * @return {?}
     */
        function () {
            return this.el.nativeElement;
        };
    return ToastContainerDirective;
}());
var ToastContainerModule = /*@__PURE__*/ (function () {
    function ToastContainerModule() {
    }
    return ToastContainerModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Everything a toast needs to launch
 */
var /**
 * Everything a toast needs to launch
 */ ngx_toastr_ToastPackage = /*@__PURE__*/ (function () {
    function ToastPackage(toastId, config, message, title, toastType, toastRef) {
        var _this = this;
        this.toastId = toastId;
        this.config = config;
        this.message = message;
        this.title = title;
        this.toastType = toastType;
        this.toastRef = toastRef;
        this._onTap = new _esm5["e" /* Subject */]();
        this._onAction = new _esm5["e" /* Subject */]();
        this.toastRef.afterClosed().subscribe(function () {
            _this._onAction.complete();
            _this._onTap.complete();
        });
    }
    /** Fired on click */
    /**
     * Fired on click
     * @return {?}
     */
    ToastPackage.prototype.triggerTap = /**
     * Fired on click
     * @return {?}
     */
        function () {
            this._onTap.next();
            if (this.config.tapToDismiss) {
                this._onTap.complete();
            }
        };
    /**
     * @return {?}
     */
    ToastPackage.prototype.onTap = /**
     * @return {?}
     */
        function () {
            return this._onTap.asObservable();
        };
    /** available for use in custom toast */
    /**
     * available for use in custom toast
     * @param {?=} action
     * @return {?}
     */
    ToastPackage.prototype.triggerAction = /**
     * available for use in custom toast
     * @param {?=} action
     * @return {?}
     */
        function (action) {
            this._onAction.next(action);
        };
    /**
     * @return {?}
     */
    ToastPackage.prototype.onAction = /**
     * @return {?}
     */
        function () {
            return this._onAction.asObservable();
        };
    return ToastPackage;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
 * @template T
 */
var /**
 * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
 * @template T
 */ ComponentPortal = /*@__PURE__*/ (function () {
    function ComponentPortal(component, injector) {
        this.component = component;
        this.injector = injector;
    }
    /** Attach this portal to a host. */
    /**
     * Attach this portal to a host.
     * @param {?} host
     * @param {?} newestOnTop
     * @return {?}
     */
    ComponentPortal.prototype.attach = /**
     * Attach this portal to a host.
     * @param {?} host
     * @param {?} newestOnTop
     * @return {?}
     */
        function (host, newestOnTop) {
            this._attachedHost = host;
            return host.attach(this, newestOnTop);
        };
    /** Detach this portal from its host */
    /**
     * Detach this portal from its host
     * @return {?}
     */
    ComponentPortal.prototype.detach = /**
     * Detach this portal from its host
     * @return {?}
     */
        function () {
            var /** @type {?} */ host = this._attachedHost;
            if (host) {
                this._attachedHost = undefined;
                return host.detach();
            }
        };
    Object.defineProperty(ComponentPortal.prototype, "isAttached", {
        /** Whether this portal is attached to a host. */
        get: /**
         * Whether this portal is attached to a host.
         * @return {?}
         */ function () {
            return this._attachedHost != null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the PortalHost reference without performing `attach()`. This is used directly by
     * the PortalHost when it is performing an `attach()` or `detach()`.
     */
    /**
     * Sets the PortalHost reference without performing `attach()`. This is used directly by
     * the PortalHost when it is performing an `attach()` or `detach()`.
     * @param {?=} host
     * @return {?}
     */
    ComponentPortal.prototype.setAttachedHost = /**
     * Sets the PortalHost reference without performing `attach()`. This is used directly by
     * the PortalHost when it is performing an `attach()` or `detach()`.
     * @param {?=} host
     * @return {?}
     */
        function (host) {
            this._attachedHost = host;
        };
    return ComponentPortal;
}());
/**
 * Partial implementation of PortalHost that only deals with attaching a
 * ComponentPortal
 * @abstract
 */
var /**
 * Partial implementation of PortalHost that only deals with attaching a
 * ComponentPortal
 * @abstract
 */ BasePortalHost = /*@__PURE__*/ (function () {
    function BasePortalHost() {
    }
    /**
     * @param {?} portal
     * @param {?} newestOnTop
     * @return {?}
     */
    BasePortalHost.prototype.attach = /**
     * @param {?} portal
     * @param {?} newestOnTop
     * @return {?}
     */
        function (portal, newestOnTop) {
            this._attachedPortal = portal;
            return this.attachComponentPortal(portal, newestOnTop);
        };
    /**
     * @return {?}
     */
    BasePortalHost.prototype.detach = /**
     * @return {?}
     */
        function () {
            if (this._attachedPortal) {
                this._attachedPortal.setAttachedHost();
            }
            this._attachedPortal = undefined;
            if (this._disposeFn) {
                this._disposeFn();
                this._disposeFn = undefined;
            }
        };
    /**
     * @param {?} fn
     * @return {?}
     */
    BasePortalHost.prototype.setDisposeFn = /**
     * @param {?} fn
     * @return {?}
     */
        function (fn) {
            this._disposeFn = fn;
        };
    return BasePortalHost;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * A PortalHost for attaching portals to an arbitrary DOM element outside of the Angular
 * application context.
 *
 * This is the only part of the portal core that directly touches the DOM.
 */
var /**
 * A PortalHost for attaching portals to an arbitrary DOM element outside of the Angular
 * application context.
 *
 * This is the only part of the portal core that directly touches the DOM.
 */ ngx_toastr_DomPortalHost = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(DomPortalHost, _super);
    function DomPortalHost(_hostDomElement, _componentFactoryResolver, _appRef) {
        var _this = _super.call(this) || this;
        _this._hostDomElement = _hostDomElement;
        _this._componentFactoryResolver = _componentFactoryResolver;
        _this._appRef = _appRef;
        return _this;
    }
    /**
     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
     * @param portal Portal to be attached
     */
    /**
     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
     * @template T
     * @param {?} portal Portal to be attached
     * @param {?} newestOnTop
     * @return {?}
     */
    DomPortalHost.prototype.attachComponentPortal = /**
     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
     * @template T
     * @param {?} portal Portal to be attached
     * @param {?} newestOnTop
     * @return {?}
     */
        function (portal, newestOnTop) {
            var _this = this;
            var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
            var /** @type {?} */ componentRef;
            // If the portal specifies a ViewContainerRef, we will use that as the attachment point
            // for the component (in terms of Angular's component tree, not rendering).
            // When the ViewContainerRef is missing, we use the factory to create the component directly
            // and then manually attach the ChangeDetector for that component to the application (which
            // happens automatically when using a ViewContainer).
            componentRef = componentFactory.create(portal.injector);
            // When creating a component outside of a ViewContainer, we need to manually register
            // its ChangeDetector with the application. This API is unfortunately not yet published
            // in Angular core. The change detector must also be deregistered when the component
            // is destroyed to prevent memory leaks.
            this._appRef.attachView(componentRef.hostView);
            this.setDisposeFn(function () {
                _this._appRef.detachView(componentRef.hostView);
                componentRef.destroy();
            });
            // At this point the component has been instantiated, so we move it to the location in the DOM
            // where we want it to be rendered.
            if (newestOnTop) {
                this._hostDomElement.insertBefore(this._getComponentRootNode(componentRef), this._hostDomElement.firstChild);
            }
            else {
                this._hostDomElement.appendChild(this._getComponentRootNode(componentRef));
            }
            return componentRef;
        };
    /**
     * Gets the root HTMLElement for an instantiated component.
     * @param {?} componentRef
     * @return {?}
     */
    DomPortalHost.prototype._getComponentRootNode = /**
     * Gets the root HTMLElement for an instantiated component.
     * @param {?} componentRef
     * @return {?}
     */
        function (componentRef) {
            return /** @type {?} */ (((componentRef.hostView)).rootNodes[0]);
        };
    return DomPortalHost;
}(BasePortalHost));
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Reference to an overlay that has been created with the Overlay service.
 * Used to manipulate or dispose of said overlay.
 */
var /**
 * Reference to an overlay that has been created with the Overlay service.
 * Used to manipulate or dispose of said overlay.
 */ OverlayRef = /*@__PURE__*/ (function () {
    function OverlayRef(_portalHost) {
        this._portalHost = _portalHost;
    }
    /**
     * @param {?} portal
     * @param {?=} newestOnTop
     * @return {?}
     */
    OverlayRef.prototype.attach = /**
     * @param {?} portal
     * @param {?=} newestOnTop
     * @return {?}
     */
        function (portal, newestOnTop) {
            if (newestOnTop === void 0) {
                newestOnTop = true;
            }
            return this._portalHost.attach(portal, newestOnTop);
        };
    /**
     * Detaches an overlay from a portal.
     * @returns Resolves when the overlay has been detached.
     */
    /**
     * Detaches an overlay from a portal.
     * @return {?} Resolves when the overlay has been detached.
     */
    OverlayRef.prototype.detach = /**
     * Detaches an overlay from a portal.
     * @return {?} Resolves when the overlay has been detached.
     */
        function () {
            return this._portalHost.detach();
        };
    return OverlayRef;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * The OverlayContainer is the container in which all overlays will load.
 * It should be provided in the root component to ensure it is properly shared.
 */
var /**
 * The OverlayContainer is the container in which all overlays will load.
 * It should be provided in the root component to ensure it is properly shared.
 */ OverlayContainer = /*@__PURE__*/ (function () {
    function OverlayContainer() {
    }
    /**
     * This method returns the overlay container element.  It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @returns the container element
     */
    /**
     * This method returns the overlay container element.  It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @return {?} the container element
     */
    OverlayContainer.prototype.getContainerElement = /**
     * This method returns the overlay container element.  It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @return {?} the container element
     */
        function () {
            if (!this._containerElement) {
                this._createContainer();
            }
            return this._containerElement;
        };
    /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     * @return {?}
     */
    OverlayContainer.prototype._createContainer = /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     * @return {?}
     */
        function () {
            var /** @type {?} */ container = document.createElement('div');
            container.classList.add('overlay-container');
            document.body.appendChild(container);
            this._containerElement = container;
        };
    return OverlayContainer;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
 * used as a low-level building building block for other components. Dialogs, tooltips, menus,
 * selects, etc. can all be built using overlays. The service should primarily be used by authors
 * of re-usable components rather than developers building end-user applications.
 *
 * An overlay *is* a PortalHost, so any kind of Portal can be loaded into one.
 */
var Overlay = /*@__PURE__*/ (function () {
    function Overlay(_overlayContainer, _componentFactoryResolver, _appRef) {
        this._overlayContainer = _overlayContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._appRef = _appRef;
        this._paneElements = {};
    }
    /**
     * Creates an overlay.
     * @returns A reference to the created overlay.
     */
    /**
     * Creates an overlay.
     * @param {?=} positionClass
     * @param {?=} overlayContainer
     * @return {?} A reference to the created overlay.
     */
    Overlay.prototype.create = /**
     * Creates an overlay.
     * @param {?=} positionClass
     * @param {?=} overlayContainer
     * @return {?} A reference to the created overlay.
     */
        function (positionClass, overlayContainer) {
            // get existing pane if possible
            return this._createOverlayRef(this.getPaneElement(positionClass, overlayContainer));
        };
    /**
     * @param {?=} positionClass
     * @param {?=} overlayContainer
     * @return {?}
     */
    Overlay.prototype.getPaneElement = /**
     * @param {?=} positionClass
     * @param {?=} overlayContainer
     * @return {?}
     */
        function (positionClass, overlayContainer) {
            if (positionClass === void 0) {
                positionClass = '';
            }
            if (!this._paneElements[positionClass]) {
                this._paneElements[positionClass] = this._createPaneElement(positionClass, overlayContainer);
            }
            return this._paneElements[positionClass];
        };
    /**
     * Creates the DOM element for an overlay and appends it to the overlay container.
     * @param {?} positionClass
     * @param {?=} overlayContainer
     * @return {?} Newly-created pane element
     */
    Overlay.prototype._createPaneElement = /**
     * Creates the DOM element for an overlay and appends it to the overlay container.
     * @param {?} positionClass
     * @param {?=} overlayContainer
     * @return {?} Newly-created pane element
     */
        function (positionClass, overlayContainer) {
            var /** @type {?} */ pane = document.createElement('div');
            pane.id = 'toast-container';
            pane.classList.add(positionClass);
            pane.classList.add('toast-container');
            if (!overlayContainer) {
                this._overlayContainer.getContainerElement().appendChild(pane);
            }
            else {
                overlayContainer.getContainerElement().appendChild(pane);
            }
            return pane;
        };
    /**
     * Create a DomPortalHost into which the overlay content can be loaded.
     * @param {?} pane The DOM element to turn into a portal host.
     * @return {?} A portal host for the given DOM element.
     */
    Overlay.prototype._createPortalHost = /**
     * Create a DomPortalHost into which the overlay content can be loaded.
     * @param {?} pane The DOM element to turn into a portal host.
     * @return {?} A portal host for the given DOM element.
     */
        function (pane) {
            return new ngx_toastr_DomPortalHost(pane, this._componentFactoryResolver, this._appRef);
        };
    /**
     * Creates an OverlayRef for an overlay in the given DOM element.
     * @param {?} pane DOM element for the overlay
     * @return {?}
     */
    Overlay.prototype._createOverlayRef = /**
     * Creates an OverlayRef for an overlay in the given DOM element.
     * @param {?} pane DOM element for the overlay
     * @return {?}
     */
        function (pane) {
            return new OverlayRef(this._createPortalHost(pane));
        };
    return Overlay;
}());
/**
 * Providers for Overlay and its related injectables.
 */
var /** @type {?} */ OVERLAY_PROVIDERS = [
    Overlay,
    OverlayContainer,
];
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Reference to a toast opened via the Toastr service.
 * @template T
 */
var /**
 * Reference to a toast opened via the Toastr service.
 * @template T
 */ ngx_toastr_ToastRef = /*@__PURE__*/ (function () {
    function ToastRef(_overlayRef) {
        this._overlayRef = _overlayRef;
        /**
         * Subject for notifying the user that the toast has finished closing.
         */
        this._afterClosed = new _esm5["e" /* Subject */]();
        /**
         * triggered when toast is activated
         */
        this._activate = new _esm5["e" /* Subject */]();
        /**
         * notifies the toast that it should close before the timeout
         */
        this._manualClose = new _esm5["e" /* Subject */]();
    }
    /**
     * @return {?}
     */
    ToastRef.prototype.manualClose = /**
     * @return {?}
     */
        function () {
            this._manualClose.next();
            this._manualClose.complete();
        };
    /**
     * @return {?}
     */
    ToastRef.prototype.manualClosed = /**
     * @return {?}
     */
        function () {
            return this._manualClose.asObservable();
        };
    /**
     * Close the toast.
     */
    /**
     * Close the toast.
     * @return {?}
     */
    ToastRef.prototype.close = /**
     * Close the toast.
     * @return {?}
     */
        function () {
            this._overlayRef.detach();
            this._afterClosed.next();
            this._afterClosed.complete();
            this._manualClose.complete();
            this._activate.complete();
        };
    /** Gets an observable that is notified when the toast is finished closing. */
    /**
     * Gets an observable that is notified when the toast is finished closing.
     * @return {?}
     */
    ToastRef.prototype.afterClosed = /**
     * Gets an observable that is notified when the toast is finished closing.
     * @return {?}
     */
        function () {
            return this._afterClosed.asObservable();
        };
    /**
     * @return {?}
     */
    ToastRef.prototype.isInactive = /**
     * @return {?}
     */
        function () {
            return this._activate.isStopped;
        };
    /**
     * @return {?}
     */
    ToastRef.prototype.activate = /**
     * @return {?}
     */
        function () {
            this._activate.next();
            this._activate.complete();
        };
    /** Gets an observable that is notified when the toast has started opening. */
    /**
     * Gets an observable that is notified when the toast has started opening.
     * @return {?}
     */
    ToastRef.prototype.afterActivate = /**
     * Gets an observable that is notified when the toast has started opening.
     * @return {?}
     */
        function () {
            return this._activate.asObservable();
        };
    return ToastRef;
}());
/**
 * Custom injector type specifically for instantiating components with a toast.
 */
var /**
 * Custom injector type specifically for instantiating components with a toast.
 */ ToastInjector = /*@__PURE__*/ (function () {
    function ToastInjector(_toastPackage, _parentInjector) {
        this._toastPackage = _toastPackage;
        this._parentInjector = _parentInjector;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    ToastInjector.prototype.get = /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
        function (token, notFoundValue) {
            if (token === ngx_toastr_ToastPackage && this._toastPackage) {
                return this._toastPackage;
            }
            return this._parentInjector.get(token, notFoundValue);
        };
    return ToastInjector;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ TOAST_CONFIG = new core["InjectionToken"]('ToastConfig');
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ngx_toastr_ToastrService = /*@__PURE__*/ (function () {
    function ToastrService(token, overlay, _injector, sanitizer, ngZone) {
        this.overlay = overlay;
        this._injector = _injector;
        this.sanitizer = sanitizer;
        this.ngZone = ngZone;
        this.currentlyActive = 0;
        this.toasts = [];
        this.index = 0;
        var /** @type {?} */ defaultConfig = new token.defaults;
        this.toastrConfig = Object(tslib_es6["__assign"])({}, defaultConfig, token.config);
        this.toastrConfig.iconClasses = Object(tslib_es6["__assign"])({}, defaultConfig.iconClasses, token.config.iconClasses);
    }
    /** show toast */
    /**
     * show toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @param {?=} type
     * @return {?}
     */
    ToastrService.prototype.show = /**
     * show toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @param {?=} type
     * @return {?}
     */
        function (message, title, override, type) {
            if (override === void 0) {
                override = {};
            }
            if (type === void 0) {
                type = '';
            }
            return this._preBuildNotification(type, message, title, this.applyConfig(override));
        };
    /** show successful toast */
    /**
     * show successful toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @return {?}
     */
    ToastrService.prototype.success = /**
     * show successful toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @return {?}
     */
        function (message, title, override) {
            if (override === void 0) {
                override = {};
            }
            var /** @type {?} */ type = this.toastrConfig.iconClasses.success || '';
            return this._preBuildNotification(type, message, title, this.applyConfig(override));
        };
    /** show error toast */
    /**
     * show error toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @return {?}
     */
    ToastrService.prototype.error = /**
     * show error toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @return {?}
     */
        function (message, title, override) {
            if (override === void 0) {
                override = {};
            }
            var /** @type {?} */ type = this.toastrConfig.iconClasses.error || '';
            return this._preBuildNotification(type, message, title, this.applyConfig(override));
        };
    /** show info toast */
    /**
     * show info toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @return {?}
     */
    ToastrService.prototype.info = /**
     * show info toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @return {?}
     */
        function (message, title, override) {
            if (override === void 0) {
                override = {};
            }
            var /** @type {?} */ type = this.toastrConfig.iconClasses.info || '';
            return this._preBuildNotification(type, message, title, this.applyConfig(override));
        };
    /** show warning toast */
    /**
     * show warning toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @return {?}
     */
    ToastrService.prototype.warning = /**
     * show warning toast
     * @param {?=} message
     * @param {?=} title
     * @param {?=} override
     * @return {?}
     */
        function (message, title, override) {
            if (override === void 0) {
                override = {};
            }
            var /** @type {?} */ type = this.toastrConfig.iconClasses.warning || '';
            return this._preBuildNotification(type, message, title, this.applyConfig(override));
        };
    /**
     * Remove all or a single toast by id
     */
    /**
     * Remove all or a single toast by id
     * @param {?=} toastId
     * @return {?}
     */
    ToastrService.prototype.clear = /**
     * Remove all or a single toast by id
     * @param {?=} toastId
     * @return {?}
     */
        function (toastId) {
            try {
                // Call every toastRef manualClose function
                for (var _a = Object(tslib_es6["__values"])(this.toasts), _b = _a.next(); !_b.done; _b = _a.next()) {
                    var toast = _b.value;
                    if (toastId !== undefined) {
                        if (toast.toastId === toastId) {
                            toast.toastRef.manualClose();
                            return;
                        }
                    }
                    else {
                        toast.toastRef.manualClose();
                    }
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_b && !_b.done && (_c = _a.return))
                        _c.call(_a);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            var e_1, _c;
        };
    /**
     * Remove and destroy a single toast by id
     */
    /**
     * Remove and destroy a single toast by id
     * @param {?} toastId
     * @return {?}
     */
    ToastrService.prototype.remove = /**
     * Remove and destroy a single toast by id
     * @param {?} toastId
     * @return {?}
     */
        function (toastId) {
            var /** @type {?} */ found = this._findToast(toastId);
            if (!found) {
                return false;
            }
            found.activeToast.toastRef.close();
            this.toasts.splice(found.index, 1);
            this.currentlyActive = this.currentlyActive - 1;
            if (!this.toastrConfig.maxOpened || !this.toasts.length) {
                return false;
            }
            if (this.currentlyActive < this.toastrConfig.maxOpened && this.toasts[this.currentlyActive]) {
                var /** @type {?} */ p = this.toasts[this.currentlyActive].toastRef;
                if (!p.isInactive()) {
                    this.currentlyActive = this.currentlyActive + 1;
                    p.activate();
                }
            }
            return true;
        };
    /**
     * Determines if toast message is already shown
     */
    /**
     * Determines if toast message is already shown
     * @param {?} message
     * @return {?}
     */
    ToastrService.prototype.isDuplicate = /**
     * Determines if toast message is already shown
     * @param {?} message
     * @return {?}
     */
        function (message) {
            for (var /** @type {?} */ i = 0; i < this.toasts.length; i++) {
                if (this.toasts[i].message === message) {
                    return true;
                }
            }
            return false;
        };
    /**
     * create a clone of global config and apply individual settings
     * @param {?=} override
     * @return {?}
     */
    ToastrService.prototype.applyConfig = /**
     * create a clone of global config and apply individual settings
     * @param {?=} override
     * @return {?}
     */
        function (override) {
            if (override === void 0) {
                override = {};
            }
            return Object(tslib_es6["__assign"])({}, this.toastrConfig, override);
        };
    /**
     * Find toast object by id
     * @param {?} toastId
     * @return {?}
     */
    ToastrService.prototype._findToast = /**
     * Find toast object by id
     * @param {?} toastId
     * @return {?}
     */
        function (toastId) {
            for (var /** @type {?} */ i = 0; i < this.toasts.length; i++) {
                if (this.toasts[i].toastId === toastId) {
                    return { index: i, activeToast: this.toasts[i] };
                }
            }
            return null;
        };
    /**
     * Determines the need to run inside angular's zone then builds the toast
     * @param {?} toastType
     * @param {?} message
     * @param {?} title
     * @param {?} config
     * @return {?}
     */
    ToastrService.prototype._preBuildNotification = /**
     * Determines the need to run inside angular's zone then builds the toast
     * @param {?} toastType
     * @param {?} message
     * @param {?} title
     * @param {?} config
     * @return {?}
     */
        function (toastType, message, title, config) {
            var _this = this;
            if (config.onActivateTick) {
                return this.ngZone.run(function () { return _this._buildNotification(toastType, message, title, config); });
            }
            return this._buildNotification(toastType, message, title, config);
        };
    /**
     * Creates and attaches toast data to component
     * returns null if toast is duplicate and preventDuplicates == True
     * @param {?} toastType
     * @param {?} message
     * @param {?} title
     * @param {?} config
     * @return {?}
     */
    ToastrService.prototype._buildNotification = /**
     * Creates and attaches toast data to component
     * returns null if toast is duplicate and preventDuplicates == True
     * @param {?} toastType
     * @param {?} message
     * @param {?} title
     * @param {?} config
     * @return {?}
     */
        function (toastType, message, title, config) {
            var _this = this;
            if (!config.toastComponent) {
                throw new Error('toastComponent required');
            }
            // max opened and auto dismiss = true
            if (message && this.toastrConfig.preventDuplicates && this.isDuplicate(message)) {
                return null;
            }
            this.previousToastMessage = message;
            var /** @type {?} */ keepInactive = false;
            if (this.toastrConfig.maxOpened && this.currentlyActive >= this.toastrConfig.maxOpened) {
                keepInactive = true;
                if (this.toastrConfig.autoDismiss) {
                    this.clear(this.toasts[0].toastId);
                }
            }
            var /** @type {?} */ overlayRef = this.overlay.create(config.positionClass, this.overlayContainer);
            this.index = this.index + 1;
            var /** @type {?} */ sanitizedMessage = message;
            if (message && config.enableHtml) {
                sanitizedMessage = this.sanitizer.sanitize(core["SecurityContext"].HTML, message);
            }
            var /** @type {?} */ toastRef = new ngx_toastr_ToastRef(overlayRef);
            var /** @type {?} */ toastPackage = new ngx_toastr_ToastPackage(this.index, config, sanitizedMessage, title, toastType, toastRef);
            var /** @type {?} */ toastInjector = new ToastInjector(toastPackage, this._injector);
            var /** @type {?} */ component = new ComponentPortal(config.toastComponent, toastInjector);
            var /** @type {?} */ portal = overlayRef.attach(component, this.toastrConfig.newestOnTop);
            toastRef.componentInstance = ((portal))._component;
            var /** @type {?} */ ins = {
                toastId: this.index,
                message: message || '',
                toastRef: toastRef,
                onShown: toastRef.afterActivate(),
                onHidden: toastRef.afterClosed(),
                onTap: toastPackage.onTap(),
                onAction: toastPackage.onAction(),
                portal: portal,
            };
            if (!keepInactive) {
                setTimeout(function () {
                    ins.toastRef.activate();
                    _this.currentlyActive = _this.currentlyActive + 1;
                });
            }
            this.toasts.push(ins);
            return ins;
        };
    return ToastrService;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ngx_toastr_Toast = /*@__PURE__*/ (function () {
    function Toast(toastrService, toastPackage, ngZone) {
        var _this = this;
        this.toastrService = toastrService;
        this.toastPackage = toastPackage;
        this.ngZone = ngZone;
        /**
         * width of progress bar
         */
        this.width = -1;
        /**
         * a combination of toast type and options.toastClass
         */
        this.toastClasses = '';
        /**
         * controls animation
         */
        this.state = {
            value: 'inactive',
            params: {
                easeTime: this.toastPackage.config.easeTime,
                easing: 'ease-in',
            },
        };
        this.message = toastPackage.message;
        this.title = toastPackage.title;
        this.options = toastPackage.config;
        this.toastClasses = toastPackage.toastType + " " + toastPackage.config.toastClass;
        this.sub = toastPackage.toastRef.afterActivate().subscribe(function () {
            _this.activateToast();
        });
        this.sub1 = toastPackage.toastRef.manualClosed().subscribe(function () {
            _this.remove();
        });
    }
    /**
     * @return {?}
     */
    Toast.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this.sub.unsubscribe();
            this.sub1.unsubscribe();
            clearInterval(this.intervalId);
            clearTimeout(this.timeout);
        };
    /**
     * activates toast and sets timeout
     */
    /**
     * activates toast and sets timeout
     * @return {?}
     */
    Toast.prototype.activateToast = /**
     * activates toast and sets timeout
     * @return {?}
     */
        function () {
            var _this = this;
            this.state = Object(tslib_es6["__assign"])({}, this.state, { value: 'active' });
            if (!this.options.disableTimeOut && this.options.timeOut) {
                this.outsideTimeout(function () { return _this.remove(); }, this.options.timeOut);
                this.hideTime = new Date().getTime() + this.options.timeOut;
                if (this.options.progressBar) {
                    this.outsideInterval(function () { return _this.updateProgress(); }, 10);
                }
            }
        };
    /**
     * updates progress bar width
     */
    /**
     * updates progress bar width
     * @return {?}
     */
    Toast.prototype.updateProgress = /**
     * updates progress bar width
     * @return {?}
     */
        function () {
            if (this.width === 0 || this.width === 100 || !this.options.timeOut) {
                return;
            }
            var /** @type {?} */ now = new Date().getTime();
            var /** @type {?} */ remaining = this.hideTime - now;
            this.width = (remaining / this.options.timeOut) * 100;
            if (this.options.progressAnimation === 'increasing') {
                this.width = 100 - this.width;
            }
            if (this.width <= 0) {
                this.width = 0;
            }
            if (this.width >= 100) {
                this.width = 100;
            }
        };
    /**
     * tells toastrService to remove this toast after animation time
     */
    /**
     * tells toastrService to remove this toast after animation time
     * @return {?}
     */
    Toast.prototype.remove = /**
     * tells toastrService to remove this toast after animation time
     * @return {?}
     */
        function () {
            var _this = this;
            if (this.state.value === 'removed') {
                return;
            }
            clearTimeout(this.timeout);
            this.state = Object(tslib_es6["__assign"])({}, this.state, { value: 'removed' });
            this.outsideTimeout(function () {
                return _this.toastrService.remove(_this.toastPackage.toastId);
            }, +this.toastPackage.config.easeTime);
        };
    /**
     * @return {?}
     */
    Toast.prototype.tapToast = /**
     * @return {?}
     */
        function () {
            if (this.state.value === 'removed') {
                return;
            }
            this.toastPackage.triggerTap();
            if (this.options.tapToDismiss) {
                this.remove();
            }
        };
    /**
     * @return {?}
     */
    Toast.prototype.stickAround = /**
     * @return {?}
     */
        function () {
            if (this.state.value === 'removed') {
                return;
            }
            clearTimeout(this.timeout);
            this.options.timeOut = 0;
            this.hideTime = 0;
            // disable progressBar
            clearInterval(this.intervalId);
            this.width = 0;
        };
    /**
     * @return {?}
     */
    Toast.prototype.delayedHideToast = /**
     * @return {?}
     */
        function () {
            var _this = this;
            if (this.options.disableTimeOut
                || this.options.extendedTimeOut === 0
                || this.state.value === 'removed') {
                return;
            }
            this.outsideTimeout(function () { return _this.remove(); }, this.options.extendedTimeOut);
            this.options.timeOut = this.options.extendedTimeOut;
            this.hideTime = new Date().getTime() + (this.options.timeOut || 0);
            this.width = -1;
            if (this.options.progressBar) {
                this.outsideInterval(function () { return _this.updateProgress(); }, 10);
            }
        };
    /**
     * @param {?} func
     * @param {?} timeout
     * @return {?}
     */
    Toast.prototype.outsideTimeout = /**
     * @param {?} func
     * @param {?} timeout
     * @return {?}
     */
        function (func, timeout) {
            var _this = this;
            if (this.ngZone) {
                this.ngZone.runOutsideAngular(function () {
                    return _this.timeout = setTimeout(function () { return _this.runInsideAngular(func); }, timeout);
                });
            }
            else {
                this.timeout = setTimeout(function () { return func(); }, timeout);
            }
        };
    /**
     * @param {?} func
     * @param {?} timeout
     * @return {?}
     */
    Toast.prototype.outsideInterval = /**
     * @param {?} func
     * @param {?} timeout
     * @return {?}
     */
        function (func, timeout) {
            var _this = this;
            if (this.ngZone) {
                this.ngZone.runOutsideAngular(function () {
                    return _this.intervalId = setInterval(function () { return _this.runInsideAngular(func); }, timeout);
                });
            }
            else {
                this.intervalId = setInterval(function () { return func(); }, timeout);
            }
        };
    /**
     * @param {?} func
     * @return {?}
     */
    Toast.prototype.runInsideAngular = /**
     * @param {?} func
     * @return {?}
     */
        function (func) {
            if (this.ngZone) {
                this.ngZone.run(function () { return func(); });
            }
            else {
                func();
            }
        };
    return Toast;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var DefaultGlobalConfig = /*@__PURE__*/ (function () {
    function DefaultGlobalConfig() {
        // Global
        this.maxOpened = 0;
        this.autoDismiss = false;
        this.newestOnTop = true;
        this.preventDuplicates = false;
        this.iconClasses = {
            error: 'toast-error',
            info: 'toast-info',
            success: 'toast-success',
            warning: 'toast-warning',
        };
        // Individual
        this.toastComponent = ngx_toastr_Toast;
        this.closeButton = false;
        this.timeOut = 5000;
        this.extendedTimeOut = 1000;
        this.enableHtml = false;
        this.progressBar = false;
        this.toastClass = 'toast';
        this.positionClass = 'toast-top-right';
        this.titleClass = 'toast-title';
        this.messageClass = 'toast-message';
        this.easing = 'ease-in';
        this.easeTime = 300;
        this.tapToDismiss = true;
        this.onActivateTick = false;
        this.progressAnimation = 'decreasing';
    }
    return DefaultGlobalConfig;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ToastrModule = /*@__PURE__*/ (function () {
    function ToastrModule(parentModule) {
        if (parentModule) {
            throw new Error('ToastrModule is already loaded. It should only be imported in your application\'s main module.');
        }
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    ToastrModule.forRoot = /**
     * @param {?=} config
     * @return {?}
     */
        function (config) {
            if (config === void 0) {
                config = {};
            }
            return {
                ngModule: ToastrModule,
                providers: [
                    { provide: TOAST_CONFIG, useValue: { config: config, defaults: DefaultGlobalConfig } },
                    OverlayContainer,
                    Overlay,
                    ngx_toastr_ToastrService,
                ],
            };
        };
    return ToastrModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ToastNoAnimation = /*@__PURE__*/ (function () {
    function ToastNoAnimation(toastrService, toastPackage, appRef) {
        var _this = this;
        this.toastrService = toastrService;
        this.toastPackage = toastPackage;
        this.appRef = appRef;
        /**
         * width of progress bar
         */
        this.width = -1;
        /**
         * a combination of toast type and options.toastClass
         */
        this.toastClasses = '';
        /**
         * controls animation
         */
        this.state = 'inactive';
        this.message = toastPackage.message;
        this.title = toastPackage.title;
        this.options = toastPackage.config;
        this.toastClasses = toastPackage.toastType + " " + toastPackage.config.toastClass;
        this.sub = toastPackage.toastRef.afterActivate().subscribe(function () {
            _this.activateToast();
        });
        this.sub1 = toastPackage.toastRef.manualClosed().subscribe(function () {
            _this.remove();
        });
    }
    Object.defineProperty(ToastNoAnimation.prototype, "displayStyle", {
        get: /**
         * @return {?}
         */ function () {
            if (this.state === 'inactive') {
                return 'none';
            }
            return 'inherit';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ToastNoAnimation.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this.sub.unsubscribe();
            this.sub1.unsubscribe();
            clearInterval(this.intervalId);
            clearTimeout(this.timeout);
        };
    /**
     * activates toast and sets timeout
     */
    /**
     * activates toast and sets timeout
     * @return {?}
     */
    ToastNoAnimation.prototype.activateToast = /**
     * activates toast and sets timeout
     * @return {?}
     */
        function () {
            var _this = this;
            this.state = 'active';
            if (!this.options.disableTimeOut && this.options.timeOut) {
                this.timeout = setTimeout(function () {
                    _this.remove();
                }, this.options.timeOut);
                this.hideTime = new Date().getTime() + this.options.timeOut;
                if (this.options.progressBar) {
                    this.intervalId = setInterval(function () { return _this.updateProgress(); }, 10);
                }
            }
            if (this.options.onActivateTick) {
                this.appRef.tick();
            }
        };
    /**
     * updates progress bar width
     */
    /**
     * updates progress bar width
     * @return {?}
     */
    ToastNoAnimation.prototype.updateProgress = /**
     * updates progress bar width
     * @return {?}
     */
        function () {
            if (this.width === 0 || this.width === 100 || !this.options.timeOut) {
                return;
            }
            var /** @type {?} */ now = new Date().getTime();
            var /** @type {?} */ remaining = this.hideTime - now;
            this.width = remaining / this.options.timeOut * 100;
            if (this.options.progressAnimation === 'increasing') {
                this.width = 100 - this.width;
            }
            if (this.width <= 0) {
                this.width = 0;
            }
            if (this.width >= 100) {
                this.width = 100;
            }
        };
    /**
     * tells toastrService to remove this toast after animation time
     */
    /**
     * tells toastrService to remove this toast after animation time
     * @return {?}
     */
    ToastNoAnimation.prototype.remove = /**
     * tells toastrService to remove this toast after animation time
     * @return {?}
     */
        function () {
            var _this = this;
            if (this.state === 'removed') {
                return;
            }
            clearTimeout(this.timeout);
            this.state = 'removed';
            this.timeout = setTimeout(function () { return _this.toastrService.remove(_this.toastPackage.toastId); });
        };
    /**
     * @return {?}
     */
    ToastNoAnimation.prototype.tapToast = /**
     * @return {?}
     */
        function () {
            if (this.state === 'removed') {
                return;
            }
            this.toastPackage.triggerTap();
            if (this.options.tapToDismiss) {
                this.remove();
            }
        };
    /**
     * @return {?}
     */
    ToastNoAnimation.prototype.stickAround = /**
     * @return {?}
     */
        function () {
            if (this.state === 'removed') {
                return;
            }
            clearTimeout(this.timeout);
            this.options.timeOut = 0;
            this.hideTime = 0;
            // disable progressBar
            clearInterval(this.intervalId);
            this.width = 0;
        };
    /**
     * @return {?}
     */
    ToastNoAnimation.prototype.delayedHideToast = /**
     * @return {?}
     */
        function () {
            var _this = this;
            if (this.options.disableTimeOut
                || this.options.extendedTimeOut === 0
                || this.state === 'removed') {
                return;
            }
            this.timeout = setTimeout(function () { return _this.remove(); }, this.options.extendedTimeOut);
            this.options.timeOut = this.options.extendedTimeOut;
            this.hideTime = new Date().getTime() + (this.options.timeOut || 0);
            this.width = -1;
            if (this.options.progressBar) {
                this.intervalId = setInterval(function () { return _this.updateProgress(); }, 10);
            }
        };
    return ToastNoAnimation;
}());
var ToastNoAnimationModule = /*@__PURE__*/ (function () {
    function ToastNoAnimationModule() {
    }
    return ToastNoAnimationModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */





// CONCATENATED MODULE: ./node_modules/ngx-toastr/ngx-toastr.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,ngx_toastr,_angular_common PURE_IMPORTS_END */



var ToastContainerModuleNgFactory = /*@__PURE__*/ core["ɵcmf"](ToastContainerModule, [], function (_l) { return core["ɵmod"]([core["ɵmpd"](512, core["ComponentFactoryResolver"], core["ɵCodegenComponentFactoryResolver"], [[8, []], [3, core["ComponentFactoryResolver"]], core["NgModuleRef"]]), core["ɵmpd"](1073742336, ToastContainerModule, ToastContainerModule, [])]); });

var ToastrModuleNgFactory = /*@__PURE__*/ core["ɵcmf"](ToastrModule, [], function (_l) { return core["ɵmod"]([core["ɵmpd"](512, core["ComponentFactoryResolver"], core["ɵCodegenComponentFactoryResolver"], [[8, [ToastNgFactory]], [3, core["ComponentFactoryResolver"]], core["NgModuleRef"]]), core["ɵmpd"](4608, common["NgLocalization"], common["NgLocaleLocalization"], [core["LOCALE_ID"], [2, common["ɵangular_packages_common_common_a"]]]), core["ɵmpd"](1073742336, common["CommonModule"], common["CommonModule"], []), core["ɵmpd"](1073742336, ToastrModule, ToastrModule, [[3, ToastrModule]])]); });

var ToastNoAnimationModuleNgFactory = /*@__PURE__*/ core["ɵcmf"](ToastNoAnimationModule, [], function (_l) { return core["ɵmod"]([core["ɵmpd"](512, core["ComponentFactoryResolver"], core["ɵCodegenComponentFactoryResolver"], [[8, [ToastNoAnimationNgFactory]], [3, core["ComponentFactoryResolver"]], core["NgModuleRef"]]), core["ɵmpd"](4608, common["NgLocalization"], common["NgLocaleLocalization"], [core["LOCALE_ID"], [2, common["ɵangular_packages_common_common_a"]]]), core["ɵmpd"](1073742336, common["CommonModule"], common["CommonModule"], []), core["ɵmpd"](1073742336, ToastNoAnimationModule, ToastNoAnimationModule, [])]); });

var styles_Toast = [];
var RenderType_Toast = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_Toast, data: { "animation": [{ type: 7, name: "flyInOut", definitions: [{ type: 0, name: "inactive", styles: { type: 6, styles: { display: "none", opacity: 0 }, offset: null }, options: undefined }, { type: 0, name: "active", styles: { type: 6, styles: {}, offset: null }, options: undefined }, { type: 0, name: "removed", styles: { type: 6, styles: { opacity: 0 }, offset: null }, options: undefined }, { type: 1, expr: "inactive => active", animation: { type: 4, styles: null, timings: "{{ easeTime }}ms {{ easing }}" }, options: null }, { type: 1, expr: "active => removed", animation: { type: 4, styles: null, timings: "{{ easeTime }}ms {{ easing }}" }, options: null }], options: {} }] } });

function View_Toast_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "toast-close-button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.remove() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"]))], null, null);
}
function View_Toast_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [], [[8, "className", 0], [1, "aria-label", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.options.titleClass; var currVal_1 = _co.title; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _co.title; _ck(_v, 1, 0, currVal_2); }); }
function View_Toast_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["aria-live", "polite"], ["role", "alertdialog"]], [[8, "className", 0], [8, "innerHTML", 1]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.options.messageClass; var currVal_1 = _co.message; _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_Toast_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["aria-live", "polite"], ["role", "alertdialog"]], [[8, "className", 0], [1, "aria-label", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.options.messageClass; var currVal_1 = _co.message; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _co.message; _ck(_v, 1, 0, currVal_2); }); }
function View_Toast_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "div", [["class", "toast-progress"]], [[4, "width", null]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.width + "%"); _ck(_v, 1, 0, currVal_0); }); }
function View_Toast_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_Toast_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Toast_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Toast_3)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Toast_4)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Toast_5)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.options.closeButton; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.title; _ck(_v, 3, 0, currVal_1); var currVal_2 = (_co.message && _co.options.enableHtml); _ck(_v, 5, 0, currVal_2); var currVal_3 = (_co.message && !_co.options.enableHtml); _ck(_v, 7, 0, currVal_3); var currVal_4 = _co.options.progressBar; _ck(_v, 9, 0, currVal_4); }, null); }
function View_Toast_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["toast-component", ""]], [[8, "className", 0], [40, "@flyInOut", 0]], [[null, "click"], [null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).tapToast() !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseenter" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).stickAround() !== false);
                ad = (pd_1 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1).delayedHideToast() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_Toast_0, RenderType_Toast)), core["ɵdid"](1, 180224, null, 0, ngx_toastr_Toast, [ngx_toastr_ToastrService, ngx_toastr_ToastPackage, core["NgZone"]], null, null)], null, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 1).toastClasses; var currVal_1 = core["ɵnov"](_v, 1).state; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
var ToastNgFactory = /*@__PURE__*/ core["ɵccf"]("[toast-component]", ngx_toastr_Toast, View_Toast_Host_0, {}, {}, []);

var styles_ToastNoAnimation = [];
var RenderType_ToastNoAnimation = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ToastNoAnimation, data: {} });

function View_ToastNoAnimation_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "toast-close-button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.remove() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"]))], null, null);
}
function View_ToastNoAnimation_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [], [[8, "className", 0], [1, "aria-label", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.options.titleClass; var currVal_1 = _co.title; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _co.title; _ck(_v, 1, 0, currVal_2); }); }
function View_ToastNoAnimation_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["aria-live", "polite"], ["role", "alert"]], [[8, "className", 0], [8, "innerHTML", 1]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.options.messageClass; var currVal_1 = _co.message; _ck(_v, 0, 0, currVal_0, currVal_1); }); }
function View_ToastNoAnimation_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["aria-live", "polite"], ["role", "alert"]], [[8, "className", 0], [1, "aria-label", 0]], null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.options.messageClass; var currVal_1 = _co.message; _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _co.message; _ck(_v, 1, 0, currVal_2); }); }
function View_ToastNoAnimation_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "div", [["class", "toast-progress"]], [[4, "width", null]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.width + "%"); _ck(_v, 1, 0, currVal_0); }); }
function View_ToastNoAnimation_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_ToastNoAnimation_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ToastNoAnimation_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ToastNoAnimation_3)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ToastNoAnimation_4)), core["ɵdid"](7, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ToastNoAnimation_5)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.options.closeButton; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.title; _ck(_v, 3, 0, currVal_1); var currVal_2 = (_co.message && _co.options.enableHtml); _ck(_v, 5, 0, currVal_2); var currVal_3 = (_co.message && !_co.options.enableHtml); _ck(_v, 7, 0, currVal_3); var currVal_4 = _co.options.progressBar; _ck(_v, 9, 0, currVal_4); }, null); }
function View_ToastNoAnimation_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "div", [["toast-component", ""]], [[8, "className", 0], [4, "display", null]], [[null, "click"], [null, "mouseenter"], [null, "mouseleave"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).tapToast() !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseenter" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).stickAround() !== false);
                ad = (pd_1 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_2 = (core["ɵnov"](_v, 1).delayedHideToast() !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, View_ToastNoAnimation_0, RenderType_ToastNoAnimation)), core["ɵdid"](1, 180224, null, 0, ToastNoAnimation, [ngx_toastr_ToastrService, ngx_toastr_ToastPackage, core["ApplicationRef"]], null, null)], null, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 1).toastClasses; var currVal_1 = core["ɵnov"](_v, 1).displayStyle; _ck(_v, 0, 0, currVal_0, currVal_1); });
}
var ToastNoAnimationNgFactory = /*@__PURE__*/ core["ɵccf"]("[toast-component]", ToastNoAnimation, View_ToastNoAnimation_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/confirmation/confirmation.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_angular_forms,_confirmation,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_toasterComponent_toasterComponent PURE_IMPORTS_END */


















var styles_ConfirmationComponent = [];
var RenderType_ConfirmationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ConfirmationComponent, data: {} });

function View_ConfirmationComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("confirmation")); _ck(_v, 1, 0, currVal_0); }); }
function View_ConfirmationComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("convertToConfirmedCase")); _ck(_v, 1, 0, currVal_0); }); }
function View_ConfirmationComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 15, "div", [], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 14, "div", [["class", "w-100 float-left relative"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 16777216, null, null, 11, "input", [["class", "form-control"], ["name", "ccDate"], ["ngbDatepicker", ""], ["placeholder", "YYYY-MM-DD"], ["readonly", ""], ["required", ""]], [[8, "disabled", 0], [1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "change"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 6).manualDateChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("change" === en)) {
                var pd_1 = (core["ɵnov"](_v, 6).manualDateChange($event.target.value, true) !== false);
                ad = (pd_1 && ad);
            }
            if (("blur" === en)) {
                var pd_2 = (core["ɵnov"](_v, 6).onBlur() !== false);
                ad = (pd_2 && ad);
            }
            if (("input" === en)) {
                var pd_3 = (core["ɵnov"](_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("blur" === en)) {
                var pd_4 = (core["ɵnov"](_v, 7).onTouched() !== false);
                ad = (pd_4 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_5 = (core["ɵnov"](_v, 7)._compositionStart() !== false);
                ad = (pd_5 && ad);
            }
            if (("compositionend" === en)) {
                var pd_6 = (core["ɵnov"](_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.ccDate = $event) !== false);
                ad = (pd_7 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_8 = (_co.onDateChange($event) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](3, 278528, null, 0, common["NgStyle"], [core["KeyValueDiffers"], core["ElementRef"], core["Renderer2"]], { ngStyle: [0, "ngStyle"] }, null), core["ɵpod"](4, { "background-color": 0 }), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](6, 671744, [["d", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], { minDate: [0, "minDate"], maxDate: [1, "maxDate"] }, null), core["ɵdid"](7, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](8, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](11, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](13, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](14, 0, null, null, 1, "button", [["class", "iga-right"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                core["ɵnov"](_v, 6).toggle();
                var pd_0 = (_co.openDatePicker(core["ɵnov"](_v, 6)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_9 = _ck(_v, 4, 0, "white"); _ck(_v, 3, 0, currVal_9); var currVal_10 = _co.minDate; var currVal_11 = _co.maxDate; _ck(_v, 6, 0, currVal_10, currVal_11); var currVal_12 = ""; _ck(_v, 8, 0, currVal_12); var currVal_13 = "ccDate"; var currVal_14 = _co.ccDate; _ck(_v, 11, 0, currVal_13, currVal_14); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 6).disabled; var currVal_1 = (core["ɵnov"](_v, 8).required ? "" : null); var currVal_2 = core["ɵnov"](_v, 13).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 13).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 13).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 13).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 13).ngClassValid; var currVal_7 = core["ɵnov"](_v, 13).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 13).ngClassPending; _ck(_v, 2, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); });
}
function View_ConfirmationComponent_4(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.confirm() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("confirm")); _ck(_v, 1, 0, currVal_0); });
}
function View_ConfirmationComponent_5(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.actionResignConfirmed() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabledButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("resign")); _ck(_v, 1, 0, currVal_1); });
}
function View_ConfirmationComponent_6(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.forceResignConfirmed() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabledButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("forceResign")); _ck(_v, 1, 0, currVal_1); });
}
function View_ConfirmationComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationComponent_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationComponent_2)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](5, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](8, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 0, "h6", [["class", "mb-2 medium"]], [[8, "innerHTML", 1]], null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationComponent_3)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 9, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](14, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationComponent_4)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationComponent_5)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationComponent_6)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.ccConversion; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.ccConversion; _ck(_v, 4, 0, currVal_1); var currVal_3 = _co.ccConversion; _ck(_v, 11, 0, currVal_3); var currVal_5 = !_co.forceResign; _ck(_v, 17, 0, currVal_5); var currVal_6 = _co.forceResign; _ck(_v, 19, 0, currVal_6); var currVal_7 = _co.bulkResign; _ck(_v, 21, 0, currVal_7); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = _co.confirmationMessage; _ck(_v, 9, 0, currVal_2); var currVal_4 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("cancel")); _ck(_v, 14, 0, currVal_4); });
}
function View_ConfirmationComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "Confirmation", [], null, [["document", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("document:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).onClick($event, $event.target) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ConfirmationComponent_0, RenderType_ConfirmationComponent)), core["ɵdid"](1, 49152, null, 0, confirmation_ConfirmationComponent, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, Configuration, http_client_HttpClientCustom, auth_Auth, SharedData, ToasterComponent, core_es5["j" /* TranslateService */]], null, null)], null, null);
}
var ConfirmationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("Confirmation", confirmation_ConfirmationComponent, View_ConfirmationComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/confirmation/confirmationModel.ts
var ConfirmationModel = /*@__PURE__*/ (function () {
    function ConfirmationModel(activeModal, _global) {
        this.activeModal = activeModal;
        this._global = _global;
        this.disabledButton = false;
        this.data = null;
    }
    ConfirmationModel.prototype.setData = function (data) {
        if (data) {
            if (!data.isErrorMessage && data.confirmationMessage == null || data.confirmationMessage == "") {
                data.confirmationMessage = 'areYouSure';
            }
            if (data.noButtonText == null || data.noButtonText.trim() == "") {
                data.noButtonText = "no";
            }
            if (data.yesButtonText == null || data.yesButtonText.trim() == "") {
                data.yesButtonText = "yes";
            }
            this.data = data;
        }
    };
    ConfirmationModel.prototype.continue = function () {
        this.disabledButton = true;
        this.activeModal.close("CONTINUE");
    };
    ConfirmationModel.prototype.close = function () {
        this.disabledButton = true;
        this.activeModal.close("CANCEL");
    };
    return ConfirmationModel;
}());



// CONCATENATED MODULE: ./src/app/confirmation/confirmationModel.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_confirmationModel,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_shared_services_configuration PURE_IMPORTS_END */






var styles_ConfirmationModel = [];
var RenderType_ConfirmationModel = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ConfirmationModel, data: {} });

function View_ConfirmationModel_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform(_co.data.heading)); _ck(_v, 1, 0, currVal_0); }); }
function View_ConfirmationModel_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("confirmation")); _ck(_v, 1, 0, currVal_0); }); }
function View_ConfirmationModel_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "mb-2 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform(_co.data.confirmationMessage)); _ck(_v, 2, 0, currVal_0); }); }
function View_ConfirmationModel_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "mb-2 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform(_v.context.$implicit)); _ck(_v, 1, 0, currVal_0); }); }
function View_ConfirmationModel_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationModel_6)), core["ɵdid"](2, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.data.errors; _ck(_v, 2, 0, currVal_0); }, null); }
function View_ConfirmationModel_7(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.continue() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.disabledButton; _ck(_v, 0, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform(_co.data.yesButtonText)); _ck(_v, 1, 0, currVal_1); });
}
function View_ConfirmationModel_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 18, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 7, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationModel_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationModel_3)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](6, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.close() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationModel_4)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationModel_5)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](13, 0, null, null, 5, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationModel_7)), core["ɵdid"](15, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](16, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.close() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](17, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.data.heading; _ck(_v, 3, 0, currVal_0); var currVal_1 = _co.data.isConformation; _ck(_v, 5, 0, currVal_1); var currVal_2 = (!_co.isErrorMessage && _co.data.confirmationMessage); _ck(_v, 10, 0, currVal_2); var currVal_3 = (_co.data.errors && (_co.data.errors.length > 0)); _ck(_v, 12, 0, currVal_3); var currVal_4 = _co.data.isConformation; _ck(_v, 15, 0, currVal_4); }, function (_ck, _v) { var _co = _v.component; var currVal_5 = _co.disabledButton; _ck(_v, 16, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 17, 0, core["ɵnov"](_v, 18).transform(_co.data.noButtonText)); _ck(_v, 17, 0, currVal_6); });
}
function View_ConfirmationModel_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_ConfirmationModel_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.data; _ck(_v, 1, 0, currVal_0); }, null); }
function View_ConfirmationModel_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "confirmationModel", [], null, null, null, View_ConfirmationModel_0, RenderType_ConfirmationModel)), core["ɵdid"](1, 49152, null, 0, ConfirmationModel, [NgbActiveModal, Configuration], null, null)], null, null); }
var ConfirmationModelNgFactory = /*@__PURE__*/ core["ɵccf"]("confirmationModel", ConfirmationModel, View_ConfirmationModel_Host_0, { data: "data" }, {}, []);



// CONCATENATED MODULE: ./src/app/employee/employeeTransfer/employeeTransfer.ts

var employeeTransfer_EmployeeTransferComponent = /*@__PURE__*/ (function () {
    function EmployeeTransferComponent(route, activeModal, _global, translate, _http, _auth, _share, _toaster, vcr) {
        this.route = route;
        this.activeModal = activeModal;
        this._global = _global;
        this.translate = translate;
        this._http = _http;
        this._auth = _auth;
        this._share = _share;
        this._toaster = _toaster;
        this.vcr = vcr;
        this.allScoreCardData = [];
        this.tempArray = [];
        this.finalPayload = [];
        this.modelArray = {};
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this.allScoreCardData = this._share.getMapValues('scoreCardData');
        this.employeeData = this._share.getMapValues('employeeData');
        this.formatPayload();
    }
    EmployeeTransferComponent.prototype.formatPayload = function () {
        var that = this;
        var arr = [];
        underscore["each"](that.allScoreCardData, function (key, val) {
            var payload = { scorecardId: null, endDate: null, orgUnitId: null };
            payload.scorecardId = key.scorecardId;
            payload.endDate = null;
            payload.orgUnitId = that.employeeData.orgId;
            arr.push(payload);
        });
        that.tempArray = arr;
    };
    EmployeeTransferComponent.prototype.confirm = function (option) {
        try {
            var that = this;
            if (that.validatePayload(option)) {
                that.transferEmployee(option);
            }
        }
        catch (e) {
            console.log('saveEmployee error caught', e);
        }
    };
    EmployeeTransferComponent.prototype.transferEmployee = function (option) {
        var _this = this;
        var that = this;
        var payload;
        if (option == 'Transfer') {
            payload = that.finalPayload;
        }
        else {
            payload = this.tempArray;
        }
        var url = this._baseUrl + 'v1/webAdmin/employee/fireEmployeeTransfer';
        that._http.post(url, that.finalPayload).subscribe(function (results) {
            if (results.success && results.errorMessages.length == 0) {
                setTimeout(function () { _this.activeModal.close('confirmed'); }, 1000);
                _this.translate.get(results.message).subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
            }
            else {
                _this.translate.get(results.message).subscribe(function (msg) {
                    _this._toaster.showSuccess(msg);
                });
            }
        });
    };
    EmployeeTransferComponent.prototype.checkSelected = function (i, e) {
        if (e.target.checked) {
            this.finalPayload.push(this.tempArray[i]);
        }
        else {
            if (this.finalPayload.length == 1) {
                this.finalPayload = [];
            }
            else {
                this.finalPayload.splice(i, 1);
            }
        }
    };
    EmployeeTransferComponent.prototype.programEndDateChanged = function (e, i) {
        this.tempArray[i].endDate = e.year + '-' + e.month + '-' + e.day;
    };
    EmployeeTransferComponent.prototype.validatePayload = function (option) {
        var that = this;
        var flag = true;
        if (option == 'Transfer') {
            if (that.finalPayload.length > 0) {
                for (var i = 0; i < that.finalPayload.length; i++) {
                    if (that.finalPayload[i].endDate == null) {
                        flag = false;
                        that.translate.get('selectEndDate').subscribe(function (msg) {
                            that._toaster.showError(msg);
                        });
                        break;
                    }
                }
            }
            else {
                that.translate.get('programToTransfer').subscribe(function (msg) {
                    that._toaster.showError(msg);
                });
                flag = false;
            }
            return flag;
        }
        else {
            if (that.tempArray.length > 0) {
                underscore["each"](that.tempArray, function (key, val) {
                    key.endDate = null;
                });
            }
            return flag;
        }
    };
    EmployeeTransferComponent.prototype.getFormatedDate = function (formatDate) {
        if (formatDate == undefined) {
            return;
        }
        var changeDate = formatDate.split('-');
        var formatedDate = {
            year: +changeDate[0],
            month: +changeDate[1],
            day: +changeDate[2]
        };
        return formatedDate;
    };
    return EmployeeTransferComponent;
}());



// CONCATENATED MODULE: ./src/app/employee/employeeTransfer/employeeTransfer.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_angular_common,_angular_forms,_ngx_translate_core,_employeeTransfer,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */


















var styles_EmployeeTransferComponent = [];
var RenderType_EmployeeTransferComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmployeeTransferComponent, data: {} });

function View_EmployeeTransferComponent_2(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "input", [["type", "checkbox"]], [[8, "id", 0]], [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.checkSelected(_v.parent.context.index, $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "label", [["class", "mb-0"]], [[8, "htmlFor", 0]], null, null, null, null))], null, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "id_", _v.parent.context.index, ""); _ck(_v, 1, 0, currVal_0); var currVal_1 = core["ɵinlineInterpolate"](1, "id_", _v.parent.context.index, ""); _ck(_v, 2, 0, currVal_1); });
}
function View_EmployeeTransferComponent_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left mb-4 left-clear"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 16777216, null, null, 9, "input", [["class", "form-control"], ["name", "endDate"], ["ngbDatepicker", ""], ["placeholder", "YYYY-MM-DD"], ["readonly", ""], ["required", ""]], [[8, "disabled", 0], [1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "change"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 3).manualDateChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("change" === en)) {
                var pd_1 = (core["ɵnov"](_v, 3).manualDateChange($event.target.value, true) !== false);
                ad = (pd_1 && ad);
            }
            if (("blur" === en)) {
                var pd_2 = (core["ɵnov"](_v, 3).onBlur() !== false);
                ad = (pd_2 && ad);
            }
            if (("input" === en)) {
                var pd_3 = (core["ɵnov"](_v, 4)._handleInput($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("blur" === en)) {
                var pd_4 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_4 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_5 = (core["ɵnov"](_v, 4)._compositionStart() !== false);
                ad = (pd_5 && ad);
            }
            if (("compositionend" === en)) {
                var pd_6 = (core["ɵnov"](_v, 4)._compositionEnd($event.target.value) !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.modelArray[_v.parent.context.index] = $event) !== false);
                ad = (pd_7 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_8 = (_co.programEndDateChanged($event, _v.parent.context.index) !== false);
                ad = (pd_8 && ad);
            }
            return ad;
        }, null, null)), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](3, 671744, [["endDate", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], { minDate: [0, "minDate"], maxDate: [1, "maxDate"] }, null), core["ɵdid"](4, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](5, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](8, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](10, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](11, 0, null, null, 1, "button", [["class", "iga-right"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 3).toggle() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_9 = _co.getFormatedDate(_v.parent.context.$implicit.startDate); var currVal_10 = _co.getFormatedDate(_v.parent.context.$implicit.endDate); _ck(_v, 3, 0, currVal_9, currVal_10); var currVal_11 = ""; _ck(_v, 5, 0, currVal_11); var currVal_12 = "endDate"; var currVal_13 = _co.modelArray[_v.parent.context.index]; _ck(_v, 8, 0, currVal_12, currVal_13); }, function (_ck, _v) { var currVal_0 = core["ɵnov"](_v, 3).disabled; var currVal_1 = (core["ɵnov"](_v, 5).required ? "" : null); var currVal_2 = core["ɵnov"](_v, 10).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 10).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 10).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 10).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 10).ngClassValid; var currVal_7 = core["ɵnov"](_v, 10).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 10).ngClassPending; _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); });
}
function View_EmployeeTransferComponent_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("transferInitiated")); _ck(_v, 2, 0, currVal_0); }); }
function View_EmployeeTransferComponent_6(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, null, null, null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("reviewCloseAndTry")); _ck(_v, 2, 0, currVal_0); }); }
function View_EmployeeTransferComponent_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeTransferComponent_6)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"], ngIfElse: [1, "ngIfElse"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_0 = ((((_v.parent.context.$implicit.state == "UPDATEDUE") || (_v.parent.context.$implicit.state == "SUBMIT_REVIEW")) || (_v.parent.context.$implicit.state == "PENDING_REVIEW_VERIFICATION")) || (_v.parent.context.$implicit.state == "NEED_INFO_SUPERVISOR")); var currVal_1 = core["ɵnov"](_v.parent, 19); _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
function View_EmployeeTransferComponent_8(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("resetBackToCreateState")); _ck(_v, 1, 0, currVal_0); }); }
function View_EmployeeTransferComponent_7(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](3, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](4, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](6, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](7, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](12, 0, null, null, 2, "li", [], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeTransferComponent_8)), core["ɵdid"](16, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { var currVal_5 = ((((_v.parent.context.$implicit.state == "PENDING_VERIFICATION") || (_v.parent.context.$implicit.state == "SUBMITTED")) || (_v.parent.context.$implicit.state == "PUBLISHED")) || (_v.parent.context.$implicit.state == "PUBLISH_REVIEW")); _ck(_v, 16, 0, currVal_5); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("reviewWillBeTriggered")); _ck(_v, 1, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 4, 0, core["ɵnov"](_v, 5).transform("consecutiveScoreCardCreated")); _ck(_v, 4, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 7, 0, core["ɵnov"](_v, 8).transform("targetCalculated")); _ck(_v, 7, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 10, 0, core["ɵnov"](_v, 11).transform("convertedSupportingKpi")); _ck(_v, 10, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("onceKpi")); _ck(_v, 13, 0, currVal_4); }); }
function View_EmployeeTransferComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 19, "div", [["class", "col-lg-12 col-md-12 float-left mb-4 b-b pb-4"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 4, "div", [["class", "w-100 float-left align-v-center"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeTransferComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, null, null, 1, "p", [["class", "m-t-nsm mb-0 ml-2 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](5, null, [" ", " "])), (_l()(), core["ɵeld"](6, 0, null, null, 2, "p", [["class", "text-12x mb-1 pl-4 w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](7, null, [" ", " ", " ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](9, 0, null, null, 2, "p", [["class", "text-13x pl-4 mb-1 w-100 float-left text-primary font-italic"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 0, "i", [["class", "fa fa-check-square mr-1 text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeTransferComponent_3)), core["ɵdid"](13, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](14, 0, null, null, 5, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 4, "ul", [["class", "text-10x m-0"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeTransferComponent_4)), core["ɵdid"](17, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"], ngIfElse: [1, "ngIfElse"] }, null), (_l()(), core["ɵand"](0, [["second", 2]], null, 0, null, View_EmployeeTransferComponent_5)), (_l()(), core["ɵand"](0, [["third", 2]], null, 0, null, View_EmployeeTransferComponent_7))], function (_ck, _v) { var currVal_0 = (((((_v.context.$implicit.state != "UPDATEDUE") && (_v.context.$implicit.state != "SUBMIT_REVIEW")) && (_v.context.$implicit.state != "PENDING_REVIEW_VERIFICATION")) && (_v.context.$implicit.state != "NEED_INFO_SUPERVISOR")) && (_v.context.$implicit.createNextScorecard == null)); _ck(_v, 3, 0, currVal_0); var currVal_6 = (((((_v.context.$implicit.state != "UPDATEDUE") && (_v.context.$implicit.state != "SUBMIT_REVIEW")) && (_v.context.$implicit.state != "PENDING_REVIEW_VERIFICATION")) && (_v.context.$implicit.state != "NEED_INFO_SUPERVISOR")) && (_v.context.$implicit.createNextScorecard == null)); _ck(_v, 13, 0, currVal_6); var currVal_7 = (_v.context.$implicit.createNextScorecard != null); var currVal_8 = core["ɵnov"](_v, 18); _ck(_v, 17, 0, currVal_7, currVal_8); }, function (_ck, _v) { var currVal_1 = _v.context.$implicit.scorecardName; _ck(_v, 5, 0, currVal_1); var currVal_2 = _v.context.$implicit.startDate; var currVal_3 = core["ɵunv"](_v, 7, 1, core["ɵnov"](_v, 8).transform("to")); var currVal_4 = _v.context.$implicit.endDate; _ck(_v, 7, 0, currVal_2, currVal_3, currVal_4); var currVal_5 = _v.context.$implicit.state; _ck(_v, 11, 0, currVal_5); }); }
function View_EmployeeTransferComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.close("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 10, "div", [["class", "w-100 float-left modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 7, "div", [["class", "col-lg-12 col-md-12 float-left mb-1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 6, "p", [], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](12, 0, null, null, 1, "span", [["class", "text-primary medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), (_l()(), core["ɵted"](14, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmployeeTransferComponent_1)), core["ɵdid"](17, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](18, 0, null, null, 6, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.confirm("Skip") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](20, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](22, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.confirm("Transfer") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](23, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_4 = _co.allScoreCardData; _ck(_v, 17, 0, currVal_4); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("employeeTransfer")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 10, 0, core["ɵnov"](_v, 11).transform("currently")); _ck(_v, 10, 0, currVal_1); var currVal_2 = _co.employeeData.displayName; _ck(_v, 13, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 14, 0, core["ɵnov"](_v, 15).transform("partOfProgram")); _ck(_v, 14, 0, currVal_3); var currVal_5 = core["ɵunv"](_v, 20, 0, core["ɵnov"](_v, 21).transform("skip")); _ck(_v, 20, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 23, 0, core["ɵnov"](_v, 24).transform("transfer")); _ck(_v, 23, 0, currVal_6); });
}
function View_EmployeeTransferComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "employeeTransfer", [], null, null, null, View_EmployeeTransferComponent_0, RenderType_EmployeeTransferComponent)), core["ɵdid"](1, 49152, null, 0, employeeTransfer_EmployeeTransferComponent, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, Configuration, core_es5["j" /* TranslateService */], http_client_HttpClientCustom, auth_Auth, SharedData, ToasterComponent, core["ViewContainerRef"]], null, null)], null, null); }
var EmployeeTransferComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("employeeTransfer", employeeTransfer_EmployeeTransferComponent, View_EmployeeTransferComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./node_modules/ng2-img-cropper/src/imageCropperComponent.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_imageCropperComponent PURE_IMPORTS_END */



var styles_ImageCropperComponent = [];
var RenderType_ImageCropperComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ImageCropperComponent, data: {} });

function View_ImageCropperComponent_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "input", [["accept", "image/*"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.fileChangeListener($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null))], null, null);
}
function View_ImageCropperComponent_0(_l) {
    return core["ɵvid"](0, [core["ɵqud"](402653184, 1, { cropcanvas: 0 }), (_l()(), core["ɵeld"](1, 0, null, null, 3, "span", [["class", "ng2-imgcrop"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ImageCropperComponent_1)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](4, 0, [[1, 0], ["cropcanvas", 1]], null, 0, "canvas", [], null, [[null, "mousedown"], [null, "mouseup"], [null, "mousemove"], [null, "mouseleave"], [null, "touchmove"], [null, "touchend"], [null, "touchstart"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("mousedown" === en)) {
                var pd_0 = (_co.onMouseDown($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("mouseup" === en)) {
                var pd_1 = (_co.onMouseUp($event) !== false);
                ad = (pd_1 && ad);
            }
            if (("mousemove" === en)) {
                var pd_2 = (_co.onMouseMove($event) !== false);
                ad = (pd_2 && ad);
            }
            if (("mouseleave" === en)) {
                var pd_3 = (_co.onMouseUp($event) !== false);
                ad = (pd_3 && ad);
            }
            if (("touchmove" === en)) {
                var pd_4 = (_co.onTouchMove($event) !== false);
                ad = (pd_4 && ad);
            }
            if (("touchend" === en)) {
                var pd_5 = (_co.onTouchEnd($event) !== false);
                ad = (pd_5 && ad);
            }
            if (("touchstart" === en)) {
                var pd_6 = (_co.onTouchStart($event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_0 = !_co.settings.noFileInput; _ck(_v, 3, 0, currVal_0); }, null);
}
function View_ImageCropperComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "img-cropper", [], null, null, null, View_ImageCropperComponent_0, RenderType_ImageCropperComponent)), core["ɵdid"](1, 4898816, null, 0, imageCropperComponent_ImageCropperComponent, [core["Renderer"]], null, null)], null, null); }
var ImageCropperComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("img-cropper", imageCropperComponent_ImageCropperComponent, View_ImageCropperComponent_Host_0, { settings: "settings", image: "image", inputImage: "inputImage", cropper: "cropper", cropPosition: "cropPosition" }, { cropPositionChange: "cropPositionChange", onCrop: "onCrop" }, []);



// CONCATENATED MODULE: ./src/app/imageCropper/imageCropper.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_.._.._node_modules_ng2_img_cropper_src_imageCropperComponent.ngfactory,ng2_img_cropper_src_imageCropperComponent,_imageCropper,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_shared_services_configuration,_shared_services_http.client,_shared_sharedData PURE_IMPORTS_END */










var styles_CropImageComponent = [];
var RenderType_CropImageComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_CropImageComponent, data: {} });

function View_CropImageComponent_0(_l) {
    return core["ɵvid"](0, [core["ɵqud"](402653184, 1, { cropper: 0 }), (_l()(), core["ɵeld"](1, 0, null, null, 6, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](3, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](5, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](8, 0, null, null, 2, "div", [["class", "w-100 float-left p-4 modal-body profile-pic-cropper"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 1, "img-cropper", [], null, null, null, View_ImageCropperComponent_0, RenderType_ImageCropperComponent)), core["ɵdid"](10, 4898816, [[1, 4], ["cropper", 4]], 0, imageCropperComponent_ImageCropperComponent, [core["Renderer"]], { settings: [0, "settings"], image: [1, "image"] }, null), (_l()(), core["ɵeld"](11, 0, null, null, 6, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](13, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](15, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.confirmCrop() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](16, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.cropperSettings; var currVal_2 = _co.data; _ck(_v, 10, 0, currVal_1, currVal_2); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 3, 0, core["ɵnov"](_v, 4).transform("cropImg")); _ck(_v, 3, 0, currVal_0); var currVal_3 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("cancel")); _ck(_v, 13, 0, currVal_3); var currVal_4 = core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 17).transform("confirm")); _ck(_v, 16, 0, currVal_4); });
}
function View_CropImageComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "Crop-Image", [], null, null, null, View_CropImageComponent_0, RenderType_CropImageComponent)), core["ɵdid"](1, 49152, null, 0, imageCropper_CropImageComponent, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], SharedData], null, null)], null, null); }
var CropImageComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("Crop-Image", imageCropper_CropImageComponent, View_CropImageComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/employee/employeeActions/actionSuspend.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_actionSuspend,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */











var styles_ActionSuspend = [];
var RenderType_ActionSuspend = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ActionSuspend, data: {} });

function View_ActionSuspend_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("suspendEmployee")); _ck(_v, 1, 0, currVal_0); }); }
function View_ActionSuspend_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("activateEmployee")); _ck(_v, 1, 0, currVal_0); }); }
function View_ActionSuspend_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("confirmSuspendEmployee")); _ck(_v, 1, 0, currVal_0); }); }
function View_ActionSuspend_4(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform("confirmActivateEmployee")); _ck(_v, 1, 0, currVal_0); }); }
function View_ActionSuspend_5(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_ActionSuspend_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 7, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ActionSuspend_1)), core["ɵdid"](2, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ActionSuspend_2)), core["ɵdid"](4, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](5, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](8, 0, null, null, 4, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ActionSuspend_3)), core["ɵdid"](10, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ActionSuspend_4)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](13, 0, null, null, 8, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](15, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](17, 0, null, null, 4, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.suspendOrActiveEmployee() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](18, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ActionSuspend_5)), core["ɵdid"](21, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = (_co.type == "SUSPEND"); _ck(_v, 2, 0, currVal_0); var currVal_1 = (_co.type == "ACTIVE"); _ck(_v, 4, 0, currVal_1); var currVal_2 = (_co.type == "SUSPEND"); _ck(_v, 10, 0, currVal_2); var currVal_3 = (_co.type == "ACTIVE"); _ck(_v, 12, 0, currVal_3); var currVal_7 = _co.showButtonLoading; _ck(_v, 21, 0, currVal_7); }, function (_ck, _v) { var _co = _v.component; var currVal_4 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("cancel")); _ck(_v, 15, 0, currVal_4); var currVal_5 = _co.showButtonLoading; _ck(_v, 17, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 18, 0, core["ɵnov"](_v, 19).transform("confirm")); _ck(_v, 18, 0, currVal_6); });
}
function View_ActionSuspend_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "ActionSuspend", [], null, null, null, View_ActionSuspend_0, RenderType_ActionSuspend)), core["ɵdid"](1, 49152, null, 0, ActionSuspend, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, core_es5["j" /* TranslateService */], Configuration, http_client_HttpClientCustom, auth_Auth, SharedData, ToasterComponent, core["ViewContainerRef"]], null, null)], null, null); }
var ActionSuspendNgFactory = /*@__PURE__*/ core["ɵccf"]("ActionSuspend", ActionSuspend, View_ActionSuspend_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/employee/employeeActions/resetPasswordByAdmin.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_.._directives_copy_to_clipboard_directive,_ngx_translate_core,_angular_common,_resetPasswordByAdmin,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */












var styles_ResetPasswordPage = [];
var RenderType_ResetPasswordPage = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ResetPasswordPage, data: {} });

function View_ResetPasswordPage_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "w-100 pull-left b-a relative text-center px-2 py-3 rounded light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "w-100 float-left overflow-auto"], ["style", "overflow:auto"]], null, [[null, "copied"], [null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 2).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("copied" === en)) {
                var pd_1 = (_co.notify($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](2, 16384, null, 0, copy_to_clipboard_directive_CopyClipboardDirective, [], { payload: [0, "payload"] }, { copied: "copied" }), (_l()(), core["ɵted"](3, null, ["", ""]))], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.passwordToken; _ck(_v, 2, 0, currVal_0); }, function (_ck, _v) { var _co = _v.component; var currVal_1 = _co.passwordToken; _ck(_v, 3, 0, currVal_1); });
}
function View_ResetPasswordPage_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_ResetPasswordPage_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "i", [["class", "fa fa-spinner fa-spin text-white m-l-smd"]], null, null, null, null, null))], null, null); }
function View_ResetPasswordPage_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 25, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 11, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 7, "div", [["class", "w-100 pull-left b-a relative text-center px-2 py-3 rounded light-bg"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 0, "i", [["class", "fa fa-check text-primary tr-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 2, "p", [["class", "w-100 float-left mt-3 mb-2 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](14, 0, null, null, 2, "h6", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵted"](15, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](17, 0, null, null, 0, "br", [], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ResetPasswordPage_1)), core["ɵdid"](19, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](20, 0, null, null, 12, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](21, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](22, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](24, 0, null, null, 4, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.resetPassword() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](25, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ResetPasswordPage_2)), core["ɵdid"](28, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](29, 0, null, null, 3, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.getPasswordToken() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](-1, null, [" Get password link "])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_ResetPasswordPage_3)), core["ɵdid"](32, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_3 = _co.passwordToken; _ck(_v, 19, 0, currVal_3); var currVal_7 = _co.showButtonLoading; _ck(_v, 28, 0, currVal_7); var currVal_9 = _co.showButtonLoading; _ck(_v, 32, 0, currVal_9); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("resetPassword")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 12, 0, core["ɵnov"](_v, 13).transform("activationLinks")); _ck(_v, 12, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 15, 0, core["ɵnov"](_v, 16).transform("confirmToSendActivationLinkMail")); _ck(_v, 15, 0, currVal_2); var currVal_4 = core["ɵunv"](_v, 22, 0, core["ɵnov"](_v, 23).transform("close")); _ck(_v, 22, 0, currVal_4); var currVal_5 = _co.showButtonLoading; _ck(_v, 24, 0, currVal_5); var currVal_6 = core["ɵunv"](_v, 25, 0, core["ɵnov"](_v, 26).transform("confirm")); _ck(_v, 25, 0, currVal_6); var currVal_8 = _co.showButtonLoading; _ck(_v, 29, 0, currVal_8); });
}
function View_ResetPasswordPage_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "EmpTableResetPwd", [], null, null, null, View_ResetPasswordPage_0, RenderType_ResetPasswordPage)), core["ɵdid"](1, 49152, null, 0, ResetPasswordPage, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, core_es5["j" /* TranslateService */], Configuration, http_client_HttpClientCustom, auth_Auth, SharedData, ToasterComponent], null, null)], null, null); }
var ResetPasswordPageNgFactory = /*@__PURE__*/ core["ɵccf"]("EmpTableResetPwd", ResetPasswordPage, View_ResetPasswordPage_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/employee/addSupervisor.ts

var addSupervisor_AddSupervisor = /*@__PURE__*/ (function () {
    function AddSupervisor(route, activeModal, modalService, _global, http, translate, _auth, router, _share, _toaster, vcr) {
        this.route = route;
        this.activeModal = activeModal;
        this.modalService = modalService;
        this._global = _global;
        this.http = http;
        this.translate = translate;
        this._auth = _auth;
        this.router = router;
        this._share = _share;
        this._toaster = _toaster;
        this.nl = 1;
        this.changeApproverBean = {
            comments: null,
            scorecardId: null,
            employeeId: null,
            secondarySupervisorIds: [],
            primarySupervisorId: null,
            verifierId: null
        };
        this.changeApproverBeanList = [];
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.programData = this._share.getData();
        // this._toaster.setViewRef(vcr);
        this.getData();
    }
    AddSupervisor.prototype.getData = function () {
        underscore["each"](this.programData.scorecardData, function (key, val) {
            key.selected = false;
        });
    };
    AddSupervisor.prototype.getScorecardId = function (scorecardData, $event) {
        this.changeApproverBean = null;
        var changeApproverBean1 = {
            comments: null,
            scorecardId: null,
            employeeId: null,
            secondarySupervisorIds: [],
            primarySupervisorId: null,
            verifierId: null
        };
        if ($event.target.checked) {
            changeApproverBean1.employeeId = this.programData.empData.id;
            changeApproverBean1.scorecardId = scorecardData.scorecardId;
            changeApproverBean1.primarySupervisorId = this.programData.empData.primarySupervisorId;
            changeApproverBean1.verifierId = this.programData.empData.verifierId;
            changeApproverBean1.secondarySupervisorIds = this.programData.empData.secSupervisorIds;
            this.changeApproverBeanList.push(changeApproverBean1);
        }
        else {
            if (this.changeApproverBeanList.length > 0) {
                for (var _i = 0, _a = this.changeApproverBeanList; _i < _a.length; _i++) {
                    var i = _a[_i];
                    if (i.scorecardId == scorecardData.scorecardId) {
                        var index = this.changeApproverBeanList.indexOf(i);
                        if (index !== -1) {
                            this.changeApproverBeanList.splice(index, 1);
                        }
                        console.log(i);
                    }
                }
            }
        }
    };
    AddSupervisor.prototype.changeApprover = function () {
        var _this = this;
        var self = this;
        if (this.changeApproverBeanList.length > 0) {
            if (this.comments == null) {
                this.translate.get('provideComments').subscribe(function (msg) {
                    _this._toaster.showError(msg);
                });
                return false;
            }
            for (var _i = 0, _a = this.changeApproverBeanList; _i < _a.length; _i++) {
                var i = _a[_i];
                i.comments = this.comments;
            }
            var url = self._baseUrl + "v1/webAdmin/employee/updateApprover";
            self.http.post(url, this.changeApproverBeanList).subscribe(function (result) {
                if (result) {
                    _this.translate.get('approved').subscribe(function (msg) {
                        _this._toaster.showSuccess(msg);
                    });
                    _this.activeModal.close(result);
                }
                else {
                    _this.translate.get('updateFailed').subscribe(function (msg) {
                        _this._toaster.showError(msg);
                    });
                }
            });
        }
        else {
            this.activeModal.close(true);
        }
    };
    AddSupervisor.prototype.selectAll = function (event) {
        for (var i = 0; i < this.programData.scorecardData.length; i++) {
            this.programData.scorecardData[i].selected = this.selectedAll;
            this.getScorecardId(this.programData.scorecardData[i], event);
        }
    };
    AddSupervisor.prototype.checkIfAllSelected = function (scorecardData, $event) {
        this.selectedAll = this.programData.scorecardData.every(function (item) {
            return item.selected == true;
        });
        this.getScorecardId(scorecardData, $event);
    };
    return AddSupervisor;
}());



// CONCATENATED MODULE: ./src/app/employee/addSupervisor.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_ngx_translate_core,_angular_common,_addSupervisor,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_ng_bootstrap_ng_bootstrap_modal_modal,_shared_services_configuration,_shared_services_http.client,_shared_services_auth,_shared_sharedData,_toasterComponent_toasterComponent PURE_IMPORTS_END */













var styles_AddSupervisor = [];
var RenderType_AddSupervisor = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddSupervisor, data: {} });

function View_AddSupervisor_1(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 12, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 8, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 5, "input", [["type", "checkbox"]], [[8, "id", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 4).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 4).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_v.context.$implicit.selected = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.checkIfAllSelected(_v.context.$implicit, $event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](4, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](6, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](8, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](9, 0, null, null, 0, "label", [["class", "mb-0"]], [[8, "htmlFor", 0]], null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 2, "div", [["class", "col-lg-11 col-md-11 col-sm-11 col-xs-11 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](11, 0, null, null, 1, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](12, null, [" ", " "]))], function (_ck, _v) { var currVal_8 = _v.context.$implicit.selected; _ck(_v, 6, 0, currVal_8); }, function (_ck, _v) { var currVal_0 = core["ɵinlineInterpolate"](1, "id_", _v.context.$implicit.scorecardId, ""); var currVal_1 = core["ɵnov"](_v, 8).ngClassUntouched; var currVal_2 = core["ɵnov"](_v, 8).ngClassTouched; var currVal_3 = core["ɵnov"](_v, 8).ngClassPristine; var currVal_4 = core["ɵnov"](_v, 8).ngClassDirty; var currVal_5 = core["ɵnov"](_v, 8).ngClassValid; var currVal_6 = core["ɵnov"](_v, 8).ngClassInvalid; var currVal_7 = core["ɵnov"](_v, 8).ngClassPending; _ck(_v, 3, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7); var currVal_9 = core["ɵinlineInterpolate"](1, "id_", _v.context.$implicit.scorecardId, ""); _ck(_v, 9, 0, currVal_9); var currVal_10 = _v.context.$implicit.programName; _ck(_v, 12, 0, currVal_10); });
}
function View_AddSupervisor_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 38, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 33, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 2, "h6", [["class", "mb-3"]], null, null, null, null, null)), (_l()(), core["ɵted"](10, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](12, 0, null, null, 14, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 13, "div", [["class", "light-bg w-100 float-left p-2 grid-details"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 8, "div", [["class", "col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](15, 0, null, null, 7, "div", [["class", "checkbox checkbox-primary"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 5, "input", [["id", "self"], ["type", "checkbox"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 17).onChange($event.target.checked) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 17).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.selectedAll = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (("change" === en)) {
                var pd_3 = (_co.selectAll($event) !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](17, 16384, null, 0, fesm5_forms["CheckboxControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["CheckboxControlValueAccessor"]]), core["ɵdid"](19, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](21, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](22, 0, null, null, 0, "label", [["class", "mb-0"], ["for", "self"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 3, "div", [["class", "col-lg-11 col-md-11 col-sm-11 col-xs-11 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 2, "h6", [["class", "mb-lg-0 medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](25, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](27, 0, null, null, 2, "div", [["class", "w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddSupervisor_1)), core["ɵdid"](29, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](30, 0, null, null, 11, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](31, 0, null, null, 10, "div", [["class", "col-lg-12 col-md-12 col-sm-12 col-xs-12 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](32, 0, null, null, 9, "div", [["class", "form-group w-100 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](34, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 5, "input", [["class", "form-control"], ["type", "textarea"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 37)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 37).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 37)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 37)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.comments = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](37, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](39, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](41, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](42, 0, null, null, 3, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](43, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.changeApprover() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](44, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = _co.selectedAll; _ck(_v, 19, 0, currVal_9); var currVal_11 = _co.programData.scorecardData; _ck(_v, 29, 0, currVal_11); var currVal_20 = _co.comments; _ck(_v, 39, 0, currVal_20); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("updateSupervisorProgram")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 10, 0, core["ɵnov"](_v, 11).transform("selectProgram")); _ck(_v, 10, 0, currVal_1); var currVal_2 = core["ɵnov"](_v, 21).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 21).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 21).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 21).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 21).ngClassValid; var currVal_7 = core["ɵnov"](_v, 21).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 21).ngClassPending; _ck(_v, 16, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_10 = core["ɵunv"](_v, 25, 0, core["ɵnov"](_v, 26).transform("selectAll")); _ck(_v, 25, 0, currVal_10); var currVal_12 = core["ɵunv"](_v, 34, 0, core["ɵnov"](_v, 35).transform("reason")); _ck(_v, 34, 0, currVal_12); var currVal_13 = core["ɵnov"](_v, 41).ngClassUntouched; var currVal_14 = core["ɵnov"](_v, 41).ngClassTouched; var currVal_15 = core["ɵnov"](_v, 41).ngClassPristine; var currVal_16 = core["ɵnov"](_v, 41).ngClassDirty; var currVal_17 = core["ɵnov"](_v, 41).ngClassValid; var currVal_18 = core["ɵnov"](_v, 41).ngClassInvalid; var currVal_19 = core["ɵnov"](_v, 41).ngClassPending; _ck(_v, 36, 0, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19); var currVal_21 = core["ɵunv"](_v, 44, 0, core["ɵnov"](_v, 45).transform("save")); _ck(_v, 44, 0, currVal_21); });
}
function View_AddSupervisor_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "AddSupervisor", [], null, null, null, View_AddSupervisor_0, RenderType_AddSupervisor)), core["ɵdid"](1, 49152, null, 0, addSupervisor_AddSupervisor, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, NgbModal, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], auth_Auth, fesm5_router["l" /* Router */], SharedData, ToasterComponent, core["ViewContainerRef"]], null, null)], null, null); }
var AddSupervisorNgFactory = /*@__PURE__*/ core["ɵccf"]("AddSupervisor", addSupervisor_AddSupervisor, View_AddSupervisor_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/programManagement/announcements/scheduleAnnouncement.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_service,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_input,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_angular_common,_angular_forms,_.._.._.._node_modules__ng_bootstrap_ng_bootstrap_timepicker_timepicker.ngfactory,_ng_bootstrap_ng_bootstrap_timepicker_timepicker,_ng_bootstrap_ng_bootstrap_timepicker_timepicker_config,_ng_bootstrap_ng_bootstrap_timepicker_ngb_time_adapter,_scheduleAnnouncement,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_services_configuration,_.._shared_services_http.client,_.._shared_services_auth,_.._shared_sharedData,_.._toasterComponent_toasterComponent PURE_IMPORTS_END */






















var styles_ScheduleAnnouncement = [];
var RenderType_ScheduleAnnouncement = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_ScheduleAnnouncement, data: {} });

function View_ScheduleAnnouncement_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 24, "div", [["class", "w-100 float-left p-4 modal-body"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 20, "div", [["class", "row d-flex align-items-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 16777216, null, null, 9, "input", [["class", "form-control"], ["name", "startDate"], ["ngbDatepicker", ""], ["placeholder", "YYYY-MM-DD"], ["readonly", ""], ["required", ""]], [[8, "disabled", 0], [1, "required", 0], [2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "change"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 15).manualDateChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("change" === en)) {
                var pd_1 = (core["ɵnov"](_v, 15).manualDateChange($event.target.value, true) !== false);
                ad = (pd_1 && ad);
            }
            if (("blur" === en)) {
                var pd_2 = (core["ɵnov"](_v, 15).onBlur() !== false);
                ad = (pd_2 && ad);
            }
            if (("input" === en)) {
                var pd_3 = (core["ɵnov"](_v, 16)._handleInput($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("blur" === en)) {
                var pd_4 = (core["ɵnov"](_v, 16).onTouched() !== false);
                ad = (pd_4 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_5 = (core["ɵnov"](_v, 16)._compositionStart() !== false);
                ad = (pd_5 && ad);
            }
            if (("compositionend" === en)) {
                var pd_6 = (core["ɵnov"](_v, 16)._compositionEnd($event.target.value) !== false);
                ad = (pd_6 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_7 = ((_co.announcementData.activationDate = $event) !== false);
                ad = (pd_7 && ad);
            }
            return ad;
        }, null, null)), core["ɵprd"](512, null, datepicker_service_NgbDatepickerService, datepicker_service_NgbDatepickerService, [NgbCalendar, NgbDatepickerI18n]), core["ɵdid"](15, 671744, [["startDate", 4]], 0, datepicker_input_NgbInputDatepicker, [NgbDateParserFormatter, core["ElementRef"], core["ViewContainerRef"], core["Renderer2"], core["ComponentFactoryResolver"], core["NgZone"], datepicker_service_NgbDatepickerService, NgbCalendar, NgbDateAdapter, common["DOCUMENT"]], { minDate: [0, "minDate"] }, null), core["ɵdid"](16, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵdid"](17, 16384, null, 0, fesm5_forms["RequiredValidator"], [], { required: [0, "required"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALIDATORS"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["RequiredValidator"]]), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [datepicker_input_NgbInputDatepicker, fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](20, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [6, fesm5_forms["NG_VALIDATORS"]], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { name: [0, "name"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](22, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](23, 0, null, null, 1, "button", [["class", "iga-right"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                core["ɵnov"](_v, 15).toggle();
                var pd_0 = (_co.openDatePicker(core["ɵnov"](_v, 15)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 0, "i", [["class", "fa fa-calendar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 6, "div", [["class", "col-lg-6 col-md-6 pl-5"]], null, null, null, null, null)), (_l()(), core["ɵeld"](26, 0, null, null, 5, "ngb-timepicker", [], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("ngModelChange" === en)) {
                var pd_0 = ((_co.activationTime = $event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_NgbTimepicker_0, RenderType_NgbTimepicker)), core["ɵdid"](27, 573440, null, 0, timepicker_NgbTimepicker, [NgbTimepickerConfig, NgbTimeAdapter], { meridian: [0, "meridian"] }, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [timepicker_NgbTimepicker]), core["ɵdid"](29, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](31, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](32, 0, null, null, 6, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](33, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](34, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](36, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], [[8, "disabled", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.schedule() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](37, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_11 = _co.minStartDate; _ck(_v, 15, 0, currVal_11); var currVal_12 = ""; _ck(_v, 17, 0, currVal_12); var currVal_13 = "startDate"; var currVal_14 = _co.announcementData.activationDate; _ck(_v, 20, 0, currVal_13, currVal_14); var currVal_22 = _co.meridian; _ck(_v, 27, 0, currVal_22); var currVal_23 = _co.activationTime; _ck(_v, 29, 0, currVal_23); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("scheduleAnnouncement")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("selectActivationDateTime")); _ck(_v, 9, 0, currVal_1); var currVal_2 = core["ɵnov"](_v, 15).disabled; var currVal_3 = (core["ɵnov"](_v, 17).required ? "" : null); var currVal_4 = core["ɵnov"](_v, 22).ngClassUntouched; var currVal_5 = core["ɵnov"](_v, 22).ngClassTouched; var currVal_6 = core["ɵnov"](_v, 22).ngClassPristine; var currVal_7 = core["ɵnov"](_v, 22).ngClassDirty; var currVal_8 = core["ɵnov"](_v, 22).ngClassValid; var currVal_9 = core["ɵnov"](_v, 22).ngClassInvalid; var currVal_10 = core["ɵnov"](_v, 22).ngClassPending; _ck(_v, 13, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8, currVal_9, currVal_10); var currVal_15 = core["ɵnov"](_v, 31).ngClassUntouched; var currVal_16 = core["ɵnov"](_v, 31).ngClassTouched; var currVal_17 = core["ɵnov"](_v, 31).ngClassPristine; var currVal_18 = core["ɵnov"](_v, 31).ngClassDirty; var currVal_19 = core["ɵnov"](_v, 31).ngClassValid; var currVal_20 = core["ɵnov"](_v, 31).ngClassInvalid; var currVal_21 = core["ɵnov"](_v, 31).ngClassPending; _ck(_v, 26, 0, currVal_15, currVal_16, currVal_17, currVal_18, currVal_19, currVal_20, currVal_21); var currVal_24 = core["ɵunv"](_v, 34, 0, core["ɵnov"](_v, 35).transform("cancel")); _ck(_v, 34, 0, currVal_24); var currVal_25 = _co.buttonStatus; _ck(_v, 36, 0, currVal_25); var currVal_26 = core["ɵunv"](_v, 37, 0, core["ɵnov"](_v, 38).transform("confirm")); _ck(_v, 37, 0, currVal_26); });
}
function View_ScheduleAnnouncement_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "ScheduleAnnouncement", [], null, [["document", "click"]], function (_v, en, $event) {
            var ad = true;
            if (("document:click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).onClick($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_ScheduleAnnouncement_0, RenderType_ScheduleAnnouncement)), core["ɵdid"](1, 49152, null, 0, scheduleAnnouncement_ScheduleAnnouncement, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, Configuration, http_client_HttpClientCustom, auth_Auth, SharedData, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], core["ElementRef"]], null, null)], null, null);
}
var ScheduleAnnouncementNgFactory = /*@__PURE__*/ core["ɵccf"]("ScheduleAnnouncement", scheduleAnnouncement_ScheduleAnnouncement, View_ScheduleAnnouncement_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/programManagement/emailNotification/emailPreview.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_common,_emailPreview,_angular_router,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_sharedData PURE_IMPORTS_END */







var styles_EmailPreview = [];
var RenderType_EmailPreview = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_EmailPreview, data: {} });

function View_EmailPreview_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 2, "p", [["class", "mb-0"]], null, null, null, null, null)), (_l()(), core["ɵted"](1, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 1, 0, core["ɵnov"](_v, 2).transform(_v.context.$implicit.name)); _ck(_v, 1, 0, currVal_0); }); }
function View_EmailPreview_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "div", [["class", "d-flex align-items-center mb-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 0, "i", [["class", "fa fa-paperclip mr-2"]], null, null, null, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmailPreview_2)), core["ɵdid"](3, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.emailData.email.attachments; _ck(_v, 3, 0, currVal_0); }, null); }
function View_EmailPreview_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 5, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), (_l()(), core["ɵeld"](3, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](6, 0, null, null, 8, "div", [["class", "w-100 float-left p-4 modal-body advanced-mode"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 3, "p", [], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 1, "b", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["To:"])), (_l()(), core["ɵted"](10, null, [" ", ""])), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_EmailPreview_1)), core["ɵdid"](12, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](13, 0, null, null, 1, "div", [["class", "light-bg p-3"]], null, null, null, null, null)), (_l()(), core["ɵeld"](14, 0, null, null, 0, "p", [], [[8, "innerHTML", 1]], null, null, null, null))], function (_ck, _v) { var _co = _v.component; var currVal_2 = (_co.emailData.email.attachments.length > 0); _ck(_v, 12, 0, currVal_2); }, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.emailData.email.subject; _ck(_v, 2, 0, currVal_0); var currVal_1 = _co.emailData.email.to[0]; _ck(_v, 10, 0, currVal_1); var currVal_3 = _co.emailData.email.body; _ck(_v, 14, 0, currVal_3); });
}
function View_EmailPreview_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "emailPreview", [], null, null, null, View_EmailPreview_0, RenderType_EmailPreview)), core["ɵdid"](1, 49152, null, 0, EmailPreview, [fesm5_router["a" /* ActivatedRoute */], NgbActiveModal, SharedData], null, null)], null, null); }
var EmailPreviewNgFactory = /*@__PURE__*/ core["ɵccf"]("emailPreview", EmailPreview, View_EmailPreview_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/tools/operations/addOperation.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_forms,_ngx_translate_core,_angular_common,_addOperation.component,_angular_router,_.._shared_permissions_permissions,_.._shared_services_configuration,_.._shared_services_http.client,_.._toasterComponent_toasterComponent,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_.._shared_sharedData PURE_IMPORTS_END */












var styles_AddOperationComponent = [];
var RenderType_AddOperationComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AddOperationComponent, data: {} });

function View_AddOperationComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 3, "option", [], [[1, "value", 0], [1, "selected", 0]], null, null, null, null)), core["ɵdid"](1, 147456, null, 0, fesm5_forms["NgSelectOption"], [core["ElementRef"], core["Renderer2"], [2, fesm5_forms["SelectControlValueAccessor"]]], null, null), core["ɵdid"](2, 147456, null, 0, fesm5_forms["ɵangular_packages_forms_forms_r"], [core["ElementRef"], core["Renderer2"], [8, null]], null, null), (_l()(), core["ɵted"](3, null, ["", " "]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _v.context.$implicit; var currVal_1 = ((_v.context.$implicit == _co.operationDetailsData.operation) ? true : null); _ck(_v, 0, 0, currVal_0, currVal_1); var currVal_2 = _v.context.$implicit; _ck(_v, 3, 0, currVal_2); }); }
function View_AddOperationComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 51, "div", [["class", "w-100 float-left p-4 modal-body advanced-mode"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 14, "div", [["class", "col-lg-6 col-md-6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 13, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](13, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](15, 0, null, null, 7, "select", [["class", "form-control light-bg"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "change"], [null, "blur"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (core["ɵnov"](_v, 16).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 16).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_2 = ((_co.operationDetailsData.operation = $event) !== false);
                ad = (pd_2 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](16, 16384, null, 0, fesm5_forms["SelectControlValueAccessor"], [core["Renderer2"], core["ElementRef"]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["SelectControlValueAccessor"]]), core["ɵdid"](18, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](20, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AddOperationComponent_1)), core["ɵdid"](22, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](23, 0, null, null, 12, "div", [["class", "col-lg-12 col-md-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](24, 0, null, null, 11, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](25, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](26, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](28, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](30, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 31)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 31).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 31)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 31)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.operationDetailsData.name = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](31, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](33, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](35, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](36, 0, null, null, 12, "div", [["class", "col-lg-12 col-md-12"]], null, null, null, null, null)), (_l()(), core["ɵeld"](37, 0, null, null, 11, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](38, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](39, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](41, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](43, 0, null, null, 5, "input", [["class", "form-control"], ["type", "url"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 44)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 44).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 44)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 44)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.operationDetailsData.externalURL = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](44, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](46, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { isDisabled: [0, "isDisabled"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](48, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](49, 0, null, null, 9, "div", [["class", "col-lg-6 col-md-6"]], null, null, null, null, null)), (_l()(), core["ɵeld"](50, 0, null, null, 8, "div", [["class", "w-100 form-group"]], null, null, null, null, null)), (_l()(), core["ɵeld"](51, 0, null, null, 1, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Logo"])), (_l()(), core["ɵeld"](53, 0, [["fileInput", 1]], null, 0, "input", [["accept", ".jpg,.png,.svg,.svgz"], ["class", "form-control"], ["name", "pic"], ["type", "file"]], null, [[null, "change"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("change" === en)) {
                var pd_0 = (_co.fileChange($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](54, 0, null, null, 4, "div", [["class", "align-v-center justify-content-end"]], null, null, null, null, null)), (_l()(), core["ɵeld"](55, 0, null, null, 1, "small", [["class", "text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["Resolution: 160*40px; "])), (_l()(), core["ɵeld"](57, 0, null, null, 1, "small", [["class", "ml-2 text-primary"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["size limit: 5mb"])), (_l()(), core["ɵeld"](59, 0, null, null, 6, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](60, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](61, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](63, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.save() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](64, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = _co.operationDetailsData.operation; _ck(_v, 18, 0, currVal_9); var currVal_10 = _co.operationList; _ck(_v, 22, 0, currVal_10); var currVal_19 = _co.operationDetailsData.name; _ck(_v, 33, 0, currVal_19); var currVal_28 = _co.isUpdate; var currVal_29 = _co.operationDetailsData.externalURL; _ck(_v, 46, 0, currVal_28, currVal_29); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("addOperation")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 11, 0, core["ɵnov"](_v, 12).transform("selectOperation")); _ck(_v, 11, 0, currVal_1); var currVal_2 = core["ɵnov"](_v, 20).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 20).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 20).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 20).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 20).ngClassValid; var currVal_7 = core["ɵnov"](_v, 20).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 20).ngClassPending; _ck(_v, 15, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_11 = core["ɵunv"](_v, 26, 0, core["ɵnov"](_v, 27).transform("name")); _ck(_v, 26, 0, currVal_11); var currVal_12 = core["ɵnov"](_v, 35).ngClassUntouched; var currVal_13 = core["ɵnov"](_v, 35).ngClassTouched; var currVal_14 = core["ɵnov"](_v, 35).ngClassPristine; var currVal_15 = core["ɵnov"](_v, 35).ngClassDirty; var currVal_16 = core["ɵnov"](_v, 35).ngClassValid; var currVal_17 = core["ɵnov"](_v, 35).ngClassInvalid; var currVal_18 = core["ɵnov"](_v, 35).ngClassPending; _ck(_v, 30, 0, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17, currVal_18); var currVal_20 = core["ɵunv"](_v, 39, 0, core["ɵnov"](_v, 40).transform("externalURL")); _ck(_v, 39, 0, currVal_20); var currVal_21 = core["ɵnov"](_v, 48).ngClassUntouched; var currVal_22 = core["ɵnov"](_v, 48).ngClassTouched; var currVal_23 = core["ɵnov"](_v, 48).ngClassPristine; var currVal_24 = core["ɵnov"](_v, 48).ngClassDirty; var currVal_25 = core["ɵnov"](_v, 48).ngClassValid; var currVal_26 = core["ɵnov"](_v, 48).ngClassInvalid; var currVal_27 = core["ɵnov"](_v, 48).ngClassPending; _ck(_v, 43, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27); var currVal_30 = core["ɵunv"](_v, 61, 0, core["ɵnov"](_v, 62).transform("cancelProcess")); _ck(_v, 61, 0, currVal_30); var currVal_31 = core["ɵunv"](_v, 64, 0, core["ɵnov"](_v, 65).transform("Save")); _ck(_v, 64, 0, currVal_31); });
}
function View_AddOperationComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "add-operation", [], null, null, null, View_AddOperationComponent_0, RenderType_AddOperationComponent)), core["ɵdid"](1, 49152, null, 0, AddOperationComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], NgbActiveModal, SharedData], null, null)], null, null); }
var AddOperationComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("add-operation", AddOperationComponent, View_AddOperationComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/superAdmin/createMobileApplication.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_angular_forms,_createMobileApplication,_angular_router,_shared_permissions_permissions,_shared_services_configuration,_shared_services_http.client,_toasterComponent_toasterComponent,_angular_common,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_shared_sharedData PURE_IMPORTS_END */












var styles_CreateMobileComponent = [];
var RenderType_CreateMobileComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_CreateMobileComponent, data: {} });

function View_CreateMobileComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.activeModal.dismiss("Cross click") !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 81, "div", [["class", "w-100 float-left p-4 modal-body advanced-mode"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](9, 0, null, null, 11, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](10, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](11, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](13, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](15, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 16)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 16).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 16)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 16)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mobileAppData.mobileAppName = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](16, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](18, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](20, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](21, 0, null, null, 12, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](22, 0, null, null, 11, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 4, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](24, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](26, 0, null, null, 1, "span", [["class", "text-danger medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["*"])), (_l()(), core["ɵeld"](28, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 29)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 29).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 29)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 29)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mobileAppData.mobileAppKey = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](29, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](31, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { isDisabled: [0, "isDisabled"], model: [1, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](33, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](34, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](35, 0, null, null, 9, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](36, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](37, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](39, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 40)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 40).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 40)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 40)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mobileAppData.versionAndroid = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](40, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](42, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](44, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](45, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](46, 0, null, null, 9, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](47, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](48, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](50, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 51)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 51).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 51)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 51)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mobileAppData.versionIos = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](51, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](53, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](55, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](56, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](57, 0, null, null, 9, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](58, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](59, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](61, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 62)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 62).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 62)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 62)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mobileAppData.fireBaseKey = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](62, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](64, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](66, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](67, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](68, 0, null, null, 9, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](69, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](70, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](72, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 73)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 73).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 73)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 73)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mobileAppData.redirectUrlAndroid = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](73, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](75, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](77, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](78, 0, null, null, 10, "div", [["class", "col-lg-6 col-md-6 float-left"]], null, null, null, null, null)), (_l()(), core["ɵeld"](79, 0, null, null, 9, "div", [["class", "form-group w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](80, 0, null, null, 2, "label", [], null, null, null, null, null)), (_l()(), core["ɵted"](81, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](83, 0, null, null, 5, "input", [["class", "form-control"], ["type", "text"]], [[2, "ng-untouched", null], [2, "ng-touched", null], [2, "ng-pristine", null], [2, "ng-dirty", null], [2, "ng-valid", null], [2, "ng-invalid", null], [2, "ng-pending", null]], [[null, "ngModelChange"], [null, "input"], [null, "blur"], [null, "compositionstart"], [null, "compositionend"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("input" === en)) {
                var pd_0 = (core["ɵnov"](_v, 84)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (("blur" === en)) {
                var pd_1 = (core["ɵnov"](_v, 84).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (("compositionstart" === en)) {
                var pd_2 = (core["ɵnov"](_v, 84)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (("compositionend" === en)) {
                var pd_3 = (core["ɵnov"](_v, 84)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (("ngModelChange" === en)) {
                var pd_4 = ((_co.mobileAppData.redirectUrlIos = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](84, 16384, null, 0, fesm5_forms["DefaultValueAccessor"], [core["Renderer2"], core["ElementRef"], [2, fesm5_forms["COMPOSITION_BUFFER_MODE"]]], null, null), core["ɵprd"](1024, null, fesm5_forms["NG_VALUE_ACCESSOR"], function (p0_0) { return [p0_0]; }, [fesm5_forms["DefaultValueAccessor"]]), core["ɵdid"](86, 671744, null, 0, fesm5_forms["NgModel"], [[8, null], [8, null], [8, null], [6, fesm5_forms["NG_VALUE_ACCESSOR"]]], { model: [0, "model"] }, { update: "ngModelChange" }), core["ɵprd"](2048, null, fesm5_forms["NgControl"], null, [fesm5_forms["NgModel"]]), core["ɵdid"](88, 16384, null, 0, fesm5_forms["NgControlStatus"], [[4, fesm5_forms["NgControl"]]], null, null), (_l()(), core["ɵeld"](89, 0, null, null, 6, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](90, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.cancel() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](91, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](93, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.save() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](94, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_9 = _co.mobileAppData.mobileAppName; _ck(_v, 18, 0, currVal_9); var currVal_18 = _co.isUpdate; var currVal_19 = _co.mobileAppData.mobileAppKey; _ck(_v, 31, 0, currVal_18, currVal_19); var currVal_28 = _co.mobileAppData.versionAndroid; _ck(_v, 42, 0, currVal_28); var currVal_37 = _co.mobileAppData.versionIos; _ck(_v, 53, 0, currVal_37); var currVal_46 = _co.mobileAppData.fireBaseKey; _ck(_v, 64, 0, currVal_46); var currVal_55 = _co.mobileAppData.redirectUrlAndroid; _ck(_v, 75, 0, currVal_55); var currVal_64 = _co.mobileAppData.redirectUrlIos; _ck(_v, 86, 0, currVal_64); }, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("createMobileApp")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 11, 0, core["ɵnov"](_v, 12).transform("appName")); _ck(_v, 11, 0, currVal_1); var currVal_2 = core["ɵnov"](_v, 20).ngClassUntouched; var currVal_3 = core["ɵnov"](_v, 20).ngClassTouched; var currVal_4 = core["ɵnov"](_v, 20).ngClassPristine; var currVal_5 = core["ɵnov"](_v, 20).ngClassDirty; var currVal_6 = core["ɵnov"](_v, 20).ngClassValid; var currVal_7 = core["ɵnov"](_v, 20).ngClassInvalid; var currVal_8 = core["ɵnov"](_v, 20).ngClassPending; _ck(_v, 15, 0, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6, currVal_7, currVal_8); var currVal_10 = core["ɵunv"](_v, 24, 0, core["ɵnov"](_v, 25).transform("appKey")); _ck(_v, 24, 0, currVal_10); var currVal_11 = core["ɵnov"](_v, 33).ngClassUntouched; var currVal_12 = core["ɵnov"](_v, 33).ngClassTouched; var currVal_13 = core["ɵnov"](_v, 33).ngClassPristine; var currVal_14 = core["ɵnov"](_v, 33).ngClassDirty; var currVal_15 = core["ɵnov"](_v, 33).ngClassValid; var currVal_16 = core["ɵnov"](_v, 33).ngClassInvalid; var currVal_17 = core["ɵnov"](_v, 33).ngClassPending; _ck(_v, 28, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17); var currVal_20 = core["ɵunv"](_v, 37, 0, core["ɵnov"](_v, 38).transform("androidVer")); _ck(_v, 37, 0, currVal_20); var currVal_21 = core["ɵnov"](_v, 44).ngClassUntouched; var currVal_22 = core["ɵnov"](_v, 44).ngClassTouched; var currVal_23 = core["ɵnov"](_v, 44).ngClassPristine; var currVal_24 = core["ɵnov"](_v, 44).ngClassDirty; var currVal_25 = core["ɵnov"](_v, 44).ngClassValid; var currVal_26 = core["ɵnov"](_v, 44).ngClassInvalid; var currVal_27 = core["ɵnov"](_v, 44).ngClassPending; _ck(_v, 39, 0, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26, currVal_27); var currVal_29 = core["ɵunv"](_v, 48, 0, core["ɵnov"](_v, 49).transform("iosVer")); _ck(_v, 48, 0, currVal_29); var currVal_30 = core["ɵnov"](_v, 55).ngClassUntouched; var currVal_31 = core["ɵnov"](_v, 55).ngClassTouched; var currVal_32 = core["ɵnov"](_v, 55).ngClassPristine; var currVal_33 = core["ɵnov"](_v, 55).ngClassDirty; var currVal_34 = core["ɵnov"](_v, 55).ngClassValid; var currVal_35 = core["ɵnov"](_v, 55).ngClassInvalid; var currVal_36 = core["ɵnov"](_v, 55).ngClassPending; _ck(_v, 50, 0, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35, currVal_36); var currVal_38 = core["ɵunv"](_v, 59, 0, core["ɵnov"](_v, 60).transform("firebaseKey")); _ck(_v, 59, 0, currVal_38); var currVal_39 = core["ɵnov"](_v, 66).ngClassUntouched; var currVal_40 = core["ɵnov"](_v, 66).ngClassTouched; var currVal_41 = core["ɵnov"](_v, 66).ngClassPristine; var currVal_42 = core["ɵnov"](_v, 66).ngClassDirty; var currVal_43 = core["ɵnov"](_v, 66).ngClassValid; var currVal_44 = core["ɵnov"](_v, 66).ngClassInvalid; var currVal_45 = core["ɵnov"](_v, 66).ngClassPending; _ck(_v, 61, 0, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45); var currVal_47 = core["ɵunv"](_v, 70, 0, core["ɵnov"](_v, 71).transform("redirectUrlAndroid")); _ck(_v, 70, 0, currVal_47); var currVal_48 = core["ɵnov"](_v, 77).ngClassUntouched; var currVal_49 = core["ɵnov"](_v, 77).ngClassTouched; var currVal_50 = core["ɵnov"](_v, 77).ngClassPristine; var currVal_51 = core["ɵnov"](_v, 77).ngClassDirty; var currVal_52 = core["ɵnov"](_v, 77).ngClassValid; var currVal_53 = core["ɵnov"](_v, 77).ngClassInvalid; var currVal_54 = core["ɵnov"](_v, 77).ngClassPending; _ck(_v, 72, 0, currVal_48, currVal_49, currVal_50, currVal_51, currVal_52, currVal_53, currVal_54); var currVal_56 = core["ɵunv"](_v, 81, 0, core["ɵnov"](_v, 82).transform("redirectUrliOS")); _ck(_v, 81, 0, currVal_56); var currVal_57 = core["ɵnov"](_v, 88).ngClassUntouched; var currVal_58 = core["ɵnov"](_v, 88).ngClassTouched; var currVal_59 = core["ɵnov"](_v, 88).ngClassPristine; var currVal_60 = core["ɵnov"](_v, 88).ngClassDirty; var currVal_61 = core["ɵnov"](_v, 88).ngClassValid; var currVal_62 = core["ɵnov"](_v, 88).ngClassInvalid; var currVal_63 = core["ɵnov"](_v, 88).ngClassPending; _ck(_v, 83, 0, currVal_57, currVal_58, currVal_59, currVal_60, currVal_61, currVal_62, currVal_63); var currVal_65 = core["ɵunv"](_v, 91, 0, core["ɵnov"](_v, 92).transform("cancelProcess")); _ck(_v, 91, 0, currVal_65); var currVal_66 = core["ɵunv"](_v, 94, 0, core["ɵnov"](_v, 95).transform("Save")); _ck(_v, 94, 0, currVal_66); });
}
function View_CreateMobileComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "create-mobile-application", [], null, null, null, View_CreateMobileComponent_0, RenderType_CreateMobileComponent)), core["ɵdid"](1, 49152, null, 0, createMobileApplication_CreateMobileComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], common["Location"], NgbActiveModal, SharedData], null, null)], null, null); }
var CreateMobileComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("create-mobile-application", createMobileApplication_CreateMobileComponent, View_CreateMobileComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/superAdmin/deleteMobileApplication.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_ngx_translate_core,_deleteMobileApplication,_angular_router,_shared_permissions_permissions,_shared_services_configuration,_shared_services_http.client,_toasterComponent_toasterComponent,_angular_common,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_shared_sharedData PURE_IMPORTS_END */











var styles_DeleteMobileComponent = [];
var RenderType_DeleteMobileComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_DeleteMobileComponent, data: {} });

function View_DeleteMobileComponent_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 6, "div", [["class", "modal-header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 2, "h6", [["class", "modal-title medium"]], null, null, null, null, null)), (_l()(), core["ɵted"](2, null, ["", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](4, 0, null, null, 2, "button", [["aria-label", "Close"], ["class", "close"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.close(false) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 1, "span", [["aria-hidden", "true"]], null, null, null, null, null)), (_l()(), core["ɵted"](-1, null, ["\u00D7"])), (_l()(), core["ɵeld"](7, 0, null, null, 3, "div", [["class", "w-100 float-left p-4 modal-body advanced-mode"]], null, null, null, null, null)), (_l()(), core["ɵeld"](8, 0, null, null, 2, "h6", [], null, null, null, null, null)), (_l()(), core["ɵted"](9, null, [" ", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](11, 0, null, null, 6, "div", [["class", "modal-footer"]], null, null, null, null, null)), (_l()(), core["ɵeld"](12, 0, null, null, 2, "button", [["class", "btn btn-secondary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.close(false) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](13, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]]), (_l()(), core["ɵeld"](15, 0, null, null, 2, "button", [["class", "btn btn-primary float-right"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.close(true) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](16, null, [" ", ""])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], null, function (_ck, _v) { var currVal_0 = core["ɵunv"](_v, 2, 0, core["ɵnov"](_v, 3).transform("deleteMobileApp")); _ck(_v, 2, 0, currVal_0); var currVal_1 = core["ɵunv"](_v, 9, 0, core["ɵnov"](_v, 10).transform("sureWantToDelete")); _ck(_v, 9, 0, currVal_1); var currVal_2 = core["ɵunv"](_v, 13, 0, core["ɵnov"](_v, 14).transform("close")); _ck(_v, 13, 0, currVal_2); var currVal_3 = core["ɵunv"](_v, 16, 0, core["ɵnov"](_v, 17).transform("delete")); _ck(_v, 16, 0, currVal_3); });
}
function View_DeleteMobileComponent_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "delete-mobile-application", [], null, null, null, View_DeleteMobileComponent_0, RenderType_DeleteMobileComponent)), core["ɵdid"](1, 49152, null, 0, DeleteMobileComponent, [fesm5_router["l" /* Router */], PermissionHelper, Configuration, http_client_HttpClientCustom, core_es5["j" /* TranslateService */], ToasterComponent, core["ViewContainerRef"], common["Location"], NgbActiveModal, SharedData], null, null)], null, null); }
var DeleteMobileComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("delete-mobile-application", DeleteMobileComponent, View_DeleteMobileComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/app.component.css.ngstyle.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var app_component_css_ngstyle_styles = ["\n"];



// CONCATENATED MODULE: ./src/app/header/header.ts








var header_Header = /** @class */ (function () {
    // userInfo = {localeName:null};
    function Header(route, _auth, translate, _global, share, http, modalService, router) {
        var _this = this;
        this.route = route;
        this._auth = _auth;
        this.translate = translate;
        this._global = _global;
        this.share = share;
        this.http = http;
        this.modalService = modalService;
        this.router = router;
        this.isNavbarCollapsed = false;
        this.openSubMenu = false;
        this.allLanguage = [];
        var result = JSON.parse(window.localStorage.getItem('userInfo'));
        this._appUrl = _global.get('USER_APP_URL');
        this._biUrl = _global.get('BI_BASE_URL');
        this.displayName = result.displayName;
        this._baseUrl = this._global.get('EPMS_BASE_URL');
        this.getLang();
        // this.getupdatedtenantImage();
        this._auth.updateProfilePic.subscribe(function (userInfo) { return _this.saveUserChanges(userInfo); });
        this.getEmp();
    }
    Header.prototype.saveUserChanges = function (userInfo) {
        this.userInfo = userInfo;
        this.tenantImage = userInfo.tenantImageUrl;
        console.log(userInfo);
    };
    Header.prototype.openSubNavbar = function () {
        this.openSubMenu = !this.openSubMenu;
    };
    Header.prototype.closeSubNavbar = function () {
        this.openSubMenu = false;
        this.isNavbarCollapsed = false;
    };
    Header.prototype.hubClicked = function () {
        window.location.href = this._appUrl + "/";
    };
    Header.prototype.logout = function () {
        var _this = this;
        var confirmData = {
            type: 'logOut',
            program: null
        };
        this.share.saveData(confirmData);
        var modalRef = this.modalService.open(confirmation_ConfirmationComponent, { windowClass: 'min-modal' }).result.then(function (result) {
            if (result === 'confirmed') {
                _this._auth.logout();
            }
        }, function (reason) {
            console.log(reason);
        });
    };
    Header.prototype.dashboardClicked = function () {
        window.location.href = this._appUrl + '/#/dashboard';
    };
    Header.prototype.getLang = function () {
        var _this = this;
        this.getAllLanguage().subscribe(function (result) {
            _this.allLanguage = result;
        });
    };
    Header.prototype.getAllLanguage = function () {
        var self = this;
        var url = self._baseUrl + 'v1/hub/settings/getAllLang';
        return self.http.get(url);
    };
    Header.prototype.selectLanguage = function (language) {
        this.selectedlanguage = language.locale;
        this.saveLanguageSelected();
    };
    Header.prototype.saveLanguageSelected = function () {
        var _this = this;
        this.changeToSelectedLanguage(this.selectedlanguage).subscribe(function (res) {
            _this.getEmp();
        });
    };
    Header.prototype.changeToSelectedLanguage = function (selectedLanguage) {
        var self = this;
        var url = self._baseUrl + 'v1/hub/changeLocale?locale=' + selectedLanguage;
        return this.http.post(url, selectedLanguage);
    };
    Header.prototype.getEmp = function () {
        var _this = this;
        this.getEmployeeDetail().subscribe(function (res) {
            console.log(res);
            _this.tenantImage = res.tenantImageUrl;
            if (environment["a" /* environment */].client == 'KEA') {
                if (res.tenantName) {
                    document.title = res.tenantName;
                }
            }
            _this.upDateLang(res.localeName);
        });
    };
    Header.prototype.getEmployeeDetail = function () {
        console.log('HEADER');
        return this.http.get(this._baseUrl + 'v1/hub/employeeInfo');
    };
    Header.prototype.upDateLang = function (lang) {
        var userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        userInfo.localeName = lang;
        this.checkLanguage = userInfo.localeName;
        this.upDateUserFromSettingPage(userInfo);
        this.translate.use(lang);
        document.documentElement.setAttribute('lang', lang);
    };
    Header.prototype.upDateUserFromSettingPage = function (userInfo) {
        this._userInfo = userInfo;
        window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
    };
    return Header;
}());


// CONCATENATED MODULE: ./src/app/header/header.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_common,_ng_bootstrap_ng_bootstrap_collapse_collapse,_ng_bootstrap_ng_bootstrap_dropdown_dropdown,_ng_bootstrap_ng_bootstrap_dropdown_dropdown_config,_angular_router,_ngx_translate_core,_header,_shared_services_auth,_shared_services_configuration,_shared_sharedData,_shared_services_http.client,_ng_bootstrap_ng_bootstrap_modal_modal PURE_IMPORTS_END */













var styles_Header = [];
var RenderType_Header = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_Header, data: {} });

function View_Header_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "img", [["style", "height:40px"]], [[8, "src", 4]], null, null, null, null))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.tenantImage; _ck(_v, 0, 0, currVal_0); }); }
function View_Header_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 0, "div", [["class", "logo"]], null, null, null, null, null))], null, null); }
function View_Header_3(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "a", [["class", "dropdown-item b py-2 px-4 text-nowrap c-p d-flex justify-content-between m-0"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.selectLanguage(_v.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵted"](1, null, ["", " "]))], null, function (_ck, _v) { var currVal_0 = _v.context.$implicit.name; _ck(_v, 1, 0, currVal_0); });
}
function View_Header_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 41, "div", [["class", "header"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 40, "nav", [["class", "navbar navbar-toggleable-md navbar-light bg-faded"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 39, "div", [["class", "container w-100"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 3, "button", [["aria-controls", "exCollapsingNavbar2"], ["aria-expanded", "false"], ["aria-label", "Toggle navigation"], ["class", "navbar-toggler navbar-toggler-right"], ["type", "button"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = ((_co.isNavbarCollapsed = !_co.isNavbarCollapsed) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "span", [["class", "icon-bar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](5, 0, null, null, 0, "span", [["class", "icon-bar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](6, 0, null, null, 0, "span", [["class", "icon-bar"]], null, null, null, null, null)), (_l()(), core["ɵeld"](7, 0, null, null, 4, "a", [["class", "navbar-brand p-h-l-xmd cursor"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.hubClicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Header_1)), core["ɵdid"](9, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Header_2)), core["ɵdid"](11, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵeld"](12, 0, null, null, 0, "div", [["style", "flex-grow: 1;"]], null, null, null, null, null)), (_l()(), core["ɵeld"](13, 0, null, null, 28, "div", [["class", "collapse navbar-collapse"], ["id", "exCollapsingNavbar2"]], [[2, "collapse", null], [2, "show", null]], null, null, null, null)), core["ɵdid"](14, 16384, null, 0, NgbCollapse, [], { collapsed: [0, "collapsed"] }, null), (_l()(), core["ɵeld"](15, 0, null, null, 26, "div", [["class", "navbar-nav pull-right"]], null, null, null, null, null)), (_l()(), core["ɵeld"](16, 0, null, null, 1, "a", [["class", "nav-item nav-link pull-left cursor p-0 d-flex align-items-center"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.hubClicked() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), core["ɵeld"](17, 0, null, null, 0, "i", [["class", "fonticon-home m-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](18, 0, null, null, 3, "a", [["class", "nav-item nav-link pull-left cursor p-0"]], null, null, null, null, null)), (_l()(), core["ɵeld"](19, 0, null, null, 0, "i", [["class", "fa fa-user-circle-o m-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](20, 0, null, null, 1, "span", [["class", "hide-txt"]], null, null, null, null, null)), (_l()(), core["ɵted"](21, null, ["", " "])), (_l()(), core["ɵeld"](22, 0, null, null, 11, "li", [["class", "nav-item nav-link pull-left cursor p-0 d-flex align-items-center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](23, 0, null, null, 10, "div", [["class", "d-inline-block"], ["ngbDropdown", ""], ["placement", "bottom-right"]], [[2, "show", null]], null, null, null, null)), core["ɵdid"](24, 212992, null, 2, dropdown_NgbDropdown, [core["ChangeDetectorRef"], NgbDropdownConfig, common["DOCUMENT"], core["NgZone"]], { placement: [0, "placement"] }, null), core["ɵqud"](335544320, 1, { _menu: 0 }), core["ɵqud"](335544320, 2, { _anchor: 0 }), (_l()(), core["ɵeld"](27, 0, null, null, 2, "i", [["aria-haspopup", "true"], ["class", "fonticon-language m-2 dropdown-toggle"], ["id", "dropdownBasic1"], ["ngbDropdownToggle", ""]], [[1, "aria-expanded", 0]], [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            if (("click" === en)) {
                var pd_0 = (core["ɵnov"](_v, 28).toggleOpen() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](28, 16384, null, 0, NgbDropdownToggle, [dropdown_NgbDropdown, core["ElementRef"]], null, null), core["ɵprd"](2048, [[2, 4]], NgbDropdownAnchor, null, [NgbDropdownToggle]), (_l()(), core["ɵeld"](30, 0, null, null, 3, "div", [["aria-labelledby", "dropdownBasic1"], ["ngbDropdownMenu", ""]], [[2, "dropdown-menu", null], [2, "show", null], [1, "x-placement", 0]], null, null, null, null)), core["ɵdid"](31, 16384, [[1, 4]], 0, dropdown_NgbDropdownMenu, [dropdown_NgbDropdown, core["ElementRef"], core["Renderer2"]], null, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_Header_3)), core["ɵdid"](33, 278528, null, 0, common["NgForOf"], [core["ViewContainerRef"], core["TemplateRef"], core["IterableDiffers"]], { ngForOf: [0, "ngForOf"] }, null), (_l()(), core["ɵeld"](34, 0, null, null, 7, "a", [["class", "nav-item nav-link pull-left cursor p-0"], ["routerLinkActive", "active"]], null, [[null, "click"]], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (("click" === en)) {
                var pd_0 = (_co.logout() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), core["ɵdid"](35, 1720320, null, 2, fesm5_router["m" /* RouterLinkActive */], [fesm5_router["l" /* Router */], core["ElementRef"], core["Renderer2"], core["ChangeDetectorRef"]], { routerLinkActive: [0, "routerLinkActive"] }, null), core["ɵqud"](603979776, 3, { links: 1 }), core["ɵqud"](603979776, 4, { linksWithHrefs: 1 }), (_l()(), core["ɵeld"](38, 0, null, null, 0, "i", [["class", "fa fa-power-off m-2"]], null, null, null, null, null)), (_l()(), core["ɵeld"](39, 0, null, null, 2, "span", [["class", "hide-txt"]], null, null, null, null, null)), (_l()(), core["ɵted"](40, null, ["", " "])), core["ɵpid"](131072, core_es5["i" /* TranslatePipe */], [core_es5["j" /* TranslateService */], core["ChangeDetectorRef"]])], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.tenantImage; _ck(_v, 9, 0, currVal_0); var currVal_1 = !_co.tenantImage; _ck(_v, 11, 0, currVal_1); var currVal_4 = !_co.isNavbarCollapsed; _ck(_v, 14, 0, currVal_4); var currVal_7 = "bottom-right"; _ck(_v, 24, 0, currVal_7); var currVal_12 = _co.allLanguage; _ck(_v, 33, 0, currVal_12); var currVal_13 = "active"; _ck(_v, 35, 0, currVal_13); }, function (_ck, _v) { var _co = _v.component; var currVal_2 = true; var currVal_3 = !core["ɵnov"](_v, 14).collapsed; _ck(_v, 13, 0, currVal_2, currVal_3); var currVal_5 = _co.displayName; _ck(_v, 21, 0, currVal_5); var currVal_6 = core["ɵnov"](_v, 24).isOpen(); _ck(_v, 23, 0, currVal_6); var currVal_8 = core["ɵnov"](_v, 28).dropdown.isOpen(); _ck(_v, 27, 0, currVal_8); var currVal_9 = true; var currVal_10 = core["ɵnov"](_v, 31).dropdown.isOpen(); var currVal_11 = core["ɵnov"](_v, 31).placement; _ck(_v, 30, 0, currVal_9, currVal_10, currVal_11); var currVal_14 = core["ɵunv"](_v, 40, 0, core["ɵnov"](_v, 41).transform("logout")); _ck(_v, 40, 0, currVal_14); });
}
function View_Header_Host_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "header", [], null, null, null, View_Header_0, RenderType_Header)), core["ɵdid"](1, 49152, null, 0, header_Header, [fesm5_router["a" /* ActivatedRoute */], auth_Auth, core_es5["j" /* TranslateService */], Configuration, SharedData, http_client_HttpClientCustom, NgbModal, fesm5_router["l" /* Router */]], null, null)], null, null); }
var HeaderNgFactory = /*@__PURE__*/ core["ɵccf"]("header", header_Header, View_Header_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./src/app/app.component.ngfactory.js
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _app.component.css.ngstyle,_angular_core,_header_header.ngfactory,_header_header,_angular_router,_shared_services_auth,_ngx_translate_core,_shared_services_configuration,_shared_sharedData,_shared_services_http.client,_ng_bootstrap_ng_bootstrap_modal_modal,_angular_common,_app.component,_app.service,_shared_permissions_permissions PURE_IMPORTS_END */















var styles_AppComponent = [app_component_css_ngstyle_styles];
var RenderType_AppComponent = /*@__PURE__*/ core["ɵcrt"]({ encapsulation: 2, styles: styles_AppComponent, data: {} });

function View_AppComponent_1(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "header", [], null, null, null, View_Header_0, RenderType_Header)), core["ɵdid"](1, 49152, null, 0, header_Header, [fesm5_router["a" /* ActivatedRoute */], auth_Auth, core_es5["j" /* TranslateService */], Configuration, SharedData, http_client_HttpClientCustom, NgbModal, fesm5_router["l" /* Router */]], null, null)], null, null); }
function View_AppComponent_2(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), core["ɵdid"](1, 212992, null, 0, fesm5_router["p" /* RouterOutlet */], [fesm5_router["b" /* ChildrenOutletContexts */], core["ViewContainerRef"], core["ComponentFactoryResolver"], [8, null], core["ChangeDetectorRef"]], null, null), (_l()(), core["ɵand"](0, null, null, 0))], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
function View_AppComponent_3(_l) { return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 4, "div", [["class", "loading1"]], null, null, null, null, null)), (_l()(), core["ɵeld"](1, 0, null, null, 1, "div", [["style", "position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center"]], null, null, null, null, null)), (_l()(), core["ɵeld"](2, 0, null, null, 0, "img", [["alt", "loading"], ["src", "./assets/img/load.gif"], ["width", "80px"]], null, null, null, null, null)), (_l()(), core["ɵeld"](3, 0, null, null, 1, "div", [["class", "loader-div"]], null, null, null, null, null)), (_l()(), core["ɵeld"](4, 0, null, null, 0, "div", [["class", "loader-gif"]], null, null, null, null, null))], null, null); }
function View_AppComponent_0(_l) { return core["ɵvid"](0, [(_l()(), core["ɵand"](16777216, null, null, 1, null, View_AppComponent_1)), core["ɵdid"](1, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AppComponent_2)), core["ɵdid"](3, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null), (_l()(), core["ɵand"](16777216, null, null, 1, null, View_AppComponent_3)), core["ɵdid"](5, 16384, null, 0, common["NgIf"], [core["ViewContainerRef"], core["TemplateRef"]], { ngIf: [0, "ngIf"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.loadTabs; _ck(_v, 1, 0, currVal_0); var currVal_1 = _co.loadTabs; _ck(_v, 3, 0, currVal_1); var currVal_2 = _co.showLoading; _ck(_v, 5, 0, currVal_2); }, null); }
function View_AppComponent_Host_0(_l) {
    return core["ɵvid"](0, [(_l()(), core["ɵeld"](0, 0, null, null, 1, "app-root", [], null, [["window", "unload"], ["window", "beforeunload"]], function (_v, en, $event) {
            var ad = true;
            if (("window:unload" === en)) {
                var pd_0 = (core["ɵnov"](_v, 1).unloadHandler($event) !== false);
                ad = (pd_0 && ad);
            }
            if (("window:beforeunload" === en)) {
                var pd_1 = (core["ɵnov"](_v, 1).beforeUnloadHander($event) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, View_AppComponent_0, RenderType_AppComponent)), core["ɵdid"](1, 114688, null, 0, app_component_AppComponent, [AppState, auth_Auth, Configuration, http_client_HttpClientCustom, PermissionHelper, core_es5["j" /* TranslateService */]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null);
}
var AppComponentNgFactory = /*@__PURE__*/ core["ɵccf"]("app-root", app_component_AppComponent, View_AppComponent_Host_0, {}, {}, []);



// CONCATENATED MODULE: ./node_modules/@angular/animations/fesm5/browser.js
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START tslib,_angular_animations,_angular_core PURE_IMPORTS_END */



function isBrowser() {
    return (typeof window !== 'undefined' && typeof window.document !== 'undefined');
}
function isNode() {
    return (typeof process !== 'undefined');
}
function optimizeGroupPlayer(players) {
    switch (players.length) {
        case 0:
            return new NoopAnimationPlayer();
        case 1:
            return players[0];
        default:
            return new AnimationGroupPlayer(players);
    }
}
function normalizeKeyframes(driver, normalizer, element, keyframes, preStyles, postStyles) {
    if (preStyles === void 0) {
        preStyles = {};
    }
    if (postStyles === void 0) {
        postStyles = {};
    }
    var errors = [];
    var normalizedKeyframes = [];
    var previousOffset = -1;
    var previousKeyframe = null;
    keyframes.forEach(function (kf) {
        var offset = kf['offset'];
        var isSameOffset = offset == previousOffset;
        var normalizedKeyframe = (isSameOffset && previousKeyframe) || {};
        Object.keys(kf).forEach(function (prop) {
            var normalizedProp = prop;
            var normalizedValue = kf[prop];
            if (prop !== 'offset') {
                normalizedProp = normalizer.normalizePropertyName(normalizedProp, errors);
                switch (normalizedValue) {
                    case ɵPRE_STYLE:
                        normalizedValue = preStyles[prop];
                        break;
                    case AUTO_STYLE:
                        normalizedValue = postStyles[prop];
                        break;
                    default:
                        normalizedValue =
                            normalizer.normalizeStyleValue(prop, normalizedProp, normalizedValue, errors);
                        break;
                }
            }
            normalizedKeyframe[normalizedProp] = normalizedValue;
        });
        if (!isSameOffset) {
            normalizedKeyframes.push(normalizedKeyframe);
        }
        previousKeyframe = normalizedKeyframe;
        previousOffset = offset;
    });
    if (errors.length) {
        var LINE_START = '\n - ';
        throw new Error("Unable to animate due to the following errors:" + LINE_START + errors.join(LINE_START));
    }
    return normalizedKeyframes;
}
function listenOnPlayer(player, eventName, event, callback) {
    switch (eventName) {
        case 'start':
            player.onStart(function () { return callback(event && copyAnimationEvent(event, 'start', player)); });
            break;
        case 'done':
            player.onDone(function () { return callback(event && copyAnimationEvent(event, 'done', player)); });
            break;
        case 'destroy':
            player.onDestroy(function () { return callback(event && copyAnimationEvent(event, 'destroy', player)); });
            break;
    }
}
function copyAnimationEvent(e, phaseName, player) {
    var totalTime = player.totalTime;
    var disabled = player.disabled ? true : false;
    var event = makeAnimationEvent(e.element, e.triggerName, e.fromState, e.toState, phaseName || e.phaseName, totalTime == undefined ? e.totalTime : totalTime, disabled);
    var data = e['_data'];
    if (data != null) {
        event['_data'] = data;
    }
    return event;
}
function makeAnimationEvent(element, triggerName, fromState, toState, phaseName, totalTime, disabled) {
    if (phaseName === void 0) {
        phaseName = '';
    }
    if (totalTime === void 0) {
        totalTime = 0;
    }
    return { element: element, triggerName: triggerName, fromState: fromState, toState: toState, phaseName: phaseName, totalTime: totalTime, disabled: !!disabled };
}
function getOrSetAsInMap(map, key, defaultValue) {
    var value;
    if (map instanceof Map) {
        value = map.get(key);
        if (!value) {
            map.set(key, value = defaultValue);
        }
    }
    else {
        value = map[key];
        if (!value) {
            value = map[key] = defaultValue;
        }
    }
    return value;
}
function parseTimelineCommand(command) {
    var separatorPos = command.indexOf(':');
    var id = command.substring(1, separatorPos);
    var action = command.substr(separatorPos + 1);
    return [id, action];
}
var _contains = function (elm1, elm2) { return false; };
var _matches = function (element, selector) {
    return false;
};
var _query = function (element, selector, multi) {
    return [];
};
// Define utility methods for browsers and platform-server(domino) where Element
// and utility methods exist.
var _isNode = /*@__PURE__*/ isNode();
if (_isNode || typeof Element !== 'undefined') {
    // this is well supported in all browsers
    _contains = function (elm1, elm2) { return elm1.contains(elm2); };
    if (_isNode || Element.prototype.matches) {
        _matches = function (element, selector) { return element.matches(selector); };
    }
    else {
        var proto = Element.prototype;
        var fn_1 = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector ||
            proto.oMatchesSelector || proto.webkitMatchesSelector;
        if (fn_1) {
            _matches = function (element, selector) { return fn_1.apply(element, [selector]); };
        }
    }
    _query = function (element, selector, multi) {
        var results = [];
        if (multi) {
            results.push.apply(results, Object(tslib_es6["__spread"])(element.querySelectorAll(selector)));
        }
        else {
            var elm = element.querySelector(selector);
            if (elm) {
                results.push(elm);
            }
        }
        return results;
    };
}
function containsVendorPrefix(prop) {
    // Webkit is the only real popular vendor prefix nowadays
    // cc: http://shouldiprefix.com/
    return prop.substring(1, 6) == 'ebkit'; // webkit or Webkit
}
var _CACHED_BODY = null;
var _IS_WEBKIT = false;
function validateStyleProperty(prop) {
    if (!_CACHED_BODY) {
        _CACHED_BODY = getBodyNode() || {};
        _IS_WEBKIT = _CACHED_BODY.style ? ('WebkitAppearance' in _CACHED_BODY.style) : false;
    }
    var result = true;
    if (_CACHED_BODY.style && !containsVendorPrefix(prop)) {
        result = prop in _CACHED_BODY.style;
        if (!result && _IS_WEBKIT) {
            var camelProp = 'Webkit' + prop.charAt(0).toUpperCase() + prop.substr(1);
            result = camelProp in _CACHED_BODY.style;
        }
    }
    return result;
}
function getBodyNode() {
    if (typeof document != 'undefined') {
        return document.body;
    }
    return null;
}
var matchesElement = _matches;
var containsElement = _contains;
var invokeQuery = _query;
function hypenatePropsObject(object) {
    var newObj = {};
    Object.keys(object).forEach(function (prop) {
        var newProp = prop.replace(/([a-z])([A-Z])/g, '$1-$2');
        newObj[newProp] = object[prop];
    });
    return newObj;
}
/**
 * @experimental
 */
var browser_NoopAnimationDriver = /*@__PURE__*/ (function () {
    function NoopAnimationDriver() {
    }
    NoopAnimationDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
    NoopAnimationDriver.prototype.matchesElement = function (element, selector) {
        return matchesElement(element, selector);
    };
    NoopAnimationDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
    NoopAnimationDriver.prototype.query = function (element, selector, multi) {
        return invokeQuery(element, selector, multi);
    };
    NoopAnimationDriver.prototype.computeStyle = function (element, prop, defaultValue) {
        return defaultValue || '';
    };
    NoopAnimationDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
        if (previousPlayers === void 0) {
            previousPlayers = [];
        }
        return new NoopAnimationPlayer(duration, delay);
    };
    return NoopAnimationDriver;
}());
/**
 * @experimental
 */
var AnimationDriver = /*@__PURE__*/ (function () {
    function AnimationDriver() {
    }
    AnimationDriver.NOOP = new browser_NoopAnimationDriver();
    return AnimationDriver;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ONE_SECOND = 1000;
var SUBSTITUTION_EXPR_START = '{{';
var SUBSTITUTION_EXPR_END = '}}';
var ENTER_CLASSNAME = 'ng-enter';
var LEAVE_CLASSNAME = 'ng-leave';
var NG_TRIGGER_CLASSNAME = 'ng-trigger';
var NG_TRIGGER_SELECTOR = '.ng-trigger';
var NG_ANIMATING_CLASSNAME = 'ng-animating';
var NG_ANIMATING_SELECTOR = '.ng-animating';
function resolveTimingValue(value) {
    if (typeof value == 'number')
        return value;
    var matches = value.match(/^(-?[\.\d]+)(m?s)/);
    if (!matches || matches.length < 2)
        return 0;
    return _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
}
function _convertTimeValueToMS(value, unit) {
    switch (unit) {
        case 's':
            return value * ONE_SECOND;
        default:// ms or something else
            return value;
    }
}
function resolveTiming(timings, errors, allowNegativeValues) {
    return timings.hasOwnProperty('duration') ?
        timings :
        parseTimeExpression(timings, errors, allowNegativeValues);
}
function parseTimeExpression(exp, errors, allowNegativeValues) {
    var regex = /^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i;
    var duration;
    var delay = 0;
    var easing = '';
    if (typeof exp === 'string') {
        var matches = exp.match(regex);
        if (matches === null) {
            errors.push("The provided timing value \"" + exp + "\" is invalid.");
            return { duration: 0, delay: 0, easing: '' };
        }
        duration = _convertTimeValueToMS(parseFloat(matches[1]), matches[2]);
        var delayMatch = matches[3];
        if (delayMatch != null) {
            delay = _convertTimeValueToMS(Math.floor(parseFloat(delayMatch)), matches[4]);
        }
        var easingVal = matches[5];
        if (easingVal) {
            easing = easingVal;
        }
    }
    else {
        duration = exp;
    }
    if (!allowNegativeValues) {
        var containsErrors = false;
        var startIndex = errors.length;
        if (duration < 0) {
            errors.push("Duration values below 0 are not allowed for this animation step.");
            containsErrors = true;
        }
        if (delay < 0) {
            errors.push("Delay values below 0 are not allowed for this animation step.");
            containsErrors = true;
        }
        if (containsErrors) {
            errors.splice(startIndex, 0, "The provided timing value \"" + exp + "\" is invalid.");
        }
    }
    return { duration: duration, delay: delay, easing: easing };
}
function copyObj(obj, destination) {
    if (destination === void 0) {
        destination = {};
    }
    Object.keys(obj).forEach(function (prop) { destination[prop] = obj[prop]; });
    return destination;
}
function normalizeStyles(styles) {
    var normalizedStyles = {};
    if (Array.isArray(styles)) {
        styles.forEach(function (data) { return copyStyles(data, false, normalizedStyles); });
    }
    else {
        copyStyles(styles, false, normalizedStyles);
    }
    return normalizedStyles;
}
function copyStyles(styles, readPrototype, destination) {
    if (destination === void 0) {
        destination = {};
    }
    if (readPrototype) {
        // we make use of a for-in loop so that the
        // prototypically inherited properties are
        // revealed from the backFill map
        for (var prop in styles) {
            destination[prop] = styles[prop];
        }
    }
    else {
        copyObj(styles, destination);
    }
    return destination;
}
function getStyleAttributeString(element, key, value) {
    // Return the key-value pair string to be added to the style attribute for the
    // given CSS style key.
    if (value) {
        return key + ':' + value + ';';
    }
    else {
        return '';
    }
}
function writeStyleAttribute(element) {
    // Read the style property of the element and manually reflect it to the
    // style attribute. This is needed because Domino on platform-server doesn't
    // understand the full set of allowed CSS properties and doesn't reflect some
    // of them automatically.
    var styleAttrValue = '';
    for (var i = 0; i < element.style.length; i++) {
        var key = element.style.item(i);
        styleAttrValue += getStyleAttributeString(element, key, element.style.getPropertyValue(key));
    }
    for (var key in element.style) {
        // Skip internal Domino properties that don't need to be reflected.
        if (!element.style.hasOwnProperty(key) || key.startsWith('_')) {
            continue;
        }
        var dashKey = camelCaseToDashCase(key);
        styleAttrValue += getStyleAttributeString(element, dashKey, element.style[key]);
    }
    element.setAttribute('style', styleAttrValue);
}
function setStyles(element, styles) {
    if (element['style']) {
        Object.keys(styles).forEach(function (prop) {
            var camelProp = dashCaseToCamelCase(prop);
            element.style[camelProp] = styles[prop];
        });
        // On the server set the 'style' attribute since it's not automatically reflected.
        if (isNode()) {
            writeStyleAttribute(element);
        }
    }
}
function eraseStyles(element, styles) {
    if (element['style']) {
        Object.keys(styles).forEach(function (prop) {
            var camelProp = dashCaseToCamelCase(prop);
            element.style[camelProp] = '';
        });
        // On the server set the 'style' attribute since it's not automatically reflected.
        if (isNode()) {
            writeStyleAttribute(element);
        }
    }
}
function normalizeAnimationEntry(steps) {
    if (Array.isArray(steps)) {
        if (steps.length == 1)
            return steps[0];
        return sequence(steps);
    }
    return steps;
}
function validateStyleParams(value, options, errors) {
    var params = options.params || {};
    var matches = extractStyleParams(value);
    if (matches.length) {
        matches.forEach(function (varName) {
            if (!params.hasOwnProperty(varName)) {
                errors.push("Unable to resolve the local animation param " + varName + " in the given list of values");
            }
        });
    }
}
var PARAM_REGEX = /*@__PURE__*/ new RegExp(SUBSTITUTION_EXPR_START + "\\s*(.+?)\\s*" + SUBSTITUTION_EXPR_END, 'g');
function extractStyleParams(value) {
    var params = [];
    if (typeof value === 'string') {
        var val = value.toString();
        var match = void 0;
        while (match = PARAM_REGEX.exec(val)) {
            params.push(match[1]);
        }
        PARAM_REGEX.lastIndex = 0;
    }
    return params;
}
function interpolateParams(value, params, errors) {
    var original = value.toString();
    var str = original.replace(PARAM_REGEX, function (_, varName) {
        var localVal = params[varName];
        // this means that the value was never overridden by the data passed in by the user
        if (!params.hasOwnProperty(varName)) {
            errors.push("Please provide a value for the animation param " + varName);
            localVal = '';
        }
        return localVal.toString();
    });
    // we do this to assert that numeric values stay as they are
    return str == original ? value : str;
}
function iteratorToArray(iterator) {
    var arr = [];
    var item = iterator.next();
    while (!item.done) {
        arr.push(item.value);
        item = iterator.next();
    }
    return arr;
}
var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
function dashCaseToCamelCase(input) {
    return input.replace(DASH_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        return m[1].toUpperCase();
    });
}
function camelCaseToDashCase(input) {
    return input.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function allowPreviousPlayerStylesMerge(duration, delay) {
    return duration === 0 || delay === 0;
}
function balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles) {
    var previousStyleProps = Object.keys(previousStyles);
    if (previousStyleProps.length && keyframes.length) {
        var startingKeyframe_1 = keyframes[0];
        var missingStyleProps_1 = [];
        previousStyleProps.forEach(function (prop) {
            if (!startingKeyframe_1.hasOwnProperty(prop)) {
                missingStyleProps_1.push(prop);
            }
            startingKeyframe_1[prop] = previousStyles[prop];
        });
        if (missingStyleProps_1.length) {
            var _loop_1 = function () {
                var kf = keyframes[i];
                missingStyleProps_1.forEach(function (prop) { kf[prop] = computeStyle(element, prop); });
            };
            // tslint:disable-next-line
            for (var i = 1; i < keyframes.length; i++) {
                _loop_1();
            }
        }
    }
    return keyframes;
}
function visitDslNode(visitor, node, context) {
    switch (node.type) {
        case 7 /* Trigger */:
            return visitor.visitTrigger(node, context);
        case 0 /* State */:
            return visitor.visitState(node, context);
        case 1 /* Transition */:
            return visitor.visitTransition(node, context);
        case 2 /* Sequence */:
            return visitor.visitSequence(node, context);
        case 3 /* Group */:
            return visitor.visitGroup(node, context);
        case 4 /* Animate */:
            return visitor.visitAnimate(node, context);
        case 5 /* Keyframes */:
            return visitor.visitKeyframes(node, context);
        case 6 /* Style */:
            return visitor.visitStyle(node, context);
        case 8 /* Reference */:
            return visitor.visitReference(node, context);
        case 9 /* AnimateChild */:
            return visitor.visitAnimateChild(node, context);
        case 10 /* AnimateRef */:
            return visitor.visitAnimateRef(node, context);
        case 11 /* Query */:
            return visitor.visitQuery(node, context);
        case 12 /* Stagger */:
            return visitor.visitStagger(node, context);
        default:
            throw new Error("Unable to resolve animation metadata node #" + node.type);
    }
}
function computeStyle(element, prop) {
    return window.getComputedStyle(element)[prop];
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ANY_STATE = '*';
function parseTransitionExpr(transitionValue, errors) {
    var expressions = [];
    if (typeof transitionValue == 'string') {
        transitionValue
            .split(/\s*,\s*/)
            .forEach(function (str) { return parseInnerTransitionStr(str, expressions, errors); });
    }
    else {
        expressions.push(transitionValue);
    }
    return expressions;
}
function parseInnerTransitionStr(eventStr, expressions, errors) {
    if (eventStr[0] == ':') {
        var result = parseAnimationAlias(eventStr, errors);
        if (typeof result == 'function') {
            expressions.push(result);
            return;
        }
        eventStr = result;
    }
    var match = eventStr.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
    if (match == null || match.length < 4) {
        errors.push("The provided transition expression \"" + eventStr + "\" is not supported");
        return expressions;
    }
    var fromState = match[1];
    var separator = match[2];
    var toState = match[3];
    expressions.push(makeLambdaFromStates(fromState, toState));
    var isFullAnyStateExpr = fromState == ANY_STATE && toState == ANY_STATE;
    if (separator[0] == '<' && !isFullAnyStateExpr) {
        expressions.push(makeLambdaFromStates(toState, fromState));
    }
}
function parseAnimationAlias(alias, errors) {
    switch (alias) {
        case ':enter':
            return 'void => *';
        case ':leave':
            return '* => void';
        case ':increment':
            return function (fromState, toState) { return parseFloat(toState) > parseFloat(fromState); };
        case ':decrement':
            return function (fromState, toState) { return parseFloat(toState) < parseFloat(fromState); };
        default:
            errors.push("The transition alias value \"" + alias + "\" is not supported");
            return '* => *';
    }
}
// DO NOT REFACTOR ... keep the follow set instantiations
// with the values intact (closure compiler for some reason
// removes follow-up lines that add the values outside of
// the constructor...
var TRUE_BOOLEAN_VALUES = /*@__PURE__*/ new Set(['true', '1']);
var FALSE_BOOLEAN_VALUES = /*@__PURE__*/ new Set(['false', '0']);
function makeLambdaFromStates(lhs, rhs) {
    var LHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(lhs) || FALSE_BOOLEAN_VALUES.has(lhs);
    var RHS_MATCH_BOOLEAN = TRUE_BOOLEAN_VALUES.has(rhs) || FALSE_BOOLEAN_VALUES.has(rhs);
    return function (fromState, toState) {
        var lhsMatch = lhs == ANY_STATE || lhs == fromState;
        var rhsMatch = rhs == ANY_STATE || rhs == toState;
        if (!lhsMatch && LHS_MATCH_BOOLEAN && typeof fromState === 'boolean') {
            lhsMatch = fromState ? TRUE_BOOLEAN_VALUES.has(lhs) : FALSE_BOOLEAN_VALUES.has(lhs);
        }
        if (!rhsMatch && RHS_MATCH_BOOLEAN && typeof toState === 'boolean') {
            rhsMatch = toState ? TRUE_BOOLEAN_VALUES.has(rhs) : FALSE_BOOLEAN_VALUES.has(rhs);
        }
        return lhsMatch && rhsMatch;
    };
}
var SELF_TOKEN = ':self';
var SELF_TOKEN_REGEX = /*@__PURE__*/ new RegExp("s*" + SELF_TOKEN + "s*,?", 'g');
/*
 * [Validation]
 * The visitor code below will traverse the animation AST generated by the animation verb functions
 * (the output is a tree of objects) and attempt to perform a series of validations on the data. The
 * following corner-cases will be validated:
 *
 * 1. Overlap of animations
 * Given that a CSS property cannot be animated in more than one place at the same time, it's
 * important that this behaviour is detected and validated. The way in which this occurs is that
 * each time a style property is examined, a string-map containing the property will be updated with
 * the start and end times for when the property is used within an animation step.
 *
 * If there are two or more parallel animations that are currently running (these are invoked by the
 * group()) on the same element then the validator will throw an error. Since the start/end timing
 * values are collected for each property then if the current animation step is animating the same
 * property and its timing values fall anywhere into the window of time that the property is
 * currently being animated within then this is what causes an error.
 *
 * 2. Timing values
 * The validator will validate to see if a timing value of `duration delay easing` or
 * `durationNumber` is valid or not.
 *
 * (note that upon validation the code below will replace the timing data with an object containing
 * {duration,delay,easing}.
 *
 * 3. Offset Validation
 * Each of the style() calls are allowed to have an offset value when placed inside of keyframes().
 * Offsets within keyframes() are considered valid when:
 *
 *   - No offsets are used at all
 *   - Each style() entry contains an offset value
 *   - Each offset is between 0 and 1
 *   - Each offset is greater to or equal than the previous one
 *
 * Otherwise an error will be thrown.
 */
function buildAnimationAst(driver, metadata, errors) {
    return new browser_AnimationAstBuilderVisitor(driver).build(metadata, errors);
}
var ROOT_SELECTOR = '';
var browser_AnimationAstBuilderVisitor = /*@__PURE__*/ (function () {
    function AnimationAstBuilderVisitor(_driver) {
        this._driver = _driver;
    }
    AnimationAstBuilderVisitor.prototype.build = function (metadata, errors) {
        var context = new AnimationAstBuilderContext(errors);
        this._resetContextStyleTimingState(context);
        return visitDslNode(this, normalizeAnimationEntry(metadata), context);
    };
    AnimationAstBuilderVisitor.prototype._resetContextStyleTimingState = function (context) {
        context.currentQuerySelector = ROOT_SELECTOR;
        context.collectedStyles = {};
        context.collectedStyles[ROOT_SELECTOR] = {};
        context.currentTime = 0;
    };
    AnimationAstBuilderVisitor.prototype.visitTrigger = function (metadata, context) {
        var _this = this;
        var queryCount = context.queryCount = 0;
        var depCount = context.depCount = 0;
        var states = [];
        var transitions = [];
        if (metadata.name.charAt(0) == '@') {
            context.errors.push('animation triggers cannot be prefixed with an `@` sign (e.g. trigger(\'@foo\', [...]))');
        }
        metadata.definitions.forEach(function (def) {
            _this._resetContextStyleTimingState(context);
            if (def.type == 0 /* State */) {
                var stateDef_1 = def;
                var name_1 = stateDef_1.name;
                name_1.toString().split(/\s*,\s*/).forEach(function (n) {
                    stateDef_1.name = n;
                    states.push(_this.visitState(stateDef_1, context));
                });
                stateDef_1.name = name_1;
            }
            else if (def.type == 1 /* Transition */) {
                var transition = _this.visitTransition(def, context);
                queryCount += transition.queryCount;
                depCount += transition.depCount;
                transitions.push(transition);
            }
            else {
                context.errors.push('only state() and transition() definitions can sit inside of a trigger()');
            }
        });
        return {
            type: 7 /* Trigger */,
            name: metadata.name, states: states, transitions: transitions, queryCount: queryCount, depCount: depCount,
            options: null
        };
    };
    AnimationAstBuilderVisitor.prototype.visitState = function (metadata, context) {
        var styleAst = this.visitStyle(metadata.styles, context);
        var astParams = (metadata.options && metadata.options.params) || null;
        if (styleAst.containsDynamicStyles) {
            var missingSubs_1 = new Set();
            var params_1 = astParams || {};
            styleAst.styles.forEach(function (value) {
                if (browser_isObject(value)) {
                    var stylesObj_1 = value;
                    Object.keys(stylesObj_1).forEach(function (prop) {
                        extractStyleParams(stylesObj_1[prop]).forEach(function (sub) {
                            if (!params_1.hasOwnProperty(sub)) {
                                missingSubs_1.add(sub);
                            }
                        });
                    });
                }
            });
            if (missingSubs_1.size) {
                var missingSubsArr = iteratorToArray(missingSubs_1.values());
                context.errors.push("state(\"" + metadata.name + "\", ...) must define default values for all the following style substitutions: " + missingSubsArr.join(', '));
            }
        }
        return {
            type: 0 /* State */,
            name: metadata.name,
            style: styleAst,
            options: astParams ? { params: astParams } : null
        };
    };
    AnimationAstBuilderVisitor.prototype.visitTransition = function (metadata, context) {
        context.queryCount = 0;
        context.depCount = 0;
        var animation = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
        var matchers = parseTransitionExpr(metadata.expr, context.errors);
        return {
            type: 1 /* Transition */,
            matchers: matchers,
            animation: animation,
            queryCount: context.queryCount,
            depCount: context.depCount,
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitSequence = function (metadata, context) {
        var _this = this;
        return {
            type: 2 /* Sequence */,
            steps: metadata.steps.map(function (s) { return visitDslNode(_this, s, context); }),
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitGroup = function (metadata, context) {
        var _this = this;
        var currentTime = context.currentTime;
        var furthestTime = 0;
        var steps = metadata.steps.map(function (step) {
            context.currentTime = currentTime;
            var innerAst = visitDslNode(_this, step, context);
            furthestTime = Math.max(furthestTime, context.currentTime);
            return innerAst;
        });
        context.currentTime = furthestTime;
        return {
            type: 3 /* Group */,
            steps: steps,
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitAnimate = function (metadata, context) {
        var timingAst = constructTimingAst(metadata.timings, context.errors);
        context.currentAnimateTimings = timingAst;
        var styleAst;
        var styleMetadata = metadata.styles ? metadata.styles : animations_style({});
        if (styleMetadata.type == 5 /* Keyframes */) {
            styleAst = this.visitKeyframes(styleMetadata, context);
        }
        else {
            var styleMetadata_1 = metadata.styles;
            var isEmpty = false;
            if (!styleMetadata_1) {
                isEmpty = true;
                var newStyleData = {};
                if (timingAst.easing) {
                    newStyleData['easing'] = timingAst.easing;
                }
                styleMetadata_1 = animations_style(newStyleData);
            }
            context.currentTime += timingAst.duration + timingAst.delay;
            var _styleAst = this.visitStyle(styleMetadata_1, context);
            _styleAst.isEmptyStep = isEmpty;
            styleAst = _styleAst;
        }
        context.currentAnimateTimings = null;
        return {
            type: 4 /* Animate */,
            timings: timingAst,
            style: styleAst,
            options: null
        };
    };
    AnimationAstBuilderVisitor.prototype.visitStyle = function (metadata, context) {
        var ast = this._makeStyleAst(metadata, context);
        this._validateStyleAst(ast, context);
        return ast;
    };
    AnimationAstBuilderVisitor.prototype._makeStyleAst = function (metadata, context) {
        var styles = [];
        if (Array.isArray(metadata.styles)) {
            metadata.styles.forEach(function (styleTuple) {
                if (typeof styleTuple == 'string') {
                    if (styleTuple == AUTO_STYLE) {
                        styles.push(styleTuple);
                    }
                    else {
                        context.errors.push("The provided style string value " + styleTuple + " is not allowed.");
                    }
                }
                else {
                    styles.push(styleTuple);
                }
            });
        }
        else {
            styles.push(metadata.styles);
        }
        var containsDynamicStyles = false;
        var collectedEasing = null;
        styles.forEach(function (styleData) {
            if (browser_isObject(styleData)) {
                var styleMap = styleData;
                var easing = styleMap['easing'];
                if (easing) {
                    collectedEasing = easing;
                    delete styleMap['easing'];
                }
                if (!containsDynamicStyles) {
                    for (var prop in styleMap) {
                        var value = styleMap[prop];
                        if (value.toString().indexOf(SUBSTITUTION_EXPR_START) >= 0) {
                            containsDynamicStyles = true;
                            break;
                        }
                    }
                }
            }
        });
        return {
            type: 6 /* Style */,
            styles: styles,
            easing: collectedEasing,
            offset: metadata.offset, containsDynamicStyles: containsDynamicStyles,
            options: null
        };
    };
    AnimationAstBuilderVisitor.prototype._validateStyleAst = function (ast, context) {
        var _this = this;
        var timings = context.currentAnimateTimings;
        var endTime = context.currentTime;
        var startTime = context.currentTime;
        if (timings && startTime > 0) {
            startTime -= timings.duration + timings.delay;
        }
        ast.styles.forEach(function (tuple) {
            if (typeof tuple == 'string')
                return;
            Object.keys(tuple).forEach(function (prop) {
                if (!_this._driver.validateStyleProperty(prop)) {
                    context.errors.push("The provided animation property \"" + prop + "\" is not a supported CSS property for animations");
                    return;
                }
                var collectedStyles = context.collectedStyles[context.currentQuerySelector];
                var collectedEntry = collectedStyles[prop];
                var updateCollectedStyle = true;
                if (collectedEntry) {
                    if (startTime != endTime && startTime >= collectedEntry.startTime &&
                        endTime <= collectedEntry.endTime) {
                        context.errors.push("The CSS property \"" + prop + "\" that exists between the times of \"" + collectedEntry.startTime + "ms\" and \"" + collectedEntry.endTime + "ms\" is also being animated in a parallel animation between the times of \"" + startTime + "ms\" and \"" + endTime + "ms\"");
                        updateCollectedStyle = false;
                    }
                    // we always choose the smaller start time value since we
                    // want to have a record of the entire animation window where
                    // the style property is being animated in between
                    startTime = collectedEntry.startTime;
                }
                if (updateCollectedStyle) {
                    collectedStyles[prop] = { startTime: startTime, endTime: endTime };
                }
                if (context.options) {
                    validateStyleParams(tuple[prop], context.options, context.errors);
                }
            });
        });
    };
    AnimationAstBuilderVisitor.prototype.visitKeyframes = function (metadata, context) {
        var _this = this;
        var ast = { type: 5 /* Keyframes */, styles: [], options: null };
        if (!context.currentAnimateTimings) {
            context.errors.push("keyframes() must be placed inside of a call to animate()");
            return ast;
        }
        var MAX_KEYFRAME_OFFSET = 1;
        var totalKeyframesWithOffsets = 0;
        var offsets = [];
        var offsetsOutOfOrder = false;
        var keyframesOutOfRange = false;
        var previousOffset = 0;
        var keyframes = metadata.steps.map(function (styles) {
            var style$$1 = _this._makeStyleAst(styles, context);
            var offsetVal = style$$1.offset != null ? style$$1.offset : consumeOffset(style$$1.styles);
            var offset = 0;
            if (offsetVal != null) {
                totalKeyframesWithOffsets++;
                offset = style$$1.offset = offsetVal;
            }
            keyframesOutOfRange = keyframesOutOfRange || offset < 0 || offset > 1;
            offsetsOutOfOrder = offsetsOutOfOrder || offset < previousOffset;
            previousOffset = offset;
            offsets.push(offset);
            return style$$1;
        });
        if (keyframesOutOfRange) {
            context.errors.push("Please ensure that all keyframe offsets are between 0 and 1");
        }
        if (offsetsOutOfOrder) {
            context.errors.push("Please ensure that all keyframe offsets are in order");
        }
        var length = metadata.steps.length;
        var generatedOffset = 0;
        if (totalKeyframesWithOffsets > 0 && totalKeyframesWithOffsets < length) {
            context.errors.push("Not all style() steps within the declared keyframes() contain offsets");
        }
        else if (totalKeyframesWithOffsets == 0) {
            generatedOffset = MAX_KEYFRAME_OFFSET / (length - 1);
        }
        var limit = length - 1;
        var currentTime = context.currentTime;
        var currentAnimateTimings = context.currentAnimateTimings;
        var animateDuration = currentAnimateTimings.duration;
        keyframes.forEach(function (kf, i) {
            var offset = generatedOffset > 0 ? (i == limit ? 1 : (generatedOffset * i)) : offsets[i];
            var durationUpToThisFrame = offset * animateDuration;
            context.currentTime = currentTime + currentAnimateTimings.delay + durationUpToThisFrame;
            currentAnimateTimings.duration = durationUpToThisFrame;
            _this._validateStyleAst(kf, context);
            kf.offset = offset;
            ast.styles.push(kf);
        });
        return ast;
    };
    AnimationAstBuilderVisitor.prototype.visitReference = function (metadata, context) {
        return {
            type: 8 /* Reference */,
            animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context),
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitAnimateChild = function (metadata, context) {
        context.depCount++;
        return {
            type: 9 /* AnimateChild */,
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitAnimateRef = function (metadata, context) {
        return {
            type: 10 /* AnimateRef */,
            animation: this.visitReference(metadata.animation, context),
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitQuery = function (metadata, context) {
        var parentSelector = context.currentQuerySelector;
        var options = (metadata.options || {});
        context.queryCount++;
        context.currentQuery = metadata;
        var _a = Object(tslib_es6["__read"])(normalizeSelector(metadata.selector), 2), selector = _a[0], includeSelf = _a[1];
        context.currentQuerySelector =
            parentSelector.length ? (parentSelector + ' ' + selector) : selector;
        getOrSetAsInMap(context.collectedStyles, context.currentQuerySelector, {});
        var animation = visitDslNode(this, normalizeAnimationEntry(metadata.animation), context);
        context.currentQuery = null;
        context.currentQuerySelector = parentSelector;
        return {
            type: 11 /* Query */,
            selector: selector,
            limit: options.limit || 0,
            optional: !!options.optional, includeSelf: includeSelf, animation: animation,
            originalSelector: metadata.selector,
            options: normalizeAnimationOptions(metadata.options)
        };
    };
    AnimationAstBuilderVisitor.prototype.visitStagger = function (metadata, context) {
        if (!context.currentQuery) {
            context.errors.push("stagger() can only be used inside of query()");
        }
        var timings = metadata.timings === 'full' ?
            { duration: 0, delay: 0, easing: 'full' } :
            resolveTiming(metadata.timings, context.errors, true);
        return {
            type: 12 /* Stagger */,
            animation: visitDslNode(this, normalizeAnimationEntry(metadata.animation), context), timings: timings,
            options: null
        };
    };
    return AnimationAstBuilderVisitor;
}());
function normalizeSelector(selector) {
    var hasAmpersand = selector.split(/\s*,\s*/).find(function (token) { return token == SELF_TOKEN; }) ? true : false;
    if (hasAmpersand) {
        selector = selector.replace(SELF_TOKEN_REGEX, '');
    }
    // the :enter and :leave selectors are filled in at runtime during timeline building
    selector = selector.replace(/@\*/g, NG_TRIGGER_SELECTOR)
        .replace(/@\w+/g, function (match) { return NG_TRIGGER_SELECTOR + '-' + match.substr(1); })
        .replace(/:animating/g, NG_ANIMATING_SELECTOR);
    return [selector, hasAmpersand];
}
function normalizeParams(obj) {
    return obj ? copyObj(obj) : null;
}
var AnimationAstBuilderContext = /*@__PURE__*/ (function () {
    function AnimationAstBuilderContext(errors) {
        this.errors = errors;
        this.queryCount = 0;
        this.depCount = 0;
        this.currentTransition = null;
        this.currentQuery = null;
        this.currentQuerySelector = null;
        this.currentAnimateTimings = null;
        this.currentTime = 0;
        this.collectedStyles = {};
        this.options = null;
    }
    return AnimationAstBuilderContext;
}());
function consumeOffset(styles) {
    if (typeof styles == 'string')
        return null;
    var offset = null;
    if (Array.isArray(styles)) {
        styles.forEach(function (styleTuple) {
            if (browser_isObject(styleTuple) && styleTuple.hasOwnProperty('offset')) {
                var obj = styleTuple;
                offset = parseFloat(obj['offset']);
                delete obj['offset'];
            }
        });
    }
    else if (browser_isObject(styles) && styles.hasOwnProperty('offset')) {
        var obj = styles;
        offset = parseFloat(obj['offset']);
        delete obj['offset'];
    }
    return offset;
}
function browser_isObject(value) {
    return !Array.isArray(value) && typeof value == 'object';
}
function constructTimingAst(value, errors) {
    var timings = null;
    if (value.hasOwnProperty('duration')) {
        timings = value;
    }
    else if (typeof value == 'number') {
        var duration = resolveTiming(value, errors).duration;
        return makeTimingAst(duration, 0, '');
    }
    var strValue = value;
    var isDynamic = strValue.split(/\s+/).some(function (v) { return v.charAt(0) == '{' && v.charAt(1) == '{'; });
    if (isDynamic) {
        var ast = makeTimingAst(0, 0, '');
        ast.dynamic = true;
        ast.strValue = strValue;
        return ast;
    }
    timings = timings || resolveTiming(strValue, errors);
    return makeTimingAst(timings.duration, timings.delay, timings.easing);
}
function normalizeAnimationOptions(options) {
    if (options) {
        options = copyObj(options);
        if (options['params']) {
            options['params'] = normalizeParams(options['params']);
        }
    }
    else {
        options = {};
    }
    return options;
}
function makeTimingAst(duration, delay, easing) {
    return { duration: duration, delay: delay, easing: easing };
}
function createTimelineInstruction(element, keyframes, preStyleProps, postStyleProps, duration, delay, easing, subTimeline) {
    if (easing === void 0) {
        easing = null;
    }
    if (subTimeline === void 0) {
        subTimeline = false;
    }
    return {
        type: 1 /* TimelineAnimation */,
        element: element,
        keyframes: keyframes,
        preStyleProps: preStyleProps,
        postStyleProps: postStyleProps,
        duration: duration,
        delay: delay,
        totalTime: duration + delay, easing: easing, subTimeline: subTimeline
    };
}
var browser_ElementInstructionMap = /*@__PURE__*/ (function () {
    function ElementInstructionMap() {
        this._map = new Map();
    }
    ElementInstructionMap.prototype.consume = function (element) {
        var instructions = this._map.get(element);
        if (instructions) {
            this._map.delete(element);
        }
        else {
            instructions = [];
        }
        return instructions;
    };
    ElementInstructionMap.prototype.append = function (element, instructions) {
        var existingInstructions = this._map.get(element);
        if (!existingInstructions) {
            this._map.set(element, existingInstructions = []);
        }
        existingInstructions.push.apply(existingInstructions, Object(tslib_es6["__spread"])(instructions));
    };
    ElementInstructionMap.prototype.has = function (element) { return this._map.has(element); };
    ElementInstructionMap.prototype.clear = function () { this._map.clear(); };
    return ElementInstructionMap;
}());
var ONE_FRAME_IN_MILLISECONDS = 1;
var ENTER_TOKEN = ':enter';
var ENTER_TOKEN_REGEX = /*@__PURE__*/ new RegExp(ENTER_TOKEN, 'g');
var LEAVE_TOKEN = ':leave';
var LEAVE_TOKEN_REGEX = /*@__PURE__*/ new RegExp(LEAVE_TOKEN, 'g');
/*
 * The code within this file aims to generate web-animations-compatible keyframes from Angular's
 * animation DSL code.
 *
 * The code below will be converted from:
 *
 * ```
 * sequence([
 *   style({ opacity: 0 }),
 *   animate(1000, style({ opacity: 0 }))
 * ])
 * ```
 *
 * To:
 * ```
 * keyframes = [{ opacity: 0, offset: 0 }, { opacity: 1, offset: 1 }]
 * duration = 1000
 * delay = 0
 * easing = ''
 * ```
 *
 * For this operation to cover the combination of animation verbs (style, animate, group, etc...) a
 * combination of prototypical inheritance, AST traversal and merge-sort-like algorithms are used.
 *
 * [AST Traversal]
 * Each of the animation verbs, when executed, will return an string-map object representing what
 * type of action it is (style, animate, group, etc...) and the data associated with it. This means
 * that when functional composition mix of these functions is evaluated (like in the example above)
 * then it will end up producing a tree of objects representing the animation itself.
 *
 * When this animation object tree is processed by the visitor code below it will visit each of the
 * verb statements within the visitor. And during each visit it will build the context of the
 * animation keyframes by interacting with the `TimelineBuilder`.
 *
 * [TimelineBuilder]
 * This class is responsible for tracking the styles and building a series of keyframe objects for a
 * timeline between a start and end time. The builder starts off with an initial timeline and each
 * time the AST comes across a `group()`, `keyframes()` or a combination of the two wihtin a
 * `sequence()` then it will generate a sub timeline for each step as well as a new one after
 * they are complete.
 *
 * As the AST is traversed, the timing state on each of the timelines will be incremented. If a sub
 * timeline was created (based on one of the cases above) then the parent timeline will attempt to
 * merge the styles used within the sub timelines into itself (only with group() this will happen).
 * This happens with a merge operation (much like how the merge works in mergesort) and it will only
 * copy the most recently used styles from the sub timelines into the parent timeline. This ensures
 * that if the styles are used later on in another phase of the animation then they will be the most
 * up-to-date values.
 *
 * [How Missing Styles Are Updated]
 * Each timeline has a `backFill` property which is responsible for filling in new styles into
 * already processed keyframes if a new style shows up later within the animation sequence.
 *
 * ```
 * sequence([
 *   style({ width: 0 }),
 *   animate(1000, style({ width: 100 })),
 *   animate(1000, style({ width: 200 })),
 *   animate(1000, style({ width: 300 }))
 *   animate(1000, style({ width: 400, height: 400 })) // notice how `height` doesn't exist anywhere
 * else
 * ])
 * ```
 *
 * What is happening here is that the `height` value is added later in the sequence, but is missing
 * from all previous animation steps. Therefore when a keyframe is created it would also be missing
 * from all previous keyframes up until where it is first used. For the timeline keyframe generation
 * to properly fill in the style it will place the previous value (the value from the parent
 * timeline) or a default value of `*` into the backFill object. Given that each of the keyframe
 * styles are objects that prototypically inhert from the backFill object, this means that if a
 * value is added into the backFill then it will automatically propagate any missing values to all
 * keyframes. Therefore the missing `height` value will be properly filled into the already
 * processed keyframes.
 *
 * When a sub-timeline is created it will have its own backFill property. This is done so that
 * styles present within the sub-timeline do not accidentally seep into the previous/future timeline
 * keyframes
 *
 * (For prototypically-inherited contents to be detected a `for(i in obj)` loop must be used.)
 *
 * [Validation]
 * The code in this file is not responsible for validation. That functionality happens with within
 * the `AnimationValidatorVisitor` code.
 */
function buildAnimationTimelines(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
    if (startingStyles === void 0) {
        startingStyles = {};
    }
    if (finalStyles === void 0) {
        finalStyles = {};
    }
    if (errors === void 0) {
        errors = [];
    }
    return new AnimationTimelineBuilderVisitor().buildKeyframes(driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors);
}
var AnimationTimelineBuilderVisitor = /*@__PURE__*/ (function () {
    function AnimationTimelineBuilderVisitor() {
    }
    AnimationTimelineBuilderVisitor.prototype.buildKeyframes = function (driver, rootElement, ast, enterClassName, leaveClassName, startingStyles, finalStyles, options, subInstructions, errors) {
        if (errors === void 0) {
            errors = [];
        }
        subInstructions = subInstructions || new browser_ElementInstructionMap();
        var context = new browser_AnimationTimelineContext(driver, rootElement, subInstructions, enterClassName, leaveClassName, errors, []);
        context.options = options;
        context.currentTimeline.setStyles([startingStyles], null, context.errors, options);
        visitDslNode(this, ast, context);
        // this checks to see if an actual animation happened
        var timelines = context.timelines.filter(function (timeline) { return timeline.containsAnimation(); });
        if (timelines.length && Object.keys(finalStyles).length) {
            var tl = timelines[timelines.length - 1];
            if (!tl.allowOnlyTimelineStyles()) {
                tl.setStyles([finalStyles], null, context.errors, options);
            }
        }
        return timelines.length ? timelines.map(function (timeline) { return timeline.buildKeyframes(); }) :
            [createTimelineInstruction(rootElement, [], [], [], 0, 0, '', false)];
    };
    AnimationTimelineBuilderVisitor.prototype.visitTrigger = function (ast, context) {
        // these values are not visited in this AST
    };
    AnimationTimelineBuilderVisitor.prototype.visitState = function (ast, context) {
        // these values are not visited in this AST
    };
    AnimationTimelineBuilderVisitor.prototype.visitTransition = function (ast, context) {
        // these values are not visited in this AST
    };
    AnimationTimelineBuilderVisitor.prototype.visitAnimateChild = function (ast, context) {
        var elementInstructions = context.subInstructions.consume(context.element);
        if (elementInstructions) {
            var innerContext = context.createSubContext(ast.options);
            var startTime = context.currentTimeline.currentTime;
            var endTime = this._visitSubInstructions(elementInstructions, innerContext, innerContext.options);
            if (startTime != endTime) {
                // we do this on the upper context because we created a sub context for
                // the sub child animations
                context.transformIntoNewTimeline(endTime);
            }
        }
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitAnimateRef = function (ast, context) {
        var innerContext = context.createSubContext(ast.options);
        innerContext.transformIntoNewTimeline();
        this.visitReference(ast.animation, innerContext);
        context.transformIntoNewTimeline(innerContext.currentTimeline.currentTime);
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype._visitSubInstructions = function (instructions, context, options) {
        var startTime = context.currentTimeline.currentTime;
        var furthestTime = startTime;
        // this is a special-case for when a user wants to skip a sub
        // animation from being fired entirely.
        var duration = options.duration != null ? resolveTimingValue(options.duration) : null;
        var delay = options.delay != null ? resolveTimingValue(options.delay) : null;
        if (duration !== 0) {
            instructions.forEach(function (instruction) {
                var instructionTimings = context.appendInstructionToTimeline(instruction, duration, delay);
                furthestTime =
                    Math.max(furthestTime, instructionTimings.duration + instructionTimings.delay);
            });
        }
        return furthestTime;
    };
    AnimationTimelineBuilderVisitor.prototype.visitReference = function (ast, context) {
        context.updateOptions(ast.options, true);
        visitDslNode(this, ast.animation, context);
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitSequence = function (ast, context) {
        var _this = this;
        var subContextCount = context.subContextCount;
        var ctx = context;
        var options = ast.options;
        if (options && (options.params || options.delay)) {
            ctx = context.createSubContext(options);
            ctx.transformIntoNewTimeline();
            if (options.delay != null) {
                if (ctx.previousNode.type == 6 /* Style */) {
                    ctx.currentTimeline.snapshotCurrentStyles();
                    ctx.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
                }
                var delay = resolveTimingValue(options.delay);
                ctx.delayNextStep(delay);
            }
        }
        if (ast.steps.length) {
            ast.steps.forEach(function (s) { return visitDslNode(_this, s, ctx); });
            // this is here just incase the inner steps only contain or end with a style() call
            ctx.currentTimeline.applyStylesToKeyframe();
            // this means that some animation function within the sequence
            // ended up creating a sub timeline (which means the current
            // timeline cannot overlap with the contents of the sequence)
            if (ctx.subContextCount > subContextCount) {
                ctx.transformIntoNewTimeline();
            }
        }
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitGroup = function (ast, context) {
        var _this = this;
        var innerTimelines = [];
        var furthestTime = context.currentTimeline.currentTime;
        var delay = ast.options && ast.options.delay ? resolveTimingValue(ast.options.delay) : 0;
        ast.steps.forEach(function (s) {
            var innerContext = context.createSubContext(ast.options);
            if (delay) {
                innerContext.delayNextStep(delay);
            }
            visitDslNode(_this, s, innerContext);
            furthestTime = Math.max(furthestTime, innerContext.currentTimeline.currentTime);
            innerTimelines.push(innerContext.currentTimeline);
        });
        // this operation is run after the AST loop because otherwise
        // if the parent timeline's collected styles were updated then
        // it would pass in invalid data into the new-to-be forked items
        innerTimelines.forEach(function (timeline) { return context.currentTimeline.mergeTimelineCollectedStyles(timeline); });
        context.transformIntoNewTimeline(furthestTime);
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype._visitTiming = function (ast, context) {
        if (ast.dynamic) {
            var strValue = ast.strValue;
            var timingValue = context.params ? interpolateParams(strValue, context.params, context.errors) : strValue;
            return resolveTiming(timingValue, context.errors);
        }
        else {
            return { duration: ast.duration, delay: ast.delay, easing: ast.easing };
        }
    };
    AnimationTimelineBuilderVisitor.prototype.visitAnimate = function (ast, context) {
        var timings = context.currentAnimateTimings = this._visitTiming(ast.timings, context);
        var timeline = context.currentTimeline;
        if (timings.delay) {
            context.incrementTime(timings.delay);
            timeline.snapshotCurrentStyles();
        }
        var style$$1 = ast.style;
        if (style$$1.type == 5 /* Keyframes */) {
            this.visitKeyframes(style$$1, context);
        }
        else {
            context.incrementTime(timings.duration);
            this.visitStyle(style$$1, context);
            timeline.applyStylesToKeyframe();
        }
        context.currentAnimateTimings = null;
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitStyle = function (ast, context) {
        var timeline = context.currentTimeline;
        var timings = context.currentAnimateTimings;
        // this is a special case for when a style() call
        // directly follows  an animate() call (but not inside of an animate() call)
        if (!timings && timeline.getCurrentStyleProperties().length) {
            timeline.forwardFrame();
        }
        var easing = (timings && timings.easing) || ast.easing;
        if (ast.isEmptyStep) {
            timeline.applyEmptyStep(easing);
        }
        else {
            timeline.setStyles(ast.styles, easing, context.errors, context.options);
        }
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitKeyframes = function (ast, context) {
        var currentAnimateTimings = context.currentAnimateTimings;
        var startTime = (context.currentTimeline).duration;
        var duration = currentAnimateTimings.duration;
        var innerContext = context.createSubContext();
        var innerTimeline = innerContext.currentTimeline;
        innerTimeline.easing = currentAnimateTimings.easing;
        ast.styles.forEach(function (step) {
            var offset = step.offset || 0;
            innerTimeline.forwardTime(offset * duration);
            innerTimeline.setStyles(step.styles, step.easing, context.errors, context.options);
            innerTimeline.applyStylesToKeyframe();
        });
        // this will ensure that the parent timeline gets all the styles from
        // the child even if the new timeline below is not used
        context.currentTimeline.mergeTimelineCollectedStyles(innerTimeline);
        // we do this because the window between this timeline and the sub timeline
        // should ensure that the styles within are exactly the same as they were before
        context.transformIntoNewTimeline(startTime + duration);
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitQuery = function (ast, context) {
        var _this = this;
        // in the event that the first step before this is a style step we need
        // to ensure the styles are applied before the children are animated
        var startTime = context.currentTimeline.currentTime;
        var options = (ast.options || {});
        var delay = options.delay ? resolveTimingValue(options.delay) : 0;
        if (delay && (context.previousNode.type === 6 /* Style */ ||
            (startTime == 0 && context.currentTimeline.getCurrentStyleProperties().length))) {
            context.currentTimeline.snapshotCurrentStyles();
            context.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        }
        var furthestTime = startTime;
        var elms = context.invokeQuery(ast.selector, ast.originalSelector, ast.limit, ast.includeSelf, options.optional ? true : false, context.errors);
        context.currentQueryTotal = elms.length;
        var sameElementTimeline = null;
        elms.forEach(function (element, i) {
            context.currentQueryIndex = i;
            var innerContext = context.createSubContext(ast.options, element);
            if (delay) {
                innerContext.delayNextStep(delay);
            }
            if (element === context.element) {
                sameElementTimeline = innerContext.currentTimeline;
            }
            visitDslNode(_this, ast.animation, innerContext);
            // this is here just incase the inner steps only contain or end
            // with a style() call (which is here to signal that this is a preparatory
            // call to style an element before it is animated again)
            innerContext.currentTimeline.applyStylesToKeyframe();
            var endTime = innerContext.currentTimeline.currentTime;
            furthestTime = Math.max(furthestTime, endTime);
        });
        context.currentQueryIndex = 0;
        context.currentQueryTotal = 0;
        context.transformIntoNewTimeline(furthestTime);
        if (sameElementTimeline) {
            context.currentTimeline.mergeTimelineCollectedStyles(sameElementTimeline);
            context.currentTimeline.snapshotCurrentStyles();
        }
        context.previousNode = ast;
    };
    AnimationTimelineBuilderVisitor.prototype.visitStagger = function (ast, context) {
        var parentContext = context.parentContext;
        var tl = context.currentTimeline;
        var timings = ast.timings;
        var duration = Math.abs(timings.duration);
        var maxTime = duration * (context.currentQueryTotal - 1);
        var delay = duration * context.currentQueryIndex;
        var staggerTransformer = timings.duration < 0 ? 'reverse' : timings.easing;
        switch (staggerTransformer) {
            case 'reverse':
                delay = maxTime - delay;
                break;
            case 'full':
                delay = parentContext.currentStaggerTime;
                break;
        }
        var timeline = context.currentTimeline;
        if (delay) {
            timeline.delayNextStep(delay);
        }
        var startingTime = timeline.currentTime;
        visitDslNode(this, ast.animation, context);
        context.previousNode = ast;
        // time = duration + delay
        // the reason why this computation is so complex is because
        // the inner timeline may either have a delay value or a stretched
        // keyframe depending on if a subtimeline is not used or is used.
        parentContext.currentStaggerTime =
            (tl.currentTime - startingTime) + (tl.startTime - parentContext.currentTimeline.startTime);
    };
    return AnimationTimelineBuilderVisitor;
}());
var DEFAULT_NOOP_PREVIOUS_NODE = {};
var browser_AnimationTimelineContext = /*@__PURE__*/ (function () {
    function AnimationTimelineContext(_driver, element, subInstructions, _enterClassName, _leaveClassName, errors, timelines, initialTimeline) {
        this._driver = _driver;
        this.element = element;
        this.subInstructions = subInstructions;
        this._enterClassName = _enterClassName;
        this._leaveClassName = _leaveClassName;
        this.errors = errors;
        this.timelines = timelines;
        this.parentContext = null;
        this.currentAnimateTimings = null;
        this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        this.subContextCount = 0;
        this.options = {};
        this.currentQueryIndex = 0;
        this.currentQueryTotal = 0;
        this.currentStaggerTime = 0;
        this.currentTimeline = initialTimeline || new browser_TimelineBuilder(this._driver, element, 0);
        timelines.push(this.currentTimeline);
    }
    Object.defineProperty(AnimationTimelineContext.prototype, "params", {
        get: function () { return this.options.params; },
        enumerable: true,
        configurable: true
    });
    AnimationTimelineContext.prototype.updateOptions = function (options, skipIfExists) {
        var _this = this;
        if (!options)
            return;
        var newOptions = options;
        var optionsToUpdate = this.options;
        // NOTE: this will get patched up when other animation methods support duration overrides
        if (newOptions.duration != null) {
            optionsToUpdate.duration = resolveTimingValue(newOptions.duration);
        }
        if (newOptions.delay != null) {
            optionsToUpdate.delay = resolveTimingValue(newOptions.delay);
        }
        var newParams = newOptions.params;
        if (newParams) {
            var paramsToUpdate_1 = optionsToUpdate.params;
            if (!paramsToUpdate_1) {
                paramsToUpdate_1 = this.options.params = {};
            }
            Object.keys(newParams).forEach(function (name) {
                if (!skipIfExists || !paramsToUpdate_1.hasOwnProperty(name)) {
                    paramsToUpdate_1[name] = interpolateParams(newParams[name], paramsToUpdate_1, _this.errors);
                }
            });
        }
    };
    AnimationTimelineContext.prototype._copyOptions = function () {
        var options = {};
        if (this.options) {
            var oldParams_1 = this.options.params;
            if (oldParams_1) {
                var params_1 = options['params'] = {};
                Object.keys(oldParams_1).forEach(function (name) { params_1[name] = oldParams_1[name]; });
            }
        }
        return options;
    };
    AnimationTimelineContext.prototype.createSubContext = function (options, element, newTime) {
        if (options === void 0) {
            options = null;
        }
        var target = element || this.element;
        var context = new AnimationTimelineContext(this._driver, target, this.subInstructions, this._enterClassName, this._leaveClassName, this.errors, this.timelines, this.currentTimeline.fork(target, newTime || 0));
        context.previousNode = this.previousNode;
        context.currentAnimateTimings = this.currentAnimateTimings;
        context.options = this._copyOptions();
        context.updateOptions(options);
        context.currentQueryIndex = this.currentQueryIndex;
        context.currentQueryTotal = this.currentQueryTotal;
        context.parentContext = this;
        this.subContextCount++;
        return context;
    };
    AnimationTimelineContext.prototype.transformIntoNewTimeline = function (newTime) {
        this.previousNode = DEFAULT_NOOP_PREVIOUS_NODE;
        this.currentTimeline = this.currentTimeline.fork(this.element, newTime);
        this.timelines.push(this.currentTimeline);
        return this.currentTimeline;
    };
    AnimationTimelineContext.prototype.appendInstructionToTimeline = function (instruction, duration, delay) {
        var updatedTimings = {
            duration: duration != null ? duration : instruction.duration,
            delay: this.currentTimeline.currentTime + (delay != null ? delay : 0) + instruction.delay,
            easing: ''
        };
        var builder = new browser_SubTimelineBuilder(this._driver, instruction.element, instruction.keyframes, instruction.preStyleProps, instruction.postStyleProps, updatedTimings, instruction.stretchStartingKeyframe);
        this.timelines.push(builder);
        return updatedTimings;
    };
    AnimationTimelineContext.prototype.incrementTime = function (time) {
        this.currentTimeline.forwardTime(this.currentTimeline.duration + time);
    };
    AnimationTimelineContext.prototype.delayNextStep = function (delay) {
        // negative delays are not yet supported
        if (delay > 0) {
            this.currentTimeline.delayNextStep(delay);
        }
    };
    AnimationTimelineContext.prototype.invokeQuery = function (selector, originalSelector, limit, includeSelf, optional, errors) {
        var results = [];
        if (includeSelf) {
            results.push(this.element);
        }
        if (selector.length > 0) {
            selector = selector.replace(ENTER_TOKEN_REGEX, '.' + this._enterClassName);
            selector = selector.replace(LEAVE_TOKEN_REGEX, '.' + this._leaveClassName);
            var multi = limit != 1;
            var elements = this._driver.query(this.element, selector, multi);
            if (limit !== 0) {
                elements = limit < 0 ? elements.slice(elements.length + limit, elements.length) :
                    elements.slice(0, limit);
            }
            results.push.apply(results, Object(tslib_es6["__spread"])(elements));
        }
        if (!optional && results.length == 0) {
            errors.push("`query(\"" + originalSelector + "\")` returned zero elements. (Use `query(\"" + originalSelector + "\", { optional: true })` if you wish to allow this.)");
        }
        return results;
    };
    return AnimationTimelineContext;
}());
var browser_TimelineBuilder = /*@__PURE__*/ (function () {
    function TimelineBuilder(_driver, element, startTime, _elementTimelineStylesLookup) {
        this._driver = _driver;
        this.element = element;
        this.startTime = startTime;
        this._elementTimelineStylesLookup = _elementTimelineStylesLookup;
        this.duration = 0;
        this._previousKeyframe = {};
        this._currentKeyframe = {};
        this._keyframes = new Map();
        this._styleSummary = {};
        this._pendingStyles = {};
        this._backFill = {};
        this._currentEmptyStepKeyframe = null;
        if (!this._elementTimelineStylesLookup) {
            this._elementTimelineStylesLookup = new Map();
        }
        this._localTimelineStyles = Object.create(this._backFill, {});
        this._globalTimelineStyles = this._elementTimelineStylesLookup.get(element);
        if (!this._globalTimelineStyles) {
            this._globalTimelineStyles = this._localTimelineStyles;
            this._elementTimelineStylesLookup.set(element, this._localTimelineStyles);
        }
        this._loadKeyframe();
    }
    TimelineBuilder.prototype.containsAnimation = function () {
        switch (this._keyframes.size) {
            case 0:
                return false;
            case 1:
                return this.getCurrentStyleProperties().length > 0;
            default:
                return true;
        }
    };
    TimelineBuilder.prototype.getCurrentStyleProperties = function () { return Object.keys(this._currentKeyframe); };
    Object.defineProperty(TimelineBuilder.prototype, "currentTime", {
        get: function () { return this.startTime + this.duration; },
        enumerable: true,
        configurable: true
    });
    TimelineBuilder.prototype.delayNextStep = function (delay) {
        // in the event that a style() step is placed right before a stagger()
        // and that style() step is the very first style() value in the animation
        // then we need to make a copy of the keyframe [0, copy, 1] so that the delay
        // properly applies the style() values to work with the stagger...
        var hasPreStyleStep = this._keyframes.size == 1 && Object.keys(this._pendingStyles).length;
        if (this.duration || hasPreStyleStep) {
            this.forwardTime(this.currentTime + delay);
            if (hasPreStyleStep) {
                this.snapshotCurrentStyles();
            }
        }
        else {
            this.startTime += delay;
        }
    };
    TimelineBuilder.prototype.fork = function (element, currentTime) {
        this.applyStylesToKeyframe();
        return new TimelineBuilder(this._driver, element, currentTime || this.currentTime, this._elementTimelineStylesLookup);
    };
    TimelineBuilder.prototype._loadKeyframe = function () {
        if (this._currentKeyframe) {
            this._previousKeyframe = this._currentKeyframe;
        }
        this._currentKeyframe = this._keyframes.get(this.duration);
        if (!this._currentKeyframe) {
            this._currentKeyframe = Object.create(this._backFill, {});
            this._keyframes.set(this.duration, this._currentKeyframe);
        }
    };
    TimelineBuilder.prototype.forwardFrame = function () {
        this.duration += ONE_FRAME_IN_MILLISECONDS;
        this._loadKeyframe();
    };
    TimelineBuilder.prototype.forwardTime = function (time) {
        this.applyStylesToKeyframe();
        this.duration = time;
        this._loadKeyframe();
    };
    TimelineBuilder.prototype._updateStyle = function (prop, value) {
        this._localTimelineStyles[prop] = value;
        this._globalTimelineStyles[prop] = value;
        this._styleSummary[prop] = { time: this.currentTime, value: value };
    };
    TimelineBuilder.prototype.allowOnlyTimelineStyles = function () { return this._currentEmptyStepKeyframe !== this._currentKeyframe; };
    TimelineBuilder.prototype.applyEmptyStep = function (easing) {
        var _this = this;
        if (easing) {
            this._previousKeyframe['easing'] = easing;
        }
        // special case for animate(duration):
        // all missing styles are filled with a `*` value then
        // if any destination styles are filled in later on the same
        // keyframe then they will override the overridden styles
        // We use `_globalTimelineStyles` here because there may be
        // styles in previous keyframes that are not present in this timeline
        Object.keys(this._globalTimelineStyles).forEach(function (prop) {
            _this._backFill[prop] = _this._globalTimelineStyles[prop] || AUTO_STYLE;
            _this._currentKeyframe[prop] = AUTO_STYLE;
        });
        this._currentEmptyStepKeyframe = this._currentKeyframe;
    };
    TimelineBuilder.prototype.setStyles = function (input, easing, errors, options) {
        var _this = this;
        if (easing) {
            this._previousKeyframe['easing'] = easing;
        }
        var params = (options && options.params) || {};
        var styles = flattenStyles(input, this._globalTimelineStyles);
        Object.keys(styles).forEach(function (prop) {
            var val = interpolateParams(styles[prop], params, errors);
            _this._pendingStyles[prop] = val;
            if (!_this._localTimelineStyles.hasOwnProperty(prop)) {
                _this._backFill[prop] = _this._globalTimelineStyles.hasOwnProperty(prop) ?
                    _this._globalTimelineStyles[prop] :
                    AUTO_STYLE;
            }
            _this._updateStyle(prop, val);
        });
    };
    TimelineBuilder.prototype.applyStylesToKeyframe = function () {
        var _this = this;
        var styles = this._pendingStyles;
        var props = Object.keys(styles);
        if (props.length == 0)
            return;
        this._pendingStyles = {};
        props.forEach(function (prop) {
            var val = styles[prop];
            _this._currentKeyframe[prop] = val;
        });
        Object.keys(this._localTimelineStyles).forEach(function (prop) {
            if (!_this._currentKeyframe.hasOwnProperty(prop)) {
                _this._currentKeyframe[prop] = _this._localTimelineStyles[prop];
            }
        });
    };
    TimelineBuilder.prototype.snapshotCurrentStyles = function () {
        var _this = this;
        Object.keys(this._localTimelineStyles).forEach(function (prop) {
            var val = _this._localTimelineStyles[prop];
            _this._pendingStyles[prop] = val;
            _this._updateStyle(prop, val);
        });
    };
    TimelineBuilder.prototype.getFinalKeyframe = function () { return this._keyframes.get(this.duration); };
    Object.defineProperty(TimelineBuilder.prototype, "properties", {
        get: function () {
            var properties = [];
            for (var prop in this._currentKeyframe) {
                properties.push(prop);
            }
            return properties;
        },
        enumerable: true,
        configurable: true
    });
    TimelineBuilder.prototype.mergeTimelineCollectedStyles = function (timeline) {
        var _this = this;
        Object.keys(timeline._styleSummary).forEach(function (prop) {
            var details0 = _this._styleSummary[prop];
            var details1 = timeline._styleSummary[prop];
            if (!details0 || details1.time > details0.time) {
                _this._updateStyle(prop, details1.value);
            }
        });
    };
    TimelineBuilder.prototype.buildKeyframes = function () {
        var _this = this;
        this.applyStylesToKeyframe();
        var preStyleProps = new Set();
        var postStyleProps = new Set();
        var isEmpty = this._keyframes.size === 1 && this.duration === 0;
        var finalKeyframes = [];
        this._keyframes.forEach(function (keyframe, time) {
            var finalKeyframe = copyStyles(keyframe, true);
            Object.keys(finalKeyframe).forEach(function (prop) {
                var value = finalKeyframe[prop];
                if (value == ɵPRE_STYLE) {
                    preStyleProps.add(prop);
                }
                else if (value == AUTO_STYLE) {
                    postStyleProps.add(prop);
                }
            });
            if (!isEmpty) {
                finalKeyframe['offset'] = time / _this.duration;
            }
            finalKeyframes.push(finalKeyframe);
        });
        var preProps = preStyleProps.size ? iteratorToArray(preStyleProps.values()) : [];
        var postProps = postStyleProps.size ? iteratorToArray(postStyleProps.values()) : [];
        // special case for a 0-second animation (which is designed just to place styles onscreen)
        if (isEmpty) {
            var kf0 = finalKeyframes[0];
            var kf1 = copyObj(kf0);
            kf0['offset'] = 0;
            kf1['offset'] = 1;
            finalKeyframes = [kf0, kf1];
        }
        return createTimelineInstruction(this.element, finalKeyframes, preProps, postProps, this.duration, this.startTime, this.easing, false);
    };
    return TimelineBuilder;
}());
var browser_SubTimelineBuilder = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(SubTimelineBuilder, _super);
    function SubTimelineBuilder(driver, element, keyframes, preStyleProps, postStyleProps, timings, _stretchStartingKeyframe) {
        if (_stretchStartingKeyframe === void 0) {
            _stretchStartingKeyframe = false;
        }
        var _this = _super.call(this, driver, element, timings.delay) || this;
        _this.element = element;
        _this.keyframes = keyframes;
        _this.preStyleProps = preStyleProps;
        _this.postStyleProps = postStyleProps;
        _this._stretchStartingKeyframe = _stretchStartingKeyframe;
        _this.timings = { duration: timings.duration, delay: timings.delay, easing: timings.easing };
        return _this;
    }
    SubTimelineBuilder.prototype.containsAnimation = function () { return this.keyframes.length > 1; };
    SubTimelineBuilder.prototype.buildKeyframes = function () {
        var keyframes = this.keyframes;
        var _a = this.timings, delay = _a.delay, duration = _a.duration, easing = _a.easing;
        if (this._stretchStartingKeyframe && delay) {
            var newKeyframes = [];
            var totalTime = duration + delay;
            var startingGap = delay / totalTime;
            // the original starting keyframe now starts once the delay is done
            var newFirstKeyframe = copyStyles(keyframes[0], false);
            newFirstKeyframe['offset'] = 0;
            newKeyframes.push(newFirstKeyframe);
            var oldFirstKeyframe = copyStyles(keyframes[0], false);
            oldFirstKeyframe['offset'] = roundOffset(startingGap);
            newKeyframes.push(oldFirstKeyframe);
            /*
              When the keyframe is stretched then it means that the delay before the animation
              starts is gone. Instead the first keyframe is placed at the start of the animation
              and it is then copied to where it starts when the original delay is over. This basically
              means nothing animates during that delay, but the styles are still renderered. For this
              to work the original offset values that exist in the original keyframes must be "warped"
              so that they can take the new keyframe + delay into account.
      
              delay=1000, duration=1000, keyframes = 0 .5 1
      
              turns into
      
              delay=0, duration=2000, keyframes = 0 .33 .66 1
             */
            // offsets between 1 ... n -1 are all warped by the keyframe stretch
            var limit = keyframes.length - 1;
            for (var i = 1; i <= limit; i++) {
                var kf = copyStyles(keyframes[i], false);
                var oldOffset = kf['offset'];
                var timeAtKeyframe = delay + oldOffset * duration;
                kf['offset'] = roundOffset(timeAtKeyframe / totalTime);
                newKeyframes.push(kf);
            }
            // the new starting keyframe should be added at the start
            duration = totalTime;
            delay = 0;
            easing = '';
            keyframes = newKeyframes;
        }
        return createTimelineInstruction(this.element, keyframes, this.preStyleProps, this.postStyleProps, duration, delay, easing, true);
    };
    return SubTimelineBuilder;
}(browser_TimelineBuilder));
function roundOffset(offset, decimalPoints) {
    if (decimalPoints === void 0) {
        decimalPoints = 3;
    }
    var mult = Math.pow(10, decimalPoints - 1);
    return Math.round(offset * mult) / mult;
}
function flattenStyles(input, allStyles) {
    var styles = {};
    var allProperties;
    input.forEach(function (token) {
        if (token === '*') {
            allProperties = allProperties || Object.keys(allStyles);
            allProperties.forEach(function (prop) { styles[prop] = AUTO_STYLE; });
        }
        else {
            copyStyles(token, false, styles);
        }
    });
    return styles;
}
var Animation = /*@__PURE__*/ (function () {
    function Animation(_driver, input) {
        this._driver = _driver;
        var errors = [];
        var ast = buildAnimationAst(_driver, input, errors);
        if (errors.length) {
            var errorMessage = "animation validation failed:\n" + errors.join("\n");
            throw new Error(errorMessage);
        }
        this._animationAst = ast;
    }
    Animation.prototype.buildTimelines = function (element, startingStyles, destinationStyles, options, subInstructions) {
        var start = Array.isArray(startingStyles) ? normalizeStyles(startingStyles) :
            startingStyles;
        var dest = Array.isArray(destinationStyles) ? normalizeStyles(destinationStyles) :
            destinationStyles;
        var errors = [];
        subInstructions = subInstructions || new browser_ElementInstructionMap();
        var result = buildAnimationTimelines(this._driver, element, this._animationAst, ENTER_CLASSNAME, LEAVE_CLASSNAME, start, dest, options, subInstructions, errors);
        if (errors.length) {
            var errorMessage = "animation building failed:\n" + errors.join("\n");
            throw new Error(errorMessage);
        }
        return result;
    };
    return Animation;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @experimental Animation support is experimental.
 */
var AnimationStyleNormalizer = /*@__PURE__*/ (function () {
    function AnimationStyleNormalizer() {
    }
    return AnimationStyleNormalizer;
}());
/**
 * @experimental Animation support is experimental.
 */
var NoopAnimationStyleNormalizer = /*@__PURE__*/ (function () {
    function NoopAnimationStyleNormalizer() {
    }
    NoopAnimationStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) { return propertyName; };
    NoopAnimationStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
        return value;
    };
    return NoopAnimationStyleNormalizer;
}());
var browser_WebAnimationsStyleNormalizer = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(WebAnimationsStyleNormalizer, _super);
    function WebAnimationsStyleNormalizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebAnimationsStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) {
        return dashCaseToCamelCase(propertyName);
    };
    WebAnimationsStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
        var unit = '';
        var strVal = value.toString().trim();
        if (DIMENSIONAL_PROP_MAP[normalizedProperty] && value !== 0 && value !== '0') {
            if (typeof value === 'number') {
                unit = 'px';
            }
            else {
                var valAndSuffixMatch = value.match(/^[+-]?[\d\.]+([a-z]*)$/);
                if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
                    errors.push("Please provide a CSS unit value for " + userProvidedProperty + ":" + value);
                }
            }
        }
        return strVal + unit;
    };
    return WebAnimationsStyleNormalizer;
}(AnimationStyleNormalizer));
var DIMENSIONAL_PROP_MAP = /*@__PURE__*/ makeBooleanMap(/*@__PURE__*/ 'width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent,perspective'
    .split(','));
function makeBooleanMap(keys) {
    var map = {};
    keys.forEach(function (key) { return map[key] = true; });
    return map;
}
function createTransitionInstruction(element, triggerName, fromState, toState, isRemovalTransition, fromStyles, toStyles, timelines, queriedElements, preStyleProps, postStyleProps, totalTime, errors) {
    return {
        type: 0 /* TransitionAnimation */,
        element: element,
        triggerName: triggerName,
        isRemovalTransition: isRemovalTransition,
        fromState: fromState,
        fromStyles: fromStyles,
        toState: toState,
        toStyles: toStyles,
        timelines: timelines,
        queriedElements: queriedElements,
        preStyleProps: preStyleProps,
        postStyleProps: postStyleProps,
        totalTime: totalTime,
        errors: errors
    };
}
var EMPTY_OBJECT = {};
var browser_AnimationTransitionFactory = /*@__PURE__*/ (function () {
    function AnimationTransitionFactory(_triggerName, ast, _stateStyles) {
        this._triggerName = _triggerName;
        this.ast = ast;
        this._stateStyles = _stateStyles;
    }
    AnimationTransitionFactory.prototype.match = function (currentState, nextState, element, params) {
        return oneOrMoreTransitionsMatch(this.ast.matchers, currentState, nextState, element, params);
    };
    AnimationTransitionFactory.prototype.buildStyles = function (stateName, params, errors) {
        var backupStateStyler = this._stateStyles['*'];
        var stateStyler = this._stateStyles[stateName];
        var backupStyles = backupStateStyler ? backupStateStyler.buildStyles(params, errors) : {};
        return stateStyler ? stateStyler.buildStyles(params, errors) : backupStyles;
    };
    AnimationTransitionFactory.prototype.build = function (driver, element, currentState, nextState, enterClassName, leaveClassName, currentOptions, nextOptions, subInstructions, skipAstBuild) {
        var errors = [];
        var transitionAnimationParams = this.ast.options && this.ast.options.params || EMPTY_OBJECT;
        var currentAnimationParams = currentOptions && currentOptions.params || EMPTY_OBJECT;
        var currentStateStyles = this.buildStyles(currentState, currentAnimationParams, errors);
        var nextAnimationParams = nextOptions && nextOptions.params || EMPTY_OBJECT;
        var nextStateStyles = this.buildStyles(nextState, nextAnimationParams, errors);
        var queriedElements = new Set();
        var preStyleMap = new Map();
        var postStyleMap = new Map();
        var isRemoval = nextState === 'void';
        var animationOptions = { params: Object(tslib_es6["__assign"])({}, transitionAnimationParams, nextAnimationParams) };
        var timelines = skipAstBuild ? [] : buildAnimationTimelines(driver, element, this.ast.animation, enterClassName, leaveClassName, currentStateStyles, nextStateStyles, animationOptions, subInstructions, errors);
        var totalTime = 0;
        timelines.forEach(function (tl) { totalTime = Math.max(tl.duration + tl.delay, totalTime); });
        if (errors.length) {
            return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, [], [], preStyleMap, postStyleMap, totalTime, errors);
        }
        timelines.forEach(function (tl) {
            var elm = tl.element;
            var preProps = getOrSetAsInMap(preStyleMap, elm, {});
            tl.preStyleProps.forEach(function (prop) { return preProps[prop] = true; });
            var postProps = getOrSetAsInMap(postStyleMap, elm, {});
            tl.postStyleProps.forEach(function (prop) { return postProps[prop] = true; });
            if (elm !== element) {
                queriedElements.add(elm);
            }
        });
        var queriedElementsList = iteratorToArray(queriedElements.values());
        return createTransitionInstruction(element, this._triggerName, currentState, nextState, isRemoval, currentStateStyles, nextStateStyles, timelines, queriedElementsList, preStyleMap, postStyleMap, totalTime);
    };
    return AnimationTransitionFactory;
}());
function oneOrMoreTransitionsMatch(matchFns, currentState, nextState, element, params) {
    return matchFns.some(function (fn) { return fn(currentState, nextState, element, params); });
}
var AnimationStateStyles = /*@__PURE__*/ (function () {
    function AnimationStateStyles(styles, defaultParams) {
        this.styles = styles;
        this.defaultParams = defaultParams;
    }
    AnimationStateStyles.prototype.buildStyles = function (params, errors) {
        var finalStyles = {};
        var combinedParams = copyObj(this.defaultParams);
        Object.keys(params).forEach(function (key) {
            var value = params[key];
            if (value != null) {
                combinedParams[key] = value;
            }
        });
        this.styles.styles.forEach(function (value) {
            if (typeof value !== 'string') {
                var styleObj_1 = value;
                Object.keys(styleObj_1).forEach(function (prop) {
                    var val = styleObj_1[prop];
                    if (val.length > 1) {
                        val = interpolateParams(val, combinedParams, errors);
                    }
                    finalStyles[prop] = val;
                });
            }
        });
        return finalStyles;
    };
    return AnimationStateStyles;
}());
/**
 * @experimental Animation support is experimental.
 */
function buildTrigger(name, ast) {
    return new AnimationTrigger(name, ast);
}
/**
* @experimental Animation support is experimental.
*/
var AnimationTrigger = /*@__PURE__*/ (function () {
    function AnimationTrigger(name, ast) {
        var _this = this;
        this.name = name;
        this.ast = ast;
        this.transitionFactories = [];
        this.states = {};
        ast.states.forEach(function (ast) {
            var defaultParams = (ast.options && ast.options.params) || {};
            _this.states[ast.name] = new AnimationStateStyles(ast.style, defaultParams);
        });
        balanceProperties(this.states, 'true', '1');
        balanceProperties(this.states, 'false', '0');
        ast.transitions.forEach(function (ast) {
            _this.transitionFactories.push(new browser_AnimationTransitionFactory(name, ast, _this.states));
        });
        this.fallbackTransition = createFallbackTransition(name, this.states);
    }
    Object.defineProperty(AnimationTrigger.prototype, "containsQueries", {
        get: function () { return this.ast.queryCount > 0; },
        enumerable: true,
        configurable: true
    });
    AnimationTrigger.prototype.matchTransition = function (currentState, nextState, element, params) {
        var entry = this.transitionFactories.find(function (f) { return f.match(currentState, nextState, element, params); });
        return entry || null;
    };
    AnimationTrigger.prototype.matchStyles = function (currentState, params, errors) {
        return this.fallbackTransition.buildStyles(currentState, params, errors);
    };
    return AnimationTrigger;
}());
function createFallbackTransition(triggerName, states) {
    var matchers = [function (fromState, toState) { return true; }];
    var animation = { type: 2 /* Sequence */, steps: [], options: null };
    var transition = {
        type: 1 /* Transition */,
        animation: animation,
        matchers: matchers,
        options: null,
        queryCount: 0,
        depCount: 0
    };
    return new browser_AnimationTransitionFactory(triggerName, transition, states);
}
function balanceProperties(obj, key1, key2) {
    if (obj.hasOwnProperty(key1)) {
        if (!obj.hasOwnProperty(key2)) {
            obj[key2] = obj[key1];
        }
    }
    else if (obj.hasOwnProperty(key2)) {
        obj[key1] = obj[key2];
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EMPTY_INSTRUCTION_MAP = /*@__PURE__*/ new browser_ElementInstructionMap();
var browser_TimelineAnimationEngine = /*@__PURE__*/ (function () {
    function TimelineAnimationEngine(bodyNode, _driver, _normalizer) {
        this.bodyNode = bodyNode;
        this._driver = _driver;
        this._normalizer = _normalizer;
        this._animations = {};
        this._playersById = {};
        this.players = [];
    }
    TimelineAnimationEngine.prototype.register = function (id, metadata) {
        var errors = [];
        var ast = buildAnimationAst(this._driver, metadata, errors);
        if (errors.length) {
            throw new Error("Unable to build the animation due to the following errors: " + errors.join("\n"));
        }
        else {
            this._animations[id] = ast;
        }
    };
    TimelineAnimationEngine.prototype._buildPlayer = function (i, preStyles, postStyles) {
        var element = i.element;
        var keyframes = normalizeKeyframes(this._driver, this._normalizer, element, i.keyframes, preStyles, postStyles);
        return this._driver.animate(element, keyframes, i.duration, i.delay, i.easing, [], true);
    };
    TimelineAnimationEngine.prototype.create = function (id, element, options) {
        var _this = this;
        if (options === void 0) {
            options = {};
        }
        var errors = [];
        var ast = this._animations[id];
        var instructions;
        var autoStylesMap = new Map();
        if (ast) {
            instructions = buildAnimationTimelines(this._driver, element, ast, ENTER_CLASSNAME, LEAVE_CLASSNAME, {}, {}, options, EMPTY_INSTRUCTION_MAP, errors);
            instructions.forEach(function (inst) {
                var styles = getOrSetAsInMap(autoStylesMap, inst.element, {});
                inst.postStyleProps.forEach(function (prop) { return styles[prop] = null; });
            });
        }
        else {
            errors.push('The requested animation doesn\'t exist or has already been destroyed');
            instructions = [];
        }
        if (errors.length) {
            throw new Error("Unable to create the animation due to the following errors: " + errors.join("\n"));
        }
        autoStylesMap.forEach(function (styles, element) {
            Object.keys(styles).forEach(function (prop) { styles[prop] = _this._driver.computeStyle(element, prop, AUTO_STYLE); });
        });
        var players = instructions.map(function (i) {
            var styles = autoStylesMap.get(i.element);
            return _this._buildPlayer(i, {}, styles);
        });
        var player = optimizeGroupPlayer(players);
        this._playersById[id] = player;
        player.onDestroy(function () { return _this.destroy(id); });
        this.players.push(player);
        return player;
    };
    TimelineAnimationEngine.prototype.destroy = function (id) {
        var player = this._getPlayer(id);
        player.destroy();
        delete this._playersById[id];
        var index = this.players.indexOf(player);
        if (index >= 0) {
            this.players.splice(index, 1);
        }
    };
    TimelineAnimationEngine.prototype._getPlayer = function (id) {
        var player = this._playersById[id];
        if (!player) {
            throw new Error("Unable to find the timeline player referenced by " + id);
        }
        return player;
    };
    TimelineAnimationEngine.prototype.listen = function (id, element, eventName, callback) {
        // triggerName, fromState, toState are all ignored for timeline animations
        var baseEvent = makeAnimationEvent(element, '', '', '');
        listenOnPlayer(this._getPlayer(id), eventName, baseEvent, callback);
        return function () { };
    };
    TimelineAnimationEngine.prototype.command = function (id, element, command, args) {
        if (command == 'register') {
            this.register(id, args[0]);
            return;
        }
        if (command == 'create') {
            var options = (args[0] || {});
            this.create(id, element, options);
            return;
        }
        var player = this._getPlayer(id);
        switch (command) {
            case 'play':
                player.play();
                break;
            case 'pause':
                player.pause();
                break;
            case 'reset':
                player.reset();
                break;
            case 'restart':
                player.restart();
                break;
            case 'finish':
                player.finish();
                break;
            case 'init':
                player.init();
                break;
            case 'setPosition':
                player.setPosition(parseFloat(args[0]));
                break;
            case 'destroy':
                this.destroy(id);
                break;
        }
    };
    return TimelineAnimationEngine;
}());
var QUEUED_CLASSNAME = 'ng-animate-queued';
var QUEUED_SELECTOR = '.ng-animate-queued';
var DISABLED_CLASSNAME = 'ng-animate-disabled';
var DISABLED_SELECTOR = '.ng-animate-disabled';
var STAR_CLASSNAME = 'ng-star-inserted';
var STAR_SELECTOR = '.ng-star-inserted';
var EMPTY_PLAYER_ARRAY = [];
var NULL_REMOVAL_STATE = {
    namespaceId: '',
    setForRemoval: false,
    setForMove: false,
    hasAnimation: false,
    removedBeforeQueried: false
};
var NULL_REMOVED_QUERIED_STATE = {
    namespaceId: '',
    setForMove: false,
    setForRemoval: false,
    hasAnimation: false,
    removedBeforeQueried: true
};
var REMOVAL_FLAG = '__ng_removed';
var StateValue = /*@__PURE__*/ (function () {
    function StateValue(input, namespaceId) {
        if (namespaceId === void 0) {
            namespaceId = '';
        }
        this.namespaceId = namespaceId;
        var isObj = input && input.hasOwnProperty('value');
        var value = isObj ? input['value'] : input;
        this.value = normalizeTriggerValue(value);
        if (isObj) {
            var options = copyObj(input);
            delete options['value'];
            this.options = options;
        }
        else {
            this.options = {};
        }
        if (!this.options.params) {
            this.options.params = {};
        }
    }
    Object.defineProperty(StateValue.prototype, "params", {
        get: function () { return this.options.params; },
        enumerable: true,
        configurable: true
    });
    StateValue.prototype.absorbOptions = function (options) {
        var newParams = options.params;
        if (newParams) {
            var oldParams_1 = this.options.params;
            Object.keys(newParams).forEach(function (prop) {
                if (oldParams_1[prop] == null) {
                    oldParams_1[prop] = newParams[prop];
                }
            });
        }
    };
    return StateValue;
}());
var VOID_VALUE = 'void';
var DEFAULT_STATE_VALUE = /*@__PURE__*/ new StateValue(VOID_VALUE);
var AnimationTransitionNamespace = /*@__PURE__*/ (function () {
    function AnimationTransitionNamespace(id, hostElement, _engine) {
        this.id = id;
        this.hostElement = hostElement;
        this._engine = _engine;
        this.players = [];
        this._triggers = {};
        this._queue = [];
        this._elementListeners = new Map();
        this._hostClassName = 'ng-tns-' + id;
        addClass(hostElement, this._hostClassName);
    }
    AnimationTransitionNamespace.prototype.listen = function (element, name, phase, callback) {
        var _this = this;
        if (!this._triggers.hasOwnProperty(name)) {
            throw new Error("Unable to listen on the animation trigger event \"" + phase + "\" because the animation trigger \"" + name + "\" doesn't exist!");
        }
        if (phase == null || phase.length == 0) {
            throw new Error("Unable to listen on the animation trigger \"" + name + "\" because the provided event is undefined!");
        }
        if (!isTriggerEventValid(phase)) {
            throw new Error("The provided animation trigger event \"" + phase + "\" for the animation trigger \"" + name + "\" is not supported!");
        }
        var listeners = getOrSetAsInMap(this._elementListeners, element, []);
        var data = { name: name, phase: phase, callback: callback };
        listeners.push(data);
        var triggersWithStates = getOrSetAsInMap(this._engine.statesByElement, element, {});
        if (!triggersWithStates.hasOwnProperty(name)) {
            addClass(element, NG_TRIGGER_CLASSNAME);
            addClass(element, NG_TRIGGER_CLASSNAME + '-' + name);
            triggersWithStates[name] = DEFAULT_STATE_VALUE;
        }
        return function () {
            // the event listener is removed AFTER the flush has occurred such
            // that leave animations callbacks can fire (otherwise if the node
            // is removed in between then the listeners would be deregistered)
            _this._engine.afterFlush(function () {
                var index = listeners.indexOf(data);
                if (index >= 0) {
                    listeners.splice(index, 1);
                }
                if (!_this._triggers[name]) {
                    delete triggersWithStates[name];
                }
            });
        };
    };
    AnimationTransitionNamespace.prototype.register = function (name, ast) {
        if (this._triggers[name]) {
            // throw
            return false;
        }
        else {
            this._triggers[name] = ast;
            return true;
        }
    };
    AnimationTransitionNamespace.prototype._getTrigger = function (name) {
        var trigger = this._triggers[name];
        if (!trigger) {
            throw new Error("The provided animation trigger \"" + name + "\" has not been registered!");
        }
        return trigger;
    };
    AnimationTransitionNamespace.prototype.trigger = function (element, triggerName, value, defaultToFallback) {
        var _this = this;
        if (defaultToFallback === void 0) {
            defaultToFallback = true;
        }
        var trigger = this._getTrigger(triggerName);
        var player = new browser_TransitionAnimationPlayer(this.id, triggerName, element);
        var triggersWithStates = this._engine.statesByElement.get(element);
        if (!triggersWithStates) {
            addClass(element, NG_TRIGGER_CLASSNAME);
            addClass(element, NG_TRIGGER_CLASSNAME + '-' + triggerName);
            this._engine.statesByElement.set(element, triggersWithStates = {});
        }
        var fromState = triggersWithStates[triggerName];
        var toState = new StateValue(value, this.id);
        var isObj = value && value.hasOwnProperty('value');
        if (!isObj && fromState) {
            toState.absorbOptions(fromState.options);
        }
        triggersWithStates[triggerName] = toState;
        if (!fromState) {
            fromState = DEFAULT_STATE_VALUE;
        }
        var isRemoval = toState.value === VOID_VALUE;
        // normally this isn't reached by here, however, if an object expression
        // is passed in then it may be a new object each time. Comparing the value
        // is important since that will stay the same despite there being a new object.
        // The removal arc here is special cased because the same element is triggered
        // twice in the event that it contains animations on the outer/inner portions
        // of the host container
        if (!isRemoval && fromState.value === toState.value) {
            // this means that despite the value not changing, some inner params
            // have changed which means that the animation final styles need to be applied
            if (!objEquals(fromState.params, toState.params)) {
                var errors = [];
                var fromStyles_1 = trigger.matchStyles(fromState.value, fromState.params, errors);
                var toStyles_1 = trigger.matchStyles(toState.value, toState.params, errors);
                if (errors.length) {
                    this._engine.reportError(errors);
                }
                else {
                    this._engine.afterFlush(function () {
                        eraseStyles(element, fromStyles_1);
                        setStyles(element, toStyles_1);
                    });
                }
            }
            return;
        }
        var playersOnElement = getOrSetAsInMap(this._engine.playersByElement, element, []);
        playersOnElement.forEach(function (player) {
            // only remove the player if it is queued on the EXACT same trigger/namespace
            // we only also deal with queued players here because if the animation has
            // started then we want to keep the player alive until the flush happens
            // (which is where the previousPlayers are passed into the new palyer)
            if (player.namespaceId == _this.id && player.triggerName == triggerName && player.queued) {
                player.destroy();
            }
        });
        var transition = trigger.matchTransition(fromState.value, toState.value, element, toState.params);
        var isFallbackTransition = false;
        if (!transition) {
            if (!defaultToFallback)
                return;
            transition = trigger.fallbackTransition;
            isFallbackTransition = true;
        }
        this._engine.totalQueuedPlayers++;
        this._queue.push({ element: element, triggerName: triggerName, transition: transition, fromState: fromState, toState: toState, player: player, isFallbackTransition: isFallbackTransition });
        if (!isFallbackTransition) {
            addClass(element, QUEUED_CLASSNAME);
            player.onStart(function () { removeClass(element, QUEUED_CLASSNAME); });
        }
        player.onDone(function () {
            var index = _this.players.indexOf(player);
            if (index >= 0) {
                _this.players.splice(index, 1);
            }
            var players = _this._engine.playersByElement.get(element);
            if (players) {
                var index_1 = players.indexOf(player);
                if (index_1 >= 0) {
                    players.splice(index_1, 1);
                }
            }
        });
        this.players.push(player);
        playersOnElement.push(player);
        return player;
    };
    AnimationTransitionNamespace.prototype.deregister = function (name) {
        var _this = this;
        delete this._triggers[name];
        this._engine.statesByElement.forEach(function (stateMap, element) { delete stateMap[name]; });
        this._elementListeners.forEach(function (listeners, element) {
            _this._elementListeners.set(element, listeners.filter(function (entry) { return entry.name != name; }));
        });
    };
    AnimationTransitionNamespace.prototype.clearElementCache = function (element) {
        this._engine.statesByElement.delete(element);
        this._elementListeners.delete(element);
        var elementPlayers = this._engine.playersByElement.get(element);
        if (elementPlayers) {
            elementPlayers.forEach(function (player) { return player.destroy(); });
            this._engine.playersByElement.delete(element);
        }
    };
    AnimationTransitionNamespace.prototype._signalRemovalForInnerTriggers = function (rootElement, context, animate) {
        var _this = this;
        if (animate === void 0) {
            animate = false;
        }
        // emulate a leave animation for all inner nodes within this node.
        // If there are no animations found for any of the nodes then clear the cache
        // for the element.
        this._engine.driver.query(rootElement, NG_TRIGGER_SELECTOR, true).forEach(function (elm) {
            // this means that an inner remove() operation has already kicked off
            // the animation on this element...
            if (elm[REMOVAL_FLAG])
                return;
            var namespaces = _this._engine.fetchNamespacesByElement(elm);
            if (namespaces.size) {
                namespaces.forEach(function (ns) { return ns.triggerLeaveAnimation(elm, context, false, true); });
            }
            else {
                _this.clearElementCache(elm);
            }
        });
    };
    AnimationTransitionNamespace.prototype.triggerLeaveAnimation = function (element, context, destroyAfterComplete, defaultToFallback) {
        var _this = this;
        var triggerStates = this._engine.statesByElement.get(element);
        if (triggerStates) {
            var players_1 = [];
            Object.keys(triggerStates).forEach(function (triggerName) {
                // this check is here in the event that an element is removed
                // twice (both on the host level and the component level)
                if (_this._triggers[triggerName]) {
                    var player = _this.trigger(element, triggerName, VOID_VALUE, defaultToFallback);
                    if (player) {
                        players_1.push(player);
                    }
                }
            });
            if (players_1.length) {
                this._engine.markElementAsRemoved(this.id, element, true, context);
                if (destroyAfterComplete) {
                    optimizeGroupPlayer(players_1).onDone(function () { return _this._engine.processLeaveNode(element); });
                }
                return true;
            }
        }
        return false;
    };
    AnimationTransitionNamespace.prototype.prepareLeaveAnimationListeners = function (element) {
        var _this = this;
        var listeners = this._elementListeners.get(element);
        if (listeners) {
            var visitedTriggers_1 = new Set();
            listeners.forEach(function (listener) {
                var triggerName = listener.name;
                if (visitedTriggers_1.has(triggerName))
                    return;
                visitedTriggers_1.add(triggerName);
                var trigger = _this._triggers[triggerName];
                var transition = trigger.fallbackTransition;
                var elementStates = _this._engine.statesByElement.get(element);
                var fromState = elementStates[triggerName] || DEFAULT_STATE_VALUE;
                var toState = new StateValue(VOID_VALUE);
                var player = new browser_TransitionAnimationPlayer(_this.id, triggerName, element);
                _this._engine.totalQueuedPlayers++;
                _this._queue.push({
                    element: element,
                    triggerName: triggerName,
                    transition: transition,
                    fromState: fromState,
                    toState: toState,
                    player: player,
                    isFallbackTransition: true
                });
            });
        }
    };
    AnimationTransitionNamespace.prototype.removeNode = function (element, context) {
        var _this = this;
        var engine = this._engine;
        if (element.childElementCount) {
            this._signalRemovalForInnerTriggers(element, context, true);
        }
        // this means that a * => VOID animation was detected and kicked off
        if (this.triggerLeaveAnimation(element, context, true))
            return;
        // find the player that is animating and make sure that the
        // removal is delayed until that player has completed
        var containsPotentialParentTransition = false;
        if (engine.totalAnimations) {
            var currentPlayers = engine.players.length ? engine.playersByQueriedElement.get(element) : [];
            // when this `if statement` does not continue forward it means that
            // a previous animation query has selected the current element and
            // is animating it. In this situation want to continue forwards and
            // allow the element to be queued up for animation later.
            if (currentPlayers && currentPlayers.length) {
                containsPotentialParentTransition = true;
            }
            else {
                var parent_1 = element;
                while (parent_1 = parent_1.parentNode) {
                    var triggers = engine.statesByElement.get(parent_1);
                    if (triggers) {
                        containsPotentialParentTransition = true;
                        break;
                    }
                }
            }
        }
        // at this stage we know that the element will either get removed
        // during flush or will be picked up by a parent query. Either way
        // we need to fire the listeners for this element when it DOES get
        // removed (once the query parent animation is done or after flush)
        this.prepareLeaveAnimationListeners(element);
        // whether or not a parent has an animation we need to delay the deferral of the leave
        // operation until we have more information (which we do after flush() has been called)
        if (containsPotentialParentTransition) {
            engine.markElementAsRemoved(this.id, element, false, context);
        }
        else {
            // we do this after the flush has occurred such
            // that the callbacks can be fired
            engine.afterFlush(function () { return _this.clearElementCache(element); });
            engine.destroyInnerAnimations(element);
            engine._onRemovalComplete(element, context);
        }
    };
    AnimationTransitionNamespace.prototype.insertNode = function (element, parent) { addClass(element, this._hostClassName); };
    AnimationTransitionNamespace.prototype.drainQueuedTransitions = function (microtaskId) {
        var _this = this;
        var instructions = [];
        this._queue.forEach(function (entry) {
            var player = entry.player;
            if (player.destroyed)
                return;
            var element = entry.element;
            var listeners = _this._elementListeners.get(element);
            if (listeners) {
                listeners.forEach(function (listener) {
                    if (listener.name == entry.triggerName) {
                        var baseEvent = makeAnimationEvent(element, entry.triggerName, entry.fromState.value, entry.toState.value);
                        baseEvent['_data'] = microtaskId;
                        listenOnPlayer(entry.player, listener.phase, baseEvent, listener.callback);
                    }
                });
            }
            if (player.markedForDestroy) {
                _this._engine.afterFlush(function () {
                    // now we can destroy the element properly since the event listeners have
                    // been bound to the player
                    player.destroy();
                });
            }
            else {
                instructions.push(entry);
            }
        });
        this._queue = [];
        return instructions.sort(function (a, b) {
            // if depCount == 0 them move to front
            // otherwise if a contains b then move back
            var d0 = a.transition.ast.depCount;
            var d1 = b.transition.ast.depCount;
            if (d0 == 0 || d1 == 0) {
                return d0 - d1;
            }
            return _this._engine.driver.containsElement(a.element, b.element) ? 1 : -1;
        });
    };
    AnimationTransitionNamespace.prototype.destroy = function (context) {
        this.players.forEach(function (p) { return p.destroy(); });
        this._signalRemovalForInnerTriggers(this.hostElement, context);
    };
    AnimationTransitionNamespace.prototype.elementContainsData = function (element) {
        var containsData = false;
        if (this._elementListeners.has(element))
            containsData = true;
        containsData =
            (this._queue.find(function (entry) { return entry.element === element; }) ? true : false) || containsData;
        return containsData;
    };
    return AnimationTransitionNamespace;
}());
var browser_TransitionAnimationEngine = /*@__PURE__*/ (function () {
    function TransitionAnimationEngine(bodyNode, driver, _normalizer) {
        this.bodyNode = bodyNode;
        this.driver = driver;
        this._normalizer = _normalizer;
        this.players = [];
        this.newHostElements = new Map();
        this.playersByElement = new Map();
        this.playersByQueriedElement = new Map();
        this.statesByElement = new Map();
        this.disabledNodes = new Set();
        this.totalAnimations = 0;
        this.totalQueuedPlayers = 0;
        this._namespaceLookup = {};
        this._namespaceList = [];
        this._flushFns = [];
        this._whenQuietFns = [];
        this.namespacesByHostElement = new Map();
        this.collectedEnterElements = [];
        this.collectedLeaveElements = [];
        // this method is designed to be overridden by the code that uses this engine
        this.onRemovalComplete = function (element, context) { };
    }
    /** @internal */
    TransitionAnimationEngine.prototype._onRemovalComplete = function (element, context) { this.onRemovalComplete(element, context); };
    Object.defineProperty(TransitionAnimationEngine.prototype, "queuedPlayers", {
        get: function () {
            var players = [];
            this._namespaceList.forEach(function (ns) {
                ns.players.forEach(function (player) {
                    if (player.queued) {
                        players.push(player);
                    }
                });
            });
            return players;
        },
        enumerable: true,
        configurable: true
    });
    TransitionAnimationEngine.prototype.createNamespace = function (namespaceId, hostElement) {
        var ns = new AnimationTransitionNamespace(namespaceId, hostElement, this);
        if (hostElement.parentNode) {
            this._balanceNamespaceList(ns, hostElement);
        }
        else {
            // defer this later until flush during when the host element has
            // been inserted so that we know exactly where to place it in
            // the namespace list
            this.newHostElements.set(hostElement, ns);
            // given that this host element is apart of the animation code, it
            // may or may not be inserted by a parent node that is an of an
            // animation renderer type. If this happens then we can still have
            // access to this item when we query for :enter nodes. If the parent
            // is a renderer then the set data-structure will normalize the entry
            this.collectEnterElement(hostElement);
        }
        return this._namespaceLookup[namespaceId] = ns;
    };
    TransitionAnimationEngine.prototype._balanceNamespaceList = function (ns, hostElement) {
        var limit = this._namespaceList.length - 1;
        if (limit >= 0) {
            var found = false;
            for (var i = limit; i >= 0; i--) {
                var nextNamespace = this._namespaceList[i];
                if (this.driver.containsElement(nextNamespace.hostElement, hostElement)) {
                    this._namespaceList.splice(i + 1, 0, ns);
                    found = true;
                    break;
                }
            }
            if (!found) {
                this._namespaceList.splice(0, 0, ns);
            }
        }
        else {
            this._namespaceList.push(ns);
        }
        this.namespacesByHostElement.set(hostElement, ns);
        return ns;
    };
    TransitionAnimationEngine.prototype.register = function (namespaceId, hostElement) {
        var ns = this._namespaceLookup[namespaceId];
        if (!ns) {
            ns = this.createNamespace(namespaceId, hostElement);
        }
        return ns;
    };
    TransitionAnimationEngine.prototype.registerTrigger = function (namespaceId, name, trigger) {
        var ns = this._namespaceLookup[namespaceId];
        if (ns && ns.register(name, trigger)) {
            this.totalAnimations++;
        }
    };
    TransitionAnimationEngine.prototype.destroy = function (namespaceId, context) {
        var _this = this;
        if (!namespaceId)
            return;
        var ns = this._fetchNamespace(namespaceId);
        this.afterFlush(function () {
            _this.namespacesByHostElement.delete(ns.hostElement);
            delete _this._namespaceLookup[namespaceId];
            var index = _this._namespaceList.indexOf(ns);
            if (index >= 0) {
                _this._namespaceList.splice(index, 1);
            }
        });
        this.afterFlushAnimationsDone(function () { return ns.destroy(context); });
    };
    TransitionAnimationEngine.prototype._fetchNamespace = function (id) { return this._namespaceLookup[id]; };
    TransitionAnimationEngine.prototype.fetchNamespacesByElement = function (element) {
        // normally there should only be one namespace per element, however
        // if @triggers are placed on both the component element and then
        // its host element (within the component code) then there will be
        // two namespaces returned. We use a set here to simply the dedupe
        // of namespaces incase there are multiple triggers both the elm and host
        var namespaces = new Set();
        var elementStates = this.statesByElement.get(element);
        if (elementStates) {
            var keys = Object.keys(elementStates);
            for (var i = 0; i < keys.length; i++) {
                var nsId = elementStates[keys[i]].namespaceId;
                if (nsId) {
                    var ns = this._fetchNamespace(nsId);
                    if (ns) {
                        namespaces.add(ns);
                    }
                }
            }
        }
        return namespaces;
    };
    TransitionAnimationEngine.prototype.trigger = function (namespaceId, element, name, value) {
        if (isElementNode(element)) {
            var ns = this._fetchNamespace(namespaceId);
            if (ns) {
                ns.trigger(element, name, value);
                return true;
            }
        }
        return false;
    };
    TransitionAnimationEngine.prototype.insertNode = function (namespaceId, element, parent, insertBefore) {
        if (!isElementNode(element))
            return;
        // special case for when an element is removed and reinserted (move operation)
        // when this occurs we do not want to use the element for deletion later
        var details = element[REMOVAL_FLAG];
        if (details && details.setForRemoval) {
            details.setForRemoval = false;
            details.setForMove = true;
            var index = this.collectedLeaveElements.indexOf(element);
            if (index >= 0) {
                this.collectedLeaveElements.splice(index, 1);
            }
        }
        // in the event that the namespaceId is blank then the caller
        // code does not contain any animation code in it, but it is
        // just being called so that the node is marked as being inserted
        if (namespaceId) {
            var ns = this._fetchNamespace(namespaceId);
            // This if-statement is a workaround for router issue #21947.
            // The router sometimes hits a race condition where while a route
            // is being instantiated a new navigation arrives, triggering leave
            // animation of DOM that has not been fully initialized, until this
            // is resolved, we need to handle the scenario when DOM is not in a
            // consistent state during the animation.
            if (ns) {
                ns.insertNode(element, parent);
            }
        }
        // only *directives and host elements are inserted before
        if (insertBefore) {
            this.collectEnterElement(element);
        }
    };
    TransitionAnimationEngine.prototype.collectEnterElement = function (element) { this.collectedEnterElements.push(element); };
    TransitionAnimationEngine.prototype.markElementAsDisabled = function (element, value) {
        if (value) {
            if (!this.disabledNodes.has(element)) {
                this.disabledNodes.add(element);
                addClass(element, DISABLED_CLASSNAME);
            }
        }
        else if (this.disabledNodes.has(element)) {
            this.disabledNodes.delete(element);
            removeClass(element, DISABLED_CLASSNAME);
        }
    };
    TransitionAnimationEngine.prototype.removeNode = function (namespaceId, element, context) {
        if (!isElementNode(element)) {
            this._onRemovalComplete(element, context);
            return;
        }
        var ns = namespaceId ? this._fetchNamespace(namespaceId) : null;
        if (ns) {
            ns.removeNode(element, context);
        }
        else {
            this.markElementAsRemoved(namespaceId, element, false, context);
        }
    };
    TransitionAnimationEngine.prototype.markElementAsRemoved = function (namespaceId, element, hasAnimation, context) {
        this.collectedLeaveElements.push(element);
        element[REMOVAL_FLAG] = {
            namespaceId: namespaceId,
            setForRemoval: context, hasAnimation: hasAnimation,
            removedBeforeQueried: false
        };
    };
    TransitionAnimationEngine.prototype.listen = function (namespaceId, element, name, phase, callback) {
        if (isElementNode(element)) {
            return this._fetchNamespace(namespaceId).listen(element, name, phase, callback);
        }
        return function () { };
    };
    TransitionAnimationEngine.prototype._buildInstruction = function (entry, subTimelines, enterClassName, leaveClassName, skipBuildAst) {
        return entry.transition.build(this.driver, entry.element, entry.fromState.value, entry.toState.value, enterClassName, leaveClassName, entry.fromState.options, entry.toState.options, subTimelines, skipBuildAst);
    };
    TransitionAnimationEngine.prototype.destroyInnerAnimations = function (containerElement) {
        var _this = this;
        var elements = this.driver.query(containerElement, NG_TRIGGER_SELECTOR, true);
        elements.forEach(function (element) { return _this.destroyActiveAnimationsForElement(element); });
        if (this.playersByQueriedElement.size == 0)
            return;
        elements = this.driver.query(containerElement, NG_ANIMATING_SELECTOR, true);
        elements.forEach(function (element) { return _this.finishActiveQueriedAnimationOnElement(element); });
    };
    TransitionAnimationEngine.prototype.destroyActiveAnimationsForElement = function (element) {
        var players = this.playersByElement.get(element);
        if (players) {
            players.forEach(function (player) {
                // special case for when an element is set for destruction, but hasn't started.
                // in this situation we want to delay the destruction until the flush occurs
                // so that any event listeners attached to the player are triggered.
                if (player.queued) {
                    player.markedForDestroy = true;
                }
                else {
                    player.destroy();
                }
            });
        }
    };
    TransitionAnimationEngine.prototype.finishActiveQueriedAnimationOnElement = function (element) {
        var players = this.playersByQueriedElement.get(element);
        if (players) {
            players.forEach(function (player) { return player.finish(); });
        }
    };
    TransitionAnimationEngine.prototype.whenRenderingDone = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.players.length) {
                return optimizeGroupPlayer(_this.players).onDone(function () { return resolve(); });
            }
            else {
                resolve();
            }
        });
    };
    TransitionAnimationEngine.prototype.processLeaveNode = function (element) {
        var _this = this;
        var details = element[REMOVAL_FLAG];
        if (details && details.setForRemoval) {
            // this will prevent it from removing it twice
            element[REMOVAL_FLAG] = NULL_REMOVAL_STATE;
            if (details.namespaceId) {
                this.destroyInnerAnimations(element);
                var ns = this._fetchNamespace(details.namespaceId);
                if (ns) {
                    ns.clearElementCache(element);
                }
            }
            this._onRemovalComplete(element, details.setForRemoval);
        }
        if (this.driver.matchesElement(element, DISABLED_SELECTOR)) {
            this.markElementAsDisabled(element, false);
        }
        this.driver.query(element, DISABLED_SELECTOR, true).forEach(function (node) {
            _this.markElementAsDisabled(element, false);
        });
    };
    TransitionAnimationEngine.prototype.flush = function (microtaskId) {
        var _this = this;
        if (microtaskId === void 0) {
            microtaskId = -1;
        }
        var players = [];
        if (this.newHostElements.size) {
            this.newHostElements.forEach(function (ns, element) { return _this._balanceNamespaceList(ns, element); });
            this.newHostElements.clear();
        }
        if (this.totalAnimations && this.collectedEnterElements.length) {
            for (var i = 0; i < this.collectedEnterElements.length; i++) {
                var elm = this.collectedEnterElements[i];
                addClass(elm, STAR_CLASSNAME);
            }
        }
        if (this._namespaceList.length &&
            (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
            var cleanupFns = [];
            try {
                players = this._flushAnimations(cleanupFns, microtaskId);
            }
            finally {
                for (var i = 0; i < cleanupFns.length; i++) {
                    cleanupFns[i]();
                }
            }
        }
        else {
            for (var i = 0; i < this.collectedLeaveElements.length; i++) {
                var element = this.collectedLeaveElements[i];
                this.processLeaveNode(element);
            }
        }
        this.totalQueuedPlayers = 0;
        this.collectedEnterElements.length = 0;
        this.collectedLeaveElements.length = 0;
        this._flushFns.forEach(function (fn) { return fn(); });
        this._flushFns = [];
        if (this._whenQuietFns.length) {
            // we move these over to a variable so that
            // if any new callbacks are registered in another
            // flush they do not populate the existing set
            var quietFns_1 = this._whenQuietFns;
            this._whenQuietFns = [];
            if (players.length) {
                optimizeGroupPlayer(players).onDone(function () { quietFns_1.forEach(function (fn) { return fn(); }); });
            }
            else {
                quietFns_1.forEach(function (fn) { return fn(); });
            }
        }
    };
    TransitionAnimationEngine.prototype.reportError = function (errors) {
        throw new Error("Unable to process animations due to the following failed trigger transitions\n " + errors.join('\n'));
    };
    TransitionAnimationEngine.prototype._flushAnimations = function (cleanupFns, microtaskId) {
        var _this = this;
        var subTimelines = new browser_ElementInstructionMap();
        var skippedPlayers = [];
        var skippedPlayersMap = new Map();
        var queuedInstructions = [];
        var queriedElements = new Map();
        var allPreStyleElements = new Map();
        var allPostStyleElements = new Map();
        var disabledElementsSet = new Set();
        this.disabledNodes.forEach(function (node) {
            disabledElementsSet.add(node);
            var nodesThatAreDisabled = _this.driver.query(node, QUEUED_SELECTOR, true);
            for (var i_1 = 0; i_1 < nodesThatAreDisabled.length; i_1++) {
                disabledElementsSet.add(nodesThatAreDisabled[i_1]);
            }
        });
        var bodyNode = this.bodyNode;
        var allTriggerElements = Array.from(this.statesByElement.keys());
        var enterNodeMap = buildRootMap(allTriggerElements, this.collectedEnterElements);
        // this must occur before the instructions are built below such that
        // the :enter queries match the elements (since the timeline queries
        // are fired during instruction building).
        var enterNodeMapIds = new Map();
        var i = 0;
        enterNodeMap.forEach(function (nodes, root) {
            var className = ENTER_CLASSNAME + i++;
            enterNodeMapIds.set(root, className);
            nodes.forEach(function (node) { return addClass(node, className); });
        });
        var allLeaveNodes = [];
        var mergedLeaveNodes = new Set();
        var leaveNodesWithoutAnimations = new Set();
        for (var i_2 = 0; i_2 < this.collectedLeaveElements.length; i_2++) {
            var element = this.collectedLeaveElements[i_2];
            var details = element[REMOVAL_FLAG];
            if (details && details.setForRemoval) {
                allLeaveNodes.push(element);
                mergedLeaveNodes.add(element);
                if (details.hasAnimation) {
                    this.driver.query(element, STAR_SELECTOR, true).forEach(function (elm) { return mergedLeaveNodes.add(elm); });
                }
                else {
                    leaveNodesWithoutAnimations.add(element);
                }
            }
        }
        var leaveNodeMapIds = new Map();
        var leaveNodeMap = buildRootMap(allTriggerElements, Array.from(mergedLeaveNodes));
        leaveNodeMap.forEach(function (nodes, root) {
            var className = LEAVE_CLASSNAME + i++;
            leaveNodeMapIds.set(root, className);
            nodes.forEach(function (node) { return addClass(node, className); });
        });
        cleanupFns.push(function () {
            enterNodeMap.forEach(function (nodes, root) {
                var className = enterNodeMapIds.get(root);
                nodes.forEach(function (node) { return removeClass(node, className); });
            });
            leaveNodeMap.forEach(function (nodes, root) {
                var className = leaveNodeMapIds.get(root);
                nodes.forEach(function (node) { return removeClass(node, className); });
            });
            allLeaveNodes.forEach(function (element) { _this.processLeaveNode(element); });
        });
        var allPlayers = [];
        var erroneousTransitions = [];
        for (var i_3 = this._namespaceList.length - 1; i_3 >= 0; i_3--) {
            var ns = this._namespaceList[i_3];
            ns.drainQueuedTransitions(microtaskId).forEach(function (entry) {
                var player = entry.player;
                var element = entry.element;
                allPlayers.push(player);
                if (_this.collectedEnterElements.length) {
                    var details = element[REMOVAL_FLAG];
                    // move animations are currently not supported...
                    if (details && details.setForMove) {
                        player.destroy();
                        return;
                    }
                }
                var nodeIsOrphaned = !bodyNode || !_this.driver.containsElement(bodyNode, element);
                var leaveClassName = leaveNodeMapIds.get(element);
                var enterClassName = enterNodeMapIds.get(element);
                var instruction = _this._buildInstruction(entry, subTimelines, enterClassName, leaveClassName, nodeIsOrphaned);
                if (instruction.errors && instruction.errors.length) {
                    erroneousTransitions.push(instruction);
                    return;
                }
                // even though the element may not be apart of the DOM, it may
                // still be added at a later point (due to the mechanics of content
                // projection and/or dynamic component insertion) therefore it's
                // important we still style the element.
                if (nodeIsOrphaned) {
                    player.onStart(function () { return eraseStyles(element, instruction.fromStyles); });
                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                    skippedPlayers.push(player);
                    return;
                }
                // if a unmatched transition is queued to go then it SHOULD NOT render
                // an animation and cancel the previously running animations.
                if (entry.isFallbackTransition) {
                    player.onStart(function () { return eraseStyles(element, instruction.fromStyles); });
                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                    skippedPlayers.push(player);
                    return;
                }
                // this means that if a parent animation uses this animation as a sub trigger
                // then it will instruct the timeline builder to not add a player delay, but
                // instead stretch the first keyframe gap up until the animation starts. The
                // reason this is important is to prevent extra initialization styles from being
                // required by the user in the animation.
                instruction.timelines.forEach(function (tl) { return tl.stretchStartingKeyframe = true; });
                subTimelines.append(element, instruction.timelines);
                var tuple = { instruction: instruction, player: player, element: element };
                queuedInstructions.push(tuple);
                instruction.queriedElements.forEach(function (element) { return getOrSetAsInMap(queriedElements, element, []).push(player); });
                instruction.preStyleProps.forEach(function (stringMap, element) {
                    var props = Object.keys(stringMap);
                    if (props.length) {
                        var setVal_1 = allPreStyleElements.get(element);
                        if (!setVal_1) {
                            allPreStyleElements.set(element, setVal_1 = new Set());
                        }
                        props.forEach(function (prop) { return setVal_1.add(prop); });
                    }
                });
                instruction.postStyleProps.forEach(function (stringMap, element) {
                    var props = Object.keys(stringMap);
                    var setVal = allPostStyleElements.get(element);
                    if (!setVal) {
                        allPostStyleElements.set(element, setVal = new Set());
                    }
                    props.forEach(function (prop) { return setVal.add(prop); });
                });
            });
        }
        if (erroneousTransitions.length) {
            var errors_1 = [];
            erroneousTransitions.forEach(function (instruction) {
                errors_1.push("@" + instruction.triggerName + " has failed due to:\n");
                instruction.errors.forEach(function (error) { return errors_1.push("- " + error + "\n"); });
            });
            allPlayers.forEach(function (player) { return player.destroy(); });
            this.reportError(errors_1);
        }
        var allPreviousPlayersMap = new Map();
        // this map works to tell which element in the DOM tree is contained by
        // which animation. Further down below this map will get populated once
        // the players are built and in doing so it can efficiently figure out
        // if a sub player is skipped due to a parent player having priority.
        var animationElementMap = new Map();
        queuedInstructions.forEach(function (entry) {
            var element = entry.element;
            if (subTimelines.has(element)) {
                animationElementMap.set(element, element);
                _this._beforeAnimationBuild(entry.player.namespaceId, entry.instruction, allPreviousPlayersMap);
            }
        });
        skippedPlayers.forEach(function (player) {
            var element = player.element;
            var previousPlayers = _this._getPreviousPlayers(element, false, player.namespaceId, player.triggerName, null);
            previousPlayers.forEach(function (prevPlayer) {
                getOrSetAsInMap(allPreviousPlayersMap, element, []).push(prevPlayer);
                prevPlayer.destroy();
            });
        });
        // this is a special case for nodes that will be removed (either by)
        // having their own leave animations or by being queried in a container
        // that will be removed once a parent animation is complete. The idea
        // here is that * styles must be identical to ! styles because of
        // backwards compatibility (* is also filled in by default in many places).
        // Otherwise * styles will return an empty value or auto since the element
        // that is being getComputedStyle'd will not be visible (since * = destination)
        var replaceNodes = allLeaveNodes.filter(function (node) {
            return replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements);
        });
        // POST STAGE: fill the * styles
        var postStylesMap = new Map();
        var allLeaveQueriedNodes = cloakAndComputeStyles(postStylesMap, this.driver, leaveNodesWithoutAnimations, allPostStyleElements, AUTO_STYLE);
        allLeaveQueriedNodes.forEach(function (node) {
            if (replacePostStylesAsPre(node, allPreStyleElements, allPostStyleElements)) {
                replaceNodes.push(node);
            }
        });
        // PRE STAGE: fill the ! styles
        var preStylesMap = new Map();
        enterNodeMap.forEach(function (nodes, root) {
            cloakAndComputeStyles(preStylesMap, _this.driver, new Set(nodes), allPreStyleElements, ɵPRE_STYLE);
        });
        replaceNodes.forEach(function (node) {
            var post = postStylesMap.get(node);
            var pre = preStylesMap.get(node);
            postStylesMap.set(node, Object(tslib_es6["__assign"])({}, post, pre));
        });
        var rootPlayers = [];
        var subPlayers = [];
        var NO_PARENT_ANIMATION_ELEMENT_DETECTED = {};
        queuedInstructions.forEach(function (entry) {
            var element = entry.element, player = entry.player, instruction = entry.instruction;
            // this means that it was never consumed by a parent animation which
            // means that it is independent and therefore should be set for animation
            if (subTimelines.has(element)) {
                if (disabledElementsSet.has(element)) {
                    player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                    player.disabled = true;
                    player.overrideTotalTime(instruction.totalTime);
                    skippedPlayers.push(player);
                    return;
                }
                // this will flow up the DOM and query the map to figure out
                // if a parent animation has priority over it. In the situation
                // that a parent is detected then it will cancel the loop. If
                // nothing is detected, or it takes a few hops to find a parent,
                // then it will fill in the missing nodes and signal them as having
                // a detected parent (or a NO_PARENT value via a special constant).
                var parentWithAnimation_1 = NO_PARENT_ANIMATION_ELEMENT_DETECTED;
                if (animationElementMap.size > 1) {
                    var elm = element;
                    var parentsToAdd = [];
                    while (elm = elm.parentNode) {
                        var detectedParent = animationElementMap.get(elm);
                        if (detectedParent) {
                            parentWithAnimation_1 = detectedParent;
                            break;
                        }
                        parentsToAdd.push(elm);
                    }
                    parentsToAdd.forEach(function (parent) { return animationElementMap.set(parent, parentWithAnimation_1); });
                }
                var innerPlayer = _this._buildAnimation(player.namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap);
                player.setRealPlayer(innerPlayer);
                if (parentWithAnimation_1 === NO_PARENT_ANIMATION_ELEMENT_DETECTED) {
                    rootPlayers.push(player);
                }
                else {
                    var parentPlayers = _this.playersByElement.get(parentWithAnimation_1);
                    if (parentPlayers && parentPlayers.length) {
                        player.parentPlayer = optimizeGroupPlayer(parentPlayers);
                    }
                    skippedPlayers.push(player);
                }
            }
            else {
                eraseStyles(element, instruction.fromStyles);
                player.onDestroy(function () { return setStyles(element, instruction.toStyles); });
                // there still might be a ancestor player animating this
                // element therefore we will still add it as a sub player
                // even if its animation may be disabled
                subPlayers.push(player);
                if (disabledElementsSet.has(element)) {
                    skippedPlayers.push(player);
                }
            }
        });
        // find all of the sub players' corresponding inner animation player
        subPlayers.forEach(function (player) {
            // even if any players are not found for a sub animation then it
            // will still complete itself after the next tick since it's Noop
            var playersForElement = skippedPlayersMap.get(player.element);
            if (playersForElement && playersForElement.length) {
                var innerPlayer = optimizeGroupPlayer(playersForElement);
                player.setRealPlayer(innerPlayer);
            }
        });
        // the reason why we don't actually play the animation is
        // because all that a skipped player is designed to do is to
        // fire the start/done transition callback events
        skippedPlayers.forEach(function (player) {
            if (player.parentPlayer) {
                player.syncPlayerEvents(player.parentPlayer);
            }
            else {
                player.destroy();
            }
        });
        // run through all of the queued removals and see if they
        // were picked up by a query. If not then perform the removal
        // operation right away unless a parent animation is ongoing.
        for (var i_4 = 0; i_4 < allLeaveNodes.length; i_4++) {
            var element = allLeaveNodes[i_4];
            var details = element[REMOVAL_FLAG];
            removeClass(element, LEAVE_CLASSNAME);
            // this means the element has a removal animation that is being
            // taken care of and therefore the inner elements will hang around
            // until that animation is over (or the parent queried animation)
            if (details && details.hasAnimation)
                continue;
            var players = [];
            // if this element is queried or if it contains queried children
            // then we want for the element not to be removed from the page
            // until the queried animations have finished
            if (queriedElements.size) {
                var queriedPlayerResults = queriedElements.get(element);
                if (queriedPlayerResults && queriedPlayerResults.length) {
                    players.push.apply(players, Object(tslib_es6["__spread"])(queriedPlayerResults));
                }
                var queriedInnerElements = this.driver.query(element, NG_ANIMATING_SELECTOR, true);
                for (var j = 0; j < queriedInnerElements.length; j++) {
                    var queriedPlayers = queriedElements.get(queriedInnerElements[j]);
                    if (queriedPlayers && queriedPlayers.length) {
                        players.push.apply(players, Object(tslib_es6["__spread"])(queriedPlayers));
                    }
                }
            }
            var activePlayers = players.filter(function (p) { return !p.destroyed; });
            if (activePlayers.length) {
                removeNodesAfterAnimationDone(this, element, activePlayers);
            }
            else {
                this.processLeaveNode(element);
            }
        }
        // this is required so the cleanup method doesn't remove them
        allLeaveNodes.length = 0;
        rootPlayers.forEach(function (player) {
            _this.players.push(player);
            player.onDone(function () {
                player.destroy();
                var index = _this.players.indexOf(player);
                _this.players.splice(index, 1);
            });
            player.play();
        });
        return rootPlayers;
    };
    TransitionAnimationEngine.prototype.elementContainsData = function (namespaceId, element) {
        var containsData = false;
        var details = element[REMOVAL_FLAG];
        if (details && details.setForRemoval)
            containsData = true;
        if (this.playersByElement.has(element))
            containsData = true;
        if (this.playersByQueriedElement.has(element))
            containsData = true;
        if (this.statesByElement.has(element))
            containsData = true;
        return this._fetchNamespace(namespaceId).elementContainsData(element) || containsData;
    };
    TransitionAnimationEngine.prototype.afterFlush = function (callback) { this._flushFns.push(callback); };
    TransitionAnimationEngine.prototype.afterFlushAnimationsDone = function (callback) { this._whenQuietFns.push(callback); };
    TransitionAnimationEngine.prototype._getPreviousPlayers = function (element, isQueriedElement, namespaceId, triggerName, toStateValue) {
        var players = [];
        if (isQueriedElement) {
            var queriedElementPlayers = this.playersByQueriedElement.get(element);
            if (queriedElementPlayers) {
                players = queriedElementPlayers;
            }
        }
        else {
            var elementPlayers = this.playersByElement.get(element);
            if (elementPlayers) {
                var isRemovalAnimation_1 = !toStateValue || toStateValue == VOID_VALUE;
                elementPlayers.forEach(function (player) {
                    if (player.queued)
                        return;
                    if (!isRemovalAnimation_1 && player.triggerName != triggerName)
                        return;
                    players.push(player);
                });
            }
        }
        if (namespaceId || triggerName) {
            players = players.filter(function (player) {
                if (namespaceId && namespaceId != player.namespaceId)
                    return false;
                if (triggerName && triggerName != player.triggerName)
                    return false;
                return true;
            });
        }
        return players;
    };
    TransitionAnimationEngine.prototype._beforeAnimationBuild = function (namespaceId, instruction, allPreviousPlayersMap) {
        var e_1, _a;
        var triggerName = instruction.triggerName;
        var rootElement = instruction.element;
        // when a removal animation occurs, ALL previous players are collected
        // and destroyed (even if they are outside of the current namespace)
        var targetNameSpaceId = instruction.isRemovalTransition ? undefined : namespaceId;
        var targetTriggerName = instruction.isRemovalTransition ? undefined : triggerName;
        var _loop_1 = function (timelineInstruction) {
            var element = timelineInstruction.element;
            var isQueriedElement = element !== rootElement;
            var players = getOrSetAsInMap(allPreviousPlayersMap, element, []);
            var previousPlayers = this_1._getPreviousPlayers(element, isQueriedElement, targetNameSpaceId, targetTriggerName, instruction.toState);
            previousPlayers.forEach(function (player) {
                var realPlayer = player.getRealPlayer();
                if (realPlayer.beforeDestroy) {
                    realPlayer.beforeDestroy();
                }
                player.destroy();
                players.push(player);
            });
        };
        var this_1 = this;
        try {
            for (var _b = Object(tslib_es6["__values"])(instruction.timelines), _c = _b.next(); !_c.done; _c = _b.next()) {
                var timelineInstruction = _c.value;
                _loop_1(timelineInstruction);
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        // this needs to be done so that the PRE/POST styles can be
        // computed properly without interfering with the previous animation
        eraseStyles(rootElement, instruction.fromStyles);
    };
    TransitionAnimationEngine.prototype._buildAnimation = function (namespaceId, instruction, allPreviousPlayersMap, skippedPlayersMap, preStylesMap, postStylesMap) {
        var _this = this;
        var triggerName = instruction.triggerName;
        var rootElement = instruction.element;
        // we first run this so that the previous animation player
        // data can be passed into the successive animation players
        var allQueriedPlayers = [];
        var allConsumedElements = new Set();
        var allSubElements = new Set();
        var allNewPlayers = instruction.timelines.map(function (timelineInstruction) {
            var element = timelineInstruction.element;
            allConsumedElements.add(element);
            // FIXME (matsko): make sure to-be-removed animations are removed properly
            var details = element[REMOVAL_FLAG];
            if (details && details.removedBeforeQueried)
                return new NoopAnimationPlayer(timelineInstruction.duration, timelineInstruction.delay);
            var isQueriedElement = element !== rootElement;
            var previousPlayers = flattenGroupPlayers((allPreviousPlayersMap.get(element) || EMPTY_PLAYER_ARRAY)
                .map(function (p) { return p.getRealPlayer(); }))
                .filter(function (p) {
                // the `element` is not apart of the AnimationPlayer definition, but
                // Mock/WebAnimations
                // use the element within their implementation. This will be added in Angular5 to
                // AnimationPlayer
                var pp = p;
                return pp.element ? pp.element === element : false;
            });
            var preStyles = preStylesMap.get(element);
            var postStyles = postStylesMap.get(element);
            var keyframes = normalizeKeyframes(_this.driver, _this._normalizer, element, timelineInstruction.keyframes, preStyles, postStyles);
            var player = _this._buildPlayer(timelineInstruction, keyframes, previousPlayers);
            // this means that this particular player belongs to a sub trigger. It is
            // important that we match this player up with the corresponding (@trigger.listener)
            if (timelineInstruction.subTimeline && skippedPlayersMap) {
                allSubElements.add(element);
            }
            if (isQueriedElement) {
                var wrappedPlayer = new browser_TransitionAnimationPlayer(namespaceId, triggerName, element);
                wrappedPlayer.setRealPlayer(player);
                allQueriedPlayers.push(wrappedPlayer);
            }
            return player;
        });
        allQueriedPlayers.forEach(function (player) {
            getOrSetAsInMap(_this.playersByQueriedElement, player.element, []).push(player);
            player.onDone(function () { return deleteOrUnsetInMap(_this.playersByQueriedElement, player.element, player); });
        });
        allConsumedElements.forEach(function (element) { return addClass(element, NG_ANIMATING_CLASSNAME); });
        var player = optimizeGroupPlayer(allNewPlayers);
        player.onDestroy(function () {
            allConsumedElements.forEach(function (element) { return removeClass(element, NG_ANIMATING_CLASSNAME); });
            setStyles(rootElement, instruction.toStyles);
        });
        // this basically makes all of the callbacks for sub element animations
        // be dependent on the upper players for when they finish
        allSubElements.forEach(function (element) { getOrSetAsInMap(skippedPlayersMap, element, []).push(player); });
        return player;
    };
    TransitionAnimationEngine.prototype._buildPlayer = function (instruction, keyframes, previousPlayers) {
        if (keyframes.length > 0) {
            return this.driver.animate(instruction.element, keyframes, instruction.duration, instruction.delay, instruction.easing, previousPlayers);
        }
        // special case for when an empty transition|definition is provided
        // ... there is no point in rendering an empty animation
        return new NoopAnimationPlayer(instruction.duration, instruction.delay);
    };
    return TransitionAnimationEngine;
}());
var browser_TransitionAnimationPlayer = /*@__PURE__*/ (function () {
    function TransitionAnimationPlayer(namespaceId, triggerName, element) {
        this.namespaceId = namespaceId;
        this.triggerName = triggerName;
        this.element = element;
        this._player = new NoopAnimationPlayer();
        this._containsRealPlayer = false;
        this._queuedCallbacks = {};
        this.destroyed = false;
        this.markedForDestroy = false;
        this.disabled = false;
        this.queued = true;
        this.totalTime = 0;
    }
    TransitionAnimationPlayer.prototype.setRealPlayer = function (player) {
        var _this = this;
        if (this._containsRealPlayer)
            return;
        this._player = player;
        Object.keys(this._queuedCallbacks).forEach(function (phase) {
            _this._queuedCallbacks[phase].forEach(function (callback) { return listenOnPlayer(player, phase, undefined, callback); });
        });
        this._queuedCallbacks = {};
        this._containsRealPlayer = true;
        this.overrideTotalTime(player.totalTime);
        this.queued = false;
    };
    TransitionAnimationPlayer.prototype.getRealPlayer = function () { return this._player; };
    TransitionAnimationPlayer.prototype.overrideTotalTime = function (totalTime) { this.totalTime = totalTime; };
    TransitionAnimationPlayer.prototype.syncPlayerEvents = function (player) {
        var _this = this;
        var p = this._player;
        if (p.triggerCallback) {
            player.onStart(function () { return p.triggerCallback('start'); });
        }
        player.onDone(function () { return _this.finish(); });
        player.onDestroy(function () { return _this.destroy(); });
    };
    TransitionAnimationPlayer.prototype._queueEvent = function (name, callback) {
        getOrSetAsInMap(this._queuedCallbacks, name, []).push(callback);
    };
    TransitionAnimationPlayer.prototype.onDone = function (fn) {
        if (this.queued) {
            this._queueEvent('done', fn);
        }
        this._player.onDone(fn);
    };
    TransitionAnimationPlayer.prototype.onStart = function (fn) {
        if (this.queued) {
            this._queueEvent('start', fn);
        }
        this._player.onStart(fn);
    };
    TransitionAnimationPlayer.prototype.onDestroy = function (fn) {
        if (this.queued) {
            this._queueEvent('destroy', fn);
        }
        this._player.onDestroy(fn);
    };
    TransitionAnimationPlayer.prototype.init = function () { this._player.init(); };
    TransitionAnimationPlayer.prototype.hasStarted = function () { return this.queued ? false : this._player.hasStarted(); };
    TransitionAnimationPlayer.prototype.play = function () { !this.queued && this._player.play(); };
    TransitionAnimationPlayer.prototype.pause = function () { !this.queued && this._player.pause(); };
    TransitionAnimationPlayer.prototype.restart = function () { !this.queued && this._player.restart(); };
    TransitionAnimationPlayer.prototype.finish = function () { this._player.finish(); };
    TransitionAnimationPlayer.prototype.destroy = function () {
        this.destroyed = true;
        this._player.destroy();
    };
    TransitionAnimationPlayer.prototype.reset = function () { !this.queued && this._player.reset(); };
    TransitionAnimationPlayer.prototype.setPosition = function (p) {
        if (!this.queued) {
            this._player.setPosition(p);
        }
    };
    TransitionAnimationPlayer.prototype.getPosition = function () { return this.queued ? 0 : this._player.getPosition(); };
    /** @internal */
    TransitionAnimationPlayer.prototype.triggerCallback = function (phaseName) {
        var p = this._player;
        if (p.triggerCallback) {
            p.triggerCallback(phaseName);
        }
    };
    return TransitionAnimationPlayer;
}());
function deleteOrUnsetInMap(map, key, value) {
    var currentValues;
    if (map instanceof Map) {
        currentValues = map.get(key);
        if (currentValues) {
            if (currentValues.length) {
                var index = currentValues.indexOf(value);
                currentValues.splice(index, 1);
            }
            if (currentValues.length == 0) {
                map.delete(key);
            }
        }
    }
    else {
        currentValues = map[key];
        if (currentValues) {
            if (currentValues.length) {
                var index = currentValues.indexOf(value);
                currentValues.splice(index, 1);
            }
            if (currentValues.length == 0) {
                delete map[key];
            }
        }
    }
    return currentValues;
}
function normalizeTriggerValue(value) {
    // we use `!= null` here because it's the most simple
    // way to test against a "falsy" value without mixing
    // in empty strings or a zero value. DO NOT OPTIMIZE.
    return value != null ? value : null;
}
function isElementNode(node) {
    return node && node['nodeType'] === 1;
}
function isTriggerEventValid(eventName) {
    return eventName == 'start' || eventName == 'done';
}
function cloakElement(element, value) {
    var oldValue = element.style.display;
    element.style.display = value != null ? value : 'none';
    return oldValue;
}
function cloakAndComputeStyles(valuesMap, driver, elements, elementPropsMap, defaultStyle) {
    var cloakVals = [];
    elements.forEach(function (element) { return cloakVals.push(cloakElement(element)); });
    var failedElements = [];
    elementPropsMap.forEach(function (props, element) {
        var styles = {};
        props.forEach(function (prop) {
            var value = styles[prop] = driver.computeStyle(element, prop, defaultStyle);
            // there is no easy way to detect this because a sub element could be removed
            // by a parent animation element being detached.
            if (!value || value.length == 0) {
                element[REMOVAL_FLAG] = NULL_REMOVED_QUERIED_STATE;
                failedElements.push(element);
            }
        });
        valuesMap.set(element, styles);
    });
    // we use a index variable here since Set.forEach(a, i) does not return
    // an index value for the closure (but instead just the value)
    var i = 0;
    elements.forEach(function (element) { return cloakElement(element, cloakVals[i++]); });
    return failedElements;
}
/*
Since the Angular renderer code will return a collection of inserted
nodes in all areas of a DOM tree, it's up to this algorithm to figure
out which nodes are roots for each animation @trigger.

By placing each inserted node into a Set and traversing upwards, it
is possible to find the @trigger elements and well any direct *star
insertion nodes, if a @trigger root is found then the enter element
is placed into the Map[@trigger] spot.
 */
function buildRootMap(roots, nodes) {
    var rootMap = new Map();
    roots.forEach(function (root) { return rootMap.set(root, []); });
    if (nodes.length == 0)
        return rootMap;
    var NULL_NODE = 1;
    var nodeSet = new Set(nodes);
    var localRootMap = new Map();
    function getRoot(node) {
        if (!node)
            return NULL_NODE;
        var root = localRootMap.get(node);
        if (root)
            return root;
        var parent = node.parentNode;
        if (rootMap.has(parent)) {
            root = parent;
        }
        else if (nodeSet.has(parent)) {
            root = NULL_NODE;
        }
        else {
            root = getRoot(parent);
        }
        localRootMap.set(node, root);
        return root;
    }
    nodes.forEach(function (node) {
        var root = getRoot(node);
        if (root !== NULL_NODE) {
            rootMap.get(root).push(node);
        }
    });
    return rootMap;
}
var CLASSES_CACHE_KEY = '$$classes';
function addClass(element, className) {
    if (element.classList) {
        element.classList.add(className);
    }
    else {
        var classes = element[CLASSES_CACHE_KEY];
        if (!classes) {
            classes = element[CLASSES_CACHE_KEY] = {};
        }
        classes[className] = true;
    }
}
function removeClass(element, className) {
    if (element.classList) {
        element.classList.remove(className);
    }
    else {
        var classes = element[CLASSES_CACHE_KEY];
        if (classes) {
            delete classes[className];
        }
    }
}
function removeNodesAfterAnimationDone(engine, element, players) {
    optimizeGroupPlayer(players).onDone(function () { return engine.processLeaveNode(element); });
}
function flattenGroupPlayers(players) {
    var finalPlayers = [];
    _flattenGroupPlayersRecur(players, finalPlayers);
    return finalPlayers;
}
function _flattenGroupPlayersRecur(players, finalPlayers) {
    for (var i = 0; i < players.length; i++) {
        var player = players[i];
        if (player instanceof AnimationGroupPlayer) {
            _flattenGroupPlayersRecur(player.players, finalPlayers);
        }
        else {
            finalPlayers.push(player);
        }
    }
}
function objEquals(a, b) {
    var k1 = Object.keys(a);
    var k2 = Object.keys(b);
    if (k1.length != k2.length)
        return false;
    for (var i = 0; i < k1.length; i++) {
        var prop = k1[i];
        if (!b.hasOwnProperty(prop) || a[prop] !== b[prop])
            return false;
    }
    return true;
}
function replacePostStylesAsPre(element, allPreStyleElements, allPostStyleElements) {
    var postEntry = allPostStyleElements.get(element);
    if (!postEntry)
        return false;
    var preEntry = allPreStyleElements.get(element);
    if (preEntry) {
        postEntry.forEach(function (data) { return preEntry.add(data); });
    }
    else {
        allPreStyleElements.set(element, postEntry);
    }
    allPostStyleElements.delete(element);
    return true;
}
var browser_AnimationEngine = /*@__PURE__*/ (function () {
    function AnimationEngine(bodyNode, _driver, normalizer) {
        var _this = this;
        this.bodyNode = bodyNode;
        this._driver = _driver;
        this._triggerCache = {};
        // this method is designed to be overridden by the code that uses this engine
        this.onRemovalComplete = function (element, context) { };
        this._transitionEngine = new browser_TransitionAnimationEngine(bodyNode, _driver, normalizer);
        this._timelineEngine = new browser_TimelineAnimationEngine(bodyNode, _driver, normalizer);
        this._transitionEngine.onRemovalComplete = function (element, context) {
            return _this.onRemovalComplete(element, context);
        };
    }
    AnimationEngine.prototype.registerTrigger = function (componentId, namespaceId, hostElement, name, metadata) {
        var cacheKey = componentId + '-' + name;
        var trigger = this._triggerCache[cacheKey];
        if (!trigger) {
            var errors = [];
            var ast = buildAnimationAst(this._driver, metadata, errors);
            if (errors.length) {
                throw new Error("The animation trigger \"" + name + "\" has failed to build due to the following errors:\n - " + errors.join("\n - "));
            }
            trigger = buildTrigger(name, ast);
            this._triggerCache[cacheKey] = trigger;
        }
        this._transitionEngine.registerTrigger(namespaceId, name, trigger);
    };
    AnimationEngine.prototype.register = function (namespaceId, hostElement) {
        this._transitionEngine.register(namespaceId, hostElement);
    };
    AnimationEngine.prototype.destroy = function (namespaceId, context) {
        this._transitionEngine.destroy(namespaceId, context);
    };
    AnimationEngine.prototype.onInsert = function (namespaceId, element, parent, insertBefore) {
        this._transitionEngine.insertNode(namespaceId, element, parent, insertBefore);
    };
    AnimationEngine.prototype.onRemove = function (namespaceId, element, context) {
        this._transitionEngine.removeNode(namespaceId, element, context);
    };
    AnimationEngine.prototype.disableAnimations = function (element, disable) {
        this._transitionEngine.markElementAsDisabled(element, disable);
    };
    AnimationEngine.prototype.process = function (namespaceId, element, property, value) {
        if (property.charAt(0) == '@') {
            var _a = Object(tslib_es6["__read"])(parseTimelineCommand(property), 2), id = _a[0], action = _a[1];
            var args = value;
            this._timelineEngine.command(id, element, action, args);
        }
        else {
            this._transitionEngine.trigger(namespaceId, element, property, value);
        }
    };
    AnimationEngine.prototype.listen = function (namespaceId, element, eventName, eventPhase, callback) {
        // @@listen
        if (eventName.charAt(0) == '@') {
            var _a = Object(tslib_es6["__read"])(parseTimelineCommand(eventName), 2), id = _a[0], action = _a[1];
            return this._timelineEngine.listen(id, element, action, callback);
        }
        return this._transitionEngine.listen(namespaceId, element, eventName, eventPhase, callback);
    };
    AnimationEngine.prototype.flush = function (microtaskId) {
        if (microtaskId === void 0) {
            microtaskId = -1;
        }
        this._transitionEngine.flush(microtaskId);
    };
    Object.defineProperty(AnimationEngine.prototype, "players", {
        get: function () {
            return this._transitionEngine.players
                .concat(this._timelineEngine.players);
        },
        enumerable: true,
        configurable: true
    });
    AnimationEngine.prototype.whenRenderingDone = function () { return this._transitionEngine.whenRenderingDone(); };
    return AnimationEngine;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var ANIMATION_PROP = 'animation';
var ANIMATIONEND_EVENT = 'animationend';
var ONE_SECOND$1 = 1000;
var ElementAnimationStyleHandler = /*@__PURE__*/ (function () {
    function ElementAnimationStyleHandler(_element, _name, _duration, _delay, _easing, _fillMode, _onDoneFn) {
        var _this = this;
        this._element = _element;
        this._name = _name;
        this._duration = _duration;
        this._delay = _delay;
        this._easing = _easing;
        this._fillMode = _fillMode;
        this._onDoneFn = _onDoneFn;
        this._finished = false;
        this._destroyed = false;
        this._startTime = 0;
        this._position = 0;
        this._eventFn = function (e) { return _this._handleCallback(e); };
    }
    ElementAnimationStyleHandler.prototype.apply = function () {
        applyKeyframeAnimation(this._element, this._duration + "ms " + this._easing + " " + this._delay + "ms 1 normal " + this._fillMode + " " + this._name);
        addRemoveAnimationEvent(this._element, this._eventFn, false);
        this._startTime = Date.now();
    };
    ElementAnimationStyleHandler.prototype.pause = function () { playPauseAnimation(this._element, this._name, 'paused'); };
    ElementAnimationStyleHandler.prototype.resume = function () { playPauseAnimation(this._element, this._name, 'running'); };
    ElementAnimationStyleHandler.prototype.setPosition = function (position) {
        var index = findIndexForAnimation(this._element, this._name);
        this._position = position * this._duration;
        setAnimationStyle(this._element, 'Delay', "-" + this._position + "ms", index);
    };
    ElementAnimationStyleHandler.prototype.getPosition = function () { return this._position; };
    ElementAnimationStyleHandler.prototype._handleCallback = function (event) {
        var timestamp = event._ngTestManualTimestamp || Date.now();
        var elapsedTime = parseFloat(event.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES)) * ONE_SECOND$1;
        if (event.animationName == this._name &&
            Math.max(timestamp - this._startTime, 0) >= this._delay && elapsedTime >= this._duration) {
            this.finish();
        }
    };
    ElementAnimationStyleHandler.prototype.finish = function () {
        if (this._finished)
            return;
        this._finished = true;
        this._onDoneFn();
        addRemoveAnimationEvent(this._element, this._eventFn, true);
    };
    ElementAnimationStyleHandler.prototype.destroy = function () {
        if (this._destroyed)
            return;
        this._destroyed = true;
        this.finish();
        removeKeyframeAnimation(this._element, this._name);
    };
    return ElementAnimationStyleHandler;
}());
function playPauseAnimation(element, name, status) {
    var index = findIndexForAnimation(element, name);
    setAnimationStyle(element, 'PlayState', status, index);
}
function applyKeyframeAnimation(element, value) {
    var anim = getAnimationStyle(element, '').trim();
    var index = 0;
    if (anim.length) {
        index = countChars(anim, ',') + 1;
        value = anim + ", " + value;
    }
    setAnimationStyle(element, '', value);
    return index;
}
function removeKeyframeAnimation(element, name) {
    var anim = getAnimationStyle(element, '');
    var tokens = anim.split(',');
    var index = findMatchingTokenIndex(tokens, name);
    if (index >= 0) {
        tokens.splice(index, 1);
        var newValue = tokens.join(',');
        setAnimationStyle(element, '', newValue);
    }
}
function findIndexForAnimation(element, value) {
    var anim = getAnimationStyle(element, '');
    if (anim.indexOf(',') > 0) {
        var tokens = anim.split(',');
        return findMatchingTokenIndex(tokens, value);
    }
    return findMatchingTokenIndex([anim], value);
}
function findMatchingTokenIndex(tokens, searchToken) {
    for (var i = 0; i < tokens.length; i++) {
        if (tokens[i].indexOf(searchToken) >= 0) {
            return i;
        }
    }
    return -1;
}
function addRemoveAnimationEvent(element, fn, doRemove) {
    doRemove ? element.removeEventListener(ANIMATIONEND_EVENT, fn) :
        element.addEventListener(ANIMATIONEND_EVENT, fn);
}
function setAnimationStyle(element, name, value, index) {
    var prop = ANIMATION_PROP + name;
    if (index != null) {
        var oldValue = element.style[prop];
        if (oldValue.length) {
            var tokens = oldValue.split(',');
            tokens[index] = value;
            value = tokens.join(',');
        }
    }
    element.style[prop] = value;
}
function getAnimationStyle(element, name) {
    return element.style[ANIMATION_PROP + name];
}
function countChars(value, char) {
    var count = 0;
    for (var i = 0; i < value.length; i++) {
        var c = value.charAt(i);
        if (c === char)
            count++;
    }
    return count;
}
var DEFAULT_FILL_MODE = 'forwards';
var DEFAULT_EASING = 'linear';
var CssKeyframesPlayer = /*@__PURE__*/ (function () {
    function CssKeyframesPlayer(element, keyframes, animationName, _duration, _delay, easing, _finalStyles) {
        this.element = element;
        this.keyframes = keyframes;
        this.animationName = animationName;
        this._duration = _duration;
        this._delay = _delay;
        this._finalStyles = _finalStyles;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._started = false;
        this.currentSnapshot = {};
        this._state = 0;
        this.easing = easing || DEFAULT_EASING;
        this.totalTime = _duration + _delay;
        this._buildStyler();
    }
    CssKeyframesPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    CssKeyframesPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    CssKeyframesPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    CssKeyframesPlayer.prototype.destroy = function () {
        this.init();
        if (this._state >= 4 /* DESTROYED */)
            return;
        this._state = 4 /* DESTROYED */;
        this._styler.destroy();
        this._flushStartFns();
        this._flushDoneFns();
        this._onDestroyFns.forEach(function (fn) { return fn(); });
        this._onDestroyFns = [];
    };
    CssKeyframesPlayer.prototype._flushDoneFns = function () {
        this._onDoneFns.forEach(function (fn) { return fn(); });
        this._onDoneFns = [];
    };
    CssKeyframesPlayer.prototype._flushStartFns = function () {
        this._onStartFns.forEach(function (fn) { return fn(); });
        this._onStartFns = [];
    };
    CssKeyframesPlayer.prototype.finish = function () {
        this.init();
        if (this._state >= 3 /* FINISHED */)
            return;
        this._state = 3 /* FINISHED */;
        this._styler.finish();
        this._flushStartFns();
        this._flushDoneFns();
    };
    CssKeyframesPlayer.prototype.setPosition = function (value) { this._styler.setPosition(value); };
    CssKeyframesPlayer.prototype.getPosition = function () { return this._styler.getPosition(); };
    CssKeyframesPlayer.prototype.hasStarted = function () { return this._state >= 2 /* STARTED */; };
    CssKeyframesPlayer.prototype.init = function () {
        if (this._state >= 1 /* INITIALIZED */)
            return;
        this._state = 1 /* INITIALIZED */;
        var elm = this.element;
        this._styler.apply();
        if (this._delay) {
            this._styler.pause();
        }
    };
    CssKeyframesPlayer.prototype.play = function () {
        this.init();
        if (!this.hasStarted()) {
            this._flushStartFns();
            this._state = 2 /* STARTED */;
        }
        this._styler.resume();
    };
    CssKeyframesPlayer.prototype.pause = function () {
        this.init();
        this._styler.pause();
    };
    CssKeyframesPlayer.prototype.restart = function () {
        this.reset();
        this.play();
    };
    CssKeyframesPlayer.prototype.reset = function () {
        this._styler.destroy();
        this._buildStyler();
        this._styler.apply();
    };
    CssKeyframesPlayer.prototype._buildStyler = function () {
        var _this = this;
        this._styler = new ElementAnimationStyleHandler(this.element, this.animationName, this._duration, this._delay, this.easing, DEFAULT_FILL_MODE, function () { return _this.finish(); });
    };
    /** @internal */
    CssKeyframesPlayer.prototype.triggerCallback = function (phaseName) {
        var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
        methods.forEach(function (fn) { return fn(); });
        methods.length = 0;
    };
    CssKeyframesPlayer.prototype.beforeDestroy = function () {
        var _this = this;
        this.init();
        var styles = {};
        if (this.hasStarted()) {
            var finished_1 = this._state >= 3 /* FINISHED */;
            Object.keys(this._finalStyles).forEach(function (prop) {
                if (prop != 'offset') {
                    styles[prop] = finished_1 ? _this._finalStyles[prop] : computeStyle(_this.element, prop);
                }
            });
        }
        this.currentSnapshot = styles;
    };
    return CssKeyframesPlayer;
}());
var browser_DirectStylePlayer = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(DirectStylePlayer, _super);
    function DirectStylePlayer(element, styles) {
        var _this = _super.call(this) || this;
        _this.element = element;
        _this._startingStyles = {};
        _this.__initialized = false;
        _this._styles = hypenatePropsObject(styles);
        return _this;
    }
    DirectStylePlayer.prototype.init = function () {
        var _this = this;
        if (this.__initialized || !this._startingStyles)
            return;
        this.__initialized = true;
        Object.keys(this._styles).forEach(function (prop) {
            _this._startingStyles[prop] = _this.element.style[prop];
        });
        _super.prototype.init.call(this);
    };
    DirectStylePlayer.prototype.play = function () {
        var _this = this;
        if (!this._startingStyles)
            return;
        this.init();
        Object.keys(this._styles)
            .forEach(function (prop) { return _this.element.style.setProperty(prop, _this._styles[prop]); });
        _super.prototype.play.call(this);
    };
    DirectStylePlayer.prototype.destroy = function () {
        var _this = this;
        if (!this._startingStyles)
            return;
        Object.keys(this._startingStyles).forEach(function (prop) {
            var value = _this._startingStyles[prop];
            if (value) {
                _this.element.style.setProperty(prop, value);
            }
            else {
                _this.element.style.removeProperty(prop);
            }
        });
        this._startingStyles = null;
        _super.prototype.destroy.call(this);
    };
    return DirectStylePlayer;
}(NoopAnimationPlayer));
var KEYFRAMES_NAME_PREFIX = 'gen_css_kf_';
var TAB_SPACE = ' ';
var CssKeyframesDriver = /*@__PURE__*/ (function () {
    function CssKeyframesDriver() {
        this._count = 0;
        this._head = document.querySelector('head');
        this._warningIssued = false;
    }
    CssKeyframesDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
    CssKeyframesDriver.prototype.matchesElement = function (element, selector) {
        return matchesElement(element, selector);
    };
    CssKeyframesDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
    CssKeyframesDriver.prototype.query = function (element, selector, multi) {
        return invokeQuery(element, selector, multi);
    };
    CssKeyframesDriver.prototype.computeStyle = function (element, prop, defaultValue) {
        return window.getComputedStyle(element)[prop];
    };
    CssKeyframesDriver.prototype.buildKeyframeElement = function (element, name, keyframes) {
        keyframes = keyframes.map(function (kf) { return hypenatePropsObject(kf); });
        var keyframeStr = "@keyframes " + name + " {\n";
        var tab = '';
        keyframes.forEach(function (kf) {
            tab = TAB_SPACE;
            var offset = parseFloat(kf.offset);
            keyframeStr += "" + tab + offset * 100 + "% {\n";
            tab += TAB_SPACE;
            Object.keys(kf).forEach(function (prop) {
                var value = kf[prop];
                switch (prop) {
                    case 'offset':
                        return;
                    case 'easing':
                        if (value) {
                            keyframeStr += tab + "animation-timing-function: " + value + ";\n";
                        }
                        return;
                    default:
                        keyframeStr += "" + tab + prop + ": " + value + ";\n";
                        return;
                }
            });
            keyframeStr += tab + "}\n";
        });
        keyframeStr += "}\n";
        var kfElm = document.createElement('style');
        kfElm.innerHTML = keyframeStr;
        return kfElm;
    };
    CssKeyframesDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
        if (previousPlayers === void 0) {
            previousPlayers = [];
        }
        if (scrubberAccessRequested) {
            this._notifyFaultyScrubber();
        }
        var previousCssKeyframePlayers = previousPlayers.filter(function (player) { return player instanceof CssKeyframesPlayer; });
        var previousStyles = {};
        if (allowPreviousPlayerStylesMerge(duration, delay)) {
            previousCssKeyframePlayers.forEach(function (player) {
                var styles = player.currentSnapshot;
                Object.keys(styles).forEach(function (prop) { return previousStyles[prop] = styles[prop]; });
            });
        }
        keyframes = balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles);
        var finalStyles = flattenKeyframesIntoStyles(keyframes);
        // if there is no animation then there is no point in applying
        // styles and waiting for an event to get fired. This causes lag.
        // It's better to just directly apply the styles to the element
        // via the direct styling animation player.
        if (duration == 0) {
            return new browser_DirectStylePlayer(element, finalStyles);
        }
        var animationName = "" + KEYFRAMES_NAME_PREFIX + this._count++;
        var kfElm = this.buildKeyframeElement(element, animationName, keyframes);
        document.querySelector('head').appendChild(kfElm);
        var player = new CssKeyframesPlayer(element, keyframes, animationName, duration, delay, easing, finalStyles);
        player.onDestroy(function () { return removeElement(kfElm); });
        return player;
    };
    CssKeyframesDriver.prototype._notifyFaultyScrubber = function () {
        if (!this._warningIssued) {
            console.warn('@angular/animations: please load the web-animations.js polyfill to allow programmatic access...\n', '  visit http://bit.ly/IWukam to learn more about using the web-animation-js polyfill.');
            this._warningIssued = true;
        }
    };
    return CssKeyframesDriver;
}());
function flattenKeyframesIntoStyles(keyframes) {
    var flatKeyframes = {};
    if (keyframes) {
        var kfs = Array.isArray(keyframes) ? keyframes : [keyframes];
        kfs.forEach(function (kf) {
            Object.keys(kf).forEach(function (prop) {
                if (prop == 'offset' || prop == 'easing')
                    return;
                flatKeyframes[prop] = kf[prop];
            });
        });
    }
    return flatKeyframes;
}
function removeElement(node) {
    node.parentNode.removeChild(node);
}
var WebAnimationsPlayer = /*@__PURE__*/ (function () {
    function WebAnimationsPlayer(element, keyframes, options) {
        this.element = element;
        this.keyframes = keyframes;
        this.options = options;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._initialized = false;
        this._finished = false;
        this._started = false;
        this._destroyed = false;
        this.time = 0;
        this.parentPlayer = null;
        this.currentSnapshot = {};
        this._duration = options['duration'];
        this._delay = options['delay'] || 0;
        this.time = this._duration + this._delay;
    }
    WebAnimationsPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    WebAnimationsPlayer.prototype.init = function () {
        this._buildPlayer();
        this._preparePlayerBeforeStart();
    };
    WebAnimationsPlayer.prototype._buildPlayer = function () {
        var _this = this;
        if (this._initialized)
            return;
        this._initialized = true;
        var keyframes = this.keyframes;
        this.domPlayer =
            this._triggerWebAnimation(this.element, keyframes, this.options);
        this._finalKeyframe = keyframes.length ? keyframes[keyframes.length - 1] : {};
        this.domPlayer.addEventListener('finish', function () { return _this._onFinish(); });
    };
    WebAnimationsPlayer.prototype._preparePlayerBeforeStart = function () {
        // this is required so that the player doesn't start to animate right away
        if (this._delay) {
            this._resetDomPlayerState();
        }
        else {
            this.domPlayer.pause();
        }
    };
    /** @internal */
    WebAnimationsPlayer.prototype._triggerWebAnimation = function (element, keyframes, options) {
        // jscompiler doesn't seem to know animate is a native property because it's not fully
        // supported yet across common browsers (we polyfill it for Edge/Safari) [CL #143630929]
        return element['animate'](keyframes, options);
    };
    WebAnimationsPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    WebAnimationsPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    WebAnimationsPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    WebAnimationsPlayer.prototype.play = function () {
        this._buildPlayer();
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
        this.domPlayer.play();
    };
    WebAnimationsPlayer.prototype.pause = function () {
        this.init();
        this.domPlayer.pause();
    };
    WebAnimationsPlayer.prototype.finish = function () {
        this.init();
        this._onFinish();
        this.domPlayer.finish();
    };
    WebAnimationsPlayer.prototype.reset = function () {
        this._resetDomPlayerState();
        this._destroyed = false;
        this._finished = false;
        this._started = false;
    };
    WebAnimationsPlayer.prototype._resetDomPlayerState = function () {
        if (this.domPlayer) {
            this.domPlayer.cancel();
        }
    };
    WebAnimationsPlayer.prototype.restart = function () {
        this.reset();
        this.play();
    };
    WebAnimationsPlayer.prototype.hasStarted = function () { return this._started; };
    WebAnimationsPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            this._resetDomPlayerState();
            this._onFinish();
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    WebAnimationsPlayer.prototype.setPosition = function (p) { this.domPlayer.currentTime = p * this.time; };
    WebAnimationsPlayer.prototype.getPosition = function () { return this.domPlayer.currentTime / this.time; };
    Object.defineProperty(WebAnimationsPlayer.prototype, "totalTime", {
        get: function () { return this._delay + this._duration; },
        enumerable: true,
        configurable: true
    });
    WebAnimationsPlayer.prototype.beforeDestroy = function () {
        var _this = this;
        var styles = {};
        if (this.hasStarted()) {
            Object.keys(this._finalKeyframe).forEach(function (prop) {
                if (prop != 'offset') {
                    styles[prop] =
                        _this._finished ? _this._finalKeyframe[prop] : computeStyle(_this.element, prop);
                }
            });
        }
        this.currentSnapshot = styles;
    };
    /** @internal */
    WebAnimationsPlayer.prototype.triggerCallback = function (phaseName) {
        var methods = phaseName == 'start' ? this._onStartFns : this._onDoneFns;
        methods.forEach(function (fn) { return fn(); });
        methods.length = 0;
    };
    return WebAnimationsPlayer;
}());
var WebAnimationsDriver = /*@__PURE__*/ (function () {
    function WebAnimationsDriver() {
        this._isNativeImpl = /\{\s*\[native\s+code\]\s*\}/.test(getElementAnimateFn().toString());
        this._cssKeyframesDriver = new CssKeyframesDriver();
    }
    WebAnimationsDriver.prototype.validateStyleProperty = function (prop) { return validateStyleProperty(prop); };
    WebAnimationsDriver.prototype.matchesElement = function (element, selector) {
        return matchesElement(element, selector);
    };
    WebAnimationsDriver.prototype.containsElement = function (elm1, elm2) { return containsElement(elm1, elm2); };
    WebAnimationsDriver.prototype.query = function (element, selector, multi) {
        return invokeQuery(element, selector, multi);
    };
    WebAnimationsDriver.prototype.computeStyle = function (element, prop, defaultValue) {
        return window.getComputedStyle(element)[prop];
    };
    WebAnimationsDriver.prototype.overrideWebAnimationsSupport = function (supported) { this._isNativeImpl = supported; };
    WebAnimationsDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers, scrubberAccessRequested) {
        if (previousPlayers === void 0) {
            previousPlayers = [];
        }
        var useKeyframes = !scrubberAccessRequested && !this._isNativeImpl;
        if (useKeyframes) {
            return this._cssKeyframesDriver.animate(element, keyframes, duration, delay, easing, previousPlayers);
        }
        var fill = delay == 0 ? 'both' : 'forwards';
        var playerOptions = { duration: duration, delay: delay, fill: fill };
        // we check for this to avoid having a null|undefined value be present
        // for the easing (which results in an error for certain browsers #9752)
        if (easing) {
            playerOptions['easing'] = easing;
        }
        var previousStyles = {};
        var previousWebAnimationPlayers = previousPlayers.filter(function (player) { return player instanceof WebAnimationsPlayer; });
        if (allowPreviousPlayerStylesMerge(duration, delay)) {
            previousWebAnimationPlayers.forEach(function (player) {
                var styles = player.currentSnapshot;
                Object.keys(styles).forEach(function (prop) { return previousStyles[prop] = styles[prop]; });
            });
        }
        keyframes = keyframes.map(function (styles) { return copyStyles(styles, false); });
        keyframes = balancePreviousStylesIntoKeyframes(element, keyframes, previousStyles);
        return new WebAnimationsPlayer(element, keyframes, playerOptions);
    };
    return WebAnimationsDriver;
}());
function supportsWebAnimations() {
    return typeof getElementAnimateFn() === 'function';
}
function getElementAnimateFn() {
    return (isBrowser() && Element.prototype['animate']) || {};
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */





// CONCATENATED MODULE: ./node_modules/@angular/platform-browser/fesm5/animations.js
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START tslib,_angular_animations,_angular_core,_angular_platform_browser,_angular_animations_browser,_angular_common PURE_IMPORTS_END */






var animations_BrowserAnimationBuilder = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(BrowserAnimationBuilder, _super);
    function BrowserAnimationBuilder(rootRenderer, doc) {
        var _this = _super.call(this) || this;
        _this._nextAnimationId = 0;
        var typeData = {
            id: '0',
            encapsulation: core["ViewEncapsulation"].None,
            styles: [],
            data: { animation: [] }
        };
        _this._renderer = rootRenderer.createRenderer(doc.body, typeData);
        return _this;
    }
    BrowserAnimationBuilder.prototype.build = function (animation) {
        var id = this._nextAnimationId.toString();
        this._nextAnimationId++;
        var entry = Array.isArray(animation) ? sequence(animation) : animation;
        issueAnimationCommand(this._renderer, null, id, 'register', [entry]);
        return new animations_BrowserAnimationFactory(id, this._renderer);
    };
    BrowserAnimationBuilder = Object(tslib_es6["__decorate"])([
        Object(tslib_es6["__param"])(1, Object(core["Inject"])(platform_browser["b" /* DOCUMENT */]))
    ], BrowserAnimationBuilder);
    return BrowserAnimationBuilder;
}(AnimationBuilder));
var animations_BrowserAnimationFactory = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(BrowserAnimationFactory, _super);
    function BrowserAnimationFactory(_id, _renderer) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this._renderer = _renderer;
        return _this;
    }
    BrowserAnimationFactory.prototype.create = function (element, options) {
        return new RendererAnimationPlayer(this._id, element, options || {}, this._renderer);
    };
    return BrowserAnimationFactory;
}(AnimationFactory));
var RendererAnimationPlayer = /*@__PURE__*/ (function () {
    function RendererAnimationPlayer(id, element, options, _renderer) {
        this.id = id;
        this.element = element;
        this._renderer = _renderer;
        this.parentPlayer = null;
        this._started = false;
        this.totalTime = 0;
        this._command('create', options);
    }
    RendererAnimationPlayer.prototype._listen = function (eventName, callback) {
        return this._renderer.listen(this.element, "@@" + this.id + ":" + eventName, callback);
    };
    RendererAnimationPlayer.prototype._command = function (command) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return issueAnimationCommand(this._renderer, this.element, this.id, command, args);
    };
    RendererAnimationPlayer.prototype.onDone = function (fn) { this._listen('done', fn); };
    RendererAnimationPlayer.prototype.onStart = function (fn) { this._listen('start', fn); };
    RendererAnimationPlayer.prototype.onDestroy = function (fn) { this._listen('destroy', fn); };
    RendererAnimationPlayer.prototype.init = function () { this._command('init'); };
    RendererAnimationPlayer.prototype.hasStarted = function () { return this._started; };
    RendererAnimationPlayer.prototype.play = function () {
        this._command('play');
        this._started = true;
    };
    RendererAnimationPlayer.prototype.pause = function () { this._command('pause'); };
    RendererAnimationPlayer.prototype.restart = function () { this._command('restart'); };
    RendererAnimationPlayer.prototype.finish = function () { this._command('finish'); };
    RendererAnimationPlayer.prototype.destroy = function () { this._command('destroy'); };
    RendererAnimationPlayer.prototype.reset = function () { this._command('reset'); };
    RendererAnimationPlayer.prototype.setPosition = function (p) { this._command('setPosition', p); };
    RendererAnimationPlayer.prototype.getPosition = function () { return 0; };
    return RendererAnimationPlayer;
}());
function issueAnimationCommand(renderer, element, id, command, args) {
    return renderer.setProperty(element, "@@" + id + ":" + command, args);
}
var ANIMATION_PREFIX = '@';
var DISABLE_ANIMATIONS_FLAG = '@.disabled';
var animations_AnimationRendererFactory = /*@__PURE__*/ (function () {
    function AnimationRendererFactory(delegate, engine, _zone) {
        this.delegate = delegate;
        this.engine = engine;
        this._zone = _zone;
        this._currentId = 0;
        this._microtaskId = 1;
        this._animationCallbacksBuffer = [];
        this._rendererCache = new Map();
        this._cdRecurDepth = 0;
        this.promise = Promise.resolve(0);
        engine.onRemovalComplete = function (element, delegate) {
            // Note: if an component element has a leave animation, and the component
            // a host leave animation, the view engine will call `removeChild` for the parent
            // component renderer as well as for the child component renderer.
            // Therefore, we need to check if we already removed the element.
            if (delegate && delegate.parentNode(element)) {
                delegate.removeChild(element.parentNode, element);
            }
        };
    }
    AnimationRendererFactory.prototype.createRenderer = function (hostElement, type) {
        var _this = this;
        var EMPTY_NAMESPACE_ID = '';
        // cache the delegates to find out which cached delegate can
        // be used by which cached renderer
        var delegate = this.delegate.createRenderer(hostElement, type);
        if (!hostElement || !type || !type.data || !type.data['animation']) {
            var renderer = this._rendererCache.get(delegate);
            if (!renderer) {
                renderer = new BaseAnimationRenderer(EMPTY_NAMESPACE_ID, delegate, this.engine);
                // only cache this result when the base renderer is used
                this._rendererCache.set(delegate, renderer);
            }
            return renderer;
        }
        var componentId = type.id;
        var namespaceId = type.id + '-' + this._currentId;
        this._currentId++;
        this.engine.register(namespaceId, hostElement);
        var animationTriggers = type.data['animation'];
        animationTriggers.forEach(function (trigger) { return _this.engine.registerTrigger(componentId, namespaceId, hostElement, trigger.name, trigger); });
        return new animations_AnimationRenderer(this, namespaceId, delegate, this.engine);
    };
    AnimationRendererFactory.prototype.begin = function () {
        this._cdRecurDepth++;
        if (this.delegate.begin) {
            this.delegate.begin();
        }
    };
    AnimationRendererFactory.prototype._scheduleCountTask = function () {
        var _this = this;
        // always use promise to schedule microtask instead of use Zone
        this.promise.then(function () { _this._microtaskId++; });
    };
    /** @internal */
    AnimationRendererFactory.prototype.scheduleListenerCallback = function (count, fn, data) {
        var _this = this;
        if (count >= 0 && count < this._microtaskId) {
            this._zone.run(function () { return fn(data); });
            return;
        }
        if (this._animationCallbacksBuffer.length == 0) {
            Promise.resolve(null).then(function () {
                _this._zone.run(function () {
                    _this._animationCallbacksBuffer.forEach(function (tuple) {
                        var _a = Object(tslib_es6["__read"])(tuple, 2), fn = _a[0], data = _a[1];
                        fn(data);
                    });
                    _this._animationCallbacksBuffer = [];
                });
            });
        }
        this._animationCallbacksBuffer.push([fn, data]);
    };
    AnimationRendererFactory.prototype.end = function () {
        var _this = this;
        this._cdRecurDepth--;
        // this is to prevent animations from running twice when an inner
        // component does CD when a parent component insted has inserted it
        if (this._cdRecurDepth == 0) {
            this._zone.runOutsideAngular(function () {
                _this._scheduleCountTask();
                _this.engine.flush(_this._microtaskId);
            });
        }
        if (this.delegate.end) {
            this.delegate.end();
        }
    };
    AnimationRendererFactory.prototype.whenRenderingDone = function () { return this.engine.whenRenderingDone(); };
    return AnimationRendererFactory;
}());
var BaseAnimationRenderer = /*@__PURE__*/ (function () {
    function BaseAnimationRenderer(namespaceId, delegate, engine) {
        this.namespaceId = namespaceId;
        this.delegate = delegate;
        this.engine = engine;
        this.destroyNode = this.delegate.destroyNode ? function (n) { return delegate.destroyNode(n); } : null;
    }
    Object.defineProperty(BaseAnimationRenderer.prototype, "data", {
        get: function () { return this.delegate.data; },
        enumerable: true,
        configurable: true
    });
    BaseAnimationRenderer.prototype.destroy = function () {
        this.engine.destroy(this.namespaceId, this.delegate);
        this.delegate.destroy();
    };
    BaseAnimationRenderer.prototype.createElement = function (name, namespace) {
        return this.delegate.createElement(name, namespace);
    };
    BaseAnimationRenderer.prototype.createComment = function (value) { return this.delegate.createComment(value); };
    BaseAnimationRenderer.prototype.createText = function (value) { return this.delegate.createText(value); };
    BaseAnimationRenderer.prototype.appendChild = function (parent, newChild) {
        this.delegate.appendChild(parent, newChild);
        this.engine.onInsert(this.namespaceId, newChild, parent, false);
    };
    BaseAnimationRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
        this.delegate.insertBefore(parent, newChild, refChild);
        this.engine.onInsert(this.namespaceId, newChild, parent, true);
    };
    BaseAnimationRenderer.prototype.removeChild = function (parent, oldChild) {
        this.engine.onRemove(this.namespaceId, oldChild, this.delegate);
    };
    BaseAnimationRenderer.prototype.selectRootElement = function (selectorOrNode) { return this.delegate.selectRootElement(selectorOrNode); };
    BaseAnimationRenderer.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
    BaseAnimationRenderer.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
    BaseAnimationRenderer.prototype.setAttribute = function (el, name, value, namespace) {
        this.delegate.setAttribute(el, name, value, namespace);
    };
    BaseAnimationRenderer.prototype.removeAttribute = function (el, name, namespace) {
        this.delegate.removeAttribute(el, name, namespace);
    };
    BaseAnimationRenderer.prototype.addClass = function (el, name) { this.delegate.addClass(el, name); };
    BaseAnimationRenderer.prototype.removeClass = function (el, name) { this.delegate.removeClass(el, name); };
    BaseAnimationRenderer.prototype.setStyle = function (el, style, value, flags) {
        this.delegate.setStyle(el, style, value, flags);
    };
    BaseAnimationRenderer.prototype.removeStyle = function (el, style, flags) {
        this.delegate.removeStyle(el, style, flags);
    };
    BaseAnimationRenderer.prototype.setProperty = function (el, name, value) {
        if (name.charAt(0) == ANIMATION_PREFIX && name == DISABLE_ANIMATIONS_FLAG) {
            this.disableAnimations(el, !!value);
        }
        else {
            this.delegate.setProperty(el, name, value);
        }
    };
    BaseAnimationRenderer.prototype.setValue = function (node, value) { this.delegate.setValue(node, value); };
    BaseAnimationRenderer.prototype.listen = function (target, eventName, callback) {
        return this.delegate.listen(target, eventName, callback);
    };
    BaseAnimationRenderer.prototype.disableAnimations = function (element, value) {
        this.engine.disableAnimations(element, value);
    };
    return BaseAnimationRenderer;
}());
var animations_AnimationRenderer = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(AnimationRenderer, _super);
    function AnimationRenderer(factory, namespaceId, delegate, engine) {
        var _this = _super.call(this, namespaceId, delegate, engine) || this;
        _this.factory = factory;
        _this.namespaceId = namespaceId;
        return _this;
    }
    AnimationRenderer.prototype.setProperty = function (el, name, value) {
        if (name.charAt(0) == ANIMATION_PREFIX) {
            if (name.charAt(1) == '.' && name == DISABLE_ANIMATIONS_FLAG) {
                value = value === undefined ? true : !!value;
                this.disableAnimations(el, value);
            }
            else {
                this.engine.process(this.namespaceId, el, name.substr(1), value);
            }
        }
        else {
            this.delegate.setProperty(el, name, value);
        }
    };
    AnimationRenderer.prototype.listen = function (target, eventName, callback) {
        var _this = this;
        var _a;
        if (eventName.charAt(0) == ANIMATION_PREFIX) {
            var element = resolveElementFromTarget(target);
            var name_1 = eventName.substr(1);
            var phase = '';
            // @listener.phase is for trigger animation callbacks
            // @@listener is for animation builder callbacks
            if (name_1.charAt(0) != ANIMATION_PREFIX) {
                _a = Object(tslib_es6["__read"])(parseTriggerCallbackName(name_1), 2), name_1 = _a[0], phase = _a[1];
            }
            return this.engine.listen(this.namespaceId, element, name_1, phase, function (event) {
                var countId = event['_data'] || -1;
                _this.factory.scheduleListenerCallback(countId, callback, event);
            });
        }
        return this.delegate.listen(target, eventName, callback);
    };
    return AnimationRenderer;
}(BaseAnimationRenderer));
function resolveElementFromTarget(target) {
    switch (target) {
        case 'body':
            return document.body;
        case 'document':
            return document;
        case 'window':
            return window;
        default:
            return target;
    }
}
function parseTriggerCallbackName(triggerName) {
    var dotIndex = triggerName.indexOf('.');
    var trigger = triggerName.substring(0, dotIndex);
    var phase = triggerName.substr(dotIndex + 1);
    return [trigger, phase];
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var animations_InjectableAnimationEngine = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(InjectableAnimationEngine, _super);
    function InjectableAnimationEngine(doc, driver, normalizer) {
        return _super.call(this, doc.body, driver, normalizer) || this;
    }
    InjectableAnimationEngine = Object(tslib_es6["__decorate"])([
        Object(tslib_es6["__param"])(0, Object(core["Inject"])(common["DOCUMENT"]))
    ], InjectableAnimationEngine);
    return InjectableAnimationEngine;
}(browser_AnimationEngine));
function instantiateSupportedAnimationDriver() {
    return supportsWebAnimations() ? new WebAnimationsDriver() : new CssKeyframesDriver();
}
function instantiateDefaultStyleNormalizer() {
    return new browser_WebAnimationsStyleNormalizer();
}
function instantiateRendererFactory(renderer, engine, zone) {
    return new animations_AnimationRendererFactory(renderer, engine, zone);
}
/**
 * @experimental Animation support is experimental.
 */
var ANIMATION_MODULE_TYPE = /*@__PURE__*/ new core["InjectionToken"]('AnimationModuleType');
var SHARED_ANIMATION_PROVIDERS = [
    { provide: AnimationBuilder, useClass: animations_BrowserAnimationBuilder },
    { provide: AnimationStyleNormalizer, useFactory: instantiateDefaultStyleNormalizer },
    { provide: browser_AnimationEngine, useClass: animations_InjectableAnimationEngine }, {
        provide: core["RendererFactory2"],
        useFactory: instantiateRendererFactory,
        deps: [platform_browser["l" /* ɵDomRendererFactory2 */], browser_AnimationEngine, core["NgZone"]]
    }
];
/**
 * Separate providers from the actual module so that we can do a local modification in Google3 to
 * include them in the BrowserModule.
 */
var BROWSER_ANIMATIONS_PROVIDERS = /*@__PURE__*/ Object(tslib_es6["__spread"])([
    { provide: AnimationDriver, useFactory: instantiateSupportedAnimationDriver },
    { provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }
], SHARED_ANIMATION_PROVIDERS);
/**
 * Separate providers from the actual module so that we can do a local modification in Google3 to
 * include them in the BrowserTestingModule.
 */
var BROWSER_NOOP_ANIMATIONS_PROVIDERS = /*@__PURE__*/ Object(tslib_es6["__spread"])([
    { provide: AnimationDriver, useClass: browser_NoopAnimationDriver },
    { provide: ANIMATION_MODULE_TYPE, useValue: 'NoopAnimations' }
], SHARED_ANIMATION_PROVIDERS);
/**
 * Exports `BrowserModule` with additional [dependency-injection providers](guide/glossary#provider)
 * for use with animations. See [Animations](guide/animations).
 * @experimental
 */
var BrowserAnimationsModule = /*@__PURE__*/ (function () {
    function BrowserAnimationsModule() {
    }
    return BrowserAnimationsModule;
}());
/**
 * A null player that must be imported to allow disabling of animations.
 * @experimental
 */
var NoopAnimationsModule = /*@__PURE__*/ (function () {
    function NoopAnimationsModule() {
    }
    return NoopAnimationsModule;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/models/tree-dragged-element.model.js

var TreeDraggedElement = /*@__PURE__*/ (function () {
    function TreeDraggedElement() {
        this._draggedElement = null;
    }
    TreeDraggedElement.prototype.set = function (draggedElement) {
        this._draggedElement = draggedElement;
    };
    TreeDraggedElement.prototype.get = function () {
        return this._draggedElement;
    };
    TreeDraggedElement.prototype.isDragging = function () {
        return !!this.get();
    };
    return TreeDraggedElement;
}());





// CONCATENATED MODULE: ./src/app/bi/common/service/number.utils.ts


var number_utils_NumberUtils = /*@__PURE__*/ (function () {
    function NumberUtils() {
        this.uomLists = { Thousand: { shortname: 'K' }, Million: { shortname: 'M' }, Billion: { shortname: 'B' }, Trillion: { shortname: 'T' } };
        // try {
        //   this.properties = { BI_BASE_URL: '/bi', EPMS_BASE_URL: '/home' };
        //   this.getUom().then(function (success: any) {
        //   });
        // } catch (e) {
        //   console.error(e);
        // }
    }
    Object.defineProperty(NumberUtils, "MILLION", {
        get: function () { return 1000000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "BILLION", {
        get: function () { return 1000000000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "LAKHS", {
        get: function () { return 100000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(NumberUtils, "THOUSANDS", {
        get: function () { return 1000.0; },
        enumerable: true,
        configurable: true
    });
    ;
    NumberUtils.prototype.autoScale = function (value) {
        var suffix = '';
        try {
            var x = parseFloat(value);
            var opr = x > 0 ? 1 : -1;
            x = Math.abs(x);
            if (x > NumberUtils.BILLION) {
                value = x / (NumberUtils.BILLION);
                suffix = this.uomLists.Billion.shortname;
            }
            else if (x > NumberUtils.MILLION) {
                value = x / (NumberUtils.MILLION);
                suffix = this.uomLists.Million.shortname;
            }
            else if (x > NumberUtils.LAKHS) {
                value = x / (NumberUtils.THOUSANDS);
                suffix = this.uomLists.Thousand.shortname;
            }
            value = opr == -1 ? -Math.abs(value) : value;
        }
        catch (e) { }
        return { value: value, suffix: suffix };
    };
    NumberUtils.prototype.autoFormat = function (x, cft) {
        try {
            var val = this.autoScale(x);
            return this.numberWithCommas(val.value, cft) + " " + val.suffix;
        }
        catch (e) {
            return '';
        }
    };
    NumberUtils.prototype.numberWithCommas = function (val, format) {
        try {
            if (!Number.isNaN(val)) {
                var x = Math.round(val * 100) / 100;
                var parts = void 0;
                if (format) {
                    parts = x.toFixed(format.pre).split(".");
                }
                else {
                    parts = x.toString().split(".");
                }
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            }
        }
        catch (e) {
        }
        return 0;
    };
    NumberUtils.prototype.isNaN = function (obj) {
        try {
            return isNaN(Number(obj));
        }
        catch (e) {
            return true;
        }
    };
    NumberUtils.prototype.checkDecimalPoints = function (event, dp) {
        var val = event.target.value.trim();
        var dec = val.split('.');
        var decimals = "";
        if (!(/^[-]?[0-9]+(?:\.[0-9]*)?$/.test(val))) {
            event.target.value = val.slice(0, -1);
            return;
        }
        else {
            if (dec.length > 1) {
                decimals = dec[1];
            }
            else {
                return;
            }
            if (val != "" && (decimals && decimals.length > dp)) {
                //console.log("Initial ", val);
                var f = parseFloat(val);
                var np = f.toFixed(dp);
                event.target.value = np;
                //console.log("Changed ", event.target.value);
            }
        }
    };
    Object.defineProperty(NumberUtils.prototype, "symbols", {
        get: function () {
            var self = this;
            try {
                var symbols = [];
                if (self.uomLists.Thousand.shortname) {
                    symbols.push(' ' + self.uomLists.Thousand.shortname.charAt(0));
                }
                else {
                    symbols.push(' k');
                }
                if (self.uomLists.Million.shortname) {
                    symbols.push(' ' + self.uomLists.Million.shortname.charAt(0));
                }
                else {
                    symbols.push(' M');
                }
                if (self.uomLists.Billion.shortname) {
                    symbols.push(' ' + self.uomLists.Billion.shortname.charAt(0));
                }
                else {
                    symbols.push(' B');
                }
                if (self.uomLists.Trillion.shortname) {
                    symbols.push(' ' + self.uomLists.Trillion.shortname.charAt(0));
                }
                else {
                    symbols.push(' T');
                }
                return symbols;
            }
            catch (e) {
                return ["k", "M", "G", "T", "P", "E"];
            }
        },
        enumerable: true,
        configurable: true
    });
    NumberUtils.prototype.get = function (key) {
        return this.properties && this.properties[key] ? this.properties[key] : undefined;
    };
    NumberUtils.prototype.getUom = function () {
        var self = this;
        //if (this.uomLists) {
        return new Promise(function (observer, reject) {
            observer(self.uomLists);
        });
        //}
        // } else {
        //     return new Promise((observer, reject: any) => {
        //         let url: string;
        //         let https: any = [];
        //         url = this.get("BI_BASE_URL") + '/v1/ads/value_range';
        //         //console.log(url)
        //         this._httpClient.get(url).subscribe(res => {
        //             self.uomLists = res;
        //             observer(res);
        //         }, err => {
        //             //console.log(err);
        //             reject(err);
        //         });
        //     });
        // }
    };
    return NumberUtils;
}());



// CONCATENATED MODULE: ./src/app/bi/common/service/time.utils.ts



var time_utils_TimeUtils = /*@__PURE__*/ (function () {
    function TimeUtils() {
    }
    TimeUtils.dateLabel = function (date, filter) {
        var prefix = filter.range.toUpperCase();
        if (prefix == "FY") {
            prefix = "Last Updated";
        }
        else if (filter && filter.psd) {
            var psd = filter.psd;
            if (psd.charAt(0) == '-') {
                prefix = "Past " + psd.charAt(1) + " " + (psd.charAt(2) == 'W' ? "Weeks" : "Months") + " as ";
            }
        }
        else if (prefix == "DAY") {
            prefix = "";
        }
        else {
            prefix += " as";
        }
        return prefix.concat(' on ').concat(moment(date).format('DD MMM YYYY'));
    };
    TimeUtils.relativeDate = function (filter, oper) {
        try {
            var ped = this.fromymd(filter.ped);
            var period = oper.charAt(0);
            var operand = oper.charAt(1).toUpperCase();
            var count = oper.charAt(2);
            var base_date = moment(ped);
            var to_date = void 0;
            var from_date = void 0;
            if (operand == "-") {
                to_date = moment(ped).subtract(count, 'M');
            }
            else {
                to_date = moment(ped).add(count, 'M');
            }
            filter.fped = to_date.format('YYYYMMDD');
            from_date = to_date.startOf('M');
            filter.fsed = from_date.format('YYYYMMDD');
        }
        catch (e) {
            console.error(e);
        }
    };
    TimeUtils.toymd = function (date) {
        return moment["utc"](date).format('YYYYMMDD');
    };
    TimeUtils.toDate = function (date) {
        return moment["utc"](date, 'YYYYMMDD').toDate();
        ;
    };
    TimeUtils.formatDate = function (date) {
        return moment["utc"](date).format('MM/DD/YYYY');
    };
    TimeUtils.fromymd = function (date) {
        return moment["utc"](date, 'YYYYMMDD');
    };
    return TimeUtils;
}());



// CONCATENATED MODULE: ./src/app/bi/admin/controller/toasterComponent.ts
var toasterComponent_ToasterComponent = /*@__PURE__*/ (function () {
    function ToasterComponent(toastr) {
        this.toastr = toastr;
    }
    ToasterComponent.prototype.success = function (msg, vcr) {
        try {
            /* this.toastr.setRootViewContainerRef(vcr);
            this.toastr.success('<span style="color: white">' + msg + '</span>', null, { enableHTML: true }) */
            this.toastr.success('<span style="color: white">' + msg + '</span>', null, { enableHtml: true });
        }
        catch (e) {
            console.log('error in toastr : ' + e);
        }
    };
    ToasterComponent.prototype.error = function (msg, vcr) {
        try {
            /* this.toastr.setRootViewContainerRef(vcr);
            this.toastr.error('<span style="color: white">' + msg + '</span>', null, { enableHTML: true }) */
            this.toastr.error('<span style="color: white">' + msg + '</span>', null, { enableHtml: true });
        }
        catch (e) {
            console.log('error in toastr : ' + e);
        }
    };
    ToasterComponent.prototype.warning = function (msg, vcr) {
        try {
            /* this.toastr.setRootViewContainerRef(vcr);
            this.toastr.warning('<span style="color: white">' + msg + '</span>', null, { enableHTML: true }) */
            this.toastr.warning('<span style="color: white">' + msg + '</span>', null, { enableHtml: true });
        }
        catch (e) {
            console.log('error in toastr : ' + e);
        }
    };
    return ToasterComponent;
}());



// CONCATENATED MODULE: ./node_modules/@angular/cdk/esm5/platform.es5.js
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** PURE_IMPORTS_START _angular_core,_angular_common PURE_IMPORTS_END */


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// Whether the current platform supports the V8 Break Iterator. The V8 check
// is necessary to detect all Blink based browsers.
/** @type {?} */
var hasV8BreakIterator;
// We need a try/catch around the reference to `Intl`, because accessing it in some cases can
// cause IE to throw. These cases are tied to particular versions of Windows and can happen if
// the consumer is providing a polyfilled `Map`. See:
// https://github.com/Microsoft/ChakraCore/issues/3189
// https://github.com/angular/material2/issues/15687
try {
    hasV8BreakIterator = (typeof Intl !== 'undefined' && (((Intl))).v8BreakIterator);
}
catch (_a) {
    hasV8BreakIterator = false;
}
/**
 * Service to detect the current platform by comparing the userAgent strings and
 * checking browser-specific global properties.
 */
var platform_es5_Platform = /*@__PURE__*/ (function () {
    /**
     * @breaking-change 8.0.0 remove optional decorator
     */
    function Platform(_platformId) {
        this._platformId = _platformId;
        /**
         * Whether the Angular application is being rendered in the browser.
         * We want to use the Angular platform check because if the Document is shimmed
         * without the navigator, the following checks will fail. This is preferred because
         * sometimes the Document may be shimmed without the user's knowledge or intention
         */
        this.isBrowser = this._platformId ?
            Object(common["isPlatformBrowser"])(this._platformId) : typeof document === 'object' && !!document;
        /**
         * Whether the current browser is Microsoft Edge.
         */
        this.EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent);
        /**
         * Whether the current rendering engine is Microsoft Trident.
         */
        this.TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent);
        /**
         * Whether the current rendering engine is Blink.
         */
        // EdgeHTML and Trident mock Blink specific things and need to be excluded from this check.
        this.BLINK = this.isBrowser && (!!((((window))).chrome || hasV8BreakIterator) &&
            typeof CSS !== 'undefined' && !this.EDGE && !this.TRIDENT);
        /**
         * Whether the current rendering engine is WebKit.
         */
        // Webkit is part of the userAgent in EdgeHTML, Blink and Trident. Therefore we need to
        // ensure that Webkit runs standalone and is not used as another engine's base.
        this.WEBKIT = this.isBrowser &&
            /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
        /**
         * Whether the current platform is Apple iOS.
         */
        this.IOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) &&
            !('MSStream' in window);
        /**
         * Whether the current browser is Firefox.
         */
        // It's difficult to detect the plain Gecko engine, because most of the browsers identify
        // them self as Gecko-like browsers and modify the userAgent's according to that.
        // Since we only cover one explicit Firefox case, we can simply check for Firefox
        // instead of having an unstable check for Gecko.
        this.FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent);
        /**
         * Whether the current platform is Android.
         */
        // Trident on mobile adds the android platform to the userAgent to trick detections.
        this.ANDROID = this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT;
        /**
         * Whether the current browser is Safari.
         */
        // Safari browsers will include the Safari keyword in their userAgent. Some browsers may fake
        // this and just place the Safari keyword in the userAgent. To be more safe about Safari every
        // Safari browser should also use Webkit as its layout engine.
        this.SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;
    }
    /** @nocollapse */ Platform.ngInjectableDef = Object(core["defineInjectable"])({ factory: function Platform_Factory() { return new Platform(Object(core["inject"])(core["PLATFORM_ID"], 8)); }, token: Platform, providedIn: "root" });
    return Platform;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PlatformModule = /*@__PURE__*/ (function () {
    function PlatformModule() {
    }
    return PlatformModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Cached result Set of input types support by the current browser.
 * @type {?}
 */
var supportedInputTypes;
/**
 * Types of `<input>` that *might* be supported.
 * @type {?}
 */
var candidateInputTypes = [
    // `color` must come first. Chrome 56 shows a warning if we change the type to `color` after
    // first changing it to something else:
    // The specified value "" does not conform to the required format.
    // The format is "#rrggbb" where rr, gg, bb are two-digit hexadecimal numbers.
    'color',
    'button',
    'checkbox',
    'date',
    'datetime-local',
    'email',
    'file',
    'hidden',
    'image',
    'month',
    'number',
    'password',
    'radio',
    'range',
    'reset',
    'search',
    'submit',
    'tel',
    'text',
    'time',
    'url',
    'week',
];
/**
 * @return {?} The input types supported by this browser.
 */
function getSupportedInputTypes() {
    // Result is cached.
    if (supportedInputTypes) {
        return supportedInputTypes;
    }
    // We can't check if an input type is not supported until we're on the browser, so say that
    // everything is supported when not on the browser. We don't use `Platform` here since it's
    // just a helper function and can't inject it.
    if (typeof document !== 'object' || !document) {
        supportedInputTypes = new Set(candidateInputTypes);
        return supportedInputTypes;
    }
    /** @type {?} */
    var featureTestInput = document.createElement('input');
    supportedInputTypes = new Set(candidateInputTypes.filter(function (value) {
        featureTestInput.setAttribute('type', value);
        return featureTestInput.type === value;
    }));
    return supportedInputTypes;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Cached result of whether the user's browser supports passive event listeners.
 * @type {?}
 */
var supportsPassiveEvents;
/**
 * Checks whether the user's browser supports passive event listeners.
 * See: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 * @return {?}
 */
function supportsPassiveEventListeners() {
    if (supportsPassiveEvents == null && typeof window !== 'undefined') {
        try {
            window.addEventListener('test', ((null)), Object.defineProperty({}, 'passive', {
                get: function () { return supportsPassiveEvents = true; }
            }));
        }
        finally {
            supportsPassiveEvents = supportsPassiveEvents || false;
        }
    }
    return supportsPassiveEvents;
}
/**
 * Normalizes an `AddEventListener` object to something that can be passed
 * to `addEventListener` on any browser, no matter whether it supports the
 * `options` parameter.
 * @param {?} options Object to be normalized.
 * @return {?}
 */
function normalizePassiveListenerOptions(options) {
    return supportsPassiveEventListeners() ? options : !!options.capture;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
var RtlScrollAxisType = /*@__PURE__*/ (function () {
    var RtlScrollAxisType = {
        /**
         * scrollLeft is 0 when scrolled all the way left and (scrollWidth - clientWidth) when scrolled
         * all the way right.
         */
        NORMAL: 0,
        /**
         * scrollLeft is -(scrollWidth - clientWidth) when scrolled all the way left and 0 when scrolled
         * all the way right.
         */
        NEGATED: 1,
        /**
         * scrollLeft is (scrollWidth - clientWidth) when scrolled all the way left and 0 when scrolled
         * all the way right.
         */
        INVERTED: 2,
    };
    RtlScrollAxisType[RtlScrollAxisType.NORMAL] = 'NORMAL';
    RtlScrollAxisType[RtlScrollAxisType.NEGATED] = 'NEGATED';
    RtlScrollAxisType[RtlScrollAxisType.INVERTED] = 'INVERTED';
    return RtlScrollAxisType;
}());
/**
 * Cached result of the way the browser handles the horizontal scroll axis in RTL mode.
 * @type {?}
 */
var rtlScrollAxisType;
/**
 * Check whether the browser supports scroll behaviors.
 * @return {?}
 */
function supportsScrollBehavior() {
    return !!(typeof document == 'object' && 'scrollBehavior' in ((document.documentElement)).style);
}
/**
 * Checks the type of RTL scroll axis used by this browser. As of time of writing, Chrome is NORMAL,
 * Firefox & Safari are NEGATED, and IE & Edge are INVERTED.
 * @return {?}
 */
function getRtlScrollAxisType() {
    // We can't check unless we're on the browser. Just assume 'normal' if we're not.
    if (typeof document !== 'object' || !document) {
        return RtlScrollAxisType.NORMAL;
    }
    if (!rtlScrollAxisType) {
        // Create a 1px wide scrolling container and a 2px wide content element.
        /** @type {?} */
        var scrollContainer = document.createElement('div');
        /** @type {?} */
        var containerStyle = scrollContainer.style;
        scrollContainer.dir = 'rtl';
        containerStyle.height = '1px';
        containerStyle.width = '1px';
        containerStyle.overflow = 'auto';
        containerStyle.visibility = 'hidden';
        containerStyle.pointerEvents = 'none';
        containerStyle.position = 'absolute';
        /** @type {?} */
        var content = document.createElement('div');
        /** @type {?} */
        var contentStyle = content.style;
        contentStyle.width = '2px';
        contentStyle.height = '1px';
        scrollContainer.appendChild(content);
        document.body.appendChild(scrollContainer);
        rtlScrollAxisType = RtlScrollAxisType.NORMAL;
        // The viewport starts scrolled all the way to the right in RTL mode. If we are in a NORMAL
        // browser this would mean that the scrollLeft should be 1. If it's zero instead we know we're
        // dealing with one of the other two types of browsers.
        if (scrollContainer.scrollLeft === 0) {
            // In a NEGATED browser the scrollLeft is always somewhere in [-maxScrollAmount, 0]. For an
            // INVERTED browser it is always somewhere in [0, maxScrollAmount]. We can determine which by
            // setting to the scrollLeft to 1. This is past the max for a NEGATED browser, so it will
            // return 0 when we read it again.
            scrollContainer.scrollLeft = 1;
            rtlScrollAxisType =
                scrollContainer.scrollLeft === 0 ? RtlScrollAxisType.NEGATED : RtlScrollAxisType.INVERTED;
        }
        ((scrollContainer.parentNode)).removeChild(scrollContainer);
    }
    return rtlScrollAxisType;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */





// CONCATENATED MODULE: ./node_modules/@angular/cdk/esm5/coercion.es5.js
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** PURE_IMPORTS_START _angular_core PURE_IMPORTS_END */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @param {?=} fallbackValue
 * @return {?}
 */
function coerceNumberProperty(value, fallbackValue) {
    if (fallbackValue === void 0) {
        fallbackValue = 0;
    }
    return _isNumberValue(value) ? Number(value) : fallbackValue;
}
/**
 * Whether the provided value is considered a number.
 * \@docs-private
 * @param {?} value
 * @return {?}
 */
function _isNumberValue(value) {
    // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
    // and other non-number values as NaN, where Number just uses 0) but it considers the string
    // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
    return !isNaN(parseFloat(((value)))) && !isNaN(Number(value));
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Wraps the provided value in an array, unless the provided value is an array.
 * @template T
 * @param {?} value
 * @return {?}
 */
function coerceArray(value) {
    return Array.isArray(value) ? value : [value];
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Coerces a value to a CSS pixel value.
 * @param {?} value
 * @return {?}
 */
function coerceCssPixelValue(value) {
    if (value == null) {
        return '';
    }
    return typeof value === 'string' ? value : value + "px";
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Coerces an ElementRef or an Element into an element.
 * Useful for APIs that can accept either a ref or the native element itself.
 * @template T
 * @param {?} elementOrRef
 * @return {?}
 */
function coerceElement(elementOrRef) {
    return elementOrRef instanceof core["ElementRef"] ? elementOrRef.nativeElement : elementOrRef;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */





// CONCATENATED MODULE: ./node_modules/@angular/cdk/esm5/bidi.es5.js
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** PURE_IMPORTS_START _angular_common,_angular_core PURE_IMPORTS_END */


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Injection token used to inject the document into Directionality.
 * This is used so that the value can be faked in tests.
 *
 * We can't use the real document in tests because changing the real `dir` causes geometry-based
 * tests in Safari to fail.
 *
 * We also can't re-provide the DOCUMENT token from platform-brower because the unit tests
 * themselves use things like `querySelector` in test code.
 *
 * This token is defined in a separate file from Directionality as a workaround for
 * https://github.com/angular/angular/issues/22559
 *
 * \@docs-private
 * @type {?}
 */
var DIR_DOCUMENT = /*@__PURE__*/ new core["InjectionToken"]('cdk-dir-doc', {
    providedIn: 'root',
    factory: DIR_DOCUMENT_FACTORY,
});
/**
 * \@docs-private
 * @return {?}
 */
function DIR_DOCUMENT_FACTORY() {
    return Object(core["inject"])(common["DOCUMENT"]);
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The directionality (LTR / RTL) context for the application (or a subtree of it).
 * Exposes the current direction and a stream of direction changes.
 */
var bidi_es5_Directionality = /*@__PURE__*/ (function () {
    function Directionality(_document) {
        /**
         * The current 'ltr' or 'rtl' value.
         */
        this.value = 'ltr';
        /**
         * Stream that emits whenever the 'ltr' / 'rtl' state changes.
         */
        this.change = new core["EventEmitter"]();
        if (_document) {
            // TODO: handle 'auto' value -
            // We still need to account for dir="auto".
            // It looks like HTMLElemenet.dir is also "auto" when that's set to the attribute,
            // but getComputedStyle return either "ltr" or "rtl". avoiding getComputedStyle for now
            /** @type {?} */
            var bodyDir = _document.body ? _document.body.dir : null;
            /** @type {?} */
            var htmlDir = _document.documentElement ? _document.documentElement.dir : null;
            /** @type {?} */
            var value = bodyDir || htmlDir;
            this.value = (value === 'ltr' || value === 'rtl') ? value : 'ltr';
        }
    }
    /**
     * @return {?}
     */
    Directionality.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this.change.complete();
        };
    /** @nocollapse */ Directionality.ngInjectableDef = Object(core["defineInjectable"])({ factory: function Directionality_Factory() { return new Directionality(Object(core["inject"])(DIR_DOCUMENT, 8)); }, token: Directionality, providedIn: "root" });
    return Directionality;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Directive to listen for changes of direction of part of the DOM.
 *
 * Provides itself as Directionality such that descendant directives only need to ever inject
 * Directionality to get the closest direction.
 */
var bidi_es5_Dir = /*@__PURE__*/ (function () {
    function Dir() {
        /**
         * Normalized direction that accounts for invalid/unsupported values.
         */
        this._dir = 'ltr';
        /**
         * Whether the `value` has been set to its initial value.
         */
        this._isInitialized = false;
        /**
         * Event emitted when the direction changes.
         */
        this.change = new core["EventEmitter"]();
    }
    Object.defineProperty(Dir.prototype, "dir", {
        /** @docs-private */
        get: /**
         * \@docs-private
         * @return {?}
         */ function () { return this._dir; },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) {
            /** @type {?} */
            var old = this._dir;
            /** @type {?} */
            var normalizedValue = value ? value.toLowerCase() : value;
            this._rawDir = value;
            this._dir = (normalizedValue === 'ltr' || normalizedValue === 'rtl') ? normalizedValue : 'ltr';
            if (old !== this._dir && this._isInitialized) {
                this.change.emit(this._dir);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dir.prototype, "value", {
        /** Current layout direction of the element. */
        get: /**
         * Current layout direction of the element.
         * @return {?}
         */ function () { return this.dir; },
        enumerable: true,
        configurable: true
    });
    /** Initialize once default value has been set. */
    /**
     * Initialize once default value has been set.
     * @return {?}
     */
    Dir.prototype.ngAfterContentInit = /**
     * Initialize once default value has been set.
     * @return {?}
     */
        function () {
            this._isInitialized = true;
        };
    /**
     * @return {?}
     */
    Dir.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this.change.complete();
        };
    return Dir;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BidiModule = /*@__PURE__*/ (function () {
    function BidiModule() {
    }
    return BidiModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */





// CONCATENATED MODULE: ./node_modules/@angular/cdk/esm5/collections.es5.js
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** PURE_IMPORTS_START tslib,rxjs,_angular_core PURE_IMPORTS_END */



/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
var /**
 * @abstract
 * @template T
 */ DataSource = /*@__PURE__*/ (function () {
    function DataSource() {
    }
    return DataSource;
}());
/**
 * Checks whether an object is a data source.
 * @param {?} value
 * @return {?}
 */
function isDataSource(value) {
    // Check if the value is a DataSource by observing if it has a connect function. Cannot
    // be checked as an `instanceof DataSource` since people could create their own sources
    // that match the interface, but don't extend DataSource.
    return value && typeof value.connect === 'function';
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * DataSource wrapper for a native array.
 * @template T
 */
var /**
 * DataSource wrapper for a native array.
 * @template T
 */ collections_es5_ArrayDataSource = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(ArrayDataSource, _super);
    function ArrayDataSource(_data) {
        var _this = _super.call(this) || this;
        _this._data = _data;
        return _this;
    }
    /**
     * @return {?}
     */
    ArrayDataSource.prototype.connect = /**
     * @return {?}
     */
        function () {
            return this._data instanceof _esm5["d" /* Observable */] ? this._data : Object(_esm5["x" /* of */])(this._data);
        };
    /**
     * @return {?}
     */
    ArrayDataSource.prototype.disconnect = /**
     * @return {?}
     */
        function () { };
    return ArrayDataSource;
}(DataSource));
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Class to be used to power selecting one or more options from a list.
 * @template T
 */
var /**
 * Class to be used to power selecting one or more options from a list.
 * @template T
 */ collections_es5_SelectionModel = /*@__PURE__*/ (function () {
    function SelectionModel(_multiple, initiallySelectedValues, _emitChanges) {
        if (_multiple === void 0) {
            _multiple = false;
        }
        if (_emitChanges === void 0) {
            _emitChanges = true;
        }
        var _this = this;
        this._multiple = _multiple;
        this._emitChanges = _emitChanges;
        /**
         * Currently-selected values.
         */
        this._selection = new Set();
        /**
         * Keeps track of the deselected options that haven't been emitted by the change event.
         */
        this._deselectedToEmit = [];
        /**
         * Keeps track of the selected options that haven't been emitted by the change event.
         */
        this._selectedToEmit = [];
        /**
         * Event emitted when the value has changed.
         */
        this.changed = new _esm5["e" /* Subject */]();
        /**
         * Event emitted when the value has changed.
         * @deprecated Use `changed` instead.
         * \@breaking-change 8.0.0 To be changed to `changed`
         */
        this.onChange = this.changed;
        if (initiallySelectedValues && initiallySelectedValues.length) {
            if (_multiple) {
                initiallySelectedValues.forEach(function (value) { return _this._markSelected(value); });
            }
            else {
                this._markSelected(initiallySelectedValues[0]);
            }
            // Clear the array in order to avoid firing the change event for preselected values.
            this._selectedToEmit.length = 0;
        }
    }
    Object.defineProperty(SelectionModel.prototype, "selected", {
        /** Selected values. */
        get: /**
         * Selected values.
         * @return {?}
         */ function () {
            if (!this._selected) {
                this._selected = Array.from(this._selection.values());
            }
            return this._selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects a value or an array of values.
     */
    /**
     * Selects a value or an array of values.
     * @param {...?} values
     * @return {?}
     */
    SelectionModel.prototype.select = /**
     * Selects a value or an array of values.
     * @param {...?} values
     * @return {?}
     */
        function () {
            var _this = this;
            var values = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                values[_i] = arguments[_i];
            }
            this._verifyValueAssignment(values);
            values.forEach(function (value) { return _this._markSelected(value); });
            this._emitChangeEvent();
        };
    /**
     * Deselects a value or an array of values.
     */
    /**
     * Deselects a value or an array of values.
     * @param {...?} values
     * @return {?}
     */
    SelectionModel.prototype.deselect = /**
     * Deselects a value or an array of values.
     * @param {...?} values
     * @return {?}
     */
        function () {
            var _this = this;
            var values = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                values[_i] = arguments[_i];
            }
            this._verifyValueAssignment(values);
            values.forEach(function (value) { return _this._unmarkSelected(value); });
            this._emitChangeEvent();
        };
    /**
     * Toggles a value between selected and deselected.
     */
    /**
     * Toggles a value between selected and deselected.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.toggle = /**
     * Toggles a value between selected and deselected.
     * @param {?} value
     * @return {?}
     */
        function (value) {
            this.isSelected(value) ? this.deselect(value) : this.select(value);
        };
    /**
     * Clears all of the selected values.
     */
    /**
     * Clears all of the selected values.
     * @return {?}
     */
    SelectionModel.prototype.clear = /**
     * Clears all of the selected values.
     * @return {?}
     */
        function () {
            this._unmarkAll();
            this._emitChangeEvent();
        };
    /**
     * Determines whether a value is selected.
     */
    /**
     * Determines whether a value is selected.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.isSelected = /**
     * Determines whether a value is selected.
     * @param {?} value
     * @return {?}
     */
        function (value) {
            return this._selection.has(value);
        };
    /**
     * Determines whether the model does not have a value.
     */
    /**
     * Determines whether the model does not have a value.
     * @return {?}
     */
    SelectionModel.prototype.isEmpty = /**
     * Determines whether the model does not have a value.
     * @return {?}
     */
        function () {
            return this._selection.size === 0;
        };
    /**
     * Determines whether the model has a value.
     */
    /**
     * Determines whether the model has a value.
     * @return {?}
     */
    SelectionModel.prototype.hasValue = /**
     * Determines whether the model has a value.
     * @return {?}
     */
        function () {
            return !this.isEmpty();
        };
    /**
     * Sorts the selected values based on a predicate function.
     */
    /**
     * Sorts the selected values based on a predicate function.
     * @param {?=} predicate
     * @return {?}
     */
    SelectionModel.prototype.sort = /**
     * Sorts the selected values based on a predicate function.
     * @param {?=} predicate
     * @return {?}
     */
        function (predicate) {
            if (this._multiple && this.selected) {
                ((this._selected)).sort(predicate);
            }
        };
    /**
     * Gets whether multiple values can be selected.
     */
    /**
     * Gets whether multiple values can be selected.
     * @return {?}
     */
    SelectionModel.prototype.isMultipleSelection = /**
     * Gets whether multiple values can be selected.
     * @return {?}
     */
        function () {
            return this._multiple;
        };
    /** Emits a change event and clears the records of selected and deselected values. */
    /**
     * Emits a change event and clears the records of selected and deselected values.
     * @private
     * @return {?}
     */
    SelectionModel.prototype._emitChangeEvent = /**
     * Emits a change event and clears the records of selected and deselected values.
     * @private
     * @return {?}
     */
        function () {
            // Clear the selected values so they can be re-cached.
            this._selected = null;
            if (this._selectedToEmit.length || this._deselectedToEmit.length) {
                this.changed.next({
                    source: this,
                    added: this._selectedToEmit,
                    removed: this._deselectedToEmit
                });
                this._deselectedToEmit = [];
                this._selectedToEmit = [];
            }
        };
    /** Selects a value. */
    /**
     * Selects a value.
     * @private
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype._markSelected = /**
     * Selects a value.
     * @private
     * @param {?} value
     * @return {?}
     */
        function (value) {
            if (!this.isSelected(value)) {
                if (!this._multiple) {
                    this._unmarkAll();
                }
                this._selection.add(value);
                if (this._emitChanges) {
                    this._selectedToEmit.push(value);
                }
            }
        };
    /** Deselects a value. */
    /**
     * Deselects a value.
     * @private
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype._unmarkSelected = /**
     * Deselects a value.
     * @private
     * @param {?} value
     * @return {?}
     */
        function (value) {
            if (this.isSelected(value)) {
                this._selection.delete(value);
                if (this._emitChanges) {
                    this._deselectedToEmit.push(value);
                }
            }
        };
    /** Clears out the selected values. */
    /**
     * Clears out the selected values.
     * @private
     * @return {?}
     */
    SelectionModel.prototype._unmarkAll = /**
     * Clears out the selected values.
     * @private
     * @return {?}
     */
        function () {
            var _this = this;
            if (!this.isEmpty()) {
                this._selection.forEach(function (value) { return _this._unmarkSelected(value); });
            }
        };
    /**
     * Verifies the value assignment and throws an error if the specified value array is
     * including multiple values while the selection model is not supporting multiple values.
     */
    /**
     * Verifies the value assignment and throws an error if the specified value array is
     * including multiple values while the selection model is not supporting multiple values.
     * @private
     * @param {?} values
     * @return {?}
     */
    SelectionModel.prototype._verifyValueAssignment = /**
     * Verifies the value assignment and throws an error if the specified value array is
     * including multiple values while the selection model is not supporting multiple values.
     * @private
     * @param {?} values
     * @return {?}
     */
        function (values) {
            if (values.length > 1 && !this._multiple) {
                throw getMultipleValuesInSingleSelectionError();
            }
        };
    return SelectionModel;
}());
/**
 * Returns an error that reports that multiple values are passed into a selection model
 * with a single value.
 * \@docs-private
 * @return {?}
 */
function getMultipleValuesInSingleSelectionError() {
    return Error('Cannot pass multiple values into SelectionModel with single-value mode.');
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Class to coordinate unique selection based on name.
 * Intended to be consumed as an Angular service.
 * This service is needed because native radio change events are only fired on the item currently
 * being selected, and we still need to uncheck the previous selection.
 *
 * This service does not *store* any IDs and names because they may change at any time, so it is
 * less error-prone if they are simply passed through when the events occur.
 */
var collections_es5_UniqueSelectionDispatcher = /*@__PURE__*/ (function () {
    function UniqueSelectionDispatcher() {
        this._listeners = [];
    }
    /**
     * Notify other items that selection for the given name has been set.
     * @param id ID of the item.
     * @param name Name of the item.
     */
    /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.notify = /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
        function (id, name) {
            for (var _i = 0, _a = this._listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener(id, name);
            }
        };
    /**
     * Listen for future changes to item selection.
     * @return Function used to deregister listener
     */
    /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?} Function used to deregister listener
     */
    UniqueSelectionDispatcher.prototype.listen = /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?} Function used to deregister listener
     */
        function (listener) {
            var _this = this;
            this._listeners.push(listener);
            return function () {
                _this._listeners = _this._listeners.filter(function (registered) {
                    return listener !== registered;
                });
            };
        };
    /**
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this._listeners = [];
        };
    /** @nocollapse */ UniqueSelectionDispatcher.ngInjectableDef = Object(core["defineInjectable"])({ factory: function UniqueSelectionDispatcher_Factory() { return new UniqueSelectionDispatcher(); }, token: UniqueSelectionDispatcher, providedIn: "root" });
    return UniqueSelectionDispatcher;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */





// CONCATENATED MODULE: ./node_modules/@angular/cdk/esm5/scrolling.es5.js
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** PURE_IMPORTS_START _angular_core,_angular_cdk_coercion,rxjs,rxjs_operators,_angular_cdk_platform,_angular_cdk_bidi,tslib,_angular_cdk_collections PURE_IMPORTS_END */








/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * The injection token used to specify the virtual scrolling strategy.
 * @type {?}
 */
var VIRTUAL_SCROLL_STRATEGY = /*@__PURE__*/ new core["InjectionToken"]('VIRTUAL_SCROLL_STRATEGY');
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Virtual scrolling strategy for lists with items of known fixed size.
 */
var /**
 * Virtual scrolling strategy for lists with items of known fixed size.
 */ scrolling_es5_FixedSizeVirtualScrollStrategy = /*@__PURE__*/ (function () {
    /**
     * @param itemSize The size of the items in the virtually scrolling list.
     * @param minBufferPx The minimum amount of buffer (in pixels) before needing to render more
     * @param maxBufferPx The amount of buffer (in pixels) to render when rendering more.
     */
    function FixedSizeVirtualScrollStrategy(itemSize, minBufferPx, maxBufferPx) {
        this._scrolledIndexChange = new _esm5["e" /* Subject */]();
        /**
         * \@docs-private Implemented as part of VirtualScrollStrategy.
         */
        this.scrolledIndexChange = this._scrolledIndexChange.pipe(Object(operators["distinctUntilChanged"])());
        /**
         * The attached viewport.
         */
        this._viewport = null;
        this._itemSize = itemSize;
        this._minBufferPx = minBufferPx;
        this._maxBufferPx = maxBufferPx;
    }
    /**
     * Attaches this scroll strategy to a viewport.
     * @param viewport The viewport to attach this strategy to.
     */
    /**
     * Attaches this scroll strategy to a viewport.
     * @param {?} viewport The viewport to attach this strategy to.
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype.attach = /**
     * Attaches this scroll strategy to a viewport.
     * @param {?} viewport The viewport to attach this strategy to.
     * @return {?}
     */
        function (viewport) {
            this._viewport = viewport;
            this._updateTotalContentSize();
            this._updateRenderedRange();
        };
    /** Detaches this scroll strategy from the currently attached viewport. */
    /**
     * Detaches this scroll strategy from the currently attached viewport.
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype.detach = /**
     * Detaches this scroll strategy from the currently attached viewport.
     * @return {?}
     */
        function () {
            this._scrolledIndexChange.complete();
            this._viewport = null;
        };
    /**
     * Update the item size and buffer size.
     * @param itemSize The size of the items in the virtually scrolling list.
     * @param minBufferPx The minimum amount of buffer (in pixels) before needing to render more
     * @param maxBufferPx The amount of buffer (in pixels) to render when rendering more.
     */
    /**
     * Update the item size and buffer size.
     * @param {?} itemSize The size of the items in the virtually scrolling list.
     * @param {?} minBufferPx The minimum amount of buffer (in pixels) before needing to render more
     * @param {?} maxBufferPx The amount of buffer (in pixels) to render when rendering more.
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype.updateItemAndBufferSize = /**
     * Update the item size and buffer size.
     * @param {?} itemSize The size of the items in the virtually scrolling list.
     * @param {?} minBufferPx The minimum amount of buffer (in pixels) before needing to render more
     * @param {?} maxBufferPx The amount of buffer (in pixels) to render when rendering more.
     * @return {?}
     */
        function (itemSize, minBufferPx, maxBufferPx) {
            if (maxBufferPx < minBufferPx) {
                throw Error('CDK virtual scroll: maxBufferPx must be greater than or equal to minBufferPx');
            }
            this._itemSize = itemSize;
            this._minBufferPx = minBufferPx;
            this._maxBufferPx = maxBufferPx;
            this._updateTotalContentSize();
            this._updateRenderedRange();
        };
    /** @docs-private Implemented as part of VirtualScrollStrategy. */
    /**
     * \@docs-private Implemented as part of VirtualScrollStrategy.
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype.onContentScrolled = /**
     * \@docs-private Implemented as part of VirtualScrollStrategy.
     * @return {?}
     */
        function () {
            this._updateRenderedRange();
        };
    /** @docs-private Implemented as part of VirtualScrollStrategy. */
    /**
     * \@docs-private Implemented as part of VirtualScrollStrategy.
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype.onDataLengthChanged = /**
     * \@docs-private Implemented as part of VirtualScrollStrategy.
     * @return {?}
     */
        function () {
            this._updateTotalContentSize();
            this._updateRenderedRange();
        };
    /** @docs-private Implemented as part of VirtualScrollStrategy. */
    /**
     * \@docs-private Implemented as part of VirtualScrollStrategy.
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype.onContentRendered = /**
     * \@docs-private Implemented as part of VirtualScrollStrategy.
     * @return {?}
     */
        function () { };
    /** @docs-private Implemented as part of VirtualScrollStrategy. */
    /**
     * \@docs-private Implemented as part of VirtualScrollStrategy.
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype.onRenderedOffsetChanged = /**
     * \@docs-private Implemented as part of VirtualScrollStrategy.
     * @return {?}
     */
        function () { };
    /**
     * Scroll to the offset for the given index.
     * @param index The index of the element to scroll to.
     * @param behavior The ScrollBehavior to use when scrolling.
     */
    /**
     * Scroll to the offset for the given index.
     * @param {?} index The index of the element to scroll to.
     * @param {?} behavior The ScrollBehavior to use when scrolling.
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype.scrollToIndex = /**
     * Scroll to the offset for the given index.
     * @param {?} index The index of the element to scroll to.
     * @param {?} behavior The ScrollBehavior to use when scrolling.
     * @return {?}
     */
        function (index, behavior) {
            if (this._viewport) {
                this._viewport.scrollToOffset(index * this._itemSize, behavior);
            }
        };
    /** Update the viewport's total content size. */
    /**
     * Update the viewport's total content size.
     * @private
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype._updateTotalContentSize = /**
     * Update the viewport's total content size.
     * @private
     * @return {?}
     */
        function () {
            if (!this._viewport) {
                return;
            }
            this._viewport.setTotalContentSize(this._viewport.getDataLength() * this._itemSize);
        };
    /** Update the viewport's rendered range. */
    /**
     * Update the viewport's rendered range.
     * @private
     * @return {?}
     */
    FixedSizeVirtualScrollStrategy.prototype._updateRenderedRange = /**
     * Update the viewport's rendered range.
     * @private
     * @return {?}
     */
        function () {
            if (!this._viewport) {
                return;
            }
            /** @type {?} */
            var scrollOffset = this._viewport.measureScrollOffset();
            /** @type {?} */
            var firstVisibleIndex = scrollOffset / this._itemSize;
            /** @type {?} */
            var renderedRange = this._viewport.getRenderedRange();
            /** @type {?} */
            var newRange = { start: renderedRange.start, end: renderedRange.end };
            /** @type {?} */
            var viewportSize = this._viewport.getViewportSize();
            /** @type {?} */
            var dataLength = this._viewport.getDataLength();
            /** @type {?} */
            var startBuffer = scrollOffset - newRange.start * this._itemSize;
            if (startBuffer < this._minBufferPx && newRange.start != 0) {
                /** @type {?} */
                var expandStart = Math.ceil((this._maxBufferPx - startBuffer) / this._itemSize);
                newRange.start = Math.max(0, newRange.start - expandStart);
                newRange.end = Math.min(dataLength, Math.ceil(firstVisibleIndex + (viewportSize + this._minBufferPx) / this._itemSize));
            }
            else {
                /** @type {?} */
                var endBuffer = newRange.end * this._itemSize - (scrollOffset + viewportSize);
                if (endBuffer < this._minBufferPx && newRange.end != dataLength) {
                    /** @type {?} */
                    var expandEnd = Math.ceil((this._maxBufferPx - endBuffer) / this._itemSize);
                    if (expandEnd > 0) {
                        newRange.end = Math.min(dataLength, newRange.end + expandEnd);
                        newRange.start = Math.max(0, Math.floor(firstVisibleIndex - this._minBufferPx / this._itemSize));
                    }
                }
            }
            this._viewport.setRenderedRange(newRange);
            this._viewport.setRenderedContentOffset(this._itemSize * newRange.start);
            this._scrolledIndexChange.next(Math.floor(firstVisibleIndex));
        };
    return FixedSizeVirtualScrollStrategy;
}());
/**
 * Provider factory for `FixedSizeVirtualScrollStrategy` that simply extracts the already created
 * `FixedSizeVirtualScrollStrategy` from the given directive.
 * @param {?} fixedSizeDir The instance of `CdkFixedSizeVirtualScroll` to extract the
 *     `FixedSizeVirtualScrollStrategy` from.
 * @return {?}
 */
function _fixedSizeVirtualScrollStrategyFactory(fixedSizeDir) {
    return fixedSizeDir._scrollStrategy;
}
/**
 * A virtual scroll strategy that supports fixed-size items.
 */
var scrolling_es5_CdkFixedSizeVirtualScroll = /*@__PURE__*/ (function () {
    function CdkFixedSizeVirtualScroll() {
        this._itemSize = 20;
        this._minBufferPx = 100;
        this._maxBufferPx = 200;
        /**
         * The scroll strategy used by this directive.
         */
        this._scrollStrategy = new scrolling_es5_FixedSizeVirtualScrollStrategy(this.itemSize, this.minBufferPx, this.maxBufferPx);
    }
    Object.defineProperty(CdkFixedSizeVirtualScroll.prototype, "itemSize", {
        /** The size of the items in the list (in pixels). */
        get: /**
         * The size of the items in the list (in pixels).
         * @return {?}
         */ function () { return this._itemSize; },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) { this._itemSize = coerceNumberProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkFixedSizeVirtualScroll.prototype, "minBufferPx", {
        /**
         * The minimum amount of buffer rendered beyond the viewport (in pixels).
         * If the amount of buffer dips below this number, more items will be rendered. Defaults to 100px.
         */
        get: /**
         * The minimum amount of buffer rendered beyond the viewport (in pixels).
         * If the amount of buffer dips below this number, more items will be rendered. Defaults to 100px.
         * @return {?}
         */ function () { return this._minBufferPx; },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) { this._minBufferPx = coerceNumberProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkFixedSizeVirtualScroll.prototype, "maxBufferPx", {
        /**
         * The number of pixels worth of buffer to render for when rendering new items. Defaults to 200px.
         */
        get: /**
         * The number of pixels worth of buffer to render for when rendering new items. Defaults to 200px.
         * @return {?}
         */ function () { return this._maxBufferPx; },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) { this._maxBufferPx = coerceNumberProperty(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkFixedSizeVirtualScroll.prototype.ngOnChanges = /**
     * @return {?}
     */
        function () {
            this._scrollStrategy.updateItemAndBufferSize(this.itemSize, this.minBufferPx, this.maxBufferPx);
        };
    return CdkFixedSizeVirtualScroll;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Time in ms to throttle the scrolling events by default.
 * @type {?}
 */
var DEFAULT_SCROLL_TIME = 20;
/**
 * Service contained all registered Scrollable references and emits an event when any one of the
 * Scrollable references emit a scrolled event.
 */
var scrolling_es5_ScrollDispatcher = /*@__PURE__*/ (function () {
    function ScrollDispatcher(_ngZone, _platform) {
        this._ngZone = _ngZone;
        this._platform = _platform;
        /**
         * Subject for notifying that a registered scrollable reference element has been scrolled.
         */
        this._scrolled = new _esm5["e" /* Subject */]();
        /**
         * Keeps track of the global `scroll` and `resize` subscriptions.
         */
        this._globalSubscription = null;
        /**
         * Keeps track of the amount of subscriptions to `scrolled`. Used for cleaning up afterwards.
         */
        this._scrolledCount = 0;
        /**
         * Map of all the scrollable references that are registered with the service and their
         * scroll event subscriptions.
         */
        this.scrollContainers = new Map();
    }
    /**
     * Registers a scrollable instance with the service and listens for its scrolled events. When the
     * scrollable is scrolled, the service emits the event to its scrolled observable.
     * @param scrollable Scrollable instance to be registered.
     */
    /**
     * Registers a scrollable instance with the service and listens for its scrolled events. When the
     * scrollable is scrolled, the service emits the event to its scrolled observable.
     * @param {?} scrollable Scrollable instance to be registered.
     * @return {?}
     */
    ScrollDispatcher.prototype.register = /**
     * Registers a scrollable instance with the service and listens for its scrolled events. When the
     * scrollable is scrolled, the service emits the event to its scrolled observable.
     * @param {?} scrollable Scrollable instance to be registered.
     * @return {?}
     */
        function (scrollable) {
            var _this = this;
            if (!this.scrollContainers.has(scrollable)) {
                this.scrollContainers.set(scrollable, scrollable.elementScrolled()
                    .subscribe(function () { return _this._scrolled.next(scrollable); }));
            }
        };
    /**
     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
     * @param scrollable Scrollable instance to be deregistered.
     */
    /**
     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
     * @param {?} scrollable Scrollable instance to be deregistered.
     * @return {?}
     */
    ScrollDispatcher.prototype.deregister = /**
     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
     * @param {?} scrollable Scrollable instance to be deregistered.
     * @return {?}
     */
        function (scrollable) {
            /** @type {?} */
            var scrollableReference = this.scrollContainers.get(scrollable);
            if (scrollableReference) {
                scrollableReference.unsubscribe();
                this.scrollContainers.delete(scrollable);
            }
        };
    /**
     * Returns an observable that emits an event whenever any of the registered Scrollable
     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
     * to override the default "throttle" time.
     *
     * **Note:** in order to avoid hitting change detection for every scroll event,
     * all of the events emitted from this stream will be run outside the Angular zone.
     * If you need to update any data bindings as a result of a scroll event, you have
     * to run the callback using `NgZone.run`.
     */
    /**
     * Returns an observable that emits an event whenever any of the registered Scrollable
     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
     * to override the default "throttle" time.
     *
     * **Note:** in order to avoid hitting change detection for every scroll event,
     * all of the events emitted from this stream will be run outside the Angular zone.
     * If you need to update any data bindings as a result of a scroll event, you have
     * to run the callback using `NgZone.run`.
     * @param {?=} auditTimeInMs
     * @return {?}
     */
    ScrollDispatcher.prototype.scrolled = /**
     * Returns an observable that emits an event whenever any of the registered Scrollable
     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
     * to override the default "throttle" time.
     *
     * **Note:** in order to avoid hitting change detection for every scroll event,
     * all of the events emitted from this stream will be run outside the Angular zone.
     * If you need to update any data bindings as a result of a scroll event, you have
     * to run the callback using `NgZone.run`.
     * @param {?=} auditTimeInMs
     * @return {?}
     */
        function (auditTimeInMs) {
            var _this = this;
            if (auditTimeInMs === void 0) {
                auditTimeInMs = DEFAULT_SCROLL_TIME;
            }
            if (!this._platform.isBrowser) {
                return Object(_esm5["x" /* of */])();
            }
            return new _esm5["d" /* Observable */](function (observer) {
                if (!_this._globalSubscription) {
                    _this._addGlobalListener();
                }
                // In the case of a 0ms delay, use an observable without auditTime
                // since it does add a perceptible delay in processing overhead.
                /** @type {?} */
                var subscription = auditTimeInMs > 0 ?
                    _this._scrolled.pipe(Object(operators["auditTime"])(auditTimeInMs)).subscribe(observer) :
                    _this._scrolled.subscribe(observer);
                _this._scrolledCount++;
                return function () {
                    subscription.unsubscribe();
                    _this._scrolledCount--;
                    if (!_this._scrolledCount) {
                        _this._removeGlobalListener();
                    }
                };
            });
        };
    /**
     * @return {?}
     */
    ScrollDispatcher.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            var _this = this;
            this._removeGlobalListener();
            this.scrollContainers.forEach(function (_, container) { return _this.deregister(container); });
            this._scrolled.complete();
        };
    /**
     * Returns an observable that emits whenever any of the
     * scrollable ancestors of an element are scrolled.
     * @param elementRef Element whose ancestors to listen for.
     * @param auditTimeInMs Time to throttle the scroll events.
     */
    /**
     * Returns an observable that emits whenever any of the
     * scrollable ancestors of an element are scrolled.
     * @param {?} elementRef Element whose ancestors to listen for.
     * @param {?=} auditTimeInMs Time to throttle the scroll events.
     * @return {?}
     */
    ScrollDispatcher.prototype.ancestorScrolled = /**
     * Returns an observable that emits whenever any of the
     * scrollable ancestors of an element are scrolled.
     * @param {?} elementRef Element whose ancestors to listen for.
     * @param {?=} auditTimeInMs Time to throttle the scroll events.
     * @return {?}
     */
        function (elementRef, auditTimeInMs) {
            /** @type {?} */
            var ancestors = this.getAncestorScrollContainers(elementRef);
            return this.scrolled(auditTimeInMs).pipe(Object(operators["filter"])(function (target) {
                return !target || ancestors.indexOf(target) > -1;
            }));
        };
    /** Returns all registered Scrollables that contain the provided element. */
    /**
     * Returns all registered Scrollables that contain the provided element.
     * @param {?} elementRef
     * @return {?}
     */
    ScrollDispatcher.prototype.getAncestorScrollContainers = /**
     * Returns all registered Scrollables that contain the provided element.
     * @param {?} elementRef
     * @return {?}
     */
        function (elementRef) {
            var _this = this;
            /** @type {?} */
            var scrollingContainers = [];
            this.scrollContainers.forEach(function (_subscription, scrollable) {
                if (_this._scrollableContainsElement(scrollable, elementRef)) {
                    scrollingContainers.push(scrollable);
                }
            });
            return scrollingContainers;
        };
    /** Returns true if the element is contained within the provided Scrollable. */
    /**
     * Returns true if the element is contained within the provided Scrollable.
     * @private
     * @param {?} scrollable
     * @param {?} elementRef
     * @return {?}
     */
    ScrollDispatcher.prototype._scrollableContainsElement = /**
     * Returns true if the element is contained within the provided Scrollable.
     * @private
     * @param {?} scrollable
     * @param {?} elementRef
     * @return {?}
     */
        function (scrollable, elementRef) {
            /** @type {?} */
            var element = elementRef.nativeElement;
            /** @type {?} */
            var scrollableElement = scrollable.getElementRef().nativeElement;
            // Traverse through the element parents until we reach null, checking if any of the elements
            // are the scrollable's element.
            do {
                if (element == scrollableElement) {
                    return true;
                }
            } while (element = ((element)).parentElement);
            return false;
        };
    /** Sets up the global scroll listeners. */
    /**
     * Sets up the global scroll listeners.
     * @private
     * @return {?}
     */
    ScrollDispatcher.prototype._addGlobalListener = /**
     * Sets up the global scroll listeners.
     * @private
     * @return {?}
     */
        function () {
            var _this = this;
            this._globalSubscription = this._ngZone.runOutsideAngular(function () {
                return Object(_esm5["r" /* fromEvent */])(window.document, 'scroll').subscribe(function () { return _this._scrolled.next(); });
            });
        };
    /** Cleans up the global scroll listener. */
    /**
     * Cleans up the global scroll listener.
     * @private
     * @return {?}
     */
    ScrollDispatcher.prototype._removeGlobalListener = /**
     * Cleans up the global scroll listener.
     * @private
     * @return {?}
     */
        function () {
            if (this._globalSubscription) {
                this._globalSubscription.unsubscribe();
                this._globalSubscription = null;
            }
        };
    /** @nocollapse */ ScrollDispatcher.ngInjectableDef = Object(core["defineInjectable"])({ factory: function ScrollDispatcher_Factory() { return new ScrollDispatcher(Object(core["inject"])(core["NgZone"]), Object(core["inject"])(platform_es5_Platform)); }, token: ScrollDispatcher, providedIn: "root" });
    return ScrollDispatcher;
}());
/**
 * \@docs-private \@deprecated \@breaking-change 8.0.0
 * @param {?} parentDispatcher
 * @param {?} ngZone
 * @param {?} platform
 * @return {?}
 */
function SCROLL_DISPATCHER_PROVIDER_FACTORY(parentDispatcher, ngZone, platform) {
    return parentDispatcher || new scrolling_es5_ScrollDispatcher(ngZone, platform);
}
/**
 * \@docs-private \@deprecated \@breaking-change 8.0.0
 * @type {?}
 */
var SCROLL_DISPATCHER_PROVIDER = {
    // If there is already a ScrollDispatcher available, use that. Otherwise, provide a new one.
    provide: scrolling_es5_ScrollDispatcher,
    deps: [[/*@__PURE__*/ new core["Optional"](), /*@__PURE__*/ new core["SkipSelf"](), scrolling_es5_ScrollDispatcher], core["NgZone"], platform_es5_Platform],
    useFactory: SCROLL_DISPATCHER_PROVIDER_FACTORY
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Sends an event when the directive's element is scrolled. Registers itself with the
 * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
 * can be listened to through the service.
 */
var scrolling_es5_CdkScrollable = /*@__PURE__*/ (function () {
    function CdkScrollable(elementRef, scrollDispatcher, ngZone, dir) {
        var _this = this;
        this.elementRef = elementRef;
        this.scrollDispatcher = scrollDispatcher;
        this.ngZone = ngZone;
        this.dir = dir;
        this._destroyed = new _esm5["e" /* Subject */]();
        this._elementScrolled = new _esm5["d" /* Observable */](function (observer) {
            return _this.ngZone.runOutsideAngular(function () {
                return Object(_esm5["r" /* fromEvent */])(_this.elementRef.nativeElement, 'scroll').pipe(Object(operators["takeUntil"])(_this._destroyed))
                    .subscribe(observer);
            });
        });
    }
    /**
     * @return {?}
     */
    CdkScrollable.prototype.ngOnInit = /**
     * @return {?}
     */
        function () {
            this.scrollDispatcher.register(this);
        };
    /**
     * @return {?}
     */
    CdkScrollable.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this.scrollDispatcher.deregister(this);
            this._destroyed.next();
            this._destroyed.complete();
        };
    /** Returns observable that emits when a scroll event is fired on the host element. */
    /**
     * Returns observable that emits when a scroll event is fired on the host element.
     * @return {?}
     */
    CdkScrollable.prototype.elementScrolled = /**
     * Returns observable that emits when a scroll event is fired on the host element.
     * @return {?}
     */
        function () {
            return this._elementScrolled;
        };
    /** Gets the ElementRef for the viewport. */
    /**
     * Gets the ElementRef for the viewport.
     * @return {?}
     */
    CdkScrollable.prototype.getElementRef = /**
     * Gets the ElementRef for the viewport.
     * @return {?}
     */
        function () {
            return this.elementRef;
        };
    /**
     * Scrolls to the specified offsets. This is a normalized version of the browser's native scrollTo
     * method, since browsers are not consistent about what scrollLeft means in RTL. For this method
     * left and right always refer to the left and right side of the scrolling container irrespective
     * of the layout direction. start and end refer to left and right in an LTR context and vice-versa
     * in an RTL context.
     * @param options specified the offsets to scroll to.
     */
    /**
     * Scrolls to the specified offsets. This is a normalized version of the browser's native scrollTo
     * method, since browsers are not consistent about what scrollLeft means in RTL. For this method
     * left and right always refer to the left and right side of the scrolling container irrespective
     * of the layout direction. start and end refer to left and right in an LTR context and vice-versa
     * in an RTL context.
     * @param {?} options specified the offsets to scroll to.
     * @return {?}
     */
    CdkScrollable.prototype.scrollTo = /**
     * Scrolls to the specified offsets. This is a normalized version of the browser's native scrollTo
     * method, since browsers are not consistent about what scrollLeft means in RTL. For this method
     * left and right always refer to the left and right side of the scrolling container irrespective
     * of the layout direction. start and end refer to left and right in an LTR context and vice-versa
     * in an RTL context.
     * @param {?} options specified the offsets to scroll to.
     * @return {?}
     */
        function (options) {
            /** @type {?} */
            var el = this.elementRef.nativeElement;
            /** @type {?} */
            var isRtl = this.dir && this.dir.value == 'rtl';
            // Rewrite start & end offsets as right or left offsets.
            options.left = options.left == null ? (isRtl ? options.end : options.start) : options.left;
            options.right = options.right == null ? (isRtl ? options.start : options.end) : options.right;
            // Rewrite the bottom offset as a top offset.
            if (options.bottom != null) {
                (((options))).top =
                    el.scrollHeight - el.clientHeight - options.bottom;
            }
            // Rewrite the right offset as a left offset.
            if (isRtl && getRtlScrollAxisType() != RtlScrollAxisType.NORMAL) {
                if (options.left != null) {
                    (((options))).right =
                        el.scrollWidth - el.clientWidth - options.left;
                }
                if (getRtlScrollAxisType() == RtlScrollAxisType.INVERTED) {
                    options.left = options.right;
                }
                else if (getRtlScrollAxisType() == RtlScrollAxisType.NEGATED) {
                    options.left = options.right ? -options.right : options.right;
                }
            }
            else {
                if (options.right != null) {
                    (((options))).left =
                        el.scrollWidth - el.clientWidth - options.right;
                }
            }
            this._applyScrollToOptions(options);
        };
    /**
     * @private
     * @param {?} options
     * @return {?}
     */
    CdkScrollable.prototype._applyScrollToOptions = /**
     * @private
     * @param {?} options
     * @return {?}
     */
        function (options) {
            /** @type {?} */
            var el = this.elementRef.nativeElement;
            if (supportsScrollBehavior()) {
                el.scrollTo(options);
            }
            else {
                if (options.top != null) {
                    el.scrollTop = options.top;
                }
                if (options.left != null) {
                    el.scrollLeft = options.left;
                }
            }
        };
    /**
     * Measures the scroll offset relative to the specified edge of the viewport. This method can be
     * used instead of directly checking scrollLeft or scrollTop, since browsers are not consistent
     * about what scrollLeft means in RTL. The values returned by this method are normalized such that
     * left and right always refer to the left and right side of the scrolling container irrespective
     * of the layout direction. start and end refer to left and right in an LTR context and vice-versa
     * in an RTL context.
     * @param from The edge to measure from.
     */
    /**
     * Measures the scroll offset relative to the specified edge of the viewport. This method can be
     * used instead of directly checking scrollLeft or scrollTop, since browsers are not consistent
     * about what scrollLeft means in RTL. The values returned by this method are normalized such that
     * left and right always refer to the left and right side of the scrolling container irrespective
     * of the layout direction. start and end refer to left and right in an LTR context and vice-versa
     * in an RTL context.
     * @param {?} from The edge to measure from.
     * @return {?}
     */
    CdkScrollable.prototype.measureScrollOffset = /**
     * Measures the scroll offset relative to the specified edge of the viewport. This method can be
     * used instead of directly checking scrollLeft or scrollTop, since browsers are not consistent
     * about what scrollLeft means in RTL. The values returned by this method are normalized such that
     * left and right always refer to the left and right side of the scrolling container irrespective
     * of the layout direction. start and end refer to left and right in an LTR context and vice-versa
     * in an RTL context.
     * @param {?} from The edge to measure from.
     * @return {?}
     */
        function (from) {
            /** @type {?} */
            var LEFT = 'left';
            /** @type {?} */
            var RIGHT = 'right';
            /** @type {?} */
            var el = this.elementRef.nativeElement;
            if (from == 'top') {
                return el.scrollTop;
            }
            if (from == 'bottom') {
                return el.scrollHeight - el.clientHeight - el.scrollTop;
            }
            // Rewrite start & end as left or right offsets.
            /** @type {?} */
            var isRtl = this.dir && this.dir.value == 'rtl';
            if (from == 'start') {
                from = isRtl ? RIGHT : LEFT;
            }
            else if (from == 'end') {
                from = isRtl ? LEFT : RIGHT;
            }
            if (isRtl && getRtlScrollAxisType() == RtlScrollAxisType.INVERTED) {
                // For INVERTED, scrollLeft is (scrollWidth - clientWidth) when scrolled all the way left and
                // 0 when scrolled all the way right.
                if (from == LEFT) {
                    return el.scrollWidth - el.clientWidth - el.scrollLeft;
                }
                else {
                    return el.scrollLeft;
                }
            }
            else if (isRtl && getRtlScrollAxisType() == RtlScrollAxisType.NEGATED) {
                // For NEGATED, scrollLeft is -(scrollWidth - clientWidth) when scrolled all the way left and
                // 0 when scrolled all the way right.
                if (from == LEFT) {
                    return el.scrollLeft + el.scrollWidth - el.clientWidth;
                }
                else {
                    return -el.scrollLeft;
                }
            }
            else {
                // For NORMAL, as well as non-RTL contexts, scrollLeft is 0 when scrolled all the way left and
                // (scrollWidth - clientWidth) when scrolled all the way right.
                if (from == LEFT) {
                    return el.scrollLeft;
                }
                else {
                    return el.scrollWidth - el.clientWidth - el.scrollLeft;
                }
            }
        };
    return CdkScrollable;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Checks if the given ranges are equal.
 * @param {?} r1
 * @param {?} r2
 * @return {?}
 */
function rangesEqual(r1, r2) {
    return r1.start == r2.start && r1.end == r2.end;
}
/**
 * Scheduler to be used for scroll events. Needs to fall back to
 * something that doesn't rely on requestAnimationFrame on environments
 * that don't support it (e.g. server-side rendering).
 * @type {?}
 */
var SCROLL_SCHEDULER = typeof requestAnimationFrame !== 'undefined' ? _esm5["g" /* animationFrameScheduler */] : _esm5["h" /* asapScheduler */];
/**
 * A viewport that virtualizes it's scrolling with the help of `CdkVirtualForOf`.
 */
var scrolling_es5_CdkVirtualScrollViewport = /*@__PURE__*/ (function (_super) {
    Object(tslib_es6["__extends"])(CdkVirtualScrollViewport, _super);
    function CdkVirtualScrollViewport(elementRef, _changeDetectorRef, ngZone, _scrollStrategy, dir, scrollDispatcher) {
        var _this = _super.call(this, elementRef, scrollDispatcher, ngZone, dir) || this;
        _this.elementRef = elementRef;
        _this._changeDetectorRef = _changeDetectorRef;
        _this._scrollStrategy = _scrollStrategy;
        /**
         * Emits when the viewport is detached from a CdkVirtualForOf.
         */
        _this._detachedSubject = new _esm5["e" /* Subject */]();
        /**
         * Emits when the rendered range changes.
         */
        _this._renderedRangeSubject = new _esm5["e" /* Subject */]();
        /**
         * The direction the viewport scrolls.
         */
        _this.orientation = 'vertical';
        // Note: we don't use the typical EventEmitter here because we need to subscribe to the scroll
        // strategy lazily (i.e. only if the user is actually listening to the events). We do this because
        // depending on how the strategy calculates the scrolled index, it may come at a cost to
        // performance.
        /**
         * Emits when the index of the first element visible in the viewport changes.
         */
        _this.scrolledIndexChange = new _esm5["d" /* Observable */](function (observer) {
            return _this._scrollStrategy.scrolledIndexChange.subscribe(function (index) {
                return Promise.resolve().then(function () { return _this.ngZone.run(function () { return observer.next(index); }); });
            });
        });
        /**
         * A stream that emits whenever the rendered range changes.
         */
        _this.renderedRangeStream = _this._renderedRangeSubject.asObservable();
        /**
         * The transform used to scale the spacer to the same size as all content, including content that
         * is not currently rendered.
         */
        _this._totalContentSizeTransform = '';
        /**
         * The total size of all content (in pixels), including content that is not currently rendered.
         */
        _this._totalContentSize = 0;
        /**
         * The currently rendered range of indices.
         */
        _this._renderedRange = { start: 0, end: 0 };
        /**
         * The length of the data bound to this viewport (in number of items).
         */
        _this._dataLength = 0;
        /**
         * The size of the viewport (in pixels).
         */
        _this._viewportSize = 0;
        /**
         * The last rendered content offset that was set.
         */
        _this._renderedContentOffset = 0;
        /**
         * Whether the last rendered content offset was to the end of the content (and therefore needs to
         * be rewritten as an offset to the start of the content).
         */
        _this._renderedContentOffsetNeedsRewrite = false;
        /**
         * Whether there is a pending change detection cycle.
         */
        _this._isChangeDetectionPending = false;
        /**
         * A list of functions to run after the next change detection cycle.
         */
        _this._runAfterChangeDetection = [];
        if (!_scrollStrategy) {
            throw Error('Error: cdk-virtual-scroll-viewport requires the "itemSize" property to be set.');
        }
        return _this;
    }
    /**
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.ngOnInit = /**
     * @return {?}
     */
        function () {
            var _this = this;
            _super.prototype.ngOnInit.call(this);
            // It's still too early to measure the viewport at this point. Deferring with a promise allows
            // the Viewport to be rendered with the correct size before we measure. We run this outside the
            // zone to avoid causing more change detection cycles. We handle the change detection loop
            // ourselves instead.
            this.ngZone.runOutsideAngular(function () {
                return Promise.resolve().then(function () {
                    _this._measureViewportSize();
                    _this._scrollStrategy.attach(_this);
                    _this.elementScrolled()
                        .pipe(
                    // Start off with a fake scroll event so we properly detect our initial position.
                    Object(operators["startWith"])(((null))), 
                    // Collect multiple events into one until the next animation frame. This way if
                    // there are multiple scroll events in the same frame we only need to recheck
                    // our layout once.
                    Object(operators["auditTime"])(0, SCROLL_SCHEDULER))
                        .subscribe(function () { return _this._scrollStrategy.onContentScrolled(); });
                    _this._markChangeDetectionNeeded();
                });
            });
        };
    /**
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this.detach();
            this._scrollStrategy.detach();
            // Complete all subjects
            this._renderedRangeSubject.complete();
            this._detachedSubject.complete();
            _super.prototype.ngOnDestroy.call(this);
        };
    /** Attaches a `CdkVirtualForOf` to this viewport. */
    /**
     * Attaches a `CdkVirtualForOf` to this viewport.
     * @param {?} forOf
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.attach = /**
     * Attaches a `CdkVirtualForOf` to this viewport.
     * @param {?} forOf
     * @return {?}
     */
        function (forOf) {
            var _this = this;
            if (this._forOf) {
                throw Error('CdkVirtualScrollViewport is already attached.');
            }
            // Subscribe to the data stream of the CdkVirtualForOf to keep track of when the data length
            // changes. Run outside the zone to avoid triggering change detection, since we're managing the
            // change detection loop ourselves.
            this.ngZone.runOutsideAngular(function () {
                _this._forOf = forOf;
                _this._forOf.dataStream.pipe(Object(operators["takeUntil"])(_this._detachedSubject)).subscribe(function (data) {
                    /** @type {?} */
                    var newLength = data.length;
                    if (newLength !== _this._dataLength) {
                        _this._dataLength = newLength;
                        _this._scrollStrategy.onDataLengthChanged();
                    }
                    _this._doChangeDetection();
                });
            });
        };
    /** Detaches the current `CdkVirtualForOf`. */
    /**
     * Detaches the current `CdkVirtualForOf`.
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.detach = /**
     * Detaches the current `CdkVirtualForOf`.
     * @return {?}
     */
        function () {
            this._forOf = null;
            this._detachedSubject.next();
        };
    /** Gets the length of the data bound to this viewport (in number of items). */
    /**
     * Gets the length of the data bound to this viewport (in number of items).
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.getDataLength = /**
     * Gets the length of the data bound to this viewport (in number of items).
     * @return {?}
     */
        function () {
            return this._dataLength;
        };
    /** Gets the size of the viewport (in pixels). */
    /**
     * Gets the size of the viewport (in pixels).
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.getViewportSize = /**
     * Gets the size of the viewport (in pixels).
     * @return {?}
     */
        function () {
            return this._viewportSize;
        };
    // TODO(mmalerba): This is technically out of sync with what's really rendered until a render
    // cycle happens. I'm being careful to only call it after the render cycle is complete and before
    // setting it to something else, but its error prone and should probably be split into
    // `pendingRange` and `renderedRange`, the latter reflecting whats actually in the DOM.
    /** Get the current rendered range of items. */
    // TODO(mmalerba): This is technically out of sync with what's really rendered until a render
    // cycle happens. I'm being careful to only call it after the render cycle is complete and before
    // setting it to something else, but its error prone and should probably be split into
    // `pendingRange` and `renderedRange`, the latter reflecting whats actually in the DOM.
    /**
     * Get the current rendered range of items.
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.getRenderedRange =
        // TODO(mmalerba): This is technically out of sync with what's really rendered until a render
        // cycle happens. I'm being careful to only call it after the render cycle is complete and before
        // setting it to something else, but its error prone and should probably be split into
        // `pendingRange` and `renderedRange`, the latter reflecting whats actually in the DOM.
        /**
         * Get the current rendered range of items.
         * @return {?}
         */
        function () {
            return this._renderedRange;
        };
    /**
     * Sets the total size of all content (in pixels), including content that is not currently
     * rendered.
     */
    /**
     * Sets the total size of all content (in pixels), including content that is not currently
     * rendered.
     * @param {?} size
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.setTotalContentSize = /**
     * Sets the total size of all content (in pixels), including content that is not currently
     * rendered.
     * @param {?} size
     * @return {?}
     */
        function (size) {
            if (this._totalContentSize !== size) {
                this._totalContentSize = size;
                /** @type {?} */
                var axis = this.orientation == 'horizontal' ? 'X' : 'Y';
                this._totalContentSizeTransform = "scale" + axis + "(" + this._totalContentSize + ")";
                this._markChangeDetectionNeeded();
            }
        };
    /** Sets the currently rendered range of indices. */
    /**
     * Sets the currently rendered range of indices.
     * @param {?} range
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.setRenderedRange = /**
     * Sets the currently rendered range of indices.
     * @param {?} range
     * @return {?}
     */
        function (range) {
            var _this = this;
            if (!rangesEqual(this._renderedRange, range)) {
                this._renderedRangeSubject.next(this._renderedRange = range);
                this._markChangeDetectionNeeded(function () { return _this._scrollStrategy.onContentRendered(); });
            }
        };
    /**
     * Gets the offset from the start of the viewport to the start of the rendered data (in pixels).
     */
    /**
     * Gets the offset from the start of the viewport to the start of the rendered data (in pixels).
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.getOffsetToRenderedContentStart = /**
     * Gets the offset from the start of the viewport to the start of the rendered data (in pixels).
     * @return {?}
     */
        function () {
            return this._renderedContentOffsetNeedsRewrite ? null : this._renderedContentOffset;
        };
    /**
     * Sets the offset from the start of the viewport to either the start or end of the rendered data
     * (in pixels).
     */
    /**
     * Sets the offset from the start of the viewport to either the start or end of the rendered data
     * (in pixels).
     * @param {?} offset
     * @param {?=} to
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.setRenderedContentOffset = /**
     * Sets the offset from the start of the viewport to either the start or end of the rendered data
     * (in pixels).
     * @param {?} offset
     * @param {?=} to
     * @return {?}
     */
        function (offset, to) {
            var _this = this;
            if (to === void 0) {
                to = 'to-start';
            }
            // For a horizontal viewport in a right-to-left language we need to translate along the x-axis
            // in the negative direction.
            /** @type {?} */
            var isRtl = this.dir && this.dir.value == 'rtl';
            /** @type {?} */
            var isHorizontal = this.orientation == 'horizontal';
            /** @type {?} */
            var axis = isHorizontal ? 'X' : 'Y';
            /** @type {?} */
            var axisDirection = isHorizontal && isRtl ? -1 : 1;
            /** @type {?} */
            var transform = "translate" + axis + "(" + Number(axisDirection * offset) + "px)";
            this._renderedContentOffset = offset;
            if (to === 'to-end') {
                transform += " translate" + axis + "(-100%)";
                // The viewport should rewrite this as a `to-start` offset on the next render cycle. Otherwise
                // elements will appear to expand in the wrong direction (e.g. `mat-expansion-panel` would
                // expand upward).
                this._renderedContentOffsetNeedsRewrite = true;
            }
            if (this._renderedContentTransform != transform) {
                // We know this value is safe because we parse `offset` with `Number()` before passing it
                // into the string.
                this._renderedContentTransform = transform;
                this._markChangeDetectionNeeded(function () {
                    if (_this._renderedContentOffsetNeedsRewrite) {
                        _this._renderedContentOffset -= _this.measureRenderedContentSize();
                        _this._renderedContentOffsetNeedsRewrite = false;
                        _this.setRenderedContentOffset(_this._renderedContentOffset);
                    }
                    else {
                        _this._scrollStrategy.onRenderedOffsetChanged();
                    }
                });
            }
        };
    /**
     * Scrolls to the given offset from the start of the viewport. Please note that this is not always
     * the same as setting `scrollTop` or `scrollLeft`. In a horizontal viewport with right-to-left
     * direction, this would be the equivalent of setting a fictional `scrollRight` property.
     * @param offset The offset to scroll to.
     * @param behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
     */
    /**
     * Scrolls to the given offset from the start of the viewport. Please note that this is not always
     * the same as setting `scrollTop` or `scrollLeft`. In a horizontal viewport with right-to-left
     * direction, this would be the equivalent of setting a fictional `scrollRight` property.
     * @param {?} offset The offset to scroll to.
     * @param {?=} behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.scrollToOffset = /**
     * Scrolls to the given offset from the start of the viewport. Please note that this is not always
     * the same as setting `scrollTop` or `scrollLeft`. In a horizontal viewport with right-to-left
     * direction, this would be the equivalent of setting a fictional `scrollRight` property.
     * @param {?} offset The offset to scroll to.
     * @param {?=} behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
     * @return {?}
     */
        function (offset, behavior) {
            if (behavior === void 0) {
                behavior = 'auto';
            }
            /** @type {?} */
            var options = { behavior: behavior };
            if (this.orientation === 'horizontal') {
                options.start = offset;
            }
            else {
                options.top = offset;
            }
            this.scrollTo(options);
        };
    /**
     * Scrolls to the offset for the given index.
     * @param index The index of the element to scroll to.
     * @param behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
     */
    /**
     * Scrolls to the offset for the given index.
     * @param {?} index The index of the element to scroll to.
     * @param {?=} behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.scrollToIndex = /**
     * Scrolls to the offset for the given index.
     * @param {?} index The index of the element to scroll to.
     * @param {?=} behavior The ScrollBehavior to use when scrolling. Default is behavior is `auto`.
     * @return {?}
     */
        function (index, behavior) {
            if (behavior === void 0) {
                behavior = 'auto';
            }
            this._scrollStrategy.scrollToIndex(index, behavior);
        };
    /**
     * Gets the current scroll offset from the start of the viewport (in pixels).
     * @param from The edge to measure the offset from. Defaults to 'top' in vertical mode and 'start'
     *     in horizontal mode.
     */
    /**
     * Gets the current scroll offset from the start of the viewport (in pixels).
     * @param {?=} from The edge to measure the offset from. Defaults to 'top' in vertical mode and 'start'
     *     in horizontal mode.
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.measureScrollOffset = /**
     * Gets the current scroll offset from the start of the viewport (in pixels).
     * @param {?=} from The edge to measure the offset from. Defaults to 'top' in vertical mode and 'start'
     *     in horizontal mode.
     * @return {?}
     */
        function (from) {
            return _super.prototype.measureScrollOffset.call(this, from ? from : this.orientation === 'horizontal' ? 'start' : 'top');
        };
    /** Measure the combined size of all of the rendered items. */
    /**
     * Measure the combined size of all of the rendered items.
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.measureRenderedContentSize = /**
     * Measure the combined size of all of the rendered items.
     * @return {?}
     */
        function () {
            /** @type {?} */
            var contentEl = this._contentWrapper.nativeElement;
            return this.orientation === 'horizontal' ? contentEl.offsetWidth : contentEl.offsetHeight;
        };
    /**
     * Measure the total combined size of the given range. Throws if the range includes items that are
     * not rendered.
     */
    /**
     * Measure the total combined size of the given range. Throws if the range includes items that are
     * not rendered.
     * @param {?} range
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.measureRangeSize = /**
     * Measure the total combined size of the given range. Throws if the range includes items that are
     * not rendered.
     * @param {?} range
     * @return {?}
     */
        function (range) {
            if (!this._forOf) {
                return 0;
            }
            return this._forOf.measureRangeSize(range, this.orientation);
        };
    /** Update the viewport dimensions and re-render. */
    /**
     * Update the viewport dimensions and re-render.
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype.checkViewportSize = /**
     * Update the viewport dimensions and re-render.
     * @return {?}
     */
        function () {
            // TODO: Cleanup later when add logic for handling content resize
            this._measureViewportSize();
            this._scrollStrategy.onDataLengthChanged();
        };
    /** Measure the viewport size. */
    /**
     * Measure the viewport size.
     * @private
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype._measureViewportSize = /**
     * Measure the viewport size.
     * @private
     * @return {?}
     */
        function () {
            /** @type {?} */
            var viewportEl = this.elementRef.nativeElement;
            this._viewportSize = this.orientation === 'horizontal' ?
                viewportEl.clientWidth : viewportEl.clientHeight;
        };
    /** Queue up change detection to run. */
    /**
     * Queue up change detection to run.
     * @private
     * @param {?=} runAfter
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype._markChangeDetectionNeeded = /**
     * Queue up change detection to run.
     * @private
     * @param {?=} runAfter
     * @return {?}
     */
        function (runAfter) {
            var _this = this;
            if (runAfter) {
                this._runAfterChangeDetection.push(runAfter);
            }
            // Use a Promise to batch together calls to `_doChangeDetection`. This way if we set a bunch of
            // properties sequentially we only have to run `_doChangeDetection` once at the end.
            if (!this._isChangeDetectionPending) {
                this._isChangeDetectionPending = true;
                this.ngZone.runOutsideAngular(function () {
                    return Promise.resolve().then(function () {
                        _this._doChangeDetection();
                    });
                });
            }
        };
    /** Run change detection. */
    /**
     * Run change detection.
     * @private
     * @return {?}
     */
    CdkVirtualScrollViewport.prototype._doChangeDetection = /**
     * Run change detection.
     * @private
     * @return {?}
     */
        function () {
            var _this = this;
            this._isChangeDetectionPending = false;
            // Apply changes to Angular bindings. Note: We must call `markForCheck` to run change detection
            // from the root, since the repeated items are content projected in. Calling `detectChanges`
            // instead does not properly check the projected content.
            this.ngZone.run(function () { return _this._changeDetectorRef.markForCheck(); });
            // Apply the content transform. The transform can't be set via an Angular binding because
            // bypassSecurityTrustStyle is banned in Google. However the value is safe, it's composed of
            // string literals, a variable that can only be 'X' or 'Y', and user input that is run through
            // the `Number` function first to coerce it to a numeric value.
            this._contentWrapper.nativeElement.style.transform = this._renderedContentTransform;
            /** @type {?} */
            var runAfterChangeDetection = this._runAfterChangeDetection;
            this._runAfterChangeDetection = [];
            for (var _i = 0, runAfterChangeDetection_1 = runAfterChangeDetection; _i < runAfterChangeDetection_1.length; _i++) {
                var fn = runAfterChangeDetection_1[_i];
                fn();
            }
        };
    return CdkVirtualScrollViewport;
}(scrolling_es5_CdkScrollable));
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Helper to extract size from a DOM Node.
 * @param {?} orientation
 * @param {?} node
 * @return {?}
 */
function getSize(orientation, node) {
    /** @type {?} */
    var el = ((node));
    if (!el.getBoundingClientRect) {
        return 0;
    }
    /** @type {?} */
    var rect = el.getBoundingClientRect();
    return orientation == 'horizontal' ? rect.width : rect.height;
}
/**
 * A directive similar to `ngForOf` to be used for rendering data inside a virtual scrolling
 * container.
 * @template T
 */
var scrolling_es5_CdkVirtualForOf = /*@__PURE__*/ (function () {
    function CdkVirtualForOf(_viewContainerRef, _template, _differs, _viewport, ngZone) {
        var _this = this;
        this._viewContainerRef = _viewContainerRef;
        this._template = _template;
        this._differs = _differs;
        this._viewport = _viewport;
        /**
         * Emits when the rendered view of the data changes.
         */
        this.viewChange = new _esm5["e" /* Subject */]();
        /**
         * Subject that emits when a new DataSource instance is given.
         */
        this._dataSourceChanges = new _esm5["e" /* Subject */]();
        /**
         * The size of the cache used to store templates that are not being used for re-use later.
         * Setting the cache size to `0` will disable caching. Defaults to 20 templates.
         */
        this.cdkVirtualForTemplateCacheSize = 20;
        /**
         * Emits whenever the data in the current DataSource changes.
         */
        this.dataStream = this._dataSourceChanges
            .pipe(
        // Start off with null `DataSource`.
        Object(operators["startWith"])(((null))), 
        // Bundle up the previous and current data sources so we can work with both.
        Object(operators["pairwise"])(), 
        // Use `_changeDataSource` to disconnect from the previous data source and connect to the
        // new one, passing back a stream of data changes which we run through `switchMap` to give
        // us a data stream that emits the latest data from whatever the current `DataSource` is.
        Object(operators["switchMap"])(function (_a) {
            var prev = _a[0], cur = _a[1];
            return _this._changeDataSource(prev, cur);
        }), 
        // Replay the last emitted data when someone subscribes.
        Object(operators["shareReplay"])(1));
        /**
         * The differ used to calculate changes to the data.
         */
        this._differ = null;
        /**
         * The template cache used to hold on ot template instancess that have been stamped out, but don't
         * currently need to be rendered. These instances will be reused in the future rather than
         * stamping out brand new ones.
         */
        this._templateCache = [];
        /**
         * Whether the rendered data should be updated during the next ngDoCheck cycle.
         */
        this._needsUpdate = false;
        this._destroyed = new _esm5["e" /* Subject */]();
        this.dataStream.subscribe(function (data) {
            _this._data = data;
            _this._onRenderedDataChange();
        });
        this._viewport.renderedRangeStream.pipe(Object(operators["takeUntil"])(this._destroyed)).subscribe(function (range) {
            _this._renderedRange = range;
            ngZone.run(function () { return _this.viewChange.next(_this._renderedRange); });
            _this._onRenderedDataChange();
        });
        this._viewport.attach(this);
    }
    Object.defineProperty(CdkVirtualForOf.prototype, "cdkVirtualForOf", {
        /** The DataSource to display. */
        get: /**
         * The DataSource to display.
         * @return {?}
         */ function () {
            return this._cdkVirtualForOf;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) {
            this._cdkVirtualForOf = value;
            /** @type {?} */
            var ds = isDataSource(value) ? value :
                // Slice the value if its an NgIterable to ensure we're working with an array.
                new collections_es5_ArrayDataSource(value instanceof _esm5["d" /* Observable */] ? value : Array.prototype.slice.call(value || []));
            this._dataSourceChanges.next(ds);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkVirtualForOf.prototype, "cdkVirtualForTrackBy", {
        /**
         * The `TrackByFunction` to use for tracking changes. The `TrackByFunction` takes the index and
         * the item and produces a value to be used as the item's identity when tracking changes.
         */
        get: /**
         * The `TrackByFunction` to use for tracking changes. The `TrackByFunction` takes the index and
         * the item and produces a value to be used as the item's identity when tracking changes.
         * @return {?}
         */ function () {
            return this._cdkVirtualForTrackBy;
        },
        set: /**
         * @param {?} fn
         * @return {?}
         */ function (fn) {
            var _this = this;
            this._needsUpdate = true;
            this._cdkVirtualForTrackBy = fn ?
                function (index, item) { return fn(index + (_this._renderedRange ? _this._renderedRange.start : 0), item); } :
                undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CdkVirtualForOf.prototype, "cdkVirtualForTemplate", {
        /** The template used to stamp out new elements. */
        set: /**
         * The template used to stamp out new elements.
         * @param {?} value
         * @return {?}
         */ function (value) {
            if (value) {
                this._needsUpdate = true;
                this._template = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Measures the combined size (width for horizontal orientation, height for vertical) of all items
     * in the specified range. Throws an error if the range includes items that are not currently
     * rendered.
     */
    /**
     * Measures the combined size (width for horizontal orientation, height for vertical) of all items
     * in the specified range. Throws an error if the range includes items that are not currently
     * rendered.
     * @param {?} range
     * @param {?} orientation
     * @return {?}
     */
    CdkVirtualForOf.prototype.measureRangeSize = /**
     * Measures the combined size (width for horizontal orientation, height for vertical) of all items
     * in the specified range. Throws an error if the range includes items that are not currently
     * rendered.
     * @param {?} range
     * @param {?} orientation
     * @return {?}
     */
        function (range, orientation) {
            if (range.start >= range.end) {
                return 0;
            }
            if (range.start < this._renderedRange.start || range.end > this._renderedRange.end) {
                throw Error("Error: attempted to measure an item that isn't rendered.");
            }
            // The index into the list of rendered views for the first item in the range.
            /** @type {?} */
            var renderedStartIndex = range.start - this._renderedRange.start;
            // The length of the range we're measuring.
            /** @type {?} */
            var rangeLen = range.end - range.start;
            // Loop over all root nodes for all items in the range and sum up their size.
            /** @type {?} */
            var totalSize = 0;
            /** @type {?} */
            var i = rangeLen;
            while (i--) {
                /** @type {?} */
                var view = ((this._viewContainerRef.get(i + renderedStartIndex)));
                /** @type {?} */
                var j = view ? view.rootNodes.length : 0;
                while (j--) {
                    totalSize += getSize(orientation, ((view)).rootNodes[j]);
                }
            }
            return totalSize;
        };
    /**
     * @return {?}
     */
    CdkVirtualForOf.prototype.ngDoCheck = /**
     * @return {?}
     */
        function () {
            if (this._differ && this._needsUpdate) {
                // TODO(mmalerba): We should differentiate needs update due to scrolling and a new portion of
                // this list being rendered (can use simpler algorithm) vs needs update due to data actually
                // changing (need to do this diff).
                /** @type {?} */
                var changes = this._differ.diff(this._renderedItems);
                if (!changes) {
                    this._updateContext();
                }
                else {
                    this._applyChanges(changes);
                }
                this._needsUpdate = false;
            }
        };
    /**
     * @return {?}
     */
    CdkVirtualForOf.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this._viewport.detach();
            this._dataSourceChanges.complete();
            this.viewChange.complete();
            this._destroyed.next();
            this._destroyed.complete();
            for (var _i = 0, _a = this._templateCache; _i < _a.length; _i++) {
                var view = _a[_i];
                view.destroy();
            }
        };
    /** React to scroll state changes in the viewport. */
    /**
     * React to scroll state changes in the viewport.
     * @private
     * @return {?}
     */
    CdkVirtualForOf.prototype._onRenderedDataChange = /**
     * React to scroll state changes in the viewport.
     * @private
     * @return {?}
     */
        function () {
            if (!this._renderedRange) {
                return;
            }
            this._renderedItems = this._data.slice(this._renderedRange.start, this._renderedRange.end);
            if (!this._differ) {
                this._differ = this._differs.find(this._renderedItems).create(this.cdkVirtualForTrackBy);
            }
            this._needsUpdate = true;
        };
    /** Swap out one `DataSource` for another. */
    /**
     * Swap out one `DataSource` for another.
     * @private
     * @param {?} oldDs
     * @param {?} newDs
     * @return {?}
     */
    CdkVirtualForOf.prototype._changeDataSource = /**
     * Swap out one `DataSource` for another.
     * @private
     * @param {?} oldDs
     * @param {?} newDs
     * @return {?}
     */
        function (oldDs, newDs) {
            if (oldDs) {
                oldDs.disconnect(this);
            }
            this._needsUpdate = true;
            return newDs.connect(this);
        };
    /** Update the `CdkVirtualForOfContext` for all views. */
    /**
     * Update the `CdkVirtualForOfContext` for all views.
     * @private
     * @return {?}
     */
    CdkVirtualForOf.prototype._updateContext = /**
     * Update the `CdkVirtualForOfContext` for all views.
     * @private
     * @return {?}
     */
        function () {
            /** @type {?} */
            var count = this._data.length;
            /** @type {?} */
            var i = this._viewContainerRef.length;
            while (i--) {
                /** @type {?} */
                var view = ((this._viewContainerRef.get(i)));
                view.context.index = this._renderedRange.start + i;
                view.context.count = count;
                this._updateComputedContextProperties(view.context);
                view.detectChanges();
            }
        };
    /** Apply changes to the DOM. */
    /**
     * Apply changes to the DOM.
     * @private
     * @param {?} changes
     * @return {?}
     */
    CdkVirtualForOf.prototype._applyChanges = /**
     * Apply changes to the DOM.
     * @private
     * @param {?} changes
     * @return {?}
     */
        function (changes) {
            var _this = this;
            // Rearrange the views to put them in the right location.
            changes.forEachOperation(function (record, adjustedPreviousIndex, currentIndex) {
                if (record.previousIndex == null) {
                    // Item added.
                    /** @type {?} */
                    var view = _this._insertViewForNewItem(((currentIndex)));
                    view.context.$implicit = record.item;
                }
                else if (currentIndex == null) {
                    _this._cacheView(_this._detachView(((adjustedPreviousIndex))));
                }
                else {
                    // Item moved.
                    /** @type {?} */
                    var view = ((_this._viewContainerRef.get(((adjustedPreviousIndex)))));
                    _this._viewContainerRef.move(view, currentIndex);
                    view.context.$implicit = record.item;
                }
            });
            // Update $implicit for any items that had an identity change.
            changes.forEachIdentityChange(function (record) {
                /** @type {?} */
                var view = ((_this._viewContainerRef.get(((record.currentIndex)))));
                view.context.$implicit = record.item;
            });
            // Update the context variables on all items.
            /** @type {?} */
            var count = this._data.length;
            /** @type {?} */
            var i = this._viewContainerRef.length;
            while (i--) {
                /** @type {?} */
                var view = ((this._viewContainerRef.get(i)));
                view.context.index = this._renderedRange.start + i;
                view.context.count = count;
                this._updateComputedContextProperties(view.context);
            }
        };
    /** Cache the given detached view. */
    /**
     * Cache the given detached view.
     * @private
     * @param {?} view
     * @return {?}
     */
    CdkVirtualForOf.prototype._cacheView = /**
     * Cache the given detached view.
     * @private
     * @param {?} view
     * @return {?}
     */
        function (view) {
            if (this._templateCache.length < this.cdkVirtualForTemplateCacheSize) {
                this._templateCache.push(view);
            }
            else {
                /** @type {?} */
                var index = this._viewContainerRef.indexOf(view);
                // It's very unlikely that the index will ever be -1, but just in case,
                // destroy the view on its own, otherwise destroy it through the
                // container to ensure that all the references are removed.
                if (index === -1) {
                    view.destroy();
                }
                else {
                    this._viewContainerRef.remove(index);
                }
            }
        };
    /** Inserts a view for a new item, either from the cache or by creating a new one. */
    /**
     * Inserts a view for a new item, either from the cache or by creating a new one.
     * @private
     * @param {?} index
     * @return {?}
     */
    CdkVirtualForOf.prototype._insertViewForNewItem = /**
     * Inserts a view for a new item, either from the cache or by creating a new one.
     * @private
     * @param {?} index
     * @return {?}
     */
        function (index) {
            return this._insertViewFromCache(index) || this._createEmbeddedViewAt(index);
        };
    /** Update the computed properties on the `CdkVirtualForOfContext`. */
    /**
     * Update the computed properties on the `CdkVirtualForOfContext`.
     * @private
     * @param {?} context
     * @return {?}
     */
    CdkVirtualForOf.prototype._updateComputedContextProperties = /**
     * Update the computed properties on the `CdkVirtualForOfContext`.
     * @private
     * @param {?} context
     * @return {?}
     */
        function (context) {
            context.first = context.index === 0;
            context.last = context.index === context.count - 1;
            context.even = context.index % 2 === 0;
            context.odd = !context.even;
        };
    /** Creates a new embedded view and moves it to the given index */
    /**
     * Creates a new embedded view and moves it to the given index
     * @private
     * @param {?} index
     * @return {?}
     */
    CdkVirtualForOf.prototype._createEmbeddedViewAt = /**
     * Creates a new embedded view and moves it to the given index
     * @private
     * @param {?} index
     * @return {?}
     */
        function (index) {
            /** @type {?} */
            var view = this._viewContainerRef.createEmbeddedView(this._template, {
                $implicit: ((null)),
                cdkVirtualForOf: this._cdkVirtualForOf,
                index: -1,
                count: -1,
                first: false,
                last: false,
                odd: false,
                even: false
            });
            if (index < this._viewContainerRef.length) {
                this._viewContainerRef.move(view, index);
            }
            return view;
        };
    /** Inserts a recycled view from the cache at the given index. */
    /**
     * Inserts a recycled view from the cache at the given index.
     * @private
     * @param {?} index
     * @return {?}
     */
    CdkVirtualForOf.prototype._insertViewFromCache = /**
     * Inserts a recycled view from the cache at the given index.
     * @private
     * @param {?} index
     * @return {?}
     */
        function (index) {
            /** @type {?} */
            var cachedView = this._templateCache.pop();
            if (cachedView) {
                this._viewContainerRef.insert(cachedView, index);
            }
            return cachedView || null;
        };
    /** Detaches the embedded view at the given index. */
    /**
     * Detaches the embedded view at the given index.
     * @private
     * @param {?} index
     * @return {?}
     */
    CdkVirtualForOf.prototype._detachView = /**
     * Detaches the embedded view at the given index.
     * @private
     * @param {?} index
     * @return {?}
     */
        function (index) {
            return ((this._viewContainerRef.detach(index)));
        };
    return CdkVirtualForOf;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ScrollingModule = /*@__PURE__*/ (function () {
    function ScrollingModule() {
    }
    return ScrollingModule;
}());
/**
 * @deprecated ScrollDispatchModule has been renamed to ScrollingModule.
 * \@breaking-change 8.0.0 delete this alias
 */
var ScrollDispatchModule = /*@__PURE__*/ (function () {
    function ScrollDispatchModule() {
    }
    return ScrollDispatchModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Time in ms to throttle the resize events by default.
 * @type {?}
 */
var DEFAULT_RESIZE_TIME = 20;
/**
 * Simple utility for getting the bounds of the browser viewport.
 * \@docs-private
 */
var scrolling_es5_ViewportRuler = /*@__PURE__*/ (function () {
    function ViewportRuler(_platform, ngZone) {
        var _this = this;
        this._platform = _platform;
        ngZone.runOutsideAngular(function () {
            _this._change = _platform.isBrowser ?
                Object(_esm5["w" /* merge */])(Object(_esm5["r" /* fromEvent */])(window, 'resize'), Object(_esm5["r" /* fromEvent */])(window, 'orientationchange')) :
                Object(_esm5["x" /* of */])();
            // Note that we need to do the subscription inside `runOutsideAngular`
            // since subscribing is what causes the event listener to be added.
            _this._invalidateCache = _this.change().subscribe(function () { return _this._updateViewportSize(); });
        });
    }
    /**
     * @return {?}
     */
    ViewportRuler.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this._invalidateCache.unsubscribe();
        };
    /** Returns the viewport's width and height. */
    /**
     * Returns the viewport's width and height.
     * @return {?}
     */
    ViewportRuler.prototype.getViewportSize = /**
     * Returns the viewport's width and height.
     * @return {?}
     */
        function () {
            if (!this._viewportSize) {
                this._updateViewportSize();
            }
            /** @type {?} */
            var output = { width: this._viewportSize.width, height: this._viewportSize.height };
            // If we're not on a browser, don't cache the size since it'll be mocked out anyway.
            if (!this._platform.isBrowser) {
                this._viewportSize = ((null));
            }
            return output;
        };
    /** Gets a ClientRect for the viewport's bounds. */
    /**
     * Gets a ClientRect for the viewport's bounds.
     * @return {?}
     */
    ViewportRuler.prototype.getViewportRect = /**
     * Gets a ClientRect for the viewport's bounds.
     * @return {?}
     */
        function () {
            // Use the document element's bounding rect rather than the window scroll properties
            // (e.g. pageYOffset, scrollY) due to in issue in Chrome and IE where window scroll
            // properties and client coordinates (boundingClientRect, clientX/Y, etc.) are in different
            // conceptual viewports. Under most circumstances these viewports are equivalent, but they
            // can disagree when the page is pinch-zoomed (on devices that support touch).
            // See https://bugs.chromium.org/p/chromium/issues/detail?id=489206#c4
            // We use the documentElement instead of the body because, by default (without a css reset)
            // browsers typically give the document body an 8px margin, which is not included in
            // getBoundingClientRect().
            /** @type {?} */
            var scrollPosition = this.getViewportScrollPosition();
            var _a = this.getViewportSize(), width = _a.width, height = _a.height;
            return {
                top: scrollPosition.top,
                left: scrollPosition.left,
                bottom: scrollPosition.top + height,
                right: scrollPosition.left + width,
                height: height,
                width: width,
            };
        };
    /** Gets the (top, left) scroll position of the viewport. */
    /**
     * Gets the (top, left) scroll position of the viewport.
     * @return {?}
     */
    ViewportRuler.prototype.getViewportScrollPosition = /**
     * Gets the (top, left) scroll position of the viewport.
     * @return {?}
     */
        function () {
            // While we can get a reference to the fake document
            // during SSR, it doesn't have getBoundingClientRect.
            if (!this._platform.isBrowser) {
                return { top: 0, left: 0 };
            }
            // The top-left-corner of the viewport is determined by the scroll position of the document
            // body, normally just (scrollLeft, scrollTop). However, Chrome and Firefox disagree about
            // whether `document.body` or `document.documentElement` is the scrolled element, so reading
            // `scrollTop` and `scrollLeft` is inconsistent. However, using the bounding rect of
            // `document.documentElement` works consistently, where the `top` and `left` values will
            // equal negative the scroll position.
            /** @type {?} */
            var documentElement = ((document.documentElement));
            /** @type {?} */
            var documentRect = documentElement.getBoundingClientRect();
            /** @type {?} */
            var top = -documentRect.top || document.body.scrollTop || window.scrollY ||
                documentElement.scrollTop || 0;
            /** @type {?} */
            var left = -documentRect.left || document.body.scrollLeft || window.scrollX ||
                documentElement.scrollLeft || 0;
            return { top: top, left: left };
        };
    /**
     * Returns a stream that emits whenever the size of the viewport changes.
     * @param throttleTime Time in milliseconds to throttle the stream.
     */
    /**
     * Returns a stream that emits whenever the size of the viewport changes.
     * @param {?=} throttleTime Time in milliseconds to throttle the stream.
     * @return {?}
     */
    ViewportRuler.prototype.change = /**
     * Returns a stream that emits whenever the size of the viewport changes.
     * @param {?=} throttleTime Time in milliseconds to throttle the stream.
     * @return {?}
     */
        function (throttleTime) {
            if (throttleTime === void 0) {
                throttleTime = DEFAULT_RESIZE_TIME;
            }
            return throttleTime > 0 ? this._change.pipe(Object(operators["auditTime"])(throttleTime)) : this._change;
        };
    /** Updates the cached viewport size. */
    /**
     * Updates the cached viewport size.
     * @private
     * @return {?}
     */
    ViewportRuler.prototype._updateViewportSize = /**
     * Updates the cached viewport size.
     * @private
     * @return {?}
     */
        function () {
            this._viewportSize = this._platform.isBrowser ?
                { width: window.innerWidth, height: window.innerHeight } :
                { width: 0, height: 0 };
        };
    /** @nocollapse */ ViewportRuler.ngInjectableDef = Object(core["defineInjectable"])({ factory: function ViewportRuler_Factory() { return new ViewportRuler(Object(core["inject"])(platform_es5_Platform), Object(core["inject"])(core["NgZone"])); }, token: ViewportRuler, providedIn: "root" });
    return ViewportRuler;
}());
/**
 * \@docs-private \@deprecated \@breaking-change 8.0.0
 * @param {?} parentRuler
 * @param {?} platform
 * @param {?} ngZone
 * @return {?}
 */
function VIEWPORT_RULER_PROVIDER_FACTORY(parentRuler, platform, ngZone) {
    return parentRuler || new scrolling_es5_ViewportRuler(platform, ngZone);
}
/**
 * \@docs-private \@deprecated \@breaking-change 8.0.0
 * @type {?}
 */
var VIEWPORT_RULER_PROVIDER = {
    // If there is already a ViewportRuler available, use that. Otherwise, provide a new one.
    provide: scrolling_es5_ViewportRuler,
    deps: [[/*@__PURE__*/ new core["Optional"](), /*@__PURE__*/ new core["SkipSelf"](), scrolling_es5_ViewportRuler], platform_es5_Platform, core["NgZone"]],
    useFactory: VIEWPORT_RULER_PROVIDER_FACTORY
};
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */





// CONCATENATED MODULE: ./node_modules/@angular/cdk/esm5/drag-drop.es5.js
/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** PURE_IMPORTS_START _angular_cdk_platform,_angular_cdk_coercion,rxjs,_angular_core,_angular_common,_angular_cdk_scrolling,_angular_cdk_bidi,rxjs_operators PURE_IMPORTS_END */








/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Shallow-extends a stylesheet object with another stylesheet object.
 * \@docs-private
 * @param {?} dest
 * @param {?} source
 * @return {?}
 */
function extendStyles(dest, source) {
    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            dest[((key))] = source[((key))];
        }
    }
    return dest;
}
/**
 * Toggles whether the native drag interactions should be enabled for an element.
 * \@docs-private
 * @param {?} element Element on which to toggle the drag interactions.
 * @param {?} enable Whether the drag interactions should be enabled.
 * @return {?}
 */
function toggleNativeDragInteractions(element, enable) {
    /** @type {?} */
    var userSelect = enable ? '' : 'none';
    extendStyles(element.style, {
        touchAction: enable ? '' : 'none',
        webkitUserDrag: enable ? '' : 'none',
        webkitTapHighlightColor: enable ? '' : 'transparent',
        userSelect: userSelect,
        msUserSelect: userSelect,
        webkitUserSelect: userSelect,
        MozUserSelect: userSelect
    });
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Parses a CSS time value to milliseconds.
 * @param {?} value
 * @return {?}
 */
function parseCssTimeUnitsToMs(value) {
    // Some browsers will return it in seconds, whereas others will return milliseconds.
    /** @type {?} */
    var multiplier = value.toLowerCase().indexOf('ms') > -1 ? 1 : 1000;
    return parseFloat(value) * multiplier;
}
/**
 * Gets the transform transition duration, including the delay, of an element in milliseconds.
 * @param {?} element
 * @return {?}
 */
function getTransformTransitionDurationInMs(element) {
    /** @type {?} */
    var computedStyle = getComputedStyle(element);
    /** @type {?} */
    var transitionedProperties = parseCssPropertyValue(computedStyle, 'transition-property');
    /** @type {?} */
    var property = transitionedProperties.find(function (prop) { return prop === 'transform' || prop === 'all'; });
    // If there's no transition for `all` or `transform`, we shouldn't do anything.
    if (!property) {
        return 0;
    }
    // Get the index of the property that we're interested in and match
    // it up to the same index in `transition-delay` and `transition-duration`.
    /** @type {?} */
    var propertyIndex = transitionedProperties.indexOf(property);
    /** @type {?} */
    var rawDurations = parseCssPropertyValue(computedStyle, 'transition-duration');
    /** @type {?} */
    var rawDelays = parseCssPropertyValue(computedStyle, 'transition-delay');
    return parseCssTimeUnitsToMs(rawDurations[propertyIndex]) +
        parseCssTimeUnitsToMs(rawDelays[propertyIndex]);
}
/**
 * Parses out multiple values from a computed style into an array.
 * @param {?} computedStyle
 * @param {?} name
 * @return {?}
 */
function parseCssPropertyValue(computedStyle, name) {
    /** @type {?} */
    var value = computedStyle.getPropertyValue(name);
    return value.split(',').map(function (part) { return part.trim(); });
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Options that can be used to bind a passive event listener.
 * @type {?}
 */
var passiveEventListenerOptions = /*@__PURE__*/ normalizePassiveListenerOptions({ passive: true });
/**
 * Options that can be used to bind an active event listener.
 * @type {?}
 */
var activeEventListenerOptions = /*@__PURE__*/ normalizePassiveListenerOptions({ passive: false });
/**
 * Time in milliseconds for which to ignore mouse events, after
 * receiving a touch event. Used to avoid doing double work for
 * touch devices where the browser fires fake mouse events, in
 * addition to touch events.
 * @type {?}
 */
var MOUSE_EVENT_IGNORE_TIME = 800;
/**
 * Reference to a draggable item. Used to manipulate or dispose of the item.
 * \@docs-private
 * @template T
 */
var /**
 * Reference to a draggable item. Used to manipulate or dispose of the item.
 * \@docs-private
 * @template T
 */ drag_drop_es5_DragRef = /*@__PURE__*/ (function () {
    function DragRef(element, _config, _document, _ngZone, _viewportRuler, _dragDropRegistry) {
        var _this = this;
        this._config = _config;
        this._document = _document;
        this._ngZone = _ngZone;
        this._viewportRuler = _viewportRuler;
        this._dragDropRegistry = _dragDropRegistry;
        /**
         * CSS `transform` applied to the element when it isn't being dragged. We need a
         * passive transform in order for the dragged element to retain its new position
         * after the user has stopped dragging and because we need to know the relative
         * position in case they start dragging again. This corresponds to `element.style.transform`.
         */
        this._passiveTransform = { x: 0, y: 0 };
        /**
         * CSS `transform` that is applied to the element while it's being dragged.
         */
        this._activeTransform = { x: 0, y: 0 };
        /**
         * Emits when the item is being moved.
         */
        this._moveEvents = new _esm5["e" /* Subject */]();
        /**
         * Amount of subscriptions to the move event. Used to avoid
         * hitting the zone if the consumer didn't subscribe to it.
         */
        this._moveEventSubscriptions = 0;
        /**
         * Subscription to pointer movement events.
         */
        this._pointerMoveSubscription = _esm5["f" /* Subscription */].EMPTY;
        /**
         * Subscription to the event that is dispatched when the user lifts their pointer.
         */
        this._pointerUpSubscription = _esm5["f" /* Subscription */].EMPTY;
        /**
         * Cached reference to the boundary element.
         */
        this._boundaryElement = null;
        /**
         * Whether the native dragging interactions have been enabled on the root element.
         */
        this._nativeInteractionsEnabled = true;
        /**
         * Elements that can be used to drag the draggable item.
         */
        this._handles = [];
        /**
         * Registered handles that are currently disabled.
         */
        this._disabledHandles = new Set();
        /**
         * Layout direction of the item.
         */
        this._direction = 'ltr';
        this._disabled = false;
        /**
         * Emits as the drag sequence is being prepared.
         */
        this.beforeStarted = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user starts dragging the item.
         */
        this.started = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user has released a drag item, before any animations have started.
         */
        this.released = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user stops dragging an item in the container.
         */
        this.ended = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user has moved the item into a new container.
         */
        this.entered = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user removes the item its container by dragging it into another container.
         */
        this.exited = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user drops the item inside a container.
         */
        this.dropped = new _esm5["e" /* Subject */]();
        /**
         * Emits as the user is dragging the item. Use with caution,
         * because this event will fire for every pixel that the user has dragged.
         */
        this.moved = new _esm5["d" /* Observable */](function (observer) {
            /** @type {?} */
            var subscription = _this._moveEvents.subscribe(observer);
            _this._moveEventSubscriptions++;
            return function () {
                subscription.unsubscribe();
                _this._moveEventSubscriptions--;
            };
        });
        /**
         * Handler for the `mousedown`/`touchstart` events.
         */
        this._pointerDown = function (event) {
            _this.beforeStarted.next();
            // Delegate the event based on whether it started from a handle or the element itself.
            if (_this._handles.length) {
                /** @type {?} */
                var targetHandle = _this._handles.find(function (handle) {
                    /** @type {?} */
                    var target = event.target;
                    return !!target && (target === handle || handle.contains(((target))));
                });
                if (targetHandle && !_this._disabledHandles.has(targetHandle) && !_this.disabled) {
                    _this._initializeDragSequence(targetHandle, event);
                }
            }
            else if (!_this.disabled) {
                _this._initializeDragSequence(_this._rootElement, event);
            }
        };
        /**
         * Handler that is invoked when the user moves their pointer after they've initiated a drag.
         */
        this._pointerMove = function (event) {
            if (!_this._hasStartedDragging) {
                /** @type {?} */
                var pointerPosition = _this._getPointerPositionOnPage(event);
                /** @type {?} */
                var distanceX = Math.abs(pointerPosition.x - _this._pickupPositionOnPage.x);
                /** @type {?} */
                var distanceY = Math.abs(pointerPosition.y - _this._pickupPositionOnPage.y);
                // Only start dragging after the user has moved more than the minimum distance in either
                // direction. Note that this is preferrable over doing something like `skip(minimumDistance)`
                // in the `pointerMove` subscription, because we're not guaranteed to have one move event
                // per pixel of movement (e.g. if the user moves their pointer quickly).
                if (distanceX + distanceY >= _this._config.dragStartThreshold) {
                    _this._hasStartedDragging = true;
                    _this._ngZone.run(function () { return _this._startDragSequence(event); });
                }
                return;
            }
            // We only need the preview dimensions if we have a boundary element.
            if (_this._boundaryElement) {
                // Cache the preview element rect if we haven't cached it already or if
                // we cached it too early before the element dimensions were computed.
                if (!_this._previewRect || (!_this._previewRect.width && !_this._previewRect.height)) {
                    _this._previewRect = (_this._preview || _this._rootElement).getBoundingClientRect();
                }
            }
            /** @type {?} */
            var constrainedPointerPosition = _this._getConstrainedPointerPosition(event);
            _this._hasMoved = true;
            event.preventDefault();
            _this._updatePointerDirectionDelta(constrainedPointerPosition);
            if (_this._dropContainer) {
                _this._updateActiveDropContainer(constrainedPointerPosition);
            }
            else {
                /** @type {?} */
                var activeTransform = _this._activeTransform;
                activeTransform.x =
                    constrainedPointerPosition.x - _this._pickupPositionOnPage.x + _this._passiveTransform.x;
                activeTransform.y =
                    constrainedPointerPosition.y - _this._pickupPositionOnPage.y + _this._passiveTransform.y;
                /** @type {?} */
                var transform = getTransform(activeTransform.x, activeTransform.y);
                // Preserve the previous `transform` value, if there was one. Note that we apply our own
                // transform before the user's, because things like rotation can affect which direction
                // the element will be translated towards.
                _this._rootElement.style.transform = _this._initialTransform ?
                    transform + ' ' + _this._initialTransform : transform;
                // Apply transform as attribute if dragging and svg element to work for IE
                if (typeof SVGElement !== 'undefined' && _this._rootElement instanceof SVGElement) {
                    /** @type {?} */
                    var appliedTransform = "translate(" + activeTransform.x + " " + activeTransform.y + ")";
                    _this._rootElement.setAttribute('transform', appliedTransform);
                }
            }
            // Since this event gets fired for every pixel while dragging, we only
            // want to fire it if the consumer opted into it. Also we have to
            // re-enter the zone because we run all of the events on the outside.
            if (_this._moveEventSubscriptions > 0) {
                _this._ngZone.run(function () {
                    _this._moveEvents.next({
                        source: _this,
                        pointerPosition: constrainedPointerPosition,
                        event: event,
                        delta: _this._pointerDirectionDelta
                    });
                });
            }
        };
        /**
         * Handler that is invoked when the user lifts their pointer up, after initiating a drag.
         */
        this._pointerUp = function (event) {
            // Note that here we use `isDragging` from the service, rather than from `this`.
            // The difference is that the one from the service reflects whether a dragging sequence
            // has been initiated, whereas the one on `this` includes whether the user has passed
            // the minimum dragging threshold.
            if (!_this._dragDropRegistry.isDragging(_this)) {
                return;
            }
            _this._removeSubscriptions();
            _this._dragDropRegistry.stopDragging(_this);
            if (_this._handles) {
                _this._rootElement.style.webkitTapHighlightColor = _this._rootElementTapHighlight;
            }
            if (!_this._hasStartedDragging) {
                return;
            }
            _this.released.next({ source: _this });
            if (!_this._dropContainer) {
                // Convert the active transform into a passive one. This means that next time
                // the user starts dragging the item, its position will be calculated relatively
                // to the new passive transform.
                _this._passiveTransform.x = _this._activeTransform.x;
                _this._passiveTransform.y = _this._activeTransform.y;
                _this._ngZone.run(function () { return _this.ended.next({ source: _this }); });
                _this._dragDropRegistry.stopDragging(_this);
                return;
            }
            _this._animatePreviewToPlaceholder().then(function () {
                _this._cleanupDragArtifacts(event);
                _this._dragDropRegistry.stopDragging(_this);
            });
        };
        this.withRootElement(element);
        _dragDropRegistry.registerDragItem(this);
    }
    Object.defineProperty(DragRef.prototype, "disabled", {
        /** Whether starting to drag this element is disabled. */
        get: /**
         * Whether starting to drag this element is disabled.
         * @return {?}
         */ function () {
            return this._disabled || !!(this._dropContainer && this._dropContainer.disabled);
        },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) {
            /** @type {?} */
            var newValue = coerceBooleanProperty(value);
            if (newValue !== this._disabled) {
                this._disabled = newValue;
                this._toggleNativeDragInteractions();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the element that is being used as a placeholder
     * while the current element is being dragged.
     */
    /**
     * Returns the element that is being used as a placeholder
     * while the current element is being dragged.
     * @return {?}
     */
    DragRef.prototype.getPlaceholderElement = /**
     * Returns the element that is being used as a placeholder
     * while the current element is being dragged.
     * @return {?}
     */
        function () {
            return this._placeholder;
        };
    /** Returns the root draggable element. */
    /**
     * Returns the root draggable element.
     * @return {?}
     */
    DragRef.prototype.getRootElement = /**
     * Returns the root draggable element.
     * @return {?}
     */
        function () {
            return this._rootElement;
        };
    /** Registers the handles that can be used to drag the element. */
    /**
     * Registers the handles that can be used to drag the element.
     * @template THIS
     * @this {THIS}
     * @param {?} handles
     * @return {THIS}
     */
    DragRef.prototype.withHandles = /**
     * Registers the handles that can be used to drag the element.
     * @template THIS
     * @this {THIS}
     * @param {?} handles
     * @return {THIS}
     */
        function (handles) {
            ((this))._handles = handles.map(function (handle) { return coerceElement(handle); });
            ((this))._handles.forEach(function (handle) { return toggleNativeDragInteractions(handle, false); });
            ((this))._toggleNativeDragInteractions();
            return ((this));
        };
    /**
     * Registers the template that should be used for the drag preview.
     * @param template Template that from which to stamp out the preview.
     */
    /**
     * Registers the template that should be used for the drag preview.
     * @template THIS
     * @this {THIS}
     * @param {?} template Template that from which to stamp out the preview.
     * @return {THIS}
     */
    DragRef.prototype.withPreviewTemplate = /**
     * Registers the template that should be used for the drag preview.
     * @template THIS
     * @this {THIS}
     * @param {?} template Template that from which to stamp out the preview.
     * @return {THIS}
     */
        function (template) {
            ((this))._previewTemplate = template;
            return ((this));
        };
    /**
     * Registers the template that should be used for the drag placeholder.
     * @param template Template that from which to stamp out the placeholder.
     */
    /**
     * Registers the template that should be used for the drag placeholder.
     * @template THIS
     * @this {THIS}
     * @param {?} template Template that from which to stamp out the placeholder.
     * @return {THIS}
     */
    DragRef.prototype.withPlaceholderTemplate = /**
     * Registers the template that should be used for the drag placeholder.
     * @template THIS
     * @this {THIS}
     * @param {?} template Template that from which to stamp out the placeholder.
     * @return {THIS}
     */
        function (template) {
            ((this))._placeholderTemplate = template;
            return ((this));
        };
    /**
     * Sets an alternate drag root element. The root element is the element that will be moved as
     * the user is dragging. Passing an alternate root element is useful when trying to enable
     * dragging on an element that you might not have access to.
     */
    /**
     * Sets an alternate drag root element. The root element is the element that will be moved as
     * the user is dragging. Passing an alternate root element is useful when trying to enable
     * dragging on an element that you might not have access to.
     * @template THIS
     * @this {THIS}
     * @param {?} rootElement
     * @return {THIS}
     */
    DragRef.prototype.withRootElement = /**
     * Sets an alternate drag root element. The root element is the element that will be moved as
     * the user is dragging. Passing an alternate root element is useful when trying to enable
     * dragging on an element that you might not have access to.
     * @template THIS
     * @this {THIS}
     * @param {?} rootElement
     * @return {THIS}
     */
        function (rootElement) {
            /** @type {?} */
            var element = coerceElement(rootElement);
            if (element !== ((this))._rootElement) {
                if (((this))._rootElement) {
                    ((this))._removeRootElementListeners(((this))._rootElement);
                }
                element.addEventListener('mousedown', ((this))._pointerDown, activeEventListenerOptions);
                element.addEventListener('touchstart', ((this))._pointerDown, passiveEventListenerOptions);
                ((this))._initialTransform = undefined;
                ((this))._rootElement = element;
            }
            return ((this));
        };
    /**
     * Element to which the draggable's position will be constrained.
     */
    /**
     * Element to which the draggable's position will be constrained.
     * @template THIS
     * @this {THIS}
     * @param {?} boundaryElement
     * @return {THIS}
     */
    DragRef.prototype.withBoundaryElement = /**
     * Element to which the draggable's position will be constrained.
     * @template THIS
     * @this {THIS}
     * @param {?} boundaryElement
     * @return {THIS}
     */
        function (boundaryElement) {
            ((this))._boundaryElement = boundaryElement ? coerceElement(boundaryElement) : null;
            return ((this));
        };
    /** Removes the dragging functionality from the DOM element. */
    /**
     * Removes the dragging functionality from the DOM element.
     * @return {?}
     */
    DragRef.prototype.dispose = /**
     * Removes the dragging functionality from the DOM element.
     * @return {?}
     */
        function () {
            this._removeRootElementListeners(this._rootElement);
            // Do this check before removing from the registry since it'll
            // stop being considered as dragged once it is removed.
            if (this.isDragging()) {
                // Since we move out the element to the end of the body while it's being
                // dragged, we have to make sure that it's removed if it gets destroyed.
                drag_drop_es5_removeElement(this._rootElement);
            }
            this._destroyPreview();
            this._destroyPlaceholder();
            this._dragDropRegistry.removeDragItem(this);
            this._removeSubscriptions();
            this.beforeStarted.complete();
            this.started.complete();
            this.released.complete();
            this.ended.complete();
            this.entered.complete();
            this.exited.complete();
            this.dropped.complete();
            this._moveEvents.complete();
            this._handles = [];
            this._disabledHandles.clear();
            this._dropContainer = undefined;
            this._boundaryElement = this._rootElement = this._placeholderTemplate =
                this._previewTemplate = this._nextSibling = ((null));
        };
    /** Checks whether the element is currently being dragged. */
    /**
     * Checks whether the element is currently being dragged.
     * @return {?}
     */
    DragRef.prototype.isDragging = /**
     * Checks whether the element is currently being dragged.
     * @return {?}
     */
        function () {
            return this._hasStartedDragging && this._dragDropRegistry.isDragging(this);
        };
    /** Resets a standalone drag item to its initial position. */
    /**
     * Resets a standalone drag item to its initial position.
     * @return {?}
     */
    DragRef.prototype.reset = /**
     * Resets a standalone drag item to its initial position.
     * @return {?}
     */
        function () {
            this._rootElement.style.transform = this._initialTransform || '';
            this._activeTransform = { x: 0, y: 0 };
            this._passiveTransform = { x: 0, y: 0 };
        };
    /**
     * Sets a handle as disabled. While a handle is disabled, it'll capture and interrupt dragging.
     * @param handle Handle element that should be disabled.
     */
    /**
     * Sets a handle as disabled. While a handle is disabled, it'll capture and interrupt dragging.
     * @param {?} handle Handle element that should be disabled.
     * @return {?}
     */
    DragRef.prototype.disableHandle = /**
     * Sets a handle as disabled. While a handle is disabled, it'll capture and interrupt dragging.
     * @param {?} handle Handle element that should be disabled.
     * @return {?}
     */
        function (handle) {
            if (this._handles.indexOf(handle) > -1) {
                this._disabledHandles.add(handle);
            }
        };
    /**
     * Enables a handle, if it has been disabled.
     * @param handle Handle element to be enabled.
     */
    /**
     * Enables a handle, if it has been disabled.
     * @param {?} handle Handle element to be enabled.
     * @return {?}
     */
    DragRef.prototype.enableHandle = /**
     * Enables a handle, if it has been disabled.
     * @param {?} handle Handle element to be enabled.
     * @return {?}
     */
        function (handle) {
            this._disabledHandles.delete(handle);
        };
    /** Sets the layout direction of the draggable item. */
    /**
     * Sets the layout direction of the draggable item.
     * @template THIS
     * @this {THIS}
     * @param {?} direction
     * @return {THIS}
     */
    DragRef.prototype.withDirection = /**
     * Sets the layout direction of the draggable item.
     * @template THIS
     * @this {THIS}
     * @param {?} direction
     * @return {THIS}
     */
        function (direction) {
            ((this))._direction = direction;
            return ((this));
        };
    /** Sets the container that the item is part of. */
    /**
     * Sets the container that the item is part of.
     * @param {?} container
     * @return {?}
     */
    DragRef.prototype._withDropContainer = /**
     * Sets the container that the item is part of.
     * @param {?} container
     * @return {?}
     */
        function (container) {
            this._dropContainer = container;
        };
    /** Unsubscribes from the global subscriptions. */
    /**
     * Unsubscribes from the global subscriptions.
     * @private
     * @return {?}
     */
    DragRef.prototype._removeSubscriptions = /**
     * Unsubscribes from the global subscriptions.
     * @private
     * @return {?}
     */
        function () {
            this._pointerMoveSubscription.unsubscribe();
            this._pointerUpSubscription.unsubscribe();
        };
    /** Destroys the preview element and its ViewRef. */
    /**
     * Destroys the preview element and its ViewRef.
     * @private
     * @return {?}
     */
    DragRef.prototype._destroyPreview = /**
     * Destroys the preview element and its ViewRef.
     * @private
     * @return {?}
     */
        function () {
            if (this._preview) {
                drag_drop_es5_removeElement(this._preview);
            }
            if (this._previewRef) {
                this._previewRef.destroy();
            }
            this._preview = this._previewRef = ((null));
        };
    /** Destroys the placeholder element and its ViewRef. */
    /**
     * Destroys the placeholder element and its ViewRef.
     * @private
     * @return {?}
     */
    DragRef.prototype._destroyPlaceholder = /**
     * Destroys the placeholder element and its ViewRef.
     * @private
     * @return {?}
     */
        function () {
            if (this._placeholder) {
                drag_drop_es5_removeElement(this._placeholder);
            }
            if (this._placeholderRef) {
                this._placeholderRef.destroy();
            }
            this._placeholder = this._placeholderRef = ((null));
        };
    /** Starts the dragging sequence. */
    /**
     * Starts the dragging sequence.
     * @private
     * @param {?} event
     * @return {?}
     */
    DragRef.prototype._startDragSequence = /**
     * Starts the dragging sequence.
     * @private
     * @param {?} event
     * @return {?}
     */
        function (event) {
            // Emit the event on the item before the one on the container.
            this.started.next({ source: this });
            if (isTouchEvent(event)) {
                this._lastTouchEventTime = Date.now();
            }
            if (this._dropContainer) {
                /** @type {?} */
                var element = this._rootElement;
                // Grab the `nextSibling` before the preview and placeholder
                // have been created so we don't get the preview by accident.
                this._nextSibling = element.nextSibling;
                /** @type {?} */
                var preview = this._preview = this._createPreviewElement();
                /** @type {?} */
                var placeholder = this._placeholder = this._createPlaceholderElement();
                // We move the element out at the end of the body and we make it hidden, because keeping it in
                // place will throw off the consumer's `:last-child` selectors. We can't remove the element
                // from the DOM completely, because iOS will stop firing all subsequent events in the chain.
                element.style.display = 'none';
                this._document.body.appendChild(((element.parentNode)).replaceChild(placeholder, element));
                this._document.body.appendChild(preview);
                this._dropContainer.start();
            }
        };
    /**
     * Sets up the different variables and subscriptions
     * that will be necessary for the dragging sequence.
     * @param referenceElement Element that started the drag sequence.
     * @param event Browser event object that started the sequence.
     */
    /**
     * Sets up the different variables and subscriptions
     * that will be necessary for the dragging sequence.
     * @private
     * @param {?} referenceElement Element that started the drag sequence.
     * @param {?} event Browser event object that started the sequence.
     * @return {?}
     */
    DragRef.prototype._initializeDragSequence = /**
     * Sets up the different variables and subscriptions
     * that will be necessary for the dragging sequence.
     * @private
     * @param {?} referenceElement Element that started the drag sequence.
     * @param {?} event Browser event object that started the sequence.
     * @return {?}
     */
        function (referenceElement, event) {
            // Always stop propagation for the event that initializes
            // the dragging sequence, in order to prevent it from potentially
            // starting another sequence for a draggable parent somewhere up the DOM tree.
            event.stopPropagation();
            /** @type {?} */
            var isDragging = this.isDragging();
            /** @type {?} */
            var isTouchSequence = isTouchEvent(event);
            /** @type {?} */
            var isAuxiliaryMouseButton = !isTouchSequence && (((event))).button !== 0;
            /** @type {?} */
            var rootElement = this._rootElement;
            /** @type {?} */
            var isSyntheticEvent = !isTouchSequence && this._lastTouchEventTime &&
                this._lastTouchEventTime + MOUSE_EVENT_IGNORE_TIME > Date.now();
            // If the event started from an element with the native HTML drag&drop, it'll interfere
            // with our own dragging (e.g. `img` tags do it by default). Prevent the default action
            // to stop it from happening. Note that preventing on `dragstart` also seems to work, but
            // it's flaky and it fails if the user drags it away quickly. Also note that we only want
            // to do this for `mousedown` since doing the same for `touchstart` will stop any `click`
            // events from firing on touch devices.
            if (event.target && (((event.target))).draggable && event.type === 'mousedown') {
                event.preventDefault();
            }
            // Abort if the user is already dragging or is using a mouse button other than the primary one.
            if (isDragging || isAuxiliaryMouseButton || isSyntheticEvent) {
                return;
            }
            // Cache the previous transform amount only after the first drag sequence, because
            // we don't want our own transforms to stack on top of each other.
            if (this._initialTransform == null) {
                this._initialTransform = this._rootElement.style.transform || '';
            }
            // If we've got handles, we need to disable the tap highlight on the entire root element,
            // otherwise iOS will still add it, even though all the drag interactions on the handle
            // are disabled.
            if (this._handles.length) {
                this._rootElementTapHighlight = rootElement.style.webkitTapHighlightColor;
                rootElement.style.webkitTapHighlightColor = 'transparent';
            }
            this._toggleNativeDragInteractions();
            this._hasStartedDragging = this._hasMoved = false;
            this._initialContainer = ((this._dropContainer));
            this._pointerMoveSubscription = this._dragDropRegistry.pointerMove.subscribe(this._pointerMove);
            this._pointerUpSubscription = this._dragDropRegistry.pointerUp.subscribe(this._pointerUp);
            this._scrollPosition = this._viewportRuler.getViewportScrollPosition();
            if (this._boundaryElement) {
                this._boundaryRect = this._boundaryElement.getBoundingClientRect();
            }
            // If we have a custom preview template, the element won't be visible anyway so we avoid the
            // extra `getBoundingClientRect` calls and just move the preview next to the cursor.
            this._pickupPositionInElement = this._previewTemplate && this._previewTemplate.template ?
                { x: 0, y: 0 } :
                this._getPointerPositionInElement(referenceElement, event);
            /** @type {?} */
            var pointerPosition = this._pickupPositionOnPage = this._getPointerPositionOnPage(event);
            this._pointerDirectionDelta = { x: 0, y: 0 };
            this._pointerPositionAtLastDirectionChange = { x: pointerPosition.x, y: pointerPosition.y };
            this._dragDropRegistry.startDragging(this, event);
        };
    /** Cleans up the DOM artifacts that were added to facilitate the element being dragged. */
    /**
     * Cleans up the DOM artifacts that were added to facilitate the element being dragged.
     * @private
     * @param {?} event
     * @return {?}
     */
    DragRef.prototype._cleanupDragArtifacts = /**
     * Cleans up the DOM artifacts that were added to facilitate the element being dragged.
     * @private
     * @param {?} event
     * @return {?}
     */
        function (event) {
            var _this = this;
            // Restore the element's visibility and insert it at its old position in the DOM.
            // It's important that we maintain the position, because moving the element around in the DOM
            // can throw off `NgFor` which does smart diffing and re-creates elements only when necessary,
            // while moving the existing elements in all other cases.
            this._rootElement.style.display = '';
            if (this._nextSibling) {
                ((this._nextSibling.parentNode)).insertBefore(this._rootElement, this._nextSibling);
            }
            else {
                this._initialContainer.element.appendChild(this._rootElement);
            }
            this._destroyPreview();
            this._destroyPlaceholder();
            this._boundaryRect = this._previewRect = undefined;
            // Re-enter the NgZone since we bound `document` events on the outside.
            this._ngZone.run(function () {
                /** @type {?} */
                var container = ((_this._dropContainer));
                /** @type {?} */
                var currentIndex = container.getItemIndex(_this);
                var _a = _this._getPointerPositionOnPage(event), x = _a.x, y = _a.y;
                /** @type {?} */
                var isPointerOverContainer = container._isOverContainer(x, y);
                _this.ended.next({ source: _this });
                _this.dropped.next({
                    item: _this,
                    currentIndex: currentIndex,
                    previousIndex: _this._initialContainer.getItemIndex(_this),
                    container: container,
                    previousContainer: _this._initialContainer,
                    isPointerOverContainer: isPointerOverContainer
                });
                container.drop(_this, currentIndex, _this._initialContainer, isPointerOverContainer);
                _this._dropContainer = _this._initialContainer;
            });
        };
    /**
     * Updates the item's position in its drop container, or moves it
     * into a new one, depending on its current drag position.
     */
    /**
     * Updates the item's position in its drop container, or moves it
     * into a new one, depending on its current drag position.
     * @private
     * @param {?} __0
     * @return {?}
     */
    DragRef.prototype._updateActiveDropContainer = /**
     * Updates the item's position in its drop container, or moves it
     * into a new one, depending on its current drag position.
     * @private
     * @param {?} __0
     * @return {?}
     */
        function (_a) {
            var _this = this;
            var x = _a.x, y = _a.y;
            // Drop container that draggable has been moved into.
            /** @type {?} */
            var newContainer = ((this._dropContainer))._getSiblingContainerFromPosition(this, x, y) ||
                this._initialContainer._getSiblingContainerFromPosition(this, x, y);
            // If we couldn't find a new container to move the item into, and the item has left it's
            // initial container, check whether the it's over the initial container. This handles the
            // case where two containers are connected one way and the user tries to undo dragging an
            // item into a new container.
            if (!newContainer && this._dropContainer !== this._initialContainer &&
                this._initialContainer._isOverContainer(x, y)) {
                newContainer = this._initialContainer;
            }
            if (newContainer && newContainer !== this._dropContainer) {
                this._ngZone.run(function () {
                    // Notify the old container that the item has left.
                    _this.exited.next({ item: _this, container: ((_this._dropContainer)) });
                    ((_this._dropContainer)).exit(_this);
                    // Notify the new container that the item has entered.
                    _this.entered.next({ item: _this, container: ((newContainer)) });
                    _this._dropContainer = ((newContainer));
                    _this._dropContainer.enter(_this, x, y);
                });
            }
            ((this._dropContainer))._sortItem(this, x, y, this._pointerDirectionDelta);
            this._preview.style.transform =
                getTransform(x - this._pickupPositionInElement.x, y - this._pickupPositionInElement.y);
        };
    /**
     * Creates the element that will be rendered next to the user's pointer
     * and will be used as a preview of the element that is being dragged.
     */
    /**
     * Creates the element that will be rendered next to the user's pointer
     * and will be used as a preview of the element that is being dragged.
     * @private
     * @return {?}
     */
    DragRef.prototype._createPreviewElement = /**
     * Creates the element that will be rendered next to the user's pointer
     * and will be used as a preview of the element that is being dragged.
     * @private
     * @return {?}
     */
        function () {
            /** @type {?} */
            var previewConfig = this._previewTemplate;
            /** @type {?} */
            var previewTemplate = previewConfig ? previewConfig.template : null;
            /** @type {?} */
            var preview;
            if (previewTemplate) {
                /** @type {?} */
                var viewRef = ((previewConfig)).viewContainer.createEmbeddedView(previewTemplate, ((previewConfig)).context);
                preview = viewRef.rootNodes[0];
                this._previewRef = viewRef;
                preview.style.transform =
                    getTransform(this._pickupPositionOnPage.x, this._pickupPositionOnPage.y);
            }
            else {
                /** @type {?} */
                var element = this._rootElement;
                /** @type {?} */
                var elementRect = element.getBoundingClientRect();
                preview = deepCloneNode(element);
                preview.style.width = elementRect.width + "px";
                preview.style.height = elementRect.height + "px";
                preview.style.transform = getTransform(elementRect.left, elementRect.top);
            }
            extendStyles(preview.style, {
                // It's important that we disable the pointer events on the preview, because
                // it can throw off the `document.elementFromPoint` calls in the `CdkDropList`.
                pointerEvents: 'none',
                position: 'fixed',
                top: '0',
                left: '0',
                zIndex: '1000'
            });
            toggleNativeDragInteractions(preview, false);
            preview.classList.add('cdk-drag-preview');
            preview.setAttribute('dir', this._direction);
            return preview;
        };
    /**
     * Animates the preview element from its current position to the location of the drop placeholder.
     * @returns Promise that resolves when the animation completes.
     */
    /**
     * Animates the preview element from its current position to the location of the drop placeholder.
     * @private
     * @return {?} Promise that resolves when the animation completes.
     */
    DragRef.prototype._animatePreviewToPlaceholder = /**
     * Animates the preview element from its current position to the location of the drop placeholder.
     * @private
     * @return {?} Promise that resolves when the animation completes.
     */
        function () {
            var _this = this;
            // If the user hasn't moved yet, the transitionend event won't fire.
            if (!this._hasMoved) {
                return Promise.resolve();
            }
            /** @type {?} */
            var placeholderRect = this._placeholder.getBoundingClientRect();
            // Apply the class that adds a transition to the preview.
            this._preview.classList.add('cdk-drag-animating');
            // Move the preview to the placeholder position.
            this._preview.style.transform = getTransform(placeholderRect.left, placeholderRect.top);
            // If the element doesn't have a `transition`, the `transitionend` event won't fire. Since
            // we need to trigger a style recalculation in order for the `cdk-drag-animating` class to
            // apply its style, we take advantage of the available info to figure out whether we need to
            // bind the event in the first place.
            /** @type {?} */
            var duration = getTransformTransitionDurationInMs(this._preview);
            if (duration === 0) {
                return Promise.resolve();
            }
            return this._ngZone.runOutsideAngular(function () {
                return new Promise(function (resolve) {
                    /** @type {?} */
                    var handler = (((function (event) {
                        if (!event || (event.target === _this._preview && event.propertyName === 'transform')) {
                            _this._preview.removeEventListener('transitionend', handler);
                            resolve();
                            clearTimeout(timeout);
                        }
                    })));
                    // If a transition is short enough, the browser might not fire the `transitionend` event.
                    // Since we know how long it's supposed to take, add a timeout with a 50% buffer that'll
                    // fire if the transition hasn't completed when it was supposed to.
                    /** @type {?} */
                    var timeout = setTimeout(((handler)), duration * 1.5);
                    _this._preview.addEventListener('transitionend', handler);
                });
            });
        };
    /** Creates an element that will be shown instead of the current element while dragging. */
    /**
     * Creates an element that will be shown instead of the current element while dragging.
     * @private
     * @return {?}
     */
    DragRef.prototype._createPlaceholderElement = /**
     * Creates an element that will be shown instead of the current element while dragging.
     * @private
     * @return {?}
     */
        function () {
            /** @type {?} */
            var placeholderConfig = this._placeholderTemplate;
            /** @type {?} */
            var placeholderTemplate = placeholderConfig ? placeholderConfig.template : null;
            /** @type {?} */
            var placeholder;
            if (placeholderTemplate) {
                this._placeholderRef = ((placeholderConfig)).viewContainer.createEmbeddedView(placeholderTemplate, ((placeholderConfig)).context);
                placeholder = this._placeholderRef.rootNodes[0];
            }
            else {
                placeholder = deepCloneNode(this._rootElement);
            }
            placeholder.classList.add('cdk-drag-placeholder');
            return placeholder;
        };
    /**
     * Figures out the coordinates at which an element was picked up.
     * @param referenceElement Element that initiated the dragging.
     * @param event Event that initiated the dragging.
     */
    /**
     * Figures out the coordinates at which an element was picked up.
     * @private
     * @param {?} referenceElement Element that initiated the dragging.
     * @param {?} event Event that initiated the dragging.
     * @return {?}
     */
    DragRef.prototype._getPointerPositionInElement = /**
     * Figures out the coordinates at which an element was picked up.
     * @private
     * @param {?} referenceElement Element that initiated the dragging.
     * @param {?} event Event that initiated the dragging.
     * @return {?}
     */
        function (referenceElement, event) {
            /** @type {?} */
            var elementRect = this._rootElement.getBoundingClientRect();
            /** @type {?} */
            var handleElement = referenceElement === this._rootElement ? null : referenceElement;
            /** @type {?} */
            var referenceRect = handleElement ? handleElement.getBoundingClientRect() : elementRect;
            /** @type {?} */
            var point = isTouchEvent(event) ? event.targetTouches[0] : event;
            /** @type {?} */
            var x = point.pageX - referenceRect.left - this._scrollPosition.left;
            /** @type {?} */
            var y = point.pageY - referenceRect.top - this._scrollPosition.top;
            return {
                x: referenceRect.left - elementRect.left + x,
                y: referenceRect.top - elementRect.top + y
            };
        };
    /** Determines the point of the page that was touched by the user. */
    /**
     * Determines the point of the page that was touched by the user.
     * @private
     * @param {?} event
     * @return {?}
     */
    DragRef.prototype._getPointerPositionOnPage = /**
     * Determines the point of the page that was touched by the user.
     * @private
     * @param {?} event
     * @return {?}
     */
        function (event) {
            // `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
            /** @type {?} */
            var point = isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
            return {
                x: point.pageX - this._scrollPosition.left,
                y: point.pageY - this._scrollPosition.top
            };
        };
    /** Gets the pointer position on the page, accounting for any position constraints. */
    /**
     * Gets the pointer position on the page, accounting for any position constraints.
     * @private
     * @param {?} event
     * @return {?}
     */
    DragRef.prototype._getConstrainedPointerPosition = /**
     * Gets the pointer position on the page, accounting for any position constraints.
     * @private
     * @param {?} event
     * @return {?}
     */
        function (event) {
            /** @type {?} */
            var point = this._getPointerPositionOnPage(event);
            /** @type {?} */
            var dropContainerLock = this._dropContainer ? this._dropContainer.lockAxis : null;
            if (this.lockAxis === 'x' || dropContainerLock === 'x') {
                point.y = this._pickupPositionOnPage.y;
            }
            else if (this.lockAxis === 'y' || dropContainerLock === 'y') {
                point.x = this._pickupPositionOnPage.x;
            }
            if (this._boundaryRect) {
                var _a = this._pickupPositionInElement, pickupX = _a.x, pickupY = _a.y;
                /** @type {?} */
                var boundaryRect = this._boundaryRect;
                /** @type {?} */
                var previewRect = ((this._previewRect));
                /** @type {?} */
                var minY = boundaryRect.top + pickupY;
                /** @type {?} */
                var maxY = boundaryRect.bottom - (previewRect.height - pickupY);
                /** @type {?} */
                var minX = boundaryRect.left + pickupX;
                /** @type {?} */
                var maxX = boundaryRect.right - (previewRect.width - pickupX);
                point.x = clamp(point.x, minX, maxX);
                point.y = clamp(point.y, minY, maxY);
            }
            return point;
        };
    /** Updates the current drag delta, based on the user's current pointer position on the page. */
    /**
     * Updates the current drag delta, based on the user's current pointer position on the page.
     * @private
     * @param {?} pointerPositionOnPage
     * @return {?}
     */
    DragRef.prototype._updatePointerDirectionDelta = /**
     * Updates the current drag delta, based on the user's current pointer position on the page.
     * @private
     * @param {?} pointerPositionOnPage
     * @return {?}
     */
        function (pointerPositionOnPage) {
            var x = pointerPositionOnPage.x, y = pointerPositionOnPage.y;
            /** @type {?} */
            var delta = this._pointerDirectionDelta;
            /** @type {?} */
            var positionSinceLastChange = this._pointerPositionAtLastDirectionChange;
            // Amount of pixels the user has dragged since the last time the direction changed.
            /** @type {?} */
            var changeX = Math.abs(x - positionSinceLastChange.x);
            /** @type {?} */
            var changeY = Math.abs(y - positionSinceLastChange.y);
            // Because we handle pointer events on a per-pixel basis, we don't want the delta
            // to change for every pixel, otherwise anything that depends on it can look erratic.
            // To make the delta more consistent, we track how much the user has moved since the last
            // delta change and we only update it after it has reached a certain threshold.
            if (changeX > this._config.pointerDirectionChangeThreshold) {
                delta.x = x > positionSinceLastChange.x ? 1 : -1;
                positionSinceLastChange.x = x;
            }
            if (changeY > this._config.pointerDirectionChangeThreshold) {
                delta.y = y > positionSinceLastChange.y ? 1 : -1;
                positionSinceLastChange.y = y;
            }
            return delta;
        };
    /** Toggles the native drag interactions, based on how many handles are registered. */
    /**
     * Toggles the native drag interactions, based on how many handles are registered.
     * @private
     * @return {?}
     */
    DragRef.prototype._toggleNativeDragInteractions = /**
     * Toggles the native drag interactions, based on how many handles are registered.
     * @private
     * @return {?}
     */
        function () {
            if (!this._rootElement || !this._handles) {
                return;
            }
            /** @type {?} */
            var shouldEnable = this.disabled || this._handles.length > 0;
            if (shouldEnable !== this._nativeInteractionsEnabled) {
                this._nativeInteractionsEnabled = shouldEnable;
                toggleNativeDragInteractions(this._rootElement, shouldEnable);
            }
        };
    /** Removes the manually-added event listeners from the root element. */
    /**
     * Removes the manually-added event listeners from the root element.
     * @private
     * @param {?} element
     * @return {?}
     */
    DragRef.prototype._removeRootElementListeners = /**
     * Removes the manually-added event listeners from the root element.
     * @private
     * @param {?} element
     * @return {?}
     */
        function (element) {
            element.removeEventListener('mousedown', this._pointerDown, activeEventListenerOptions);
            element.removeEventListener('touchstart', this._pointerDown, passiveEventListenerOptions);
        };
    return DragRef;
}());
/**
 * Gets a 3d `transform` that can be applied to an element.
 * @param {?} x Desired position of the element along the X axis.
 * @param {?} y Desired position of the element along the Y axis.
 * @return {?}
 */
function getTransform(x, y) {
    // Round the transforms since some browsers will
    // blur the elements for sub-pixel transforms.
    return "translate3d(" + Math.round(x) + "px, " + Math.round(y) + "px, 0)";
}
/**
 * Creates a deep clone of an element.
 * @param {?} node
 * @return {?}
 */
function deepCloneNode(node) {
    /** @type {?} */
    var clone = ((node.cloneNode(true)));
    // Remove the `id` to avoid having multiple elements with the same id on the page.
    clone.removeAttribute('id');
    return clone;
}
/**
 * Clamps a value between a minimum and a maximum.
 * @param {?} value
 * @param {?} min
 * @param {?} max
 * @return {?}
 */
function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Helper to remove an element from the DOM and to do all the necessary null checks.
 * @param {?} element Element to be removed.
 * @return {?}
 */
function drag_drop_es5_removeElement(element) {
    if (element && element.parentNode) {
        element.parentNode.removeChild(element);
    }
}
/**
 * Determines whether an event is a touch event.
 * @param {?} event
 * @return {?}
 */
function isTouchEvent(event) {
    return event.type.startsWith('touch');
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Moves an item one index in an array to another.
 * @template T
 * @param {?} array Array in which to move the item.
 * @param {?} fromIndex Starting index of the item.
 * @param {?} toIndex Index to which the item should be moved.
 * @return {?}
 */
function moveItemInArray(array, fromIndex, toIndex) {
    /** @type {?} */
    var from = clamp$1(fromIndex, array.length - 1);
    /** @type {?} */
    var to = clamp$1(toIndex, array.length - 1);
    if (from === to) {
        return;
    }
    /** @type {?} */
    var target = array[from];
    /** @type {?} */
    var delta = to < from ? -1 : 1;
    for (var i = from; i !== to; i += delta) {
        array[i] = array[i + delta];
    }
    array[to] = target;
}
/**
 * Moves an item from one array to another.
 * @template T
 * @param {?} currentArray Array from which to transfer the item.
 * @param {?} targetArray Array into which to put the item.
 * @param {?} currentIndex Index of the item in its current array.
 * @param {?} targetIndex Index at which to insert the item.
 * @return {?}
 */
function transferArrayItem(currentArray, targetArray, currentIndex, targetIndex) {
    /** @type {?} */
    var from = clamp$1(currentIndex, currentArray.length - 1);
    /** @type {?} */
    var to = clamp$1(targetIndex, targetArray.length);
    if (currentArray.length) {
        targetArray.splice(to, 0, currentArray.splice(from, 1)[0]);
    }
}
/**
 * Copies an item from one array to another, leaving it in its
 * original position in current array.
 * @template T
 * @param {?} currentArray Array from which to copy the item.
 * @param {?} targetArray Array into which is copy the item.
 * @param {?} currentIndex Index of the item in its current array.
 * @param {?} targetIndex Index at which to insert the item.
 *
 * @return {?}
 */
function copyArrayItem(currentArray, targetArray, currentIndex, targetIndex) {
    /** @type {?} */
    var to = clamp$1(targetIndex, targetArray.length);
    if (currentArray.length) {
        targetArray.splice(to, 0, currentArray[currentIndex]);
    }
}
/**
 * Clamps a number between zero and a maximum.
 * @param {?} value
 * @param {?} max
 * @return {?}
 */
function clamp$1(value, max) {
    return Math.max(0, Math.min(max, value));
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Counter used to generate unique ids for drop refs.
 * @type {?}
 */
var _uniqueIdCounter = 0;
/**
 * Proximity, as a ratio to width/height, at which a
 * dragged item will affect the drop container.
 * @type {?}
 */
var DROP_PROXIMITY_THRESHOLD = 0.05;
/**
 * Reference to a drop list. Used to manipulate or dispose of the container.
 * \@docs-private
 * @template T
 */
var /**
 * Reference to a drop list. Used to manipulate or dispose of the container.
 * \@docs-private
 * @template T
 */ drag_drop_es5_DropListRef = /*@__PURE__*/ (function () {
    function DropListRef(element, _dragDropRegistry, _document) {
        this._dragDropRegistry = _dragDropRegistry;
        /**
         * Unique ID for the drop list.
         * @deprecated No longer being used. To be removed.
         * \@breaking-change 8.0.0
         */
        this.id = "cdk-drop-list-ref-" + _uniqueIdCounter++;
        /**
         * Whether starting a dragging sequence from this container is disabled.
         */
        this.disabled = false;
        /**
         * Function that is used to determine whether an item
         * is allowed to be moved into a drop container.
         */
        this.enterPredicate = function () { return true; };
        /**
         * Emits right before dragging has started.
         */
        this.beforeStarted = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user has moved a new drag item into this container.
         */
        this.entered = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user removes an item from the container
         * by dragging it into another container.
         */
        this.exited = new _esm5["e" /* Subject */]();
        /**
         * Emits when the user drops an item inside the container.
         */
        this.dropped = new _esm5["e" /* Subject */]();
        /**
         * Emits as the user is swapping items while actively dragging.
         */
        this.sorted = new _esm5["e" /* Subject */]();
        /**
         * Whether an item in the list is being dragged.
         */
        this._isDragging = false;
        /**
         * Cache of the dimensions of all the items inside the container.
         */
        this._itemPositions = [];
        /**
         * Keeps track of the item that was last swapped with the dragged item, as
         * well as what direction the pointer was moving in when the swap occured.
         */
        this._previousSwap = { drag: ((null)), delta: 0 };
        /**
         * Drop lists that are connected to the current one.
         */
        this._siblings = [];
        /**
         * Direction in which the list is oriented.
         */
        this._orientation = 'vertical';
        /**
         * Connected siblings that currently have a dragged item.
         */
        this._activeSiblings = new Set();
        /**
         * Layout direction of the drop list.
         */
        this._direction = 'ltr';
        _dragDropRegistry.registerDropContainer(this);
        this._document = _document;
        this.element = element instanceof core["ElementRef"] ? element.nativeElement : element;
    }
    /** Removes the drop list functionality from the DOM element. */
    /**
     * Removes the drop list functionality from the DOM element.
     * @return {?}
     */
    DropListRef.prototype.dispose = /**
     * Removes the drop list functionality from the DOM element.
     * @return {?}
     */
        function () {
            this.beforeStarted.complete();
            this.entered.complete();
            this.exited.complete();
            this.dropped.complete();
            this.sorted.complete();
            this._activeSiblings.clear();
            this._dragDropRegistry.removeDropContainer(this);
        };
    /** Whether an item from this list is currently being dragged. */
    /**
     * Whether an item from this list is currently being dragged.
     * @return {?}
     */
    DropListRef.prototype.isDragging = /**
     * Whether an item from this list is currently being dragged.
     * @return {?}
     */
        function () {
            return this._isDragging;
        };
    /** Starts dragging an item. */
    /**
     * Starts dragging an item.
     * @return {?}
     */
    DropListRef.prototype.start = /**
     * Starts dragging an item.
     * @return {?}
     */
        function () {
            var _this = this;
            this.beforeStarted.next();
            this._isDragging = true;
            this._activeDraggables = this._draggables.slice();
            this._cacheOwnPosition();
            this._cacheItemPositions();
            this._siblings.forEach(function (sibling) { return sibling._startReceiving(_this); });
        };
    /**
     * Emits an event to indicate that the user moved an item into the container.
     * @param item Item that was moved into the container.
     * @param pointerX Position of the item along the X axis.
     * @param pointerY Position of the item along the Y axis.
     */
    /**
     * Emits an event to indicate that the user moved an item into the container.
     * @param {?} item Item that was moved into the container.
     * @param {?} pointerX Position of the item along the X axis.
     * @param {?} pointerY Position of the item along the Y axis.
     * @return {?}
     */
    DropListRef.prototype.enter = /**
     * Emits an event to indicate that the user moved an item into the container.
     * @param {?} item Item that was moved into the container.
     * @param {?} pointerX Position of the item along the X axis.
     * @param {?} pointerY Position of the item along the Y axis.
     * @return {?}
     */
        function (item, pointerX, pointerY) {
            this.entered.next({ item: item, container: this });
            this.start();
            // We use the coordinates of where the item entered the drop
            // zone to figure out at which index it should be inserted.
            /** @type {?} */
            var newIndex = this._getItemIndexFromPointerPosition(item, pointerX, pointerY);
            /** @type {?} */
            var currentIndex = this._activeDraggables.indexOf(item);
            /** @type {?} */
            var newPositionReference = this._activeDraggables[newIndex];
            /** @type {?} */
            var placeholder = item.getPlaceholderElement();
            // Since the item may be in the `activeDraggables` already (e.g. if the user dragged it
            // into another container and back again), we have to ensure that it isn't duplicated.
            if (currentIndex > -1) {
                this._activeDraggables.splice(currentIndex, 1);
            }
            // Don't use items that are being dragged as a reference, because
            // their element has been moved down to the bottom of the body.
            if (newPositionReference && !this._dragDropRegistry.isDragging(newPositionReference)) {
                /** @type {?} */
                var element = newPositionReference.getRootElement();
                ((element.parentElement)).insertBefore(placeholder, element);
                this._activeDraggables.splice(newIndex, 0, item);
            }
            else {
                this.element.appendChild(placeholder);
                this._activeDraggables.push(item);
            }
            // The transform needs to be cleared so it doesn't throw off the measurements.
            placeholder.style.transform = '';
            // Note that the positions were already cached when we called `start` above,
            // but we need to refresh them since the amount of items has changed.
            this._cacheItemPositions();
        };
    /**
     * Removes an item from the container after it was dragged into another container by the user.
     * @param item Item that was dragged out.
     */
    /**
     * Removes an item from the container after it was dragged into another container by the user.
     * @param {?} item Item that was dragged out.
     * @return {?}
     */
    DropListRef.prototype.exit = /**
     * Removes an item from the container after it was dragged into another container by the user.
     * @param {?} item Item that was dragged out.
     * @return {?}
     */
        function (item) {
            this._reset();
            this.exited.next({ item: item, container: this });
        };
    /**
     * Drops an item into this container.
     * @param item Item being dropped into the container.
     * @param currentIndex Index at which the item should be inserted.
     * @param previousContainer Container from which the item got dragged in.
     * @param isPointerOverContainer Whether the user's pointer was over the
     *    container when the item was dropped.
     */
    /**
     * Drops an item into this container.
     * @param {?} item Item being dropped into the container.
     * @param {?} currentIndex Index at which the item should be inserted.
     * @param {?} previousContainer Container from which the item got dragged in.
     * @param {?} isPointerOverContainer Whether the user's pointer was over the
     *    container when the item was dropped.
     * @return {?}
     */
    DropListRef.prototype.drop = /**
     * Drops an item into this container.
     * @param {?} item Item being dropped into the container.
     * @param {?} currentIndex Index at which the item should be inserted.
     * @param {?} previousContainer Container from which the item got dragged in.
     * @param {?} isPointerOverContainer Whether the user's pointer was over the
     *    container when the item was dropped.
     * @return {?}
     */
        function (item, currentIndex, previousContainer, isPointerOverContainer) {
            this._reset();
            this.dropped.next({
                item: item,
                currentIndex: currentIndex,
                previousIndex: previousContainer.getItemIndex(item),
                container: this,
                previousContainer: previousContainer,
                isPointerOverContainer: isPointerOverContainer
            });
        };
    /**
     * Sets the draggable items that are a part of this list.
     * @param items Items that are a part of this list.
     */
    /**
     * Sets the draggable items that are a part of this list.
     * @template THIS
     * @this {THIS}
     * @param {?} items Items that are a part of this list.
     * @return {THIS}
     */
    DropListRef.prototype.withItems = /**
     * Sets the draggable items that are a part of this list.
     * @template THIS
     * @this {THIS}
     * @param {?} items Items that are a part of this list.
     * @return {THIS}
     */
        function (items) {
            var _this = this;
            ((this))._draggables = items;
            items.forEach(function (item) { return item._withDropContainer(((_this))); });
            return ((this));
        };
    /** Sets the layout direction of the drop list. */
    /**
     * Sets the layout direction of the drop list.
     * @template THIS
     * @this {THIS}
     * @param {?} direction
     * @return {THIS}
     */
    DropListRef.prototype.withDirection = /**
     * Sets the layout direction of the drop list.
     * @template THIS
     * @this {THIS}
     * @param {?} direction
     * @return {THIS}
     */
        function (direction) {
            ((this))._direction = direction;
            return ((this));
        };
    /**
     * Sets the containers that are connected to this one. When two or more containers are
     * connected, the user will be allowed to transfer items between them.
     * @param connectedTo Other containers that the current containers should be connected to.
     */
    /**
     * Sets the containers that are connected to this one. When two or more containers are
     * connected, the user will be allowed to transfer items between them.
     * @template THIS
     * @this {THIS}
     * @param {?} connectedTo Other containers that the current containers should be connected to.
     * @return {THIS}
     */
    DropListRef.prototype.connectedTo = /**
     * Sets the containers that are connected to this one. When two or more containers are
     * connected, the user will be allowed to transfer items between them.
     * @template THIS
     * @this {THIS}
     * @param {?} connectedTo Other containers that the current containers should be connected to.
     * @return {THIS}
     */
        function (connectedTo) {
            ((this))._siblings = connectedTo.slice();
            return ((this));
        };
    /**
     * Sets the orientation of the container.
     * @param orientation New orientation for the container.
     */
    /**
     * Sets the orientation of the container.
     * @template THIS
     * @this {THIS}
     * @param {?} orientation New orientation for the container.
     * @return {THIS}
     */
    DropListRef.prototype.withOrientation = /**
     * Sets the orientation of the container.
     * @template THIS
     * @this {THIS}
     * @param {?} orientation New orientation for the container.
     * @return {THIS}
     */
        function (orientation) {
            ((this))._orientation = orientation;
            return ((this));
        };
    /**
     * Figures out the index of an item in the container.
     * @param item Item whose index should be determined.
     */
    /**
     * Figures out the index of an item in the container.
     * @param {?} item Item whose index should be determined.
     * @return {?}
     */
    DropListRef.prototype.getItemIndex = /**
     * Figures out the index of an item in the container.
     * @param {?} item Item whose index should be determined.
     * @return {?}
     */
        function (item) {
            if (!this._isDragging) {
                return this._draggables.indexOf(item);
            }
            // Items are sorted always by top/left in the cache, however they flow differently in RTL.
            // The rest of the logic still stands no matter what orientation we're in, however
            // we need to invert the array when determining the index.
            /** @type {?} */
            var items = this._orientation === 'horizontal' && this._direction === 'rtl' ?
                this._itemPositions.slice().reverse() : this._itemPositions;
            return drag_drop_es5_findIndex(items, function (currentItem) { return currentItem.drag === item; });
        };
    /**
     * Whether the list is able to receive the item that
     * is currently being dragged inside a connected drop list.
     */
    /**
     * Whether the list is able to receive the item that
     * is currently being dragged inside a connected drop list.
     * @return {?}
     */
    DropListRef.prototype.isReceiving = /**
     * Whether the list is able to receive the item that
     * is currently being dragged inside a connected drop list.
     * @return {?}
     */
        function () {
            return this._activeSiblings.size > 0;
        };
    /**
     * Sorts an item inside the container based on its position.
     * @param item Item to be sorted.
     * @param pointerX Position of the item along the X axis.
     * @param pointerY Position of the item along the Y axis.
     * @param pointerDelta Direction in which the pointer is moving along each axis.
     */
    /**
     * Sorts an item inside the container based on its position.
     * @param {?} item Item to be sorted.
     * @param {?} pointerX Position of the item along the X axis.
     * @param {?} pointerY Position of the item along the Y axis.
     * @param {?} pointerDelta Direction in which the pointer is moving along each axis.
     * @return {?}
     */
    DropListRef.prototype._sortItem = /**
     * Sorts an item inside the container based on its position.
     * @param {?} item Item to be sorted.
     * @param {?} pointerX Position of the item along the X axis.
     * @param {?} pointerY Position of the item along the Y axis.
     * @param {?} pointerDelta Direction in which the pointer is moving along each axis.
     * @return {?}
     */
        function (item, pointerX, pointerY, pointerDelta) {
            // Don't sort the item if it's out of range.
            if (!this._isPointerNearDropContainer(pointerX, pointerY)) {
                return;
            }
            /** @type {?} */
            var siblings = this._itemPositions;
            /** @type {?} */
            var newIndex = this._getItemIndexFromPointerPosition(item, pointerX, pointerY, pointerDelta);
            if (newIndex === -1 && siblings.length > 0) {
                return;
            }
            /** @type {?} */
            var isHorizontal = this._orientation === 'horizontal';
            /** @type {?} */
            var currentIndex = drag_drop_es5_findIndex(siblings, function (currentItem) { return currentItem.drag === item; });
            /** @type {?} */
            var siblingAtNewPosition = siblings[newIndex];
            /** @type {?} */
            var currentPosition = siblings[currentIndex].clientRect;
            /** @type {?} */
            var newPosition = siblingAtNewPosition.clientRect;
            /** @type {?} */
            var delta = currentIndex > newIndex ? 1 : -1;
            this._previousSwap.drag = siblingAtNewPosition.drag;
            this._previousSwap.delta = isHorizontal ? pointerDelta.x : pointerDelta.y;
            // How many pixels the item's placeholder should be offset.
            /** @type {?} */
            var itemOffset = this._getItemOffsetPx(currentPosition, newPosition, delta);
            // How many pixels all the other items should be offset.
            /** @type {?} */
            var siblingOffset = this._getSiblingOffsetPx(currentIndex, siblings, delta);
            // Save the previous order of the items before moving the item to its new index.
            // We use this to check whether an item has been moved as a result of the sorting.
            /** @type {?} */
            var oldOrder = siblings.slice();
            // Shuffle the array in place.
            moveItemInArray(siblings, currentIndex, newIndex);
            this.sorted.next({
                previousIndex: currentIndex,
                currentIndex: newIndex,
                container: this,
                item: item
            });
            siblings.forEach(function (sibling, index) {
                // Don't do anything if the position hasn't changed.
                if (oldOrder[index] === sibling) {
                    return;
                }
                /** @type {?} */
                var isDraggedItem = sibling.drag === item;
                /** @type {?} */
                var offset = isDraggedItem ? itemOffset : siblingOffset;
                /** @type {?} */
                var elementToOffset = isDraggedItem ? item.getPlaceholderElement() :
                    sibling.drag.getRootElement();
                // Update the offset to reflect the new position.
                sibling.offset += offset;
                // Since we're moving the items with a `transform`, we need to adjust their cached
                // client rects to reflect their new position, as well as swap their positions in the cache.
                // Note that we shouldn't use `getBoundingClientRect` here to update the cache, because the
                // elements may be mid-animation which will give us a wrong result.
                if (isHorizontal) {
                    // Round the transforms since some browsers will
                    // blur the elements, for sub-pixel transforms.
                    elementToOffset.style.transform = "translate3d(" + Math.round(sibling.offset) + "px, 0, 0)";
                    adjustClientRect(sibling.clientRect, 0, offset);
                }
                else {
                    elementToOffset.style.transform = "translate3d(0, " + Math.round(sibling.offset) + "px, 0)";
                    adjustClientRect(sibling.clientRect, offset, 0);
                }
            });
        };
    /** Caches the position of the drop list. */
    /**
     * Caches the position of the drop list.
     * @private
     * @return {?}
     */
    DropListRef.prototype._cacheOwnPosition = /**
     * Caches the position of the drop list.
     * @private
     * @return {?}
     */
        function () {
            this._clientRect = this.element.getBoundingClientRect();
        };
    /** Refreshes the position cache of the items and sibling containers. */
    /**
     * Refreshes the position cache of the items and sibling containers.
     * @private
     * @return {?}
     */
    DropListRef.prototype._cacheItemPositions = /**
     * Refreshes the position cache of the items and sibling containers.
     * @private
     * @return {?}
     */
        function () {
            var _this = this;
            /** @type {?} */
            var isHorizontal = this._orientation === 'horizontal';
            this._itemPositions = this._activeDraggables.map(function (drag) {
                /** @type {?} */
                var elementToMeasure = _this._dragDropRegistry.isDragging(drag) ?
                    // If the element is being dragged, we have to measure the
                    // placeholder, because the element is hidden.
                    drag.getPlaceholderElement() :
                    drag.getRootElement();
                /** @type {?} */
                var clientRect = elementToMeasure.getBoundingClientRect();
                return {
                    drag: drag,
                    offset: 0,
                    // We need to clone the `clientRect` here, because all the values on it are readonly
                    // and we need to be able to update them. Also we can't use a spread here, because
                    // the values on a `ClientRect` aren't own properties. See:
                    // https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect#Notes
                    clientRect: {
                        top: clientRect.top,
                        right: clientRect.right,
                        bottom: clientRect.bottom,
                        left: clientRect.left,
                        width: clientRect.width,
                        height: clientRect.height
                    }
                };
            }).sort(function (a, b) {
                return isHorizontal ? a.clientRect.left - b.clientRect.left :
                    a.clientRect.top - b.clientRect.top;
            });
        };
    /** Resets the container to its initial state. */
    /**
     * Resets the container to its initial state.
     * @private
     * @return {?}
     */
    DropListRef.prototype._reset = /**
     * Resets the container to its initial state.
     * @private
     * @return {?}
     */
        function () {
            var _this = this;
            this._isDragging = false;
            // TODO(crisbeto): may have to wait for the animations to finish.
            this._activeDraggables.forEach(function (item) { return item.getRootElement().style.transform = ''; });
            this._siblings.forEach(function (sibling) { return sibling._stopReceiving(_this); });
            this._activeDraggables = [];
            this._itemPositions = [];
            this._previousSwap.drag = null;
            this._previousSwap.delta = 0;
        };
    /**
     * Gets the offset in pixels by which the items that aren't being dragged should be moved.
     * @param currentIndex Index of the item currently being dragged.
     * @param siblings All of the items in the list.
     * @param delta Direction in which the user is moving.
     */
    /**
     * Gets the offset in pixels by which the items that aren't being dragged should be moved.
     * @private
     * @param {?} currentIndex Index of the item currently being dragged.
     * @param {?} siblings All of the items in the list.
     * @param {?} delta Direction in which the user is moving.
     * @return {?}
     */
    DropListRef.prototype._getSiblingOffsetPx = /**
     * Gets the offset in pixels by which the items that aren't being dragged should be moved.
     * @private
     * @param {?} currentIndex Index of the item currently being dragged.
     * @param {?} siblings All of the items in the list.
     * @param {?} delta Direction in which the user is moving.
     * @return {?}
     */
        function (currentIndex, siblings, delta) {
            /** @type {?} */
            var isHorizontal = this._orientation === 'horizontal';
            /** @type {?} */
            var currentPosition = siblings[currentIndex].clientRect;
            /** @type {?} */
            var immediateSibling = siblings[currentIndex + delta * -1];
            /** @type {?} */
            var siblingOffset = currentPosition[isHorizontal ? 'width' : 'height'] * delta;
            if (immediateSibling) {
                /** @type {?} */
                var start = isHorizontal ? 'left' : 'top';
                /** @type {?} */
                var end = isHorizontal ? 'right' : 'bottom';
                // Get the spacing between the start of the current item and the end of the one immediately
                // after it in the direction in which the user is dragging, or vice versa. We add it to the
                // offset in order to push the element to where it will be when it's inline and is influenced
                // by the `margin` of its siblings.
                if (delta === -1) {
                    siblingOffset -= immediateSibling.clientRect[start] - currentPosition[end];
                }
                else {
                    siblingOffset += currentPosition[start] - immediateSibling.clientRect[end];
                }
            }
            return siblingOffset;
        };
    /**
     * Checks whether the pointer coordinates are close to the drop container.
     * @param pointerX Coordinates along the X axis.
     * @param pointerY Coordinates along the Y axis.
     */
    /**
     * Checks whether the pointer coordinates are close to the drop container.
     * @private
     * @param {?} pointerX Coordinates along the X axis.
     * @param {?} pointerY Coordinates along the Y axis.
     * @return {?}
     */
    DropListRef.prototype._isPointerNearDropContainer = /**
     * Checks whether the pointer coordinates are close to the drop container.
     * @private
     * @param {?} pointerX Coordinates along the X axis.
     * @param {?} pointerY Coordinates along the Y axis.
     * @return {?}
     */
        function (pointerX, pointerY) {
            var _a = this._clientRect, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
            /** @type {?} */
            var xThreshold = width * DROP_PROXIMITY_THRESHOLD;
            /** @type {?} */
            var yThreshold = height * DROP_PROXIMITY_THRESHOLD;
            return pointerY > top - yThreshold && pointerY < bottom + yThreshold &&
                pointerX > left - xThreshold && pointerX < right + xThreshold;
        };
    /**
     * Gets the offset in pixels by which the item that is being dragged should be moved.
     * @param currentPosition Current position of the item.
     * @param newPosition Position of the item where the current item should be moved.
     * @param delta Direction in which the user is moving.
     */
    /**
     * Gets the offset in pixels by which the item that is being dragged should be moved.
     * @private
     * @param {?} currentPosition Current position of the item.
     * @param {?} newPosition Position of the item where the current item should be moved.
     * @param {?} delta Direction in which the user is moving.
     * @return {?}
     */
    DropListRef.prototype._getItemOffsetPx = /**
     * Gets the offset in pixels by which the item that is being dragged should be moved.
     * @private
     * @param {?} currentPosition Current position of the item.
     * @param {?} newPosition Position of the item where the current item should be moved.
     * @param {?} delta Direction in which the user is moving.
     * @return {?}
     */
        function (currentPosition, newPosition, delta) {
            /** @type {?} */
            var isHorizontal = this._orientation === 'horizontal';
            /** @type {?} */
            var itemOffset = isHorizontal ? newPosition.left - currentPosition.left :
                newPosition.top - currentPosition.top;
            // Account for differences in the item width/height.
            if (delta === -1) {
                itemOffset += isHorizontal ? newPosition.width - currentPosition.width :
                    newPosition.height - currentPosition.height;
            }
            return itemOffset;
        };
    /**
     * Gets the index of an item in the drop container, based on the position of the user's pointer.
     * @param item Item that is being sorted.
     * @param pointerX Position of the user's pointer along the X axis.
     * @param pointerY Position of the user's pointer along the Y axis.
     * @param delta Direction in which the user is moving their pointer.
     */
    /**
     * Gets the index of an item in the drop container, based on the position of the user's pointer.
     * @private
     * @param {?} item Item that is being sorted.
     * @param {?} pointerX Position of the user's pointer along the X axis.
     * @param {?} pointerY Position of the user's pointer along the Y axis.
     * @param {?=} delta Direction in which the user is moving their pointer.
     * @return {?}
     */
    DropListRef.prototype._getItemIndexFromPointerPosition = /**
     * Gets the index of an item in the drop container, based on the position of the user's pointer.
     * @private
     * @param {?} item Item that is being sorted.
     * @param {?} pointerX Position of the user's pointer along the X axis.
     * @param {?} pointerY Position of the user's pointer along the Y axis.
     * @param {?=} delta Direction in which the user is moving their pointer.
     * @return {?}
     */
        function (item, pointerX, pointerY, delta) {
            var _this = this;
            /** @type {?} */
            var isHorizontal = this._orientation === 'horizontal';
            return drag_drop_es5_findIndex(this._itemPositions, function (_a, _, array) {
                var drag = _a.drag, clientRect = _a.clientRect;
                if (drag === item) {
                    // If there's only one item left in the container, it must be
                    // the dragged item itself so we use it as a reference.
                    return array.length < 2;
                }
                if (delta) {
                    /** @type {?} */
                    var direction = isHorizontal ? delta.x : delta.y;
                    // If the user is still hovering over the same item as last time, and they didn't change
                    // the direction in which they're dragging, we don't consider it a direction swap.
                    if (drag === _this._previousSwap.drag && direction === _this._previousSwap.delta) {
                        return false;
                    }
                }
                return isHorizontal ?
                    // Round these down since most browsers report client rects with
                    // sub-pixel precision, whereas the pointer coordinates are rounded to pixels.
                    pointerX >= Math.floor(clientRect.left) && pointerX <= Math.floor(clientRect.right) :
                    pointerY >= Math.floor(clientRect.top) && pointerY <= Math.floor(clientRect.bottom);
            });
        };
    /**
     * Checks whether the user's pointer is positioned over the container.
     * @param x Pointer position along the X axis.
     * @param y Pointer position along the Y axis.
     */
    /**
     * Checks whether the user's pointer is positioned over the container.
     * @param {?} x Pointer position along the X axis.
     * @param {?} y Pointer position along the Y axis.
     * @return {?}
     */
    DropListRef.prototype._isOverContainer = /**
     * Checks whether the user's pointer is positioned over the container.
     * @param {?} x Pointer position along the X axis.
     * @param {?} y Pointer position along the Y axis.
     * @return {?}
     */
        function (x, y) {
            return isInsideClientRect(this._clientRect, x, y);
        };
    /**
     * Figures out whether an item should be moved into a sibling
     * drop container, based on its current position.
     * @param item Drag item that is being moved.
     * @param x Position of the item along the X axis.
     * @param y Position of the item along the Y axis.
     */
    /**
     * Figures out whether an item should be moved into a sibling
     * drop container, based on its current position.
     * @param {?} item Drag item that is being moved.
     * @param {?} x Position of the item along the X axis.
     * @param {?} y Position of the item along the Y axis.
     * @return {?}
     */
    DropListRef.prototype._getSiblingContainerFromPosition = /**
     * Figures out whether an item should be moved into a sibling
     * drop container, based on its current position.
     * @param {?} item Drag item that is being moved.
     * @param {?} x Position of the item along the X axis.
     * @param {?} y Position of the item along the Y axis.
     * @return {?}
     */
        function (item, x, y) {
            return this._siblings.find(function (sibling) { return sibling._canReceive(item, x, y); });
        };
    /**
     * Checks whether the drop list can receive the passed-in item.
     * @param item Item that is being dragged into the list.
     * @param x Position of the item along the X axis.
     * @param y Position of the item along the Y axis.
     */
    /**
     * Checks whether the drop list can receive the passed-in item.
     * @param {?} item Item that is being dragged into the list.
     * @param {?} x Position of the item along the X axis.
     * @param {?} y Position of the item along the Y axis.
     * @return {?}
     */
    DropListRef.prototype._canReceive = /**
     * Checks whether the drop list can receive the passed-in item.
     * @param {?} item Item that is being dragged into the list.
     * @param {?} x Position of the item along the X axis.
     * @param {?} y Position of the item along the Y axis.
     * @return {?}
     */
        function (item, x, y) {
            if (!this.enterPredicate(item, this) || !isInsideClientRect(this._clientRect, x, y)) {
                return false;
            }
            /** @type {?} */
            var elementFromPoint = this._document.elementFromPoint(x, y);
            // If there's no element at the pointer position, then
            // the client rect is probably scrolled out of the view.
            if (!elementFromPoint) {
                return false;
            }
            // The `ClientRect`, that we're using to find the container over which the user is
            // hovering, doesn't give us any information on whether the element has been scrolled
            // out of the view or whether it's overlapping with other containers. This means that
            // we could end up transferring the item into a container that's invisible or is positioned
            // below another one. We use the result from `elementFromPoint` to get the top-most element
            // at the pointer position and to find whether it's one of the intersecting drop containers.
            return elementFromPoint === this.element || this.element.contains(elementFromPoint);
        };
    /**
     * Called by one of the connected drop lists when a dragging sequence has started.
     * @param sibling Sibling in which dragging has started.
     */
    /**
     * Called by one of the connected drop lists when a dragging sequence has started.
     * @param {?} sibling Sibling in which dragging has started.
     * @return {?}
     */
    DropListRef.prototype._startReceiving = /**
     * Called by one of the connected drop lists when a dragging sequence has started.
     * @param {?} sibling Sibling in which dragging has started.
     * @return {?}
     */
        function (sibling) {
            /** @type {?} */
            var activeSiblings = this._activeSiblings;
            if (!activeSiblings.has(sibling)) {
                activeSiblings.add(sibling);
                this._cacheOwnPosition();
            }
        };
    /**
     * Called by a connected drop list when dragging has stopped.
     * @param sibling Sibling whose dragging has stopped.
     */
    /**
     * Called by a connected drop list when dragging has stopped.
     * @param {?} sibling Sibling whose dragging has stopped.
     * @return {?}
     */
    DropListRef.prototype._stopReceiving = /**
     * Called by a connected drop list when dragging has stopped.
     * @param {?} sibling Sibling whose dragging has stopped.
     * @return {?}
     */
        function (sibling) {
            this._activeSiblings.delete(sibling);
        };
    return DropListRef;
}());
/**
 * Updates the top/left positions of a `ClientRect`, as well as their bottom/right counterparts.
 * @param {?} clientRect `ClientRect` that should be updated.
 * @param {?} top Amount to add to the `top` position.
 * @param {?} left Amount to add to the `left` position.
 * @return {?}
 */
function adjustClientRect(clientRect, top, left) {
    clientRect.top += top;
    clientRect.bottom = clientRect.top + clientRect.height;
    clientRect.left += left;
    clientRect.right = clientRect.left + clientRect.width;
}
/**
 * Finds the index of an item that matches a predicate function. Used as an equivalent
 * of `Array.prototype.find` which isn't part of the standard Google typings.
 * @template T
 * @param {?} array Array in which to look for matches.
 * @param {?} predicate Function used to determine whether an item is a match.
 * @return {?}
 */
function drag_drop_es5_findIndex(array, predicate) {
    for (var i = 0; i < array.length; i++) {
        if (predicate(array[i], i, array)) {
            return i;
        }
    }
    return -1;
}
/**
 * Checks whether some coordinates are within a `ClientRect`.
 * @param {?} clientRect ClientRect that is being checked.
 * @param {?} x Coordinates along the X axis.
 * @param {?} y Coordinates along the Y axis.
 * @return {?}
 */
function isInsideClientRect(clientRect, x, y) {
    var top = clientRect.top, bottom = clientRect.bottom, left = clientRect.left, right = clientRect.right;
    return y >= top && y <= bottom && x >= left && x <= right;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Event options that can be used to bind an active, capturing event.
 * @type {?}
 */
var activeCapturingEventOptions = /*@__PURE__*/ normalizePassiveListenerOptions({
    passive: false,
    capture: true
});
/**
 * Service that keeps track of all the drag item and drop container
 * instances, and manages global event listeners on the `document`.
 * \@docs-private
 * @template I, C
 */
// Note: this class is generic, rather than referencing CdkDrag and CdkDropList directly, in order
// to avoid circular imports. If we were to reference them here, importing the registry into the
// classes that are registering themselves will introduce a circular import.
var drag_drop_es5_DragDropRegistry = /*@__PURE__*/ (function () {
    function DragDropRegistry(_ngZone, _document) {
        var _this = this;
        this._ngZone = _ngZone;
        /**
         * Registered drop container instances.
         */
        this._dropInstances = new Set();
        /**
         * Registered drag item instances.
         */
        this._dragInstances = new Set();
        /**
         * Drag item instances that are currently being dragged.
         */
        this._activeDragInstances = new Set();
        /**
         * Keeps track of the event listeners that we've bound to the `document`.
         */
        this._globalListeners = new Map();
        /**
         * Emits the `touchmove` or `mousemove` events that are dispatched
         * while the user is dragging a drag item instance.
         */
        this.pointerMove = new _esm5["e" /* Subject */]();
        /**
         * Emits the `touchend` or `mouseup` events that are dispatched
         * while the user is dragging a drag item instance.
         */
        this.pointerUp = new _esm5["e" /* Subject */]();
        /**
         * Event listener that will prevent the default browser action while the user is dragging.
         * @param event Event whose default action should be prevented.
         */
        this._preventDefaultWhileDragging = function (event) {
            if (_this._activeDragInstances.size) {
                event.preventDefault();
            }
        };
        this._document = _document;
    }
    /** Adds a drop container to the registry. */
    /**
     * Adds a drop container to the registry.
     * @param {?} drop
     * @return {?}
     */
    DragDropRegistry.prototype.registerDropContainer = /**
     * Adds a drop container to the registry.
     * @param {?} drop
     * @return {?}
     */
        function (drop) {
            if (!this._dropInstances.has(drop)) {
                if (this.getDropContainer(drop.id)) {
                    throw Error("Drop instance with id \"" + drop.id + "\" has already been registered.");
                }
                this._dropInstances.add(drop);
            }
        };
    /** Adds a drag item instance to the registry. */
    /**
     * Adds a drag item instance to the registry.
     * @param {?} drag
     * @return {?}
     */
    DragDropRegistry.prototype.registerDragItem = /**
     * Adds a drag item instance to the registry.
     * @param {?} drag
     * @return {?}
     */
        function (drag) {
            var _this = this;
            this._dragInstances.add(drag);
            // The `touchmove` event gets bound once, ahead of time, because WebKit
            // won't preventDefault on a dynamically-added `touchmove` listener.
            // See https://bugs.webkit.org/show_bug.cgi?id=184250.
            if (this._dragInstances.size === 1) {
                this._ngZone.runOutsideAngular(function () {
                    // The event handler has to be explicitly active,
                    // because newer browsers make it passive by default.
                    _this._document.addEventListener('touchmove', _this._preventDefaultWhileDragging, activeCapturingEventOptions);
                });
            }
        };
    /** Removes a drop container from the registry. */
    /**
     * Removes a drop container from the registry.
     * @param {?} drop
     * @return {?}
     */
    DragDropRegistry.prototype.removeDropContainer = /**
     * Removes a drop container from the registry.
     * @param {?} drop
     * @return {?}
     */
        function (drop) {
            this._dropInstances.delete(drop);
        };
    /** Removes a drag item instance from the registry. */
    /**
     * Removes a drag item instance from the registry.
     * @param {?} drag
     * @return {?}
     */
    DragDropRegistry.prototype.removeDragItem = /**
     * Removes a drag item instance from the registry.
     * @param {?} drag
     * @return {?}
     */
        function (drag) {
            this._dragInstances.delete(drag);
            this.stopDragging(drag);
            if (this._dragInstances.size === 0) {
                this._document.removeEventListener('touchmove', this._preventDefaultWhileDragging, activeCapturingEventOptions);
            }
        };
    /**
     * Starts the dragging sequence for a drag instance.
     * @param drag Drag instance which is being dragged.
     * @param event Event that initiated the dragging.
     */
    /**
     * Starts the dragging sequence for a drag instance.
     * @param {?} drag Drag instance which is being dragged.
     * @param {?} event Event that initiated the dragging.
     * @return {?}
     */
    DragDropRegistry.prototype.startDragging = /**
     * Starts the dragging sequence for a drag instance.
     * @param {?} drag Drag instance which is being dragged.
     * @param {?} event Event that initiated the dragging.
     * @return {?}
     */
        function (drag, event) {
            var _this = this;
            this._activeDragInstances.add(drag);
            if (this._activeDragInstances.size === 1) {
                /** @type {?} */
                var isTouchEvent = event.type.startsWith('touch');
                /** @type {?} */
                var moveEvent = isTouchEvent ? 'touchmove' : 'mousemove';
                /** @type {?} */
                var upEvent = isTouchEvent ? 'touchend' : 'mouseup';
                // We explicitly bind __active__ listeners here, because newer browsers will default to
                // passive ones for `mousemove` and `touchmove`. The events need to be active, because we
                // use `preventDefault` to prevent the page from scrolling while the user is dragging.
                this._globalListeners
                    .set(moveEvent, {
                    handler: function (e) { return _this.pointerMove.next(((e))); },
                    options: activeCapturingEventOptions
                })
                    .set(upEvent, {
                    handler: function (e) { return _this.pointerUp.next(((e))); },
                    options: true
                })
                    .set('selectstart', {
                    handler: this._preventDefaultWhileDragging,
                    options: activeCapturingEventOptions
                });
                // TODO(crisbeto): prevent mouse wheel scrolling while
                // dragging until we've set up proper scroll handling.
                if (!isTouchEvent) {
                    this._globalListeners.set('wheel', {
                        handler: this._preventDefaultWhileDragging,
                        options: activeCapturingEventOptions
                    });
                }
                this._ngZone.runOutsideAngular(function () {
                    _this._globalListeners.forEach(function (config, name) {
                        _this._document.addEventListener(name, config.handler, config.options);
                    });
                });
            }
        };
    /** Stops dragging a drag item instance. */
    /**
     * Stops dragging a drag item instance.
     * @param {?} drag
     * @return {?}
     */
    DragDropRegistry.prototype.stopDragging = /**
     * Stops dragging a drag item instance.
     * @param {?} drag
     * @return {?}
     */
        function (drag) {
            this._activeDragInstances.delete(drag);
            if (this._activeDragInstances.size === 0) {
                this._clearGlobalListeners();
            }
        };
    /** Gets whether a drag item instance is currently being dragged. */
    /**
     * Gets whether a drag item instance is currently being dragged.
     * @param {?} drag
     * @return {?}
     */
    DragDropRegistry.prototype.isDragging = /**
     * Gets whether a drag item instance is currently being dragged.
     * @param {?} drag
     * @return {?}
     */
        function (drag) {
            return this._activeDragInstances.has(drag);
        };
    /**
     * Gets a drop container by its id.
     * @deprecated No longer being used. To be removed.
     * @breaking-change 8.0.0
     */
    /**
     * Gets a drop container by its id.
     * @deprecated No longer being used. To be removed.
     * \@breaking-change 8.0.0
     * @param {?} id
     * @return {?}
     */
    DragDropRegistry.prototype.getDropContainer = /**
     * Gets a drop container by its id.
     * @deprecated No longer being used. To be removed.
     * \@breaking-change 8.0.0
     * @param {?} id
     * @return {?}
     */
        function (id) {
            return Array.from(this._dropInstances).find(function (instance) { return instance.id === id; });
        };
    /**
     * @return {?}
     */
    DragDropRegistry.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            var _this = this;
            this._dragInstances.forEach(function (instance) { return _this.removeDragItem(instance); });
            this._dropInstances.forEach(function (instance) { return _this.removeDropContainer(instance); });
            this._clearGlobalListeners();
            this.pointerMove.complete();
            this.pointerUp.complete();
        };
    /** Clears out the global event listeners from the `document`. */
    /**
     * Clears out the global event listeners from the `document`.
     * @private
     * @return {?}
     */
    DragDropRegistry.prototype._clearGlobalListeners = /**
     * Clears out the global event listeners from the `document`.
     * @private
     * @return {?}
     */
        function () {
            var _this = this;
            this._globalListeners.forEach(function (config, name) {
                _this._document.removeEventListener(name, config.handler, config.options);
            });
            this._globalListeners.clear();
        };
    /** @nocollapse */ DragDropRegistry.ngInjectableDef = Object(core["defineInjectable"])({ factory: function DragDropRegistry_Factory() { return new DragDropRegistry(Object(core["inject"])(core["NgZone"]), Object(core["inject"])(common["DOCUMENT"])); }, token: DragDropRegistry, providedIn: "root" });
    return DragDropRegistry;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Default configuration to be used when creating a `DragRef`.
 * @type {?}
 */
var DEFAULT_CONFIG = {
    dragStartThreshold: 5,
    pointerDirectionChangeThreshold: 5
};
/**
 * Service that allows for drag-and-drop functionality to be attached to DOM elements.
 */
var drag_drop_es5_DragDrop = /*@__PURE__*/ (function () {
    function DragDrop(_document, _ngZone, _viewportRuler, _dragDropRegistry) {
        this._document = _document;
        this._ngZone = _ngZone;
        this._viewportRuler = _viewportRuler;
        this._dragDropRegistry = _dragDropRegistry;
    }
    /**
     * Turns an element into a draggable item.
     * @param element Element to which to attach the dragging functionality.
     * @param config Object used to configure the dragging behavior.
     */
    /**
     * Turns an element into a draggable item.
     * @template T
     * @param {?} element Element to which to attach the dragging functionality.
     * @param {?=} config Object used to configure the dragging behavior.
     * @return {?}
     */
    DragDrop.prototype.createDrag = /**
     * Turns an element into a draggable item.
     * @template T
     * @param {?} element Element to which to attach the dragging functionality.
     * @param {?=} config Object used to configure the dragging behavior.
     * @return {?}
     */
        function (element, config) {
            if (config === void 0) {
                config = DEFAULT_CONFIG;
            }
            return new drag_drop_es5_DragRef(element, config, this._document, this._ngZone, this._viewportRuler, this._dragDropRegistry);
        };
    /**
     * Turns an element into a drop list.
     * @param element Element to which to attach the drop list functionality.
     */
    /**
     * Turns an element into a drop list.
     * @template T
     * @param {?} element Element to which to attach the drop list functionality.
     * @return {?}
     */
    DragDrop.prototype.createDropList = /**
     * Turns an element into a drop list.
     * @template T
     * @param {?} element Element to which to attach the drop list functionality.
     * @return {?}
     */
        function (element) {
            return new drag_drop_es5_DropListRef(element, this._dragDropRegistry, this._document);
        };
    /** @nocollapse */ DragDrop.ngInjectableDef = Object(core["defineInjectable"])({ factory: function DragDrop_Factory() { return new DragDrop(Object(core["inject"])(common["DOCUMENT"]), Object(core["inject"])(core["NgZone"]), Object(core["inject"])(scrolling_es5_ViewportRuler), Object(core["inject"])(drag_drop_es5_DragDropRegistry)); }, token: DragDrop, providedIn: "root" });
    return DragDrop;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Injection token that is used to provide a CdkDropList instance to CdkDrag.
 * Used for avoiding circular imports.
 * @type {?}
 */
var CDK_DROP_LIST = /*@__PURE__*/ new core["InjectionToken"]('CDK_DROP_LIST');
/**
 * Injection token that is used to provide a CdkDropList instance to CdkDrag.
 * Used for avoiding circular imports.
 * @deprecated Use `CDK_DROP_LIST` instead.
 * \@breaking-change 8.0.0
 * @type {?}
 */
var CDK_DROP_LIST_CONTAINER = CDK_DROP_LIST;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Injection token that can be used for a `CdkDrag` to provide itself as a parent to the
 * drag-specific child directive (`CdkDragHandle`, `CdkDragPreview` etc.). Used primarily
 * to avoid circular imports.
 * \@docs-private
 * @type {?}
 */
var CDK_DRAG_PARENT = /*@__PURE__*/ new core["InjectionToken"]('CDK_DRAG_PARENT');
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Handle that can be used to drag and CdkDrag instance.
 */
var drag_drop_es5_CdkDragHandle = /*@__PURE__*/ (function () {
    function CdkDragHandle(element, parentDrag) {
        this.element = element;
        /**
         * Emits when the state of the handle has changed.
         */
        this._stateChanges = new _esm5["e" /* Subject */]();
        this._disabled = false;
        this._parentDrag = parentDrag;
        toggleNativeDragInteractions(element.nativeElement, false);
    }
    Object.defineProperty(CdkDragHandle.prototype, "disabled", {
        /** Whether starting to drag through this handle is disabled. */
        get: /**
         * Whether starting to drag through this handle is disabled.
         * @return {?}
         */ function () { return this._disabled; },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) {
            this._disabled = coerceBooleanProperty(value);
            this._stateChanges.next(this);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkDragHandle.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this._stateChanges.complete();
        };
    return CdkDragHandle;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Element that will be used as a template for the placeholder of a CdkDrag when
 * it is being dragged. The placeholder is displayed in place of the element being dragged.
 * @template T
 */
var CdkDragPlaceholder = /*@__PURE__*/ (function () {
    function CdkDragPlaceholder(templateRef) {
        this.templateRef = templateRef;
    }
    return CdkDragPlaceholder;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Element that will be used as a template for the preview
 * of a CdkDrag when it is being dragged.
 * @template T
 */
var CdkDragPreview = /*@__PURE__*/ (function () {
    function CdkDragPreview(templateRef) {
        this.templateRef = templateRef;
    }
    return CdkDragPreview;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Injection token that can be used to configure the behavior of `CdkDrag`.
 * @type {?}
 */
var CDK_DRAG_CONFIG = /*@__PURE__*/ new core["InjectionToken"]('CDK_DRAG_CONFIG', {
    providedIn: 'root',
    factory: CDK_DRAG_CONFIG_FACTORY
});
/**
 * \@docs-private
 * @return {?}
 */
function CDK_DRAG_CONFIG_FACTORY() {
    return { dragStartThreshold: 5, pointerDirectionChangeThreshold: 5 };
}
/**
 * Element that can be moved inside a CdkDropList container.
 * @template T
 */
var drag_drop_es5_CdkDrag = /*@__PURE__*/ (function () {
    function CdkDrag(element, dropContainer, _document, _ngZone, _viewContainerRef, viewportRuler, dragDropRegistry, config, _dir, 
    /**
     * @deprecated `viewportRuler`, `dragDropRegistry` and `_changeDetectorRef` parameters
     * to be removed. Also `dragDrop` parameter to be made required.
     * @breaking-change 8.0.0.
     */
    dragDrop, _changeDetectorRef) {
        var _this = this;
        this.element = element;
        this.dropContainer = dropContainer;
        this._document = _document;
        this._ngZone = _ngZone;
        this._viewContainerRef = _viewContainerRef;
        this._dir = _dir;
        this._changeDetectorRef = _changeDetectorRef;
        this._destroyed = new _esm5["e" /* Subject */]();
        this._disabled = false;
        /**
         * Emits when the user starts dragging the item.
         */
        this.started = new core["EventEmitter"]();
        /**
         * Emits when the user has released a drag item, before any animations have started.
         */
        this.released = new core["EventEmitter"]();
        /**
         * Emits when the user stops dragging an item in the container.
         */
        this.ended = new core["EventEmitter"]();
        /**
         * Emits when the user has moved the item into a new container.
         */
        this.entered = new core["EventEmitter"]();
        /**
         * Emits when the user removes the item its container by dragging it into another container.
         */
        this.exited = new core["EventEmitter"]();
        /**
         * Emits when the user drops the item inside a container.
         */
        this.dropped = new core["EventEmitter"]();
        /**
         * Emits as the user is dragging the item. Use with caution,
         * because this event will fire for every pixel that the user has dragged.
         */
        this.moved = new _esm5["d" /* Observable */](function (observer) {
            /** @type {?} */
            var subscription = _this._dragRef.moved.pipe(Object(operators["map"])(function (movedEvent) {
                return ({
                    source: _this,
                    pointerPosition: movedEvent.pointerPosition,
                    event: movedEvent.event,
                    delta: movedEvent.delta
                });
            })).subscribe(observer);
            return function () {
                subscription.unsubscribe();
            };
        });
        // @breaking-change 8.0.0 Remove null check once the paramter is made required.
        if (dragDrop) {
            this._dragRef = dragDrop.createDrag(element, config);
        }
        else {
            this._dragRef = new drag_drop_es5_DragRef(element, config, _document, _ngZone, viewportRuler, dragDropRegistry);
        }
        this._dragRef.data = this;
        this._syncInputs(this._dragRef);
        this._handleEvents(this._dragRef);
    }
    Object.defineProperty(CdkDrag.prototype, "disabled", {
        /** Whether starting to drag this element is disabled. */
        get: /**
         * Whether starting to drag this element is disabled.
         * @return {?}
         */ function () {
            return this._disabled || (this.dropContainer && this.dropContainer.disabled);
        },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) {
            this._disabled = coerceBooleanProperty(value);
            this._dragRef.disabled = this._disabled;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the element that is being used as a placeholder
     * while the current element is being dragged.
     */
    /**
     * Returns the element that is being used as a placeholder
     * while the current element is being dragged.
     * @return {?}
     */
    CdkDrag.prototype.getPlaceholderElement = /**
     * Returns the element that is being used as a placeholder
     * while the current element is being dragged.
     * @return {?}
     */
        function () {
            return this._dragRef.getPlaceholderElement();
        };
    /** Returns the root draggable element. */
    /**
     * Returns the root draggable element.
     * @return {?}
     */
    CdkDrag.prototype.getRootElement = /**
     * Returns the root draggable element.
     * @return {?}
     */
        function () {
            return this._dragRef.getRootElement();
        };
    /** Resets a standalone drag item to its initial position. */
    /**
     * Resets a standalone drag item to its initial position.
     * @return {?}
     */
    CdkDrag.prototype.reset = /**
     * Resets a standalone drag item to its initial position.
     * @return {?}
     */
        function () {
            this._dragRef.reset();
        };
    /**
     * @return {?}
     */
    CdkDrag.prototype.ngAfterViewInit = /**
     * @return {?}
     */
        function () {
            var _this = this;
            // We need to wait for the zone to stabilize, in order for the reference
            // element to be in the proper place in the DOM. This is mostly relevant
            // for draggable elements inside portals since they get stamped out in
            // their original DOM position and then they get transferred to the portal.
            this._ngZone.onStable.asObservable()
                .pipe(Object(operators["take"])(1), Object(operators["takeUntil"])(this._destroyed))
                .subscribe(function () {
                _this._updateRootElement();
                // Listen for any newly-added handles.
                _this._handles.changes.pipe(Object(operators["startWith"])(_this._handles), 
                // Sync the new handles with the DragRef.
                Object(operators["tap"])(function (handles) {
                    /** @type {?} */
                    var childHandleElements = handles
                        .filter(function (handle) { return handle._parentDrag === _this; })
                        .map(function (handle) { return handle.element; });
                    _this._dragRef.withHandles(childHandleElements);
                }), 
                // Listen if the state of any of the handles changes.
                Object(operators["switchMap"])(function (handles) {
                    return _esm5["w" /* merge */].apply(void 0, handles.map(function (item) { return item._stateChanges; }));
                }), Object(operators["takeUntil"])(_this._destroyed)).subscribe(function (handleInstance) {
                    // Enabled/disable the handle that changed in the DragRef.
                    /** @type {?} */
                    var dragRef = _this._dragRef;
                    /** @type {?} */
                    var handle = handleInstance.element.nativeElement;
                    handleInstance.disabled ? dragRef.disableHandle(handle) : dragRef.enableHandle(handle);
                });
            });
        };
    /**
     * @param {?} changes
     * @return {?}
     */
    CdkDrag.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
        function (changes) {
            /** @type {?} */
            var rootSelectorChange = changes['rootElementSelector'];
            // We don't have to react to the first change since it's being
            // handled in `ngAfterViewInit` where it needs to be deferred.
            if (rootSelectorChange && !rootSelectorChange.firstChange) {
                this._updateRootElement();
            }
        };
    /**
     * @return {?}
     */
    CdkDrag.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this._destroyed.next();
            this._destroyed.complete();
            this._dragRef.dispose();
        };
    /** Syncs the root element with the `DragRef`. */
    /**
     * Syncs the root element with the `DragRef`.
     * @private
     * @return {?}
     */
    CdkDrag.prototype._updateRootElement = /**
     * Syncs the root element with the `DragRef`.
     * @private
     * @return {?}
     */
        function () {
            /** @type {?} */
            var element = this.element.nativeElement;
            /** @type {?} */
            var rootElement = this.rootElementSelector ?
                getClosestMatchingAncestor(element, this.rootElementSelector) : element;
            if (rootElement && rootElement.nodeType !== this._document.ELEMENT_NODE) {
                throw Error("cdkDrag must be attached to an element node. " +
                    ("Currently attached to \"" + rootElement.nodeName + "\"."));
            }
            this._dragRef.withRootElement(rootElement || element);
        };
    /** Gets the boundary element, based on the `boundaryElementSelector`. */
    /**
     * Gets the boundary element, based on the `boundaryElementSelector`.
     * @private
     * @return {?}
     */
    CdkDrag.prototype._getBoundaryElement = /**
     * Gets the boundary element, based on the `boundaryElementSelector`.
     * @private
     * @return {?}
     */
        function () {
            /** @type {?} */
            var selector = this.boundaryElementSelector;
            return selector ? getClosestMatchingAncestor(this.element.nativeElement, selector) : null;
        };
    /** Syncs the inputs of the CdkDrag with the options of the underlying DragRef. */
    /**
     * Syncs the inputs of the CdkDrag with the options of the underlying DragRef.
     * @private
     * @param {?} ref
     * @return {?}
     */
    CdkDrag.prototype._syncInputs = /**
     * Syncs the inputs of the CdkDrag with the options of the underlying DragRef.
     * @private
     * @param {?} ref
     * @return {?}
     */
        function (ref) {
            var _this = this;
            ref.beforeStarted.subscribe(function () {
                if (!ref.isDragging()) {
                    /** @type {?} */
                    var dir = _this._dir;
                    /** @type {?} */
                    var placeholder = _this._placeholderTemplate ? {
                        template: _this._placeholderTemplate.templateRef,
                        context: _this._placeholderTemplate.data,
                        viewContainer: _this._viewContainerRef
                    } : null;
                    /** @type {?} */
                    var preview = _this._previewTemplate ? {
                        template: _this._previewTemplate.templateRef,
                        context: _this._previewTemplate.data,
                        viewContainer: _this._viewContainerRef
                    } : null;
                    ref.disabled = _this.disabled;
                    ref.lockAxis = _this.lockAxis;
                    ref
                        .withBoundaryElement(_this._getBoundaryElement())
                        .withPlaceholderTemplate(placeholder)
                        .withPreviewTemplate(preview);
                    if (dir) {
                        ref.withDirection(dir.value);
                    }
                }
            });
        };
    /** Handles the events from the underlying `DragRef`. */
    /**
     * Handles the events from the underlying `DragRef`.
     * @private
     * @param {?} ref
     * @return {?}
     */
    CdkDrag.prototype._handleEvents = /**
     * Handles the events from the underlying `DragRef`.
     * @private
     * @param {?} ref
     * @return {?}
     */
        function (ref) {
            var _this = this;
            ref.started.subscribe(function () {
                _this.started.emit({ source: _this });
                // Since all of these events run outside of change detection,
                // we need to ensure that everything is marked correctly.
                if (_this._changeDetectorRef) {
                    // @breaking-change 8.0.0 Remove null check for _changeDetectorRef
                    _this._changeDetectorRef.markForCheck();
                }
            });
            ref.released.subscribe(function () {
                _this.released.emit({ source: _this });
            });
            ref.ended.subscribe(function () {
                _this.ended.emit({ source: _this });
                // Since all of these events run outside of change detection,
                // we need to ensure that everything is marked correctly.
                if (_this._changeDetectorRef) {
                    // @breaking-change 8.0.0 Remove null check for _changeDetectorRef
                    _this._changeDetectorRef.markForCheck();
                }
            });
            ref.entered.subscribe(function (event) {
                _this.entered.emit({
                    container: event.container.data,
                    item: _this
                });
            });
            ref.exited.subscribe(function (event) {
                _this.exited.emit({
                    container: event.container.data,
                    item: _this
                });
            });
            ref.dropped.subscribe(function (event) {
                _this.dropped.emit({
                    previousIndex: event.previousIndex,
                    currentIndex: event.currentIndex,
                    previousContainer: event.previousContainer.data,
                    container: event.container.data,
                    isPointerOverContainer: event.isPointerOverContainer,
                    item: _this
                });
            });
        };
    return CdkDrag;
}());
/**
 * Gets the closest ancestor of an element that matches a selector.
 * @param {?} element
 * @param {?} selector
 * @return {?}
 */
function getClosestMatchingAncestor(element, selector) {
    /** @type {?} */
    var currentElement = ((element.parentElement));
    while (currentElement) {
        // IE doesn't support `matches` so we have to fall back to `msMatchesSelector`.
        if (currentElement.matches ? currentElement.matches(selector) :
            (((currentElement))).msMatchesSelector(selector)) {
            return currentElement;
        }
        currentElement = currentElement.parentElement;
    }
    return null;
}
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Declaratively connects sibling `cdkDropList` instances together. All of the `cdkDropList`
 * elements that are placed inside a `cdkDropListGroup` will be connected to each other
 * automatically. Can be used as an alternative to the `cdkDropListConnectedTo` input
 * from `cdkDropList`.
 * @template T
 */
var drag_drop_es5_CdkDropListGroup = /*@__PURE__*/ (function () {
    function CdkDropListGroup() {
        /**
         * Drop lists registered inside the group.
         */
        this._items = new Set();
        this._disabled = false;
    }
    Object.defineProperty(CdkDropListGroup.prototype, "disabled", {
        /** Whether starting a dragging sequence from inside this group is disabled. */
        get: /**
         * Whether starting a dragging sequence from inside this group is disabled.
         * @return {?}
         */ function () { return this._disabled; },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkDropListGroup.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            this._items.clear();
        };
    return CdkDropListGroup;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Counter used to generate unique ids for drop zones.
 * @type {?}
 */
var _uniqueIdCounter$1 = 0;
var drag_drop_es5__0 = undefined;
// @breaking-change 8.0.0 `CdkDropList` implements `CdkDropListContainer` for backwards
// compatiblity. The implements clause, as well as all the methods that it enforces can
// be removed when `CdkDropListContainer` is deleted.
/**
 * Container that wraps a set of draggable items.
 * @template T
 */
var drag_drop_es5_CdkDropList = /*@__PURE__*/ (function () {
    function CdkDropList(element, dragDropRegistry, _changeDetectorRef, _dir, _group, _document, 
    /**
     * @deprecated `dragDropRegistry` and `_document` parameters to be removed.
     * Also `dragDrop` parameter to be made required.
     * @breaking-change 8.0.0.
     */
    dragDrop) {
        var _this = this;
        this.element = element;
        this._changeDetectorRef = _changeDetectorRef;
        this._dir = _dir;
        this._group = _group;
        /**
         * Emits when the list has been destroyed.
         */
        this._destroyed = new _esm5["e" /* Subject */]();
        /**
         * Other draggable containers that this container is connected to and into which the
         * container's items can be transferred. Can either be references to other drop containers,
         * or their unique IDs.
         */
        this.connectedTo = [];
        /**
         * Direction in which the list is oriented.
         */
        this.orientation = 'vertical';
        /**
         * Unique ID for the drop zone. Can be used as a reference
         * in the `connectedTo` of another `CdkDropList`.
         */
        this.id = "cdk-drop-list-" + _uniqueIdCounter$1++;
        this._disabled = false;
        /**
         * Function that is used to determine whether an item
         * is allowed to be moved into a drop container.
         */
        this.enterPredicate = function () { return true; };
        /**
         * Emits when the user drops an item inside the container.
         */
        this.dropped = new core["EventEmitter"]();
        /**
         * Emits when the user has moved a new drag item into this container.
         */
        this.entered = new core["EventEmitter"]();
        /**
         * Emits when the user removes an item from the container
         * by dragging it into another container.
         */
        this.exited = new core["EventEmitter"]();
        /**
         * Emits as the user is swapping items while actively dragging.
         */
        this.sorted = new core["EventEmitter"]();
        // @breaking-change 8.0.0 Remove null check once `dragDrop` parameter is made required.
        if (dragDrop) {
            this._dropListRef = dragDrop.createDropList(element);
        }
        else {
            this._dropListRef = new drag_drop_es5_DropListRef(element, dragDropRegistry, _document || document);
        }
        this._dropListRef.data = this;
        this._dropListRef.enterPredicate = function (drag, drop) {
            return _this.enterPredicate(drag.data, drop.data);
        };
        this._syncInputs(this._dropListRef);
        this._handleEvents(this._dropListRef);
        CdkDropList._dropLists.push(this);
        if (_group) {
            _group._items.add(this);
        }
    }
    Object.defineProperty(CdkDropList.prototype, "disabled", {
        /** Whether starting a dragging sequence from this container is disabled. */
        get: /**
         * Whether starting a dragging sequence from this container is disabled.
         * @return {?}
         */ function () {
            return this._disabled || (!!this._group && this._group.disabled);
        },
        set: /**
         * @param {?} value
         * @return {?}
         */ function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    CdkDropList.prototype.ngAfterContentInit = /**
     * @return {?}
     */
        function () {
            var _this = this;
            this._draggables.changes
                .pipe(Object(operators["startWith"])(this._draggables), Object(operators["takeUntil"])(this._destroyed))
                .subscribe(function (items) {
                _this._dropListRef.withItems(items.map(function (drag) { return drag._dragRef; }));
            });
        };
    /**
     * @return {?}
     */
    CdkDropList.prototype.ngOnDestroy = /**
     * @return {?}
     */
        function () {
            /** @type {?} */
            var index = CdkDropList._dropLists.indexOf(this);
            if (index > -1) {
                CdkDropList._dropLists.splice(index, 1);
            }
            if (this._group) {
                this._group._items.delete(this);
            }
            this._dropListRef.dispose();
            this._destroyed.next();
            this._destroyed.complete();
        };
    /** Starts dragging an item. */
    /**
     * Starts dragging an item.
     * @return {?}
     */
    CdkDropList.prototype.start = /**
     * Starts dragging an item.
     * @return {?}
     */
        function () {
            this._dropListRef.start();
        };
    /**
     * Drops an item into this container.
     * @param item Item being dropped into the container.
     * @param currentIndex Index at which the item should be inserted.
     * @param previousContainer Container from which the item got dragged in.
     * @param isPointerOverContainer Whether the user's pointer was over the
     *    container when the item was dropped.
     */
    /**
     * Drops an item into this container.
     * @param {?} item Item being dropped into the container.
     * @param {?} currentIndex Index at which the item should be inserted.
     * @param {?} previousContainer Container from which the item got dragged in.
     * @param {?} isPointerOverContainer Whether the user's pointer was over the
     *    container when the item was dropped.
     * @return {?}
     */
    CdkDropList.prototype.drop = /**
     * Drops an item into this container.
     * @param {?} item Item being dropped into the container.
     * @param {?} currentIndex Index at which the item should be inserted.
     * @param {?} previousContainer Container from which the item got dragged in.
     * @param {?} isPointerOverContainer Whether the user's pointer was over the
     *    container when the item was dropped.
     * @return {?}
     */
        function (item, currentIndex, previousContainer, isPointerOverContainer) {
            this._dropListRef.drop(item._dragRef, currentIndex, (((previousContainer)))._dropListRef, isPointerOverContainer);
        };
    /**
     * Emits an event to indicate that the user moved an item into the container.
     * @param item Item that was moved into the container.
     * @param pointerX Position of the item along the X axis.
     * @param pointerY Position of the item along the Y axis.
     */
    /**
     * Emits an event to indicate that the user moved an item into the container.
     * @param {?} item Item that was moved into the container.
     * @param {?} pointerX Position of the item along the X axis.
     * @param {?} pointerY Position of the item along the Y axis.
     * @return {?}
     */
    CdkDropList.prototype.enter = /**
     * Emits an event to indicate that the user moved an item into the container.
     * @param {?} item Item that was moved into the container.
     * @param {?} pointerX Position of the item along the X axis.
     * @param {?} pointerY Position of the item along the Y axis.
     * @return {?}
     */
        function (item, pointerX, pointerY) {
            this._dropListRef.enter(item._dragRef, pointerX, pointerY);
        };
    /**
     * Removes an item from the container after it was dragged into another container by the user.
     * @param item Item that was dragged out.
     */
    /**
     * Removes an item from the container after it was dragged into another container by the user.
     * @param {?} item Item that was dragged out.
     * @return {?}
     */
    CdkDropList.prototype.exit = /**
     * Removes an item from the container after it was dragged into another container by the user.
     * @param {?} item Item that was dragged out.
     * @return {?}
     */
        function (item) {
            this._dropListRef.exit(item._dragRef);
        };
    /**
     * Figures out the index of an item in the container.
     * @param item Item whose index should be determined.
     */
    /**
     * Figures out the index of an item in the container.
     * @param {?} item Item whose index should be determined.
     * @return {?}
     */
    CdkDropList.prototype.getItemIndex = /**
     * Figures out the index of an item in the container.
     * @param {?} item Item whose index should be determined.
     * @return {?}
     */
        function (item) {
            return this._dropListRef.getItemIndex(item._dragRef);
        };
    /**
     * Sorts an item inside the container based on its position.
     * @param item Item to be sorted.
     * @param pointerX Position of the item along the X axis.
     * @param pointerY Position of the item along the Y axis.
     * @param pointerDelta Direction in which the pointer is moving along each axis.
     */
    /**
     * Sorts an item inside the container based on its position.
     * @param {?} item Item to be sorted.
     * @param {?} pointerX Position of the item along the X axis.
     * @param {?} pointerY Position of the item along the Y axis.
     * @param {?} pointerDelta Direction in which the pointer is moving along each axis.
     * @return {?}
     */
    CdkDropList.prototype._sortItem = /**
     * Sorts an item inside the container based on its position.
     * @param {?} item Item to be sorted.
     * @param {?} pointerX Position of the item along the X axis.
     * @param {?} pointerY Position of the item along the Y axis.
     * @param {?} pointerDelta Direction in which the pointer is moving along each axis.
     * @return {?}
     */
        function (item, pointerX, pointerY, pointerDelta) {
            return this._dropListRef._sortItem(item._dragRef, pointerX, pointerY, pointerDelta);
        };
    /**
     * Figures out whether an item should be moved into a sibling
     * drop container, based on its current position.
     * @param item Drag item that is being moved.
     * @param x Position of the item along the X axis.
     * @param y Position of the item along the Y axis.
     */
    /**
     * Figures out whether an item should be moved into a sibling
     * drop container, based on its current position.
     * @param {?} item Drag item that is being moved.
     * @param {?} x Position of the item along the X axis.
     * @param {?} y Position of the item along the Y axis.
     * @return {?}
     */
    CdkDropList.prototype._getSiblingContainerFromPosition = /**
     * Figures out whether an item should be moved into a sibling
     * drop container, based on its current position.
     * @param {?} item Drag item that is being moved.
     * @param {?} x Position of the item along the X axis.
     * @param {?} y Position of the item along the Y axis.
     * @return {?}
     */
        function (item, x, y) {
            /** @type {?} */
            var result = this._dropListRef._getSiblingContainerFromPosition(item._dragRef, x, y);
            return result ? result.data : null;
        };
    /**
     * Checks whether the user's pointer is positioned over the container.
     * @param x Pointer position along the X axis.
     * @param y Pointer position along the Y axis.
     */
    /**
     * Checks whether the user's pointer is positioned over the container.
     * @param {?} x Pointer position along the X axis.
     * @param {?} y Pointer position along the Y axis.
     * @return {?}
     */
    CdkDropList.prototype._isOverContainer = /**
     * Checks whether the user's pointer is positioned over the container.
     * @param {?} x Pointer position along the X axis.
     * @param {?} y Pointer position along the Y axis.
     * @return {?}
     */
        function (x, y) {
            return this._dropListRef._isOverContainer(x, y);
        };
    /** Syncs the inputs of the CdkDropList with the options of the underlying DropListRef. */
    /**
     * Syncs the inputs of the CdkDropList with the options of the underlying DropListRef.
     * @private
     * @param {?} ref
     * @return {?}
     */
    CdkDropList.prototype._syncInputs = /**
     * Syncs the inputs of the CdkDropList with the options of the underlying DropListRef.
     * @private
     * @param {?} ref
     * @return {?}
     */
        function (ref) {
            var _this = this;
            if (this._dir) {
                this._dir.change
                    .pipe(Object(operators["startWith"])(this._dir.value), Object(operators["takeUntil"])(this._destroyed))
                    .subscribe(function (value) { return ref.withDirection(value); });
            }
            ref.beforeStarted.subscribe(function () {
                /** @type {?} */
                var siblings = coerceArray(_this.connectedTo).map(function (drop) {
                    return typeof drop === 'string' ?
                        ((CdkDropList._dropLists.find(function (list) { return list.id === drop; }))) : drop;
                });
                if (_this._group) {
                    _this._group._items.forEach(function (drop) {
                        if (siblings.indexOf(drop) === -1) {
                            siblings.push(drop);
                        }
                    });
                }
                ref.lockAxis = _this.lockAxis;
                ref
                    .connectedTo(siblings.filter(function (drop) { return drop && drop !== _this; }).map(function (list) { return list._dropListRef; }))
                    .withOrientation(_this.orientation);
            });
        };
    /** Handles events from the underlying DropListRef. */
    /**
     * Handles events from the underlying DropListRef.
     * @private
     * @param {?} ref
     * @return {?}
     */
    CdkDropList.prototype._handleEvents = /**
     * Handles events from the underlying DropListRef.
     * @private
     * @param {?} ref
     * @return {?}
     */
        function (ref) {
            var _this = this;
            ref.beforeStarted.subscribe(function () {
                _this._changeDetectorRef.markForCheck();
            });
            ref.entered.subscribe(function (event) {
                _this.entered.emit({
                    container: _this,
                    item: event.item.data
                });
            });
            ref.exited.subscribe(function (event) {
                _this.exited.emit({
                    container: _this,
                    item: event.item.data
                });
            });
            ref.sorted.subscribe(function (event) {
                _this.sorted.emit({
                    previousIndex: event.previousIndex,
                    currentIndex: event.currentIndex,
                    container: _this,
                    item: event.item.data
                });
            });
            ref.dropped.subscribe(function (event) {
                _this.dropped.emit({
                    previousIndex: event.previousIndex,
                    currentIndex: event.currentIndex,
                    previousContainer: event.previousContainer.data,
                    container: event.container.data,
                    item: event.item.data,
                    isPointerOverContainer: event.isPointerOverContainer
                });
                // Mark for check since all of these events run outside of change
                // detection and we're not guaranteed for something else to have triggered it.
                _this._changeDetectorRef.markForCheck();
            });
        };
    /**
     * Keeps track of the drop lists that are currently on the page.
     */
    CdkDropList._dropLists = [];
    return CdkDropList;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DragDropModule = /*@__PURE__*/ (function () {
    function DragDropModule() {
    }
    return DragDropModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */





// CONCATENATED MODULE: ./src/app/shared/auth/auth.service.ts
var AuthService = /*@__PURE__*/ (function () {
    function AuthService() {
    }
    AuthService.prototype.getToken = function () {
        return localStorage.getItem('activeToken');
    };
    AuthService.prototype.isAuthenticated = function () {
        var token = this.getToken();
        return token != null;
    };
    return AuthService;
}());



// CONCATENATED MODULE: ./src/app/shared/auth/jwt.interceptor.ts


var jwt_interceptor_JwtInterceptor = /*@__PURE__*/ (function () {
    function JwtInterceptor(auth, _toaster, _global) {
        this.auth = auth;
        this._toaster = _toaster;
        this._global = _global;
    }
    JwtInterceptor.prototype.handelSSOLoginResponse = function (result) {
        if (result && result.headers) {
            var contentType = result.headers.get('Content-type');
            if (result.status == 200 && contentType != null
                && (contentType.includes('text') || contentType.includes('html'))) {
                window.location.href = '/epms/noAuth/sdgSSO';
            }
        }
    };
    JwtInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        if (typeof window.localStorage.getItem('activeToken') !== 'undefined'
            && window.localStorage.getItem('activeToken') != null
            && window.localStorage.getItem('activeToken').trim() !== '') {
            request = request.clone({
                headers: request.headers.set('X-AUTH-TOKEN', window.localStorage.getItem('activeToken'))
            });
        }
        else {
            this.clearLocalStorage();
            window.location.href = this._global.get('USER_APP_URL') + "/";
        }
        return next.handle(request).pipe(Object(operators["tap"])(function (event) {
            if (event instanceof http_HttpResponse) {
                var auth = event.headers.get('X-Auth-Token');
                if (typeof auth !== 'undefined' && auth != null) {
                    window.localStorage.setItem('activeToken', event.headers.get('X-Auth-Token'));
                }
                if (request.url.includes('getAdminOperations')) {
                    _this.handelSSOLoginResponse(event);
                }
            }
        }, function (err) {
            if (err instanceof http_HttpErrorResponse) {
                if (err.status === 401 || err.status === 403) {
                    _this.clearLocalStorage();
                    window.location.href = _this._global.get('USER_APP_URL') + "/";
                }
                else if (err.status === 500) {
                    _this._toaster.showError('Something Went Wrong ');
                }
                else if (err.status === 503) {
                    _this._toaster.showError('Service Unavailable');
                }
                else if (err.status === 200) {
                    if (request.url.includes('getAdminOperations')) {
                        _this.handelSSOLoginResponse(err);
                    }
                }
            }
        }));
    };
    JwtInterceptor.prototype.clearLocalStorage = function () {
        window.localStorage.clear();
    };
    return JwtInterceptor;
}());



// CONCATENATED MODULE: ./node_modules/@ngx-translate/http-loader/src/http-loader.js
var TranslateHttpLoader = /*@__PURE__*/ (function () {
    function TranslateHttpLoader(http, prefix, suffix) {
        if (prefix === void 0) {
            prefix = "/assets/i18n/";
        }
        if (suffix === void 0) {
            suffix = ".json";
        }
        this.http = http;
        this.prefix = prefix;
        this.suffix = suffix;
    }
    /**
     * Gets the translations from the server
     * @param lang
     * @returns {any}
     */
    TranslateHttpLoader.prototype.getTranslation = function (lang) {
        return this.http.get("" + this.prefix + lang + this.suffix);
    };
    return TranslateHttpLoader;
}());



// CONCATENATED MODULE: ./node_modules/@ngx-translate/http-loader/index.js


// CONCATENATED MODULE: ./src/app/common/common-app.module.ts




function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
var common_app_module__0 = (createTranslateLoader);
var translateModule = core_es5["g" /* TranslateModule */].forRoot({
    loader: {
        provide: core_es5["f" /* TranslateLoader */],
        useFactory: common_app_module__0,
        deps: [http_HttpClient]
    }
});
var toastrModule = ToastrModule.forRoot({
    autoDismiss: true,
    maxOpened: 1,
    timeOut: 2000,
    positionClass: 'toast-top-center',
    enableHtml: true
});
var CommonAppModule = /*@__PURE__*/ (function () {
    function CommonAppModule() {
    }
    return CommonAppModule;
}());




// EXTERNAL MODULE: ./node_modules/ng2-auto-complete/dist/ng2-auto-complete.module.js
var ng2_auto_complete_module = __webpack_require__("qhmd");
var ng2_auto_complete_module_default = /*#__PURE__*/__webpack_require__.n(ng2_auto_complete_module);

// EXTERNAL MODULE: ./node_modules/mobx/lib/mobx.module.js
var mobx_module = __webpack_require__("y986");

// CONCATENATED MODULE: ./node_modules/mobx-angular/dist/utils/mobx-angular-debug.js
/* tslint:disable:max-line-length */
/* tslint:disable:no-console */

// function for turning debug on / off
var mobx_angular_debug_mobxAngularDebug = (function () {
    if (typeof localStorage === 'undefined' || typeof console === 'undefined' || typeof window === 'undefined') {
        return function () { };
    }
    if (!localStorage || !console || !window) {
        return function () { };
    }
    var style = 'background: #222; color: #bada55';
    window['mobxAngularDebug'] = function (value) {
        if (value) {
            console.log('%c MobX will now log everything to the console', style);
            console.log('%c Right-click any element to see its dependency tree', style);
            localStorage['mobx-angular-debug'] = true;
        }
        else
            delete localStorage['mobx-angular-debug'];
    };
    function isDebugOn() {
        return localStorage['mobx-angular-debug'];
    }
    Object(mobx_module["i" /* spy */])(function (change) { return isDebugOn() && consoleLogChange(change, function () { return true; }); });
    // Debugging element dependency tree
    function mobxAngularDebug(view, renderer, observer) {
        var element = view.rootNodes[0];
        renderer.listen(element, 'contextmenu', function () {
            if (isDebugOn())
                console.log(mobx_module["d" /* extras */].getDependencyTree(observer));
        });
    }
    /////////////////////////////////////////////////////////
    // console logging (copied from mobx-react)
    var advicedToUseChrome = false;
    var currentDepth = 0;
    var isInsideSkippedGroup = false;
    function consoleLogChange(change, filter) {
        if (advicedToUseChrome === false && typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Chrome') === -1) {
            console.warn('The output of the MobX logger is optimized for Chrome');
            advicedToUseChrome = true;
        }
        var isGroupStart = change.spyReportStart === true;
        var isGroupEnd = change.spyReportEnd === true;
        var show;
        if (currentDepth === 0) {
            show = filter(change);
            if (isGroupStart && !show) {
                isInsideSkippedGroup = true;
            }
        }
        else if (isGroupEnd && isInsideSkippedGroup && currentDepth === 1) {
            show = false;
            isInsideSkippedGroup = false;
        }
        else {
            show = isInsideSkippedGroup !== true;
        }
        if (show && isGroupEnd) {
            groupEnd(change.time);
        }
        else if (show) {
            var logNext = isGroupStart ? group : log;
            switch (change.type) {
                case 'action':
                    // name, target, arguments, fn
                    logNext("%caction '%s' %s", 'color:dodgerblue', change.name, autoWrap('(', getNameForThis(change.target)));
                    log(change.arguments);
                    trace();
                    break;
                case 'transaction':
                    // name, target
                    logNext("%ctransaction '%s' %s", 'color:gray', change.name, autoWrap('(', getNameForThis(change.target)));
                    break;
                case 'scheduled-reaction':
                    // object
                    logNext("%cscheduled async reaction '%s'", 'color:#10a210', observableName(change.object));
                    break;
                case 'reaction':
                    // object, fn
                    logNext("%creaction '%s'", 'color:#10a210', observableName(change.object));
                    // dir({
                    //     fn: change.fn
                    // });
                    trace();
                    break;
                case 'compute':
                    // object, target, fn
                    group("%ccomputed '%s' %s", 'color:#10a210', observableName(change.object), autoWrap('(', getNameForThis(change.target)));
                    // dir({
                    //    fn: change.fn,
                    //    target: change.target
                    // });
                    groupEnd();
                    break;
                case 'error':
                    // message
                    logNext('%cerror: %s', 'color:tomato', change.message);
                    trace();
                    closeGroupsOnError();
                    break;
                case 'update':
                    // (array) object, index, newValue, oldValue
                    // (map, obbject) object, name, newValue, oldValue
                    // (value) object, newValue, oldValue
                    if (Object(mobx_module["e" /* isObservableArray */])(change.object)) {
                        logNext('updated \'%s[%s]\': %s (was: %s)', observableName(change.object), change.index, formatValue(change.newValue), formatValue(change.oldValue));
                    }
                    else if (Object(mobx_module["f" /* isObservableObject */])(change.object)) {
                        logNext('updated \'%s.%s\': %s (was: %s)', observableName(change.object), change.name, formatValue(change.newValue), formatValue(change.oldValue));
                    }
                    else {
                        logNext('updated \'%s\': %s (was: %s)', observableName(change.object), change.name, formatValue(change.newValue), formatValue(change.oldValue));
                    }
                    dir({
                        newValue: change.newValue,
                        oldValue: change.oldValue
                    });
                    trace();
                    break;
                case 'splice':
                    // (array) object, index, added, removed, addedCount, removedCount
                    logNext('spliced \'%s\': index %d, added %d, removed %d', observableName(change.object), change.index, change.addedCount, change.removedCount);
                    dir({
                        added: change.added,
                        removed: change.removed
                    });
                    trace();
                    break;
                case 'add':
                    // (map, object) object, name, newValue
                    logNext('set \'%s.%s\': %s', observableName(change.object), change.name, formatValue(change.newValue));
                    dir({
                        newValue: change.newValue
                    });
                    trace();
                    break;
                case 'delete':
                    // (map) object, name, oldValue
                    logNext('removed \'%s.%s\' (was %s)', observableName(change.object), change.name, formatValue(change.oldValue));
                    dir({
                        oldValue: change.oldValue
                    });
                    trace();
                    break;
                case 'create':
                    // (value) object, newValue
                    logNext('set \'%s\': %s', observableName(change.object), formatValue(change.newValue));
                    dir({
                        newValue: change.newValue
                    });
                    trace();
                    break;
                default:
                    // generic fallback for future events
                    logNext(change.type);
                    dir(change);
                    break;
            }
        }
        if (isGroupStart)
            currentDepth++;
        if (isGroupEnd)
            currentDepth--;
    }
    var consoleSupportsGroups = false; // typeof console.groupCollapsed === 'function';
    var currentlyLoggedDepth = 0;
    function group() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // TODO: firefox does not support formatting in groupStart methods..
        consoleSupportsGroups ?
            console.groupCollapsed.apply(console, args) :
            console.log.apply(console, args);
        currentlyLoggedDepth++;
    }
    function groupEnd(time) {
        currentlyLoggedDepth--;
        if (typeof time === 'number') {
            log('%ctotal time: %sms', 'color:gray', time);
        }
        if (consoleSupportsGroups)
            console.groupEnd();
    }
    function log() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.log.apply(console, args);
    }
    function dir() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.dir.apply(console, args);
    }
    function trace() {
        // TODO: needs wrapping in firefox?
        if (console.trace) {
            console.trace('stack'); // TODO: use stacktrace.js or similar and strip off unrelevant stuff?
        }
    }
    function closeGroupsOnError() {
        for (var i = 0, m = currentlyLoggedDepth; i < m; i++)
            groupEnd();
    }
    var closeToken = {
        '"': '"',
        '\'': '\'',
        '(': ')',
        '[': ']',
        '<': ']',
        '#': ''
    };
    function autoWrap(token, value) {
        if (!value)
            return '';
        return (token || '') + value + (closeToken[token] || '');
    }
    function observableName(object) {
        return mobx_module["d" /* extras */].getDebugName(object);
    }
    function formatValue(value) {
        if (isPrimitive(value)) {
            if (typeof value === 'string' && value.length > 100)
                return value.substr(0, 97) + '...';
            return value;
        }
        else
            return autoWrap('(', getNameForThis(value));
    }
    function getNameForThis(who) {
        if (who === null || who === undefined) {
            return '';
        }
        else if (who && typeof who === 'object') {
            if (who && who.$mobx) {
                return who.$mobx.name;
            }
            else if (who.constructor) {
                return who.constructor.name || 'object';
            }
        }
        return "" + typeof who;
    }
    function isPrimitive(value) {
        return value === null || value === undefined || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
    }
    return mobxAngularDebug;
})();
//# sourceMappingURL=data:application/json;base64,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
// CONCATENATED MODULE: ./node_modules/mobx-angular/dist/directives/mobx-autorun.directive.js



var mobx_autorun_directive_MobxAutorunDirective = /*@__PURE__*/ (function () {
    function MobxAutorunDirective(templateRef, viewContainer, renderer) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.renderer = renderer;
        this.templateBindings = {};
    }
    MobxAutorunDirective.prototype.ngOnInit = function () {
        this.view = this.viewContainer.createEmbeddedView(this.templateRef);
        if (this.dispose)
            this.dispose();
        if (this.shouldDetach()) {
            this.view.detach();
        }
        this.autoDetect(this.view);
        mobx_angular_debug_mobxAngularDebug(this.view, this.renderer, this.dispose);
    };
    MobxAutorunDirective.prototype.shouldDetach = function () {
        return this.mobxAutorun && this.mobxAutorun.detach;
    };
    MobxAutorunDirective.prototype.autoDetect = function (view) {
        var autorunName = view._view.component
            ? view._view.component.constructor.name + ".detectChanges()" // angular 4+
            : view._view.parentView.context.constructor.name + ".detectChanges()"; // angular 2
        this.dispose = Object(mobx_module["b" /* autorun */])(autorunName, function () { return view['detectChanges'](); });
    };
    MobxAutorunDirective.prototype.ngOnDestroy = function () {
        if (this.dispose)
            this.dispose();
    };
    return MobxAutorunDirective;
}());





// CONCATENATED MODULE: ./node_modules/mobx-angular/dist/directives/mobx-autorun-sync.directive.js
var mobx_autorun_sync_directive___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var mobx_autorun_sync_directive_MobxAutorunSyncDirective = /*@__PURE__*/ (function (_super) {
    mobx_autorun_sync_directive___extends(MobxAutorunSyncDirective, _super);
    function MobxAutorunSyncDirective(templateRef, viewContainer, renderer) {
        var _this = _super.call(this, templateRef, viewContainer, renderer) || this;
        _this.templateRef = templateRef;
        _this.viewContainer = viewContainer;
        _this.renderer = renderer;
        return _this;
    }
    MobxAutorunSyncDirective.prototype.autoDetect = function (view) {
        console.warn('mobxAutorunSync is deprecated, please use mobxAutorun instead - it\'s doing exactly the same thing');
        this.dispose = Object(mobx_module["b" /* autorun */])(function () {
            view['detectChanges']();
        });
    };
    return MobxAutorunSyncDirective;
}(mobx_autorun_directive_MobxAutorunDirective));





// CONCATENATED MODULE: ./node_modules/mobx-angular/dist/directives/mobx-reaction.directive.js
var mobx_reaction_directive___extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b)
            if (b.hasOwnProperty(p))
                d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var mobx_reaction_directive_MobxReactionDirective = /*@__PURE__*/ (function (_super) {
    mobx_reaction_directive___extends(MobxReactionDirective, _super);
    function MobxReactionDirective(templateRef, viewContainer, renderer) {
        var _this = _super.call(this, templateRef, viewContainer, renderer) || this;
        _this.templateRef = templateRef;
        _this.viewContainer = viewContainer;
        _this.renderer = renderer;
        return _this;
    }
    MobxReactionDirective.prototype.autoDetect = function (view) {
        this.dispose = Object(mobx_module["h" /* reaction */])(this.mobxReaction, function () {
            view['detectChanges']();
        }, { fireImmediately: true });
    };
    return MobxReactionDirective;
}(mobx_autorun_directive_MobxAutorunDirective));





// CONCATENATED MODULE: ./node_modules/mobx-angular/dist/mobx-angular.js








var DIRECTIVES = [mobx_autorun_directive_MobxAutorunDirective, mobx_autorun_sync_directive_MobxAutorunSyncDirective, mobx_reaction_directive_MobxReactionDirective];
var MobxAngularModule = /*@__PURE__*/ (function () {
    function MobxAngularModule() {
    }
    return MobxAngularModule;
}());

function mobx_angular_action() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return mobx_module["a" /* action */].apply(void 0, args);
}
function computed() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return mobx_module["c" /* computed */].apply(void 0, args);
}
function mobx_angular_observable() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return mobx_module["g" /* observable */].apply(void 0, args);
}




// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/constants/keys.js
var KEYS = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ENTER: 13,
    SPACE: 32,
    CONTEXT_MENU: 32
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9jb25zdGFudHMva2V5cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxJQUFJLEdBQUc7SUFDbEIsSUFBSSxFQUFFLEVBQUU7SUFDUixFQUFFLEVBQUUsRUFBRTtJQUNOLEtBQUssRUFBRSxFQUFFO0lBQ1QsSUFBSSxFQUFFLEVBQUU7SUFDUixLQUFLLEVBQUUsRUFBRTtJQUNULEtBQUssRUFBRSxFQUFFO0lBQ1QsWUFBWSxFQUFFLEVBQUU7Q0FDakIsQ0FBQyIsImZpbGUiOiJrZXlzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBLRVlTID0ge1xuICBMRUZUOiAzNyxcbiAgVVA6IDM4LFxuICBSSUdIVDogMzksXG4gIERPV046IDQwLFxuICBFTlRFUjogMTMsXG4gIFNQQUNFOiAzMixcbiAgQ09OVEVYVF9NRU5VOiAzMlxufTtcbiJdfQ==
// EXTERNAL MODULE: ./node_modules/lodash/defaultsDeep.js
var defaultsDeep = __webpack_require__("gs2Y");
var defaultsDeep_default = /*#__PURE__*/__webpack_require__.n(defaultsDeep);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__("Q7hp");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__("Dc7M");
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: ./node_modules/lodash/isNumber.js
var lodash_isNumber = __webpack_require__("J009");
var isNumber_default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber);

// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/models/tree-options.model.js





var TREE_ACTIONS = {
    TOGGLE_ACTIVE: function (tree, node, $event) { return node && node.toggleActivated(); },
    TOGGLE_ACTIVE_MULTI: function (tree, node, $event) { return node && node.toggleActivated(true); },
    TOGGLE_SELECTED: function (tree, node, $event) { return node && node.toggleSelected(); },
    ACTIVATE: function (tree, node, $event) { return node.setIsActive(true); },
    DEACTIVATE: function (tree, node, $event) { return node.setIsActive(false); },
    SELECT: function (tree, node, $event) { return node.setIsSelected(true); },
    DESELECT: function (tree, node, $event) { return node.setIsSelected(false); },
    FOCUS: function (tree, node, $event) { return node.focus(); },
    TOGGLE_EXPANDED: function (tree, node, $event) { return node.hasChildren && node.toggleExpanded(); },
    EXPAND: function (tree, node, $event) { return node.expand(); },
    COLLAPSE: function (tree, node, $event) { return node.collapse(); },
    DRILL_DOWN: function (tree, node, $event) { return tree.focusDrillDown(); },
    DRILL_UP: function (tree, node, $event) { return tree.focusDrillUp(); },
    NEXT_NODE: function (tree, node, $event) { return tree.focusNextNode(); },
    PREVIOUS_NODE: function (tree, node, $event) { return tree.focusPreviousNode(); },
    MOVE_NODE: function (tree, node, $event, _a) {
        var from = _a.from, to = _a.to;
        // default action assumes from = node, to = {parent, index}
        if ($event.ctrlKey) {
            tree.copyNode(from, to);
        }
        else {
            tree.moveNode(from, to);
        }
    }
};
var defaultActionMapping = {
    mouse: {
        click: TREE_ACTIONS.TOGGLE_ACTIVE,
        dblClick: null,
        contextMenu: null,
        expanderClick: TREE_ACTIONS.TOGGLE_EXPANDED,
        checkboxClick: TREE_ACTIONS.TOGGLE_SELECTED,
        drop: TREE_ACTIONS.MOVE_NODE
    },
    keys: (tree_options_model__a = {},
        tree_options_model__a[KEYS.RIGHT] = TREE_ACTIONS.DRILL_DOWN,
        tree_options_model__a[KEYS.LEFT] = TREE_ACTIONS.DRILL_UP,
        tree_options_model__a[KEYS.DOWN] = TREE_ACTIONS.NEXT_NODE,
        tree_options_model__a[KEYS.UP] = TREE_ACTIONS.PREVIOUS_NODE,
        tree_options_model__a[KEYS.SPACE] = TREE_ACTIONS.TOGGLE_ACTIVE,
        tree_options_model__a[KEYS.ENTER] = TREE_ACTIONS.TOGGLE_ACTIVE,
        tree_options_model__a)
};
var tree_options_model_TreeOptions = /*@__PURE__*/ (function () {
    function TreeOptions(options) {
        if (options === void 0) {
            options = {};
        }
        this.options = options;
        this.actionMapping = defaultsDeep_default()({}, this.options.actionMapping, defaultActionMapping);
        if (options.rtl) {
            this.actionMapping.keys[KEYS.RIGHT] = get_default()(options, ['actionMapping', 'keys', KEYS.RIGHT]) || TREE_ACTIONS.DRILL_UP;
            this.actionMapping.keys[KEYS.LEFT] = get_default()(options, ['actionMapping', 'keys', KEYS.LEFT]) || TREE_ACTIONS.DRILL_DOWN;
        }
    }
    Object.defineProperty(TreeOptions.prototype, "hasChildrenField", {
        get: function () { return this.options.hasChildrenField || 'hasChildren'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "childrenField", {
        get: function () { return this.options.childrenField || 'children'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "displayField", {
        get: function () { return this.options.displayField || 'name'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "idField", {
        get: function () { return this.options.idField || 'id'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "isExpandedField", {
        get: function () { return this.options.isExpandedField || 'isExpanded'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "getChildren", {
        get: function () { return this.options.getChildren; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "levelPadding", {
        get: function () { return this.options.levelPadding || 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "useVirtualScroll", {
        get: function () { return this.options.useVirtualScroll; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "animateExpand", {
        get: function () { return this.options.animateExpand; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "animateSpeed", {
        get: function () { return this.options.animateSpeed || 1; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "animateAcceleration", {
        get: function () { return this.options.animateAcceleration || 1.2; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "scrollOnActivate", {
        get: function () { return this.options.scrollOnActivate === undefined ? true : this.options.scrollOnActivate; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "rtl", {
        get: function () { return !!this.options.rtl; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "rootId", {
        get: function () { return this.options.rootId; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "useCheckbox", {
        get: function () { return this.options.useCheckbox; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "useTriState", {
        get: function () { return this.options.useTriState === undefined ? true : this.options.useTriState; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeOptions.prototype, "scrollContainer", {
        get: function () { return this.options.scrollContainer; },
        enumerable: true,
        configurable: true
    });
    TreeOptions.prototype.getNodeClone = function (node) {
        if (this.options.getNodeClone) {
            return this.options.getNodeClone(node);
        }
        return omit_default()(Object.assign({}, node.data), ['id']);
    };
    TreeOptions.prototype.allowDrop = function (element, to, $event) {
        if (this.options.allowDrop instanceof Function) {
            return this.options.allowDrop(element, to, $event);
        }
        else {
            return this.options.allowDrop === undefined ? true : this.options.allowDrop;
        }
    };
    TreeOptions.prototype.allowDrag = function (node) {
        if (this.options.allowDrag instanceof Function) {
            return this.options.allowDrag(node);
        }
        else {
            return this.options.allowDrag;
        }
    };
    TreeOptions.prototype.nodeClass = function (node) {
        return this.options.nodeClass ? this.options.nodeClass(node) : '';
    };
    TreeOptions.prototype.nodeHeight = function (node) {
        if (node.data.virtual) {
            return 0;
        }
        var nodeHeight = this.options.nodeHeight || 22;
        if (typeof nodeHeight === 'function') {
            nodeHeight = nodeHeight(node);
        }
        // account for drop slots:
        return nodeHeight + (node.index === 0 ? 2 : 1) * this.dropSlotHeight;
    };
    Object.defineProperty(TreeOptions.prototype, "dropSlotHeight", {
        get: function () {
            return isNumber_default()(this.options.dropSlotHeight) ? this.options.dropSlotHeight : 2;
        },
        enumerable: true,
        configurable: true
    });
    return TreeOptions;
}());

var tree_options_model__a;




// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/constants/events.js
var TREE_EVENTS = {
    toggleExpanded: 'toggleExpanded',
    activate: 'activate',
    deactivate: 'deactivate',
    nodeActivate: 'nodeActivate',
    nodeDeactivate: 'nodeDeactivate',
    select: 'select',
    deselect: 'deselect',
    focus: 'focus',
    blur: 'blur',
    initialized: 'initialized',
    updateData: 'updateData',
    moveNode: 'moveNode',
    copyNode: 'copyNode',
    event: 'event',
    loadNodeChildren: 'loadNodeChildren',
    changeFilter: 'changeFilter',
    stateChange: 'stateChange'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9jb25zdGFudHMvZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxJQUFNLFdBQVcsR0FBRztJQUN6QixjQUFjLEVBQUUsZ0JBQWdCO0lBQ2hDLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLFlBQVksRUFBRSxjQUFjO0lBQzVCLGNBQWMsRUFBRSxnQkFBZ0I7SUFDaEMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsUUFBUSxFQUFFLFVBQVU7SUFDcEIsS0FBSyxFQUFFLE9BQU87SUFDZCxJQUFJLEVBQUUsTUFBTTtJQUNaLFdBQVcsRUFBRSxhQUFhO0lBQzFCLFVBQVUsRUFBRSxZQUFZO0lBQ3hCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLEtBQUssRUFBRSxPQUFPO0lBQ2QsZ0JBQWdCLEVBQUUsa0JBQWtCO0lBQ3BDLFlBQVksRUFBRSxjQUFjO0lBQzVCLFdBQVcsRUFBRSxhQUFhO0NBQzNCLENBQUMiLCJmaWxlIjoiZXZlbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBUUkVFX0VWRU5UUyA9IHtcbiAgdG9nZ2xlRXhwYW5kZWQ6ICd0b2dnbGVFeHBhbmRlZCcsXG4gIGFjdGl2YXRlOiAnYWN0aXZhdGUnLFxuICBkZWFjdGl2YXRlOiAnZGVhY3RpdmF0ZScsXG4gIG5vZGVBY3RpdmF0ZTogJ25vZGVBY3RpdmF0ZScsXG4gIG5vZGVEZWFjdGl2YXRlOiAnbm9kZURlYWN0aXZhdGUnLFxuICBzZWxlY3Q6ICdzZWxlY3QnLFxuICBkZXNlbGVjdDogJ2Rlc2VsZWN0JyxcbiAgZm9jdXM6ICdmb2N1cycsXG4gIGJsdXI6ICdibHVyJyxcbiAgaW5pdGlhbGl6ZWQ6ICdpbml0aWFsaXplZCcsXG4gIHVwZGF0ZURhdGE6ICd1cGRhdGVEYXRhJyxcbiAgbW92ZU5vZGU6ICdtb3ZlTm9kZScsXG4gIGNvcHlOb2RlOiAnY29weU5vZGUnLFxuICBldmVudDogJ2V2ZW50JyxcbiAgbG9hZE5vZGVDaGlsZHJlbjogJ2xvYWROb2RlQ2hpbGRyZW4nLFxuICBjaGFuZ2VGaWx0ZXI6ICdjaGFuZ2VGaWx0ZXInLFxuICBzdGF0ZUNoYW5nZTogJ3N0YXRlQ2hhbmdlJ1xufTtcbiJdfQ==
// EXTERNAL MODULE: ./node_modules/lodash/first.js
var lodash_first = __webpack_require__("y9NZ");
var first_default = /*#__PURE__*/__webpack_require__.n(lodash_first);

// EXTERNAL MODULE: ./node_modules/lodash/last.js
var lodash_last = __webpack_require__("oqL2");
var last_default = /*#__PURE__*/__webpack_require__.n(lodash_last);

// EXTERNAL MODULE: ./node_modules/lodash/some.js
var some = __webpack_require__("mGzp");
var some_default = /*#__PURE__*/__webpack_require__.n(some);

// EXTERNAL MODULE: ./node_modules/lodash/every.js
var lodash_every = __webpack_require__("Lrp7");
var every_default = /*#__PURE__*/__webpack_require__.n(lodash_every);

// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/models/tree-node.model.js








var tree_node_model_TreeNode = /*@__PURE__*/ (function () {
    function TreeNode(data, parent, treeModel, index) {
        var _this = this;
        this.data = data;
        this.parent = parent;
        this.treeModel = treeModel;
        this.position = 0;
        this.allowDrop = function (element, $event) {
            return _this.options.allowDrop(element, { parent: _this, index: 0 }, $event);
        };
        if (this.id === undefined || this.id === null) {
            this.id = uuid();
        } // Make sure there's a unique id without overriding existing ids to work with immutable data structures
        this.index = index;
        if (this.getField('children')) {
            this._initChildren();
        }
        this.autoLoadChildren();
    }
    Object.defineProperty(TreeNode.prototype, "isHidden", {
        get: function () { return this.treeModel.isHidden(this); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeNode.prototype, "isExpanded", {
        get: function () { return this.treeModel.isExpanded(this); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeNode.prototype, "isActive", {
        get: function () { return this.treeModel.isActive(this); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeNode.prototype, "isFocused", {
        get: function () { return this.treeModel.isNodeFocused(this); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeNode.prototype, "isSelected", {
        get: function () {
            if (this.treeModel.options.useTriState) {
                if (this.isLeaf) {
                    return this.treeModel.isSelected(this);
                }
                else {
                    return some_default()(this.children, function (node) { return node.isSelected; });
                }
            }
            else {
                return this.treeModel.isSelected(this);
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeNode.prototype, "isAllSelected", {
        get: function () {
            if (this.treeModel.options.useTriState) {
                if (this.isLeaf) {
                    return this.isSelected;
                }
                else {
                    return every_default()(this.children, function (node) { return node.isAllSelected; });
                }
            }
            else {
                return this.isSelected;
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeNode.prototype, "isPartiallySelected", {
        get: function () {
            return this.isSelected && !this.isAllSelected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "level", {
        get: function () {
            return this.parent ? this.parent.level + 1 : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "path", {
        get: function () {
            return this.parent ? this.parent.path.concat([this.id]) : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "elementRef", {
        get: function () {
            throw "Element Ref is no longer supported since introducing virtual scroll\n\n      You may use a template to obtain a reference to the element";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "originalNode", {
        get: function () { return this._originalNode; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeNode.prototype, "hasChildren", {
        // helper get functions:
        get: function () {
            return !!(this.getField('hasChildren') || (this.children && this.children.length > 0));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "isCollapsed", {
        get: function () { return !this.isExpanded; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "isLeaf", {
        get: function () { return !this.hasChildren; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "isRoot", {
        get: function () { return this.parent.data.virtual; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "realParent", {
        get: function () { return this.isRoot ? null : this.parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "options", {
        // proxy functions:
        get: function () { return this.treeModel.options; },
        enumerable: true,
        configurable: true
    });
    TreeNode.prototype.fireEvent = function (event) { this.treeModel.fireEvent(event); };
    Object.defineProperty(TreeNode.prototype, "displayField", {
        // field accessors:
        get: function () {
            return this.getField('display');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNode.prototype, "id", {
        get: function () {
            return this.getField('id');
        },
        set: function (value) {
            this.setField('id', value);
        },
        enumerable: true,
        configurable: true
    });
    TreeNode.prototype.getField = function (key) {
        return this.data[this.options[key + "Field"]];
    };
    TreeNode.prototype.setField = function (key, value) {
        this.data[this.options[key + "Field"]] = value;
    };
    // traversing:
    TreeNode.prototype._findAdjacentSibling = function (steps, skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        var siblings = this._getParentsChildren(skipHidden);
        var index = siblings.indexOf(this);
        return siblings.length > index + steps ? siblings[index + steps] : null;
    };
    TreeNode.prototype.findNextSibling = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        return this._findAdjacentSibling(+1, skipHidden);
    };
    TreeNode.prototype.findPreviousSibling = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        return this._findAdjacentSibling(-1, skipHidden);
    };
    TreeNode.prototype.getVisibleChildren = function () {
        return this.visibleChildren;
    };
    Object.defineProperty(TreeNode.prototype, "visibleChildren", {
        get: function () {
            return (this.children || []).filter(function (node) { return !node.isHidden; });
        },
        enumerable: true,
        configurable: true
    });
    TreeNode.prototype.getFirstChild = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        var children = skipHidden ? this.visibleChildren : this.children;
        return first_default()(children || []);
    };
    TreeNode.prototype.getLastChild = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        var children = skipHidden ? this.visibleChildren : this.children;
        return last_default()(children || []);
    };
    TreeNode.prototype.findNextNode = function (goInside, skipHidden) {
        if (goInside === void 0) {
            goInside = true;
        }
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        return goInside && this.isExpanded && this.getFirstChild(skipHidden) ||
            this.findNextSibling(skipHidden) ||
            this.parent && this.parent.findNextNode(false, skipHidden);
    };
    TreeNode.prototype.findPreviousNode = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        var previousSibling = this.findPreviousSibling(skipHidden);
        if (!previousSibling) {
            return this.realParent;
        }
        return previousSibling._getLastOpenDescendant(skipHidden);
    };
    TreeNode.prototype._getLastOpenDescendant = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        var lastChild = this.getLastChild(skipHidden);
        return (this.isCollapsed || !lastChild)
            ? this
            : lastChild._getLastOpenDescendant(skipHidden);
    };
    TreeNode.prototype._getParentsChildren = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        var children = this.parent &&
            (skipHidden ? this.parent.getVisibleChildren() : this.parent.children);
        return children || [];
    };
    TreeNode.prototype.getIndexInParent = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        return this._getParentsChildren(skipHidden).indexOf(this);
    };
    TreeNode.prototype.isDescendantOf = function (node) {
        if (this === node)
            return true;
        else
            return this.parent && this.parent.isDescendantOf(node);
    };
    TreeNode.prototype.getNodePadding = function () {
        return this.options.levelPadding * (this.level - 1) + 'px';
    };
    TreeNode.prototype.getClass = function () {
        return [this.options.nodeClass(this), "tree-node-level-" + this.level].join(' ');
    };
    TreeNode.prototype.onDrop = function ($event) {
        this.mouseAction('drop', $event.event, {
            from: $event.element,
            to: { parent: this, index: 0, dropOnNode: true }
        });
    };
    TreeNode.prototype.allowDrag = function () {
        return this.options.allowDrag(this);
    };
    // helper methods:
    TreeNode.prototype.loadNodeChildren = function () {
        var _this = this;
        if (!this.options.getChildren) {
            return Promise.resolve(); // Not getChildren method - for using redux
        }
        return Promise.resolve(this.options.getChildren(this))
            .then(function (children) {
            if (children) {
                _this.setField('children', children);
                _this._initChildren();
                _this.children.forEach(function (child) {
                    if (child.getField('isExpanded') && child.hasChildren) {
                        child.expand();
                    }
                });
            }
        }).then(function () {
            _this.fireEvent({
                eventName: TREE_EVENTS.loadNodeChildren,
                node: _this
            });
        });
    };
    TreeNode.prototype.expand = function () {
        if (!this.isExpanded) {
            this.toggleExpanded();
        }
        return this;
    };
    TreeNode.prototype.collapse = function () {
        if (this.isExpanded) {
            this.toggleExpanded();
        }
        return this;
    };
    TreeNode.prototype.doForAll = function (fn) {
        var _this = this;
        Promise.resolve(fn(this)).then(function () {
            if (_this.children) {
                _this.children.forEach(function (child) { return child.doForAll(fn); });
            }
        });
    };
    TreeNode.prototype.expandAll = function () {
        this.doForAll(function (node) { return node.expand(); });
    };
    TreeNode.prototype.collapseAll = function () {
        this.doForAll(function (node) { return node.collapse(); });
    };
    TreeNode.prototype.ensureVisible = function () {
        if (this.realParent) {
            this.realParent.expand();
            this.realParent.ensureVisible();
        }
        return this;
    };
    TreeNode.prototype.toggleExpanded = function () {
        this.setIsExpanded(!this.isExpanded);
        return this;
    };
    TreeNode.prototype.setIsExpanded = function (value) {
        if (this.hasChildren) {
            this.treeModel.setExpandedNode(this, value);
        }
        return this;
    };
    ;
    TreeNode.prototype.autoLoadChildren = function () {
        var _this = this;
        this.handler =
            Object(mobx_module["h" /* reaction */])(function () { return _this.isExpanded; }, function (isExpanded) {
                if (!_this.children && _this.hasChildren && isExpanded) {
                    _this.loadNodeChildren();
                }
            }, { fireImmediately: true });
    };
    TreeNode.prototype.dispose = function () {
        if (this.children) {
            this.children.forEach(function (child) { return child.dispose(); });
        }
        if (this.handler) {
            this.handler();
        }
    };
    TreeNode.prototype.setIsActive = function (value, multi) {
        if (multi === void 0) {
            multi = false;
        }
        this.treeModel.setActiveNode(this, value, multi);
        if (value) {
            this.focus(this.options.scrollOnActivate);
        }
        return this;
    };
    TreeNode.prototype.setIsSelected = function (value) {
        if (this.treeModel.options.useTriState) {
            if (this.isLeaf) {
                this.treeModel.setSelectedNode(this, value);
            }
            else {
                this.visibleChildren.forEach(function (child) { return child.setIsSelected(value); });
            }
        }
        else {
            this.treeModel.setSelectedNode(this, value);
        }
        return this;
    };
    TreeNode.prototype.toggleSelected = function () {
        this.setIsSelected(!this.isSelected);
        return this;
    };
    TreeNode.prototype.toggleActivated = function (multi) {
        if (multi === void 0) {
            multi = false;
        }
        this.setIsActive(!this.isActive, multi);
        return this;
    };
    TreeNode.prototype.setActiveAndVisible = function (multi) {
        if (multi === void 0) {
            multi = false;
        }
        this.setIsActive(true, multi)
            .ensureVisible();
        setTimeout(this.scrollIntoView.bind(this));
        return this;
    };
    TreeNode.prototype.scrollIntoView = function (force) {
        if (force === void 0) {
            force = false;
        }
        this.treeModel.virtualScroll.scrollIntoView(this, force);
    };
    TreeNode.prototype.focus = function (scroll) {
        if (scroll === void 0) {
            scroll = true;
        }
        var previousNode = this.treeModel.getFocusedNode();
        this.treeModel.setFocusedNode(this);
        if (scroll) {
            this.scrollIntoView();
        }
        if (previousNode) {
            this.fireEvent({ eventName: TREE_EVENTS.blur, node: previousNode });
        }
        this.fireEvent({ eventName: TREE_EVENTS.focus, node: this });
        return this;
    };
    TreeNode.prototype.blur = function () {
        var previousNode = this.treeModel.getFocusedNode();
        this.treeModel.setFocusedNode(null);
        if (previousNode) {
            this.fireEvent({ eventName: TREE_EVENTS.blur, node: this });
        }
        return this;
    };
    TreeNode.prototype.setIsHidden = function (value) {
        this.treeModel.setIsHidden(this, value);
    };
    TreeNode.prototype.hide = function () {
        this.setIsHidden(true);
    };
    TreeNode.prototype.show = function () {
        this.setIsHidden(false);
    };
    TreeNode.prototype.mouseAction = function (actionName, $event, data) {
        if (data === void 0) {
            data = null;
        }
        this.treeModel.setFocus(true);
        var actionMapping = this.options.actionMapping.mouse;
        var action = actionMapping[actionName];
        if (action) {
            action(this.treeModel, this, $event, data);
        }
    };
    TreeNode.prototype.getSelfHeight = function () {
        return this.options.nodeHeight(this);
    };
    TreeNode.prototype._initChildren = function () {
        var _this = this;
        this.children = this.getField('children')
            .map(function (c, index) { return new TreeNode(c, _this, _this.treeModel, index); });
    };
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "isHidden", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "isExpanded", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "isActive", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "isFocused", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "isSelected", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "isAllSelected", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "isPartiallySelected", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Array)
    ], TreeNode.prototype, "children", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Number)
    ], TreeNode.prototype, "index", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeNode.prototype, "position", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Number)
    ], TreeNode.prototype, "height", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Number),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "level", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Array),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "path", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNode.prototype, "visibleChildren", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeNode.prototype, "setIsSelected", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeNode.prototype, "_initChildren", null);
    return TreeNode;
}());

function uuid() {
    return Math.floor(Math.random() * 10000000000000);
}




// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__("C2y9");
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);

// EXTERNAL MODULE: ./node_modules/lodash/find.js
var lodash_find = __webpack_require__("kbi+");
var find_default = /*#__PURE__*/__webpack_require__.n(lodash_find);

// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var lodash_isString = __webpack_require__("JDN0");
var isString_default = /*#__PURE__*/__webpack_require__.n(lodash_isString);

// EXTERNAL MODULE: ./node_modules/lodash/isFunction.js
var lodash_isFunction = __webpack_require__("gGqR");
var isFunction_default = /*#__PURE__*/__webpack_require__.n(lodash_isFunction);

// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/models/tree.model.js













var tree_model_TreeModel = /*@__PURE__*/ (function () {
    function TreeModel() {
        this.options = new tree_options_model_TreeOptions();
        this.eventNames = Object.keys(TREE_EVENTS);
        this.expandedNodeIds = {};
        this.selectedLeafNodeIds = {};
        this.activeNodeIds = {};
        this.hiddenNodeIds = {};
        this.focusedNodeId = null;
        this.firstUpdate = true;
    }
    // events
    TreeModel.prototype.fireEvent = function (event) {
        event.treeModel = this;
        this.events[event.eventName].emit(event);
        this.events.event.emit(event);
    };
    TreeModel.prototype.subscribe = function (eventName, fn) {
        this.events[eventName].subscribe(fn);
    };
    // getters
    TreeModel.prototype.getFocusedNode = function () {
        return this.focusedNode;
    };
    TreeModel.prototype.getActiveNode = function () {
        return this.activeNodes[0];
    };
    TreeModel.prototype.getActiveNodes = function () {
        return this.activeNodes;
    };
    TreeModel.prototype.getVisibleRoots = function () {
        return this.virtualRoot.visibleChildren;
    };
    TreeModel.prototype.getFirstRoot = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        return first_default()(skipHidden ? this.getVisibleRoots() : this.roots);
    };
    TreeModel.prototype.getLastRoot = function (skipHidden) {
        if (skipHidden === void 0) {
            skipHidden = false;
        }
        return last_default()(skipHidden ? this.getVisibleRoots() : this.roots);
    };
    Object.defineProperty(TreeModel.prototype, "isFocused", {
        get: function () {
            return TreeModel.focusedTree === this;
        },
        enumerable: true,
        configurable: true
    });
    TreeModel.prototype.isNodeFocused = function (node) {
        return this.focusedNode === node;
    };
    TreeModel.prototype.isEmptyTree = function () {
        return this.roots && this.roots.length === 0;
    };
    Object.defineProperty(TreeModel.prototype, "focusedNode", {
        get: function () {
            return this.focusedNodeId ? this.getNodeById(this.focusedNodeId) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeModel.prototype, "expandedNodes", {
        get: function () {
            var _this = this;
            var nodes = Object.keys(this.expandedNodeIds)
                .filter(function (id) { return _this.expandedNodeIds[id]; })
                .map(function (id) { return _this.getNodeById(id); });
            return compact_default()(nodes);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeModel.prototype, "activeNodes", {
        get: function () {
            var _this = this;
            var nodes = Object.keys(this.activeNodeIds)
                .filter(function (id) { return _this.activeNodeIds[id]; })
                .map(function (id) { return _this.getNodeById(id); });
            return compact_default()(nodes);
        },
        enumerable: true,
        configurable: true
    });
    // locating nodes
    TreeModel.prototype.getNodeByPath = function (path, startNode) {
        if (startNode === void 0) {
            startNode = null;
        }
        if (!path)
            return null;
        startNode = startNode || this.virtualRoot;
        if (path.length === 0)
            return startNode;
        if (!startNode.children)
            return null;
        var childId = path.shift();
        var childNode = find_default()(startNode.children, { id: childId });
        if (!childNode)
            return null;
        return this.getNodeByPath(path, childNode);
    };
    TreeModel.prototype.getNodeById = function (id) {
        var idStr = id.toString();
        return this.getNodeBy(function (node) { return node.id.toString() === idStr; });
    };
    TreeModel.prototype.getNodeBy = function (predicate, startNode) {
        if (startNode === void 0) {
            startNode = null;
        }
        startNode = startNode || this.virtualRoot;
        if (!startNode.children)
            return null;
        var found = find_default()(startNode.children, predicate);
        if (found) {
            return found;
        }
        else {
            for (var _i = 0, _a = startNode.children; _i < _a.length; _i++) {
                var child = _a[_i];
                var foundInChildren = this.getNodeBy(predicate, child);
                if (foundInChildren)
                    return foundInChildren;
            }
        }
    };
    TreeModel.prototype.isExpanded = function (node) {
        return this.expandedNodeIds[node.id];
    };
    TreeModel.prototype.isHidden = function (node) {
        return this.hiddenNodeIds[node.id];
    };
    TreeModel.prototype.isActive = function (node) {
        return this.activeNodeIds[node.id];
    };
    TreeModel.prototype.isSelected = function (node) {
        return this.selectedLeafNodeIds[node.id];
    };
    TreeModel.prototype.ngOnDestroy = function () {
        this.dispose();
    };
    TreeModel.prototype.dispose = function () {
        // Dispose reactions of the replaced nodes
        if (this.virtualRoot) {
            this.virtualRoot.dispose();
        }
    };
    // actions
    TreeModel.prototype.setData = function (_a) {
        var nodes = _a.nodes, _b = _a.options, options = _b === void 0 ? null : _b, _c = _a.events, events = _c === void 0 ? null : _c;
        if (options) {
            this.options = new tree_options_model_TreeOptions(options);
        }
        if (events) {
            this.events = events;
        }
        if (nodes) {
            this.nodes = nodes;
        }
        this.update();
    };
    TreeModel.prototype.update = function () {
        // Rebuild tree:
        var virtualRootConfig = (_a = {
            id: this.options.rootId,
            virtual: true
        },
            _a[this.options.childrenField] = this.nodes,
            _a);
        this.dispose();
        this.virtualRoot = new tree_node_model_TreeNode(virtualRootConfig, null, this, 0);
        this.roots = this.virtualRoot.children;
        // Fire event:
        if (this.firstUpdate) {
            if (this.roots) {
                this.firstUpdate = false;
                this._calculateExpandedNodes();
            }
        }
        else {
            this.fireEvent({ eventName: TREE_EVENTS.updateData });
        }
        var _a;
    };
    TreeModel.prototype.setFocusedNode = function (node) {
        this.focusedNodeId = node ? node.id : null;
    };
    TreeModel.prototype.setFocus = function (value) {
        TreeModel.focusedTree = value ? this : null;
    };
    TreeModel.prototype.doForAll = function (fn) {
        this.roots.forEach(function (root) { return root.doForAll(fn); });
    };
    TreeModel.prototype.focusNextNode = function () {
        var previousNode = this.getFocusedNode();
        var nextNode = previousNode ? previousNode.findNextNode(true, true) : this.getFirstRoot(true);
        if (nextNode)
            nextNode.focus();
    };
    TreeModel.prototype.focusPreviousNode = function () {
        var previousNode = this.getFocusedNode();
        var nextNode = previousNode ? previousNode.findPreviousNode(true) : this.getLastRoot(true);
        if (nextNode)
            nextNode.focus();
    };
    TreeModel.prototype.focusDrillDown = function () {
        var previousNode = this.getFocusedNode();
        if (previousNode && previousNode.isCollapsed && previousNode.hasChildren) {
            previousNode.toggleExpanded();
        }
        else {
            var nextNode = previousNode ? previousNode.getFirstChild(true) : this.getFirstRoot(true);
            if (nextNode)
                nextNode.focus();
        }
    };
    TreeModel.prototype.focusDrillUp = function () {
        var previousNode = this.getFocusedNode();
        if (!previousNode)
            return;
        if (previousNode.isExpanded) {
            previousNode.toggleExpanded();
        }
        else {
            var nextNode = previousNode.realParent;
            if (nextNode)
                nextNode.focus();
        }
    };
    TreeModel.prototype.setActiveNode = function (node, value, multi) {
        if (multi === void 0) {
            multi = false;
        }
        if (multi) {
            this._setActiveNodeMulti(node, value);
        }
        else {
            this._setActiveNodeSingle(node, value);
        }
        if (value) {
            node.focus();
            this.fireEvent({ eventName: TREE_EVENTS.activate, node: node });
            this.fireEvent({ eventName: TREE_EVENTS.nodeActivate, node: node }); // For IE11
        }
        else {
            this.fireEvent({ eventName: TREE_EVENTS.deactivate, node: node });
            this.fireEvent({ eventName: TREE_EVENTS.nodeDeactivate, node: node }); // For IE11
        }
    };
    TreeModel.prototype.setSelectedNode = function (node, value) {
        this.selectedLeafNodeIds = Object.assign({}, this.selectedLeafNodeIds, (_a = {}, _a[node.id] = value, _a));
        if (value) {
            node.focus();
            this.fireEvent({ eventName: TREE_EVENTS.select, node: node });
        }
        else {
            this.fireEvent({ eventName: TREE_EVENTS.deselect, node: node });
        }
        var _a;
    };
    TreeModel.prototype.setExpandedNode = function (node, value) {
        this.expandedNodeIds = Object.assign({}, this.expandedNodeIds, (_a = {}, _a[node.id] = value, _a));
        this.fireEvent({ eventName: TREE_EVENTS.toggleExpanded, node: node, isExpanded: value });
        var _a;
    };
    TreeModel.prototype.expandAll = function () {
        this.roots.forEach(function (root) { return root.expandAll(); });
    };
    TreeModel.prototype.collapseAll = function () {
        this.roots.forEach(function (root) { return root.collapseAll(); });
    };
    TreeModel.prototype.setIsHidden = function (node, value) {
        this.hiddenNodeIds = Object.assign({}, this.hiddenNodeIds, (_a = {}, _a[node.id] = value, _a));
        var _a;
    };
    TreeModel.prototype.setHiddenNodeIds = function (nodeIds) {
        this.hiddenNodeIds = nodeIds.reduce(function (hiddenNodeIds, id) {
            return Object.assign(hiddenNodeIds, (_a = {},
                _a[id] = true,
                _a));
            var _a;
        }, {});
    };
    TreeModel.prototype.performKeyAction = function (node, $event) {
        var action = this.options.actionMapping.keys[$event.keyCode];
        if (action) {
            $event.preventDefault();
            action(this, node, $event);
            return true;
        }
        else {
            return false;
        }
    };
    TreeModel.prototype.filterNodes = function (filter, autoShow) {
        var _this = this;
        if (autoShow === void 0) {
            autoShow = true;
        }
        var filterFn;
        if (!filter) {
            return this.clearFilter();
        }
        // support function and string filter
        if (isString_default()(filter)) {
            filterFn = function (node) { return node.displayField.toLowerCase().indexOf(filter.toLowerCase()) !== -1; };
        }
        else if (isFunction_default()(filter)) {
            filterFn = filter;
        }
        else {
            console.error('Don\'t know what to do with filter', filter);
            console.error('Should be either a string or function');
            return;
        }
        var ids = {};
        this.roots.forEach(function (node) { return _this._filterNode(ids, node, filterFn, autoShow); });
        this.hiddenNodeIds = ids;
        this.fireEvent({ eventName: TREE_EVENTS.changeFilter });
    };
    TreeModel.prototype.clearFilter = function () {
        this.hiddenNodeIds = {};
        this.fireEvent({ eventName: TREE_EVENTS.changeFilter });
    };
    TreeModel.prototype.moveNode = function (node, to) {
        var fromIndex = node.getIndexInParent();
        var fromParent = node.parent;
        if (!this._canMoveNode(node, fromIndex, to))
            return;
        var fromChildren = fromParent.getField('children');
        // If node doesn't have children - create children array
        if (!to.parent.getField('children')) {
            to.parent.setField('children', []);
        }
        var toChildren = to.parent.getField('children');
        var originalNode = fromChildren.splice(fromIndex, 1)[0];
        // Compensate for index if already removed from parent:
        var toIndex = (fromParent === to.parent && to.index > fromIndex) ? to.index - 1 : to.index;
        toChildren.splice(toIndex, 0, originalNode);
        fromParent.treeModel.update();
        if (to.parent.treeModel !== fromParent.treeModel) {
            to.parent.treeModel.update();
        }
        this.fireEvent({ eventName: TREE_EVENTS.moveNode, node: originalNode, to: { parent: to.parent.data, index: toIndex } });
    };
    TreeModel.prototype.copyNode = function (node, to) {
        var fromIndex = node.getIndexInParent();
        if (!this._canMoveNode(node, fromIndex, to))
            return;
        // If node doesn't have children - create children array
        if (!to.parent.getField('children')) {
            to.parent.setField('children', []);
        }
        var toChildren = to.parent.getField('children');
        var nodeCopy = this.options.getNodeClone(node);
        toChildren.splice(to.index, 0, nodeCopy);
        node.treeModel.update();
        if (to.parent.treeModel !== node.treeModel) {
            to.parent.treeModel.update();
        }
        this.fireEvent({ eventName: TREE_EVENTS.copyNode, node: nodeCopy, to: { parent: to.parent.data, index: to.index } });
    };
    TreeModel.prototype.getState = function () {
        return {
            expandedNodeIds: this.expandedNodeIds,
            selectedLeafNodeIds: this.selectedLeafNodeIds,
            activeNodeIds: this.activeNodeIds,
            hiddenNodeIds: this.hiddenNodeIds,
            focusedNodeId: this.focusedNodeId
        };
    };
    TreeModel.prototype.setState = function (state) {
        if (!state)
            return;
        Object.assign(this, {
            expandedNodeIds: state.expandedNodeIds || {},
            selectedLeafNodeIds: state.selectedLeafNodeIds || {},
            activeNodeIds: state.activeNodeIds || {},
            hiddenNodeIds: state.hiddenNodeIds || {},
            focusedNodeId: state.focusedNodeId
        });
    };
    TreeModel.prototype.subscribeToState = function (fn) {
        var _this = this;
        Object(mobx_module["b" /* autorun */])(function () { return fn(_this.getState()); });
    };
    // private methods
    TreeModel.prototype._canMoveNode = function (node, fromIndex, to) {
        // same node:
        if (node.parent === to.parent && fromIndex === to.index) {
            return false;
        }
        return !to.parent.isDescendantOf(node);
    };
    TreeModel.prototype._filterNode = function (ids, node, filterFn, autoShow) {
        var _this = this;
        // if node passes function then it's visible
        var isVisible = filterFn(node);
        if (node.children) {
            // if one of node's children passes filter then this node is also visible
            node.children.forEach(function (child) {
                if (_this._filterNode(ids, child, filterFn, autoShow)) {
                    isVisible = true;
                }
            });
        }
        // mark node as hidden
        if (!isVisible) {
            ids[node.id] = true;
        }
        // auto expand parents to make sure the filtered nodes are visible
        if (autoShow && isVisible) {
            node.ensureVisible();
        }
        return isVisible;
    };
    TreeModel.prototype._calculateExpandedNodes = function (startNode) {
        var _this = this;
        if (startNode === void 0) {
            startNode = null;
        }
        startNode = startNode || this.virtualRoot;
        if (startNode.data[this.options.isExpandedField]) {
            this.expandedNodeIds = Object.assign({}, this.expandedNodeIds, (_a = {}, _a[startNode.id] = true, _a));
        }
        if (startNode.children) {
            startNode.children.forEach(function (child) { return _this._calculateExpandedNodes(child); });
        }
        var _a;
    };
    TreeModel.prototype._setActiveNodeSingle = function (node, value) {
        var _this = this;
        // Deactivate all other nodes:
        this.activeNodes
            .filter(function (activeNode) { return activeNode !== node; })
            .forEach(function (activeNode) {
            _this.fireEvent({ eventName: TREE_EVENTS.deactivate, node: activeNode });
            _this.fireEvent({ eventName: TREE_EVENTS.nodeDeactivate, node: activeNode }); // For IE11
        });
        if (value) {
            this.activeNodeIds = (_a = {}, _a[node.id] = true, _a);
        }
        else {
            this.activeNodeIds = {};
        }
        var _a;
    };
    TreeModel.prototype._setActiveNodeMulti = function (node, value) {
        this.activeNodeIds = Object.assign({}, this.activeNodeIds, (_a = {}, _a[node.id] = value, _a));
        var _a;
    };
    TreeModel.focusedTree = null;
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Array)
    ], TreeModel.prototype, "roots", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeModel.prototype, "expandedNodeIds", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeModel.prototype, "selectedLeafNodeIds", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeModel.prototype, "activeNodeIds", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeModel.prototype, "hiddenNodeIds", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeModel.prototype, "focusedNodeId", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", tree_node_model_TreeNode)
    ], TreeModel.prototype, "virtualRoot", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeModel.prototype, "focusedNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeModel.prototype, "expandedNodes", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeModel.prototype, "activeNodes", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setData", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "update", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setFocusedNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setFocus", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "doForAll", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "focusNextNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "focusPreviousNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "focusDrillDown", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "focusDrillUp", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object, Object, Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setActiveNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object, Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setSelectedNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object, Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setExpandedNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "expandAll", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "collapseAll", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object, Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setIsHidden", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setHiddenNodeIds", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object, Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "filterNodes", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "clearFilter", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object, Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "moveNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object, Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "copyNode", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeModel.prototype, "setState", null);
    return TreeModel;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/models/tree-virtual-scroll.model.js






var Y_OFFSET = 500; // Extra pixels outside the viewport, in each direction, to render nodes in
var Y_EPSILON = 150; // Minimum pixel change required to recalculate the rendered nodes
var tree_virtual_scroll_model_TreeVirtualScroll = /*@__PURE__*/ (function () {
    function TreeVirtualScroll(treeModel) {
        var _this = this;
        this.treeModel = treeModel;
        this.yBlocks = 0;
        this.x = 0;
        this.viewportHeight = null;
        this.viewport = null;
        treeModel.virtualScroll = this;
        this._dispose = [Object(mobx_module["b" /* autorun */])(function () { return _this.fixScroll(); })];
    }
    Object.defineProperty(TreeVirtualScroll.prototype, "y", {
        get: function () {
            return this.yBlocks * Y_EPSILON;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeVirtualScroll.prototype, "totalHeight", {
        get: function () {
            return this.treeModel.virtualRoot ? this.treeModel.virtualRoot.height : 0;
        },
        enumerable: true,
        configurable: true
    });
    TreeVirtualScroll.prototype.fireEvent = function (event) {
        this.treeModel.fireEvent(event);
    };
    TreeVirtualScroll.prototype.init = function () {
        var _this = this;
        var fn = this.recalcPositions.bind(this);
        fn();
        this._dispose = this._dispose.concat([
            Object(mobx_module["h" /* reaction */])(function () { return _this.treeModel.roots; }, fn),
            Object(mobx_module["h" /* reaction */])(function () { return _this.treeModel.expandedNodeIds; }, fn),
            Object(mobx_module["h" /* reaction */])(function () { return _this.treeModel.hiddenNodeIds; }, fn)
        ]);
        this.treeModel.subscribe(TREE_EVENTS.loadNodeChildren, fn);
    };
    TreeVirtualScroll.prototype.isEnabled = function () {
        return this.treeModel.options.useVirtualScroll;
    };
    TreeVirtualScroll.prototype._setYBlocks = function (value) {
        this.yBlocks = value;
    };
    TreeVirtualScroll.prototype.recalcPositions = function () {
        this.treeModel.virtualRoot.height = this._getPositionAfter(this.treeModel.getVisibleRoots(), 0);
    };
    TreeVirtualScroll.prototype._getPositionAfter = function (nodes, startPos) {
        var _this = this;
        var position = startPos;
        nodes.forEach(function (node) {
            node.position = position;
            position = _this._getPositionAfterNode(node, position);
        });
        return position;
    };
    TreeVirtualScroll.prototype._getPositionAfterNode = function (node, startPos) {
        var position = node.getSelfHeight() + startPos;
        if (node.children && node.isExpanded) {
            position = this._getPositionAfter(node.visibleChildren, position);
        }
        node.height = position - startPos;
        return position;
    };
    TreeVirtualScroll.prototype.clear = function () {
        this._dispose.forEach(function (d) { return d(); });
    };
    TreeVirtualScroll.prototype.setViewport = function (viewport) {
        Object.assign(this, {
            viewport: viewport,
            x: viewport.scrollLeft,
            yBlocks: Math.round(viewport.scrollTop / Y_EPSILON),
            viewportHeight: viewport.getBoundingClientRect ? viewport.getBoundingClientRect().height : 0
        });
    };
    TreeVirtualScroll.prototype.scrollIntoView = function (node, force, scrollToMiddle) {
        if (scrollToMiddle === void 0) {
            scrollToMiddle = true;
        }
        if (node.options.scrollContainer) {
            var scrollContainer = node.options.scrollContainer;
            var scrollContainerHeight = scrollContainer.getBoundingClientRect().height;
            var scrollContainerTop = scrollContainer.getBoundingClientRect().top;
            var nodeTop = this.viewport.getBoundingClientRect().top + node.position - scrollContainerTop;
            if (force || // force scroll to node
                nodeTop < scrollContainer.scrollTop || // node is above scroll container
                nodeTop + node.getSelfHeight() > scrollContainer.scrollTop + scrollContainerHeight) {
                scrollContainer.scrollTop = scrollToMiddle ?
                    nodeTop - scrollContainerHeight / 2 : // scroll to middle
                    nodeTop; // scroll to start
            }
        }
        else {
            if (force || // force scroll to node
                node.position < this.y || // node is above viewport
                node.position + node.getSelfHeight() > this.y + this.viewportHeight) {
                if (this.viewport) {
                    this.viewport.scrollTop = scrollToMiddle ?
                        node.position - this.viewportHeight / 2 : // scroll to middle
                        node.position; // scroll to start
                    this._setYBlocks(Math.floor(this.viewport.scrollTop / Y_EPSILON));
                }
            }
        }
    };
    TreeVirtualScroll.prototype.getViewportNodes = function (nodes) {
        var _this = this;
        if (!nodes)
            return [];
        var visibleNodes = nodes.filter(function (node) { return !node.isHidden; });
        if (!this.isEnabled())
            return visibleNodes;
        if (!this.viewportHeight || !visibleNodes.length)
            return [];
        // Search for first node in the viewport using binary search
        // Look for first node that starts after the beginning of the viewport (with buffer)
        // Or that ends after the beginning of the viewport
        var firstIndex = binarySearch(visibleNodes, function (node) {
            return (node.position + Y_OFFSET > _this.y) ||
                (node.position + node.height > _this.y);
        });
        // Search for last node in the viewport using binary search
        // Look for first node that starts after the end of the viewport (with buffer)
        var lastIndex = binarySearch(visibleNodes, function (node) {
            return node.position - Y_OFFSET > _this.y + _this.viewportHeight;
        }, firstIndex);
        var viewportNodes = [];
        for (var i = firstIndex; i <= lastIndex; i++) {
            viewportNodes.push(visibleNodes[i]);
        }
        return viewportNodes;
    };
    TreeVirtualScroll.prototype.fixScroll = function () {
        var maxY = Math.max(0, this.totalHeight - this.viewportHeight);
        if (this.y < 0)
            this._setYBlocks(0);
        if (this.y > maxY)
            this._setYBlocks(maxY / Y_EPSILON);
    };
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeVirtualScroll.prototype, "yBlocks", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeVirtualScroll.prototype, "x", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["g" /* observable */],
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeVirtualScroll.prototype, "viewportHeight", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeVirtualScroll.prototype, "y", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["c" /* computed */],
        Object(tslib_es6["__metadata"])("design:type", Object),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeVirtualScroll.prototype, "totalHeight", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeVirtualScroll.prototype, "_setYBlocks", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", []),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeVirtualScroll.prototype, "recalcPositions", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeVirtualScroll.prototype, "setViewport", null);
    Object(tslib_es6["__decorate"])([
        mobx_module["a" /* action */],
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object, Object, Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeVirtualScroll.prototype, "scrollIntoView", null);
    return TreeVirtualScroll;
}());

function binarySearch(nodes, condition, firstIndex) {
    if (firstIndex === void 0) {
        firstIndex = 0;
    }
    var index = firstIndex;
    var toIndex = nodes.length - 1;
    while (index !== toIndex) {
        var midIndex = Math.floor((index + toIndex) / 2);
        if (condition(nodes[midIndex])) {
            toIndex = midIndex;
        }
        else {
            if (index === midIndex)
                index = toIndex;
            else
                index = midIndex;
        }
    }
    return index;
}




// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/loading.component.js

var LoadingComponent = /*@__PURE__*/ (function () {
    function LoadingComponent() {
    }
    return LoadingComponent;
}());





// EXTERNAL MODULE: ./node_modules/lodash/includes.js
var includes = __webpack_require__("q+Dy");
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);

// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__("w9Mt");
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree.component.js





var tree_component_TreeComponent = /*@__PURE__*/ (function () {
    function TreeComponent(treeModel, treeDraggedElement, renderer) {
        var _this = this;
        this.treeModel = treeModel;
        this.treeDraggedElement = treeDraggedElement;
        this.renderer = renderer;
        treeModel.eventNames.forEach(function (name) { return _this[name] = new core["EventEmitter"](); });
        treeModel.subscribeToState(function (state) { return _this.stateChange.emit(state); });
    }
    Object.defineProperty(TreeComponent.prototype, "nodes", {
        // Will be handled in ngOnChanges
        set: function (nodes) { },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeComponent.prototype, "options", {
        set: function (options) { },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(TreeComponent.prototype, "focused", {
        set: function (value) {
            this.treeModel.setFocus(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeComponent.prototype, "state", {
        set: function (state) {
            this.treeModel.setState(state);
        },
        enumerable: true,
        configurable: true
    });
    TreeComponent.prototype.onKeydown = function ($event) {
        if (!this.treeModel.isFocused)
            return;
        if (includes_default()(['input', 'textarea'], document.activeElement.tagName.toLowerCase()))
            return;
        var focusedNode = this.treeModel.getFocusedNode();
        this.treeModel.performKeyAction(focusedNode, $event);
    };
    TreeComponent.prototype.onMousedown = function ($event) {
        var insideClick = this.renderer.invokeElementMethod($event.target, 'closest', ['Tree']);
        if (!insideClick) {
            this.treeModel.setFocus(false);
        }
    };
    TreeComponent.prototype.ngOnChanges = function (changes) {
        this.treeModel.setData({
            options: changes.options && changes.options.currentValue,
            nodes: changes.nodes && changes.nodes.currentValue,
            events: pick_default()(this, this.treeModel.eventNames)
        });
    };
    TreeComponent.prototype.sizeChanged = function () {
        this.viewportComponent.setViewport();
    };
    return TreeComponent;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-node.component.js

var TreeNodeComponent = /*@__PURE__*/ (function () {
    function TreeNodeComponent() {
    }
    return TreeNodeComponent;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-node-content.component.js

var TreeNodeContent = /*@__PURE__*/ (function () {
    function TreeNodeContent() {
    }
    return TreeNodeContent;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-node-drop-slot.component.js

var TreeNodeDropSlot = /*@__PURE__*/ (function () {
    function TreeNodeDropSlot() {
    }
    TreeNodeDropSlot.prototype.onDrop = function ($event) {
        this.node.mouseAction('drop', $event.event, {
            from: $event.element,
            to: { parent: this.node, index: this.dropIndex }
        });
    };
    TreeNodeDropSlot.prototype.allowDrop = function (element, $event) {
        return this.node.options.allowDrop(element, { parent: this.node, index: this.dropIndex }, $event);
    };
    return TreeNodeDropSlot;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-node-expander.component.js

var TreeNodeExpanderComponent = /*@__PURE__*/ (function () {
    function TreeNodeExpanderComponent() {
    }
    return TreeNodeExpanderComponent;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-node-children.component.js

var TreeNodeChildrenComponent = /*@__PURE__*/ (function () {
    function TreeNodeChildrenComponent() {
    }
    return TreeNodeChildrenComponent;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-node-collection.component.js





var tree_node_collection_component_TreeNodeCollectionComponent = /*@__PURE__*/ (function () {
    function TreeNodeCollectionComponent() {
        this._dispose = [];
    }
    Object.defineProperty(TreeNodeCollectionComponent.prototype, "nodes", {
        get: function () { return this._nodes; },
        set: function (nodes) { this.setNodes(nodes); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TreeNodeCollectionComponent.prototype, "marginTop", {
        get: function () {
            var firstNode = this.viewportNodes && this.viewportNodes.length && this.viewportNodes[0];
            var relativePosition = firstNode ? firstNode.position - firstNode.parent.position - firstNode.parent.getSelfHeight() : 0;
            return relativePosition + "px";
        },
        enumerable: true,
        configurable: true
    });
    TreeNodeCollectionComponent.prototype.setNodes = function (nodes) {
        this._nodes = nodes;
    };
    TreeNodeCollectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.virtualScroll = this.treeModel.virtualScroll;
        this._dispose = [
            // return node indexes so we can compare structurally,
            Object(mobx_module["h" /* reaction */])(function () {
                return _this.virtualScroll.getViewportNodes(_this.nodes).map(function (n) { return n.index; });
            }, function (nodeIndexes) {
                _this.viewportNodes = nodeIndexes.map(function (i) { return _this.nodes[i]; });
            }, { compareStructural: true, fireImmediately: true }),
            Object(mobx_module["h" /* reaction */])(function () { return _this.nodes; }, function (nodes) {
                _this.viewportNodes = _this.virtualScroll.getViewportNodes(nodes);
            })
        ];
    };
    TreeNodeCollectionComponent.prototype.ngOnDestroy = function () {
        this._dispose.forEach(function (d) { return d(); });
    };
    TreeNodeCollectionComponent.prototype.trackNode = function (index, node) {
        return node.id;
    };
    Object(tslib_es6["__decorate"])([
        mobx_angular_observable,
        Object(tslib_es6["__metadata"])("design:type", Object)
    ], TreeNodeCollectionComponent.prototype, "_nodes", void 0);
    Object(tslib_es6["__decorate"])([
        mobx_angular_observable,
        Object(tslib_es6["__metadata"])("design:type", Array)
    ], TreeNodeCollectionComponent.prototype, "viewportNodes", void 0);
    Object(tslib_es6["__decorate"])([
        computed,
        Object(tslib_es6["__metadata"])("design:type", String),
        Object(tslib_es6["__metadata"])("design:paramtypes", [])
    ], TreeNodeCollectionComponent.prototype, "marginTop", null);
    Object(tslib_es6["__decorate"])([
        mobx_angular_action,
        Object(tslib_es6["__metadata"])("design:type", Function),
        Object(tslib_es6["__metadata"])("design:paramtypes", [Object]),
        Object(tslib_es6["__metadata"])("design:returntype", void 0)
    ], TreeNodeCollectionComponent.prototype, "setNodes", null);
    return TreeNodeCollectionComponent;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-node-wrapper.component.js

var TreeNodeWrapperComponent = /*@__PURE__*/ (function () {
    function TreeNodeWrapperComponent() {
    }
    return TreeNodeWrapperComponent;
}());





// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var lodash_throttle = __webpack_require__("+X65");
var throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);

// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-viewport.component.js




var tree_viewport_component_TreeViewportComponent = /*@__PURE__*/ (function () {
    function TreeViewportComponent(elementRef, virtualScroll) {
        var _this = this;
        this.elementRef = elementRef;
        this.virtualScroll = virtualScroll;
        this.setViewport = throttle_default()(function () {
            _this.virtualScroll.setViewport(_this.elementRef.nativeElement);
        }, 17);
    }
    TreeViewportComponent.prototype.ngOnInit = function () {
        this.virtualScroll.init();
    };
    TreeViewportComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.setViewport();
            _this.virtualScroll.fireEvent({ eventName: TREE_EVENTS.initialized });
        });
    };
    TreeViewportComponent.prototype.ngOnDestroy = function () {
        this.virtualScroll.clear();
    };
    TreeViewportComponent.prototype.getTotalHeight = function () {
        return this.virtualScroll.isEnabled() && this.virtualScroll.totalHeight + 'px' || 'auto';
    };
    TreeViewportComponent.prototype.onScroll = function () {
        this.setViewport();
    };
    return TreeViewportComponent;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/components/tree-node-checkbox.component.js

var TreeNodeCheckboxComponent = /*@__PURE__*/ (function () {
    function TreeNodeCheckboxComponent() {
    }
    return TreeNodeCheckboxComponent;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/directives/tree-drop.directive.js


var DRAG_OVER_CLASS = 'is-dragging-over';
var DRAG_DISABLED_CLASS = 'is-dragging-over-disabled';
var tree_drop_directive_TreeDropDirective = /*@__PURE__*/ (function () {
    function TreeDropDirective(el, renderer, treeDraggedElement, ngZone) {
        this.el = el;
        this.renderer = renderer;
        this.treeDraggedElement = treeDraggedElement;
        this.ngZone = ngZone;
        this.onDropCallback = new core["EventEmitter"]();
        this.onDragOverCallback = new core["EventEmitter"]();
        this.onDragLeaveCallback = new core["EventEmitter"]();
        this.onDragEnterCallback = new core["EventEmitter"]();
        this._allowDrop = function (element, $event) { return true; };
        this.dragOverEventHandler = this.onDragOver.bind(this);
        this.dragEnterEventHandler = this.onDragEnter.bind(this);
        this.dragLeaveEventHandler = this.onDragLeave.bind(this);
    }
    Object.defineProperty(TreeDropDirective.prototype, "treeAllowDrop", {
        set: function (allowDrop) {
            if (allowDrop instanceof Function) {
                this._allowDrop = allowDrop;
            }
            else
                this._allowDrop = function (element, $event) { return allowDrop; };
        },
        enumerable: true,
        configurable: true
    });
    TreeDropDirective.prototype.allowDrop = function ($event) {
        return this._allowDrop(this.treeDraggedElement.get(), $event);
    };
    TreeDropDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        var el = this.el.nativeElement;
        this.ngZone.runOutsideAngular(function () {
            el.addEventListener('dragover', _this.dragOverEventHandler);
            el.addEventListener('dragenter', _this.dragEnterEventHandler);
            el.addEventListener('dragleave', _this.dragLeaveEventHandler);
        });
    };
    TreeDropDirective.prototype.ngOnDestroy = function () {
        var el = this.el.nativeElement;
        el.removeEventListener('dragover', this.dragOverEventHandler);
        el.removeEventListener('dragenter', this.dragEnterEventHandler);
        el.removeEventListener('dragleave', this.dragLeaveEventHandler);
    };
    TreeDropDirective.prototype.onDragOver = function ($event) {
        if (!this.allowDrop($event))
            return this.addDisabledClass();
        this.onDragOverCallback.emit({ event: $event, element: this.treeDraggedElement.get() });
        $event.preventDefault();
        this.addClass();
    };
    TreeDropDirective.prototype.onDragEnter = function ($event) {
        if (!this.allowDrop($event))
            return;
        this.onDragEnterCallback.emit({ event: $event, element: this.treeDraggedElement.get() });
    };
    TreeDropDirective.prototype.onDragLeave = function ($event) {
        if (!this.allowDrop($event))
            return this.removeDisabledClass();
        this.onDragLeaveCallback.emit({ event: $event, element: this.treeDraggedElement.get() });
        this.removeClass();
    };
    TreeDropDirective.prototype.onDrop = function ($event) {
        if (!this.allowDrop($event))
            return;
        $event.preventDefault();
        this.onDropCallback.emit({ event: $event, element: this.treeDraggedElement.get() });
        this.removeClass();
        this.treeDraggedElement.set(null);
    };
    TreeDropDirective.prototype.addClass = function () {
        this.renderer.setElementClass(this.el.nativeElement, DRAG_OVER_CLASS, true);
    };
    TreeDropDirective.prototype.removeClass = function () {
        this.renderer.setElementClass(this.el.nativeElement, DRAG_OVER_CLASS, false);
    };
    TreeDropDirective.prototype.addDisabledClass = function () {
        this.renderer.setElementClass(this.el.nativeElement, DRAG_DISABLED_CLASS, true);
    };
    TreeDropDirective.prototype.removeDisabledClass = function () {
        this.renderer.setElementClass(this.el.nativeElement, DRAG_DISABLED_CLASS, false);
    };
    return TreeDropDirective;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/directives/tree-drag.directive.js


var tree_drag_directive_DRAG_OVER_CLASS = 'is-dragging-over';
var TreeDragDirective = /*@__PURE__*/ (function () {
    function TreeDragDirective(el, renderer, treeDraggedElement, ngZone) {
        this.el = el;
        this.renderer = renderer;
        this.treeDraggedElement = treeDraggedElement;
        this.ngZone = ngZone;
        this.dragEventHandler = this.onDrag.bind(this);
    }
    TreeDragDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        var el = this.el.nativeElement;
        this.ngZone.runOutsideAngular(function () {
            el.addEventListener('drag', _this.dragEventHandler);
        });
    };
    TreeDragDirective.prototype.ngDoCheck = function () {
        this.renderer.setElementAttribute(this.el.nativeElement, 'draggable', this.treeDragEnabled ? 'true' : 'false');
    };
    TreeDragDirective.prototype.ngOnDestroy = function () {
        var el = this.el.nativeElement;
        el.removeEventListener('drag', this.dragEventHandler);
    };
    TreeDragDirective.prototype.onDragStart = function (ev) {
        // setting the data is required by firefox
        ev.dataTransfer.setData('text', ev.target.id);
        this.treeDraggedElement.set(this.draggedElement);
        if (this.draggedElement.mouseAction) {
            this.draggedElement.mouseAction('dragStart', ev);
        }
    };
    TreeDragDirective.prototype.onDrag = function (ev) {
        if (this.draggedElement.mouseAction) {
            this.draggedElement.mouseAction('drag', ev);
        }
    };
    TreeDragDirective.prototype.onDragEnd = function () {
        if (this.draggedElement.mouseAction) {
            this.draggedElement.mouseAction('dragEnd');
        }
        this.treeDraggedElement.set(null);
    };
    return TreeDragDirective;
}());





// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/directives/tree-animate-open.directive.js

var EASE_ACCELERATION = 1.005;
var TreeAnimateOpenDirective = /*@__PURE__*/ (function () {
    function TreeAnimateOpenDirective(renderer, templateRef, viewContainerRef) {
        this.renderer = renderer;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
    }
    Object.defineProperty(TreeAnimateOpenDirective.prototype, "isOpen", {
        set: function (value) {
            if (value) {
                this._show();
                if (this.isEnabled && this._isOpen === false) {
                    this._animateOpen();
                }
            }
            else {
                this.isEnabled ? this._animateClose() : this._hide();
            }
            this._isOpen = !!value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    TreeAnimateOpenDirective.prototype._show = function () {
        if (this.innerElement)
            return;
        // create child view
        this.innerElement = this.viewContainerRef.createEmbeddedView(this.templateRef).rootNodes[0];
    };
    TreeAnimateOpenDirective.prototype._hide = function () {
        this.viewContainerRef.clear();
        this.innerElement = null;
    };
    TreeAnimateOpenDirective.prototype._animateOpen = function () {
        var _this = this;
        var delta = this.animateSpeed;
        var ease = this.animateAcceleration;
        var maxHeight = 0;
        // set height to 0
        this.renderer.setElementStyle(this.innerElement, 'max-height', "0");
        // increase maxHeight until height doesn't change
        setTimeout(function () {
            var i = setInterval(function () {
                if (!_this._isOpen || !_this.innerElement)
                    return clearInterval(i);
                maxHeight += delta;
                var roundedMaxHeight = Math.round(maxHeight);
                _this.renderer.setElementStyle(_this.innerElement, 'max-height', roundedMaxHeight + "px");
                var height = _this.innerElement.getBoundingClientRect ? _this.innerElement.getBoundingClientRect().height : 0; // TBD use renderer
                delta *= ease;
                ease *= EASE_ACCELERATION;
                if (height < roundedMaxHeight) {
                    // Make maxHeight auto because animation finished and container might change height later on
                    _this.renderer.setElementStyle(_this.innerElement, 'max-height', null);
                    clearInterval(i);
                }
            }, 17);
        });
    };
    TreeAnimateOpenDirective.prototype._animateClose = function () {
        var _this = this;
        if (!this.innerElement)
            return;
        var delta = this.animateSpeed;
        var ease = this.animateAcceleration;
        var height = this.innerElement.getBoundingClientRect().height; // TBD use renderer
        // slowly decrease maxHeight to 0, starting from current height
        var i = setInterval(function () {
            if (_this._isOpen || !_this.innerElement)
                return clearInterval(i);
            height -= delta;
            _this.renderer.setElementStyle(_this.innerElement, 'max-height', height + "px");
            delta *= ease;
            ease *= EASE_ACCELERATION;
            if (height <= 0) {
                // after animation complete - remove child element
                _this.viewContainerRef.clear();
                _this.innerElement = null;
                clearInterval(i);
            }
        }, 17);
    };
    return TreeAnimateOpenDirective;
}());





// EXTERNAL MODULE: ./node_modules/angular-tree-component/dist/vendor/closest.js
var closest = __webpack_require__("mzAu");
var closest_default = /*#__PURE__*/__webpack_require__.n(closest);

// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/polyfills.js

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL2xpYi9wb2x5ZmlsbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxrQkFBa0IsQ0FBQyIsImZpbGUiOiJwb2x5ZmlsbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICcuL3ZlbmRvci9jbG9zZXN0JztcbiJdfQ==
// CONCATENATED MODULE: ./node_modules/angular-tree-component/dist/angular-tree-component.js
























var TreeModule = /*@__PURE__*/ (function () {
    function TreeModule() {
    }
    return TreeModule;
}());






// EXTERNAL MODULE: ./node_modules/angular-mentions/mention/mention.module.js
var mention_module = __webpack_require__("bHqE");
var mention_module_default = /*#__PURE__*/__webpack_require__.n(mention_module);

// CONCATENATED MODULE: ./src/app/employee/employeeFilter.module.ts


var employeeFilter_module_ngbModule = NgbModule.forRoot();
var employeeFilter_module_treeviewModule = treeview_module_TreeviewModule.forRoot();
var EmployeeFilterModule = /*@__PURE__*/ (function () {
    function EmployeeFilterModule() {
    }
    return EmployeeFilterModule;
}());



// CONCATENATED MODULE: ./src/app/bi/index.ts




// import { HighChartDataParser } from './common/service/highchart-data-parser';
var bi_ngbModule = NgbModule.forRoot();
var bi_dndModule = DndModule.forRoot();
var routModule = fesm5_router["o" /* RouterModule */].forRoot(ROUTES, {
    useHash: Boolean(history.pushState) === true,
    preloadingStrategy: fesm5_router["f" /* PreloadAllModules */]
});
var BIAdminModule = /*@__PURE__*/ (function () {
    function BIAdminModule() {
    }
    return BIAdminModule;
}());



// EXTERNAL MODULE: ./node_modules/primeng/components/inputtext/inputtext.js
var inputtext = __webpack_require__("iE7H");
var inputtext_default = /*#__PURE__*/__webpack_require__.n(inputtext);

// EXTERNAL MODULE: ./node_modules/primeng/components/button/button.js
var button_button = __webpack_require__("ovmJ");
var button_default = /*#__PURE__*/__webpack_require__.n(button_button);

// EXTERNAL MODULE: ./node_modules/primeng/components/common/shared.js
var shared = __webpack_require__("WtLm");
var shared_default = /*#__PURE__*/__webpack_require__.n(shared);

// EXTERNAL MODULE: ./node_modules/primeng/components/autocomplete/autocomplete.js
var autocomplete = __webpack_require__("+8aO");
var autocomplete_default = /*#__PURE__*/__webpack_require__.n(autocomplete);

// CONCATENATED MODULE: ./node_modules/ngx-toggle-switch/ui-switch.es5.js



/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UI_SWITCH_CONTROL_VALUE_ACCESSOR = {
    provide: fesm5_forms["NG_VALUE_ACCESSOR"],
    /* tslint:disable-next-line: no-use-before-declare */
    useExisting: Object(core["forwardRef"])(function () { return ui_switch_es5_UiSwitchComponent; }),
    multi: true
};
var ui_switch_es5_UiSwitchComponent = /*@__PURE__*/ (function () {
    function UiSwitchComponent() {
        this.size = 'medium';
        this.change = new core["EventEmitter"]();
        this.color = 'rgb(100, 189, 99)';
        this.switchOffColor = '';
        this.switchColor = '#fff';
        this.defaultBgColor = '#fff';
        this.defaultBoColor = '#dfdfdf';
        this.labelOn = '';
        this.labelOff = '';
        this.onTouchedCallback = function (v) { };
        this.onChangeCallback = function (v) { };
    }
    Object.defineProperty(UiSwitchComponent.prototype, "checked", {
        get: /**
         * @return {?}
         */ function () {
            return this._checked;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */ function (v) {
            this._checked = v !== false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSwitchComponent.prototype, "disabled", {
        get: /**
         * @return {?}
         */ function () {
            return this._disabled;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */ function (v) {
            this._disabled = v !== false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSwitchComponent.prototype, "reverse", {
        get: /**
         * @return {?}
         */ function () {
            return this._reverse;
        },
        set: /**
         * @param {?} v
         * @return {?}
         */ function (v) {
            this._reverse = v !== false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} flag
     * @return {?}
     */
    UiSwitchComponent.prototype.getColor = /**
     * @param {?=} flag
     * @return {?}
     */
        function (flag) {
            if (flag === void 0) {
                flag = '';
            }
            if (flag === 'borderColor') {
                return this.defaultBoColor;
            }
            if (flag === 'switchColor') {
                if (this.reverse) {
                    return !this.checked ? this.switchColor : this.switchOffColor || this.switchColor;
                }
                return this.checked ? this.switchColor : this.switchOffColor || this.switchColor;
            }
            if (this.reverse) {
                return !this.checked ? this.color : this.defaultBgColor;
            }
            return this.checked ? this.color : this.defaultBgColor;
        };
    /**
     * @return {?}
     */
    UiSwitchComponent.prototype.onToggle = /**
     * @return {?}
     */
        function () {
            if (this.disabled) {
                return;
            }
            this.checked = !this.checked;
            this.change.emit(this.checked);
            this.onChangeCallback(this.checked);
            this.onTouchedCallback(this.checked);
        };
    /**
     * @param {?} obj
     * @return {?}
     */
    UiSwitchComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
        function (obj) {
            if (obj !== this.checked) {
                this.checked = !!obj;
            }
        };
    /**
     * @param {?} fn
     * @return {?}
     */
    UiSwitchComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
        function (fn) {
            this.onChangeCallback = fn;
        };
    /**
     * @param {?} fn
     * @return {?}
     */
    UiSwitchComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
        function (fn) {
            this.onTouchedCallback = fn;
        };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    UiSwitchComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
        function (isDisabled) {
            this.disabled = isDisabled;
        };
    return UiSwitchComponent;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UiSwitchModule = /*@__PURE__*/ (function () {
    function UiSwitchModule() {
    }
    return UiSwitchModule;
}());
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */





// EXTERNAL MODULE: ./node_modules/ngx-color-picker/dist/lib/color-picker.module.js
var color_picker_module = __webpack_require__("6OI+");
var color_picker_module_default = /*#__PURE__*/__webpack_require__.n(color_picker_module);

// CONCATENATED MODULE: ./src/app/app.module.ngfactory.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppModuleNgFactory; });
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_app.module,_app.component,_.._node_modules__ng_bootstrap_ng_bootstrap_alert_alert.ngfactory,_.._node_modules__ng_bootstrap_ng_bootstrap_datepicker_datepicker.ngfactory,_.._node_modules__ng_bootstrap_ng_bootstrap_modal_modal_backdrop.ngfactory,_.._node_modules__ng_bootstrap_ng_bootstrap_modal_modal_window.ngfactory,_.._node_modules__ng_bootstrap_ng_bootstrap_popover_popover.ngfactory,_.._node_modules__ng_bootstrap_ng_bootstrap_tooltip_tooltip.ngfactory,_.._node_modules__ng_bootstrap_ng_bootstrap_typeahead_typeahead_window.ngfactory,_.._node_modules__angular_router_router.ngfactory,_.._node_modules_ng2_auto_complete_dist_ng2_auto_complete.component.ngfactory,_.._node_modules_angular_mentions_mention_mention_list.component.ngfactory,_bi_admin_controller_adminPage.component.ngfactory,_bi_admin_controller_pageAuthorization.component.ngfactory,_bi_admin_controller_roleAuthorization.component.ngfactory,_bi_admin_controller_editRoleAuthorization.component.ngfactory,_bi_admin_controller_dimLvlPermissions.component.ngfactory,_bi_admin_controller_tenantConfiguration.component.ngfactory,_bi_admin_controller_target.component.ngfactory,_bi_admin_controller_cube.component.ngfactory,_bi_admin_controller_measure.component.ngfactory,_bi_admin_controller_uom.component.ngfactory,_bi_admin_controller_scope.component.ngfactory,_bi_admin_controller_dimension.component.ngfactory,_bi_admin_controller_valueStream.component.ngfactory,_bi_admin_controller_dataSource.component.ngfactory,_bi_admin_controller_recordFormat.component.ngfactory,_bi_admin_controller_dataEngine.component.ngfactory,_bi_admin_pocdesigner_pocWizard.component.ngfactory,_menu_menu.ngfactory,_employee_employeeList.ngfactory,_employee_employeeSearch.ngfactory,_employee_addEmployees.ngfactory,_switchUser_switchUser.ngfactory,_tools_designationList.ngfactory,_tools_organizationUnit_organizationUnitList.ngfactory,_tools_userGroup_userGroup.ngfactory,_tools_addDesignation.ngfactory,_tools_organizationUnit_organizationUnit.ngfactory,_tools_userGroup_addUserGroup.ngfactory,_tools_userGroup_addUsersToGroup.ngfactory,_tools_empTypeList.ngfactory,_tools_addEmpType.ngfactory,_tools_gradeList.ngfactory,_tools_addGrade.ngfactory,_tools_mgrLevelList.ngfactory,_tools_addMgrLevel.ngfactory,_tools_org_addParentOrganization.ngfactory,_tools_rolesAndPermission_rolesAndPermission.ngfactory,_tools_operations_manageOperation.component.ngfactory,_cob_cob.component.ngfactory,_bulkResign_bulkResign.component.ngfactory,_tools_rolesAndPermission_createRolesAndPermission.ngfactory,_tools_rolesAndPermission_addUsersToRole.ngfactory,_tools_org_organizationList.ngfactory,_tools_rolesAndPermission_employeesInRole.ngfactory,_tools_userGroup_employeesInGroup.ngfactory,_programManagement_announcements_announcements.ngfactory,_bulkUpload_bulkUpload.ngfactory,_tools_tenantPreference.ngfactory,_superAdmin_buildDetailsComponent.ngfactory,_superAdmin_tenantManagement.ngfactory,_superAdmin_createTenant.ngfactory,_superAdmin_updateTenant.ngfactory,_tools_notificationEditor_notificationGridComponent.ngfactory,_tools_notificationEditor_editNotificationComponent.ngfactory,_tools_clearComponent_clearComponent.ngfactory,_programManagement_emailNotification_emailNotification.ngfactory,_superAdmin_mobileAppManagement.ngfactory,_tools_passwordPolicy_passwordPolicy.ngfactory,_no_content_no_content.component.ngfactory,_bi_admin_controller_fileUploadModal.ngfactory,_.._node_modules_ngx_color_picker_dist_lib_color_picker.component.ngfactory,_.._node_modules_ngx_toastr_ngx_toastr.ngfactory,_confirmation_confirmation.ngfactory,_confirmation_confirmationModel.ngfactory,_employee_employeeTransfer_employeeTransfer.ngfactory,_imageCropper_imageCropper.ngfactory,_employee_employeeActions_actionSuspend.ngfactory,_employee_employeeActions_resetPasswordByAdmin.ngfactory,_employee_addSupervisor.ngfactory,_programManagement_announcements_scheduleAnnouncement.ngfactory,_programManagement_emailNotification_emailPreview.ngfactory,_tools_operations_addOperation.component.ngfactory,_superAdmin_createMobileApplication.ngfactory,_superAdmin_deleteMobileApplication.ngfactory,_app.component.ngfactory,_angular_common,_angular_platform_browser,_angular_animations_browser,_angular_platform_browser_animations,_angular_forms,_angular_http,_ng_bootstrap_ng_bootstrap_util_scrollbar,_ng_bootstrap_ng_bootstrap_modal_modal_stack,_ng_bootstrap_ng_bootstrap_modal_modal,_ng_bootstrap_ng_bootstrap_alert_alert_config,_ng_bootstrap_ng_bootstrap_progressbar_progressbar_config,_ng_bootstrap_ng_bootstrap_tooltip_tooltip_config,_ng_bootstrap_ng_bootstrap_util_accessibility_live,_ng_bootstrap_ng_bootstrap_typeahead_typeahead_config,_ng_bootstrap_ng_bootstrap_accordion_accordion_config,_ng_bootstrap_ng_bootstrap_carousel_carousel_config,_ng_bootstrap_ng_bootstrap_datepicker_ngb_calendar,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_i18n,_ng_bootstrap_ng_bootstrap_datepicker_ngb_date_parser_formatter,_ng_bootstrap_ng_bootstrap_datepicker_adapters_ngb_date_adapter,_ng_bootstrap_ng_bootstrap_datepicker_datepicker_config,_ng_bootstrap_ng_bootstrap_dropdown_dropdown_config,_ng_bootstrap_ng_bootstrap_pagination_pagination_config,_ng_bootstrap_ng_bootstrap_popover_popover_config,_ng_bootstrap_ng_bootstrap_rating_rating_config,_ng_bootstrap_ng_bootstrap_tabset_tabset_config,_ng_bootstrap_ng_bootstrap_timepicker_timepicker_config,_ng_bootstrap_ng_bootstrap_timepicker_ngb_time_adapter,angular_tree_component_dist_models_tree_dragged_element.model,_angular_animations,ngx_treeview_src_treeview_config,ngx_treeview_src_treeview_i18n,ngx_treeview_src_treeview_event_parser,ng2_dnd_src_dnd.config,ng2_dnd_src_dnd.service,_angular_router,_angular_common_http,ngx_toastr,_toasterComponent_toasterComponent,_shared_services_http.client,_shared_services_configuration,_bi_admin_services_mdmService.service,_bi_admin_services_roleAuthService.service,_bi_common_service_number.utils,_bi_common_service_ngbDateConverter.utils,_bi_common_service_ngbTimeConverter.utils,_shared_services_fileService,_bi_common_service_time.utils,_bi_admin_controller_toasterComponent,_angular_cdk_drag_drop,_angular_cdk_scrolling,ngx_color_picker_dist_lib_color_picker.service,_shared_auth_auth.service,_shared_auth_jwt.interceptor,_ngx_translate_core,_common_common_app.module,_image_upload_image_upload_image.service,_app.resolver,_ng_bootstrap_ng_bootstrap_modal_modal_ref,_shared_services_auth,_shared_services_date_utils,_shared_services_number.utils,_shared_services_theme_service,_shared_sharedData,_shared_permissions_permissions,ng2_dnd,ngx_treeview_src_treeview.module,_ng_bootstrap_ng_bootstrap_accordion_accordion.module,_ng_bootstrap_ng_bootstrap_alert_alert.module,_ng_bootstrap_ng_bootstrap_buttons_buttons.module,_ng_bootstrap_ng_bootstrap_carousel_carousel.module,_ng_bootstrap_ng_bootstrap_collapse_collapse.module,_ng_bootstrap_ng_bootstrap_datepicker_datepicker.module,_ng_bootstrap_ng_bootstrap_dropdown_dropdown.module,_ng_bootstrap_ng_bootstrap_modal_modal.module,_ng_bootstrap_ng_bootstrap_pagination_pagination.module,_ng_bootstrap_ng_bootstrap_popover_popover.module,_ng_bootstrap_ng_bootstrap_progressbar_progressbar.module,_ng_bootstrap_ng_bootstrap_rating_rating.module,_ng_bootstrap_ng_bootstrap_tabset_tabset.module,_ng_bootstrap_ng_bootstrap_timepicker_timepicker.module,_ng_bootstrap_ng_bootstrap_tooltip_tooltip.module,_ng_bootstrap_ng_bootstrap_typeahead_typeahead.module,_ng_bootstrap_ng_bootstrap,_image_upload_image_upload.module,_bi_admin_controller_adminPage.component,_bi_admin_controller_pageAuthorization.component,_bi_admin_controller_roleAuthorization.component,_bi_admin_controller_editRoleAuthorization.component,_bi_admin_controller_dimLvlPermissions.component,_bi_admin_controller_tenantConfiguration.component,_bi_admin_controller_target.component,_bi_admin_controller_cube.component,_bi_admin_controller_measure.component,_bi_admin_controller_uom.component,_bi_admin_controller_scope.component,_bi_admin_controller_dimension.component,_bi_admin_controller_valueStream.component,_bi_admin_controller_dataSource.component,_bi_admin_controller_recordFormat.component,_bi_admin_controller_dataEngine.component,_bi_admin_pocdesigner_pocWizard.component,_menu_menu,_employee_employeeList,_employee_employeeSearch,_employee_addEmployees,_switchUser_switchUser,_tools_designationList,_tools_organizationUnit_organizationUnitList,_tools_userGroup_userGroup,_tools_addDesignation,_tools_organizationUnit_organizationUnit,_tools_userGroup_addUserGroup,_tools_userGroup_addUsersToGroup,_tools_empTypeList,_tools_addEmpType,_tools_gradeList,_tools_addGrade,_tools_mgrLevelList,_tools_addMgrLevel,_tools_org_addParentOrganization,_tools_rolesAndPermission_rolesAndPermission,_tools_operations_manageOperation.component,_cob_cob.component,_bulkResign_bulkResign.component,_tools_rolesAndPermission_createRolesAndPermission,_tools_rolesAndPermission_addUsersToRole,_tools_org_organizationList,_tools_rolesAndPermission_employeesInRole,_tools_userGroup_employeesInGroup,_programManagement_announcements_announcements,_bulkUpload_bulkUpload,_tools_tenantPreference,_superAdmin_buildDetailsComponent,_superAdmin_tenantManagement,_superAdmin_createTenant,_superAdmin_updateTenant,_tools_notificationEditor_notificationGridComponent,_tools_notificationEditor_editNotificationComponent,_tools_clearComponent_clearComponent,_programManagement_emailNotification_emailNotification,_superAdmin_mobileAppManagement,_tools_passwordPolicy_passwordPolicy,_no_content_no_content.component,angular_froala_wysiwyg_editor_editor.module,angular_froala_wysiwyg_view_view.module,ng2_auto_complete_dist_ng2_auto_complete.module,mobx_angular,angular_tree_component_dist_angular_tree_component,angular2_multiselect_dropdown_multiselect.component,angular_mentions_mention_mention.module,_employee_employeeFilter.module,_bi_index,ngx_quill_src_quill.module,primeng_components_inputtext_inputtext,primeng_components_button_button,primeng_components_common_shared,primeng_components_autocomplete_autocomplete,ngx_toggle_switch,ngx_color_picker_dist_lib_color_picker.module,ng2_img_cropper_src_imageCropperModule,_app.service PURE_IMPORTS_END */


























































































































































































































































var AppModuleNgFactory = /*@__PURE__*/ core["ɵcmf"](app_module_AppModule, [app_component_AppComponent], function (_l) { return core["ɵmod"]([core["ɵmpd"](512, core["ComponentFactoryResolver"], core["ɵCodegenComponentFactoryResolver"], [[8, [NgbAlertNgFactory, NgbDatepickerNgFactory, NgbModalBackdropNgFactory, NgbModalWindowNgFactory, NgbPopoverWindowNgFactory, NgbTooltipWindowNgFactory, NgbTypeaheadWindowNgFactory, router_ngfactory["a" /* ɵEmptyOutletComponentNgFactory */], Ng2AutoCompleteComponentNgFactory, MentionListComponentNgFactory, AdminPageNgFactory, pageAuthorizationComponentNgFactory, roleAuthorizationComponentNgFactory, editRoleAuthorizationComponentNgFactory, dimLvlPermComponentNgFactory, tenantConfigComponentNgFactory, targetComponentNgFactory, CubeComponentNgFactory, MeasureComponentNgFactory, UomComponentNgFactory, ScopeComponentNgFactory, DimensionComponentNgFactory, ValueStreamComponentNgFactory, DataSourceComponentNgFactory, RecordFormatComponentNgFactory, DataEngineNgFactory, POCWizardNgFactory, MenuComponentNgFactory, EmployeesListingPageNgFactory, EmployeeSearchNgFactory, AddEmployeesComponentNgFactory, SwitchUserComponentNgFactory, DesignationPageComponentNgFactory, OrgUnitTypePageComponentNgFactory, UserGroupPageNgFactory, AddDesignationComponentNgFactory, AddOrgUnitTypeComponentNgFactory, AddUserGroupComponentNgFactory, AddUsersToGroupComponentNgFactory, EmployementTypePageComponentNgFactory, AddEmployementTypeComponentNgFactory, GradePageComponentNgFactory, AddGradeComponentNgFactory, ManagerLevelComponentNgFactory, AddManagerLevelComponentNgFactory, AddParentOrganizationComponentNgFactory, RolesAndPermissionComponentNgFactory, ManageOperationComponentNgFactory, CobComponentNgFactory, BulkResignComponentNgFactory, CreateRolesAndPermissionComponentNgFactory, AddUsersToRolesComponentNgFactory, OrganizationPageNgFactory, EmployeeInRoleComponentNgFactory, EmployeeInGroupComponentNgFactory, AnnouncementsNgFactory, BulkUploadComponentNgFactory, TenantPreferenceComponentNgFactory, BuildDetailsComponentNgFactory, TenantManagementComponentNgFactory, CreateTenantComponentNgFactory, UpdateTenantComponentNgFactory, NotificationGridComponentNgFactory, EditNotificationComponentNgFactory, ClearCacheComponentNgFactory, EmailNotificationNgFactory, MobileAppManagementComponentNgFactory, PasswordPolicyComponentNgFactory, NoContentComponentNgFactory, FileUploaderNgFactory, ColorPickerComponentNgFactory, ToastNgFactory, ConfirmationComponentNgFactory, ConfirmationModelNgFactory, EmployeeTransferComponentNgFactory, CropImageComponentNgFactory, ActionSuspendNgFactory, ResetPasswordPageNgFactory, AddSupervisorNgFactory, ScheduleAnnouncementNgFactory, EmailPreviewNgFactory, AddOperationComponentNgFactory, CreateMobileComponentNgFactory, DeleteMobileComponentNgFactory, AppComponentNgFactory]], [3, core["ComponentFactoryResolver"]], core["NgModuleRef"]]), core["ɵmpd"](5120, core["LOCALE_ID"], core["ɵangular_packages_core_core_k"], [[3, core["LOCALE_ID"]]]), core["ɵmpd"](4608, common["NgLocalization"], common["NgLocaleLocalization"], [core["LOCALE_ID"], [2, common["ɵangular_packages_common_common_a"]]]), core["ɵmpd"](5120, core["APP_ID"], core["ɵangular_packages_core_core_f"], []), core["ɵmpd"](5120, core["IterableDiffers"], core["ɵangular_packages_core_core_i"], []), core["ɵmpd"](5120, core["KeyValueDiffers"], core["ɵangular_packages_core_core_j"], []), core["ɵmpd"](4608, platform_browser["c" /* DomSanitizer */], platform_browser["m" /* ɵDomSanitizerImpl */], [common["DOCUMENT"]]), core["ɵmpd"](6144, core["Sanitizer"], null, [platform_browser["c" /* DomSanitizer */]]), core["ɵmpd"](4608, platform_browser["f" /* HAMMER_GESTURE_CONFIG */], platform_browser["h" /* HammerGestureConfig */], []), core["ɵmpd"](5120, platform_browser["d" /* EVENT_MANAGER_PLUGINS */], function (p0_0, p0_1, p0_2, p1_0, p2_0, p2_1, p2_2, p2_3) { return [new platform_browser["k" /* ɵDomEventsPlugin */](p0_0, p0_1, p0_2), new platform_browser["p" /* ɵKeyEventsPlugin */](p1_0), new platform_browser["o" /* ɵHammerGesturesPlugin */](p2_0, p2_1, p2_2, p2_3)]; }, [common["DOCUMENT"], core["NgZone"], core["PLATFORM_ID"], common["DOCUMENT"], common["DOCUMENT"], platform_browser["f" /* HAMMER_GESTURE_CONFIG */], core["ɵConsole"], [2, platform_browser["g" /* HAMMER_LOADER */]]]), core["ɵmpd"](4608, platform_browser["e" /* EventManager */], platform_browser["e" /* EventManager */], [platform_browser["d" /* EVENT_MANAGER_PLUGINS */], core["NgZone"]]), core["ɵmpd"](135680, platform_browser["n" /* ɵDomSharedStylesHost */], platform_browser["n" /* ɵDomSharedStylesHost */], [common["DOCUMENT"]]), core["ɵmpd"](4608, platform_browser["l" /* ɵDomRendererFactory2 */], platform_browser["l" /* ɵDomRendererFactory2 */], [platform_browser["e" /* EventManager */], platform_browser["n" /* ɵDomSharedStylesHost */]]), core["ɵmpd"](5120, AnimationDriver, instantiateSupportedAnimationDriver, []), core["ɵmpd"](5120, AnimationStyleNormalizer, instantiateDefaultStyleNormalizer, []), core["ɵmpd"](4608, browser_AnimationEngine, animations_InjectableAnimationEngine, [common["DOCUMENT"], AnimationDriver, AnimationStyleNormalizer]), core["ɵmpd"](5120, core["RendererFactory2"], instantiateRendererFactory, [platform_browser["l" /* ɵDomRendererFactory2 */], browser_AnimationEngine, core["NgZone"]]), core["ɵmpd"](6144, platform_browser["q" /* ɵSharedStylesHost */], null, [platform_browser["n" /* ɵDomSharedStylesHost */]]), core["ɵmpd"](4608, core["Testability"], core["Testability"], [core["NgZone"]]), core["ɵmpd"](4608, fesm5_forms["ɵangular_packages_forms_forms_i"], fesm5_forms["ɵangular_packages_forms_forms_i"], []), core["ɵmpd"](4608, fesm5_http["BrowserXhr"], fesm5_http["BrowserXhr"], []), core["ɵmpd"](4608, fesm5_http["ResponseOptions"], fesm5_http["BaseResponseOptions"], []), core["ɵmpd"](5120, fesm5_http["XSRFStrategy"], fesm5_http["ɵangular_packages_http_http_a"], []), core["ɵmpd"](4608, fesm5_http["XHRBackend"], fesm5_http["XHRBackend"], [fesm5_http["BrowserXhr"], fesm5_http["ResponseOptions"], fesm5_http["XSRFStrategy"]]), core["ɵmpd"](4608, fesm5_http["RequestOptions"], fesm5_http["BaseRequestOptions"], []), core["ɵmpd"](5120, fesm5_http["Http"], fesm5_http["ɵangular_packages_http_http_b"], [fesm5_http["XHRBackend"], fesm5_http["RequestOptions"]]), core["ɵmpd"](4608, ScrollBar, ScrollBar, [common["DOCUMENT"]]), core["ɵmpd"](4608, modal_stack_NgbModalStack, modal_stack_NgbModalStack, [core["ApplicationRef"], core["Injector"], core["ComponentFactoryResolver"], common["DOCUMENT"], ScrollBar]), core["ɵmpd"](4608, NgbModal, NgbModal, [core["ComponentFactoryResolver"], core["Injector"], modal_stack_NgbModalStack]), core["ɵmpd"](4608, NgbAlertConfig, NgbAlertConfig, []), core["ɵmpd"](4608, NgbProgressbarConfig, NgbProgressbarConfig, []), core["ɵmpd"](4608, NgbTooltipConfig, NgbTooltipConfig, []), core["ɵmpd"](135680, Live, Live, [common["DOCUMENT"], ARIA_LIVE_DELAY]), core["ɵmpd"](4608, NgbTypeaheadConfig, NgbTypeaheadConfig, []), core["ɵmpd"](4608, NgbAccordionConfig, NgbAccordionConfig, []), core["ɵmpd"](4608, NgbCarouselConfig, NgbCarouselConfig, []), core["ɵmpd"](4608, NgbCalendar, ngb_calendar_NgbCalendarGregorian, []), core["ɵmpd"](4608, common["DatePipe"], common["DatePipe"], [core["LOCALE_ID"]]), core["ɵmpd"](4608, NgbDatepickerI18n, datepicker_i18n_NgbDatepickerI18nDefault, [core["LOCALE_ID"], common["DatePipe"]]), core["ɵmpd"](4608, NgbDateParserFormatter, ngb_date_parser_formatter_NgbDateISOParserFormatter, []), core["ɵmpd"](4608, NgbDateAdapter, NgbDateStructAdapter, []), core["ɵmpd"](4608, NgbDatepickerConfig, NgbDatepickerConfig, []), core["ɵmpd"](4608, NgbDropdownConfig, NgbDropdownConfig, []), core["ɵmpd"](4608, NgbPaginationConfig, NgbPaginationConfig, []), core["ɵmpd"](4608, NgbPopoverConfig, NgbPopoverConfig, []), core["ɵmpd"](4608, NgbRatingConfig, NgbRatingConfig, []), core["ɵmpd"](4608, NgbTabsetConfig, NgbTabsetConfig, []), core["ɵmpd"](4608, NgbTimepickerConfig, NgbTimepickerConfig, []), core["ɵmpd"](4608, NgbTimeAdapter, ngb_time_adapter_NgbTimeStructAdapter, []), core["ɵmpd"](4608, fesm5_forms["FormBuilder"], fesm5_forms["FormBuilder"], []), core["ɵmpd"](4608, TreeDraggedElement, TreeDraggedElement, []), core["ɵmpd"](4608, AnimationBuilder, animations_BrowserAnimationBuilder, [core["RendererFactory2"], platform_browser["b" /* DOCUMENT */]]), core["ɵmpd"](4608, TreeviewConfig, TreeviewConfig, []), core["ɵmpd"](4608, TreeviewI18n, TreeviewI18nDefault, []), core["ɵmpd"](4608, TreeviewEventParser, treeview_event_parser_DefaultTreeviewEventParser, []), core["ɵmpd"](4608, DragDropConfig, DragDropConfig, []), core["ɵmpd"](5120, DragDropService, dragDropServiceFactory, []), core["ɵmpd"](5120, dnd_service_DragDropSortableService, dragDropSortableServiceFactory, [DragDropConfig]), core["ɵmpd"](5120, fesm5_router["a" /* ActivatedRoute */], fesm5_router["A" /* ɵangular_packages_router_router_g */], [fesm5_router["l" /* Router */]]), core["ɵmpd"](4608, fesm5_router["f" /* PreloadAllModules */], fesm5_router["f" /* PreloadAllModules */], []), core["ɵmpd"](6144, fesm5_router["g" /* PreloadingStrategy */], null, [fesm5_router["f" /* PreloadAllModules */]]), core["ɵmpd"](135680, fesm5_router["q" /* RouterPreloader */], fesm5_router["q" /* RouterPreloader */], [fesm5_router["l" /* Router */], core["NgModuleFactoryLoader"], core["Compiler"], core["Injector"], fesm5_router["g" /* PreloadingStrategy */]]), core["ɵmpd"](4608, fesm5_router["e" /* NoPreloading */], fesm5_router["e" /* NoPreloading */], []), core["ɵmpd"](5120, fesm5_router["E" /* ɵangular_packages_router_router_n */], fesm5_router["w" /* ɵangular_packages_router_router_c */], [fesm5_router["l" /* Router */], common["ViewportScroller"], fesm5_router["h" /* ROUTER_CONFIGURATION */]]), core["ɵmpd"](5120, fesm5_router["i" /* ROUTER_INITIALIZER */], fesm5_router["D" /* ɵangular_packages_router_router_j */], [fesm5_router["B" /* ɵangular_packages_router_router_h */]]), core["ɵmpd"](5120, core["APP_BOOTSTRAP_LISTENER"], function (p0_0, p1_0) { return [p0_0, p1_0]; }, [fesm5_router["i" /* ROUTER_INITIALIZER */], fesm5_router["i" /* ROUTER_INITIALIZER */]]), core["ɵmpd"](4608, BrowserXhr, BrowserXhr, []), core["ɵmpd"](6144, XhrFactory, null, [BrowserXhr]), core["ɵmpd"](4608, http_HttpXhrBackend, http_HttpXhrBackend, [XhrFactory]), core["ɵmpd"](6144, HttpBackend, null, [http_HttpXhrBackend]), core["ɵmpd"](4608, HttpHandler, HttpInterceptingHandler, [HttpBackend, core["Injector"]]), core["ɵmpd"](4608, http_HttpClient, http_HttpClient, [HttpHandler]), core["ɵmpd"](4608, OverlayContainer, OverlayContainer, []), core["ɵmpd"](4608, Overlay, Overlay, [OverlayContainer, core["ComponentFactoryResolver"], core["ApplicationRef"]]), core["ɵmpd"](4608, ngx_toastr_ToastrService, ngx_toastr_ToastrService, [TOAST_CONFIG, Overlay, core["Injector"], platform_browser["c" /* DomSanitizer */], core["NgZone"]]), core["ɵmpd"](4608, ToasterComponent, ToasterComponent, [ngx_toastr_ToastrService]), core["ɵmpd"](4608, http_client_HttpClientCustom, http_client_HttpClientCustom, [http_HttpClient, fesm5_router["l" /* Router */], ToasterComponent]), core["ɵmpd"](4608, Configuration, Configuration, []), core["ɵmpd"](4608, mdmService_service_MDMService, mdmService_service_MDMService, [http_client_HttpClientCustom, Configuration]), core["ɵmpd"](4608, roleAuthService_service_RoleAuthService, roleAuthService_service_RoleAuthService, [mdmService_service_MDMService, ToasterComponent, Configuration]), core["ɵmpd"](4608, number_utils_NumberUtils, number_utils_NumberUtils, []), core["ɵmpd"](4608, ngbDateConverter_utils_NgbDateConverter, ngbDateConverter_utils_NgbDateConverter, []), core["ɵmpd"](4608, ngbTimeConverter_utils_NgbTimeConverter, ngbTimeConverter_utils_NgbTimeConverter, []), core["ɵmpd"](4608, fileService_FileService, fileService_FileService, [http_client_HttpClientCustom, Configuration, fesm5_router["l" /* Router */], ToasterComponent]), core["ɵmpd"](4608, time_utils_TimeUtils, time_utils_TimeUtils, []), core["ɵmpd"](4608, toasterComponent_ToasterComponent, toasterComponent_ToasterComponent, [ngx_toastr_ToastrService]), core["ɵmpd"](4608, drag_drop_es5_DragDrop, drag_drop_es5_DragDrop, [common["DOCUMENT"], core["NgZone"], scrolling_es5_ViewportRuler, drag_drop_es5_DragDropRegistry]), core["ɵmpd"](4608, color_picker_service["ColorPickerService"], color_picker_service["ColorPickerService"], []), core["ɵmpd"](4608, HttpXsrfTokenExtractor, http_HttpXsrfCookieExtractor, [common["DOCUMENT"], core["PLATFORM_ID"], XSRF_COOKIE_NAME]), core["ɵmpd"](4608, http_HttpXsrfInterceptor, http_HttpXsrfInterceptor, [HttpXsrfTokenExtractor, XSRF_HEADER_NAME]), core["ɵmpd"](4608, AuthService, AuthService, []), core["ɵmpd"](5120, HTTP_INTERCEPTORS, function (p0_0, p1_0, p1_1, p1_2) { return [p0_0, new jwt_interceptor_JwtInterceptor(p1_0, p1_1, p1_2)]; }, [http_HttpXsrfInterceptor, AuthService, ToasterComponent, Configuration]), core["ɵmpd"](5120, core_es5["f" /* TranslateLoader */], common_app_module__0, [http_HttpClient]), core["ɵmpd"](4608, core_es5["c" /* TranslateCompiler */], core_es5["e" /* TranslateFakeCompiler */], []), core["ɵmpd"](4608, core_es5["h" /* TranslateParser */], core_es5["d" /* TranslateDefaultParser */], []), core["ɵmpd"](4608, core_es5["b" /* MissingTranslationHandler */], core_es5["a" /* FakeMissingTranslationHandler */], []), core["ɵmpd"](4608, core_es5["m" /* ɵa */], core_es5["m" /* ɵa */], []), core["ɵmpd"](4608, core_es5["j" /* TranslateService */], core_es5["j" /* TranslateService */], [core_es5["m" /* ɵa */], core_es5["f" /* TranslateLoader */], core_es5["c" /* TranslateCompiler */], core_es5["h" /* TranslateParser */], core_es5["b" /* MissingTranslationHandler */], core_es5["k" /* USE_DEFAULT_LANG */], core_es5["l" /* USE_STORE */]]), core["ɵmpd"](4608, image_service_ImageService, image_service_ImageService, [http_client_HttpClientCustom]), core["ɵmpd"](4608, app_resolver_DataResolver, app_resolver_DataResolver, []), core["ɵmpd"](4608, NgbActiveModal, NgbActiveModal, []), core["ɵmpd"](4608, auth_Auth, auth_Auth, [http_client_HttpClientCustom, Configuration, fesm5_router["l" /* Router */]]), core["ɵmpd"](4608, date_utils_DateTimeUtils, date_utils_DateTimeUtils, []), core["ɵmpd"](4608, NumberUtils, NumberUtils, []), core["ɵmpd"](4608, ThemeService, ThemeService, []), core["ɵmpd"](4608, SharedData, SharedData, []), core["ɵmpd"](4608, PermissionHelper, PermissionHelper, []), core["ɵmpd"](1073742336, common["CommonModule"], common["CommonModule"], []), core["ɵmpd"](1024, core["ErrorHandler"], platform_browser["r" /* ɵangular_packages_platform_browser_platform_browser_a */], []), core["ɵmpd"](1024, core["NgProbeToken"], function () { return [fesm5_router["v" /* ɵangular_packages_router_router_b */](), fesm5_router["v" /* ɵangular_packages_router_router_b */]()]; }, []), core["ɵmpd"](512, fesm5_router["B" /* ɵangular_packages_router_router_h */], fesm5_router["B" /* ɵangular_packages_router_router_h */], [core["Injector"]]), core["ɵmpd"](1024, core["APP_INITIALIZER"], function (p0_0, p1_0, p2_0) { return [platform_browser["s" /* ɵangular_packages_platform_browser_platform_browser_j */](p0_0), fesm5_router["C" /* ɵangular_packages_router_router_i */](p1_0), fesm5_router["C" /* ɵangular_packages_router_router_i */](p2_0)]; }, [[2, core["NgProbeToken"]], fesm5_router["B" /* ɵangular_packages_router_router_h */], fesm5_router["B" /* ɵangular_packages_router_router_h */]]), core["ɵmpd"](512, core["ApplicationInitStatus"], core["ApplicationInitStatus"], [[2, core["APP_INITIALIZER"]]]), core["ɵmpd"](131584, core["ApplicationRef"], core["ApplicationRef"], [core["NgZone"], core["ɵConsole"], core["Injector"], core["ErrorHandler"], core["ComponentFactoryResolver"], core["ApplicationInitStatus"]]), core["ɵmpd"](1073742336, core["ApplicationModule"], core["ApplicationModule"], [core["ApplicationRef"]]), core["ɵmpd"](1073742336, platform_browser["a" /* BrowserModule */], platform_browser["a" /* BrowserModule */], [[3, platform_browser["a" /* BrowserModule */]]]), core["ɵmpd"](1073742336, DndModule, DndModule, []), core["ɵmpd"](1073742336, fesm5_forms["ɵangular_packages_forms_forms_bb"], fesm5_forms["ɵangular_packages_forms_forms_bb"], []), core["ɵmpd"](1073742336, fesm5_forms["FormsModule"], fesm5_forms["FormsModule"], []), core["ɵmpd"](1073742336, treeview_module_TreeviewModule, treeview_module_TreeviewModule, []), core["ɵmpd"](1073742336, fesm5_http["HttpModule"], fesm5_http["HttpModule"], []), core["ɵmpd"](1073742336, accordion_module_NgbAccordionModule, accordion_module_NgbAccordionModule, []), core["ɵmpd"](1073742336, alert_module_NgbAlertModule, alert_module_NgbAlertModule, []), core["ɵmpd"](1073742336, NgbButtonsModule, NgbButtonsModule, []), core["ɵmpd"](1073742336, carousel_module_NgbCarouselModule, carousel_module_NgbCarouselModule, []), core["ɵmpd"](1073742336, NgbCollapseModule, NgbCollapseModule, []), core["ɵmpd"](1073742336, datepicker_module_NgbDatepickerModule, datepicker_module_NgbDatepickerModule, []), core["ɵmpd"](1073742336, dropdown_module_NgbDropdownModule, dropdown_module_NgbDropdownModule, []), core["ɵmpd"](1073742336, modal_module_NgbModalModule, modal_module_NgbModalModule, []), core["ɵmpd"](1073742336, pagination_module_NgbPaginationModule, pagination_module_NgbPaginationModule, []), core["ɵmpd"](1073742336, popover_module_NgbPopoverModule, popover_module_NgbPopoverModule, []), core["ɵmpd"](1073742336, progressbar_module_NgbProgressbarModule, progressbar_module_NgbProgressbarModule, []), core["ɵmpd"](1073742336, rating_module_NgbRatingModule, rating_module_NgbRatingModule, []), core["ɵmpd"](1073742336, tabset_module_NgbTabsetModule, tabset_module_NgbTabsetModule, []), core["ɵmpd"](1073742336, timepicker_module_NgbTimepickerModule, timepicker_module_NgbTimepickerModule, []), core["ɵmpd"](1073742336, tooltip_module_NgbTooltipModule, tooltip_module_NgbTooltipModule, []), core["ɵmpd"](1073742336, typeahead_module_NgbTypeaheadModule, typeahead_module_NgbTypeaheadModule, []), core["ɵmpd"](1073742336, NgbModule, NgbModule, []), core["ɵmpd"](1073742336, core_es5["g" /* TranslateModule */], core_es5["g" /* TranslateModule */], []), core["ɵmpd"](1073742336, image_upload_module_ImageUploadModule, image_upload_module_ImageUploadModule, []), core["ɵmpd"](1073742336, NgbRootModule, NgbRootModule, []), core["ɵmpd"](1024, fesm5_router["u" /* ɵangular_packages_router_router_a */], fesm5_router["y" /* ɵangular_packages_router_router_e */], [[3, fesm5_router["l" /* Router */]]]), core["ɵmpd"](512, fesm5_router["s" /* UrlSerializer */], fesm5_router["c" /* DefaultUrlSerializer */], []), core["ɵmpd"](512, fesm5_router["b" /* ChildrenOutletContexts */], fesm5_router["b" /* ChildrenOutletContexts */], []), core["ɵmpd"](256, fesm5_router["h" /* ROUTER_CONFIGURATION */], { useHash: true, preloadingStrategy: fesm5_router["f" /* PreloadAllModules */] }, []), core["ɵmpd"](1024, common["LocationStrategy"], fesm5_router["x" /* ɵangular_packages_router_router_d */], [common["PlatformLocation"], [2, common["APP_BASE_HREF"]], fesm5_router["h" /* ROUTER_CONFIGURATION */]]), core["ɵmpd"](512, common["Location"], common["Location"], [common["LocationStrategy"]]), core["ɵmpd"](512, core["Compiler"], core["Compiler"], []), core["ɵmpd"](512, core["NgModuleFactoryLoader"], core["SystemJsNgModuleLoader"], [core["Compiler"], [2, core["SystemJsNgModuleLoaderConfig"]]]), core["ɵmpd"](1024, fesm5_router["j" /* ROUTES */], function () { return [[{ path: "", redirectTo: "/menu", pathMatch: "full" }, { path: "biAdmin", component: AdminPage, children: [{ path: "pageAuthorization", component: pageAuthorization_component_pageAuthorizationComponent }, { path: "roleAuthorization", component: roleAuthorization_component_roleAuthorizationComponent, children: [] }, { path: "editRoleAuth", component: editRoleAuthorization_component_editRoleAuthorizationComponent }, { path: "dimLvlPermissions", component: dimLvlPermissions_component_dimLvlPermComponent }, { path: "tenantConfiguration", component: tenantConfiguration_component_tenantConfigComponent }, { path: "target", component: target_component_targetComponent }, { path: "cube", component: cube_component_CubeComponent }, { path: "measure", component: measure_component_MeasureComponent }, { path: "uom", component: uom_component_UomComponent }, { path: "scope", component: scope_component_ScopeComponent }, { path: "dimension", component: dimension_component_DimensionComponent }, { path: "valueStream", component: valueStream_component_ValueStreamComponent }, { path: "dataSource", component: dataSource_component_DataSourceComponent }, { path: "recordFormat", component: recordFormat_component_RecordFormatComponent }, { path: "dataEngine", component: dataEngine_component_DataEngine }, { path: "wizard", component: pocWizard_component_POCWizard }] }, { path: "menu", component: menu_MenuComponent, children: [{ path: "employeesList", component: employeeList_EmployeesListingPage }, { path: "employeeSearch", component: employeeSearch_EmployeeSearch }, { path: "addEmployee", component: addEmployees_AddEmployeesComponent }, { path: "switch", component: switchUser_SwitchUserComponent }, { path: "designationList", component: designationList_DesignationPageComponent }, { path: "organizationUnitType", component: organizationUnitList_OrgUnitTypePageComponent }, { path: "userGroup", component: userGroup_UserGroupPage }, { path: "addDesignation", component: addDesignation_AddDesignationComponent }, { path: "addOrgUnitType", component: organizationUnit_AddOrgUnitTypeComponent }, { path: "addUserGroup", component: addUserGroup_AddUserGroupComponent }, { path: "addUsersToGroup", component: addUsersToGroup_AddUsersToGroupComponent }, { path: "empTypeList", component: EmployementTypePageComponent }, { path: "addEmpType", component: addEmpType_AddEmployementTypeComponent }, { path: "gradeList", component: GradePageComponent }, { path: "addGrade", component: addGrade_AddGradeComponent }, { path: "mgrLevelList", component: mgrLevelList_ManagerLevelComponent }, { path: "addMgrLevel", component: addMgrLevel_AddManagerLevelComponent }, { path: "addParentOrganization", component: addParentOrganization_AddParentOrganizationComponent }, { path: "rolesAndPermission", component: rolesAndPermission_RolesAndPermissionComponent }, { path: "manageOperations", component: manageOperation_component_ManageOperationComponent }, { path: "cob", component: cob_component_CobComponent }, { path: "bulkResignUpload", component: bulkResign_component_BulkResignComponent }, { path: "createRoles", component: createRolesAndPermission_CreateRolesAndPermissionComponent }, { path: "addUsers", component: addUsersToRole_AddUsersToRolesComponent }, { path: "organizationList", component: organizationList_OrganizationPage }, { path: "EmployeeInRole", component: employeesInRole_EmployeeInRoleComponent }, { path: "EmployeeInGroup", component: employeesInGroup_EmployeeInGroupComponent }, { path: "announcementProgram", component: announcements_Announcements }, { path: "bulkupload", component: bulkUpload_BulkUploadComponent }, { path: "tenantPreference", component: tenantPreference_TenantPreferenceComponent }, { path: "buildDetails", component: BuildDetailsComponent }, { path: "tenantManagement", component: TenantManagementComponent }, { path: "createTenant", component: createTenant_CreateTenantComponent }, { path: "updateTenant", component: updateTenant_UpdateTenantComponent }, { path: "notifications", component: notificationGridComponent_NotificationGridComponent }, { path: "editNotifications", component: EditNotificationComponent }, { path: "cache", component: ClearCacheComponent }, { path: "emailNotification", component: emailNotification_EmailNotification }, { path: "mobileAppManagement", component: mobileAppManagement_MobileAppManagementComponent }, { path: "passwordPolicy", component: PasswordPolicyComponent }] }, { path: "**", component: NoContentComponent }], [{ path: "", redirectTo: "/menu", pathMatch: "full" }, { path: "biAdmin", component: AdminPage, children: [{ path: "pageAuthorization", component: pageAuthorization_component_pageAuthorizationComponent }, { path: "roleAuthorization", component: roleAuthorization_component_roleAuthorizationComponent, children: [] }, { path: "editRoleAuth", component: editRoleAuthorization_component_editRoleAuthorizationComponent }, { path: "dimLvlPermissions", component: dimLvlPermissions_component_dimLvlPermComponent }, { path: "tenantConfiguration", component: tenantConfiguration_component_tenantConfigComponent }, { path: "target", component: target_component_targetComponent }, { path: "cube", component: cube_component_CubeComponent }, { path: "measure", component: measure_component_MeasureComponent }, { path: "uom", component: uom_component_UomComponent }, { path: "scope", component: scope_component_ScopeComponent }, { path: "dimension", component: dimension_component_DimensionComponent }, { path: "valueStream", component: valueStream_component_ValueStreamComponent }, { path: "dataSource", component: dataSource_component_DataSourceComponent }, { path: "recordFormat", component: recordFormat_component_RecordFormatComponent }, { path: "dataEngine", component: dataEngine_component_DataEngine }, { path: "wizard", component: pocWizard_component_POCWizard }] }, { path: "menu", component: menu_MenuComponent, children: [{ path: "employeesList", component: employeeList_EmployeesListingPage }, { path: "employeeSearch", component: employeeSearch_EmployeeSearch }, { path: "addEmployee", component: addEmployees_AddEmployeesComponent }, { path: "switch", component: switchUser_SwitchUserComponent }, { path: "designationList", component: designationList_DesignationPageComponent }, { path: "organizationUnitType", component: organizationUnitList_OrgUnitTypePageComponent }, { path: "userGroup", component: userGroup_UserGroupPage }, { path: "addDesignation", component: addDesignation_AddDesignationComponent }, { path: "addOrgUnitType", component: organizationUnit_AddOrgUnitTypeComponent }, { path: "addUserGroup", component: addUserGroup_AddUserGroupComponent }, { path: "addUsersToGroup", component: addUsersToGroup_AddUsersToGroupComponent }, { path: "empTypeList", component: EmployementTypePageComponent }, { path: "addEmpType", component: addEmpType_AddEmployementTypeComponent }, { path: "gradeList", component: GradePageComponent }, { path: "addGrade", component: addGrade_AddGradeComponent }, { path: "mgrLevelList", component: mgrLevelList_ManagerLevelComponent }, { path: "addMgrLevel", component: addMgrLevel_AddManagerLevelComponent }, { path: "addParentOrganization", component: addParentOrganization_AddParentOrganizationComponent }, { path: "rolesAndPermission", component: rolesAndPermission_RolesAndPermissionComponent }, { path: "manageOperations", component: manageOperation_component_ManageOperationComponent }, { path: "cob", component: cob_component_CobComponent }, { path: "bulkResignUpload", component: bulkResign_component_BulkResignComponent }, { path: "createRoles", component: createRolesAndPermission_CreateRolesAndPermissionComponent }, { path: "addUsers", component: addUsersToRole_AddUsersToRolesComponent }, { path: "organizationList", component: organizationList_OrganizationPage }, { path: "EmployeeInRole", component: employeesInRole_EmployeeInRoleComponent }, { path: "EmployeeInGroup", component: employeesInGroup_EmployeeInGroupComponent }, { path: "announcementProgram", component: announcements_Announcements }, { path: "bulkupload", component: bulkUpload_BulkUploadComponent }, { path: "tenantPreference", component: tenantPreference_TenantPreferenceComponent }, { path: "buildDetails", component: BuildDetailsComponent }, { path: "tenantManagement", component: TenantManagementComponent }, { path: "createTenant", component: createTenant_CreateTenantComponent }, { path: "updateTenant", component: updateTenant_UpdateTenantComponent }, { path: "notifications", component: notificationGridComponent_NotificationGridComponent }, { path: "editNotifications", component: EditNotificationComponent }, { path: "cache", component: ClearCacheComponent }, { path: "emailNotification", component: emailNotification_EmailNotification }, { path: "mobileAppManagement", component: mobileAppManagement_MobileAppManagementComponent }, { path: "passwordPolicy", component: PasswordPolicyComponent }] }, { path: "**", component: NoContentComponent }]]; }, []), core["ɵmpd"](1024, fesm5_router["l" /* Router */], fesm5_router["z" /* ɵangular_packages_router_router_f */], [core["ApplicationRef"], fesm5_router["s" /* UrlSerializer */], fesm5_router["b" /* ChildrenOutletContexts */], common["Location"], core["Injector"], core["NgModuleFactoryLoader"], core["Compiler"], fesm5_router["j" /* ROUTES */], fesm5_router["h" /* ROUTER_CONFIGURATION */], [2, fesm5_router["r" /* UrlHandlingStrategy */]], [2, fesm5_router["k" /* RouteReuseStrategy */]]]), core["ɵmpd"](1073742336, fesm5_router["o" /* RouterModule */], fesm5_router["o" /* RouterModule */], [[2, fesm5_router["u" /* ɵangular_packages_router_router_a */]], [2, fesm5_router["l" /* Router */]]]), core["ɵmpd"](1073742336, FroalaEditorModule, FroalaEditorModule, []), core["ɵmpd"](1073742336, FroalaViewModule, FroalaViewModule, []), core["ɵmpd"](1073742336, fesm5_forms["ReactiveFormsModule"], fesm5_forms["ReactiveFormsModule"], []), core["ɵmpd"](1073742336, ng2_auto_complete_module["Ng2AutoCompleteModule"], ng2_auto_complete_module["Ng2AutoCompleteModule"], []), core["ɵmpd"](1073742336, MobxAngularModule, MobxAngularModule, []), core["ɵmpd"](1073742336, TreeModule, TreeModule, []), core["ɵmpd"](1073742336, AngularMultiSelectModule, AngularMultiSelectModule, []), core["ɵmpd"](1073742336, BrowserAnimationsModule, BrowserAnimationsModule, []), core["ɵmpd"](1073742336, mention_module["MentionModule"], mention_module["MentionModule"], []), core["ɵmpd"](1073742336, EmployeeFilterModule, EmployeeFilterModule, []), core["ɵmpd"](1073742336, BIAdminModule, BIAdminModule, []), core["ɵmpd"](1073742336, QuillModule, QuillModule, []), core["ɵmpd"](1073742336, DragDropModule, DragDropModule, []), core["ɵmpd"](1073742336, inputtext["InputTextModule"], inputtext["InputTextModule"], []), core["ɵmpd"](1073742336, button_button["ButtonModule"], button_button["ButtonModule"], []), core["ɵmpd"](1073742336, shared["SharedModule"], shared["SharedModule"], []), core["ɵmpd"](1073742336, autocomplete["AutoCompleteModule"], autocomplete["AutoCompleteModule"], []), core["ɵmpd"](1073742336, UiSwitchModule, UiSwitchModule, []), core["ɵmpd"](1073742336, color_picker_module["ColorPickerModule"], color_picker_module["ColorPickerModule"], []), core["ɵmpd"](1073742336, HttpClientXsrfModule, HttpClientXsrfModule, []), core["ɵmpd"](1073742336, HttpClientModule, HttpClientModule, []), core["ɵmpd"](1073742336, ToastrModule, ToastrModule, [[3, ToastrModule]]), core["ɵmpd"](1073742336, CommonAppModule, CommonAppModule, []), core["ɵmpd"](1073742336, ImageCropperModule, ImageCropperModule, []), core["ɵmpd"](512, AppState, AppState, []), core["ɵmpd"](1073742336, app_module_AppModule, app_module_AppModule, [core["ApplicationRef"], AppState]), core["ɵmpd"](256, core["ɵAPP_ROOT"], true, []), core["ɵmpd"](256, ARIA_LIVE_DELAY, DEFAULT_ARIA_LIVE_DELAY, []), core["ɵmpd"](256, ANIMATION_MODULE_TYPE, "BrowserAnimations", []), core["ɵmpd"](256, TOAST_CONFIG, { config: { autoDismiss: true, maxOpened: 1, timeOut: 2000, positionClass: "toast-top-center", enableHtml: true }, defaults: DefaultGlobalConfig }, []), core["ɵmpd"](256, XSRF_COOKIE_NAME, "XSRF-TOKEN", []), core["ɵmpd"](256, XSRF_HEADER_NAME, "X-XSRF-TOKEN", []), core["ɵmpd"](256, core_es5["l" /* USE_STORE */], undefined, []), core["ɵmpd"](256, core_es5["k" /* USE_DEFAULT_LANG */], undefined, [])]); });




/***/ }),

/***/ "OMJi":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("fC4T");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__("LC74");

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ "ORgI":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        ss : '%d秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),

/***/ "OSsP":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        ss : '%d eilenn',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),

/***/ "OUMt":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekúnd');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),

/***/ "OVPi":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        ss : '%d sekundir',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),

/***/ "OvSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RouterModuleNgFactory */
/* unused harmony export RenderType_ɵEmptyOutletComponent */
/* unused harmony export View_ɵEmptyOutletComponent_0 */
/* unused harmony export View_ɵEmptyOutletComponent_Host_0 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ɵEmptyOutletComponentNgFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = /*@__PURE__*/__webpack_require__("yZfy");
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */
/** PURE_IMPORTS_START _angular_core,_angular_router PURE_IMPORTS_END */


var RouterModuleNgFactory = /*@__PURE__*/ __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcmf"](__WEBPACK_IMPORTED_MODULE_1__angular_router__["o" /* RouterModule */], [], function (_l) { return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmod"]([__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](512, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵCodegenComponentFactoryResolver"], [[8, [ɵEmptyOutletComponentNgFactory]], [3, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleRef"]]), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵmpd"](1073742336, __WEBPACK_IMPORTED_MODULE_1__angular_router__["o" /* RouterModule */], __WEBPACK_IMPORTED_MODULE_1__angular_router__["o" /* RouterModule */], [[2, __WEBPACK_IMPORTED_MODULE_1__angular_router__["u" /* ɵangular_packages_router_router_a */]], [2, __WEBPACK_IMPORTED_MODULE_1__angular_router__["l" /* Router */]]])]); });

var styles_ɵEmptyOutletComponent = [];
var RenderType_ɵEmptyOutletComponent = /*@__PURE__*/ __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"]({ encapsulation: 2, styles: styles_ɵEmptyOutletComponent, data: {} });

function View_ɵEmptyOutletComponent_0(_l) { return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, 16777216, null, null, 1, "router-outlet", [], null, null, null, null, null)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](1, 212992, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_router__["p" /* RouterOutlet */], [__WEBPACK_IMPORTED_MODULE_1__angular_router__["b" /* ChildrenOutletContexts */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], [8, null], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
function View_ɵEmptyOutletComponent_Host_0(_l) { return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"](0, [(_l()(), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"](0, 0, null, null, 1, "ng-component", [], null, null, null, View_ɵEmptyOutletComponent_0, RenderType_ɵEmptyOutletComponent)), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"](1, 49152, null, 0, __WEBPACK_IMPORTED_MODULE_1__angular_router__["t" /* ɵEmptyOutletComponent */], [], null, null)], null, null); }
var ɵEmptyOutletComponentNgFactory = /*@__PURE__*/ __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"]("ng-component", __WEBPACK_IMPORTED_MODULE_1__angular_router__["t" /* ɵEmptyOutletComponent */], View_ɵEmptyOutletComponent_Host_0, {}, {}, []);




/***/ }),

/***/ "PD94":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),

/***/ "PJh5":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.20.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            __webpack_require__("uslO")("./" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.20.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "POb3":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD"),
    root = __webpack_require__("TQ3y");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "PqYH":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "Q2wK":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("8AZL");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "Q7hp":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("uCi2");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "QFiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultThrottleConfig; });
/* harmony export (immutable) */ __webpack_exports__["b"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__ = /*@__PURE__*/__webpack_require__("1E73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__ = /*@__PURE__*/__webpack_require__("3SjU");
/** PURE_IMPORTS_START tslib,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */



var defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */
function throttle(durationSelector, config) {
    if (config === void 0) {
        config = defaultThrottleConfig;
    }
    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
}
var ThrottleOperator = /*@__PURE__*/ (function () {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */
var ThrottleSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        _this.durationSelector = durationSelector;
        _this._leading = _leading;
        _this._trailing = _trailing;
        _this._hasValue = false;
        return _this;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        this._hasValue = true;
        this._sendValue = value;
        if (!this._throttled) {
            if (this._leading) {
                this.send();
            }
            else {
                this.throttle(value);
            }
        }
    };
    ThrottleSubscriber.prototype.send = function () {
        var _a = this, _hasValue = _a._hasValue, _sendValue = _a._sendValue;
        if (_hasValue) {
            this.destination.next(_sendValue);
            this.throttle(_sendValue);
        }
        this._hasValue = false;
        this._sendValue = null;
    };
    ThrottleSubscriber.prototype.throttle = function (value) {
        var duration = this.tryDurationSelector(value);
        if (duration) {
            this.add(this._throttled = Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToResult__["a" /* subscribeToResult */])(this, duration));
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        try {
            return this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    ThrottleSubscriber.prototype.throttlingDone = function () {
        var _a = this, _throttled = _a._throttled, _trailing = _a._trailing;
        if (_throttled) {
            _throttled.unsubscribe();
        }
        this._throttled = null;
        if (_trailing) {
            this.send();
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.throttlingDone();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this.throttlingDone();
    };
    return ThrottleSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__OuterSubscriber__["a" /* OuterSubscriber */]));





/***/ }),

/***/ "QX4X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return async; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncAction__ = /*@__PURE__*/__webpack_require__("2mZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = /*@__PURE__*/__webpack_require__("g8cW");
/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */


/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */
var async = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */](__WEBPACK_IMPORTED_MODULE_0__AsyncAction__["a" /* AsyncAction */]);
//# sourceMappingURL=async.js.map


/***/ }),

/***/ "Qp3N":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn"),
    isArguments = __webpack_require__("1Yb9"),
    isArray = __webpack_require__("NGEn");

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ "RGrk":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dCZQ");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "RVHk":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "RfZv":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("SOZo"),
    hasPath = __webpack_require__("IGcM");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "Rh28":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "RlMM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var formats_1 = __webpack_require__("3BtS");
var ColorPickerService = /*@__PURE__*/ (function () {
    function ColorPickerService() {
        this.active = null;
    }
    ColorPickerService.prototype.setActive = function (active) {
        if (this.active && this.active !== active && this.active.cpDialogDisplay !== 'inline') {
            this.active.closeColorPicker();
        }
        this.active = active;
    };
    ColorPickerService.prototype.hsla2hsva = function (hsla) {
        var h = Math.min(hsla.h, 1), s = Math.min(hsla.s, 1), l = Math.min(hsla.l, 1), a = Math.min(hsla.a, 1);
        if (l === 0) {
            return new formats_1.Hsva(h, 0, 0, a);
        }
        else {
            var v = l + s * (1 - Math.abs(2 * l - 1)) / 2;
            return new formats_1.Hsva(h, 2 * (v - l) / v, v, a);
        }
    };
    ColorPickerService.prototype.hsva2hsla = function (hsva) {
        var h = hsva.h, s = hsva.s, v = hsva.v, a = hsva.a;
        if (v === 0) {
            return new formats_1.Hsla(h, 0, 0, a);
        }
        else if (s === 0 && v === 1) {
            return new formats_1.Hsla(h, 1, 1, a);
        }
        else {
            var l = v * (2 - s) / 2;
            return new formats_1.Hsla(h, v * s / (1 - Math.abs(2 * l - 1)), l, a);
        }
    };
    ColorPickerService.prototype.rgbaToHsva = function (rgba) {
        var r = Math.min(rgba.r, 1), g = Math.min(rgba.g, 1), b = Math.min(rgba.b, 1), a = Math.min(rgba.a, 1);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max === min) {
            h = 0;
        }
        else {
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return new formats_1.Hsva(h, s, v, a);
    };
    ColorPickerService.prototype.hsvaToRgba = function (hsva) {
        var h = hsva.h, s = hsva.s, v = hsva.v, a = hsva.a;
        var r, g, b;
        var i = Math.floor(h * 6);
        var f = h * 6 - i;
        var p = v * (1 - s);
        var q = v * (1 - f * s);
        var t = v * (1 - (1 - f) * s);
        switch (i % 6) {
            case 0:
                r = v, g = t, b = p;
                break;
            case 1:
                r = q, g = v, b = p;
                break;
            case 2:
                r = p, g = v, b = t;
                break;
            case 3:
                r = p, g = q, b = v;
                break;
            case 4:
                r = t, g = p, b = v;
                break;
            case 5:
                r = v, g = p, b = q;
                break;
        }
        return new formats_1.Rgba(r, g, b, a);
    };
    ColorPickerService.prototype.stringToHsva = function (colorString, allowHex8) {
        if (colorString === void 0) {
            colorString = '';
        }
        if (allowHex8 === void 0) {
            allowHex8 = false;
        }
        var stringParsers = [
            {
                re: /(rgb)a?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*%?,\s*(\d{1,3})\s*%?(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                parse: function (execResult) {
                    return new formats_1.Rgba(parseInt(execResult[2]) / 255, parseInt(execResult[3]) / 255, parseInt(execResult[4]) / 255, isNaN(parseFloat(execResult[5])) ? 1 : parseFloat(execResult[5]));
                }
            },
            {
                re: /(hsl)a?\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
                parse: function (execResult) {
                    return new formats_1.Hsla(parseInt(execResult[2]) / 360, parseInt(execResult[3]) / 100, parseInt(execResult[4]) / 100, isNaN(parseFloat(execResult[5])) ? 1 : parseFloat(execResult[5]));
                }
            }
        ];
        if (allowHex8) {
            stringParsers.push({
                re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})?$/,
                parse: function (execResult) {
                    return new formats_1.Rgba(parseInt(execResult[1], 16) / 255, parseInt(execResult[2], 16) / 255, parseInt(execResult[3], 16) / 255, parseInt(execResult[4] || 'FF', 16) / 255);
                }
            });
        }
        else {
            stringParsers.push({
                re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})$/,
                parse: function (execResult) {
                    return new formats_1.Rgba(parseInt(execResult[1], 16) / 255, parseInt(execResult[2], 16) / 255, parseInt(execResult[3], 16) / 255, 1);
                }
            }, {
                re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])$/,
                parse: function (execResult) {
                    return new formats_1.Rgba(parseInt(execResult[1] + execResult[1], 16) / 255, parseInt(execResult[2] + execResult[2], 16) / 255, parseInt(execResult[3] + execResult[3], 16) / 255, 1);
                }
            });
        }
        colorString = (colorString || '').toLowerCase();
        var hsva = null;
        for (var key in stringParsers) {
            if (stringParsers.hasOwnProperty(key)) {
                var parser = stringParsers[key];
                var match = parser.re.exec(colorString), color = match && parser.parse(match);
                if (color) {
                    if (color instanceof formats_1.Rgba) {
                        hsva = this.rgbaToHsva(color);
                    }
                    else if (color instanceof formats_1.Hsla) {
                        hsva = this.hsla2hsva(color);
                    }
                    return hsva;
                }
            }
        }
        return hsva;
    };
    ColorPickerService.prototype.outputFormat = function (hsva, outputFormat, alphaChannel) {
        switch (outputFormat) {
            case 'hsla':
                var hsla = this.hsva2hsla(hsva);
                var hslaText = new formats_1.Hsla(Math.round((hsla.h) * 360), Math.round(hsla.s * 100), Math.round(hsla.l * 100), Math.round(hsla.a * 100) / 100);
                if (hsva.a < 1 || alphaChannel === 'always') {
                    return 'hsla(' + hslaText.h + ',' + hslaText.s + '%,' + hslaText.l + '%,' + hslaText.a + ')';
                }
                else {
                    return 'hsl(' + hslaText.h + ',' + hslaText.s + '%,' + hslaText.l + '%)';
                }
            case 'rgba':
                var rgba = this.denormalizeRGBA(this.hsvaToRgba(hsva));
                if (hsva.a < 1 || alphaChannel === 'always') {
                    return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + Math.round(rgba.a * 100) / 100 + ')';
                }
                else {
                    return 'rgb(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ')';
                }
            default:
                return this.hexText(this.denormalizeRGBA(this.hsvaToRgba(hsva)), alphaChannel === 'always' || alphaChannel === 'hex8');
        }
    };
    ColorPickerService.prototype.hexText = function (rgba, allowHex8) {
        var hexText = '#' + ((1 << 24) | (rgba.r << 16) | (rgba.g << 8) | rgba.b).toString(16).substr(1);
        /*if (hexText[1] === hexText[2] && hexText[3] === hexText[4] && hexText[5] === hexText[6] && !allowHex8) {
            hexText = '#' + hexText[1] + hexText[3] + hexText[5];
        }*/
        if (allowHex8) {
            hexText += ((1 << 8) | Math.round(rgba.a * 255)).toString(16).substr(1);
        }
        return hexText;
    };
    ColorPickerService.prototype.denormalizeRGBA = function (rgba) {
        return new formats_1.Rgba(Math.round(rgba.r * 255), Math.round(rgba.g * 255), Math.round(rgba.b * 255), rgba.a);
    };
    ColorPickerService.decorators = [
        { type: core_1.Injectable },
    ];
    return ColorPickerService;
}());
exports.ColorPickerService = ColorPickerService;



/***/ }),

/***/ "RnJI":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        ss : '%d წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),

/***/ "S/3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return environment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = /*@__PURE__*/__webpack_require__("5D2H");
/* tslint:disable */


Error.stackTraceLimit = Infinity;
__webpack_require__("9/kn");
var environment = {
    production: false,
    showDevModule: true,
    styleUrls: '../styles/styles.scss',
    client: 'KEA',
    appTitle: 'entomo',
    /** Angular debug tools in the dev console
     * https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
     * @param modRef
     * @return {any}
     */
    decorateModuleRef: function (modRef) {
        var appRef = modRef.injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"]);
        var cmpRef = appRef.components[0];
        var _ng = window.ng;
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["i" /* enableDebugTools */])(cmpRef);
        window.ng.probe = _ng.probe;
        window.ng.coreTokens = _ng.coreTokens;
        return modRef;
    },
    ENV_PROVIDERS: []
};


/***/ }),

/***/ "S/xh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concat;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isScheduler__ = /*@__PURE__*/__webpack_require__("5eyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__of__ = /*@__PURE__*/__webpack_require__("MnTv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from__ = /*@__PURE__*/__webpack_require__("5XgX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_concatAll__ = /*@__PURE__*/__webpack_require__("K3Sm");
/** PURE_IMPORTS_START _util_isScheduler,_of,_from,_operators_concatAll PURE_IMPORTS_END */




/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1 || (observables.length === 2 && Object(__WEBPACK_IMPORTED_MODULE_0__util_isScheduler__["a" /* isScheduler */])(observables[1]))) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__from__["a" /* from */])(observables[0]);
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__operators_concatAll__["a" /* concatAll */])()(__WEBPACK_IMPORTED_MODULE_1__of__["a" /* of */].apply(void 0, observables));
}
//# sourceMappingURL=concat.js.map


/***/ }),

/***/ "S7p9":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "SAuu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__ = /*@__PURE__*/__webpack_require__("Egod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observer__ = /*@__PURE__*/__webpack_require__("ESBe");
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */



function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */]) {
            return nextOrObserver;
        }
        if (nextOrObserver[__WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__["a" /* rxSubscriber */]]) {
            return nextOrObserver[__WEBPACK_IMPORTED_MODULE_1__symbol_rxSubscriber__["a" /* rxSubscriber */]]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */](__WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */]);
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* Subscriber */](nextOrObserver, error, complete);
}
//# sourceMappingURL=toSubscriber.js.map


/***/ }),

/***/ "SHWz":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("MoMe");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "SOZo":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "SQxw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorObject; });
// typeof any so that it we don't have to cast when comparing a result to the error object
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map


/***/ }),

/***/ "SYCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = groupBy;
/* unused harmony export GroupedObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subject__ = /*@__PURE__*/__webpack_require__("tUzZ");
/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */





/* tslint:enable:max-line-length */
/**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function (source) {
        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
var GroupByOperator = /*@__PURE__*/ (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupBySubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        var _this = _super.call(this, destination) || this;
        _this.keySelector = keySelector;
        _this.elementSelector = elementSelector;
        _this.durationSelector = durationSelector;
        _this.subjectSelector = subjectSelector;
        _this.groups = null;
        _this.attemptedToUnsubscribe = false;
        _this.count = 0;
        return _this;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = new Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = (this.subjectSelector ? this.subjectSelector() : new __WEBPACK_IMPORTED_MODULE_4__Subject__["b" /* Subject */]());
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupDurationSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        var _this = _super.call(this, group) || this;
        _this.key = key;
        _this.group = group;
        _this.parent = parent;
        return _this;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this.complete();
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    GroupDurationSubscriber.prototype._unsubscribe = function () {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) {
            parent.removeGroup(key);
        }
    };
    return GroupDurationSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */
var GroupedObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](GroupedObservable, _super);
    /** @deprecated Do not construct this type. Internal use only */
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    /** @deprecated This is an internal implementation detail, do not use. */
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */]();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(__WEBPACK_IMPORTED_MODULE_3__Observable__["a" /* Observable */]));

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(__WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* Subscription */]));





/***/ }),

/***/ "SfPD":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./+child-barrel.ngfactory": [
		"cK1S",
		1
	],
	"./+child-detail.ngfactory": [
		"NNTw",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "SfPD";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "Sjoy":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),

/***/ "T/bE":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("94sX"),
    hashDelete = __webpack_require__("ue/d"),
    hashGet = __webpack_require__("eVIm"),
    hashHas = __webpack_require__("RGrk"),
    hashSet = __webpack_require__("Z2pD");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "T3q3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_http_http_e", function() { return BrowserJsonp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_http_http_f", function() { return Body; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_http_http_a", function() { return _createDefaultCookieXSRFStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_http_http_b", function() { return httpFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_http_http_c", function() { return jsonpFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserXhr", function() { return BrowserXhr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JSONPBackend", function() { return JSONPBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JSONPConnection", function() { return JSONPConnection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CookieXSRFStrategy", function() { return CookieXSRFStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XHRBackend", function() { return XHRBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XHRConnection", function() { return XHRConnection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseRequestOptions", function() { return BaseRequestOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequestOptions", function() { return RequestOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseResponseOptions", function() { return BaseResponseOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponseOptions", function() { return ResponseOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReadyState", function() { return ReadyState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequestMethod", function() { return RequestMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponseContentType", function() { return ResponseContentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponseType", function() { return ResponseType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Headers", function() { return Headers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Http", function() { return Http; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jsonp", function() { return Jsonp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HttpModule", function() { return HttpModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonpModule", function() { return JsonpModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Connection", function() { return Connection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectionBackend", function() { return ConnectionBackend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XSRFStrategy", function() { return XSRFStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Request", function() { return Request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Response", function() { return Response; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryEncoder", function() { return QueryEncoder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "URLSearchParams", function() { return URLSearchParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = /*@__PURE__*/__webpack_require__("0nHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = /*@__PURE__*/__webpack_require__("5D2H");
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START tslib,_angular_core,rxjs,_angular_platform_browser PURE_IMPORTS_END */




/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A backend for http that uses the `XMLHttpRequest` browser API.
 *
 * Take care not to evaluate this in non-browser contexts.
 *
 * @deprecated see https://angular.io/guide/http
 */
var BrowserXhr = /*@__PURE__*/ (function () {
    function BrowserXhr() {
    }
    BrowserXhr.prototype.build = function () { return (new XMLHttpRequest()); };
    return BrowserXhr;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Supported http methods.
 * @deprecated see https://angular.io/guide/http
 */
var RequestMethod = /*@__PURE__*/ (function (RequestMethod) {
    RequestMethod[RequestMethod["Get"] = 0] = "Get";
    RequestMethod[RequestMethod["Post"] = 1] = "Post";
    RequestMethod[RequestMethod["Put"] = 2] = "Put";
    RequestMethod[RequestMethod["Delete"] = 3] = "Delete";
    RequestMethod[RequestMethod["Options"] = 4] = "Options";
    RequestMethod[RequestMethod["Head"] = 5] = "Head";
    RequestMethod[RequestMethod["Patch"] = 6] = "Patch";
    return RequestMethod;
})({});
/**
 * All possible states in which a connection can be, based on
 * [States](http://www.w3.org/TR/XMLHttpRequest/#states) from the `XMLHttpRequest` spec, but with an
 * additional "CANCELLED" state.
 * @deprecated see https://angular.io/guide/http
 */
var ReadyState = /*@__PURE__*/ (function (ReadyState) {
    ReadyState[ReadyState["Unsent"] = 0] = "Unsent";
    ReadyState[ReadyState["Open"] = 1] = "Open";
    ReadyState[ReadyState["HeadersReceived"] = 2] = "HeadersReceived";
    ReadyState[ReadyState["Loading"] = 3] = "Loading";
    ReadyState[ReadyState["Done"] = 4] = "Done";
    ReadyState[ReadyState["Cancelled"] = 5] = "Cancelled";
    return ReadyState;
})({});
/**
 * Acceptable response types to be associated with a {@link Response}, based on
 * [ResponseType](https://fetch.spec.whatwg.org/#responsetype) from the Fetch spec.
 * @deprecated see https://angular.io/guide/http
 */
var ResponseType = /*@__PURE__*/ (function (ResponseType) {
    ResponseType[ResponseType["Basic"] = 0] = "Basic";
    ResponseType[ResponseType["Cors"] = 1] = "Cors";
    ResponseType[ResponseType["Default"] = 2] = "Default";
    ResponseType[ResponseType["Error"] = 3] = "Error";
    ResponseType[ResponseType["Opaque"] = 4] = "Opaque";
    return ResponseType;
})({});
/**
 * Supported content type to be automatically associated with a {@link Request}.
 * @deprecated see https://angular.io/guide/http
 */
var ContentType = /*@__PURE__*/ (function (ContentType) {
    ContentType[ContentType["NONE"] = 0] = "NONE";
    ContentType[ContentType["JSON"] = 1] = "JSON";
    ContentType[ContentType["FORM"] = 2] = "FORM";
    ContentType[ContentType["FORM_DATA"] = 3] = "FORM_DATA";
    ContentType[ContentType["TEXT"] = 4] = "TEXT";
    ContentType[ContentType["BLOB"] = 5] = "BLOB";
    ContentType[ContentType["ARRAY_BUFFER"] = 6] = "ARRAY_BUFFER";
    return ContentType;
})({});
/**
 * Define which buffer to use to store the response
 * @deprecated see https://angular.io/guide/http
 */
var ResponseContentType = /*@__PURE__*/ (function (ResponseContentType) {
    ResponseContentType[ResponseContentType["Text"] = 0] = "Text";
    ResponseContentType[ResponseContentType["Json"] = 1] = "Json";
    ResponseContentType[ResponseContentType["ArrayBuffer"] = 2] = "ArrayBuffer";
    ResponseContentType[ResponseContentType["Blob"] = 3] = "Blob";
    return ResponseContentType;
})({});
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Polyfill for [Headers](https://developer.mozilla.org/en-US/docs/Web/API/Headers/Headers), as
 * specified in the [Fetch Spec](https://fetch.spec.whatwg.org/#headers-class).
 *
 * The only known difference between this `Headers` implementation and the spec is the
 * lack of an `entries` method.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * import {Headers} from '@angular/http';
 *
 * var firstHeaders = new Headers();
 * firstHeaders.append('Content-Type', 'image/jpeg');
 * console.log(firstHeaders.get('Content-Type')) //'image/jpeg'
 *
 * // Create headers from Plain Old JavaScript Object
 * var secondHeaders = new Headers({
 *   'X-My-Custom-Header': 'Angular'
 * });
 * console.log(secondHeaders.get('X-My-Custom-Header')); //'Angular'
 *
 * var thirdHeaders = new Headers(secondHeaders);
 * console.log(thirdHeaders.get('X-My-Custom-Header')); //'Angular'
 * ```
 *
 * @deprecated see https://angular.io/guide/http
 */
var Headers = /*@__PURE__*/ (function () {
    // TODO(vicb): any -> string|string[]
    function Headers(headers) {
        var _this = this;
        /** @internal header names are lower case */
        this._headers = new Map();
        /** @internal map lower case names to actual names */
        this._normalizedNames = new Map();
        if (!headers) {
            return;
        }
        if (headers instanceof Headers) {
            headers.forEach(function (values, name) {
                values.forEach(function (value) { return _this.append(name, value); });
            });
            return;
        }
        Object.keys(headers).forEach(function (name) {
            var values = Array.isArray(headers[name]) ? headers[name] : [headers[name]];
            _this.delete(name);
            values.forEach(function (value) { return _this.append(name, value); });
        });
    }
    /**
     * Returns a new Headers instance from the given DOMString of Response Headers
     */
    Headers.fromResponseHeaderString = function (headersString) {
        var headers = new Headers();
        headersString.split('\n').forEach(function (line) {
            var index = line.indexOf(':');
            if (index > 0) {
                var name_1 = line.slice(0, index);
                var value = line.slice(index + 1).trim();
                headers.set(name_1, value);
            }
        });
        return headers;
    };
    /**
     * Appends a header to existing list of header values for a given header name.
     */
    Headers.prototype.append = function (name, value) {
        var values = this.getAll(name);
        if (values === null) {
            this.set(name, value);
        }
        else {
            values.push(value);
        }
    };
    /**
     * Deletes all header values for the given name.
     */
    Headers.prototype.delete = function (name) {
        var lcName = name.toLowerCase();
        this._normalizedNames.delete(lcName);
        this._headers.delete(lcName);
    };
    Headers.prototype.forEach = function (fn) {
        var _this = this;
        this._headers.forEach(function (values, lcName) { return fn(values, _this._normalizedNames.get(lcName), _this._headers); });
    };
    /**
     * Returns first header that matches given name.
     */
    Headers.prototype.get = function (name) {
        var values = this.getAll(name);
        if (values === null) {
            return null;
        }
        return values.length > 0 ? values[0] : null;
    };
    /**
     * Checks for existence of header by given name.
     */
    Headers.prototype.has = function (name) { return this._headers.has(name.toLowerCase()); };
    /**
     * Returns the names of the headers
     */
    Headers.prototype.keys = function () { return Array.from(this._normalizedNames.values()); };
    /**
     * Sets or overrides header value for given name.
     */
    Headers.prototype.set = function (name, value) {
        if (Array.isArray(value)) {
            if (value.length) {
                this._headers.set(name.toLowerCase(), [value.join(',')]);
            }
        }
        else {
            this._headers.set(name.toLowerCase(), [value]);
        }
        this.mayBeSetNormalizedName(name);
    };
    /**
     * Returns values of all headers.
     */
    Headers.prototype.values = function () { return Array.from(this._headers.values()); };
    /**
     * Returns string of all headers.
     */
    // TODO(vicb): returns {[name: string]: string[]}
    Headers.prototype.toJSON = function () {
        var _this = this;
        var serialized = {};
        this._headers.forEach(function (values, name) {
            var split = [];
            values.forEach(function (v) { return split.push.apply(split, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(v.split(','))); });
            serialized[_this._normalizedNames.get(name)] = split;
        });
        return serialized;
    };
    /**
     * Returns list of header values for a given name.
     */
    Headers.prototype.getAll = function (name) {
        return this.has(name) ? this._headers.get(name.toLowerCase()) || null : null;
    };
    /**
     * This method is not implemented.
     */
    Headers.prototype.entries = function () { throw new Error('"entries" method is not implemented on Headers class'); };
    Headers.prototype.mayBeSetNormalizedName = function (name) {
        var lcName = name.toLowerCase();
        if (!this._normalizedNames.has(lcName)) {
            this._normalizedNames.set(lcName, name);
        }
    };
    return Headers;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates a response options object to be optionally provided when instantiating a
 * {@link Response}.
 *
 * This class is based on the `ResponseInit` description in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#responseinit).
 *
 * All values are null by default. Typical defaults can be found in the
 * {@link BaseResponseOptions} class, which sub-classes `ResponseOptions`.
 *
 * This class may be used in tests to build {@link Response Responses} for
 * mock responses (see {@link MockBackend}).
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * import {ResponseOptions, Response} from '@angular/http';
 *
 * var options = new ResponseOptions({
 *   body: '{"name":"Jeff"}'
 * });
 * var res = new Response(options);
 *
 * console.log('res.json():', res.json()); // Object {name: "Jeff"}
 * ```
 *
 * @deprecated see https://angular.io/guide/http
 */
var ResponseOptions = /*@__PURE__*/ (function () {
    function ResponseOptions(opts) {
        if (opts === void 0) {
            opts = {};
        }
        var body = opts.body, status = opts.status, headers = opts.headers, statusText = opts.statusText, type = opts.type, url = opts.url;
        this.body = body != null ? body : null;
        this.status = status != null ? status : null;
        this.headers = headers != null ? headers : null;
        this.statusText = statusText != null ? statusText : null;
        this.type = type != null ? type : null;
        this.url = url != null ? url : null;
    }
    /**
     * Creates a copy of the `ResponseOptions` instance, using the optional input as values to
     * override
     * existing values. This method will not change the values of the instance on which it is being
     * called.
     *
     * This may be useful when sharing a base `ResponseOptions` object inside tests,
     * where certain properties may change from test to test.
     *
     * @usageNotes
     * ### Example
     *
     * ```typescript
     * import {ResponseOptions, Response} from '@angular/http';
     *
     * var options = new ResponseOptions({
     *   body: {name: 'Jeff'}
     * });
     * var res = new Response(options.merge({
     *   url: 'https://google.com'
     * }));
     * console.log('options.url:', options.url); // null
     * console.log('res.json():', res.json()); // Object {name: "Jeff"}
     * console.log('res.url:', res.url); // https://google.com
     * ```
     */
    ResponseOptions.prototype.merge = function (options) {
        return new ResponseOptions({
            body: options && options.body != null ? options.body : this.body,
            status: options && options.status != null ? options.status : this.status,
            headers: options && options.headers != null ? options.headers : this.headers,
            statusText: options && options.statusText != null ? options.statusText : this.statusText,
            type: options && options.type != null ? options.type : this.type,
            url: options && options.url != null ? options.url : this.url,
        });
    };
    return ResponseOptions;
}());
/**
 * Subclass of {@link ResponseOptions}, with default values.
 *
 * Default values:
 *  * status: 200
 *  * headers: empty {@link Headers} object
 *
 * This class could be extended and bound to the {@link ResponseOptions} class
 * when configuring an {@link Injector}, in order to override the default options
 * used by {@link Http} to create {@link Response Responses}.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * import {provide} from '@angular/core';
 * import {bootstrap} from '@angular/platform-browser/browser';
 * import {HTTP_PROVIDERS, Headers, Http, BaseResponseOptions, ResponseOptions} from
 * '@angular/http';
 * import {App} from './myapp';
 *
 * class MyOptions extends BaseResponseOptions {
 *   headers:Headers = new Headers({network: 'github'});
 * }
 *
 * bootstrap(App, [HTTP_PROVIDERS, {provide: ResponseOptions, useClass: MyOptions}]);
 * ```
 *
 * The options could also be extended when manually creating a {@link Response}
 * object.
 *
 * ### Example
 *
 * ```
 * import {BaseResponseOptions, Response} from '@angular/http';
 *
 * var options = new BaseResponseOptions();
 * var res = new Response(options.merge({
 *   body: 'Angular',
 *   headers: new Headers({framework: 'angular'})
 * }));
 * console.log('res.headers.get("framework"):', res.headers.get('framework')); // angular
 * console.log('res.text():', res.text()); // Angular;
 * ```
 *
 * @deprecated see https://angular.io/guide/http
 */
var BaseResponseOptions = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(BaseResponseOptions, _super);
    function BaseResponseOptions() {
        return _super.call(this, { status: 200, statusText: 'Ok', type: ResponseType.Default, headers: new Headers() }) || this;
    }
    return BaseResponseOptions;
}(ResponseOptions));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Abstract class from which real backends are derived.
 *
 * The primary purpose of a `ConnectionBackend` is to create new connections to fulfill a given
 * {@link Request}.
 *
 * @deprecated see https://angular.io/guide/http
 */
var ConnectionBackend = /*@__PURE__*/ (function () {
    function ConnectionBackend() {
    }
    return ConnectionBackend;
}());
/**
 * Abstract class from which real connections are derived.
 *
 * @deprecated see https://angular.io/guide/http
 */
var Connection = /*@__PURE__*/ (function () {
    function Connection() {
    }
    return Connection;
}());
/**
 * An XSRFStrategy configures XSRF protection (e.g. via headers) on an HTTP request.
 *
 * @deprecated see https://angular.io/guide/http
 */
var XSRFStrategy = /*@__PURE__*/ (function () {
    function XSRFStrategy() {
    }
    return XSRFStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function normalizeMethodName(method) {
    if (typeof method !== 'string')
        return method;
    switch (method.toUpperCase()) {
        case 'GET':
            return RequestMethod.Get;
        case 'POST':
            return RequestMethod.Post;
        case 'PUT':
            return RequestMethod.Put;
        case 'DELETE':
            return RequestMethod.Delete;
        case 'OPTIONS':
            return RequestMethod.Options;
        case 'HEAD':
            return RequestMethod.Head;
        case 'PATCH':
            return RequestMethod.Patch;
    }
    throw new Error("Invalid request method. The method \"" + method + "\" is not supported.");
}
var isSuccess = function (status) { return (status >= 200 && status < 300); };
function getResponseURL(xhr) {
    if ('responseURL' in xhr) {
        return xhr.responseURL;
    }
    if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
        return xhr.getResponseHeader('X-Request-URL');
    }
    return null;
}
function stringToArrayBuffer(input) {
    var view = new Uint16Array(input.length);
    for (var i = 0, strLen = input.length; i < strLen; i++) {
        view[i] = input.charCodeAt(i);
    }
    return view.buffer;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function paramParser(rawParams) {
    if (rawParams === void 0) {
        rawParams = '';
    }
    var map = new Map();
    if (rawParams.length > 0) {
        var params = rawParams.split('&');
        params.forEach(function (param) {
            var eqIdx = param.indexOf('=');
            var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(eqIdx == -1 ? [param, ''] : [param.slice(0, eqIdx), param.slice(eqIdx + 1)], 2), key = _a[0], val = _a[1];
            var list = map.get(key) || [];
            list.push(val);
            map.set(key, list);
        });
    }
    return map;
}
/**
 * @deprecated see https://angular.io/guide/http
 **/
var QueryEncoder = /*@__PURE__*/ (function () {
    function QueryEncoder() {
    }
    QueryEncoder.prototype.encodeKey = function (key) { return standardEncoding(key); };
    QueryEncoder.prototype.encodeValue = function (value) { return standardEncoding(value); };
    return QueryEncoder;
}());
function standardEncoding(v) {
    return encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%2B/gi, '+')
        .replace(/%3D/gi, '=')
        .replace(/%3F/gi, '?')
        .replace(/%2F/gi, '/');
}
/**
 * Map-like representation of url search parameters, based on
 * [URLSearchParams](https://url.spec.whatwg.org/#urlsearchparams) in the url living standard,
 * with several extensions for merging URLSearchParams objects:
 *   - setAll()
 *   - appendAll()
 *   - replaceAll()
 *
 * This class accepts an optional second parameter of ${@link QueryEncoder},
 * which is used to serialize parameters before making a request. By default,
 * `QueryEncoder` encodes keys and values of parameters using `encodeURIComponent`,
 * and then un-encodes certain characters that are allowed to be part of the query
 * according to IETF RFC 3986: https://tools.ietf.org/html/rfc3986.
 *
 * These are the characters that are not encoded: `! $ \' ( ) * + , ; A 9 - . _ ~ ? /`
 *
 * If the set of allowed query characters is not acceptable for a particular backend,
 * `QueryEncoder` can be subclassed and provided as the 2nd argument to URLSearchParams.
 *
 * ```
 * import {URLSearchParams, QueryEncoder} from '@angular/http';
 * class MyQueryEncoder extends QueryEncoder {
 *   encodeKey(k: string): string {
 *     return myEncodingFunction(k);
 *   }
 *
 *   encodeValue(v: string): string {
 *     return myEncodingFunction(v);
 *   }
 * }
 *
 * let params = new URLSearchParams('', new MyQueryEncoder());
 * ```
 * @deprecated see https://angular.io/guide/http
 */
var URLSearchParams = /*@__PURE__*/ (function () {
    function URLSearchParams(rawParams, queryEncoder) {
        if (rawParams === void 0) {
            rawParams = '';
        }
        if (queryEncoder === void 0) {
            queryEncoder = new QueryEncoder();
        }
        this.rawParams = rawParams;
        this.queryEncoder = queryEncoder;
        this.paramsMap = paramParser(rawParams);
    }
    URLSearchParams.prototype.clone = function () {
        var clone = new URLSearchParams('', this.queryEncoder);
        clone.appendAll(this);
        return clone;
    };
    URLSearchParams.prototype.has = function (param) { return this.paramsMap.has(param); };
    URLSearchParams.prototype.get = function (param) {
        var storedParam = this.paramsMap.get(param);
        return Array.isArray(storedParam) ? storedParam[0] : null;
    };
    URLSearchParams.prototype.getAll = function (param) { return this.paramsMap.get(param) || []; };
    URLSearchParams.prototype.set = function (param, val) {
        if (val === void 0 || val === null) {
            this.delete(param);
            return;
        }
        var list = this.paramsMap.get(param) || [];
        list.length = 0;
        list.push(val);
        this.paramsMap.set(param, list);
    };
    // A merge operation
    // For each name-values pair in `searchParams`, perform `set(name, values[0])`
    //
    // E.g: "a=[1,2,3], c=[8]" + "a=[4,5,6], b=[7]" = "a=[4], c=[8], b=[7]"
    //
    // TODO(@caitp): document this better
    URLSearchParams.prototype.setAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var list = _this.paramsMap.get(param) || [];
            list.length = 0;
            list.push(value[0]);
            _this.paramsMap.set(param, list);
        });
    };
    URLSearchParams.prototype.append = function (param, val) {
        if (val === void 0 || val === null)
            return;
        var list = this.paramsMap.get(param) || [];
        list.push(val);
        this.paramsMap.set(param, list);
    };
    // A merge operation
    // For each name-values pair in `searchParams`, perform `append(name, value)`
    // for each value in `values`.
    //
    // E.g: "a=[1,2], c=[8]" + "a=[3,4], b=[7]" = "a=[1,2,3,4], c=[8], b=[7]"
    //
    // TODO(@caitp): document this better
    URLSearchParams.prototype.appendAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var list = _this.paramsMap.get(param) || [];
            for (var i = 0; i < value.length; ++i) {
                list.push(value[i]);
            }
            _this.paramsMap.set(param, list);
        });
    };
    // A merge operation
    // For each name-values pair in `searchParams`, perform `delete(name)`,
    // followed by `set(name, values)`
    //
    // E.g: "a=[1,2,3], c=[8]" + "a=[4,5,6], b=[7]" = "a=[4,5,6], c=[8], b=[7]"
    //
    // TODO(@caitp): document this better
    URLSearchParams.prototype.replaceAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var list = _this.paramsMap.get(param) || [];
            list.length = 0;
            for (var i = 0; i < value.length; ++i) {
                list.push(value[i]);
            }
            _this.paramsMap.set(param, list);
        });
    };
    URLSearchParams.prototype.toString = function () {
        var _this = this;
        var paramsList = [];
        this.paramsMap.forEach(function (values, k) {
            values.forEach(function (v) { return paramsList.push(_this.queryEncoder.encodeKey(k) + '=' + _this.queryEncoder.encodeValue(v)); });
        });
        return paramsList.join('&');
    };
    URLSearchParams.prototype.delete = function (param) { this.paramsMap.delete(param); };
    return URLSearchParams;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * HTTP request body used by both {@link Request} and {@link Response}
 * https://fetch.spec.whatwg.org/#body
 */
var Body = /*@__PURE__*/ (function () {
    function Body() {
    }
    /**
     * Attempts to return body as parsed `JSON` object, or raises an exception.
     */
    Body.prototype.json = function () {
        if (typeof this._body === 'string') {
            return JSON.parse(this._body);
        }
        if (this._body instanceof ArrayBuffer) {
            return JSON.parse(this.text());
        }
        return this._body;
    };
    /**
     * Returns the body as a string, presuming `toString()` can be called on the response body.
     *
     * When decoding an `ArrayBuffer`, the optional `encodingHint` parameter determines how the
     * bytes in the buffer will be interpreted. Valid values are:
     *
     * - `legacy` - incorrectly interpret the bytes as UTF-16 (technically, UCS-2). Only characters
     *   in the Basic Multilingual Plane are supported, surrogate pairs are not handled correctly.
     *   In addition, the endianness of the 16-bit octet pairs in the `ArrayBuffer` is not taken
     *   into consideration. This is the default behavior to avoid breaking apps, but should be
     *   considered deprecated.
     *
     * - `iso-8859` - interpret the bytes as ISO-8859 (which can be used for ASCII encoded text).
     */
    Body.prototype.text = function (encodingHint) {
        if (encodingHint === void 0) {
            encodingHint = 'legacy';
        }
        if (this._body instanceof URLSearchParams) {
            return this._body.toString();
        }
        if (this._body instanceof ArrayBuffer) {
            switch (encodingHint) {
                case 'legacy':
                    return String.fromCharCode.apply(null, new Uint16Array(this._body));
                case 'iso-8859':
                    return String.fromCharCode.apply(null, new Uint8Array(this._body));
                default:
                    throw new Error("Invalid value for encodingHint: " + encodingHint);
            }
        }
        if (this._body == null) {
            return '';
        }
        if (typeof this._body === 'object') {
            return JSON.stringify(this._body, null, 2);
        }
        return this._body.toString();
    };
    /**
     * Return the body as an ArrayBuffer
     */
    Body.prototype.arrayBuffer = function () {
        if (this._body instanceof ArrayBuffer) {
            return this._body;
        }
        return stringToArrayBuffer(this.text());
    };
    /**
      * Returns the request's body as a Blob, assuming that body exists.
      */
    Body.prototype.blob = function () {
        if (this._body instanceof Blob) {
            return this._body;
        }
        if (this._body instanceof ArrayBuffer) {
            return new Blob([this._body]);
        }
        throw new Error('The request body isn\'t either a blob or an array buffer');
    };
    return Body;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates `Response` instances from provided values.
 *
 * Though this object isn't
 * usually instantiated by end-users, it is the primary object interacted with when it comes time to
 * add data to a view.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * http.request('my-friends.txt').subscribe(response => this.friends = response.text());
 * ```
 *
 * The Response's interface is inspired by the Response constructor defined in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#response-class), but is considered a static value whose body
 * can be accessed many times. There are other differences in the implementation, but this is the
 * most significant.
 *
 * @deprecated see https://angular.io/guide/http
 */
var Response = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(Response, _super);
    function Response(responseOptions) {
        var _this = _super.call(this) || this;
        _this._body = responseOptions.body;
        _this.status = responseOptions.status;
        _this.ok = (_this.status >= 200 && _this.status <= 299);
        _this.statusText = responseOptions.statusText;
        _this.headers = responseOptions.headers;
        _this.type = responseOptions.type;
        _this.url = responseOptions.url;
        return _this;
    }
    Response.prototype.toString = function () {
        return "Response with status: " + this.status + " " + this.statusText + " for URL: " + this.url;
    };
    return Response;
}(Body));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _nextRequestId = 0;
var JSONP_HOME = '__ng_jsonp__';
var _jsonpConnections = null;
function _getJsonpConnections() {
    var w = typeof window == 'object' ? window : {};
    if (_jsonpConnections === null) {
        _jsonpConnections = w[JSONP_HOME] = {};
    }
    return _jsonpConnections;
}
// Make sure not to evaluate this in a non-browser environment!
var BrowserJsonp = /*@__PURE__*/ (function () {
    function BrowserJsonp() {
    }
    // Construct a <script> element with the specified URL
    BrowserJsonp.prototype.build = function (url) {
        var node = document.createElement('script');
        node.src = url;
        return node;
    };
    BrowserJsonp.prototype.nextRequestID = function () { return "__req" + _nextRequestId++; };
    BrowserJsonp.prototype.requestCallback = function (id) { return JSONP_HOME + "." + id + ".finished"; };
    BrowserJsonp.prototype.exposeConnection = function (id, connection) {
        var connections = _getJsonpConnections();
        connections[id] = connection;
    };
    BrowserJsonp.prototype.removeConnection = function (id) {
        var connections = _getJsonpConnections();
        connections[id] = null;
    };
    // Attach the <script> element to the DOM
    BrowserJsonp.prototype.send = function (node) { document.body.appendChild((node)); };
    // Remove <script> element from the DOM
    BrowserJsonp.prototype.cleanup = function (node) {
        if (node.parentNode) {
            node.parentNode.removeChild((node));
        }
    };
    return BrowserJsonp;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use GET request method.';
/**
 * Base class for an in-flight JSONP request.
 *
 * @deprecated see https://angular.io/guide/http
 */
var JSONPConnection = /*@__PURE__*/ (function () {
    /** @internal */
    function JSONPConnection(req, _dom, baseResponseOptions) {
        var _this = this;
        this._dom = _dom;
        this.baseResponseOptions = baseResponseOptions;
        this._finished = false;
        if (req.method !== RequestMethod.Get) {
            throw new TypeError(JSONP_ERR_WRONG_METHOD);
        }
        this.request = req;
        this.response = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["d" /* Observable */](function (responseObserver) {
            _this.readyState = ReadyState.Loading;
            var id = _this._id = _dom.nextRequestID();
            _dom.exposeConnection(id, _this);
            // Workaround Dart
            // url = url.replace(/=JSONP_CALLBACK(&|$)/, `generated method`);
            var callback = _dom.requestCallback(_this._id);
            var url = req.url;
            if (url.indexOf('=JSONP_CALLBACK&') > -1) {
                url = url.replace('=JSONP_CALLBACK&', "=" + callback + "&");
            }
            else if (url.lastIndexOf('=JSONP_CALLBACK') === url.length - '=JSONP_CALLBACK'.length) {
                url = url.substring(0, url.length - '=JSONP_CALLBACK'.length) + ("=" + callback);
            }
            var script = _this._script = _dom.build(url);
            var onLoad = function (event) {
                if (_this.readyState === ReadyState.Cancelled)
                    return;
                _this.readyState = ReadyState.Done;
                _dom.cleanup(script);
                if (!_this._finished) {
                    var responseOptions_1 = new ResponseOptions({ body: JSONP_ERR_NO_CALLBACK, type: ResponseType.Error, url: url });
                    if (baseResponseOptions) {
                        responseOptions_1 = baseResponseOptions.merge(responseOptions_1);
                    }
                    responseObserver.error(new Response(responseOptions_1));
                    return;
                }
                var responseOptions = new ResponseOptions({ body: _this._responseData, url: url });
                if (_this.baseResponseOptions) {
                    responseOptions = _this.baseResponseOptions.merge(responseOptions);
                }
                responseObserver.next(new Response(responseOptions));
                responseObserver.complete();
            };
            var onError = function (error) {
                if (_this.readyState === ReadyState.Cancelled)
                    return;
                _this.readyState = ReadyState.Done;
                _dom.cleanup(script);
                var responseOptions = new ResponseOptions({ body: error.message, type: ResponseType.Error });
                if (baseResponseOptions) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                responseObserver.error(new Response(responseOptions));
            };
            script.addEventListener('load', onLoad);
            script.addEventListener('error', onError);
            _dom.send(script);
            return function () {
                _this.readyState = ReadyState.Cancelled;
                script.removeEventListener('load', onLoad);
                script.removeEventListener('error', onError);
                _this._dom.cleanup(script);
            };
        });
    }
    /**
     * Callback called when the JSONP request completes, to notify the application
     * of the new data.
     */
    JSONPConnection.prototype.finished = function (data) {
        // Don't leak connections
        this._finished = true;
        this._dom.removeConnection(this._id);
        if (this.readyState === ReadyState.Cancelled)
            return;
        this._responseData = data;
    };
    return JSONPConnection;
}());
/**
 * A {@link ConnectionBackend} that uses the JSONP strategy of making requests.
 *
 * @deprecated see https://angular.io/guide/http
 */
var JSONPBackend = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(JSONPBackend, _super);
    /** @internal */
    function JSONPBackend(_browserJSONP, _baseResponseOptions) {
        var _this = _super.call(this) || this;
        _this._browserJSONP = _browserJSONP;
        _this._baseResponseOptions = _baseResponseOptions;
        return _this;
    }
    JSONPBackend.prototype.createConnection = function (request) {
        return new JSONPConnection(request, this._browserJSONP, this._baseResponseOptions);
    };
    return JSONPBackend;
}(ConnectionBackend));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XSSI_PREFIX = /^\)\]\}',?\n/;
/**
 * Creates connections using `XMLHttpRequest`. Given a fully-qualified
 * request, an `XHRConnection` will immediately create an `XMLHttpRequest` object and send the
 * request.
 *
 * This class would typically not be created or interacted with directly inside applications, though
 * the {@link MockConnection} may be interacted with in tests.
 *
 * @deprecated see https://angular.io/guide/http
 */
var XHRConnection = /*@__PURE__*/ (function () {
    function XHRConnection(req, browserXHR, baseResponseOptions) {
        var _this = this;
        this.request = req;
        this.response = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["d" /* Observable */](function (responseObserver) {
            var _xhr = browserXHR.build();
            _xhr.open(RequestMethod[req.method].toUpperCase(), req.url);
            if (req.withCredentials != null) {
                _xhr.withCredentials = req.withCredentials;
            }
            // load event handler
            var onLoad = function () {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status = _xhr.status === 1223 ? 204 : _xhr.status;
                var body = null;
                // HTTP 204 means no content
                if (status !== 204) {
                    // responseText is the old-school way of retrieving response (supported by IE8 & 9)
                    // response/responseType properties were introduced in ResourceLoader Level2 spec
                    // (supported by IE10)
                    body = (typeof _xhr.response === 'undefined') ? _xhr.responseText : _xhr.response;
                    // Implicitly strip a potential XSSI prefix.
                    if (typeof body === 'string') {
                        body = body.replace(XSSI_PREFIX, '');
                    }
                }
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status === 0) {
                    status = body ? 200 : 0;
                }
                var headers = Headers.fromResponseHeaderString(_xhr.getAllResponseHeaders());
                // IE 9 does not provide the way to get URL of response
                var url = getResponseURL(_xhr) || req.url;
                var statusText = _xhr.statusText || 'OK';
                var responseOptions = new ResponseOptions({ body: body, status: status, headers: headers, statusText: statusText, url: url });
                if (baseResponseOptions != null) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                var response = new Response(responseOptions);
                response.ok = isSuccess(status);
                if (response.ok) {
                    responseObserver.next(response);
                    // TODO(gdi2290): defer complete if array buffer until done
                    responseObserver.complete();
                    return;
                }
                responseObserver.error(response);
            };
            // error event handler
            var onError = function (err) {
                var responseOptions = new ResponseOptions({
                    body: err,
                    type: ResponseType.Error,
                    status: _xhr.status,
                    statusText: _xhr.statusText,
                });
                if (baseResponseOptions != null) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                responseObserver.error(new Response(responseOptions));
            };
            _this.setDetectedContentType(req, _xhr);
            if (req.headers == null) {
                req.headers = new Headers();
            }
            if (!req.headers.has('Accept')) {
                req.headers.append('Accept', 'application/json, text/plain, */*');
            }
            req.headers.forEach(function (values, name) { return _xhr.setRequestHeader(name, values.join(',')); });
            // Select the correct buffer type to store the response
            if (req.responseType != null && _xhr.responseType != null) {
                switch (req.responseType) {
                    case ResponseContentType.ArrayBuffer:
                        _xhr.responseType = 'arraybuffer';
                        break;
                    case ResponseContentType.Json:
                        _xhr.responseType = 'json';
                        break;
                    case ResponseContentType.Text:
                        _xhr.responseType = 'text';
                        break;
                    case ResponseContentType.Blob:
                        _xhr.responseType = 'blob';
                        break;
                    default:
                        throw new Error('The selected responseType is not supported');
                }
            }
            _xhr.addEventListener('load', onLoad);
            _xhr.addEventListener('error', onError);
            _xhr.send(_this.request.getBody());
            return function () {
                _xhr.removeEventListener('load', onLoad);
                _xhr.removeEventListener('error', onError);
                _xhr.abort();
            };
        });
    }
    XHRConnection.prototype.setDetectedContentType = function (req /** TODO Request */, _xhr /** XMLHttpRequest */) {
        // Skip if a custom Content-Type header is provided
        if (req.headers != null && req.headers.get('Content-Type') != null) {
            return;
        }
        // Set the detected content type
        switch (req.contentType) {
            case ContentType.NONE:
                break;
            case ContentType.JSON:
                _xhr.setRequestHeader('content-type', 'application/json');
                break;
            case ContentType.FORM:
                _xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                break;
            case ContentType.TEXT:
                _xhr.setRequestHeader('content-type', 'text/plain');
                break;
            case ContentType.BLOB:
                var blob = req.blob();
                if (blob.type) {
                    _xhr.setRequestHeader('content-type', blob.type);
                }
                break;
        }
    };
    return XHRConnection;
}());
/**
 * `XSRFConfiguration` sets up Cross Site Request Forgery (XSRF) protection for the application
 * using a cookie. See https://www.owasp.org/index.php/Cross-Site_Request_Forgery_(CSRF)
 * for more information on XSRF.
 *
 * Applications can configure custom cookie and header names by binding an instance of this class
 * with different `cookieName` and `headerName` values. See the main HTTP documentation for more
 * details.
 *
 * @deprecated see https://angular.io/guide/http
 */
var CookieXSRFStrategy = /*@__PURE__*/ (function () {
    function CookieXSRFStrategy(_cookieName, _headerName) {
        if (_cookieName === void 0) {
            _cookieName = 'XSRF-TOKEN';
        }
        if (_headerName === void 0) {
            _headerName = 'X-XSRF-TOKEN';
        }
        this._cookieName = _cookieName;
        this._headerName = _headerName;
    }
    CookieXSRFStrategy.prototype.configureRequest = function (req) {
        var xsrfToken = Object(__WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["t" /* ɵgetDOM */])().getCookie(this._cookieName);
        if (xsrfToken) {
            req.headers.set(this._headerName, xsrfToken);
        }
    };
    return CookieXSRFStrategy;
}());
/**
 * Creates {@link XHRConnection} instances.
 *
 * This class would typically not be used by end users, but could be
 * overridden if a different backend implementation should be used,
 * such as in a node backend.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * import {Http, MyNodeBackend, HTTP_PROVIDERS, BaseRequestOptions} from '@angular/http';
 * @Component({
 *   viewProviders: [
 *     HTTP_PROVIDERS,
 *     {provide: Http, useFactory: (backend, options) => {
 *       return new Http(backend, options);
 *     }, deps: [MyNodeBackend, BaseRequestOptions]}]
 * })
 * class MyComponent {
 *   constructor(http:Http) {
 *     http.request('people.json').subscribe(res => this.people = res.json());
 *   }
 * }
 * ```
 * @deprecated see https://angular.io/guide/http
 */
var XHRBackend = /*@__PURE__*/ (function () {
    function XHRBackend(_browserXHR, _baseResponseOptions, _xsrfStrategy) {
        this._browserXHR = _browserXHR;
        this._baseResponseOptions = _baseResponseOptions;
        this._xsrfStrategy = _xsrfStrategy;
    }
    XHRBackend.prototype.createConnection = function (request) {
        this._xsrfStrategy.configureRequest(request);
        return new XHRConnection(request, this._browserXHR, this._baseResponseOptions);
    };
    return XHRBackend;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates a request options object to be optionally provided when instantiating a
 * {@link Request}.
 *
 * This class is based on the `RequestInit` description in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#requestinit).
 *
 * All values are null by default. Typical defaults can be found in the {@link BaseRequestOptions}
 * class, which sub-classes `RequestOptions`.
 *
 * ```typescript
 * import {RequestOptions, Request, RequestMethod} from '@angular/http';
 *
 * const options = new RequestOptions({
 *   method: RequestMethod.Post,
 *   url: 'https://google.com'
 * });
 * const req = new Request(options);
 * console.log('req.method:', RequestMethod[req.method]); // Post
 * console.log('options.url:', options.url); // https://google.com
 * ```
 *
 * @deprecated see https://angular.io/guide/http
 */
var RequestOptions = /*@__PURE__*/ (function () {
    // TODO(Dzmitry): remove search when this.search is removed
    function RequestOptions(opts) {
        if (opts === void 0) {
            opts = {};
        }
        var method = opts.method, headers = opts.headers, body = opts.body, url = opts.url, search = opts.search, params = opts.params, withCredentials = opts.withCredentials, responseType = opts.responseType;
        this.method = method != null ? normalizeMethodName(method) : null;
        this.headers = headers != null ? headers : null;
        this.body = body != null ? body : null;
        this.url = url != null ? url : null;
        this.params = this._mergeSearchParams(params || search);
        this.withCredentials = withCredentials != null ? withCredentials : null;
        this.responseType = responseType != null ? responseType : null;
    }
    Object.defineProperty(RequestOptions.prototype, "search", {
        /**
         * @deprecated from 4.0.0. Use params instead.
         */
        get: function () { return this.params; },
        /**
         * @deprecated from 4.0.0. Use params instead.
         */
        set: function (params) { this.params = params; },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a copy of the `RequestOptions` instance, using the optional input as values to override
     * existing values. This method will not change the values of the instance on which it is being
     * called.
     *
     * Note that `headers` and `search` will override existing values completely if present in
     * the `options` object. If these values should be merged, it should be done prior to calling
     * `merge` on the `RequestOptions` instance.
     *
     * ```typescript
     * import {RequestOptions, Request, RequestMethod} from '@angular/http';
     *
     * const options = new RequestOptions({
     *   method: RequestMethod.Post
     * });
     * const req = new Request(options.merge({
     *   url: 'https://google.com'
     * }));
     * console.log('req.method:', RequestMethod[req.method]); // Post
     * console.log('options.url:', options.url); // null
     * console.log('req.url:', req.url); // https://google.com
     * ```
     */
    RequestOptions.prototype.merge = function (options) {
        return new RequestOptions({
            method: options && options.method != null ? options.method : this.method,
            headers: options && options.headers != null ? options.headers : new Headers(this.headers),
            body: options && options.body != null ? options.body : this.body,
            url: options && options.url != null ? options.url : this.url,
            params: options && this._mergeSearchParams(options.params || options.search),
            withCredentials: options && options.withCredentials != null ? options.withCredentials :
                this.withCredentials,
            responseType: options && options.responseType != null ? options.responseType :
                this.responseType
        });
    };
    RequestOptions.prototype._mergeSearchParams = function (params) {
        if (!params)
            return this.params;
        if (params instanceof URLSearchParams) {
            return params.clone();
        }
        if (typeof params === 'string') {
            return new URLSearchParams(params);
        }
        return this._parseParams(params);
    };
    RequestOptions.prototype._parseParams = function (objParams) {
        var _this = this;
        if (objParams === void 0) {
            objParams = {};
        }
        var params = new URLSearchParams();
        Object.keys(objParams).forEach(function (key) {
            var value = objParams[key];
            if (Array.isArray(value)) {
                value.forEach(function (item) { return _this._appendParam(key, item, params); });
            }
            else {
                _this._appendParam(key, value, params);
            }
        });
        return params;
    };
    RequestOptions.prototype._appendParam = function (key, value, params) {
        if (typeof value !== 'string') {
            value = JSON.stringify(value);
        }
        params.append(key, value);
    };
    return RequestOptions;
}());
/**
 * Subclass of {@link RequestOptions}, with default values.
 *
 * Default values:
 *  * method: {@link RequestMethod RequestMethod.Get}
 *  * headers: empty {@link Headers} object
 *
 * This class could be extended and bound to the {@link RequestOptions} class
 * when configuring an {@link Injector}, in order to override the default options
 * used by {@link Http} to create and send {@link Request Requests}.
 *
 * ```typescript
 * import {BaseRequestOptions, RequestOptions} from '@angular/http';
 *
 * class MyOptions extends BaseRequestOptions {
 *   search: string = 'coreTeam=true';
 * }
 *
 * {provide: RequestOptions, useClass: MyOptions};
 * ```
 *
 * The options could also be extended when manually creating a {@link Request}
 * object.
 *
 * ```
 * import {BaseRequestOptions, Request, RequestMethod} from '@angular/http';
 *
 * const options = new BaseRequestOptions();
 * const req = new Request(options.merge({
 *   method: RequestMethod.Post,
 *   url: 'https://google.com'
 * }));
 * console.log('req.method:', RequestMethod[req.method]); // Post
 * console.log('options.url:', options.url); // null
 * console.log('req.url:', req.url); // https://google.com
 * ```
 *
 * @deprecated see https://angular.io/guide/http
 */
var BaseRequestOptions = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(BaseRequestOptions, _super);
    function BaseRequestOptions() {
        return _super.call(this, { method: RequestMethod.Get, headers: new Headers() }) || this;
    }
    return BaseRequestOptions;
}(RequestOptions));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// TODO(jeffbcross): properly implement body accessors
/**
 * Creates `Request` instances from provided values.
 *
 * The Request's interface is inspired by the Request constructor defined in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#request-class),
 * but is considered a static value whose body can be accessed many times. There are other
 * differences in the implementation, but this is the most significant.
 *
 * `Request` instances are typically created by higher-level classes, like {@link Http} and
 * {@link Jsonp}, but it may occasionally be useful to explicitly create `Request` instances.
 * One such example is when creating services that wrap higher-level services, like {@link Http},
 * where it may be useful to generate a `Request` with arbitrary headers and search params.
 *
 * ```typescript
 * import {Injectable, Injector} from '@angular/core';
 * import {HTTP_PROVIDERS, Http, Request, RequestMethod} from '@angular/http';
 *
 * @Injectable()
 * class AutoAuthenticator {
 *   constructor(public http:Http) {}
 *   request(url:string) {
 *     return this.http.request(new Request({
 *       method: RequestMethod.Get,
 *       url: url,
 *       search: 'password=123'
 *     }));
 *   }
 * }
 *
 * var injector = Injector.resolveAndCreate([HTTP_PROVIDERS, AutoAuthenticator]);
 * var authenticator = injector.get(AutoAuthenticator);
 * authenticator.request('people.json').subscribe(res => {
 *   //URL should have included '?password=123'
 *   console.log('people', res.json());
 * });
 * ```
 *
 * @deprecated see https://angular.io/guide/http
 */
var Request = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(Request, _super);
    function Request(requestOptions) {
        var _this = _super.call(this) || this;
        // TODO: assert that url is present
        var url = requestOptions.url;
        _this.url = requestOptions.url;
        var paramsArg = requestOptions.params || requestOptions.search;
        if (paramsArg) {
            var params = void 0;
            if (typeof paramsArg === 'object' && !(paramsArg instanceof URLSearchParams)) {
                params = urlEncodeParams(paramsArg).toString();
            }
            else {
                params = paramsArg.toString();
            }
            if (params.length > 0) {
                var prefix = '?';
                if (_this.url.indexOf('?') != -1) {
                    prefix = (_this.url[_this.url.length - 1] == '&') ? '' : '&';
                }
                // TODO: just delete search-query-looking string in url?
                _this.url = url + prefix + params;
            }
        }
        _this._body = requestOptions.body;
        _this.method = normalizeMethodName(requestOptions.method);
        // TODO(jeffbcross): implement behavior
        // Defaults to 'omit', consistent with browser
        _this.headers = new Headers(requestOptions.headers);
        _this.contentType = _this.detectContentType();
        _this.withCredentials = requestOptions.withCredentials;
        _this.responseType = requestOptions.responseType;
        return _this;
    }
    /**
     * Returns the content type enum based on header options.
     */
    Request.prototype.detectContentType = function () {
        switch (this.headers.get('content-type')) {
            case 'application/json':
                return ContentType.JSON;
            case 'application/x-www-form-urlencoded':
                return ContentType.FORM;
            case 'multipart/form-data':
                return ContentType.FORM_DATA;
            case 'text/plain':
            case 'text/html':
                return ContentType.TEXT;
            case 'application/octet-stream':
                return this._body instanceof ArrayBuffer$1 ? ContentType.ARRAY_BUFFER : ContentType.BLOB;
            default:
                return this.detectContentTypeFromBody();
        }
    };
    /**
     * Returns the content type of request's body based on its type.
     */
    Request.prototype.detectContentTypeFromBody = function () {
        if (this._body == null) {
            return ContentType.NONE;
        }
        else if (this._body instanceof URLSearchParams) {
            return ContentType.FORM;
        }
        else if (this._body instanceof FormData) {
            return ContentType.FORM_DATA;
        }
        else if (this._body instanceof Blob$1) {
            return ContentType.BLOB;
        }
        else if (this._body instanceof ArrayBuffer$1) {
            return ContentType.ARRAY_BUFFER;
        }
        else if (this._body && typeof this._body === 'object') {
            return ContentType.JSON;
        }
        else {
            return ContentType.TEXT;
        }
    };
    /**
     * Returns the request's body according to its type. If body is undefined, return
     * null.
     */
    Request.prototype.getBody = function () {
        switch (this.contentType) {
            case ContentType.JSON:
                return this.text();
            case ContentType.FORM:
                return this.text();
            case ContentType.FORM_DATA:
                return this._body;
            case ContentType.TEXT:
                return this.text();
            case ContentType.BLOB:
                return this.blob();
            case ContentType.ARRAY_BUFFER:
                return this.arrayBuffer();
            default:
                return null;
        }
    };
    return Request;
}(Body));
function urlEncodeParams(params) {
    var searchParams = new URLSearchParams();
    Object.keys(params).forEach(function (key) {
        var value = params[key];
        if (value && Array.isArray(value)) {
            value.forEach(function (element) { return searchParams.append(key, element.toString()); });
        }
        else {
            searchParams.append(key, value.toString());
        }
    });
    return searchParams;
}
var noop = function () { };
var w = typeof window == 'object' ? window : noop;
var FormData = w /** TODO #9100 */['FormData'] || noop;
var Blob$1 = w /** TODO #9100 */['Blob'] || noop;
var ArrayBuffer$1 = w /** TODO #9100 */['ArrayBuffer'] || noop;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function httpRequest(backend, request) {
    return backend.createConnection(request).response;
}
function mergeOptions(defaultOpts, providedOpts, method, url) {
    var newOptions = defaultOpts;
    if (providedOpts) {
        // Hack so Dart can used named parameters
        return newOptions.merge(new RequestOptions({
            method: providedOpts.method || method,
            url: providedOpts.url || url,
            search: providedOpts.search,
            params: providedOpts.params,
            headers: providedOpts.headers,
            body: providedOpts.body,
            withCredentials: providedOpts.withCredentials,
            responseType: providedOpts.responseType
        }));
    }
    return newOptions.merge(new RequestOptions({ method: method, url: url }));
}
/**
 * Performs http requests using `XMLHttpRequest` as the default backend.
 *
 * `Http` is available as an injectable class, with methods to perform http requests. Calling
 * `request` returns an `Observable` which will emit a single {@link Response} when a
 * response is received.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * import {Http, HTTP_PROVIDERS} from '@angular/http';
 * import {map} from 'rxjs/operators';
 *
 * @Component({
 *   selector: 'http-app',
 *   viewProviders: [HTTP_PROVIDERS],
 *   templateUrl: 'people.html'
 * })
 * class PeopleComponent {
 *   constructor(http: Http) {
 *     http.get('people.json')
 *       // Call map on the response observable to get the parsed people object
 *       .pipe(map(res => res.json()))
 *       // Subscribe to the observable to get the parsed people object and attach it to the
 *       // component
 *       .subscribe(people => this.people = people);
 *   }
 * }
 * ```
 *
 *
 * ### Example
 *
 * ```
 * http.get('people.json').subscribe((res:Response) => this.people = res.json());
 * ```
 *
 * The default construct used to perform requests, `XMLHttpRequest`, is abstracted as a "Backend" (
 * {@link XHRBackend} in this case), which could be mocked with dependency injection by replacing
 * the {@link XHRBackend} provider, as in the following example:
 *
 * ### Example
 *
 * ```typescript
 * import {BaseRequestOptions, Http} from '@angular/http';
 * import {MockBackend} from '@angular/http/testing';
 * var injector = Injector.resolveAndCreate([
 *   BaseRequestOptions,
 *   MockBackend,
 *   {provide: Http, useFactory:
 *       function(backend, defaultOptions) {
 *         return new Http(backend, defaultOptions);
 *       },
 *       deps: [MockBackend, BaseRequestOptions]}
 * ]);
 * var http = injector.get(Http);
 * http.get('request-from-mock-backend.json').subscribe((res:Response) => doSomething(res));
 * ```
 *
 * @deprecated see https://angular.io/guide/http
 */
var Http = /*@__PURE__*/ (function () {
    function Http(_backend, _defaultOptions) {
        this._backend = _backend;
        this._defaultOptions = _defaultOptions;
    }
    /**
     * Performs any type of http request. First argument is required, and can either be a url or
     * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
     * object can be provided as the 2nd argument. The options object will be merged with the values
     * of {@link BaseRequestOptions} before performing the request.
     */
    Http.prototype.request = function (url, options) {
        var responseObservable;
        if (typeof url === 'string') {
            responseObservable = httpRequest(this._backend, new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, url)));
        }
        else if (url instanceof Request) {
            responseObservable = httpRequest(this._backend, url);
        }
        else {
            throw new Error('First argument must be a url string or Request instance.');
        }
        return responseObservable;
    };
    /**
     * Performs a request with `get` http method.
     */
    Http.prototype.get = function (url, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, url)));
    };
    /**
     * Performs a request with `post` http method.
     */
    Http.prototype.post = function (url, body, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Post, url)));
    };
    /**
     * Performs a request with `put` http method.
     */
    Http.prototype.put = function (url, body, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Put, url)));
    };
    /**
     * Performs a request with `delete` http method.
     */
    Http.prototype.delete = function (url, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Delete, url)));
    };
    /**
     * Performs a request with `patch` http method.
     */
    Http.prototype.patch = function (url, body, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Patch, url)));
    };
    /**
     * Performs a request with `head` http method.
     */
    Http.prototype.head = function (url, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Head, url)));
    };
    /**
     * Performs a request with `options` http method.
     */
    Http.prototype.options = function (url, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Options, url)));
    };
    return Http;
}());
/**
 * @deprecated see https://angular.io/guide/http
 */
var Jsonp = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(Jsonp, _super);
    function Jsonp(backend, defaultOptions) {
        return _super.call(this, backend, defaultOptions) || this;
    }
    /**
     * Performs any type of http request. First argument is required, and can either be a url or
     * a {@link Request} instance. If the first argument is a url, an optional {@link RequestOptions}
     * object can be provided as the 2nd argument. The options object will be merged with the values
     * of {@link BaseRequestOptions} before performing the request.
     *
     * @security Regular XHR is the safest alternative to JSONP for most applications, and is
     * supported by all current browsers. Because JSONP creates a `<script>` element with
     * contents retrieved from a remote source, attacker-controlled data introduced by an untrusted
     * source could expose your application to XSS risks. Data exposed by JSONP may also be
     * readable by malicious third-party websites. In addition, JSONP introduces potential risk for
     * future security issues (e.g. content sniffing).  For more detail, see the
     * [Security Guide](http://g.co/ng/security).
     */
    Jsonp.prototype.request = function (url, options) {
        var responseObservable;
        if (typeof url === 'string') {
            url =
                new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, url));
        }
        if (url instanceof Request) {
            if (url.method !== RequestMethod.Get) {
                throw new Error('JSONP requests must use GET request method.');
            }
            responseObservable = httpRequest(this._backend, url);
        }
        else {
            throw new Error('First argument must be a url string or Request instance.');
        }
        return responseObservable;
    };
    return Jsonp;
}(Http));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function _createDefaultCookieXSRFStrategy() {
    return new CookieXSRFStrategy();
}
function httpFactory(xhrBackend, requestOptions) {
    return new Http(xhrBackend, requestOptions);
}
function jsonpFactory(jsonpBackend, requestOptions) {
    return new Jsonp(jsonpBackend, requestOptions);
}
/**
 * The module that includes http's providers
 *
 * @deprecated see https://angular.io/guide/http
 */
var HttpModule = /*@__PURE__*/ (function () {
    function HttpModule() {
    }
    return HttpModule;
}());
/**
 * The module that includes jsonp's providers
 *
 * @deprecated see https://angular.io/guide/http
 */
var JsonpModule = /*@__PURE__*/ (function () {
    function JsonpModule() {
    }
    return JsonpModule;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @deprecated see https://angular.io/guide/http
 */
var VERSION = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('6.1.10');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */






/***/ }),

/***/ "TQ3y":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("blYT");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "TToO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */
var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p]; };
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
function __rest(s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator.throw(value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __exportStar(m, exports) {
    for (var p in m)
        if (!exports.hasOwnProperty(p))
            exports[p] = m[p];
}
function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m)
        return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length)
                o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m)
        return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
            ar.push(r.value);
    }
    catch (error) {
        e = { error: error };
    }
    finally {
        try {
            if (r && !r.done && (m = i["return"]))
                m.call(i);
        }
        finally {
            if (e)
                throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n])
        i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try {
        step(g[n](v));
    }
    catch (e) {
        settle(q[0][3], e);
    } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length)
        resume(q[0][0], q[0][1]); }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n])
        i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}



/***/ }),

/***/ "Td+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scan;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */
function scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return function scanOperatorFunction(source) {
        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
    };
}
var ScanOperator = /*@__PURE__*/ (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) {
            hasSeed = false;
        }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ScanSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        var _this = _super.call(this, destination) || this;
        _this.accumulator = accumulator;
        _this._seed = _seed;
        _this.hasSeed = hasSeed;
        _this.index = 0;
        return _this;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));





/***/ }),

/***/ "TdOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_l", function() { return APPLICATION_MODULE_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_i", function() { return _iterableDiffersFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_j", function() { return _keyValueDiffersFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_k", function() { return _localeFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_f", function() { return _appIdRandomProviderFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_g", function() { return DefaultIterableDifferFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_h", function() { return DefaultKeyValueDifferFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_c", function() { return ReflectiveInjector_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_d", function() { return ReflectiveDependency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_e", function() { return resolveReflectiveProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_m", function() { return wtfEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_o", function() { return createScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_n", function() { return detectWTF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_r", function() { return endTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_p", function() { return leave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_q", function() { return startTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_v", function() { return getOrCreateChangeDetectorRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_y", function() { return getOrCreateContainerRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_x", function() { return getOrCreateElementRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_w", function() { return getOrCreateInjectable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_u", function() { return getOrCreateNodeInjector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_z", function() { return getOrCreateTemplateRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_ba", function() { return bindingUpdated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_bb", function() { return loadInternal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_a", function() { return makeParamDecorator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_b", function() { return makePropDecorator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_s", function() { return _def; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_core_core_t", function() { return DebugContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlatform", function() { return createPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assertPlatform", function() { return assertPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyPlatform", function() { return destroyPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatform", function() { return getPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlatformRef", function() { return PlatformRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationRef", function() { return ApplicationRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableProdMode", function() { return enableProdMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDevMode", function() { return isDevMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlatformFactory", function() { return createPlatformFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgProbeToken", function() { return NgProbeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_ID", function() { return APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PACKAGE_ROOT_URL", function() { return PACKAGE_ROOT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLATFORM_INITIALIZER", function() { return PLATFORM_INITIALIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLATFORM_ID", function() { return PLATFORM_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_BOOTSTRAP_LISTENER", function() { return APP_BOOTSTRAP_LISTENER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_INITIALIZER", function() { return APP_INITIALIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationInitStatus", function() { return ApplicationInitStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugElement", function() { return DebugElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugNode", function() { return DebugNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asNativeElements", function() { return asNativeElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDebugNode", function() { return getDebugNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Testability", function() { return Testability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TestabilityRegistry", function() { return TestabilityRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTestabilityGetter", function() { return setTestabilityGetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSLATIONS", function() { return TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSLATIONS_FORMAT", function() { return TRANSLATIONS_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCALE_ID", function() { return LOCALE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MissingTranslationStrategy", function() { return MissingTranslationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationModule", function() { return ApplicationModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfCreateScope", function() { return wtfCreateScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfLeave", function() { return wtfLeave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfStartTimeRange", function() { return wtfStartTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfEndTimeRange", function() { return wtfEndTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Type", function() { return Type; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventEmitter", function() { return EventEmitter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorHandler", function() { return ErrorHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sanitizer", function() { return Sanitizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecurityContext", function() { return SecurityContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANALYZE_FOR_ENTRY_COMPONENTS", function() { return ANALYZE_FOR_ENTRY_COMPONENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Attribute", function() { return Attribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentChild", function() { return ContentChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentChildren", function() { return ContentChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Query", function() { return Query; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewChild", function() { return ViewChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewChildren", function() { return ViewChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Directive", function() { return Directive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HostBinding", function() { return HostBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HostListener", function() { return HostListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Output", function() { return Output; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pipe", function() { return Pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CUSTOM_ELEMENTS_SCHEMA", function() { return CUSTOM_ELEMENTS_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NO_ERRORS_SCHEMA", function() { return NO_ERRORS_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModule", function() { return NgModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewEncapsulation", function() { return ViewEncapsulation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Version", function() { return Version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineInjectable", function() { return defineInjectable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineInjector", function() { return defineInjector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forwardRef", function() { return forwardRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveForwardRef", function() { return resolveForwardRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Injectable", function() { return Injectable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INJECTOR", function() { return INJECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Injector", function() { return Injector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReflectiveInjector", function() { return ReflectiveInjector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInjector", function() { return createInjector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResolvedReflectiveFactory", function() { return ResolvedReflectiveFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReflectiveKey", function() { return ReflectiveKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InjectionToken", function() { return InjectionToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Inject", function() { return Inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Optional", function() { return Optional; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Self", function() { return Self; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SkipSelf", function() { return SkipSelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Host", function() { return Host; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgZone", function() { return NgZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNoopNgZone", function() { return NoopNgZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenderComponentType", function() { return RenderComponentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Renderer", function() { return Renderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Renderer2", function() { return Renderer2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RendererFactory2", function() { return RendererFactory2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RendererStyleFlags2", function() { return RendererStyleFlags2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RootRenderer", function() { return RootRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPILER_OPTIONS", function() { return COMPILER_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Compiler", function() { return Compiler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompilerFactory", function() { return CompilerFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleWithComponentFactories", function() { return ModuleWithComponentFactories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentFactory", function() { return ComponentFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentRef", function() { return ComponentRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentFactoryResolver", function() { return ComponentFactoryResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementRef", function() { return ElementRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleFactory", function() { return NgModuleFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleRef", function() { return NgModuleRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleFactoryLoader", function() { return NgModuleFactoryLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModuleFactory", function() { return getModuleFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryList", function() { return QueryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SystemJsNgModuleLoader", function() { return SystemJsNgModuleLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SystemJsNgModuleLoaderConfig", function() { return SystemJsNgModuleLoaderConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateRef", function() { return TemplateRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewContainerRef", function() { return ViewContainerRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmbeddedViewRef", function() { return EmbeddedViewRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewRef", function() { return ViewRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeDetectionStrategy", function() { return ChangeDetectionStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeDetectorRef", function() { return ChangeDetectorRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultIterableDiffer", function() { return DefaultIterableDiffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IterableDiffers", function() { return IterableDiffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyValueDiffers", function() { return KeyValueDiffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleChange", function() { return SimpleChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WrappedValue", function() { return WrappedValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformCore", function() { return platformCore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵALLOW_MULTIPLE_PLATFORMS", function() { return ALLOW_MULTIPLE_PLATFORMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAPP_ID_RANDOM_PROVIDER", function() { return APP_ID_RANDOM_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdefaultIterableDiffers", function() { return defaultIterableDiffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdefaultKeyValueDiffers", function() { return defaultKeyValueDiffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdevModeEqual", function() { return devModeEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisListLikeIterable", function() { return isListLikeIterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵChangeDetectorStatus", function() { return ChangeDetectorStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisDefaultChangeDetectionStrategy", function() { return isDefaultChangeDetectionStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵConsole", function() { return Console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinject", function() { return inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsetCurrentInjector", function() { return setCurrentInjector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAPP_ROOT", function() { return APP_ROOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵivyEnabled", function() { return ivyEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵComponentFactory", function() { return ComponentFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCodegenComponentFactoryResolver", function() { return CodegenComponentFactoryResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵresolveComponentResources", function() { return resolveComponentResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵReflectionCapabilities", function() { return ReflectionCapabilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵRenderDebugInfo", function() { return RenderDebugInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵ_sanitizeHtml", function() { return _sanitizeHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵ_sanitizeStyle", function() { return _sanitizeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵ_sanitizeUrl", function() { return _sanitizeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵglobal", function() { return _global; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵlooseIdentical", function() { return looseIdentical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵstringify", function() { return stringify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmakeDecorator", function() { return makeDecorator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵclearOverrides", function() { return clearOverrides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinitServicesIfNeeded", function() { return initServicesIfNeeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵoverrideComponentView", function() { return overrideComponentView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵoverrideProvider", function() { return overrideProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR", function() { return NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdefineComponent", function() { return defineComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdefineDirective", function() { return defineDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdefinePipe", function() { return definePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdefineNgModule", function() { return defineNgModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdetectChanges", function() { return detectChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵrenderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdirectiveInject", function() { return directiveInject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinjectElementRef", function() { return injectElementRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinjectTemplateRef", function() { return injectTemplateRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinjectViewContainerRef", function() { return injectViewContainerRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinjectChangeDetectorRef", function() { return injectChangeDetectorRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinjectAttribute", function() { return injectAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPublicFeature", function() { return PublicFeature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵInheritDefinitionFeature", function() { return InheritDefinitionFeature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgOnChangesFeature", function() { return NgOnChangesFeature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmarkDirty", function() { return markDirty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgModuleFactory", function() { return NgModuleFactory$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNC", function() { return NO_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵC", function() { return container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵE", function() { return elementStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNH", function() { return namespaceHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNM", function() { return namespaceMathML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNS", function() { return namespaceSVG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵEe", function() { return element; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵL", function() { return listener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵT", function() { return text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵV", function() { return embeddedViewStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵQ", function() { return query; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵQr", function() { return registerContentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return loadDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵP", function() { return projection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return bind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi1", function() { return interpolation1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi2", function() { return interpolation2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi3", function() { return interpolation3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi4", function() { return interpolation4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi5", function() { return interpolation5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi6", function() { return interpolation6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi7", function() { return interpolation7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi8", function() { return interpolation8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiV", function() { return interpolationV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpb1", function() { return pipeBind1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpb2", function() { return pipeBind2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpb3", function() { return pipeBind3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpb4", function() { return pipeBind4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpbV", function() { return pipeBindV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf0", function() { return pureFunction0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf1", function() { return pureFunction1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf2", function() { return pureFunction2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf3", function() { return pureFunction3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf4", function() { return pureFunction4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf5", function() { return pureFunction5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf6", function() { return pureFunction6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf7", function() { return pureFunction7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf8", function() { return pureFunction8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵfV", function() { return pureFunctionV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcR", function() { return containerRefreshStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcr", function() { return containerRefreshEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵqR", function() { return queryRefresh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵql", function() { return loadQueryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return elementEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵp", function() { return elementProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpD", function() { return projectionDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵrS", function() { return reserveSlots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return elementAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵs", function() { return elementStyling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsm", function() { return elementStylingMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsp", function() { return elementStyleProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsa", function() { return elementStylingApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcp", function() { return elementClassProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵt", function() { return textBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵv", function() { return embeddedViewEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵst", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵld", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPp", function() { return pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵwhenRendered", function() { return whenRendered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiA", function() { return i18nApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiEM", function() { return i18nExpMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiI1", function() { return i18nInterpolation1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiI2", function() { return i18nInterpolation2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiI3", function() { return i18nInterpolation3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiI4", function() { return i18nInterpolation4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiI5", function() { return i18nInterpolation5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiI6", function() { return i18nInterpolation6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiI7", function() { return i18nInterpolation7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiI8", function() { return i18nInterpolation8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵIV", function() { return i18nInterpolationV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵiM", function() { return i18nMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsanitizeHtml", function() { return sanitizeHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsanitizeStyle", function() { return sanitizeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsanitizeUrl", function() { return sanitizeUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsanitizeResourceUrl", function() { return sanitizeResourceUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustHtml", function() { return bypassSanitizationTrustHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustStyle", function() { return bypassSanitizationTrustStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustScript", function() { return bypassSanitizationTrustScript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustUrl", function() { return bypassSanitizationTrustUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbypassSanitizationTrustResourceUrl", function() { return bypassSanitizationTrustResourceUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵregisterModuleFactory", function() { return registerModuleFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵEMPTY_ARRAY", function() { return EMPTY_ARRAY$2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵEMPTY_MAP", function() { return EMPTY_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵand", function() { return anchorDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵccf", function() { return createComponentFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcmf", function() { return createNgModuleFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcrt", function() { return createRendererType2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdid", function() { return directiveDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵeld", function() { return elementDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵelementEventFullName", function() { return elementEventFullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetComponentViewDefinitionFactory", function() { return getComponentViewDefinitionFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinlineInterpolate", function() { return inlineInterpolate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinterpolate", function() { return interpolate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmod", function() { return moduleDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmpd", function() { return moduleProvideDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵncd", function() { return ngContentDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵnov", function() { return nodeValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpid", function() { return pipeDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵprd", function() { return providerDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpad", function() { return pureArrayDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpod", function() { return pureObjectDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵppd", function() { return purePipeDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵqud", function() { return queryDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵted", function() { return textDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵunv", function() { return unwrapValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵvid", function() { return viewDef; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = /*@__PURE__*/__webpack_require__("0nHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START tslib,rxjs,rxjs_operators PURE_IMPORTS_END */



/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Construct an `InjectableDef` which defines how a token will be constructed by the DI system, and
 * in which injectors (if any) it will be available.
 *
 * This should be assigned to a static `ngInjectableDef` field on a type, which will then be an
 * `InjectableType`.
 *
 * Options:
 * * `providedIn` determines which injectors will include the injectable, by either associating it
 *   with an `@NgModule` or other `InjectorType`, or by specifying that this injectable should be
 *   provided in the `'root'` injector, which will be the application-level injector in most apps.
 * * `factory` gives the zero argument function which will create an instance of the injectable.
 *   The factory can call `inject` to access the `Injector` and request injection of dependencies.
 *
 * @experimental
 */
function defineInjectable(opts) {
    return {
        providedIn: opts.providedIn || null, factory: opts.factory, value: undefined,
    };
}
/**
 * Construct an `InjectorDef` which configures an injector.
 *
 * This should be assigned to a static `ngInjectorDef` field on a type, which will then be an
 * `InjectorType`.
 *
 * Options:
 *
 * * `factory`: an `InjectorType` is an instantiable type, so a zero argument `factory` function to
 *   create the type must be provided. If that factory function needs to inject arguments, it can
 *   use the `inject` function.
 * * `providers`: an optional array of providers to add to the injector. Each provider must
 *   either have a factory or point to a type which has an `ngInjectableDef` static property (the
 *   type must be an `InjectableType`).
 * * `imports`: an optional array of imports of other `InjectorType`s or `InjectorTypeWithModule`s
 *   whose providers will also be added to the injector. Locally provided types will override
 *   providers from imports.
 *
 * @experimental
 */
function defineInjector(options) {
    return {
        factory: options.factory, providers: options.providers || [], imports: options.imports || [],
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates a token that can be used in a DI Provider.
 *
 * Use an `InjectionToken` whenever the type you are injecting is not reified (does not have a
 * runtime representation) such as when injecting an interface, callable type, array or
 * parametrized type.
 *
 * `InjectionToken` is parameterized on `T` which is the type of object which will be returned by
 * the `Injector`. This provides additional level of type safety.
 *
 * ```
 * interface MyInterface {...}
 * var myInterface = injector.get(new InjectionToken<MyInterface>('SomeToken'));
 * // myInterface is inferred to be MyInterface.
 * ```
 *
 * When creating an `InjectionToken`, you can optionally specify a factory function which returns
 * (possibly by creating) a default value of the parameterized type `T`. This sets up the
 * `InjectionToken` using this factory as a provider as if it was defined explicitly in the
 * application's root injector. If the factory function, which takes zero arguments, needs to inject
 * dependencies, it can do so using the `inject` function. See below for an example.
 *
 * Additionally, if a `factory` is specified you can also specify the `providedIn` option, which
 * overrides the above behavior and marks the token as belonging to a particular `@NgModule`. As
 * mentioned above, `'root'` is the default value for `providedIn`.
 *
 * @usageNotes
 * ### Basic Example
 *
 * ### Plain InjectionToken
 *
 * {@example core/di/ts/injector_spec.ts region='InjectionToken'}
 *
 * ### Tree-shakable InjectionToken
 *
 * {@example core/di/ts/injector_spec.ts region='ShakableInjectionToken'}
 *
 */
var InjectionToken = /*@__PURE__*/ (function () {
    function InjectionToken(_desc, options) {
        this._desc = _desc;
        /** @internal */
        this.ngMetadataName = 'InjectionToken';
        if (options !== undefined) {
            this.ngInjectableDef = defineInjectable({
                providedIn: options.providedIn || 'root',
                factory: options.factory,
            });
        }
        else {
            this.ngInjectableDef = undefined;
        }
    }
    InjectionToken.prototype.toString = function () { return "InjectionToken " + this._desc; };
    return InjectionToken;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ANNOTATIONS = '__annotations__';
var PARAMETERS = '__parameters__';
var PROP_METADATA = '__prop__metadata__';
/**
 * @suppress {globalThis}
 */
function makeDecorator(name, props, parentClass, chainFn, typeFn) {
    var metaCtor = makeMetadataCtor(props);
    function DecoratorFactory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a;
        if (this instanceof DecoratorFactory) {
            metaCtor.call.apply(metaCtor, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([this], args));
            return this;
        }
        var annotationInstance = new ((_a = DecoratorFactory).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], args)))();
        var TypeDecorator = function TypeDecorator(cls) {
            typeFn && typeFn.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([cls], args));
            // Use of Object.defineProperty is important since it creates non-enumerable property which
            // prevents the property is copied during subclassing.
            var annotations = cls.hasOwnProperty(ANNOTATIONS) ?
                cls[ANNOTATIONS] :
                Object.defineProperty(cls, ANNOTATIONS, { value: [] })[ANNOTATIONS];
            annotations.push(annotationInstance);
            return cls;
        };
        if (chainFn)
            chainFn(TypeDecorator);
        return TypeDecorator;
    }
    if (parentClass) {
        DecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    DecoratorFactory.prototype.ngMetadataName = name;
    DecoratorFactory.annotationCls = DecoratorFactory;
    return DecoratorFactory;
}
function makeMetadataCtor(props) {
    return function ctor() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (props) {
            var values = props.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(args));
            for (var propName in values) {
                this[propName] = values[propName];
            }
        }
    };
}
function makeParamDecorator(name, props, parentClass) {
    var metaCtor = makeMetadataCtor(props);
    function ParamDecoratorFactory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a;
        if (this instanceof ParamDecoratorFactory) {
            metaCtor.apply(this, args);
            return this;
        }
        var annotationInstance = new ((_a = ParamDecoratorFactory).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], args)))();
        ParamDecorator.annotation = annotationInstance;
        return ParamDecorator;
        function ParamDecorator(cls, unusedKey, index) {
            // Use of Object.defineProperty is important since it creates non-enumerable property which
            // prevents the property is copied during subclassing.
            var parameters = cls.hasOwnProperty(PARAMETERS) ?
                cls[PARAMETERS] :
                Object.defineProperty(cls, PARAMETERS, { value: [] })[PARAMETERS];
            // there might be gaps if some in between parameters do not have annotations.
            // we pad with nulls.
            while (parameters.length <= index) {
                parameters.push(null);
            }
            (parameters[index] = parameters[index] || []).push(annotationInstance);
            return cls;
        }
    }
    if (parentClass) {
        ParamDecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    ParamDecoratorFactory.prototype.ngMetadataName = name;
    ParamDecoratorFactory.annotationCls = ParamDecoratorFactory;
    return ParamDecoratorFactory;
}
function makePropDecorator(name, props, parentClass) {
    var metaCtor = makeMetadataCtor(props);
    function PropDecoratorFactory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a;
        if (this instanceof PropDecoratorFactory) {
            metaCtor.apply(this, args);
            return this;
        }
        var decoratorInstance = new ((_a = PropDecoratorFactory).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], args)))();
        return function PropDecorator(target, name) {
            var constructor = target.constructor;
            // Use of Object.defineProperty is important since it creates non-enumerable property which
            // prevents the property is copied during subclassing.
            var meta = constructor.hasOwnProperty(PROP_METADATA) ?
                constructor[PROP_METADATA] :
                Object.defineProperty(constructor, PROP_METADATA, { value: {} })[PROP_METADATA];
            meta[name] = meta.hasOwnProperty(name) && meta[name] || [];
            meta[name].unshift(decoratorInstance);
        };
    }
    if (parentClass) {
        PropDecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    PropDecoratorFactory.prototype.ngMetadataName = name;
    PropDecoratorFactory.annotationCls = PropDecoratorFactory;
    return PropDecoratorFactory;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This token can be used to create a virtual provider that will populate the
 * `entryComponents` fields of components and ng modules based on its `useValue`.
 * All components that are referenced in the `useValue` value (either directly
 * or in a nested array or map) will be added to the `entryComponents` property.
 *
 * @usageNotes
 * ### Example
 * The following example shows how the router can populate the `entryComponents`
 * field of an NgModule based on the router configuration which refers
 * to components.
 *
 * ```typescript
 * // helper function inside the router
 * function provideRoutes(routes) {
 *   return [
 *     {provide: ROUTES, useValue: routes},
 *     {provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: routes, multi: true}
 *   ];
 * }
 *
 * // user code
 * let routes = [
 *   {path: '/root', component: RootComp},
 *   {path: '/teams', component: TeamsComp}
 * ];
 *
 * @NgModule({
 *   providers: [provideRoutes(routes)]
 * })
 * class ModuleWithRoutes {}
 * ```
 *
 * @experimental
 */
var ANALYZE_FOR_ENTRY_COMPONENTS = /*@__PURE__*/ new InjectionToken('AnalyzeForEntryComponents');
/**
 * Attribute decorator and metadata.
 *
 * @Annotation
 */
var Attribute = /*@__PURE__*/ makeParamDecorator('Attribute', function (attributeName) { return ({ attributeName: attributeName }); });
/**
 * Base class for query metadata.
 *
 * @see `ContentChildren`.
 * @see `ContentChild`.
 * @see `ViewChildren`.
 * @see `ViewChild`.
 */
var Query = /*@__PURE__*/ (function () {
    function Query() {
    }
    return Query;
}());
/**
 * ContentChildren decorator and metadata.
 *
 *
 *  @Annotation
 */
var ContentChildren = /*@__PURE__*/ makePropDecorator('ContentChildren', function (selector, data) {
    if (data === void 0) {
        data = {};
    }
    return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ selector: selector, first: false, isViewQuery: false, descendants: false }, data));
}, Query);
/**
 * ContentChild decorator and metadata.
 *
 *
 * @Annotation
 */
var ContentChild = /*@__PURE__*/ makePropDecorator('ContentChild', function (selector, data) {
    if (data === void 0) {
        data = {};
    }
    return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ selector: selector, first: true, isViewQuery: false, descendants: true }, data));
}, Query);
/**
 * ViewChildren decorator and metadata.
 *
 * @Annotation
 */
var ViewChildren = /*@__PURE__*/ makePropDecorator('ViewChildren', function (selector, data) {
    if (data === void 0) {
        data = {};
    }
    return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ selector: selector, first: false, isViewQuery: true, descendants: true }, data));
}, Query);
/**
 * ViewChild decorator and metadata.
 *
 * @Annotation
 */
var ViewChild = /*@__PURE__*/ makePropDecorator('ViewChild', function (selector, data) {
    return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ selector: selector, first: true, isViewQuery: true, descendants: true }, data));
}, Query);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The strategy that the default change detector uses to detect changes.
 * When set, takes effect the next time change detection is triggered.
 *
 */
var ChangeDetectionStrategy = /*@__PURE__*/ (function (ChangeDetectionStrategy) {
    /**
     * Use the `CheckOnce` strategy, meaning that automatic change detection is deactivated
     * until reactivated by setting the strategy to `Default` (`CheckAlways`).
     * Change detection can still be explictly invoked.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["OnPush"] = 0] = "OnPush";
    /**
     * Use the default `CheckAlways` strategy, in which change detection is automatic until
     * explicitly deactivated.
     */
    ChangeDetectionStrategy[ChangeDetectionStrategy["Default"] = 1] = "Default";
    return ChangeDetectionStrategy;
})({});
/**
 * Defines the possible states of the default change detector.
 * @see `ChangeDetectorRef`
 */
var ChangeDetectorStatus = /*@__PURE__*/ (function (ChangeDetectorStatus) {
    /**
     * A state in which, after calling `detectChanges()`, the change detector
     * state becomes `Checked`, and must be explicitly invoked or reactivated.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["CheckOnce"] = 0] = "CheckOnce";
    /**
     * A state in which change detection is skipped until the change detector mode
     * becomes `CheckOnce`.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["Checked"] = 1] = "Checked";
    /**
     * A state in which change detection continues automatically until explictly
     * deactivated.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["CheckAlways"] = 2] = "CheckAlways";
    /**
     * A state in which a change detector sub tree is not a part of the main tree and
     * should be skipped.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["Detached"] = 3] = "Detached";
    /**
     * Indicates that the change detector encountered an error checking a binding
     * or calling a directive lifecycle method and is now in an inconsistent state. Change
     * detectors in this state do not detect changes.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["Errored"] = 4] = "Errored";
    /**
     * Indicates that the change detector has been destroyed.
     */
    ChangeDetectorStatus[ChangeDetectorStatus["Destroyed"] = 5] = "Destroyed";
    return ChangeDetectorStatus;
})({});
/**
 * Reports whether a given strategy is currently the default for change detection.
 * @param changeDetectionStrategy The strategy to check.
 * @returns True if the given strategy is the current default, false otherwise.
 * @see `ChangeDetectorStatus`
 * @see `ChangeDetectorRef`
 */
function isDefaultChangeDetectionStrategy(changeDetectionStrategy) {
    return changeDetectionStrategy == null ||
        changeDetectionStrategy === ChangeDetectionStrategy.Default;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ivyEnabled = false;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Type of the Directive metadata.
 */
var Directive = /*@__PURE__*/ makeDecorator('Directive', function (dir) {
    if (dir === void 0) {
        dir = {};
    }
    return dir;
}, undefined, undefined, function (type, meta) { return (function () { })(type, meta); });
/**
 * Component decorator and metadata.
 *
 * @usageNotes
 *
 * ### Using animations
 *
 * The following snippet shows an animation trigger in a component's
 * metadata. The trigger is attached to an element in the component's
 * template, using "@_trigger_name_", and a state expression that is evaluated
 * at run time to determine whether the animation should start.
 *
 * ```typescript
 * @Component({
 *   selector: 'animation-cmp',
 *   templateUrl: 'animation-cmp.html',
 *   animations: [
 *     trigger('myTriggerName', [
 *       state('on', style({ opacity: 1 }),
 *       state('off', style({ opacity: 0 }),
 *       transition('on => off', [
 *         animate("1s")
 *       ])
 *     ])
 *   ]
 * })
 * ```
 *
 * ```html
 * <!-- animation-cmp.html -->
 * <div @myTriggerName="expression">...</div>
 * ```
 *
 * ### Preserving whitespace
 *
 * Removing whitespace can greatly reduce AOT-generated code size, and speed up view creation.
 * As of Angular 6, default for `preserveWhitespaces` is false (whitespace is removed).
 * To change the default setting for all components in your application, set
 * the `preserveWhitespaces` option of the AOT compiler.
 *
 * Current implementation removes whitespace characters as follows:
 * - Trims all whitespaces at the beginning and the end of a template.
 * - Removes whitespace-only text nodes. For example,
 * `<button>Action 1</button>  <button>Action 2</button>` becomes
 * `<button>Action 1</button><button>Action 2</button>`.
 * - Replaces a series of whitespace characters in text nodes with a single space.
 * For example, `<span>\n some text\n</span>` becomes `<span> some text </span>`.
 * - Does NOT alter text nodes inside HTML tags such as `<pre>` or `<textarea>`,
 * where whitespace characters are significant.
 *
 * Note that these transformations can influence DOM nodes layout, although impact
 * should be minimal.
 *
 * You can override the default behavior to preserve whitespace characters
 * in certain fragments of a template. For example, you can exclude an entire
 * DOM sub-tree by using the `ngPreserveWhitespaces` attribute:
 *
 * ```html
 * <div ngPreserveWhitespaces>
 *     whitespaces are preserved here
 *     <span>    and here </span>
 * </div>
 * ```
 *
 * You can force a single space to be preserved in a text node by using `&ngsp;`,
 * which is replaced with a space character by Angular's template
 * compiler:
 *
 * ```html
 * <a>Spaces</a>&ngsp;<a>between</a>&ngsp;<a>links.</a>
 * <!-->compiled to be equivalent to:</>
 *  <a>Spaces</a> <a>between</a> <a>links.</a>
 * ```
 *
 * Note that sequences of `&ngsp;` are still collapsed to just one space character when
 * the `preserveWhitespaces` option is set to `false`.
 *
 * ```html
 * <a>before</a>&ngsp;&ngsp;&ngsp;<a>after</a>
 * <!-->compiled to be equivalent to:</>
 *  <a>Spaces</a> <a>between</a> <a>links.</a>
 * ```
 *
 * To preserve sequences of whitespace characters, use the
 * `ngPreserveWhitespaces` attribute.
 *
 * @Annotation
 */
var Component = /*@__PURE__*/ makeDecorator('Component', function (c) {
    if (c === void 0) {
        c = {};
    }
    return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ changeDetection: ChangeDetectionStrategy.Default }, c));
}, Directive, undefined, function (type, meta) { return (function () { })(type, meta); });
/**
 *
 *
 * @Annotation
 */
var Pipe = /*@__PURE__*/ makeDecorator('Pipe', function (p) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ pure: true }, p)); }, undefined, undefined, function (type, meta) { return (function () { })(type, meta); });
/**
 *
 * @Annotation
 */
var Input = /*@__PURE__*/ makePropDecorator('Input', function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); });
/**
 *
 * @Annotation
 */
var Output = /*@__PURE__*/ makePropDecorator('Output', function (bindingPropertyName) { return ({ bindingPropertyName: bindingPropertyName }); });
/**
 *
 * @Annotation
 */
var HostBinding = /*@__PURE__*/ makePropDecorator('HostBinding', function (hostPropertyName) { return ({ hostPropertyName: hostPropertyName }); });
/**
 * Binds a CSS event to a host listener and supplies configuration metadata.
 * Angular invokes the supplied handler method when the host element emits the specified event,
 * and updates the bound element with the result.
 * If the handler method returns false, applies `preventDefault` on the bound element.
 *
 * @usageNotes
 *
 * The following example declares a directive
 * that attaches a click listener to a button and counts clicks.
 *
 * ```
 * @Directive({selector: 'button[counting]'})
 * class CountClicks {
 *   numberOfClicks = 0;
 *
 *   @HostListener('click', ['$event.target'])
 *   onClick(btn) {
 *     console.log('button', btn, 'number of clicks:', this.numberOfClicks++);
 *  }
 * }
 *
 * @Component({
 *   selector: 'app',
 *   template: '<button counting>Increment</button>',
 * })
 * class App {}
 * ```
 *
 * @Annotation
 */
var HostListener = /*@__PURE__*/ makePropDecorator('HostListener', function (eventName, args) { return ({ eventName: eventName, args: args }); });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Represents a type that a Component or other object is instances of.
 *
 * An example of a `Type` is `MyCustomComponent` class, which in JavaScript is be represented by
 * the `MyCustomComponent` constructor function.
 *
 *
 */
var Type = Function;
function isType(v) {
    return typeof v === 'function';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
// Check __global first, because in Node tests both __global and __window may be defined and _global
// should be __global in that case.
var _global = __global || __window || __self;
var promise = /*@__PURE__*/ Promise.resolve(0);
var _symbolIterator = null;
function getSymbolIterator() {
    if (!_symbolIterator) {
        var Symbol_1 = _global['Symbol'];
        if (Symbol_1 && Symbol_1.iterator) {
            _symbolIterator = Symbol_1.iterator;
        }
        else {
            // es6-shim specific logic
            var keys = Object.getOwnPropertyNames(Map.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (key !== 'entries' && key !== 'size' &&
                    Map.prototype[key] === Map.prototype['entries']) {
                    _symbolIterator = key;
                }
            }
        }
    }
    return _symbolIterator;
}
function scheduleMicroTask(fn) {
    if (typeof Zone === 'undefined') {
        // use promise to schedule microTask instead of use Zone
        promise.then(function () { fn && fn.apply(null, null); });
    }
    else {
        Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
    }
}
// JS has NaN !== NaN
function looseIdentical(a, b) {
    return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
}
function stringify(token) {
    if (typeof token === 'string') {
        return token;
    }
    if (token instanceof Array) {
        return '[' + token.map(stringify).join(', ') + ']';
    }
    if (token == null) {
        return '' + token;
    }
    if (token.overriddenName) {
        return "" + token.overriddenName;
    }
    if (token.name) {
        return "" + token.name;
    }
    var res = token.toString();
    if (res == null) {
        return '' + res;
    }
    var newLineIndex = res.indexOf('\n');
    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Attention: These regex has to hold even if the code is minified!
 */
var DELEGATE_CTOR = /^function\s+\S+\(\)\s*{[\s\S]+\.apply\(this,\s*arguments\)/;
var INHERITED_CLASS = /^class\s+[A-Za-z\d$_]*\s*extends\s+[A-Za-z\d$_]+\s*{/;
var INHERITED_CLASS_WITH_CTOR = /^class\s+[A-Za-z\d$_]*\s*extends\s+[A-Za-z\d$_]+\s*{[\s\S]*constructor\s*\(/;
var ReflectionCapabilities = /*@__PURE__*/ (function () {
    function ReflectionCapabilities(reflect) {
        this._reflect = reflect || _global['Reflect'];
    }
    ReflectionCapabilities.prototype.isReflectionEnabled = function () { return true; };
    ReflectionCapabilities.prototype.factory = function (t) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (t.bind.apply(t, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], args)))();
        };
    };
    /** @internal */
    ReflectionCapabilities.prototype._zipTypesAndAnnotations = function (paramTypes, paramAnnotations) {
        var result;
        if (typeof paramTypes === 'undefined') {
            result = new Array(paramAnnotations.length);
        }
        else {
            result = new Array(paramTypes.length);
        }
        for (var i = 0; i < result.length; i++) {
            // TS outputs Object for parameters without types, while Traceur omits
            // the annotations. For now we preserve the Traceur behavior to aid
            // migration, but this can be revisited.
            if (typeof paramTypes === 'undefined') {
                result[i] = [];
            }
            else if (paramTypes[i] != Object) {
                result[i] = [paramTypes[i]];
            }
            else {
                result[i] = [];
            }
            if (paramAnnotations && paramAnnotations[i] != null) {
                result[i] = result[i].concat(paramAnnotations[i]);
            }
        }
        return result;
    };
    ReflectionCapabilities.prototype._ownParameters = function (type, parentCtor) {
        var typeStr = type.toString();
        // If we have no decorators, we only have function.length as metadata.
        // In that case, to detect whether a child class declared an own constructor or not,
        // we need to look inside of that constructor to check whether it is
        // just calling the parent.
        // This also helps to work around for https://github.com/Microsoft/TypeScript/issues/12439
        // that sets 'design:paramtypes' to []
        // if a class inherits from another class but has no ctor declared itself.
        if (DELEGATE_CTOR.exec(typeStr) ||
            (INHERITED_CLASS.exec(typeStr) && !INHERITED_CLASS_WITH_CTOR.exec(typeStr))) {
            return null;
        }
        // Prefer the direct API.
        if (type.parameters && type.parameters !== parentCtor.parameters) {
            return type.parameters;
        }
        // API of tsickle for lowering decorators to properties on the class.
        var tsickleCtorParams = type.ctorParameters;
        if (tsickleCtorParams && tsickleCtorParams !== parentCtor.ctorParameters) {
            // Newer tsickle uses a function closure
            // Retain the non-function case for compatibility with older tsickle
            var ctorParameters = typeof tsickleCtorParams === 'function' ? tsickleCtorParams() : tsickleCtorParams;
            var paramTypes_1 = ctorParameters.map(function (ctorParam) { return ctorParam && ctorParam.type; });
            var paramAnnotations_1 = ctorParameters.map(function (ctorParam) {
                return ctorParam && convertTsickleDecoratorIntoMetadata(ctorParam.decorators);
            });
            return this._zipTypesAndAnnotations(paramTypes_1, paramAnnotations_1);
        }
        // API for metadata created by invoking the decorators.
        var paramAnnotations = type.hasOwnProperty(PARAMETERS) && type[PARAMETERS];
        var paramTypes = this._reflect && this._reflect.getOwnMetadata &&
            this._reflect.getOwnMetadata('design:paramtypes', type);
        if (paramTypes || paramAnnotations) {
            return this._zipTypesAndAnnotations(paramTypes, paramAnnotations);
        }
        // If a class has no decorators, at least create metadata
        // based on function.length.
        // Note: We know that this is a real constructor as we checked
        // the content of the constructor above.
        return new Array(type.length).fill(undefined);
    };
    ReflectionCapabilities.prototype.parameters = function (type) {
        // Note: only report metadata if we have at least one class decorator
        // to stay in sync with the static reflector.
        if (!isType(type)) {
            return [];
        }
        var parentCtor = getParentCtor(type);
        var parameters = this._ownParameters(type, parentCtor);
        if (!parameters && parentCtor !== Object) {
            parameters = this.parameters(parentCtor);
        }
        return parameters || [];
    };
    ReflectionCapabilities.prototype._ownAnnotations = function (typeOrFunc, parentCtor) {
        // Prefer the direct API.
        if (typeOrFunc.annotations && typeOrFunc.annotations !== parentCtor.annotations) {
            var annotations = typeOrFunc.annotations;
            if (typeof annotations === 'function' && annotations.annotations) {
                annotations = annotations.annotations;
            }
            return annotations;
        }
        // API of tsickle for lowering decorators to properties on the class.
        if (typeOrFunc.decorators && typeOrFunc.decorators !== parentCtor.decorators) {
            return convertTsickleDecoratorIntoMetadata(typeOrFunc.decorators);
        }
        // API for metadata created by invoking the decorators.
        if (typeOrFunc.hasOwnProperty(ANNOTATIONS)) {
            return typeOrFunc[ANNOTATIONS];
        }
        return null;
    };
    ReflectionCapabilities.prototype.annotations = function (typeOrFunc) {
        if (!isType(typeOrFunc)) {
            return [];
        }
        var parentCtor = getParentCtor(typeOrFunc);
        var ownAnnotations = this._ownAnnotations(typeOrFunc, parentCtor) || [];
        var parentAnnotations = parentCtor !== Object ? this.annotations(parentCtor) : [];
        return parentAnnotations.concat(ownAnnotations);
    };
    ReflectionCapabilities.prototype._ownPropMetadata = function (typeOrFunc, parentCtor) {
        // Prefer the direct API.
        if (typeOrFunc.propMetadata &&
            typeOrFunc.propMetadata !== parentCtor.propMetadata) {
            var propMetadata = typeOrFunc.propMetadata;
            if (typeof propMetadata === 'function' && propMetadata.propMetadata) {
                propMetadata = propMetadata.propMetadata;
            }
            return propMetadata;
        }
        // API of tsickle for lowering decorators to properties on the class.
        if (typeOrFunc.propDecorators &&
            typeOrFunc.propDecorators !== parentCtor.propDecorators) {
            var propDecorators_1 = typeOrFunc.propDecorators;
            var propMetadata_1 = {};
            Object.keys(propDecorators_1).forEach(function (prop) {
                propMetadata_1[prop] = convertTsickleDecoratorIntoMetadata(propDecorators_1[prop]);
            });
            return propMetadata_1;
        }
        // API for metadata created by invoking the decorators.
        if (typeOrFunc.hasOwnProperty(PROP_METADATA)) {
            return typeOrFunc[PROP_METADATA];
        }
        return null;
    };
    ReflectionCapabilities.prototype.propMetadata = function (typeOrFunc) {
        if (!isType(typeOrFunc)) {
            return {};
        }
        var parentCtor = getParentCtor(typeOrFunc);
        var propMetadata = {};
        if (parentCtor !== Object) {
            var parentPropMetadata_1 = this.propMetadata(parentCtor);
            Object.keys(parentPropMetadata_1).forEach(function (propName) {
                propMetadata[propName] = parentPropMetadata_1[propName];
            });
        }
        var ownPropMetadata = this._ownPropMetadata(typeOrFunc, parentCtor);
        if (ownPropMetadata) {
            Object.keys(ownPropMetadata).forEach(function (propName) {
                var decorators = [];
                if (propMetadata.hasOwnProperty(propName)) {
                    decorators.push.apply(decorators, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(propMetadata[propName]));
                }
                decorators.push.apply(decorators, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(ownPropMetadata[propName]));
                propMetadata[propName] = decorators;
            });
        }
        return propMetadata;
    };
    ReflectionCapabilities.prototype.hasLifecycleHook = function (type, lcProperty) {
        return type instanceof Type && lcProperty in type.prototype;
    };
    ReflectionCapabilities.prototype.guards = function (type) { return {}; };
    ReflectionCapabilities.prototype.getter = function (name) { return new Function('o', 'return o.' + name + ';'); };
    ReflectionCapabilities.prototype.setter = function (name) {
        return new Function('o', 'v', 'return o.' + name + ' = v;');
    };
    ReflectionCapabilities.prototype.method = function (name) {
        var functionBody = "if (!o." + name + ") throw new Error('\"" + name + "\" is undefined');\n        return o." + name + ".apply(o, args);";
        return new Function('o', 'args', functionBody);
    };
    // There is not a concept of import uri in Js, but this is useful in developing Dart applications.
    ReflectionCapabilities.prototype.importUri = function (type) {
        // StaticSymbol
        if (typeof type === 'object' && type['filePath']) {
            return type['filePath'];
        }
        // Runtime type
        return "./" + stringify(type);
    };
    ReflectionCapabilities.prototype.resourceUri = function (type) { return "./" + stringify(type); };
    ReflectionCapabilities.prototype.resolveIdentifier = function (name, moduleUrl, members, runtime) {
        return runtime;
    };
    ReflectionCapabilities.prototype.resolveEnum = function (enumIdentifier, name) { return enumIdentifier[name]; };
    return ReflectionCapabilities;
}());
function convertTsickleDecoratorIntoMetadata(decoratorInvocations) {
    if (!decoratorInvocations) {
        return [];
    }
    return decoratorInvocations.map(function (decoratorInvocation) {
        var decoratorType = decoratorInvocation.type;
        var annotationCls = decoratorType.annotationCls;
        var annotationArgs = decoratorInvocation.args ? decoratorInvocation.args : [];
        return new (annotationCls.bind.apply(annotationCls, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], annotationArgs)))();
    });
}
function getParentCtor(ctor) {
    var parentProto = ctor.prototype ? Object.getPrototypeOf(ctor.prototype) : null;
    var parentCtor = parentProto ? parentProto.constructor : null;
    // Note: We always use `Object` as the null value
    // to simplify checking later on.
    return parentCtor || Object;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function getClosureSafeProperty(objWithPropertyToExtract, target) {
    for (var key in objWithPropertyToExtract) {
        if (objWithPropertyToExtract[key] === target) {
            return key;
        }
    }
    throw Error('Could not find renamed property on target object.');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Allows to refer to references which are not yet defined.
 *
 * For instance, `forwardRef` is used when the `token` which we need to refer to for the purposes of
 * DI is declared, but not yet defined. It is also used when the `token` which we use when creating
 * a query is not yet defined.
 *
 * @usageNotes
 * ### Example
 * {@example core/di/ts/forward_ref/forward_ref_spec.ts region='forward_ref'}
 * @experimental
 */
function forwardRef(forwardRefFn) {
    forwardRefFn.__forward_ref__ = forwardRef;
    forwardRefFn.toString = function () { return stringify(this()); };
    return forwardRefFn;
}
/**
 * Lazily retrieves the reference value from a forwardRef.
 *
 * Acts as the identity function when given a non-forward-ref value.
 *
 * @usageNotes
 * ### Example
 *
 * {@example core/di/ts/forward_ref/forward_ref_spec.ts region='resolve_forward_ref'}
 *
 * @see `forwardRef`
 * @experimental
 */
function resolveForwardRef(type) {
    if (typeof type === 'function' && type.hasOwnProperty('__forward_ref__') &&
        type.__forward_ref__ === forwardRef) {
        return type();
    }
    else {
        return type;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Inject decorator and metadata.
 *
 * @Annotation
 */
var Inject = /*@__PURE__*/ makeParamDecorator('Inject', function (token) { return ({ token: token }); });
/**
 * Optional decorator and metadata.
 *
 * @Annotation
 */
var Optional = /*@__PURE__*/ makeParamDecorator('Optional');
/**
 * Self decorator and metadata.
 *
 * @Annotation
 */
var Self = /*@__PURE__*/ makeParamDecorator('Self');
/**
 * SkipSelf decorator and metadata.
 *
 * @Annotation
 */
var SkipSelf = /*@__PURE__*/ makeParamDecorator('SkipSelf');
/**
 * Host decorator and metadata.
 *
 * @Annotation
 */
var Host = /*@__PURE__*/ makeParamDecorator('Host');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SOURCE = '__source';
var _THROW_IF_NOT_FOUND = /*@__PURE__*/ new Object();
var THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
/**
 * An InjectionToken that gets the current `Injector` for `createInjector()`-style injectors.
 *
 * Requesting this token instead of `Injector` allows `StaticInjector` to be tree-shaken from a
 * project.
 *
 * @experimental
 */
var INJECTOR = /*@__PURE__*/ new InjectionToken('INJECTOR');
var NullInjector = /*@__PURE__*/ (function () {
    function NullInjector() {
    }
    NullInjector.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) {
            notFoundValue = _THROW_IF_NOT_FOUND;
        }
        if (notFoundValue === _THROW_IF_NOT_FOUND) {
            // Intentionally left behind: With dev tools open the debugger will stop here. There is no
            // reason why correctly written application should cause this exception.
            // TODO(misko): uncomment the next line once `ngDevMode` works with closure.
            // if(ngDevMode) debugger;
            throw new Error("NullInjectorError: No provider for " + stringify(token) + "!");
        }
        return notFoundValue;
    };
    return NullInjector;
}());
/**
 * Concrete injectors implement this interface.
 *
 * For more details, see the ["Dependency Injection Guide"](guide/dependency-injection).
 *
 * @usageNotes
 * ### Example
 *
 * {@example core/di/ts/injector_spec.ts region='Injector'}
 *
 * `Injector` returns itself when given `Injector` as a token:
 *
 * {@example core/di/ts/injector_spec.ts region='injectInjector'}
 *
 *
 */
var Injector = /*@__PURE__*/ (function () {
    function Injector() {
    }
    /**
     * Create a new Injector which is configure using `StaticProvider`s.
     *
     * @usageNotes
     * ### Example
     *
     * {@example core/di/ts/provider_spec.ts region='ConstructorProvider'}
     */
    Injector.create = function (options, parent) {
        if (Array.isArray(options)) {
            return new StaticInjector(options, parent);
        }
        else {
            return new StaticInjector(options.providers, options.parent, options.name || null);
        }
    };
    Injector.THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
    Injector.NULL = new NullInjector();
    Injector.ngInjectableDef = defineInjectable({
        providedIn: 'any',
        factory: function () { return inject(INJECTOR); },
    });
    return Injector;
}());
var IDENT = function (value) {
    return value;
};
var EMPTY = [];
var CIRCULAR = IDENT;
var MULTI_PROVIDER_FN = function () {
    return Array.prototype.slice.call(arguments);
};
var GET_PROPERTY_NAME = {};
var USE_VALUE = /*@__PURE__*/ getClosureSafeProperty$1({ provide: String, useValue: GET_PROPERTY_NAME });
var NG_TOKEN_PATH = 'ngTokenPath';
var NG_TEMP_TOKEN_PATH = 'ngTempTokenPath';
var NULL_INJECTOR = Injector.NULL;
var NEW_LINE = /\n/gm;
var NO_NEW_LINE = 'ɵ';
var StaticInjector = /*@__PURE__*/ (function () {
    function StaticInjector(providers, parent, source) {
        if (parent === void 0) {
            parent = NULL_INJECTOR;
        }
        if (source === void 0) {
            source = null;
        }
        this.parent = parent;
        this.source = source;
        var records = this._records = new Map();
        records.set(Injector, { token: Injector, fn: IDENT, deps: EMPTY, value: this, useNew: false });
        records.set(INJECTOR, { token: INJECTOR, fn: IDENT, deps: EMPTY, value: this, useNew: false });
        recursivelyProcessProviders(records, providers);
    }
    StaticInjector.prototype.get = function (token, notFoundValue, flags) {
        if (flags === void 0) {
            flags = 0 /* Default */;
        }
        var record = this._records.get(token);
        try {
            return tryResolveToken(token, record, this._records, this.parent, notFoundValue, flags);
        }
        catch (e) {
            var tokenPath = e[NG_TEMP_TOKEN_PATH];
            if (token[SOURCE]) {
                tokenPath.unshift(token[SOURCE]);
            }
            e.message = formatError('\n' + e.message, tokenPath, this.source);
            e[NG_TOKEN_PATH] = tokenPath;
            e[NG_TEMP_TOKEN_PATH] = null;
            throw e;
        }
    };
    StaticInjector.prototype.toString = function () {
        var tokens = [], records = this._records;
        records.forEach(function (v, token) { return tokens.push(stringify(token)); });
        return "StaticInjector[" + tokens.join(', ') + "]";
    };
    return StaticInjector;
}());
function resolveProvider(provider) {
    var deps = computeDeps(provider);
    var fn = IDENT;
    var value = EMPTY;
    var useNew = false;
    var provide = resolveForwardRef(provider.provide);
    if (USE_VALUE in provider) {
        // We need to use USE_VALUE in provider since provider.useValue could be defined as undefined.
        value = provider.useValue;
    }
    else if (provider.useFactory) {
        fn = provider.useFactory;
    }
    else if (provider.useExisting)
        ;
    else if (provider.useClass) {
        useNew = true;
        fn = resolveForwardRef(provider.useClass);
    }
    else if (typeof provide == 'function') {
        useNew = true;
        fn = provide;
    }
    else {
        throw staticError('StaticProvider does not have [useValue|useFactory|useExisting|useClass] or [provide] is not newable', provider);
    }
    return { deps: deps, fn: fn, useNew: useNew, value: value };
}
function multiProviderMixError(token) {
    return staticError('Cannot mix multi providers and regular providers', token);
}
function recursivelyProcessProviders(records, provider) {
    if (provider) {
        provider = resolveForwardRef(provider);
        if (provider instanceof Array) {
            // if we have an array recurse into the array
            for (var i = 0; i < provider.length; i++) {
                recursivelyProcessProviders(records, provider[i]);
            }
        }
        else if (typeof provider === 'function') {
            // Functions were supported in ReflectiveInjector, but are not here. For safety give useful
            // error messages
            throw staticError('Function/Class not supported', provider);
        }
        else if (provider && typeof provider === 'object' && provider.provide) {
            // At this point we have what looks like a provider: {provide: ?, ....}
            var token = resolveForwardRef(provider.provide);
            var resolvedProvider = resolveProvider(provider);
            if (provider.multi === true) {
                // This is a multi provider.
                var multiProvider = records.get(token);
                if (multiProvider) {
                    if (multiProvider.fn !== MULTI_PROVIDER_FN) {
                        throw multiProviderMixError(token);
                    }
                }
                else {
                    // Create a placeholder factory which will look up the constituents of the multi provider.
                    records.set(token, multiProvider = {
                        token: provider.provide,
                        deps: [],
                        useNew: false,
                        fn: MULTI_PROVIDER_FN,
                        value: EMPTY
                    });
                }
                // Treat the provider as the token.
                token = provider;
                multiProvider.deps.push({ token: token, options: 6 /* Default */ });
            }
            var record = records.get(token);
            if (record && record.fn == MULTI_PROVIDER_FN) {
                throw multiProviderMixError(token);
            }
            records.set(token, resolvedProvider);
        }
        else {
            throw staticError('Unexpected provider', provider);
        }
    }
}
function tryResolveToken(token, record, records, parent, notFoundValue, flags) {
    try {
        return resolveToken(token, record, records, parent, notFoundValue, flags);
    }
    catch (e) {
        // ensure that 'e' is of type Error.
        if (!(e instanceof Error)) {
            e = new Error(e);
        }
        var path = e[NG_TEMP_TOKEN_PATH] = e[NG_TEMP_TOKEN_PATH] || [];
        path.unshift(token);
        if (record && record.value == CIRCULAR) {
            // Reset the Circular flag.
            record.value = EMPTY;
        }
        throw e;
    }
}
function resolveToken(token, record, records, parent, notFoundValue, flags) {
    var _a;
    var value;
    if (record && !(flags & 4 /* SkipSelf */)) {
        // If we don't have a record, this implies that we don't own the provider hence don't know how
        // to resolve it.
        value = record.value;
        if (value == CIRCULAR) {
            throw Error(NO_NEW_LINE + 'Circular dependency');
        }
        else if (value === EMPTY) {
            record.value = CIRCULAR;
            var obj = undefined;
            var useNew = record.useNew;
            var fn = record.fn;
            var depRecords = record.deps;
            var deps = EMPTY;
            if (depRecords.length) {
                deps = [];
                for (var i = 0; i < depRecords.length; i++) {
                    var depRecord = depRecords[i];
                    var options = depRecord.options;
                    var childRecord = options & 2 /* CheckSelf */ ? records.get(depRecord.token) : undefined;
                    deps.push(tryResolveToken(
                    // Current Token to resolve
                    depRecord.token, 
                    // A record which describes how to resolve the token.
                    // If undefined, this means we don't have such a record
                    childRecord, 
                    // Other records we know about.
                    records, 
                    // If we don't know how to resolve dependency and we should not check parent for it,
                    // than pass in Null injector.
                    !childRecord && !(options & 4 /* CheckParent */) ? NULL_INJECTOR : parent, options & 1 /* Optional */ ? null : Injector.THROW_IF_NOT_FOUND, 0 /* Default */));
                }
            }
            record.value = value = useNew ? new ((_a = fn).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], deps)))() : fn.apply(obj, deps);
        }
    }
    else if (!(flags & 2 /* Self */)) {
        value = parent.get(token, notFoundValue, 0 /* Default */);
    }
    return value;
}
function computeDeps(provider) {
    var deps = EMPTY;
    var providerDeps = provider.deps;
    if (providerDeps && providerDeps.length) {
        deps = [];
        for (var i = 0; i < providerDeps.length; i++) {
            var options = 6 /* Default */;
            var token = resolveForwardRef(providerDeps[i]);
            if (token instanceof Array) {
                for (var j = 0, annotations = token; j < annotations.length; j++) {
                    var annotation = annotations[j];
                    if (annotation instanceof Optional || annotation == Optional) {
                        options = options | 1 /* Optional */;
                    }
                    else if (annotation instanceof SkipSelf || annotation == SkipSelf) {
                        options = options & ~2 /* CheckSelf */;
                    }
                    else if (annotation instanceof Self || annotation == Self) {
                        options = options & ~4 /* CheckParent */;
                    }
                    else if (annotation instanceof Inject) {
                        token = annotation.token;
                    }
                    else {
                        token = resolveForwardRef(annotation);
                    }
                }
            }
            deps.push({ token: token, options: options });
        }
    }
    else if (provider.useExisting) {
        var token = resolveForwardRef(provider.useExisting);
        deps = [{ token: token, options: 6 /* Default */ }];
    }
    else if (!providerDeps && !(USE_VALUE in provider)) {
        // useValue & useExisting are the only ones which are exempt from deps all others need it.
        throw staticError('\'deps\' required', provider);
    }
    return deps;
}
function formatError(text, obj, source) {
    if (source === void 0) {
        source = null;
    }
    text = text && text.charAt(0) === '\n' && text.charAt(1) == NO_NEW_LINE ? text.substr(2) : text;
    var context = stringify(obj);
    if (obj instanceof Array) {
        context = obj.map(stringify).join(' -> ');
    }
    else if (typeof obj === 'object') {
        var parts = [];
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var value = obj[key];
                parts.push(key + ':' + (typeof value === 'string' ? JSON.stringify(value) : stringify(value)));
            }
        }
        context = "{" + parts.join(', ') + "}";
    }
    return "StaticInjectorError" + (source ? '(' + source + ')' : '') + "[" + context + "]: " + text.replace(NEW_LINE, '\n  ');
}
function staticError(text, obj) {
    return new Error(formatError(text, obj));
}
function getClosureSafeProperty$1(objWithPropertyToExtract) {
    for (var key in objWithPropertyToExtract) {
        if (objWithPropertyToExtract[key] === GET_PROPERTY_NAME) {
            return key;
        }
    }
    throw Error('!prop');
}
/**
 * Current injector value used by `inject`.
 * - `undefined`: it is an error to call `inject`
 * - `null`: `inject` can be called but there is no injector (limp-mode).
 * - Injector instance: Use the injector for resolution.
 */
var _currentInjector = undefined;
function setCurrentInjector(injector) {
    var former = _currentInjector;
    _currentInjector = injector;
    return former;
}
function inject(token, flags) {
    if (flags === void 0) {
        flags = 0 /* Default */;
    }
    if (_currentInjector === undefined) {
        throw new Error("inject() must be called from an injection context");
    }
    else if (_currentInjector === null) {
        var injectableDef = token.ngInjectableDef;
        if (injectableDef && injectableDef.providedIn == 'root') {
            return injectableDef.value === undefined ? injectableDef.value = injectableDef.factory() :
                injectableDef.value;
        }
        if (flags & 8 /* Optional */)
            return null;
        throw new Error("Injector: NOT_FOUND [" + stringify(token) + "]");
    }
    else {
        return _currentInjector.get(token, flags & 8 /* Optional */ ? null : undefined, flags);
    }
}
function injectArgs(types) {
    var args = [];
    for (var i = 0; i < types.length; i++) {
        var arg = types[i];
        if (Array.isArray(arg)) {
            if (arg.length === 0) {
                throw new Error('Arguments array must have arguments.');
            }
            var type = undefined;
            var flags = 0 /* Default */;
            for (var j = 0; j < arg.length; j++) {
                var meta = arg[j];
                if (meta instanceof Optional || meta.ngMetadataName === 'Optional') {
                    flags |= 8 /* Optional */;
                }
                else if (meta instanceof SkipSelf || meta.ngMetadataName === 'SkipSelf') {
                    flags |= 4 /* SkipSelf */;
                }
                else if (meta instanceof Self || meta.ngMetadataName === 'Self') {
                    flags |= 2 /* Self */;
                }
                else if (meta instanceof Inject) {
                    type = meta.token;
                }
                else {
                    type = meta;
                }
            }
            args.push(inject(type, flags));
        }
        else {
            args.push(inject(arg));
        }
    }
    return args;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var GET_PROPERTY_NAME$1 = {};
var ɵ0$1 = GET_PROPERTY_NAME$1;
var USE_VALUE$1 = /*@__PURE__*/ getClosureSafeProperty({ provide: String, useValue: ɵ0$1 }, GET_PROPERTY_NAME$1);
var EMPTY_ARRAY = [];
function convertInjectableProviderToFactory(type, provider) {
    if (!provider) {
        var reflectionCapabilities = new ReflectionCapabilities();
        var deps_1 = reflectionCapabilities.parameters(type);
        // TODO - convert to flags.
        return function () { return new (type.bind.apply(type, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], injectArgs(deps_1))))(); };
    }
    if (USE_VALUE$1 in provider) {
        var valueProvider_1 = provider;
        return function () { return valueProvider_1.useValue; };
    }
    else if (provider.useExisting) {
        var existingProvider_1 = provider;
        return function () { return inject(existingProvider_1.useExisting); };
    }
    else if (provider.useFactory) {
        var factoryProvider_1 = provider;
        return function () { return factoryProvider_1.useFactory.apply(factoryProvider_1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(injectArgs(factoryProvider_1.deps || EMPTY_ARRAY))); };
    }
    else if (provider.useClass) {
        var classProvider_1 = provider;
        var deps_2 = provider.deps;
        if (!deps_2) {
            var reflectionCapabilities = new ReflectionCapabilities();
            deps_2 = reflectionCapabilities.parameters(type);
        }
        return function () {
            var _a;
            return new ((_a = classProvider_1.useClass).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], injectArgs(deps_2))))();
        };
    }
    else {
        var deps_3 = provider.deps;
        if (!deps_3) {
            var reflectionCapabilities = new ReflectionCapabilities();
            deps_3 = reflectionCapabilities.parameters(type);
        }
        return function () { return new (type.bind.apply(type, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], injectArgs(deps_3))))(); };
    }
}
/**
 * Supports @Injectable() in JIT mode for Render2.
 */
function preR3InjectableCompile(injectableType, options) {
    if (options && options.providedIn !== undefined && injectableType.ngInjectableDef === undefined) {
        injectableType.ngInjectableDef = defineInjectable({
            providedIn: options.providedIn,
            factory: convertInjectableProviderToFactory(injectableType, options),
        });
    }
}
/**
* Injectable decorator and metadata.
*
* @Annotation
*/
var Injectable = /*@__PURE__*/ makeDecorator('Injectable', undefined, undefined, undefined, function (type, meta) {
    return (preR3InjectableCompile)(type, meta);
});
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Defines a schema that allows an NgModule to contain the following:
 * - Non-Angular elements named with dash case (`-`).
 * - Element properties named with dash case (`-`).
 * Dash case is the naming convention for custom elements.
 *
 *
 */
var CUSTOM_ELEMENTS_SCHEMA = {
    name: 'custom-elements'
};
/**
 * Defines a schema that allows any property on any element.
 *
 * @experimental
 */
var NO_ERRORS_SCHEMA = {
    name: 'no-errors-schema'
};
function preR3NgModuleCompile(moduleType, metadata) {
    var imports = (metadata && metadata.imports) || [];
    if (metadata && metadata.exports) {
        imports = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(imports, [metadata.exports]);
    }
    moduleType.ngInjectorDef = defineInjector({
        factory: convertInjectableProviderToFactory(moduleType, { useClass: moduleType }),
        providers: metadata && metadata.providers,
        imports: imports,
    });
}
/**
 * @Annotation
 */
var NgModule = /*@__PURE__*/ makeDecorator('NgModule', function (ngModule) { return ngModule; }, undefined, undefined, 
/**
 * Decorator that marks the following class as an NgModule, and supplies
 * configuration metadata for it.
 *
 * * The `declarations` and `entryComponents` options configure the compiler
 * with information about what belongs to the NgModule.
 * * The `providers` options configures the NgModule's injector to provide
 * dependencies the NgModule members.
 * * The `imports` and `exports` options bring in members from other modules, and make
 * this module's members available to others.
 */
function (type, meta) { return (preR3NgModuleCompile)(type, meta); });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Defines template and style encapsulation options available for Component's {@link Component}.
 *
 * See {@link Component#encapsulation encapsulation}.
 *
 * @usageNotes
 * ### Example
 * {@example core/ts/metadata/encapsulation.ts region='longform'}
 */
var ViewEncapsulation = /*@__PURE__*/ (function (ViewEncapsulation) {
    /**
     * Emulate `Native` scoping of styles by adding an attribute containing surrogate id to the Host
     * Element and pre-processing the style rules provided via {@link Component#styles styles} or
     * {@link Component#styleUrls styleUrls}, and adding the new Host Element attribute to all
     * selectors.
     *
     * This is the default option.
     */
    ViewEncapsulation[ViewEncapsulation["Emulated"] = 0] = "Emulated";
    /**
     * @deprecated v6.1.0 - use {ViewEncapsulation.ShadowDom} instead.
     * Use the native encapsulation mechanism of the renderer.
     *
     * For the DOM this means using the deprecated [Shadow DOM
     * v0](https://w3c.github.io/webcomponents/spec/shadow/) and
     * creating a ShadowRoot for Component's Host Element.
     */
    ViewEncapsulation[ViewEncapsulation["Native"] = 1] = "Native";
    /**
     * Don't provide any template or style encapsulation.
     */
    ViewEncapsulation[ViewEncapsulation["None"] = 2] = "None";
    /**
     * Use Shadow DOM to encapsulate styles.
     *
     * For the DOM this means using modern [Shadow
     * DOM](https://w3c.github.io/webcomponents/spec/shadow/) and
     * creating a ShadowRoot for Component's Host Element.
     */
    ViewEncapsulation[ViewEncapsulation["ShadowDom"] = 3] = "ShadowDom";
    return ViewEncapsulation;
})({});
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description Represents the version of Angular
 *
 *
 */
var Version = /*@__PURE__*/ (function () {
    function Version(full) {
        this.full = full;
        this.major = full.split('.')[0];
        this.minor = full.split('.')[1];
        this.patch = full.split('.').slice(2).join('.');
    }
    return Version;
}());
var VERSION = /*@__PURE__*/ new Version('6.1.10');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ERROR_DEBUG_CONTEXT = 'ngDebugContext';
var ERROR_ORIGINAL_ERROR = 'ngOriginalError';
var ERROR_LOGGER = 'ngErrorLogger';
function getDebugContext(error) {
    return error[ERROR_DEBUG_CONTEXT];
}
function getOriginalError(error) {
    return error[ERROR_ORIGINAL_ERROR];
}
function getErrorLogger(error) {
    return error[ERROR_LOGGER] || defaultErrorLogger;
}
function defaultErrorLogger(console) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    console.error.apply(console, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(values));
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Provides a hook for centralized exception handling.
 *
 * The default implementation of `ErrorHandler` prints error messages to the `console`. To
 * intercept error handling, write a custom exception handler that replaces this default as
 * appropriate for your app.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * class MyErrorHandler implements ErrorHandler {
 *   handleError(error) {
 *     // do something with the exception
 *   }
 * }
 *
 * @NgModule({
 *   providers: [{provide: ErrorHandler, useClass: MyErrorHandler}]
 * })
 * class MyModule {}
 * ```
 */
var ErrorHandler = /*@__PURE__*/ (function () {
    function ErrorHandler() {
        /**
         * @internal
         */
        this._console = console;
    }
    ErrorHandler.prototype.handleError = function (error) {
        var originalError = this._findOriginalError(error);
        var context = this._findContext(error);
        // Note: Browser consoles show the place from where console.error was called.
        // We can use this to give users additional information about the error.
        var errorLogger = getErrorLogger(error);
        errorLogger(this._console, "ERROR", error);
        if (originalError) {
            errorLogger(this._console, "ORIGINAL ERROR", originalError);
        }
        if (context) {
            errorLogger(this._console, 'ERROR CONTEXT', context);
        }
    };
    /** @internal */
    ErrorHandler.prototype._findContext = function (error) {
        if (error) {
            return getDebugContext(error) ? getDebugContext(error) :
                this._findContext(getOriginalError(error));
        }
        return null;
    };
    /** @internal */
    ErrorHandler.prototype._findOriginalError = function (error) {
        var e = getOriginalError(error);
        while (e && getOriginalError(e)) {
            e = getOriginalError(e);
        }
        return e;
    };
    return ErrorHandler;
}());
function wrappedError(message, originalError) {
    var msg = message + " caused by: " + (originalError instanceof Error ? originalError.message : originalError);
    var error = Error(msg);
    error[ERROR_ORIGINAL_ERROR] = originalError;
    return error;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function findFirstClosedCycle(keys) {
    var res = [];
    for (var i = 0; i < keys.length; ++i) {
        if (res.indexOf(keys[i]) > -1) {
            res.push(keys[i]);
            return res;
        }
        res.push(keys[i]);
    }
    return res;
}
function constructResolvingPath(keys) {
    if (keys.length > 1) {
        var reversed = findFirstClosedCycle(keys.slice().reverse());
        var tokenStrs = reversed.map(function (k) { return stringify(k.token); });
        return ' (' + tokenStrs.join(' -> ') + ')';
    }
    return '';
}
function injectionError(injector, key, constructResolvingMessage, originalError) {
    var keys = [key];
    var errMsg = constructResolvingMessage(keys);
    var error = (originalError ? wrappedError(errMsg, originalError) : Error(errMsg));
    error.addKey = addKey;
    error.keys = keys;
    error.injectors = [injector];
    error.constructResolvingMessage = constructResolvingMessage;
    error[ERROR_ORIGINAL_ERROR] = originalError;
    return error;
}
function addKey(injector, key) {
    this.injectors.push(injector);
    this.keys.push(key);
    // Note: This updated message won't be reflected in the `.stack` property
    this.message = this.constructResolvingMessage(this.keys);
}
/**
 * Thrown when trying to retrieve a dependency by key from {@link Injector}, but the
 * {@link Injector} does not have a {@link Provider} for the given key.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * class A {
 *   constructor(b:B) {}
 * }
 *
 * expect(() => Injector.resolveAndCreate([A])).toThrowError();
 * ```
 */
function noProviderError(injector, key) {
    return injectionError(injector, key, function (keys) {
        var first = stringify(keys[0].token);
        return "No provider for " + first + "!" + constructResolvingPath(keys);
    });
}
/**
 * Thrown when dependencies form a cycle.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * var injector = Injector.resolveAndCreate([
 *   {provide: "one", useFactory: (two) => "two", deps: [[new Inject("two")]]},
 *   {provide: "two", useFactory: (one) => "one", deps: [[new Inject("one")]]}
 * ]);
 *
 * expect(() => injector.get("one")).toThrowError();
 * ```
 *
 * Retrieving `A` or `B` throws a `CyclicDependencyError` as the graph above cannot be constructed.
 */
function cyclicDependencyError(injector, key) {
    return injectionError(injector, key, function (keys) {
        return "Cannot instantiate cyclic dependency!" + constructResolvingPath(keys);
    });
}
/**
 * Thrown when a constructing type returns with an Error.
 *
 * The `InstantiationError` class contains the original error plus the dependency graph which caused
 * this object to be instantiated.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * class A {
 *   constructor() {
 *     throw new Error('message');
 *   }
 * }
 *
 * var injector = Injector.resolveAndCreate([A]);

 * try {
 *   injector.get(A);
 * } catch (e) {
 *   expect(e instanceof InstantiationError).toBe(true);
 *   expect(e.originalException.message).toEqual("message");
 *   expect(e.originalStack).toBeDefined();
 * }
 * ```
 */
function instantiationError(injector, originalException, originalStack, key) {
    return injectionError(injector, key, function (keys) {
        var first = stringify(keys[0].token);
        return originalException.message + ": Error during instantiation of " + first + "!" + constructResolvingPath(keys) + ".";
    }, originalException);
}
/**
 * Thrown when an object other then {@link Provider} (or `Type`) is passed to {@link Injector}
 * creation.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * expect(() => Injector.resolveAndCreate(["not a type"])).toThrowError();
 * ```
 */
function invalidProviderError(provider) {
    return Error("Invalid provider - only instances of Provider and Type are allowed, got: " + provider);
}
/**
 * Thrown when the class has no annotation information.
 *
 * Lack of annotation information prevents the {@link Injector} from determining which dependencies
 * need to be injected into the constructor.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * class A {
 *   constructor(b) {}
 * }
 *
 * expect(() => Injector.resolveAndCreate([A])).toThrowError();
 * ```
 *
 * This error is also thrown when the class not marked with {@link Injectable} has parameter types.
 *
 * ```typescript
 * class B {}
 *
 * class A {
 *   constructor(b:B) {} // no information about the parameter types of A is available at runtime.
 * }
 *
 * expect(() => Injector.resolveAndCreate([A,B])).toThrowError();
 * ```
 *
 */
function noAnnotationError(typeOrFunc, params) {
    var signature = [];
    for (var i = 0, ii = params.length; i < ii; i++) {
        var parameter = params[i];
        if (!parameter || parameter.length == 0) {
            signature.push('?');
        }
        else {
            signature.push(parameter.map(stringify).join(' '));
        }
    }
    return Error('Cannot resolve all parameters for \'' + stringify(typeOrFunc) + '\'(' +
        signature.join(', ') + '). ' +
        'Make sure that all the parameters are decorated with Inject or have valid type annotations and that \'' +
        stringify(typeOrFunc) + '\' is decorated with Injectable.');
}
/**
 * Thrown when getting an object by index.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * class A {}
 *
 * var injector = Injector.resolveAndCreate([A]);
 *
 * expect(() => injector.getAt(100)).toThrowError();
 * ```
 *
 */
function outOfBoundsError(index) {
    return Error("Index " + index + " is out-of-bounds.");
}
// TODO: add a working example after alpha38 is released
/**
 * Thrown when a multi provider and a regular provider are bound to the same token.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * expect(() => Injector.resolveAndCreate([
 *   { provide: "Strings", useValue: "string1", multi: true},
 *   { provide: "Strings", useValue: "string2", multi: false}
 * ])).toThrowError();
 * ```
 */
function mixingMultiProvidersWithRegularProvidersError(provider1, provider2) {
    return Error("Cannot mix multi providers and regular providers, got: " + provider1 + " " + provider2);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A unique object used for retrieving items from the {@link ReflectiveInjector}.
 *
 * Keys have:
 * - a system-wide unique `id`.
 * - a `token`.
 *
 * `Key` is used internally by {@link ReflectiveInjector} because its system-wide unique `id` allows
 * the
 * injector to store created objects in a more efficient way.
 *
 * `Key` should not be created directly. {@link ReflectiveInjector} creates keys automatically when
 * resolving
 * providers.
 * @deprecated No replacement
 */
var ReflectiveKey = /*@__PURE__*/ (function () {
    /**
     * Private
     */
    function ReflectiveKey(token, id) {
        this.token = token;
        this.id = id;
        if (!token) {
            throw new Error('Token must be defined!');
        }
        this.displayName = stringify(this.token);
    }
    /**
     * Retrieves a `Key` for a token.
     */
    ReflectiveKey.get = function (token) {
        return _globalKeyRegistry.get(resolveForwardRef(token));
    };
    Object.defineProperty(ReflectiveKey, "numberOfKeys", {
        /**
         * @returns the number of keys registered in the system.
         */
        get: function () { return _globalKeyRegistry.numberOfKeys; },
        enumerable: true,
        configurable: true
    });
    return ReflectiveKey;
}());
var KeyRegistry = /*@__PURE__*/ (function () {
    function KeyRegistry() {
        this._allKeys = new Map();
    }
    KeyRegistry.prototype.get = function (token) {
        if (token instanceof ReflectiveKey)
            return token;
        if (this._allKeys.has(token)) {
            return this._allKeys.get(token);
        }
        var newKey = new ReflectiveKey(token, ReflectiveKey.numberOfKeys);
        this._allKeys.set(token, newKey);
        return newKey;
    };
    Object.defineProperty(KeyRegistry.prototype, "numberOfKeys", {
        get: function () { return this._allKeys.size; },
        enumerable: true,
        configurable: true
    });
    return KeyRegistry;
}());
var _globalKeyRegistry = /*@__PURE__*/ new KeyRegistry();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Provides access to reflection data about symbols. Used internally by Angular
 * to power dependency injection and compilation.
 */
var Reflector = /*@__PURE__*/ (function () {
    function Reflector(reflectionCapabilities) {
        this.reflectionCapabilities = reflectionCapabilities;
    }
    Reflector.prototype.updateCapabilities = function (caps) { this.reflectionCapabilities = caps; };
    Reflector.prototype.factory = function (type) { return this.reflectionCapabilities.factory(type); };
    Reflector.prototype.parameters = function (typeOrFunc) {
        return this.reflectionCapabilities.parameters(typeOrFunc);
    };
    Reflector.prototype.annotations = function (typeOrFunc) {
        return this.reflectionCapabilities.annotations(typeOrFunc);
    };
    Reflector.prototype.propMetadata = function (typeOrFunc) {
        return this.reflectionCapabilities.propMetadata(typeOrFunc);
    };
    Reflector.prototype.hasLifecycleHook = function (type, lcProperty) {
        return this.reflectionCapabilities.hasLifecycleHook(type, lcProperty);
    };
    Reflector.prototype.getter = function (name) { return this.reflectionCapabilities.getter(name); };
    Reflector.prototype.setter = function (name) { return this.reflectionCapabilities.setter(name); };
    Reflector.prototype.method = function (name) { return this.reflectionCapabilities.method(name); };
    Reflector.prototype.importUri = function (type) { return this.reflectionCapabilities.importUri(type); };
    Reflector.prototype.resourceUri = function (type) { return this.reflectionCapabilities.resourceUri(type); };
    Reflector.prototype.resolveIdentifier = function (name, moduleUrl, members, runtime) {
        return this.reflectionCapabilities.resolveIdentifier(name, moduleUrl, members, runtime);
    };
    Reflector.prototype.resolveEnum = function (identifier, name) {
        return this.reflectionCapabilities.resolveEnum(identifier, name);
    };
    return Reflector;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The {@link Reflector} used internally in Angular to access metadata
 * about symbols.
 */
var reflector = /*@__PURE__*/ new Reflector(/*@__PURE__*/ new ReflectionCapabilities());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * `Dependency` is used by the framework to extend DI.
 * This is internal to Angular and should not be used directly.
 */
var ReflectiveDependency = /*@__PURE__*/ (function () {
    function ReflectiveDependency(key, optional, visibility) {
        this.key = key;
        this.optional = optional;
        this.visibility = visibility;
    }
    ReflectiveDependency.fromKey = function (key) {
        return new ReflectiveDependency(key, false, null);
    };
    return ReflectiveDependency;
}());
var _EMPTY_LIST = [];
var ResolvedReflectiveProvider_ = /*@__PURE__*/ (function () {
    function ResolvedReflectiveProvider_(key, resolvedFactories, multiProvider) {
        this.key = key;
        this.resolvedFactories = resolvedFactories;
        this.multiProvider = multiProvider;
        this.resolvedFactory = this.resolvedFactories[0];
    }
    return ResolvedReflectiveProvider_;
}());
/**
 * An internal resolved representation of a factory function created by resolving `Provider`.
 * @experimental
 */
var ResolvedReflectiveFactory = /*@__PURE__*/ (function () {
    function ResolvedReflectiveFactory(
    /**
     * Factory function which can return an instance of an object represented by a key.
     */
    factory, 
    /**
     * Arguments (dependencies) to the `factory` function.
     */
    dependencies) {
        this.factory = factory;
        this.dependencies = dependencies;
    }
    return ResolvedReflectiveFactory;
}());
/**
 * Resolve a single provider.
 */
function resolveReflectiveFactory(provider) {
    var factoryFn;
    var resolvedDeps;
    if (provider.useClass) {
        var useClass = resolveForwardRef(provider.useClass);
        factoryFn = reflector.factory(useClass);
        resolvedDeps = _dependenciesFor(useClass);
    }
    else if (provider.useExisting) {
        factoryFn = function (aliasInstance) { return aliasInstance; };
        resolvedDeps = [ReflectiveDependency.fromKey(ReflectiveKey.get(provider.useExisting))];
    }
    else if (provider.useFactory) {
        factoryFn = provider.useFactory;
        resolvedDeps = constructDependencies(provider.useFactory, provider.deps);
    }
    else {
        factoryFn = function () { return provider.useValue; };
        resolvedDeps = _EMPTY_LIST;
    }
    return new ResolvedReflectiveFactory(factoryFn, resolvedDeps);
}
/**
 * Converts the `Provider` into `ResolvedProvider`.
 *
 * `Injector` internally only uses `ResolvedProvider`, `Provider` contains convenience provider
 * syntax.
 */
function resolveReflectiveProvider(provider) {
    return new ResolvedReflectiveProvider_(ReflectiveKey.get(provider.provide), [resolveReflectiveFactory(provider)], provider.multi || false);
}
/**
 * Resolve a list of Providers.
 */
function resolveReflectiveProviders(providers) {
    var normalized = _normalizeProviders(providers, []);
    var resolved = normalized.map(resolveReflectiveProvider);
    var resolvedProviderMap = mergeResolvedReflectiveProviders(resolved, new Map());
    return Array.from(resolvedProviderMap.values());
}
/**
 * Merges a list of ResolvedProviders into a list where each key is contained exactly once and
 * multi providers have been merged.
 */
function mergeResolvedReflectiveProviders(providers, normalizedProvidersMap) {
    for (var i = 0; i < providers.length; i++) {
        var provider = providers[i];
        var existing = normalizedProvidersMap.get(provider.key.id);
        if (existing) {
            if (provider.multiProvider !== existing.multiProvider) {
                throw mixingMultiProvidersWithRegularProvidersError(existing, provider);
            }
            if (provider.multiProvider) {
                for (var j = 0; j < provider.resolvedFactories.length; j++) {
                    existing.resolvedFactories.push(provider.resolvedFactories[j]);
                }
            }
            else {
                normalizedProvidersMap.set(provider.key.id, provider);
            }
        }
        else {
            var resolvedProvider = void 0;
            if (provider.multiProvider) {
                resolvedProvider = new ResolvedReflectiveProvider_(provider.key, provider.resolvedFactories.slice(), provider.multiProvider);
            }
            else {
                resolvedProvider = provider;
            }
            normalizedProvidersMap.set(provider.key.id, resolvedProvider);
        }
    }
    return normalizedProvidersMap;
}
function _normalizeProviders(providers, res) {
    providers.forEach(function (b) {
        if (b instanceof Type) {
            res.push({ provide: b, useClass: b });
        }
        else if (b && typeof b == 'object' && b.provide !== undefined) {
            res.push(b);
        }
        else if (b instanceof Array) {
            _normalizeProviders(b, res);
        }
        else {
            throw invalidProviderError(b);
        }
    });
    return res;
}
function constructDependencies(typeOrFunc, dependencies) {
    if (!dependencies) {
        return _dependenciesFor(typeOrFunc);
    }
    else {
        var params_1 = dependencies.map(function (t) { return [t]; });
        return dependencies.map(function (t) { return _extractToken(typeOrFunc, t, params_1); });
    }
}
function _dependenciesFor(typeOrFunc) {
    var params = reflector.parameters(typeOrFunc);
    if (!params)
        return [];
    if (params.some(function (p) { return p == null; })) {
        throw noAnnotationError(typeOrFunc, params);
    }
    return params.map(function (p) { return _extractToken(typeOrFunc, p, params); });
}
function _extractToken(typeOrFunc, metadata, params) {
    var token = null;
    var optional = false;
    if (!Array.isArray(metadata)) {
        if (metadata instanceof Inject) {
            return _createDependency(metadata.token, optional, null);
        }
        else {
            return _createDependency(metadata, optional, null);
        }
    }
    var visibility = null;
    for (var i = 0; i < metadata.length; ++i) {
        var paramMetadata = metadata[i];
        if (paramMetadata instanceof Type) {
            token = paramMetadata;
        }
        else if (paramMetadata instanceof Inject) {
            token = paramMetadata.token;
        }
        else if (paramMetadata instanceof Optional) {
            optional = true;
        }
        else if (paramMetadata instanceof Self || paramMetadata instanceof SkipSelf) {
            visibility = paramMetadata;
        }
        else if (paramMetadata instanceof InjectionToken) {
            token = paramMetadata;
        }
    }
    token = resolveForwardRef(token);
    if (token != null) {
        return _createDependency(token, optional, visibility);
    }
    else {
        throw noAnnotationError(typeOrFunc, params);
    }
}
function _createDependency(token, optional, visibility) {
    return new ReflectiveDependency(ReflectiveKey.get(token), optional, visibility);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Threshold for the dynamic version
var UNDEFINED = /*@__PURE__*/ new Object();
/**
 * A ReflectiveDependency injection container used for instantiating objects and resolving
 * dependencies.
 *
 * An `Injector` is a replacement for a `new` operator, which can automatically resolve the
 * constructor dependencies.
 *
 * In typical use, application code asks for the dependencies in the constructor and they are
 * resolved by the `Injector`.
 *
 * @usageNotes
 * ### Example
 *
 * The following example creates an `Injector` configured to create `Engine` and `Car`.
 *
 * ```typescript
 * @Injectable()
 * class Engine {
 * }
 *
 * @Injectable()
 * class Car {
 *   constructor(public engine:Engine) {}
 * }
 *
 * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
 * var car = injector.get(Car);
 * expect(car instanceof Car).toBe(true);
 * expect(car.engine instanceof Engine).toBe(true);
 * ```
 *
 * Notice, we don't use the `new` operator because we explicitly want to have the `Injector`
 * resolve all of the object's dependencies automatically.
 *
 * @deprecated from v5 - slow and brings in a lot of code, Use `Injector.create` instead.
 */
var ReflectiveInjector = /*@__PURE__*/ (function () {
    function ReflectiveInjector() {
    }
    /**
     * Turns an array of provider definitions into an array of resolved providers.
     *
     * A resolution is a process of flattening multiple nested arrays and converting individual
     * providers into an array of `ResolvedReflectiveProvider`s.
     *
     * @usageNotes
     * ### Example
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var providers = ReflectiveInjector.resolve([Car, [[Engine]]]);
     *
     * expect(providers.length).toEqual(2);
     *
     * expect(providers[0] instanceof ResolvedReflectiveProvider).toBe(true);
     * expect(providers[0].key.displayName).toBe("Car");
     * expect(providers[0].dependencies.length).toEqual(1);
     * expect(providers[0].factory).toBeDefined();
     *
     * expect(providers[1].key.displayName).toBe("Engine");
     * });
     * ```
     *
     */
    ReflectiveInjector.resolve = function (providers) {
        return resolveReflectiveProviders(providers);
    };
    /**
     * Resolves an array of providers and creates an injector from those providers.
     *
     * The passed-in providers can be an array of `Type`, `Provider`,
     * or a recursive array of more providers.
     *
     * @usageNotes
     * ### Example
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
     * expect(injector.get(Car) instanceof Car).toBe(true);
     * ```
     */
    ReflectiveInjector.resolveAndCreate = function (providers, parent) {
        var ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
        return ReflectiveInjector.fromResolvedProviders(ResolvedReflectiveProviders, parent);
    };
    /**
     * Creates an injector from previously resolved providers.
     *
     * This API is the recommended way to construct injectors in performance-sensitive parts.
     *
     * @usageNotes
     * ### Example
     *
     * ```typescript
     * @Injectable()
     * class Engine {
     * }
     *
     * @Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var providers = ReflectiveInjector.resolve([Car, Engine]);
     * var injector = ReflectiveInjector.fromResolvedProviders(providers);
     * expect(injector.get(Car) instanceof Car).toBe(true);
     * ```
     * @experimental
     */
    ReflectiveInjector.fromResolvedProviders = function (providers, parent) {
        return new ReflectiveInjector_(providers, parent);
    };
    return ReflectiveInjector;
}());
var ReflectiveInjector_ = /*@__PURE__*/ (function () {
    /**
     * Private
     */
    function ReflectiveInjector_(_providers, _parent) {
        /** @internal */
        this._constructionCounter = 0;
        this._providers = _providers;
        this.parent = _parent || null;
        var len = _providers.length;
        this.keyIds = new Array(len);
        this.objs = new Array(len);
        for (var i = 0; i < len; i++) {
            this.keyIds[i] = _providers[i].key.id;
            this.objs[i] = UNDEFINED;
        }
    }
    ReflectiveInjector_.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) {
            notFoundValue = THROW_IF_NOT_FOUND;
        }
        return this._getByKey(ReflectiveKey.get(token), null, notFoundValue);
    };
    ReflectiveInjector_.prototype.resolveAndCreateChild = function (providers) {
        var ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
        return this.createChildFromResolved(ResolvedReflectiveProviders);
    };
    ReflectiveInjector_.prototype.createChildFromResolved = function (providers) {
        var inj = new ReflectiveInjector_(providers);
        inj.parent = this;
        return inj;
    };
    ReflectiveInjector_.prototype.resolveAndInstantiate = function (provider) {
        return this.instantiateResolved(ReflectiveInjector.resolve([provider])[0]);
    };
    ReflectiveInjector_.prototype.instantiateResolved = function (provider) {
        return this._instantiateProvider(provider);
    };
    ReflectiveInjector_.prototype.getProviderAtIndex = function (index) {
        if (index < 0 || index >= this._providers.length) {
            throw outOfBoundsError(index);
        }
        return this._providers[index];
    };
    /** @internal */
    ReflectiveInjector_.prototype._new = function (provider) {
        if (this._constructionCounter++ > this._getMaxNumberOfObjects()) {
            throw cyclicDependencyError(this, provider.key);
        }
        return this._instantiateProvider(provider);
    };
    ReflectiveInjector_.prototype._getMaxNumberOfObjects = function () { return this.objs.length; };
    ReflectiveInjector_.prototype._instantiateProvider = function (provider) {
        if (provider.multiProvider) {
            var res = new Array(provider.resolvedFactories.length);
            for (var i = 0; i < provider.resolvedFactories.length; ++i) {
                res[i] = this._instantiate(provider, provider.resolvedFactories[i]);
            }
            return res;
        }
        else {
            return this._instantiate(provider, provider.resolvedFactories[0]);
        }
    };
    ReflectiveInjector_.prototype._instantiate = function (provider, ResolvedReflectiveFactory$$1) {
        var _this = this;
        var factory = ResolvedReflectiveFactory$$1.factory;
        var deps;
        try {
            deps =
                ResolvedReflectiveFactory$$1.dependencies.map(function (dep) { return _this._getByReflectiveDependency(dep); });
        }
        catch (e) {
            if (e.addKey) {
                e.addKey(this, provider.key);
            }
            throw e;
        }
        var obj;
        try {
            obj = factory.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(deps));
        }
        catch (e) {
            throw instantiationError(this, e, e.stack, provider.key);
        }
        return obj;
    };
    ReflectiveInjector_.prototype._getByReflectiveDependency = function (dep) {
        return this._getByKey(dep.key, dep.visibility, dep.optional ? null : THROW_IF_NOT_FOUND);
    };
    ReflectiveInjector_.prototype._getByKey = function (key, visibility, notFoundValue) {
        if (key === ReflectiveInjector_.INJECTOR_KEY) {
            return this;
        }
        if (visibility instanceof Self) {
            return this._getByKeySelf(key, notFoundValue);
        }
        else {
            return this._getByKeyDefault(key, notFoundValue, visibility);
        }
    };
    ReflectiveInjector_.prototype._getObjByKeyId = function (keyId) {
        for (var i = 0; i < this.keyIds.length; i++) {
            if (this.keyIds[i] === keyId) {
                if (this.objs[i] === UNDEFINED) {
                    this.objs[i] = this._new(this._providers[i]);
                }
                return this.objs[i];
            }
        }
        return UNDEFINED;
    };
    /** @internal */
    ReflectiveInjector_.prototype._throwOrNull = function (key, notFoundValue) {
        if (notFoundValue !== THROW_IF_NOT_FOUND) {
            return notFoundValue;
        }
        else {
            throw noProviderError(this, key);
        }
    };
    /** @internal */
    ReflectiveInjector_.prototype._getByKeySelf = function (key, notFoundValue) {
        var obj = this._getObjByKeyId(key.id);
        return (obj !== UNDEFINED) ? obj : this._throwOrNull(key, notFoundValue);
    };
    /** @internal */
    ReflectiveInjector_.prototype._getByKeyDefault = function (key, notFoundValue, visibility) {
        var inj;
        if (visibility instanceof SkipSelf) {
            inj = this.parent;
        }
        else {
            inj = this;
        }
        while (inj instanceof ReflectiveInjector_) {
            var inj_ = inj;
            var obj = inj_._getObjByKeyId(key.id);
            if (obj !== UNDEFINED)
                return obj;
            inj = inj_.parent;
        }
        if (inj !== null) {
            return inj.get(key.token, notFoundValue);
        }
        else {
            return this._throwOrNull(key, notFoundValue);
        }
    };
    Object.defineProperty(ReflectiveInjector_.prototype, "displayName", {
        get: function () {
            var providers = _mapProviders(this, function (b) { return ' "' + b.key.displayName + '" '; })
                .join(', ');
            return "ReflectiveInjector(providers: [" + providers + "])";
        },
        enumerable: true,
        configurable: true
    });
    ReflectiveInjector_.prototype.toString = function () { return this.displayName; };
    ReflectiveInjector_.INJECTOR_KEY = ReflectiveKey.get(Injector);
    return ReflectiveInjector_;
}());
function _mapProviders(injector, fn) {
    var res = new Array(injector._providers.length);
    for (var i = 0; i < injector._providers.length; ++i) {
        res[i] = fn(injector.getProviderAtIndex(i));
    }
    return res;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An internal token whose presence in an injector indicates that the injector should treat itself
 * as a root scoped injector when processing requests for unknown tokens which may indicate
 * they are provided in the root scope.
 */
var APP_ROOT = /*@__PURE__*/ new InjectionToken('The presence of this token marks an injector as being the root injector.');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Marker which indicates that a value has not yet been created from the factory function.
 */
var NOT_YET = {};
/**
 * Marker which indicates that the factory function for a token is in the process of being called.
 *
 * If the injector is asked to inject a token with its value set to CIRCULAR, that indicates
 * injection of a dependency has recursively attempted to inject the original token, and there is
 * a circular dependency among the providers.
 */
var CIRCULAR$1 = {};
var EMPTY_ARRAY$1 = [];
/**
 * A lazily initialized NullInjector.
 */
var NULL_INJECTOR$1 = undefined;
function getNullInjector() {
    if (NULL_INJECTOR$1 === undefined) {
        NULL_INJECTOR$1 = new NullInjector();
    }
    return NULL_INJECTOR$1;
}
/**
 * Create a new `Injector` which is configured using a `defType` of `InjectorType<any>`s.
 *
 * @experimental
 */
function createInjector(defType, parent, additionalProviders) {
    if (parent === void 0) {
        parent = null;
    }
    if (additionalProviders === void 0) {
        additionalProviders = null;
    }
    parent = parent || getNullInjector();
    return new R3Injector(defType, additionalProviders, parent);
}
var R3Injector = /*@__PURE__*/ (function () {
    function R3Injector(def, additionalProviders, parent) {
        var _this = this;
        this.parent = parent;
        /**
         * Map of tokens to records which contain the instances of those tokens.
         */
        this.records = new Map();
        /**
         * The transitive set of `InjectorType`s which define this injector.
         */
        this.injectorDefTypes = new Set();
        /**
         * Set of values instantiated by this injector which contain `ngOnDestroy` lifecycle hooks.
         */
        this.onDestroy = new Set();
        /**
         * Flag indicating that this injector was previously destroyed.
         */
        this.destroyed = false;
        // Start off by creating Records for every provider declared in every InjectorType
        // included transitively in `def`.
        deepForEach([def], function (injectorDef) { return _this.processInjectorType(injectorDef, new Set()); });
        additionalProviders &&
            deepForEach(additionalProviders, function (provider) { return _this.processProvider(provider); });
        // Make sure the INJECTOR token provides this injector.
        this.records.set(INJECTOR, makeRecord(undefined, this));
        // Detect whether this injector has the APP_ROOT_SCOPE token and thus should provide
        // any injectable scoped to APP_ROOT_SCOPE.
        this.isRootInjector = this.records.has(APP_ROOT);
        // Eagerly instantiate the InjectorType classes themselves.
        this.injectorDefTypes.forEach(function (defType) { return _this.get(defType); });
    }
    /**
     * Destroy the injector and release references to every instance or provider associated with it.
     *
     * Also calls the `OnDestroy` lifecycle hooks of every instance that was created for which a
     * hook was found.
     */
    R3Injector.prototype.destroy = function () {
        this.assertNotDestroyed();
        // Set destroyed = true first, in case lifecycle hooks re-enter destroy().
        this.destroyed = true;
        try {
            // Call all the lifecycle hooks.
            this.onDestroy.forEach(function (service) { return service.ngOnDestroy(); });
        }
        finally {
            // Release all references.
            this.records.clear();
            this.onDestroy.clear();
            this.injectorDefTypes.clear();
        }
    };
    R3Injector.prototype.get = function (token, notFoundValue, flags) {
        if (notFoundValue === void 0) {
            notFoundValue = THROW_IF_NOT_FOUND;
        }
        if (flags === void 0) {
            flags = 0 /* Default */;
        }
        this.assertNotDestroyed();
        // Set the injection context.
        var previousInjector = setCurrentInjector(this);
        try {
            // Check for the SkipSelf flag.
            if (!(flags & 4 /* SkipSelf */)) {
                // SkipSelf isn't set, check if the record belongs to this injector.
                var record = this.records.get(token);
                if (record === undefined) {
                    // No record, but maybe the token is scoped to this injector. Look for an ngInjectableDef
                    // with a scope matching this injector.
                    var def = couldBeInjectableType(token) &&
                        token.ngInjectableDef ||
                        undefined;
                    if (def !== undefined && this.injectableDefInScope(def)) {
                        // Found an ngInjectableDef and it's scoped to this injector. Pretend as if it was here
                        // all along.
                        record = injectableDefRecord(token);
                        this.records.set(token, record);
                    }
                }
                // If a record was found, get the instance for it and return it.
                if (record !== undefined) {
                    return this.hydrate(token, record);
                }
            }
            // Select the next injector based on the Self flag - if self is set, the next injector is
            // the NullInjector, otherwise it's the parent.
            var next = !(flags & 2 /* Self */) ? this.parent : getNullInjector();
            return this.parent.get(token, notFoundValue);
        }
        finally {
            // Lastly, clean up the state by restoring the previous injector.
            setCurrentInjector(previousInjector);
        }
    };
    R3Injector.prototype.assertNotDestroyed = function () {
        if (this.destroyed) {
            throw new Error('Injector has already been destroyed.');
        }
    };
    /**
     * Add an `InjectorType` or `InjectorDefTypeWithProviders` and all of its transitive providers
     * to this injector.
     */
    R3Injector.prototype.processInjectorType = function (defOrWrappedDef, parents) {
        var _this = this;
        defOrWrappedDef = resolveForwardRef(defOrWrappedDef);
        // Either the defOrWrappedDef is an InjectorType (with ngInjectorDef) or an
        // InjectorDefTypeWithProviders (aka ModuleWithProviders). Detecting either is a megamorphic
        // read, so care is taken to only do the read once.
        // First attempt to read the ngInjectorDef.
        var def = defOrWrappedDef.ngInjectorDef;
        // If that's not present, then attempt to read ngModule from the InjectorDefTypeWithProviders.
        var ngModule = (def == null) && defOrWrappedDef.ngModule || undefined;
        // Determine the InjectorType. In the case where `defOrWrappedDef` is an `InjectorType`,
        // then this is easy. In the case of an InjectorDefTypeWithProviders, then the definition type
        // is the `ngModule`.
        var defType = (ngModule === undefined) ? defOrWrappedDef : ngModule;
        // If defOrWrappedType was an InjectorDefTypeWithProviders, then .providers may hold some
        // extra providers.
        var providers = (ngModule !== undefined) && defOrWrappedDef.providers ||
            EMPTY_ARRAY$1;
        // Finally, if defOrWrappedType was an `InjectorDefTypeWithProviders`, then the actual
        // `InjectorDef` is on its `ngModule`.
        if (ngModule !== undefined) {
            def = ngModule.ngInjectorDef;
        }
        // If no definition was found, it might be from exports. Remove it.
        if (def == null) {
            return;
        }
        // Check for circular dependencies.
        if (parents.has(defType)) {
            throw new Error("Circular dependency: type " + stringify(defType) + " ends up importing itself.");
        }
        // Track the InjectorType and add a provider for it.
        this.injectorDefTypes.add(defType);
        this.records.set(defType, makeRecord(def.factory));
        // Add providers in the same way that @NgModule resolution did:
        // First, include providers from any imports.
        if (def.imports != null) {
            // Before processing defType's imports, add it to the set of parents. This way, if it ends
            // up deeply importing itself, this can be detected.
            parents.add(defType);
            try {
                deepForEach(def.imports, function (imported) { return _this.processInjectorType(imported, parents); });
            }
            finally {
                // Remove it from the parents set when finished.
                parents.delete(defType);
            }
        }
        // Next, include providers listed on the definition itself.
        if (def.providers != null) {
            deepForEach(def.providers, function (provider) { return _this.processProvider(provider); });
        }
        // Finally, include providers from an InjectorDefTypeWithProviders if there was one.
        deepForEach(providers, function (provider) { return _this.processProvider(provider); });
    };
    /**
     * Process a `SingleProvider` and add it.
     */
    R3Injector.prototype.processProvider = function (provider) {
        // Determine the token from the provider. Either it's its own token, or has a {provide: ...}
        // property.
        provider = resolveForwardRef(provider);
        var token = isTypeProvider(provider) ? provider : resolveForwardRef(provider.provide);
        // Construct a `Record` for the provider.
        var record = providerToRecord(provider);
        if (!isTypeProvider(provider) && provider.multi === true) {
            // If the provider indicates that it's a multi-provider, process it specially.
            // First check whether it's been defined already.
            var multiRecord_1 = this.records.get(token);
            if (multiRecord_1) {
                // It has. Throw a nice error if
                if (multiRecord_1.multi === undefined) {
                    throw new Error("Mixed multi-provider for " + token + ".");
                }
            }
            else {
                multiRecord_1 = makeRecord(undefined, NOT_YET, true);
                multiRecord_1.factory = function () { return injectArgs(multiRecord_1.multi); };
                this.records.set(token, multiRecord_1);
            }
            token = provider;
            multiRecord_1.multi.push(provider);
        }
        else {
            var existing = this.records.get(token);
            if (existing && existing.multi !== undefined) {
                throw new Error("Mixed multi-provider for " + stringify(token));
            }
        }
        this.records.set(token, record);
    };
    R3Injector.prototype.hydrate = function (token, record) {
        if (record.value === CIRCULAR$1) {
            throw new Error("Circular dep for " + stringify(token));
        }
        else if (record.value === NOT_YET) {
            record.value = CIRCULAR$1;
            record.value = record.factory();
        }
        if (typeof record.value === 'object' && record.value && hasOnDestroy(record.value)) {
            this.onDestroy.add(record.value);
        }
        return record.value;
    };
    R3Injector.prototype.injectableDefInScope = function (def) {
        if (!def.providedIn) {
            return false;
        }
        else if (typeof def.providedIn === 'string') {
            return def.providedIn === 'any' || (def.providedIn === 'root' && this.isRootInjector);
        }
        else {
            return this.injectorDefTypes.has(def.providedIn);
        }
    };
    return R3Injector;
}());
function injectableDefRecord(token) {
    var def = token.ngInjectableDef;
    if (def === undefined) {
        if (token instanceof InjectionToken) {
            throw new Error("Token " + stringify(token) + " is missing an ngInjectableDef definition.");
        }
        // TODO(alxhub): there should probably be a strict mode which throws here instead of assuming a
        // no-args constructor.
        return makeRecord(function () { return new token(); });
    }
    return makeRecord(def.factory);
}
function providerToRecord(provider) {
    var token = resolveForwardRef(provider);
    var value = NOT_YET;
    var factory = undefined;
    if (isTypeProvider(provider)) {
        return injectableDefRecord(provider);
    }
    else {
        token = resolveForwardRef(provider.provide);
        if (isValueProvider(provider)) {
            value = provider.useValue;
        }
        else if (isExistingProvider(provider)) {
            factory = function () { return inject(provider.useExisting); };
        }
        else if (isFactoryProvider(provider)) {
            factory = function () { return provider.useFactory.apply(provider, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(injectArgs(provider.deps || []))); };
        }
        else {
            var classRef_1 = provider.useClass || token;
            if (hasDeps(provider)) {
                factory = function () { return new ((classRef_1).bind.apply((classRef_1), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], injectArgs(provider.deps))))(); };
            }
            else {
                return injectableDefRecord(classRef_1);
            }
        }
    }
    return makeRecord(factory, value);
}
function makeRecord(factory, value, multi) {
    if (value === void 0) {
        value = NOT_YET;
    }
    if (multi === void 0) {
        multi = false;
    }
    return {
        factory: factory,
        value: value,
        multi: multi ? [] : undefined,
    };
}
function deepForEach(input, fn) {
    input.forEach(function (value) { return Array.isArray(value) ? deepForEach(value, fn) : fn(value); });
}
function isValueProvider(value) {
    return USE_VALUE in value;
}
function isExistingProvider(value) {
    return !!value.useExisting;
}
function isFactoryProvider(value) {
    return !!value.useFactory;
}
function isTypeProvider(value) {
    return typeof value === 'function';
}
function hasDeps(value) {
    return !!value.deps;
}
function hasOnDestroy(value) {
    return typeof value === 'object' && value != null && value.ngOnDestroy &&
        typeof value.ngOnDestroy === 'function';
}
function couldBeInjectableType(value) {
    return (typeof value === 'function') ||
        (typeof value === 'object' && value instanceof InjectionToken);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Determine if the argument is shaped like a Promise
 */
function isPromise(obj) {
    // allow any Promise/A+ compliant thenable.
    // It's up to the caller to ensure that obj.then conforms to the spec
    return !!obj && typeof obj.then === 'function';
}
/**
 * Determine if the argument is an Observable
 */
function isObservable(obj) {
    // TODO: use Symbol.observable when https://github.com/ReactiveX/rxjs/issues/2415 will be resolved
    return !!obj && typeof obj.subscribe === 'function';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A function that will be executed when an application is initialized.
 */
var APP_INITIALIZER = /*@__PURE__*/ new InjectionToken('Application Initializer');
/**
 * A class that reflects the state of running {@link APP_INITIALIZER}s.
 */
var ApplicationInitStatus = /*@__PURE__*/ (function () {
    function ApplicationInitStatus(appInits) {
        var _this = this;
        this.appInits = appInits;
        this.initialized = false;
        this.done = false;
        this.donePromise = new Promise(function (res, rej) {
            _this.resolve = res;
            _this.reject = rej;
        });
    }
    /** @internal */
    ApplicationInitStatus.prototype.runInitializers = function () {
        var _this = this;
        if (this.initialized) {
            return;
        }
        var asyncInitPromises = [];
        var complete = function () {
            _this.done = true;
            _this.resolve();
        };
        if (this.appInits) {
            for (var i = 0; i < this.appInits.length; i++) {
                var initResult = this.appInits[i]();
                if (isPromise(initResult)) {
                    asyncInitPromises.push(initResult);
                }
            }
        }
        Promise.all(asyncInitPromises).then(function () { complete(); }).catch(function (e) { _this.reject(e); });
        if (asyncInitPromises.length === 0) {
            complete();
        }
        this.initialized = true;
    };
    ApplicationInitStatus = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Inject(APP_INITIALIZER)), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Optional())
    ], ApplicationInitStatus);
    return ApplicationInitStatus;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A DI Token representing a unique string id assigned to the application by Angular and used
 * primarily for prefixing application attributes and CSS styles when
 * {@link ViewEncapsulation#Emulated ViewEncapsulation.Emulated} is being used.
 *
 * If you need to avoid randomly generated value to be used as an application id, you can provide
 * a custom value via a DI provider <!-- TODO: provider --> configuring the root {@link Injector}
 * using this token.
 * @experimental
 */
var APP_ID = /*@__PURE__*/ new InjectionToken('AppId');
function _appIdRandomProviderFactory() {
    return "" + _randomChar() + _randomChar() + _randomChar();
}
/**
 * Providers that will generate a random APP_ID_TOKEN.
 * @experimental
 */
var APP_ID_RANDOM_PROVIDER = {
    provide: APP_ID,
    useFactory: _appIdRandomProviderFactory,
    deps: [],
};
function _randomChar() {
    return String.fromCharCode(97 + Math.floor(Math.random() * 25));
}
/**
 * A function that will be executed when a platform is initialized.
 * @experimental
 */
var PLATFORM_INITIALIZER = /*@__PURE__*/ new InjectionToken('Platform Initializer');
/**
 * A token that indicates an opaque platform id.
 * @experimental
 */
var PLATFORM_ID = /*@__PURE__*/ new InjectionToken('Platform ID');
/**
 * All callbacks provided via this token will be called for every component that is bootstrapped.
 * Signature of the callback:
 *
 * `(componentRef: ComponentRef) => void`.
 *
 * @experimental
 */
var APP_BOOTSTRAP_LISTENER = /*@__PURE__*/ new InjectionToken('appBootstrapListener');
/**
 * A token which indicates the root directory of the application
 * @experimental
 */
var PACKAGE_ROOT_URL = /*@__PURE__*/ new InjectionToken('Application Packages Root URL');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Console = /*@__PURE__*/ (function () {
    function Console() {
    }
    Console.prototype.log = function (message) {
        // tslint:disable-next-line:no-console
        console.log(message);
    };
    // Note: for reporting errors use `DOM.logError()` as it is platform specific
    Console.prototype.warn = function (message) {
        // tslint:disable-next-line:no-console
        console.warn(message);
    };
    return Console;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Combination of NgModuleFactory and ComponentFactorys.
 *
 * @experimental
 */
var ModuleWithComponentFactories = /*@__PURE__*/ (function () {
    function ModuleWithComponentFactories(ngModuleFactory, componentFactories) {
        this.ngModuleFactory = ngModuleFactory;
        this.componentFactories = componentFactories;
    }
    return ModuleWithComponentFactories;
}());
function _throwError() {
    throw new Error("Runtime compiler is not loaded");
}
/**
 * Low-level service for running the angular compiler during runtime
 * to create {@link ComponentFactory}s, which
 * can later be used to create and render a Component instance.
 *
 * Each `@NgModule` provides an own `Compiler` to its injector,
 * that will use the directives/pipes of the ng module for compilation
 * of components.
 *
 */
var Compiler = /*@__PURE__*/ (function () {
    function Compiler() {
    }
    /**
     * Compiles the given NgModule and all of its components. All templates of the components listed
     * in `entryComponents` have to be inlined.
     */
    Compiler.prototype.compileModuleSync = function (moduleType) { throw _throwError(); };
    /**
     * Compiles the given NgModule and all of its components
     */
    Compiler.prototype.compileModuleAsync = function (moduleType) { throw _throwError(); };
    /**
     * Same as {@link #compileModuleSync} but also creates ComponentFactories for all components.
     */
    Compiler.prototype.compileModuleAndAllComponentsSync = function (moduleType) {
        throw _throwError();
    };
    /**
     * Same as {@link #compileModuleAsync} but also creates ComponentFactories for all components.
     */
    Compiler.prototype.compileModuleAndAllComponentsAsync = function (moduleType) {
        throw _throwError();
    };
    /**
     * Clears all caches.
     */
    Compiler.prototype.clearCache = function () { };
    /**
     * Clears the cache for the given component/ngModule.
     */
    Compiler.prototype.clearCacheFor = function (type) { };
    /**
     * Returns the id for a given NgModule, if one is defined and known to the compiler.
     */
    Compiler.prototype.getModuleId = function (moduleType) { return undefined; };
    return Compiler;
}());
/**
 * Token to provide CompilerOptions in the platform injector.
 *
 * @experimental
 */
var COMPILER_OPTIONS = /*@__PURE__*/ new InjectionToken('compilerOptions');
/**
 * A factory for creating a Compiler
 *
 * @experimental
 */
var CompilerFactory = /*@__PURE__*/ (function () {
    function CompilerFactory() {
    }
    return CompilerFactory;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents a component created by a `ComponentFactory`.
 * Provides access to the component instance and related objects,
 * and provides the means of destroying the instance.
 *
 */
var ComponentRef = /*@__PURE__*/ (function () {
    function ComponentRef() {
    }
    return ComponentRef;
}());
var ComponentFactory = /*@__PURE__*/ (function () {
    function ComponentFactory() {
    }
    return ComponentFactory;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function noComponentFactoryError(component) {
    var error = Error("No component factory found for " + stringify(component) + ". Did you add it to @NgModule.entryComponents?");
    error[ERROR_COMPONENT] = component;
    return error;
}
var ERROR_COMPONENT = 'ngComponent';
var _NullComponentFactoryResolver = /*@__PURE__*/ (function () {
    function _NullComponentFactoryResolver() {
    }
    _NullComponentFactoryResolver.prototype.resolveComponentFactory = function (component) {
        throw noComponentFactoryError(component);
    };
    return _NullComponentFactoryResolver;
}());
var ComponentFactoryResolver = /*@__PURE__*/ (function () {
    function ComponentFactoryResolver() {
    }
    ComponentFactoryResolver.NULL = new _NullComponentFactoryResolver();
    return ComponentFactoryResolver;
}());
var CodegenComponentFactoryResolver = /*@__PURE__*/ (function () {
    function CodegenComponentFactoryResolver(factories, _parent, _ngModule) {
        this._parent = _parent;
        this._ngModule = _ngModule;
        this._factories = new Map();
        for (var i = 0; i < factories.length; i++) {
            var factory = factories[i];
            this._factories.set(factory.componentType, factory);
        }
    }
    CodegenComponentFactoryResolver.prototype.resolveComponentFactory = function (component) {
        var factory = this._factories.get(component);
        if (!factory && this._parent) {
            factory = this._parent.resolveComponentFactory(component);
        }
        if (!factory) {
            throw noComponentFactoryError(component);
        }
        return new ComponentFactoryBoundToModule(factory, this._ngModule);
    };
    return CodegenComponentFactoryResolver;
}());
var ComponentFactoryBoundToModule = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ComponentFactoryBoundToModule, _super);
    function ComponentFactoryBoundToModule(factory, ngModule) {
        var _this = _super.call(this) || this;
        _this.factory = factory;
        _this.ngModule = ngModule;
        _this.selector = factory.selector;
        _this.componentType = factory.componentType;
        _this.ngContentSelectors = factory.ngContentSelectors;
        _this.inputs = factory.inputs;
        _this.outputs = factory.outputs;
        return _this;
    }
    ComponentFactoryBoundToModule.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
        return this.factory.create(injector, projectableNodes, rootSelectorOrNode, ngModule || this.ngModule);
    };
    return ComponentFactoryBoundToModule;
}(ComponentFactory));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents an instance of an NgModule created via a {@link NgModuleFactory}.
 *
 * `NgModuleRef` provides access to the NgModule Instance as well other objects related to this
 * NgModule Instance.
 *
 *
 */
var NgModuleRef = /*@__PURE__*/ (function () {
    function NgModuleRef() {
    }
    return NgModuleRef;
}());
/**
 * @experimental
 */
var NgModuleFactory = /*@__PURE__*/ (function () {
    function NgModuleFactory() {
    }
    return NgModuleFactory;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var trace;
var events;
function detectWTF() {
    var wtf = _global /** TODO #9100 */['wtf'];
    if (wtf) {
        trace = wtf['trace'];
        if (trace) {
            events = trace['events'];
            return true;
        }
    }
    return false;
}
function createScope(signature, flags) {
    if (flags === void 0) {
        flags = null;
    }
    return events.createScope(signature, flags);
}
function leave(scope, returnValue) {
    trace.leaveScope(scope, returnValue);
    return returnValue;
}
function startTimeRange(rangeType, action) {
    return trace.beginTimeRange(rangeType, action);
}
function endTimeRange(range) {
    trace.endTimeRange(range);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * True if WTF is enabled.
 */
var wtfEnabled = /*@__PURE__*/ detectWTF();
function noopScope(arg0, arg1) {
    return null;
}
/**
 * Create trace scope.
 *
 * Scopes must be strictly nested and are analogous to stack frames, but
 * do not have to follow the stack frames. Instead it is recommended that they follow logical
 * nesting. You may want to use
 * [Event
 * Signatures](http://google.github.io/tracing-framework/instrumenting-code.html#custom-events)
 * as they are defined in WTF.
 *
 * Used to mark scope entry. The return value is used to leave the scope.
 *
 *     var myScope = wtfCreateScope('MyClass#myMethod(ascii someVal)');
 *
 *     someMethod() {
 *        var s = myScope('Foo'); // 'Foo' gets stored in tracing UI
 *        // DO SOME WORK HERE
 *        return wtfLeave(s, 123); // Return value 123
 *     }
 *
 * Note, adding try-finally block around the work to ensure that `wtfLeave` gets called can
 * negatively impact the performance of your application. For this reason we recommend that
 * you don't add them to ensure that `wtfLeave` gets called. In production `wtfLeave` is a noop and
 * so try-finally block has no value. When debugging perf issues, skipping `wtfLeave`, do to
 * exception, will produce incorrect trace, but presence of exception signifies logic error which
 * needs to be fixed before the app should be profiled. Add try-finally only when you expect that
 * an exception is expected during normal execution while profiling.
 *
 * @experimental
 */
var wtfCreateScope = wtfEnabled ? createScope : function (signature, flags) { return noopScope; };
/**
 * Used to mark end of Scope.
 *
 * - `scope` to end.
 * - `returnValue` (optional) to be passed to the WTF.
 *
 * Returns the `returnValue for easy chaining.
 * @experimental
 */
var wtfLeave = wtfEnabled ? leave : function (s, r) { return r; };
/**
 * Used to mark Async start. Async are similar to scope but they don't have to be strictly nested.
 * The return value is used in the call to [endAsync]. Async ranges only work if WTF has been
 * enabled.
 *
 *     someMethod() {
 *        var s = wtfStartTimeRange('HTTP:GET', 'some.url');
 *        var future = new Future.delay(5).then((_) {
 *          wtfEndTimeRange(s);
 *        });
 *     }
 * @experimental
 */
var wtfStartTimeRange = wtfEnabled ? startTimeRange : function (rangeType, action) { return null; };
/**
 * Ends a async time range operation.
 * [range] is the return value from [wtfStartTimeRange] Async ranges only work if WTF has been
 * enabled.
 * @experimental
 */
var wtfEndTimeRange = wtfEnabled ? endTimeRange : function (r) { return null; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Use in directives and components to emit custom events synchronously
 * or asynchronously, and register handlers for those events by subscribing
 * to an instance.
 *
 * @usageNotes
 *
 * In the following example, a component defines two output properties
 * that create event emitters. When the title is clicked, the emitter
 * emits an open or close event to toggle the current visibility state.
 *
 * ```
 * @Component({
 *   selector: 'zippy',
 *   template: `
 *   <div class="zippy">
 *     <div (click)="toggle()">Toggle</div>
 *     <div [hidden]="!visible">
 *       <ng-content></ng-content>
 *     </div>
 *  </div>`})
 * export class Zippy {
 *   visible: boolean = true;
 *   @Output() open: EventEmitter<any> = new EventEmitter();
 *   @Output() close: EventEmitter<any> = new EventEmitter();
 *
 *   toggle() {
 *     this.visible = !this.visible;
 *     if (this.visible) {
 *       this.open.emit(null);
 *     } else {
 *       this.close.emit(null);
 *     }
 *   }
 * }
 * ```
 *
 * Access the event object with the `$event` argument passed to the output event
 * handler:
 *
 * ```
 * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
 * ```
 *
 * ### Notes
 *
 * Uses Rx.Observable but provides an adapter to make it work as specified here:
 * https://github.com/jhusain/observable-spec
 *
 * Once a reference implementation of the spec is available, switch to it.
 *
 */
var EventEmitter = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(EventEmitter, _super);
    /**
     * Creates an instance of this class that can
     * deliver events synchronously or asynchronously.
     *
     * @param isAsync When true, deliver events asynchronously.
     *
     */
    function EventEmitter(isAsync) {
        if (isAsync === void 0) {
            isAsync = false;
        }
        var _this = _super.call(this) || this;
        _this.__isAsync = isAsync;
        return _this;
    }
    /**
     * Emits an event containing a given value.
     * @param value The value to emit.
     */
    EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
    /**
     * Registers handlers for events emitted by this instance.
     * @param generatorOrNext When supplied, a custom handler for emitted events.
     * @param error When supplied, a custom handler for an error notification
     * from this emitter.
     * @param complete When supplied, a custom handler for a completion
     * notification from this emitter.
     */
    EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
        var schedulerFn;
        var errorFn = function (err) { return null; };
        var completeFn = function () { return null; };
        if (generatorOrNext && typeof generatorOrNext === 'object') {
            schedulerFn = this.__isAsync ? function (value) {
                setTimeout(function () { return generatorOrNext.next(value); });
            } : function (value) { generatorOrNext.next(value); };
            if (generatorOrNext.error) {
                errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
                    function (err) { generatorOrNext.error(err); };
            }
            if (generatorOrNext.complete) {
                completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
                    function () { generatorOrNext.complete(); };
            }
        }
        else {
            schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
                function (value) { generatorOrNext(value); };
            if (error) {
                errorFn =
                    this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
            }
            if (complete) {
                completeFn =
                    this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
            }
        }
        var sink = _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
        if (generatorOrNext instanceof __WEBPACK_IMPORTED_MODULE_1_rxjs__["f" /* Subscription */]) {
            generatorOrNext.add(sink);
        }
        return sink;
    };
    return EventEmitter;
}(__WEBPACK_IMPORTED_MODULE_1_rxjs__["e" /* Subject */]));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An injectable service for executing work inside or outside of the Angular zone.
 *
 * The most common use of this service is to optimize performance when starting a work consisting of
 * one or more asynchronous tasks that don't require UI updates or error handling to be handled by
 * Angular. Such tasks can be kicked off via {@link #runOutsideAngular} and if needed, these tasks
 * can reenter the Angular zone via {@link #run}.
 *
 * <!-- TODO: add/fix links to:
 *   - docs explaining zones and the use of zones in Angular and change-detection
 *   - link to runOutsideAngular/run (throughout this file!)
 *   -->
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * import {Component, NgZone} from '@angular/core';
 * import {NgIf} from '@angular/common';
 *
 * @Component({
 *   selector: 'ng-zone-demo',
 *   template: `
 *     <h2>Demo: NgZone</h2>
 *
 *     <p>Progress: {{progress}}%</p>
 *     <p *ngIf="progress >= 100">Done processing {{label}} of Angular zone!</p>
 *
 *     <button (click)="processWithinAngularZone()">Process within Angular zone</button>
 *     <button (click)="processOutsideOfAngularZone()">Process outside of Angular zone</button>
 *   `,
 * })
 * export class NgZoneDemo {
 *   progress: number = 0;
 *   label: string;
 *
 *   constructor(private _ngZone: NgZone) {}
 *
 *   // Loop inside the Angular zone
 *   // so the UI DOES refresh after each setTimeout cycle
 *   processWithinAngularZone() {
 *     this.label = 'inside';
 *     this.progress = 0;
 *     this._increaseProgress(() => console.log('Inside Done!'));
 *   }
 *
 *   // Loop outside of the Angular zone
 *   // so the UI DOES NOT refresh after each setTimeout cycle
 *   processOutsideOfAngularZone() {
 *     this.label = 'outside';
 *     this.progress = 0;
 *     this._ngZone.runOutsideAngular(() => {
 *       this._increaseProgress(() => {
 *         // reenter the Angular zone and display done
 *         this._ngZone.run(() => { console.log('Outside Done!'); });
 *       });
 *     });
 *   }
 *
 *   _increaseProgress(doneCallback: () => void) {
 *     this.progress += 1;
 *     console.log(`Current progress: ${this.progress}%`);
 *
 *     if (this.progress < 100) {
 *       window.setTimeout(() => this._increaseProgress(doneCallback), 10);
 *     } else {
 *       doneCallback();
 *     }
 *   }
 * }
 * ```
 *
 * @experimental
 */
var NgZone = /*@__PURE__*/ (function () {
    function NgZone(_a) {
        var _b = _a.enableLongStackTrace, enableLongStackTrace = _b === void 0 ? false : _b;
        this.hasPendingMicrotasks = false;
        this.hasPendingMacrotasks = false;
        /**
         * Whether there are no outstanding microtasks or macrotasks.
         */
        this.isStable = true;
        /**
         * Notifies when code enters Angular Zone. This gets fired first on VM Turn.
         */
        this.onUnstable = new EventEmitter(false);
        /**
         * Notifies when there is no more microtasks enqueued in the current VM Turn.
         * This is a hint for Angular to do change detection, which may enqueue more microtasks.
         * For this reason this event can fire multiple times per VM Turn.
         */
        this.onMicrotaskEmpty = new EventEmitter(false);
        /**
         * Notifies when the last `onMicrotaskEmpty` has run and there are no more microtasks, which
         * implies we are about to relinquish VM turn.
         * This event gets called just once.
         */
        this.onStable = new EventEmitter(false);
        /**
         * Notifies that an error has been delivered.
         */
        this.onError = new EventEmitter(false);
        if (typeof Zone == 'undefined') {
            throw new Error("In this configuration Angular requires Zone.js");
        }
        Zone.assertZonePatched();
        var self = this;
        self._nesting = 0;
        self._outer = self._inner = Zone.current;
        if (Zone['wtfZoneSpec']) {
            self._inner = self._inner.fork(Zone['wtfZoneSpec']);
        }
        if (Zone['TaskTrackingZoneSpec']) {
            self._inner = self._inner.fork(new Zone['TaskTrackingZoneSpec']);
        }
        if (enableLongStackTrace && Zone['longStackTraceZoneSpec']) {
            self._inner = self._inner.fork(Zone['longStackTraceZoneSpec']);
        }
        forkInnerZoneWithAngularBehavior(self);
    }
    NgZone.isInAngularZone = function () { return Zone.current.get('isAngularZone') === true; };
    NgZone.assertInAngularZone = function () {
        if (!NgZone.isInAngularZone()) {
            throw new Error('Expected to be in Angular Zone, but it is not!');
        }
    };
    NgZone.assertNotInAngularZone = function () {
        if (NgZone.isInAngularZone()) {
            throw new Error('Expected to not be in Angular Zone, but it is!');
        }
    };
    /**
     * Executes the `fn` function synchronously within the Angular zone and returns value returned by
     * the function.
     *
     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
     * outside of the Angular zone (typically started via {@link #runOutsideAngular}).
     *
     * Any future tasks or microtasks scheduled from within this function will continue executing from
     * within the Angular zone.
     *
     * If a synchronous error happens it will be rethrown and not reported via `onError`.
     */
    NgZone.prototype.run = function (fn, applyThis, applyArgs) {
        return this._inner.run(fn, applyThis, applyArgs);
    };
    /**
     * Executes the `fn` function synchronously within the Angular zone as a task and returns value
     * returned by the function.
     *
     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
     * outside of the Angular zone (typically started via {@link #runOutsideAngular}).
     *
     * Any future tasks or microtasks scheduled from within this function will continue executing from
     * within the Angular zone.
     *
     * If a synchronous error happens it will be rethrown and not reported via `onError`.
     */
    NgZone.prototype.runTask = function (fn, applyThis, applyArgs, name) {
        var zone = this._inner;
        var task = zone.scheduleEventTask('NgZoneEvent: ' + name, fn, EMPTY_PAYLOAD, noop, noop);
        try {
            return zone.runTask(task, applyThis, applyArgs);
        }
        finally {
            zone.cancelTask(task);
        }
    };
    /**
     * Same as `run`, except that synchronous errors are caught and forwarded via `onError` and not
     * rethrown.
     */
    NgZone.prototype.runGuarded = function (fn, applyThis, applyArgs) {
        return this._inner.runGuarded(fn, applyThis, applyArgs);
    };
    /**
     * Executes the `fn` function synchronously in Angular's parent zone and returns value returned by
     * the function.
     *
     * Running functions via {@link #runOutsideAngular} allows you to escape Angular's zone and do
     * work that
     * doesn't trigger Angular change-detection or is subject to Angular's error handling.
     *
     * Any future tasks or microtasks scheduled from within this function will continue executing from
     * outside of the Angular zone.
     *
     * Use {@link #run} to reenter the Angular zone and do work that updates the application model.
     */
    NgZone.prototype.runOutsideAngular = function (fn) {
        return this._outer.run(fn);
    };
    return NgZone;
}());
function noop() { }
var EMPTY_PAYLOAD = {};
function checkStable(zone) {
    if (zone._nesting == 0 && !zone.hasPendingMicrotasks && !zone.isStable) {
        try {
            zone._nesting++;
            zone.onMicrotaskEmpty.emit(null);
        }
        finally {
            zone._nesting--;
            if (!zone.hasPendingMicrotasks) {
                try {
                    zone.runOutsideAngular(function () { return zone.onStable.emit(null); });
                }
                finally {
                    zone.isStable = true;
                }
            }
        }
    }
}
function forkInnerZoneWithAngularBehavior(zone) {
    zone._inner = zone._inner.fork({
        name: 'angular',
        properties: { 'isAngularZone': true },
        onInvokeTask: function (delegate, current, target, task, applyThis, applyArgs) {
            try {
                onEnter(zone);
                return delegate.invokeTask(target, task, applyThis, applyArgs);
            }
            finally {
                onLeave(zone);
            }
        },
        onInvoke: function (delegate, current, target, callback, applyThis, applyArgs, source) {
            try {
                onEnter(zone);
                return delegate.invoke(target, callback, applyThis, applyArgs, source);
            }
            finally {
                onLeave(zone);
            }
        },
        onHasTask: function (delegate, current, target, hasTaskState) {
            delegate.hasTask(target, hasTaskState);
            if (current === target) {
                // We are only interested in hasTask events which originate from our zone
                // (A child hasTask event is not interesting to us)
                if (hasTaskState.change == 'microTask') {
                    zone.hasPendingMicrotasks = hasTaskState.microTask;
                    checkStable(zone);
                }
                else if (hasTaskState.change == 'macroTask') {
                    zone.hasPendingMacrotasks = hasTaskState.macroTask;
                }
            }
        },
        onHandleError: function (delegate, current, target, error) {
            delegate.handleError(target, error);
            zone.runOutsideAngular(function () { return zone.onError.emit(error); });
            return false;
        }
    });
}
function onEnter(zone) {
    zone._nesting++;
    if (zone.isStable) {
        zone.isStable = false;
        zone.onUnstable.emit(null);
    }
}
function onLeave(zone) {
    zone._nesting--;
    checkStable(zone);
}
/**
 * Provides a noop implementation of `NgZone` which does nothing. This zone requires explicit calls
 * to framework to perform rendering.
 */
var NoopNgZone = /*@__PURE__*/ (function () {
    function NoopNgZone() {
        this.hasPendingMicrotasks = false;
        this.hasPendingMacrotasks = false;
        this.isStable = true;
        this.onUnstable = new EventEmitter();
        this.onMicrotaskEmpty = new EventEmitter();
        this.onStable = new EventEmitter();
        this.onError = new EventEmitter();
    }
    NoopNgZone.prototype.run = function (fn) { return fn(); };
    NoopNgZone.prototype.runGuarded = function (fn) { return fn(); };
    NoopNgZone.prototype.runOutsideAngular = function (fn) { return fn(); };
    NoopNgZone.prototype.runTask = function (fn) { return fn(); };
    return NoopNgZone;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The Testability service provides testing hooks that can be accessed from
 * the browser and by services such as Protractor. Each bootstrapped Angular
 * application on the page will have an instance of Testability.
 * @experimental
 */
var Testability = /*@__PURE__*/ (function () {
    function Testability(_ngZone) {
        var _this = this;
        this._ngZone = _ngZone;
        this._pendingCount = 0;
        this._isZoneStable = true;
        /**
         * Whether any work was done since the last 'whenStable' callback. This is
         * useful to detect if this could have potentially destabilized another
         * component while it is stabilizing.
         * @internal
         */
        this._didWork = false;
        this._callbacks = [];
        this._watchAngularEvents();
        _ngZone.run(function () { _this.taskTrackingZone = Zone.current.get('TaskTrackingZone'); });
    }
    Testability.prototype._watchAngularEvents = function () {
        var _this = this;
        this._ngZone.onUnstable.subscribe({
            next: function () {
                _this._didWork = true;
                _this._isZoneStable = false;
            }
        });
        this._ngZone.runOutsideAngular(function () {
            _this._ngZone.onStable.subscribe({
                next: function () {
                    NgZone.assertNotInAngularZone();
                    scheduleMicroTask(function () {
                        _this._isZoneStable = true;
                        _this._runCallbacksIfReady();
                    });
                }
            });
        });
    };
    /**
     * Increases the number of pending request
     * @deprecated pending requests are now tracked with zones.
     */
    Testability.prototype.increasePendingRequestCount = function () {
        this._pendingCount += 1;
        this._didWork = true;
        return this._pendingCount;
    };
    /**
     * Decreases the number of pending request
     * @deprecated pending requests are now tracked with zones
     */
    Testability.prototype.decreasePendingRequestCount = function () {
        this._pendingCount -= 1;
        if (this._pendingCount < 0) {
            throw new Error('pending async requests below zero');
        }
        this._runCallbacksIfReady();
        return this._pendingCount;
    };
    /**
     * Whether an associated application is stable
     */
    Testability.prototype.isStable = function () {
        return this._isZoneStable && this._pendingCount === 0 && !this._ngZone.hasPendingMacrotasks;
    };
    Testability.prototype._runCallbacksIfReady = function () {
        var _this = this;
        if (this.isStable()) {
            // Schedules the call backs in a new frame so that it is always async.
            scheduleMicroTask(function () {
                while (_this._callbacks.length !== 0) {
                    var cb = _this._callbacks.pop();
                    clearTimeout(cb.timeoutId);
                    cb.doneCb(_this._didWork);
                }
                _this._didWork = false;
            });
        }
        else {
            // Still not stable, send updates.
            var pending_1 = this.getPendingTasks();
            this._callbacks = this._callbacks.filter(function (cb) {
                if (cb.updateCb && cb.updateCb(pending_1)) {
                    clearTimeout(cb.timeoutId);
                    return false;
                }
                return true;
            });
            this._didWork = true;
        }
    };
    Testability.prototype.getPendingTasks = function () {
        if (!this.taskTrackingZone) {
            return [];
        }
        return this.taskTrackingZone.macroTasks.map(function (t) {
            return {
                source: t.source,
                isPeriodic: t.data.isPeriodic,
                delay: t.data.delay,
                // From TaskTrackingZone:
                // https://github.com/angular/zone.js/blob/master/lib/zone-spec/task-tracking.ts#L40
                creationLocation: t.creationLocation,
                // Added by Zones for XHRs
                // https://github.com/angular/zone.js/blob/master/lib/browser/browser.ts#L133
                xhr: t.data.target
            };
        });
    };
    Testability.prototype.addCallback = function (cb, timeout, updateCb) {
        var _this = this;
        var timeoutId = -1;
        if (timeout && timeout > 0) {
            timeoutId = setTimeout(function () {
                _this._callbacks = _this._callbacks.filter(function (cb) { return cb.timeoutId !== timeoutId; });
                cb(_this._didWork, _this.getPendingTasks());
            }, timeout);
        }
        this._callbacks.push({ doneCb: cb, timeoutId: timeoutId, updateCb: updateCb });
    };
    /**
     * Wait for the application to be stable with a timeout. If the timeout is reached before that
     * happens, the callback receives a list of the macro tasks that were pending, otherwise null.
     *
     * @param doneCb The callback to invoke when Angular is stable or the timeout expires
     *    whichever comes first.
     * @param timeout Optional. The maximum time to wait for Angular to become stable. If not
     *    specified, whenStable() will wait forever.
     * @param updateCb Optional. If specified, this callback will be invoked whenever the set of
     *    pending macrotasks changes. If this callback returns true doneCb will not be invoked
     *    and no further updates will be issued.
     */
    Testability.prototype.whenStable = function (doneCb, timeout, updateCb) {
        if (updateCb && !this.taskTrackingZone) {
            throw new Error('Task tracking zone is required when passing an update callback to ' +
                'whenStable(). Is "zone.js/dist/task-tracking.js" loaded?');
        }
        // These arguments are 'Function' above to keep the public API simple.
        this.addCallback(doneCb, timeout, updateCb);
        this._runCallbacksIfReady();
    };
    /**
     * Get the number of pending requests
     * @deprecated pending requests are now tracked with zones
     */
    Testability.prototype.getPendingRequestCount = function () { return this._pendingCount; };
    /**
     * Find providers by name
     * @param using The root element to search from
     * @param provider The name of binding variable
     * @param exactMatch Whether using exactMatch
     */
    Testability.prototype.findProviders = function (using, provider, exactMatch) {
        // TODO(juliemr): implement.
        return [];
    };
    return Testability;
}());
/**
 * A global registry of {@link Testability} instances for specific elements.
 * @experimental
 */
var TestabilityRegistry = /*@__PURE__*/ (function () {
    function TestabilityRegistry() {
        /** @internal */
        this._applications = new Map();
        _testabilityGetter.addToWindow(this);
    }
    /**
     * Registers an application with a testability hook so that it can be tracked
     * @param token token of application, root element
     * @param testability Testability hook
     */
    TestabilityRegistry.prototype.registerApplication = function (token, testability) {
        this._applications.set(token, testability);
    };
    /**
     * Unregisters an application.
     * @param token token of application, root element
     */
    TestabilityRegistry.prototype.unregisterApplication = function (token) { this._applications.delete(token); };
    /**
     * Unregisters all applications
     */
    TestabilityRegistry.prototype.unregisterAllApplications = function () { this._applications.clear(); };
    /**
     * Get a testability hook associated with the application
     * @param elem root element
     */
    TestabilityRegistry.prototype.getTestability = function (elem) { return this._applications.get(elem) || null; };
    /**
     * Get all registered testabilities
     */
    TestabilityRegistry.prototype.getAllTestabilities = function () { return Array.from(this._applications.values()); };
    /**
     * Get all registered applications(root elements)
     */
    TestabilityRegistry.prototype.getAllRootElements = function () { return Array.from(this._applications.keys()); };
    /**
     * Find testability of a node in the Tree
     * @param elem node
     * @param findInAncestors whether finding testability in ancestors if testability was not found in
     * current node
     */
    TestabilityRegistry.prototype.findTestabilityInTree = function (elem, findInAncestors) {
        if (findInAncestors === void 0) {
            findInAncestors = true;
        }
        return _testabilityGetter.findTestabilityInTree(this, elem, findInAncestors);
    };
    TestabilityRegistry = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:paramtypes", [])
    ], TestabilityRegistry);
    return TestabilityRegistry;
}());
var _NoopGetTestability = /*@__PURE__*/ (function () {
    function _NoopGetTestability() {
    }
    _NoopGetTestability.prototype.addToWindow = function (registry) { };
    _NoopGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
        return null;
    };
    return _NoopGetTestability;
}());
/**
 * Set the {@link GetTestability} implementation used by the Angular testing framework.
 * @experimental
 */
function setTestabilityGetter(getter) {
    _testabilityGetter = getter;
}
var _testabilityGetter = /*@__PURE__*/ new _NoopGetTestability();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _devMode = true;
var _runModeLocked = false;
var _platform;
var ALLOW_MULTIPLE_PLATFORMS = /*@__PURE__*/ new InjectionToken('AllowMultipleToken');
/**
 * Disable Angular's development mode, which turns off assertions and other
 * checks within the framework.
 *
 * One important assertion this disables verifies that a change detection pass
 * does not result in additional changes to any bindings (also known as
 * unidirectional data flow).
 *
 *
 */
function enableProdMode() {
    if (_runModeLocked) {
        throw new Error('Cannot enable prod mode after platform setup.');
    }
    _devMode = false;
}
/**
 * Returns whether Angular is in development mode. After called once,
 * the value is locked and won't change any more.
 *
 * By default, this is true, unless a user calls `enableProdMode` before calling this.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function isDevMode() {
    _runModeLocked = true;
    return _devMode;
}
/**
 * A token for third-party components that can register themselves with NgProbe.
 *
 * @experimental
 */
var NgProbeToken = /*@__PURE__*/ (function () {
    function NgProbeToken(name, token) {
        this.name = name;
        this.token = token;
    }
    return NgProbeToken;
}());
/**
 * Creates a platform.
 * Platforms have to be eagerly created via this function.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function createPlatform(injector) {
    if (_platform && !_platform.destroyed &&
        !_platform.injector.get(ALLOW_MULTIPLE_PLATFORMS, false)) {
        throw new Error('There can be only one platform. Destroy the previous one to create a new one.');
    }
    _platform = injector.get(PlatformRef);
    var inits = injector.get(PLATFORM_INITIALIZER, null);
    if (inits)
        inits.forEach(function (init) { return init(); });
    return _platform;
}
/**
 * Creates a factory for a platform
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function createPlatformFactory(parentPlatformFactory, name, providers) {
    if (providers === void 0) {
        providers = [];
    }
    var desc = "Platform: " + name;
    var marker = new InjectionToken(desc);
    return function (extraProviders) {
        if (extraProviders === void 0) {
            extraProviders = [];
        }
        var platform = getPlatform();
        if (!platform || platform.injector.get(ALLOW_MULTIPLE_PLATFORMS, false)) {
            if (parentPlatformFactory) {
                parentPlatformFactory(providers.concat(extraProviders).concat({ provide: marker, useValue: true }));
            }
            else {
                var injectedProviders = providers.concat(extraProviders).concat({ provide: marker, useValue: true });
                createPlatform(Injector.create({ providers: injectedProviders, name: desc }));
            }
        }
        return assertPlatform(marker);
    };
}
/**
 * Checks that there currently is a platform which contains the given token as a provider.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function assertPlatform(requiredToken) {
    var platform = getPlatform();
    if (!platform) {
        throw new Error('No platform exists!');
    }
    if (!platform.injector.get(requiredToken, null)) {
        throw new Error('A platform with a different configuration has been created. Please destroy it first.');
    }
    return platform;
}
/**
 * Destroy the existing platform.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function destroyPlatform() {
    if (_platform && !_platform.destroyed) {
        _platform.destroy();
    }
}
/**
 * Returns the current platform.
 *
 * @experimental APIs related to application bootstrap are currently under review.
 */
function getPlatform() {
    return _platform && !_platform.destroyed ? _platform : null;
}
/**
 * The Angular platform is the entry point for Angular on a web page. Each page
 * has exactly one platform, and services (such as reflection) which are common
 * to every Angular application running on the page are bound in its scope.
 *
 * A page's platform is initialized implicitly when a platform is created via a platform factory
 * (e.g. {@link platformBrowser}), or explicitly by calling the {@link createPlatform} function.
 */
var PlatformRef = /*@__PURE__*/ (function () {
    /** @internal */
    function PlatformRef(_injector) {
        this._injector = _injector;
        this._modules = [];
        this._destroyListeners = [];
        this._destroyed = false;
    }
    /**
     * Creates an instance of an `@NgModule` for the given platform
     * for offline compilation.
     *
     * @usageNotes
     * ### Simple Example
     *
     * ```typescript
     * my_module.ts:
     *
     * @NgModule({
     *   imports: [BrowserModule]
     * })
     * class MyModule {}
     *
     * main.ts:
     * import {MyModuleNgFactory} from './my_module.ngfactory';
     * import {platformBrowser} from '@angular/platform-browser';
     *
     * let moduleRef = platformBrowser().bootstrapModuleFactory(MyModuleNgFactory);
     * ```
     *
     * @experimental APIs related to application bootstrap are currently under review.
     */
    PlatformRef.prototype.bootstrapModuleFactory = function (moduleFactory, options) {
        var _this = this;
        // Note: We need to create the NgZone _before_ we instantiate the module,
        // as instantiating the module creates some providers eagerly.
        // So we create a mini parent injector that just contains the new NgZone and
        // pass that as parent to the NgModuleFactory.
        var ngZoneOption = options ? options.ngZone : undefined;
        var ngZone = getNgZone(ngZoneOption);
        var providers = [{ provide: NgZone, useValue: ngZone }];
        // Attention: Don't use ApplicationRef.run here,
        // as we want to be sure that all possible constructor calls are inside `ngZone.run`!
        return ngZone.run(function () {
            var ngZoneInjector = Injector.create({ providers: providers, parent: _this.injector, name: moduleFactory.moduleType.name });
            var moduleRef = moduleFactory.create(ngZoneInjector);
            var exceptionHandler = moduleRef.injector.get(ErrorHandler, null);
            if (!exceptionHandler) {
                throw new Error('No ErrorHandler. Is platform module (BrowserModule) included?');
            }
            moduleRef.onDestroy(function () { return remove(_this._modules, moduleRef); });
            ngZone.runOutsideAngular(function () { return ngZone.onError.subscribe({ next: function (error) { exceptionHandler.handleError(error); } }); });
            return _callAndReportToErrorHandler(exceptionHandler, ngZone, function () {
                var initStatus = moduleRef.injector.get(ApplicationInitStatus);
                initStatus.runInitializers();
                return initStatus.donePromise.then(function () {
                    _this._moduleDoBootstrap(moduleRef);
                    return moduleRef;
                });
            });
        });
    };
    /**
     * Creates an instance of an `@NgModule` for a given platform using the given runtime compiler.
     *
     * @usageNotes
     * ### Simple Example
     *
     * ```typescript
     * @NgModule({
     *   imports: [BrowserModule]
     * })
     * class MyModule {}
     *
     * let moduleRef = platformBrowser().bootstrapModule(MyModule);
     * ```
     *
     */
    PlatformRef.prototype.bootstrapModule = function (moduleType, compilerOptions) {
        var _this = this;
        if (compilerOptions === void 0) {
            compilerOptions = [];
        }
        var compilerFactory = this.injector.get(CompilerFactory);
        var options = optionsReducer({}, compilerOptions);
        var compiler = compilerFactory.createCompiler([options]);
        return compiler.compileModuleAsync(moduleType)
            .then(function (moduleFactory) { return _this.bootstrapModuleFactory(moduleFactory, options); });
    };
    PlatformRef.prototype._moduleDoBootstrap = function (moduleRef) {
        var appRef = moduleRef.injector.get(ApplicationRef);
        if (moduleRef._bootstrapComponents.length > 0) {
            moduleRef._bootstrapComponents.forEach(function (f) { return appRef.bootstrap(f); });
        }
        else if (moduleRef.instance.ngDoBootstrap) {
            moduleRef.instance.ngDoBootstrap(appRef);
        }
        else {
            throw new Error("The module " + stringify(moduleRef.instance.constructor) + " was bootstrapped, but it does not declare \"@NgModule.bootstrap\" components nor a \"ngDoBootstrap\" method. " +
                "Please define one of these.");
        }
        this._modules.push(moduleRef);
    };
    /**
     * Register a listener to be called when the platform is disposed.
     */
    PlatformRef.prototype.onDestroy = function (callback) { this._destroyListeners.push(callback); };
    Object.defineProperty(PlatformRef.prototype, "injector", {
        /**
         * Retrieve the platform {@link Injector}, which is the parent injector for
         * every Angular application on the page and provides singleton providers.
         */
        get: function () { return this._injector; },
        enumerable: true,
        configurable: true
    });
    /**
     * Destroy the Angular platform and all Angular applications on the page.
     */
    PlatformRef.prototype.destroy = function () {
        if (this._destroyed) {
            throw new Error('The platform has already been destroyed!');
        }
        this._modules.slice().forEach(function (module) { return module.destroy(); });
        this._destroyListeners.forEach(function (listener) { return listener(); });
        this._destroyed = true;
    };
    Object.defineProperty(PlatformRef.prototype, "destroyed", {
        get: function () { return this._destroyed; },
        enumerable: true,
        configurable: true
    });
    return PlatformRef;
}());
function getNgZone(ngZoneOption) {
    var ngZone;
    if (ngZoneOption === 'noop') {
        ngZone = new NoopNgZone();
    }
    else {
        ngZone = (ngZoneOption === 'zone.js' ? undefined : ngZoneOption) ||
            new NgZone({ enableLongStackTrace: isDevMode() });
    }
    return ngZone;
}
function _callAndReportToErrorHandler(errorHandler, ngZone, callback) {
    try {
        var result = callback();
        if (isPromise(result)) {
            return result.catch(function (e) {
                ngZone.runOutsideAngular(function () { return errorHandler.handleError(e); });
                // rethrow as the exception handler might not do it
                throw e;
            });
        }
        return result;
    }
    catch (e) {
        ngZone.runOutsideAngular(function () { return errorHandler.handleError(e); });
        // rethrow as the exception handler might not do it
        throw e;
    }
}
function optionsReducer(dst, objs) {
    if (Array.isArray(objs)) {
        dst = objs.reduce(optionsReducer, dst);
    }
    else {
        dst = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, dst, objs);
    }
    return dst;
}
/**
 * A reference to an Angular application running on a page.
 */
var ApplicationRef = /*@__PURE__*/ (function () {
    /** @internal */
    function ApplicationRef(_zone, _console, _injector, _exceptionHandler, _componentFactoryResolver, _initStatus) {
        var _this = this;
        this._zone = _zone;
        this._console = _console;
        this._injector = _injector;
        this._exceptionHandler = _exceptionHandler;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._initStatus = _initStatus;
        this._bootstrapListeners = [];
        this._views = [];
        this._runningTick = false;
        this._enforceNoNewChanges = false;
        this._stable = true;
        /**
         * Get a list of component types registered to this application.
         * This list is populated even before the component is created.
         */
        this.componentTypes = [];
        /**
         * Get a list of components registered to this application.
         */
        this.components = [];
        this._enforceNoNewChanges = isDevMode();
        this._zone.onMicrotaskEmpty.subscribe({ next: function () { _this._zone.run(function () { _this.tick(); }); } });
        var isCurrentlyStable = new __WEBPACK_IMPORTED_MODULE_1_rxjs__["d" /* Observable */](function (observer) {
            _this._stable = _this._zone.isStable && !_this._zone.hasPendingMacrotasks &&
                !_this._zone.hasPendingMicrotasks;
            _this._zone.runOutsideAngular(function () {
                observer.next(_this._stable);
                observer.complete();
            });
        });
        var isStable = new __WEBPACK_IMPORTED_MODULE_1_rxjs__["d" /* Observable */](function (observer) {
            // Create the subscription to onStable outside the Angular Zone so that
            // the callback is run outside the Angular Zone.
            var stableSub;
            _this._zone.runOutsideAngular(function () {
                stableSub = _this._zone.onStable.subscribe(function () {
                    NgZone.assertNotInAngularZone();
                    // Check whether there are no pending macro/micro tasks in the next tick
                    // to allow for NgZone to update the state.
                    scheduleMicroTask(function () {
                        if (!_this._stable && !_this._zone.hasPendingMacrotasks &&
                            !_this._zone.hasPendingMicrotasks) {
                            _this._stable = true;
                            observer.next(true);
                        }
                    });
                });
            });
            var unstableSub = _this._zone.onUnstable.subscribe(function () {
                NgZone.assertInAngularZone();
                if (_this._stable) {
                    _this._stable = false;
                    _this._zone.runOutsideAngular(function () { observer.next(false); });
                }
            });
            return function () {
                stableSub.unsubscribe();
                unstableSub.unsubscribe();
            };
        });
        this.isStable =
            Object(__WEBPACK_IMPORTED_MODULE_1_rxjs__["w" /* merge */])(isCurrentlyStable, isStable.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs_operators__["share"])()));
    }
    ApplicationRef_1 = ApplicationRef;
    /**
     * Bootstrap a new component at the root level of the application.
     *
     * @usageNotes
     * ### Bootstrap process
     *
     * When bootstrapping a new root component into an application, Angular mounts the
     * specified application component onto DOM elements identified by the componentType's
     * selector and kicks off automatic change detection to finish initializing the component.
     *
     * Optionally, a component can be mounted onto a DOM element that does not match the
     * componentType's selector.
     *
     * ### Example
     * {@example core/ts/platform/platform.ts region='longform'}
     */
    ApplicationRef.prototype.bootstrap = function (componentOrFactory, rootSelectorOrNode) {
        var _this = this;
        if (!this._initStatus.done) {
            throw new Error('Cannot bootstrap as there are still asynchronous initializers running. Bootstrap components in the `ngDoBootstrap` method of the root module.');
        }
        var componentFactory;
        if (componentOrFactory instanceof ComponentFactory) {
            componentFactory = componentOrFactory;
        }
        else {
            componentFactory =
                this._componentFactoryResolver.resolveComponentFactory(componentOrFactory);
        }
        this.componentTypes.push(componentFactory.componentType);
        // Create a factory associated with the current module if it's not bound to some other
        var ngModule = componentFactory instanceof ComponentFactoryBoundToModule ?
            null :
            this._injector.get(NgModuleRef);
        var selectorOrNode = rootSelectorOrNode || componentFactory.selector;
        var compRef = componentFactory.create(Injector.NULL, [], selectorOrNode, ngModule);
        compRef.onDestroy(function () { _this._unloadComponent(compRef); });
        var testability = compRef.injector.get(Testability, null);
        if (testability) {
            compRef.injector.get(TestabilityRegistry)
                .registerApplication(compRef.location.nativeElement, testability);
        }
        this._loadComponent(compRef);
        if (isDevMode()) {
            this._console.log("Angular is running in the development mode. Call enableProdMode() to enable the production mode.");
        }
        return compRef;
    };
    /**
     * Invoke this method to explicitly process change detection and its side-effects.
     *
     * In development mode, `tick()` also performs a second change detection cycle to ensure that no
     * further changes are detected. If additional changes are picked up during this second cycle,
     * bindings in the app have side-effects that cannot be resolved in a single change detection
     * pass.
     * In this case, Angular throws an error, since an Angular application can only have one change
     * detection pass during which all change detection must complete.
     */
    ApplicationRef.prototype.tick = function () {
        var _this = this;
        if (this._runningTick) {
            throw new Error('ApplicationRef.tick is called recursively');
        }
        var scope = ApplicationRef_1._tickScope();
        try {
            this._runningTick = true;
            this._views.forEach(function (view) { return view.detectChanges(); });
            if (this._enforceNoNewChanges) {
                this._views.forEach(function (view) { return view.checkNoChanges(); });
            }
        }
        catch (e) {
            // Attention: Don't rethrow as it could cancel subscriptions to Observables!
            this._zone.runOutsideAngular(function () { return _this._exceptionHandler.handleError(e); });
        }
        finally {
            this._runningTick = false;
            wtfLeave(scope);
        }
    };
    /**
     * Attaches a view so that it will be dirty checked.
     * The view will be automatically detached when it is destroyed.
     * This will throw if the view is already attached to a ViewContainer.
     */
    ApplicationRef.prototype.attachView = function (viewRef) {
        var view = viewRef;
        this._views.push(view);
        view.attachToAppRef(this);
    };
    /**
     * Detaches a view from dirty checking again.
     */
    ApplicationRef.prototype.detachView = function (viewRef) {
        var view = viewRef;
        remove(this._views, view);
        view.detachFromAppRef();
    };
    ApplicationRef.prototype._loadComponent = function (componentRef) {
        this.attachView(componentRef.hostView);
        this.tick();
        this.components.push(componentRef);
        // Get the listeners lazily to prevent DI cycles.
        var listeners = this._injector.get(APP_BOOTSTRAP_LISTENER, []).concat(this._bootstrapListeners);
        listeners.forEach(function (listener) { return listener(componentRef); });
    };
    ApplicationRef.prototype._unloadComponent = function (componentRef) {
        this.detachView(componentRef.hostView);
        remove(this.components, componentRef);
    };
    /** @internal */
    ApplicationRef.prototype.ngOnDestroy = function () {
        // TODO(alxhub): Dispose of the NgZone.
        this._views.slice().forEach(function (view) { return view.destroy(); });
    };
    Object.defineProperty(ApplicationRef.prototype, "viewCount", {
        /**
         * Returns the number of attached views.
         */
        get: function () { return this._views.length; },
        enumerable: true,
        configurable: true
    });
    var ApplicationRef_1;
    /** @internal */
    ApplicationRef._tickScope = wtfCreateScope('ApplicationRef#tick()');
    return ApplicationRef;
}());
function remove(list, el) {
    var index = list.indexOf(el);
    if (index > -1) {
        list.splice(index, 1);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @deprecated Use `RendererType2` (and `Renderer2`) instead.
 */
var RenderComponentType = /*@__PURE__*/ (function () {
    function RenderComponentType(id, templateUrl, slotCount, encapsulation, styles, animations) {
        this.id = id;
        this.templateUrl = templateUrl;
        this.slotCount = slotCount;
        this.encapsulation = encapsulation;
        this.styles = styles;
        this.animations = animations;
    }
    return RenderComponentType;
}());
/**
 * @deprecated Debug info is handeled internally in the view engine now.
 */
var RenderDebugInfo = /*@__PURE__*/ (function () {
    function RenderDebugInfo() {
    }
    return RenderDebugInfo;
}());
/**
 * @deprecated Use the `Renderer2` instead.
 */
var Renderer = /*@__PURE__*/ (function () {
    function Renderer() {
    }
    return Renderer;
}());
var Renderer2Interceptor = /*@__PURE__*/ new InjectionToken('Renderer2Interceptor');
/**
 * Injectable service that provides a low-level interface for modifying the UI.
 *
 * Use this service to bypass Angular's templating and make custom UI changes that can't be
 * expressed declaratively. For example if you need to set a property or an attribute whose name is
 * not statically known, use {@link Renderer#setElementProperty setElementProperty} or
 * {@link Renderer#setElementAttribute setElementAttribute} respectively.
 *
 * If you are implementing a custom renderer, you must implement this interface.
 *
 * The default Renderer implementation is `DomRenderer`. Also available is `WebWorkerRenderer`.
 *
 * @deprecated Use `RendererFactory2` instead.
 */
var RootRenderer = /*@__PURE__*/ (function () {
    function RootRenderer() {
    }
    return RootRenderer;
}());
/**
 * Creates and initializes a custom renderer that implements the `Renderer2` base class.
 *
 * @experimental
 */
var RendererFactory2 = /*@__PURE__*/ (function () {
    function RendererFactory2() {
    }
    return RendererFactory2;
}());
/**
 * Flags for renderer-specific style modifiers.
 * @experimental
 */
var RendererStyleFlags2 = /*@__PURE__*/ (function (RendererStyleFlags2) {
    /**
     * Marks a style as important.
     */
    RendererStyleFlags2[RendererStyleFlags2["Important"] = 1] = "Important";
    /**
     * Marks a style as using dash case naming (this-is-dash-case).
     */
    RendererStyleFlags2[RendererStyleFlags2["DashCase"] = 2] = "DashCase";
    return RendererStyleFlags2;
})({});
/**
 * Extend this base class to implement custom rendering. By default, Angular
 * renders a template into DOM. You can use custom rendering to intercept
 * rendering calls, or to render to something other than DOM.
 *
 * Create your custom renderer using `RendererFactory2`.
 *
 * Use a custom renderer to bypass Angular's templating and
 * make custom UI changes that can't be expressed declaratively.
 * For example if you need to set a property or an attribute whose name is
 * not statically known, use the `setProperty()` or
 * `setAttribute()` method.
 *
 * @experimental
 */
var Renderer2 = /*@__PURE__*/ (function () {
    function Renderer2() {
    }
    return Renderer2;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A wrapper around a native element inside of a View.
 *
 * An `ElementRef` is backed by a render-specific element. In the browser, this is usually a DOM
 * element.
 *
 * @security Permitting direct access to the DOM can make your application more vulnerable to
 * XSS attacks. Carefully review any use of `ElementRef` in your code. For more detail, see the
 * [Security Guide](http://g.co/ng/security).
 *
 *
 */
// Note: We don't expose things like `Injector`, `ViewContainer`, ... here,
// i.e. users have to ask for what they need. With that, we can build better analysis tools
// and could do better codegen in the future.
var ElementRef = /*@__PURE__*/ (function () {
    function ElementRef(nativeElement) {
        this.nativeElement = nativeElement;
    }
    return ElementRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to load ng module factories.
 *
 */
var NgModuleFactoryLoader = /*@__PURE__*/ (function () {
    function NgModuleFactoryLoader() {
    }
    return NgModuleFactoryLoader;
}());
var moduleFactories = /*@__PURE__*/ new Map();
/**
 * Registers a loaded module. Should only be called from generated NgModuleFactory code.
 * @experimental
 */
function registerModuleFactory(id, factory) {
    var existing = moduleFactories.get(id);
    if (existing) {
        throw new Error("Duplicate module registered for " + id + " - " + existing.moduleType.name + " vs " + factory.moduleType.name);
    }
    moduleFactories.set(id, factory);
}
/**
 * Returns the NgModuleFactory with the given id, if it exists and has been loaded.
 * Factories for modules that do not specify an `id` cannot be retrieved. Throws if the module
 * cannot be found.
 * @experimental
 */
function getModuleFactory(id) {
    var factory = moduleFactories.get(id);
    if (!factory)
        throw new Error("No module with ID " + id + " loaded");
    return factory;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An unmodifiable list of items that Angular keeps up to date when the state
 * of the application changes.
 *
 * The type of object that {@link ViewChildren}, {@link ContentChildren}, and {@link QueryList}
 * provide.
 *
 * Implements an iterable interface, therefore it can be used in both ES6
 * javascript `for (var i of items)` loops as well as in Angular templates with
 * `*ngFor="let i of myList"`.
 *
 * Changes can be observed by subscribing to the changes `Observable`.
 *
 * NOTE: In the future this class will implement an `Observable` interface.
 *
 * @usageNotes
 * ### Example
 * ```typescript
 * @Component({...})
 * class Container {
 *   @ViewChildren(Item) items:QueryList<Item>;
 * }
 * ```
 */
var QueryList = /*@__PURE__*/ (function () {
    function QueryList() {
        this.dirty = true;
        this._results = [];
        this.changes = new EventEmitter();
        this.length = 0;
    }
    /**
     * See
     * [Array.map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)
     */
    QueryList.prototype.map = function (fn) { return this._results.map(fn); };
    /**
     * See
     * [Array.filter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter)
     */
    QueryList.prototype.filter = function (fn) {
        return this._results.filter(fn);
    };
    /**
     * See
     * [Array.find](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find)
     */
    QueryList.prototype.find = function (fn) {
        return this._results.find(fn);
    };
    /**
     * See
     * [Array.reduce](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce)
     */
    QueryList.prototype.reduce = function (fn, init) {
        return this._results.reduce(fn, init);
    };
    /**
     * See
     * [Array.forEach](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach)
     */
    QueryList.prototype.forEach = function (fn) { this._results.forEach(fn); };
    /**
     * See
     * [Array.some](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some)
     */
    QueryList.prototype.some = function (fn) {
        return this._results.some(fn);
    };
    QueryList.prototype.toArray = function () { return this._results.slice(); };
    QueryList.prototype[getSymbolIterator()] = function () { return this._results[getSymbolIterator()](); };
    QueryList.prototype.toString = function () { return this._results.toString(); };
    QueryList.prototype.reset = function (res) {
        this._results = flatten(res);
        this.dirty = false;
        this.length = this._results.length;
        this.last = this._results[this.length - 1];
        this.first = this._results[0];
    };
    QueryList.prototype.notifyOnChanges = function () { this.changes.emit(this); };
    /** internal */
    QueryList.prototype.setDirty = function () { this.dirty = true; };
    /** internal */
    QueryList.prototype.destroy = function () {
        this.changes.complete();
        this.changes.unsubscribe();
    };
    return QueryList;
}());
function flatten(list) {
    return list.reduce(function (flat, item) {
        var flatItem = Array.isArray(item) ? flatten(item) : item;
        return flat.concat(flatItem);
    }, []);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _SEPARATOR = '#';
var FACTORY_CLASS_SUFFIX = 'NgFactory';
/**
 * Configuration for SystemJsNgModuleLoader.
 * token.
 *
 * @experimental
 */
var SystemJsNgModuleLoaderConfig = /*@__PURE__*/ (function () {
    function SystemJsNgModuleLoaderConfig() {
    }
    return SystemJsNgModuleLoaderConfig;
}());
var DEFAULT_CONFIG = {
    factoryPathPrefix: '',
    factoryPathSuffix: '.ngfactory',
};
/**
 * NgModuleFactoryLoader that uses SystemJS to load NgModuleFactory
 * @experimental
 */
var SystemJsNgModuleLoader = /*@__PURE__*/ (function () {
    function SystemJsNgModuleLoader(_compiler, config) {
        this._compiler = _compiler;
        this._config = config || DEFAULT_CONFIG;
    }
    SystemJsNgModuleLoader.prototype.load = function (path) {
        var offlineMode = this._compiler instanceof Compiler;
        return offlineMode ? this.loadFactory(path) : this.loadAndCompile(path);
    };
    SystemJsNgModuleLoader.prototype.loadAndCompile = function (path) {
        var _this = this;
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(path.split(_SEPARATOR), 2), module = _a[0], exportName = _a[1];
        if (exportName === undefined) {
            exportName = 'default';
        }
        return __webpack_require__("SfPD")(module)
            .then(function (module) { return module[exportName]; })
            .then(function (type) { return checkNotEmpty(type, module, exportName); })
            .then(function (type) { return _this._compiler.compileModuleAsync(type); });
    };
    SystemJsNgModuleLoader.prototype.loadFactory = function (path) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(path.split(_SEPARATOR), 2), module = _a[0], exportName = _a[1];
        var factoryClassSuffix = FACTORY_CLASS_SUFFIX;
        if (exportName === undefined) {
            exportName = 'default';
            factoryClassSuffix = '';
        }
        return __webpack_require__("SfPD")(this._config.factoryPathPrefix + module + this._config.factoryPathSuffix)
            .then(function (module) { return module[exportName + factoryClassSuffix]; })
            .then(function (factory) { return checkNotEmpty(factory, module, exportName); });
    };
    SystemJsNgModuleLoader = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Optional())
    ], SystemJsNgModuleLoader);
    return SystemJsNgModuleLoader;
}());
function checkNotEmpty(value, modulePath, exportName) {
    if (!value) {
        throw new Error("Cannot find '" + exportName + "' in '" + modulePath + "'");
    }
    return value;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents an embedded template that can be used to instantiate embedded views.
 * To instantiate embedded views based on a template, use the `ViewContainerRef`
 * method `createEmbeddedView()`.
 *
 * Access a `TemplateRef` instance by placing a directive on an `<ng-template>`
 * element (or directive prefixed with `*`). The `TemplateRef` for the embedded view
 * is injected into the constructor of the directive,
 * using the `TemplateRef` token.
 *
 * You can also use a `Query` to find a `TemplateRef` associated with
 * a component or a directive.
 *
 * @see `ViewContainerRef`
 * @see [Navigate the Component Tree with DI](guide/dependency-injection-navtree)
 *
 */
var TemplateRef = /*@__PURE__*/ (function () {
    function TemplateRef() {
    }
    return TemplateRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents a container where one or more views can be attached to a component.
 *
 * Can contain *host views* (created by instantiating a
 * component with the `createComponent()` method), and *embedded views*
 * (created by instantiating a `TemplateRef` with the `createEmbeddedView()` method).
 *
 * A view container instance can contain other view containers,
 * creating a [view hierarchy](guide/glossary#view-tree).
 *
 * @see `ComponentRef`
 * @see `EmbeddedViewRef`
 *
 */
var ViewContainerRef = /*@__PURE__*/ (function () {
    function ViewContainerRef() {
    }
    return ViewContainerRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Base class for Angular Views, provides change detection functionality.
 * A change-detection tree collects all views that are to be checked for changes.
 * Use the methods to add and remove views from the tree, initiate change-detection,
 * and explicitly mark views as _dirty_, meaning that they have changed and need to be rerendered.
 *
 * @usageNotes
 *
 * The following examples demonstrate how to modify default change-detection behavior
 * to perform explicit detection when needed.
 *
 * ### Use `markForCheck()` with `CheckOnce` strategy
 *
 * The following example sets the `OnPush` change-detection strategy for a component
 * (`CheckOnce`, rather than the default `CheckAlways`), then forces a second check
 * after an interval. See [live demo](http://plnkr.co/edit/GC512b?p=preview).
 *
 * <code-example path="core/ts/change_detect/change-detection.ts"
 * region="mark-for-check"></code-example>
 *
 * ### Detach change detector to limit how often check occurs
 *
 * The following example defines a component with a large list of read-only data
 * that is expected to change constantly, many times per second.
 * To improve performance, we want to check and update the list
 * less often than the changes actually occur. To do that, we detach
 * the component's change detector and perform an explicit local check every five seconds.
 *
 * <code-example path="core/ts/change_detect/change-detection.ts" region="detach"></code-example>
 *
 *
 * ### Reattaching a detached component
 *
 * The following example creates a component displaying live data.
 * The component detaches its change detector from the main change detector tree
 * when the `live` property is set to false, and reattaches it when the property
 * becomes true.
 *
 * <code-example path="core/ts/change_detect/change-detection.ts" region="reattach"></code-example>
 *
 */
var ChangeDetectorRef = /*@__PURE__*/ (function () {
    function ChangeDetectorRef() {
    }
    return ChangeDetectorRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents an Angular [view](guide/glossary#view),
 * specifically the [host view](guide/glossary#view-tree) that is defined by a component.
 * Also serves as the base class
 * that adds destroy methods for [embedded views](guide/glossary#view-tree).
 *
 * @see `EmbeddedViewRef`
 */
var ViewRef = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ViewRef, _super);
    function ViewRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ViewRef;
}(ChangeDetectorRef));
/**
 * Represents an Angular [view](guide/glossary#view) in a view container.
 * An [embedded view](guide/glossary#view-tree) can be referenced from a component
 * other than the hosting component whose template defines it, or it can be defined
 * independently by a `TemplateRef`.
 *
 * Properties of elements in a view can change, but the structure (number and order) of elements in
 * a view cannot. Change the structure of elements by inserting, moving, or
 * removing nested views in a view container.
 *
 * @see `ViewContainerRef`
 *
 * @usageNotes
 *
 * The following template breaks down into two separate `TemplateRef` instances,
 * an outer one and an inner one.
 *
 * ```
 * Count: {{items.length}}
 * <ul>
 *   <li *ngFor="let  item of items">{{item}}</li>
 * </ul>
 * ```
 *
 * This is the outer `TemplateRef`:
 *
 * ```
 * Count: {{items.length}}
 * <ul>
 *   <ng-template ngFor let-item [ngForOf]="items"></ng-template>
 * </ul>
 * ```
 *
 * This is the inner `TemplateRef`:
 *
 * ```
 *   <li>{{item}}</li>
 * ```
 *
 * The outer and inner `TemplateRef` instances are assembled into views as follows:
 *
 * ```
 * <!-- ViewRef: outer-0 -->
 * Count: 2
 * <ul>
 *   <ng-template view-container-ref></ng-template>
 *   <!-- ViewRef: inner-1 --><li>first</li><!-- /ViewRef: inner-1 -->
 *   <!-- ViewRef: inner-2 --><li>second</li><!-- /ViewRef: inner-2 -->
 * </ul>
 * <!-- /ViewRef: outer-0 -->
 * ```
 * @experimental
 */
var EmbeddedViewRef = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(EmbeddedViewRef, _super);
    function EmbeddedViewRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EmbeddedViewRef;
}(ViewRef));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EventListener = /*@__PURE__*/ (function () {
    function EventListener(name, callback) {
        this.name = name;
        this.callback = callback;
    }
    return EventListener;
}());
/**
 * @experimental All debugging apis are currently experimental.
 */
var DebugNode = /*@__PURE__*/ (function () {
    function DebugNode(nativeNode, parent, _debugContext) {
        this._debugContext = _debugContext;
        this.nativeNode = nativeNode;
        if (parent && parent instanceof DebugElement) {
            parent.addChild(this);
        }
        else {
            this.parent = null;
        }
        this.listeners = [];
    }
    Object.defineProperty(DebugNode.prototype, "injector", {
        get: function () { return this._debugContext.injector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "componentInstance", {
        get: function () { return this._debugContext.component; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "context", {
        get: function () { return this._debugContext.context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "references", {
        get: function () { return this._debugContext.references; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "providerTokens", {
        get: function () { return this._debugContext.providerTokens; },
        enumerable: true,
        configurable: true
    });
    return DebugNode;
}());
/**
 * @experimental All debugging apis are currently experimental.
 */
var DebugElement = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(DebugElement, _super);
    function DebugElement(nativeNode, parent, _debugContext) {
        var _this = _super.call(this, nativeNode, parent, _debugContext) || this;
        _this.properties = {};
        _this.attributes = {};
        _this.classes = {};
        _this.styles = {};
        _this.childNodes = [];
        _this.nativeElement = nativeNode;
        return _this;
    }
    DebugElement.prototype.addChild = function (child) {
        if (child) {
            this.childNodes.push(child);
            child.parent = this;
        }
    };
    DebugElement.prototype.removeChild = function (child) {
        var childIndex = this.childNodes.indexOf(child);
        if (childIndex !== -1) {
            child.parent = null;
            this.childNodes.splice(childIndex, 1);
        }
    };
    DebugElement.prototype.insertChildrenAfter = function (child, newChildren) {
        var _this = this;
        var _a;
        var siblingIndex = this.childNodes.indexOf(child);
        if (siblingIndex !== -1) {
            (_a = this.childNodes).splice.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([siblingIndex + 1, 0], newChildren));
            newChildren.forEach(function (c) {
                if (c.parent) {
                    c.parent.removeChild(c);
                }
                c.parent = _this;
            });
        }
    };
    DebugElement.prototype.insertBefore = function (refChild, newChild) {
        var refIndex = this.childNodes.indexOf(refChild);
        if (refIndex === -1) {
            this.addChild(newChild);
        }
        else {
            if (newChild.parent) {
                newChild.parent.removeChild(newChild);
            }
            newChild.parent = this;
            this.childNodes.splice(refIndex, 0, newChild);
        }
    };
    DebugElement.prototype.query = function (predicate) {
        var results = this.queryAll(predicate);
        return results[0] || null;
    };
    DebugElement.prototype.queryAll = function (predicate) {
        var matches = [];
        _queryElementChildren(this, predicate, matches);
        return matches;
    };
    DebugElement.prototype.queryAllNodes = function (predicate) {
        var matches = [];
        _queryNodeChildren(this, predicate, matches);
        return matches;
    };
    Object.defineProperty(DebugElement.prototype, "children", {
        get: function () {
            return this.childNodes.filter(function (node) { return node instanceof DebugElement; });
        },
        enumerable: true,
        configurable: true
    });
    DebugElement.prototype.triggerEventHandler = function (eventName, eventObj) {
        this.listeners.forEach(function (listener) {
            if (listener.name == eventName) {
                listener.callback(eventObj);
            }
        });
    };
    return DebugElement;
}(DebugNode));
/**
 * @experimental
 */
function asNativeElements(debugEls) {
    return debugEls.map(function (el) { return el.nativeElement; });
}
function _queryElementChildren(element, predicate, matches) {
    element.childNodes.forEach(function (node) {
        if (node instanceof DebugElement) {
            if (predicate(node)) {
                matches.push(node);
            }
            _queryElementChildren(node, predicate, matches);
        }
    });
}
function _queryNodeChildren(parentNode, predicate, matches) {
    if (parentNode instanceof DebugElement) {
        parentNode.childNodes.forEach(function (node) {
            if (predicate(node)) {
                matches.push(node);
            }
            if (node instanceof DebugElement) {
                _queryNodeChildren(node, predicate, matches);
            }
        });
    }
}
// Need to keep the nodes in a global Map so that multiple angular apps are supported.
var _nativeNodeToDebugNode = /*@__PURE__*/ new Map();
/**
 * @experimental
 */
function getDebugNode(nativeNode) {
    return _nativeNodeToDebugNode.get(nativeNode) || null;
}
function indexDebugNode(node) {
    _nativeNodeToDebugNode.set(node.nativeNode, node);
}
function removeDebugNodeFromIndex(node) {
    _nativeNodeToDebugNode.delete(node.nativeNode);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function devModeEqual(a, b) {
    var isListLikeIterableA = isListLikeIterable(a);
    var isListLikeIterableB = isListLikeIterable(b);
    if (isListLikeIterableA && isListLikeIterableB) {
        return areIterablesEqual(a, b, devModeEqual);
    }
    else {
        var isAObject = a && (typeof a === 'object' || typeof a === 'function');
        var isBObject = b && (typeof b === 'object' || typeof b === 'function');
        if (!isListLikeIterableA && isAObject && !isListLikeIterableB && isBObject) {
            return true;
        }
        else {
            return looseIdentical(a, b);
        }
    }
}
/**
 * Indicates that the result of a {@link Pipe} transformation has changed even though the
 * reference has not changed.
 *
 * Wrapped values are unwrapped automatically during the change detection, and the unwrapped value
 * is stored.
 *
 * Example:
 *
 * ```
 * if (this._latestValue === this._latestReturnedValue) {
 *    return this._latestReturnedValue;
 *  } else {
 *    this._latestReturnedValue = this._latestValue;
 *    return WrappedValue.wrap(this._latestValue); // this will force update
 *  }
 * ```
 *
 */
var WrappedValue = /*@__PURE__*/ (function () {
    function WrappedValue(value) {
        this.wrapped = value;
    }
    /** Creates a wrapped value. */
    WrappedValue.wrap = function (value) { return new WrappedValue(value); };
    /**
     * Returns the underlying value of a wrapped value.
     * Returns the given `value` when it is not wrapped.
     **/
    WrappedValue.unwrap = function (value) { return WrappedValue.isWrapped(value) ? value.wrapped : value; };
    /** Returns true if `value` is a wrapped value. */
    WrappedValue.isWrapped = function (value) { return value instanceof WrappedValue; };
    return WrappedValue;
}());
/**
 * Represents a basic change from a previous to a new value.
 *
 */
var SimpleChange = /*@__PURE__*/ (function () {
    function SimpleChange(previousValue, currentValue, firstChange) {
        this.previousValue = previousValue;
        this.currentValue = currentValue;
        this.firstChange = firstChange;
    }
    /**
     * Check whether the new value is the first value assigned.
     */
    SimpleChange.prototype.isFirstChange = function () { return this.firstChange; };
    return SimpleChange;
}());
function isListLikeIterable(obj) {
    if (!isJsObject(obj))
        return false;
    return Array.isArray(obj) ||
        (!(obj instanceof Map) && // JS Map are iterables but return entries as [k, v]
            getSymbolIterator() in obj); // JS Iterable have a Symbol.iterator prop
}
function areIterablesEqual(a, b, comparator) {
    var iterator1 = a[getSymbolIterator()]();
    var iterator2 = b[getSymbolIterator()]();
    while (true) {
        var item1 = iterator1.next();
        var item2 = iterator2.next();
        if (item1.done && item2.done)
            return true;
        if (item1.done || item2.done)
            return false;
        if (!comparator(item1.value, item2.value))
            return false;
    }
}
function iterateListLike(obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
            fn(obj[i]);
        }
    }
    else {
        var iterator = obj[getSymbolIterator()]();
        var item = void 0;
        while (!((item = iterator.next()).done)) {
            fn(item.value);
        }
    }
}
function isJsObject(o) {
    return o !== null && (typeof o === 'function' || typeof o === 'object');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DefaultIterableDifferFactory = /*@__PURE__*/ (function () {
    function DefaultIterableDifferFactory() {
    }
    DefaultIterableDifferFactory.prototype.supports = function (obj) { return isListLikeIterable(obj); };
    DefaultIterableDifferFactory.prototype.create = function (trackByFn) {
        return new DefaultIterableDiffer(trackByFn);
    };
    return DefaultIterableDifferFactory;
}());
var trackByIdentity = function (index, item) { return item; };
/**
 * @deprecated v4.0.0 - Should not be part of public API.
 */
var DefaultIterableDiffer = /*@__PURE__*/ (function () {
    function DefaultIterableDiffer(trackByFn) {
        this.length = 0;
        // Keeps track of the used records at any point in time (during & across `_check()` calls)
        this._linkedRecords = null;
        // Keeps track of the removed records at any point in time during `_check()` calls.
        this._unlinkedRecords = null;
        this._previousItHead = null;
        this._itHead = null;
        this._itTail = null;
        this._additionsHead = null;
        this._additionsTail = null;
        this._movesHead = null;
        this._movesTail = null;
        this._removalsHead = null;
        this._removalsTail = null;
        // Keeps track of records where custom track by is the same, but item identity has changed
        this._identityChangesHead = null;
        this._identityChangesTail = null;
        this._trackByFn = trackByFn || trackByIdentity;
    }
    DefaultIterableDiffer.prototype.forEachItem = function (fn) {
        var record;
        for (record = this._itHead; record !== null; record = record._next) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachOperation = function (fn) {
        var nextIt = this._itHead;
        var nextRemove = this._removalsHead;
        var addRemoveOffset = 0;
        var moveOffsets = null;
        while (nextIt || nextRemove) {
            // Figure out which is the next record to process
            // Order: remove, add, move
            var record = !nextRemove ||
                nextIt &&
                    nextIt.currentIndex <
                        getPreviousIndex(nextRemove, addRemoveOffset, moveOffsets) ?
                nextIt :
                nextRemove;
            var adjPreviousIndex = getPreviousIndex(record, addRemoveOffset, moveOffsets);
            var currentIndex = record.currentIndex;
            // consume the item, and adjust the addRemoveOffset and update moveDistance if necessary
            if (record === nextRemove) {
                addRemoveOffset--;
                nextRemove = nextRemove._nextRemoved;
            }
            else {
                nextIt = nextIt._next;
                if (record.previousIndex == null) {
                    addRemoveOffset++;
                }
                else {
                    // INVARIANT:  currentIndex < previousIndex
                    if (!moveOffsets)
                        moveOffsets = [];
                    var localMovePreviousIndex = adjPreviousIndex - addRemoveOffset;
                    var localCurrentIndex = currentIndex - addRemoveOffset;
                    if (localMovePreviousIndex != localCurrentIndex) {
                        for (var i = 0; i < localMovePreviousIndex; i++) {
                            var offset = i < moveOffsets.length ? moveOffsets[i] : (moveOffsets[i] = 0);
                            var index = offset + i;
                            if (localCurrentIndex <= index && index < localMovePreviousIndex) {
                                moveOffsets[i] = offset + 1;
                            }
                        }
                        var previousIndex = record.previousIndex;
                        moveOffsets[previousIndex] = localCurrentIndex - localMovePreviousIndex;
                    }
                }
            }
            if (adjPreviousIndex !== currentIndex) {
                fn(record, adjPreviousIndex, currentIndex);
            }
        }
    };
    DefaultIterableDiffer.prototype.forEachPreviousItem = function (fn) {
        var record;
        for (record = this._previousItHead; record !== null; record = record._nextPrevious) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachAddedItem = function (fn) {
        var record;
        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachMovedItem = function (fn) {
        var record;
        for (record = this._movesHead; record !== null; record = record._nextMoved) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachRemovedItem = function (fn) {
        var record;
        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.forEachIdentityChange = function (fn) {
        var record;
        for (record = this._identityChangesHead; record !== null; record = record._nextIdentityChange) {
            fn(record);
        }
    };
    DefaultIterableDiffer.prototype.diff = function (collection) {
        if (collection == null)
            collection = [];
        if (!isListLikeIterable(collection)) {
            throw new Error("Error trying to diff '" + stringify(collection) + "'. Only arrays and iterables are allowed");
        }
        if (this.check(collection)) {
            return this;
        }
        else {
            return null;
        }
    };
    DefaultIterableDiffer.prototype.onDestroy = function () { };
    DefaultIterableDiffer.prototype.check = function (collection) {
        var _this = this;
        this._reset();
        var record = this._itHead;
        var mayBeDirty = false;
        var index;
        var item;
        var itemTrackBy;
        if (Array.isArray(collection)) {
            this.length = collection.length;
            for (var index_1 = 0; index_1 < this.length; index_1++) {
                item = collection[index_1];
                itemTrackBy = this._trackByFn(index_1, item);
                if (record === null || !looseIdentical(record.trackById, itemTrackBy)) {
                    record = this._mismatch(record, item, itemTrackBy, index_1);
                    mayBeDirty = true;
                }
                else {
                    if (mayBeDirty) {
                        // TODO(misko): can we limit this to duplicates only?
                        record = this._verifyReinsertion(record, item, itemTrackBy, index_1);
                    }
                    if (!looseIdentical(record.item, item))
                        this._addIdentityChange(record, item);
                }
                record = record._next;
            }
        }
        else {
            index = 0;
            iterateListLike(collection, function (item) {
                itemTrackBy = _this._trackByFn(index, item);
                if (record === null || !looseIdentical(record.trackById, itemTrackBy)) {
                    record = _this._mismatch(record, item, itemTrackBy, index);
                    mayBeDirty = true;
                }
                else {
                    if (mayBeDirty) {
                        // TODO(misko): can we limit this to duplicates only?
                        record = _this._verifyReinsertion(record, item, itemTrackBy, index);
                    }
                    if (!looseIdentical(record.item, item))
                        _this._addIdentityChange(record, item);
                }
                record = record._next;
                index++;
            });
            this.length = index;
        }
        this._truncate(record);
        this.collection = collection;
        return this.isDirty;
    };
    Object.defineProperty(DefaultIterableDiffer.prototype, "isDirty", {
        /* CollectionChanges is considered dirty if it has any additions, moves, removals, or identity
         * changes.
         */
        get: function () {
            return this._additionsHead !== null || this._movesHead !== null ||
                this._removalsHead !== null || this._identityChangesHead !== null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Reset the state of the change objects to show no changes. This means set previousKey to
     * currentKey, and clear all of the queues (additions, moves, removals).
     * Set the previousIndexes of moved and added items to their currentIndexes
     * Reset the list of additions, moves and removals
     *
     * @internal
     */
    DefaultIterableDiffer.prototype._reset = function () {
        if (this.isDirty) {
            var record = void 0;
            var nextRecord = void 0;
            for (record = this._previousItHead = this._itHead; record !== null; record = record._next) {
                record._nextPrevious = record._next;
            }
            for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                record.previousIndex = record.currentIndex;
            }
            this._additionsHead = this._additionsTail = null;
            for (record = this._movesHead; record !== null; record = nextRecord) {
                record.previousIndex = record.currentIndex;
                nextRecord = record._nextMoved;
            }
            this._movesHead = this._movesTail = null;
            this._removalsHead = this._removalsTail = null;
            this._identityChangesHead = this._identityChangesTail = null;
            // TODO(vicb): when assert gets supported
            // assert(!this.isDirty);
        }
    };
    /**
     * This is the core function which handles differences between collections.
     *
     * - `record` is the record which we saw at this position last time. If null then it is a new
     *   item.
     * - `item` is the current item in the collection
     * - `index` is the position of the item in the collection
     *
     * @internal
     */
    DefaultIterableDiffer.prototype._mismatch = function (record, item, itemTrackBy, index) {
        // The previous record after which we will append the current one.
        var previousRecord;
        if (record === null) {
            previousRecord = this._itTail;
        }
        else {
            previousRecord = record._prev;
            // Remove the record from the collection since we know it does not match the item.
            this._remove(record);
        }
        // Attempt to see if we have seen the item before.
        record = this._linkedRecords === null ? null : this._linkedRecords.get(itemTrackBy, index);
        if (record !== null) {
            // We have seen this before, we need to move it forward in the collection.
            // But first we need to check if identity changed, so we can update in view if necessary
            if (!looseIdentical(record.item, item))
                this._addIdentityChange(record, item);
            this._moveAfter(record, previousRecord, index);
        }
        else {
            // Never seen it, check evicted list.
            record = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy, null);
            if (record !== null) {
                // It is an item which we have evicted earlier: reinsert it back into the list.
                // But first we need to check if identity changed, so we can update in view if necessary
                if (!looseIdentical(record.item, item))
                    this._addIdentityChange(record, item);
                this._reinsertAfter(record, previousRecord, index);
            }
            else {
                // It is a new item: add it.
                record =
                    this._addAfter(new IterableChangeRecord_(item, itemTrackBy), previousRecord, index);
            }
        }
        return record;
    };
    /**
     * This check is only needed if an array contains duplicates. (Short circuit of nothing dirty)
     *
     * Use case: `[a, a]` => `[b, a, a]`
     *
     * If we did not have this check then the insertion of `b` would:
     *   1) evict first `a`
     *   2) insert `b` at `0` index.
     *   3) leave `a` at index `1` as is. <-- this is wrong!
     *   3) reinsert `a` at index 2. <-- this is wrong!
     *
     * The correct behavior is:
     *   1) evict first `a`
     *   2) insert `b` at `0` index.
     *   3) reinsert `a` at index 1.
     *   3) move `a` at from `1` to `2`.
     *
     *
     * Double check that we have not evicted a duplicate item. We need to check if the item type may
     * have already been removed:
     * The insertion of b will evict the first 'a'. If we don't reinsert it now it will be reinserted
     * at the end. Which will show up as the two 'a's switching position. This is incorrect, since a
     * better way to think of it is as insert of 'b' rather then switch 'a' with 'b' and then add 'a'
     * at the end.
     *
     * @internal
     */
    DefaultIterableDiffer.prototype._verifyReinsertion = function (record, item, itemTrackBy, index) {
        var reinsertRecord = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy, null);
        if (reinsertRecord !== null) {
            record = this._reinsertAfter(reinsertRecord, record._prev, index);
        }
        else if (record.currentIndex != index) {
            record.currentIndex = index;
            this._addToMoves(record, index);
        }
        return record;
    };
    /**
     * Get rid of any excess {@link IterableChangeRecord_}s from the previous collection
     *
     * - `record` The first excess {@link IterableChangeRecord_}.
     *
     * @internal
     */
    DefaultIterableDiffer.prototype._truncate = function (record) {
        // Anything after that needs to be removed;
        while (record !== null) {
            var nextRecord = record._next;
            this._addToRemovals(this._unlink(record));
            record = nextRecord;
        }
        if (this._unlinkedRecords !== null) {
            this._unlinkedRecords.clear();
        }
        if (this._additionsTail !== null) {
            this._additionsTail._nextAdded = null;
        }
        if (this._movesTail !== null) {
            this._movesTail._nextMoved = null;
        }
        if (this._itTail !== null) {
            this._itTail._next = null;
        }
        if (this._removalsTail !== null) {
            this._removalsTail._nextRemoved = null;
        }
        if (this._identityChangesTail !== null) {
            this._identityChangesTail._nextIdentityChange = null;
        }
    };
    /** @internal */
    DefaultIterableDiffer.prototype._reinsertAfter = function (record, prevRecord, index) {
        if (this._unlinkedRecords !== null) {
            this._unlinkedRecords.remove(record);
        }
        var prev = record._prevRemoved;
        var next = record._nextRemoved;
        if (prev === null) {
            this._removalsHead = next;
        }
        else {
            prev._nextRemoved = next;
        }
        if (next === null) {
            this._removalsTail = prev;
        }
        else {
            next._prevRemoved = prev;
        }
        this._insertAfter(record, prevRecord, index);
        this._addToMoves(record, index);
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._moveAfter = function (record, prevRecord, index) {
        this._unlink(record);
        this._insertAfter(record, prevRecord, index);
        this._addToMoves(record, index);
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._addAfter = function (record, prevRecord, index) {
        this._insertAfter(record, prevRecord, index);
        if (this._additionsTail === null) {
            // TODO(vicb):
            // assert(this._additionsHead === null);
            this._additionsTail = this._additionsHead = record;
        }
        else {
            // TODO(vicb):
            // assert(_additionsTail._nextAdded === null);
            // assert(record._nextAdded === null);
            this._additionsTail = this._additionsTail._nextAdded = record;
        }
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._insertAfter = function (record, prevRecord, index) {
        // TODO(vicb):
        // assert(record != prevRecord);
        // assert(record._next === null);
        // assert(record._prev === null);
        var next = prevRecord === null ? this._itHead : prevRecord._next;
        // TODO(vicb):
        // assert(next != record);
        // assert(prevRecord != record);
        record._next = next;
        record._prev = prevRecord;
        if (next === null) {
            this._itTail = record;
        }
        else {
            next._prev = record;
        }
        if (prevRecord === null) {
            this._itHead = record;
        }
        else {
            prevRecord._next = record;
        }
        if (this._linkedRecords === null) {
            this._linkedRecords = new _DuplicateMap();
        }
        this._linkedRecords.put(record);
        record.currentIndex = index;
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._remove = function (record) {
        return this._addToRemovals(this._unlink(record));
    };
    /** @internal */
    DefaultIterableDiffer.prototype._unlink = function (record) {
        if (this._linkedRecords !== null) {
            this._linkedRecords.remove(record);
        }
        var prev = record._prev;
        var next = record._next;
        // TODO(vicb):
        // assert((record._prev = null) === null);
        // assert((record._next = null) === null);
        if (prev === null) {
            this._itHead = next;
        }
        else {
            prev._next = next;
        }
        if (next === null) {
            this._itTail = prev;
        }
        else {
            next._prev = prev;
        }
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._addToMoves = function (record, toIndex) {
        // TODO(vicb):
        // assert(record._nextMoved === null);
        if (record.previousIndex === toIndex) {
            return record;
        }
        if (this._movesTail === null) {
            // TODO(vicb):
            // assert(_movesHead === null);
            this._movesTail = this._movesHead = record;
        }
        else {
            // TODO(vicb):
            // assert(_movesTail._nextMoved === null);
            this._movesTail = this._movesTail._nextMoved = record;
        }
        return record;
    };
    DefaultIterableDiffer.prototype._addToRemovals = function (record) {
        if (this._unlinkedRecords === null) {
            this._unlinkedRecords = new _DuplicateMap();
        }
        this._unlinkedRecords.put(record);
        record.currentIndex = null;
        record._nextRemoved = null;
        if (this._removalsTail === null) {
            // TODO(vicb):
            // assert(_removalsHead === null);
            this._removalsTail = this._removalsHead = record;
            record._prevRemoved = null;
        }
        else {
            // TODO(vicb):
            // assert(_removalsTail._nextRemoved === null);
            // assert(record._nextRemoved === null);
            record._prevRemoved = this._removalsTail;
            this._removalsTail = this._removalsTail._nextRemoved = record;
        }
        return record;
    };
    /** @internal */
    DefaultIterableDiffer.prototype._addIdentityChange = function (record, item) {
        record.item = item;
        if (this._identityChangesTail === null) {
            this._identityChangesTail = this._identityChangesHead = record;
        }
        else {
            this._identityChangesTail = this._identityChangesTail._nextIdentityChange = record;
        }
        return record;
    };
    return DefaultIterableDiffer;
}());
var IterableChangeRecord_ = /*@__PURE__*/ (function () {
    function IterableChangeRecord_(item, trackById) {
        this.item = item;
        this.trackById = trackById;
        this.currentIndex = null;
        this.previousIndex = null;
        /** @internal */
        this._nextPrevious = null;
        /** @internal */
        this._prev = null;
        /** @internal */
        this._next = null;
        /** @internal */
        this._prevDup = null;
        /** @internal */
        this._nextDup = null;
        /** @internal */
        this._prevRemoved = null;
        /** @internal */
        this._nextRemoved = null;
        /** @internal */
        this._nextAdded = null;
        /** @internal */
        this._nextMoved = null;
        /** @internal */
        this._nextIdentityChange = null;
    }
    return IterableChangeRecord_;
}());
// A linked list of CollectionChangeRecords with the same IterableChangeRecord_.item
var _DuplicateItemRecordList = /*@__PURE__*/ (function () {
    function _DuplicateItemRecordList() {
        /** @internal */
        this._head = null;
        /** @internal */
        this._tail = null;
    }
    /**
     * Append the record to the list of duplicates.
     *
     * Note: by design all records in the list of duplicates hold the same value in record.item.
     */
    _DuplicateItemRecordList.prototype.add = function (record) {
        if (this._head === null) {
            this._head = this._tail = record;
            record._nextDup = null;
            record._prevDup = null;
        }
        else {
            // TODO(vicb):
            // assert(record.item ==  _head.item ||
            //       record.item is num && record.item.isNaN && _head.item is num && _head.item.isNaN);
            this._tail._nextDup = record;
            record._prevDup = this._tail;
            record._nextDup = null;
            this._tail = record;
        }
    };
    // Returns a IterableChangeRecord_ having IterableChangeRecord_.trackById == trackById and
    // IterableChangeRecord_.currentIndex >= atOrAfterIndex
    _DuplicateItemRecordList.prototype.get = function (trackById, atOrAfterIndex) {
        var record;
        for (record = this._head; record !== null; record = record._nextDup) {
            if ((atOrAfterIndex === null || atOrAfterIndex <= record.currentIndex) &&
                looseIdentical(record.trackById, trackById)) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove one {@link IterableChangeRecord_} from the list of duplicates.
     *
     * Returns whether the list of duplicates is empty.
     */
    _DuplicateItemRecordList.prototype.remove = function (record) {
        // TODO(vicb):
        // assert(() {
        //  // verify that the record being removed is in the list.
        //  for (IterableChangeRecord_ cursor = _head; cursor != null; cursor = cursor._nextDup) {
        //    if (identical(cursor, record)) return true;
        //  }
        //  return false;
        //});
        var prev = record._prevDup;
        var next = record._nextDup;
        if (prev === null) {
            this._head = next;
        }
        else {
            prev._nextDup = next;
        }
        if (next === null) {
            this._tail = prev;
        }
        else {
            next._prevDup = prev;
        }
        return this._head === null;
    };
    return _DuplicateItemRecordList;
}());
var _DuplicateMap = /*@__PURE__*/ (function () {
    function _DuplicateMap() {
        this.map = new Map();
    }
    _DuplicateMap.prototype.put = function (record) {
        var key = record.trackById;
        var duplicates = this.map.get(key);
        if (!duplicates) {
            duplicates = new _DuplicateItemRecordList();
            this.map.set(key, duplicates);
        }
        duplicates.add(record);
    };
    /**
     * Retrieve the `value` using key. Because the IterableChangeRecord_ value may be one which we
     * have already iterated over, we use the `atOrAfterIndex` to pretend it is not there.
     *
     * Use case: `[a, b, c, a, a]` if we are at index `3` which is the second `a` then asking if we
     * have any more `a`s needs to return the second `a`.
     */
    _DuplicateMap.prototype.get = function (trackById, atOrAfterIndex) {
        var key = trackById;
        var recordList = this.map.get(key);
        return recordList ? recordList.get(trackById, atOrAfterIndex) : null;
    };
    /**
     * Removes a {@link IterableChangeRecord_} from the list of duplicates.
     *
     * The list of duplicates also is removed from the map if it gets empty.
     */
    _DuplicateMap.prototype.remove = function (record) {
        var key = record.trackById;
        var recordList = this.map.get(key);
        // Remove the list of duplicates when it gets empty
        if (recordList.remove(record)) {
            this.map.delete(key);
        }
        return record;
    };
    Object.defineProperty(_DuplicateMap.prototype, "isEmpty", {
        get: function () { return this.map.size === 0; },
        enumerable: true,
        configurable: true
    });
    _DuplicateMap.prototype.clear = function () { this.map.clear(); };
    return _DuplicateMap;
}());
function getPreviousIndex(item, addRemoveOffset, moveOffsets) {
    var previousIndex = item.previousIndex;
    if (previousIndex === null)
        return previousIndex;
    var moveOffset = 0;
    if (moveOffsets && previousIndex < moveOffsets.length) {
        moveOffset = moveOffsets[previousIndex];
    }
    return previousIndex + addRemoveOffset + moveOffset;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DefaultKeyValueDifferFactory = /*@__PURE__*/ (function () {
    function DefaultKeyValueDifferFactory() {
    }
    DefaultKeyValueDifferFactory.prototype.supports = function (obj) { return obj instanceof Map || isJsObject(obj); };
    DefaultKeyValueDifferFactory.prototype.create = function () { return new DefaultKeyValueDiffer(); };
    return DefaultKeyValueDifferFactory;
}());
var DefaultKeyValueDiffer = /*@__PURE__*/ (function () {
    function DefaultKeyValueDiffer() {
        this._records = new Map();
        this._mapHead = null;
        // _appendAfter is used in the check loop
        this._appendAfter = null;
        this._previousMapHead = null;
        this._changesHead = null;
        this._changesTail = null;
        this._additionsHead = null;
        this._additionsTail = null;
        this._removalsHead = null;
        this._removalsTail = null;
    }
    Object.defineProperty(DefaultKeyValueDiffer.prototype, "isDirty", {
        get: function () {
            return this._additionsHead !== null || this._changesHead !== null ||
                this._removalsHead !== null;
        },
        enumerable: true,
        configurable: true
    });
    DefaultKeyValueDiffer.prototype.forEachItem = function (fn) {
        var record;
        for (record = this._mapHead; record !== null; record = record._next) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.forEachPreviousItem = function (fn) {
        var record;
        for (record = this._previousMapHead; record !== null; record = record._nextPrevious) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.forEachChangedItem = function (fn) {
        var record;
        for (record = this._changesHead; record !== null; record = record._nextChanged) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.forEachAddedItem = function (fn) {
        var record;
        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.forEachRemovedItem = function (fn) {
        var record;
        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
            fn(record);
        }
    };
    DefaultKeyValueDiffer.prototype.diff = function (map) {
        if (!map) {
            map = new Map();
        }
        else if (!(map instanceof Map || isJsObject(map))) {
            throw new Error("Error trying to diff '" + stringify(map) + "'. Only maps and objects are allowed");
        }
        return this.check(map) ? this : null;
    };
    DefaultKeyValueDiffer.prototype.onDestroy = function () { };
    /**
     * Check the current state of the map vs the previous.
     * The algorithm is optimised for when the keys do no change.
     */
    DefaultKeyValueDiffer.prototype.check = function (map) {
        var _this = this;
        this._reset();
        var insertBefore = this._mapHead;
        this._appendAfter = null;
        this._forEach(map, function (value, key) {
            if (insertBefore && insertBefore.key === key) {
                _this._maybeAddToChanges(insertBefore, value);
                _this._appendAfter = insertBefore;
                insertBefore = insertBefore._next;
            }
            else {
                var record = _this._getOrCreateRecordForKey(key, value);
                insertBefore = _this._insertBeforeOrAppend(insertBefore, record);
            }
        });
        // Items remaining at the end of the list have been deleted
        if (insertBefore) {
            if (insertBefore._prev) {
                insertBefore._prev._next = null;
            }
            this._removalsHead = insertBefore;
            for (var record = insertBefore; record !== null; record = record._nextRemoved) {
                if (record === this._mapHead) {
                    this._mapHead = null;
                }
                this._records.delete(record.key);
                record._nextRemoved = record._next;
                record.previousValue = record.currentValue;
                record.currentValue = null;
                record._prev = null;
                record._next = null;
            }
        }
        // Make sure tails have no next records from previous runs
        if (this._changesTail)
            this._changesTail._nextChanged = null;
        if (this._additionsTail)
            this._additionsTail._nextAdded = null;
        return this.isDirty;
    };
    /**
     * Inserts a record before `before` or append at the end of the list when `before` is null.
     *
     * Notes:
     * - This method appends at `this._appendAfter`,
     * - This method updates `this._appendAfter`,
     * - The return value is the new value for the insertion pointer.
     */
    DefaultKeyValueDiffer.prototype._insertBeforeOrAppend = function (before, record) {
        if (before) {
            var prev = before._prev;
            record._next = before;
            record._prev = prev;
            before._prev = record;
            if (prev) {
                prev._next = record;
            }
            if (before === this._mapHead) {
                this._mapHead = record;
            }
            this._appendAfter = before;
            return before;
        }
        if (this._appendAfter) {
            this._appendAfter._next = record;
            record._prev = this._appendAfter;
        }
        else {
            this._mapHead = record;
        }
        this._appendAfter = record;
        return null;
    };
    DefaultKeyValueDiffer.prototype._getOrCreateRecordForKey = function (key, value) {
        if (this._records.has(key)) {
            var record_1 = this._records.get(key);
            this._maybeAddToChanges(record_1, value);
            var prev = record_1._prev;
            var next = record_1._next;
            if (prev) {
                prev._next = next;
            }
            if (next) {
                next._prev = prev;
            }
            record_1._next = null;
            record_1._prev = null;
            return record_1;
        }
        var record = new KeyValueChangeRecord_(key);
        this._records.set(key, record);
        record.currentValue = value;
        this._addToAdditions(record);
        return record;
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._reset = function () {
        if (this.isDirty) {
            var record = void 0;
            // let `_previousMapHead` contain the state of the map before the changes
            this._previousMapHead = this._mapHead;
            for (record = this._previousMapHead; record !== null; record = record._next) {
                record._nextPrevious = record._next;
            }
            // Update `record.previousValue` with the value of the item before the changes
            // We need to update all changed items (that's those which have been added and changed)
            for (record = this._changesHead; record !== null; record = record._nextChanged) {
                record.previousValue = record.currentValue;
            }
            for (record = this._additionsHead; record != null; record = record._nextAdded) {
                record.previousValue = record.currentValue;
            }
            this._changesHead = this._changesTail = null;
            this._additionsHead = this._additionsTail = null;
            this._removalsHead = null;
        }
    };
    // Add the record or a given key to the list of changes only when the value has actually changed
    DefaultKeyValueDiffer.prototype._maybeAddToChanges = function (record, newValue) {
        if (!looseIdentical(newValue, record.currentValue)) {
            record.previousValue = record.currentValue;
            record.currentValue = newValue;
            this._addToChanges(record);
        }
    };
    DefaultKeyValueDiffer.prototype._addToAdditions = function (record) {
        if (this._additionsHead === null) {
            this._additionsHead = this._additionsTail = record;
        }
        else {
            this._additionsTail._nextAdded = record;
            this._additionsTail = record;
        }
    };
    DefaultKeyValueDiffer.prototype._addToChanges = function (record) {
        if (this._changesHead === null) {
            this._changesHead = this._changesTail = record;
        }
        else {
            this._changesTail._nextChanged = record;
            this._changesTail = record;
        }
    };
    /** @internal */
    DefaultKeyValueDiffer.prototype._forEach = function (obj, fn) {
        if (obj instanceof Map) {
            obj.forEach(fn);
        }
        else {
            Object.keys(obj).forEach(function (k) { return fn(obj[k], k); });
        }
    };
    return DefaultKeyValueDiffer;
}());
var KeyValueChangeRecord_ = /*@__PURE__*/ (function () {
    function KeyValueChangeRecord_(key) {
        this.key = key;
        this.previousValue = null;
        this.currentValue = null;
        /** @internal */
        this._nextPrevious = null;
        /** @internal */
        this._next = null;
        /** @internal */
        this._prev = null;
        /** @internal */
        this._nextAdded = null;
        /** @internal */
        this._nextRemoved = null;
        /** @internal */
        this._nextChanged = null;
    }
    return KeyValueChangeRecord_;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A repository of different iterable diffing strategies used by NgFor, NgClass, and others.
 *
 */
var IterableDiffers = /*@__PURE__*/ (function () {
    function IterableDiffers(factories) {
        this.factories = factories;
    }
    IterableDiffers.create = function (factories, parent) {
        if (parent != null) {
            var copied = parent.factories.slice();
            factories = factories.concat(copied);
        }
        return new IterableDiffers(factories);
    };
    /**
     * Takes an array of {@link IterableDifferFactory} and returns a provider used to extend the
     * inherited {@link IterableDiffers} instance with the provided factories and return a new
     * {@link IterableDiffers} instance.
     *
     * @usageNotes
     * ### Example
     *
     * The following example shows how to extend an existing list of factories,
     * which will only be applied to the injector for this component and its children.
     * This step is all that's required to make a new {@link IterableDiffer} available.
     *
     * ```
     * @Component({
     *   viewProviders: [
     *     IterableDiffers.extend([new ImmutableListDiffer()])
     *   ]
     * })
     * ```
     */
    IterableDiffers.extend = function (factories) {
        return {
            provide: IterableDiffers,
            useFactory: function (parent) {
                if (!parent) {
                    // Typically would occur when calling IterableDiffers.extend inside of dependencies passed
                    // to
                    // bootstrap(), which would override default pipes instead of extending them.
                    throw new Error('Cannot extend IterableDiffers without a parent injector');
                }
                return IterableDiffers.create(factories, parent);
            },
            // Dependency technically isn't optional, but we can provide a better error message this way.
            deps: [[IterableDiffers, new SkipSelf(), new Optional()]]
        };
    };
    IterableDiffers.prototype.find = function (iterable) {
        var factory = this.factories.find(function (f) { return f.supports(iterable); });
        if (factory != null) {
            return factory;
        }
        else {
            throw new Error("Cannot find a differ supporting object '" + iterable + "' of type '" + getTypeNameForDebugging(iterable) + "'");
        }
    };
    IterableDiffers.ngInjectableDef = defineInjectable({
        providedIn: 'root',
        factory: function () { return new IterableDiffers([new DefaultIterableDifferFactory()]); }
    });
    return IterableDiffers;
}());
function getTypeNameForDebugging(type) {
    return type['name'] || typeof type;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A repository of different Map diffing strategies used by NgClass, NgStyle, and others.
 *
 */
var KeyValueDiffers = /*@__PURE__*/ (function () {
    function KeyValueDiffers(factories) {
        this.factories = factories;
    }
    KeyValueDiffers.create = function (factories, parent) {
        if (parent) {
            var copied = parent.factories.slice();
            factories = factories.concat(copied);
        }
        return new KeyValueDiffers(factories);
    };
    /**
     * Takes an array of {@link KeyValueDifferFactory} and returns a provider used to extend the
     * inherited {@link KeyValueDiffers} instance with the provided factories and return a new
     * {@link KeyValueDiffers} instance.
     *
     * @usageNotes
     * ### Example
     *
     * The following example shows how to extend an existing list of factories,
     * which will only be applied to the injector for this component and its children.
     * This step is all that's required to make a new {@link KeyValueDiffer} available.
     *
     * ```
     * @Component({
     *   viewProviders: [
     *     KeyValueDiffers.extend([new ImmutableMapDiffer()])
     *   ]
     * })
     * ```
     */
    KeyValueDiffers.extend = function (factories) {
        return {
            provide: KeyValueDiffers,
            useFactory: function (parent) {
                if (!parent) {
                    // Typically would occur when calling KeyValueDiffers.extend inside of dependencies passed
                    // to bootstrap(), which would override default pipes instead of extending them.
                    throw new Error('Cannot extend KeyValueDiffers without a parent injector');
                }
                return KeyValueDiffers.create(factories, parent);
            },
            // Dependency technically isn't optional, but we can provide a better error message this way.
            deps: [[KeyValueDiffers, new SkipSelf(), new Optional()]]
        };
    };
    KeyValueDiffers.prototype.find = function (kv) {
        var factory = this.factories.find(function (f) { return f.supports(kv); });
        if (factory) {
            return factory;
        }
        throw new Error("Cannot find a differ supporting object '" + kv + "'");
    };
    return KeyValueDiffers;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Structural diffing for `Object`s and `Map`s.
 */
var keyValDiff = [/*@__PURE__*/ new DefaultKeyValueDifferFactory()];
/**
 * Structural diffing for `Iterable` types such as `Array`s.
 */
var iterableDiff = [/*@__PURE__*/ new DefaultIterableDifferFactory()];
var defaultIterableDiffers = /*@__PURE__*/ new IterableDiffers(iterableDiff);
var defaultKeyValueDiffers = /*@__PURE__*/ new KeyValueDiffers(keyValDiff);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _CORE_PLATFORM_PROVIDERS = [
    // Set a default platform name for platforms that don't set it explicitly.
    { provide: PLATFORM_ID, useValue: 'unknown' },
    { provide: PlatformRef, deps: [Injector] },
    { provide: TestabilityRegistry, deps: [] },
    { provide: Console, deps: [] },
];
/**
 * This platform has to be included in any other platform
 *
 * @experimental
 */
var platformCore = /*@__PURE__*/ createPlatformFactory(null, 'core', _CORE_PLATFORM_PROVIDERS);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Provide this token to set the locale of your application.
 * It is used for i18n extraction, by i18n pipes (DatePipe, I18nPluralPipe, CurrencyPipe,
 * DecimalPipe and PercentPipe) and by ICU expressions.
 *
 * See the [i18n guide](guide/i18n#setting-up-locale) for more information.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * import { LOCALE_ID } from '@angular/core';
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { AppModule } from './app/app.module';
 *
 * platformBrowserDynamic().bootstrapModule(AppModule, {
 *   providers: [{provide: LOCALE_ID, useValue: 'en-US' }]
 * });
 * ```
 *
 * @experimental i18n support is experimental.
 */
var LOCALE_ID = /*@__PURE__*/ new InjectionToken('LocaleId');
/**
 * Use this token at bootstrap to provide the content of your translation file (`xtb`,
 * `xlf` or `xlf2`) when you want to translate your application in another language.
 *
 * See the [i18n guide](guide/i18n#merge) for more information.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * import { TRANSLATIONS } from '@angular/core';
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { AppModule } from './app/app.module';
 *
 * // content of your translation file
 * const translations = '....';
 *
 * platformBrowserDynamic().bootstrapModule(AppModule, {
 *   providers: [{provide: TRANSLATIONS, useValue: translations }]
 * });
 * ```
 *
 * @experimental i18n support is experimental.
 */
var TRANSLATIONS = /*@__PURE__*/ new InjectionToken('Translations');
/**
 * Provide this token at bootstrap to set the format of your {@link TRANSLATIONS}: `xtb`,
 * `xlf` or `xlf2`.
 *
 * See the [i18n guide](guide/i18n#merge) for more information.
 *
 * @usageNotes
 * ### Example
 *
 * ```typescript
 * import { TRANSLATIONS_FORMAT } from '@angular/core';
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { AppModule } from './app/app.module';
 *
 * platformBrowserDynamic().bootstrapModule(AppModule, {
 *   providers: [{provide: TRANSLATIONS_FORMAT, useValue: 'xlf' }]
 * });
 * ```
 *
 * @experimental i18n support is experimental.
 */
var TRANSLATIONS_FORMAT = /*@__PURE__*/ new InjectionToken('TranslationsFormat');
/**
 * Use this enum at bootstrap as an option of `bootstrapModule` to define the strategy
 * that the compiler should use in case of missing translations:
 * - Error: throw if you have missing translations.
 * - Warning (default): show a warning in the console and/or shell.
 * - Ignore: do nothing.
 *
 * See the [i18n guide](guide/i18n#missing-translation) for more information.
 *
 * @usageNotes
 * ### Example
 * ```typescript
 * import { MissingTranslationStrategy } from '@angular/core';
 * import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
 * import { AppModule } from './app/app.module';
 *
 * platformBrowserDynamic().bootstrapModule(AppModule, {
 *   missingTranslation: MissingTranslationStrategy.Error
 * });
 * ```
 *
 * @experimental i18n support is experimental.
 */
var MissingTranslationStrategy = /*@__PURE__*/ (function (MissingTranslationStrategy) {
    MissingTranslationStrategy[MissingTranslationStrategy["Error"] = 0] = "Error";
    MissingTranslationStrategy[MissingTranslationStrategy["Warning"] = 1] = "Warning";
    MissingTranslationStrategy[MissingTranslationStrategy["Ignore"] = 2] = "Ignore";
    return MissingTranslationStrategy;
})({});
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function _iterableDiffersFactory() {
    return defaultIterableDiffers;
}
function _keyValueDiffersFactory() {
    return defaultKeyValueDiffers;
}
function _localeFactory(locale) {
    return locale || 'en-US';
}
/**
 * A built-in [dependency injection token](guide/glossary#di-token)
 * that is used to configure the root injector for bootstrapping.
 */
var APPLICATION_MODULE_PROVIDERS = [
    {
        provide: ApplicationRef,
        useClass: ApplicationRef,
        deps: [NgZone, Console, Injector, ErrorHandler, ComponentFactoryResolver, ApplicationInitStatus]
    },
    {
        provide: ApplicationInitStatus,
        useClass: ApplicationInitStatus,
        deps: [[/*@__PURE__*/ new Optional(), APP_INITIALIZER]]
    },
    { provide: Compiler, useClass: Compiler, deps: [] },
    APP_ID_RANDOM_PROVIDER,
    { provide: IterableDiffers, useFactory: _iterableDiffersFactory, deps: [] },
    { provide: KeyValueDiffers, useFactory: _keyValueDiffersFactory, deps: [] },
    {
        provide: LOCALE_ID,
        useFactory: _localeFactory,
        deps: [[/*@__PURE__*/ new Inject(LOCALE_ID), /*@__PURE__*/ new Optional(), /*@__PURE__*/ new SkipSelf()]]
    },
];
/**
 * Configures the root injector for an app with
 * providers of `@angular/core` dependencies that `ApplicationRef` needs
 * to bootstrap components.
 *
 * Re-exported by `BrowserModule`, which is included automatically in the root
 * `AppModule` when you create a new app with the CLI `new` command.
 *
 * @experimental
 */
var ApplicationModule = /*@__PURE__*/ (function () {
    // Inject ApplicationRef to make it eager...
    function ApplicationModule(appRef) {
    }
    return ApplicationModule;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to resolve resource URLs on `@Component` when used with JIT compilation.
 *
 * Example:
 * ```
 * @Component({
 *   selector: 'my-comp',
 *   templateUrl: 'my-comp.html', // This requires asynchronous resolution
 * })
 * class MyComponnent{
 * }
 *
 * // Calling `renderComponent` will fail because `MyComponent`'s `@Compenent.templateUrl`
 * // needs to be resolved because `renderComponent` is synchronous process.
 * // renderComponent(MyComponent);
 *
 * // Calling `resolveComponentResources` will resolve `@Compenent.templateUrl` into
 * // `@Compenent.template`, which would allow `renderComponent` to proceed in synchronous manner.
 * // Use browser's `fetch` function as the default resource resolution strategy.
 * resolveComponentResources(fetch).then(() => {
 *   // After resolution all URLs have been converted into strings.
 *   renderComponent(MyComponent);
 * });
 *
 * ```
 *
 * NOTE: In AOT the resolution happens during compilation, and so there should be no need
 * to call this method outside JIT mode.
 *
 * @param resourceResolver a function which is responsible to returning a `Promise` of the resolved
 * URL. Browser's `fetch` method is a good default implementation.
 */
function resolveComponentResources(resourceResolver) {
    // Store all promises which are fetching the resources.
    var urlFetches = [];
    // Cache so that we don't fetch the same resource more than once.
    var urlMap = new Map();
    function cachedResourceResolve(url) {
        var promise = urlMap.get(url);
        if (!promise) {
            var resp = resourceResolver(url);
            urlMap.set(url, promise = resp.then(unwrapResponse));
            urlFetches.push(promise);
        }
        return promise;
    }
    componentResourceResolutionQueue.forEach(function (component) {
        if (component.templateUrl) {
            cachedResourceResolve(component.templateUrl).then(function (template) {
                component.template = template;
                component.templateUrl = undefined;
            });
        }
        var styleUrls = component.styleUrls;
        var styles = component.styles || (component.styles = []);
        var styleOffset = component.styles.length;
        styleUrls && styleUrls.forEach(function (styleUrl, index) {
            styles.push(''); // pre-allocate array.
            cachedResourceResolve(styleUrl).then(function (style) {
                styles[styleOffset + index] = style;
                styleUrls.splice(styleUrls.indexOf(styleUrl), 1);
                if (styleUrls.length == 0) {
                    component.styleUrls = undefined;
                }
            });
        });
    });
    componentResourceResolutionQueue.clear();
    return Promise.all(urlFetches).then(function () { return null; });
}
var componentResourceResolutionQueue = /*@__PURE__*/ new Set();
function unwrapResponse(response) {
    return typeof response == 'string' ? response : response.text();
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This helper class is used to get hold of an inert tree of DOM elements containing dirty HTML
 * that needs sanitizing.
 * Depending upon browser support we must use one of three strategies for doing this.
 * Support: Safari 10.x -> XHR strategy
 * Support: Firefox -> DomParser strategy
 * Default: InertDocument strategy
 */
var InertBodyHelper = /*@__PURE__*/ (function () {
    function InertBodyHelper(defaultDoc) {
        this.defaultDoc = defaultDoc;
        this.inertDocument = this.defaultDoc.implementation.createHTMLDocument('sanitization-inert');
        this.inertBodyElement = this.inertDocument.body;
        if (this.inertBodyElement == null) {
            // usually there should be only one body element in the document, but IE doesn't have any, so
            // we need to create one.
            var inertHtml = this.inertDocument.createElement('html');
            this.inertDocument.appendChild(inertHtml);
            this.inertBodyElement = this.inertDocument.createElement('body');
            inertHtml.appendChild(this.inertBodyElement);
        }
        this.inertBodyElement.innerHTML = '<svg><g onload="this.parentNode.remove()"></g></svg>';
        if (this.inertBodyElement.querySelector && !this.inertBodyElement.querySelector('svg')) {
            // We just hit the Safari 10.1 bug - which allows JS to run inside the SVG G element
            // so use the XHR strategy.
            this.getInertBodyElement = this.getInertBodyElement_XHR;
            return;
        }
        this.inertBodyElement.innerHTML =
            '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">';
        if (this.inertBodyElement.querySelector && this.inertBodyElement.querySelector('svg img')) {
            // We just hit the Firefox bug - which prevents the inner img JS from being sanitized
            // so use the DOMParser strategy, if it is available.
            // If the DOMParser is not available then we are not in Firefox (Server/WebWorker?) so we
            // fall through to the default strategy below.
            if (isDOMParserAvailable()) {
                this.getInertBodyElement = this.getInertBodyElement_DOMParser;
                return;
            }
        }
        // None of the bugs were hit so it is safe for us to use the default InertDocument strategy
        this.getInertBodyElement = this.getInertBodyElement_InertDocument;
    }
    /**
     * Use XHR to create and fill an inert body element (on Safari 10.1)
     * See
     * https://github.com/cure53/DOMPurify/blob/a992d3a75031cb8bb032e5ea8399ba972bdf9a65/src/purify.js#L439-L449
     */
    InertBodyHelper.prototype.getInertBodyElement_XHR = function (html) {
        // We add these extra elements to ensure that the rest of the content is parsed as expected
        // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the
        // `<head>` tag.
        html = '<body><remove></remove>' + html + '</body>';
        try {
            html = encodeURI(html);
        }
        catch (e) {
            return null;
        }
        var xhr = new XMLHttpRequest();
        xhr.responseType = 'document';
        xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
        xhr.send(null);
        var body = xhr.response.body;
        body.removeChild(body.firstChild);
        return body;
    };
    /**
     * Use DOMParser to create and fill an inert body element (on Firefox)
     * See https://github.com/cure53/DOMPurify/releases/tag/0.6.7
     *
     */
    InertBodyHelper.prototype.getInertBodyElement_DOMParser = function (html) {
        // We add these extra elements to ensure that the rest of the content is parsed as expected
        // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the
        // `<head>` tag.
        html = '<body><remove></remove>' + html + '</body>';
        try {
            var body = new window
                .DOMParser()
                .parseFromString(html, 'text/html')
                .body;
            body.removeChild(body.firstChild);
            return body;
        }
        catch (e) {
            return null;
        }
    };
    /**
     * Use an HTML5 `template` element, if supported, or an inert body element created via
     * `createHtmlDocument` to create and fill an inert DOM element.
     * This is the default sane strategy to use if the browser does not require one of the specialised
     * strategies above.
     */
    InertBodyHelper.prototype.getInertBodyElement_InertDocument = function (html) {
        // Prefer using <template> element if supported.
        var templateEl = this.inertDocument.createElement('template');
        if ('content' in templateEl) {
            templateEl.innerHTML = html;
            return templateEl;
        }
        this.inertBodyElement.innerHTML = html;
        // Support: IE 9-11 only
        // strip custom-namespaced attributes on IE<=11
        if (this.defaultDoc.documentMode) {
            this.stripCustomNsAttrs(this.inertBodyElement);
        }
        return this.inertBodyElement;
    };
    /**
     * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1'
     * attribute to declare ns1 namespace and prefixes the attribute with 'ns1' (e.g.
     * 'ns1:xlink:foo').
     *
     * This is undesirable since we don't want to allow any of these custom attributes. This method
     * strips them all.
     */
    InertBodyHelper.prototype.stripCustomNsAttrs = function (el) {
        var elAttrs = el.attributes;
        // loop backwards so that we can support removals.
        for (var i = elAttrs.length - 1; 0 < i; i--) {
            var attrib = elAttrs.item(i);
            var attrName = attrib.name;
            if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
                el.removeAttribute(attrName);
            }
        }
        var childNode = el.firstChild;
        while (childNode) {
            if (childNode.nodeType === Node.ELEMENT_NODE)
                this.stripCustomNsAttrs(childNode);
            childNode = childNode.nextSibling;
        }
    };
    return InertBodyHelper;
}());
/**
 * We need to determine whether the DOMParser exists in the global context.
 * The try-catch is because, on some browsers, trying to access this property
 * on window can actually throw an error.
 *
 * @suppress {uselessCode}
 */
function isDOMParserAvailable() {
    try {
        return !!window.DOMParser;
    }
    catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A pattern that recognizes a commonly useful subset of URLs that are safe.
 *
 * This regular expression matches a subset of URLs that will not cause script
 * execution if used in URL context within a HTML document. Specifically, this
 * regular expression matches if (comment from here on and regex copied from
 * Soy's EscapingConventions):
 * (1) Either a protocol in a whitelist (http, https, mailto or ftp).
 * (2) or no protocol.  A protocol must be followed by a colon. The below
 *     allows that by allowing colons only after one of the characters [/?#].
 *     A colon after a hash (#) must be in the fragment.
 *     Otherwise, a colon after a (?) must be in a query.
 *     Otherwise, a colon after a single solidus (/) must be in a path.
 *     Otherwise, a colon after a double solidus (//) must be in the authority
 *     (before port).
 *
 * The pattern disallows &, used in HTML entity declarations before
 * one of the characters in [/?#]. This disallows HTML entities used in the
 * protocol name, which should never happen, e.g. "h&#116;tp" for "http".
 * It also disallows HTML entities in the first path part of a relative path,
 * e.g. "foo&lt;bar/baz".  Our existing escaping functions should not produce
 * that. More importantly, it disallows masking of a colon,
 * e.g. "javascript&#58;...".
 *
 * This regular expression was taken from the Closure sanitization library.
 */
var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
/** A pattern that matches safe data URLs. Only matches image, video and audio types. */
var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
function _sanitizeUrl(url) {
    url = String(url);
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN))
        return url;
    if (isDevMode()) {
        console.warn("WARNING: sanitizing unsafe URL value " + url + " (see http://g.co/ng/security#xss)");
    }
    return 'unsafe:' + url;
}
function sanitizeSrcset(srcset) {
    srcset = String(srcset);
    return srcset.split(',').map(function (srcset) { return _sanitizeUrl(srcset.trim()); }).join(', ');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function tagSet(tags) {
    var e_1, _a;
    var res = {};
    try {
        for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(tags.split(',')), _c = _b.next(); !_c.done; _c = _b.next()) {
            var t = _c.value;
            res[t] = true;
        }
    }
    catch (e_1_1) {
        e_1 = { error: e_1_1 };
    }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return))
                _a.call(_b);
        }
        finally {
            if (e_1)
                throw e_1.error;
        }
    }
    return res;
}
function merge$1() {
    var sets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sets[_i] = arguments[_i];
    }
    var e_2, _a;
    var res = {};
    try {
        for (var sets_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(sets), sets_1_1 = sets_1.next(); !sets_1_1.done; sets_1_1 = sets_1.next()) {
            var s = sets_1_1.value;
            for (var v in s) {
                if (s.hasOwnProperty(v))
                    res[v] = true;
            }
        }
    }
    catch (e_2_1) {
        e_2 = { error: e_2_1 };
    }
    finally {
        try {
            if (sets_1_1 && !sets_1_1.done && (_a = sets_1.return))
                _a.call(sets_1);
        }
        finally {
            if (e_2)
                throw e_2.error;
        }
    }
    return res;
}
// Good source of info about elements and attributes
// http://dev.w3.org/html5/spec/Overview.html#semantics
// http://simon.html5.org/html-elements
// Safe Void Elements - HTML5
// http://dev.w3.org/html5/spec/Overview.html#void-elements
var VOID_ELEMENTS = /*@__PURE__*/ tagSet('area,br,col,hr,img,wbr');
// Elements that you can, intentionally, leave open (and which close themselves)
// http://dev.w3.org/html5/spec/Overview.html#optional-tags
var OPTIONAL_END_TAG_BLOCK_ELEMENTS = /*@__PURE__*/ tagSet('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr');
var OPTIONAL_END_TAG_INLINE_ELEMENTS = /*@__PURE__*/ tagSet('rp,rt');
var OPTIONAL_END_TAG_ELEMENTS = /*@__PURE__*/ merge$1(OPTIONAL_END_TAG_INLINE_ELEMENTS, OPTIONAL_END_TAG_BLOCK_ELEMENTS);
// Safe Block Elements - HTML5
var BLOCK_ELEMENTS = /*@__PURE__*/ merge$1(OPTIONAL_END_TAG_BLOCK_ELEMENTS, /*@__PURE__*/ tagSet('address,article,' +
    'aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
    'h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul'));
// Inline Elements - HTML5
var INLINE_ELEMENTS = /*@__PURE__*/ merge$1(OPTIONAL_END_TAG_INLINE_ELEMENTS, /*@__PURE__*/ tagSet('a,abbr,acronym,audio,b,' +
    'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,' +
    'samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video'));
var VALID_ELEMENTS = /*@__PURE__*/ merge$1(VOID_ELEMENTS, BLOCK_ELEMENTS, INLINE_ELEMENTS, OPTIONAL_END_TAG_ELEMENTS);
// Attributes that have href and hence need to be sanitized
var URI_ATTRS = /*@__PURE__*/ tagSet('background,cite,href,itemtype,longdesc,poster,src,xlink:href');
// Attributes that have special href set hence need to be sanitized
var SRCSET_ATTRS = /*@__PURE__*/ tagSet('srcset');
var HTML_ATTRS = /*@__PURE__*/ tagSet('abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,' +
    'compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,' +
    'ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,' +
    'scope,scrolling,shape,size,sizes,span,srclang,start,summary,tabindex,target,title,translate,type,usemap,' +
    'valign,value,vspace,width');
// NB: This currently consciously doesn't support SVG. SVG sanitization has had several security
// issues in the past, so it seems safer to leave it out if possible. If support for binding SVG via
// innerHTML is required, SVG attributes should be added here.
// NB: Sanitization does not allow <form> elements or other active elements (<button> etc). Those
// can be sanitized, but they increase security surface area without a legitimate use case, so they
// are left out here.
var VALID_ATTRS = /*@__PURE__*/ merge$1(URI_ATTRS, SRCSET_ATTRS, HTML_ATTRS);
/**
 * SanitizingHtmlSerializer serializes a DOM fragment, stripping out any unsafe elements and unsafe
 * attributes.
 */
var SanitizingHtmlSerializer = /*@__PURE__*/ (function () {
    function SanitizingHtmlSerializer() {
        // Explicitly track if something was stripped, to avoid accidentally warning of sanitization just
        // because characters were re-encoded.
        this.sanitizedSomething = false;
        this.buf = [];
    }
    SanitizingHtmlSerializer.prototype.sanitizeChildren = function (el) {
        // This cannot use a TreeWalker, as it has to run on Angular's various DOM adapters.
        // However this code never accesses properties off of `document` before deleting its contents
        // again, so it shouldn't be vulnerable to DOM clobbering.
        var current = el.firstChild;
        while (current) {
            if (current.nodeType === Node.ELEMENT_NODE) {
                this.startElement(current);
            }
            else if (current.nodeType === Node.TEXT_NODE) {
                this.chars(current.nodeValue);
            }
            else {
                // Strip non-element, non-text nodes.
                this.sanitizedSomething = true;
            }
            if (current.firstChild) {
                current = current.firstChild;
                continue;
            }
            while (current) {
                // Leaving the element. Walk up and to the right, closing tags as we go.
                if (current.nodeType === Node.ELEMENT_NODE) {
                    this.endElement(current);
                }
                var next = this.checkClobberedElement(current, current.nextSibling);
                if (next) {
                    current = next;
                    break;
                }
                current = this.checkClobberedElement(current, current.parentNode);
            }
        }
        return this.buf.join('');
    };
    SanitizingHtmlSerializer.prototype.startElement = function (element) {
        var tagName = element.nodeName.toLowerCase();
        if (!VALID_ELEMENTS.hasOwnProperty(tagName)) {
            this.sanitizedSomething = true;
            return;
        }
        this.buf.push('<');
        this.buf.push(tagName);
        var elAttrs = element.attributes;
        for (var i = 0; i < elAttrs.length; i++) {
            var elAttr = elAttrs.item(i);
            var attrName = elAttr.name;
            var lower = attrName.toLowerCase();
            if (!VALID_ATTRS.hasOwnProperty(lower)) {
                this.sanitizedSomething = true;
                continue;
            }
            var value = elAttr.value;
            // TODO(martinprobst): Special case image URIs for data:image/...
            if (URI_ATTRS[lower])
                value = _sanitizeUrl(value);
            if (SRCSET_ATTRS[lower])
                value = sanitizeSrcset(value);
            this.buf.push(' ', attrName, '="', encodeEntities(value), '"');
        }
        this.buf.push('>');
    };
    SanitizingHtmlSerializer.prototype.endElement = function (current) {
        var tagName = current.nodeName.toLowerCase();
        if (VALID_ELEMENTS.hasOwnProperty(tagName) && !VOID_ELEMENTS.hasOwnProperty(tagName)) {
            this.buf.push('</');
            this.buf.push(tagName);
            this.buf.push('>');
        }
    };
    SanitizingHtmlSerializer.prototype.chars = function (chars) { this.buf.push(encodeEntities(chars)); };
    SanitizingHtmlSerializer.prototype.checkClobberedElement = function (node, nextNode) {
        if (nextNode &&
            (node.compareDocumentPosition(nextNode) &
                Node.DOCUMENT_POSITION_CONTAINED_BY) === Node.DOCUMENT_POSITION_CONTAINED_BY) {
            throw new Error("Failed to sanitize html because the element is clobbered: " + node.outerHTML);
        }
        return nextNode;
    };
    return SanitizingHtmlSerializer;
}());
// Regular Expressions for parsing tags and attributes
var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
// ! to ~ is the ASCII range.
var NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
/**
 * Escapes all potentially dangerous characters, so that the
 * resulting string can be safely inserted into attribute or
 * element text.
 * @param value
 */
function encodeEntities(value) {
    return value.replace(/&/g, '&amp;')
        .replace(SURROGATE_PAIR_REGEXP, function (match) {
        var hi = match.charCodeAt(0);
        var low = match.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
    })
        .replace(NON_ALPHANUMERIC_REGEXP, function (match) { return '&#' + match.charCodeAt(0) + ';'; })
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
var inertBodyHelper;
/**
 * Sanitizes the given unsafe, untrusted HTML fragment, and returns HTML text that is safe to add to
 * the DOM in a browser environment.
 */
function _sanitizeHtml(defaultDoc, unsafeHtmlInput) {
    var inertBodyElement = null;
    try {
        inertBodyHelper = inertBodyHelper || new InertBodyHelper(defaultDoc);
        // Make sure unsafeHtml is actually a string (TypeScript types are not enforced at runtime).
        var unsafeHtml = unsafeHtmlInput ? String(unsafeHtmlInput) : '';
        inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
        // mXSS protection. Repeatedly parse the document to make sure it stabilizes, so that a browser
        // trying to auto-correct incorrect HTML cannot cause formerly inert HTML to become dangerous.
        var mXSSAttempts = 5;
        var parsedHtml = unsafeHtml;
        do {
            if (mXSSAttempts === 0) {
                throw new Error('Failed to sanitize html because the input is unstable');
            }
            mXSSAttempts--;
            unsafeHtml = parsedHtml;
            parsedHtml = inertBodyElement.innerHTML;
            inertBodyElement = inertBodyHelper.getInertBodyElement(unsafeHtml);
        } while (unsafeHtml !== parsedHtml);
        var sanitizer = new SanitizingHtmlSerializer();
        var safeHtml = sanitizer.sanitizeChildren(getTemplateContent(inertBodyElement) || inertBodyElement);
        if (isDevMode() && sanitizer.sanitizedSomething) {
            console.warn('WARNING: sanitizing HTML stripped some content (see http://g.co/ng/security#xss).');
        }
        return safeHtml;
    }
    finally {
        // In case anything goes wrong, clear out inertElement to reset the entire DOM structure.
        if (inertBodyElement) {
            var parent_1 = getTemplateContent(inertBodyElement) || inertBodyElement;
            while (parent_1.firstChild) {
                parent_1.removeChild(parent_1.firstChild);
            }
        }
    }
}
function getTemplateContent(el) {
    return 'content' in el /** Microsoft/TypeScript#21517 */ && isTemplateElement(el) ?
        el.content :
        null;
}
function isTemplateElement(el) {
    return el.nodeType === Node.ELEMENT_NODE && el.nodeName === 'TEMPLATE';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Regular expression for safe style values.
 *
 * Quotes (" and ') are allowed, but a check must be done elsewhere to ensure they're balanced.
 *
 * ',' allows multiple values to be assigned to the same property (e.g. background-attachment or
 * font-family) and hence could allow multiple values to get injected, but that should pose no risk
 * of XSS.
 *
 * The function expression checks only for XSS safety, not for CSS validity.
 *
 * This regular expression was taken from the Closure sanitization library, and augmented for
 * transformation values.
 */
var VALUES = '[-,."\'%_!# a-zA-Z0-9]+';
var TRANSFORMATION_FNS = '(?:matrix|translate|scale|rotate|skew|perspective)(?:X|Y|3d)?';
var COLOR_FNS = '(?:rgb|hsl)a?';
var GRADIENTS = '(?:repeating-)?(?:linear|radial)-gradient';
var CSS3_FNS = '(?:calc|attr)';
var FN_ARGS = '\\([-0-9.%, #a-zA-Z]+\\)';
var SAFE_STYLE_VALUE = /*@__PURE__*/ new RegExp("^(" + VALUES + "|" +
    ("(?:" + TRANSFORMATION_FNS + "|" + COLOR_FNS + "|" + GRADIENTS + "|" + CSS3_FNS + ")") +
    (FN_ARGS + ")$"), 'g');
/**
 * Matches a `url(...)` value with an arbitrary argument as long as it does
 * not contain parentheses.
 *
 * The URL value still needs to be sanitized separately.
 *
 * `url(...)` values are a very common use case, e.g. for `background-image`. With carefully crafted
 * CSS style rules, it is possible to construct an information leak with `url` values in CSS, e.g.
 * by observing whether scroll bars are displayed, or character ranges used by a font face
 * definition.
 *
 * Angular only allows binding CSS values (as opposed to entire CSS rules), so it is unlikely that
 * binding a URL value without further cooperation from the page will cause an information leak, and
 * if so, it is just a leak, not a full blown XSS vulnerability.
 *
 * Given the common use case, low likelihood of attack vector, and low impact of an attack, this
 * code is permissive and allows URLs that sanitize otherwise.
 */
var URL_RE = /^url\(([^)]+)\)$/;
/**
 * Checks that quotes (" and ') are properly balanced inside a string. Assumes
 * that neither escape (\) nor any other character that could result in
 * breaking out of a string parsing context are allowed;
 * see http://www.w3.org/TR/css3-syntax/#string-token-diagram.
 *
 * This code was taken from the Closure sanitization library.
 */
function hasBalancedQuotes(value) {
    var outsideSingle = true;
    var outsideDouble = true;
    for (var i = 0; i < value.length; i++) {
        var c = value.charAt(i);
        if (c === '\'' && outsideDouble) {
            outsideSingle = !outsideSingle;
        }
        else if (c === '"' && outsideSingle) {
            outsideDouble = !outsideDouble;
        }
    }
    return outsideSingle && outsideDouble;
}
/**
 * Sanitizes the given untrusted CSS style property value (i.e. not an entire object, just a single
 * value) and returns a value that is safe to use in a browser environment.
 */
function _sanitizeStyle(value) {
    value = String(value).trim(); // Make sure it's actually a string.
    if (!value)
        return '';
    // Single url(...) values are supported, but only for URLs that sanitize cleanly. See above for
    // reasoning behind this.
    var urlMatch = value.match(URL_RE);
    if ((urlMatch && _sanitizeUrl(urlMatch[1]) === urlMatch[1]) ||
        value.match(SAFE_STYLE_VALUE) && hasBalancedQuotes(value)) {
        return value; // Safe style values.
    }
    if (isDevMode()) {
        console.warn("WARNING: sanitizing unsafe style value " + value + " (see http://g.co/ng/security#xss).");
    }
    return 'unsafe';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A SecurityContext marks a location that has dangerous security implications, e.g. a DOM property
 * like `innerHTML` that could cause Cross Site Scripting (XSS) security bugs when improperly
 * handled.
 *
 * See DomSanitizer for more details on security in Angular applications.
 *
 *
 */
var SecurityContext = /*@__PURE__*/ (function (SecurityContext) {
    SecurityContext[SecurityContext["NONE"] = 0] = "NONE";
    SecurityContext[SecurityContext["HTML"] = 1] = "HTML";
    SecurityContext[SecurityContext["STYLE"] = 2] = "STYLE";
    SecurityContext[SecurityContext["SCRIPT"] = 3] = "SCRIPT";
    SecurityContext[SecurityContext["URL"] = 4] = "URL";
    SecurityContext[SecurityContext["RESOURCE_URL"] = 5] = "RESOURCE_URL";
    return SecurityContext;
})({});
/**
 * Sanitizer is used by the views to sanitize potentially dangerous values.
 *
 *
 */
var Sanitizer = /*@__PURE__*/ (function () {
    function Sanitizer() {
    }
    return Sanitizer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Called before each cycle of a view's check to detect whether this is in the
// initState for which we need to call ngOnInit, ngAfterContentInit or ngAfterViewInit
// lifecycle methods. Returns true if this check cycle should call lifecycle
// methods.
function shiftInitState(view, priorInitState, newInitState) {
    // Only update the InitState if we are currently in the prior state.
    // For example, only move into CallingInit if we are in BeforeInit. Only
    // move into CallingContentInit if we are in CallingInit. Normally this will
    // always be true because of how checkCycle is called in checkAndUpdateView.
    // However, if checkAndUpdateView is called recursively or if an exception is
    // thrown while checkAndUpdateView is running, checkAndUpdateView starts over
    // from the beginning. This ensures the state is monotonically increasing,
    // terminating in the AfterInit state, which ensures the Init methods are called
    // at least once and only once.
    var state = view.state;
    var initState = state & 1792 /* InitState_Mask */;
    if (initState === priorInitState) {
        view.state = (state & ~1792 /* InitState_Mask */) | newInitState;
        view.initIndex = -1;
        return true;
    }
    return initState === newInitState;
}
// Returns true if the lifecycle init method should be called for the node with
// the given init index.
function shouldCallLifecycleInitHook(view, initState, index) {
    if ((view.state & 1792 /* InitState_Mask */) === initState && view.initIndex <= index) {
        view.initIndex = index + 1;
        return true;
    }
    return false;
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 */
function asTextData(view, index) {
    return view.nodes[index];
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 */
function asElementData(view, index) {
    return view.nodes[index];
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 */
function asProviderData(view, index) {
    return view.nodes[index];
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 */
function asPureExpressionData(view, index) {
    return view.nodes[index];
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 */
function asQueryList(view, index) {
    return view.nodes[index];
}
var DebugContext = /*@__PURE__*/ (function () {
    function DebugContext() {
    }
    return DebugContext;
}());
/**
 * This object is used to prevent cycles in the source files and to have a place where
 * debug mode can hook it. It is lazily filled when `isDevMode` is known.
 */
var Services = {
    setCurrentNode: undefined,
    createRootView: undefined,
    createEmbeddedView: undefined,
    createComponentView: undefined,
    createNgModuleRef: undefined,
    overrideProvider: undefined,
    overrideComponentView: undefined,
    clearOverrides: undefined,
    checkAndUpdateView: undefined,
    checkNoChangesView: undefined,
    destroyView: undefined,
    resolveDep: undefined,
    createDebugContext: undefined,
    handleEvent: undefined,
    updateDirectives: undefined,
    updateRenderer: undefined,
    dirtyParentQueries: undefined,
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function expressionChangedAfterItHasBeenCheckedError(context, oldValue, currValue, isFirstCheck) {
    var msg = "ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '" + oldValue + "'. Current value: '" + currValue + "'.";
    if (isFirstCheck) {
        msg +=
            " It seems like the view has been created after its parent and its children have been dirty checked." +
                " Has it been created in a change detection hook ?";
    }
    return viewDebugError(msg, context);
}
function viewWrappedDebugError(err, context) {
    if (!(err instanceof Error)) {
        // errors that are not Error instances don't have a stack,
        // so it is ok to wrap them into a new Error object...
        err = new Error(err.toString());
    }
    _addDebugContext(err, context);
    return err;
}
function viewDebugError(msg, context) {
    var err = new Error(msg);
    _addDebugContext(err, context);
    return err;
}
function _addDebugContext(err, context) {
    err[ERROR_DEBUG_CONTEXT] = context;
    err[ERROR_LOGGER] = context.logError.bind(context);
}
function isViewDebugError(err) {
    return !!getDebugContext(err);
}
function viewDestroyedError(action) {
    return new Error("ViewDestroyedError: Attempt to use a destroyed view: " + action);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NOOP = function () { };
var _tokenKeyCache = /*@__PURE__*/ new Map();
function tokenKey(token) {
    var key = _tokenKeyCache.get(token);
    if (!key) {
        key = stringify(token) + '_' + _tokenKeyCache.size;
        _tokenKeyCache.set(token, key);
    }
    return key;
}
function unwrapValue(view, nodeIdx, bindingIdx, value) {
    if (WrappedValue.isWrapped(value)) {
        value = WrappedValue.unwrap(value);
        var globalBindingIdx = view.def.nodes[nodeIdx].bindingIndex + bindingIdx;
        var oldValue = WrappedValue.unwrap(view.oldValues[globalBindingIdx]);
        view.oldValues[globalBindingIdx] = new WrappedValue(oldValue);
    }
    return value;
}
var UNDEFINED_RENDERER_TYPE_ID = '$$undefined';
var EMPTY_RENDERER_TYPE_ID = '$$empty';
// Attention: this function is called as top level function.
// Putting any logic in here will destroy closure tree shaking!
function createRendererType2(values) {
    return {
        id: UNDEFINED_RENDERER_TYPE_ID,
        styles: values.styles,
        encapsulation: values.encapsulation,
        data: values.data
    };
}
var _renderCompCount = 0;
function resolveRendererType2(type) {
    if (type && type.id === UNDEFINED_RENDERER_TYPE_ID) {
        // first time we see this RendererType2. Initialize it...
        var isFilled = ((type.encapsulation != null && type.encapsulation !== ViewEncapsulation.None) ||
            type.styles.length || Object.keys(type.data).length);
        if (isFilled) {
            type.id = "c" + _renderCompCount++;
        }
        else {
            type.id = EMPTY_RENDERER_TYPE_ID;
        }
    }
    if (type && type.id === EMPTY_RENDERER_TYPE_ID) {
        type = null;
    }
    return type || null;
}
function checkBinding(view, def, bindingIdx, value) {
    var oldValues = view.oldValues;
    if ((view.state & 2 /* FirstCheck */) ||
        !looseIdentical(oldValues[def.bindingIndex + bindingIdx], value)) {
        return true;
    }
    return false;
}
function checkAndUpdateBinding(view, def, bindingIdx, value) {
    if (checkBinding(view, def, bindingIdx, value)) {
        view.oldValues[def.bindingIndex + bindingIdx] = value;
        return true;
    }
    return false;
}
function checkBindingNoChanges(view, def, bindingIdx, value) {
    var oldValue = view.oldValues[def.bindingIndex + bindingIdx];
    if ((view.state & 1 /* BeforeFirstCheck */) || !devModeEqual(oldValue, value)) {
        var bindingName = def.bindings[bindingIdx].name;
        throw expressionChangedAfterItHasBeenCheckedError(Services.createDebugContext(view, def.nodeIndex), bindingName + ": " + oldValue, bindingName + ": " + value, (view.state & 1 /* BeforeFirstCheck */) !== 0);
    }
}
function markParentViewsForCheck(view) {
    var currView = view;
    while (currView) {
        if (currView.def.flags & 2 /* OnPush */) {
            currView.state |= 8 /* ChecksEnabled */;
        }
        currView = currView.viewContainerParent || currView.parent;
    }
}
function markParentViewsForCheckProjectedViews(view, endView) {
    var currView = view;
    while (currView && currView !== endView) {
        currView.state |= 64 /* CheckProjectedViews */;
        currView = currView.viewContainerParent || currView.parent;
    }
}
function dispatchEvent(view, nodeIndex, eventName, event) {
    try {
        var nodeDef = view.def.nodes[nodeIndex];
        var startView = nodeDef.flags & 33554432 /* ComponentView */ ?
            asElementData(view, nodeIndex).componentView :
            view;
        markParentViewsForCheck(startView);
        return Services.handleEvent(view, nodeIndex, eventName, event);
    }
    catch (e) {
        // Attention: Don't rethrow, as it would cancel Observable subscriptions!
        view.root.errorHandler.handleError(e);
    }
}
function declaredViewContainer(view) {
    if (view.parent) {
        var parentView = view.parent;
        return asElementData(parentView, view.parentNodeDef.nodeIndex);
    }
    return null;
}
/**
 * for component views, this is the host element.
 * for embedded views, this is the index of the parent node
 * that contains the view container.
 */
function viewParentEl(view) {
    var parentView = view.parent;
    if (parentView) {
        return view.parentNodeDef.parent;
    }
    else {
        return null;
    }
}
function renderNode(view, def) {
    switch (def.flags & 201347067 /* Types */) {
        case 1 /* TypeElement */:
            return asElementData(view, def.nodeIndex).renderElement;
        case 2 /* TypeText */:
            return asTextData(view, def.nodeIndex).renderText;
    }
}
function elementEventFullName(target, name) {
    return target ? target + ":" + name : name;
}
function isComponentView(view) {
    return !!view.parent && !!(view.parentNodeDef.flags & 32768 /* Component */);
}
function isEmbeddedView(view) {
    return !!view.parent && !(view.parentNodeDef.flags & 32768 /* Component */);
}
function filterQueryId(queryId) {
    return 1 << (queryId % 32);
}
function splitMatchedQueriesDsl(matchedQueriesDsl) {
    var matchedQueries = {};
    var matchedQueryIds = 0;
    var references = {};
    if (matchedQueriesDsl) {
        matchedQueriesDsl.forEach(function (_a) {
            var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(_a, 2), queryId = _b[0], valueType = _b[1];
            if (typeof queryId === 'number') {
                matchedQueries[queryId] = valueType;
                matchedQueryIds |= filterQueryId(queryId);
            }
            else {
                references[queryId] = valueType;
            }
        });
    }
    return { matchedQueries: matchedQueries, references: references, matchedQueryIds: matchedQueryIds };
}
function splitDepsDsl(deps, sourceName) {
    return deps.map(function (value) {
        var _a;
        var token;
        var flags;
        if (Array.isArray(value)) {
            _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(value, 2), flags = _a[0], token = _a[1];
        }
        else {
            flags = 0 /* None */;
            token = value;
        }
        if (token && (typeof token === 'function' || typeof token === 'object') && sourceName) {
            Object.defineProperty(token, SOURCE, { value: sourceName, configurable: true });
        }
        return { flags: flags, token: token, tokenKey: tokenKey(token) };
    });
}
function getParentRenderElement(view, renderHost, def) {
    var renderParent = def.renderParent;
    if (renderParent) {
        if ((renderParent.flags & 1 /* TypeElement */) === 0 ||
            (renderParent.flags & 33554432 /* ComponentView */) === 0 ||
            (renderParent.element.componentRendererType &&
                renderParent.element.componentRendererType.encapsulation ===
                    ViewEncapsulation.Native)) {
            // only children of non components, or children of components with native encapsulation should
            // be attached.
            return asElementData(view, def.renderParent.nodeIndex).renderElement;
        }
    }
    else {
        return renderHost;
    }
}
var DEFINITION_CACHE = /*@__PURE__*/ new WeakMap();
function resolveDefinition(factory) {
    var value = DEFINITION_CACHE.get(factory);
    if (!value) {
        value = factory(function () { return NOOP; });
        value.factory = factory;
        DEFINITION_CACHE.set(factory, value);
    }
    return value;
}
function rootRenderNodes(view) {
    var renderNodes = [];
    visitRootRenderNodes(view, 0 /* Collect */, undefined, undefined, renderNodes);
    return renderNodes;
}
function visitRootRenderNodes(view, action, parentNode, nextSibling, target) {
    // We need to re-compute the parent node in case the nodes have been moved around manually
    if (action === 3 /* RemoveChild */) {
        parentNode = view.renderer.parentNode(renderNode(view, view.def.lastRenderRootNode));
    }
    visitSiblingRenderNodes(view, action, 0, view.def.nodes.length - 1, parentNode, nextSibling, target);
}
function visitSiblingRenderNodes(view, action, startIndex, endIndex, parentNode, nextSibling, target) {
    for (var i = startIndex; i <= endIndex; i++) {
        var nodeDef = view.def.nodes[i];
        if (nodeDef.flags & (1 /* TypeElement */ | 2 /* TypeText */ | 8 /* TypeNgContent */)) {
            visitRenderNode(view, nodeDef, action, parentNode, nextSibling, target);
        }
        // jump to next sibling
        i += nodeDef.childCount;
    }
}
function visitProjectedRenderNodes(view, ngContentIndex, action, parentNode, nextSibling, target) {
    var compView = view;
    while (compView && !isComponentView(compView)) {
        compView = compView.parent;
    }
    var hostView = compView.parent;
    var hostElDef = viewParentEl(compView);
    var startIndex = hostElDef.nodeIndex + 1;
    var endIndex = hostElDef.nodeIndex + hostElDef.childCount;
    for (var i = startIndex; i <= endIndex; i++) {
        var nodeDef = hostView.def.nodes[i];
        if (nodeDef.ngContentIndex === ngContentIndex) {
            visitRenderNode(hostView, nodeDef, action, parentNode, nextSibling, target);
        }
        // jump to next sibling
        i += nodeDef.childCount;
    }
    if (!hostView.parent) {
        // a root view
        var projectedNodes = view.root.projectableNodes[ngContentIndex];
        if (projectedNodes) {
            for (var i = 0; i < projectedNodes.length; i++) {
                execRenderNodeAction(view, projectedNodes[i], action, parentNode, nextSibling, target);
            }
        }
    }
}
function visitRenderNode(view, nodeDef, action, parentNode, nextSibling, target) {
    if (nodeDef.flags & 8 /* TypeNgContent */) {
        visitProjectedRenderNodes(view, nodeDef.ngContent.index, action, parentNode, nextSibling, target);
    }
    else {
        var rn = renderNode(view, nodeDef);
        if (action === 3 /* RemoveChild */ && (nodeDef.flags & 33554432 /* ComponentView */) &&
            (nodeDef.bindingFlags & 48 /* CatSyntheticProperty */)) {
            // Note: we might need to do both actions.
            if (nodeDef.bindingFlags & (16 /* SyntheticProperty */)) {
                execRenderNodeAction(view, rn, action, parentNode, nextSibling, target);
            }
            if (nodeDef.bindingFlags & (32 /* SyntheticHostProperty */)) {
                var compView = asElementData(view, nodeDef.nodeIndex).componentView;
                execRenderNodeAction(compView, rn, action, parentNode, nextSibling, target);
            }
        }
        else {
            execRenderNodeAction(view, rn, action, parentNode, nextSibling, target);
        }
        if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
            var embeddedViews = asElementData(view, nodeDef.nodeIndex).viewContainer._embeddedViews;
            for (var k = 0; k < embeddedViews.length; k++) {
                visitRootRenderNodes(embeddedViews[k], action, parentNode, nextSibling, target);
            }
        }
        if (nodeDef.flags & 1 /* TypeElement */ && !nodeDef.element.name) {
            visitSiblingRenderNodes(view, action, nodeDef.nodeIndex + 1, nodeDef.nodeIndex + nodeDef.childCount, parentNode, nextSibling, target);
        }
    }
}
function execRenderNodeAction(view, renderNode, action, parentNode, nextSibling, target) {
    var renderer = view.renderer;
    switch (action) {
        case 1 /* AppendChild */:
            renderer.appendChild(parentNode, renderNode);
            break;
        case 2 /* InsertBefore */:
            renderer.insertBefore(parentNode, renderNode, nextSibling);
            break;
        case 3 /* RemoveChild */:
            renderer.removeChild(parentNode, renderNode);
            break;
        case 0 /* Collect */:
            target.push(renderNode);
            break;
    }
}
var NS_PREFIX_RE = /^:([^:]+):(.+)$/;
function splitNamespace(name) {
    if (name[0] === ':') {
        var match = name.match(NS_PREFIX_RE);
        return [match[1], match[2]];
    }
    return ['', name];
}
function calcBindingFlags(bindings) {
    var flags = 0;
    for (var i = 0; i < bindings.length; i++) {
        flags |= bindings[i].flags;
    }
    return flags;
}
function interpolate(valueCount, constAndInterp) {
    var result = '';
    for (var i = 0; i < valueCount * 2; i = i + 2) {
        result = result + constAndInterp[i] + _toStringWithNull(constAndInterp[i + 1]);
    }
    return result + constAndInterp[valueCount * 2];
}
function inlineInterpolate(valueCount, c0, a1, c1, a2, c2, a3, c3, a4, c4, a5, c5, a6, c6, a7, c7, a8, c8, a9, c9) {
    switch (valueCount) {
        case 1:
            return c0 + _toStringWithNull(a1) + c1;
        case 2:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2;
        case 3:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3;
        case 4:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4;
        case 5:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5;
        case 6:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) + c6;
        case 7:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7;
        case 8:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8;
        case 9:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8 + _toStringWithNull(a9) + c9;
        default:
            throw new Error("Does not support more than 9 expressions");
    }
}
function _toStringWithNull(v) {
    return v != null ? v.toString() : '';
}
var EMPTY_ARRAY$2 = [];
var EMPTY_MAP = {};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function anchorDef(flags, matchedQueriesDsl, ngContentIndex, childCount, handleEvent, templateFactory) {
    flags |= 1 /* TypeElement */;
    var _a = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _a.matchedQueries, references = _a.references, matchedQueryIds = _a.matchedQueryIds;
    var template = templateFactory ? resolveDefinition(templateFactory) : null;
    return {
        // will bet set by the view definition
        nodeIndex: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        flags: flags,
        checkIndex: -1,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references, ngContentIndex: ngContentIndex, childCount: childCount,
        bindings: [],
        bindingFlags: 0,
        outputs: [],
        element: {
            ns: null,
            name: null,
            attrs: null, template: template,
            componentProvider: null,
            componentView: null,
            componentRendererType: null,
            publicProviders: null,
            allProviders: null,
            handleEvent: handleEvent || NOOP
        },
        provider: null,
        text: null,
        query: null,
        ngContent: null
    };
}
function elementDef(checkIndex, flags, matchedQueriesDsl, ngContentIndex, childCount, namespaceAndName, fixedAttrs, bindings, outputs, handleEvent, componentView, componentRendererType) {
    if (fixedAttrs === void 0) {
        fixedAttrs = [];
    }
    var _a;
    if (!handleEvent) {
        handleEvent = NOOP;
    }
    var _b = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _b.matchedQueries, references = _b.references, matchedQueryIds = _b.matchedQueryIds;
    var ns = null;
    var name = null;
    if (namespaceAndName) {
        _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(splitNamespace(namespaceAndName), 2), ns = _a[0], name = _a[1];
    }
    bindings = bindings || [];
    var bindingDefs = new Array(bindings.length);
    for (var i = 0; i < bindings.length; i++) {
        var _c = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(bindings[i], 3), bindingFlags = _c[0], namespaceAndName_1 = _c[1], suffixOrSecurityContext = _c[2];
        var _d = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(splitNamespace(namespaceAndName_1), 2), ns_1 = _d[0], name_1 = _d[1];
        var securityContext = undefined;
        var suffix = undefined;
        switch (bindingFlags & 15 /* Types */) {
            case 4 /* TypeElementStyle */:
                suffix = suffixOrSecurityContext;
                break;
            case 1 /* TypeElementAttribute */:
            case 8 /* TypeProperty */:
                securityContext = suffixOrSecurityContext;
                break;
        }
        bindingDefs[i] =
            { flags: bindingFlags, ns: ns_1, name: name_1, nonMinifiedName: name_1, securityContext: securityContext, suffix: suffix };
    }
    outputs = outputs || [];
    var outputDefs = new Array(outputs.length);
    for (var i = 0; i < outputs.length; i++) {
        var _e = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(outputs[i], 2), target = _e[0], eventName = _e[1];
        outputDefs[i] = {
            type: 0 /* ElementOutput */,
            target: target, eventName: eventName,
            propName: null
        };
    }
    fixedAttrs = fixedAttrs || [];
    var attrs = fixedAttrs.map(function (_a) {
        var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(_a, 2), namespaceAndName = _b[0], value = _b[1];
        var _c = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(splitNamespace(namespaceAndName), 2), ns = _c[0], name = _c[1];
        return [ns, name, value];
    });
    componentRendererType = resolveRendererType2(componentRendererType);
    if (componentView) {
        flags |= 33554432 /* ComponentView */;
    }
    flags |= 1 /* TypeElement */;
    return {
        // will bet set by the view definition
        nodeIndex: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        checkIndex: checkIndex,
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references, ngContentIndex: ngContentIndex, childCount: childCount,
        bindings: bindingDefs,
        bindingFlags: calcBindingFlags(bindingDefs),
        outputs: outputDefs,
        element: {
            ns: ns,
            name: name,
            attrs: attrs,
            template: null,
            // will bet set by the view definition
            componentProvider: null,
            componentView: componentView || null,
            componentRendererType: componentRendererType,
            publicProviders: null,
            allProviders: null,
            handleEvent: handleEvent || NOOP,
        },
        provider: null,
        text: null,
        query: null,
        ngContent: null
    };
}
function createElement(view, renderHost, def) {
    var elDef = def.element;
    var rootSelectorOrNode = view.root.selectorOrNode;
    var renderer = view.renderer;
    var el;
    if (view.parent || !rootSelectorOrNode) {
        if (elDef.name) {
            el = renderer.createElement(elDef.name, elDef.ns);
        }
        else {
            el = renderer.createComment('');
        }
        var parentEl = getParentRenderElement(view, renderHost, def);
        if (parentEl) {
            renderer.appendChild(parentEl, el);
        }
    }
    else {
        el = renderer.selectRootElement(rootSelectorOrNode);
    }
    if (elDef.attrs) {
        for (var i = 0; i < elDef.attrs.length; i++) {
            var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(elDef.attrs[i], 3), ns = _a[0], name_2 = _a[1], value = _a[2];
            renderer.setAttribute(el, name_2, value, ns);
        }
    }
    return el;
}
function listenToElementOutputs(view, compView, def, el) {
    for (var i = 0; i < def.outputs.length; i++) {
        var output = def.outputs[i];
        var handleEventClosure = renderEventHandlerClosure(view, def.nodeIndex, elementEventFullName(output.target, output.eventName));
        var listenTarget = output.target;
        var listenerView = view;
        if (output.target === 'component') {
            listenTarget = null;
            listenerView = compView;
        }
        var disposable = listenerView.renderer.listen(listenTarget || el, output.eventName, handleEventClosure);
        view.disposables[def.outputIndex + i] = disposable;
    }
}
function renderEventHandlerClosure(view, index, eventName) {
    return function (event) { return dispatchEvent(view, index, eventName, event); };
}
function checkAndUpdateElementInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var bindLen = def.bindings.length;
    var changed = false;
    if (bindLen > 0 && checkAndUpdateElementValue(view, def, 0, v0))
        changed = true;
    if (bindLen > 1 && checkAndUpdateElementValue(view, def, 1, v1))
        changed = true;
    if (bindLen > 2 && checkAndUpdateElementValue(view, def, 2, v2))
        changed = true;
    if (bindLen > 3 && checkAndUpdateElementValue(view, def, 3, v3))
        changed = true;
    if (bindLen > 4 && checkAndUpdateElementValue(view, def, 4, v4))
        changed = true;
    if (bindLen > 5 && checkAndUpdateElementValue(view, def, 5, v5))
        changed = true;
    if (bindLen > 6 && checkAndUpdateElementValue(view, def, 6, v6))
        changed = true;
    if (bindLen > 7 && checkAndUpdateElementValue(view, def, 7, v7))
        changed = true;
    if (bindLen > 8 && checkAndUpdateElementValue(view, def, 8, v8))
        changed = true;
    if (bindLen > 9 && checkAndUpdateElementValue(view, def, 9, v9))
        changed = true;
    return changed;
}
function checkAndUpdateElementDynamic(view, def, values) {
    var changed = false;
    for (var i = 0; i < values.length; i++) {
        if (checkAndUpdateElementValue(view, def, i, values[i]))
            changed = true;
    }
    return changed;
}
function checkAndUpdateElementValue(view, def, bindingIdx, value) {
    if (!checkAndUpdateBinding(view, def, bindingIdx, value)) {
        return false;
    }
    var binding = def.bindings[bindingIdx];
    var elData = asElementData(view, def.nodeIndex);
    var renderNode$$1 = elData.renderElement;
    var name = binding.name;
    switch (binding.flags & 15 /* Types */) {
        case 1 /* TypeElementAttribute */:
            setElementAttribute(view, binding, renderNode$$1, binding.ns, name, value);
            break;
        case 2 /* TypeElementClass */:
            setElementClass(view, renderNode$$1, name, value);
            break;
        case 4 /* TypeElementStyle */:
            setElementStyle(view, binding, renderNode$$1, name, value);
            break;
        case 8 /* TypeProperty */:
            var bindView = (def.flags & 33554432 /* ComponentView */ &&
                binding.flags & 32 /* SyntheticHostProperty */) ?
                elData.componentView :
                view;
            setElementProperty(bindView, binding, renderNode$$1, name, value);
            break;
    }
    return true;
}
function setElementAttribute(view, binding, renderNode$$1, ns, name, value) {
    var securityContext = binding.securityContext;
    var renderValue = securityContext ? view.root.sanitizer.sanitize(securityContext, value) : value;
    renderValue = renderValue != null ? renderValue.toString() : null;
    var renderer = view.renderer;
    if (value != null) {
        renderer.setAttribute(renderNode$$1, name, renderValue, ns);
    }
    else {
        renderer.removeAttribute(renderNode$$1, name, ns);
    }
}
function setElementClass(view, renderNode$$1, name, value) {
    var renderer = view.renderer;
    if (value) {
        renderer.addClass(renderNode$$1, name);
    }
    else {
        renderer.removeClass(renderNode$$1, name);
    }
}
function setElementStyle(view, binding, renderNode$$1, name, value) {
    var renderValue = view.root.sanitizer.sanitize(SecurityContext.STYLE, value);
    if (renderValue != null) {
        renderValue = renderValue.toString();
        var unit = binding.suffix;
        if (unit != null) {
            renderValue = renderValue + unit;
        }
    }
    else {
        renderValue = null;
    }
    var renderer = view.renderer;
    if (renderValue != null) {
        renderer.setStyle(renderNode$$1, name, renderValue);
    }
    else {
        renderer.removeStyle(renderNode$$1, name);
    }
}
function setElementProperty(view, binding, renderNode$$1, name, value) {
    var securityContext = binding.securityContext;
    var renderValue = securityContext ? view.root.sanitizer.sanitize(securityContext, value) : value;
    view.renderer.setProperty(renderNode$$1, name, renderValue);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var UNDEFINED_VALUE = /*@__PURE__*/ new Object();
var InjectorRefTokenKey = /*@__PURE__*/ tokenKey(Injector);
var INJECTORRefTokenKey = /*@__PURE__*/ tokenKey(INJECTOR);
var NgModuleRefTokenKey = /*@__PURE__*/ tokenKey(NgModuleRef);
function moduleProvideDef(flags, token, value, deps) {
    // Need to resolve forwardRefs as e.g. for `useValue` we
    // lowered the expression and then stopped evaluating it,
    // i.e. also didn't unwrap it.
    value = resolveForwardRef(value);
    var depDefs = splitDepsDsl(deps, stringify(token));
    return {
        // will bet set by the module definition
        index: -1,
        deps: depDefs, flags: flags, token: token, value: value
    };
}
function moduleDef(providers) {
    var providersByKey = {};
    var modules = [];
    var isRoot = false;
    for (var i = 0; i < providers.length; i++) {
        var provider = providers[i];
        if (provider.token === APP_ROOT && provider.value === true) {
            isRoot = true;
        }
        if (provider.flags & 1073741824 /* TypeNgModule */) {
            modules.push(provider.token);
        }
        provider.index = i;
        providersByKey[tokenKey(provider.token)] = provider;
    }
    return {
        // Will be filled later...
        factory: null,
        providersByKey: providersByKey,
        providers: providers,
        modules: modules,
        isRoot: isRoot,
    };
}
function initNgModule(data) {
    var def = data._def;
    var providers = data._providers = new Array(def.providers.length);
    for (var i = 0; i < def.providers.length; i++) {
        var provDef = def.providers[i];
        if (!(provDef.flags & 4096 /* LazyProvider */)) {
            // Make sure the provider has not been already initialized outside this loop.
            if (providers[i] === undefined) {
                providers[i] = _createProviderInstance(data, provDef);
            }
        }
    }
}
function resolveNgModuleDep(data, depDef, notFoundValue) {
    if (notFoundValue === void 0) {
        notFoundValue = Injector.THROW_IF_NOT_FOUND;
    }
    var former = setCurrentInjector(data);
    try {
        if (depDef.flags & 8 /* Value */) {
            return depDef.token;
        }
        if (depDef.flags & 2 /* Optional */) {
            notFoundValue = null;
        }
        if (depDef.flags & 1 /* SkipSelf */) {
            return data._parent.get(depDef.token, notFoundValue);
        }
        var tokenKey_1 = depDef.tokenKey;
        switch (tokenKey_1) {
            case InjectorRefTokenKey:
            case INJECTORRefTokenKey:
            case NgModuleRefTokenKey:
                return data;
        }
        var providerDef = data._def.providersByKey[tokenKey_1];
        if (providerDef) {
            var providerInstance = data._providers[providerDef.index];
            if (providerInstance === undefined) {
                providerInstance = data._providers[providerDef.index] =
                    _createProviderInstance(data, providerDef);
            }
            return providerInstance === UNDEFINED_VALUE ? undefined : providerInstance;
        }
        else if (depDef.token.ngInjectableDef && targetsModule(data, depDef.token.ngInjectableDef)) {
            var injectableDef = depDef.token.ngInjectableDef;
            var index = data._providers.length;
            data._def.providersByKey[depDef.tokenKey] = {
                flags: 1024 /* TypeFactoryProvider */ | 4096 /* LazyProvider */,
                value: injectableDef.factory,
                deps: [], index: index,
                token: depDef.token,
            };
            data._providers[index] = UNDEFINED_VALUE;
            return (data._providers[index] =
                _createProviderInstance(data, data._def.providersByKey[depDef.tokenKey]));
        }
        else if (depDef.flags & 4 /* Self */) {
            return notFoundValue;
        }
        return data._parent.get(depDef.token, notFoundValue);
    }
    finally {
        setCurrentInjector(former);
    }
}
function moduleTransitivelyPresent(ngModule, scope) {
    return ngModule._def.modules.indexOf(scope) > -1;
}
function targetsModule(ngModule, def) {
    return def.providedIn != null && (moduleTransitivelyPresent(ngModule, def.providedIn) ||
        def.providedIn === 'root' && ngModule._def.isRoot);
}
function _createProviderInstance(ngModule, providerDef) {
    var injectable;
    switch (providerDef.flags & 201347067 /* Types */) {
        case 512 /* TypeClassProvider */:
            injectable = _createClass(ngModule, providerDef.value, providerDef.deps);
            break;
        case 1024 /* TypeFactoryProvider */:
            injectable = _callFactory(ngModule, providerDef.value, providerDef.deps);
            break;
        case 2048 /* TypeUseExistingProvider */:
            injectable = resolveNgModuleDep(ngModule, providerDef.deps[0]);
            break;
        case 256 /* TypeValueProvider */:
            injectable = providerDef.value;
            break;
    }
    // The read of `ngOnDestroy` here is slightly expensive as it's megamorphic, so it should be
    // avoided if possible. The sequence of checks here determines whether ngOnDestroy needs to be
    // checked. It might not if the `injectable` isn't an object or if NodeFlags.OnDestroy is already
    // set (ngOnDestroy was detected statically).
    if (injectable !== UNDEFINED_VALUE && injectable != null && typeof injectable === 'object' &&
        !(providerDef.flags & 131072 /* OnDestroy */) && typeof injectable.ngOnDestroy === 'function') {
        providerDef.flags |= 131072 /* OnDestroy */;
    }
    return injectable === undefined ? UNDEFINED_VALUE : injectable;
}
function _createClass(ngModule, ctor, deps) {
    var len = deps.length;
    switch (len) {
        case 0:
            return new ctor();
        case 1:
            return new ctor(resolveNgModuleDep(ngModule, deps[0]));
        case 2:
            return new ctor(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]));
        case 3:
            return new ctor(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]), resolveNgModuleDep(ngModule, deps[2]));
        default:
            var depValues = new Array(len);
            for (var i = 0; i < len; i++) {
                depValues[i] = resolveNgModuleDep(ngModule, deps[i]);
            }
            return new (ctor.bind.apply(ctor, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], depValues)))();
    }
}
function _callFactory(ngModule, factory, deps) {
    var len = deps.length;
    switch (len) {
        case 0:
            return factory();
        case 1:
            return factory(resolveNgModuleDep(ngModule, deps[0]));
        case 2:
            return factory(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]));
        case 3:
            return factory(resolveNgModuleDep(ngModule, deps[0]), resolveNgModuleDep(ngModule, deps[1]), resolveNgModuleDep(ngModule, deps[2]));
        default:
            var depValues = Array(len);
            for (var i = 0; i < len; i++) {
                depValues[i] = resolveNgModuleDep(ngModule, deps[i]);
            }
            return factory.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(depValues));
    }
}
function callNgModuleLifecycle(ngModule, lifecycles) {
    var def = ngModule._def;
    var destroyed = new Set();
    for (var i = 0; i < def.providers.length; i++) {
        var provDef = def.providers[i];
        if (provDef.flags & 131072 /* OnDestroy */) {
            var instance = ngModule._providers[i];
            if (instance && instance !== UNDEFINED_VALUE) {
                var onDestroy = instance.ngOnDestroy;
                if (typeof onDestroy === 'function' && !destroyed.has(instance)) {
                    onDestroy.apply(instance);
                    destroyed.add(instance);
                }
            }
        }
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function attachEmbeddedView(parentView, elementData, viewIndex, view) {
    var embeddedViews = elementData.viewContainer._embeddedViews;
    if (viewIndex === null || viewIndex === undefined) {
        viewIndex = embeddedViews.length;
    }
    view.viewContainerParent = parentView;
    addToArray(embeddedViews, viewIndex, view);
    attachProjectedView(elementData, view);
    Services.dirtyParentQueries(view);
    var prevView = viewIndex > 0 ? embeddedViews[viewIndex - 1] : null;
    renderAttachEmbeddedView(elementData, prevView, view);
}
function attachProjectedView(vcElementData, view) {
    var dvcElementData = declaredViewContainer(view);
    if (!dvcElementData || dvcElementData === vcElementData ||
        view.state & 16 /* IsProjectedView */) {
        return;
    }
    // Note: For performance reasons, we
    // - add a view to template._projectedViews only 1x throughout its lifetime,
    //   and remove it not until the view is destroyed.
    //   (hard, as when a parent view is attached/detached we would need to attach/detach all
    //    nested projected views as well, even across component boundaries).
    // - don't track the insertion order of views in the projected views array
    //   (hard, as when the views of the same template are inserted different view containers)
    view.state |= 16 /* IsProjectedView */;
    var projectedViews = dvcElementData.template._projectedViews;
    if (!projectedViews) {
        projectedViews = dvcElementData.template._projectedViews = [];
    }
    projectedViews.push(view);
    // Note: we are changing the NodeDef here as we cannot calculate
    // the fact whether a template is used for projection during compilation.
    markNodeAsProjectedTemplate(view.parent.def, view.parentNodeDef);
}
function markNodeAsProjectedTemplate(viewDef, nodeDef) {
    if (nodeDef.flags & 4 /* ProjectedTemplate */) {
        return;
    }
    viewDef.nodeFlags |= 4 /* ProjectedTemplate */;
    nodeDef.flags |= 4 /* ProjectedTemplate */;
    var parentNodeDef = nodeDef.parent;
    while (parentNodeDef) {
        parentNodeDef.childFlags |= 4 /* ProjectedTemplate */;
        parentNodeDef = parentNodeDef.parent;
    }
}
function detachEmbeddedView(elementData, viewIndex) {
    var embeddedViews = elementData.viewContainer._embeddedViews;
    if (viewIndex == null || viewIndex >= embeddedViews.length) {
        viewIndex = embeddedViews.length - 1;
    }
    if (viewIndex < 0) {
        return null;
    }
    var view = embeddedViews[viewIndex];
    view.viewContainerParent = null;
    removeFromArray(embeddedViews, viewIndex);
    // See attachProjectedView for why we don't update projectedViews here.
    Services.dirtyParentQueries(view);
    renderDetachView(view);
    return view;
}
function detachProjectedView(view) {
    if (!(view.state & 16 /* IsProjectedView */)) {
        return;
    }
    var dvcElementData = declaredViewContainer(view);
    if (dvcElementData) {
        var projectedViews = dvcElementData.template._projectedViews;
        if (projectedViews) {
            removeFromArray(projectedViews, projectedViews.indexOf(view));
            Services.dirtyParentQueries(view);
        }
    }
}
function moveEmbeddedView(elementData, oldViewIndex, newViewIndex) {
    var embeddedViews = elementData.viewContainer._embeddedViews;
    var view = embeddedViews[oldViewIndex];
    removeFromArray(embeddedViews, oldViewIndex);
    if (newViewIndex == null) {
        newViewIndex = embeddedViews.length;
    }
    addToArray(embeddedViews, newViewIndex, view);
    // Note: Don't need to change projectedViews as the order in there
    // as always invalid...
    Services.dirtyParentQueries(view);
    renderDetachView(view);
    var prevView = newViewIndex > 0 ? embeddedViews[newViewIndex - 1] : null;
    renderAttachEmbeddedView(elementData, prevView, view);
    return view;
}
function renderAttachEmbeddedView(elementData, prevView, view) {
    var prevRenderNode = prevView ? renderNode(prevView, prevView.def.lastRenderRootNode) :
        elementData.renderElement;
    var parentNode = view.renderer.parentNode(prevRenderNode);
    var nextSibling = view.renderer.nextSibling(prevRenderNode);
    // Note: We can't check if `nextSibling` is present, as on WebWorkers it will always be!
    // However, browsers automatically do `appendChild` when there is no `nextSibling`.
    visitRootRenderNodes(view, 2 /* InsertBefore */, parentNode, nextSibling, undefined);
}
function renderDetachView(view) {
    visitRootRenderNodes(view, 3 /* RemoveChild */, null, null, undefined);
}
function addToArray(arr, index, value) {
    // perf: array.push is faster than array.splice!
    if (index >= arr.length) {
        arr.push(value);
    }
    else {
        arr.splice(index, 0, value);
    }
}
function removeFromArray(arr, index) {
    // perf: array.pop is faster than array.splice!
    if (index >= arr.length - 1) {
        arr.pop();
    }
    else {
        arr.splice(index, 1);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EMPTY_CONTEXT = /*@__PURE__*/ new Object();
// Attention: this function is called as top level function.
// Putting any logic in here will destroy closure tree shaking!
function createComponentFactory(selector, componentType, viewDefFactory, inputs, outputs, ngContentSelectors) {
    return new ComponentFactory_(selector, componentType, viewDefFactory, inputs, outputs, ngContentSelectors);
}
function getComponentViewDefinitionFactory(componentFactory) {
    return componentFactory.viewDefFactory;
}
var ComponentFactory_ = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ComponentFactory_, _super);
    function ComponentFactory_(selector, componentType, viewDefFactory, _inputs, _outputs, ngContentSelectors) {
        var _this = 
        // Attention: this ctor is called as top level function.
        // Putting any logic in here will destroy closure tree shaking!
        _super.call(this) || this;
        _this.selector = selector;
        _this.componentType = componentType;
        _this._inputs = _inputs;
        _this._outputs = _outputs;
        _this.ngContentSelectors = ngContentSelectors;
        _this.viewDefFactory = viewDefFactory;
        return _this;
    }
    Object.defineProperty(ComponentFactory_.prototype, "inputs", {
        get: function () {
            var inputsArr = [];
            var inputs = this._inputs;
            for (var propName in inputs) {
                var templateName = inputs[propName];
                inputsArr.push({ propName: propName, templateName: templateName });
            }
            return inputsArr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentFactory_.prototype, "outputs", {
        get: function () {
            var outputsArr = [];
            for (var propName in this._outputs) {
                var templateName = this._outputs[propName];
                outputsArr.push({ propName: propName, templateName: templateName });
            }
            return outputsArr;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a new component.
     */
    ComponentFactory_.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
        if (!ngModule) {
            throw new Error('ngModule should be provided');
        }
        var viewDef = resolveDefinition(this.viewDefFactory);
        var componentNodeIndex = viewDef.nodes[0].element.componentProvider.nodeIndex;
        var view = Services.createRootView(injector, projectableNodes || [], rootSelectorOrNode, viewDef, ngModule, EMPTY_CONTEXT);
        var component = asProviderData(view, componentNodeIndex).instance;
        if (rootSelectorOrNode) {
            view.renderer.setAttribute(asElementData(view, 0).renderElement, 'ng-version', VERSION.full);
        }
        return new ComponentRef_(view, new ViewRef_(view), component);
    };
    return ComponentFactory_;
}(ComponentFactory));
var ComponentRef_ = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ComponentRef_, _super);
    function ComponentRef_(_view, _viewRef, _component) {
        var _this = _super.call(this) || this;
        _this._view = _view;
        _this._viewRef = _viewRef;
        _this._component = _component;
        _this._elDef = _this._view.def.nodes[0];
        _this.hostView = _viewRef;
        _this.changeDetectorRef = _viewRef;
        _this.instance = _component;
        return _this;
    }
    Object.defineProperty(ComponentRef_.prototype, "location", {
        get: function () {
            return new ElementRef(asElementData(this._view, this._elDef.nodeIndex).renderElement);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef_.prototype, "injector", {
        get: function () { return new Injector_(this._view, this._elDef); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef_.prototype, "componentType", {
        get: function () { return this._component.constructor; },
        enumerable: true,
        configurable: true
    });
    ComponentRef_.prototype.destroy = function () { this._viewRef.destroy(); };
    ComponentRef_.prototype.onDestroy = function (callback) { this._viewRef.onDestroy(callback); };
    return ComponentRef_;
}(ComponentRef));
function createViewContainerData(view, elDef, elData) {
    return new ViewContainerRef_(view, elDef, elData);
}
var ViewContainerRef_ = /*@__PURE__*/ (function () {
    function ViewContainerRef_(_view, _elDef, _data) {
        this._view = _view;
        this._elDef = _elDef;
        this._data = _data;
        /**
         * @internal
         */
        this._embeddedViews = [];
    }
    Object.defineProperty(ViewContainerRef_.prototype, "element", {
        get: function () { return new ElementRef(this._data.renderElement); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef_.prototype, "injector", {
        get: function () { return new Injector_(this._view, this._elDef); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef_.prototype, "parentInjector", {
        get: function () {
            var view = this._view;
            var elDef = this._elDef.parent;
            while (!elDef && view) {
                elDef = viewParentEl(view);
                view = view.parent;
            }
            return view ? new Injector_(view, elDef) : new Injector_(this._view, null);
        },
        enumerable: true,
        configurable: true
    });
    ViewContainerRef_.prototype.clear = function () {
        var len = this._embeddedViews.length;
        for (var i = len - 1; i >= 0; i--) {
            var view = detachEmbeddedView(this._data, i);
            Services.destroyView(view);
        }
    };
    ViewContainerRef_.prototype.get = function (index) {
        var view = this._embeddedViews[index];
        if (view) {
            var ref = new ViewRef_(view);
            ref.attachToViewContainerRef(this);
            return ref;
        }
        return null;
    };
    Object.defineProperty(ViewContainerRef_.prototype, "length", {
        get: function () { return this._embeddedViews.length; },
        enumerable: true,
        configurable: true
    });
    ViewContainerRef_.prototype.createEmbeddedView = function (templateRef, context, index) {
        var viewRef = templateRef.createEmbeddedView(context || {});
        this.insert(viewRef, index);
        return viewRef;
    };
    ViewContainerRef_.prototype.createComponent = function (componentFactory, index, injector, projectableNodes, ngModuleRef) {
        var contextInjector = injector || this.parentInjector;
        if (!ngModuleRef && !(componentFactory instanceof ComponentFactoryBoundToModule)) {
            ngModuleRef = contextInjector.get(NgModuleRef);
        }
        var componentRef = componentFactory.create(contextInjector, projectableNodes, undefined, ngModuleRef);
        this.insert(componentRef.hostView, index);
        return componentRef;
    };
    ViewContainerRef_.prototype.insert = function (viewRef, index) {
        if (viewRef.destroyed) {
            throw new Error('Cannot insert a destroyed View in a ViewContainer!');
        }
        var viewRef_ = viewRef;
        var viewData = viewRef_._view;
        attachEmbeddedView(this._view, this._data, index, viewData);
        viewRef_.attachToViewContainerRef(this);
        return viewRef;
    };
    ViewContainerRef_.prototype.move = function (viewRef, currentIndex) {
        if (viewRef.destroyed) {
            throw new Error('Cannot move a destroyed View in a ViewContainer!');
        }
        var previousIndex = this._embeddedViews.indexOf(viewRef._view);
        moveEmbeddedView(this._data, previousIndex, currentIndex);
        return viewRef;
    };
    ViewContainerRef_.prototype.indexOf = function (viewRef) {
        return this._embeddedViews.indexOf(viewRef._view);
    };
    ViewContainerRef_.prototype.remove = function (index) {
        var viewData = detachEmbeddedView(this._data, index);
        if (viewData) {
            Services.destroyView(viewData);
        }
    };
    ViewContainerRef_.prototype.detach = function (index) {
        var view = detachEmbeddedView(this._data, index);
        return view ? new ViewRef_(view) : null;
    };
    return ViewContainerRef_;
}());
function createChangeDetectorRef(view) {
    return new ViewRef_(view);
}
var ViewRef_ = /*@__PURE__*/ (function () {
    function ViewRef_(_view) {
        this._view = _view;
        this._viewContainerRef = null;
        this._appRef = null;
    }
    Object.defineProperty(ViewRef_.prototype, "rootNodes", {
        get: function () { return rootRenderNodes(this._view); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewRef_.prototype, "context", {
        get: function () { return this._view.context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewRef_.prototype, "destroyed", {
        get: function () { return (this._view.state & 128 /* Destroyed */) !== 0; },
        enumerable: true,
        configurable: true
    });
    ViewRef_.prototype.markForCheck = function () { markParentViewsForCheck(this._view); };
    ViewRef_.prototype.detach = function () { this._view.state &= ~4 /* Attached */; };
    ViewRef_.prototype.detectChanges = function () {
        var fs = this._view.root.rendererFactory;
        if (fs.begin) {
            fs.begin();
        }
        try {
            Services.checkAndUpdateView(this._view);
        }
        finally {
            if (fs.end) {
                fs.end();
            }
        }
    };
    ViewRef_.prototype.checkNoChanges = function () { Services.checkNoChangesView(this._view); };
    ViewRef_.prototype.reattach = function () { this._view.state |= 4 /* Attached */; };
    ViewRef_.prototype.onDestroy = function (callback) {
        if (!this._view.disposables) {
            this._view.disposables = [];
        }
        this._view.disposables.push(callback);
    };
    ViewRef_.prototype.destroy = function () {
        if (this._appRef) {
            this._appRef.detachView(this);
        }
        else if (this._viewContainerRef) {
            this._viewContainerRef.detach(this._viewContainerRef.indexOf(this));
        }
        Services.destroyView(this._view);
    };
    ViewRef_.prototype.detachFromAppRef = function () {
        this._appRef = null;
        renderDetachView(this._view);
        Services.dirtyParentQueries(this._view);
    };
    ViewRef_.prototype.attachToAppRef = function (appRef) {
        if (this._viewContainerRef) {
            throw new Error('This view is already attached to a ViewContainer!');
        }
        this._appRef = appRef;
    };
    ViewRef_.prototype.attachToViewContainerRef = function (vcRef) {
        if (this._appRef) {
            throw new Error('This view is already attached directly to the ApplicationRef!');
        }
        this._viewContainerRef = vcRef;
    };
    return ViewRef_;
}());
function createTemplateData(view, def) {
    return new TemplateRef_(view, def);
}
var TemplateRef_ = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(TemplateRef_, _super);
    function TemplateRef_(_parentView, _def) {
        var _this = _super.call(this) || this;
        _this._parentView = _parentView;
        _this._def = _def;
        return _this;
    }
    TemplateRef_.prototype.createEmbeddedView = function (context) {
        return new ViewRef_(Services.createEmbeddedView(this._parentView, this._def, this._def.element.template, context));
    };
    Object.defineProperty(TemplateRef_.prototype, "elementRef", {
        get: function () {
            return new ElementRef(asElementData(this._parentView, this._def.nodeIndex).renderElement);
        },
        enumerable: true,
        configurable: true
    });
    return TemplateRef_;
}(TemplateRef));
function createInjector$1(view, elDef) {
    return new Injector_(view, elDef);
}
var Injector_ = /*@__PURE__*/ (function () {
    function Injector_(view, elDef) {
        this.view = view;
        this.elDef = elDef;
    }
    Injector_.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) {
            notFoundValue = Injector.THROW_IF_NOT_FOUND;
        }
        var allowPrivateServices = this.elDef ? (this.elDef.flags & 33554432 /* ComponentView */) !== 0 : false;
        return Services.resolveDep(this.view, this.elDef, allowPrivateServices, { flags: 0 /* None */, token: token, tokenKey: tokenKey(token) }, notFoundValue);
    };
    return Injector_;
}());
function nodeValue(view, index) {
    var def = view.def.nodes[index];
    if (def.flags & 1 /* TypeElement */) {
        var elData = asElementData(view, def.nodeIndex);
        return def.element.template ? elData.template : elData.renderElement;
    }
    else if (def.flags & 2 /* TypeText */) {
        return asTextData(view, def.nodeIndex).renderText;
    }
    else if (def.flags & (20224 /* CatProvider */ | 16 /* TypePipe */)) {
        return asProviderData(view, def.nodeIndex).instance;
    }
    throw new Error("Illegal state: read nodeValue for node index " + index);
}
function createRendererV1(view) {
    return new RendererAdapter(view.renderer);
}
var RendererAdapter = /*@__PURE__*/ (function () {
    function RendererAdapter(delegate) {
        this.delegate = delegate;
    }
    RendererAdapter.prototype.selectRootElement = function (selectorOrNode) {
        return this.delegate.selectRootElement(selectorOrNode);
    };
    RendererAdapter.prototype.createElement = function (parent, namespaceAndName) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(splitNamespace(namespaceAndName), 2), ns = _a[0], name = _a[1];
        var el = this.delegate.createElement(name, ns);
        if (parent) {
            this.delegate.appendChild(parent, el);
        }
        return el;
    };
    RendererAdapter.prototype.createViewRoot = function (hostElement) { return hostElement; };
    RendererAdapter.prototype.createTemplateAnchor = function (parentElement) {
        var comment = this.delegate.createComment('');
        if (parentElement) {
            this.delegate.appendChild(parentElement, comment);
        }
        return comment;
    };
    RendererAdapter.prototype.createText = function (parentElement, value) {
        var node = this.delegate.createText(value);
        if (parentElement) {
            this.delegate.appendChild(parentElement, node);
        }
        return node;
    };
    RendererAdapter.prototype.projectNodes = function (parentElement, nodes) {
        for (var i = 0; i < nodes.length; i++) {
            this.delegate.appendChild(parentElement, nodes[i]);
        }
    };
    RendererAdapter.prototype.attachViewAfter = function (node, viewRootNodes) {
        var parentElement = this.delegate.parentNode(node);
        var nextSibling = this.delegate.nextSibling(node);
        for (var i = 0; i < viewRootNodes.length; i++) {
            this.delegate.insertBefore(parentElement, viewRootNodes[i], nextSibling);
        }
    };
    RendererAdapter.prototype.detachView = function (viewRootNodes) {
        for (var i = 0; i < viewRootNodes.length; i++) {
            var node = viewRootNodes[i];
            var parentElement = this.delegate.parentNode(node);
            this.delegate.removeChild(parentElement, node);
        }
    };
    RendererAdapter.prototype.destroyView = function (hostElement, viewAllNodes) {
        for (var i = 0; i < viewAllNodes.length; i++) {
            this.delegate.destroyNode(viewAllNodes[i]);
        }
    };
    RendererAdapter.prototype.listen = function (renderElement, name, callback) {
        return this.delegate.listen(renderElement, name, callback);
    };
    RendererAdapter.prototype.listenGlobal = function (target, name, callback) {
        return this.delegate.listen(target, name, callback);
    };
    RendererAdapter.prototype.setElementProperty = function (renderElement, propertyName, propertyValue) {
        this.delegate.setProperty(renderElement, propertyName, propertyValue);
    };
    RendererAdapter.prototype.setElementAttribute = function (renderElement, namespaceAndName, attributeValue) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(splitNamespace(namespaceAndName), 2), ns = _a[0], name = _a[1];
        if (attributeValue != null) {
            this.delegate.setAttribute(renderElement, name, attributeValue, ns);
        }
        else {
            this.delegate.removeAttribute(renderElement, name, ns);
        }
    };
    RendererAdapter.prototype.setBindingDebugInfo = function (renderElement, propertyName, propertyValue) { };
    RendererAdapter.prototype.setElementClass = function (renderElement, className, isAdd) {
        if (isAdd) {
            this.delegate.addClass(renderElement, className);
        }
        else {
            this.delegate.removeClass(renderElement, className);
        }
    };
    RendererAdapter.prototype.setElementStyle = function (renderElement, styleName, styleValue) {
        if (styleValue != null) {
            this.delegate.setStyle(renderElement, styleName, styleValue);
        }
        else {
            this.delegate.removeStyle(renderElement, styleName);
        }
    };
    RendererAdapter.prototype.invokeElementMethod = function (renderElement, methodName, args) {
        renderElement[methodName].apply(renderElement, args);
    };
    RendererAdapter.prototype.setText = function (renderNode$$1, text) { this.delegate.setValue(renderNode$$1, text); };
    RendererAdapter.prototype.animate = function () { throw new Error('Renderer.animate is no longer supported!'); };
    return RendererAdapter;
}());
function createNgModuleRef(moduleType, parent, bootstrapComponents, def) {
    return new NgModuleRef_(moduleType, parent, bootstrapComponents, def);
}
var NgModuleRef_ = /*@__PURE__*/ (function () {
    function NgModuleRef_(_moduleType, _parent, _bootstrapComponents, _def) {
        this._moduleType = _moduleType;
        this._parent = _parent;
        this._bootstrapComponents = _bootstrapComponents;
        this._def = _def;
        this._destroyListeners = [];
        this._destroyed = false;
        this.injector = this;
        initNgModule(this);
    }
    NgModuleRef_.prototype.get = function (token, notFoundValue, injectFlags) {
        if (notFoundValue === void 0) {
            notFoundValue = Injector.THROW_IF_NOT_FOUND;
        }
        if (injectFlags === void 0) {
            injectFlags = 0 /* Default */;
        }
        var flags = 0 /* None */;
        if (injectFlags & 4 /* SkipSelf */) {
            flags |= 1 /* SkipSelf */;
        }
        else if (injectFlags & 2 /* Self */) {
            flags |= 4 /* Self */;
        }
        return resolveNgModuleDep(this, { token: token, tokenKey: tokenKey(token), flags: flags }, notFoundValue);
    };
    Object.defineProperty(NgModuleRef_.prototype, "instance", {
        get: function () { return this.get(this._moduleType); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModuleRef_.prototype, "componentFactoryResolver", {
        get: function () { return this.get(ComponentFactoryResolver); },
        enumerable: true,
        configurable: true
    });
    NgModuleRef_.prototype.destroy = function () {
        if (this._destroyed) {
            throw new Error("The ng module " + stringify(this.instance.constructor) + " has already been destroyed.");
        }
        this._destroyed = true;
        callNgModuleLifecycle(this, 131072 /* OnDestroy */);
        this._destroyListeners.forEach(function (listener) { return listener(); });
    };
    NgModuleRef_.prototype.onDestroy = function (callback) { this._destroyListeners.push(callback); };
    return NgModuleRef_;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RendererV1TokenKey = /*@__PURE__*/ tokenKey(Renderer);
var Renderer2TokenKey = /*@__PURE__*/ tokenKey(Renderer2);
var ElementRefTokenKey = /*@__PURE__*/ tokenKey(ElementRef);
var ViewContainerRefTokenKey = /*@__PURE__*/ tokenKey(ViewContainerRef);
var TemplateRefTokenKey = /*@__PURE__*/ tokenKey(TemplateRef);
var ChangeDetectorRefTokenKey = /*@__PURE__*/ tokenKey(ChangeDetectorRef);
var InjectorRefTokenKey$1 = /*@__PURE__*/ tokenKey(Injector);
var INJECTORRefTokenKey$1 = /*@__PURE__*/ tokenKey(INJECTOR);
function directiveDef(checkIndex, flags, matchedQueries, childCount, ctor, deps, props, outputs) {
    var bindings = [];
    if (props) {
        for (var prop in props) {
            var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(props[prop], 2), bindingIndex = _a[0], nonMinifiedName = _a[1];
            bindings[bindingIndex] = {
                flags: 8 /* TypeProperty */,
                name: prop, nonMinifiedName: nonMinifiedName,
                ns: null,
                securityContext: null,
                suffix: null
            };
        }
    }
    var outputDefs = [];
    if (outputs) {
        for (var propName in outputs) {
            outputDefs.push({ type: 1 /* DirectiveOutput */, propName: propName, target: null, eventName: outputs[propName] });
        }
    }
    flags |= 16384 /* TypeDirective */;
    return _def(checkIndex, flags, matchedQueries, childCount, ctor, ctor, deps, bindings, outputDefs);
}
function pipeDef(flags, ctor, deps) {
    flags |= 16 /* TypePipe */;
    return _def(-1, flags, null, 0, ctor, ctor, deps);
}
function providerDef(flags, matchedQueries, token, value, deps) {
    return _def(-1, flags, matchedQueries, 0, token, value, deps);
}
function _def(checkIndex, flags, matchedQueriesDsl, childCount, token, value, deps, bindings, outputs) {
    var _a = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _a.matchedQueries, references = _a.references, matchedQueryIds = _a.matchedQueryIds;
    if (!outputs) {
        outputs = [];
    }
    if (!bindings) {
        bindings = [];
    }
    // Need to resolve forwardRefs as e.g. for `useValue` we
    // lowered the expression and then stopped evaluating it,
    // i.e. also didn't unwrap it.
    value = resolveForwardRef(value);
    var depDefs = splitDepsDsl(deps, stringify(token));
    return {
        // will bet set by the view definition
        nodeIndex: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        checkIndex: checkIndex,
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references,
        ngContentIndex: -1, childCount: childCount, bindings: bindings,
        bindingFlags: calcBindingFlags(bindings), outputs: outputs,
        element: null,
        provider: { token: token, value: value, deps: depDefs },
        text: null,
        query: null,
        ngContent: null
    };
}
function createProviderInstance(view, def) {
    return _createProviderInstance$1(view, def);
}
function createPipeInstance(view, def) {
    // deps are looked up from component.
    var compView = view;
    while (compView.parent && !isComponentView(compView)) {
        compView = compView.parent;
    }
    // pipes can see the private services of the component
    var allowPrivateServices = true;
    // pipes are always eager and classes!
    return createClass(compView.parent, viewParentEl(compView), allowPrivateServices, def.provider.value, def.provider.deps);
}
function createDirectiveInstance(view, def) {
    // components can see other private services, other directives can't.
    var allowPrivateServices = (def.flags & 32768 /* Component */) > 0;
    // directives are always eager and classes!
    var instance = createClass(view, def.parent, allowPrivateServices, def.provider.value, def.provider.deps);
    if (def.outputs.length) {
        for (var i = 0; i < def.outputs.length; i++) {
            var output = def.outputs[i];
            var subscription = instance[output.propName].subscribe(eventHandlerClosure(view, def.parent.nodeIndex, output.eventName));
            view.disposables[def.outputIndex + i] = subscription.unsubscribe.bind(subscription);
        }
    }
    return instance;
}
function eventHandlerClosure(view, index, eventName) {
    return function (event) { return dispatchEvent(view, index, eventName, event); };
}
function checkAndUpdateDirectiveInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var providerData = asProviderData(view, def.nodeIndex);
    var directive = providerData.instance;
    var changed = false;
    var changes = undefined;
    var bindLen = def.bindings.length;
    if (bindLen > 0 && checkBinding(view, def, 0, v0)) {
        changed = true;
        changes = updateProp(view, providerData, def, 0, v0, changes);
    }
    if (bindLen > 1 && checkBinding(view, def, 1, v1)) {
        changed = true;
        changes = updateProp(view, providerData, def, 1, v1, changes);
    }
    if (bindLen > 2 && checkBinding(view, def, 2, v2)) {
        changed = true;
        changes = updateProp(view, providerData, def, 2, v2, changes);
    }
    if (bindLen > 3 && checkBinding(view, def, 3, v3)) {
        changed = true;
        changes = updateProp(view, providerData, def, 3, v3, changes);
    }
    if (bindLen > 4 && checkBinding(view, def, 4, v4)) {
        changed = true;
        changes = updateProp(view, providerData, def, 4, v4, changes);
    }
    if (bindLen > 5 && checkBinding(view, def, 5, v5)) {
        changed = true;
        changes = updateProp(view, providerData, def, 5, v5, changes);
    }
    if (bindLen > 6 && checkBinding(view, def, 6, v6)) {
        changed = true;
        changes = updateProp(view, providerData, def, 6, v6, changes);
    }
    if (bindLen > 7 && checkBinding(view, def, 7, v7)) {
        changed = true;
        changes = updateProp(view, providerData, def, 7, v7, changes);
    }
    if (bindLen > 8 && checkBinding(view, def, 8, v8)) {
        changed = true;
        changes = updateProp(view, providerData, def, 8, v8, changes);
    }
    if (bindLen > 9 && checkBinding(view, def, 9, v9)) {
        changed = true;
        changes = updateProp(view, providerData, def, 9, v9, changes);
    }
    if (changes) {
        directive.ngOnChanges(changes);
    }
    if ((def.flags & 65536 /* OnInit */) &&
        shouldCallLifecycleInitHook(view, 256 /* InitState_CallingOnInit */, def.nodeIndex)) {
        directive.ngOnInit();
    }
    if (def.flags & 262144 /* DoCheck */) {
        directive.ngDoCheck();
    }
    return changed;
}
function checkAndUpdateDirectiveDynamic(view, def, values) {
    var providerData = asProviderData(view, def.nodeIndex);
    var directive = providerData.instance;
    var changed = false;
    var changes = undefined;
    for (var i = 0; i < values.length; i++) {
        if (checkBinding(view, def, i, values[i])) {
            changed = true;
            changes = updateProp(view, providerData, def, i, values[i], changes);
        }
    }
    if (changes) {
        directive.ngOnChanges(changes);
    }
    if ((def.flags & 65536 /* OnInit */) &&
        shouldCallLifecycleInitHook(view, 256 /* InitState_CallingOnInit */, def.nodeIndex)) {
        directive.ngOnInit();
    }
    if (def.flags & 262144 /* DoCheck */) {
        directive.ngDoCheck();
    }
    return changed;
}
function _createProviderInstance$1(view, def) {
    // private services can see other private services
    var allowPrivateServices = (def.flags & 8192 /* PrivateProvider */) > 0;
    var providerDef = def.provider;
    switch (def.flags & 201347067 /* Types */) {
        case 512 /* TypeClassProvider */:
            return createClass(view, def.parent, allowPrivateServices, providerDef.value, providerDef.deps);
        case 1024 /* TypeFactoryProvider */:
            return callFactory(view, def.parent, allowPrivateServices, providerDef.value, providerDef.deps);
        case 2048 /* TypeUseExistingProvider */:
            return resolveDep(view, def.parent, allowPrivateServices, providerDef.deps[0]);
        case 256 /* TypeValueProvider */:
            return providerDef.value;
    }
}
function createClass(view, elDef, allowPrivateServices, ctor, deps) {
    var len = deps.length;
    switch (len) {
        case 0:
            return new ctor();
        case 1:
            return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]));
        case 2:
            return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]));
        case 3:
            return new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]), resolveDep(view, elDef, allowPrivateServices, deps[2]));
        default:
            var depValues = new Array(len);
            for (var i = 0; i < len; i++) {
                depValues[i] = resolveDep(view, elDef, allowPrivateServices, deps[i]);
            }
            return new (ctor.bind.apply(ctor, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([void 0], depValues)))();
    }
}
function callFactory(view, elDef, allowPrivateServices, factory, deps) {
    var len = deps.length;
    switch (len) {
        case 0:
            return factory();
        case 1:
            return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]));
        case 2:
            return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]));
        case 3:
            return factory(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]), resolveDep(view, elDef, allowPrivateServices, deps[2]));
        default:
            var depValues = Array(len);
            for (var i = 0; i < len; i++) {
                depValues[i] = resolveDep(view, elDef, allowPrivateServices, deps[i]);
            }
            return factory.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(depValues));
    }
}
// This default value is when checking the hierarchy for a token.
//
// It means both:
// - the token is not provided by the current injector,
// - only the element injectors should be checked (ie do not check module injectors
//
//          mod1
//         /
//       el1   mod2
//         \  /
//         el2
//
// When requesting el2.injector.get(token), we should check in the following order and return the
// first found value:
// - el2.injector.get(token, default)
// - el1.injector.get(token, NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) -> do not check the module
// - mod2.injector.get(token, default)
var NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR = {};
function resolveDep(view, elDef, allowPrivateServices, depDef, notFoundValue) {
    if (notFoundValue === void 0) {
        notFoundValue = Injector.THROW_IF_NOT_FOUND;
    }
    if (depDef.flags & 8 /* Value */) {
        return depDef.token;
    }
    var startView = view;
    if (depDef.flags & 2 /* Optional */) {
        notFoundValue = null;
    }
    var tokenKey$$1 = depDef.tokenKey;
    if (tokenKey$$1 === ChangeDetectorRefTokenKey) {
        // directives on the same element as a component should be able to control the change detector
        // of that component as well.
        allowPrivateServices = !!(elDef && elDef.element.componentView);
    }
    if (elDef && (depDef.flags & 1 /* SkipSelf */)) {
        allowPrivateServices = false;
        elDef = elDef.parent;
    }
    var searchView = view;
    while (searchView) {
        if (elDef) {
            switch (tokenKey$$1) {
                case RendererV1TokenKey: {
                    var compView = findCompView(searchView, elDef, allowPrivateServices);
                    return createRendererV1(compView);
                }
                case Renderer2TokenKey: {
                    var compView = findCompView(searchView, elDef, allowPrivateServices);
                    return compView.renderer;
                }
                case ElementRefTokenKey:
                    return new ElementRef(asElementData(searchView, elDef.nodeIndex).renderElement);
                case ViewContainerRefTokenKey:
                    return asElementData(searchView, elDef.nodeIndex).viewContainer;
                case TemplateRefTokenKey: {
                    if (elDef.element.template) {
                        return asElementData(searchView, elDef.nodeIndex).template;
                    }
                    break;
                }
                case ChangeDetectorRefTokenKey: {
                    var cdView = findCompView(searchView, elDef, allowPrivateServices);
                    return createChangeDetectorRef(cdView);
                }
                case InjectorRefTokenKey$1:
                case INJECTORRefTokenKey$1:
                    return createInjector$1(searchView, elDef);
                default:
                    var providerDef_1 = (allowPrivateServices ? elDef.element.allProviders :
                        elDef.element.publicProviders)[tokenKey$$1];
                    if (providerDef_1) {
                        var providerData = asProviderData(searchView, providerDef_1.nodeIndex);
                        if (!providerData) {
                            providerData = { instance: _createProviderInstance$1(searchView, providerDef_1) };
                            searchView.nodes[providerDef_1.nodeIndex] = providerData;
                        }
                        return providerData.instance;
                    }
            }
        }
        allowPrivateServices = isComponentView(searchView);
        elDef = viewParentEl(searchView);
        searchView = searchView.parent;
        if (depDef.flags & 4 /* Self */) {
            searchView = null;
        }
    }
    var value = startView.root.injector.get(depDef.token, NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR);
    if (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR ||
        notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) {
        // Return the value from the root element injector when
        // - it provides it
        //   (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
        // - the module injector should not be checked
        //   (notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
        return value;
    }
    return startView.root.ngModule.injector.get(depDef.token, notFoundValue);
}
function findCompView(view, elDef, allowPrivateServices) {
    var compView;
    if (allowPrivateServices) {
        compView = asElementData(view, elDef.nodeIndex).componentView;
    }
    else {
        compView = view;
        while (compView.parent && !isComponentView(compView)) {
            compView = compView.parent;
        }
    }
    return compView;
}
function updateProp(view, providerData, def, bindingIdx, value, changes) {
    if (def.flags & 32768 /* Component */) {
        var compView = asElementData(view, def.parent.nodeIndex).componentView;
        if (compView.def.flags & 2 /* OnPush */) {
            compView.state |= 8 /* ChecksEnabled */;
        }
    }
    var binding = def.bindings[bindingIdx];
    var propName = binding.name;
    // Note: This is still safe with Closure Compiler as
    // the user passed in the property name as an object has to `providerDef`,
    // so Closure Compiler will have renamed the property correctly already.
    providerData.instance[propName] = value;
    if (def.flags & 524288 /* OnChanges */) {
        changes = changes || {};
        var oldValue = WrappedValue.unwrap(view.oldValues[def.bindingIndex + bindingIdx]);
        var binding_1 = def.bindings[bindingIdx];
        changes[binding_1.nonMinifiedName] =
            new SimpleChange(oldValue, value, (view.state & 2 /* FirstCheck */) !== 0);
    }
    view.oldValues[def.bindingIndex + bindingIdx] = value;
    return changes;
}
// This function calls the ngAfterContentCheck, ngAfterContentInit,
// ngAfterViewCheck, and ngAfterViewInit lifecycle hooks (depending on the node
// flags in lifecycle). Unlike ngDoCheck, ngOnChanges and ngOnInit, which are
// called during a pre-order traversal of the view tree (that is calling the
// parent hooks before the child hooks) these events are sent in using a
// post-order traversal of the tree (children before parents). This changes the
// meaning of initIndex in the view state. For ngOnInit, initIndex tracks the
// expected nodeIndex which a ngOnInit should be called. When sending
// ngAfterContentInit and ngAfterViewInit it is the expected count of
// ngAfterContentInit or ngAfterViewInit methods that have been called. This
// ensure that despite being called recursively or after picking up after an
// exception, the ngAfterContentInit or ngAfterViewInit will be called on the
// correct nodes. Consider for example, the following (where E is an element
// and D is a directive)
//  Tree:       pre-order index  post-order index
//    E1        0                6
//      E2      1                1
//       D3     2                0
//      E4      3                5
//       E5     4                4
//        E6    5                2
//        E7    6                3
// As can be seen, the post-order index has an unclear relationship to the
// pre-order index (postOrderIndex === preOrderIndex - parentCount +
// childCount). Since number of calls to ngAfterContentInit and ngAfterViewInit
// are stable (will be the same for the same view regardless of exceptions or
// recursion) we just need to count them which will roughly correspond to the
// post-order index (it skips elements and directives that do not have
// lifecycle hooks).
//
// For example, if an exception is raised in the E6.onAfterViewInit() the
// initIndex is left at 3 (by shouldCallLifecycleInitHook() which set it to
// initIndex + 1). When checkAndUpdateView() is called again D3, E2 and E6 will
// not have their ngAfterViewInit() called but, starting with E7, the rest of
// the view will begin getting ngAfterViewInit() called until a check and
// pass is complete.
//
// This algorthim also handles recursion. Consider if E4's ngAfterViewInit()
// indirectly calls E1's ChangeDetectorRef.detectChanges(). The expected
// initIndex is set to 6, the recusive checkAndUpdateView() starts walk again.
// D3, E2, E6, E7, E5 and E4 are skipped, ngAfterViewInit() is called on E1.
// When the recursion returns the initIndex will be 7 so E1 is skipped as it
// has already been called in the recursively called checkAnUpdateView().
function callLifecycleHooksChildrenFirst(view, lifecycles) {
    if (!(view.def.nodeFlags & lifecycles)) {
        return;
    }
    var nodes = view.def.nodes;
    var initIndex = 0;
    for (var i = 0; i < nodes.length; i++) {
        var nodeDef = nodes[i];
        var parent_1 = nodeDef.parent;
        if (!parent_1 && nodeDef.flags & lifecycles) {
            // matching root node (e.g. a pipe)
            callProviderLifecycles(view, i, nodeDef.flags & lifecycles, initIndex++);
        }
        if ((nodeDef.childFlags & lifecycles) === 0) {
            // no child matches one of the lifecycles
            i += nodeDef.childCount;
        }
        while (parent_1 && (parent_1.flags & 1 /* TypeElement */) &&
            i === parent_1.nodeIndex + parent_1.childCount) {
            // last child of an element
            if (parent_1.directChildFlags & lifecycles) {
                initIndex = callElementProvidersLifecycles(view, parent_1, lifecycles, initIndex);
            }
            parent_1 = parent_1.parent;
        }
    }
}
function callElementProvidersLifecycles(view, elDef, lifecycles, initIndex) {
    for (var i = elDef.nodeIndex + 1; i <= elDef.nodeIndex + elDef.childCount; i++) {
        var nodeDef = view.def.nodes[i];
        if (nodeDef.flags & lifecycles) {
            callProviderLifecycles(view, i, nodeDef.flags & lifecycles, initIndex++);
        }
        // only visit direct children
        i += nodeDef.childCount;
    }
    return initIndex;
}
function callProviderLifecycles(view, index, lifecycles, initIndex) {
    var providerData = asProviderData(view, index);
    if (!providerData) {
        return;
    }
    var provider = providerData.instance;
    if (!provider) {
        return;
    }
    Services.setCurrentNode(view, index);
    if (lifecycles & 1048576 /* AfterContentInit */ &&
        shouldCallLifecycleInitHook(view, 512 /* InitState_CallingAfterContentInit */, initIndex)) {
        provider.ngAfterContentInit();
    }
    if (lifecycles & 2097152 /* AfterContentChecked */) {
        provider.ngAfterContentChecked();
    }
    if (lifecycles & 4194304 /* AfterViewInit */ &&
        shouldCallLifecycleInitHook(view, 768 /* InitState_CallingAfterViewInit */, initIndex)) {
        provider.ngAfterViewInit();
    }
    if (lifecycles & 8388608 /* AfterViewChecked */) {
        provider.ngAfterViewChecked();
    }
    if (lifecycles & 131072 /* OnDestroy */) {
        provider.ngOnDestroy();
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function queryDef(flags, id, bindings) {
    var bindingDefs = [];
    for (var propName in bindings) {
        var bindingType = bindings[propName];
        bindingDefs.push({ propName: propName, bindingType: bindingType });
    }
    return {
        // will bet set by the view definition
        nodeIndex: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        // TODO(vicb): check
        checkIndex: -1, flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0,
        ngContentIndex: -1,
        matchedQueries: {},
        matchedQueryIds: 0,
        references: {},
        childCount: 0,
        bindings: [],
        bindingFlags: 0,
        outputs: [],
        element: null,
        provider: null,
        text: null,
        query: { id: id, filterId: filterQueryId(id), bindings: bindingDefs },
        ngContent: null
    };
}
function createQuery() {
    return new QueryList();
}
function dirtyParentQueries(view) {
    var queryIds = view.def.nodeMatchedQueries;
    while (view.parent && isEmbeddedView(view)) {
        var tplDef = view.parentNodeDef;
        view = view.parent;
        // content queries
        var end = tplDef.nodeIndex + tplDef.childCount;
        for (var i = 0; i <= end; i++) {
            var nodeDef = view.def.nodes[i];
            if ((nodeDef.flags & 67108864 /* TypeContentQuery */) &&
                (nodeDef.flags & 536870912 /* DynamicQuery */) &&
                (nodeDef.query.filterId & queryIds) === nodeDef.query.filterId) {
                asQueryList(view, i).setDirty();
            }
            if ((nodeDef.flags & 1 /* TypeElement */ && i + nodeDef.childCount < tplDef.nodeIndex) ||
                !(nodeDef.childFlags & 67108864 /* TypeContentQuery */) ||
                !(nodeDef.childFlags & 536870912 /* DynamicQuery */)) {
                // skip elements that don't contain the template element or no query.
                i += nodeDef.childCount;
            }
        }
    }
    // view queries
    if (view.def.nodeFlags & 134217728 /* TypeViewQuery */) {
        for (var i = 0; i < view.def.nodes.length; i++) {
            var nodeDef = view.def.nodes[i];
            if ((nodeDef.flags & 134217728 /* TypeViewQuery */) && (nodeDef.flags & 536870912 /* DynamicQuery */)) {
                asQueryList(view, i).setDirty();
            }
            // only visit the root nodes
            i += nodeDef.childCount;
        }
    }
}
function checkAndUpdateQuery(view, nodeDef) {
    var queryList = asQueryList(view, nodeDef.nodeIndex);
    if (!queryList.dirty) {
        return;
    }
    var directiveInstance;
    var newValues = undefined;
    if (nodeDef.flags & 67108864 /* TypeContentQuery */) {
        var elementDef = nodeDef.parent.parent;
        newValues = calcQueryValues(view, elementDef.nodeIndex, elementDef.nodeIndex + elementDef.childCount, nodeDef.query, []);
        directiveInstance = asProviderData(view, nodeDef.parent.nodeIndex).instance;
    }
    else if (nodeDef.flags & 134217728 /* TypeViewQuery */) {
        newValues = calcQueryValues(view, 0, view.def.nodes.length - 1, nodeDef.query, []);
        directiveInstance = view.component;
    }
    queryList.reset(newValues);
    var bindings = nodeDef.query.bindings;
    var notify = false;
    for (var i = 0; i < bindings.length; i++) {
        var binding = bindings[i];
        var boundValue = void 0;
        switch (binding.bindingType) {
            case 0 /* First */:
                boundValue = queryList.first;
                break;
            case 1 /* All */:
                boundValue = queryList;
                notify = true;
                break;
        }
        directiveInstance[binding.propName] = boundValue;
    }
    if (notify) {
        queryList.notifyOnChanges();
    }
}
function calcQueryValues(view, startIndex, endIndex, queryDef, values) {
    for (var i = startIndex; i <= endIndex; i++) {
        var nodeDef = view.def.nodes[i];
        var valueType = nodeDef.matchedQueries[queryDef.id];
        if (valueType != null) {
            values.push(getQueryValue(view, nodeDef, valueType));
        }
        if (nodeDef.flags & 1 /* TypeElement */ && nodeDef.element.template &&
            (nodeDef.element.template.nodeMatchedQueries & queryDef.filterId) ===
                queryDef.filterId) {
            var elementData = asElementData(view, i);
            // check embedded views that were attached at the place of their template,
            // but process child nodes first if some match the query (see issue #16568)
            if ((nodeDef.childMatchedQueries & queryDef.filterId) === queryDef.filterId) {
                calcQueryValues(view, i + 1, i + nodeDef.childCount, queryDef, values);
                i += nodeDef.childCount;
            }
            if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
                var embeddedViews = elementData.viewContainer._embeddedViews;
                for (var k = 0; k < embeddedViews.length; k++) {
                    var embeddedView = embeddedViews[k];
                    var dvc = declaredViewContainer(embeddedView);
                    if (dvc && dvc === elementData) {
                        calcQueryValues(embeddedView, 0, embeddedView.def.nodes.length - 1, queryDef, values);
                    }
                }
            }
            var projectedViews = elementData.template._projectedViews;
            if (projectedViews) {
                for (var k = 0; k < projectedViews.length; k++) {
                    var projectedView = projectedViews[k];
                    calcQueryValues(projectedView, 0, projectedView.def.nodes.length - 1, queryDef, values);
                }
            }
        }
        if ((nodeDef.childMatchedQueries & queryDef.filterId) !== queryDef.filterId) {
            // if no child matches the query, skip the children.
            i += nodeDef.childCount;
        }
    }
    return values;
}
function getQueryValue(view, nodeDef, queryValueType) {
    if (queryValueType != null) {
        // a match
        switch (queryValueType) {
            case 1 /* RenderElement */:
                return asElementData(view, nodeDef.nodeIndex).renderElement;
            case 0 /* ElementRef */:
                return new ElementRef(asElementData(view, nodeDef.nodeIndex).renderElement);
            case 2 /* TemplateRef */:
                return asElementData(view, nodeDef.nodeIndex).template;
            case 3 /* ViewContainerRef */:
                return asElementData(view, nodeDef.nodeIndex).viewContainer;
            case 4 /* Provider */:
                return asProviderData(view, nodeDef.nodeIndex).instance;
        }
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function ngContentDef(ngContentIndex, index) {
    return {
        // will bet set by the view definition
        nodeIndex: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        checkIndex: -1,
        flags: 8 /* TypeNgContent */,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0,
        matchedQueries: {},
        matchedQueryIds: 0,
        references: {}, ngContentIndex: ngContentIndex,
        childCount: 0,
        bindings: [],
        bindingFlags: 0,
        outputs: [],
        element: null,
        provider: null,
        text: null,
        query: null,
        ngContent: { index: index }
    };
}
function appendNgContent(view, renderHost, def) {
    var parentEl = getParentRenderElement(view, renderHost, def);
    if (!parentEl) {
        // Nothing to do if there is no parent element.
        return;
    }
    var ngContentIndex = def.ngContent.index;
    visitProjectedRenderNodes(view, ngContentIndex, 1 /* AppendChild */, parentEl, null, undefined);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function purePipeDef(checkIndex, argCount) {
    // argCount + 1 to include the pipe as first arg
    return _pureExpressionDef(128 /* TypePurePipe */, checkIndex, new Array(argCount + 1));
}
function pureArrayDef(checkIndex, argCount) {
    return _pureExpressionDef(32 /* TypePureArray */, checkIndex, new Array(argCount));
}
function pureObjectDef(checkIndex, propToIndex) {
    var keys = Object.keys(propToIndex);
    var nbKeys = keys.length;
    var propertyNames = new Array(nbKeys);
    for (var i = 0; i < nbKeys; i++) {
        var key = keys[i];
        var index = propToIndex[key];
        propertyNames[index] = key;
    }
    return _pureExpressionDef(64 /* TypePureObject */, checkIndex, propertyNames);
}
function _pureExpressionDef(flags, checkIndex, propertyNames) {
    var bindings = new Array(propertyNames.length);
    for (var i = 0; i < propertyNames.length; i++) {
        var prop = propertyNames[i];
        bindings[i] = {
            flags: 8 /* TypeProperty */,
            name: prop,
            ns: null,
            nonMinifiedName: prop,
            securityContext: null,
            suffix: null
        };
    }
    return {
        // will bet set by the view definition
        nodeIndex: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        checkIndex: checkIndex,
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0,
        matchedQueries: {},
        matchedQueryIds: 0,
        references: {},
        ngContentIndex: -1,
        childCount: 0, bindings: bindings,
        bindingFlags: calcBindingFlags(bindings),
        outputs: [],
        element: null,
        provider: null,
        text: null,
        query: null,
        ngContent: null
    };
}
function createPureExpression(view, def) {
    return { value: undefined };
}
function checkAndUpdatePureExpressionInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var bindings = def.bindings;
    var changed = false;
    var bindLen = bindings.length;
    if (bindLen > 0 && checkAndUpdateBinding(view, def, 0, v0))
        changed = true;
    if (bindLen > 1 && checkAndUpdateBinding(view, def, 1, v1))
        changed = true;
    if (bindLen > 2 && checkAndUpdateBinding(view, def, 2, v2))
        changed = true;
    if (bindLen > 3 && checkAndUpdateBinding(view, def, 3, v3))
        changed = true;
    if (bindLen > 4 && checkAndUpdateBinding(view, def, 4, v4))
        changed = true;
    if (bindLen > 5 && checkAndUpdateBinding(view, def, 5, v5))
        changed = true;
    if (bindLen > 6 && checkAndUpdateBinding(view, def, 6, v6))
        changed = true;
    if (bindLen > 7 && checkAndUpdateBinding(view, def, 7, v7))
        changed = true;
    if (bindLen > 8 && checkAndUpdateBinding(view, def, 8, v8))
        changed = true;
    if (bindLen > 9 && checkAndUpdateBinding(view, def, 9, v9))
        changed = true;
    if (changed) {
        var data = asPureExpressionData(view, def.nodeIndex);
        var value = void 0;
        switch (def.flags & 201347067 /* Types */) {
            case 32 /* TypePureArray */:
                value = new Array(bindings.length);
                if (bindLen > 0)
                    value[0] = v0;
                if (bindLen > 1)
                    value[1] = v1;
                if (bindLen > 2)
                    value[2] = v2;
                if (bindLen > 3)
                    value[3] = v3;
                if (bindLen > 4)
                    value[4] = v4;
                if (bindLen > 5)
                    value[5] = v5;
                if (bindLen > 6)
                    value[6] = v6;
                if (bindLen > 7)
                    value[7] = v7;
                if (bindLen > 8)
                    value[8] = v8;
                if (bindLen > 9)
                    value[9] = v9;
                break;
            case 64 /* TypePureObject */:
                value = {};
                if (bindLen > 0)
                    value[bindings[0].name] = v0;
                if (bindLen > 1)
                    value[bindings[1].name] = v1;
                if (bindLen > 2)
                    value[bindings[2].name] = v2;
                if (bindLen > 3)
                    value[bindings[3].name] = v3;
                if (bindLen > 4)
                    value[bindings[4].name] = v4;
                if (bindLen > 5)
                    value[bindings[5].name] = v5;
                if (bindLen > 6)
                    value[bindings[6].name] = v6;
                if (bindLen > 7)
                    value[bindings[7].name] = v7;
                if (bindLen > 8)
                    value[bindings[8].name] = v8;
                if (bindLen > 9)
                    value[bindings[9].name] = v9;
                break;
            case 128 /* TypePurePipe */:
                var pipe = v0;
                switch (bindLen) {
                    case 1:
                        value = pipe.transform(v0);
                        break;
                    case 2:
                        value = pipe.transform(v1);
                        break;
                    case 3:
                        value = pipe.transform(v1, v2);
                        break;
                    case 4:
                        value = pipe.transform(v1, v2, v3);
                        break;
                    case 5:
                        value = pipe.transform(v1, v2, v3, v4);
                        break;
                    case 6:
                        value = pipe.transform(v1, v2, v3, v4, v5);
                        break;
                    case 7:
                        value = pipe.transform(v1, v2, v3, v4, v5, v6);
                        break;
                    case 8:
                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7);
                        break;
                    case 9:
                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7, v8);
                        break;
                    case 10:
                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7, v8, v9);
                        break;
                }
                break;
        }
        data.value = value;
    }
    return changed;
}
function checkAndUpdatePureExpressionDynamic(view, def, values) {
    var bindings = def.bindings;
    var changed = false;
    for (var i = 0; i < values.length; i++) {
        // Note: We need to loop over all values, so that
        // the old values are updates as well!
        if (checkAndUpdateBinding(view, def, i, values[i])) {
            changed = true;
        }
    }
    if (changed) {
        var data = asPureExpressionData(view, def.nodeIndex);
        var value = void 0;
        switch (def.flags & 201347067 /* Types */) {
            case 32 /* TypePureArray */:
                value = values;
                break;
            case 64 /* TypePureObject */:
                value = {};
                for (var i = 0; i < values.length; i++) {
                    value[bindings[i].name] = values[i];
                }
                break;
            case 128 /* TypePurePipe */:
                var pipe = values[0];
                var params = values.slice(1);
                value = pipe.transform.apply(pipe, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(params));
                break;
        }
        data.value = value;
    }
    return changed;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function textDef(checkIndex, ngContentIndex, staticText) {
    var bindings = new Array(staticText.length - 1);
    for (var i = 1; i < staticText.length; i++) {
        bindings[i - 1] = {
            flags: 8 /* TypeProperty */,
            name: null,
            ns: null,
            nonMinifiedName: null,
            securityContext: null,
            suffix: staticText[i],
        };
    }
    return {
        // will bet set by the view definition
        nodeIndex: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        checkIndex: checkIndex,
        flags: 2 /* TypeText */,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0,
        matchedQueries: {},
        matchedQueryIds: 0,
        references: {}, ngContentIndex: ngContentIndex,
        childCount: 0, bindings: bindings,
        bindingFlags: 8 /* TypeProperty */,
        outputs: [],
        element: null,
        provider: null,
        text: { prefix: staticText[0] },
        query: null,
        ngContent: null,
    };
}
function createText(view, renderHost, def) {
    var renderNode$$1;
    var renderer = view.renderer;
    renderNode$$1 = renderer.createText(def.text.prefix);
    var parentEl = getParentRenderElement(view, renderHost, def);
    if (parentEl) {
        renderer.appendChild(parentEl, renderNode$$1);
    }
    return { renderText: renderNode$$1 };
}
function checkAndUpdateTextInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var changed = false;
    var bindings = def.bindings;
    var bindLen = bindings.length;
    if (bindLen > 0 && checkAndUpdateBinding(view, def, 0, v0))
        changed = true;
    if (bindLen > 1 && checkAndUpdateBinding(view, def, 1, v1))
        changed = true;
    if (bindLen > 2 && checkAndUpdateBinding(view, def, 2, v2))
        changed = true;
    if (bindLen > 3 && checkAndUpdateBinding(view, def, 3, v3))
        changed = true;
    if (bindLen > 4 && checkAndUpdateBinding(view, def, 4, v4))
        changed = true;
    if (bindLen > 5 && checkAndUpdateBinding(view, def, 5, v5))
        changed = true;
    if (bindLen > 6 && checkAndUpdateBinding(view, def, 6, v6))
        changed = true;
    if (bindLen > 7 && checkAndUpdateBinding(view, def, 7, v7))
        changed = true;
    if (bindLen > 8 && checkAndUpdateBinding(view, def, 8, v8))
        changed = true;
    if (bindLen > 9 && checkAndUpdateBinding(view, def, 9, v9))
        changed = true;
    if (changed) {
        var value = def.text.prefix;
        if (bindLen > 0)
            value += _addInterpolationPart(v0, bindings[0]);
        if (bindLen > 1)
            value += _addInterpolationPart(v1, bindings[1]);
        if (bindLen > 2)
            value += _addInterpolationPart(v2, bindings[2]);
        if (bindLen > 3)
            value += _addInterpolationPart(v3, bindings[3]);
        if (bindLen > 4)
            value += _addInterpolationPart(v4, bindings[4]);
        if (bindLen > 5)
            value += _addInterpolationPart(v5, bindings[5]);
        if (bindLen > 6)
            value += _addInterpolationPart(v6, bindings[6]);
        if (bindLen > 7)
            value += _addInterpolationPart(v7, bindings[7]);
        if (bindLen > 8)
            value += _addInterpolationPart(v8, bindings[8]);
        if (bindLen > 9)
            value += _addInterpolationPart(v9, bindings[9]);
        var renderNode$$1 = asTextData(view, def.nodeIndex).renderText;
        view.renderer.setValue(renderNode$$1, value);
    }
    return changed;
}
function checkAndUpdateTextDynamic(view, def, values) {
    var bindings = def.bindings;
    var changed = false;
    for (var i = 0; i < values.length; i++) {
        // Note: We need to loop over all values, so that
        // the old values are updates as well!
        if (checkAndUpdateBinding(view, def, i, values[i])) {
            changed = true;
        }
    }
    if (changed) {
        var value = '';
        for (var i = 0; i < values.length; i++) {
            value = value + _addInterpolationPart(values[i], bindings[i]);
        }
        value = def.text.prefix + value;
        var renderNode$$1 = asTextData(view, def.nodeIndex).renderText;
        view.renderer.setValue(renderNode$$1, value);
    }
    return changed;
}
function _addInterpolationPart(value, binding) {
    var valueStr = value != null ? value.toString() : '';
    return valueStr + binding.suffix;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function viewDef(flags, nodes, updateDirectives, updateRenderer) {
    // clone nodes and set auto calculated values
    var viewBindingCount = 0;
    var viewDisposableCount = 0;
    var viewNodeFlags = 0;
    var viewRootNodeFlags = 0;
    var viewMatchedQueries = 0;
    var currentParent = null;
    var currentRenderParent = null;
    var currentElementHasPublicProviders = false;
    var currentElementHasPrivateProviders = false;
    var lastRenderRootNode = null;
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        node.nodeIndex = i;
        node.parent = currentParent;
        node.bindingIndex = viewBindingCount;
        node.outputIndex = viewDisposableCount;
        node.renderParent = currentRenderParent;
        viewNodeFlags |= node.flags;
        viewMatchedQueries |= node.matchedQueryIds;
        if (node.element) {
            var elDef = node.element;
            elDef.publicProviders =
                currentParent ? currentParent.element.publicProviders : Object.create(null);
            elDef.allProviders = elDef.publicProviders;
            // Note: We assume that all providers of an element are before any child element!
            currentElementHasPublicProviders = false;
            currentElementHasPrivateProviders = false;
            if (node.element.template) {
                viewMatchedQueries |= node.element.template.nodeMatchedQueries;
            }
        }
        validateNode(currentParent, node, nodes.length);
        viewBindingCount += node.bindings.length;
        viewDisposableCount += node.outputs.length;
        if (!currentRenderParent && (node.flags & 3 /* CatRenderNode */)) {
            lastRenderRootNode = node;
        }
        if (node.flags & 20224 /* CatProvider */) {
            if (!currentElementHasPublicProviders) {
                currentElementHasPublicProviders = true;
                // Use prototypical inheritance to not get O(n^2) complexity...
                currentParent.element.publicProviders =
                    Object.create(currentParent.element.publicProviders);
                currentParent.element.allProviders = currentParent.element.publicProviders;
            }
            var isPrivateService = (node.flags & 8192 /* PrivateProvider */) !== 0;
            var isComponent = (node.flags & 32768 /* Component */) !== 0;
            if (!isPrivateService || isComponent) {
                currentParent.element.publicProviders[tokenKey(node.provider.token)] = node;
            }
            else {
                if (!currentElementHasPrivateProviders) {
                    currentElementHasPrivateProviders = true;
                    // Use prototypical inheritance to not get O(n^2) complexity...
                    currentParent.element.allProviders =
                        Object.create(currentParent.element.publicProviders);
                }
                currentParent.element.allProviders[tokenKey(node.provider.token)] = node;
            }
            if (isComponent) {
                currentParent.element.componentProvider = node;
            }
        }
        if (currentParent) {
            currentParent.childFlags |= node.flags;
            currentParent.directChildFlags |= node.flags;
            currentParent.childMatchedQueries |= node.matchedQueryIds;
            if (node.element && node.element.template) {
                currentParent.childMatchedQueries |= node.element.template.nodeMatchedQueries;
            }
        }
        else {
            viewRootNodeFlags |= node.flags;
        }
        if (node.childCount > 0) {
            currentParent = node;
            if (!isNgContainer(node)) {
                currentRenderParent = node;
            }
        }
        else {
            // When the current node has no children, check if it is the last children of its parent.
            // When it is, propagate the flags up.
            // The loop is required because an element could be the last transitive children of several
            // elements. We loop to either the root or the highest opened element (= with remaining
            // children)
            while (currentParent && i === currentParent.nodeIndex + currentParent.childCount) {
                var newParent = currentParent.parent;
                if (newParent) {
                    newParent.childFlags |= currentParent.childFlags;
                    newParent.childMatchedQueries |= currentParent.childMatchedQueries;
                }
                currentParent = newParent;
                // We also need to update the render parent & account for ng-container
                if (currentParent && isNgContainer(currentParent)) {
                    currentRenderParent = currentParent.renderParent;
                }
                else {
                    currentRenderParent = currentParent;
                }
            }
        }
    }
    var handleEvent = function (view, nodeIndex, eventName, event) {
        return nodes[nodeIndex].element.handleEvent(view, eventName, event);
    };
    return {
        // Will be filled later...
        factory: null,
        nodeFlags: viewNodeFlags,
        rootNodeFlags: viewRootNodeFlags,
        nodeMatchedQueries: viewMatchedQueries, flags: flags,
        nodes: nodes,
        updateDirectives: updateDirectives || NOOP,
        updateRenderer: updateRenderer || NOOP, handleEvent: handleEvent,
        bindingCount: viewBindingCount,
        outputCount: viewDisposableCount, lastRenderRootNode: lastRenderRootNode
    };
}
function isNgContainer(node) {
    return (node.flags & 1 /* TypeElement */) !== 0 && node.element.name === null;
}
function validateNode(parent, node, nodeCount) {
    var template = node.element && node.element.template;
    if (template) {
        if (!template.lastRenderRootNode) {
            throw new Error("Illegal State: Embedded templates without nodes are not allowed!");
        }
        if (template.lastRenderRootNode &&
            template.lastRenderRootNode.flags & 16777216 /* EmbeddedViews */) {
            throw new Error("Illegal State: Last root node of a template can't have embedded views, at index " + node.nodeIndex + "!");
        }
    }
    if (node.flags & 20224 /* CatProvider */) {
        var parentFlags = parent ? parent.flags : 0;
        if ((parentFlags & 1 /* TypeElement */) === 0) {
            throw new Error("Illegal State: StaticProvider/Directive nodes need to be children of elements or anchors, at index " + node.nodeIndex + "!");
        }
    }
    if (node.query) {
        if (node.flags & 67108864 /* TypeContentQuery */ &&
            (!parent || (parent.flags & 16384 /* TypeDirective */) === 0)) {
            throw new Error("Illegal State: Content Query nodes need to be children of directives, at index " + node.nodeIndex + "!");
        }
        if (node.flags & 134217728 /* TypeViewQuery */ && parent) {
            throw new Error("Illegal State: View Query nodes have to be top level nodes, at index " + node.nodeIndex + "!");
        }
    }
    if (node.childCount) {
        var parentEnd = parent ? parent.nodeIndex + parent.childCount : nodeCount - 1;
        if (node.nodeIndex <= parentEnd && node.nodeIndex + node.childCount > parentEnd) {
            throw new Error("Illegal State: childCount of node leads outside of parent, at index " + node.nodeIndex + "!");
        }
    }
}
function createEmbeddedView(parent, anchorDef$$1, viewDef, context) {
    // embedded views are seen as siblings to the anchor, so we need
    // to get the parent of the anchor and use it as parentIndex.
    var view = createView(parent.root, parent.renderer, parent, anchorDef$$1, viewDef);
    initView(view, parent.component, context);
    createViewNodes(view);
    return view;
}
function createRootView(root, def, context) {
    var view = createView(root, root.renderer, null, null, def);
    initView(view, context, context);
    createViewNodes(view);
    return view;
}
function createComponentView(parentView, nodeDef, viewDef, hostElement) {
    var rendererType = nodeDef.element.componentRendererType;
    var compRenderer;
    if (!rendererType) {
        compRenderer = parentView.root.renderer;
    }
    else {
        compRenderer = parentView.root.rendererFactory.createRenderer(hostElement, rendererType);
    }
    return createView(parentView.root, compRenderer, parentView, nodeDef.element.componentProvider, viewDef);
}
function createView(root, renderer, parent, parentNodeDef, def) {
    var nodes = new Array(def.nodes.length);
    var disposables = def.outputCount ? new Array(def.outputCount) : null;
    var view = {
        def: def,
        parent: parent,
        viewContainerParent: null, parentNodeDef: parentNodeDef,
        context: null,
        component: null, nodes: nodes,
        state: 13 /* CatInit */, root: root, renderer: renderer,
        oldValues: new Array(def.bindingCount), disposables: disposables,
        initIndex: -1
    };
    return view;
}
function initView(view, component, context) {
    view.component = component;
    view.context = context;
}
function createViewNodes(view) {
    var renderHost;
    if (isComponentView(view)) {
        var hostDef = view.parentNodeDef;
        renderHost = asElementData(view.parent, hostDef.parent.nodeIndex).renderElement;
    }
    var def = view.def;
    var nodes = view.nodes;
    for (var i = 0; i < def.nodes.length; i++) {
        var nodeDef = def.nodes[i];
        Services.setCurrentNode(view, i);
        var nodeData = void 0;
        switch (nodeDef.flags & 201347067 /* Types */) {
            case 1 /* TypeElement */:
                var el = createElement(view, renderHost, nodeDef);
                var componentView = undefined;
                if (nodeDef.flags & 33554432 /* ComponentView */) {
                    var compViewDef = resolveDefinition(nodeDef.element.componentView);
                    componentView = Services.createComponentView(view, nodeDef, compViewDef, el);
                }
                listenToElementOutputs(view, componentView, nodeDef, el);
                nodeData = {
                    renderElement: el,
                    componentView: componentView,
                    viewContainer: null,
                    template: nodeDef.element.template ? createTemplateData(view, nodeDef) : undefined
                };
                if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
                    nodeData.viewContainer = createViewContainerData(view, nodeDef, nodeData);
                }
                break;
            case 2 /* TypeText */:
                nodeData = createText(view, renderHost, nodeDef);
                break;
            case 512 /* TypeClassProvider */:
            case 1024 /* TypeFactoryProvider */:
            case 2048 /* TypeUseExistingProvider */:
            case 256 /* TypeValueProvider */: {
                nodeData = nodes[i];
                if (!nodeData && !(nodeDef.flags & 4096 /* LazyProvider */)) {
                    var instance = createProviderInstance(view, nodeDef);
                    nodeData = { instance: instance };
                }
                break;
            }
            case 16 /* TypePipe */: {
                var instance = createPipeInstance(view, nodeDef);
                nodeData = { instance: instance };
                break;
            }
            case 16384 /* TypeDirective */: {
                nodeData = nodes[i];
                if (!nodeData) {
                    var instance = createDirectiveInstance(view, nodeDef);
                    nodeData = { instance: instance };
                }
                if (nodeDef.flags & 32768 /* Component */) {
                    var compView = asElementData(view, nodeDef.parent.nodeIndex).componentView;
                    initView(compView, nodeData.instance, nodeData.instance);
                }
                break;
            }
            case 32 /* TypePureArray */:
            case 64 /* TypePureObject */:
            case 128 /* TypePurePipe */:
                nodeData = createPureExpression(view, nodeDef);
                break;
            case 67108864 /* TypeContentQuery */:
            case 134217728 /* TypeViewQuery */:
                nodeData = createQuery();
                break;
            case 8 /* TypeNgContent */:
                appendNgContent(view, renderHost, nodeDef);
                // no runtime data needed for NgContent...
                nodeData = undefined;
                break;
        }
        nodes[i] = nodeData;
    }
    // Create the ViewData.nodes of component views after we created everything else,
    // so that e.g. ng-content works
    execComponentViewsAction(view, ViewAction.CreateViewNodes);
    // fill static content and view queries
    execQueriesAction(view, 67108864 /* TypeContentQuery */ | 134217728 /* TypeViewQuery */, 268435456 /* StaticQuery */, 0 /* CheckAndUpdate */);
}
function checkNoChangesView(view) {
    markProjectedViewsForCheck(view);
    Services.updateDirectives(view, 1 /* CheckNoChanges */);
    execEmbeddedViewsAction(view, ViewAction.CheckNoChanges);
    Services.updateRenderer(view, 1 /* CheckNoChanges */);
    execComponentViewsAction(view, ViewAction.CheckNoChanges);
    // Note: We don't check queries for changes as we didn't do this in v2.x.
    // TODO(tbosch): investigate if we can enable the check again in v5.x with a nicer error message.
    view.state &= ~(64 /* CheckProjectedViews */ | 32 /* CheckProjectedView */);
}
function checkAndUpdateView(view) {
    if (view.state & 1 /* BeforeFirstCheck */) {
        view.state &= ~1 /* BeforeFirstCheck */;
        view.state |= 2 /* FirstCheck */;
    }
    else {
        view.state &= ~2 /* FirstCheck */;
    }
    shiftInitState(view, 0 /* InitState_BeforeInit */, 256 /* InitState_CallingOnInit */);
    markProjectedViewsForCheck(view);
    Services.updateDirectives(view, 0 /* CheckAndUpdate */);
    execEmbeddedViewsAction(view, ViewAction.CheckAndUpdate);
    execQueriesAction(view, 67108864 /* TypeContentQuery */, 536870912 /* DynamicQuery */, 0 /* CheckAndUpdate */);
    var callInit = shiftInitState(view, 256 /* InitState_CallingOnInit */, 512 /* InitState_CallingAfterContentInit */);
    callLifecycleHooksChildrenFirst(view, 2097152 /* AfterContentChecked */ | (callInit ? 1048576 /* AfterContentInit */ : 0));
    Services.updateRenderer(view, 0 /* CheckAndUpdate */);
    execComponentViewsAction(view, ViewAction.CheckAndUpdate);
    execQueriesAction(view, 134217728 /* TypeViewQuery */, 536870912 /* DynamicQuery */, 0 /* CheckAndUpdate */);
    callInit = shiftInitState(view, 512 /* InitState_CallingAfterContentInit */, 768 /* InitState_CallingAfterViewInit */);
    callLifecycleHooksChildrenFirst(view, 8388608 /* AfterViewChecked */ | (callInit ? 4194304 /* AfterViewInit */ : 0));
    if (view.def.flags & 2 /* OnPush */) {
        view.state &= ~8 /* ChecksEnabled */;
    }
    view.state &= ~(64 /* CheckProjectedViews */ | 32 /* CheckProjectedView */);
    shiftInitState(view, 768 /* InitState_CallingAfterViewInit */, 1024 /* InitState_AfterInit */);
}
function checkAndUpdateNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    if (argStyle === 0 /* Inline */) {
        return checkAndUpdateNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    }
    else {
        return checkAndUpdateNodeDynamic(view, nodeDef, v0);
    }
}
function markProjectedViewsForCheck(view) {
    var def = view.def;
    if (!(def.nodeFlags & 4 /* ProjectedTemplate */)) {
        return;
    }
    for (var i = 0; i < def.nodes.length; i++) {
        var nodeDef = def.nodes[i];
        if (nodeDef.flags & 4 /* ProjectedTemplate */) {
            var projectedViews = asElementData(view, i).template._projectedViews;
            if (projectedViews) {
                for (var i_1 = 0; i_1 < projectedViews.length; i_1++) {
                    var projectedView = projectedViews[i_1];
                    projectedView.state |= 32 /* CheckProjectedView */;
                    markParentViewsForCheckProjectedViews(projectedView, view);
                }
            }
        }
        else if ((nodeDef.childFlags & 4 /* ProjectedTemplate */) === 0) {
            // a parent with leafs
            // no child is a component,
            // then skip the children
            i += nodeDef.childCount;
        }
    }
}
function checkAndUpdateNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    switch (nodeDef.flags & 201347067 /* Types */) {
        case 1 /* TypeElement */:
            return checkAndUpdateElementInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
        case 2 /* TypeText */:
            return checkAndUpdateTextInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
        case 16384 /* TypeDirective */:
            return checkAndUpdateDirectiveInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
        case 32 /* TypePureArray */:
        case 64 /* TypePureObject */:
        case 128 /* TypePurePipe */:
            return checkAndUpdatePureExpressionInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
        default:
            throw 'unreachable';
    }
}
function checkAndUpdateNodeDynamic(view, nodeDef, values) {
    switch (nodeDef.flags & 201347067 /* Types */) {
        case 1 /* TypeElement */:
            return checkAndUpdateElementDynamic(view, nodeDef, values);
        case 2 /* TypeText */:
            return checkAndUpdateTextDynamic(view, nodeDef, values);
        case 16384 /* TypeDirective */:
            return checkAndUpdateDirectiveDynamic(view, nodeDef, values);
        case 32 /* TypePureArray */:
        case 64 /* TypePureObject */:
        case 128 /* TypePurePipe */:
            return checkAndUpdatePureExpressionDynamic(view, nodeDef, values);
        default:
            throw 'unreachable';
    }
}
function checkNoChangesNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    if (argStyle === 0 /* Inline */) {
        checkNoChangesNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    }
    else {
        checkNoChangesNodeDynamic(view, nodeDef, v0);
    }
    // Returning false is ok here as we would have thrown in case of a change.
    return false;
}
function checkNoChangesNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var bindLen = nodeDef.bindings.length;
    if (bindLen > 0)
        checkBindingNoChanges(view, nodeDef, 0, v0);
    if (bindLen > 1)
        checkBindingNoChanges(view, nodeDef, 1, v1);
    if (bindLen > 2)
        checkBindingNoChanges(view, nodeDef, 2, v2);
    if (bindLen > 3)
        checkBindingNoChanges(view, nodeDef, 3, v3);
    if (bindLen > 4)
        checkBindingNoChanges(view, nodeDef, 4, v4);
    if (bindLen > 5)
        checkBindingNoChanges(view, nodeDef, 5, v5);
    if (bindLen > 6)
        checkBindingNoChanges(view, nodeDef, 6, v6);
    if (bindLen > 7)
        checkBindingNoChanges(view, nodeDef, 7, v7);
    if (bindLen > 8)
        checkBindingNoChanges(view, nodeDef, 8, v8);
    if (bindLen > 9)
        checkBindingNoChanges(view, nodeDef, 9, v9);
}
function checkNoChangesNodeDynamic(view, nodeDef, values) {
    for (var i = 0; i < values.length; i++) {
        checkBindingNoChanges(view, nodeDef, i, values[i]);
    }
}
/**
 * Workaround https://github.com/angular/tsickle/issues/497
 * @suppress {misplacedTypeAnnotation}
 */
function checkNoChangesQuery(view, nodeDef) {
    var queryList = asQueryList(view, nodeDef.nodeIndex);
    if (queryList.dirty) {
        throw expressionChangedAfterItHasBeenCheckedError(Services.createDebugContext(view, nodeDef.nodeIndex), "Query " + nodeDef.query.id + " not dirty", "Query " + nodeDef.query.id + " dirty", (view.state & 1 /* BeforeFirstCheck */) !== 0);
    }
}
function destroyView(view) {
    if (view.state & 128 /* Destroyed */) {
        return;
    }
    execEmbeddedViewsAction(view, ViewAction.Destroy);
    execComponentViewsAction(view, ViewAction.Destroy);
    callLifecycleHooksChildrenFirst(view, 131072 /* OnDestroy */);
    if (view.disposables) {
        for (var i = 0; i < view.disposables.length; i++) {
            view.disposables[i]();
        }
    }
    detachProjectedView(view);
    if (view.renderer.destroyNode) {
        destroyViewNodes(view);
    }
    if (isComponentView(view)) {
        view.renderer.destroy();
    }
    view.state |= 128 /* Destroyed */;
}
function destroyViewNodes(view) {
    var len = view.def.nodes.length;
    for (var i = 0; i < len; i++) {
        var def = view.def.nodes[i];
        if (def.flags & 1 /* TypeElement */) {
            view.renderer.destroyNode(asElementData(view, i).renderElement);
        }
        else if (def.flags & 2 /* TypeText */) {
            view.renderer.destroyNode(asTextData(view, i).renderText);
        }
        else if (def.flags & 67108864 /* TypeContentQuery */ || def.flags & 134217728 /* TypeViewQuery */) {
            asQueryList(view, i).destroy();
        }
    }
}
var ViewAction = /*@__PURE__*/ (function (ViewAction) {
    ViewAction[ViewAction["CreateViewNodes"] = 0] = "CreateViewNodes";
    ViewAction[ViewAction["CheckNoChanges"] = 1] = "CheckNoChanges";
    ViewAction[ViewAction["CheckNoChangesProjectedViews"] = 2] = "CheckNoChangesProjectedViews";
    ViewAction[ViewAction["CheckAndUpdate"] = 3] = "CheckAndUpdate";
    ViewAction[ViewAction["CheckAndUpdateProjectedViews"] = 4] = "CheckAndUpdateProjectedViews";
    ViewAction[ViewAction["Destroy"] = 5] = "Destroy";
    return ViewAction;
})({});
function execComponentViewsAction(view, action) {
    var def = view.def;
    if (!(def.nodeFlags & 33554432 /* ComponentView */)) {
        return;
    }
    for (var i = 0; i < def.nodes.length; i++) {
        var nodeDef = def.nodes[i];
        if (nodeDef.flags & 33554432 /* ComponentView */) {
            // a leaf
            callViewAction(asElementData(view, i).componentView, action);
        }
        else if ((nodeDef.childFlags & 33554432 /* ComponentView */) === 0) {
            // a parent with leafs
            // no child is a component,
            // then skip the children
            i += nodeDef.childCount;
        }
    }
}
function execEmbeddedViewsAction(view, action) {
    var def = view.def;
    if (!(def.nodeFlags & 16777216 /* EmbeddedViews */)) {
        return;
    }
    for (var i = 0; i < def.nodes.length; i++) {
        var nodeDef = def.nodes[i];
        if (nodeDef.flags & 16777216 /* EmbeddedViews */) {
            // a leaf
            var embeddedViews = asElementData(view, i).viewContainer._embeddedViews;
            for (var k = 0; k < embeddedViews.length; k++) {
                callViewAction(embeddedViews[k], action);
            }
        }
        else if ((nodeDef.childFlags & 16777216 /* EmbeddedViews */) === 0) {
            // a parent with leafs
            // no child is a component,
            // then skip the children
            i += nodeDef.childCount;
        }
    }
}
function callViewAction(view, action) {
    var viewState = view.state;
    switch (action) {
        case ViewAction.CheckNoChanges:
            if ((viewState & 128 /* Destroyed */) === 0) {
                if ((viewState & 12 /* CatDetectChanges */) === 12 /* CatDetectChanges */) {
                    checkNoChangesView(view);
                }
                else if (viewState & 64 /* CheckProjectedViews */) {
                    execProjectedViewsAction(view, ViewAction.CheckNoChangesProjectedViews);
                }
            }
            break;
        case ViewAction.CheckNoChangesProjectedViews:
            if ((viewState & 128 /* Destroyed */) === 0) {
                if (viewState & 32 /* CheckProjectedView */) {
                    checkNoChangesView(view);
                }
                else if (viewState & 64 /* CheckProjectedViews */) {
                    execProjectedViewsAction(view, action);
                }
            }
            break;
        case ViewAction.CheckAndUpdate:
            if ((viewState & 128 /* Destroyed */) === 0) {
                if ((viewState & 12 /* CatDetectChanges */) === 12 /* CatDetectChanges */) {
                    checkAndUpdateView(view);
                }
                else if (viewState & 64 /* CheckProjectedViews */) {
                    execProjectedViewsAction(view, ViewAction.CheckAndUpdateProjectedViews);
                }
            }
            break;
        case ViewAction.CheckAndUpdateProjectedViews:
            if ((viewState & 128 /* Destroyed */) === 0) {
                if (viewState & 32 /* CheckProjectedView */) {
                    checkAndUpdateView(view);
                }
                else if (viewState & 64 /* CheckProjectedViews */) {
                    execProjectedViewsAction(view, action);
                }
            }
            break;
        case ViewAction.Destroy:
            // Note: destroyView recurses over all views,
            // so we don't need to special case projected views here.
            destroyView(view);
            break;
        case ViewAction.CreateViewNodes:
            createViewNodes(view);
            break;
    }
}
function execProjectedViewsAction(view, action) {
    execEmbeddedViewsAction(view, action);
    execComponentViewsAction(view, action);
}
function execQueriesAction(view, queryFlags, staticDynamicQueryFlag, checkType) {
    if (!(view.def.nodeFlags & queryFlags) || !(view.def.nodeFlags & staticDynamicQueryFlag)) {
        return;
    }
    var nodeCount = view.def.nodes.length;
    for (var i = 0; i < nodeCount; i++) {
        var nodeDef = view.def.nodes[i];
        if ((nodeDef.flags & queryFlags) && (nodeDef.flags & staticDynamicQueryFlag)) {
            Services.setCurrentNode(view, nodeDef.nodeIndex);
            switch (checkType) {
                case 0 /* CheckAndUpdate */:
                    checkAndUpdateQuery(view, nodeDef);
                    break;
                case 1 /* CheckNoChanges */:
                    checkNoChangesQuery(view, nodeDef);
                    break;
            }
        }
        if (!(nodeDef.childFlags & queryFlags) || !(nodeDef.childFlags & staticDynamicQueryFlag)) {
            // no child has a matching query
            // then skip the children
            i += nodeDef.childCount;
        }
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var initialized = false;
function initServicesIfNeeded() {
    if (initialized) {
        return;
    }
    initialized = true;
    var services = isDevMode() ? createDebugServices() : createProdServices();
    Services.setCurrentNode = services.setCurrentNode;
    Services.createRootView = services.createRootView;
    Services.createEmbeddedView = services.createEmbeddedView;
    Services.createComponentView = services.createComponentView;
    Services.createNgModuleRef = services.createNgModuleRef;
    Services.overrideProvider = services.overrideProvider;
    Services.overrideComponentView = services.overrideComponentView;
    Services.clearOverrides = services.clearOverrides;
    Services.checkAndUpdateView = services.checkAndUpdateView;
    Services.checkNoChangesView = services.checkNoChangesView;
    Services.destroyView = services.destroyView;
    Services.resolveDep = resolveDep;
    Services.createDebugContext = services.createDebugContext;
    Services.handleEvent = services.handleEvent;
    Services.updateDirectives = services.updateDirectives;
    Services.updateRenderer = services.updateRenderer;
    Services.dirtyParentQueries = dirtyParentQueries;
}
function createProdServices() {
    return {
        setCurrentNode: function () { },
        createRootView: createProdRootView,
        createEmbeddedView: createEmbeddedView,
        createComponentView: createComponentView,
        createNgModuleRef: createNgModuleRef,
        overrideProvider: NOOP,
        overrideComponentView: NOOP,
        clearOverrides: NOOP,
        checkAndUpdateView: checkAndUpdateView,
        checkNoChangesView: checkNoChangesView,
        destroyView: destroyView,
        createDebugContext: function (view, nodeIndex) { return new DebugContext_(view, nodeIndex); },
        handleEvent: function (view, nodeIndex, eventName, event) {
            return view.def.handleEvent(view, nodeIndex, eventName, event);
        },
        updateDirectives: function (view, checkType) {
            return view.def.updateDirectives(checkType === 0 /* CheckAndUpdate */ ? prodCheckAndUpdateNode :
                prodCheckNoChangesNode, view);
        },
        updateRenderer: function (view, checkType) {
            return view.def.updateRenderer(checkType === 0 /* CheckAndUpdate */ ? prodCheckAndUpdateNode :
                prodCheckNoChangesNode, view);
        },
    };
}
function createDebugServices() {
    return {
        setCurrentNode: debugSetCurrentNode,
        createRootView: debugCreateRootView,
        createEmbeddedView: debugCreateEmbeddedView,
        createComponentView: debugCreateComponentView,
        createNgModuleRef: debugCreateNgModuleRef,
        overrideProvider: debugOverrideProvider,
        overrideComponentView: debugOverrideComponentView,
        clearOverrides: debugClearOverrides,
        checkAndUpdateView: debugCheckAndUpdateView,
        checkNoChangesView: debugCheckNoChangesView,
        destroyView: debugDestroyView,
        createDebugContext: function (view, nodeIndex) { return new DebugContext_(view, nodeIndex); },
        handleEvent: debugHandleEvent,
        updateDirectives: debugUpdateDirectives,
        updateRenderer: debugUpdateRenderer,
    };
}
function createProdRootView(elInjector, projectableNodes, rootSelectorOrNode, def, ngModule, context) {
    var rendererFactory = ngModule.injector.get(RendererFactory2);
    return createRootView(createRootData(elInjector, ngModule, rendererFactory, projectableNodes, rootSelectorOrNode), def, context);
}
function debugCreateRootView(elInjector, projectableNodes, rootSelectorOrNode, def, ngModule, context) {
    var rendererFactory = ngModule.injector.get(RendererFactory2);
    var root = createRootData(elInjector, ngModule, new DebugRendererFactory2(rendererFactory), projectableNodes, rootSelectorOrNode);
    var defWithOverride = applyProviderOverridesToView(def);
    return callWithDebugContext(DebugAction.create, createRootView, null, [root, defWithOverride, context]);
}
function createRootData(elInjector, ngModule, rendererFactory, projectableNodes, rootSelectorOrNode) {
    var sanitizer = ngModule.injector.get(Sanitizer);
    var errorHandler = ngModule.injector.get(ErrorHandler);
    var renderer = rendererFactory.createRenderer(null, null);
    return {
        ngModule: ngModule,
        injector: elInjector, projectableNodes: projectableNodes,
        selectorOrNode: rootSelectorOrNode, sanitizer: sanitizer, rendererFactory: rendererFactory, renderer: renderer, errorHandler: errorHandler
    };
}
function debugCreateEmbeddedView(parentView, anchorDef, viewDef$$1, context) {
    var defWithOverride = applyProviderOverridesToView(viewDef$$1);
    return callWithDebugContext(DebugAction.create, createEmbeddedView, null, [parentView, anchorDef, defWithOverride, context]);
}
function debugCreateComponentView(parentView, nodeDef, viewDef$$1, hostElement) {
    var overrideComponentView = viewDefOverrides.get(nodeDef.element.componentProvider.provider.token);
    if (overrideComponentView) {
        viewDef$$1 = overrideComponentView;
    }
    else {
        viewDef$$1 = applyProviderOverridesToView(viewDef$$1);
    }
    return callWithDebugContext(DebugAction.create, createComponentView, null, [parentView, nodeDef, viewDef$$1, hostElement]);
}
function debugCreateNgModuleRef(moduleType, parentInjector, bootstrapComponents, def) {
    var defWithOverride = applyProviderOverridesToNgModule(def);
    return createNgModuleRef(moduleType, parentInjector, bootstrapComponents, defWithOverride);
}
var providerOverrides = /*@__PURE__*/ new Map();
var providerOverridesWithScope = /*@__PURE__*/ new Map();
var viewDefOverrides = /*@__PURE__*/ new Map();
function debugOverrideProvider(override) {
    providerOverrides.set(override.token, override);
    if (typeof override.token === 'function' && override.token.ngInjectableDef &&
        typeof override.token.ngInjectableDef.providedIn === 'function') {
        providerOverridesWithScope.set(override.token, override);
    }
}
function debugOverrideComponentView(comp, compFactory) {
    var hostViewDef = resolveDefinition(getComponentViewDefinitionFactory(compFactory));
    var compViewDef = resolveDefinition(hostViewDef.nodes[0].element.componentView);
    viewDefOverrides.set(comp, compViewDef);
}
function debugClearOverrides() {
    providerOverrides.clear();
    providerOverridesWithScope.clear();
    viewDefOverrides.clear();
}
// Notes about the algorithm:
// 1) Locate the providers of an element and check if one of them was overwritten
// 2) Change the providers of that element
//
// We only create new datastructures if we need to, to keep perf impact
// reasonable.
function applyProviderOverridesToView(def) {
    if (providerOverrides.size === 0) {
        return def;
    }
    var elementIndicesWithOverwrittenProviders = findElementIndicesWithOverwrittenProviders(def);
    if (elementIndicesWithOverwrittenProviders.length === 0) {
        return def;
    }
    // clone the whole view definition,
    // as it maintains references between the nodes that are hard to update.
    def = def.factory(function () { return NOOP; });
    for (var i = 0; i < elementIndicesWithOverwrittenProviders.length; i++) {
        applyProviderOverridesToElement(def, elementIndicesWithOverwrittenProviders[i]);
    }
    return def;
    function findElementIndicesWithOverwrittenProviders(def) {
        var elIndicesWithOverwrittenProviders = [];
        var lastElementDef = null;
        for (var i = 0; i < def.nodes.length; i++) {
            var nodeDef = def.nodes[i];
            if (nodeDef.flags & 1 /* TypeElement */) {
                lastElementDef = nodeDef;
            }
            if (lastElementDef && nodeDef.flags & 3840 /* CatProviderNoDirective */ &&
                providerOverrides.has(nodeDef.provider.token)) {
                elIndicesWithOverwrittenProviders.push(lastElementDef.nodeIndex);
                lastElementDef = null;
            }
        }
        return elIndicesWithOverwrittenProviders;
    }
    function applyProviderOverridesToElement(viewDef$$1, elIndex) {
        for (var i = elIndex + 1; i < viewDef$$1.nodes.length; i++) {
            var nodeDef = viewDef$$1.nodes[i];
            if (nodeDef.flags & 1 /* TypeElement */) {
                // stop at the next element
                return;
            }
            if (nodeDef.flags & 3840 /* CatProviderNoDirective */) {
                var provider = nodeDef.provider;
                var override = providerOverrides.get(provider.token);
                if (override) {
                    nodeDef.flags = (nodeDef.flags & ~3840 /* CatProviderNoDirective */) | override.flags;
                    provider.deps = splitDepsDsl(override.deps);
                    provider.value = override.value;
                }
            }
        }
    }
}
// Notes about the algorithm:
// We only create new datastructures if we need to, to keep perf impact
// reasonable.
function applyProviderOverridesToNgModule(def) {
    var _a = calcHasOverrides(def), hasOverrides = _a.hasOverrides, hasDeprecatedOverrides = _a.hasDeprecatedOverrides;
    if (!hasOverrides) {
        return def;
    }
    // clone the whole view definition,
    // as it maintains references between the nodes that are hard to update.
    def = def.factory(function () { return NOOP; });
    applyProviderOverrides(def);
    return def;
    function calcHasOverrides(def) {
        var hasOverrides = false;
        var hasDeprecatedOverrides = false;
        if (providerOverrides.size === 0) {
            return { hasOverrides: hasOverrides, hasDeprecatedOverrides: hasDeprecatedOverrides };
        }
        def.providers.forEach(function (node) {
            var override = providerOverrides.get(node.token);
            if ((node.flags & 3840 /* CatProviderNoDirective */) && override) {
                hasOverrides = true;
                hasDeprecatedOverrides = hasDeprecatedOverrides || override.deprecatedBehavior;
            }
        });
        def.modules.forEach(function (module) {
            providerOverridesWithScope.forEach(function (override, token) {
                if (token.ngInjectableDef.providedIn === module) {
                    hasOverrides = true;
                    hasDeprecatedOverrides = hasDeprecatedOverrides || override.deprecatedBehavior;
                }
            });
        });
        return { hasOverrides: hasOverrides, hasDeprecatedOverrides: hasDeprecatedOverrides };
    }
    function applyProviderOverrides(def) {
        for (var i = 0; i < def.providers.length; i++) {
            var provider = def.providers[i];
            if (hasDeprecatedOverrides) {
                // We had a bug where me made
                // all providers lazy. Keep this logic behind a flag
                // for migrating existing users.
                provider.flags |= 4096 /* LazyProvider */;
            }
            var override = providerOverrides.get(provider.token);
            if (override) {
                provider.flags = (provider.flags & ~3840 /* CatProviderNoDirective */) | override.flags;
                provider.deps = splitDepsDsl(override.deps);
                provider.value = override.value;
            }
        }
        if (providerOverridesWithScope.size > 0) {
            var moduleSet_1 = new Set(def.modules);
            providerOverridesWithScope.forEach(function (override, token) {
                if (moduleSet_1.has(token.ngInjectableDef.providedIn)) {
                    var provider = {
                        token: token,
                        flags: override.flags | (hasDeprecatedOverrides ? 4096 /* LazyProvider */ : 0 /* None */),
                        deps: splitDepsDsl(override.deps),
                        value: override.value,
                        index: def.providers.length,
                    };
                    def.providers.push(provider);
                    def.providersByKey[tokenKey(token)] = provider;
                }
            });
        }
    }
}
function prodCheckAndUpdateNode(view, checkIndex, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var nodeDef = view.def.nodes[checkIndex];
    checkAndUpdateNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    return (nodeDef.flags & 224 /* CatPureExpression */) ?
        asPureExpressionData(view, checkIndex).value :
        undefined;
}
function prodCheckNoChangesNode(view, checkIndex, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var nodeDef = view.def.nodes[checkIndex];
    checkNoChangesNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    return (nodeDef.flags & 224 /* CatPureExpression */) ?
        asPureExpressionData(view, checkIndex).value :
        undefined;
}
function debugCheckAndUpdateView(view) {
    return callWithDebugContext(DebugAction.detectChanges, checkAndUpdateView, null, [view]);
}
function debugCheckNoChangesView(view) {
    return callWithDebugContext(DebugAction.checkNoChanges, checkNoChangesView, null, [view]);
}
function debugDestroyView(view) {
    return callWithDebugContext(DebugAction.destroy, destroyView, null, [view]);
}
var DebugAction = /*@__PURE__*/ (function (DebugAction) {
    DebugAction[DebugAction["create"] = 0] = "create";
    DebugAction[DebugAction["detectChanges"] = 1] = "detectChanges";
    DebugAction[DebugAction["checkNoChanges"] = 2] = "checkNoChanges";
    DebugAction[DebugAction["destroy"] = 3] = "destroy";
    DebugAction[DebugAction["handleEvent"] = 4] = "handleEvent";
    return DebugAction;
})({});
var _currentAction;
var _currentView;
var _currentNodeIndex;
function debugSetCurrentNode(view, nodeIndex) {
    _currentView = view;
    _currentNodeIndex = nodeIndex;
}
function debugHandleEvent(view, nodeIndex, eventName, event) {
    debugSetCurrentNode(view, nodeIndex);
    return callWithDebugContext(DebugAction.handleEvent, view.def.handleEvent, null, [view, nodeIndex, eventName, event]);
}
function debugUpdateDirectives(view, checkType) {
    if (view.state & 128 /* Destroyed */) {
        throw viewDestroyedError(DebugAction[_currentAction]);
    }
    debugSetCurrentNode(view, nextDirectiveWithBinding(view, 0));
    return view.def.updateDirectives(debugCheckDirectivesFn, view);
    function debugCheckDirectivesFn(view, nodeIndex, argStyle) {
        var values = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            values[_i - 3] = arguments[_i];
        }
        var nodeDef = view.def.nodes[nodeIndex];
        if (checkType === 0 /* CheckAndUpdate */) {
            debugCheckAndUpdateNode(view, nodeDef, argStyle, values);
        }
        else {
            debugCheckNoChangesNode(view, nodeDef, argStyle, values);
        }
        if (nodeDef.flags & 16384 /* TypeDirective */) {
            debugSetCurrentNode(view, nextDirectiveWithBinding(view, nodeIndex));
        }
        return (nodeDef.flags & 224 /* CatPureExpression */) ?
            asPureExpressionData(view, nodeDef.nodeIndex).value :
            undefined;
    }
}
function debugUpdateRenderer(view, checkType) {
    if (view.state & 128 /* Destroyed */) {
        throw viewDestroyedError(DebugAction[_currentAction]);
    }
    debugSetCurrentNode(view, nextRenderNodeWithBinding(view, 0));
    return view.def.updateRenderer(debugCheckRenderNodeFn, view);
    function debugCheckRenderNodeFn(view, nodeIndex, argStyle) {
        var values = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            values[_i - 3] = arguments[_i];
        }
        var nodeDef = view.def.nodes[nodeIndex];
        if (checkType === 0 /* CheckAndUpdate */) {
            debugCheckAndUpdateNode(view, nodeDef, argStyle, values);
        }
        else {
            debugCheckNoChangesNode(view, nodeDef, argStyle, values);
        }
        if (nodeDef.flags & 3 /* CatRenderNode */) {
            debugSetCurrentNode(view, nextRenderNodeWithBinding(view, nodeIndex));
        }
        return (nodeDef.flags & 224 /* CatPureExpression */) ?
            asPureExpressionData(view, nodeDef.nodeIndex).value :
            undefined;
    }
}
function debugCheckAndUpdateNode(view, nodeDef, argStyle, givenValues) {
    var changed = checkAndUpdateNode.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([view, nodeDef, argStyle], givenValues));
    if (changed) {
        var values = argStyle === 1 /* Dynamic */ ? givenValues[0] : givenValues;
        if (nodeDef.flags & 16384 /* TypeDirective */) {
            var bindingValues = {};
            for (var i = 0; i < nodeDef.bindings.length; i++) {
                var binding = nodeDef.bindings[i];
                var value = values[i];
                if (binding.flags & 8 /* TypeProperty */) {
                    bindingValues[normalizeDebugBindingName(binding.nonMinifiedName)] =
                        normalizeDebugBindingValue(value);
                }
            }
            var elDef = nodeDef.parent;
            var el = asElementData(view, elDef.nodeIndex).renderElement;
            if (!elDef.element.name) {
                // a comment.
                view.renderer.setValue(el, "bindings=" + JSON.stringify(bindingValues, null, 2));
            }
            else {
                // a regular element.
                for (var attr in bindingValues) {
                    var value = bindingValues[attr];
                    if (value != null) {
                        view.renderer.setAttribute(el, attr, value);
                    }
                    else {
                        view.renderer.removeAttribute(el, attr);
                    }
                }
            }
        }
    }
}
function debugCheckNoChangesNode(view, nodeDef, argStyle, values) {
    checkNoChangesNode.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([view, nodeDef, argStyle], values));
}
function normalizeDebugBindingName(name) {
    // Attribute names with `$` (eg `x-y$`) are valid per spec, but unsupported by some browsers
    name = camelCaseToDashCase(name.replace(/[$@]/g, '_'));
    return "ng-reflect-" + name;
}
var CAMEL_CASE_REGEXP = /([A-Z])/g;
function camelCaseToDashCase(input) {
    return input.replace(CAMEL_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        return '-' + m[1].toLowerCase();
    });
}
function normalizeDebugBindingValue(value) {
    try {
        // Limit the size of the value as otherwise the DOM just gets polluted.
        return value != null ? value.toString().slice(0, 30) : value;
    }
    catch (e) {
        return '[ERROR] Exception while trying to serialize the value';
    }
}
function nextDirectiveWithBinding(view, nodeIndex) {
    for (var i = nodeIndex; i < view.def.nodes.length; i++) {
        var nodeDef = view.def.nodes[i];
        if (nodeDef.flags & 16384 /* TypeDirective */ && nodeDef.bindings && nodeDef.bindings.length) {
            return i;
        }
    }
    return null;
}
function nextRenderNodeWithBinding(view, nodeIndex) {
    for (var i = nodeIndex; i < view.def.nodes.length; i++) {
        var nodeDef = view.def.nodes[i];
        if ((nodeDef.flags & 3 /* CatRenderNode */) && nodeDef.bindings && nodeDef.bindings.length) {
            return i;
        }
    }
    return null;
}
var DebugContext_ = /*@__PURE__*/ (function () {
    function DebugContext_(view, nodeIndex) {
        this.view = view;
        this.nodeIndex = nodeIndex;
        if (nodeIndex == null) {
            this.nodeIndex = nodeIndex = 0;
        }
        this.nodeDef = view.def.nodes[nodeIndex];
        var elDef = this.nodeDef;
        var elView = view;
        while (elDef && (elDef.flags & 1 /* TypeElement */) === 0) {
            elDef = elDef.parent;
        }
        if (!elDef) {
            while (!elDef && elView) {
                elDef = viewParentEl(elView);
                elView = elView.parent;
            }
        }
        this.elDef = elDef;
        this.elView = elView;
    }
    Object.defineProperty(DebugContext_.prototype, "elOrCompView", {
        get: function () {
            // Has to be done lazily as we use the DebugContext also during creation of elements...
            return asElementData(this.elView, this.elDef.nodeIndex).componentView || this.view;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "injector", {
        get: function () { return createInjector$1(this.elView, this.elDef); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "component", {
        get: function () { return this.elOrCompView.component; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "context", {
        get: function () { return this.elOrCompView.context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "providerTokens", {
        get: function () {
            var tokens = [];
            if (this.elDef) {
                for (var i = this.elDef.nodeIndex + 1; i <= this.elDef.nodeIndex + this.elDef.childCount; i++) {
                    var childDef = this.elView.def.nodes[i];
                    if (childDef.flags & 20224 /* CatProvider */) {
                        tokens.push(childDef.provider.token);
                    }
                    i += childDef.childCount;
                }
            }
            return tokens;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "references", {
        get: function () {
            var references = {};
            if (this.elDef) {
                collectReferences(this.elView, this.elDef, references);
                for (var i = this.elDef.nodeIndex + 1; i <= this.elDef.nodeIndex + this.elDef.childCount; i++) {
                    var childDef = this.elView.def.nodes[i];
                    if (childDef.flags & 20224 /* CatProvider */) {
                        collectReferences(this.elView, childDef, references);
                    }
                    i += childDef.childCount;
                }
            }
            return references;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "componentRenderElement", {
        get: function () {
            var elData = findHostElement(this.elOrCompView);
            return elData ? elData.renderElement : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "renderNode", {
        get: function () {
            return this.nodeDef.flags & 2 /* TypeText */ ? renderNode(this.view, this.nodeDef) :
                renderNode(this.elView, this.elDef);
        },
        enumerable: true,
        configurable: true
    });
    DebugContext_.prototype.logError = function (console) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        var logViewDef;
        var logNodeIndex;
        if (this.nodeDef.flags & 2 /* TypeText */) {
            logViewDef = this.view.def;
            logNodeIndex = this.nodeDef.nodeIndex;
        }
        else {
            logViewDef = this.elView.def;
            logNodeIndex = this.elDef.nodeIndex;
        }
        // Note: we only generate a log function for text and element nodes
        // to make the generated code as small as possible.
        var renderNodeIndex = getRenderNodeIndex(logViewDef, logNodeIndex);
        var currRenderNodeIndex = -1;
        var nodeLogger = function () {
            var _a;
            currRenderNodeIndex++;
            if (currRenderNodeIndex === renderNodeIndex) {
                return (_a = console.error).bind.apply(_a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([console], values));
            }
            else {
                return NOOP;
            }
        };
        logViewDef.factory(nodeLogger);
        if (currRenderNodeIndex < renderNodeIndex) {
            console.error('Illegal state: the ViewDefinitionFactory did not call the logger!');
            console.error.apply(console, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(values));
        }
    };
    return DebugContext_;
}());
function getRenderNodeIndex(viewDef$$1, nodeIndex) {
    var renderNodeIndex = -1;
    for (var i = 0; i <= nodeIndex; i++) {
        var nodeDef = viewDef$$1.nodes[i];
        if (nodeDef.flags & 3 /* CatRenderNode */) {
            renderNodeIndex++;
        }
    }
    return renderNodeIndex;
}
function findHostElement(view) {
    while (view && !isComponentView(view)) {
        view = view.parent;
    }
    if (view.parent) {
        return asElementData(view.parent, viewParentEl(view).nodeIndex);
    }
    return null;
}
function collectReferences(view, nodeDef, references) {
    for (var refName in nodeDef.references) {
        references[refName] = getQueryValue(view, nodeDef, nodeDef.references[refName]);
    }
}
function callWithDebugContext(action, fn, self, args) {
    var oldAction = _currentAction;
    var oldView = _currentView;
    var oldNodeIndex = _currentNodeIndex;
    try {
        _currentAction = action;
        var result = fn.apply(self, args);
        _currentView = oldView;
        _currentNodeIndex = oldNodeIndex;
        _currentAction = oldAction;
        return result;
    }
    catch (e) {
        if (isViewDebugError(e) || !_currentView) {
            throw e;
        }
        throw viewWrappedDebugError(e, getCurrentDebugContext());
    }
}
function getCurrentDebugContext() {
    return _currentView ? new DebugContext_(_currentView, _currentNodeIndex) : null;
}
var DebugRendererFactory2 = /*@__PURE__*/ (function () {
    function DebugRendererFactory2(delegate) {
        this.delegate = delegate;
    }
    DebugRendererFactory2.prototype.createRenderer = function (element, renderData) {
        return new DebugRenderer2(this.delegate.createRenderer(element, renderData));
    };
    DebugRendererFactory2.prototype.begin = function () {
        if (this.delegate.begin) {
            this.delegate.begin();
        }
    };
    DebugRendererFactory2.prototype.end = function () {
        if (this.delegate.end) {
            this.delegate.end();
        }
    };
    DebugRendererFactory2.prototype.whenRenderingDone = function () {
        if (this.delegate.whenRenderingDone) {
            return this.delegate.whenRenderingDone();
        }
        return Promise.resolve(null);
    };
    return DebugRendererFactory2;
}());
var DebugRenderer2 = /*@__PURE__*/ (function () {
    function DebugRenderer2(delegate) {
        this.delegate = delegate;
        this.data = this.delegate.data;
    }
    DebugRenderer2.prototype.destroyNode = function (node) {
        removeDebugNodeFromIndex(getDebugNode(node));
        if (this.delegate.destroyNode) {
            this.delegate.destroyNode(node);
        }
    };
    DebugRenderer2.prototype.destroy = function () { this.delegate.destroy(); };
    DebugRenderer2.prototype.createElement = function (name, namespace) {
        var el = this.delegate.createElement(name, namespace);
        var debugCtx = getCurrentDebugContext();
        if (debugCtx) {
            var debugEl = new DebugElement(el, null, debugCtx);
            debugEl.name = name;
            indexDebugNode(debugEl);
        }
        return el;
    };
    DebugRenderer2.prototype.createComment = function (value) {
        var comment = this.delegate.createComment(value);
        var debugCtx = getCurrentDebugContext();
        if (debugCtx) {
            indexDebugNode(new DebugNode(comment, null, debugCtx));
        }
        return comment;
    };
    DebugRenderer2.prototype.createText = function (value) {
        var text = this.delegate.createText(value);
        var debugCtx = getCurrentDebugContext();
        if (debugCtx) {
            indexDebugNode(new DebugNode(text, null, debugCtx));
        }
        return text;
    };
    DebugRenderer2.prototype.appendChild = function (parent, newChild) {
        var debugEl = getDebugNode(parent);
        var debugChildEl = getDebugNode(newChild);
        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
            debugEl.addChild(debugChildEl);
        }
        this.delegate.appendChild(parent, newChild);
    };
    DebugRenderer2.prototype.insertBefore = function (parent, newChild, refChild) {
        var debugEl = getDebugNode(parent);
        var debugChildEl = getDebugNode(newChild);
        var debugRefEl = getDebugNode(refChild);
        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
            debugEl.insertBefore(debugRefEl, debugChildEl);
        }
        this.delegate.insertBefore(parent, newChild, refChild);
    };
    DebugRenderer2.prototype.removeChild = function (parent, oldChild) {
        var debugEl = getDebugNode(parent);
        var debugChildEl = getDebugNode(oldChild);
        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
            debugEl.removeChild(debugChildEl);
        }
        this.delegate.removeChild(parent, oldChild);
    };
    DebugRenderer2.prototype.selectRootElement = function (selectorOrNode) {
        var el = this.delegate.selectRootElement(selectorOrNode);
        var debugCtx = getCurrentDebugContext();
        if (debugCtx) {
            indexDebugNode(new DebugElement(el, null, debugCtx));
        }
        return el;
    };
    DebugRenderer2.prototype.setAttribute = function (el, name, value, namespace) {
        var debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            var fullName = namespace ? namespace + ':' + name : name;
            debugEl.attributes[fullName] = value;
        }
        this.delegate.setAttribute(el, name, value, namespace);
    };
    DebugRenderer2.prototype.removeAttribute = function (el, name, namespace) {
        var debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            var fullName = namespace ? namespace + ':' + name : name;
            debugEl.attributes[fullName] = null;
        }
        this.delegate.removeAttribute(el, name, namespace);
    };
    DebugRenderer2.prototype.addClass = function (el, name) {
        var debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.classes[name] = true;
        }
        this.delegate.addClass(el, name);
    };
    DebugRenderer2.prototype.removeClass = function (el, name) {
        var debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.classes[name] = false;
        }
        this.delegate.removeClass(el, name);
    };
    DebugRenderer2.prototype.setStyle = function (el, style, value, flags) {
        var debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.styles[style] = value;
        }
        this.delegate.setStyle(el, style, value, flags);
    };
    DebugRenderer2.prototype.removeStyle = function (el, style, flags) {
        var debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.styles[style] = null;
        }
        this.delegate.removeStyle(el, style, flags);
    };
    DebugRenderer2.prototype.setProperty = function (el, name, value) {
        var debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.properties[name] = value;
        }
        this.delegate.setProperty(el, name, value);
    };
    DebugRenderer2.prototype.listen = function (target, eventName, callback) {
        if (typeof target !== 'string') {
            var debugEl = getDebugNode(target);
            if (debugEl) {
                debugEl.listeners.push(new EventListener(eventName, callback));
            }
        }
        return this.delegate.listen(target, eventName, callback);
    };
    DebugRenderer2.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
    DebugRenderer2.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
    DebugRenderer2.prototype.setValue = function (node, value) { return this.delegate.setValue(node, value); };
    return DebugRenderer2;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function overrideProvider(override) {
    initServicesIfNeeded();
    return Services.overrideProvider(override);
}
function overrideComponentView(comp, componentFactory) {
    initServicesIfNeeded();
    return Services.overrideComponentView(comp, componentFactory);
}
function clearOverrides() {
    initServicesIfNeeded();
    return Services.clearOverrides();
}
// Attention: this function is called as top level function.
// Putting any logic in here will destroy closure tree shaking!
function createNgModuleFactory(ngModuleType, bootstrapComponents, defFactory) {
    return new NgModuleFactory_(ngModuleType, bootstrapComponents, defFactory);
}
function cloneNgModuleDefinition(def) {
    var providers = Array.from(def.providers);
    var modules = Array.from(def.modules);
    var providersByKey = {};
    for (var key in def.providersByKey) {
        providersByKey[key] = def.providersByKey[key];
    }
    return {
        factory: def.factory,
        isRoot: def.isRoot, providers: providers, modules: modules, providersByKey: providersByKey,
    };
}
var NgModuleFactory_ = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgModuleFactory_, _super);
    function NgModuleFactory_(moduleType, _bootstrapComponents, _ngModuleDefFactory) {
        var _this = 
        // Attention: this ctor is called as top level function.
        // Putting any logic in here will destroy closure tree shaking!
        _super.call(this) || this;
        _this.moduleType = moduleType;
        _this._bootstrapComponents = _bootstrapComponents;
        _this._ngModuleDefFactory = _ngModuleDefFactory;
        return _this;
    }
    NgModuleFactory_.prototype.create = function (parentInjector) {
        initServicesIfNeeded();
        // Clone the NgModuleDefinition so that any tree shakeable provider definition
        // added to this instance of the NgModuleRef doesn't affect the cached copy.
        // See https://github.com/angular/angular/issues/25018.
        var def = cloneNgModuleDefinition(resolveDefinition(this._ngModuleDefFactory));
        return Services.createNgModuleRef(this.moduleType, parentInjector || Injector.NULL, this._bootstrapComponents, def);
    };
    return NgModuleFactory_;
}(NgModuleFactory));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function assertEqual(actual, expected, msg) {
    if (actual != expected) {
        throwError(msg);
    }
}
function assertNotEqual(actual, expected, msg) {
    if (actual == expected) {
        throwError(msg);
    }
}
function assertLessThan(actual, expected, msg) {
    if (actual >= expected) {
        throwError(msg);
    }
}
function assertGreaterThan(actual, expected, msg) {
    if (actual <= expected) {
        throwError(msg);
    }
}
function assertNotDefined(actual, msg) {
    if (actual != null) {
        throwError(msg);
    }
}
function assertDefined(actual, msg) {
    if (actual == null) {
        throwError(msg);
    }
}
function assertComponentType(actual, msg) {
    if (msg === void 0) {
        msg = 'Type passed in is not ComponentType, it does not have \'ngComponentDef\' property.';
    }
    if (!actual.ngComponentDef) {
        debugger;
        throwError(msg);
    }
}
function throwError(msg) {
    debugger; // Left intentionally for better debugger experience.
    throw new Error("ASSERTION ERROR: " + msg);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Size of LViewData's header. Necessary to adjust for it when setting slots.  */
var HEADER_OFFSET = 16;
// Below are constants for LViewData indices to help us look up LViewData members
// without having to remember the specific indices.
// Uglify will inline these when minifying so there shouldn't be a cost.
var TVIEW = 0;
var PARENT = 1;
var NEXT = 2;
var QUERIES = 3;
var FLAGS = 4;
var HOST_NODE = 5;
var BINDING_INDEX = 6;
var DIRECTIVES = 7;
var CLEANUP = 8;
var CONTEXT = 9;
var INJECTOR$1 = 10;
var RENDERER = 11;
var SANITIZER = 12;
var TAIL = 13;
var CONTAINER_INDEX = 14;
var CONTENT_QUERIES = 15;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * If this is the first template pass, any ngOnInit or ngDoCheck hooks will be queued into
 * TView.initHooks during directiveCreate.
 *
 * The directive index and hook type are encoded into one number (1st bit: type, remaining bits:
 * directive index), then saved in the even indices of the initHooks array. The odd indices
 * hold the hook functions themselves.
 *
 * @param index The index of the directive in LViewData[DIRECTIVES]
 * @param hooks The static hooks map on the directive def
 * @param tView The current TView
 */
function queueInitHooks(index, onInit, doCheck, tView) {
    ngDevMode &&
        assertEqual(tView.firstTemplatePass, true, 'Should only be called on first template pass');
    if (onInit) {
        (tView.initHooks || (tView.initHooks = [])).push(index, onInit);
    }
    if (doCheck) {
        (tView.initHooks || (tView.initHooks = [])).push(index, doCheck);
        (tView.checkHooks || (tView.checkHooks = [])).push(index, doCheck);
    }
}
/**
 * Loops through the directives on a node and queues all their hooks except ngOnInit
 * and ngDoCheck, which are queued separately in directiveCreate.
 */
function queueLifecycleHooks(flags, tView) {
    if (tView.firstTemplatePass) {
        var start = flags >> 14 /* DirectiveStartingIndexShift */;
        var count = flags & 4095 /* DirectiveCountMask */;
        var end = start + count;
        // It's necessary to loop through the directives at elementEnd() (rather than processing in
        // directiveCreate) so we can preserve the current hook order. Content, view, and destroy
        // hooks for projected components and directives must be called *before* their hosts.
        for (var i = start; i < end; i++) {
            var def = tView.directives[i];
            queueContentHooks(def, tView, i);
            queueViewHooks(def, tView, i);
            queueDestroyHooks(def, tView, i);
        }
    }
}
/** Queues afterContentInit and afterContentChecked hooks on TView */
function queueContentHooks(def, tView, i) {
    if (def.afterContentInit) {
        (tView.contentHooks || (tView.contentHooks = [])).push(i, def.afterContentInit);
    }
    if (def.afterContentChecked) {
        (tView.contentHooks || (tView.contentHooks = [])).push(i, def.afterContentChecked);
        (tView.contentCheckHooks || (tView.contentCheckHooks = [])).push(i, def.afterContentChecked);
    }
}
/** Queues afterViewInit and afterViewChecked hooks on TView */
function queueViewHooks(def, tView, i) {
    if (def.afterViewInit) {
        (tView.viewHooks || (tView.viewHooks = [])).push(i, def.afterViewInit);
    }
    if (def.afterViewChecked) {
        (tView.viewHooks || (tView.viewHooks = [])).push(i, def.afterViewChecked);
        (tView.viewCheckHooks || (tView.viewCheckHooks = [])).push(i, def.afterViewChecked);
    }
}
/** Queues onDestroy hooks on TView */
function queueDestroyHooks(def, tView, i) {
    if (def.onDestroy != null) {
        (tView.destroyHooks || (tView.destroyHooks = [])).push(i, def.onDestroy);
    }
}
/**
 * Calls onInit and doCheck calls if they haven't already been called.
 *
 * @param currentView The current view
 */
function executeInitHooks(currentView, tView, creationMode) {
    if (currentView[FLAGS] & 16 /* RunInit */) {
        executeHooks(currentView[DIRECTIVES], tView.initHooks, tView.checkHooks, creationMode);
        currentView[FLAGS] &= ~16 /* RunInit */;
    }
}
/**
 * Iterates over afterViewInit and afterViewChecked functions and calls them.
 *
 * @param currentView The current view
 */
function executeHooks(data, allHooks, checkHooks, creationMode) {
    var hooksToCall = creationMode ? allHooks : checkHooks;
    if (hooksToCall) {
        callHooks(data, hooksToCall);
    }
}
/**
 * Calls lifecycle hooks with their contexts, skipping init hooks if it's not
 * creation mode.
 *
 * @param currentView The current view
 * @param arr The array in which the hooks are found
 */
function callHooks(data, arr) {
    for (var i = 0; i < arr.length; i += 2) {
        arr[i + 1].call(data[arr[i]]);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function ngDevModeResetPerfCounters() {
    var newCounters = {
        firstTemplatePass: 0,
        tNode: 0,
        tView: 0,
        rendererCreateTextNode: 0,
        rendererSetText: 0,
        rendererCreateElement: 0,
        rendererAddEventListener: 0,
        rendererSetAttribute: 0,
        rendererRemoveAttribute: 0,
        rendererSetProperty: 0,
        rendererSetClassName: 0,
        rendererAddClass: 0,
        rendererRemoveClass: 0,
        rendererSetStyle: 0,
        rendererRemoveStyle: 0,
        rendererDestroy: 0,
        rendererDestroyNode: 0,
        rendererMoveNode: 0,
        rendererRemoveNode: 0,
    };
    // NOTE: Under Ivy we may have both window & global defined in the Node
    //    environment since ensureDocument() in render3.ts sets global.window.
    if (typeof window != 'undefined') {
        // Make sure to refer to ngDevMode as ['ngDevMode'] for closure.
        window['ngDevMode'] = newCounters;
    }
    if (typeof global != 'undefined') {
        // Make sure to refer to ngDevMode as ['ngDevMode'] for closure.
        global['ngDevMode'] = newCounters;
    }
    if (typeof self != 'undefined') {
        // Make sure to refer to ngDevMode as ['ngDevMode'] for closure.
        self['ngDevMode'] = newCounters;
    }
    return newCounters;
}
/**
 * This checks to see if the `ngDevMode` has been set. If yes,
 * than we honor it, otherwise we default to dev mode with additional checks.
 *
 * The idea is that unless we are doing production build where we explicitly
 * set `ngDevMode == false` we should be helping the developer by providing
 * as much early warning and errors as possible.
 */
if (typeof ngDevMode === 'undefined' || ngDevMode) {
    /*@__PURE__*/ ngDevModeResetPerfCounters();
}
/** Called when directives inject each other (creating a circular dependency) */
function throwCyclicDependencyError(token) {
    throw new Error("Cannot instantiate cyclic dependency! " + token);
}
/** Called when there are multiple component selectors that match a given node */
function throwMultipleComponentError(tNode) {
    throw new Error("Multiple components match node with tagname " + tNode.tagName);
}
/** Throws an ExpressionChangedAfterChecked error if checkNoChanges mode is on. */
function throwErrorIfNoChangesMode(creationMode, checkNoChangesMode, oldValue, currValue) {
    if (checkNoChangesMode) {
        var msg = "ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '" + oldValue + "'. Current value: '" + currValue + "'.";
        if (creationMode) {
            msg +=
                " It seems like the view has been created after its parent and its children have been dirty checked." +
                    " Has it been created in a change detection hook ?";
        }
        // TODO: include debug context
        throw new Error(msg);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Below are constants for LContainer indices to help us look up LContainer members
 * without having to remember the specific indices.
 * Uglify will inline these when minifying so there shouldn't be a cost.
 */
var ACTIVE_INDEX = 0;
// PARENT, NEXT, and QUERIES are indices 1, 2, and 3.
// As we already have these constants in LViewData, we don't need to re-create them.
var VIEWS = 4;
var RENDER_PARENT = 5;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NG_PROJECT_AS_ATTR_NAME = 'ngProjectAs';
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// TODO: cleanup once the code is merged in angular/angular
var RendererStyleFlags3 = /*@__PURE__*/ (function (RendererStyleFlags3) {
    RendererStyleFlags3[RendererStyleFlags3["Important"] = 1] = "Important";
    RendererStyleFlags3[RendererStyleFlags3["DashCase"] = 2] = "DashCase";
    return RendererStyleFlags3;
})({});
/** Returns whether the `renderer` is a `ProceduralRenderer3` */
function isProceduralRenderer(renderer) {
    return !!(renderer.listen);
}
var domRendererFactory3 = {
    createRenderer: function (hostElement, rendererType) { return document; }
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function assertNodeType(node, type) {
    assertDefined(node, 'should be called with a node');
    assertEqual(node.tNode.type, type, "should be a " + typeName(type));
}
function assertNodeOfPossibleTypes(node) {
    var types = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        types[_i - 1] = arguments[_i];
    }
    assertDefined(node, 'should be called with a node');
    var found = types.some(function (type) { return node.tNode.type === type; });
    assertEqual(found, true, "Should be one of " + types.map(typeName).join(', '));
}
function typeName(type) {
    if (type == 1 /* Projection */)
        return 'Projection';
    if (type == 0 /* Container */)
        return 'Container';
    if (type == 2 /* View */)
        return 'View';
    if (type == 3 /* Element */)
        return 'Element';
    return '<unknown>';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
* Must use this method for CD (instead of === ) since NaN !== NaN
*/
function isDifferent(a, b) {
    // NaN is the only value that is not equal to itself so the first
    // test checks if both a and b are not NaN
    return !(a !== a && b !== b) && a !== b;
}
function stringify$1(value) {
    if (typeof value == 'function')
        return value.name || value;
    if (typeof value == 'string')
        return value;
    if (value == null)
        return '';
    return '' + value;
}
/**
 * Flattens an array in non-recursive way. Input arrays are not modified.
 */
function flatten$1(list) {
    var result = [];
    var i = 0;
    while (i < list.length) {
        var item = list[i];
        if (Array.isArray(item)) {
            if (item.length > 0) {
                list = item.concat(list.slice(i + 1));
                i = 0;
            }
            else {
                i++;
            }
        }
        else {
            result.push(item);
            i++;
        }
    }
    return result;
}
/** Retrieves a value from any `LViewData`. */
function loadInternal(index, arr) {
    ngDevMode && assertDataInRangeInternal(index + HEADER_OFFSET, arr);
    return arr[index + HEADER_OFFSET];
}
function assertDataInRangeInternal(index, arr) {
    assertLessThan(index, arr ? arr.length : 0, 'index expected to be a valid data index');
}
/** Retrieves an element value from the provided `viewData`.
  *
  * Elements that are read may be wrapped in a style context,
  * therefore reading the value may involve unwrapping that.
  */
function loadElementInternal(index, arr) {
    var value = loadInternal(index, arr);
    return readElementValue(value);
}
function readElementValue(value) {
    return (Array.isArray(value) ? value[0] : value);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Retrieves the sibling node for the given node. */
function getNextLNode(node) {
    // View nodes don't have TNodes, so their next must be retrieved through their LView.
    if (node.tNode.type === 2 /* View */) {
        var viewData = node.data;
        return viewData[NEXT] ? viewData[NEXT][HOST_NODE] : null;
    }
    return node.tNode.next ? node.view[node.tNode.next.index] : null;
}
/** Retrieves the first child of a given node */
function getChildLNode(node) {
    if (node.tNode.child) {
        var viewData = node.tNode.type === 2 /* View */ ? node.data : node.view;
        return readElementValue(viewData[node.tNode.child.index]);
    }
    return null;
}
function getParentLNode(node) {
    if (node.tNode.index === -1 && node.tNode.type === 2 /* View */) {
        // This is a dynamically created view inside a dynamic container.
        // If the host index is -1, the view has not yet been inserted, so it has no parent.
        var containerHostIndex = node.data[CONTAINER_INDEX];
        return containerHostIndex === -1 ? null : node.view[containerHostIndex].dynamicLContainerNode;
    }
    var parent = node.tNode.parent;
    return readElementValue(parent ? node.view[parent.index] : node.view[HOST_NODE]);
}
/**
 * Stack used to keep track of projection nodes in walkLNodeTree.
 *
 * This is deliberately created outside of walkLNodeTree to avoid allocating
 * a new array each time the function is called. Instead the array will be
 * re-used by each invocation. This works because the function is not reentrant.
 */
var projectionNodeStack = [];
/**
 * Walks a tree of LNodes, applying a transformation on the LElement nodes, either only on the first
 * one found, or on all of them.
 *
 * @param startingNode the node from which the walk is started.
 * @param rootNode the root node considered. This prevents walking past that node.
 * @param action identifies the action to be performed on the LElement nodes.
 * @param renderer the current renderer.
 * @param renderParentNode Optional the render parent node to be set in all LContainerNodes found,
 * required for action modes Insert and Destroy.
 * @param beforeNode Optional the node before which elements should be added, required for action
 * Insert.
 */
function walkLNodeTree(startingNode, rootNode, action, renderer, renderParentNode, beforeNode) {
    var node = startingNode;
    var projectionNodeIndex = -1;
    while (node) {
        var nextNode = null;
        var parent_1 = renderParentNode ? renderParentNode.native : null;
        var nodeType = node.tNode.type;
        if (nodeType === 3 /* Element */) {
            // Execute the action
            executeNodeAction(action, renderer, parent_1, node.native, beforeNode);
            if (node.dynamicLContainerNode) {
                executeNodeAction(action, renderer, parent_1, node.dynamicLContainerNode.native, beforeNode);
            }
        }
        else if (nodeType === 0 /* Container */) {
            executeNodeAction(action, renderer, parent_1, node.native, beforeNode);
            var lContainerNode = node;
            var childContainerData = lContainerNode.dynamicLContainerNode ?
                lContainerNode.dynamicLContainerNode.data :
                lContainerNode.data;
            if (renderParentNode) {
                childContainerData[RENDER_PARENT] = renderParentNode;
            }
            nextNode =
                childContainerData[VIEWS].length ? getChildLNode(childContainerData[VIEWS][0]) : null;
            if (nextNode) {
                // When the walker enters a container, then the beforeNode has to become the local native
                // comment node.
                beforeNode = lContainerNode.dynamicLContainerNode ?
                    lContainerNode.dynamicLContainerNode.native :
                    lContainerNode.native;
            }
        }
        else if (nodeType === 1 /* Projection */) {
            var componentHost = findComponentHost(node.view);
            var head = componentHost.tNode.projection[node.tNode.projection];
            projectionNodeStack[++projectionNodeIndex] = node;
            nextNode = head ? componentHost.data[PARENT][head.index] : null;
        }
        else {
            // Otherwise look at the first child
            nextNode = getChildLNode(node);
        }
        if (nextNode === null) {
            nextNode = getNextLNode(node);
            // this last node was projected, we need to get back down to its projection node
            if (nextNode === null && (node.tNode.flags & 8192 /* isProjected */)) {
                nextNode = getNextLNode(projectionNodeStack[projectionNodeIndex--]);
            }
            /**
             * Find the next node in the LNode tree, taking into account the place where a node is
             * projected (in the shadow DOM) rather than where it comes from (in the light DOM).
             *
             * If there is no sibling node, then it goes to the next sibling of the parent node...
             * until it reaches rootNode (at which point null is returned).
             */
            while (node && !nextNode) {
                node = getParentLNode(node);
                if (node === null || node === rootNode)
                    return null;
                // When exiting a container, the beforeNode must be restored to the previous value
                if (!node.tNode.next && nodeType === 0 /* Container */) {
                    beforeNode = node.native;
                }
                nextNode = getNextLNode(node);
            }
        }
        node = nextNode;
    }
}
/**
 * Given a current view, finds the nearest component's host (LElement).
 *
 * @param lViewData LViewData for which we want a host element node
 * @returns The host node
 */
function findComponentHost(lViewData) {
    var viewRootLNode = lViewData[HOST_NODE];
    while (viewRootLNode.tNode.type === 2 /* View */) {
        ngDevMode && assertDefined(lViewData[PARENT], 'lViewData.parent');
        lViewData = lViewData[PARENT];
        viewRootLNode = lViewData[HOST_NODE];
    }
    ngDevMode && assertNodeType(viewRootLNode, 3 /* Element */);
    ngDevMode && assertDefined(viewRootLNode.data, 'node.data');
    return viewRootLNode;
}
/**
 * NOTE: for performance reasons, the possible actions are inlined within the function instead of
 * being passed as an argument.
 */
function executeNodeAction(action, renderer, parent, node, beforeNode) {
    if (action === 0 /* Insert */) {
        isProceduralRenderer(renderer) ?
            renderer.insertBefore(parent, node, beforeNode) :
            parent.insertBefore(node, beforeNode, true);
    }
    else if (action === 1 /* Detach */) {
        isProceduralRenderer(renderer) ?
            renderer.removeChild(parent, node) :
            parent.removeChild(node);
    }
    else if (action === 2 /* Destroy */) {
        ngDevMode && ngDevMode.rendererDestroyNode++;
        renderer.destroyNode(node);
    }
}
function createTextNode(value, renderer) {
    return isProceduralRenderer(renderer) ? renderer.createText(stringify$1(value)) :
        renderer.createTextNode(stringify$1(value));
}
function addRemoveViewFromContainer(container, rootNode, insertMode, beforeNode) {
    ngDevMode && assertNodeType(container, 0 /* Container */);
    ngDevMode && assertNodeType(rootNode, 2 /* View */);
    var parentNode = container.data[RENDER_PARENT];
    var parent = parentNode ? parentNode.native : null;
    if (parent) {
        var node = getChildLNode(rootNode);
        var renderer = container.view[RENDERER];
        walkLNodeTree(node, rootNode, insertMode ? 0 /* Insert */ : 1 /* Detach */, renderer, parentNode, beforeNode);
    }
}
/**
 * Traverses down and up the tree of views and containers to remove listeners and
 * call onDestroy callbacks.
 *
 * Notes:
 *  - Because it's used for onDestroy calls, it needs to be bottom-up.
 *  - Must process containers instead of their views to avoid splicing
 *  when views are destroyed and re-added.
 *  - Using a while loop because it's faster than recursion
 *  - Destroy only called on movement to sibling or movement to parent (laterally or up)
 *
 *  @param rootView The view to destroy
 */
function destroyViewTree(rootView) {
    // If the view has no children, we can clean it up and return early.
    if (rootView[TVIEW].childIndex === -1) {
        return cleanUpView(rootView);
    }
    var viewOrContainer = getLViewChild(rootView);
    while (viewOrContainer) {
        var next = null;
        if (viewOrContainer.length >= HEADER_OFFSET) {
            // If LViewData, traverse down to child.
            var view = viewOrContainer;
            if (view[TVIEW].childIndex > -1)
                next = getLViewChild(view);
        }
        else {
            // If container, traverse down to its first LViewData.
            var container = viewOrContainer;
            if (container[VIEWS].length)
                next = container[VIEWS][0].data;
        }
        if (next == null) {
            // Only clean up view when moving to the side or up, as destroy hooks
            // should be called in order from the bottom up.
            while (viewOrContainer && !viewOrContainer[NEXT] && viewOrContainer !== rootView) {
                cleanUpView(viewOrContainer);
                viewOrContainer = getParentState(viewOrContainer, rootView);
            }
            cleanUpView(viewOrContainer || rootView);
            next = viewOrContainer && viewOrContainer[NEXT];
        }
        viewOrContainer = next;
    }
}
/**
 * Inserts a view into a container.
 *
 * This adds the view to the container's array of active views in the correct
 * position. It also adds the view's elements to the DOM if the container isn't a
 * root node of another view (in that case, the view's elements will be added when
 * the container's parent view is added later).
 *
 * @param container The container into which the view should be inserted
 * @param viewNode The view to insert
 * @param index The index at which to insert the view
 * @returns The inserted view
 */
function insertView(container, viewNode, index) {
    var state = container.data;
    var views = state[VIEWS];
    var lView = viewNode.data;
    if (index > 0) {
        // This is a new view, we need to add it to the children.
        views[index - 1].data[NEXT] = lView;
    }
    if (index < views.length) {
        lView[NEXT] = views[index].data;
        views.splice(index, 0, viewNode);
    }
    else {
        views.push(viewNode);
        lView[NEXT] = null;
    }
    // Dynamically inserted views need a reference to their parent container'S host so it's
    // possible to jump from a view to its container's next when walking the node tree.
    if (viewNode.tNode.index === -1) {
        lView[CONTAINER_INDEX] = container.tNode.parent.index;
        viewNode.view = container.view;
    }
    // Notify query that a new view has been added
    if (lView[QUERIES]) {
        lView[QUERIES].insertView(index);
    }
    // Sets the attached flag
    lView[FLAGS] |= 8 /* Attached */;
    return viewNode;
}
/**
 * Detaches a view from a container.
 *
 * This method splices the view from the container's array of active views. It also
 * removes the view's elements from the DOM.
 *
 * @param container The container from which to detach a view
 * @param removeIndex The index of the view to detach
 * @returns The detached view
 */
function detachView(container, removeIndex) {
    var views = container.data[VIEWS];
    var viewNode = views[removeIndex];
    if (removeIndex > 0) {
        views[removeIndex - 1].data[NEXT] = viewNode.data[NEXT];
    }
    views.splice(removeIndex, 1);
    if (!container.tNode.detached) {
        addRemoveViewFromContainer(container, viewNode, false);
    }
    // Notify query that view has been removed
    var removedLView = viewNode.data;
    if (removedLView[QUERIES]) {
        removedLView[QUERIES].removeView();
    }
    removedLView[CONTAINER_INDEX] = -1;
    viewNode.view = null;
    // Unsets the attached flag
    viewNode.data[FLAGS] &= ~8 /* Attached */;
    return viewNode;
}
/**
 * Removes a view from a container, i.e. detaches it and then destroys the underlying LView.
 *
 * @param container The container from which to remove a view
 * @param removeIndex The index of the view to remove
 * @returns The removed view
 */
function removeView(container, removeIndex) {
    var viewNode = container.data[VIEWS][removeIndex];
    detachView(container, removeIndex);
    destroyLView(viewNode.data);
    return viewNode;
}
/** Gets the child of the given LViewData */
function getLViewChild(viewData) {
    if (viewData[TVIEW].childIndex === -1)
        return null;
    var hostNode = viewData[viewData[TVIEW].childIndex];
    return hostNode.data ? hostNode.data : hostNode.dynamicLContainerNode.data;
}
/**
 * A standalone function which destroys an LView,
 * conducting cleanup (e.g. removing listeners, calling onDestroys).
 *
 * @param view The view to be destroyed.
 */
function destroyLView(view) {
    var renderer = view[RENDERER];
    if (isProceduralRenderer(renderer) && renderer.destroyNode) {
        walkLNodeTree(view[HOST_NODE], view[HOST_NODE], 2 /* Destroy */, renderer);
    }
    destroyViewTree(view);
    // Sets the destroyed flag
    view[FLAGS] |= 32 /* Destroyed */;
}
/**
 * Determines which LViewOrLContainer to jump to when traversing back up the
 * tree in destroyViewTree.
 *
 * Normally, the view's parent LView should be checked, but in the case of
 * embedded views, the container (which is the view node's parent, but not the
 * LView's parent) needs to be checked for a possible next property.
 *
 * @param state The LViewOrLContainer for which we need a parent state
 * @param rootView The rootView, so we don't propagate too far up the view tree
 * @returns The correct parent LViewOrLContainer
 */
function getParentState(state, rootView) {
    var node;
    if ((node = state[HOST_NODE]) && node.tNode.type === 2 /* View */) {
        // if it's an embedded view, the state needs to go up to the container, in case the
        // container has a next
        return getParentLNode(node).data;
    }
    else {
        // otherwise, use parent view for containers or component views
        return state[PARENT] === rootView ? null : state[PARENT];
    }
}
/**
 * Removes all listeners and call all onDestroys in a given view.
 *
 * @param view The LViewData to clean up
 */
function cleanUpView(viewOrContainer) {
    if (viewOrContainer[TVIEW]) {
        var view = viewOrContainer;
        removeListeners(view);
        executeOnDestroys(view);
        executePipeOnDestroys(view);
        // For component views only, the local renderer is destroyed as clean up time.
        if (view[TVIEW].id === -1 && isProceduralRenderer(view[RENDERER])) {
            ngDevMode && ngDevMode.rendererDestroy++;
            view[RENDERER].destroy();
        }
    }
}
/** Removes listeners and unsubscribes from output subscriptions */
function removeListeners(viewData) {
    var cleanup = viewData[TVIEW].cleanup;
    if (cleanup != null) {
        for (var i = 0; i < cleanup.length - 1; i += 2) {
            if (typeof cleanup[i] === 'string') {
                // This is a listener with the native renderer
                var native = readElementValue(viewData[cleanup[i + 1]]).native;
                var listener = viewData[CLEANUP][cleanup[i + 2]];
                native.removeEventListener(cleanup[i], listener, cleanup[i + 3]);
                i += 2;
            }
            else if (typeof cleanup[i] === 'number') {
                // This is a listener with renderer2 (cleanup fn can be found by index)
                var cleanupFn = viewData[CLEANUP][cleanup[i]];
                cleanupFn();
            }
            else {
                // This is a cleanup function that is grouped with the index of its context
                var context = viewData[CLEANUP][cleanup[i + 1]];
                cleanup[i].call(context);
            }
        }
        viewData[CLEANUP] = null;
    }
}
/** Calls onDestroy hooks for this view */
function executeOnDestroys(view) {
    var tView = view[TVIEW];
    var destroyHooks;
    if (tView != null && (destroyHooks = tView.destroyHooks) != null) {
        callHooks(view[DIRECTIVES], destroyHooks);
    }
}
/** Calls pipe destroy hooks for this view */
function executePipeOnDestroys(viewData) {
    var pipeDestroyHooks = viewData[TVIEW] && viewData[TVIEW].pipeDestroyHooks;
    if (pipeDestroyHooks) {
        callHooks(viewData, pipeDestroyHooks);
    }
}
/**
 * Returns whether a native element can be inserted into the given parent.
 *
 * There are two reasons why we may not be able to insert a element immediately.
 * - Projection: When creating a child content element of a component, we have to skip the
 *   insertion because the content of a component will be projected.
 *   `<component><content>delayed due to projection</content></component>`
 * - Parent container is disconnected: This can happen when we are inserting a view into
 *   parent container, which itself is disconnected. For example the parent container is part
 *   of a View which has not be inserted or is mare for projection but has not been inserted
 *   into destination.
 *

 *
 * @param parent The parent where the child will be inserted into.
 * @param currentView Current LView being processed.
 * @return boolean Whether the child should be inserted now (or delayed until later).
 */
function canInsertNativeNode(parent, currentView) {
    // We can only insert into a Component or View. Any other type should be an Error.
    ngDevMode && assertNodeOfPossibleTypes(parent, 3 /* Element */, 2 /* View */);
    if (parent.tNode.type === 3 /* Element */) {
        // Parent is an element.
        if (parent.view !== currentView) {
            // If the Parent view is not the same as current view than we are inserting across
            // Views. This happens when we insert a root element of the component view into
            // the component host element and it should always be eager.
            return true;
        }
        // Parent elements can be a component which may have projection.
        if (parent.data === null) {
            // Parent is a regular non-component element. We should eagerly insert into it
            // since we know that this relationship will never be broken.
            return true;
        }
        else {
            // Parent is a Component. Component's content nodes are not inserted immediately
            // because they will be projected, and so doing insert at this point would be wasteful.
            // Since the projection would than move it to its final destination.
            return false;
        }
    }
    else {
        // Parent is a View.
        ngDevMode && assertNodeType(parent, 2 /* View */);
        // Because we are inserting into a `View` the `View` may be disconnected.
        var grandParentContainer = getParentLNode(parent);
        if (grandParentContainer == null) {
            // The `View` is not inserted into a `Container` we have to delay insertion.
            return false;
        }
        ngDevMode && assertNodeType(grandParentContainer, 0 /* Container */);
        if (grandParentContainer.data[RENDER_PARENT] == null) {
            // The parent `Container` itself is disconnected. So we have to delay.
            return false;
        }
        else {
            // The parent `Container` is in inserted state, so we can eagerly insert into
            // this location.
            return true;
        }
    }
}
/**
 * Appends the `child` element to the `parent`.
 *
 * The element insertion might be delayed {@link canInsertNativeNode}.
 *
 * @param parent The parent to which to append the child
 * @param child The child that should be appended
 * @param currentView The current LView
 * @returns Whether or not the child was appended
 */
function appendChild(parent, child, currentView) {
    if (child !== null && canInsertNativeNode(parent, currentView)) {
        var renderer = currentView[RENDERER];
        if (parent.tNode.type === 2 /* View */) {
            var container = getParentLNode(parent);
            var renderParent = container.data[RENDER_PARENT];
            var views = container.data[VIEWS];
            var index = views.indexOf(parent);
            var beforeNode = index + 1 < views.length ? (getChildLNode(views[index + 1])).native : container.native;
            isProceduralRenderer(renderer) ?
                renderer.insertBefore(renderParent.native, child, beforeNode) :
                renderParent.native.insertBefore(child, beforeNode, true);
        }
        else {
            isProceduralRenderer(renderer) ? renderer.appendChild(parent.native, child) :
                parent.native.appendChild(child);
        }
        return true;
    }
    return false;
}
/**
 * Removes the `child` element of the `parent` from the DOM.
 *
 * @param parent The parent from which to remove the child
 * @param child The child that should be removed
 * @param currentView The current LView
 * @returns Whether or not the child was removed
 */
function removeChild(parent, child, currentView) {
    if (child !== null && canInsertNativeNode(parent, currentView)) {
        // We only remove the element if not in View or not projected.
        var renderer = currentView[RENDERER];
        isProceduralRenderer(renderer) ? renderer.removeChild(parent.native, child) :
            parent.native.removeChild(child);
        return true;
    }
    return false;
}
/**
 * Appends a projected node to the DOM, or in the case of a projected container,
 * appends the nodes from all of the container's active views to the DOM.
 *
 * @param node The node to process
 * @param currentParent The last parent element to be processed
 * @param currentView Current LView
 */
function appendProjectedNode(node, currentParent, currentView, renderParent) {
    appendChild(currentParent, node.native, currentView);
    if (node.tNode.type === 0 /* Container */) {
        // The node we are adding is a container and we are adding it to an element which
        // is not a component (no more re-projection).
        // Alternatively a container is projected at the root of a component's template
        // and can't be re-projected (as not content of any component).
        // Assign the final projection location in those cases.
        var lContainer = node.data;
        lContainer[RENDER_PARENT] = renderParent;
        var views = lContainer[VIEWS];
        for (var i = 0; i < views.length; i++) {
            addRemoveViewFromContainer(node, views[i], true, node.native);
        }
    }
    if (node.dynamicLContainerNode) {
        node.dynamicLContainerNode.data[RENDER_PARENT] = renderParent;
        appendChild(currentParent, node.dynamicLContainerNode.native, currentView);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function isCssClassMatching(nodeClassAttrVal, cssClassToMatch) {
    var nodeClassesLen = nodeClassAttrVal.length;
    var matchIndex = nodeClassAttrVal.indexOf(cssClassToMatch);
    var matchEndIdx = matchIndex + cssClassToMatch.length;
    if (matchIndex === -1 // no match
        || (matchIndex > 0 && nodeClassAttrVal[matchIndex - 1] !== ' ') // no space before
        ||
            (matchEndIdx < nodeClassesLen && nodeClassAttrVal[matchEndIdx] !== ' ')) {
        return false;
    }
    return true;
}
/**
 * A utility function to match an Ivy node static data against a simple CSS selector
 *
 * @param node static data to match
 * @param selector
 * @returns true if node matches the selector.
 */
function isNodeMatchingSelector(tNode, selector) {
    ngDevMode && assertDefined(selector[0], 'Selector should have a tag name');
    var mode = 4 /* ELEMENT */;
    var nodeAttrs = tNode.attrs;
    var selectOnlyMarkerIdx = nodeAttrs ? nodeAttrs.indexOf(1 /* SelectOnly */) : -1;
    // When processing ":not" selectors, we skip to the next ":not" if the
    // current one doesn't match
    var skipToNextSelector = false;
    for (var i = 0; i < selector.length; i++) {
        var current = selector[i];
        if (typeof current === 'number') {
            // If we finish processing a :not selector and it hasn't failed, return false
            if (!skipToNextSelector && !isPositive(mode) && !isPositive(current)) {
                return false;
            }
            // If we are skipping to the next :not() and this mode flag is positive,
            // it's a part of the current :not() selector, and we should keep skipping
            if (skipToNextSelector && isPositive(current))
                continue;
            skipToNextSelector = false;
            mode = current | (mode & 1 /* NOT */);
            continue;
        }
        if (skipToNextSelector)
            continue;
        if (mode & 4 /* ELEMENT */) {
            mode = 2 /* ATTRIBUTE */ | mode & 1 /* NOT */;
            if (current !== '' && current !== tNode.tagName) {
                if (isPositive(mode))
                    return false;
                skipToNextSelector = true;
            }
        }
        else {
            var attrName = mode & 8 /* CLASS */ ? 'class' : current;
            var attrIndexInNode = findAttrIndexInNode(attrName, nodeAttrs);
            if (attrIndexInNode === -1) {
                if (isPositive(mode))
                    return false;
                skipToNextSelector = true;
                continue;
            }
            var selectorAttrValue = mode & 8 /* CLASS */ ? current : selector[++i];
            if (selectorAttrValue !== '') {
                var nodeAttrValue = void 0;
                var maybeAttrName = nodeAttrs[attrIndexInNode];
                if (selectOnlyMarkerIdx > -1 && attrIndexInNode > selectOnlyMarkerIdx) {
                    nodeAttrValue = '';
                }
                else {
                    ngDevMode && assertNotEqual(maybeAttrName, 0 /* NamespaceURI */, 'We do not match directives on namespaced attributes');
                    nodeAttrValue = nodeAttrs[attrIndexInNode + 1];
                }
                if (mode & 8 /* CLASS */ &&
                    !isCssClassMatching(nodeAttrValue, selectorAttrValue) ||
                    mode & 2 /* ATTRIBUTE */ && selectorAttrValue !== nodeAttrValue) {
                    if (isPositive(mode))
                        return false;
                    skipToNextSelector = true;
                }
            }
        }
    }
    return isPositive(mode) || skipToNextSelector;
}
function isPositive(mode) {
    return (mode & 1 /* NOT */) === 0;
}
/**
 * Examines an attributes definition array from a node to find the index of the
 * attribute with the specified name.
 *
 * NOTE: Will not find namespaced attributes.
 *
 * @param name the name of the attribute to find
 * @param attrs the attribute array to examine
 */
function findAttrIndexInNode(name, attrs) {
    if (attrs === null)
        return -1;
    var selectOnlyMode = false;
    var i = 0;
    while (i < attrs.length) {
        var maybeAttrName = attrs[i];
        if (maybeAttrName === name) {
            return i;
        }
        else if (maybeAttrName === 0 /* NamespaceURI */) {
            // NOTE(benlesh): will not find namespaced attributes. This is by design.
            i += 4;
        }
        else {
            if (maybeAttrName === 1 /* SelectOnly */) {
                selectOnlyMode = true;
            }
            i += selectOnlyMode ? 1 : 2;
        }
    }
    return -1;
}
function isNodeMatchingSelectorList(tNode, selector) {
    for (var i = 0; i < selector.length; i++) {
        if (isNodeMatchingSelector(tNode, selector[i])) {
            return true;
        }
    }
    return false;
}
function getProjectAsAttrValue(tNode) {
    var nodeAttrs = tNode.attrs;
    if (nodeAttrs != null) {
        var ngProjectAsAttrIdx = nodeAttrs.indexOf(NG_PROJECT_AS_ATTR_NAME);
        // only check for ngProjectAs in attribute names, don't accidentally match attribute's value
        // (attribute names are stored at even indexes)
        if ((ngProjectAsAttrIdx & 1) === 0) {
            return nodeAttrs[ngProjectAsAttrIdx + 1];
        }
    }
    return null;
}
/**
 * Checks a given node against matching selectors and returns
 * selector index (or 0 if none matched).
 *
 * This function takes into account the ngProjectAs attribute: if present its value will be compared
 * to the raw (un-parsed) CSS selector instead of using standard selector matching logic.
 */
function matchingSelectorIndex(tNode, selectors, textSelectors) {
    var ngProjectAsAttrVal = getProjectAsAttrValue(tNode);
    for (var i = 0; i < selectors.length; i++) {
        // if a node has the ngProjectAs attribute match it against unparsed selector
        // match a node against a parsed selector only if ngProjectAs attribute is not present
        if (ngProjectAsAttrVal === textSelectors[i] ||
            ngProjectAsAttrVal === null && isNodeMatchingSelectorList(tNode, selectors[i])) {
            return i + 1; // first matching selector "captures" a given node
        }
    }
    return 0;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used clone a copy of a pre-computed template of a styling context.
 *
 * A pre-computed template is designed to be computed once for a given element
 * (instructions.ts has logic for caching this).
 */
function allocStylingContext(lElement, templateStyleContext) {
    // each instance gets a copy
    var context = templateStyleContext.slice();
    context[0 /* ElementPosition */] = lElement;
    return context;
}
/**
 * Creates a styling context template where styling information is stored.
 * Any styles that are later referenced using `updateStyleProp` must be
 * passed in within this function. Initial values for those styles are to
 * be declared after all initial style properties are declared (this change in
 * mode between declarations and initial styles is made possible using a special
 * enum value found in `definition.ts`).
 *
 * @param initialStyleDeclarations a list of style declarations and initial style values
 *    that are used later within the styling context.
 *
 *    -> ['width', 'height', SPECIAL_ENUM_VAL, 'width', '100px']
 *       This implies that `width` and `height` will be later styled and that the `width`
 *       property has an initial value of `100px`.
 *
 * @param initialClassDeclarations a list of class declarations and initial class values
 *    that are used later within the styling context.
 *
 *    -> ['foo', 'bar', SPECIAL_ENUM_VAL, 'foo', true]
 *       This implies that `foo` and `bar` will be later styled and that the `foo`
 *       class will be applied to the element as an initial class since it's true
 */
function createStylingContextTemplate(initialClassDeclarations, initialStyleDeclarations, styleSanitizer) {
    var initialStylingValues = [null];
    var context = [null, styleSanitizer || null, initialStylingValues, 0, 0, null];
    // we use two maps since a class name might collide with a CSS style prop
    var stylesLookup = {};
    var classesLookup = {};
    var totalStyleDeclarations = 0;
    if (initialStyleDeclarations) {
        var hasPassedDeclarations = false;
        for (var i = 0; i < initialStyleDeclarations.length; i++) {
            var v = initialStyleDeclarations[i];
            // this flag value marks where the declarations end the initial values begin
            if (v === 1 /* VALUES_MODE */) {
                hasPassedDeclarations = true;
            }
            else {
                var prop = v;
                if (hasPassedDeclarations) {
                    var value = initialStyleDeclarations[++i];
                    initialStylingValues.push(value);
                    stylesLookup[prop] = initialStylingValues.length - 1;
                }
                else {
                    totalStyleDeclarations++;
                    stylesLookup[prop] = 0;
                }
            }
        }
    }
    // make where the class offsets begin
    context[4 /* ClassOffsetPosition */] = totalStyleDeclarations;
    if (initialClassDeclarations) {
        var hasPassedDeclarations = false;
        for (var i = 0; i < initialClassDeclarations.length; i++) {
            var v = initialClassDeclarations[i];
            // this flag value marks where the declarations end the initial values begin
            if (v === 1 /* VALUES_MODE */) {
                hasPassedDeclarations = true;
            }
            else {
                var className = v;
                if (hasPassedDeclarations) {
                    var value = initialClassDeclarations[++i];
                    initialStylingValues.push(value);
                    classesLookup[className] = initialStylingValues.length - 1;
                }
                else {
                    classesLookup[className] = 0;
                }
            }
        }
    }
    var styleProps = Object.keys(stylesLookup);
    var classNames = Object.keys(classesLookup);
    var classNamesIndexStart = styleProps.length;
    var totalProps = styleProps.length + classNames.length;
    // *2 because we are filling for both single and multi style spaces
    var maxLength = totalProps * 3 /* Size */ * 2 + 6 /* SingleStylesStartPosition */;
    // we need to fill the array from the start so that we can access
    // both the multi and the single array positions in the same loop block
    for (var i = 6 /* SingleStylesStartPosition */; i < maxLength; i++) {
        context.push(null);
    }
    var singleStart = 6 /* SingleStylesStartPosition */;
    var multiStart = totalProps * 3 /* Size */ + 6 /* SingleStylesStartPosition */;
    // fill single and multi-level styles
    for (var i = 0; i < totalProps; i++) {
        var isClassBased_1 = i >= classNamesIndexStart;
        var prop = isClassBased_1 ? classNames[i - classNamesIndexStart] : styleProps[i];
        var indexForInitial = isClassBased_1 ? classesLookup[prop] : stylesLookup[prop];
        var initialValue = initialStylingValues[indexForInitial];
        var indexForMulti = i * 3 /* Size */ + multiStart;
        var indexForSingle = i * 3 /* Size */ + singleStart;
        var initialFlag = prepareInitialFlag(prop, isClassBased_1, styleSanitizer || null);
        setFlag(context, indexForSingle, pointers(initialFlag, indexForInitial, indexForMulti));
        setProp(context, indexForSingle, prop);
        setValue(context, indexForSingle, null);
        var flagForMulti = initialFlag | (initialValue !== null ? 1 /* Dirty */ : 0 /* None */);
        setFlag(context, indexForMulti, pointers(flagForMulti, indexForInitial, indexForSingle));
        setProp(context, indexForMulti, prop);
        setValue(context, indexForMulti, null);
    }
    // there is no initial value flag for the master index since it doesn't
    // reference an initial style value
    setFlag(context, 3 /* MasterFlagPosition */, pointers(0, 0, multiStart));
    setContextDirty(context, initialStylingValues.length > 1);
    return context;
}
var EMPTY_ARR = [];
var EMPTY_OBJ = {};
/**
 * Sets and resolves all `multi` styling on an `StylingContext` so that they can be
 * applied to the element once `renderStyling` is called.
 *
 * All missing styles/class (any values that are not provided in the new `styles`
 * or `classes` params) will resolve to `null` within their respective positions
 * in the context.
 *
 * @param context The styling context that will be updated with the
 *    newly provided style values.
 * @param classes The key/value map of CSS class names that will be used for the update.
 * @param styles The key/value map of CSS styles that will be used for the update.
 */
function updateStylingMap(context, classes, styles) {
    var classNames = EMPTY_ARR;
    var applyAllClasses = false;
    var ignoreAllClassUpdates = false;
    // each time a string-based value pops up then it shouldn't require a deep
    // check of what's changed.
    if (typeof classes == 'string') {
        var cachedClassString = context[5 /* CachedCssClassString */];
        if (cachedClassString && cachedClassString === classes) {
            ignoreAllClassUpdates = true;
        }
        else {
            context[5 /* CachedCssClassString */] = classes;
            classNames = classes.split(/\s+/);
            // this boolean is used to avoid having to create a key/value map of `true` values
            // since a classname string implies that all those classes are added
            applyAllClasses = true;
        }
    }
    else {
        classNames = classes ? Object.keys(classes) : EMPTY_ARR;
        context[5 /* CachedCssClassString */] = null;
    }
    classes = (classes || EMPTY_OBJ);
    var styleProps = styles ? Object.keys(styles) : EMPTY_ARR;
    styles = styles || EMPTY_OBJ;
    var classesStartIndex = styleProps.length;
    var multiStartIndex = getMultiStartIndex(context);
    var dirty = false;
    var ctxIndex = multiStartIndex;
    var propIndex = 0;
    var propLimit = styleProps.length + classNames.length;
    // the main loop here will try and figure out how the shape of the provided
    // styles differ with respect to the context. Later if the context/styles/classes
    // are off-balance then they will be dealt in another loop after this one
    while (ctxIndex < context.length && propIndex < propLimit) {
        var isClassBased_2 = propIndex >= classesStartIndex;
        // when there is a cache-hit for a string-based class then we should
        // avoid doing any work diffing any of the changes
        if (!ignoreAllClassUpdates || !isClassBased_2) {
            var adjustedPropIndex = isClassBased_2 ? propIndex - classesStartIndex : propIndex;
            var newProp = isClassBased_2 ? classNames[adjustedPropIndex] : styleProps[adjustedPropIndex];
            var newValue = isClassBased_2 ? (applyAllClasses ? true : classes[newProp]) : styles[newProp];
            var prop = getProp(context, ctxIndex);
            if (prop === newProp) {
                var value = getValue(context, ctxIndex);
                var flag = getPointers(context, ctxIndex);
                if (hasValueChanged(flag, value, newValue)) {
                    setValue(context, ctxIndex, newValue);
                    var initialValue = getInitialValue(context, flag);
                    // there is no point in setting this to dirty if the previously
                    // rendered value was being referenced by the initial style (or null)
                    if (initialValue !== newValue) {
                        setDirty(context, ctxIndex, true);
                        dirty = true;
                    }
                }
            }
            else {
                var indexOfEntry = findEntryPositionByProp(context, newProp, ctxIndex);
                if (indexOfEntry > 0) {
                    // it was found at a later point ... just swap the values
                    var valueToCompare = getValue(context, indexOfEntry);
                    var flagToCompare = getPointers(context, indexOfEntry);
                    swapMultiContextEntries(context, ctxIndex, indexOfEntry);
                    if (valueToCompare !== newValue) {
                        var initialValue = getInitialValue(context, flagToCompare);
                        setValue(context, ctxIndex, newValue);
                        if (initialValue !== newValue) {
                            setDirty(context, ctxIndex, true);
                            dirty = true;
                        }
                    }
                }
                else {
                    // we only care to do this if the insertion is in the middle
                    var newFlag = prepareInitialFlag(newProp, isClassBased_2, getStyleSanitizer(context));
                    insertNewMultiProperty(context, ctxIndex, isClassBased_2, newProp, newFlag, newValue);
                    dirty = true;
                }
            }
        }
        ctxIndex += 3 /* Size */;
        propIndex++;
    }
    // this means that there are left-over values in the context that
    // were not included in the provided styles/classes and in this
    // case the  goal is to "remove" them from the context (by nullifying)
    while (ctxIndex < context.length) {
        var flag = getPointers(context, ctxIndex);
        var isClassBased_3 = (flag & 2 /* Class */) === 2 /* Class */;
        if (ignoreAllClassUpdates && isClassBased_3)
            break;
        var value = getValue(context, ctxIndex);
        var doRemoveValue = valueExists(value, isClassBased_3);
        if (doRemoveValue) {
            setDirty(context, ctxIndex, true);
            setValue(context, ctxIndex, null);
            dirty = true;
        }
        ctxIndex += 3 /* Size */;
    }
    // this means that there are left-over properties in the context that
    // were not detected in the context during the loop above. In that
    // case we want to add the new entries into the list
    var sanitizer = getStyleSanitizer(context);
    while (propIndex < propLimit) {
        var isClassBased_4 = propIndex >= classesStartIndex;
        if (ignoreAllClassUpdates && isClassBased_4)
            break;
        var adjustedPropIndex = isClassBased_4 ? propIndex - classesStartIndex : propIndex;
        var prop = isClassBased_4 ? classNames[adjustedPropIndex] : styleProps[adjustedPropIndex];
        var value = isClassBased_4 ? (applyAllClasses ? true : classes[prop]) : styles[prop];
        var flag = prepareInitialFlag(prop, isClassBased_4, sanitizer) | 1 /* Dirty */;
        context.push(flag, prop, value);
        propIndex++;
        dirty = true;
    }
    if (dirty) {
        setContextDirty(context, true);
    }
}
/**
 * Sets and resolves a single styling property/value on the provided `StylingContext` so
 * that they can be applied to the element once `renderStyling` is called.
 *
 * Note that prop-level styling values are considered higher priority than any styling that
 * has been applied using `updateStylingMap`, therefore, when styling values are rendered
 * then any styles/classes that have been applied using this function will be considered first
 * (then multi values second and then initial values as a backup).
 *
 * @param context The styling context that will be updated with the
 *    newly provided style value.
 * @param index The index of the property which is being updated.
 * @param value The CSS style value that will be assigned
 */
function updateStyleProp(context, index, value) {
    var singleIndex = 6 /* SingleStylesStartPosition */ + index * 3 /* Size */;
    var currValue = getValue(context, singleIndex);
    var currFlag = getPointers(context, singleIndex);
    // didn't change ... nothing to make a note of
    if (hasValueChanged(currFlag, currValue, value)) {
        // the value will always get updated (even if the dirty flag is skipped)
        setValue(context, singleIndex, value);
        var indexForMulti = getMultiOrSingleIndex(currFlag);
        // if the value is the same in the multi-area then there's no point in re-assembling
        var valueForMulti = getValue(context, indexForMulti);
        if (!valueForMulti || valueForMulti !== value) {
            var multiDirty = false;
            var singleDirty = true;
            var isClassBased_5 = (currFlag & 2 /* Class */) === 2 /* Class */;
            // only when the value is set to `null` should the multi-value get flagged
            if (!valueExists(value, isClassBased_5) && valueExists(valueForMulti, isClassBased_5)) {
                multiDirty = true;
                singleDirty = false;
            }
            setDirty(context, indexForMulti, multiDirty);
            setDirty(context, singleIndex, singleDirty);
            setContextDirty(context, true);
        }
    }
}
/**
 * This method will toggle the referenced CSS class (by the provided index)
 * within the given context.
 *
 * @param context The styling context that will be updated with the
 *    newly provided class value.
 * @param index The index of the CSS class which is being updated.
 * @param addOrRemove Whether or not to add or remove the CSS class
 */
function updateClassProp(context, index, addOrRemove) {
    var adjustedIndex = index + context[4 /* ClassOffsetPosition */];
    updateStyleProp(context, adjustedIndex, addOrRemove);
}
/**
 * Renders all queued styling using a renderer onto the given element.
 *
 * This function works by rendering any styles (that have been applied
 * using `updateStylingMap`) and any classes (that have been applied using
 * `updateStyleProp`) onto the provided element using the provided renderer.
 * Just before the styles/classes are rendered a final key/value style map
 * will be assembled (if `styleStore` or `classStore` are provided).
 *
 * @param lElement the element that the styles will be rendered on
 * @param context The styling context that will be used to determine
 *      what styles will be rendered
 * @param renderer the renderer that will be used to apply the styling
 * @param styleStore if provided, the updated style values will be applied
 *    to this key/value map instead of being renderered via the renderer.
 * @param classStore if provided, the updated class values will be applied
 *    to this key/value map instead of being renderered via the renderer.
 */
function renderStyling(context, renderer, styleStore, classStore) {
    if (isContextDirty(context)) {
        var native = context[0 /* ElementPosition */].native;
        var multiStartIndex = getMultiStartIndex(context);
        var styleSanitizer = getStyleSanitizer(context);
        for (var i = 6 /* SingleStylesStartPosition */; i < context.length; i += 3 /* Size */) {
            // there is no point in rendering styles that have not changed on screen
            if (isDirty(context, i)) {
                var prop = getProp(context, i);
                var value = getValue(context, i);
                var flag = getPointers(context, i);
                var isClassBased_6 = flag & 2 /* Class */ ? true : false;
                var isInSingleRegion = i < multiStartIndex;
                var valueToApply = value;
                // VALUE DEFER CASE 1: Use a multi value instead of a null single value
                // this check implies that a single value was removed and we
                // should now defer to a multi value and use that (if set).
                if (isInSingleRegion && !valueExists(valueToApply, isClassBased_6)) {
                    // single values ALWAYS have a reference to a multi index
                    var multiIndex = getMultiOrSingleIndex(flag);
                    valueToApply = getValue(context, multiIndex);
                }
                // VALUE DEFER CASE 2: Use the initial value if all else fails (is falsy)
                // the initial value will always be a string or null,
                // therefore we can safely adopt it incase there's nothing else
                // note that this should always be a falsy check since `false` is used
                // for both class and style comparisons (styles can't be false and false
                // classes are turned off and should therefore defer to their initial values)
                if (!valueExists(valueToApply, isClassBased_6)) {
                    valueToApply = getInitialValue(context, flag);
                }
                if (isClassBased_6) {
                    setClass(native, prop, valueToApply ? true : false, renderer, classStore);
                }
                else {
                    var sanitizer = (flag & 4 /* Sanitize */) ? styleSanitizer : null;
                    setStyle(native, prop, valueToApply, renderer, sanitizer, styleStore);
                }
                setDirty(context, i, false);
            }
        }
        setContextDirty(context, false);
    }
}
/**
 * This function renders a given CSS prop/value entry using the
 * provided renderer. If a `store` value is provided then
 * that will be used a render context instead of the provided
 * renderer.
 *
 * @param native the DOM Element
 * @param prop the CSS style property that will be rendered
 * @param value the CSS style value that will be rendered
 * @param renderer
 * @param store an optional key/value map that will be used as a context to render styles on
 */
function setStyle(native, prop, value, renderer, sanitizer, store) {
    value = sanitizer && value ? sanitizer(prop, value) : value;
    if (store) {
        store[prop] = value;
    }
    else if (value) {
        ngDevMode && ngDevMode.rendererSetStyle++;
        isProceduralRenderer(renderer) ?
            renderer.setStyle(native, prop, value, RendererStyleFlags3.DashCase) :
            native['style'].setProperty(prop, value);
    }
    else {
        ngDevMode && ngDevMode.rendererRemoveStyle++;
        isProceduralRenderer(renderer) ?
            renderer.removeStyle(native, prop, RendererStyleFlags3.DashCase) :
            native['style'].removeProperty(prop);
    }
}
/**
 * This function renders a given CSS class value using the provided
 * renderer (by adding or removing it from the provided element).
 * If a `store` value is provided then that will be used a render
 * context instead of the provided renderer.
 *
 * @param native the DOM Element
 * @param prop the CSS style property that will be rendered
 * @param value the CSS style value that will be rendered
 * @param renderer
 * @param store an optional key/value map that will be used as a context to render styles on
 */
function setClass(native, className, add, renderer, store) {
    if (store) {
        store[className] = add;
    }
    else if (add) {
        ngDevMode && ngDevMode.rendererAddClass++;
        isProceduralRenderer(renderer) ? renderer.addClass(native, className) :
            native['classList'].add(className);
    }
    else {
        ngDevMode && ngDevMode.rendererRemoveClass++;
        isProceduralRenderer(renderer) ? renderer.removeClass(native, className) :
            native['classList'].remove(className);
    }
}
function setDirty(context, index, isDirtyYes) {
    var adjustedIndex = index >= 6 /* SingleStylesStartPosition */ ? (index + 0 /* FlagsOffset */) : index;
    if (isDirtyYes) {
        context[adjustedIndex] |= 1 /* Dirty */;
    }
    else {
        context[adjustedIndex] &= ~1 /* Dirty */;
    }
}
function isDirty(context, index) {
    var adjustedIndex = index >= 6 /* SingleStylesStartPosition */ ? (index + 0 /* FlagsOffset */) : index;
    return (context[adjustedIndex] & 1 /* Dirty */) == 1 /* Dirty */;
}
function isClassBased(context, index) {
    var adjustedIndex = index >= 6 /* SingleStylesStartPosition */ ? (index + 0 /* FlagsOffset */) : index;
    return (context[adjustedIndex] & 2 /* Class */) == 2 /* Class */;
}
function isSanitizable(context, index) {
    var adjustedIndex = index >= 6 /* SingleStylesStartPosition */ ? (index + 0 /* FlagsOffset */) : index;
    return (context[adjustedIndex] & 4 /* Sanitize */) == 4 /* Sanitize */;
}
function pointers(configFlag, staticIndex, dynamicIndex) {
    return (configFlag & 7 /* BitMask */) | (staticIndex << 3 /* BitCountSize */) |
        (dynamicIndex << (14 /* BitCountSize */ + 3 /* BitCountSize */));
}
function getInitialValue(context, flag) {
    var index = getInitialIndex(flag);
    return context[2 /* InitialStylesPosition */][index];
}
function getInitialIndex(flag) {
    return (flag >> 3 /* BitCountSize */) & 16383 /* BitMask */;
}
function getMultiOrSingleIndex(flag) {
    var index = (flag >> (14 /* BitCountSize */ + 3 /* BitCountSize */)) & 16383 /* BitMask */;
    return index >= 6 /* SingleStylesStartPosition */ ? index : -1;
}
function getMultiStartIndex(context) {
    return getMultiOrSingleIndex(context[3 /* MasterFlagPosition */]);
}
function getStyleSanitizer(context) {
    return context[1 /* StyleSanitizerPosition */];
}
function setProp(context, index, prop) {
    context[index + 1 /* PropertyOffset */] = prop;
}
function setValue(context, index, value) {
    context[index + 2 /* ValueOffset */] = value;
}
function setFlag(context, index, flag) {
    var adjustedIndex = index === 3 /* MasterFlagPosition */ ? index : (index + 0 /* FlagsOffset */);
    context[adjustedIndex] = flag;
}
function getPointers(context, index) {
    var adjustedIndex = index === 3 /* MasterFlagPosition */ ? index : (index + 0 /* FlagsOffset */);
    return context[adjustedIndex];
}
function getValue(context, index) {
    return context[index + 2 /* ValueOffset */];
}
function getProp(context, index) {
    return context[index + 1 /* PropertyOffset */];
}
function isContextDirty(context) {
    return isDirty(context, 3 /* MasterFlagPosition */);
}
function setContextDirty(context, isDirtyYes) {
    setDirty(context, 3 /* MasterFlagPosition */, isDirtyYes);
}
function findEntryPositionByProp(context, prop, startIndex) {
    for (var i = (startIndex || 0) + 1 /* PropertyOffset */; i < context.length; i += 3 /* Size */) {
        var thisProp = context[i];
        if (thisProp == prop) {
            return i - 1 /* PropertyOffset */;
        }
    }
    return -1;
}
function swapMultiContextEntries(context, indexA, indexB) {
    var tmpValue = getValue(context, indexA);
    var tmpProp = getProp(context, indexA);
    var tmpFlag = getPointers(context, indexA);
    var flagA = tmpFlag;
    var flagB = getPointers(context, indexB);
    var singleIndexA = getMultiOrSingleIndex(flagA);
    if (singleIndexA >= 0) {
        var _flag = getPointers(context, singleIndexA);
        var _initial = getInitialIndex(_flag);
        setFlag(context, singleIndexA, pointers(_flag, _initial, indexB));
    }
    var singleIndexB = getMultiOrSingleIndex(flagB);
    if (singleIndexB >= 0) {
        var _flag = getPointers(context, singleIndexB);
        var _initial = getInitialIndex(_flag);
        setFlag(context, singleIndexB, pointers(_flag, _initial, indexA));
    }
    setValue(context, indexA, getValue(context, indexB));
    setProp(context, indexA, getProp(context, indexB));
    setFlag(context, indexA, getPointers(context, indexB));
    setValue(context, indexB, tmpValue);
    setProp(context, indexB, tmpProp);
    setFlag(context, indexB, tmpFlag);
}
function updateSinglePointerValues(context, indexStartPosition) {
    for (var i = indexStartPosition; i < context.length; i += 3 /* Size */) {
        var multiFlag = getPointers(context, i);
        var singleIndex = getMultiOrSingleIndex(multiFlag);
        if (singleIndex > 0) {
            var singleFlag = getPointers(context, singleIndex);
            var initialIndexForSingle = getInitialIndex(singleFlag);
            var flagValue = (isDirty(context, singleIndex) ? 1 /* Dirty */ : 0 /* None */) |
                (isClassBased(context, singleIndex) ? 2 /* Class */ : 0 /* None */) |
                (isSanitizable(context, singleIndex) ? 4 /* Sanitize */ : 0 /* None */);
            var updatedFlag = pointers(flagValue, initialIndexForSingle, i);
            setFlag(context, singleIndex, updatedFlag);
        }
    }
}
function insertNewMultiProperty(context, index, classBased, name, flag, value) {
    var doShift = index < context.length;
    // prop does not exist in the list, add it in
    context.splice(index, 0, flag | 1 /* Dirty */ | (classBased ? 2 /* Class */ : 0 /* None */), name, value);
    if (doShift) {
        // because the value was inserted midway into the array then we
        // need to update all the shifted multi values' single value
        // pointers to point to the newly shifted location
        updateSinglePointerValues(context, index + 3 /* Size */);
    }
}
function valueExists(value, isClassBased) {
    if (isClassBased) {
        return value ? true : false;
    }
    return value !== null;
}
function prepareInitialFlag(name, isClassBased, sanitizer) {
    if (isClassBased) {
        return 2 /* Class */;
    }
    else if (sanitizer && sanitizer(name)) {
        return 4 /* Sanitize */;
    }
    return 0 /* None */;
}
function hasValueChanged(flag, a, b) {
    var isClassBased = flag & 2 /* Class */;
    var hasValues = a && b;
    var usesSanitizer = flag & 4 /* Sanitize */;
    // the toString() comparison ensures that a value is checked
    // ... otherwise (during sanitization bypassing) the === comparsion
    // would fail since a new String() instance is created
    if (!isClassBased && hasValues && usesSanitizer) {
        // we know for sure we're dealing with strings at this point
        return a.toString() !== b.toString();
    }
    // everything else is safe to check with a normal equality check
    return a !== b;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Directive (D) sets a property on all component instances using this constant as a key and the
 * component's host node (LElement) as the value. This is used in methods like detectChanges to
 * facilitate jumping from an instance to the host node.
 */
var NG_HOST_SYMBOL = '__ngHostLNode__';
/**
 * A permanent marker promise which signifies that the current CD tree is
 * clean.
 */
var _CLEAN_PROMISE = /*@__PURE__*/ Promise.resolve(null);
/**
 * Directive and element indices for top-level directive.
 *
 * Saved here to avoid re-instantiating an array on every change detection run.
 *
 * Note: Element is not actually stored at index 0 because of the LViewData
 * header, but the host bindings function expects an index that is NOT adjusted
 * because it will ultimately be fed to instructions like elementProperty.
 */
var _ROOT_DIRECTIVE_INDICES = [0, 0];
/**
 * TView.data needs to fill the same number of slots as the LViewData header
 * so the indices of nodes are consistent between LViewData and TView.data.
 *
 * It's much faster to keep a blueprint of the pre-filled array and slice it
 * than it is to create a new array and fill it each time a TView is created.
 */
var HEADER_FILLER = /*@__PURE__*/ /*@__PURE__*/ new Array(HEADER_OFFSET).fill(null);
/**
 * Token set in currentMatches while dependencies are being resolved.
 *
 * If we visit a directive that has a value set to CIRCULAR, we know we've
 * already seen it, and thus have a circular dependency.
 */
var CIRCULAR$2 = '__CIRCULAR__';
/**
 * This property gets set before entering a template.
 *
 * This renderer can be one of two varieties of Renderer3:
 *
 * - ObjectedOrientedRenderer3
 *
 * This is the native browser API style, e.g. operations are methods on individual objects
 * like HTMLElement. With this style, no additional code is needed as a facade (reducing payload
 * size).
 *
 * - ProceduralRenderer3
 *
 * In non-native browser environments (e.g. platforms such as web-workers), this is the facade
 * that enables element manipulation. This also facilitates backwards compatibility with
 * Renderer2.
 */
var renderer;
var rendererFactory;
var currentElementNode = null;
function getRenderer() {
    // top level variables should not be exported for performance reasons (PERF_NOTES.md)
    return renderer;
}
function getCurrentSanitizer() {
    return viewData && viewData[SANITIZER];
}
function getViewData() {
    // top level variables should not be exported for performance reasons (PERF_NOTES.md)
    return viewData;
}
/** Used to set the parent property when nodes are created. */
var previousOrParentNode;
function getPreviousOrParentNode() {
    // top level variables should not be exported for performance reasons (PERF_NOTES.md)
    return previousOrParentNode;
}
/**
 * If `isParent` is:
 *  - `true`: then `previousOrParentNode` points to a parent node.
 *  - `false`: then `previousOrParentNode` points to previous node (sibling).
 */
var isParent;
var tView;
var currentQueries;
/**
 * Query instructions can ask for "current queries" in 2 different cases:
 * - when creating view queries (at the root of a component view, before any node is created - in
 * this case currentQueries points to view queries)
 * - when creating content queries (inb this previousOrParentNode points to a node on which we
 * create content queries).
 */
function getCurrentQueries(QueryType) {
    // top level variables should not be exported for performance reasons (PERF_NOTES.md)
    return currentQueries ||
        (currentQueries =
            (previousOrParentNode.queries && previousOrParentNode.queries.clone() ||
                new QueryType()));
}
/**
 * This property gets set before entering a template.
 */
var creationMode;
function getCreationMode() {
    // top level variables should not be exported for performance reasons (PERF_NOTES.md)
    return creationMode;
}
/**
 * State of the current view being processed.
 *
 * An array of nodes (text, element, container, etc), pipes, their bindings, and
 * any local variables that need to be stored between invocations.
 */
var viewData;
/**
 * An array of directive instances in the current view.
 *
 * These must be stored separately from LNodes because their presence is
 * unknown at compile-time and thus space cannot be reserved in data[].
 */
var directives;
function getCleanup(view) {
    // top level variables should not be exported for performance reasons (PERF_NOTES.md)
    return view[CLEANUP] || (view[CLEANUP] = []);
}
function getTViewCleanup(view) {
    return view[TVIEW].cleanup || (view[TVIEW].cleanup = []);
}
/**
 * In this mode, any changes in bindings will throw an ExpressionChangedAfterChecked error.
 *
 * Necessary to support ChangeDetectorRef.checkNoChanges().
 */
var checkNoChangesMode = false;
/** Whether or not this is the first time the current view has been processed. */
var firstTemplatePass = true;
/**
 * Swap the current state with a new state.
 *
 * For performance reasons we store the state in the top level of the module.
 * This way we minimize the number of properties to read. Whenever a new view
 * is entered we have to store the state for later, and when the view is
 * exited the state has to be restored
 *
 * @param newView New state to become active
 * @param host Element to which the View is a child of
 * @returns the previous state;
 */
function enterView(newView, host) {
    var oldView = viewData;
    directives = newView && newView[DIRECTIVES];
    tView = newView && newView[TVIEW];
    creationMode = newView && (newView[FLAGS] & 1 /* CreationMode */) === 1 /* CreationMode */;
    firstTemplatePass = newView && tView.firstTemplatePass;
    renderer = newView && newView[RENDERER];
    if (host != null) {
        previousOrParentNode = host;
        isParent = true;
    }
    viewData = newView;
    currentQueries = newView && newView[QUERIES];
    return oldView;
}
/**
 * Used in lieu of enterView to make it clear when we are exiting a child view. This makes
 * the direction of traversal (up or down the view tree) a bit clearer.
 *
 * @param newView New state to become active
 * @param creationOnly An optional boolean to indicate that the view was processed in creation mode
 * only, i.e. the first update will be done later. Only possible for dynamically created views.
 */
function leaveView(newView, creationOnly) {
    if (!creationOnly) {
        if (!checkNoChangesMode) {
            executeHooks(directives, tView.viewHooks, tView.viewCheckHooks, creationMode);
        }
        // Views are clean and in update mode after being checked, so these bits are cleared
        viewData[FLAGS] &= ~(1 /* CreationMode */ | 4 /* Dirty */);
    }
    viewData[FLAGS] |= 16 /* RunInit */;
    viewData[BINDING_INDEX] = -1;
    enterView(newView, null);
}
/**
 * Refreshes the view, executing the following steps in that order:
 * triggers init hooks, refreshes dynamic embedded views, triggers content hooks, sets host
 * bindings,
 * refreshes child components.
 * Note: view hooks are triggered later when leaving the view.
 */
function refreshView() {
    if (!checkNoChangesMode) {
        executeInitHooks(viewData, tView, creationMode);
    }
    refreshDynamicEmbeddedViews(viewData);
    if (!checkNoChangesMode) {
        executeHooks(directives, tView.contentHooks, tView.contentCheckHooks, creationMode);
    }
    // This needs to be set before children are processed to support recursive components
    tView.firstTemplatePass = firstTemplatePass = false;
    setHostBindings(tView.hostBindings);
    refreshContentQueries(tView);
    refreshChildComponents(tView.components);
}
/** Sets the host bindings for the current view. */
function setHostBindings(bindings) {
    if (bindings != null) {
        var defs = tView.directives;
        for (var i = 0; i < bindings.length; i += 2) {
            var dirIndex = bindings[i];
            var def = defs[dirIndex];
            def.hostBindings && def.hostBindings(dirIndex, bindings[i + 1]);
        }
    }
}
/** Refreshes content queries for all directives in the given view. */
function refreshContentQueries(tView) {
    if (tView.contentQueries != null) {
        for (var i = 0; i < tView.contentQueries.length; i += 2) {
            var directiveDefIdx = tView.contentQueries[i];
            var directiveDef = tView.directives[directiveDefIdx];
            directiveDef.contentQueriesRefresh(directiveDefIdx, tView.contentQueries[i + 1]);
        }
    }
}
/** Refreshes child components in the current view. */
function refreshChildComponents(components) {
    if (components != null) {
        for (var i = 0; i < components.length; i += 2) {
            componentRefresh(components[i], components[i + 1]);
        }
    }
}
function executeInitAndContentHooks() {
    if (!checkNoChangesMode) {
        executeInitHooks(viewData, tView, creationMode);
        executeHooks(directives, tView.contentHooks, tView.contentCheckHooks, creationMode);
    }
}
function createLViewData(renderer, tView, context, flags, sanitizer) {
    return [
        tView,
        viewData,
        null,
        null,
        flags | 1 /* CreationMode */ | 8 /* Attached */ | 16 /* RunInit */,
        null,
        -1,
        null,
        null,
        context,
        viewData && viewData[INJECTOR$1],
        renderer,
        sanitizer || null,
        null,
        -1,
        null,
    ];
}
/**
 * Creation of LNode object is extracted to a separate function so we always create LNode object
 * with the same shape
 * (same properties assigned in the same order).
 */
function createLNodeObject(type, currentView, parent, native, state, queries) {
    return {
        native: native,
        view: currentView,
        nodeInjector: parent ? parent.nodeInjector : null,
        data: state,
        queries: queries,
        tNode: null,
        dynamicLContainerNode: null
    };
}
function createLNode(index, type, native, name, attrs, state) {
    var parent = isParent ? previousOrParentNode :
        previousOrParentNode && getParentLNode(previousOrParentNode);
    // Parents cannot cross component boundaries because components will be used in multiple places,
    // so it's only set if the view is the same.
    var tParent = parent && parent.view === viewData ? parent.tNode : null;
    var queries = (isParent ? currentQueries : previousOrParentNode && previousOrParentNode.queries) ||
        parent && parent.queries && parent.queries.child();
    var isState = state != null;
    var node = createLNodeObject(type, viewData, parent, native, isState ? state : null, queries);
    if (index === -1 || type === 2 /* View */) {
        // View nodes are not stored in data because they can be added / removed at runtime (which
        // would cause indices to change). Their TNodes are instead stored in TView.node.
        node.tNode = (state ? state[TVIEW].node : null) ||
            createTNode(type, index, null, null, tParent, null);
    }
    else {
        var adjustedIndex = index + HEADER_OFFSET;
        // This is an element or container or projection node
        ngDevMode && assertDataNext(adjustedIndex);
        var tData = tView.data;
        viewData[adjustedIndex] = node;
        // Every node adds a value to the static data array to avoid a sparse array
        if (adjustedIndex >= tData.length) {
            var tNode = tData[adjustedIndex] =
                createTNode(type, adjustedIndex, name, attrs, tParent, null);
            if (!isParent && previousOrParentNode) {
                var previousTNode = previousOrParentNode.tNode;
                previousTNode.next = tNode;
                if (previousTNode.dynamicContainerNode)
                    previousTNode.dynamicContainerNode.next = tNode;
            }
        }
        node.tNode = tData[adjustedIndex];
        // Now link ourselves into the tree.
        if (isParent) {
            currentQueries = null;
            if (previousOrParentNode.tNode.child == null && previousOrParentNode.view === viewData ||
                previousOrParentNode.tNode.type === 2 /* View */) {
                // We are in the same view, which means we are adding content node to the parent View.
                previousOrParentNode.tNode.child = node.tNode;
            }
        }
    }
    // View nodes and host elements need to set their host node (components set host nodes later)
    if ((type & 2 /* ViewOrElement */) === 2 /* ViewOrElement */ && isState) {
        var lViewData = state;
        ngDevMode && assertNotDefined(lViewData[HOST_NODE], 'lViewData[HOST_NODE] should not have been initialized');
        lViewData[HOST_NODE] = node;
        if (firstTemplatePass)
            lViewData[TVIEW].node = node.tNode;
    }
    previousOrParentNode = node;
    isParent = true;
    return node;
}
//////////////////////////
//// Render
//////////////////////////
/**
 * Resets the application state.
 */
function resetApplicationState() {
    isParent = false;
    previousOrParentNode = null;
}
/**
 * Used for creating the LViewNode of a dynamic embedded view,
 * either through ViewContainerRef.createEmbeddedView() or TemplateRef.createEmbeddedView().
 * Such lViewNode will then be renderer with renderEmbeddedTemplate() (see below).
 */
function createEmbeddedViewNode(tView, context, renderer, queries) {
    var _isParent = isParent;
    var _previousOrParentNode = previousOrParentNode;
    isParent = true;
    previousOrParentNode = null;
    var lView = createLViewData(renderer, tView, context, 2 /* CheckAlways */, getCurrentSanitizer());
    if (queries) {
        lView[QUERIES] = queries.createView();
    }
    var viewNode = createLNode(-1, 2 /* View */, null, null, null, lView);
    isParent = _isParent;
    previousOrParentNode = _previousOrParentNode;
    return viewNode;
}
/**
 * Used for rendering embedded views (e.g. dynamically created views)
 *
 * Dynamically created views must store/retrieve their TViews differently from component views
 * because their template functions are nested in the template functions of their hosts, creating
 * closures. If their host template happens to be an embedded template in a loop (e.g. ngFor inside
 * an ngFor), the nesting would mean we'd have multiple instances of the template function, so we
 * can't store TViews in the template function itself (as we do for comps). Instead, we store the
 * TView for dynamically created views on their host TNode, which only has one instance.
 */
function renderEmbeddedTemplate(viewNode, tView, context, rf) {
    var _isParent = isParent;
    var _previousOrParentNode = previousOrParentNode;
    var oldView;
    if (viewNode.data[PARENT] == null && viewNode.data[CONTEXT] && !tView.template) {
        // This is a root view inside the view tree
        tickRootContext(viewNode.data[CONTEXT]);
    }
    else {
        try {
            isParent = true;
            previousOrParentNode = null;
            oldView = enterView(viewNode.data, viewNode);
            namespaceHTML();
            tView.template(rf, context);
            if (rf & 2 /* Update */) {
                refreshView();
            }
            else {
                viewNode.data[TVIEW].firstTemplatePass = firstTemplatePass = false;
            }
        }
        finally {
            // renderEmbeddedTemplate() is called twice in fact, once for creation only and then once for
            // update. When for creation only, leaveView() must not trigger view hooks, nor clean flags.
            var isCreationOnly = (rf & 1 /* Create */) === 1 /* Create */;
            leaveView(oldView, isCreationOnly);
            isParent = _isParent;
            previousOrParentNode = _previousOrParentNode;
        }
    }
    return viewNode;
}
function renderComponentOrTemplate(node, hostView, componentOrContext, template) {
    var oldView = enterView(hostView, node);
    try {
        if (rendererFactory.begin) {
            rendererFactory.begin();
        }
        if (template) {
            namespaceHTML();
            template(getRenderFlags(hostView), componentOrContext);
            refreshView();
        }
        else {
            executeInitAndContentHooks();
            // Element was stored at 0 in data and directive was stored at 0 in directives
            // in renderComponent()
            setHostBindings(_ROOT_DIRECTIVE_INDICES);
            componentRefresh(0, HEADER_OFFSET);
        }
    }
    finally {
        if (rendererFactory.end) {
            rendererFactory.end();
        }
        leaveView(oldView);
    }
}
/**
 * This function returns the default configuration of rendering flags depending on when the
 * template is in creation mode or update mode. By default, the update block is run with the
 * creation block when the view is in creation mode. Otherwise, the update block is run
 * alone.
 *
 * Dynamically created views do NOT use this configuration (update block and create block are
 * always run separately).
 */
function getRenderFlags(view) {
    return view[FLAGS] & 1 /* CreationMode */ ? 1 /* Create */ | 2 /* Update */ :
        2 /* Update */;
}
//////////////////////////
//// Namespace
//////////////////////////
var _currentNamespace = null;
function namespaceSVG() {
    _currentNamespace = 'http://www.w3.org/2000/svg/';
}
function namespaceMathML() {
    _currentNamespace = 'http://www.w3.org/1998/MathML/';
}
function namespaceHTML() {
    _currentNamespace = null;
}
//////////////////////////
//// Element
//////////////////////////
/**
 * Creates an empty element using {@link elementStart} and {@link elementEnd}
 *
 * @param index Index of the element in the data array
 * @param name Name of the DOM Node
 * @param attrs Statically bound set of attributes to be written into the DOM element on creation.
 * @param localRefs A set of local reference bindings on the element.
 */
function element(index, name, attrs, localRefs) {
    elementStart(index, name, attrs, localRefs);
    elementEnd();
}
/**
 * Create DOM element. The instruction must later be followed by `elementEnd()` call.
 *
 * @param index Index of the element in the LViewData array
 * @param name Name of the DOM Node
 * @param attrs Statically bound set of attributes to be written into the DOM element on creation.
 * @param localRefs A set of local reference bindings on the element.
 *
 * Attributes and localRefs are passed as an array of strings where elements with an even index
 * hold an attribute name and elements with an odd index hold an attribute value, ex.:
 * ['id', 'warning5', 'class', 'alert']
 */
function elementStart(index, name, attrs, localRefs) {
    ngDevMode &&
        assertEqual(viewData[BINDING_INDEX], -1, 'elements should be created before any bindings');
    ngDevMode && ngDevMode.rendererCreateElement++;
    var native = elementCreate(name);
    ngDevMode && assertDataInRange(index - 1);
    var node = createLNode(index, 3 /* Element */, native, name, attrs || null, null);
    currentElementNode = node;
    if (attrs) {
        setUpAttributes(native, attrs);
    }
    appendChild(getParentLNode(node), native, viewData);
    createDirectivesAndLocals(localRefs);
    return native;
}
/**
 * Creates a native element from a tag name, using a renderer.
 * @param name the tag name
 * @param overriddenRenderer Optional A renderer to override the default one
 * @returns the element created
 */
function elementCreate(name, overriddenRenderer) {
    var native;
    var rendererToUse = overriddenRenderer || renderer;
    if (isProceduralRenderer(rendererToUse)) {
        native = rendererToUse.createElement(name, _currentNamespace);
    }
    else {
        if (_currentNamespace === null) {
            native = rendererToUse.createElement(name);
        }
        else {
            native = rendererToUse.createElementNS(_currentNamespace, name);
        }
    }
    return native;
}
/**
 * Creates directive instances and populates local refs.
 *
 * @param localRefs Local refs of the current node
 */
function createDirectivesAndLocals(localRefs) {
    var node = previousOrParentNode;
    if (firstTemplatePass) {
        ngDevMode && ngDevMode.firstTemplatePass++;
        cacheMatchingDirectivesForNode(node.tNode, tView, localRefs || null);
    }
    else {
        instantiateDirectivesDirectly();
    }
    saveResolvedLocalsInData();
}
/**
 * On first template pass, we match each node against available directive selectors and save
 * the resulting defs in the correct instantiation order for subsequent change detection runs
 * (so dependencies are always created before the directives that inject them).
 */
function cacheMatchingDirectivesForNode(tNode, tView, localRefs) {
    // Please make sure to have explicit type for `exportsMap`. Inferred type triggers bug in tsickle.
    var exportsMap = localRefs ? { '': -1 } : null;
    var matches = tView.currentMatches = findDirectiveMatches(tNode);
    if (matches) {
        for (var i = 0; i < matches.length; i += 2) {
            var def = matches[i];
            var valueIndex = i + 1;
            resolveDirective(def, valueIndex, matches, tView);
            saveNameToExportMap(matches[valueIndex], def, exportsMap);
        }
    }
    if (exportsMap)
        cacheMatchingLocalNames(tNode, localRefs, exportsMap);
}
/** Matches the current node against all available selectors. */
function findDirectiveMatches(tNode) {
    var registry = tView.directiveRegistry;
    var matches = null;
    if (registry) {
        for (var i = 0; i < registry.length; i++) {
            var def = registry[i];
            if (isNodeMatchingSelectorList(tNode, def.selectors)) {
                if (def.template) {
                    if (tNode.flags & 4096 /* isComponent */)
                        throwMultipleComponentError(tNode);
                    tNode.flags = 4096 /* isComponent */;
                }
                if (def.diPublic)
                    def.diPublic(def);
                (matches || (matches = [])).push(def, null);
            }
        }
    }
    return matches;
}
function resolveDirective(def, valueIndex, matches, tView) {
    if (matches[valueIndex] === null) {
        matches[valueIndex] = CIRCULAR$2;
        var instance = def.factory();
        (tView.directives || (tView.directives = [])).push(def);
        return directiveCreate(matches[valueIndex] = tView.directives.length - 1, instance, def);
    }
    else if (matches[valueIndex] === CIRCULAR$2) {
        // If we revisit this directive before it's resolved, we know it's circular
        throwCyclicDependencyError(def.type);
    }
    return null;
}
/** Stores index of component's host element so it will be queued for view refresh during CD. */
function queueComponentIndexForCheck(dirIndex) {
    if (firstTemplatePass) {
        (tView.components || (tView.components = [])).push(dirIndex, viewData.length - 1);
    }
}
/** Stores index of directive and host element so it will be queued for binding refresh during CD.
 */
function queueHostBindingForCheck(dirIndex) {
    // Must subtract the header offset because hostBindings functions are generated with
    // instructions that expect element indices that are NOT adjusted (e.g. elementProperty).
    ngDevMode &&
        assertEqual(firstTemplatePass, true, 'Should only be called in first template pass.');
    (tView.hostBindings || (tView.hostBindings = [])).push(dirIndex, viewData.length - 1 - HEADER_OFFSET);
}
/** Sets the context for a ChangeDetectorRef to the given instance. */
function initChangeDetectorIfExisting(injector, instance, view) {
    if (injector && injector.changeDetectorRef != null) {
        injector.changeDetectorRef._setComponentContext(view, instance);
    }
}
function isComponent(tNode) {
    return (tNode.flags & 4096 /* isComponent */) === 4096 /* isComponent */;
}
/**
 * This function instantiates the given directives.
 */
function instantiateDirectivesDirectly() {
    var tNode = previousOrParentNode.tNode;
    var count = tNode.flags & 4095 /* DirectiveCountMask */;
    if (count > 0) {
        var start = tNode.flags >> 14 /* DirectiveStartingIndexShift */;
        var end = start + count;
        var tDirectives = tView.directives;
        for (var i = start; i < end; i++) {
            var def = tDirectives[i];
            directiveCreate(i, def.factory(), def);
        }
    }
}
/** Caches local names and their matching directive indices for query and template lookups. */
function cacheMatchingLocalNames(tNode, localRefs, exportsMap) {
    if (localRefs) {
        var localNames = tNode.localNames = [];
        // Local names must be stored in tNode in the same order that localRefs are defined
        // in the template to ensure the data is loaded in the same slots as their refs
        // in the template (for template queries).
        for (var i = 0; i < localRefs.length; i += 2) {
            var index = exportsMap[localRefs[i + 1]];
            if (index == null)
                throw new Error("Export of name '" + localRefs[i + 1] + "' not found!");
            localNames.push(localRefs[i], index);
        }
    }
}
/**
 * Builds up an export map as directives are created, so local refs can be quickly mapped
 * to their directive instances.
 */
function saveNameToExportMap(index, def, exportsMap) {
    if (exportsMap) {
        if (def.exportAs)
            exportsMap[def.exportAs] = index;
        if (def.template)
            exportsMap[''] = index;
    }
}
/**
 * Takes a list of local names and indices and pushes the resolved local variable values
 * to LViewData in the same order as they are loaded in the template with load().
 */
function saveResolvedLocalsInData() {
    var localNames = previousOrParentNode.tNode.localNames;
    if (localNames) {
        for (var i = 0; i < localNames.length; i += 2) {
            var index = localNames[i + 1];
            var value = index === -1 ? previousOrParentNode.native : directives[index];
            viewData.push(value);
        }
    }
}
/**
 * Gets TView from a template function or creates a new TView
 * if it doesn't already exist.
 *
 * @param template The template from which to get static data
 * @param directives Directive defs that should be saved on TView
 * @param pipes Pipe defs that should be saved on TView
 * @returns TView
 */
function getOrCreateTView(template, directives, pipes, viewQuery) {
    // TODO(misko): reading `ngPrivateData` here is problematic for two reasons
    // 1. It is a megamorphic call on each invocation.
    // 2. For nested embedded views (ngFor inside ngFor) the template instance is per
    //    outer template invocation, which means that no such property will exist
    // Correct solution is to only put `ngPrivateData` on the Component template
    // and not on embedded templates.
    return template.ngPrivateData ||
        (template.ngPrivateData = createTView(-1, template, directives, pipes, viewQuery));
}
/**
 * Creates a TView instance
 *
 * @param viewIndex The viewBlockId for inline views, or -1 if it's a component/dynamic
 * @param directives Registry of directives for this view
 * @param pipes Registry of pipes for this view
 */
function createTView(viewIndex, template, directives, pipes, viewQuery) {
    ngDevMode && ngDevMode.tView++;
    return {
        id: viewIndex,
        template: template,
        viewQuery: viewQuery,
        node: null,
        data: HEADER_FILLER.slice(),
        childIndex: -1,
        bindingStartIndex: -1,
        directives: null,
        firstTemplatePass: true,
        initHooks: null,
        checkHooks: null,
        contentHooks: null,
        contentCheckHooks: null,
        viewHooks: null,
        viewCheckHooks: null,
        destroyHooks: null,
        pipeDestroyHooks: null,
        cleanup: null,
        hostBindings: null,
        contentQueries: null,
        components: null,
        directiveRegistry: typeof directives === 'function' ? directives() : directives,
        pipeRegistry: typeof pipes === 'function' ? pipes() : pipes,
        currentMatches: null
    };
}
function setUpAttributes(native, attrs) {
    var isProc = isProceduralRenderer(renderer);
    var i = 0;
    while (i < attrs.length) {
        var attrName = attrs[i];
        if (attrName === 1 /* SelectOnly */)
            break;
        if (attrName === NG_PROJECT_AS_ATTR_NAME) {
            i += 2;
        }
        else {
            ngDevMode && ngDevMode.rendererSetAttribute++;
            if (attrName === 0 /* NamespaceURI */) {
                // Namespaced attributes
                var namespaceURI = attrs[i + 1];
                var attrName_1 = attrs[i + 2];
                var attrVal = attrs[i + 3];
                isProc ?
                    renderer
                        .setAttribute(native, attrName_1, attrVal, namespaceURI) :
                    native.setAttributeNS(namespaceURI, attrName_1, attrVal);
                i += 4;
            }
            else {
                // Standard attributes
                var attrVal = attrs[i + 1];
                isProc ?
                    renderer
                        .setAttribute(native, attrName, attrVal) :
                    native.setAttribute(attrName, attrVal);
                i += 2;
            }
        }
    }
}
function createError(text, token) {
    return new Error("Renderer: " + text + " [" + stringify$1(token) + "]");
}
/**
 * Locates the host native element, used for bootstrapping existing nodes into rendering pipeline.
 *
 * @param elementOrSelector Render element or CSS selector to locate the element.
 */
function locateHostElement(factory, elementOrSelector) {
    ngDevMode && assertDataInRange(-1);
    rendererFactory = factory;
    var defaultRenderer = factory.createRenderer(null, null);
    var rNode = typeof elementOrSelector === 'string' ?
        (isProceduralRenderer(defaultRenderer) ?
            defaultRenderer.selectRootElement(elementOrSelector) :
            defaultRenderer.querySelector(elementOrSelector)) :
        elementOrSelector;
    if (ngDevMode && !rNode) {
        if (typeof elementOrSelector === 'string') {
            throw createError('Host node with selector not found:', elementOrSelector);
        }
        else {
            throw createError('Host node is required:', elementOrSelector);
        }
    }
    return rNode;
}
/**
 * Creates the host LNode.
 *
 * @param rNode Render host element.
 * @param def ComponentDef
 *
 * @returns LElementNode created
 */
function hostElement(tag, rNode, def, sanitizer) {
    resetApplicationState();
    var node = createLNode(0, 3 /* Element */, rNode, null, null, createLViewData(renderer, getOrCreateTView(def.template, def.directiveDefs, def.pipeDefs, def.viewQuery), null, def.onPush ? 4 /* Dirty */ : 2 /* CheckAlways */, sanitizer));
    if (firstTemplatePass) {
        node.tNode.flags = 4096 /* isComponent */;
        if (def.diPublic)
            def.diPublic(def);
        tView.directives = [def];
    }
    return node;
}
/**
 * Adds an event listener to the current node.
 *
 * If an output exists on one of the node's directives, it also subscribes to the output
 * and saves the subscription for later cleanup.
 *
 * @param eventName Name of the event
 * @param listenerFn The function to be called when event emits
 * @param useCapture Whether or not to use capture in event listener.
 */
function listener(eventName, listenerFn, useCapture) {
    if (useCapture === void 0) {
        useCapture = false;
    }
    ngDevMode && assertPreviousIsParent();
    var node = previousOrParentNode;
    var native = node.native;
    ngDevMode && ngDevMode.rendererAddEventListener++;
    // In order to match current behavior, native DOM event listeners must be added for all
    // events (including outputs).
    if (isProceduralRenderer(renderer)) {
        var wrappedListener = wrapListenerWithDirtyLogic(viewData, listenerFn);
        var cleanupFn = renderer.listen(native, eventName, wrappedListener);
        storeCleanupFn(viewData, cleanupFn);
    }
    else {
        var wrappedListener = wrapListenerWithDirtyAndDefault(viewData, listenerFn);
        native.addEventListener(eventName, wrappedListener, useCapture);
        var cleanupInstances = getCleanup(viewData);
        cleanupInstances.push(wrappedListener);
        if (firstTemplatePass) {
            getTViewCleanup(viewData).push(eventName, node.tNode.index, cleanupInstances.length - 1, useCapture);
        }
    }
    var tNode = node.tNode;
    if (tNode.outputs === undefined) {
        // if we create TNode here, inputs must be undefined so we know they still need to be
        // checked
        tNode.outputs = generatePropertyAliases(node.tNode.flags, 1 /* Output */);
    }
    var outputs = tNode.outputs;
    var outputData;
    if (outputs && (outputData = outputs[eventName])) {
        createOutput(outputData, listenerFn);
    }
}
/**
 * Iterates through the outputs associated with a particular event name and subscribes to
 * each output.
 */
function createOutput(outputs, listener) {
    for (var i = 0; i < outputs.length; i += 2) {
        ngDevMode && assertDataInRange(outputs[i], directives);
        var subscription = directives[outputs[i]][outputs[i + 1]].subscribe(listener);
        storeCleanupWithContext(viewData, subscription, subscription.unsubscribe);
    }
}
/**
 * Saves context for this cleanup function in LView.cleanupInstances.
 *
 * On the first template pass, saves in TView:
 * - Cleanup function
 * - Index of context we just saved in LView.cleanupInstances
 */
function storeCleanupWithContext(view, context, cleanupFn) {
    if (!view)
        view = viewData;
    getCleanup(view).push(context);
    if (view[TVIEW].firstTemplatePass) {
        getTViewCleanup(view).push(cleanupFn, view[CLEANUP].length - 1);
    }
}
/**
 * Saves the cleanup function itself in LView.cleanupInstances.
 *
 * This is necessary for functions that are wrapped with their contexts, like in renderer2
 * listeners.
 *
 * On the first template pass, the index of the cleanup function is saved in TView.
 */
function storeCleanupFn(view, cleanupFn) {
    getCleanup(view).push(cleanupFn);
    if (view[TVIEW].firstTemplatePass) {
        getTViewCleanup(view).push(view[CLEANUP].length - 1, null);
    }
}
/** Mark the end of the element. */
function elementEnd() {
    if (isParent) {
        isParent = false;
    }
    else {
        ngDevMode && assertHasParent();
        previousOrParentNode = getParentLNode(previousOrParentNode);
    }
    ngDevMode && assertNodeType(previousOrParentNode, 3 /* Element */);
    var queries = previousOrParentNode.queries;
    queries && queries.addNode(previousOrParentNode);
    queueLifecycleHooks(previousOrParentNode.tNode.flags, tView);
    currentElementNode = null;
}
/**
 * Updates the value of removes an attribute on an Element.
 *
 * @param number index The index of the element in the data array
 * @param name name The name of the attribute.
 * @param value value The attribute is removed when value is `null` or `undefined`.
 *                  Otherwise the attribute value is set to the stringified value.
 * @param sanitizer An optional function used to sanitize the value.
 */
function elementAttribute(index, name, value, sanitizer) {
    if (value !== NO_CHANGE) {
        var element_1 = loadElement(index);
        if (value == null) {
            ngDevMode && ngDevMode.rendererRemoveAttribute++;
            isProceduralRenderer(renderer) ? renderer.removeAttribute(element_1.native, name) :
                element_1.native.removeAttribute(name);
        }
        else {
            ngDevMode && ngDevMode.rendererSetAttribute++;
            var strValue = sanitizer == null ? stringify$1(value) : sanitizer(value);
            isProceduralRenderer(renderer) ? renderer.setAttribute(element_1.native, name, strValue) :
                element_1.native.setAttribute(name, strValue);
        }
    }
}
/**
 * Update a property on an Element.
 *
 * If the property name also exists as an input property on one of the element's directives,
 * the component property will be set instead of the element property. This check must
 * be conducted at runtime so child components that add new @Inputs don't have to be re-compiled.
 *
 * @param index The index of the element to update in the data array
 * @param propName Name of property. Because it is going to DOM, this is not subject to
 *        renaming as part of minification.
 * @param value New value to write.
 * @param sanitizer An optional function used to sanitize the value.
 */
function elementProperty(index, propName, value, sanitizer) {
    if (value === NO_CHANGE)
        return;
    var node = loadElement(index);
    var tNode = node.tNode;
    // if tNode.inputs is undefined, a listener has created outputs, but inputs haven't
    // yet been checked
    if (tNode && tNode.inputs === undefined) {
        // mark inputs as checked
        tNode.inputs = generatePropertyAliases(node.tNode.flags, 0 /* Input */);
    }
    var inputData = tNode && tNode.inputs;
    var dataValue;
    if (inputData && (dataValue = inputData[propName])) {
        setInputsForProperty(dataValue, value);
        markDirtyIfOnPush(node);
    }
    else {
        // It is assumed that the sanitizer is only added when the compiler determines that the property
        // is risky, so sanitization can be done without further checks.
        value = sanitizer != null ? sanitizer(value) : value;
        var native = node.native;
        ngDevMode && ngDevMode.rendererSetProperty++;
        isProceduralRenderer(renderer) ? renderer.setProperty(native, propName, value) :
            (native.setProperty ? native.setProperty(propName, value) :
                native[propName] = value);
    }
}
/**
 * Constructs a TNode object from the arguments.
 *
 * @param type The type of the node
 * @param adjustedIndex The index of the TNode in TView.data, adjusted for HEADER_OFFSET
 * @param tagName The tag name of the node
 * @param attrs The attributes defined on this node
 * @param parent The parent of this node
 * @param tViews Any TViews attached to this node
 * @returns the TNode object
 */
function createTNode(type, adjustedIndex, tagName, attrs, parent, tViews) {
    ngDevMode && ngDevMode.tNode++;
    return {
        type: type,
        index: adjustedIndex,
        flags: 0,
        tagName: tagName,
        attrs: attrs,
        localNames: null,
        initialInputs: undefined,
        inputs: undefined,
        outputs: undefined,
        tViews: tViews,
        next: null,
        child: null,
        parent: parent,
        dynamicContainerNode: null,
        detached: null,
        stylingTemplate: null,
        projection: null
    };
}
/**
 * Given a list of directive indices and minified input names, sets the
 * input properties on the corresponding directives.
 */
function setInputsForProperty(inputs, value) {
    for (var i = 0; i < inputs.length; i += 2) {
        ngDevMode && assertDataInRange(inputs[i], directives);
        directives[inputs[i]][inputs[i + 1]] = value;
    }
}
/**
 * Consolidates all inputs or outputs of all directives on this logical node.
 *
 * @param number lNodeFlags logical node flags
 * @param Direction direction whether to consider inputs or outputs
 * @returns PropertyAliases|null aggregate of all properties if any, `null` otherwise
 */
function generatePropertyAliases(tNodeFlags, direction) {
    var count = tNodeFlags & 4095 /* DirectiveCountMask */;
    var propStore = null;
    if (count > 0) {
        var start = tNodeFlags >> 14 /* DirectiveStartingIndexShift */;
        var end = start + count;
        var isInput = direction === 0 /* Input */;
        var defs = tView.directives;
        for (var i = start; i < end; i++) {
            var directiveDef = defs[i];
            var propertyAliasMap = isInput ? directiveDef.inputs : directiveDef.outputs;
            for (var publicName in propertyAliasMap) {
                if (propertyAliasMap.hasOwnProperty(publicName)) {
                    propStore = propStore || {};
                    var internalName = propertyAliasMap[publicName];
                    var hasProperty = propStore.hasOwnProperty(publicName);
                    hasProperty ? propStore[publicName].push(i, internalName) :
                        (propStore[publicName] = [i, internalName]);
                }
            }
        }
    }
    return propStore;
}
/**
 * Add or remove a class in a `classList` on a DOM element.
 *
 * This instruction is meant to handle the [class.foo]="exp" case
 *
 * @param index The index of the element to update in the data array
 * @param className Name of class to toggle. Because it is going to DOM, this is not subject to
 *        renaming as part of minification.
 * @param value A value indicating if a given class should be added or removed.
 */
function elementClassProp(index, stylingIndex, value) {
    updateClassProp(getStylingContext(index), stylingIndex, value ? true : false);
}
/**
 * Assign any inline style values to the element during creation mode.
 *
 * This instruction is meant to be called during creation mode to apply all styling
 * (e.g. `style="..."`) values to the element. This is also where the provided index
 * value is allocated for the styling details for its corresponding element (the element
 * index is the previous index value from this one).
 *
 * (Note this function calls `elementStylingApply` immediately when called.)
 *
 *
 * @param index Index value which will be allocated to store styling data for the element.
 *        (Note that this is not the element index, but rather an index value allocated
 *        specifically for element styling--the index must be the next index after the element
 *        index.)
 * @param classDeclarations A key/value array of CSS classes that will be registered on the element.
 *   Each individual style will be used on the element as long as it is not overridden
 *   by any classes placed on the element by multiple (`[class]`) or singular (`[class.named]`)
 *   bindings. If a class binding changes its value to a falsy value then the matching initial
 *   class value that are passed in here will be applied to the element (if matched).
 * @param styleDeclarations A key/value array of CSS styles that will be registered on the element.
 *   Each individual style will be used on the element as long as it is not overridden
 *   by any styles placed on the element by multiple (`[style]`) or singular (`[style.prop]`)
 *   bindings. If a style binding changes its value to null then the initial styling
 *   values that are passed in here will be applied to the element (if matched).
 * @param styleSanitizer An optional sanitizer function that will be used (if provided)
 *   to sanitize the any CSS property values that are applied to the element (during rendering).
 */
function elementStyling(classDeclarations, styleDeclarations, styleSanitizer) {
    var lElement = currentElementNode;
    var tNode = lElement.tNode;
    if (!tNode.stylingTemplate) {
        // initialize the styling template.
        tNode.stylingTemplate =
            createStylingContextTemplate(classDeclarations, styleDeclarations, styleSanitizer);
    }
    if (styleDeclarations && styleDeclarations.length ||
        classDeclarations && classDeclarations.length) {
        elementStylingApply(tNode.index - HEADER_OFFSET);
    }
}
/**
 * Retrieve the `StylingContext` at a given index.
 *
 * This method lazily creates the `StylingContext`. This is because in most cases
 * we have styling without any bindings. Creating `StylingContext` eagerly would mean that
 * every style declaration such as `<div style="color: red">` would result `StyleContext`
 * which would create unnecessary memory pressure.
 *
 * @param index Index of the style allocation. See: `elementStyling`.
 */
function getStylingContext(index) {
    var stylingContext = load(index);
    if (!Array.isArray(stylingContext)) {
        var lElement = stylingContext;
        var tNode = lElement.tNode;
        ngDevMode &&
            assertDefined(tNode.stylingTemplate, 'getStylingContext() called before elementStyling()');
        stylingContext = viewData[index + HEADER_OFFSET] =
            allocStylingContext(lElement, tNode.stylingTemplate);
    }
    return stylingContext;
}
/**
 * Apply all styling values to the element which have been queued by any styling instructions.
 *
 * This instruction is meant to be run once one or more `elementStyle` and/or `elementStyleProp`
 * have been issued against the element. This function will also determine if any styles have
 * changed and will then skip the operation if there is nothing new to render.
 *
 * Once called then all queued styles will be flushed.
 *
 * @param index Index of the element's styling storage that will be rendered.
 *        (Note that this is not the element index, but rather an index value allocated
 *        specifically for element styling--the index must be the next index after the element
 *        index.)
 */
function elementStylingApply(index) {
    renderStyling(getStylingContext(index), renderer);
}
/**
 * Queue a given style to be rendered on an Element.
 *
 * If the style value is `null` then it will be removed from the element
 * (or assigned a different value depending if there are any styles placed
 * on the element with `elementStyle` or any styles that are present
 * from when the element was created (with `elementStyling`).
 *
 * (Note that the styling instruction will not be applied until `elementStylingApply` is called.)
 *
 * @param index Index of the element's styling storage to change in the data array.
 *        (Note that this is not the element index, but rather an index value allocated
 *        specifically for element styling--the index must be the next index after the element
 *        index.)
 * @param styleIndex Index of the style property on this element. (Monotonically increasing.)
 * @param styleName Name of property. Because it is going to DOM this is not subject to
 *        renaming as part of minification.
 * @param value New value to write (null to remove).
 * @param suffix Optional suffix. Used with scalar values to add unit such as `px`.
 *        Note that when a suffix is provided then the underlying sanitizer will
 *        be ignored.
 */
function elementStyleProp(index, styleIndex, value, suffix) {
    var valueToAdd = null;
    if (value) {
        if (suffix) {
            // when a suffix is applied then it will bypass
            // sanitization entirely (b/c a new string is created)
            valueToAdd = stringify$1(value) + suffix;
        }
        else {
            // sanitization happens by dealing with a String value
            // this means that the string value will be passed through
            // into the style rendering later (which is where the value
            // will be sanitized before it is applied)
            valueToAdd = value;
        }
    }
    updateStyleProp(getStylingContext(index), styleIndex, valueToAdd);
}
/**
 * Queue a key/value map of styles to be rendered on an Element.
 *
 * This instruction is meant to handle the `[style]="exp"` usage. When styles are applied to
 * the Element they will then be placed with respect to any styles set with `elementStyleProp`.
 * If any styles are set to `null` then they will be removed from the element (unless the same
 * style properties have been assigned to the element during creation using `elementStyling`).
 *
 * (Note that the styling instruction will not be applied until `elementStylingApply` is called.)
 *
 * @param index Index of the element's styling storage to change in the data array.
 *        (Note that this is not the element index, but rather an index value allocated
 *        specifically for element styling--the index must be the next index after the element
 *        index.)
 * @param classes A key/value style map of CSS classes that will be added to the given element.
 *        Any missing classes (that have already been applied to the element beforehand) will be
 *        removed (unset) from the element's list of CSS classes.
 * @param styles A key/value style map of the styles that will be applied to the given element.
 *        Any missing styles (that have already been applied to the element beforehand) will be
 *        removed (unset) from the element's styling.
 */
function elementStylingMap(index, classes, styles) {
    updateStylingMap(getStylingContext(index), classes, styles);
}
//////////////////////////
//// Text
//////////////////////////
/**
 * Create static text node
 *
 * @param index Index of the node in the data array
 * @param value Value to write. This value will be stringified.
 */
function text(index, value) {
    ngDevMode &&
        assertEqual(viewData[BINDING_INDEX], -1, 'text nodes should be created before bindings');
    ngDevMode && ngDevMode.rendererCreateTextNode++;
    var textNode = createTextNode(value, renderer);
    var node = createLNode(index, 3 /* Element */, textNode, null, null);
    // Text nodes are self closing.
    isParent = false;
    appendChild(getParentLNode(node), textNode, viewData);
}
/**
 * Create text node with binding
 * Bindings should be handled externally with the proper interpolation(1-8) method
 *
 * @param index Index of the node in the data array.
 * @param value Stringified value to write.
 */
function textBinding(index, value) {
    if (value !== NO_CHANGE) {
        ngDevMode && assertDataInRange(index + HEADER_OFFSET);
        var existingNode = loadElement(index);
        ngDevMode && assertDefined(existingNode, 'LNode should exist');
        ngDevMode && assertDefined(existingNode.native, 'native element should exist');
        ngDevMode && ngDevMode.rendererSetText++;
        isProceduralRenderer(renderer) ? renderer.setValue(existingNode.native, stringify$1(value)) :
            existingNode.native.textContent = stringify$1(value);
    }
}
//////////////////////////
//// Directive
//////////////////////////
/**
 * Create a directive and their associated content queries.
 *
 * NOTE: directives can be created in order other than the index order. They can also
 *       be retrieved before they are created in which case the value will be null.
 *
 * @param directive The directive instance.
 * @param directiveDef DirectiveDef object which contains information about the template.
 */
function directiveCreate(directiveDefIdx, directive, directiveDef) {
    var instance = baseDirectiveCreate(directiveDefIdx, directive, directiveDef);
    ngDevMode && assertDefined(previousOrParentNode.tNode, 'previousOrParentNode.tNode');
    var tNode = previousOrParentNode.tNode;
    var isComponent = directiveDef.template;
    if (isComponent) {
        addComponentLogic(directiveDefIdx, directive, directiveDef);
    }
    if (firstTemplatePass) {
        // Init hooks are queued now so ngOnInit is called in host components before
        // any projected components.
        queueInitHooks(directiveDefIdx, directiveDef.onInit, directiveDef.doCheck, tView);
        if (directiveDef.hostBindings)
            queueHostBindingForCheck(directiveDefIdx);
    }
    if (tNode && tNode.attrs) {
        setInputsFromAttrs(directiveDefIdx, instance, directiveDef.inputs, tNode);
    }
    if (directiveDef.contentQueries) {
        directiveDef.contentQueries();
    }
    return instance;
}
function addComponentLogic(directiveIndex, instance, def) {
    var tView = getOrCreateTView(def.template, def.directiveDefs, def.pipeDefs, def.viewQuery);
    // Only component views should be added to the view tree directly. Embedded views are
    // accessed through their containers because they may be removed / re-added later.
    var componentView = addToViewTree(viewData, previousOrParentNode.tNode.index, createLViewData(rendererFactory.createRenderer(previousOrParentNode.native, def.rendererType), tView, null, def.onPush ? 4 /* Dirty */ : 2 /* CheckAlways */, getCurrentSanitizer()));
    // We need to set the host node/data here because when the component LNode was created,
    // we didn't yet know it was a component (just an element).
    previousOrParentNode.data = componentView;
    componentView[HOST_NODE] = previousOrParentNode;
    initChangeDetectorIfExisting(previousOrParentNode.nodeInjector, instance, componentView);
    if (firstTemplatePass)
        queueComponentIndexForCheck(directiveIndex);
}
/**
 * A lighter version of directiveCreate() that is used for the root component
 *
 * This version does not contain features that we don't already support at root in
 * current Angular. Example: local refs and inputs on root component.
 */
function baseDirectiveCreate(index, directive, directiveDef) {
    ngDevMode &&
        assertEqual(viewData[BINDING_INDEX], -1, 'directives should be created before any bindings');
    ngDevMode && assertPreviousIsParent();
    Object.defineProperty(directive, NG_HOST_SYMBOL, { enumerable: false, value: previousOrParentNode });
    if (directives == null)
        viewData[DIRECTIVES] = directives = [];
    ngDevMode && assertDataNext(index, directives);
    directives[index] = directive;
    if (firstTemplatePass) {
        var flags = previousOrParentNode.tNode.flags;
        if ((flags & 4095 /* DirectiveCountMask */) === 0) {
            // When the first directive is created:
            // - save the index,
            // - set the number of directives to 1
            previousOrParentNode.tNode.flags =
                index << 14 /* DirectiveStartingIndexShift */ | flags & 4096 /* isComponent */ | 1;
        }
        else {
            // Only need to bump the size when subsequent directives are created
            ngDevMode && assertNotEqual(flags & 4095 /* DirectiveCountMask */, 4095 /* DirectiveCountMask */, 'Reached the max number of directives');
            previousOrParentNode.tNode.flags++;
        }
    }
    else {
        var diPublic = directiveDef.diPublic;
        if (diPublic)
            diPublic(directiveDef);
    }
    if (directiveDef.attributes != null && previousOrParentNode.tNode.type == 3 /* Element */) {
        setUpAttributes(previousOrParentNode.native, directiveDef.attributes);
    }
    return directive;
}
/**
 * Sets initial input properties on directive instances from attribute data
 *
 * @param directiveIndex Index of the directive in directives array
 * @param instance Instance of the directive on which to set the initial inputs
 * @param inputs The list of inputs from the directive def
 * @param tNode The static data for this node
 */
function setInputsFromAttrs(directiveIndex, instance, inputs, tNode) {
    var initialInputData = tNode.initialInputs;
    if (initialInputData === undefined || directiveIndex >= initialInputData.length) {
        initialInputData = generateInitialInputs(directiveIndex, inputs, tNode);
    }
    var initialInputs = initialInputData[directiveIndex];
    if (initialInputs) {
        for (var i = 0; i < initialInputs.length; i += 2) {
            instance[initialInputs[i]] = initialInputs[i + 1];
        }
    }
}
/**
 * Generates initialInputData for a node and stores it in the template's static storage
 * so subsequent template invocations don't have to recalculate it.
 *
 * initialInputData is an array containing values that need to be set as input properties
 * for directives on this node, but only once on creation. We need this array to support
 * the case where you set an @Input property of a directive using attribute-like syntax.
 * e.g. if you have a `name` @Input, you can set it once like this:
 *
 * <my-component name="Bess"></my-component>
 *
 * @param directiveIndex Index to store the initial input data
 * @param inputs The list of inputs from the directive def
 * @param tNode The static data on this node
 */
function generateInitialInputs(directiveIndex, inputs, tNode) {
    var initialInputData = tNode.initialInputs || (tNode.initialInputs = []);
    initialInputData[directiveIndex] = null;
    var attrs = tNode.attrs;
    var i = 0;
    while (i < attrs.length) {
        var attrName = attrs[i];
        if (attrName === 1 /* SelectOnly */)
            break;
        if (attrName === 0 /* NamespaceURI */) {
            // We do not allow inputs on namespaced attributes.
            i += 4;
            continue;
        }
        var minifiedInputName = inputs[attrName];
        var attrValue = attrs[i + 1];
        if (minifiedInputName !== undefined) {
            var inputsToStore = initialInputData[directiveIndex] || (initialInputData[directiveIndex] = []);
            inputsToStore.push(minifiedInputName, attrValue);
        }
        i += 2;
    }
    return initialInputData;
}
//////////////////////////
//// ViewContainer & View
//////////////////////////
/**
 * Creates a LContainer, either from a container instruction, or for a ViewContainerRef.
 *
 * @param parentLNode the LNode in which the container's content will be rendered
 * @param currentView The parent view of the LContainer
 * @param isForViewContainerRef Optional a flag indicating the ViewContainerRef case
 * @returns LContainer
 */
function createLContainer(parentLNode, currentView, isForViewContainerRef) {
    ngDevMode && assertDefined(parentLNode, 'containers should have a parent');
    var renderParent = canInsertNativeNode(parentLNode, currentView) ?
        parentLNode :
        null;
    if (renderParent && renderParent.tNode.type === 2 /* View */) {
        renderParent = getParentLNode(renderParent).data[RENDER_PARENT];
    }
    return [
        isForViewContainerRef ? null : 0,
        currentView,
        null,
        null,
        [],
        renderParent
    ];
}
/**
 * Creates an LContainerNode.
 *
 * Only `LViewNodes` can go into `LContainerNodes`.
 *
 * @param index The index of the container in the data array
 * @param template Optional inline template
 * @param tagName The name of the container element, if applicable
 * @param attrs The attrs attached to the container, if applicable
 * @param localRefs A set of local reference bindings on the element.
 */
function container(index, template, tagName, attrs, localRefs) {
    ngDevMode &&
        assertEqual(viewData[BINDING_INDEX], -1, 'container nodes should be created before any bindings');
    var currentParent = isParent ? previousOrParentNode : getParentLNode(previousOrParentNode);
    var lContainer = createLContainer(currentParent, viewData);
    var comment = renderer.createComment(ngDevMode ? 'container' : '');
    var node = createLNode(index, 0 /* Container */, comment, tagName || null, attrs || null, lContainer);
    appendChild(getParentLNode(node), comment, viewData);
    if (firstTemplatePass) {
        node.tNode.tViews = template ?
            createTView(-1, template, tView.directiveRegistry, tView.pipeRegistry, null) :
            [];
    }
    // Containers are added to the current view tree instead of their embedded views
    // because views can be removed and re-inserted.
    addToViewTree(viewData, index + HEADER_OFFSET, node.data);
    var queries = node.queries;
    if (queries) {
        // prepare place for matching nodes from views inserted into a given container
        lContainer[QUERIES] = queries.container();
    }
    createDirectivesAndLocals(localRefs);
    isParent = false;
    ngDevMode && assertNodeType(previousOrParentNode, 0 /* Container */);
    queries && queries.addNode(node); // check if a given container node matches
    queueLifecycleHooks(node.tNode.flags, tView);
}
/**
 * Sets a container up to receive views.
 *
 * @param index The index of the container in the data array
 */
function containerRefreshStart(index) {
    previousOrParentNode = loadElement(index);
    ngDevMode && assertNodeType(previousOrParentNode, 0 /* Container */);
    isParent = true;
    previousOrParentNode.data[ACTIVE_INDEX] = 0;
    if (!checkNoChangesMode) {
        // We need to execute init hooks here so ngOnInit hooks are called in top level views
        // before they are called in embedded views (for backwards compatibility).
        executeInitHooks(viewData, tView, creationMode);
    }
}
/**
 * Marks the end of the LContainerNode.
 *
 * Marking the end of LContainerNode is the time when to child Views get inserted or removed.
 */
function containerRefreshEnd() {
    if (isParent) {
        isParent = false;
    }
    else {
        ngDevMode && assertNodeType(previousOrParentNode, 2 /* View */);
        ngDevMode && assertHasParent();
        previousOrParentNode = getParentLNode(previousOrParentNode);
    }
    ngDevMode && assertNodeType(previousOrParentNode, 0 /* Container */);
    var container = previousOrParentNode;
    ngDevMode && assertNodeType(container, 0 /* Container */);
    var nextIndex = container.data[ACTIVE_INDEX];
    // remove extra views at the end of the container
    while (nextIndex < container.data[VIEWS].length) {
        removeView(container, nextIndex);
    }
}
/**
 * Goes over dynamic embedded views (ones created through ViewContainerRef APIs) and refreshes them
 * by executing an associated template function.
 */
function refreshDynamicEmbeddedViews(lViewData) {
    for (var current = getLViewChild(lViewData); current !== null; current = current[NEXT]) {
        // Note: current can be an LViewData or an LContainer instance, but here we are only interested
        // in LContainer. We can tell it's an LContainer because its length is less than the LViewData
        // header.
        if (current.length < HEADER_OFFSET && current[ACTIVE_INDEX] === null) {
            var container_1 = current;
            for (var i = 0; i < container_1[VIEWS].length; i++) {
                var lViewNode = container_1[VIEWS][i];
                // The directives and pipes are not needed here as an existing view is only being refreshed.
                var dynamicViewData = lViewNode.data;
                ngDevMode && assertDefined(dynamicViewData[TVIEW], 'TView must be allocated');
                renderEmbeddedTemplate(lViewNode, dynamicViewData[TVIEW], dynamicViewData[CONTEXT], 2 /* Update */);
            }
        }
    }
}
/**
 * Looks for a view with a given view block id inside a provided LContainer.
 * Removes views that need to be deleted in the process.
 *
 * @param containerNode where to search for views
 * @param startIdx starting index in the views array to search from
 * @param viewBlockId exact view block id to look for
 * @returns index of a found view or -1 if not found
 */
function scanForView(containerNode, startIdx, viewBlockId) {
    var views = containerNode.data[VIEWS];
    for (var i = startIdx; i < views.length; i++) {
        var viewAtPositionId = views[i].data[TVIEW].id;
        if (viewAtPositionId === viewBlockId) {
            return views[i];
        }
        else if (viewAtPositionId < viewBlockId) {
            // found a view that should not be at this position - remove
            removeView(containerNode, i);
        }
        else {
            // found a view with id greater than the one we are searching for
            // which means that required view doesn't exist and can't be found at
            // later positions in the views array - stop the search here
            break;
        }
    }
    return null;
}
/**
 * Marks the start of an embedded view.
 *
 * @param viewBlockId The ID of this view
 * @return boolean Whether or not this view is in creation mode
 */
function embeddedViewStart(viewBlockId) {
    var container = (isParent ? previousOrParentNode : getParentLNode(previousOrParentNode));
    ngDevMode && assertNodeType(container, 0 /* Container */);
    var lContainer = container.data;
    var viewNode = scanForView(container, lContainer[ACTIVE_INDEX], viewBlockId);
    if (viewNode) {
        previousOrParentNode = viewNode;
        ngDevMode && assertNodeType(previousOrParentNode, 2 /* View */);
        isParent = true;
        enterView(viewNode.data, viewNode);
    }
    else {
        // When we create a new LView, we always reset the state of the instructions.
        var newView = createLViewData(renderer, getOrCreateEmbeddedTView(viewBlockId, container), null, 2 /* CheckAlways */, getCurrentSanitizer());
        if (lContainer[QUERIES]) {
            newView[QUERIES] = lContainer[QUERIES].createView();
        }
        enterView(newView, viewNode = createLNode(viewBlockId, 2 /* View */, null, null, null, newView));
    }
    if (container) {
        if (creationMode) {
            // it is a new view, insert it into collection of views for a given container
            insertView(container, viewNode, lContainer[ACTIVE_INDEX]);
        }
        lContainer[ACTIVE_INDEX]++;
    }
    return getRenderFlags(viewNode.data);
}
/**
 * Initialize the TView (e.g. static data) for the active embedded view.
 *
 * Each embedded view block must create or retrieve its own TView. Otherwise, the embedded view's
 * static data for a particular node would overwrite the static data for a node in the view above
 * it with the same index (since it's in the same template).
 *
 * @param viewIndex The index of the TView in TNode.tViews
 * @param parent The parent container in which to look for the view's static data
 * @returns TView
 */
function getOrCreateEmbeddedTView(viewIndex, parent) {
    ngDevMode && assertNodeType(parent, 0 /* Container */);
    var containerTViews = parent.tNode.tViews;
    ngDevMode && assertDefined(containerTViews, 'TView expected');
    ngDevMode && assertEqual(Array.isArray(containerTViews), true, 'TViews should be in an array');
    if (viewIndex >= containerTViews.length || containerTViews[viewIndex] == null) {
        containerTViews[viewIndex] =
            createTView(viewIndex, null, tView.directiveRegistry, tView.pipeRegistry, null);
    }
    return containerTViews[viewIndex];
}
/** Marks the end of an embedded view. */
function embeddedViewEnd() {
    refreshView();
    isParent = false;
    previousOrParentNode = viewData[HOST_NODE];
    leaveView(viewData[PARENT]);
    ngDevMode && assertEqual(isParent, false, 'isParent');
    ngDevMode && assertNodeType(previousOrParentNode, 2 /* View */);
}
/////////////
/**
 * Refreshes components by entering the component view and processing its bindings, queries, etc.
 *
 * @param directiveIndex Directive index in LViewData[DIRECTIVES]
 * @param adjustedElementIndex  Element index in LViewData[] (adjusted for HEADER_OFFSET)
 */
function componentRefresh(directiveIndex, adjustedElementIndex) {
    ngDevMode && assertDataInRange(adjustedElementIndex);
    var element = viewData[adjustedElementIndex];
    ngDevMode && assertNodeType(element, 3 /* Element */);
    ngDevMode &&
        assertDefined(element.data, "Component's host node should have an LViewData attached.");
    var hostView = element.data;
    // Only attached CheckAlways components or attached, dirty OnPush components should be checked
    if (viewAttached(hostView) && hostView[FLAGS] & (2 /* CheckAlways */ | 4 /* Dirty */)) {
        ngDevMode && assertDataInRange(directiveIndex, directives);
        detectChangesInternal(hostView, element, directives[directiveIndex]);
    }
}
/** Returns a boolean for whether the view is attached */
function viewAttached(view) {
    return (view[FLAGS] & 8 /* Attached */) === 8 /* Attached */;
}
/**
 * Instruction to distribute projectable nodes among <ng-content> occurrences in a given template.
 * It takes all the selectors from the entire component's template and decides where
 * each projected node belongs (it re-distributes nodes among "buckets" where each "bucket" is
 * backed by a selector).
 *
 * This function requires CSS selectors to be provided in 2 forms: parsed (by a compiler) and text,
 * un-parsed form.
 *
 * The parsed form is needed for efficient matching of a node against a given CSS selector.
 * The un-parsed, textual form is needed for support of the ngProjectAs attribute.
 *
 * Having a CSS selector in 2 different formats is not ideal, but alternatives have even more
 * drawbacks:
 * - having only a textual form would require runtime parsing of CSS selectors;
 * - we can't have only a parsed as we can't re-construct textual form from it (as entered by a
 * template author).
 *
 * @param selectors A collection of parsed CSS selectors
 * @param rawSelectors A collection of CSS selectors in the raw, un-parsed form
 */
function projectionDef(selectors, textSelectors) {
    var componentNode = findComponentHost(viewData);
    if (!componentNode.tNode.projection) {
        var noOfNodeBuckets = selectors ? selectors.length + 1 : 1;
        var pData = componentNode.tNode.projection =
            new Array(noOfNodeBuckets).fill(null);
        var tails = pData.slice();
        var componentChild = componentNode.tNode.child;
        while (componentChild !== null) {
            var bucketIndex = selectors ? matchingSelectorIndex(componentChild, selectors, textSelectors) : 0;
            var nextNode = componentChild.next;
            if (tails[bucketIndex]) {
                tails[bucketIndex].next = componentChild;
            }
            else {
                pData[bucketIndex] = componentChild;
                componentChild.next = null;
            }
            tails[bucketIndex] = componentChild;
            componentChild = nextNode;
        }
    }
}
/**
 * Stack used to keep track of projection nodes in projection() instruction.
 *
 * This is deliberately created outside of projection() to avoid allocating
 * a new array each time the function is called. Instead the array will be
 * re-used by each invocation. This works because the function is not reentrant.
 */
var projectionNodeStack$1 = [];
/**
 * Inserts previously re-distributed projected nodes. This instruction must be preceded by a call
 * to the projectionDef instruction.
 *
 * @param nodeIndex
 * @param selectorIndex:
 *        - 0 when the selector is `*` (or unspecified as this is the default value),
 *        - 1 based index of the selector from the {@link projectionDef}
 */
function projection(nodeIndex, selectorIndex, attrs) {
    if (selectorIndex === void 0) {
        selectorIndex = 0;
    }
    var node = createLNode(nodeIndex, 1 /* Projection */, null, null, attrs || null, null);
    // We can't use viewData[HOST_NODE] because projection nodes can be nested in embedded views.
    if (node.tNode.projection === null)
        node.tNode.projection = selectorIndex;
    // `<ng-content>` has no content
    isParent = false;
    // re-distribution of projectable nodes is stored on a component's view level
    var parent = getParentLNode(node);
    if (canInsertNativeNode(parent, viewData)) {
        var componentNode = findComponentHost(viewData);
        var nodeToProject = componentNode.tNode.projection[selectorIndex];
        var projectedView = componentNode.view;
        var projectionNodeIndex = -1;
        var grandparent = void 0;
        var renderParent = parent.tNode.type === 2 /* View */ ?
            (grandparent = getParentLNode(parent)) &&
                grandparent.data[RENDER_PARENT] :
            parent;
        while (nodeToProject) {
            if (nodeToProject.type === 1 /* Projection */) {
                // This node is re-projected, so we must go up the tree to get its projected nodes.
                var currentComponentHost = findComponentHost(projectedView);
                var firstProjectedNode = currentComponentHost.tNode.projection[nodeToProject.projection];
                if (firstProjectedNode) {
                    projectionNodeStack$1[++projectionNodeIndex] = projectedView[nodeToProject.index];
                    nodeToProject = firstProjectedNode;
                    projectedView = currentComponentHost.view;
                    continue;
                }
            }
            else {
                var lNode = projectedView[nodeToProject.index];
                lNode.tNode.flags |= 8192 /* isProjected */;
                appendProjectedNode(lNode, parent, viewData, renderParent);
            }
            // If we are finished with a list of re-projected nodes, we need to get
            // back to the root projection node that was re-projected.
            if (nodeToProject.next === null && projectedView !== componentNode.view) {
                // move down into the view of the component we're projecting right now
                var lNode = projectionNodeStack$1[projectionNodeIndex--];
                nodeToProject = lNode.tNode;
                projectedView = lNode.view;
            }
            nodeToProject = nodeToProject.next;
        }
    }
}
/**
 * Adds LViewData or LContainer to the end of the current view tree.
 *
 * This structure will be used to traverse through nested views to remove listeners
 * and call onDestroy callbacks.
 *
 * @param currentView The view where LViewData or LContainer should be added
 * @param adjustedHostIndex Index of the view's host node in LViewData[], adjusted for header
 * @param state The LViewData or LContainer to add to the view tree
 * @returns The state passed in
 */
function addToViewTree(currentView, adjustedHostIndex, state) {
    if (currentView[TAIL]) {
        currentView[TAIL][NEXT] = state;
    }
    else if (firstTemplatePass) {
        tView.childIndex = adjustedHostIndex;
    }
    currentView[TAIL] = state;
    return state;
}
///////////////////////////////
//// Change detection
///////////////////////////////
/** If node is an OnPush component, marks its LViewData dirty. */
function markDirtyIfOnPush(node) {
    // Because data flows down the component tree, ancestors do not need to be marked dirty
    if (node.data && !(node.data[FLAGS] & 2 /* CheckAlways */)) {
        node.data[FLAGS] |= 4 /* Dirty */;
    }
}
/**
 * Wraps an event listener so its host view and its ancestor views will be marked dirty
 * whenever the event fires. Necessary to support OnPush components.
 */
function wrapListenerWithDirtyLogic(view, listenerFn) {
    return function (e) {
        markViewDirty(view);
        return listenerFn(e);
    };
}
/**
 * Wraps an event listener so its host view and its ancestor views will be marked dirty
 * whenever the event fires. Also wraps with preventDefault behavior.
 */
function wrapListenerWithDirtyAndDefault(view, listenerFn) {
    return function wrapListenerIn_markViewDirty(e) {
        markViewDirty(view);
        if (listenerFn(e) === false) {
            e.preventDefault();
            // Necessary for legacy browsers that don't support preventDefault (e.g. IE)
            e.returnValue = false;
        }
    };
}
/** Marks current view and all ancestors dirty */
function markViewDirty(view) {
    var currentView = view;
    while (currentView[PARENT] != null) {
        currentView[FLAGS] |= 4 /* Dirty */;
        currentView = currentView[PARENT];
    }
    currentView[FLAGS] |= 4 /* Dirty */;
    ngDevMode && assertDefined(currentView[CONTEXT], 'rootContext');
    scheduleTick(currentView[CONTEXT]);
}
/**
 * Used to schedule change detection on the whole application.
 *
 * Unlike `tick`, `scheduleTick` coalesces multiple calls into one change detection run.
 * It is usually called indirectly by calling `markDirty` when the view needs to be
 * re-rendered.
 *
 * Typically `scheduleTick` uses `requestAnimationFrame` to coalesce multiple
 * `scheduleTick` requests. The scheduling function can be overridden in
 * `renderComponent`'s `scheduler` option.
 */
function scheduleTick(rootContext) {
    if (rootContext.clean == _CLEAN_PROMISE) {
        var res_1;
        rootContext.clean = new Promise(function (r) { return res_1 = r; });
        rootContext.scheduler(function () {
            tickRootContext(rootContext);
            res_1(null);
            rootContext.clean = _CLEAN_PROMISE;
        });
    }
}
function tickRootContext(rootContext) {
    for (var i = 0; i < rootContext.components.length; i++) {
        var rootComponent = rootContext.components[i];
        var hostNode = _getComponentHostLElementNode(rootComponent);
        ngDevMode && assertDefined(hostNode.data, 'Component host node should be attached to an LView');
        renderComponentOrTemplate(hostNode, getRootView(rootComponent), rootComponent);
    }
}
/**
 * Retrieve the root view from any component by walking the parent `LViewData` until
 * reaching the root `LViewData`.
 *
 * @param component any component
 */
function getRootView(component) {
    ngDevMode && assertDefined(component, 'component');
    var lElementNode = _getComponentHostLElementNode(component);
    var lViewData = lElementNode.view;
    while (lViewData[PARENT]) {
        lViewData = lViewData[PARENT];
    }
    return lViewData;
}
/**
 * Synchronously perform change detection on a component (and possibly its sub-components).
 *
 * This function triggers change detection in a synchronous way on a component. There should
 * be very little reason to call this function directly since a preferred way to do change
 * detection is to {@link markDirty} the component and wait for the scheduler to call this method
 * at some future point in time. This is because a single user action often results in many
 * components being invalidated and calling change detection on each component synchronously
 * would be inefficient. It is better to wait until all components are marked as dirty and
 * then perform single change detection across all of the components
 *
 * @param component The component which the change detection should be performed on.
 */
function detectChanges(component) {
    var hostNode = _getComponentHostLElementNode(component);
    ngDevMode &&
        assertDefined(hostNode.data, 'Component host node should be attached to an LViewData instance.');
    detectChangesInternal(hostNode.data, hostNode, component);
}
/**
 * Checks the change detector and its children, and throws if any changes are detected.
 *
 * This is used in development mode to verify that running change detection doesn't
 * introduce other changes.
 */
function checkNoChanges(component) {
    checkNoChangesMode = true;
    try {
        detectChanges(component);
    }
    finally {
        checkNoChangesMode = false;
    }
}
/** Checks the view of the component provided. Does not gate on dirty checks or execute doCheck. */
function detectChangesInternal(hostView, hostNode, component) {
    var oldView = enterView(hostView, hostNode);
    var hostTView = hostView[TVIEW];
    var template = hostTView.template;
    var viewQuery = hostTView.viewQuery;
    try {
        namespaceHTML();
        createViewQuery(viewQuery, hostView[FLAGS], component);
        template(getRenderFlags(hostView), component);
        refreshView();
        updateViewQuery(viewQuery, component);
    }
    finally {
        leaveView(oldView);
    }
}
function createViewQuery(viewQuery, flags, component) {
    if (viewQuery && (flags & 1 /* CreationMode */)) {
        viewQuery(1 /* Create */, component);
    }
}
function updateViewQuery(viewQuery, component) {
    if (viewQuery) {
        viewQuery(2 /* Update */, component);
    }
}
/**
 * Mark the component as dirty (needing change detection).
 *
 * Marking a component dirty will schedule a change detection on this
 * component at some point in the future. Marking an already dirty
 * component as dirty is a noop. Only one outstanding change detection
 * can be scheduled per component tree. (Two components bootstrapped with
 * separate `renderComponent` will have separate schedulers)
 *
 * When the root component is bootstrapped with `renderComponent`, a scheduler
 * can be provided.
 *
 * @param component Component to mark as dirty.
 */
function markDirty(component) {
    ngDevMode && assertDefined(component, 'component');
    var lElementNode = _getComponentHostLElementNode(component);
    markViewDirty(lElementNode.view);
}
/** A special value which designates that a value has not changed. */
var NO_CHANGE = {};
/**
 *  Initializes the binding start index. Will get inlined.
 *
 *  This function must be called before any binding related function is called
 *  (ie `bind()`, `interpolationX()`, `pureFunctionX()`)
 */
function initBindings() {
    ngDevMode && assertEqual(viewData[BINDING_INDEX], -1, 'Binding index should not yet be set ' + viewData[BINDING_INDEX]);
    if (tView.bindingStartIndex === -1) {
        tView.bindingStartIndex = viewData.length;
    }
    viewData[BINDING_INDEX] = tView.bindingStartIndex;
}
/**
 * Creates a single value binding.
 *
 * @param value Value to diff
 */
function bind(value) {
    return bindingUpdated(value) ? value : NO_CHANGE;
}
/**
 * Reserves slots for pure functions (`pureFunctionX` instructions)
 *
 * Bindings for pure functions are stored after the LNodes in the data array but before the binding.
 *
 *  ----------------------------------------------------------------------------
 *  |  LNodes ... | pure function bindings | regular bindings / interpolations |
 *  ----------------------------------------------------------------------------
 *                                         ^
 *                                         TView.bindingStartIndex
 *
 * Pure function instructions are given an offset from TView.bindingStartIndex.
 * Subtracting the offset from TView.bindingStartIndex gives the first index where the bindings
 * are stored.
 *
 * NOTE: reserveSlots instructions are only ever allowed at the very end of the creation block
 */
function reserveSlots(numSlots) {
    // Init the slots with a unique `NO_CHANGE` value so that the first change is always detected
    // whether it happens or not during the first change detection pass - pure functions checks
    // might be skipped when short-circuited.
    viewData.length += numSlots;
    viewData.fill(NO_CHANGE, -numSlots);
    // We need to initialize the binding in case a `pureFunctionX` kind of binding instruction is
    // called first in the update section.
    initBindings();
}
/**
 * Sets up the binding index before executing any `pureFunctionX` instructions.
 *
 * The index must be restored after the pure function is executed
 *
 * {@link reserveSlots}
 */
function moveBindingIndexToReservedSlot(offset) {
    var currentSlot = viewData[BINDING_INDEX];
    viewData[BINDING_INDEX] = tView.bindingStartIndex - offset;
    return currentSlot;
}
/**
 * Restores the binding index to the given value.
 *
 * This function is typically used to restore the index after a `pureFunctionX` has
 * been executed.
 */
function restoreBindingIndex(index) {
    viewData[BINDING_INDEX] = index;
}
/**
 * Create interpolation bindings with a variable number of expressions.
 *
 * If there are 1 to 8 expressions `interpolation1()` to `interpolation8()` should be used instead.
 * Those are faster because there is no need to create an array of expressions and iterate over it.
 *
 * `values`:
 * - has static text at even indexes,
 * - has evaluated expressions at odd indexes.
 *
 * Returns the concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function interpolationV(values) {
    ngDevMode && assertLessThan(2, values.length, 'should have at least 3 values');
    ngDevMode && assertEqual(values.length % 2, 1, 'should have an odd number of values');
    var different = false;
    for (var i = 1; i < values.length; i += 2) {
        // Check if bindings (odd indexes) have changed
        bindingUpdated(values[i]) && (different = true);
    }
    if (!different) {
        return NO_CHANGE;
    }
    // Build the updated content
    var content = values[0];
    for (var i = 1; i < values.length; i += 2) {
        content += stringify$1(values[i]) + values[i + 1];
    }
    return content;
}
/**
 * Creates an interpolation binding with 1 expression.
 *
 * @param prefix static value used for concatenation only.
 * @param v0 value checked for change.
 * @param suffix static value used for concatenation only.
 */
function interpolation1(prefix, v0, suffix) {
    var different = bindingUpdated(v0);
    return different ? prefix + stringify$1(v0) + suffix : NO_CHANGE;
}
/** Creates an interpolation binding with 2 expressions. */
function interpolation2(prefix, v0, i0, v1, suffix) {
    var different = bindingUpdated2(v0, v1);
    return different ? prefix + stringify$1(v0) + i0 + stringify$1(v1) + suffix : NO_CHANGE;
}
/** Creates an interpolation binding with 3 expressions. */
function interpolation3(prefix, v0, i0, v1, i1, v2, suffix) {
    var different = bindingUpdated2(v0, v1);
    different = bindingUpdated(v2) || different;
    return different ? prefix + stringify$1(v0) + i0 + stringify$1(v1) + i1 + stringify$1(v2) + suffix :
        NO_CHANGE;
}
/** Create an interpolation binding with 4 expressions. */
function interpolation4(prefix, v0, i0, v1, i1, v2, i2, v3, suffix) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    return different ?
        prefix + stringify$1(v0) + i0 + stringify$1(v1) + i1 + stringify$1(v2) + i2 + stringify$1(v3) +
            suffix :
        NO_CHANGE;
}
/** Creates an interpolation binding with 5 expressions. */
function interpolation5(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, suffix) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    different = bindingUpdated(v4) || different;
    return different ?
        prefix + stringify$1(v0) + i0 + stringify$1(v1) + i1 + stringify$1(v2) + i2 + stringify$1(v3) + i3 +
            stringify$1(v4) + suffix :
        NO_CHANGE;
}
/** Creates an interpolation binding with 6 expressions. */
function interpolation6(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, suffix) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    different = bindingUpdated2(v4, v5) || different;
    return different ?
        prefix + stringify$1(v0) + i0 + stringify$1(v1) + i1 + stringify$1(v2) + i2 + stringify$1(v3) + i3 +
            stringify$1(v4) + i4 + stringify$1(v5) + suffix :
        NO_CHANGE;
}
/** Creates an interpolation binding with 7 expressions. */
function interpolation7(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, suffix) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    different = bindingUpdated2(v4, v5) || different;
    different = bindingUpdated(v6) || different;
    return different ?
        prefix + stringify$1(v0) + i0 + stringify$1(v1) + i1 + stringify$1(v2) + i2 + stringify$1(v3) + i3 +
            stringify$1(v4) + i4 + stringify$1(v5) + i5 + stringify$1(v6) + suffix :
        NO_CHANGE;
}
/** Creates an interpolation binding with 8 expressions. */
function interpolation8(prefix, v0, i0, v1, i1, v2, i2, v3, i3, v4, i4, v5, i5, v6, i6, v7, suffix) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    different = bindingUpdated4(v4, v5, v6, v7) || different;
    return different ?
        prefix + stringify$1(v0) + i0 + stringify$1(v1) + i1 + stringify$1(v2) + i2 + stringify$1(v3) + i3 +
            stringify$1(v4) + i4 + stringify$1(v5) + i5 + stringify$1(v6) + i6 + stringify$1(v7) + suffix :
        NO_CHANGE;
}
/** Store a value in the `data` at a given `index`. */
function store(index, value) {
    // We don't store any static data for local variables, so the first time
    // we see the template, we should store as null to avoid a sparse array
    var adjustedIndex = index + HEADER_OFFSET;
    if (adjustedIndex >= tView.data.length) {
        tView.data[adjustedIndex] = null;
    }
    viewData[adjustedIndex] = value;
}
/** Retrieves a value from the `directives` array. */
function loadDirective(index) {
    ngDevMode && assertDefined(directives, 'Directives array should be defined if reading a dir.');
    ngDevMode && assertDataInRange(index, directives);
    return directives[index];
}
function loadQueryList(queryListIdx) {
    ngDevMode && assertDefined(viewData[CONTENT_QUERIES], 'Content QueryList array should be defined if reading a query.');
    ngDevMode && assertDataInRange(queryListIdx, viewData[CONTENT_QUERIES]);
    return viewData[CONTENT_QUERIES][queryListIdx];
}
/** Retrieves a value from current `viewData`. */
function load(index) {
    return loadInternal(index, viewData);
}
function loadElement(index) {
    return loadElementInternal(index, viewData);
}
/** Gets the current binding value and increments the binding index. */
function consumeBinding() {
    ngDevMode && assertDataInRange(viewData[BINDING_INDEX]);
    ngDevMode &&
        assertNotEqual(viewData[viewData[BINDING_INDEX]], NO_CHANGE, 'Stored value should never be NO_CHANGE.');
    return viewData[viewData[BINDING_INDEX]++];
}
/** Updates binding if changed, then returns whether it was updated. */
function bindingUpdated(value) {
    ngDevMode && assertNotEqual(value, NO_CHANGE, 'Incoming value should never be NO_CHANGE.');
    if (viewData[BINDING_INDEX] === -1)
        initBindings();
    var bindingIndex = viewData[BINDING_INDEX];
    if (bindingIndex >= viewData.length) {
        viewData[viewData[BINDING_INDEX]++] = value;
    }
    else if (isDifferent(viewData[bindingIndex], value)) {
        throwErrorIfNoChangesMode(creationMode, checkNoChangesMode, viewData[bindingIndex], value);
        viewData[viewData[BINDING_INDEX]++] = value;
    }
    else {
        viewData[BINDING_INDEX]++;
        return false;
    }
    return true;
}
/** Updates binding if changed, then returns the latest value. */
function checkAndUpdateBinding$1(value) {
    bindingUpdated(value);
    return value;
}
/** Updates 2 bindings if changed, then returns whether either was updated. */
function bindingUpdated2(exp1, exp2) {
    var different = bindingUpdated(exp1);
    return bindingUpdated(exp2) || different;
}
/** Updates 4 bindings if changed, then returns whether any was updated. */
function bindingUpdated4(exp1, exp2, exp3, exp4) {
    var different = bindingUpdated2(exp1, exp2);
    return bindingUpdated2(exp3, exp4) || different;
}
function getTView() {
    return tView;
}
/**
 * Registers a QueryList, associated with a content query, for later refresh (part of a view
 * refresh).
 */
function registerContentQuery(queryList) {
    var savedContentQueriesLength = (viewData[CONTENT_QUERIES] || (viewData[CONTENT_QUERIES] = [])).push(queryList);
    if (firstTemplatePass) {
        var currentDirectiveIndex = directives.length - 1;
        var tViewContentQueries = tView.contentQueries || (tView.contentQueries = []);
        var lastSavedDirectiveIndex = tView.contentQueries.length ? tView.contentQueries[tView.contentQueries.length - 2] : -1;
        if (currentDirectiveIndex !== lastSavedDirectiveIndex) {
            tViewContentQueries.push(currentDirectiveIndex, savedContentQueriesLength - 1);
        }
    }
}
function assertPreviousIsParent() {
    assertEqual(isParent, true, 'previousOrParentNode should be a parent');
}
function assertHasParent() {
    assertDefined(getParentLNode(previousOrParentNode), 'previousOrParentNode should have a parent');
}
function assertDataInRange(index, arr) {
    if (arr == null)
        arr = viewData;
    assertDataInRangeInternal(index, arr || viewData);
}
function assertDataNext(index, arr) {
    if (arr == null)
        arr = viewData;
    assertEqual(arr.length, index, "index " + index + " expected to be at the end of arr (length " + arr.length + ")");
}
/**
 * On the first template pass, the reserved slots should be set `NO_CHANGE`.
 *
 * If not, they might not have been actually reserved.
 */
function assertReservedSlotInitialized(slotOffset, numSlots) {
    if (firstTemplatePass) {
        var startIndex = tView.bindingStartIndex - slotOffset;
        for (var i = 0; i < numSlots; i++) {
            assertEqual(viewData[startIndex + i], NO_CHANGE, 'The reserved slots should be set to `NO_CHANGE` on first template pass');
        }
    }
}
function _getComponentHostLElementNode(component) {
    ngDevMode && assertDefined(component, 'expecting component got null');
    var lElementNode = component[NG_HOST_SYMBOL];
    ngDevMode && assertDefined(component, 'object is not a component');
    return lElementNode;
}
var CLEAN_PROMISE = _CLEAN_PROMISE;
var ROOT_DIRECTIVE_INDICES = _ROOT_DIRECTIVE_INDICES;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Bootstraps a Component into an existing host element and returns an instance
 * of the component.
 *
 * Use this function to bootstrap a component into the DOM tree. Each invocation
 * of this function will create a separate tree of components, injectors and
 * change detection cycles and lifetimes. To dynamically insert a new component
 * into an existing tree such that it shares the same injection, change detection
 * and object lifetime, use {@link ViewContainer#createComponent}.
 *
 * @param componentType Component to bootstrap
 * @param options Optional parameters which control bootstrapping
 */
function renderComponent(componentType /* Type as workaround for: Microsoft/TypeScript/issues/4881 */, opts) {
    if (opts === void 0) {
        opts = {};
    }
    ngDevMode && assertComponentType(componentType);
    var rendererFactory = opts.rendererFactory || domRendererFactory3;
    var sanitizer = opts.sanitizer || null;
    var componentDef = componentType.ngComponentDef;
    if (componentDef.type != componentType)
        componentDef.type = componentType;
    var component;
    // The first index of the first selector is the tag name.
    var componentTag = componentDef.selectors[0][0];
    var hostNode = locateHostElement(rendererFactory, opts.host || componentTag);
    var rootContext = createRootContext(opts.scheduler || requestAnimationFrame.bind(window));
    var rootView = createLViewData(rendererFactory.createRenderer(hostNode, componentDef.rendererType), createTView(-1, null, null, null, null), rootContext, componentDef.onPush ? 4 /* Dirty */ : 2 /* CheckAlways */);
    rootView[INJECTOR$1] = opts.injector || null;
    var oldView = enterView(rootView, null);
    var elementNode;
    try {
        if (rendererFactory.begin)
            rendererFactory.begin();
        // Create element node at index 0 in data array
        elementNode = hostElement(componentTag, hostNode, componentDef, sanitizer);
        // Create directive instance with factory() and store at index 0 in directives array
        rootContext.components.push(component = baseDirectiveCreate(0, componentDef.factory(), componentDef));
        initChangeDetectorIfExisting(elementNode.nodeInjector, component, elementNode.data);
        opts.hostFeatures && opts.hostFeatures.forEach(function (feature) { return feature(component, componentDef); });
        executeInitAndContentHooks();
        setHostBindings(ROOT_DIRECTIVE_INDICES);
        detectChangesInternal(elementNode.data, elementNode, component);
    }
    finally {
        leaveView(oldView);
        if (rendererFactory.end)
            rendererFactory.end();
    }
    return component;
}
function createRootContext(scheduler) {
    return {
        components: [],
        scheduler: scheduler,
        clean: CLEAN_PROMISE,
    };
}
/**
 * Used to enable lifecycle hooks on the root component.
 *
 * Include this feature when calling `renderComponent` if the root component
 * you are rendering has lifecycle hooks defined. Otherwise, the hooks won't
 * be called properly.
 *
 * Example:
 *
 * ```
 * renderComponent(AppComponent, {features: [RootLifecycleHooks]});
 * ```
 */
function LifecycleHooksFeature(component, def) {
    var elementNode = _getComponentHostLElementNode(component);
    // Root component is always created at dir index 0
    var tView = elementNode.view[TVIEW];
    queueInitHooks(0, def.onInit, def.doCheck, tView);
    queueLifecycleHooks(elementNode.tNode.flags, tView);
}
/**
 * Retrieve the root context for any component by walking the parent `LView` until
 * reaching the root `LView`.
 *
 * @param component any component
 */
function getRootContext(component) {
    var rootContext = getRootView(component)[CONTEXT];
    ngDevMode && assertDefined(rootContext, 'rootContext');
    return rootContext;
}
/**
 * Wait on component until it is rendered.
 *
 * This function returns a `Promise` which is resolved when the component's
 * change detection is executed. This is determined by finding the scheduler
 * associated with the `component`'s render tree and waiting until the scheduler
 * flushes. If nothing is scheduled, the function returns a resolved promise.
 *
 * Example:
 * ```
 * await whenRendered(myComponent);
 * ```
 *
 * @param component Component to wait upon
 * @returns Promise which resolves when the component is rendered.
 */
function whenRendered(component) {
    return getRootContext(component).clean;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Create a component definition object.
 *
 *
 * # Example
 * ```
 * class MyDirective {
 *   // Generated by Angular Template Compiler
 *   // [Symbol] syntax will not be supported by TypeScript until v2.7
 *   static ngComponentDef = defineComponent({
 *     ...
 *   });
 * }
 * ```
 */
function defineComponent(componentDefinition) {
    var type = componentDefinition.type;
    var pipeTypes = componentDefinition.pipes;
    var directiveTypes = componentDefinition.directives;
    var declaredInputs = {};
    var def = {
        type: type,
        diPublic: null,
        factory: componentDefinition.factory,
        template: componentDefinition.template || null,
        hostBindings: componentDefinition.hostBindings || null,
        contentQueries: componentDefinition.contentQueries || null,
        contentQueriesRefresh: componentDefinition.contentQueriesRefresh || null,
        attributes: componentDefinition.attributes || null,
        inputs: invertObject(componentDefinition.inputs, declaredInputs),
        declaredInputs: declaredInputs,
        outputs: invertObject(componentDefinition.outputs),
        rendererType: resolveRendererType2(componentDefinition.rendererType) || null,
        exportAs: componentDefinition.exportAs || null,
        onInit: type.prototype.ngOnInit || null,
        doCheck: type.prototype.ngDoCheck || null,
        afterContentInit: type.prototype.ngAfterContentInit || null,
        afterContentChecked: type.prototype.ngAfterContentChecked || null,
        afterViewInit: type.prototype.ngAfterViewInit || null,
        afterViewChecked: type.prototype.ngAfterViewChecked || null,
        onDestroy: type.prototype.ngOnDestroy || null,
        onPush: componentDefinition.changeDetection === ChangeDetectionStrategy.OnPush,
        directiveDefs: directiveTypes ?
            function () {
                return (typeof directiveTypes === 'function' ? directiveTypes() : directiveTypes)
                    .map(extractDirectiveDef);
            } :
            null,
        pipeDefs: pipeTypes ?
            function () { return (typeof pipeTypes === 'function' ? pipeTypes() : pipeTypes).map(extractPipeDef); } :
            null,
        selectors: componentDefinition.selectors,
        viewQuery: componentDefinition.viewQuery || null,
        features: componentDefinition.features || null,
    };
    var feature = componentDefinition.features;
    feature && feature.forEach(function (fn) { return fn(def); });
    return def;
}
function extractDirectiveDef(type) {
    var def = type.ngComponentDef || type.ngDirectiveDef;
    if (ngDevMode && !def) {
        throw new Error("'" + type.name + "' is neither 'ComponentType' or 'DirectiveType'.");
    }
    return def;
}
function extractPipeDef(type) {
    var def = type.ngPipeDef;
    if (ngDevMode && !def) {
        throw new Error("'" + type.name + "' is not a 'PipeType'.");
    }
    return def;
}
function defineNgModule(def) {
    var res = {
        type: def.type,
        bootstrap: def.bootstrap || [],
        declarations: def.declarations || [],
        imports: def.imports || [],
        exports: def.exports || [],
        transitiveCompileScopes: null,
    };
    return res;
}
var EMPTY$1 = {};
/**
 * Inverts an inputs or outputs lookup such that the keys, which were the
 * minified keys, are part of the values, and the values are parsed so that
 * the publicName of the property is the new key
 *
 * e.g. for
 *
 * ```
 * class Comp {
 *   @Input()
 *   propName1: string;
 *
 *   @Input('publicName')
 *   propName2: number;
 * }
 * ```
 *
 * will be serialized as
 *
 * ```
 * {
 *   a0: 'propName1',
 *   b1: ['publicName', 'propName2'],
 * }
 * ```
 *
 * becomes
 *
 * ```
 * {
 *  'propName1': 'a0',
 *  'publicName': 'b1'
 * }
 * ```
 *
 * Optionally the function can take `secondary` which will result in:
 *
 * ```
 * {
 *  'propName1': 'a0',
 *  'propName2': 'b1'
 * }
 * ```
 *

 */
function invertObject(obj, secondary) {
    if (obj == null)
        return EMPTY$1;
    var newLookup = {};
    for (var minifiedKey in obj) {
        if (obj.hasOwnProperty(minifiedKey)) {
            var publicName = obj[minifiedKey];
            var declaredName = publicName;
            if (Array.isArray(publicName)) {
                declaredName = publicName[1];
                publicName = publicName[0];
            }
            newLookup[publicName] = minifiedKey;
            if (secondary) {
                (secondary[declaredName] = minifiedKey);
            }
        }
    }
    return newLookup;
}
/**
 * Create a directive definition object.
 *
 * # Example
 * ```
 * class MyDirective {
 *   // Generated by Angular Template Compiler
 *   // [Symbol] syntax will not be supported by TypeScript until v2.7
 *   static ngDirectiveDef = defineDirective({
 *     ...
 *   });
 * }
 * ```
 */
var defineDirective = defineComponent;
/**
 * Create a pipe definition object.
 *
 * # Example
 * ```
 * class MyPipe implements PipeTransform {
 *   // Generated by Angular Template Compiler
 *   static ngPipeDef = definePipe({
 *     ...
 *   });
 * }
 * ```
 * @param pipeDef Pipe definition generated by the compiler
 */
function definePipe(pipeDef) {
    return {
        name: pipeDef.name,
        factory: pipeDef.factory,
        pure: pipeDef.pure !== false,
        onDestroy: pipeDef.type.prototype.ngOnDestroy || null
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Sets properties on a target object from a source object, but only if
 * the property doesn't already exist on the target object.
 * @param target The target to set properties on
 * @param source The source of the property keys and values to set
 */
function fillProperties(target, source) {
    for (var key in source) {
        if (source.hasOwnProperty(key) && !target.hasOwnProperty(key)) {
            target[key] = source[key];
        }
    }
}
/**
 * Determines if a definition is a {@link ComponentDefInternal} or a {@link DirectiveDefInternal}
 * @param definition The definition to examine
 */
function isComponentDef(definition) {
    var def = definition;
    return typeof def.template === 'function';
}
function getSuperType(type) {
    return Object.getPrototypeOf(type.prototype).constructor;
}
/**
 * Merges the definition from a super class to a sub class.
 * @param definition The definition that is a SubClass of another directive of component
 */
function InheritDefinitionFeature(definition) {
    var superType = getSuperType(definition.type);
    var superDef = undefined;
    var _loop_1 = function () {
        var e_1, _a;
        if (isComponentDef(definition)) {
            superDef = superType.ngComponentDef || superType.ngDirectiveDef;
        }
        else {
            if (superType.ngComponentDef) {
                throw new Error('Directives cannot inherit Components');
            }
            superDef = superType.ngDirectiveDef;
        }
        if (superDef) {
            // Merge inputs and outputs
            fillProperties(definition.inputs, superDef.inputs);
            fillProperties(definition.declaredInputs, superDef.declaredInputs);
            fillProperties(definition.outputs, superDef.outputs);
            // Merge hostBindings
            var prevHostBindings_1 = definition.hostBindings;
            var superHostBindings_1 = superDef.hostBindings;
            if (superHostBindings_1) {
                if (prevHostBindings_1) {
                    definition.hostBindings = function (directiveIndex, elementIndex) {
                        superHostBindings_1(directiveIndex, elementIndex);
                        prevHostBindings_1(directiveIndex, elementIndex);
                    };
                }
                else {
                    definition.hostBindings = superHostBindings_1;
                }
            }
            // Inherit hooks
            // Assume super class inheritance feature has already run.
            definition.afterContentChecked =
                definition.afterContentChecked || superDef.afterContentChecked;
            definition.afterContentInit = definition.afterContentInit || superDef.afterContentInit;
            definition.afterViewChecked = definition.afterViewChecked || superDef.afterViewChecked;
            definition.afterViewInit = definition.afterViewInit || superDef.afterViewInit;
            definition.doCheck = definition.doCheck || superDef.doCheck;
            definition.onDestroy = definition.onDestroy || superDef.onDestroy;
            definition.onInit = definition.onInit || superDef.onInit;
            // Run parent features
            var features = superDef.features;
            if (features) {
                try {
                    for (var features_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(features), features_1_1 = features_1.next(); !features_1_1.done; features_1_1 = features_1.next()) {
                        var feature = features_1_1.value;
                        if (feature && feature !== InheritDefinitionFeature) {
                            feature(definition);
                        }
                    }
                }
                catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                }
                finally {
                    try {
                        if (features_1_1 && !features_1_1.done && (_a = features_1.return))
                            _a.call(features_1);
                    }
                    finally {
                        if (e_1)
                            throw e_1.error;
                    }
                }
            }
        }
        else {
            // Even if we don't have a definition, check the type for the hooks and use those if need be
            var superPrototype = superType.prototype;
            if (superPrototype) {
                definition.afterContentChecked =
                    definition.afterContentChecked || superPrototype.afterContentChecked;
                definition.afterContentInit =
                    definition.afterContentInit || superPrototype.afterContentInit;
                definition.afterViewChecked =
                    definition.afterViewChecked || superPrototype.afterViewChecked;
                definition.afterViewInit = definition.afterViewInit || superPrototype.afterViewInit;
                definition.doCheck = definition.doCheck || superPrototype.doCheck;
                definition.onDestroy = definition.onDestroy || superPrototype.onDestroy;
                definition.onInit = definition.onInit || superPrototype.onInit;
            }
        }
        superType = Object.getPrototypeOf(superType);
    };
    while (superType && !superDef) {
        _loop_1();
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var PRIVATE_PREFIX = '__ngOnChanges_';
/**
 * The NgOnChangesFeature decorates a component with support for the ngOnChanges
 * lifecycle hook, so it should be included in any component that implements
 * that hook.
 *
 * If the component or directive uses inheritance, the NgOnChangesFeature MUST
 * be included as a feature AFTER {@link InheritDefinitionFeature}, otherwise
 * inherited properties will not be propagated to the ngOnChanges lifecycle
 * hook.
 *
 * Example usage:
 *
 * ```
 * static ngComponentDef = defineComponent({
 *   ...
 *   inputs: {name: 'publicName'},
 *   features: [NgOnChangesFeature]
 * });
 * ```
 */
function NgOnChangesFeature(definition) {
    var declaredToMinifiedInputs = definition.declaredInputs;
    var proto = definition.type.prototype;
    var _loop_1 = function (declaredName) {
        if (declaredToMinifiedInputs.hasOwnProperty(declaredName)) {
            var minifiedKey = declaredToMinifiedInputs[declaredName];
            var privateMinKey_1 = PRIVATE_PREFIX + minifiedKey;
            // Walk the prototype chain to see if we find a property descriptor
            // That way we can honor setters and getters that were inherited.
            var originalProperty = undefined;
            var checkProto = proto;
            while (!originalProperty && checkProto &&
                Object.getPrototypeOf(checkProto) !== Object.getPrototypeOf(Object.prototype)) {
                originalProperty = Object.getOwnPropertyDescriptor(checkProto, minifiedKey);
                checkProto = Object.getPrototypeOf(checkProto);
            }
            var getter = originalProperty && originalProperty.get;
            var setter_1 = originalProperty && originalProperty.set;
            // create a getter and setter for property
            Object.defineProperty(proto, minifiedKey, {
                get: getter ||
                    (setter_1 ? undefined : function () { return this[privateMinKey_1]; }),
                set: function (value) {
                    var simpleChanges = this[PRIVATE_PREFIX];
                    if (!simpleChanges) {
                        simpleChanges = {};
                        // Place where we will store SimpleChanges if there is a change
                        Object.defineProperty(this, PRIVATE_PREFIX, { value: simpleChanges, writable: true });
                    }
                    var isFirstChange = !this.hasOwnProperty(privateMinKey_1);
                    var currentChange = simpleChanges[declaredName];
                    if (currentChange) {
                        currentChange.currentValue = value;
                    }
                    else {
                        simpleChanges[declaredName] =
                            new SimpleChange(this[privateMinKey_1], value, isFirstChange);
                    }
                    if (isFirstChange) {
                        // Create a place where the actual value will be stored and make it non-enumerable
                        Object.defineProperty(this, privateMinKey_1, { value: value, writable: true });
                    }
                    else {
                        this[privateMinKey_1] = value;
                    }
                    if (setter_1)
                        setter_1.call(this, value);
                }
            });
        }
    };
    for (var declaredName in declaredToMinifiedInputs) {
        _loop_1(declaredName);
    }
    // If an onInit hook is defined, it will need to wrap the ngOnChanges call
    // so the call order is changes-init-check in creation mode. In subsequent
    // change detection runs, only the check wrapper will be called.
    if (definition.onInit != null) {
        definition.onInit = onChangesWrapper(definition.onInit);
    }
    definition.doCheck = onChangesWrapper(definition.doCheck);
}
function onChangesWrapper(delegateHook) {
    return function () {
        var simpleChanges = this[PRIVATE_PREFIX];
        if (simpleChanges != null) {
            this.ngOnChanges(simpleChanges);
            this[PRIVATE_PREFIX] = null;
        }
        if (delegateHook)
            delegateHook.apply(this);
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ViewRef$1 = /*@__PURE__*/ (function () {
    function ViewRef(_view, context) {
        this._view = _view;
        this._appRef = null;
        this._viewContainerRef = null;
        /**
         * @internal
         */
        this._lViewNode = null;
        this.context = context;
    }
    /** @internal */
    ViewRef.prototype._setComponentContext = function (view, context) {
        this._view = view;
        this.context = context;
    };
    Object.defineProperty(ViewRef.prototype, "destroyed", {
        get: function () {
            return (this._view[FLAGS] & 32 /* Destroyed */) === 32 /* Destroyed */;
        },
        enumerable: true,
        configurable: true
    });
    ViewRef.prototype.destroy = function () {
        if (this._viewContainerRef && viewAttached(this._view)) {
            this._viewContainerRef.detach(this._viewContainerRef.indexOf(this));
            this._viewContainerRef = null;
        }
        destroyLView(this._view);
    };
    ViewRef.prototype.onDestroy = function (callback) { storeCleanupFn(this._view, callback); };
    /**
     * Marks a view and all of its ancestors dirty.
     *
     * It also triggers change detection by calling `scheduleTick` internally, which coalesces
     * multiple `markForCheck` calls to into one change detection run.
     *
     * This can be used to ensure an {@link ChangeDetectionStrategy#OnPush OnPush} component is
     * checked when it needs to be re-rendered but the two normal triggers haven't marked it
     * dirty (i.e. inputs haven't changed and events haven't fired in the view).
     *
     * <!-- TODO: Add a link to a chapter on OnPush components -->
     *
     * @usageNotes
     * ### Example
     *
     * ```typescript
     * @Component({
     *   selector: 'my-app',
     *   template: `Number of ticks: {{numberOfTicks}}`
     *   changeDetection: ChangeDetectionStrategy.OnPush,
     * })
     * class AppComponent {
     *   numberOfTicks = 0;
     *
     *   constructor(private ref: ChangeDetectorRef) {
     *     setInterval(() => {
     *       this.numberOfTicks++;
     *       // the following is required, otherwise the view will not be updated
     *       this.ref.markForCheck();
     *     }, 1000);
     *   }
     * }
     * ```
     */
    ViewRef.prototype.markForCheck = function () { markViewDirty(this._view); };
    /**
     * Detaches the view from the change detection tree.
     *
     * Detached views will not be checked during change detection runs until they are
     * re-attached, even if they are dirty. `detach` can be used in combination with
     * {@link ChangeDetectorRef#detectChanges detectChanges} to implement local change
     * detection checks.
     *
     * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
     * <!-- TODO: Add a live demo once ref.detectChanges is merged into master -->
     *
     * @usageNotes
     * ### Example
     *
     * The following example defines a component with a large list of readonly data.
     * Imagine the data changes constantly, many times per second. For performance reasons,
     * we want to check and update the list every five seconds. We can do that by detaching
     * the component's change detector and doing a local check every five seconds.
     *
     * ```typescript
     * class DataProvider {
     *   // in a real application the returned data will be different every time
     *   get data() {
     *     return [1,2,3,4,5];
     *   }
     * }
     *
     * @Component({
     *   selector: 'giant-list',
     *   template: `
     *     <li *ngFor="let d of dataProvider.data">Data {{d}}</li>
     *   `,
     * })
     * class GiantList {
     *   constructor(private ref: ChangeDetectorRef, private dataProvider: DataProvider) {
     *     ref.detach();
     *     setInterval(() => {
     *       this.ref.detectChanges();
     *     }, 5000);
     *   }
     * }
     *
     * @Component({
     *   selector: 'app',
     *   providers: [DataProvider],
     *   template: `
     *     <giant-list><giant-list>
     *   `,
     * })
     * class App {
     * }
     * ```
     */
    ViewRef.prototype.detach = function () { this._view[FLAGS] &= ~8 /* Attached */; };
    /**
     * Re-attaches a view to the change detection tree.
     *
     * This can be used to re-attach views that were previously detached from the tree
     * using {@link ChangeDetectorRef#detach detach}. Views are attached to the tree by default.
     *
     * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
     *
     * @usageNotes
     * ### Example
     *
     * The following example creates a component displaying `live` data. The component will detach
     * its change detector from the main change detector tree when the component's live property
     * is set to false.
     *
     * ```typescript
     * class DataProvider {
     *   data = 1;
     *
     *   constructor() {
     *     setInterval(() => {
     *       this.data = this.data * 2;
     *     }, 500);
     *   }
     * }
     *
     * @Component({
     *   selector: 'live-data',
     *   inputs: ['live'],
     *   template: 'Data: {{dataProvider.data}}'
     * })
     * class LiveData {
     *   constructor(private ref: ChangeDetectorRef, private dataProvider: DataProvider) {}
     *
     *   set live(value) {
     *     if (value) {
     *       this.ref.reattach();
     *     } else {
     *       this.ref.detach();
     *     }
     *   }
     * }
     *
     * @Component({
     *   selector: 'my-app',
     *   providers: [DataProvider],
     *   template: `
     *     Live Update: <input type="checkbox" [(ngModel)]="live">
     *     <live-data [live]="live"><live-data>
     *   `,
     * })
     * class AppComponent {
     *   live = true;
     * }
     * ```
     */
    ViewRef.prototype.reattach = function () { this._view[FLAGS] |= 8 /* Attached */; };
    /**
     * Checks the view and its children.
     *
     * This can also be used in combination with {@link ChangeDetectorRef#detach detach} to implement
     * local change detection checks.
     *
     * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
     * <!-- TODO: Add a live demo once ref.detectChanges is merged into master -->
     *
     * @usageNotes
     * ### Example
     *
     * The following example defines a component with a large list of readonly data.
     * Imagine, the data changes constantly, many times per second. For performance reasons,
     * we want to check and update the list every five seconds.
     *
     * We can do that by detaching the component's change detector and doing a local change detection
     * check every five seconds.
     *
     * See {@link ChangeDetectorRef#detach detach} for more information.
     */
    ViewRef.prototype.detectChanges = function () { detectChanges(this.context); };
    /**
     * Checks the change detector and its children, and throws if any changes are detected.
     *
     * This is used in development mode to verify that running change detection doesn't
     * introduce other changes.
     */
    ViewRef.prototype.checkNoChanges = function () { checkNoChanges(this.context); };
    ViewRef.prototype.attachToViewContainerRef = function (vcRef) { this._viewContainerRef = vcRef; };
    ViewRef.prototype.detachFromAppRef = function () { this._appRef = null; };
    ViewRef.prototype.attachToAppRef = function (appRef) { this._appRef = appRef; };
    return ViewRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ComponentFactoryResolver$1 = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ComponentFactoryResolver$$1, _super);
    function ComponentFactoryResolver$$1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComponentFactoryResolver$$1.prototype.resolveComponentFactory = function (component) {
        ngDevMode && assertComponentType(component);
        var componentDef = component.ngComponentDef;
        return new ComponentFactory$1(componentDef);
    };
    return ComponentFactoryResolver$$1;
}(ComponentFactoryResolver));
function toRefArray(map) {
    var array = [];
    for (var nonMinified in map) {
        if (map.hasOwnProperty(nonMinified)) {
            var minified = map[nonMinified];
            array.push({ propName: minified, templateName: nonMinified });
        }
    }
    return array;
}
/**
 * Default {@link RootContext} for all components rendered with {@link renderComponent}.
 */
var ROOT_CONTEXT = /*@__PURE__*/ new InjectionToken('ROOT_CONTEXT_TOKEN', { providedIn: 'root', factory: function () { return createRootContext(inject(SCHEDULER)); } });
/**
 * A change detection scheduler token for {@link RootContext}. This token is the default value used
 * for the default `RootContext` found in the {@link ROOT_CONTEXT} token.
 */
var SCHEDULER = /*@__PURE__*/ new InjectionToken('SCHEDULER_TOKEN', { providedIn: 'root', factory: function () { return requestAnimationFrame.bind(window); } });
/**
 * Render3 implementation of {@link viewEngine_ComponentFactory}.
 */
var ComponentFactory$1 = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ComponentFactory$$1, _super);
    function ComponentFactory$$1(componentDef) {
        var _this = _super.call(this) || this;
        _this.componentDef = componentDef;
        _this.componentType = componentDef.type;
        _this.selector = componentDef.selectors[0][0];
        _this.ngContentSelectors = [];
        return _this;
    }
    Object.defineProperty(ComponentFactory$$1.prototype, "inputs", {
        get: function () {
            return toRefArray(this.componentDef.inputs);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentFactory$$1.prototype, "outputs", {
        get: function () {
            return toRefArray(this.componentDef.outputs);
        },
        enumerable: true,
        configurable: true
    });
    ComponentFactory$$1.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
        var isInternalRootView = rootSelectorOrNode === undefined;
        var rendererFactory = ngModule ? ngModule.injector.get(RendererFactory2) : domRendererFactory3;
        var hostNode = isInternalRootView ?
            elementCreate(this.selector, rendererFactory.createRenderer(null, this.componentDef.rendererType)) :
            locateHostElement(rendererFactory, rootSelectorOrNode);
        // The first index of the first selector is the tag name.
        var componentTag = this.componentDef.selectors[0][0];
        var rootContext = ngModule && !isInternalRootView ?
            ngModule.injector.get(ROOT_CONTEXT) :
            createRootContext(requestAnimationFrame.bind(window));
        // Create the root view. Uses empty TView and ContentTemplate.
        var rootView = createLViewData(rendererFactory.createRenderer(hostNode, this.componentDef.rendererType), createTView(-1, null, null, null, null), rootContext, this.componentDef.onPush ? 4 /* Dirty */ : 2 /* CheckAlways */);
        rootView[INJECTOR$1] = ngModule && ngModule.injector || null;
        // rootView is the parent when bootstrapping
        var oldView = enterView(rootView, null);
        var component;
        var elementNode;
        try {
            if (rendererFactory.begin)
                rendererFactory.begin();
            // Create element node at index 0 in data array
            elementNode = hostElement(componentTag, hostNode, this.componentDef);
            // Create directive instance with factory() and store at index 0 in directives array
            rootContext.components.push(component = baseDirectiveCreate(0, this.componentDef.factory(), this.componentDef));
            initChangeDetectorIfExisting(elementNode.nodeInjector, component, elementNode.data);
            // TODO: should LifecycleHooksFeature and other host features be generated by the compiler and
            // executed here?
            // Angular 5 reference: https://stackblitz.com/edit/lifecycle-hooks-vcref
            LifecycleHooksFeature(component, this.componentDef);
            // Transform the arrays of native nodes into a LNode structure that can be consumed by the
            // projection instruction. This is needed to support the reprojection of these nodes.
            if (projectableNodes) {
                var index = 0;
                var projection$$1 = elementNode.tNode.projection = [];
                for (var i = 0; i < projectableNodes.length; i++) {
                    var nodeList = projectableNodes[i];
                    var firstTNode = null;
                    var previousTNode = null;
                    for (var j = 0; j < nodeList.length; j++) {
                        var lNode = createLNode(++index, 3 /* Element */, nodeList[j], null, null);
                        if (previousTNode) {
                            previousTNode.next = lNode.tNode;
                        }
                        else {
                            firstTNode = lNode.tNode;
                        }
                        previousTNode = lNode.tNode;
                    }
                    projection$$1.push(firstTNode);
                }
            }
            // Execute the template in creation mode only, and then turn off the CreationMode flag
            renderEmbeddedTemplate(elementNode, elementNode.data[TVIEW], component, 1 /* Create */);
            elementNode.data[FLAGS] &= ~1 /* CreationMode */;
        }
        finally {
            enterView(oldView, null);
            if (rendererFactory.end)
                rendererFactory.end();
        }
        var componentRef = new ComponentRef$1(this.componentType, component, rootView, injector, hostNode);
        if (isInternalRootView) {
            // The host element of the internal root view is attached to the component's host view node
            componentRef.hostView._lViewNode.tNode.child = elementNode.tNode;
        }
        return componentRef;
    };
    return ComponentFactory$$1;
}(ComponentFactory));
/**
 * Represents an instance of a Component created via a {@link ComponentFactory}.
 *
 * `ComponentRef` provides access to the Component Instance as well other objects related to this
 * Component Instance and allows you to destroy the Component Instance via the {@link #destroy}
 * method.
 *
 */
var ComponentRef$1 = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ComponentRef$$1, _super);
    function ComponentRef$$1(componentType, instance, rootView, injector, hostNode) {
        var _this = _super.call(this) || this;
        _this.destroyCbs = [];
        _this.instance = instance;
        /* TODO(jasonaden): This is incomplete, to be adjusted in follow-up PR. Notes from Kara:When
         * ViewRef.detectChanges is called from ApplicationRef.tick, it will call detectChanges at the
         * component instance level. I suspect this means that lifecycle hooks and host bindings on the
         * given component won't work (as these are always called at the level above a component).
         *
         * In render2, ViewRef.detectChanges uses the root view instance for view checks, not the
         * component instance. So passing in the root view (1 level above the component) is sufficient.
         * We might  want to think about creating a fake component for the top level? Or overwrite
         * detectChanges with a function that calls tickRootContext? */
        _this.hostView = _this.changeDetectorRef = new ViewRef$1(rootView, instance);
        _this.hostView._lViewNode = createLNode(-1, 2 /* View */, null, null, null, rootView);
        _this.injector = injector;
        _this.location = new ElementRef(hostNode);
        _this.componentType = componentType;
        return _this;
    }
    ComponentRef$$1.prototype.destroy = function () {
        ngDevMode && assertDefined(this.destroyCbs, 'NgModule already destroyed');
        this.destroyCbs.forEach(function (fn) { return fn(); });
        this.destroyCbs = null;
    };
    ComponentRef$$1.prototype.onDestroy = function (callback) {
        ngDevMode && assertDefined(this.destroyCbs, 'NgModule already destroyed');
        this.destroyCbs.push(callback);
    };
    return ComponentRef$$1;
}(ComponentRef));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * If a directive is diPublic, bloomAdd sets a property on the instance with this constant as
 * the key and the directive's unique ID as the value. This allows us to map directives to their
 * bloom filter bit for DI.
 */
var NG_ELEMENT_ID = '__NG_ELEMENT_ID__';
/**
 * The number of slots in each bloom filter (used by DI). The larger this number, the fewer
 * directives that will share slots, and thus, the fewer false positives when checking for
 * the existence of a directive.
 */
var BLOOM_SIZE = 256;
/** Counter used to generate unique IDs for directives. */
var nextNgElementId = 0;
/**
 * Registers this directive as present in its node's injector by flipping the directive's
 * corresponding bit in the injector's bloom filter.
 *
 * @param injector The node injector in which the directive should be registered
 * @param type The directive to register
 */
function bloomAdd(injector, type) {
    var id = type[NG_ELEMENT_ID];
    // Set a unique ID on the directive type, so if something tries to inject the directive,
    // we can easily retrieve the ID and hash it into the bloom bit that should be checked.
    if (id == null) {
        id = type[NG_ELEMENT_ID] = nextNgElementId++;
    }
    // We only have BLOOM_SIZE (256) slots in our bloom filter (8 buckets * 32 bits each),
    // so all unique IDs must be modulo-ed into a number from 0 - 255 to fit into the filter.
    // This means that after 255, some directives will share slots, leading to some false positives
    // when checking for a directive's presence.
    var bloomBit = id % BLOOM_SIZE;
    // Create a mask that targets the specific bit associated with the directive.
    // JS bit operations are 32 bits, so this will be a number between 2^0 and 2^31, corresponding
    // to bit positions 0 - 31 in a 32 bit integer.
    var mask = 1 << bloomBit;
    // Use the raw bloomBit number to determine which bloom filter bucket we should check
    // e.g: bf0 = [0 - 31], bf1 = [32 - 63], bf2 = [64 - 95], bf3 = [96 - 127], etc
    if (bloomBit < 128) {
        // Then use the mask to flip on the bit (0-31) associated with the directive in that bucket
        bloomBit < 64 ? (bloomBit < 32 ? (injector.bf0 |= mask) : (injector.bf1 |= mask)) :
            (bloomBit < 96 ? (injector.bf2 |= mask) : (injector.bf3 |= mask));
    }
    else {
        bloomBit < 192 ? (bloomBit < 160 ? (injector.bf4 |= mask) : (injector.bf5 |= mask)) :
            (bloomBit < 224 ? (injector.bf6 |= mask) : (injector.bf7 |= mask));
    }
}
function getOrCreateNodeInjector() {
    ngDevMode && assertPreviousIsParent();
    return getOrCreateNodeInjectorForNode(getPreviousOrParentNode());
}
/**
 * Creates (or gets an existing) injector for a given element or container.
 *
 * @param node for which an injector should be retrieved / created.
 * @returns Node injector
 */
function getOrCreateNodeInjectorForNode(node) {
    var nodeInjector = node.nodeInjector;
    var parent = getParentLNode(node);
    var parentInjector = parent && parent.nodeInjector;
    if (nodeInjector != parentInjector) {
        return nodeInjector;
    }
    return node.nodeInjector = {
        parent: parentInjector,
        node: node,
        bf0: 0,
        bf1: 0,
        bf2: 0,
        bf3: 0,
        bf4: 0,
        bf5: 0,
        bf6: 0,
        bf7: 0,
        cbf0: parentInjector == null ? 0 : parentInjector.cbf0 | parentInjector.bf0,
        cbf1: parentInjector == null ? 0 : parentInjector.cbf1 | parentInjector.bf1,
        cbf2: parentInjector == null ? 0 : parentInjector.cbf2 | parentInjector.bf2,
        cbf3: parentInjector == null ? 0 : parentInjector.cbf3 | parentInjector.bf3,
        cbf4: parentInjector == null ? 0 : parentInjector.cbf4 | parentInjector.bf4,
        cbf5: parentInjector == null ? 0 : parentInjector.cbf5 | parentInjector.bf5,
        cbf6: parentInjector == null ? 0 : parentInjector.cbf6 | parentInjector.bf6,
        cbf7: parentInjector == null ? 0 : parentInjector.cbf7 | parentInjector.bf7,
        templateRef: null,
        viewContainerRef: null,
        elementRef: null,
        changeDetectorRef: null,
    };
}
/**
 * Makes a directive public to the DI system by adding it to an injector's bloom filter.
 *
 * @param di The node injector in which a directive will be added
 * @param def The definition of the directive to be made public
 */
function diPublicInInjector(di, def) {
    bloomAdd(di, def.type);
}
/**
 * Makes a directive public to the DI system by adding it to an injector's bloom filter.
 *
 * @param def The definition of the directive to be made public
 */
function diPublic(def) {
    diPublicInInjector(getOrCreateNodeInjector(), def);
}
function directiveInject(token, flags) {
    if (flags === void 0) {
        flags = 0 /* Default */;
    }
    return getOrCreateInjectable(getOrCreateNodeInjector(), token, flags);
}
/**
 * Creates an ElementRef and stores it on the injector.
 * Or, if the ElementRef already exists, retrieves the existing ElementRef.
 *
 * @returns The ElementRef instance to use
 */
function injectElementRef() {
    return getOrCreateElementRef(getOrCreateNodeInjector());
}
/**
 * Creates a TemplateRef and stores it on the injector. Or, if the TemplateRef already
 * exists, retrieves the existing TemplateRef.
 *
 * @returns The TemplateRef instance to use
 */
function injectTemplateRef() {
    return getOrCreateTemplateRef(getOrCreateNodeInjector());
}
/**
 * Creates a ViewContainerRef and stores it on the injector. Or, if the ViewContainerRef
 * already exists, retrieves the existing ViewContainerRef.
 *
 * @returns The ViewContainerRef instance to use
 */
function injectViewContainerRef() {
    return getOrCreateContainerRef(getOrCreateNodeInjector());
}
/** Returns a ChangeDetectorRef (a.k.a. a ViewRef) */
function injectChangeDetectorRef() {
    return getOrCreateChangeDetectorRef(getOrCreateNodeInjector(), null);
}
var componentFactoryResolver = /*@__PURE__*/ new ComponentFactoryResolver$1();
/**
 * Inject static attribute value into directive constructor.
 *
 * This method is used with `factory` functions which are generated as part of
 * `defineDirective` or `defineComponent`. The method retrieves the static value
 * of an attribute. (Dynamic attributes are not supported since they are not resolved
 *  at the time of injection and can change over time.)
 *
 * # Example
 * Given:
 * ```
 * @Component(...)
 * class MyComponent {
 *   constructor(@Attribute('title') title: string) { ... }
 * }
 * ```
 * When instantiated with
 * ```
 * <my-component title="Hello"></my-component>
 * ```
 *
 * Then factory method generated is:
 * ```
 * MyComponent.ngComponentDef = defineComponent({
 *   factory: () => new MyComponent(injectAttribute('title'))
 *   ...
 * })
 * ```
 *
 * @experimental
 */
function injectAttribute(attrNameToInject) {
    ngDevMode && assertPreviousIsParent();
    var lElement = getPreviousOrParentNode();
    ngDevMode && assertNodeType(lElement, 3 /* Element */);
    var tElement = lElement.tNode;
    ngDevMode && assertDefined(tElement, 'expecting tNode');
    var attrs = tElement.attrs;
    if (attrs) {
        for (var i = 0; i < attrs.length; i = i + 2) {
            var attrName = attrs[i];
            if (attrName === 1 /* SelectOnly */)
                break;
            if (attrName == attrNameToInject) {
                return attrs[i + 1];
            }
        }
    }
    return undefined;
}
/**
 * Creates a ViewRef and stores it on the injector as ChangeDetectorRef (public alias).
 * Or, if it already exists, retrieves the existing instance.
 *
 * @returns The ChangeDetectorRef to use
 */
function getOrCreateChangeDetectorRef(di, context) {
    if (di.changeDetectorRef)
        return di.changeDetectorRef;
    var currentNode = di.node;
    if (isComponent(currentNode.tNode)) {
        return di.changeDetectorRef = new ViewRef$1(currentNode.data, context);
    }
    else if (currentNode.tNode.type === 3 /* Element */) {
        return di.changeDetectorRef = getOrCreateHostChangeDetector(currentNode.view[HOST_NODE]);
    }
    return null;
}
/** Gets or creates ChangeDetectorRef for the closest host component */
function getOrCreateHostChangeDetector(currentNode) {
    var hostNode = getClosestComponentAncestor(currentNode);
    var hostInjector = hostNode.nodeInjector;
    var existingRef = hostInjector && hostInjector.changeDetectorRef;
    return existingRef ?
        existingRef :
        new ViewRef$1(hostNode.data, hostNode
            .view[DIRECTIVES][hostNode.tNode.flags >> 14 /* DirectiveStartingIndexShift */]);
}
/**
 * If the node is an embedded view, traverses up the view tree to return the closest
 * ancestor view that is attached to a component. If it's already a component node,
 * returns itself.
 */
function getClosestComponentAncestor(node) {
    while (node.tNode.type === 2 /* View */) {
        node = node.view[HOST_NODE];
    }
    return node;
}
/**
 * Searches for an instance of the given directive type up the injector tree and returns
 * that instance if found.
 *
 * Specifically, it gets the bloom filter bit associated with the directive (see bloomHashBit),
 * checks that bit against the bloom filter structure to identify an injector that might have
 * the directive (see bloomFindPossibleInjector), then searches the directives on that injector
 * for a match.
 *
 * If not found, it will propagate up to the next parent injector until the token
 * is found or the top is reached.
 *
 * @param di Node injector where the search should start
 * @param token The directive type to search for
 * @param flags Injection flags (e.g. CheckParent)
 * @returns The instance found
 */
function getOrCreateInjectable(di, token, flags) {
    if (flags === void 0) {
        flags = 0 /* Default */;
    }
    var bloomHash = bloomHashBit(token);
    // If the token has a bloom hash, then it is a directive that is public to the injection system
    // (diPublic). If there is no hash, fall back to the module injector.
    if (bloomHash === null) {
        var moduleInjector = getPreviousOrParentNode().view[INJECTOR$1];
        var formerInjector = setCurrentInjector(moduleInjector);
        try {
            return inject(token, flags);
        }
        finally {
            setCurrentInjector(formerInjector);
        }
    }
    else {
        var injector = di;
        while (injector) {
            // Get the closest potential matching injector (upwards in the injector tree) that
            // *potentially* has the token.
            injector = bloomFindPossibleInjector(injector, bloomHash, flags);
            // If no injector is found, we *know* that there is no ancestor injector that contains the
            // token, so we abort.
            if (!injector) {
                break;
            }
            // At this point, we have an injector which *may* contain the token, so we step through the
            // directives associated with the injector's corresponding node to get the directive instance.
            var node = injector.node;
            var nodeFlags = node.tNode.flags;
            var count = nodeFlags & 4095 /* DirectiveCountMask */;
            if (count !== 0) {
                var start = nodeFlags >> 14 /* DirectiveStartingIndexShift */;
                var end = start + count;
                var defs = node.view[TVIEW].directives;
                for (var i = start; i < end; i++) {
                    // Get the definition for the directive at this index and, if it is injectable (diPublic),
                    // and matches the given token, return the directive instance.
                    var directiveDef = defs[i];
                    if (directiveDef.type === token && directiveDef.diPublic) {
                        return node.view[DIRECTIVES][i];
                    }
                }
            }
            // If we *didn't* find the directive for the token and we are searching the current node's
            // injector, it's possible the directive is on this node and hasn't been created yet.
            var instance = void 0;
            if (injector === di && (instance = searchMatchesQueuedForCreation(node, token))) {
                return instance;
            }
            // The def wasn't found anywhere on this node, so it was a false positive.
            // If flags permit, traverse up the tree and continue searching.
            if (flags & 2 /* Self */ || flags & 1 /* Host */ && !sameHostView(injector)) {
                injector = null;
            }
            else {
                injector = injector.parent;
            }
        }
    }
    // No directive was found for the given token.
    if (flags & 8 /* Optional */)
        return null;
    throw new Error("Injector: NOT_FOUND [" + stringify$1(token) + "]");
}
function searchMatchesQueuedForCreation(node, token) {
    var matches = node.view[TVIEW].currentMatches;
    if (matches) {
        for (var i = 0; i < matches.length; i += 2) {
            var def = matches[i];
            if (def.type === token) {
                return resolveDirective(def, i + 1, matches, node.view[TVIEW]);
            }
        }
    }
    return null;
}
/**
 * Given a directive type, this function returns the bit in an injector's bloom filter
 * that should be used to determine whether or not the directive is present.
 *
 * When the directive was added to the bloom filter, it was given a unique ID that can be
 * retrieved on the class. Since there are only BLOOM_SIZE slots per bloom filter, the directive's
 * ID must be modulo-ed by BLOOM_SIZE to get the correct bloom bit (directives share slots after
 * BLOOM_SIZE is reached).
 *
 * @param type The directive type
 * @returns The bloom bit to check for the directive
 */
function bloomHashBit(type) {
    var id = type[NG_ELEMENT_ID];
    return typeof id === 'number' ? id % BLOOM_SIZE : null;
}
/**
 * Finds the closest injector that might have a certain directive.
 *
 * Each directive corresponds to a bit in an injector's bloom filter. Given the bloom bit to
 * check and a starting injector, this function traverses up injectors until it finds an
 * injector that contains a 1 for that bit in its bloom filter. A 1 indicates that the
 * injector may have that directive. It only *may* have the directive because directives begin
 * to share bloom filter bits after the BLOOM_SIZE is reached, and it could correspond to a
 * different directive sharing the bit.
 *
 * Note: We can skip checking further injectors up the tree if an injector's cbf structure
 * has a 0 for that bloom bit. Since cbf contains the merged value of all the parent
 * injectors, a 0 in the bloom bit indicates that the parents definitely do not contain
 * the directive and do not need to be checked.
 *
 * @param injector The starting node injector to check
 * @param  bloomBit The bit to check in each injector's bloom filter
 * @param  flags The injection flags for this injection site (e.g. Optional or SkipSelf)
 * @returns An injector that might have the directive
 */
function bloomFindPossibleInjector(startInjector, bloomBit, flags) {
    // Create a mask that targets the specific bit associated with the directive we're looking for.
    // JS bit operations are 32 bits, so this will be a number between 2^0 and 2^31, corresponding
    // to bit positions 0 - 31 in a 32 bit integer.
    var mask = 1 << bloomBit;
    // Traverse up the injector tree until we find a potential match or until we know there *isn't* a
    // match.
    var injector = flags & 4 /* SkipSelf */ ? startInjector.parent : startInjector;
    while (injector) {
        // Our bloom filter size is 256 bits, which is eight 32-bit bloom filter buckets:
        // bf0 = [0 - 31], bf1 = [32 - 63], bf2 = [64 - 95], bf3 = [96 - 127], etc.
        // Get the bloom filter value from the appropriate bucket based on the directive's bloomBit.
        var value = void 0;
        if (bloomBit < 128) {
            value = bloomBit < 64 ? (bloomBit < 32 ? injector.bf0 : injector.bf1) :
                (bloomBit < 96 ? injector.bf2 : injector.bf3);
        }
        else {
            value = bloomBit < 192 ? (bloomBit < 160 ? injector.bf4 : injector.bf5) :
                (bloomBit < 224 ? injector.bf6 : injector.bf7);
        }
        // If the bloom filter value has the bit corresponding to the directive's bloomBit flipped on,
        // this injector is a potential match.
        if ((value & mask) === mask) {
            return injector;
        }
        else if (flags & 2 /* Self */ || flags & 1 /* Host */ && !sameHostView(injector)) {
            return null;
        }
        // If the current injector does not have the directive, check the bloom filters for the ancestor
        // injectors (cbf0 - cbf7). These filters capture *all* ancestor injectors.
        if (bloomBit < 128) {
            value = bloomBit < 64 ? (bloomBit < 32 ? injector.cbf0 : injector.cbf1) :
                (bloomBit < 96 ? injector.cbf2 : injector.cbf3);
        }
        else {
            value = bloomBit < 192 ? (bloomBit < 160 ? injector.cbf4 : injector.cbf5) :
                (bloomBit < 224 ? injector.cbf6 : injector.cbf7);
        }
        // If the ancestor bloom filter value has the bit corresponding to the directive, traverse up to
        // find the specific injector. If the ancestor bloom filter does not have the bit, we can abort.
        injector = (value & mask) ? injector.parent : null;
    }
    return null;
}
/**
 * Checks whether the current injector and its parent are in the same host view.
 *
 * This is necessary to support @Host() decorators. If @Host() is set, we should stop searching once
 * the injector and its parent view don't match because it means we'd cross the view boundary.
 */
function sameHostView(injector) {
    return !!injector.parent && injector.parent.node.view === injector.node.view;
}
var ReadFromInjectorFn = /*@__PURE__*/ (function () {
    function ReadFromInjectorFn(read) {
        this.read = read;
    }
    return ReadFromInjectorFn;
}());
/**
 * Creates an ElementRef for a given node injector and stores it on the injector.
 * Or, if the ElementRef already exists, retrieves the existing ElementRef.
 *
 * @param di The node injector where we should store a created ElementRef
 * @returns The ElementRef instance to use
 */
function getOrCreateElementRef(di) {
    return di.elementRef || (di.elementRef = new ElementRef$1(di.node.native));
}
/** A ref to a node's native element. */
var ElementRef$1 = /*@__PURE__*/ (function () {
    function ElementRef(nativeElement) {
        this.nativeElement = nativeElement;
    }
    return ElementRef;
}());
/**
 * Creates a ViewContainerRef and stores it on the injector. Or, if the ViewContainerRef
 * already exists, retrieves the existing ViewContainerRef.
 *
 * @returns The ViewContainerRef instance to use
 */
function getOrCreateContainerRef(di) {
    if (!di.viewContainerRef) {
        var vcRefHost = di.node;
        ngDevMode && assertNodeOfPossibleTypes(vcRefHost, 0 /* Container */, 3 /* Element */);
        var hostParent = getParentLNode(vcRefHost);
        var lContainer = createLContainer(hostParent, vcRefHost.view, true);
        var comment = vcRefHost.view[RENDERER].createComment(ngDevMode ? 'container' : '');
        var lContainerNode = createLNodeObject(0 /* Container */, vcRefHost.view, hostParent, comment, lContainer, null);
        appendChild(hostParent, comment, vcRefHost.view);
        if (vcRefHost.queries) {
            lContainerNode.queries = vcRefHost.queries.container();
        }
        var hostTNode = vcRefHost.tNode;
        if (!hostTNode.dynamicContainerNode) {
            hostTNode.dynamicContainerNode =
                createTNode(0 /* Container */, -1, null, null, hostTNode, null);
        }
        lContainerNode.tNode = hostTNode.dynamicContainerNode;
        vcRefHost.dynamicLContainerNode = lContainerNode;
        addToViewTree(vcRefHost.view, hostTNode.index, lContainer);
        di.viewContainerRef = new ViewContainerRef$1(lContainerNode);
    }
    return di.viewContainerRef;
}
/**
 * A ref to a container that enables adding and removing views from that container
 * imperatively.
 */
var ViewContainerRef$1 = /*@__PURE__*/ (function () {
    function ViewContainerRef(_lContainerNode) {
        this._lContainerNode = _lContainerNode;
        this._viewRefs = [];
    }
    ViewContainerRef.prototype.clear = function () {
        var lContainer = this._lContainerNode.data;
        while (lContainer[VIEWS].length) {
            this.remove(0);
        }
    };
    ViewContainerRef.prototype.get = function (index) { return this._viewRefs[index] || null; };
    Object.defineProperty(ViewContainerRef.prototype, "length", {
        get: function () {
            var lContainer = this._lContainerNode.data;
            return lContainer[VIEWS].length;
        },
        enumerable: true,
        configurable: true
    });
    ViewContainerRef.prototype.createEmbeddedView = function (templateRef, context, index) {
        var adjustedIdx = this._adjustIndex(index);
        var viewRef = templateRef
            .createEmbeddedView(context || {}, this._lContainerNode, adjustedIdx);
        viewRef.attachToViewContainerRef(this);
        this._viewRefs.splice(adjustedIdx, 0, viewRef);
        return viewRef;
    };
    ViewContainerRef.prototype.createComponent = function (componentFactory, index, injector, projectableNodes, ngModuleRef) {
        var contextInjector = injector || this.parentInjector;
        if (!ngModuleRef && contextInjector) {
            ngModuleRef = contextInjector.get(NgModuleRef);
        }
        var componentRef = componentFactory.create(contextInjector, projectableNodes, undefined, ngModuleRef);
        this.insert(componentRef.hostView, index);
        return componentRef;
    };
    ViewContainerRef.prototype.insert = function (viewRef, index) {
        if (viewRef.destroyed) {
            throw new Error('Cannot insert a destroyed View in a ViewContainer!');
        }
        var lViewNode = viewRef._lViewNode;
        var adjustedIdx = this._adjustIndex(index);
        insertView(this._lContainerNode, lViewNode, adjustedIdx);
        var views = this._lContainerNode.data[VIEWS];
        var beforeNode = adjustedIdx + 1 < views.length ?
            (getChildLNode(views[adjustedIdx + 1])).native :
            this._lContainerNode.native;
        addRemoveViewFromContainer(this._lContainerNode, lViewNode, true, beforeNode);
        viewRef.attachToViewContainerRef(this);
        this._viewRefs.splice(adjustedIdx, 0, viewRef);
        return viewRef;
    };
    ViewContainerRef.prototype.move = function (viewRef, newIndex) {
        var index = this.indexOf(viewRef);
        this.detach(index);
        this.insert(viewRef, this._adjustIndex(newIndex));
        return viewRef;
    };
    ViewContainerRef.prototype.indexOf = function (viewRef) { return this._viewRefs.indexOf(viewRef); };
    ViewContainerRef.prototype.remove = function (index) {
        var adjustedIdx = this._adjustIndex(index, -1);
        removeView(this._lContainerNode, adjustedIdx);
        this._viewRefs.splice(adjustedIdx, 1);
    };
    ViewContainerRef.prototype.detach = function (index) {
        var adjustedIdx = this._adjustIndex(index, -1);
        var lViewNode = detachView(this._lContainerNode, adjustedIdx);
        return this._viewRefs.splice(adjustedIdx, 1)[0] || null;
    };
    ViewContainerRef.prototype._adjustIndex = function (index, shift) {
        if (shift === void 0) {
            shift = 0;
        }
        if (index == null) {
            return this._lContainerNode.data[VIEWS].length + shift;
        }
        if (ngDevMode) {
            assertGreaterThan(index, -1, 'index must be positive');
            // +1 because it's legal to insert at the end.
            assertLessThan(index, this._lContainerNode.data[VIEWS].length + 1 + shift, 'index');
        }
        return index;
    };
    return ViewContainerRef;
}());
/**
 * Creates a TemplateRef and stores it on the injector. Or, if the TemplateRef already
 * exists, retrieves the existing TemplateRef.
 *
 * @param di The node injector where we should store a created TemplateRef
 * @returns The TemplateRef instance to use
 */
function getOrCreateTemplateRef(di) {
    if (!di.templateRef) {
        ngDevMode && assertNodeType(di.node, 0 /* Container */);
        var hostNode = di.node;
        var hostTNode = hostNode.tNode;
        ngDevMode && assertDefined(hostTNode.tViews, 'TView must be allocated');
        di.templateRef = new TemplateRef$1(getOrCreateElementRef(di), hostTNode.tViews, getRenderer(), hostNode.data[QUERIES]);
    }
    return di.templateRef;
}
var TemplateRef$1 = /*@__PURE__*/ (function () {
    function TemplateRef(elementRef, _tView, _renderer, _queries) {
        this._tView = _tView;
        this._renderer = _renderer;
        this._queries = _queries;
        this.elementRef = elementRef;
    }
    TemplateRef.prototype.createEmbeddedView = function (context, containerNode, index) {
        var viewNode = createEmbeddedViewNode(this._tView, context, this._renderer, this._queries);
        if (containerNode) {
            insertView(containerNode, viewNode, index);
        }
        renderEmbeddedTemplate(viewNode, this._tView, context, 1 /* Create */);
        var viewRef = new ViewRef$1(viewNode.data, context);
        viewRef._lViewNode = viewNode;
        return viewRef;
    };
    return TemplateRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This feature publishes the directive (or component) into the DI system, making it visible to
 * others for injection.
 *
 * @param definition
 */
function PublicFeature(definition) {
    definition.diPublic = diPublic;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var i18nTagRegex = /{\$([^}]+)}/g;
/**
 * Takes a translation string, the initial list of placeholders (elements and expressions) and the
 * indexes of their corresponding expression nodes to return a list of instructions for each
 * template function.
 *
 * Because embedded templates have different indexes for each placeholder, each parameter (except
 * the translation) is an array, where each value corresponds to a different template, by order of
 * appearance.
 *
 * @param translation A translation string where placeholders are represented by `{$name}`
 * @param elements An array containing, for each template, the maps of element placeholders and
 * their indexes.
 * @param expressions An array containing, for each template, the maps of expression placeholders
 * and their indexes.
 * @param templateRoots An array of template roots whose content should be ignored when
 * generating the instructions for their parent template.
 * @param lastChildIndex The index of the last child of the i18n node. Used when the i18n block is
 * an ng-container.
 *
 * @returns A list of instructions used to translate each template.
 */
function i18nMapping(translation, elements, expressions, templateRoots, lastChildIndex) {
    var translationParts = translation.split(i18nTagRegex);
    var nbTemplates = templateRoots ? templateRoots.length + 1 : 1;
    var instructions = (new Array(nbTemplates)).fill(undefined);
    generateMappingInstructions(0, 0, translationParts, instructions, elements, expressions, templateRoots, lastChildIndex);
    return instructions;
}
/**
 * Internal function that reads the translation parts and generates a set of instructions for each
 * template.
 *
 * See `i18nMapping()` for more details.
 *
 * @param tmplIndex The order of appearance of the template.
 * 0 for the root template, following indexes match the order in `templateRoots`.
 * @param partIndex The current index in `translationParts`.
 * @param translationParts The translation string split into an array of placeholders and text
 * elements.
 * @param instructions The current list of instructions to update.
 * @param elements An array containing, for each template, the maps of element placeholders and
 * their indexes.
 * @param expressions An array containing, for each template, the maps of expression placeholders
 * and their indexes.
 * @param templateRoots An array of template roots whose content should be ignored when
 * generating the instructions for their parent template.
 * @param lastChildIndex The index of the last child of the i18n node. Used when the i18n block is
 * an ng-container.
 *
 * @returns the current index in `translationParts`
 */
function generateMappingInstructions(tmplIndex, partIndex, translationParts, instructions, elements, expressions, templateRoots, lastChildIndex) {
    var tmplInstructions = [];
    var phVisited = [];
    var openedTagCount = 0;
    var maxIndex = 0;
    var currentElements = elements && elements[tmplIndex] ? elements[tmplIndex] : null;
    var currentExpressions = expressions && expressions[tmplIndex] ? expressions[tmplIndex] : null;
    instructions[tmplIndex] = tmplInstructions;
    for (; partIndex < translationParts.length; partIndex++) {
        // The value can either be text or the name of a placeholder (element/template root/expression)
        var value = translationParts[partIndex];
        // Odd indexes are placeholders
        if (partIndex & 1) {
            var phIndex = void 0;
            if (currentElements && currentElements[value] !== undefined) {
                phIndex = currentElements[value];
                // The placeholder represents a DOM element, add an instruction to move it
                var templateRootIndex = templateRoots ? templateRoots.indexOf(value) : -1;
                if (templateRootIndex !== -1 && (templateRootIndex + 1) !== tmplIndex) {
                    // This is a template root, it has no closing tag, not treating it as an element
                    tmplInstructions.push(phIndex | -2147483648 /* TemplateRoot */);
                }
                else {
                    tmplInstructions.push(phIndex | 1073741824 /* Element */);
                    openedTagCount++;
                }
                phVisited.push(value);
            }
            else if (currentExpressions && currentExpressions[value] !== undefined) {
                phIndex = currentExpressions[value];
                // The placeholder represents an expression, add an instruction to move it
                tmplInstructions.push(phIndex | 1610612736 /* Expression */);
                phVisited.push(value);
            }
            else {
                // It is a closing tag
                tmplInstructions.push(-1073741824 /* CloseNode */);
                if (tmplIndex > 0) {
                    openedTagCount--;
                    // If we have reached the closing tag for this template, exit the loop
                    if (openedTagCount === 0) {
                        break;
                    }
                }
            }
            if (phIndex !== undefined && phIndex > maxIndex) {
                maxIndex = phIndex;
            }
            if (templateRoots) {
                var newTmplIndex = templateRoots.indexOf(value) + 1;
                if (newTmplIndex !== 0 && newTmplIndex !== tmplIndex) {
                    partIndex = generateMappingInstructions(newTmplIndex, partIndex, translationParts, instructions, elements, expressions, templateRoots, lastChildIndex);
                }
            }
        }
        else if (value) {
            // It's a non-empty string, create a text node
            tmplInstructions.push(536870912 /* Text */, value);
        }
    }
    // Add instructions to remove elements that are not used in the translation
    if (elements) {
        var tmplElements = elements[tmplIndex];
        if (tmplElements) {
            var phKeys = Object.keys(tmplElements);
            for (var i = 0; i < phKeys.length; i++) {
                var ph = phKeys[i];
                if (phVisited.indexOf(ph) === -1) {
                    var index = tmplElements[ph];
                    // Add an instruction to remove the element
                    tmplInstructions.push(index | -536870912 /* RemoveNode */);
                    if (index > maxIndex) {
                        maxIndex = index;
                    }
                }
            }
        }
    }
    // Add instructions to remove expressions that are not used in the translation
    if (expressions) {
        var tmplExpressions = expressions[tmplIndex];
        if (tmplExpressions) {
            var phKeys = Object.keys(tmplExpressions);
            for (var i = 0; i < phKeys.length; i++) {
                var ph = phKeys[i];
                if (phVisited.indexOf(ph) === -1) {
                    var index = tmplExpressions[ph];
                    if (ngDevMode) {
                        assertLessThan(index.toString(2).length, 28, "Index " + index + " is too big and will overflow");
                    }
                    // Add an instruction to remove the expression
                    tmplInstructions.push(index | -536870912 /* RemoveNode */);
                    if (index > maxIndex) {
                        maxIndex = index;
                    }
                }
            }
        }
    }
    if (tmplIndex === 0 && typeof lastChildIndex === 'number') {
        // The current parent is an ng-container and it has more children after the translation that we
        // need to append to keep the order of the DOM nodes correct
        for (var i = maxIndex + 1; i <= lastChildIndex; i++) {
            if (ngDevMode) {
                assertLessThan(i.toString(2).length, 28, "Index " + i + " is too big and will overflow");
            }
            tmplInstructions.push(i | -1610612736 /* Any */);
        }
    }
    return partIndex;
}
function appendI18nNode(node, parentNode, previousNode) {
    if (ngDevMode) {
        ngDevMode.rendererMoveNode++;
    }
    var viewData = getViewData();
    appendChild(parentNode, node.native || null, viewData);
    // On first pass, re-organize node tree to put this node in the correct position.
    var firstTemplatePass = node.view[TVIEW].firstTemplatePass;
    if (firstTemplatePass) {
        if (previousNode === parentNode && node.tNode !== parentNode.tNode.child) {
            node.tNode.next = parentNode.tNode.child;
            parentNode.tNode.child = node.tNode;
        }
        else if (previousNode !== parentNode && node.tNode !== previousNode.tNode.next) {
            node.tNode.next = previousNode.tNode.next;
            previousNode.tNode.next = node.tNode;
        }
        else {
            node.tNode.next = null;
        }
        if (parentNode.view === node.view)
            node.tNode.parent = parentNode.tNode;
    }
    // Template containers also have a comment node for the `ViewContainerRef` that should be moved
    if (node.tNode.type === 0 /* Container */ && node.dynamicLContainerNode) {
        appendChild(parentNode, node.dynamicLContainerNode.native || null, viewData);
        if (firstTemplatePass) {
            node.tNode.dynamicContainerNode = node.dynamicLContainerNode.tNode;
            node.dynamicLContainerNode.tNode.parent = node.tNode;
        }
        return node.dynamicLContainerNode;
    }
    return node;
}
/**
 * Takes a list of instructions generated by `i18nMapping()` to transform the template accordingly.
 *
 * @param startIndex Index of the first element to translate (for instance the first child of the
 * element with the i18n attribute).
 * @param instructions The list of instructions to apply on the current view.
 */
function i18nApply(startIndex, instructions) {
    var viewData = getViewData();
    if (ngDevMode) {
        assertEqual(viewData[BINDING_INDEX], -1, 'i18nApply should be called before any binding');
    }
    if (!instructions) {
        return;
    }
    var renderer = getRenderer();
    var localParentNode = getParentLNode(load(startIndex)) || getPreviousOrParentNode();
    var localPreviousNode = localParentNode;
    resetApplicationState(); // We don't want to add to the tree with the wrong previous node
    for (var i = 0; i < instructions.length; i++) {
        var instruction = instructions[i];
        switch (instruction & -536870912 /* InstructionMask */) {
            case 1073741824 /* Element */:
                var element$$1 = load(instruction & 536870911 /* IndexMask */);
                localPreviousNode = appendI18nNode(element$$1, localParentNode, localPreviousNode);
                localParentNode = element$$1;
                break;
            case 1610612736 /* Expression */:
            case -2147483648 /* TemplateRoot */:
            case -1610612736 /* Any */:
                var node = load(instruction & 536870911 /* IndexMask */);
                localPreviousNode = appendI18nNode(node, localParentNode, localPreviousNode);
                break;
            case 536870912 /* Text */:
                if (ngDevMode) {
                    ngDevMode.rendererCreateTextNode++;
                }
                var value = instructions[++i];
                var textRNode = createTextNode(value, renderer);
                // If we were to only create a `RNode` then projections won't move the text.
                // Create text node at the current end of viewData. Must subtract header offset because
                // createLNode takes a raw index (not adjusted by header offset).
                var textLNode = createLNode(viewData.length - HEADER_OFFSET, 3 /* Element */, textRNode, null, null);
                localPreviousNode = appendI18nNode(textLNode, localParentNode, localPreviousNode);
                resetApplicationState();
                break;
            case -1073741824 /* CloseNode */:
                localPreviousNode = localParentNode;
                localParentNode = getParentLNode(localParentNode);
                break;
            case -536870912 /* RemoveNode */:
                if (ngDevMode) {
                    ngDevMode.rendererRemoveNode++;
                }
                var index = instruction & 536870911 /* IndexMask */;
                var removedNode = load(index);
                var parentNode = getParentLNode(removedNode);
                removeChild(parentNode, removedNode.native || null, viewData);
                // For template containers we also need to remove their `ViewContainerRef` from the DOM
                if (removedNode.tNode.type === 0 /* Container */ && removedNode.dynamicLContainerNode) {
                    removeChild(parentNode, removedNode.dynamicLContainerNode.native || null, viewData);
                    removedNode.dynamicLContainerNode.tNode.detached = true;
                    removedNode.dynamicLContainerNode.data[RENDER_PARENT] = null;
                }
                break;
        }
    }
}
/**
 * Takes a translation string and the initial list of expressions and returns a list of instructions
 * that will be used to translate an attribute.
 * Even indexes contain static strings, while odd indexes contain the index of the expression whose
 * value will be concatenated into the final translation.
 */
function i18nExpMapping(translation, placeholders) {
    var staticText = translation.split(i18nTagRegex);
    // odd indexes are placeholders
    for (var i = 1; i < staticText.length; i += 2) {
        staticText[i] = placeholders[staticText[i]];
    }
    return staticText;
}
/**
 * Checks if the value of an expression has changed and replaces it by its value in a translation,
 * or returns NO_CHANGE.
 *
 * @param instructions A list of instructions that will be used to translate an attribute.
 * @param v0 value checked for change.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function i18nInterpolation1(instructions, v0) {
    var different = bindingUpdated(v0);
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are bindings
        if (i & 1) {
            res += stringify$1(v0);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * Checks if the values of up to 2 expressions have changed and replaces them by their values in a
 * translation, or returns NO_CHANGE.
 *
 * @param instructions A list of instructions that will be used to translate an attribute.
 * @param v0 value checked for change.
 * @param v1 value checked for change.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function i18nInterpolation2(instructions, v0, v1) {
    var different = bindingUpdated2(v0, v1);
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are bindings
        if (i & 1) {
            // Extract bits
            var idx = instructions[i];
            var b1 = idx & 1;
            // Get the value from the argument vx where x = idx
            var value = b1 ? v1 : v0;
            res += stringify$1(value);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * Checks if the values of up to 3 expressions have changed and replaces them by their values in a
 * translation, or returns NO_CHANGE.
 *
 * @param instructions A list of instructions that will be used to translate an attribute.
 * @param v0 value checked for change.
 * @param v1 value checked for change.
 * @param v2 value checked for change.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function i18nInterpolation3(instructions, v0, v1, v2) {
    var different = bindingUpdated2(v0, v1);
    different = bindingUpdated(v2) || different;
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are bindings
        if (i & 1) {
            // Extract bits
            var idx = instructions[i];
            var b2 = idx & 2;
            var b1 = idx & 1;
            // Get the value from the argument vx where x = idx
            var value = b2 ? v2 : (b1 ? v1 : v0);
            res += stringify$1(value);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * Checks if the values of up to 4 expressions have changed and replaces them by their values in a
 * translation, or returns NO_CHANGE.
 *
 * @param instructions A list of instructions that will be used to translate an attribute.
 * @param v0 value checked for change.
 * @param v1 value checked for change.
 * @param v2 value checked for change.
 * @param v3 value checked for change.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function i18nInterpolation4(instructions, v0, v1, v2, v3) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are bindings
        if (i & 1) {
            // Extract bits
            var idx = instructions[i];
            var b2 = idx & 2;
            var b1 = idx & 1;
            // Get the value from the argument vx where x = idx
            var value = b2 ? (b1 ? v3 : v2) : (b1 ? v1 : v0);
            res += stringify$1(value);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * Checks if the values of up to 5 expressions have changed and replaces them by their values in a
 * translation, or returns NO_CHANGE.
 *
 * @param instructions A list of instructions that will be used to translate an attribute.
 * @param v0 value checked for change.
 * @param v1 value checked for change.
 * @param v2 value checked for change.
 * @param v3 value checked for change.
 * @param v4 value checked for change.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function i18nInterpolation5(instructions, v0, v1, v2, v3, v4) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    different = bindingUpdated(v4) || different;
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are bindings
        if (i & 1) {
            // Extract bits
            var idx = instructions[i];
            var b4 = idx & 4;
            var b2 = idx & 2;
            var b1 = idx & 1;
            // Get the value from the argument vx where x = idx
            var value = b4 ? v4 : (b2 ? (b1 ? v3 : v2) : (b1 ? v1 : v0));
            res += stringify$1(value);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * Checks if the values of up to 6 expressions have changed and replaces them by their values in a
 * translation, or returns NO_CHANGE.
 *
 * @param instructions A list of instructions that will be used to translate an attribute.
 * @param v0 value checked for change.
 * @param v1 value checked for change.
 * @param v2 value checked for change.
 * @param v3 value checked for change.
 * @param v4 value checked for change.
 * @param v5 value checked for change.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */ function i18nInterpolation6(instructions, v0, v1, v2, v3, v4, v5) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    different = bindingUpdated2(v4, v5) || different;
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are bindings
        if (i & 1) {
            // Extract bits
            var idx = instructions[i];
            var b4 = idx & 4;
            var b2 = idx & 2;
            var b1 = idx & 1;
            // Get the value from the argument vx where x = idx
            var value = b4 ? (b1 ? v5 : v4) : (b2 ? (b1 ? v3 : v2) : (b1 ? v1 : v0));
            res += stringify$1(value);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * Checks if the values of up to 7 expressions have changed and replaces them by their values in a
 * translation, or returns NO_CHANGE.
 *
 * @param instructions A list of instructions that will be used to translate an attribute.
 * @param v0 value checked for change.
 * @param v1 value checked for change.
 * @param v2 value checked for change.
 * @param v3 value checked for change.
 * @param v4 value checked for change.
 * @param v5 value checked for change.
 * @param v6 value checked for change.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function i18nInterpolation7(instructions, v0, v1, v2, v3, v4, v5, v6) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    different = bindingUpdated2(v4, v5) || different;
    different = bindingUpdated(v6) || different;
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are bindings
        if (i & 1) {
            // Extract bits
            var idx = instructions[i];
            var b4 = idx & 4;
            var b2 = idx & 2;
            var b1 = idx & 1;
            // Get the value from the argument vx where x = idx
            var value = b4 ? (b2 ? v6 : (b1 ? v5 : v4)) : (b2 ? (b1 ? v3 : v2) : (b1 ? v1 : v0));
            res += stringify$1(value);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * Checks if the values of up to 8 expressions have changed and replaces them by their values in a
 * translation, or returns NO_CHANGE.
 *
 * @param instructions A list of instructions that will be used to translate an attribute.
 * @param v0 value checked for change.
 * @param v1 value checked for change.
 * @param v2 value checked for change.
 * @param v3 value checked for change.
 * @param v4 value checked for change.
 * @param v5 value checked for change.
 * @param v6 value checked for change.
 * @param v7 value checked for change.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function i18nInterpolation8(instructions, v0, v1, v2, v3, v4, v5, v6, v7) {
    var different = bindingUpdated4(v0, v1, v2, v3);
    different = bindingUpdated4(v4, v5, v6, v7) || different;
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are bindings
        if (i & 1) {
            // Extract bits
            var idx = instructions[i];
            var b4 = idx & 4;
            var b2 = idx & 2;
            var b1 = idx & 1;
            // Get the value from the argument vx where x = idx
            var value = b4 ? (b2 ? (b1 ? v7 : v6) : (b1 ? v5 : v4)) : (b2 ? (b1 ? v3 : v2) : (b1 ? v1 : v0));
            res += stringify$1(value);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * Create a translated interpolation binding with a variable number of expressions.
 *
 * If there are 1 to 8 expressions then `i18nInterpolation()` should be used instead. It is faster
 * because there is no need to create an array of expressions and iterate over it.
 *
 * @returns The concatenated string when any of the arguments changes, `NO_CHANGE` otherwise.
 */
function i18nInterpolationV(instructions, values) {
    var different = false;
    for (var i = 0; i < values.length; i++) {
        // Check if bindings have changed
        bindingUpdated(values[i]) && (different = true);
    }
    if (!different) {
        return NO_CHANGE;
    }
    var res = '';
    for (var i = 0; i < instructions.length; i++) {
        // Odd indexes are placeholders
        if (i & 1) {
            res += stringify$1(values[instructions[i]]);
        }
        else {
            res += instructions[i];
        }
    }
    return res;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var COMPONENT_FACTORY_RESOLVER = {
    provide: ComponentFactoryResolver,
    useFactory: function () { return new ComponentFactoryResolver$1(); },
    deps: [],
};
var NgModuleRef$1 = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgModuleRef$$1, _super);
    function NgModuleRef$$1(ngModuleType, parentInjector) {
        var _this = _super.call(this) || this;
        // tslint:disable-next-line:require-internal-with-underscore
        _this._bootstrapComponents = [];
        _this.destroyCbs = [];
        var ngModuleDef = ngModuleType.ngModuleDef;
        ngDevMode && assertDefined(ngModuleDef, "NgModule '" + stringify(ngModuleType) + "' is not a subtype of 'NgModuleType'.");
        _this._bootstrapComponents = ngModuleDef.bootstrap;
        var additionalProviders = [
            COMPONENT_FACTORY_RESOLVER, {
                provide: NgModuleRef,
                useValue: _this,
            }
        ];
        _this.injector = createInjector(ngModuleType, parentInjector, additionalProviders);
        _this.instance = _this.injector.get(ngModuleType);
        _this.componentFactoryResolver = new ComponentFactoryResolver$1();
        return _this;
    }
    NgModuleRef$$1.prototype.destroy = function () {
        ngDevMode && assertDefined(this.destroyCbs, 'NgModule already destroyed');
        this.destroyCbs.forEach(function (fn) { return fn(); });
        this.destroyCbs = null;
    };
    NgModuleRef$$1.prototype.onDestroy = function (callback) {
        ngDevMode && assertDefined(this.destroyCbs, 'NgModule already destroyed');
        this.destroyCbs.push(callback);
    };
    return NgModuleRef$$1;
}(NgModuleRef));
var NgModuleFactory$1 = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NgModuleFactory$$1, _super);
    function NgModuleFactory$$1(moduleType) {
        var _this = _super.call(this) || this;
        _this.moduleType = moduleType;
        return _this;
    }
    NgModuleFactory$$1.prototype.create = function (parentInjector) {
        return new NgModuleRef$1(this.moduleType, parentInjector);
    };
    return NgModuleFactory$$1;
}(NgModuleFactory));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * If the value hasn't been saved, calls the pure function to store and return the
 * value. If it has been saved, returns the saved value.
 *
 * @param pureFn Function that returns a value
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param thisArg Optional calling context of pureFn
 * @returns value
 */
function pureFunction0(slotOffset, pureFn, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 1);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var value = getCreationMode() ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg) : pureFn()) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * If the value of the provided exp has changed, calls the pure function to return
 * an updated value. Or if the value has not changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn Function that returns an updated value
 * @param exp Updated expression value
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunction1(slotOffset, pureFn, exp, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 2);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var value = bindingUpdated(exp) ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg, exp) : pureFn(exp)) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * If the value of any provided exp has changed, calls the pure function to return
 * an updated value. Or if no values have changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn
 * @param exp1
 * @param exp2
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunction2(slotOffset, pureFn, exp1, exp2, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 3);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var value = bindingUpdated2(exp1, exp2) ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg, exp1, exp2) : pureFn(exp1, exp2)) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * If the value of any provided exp has changed, calls the pure function to return
 * an updated value. Or if no values have changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn
 * @param exp1
 * @param exp2
 * @param exp3
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunction3(slotOffset, pureFn, exp1, exp2, exp3, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 4);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var different = bindingUpdated2(exp1, exp2);
    var value = bindingUpdated(exp3) || different ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg, exp1, exp2, exp3) : pureFn(exp1, exp2, exp3)) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * If the value of any provided exp has changed, calls the pure function to return
 * an updated value. Or if no values have changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn
 * @param exp1
 * @param exp2
 * @param exp3
 * @param exp4
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunction4(slotOffset, pureFn, exp1, exp2, exp3, exp4, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 5);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var value = bindingUpdated4(exp1, exp2, exp3, exp4) ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg, exp1, exp2, exp3, exp4) : pureFn(exp1, exp2, exp3, exp4)) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * If the value of any provided exp has changed, calls the pure function to return
 * an updated value. Or if no values have changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn
 * @param exp1
 * @param exp2
 * @param exp3
 * @param exp4
 * @param exp5
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunction5(slotOffset, pureFn, exp1, exp2, exp3, exp4, exp5, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 6);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var different = bindingUpdated4(exp1, exp2, exp3, exp4);
    var value = bindingUpdated(exp5) || different ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg, exp1, exp2, exp3, exp4, exp5) :
            pureFn(exp1, exp2, exp3, exp4, exp5)) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * If the value of any provided exp has changed, calls the pure function to return
 * an updated value. Or if no values have changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn
 * @param exp1
 * @param exp2
 * @param exp3
 * @param exp4
 * @param exp5
 * @param exp6
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunction6(slotOffset, pureFn, exp1, exp2, exp3, exp4, exp5, exp6, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 7);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var different = bindingUpdated4(exp1, exp2, exp3, exp4);
    var value = bindingUpdated2(exp5, exp6) || different ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg, exp1, exp2, exp3, exp4, exp5, exp6) :
            pureFn(exp1, exp2, exp3, exp4, exp5, exp6)) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * If the value of any provided exp has changed, calls the pure function to return
 * an updated value. Or if no values have changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn
 * @param exp1
 * @param exp2
 * @param exp3
 * @param exp4
 * @param exp5
 * @param exp6
 * @param exp7
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunction7(slotOffset, pureFn, exp1, exp2, exp3, exp4, exp5, exp6, exp7, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 8);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var different = bindingUpdated4(exp1, exp2, exp3, exp4);
    different = bindingUpdated2(exp5, exp6) || different;
    var value = bindingUpdated(exp7) || different ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg, exp1, exp2, exp3, exp4, exp5, exp6, exp7) :
            pureFn(exp1, exp2, exp3, exp4, exp5, exp6, exp7)) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * If the value of any provided exp has changed, calls the pure function to return
 * an updated value. Or if no values have changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn
 * @param exp1
 * @param exp2
 * @param exp3
 * @param exp4
 * @param exp5
 * @param exp6
 * @param exp7
 * @param exp8
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunction8(slotOffset, pureFn, exp1, exp2, exp3, exp4, exp5, exp6, exp7, exp8, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, 9);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var different = bindingUpdated4(exp1, exp2, exp3, exp4);
    var value = bindingUpdated4(exp5, exp6, exp7, exp8) || different ?
        checkAndUpdateBinding$1(thisArg ? pureFn.call(thisArg, exp1, exp2, exp3, exp4, exp5, exp6, exp7, exp8) :
            pureFn(exp1, exp2, exp3, exp4, exp5, exp6, exp7, exp8)) :
        consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * pureFunction instruction that can support any number of bindings.
 *
 * If the value of any provided exp has changed, calls the pure function to return
 * an updated value. Or if no values have changed, returns cached value.
 *
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param pureFn A pure function that takes binding values and builds an object or array
 * containing those values.
 * @param exps An array of binding values
 * @param thisArg Optional calling context of pureFn
 * @returns Updated or cached value
 */
function pureFunctionV(slotOffset, pureFn, exps, thisArg) {
    ngDevMode && assertReservedSlotInitialized(slotOffset, exps.length + 1);
    var index = moveBindingIndexToReservedSlot(slotOffset);
    var different = false;
    for (var i = 0; i < exps.length; i++) {
        bindingUpdated(exps[i]) && (different = true);
    }
    var value = different ? checkAndUpdateBinding$1(pureFn.apply(thisArg, exps)) : consumeBinding();
    restoreBindingIndex(index);
    return value;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Create a pipe.
 *
 * @param index Pipe index where the pipe will be stored.
 * @param pipeName The name of the pipe
 * @returns T the instance of the pipe.
 */
function pipe(index, pipeName) {
    var tView = getTView();
    var pipeDef;
    var adjustedIndex = index + HEADER_OFFSET;
    if (tView.firstTemplatePass) {
        pipeDef = getPipeDef(pipeName, tView.pipeRegistry);
        tView.data[adjustedIndex] = pipeDef;
        if (pipeDef.onDestroy) {
            (tView.pipeDestroyHooks || (tView.pipeDestroyHooks = [])).push(adjustedIndex, pipeDef.onDestroy);
        }
    }
    else {
        pipeDef = tView.data[adjustedIndex];
    }
    var pipeInstance = pipeDef.factory();
    store(index, pipeInstance);
    return pipeInstance;
}
/**
 * Searches the pipe registry for a pipe with the given name. If one is found,
 * returns the pipe. Otherwise, an error is thrown because the pipe cannot be resolved.
 *
 * @param name Name of pipe to resolve
 * @param registry Full list of available pipes
 * @returns Matching PipeDef
 */
function getPipeDef(name, registry) {
    if (registry) {
        for (var i = 0; i < registry.length; i++) {
            var pipeDef = registry[i];
            if (name === pipeDef.name) {
                return pipeDef;
            }
        }
    }
    throw new Error("Pipe with name '" + name + "' not found!");
}
/**
 * Invokes a pipe with 1 arguments.
 *
 * This instruction acts as a guard to {@link PipeTransform#transform} invoking
 * the pipe only when an input to the pipe changes.
 *
 * @param index Pipe index where the pipe was stored on creation.
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param v1 1st argument to {@link PipeTransform#transform}.
 */
function pipeBind1(index, slotOffset, v1) {
    var pipeInstance = load(index);
    return isPure(index) ? pureFunction1(slotOffset, pipeInstance.transform, v1, pipeInstance) :
        pipeInstance.transform(v1);
}
/**
 * Invokes a pipe with 2 arguments.
 *
 * This instruction acts as a guard to {@link PipeTransform#transform} invoking
 * the pipe only when an input to the pipe changes.
 *
 * @param index Pipe index where the pipe was stored on creation.
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param v1 1st argument to {@link PipeTransform#transform}.
 * @param v2 2nd argument to {@link PipeTransform#transform}.
 */
function pipeBind2(index, slotOffset, v1, v2) {
    var pipeInstance = load(index);
    return isPure(index) ? pureFunction2(slotOffset, pipeInstance.transform, v1, v2, pipeInstance) :
        pipeInstance.transform(v1, v2);
}
/**
 * Invokes a pipe with 3 arguments.
 *
 * This instruction acts as a guard to {@link PipeTransform#transform} invoking
 * the pipe only when an input to the pipe changes.
 *
 * @param index Pipe index where the pipe was stored on creation.
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param v1 1st argument to {@link PipeTransform#transform}.
 * @param v2 2nd argument to {@link PipeTransform#transform}.
 * @param v3 4rd argument to {@link PipeTransform#transform}.
 */
function pipeBind3(index, slotOffset, v1, v2, v3) {
    var pipeInstance = load(index);
    return isPure(index) ?
        pureFunction3(slotOffset, pipeInstance.transform, v1, v2, v3, pipeInstance) :
        pipeInstance.transform(v1, v2, v3);
}
/**
 * Invokes a pipe with 4 arguments.
 *
 * This instruction acts as a guard to {@link PipeTransform#transform} invoking
 * the pipe only when an input to the pipe changes.
 *
 * @param index Pipe index where the pipe was stored on creation.
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param v1 1st argument to {@link PipeTransform#transform}.
 * @param v2 2nd argument to {@link PipeTransform#transform}.
 * @param v3 3rd argument to {@link PipeTransform#transform}.
 * @param v4 4th argument to {@link PipeTransform#transform}.
 */
function pipeBind4(index, slotOffset, v1, v2, v3, v4) {
    var pipeInstance = load(index);
    return isPure(index) ?
        pureFunction4(slotOffset, pipeInstance.transform, v1, v2, v3, v4, pipeInstance) :
        pipeInstance.transform(v1, v2, v3, v4);
}
/**
 * Invokes a pipe with variable number of arguments.
 *
 * This instruction acts as a guard to {@link PipeTransform#transform} invoking
 * the pipe only when an input to the pipe changes.
 *
 * @param index Pipe index where the pipe was stored on creation.
 * @param slotOffset the offset in the reserved slot space {@link reserveSlots}
 * @param values Array of arguments to pass to {@link PipeTransform#transform} method.
 */
function pipeBindV(index, slotOffset, values) {
    var pipeInstance = load(index);
    return isPure(index) ? pureFunctionV(slotOffset, pipeInstance.transform, values, pipeInstance) :
        pipeInstance.transform.apply(pipeInstance, values);
}
function isPure(index) {
    return getTView().data[index + HEADER_OFFSET].pure;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var LQueries_ = /*@__PURE__*/ (function () {
    function LQueries_(deep) {
        this.shallow = null;
        this.deep = null;
        this.deep = deep == null ? null : deep;
    }
    LQueries_.prototype.track = function (queryList, predicate, descend, read) {
        if (descend) {
            this.deep = createQuery$1(this.deep, queryList, predicate, read != null ? read : null);
        }
        else {
            this.shallow = createQuery$1(this.shallow, queryList, predicate, read != null ? read : null);
        }
    };
    LQueries_.prototype.clone = function () { return this.deep ? new LQueries_(this.deep) : null; };
    LQueries_.prototype.child = function () {
        if (this.deep === null) {
            // if we don't have any deep queries then no need to track anything more.
            return null;
        }
        if (this.shallow === null) {
            // DeepQuery: We can reuse the current state if the child state would be same as current
            // state.
            return this;
        }
        else {
            // We need to create new state
            return new LQueries_(this.deep);
        }
    };
    LQueries_.prototype.container = function () {
        var result = null;
        var query = this.deep;
        while (query) {
            var containerValues = []; // prepare room for views
            query.values.push(containerValues);
            var clonedQuery = {
                next: null,
                list: query.list,
                predicate: query.predicate,
                values: containerValues,
                containerValues: null
            };
            clonedQuery.next = result;
            result = clonedQuery;
            query = query.next;
        }
        return result ? new LQueries_(result) : null;
    };
    LQueries_.prototype.createView = function () {
        var result = null;
        var query = this.deep;
        while (query) {
            var clonedQuery = {
                next: null,
                list: query.list,
                predicate: query.predicate,
                values: [],
                containerValues: query.values
            };
            clonedQuery.next = result;
            result = clonedQuery;
            query = query.next;
        }
        return result ? new LQueries_(result) : null;
    };
    LQueries_.prototype.insertView = function (index) {
        var query = this.deep;
        while (query) {
            ngDevMode &&
                assertDefined(query.containerValues, 'View queries need to have a pointer to container values.');
            query.containerValues.splice(index, 0, query.values);
            query = query.next;
        }
    };
    LQueries_.prototype.addNode = function (node) {
        add(this.shallow, node);
        add(this.deep, node);
    };
    LQueries_.prototype.removeView = function () {
        var query = this.deep;
        while (query) {
            ngDevMode &&
                assertDefined(query.containerValues, 'View queries need to have a pointer to container values.');
            var containerValues = query.containerValues;
            var viewValuesIdx = containerValues.indexOf(query.values);
            var removed = containerValues.splice(viewValuesIdx, 1);
            // mark a query as dirty only when removed view had matching modes
            ngDevMode && assertEqual(removed.length, 1, 'removed.length');
            if (removed[0].length) {
                query.list.setDirty();
            }
            query = query.next;
        }
    };
    return LQueries_;
}());
/**
 * Iterates over local names for a given node and returns directive index
 * (or -1 if a local name points to an element).
 *
 * @param tNode static data of a node to check
 * @param selector selector to match
 * @returns directive index, -1 or null if a selector didn't match any of the local names
 */
function getIdxOfMatchingSelector(tNode, selector) {
    var localNames = tNode.localNames;
    if (localNames) {
        for (var i = 0; i < localNames.length; i += 2) {
            if (localNames[i] === selector) {
                return localNames[i + 1];
            }
        }
    }
    return null;
}
/**
 * Iterates over all the directives for a node and returns index of a directive for a given type.
 *
 * @param node Node on which directives are present.
 * @param type Type of a directive to look for.
 * @returns Index of a found directive or null when none found.
 */
function getIdxOfMatchingDirective(node, type) {
    var defs = node.view[TVIEW].directives;
    var flags = node.tNode.flags;
    var count = flags & 4095 /* DirectiveCountMask */;
    var start = flags >> 14 /* DirectiveStartingIndexShift */;
    var end = start + count;
    for (var i = start; i < end; i++) {
        var def = defs[i];
        if (def.type === type && def.diPublic) {
            return i;
        }
    }
    return null;
}
function readFromNodeInjector(nodeInjector, node, read, directiveIdx) {
    if (read instanceof ReadFromInjectorFn) {
        return read.read(nodeInjector, node, directiveIdx);
    }
    else {
        var matchingIdx = getIdxOfMatchingDirective(node, read);
        if (matchingIdx !== null) {
            return node.view[DIRECTIVES][matchingIdx];
        }
    }
    return null;
}
function add(query, node) {
    var nodeInjector = getOrCreateNodeInjectorForNode(node);
    while (query) {
        var predicate = query.predicate;
        var type = predicate.type;
        if (type) {
            var directiveIdx = getIdxOfMatchingDirective(node, type);
            if (directiveIdx !== null) {
                // a node is matching a predicate - determine what to read
                // if read token and / or strategy is not specified, use type as read token
                var result = readFromNodeInjector(nodeInjector, node, predicate.read || type, directiveIdx);
                if (result !== null) {
                    addMatch(query, result);
                }
            }
        }
        else {
            var selector = predicate.selector;
            for (var i = 0; i < selector.length; i++) {
                var directiveIdx = getIdxOfMatchingSelector(node.tNode, selector[i]);
                if (directiveIdx !== null) {
                    // a node is matching a predicate - determine what to read
                    // note that queries using name selector must specify read strategy
                    ngDevMode && assertDefined(predicate.read, 'the node should have a predicate');
                    var result = readFromNodeInjector(nodeInjector, node, predicate.read, directiveIdx);
                    if (result !== null) {
                        addMatch(query, result);
                    }
                }
            }
        }
        query = query.next;
    }
}
function addMatch(query, matchingValue) {
    query.values.push(matchingValue);
    query.list.setDirty();
}
function createPredicate(predicate, read) {
    var isArray = Array.isArray(predicate);
    return {
        type: isArray ? null : predicate,
        selector: isArray ? predicate : null,
        read: read
    };
}
function createQuery$1(previous, queryList, predicate, read) {
    return {
        next: previous,
        list: queryList,
        predicate: createPredicate(predicate, read),
        values: queryList._valuesTree,
        containerValues: null
    };
}
var QueryList_ = /*@__PURE__*/ (function () {
    function QueryList_() {
        this.dirty = true;
        this.changes = new EventEmitter();
        this._values = [];
        /** @internal */
        this._valuesTree = [];
    }
    Object.defineProperty(QueryList_.prototype, "length", {
        get: function () { return this._values.length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryList_.prototype, "first", {
        get: function () {
            var values = this._values;
            return values.length ? values[0] : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryList_.prototype, "last", {
        get: function () {
            var values = this._values;
            return values.length ? values[values.length - 1] : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * See
     * [Array.map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)
     */
    QueryList_.prototype.map = function (fn) { return this._values.map(fn); };
    /**
     * See
     * [Array.filter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter)
     */
    QueryList_.prototype.filter = function (fn) {
        return this._values.filter(fn);
    };
    /**
     * See
     * [Array.find](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find)
     */
    QueryList_.prototype.find = function (fn) {
        return this._values.find(fn);
    };
    /**
     * See
     * [Array.reduce](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce)
     */
    QueryList_.prototype.reduce = function (fn, init) {
        return this._values.reduce(fn, init);
    };
    /**
     * See
     * [Array.forEach](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach)
     */
    QueryList_.prototype.forEach = function (fn) { this._values.forEach(fn); };
    /**
     * See
     * [Array.some](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some)
     */
    QueryList_.prototype.some = function (fn) {
        return this._values.some(fn);
    };
    QueryList_.prototype.toArray = function () { return this._values.slice(0); };
    QueryList_.prototype[getSymbolIterator()] = function () { return this._values[getSymbolIterator()](); };
    QueryList_.prototype.toString = function () { return this._values.toString(); };
    QueryList_.prototype.reset = function (res) {
        this._values = flatten$1(res);
        this.dirty = false;
    };
    QueryList_.prototype.notifyOnChanges = function () { this.changes.emit(this); };
    QueryList_.prototype.setDirty = function () { this.dirty = true; };
    QueryList_.prototype.destroy = function () {
        this.changes.complete();
        this.changes.unsubscribe();
    };
    return QueryList_;
}());
var QueryList$1 = QueryList_;
/**
 * Creates and returns a QueryList.
 *
 * @param memoryIndex The index in memory where the QueryList should be saved. If null,
 * this is is a content query and the QueryList will be saved later through directiveCreate.
 * @param predicate The type for which the query will search
 * @param descend Whether or not to descend into children
 * @param read What to save in the query
 * @returns QueryList<T>
 */
function query(memoryIndex, predicate, descend, read) {
    ngDevMode && assertPreviousIsParent();
    var queryList = new QueryList$1();
    var queries = getCurrentQueries(LQueries_);
    queries.track(queryList, predicate, descend, read);
    storeCleanupWithContext(null, queryList, queryList.destroy);
    if (memoryIndex != null) {
        store(memoryIndex, queryList);
    }
    return queryList;
}
/**
 * Refreshes a query by combining matches from all active views and removing matches from deleted
 * views.
 * Returns true if a query got dirty during change detection, false otherwise.
 */
function queryRefresh(queryList) {
    var queryListImpl = queryList;
    if (queryList.dirty) {
        queryList.reset(queryListImpl._valuesTree);
        queryList.notifyOnChanges();
        return true;
    }
    return false;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var BRAND = '__SANITIZER_TRUSTED_BRAND__';
function allowSanitizationBypass(value, type) {
    return (value instanceof String && value[BRAND] === type) ? true : false;
}
/**
 * Mark `html` string as trusted.
 *
 * This function wraps the trusted string in `String` and brands it in a way which makes it
 * recognizable to {@link htmlSanitizer} to be trusted implicitly.
 *
 * @param trustedHtml `html` string which needs to be implicitly trusted.
 * @returns a `html` `String` which has been branded to be implicitly trusted.
 */
function bypassSanitizationTrustHtml(trustedHtml) {
    return bypassSanitizationTrustString(trustedHtml, "Html" /* Html */);
}
/**
 * Mark `style` string as trusted.
 *
 * This function wraps the trusted string in `String` and brands it in a way which makes it
 * recognizable to {@link styleSanitizer} to be trusted implicitly.
 *
 * @param trustedStyle `style` string which needs to be implicitly trusted.
 * @returns a `style` `String` which has been branded to be implicitly trusted.
 */
function bypassSanitizationTrustStyle(trustedStyle) {
    return bypassSanitizationTrustString(trustedStyle, "Style" /* Style */);
}
/**
 * Mark `script` string as trusted.
 *
 * This function wraps the trusted string in `String` and brands it in a way which makes it
 * recognizable to {@link scriptSanitizer} to be trusted implicitly.
 *
 * @param trustedScript `script` string which needs to be implicitly trusted.
 * @returns a `script` `String` which has been branded to be implicitly trusted.
 */
function bypassSanitizationTrustScript(trustedScript) {
    return bypassSanitizationTrustString(trustedScript, "Script" /* Script */);
}
/**
 * Mark `url` string as trusted.
 *
 * This function wraps the trusted string in `String` and brands it in a way which makes it
 * recognizable to {@link urlSanitizer} to be trusted implicitly.
 *
 * @param trustedUrl `url` string which needs to be implicitly trusted.
 * @returns a `url` `String` which has been branded to be implicitly trusted.
 */
function bypassSanitizationTrustUrl(trustedUrl) {
    return bypassSanitizationTrustString(trustedUrl, "Url" /* Url */);
}
/**
 * Mark `url` string as trusted.
 *
 * This function wraps the trusted string in `String` and brands it in a way which makes it
 * recognizable to {@link resourceUrlSanitizer} to be trusted implicitly.
 *
 * @param trustedResourceUrl `url` string which needs to be implicitly trusted.
 * @returns a `url` `String` which has been branded to be implicitly trusted.
 */
function bypassSanitizationTrustResourceUrl(trustedResourceUrl) {
    return bypassSanitizationTrustString(trustedResourceUrl, "ResourceUrl" /* ResourceUrl */);
}
function bypassSanitizationTrustString(trustedString, mode) {
    var trusted = new String(trustedString);
    trusted[BRAND] = mode;
    return trusted;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An `html` sanitizer which converts untrusted `html` **string** into trusted string by removing
 * dangerous content.
 *
 * This method parses the `html` and locates potentially dangerous content (such as urls and
 * javascript) and removes it.
 *
 * It is possible to mark a string as trusted by calling {@link bypassSanitizationTrustHtml}.
 *
 * @param unsafeHtml untrusted `html`, typically from the user.
 * @returns `html` string which is safe to display to user, because all of the dangerous javascript
 * and urls have been removed.
 */
function sanitizeHtml(unsafeHtml) {
    var s = getCurrentSanitizer();
    if (s) {
        return s.sanitize(SecurityContext.HTML, unsafeHtml) || '';
    }
    if (allowSanitizationBypass(unsafeHtml, "Html" /* Html */)) {
        return unsafeHtml.toString();
    }
    return _sanitizeHtml(document, stringify$1(unsafeHtml));
}
/**
 * A `style` sanitizer which converts untrusted `style` **string** into trusted string by removing
 * dangerous content.
 *
 * This method parses the `style` and locates potentially dangerous content (such as urls and
 * javascript) and removes it.
 *
 * It is possible to mark a string as trusted by calling {@link bypassSanitizationTrustStyle}.
 *
 * @param unsafeStyle untrusted `style`, typically from the user.
 * @returns `style` string which is safe to bind to the `style` properties, because all of the
 * dangerous javascript and urls have been removed.
 */
function sanitizeStyle(unsafeStyle) {
    var s = getCurrentSanitizer();
    if (s) {
        return s.sanitize(SecurityContext.STYLE, unsafeStyle) || '';
    }
    if (allowSanitizationBypass(unsafeStyle, "Style" /* Style */)) {
        return unsafeStyle.toString();
    }
    return _sanitizeStyle(stringify$1(unsafeStyle));
}
/**
 * A `url` sanitizer which converts untrusted `url` **string** into trusted string by removing
 * dangerous
 * content.
 *
 * This method parses the `url` and locates potentially dangerous content (such as javascript) and
 * removes it.
 *
 * It is possible to mark a string as trusted by calling {@link bypassSanitizationTrustUrl}.
 *
 * @param unsafeUrl untrusted `url`, typically from the user.
 * @returns `url` string which is safe to bind to the `src` properties such as `<img src>`, because
 * all of the dangerous javascript has been removed.
 */
function sanitizeUrl(unsafeUrl) {
    var s = getCurrentSanitizer();
    if (s) {
        return s.sanitize(SecurityContext.URL, unsafeUrl) || '';
    }
    if (allowSanitizationBypass(unsafeUrl, "Url" /* Url */)) {
        return unsafeUrl.toString();
    }
    return _sanitizeUrl(stringify$1(unsafeUrl));
}
/**
 * A `url` sanitizer which only lets trusted `url`s through.
 *
 * This passes only `url`s marked trusted by calling {@link bypassSanitizationTrustResourceUrl}.
 *
 * @param unsafeResourceUrl untrusted `url`, typically from the user.
 * @returns `url` string which is safe to bind to the `src` properties such as `<img src>`, because
 * only trusted `url`s have been allowed to pass.
 */
function sanitizeResourceUrl(unsafeResourceUrl) {
    var s = getCurrentSanitizer();
    if (s) {
        return s.sanitize(SecurityContext.RESOURCE_URL, unsafeResourceUrl) || '';
    }
    if (allowSanitizationBypass(unsafeResourceUrl, "ResourceUrl" /* ResourceUrl */)) {
        return unsafeResourceUrl.toString();
    }
    throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// clang-format on
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */





/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "TlPD":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("tv3T"),
    keysIn = __webpack_require__("t8rQ");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "Tqun":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),

/***/ "U7Aq":
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),

/***/ "Ubhr":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("6MiT");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "UfSK":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "UnEC":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "UnLw":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("fMqj");

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "Uz1a":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("bJWQ"),
    equalArrays = __webpack_require__("FhcP"),
    equalByTag = __webpack_require__("EHRO"),
    equalObjects = __webpack_require__("SHWz"),
    getTag = __webpack_require__("gHOb"),
    isArray = __webpack_require__("NGEn"),
    isBuffer = __webpack_require__("ggOT"),
    isTypedArray = __webpack_require__("YsVG");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "V0td":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        ss : '%d sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),

/***/ "V4qH":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),

/***/ "V9Cg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observable; });
/** Symbol.observable or a string "@@observable". Used for interop */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = typeof Symbol === 'function' && Symbol.observable || '@@observable';
//# sourceMappingURL=observable.js.map


/***/ }),

/***/ "VHBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timeInterval;
/* unused harmony export TimeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = /*@__PURE__*/__webpack_require__("QX4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scan__ = /*@__PURE__*/__webpack_require__("Td+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_defer__ = /*@__PURE__*/__webpack_require__("JBKL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__map__ = /*@__PURE__*/__webpack_require__("rylm");
/** PURE_IMPORTS_START _scheduler_async,_scan,_observable_defer,_map PURE_IMPORTS_END */




function timeInterval(scheduler) {
    if (scheduler === void 0) {
        scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["a" /* async */];
    }
    return function (source) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__observable_defer__["a" /* defer */])(function () {
            return source.pipe(
            // HACK: the typings seem off with scan
            Object(__WEBPACK_IMPORTED_MODULE_1__scan__["a" /* scan */])(function (_a, value) {
                var current = _a.current;
                return ({ value: value, current: scheduler.now(), last: current });
            }, { current: scheduler.now(), value: undefined, last: undefined }), Object(__WEBPACK_IMPORTED_MODULE_3__map__["a" /* map */])(function (_a) {
                var current = _a.current, last = _a.last, value = _a.value;
                return new TimeInterval(value, current - last);
            }));
        });
    };
}
var TimeInterval = /*@__PURE__*/ (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());






/***/ }),

/***/ "VK9h":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),

/***/ "VORN":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "VWaN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
/* tslint:disable:no-empty */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }
//# sourceMappingURL=noop.js.map


/***/ }),

/***/ "Vi3P":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("bIjD"),
    last = __webpack_require__("oqL2"),
    parent = __webpack_require__("Cf65"),
    toKey = __webpack_require__("Ubhr");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ "Vz2w":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日Ah点mm分',
        LLLL : 'YYYY年M月D日ddddAh点mm分',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        ss : '%d 秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),

/***/ "W4FO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__["switchMap"]; });

//# sourceMappingURL=switchMap.js.map

/***/ }),

/***/ "W529":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("f931");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "WFiI":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "WHce":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("037f"),
    shortOut = __webpack_require__("Zk5a");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "WQFf":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("VORN"),
    getPrototype = __webpack_require__("vi0E"),
    isPrototype = __webpack_require__("HT7L");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "WtLm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = /*@__PURE__*/ __webpack_require__("TToO").__decorate;
var __metadata = /*@__PURE__*/ __webpack_require__("TToO").__metadata;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var common_1 = __webpack_require__("wTuo");
var core_2 = __webpack_require__("TdOr");
var Header = /*@__PURE__*/ (function () {
    function Header() {
    }
    Header = __decorate([
        core_2.Component({
            selector: 'p-header',
            template: '<ng-content></ng-content>'
        })
    ], Header);
    return Header;
}());
exports.Header = Header;
var Footer = /*@__PURE__*/ (function () {
    function Footer() {
    }
    Footer = __decorate([
        core_2.Component({
            selector: 'p-footer',
            template: '<ng-content></ng-content>'
        })
    ], Footer);
    return Footer;
}());
exports.Footer = Footer;
var PrimeTemplate = /*@__PURE__*/ (function () {
    function PrimeTemplate(template) {
        this.template = template;
    }
    PrimeTemplate.prototype.getType = function () {
        return this.name;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], PrimeTemplate.prototype, "type", void 0);
    __decorate([
        core_1.Input('pTemplate'),
        __metadata("design:type", String)
    ], PrimeTemplate.prototype, "name", void 0);
    PrimeTemplate = __decorate([
        core_1.Directive({
            selector: '[pTemplate]',
            host: {}
        })
    ], PrimeTemplate);
    return PrimeTemplate;
}());
exports.PrimeTemplate = PrimeTemplate;
/* Deprecated */
var Column = /*@__PURE__*/ (function () {
    function Column() {
        this.filterType = 'text';
        this.exportable = true;
        this.resizable = true;
        this.sortFunction = new core_1.EventEmitter();
    }
    Column.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.templates.forEach(function (item) {
            switch (item.getType()) {
                case 'header':
                    _this.headerTemplate = item.template;
                    break;
                case 'body':
                    _this.bodyTemplate = item.template;
                    break;
                case 'footer':
                    _this.footerTemplate = item.template;
                    break;
                case 'filter':
                    _this.filterTemplate = item.template;
                    break;
                case 'editor':
                    _this.editorTemplate = item.template;
                    break;
                default:
                    _this.bodyTemplate = item.template;
                    break;
            }
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "field", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "colId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "sortField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "filterField", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "header", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "footer", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Column.prototype, "sortable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Column.prototype, "editable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Column.prototype, "filter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "filterMatchMode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "filterType", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Column.prototype, "excludeGlobalFilter", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Column.prototype, "rowspan", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Column.prototype, "colspan", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "scope", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Column.prototype, "style", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "styleClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Column.prototype, "exportable", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Column.prototype, "headerStyle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "headerStyleClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Column.prototype, "bodyStyle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "bodyStyleClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Column.prototype, "footerStyle", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "footerStyleClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Column.prototype, "hidden", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Column.prototype, "expander", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "selectionMode", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Column.prototype, "filterPlaceholder", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Column.prototype, "filterMaxlength", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Column.prototype, "frozen", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Column.prototype, "resizable", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], Column.prototype, "sortFunction", void 0);
    __decorate([
        core_1.ContentChildren(PrimeTemplate),
        __metadata("design:type", core_1.QueryList)
    ], Column.prototype, "templates", void 0);
    __decorate([
        core_1.ContentChild(core_1.TemplateRef),
        __metadata("design:type", core_1.TemplateRef)
    ], Column.prototype, "template", void 0);
    Column = __decorate([
        core_2.Component({
            selector: 'p-column',
            template: ''
        })
    ], Column);
    return Column;
}());
exports.Column = Column;
/* Deprecated */
var Row = /*@__PURE__*/ (function () {
    function Row() {
    }
    __decorate([
        core_1.ContentChildren(Column),
        __metadata("design:type", core_1.QueryList)
    ], Row.prototype, "columns", void 0);
    Row = __decorate([
        core_2.Component({
            selector: 'p-row',
            template: ""
        })
    ], Row);
    return Row;
}());
exports.Row = Row;
/* Deprecated */
var HeaderColumnGroup = /*@__PURE__*/ (function () {
    function HeaderColumnGroup() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], HeaderColumnGroup.prototype, "frozen", void 0);
    __decorate([
        core_1.ContentChildren(Row),
        __metadata("design:type", core_1.QueryList)
    ], HeaderColumnGroup.prototype, "rows", void 0);
    HeaderColumnGroup = __decorate([
        core_2.Component({
            selector: 'p-headerColumnGroup',
            template: ""
        })
    ], HeaderColumnGroup);
    return HeaderColumnGroup;
}());
exports.HeaderColumnGroup = HeaderColumnGroup;
/* Deprecated */
var FooterColumnGroup = /*@__PURE__*/ (function () {
    function FooterColumnGroup() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], FooterColumnGroup.prototype, "frozen", void 0);
    __decorate([
        core_1.ContentChildren(Row),
        __metadata("design:type", core_1.QueryList)
    ], FooterColumnGroup.prototype, "rows", void 0);
    FooterColumnGroup = __decorate([
        core_2.Component({
            selector: 'p-footerColumnGroup',
            template: ""
        })
    ], FooterColumnGroup);
    return FooterColumnGroup;
}());
exports.FooterColumnGroup = FooterColumnGroup;
var SharedModule = /*@__PURE__*/ (function () {
    function SharedModule() {
    }
    SharedModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule],
            exports: [Header, Footer, Column, PrimeTemplate, Row, HeaderColumnGroup, FooterColumnGroup],
            declarations: [Header, Footer, Column, PrimeTemplate, Row, HeaderColumnGroup, FooterColumnGroup]
        })
    ], SharedModule);
    return SharedModule;
}());
exports.SharedModule = SharedModule;



/***/ }),

/***/ "Wubi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scheduler; });
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 * @deprecated Scheduler is an internal implementation detail of RxJS, and
 * should not be used directly. Rather, create your own class and implement
 * {@link SchedulerLike}
 */
var Scheduler = /*@__PURE__*/ (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    /** @nocollapse */
    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
    return Scheduler;
}());






/***/ }),

/***/ "WxI4":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "WyC4":
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ "XTlk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
//# sourceMappingURL=isPromise.js.map


/***/ }),

/***/ "XU1s":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        ss : '%d фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),

/***/ "XlWM":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'ss': [number + 'sekundi', number + 'sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        ss     : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),

/***/ "XtZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = observeOn;
/* unused harmony export ObserveOnOperator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObserveOnSubscriber; });
/* unused harmony export ObserveOnMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification__ = /*@__PURE__*/__webpack_require__("NGRO");
/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */



/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {SchedulerLike} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var ObserveOnOperator = /*@__PURE__*/ (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    /** @nocollapse */
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(__WEBPACK_IMPORTED_MODULE_2__Notification__["a" /* Notification */].createComplete());
    };
    return ObserveOnSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));

var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());






/***/ }),

/***/ "XzD+":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        ss : '%d วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),

/***/ "Y9kR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubscribeOnObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__ = /*@__PURE__*/__webpack_require__("wdeq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isNumeric__ = /*@__PURE__*/__webpack_require__("03ca");
/** PURE_IMPORTS_START tslib,_Observable,_scheduler_asap,_util_isNumeric PURE_IMPORTS_END */




/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var SubscribeOnObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) {
            delayTime = 0;
        }
        if (scheduler === void 0) {
            scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.delayTime = delayTime;
        _this.scheduler = scheduler;
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__util_isNumeric__["a" /* isNumeric */])(delayTime) || delayTime < 0) {
            _this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            _this.scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        return _this;
    }
    /** @nocollapse */
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) {
            delay = 0;
        }
        if (scheduler === void 0) {
            scheduler = __WEBPACK_IMPORTED_MODULE_2__scheduler_asap__["a" /* asap */];
        }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    /** @nocollapse */
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(__WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]));






/***/ }),

/***/ "YBA/":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        ss : '%d sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),

/***/ "YDHx":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("Uz1a"),
    isObjectLike = __webpack_require__("UnEC");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "YKDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TranslateStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TranslateModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TranslateLoader; });
/* unused harmony export TranslateFakeLoader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return USE_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return USE_DEFAULT_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TranslateService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MissingTranslationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FakeMissingTranslationHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TranslateParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TranslateDefaultParser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TranslateCompiler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TranslateFakeCompiler; });
/* unused harmony export TranslateDirective */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TranslatePipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__ = __webpack_require__("KHsn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__ = __webpack_require__("H0JA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators_share__ = __webpack_require__("v389");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operators_map__ = __webpack_require__("bV3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operators_merge__ = __webpack_require__("d3Hm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operators_switchMap__ = __webpack_require__("W4FO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operators_toArray__ = __webpack_require__("/4GN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operators_take__ = __webpack_require__("jHrt");
var __extends = /*@__PURE__*/ __webpack_require__("TToO").__extends;









var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TranslateLoader = /*@__PURE__*/ (function () {
    function TranslateLoader() {
    }
    return TranslateLoader;
}());
/**
 * This loader is just a placeholder that does nothing, in case you don't need a loader at all
 */
var TranslateFakeLoader = /*@__PURE__*/ (function (_super) {
    __extends(TranslateFakeLoader, _super);
    function TranslateFakeLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TranslateFakeLoader.prototype.getTranslation = function (lang) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["a" /* of */])({});
    };
    return TranslateFakeLoader;
}(TranslateLoader));
TranslateFakeLoader = __decorate$1([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
], TranslateFakeLoader);
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
var isScheduler_2 = isScheduler;
var isScheduler_1 = {
    isScheduler: isScheduler_2
};
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
}
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof commonjsGlobal !== 'undefined' && commonjsGlobal;
var _root = __window || __global || __self;
var root_1 = _root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function () {
    if (!_root) {
        throw new Error('RxJS could not find any global context (window, self, global)');
    }
})();
var root = {
    root: root_1
};
function isFunction(x) {
    return typeof x === 'function';
}
var isFunction_2 = isFunction;
var isFunction_1 = {
    isFunction: isFunction_2
};
var isArray_1 = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
var isArray = {
    isArray: isArray_1
};
function isObject(x) {
    return x != null && typeof x === 'object';
}
var isObject_2 = isObject;
var isObject_1 = {
    isObject: isObject_2
};
// typeof any so that it we don't have to cast when comparing a result to the error object
var errorObject_1 = { e: {} };
var errorObject = {
    errorObject: errorObject_1
};
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject.errorObject.e = e;
        return errorObject.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
var tryCatch_2 = tryCatch;
var tryCatch_1 = {
    tryCatch: tryCatch_2
};
var __extends$2 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends$2(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
var UnsubscriptionError_2 = UnsubscriptionError;
var UnsubscriptionError_1 = {
    UnsubscriptionError: UnsubscriptionError_2
};
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = /*@__PURE__*/ (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject.errorObject.e.errors) : [errorObject.errorObject.e]);
            }
        }
        if (isArray.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
var Subscription_2 = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
var Subscription_1 = {
    Subscription: Subscription_2
};
var empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
var Observer = {
    empty: empty
};
var rxSubscriber = createCommonjsModule(function (module, exports) {
    var Symbol = root.root.Symbol;
    exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
        Symbol.for('rxSubscriber') : '@@rxSubscriber';
    /**
     * @deprecated use rxSubscriber instead
     */
    exports.$$rxSubscriber = exports.rxSubscriber;
});
var rxSubscriber_1 = rxSubscriber.rxSubscriber;
var rxSubscriber_2 = rxSubscriber.$$rxSubscriber;
var __extends$1 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends$1(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
var Subscriber_2 = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends$1(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
var Subscriber_1 = {
    Subscriber: Subscriber_2
};
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber.rxSubscriber]) {
            return nextOrObserver[rxSubscriber.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
var toSubscriber_2 = toSubscriber;
var toSubscriber_1 = {
    toSubscriber: toSubscriber_2
};
var observable = createCommonjsModule(function (module, exports) {
    function getSymbolObservable(context) {
        var $$observable;
        var Symbol = context.Symbol;
        if (typeof Symbol === 'function') {
            if (Symbol.observable) {
                $$observable = Symbol.observable;
            }
            else {
                $$observable = Symbol('observable');
                Symbol.observable = $$observable;
            }
        }
        else {
            $$observable = '@@observable';
        }
        return $$observable;
    }
    exports.getSymbolObservable = getSymbolObservable;
    exports.observable = getSymbolObservable(root.root);
    /**
     * @deprecated use observable instead
     */
    exports.$$observable = exports.observable;
});
var observable_1 = observable.getSymbolObservable;
var observable_2 = observable.observable;
var observable_3 = observable.$$observable;
/* tslint:disable:no-empty */
function noop() { }
var noop_2 = noop;
var noop_1 = {
    noop: noop_2
};
/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i - 0] = arguments[_i];
    }
    return pipeFromArray(fns);
}
var pipe_2 = pipe;
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return noop_1.noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
var pipeFromArray_1 = pipeFromArray;
var pipe_1 = {
    pipe: pipe_2,
    pipeFromArray: pipeFromArray_1
};
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable$2 = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable$$1(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable$$1.prototype.lift = function (operator) {
        var observable$$1 = new Observable$$1();
        observable$$1.source = this;
        observable$$1.operator = operator;
        return observable$$1;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable$$1.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable$$1.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable$$1.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root.root.Rx && root.root.Rx.config && root.root.Rx.config.Promise) {
                PromiseCtor = root.root.Rx.config.Promise;
            }
            else if (root.root.Promise) {
                PromiseCtor = root.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable$$1.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable$$1.prototype[observable.observable] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable$$1.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i - 0] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipe_1.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable$$1.prototype.toPromise = function (PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root.root.Rx && root.root.Rx.config && root.root.Rx.config.Promise) {
                PromiseCtor = root.root.Rx.config.Promise;
            }
            else if (root.root.Promise) {
                PromiseCtor = root.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable$$1.create = function (subscribe) {
        return new Observable$$1(subscribe);
    };
    return Observable$$1;
}());
var Observable_2 = Observable$2;
var Observable_1 = {
    Observable: Observable_2
};
var __extends$3 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable = (function (_super) {
    __extends$3(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) {
            this._isScalar = false;
        }
    }
    ScalarObservable.create = function (value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function (state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        state.done = true;
        this.schedule(state);
    };
    ScalarObservable.prototype._subscribe = function (subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ScalarObservable.dispatch, 0, {
                done: false, value: value, subscriber: subscriber
            });
        }
        else {
            subscriber.next(value);
            if (!subscriber.closed) {
                subscriber.complete();
            }
        }
    };
    return ScalarObservable;
}(Observable_1.Observable));
var ScalarObservable_2 = ScalarObservable;
var ScalarObservable_1 = {
    ScalarObservable: ScalarObservable_2
};
var __extends$4 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var EmptyObservable = (function (_super) {
    __extends$4(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */
    EmptyObservable.create = function (scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function (arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    EmptyObservable.prototype._subscribe = function (subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
        }
        else {
            subscriber.complete();
        }
    };
    return EmptyObservable;
}(Observable_1.Observable));
var EmptyObservable_2 = EmptyObservable;
var EmptyObservable_1 = {
    EmptyObservable: EmptyObservable_2
};
var __extends = /*@__PURE__*/ __webpack_require__("TToO").__extends;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable = /*@__PURE__*/ (function (_super) {
    __extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function (array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */
    ArrayObservable.of = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len > 1) {
            return new ArrayObservable(array, scheduler);
        }
        else if (len === 1) {
            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
        }
        else {
            return new EmptyObservable_1.EmptyObservable(scheduler);
        }
    };
    ArrayObservable.dispatch = function (state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ArrayObservable.dispatch, 0, {
                array: array, index: index, count: count, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < count && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayObservable;
}(Observable_1.Observable));
var ArrayObservable_2 = ArrayObservable;
var ArrayObservable_1 = {
    ArrayObservable: ArrayObservable_2
};
var of_1 = ArrayObservable_1.ArrayObservable.of;
var of$2 = {
    of: of_1
};
var isArrayLike_1 = (function (x) { return x && typeof x.length === 'number'; });
var isArrayLike = {
    isArrayLike: isArrayLike_1
};
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
var isPromise_2 = isPromise;
var isPromise_1 = {
    isPromise: isPromise_2
};
var __extends$6 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable = (function (_super) {
    __extends$6(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */
    PromiseObservable.create = function (promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    PromiseObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.error(err);
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root.root.setTimeout(function () { throw err; });
                });
            }
        }
        else {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root.root.setTimeout(function () { throw err; });
                });
            }
        }
    };
    return PromiseObservable;
}(Observable_1.Observable));
var PromiseObservable_2 = PromiseObservable;
function dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.error(err);
    }
}
var PromiseObservable_1 = {
    PromiseObservable: PromiseObservable_2
};
var iterator = createCommonjsModule(function (module, exports) {
    function symbolIteratorPonyfill(root$$2) {
        var Symbol = root$$2.Symbol;
        if (typeof Symbol === 'function') {
            if (!Symbol.iterator) {
                Symbol.iterator = Symbol('iterator polyfill');
            }
            return Symbol.iterator;
        }
        else {
            // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
            var Set_1 = root$$2.Set;
            if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
                return '@@iterator';
            }
            var Map_1 = root$$2.Map;
            // required for compatability with es6-shim
            if (Map_1) {
                var keys = Object.getOwnPropertyNames(Map_1.prototype);
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                    if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                        return key;
                    }
                }
            }
            return '@@iterator';
        }
    }
    exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
    exports.iterator = symbolIteratorPonyfill(root.root);
    /**
     * @deprecated use iterator instead
     */
    exports.$$iterator = exports.iterator;
});
var iterator_1 = iterator.symbolIteratorPonyfill;
var iterator_2 = iterator.iterator;
var iterator_3 = iterator.$$iterator;
var __extends$7 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable = (function (_super) {
    __extends$7(IteratorObservable, _super);
    function IteratorObservable(iterator$$1, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator$$1 == null) {
            throw new Error('iterator cannot be null.');
        }
        this.iterator = getIterator(iterator$$1);
    }
    IteratorObservable.create = function (iterator$$1, scheduler) {
        return new IteratorObservable(iterator$$1, scheduler);
    };
    IteratorObservable.dispatch = function (state) {
        var index = state.index, hasError = state.hasError, iterator$$1 = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator$$1.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator$$1.return === 'function') {
                iterator$$1.return();
            }
            return;
        }
        this.schedule(state);
    };
    IteratorObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, iterator$$1 = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) {
            return scheduler.schedule(IteratorObservable.dispatch, 0, {
                index: index, iterator: iterator$$1, subscriber: subscriber
            });
        }
        else {
            do {
                var result = iterator$$1.next();
                if (result.done) {
                    subscriber.complete();
                    break;
                }
                else {
                    subscriber.next(result.value);
                }
                if (subscriber.closed) {
                    if (typeof iterator$$1.return === 'function') {
                        iterator$$1.return();
                    }
                    break;
                }
            } while (true);
        }
    };
    return IteratorObservable;
}(Observable_1.Observable));
var IteratorObservable_2 = IteratorObservable;
var StringIterator = /*@__PURE__*/ (function () {
    function StringIterator(str, idx, len) {
        if (idx === void 0) {
            idx = 0;
        }
        if (len === void 0) {
            len = str.length;
        }
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[iterator.iterator] = function () { return (this); };
    StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}());
var ArrayIterator = /*@__PURE__*/ (function () {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) {
            idx = 0;
        }
        if (len === void 0) {
            len = toLength(arr);
        }
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[iterator.iterator] = function () { return this; };
    ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}());
function getIterator(obj) {
    var i = obj[iterator.iterator];
    if (!i && typeof obj === 'string') {
        return new StringIterator(obj);
    }
    if (!i && obj.length !== undefined) {
        return new ArrayIterator(obj);
    }
    if (!i) {
        throw new TypeError('object is not iterable');
    }
    return obj[iterator.iterator]();
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) {
        return 0;
    }
    if (len === 0 || !numberIsFinite(len)) {
        return len;
    }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) {
        return 0;
    }
    if (len > maxSafeInteger) {
        return maxSafeInteger;
    }
    return len;
}
function numberIsFinite(value) {
    return typeof value === 'number' && root.root.isFinite(value);
}
function sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) {
        return valueAsNumber;
    }
    if (isNaN(valueAsNumber)) {
        return valueAsNumber;
    }
    return valueAsNumber < 0 ? -1 : 1;
}
var IteratorObservable_1 = {
    IteratorObservable: IteratorObservable_2
};
var __extends$8 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable = (function (_super) {
    __extends$8(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function (arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (length === 1) {
            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
        }
        else {
            return new ArrayLikeObservable(arrayLike, scheduler);
        }
    };
    ArrayLikeObservable.dispatch = function (state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) {
            return;
        }
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayLikeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) {
            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < length && !subscriber.closed; i++) {
                subscriber.next(arrayLike[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}(Observable_1.Observable));
var ArrayLikeObservable_2 = ArrayLikeObservable;
var ArrayLikeObservable_1 = {
    ArrayLikeObservable: ArrayLikeObservable_2
};
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Observable_1.Observable.of(this.value);
            case 'E':
                return Observable_1.Observable.throw(this.error);
            case 'C':
                return Observable_1.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
var Notification_2 = Notification;
var Notification_1 = {
    Notification: Notification_2
};
var __extends$9 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) {
        delay = 0;
    }
    return function observeOnOperatorFunction(source) {
        return source.lift(new ObserveOnOperator(scheduler, delay));
    };
}
var observeOn_2 = observeOn;
var ObserveOnOperator = /*@__PURE__*/ (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
var ObserveOnOperator_1 = ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = (function (_super) {
    __extends$9(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification_1.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}(Subscriber_1.Subscriber));
var ObserveOnSubscriber_1 = ObserveOnSubscriber;
var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
var ObserveOnMessage_1 = ObserveOnMessage;
var observeOn_1 = {
    observeOn: observeOn_2,
    ObserveOnOperator: ObserveOnOperator_1,
    ObserveOnSubscriber: ObserveOnSubscriber_1,
    ObserveOnMessage: ObserveOnMessage_1
};
var __extends$5 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromObservable = (function (_super) {
    __extends$5(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */
    FromObservable.create = function (ish, scheduler) {
        if (ish != null) {
            if (typeof ish[observable.observable] === 'function') {
                if (ish instanceof Observable_1.Observable && !scheduler) {
                    return ish;
                }
                return new FromObservable(ish, scheduler);
            }
            else if (isArray.isArray(ish)) {
                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
            }
            else if (isPromise_1.isPromise(ish)) {
                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
            }
            else if (typeof ish[iterator.iterator] === 'function' || typeof ish === 'string') {
                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
            }
            else if (isArrayLike.isArrayLike(ish)) {
                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
            }
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    FromObservable.prototype._subscribe = function (subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            return ish[observable.observable]().subscribe(subscriber);
        }
        else {
            return ish[observable.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
        }
    };
    return FromObservable;
}(Observable_1.Observable));
var FromObservable_2 = FromObservable;
var FromObservable_1 = {
    FromObservable: FromObservable_2
};
var from_1 = FromObservable_1.FromObservable.create;
var from = {
    from: from_1
};
var __extends$11 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends$11(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
var InnerSubscriber_2 = InnerSubscriber;
var InnerSubscriber_1 = {
    InnerSubscriber: InnerSubscriber_2
};
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    }
    else if (isArrayLike.isArrayLike(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator.iterator] === 'function') {
        var iterator$$2 = result[iterator.iterator]();
        do {
            var item = iterator$$2.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable.observable] === 'function') {
        var obs = result[observable.observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
var subscribeToResult_2 = subscribeToResult;
var subscribeToResult_1 = {
    subscribeToResult: subscribeToResult_2
};
var __extends$12 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends$12(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
var OuterSubscriber_2 = OuterSubscriber;
var OuterSubscriber_1 = {
    OuterSubscriber: OuterSubscriber_2
};
var __extends$10 = (commonjsGlobal && commonjsGlobal.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
    };
}
var mergeMap_2 = mergeMap;
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}());
var MergeMapOperator_1 = MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = (function (_super) {
    __extends$10(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
var MergeMapSubscriber_1 = MergeMapSubscriber;
var mergeMap_1 = {
    mergeMap: mergeMap_2,
    MergeMapOperator: MergeMapOperator_1,
    MergeMapSubscriber: MergeMapSubscriber_1
};
function identity(x) {
    return x;
}
var identity_2 = identity;
var identity_1 = {
    identity: identity_2
};
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
}
var mergeAll_2 = mergeAll;
var mergeAll_1 = {
    mergeAll: mergeAll_2
};
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return mergeAll_1.mergeAll(1);
}
var concatAll_2 = concatAll;
var concatAll_1 = {
    concatAll: concatAll_2
};
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */
function concat$1() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    if (observables.length === 1 || (observables.length === 2 && isScheduler_1.isScheduler(observables[1]))) {
        return from.from(observables[0]);
    }
    return concatAll_1.concatAll()(of$2.of.apply(void 0, observables));
}
var concat_2$2 = concat$1;
var concat_1 = {
    concat: concat_2$2
};
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return function (source) { return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables))); };
}
var concat_3 = concat;
var __decorate$3 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MissingTranslationHandler = /*@__PURE__*/ (function () {
    function MissingTranslationHandler() {
    }
    return MissingTranslationHandler;
}());
/**
 * This handler is just a placeholder that does nothing, in case you don't need a missing translation handler at all
 */
var FakeMissingTranslationHandler = /*@__PURE__*/ (function () {
    function FakeMissingTranslationHandler() {
    }
    FakeMissingTranslationHandler.prototype.handle = function (params) {
        return params.key;
    };
    return FakeMissingTranslationHandler;
}());
FakeMissingTranslationHandler = __decorate$3([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
], FakeMissingTranslationHandler);
var __decorate$4 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TranslateCompiler = /*@__PURE__*/ (function () {
    function TranslateCompiler() {
    }
    return TranslateCompiler;
}());
/**
 * This compiler is just a placeholder that does nothing, in case you don't need a compiler at all
 */
var TranslateFakeCompiler = /*@__PURE__*/ (function (_super) {
    __extends(TranslateFakeCompiler, _super);
    function TranslateFakeCompiler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TranslateFakeCompiler.prototype.compile = function (value, lang) {
        return value;
    };
    TranslateFakeCompiler.prototype.compileTranslations = function (translations, lang) {
        return translations;
    };
    return TranslateFakeCompiler;
}(TranslateCompiler));
TranslateFakeCompiler = __decorate$4([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
], TranslateFakeCompiler);
/* tslint:disable */
/**
 * @name equals
 *
 * @description
 * Determines if two objects or two values are equivalent.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `equals`.
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 */
function equals(o1, o2) {
    if (o1 === o2)
        return true;
    if (o1 === null || o2 === null)
        return false;
    if (o1 !== o1 && o2 !== o2)
        return true; // NaN === NaN
    var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
    if (t1 == t2 && t1 == 'object') {
        if (Array.isArray(o1)) {
            if (!Array.isArray(o2))
                return false;
            if ((length = o1.length) == o2.length) {
                for (key = 0; key < length; key++) {
                    if (!equals(o1[key], o2[key]))
                        return false;
                }
                return true;
            }
        }
        else {
            if (Array.isArray(o2)) {
                return false;
            }
            keySet = Object.create(null);
            for (key in o1) {
                if (!equals(o1[key], o2[key])) {
                    return false;
                }
                keySet[key] = true;
            }
            for (key in o2) {
                if (!(key in keySet) && typeof o2[key] !== 'undefined') {
                    return false;
                }
            }
            return true;
        }
    }
    return false;
}
/* tslint:enable */
function isDefined(value) {
    return typeof value !== 'undefined' && value !== null;
}
function isObject$1(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}
function mergeDeep(target, source) {
    var output = Object.assign({}, target);
    if (isObject$1(target) && isObject$1(source)) {
        Object.keys(source).forEach(function (key) {
            if (isObject$1(source[key])) {
                if (!(key in target)) {
                    Object.assign(output, (_b = {}, _b[key] = source[key], _b));
                }
                else {
                    output[key] = mergeDeep(target[key], source[key]);
                }
            }
            else {
                Object.assign(output, (_c = {}, _c[key] = source[key], _c));
            }
            var _b, _c;
        });
    }
    return output;
}
var __decorate$5 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TranslateParser = /*@__PURE__*/ (function () {
    function TranslateParser() {
    }
    return TranslateParser;
}());
var TranslateDefaultParser = /*@__PURE__*/ (function (_super) {
    __extends(TranslateDefaultParser, _super);
    function TranslateDefaultParser() {
        var _this = _super.apply(this, arguments) || this;
        _this.templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
        return _this;
    }
    TranslateDefaultParser.prototype.interpolate = function (expr, params) {
        var result;
        if (typeof expr === 'string') {
            result = this.interpolateString(expr, params);
        }
        else if (typeof expr === 'function') {
            result = this.interpolateFunction(expr, params);
        }
        else {
            // this should not happen, but an unrelated TranslateService test depends on it
            result = expr;
        }
        return result;
    };
    TranslateDefaultParser.prototype.getValue = function (target, key) {
        var keys = key.split('.');
        key = '';
        do {
            key += keys.shift();
            if (isDefined(target) && isDefined(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
                target = target[key];
                key = '';
            }
            else if (!keys.length) {
                target = undefined;
            }
            else {
                key += '.';
            }
        } while (keys.length);
        return target;
    };
    TranslateDefaultParser.prototype.interpolateFunction = function (fn, params) {
        return fn(params);
    };
    TranslateDefaultParser.prototype.interpolateString = function (expr, params) {
        var _this = this;
        if (!params) {
            return expr;
        }
        return expr.replace(this.templateMatcher, function (substring, b) {
            var r = _this.getValue(params, b);
            return isDefined(r) ? r : substring;
        });
    };
    return TranslateDefaultParser;
}(TranslateParser));
TranslateDefaultParser = __decorate$5([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])()
], TranslateDefaultParser);
var TranslateStore = /*@__PURE__*/ (function () {
    function TranslateStore() {
        /**
         * The lang currently used
         * @type {string}
         */
        this.currentLang = this.defaultLang;
        /**
         * a list of translations per lang
         * @type {{}}
         */
        this.translations = {};
        /**
         * an array of langs
         * @type {Array}
         */
        this.langs = [];
        /**
         * An EventEmitter to listen to translation change events
         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
         *     // do something
         * });
         * @type {EventEmitter<TranslationChangeEvent>}
         */
        this.onTranslationChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * An EventEmitter to listen to lang change events
         * onLangChange.subscribe((params: LangChangeEvent) => {
         *     // do something
         * });
         * @type {EventEmitter<LangChangeEvent>}
         */
        this.onLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * An EventEmitter to listen to default lang change events
         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
         *     // do something
         * });
         * @type {EventEmitter<DefaultLangChangeEvent>}
         */
        this.onDefaultLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    return TranslateStore;
}());
var __decorate$2 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = /*@__PURE__*/ __webpack_require__("TToO").__metadata;
var __param = /*@__PURE__*/ __webpack_require__("TToO").__param;
var USE_STORE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('USE_STORE');
var USE_DEFAULT_LANG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('USE_DEFAULT_LANG');
var TranslateService = /*@__PURE__*/ (function () {
    /**
     *
     * @param store an instance of the store (that is supposed to be unique)
     * @param currentLoader An instance of the loader currently used
     * @param compiler An instance of the compiler currently used
     * @param parser An instance of the parser currently used
     * @param missingTranslationHandler A handler for missing translations.
     * @param isolate whether this service should use the store or not
     * @param useDefaultLang whether we should use default language translation when current language translation is missing.
     */
    function TranslateService(store, currentLoader, compiler, parser, missingTranslationHandler, useDefaultLang, isolate) {
        if (useDefaultLang === void 0) {
            useDefaultLang = true;
        }
        if (isolate === void 0) {
            isolate = false;
        }
        this.store = store;
        this.currentLoader = currentLoader;
        this.compiler = compiler;
        this.parser = parser;
        this.missingTranslationHandler = missingTranslationHandler;
        this.useDefaultLang = useDefaultLang;
        this.isolate = isolate;
        this.pending = false;
        this._onTranslationChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._onLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._onDefaultLangChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._langs = [];
        this._translations = {};
        this._translationRequests = {};
    }
    Object.defineProperty(TranslateService.prototype, "onTranslationChange", {
        /**
         * An EventEmitter to listen to translation change events
         * onTranslationChange.subscribe((params: TranslationChangeEvent) => {
         *     // do something
         * });
         * @type {EventEmitter<TranslationChangeEvent>}
         */
        get: function () {
            return this.isolate ? this._onTranslationChange : this.store.onTranslationChange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslateService.prototype, "onLangChange", {
        /**
         * An EventEmitter to listen to lang change events
         * onLangChange.subscribe((params: LangChangeEvent) => {
         *     // do something
         * });
         * @type {EventEmitter<LangChangeEvent>}
         */
        get: function () {
            return this.isolate ? this._onLangChange : this.store.onLangChange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslateService.prototype, "onDefaultLangChange", {
        /**
         * An EventEmitter to listen to default lang change events
         * onDefaultLangChange.subscribe((params: DefaultLangChangeEvent) => {
         *     // do something
         * });
         * @type {EventEmitter<DefaultLangChangeEvent>}
         */
        get: function () {
            return this.isolate ? this._onDefaultLangChange : this.store.onDefaultLangChange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslateService.prototype, "defaultLang", {
        /**
         * The default lang to fallback when translations are missing on the current lang
         */
        get: function () {
            return this.isolate ? this._defaultLang : this.store.defaultLang;
        },
        set: function (defaultLang) {
            if (this.isolate) {
                this._defaultLang = defaultLang;
            }
            else {
                this.store.defaultLang = defaultLang;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslateService.prototype, "currentLang", {
        /**
         * The lang currently used
         * @type {string}
         */
        get: function () {
            return this.isolate ? this._currentLang : this.store.currentLang;
        },
        set: function (currentLang) {
            if (this.isolate) {
                this._currentLang = currentLang;
            }
            else {
                this.store.currentLang = currentLang;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslateService.prototype, "langs", {
        /**
         * an array of langs
         * @type {Array}
         */
        get: function () {
            return this.isolate ? this._langs : this.store.langs;
        },
        set: function (langs) {
            if (this.isolate) {
                this._langs = langs;
            }
            else {
                this.store.langs = langs;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslateService.prototype, "translations", {
        /**
         * a list of translations per lang
         * @type {{}}
         */
        get: function () {
            return this.isolate ? this._translations : this.store.translations;
        },
        set: function (translations) {
            if (this.isolate) {
                this._translations = translations;
            }
            else {
                this.store.translations = translations;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the default language to use as a fallback
     * @param lang
     */
    TranslateService.prototype.setDefaultLang = function (lang) {
        var _this = this;
        if (lang === this.defaultLang) {
            return;
        }
        var pending = this.retrieveTranslations(lang);
        if (typeof pending !== "undefined") {
            // on init set the defaultLang immediately
            if (!this.defaultLang) {
                this.defaultLang = lang;
            }
            pending.pipe(Object(__WEBPACK_IMPORTED_MODULE_8_rxjs_operators_take__["a" /* take */])(1))
                .subscribe(function (res) {
                _this.changeDefaultLang(lang);
            });
        }
        else {
            this.changeDefaultLang(lang);
        }
    };
    /**
     * Gets the default language used
     * @returns string
     */
    TranslateService.prototype.getDefaultLang = function () {
        return this.defaultLang;
    };
    /**
     * Changes the lang currently used
     * @param lang
     * @returns {Observable<*>}
     */
    TranslateService.prototype.use = function (lang) {
        var _this = this;
        // don't change the language if the language given is already selected
        if (lang === this.currentLang) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["a" /* of */])(this.translations[lang]);
        }
        var pending = this.retrieveTranslations(lang);
        if (typeof pending !== "undefined") {
            // on init set the currentLang immediately
            if (!this.currentLang) {
                this.currentLang = lang;
            }
            pending.pipe(Object(__WEBPACK_IMPORTED_MODULE_8_rxjs_operators_take__["a" /* take */])(1))
                .subscribe(function (res) {
                _this.changeLang(lang);
            });
            return pending;
        }
        else {
            this.changeLang(lang);
            return Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["a" /* of */])(this.translations[lang]);
        }
    };
    /**
     * Retrieves the given translations
     * @param lang
     * @returns {Observable<*>}
     */
    TranslateService.prototype.retrieveTranslations = function (lang) {
        var pending;
        // if this language is unavailable, ask for it
        if (typeof this.translations[lang] === "undefined") {
            this._translationRequests[lang] = this._translationRequests[lang] || this.getTranslation(lang);
            pending = this._translationRequests[lang];
        }
        return pending;
    };
    /**
     * Gets an object of translations for a given language with the current loader
     * and passes it through the compiler
     * @param lang
     * @returns {Observable<*>}
     */
    TranslateService.prototype.getTranslation = function (lang) {
        var _this = this;
        this.pending = true;
        this.loadingTranslations = this.currentLoader.getTranslation(lang).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators_share__["a" /* share */])());
        this.loadingTranslations.pipe(Object(__WEBPACK_IMPORTED_MODULE_8_rxjs_operators_take__["a" /* take */])(1))
            .subscribe(function (res) {
            _this.translations[lang] = _this.compiler.compileTranslations(res, lang);
            _this.updateLangs();
            _this.pending = false;
        }, function (err) {
            _this.pending = false;
        });
        return this.loadingTranslations;
    };
    /**
     * Manually sets an object of translations for a given language
     * after passing it through the compiler
     * @param lang
     * @param translations
     * @param shouldMerge
     */
    TranslateService.prototype.setTranslation = function (lang, translations, shouldMerge) {
        if (shouldMerge === void 0) {
            shouldMerge = false;
        }
        translations = this.compiler.compileTranslations(translations, lang);
        if (shouldMerge && this.translations[lang]) {
            this.translations[lang] = mergeDeep(this.translations[lang], translations);
        }
        else {
            this.translations[lang] = translations;
        }
        this.updateLangs();
        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
    };
    /**
     * Returns an array of currently available langs
     * @returns {any}
     */
    TranslateService.prototype.getLangs = function () {
        return this.langs;
    };
    /**
     * @param langs
     * Add available langs
     */
    TranslateService.prototype.addLangs = function (langs) {
        var _this = this;
        langs.forEach(function (lang) {
            if (_this.langs.indexOf(lang) === -1) {
                _this.langs.push(lang);
            }
        });
    };
    /**
     * Update the list of available langs
     */
    TranslateService.prototype.updateLangs = function () {
        this.addLangs(Object.keys(this.translations));
    };
    /**
     * Returns the parsed result of the translations
     * @param translations
     * @param key
     * @param interpolateParams
     * @returns {any}
     */
    TranslateService.prototype.getParsedResult = function (translations, key, interpolateParams) {
        var res;
        if (key instanceof Array) {
            var result = {}, observables = false;
            for (var _b = 0, key_1 = key; _b < key_1.length; _b++) {
                var k = key_1[_b];
                result[k] = this.getParsedResult(translations, k, interpolateParams);
                if (typeof result[k].subscribe === "function") {
                    observables = true;
                }
            }
            if (observables) {
                var mergedObs = void 0;
                for (var _c = 0, key_2 = key; _c < key_2.length; _c++) {
                    var k = key_2[_c];
                    var obs = typeof result[k].subscribe === "function" ? result[k] : Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["a" /* of */])(result[k]);
                    if (typeof mergedObs === "undefined") {
                        mergedObs = obs;
                    }
                    else {
                        mergedObs = mergedObs.pipe(Object(__WEBPACK_IMPORTED_MODULE_5_rxjs_operators_merge__["a" /* merge */])(obs));
                    }
                }
                return mergedObs.pipe(Object(__WEBPACK_IMPORTED_MODULE_7_rxjs_operators_toArray__["a" /* toArray */])(), Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators_map__["a" /* map */])(function (arr) {
                    var obj = {};
                    arr.forEach(function (value, index) {
                        obj[key[index]] = value;
                    });
                    return obj;
                }));
            }
            return result;
        }
        if (translations) {
            res = this.parser.interpolate(this.parser.getValue(translations, key), interpolateParams);
        }
        if (typeof res === "undefined" && this.defaultLang && this.defaultLang !== this.currentLang && this.useDefaultLang) {
            res = this.parser.interpolate(this.parser.getValue(this.translations[this.defaultLang], key), interpolateParams);
        }
        if (typeof res === "undefined") {
            var params = { key: key, translateService: this };
            if (typeof interpolateParams !== 'undefined') {
                params.interpolateParams = interpolateParams;
            }
            res = this.missingTranslationHandler.handle(params);
        }
        return typeof res !== "undefined" ? res : key;
    };
    /**
     * Gets the translated value of a key (or an array of keys)
     * @param key
     * @param interpolateParams
     * @returns {any} the translated key, or an object of translated keys
     */
    TranslateService.prototype.get = function (key, interpolateParams) {
        var _this = this;
        if (!isDefined(key) || !key.length) {
            throw new Error("Parameter \"key\" required");
        }
        // check if we are loading a new translation to use
        if (this.pending) {
            return __WEBPACK_IMPORTED_MODULE_2_rxjs_Observable__["a" /* Observable */].create(function (observer) {
                var onComplete = function (res) {
                    observer.next(res);
                    observer.complete();
                };
                var onError = function (err) {
                    observer.error(err);
                };
                _this.loadingTranslations.subscribe(function (res) {
                    res = _this.getParsedResult(_this.compiler.compileTranslations(res, _this.currentLang), key, interpolateParams);
                    if (typeof res.subscribe === "function") {
                        res.subscribe(onComplete, onError);
                    }
                    else {
                        onComplete(res);
                    }
                }, onError);
            });
        }
        else {
            var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
            if (typeof res.subscribe === "function") {
                return res;
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["a" /* of */])(res);
            }
        }
    };
    /**
     * Returns a stream of translated values of a key (or an array of keys) which updates
     * whenever the language changes.
     * @param key
     * @param interpolateParams
     * @returns {any} A stream of the translated key, or an object of translated keys
     */
    TranslateService.prototype.stream = function (key, interpolateParams) {
        var _this = this;
        if (!isDefined(key) || !key.length) {
            throw new Error("Parameter \"key\" required");
        }
        return this
            .get(key, interpolateParams)
            .pipe(concat_3(this.onLangChange.pipe(Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_operators_switchMap__["a" /* switchMap */])(function (event) {
            var res = _this.getParsedResult(event.translations, key, interpolateParams);
            if (typeof res.subscribe === "function") {
                return res;
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_of__["a" /* of */])(res);
            }
        }))));
    };
    /**
     * Returns a translation instantly from the internal state of loaded translation.
     * All rules regarding the current language, the preferred language of even fallback languages will be used except any promise handling.
     * @param key
     * @param interpolateParams
     * @returns {string}
     */
    TranslateService.prototype.instant = function (key, interpolateParams) {
        if (!isDefined(key) || !key.length) {
            throw new Error("Parameter \"key\" required");
        }
        var res = this.getParsedResult(this.translations[this.currentLang], key, interpolateParams);
        if (typeof res.subscribe !== "undefined") {
            if (key instanceof Array) {
                var obj_1 = {};
                key.forEach(function (value, index) {
                    obj_1[key[index]] = key[index];
                });
                return obj_1;
            }
            return key;
        }
        else {
            return res;
        }
    };
    /**
     * Sets the translated value of a key, after compiling it
     * @param key
     * @param value
     * @param lang
     */
    TranslateService.prototype.set = function (key, value, lang) {
        if (lang === void 0) {
            lang = this.currentLang;
        }
        this.translations[lang][key] = this.compiler.compile(value, lang);
        this.updateLangs();
        this.onTranslationChange.emit({ lang: lang, translations: this.translations[lang] });
    };
    /**
     * Changes the current lang
     * @param lang
     */
    TranslateService.prototype.changeLang = function (lang) {
        this.currentLang = lang;
        this.onLangChange.emit({ lang: lang, translations: this.translations[lang] });
        // if there is no default lang, use the one that we just set
        if (!this.defaultLang) {
            this.changeDefaultLang(lang);
        }
    };
    /**
     * Changes the default lang
     * @param lang
     */
    TranslateService.prototype.changeDefaultLang = function (lang) {
        this.defaultLang = lang;
        this.onDefaultLangChange.emit({ lang: lang, translations: this.translations[lang] });
    };
    /**
     * Allows to reload the lang file from the file
     * @param lang
     * @returns {Observable<any>}
     */
    TranslateService.prototype.reloadLang = function (lang) {
        this.resetLang(lang);
        return this.getTranslation(lang);
    };
    /**
     * Deletes inner translation
     * @param lang
     */
    TranslateService.prototype.resetLang = function (lang) {
        this._translationRequests[lang] = undefined;
        this.translations[lang] = undefined;
    };
    /**
     * Returns the language code name from the browser, e.g. "de"
     *
     * @returns string
     */
    TranslateService.prototype.getBrowserLang = function () {
        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
            return undefined;
        }
        var browserLang = window.navigator.languages ? window.navigator.languages[0] : null;
        browserLang = browserLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
        if (browserLang.indexOf('-') !== -1) {
            browserLang = browserLang.split('-')[0];
        }
        if (browserLang.indexOf('_') !== -1) {
            browserLang = browserLang.split('_')[0];
        }
        return browserLang;
    };
    /**
     * Returns the culture language code name from the browser, e.g. "de-DE"
     *
     * @returns string
     */
    TranslateService.prototype.getBrowserCultureLang = function () {
        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
            return undefined;
        }
        var browserCultureLang = window.navigator.languages ? window.navigator.languages[0] : null;
        browserCultureLang = browserCultureLang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
        return browserCultureLang;
    };
    return TranslateService;
}());
TranslateService = __decorate$2([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __param(5, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(USE_DEFAULT_LANG)),
    __param(6, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(USE_STORE)),
    __metadata("design:paramtypes", [TranslateStore,
        TranslateLoader,
        TranslateCompiler,
        TranslateParser,
        MissingTranslationHandler, Boolean, Boolean])
], TranslateService);
var __decorate$6 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(k, v);
};
var TranslateDirective = /*@__PURE__*/ (function () {
    function TranslateDirective(translateService, element, _ref) {
        var _this = this;
        this.translateService = translateService;
        this.element = element;
        this._ref = _ref;
        // subscribe to onTranslationChange event, in case the translations of the current lang change
        if (!this.onTranslationChangeSub) {
            this.onTranslationChangeSub = this.translateService.onTranslationChange.subscribe(function (event) {
                if (event.lang === _this.translateService.currentLang) {
                    _this.checkNodes(true, event.translations);
                }
            });
        }
        // subscribe to onLangChange event, in case the language changes
        if (!this.onLangChangeSub) {
            this.onLangChangeSub = this.translateService.onLangChange.subscribe(function (event) {
                _this.checkNodes(true, event.translations);
            });
        }
        // subscribe to onDefaultLangChange event, in case the default language changes
        if (!this.onDefaultLangChangeSub) {
            this.onDefaultLangChangeSub = this.translateService.onDefaultLangChange.subscribe(function (event) {
                _this.checkNodes(true);
            });
        }
    }
    Object.defineProperty(TranslateDirective.prototype, "translate", {
        set: function (key) {
            if (key) {
                this.key = key;
                this.checkNodes();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslateDirective.prototype, "translateParams", {
        set: function (params) {
            if (!equals(this.currentParams, params)) {
                this.currentParams = params;
                this.checkNodes(true);
            }
        },
        enumerable: true,
        configurable: true
    });
    TranslateDirective.prototype.ngAfterViewChecked = function () {
        this.checkNodes();
    };
    TranslateDirective.prototype.checkNodes = function (forceUpdate, translations) {
        if (forceUpdate === void 0) {
            forceUpdate = false;
        }
        var nodes = this.element.nativeElement.childNodes;
        // if the element is empty
        if (!nodes.length) {
            // we add the key as content
            this.setContent(this.element.nativeElement, this.key);
            nodes = this.element.nativeElement.childNodes;
        }
        for (var i = 0; i < nodes.length; ++i) {
            var node = nodes[i];
            if (node.nodeType === 3) {
                var key = void 0;
                if (this.key) {
                    key = this.key;
                    if (forceUpdate) {
                        node.lastKey = null;
                    }
                }
                else {
                    var content = this.getContent(node).trim();
                    if (content.length) {
                        // we want to use the content as a key, not the translation value
                        if (content !== node.currentValue) {
                            key = content;
                            // the content was changed from the user, we'll use it as a reference if needed
                            node.originalContent = this.getContent(node);
                        }
                        else if (node.originalContent && forceUpdate) {
                            node.lastKey = null;
                            // the current content is the translation, not the key, use the last real content as key
                            key = node.originalContent.trim();
                        }
                    }
                }
                this.updateValue(key, node, translations);
            }
        }
    };
    TranslateDirective.prototype.updateValue = function (key, node, translations) {
        var _this = this;
        if (key) {
            if (node.lastKey === key && this.lastParams === this.currentParams) {
                return;
            }
            this.lastParams = this.currentParams;
            var onTranslation = function (res) {
                if (res !== key) {
                    node.lastKey = key;
                }
                if (!node.originalContent) {
                    node.originalContent = _this.getContent(node);
                }
                node.currentValue = isDefined(res) ? res : (node.originalContent || key);
                // we replace in the original content to preserve spaces that we might have trimmed
                _this.setContent(node, _this.key ? node.currentValue : node.originalContent.replace(key, node.currentValue));
                _this._ref.markForCheck();
            };
            if (isDefined(translations)) {
                var res = this.translateService.getParsedResult(translations, key, this.currentParams);
                if (typeof res.subscribe === "function") {
                    res.subscribe(onTranslation);
                }
                else {
                    onTranslation(res);
                }
            }
            else {
                this.translateService.get(key, this.currentParams).subscribe(onTranslation);
            }
        }
    };
    TranslateDirective.prototype.getContent = function (node) {
        return isDefined(node.textContent) ? node.textContent : node.data;
    };
    TranslateDirective.prototype.setContent = function (node, content) {
        if (isDefined(node.textContent)) {
            node.textContent = content;
        }
        else {
            node.data = content;
        }
    };
    TranslateDirective.prototype.ngOnDestroy = function () {
        if (this.onLangChangeSub) {
            this.onLangChangeSub.unsubscribe();
        }
        if (this.onDefaultLangChangeSub) {
            this.onDefaultLangChangeSub.unsubscribe();
        }
        if (this.onTranslationChangeSub) {
            this.onTranslationChangeSub.unsubscribe();
        }
    };
    return TranslateDirective;
}());
__decorate$6([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata$1("design:type", String),
    __metadata$1("design:paramtypes", [String])
], TranslateDirective.prototype, "translate", null);
__decorate$6([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"])(),
    __metadata$1("design:type", Object),
    __metadata$1("design:paramtypes", [Object])
], TranslateDirective.prototype, "translateParams", null);
TranslateDirective = __decorate$6([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"])({
        selector: '[translate],[ngx-translate]'
    }),
    __metadata$1("design:paramtypes", [TranslateService, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
], TranslateDirective);
var __decorate$7 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$2 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(k, v);
};
var TranslatePipe = /*@__PURE__*/ (function () {
    function TranslatePipe(translate, _ref) {
        this.translate = translate;
        this._ref = _ref;
        this.value = '';
    }
    TranslatePipe.prototype.updateValue = function (key, interpolateParams, translations) {
        var _this = this;
        var onTranslation = function (res) {
            _this.value = res !== undefined ? res : key;
            _this.lastKey = key;
            _this._ref.markForCheck();
        };
        if (translations) {
            var res = this.translate.getParsedResult(translations, key, interpolateParams);
            if (typeof res.subscribe === 'function') {
                res.subscribe(onTranslation);
            }
            else {
                onTranslation(res);
            }
        }
        this.translate.get(key, interpolateParams).subscribe(onTranslation);
    };
    TranslatePipe.prototype.transform = function (query) {
        var _this = this;
        var args = [];
        for (var _b = 1; _b < arguments.length; _b++) {
            args[_b - 1] = arguments[_b];
        }
        if (!query || query.length === 0) {
            return query;
        }
        // if we ask another time for the same key, return the last value
        if (equals(query, this.lastKey) && equals(args, this.lastParams)) {
            return this.value;
        }
        var interpolateParams;
        if (isDefined(args[0]) && args.length) {
            if (typeof args[0] === 'string' && args[0].length) {
                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
                var validArgs = args[0]
                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
                try {
                    interpolateParams = JSON.parse(validArgs);
                }
                catch (e) {
                    throw new SyntaxError("Wrong parameter in TranslatePipe. Expected a valid Object, received: " + args[0]);
                }
            }
            else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
                interpolateParams = args[0];
            }
        }
        // store the query, in case it changes
        this.lastKey = query;
        // store the params, in case they change
        this.lastParams = args;
        // set the value
        this.updateValue(query, interpolateParams);
        // if there is a subscription to onLangChange, clean it
        this._dispose();
        // subscribe to onTranslationChange event, in case the translations change
        if (!this.onTranslationChange) {
            this.onTranslationChange = this.translate.onTranslationChange.subscribe(function (event) {
                if (_this.lastKey && event.lang === _this.translate.currentLang) {
                    _this.lastKey = null;
                    _this.updateValue(query, interpolateParams, event.translations);
                }
            });
        }
        // subscribe to onLangChange event, in case the language changes
        if (!this.onLangChange) {
            this.onLangChange = this.translate.onLangChange.subscribe(function (event) {
                if (_this.lastKey) {
                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
                    _this.updateValue(query, interpolateParams, event.translations);
                }
            });
        }
        // subscribe to onDefaultLangChange event, in case the default language changes
        if (!this.onDefaultLangChange) {
            this.onDefaultLangChange = this.translate.onDefaultLangChange.subscribe(function () {
                if (_this.lastKey) {
                    _this.lastKey = null; // we want to make sure it doesn't return the same value until it's been updated
                    _this.updateValue(query, interpolateParams);
                }
            });
        }
        return this.value;
    };
    /**
     * Clean any existing subscription to change events
     * @private
     */
    TranslatePipe.prototype._dispose = function () {
        if (typeof this.onTranslationChange !== 'undefined') {
            this.onTranslationChange.unsubscribe();
            this.onTranslationChange = undefined;
        }
        if (typeof this.onLangChange !== 'undefined') {
            this.onLangChange.unsubscribe();
            this.onLangChange = undefined;
        }
        if (typeof this.onDefaultLangChange !== 'undefined') {
            this.onDefaultLangChange.unsubscribe();
            this.onDefaultLangChange = undefined;
        }
    };
    TranslatePipe.prototype.ngOnDestroy = function () {
        this._dispose();
    };
    return TranslatePipe;
}());
TranslatePipe = __decorate$7([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"])({
        name: 'translate',
        pure: false // required to update the value when the promise is resolved
    }),
    __metadata$2("design:paramtypes", [TranslateService, __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"]])
], TranslatePipe);
var __decorate = /*@__PURE__*/ __webpack_require__("TToO").__decorate;
var TranslateModule = TranslateModule_1 = (function () {
    function TranslateModule() {
    }
    /**
     * Use this method in your root module to provide the TranslateService
     * @param {TranslateModuleConfig} config
     * @returns {ModuleWithProviders}
     */
    TranslateModule.forRoot = function (config) {
        if (config === void 0) {
            config = {};
        }
        return {
            ngModule: TranslateModule_1,
            providers: [
                config.loader || { provide: TranslateLoader, useClass: TranslateFakeLoader },
                config.compiler || { provide: TranslateCompiler, useClass: TranslateFakeCompiler },
                config.parser || { provide: TranslateParser, useClass: TranslateDefaultParser },
                config.missingTranslationHandler || { provide: MissingTranslationHandler, useClass: FakeMissingTranslationHandler },
                TranslateStore,
                { provide: USE_STORE, useValue: config.isolate },
                { provide: USE_DEFAULT_LANG, useValue: config.useDefaultLang },
                TranslateService
            ]
        };
    };
    /**
     * Use this method in your other (non root) modules to import the directive/pipe
     * @param {TranslateModuleConfig} config
     * @returns {ModuleWithProviders}
     */
    TranslateModule.forChild = function (config) {
        if (config === void 0) {
            config = {};
        }
        return {
            ngModule: TranslateModule_1,
            providers: [
                config.loader || { provide: TranslateLoader, useClass: TranslateFakeLoader },
                config.compiler || { provide: TranslateCompiler, useClass: TranslateFakeCompiler },
                config.parser || { provide: TranslateParser, useClass: TranslateDefaultParser },
                config.missingTranslationHandler || { provide: MissingTranslationHandler, useClass: FakeMissingTranslationHandler },
                { provide: USE_STORE, useValue: config.isolate },
                { provide: USE_DEFAULT_LANG, useValue: config.useDefaultLang },
                TranslateService
            ]
        };
    };
    return TranslateModule;
}());
var TranslateModule_1;
/**
 * Generated bundle index. Do not edit.
 */





/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "YXlc":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        ss :'aayá %d',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),

/***/ "YeCl":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("CW5P"),
    mapCacheDelete = __webpack_require__("A9mX"),
    mapCacheGet = __webpack_require__("v8Dt"),
    mapCacheHas = __webpack_require__("agim"),
    mapCacheSet = __webpack_require__("Dv2r");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "YgML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArray; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map


/***/ }),

/***/ "YkxI":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("wSKX"),
    overRest = __webpack_require__("Q2wK"),
    setToString = __webpack_require__("WHce");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "YsVG":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("z4hc"),
    baseUnary = __webpack_require__("S7p9"),
    nodeUtil = __webpack_require__("Dc0G");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "Z2pD":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dCZQ");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "ZD0O":
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__("CHen"),
    hasIn = __webpack_require__("RfZv");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),

/***/ "ZFGz":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        ss: '%d eiliad',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),

/***/ "ZGh9":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "ZT2e":
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__("o2mx");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "ZUyn":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日dddd HH:mm',
        l : 'YYYY/M/D',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        ss : '%d 秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),

/***/ "Zk5a":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "ZoSI":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),

/***/ "a5nY":
/***/ (function(module, exports) {

var ALPHA_INDEX = {
    '&lt': '<',
    '&gt': '>',
    '&quot': '"',
    '&apos': '\'',
    '&amp': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': '\'',
    '&amp;': '&'
};

var CHAR_INDEX = {
    60: 'lt',
    62: 'gt',
    34: 'quot',
    39: 'apos',
    38: 'amp'
};

var CHAR_S_INDEX = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&apos;',
    '&': '&amp;'
};

/**
 * @constructor
 */
function XmlEntities() {}

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encode = function(str) {
    if (!str || !str.length) {
        return '';
    }
    return str.replace(/<|>|"|'|&/g, function(s) {
        return CHAR_S_INDEX[s];
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
 XmlEntities.encode = function(str) {
    return new XmlEntities().encode(str);
 };

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.decode = function(str) {
    if (!str || !str.length) {
        return '';
    }
    return str.replace(/&#?[0-9a-zA-Z]+;?/g, function(s) {
        if (s.charAt(1) === '#') {
            var code = s.charAt(2).toLowerCase() === 'x' ?
                parseInt(s.substr(3), 16) :
                parseInt(s.substr(2));

            if (isNaN(code) || code < -32768 || code > 65535) {
                return '';
            }
            return String.fromCharCode(code);
        }
        return ALPHA_INDEX[s] || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
 XmlEntities.decode = function(str) {
    return new XmlEntities().decode(str);
 };

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encodeNonUTF = function(str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        var alpha = CHAR_INDEX[c];
        if (alpha) {
            result += "&" + alpha + ";";
            i++;
            continue;
        }
        if (c < 32 || c > 126) {
            result += '&#' + c + ';';
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
 XmlEntities.encodeNonUTF = function(str) {
    return new XmlEntities().encodeNonUTF(str);
 };

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encodeNonASCII = function(str) {
    if (!str || !str.length) {
        return '';
    }
    var strLenght = str.length;
    var result = '';
    var i = 0;
    while (i < strLenght) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
 XmlEntities.encodeNonASCII = function(str) {
    return new XmlEntities().encodeNonASCII(str);
 };

module.exports = XmlEntities;


/***/ }),

/***/ "aCM0":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn"),
    getRawTag = __webpack_require__("uLhX"),
    objectToString = __webpack_require__("+66z");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "aM0x":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        ss : '%d সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),

/***/ "aQOO":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "agim":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("pTUa");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "ai7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObject;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x != null && typeof x === 'object';
}
//# sourceMappingURL=isObject.js.map


/***/ }),

/***/ "alQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToIterable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_iterator__ = /*@__PURE__*/__webpack_require__("uOsm");
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */

var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator = iterable[__WEBPACK_IMPORTED_MODULE_0__symbol_iterator__["a" /* iterator */]]();
        do {
            var item = iterator.next();
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        // Finalize the iterator if it happens to be a Generator
        if (typeof iterator.return === 'function') {
            subscriber.add(function () {
                if (iterator.return) {
                    iterator.return();
                }
            });
        }
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToIterable.js.map


/***/ }),

/***/ "aqvp":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'ss':
            if (number === 1) {
                result += 'sekunda';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sekunde';
            } else {
                result += 'sekundi';
            }
            return result;
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        ss     : translate,
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),

/***/ "b2EL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_subscribeToArray__ = /*@__PURE__*/__webpack_require__("9hho");
/** PURE_IMPORTS_START _Observable,_Subscription,_util_subscribeToArray PURE_IMPORTS_END */



function fromArray(input, scheduler) {
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_2__util_subscribeToArray__["a" /* subscribeToArray */])(input));
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            var i = 0;
            sub.add(scheduler.schedule(function () {
                if (i === input.length) {
                    subscriber.complete();
                    return;
                }
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    sub.add(this.schedule());
                }
            }));
            return sub;
        });
    }
}
//# sourceMappingURL=fromArray.js.map


/***/ }),

/***/ "bGc4":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("gGqR"),
    isLength = __webpack_require__("Rh28");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "bHqE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var common_1 = __webpack_require__("wTuo");
var core_1 = __webpack_require__("TdOr");
var mention_directive_1 = __webpack_require__("54GR");
var mention_list_component_1 = __webpack_require__("vFoO");
var MentionModule = /*@__PURE__*/ (function () {
    function MentionModule() {
    }
    MentionModule.forRoot = function () {
        return {
            ngModule: MentionModule
        };
    };
    MentionModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [
                        common_1.CommonModule
                    ],
                    exports: [
                        mention_directive_1.MentionDirective,
                        mention_list_component_1.MentionListComponent
                    ],
                    entryComponents: [
                        mention_list_component_1.MentionListComponent
                    ],
                    declarations: [
                        mention_directive_1.MentionDirective,
                        mention_list_component_1.MentionListComponent
                    ]
                },] },
    ];
    return MentionModule;
}());
exports.MentionModule = MentionModule;



/***/ }),

/***/ "bIbi":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD"),
    root = __webpack_require__("TQ3y");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "bIjD":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("NGEn"),
    isKey = __webpack_require__("hIPy"),
    stringToPath = __webpack_require__("UnLw"),
    toString = __webpack_require__("ZT2e");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "bJWQ":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("duB3"),
    stackClear = __webpack_require__("KmWZ"),
    stackDelete = __webpack_require__("NqZt"),
    stackGet = __webpack_require__("E4Hj"),
    stackHas = __webpack_require__("G2xm"),
    stackSet = __webpack_require__("zpVT");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "bO0Y":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD"),
    root = __webpack_require__("TQ3y");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "bOhj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFunction;
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
    return typeof x === 'function';
}
//# sourceMappingURL=isFunction.js.map


/***/ }),

/***/ "bV3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__["map"]; });

//# sourceMappingURL=map.js.map

/***/ }),

/***/ "bXQP":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),

/***/ "bdRZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Immediate; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var nextHandle = 1;
var tasksByHandle = {};
function runIfPresent(handle) {
    var cb = tasksByHandle[handle];
    if (cb) {
        cb();
    }
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        tasksByHandle[handle] = cb;
        Promise.resolve().then(function () { return runIfPresent(handle); });
        return handle;
    },
    clearImmediate: function (handle) {
        delete tasksByHandle[handle];
    },
};
//# sourceMappingURL=Immediate.js.map


/***/ }),

/***/ "blYT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "bqNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeToPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hostReportError__ = /*@__PURE__*/__webpack_require__("BdDE");
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */

var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, __WEBPACK_IMPORTED_MODULE_0__hostReportError__["a" /* hostReportError */]);
        return subscriber;
    };
};
//# sourceMappingURL=subscribeToPromise.js.map


/***/ }),

/***/ "bx9F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* From: https://github.com/component/textarea-caret-position */
/* jshint browser: true */

// The properties that we copy into a mirrored div.
// Note that some browsers, such as Firefox,
// do not concatenate properties, i.e. padding-top, bottom etc. -> padding,
// so we have to do every single property specifically.
var properties = [
    'direction',
    'boxSizing',
    'width',
    'height',
    'overflowX',
    'overflowY',
    'borderTopWidth',
    'borderRightWidth',
    'borderBottomWidth',
    'borderLeftWidth',
    'borderStyle',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    // https://developer.mozilla.org/en-US/docs/Web/CSS/font
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'fontStretch',
    'fontSize',
    'fontSizeAdjust',
    'lineHeight',
    'fontFamily',
    'textAlign',
    'textTransform',
    'textIndent',
    'textDecoration',
    'letterSpacing',
    'wordSpacing',
    'tabSize',
    'MozTabSize'
];
var isBrowser = (typeof window !== 'undefined');
var isFirefox = (isBrowser && window.mozInnerScreenX != null);
function getCaretCoordinates(element, position, options) {
    if (options === void 0) { options = null; }
    if (!isBrowser) {
        throw new Error('textarea-caret-position#getCaretCoordinates should only be called in a browser');
    }
    var debug = options && options.debug || false;
    if (debug) {
        var el = document.querySelector('#input-textarea-caret-position-mirror-div');
        if (el) {
            el.parentNode.removeChild(el);
        }
    }
    // mirrored div
    var div = document.createElement('div');
    div.id = 'input-textarea-caret-position-mirror-div';
    document.body.appendChild(div);
    var style = div.style;
    var computed = window.getComputedStyle ? getComputedStyle(element) : element.currentStyle; // currentStyle for IE < 9
    // default textarea styles
    style.whiteSpace = 'pre-wrap';
    if (element.nodeName !== 'INPUT')
        style.wordWrap = 'break-word'; // only for textarea-s
    // position off-screen
    style.position = 'absolute'; // required to return coordinates properly
    if (!debug)
        style.visibility = 'hidden'; // not 'display: none' because we want rendering
    // transfer the element's properties to the div
    properties.forEach(function (prop) {
        style[prop] = computed[prop];
    });
    if (isFirefox) {
        // Firefox lies about the overflow property for textareas: https://bugzilla.mozilla.org/show_bug.cgi?id=984275
        if (element.scrollHeight > parseInt(computed.height))
            style.overflowY = 'scroll';
    }
    else {
        style.overflow = 'hidden'; // for Chrome to not render a scrollbar; IE keeps overflowY = 'scroll'
    }
    div.textContent = element.value.substring(0, position);
    // the second special handling for input type="text" vs textarea: spaces need to be replaced with non-breaking spaces - http://stackoverflow.com/a/13402035/1269037
    if (element.nodeName === 'INPUT')
        div.textContent = div.textContent.replace(/\s/g, '\u00a0');
    var span = document.createElement('span');
    // Wrapping must be replicated *exactly*, including when a long word gets
    // onto the next line, with whitespace at the end of the line before (#7).
    // The  *only* reliable way to do that is to copy the *entire* rest of the
    // textarea's content into the <span> created at the caret position.
    // for inputs, just '.' would be enough, but why bother?
    span.textContent = element.value.substring(position) || '.'; // || because a completely empty faux span doesn't render at all
    div.appendChild(span);
    var coordinates = {
        top: span.offsetTop + parseInt(computed['borderTopWidth']),
        left: span.offsetLeft + parseInt(computed['borderLeftWidth'])
    };
    if (debug) {
        span.style.backgroundColor = '#aaa';
    }
    else {
        document.body.removeChild(div);
    }
    return coordinates;
}
exports.getCaretCoordinates = getCaretCoordinates;
// if (typeof module != 'undefined' && typeof module.exports != 'undefined') {
//   module.exports = getCaretCoordinates;
// } else if(isBrowser){
//   window.getCaretCoordinates = getCaretCoordinates;
// }


/***/ }),

/***/ "c1x4":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['секунда', 'секунде', 'секунди'],
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),

/***/ "cCSk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = /*@__PURE__*/__webpack_require__("QX4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isNumeric__ = /*@__PURE__*/__webpack_require__("03ca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isScheduler__ = /*@__PURE__*/__webpack_require__("5eyr");
/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */




/**
 * Creates an Observable that starts emitting after an `initialDelay` and
 * emits ever increasing numbers after each `period` of time thereafter.
 *
 * <span class="informal">Its like {@link interval}, but you can specify when
 * should the emissions start.</span>
 *
 * <img src="./img/timer.png" width="100%">
 *
 * `timer` returns an Observable that emits an infinite sequence of ascending
 * integers, with a constant interval of time, `period` of your choosing
 * between those emissions. The first emission happens after the specified
 * `initialDelay`. The initial delay may be a {@link Date}. By default, this
 * operator uses the `async` IScheduler to provide a notion of time, but you
 * may pass any IScheduler to it. If `period` is not specified, the output
 * Observable emits only one value, `0`. Otherwise, it emits an infinite
 * sequence.
 *
 * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
 * var numbers = Rx.Observable.timer(3000, 1000);
 * numbers.subscribe(x => console.log(x));
 *
 * @example <caption>Emits one number after five seconds</caption>
 * var numbers = Rx.Observable.timer(5000);
 * numbers.subscribe(x => console.log(x));
 *
 * @see {@link interval}
 * @see {@link delay}
 *
 * @param {number|Date} [dueTime] The initial delay time to wait before
 * emitting the first value of `0`.
 * @param {number|SchedulerLike} [periodOrScheduler] The period of time between emissions of the
 * subsequent numbers.
 * @param {SchedulerLike} [scheduler=async] The IScheduler to use for scheduling
 * the emission of values, and providing a notion of "time".
 * @return {Observable} An Observable that emits a `0` after the
 * `initialDelay` and ever increasing numbers after each `period` of time
 * thereafter.
 * @static true
 * @name timer
 * @owner Observable
 */
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    var period = -1;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isNumeric__["a" /* isNumeric */])(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!Object(__WEBPACK_IMPORTED_MODULE_3__util_isScheduler__["a" /* isScheduler */])(scheduler)) {
        scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */];
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var due = Object(__WEBPACK_IMPORTED_MODULE_2__util_isNumeric__["a" /* isNumeric */])(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(dispatch, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}
//# sourceMappingURL=timer.js.map


/***/ }),

/***/ "cdq7":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ "d+aQ":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("hbAh"),
    getMatchData = __webpack_require__("16tV"),
    matchesStrictComparable = __webpack_require__("sJvV");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "d3Hm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__["merge"]; });

//# sourceMappingURL=merge.js.map

/***/ }),

/***/ "d4US":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD"),
    root = __webpack_require__("TQ3y");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "dCZQ":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "dFpP":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("imBK");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "dURR":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),

/***/ "dYhQ":
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__("9UkZ");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ "deUO":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("imBK");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "dfzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return subscribeTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subscribeToArray__ = /*@__PURE__*/__webpack_require__("9hho");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subscribeToPromise__ = /*@__PURE__*/__webpack_require__("bqNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subscribeToIterable__ = /*@__PURE__*/__webpack_require__("alQS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscribeToObservable__ = /*@__PURE__*/__webpack_require__("JzXe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArrayLike__ = /*@__PURE__*/__webpack_require__("6iAM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPromise__ = /*@__PURE__*/__webpack_require__("XTlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isObject__ = /*@__PURE__*/__webpack_require__("ai7y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol_iterator__ = /*@__PURE__*/__webpack_require__("uOsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__symbol_observable__ = /*@__PURE__*/__webpack_require__("V9Cg");
/** PURE_IMPORTS_START _Observable,_subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */










var subscribeTo = function (result) {
    if (result instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */]) {
        return function (subscriber) {
            if (result._isScalar) {
                subscriber.next(result.value);
                subscriber.complete();
                return undefined;
            }
            else {
                return result.subscribe(subscriber);
            }
        };
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_5__isArrayLike__["a" /* isArrayLike */])(result)) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__subscribeToArray__["a" /* subscribeToArray */])(result);
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_6__isPromise__["a" /* isPromise */])(result)) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__subscribeToPromise__["a" /* subscribeToPromise */])(result);
    }
    else if (result && typeof result[__WEBPACK_IMPORTED_MODULE_8__symbol_iterator__["a" /* iterator */]] === 'function') {
        return Object(__WEBPACK_IMPORTED_MODULE_3__subscribeToIterable__["a" /* subscribeToIterable */])(result);
    }
    else if (result && typeof result[__WEBPACK_IMPORTED_MODULE_9__symbol_observable__["a" /* observable */]] === 'function') {
        return Object(__WEBPACK_IMPORTED_MODULE_4__subscribeToObservable__["a" /* subscribeToObservable */])(result);
    }
    else {
        var value = Object(__WEBPACK_IMPORTED_MODULE_7__isObject__["a" /* isObject */])(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};
//# sourceMappingURL=subscribeTo.js.map


/***/ }),

/***/ "dmQx":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "duB3":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("WxI4"),
    listCacheDelete = __webpack_require__("dFpP"),
    listCacheGet = __webpack_require__("JBvZ"),
    listCacheHas = __webpack_require__("2Hvv"),
    listCacheSet = __webpack_require__("deUO");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "dyB6":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),

/***/ "e/KL":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        ss : '%d s~écóñ~ds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),

/***/ "e5i8":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("HbnZ"),
    isObject = __webpack_require__("yCNF");

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),

/***/ "eBB/":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '일';
            case 'M':
                return number + '월';
            case 'w':
            case 'W':
                return number + '주';
            default:
                return number;
        }
    },
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),

/***/ "eFps":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("+gg+");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "eG8/":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "eHwN":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        ss : '%d saniyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),

/***/ "eHwr":
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__("JyYQ"),
    isArrayLike = __webpack_require__("bGc4"),
    keys = __webpack_require__("ktak");

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ "eKBv":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("YDHx"),
    get = __webpack_require__("Q7hp"),
    hasIn = __webpack_require__("RfZv"),
    isKey = __webpack_require__("hIPy"),
    isStrictComparable = __webpack_require__("tO4o"),
    matchesStrictComparable = __webpack_require__("sJvV"),
    toKey = __webpack_require__("Ubhr");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "eVIm":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("dCZQ");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "eYUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pipe;
/* harmony export (immutable) */ __webpack_exports__["b"] = pipeFromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = /*@__PURE__*/__webpack_require__("VWaN");
/** PURE_IMPORTS_START _noop PURE_IMPORTS_END */

/* tslint:enable:max-line-length */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
/* @internal */
function pipeFromArray(fns) {
    if (!fns) {
        return __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* noop */];
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map


/***/ }),

/***/ "f1Eh":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "f4W3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekunda', 'sekunde', 'sekundi'],
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),

/***/ "f931":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "fC4T":
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ "fMqj":
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__("zGZ6");

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ "fW1y":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        ss : '%d سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),

/***/ "fYOR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (immutable) */ __webpack_exports__["main"] = main;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_environment__ = __webpack_require__("S/3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angularclass_hmr__ = __webpack_require__("NTqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angularclass_hmr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__angularclass_hmr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_app_module_ngfactory__ = __webpack_require__("O83F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = /*@__PURE__*/__webpack_require__("5D2H");




/**
 * Bootstrap our Angular app with a top level NgModule
 */
function main() {
    return __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["j" /* platformBrowser */]()
        .bootstrapModuleFactory(__WEBPACK_IMPORTED_MODULE_2__app_app_module_ngfactory__["a" /* AppModuleNgFactory */])
        .then(__WEBPACK_IMPORTED_MODULE_0__app_environment__["a" /* environment */].decorateModuleRef)
        .then(function (ngModuleRef) {
        // `module` global ref for webpackhmr
        // Don't run this in Prod
        return Object(__WEBPACK_IMPORTED_MODULE_1__angularclass_hmr__["hmrModule"])(ngModuleRef, module);
    })
        .catch(function (err) { return console.error(err); });
}
/**
 * Needed for hmr
 * in prod this is replace for document ready
 */
switch (document.readyState) {
    case 'loading':
        document.addEventListener('DOMContentLoaded', _domReadyHandler, false);
        break;
    case 'interactive':
    case 'complete':
    default:
        main();
}
function _domReadyHandler() {
    document.removeEventListener('DOMContentLoaded', _domReadyHandler, false);
    main();
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "g7KF":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        ss : '%d sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),

/***/ "g8cW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Scheduler__ = /*@__PURE__*/__webpack_require__("Wubi");
/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */


var AsyncScheduler = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = __WEBPACK_IMPORTED_MODULE_1__Scheduler__["a" /* Scheduler */].now;
        }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         * @deprecated internal use only
         */
        _this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         * @deprecated internal use only
         */
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__Scheduler__["a" /* Scheduler */]));






/***/ }),

/***/ "gBXS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// DOM element manipulation functions...
//

function setValue(el, value) {
    //console.log("setValue", el.nodeName, "["+value+"]");
    if (isInputOrTextAreaElement(el)) {
        el.value = value;
    }
    else {
        el.textContent = value;
    }
}
function getValue(el) {
    return isInputOrTextAreaElement(el) ? el.value : el.textContent;
}
exports.getValue = getValue;
function insertValue(el, start, end, text, iframe, noRecursion) {
    if (noRecursion === void 0) { noRecursion = false; }
    //console.log("insertValue", el.nodeName, start, end, "["+text+"]", el);
    if (isTextElement(el)) {
        var val = getValue(el);
        setValue(el, val.substring(0, start) + text + val.substring(end, val.length));
        setCaretPosition(el, start + text.length, iframe);
    }
    else if (!noRecursion) {
        var selObj = getWindowSelection(iframe);
        if (selObj && selObj.rangeCount > 0) {
            var selRange = selObj.getRangeAt(0);
            var position = selRange.startOffset;
            var anchorNode = selObj.anchorNode;
            // if (text.endsWith(' ')) {
            //   text = text.substring(0, text.length-1) + '\xA0';
            // }
            insertValue(anchorNode, position - (end - start), position, text, iframe, true);
        }
    }
}
exports.insertValue = insertValue;
function isInputOrTextAreaElement(el) {
    return el != null && (el.nodeName == 'INPUT' || el.nodeName == 'TEXTAREA');
}
exports.isInputOrTextAreaElement = isInputOrTextAreaElement;
;
function isTextElement(el) {
    return el != null && (el.nodeName == 'INPUT' || el.nodeName == 'TEXTAREA' || el.nodeName == '#text');
}
exports.isTextElement = isTextElement;
;
function setCaretPosition(el, pos, iframe) {
    if (iframe === void 0) { iframe = null; }
    //console.log("setCaretPosition", pos, el, iframe==null);
    if (isInputOrTextAreaElement(el) && el.selectionStart) {
        el.focus();
        el.setSelectionRange(pos, pos);
    }
    else {
        var range = getDocument(iframe).createRange();
        range.setStart(el, pos);
        range.collapse(true);
        var sel = getWindowSelection(iframe);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
exports.setCaretPosition = setCaretPosition;
function getCaretPosition(el, iframe) {
    if (iframe === void 0) { iframe = null; }
    //console.log("getCaretPosition", el);
    if (isInputOrTextAreaElement(el)) {
        var val = el.value;
        return val.slice(0, el.selectionStart).length;
    }
    else {
        var selObj = getWindowSelection(iframe); //window.getSelection();
        if (selObj.rangeCount > 0) {
            var selRange = selObj.getRangeAt(0);
            var position = selRange.startOffset;
            return position;
        }
    }
}
exports.getCaretPosition = getCaretPosition;
// Based on ment.io functions...
//
function getDocument(iframe) {
    if (!iframe) {
        return document;
    }
    else {
        return iframe.contentWindow.document;
    }
}
function getWindowSelection(iframe) {
    if (!iframe) {
        return window.getSelection();
    }
    else {
        return iframe.contentWindow.getSelection();
    }
}
function getContentEditableCaretCoords(ctx) {
    var markerTextChar = '\ufeff';
    var markerId = 'sel_' + new Date().getTime() + '_' + Math.random().toString().substr(2);
    var doc = getDocument(ctx ? ctx.iframe : null);
    var sel = getWindowSelection(ctx ? ctx.iframe : null);
    var prevRange = sel.getRangeAt(0);
    // create new range and set postion using prevRange
    var range = doc.createRange();
    range.setStart(sel.anchorNode, prevRange.startOffset);
    range.setEnd(sel.anchorNode, prevRange.startOffset);
    range.collapse(false);
    // Create the marker element containing a single invisible character
    // using DOM methods and insert it at the position in the range
    var markerEl = doc.createElement('span');
    markerEl.id = markerId;
    markerEl.appendChild(doc.createTextNode(markerTextChar));
    range.insertNode(markerEl);
    sel.removeAllRanges();
    sel.addRange(prevRange);
    var coordinates = {
        left: 0,
        top: markerEl.offsetHeight
    };
    localToRelativeCoordinates(ctx, markerEl, coordinates);
    markerEl.parentNode.removeChild(markerEl);
    return coordinates;
}
exports.getContentEditableCaretCoords = getContentEditableCaretCoords;
function localToRelativeCoordinates(ctx, element, coordinates) {
    var obj = element;
    var iframe = ctx ? ctx.iframe : null;
    while (obj) {
        if (ctx.parent != null && ctx.parent == obj) {
            break;
        }
        coordinates.left += obj.offsetLeft + obj.clientLeft;
        coordinates.top += obj.offsetTop + obj.clientTop;
        obj = obj.offsetParent;
        if (!obj && iframe) {
            obj = iframe;
            iframe = null;
        }
    }
    obj = element;
    iframe = ctx ? ctx.iframe : null;
    while (obj !== getDocument(null).body && obj != null) {
        if (ctx.parent != null && ctx.parent == obj) {
            break;
        }
        if (obj.scrollTop && obj.scrollTop > 0) {
            coordinates.top -= obj.scrollTop;
        }
        if (obj.scrollLeft && obj.scrollLeft > 0) {
            coordinates.left -= obj.scrollLeft;
        }
        obj = obj.parentNode;
        if (!obj && iframe) {
            obj = iframe;
            iframe = null;
        }
    }
}


/***/ }),

/***/ "gEQe":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        ss : '%d ಸೆಕೆಂಡುಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),

/***/ "gEU3":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        ss: '%d hēkona',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),

/***/ "gGqR":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObject = __webpack_require__("yCNF");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "gHOb":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("d4US"),
    Map = __webpack_require__("POb3"),
    Promise = __webpack_require__("bO0Y"),
    Set = __webpack_require__("5N57"),
    WeakMap = __webpack_require__("bIbi"),
    baseGetTag = __webpack_require__("aCM0"),
    toSource = __webpack_require__("Ai/T");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "gUgh":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        ss : 'minutu %d',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),

/***/ "ggOT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("TQ3y"),
    stubFalse = __webpack_require__("gwcX");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "gne3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConnectableObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connectableObservableDescriptor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = /*@__PURE__*/__webpack_require__("tUzZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operators_refCount__ = /*@__PURE__*/__webpack_require__("/qTI");
/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */






/**
 * @class ConnectableObservable<T>
 */
var ConnectableObservable = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        /** @internal */
        _this._isComplete = false;
        return _this;
    }
    /** @deprecated This is an internal implementation detail, do not use. */
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new __WEBPACK_IMPORTED_MODULE_4__Subscription__["a" /* Subscription */]();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = __WEBPACK_IMPORTED_MODULE_4__Subscription__["a" /* Subscription */].EMPTY;
            }
            else {
                this._connection = connection;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_5__operators_refCount__["a" /* refCount */])()(this);
    };
    return ConnectableObservable;
}(__WEBPACK_IMPORTED_MODULE_2__Observable__["a" /* Observable */]));

var connectableProto = ConnectableObservable.prototype;
var connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: true },
    _subject: { value: null, writable: true },
    _connection: { value: null, writable: true },
    _subscribe: { value: connectableProto._subscribe },
    _isComplete: { value: connectableProto._isComplete, writable: true },
    getSubject: { value: connectableProto.getSubject },
    connect: { value: connectableProto.connect },
    refCount: { value: connectableProto.refCount }
};
var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["c" /* SubjectSubscriber */]));
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));





/***/ }),

/***/ "gs2Y":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("8AZL"),
    baseRest = __webpack_require__("YkxI"),
    customDefaultsMerge = __webpack_require__("e5i8"),
    mergeWith = __webpack_require__("zMR/");

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),

/***/ "gwcX":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "hIPy":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("NGEn"),
    isSymbol = __webpack_require__("6MiT");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "hPuz":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        ss : '%d seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),

/***/ "hbAh":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("bJWQ"),
    baseIsEqual = __webpack_require__("YDHx");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "hng5":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

// Language contact person : Abdoufata Kane : https://github.com/abdoufata

var bm = moment.defineLocale('bm', {
    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'MMMM [tile] D [san] YYYY',
        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
    },
    calendar : {
        sameDay : '[Bi lɛrɛ] LT',
        nextDay : '[Sini lɛrɛ] LT',
        nextWeek : 'dddd [don lɛrɛ] LT',
        lastDay : '[Kunu lɛrɛ] LT',
        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s kɔnɔ',
        past : 'a bɛ %s bɔ',
        s : 'sanga dama dama',
        ss : 'sekondi %d',
        m : 'miniti kelen',
        mm : 'miniti %d',
        h : 'lɛrɛ kelen',
        hh : 'lɛrɛ %d',
        d : 'tile kelen',
        dd : 'tile %d',
        M : 'kalo kelen',
        MM : 'kalo %d',
        y : 'san kelen',
        yy : 'san %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return bm;

})));


/***/ }),

/***/ "hrPF":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "i4ON":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("nw3t"),
    eq = __webpack_require__("22B7");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "i6nN":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "iE7H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = /*@__PURE__*/ __webpack_require__("TToO").__decorate;
var __metadata = /*@__PURE__*/ __webpack_require__("TToO").__metadata;
var __param = /*@__PURE__*/ __webpack_require__("TToO").__param;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var forms_1 = __webpack_require__("B+Nj");
var common_1 = __webpack_require__("wTuo");
var InputText = /*@__PURE__*/ (function () {
    function InputText(el, ngModel) {
        this.el = el;
        this.ngModel = ngModel;
    }
    InputText.prototype.ngDoCheck = function () {
        this.updateFilledState();
    };
    //To trigger change detection to manage ui-state-filled for material labels when there is no value binding
    InputText.prototype.onInput = function (e) {
        this.updateFilledState();
    };
    InputText.prototype.updateFilledState = function () {
        this.filled = (this.el.nativeElement.value && this.el.nativeElement.value.length) ||
            (this.ngModel && this.ngModel.model);
    };
    __decorate([
        core_1.HostListener('input', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], InputText.prototype, "onInput", null);
    InputText = __decorate([
        core_1.Directive({
            selector: '[pInputText]',
            host: {
                '[class.ui-inputtext]': 'true',
                '[class.ui-corner-all]': 'true',
                '[class.ui-state-default]': 'true',
                '[class.ui-widget]': 'true',
                '[class.ui-state-filled]': 'filled'
            }
        }),
        __param(1, core_1.Optional())
    ], InputText);
    return InputText;
}());
exports.InputText = InputText;
var InputTextModule = /*@__PURE__*/ (function () {
    function InputTextModule() {
    }
    InputTextModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule],
            exports: [InputText],
            declarations: [InputText]
        })
    ], InputTextModule);
    return InputTextModule;
}());
exports.InputTextModule = InputTextModule;



/***/ }),

/***/ "iL3P":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("eG8/"),
    basePropertyDeep = __webpack_require__("3Did"),
    isKey = __webpack_require__("hIPy"),
    toKey = __webpack_require__("Ubhr");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "iNtv":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        ss : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'ss': [number + ' secunds', '' + number + ' secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),

/***/ "im1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = merge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isScheduler__ = /*@__PURE__*/__webpack_require__("5eyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_mergeAll__ = /*@__PURE__*/__webpack_require__("4jp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromArray__ = /*@__PURE__*/__webpack_require__("b2EL");
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */




/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isScheduler__["a" /* isScheduler */])(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */]) {
        return observables[0];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__operators_mergeAll__["a" /* mergeAll */])(concurrent)(Object(__WEBPACK_IMPORTED_MODULE_3__fromArray__["a" /* fromArray */])(observables, scheduler));
}
//# sourceMappingURL=merge.js.map


/***/ }),

/***/ "imBK":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("22B7");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "j+ls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = range;
/* unused harmony export dispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

/**
 * Creates an Observable that emits a sequence of numbers within a specified
 * range.
 *
 * <span class="informal">Emits a sequence of numbers in a range.</span>
 *
 * <img src="./img/range.png" width="100%">
 *
 * `range` operator emits a range of sequential integers, in order, where you
 * select the `start` of the range and its `length`. By default, uses no
 * IScheduler and just delivers the notifications synchronously, but may use
 * an optional IScheduler to regulate those deliveries.
 *
 * @example <caption>Emits the numbers 1 to 10</caption>
 * var numbers = Rx.Observable.range(1, 10);
 * numbers.subscribe(x => console.log(x));
 *
 * @see {@link timer}
 * @see {@link interval}
 *
 * @param {number} [start=0] The value of the first integer in the sequence.
 * @param {number} [count=0] The number of sequential integers to generate.
 * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
 * the emissions of the notifications.
 * @return {Observable} An Observable of numbers that emits a finite range of
 * sequential integers.
 * @static true
 * @name range
 * @owner Observable
 */
function range(start, count, scheduler) {
    if (start === void 0) {
        start = 0;
    }
    if (count === void 0) {
        count = 0;
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var index = 0;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(start++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
/** @internal */
function dispatch(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}
//# sourceMappingURL=range.js.map


/***/ }),

/***/ "j+vx":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        ss : '%d секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),

/***/ "j8cJ":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),

/***/ "jAXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = combineLatest;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CombineLatestOperator; });
/* unused harmony export CombineLatestSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isScheduler__ = /*@__PURE__*/__webpack_require__("5eyr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = /*@__PURE__*/__webpack_require__("YgML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = /*@__PURE__*/__webpack_require__("1E73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = /*@__PURE__*/__webpack_require__("3SjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fromArray__ = /*@__PURE__*/__webpack_require__("b2EL");
/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */






var NONE = {};
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = null;
    var scheduler = null;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isScheduler__["a" /* isScheduler */])(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], resultSelector)`
    if (observables.length === 1 && Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(observables[0])) {
        observables = observables[0];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_5__fromArray__["a" /* fromArray */])(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));






/***/ }),

/***/ "jD7S":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("tv3T"),
    keys = __webpack_require__("ktak");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "jHrt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__["take"]; });

//# sourceMappingURL=take.js.map

/***/ }),

/***/ "jMi8":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("O1jc"),
    cloneBuffer = __webpack_require__("mKB/"),
    cloneTypedArray = __webpack_require__("Ilb/"),
    copyArray = __webpack_require__("hrPF"),
    initCloneObject = __webpack_require__("WQFf"),
    isArguments = __webpack_require__("1Yb9"),
    isArray = __webpack_require__("NGEn"),
    isArrayLikeObject = __webpack_require__("Fp5l"),
    isBuffer = __webpack_require__("ggOT"),
    isFunction = __webpack_require__("gGqR"),
    isObject = __webpack_require__("yCNF"),
    isPlainObject = __webpack_require__("9UkZ"),
    isTypedArray = __webpack_require__("YsVG"),
    toPlainObject = __webpack_require__("TlPD");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "jxEH":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        ss : relativeTimeWithPlural,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),

/***/ "k+5o":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[gelecek] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        ss : '%d saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),

/***/ "kbi+":
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__("eHwr"),
    findIndex = __webpack_require__("KgVm");

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ "kk5+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnsubscriptionError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */

/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        var _this = _super.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '') || this;
        _this.errors = errors;
        _this.name = 'UnsubscriptionError';
        Object.setPrototypeOf(_this, UnsubscriptionError.prototype);
        return _this;
    }
    return UnsubscriptionError;
}(Error));






/***/ }),

/***/ "krPU":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        ss : '%d imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),

/***/ "ktak":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("7e4z"),
    baseKeys = __webpack_require__("/GnY"),
    isArrayLike = __webpack_require__("bGc4");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "ktnU":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("Hxdr");

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ "kxzG":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF"),
    isSymbol = __webpack_require__("6MiT");

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ "l9Lx":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("lb6C"),
    stubArray = __webpack_require__("C0hh");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "lDdF":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__("LGuY") !== null) && (__webpack_require__("nErl") !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),

/***/ "lKpf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
/**
 * The global configuration object for RxJS, used to configure things
 * like what Promise contructor should used to create Promises
 */
var config = {
    /**
     * The promise constructor used by default for methods such as
     * {@link toPromise} and {@link forEach}
     */
    Promise: undefined,
    /**
     * If true, turns on synchronous error rethrowing, which is a deprecated behavior
     * in v6 and higher. This behavior enables bad patterns like wrapping a subscribe
     * call in a try/catch block. It also enables producer interference, a nasty bug
     * where a multicast can be broken for all observers by a downstream consumer with
     * an unhandled error. DO NOT USE THIS FLAG UNLESS IT'S NEEDED TO BY TIME
     * FOR MIGRATION REASONS.
     */
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        else if (_enable_super_gross_mode_that_will_cause_bad_things) {
            /*@__PURE__*/ console.log('RxJS: Back to a better error behavior. Thank you. <3');
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};
//# sourceMappingURL=config.js.map


/***/ }),

/***/ "lOED":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        ss : '%d секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),

/***/ "lWPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_toSubscriber__ = /*@__PURE__*/__webpack_require__("SAuu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_symbol_observable__ = /*@__PURE__*/__webpack_require__("V9Cg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_pipe__ = /*@__PURE__*/__webpack_require__("eYUY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = /*@__PURE__*/__webpack_require__("lKpf");
/** PURE_IMPORTS_START _util_toSubscriber,_internal_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */




/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = /*@__PURE__*/ (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        /** Internal implementation detail, do not use directly. */
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = Object(__WEBPACK_IMPORTED_MODULE_0__util_toSubscriber__["a" /* toSubscriber */])(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        }
        if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [promiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_1__internal_symbol_observable__["a" /* observable */]] = function () {
        return this;
    };
    /* tslint:enable:max-line-length */
    /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_2__util_pipe__["b" /* pipeFromArray */])(operations)(this);
    };
    /* tslint:enable:max-line-length */
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     * @nocollapse
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());

/**
 * Decides between a passed promise constructor from consuming code,
 * A default configured promise constructor, and the native promise
 * constructor and returns it. If nothing can be found, it will throw
 * an error.
 * @param promiseCtor The optional promise constructor to passed by consuming code
 */
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}





/***/ }),

/***/ "lb6C":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "lyWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = zip;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZipOperator; });
/* unused harmony export ZipSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromArray__ = /*@__PURE__*/__webpack_require__("b2EL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isArray__ = /*@__PURE__*/__webpack_require__("YgML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__ = /*@__PURE__*/__webpack_require__("1E73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__ = /*@__PURE__*/__webpack_require__("3SjU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__ = __webpack_require__("uOsm");
/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_OuterSubscriber,_util_subscribeToResult,_.._internal_symbol_iterator PURE_IMPORTS_END */







/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */
function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* fromArray */])(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ZipSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        if (values === void 0) {
            values = Object.create(null);
        }
        var _this = _super.call(this, destination) || this;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : null;
        _this.values = values;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isArray__["a" /* isArray */])(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] === 'function') {
            iterators.push(new StaticIterator(value[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                this.add(iterator.subscribe(iterator, i));
            }
            else {
                this.active--; // not an observable
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscriber__["a" /* Subscriber */]));

var StaticIterator = /*@__PURE__*/ (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}());
var StaticArrayIterator = /*@__PURE__*/ (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_iterator__["a" /* iterator */]] = function () {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function (value, index) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_subscribeToResult__["a" /* subscribeToResult */])(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}(__WEBPACK_IMPORTED_MODULE_4__OuterSubscriber__["a" /* OuterSubscriber */]));





/***/ }),

/***/ "m7yE":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'ss':
            return numberNoun + ' lup';
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        ss : translate,
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),

/***/ "mGzp":
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__("2X2u"),
    baseIteratee = __webpack_require__("JyYQ"),
    baseSome = __webpack_require__("LkuQ"),
    isArray = __webpack_require__("NGEn"),
    isIterateeCall = __webpack_require__("zBOP");

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),

/***/ "mKB/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("TQ3y");

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "mTAn":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "mgnk":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "mwFx":
/***/ (function(module, exports) {

var HTML_ALPHA = ['apos', 'nbsp', 'iexcl', 'cent', 'pound', 'curren', 'yen', 'brvbar', 'sect', 'uml', 'copy', 'ordf', 'laquo', 'not', 'shy', 'reg', 'macr', 'deg', 'plusmn', 'sup2', 'sup3', 'acute', 'micro', 'para', 'middot', 'cedil', 'sup1', 'ordm', 'raquo', 'frac14', 'frac12', 'frac34', 'iquest', 'Agrave', 'Aacute', 'Acirc', 'Atilde', 'Auml', 'Aring', 'Aelig', 'Ccedil', 'Egrave', 'Eacute', 'Ecirc', 'Euml', 'Igrave', 'Iacute', 'Icirc', 'Iuml', 'ETH', 'Ntilde', 'Ograve', 'Oacute', 'Ocirc', 'Otilde', 'Ouml', 'times', 'Oslash', 'Ugrave', 'Uacute', 'Ucirc', 'Uuml', 'Yacute', 'THORN', 'szlig', 'agrave', 'aacute', 'acirc', 'atilde', 'auml', 'aring', 'aelig', 'ccedil', 'egrave', 'eacute', 'ecirc', 'euml', 'igrave', 'iacute', 'icirc', 'iuml', 'eth', 'ntilde', 'ograve', 'oacute', 'ocirc', 'otilde', 'ouml', 'divide', 'oslash', 'ugrave', 'uacute', 'ucirc', 'uuml', 'yacute', 'thorn', 'yuml', 'quot', 'amp', 'lt', 'gt', 'OElig', 'oelig', 'Scaron', 'scaron', 'Yuml', 'circ', 'tilde', 'ensp', 'emsp', 'thinsp', 'zwnj', 'zwj', 'lrm', 'rlm', 'ndash', 'mdash', 'lsquo', 'rsquo', 'sbquo', 'ldquo', 'rdquo', 'bdquo', 'dagger', 'Dagger', 'permil', 'lsaquo', 'rsaquo', 'euro', 'fnof', 'Alpha', 'Beta', 'Gamma', 'Delta', 'Epsilon', 'Zeta', 'Eta', 'Theta', 'Iota', 'Kappa', 'Lambda', 'Mu', 'Nu', 'Xi', 'Omicron', 'Pi', 'Rho', 'Sigma', 'Tau', 'Upsilon', 'Phi', 'Chi', 'Psi', 'Omega', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigmaf', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'thetasym', 'upsih', 'piv', 'bull', 'hellip', 'prime', 'Prime', 'oline', 'frasl', 'weierp', 'image', 'real', 'trade', 'alefsym', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'crarr', 'lArr', 'uArr', 'rArr', 'dArr', 'hArr', 'forall', 'part', 'exist', 'empty', 'nabla', 'isin', 'notin', 'ni', 'prod', 'sum', 'minus', 'lowast', 'radic', 'prop', 'infin', 'ang', 'and', 'or', 'cap', 'cup', 'int', 'there4', 'sim', 'cong', 'asymp', 'ne', 'equiv', 'le', 'ge', 'sub', 'sup', 'nsub', 'sube', 'supe', 'oplus', 'otimes', 'perp', 'sdot', 'lceil', 'rceil', 'lfloor', 'rfloor', 'lang', 'rang', 'loz', 'spades', 'clubs', 'hearts', 'diams'];
var HTML_CODES = [39, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 34, 38, 60, 62, 338, 339, 352, 353, 376, 710, 732, 8194, 8195, 8201, 8204, 8205, 8206, 8207, 8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8240, 8249, 8250, 8364, 402, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 977, 978, 982, 8226, 8230, 8242, 8243, 8254, 8260, 8472, 8465, 8476, 8482, 8501, 8592, 8593, 8594, 8595, 8596, 8629, 8656, 8657, 8658, 8659, 8660, 8704, 8706, 8707, 8709, 8711, 8712, 8713, 8715, 8719, 8721, 8722, 8727, 8730, 8733, 8734, 8736, 8743, 8744, 8745, 8746, 8747, 8756, 8764, 8773, 8776, 8800, 8801, 8804, 8805, 8834, 8835, 8836, 8838, 8839, 8853, 8855, 8869, 8901, 8968, 8969, 8970, 8971, 9001, 9002, 9674, 9824, 9827, 9829, 9830];

var alphaIndex = {};
var numIndex = {};

var i = 0;
var length = HTML_ALPHA.length;
while (i < length) {
    var a = HTML_ALPHA[i];
    var c = HTML_CODES[i];
    alphaIndex[a] = String.fromCharCode(c);
    numIndex[c] = a;
    i++;
}

/**
 * @constructor
 */
function Html4Entities() {}

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.decode = function(str) {
    if (!str || !str.length) {
        return '';
    }
    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
        var chr;
        if (entity.charAt(0) === "#") {
            var code = entity.charAt(1).toLowerCase() === 'x' ?
                parseInt(entity.substr(2), 16) :
                parseInt(entity.substr(1));

            if (!(isNaN(code) || code < -32768 || code > 65535)) {
                chr = String.fromCharCode(code);
            }
        } else {
            chr = alphaIndex[entity];
        }
        return chr || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.decode = function(str) {
    return new Html4Entities().decode(str);
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encode = function(str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var alpha = numIndex[str.charCodeAt(i)];
        result += alpha ? "&" + alpha + ";" : str.charAt(i);
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.encode = function(str) {
    return new Html4Entities().encode(str);
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encodeNonUTF = function(str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var cc = str.charCodeAt(i);
        var alpha = numIndex[cc];
        if (alpha) {
            result += "&" + alpha + ";";
        } else if (cc < 32 || cc > 126) {
            result += "&#" + cc + ";";
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.encodeNonUTF = function(str) {
    return new Html4Entities().encodeNonUTF(str);
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encodeNonASCII = function(str) {
    if (!str || !str.length) {
        return '';
    }
    var strLength = str.length;
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.encodeNonASCII = function(str) {
    return new Html4Entities().encodeNonASCII(str);
};

module.exports = Html4Entities;


/***/ }),

/***/ "mypn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "mzAu":
/***/ (function(module, exports) {

// element-closest | CC0-1.0 | github.com/jonathantneal/closest
if (typeof Element !== 'undefined') {
    if (typeof Element.prototype.matches !== 'function') {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
            Element.prototype['mozMatchesSelector'] ||
            Element.prototype.webkitMatchesSelector ||
            function matches(selector) {
                var element = this;
                var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
                var index = 0;
                while (elements[index] && elements[index] !== element) {
                    ++index;
                }
                return Boolean(elements[index]);
            };
    }
    if (typeof Element.prototype['closest'] !== 'function') {
        Element.prototype['closest'] = function closest(selector) {
            var element = this;
            while (element && element.nodeType === 1) {
                if (element.matches(selector)) {
                    return element;
                }
                element = element.parentNode;
            }
            return null;
        };
    }
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ "nE8X":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        ss : '%d ວິນາທີ' ,
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),

/***/ "nErl":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "nLOz":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        ss : '%d diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),

/***/ "nS2h":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'ss':
            return isFuture ? 'sekunnin' : 'sekuntia';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),

/***/ "nWuj":
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),

/***/ "ntHu":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),

/***/ "nw3t":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("p0bc");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "o2mx":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn"),
    arrayMap = __webpack_require__("Hxdr"),
    isArray = __webpack_require__("NGEn"),
    isSymbol = __webpack_require__("6MiT");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "oCzW":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mt = moment.defineLocale('mt', {
    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Illum fil-]LT',
        nextDay : '[Għada fil-]LT',
        nextWeek : 'dddd [fil-]LT',
        lastDay : '[Il-bieraħ fil-]LT',
        lastWeek : 'dddd [li għadda] [fil-]LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'f’ %s',
        past : '%s ilu',
        s : 'ftit sekondi',
        ss : '%d sekondi',
        m : 'minuta',
        mm : '%d minuti',
        h : 'siegħa',
        hh : '%d siegħat',
        d : 'ġurnata',
        dd : '%d ġranet',
        M : 'xahar',
        MM : '%d xhur',
        y : 'sena',
        yy : '%d sni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mt;

})));


/***/ }),

/***/ "octw":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "oo1B":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        ss : '%d സെക്കൻഡ്',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),

/***/ "ooba":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        ss : '%d saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),

/***/ "oqL2":
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "ovmJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = /*@__PURE__*/ __webpack_require__("TToO").__decorate;
var __metadata = /*@__PURE__*/ __webpack_require__("TToO").__metadata;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var domhandler_1 = __webpack_require__("55Fp");
var common_1 = __webpack_require__("wTuo");
var ButtonDirective = /*@__PURE__*/ (function () {
    function ButtonDirective(el, domHandler) {
        this.el = el;
        this.domHandler = domHandler;
        this.iconPos = 'left';
        this.cornerStyleClass = 'ui-corner-all';
    }
    ButtonDirective.prototype.ngAfterViewInit = function () {
        this.domHandler.addMultipleClasses(this.el.nativeElement, this.getStyleClass());
        if (this.icon) {
            var iconElement = document.createElement("span");
            iconElement.setAttribute("aria-hidden", "true");
            var iconPosClass = (this.iconPos == 'right') ? 'ui-button-icon-right' : 'ui-button-icon-left';
            iconElement.className = iconPosClass + ' ui-clickable fa fa-fw ' + this.icon;
            this.el.nativeElement.appendChild(iconElement);
        }
        var labelElement = document.createElement("span");
        labelElement.className = 'ui-button-text ui-clickable';
        labelElement.appendChild(document.createTextNode(this.label || 'ui-btn'));
        this.el.nativeElement.appendChild(labelElement);
        this.initialized = true;
    };
    ButtonDirective.prototype.getStyleClass = function () {
        var styleClass = 'ui-button ui-widget ui-state-default ' + this.cornerStyleClass;
        if (this.icon) {
            if (this.label != null && this.label != undefined) {
                if (this.iconPos == 'left')
                    styleClass = styleClass + ' ui-button-text-icon-left';
                else
                    styleClass = styleClass + ' ui-button-text-icon-right';
            }
            else {
                styleClass = styleClass + ' ui-button-icon-only';
            }
        }
        else {
            if (this.label) {
                styleClass = styleClass + ' ui-button-text-only';
            }
            else {
                styleClass = styleClass + ' ui-button-text-empty';
            }
        }
        return styleClass;
    };
    Object.defineProperty(ButtonDirective.prototype, "label", {
        get: function () {
            return this._label;
        },
        set: function (val) {
            this._label = val;
            if (this.initialized) {
                this.domHandler.findSingle(this.el.nativeElement, '.ui-button-text').textContent = this._label;
                if (!this.icon) {
                    if (this._label) {
                        this.domHandler.removeClass(this.el.nativeElement, 'ui-button-text-empty');
                        this.domHandler.addClass(this.el.nativeElement, 'ui-button-text-only');
                    }
                    else {
                        this.domHandler.addClass(this.el.nativeElement, 'ui-button-text-empty');
                        this.domHandler.removeClass(this.el.nativeElement, 'ui-button-text-only');
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonDirective.prototype, "icon", {
        get: function () {
            return this._icon;
        },
        set: function (val) {
            this._icon = val;
            if (this.initialized) {
                var iconPosClass = (this.iconPos == 'right') ? 'ui-button-icon-right' : 'ui-button-icon-left';
                this.domHandler.findSingle(this.el.nativeElement, '.fa').className =
                    iconPosClass + ' ui-clickable fa fa-fw ' + this.icon;
            }
        },
        enumerable: true,
        configurable: true
    });
    ButtonDirective.prototype.ngOnDestroy = function () {
        while (this.el.nativeElement.hasChildNodes()) {
            this.el.nativeElement.removeChild(this.el.nativeElement.lastChild);
        }
        this.initialized = false;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ButtonDirective.prototype, "iconPos", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ButtonDirective.prototype, "cornerStyleClass", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ButtonDirective.prototype, "label", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ButtonDirective.prototype, "icon", null);
    ButtonDirective = __decorate([
        core_1.Directive({
            selector: '[pButton]',
            providers: [domhandler_1.DomHandler]
        })
    ], ButtonDirective);
    return ButtonDirective;
}());
exports.ButtonDirective = ButtonDirective;
var Button = /*@__PURE__*/ (function () {
    function Button() {
        this.type = 'button';
        this.iconPos = 'left';
        this.onClick = new core_1.EventEmitter();
        this.onFocus = new core_1.EventEmitter();
        this.onBlur = new core_1.EventEmitter();
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Button.prototype, "type", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Button.prototype, "iconPos", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Button.prototype, "icon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Button.prototype, "label", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], Button.prototype, "disabled", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], Button.prototype, "style", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Button.prototype, "styleClass", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], Button.prototype, "onClick", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], Button.prototype, "onFocus", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], Button.prototype, "onBlur", void 0);
    Button = __decorate([
        core_1.Component({
            selector: 'p-button',
            template: "\n        <button [attr.type]=\"type\" [class]=\"styleClass\" [style]=\"style\" [disabled]=\"disabled\"\n            [ngClass]=\"{'ui-button ui-widget ui-state-default ui-corner-all':true,\n                        'ui-button-icon-only': (icon && !label),\n                        'ui-button-text-icon-left': (icon && label && iconPos === 'left'),\n                        'ui-button-text-icon-right': (icon && label && iconPos === 'right'),\n                        'ui-button-text-only': (!icon && label),\n                        'ui-button-text-empty': (!icon && !label),\n                        'ui-state-disabled': disabled}\"\n                        (click)=\"onClick.emit($event)\" (focus)=\"onFocus.emit($event)\" (blur)=\"onBlur.emit($event)\">\n            <ng-content></ng-content>\n            <span [ngClass]=\"{'ui-clickable': true,\n                        'ui-button-icon-left': (iconPos === 'left'), \n                        'ui-button-icon-right': (iconPos === 'right')}\"\n                        [class]=\"icon\" *ngIf=\"icon\"></span>\n            <span class=\"ui-button-text ui-clickable\">{{label||'ui-btn'}}</span>\n        </button>\n    "
        })
    ], Button);
    return Button;
}());
exports.Button = Button;
var ButtonModule = /*@__PURE__*/ (function () {
    function ButtonModule() {
    }
    ButtonModule = __decorate([
        core_1.NgModule({
            imports: [common_1.CommonModule],
            exports: [ButtonDirective, Button],
            declarations: [ButtonDirective, Button]
        })
    ], ButtonModule);
    return ButtonModule;
}());
exports.ButtonModule = ButtonModule;



/***/ }),

/***/ "p0bc":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("ICSD");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "p1Bo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isFunction__ = /*@__PURE__*/__webpack_require__("bOhj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observer__ = /*@__PURE__*/__webpack_require__("ESBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__ = /*@__PURE__*/__webpack_require__("Egod");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = /*@__PURE__*/__webpack_require__("lKpf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_hostReportError__ = /*@__PURE__*/__webpack_require__("BdDE");
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */







/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        /** @internal */ _this.syncErrorValue = null;
        /** @internal */ _this.syncErrorThrown = false;
        /** @internal */ _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */];
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */];
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): For situations where Node has multiple copies of rxjs in
                    // node_modules, we cannot rely on `instanceof` checks
                    if (isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[__WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]]();
                        _this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        _this.destination = trustedSubscriber;
                        trustedSubscriber.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[__WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     * @nocollapse
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(__WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */]));

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== __WEBPACK_IMPORTED_MODULE_2__Observer__["a" /* empty */]) {
                context = Object.create(observerOrNext);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = __WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_6__util_hostReportError__["a" /* hostReportError */])(err);
                return true;
            }
        }
        return false;
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
function isTrustedSubscriber(obj) {
    return obj instanceof Subscriber || ('syncErrorThrowable' in obj && obj[__WEBPACK_IMPORTED_MODULE_4__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]]);
}





/***/ }),

/***/ "pHYG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InnerSubscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));






/***/ }),

/***/ "pQJ6":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("bGc4");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ "pTUa":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("/I3N");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "pfs9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        ss : '%d ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),

/***/ "pqjY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  XmlEntities: __webpack_require__("a5nY"),
  Html4Entities: __webpack_require__("mwFx"),
  Html5Entities: __webpack_require__("1o7w"),
  AllHtmlEntities: __webpack_require__("1o7w")
};


/***/ }),

/***/ "py9u":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("tv3T"),
    keysIn = __webpack_require__("t8rQ");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "q+Dy":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("G8ar"),
    isArrayLike = __webpack_require__("bGc4"),
    isString = __webpack_require__("JDN0"),
    toInteger = __webpack_require__("5Zxu"),
    values = __webpack_require__("L8MQ");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ "qhmd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__("TdOr");
var common_1 = __webpack_require__("wTuo");
var forms_1 = __webpack_require__("B+Nj");
var ng2_auto_complete_component_1 = __webpack_require__("BUs8");
var ng2_auto_complete_directive_1 = __webpack_require__("/lQQ");
var ng2_auto_complete_1 = __webpack_require__("Hoss");
var Ng2AutoCompleteModule = /*@__PURE__*/ (function () {
    function Ng2AutoCompleteModule() {
    }
    Ng2AutoCompleteModule.forRoot = function () {
        return {
            ngModule: Ng2AutoCompleteModule,
            providers: [ng2_auto_complete_1.Ng2AutoComplete]
        };
    };
    Ng2AutoCompleteModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [common_1.CommonModule, forms_1.FormsModule],
                    declarations: [ng2_auto_complete_component_1.Ng2AutoCompleteComponent, ng2_auto_complete_directive_1.Ng2AutoCompleteDirective],
                    exports: [ng2_auto_complete_component_1.Ng2AutoCompleteComponent, ng2_auto_complete_directive_1.Ng2AutoCompleteDirective],
                    entryComponents: [ng2_auto_complete_component_1.Ng2AutoCompleteComponent]
                },] },
    ];
    /** @nocollapse */
    Ng2AutoCompleteModule.ctorParameters = [];
    return Ng2AutoCompleteModule;
}());
exports.Ng2AutoCompleteModule = Ng2AutoCompleteModule;



/***/ }),

/***/ "qpVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_iterator__ = /*@__PURE__*/__webpack_require__("uOsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_subscribeToIterable__ = /*@__PURE__*/__webpack_require__("alQS");
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator,_util_subscribeToIterable PURE_IMPORTS_END */




function fromIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    if (!scheduler) {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](Object(__WEBPACK_IMPORTED_MODULE_3__util_subscribeToIterable__["a" /* subscribeToIterable */])(input));
    }
    else {
        return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
            var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["a" /* Subscription */]();
            var iterator;
            sub.add(function () {
                // Finalize generators
                if (iterator && typeof iterator.return === 'function') {
                    iterator.return();
                }
            });
            sub.add(scheduler.schedule(function () {
                iterator = input[__WEBPACK_IMPORTED_MODULE_2__symbol_iterator__["a" /* iterator */]]();
                sub.add(scheduler.schedule(function () {
                    if (subscriber.closed) {
                        return;
                    }
                    var value;
                    var done;
                    try {
                        var result = iterator.next();
                        value = result.value;
                        done = result.done;
                    }
                    catch (err) {
                        subscriber.error(err);
                        return;
                    }
                    if (done) {
                        subscriber.complete();
                    }
                    else {
                        subscriber.next(value);
                        this.schedule();
                    }
                }));
            }));
            return sub;
        });
    }
}
//# sourceMappingURL=fromIterable.js.map


/***/ }),

/***/ "qwTf":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("TQ3y");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "rCVp":
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__("1C79");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ "rIuo":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        ss : 'd% ސިކުންތު',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),

/***/ "rdLu":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),

/***/ "rpnb":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("tHks");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "rtsW":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
        '1': '૧',
        '2': '૨',
        '3': '૩',
        '4': '૪',
        '5': '૫',
        '6': '૬',
        '7': '૭',
        '8': '૮',
        '9': '૯',
        '0': '૦'
    };
var numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

var gu = moment.defineLocale('gu', {
    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
    monthsParseExact: true,
    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
    longDateFormat: {
        LT: 'A h:mm વાગ્યે',
        LTS: 'A h:mm:ss વાગ્યે',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
    },
    calendar: {
        sameDay: '[આજ] LT',
        nextDay: '[કાલે] LT',
        nextWeek: 'dddd, LT',
        lastDay: '[ગઇકાલે] LT',
        lastWeek: '[પાછલા] dddd, LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%s મા',
        past: '%s પેહલા',
        s: 'અમુક પળો',
        ss: '%d સેકંડ',
        m: 'એક મિનિટ',
        mm: '%d મિનિટ',
        h: 'એક કલાક',
        hh: '%d કલાક',
        d: 'એક દિવસ',
        dd: '%d દિવસ',
        M: 'એક મહિનો',
        MM: '%d મહિનો',
        y: 'એક વર્ષ',
        yy: '%d વર્ષ'
    },
    preparse: function (string) {
        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'રાત') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'સવાર') {
            return hour;
        } else if (meridiem === 'બપોર') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'સાંજ') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'રાત';
        } else if (hour < 10) {
            return 'સવાર';
        } else if (hour < 17) {
            return 'બપોર';
        } else if (hour < 20) {
            return 'સાંજ';
        } else {
            return 'રાત';
        }
    },
    week: {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 1st is the first week of the year.
    }
});

return gu;

})));


/***/ }),

/***/ "rylm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* unused harmony export MapOperator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */


/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* Subscriber */]));





/***/ }),

/***/ "sBat":
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__("kxzG");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ "sJvV":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "sOR5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "sXnP":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * froala_editor v2.7.3 (https://www.froala.com/wysiwyg-editor)
 * License https://froala.com/wysiwyg-editor/terms/
 * Copyright 2014-2017 Froala Labs
 */

!function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("7t+N")], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=function(b,c){return void 0===c&&(c="undefined"!=typeof window?require("jquery"):require("jquery")(b)),a(c)}:a(window.jQuery)}(function(a){var b=function(c,d){this.id=++a.FE.ID,this.opts=a.extend(!0,{},a.extend({},b.DEFAULTS,"object"==typeof d&&d));var e=JSON.stringify(this.opts);a.FE.OPTS_MAPPING[e]=a.FE.OPTS_MAPPING[e]||this.id,this.sid=a.FE.OPTS_MAPPING[e],a.FE.SHARED[this.sid]=a.FE.SHARED[this.sid]||{},this.shared=a.FE.SHARED[this.sid],this.shared.count=(this.shared.count||0)+1,this.$oel=a(c),this.$oel.data("froala.editor",this),this.o_doc=c.ownerDocument,this.o_win="defaultView"in this.o_doc?this.o_doc.defaultView:this.o_doc.parentWindow;var f=a(this.o_win).scrollTop();this.$oel.on("froala.doInit",a.proxy(function(){this.$oel.off("froala.doInit"),this.doc=this.$el.get(0).ownerDocument,this.win="defaultView"in this.doc?this.doc.defaultView:this.doc.parentWindow,this.$doc=a(this.doc),this.$win=a(this.win),this.opts.pluginsEnabled||(this.opts.pluginsEnabled=Object.keys(a.FE.PLUGINS)),this.opts.initOnClick?(this.load(a.FE.MODULES),this.$el.on("touchstart.init",function(){a(this).data("touched",!0)}),this.$el.on("touchmove.init",function(){a(this).removeData("touched")}),this.$el.on("mousedown.init touchend.init dragenter.init focus.init",a.proxy(function(b){if("touchend"==b.type&&!this.$el.data("touched"))return!0;if(1===b.which||!b.which){this.$el.off("mousedown.init touchstart.init touchmove.init touchend.init dragenter.init focus.init"),this.load(a.FE.MODULES),this.load(a.FE.PLUGINS);var c=b.originalEvent&&b.originalEvent.originalTarget;c&&"IMG"==c.tagName&&a(c).trigger("mousedown"),void 0===this.ul&&this.destroy(),"touchend"==b.type&&this.image&&b.originalEvent&&b.originalEvent.target&&a(b.originalEvent.target).is("img")&&setTimeout(a.proxy(function(){this.image.edit(a(b.originalEvent.target))},this),100),this.ready=!0,this.events.trigger("initialized")}},this)),this.events.trigger("initializationDelayed")):(this.load(a.FE.MODULES),this.load(a.FE.PLUGINS),a(this.o_win).scrollTop(f),void 0===this.ul&&this.destroy(),this.ready=!0,this.events.trigger("initialized"))},this)),this._init()};b.DEFAULTS={initOnClick:!1,pluginsEnabled:null},b.MODULES={},b.PLUGINS={},b.VERSION="2.7.3",b.INSTANCES=[],b.OPTS_MAPPING={},b.SHARED={},b.ID=0,b.prototype._init=function(){var b=this.$oel.prop("tagName");this.$oel.closest("label").length;var c=a.proxy(function(){"TEXTAREA"!=b&&(this._original_html=this._original_html||this.$oel.html()),this.$box=this.$box||this.$oel,this.opts.fullPage&&(this.opts.iframe=!0),this.opts.iframe?(this.$iframe=a('<iframe src="about:blank" frameBorder="0">'),this.$wp=a("<div></div>"),this.$box.html(this.$wp),this.$wp.append(this.$iframe),this.$iframe.get(0).contentWindow.document.open(),this.$iframe.get(0).contentWindow.document.write("<!DOCTYPE html>"),this.$iframe.get(0).contentWindow.document.write("<html><head></head><body></body></html>"),this.$iframe.get(0).contentWindow.document.close(),this.$el=this.$iframe.contents().find("body"),this.el=this.$el.get(0),this.$head=this.$iframe.contents().find("head"),this.$html=this.$iframe.contents().find("html"),this.iframe_document=this.$iframe.get(0).contentWindow.document,this.$oel.trigger("froala.doInit")):(this.$el=a("<div></div>"),this.el=this.$el.get(0),this.$wp=a("<div></div>").append(this.$el),this.$box.html(this.$wp),this.$oel.trigger("froala.doInit"))},this),d=a.proxy(function(){this.$box=a("<div>"),this.$oel.before(this.$box).hide(),this._original_html=this.$oel.val(),this.$oel.parents("form").on("submit."+this.id,a.proxy(function(){this.events.trigger("form.submit")},this)),this.$oel.parents("form").on("reset."+this.id,a.proxy(function(){this.events.trigger("form.reset")},this)),c()},this),e=a.proxy(function(){this.$el=this.$oel,this.el=this.$el.get(0),this.$el.attr("contenteditable",!0).css("outline","none").css("display","inline-block"),this.opts.multiLine=!1,this.opts.toolbarInline=!1,this.$oel.trigger("froala.doInit")},this),f=a.proxy(function(){this.$el=this.$oel,this.el=this.$el.get(0),this.opts.toolbarInline=!1,this.$oel.trigger("froala.doInit")},this),g=a.proxy(function(){this.$el=this.$oel,this.el=this.$el.get(0),this.opts.toolbarInline=!1,this.$oel.on("click.popup",function(a){a.preventDefault()}),this.$oel.trigger("froala.doInit")},this);this.opts.editInPopup?g():"TEXTAREA"==b?d():"A"==b?e():"IMG"==b?f():"BUTTON"==b||"INPUT"==b?(this.opts.editInPopup=!0,this.opts.toolbarInline=!1,g()):c()},b.prototype.load=function(b){for(var c in b)if(b.hasOwnProperty(c)){if(this[c])continue;if(a.FE.PLUGINS[c]&&this.opts.pluginsEnabled.indexOf(c)<0)continue;if(this[c]=new b[c](this),this[c]._init&&(this[c]._init(),this.opts.initOnClick&&"core"==c))return!1}},b.prototype.destroy=function(){this.shared.count--,this.events.$off();var b=this.html.get();if(this.events.trigger("destroy",[],!0),this.events.trigger("shared.destroy",void 0,!0),0===this.shared.count){for(var c in this.shared)this.shared.hasOwnProperty(c)&&(this.shared[c],a.FE.SHARED[this.sid][c]=null);a.FE.SHARED[this.sid]={}}this.$oel.parents("form").off("."+this.id),this.$oel.off("click.popup"),this.$oel.removeData("froala.editor"),this.$oel.off("froalaEditor"),this.core.destroy(b),a.FE.INSTANCES.splice(a.FE.INSTANCES.indexOf(this),1)},a.fn.froalaEditor=function(c){for(var d=[],e=0;e<arguments.length;e++)d.push(arguments[e]);if("string"==typeof c){var f=[];return this.each(function(){var b=a(this),e=b.data("froala.editor");if(e){var g,h;if(c.indexOf(".")>0&&e[c.split(".")[0]]?(e[c.split(".")[0]]&&(g=e[c.split(".")[0]]),h=c.split(".")[1]):(g=e,h=c.split(".")[0]),!g[h])return a.error("Method "+c+" does not exist in Froala Editor.");var i=g[h].apply(e,d.slice(1));void 0===i?f.push(this):0===f.length&&f.push(i)}}),1==f.length?f[0]:f}if("object"==typeof c||!c)return this.each(function(){a(this).data("froala.editor")||new b(this,c)})},a.fn.froalaEditor.Constructor=b,a.FroalaEditor=b,a.FE=b,a.FE.XS=0,a.FE.SM=1,a.FE.MD=2,a.FE.LG=3;var c="a-z\\u0080-\\u009f\\u00a1-\\uffff0-9-_";if(a.FE.LinkRegExCommon="((["+c+"])|(["+c+"](\\.|-|_|--))){1,}["+c+"]{1,}",a.FE.LinkRegExEnd="((:[0-9]{1,5})|)(((\\/|\\?|#)[a-z\\u00a1-\\uffff0-9@?\\|!^=%&amp;/~+#-_{}]*)|())",a.FE.LinkRegExTLD="(("+a.FE.LinkRegExCommon+")(\\.(com|net|org|edu|mil|gov|co|biz|info|me|dev)))",a.FE.LinkRegExHTTP="((ftp|http|https):\\/\\/"+a.FE.LinkRegExCommon+")",a.FE.LinkRegExAuth="((ftp|http|https):\\/\\/[\\u0021-\\uffff]{1,}@"+a.FE.LinkRegExCommon+")",a.FE.LinkRegExWWW="(www\\."+a.FE.LinkRegExCommon+"\\.[a-z0-9-]{2,24})",a.FE.LinkRegEx="("+a.FE.LinkRegExTLD+"|"+a.FE.LinkRegExHTTP+"|"+a.FE.LinkRegExWWW+"|"+a.FE.LinkRegExAuth+")"+a.FE.LinkRegExEnd,a.FE.LinkProtocols=["mailto","tel","sms","notes","data"],a.FE.MAIL_REGEX=/.+@.+\..+/i,a.FE.MODULES.helpers=function(b){function c(){var a,b,c=-1;return"Microsoft Internet Explorer"==navigator.appName?(a=navigator.userAgent,b=new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})"),null!==b.exec(a)&&(c=parseFloat(RegExp.$1))):"Netscape"==navigator.appName&&(a=navigator.userAgent,b=new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})"),null!==b.exec(a)&&(c=parseFloat(RegExp.$1))),c}function d(){var a={},b=c();if(b>0)a.msie=!0;else{var d=navigator.userAgent.toLowerCase(),e=/(edge)[ \/]([\w.]+)/.exec(d)||/(chrome)[ \/]([\w.]+)/.exec(d)||/(webkit)[ \/]([\w.]+)/.exec(d)||/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(d)||/(msie) ([\w.]+)/.exec(d)||d.indexOf("compatible")<0&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(d)||[],f={browser:e[1]||"",version:e[2]||"0"};e[1]&&(a[f.browser]=!0),a.chrome?a.webkit=!0:a.webkit&&(a.safari=!0)}return a.msie&&(a.version=b),a}function e(){return/(iPad|iPhone|iPod)/g.test(navigator.userAgent)&&!h()}function f(){return/(Android)/g.test(navigator.userAgent)&&!h()}function g(){return/(Blackberry)/g.test(navigator.userAgent)}function h(){return/(Windows Phone)/gi.test(navigator.userAgent)}function i(){return f()||e()||g()}function j(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(a){window.setTimeout(a,1e3/60)}}function k(a){return parseInt(a,10)||0}function l(){var b=a('<div class="fr-visibility-helper"></div>').appendTo("body:first");try{var c=k(b.css("margin-left"));return b.remove(),c}catch(d){return a.FE.LG}}function m(){return"ontouchstart"in window||window.DocumentTouch&&document instanceof DocumentTouch}function n(b){return!!/^(https?:|ftps?:|)\/\//i.test(b)&&(b=String(b).replace(/</g,"%3C").replace(/>/g,"%3E").replace(/"/g,"%22").replace(/ /g,"%20"),new RegExp("^"+a.FE.LinkRegEx+"$","gi").test(b))}function o(b){return!/^(https?:|ftps?:|)\/\//i.test(b)&&a.FE.MAIL_REGEX.test(b)}function p(b){if(/^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i.test(b))return b;if(/^(https?:|ftps?:|)\/\//i.test(b)){if(!n(b)&&!n("http:"+b))return""}else{if(new RegExp("^("+a.FE.LinkProtocols.join("|")+"):\\/\\/","i").test(b))return b;b=encodeURIComponent(b).replace(/%23/g,"#").replace(/%2F/g,"/").replace(/%25/g,"%").replace(/mailto%3A/gi,"mailto:").replace(/file%3A/gi,"file:").replace(/sms%3A/gi,"sms:").replace(/tel%3A/gi,"tel:").replace(/notes%3A/gi,"notes:").replace(/data%3Aimage/gi,"data:image").replace(/blob%3A/gi,"blob:").replace(/webkit-fake-url%3A/gi,"webkit-fake-url:").replace(/%3F/g,"?").replace(/%3D/g,"=").replace(/%26/g,"&").replace(/&amp;/g,"&").replace(/%2C/g,",").replace(/%3B/g,";").replace(/%2B/g,"+").replace(/%40/g,"@").replace(/%5B/g,"[").replace(/%5D/g,"]").replace(/%7B/g,"{").replace(/%7D/g,"}")}return b}function q(a){return a&&!a.propertyIsEnumerable("length")&&"object"==typeof a&&"number"==typeof a.length}function r(a){function b(a){return("0"+parseInt(a,10).toString(16)).slice(-2)}try{return a&&"transparent"!==a?/^#[0-9A-F]{6}$/i.test(a)?a:(a=a.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/),("#"+b(a[1])+b(a[2])+b(a[3])).toUpperCase()):""}catch(c){return null}}function s(a){var b=/^#?([a-f\d])([a-f\d])([a-f\d])$/i;a=a.replace(b,function(a,b,c,d){return b+b+c+c+d+d});var c=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);return c?"rgb("+parseInt(c[1],16)+", "+parseInt(c[2],16)+", "+parseInt(c[3],16)+")":""}function t(c){var d=(c.css("text-align")||"").replace(/-(.*)-/g,"");if(["left","right","justify","center"].indexOf(d)<0){if(!B){var e=a('<div dir="'+("rtl"==b.opts.direction?"rtl":"auto")+'" style="text-align: '+b.$el.css("text-align")+'; position: fixed; left: -3000px;"><span id="s1">.</span><span id="s2">.</span></div>');a("body:first").append(e);var f=e.find("#s1").get(0).getBoundingClientRect().left,g=e.find("#s2").get(0).getBoundingClientRect().left;e.remove(),B=f<g?"left":"right"}d=B}return d}function u(){return null==C&&(C=navigator.platform.toUpperCase().indexOf("MAC")>=0),C}function v(){function a(a,b){var e=a[b];a[b]=function(a){var b,f=!1,g=!1;if(a&&a.match(d)){a=a.replace(d,""),this.parentNode||(c.appendChild(this),g=!0);var h=this.parentNode;return this.id||(this.id="rootedQuerySelector_id_"+(new Date).getTime(),f=!0),b=e.call(h,"#"+this.id+" "+a),f&&(this.id=""),g&&c.removeChild(this),b}return e.call(this,a)}}var c=b.o_doc.createElement("div");try{c.querySelectorAll(":scope *")}catch(e){var d=/^\s*:scope/gi;a(Element.prototype,"querySelector"),a(Element.prototype,"querySelectorAll"),a(HTMLElement.prototype,"querySelector"),a(HTMLElement.prototype,"querySelectorAll")}}function w(){return b.o_win.pageYOffset?b.o_win.pageYOffset:b.o_doc.documentElement&&b.o_doc.documentElement.scrollTop?b.o_doc.documentElement.scrollTop:b.o_doc.body.scrollTop?b.o_doc.body.scrollTop:0}function x(){return b.o_win.pageXOffset?b.o_win.pageXOffset:b.o_doc.documentElement&&b.o_doc.documentElement.scrollLeft?b.o_doc.documentElement.scrollLeft:b.o_doc.body.scrollLeft?b.o_doc.body.scrollLeft:0}function y(){Element.prototype.matches||(Element.prototype.matches=Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector),Element.prototype.closest||(Element.prototype.closest=function(a){var b=this,c=this;if(!document.documentElement.contains(b))return null;do{if(c.matches(a))return c;c=c.parentElement}while(null!==c);return null})}function z(a){var b=a.getBoundingClientRect();return b.top>=0&&b.bottom<=(window.innerHeight||document.documentElement.clientHeight)||b.top<=0&&b.bottom>=(window.innerHeight||document.documentElement.clientHeight)}function A(){b.browser=d(),v(),y()}var B,C=null;return{_init:A,isIOS:e,isMac:u,isAndroid:f,isBlackberry:g,isWindowsPhone:h,isMobile:i,isEmail:o,requestAnimationFrame:j,getPX:k,screenSize:l,isTouch:m,sanitizeURL:p,isArray:q,RGBToHex:r,HEXtoRGB:s,isURL:n,getAlignment:t,scrollTop:w,scrollLeft:x,isInViewPort:z}},a.FE.MODULES.events=function(b){function c(a,b,c){s(a,b,c)}function d(){c(b.$el,"cut copy paste beforepaste",function(a){v(a.type,[a])})}function e(){c(b.$el,"click mouseup mousedown touchstart touchend dragenter dragover dragleave dragend drop dragstart",function(a){v(a.type,[a])}),r("mousedown",function(){for(var c=0;c<a.FE.INSTANCES.length;c++)a.FE.INSTANCES[c]!=b&&a.FE.INSTANCES[c].popups&&a.FE.INSTANCES[c].popups.areVisible()&&a.FE.INSTANCES[c].$el.find(".fr-marker").remove()})}function f(){c(b.$el,"keydown keypress keyup input",function(a){v(a.type,[a])})}function g(){c(b.$win,b._mousedown,function(a){v("window.mousedown",[a]),n()}),c(b.$win,b._mouseup,function(a){v("window.mouseup",[a])}),c(b.$win,"cut copy keydown keyup touchmove touchend",function(a){v("window."+a.type,[a])})}function h(){c(b.$doc,"dragend drop",function(a){v("document."+a.type,[a])})}function i(c){var d;if(void 0===c&&(c=!0),!b.$wp)return!1;if(b.helpers.isIOS()&&b.$win.get(0).focus(),!b.core.hasFocus()&&c){var e=b.$win.scrollTop();if(b.browser.msie&&b.$box&&b.$box.css("position","fixed"),b.browser.msie&&b.$wp&&b.$wp.css("overflow","visible"),o(),b.$el.focus(),n(),b.browser.msie&&b.$box&&b.$box.css("position",""),b.browser.msie&&b.$wp&&b.$wp.css("overflow","auto"),e!=b.$win.scrollTop()&&b.$win.scrollTop(e),d=b.selection.info(b.el),!d.atStart)return!1}if(!b.core.hasFocus()||b.$el.find(".fr-marker").length>0)return!1;if(d=b.selection.info(b.el),d.atStart&&b.selection.isCollapsed()&&null!=b.html.defaultTag()){var f=b.markers.insert();if(f&&!b.node.blockParent(f)){a(f).remove();var g=b.$el.find(b.html.blockTagsQuery()).get(0);g&&(a(g).prepend(a.FE.MARKERS),b.selection.restore())}else f&&a(f).remove()}}function j(){c(b.$el,"focus",function(a){p()&&(i(!1),!1===C&&v(a.type,[a]))}),c(b.$el,"blur",function(a){p()&&!0===C&&(v(a.type,[a]),n())}),r("focus",function(){C=!0}),r("blur",function(){C=!1})}function k(){b.helpers.isMobile()?(b._mousedown="touchstart",b._mouseup="touchend",b._move="touchmove",b._mousemove="touchmove"):(b._mousedown="mousedown",b._mouseup="mouseup",b._move="",b._mousemove="mousemove")}function l(c){var d=a(c.currentTarget);return b.edit.isDisabled()||b.node.hasClass(d.get(0),"fr-disabled")?(c.preventDefault(),!1):"mousedown"===c.type&&1!==c.which||(b.helpers.isMobile()||c.preventDefault(),(b.helpers.isAndroid()||b.helpers.isWindowsPhone())&&0===d.parents(".fr-dropdown-menu").length&&(c.preventDefault(),c.stopPropagation()),d.addClass("fr-selected"),void b.events.trigger("commands.mousedown",[d]))}function m(c,d){var e=a(c.currentTarget);if(b.edit.isDisabled()||b.node.hasClass(e.get(0),"fr-disabled"))return c.preventDefault(),!1;if("mouseup"===c.type&&1!==c.which)return!0;if(!b.node.hasClass(e.get(0),"fr-selected"))return!0;if("touchmove"!=c.type){if(c.stopPropagation(),c.stopImmediatePropagation(),c.preventDefault(),!b.node.hasClass(e.get(0),"fr-selected"))return b.button.getButtons(".fr-selected",!0).removeClass("fr-selected"),!1;if(b.button.getButtons(".fr-selected",!0).removeClass("fr-selected"),e.data("dragging")||e.attr("disabled"))return e.removeData("dragging"),!1;var f=e.data("timeout");f&&(clearTimeout(f),e.removeData("timeout")),d.apply(b,[c])}else e.data("timeout")||e.data("timeout",setTimeout(function(){e.data("dragging",!0)},100))}function n(){A=!0}function o(){A=!1}function p(){return A}function q(a,c,d){s(a,b._mousedown,c,function(a){b.edit.isDisabled()||l(a)},!0),s(a,b._mouseup+" "+b._move,c,function(a){b.edit.isDisabled()||m(a,d)},!0),s(a,"mousedown click mouseup",c,function(a){b.edit.isDisabled()||a.stopPropagation()},!0),r("window.mouseup",function(){b.edit.isDisabled()||(a.find(c).removeClass("fr-selected"),n())})}function r(a,c,d){var e=a.split(" ");if(e.length>1){for(var f=0;f<e.length;f++)r(e[f],c,d);return!0}void 0===d&&(d=!1);var g;g=0!==a.indexOf("shared.")?B[a]=B[a]||[]:b.shared._events[a]=b.shared._events[a]||[],d?g.unshift(c):g.push(c)}function s(a,c,d,e,f){"function"==typeof d&&(f=e,e=d,d=!1);var g=f?b.shared.$_events:D,h=f?b.sid:b.id;d?a.on(c.split(" ").join(".ed"+h+" ")+".ed"+h,d,e):a.on(c.split(" ").join(".ed"+h+" ")+".ed"+h,e),g.push([a,c.split(" ").join(".ed"+h+" ")+".ed"+h])}function t(a){for(var b=0;b<a.length;b++)a[b][0].off(a[b][1])}function u(){t(D),D=[],0===b.shared.count&&(t(b.shared.$_events),b.shared.$_events=[])}function v(c,d,e){if(!b.edit.isDisabled()||e){var f;if(0!==c.indexOf("shared."))f=B[c];else{if(b.shared.count>0)return!1;f=b.shared._events[c]}var g;if(f)for(var h=0;h<f.length;h++)if(!1===(g=f[h].apply(b,d)))return!1;return!1!==(g=b.$oel.triggerHandler("froalaEditor."+c,a.merge([b],d||[])))&&g}}function w(c,d,e){if(!b.edit.isDisabled()||e){var f;if(0!==c.indexOf("shared."))f=B[c];else{if(b.shared.count>0)return!1;f=b.shared._events[c]}var g;if(f)for(var h=0;h<f.length;h++)void 0!==(g=f[h].apply(b,[d]))&&(d=g);return g=b.$oel.triggerHandler("froalaEditor."+c,a.merge([b],[d])),void 0!==g&&(d=g),d}}function x(){for(var a in B)B.hasOwnProperty(a)&&delete B[a]}function y(){for(var a in b.shared._events)b.shared._events.hasOwnProperty(a)&&delete b.shared._events[a]}function z(){b.shared.$_events=b.shared.$_events||[],b.shared._events={},k(),e(),g(),h(),f(),j(),n(),d(),r("destroy",x),r("shared.destroy",y)}var A,B={},C=!1,D=[];return{_init:z,on:r,trigger:v,bindClick:q,disableBlur:o,enableBlur:n,blurActive:p,focus:i,chainTrigger:w,$on:s,$off:u}},a.FE.MODULES.node=function(b){function c(a){return a&&"IFRAME"!=a.tagName?Array.prototype.slice.call(a.childNodes||[]):[]}function d(b){return!!b&&(b.nodeType==Node.ELEMENT_NODE&&a.FE.BLOCK_TAGS.indexOf(b.tagName.toLowerCase())>=0)}function e(a){return!!a&&(a.nodeType==Node.ELEMENT_NODE&&"a"==a.tagName.toLowerCase())}function f(e,f){if(!e)return!0;if(e.querySelector("table"))return!1;var g=c(e);1==g.length&&d(g[0])&&(g=c(g[0]));for(var h=!1,i=0;i<g.length;i++){var j=g[i];if((!f||!b.node.hasClass(j,"fr-marker"))&&(j.nodeType!=Node.TEXT_NODE||0!==j.textContent.length)){if("BR"!=j.tagName&&(j.textContent||"").replace(/\u200B/gi,"").replace(/\n/g,"").length>0)return!1;if(h)return!1;"BR"==j.tagName&&(h=!0)}}return!(e.querySelectorAll(a.FE.VOID_ELEMENTS.join(",")).length-e.querySelectorAll("br").length)&&(!e.querySelector(b.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),")+":not(.fr-marker)")&&(!(e.querySelectorAll(a.FE.BLOCK_TAGS.join(",")).length>1)&&!e.querySelector(b.opts.htmlDoNotWrapTags.join(":not(.fr-marker),")+":not(.fr-marker)")))}function g(a){for(;a&&a.parentNode!==b.el&&(!a.parentNode||!b.node.hasClass(a.parentNode,"fr-inner"));)if(a=a.parentNode,d(a))return a;return null}function h(c,e,f){if(void 0===e&&(e=[]),void 0===f&&(f=!0),e.push(b.el),e.indexOf(c.parentNode)>=0||c.parentNode&&b.node.hasClass(c.parentNode,"fr-inner")||c.parentNode&&a.FE.SIMPLE_ENTER_TAGS.indexOf(c.parentNode.tagName)>=0&&f)return null;for(;e.indexOf(c.parentNode)<0&&c.parentNode&&!b.node.hasClass(c.parentNode,"fr-inner")&&(a.FE.SIMPLE_ENTER_TAGS.indexOf(c.parentNode.tagName)<0||!f)&&(!d(c)||!d(c.parentNode)||!f);)c=c.parentNode;return c}function i(a){var b={},c=a.attributes;if(c)for(var d=0;d<c.length;d++){var e=c[d];b[e.nodeName]=e.value}return b}function j(a){for(var b="",c=i(a),d=Object.keys(c).sort(),e=0;e<d.length;e++){var f=d[e],g=c[f];g.indexOf("'")<0&&g.indexOf('"')>=0?b+=" "+f+"='"+g+"'":g.indexOf('"')>=0&&g.indexOf("'")>=0?(g=g.replace(/"/g,"&quot;"),b+=" "+f+'="'+g+'"'):b+=" "+f+'="'+g+'"'}return b}function k(a){for(var b=a.attributes,c=b.length-1;c>=0;c--){var d=b[c];a.removeAttribute(d.nodeName)}}function l(a){return"<"+a.tagName.toLowerCase()+j(a)+">"}function m(a){return"</"+a.tagName.toLowerCase()+">"}function n(a,c){void 0===c&&(c=!0);for(var d=a.previousSibling;d&&c&&b.node.hasClass(d,"fr-marker");)d=d.previousSibling;return!d||d.nodeType==Node.TEXT_NODE&&""===d.textContent&&n(d)}function o(a,c){void 0===c&&(c=!0);for(var d=a.nextSibling;d&&c&&b.node.hasClass(d,"fr-marker");)d=d.nextSibling;return!d||d.nodeType==Node.TEXT_NODE&&""===d.textContent&&o(d)}function p(b){return b&&b.nodeType==Node.ELEMENT_NODE&&a.FE.VOID_ELEMENTS.indexOf((b.tagName||"").toLowerCase())>=0}function q(a){return!!a&&["UL","OL"].indexOf(a.tagName)>=0}function r(a){return a===b.el}function s(a){return a&&a.nodeType==Node.ELEMENT_NODE&&a.getAttribute("class")&&(a.getAttribute("class")||"").indexOf("fr-deletable")>=0}function t(a){return a===b.doc.activeElement&&(!b.doc.hasFocus||b.doc.hasFocus())&&!!(r(a)||a.type||a.href||~a.tabIndex)}function u(a){return(!a.getAttribute||"false"!=a.getAttribute("contenteditable"))&&["STYLE","SCRIPT"].indexOf(a.tagName)<0}function v(b,c){return b instanceof a&&(b=b.get(0)),b&&b.classList&&b.classList.contains(c)}function w(a){return b.browser.msie?a:{acceptNode:a}}return{isBlock:d,isEmpty:f,blockParent:g,deepestParent:h,rawAttributes:i,attributes:j,clearAttributes:k,openTagString:l,closeTagString:m,isFirstSibling:n,isLastSibling:o,isList:q,isLink:e,isElement:r,contents:c,isVoid:p,hasFocus:t,isEditable:u,isDeletable:s,hasClass:v,filter:w}},a.FE.INVISIBLE_SPACE="&#8203;",a.FE.START_MARKER='<span class="fr-marker" data-id="0" data-type="true" style="display: none; line-height: 0;">'+a.FE.INVISIBLE_SPACE+"</span>",a.FE.END_MARKER='<span class="fr-marker" data-id="0" data-type="false" style="display: none; line-height: 0;">'+a.FE.INVISIBLE_SPACE+"</span>",a.FE.MARKERS=a.FE.START_MARKER+a.FE.END_MARKER,a.FE.MODULES.markers=function(b){function c(c,d){return a('<span class="fr-marker" data-id="'+d+'" data-type="'+c+'" style="display: '+(b.browser.safari?"none":"inline-block")+'; line-height: 0;">'+a.FE.INVISIBLE_SPACE+"</span>",b.doc)[0]}function d(d,e,f){var g,h,i;try{var j=d.cloneRange();if(j.collapse(e),j.insertNode(c(e,f)),!0===e)for(g=b.$el.find('span.fr-marker[data-type="true"][data-id="'+f+'"]').get(0),i=g.nextSibling;i&&i.nodeType===Node.TEXT_NODE&&0===i.textContent.length;)a(i).remove(),i=g.nextSibling;if(!0===e&&!d.collapsed){for(;!b.node.isElement(g.parentNode)&&!i;)a(g.parentNode).after(g),i=g.nextSibling;if(i&&i.nodeType===Node.ELEMENT_NODE&&b.node.isBlock(i)){h=[i];do{i=h[0],h=b.node.contents(i)}while(h[0]&&b.node.isBlock(h[0]));a(i).prepend(a(g))}}if(!1===e&&!d.collapsed){if(g=b.$el.find('span.fr-marker[data-type="false"][data-id="'+f+'"]').get(0),(i=g.previousSibling)&&i.nodeType===Node.ELEMENT_NODE&&b.node.isBlock(i)){h=[i];do{i=h[h.length-1],h=b.node.contents(i)}while(h[h.length-1]&&b.node.isBlock(h[h.length-1]));a(i).append(a(g))}g.parentNode&&["TD","TH"].indexOf(g.parentNode.tagName)>=0&&g.parentNode.previousSibling&&!g.previousSibling&&a(g.parentNode.previousSibling).append(g)}var k=b.$el.find('span.fr-marker[data-type="'+e+'"][data-id="'+f+'"]').get(0);return k&&(k.style.display="none"),k}catch(l){return null}}function e(){if(!b.$wp)return null;try{var c=b.selection.ranges(0),d=c.commonAncestorContainer;if(d!=b.el&&0===b.$el.find(d).length)return null;var e=c.cloneRange(),f=c.cloneRange();e.collapse(!0);var g=a('<span class="fr-marker" style="display: none; line-height: 0;">'+a.FE.INVISIBLE_SPACE+"</span>",b.doc)[0];if(e.insertNode(g),g=b.$el.find("span.fr-marker").get(0)){for(var h=g.nextSibling;h&&h.nodeType===Node.TEXT_NODE&&0===h.textContent.length;)a(h).remove(),h=b.$el.find("span.fr-marker").get(0).nextSibling;return b.selection.clear(),b.selection.get().addRange(f),g}return null}catch(i){}}function f(){b.selection.isCollapsed()||b.selection.remove();var c=b.$el.find(".fr-marker").get(0);if(null==c&&(c=e()),null==c)return null;var d=b.node.deepestParent(c);if(d||(d=b.node.blockParent(c))&&"LI"!=d.tagName&&(d=null),d)if(b.node.isBlock(d)&&b.node.isEmpty(d))"LI"!=d.tagName||d.parentNode.firstElementChild!=d||b.node.isEmpty(d.parentNode)?a(d).replaceWith('<span class="fr-marker"></span>'):a(d).append('<span class="fr-marker"></span>');else if(b.cursor.isAtStart(c,d))a(d).before('<span class="fr-marker"></span>'),a(c).remove();else if(b.cursor.isAtEnd(c,d))a(d).after('<span class="fr-marker"></span>'),a(c).remove();else{var f=c,g="",h="";do{f=f.parentNode,g+=b.node.closeTagString(f),h=b.node.openTagString(f)+h}while(f!=d);a(c).replaceWith('<span id="fr-break"></span>');var i=b.node.openTagString(d)+a(d).html()+b.node.closeTagString(d);i=i.replace(/<span id="fr-break"><\/span>/g,g+'<span class="fr-marker"></span>'+h),a(d).replaceWith(i)}return b.$el.find(".fr-marker").get(0)}function g(a){var c=a.clientX,d=a.clientY;h();var f,g=null;if(void 0!==b.doc.caretPositionFromPoint?(f=b.doc.caretPositionFromPoint(c,d),g=b.doc.createRange(),g.setStart(f.offsetNode,f.offset),g.setEnd(f.offsetNode,f.offset)):void 0!==b.doc.caretRangeFromPoint&&(f=b.doc.caretRangeFromPoint(c,d),g=b.doc.createRange(),g.setStart(f.startContainer,f.startOffset),g.setEnd(f.startContainer,f.startOffset)),null!==g&&void 0!==b.win.getSelection){var i=b.win.getSelection();i.removeAllRanges(),i.addRange(g)}else if(void 0!==b.doc.body.createTextRange)try{g=b.doc.body.createTextRange(),g.moveToPoint(c,d);var j=g.duplicate();j.moveToPoint(c,d),g.setEndPoint("EndToEnd",j),g.select()}catch(k){return!1}e()}function h(){b.$el.find(".fr-marker").remove()}return{place:d,insert:e,split:f,insertAtPoint:g,remove:h}},a.FE.MODULES.selection=function(b){function c(){var a="";return b.win.getSelection?a=b.win.getSelection():b.doc.getSelection?a=b.doc.getSelection():b.doc.selection&&(a=b.doc.selection.createRange().text),a.toString()}function d(){return b.win.getSelection?b.win.getSelection():b.doc.getSelection?b.doc.getSelection():b.doc.selection.createRange()}function e(a){var c=d(),e=[];if(c&&c.getRangeAt&&c.rangeCount){e=[];for(var f=0;f<c.rangeCount;f++)e.push(c.getRangeAt(f))}else e=b.doc.createRange?[b.doc.createRange()]:[];return void 0!==a?e[a]:e}function f(){var a=d();try{a.removeAllRanges?a.removeAllRanges():a.empty?a.empty():a.clear&&a.clear()}catch(b){}}function g(){var f=d();try{if(f.rangeCount){var g,h=e(0),i=h.startContainer;if(i.nodeType==Node.TEXT_NODE&&h.startOffset==(i.textContent||"").length&&i.nextSibling&&(i=i.nextSibling),i.nodeType==Node.ELEMENT_NODE){var j=!1;if(i.childNodes.length>0&&i.childNodes[h.startOffset]){for(g=i.childNodes[h.startOffset];g&&g.nodeType==Node.TEXT_NODE&&0===g.textContent.length;)g=g.nextSibling;if(g&&g.textContent.replace(/\u200B/g,"")===c().replace(/\u200B/g,"")&&(i=g,j=!0),!j&&i.childNodes.length>1&&h.startOffset>0&&i.childNodes[h.startOffset-1]){for(g=i.childNodes[h.startOffset-1];g&&g.nodeType==Node.TEXT_NODE&&0===g.textContent.length;)g=g.nextSibling;g&&g.textContent.replace(/\u200B/g,"")===c().replace(/\u200B/g,"")&&(i=g,j=!0)}}else!h.collapsed&&i.nextSibling&&i.nextSibling.nodeType==Node.ELEMENT_NODE&&(g=i.nextSibling)&&g.textContent.replace(/\u200B/g,"")===c().replace(/\u200B/g,"")&&(i=g,j=!0);!j&&i.childNodes.length>0&&a(i.childNodes[0]).text().replace(/\u200B/g,"")===c().replace(/\u200B/g,"")&&["BR","IMG","HR"].indexOf(i.childNodes[0].tagName)<0&&(i=i.childNodes[0])}for(;i.nodeType!=Node.ELEMENT_NODE&&i.parentNode;)i=i.parentNode;for(var k=i;k&&"HTML"!=k.tagName;){if(k==b.el)return i;k=a(k).parent()[0]}}}catch(l){}return b.el}function h(){var f=d();try{if(f.rangeCount){var g,h=e(0),i=h.endContainer;if(i.nodeType==Node.ELEMENT_NODE){var j=!1;i.childNodes.length>0&&i.childNodes[h.endOffset]&&a(i.childNodes[h.endOffset]).text()===c()?(i=i.childNodes[h.endOffset],j=!0):!h.collapsed&&i.previousSibling&&i.previousSibling.nodeType==Node.ELEMENT_NODE?(g=i.previousSibling)&&g.textContent.replace(/\u200B/g,"")===c().replace(/\u200B/g,"")&&(i=g,j=!0):!h.collapsed&&i.childNodes.length>0&&i.childNodes[h.endOffset]&&(g=i.childNodes[h.endOffset].previousSibling,g.nodeType==Node.ELEMENT_NODE&&g&&g.textContent.replace(/\u200B/g,"")===c().replace(/\u200B/g,"")&&(i=g,j=!0)),!j&&i.childNodes.length>0&&a(i.childNodes[i.childNodes.length-1]).text()===c()&&["BR","IMG","HR"].indexOf(i.childNodes[i.childNodes.length-1].tagName)<0&&(i=i.childNodes[i.childNodes.length-1])}for(i.nodeType==Node.TEXT_NODE&&0===h.endOffset&&i.previousSibling&&i.previousSibling.nodeType==Node.ELEMENT_NODE&&(i=i.previousSibling);i.nodeType!=Node.ELEMENT_NODE&&i.parentNode;)i=i.parentNode;for(var k=i;k&&"HTML"!=k.tagName;){if(k==b.el)return i;k=a(k).parent()[0]}}}catch(l){}return b.el}function i(a,b){var c=a;return c.nodeType==Node.ELEMENT_NODE&&c.childNodes.length>0&&c.childNodes[b]&&(c=c.childNodes[b]),c.nodeType==Node.TEXT_NODE&&(c=c.parentNode),c}function j(){var c,f=[],g=d();if(u()&&g.rangeCount){var h=e();for(c=0;c<h.length;c++){var j,k=h[c],l=i(k.startContainer,k.startOffset),m=i(k.endContainer,k.endOffset);b.node.isBlock(l)&&f.indexOf(l)<0&&f.push(l),j=b.node.blockParent(l),j&&f.indexOf(j)<0&&f.push(j);for(var n=[],o=l;o!==m&&o!==b.el;)n.indexOf(o)<0&&o.children&&o.children.length?(n.push(o),o=o.children[0]):o.nextSibling?o=o.nextSibling:o.parentNode&&(o=o.parentNode,n.push(o)),b.node.isBlock(o)&&n.indexOf(o)<0&&f.indexOf(o)<0&&(o!==m||k.endOffset>0)&&f.push(o);b.node.isBlock(m)&&f.indexOf(m)<0&&k.endOffset>0&&f.push(m),j=b.node.blockParent(m),j&&f.indexOf(j)<0&&f.push(j)}}for(c=f.length-1;c>0;c--)a(f[c]).find(f).length&&("LI"!=f[c].tagName||f[c].children.length>0&&f.indexOf(f[c].children[0])>=0)&&f.splice(c,1);return f}function k(){if(b.$wp){b.markers.remove();var c,d,f=e(),g=[];for(d=0;d<f.length;d++)if(f[d].startContainer!==b.doc||b.browser.msie){c=f[d];var h=c.collapsed,i=b.markers.place(c,!0,d),j=b.markers.place(c,!1,d);void 0!==i&&i||!h||(a(".fr-marker").remove(),b.selection.setAtEnd(b.el)),b.el.normalize(),b.browser.safari&&!h&&(c=b.doc.createRange(),c.setStartAfter(i),c.setEndBefore(j),g.push(c))}if(b.browser.safari&&g.length)for(b.selection.clear(),d=0;d<g.length;d++)b.selection.get().addRange(g[d])}}function l(){var c,e=b.el.querySelectorAll('.fr-marker[data-type="true"]');if(!b.$wp)return b.markers.remove(),!1;if(0===e.length)return!1;if(b.browser.msie||b.browser.edge)for(c=0;c<e.length;c++)e[c].style.display="inline-block";b.core.hasFocus()||b.browser.msie||b.browser.webkit||b.$el.focus(),f();var g=d();for(c=0;c<e.length;c++){var h=a(e[c]).data("id"),i=e[c],j=b.doc.createRange(),k=b.$el.find('.fr-marker[data-type="false"][data-id="'+h+'"]');(b.browser.msie||b.browser.edge)&&k.css("display","inline-block");var l=null;if(k.length>0){k=k[0];try{for(var n,o=!1,p=i.nextSibling;p&&p.nodeType==Node.TEXT_NODE&&0===p.textContent.length;)n=p,p=p.nextSibling,a(n).remove();for(var q=k.nextSibling;q&&q.nodeType==Node.TEXT_NODE&&0===q.textContent.length;)n=q,q=q.nextSibling,a(n).remove();if(i.nextSibling==k||k.nextSibling==i){for(var r=i.nextSibling==k?i:k,s=r==i?k:i,t=r.previousSibling;t&&t.nodeType==Node.TEXT_NODE&&0===t.length;)n=t,t=t.previousSibling,a(n).remove();if(t&&t.nodeType==Node.TEXT_NODE)for(;t&&t.previousSibling&&t.previousSibling.nodeType==Node.TEXT_NODE;)t.previousSibling.textContent=t.previousSibling.textContent+t.textContent,t=t.previousSibling,a(t.nextSibling).remove();for(var u=s.nextSibling;u&&u.nodeType==Node.TEXT_NODE&&0===u.length;)n=u,u=u.nextSibling,a(n).remove();if(u&&u.nodeType==Node.TEXT_NODE)for(;u&&u.nextSibling&&u.nextSibling.nodeType==Node.TEXT_NODE;)u.nextSibling.textContent=u.textContent+u.nextSibling.textContent,u=u.nextSibling,a(u.previousSibling).remove();if(t&&(b.node.isVoid(t)||b.node.isBlock(t))&&(t=null),u&&(b.node.isVoid(u)||b.node.isBlock(u))&&(u=null),t&&u&&t.nodeType==Node.TEXT_NODE&&u.nodeType==Node.TEXT_NODE){
a(i).remove(),a(k).remove();var v=t.textContent.length;t.textContent=t.textContent+u.textContent,a(u).remove(),b.spaces.normalize(t),j.setStart(t,v),j.setEnd(t,v),o=!0}else!t&&u&&u.nodeType==Node.TEXT_NODE?(a(i).remove(),a(k).remove(),b.spaces.normalize(u),l=a(b.doc.createTextNode("\u200b")),a(u).before(l),j.setStart(u,0),j.setEnd(u,0),o=!0):!u&&t&&t.nodeType==Node.TEXT_NODE&&(a(i).remove(),a(k).remove(),b.spaces.normalize(t),l=a(b.doc.createTextNode("\u200b")),a(t).after(l),j.setStart(t,t.textContent.length),j.setEnd(t,t.textContent.length),o=!0)}if(!o){var w,x;(b.browser.chrome||b.browser.edge)&&i.nextSibling==k?(w=m(k,j,!0)||j.setStartAfter(k),x=m(i,j,!1)||j.setEndBefore(i)):(i.previousSibling==k&&(i=k,k=i.nextSibling),k.nextSibling&&"BR"===k.nextSibling.tagName||!k.nextSibling&&b.node.isBlock(i.previousSibling)||i.previousSibling&&"BR"==i.previousSibling.tagName||(i.style.display="inline",k.style.display="inline",l=a(b.doc.createTextNode("\u200b"))),w=m(i,j,!0)||a(i).before(l)&&j.setStartBefore(i),x=m(k,j,!1)||a(k).after(l)&&j.setEndAfter(k)),"function"==typeof w&&w(),"function"==typeof x&&x()}}catch(y){}}l&&l.remove();try{g.addRange(j)}catch(y){}}b.markers.remove()}function m(c,d,e){var f,g=c.previousSibling,h=c.nextSibling;return g&&h&&g.nodeType==Node.TEXT_NODE&&h.nodeType==Node.TEXT_NODE?(f=g.textContent.length,e?(h.textContent=g.textContent+h.textContent,a(g).remove(),a(c).remove(),b.spaces.normalize(h),function(){d.setStart(h,f)}):(g.textContent=g.textContent+h.textContent,a(h).remove(),a(c).remove(),b.spaces.normalize(g),function(){d.setEnd(g,f)})):g&&!h&&g.nodeType==Node.TEXT_NODE?(f=g.textContent.length,e?(b.spaces.normalize(g),function(){d.setStart(g,f)}):(b.spaces.normalize(g),function(){d.setEnd(g,f)})):!(!h||g||h.nodeType!=Node.TEXT_NODE)&&(e?(b.spaces.normalize(h),function(){d.setStart(h,0)}):(b.spaces.normalize(h),function(){d.setEnd(h,0)}))}function n(){return!0}function o(){for(var a=e(),b=0;b<a.length;b++)if(!a[b].collapsed)return!1;return!0}function p(a){var c,d,e=!1,f=!1;if(b.win.getSelection){var g=b.win.getSelection();g.rangeCount&&(c=g.getRangeAt(0),d=c.cloneRange(),d.selectNodeContents(a),d.setEnd(c.startContainer,c.startOffset),e=""===d.toString(),d.selectNodeContents(a),d.setStart(c.endContainer,c.endOffset),f=""===d.toString())}else b.doc.selection&&"Control"!=b.doc.selection.type&&(c=b.doc.selection.createRange(),d=c.duplicate(),d.moveToElementText(a),d.setEndPoint("EndToStart",c),e=""===d.text,d.moveToElementText(a),d.setEndPoint("StartToEnd",c),f=""===d.text);return{atStart:e,atEnd:f}}function q(){if(o())return!1;b.$el.find("td, th, img, br:not(:last)").prepend('<span class="fr-mk">'+a.FE.INVISIBLE_SPACE+"</span>");var c=!1,d=p(b.el);return d.atStart&&d.atEnd&&(c=!0),b.$el.find(".fr-mk").remove(),c}function r(c,d){void 0===d&&(d=!0);var e=a(c).html();e&&e.replace(/\u200b/g,"").length!=e.length&&a(c).html(e.replace(/\u200b/g,""));for(var f=b.node.contents(c),g=0;g<f.length;g++)f[g].nodeType!=Node.ELEMENT_NODE?a(f[g]).remove():(r(f[g],0===g),0===g&&(d=!1));c.nodeType==Node.TEXT_NODE?a(c).replaceWith('<span data-first="true" data-text="true"></span>'):d&&a(c).attr("data-first",!0)}function s(){return 0===a(this).find("fr-inner").length}function t(c,d){var e=b.node.contents(c.get(0));["TD","TH"].indexOf(c.get(0).tagName)>=0&&1==c.find(".fr-marker").length&&b.node.hasClass(e[0],"fr-marker")&&c.attr("data-del-cell",!0);for(var f=0;f<e.length;f++){var g=e[f];b.node.hasClass(g,"fr-marker")?d=(d+1)%2:d?a(g).find(".fr-marker").length>0?d=t(a(g),d):["TD","TH"].indexOf(g.tagName)<0&&!b.node.hasClass(g,"fr-inner")?!b.opts.keepFormatOnDelete||b.$el.find("[data-first]").length>0?a(g).remove():r(g):b.node.hasClass(g,"fr-inner")?0===a(g).find(".fr-inner").length?a(g).html("<br>"):a(g).find(".fr-inner").filter(s).html("<br>"):(a(g).empty(),a(g).attr("data-del-cell",!0)):a(g).find(".fr-marker").length>0&&(d=t(a(g),d))}return d}function u(){try{if(!b.$wp)return!1;for(var a=e(0),c=a.commonAncestorContainer;c&&!b.node.isElement(c);)c=c.parentNode;return!!b.node.isElement(c)}catch(d){return!1}}function v(){if(o())return!0;var c;k();var d=function(b){for(var c=b.previousSibling;c&&c.nodeType==Node.TEXT_NODE&&0===c.textContent.length;){var d=c;c=c.previousSibling,a(d).remove()}return c},e=function(b){for(var c=b.nextSibling;c&&c.nodeType==Node.TEXT_NODE&&0===c.textContent.length;){var d=c;c=c.nextSibling,a(d).remove()}return c},f=b.$el.find('.fr-marker[data-type="true"]');for(c=0;c<f.length;c++)for(var g=f[c];!(d(g)||b.node.isBlock(g.parentNode)||b.$el.is(g.parentNode)||b.node.hasClass(g.parentNode,"fr-inner"));)a(g.parentNode).before(g);var h=b.$el.find('.fr-marker[data-type="false"]');for(c=0;c<h.length;c++){for(var i=h[c];!(e(i)||b.node.isBlock(i.parentNode)||b.$el.is(i.parentNode)||b.node.hasClass(i.parentNode,"fr-inner"));)a(i.parentNode).after(i);i.parentNode&&b.node.isBlock(i.parentNode)&&b.node.isEmpty(i.parentNode)&&!b.$el.is(i.parentNode)&&!b.node.hasClass(i.parentNode,"fr-inner")&&b.opts.keepFormatOnDelete&&a(i.parentNode).after(i)}if(n()){t(b.$el,0);var j=b.$el.find('[data-first="true"]');if(j.length)b.$el.find(".fr-marker").remove(),j.append(a.FE.INVISIBLE_SPACE+a.FE.MARKERS).removeAttr("data-first"),j.attr("data-text")&&j.replaceWith(j.html());else for(b.$el.find("table").filter(function(){return a(this).find("[data-del-cell]").length>0&&a(this).find("[data-del-cell]").length==a(this).find("td, th").length}).remove(),b.$el.find("[data-del-cell]").removeAttr("data-del-cell"),f=b.$el.find('.fr-marker[data-type="true"]'),c=0;c<f.length;c++){var m=f[c],p=m.nextSibling,q=b.$el.find('.fr-marker[data-type="false"][data-id="'+a(m).data("id")+'"]').get(0);if(q){if(m&&(!p||p!=q)){var r=b.node.blockParent(m),s=b.node.blockParent(q),u=!1,v=!1;if(r&&["UL","OL"].indexOf(r.tagName)>=0&&(r=null,u=!0),s&&["UL","OL"].indexOf(s.tagName)>=0&&(s=null,v=!0),a(m).after(q),r!=s)if(null!=r||u)if(null!=s||v||0!==a(r).parentsUntil(b.$el,"table").length)r&&s&&0===a(r).parentsUntil(b.$el,"table").length&&0===a(s).parentsUntil(b.$el,"table").length&&0===a(r).find(s).length&&0===a(s).find(r).length&&(a(r).append(a(s).html()),a(s).remove());else{for(p=r;!p.nextSibling&&p.parentNode!=b.el;)p=p.parentNode;for(p=p.nextSibling;p&&"BR"!=p.tagName;){var w=p.nextSibling;a(r).append(p),p=w}p&&"BR"==p.tagName&&a(p).remove()}else{var x=b.node.deepestParent(m);x?(a(x).after(a(s).html()),a(s).remove()):0===a(s).parentsUntil(b.$el,"table").length&&(a(m).next().after(a(s).html()),a(s).remove())}}}else q=a(m).clone().attr("data-type",!1),a(m).after(q)}}b.opts.keepFormatOnDelete||b.html.fillEmptyBlocks(),b.html.cleanEmptyTags(!0),b.clean.lists(),b.opts.htmlUntouched||b.spaces.normalize();var y=b.$el.find(".fr-marker:last").get(0),z=b.$el.find(".fr-marker:first").get(0);void 0!==y&&void 0!==z&&!y.nextSibling&&z.previousSibling&&"BR"==z.previousSibling.tagName&&b.node.isElement(y.parentNode)&&b.node.isElement(z.parentNode)&&b.$el.append("<br>"),l()}function w(c,d){if(!c||c.getElementsByClassName("fr-marker").length>0)return!1;for(var e=c.firstChild;e&&(b.node.isBlock(e)||d&&!b.node.isVoid(e)&&e.nodeType==Node.ELEMENT_NODE);)c=e,e=e.firstChild;c.innerHTML=a.FE.MARKERS+c.innerHTML}function x(c,d){if(!c||c.getElementsByClassName("fr-marker").length>0)return!1;for(var e=c.lastChild;e&&(b.node.isBlock(e)||d&&!b.node.isVoid(e)&&e.nodeType==Node.ELEMENT_NODE);)c=e,e=e.lastChild;var f=b.doc.createElement("SPAN");f.setAttribute("id","fr-sel-markers"),f.innerHTML=a.FE.MARKERS,c.appendChild(f);var g=c.querySelector("#fr-sel-markers");g.outerHTML=g.innerHTML}function y(c,d){void 0===d&&(d=!0);for(var e=c.previousSibling;e&&e.nodeType==Node.TEXT_NODE&&0===e.textContent.length;)e=e.previousSibling;return e?(b.node.isBlock(e)?x(e):"BR"==e.tagName?a(e).before(a.FE.MARKERS):a(e).after(a.FE.MARKERS),!0):!!d&&(b.node.isBlock(c)?w(c):a(c).before(a.FE.MARKERS),!0)}function z(c,d){void 0===d&&(d=!0);for(var e=c.nextSibling;e&&e.nodeType==Node.TEXT_NODE&&0===e.textContent.length;)e=e.nextSibling;return e?(b.node.isBlock(e)?w(e):a(e).before(a.FE.MARKERS),!0):!!d&&(b.node.isBlock(c)?x(c):a(c).after(a.FE.MARKERS),!0)}return{text:c,get:d,ranges:e,clear:f,element:g,endElement:h,save:k,restore:l,isCollapsed:o,isFull:q,inEditor:u,remove:v,blocks:j,info:p,setAtEnd:x,setAtStart:w,setBefore:y,setAfter:z,rangeElement:i}},a.extend(a.FE.DEFAULTS,{htmlAllowedTags:["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","br","button","canvas","caption","cite","code","col","colgroup","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","menu","menuitem","meter","nav","noscript","object","ol","optgroup","option","output","p","param","pre","progress","queue","rp","rt","ruby","s","samp","script","style","section","select","small","source","span","strike","strong","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","tr","track","u","ul","var","video","wbr"],htmlRemoveTags:["script","style"],htmlAllowedAttrs:["accept","accept-charset","accesskey","action","align","allowfullscreen","allowtransparency","alt","async","autocomplete","autofocus","autoplay","autosave","background","bgcolor","border","charset","cellpadding","cellspacing","checked","cite","class","color","cols","colspan","content","contenteditable","contextmenu","controls","coords","data","data-.*","datetime","default","defer","dir","dirname","disabled","download","draggable","dropzone","enctype","for","form","formaction","frameborder","headers","height","hidden","high","href","hreflang","http-equiv","icon","id","ismap","itemprop","keytype","kind","label","lang","language","list","loop","low","max","maxlength","media","method","min","mozallowfullscreen","multiple","muted","name","novalidate","open","optimum","pattern","ping","placeholder","playsinline","poster","preload","pubdate","radiogroup","readonly","rel","required","reversed","rows","rowspan","sandbox","scope","scoped","scrolling","seamless","selected","shape","size","sizes","span","src","srcdoc","srclang","srcset","start","step","summary","spellcheck","style","tabindex","target","title","type","translate","usemap","value","valign","webkitallowfullscreen","width","wrap"],htmlAllowedStyleProps:[".*"],htmlAllowComments:!0,htmlUntouched:!1,fullPage:!1}),a.FE.HTML5Map={B:"STRONG",I:"EM",STRIKE:"S"},a.FE.MODULES.clean=function(b){function c(a){if(a.nodeType==Node.ELEMENT_NODE&&a.getAttribute("class")&&a.getAttribute("class").indexOf("fr-marker")>=0)return!1;var d,e=b.node.contents(a),f=[];for(d=0;d<e.length;d++)e[d].nodeType!=Node.ELEMENT_NODE||b.node.isVoid(e[d])?e[d].nodeType==Node.TEXT_NODE&&(e[d].textContent=e[d].textContent.replace(/\u200b/g,"")):e[d].textContent.replace(/\u200b/g,"").length!=e[d].textContent.length&&c(e[d]);if(a.nodeType==Node.ELEMENT_NODE&&!b.node.isVoid(a)&&(a.normalize(),e=b.node.contents(a),f=a.querySelectorAll(".fr-marker"),e.length-f.length==0)){for(d=0;d<e.length;d++)if((e[d].getAttribute("class")||"").indexOf("fr-marker")<0)return!1;for(d=0;d<f.length;d++)a.parentNode.insertBefore(f[d].cloneNode(!0),a);return a.parentNode.removeChild(a),!1}}function d(a,c){if(a.nodeType==Node.COMMENT_NODE)return"\x3c!--"+a.nodeValue+"--\x3e";if(a.nodeType==Node.TEXT_NODE)return c?a.textContent.replace(/\&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"):a.textContent.replace(/\&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\u00A0/g,"&nbsp;").replace(/\u0009/g,"");if(a.nodeType!=Node.ELEMENT_NODE)return a.outerHTML;if(a.nodeType==Node.ELEMENT_NODE&&["STYLE","SCRIPT","NOSCRIPT"].indexOf(a.tagName)>=0)return a.outerHTML;if(a.nodeType==Node.ELEMENT_NODE&&"svg"==a.tagName){var e=document.createElement("div"),f=a.cloneNode(!0);return e.appendChild(f),e.innerHTML}if("IFRAME"==a.tagName)return a.outerHTML.replace(/\&lt;/g,"<").replace(/\&gt;/g,">");var g=a.childNodes;if(0===g.length)return a.outerHTML;for(var h="",i=0;i<g.length;i++)"PRE"==a.tagName&&(c=!0),h+=d(g[i],c);return b.node.openTagString(a)+h+b.node.closeTagString(a)}function e(a){return I=[],a=a.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,function(a){return I.push(a),"[FROALA.EDITOR.SCRIPT "+(I.length-1)+"]"}),a=a.replace(/<noscript\b[^<]*(?:(?!<\/noscript>)<[^<]*)*<\/noscript>/gi,function(a){return I.push(a),"[FROALA.EDITOR.NOSCRIPT "+(I.length-1)+"]"}),a=a.replace(/<img((?:[\w\W]*?)) src="/g,'<img$1 data-fr-src="')}function f(a){return a=a.replace(/\[FROALA\.EDITOR\.SCRIPT ([\d]*)\]/gi,function(a,c){return b.opts.htmlRemoveTags.indexOf("script")>=0?"":I[parseInt(c,10)]}),a=a.replace(/\[FROALA\.EDITOR\.NOSCRIPT ([\d]*)\]/gi,function(a,c){return b.opts.htmlRemoveTags.indexOf("noscript")>=0?"":I[parseInt(c,10)].replace(/\&lt;/g,"<").replace(/\&gt;/g,">")}),a=a.replace(/<img((?:[\w\W]*?)) data-fr-src="/g,'<img$1 src="')}function g(a){var b=a.replace(/;;/gi,";");return b=b.replace(/^;/gi,""),";"!=b.charAt(b.length)&&(b+=";"),b}function h(a){var c;for(c in a)if(a.hasOwnProperty(c)){var d=c.match(G),e=null;"style"==c&&b.opts.htmlAllowedStyleProps.length&&(e=a[c].match(H)),d&&e?a[c]=g(e.join(";")):d&&("style"!=c||e)||delete a[c]}for(var f="",h=Object.keys(a).sort(),i=0;i<h.length;i++)c=h[i],a[c].indexOf('"')<0?f+=" "+c+'="'+a[c]+'"':f+=" "+c+"='"+a[c]+"'";return f}function i(a,c,d){if(b.opts.fullPage){var e=b.html.extractDoctype(d),f=h(b.html.extractNodeAttrs(d,"html"));c=null==c?b.html.extractNode(d,"head")||"<title></title>":c;return e+"<html"+f+"><head"+h(b.html.extractNodeAttrs(d,"head"))+">"+c+"</head><body"+h(b.html.extractNodeAttrs(d,"body"))+">"+a+"</body></html>"}return a}function j(c,e){var f,g=a("<div>"+c+"</div>"),h="";if(g){var i=b.node.contents(g.get(0));for(f=0;f<i.length;f++)e(i[f]);for(i=b.node.contents(g.get(0)),f=0;f<i.length;f++)h+=d(i[f])}return h}function k(a,c,d){a=e(a);var g=a,h=null;return b.opts.fullPage&&(g=b.html.extractNode(a,"body")||(a.indexOf("<body")>=0?"":a),d&&(h=b.html.extractNode(a,"head")||"")),g=j(g,c),h&&(h=j(h,c)),f(i(g,h,a))}function l(a){return a.replace(/\u200b/g,"").length==a.length?a:b.clean.exec(a,c)}function m(){var c=b.el.querySelectorAll(Object.keys(a.FE.HTML5Map).join(","));if(c.length){var d=!1;b.el.querySelector(".fr-marker")||(b.selection.save(),d=!0);for(var e=0;e<c.length;e++)""===b.node.attributes(c[e])&&a(c[e]).replaceWith("<"+a.FE.HTML5Map[c[e].tagName]+">"+c[e].innerHTML+"</"+a.FE.HTML5Map[c[e].tagName]+">");d&&b.selection.restore()}}function n(a){var c=b.doc.createElement("DIV");return c.innerText=a,c.textContent}function o(c){if("SPAN"==c.tagName&&(c.getAttribute("class")||"").indexOf("fr-marker")>=0)return!1;if("PRE"==c.tagName&&q(c),c.nodeType==Node.ELEMENT_NODE&&(c.getAttribute("data-fr-src")&&0!==c.getAttribute("data-fr-src").indexOf("blob:")&&c.setAttribute("data-fr-src",b.helpers.sanitizeURL(n(c.getAttribute("data-fr-src")))),c.getAttribute("href")&&c.setAttribute("href",b.helpers.sanitizeURL(n(c.getAttribute("href")))),c.getAttribute("src")&&c.setAttribute("src",b.helpers.sanitizeURL(n(c.getAttribute("src")))),["TABLE","TBODY","TFOOT","TR"].indexOf(c.tagName)>=0&&(c.innerHTML=c.innerHTML.trim())),!b.opts.pasteAllowLocalImages&&c.nodeType==Node.ELEMENT_NODE&&"IMG"==c.tagName&&c.getAttribute("data-fr-src")&&0===c.getAttribute("data-fr-src").indexOf("file://"))return c.parentNode.removeChild(c),!1;if(c.nodeType==Node.ELEMENT_NODE&&a.FE.HTML5Map[c.tagName]&&""===b.node.attributes(c)){var d=a.FE.HTML5Map[c.tagName],e="<"+d+">"+c.innerHTML+"</"+d+">";c.insertAdjacentHTML("beforebegin",e),c=c.previousSibling,c.parentNode.removeChild(c.nextSibling)}if(b.opts.htmlAllowComments||c.nodeType!=Node.COMMENT_NODE)if(c.tagName&&c.tagName.match(F))c.parentNode.removeChild(c);else if(c.tagName&&!c.tagName.match(E))"svg"===c.tagName?c.parentNode.removeChild(c):b.browser.safari&&"path"==c.tagName&&c.parentNode&&"svg"==c.parentNode.tagName||(c.outerHTML=c.innerHTML);else{var f=c.attributes;if(f)for(var h=f.length-1;h>=0;h--){var i=f[h],j=i.nodeName.match(G),k=null;"style"==i.nodeName&&b.opts.htmlAllowedStyleProps.length&&(k=i.value.match(H)),j&&k?i.value=g(k.join(";")):j&&("style"!=i.nodeName||k)||c.removeAttribute(i.nodeName)}}else 0!==c.data.indexOf("[FROALA.EDITOR")&&c.parentNode.removeChild(c)}function p(a){for(var c=b.node.contents(a),d=0;d<c.length;d++)c[d].nodeType!=Node.TEXT_NODE&&p(c[d]);o(a)}function q(a){var b=a.innerHTML;b.indexOf("\n")>=0&&(a.innerHTML=b.replace(/\n/g,"<br>"))}function r(c,d,e,f){void 0===d&&(d=[]),void 0===e&&(e=[]),void 0===f&&(f=!1),c=c.replace(/<br> */g,"<br>");var g,h=a.merge([],b.opts.htmlAllowedTags);for(g=0;g<d.length;g++)h.indexOf(d[g])>=0&&h.splice(h.indexOf(d[g]),1);var i=a.merge([],b.opts.htmlAllowedAttrs);for(g=0;g<e.length;g++)i.indexOf(e[g])>=0&&i.splice(i.indexOf(e[g]),1);return i.push("data-fr-.*"),i.push("fr-.*"),E=new RegExp("^"+h.join("$|^")+"$","gi"),G=new RegExp("^"+i.join("$|^")+"$","gi"),F=new RegExp("^"+b.opts.htmlRemoveTags.join("$|^")+"$","gi"),H=b.opts.htmlAllowedStyleProps.length?new RegExp("((^|;|\\s)"+b.opts.htmlAllowedStyleProps.join(":.+?(?=;|$))|((^|;|\\s)")+":.+?(?=(;)|$))","gi"):null,c=k(c,p,!0)}function s(){for(var a=b.el.querySelectorAll("tr"),c=0;c<a.length;c++){for(var d=a[c].children,e=!0,f=0;f<d.length;f++)if("TH"!=d[f].tagName){e=!1;break}if(!1!==e&&0!==d.length){for(var g=a[c];g&&"TABLE"!=g.tagName&&"THEAD"!=g.tagName;)g=g.parentNode;var h=g;"THEAD"!=h.tagName&&(h=b.doc.createElement("THEAD"),g.insertBefore(h,g.firstChild)),h.appendChild(a[c])}}}function t(){s()}function u(){var a=[],c=function(a){return!b.node.isList(a.parentNode)};do{if(a.length){var d=a[0],e=b.doc.createElement("ul");d.parentNode.insertBefore(e,d);do{var f=d;d=d.nextSibling,e.appendChild(f)}while(d&&"LI"==d.tagName)}a=[];for(var g=b.el.querySelectorAll("li"),h=0;h<g.length;h++)c(g[h])&&a.push(g[h])}while(a.length>0)}function v(){for(var a=b.el.querySelectorAll("ol + ol, ul + ul"),c=0;c<a.length;c++){var d=a[c];if(b.node.isList(d.previousSibling)&&b.node.openTagString(d)==b.node.openTagString(d.previousSibling)){for(var e=b.node.contents(d),f=0;f<e.length;f++)d.previousSibling.appendChild(e[f]);d.parentNode.removeChild(d)}}}function w(){var a,c,d=function(a){a.querySelector("LI")||(c=!0,a.parentNode.removeChild(a))};do{c=!1;var e=b.el.querySelectorAll("li:empty");for(a=0;a<e.length;a++)e[a].parentNode.removeChild(e[a]);var f=b.el.querySelectorAll("ul, ol");for(a=0;a<f.length;a++)d(f[a])}while(!0===c)}function x(){for(var c=b.el.querySelectorAll("ul > ul, ol > ol, ul > ol, ol > ul"),d=0;d<c.length;d++){var e=c[d],f=e.previousSibling;f&&("LI"==f.tagName?f.appendChild(e):a(e).wrap("<li></li>"))}}function y(){for(var c=b.el.querySelectorAll("li > ul, li > ol"),d=0;d<c.length;d++){var e=c[d];if(e.nextSibling){var f=e.nextSibling,g=a("<li>");a(e.parentNode).after(g);do{var h=f;f=f.nextSibling,g.append(h)}while(f)}}}function z(){for(var c=b.el.querySelectorAll("li > ul, li > ol"),d=0;d<c.length;d++){var e=c[d];if(b.node.isFirstSibling(e))a(e).before("<br/>");else if(e.previousSibling&&"BR"==e.previousSibling.tagName){for(var f=e.previousSibling.previousSibling;f&&b.node.hasClass(f,"fr-marker");)f=f.previousSibling;f&&"BR"!=f.tagName&&a(e.previousSibling).remove()}}}function A(){for(var c=b.el.querySelectorAll("li:empty"),d=0;d<c.length;d++)a(c[d]).remove()}function B(){for(var c=b.el.querySelectorAll("ul, ol"),d=0;d<c.length;d++)for(var e=b.node.contents(c[d]),f=null,g=e.length-1;g>=0;g--)"LI"!=e[g].tagName?(f||(f=a("<li>"),f.insertBefore(e[g])),f.prepend(e[g])):f=null}function C(){u(),v(),B(),w(),x(),y(),z(),A()}function D(){b.opts.fullPage&&a.merge(b.opts.htmlAllowedTags,["head","title","style","link","base","body","html","meta"])}var E,F,G,H,I=[];return{_init:D,html:r,toHTML5:m,tables:t,lists:C,invisibleSpaces:l,exec:k}},a.FE.MODULES.spaces=function(b){function c(c,d){var e=c.previousSibling,f=c.nextSibling,g=c.textContent,h=c.parentNode;if(!b.html.isPreformatted(h)){d&&(g=g.replace(/[\f\n\r\t\v ]{2,}/g," "),f&&"BR"!==f.tagName&&!b.node.isBlock(f)||!(b.node.isBlock(h)||b.node.isLink(h)||b.node.isElement(h))||(g=g.replace(/[\f\n\r\t\v ]{1,}$/g,"")),e&&"BR"!==e.tagName&&!b.node.isBlock(e)||!(b.node.isBlock(h)||b.node.isLink(h)||b.node.isElement(h))||(g=g.replace(/^[\f\n\r\t\v ]{1,}/g,""))," "===g&&(e&&b.node.isVoid(e)||f&&b.node.isVoid(f))&&(g="")),g=g.replace(new RegExp(a.FE.UNICODE_NBSP,"g")," ");for(var i="",j=0;j<g.length;j++)32!=g.charCodeAt(j)||0!==j&&32!=i.charCodeAt(j-1)?i+=g[j]:i+=a.FE.UNICODE_NBSP;(!f||f&&b.node.isBlock(f)||f&&f.nodeType==Node.ELEMENT_NODE&&b.win.getComputedStyle(f)&&"block"==b.win.getComputedStyle(f).display)&&(i=i.replace(/ $/,a.FE.UNICODE_NBSP)),!e||b.node.isVoid(e)||b.node.isBlock(e)||(i=i.replace(/^\u00A0([^ $])/," $1"),1!==i.length||160!==i.charCodeAt(0)||!f||b.node.isVoid(f)||b.node.isBlock(f)||(i=" ")),i=i.replace(/([^ \u00A0])\u00A0([^ \u00A0])/g,"$1 $2"),c.textContent!=i&&(c.textContent=i)}}function d(a,d){if(void 0!==a&&a||(a=b.el),void 0===d&&(d=!1),!a.getAttribute||"false"!=a.getAttribute("contenteditable"))if(a.nodeType==Node.TEXT_NODE)c(a,d);else if(a.nodeType==Node.ELEMENT_NODE)for(var e=b.doc.createTreeWalker(a,NodeFilter.SHOW_TEXT,b.node.filter(function(a){for(var c=a.parentNode;c&&c!==b.el;){if("STYLE"==c.tagName||"IFRAME"==c.tagName)return!1;if("PRE"===c.tagName)return!1;c=c.parentNode}return null!=a.textContent.match(/([ \u00A0\f\n\r\t\v]{2,})|(^[ \u00A0\f\n\r\t\v]{1,})|([ \u00A0\f\n\r\t\v]{1,}$)/g)&&!b.node.hasClass(a.parentNode,"fr-marker")}),!1);e.nextNode();)c(e.currentNode,d)}function e(){for(var a=[],c=b.el.querySelectorAll(".fr-marker"),e=0;e<c.length;e++){var f=null,g=b.node.blockParent(c[e]);f=g||c[e];for(var h=f.nextSibling,i=f.previousSibling;h&&"BR"==h.tagName;)h=h.nextSibling;for(;i&&"BR"==i.tagName;)i=i.previousSibling;f&&a.indexOf(f)<0&&a.push(f),i&&a.indexOf(i)<0&&a.push(i),h&&a.indexOf(h)<0&&a.push(h)}for(var j=0;j<a.length;j++)d(a[j])}return{normalize:d,normalizeAroundCursor:e}},a.FE.UNICODE_NBSP=String.fromCharCode(160),a.FE.VOID_ELEMENTS=["area","base","br","col","embed","hr","img","input","keygen","link","menuitem","meta","param","source","track","wbr"],a.FE.BLOCK_TAGS=["address","article","aside","audio","blockquote","canvas","dd","div","dl","dt","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","header","hgroup","hr","li","main","nav","noscript","ol","output","p","pre","section","table","tbody","td","tfoot","th","thead","tr","ul","video"],a.extend(a.FE.DEFAULTS,{htmlAllowedEmptyTags:["textarea","a","iframe","object","video","style","script",".fa",".fr-emoticon",".fr-inner"],htmlDoNotWrapTags:["script","style"],htmlSimpleAmpersand:!1,htmlIgnoreCSSProperties:[],htmlExecuteScripts:!0}),a.FE.MODULES.html=function(b){function c(){return b.opts.enter==a.FE.ENTER_P?"p":b.opts.enter==a.FE.ENTER_DIV?"div":b.opts.enter==a.FE.ENTER_BR?null:void 0}function d(a,c){return!(!a||a===b.el)&&(c?-1!=["PRE","SCRIPT","STYLE"].indexOf(a.tagName)||d(a.parentNode,c):-1!=["PRE","SCRIPT","STYLE"].indexOf(a.tagName))}function e(c){var d,e=[],f=[];if(c){var h=b.el.querySelectorAll(".fr-marker");for(d=0;d<h.length;d++){var i=b.node.blockParent(h[d])||h[d];if(i){var j=i.nextSibling,k=i.previousSibling;i&&f.indexOf(i)<0&&b.node.isBlock(i)&&f.push(i),k&&b.node.isBlock(k)&&f.indexOf(k)<0&&f.push(k),j&&b.node.isBlock(j)&&f.indexOf(j)<0&&f.push(j)}}}else f=b.el.querySelectorAll(g());var l=g();for(l+=","+a.FE.VOID_ELEMENTS.join(","),l+=", .fr-inner",l+=","+b.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),")+":not(.fr-marker)",d=f.length-1;d>=0;d--)if(!(f[d].textContent&&f[d].textContent.replace(/\u200B|\n/g,"").length>0||f[d].querySelectorAll(l).length>0)){for(var m=b.node.contents(f[d]),n=!1,o=0;o<m.length;o++)if(m[o].nodeType!=Node.COMMENT_NODE&&m[o].textContent&&m[o].textContent.replace(/\u200B|\n/g,"").length>0){n=!0;break}n||e.push(f[d])}return e}function f(){return a.FE.BLOCK_TAGS.join(":empty, ")+":empty"}function g(){return a.FE.BLOCK_TAGS.join(", ")}function h(c){var d=a.merge([],a.FE.VOID_ELEMENTS);d=a.merge(d,b.opts.htmlAllowedEmptyTags),d=void 0===c?a.merge(d,a.FE.BLOCK_TAGS):a.merge(d,a.FE.NO_DELETE_TAGS);var e,f;e=b.el.querySelectorAll("*:empty:not("+d.join("):not(")+"):not(.fr-marker)");do{f=!1;for(var g=0;g<e.length;g++)0!==e[g].attributes.length&&void 0===e[g].getAttribute("href")||(e[g].parentNode.removeChild(e[g]),f=!0);e=b.el.querySelectorAll("*:empty:not("+d.join("):not(")+"):not(.fr-marker)")}while(e.length&&f)}function i(a,d){var e=c();if(d&&(e="div"),e){for(var f=b.doc.createDocumentFragment(),g=null,h=!1,i=a.firstChild,j=!1;i;){var k=i.nextSibling;if(i.nodeType==Node.ELEMENT_NODE&&(b.node.isBlock(i)||b.opts.htmlDoNotWrapTags.indexOf(i.tagName.toLowerCase())>=0&&!b.node.hasClass(i,"fr-marker")))g=null,f.appendChild(i.cloneNode(!0));else if(i.nodeType!=Node.ELEMENT_NODE&&i.nodeType!=Node.TEXT_NODE)g=null,f.appendChild(i.cloneNode(!0));else if("BR"==i.tagName)null==g?(g=b.doc.createElement(e),j=!0,d&&g.setAttribute("class","fr-temp-div"),g.setAttribute("data-empty",!0),g.appendChild(i.cloneNode(!0)),f.appendChild(g)):!1===h&&(g.appendChild(b.doc.createElement("br")),d&&g.setAttribute("class","fr-temp-div"),g.setAttribute("data-empty",!0)),g=null;else{var l=i.textContent;(i.nodeType!==Node.TEXT_NODE||l.replace(/\n/g,"").replace(/(^ *)|( *$)/g,"").length>0||l.length&&l.indexOf("\n")<0)&&(null==g&&(g=b.doc.createElement(e),j=!0,d&&g.setAttribute("class","fr-temp-div"),f.appendChild(g),h=!1),g.appendChild(i.cloneNode(!0)),h||b.node.hasClass(i,"fr-marker")||i.nodeType==Node.TEXT_NODE&&0===l.replace(/ /g,"").length||(h=!0))}i=k}j&&(a.innerHTML="",a.appendChild(f))}}function j(a,b){for(var c=0;c<a.length;c++)i(a[c],b)}function k(a,c,d,e){if(!b.$wp)return!1;void 0===a&&(a=!1),void 0===c&&(c=!1),void 0===d&&(d=!1),void 0===e&&(e=!1);var f=b.$wp.scrollTop();i(b.el,a),e&&j(b.el.querySelectorAll(".fr-inner"),a),c&&j(b.el.querySelectorAll("td, th"),a),d&&j(b.el.querySelectorAll("blockquote"),a),f!=b.$wp.scrollTop()&&b.$wp.scrollTop(f)}function l(){b.$el.find("div.fr-temp-div").each(function(){a(this).attr("data-empty")||["LI"].indexOf(this.parentNode.tagName)>=0||b.node.isBlock(this.nextSibling)&&!a(this.nextSibling).hasClass("fr-temp-div")?a(this).replaceWith(a(this).html()):a(this).replaceWith(a(this).html()+"<br>")}),b.$el.find(".fr-temp-div").removeClass("fr-temp-div").filter(function(){return""===a(this).attr("class")}).removeAttr("class")}function m(c){for(var d=e(c),f=0;f<d.length;f++){var g=d[f];"false"===g.getAttribute("contenteditable")||g.querySelector(b.opts.htmlAllowedEmptyTags.join(":not(.fr-marker),")+":not(.fr-marker)")||b.node.isVoid(g)||"TABLE"!=g.tagName&&"TBODY"!=g.tagName&&"TR"!=g.tagName&&"UL"!=g.tagName&&"OL"!=g.tagName&&g.appendChild(b.doc.createElement("br"))}if(b.browser.msie&&b.opts.enter==a.FE.ENTER_BR){var h=b.node.contents(b.el);h.length&&h[h.length-1].nodeType==Node.TEXT_NODE&&b.$el.append("<br>")}}function n(){return b.$el.get(0).querySelectorAll(g())}function o(a){if(void 0===a&&(a=b.el),a&&["SCRIPT","STYLE","PRE"].indexOf(a.tagName)>=0)return!1;for(var c=b.doc.createTreeWalker(a,NodeFilter.SHOW_TEXT,b.node.filter(function(a){return null!=a.textContent.match(/([ \n]{2,})|(^[ \n]{1,})|([ \n]{1,}$)/g)}),!1);c.nextNode();){var e=c.currentNode;if(!d(e.parentNode,!0)){var f=b.node.isBlock(e.parentNode)||b.node.isElement(e.parentNode),g=e.textContent.replace(/(?!^)( ){2,}(?!$)/g," ").replace(/\n/g," ").replace(/^[ ]{2,}/g," ").replace(/[ ]{2,}$/g," ");if(f){var h=e.previousSibling,i=e.nextSibling;h&&i&&" "==g?g=b.node.isBlock(h)&&b.node.isBlock(i)?"":" ":(h||(g=g.replace(/^ */,"")),i||(g=g.replace(/ *$/,"")))}e.textContent=g}}}function p(a,b,c){var d=new RegExp(b,"gi"),e=d.exec(a);return e?e[c]:null}function q(a,b){var c=a.match(/<!DOCTYPE ?([^ ]*) ?([^ ]*) ?"?([^"]*)"? ?"?([^"]*)"?>/i);return c?b.implementation.createDocumentType(c[1],c[3],c[4]):b.implementation.createDocumentType("html")}function r(a){var b=a.doctype,c="<!DOCTYPE html>";return b&&(c="<!DOCTYPE "+b.name+(b.publicId?' PUBLIC "'+b.publicId+'"':"")+(!b.publicId&&b.systemId?" SYSTEM":"")+(b.systemId?' "'+b.systemId+'"':"")+">"),c}function s(c){var d=c.parentNode;if(d&&(b.node.isBlock(d)||b.node.isElement(d))&&["TD","TH"].indexOf(d.tagName)<0){for(var e=c.previousSibling,f=c.nextSibling;e&&e.nodeType==Node.TEXT_NODE&&0===e.textContent.replace(/\n|\r/g,"").length;)e=e.previousSibling;e&&d&&"BR"!=e.tagName&&!b.node.isBlock(e)&&!f&&d.textContent.replace(/\u200B/g,"").length>0&&e.textContent.length>0&&!b.node.hasClass(e,"fr-marker")&&(b.el==d&&!f&&b.opts.enter==a.FE.ENTER_BR&&b.browser.msie||c.parentNode.removeChild(c))}else!d||b.node.isBlock(d)||b.node.isElement(d)||c.previousSibling||c.nextSibling||s(c.parentNode)}function t(){for(var a=b.el.getElementsByTagName("br"),c=0;c<a.length;c++)s(a[c])}function u(){b.opts.htmlUntouched||(h(),k()),o(),b.opts.htmlUntouched||(b.spaces.normalize(null,!0),b.html.fillEmptyBlocks(),b.clean.lists(),b.clean.tables(),b.clean.toHTML5(),b.html.cleanBRs()),b.selection.restore(),v(),b.placeholder.refresh()}function v(){b.core.isEmpty()&&(null!=c()?b.el.querySelector(g())||b.el.querySelector(b.opts.htmlDoNotWrapTags.join(":not(.fr-marker),")+":not(.fr-marker)")||(b.core.hasFocus()?(b.$el.html("<"+c()+">"+a.FE.MARKERS+"<br/></"+c()+">"),b.selection.restore()):b.$el.html("<"+c()+"><br/></"+c()+">")):b.el.querySelector("*:not(.fr-marker):not(br)")||(b.core.hasFocus()?(b.$el.html(a.FE.MARKERS+"<br/>"),b.selection.restore()):b.$el.html("<br/>")))}function w(a,b){return p(a,"<"+b+"[^>]*?>([\\w\\W]*)</"+b+">",1)}function x(c,d){var e=a("<div "+(p(c,"<"+d+"([^>]*?)>",1)||"")+">");return b.node.rawAttributes(e.get(0))}function y(a){return(p(a,"<!DOCTYPE([^>]*?)>",0)||"<!DOCTYPE html>").replace(/\n/g," ").replace(/ {2,}/g," ")}function z(a,c){b.opts.htmlExecuteScripts?a.html(c):a.get(0).innerHTML=c}function A(c){var d=b.clean.html((c||"").trim(),[],[],b.opts.fullPage);if(b.opts.fullPage){var e=w(d,"body")||(d.indexOf("<body")>=0?"":d),f=x(d,"body"),g=w(d,"head")||"<title></title>",h=x(d,"head"),i=a("<div>").append(g).contents().each(function(){(this.nodeType==Node.COMMENT_NODE||["BASE","LINK","META","NOSCRIPT","SCRIPT","STYLE","TEMPLATE","TITLE"].indexOf(this.tagName)>=0)&&this.parentNode.removeChild(this)}).end().html().trim();g=a("<div>").append(g).contents().map(function(){return this.nodeType==Node.COMMENT_NODE?"\x3c!--"+this.nodeValue+"--\x3e":["BASE","LINK","META","NOSCRIPT","SCRIPT","STYLE","TEMPLATE","TITLE"].indexOf(this.tagName)>=0?this.outerHTML:""}).toArray().join("");var j=y(d),k=x(d,"html");z(b.$el,i+"\n"+e),b.node.clearAttributes(b.el),b.$el.attr(f),b.$el.addClass("fr-view"),b.$el.attr("spellcheck",b.opts.spellcheck),b.$el.attr("dir",b.opts.direction),z(b.$head,g),b.node.clearAttributes(b.$head.get(0)),b.$head.attr(h),b.node.clearAttributes(b.$html.get(0)),b.$html.attr(k),b.iframe_document.doctype.parentNode.replaceChild(q(j,b.iframe_document),b.iframe_document.doctype)}else z(b.$el,d);var l=b.edit.isDisabled();b.edit.on(),b.core.injectStyle(b.opts.iframeStyle),u(),b.opts.useClasses||(b.$el.find("[fr-original-class]").each(function(){this.setAttribute("class",this.getAttribute("fr-original-class")),this.removeAttribute("fr-original-class")}),b.$el.find("[fr-original-style]").each(function(){this.setAttribute("style",this.getAttribute("fr-original-style")),this.removeAttribute("fr-original-style")})),l&&b.edit.off(),b.events.trigger("html.set")}function B(a){var b=/(#[^\s\+>~\.\[:]+)/g,c=/(\[[^\]]+\])/g,d=/(\.[^\s\+>~\.\[:]+)/g,e=/(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi,f=/(:[\w-]+\([^\)]*\))/gi,g=/(:[^\s\+>~\.\[:]+)/g,h=/([^\s\+>~\.\[:]+)/g;!function(){var b=/:not\(([^\)]*)\)/g;b.test(a)&&(a=a.replace(b,"     $1 "))}()
;var i=100*(a.match(b)||[]).length+10*(a.match(c)||[]).length+10*(a.match(d)||[]).length+10*(a.match(f)||[]).length+10*(a.match(g)||[]).length+(a.match(e)||[]).length;return a=a.replace(/[\*\s\+>~]/g," "),a=a.replace(/[#\.]/g," "),i+=(a.match(h)||[]).length}function C(a){if(b.events.trigger("html.processGet",[a]),a&&a.getAttribute&&""===a.getAttribute("class")&&a.removeAttribute("class"),a&&a.getAttribute&&""===a.getAttribute("style")&&a.removeAttribute("style"),a&&a.nodeType==Node.ELEMENT_NODE){var c,d=a.querySelectorAll('[class=""],[style=""]');for(c=0;c<d.length;c++){var e=d[c];""===e.getAttribute("class")&&e.removeAttribute("class"),""===e.getAttribute("style")&&e.removeAttribute("style")}var f=a.querySelectorAll("br");for(c=0;c<f.length;c++)s(f[c])}}function D(a,b){return a[3]-b[3]}function E(a,c){if(!b.$wp)return b.$oel.clone().removeClass("fr-view").removeAttr("contenteditable").get(0).outerHTML;var d="";b.events.trigger("html.beforeGet");var e,f,g=[],h={},i=[];if(!b.opts.useClasses&&!c){var j=new RegExp("^"+b.opts.htmlIgnoreCSSProperties.join("$|^")+"$","gi");for(e=0;e<b.doc.styleSheets.length;e++){var k,l=0;try{k=b.doc.styleSheets[e].cssRules,b.doc.styleSheets[e].ownerNode&&"STYLE"==b.doc.styleSheets[e].ownerNode.nodeType&&(l=1)}catch(y){}if(k)for(var m=0,n=k.length;m<n;m++)if(k[m].selectorText&&k[m].style.cssText.length>0){var o,p=k[m].selectorText.replace(/body |\.fr-view /g,"").replace(/::/g,":");try{o=b.el.querySelectorAll(p)}catch(y){o=[]}for(f=0;f<o.length;f++){!o[f].getAttribute("fr-original-style")&&o[f].getAttribute("style")?(o[f].setAttribute("fr-original-style",o[f].getAttribute("style")),g.push(o[f])):o[f].getAttribute("fr-original-style")||(o[f].setAttribute("fr-original-style",""),g.push(o[f])),h[o[f]]||(h[o[f]]={});for(var q=1e3*l+B(k[m].selectorText),s=k[m].style.cssText.split(";"),t=0;t<s.length;t++){var u=s[t].trim().split(":")[0];u.match(j)||(h[o[f]][u]||(h[o[f]][u]=0,(o[f].getAttribute("fr-original-style")||"").indexOf(u+":")>=0&&(h[o[f]][u]=1e4)),q>=h[o[f]][u]&&(h[o[f]][u]=q,s[t].trim().length&&i.push([o[f],u.trim(),s[t].trim().split(":")[1].trim(),q])))}}}}for(i.sort(D),e=0;e<i.length;e++){var v=i[e];v[0].style[v[1]]=v[2]}for(e=0;e<g.length;e++)if(g[e].getAttribute("class")&&(g[e].setAttribute("fr-original-class",g[e].getAttribute("class")),g[e].removeAttribute("class")),(g[e].getAttribute("fr-original-style")||"").trim().length>0){var w=g[e].getAttribute("fr-original-style").split(";");for(f=0;f<w.length;f++)w[f].indexOf(":")>0&&(g[e].style[w[f].split(":")[0].trim()]=w[f].split(":")[1].trim())}}if(b.core.isEmpty()?b.opts.fullPage&&(d=r(b.iframe_document),d+="<html"+b.node.attributes(b.$html.get(0))+">"+b.$html.find("head").get(0).outerHTML+"<body></body></html>"):(void 0===a&&(a=!1),b.opts.fullPage?(d=r(b.iframe_document),b.$el.removeClass("fr-view"),d+="<html"+b.node.attributes(b.$html.get(0))+">"+b.$html.html()+"</html>",b.$el.addClass("fr-view")):d=b.$el.html()),!b.opts.useClasses&&!c)for(e=0;e<g.length;e++)g[e].getAttribute("fr-original-class")&&(g[e].setAttribute("class",g[e].getAttribute("fr-original-class")),g[e].removeAttribute("fr-original-class")),g[e].getAttribute("fr-original-style")?(g[e].setAttribute("style",g[e].getAttribute("fr-original-style")),g[e].removeAttribute("fr-original-style")):g[e].removeAttribute("style");b.opts.fullPage&&(d=d.replace(/<style data-fr-style="true">(?:[\w\W]*?)<\/style>/g,""),d=d.replace(/<link([^>]*)data-fr-style="true"([^>]*)>/g,""),d=d.replace(/<style(?:[\w\W]*?)class="firebugResetStyles"(?:[\w\W]*?)>(?:[\w\W]*?)<\/style>/g,""),d=d.replace(/<body((?:[\w\W]*?)) spellcheck="true"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,"<body$1$2>$3</body>"),d=d.replace(/<body((?:[\w\W]*?)) contenteditable="(true|false)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,"<body$1$3>$4</body>"),d=d.replace(/<body((?:[\w\W]*?)) dir="([\w]*)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,"<body$1$3>$4</body>"),d=d.replace(/<body((?:[\w\W]*?))class="([\w\W]*?)(fr-rtl|fr-ltr)([\w\W]*?)"((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,'<body$1class="$2$4"$5>$6</body>'),d=d.replace(/<body((?:[\w\W]*?)) class=""((?:[\w\W]*?))>((?:[\w\W]*?))<\/body>/g,"<body$1$2>$3</body>")),b.opts.htmlSimpleAmpersand&&(d=d.replace(/\&amp;/gi,"&")),b.events.trigger("html.afterGet"),a||(d=d.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi,"")),d=b.clean.invisibleSpaces(d),d=b.clean.exec(d,C);var x=b.events.chainTrigger("html.get",d);return"string"==typeof x&&(d=x),d=d.replace(/<pre(?:[\w\W]*?)>(?:[\w\W]*?)<\/pre>/g,function(a){return a.replace(/<br>/g,"\n")})}function F(){var c=function(c,d){for(;d&&(d.nodeType==Node.TEXT_NODE||!b.node.isBlock(d))&&!b.node.isElement(d);)d&&d.nodeType!=Node.TEXT_NODE&&a(c).wrapInner(b.node.openTagString(d)+b.node.closeTagString(d)),d=d.parentNode;d&&c.innerHTML==d.innerHTML&&(c.innerHTML=d.outerHTML)},d=function(){var c,d=null;return b.win.getSelection?(c=b.win.getSelection())&&c.rangeCount&&(d=c.getRangeAt(0).commonAncestorContainer,d.nodeType!=Node.ELEMENT_NODE&&(d=d.parentNode)):(c=b.doc.selection)&&"Control"!=c.type&&(d=c.createRange().parentElement()),null!=d&&(a.inArray(b.el,a(d).parents())>=0||d==b.el)?d:null},e="";if(void 0!==b.win.getSelection){b.browser.mozilla&&(b.selection.save(),b.$el.find('.fr-marker[data-type="false"]').length>1&&(b.$el.find('.fr-marker[data-type="false"][data-id="0"]').remove(),b.$el.find('.fr-marker[data-type="false"]:last').attr("data-id","0"),b.$el.find(".fr-marker").not('[data-id="0"]').remove()),b.selection.restore());for(var f=b.selection.ranges(),g=0;g<f.length;g++){var h=document.createElement("div");h.appendChild(f[g].cloneContents());var i=h.children;if(i.length){var j=i[i.length-1];("P"==j.tagName&&b.opts.enter==a.FroalaEditor.ENTER_P||"DIV"==j.tagName&&b.opts.enter==a.FroalaEditor.ENTER_DIV)&&b.node.isEmpty(j)&&h.removeChild(j)}c(h,d()),a(h).find(".fr-element").length>0&&(h=b.el),e+=h.innerHTML}}else void 0!==b.doc.selection&&"Text"==b.doc.selection.type&&(e=b.doc.selection.createRange().htmlText);return e}function G(a){var c=b.doc.createElement("div");return c.innerHTML=a,null!==c.querySelector(g())}function H(a){var c=b.doc.createElement("div");return c.innerHTML=a,b.selection.setAtEnd(c),c.innerHTML}function I(a){return a.replace(/</gi,"&lt;").replace(/>/gi,"&gt;").replace(/"/gi,"&quot;").replace(/'/gi,"&#39;")}function J(c){if(!b.html.defaultTag())return c;var d=b.doc.createElement("div");d.innerHTML=c;for(var e=d.querySelectorAll(":scope > "+b.html.defaultTag()),f=e.length-1;f>=0;f--){var g=e[f];b.node.isBlock(g.previousSibling)||(g.previousSibling&&!b.node.isEmpty(g)&&a("<br>").insertAfter(g.previousSibling),g.outerHTML=g.innerHTML)}return d.innerHTML}function K(c,d,e){b.selection.isCollapsed()||b.selection.remove();var f;if(f=d?c:b.clean.html(c),f=f.replace(/\r|\n/g," "),c.indexOf('class="fr-marker"')<0&&(f=H(f)),b.core.isEmpty()&&!b.opts.keepFormatOnDelete&&G(f))b.el.innerHTML=f;else{var g=b.markers.insert();if(g){b.node.isLastSibling(g)&&a(g).parent().hasClass("fr-deletable")&&a(g).insertAfter(a(g).parent());var h=b.node.blockParent(g);if((G(f)||e)&&(b.node.deepestParent(g)||h&&"LI"==h.tagName)){if(h&&"LI"==h.tagName&&(f=J(f)),!(g=b.markers.split()))return!1;g.outerHTML=f}else g.outerHTML=f}else b.el.innerHTML=b.el.innerHTML+f}u(),b.keys.positionCaret(),b.events.trigger("html.inserted")}function L(c){var d=null;if(void 0===c&&(d=b.selection.element()),b.opts.keepFormatOnDelete)return!1;var e=d?(d.textContent.match(/\u200B/g)||[]).length-d.querySelectorAll(".fr-marker").length:0;if((b.el.textContent.match(/\u200B/g)||[]).length-b.el.querySelectorAll(".fr-marker").length==e)return!1;var f,g;do{g=!1,f=b.el.querySelectorAll("*:not(.fr-marker)");for(var h=0;h<f.length;h++){var i=f[h];if(d!=i){var j=i.textContent;0===i.children.length&&1===j.length&&8203==j.charCodeAt(0)&&"TD"!==i.tagName&&(a(i).remove(),g=!0)}}}while(g)}function M(){if(b.$wp){var a=function(){L(),b.placeholder&&setTimeout(b.placeholder.refresh,0)};b.events.on("mouseup",a),b.events.on("keydown",a),b.events.on("contentChanged",v)}}return{defaultTag:c,isPreformatted:d,emptyBlocks:e,emptyBlockTagsQuery:f,blockTagsQuery:g,fillEmptyBlocks:m,cleanEmptyTags:h,cleanWhiteTags:L,cleanBlankSpaces:o,blocks:n,getDoctype:r,set:A,get:E,getSelected:F,insert:K,wrap:k,unwrap:l,escapeEntities:I,checkIfEmpty:v,extractNode:w,extractNodeAttrs:x,extractDoctype:y,cleanBRs:t,_init:M}},a.extend(a.FE.DEFAULTS,{height:null,heightMax:null,heightMin:null,width:null}),a.FE.MODULES.size=function(a){function b(){c(),a.opts.height&&a.$el.css("minHeight",a.opts.height-a.helpers.getPX(a.$el.css("padding-top"))-a.helpers.getPX(a.$el.css("padding-bottom"))),a.$iframe.height(a.$el.outerHeight(!0))}function c(){a.opts.heightMin?a.$el.css("minHeight",a.opts.heightMin):a.$el.css("minHeight",""),a.opts.heightMax?(a.$wp.css("maxHeight",a.opts.heightMax),a.$wp.css("overflow","auto")):(a.$wp.css("maxHeight",""),a.$wp.css("overflow","")),a.opts.height?(a.$wp.height(a.opts.height),a.$wp.css("overflow","auto"),a.$el.css("minHeight",a.opts.height-a.helpers.getPX(a.$el.css("padding-top"))-a.helpers.getPX(a.$el.css("padding-bottom")))):(a.$wp.css("height",""),a.opts.heightMin||a.$el.css("minHeight",""),a.opts.heightMax||a.$wp.css("overflow","")),a.opts.width&&a.$box.width(a.opts.width)}function d(){if(!a.$wp)return!1;c(),a.$iframe&&(a.events.on("keyup keydown",function(){setTimeout(b,0)},!0),a.events.on("commands.after html.set init initialized paste.after",b))}return{_init:d,syncIframe:b,refresh:c}},a.extend(a.FE.DEFAULTS,{language:null}),a.FE.LANGUAGE={},a.FE.MODULES.language=function(b){function c(a){return e&&e.translation[a]&&e.translation[a].length?e.translation[a]:a}function d(){a.FE.LANGUAGE&&(e=a.FE.LANGUAGE[b.opts.language]),e&&e.direction&&(b.opts.direction=e.direction)}var e;return{_init:d,translate:c}},a.extend(a.FE.DEFAULTS,{placeholderText:"Type something"}),a.FE.MODULES.placeholder=function(b){function c(){b.$placeholder||g();var c=b.opts.iframe?b.$iframe.prev().outerHeight(!0):b.$el.prev().outerHeight(!0),d=0,e=0,f=0,h=0,i=0,j=0,k=b.node.contents(b.el),l=a(b.selection.element()).css("text-align");if(k.length&&k[0].nodeType==Node.ELEMENT_NODE){var m=a(k[0]);(!b.opts.toolbarInline||b.$el.prev().length>0)&&b.ready&&(d=b.helpers.getPX(m.css("margin-top")),h=b.helpers.getPX(m.css("padding-top")),e=b.helpers.getPX(m.css("margin-left")),f=b.helpers.getPX(m.css("margin-right")),i=b.helpers.getPX(m.css("padding-left")),j=b.helpers.getPX(m.css("padding-right"))),b.$placeholder.css("font-size",m.css("font-size")),b.$placeholder.css("line-height",m.css("line-height"))}else b.$placeholder.css("font-size",b.$el.css("font-size")),b.$placeholder.css("line-height",b.$el.css("line-height"));b.$wp.addClass("show-placeholder"),b.$placeholder.css({marginTop:Math.max(b.helpers.getPX(b.$el.css("margin-top")),d)+c,paddingTop:Math.max(b.helpers.getPX(b.$el.css("padding-top")),h),paddingLeft:Math.max(b.helpers.getPX(b.$el.css("padding-left")),i),marginLeft:Math.max(b.helpers.getPX(b.$el.css("margin-left")),e),paddingRight:Math.max(b.helpers.getPX(b.$el.css("padding-right")),j),marginRight:Math.max(b.helpers.getPX(b.$el.css("margin-right")),f),textAlign:l}).text(b.language.translate(b.opts.placeholderText||b.$oel.attr("placeholder")||"")),b.$placeholder.html(b.$placeholder.text().replace(/\n/g,"<br>"))}function d(){b.$wp.removeClass("show-placeholder")}function e(){return!b.$wp||b.node.hasClass(b.$wp.get(0),"show-placeholder")}function f(){if(!b.$wp)return!1;b.core.isEmpty()?c():d()}function g(){b.$placeholder=a('<span class="fr-placeholder"></span>'),b.$wp.append(b.$placeholder)}function h(){if(!b.$wp)return!1;b.events.on("init input keydown keyup contentChanged initialized",f)}return{_init:h,show:c,hide:d,refresh:f,isVisible:e}},a.FE.MODULES.edit=function(a){function b(){if(a.browser.mozilla)try{a.doc.execCommand("enableObjectResizing",!1,"false"),a.doc.execCommand("enableInlineTableEditing",!1,"false")}catch(b){}if(a.browser.msie)try{a.doc.body.addEventListener("mscontrolselect",function(a){return a.preventDefault(),!1})}catch(b){}}function c(){a.$wp?(a.$el.attr("contenteditable",!0),a.$el.removeClass("fr-disabled").attr("aria-disabled",!1),a.$tb&&a.$tb.removeClass("fr-disabled").attr("aria-disabled",!1),b()):a.$el.is("a")&&a.$el.attr("contenteditable",!0),g=!1}function d(){a.events.disableBlur(),a.$wp?(a.$el.attr("contenteditable",!1),a.$el.addClass("fr-disabled").attr("aria-disabled",!0),a.$tb&&a.$tb.addClass("fr-disabled").attr("aria-disabled",!0)):a.$el.is("a")&&a.$el.attr("contenteditable",!1),a.events.enableBlur(),g=!0}function e(){return g}function f(){a.events.on("focus",function(){e()?a.edit.off():a.edit.on()})}var g=!1;return{_init:f,on:c,off:d,disableDesign:b,isDisabled:e}},a.extend(a.FE.DEFAULTS,{editorClass:null,typingTimer:500,iframe:!1,requestWithCORS:!0,requestWithCredentials:!1,requestHeaders:{},useClasses:!0,spellcheck:!0,iframeStyle:'html{margin:0px;height:auto;}body{height:auto;padding:10px;background:transparent;color:#000000;position:relative;z-index: 2;-webkit-user-select:auto;margin:0px;overflow:hidden;min-height:20px;}body:after{content:"";display:block;clear:both;}',iframeStyleFiles:[],direction:"auto",zIndex:1,tabIndex:null,disableRightClick:!1,scrollableContainer:"body",keepFormatOnDelete:!1,theme:null}),a.FE.MODULES.core=function(b){function c(c){if(b.opts.iframe){b.$head.find("style[data-fr-style], link[data-fr-style]").remove(),b.$head.append('<style data-fr-style="true">'+c+"</style>");for(var d=0;d<b.opts.iframeStyleFiles.length;d++){var e=a('<link data-fr-style="true" rel="stylesheet" href="'+b.opts.iframeStyleFiles[d]+'">');e.get(0).addEventListener("load",b.size.syncIframe),b.$head.append(e)}}}function d(){b.opts.iframe||b.$el.addClass("fr-element fr-view")}function e(){if(b.$box.addClass("fr-box"+(b.opts.editorClass?" "+b.opts.editorClass:"")),b.$wp.addClass("fr-wrapper"),d(),b.opts.iframe){b.$iframe.addClass("fr-iframe"),b.$el.addClass("fr-view");for(var a=0;a<b.o_doc.styleSheets.length;a++){var c;try{c=b.o_doc.styleSheets[a].cssRules}catch(g){}if(c)for(var e=0,f=c.length;e<f;e++)!c[e].selectorText||0!==c[e].selectorText.indexOf(".fr-view")&&0!==c[e].selectorText.indexOf(".fr-element")||c[e].style.cssText.length>0&&(0===c[e].selectorText.indexOf(".fr-view")?b.opts.iframeStyle+=c[e].selectorText.replace(/\.fr-view/g,"body")+"{"+c[e].style.cssText+"}":b.opts.iframeStyle+=c[e].selectorText.replace(/\.fr-element/g,"body")+"{"+c[e].style.cssText+"}")}}"auto"!=b.opts.direction&&b.$box.removeClass("fr-ltr fr-rtl").addClass("fr-"+b.opts.direction),b.$el.attr("dir",b.opts.direction),b.$wp.attr("dir",b.opts.direction),b.opts.zIndex>1&&b.$box.css("z-index",b.opts.zIndex),b.opts.theme&&b.$box.addClass(b.opts.theme+"-theme"),b.opts.tabIndex=b.opts.tabIndex||b.$oel.attr("tabIndex"),b.opts.tabIndex&&b.$el.attr("tabIndex",b.opts.tabIndex)}function f(){return b.node.isEmpty(b.el)}function g(){b.drag_support={filereader:"undefined"!=typeof FileReader,formdata:!!b.win.FormData,progress:"upload"in new XMLHttpRequest}}function h(a,c){var d=new XMLHttpRequest;d.open(c,a,!0),b.opts.requestWithCredentials&&(d.withCredentials=!0);for(var e in b.opts.requestHeaders)b.opts.requestHeaders.hasOwnProperty(e)&&d.setRequestHeader(e,b.opts.requestHeaders[e]);return d}function i(a){"TEXTAREA"==b.$oel.get(0).tagName&&b.$oel.val(a),b.$wp&&("TEXTAREA"==b.$oel.get(0).tagName?(b.$el.html(""),b.$wp.html(""),b.$box.replaceWith(b.$oel),b.$oel.show()):(b.$wp.replaceWith(a),b.$el.html(""),b.$box.removeClass("fr-view fr-ltr fr-box "+(b.opts.editorClass||"")),b.opts.theme&&b.$box.addClass(b.opts.theme+"-theme"))),this.$wp=null,this.$el=null,this.el=null,this.$box=null}function j(){return b.browser.mozilla&&b.helpers.isMobile()?b.selection.inEditor():b.node.hasFocus(b.el)||b.$el.find("*:focus").length>0}function k(a){if(!a)return!1;var c=a.data("instance");return!!c&&c.id==b.id}function l(){if(a.FE.INSTANCES.push(b),g(),b.$wp){e(),b.html.set(b._original_html),b.$el.attr("spellcheck",b.opts.spellcheck),b.helpers.isMobile()&&(b.$el.attr("autocomplete",b.opts.spellcheck?"on":"off"),b.$el.attr("autocorrect",b.opts.spellcheck?"on":"off"),b.$el.attr("autocapitalize",b.opts.spellcheck?"on":"off")),b.opts.disableRightClick&&b.events.$on(b.$el,"contextmenu",function(a){if(2==a.button)return!1});try{b.doc.execCommand("styleWithCSS",!1,!1)}catch(c){}}"TEXTAREA"==b.$oel.get(0).tagName&&(b.events.on("contentChanged",function(){b.$oel.val(b.html.get())}),b.events.on("form.submit",function(){b.$oel.val(b.html.get())}),b.events.on("form.reset",function(){b.html.set(b._original_html)}),b.$oel.val(b.html.get())),b.helpers.isIOS()&&b.events.$on(b.$doc,"selectionchange",function(){b.$doc.get(0).hasFocus()||b.$win.get(0).focus()}),b.events.trigger("init")}return{_init:l,destroy:i,isEmpty:f,getXHR:h,injectStyle:c,hasFocus:j,sameInstance:k}},a.FE.MODULES.cursorLists=function(b){function c(a){for(var b=a;"LI"!=b.tagName;)b=b.parentNode;return b}function d(a){for(var c=a;!b.node.isList(c);)c=c.parentNode;return c}function e(e){var f,g=c(e),h=g.nextSibling,i=g.previousSibling,j=b.html.defaultTag();if(b.node.isEmpty(g,!0)&&h){for(var k="",l="",m=e.parentNode;!b.node.isList(m)&&m.parentNode&&"LI"!==m.parentNode.tagName;)k=b.node.openTagString(m)+k,l+=b.node.closeTagString(m),m=m.parentNode;k=b.node.openTagString(m)+k,l+=b.node.closeTagString(m);var n="";for(n=m.parentNode&&"LI"==m.parentNode.tagName?l+"<li>"+a.FE.MARKERS+"<br>"+k:j?l+"<"+j+">"+a.FE.MARKERS+"<br></"+j+">"+k:l+a.FE.MARKERS+"<br>"+k,a(g).html('<span id="fr-break"></span>');["UL","OL"].indexOf(m.tagName)<0||m.parentNode&&"LI"===m.parentNode.tagName;)m=m.parentNode;var o=b.node.openTagString(m)+a(m).html()+b.node.closeTagString(m);o=o.replace(/<span id="fr-break"><\/span>/g,n),a(m).replaceWith(o),b.$el.find("li:empty").remove()}else if(i&&h||!b.node.isEmpty(g,!0)){for(var p="<br>",q=e.parentNode;q&&"LI"!=q.tagName;)p=b.node.openTagString(q)+p+b.node.closeTagString(q),q=q.parentNode;a(g).before("<li>"+p+"</li>"),a(e).remove()}else if(i){f=d(g);for(var r=a.FE.MARKERS+"<br>",s=e.parentNode;s&&"LI"!=s.tagName;)r=b.node.openTagString(s)+r+b.node.closeTagString(s),s=s.parentNode;f.parentNode&&"LI"==f.parentNode.tagName?a(f.parentNode).after("<li>"+r+"</li>"):j?a(f).after("<"+j+">"+r+"</"+j+">"):a(f).after(r),a(g).remove()}else f=d(g),f.parentNode&&"LI"==f.parentNode.tagName?h?a(f.parentNode).before(b.node.openTagString(g)+a.FE.MARKERS+"<br></li>"):a(f.parentNode).after(b.node.openTagString(g)+a.FE.MARKERS+"<br></li>"):j?a(f).before("<"+j+">"+a.FE.MARKERS+"<br></"+j+">"):a(f).before(a.FE.MARKERS+"<br>"),a(g).remove()}function f(d){for(var e=c(d),f="",g=d,h="",i="";g!=e;){g=g.parentNode;var j="A"==g.tagName&&b.cursor.isAtEnd(d,g)?"fr-to-remove":"";h=b.node.openTagString(a(g).clone().addClass(j).get(0))+h,i=b.node.closeTagString(g)+i}f=i+f+h+a.FE.MARKERS+a.FE.INVISIBLE_SPACE,a(d).replaceWith('<span id="fr-break"></span>');var k=b.node.openTagString(e)+a(e).html()+b.node.closeTagString(e);k=k.replace(/<span id="fr-break"><\/span>/g,f),a(e).replaceWith(k)}function g(d){for(var e=c(d),f=a.FE.MARKERS,g="",h=d,i=!1;h!=e;){h=h.parentNode;var j="A"==h.tagName&&b.cursor.isAtEnd(d,h)?"fr-to-remove":"";i||h==e||b.node.isBlock(h)||(i=!0,g+=a.FE.INVISIBLE_SPACE),g=b.node.openTagString(a(h).clone().addClass(j).get(0))+g,f+=b.node.closeTagString(h)}var k=g+f;a(d).remove(),a(e).after(k)}function h(e){var f=c(e),g=f.previousSibling;if(g){g=a(g).find(b.html.blockTagsQuery()).get(-1)||g,a(e).replaceWith(a.FE.MARKERS);var h=b.node.contents(g);h.length&&"BR"==h[h.length-1].tagName&&a(h[h.length-1]).remove(),a(f).find(b.html.blockTagsQuery()).not("ol, ul, table").each(function(){this.parentNode==f&&a(this).replaceWith(a(this).html()+(b.node.isEmpty(this)?"":"<br>"))});for(var i,j=b.node.contents(f)[0];j&&!b.node.isList(j);)i=j.nextSibling,a(g).append(j),j=i;for(g=f.previousSibling;j;)i=j.nextSibling,a(g).append(j),j=i;a(f).remove()}else{var k=d(f);if(a(e).replaceWith(a.FE.MARKERS),k.parentNode&&"LI"==k.parentNode.tagName){var l=k.previousSibling;b.node.isBlock(l)?(a(f).find(b.html.blockTagsQuery()).not("ol, ul, table").each(function(){this.parentNode==f&&a(this).replaceWith(a(this).html()+(b.node.isEmpty(this)?"":"<br>"))}),a(l).append(a(f).html())):a(k).before(a(f).html())}else{var m=b.html.defaultTag();m&&0===a(f).find(b.html.blockTagsQuery()).length?a(k).before("<"+m+">"+a(f).html()+"</"+m+">"):a(k).before(a(f).html())}a(f).remove(),b.html.wrap(),0===a(k).find("li").length&&a(k).remove()}}function i(d){var e,f=c(d),g=f.nextSibling;if(g){e=b.node.contents(g),e.length&&"BR"==e[0].tagName&&a(e[0]).remove(),a(g).find(b.html.blockTagsQuery()).not("ol, ul, table").each(function(){this.parentNode==g&&a(this).replaceWith(a(this).html()+(b.node.isEmpty(this)?"":"<br>"))});for(var h,i=d,j=b.node.contents(g)[0];j&&!b.node.isList(j);)h=j.nextSibling,a(i).after(j),i=j,j=h;for(;j;)h=j.nextSibling,a(f).append(j),j=h;a(d).replaceWith(a.FE.MARKERS),a(g).remove()}else{for(var k=f;!k.nextSibling&&k!=b.el;)k=k.parentNode;if(k==b.el)return!1;if(k=k.nextSibling,b.node.isBlock(k))a.FE.NO_DELETE_TAGS.indexOf(k.tagName)<0&&(a(d).replaceWith(a.FE.MARKERS),e=b.node.contents(f),e.length&&"BR"==e[e.length-1].tagName&&a(e[e.length-1]).remove(),a(f).append(a(k).html()),a(k).remove());else for(e=b.node.contents(f),e.length&&"BR"==e[e.length-1].tagName&&a(e[e.length-1]).remove(),a(d).replaceWith(a.FE.MARKERS);k&&!b.node.isBlock(k)&&"BR"!=k.tagName;)a(f).append(a(k)),k=k.nextSibling}}return{_startEnter:e,_middleEnter:f,_endEnter:g,_backspace:h,_del:i}},a.FE.NO_DELETE_TAGS=["TH","TD","TR","TABLE","FORM"],a.FE.SIMPLE_ENTER_TAGS=["TH","TD","LI","DL","DT","FORM"],a.FE.MODULES.cursor=function(b){function c(a){return!!a&&(!!b.node.isBlock(a)||(a.nextSibling&&a.nextSibling.nodeType==Node.TEXT_NODE&&0===a.nextSibling.textContent.replace(/\u200b/g,"").length?c(a.nextSibling):!(a.nextSibling&&(!a.previousSibling||"BR"!=a.nextSibling.tagName||a.nextSibling.nextSibling))&&c(a.parentNode)))}function d(a){return!!a&&(!!b.node.isBlock(a)||(a.previousSibling&&a.previousSibling.nodeType==Node.TEXT_NODE&&0===a.previousSibling.textContent.replace(/\u200b/g,"").length?d(a.previousSibling):!a.previousSibling&&(!(a.previousSibling||!b.node.hasClass(a.parentNode,"fr-inner"))||d(a.parentNode))))}function e(a,c){return!!a&&(a!=b.$wp.get(0)&&(a.previousSibling&&a.previousSibling.nodeType==Node.TEXT_NODE&&0===a.previousSibling.textContent.replace(/\u200b/g,"").length?e(a.previousSibling,c):!a.previousSibling&&(a.parentNode==c||e(a.parentNode,c))))}function f(a,c){return!!a&&(a!=b.$wp.get(0)&&(a.nextSibling&&a.nextSibling.nodeType==Node.TEXT_NODE&&0===a.nextSibling.textContent.replace(/\u200b/g,"").length?f(a.nextSibling,c):!(a.nextSibling&&(!a.previousSibling||"BR"!=a.nextSibling.tagName||a.nextSibling.nextSibling))&&(a.parentNode==c||f(a.parentNode,c))))}function g(c){return a(c).parentsUntil(b.$el,"LI").length>0&&0===a(c).parentsUntil("LI","TABLE").length}function h(a,b){var c=new RegExp((b?"^":"")+"([\\uD83C-\\uDBFF\\uDC00-\\uDFFF\\u200D]+)"+(b?"":"$"),"i"),d=a.match(c);return d?d[0].length:1}function i(c){var d=a(c).parentsUntil(b.$el,"BLOCKQUOTE").length>0,e=b.node.deepestParent(c,[],!d);if(e&&"BLOCKQUOTE"==e.tagName){var f=b.node.deepestParent(c,[a(c).parentsUntil(b.$el,"BLOCKQUOTE").get(0)]);f&&f.previousSibling&&(e=f)}if(null!==e){var g,h=e.previousSibling;if(b.node.isBlock(e)&&b.node.isEditable(e)&&h&&a.FE.NO_DELETE_TAGS.indexOf(h.tagName)<0)if(b.node.isDeletable(h))a(h).remove(),a(c).replaceWith(a.FE.MARKERS);else if(b.node.isEditable(h))if(b.node.isBlock(h))if(b.node.isEmpty(h)&&!b.node.isList(h))a(h).remove(),a(c).after(b.opts.keepFormatOnDelete?a.FE.INVISIBLE_SPACE:"");else{if(b.node.isList(h)&&(h=a(h).find("li:last").get(0)),g=b.node.contents(h),g.length&&"BR"==g[g.length-1].tagName&&a(g[g.length-1]).remove(),"BLOCKQUOTE"==h.tagName&&"BLOCKQUOTE"!=e.tagName)for(g=b.node.contents(h);g.length&&b.node.isBlock(g[g.length-1]);)h=g[g.length-1],g=b.node.contents(h);else if("BLOCKQUOTE"!=h.tagName&&"BLOCKQUOTE"==e.tagName)for(g=b.node.contents(e);g.length&&b.node.isBlock(g[0]);)e=g[0],g=b.node.contents(e);b.node.isEmpty(e)?(a(c).remove(),b.selection.setAtEnd(h,b.opts.keepFormatOnDelete)):(a(c).replaceWith(a.FE.MARKERS),a(h).append(e.innerHTML)),a(e).remove()}else a(c).replaceWith(a.FE.MARKERS),"BLOCKQUOTE"==e.tagName&&h.nodeType==Node.ELEMENT_NODE?a(h).remove():(a(h).after(b.node.isEmpty(e)?"":a(e).html()),a(e).remove(),"BR"==h.tagName&&a(h).remove())}}function j(c){for(var d=c;!d.previousSibling;)if(d=d.parentNode,b.node.isElement(d))return!1;d=d.previousSibling;var e;if(!b.node.isBlock(d)&&b.node.isEditable(d)){for(e=b.node.contents(d);d.nodeType!=Node.TEXT_NODE&&!b.node.isDeletable(d)&&e.length&&b.node.isEditable(d);)d=e[e.length-1],e=b.node.contents(d);if(d.nodeType==Node.TEXT_NODE){var f=d.textContent,g=f.length;if(b.opts.tabSpaces&&f.length>=b.opts.tabSpaces){0===f.substr(f.length-b.opts.tabSpaces,f.length-1).replace(/ /g,"").replace(new RegExp(a.FE.UNICODE_NBSP,"g"),"").length&&(g=f.length-b.opts.tabSpaces)}d.textContent=f.substring(0,g-h(f));var i=f.length!=d.textContent.length;0===d.textContent.length?i&&b.opts.keepFormatOnDelete?a(d).after(a.FE.INVISIBLE_SPACE+a.FE.MARKERS):(2!=d.parentNode.childNodes.length||d.parentNode!=c.parentNode)&&1!=d.parentNode.childNodes.length||b.node.isBlock(d.parentNode)||b.node.isElement(d.parentNode)?(a(d).after(a.FE.MARKERS),b.node.isElement(d.parentNode)&&!c.nextSibling&&d.previousSibling&&"BR"==d.previousSibling.tagName&&a(c).after("<br>"),d.parentNode.removeChild(d)):(a(d.parentNode).after(a.FE.MARKERS),a(d.parentNode).remove()):a(d).after(a.FE.MARKERS)}else b.node.isDeletable(d)?(a(d).after(a.FE.MARKERS),a(d).remove()):c.nextSibling&&"BR"==c.nextSibling.tagName&&b.node.isVoid(d)&&"BR"!=d.tagName?(a(c.nextSibling).remove(),a(c).replaceWith(a.FE.MARKERS)):!1!==b.events.trigger("node.remove",[a(d)])&&(a(d).after(a.FE.MARKERS),a(d).remove())}else if(a.FE.NO_DELETE_TAGS.indexOf(d.tagName)<0&&(b.node.isEditable(d)||b.node.isDeletable(d)))if(b.node.isDeletable(d))a(c).replaceWith(a.FE.MARKERS),a(d).remove();else if(b.node.isEmpty(d)&&!b.node.isList(d))a(d).remove(),a(c).replaceWith(a.FE.MARKERS);else{for(b.node.isList(d)&&(d=a(d).find("li:last").get(0)),e=b.node.contents(d),e&&"BR"==e[e.length-1].tagName&&a(e[e.length-1]).remove(),e=b.node.contents(d);e&&b.node.isBlock(e[e.length-1]);)d=e[e.length-1],e=b.node.contents(d);a(d).append(a.FE.MARKERS);for(var j=c;!j.previousSibling;)j=j.parentNode;for(;j&&"BR"!==j.tagName&&!b.node.isBlock(j);){var k=j;j=j.nextSibling,a(d).append(k)}j&&"BR"==j.tagName&&a(j).remove(),a(c).remove()}else c.nextSibling&&"BR"==c.nextSibling.tagName&&a(c.nextSibling).remove()}function k(){var f=!1,k=b.markers.insert();if(!k)return!0;for(var l=k.parentNode;l&&!b.node.isElement(l);){if("false"===l.getAttribute("contenteditable"))return a(k).replaceWith(a.FE.MARKERS),b.selection.restore(),!1;if("true"===l.getAttribute("contenteditable"))break;l=l.parentNode}b.el.normalize();var m=k.previousSibling;if(m){var n=m.textContent;n&&n.length&&8203==n.charCodeAt(n.length-1)&&(1==n.length?a(m).remove():m.textContent=m.textContent.substr(0,n.length-h(n)))}return c(k)?f=j(k):d(k)?g(k)&&e(k,a(k).parents("li:first").get(0))?b.cursorLists._backspace(k):i(k):f=j(k),a(k).remove(),o(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists()),b.spaces.normalizeAroundCursor(),b.selection.restore(),f}function l(c){var d=a(c).parentsUntil(b.$el,"BLOCKQUOTE").length>0,e=b.node.deepestParent(c,[],!d);if(e&&"BLOCKQUOTE"==e.tagName){var f=b.node.deepestParent(c,[a(c).parentsUntil(b.$el,"BLOCKQUOTE").get(0)]);f&&f.nextSibling&&(e=f)}if(null!==e){var g,h=e.nextSibling;if(b.node.isBlock(e)&&(b.node.isEditable(e)||b.node.isDeletable(e))&&h&&a.FE.NO_DELETE_TAGS.indexOf(h.tagName)<0)if(b.node.isDeletable(h))a(h).remove(),a(c).replaceWith(a.FE.MARKERS);else if(b.node.isBlock(h)&&b.node.isEditable(h))if(b.node.isList(h))if(b.node.isEmpty(e,!0))a(e).remove(),a(h).find("li:first").prepend(a.FE.MARKERS);else{var i=a(h).find("li:first");"BLOCKQUOTE"==e.tagName&&(g=b.node.contents(e),g.length&&b.node.isBlock(g[g.length-1])&&(e=g[g.length-1])),0===i.find("ul, ol").length&&(a(c).replaceWith(a.FE.MARKERS),i.find(b.html.blockTagsQuery()).not("ol, ul, table").each(function(){this.parentNode==i.get(0)&&a(this).replaceWith(a(this).html()+(b.node.isEmpty(this)?"":"<br>"))}),a(e).append(b.node.contents(i.get(0))),i.remove(),0===a(h).find("li").length&&a(h).remove())}else{if(g=b.node.contents(h),g.length&&"BR"==g[0].tagName&&a(g[0]).remove(),"BLOCKQUOTE"!=h.tagName&&"BLOCKQUOTE"==e.tagName)for(g=b.node.contents(e);g.length&&b.node.isBlock(g[g.length-1]);)e=g[g.length-1],g=b.node.contents(e);else if("BLOCKQUOTE"==h.tagName&&"BLOCKQUOTE"!=e.tagName)for(g=b.node.contents(h);g.length&&b.node.isBlock(g[0]);)h=g[0],g=b.node.contents(h);a(c).replaceWith(a.FE.MARKERS),a(e).append(h.innerHTML),a(h).remove()}else{for(a(c).replaceWith(a.FE.MARKERS);h&&"BR"!==h.tagName&&!b.node.isBlock(h)&&b.node.isEditable(h);){var j=h;h=h.nextSibling,a(e).append(j)}h&&"BR"==h.tagName&&b.node.isEditable(h)&&a(h).remove()}}}function m(d){for(var e=d;!e.nextSibling;)if(e=e.parentNode,b.node.isElement(e))return!1;if(e=e.nextSibling,"BR"==e.tagName&&b.node.isEditable(e))if(e.nextSibling){if(b.node.isBlock(e.nextSibling)&&b.node.isEditable(e.nextSibling)){if(!(a.FE.NO_DELETE_TAGS.indexOf(e.nextSibling.tagName)<0))return void a(e).remove();e=e.nextSibling,a(e.previousSibling).remove()}}else if(c(e)){if(g(d))b.cursorLists._del(d);else{var f=b.node.deepestParent(e);f&&((!b.node.isEmpty(b.node.blockParent(e))||(b.node.blockParent(e).nextSibling&&a.FE.NO_DELETE_TAGS.indexOf(b.node.blockParent(e).nextSibling.tagName))<0)&&a(e).remove(),l(d))}return}var i;if(!b.node.isBlock(e)&&b.node.isEditable(e)){for(i=b.node.contents(e);e.nodeType!=Node.TEXT_NODE&&i.length&&!b.node.isDeletable(e)&&b.node.isEditable(e);)e=i[0],i=b.node.contents(e);e.nodeType==Node.TEXT_NODE?(a(e).before(a.FE.MARKERS),e.textContent.length&&(e.textContent=e.textContent.substring(h(e.textContent,!0),e.textContent.length))):b.node.isDeletable(e)?(a(e).before(a.FE.MARKERS),a(e).remove()):!1!==b.events.trigger("node.remove",[a(e)])&&(a(e).before(a.FE.MARKERS),a(e).remove()),a(d).remove()}else if(a.FE.NO_DELETE_TAGS.indexOf(e.tagName)<0&&(b.node.isEditable(e)||b.node.isDeletable(e)))if(b.node.isDeletable(e))a(d).replaceWith(a.FE.MARKERS),a(e).remove();else if(b.node.isList(e))d.previousSibling?(a(e).find("li:first").prepend(d),b.cursorLists._backspace(d)):(a(e).find("li:first").prepend(a.FE.MARKERS),a(d).remove());else if(i=b.node.contents(e),i&&"BR"==i[0].tagName&&a(i[0]).remove(),i&&"BLOCKQUOTE"==e.tagName){var j=i[0];for(a(d).before(a.FE.MARKERS);j&&"BR"!=j.tagName;){var k=j;j=j.nextSibling,a(d).before(k)}j&&"BR"==j.tagName&&a(j).remove()}else a(d).after(a(e).html()).after(a.FE.MARKERS),a(e).remove()}function n(){var e=b.markers.insert();if(!e)return!1;if(b.el.normalize(),c(e))if(g(e))if(0===a(e).parents("li:first").find("ul, ol").length)b.cursorLists._del(e);else{var f=a(e).parents("li:first").find("ul:first, ol:first").find("li:first");f=f.find(b.html.blockTagsQuery()).get(-1)||f,f.prepend(e),b.cursorLists._backspace(e)}else l(e);else m(d(e)?e:e);a(e).remove(),o(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists()),b.spaces.normalizeAroundCursor(),b.selection.restore()}function o(){for(var a=b.el.querySelectorAll("blockquote:empty"),c=0;c<a.length;c++)a[c].parentNode.removeChild(a[c])}function p(){b.$el.find(".fr-to-remove").each(function(){for(var c=b.node.contents(this),d=0;d<c.length;d++)c[d].nodeType==Node.TEXT_NODE&&(c[d].textContent=c[d].textContent.replace(/\u200B/g,""));a(this).replaceWith(this.innerHTML)})}function q(c,d,e){var g,h=b.node.deepestParent(c,[],!e);if(h&&"BLOCKQUOTE"==h.tagName)return f(c,h)?(g=b.html.defaultTag(),
g?a(h).after("<"+g+">"+a.FE.MARKERS+"<br></"+g+">"):a(h).after(a.FE.MARKERS+"<br>"),a(c).remove(),!1):(s(c,d,e),!1);if(null==h)g=b.html.defaultTag(),g&&b.node.isElement(c.parentNode)?a(c).replaceWith("<"+g+">"+a.FE.MARKERS+"<br></"+g+">"):!c.previousSibling||a(c.previousSibling).is("br")||c.nextSibling?a(c).replaceWith("<br>"+a.FE.MARKERS):a(c).replaceWith("<br>"+a.FE.MARKERS+"<br>");else{var i=c,j="";b.node.isBlock(h)&&!d||(j="<br/>");var k="",l="";g=b.html.defaultTag();var m="",n="";g&&b.node.isBlock(h)&&(m="<"+g+">",n="</"+g+">",h.tagName==g.toUpperCase()&&(m=b.node.openTagString(a(h).clone().removeAttr("id").get(0))));do{if(i=i.parentNode,!d||i!=h||d&&!b.node.isBlock(h))if(k+=b.node.closeTagString(i),i==h&&b.node.isBlock(h))l=m+l;else{var o="A"==i.tagName&&f(c,i)?"fr-to-remove":"";l=b.node.openTagString(a(i).clone().addClass(o).get(0))+l}}while(i!=h);j=k+j+l+(c.parentNode==h&&b.node.isBlock(h)?"":a.FE.INVISIBLE_SPACE)+a.FE.MARKERS,b.node.isBlock(h)&&!a(h).find("*:last").is("br")&&a(h).append("<br/>"),a(c).after('<span id="fr-break"></span>'),a(c).remove(),h.nextSibling&&!b.node.isBlock(h.nextSibling)||b.node.isBlock(h)||a(h).after("<br>");var p;p=!d&&b.node.isBlock(h)?b.node.openTagString(h)+a(h).html()+n:b.node.openTagString(h)+a(h).html()+b.node.closeTagString(h),p=p.replace(/<span id="fr-break"><\/span>/g,j),a(h).replaceWith(p)}}function r(c,d,g){var h,i=b.node.deepestParent(c,[],!g);if(i&&"TABLE"==i.tagName)return a(i).find("td:first, th:first").prepend(c),r(c,d,g);if(i&&"BLOCKQUOTE"==i.tagName){if(e(c,i))return h=b.html.defaultTag(),h?a(i).before("<"+h+">"+a.FE.MARKERS+"<br></"+h+">"):a(i).before(a.FE.MARKERS+"<br>"),a(c).remove(),!1;f(c,i)?q(c,d,!0):s(c,d,!0)}if(null==i)h=b.html.defaultTag(),h&&b.node.isElement(c.parentNode)?a(c).replaceWith("<"+h+">"+a.FE.MARKERS+"<br></"+h+">"):a(c).replaceWith("<br>"+a.FE.MARKERS);else{if(b.node.isBlock(i))if("PRE"==i.tagName&&(d=!0),d)a(c).remove(),a(i).prepend("<br>"+a.FE.MARKERS);else{if(b.node.isEmpty(i,!0))return q(c,d,g);if(b.opts.keepFormatOnDelete){for(var j=c,k=a.FE.INVISIBLE_SPACE;j!=i&&!b.node.isElement(j);)j=j.parentNode,k=b.node.openTagString(j)+k+b.node.closeTagString(j);a(i).before(k)}else a(i).before(b.node.openTagString(a(i).clone().removeAttr("id").get(0))+"<br>"+b.node.closeTagString(i))}else a(i).before("<br>");a(c).remove()}}function s(c,d,g){var h=b.node.deepestParent(c,[],!g);if(null==h)b.html.defaultTag()&&c.parentNode===b.el?a(c).replaceWith("<"+b.html.defaultTag()+">"+a.FE.MARKERS+"<br></"+b.html.defaultTag()+">"):(c.nextSibling&&!b.node.isBlock(c.nextSibling)||a(c).after("<br>"),a(c).replaceWith("<br>"+a.FE.MARKERS));else{var i=c,j="";"PRE"==h.tagName&&(d=!0),b.node.isBlock(h)&&!d||(j="<br>");var k="",l="";do{var m=i;if(i=i.parentNode,"BLOCKQUOTE"==h.tagName&&b.node.isEmpty(m)&&!b.node.hasClass(m,"fr-marker")&&a(m).find(c).length>0&&a(m).after(c),("BLOCKQUOTE"!=h.tagName||!f(c,i)&&!e(c,i))&&(!d||i!=h||d&&!b.node.isBlock(h))){k+=b.node.closeTagString(i);var n="A"==i.tagName&&f(c,i)?"fr-to-remove":"";l=b.node.openTagString(a(i).clone().addClass(n).removeAttr("id").get(0))+l}}while(i!=h);var o=h==c.parentNode&&b.node.isBlock(h)||c.nextSibling;if("BLOCKQUOTE"==h.tagName){c.previousSibling&&b.node.isBlock(c.previousSibling)&&c.nextSibling&&"BR"==c.nextSibling.tagName&&(a(c.nextSibling).after(c),c.nextSibling&&"BR"==c.nextSibling.tagName&&a(c.nextSibling).remove());var p=b.html.defaultTag();j=k+j+(p?"<"+p+">":"")+a.FE.MARKERS+"<br>"+(p?"</"+p+">":"")+l}else j=k+j+l+(o?"":a.FE.INVISIBLE_SPACE)+a.FE.MARKERS;a(c).replaceWith('<span id="fr-break"></span>');var q=b.node.openTagString(h)+a(h).html()+b.node.closeTagString(h);q=q.replace(/<span id="fr-break"><\/span>/g,j),a(h).replaceWith(q)}}function t(e){var f=b.markers.insert();if(!f)return!0;b.el.normalize();var h=!1;a(f).parentsUntil(b.$el,"BLOCKQUOTE").length>0&&(e=!1,h=!0),a(f).parentsUntil(b.$el,"TD, TH").length&&(h=!1),c(f)?!g(f)||e||h?q(f,e,h):b.cursorLists._endEnter(f):d(f)?!g(f)||e||h?r(f,e,h):b.cursorLists._startEnter(f):!g(f)||e||h?s(f,e,h):b.cursorLists._middleEnter(f),p(),b.html.fillEmptyBlocks(!0),b.opts.htmlUntouched||(b.html.cleanEmptyTags(),b.clean.lists()),b.spaces.normalizeAroundCursor(),b.selection.restore()}return{enter:t,backspace:k,del:n,isAtEnd:f,isAtStart:e}},a.FE.ENTER_P=0,a.FE.ENTER_DIV=1,a.FE.ENTER_BR=2,a.FE.KEYCODE={BACKSPACE:8,TAB:9,ENTER:13,SHIFT:16,CTRL:17,ALT:18,ESC:27,SPACE:32,ARROW_LEFT:37,ARROW_UP:38,ARROW_RIGHT:39,ARROW_DOWN:40,DELETE:46,ZERO:48,ONE:49,TWO:50,THREE:51,FOUR:52,FIVE:53,SIX:54,SEVEN:55,EIGHT:56,NINE:57,FF_SEMICOLON:59,FF_EQUALS:61,QUESTION_MARK:63,A:65,B:66,C:67,D:68,E:69,F:70,G:71,H:72,I:73,J:74,K:75,L:76,M:77,N:78,O:79,P:80,Q:81,R:82,S:83,T:84,U:85,V:86,W:87,X:88,Y:89,Z:90,META:91,NUM_ZERO:96,NUM_ONE:97,NUM_TWO:98,NUM_THREE:99,NUM_FOUR:100,NUM_FIVE:101,NUM_SIX:102,NUM_SEVEN:103,NUM_EIGHT:104,NUM_NINE:105,NUM_MULTIPLY:106,NUM_PLUS:107,NUM_MINUS:109,NUM_PERIOD:110,NUM_DIVISION:111,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123,FF_HYPHEN:173,SEMICOLON:186,DASH:189,EQUALS:187,COMMA:188,HYPHEN:189,PERIOD:190,SLASH:191,APOSTROPHE:192,TILDE:192,SINGLE_QUOTE:222,OPEN_SQUARE_BRACKET:219,BACKSLASH:220,CLOSE_SQUARE_BRACKET:221,IME:229},a.extend(a.FE.DEFAULTS,{enter:a.FE.ENTER_P,multiLine:!0,tabSpaces:0}),a.FE.MODULES.keys=function(b){function c(a){b.opts.multiLine?b.helpers.isIOS()?I=b.snapshot.get():(a.preventDefault(),a.stopPropagation(),b.selection.isCollapsed()||b.selection.remove(),b.cursor.enter()):(a.preventDefault(),a.stopPropagation())}function d(a){a.preventDefault(),a.stopPropagation(),b.opts.multiLine&&(b.selection.isCollapsed()||b.selection.remove(),b.cursor.enter(!0))}function e(){setTimeout(function(){b.events.disableBlur(),b.events.focus()},0)}function f(a){b.selection.isCollapsed()?b.helpers.isIOS()?I=b.snapshot.get():(b.cursor.backspace(),a.preventDefault(),a.stopPropagation()):(a.preventDefault(),a.stopPropagation(),b.selection.remove(),b.html.fillEmptyBlocks()),b.placeholder.refresh()}function g(a){a.preventDefault(),a.stopPropagation(),""===b.selection.text()?b.cursor.del():b.selection.remove(),b.placeholder.refresh()}function h(c){var d=b.selection.element();if(!b.helpers.isMobile()&&d&&"A"==d.tagName){c.preventDefault(),c.stopPropagation(),b.selection.isCollapsed()||b.selection.remove();var e=b.markers.insert();if(e){var f=e.previousSibling;!e.nextSibling&&e.parentNode&&"A"==e.parentNode.tagName?(e.parentNode.insertAdjacentHTML("afterend","&nbsp;"+a.FE.MARKERS),e.parentNode.removeChild(e)):(f&&f.nodeType==Node.TEXT_NODE&&1==f.textContent.length&&160==f.textContent.charCodeAt(0)?f.textContent=f.textContent+" ":e.insertAdjacentHTML("beforebegin","&nbsp;"),e.outerHTML=a.FE.MARKERS),b.selection.restore()}}}function i(){if(b.browser.mozilla&&b.selection.isCollapsed()&&!H){var a=b.selection.ranges(0),c=a.startContainer,d=a.startOffset;c&&c.nodeType==Node.TEXT_NODE&&d<=c.textContent.length&&d>0&&32==c.textContent.charCodeAt(d-1)&&(b.selection.save(),b.spaces.normalize(),b.selection.restore())}}function j(){b.selection.isFull()&&setTimeout(function(){var c=b.html.defaultTag();c?b.$el.html("<"+c+">"+a.FE.MARKERS+"<br/></"+c+">"):b.$el.html(a.FE.MARKERS+"<br/>"),b.selection.restore(),b.placeholder.refresh(),b.button.bulkRefresh(),b.undo.saveStep()},0)}function k(a){if(b.opts.tabSpaces>0)if(b.selection.isCollapsed()){b.undo.saveStep(),a.preventDefault(),a.stopPropagation();for(var c="",d=0;d<b.opts.tabSpaces;d++)c+="&nbsp;";b.html.insert(c),b.placeholder.refresh(),b.undo.saveStep()}else a.preventDefault(),a.stopPropagation(),a.shiftKey?b.commands.outdent():b.commands.indent()}function l(){H=!1}function m(){H=!1}function n(){return H}function o(){var c=b.html.defaultTag();c?b.$el.html("<"+c+">"+a.FE.MARKERS+"<br/></"+c+">"):b.$el.html(a.FE.MARKERS+"<br/>"),b.selection.restore()}function p(i){b.events.disableBlur(),I=null;var j=i.which;if(16===j)return!0;if(E=j,j===a.FE.KEYCODE.IME)return H=!0,!0;H=!1;var l=w(j)&&!u(i),m=j==a.FE.KEYCODE.BACKSPACE||j==a.FE.KEYCODE.DELETE;if((b.selection.isFull()&&!b.opts.keepFormatOnDelete&&!b.placeholder.isVisible()||m&&b.placeholder.isVisible()&&b.opts.keepFormatOnDelete)&&(l||m)&&(o(),!w(j)))return i.preventDefault(),!0;j==a.FE.KEYCODE.ENTER?i.shiftKey?d(i):c(i):j===a.FE.KEYCODE.BACKSPACE&&(i.metaKey||i.ctrlKey)?e():j!=a.FE.KEYCODE.BACKSPACE||u(i)||i.altKey?j!=a.FE.KEYCODE.DELETE||u(i)||i.altKey||i.shiftKey?j==a.FE.KEYCODE.SPACE?h(i):j==a.FE.KEYCODE.TAB?k(i):u(i)||!w(i.which)||b.selection.isCollapsed()||i.ctrlKey||b.selection.remove():b.placeholder.isVisible()?(b.opts.keepFormatOnDelete||o(),i.preventDefault(),i.stopPropagation()):g(i):b.placeholder.isVisible()?(b.opts.keepFormatOnDelete||o(),i.preventDefault(),i.stopPropagation()):f(i),b.events.enableBlur()}function q(a){for(var c=b.doc.createTreeWalker(a,NodeFilter.SHOW_TEXT,b.node.filter(function(a){return/\u200B/gi.test(a.textContent)}),!1);c.nextNode();){var d=c.currentNode;d.textContent=d.textContent.replace(/\u200B/gi,"")}}function r(){if(!b.$wp)return!0;var c;b.opts.height||b.opts.heightMax?(c=b.position.getBoundingRect().top,(b.helpers.isIOS()||b.helpers.isAndroid())&&(c-=b.helpers.scrollTop()),b.opts.iframe&&(c+=b.$iframe.offset().top),c>b.$wp.offset().top-b.helpers.scrollTop()+b.$wp.height()-20&&b.$wp.scrollTop(c+b.$wp.scrollTop()-(b.$wp.height()+b.$wp.offset().top)+b.helpers.scrollTop()+20)):(c=b.position.getBoundingRect().top,b.opts.toolbarBottom&&(c+=b.opts.toolbarStickyOffset),(b.helpers.isIOS()||b.helpers.isAndroid())&&(c-=b.helpers.scrollTop()),b.opts.iframe&&(c+=b.$iframe.offset().top,c-=b.helpers.scrollTop()),c+=b.opts.toolbarStickyOffset,c>b.o_win.innerHeight-20&&a(b.o_win).scrollTop(c+b.helpers.scrollTop()-b.o_win.innerHeight+20),c=b.position.getBoundingRect().top,b.opts.toolbarBottom||(c-=b.opts.toolbarStickyOffset),(b.helpers.isIOS()||b.helpers.isAndroid())&&(c-=b.helpers.scrollTop()),b.opts.iframe&&(c+=b.$iframe.offset().top,c-=b.helpers.scrollTop()),c<b.$tb.height()+20&&c>=0&&a(b.o_win).scrollTop(c+b.helpers.scrollTop()-b.$tb.height()-20))}function s(){var c=b.selection.element(),d=b.node.blockParent(c);if(d&&"DIV"==d.tagName&&b.selection.info(d).atStart){var e=b.html.defaultTag();d.previousSibling&&"DIV"!=d.previousSibling.tagName&&e&&"div"!=e&&(b.selection.save(),a(d).replaceWith("<"+e+">"+d.innerHTML+"</"+e+">"),b.selection.restore())}}function t(c){if(c&&0===c.which&&E&&(c.which=E),b.helpers.isIOS()&&c&&I)if(c.which==a.FE.KEYCODE.ENTER)b.snapshot.restore(I),b.cursor.enter();else if(c.which==a.FE.KEYCODE.BACKSPACE){var d=b.snapshot.get();b.snapshot.restore(I),b.cursor.backspace(),b.el.innerHTML!==d.html&&b.snapshot.restore(d)}if(b.helpers.isAndroid()&&b.browser.mozilla)return!0;if(H)return!1;if(!b.selection.isCollapsed())return!0;if(c&&(c.which===a.FE.KEYCODE.META||c.which==a.FE.KEYCODE.CTRL))return!0;if(c&&v(c.which))return!0;c&&c.which==a.FE.KEYCODE.ENTER&&b.helpers.isIOS()&&s(),c&&(c.which==a.FE.KEYCODE.ENTER||c.which==a.FE.KEYCODE.BACKSPACE||c.which>=37&&c.which<=40&&!b.browser.msie)&&r();var e=function(a){if(!a)return!1;var b=a.innerHTML;return!!((b=b.replace(/<span[^>]*? class\s*=\s*["']?fr-marker["']?[^>]+>\u200b<\/span>/gi,""))&&/\u200B/.test(b)&&b.replace(/\u200B/gi,"").length>0)},f=function(a){var c=/[\u3041-\u3096\u30A0-\u30FF\u4E00-\u9FFF\u3130-\u318F\uAC00-\uD7AF]/gi;return!b.helpers.isIOS()||0===((a.textContent||"").match(c)||[]).length},g=b.selection.element();e(g)&&!b.node.hasClass(g,"fr-marker")&&"IFRAME"!=g.tagName&&f(g)&&(b.selection.save(),q(g),b.selection.restore())}function u(a){if(-1!=navigator.userAgent.indexOf("Mac OS X")){if(a.metaKey&&!a.altKey)return!0}else if(a.ctrlKey&&!a.altKey)return!0;return!1}function v(b){if(b>=a.FE.KEYCODE.ARROW_LEFT&&b<=a.FE.KEYCODE.ARROW_DOWN)return!0}function w(c){if(c>=a.FE.KEYCODE.ZERO&&c<=a.FE.KEYCODE.NINE)return!0;if(c>=a.FE.KEYCODE.NUM_ZERO&&c<=a.FE.KEYCODE.NUM_MULTIPLY)return!0;if(c>=a.FE.KEYCODE.A&&c<=a.FE.KEYCODE.Z)return!0;if(b.browser.webkit&&0===c)return!0;switch(c){case a.FE.KEYCODE.SPACE:case a.FE.KEYCODE.QUESTION_MARK:case a.FE.KEYCODE.NUM_PLUS:case a.FE.KEYCODE.NUM_MINUS:case a.FE.KEYCODE.NUM_PERIOD:case a.FE.KEYCODE.NUM_DIVISION:case a.FE.KEYCODE.SEMICOLON:case a.FE.KEYCODE.FF_SEMICOLON:case a.FE.KEYCODE.DASH:case a.FE.KEYCODE.EQUALS:case a.FE.KEYCODE.FF_EQUALS:case a.FE.KEYCODE.COMMA:case a.FE.KEYCODE.PERIOD:case a.FE.KEYCODE.SLASH:case a.FE.KEYCODE.APOSTROPHE:case a.FE.KEYCODE.SINGLE_QUOTE:case a.FE.KEYCODE.OPEN_SQUARE_BRACKET:case a.FE.KEYCODE.BACKSLASH:case a.FE.KEYCODE.CLOSE_SQUARE_BRACKET:return!0;default:return!1}}function x(c){var d=c.which;if(u(c)||d>=37&&d<=40||!w(d)&&d!=a.FE.KEYCODE.DELETE&&d!=a.FE.KEYCODE.BACKSPACE&&d!=a.FE.KEYCODE.ENTER&&d!=a.FE.KEYCODE.IME)return!0;F||(G=b.snapshot.get(),b.undo.canDo()||b.undo.saveStep()),clearTimeout(F),F=setTimeout(function(){F=null,b.undo.saveStep()},Math.max(250,b.opts.typingTimer))}function y(a){var c=a.which;if(u(a)||c>=37&&c<=40)return!0;G&&F?(b.undo.saveStep(G),G=null):void 0!==c&&0!==c||G||F||b.undo.saveStep()}function z(){F&&(clearTimeout(F),b.undo.saveStep(),G=null)}function A(b){var c=b.which;return u(b)||c==a.FE.KEYCODE.F5}function B(a){return(!a||"BR"!=a.tagName)&&(0===(a.textContent||"").length&&a.querySelector&&!a.querySelector(":scope > br"))}function C(c){var d=b.el.childNodes,e=b.html.defaultTag();return!(!c.target||c.target===b.el)||(0===d.length||void(b.$el.outerHeight()-c.offsetY<=10?B(d[d.length-1])&&(e?b.$el.append("<"+e+">"+a.FE.MARKERS+"<br></"+e+">"):b.$el.append(a.FE.MARKERS+"<br>"),b.selection.restore(),r()):c.offsetY<=10&&B(d[0])&&(e?b.$el.prepend("<"+e+">"+a.FE.MARKERS+"<br></"+e+">"):b.$el.prepend(a.FE.MARKERS+"<br>"),b.selection.restore(),r())))}function D(){if(b.events.on("keydown",x),b.events.on("input",i),b.events.on("mousedown",m),b.events.on("keyup input",y),b.events.on("keypress",l),b.events.on("keydown",p),b.events.on("keyup",t),b.events.on("html.inserted",t),b.events.on("cut",j),b.events.on("click",C),!b.browser.edge&&b.el.msGetInputContext)try{b.el.msGetInputContext().addEventListener("MSCandidateWindowShow",function(){H=!0}),b.el.msGetInputContext().addEventListener("MSCandidateWindowHide",function(){H=!1,t()})}catch(a){}}var E,F,G,H=!1,I=null;return{_init:D,ctrlKey:u,isCharacter:w,isArrow:v,forceUndo:z,isIME:n,isBrowserAction:A,positionCaret:r}},a.FE.MODULES.accessibility=function(b){function c(a){if(a&&a.length){a.data("blur-event-set")||a.parents(".fr-popup").length||(b.events.$on(a,"blur",function(){var c=a.parents(".fr-toolbar, .fr-popup").data("instance")||b;c.events.blurActive()&&c.events.trigger("blur"),c.events.enableBlur()},!0),a.data("blur-event-set",!0));(a.parents(".fr-toolbar, .fr-popup").data("instance")||b).events.disableBlur(),a.focus(),b.shared.$f_el=a}}function d(a,b){var d=b?"last":"first",e=a.find("button:visible:not(.fr-disabled), .fr-group span.fr-command:visible")[d]();if(e.length)return c(e),!0}function e(a){return a.is("input, textarea")&&g(),b.events.disableBlur(),a.focus(),!0}function f(a,c){var d=a.find("input, textarea, button, select").filter(":visible").not(":disabled").filter(c?":last":":first");if(d.length)return e(d);if(b.shared.with_kb){var f=a.find(".fr-active-item:visible:first");if(f.length)return e(f);var g=a.find("[tabIndex]:visible:first");if(g.length)return e(g)}}function g(){0===b.$el.find(".fr-marker").length&&b.core.hasFocus()&&b.selection.save()}function h(a){a.$el.find(".fr-marker").length&&(a.events.disableBlur(),a.selection.restore(),a.events.enableBlur())}function i(a){var c=a.children().not(".fr-buttons");c.data("mouseenter-event-set")||(b.events.$on(c,"mouseenter","[tabIndex]",function(d){var e=a.data("instance")||b;if(!F)return d.stopPropagation(),void d.preventDefault();var f=c.find(":focus:first");f.length&&!f.is("input, button, textarea")&&(e.events.disableBlur(),f.blur(),e.events.disableBlur(),e.events.focus())}),c.data("mouseenter-event-set",!0)),!f(c)&&b.shared.with_kb&&d(a.find(".fr-buttons"))}function j(a){b.core.hasFocus()||(b.events.disableBlur(),b.events.focus()),b.accessibility.saveSelection(),b.events.disableBlur(),b.$el.blur(),b.selection.clear(),b.events.disableBlur(),b.shared.with_kb?a.find(".fr-command[tabIndex], [tabIndex]").first().focus():a.find("[tabIndex]:first").focus()}function k(){var a=b.popups.areVisible();if(a){var c=a.find(".fr-buttons");return c.find("button:focus, .fr-group span:focus").length?!d(a.data("instance").$tb):!d(c)}return!d(b.$tb)}function l(){var a=null;return b.shared.$f_el.is(".fr-dropdown.fr-active")?a=b.shared.$f_el:b.shared.$f_el.closest(".fr-dropdown-menu").prev().is(".fr-dropdown.fr-active")&&(a=b.shared.$f_el.closest(".fr-dropdown-menu").prev()),a}function m(e,g,h){if(b.shared.$f_el){var i=l();i&&(b.button.click(i),b.shared.$f_el=i);var j=e.find("button:visible:not(.fr-disabled), .fr-group span.fr-command:visible"),k=j.index(b.shared.$f_el);if(0===k&&!h||k==j.length-1&&h){var m;if(g){if(e.parent().is(".fr-popup")){m=!f(e.parent().children().not(".fr-buttons"),!h)}!1===m&&(b.shared.$f_el=null)}g&&!1===m||d(e,!h)}else c(a(j.get(k+(h?1:-1))));return!1}}function n(a,b){return m(a,b,!0)}function o(a,b){return m(a,b)}function p(a){if(b.shared.$f_el){var d;if(b.shared.$f_el.is(".fr-dropdown.fr-active"))return d=a?b.shared.$f_el.next().find(".fr-command:not(.fr-disabled)").first():b.shared.$f_el.next().find(".fr-command:not(.fr-disabled)").last(),c(d),!1;if(b.shared.$f_el.is("a.fr-command"))return d=a?b.shared.$f_el.closest("li").nextAll(":visible:first").find(".fr-command:not(.fr-disabled)").first():b.shared.$f_el.closest("li").prevAll(":visible:first").find(".fr-command:not(.fr-disabled)").first(),d.length||(d=a?b.shared.$f_el.closest(".fr-dropdown-menu").find(".fr-command:not(.fr-disabled)").first():b.shared.$f_el.closest(".fr-dropdown-menu").find(".fr-command:not(.fr-disabled)").last()),c(d),!1}}function q(){return b.shared.$f_el&&b.shared.$f_el.is(".fr-dropdown:not(.fr-active)")?s():p(!0)}function r(){return p()}function s(){if(b.shared.$f_el){if(b.shared.$f_el.hasClass("fr-dropdown"))b.button.click(b.shared.$f_el);else if(b.shared.$f_el.is("button.fr-back")){b.opts.toolbarInline&&(b.events.disableBlur(),b.events.focus());var a=b.popups.areVisible(b);a&&(b.shared.with_kb=!1),b.button.click(b.shared.$f_el),z(a)}else{if(b.events.disableBlur(),b.button.click(b.shared.$f_el),b.shared.$f_el.attr("data-popup")){var c=b.popups.areVisible(b);c&&c.data("popup-button",b.shared.$f_el)}else if(b.shared.$f_el.attr("data-modal")){var d=b.modals.areVisible(b);d&&d.data("modal-button",b.shared.$f_el)}b.shared.$f_el=null}return!1}}function t(){b.shared.$f_el&&(b.events.disableBlur(),b.shared.$f_el.blur(),b.shared.$f_el=null),!1!==b.events.trigger("toolbar.focusEditor")&&(b.events.disableBlur(),b.$el.focus(),b.events.focus())}function u(a){if(b.shared.$f_el){var d=l();return d?(b.button.click(d),c(d)):a.parent().find(".fr-back:visible").length?(b.shared.with_kb=!1,b.opts.toolbarInline&&(b.events.disableBlur(),b.events.focus()),b.button.exec(a.parent().find(".fr-back:visible:first")),z(a.parent())):b.shared.$f_el.is("button, .fr-group span")&&(a.parent().is(".fr-popup")?(h(b),b.shared.$f_el=null,!1!==b.events.trigger("toolbar.esc")&&(b.popups.hide(a.parent()),b.opts.toolbarInline&&b.toolbar.showInline(null,!0),z(a.parent()))):t()),!1}}function v(c,d){var e=-1!=navigator.userAgent.indexOf("Mac OS X")?c.metaKey:c.ctrlKey,f=c.which,g=!1;return f!=a.FE.KEYCODE.TAB||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ARROW_RIGHT||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.TAB||e||!c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ARROW_LEFT||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ARROW_UP||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ARROW_DOWN||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ENTER||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.ESC||e||c.shiftKey||c.altKey?f!=a.FE.KEYCODE.F10||e||c.shiftKey||!c.altKey||(g=k()):g=u(d):g=s():g=q():g=r():g=o(d):g=o(d,!0):g=n(d):g=n(d,!0),b.shared.$f_el||void 0!==g||(g=!0),!g&&b.keys.isBrowserAction(c)&&(g=!0),!!g||(c.preventDefault(),c.stopPropagation(),!1)}function w(c){c&&c.length&&(b.events.$on(c,"keydown",function(d){if(!a(d.target).is("a.fr-command, button.fr-command, .fr-group span.fr-command"))return!0;var e=c.parents(".fr-popup").data("instance")||c.data("instance")||b;b.shared.with_kb=!0;var f=e.accessibility.exec(d,c);return b.shared.with_kb=!1,f},!0),b.events.$on(c,"mouseenter","[tabIndex]",function(d){var e=c.parents(".fr-popup").data("instance")||c.data("instance")||b;if(!F)return d.stopPropagation(),void d.preventDefault();var f=a(d.currentTarget);e.shared.$f_el&&e.shared.$f_el.not(f)&&e.accessibility.focusEditor()},!0))}function x(a){var c=b.popups.get(a),d=y(a);w(c.find(".fr-buttons")),b.events.$on(c,"mouseenter","tabIndex",d._tiMouseenter,!0),b.events.$on(c.children().not(".fr-buttons"),"keydown","[tabIndex]",d._tiKeydown,!0),b.popups.onHide(a,function(){h(c.data("instance")||b)}),b.popups.onShow(a,function(){F=!1,setTimeout(function(){F=!0},0)})}function y(c){var e=b.popups.get(c);return{_tiKeydown:function(g){var i=e.data("instance")||b;if(!1===i.events.trigger("popup.tab",[g]))return!1;var j=g.which,k=e.find(":focus:first");if(a.FE.KEYCODE.TAB==j){g.preventDefault();var l=e.children().not(".fr-buttons"),m=l.find("input, textarea, button, select").filter(":visible").not(".fr-no-touch input, .fr-no-touch textarea, .fr-no-touch button, .fr-no-touch select, :disabled").toArray(),n=m.indexOf(this)+(g.shiftKey?-1:1);if(0<=n&&n<m.length)return i.events.disableBlur(),a(m[n]).focus(),g.stopPropagation(),!1;var o=e.find(".fr-buttons");if(o.length&&d(o,!!g.shiftKey))return g.stopPropagation(),!1;if(f(l))return g.stopPropagation(),!1}else{if(a.FE.KEYCODE.ENTER!=j)return a.FE.KEYCODE.ESC==j?(g.preventDefault(),g.stopPropagation(),h(i),i.popups.isVisible(c)&&e.find(".fr-back:visible").length?(i.opts.toolbarInline&&(i.events.disableBlur(),i.events.focus()),i.button.exec(e.find(".fr-back:visible:first")),z(e)):i.popups.isVisible(c)&&e.find(".fr-dismiss:visible").length?i.button.exec(e.find(".fr-dismiss:visible:first")):(i.popups.hide(c),i.opts.toolbarInline&&i.toolbar.showInline(null,!0),z(e)),!1):a.FE.KEYCODE.SPACE==j&&(k.is(".fr-submit")||k.is(".fr-dismiss"))?(g.preventDefault(),g.stopPropagation(),i.events.disableBlur(),i.button.exec(k),!0):i.keys.isBrowserAction(g)?void g.stopPropagation():k.is("input[type=text], textarea")?void g.stopPropagation():a.FE.KEYCODE.SPACE==j&&(k.is(".fr-link-attr")||k.is("input[type=file]"))?void g.stopPropagation():(g.stopPropagation(),g.preventDefault(),!1);var p=null;e.find(".fr-submit:visible").length>0?p=e.find(".fr-submit:visible:first"):e.find(".fr-dismiss:visible").length&&(p=e.find(".fr-dismiss:visible:first")),p&&(g.preventDefault(),g.stopPropagation(),i.events.disableBlur(),i.button.exec(p))}},_tiMouseenter:function(){C(e.data("instance")||b)}}}function z(a){var b=a.data("popup-button");b&&setTimeout(function(){c(b),a.data("popup-button",null)},0)}function A(a){var b=a.data("modal-button");b&&setTimeout(function(){c(b),a.data("modal-button",null)},0)}function B(){return null!=b.shared.$f_el}function C(a){var c=b.popups.areVisible(a);c&&c.data("popup-button",null)}function D(c){var d=-1!=navigator.userAgent.indexOf("Mac OS X")?c.metaKey:c.ctrlKey;if(c.which==a.FE.KEYCODE.F10&&!d&&!c.shiftKey&&c.altKey){b.shared.with_kb=!0;var e=b.popups.areVisible(b),g=!1;return e&&(g=f(e.children().not(".fr-buttons"))),g||k(),b.shared.with_kb=!1,c.preventDefault(),c.stopPropagation(),!1}return!0}function E(){b.$wp?b.events.on("keydown",D,!0):b.events.$on(b.$win,"keydown",D,!0),b.events.on("mousedown",function(a){C(b),b.shared.$f_el&&(h(b),a.stopPropagation(),b.events.disableBlur(),b.shared.$f_el=null)},!0),b.events.on("blur",function(){b.shared.$f_el=null,C(b)},!0)}var F=!0;return{_init:E,registerPopup:x,registerToolbar:w,focusToolbarElement:c,focusToolbar:d,focusContent:f,focusPopup:i,focusModal:j,focusEditor:t,focusPopupButton:z,focusModalButton:A,hasFocus:B,exec:v,saveSelection:g,restoreSelection:h}},a.FE.MODULES.format=function(b){function c(a,b){var c="<"+a;for(var d in b)b.hasOwnProperty(d)&&(c+=" "+d+'="'+b[d]+'"');return c+=">"}function d(a){return"</"+a+">"}function e(a,b){var c=a;for(var d in b)b.hasOwnProperty(d)&&(c+="id"==d?"#"+b[d]:"class"==d?"."+b[d]:"["+d+'="'+b[d]+'"]');return c}function f(a,b){return!(!a||a.nodeType!=Node.ELEMENT_NODE)&&(a.matches||a.matchesSelector||a.msMatchesSelector||a.mozMatchesSelector||a.webkitMatchesSelector||a.oMatchesSelector).call(a,b)}function g(d,e,f){if(d){if(b.node.isBlock(d))return g(d.firstChild,e,f),!1;for(var h=a(c(e,f)).insertBefore(d),i=d;i&&!a(i).is(".fr-marker")&&0===a(i).find(".fr-marker").length&&"UL"!=i.tagName&&"OL"!=i.tagName;){var j=i;i=i.nextSibling,h.append(j)}if(i)(a(i).find(".fr-marker").length||"UL"==i.tagName||"OL"==i.tagName)&&g(i.firstChild,e,f);else{for(var k=h.get(0).parentNode;k&&!k.nextSibling&&!b.node.isElement(k);)k=k.parentNode;if(k){var l=k.nextSibling;l&&(b.node.isBlock(l)?g(l.firstChild,e,f):g(l,e,f))}}h.is(":empty")&&h.remove()}}function h(h,i){var j;if(void 0===i&&(i={}),i.style&&delete i.style,b.selection.isCollapsed()){b.markers.insert();b.$el.find(".fr-marker").replaceWith(c(h,i)+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+d(h)),b.selection.restore()}else{b.selection.save();g(b.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling,h,i);var k;do{for(k=b.$el.find(e(h,i)+" > "+e(h,i)),j=0;j<k.length;j++)k[j].outerHTML=k[j].innerHTML}while(k.length);b.el.normalize();var l=b.el.querySelectorAll(".fr-marker");for(j=0;j<l.length;j++){var m=a(l[j]);!0===m.data("type")?f(m.get(0).nextSibling,e(h,i))&&m.next().prepend(m):f(m.get(0).previousSibling,e(h,i))&&m.prev().append(m)}b.selection.restore()}}function i(a,c,d,g){if(!g){var h=!1;if(!0===a.data("type"))for(;b.node.isFirstSibling(a.get(0))&&!a.parent().is(b.$el)&&!a.parent().is("ol")&&!a.parent().is("ul");)a.parent().before(a),h=!0;else if(!1===a.data("type"))for(;b.node.isLastSibling(a.get(0))&&!a.parent().is(b.$el)&&!a.parent().is("ol")&&!a.parent().is("ul");)a.parent().after(a),h=!0;if(h)return!0}if(a.parents(c).length||void 0===c){var i="",j="",k=a.parent();if(k.is(b.$el)||b.node.isBlock(k.get(0)))return!1;for(;!b.node.isBlock(k.parent().get(0))&&(void 0===c||void 0!==c&&!f(k.get(0),e(c,d)));)i+=b.node.closeTagString(k.get(0)),j=b.node.openTagString(k.get(0))+j,k=k.parent();var l=a.get(0).outerHTML;a.replaceWith('<span id="mark"></span>');var m=k.html().replace(/<span id="mark"><\/span>/,i+b.node.closeTagString(k.get(0))+j+l+i+b.node.openTagString(k.get(0))+j);return k.replaceWith(b.node.openTagString(k.get(0))+m+b.node.closeTagString(k.get(0))),!0}return!1}function j(c,d,g,h){for(var i=b.node.contents(c.get(0)),k=0;k<i.length;k++){var l=i[k];if(b.node.hasClass(l,"fr-marker"))d=(d+1)%2;else if(d)if(a(l).find(".fr-marker").length>0)d=j(a(l),d,g,h);else{for(var m=a(l).find(g||"*"),n=m.length-1;n>=0;n--){var o=m[n];b.node.isBlock(o)||b.node.isVoid(o)||void 0!==g&&!f(o,e(g,h))||(o.outerHTML=o.innerHTML)}void 0===g&&l.nodeType==Node.ELEMENT_NODE&&!b.node.isVoid(l)&&!b.node.isBlock(l)||f(l,e(g,h))?a(l).replaceWith(l.innerHTML):void 0===g&&l.nodeType==Node.ELEMENT_NODE&&b.node.isBlock(l)&&b.node.clearAttributes(l)}else a(l).find(".fr-marker").length>0&&(d=j(a(l),d,g,h))}return d}function k(c,d){void 0===d&&(d={}),d.style&&delete d.style;var e=b.selection.isCollapsed();b.selection.save();for(var f=!0;f;){f=!1;for(var g=b.$el.find(".fr-marker"),h=0;h<g.length;h++){var k=a(g[h]),l=null;if(k.attr("data-cloned")||e||(l=k.clone().removeClass("fr-marker").addClass("fr-clone"),!0===k.data("type")?k.attr("data-cloned",!0).after(l):k.attr("data-cloned",!0).before(l)),i(k,c,d,e)){f=!0;break}}}j(b.$el,0,c,d),e||(b.$el.find(".fr-marker").remove(),b.$el.find(".fr-clone").removeClass("fr-clone").addClass("fr-marker")),e&&b.$el.find(".fr-marker").before(a.FE.INVISIBLE_SPACE).after(a.FE.INVISIBLE_SPACE),b.html.cleanEmptyTags(),b.el.normalize(),b.selection.restore()}function l(a,b){q(a,b)?k(a,b):h(a,b)}function m(b,c){var d=a(b);d.css(c,""),""===d.attr("style")&&d.replaceWith(d.html())}function n(b,c){return 0===a(b).attr("style").indexOf(c+":")||a(b).attr("style").indexOf(";"+c+":")>=0||a(b).attr("style").indexOf("; "+c+":")>=0}function o(c,d){var e,f;if(b.selection.isCollapsed()){b.markers.insert(),f=b.$el.find(".fr-marker");var h=f.parent();if(b.node.openTagString(h.get(0))=='<span style="'+c+": "+h.css(c)+';">'){if(b.node.isEmpty(h.get(0)))h.replaceWith('<span style="'+c+": "+d+';">'+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+"</span>");else{var j={};j["style*"]=c+":",i(f,"span",j,!0),f=b.$el.find(".fr-marker"),d?f.replaceWith('<span style="'+c+": "+d+';">'+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+"</span>"):f.replaceWith(a.FE.INVISIBLE_SPACE+a.FE.MARKERS)}b.html.cleanEmptyTags()}else b.node.isEmpty(h.get(0))&&h.is("span")?(f.replaceWith(a.FE.MARKERS),h.css(c,d)):f.replaceWith('<span style="'+c+": "+d+';">'+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+"</span>");b.selection.restore()}else{if(b.selection.save(),null==d||"color"==c&&b.$el.find(".fr-marker").parents("u, a").length>0){var k=b.$el.find(".fr-marker");for(e=0;e<k.length;e++)if(f=a(k[e]),!0===f.data("type"))for(;b.node.isFirstSibling(f.get(0))&&!f.parent().is(b.$el)&&!b.node.isElement(f.parent().get(0))&&!b.node.isBlock(f.parent().get(0));)f.parent().before(f);else for(;b.node.isLastSibling(f.get(0))&&!f.parent().is(b.$el)&&!b.node.isElement(f.parent().get(0))&&!b.node.isBlock(f.parent().get(0));)f.parent().after(f)}var l=b.$el.find('.fr-marker[data-type="true"]').get(0).nextSibling,o={class:"fr-unprocessed"};for(d&&(o.style=c+": "+d+";"),g(l,"span",o),b.$el.find(".fr-marker + .fr-unprocessed").each(function(){a(this).prepend(a(this).prev())}),b.$el.find(".fr-unprocessed + .fr-marker").each(function(){a(this).prev().append(this)}),(d||"").match(/\dem$/)&&b.$el.find("span.fr-unprocessed").removeClass("fr-unprocessed");b.$el.find("span.fr-unprocessed").length>0;){var p=b.$el.find("span.fr-unprocessed:first").removeClass("fr-unprocessed");if(p.parent().get(0).normalize(),p.parent().is("span")&&1==p.parent().get(0).childNodes.length){p.parent().css(c,d);var q=p;p=p.parent(),q.replaceWith(q.html())}var r=p.find("span");for(e=r.length-1;e>=0;e--)m(r[e],c);var s=p.parentsUntil(b.$el,"span[style]"),t=[];for(e=s.length-1;e>=0;e--)n(s[e],c)||t.push(s[e]);if(s=s.not(t),s.length){var u="",v="",w="",x="",y=p.get(0);do{y=y.parentNode,a(y).addClass("fr-split"),u+=b.node.closeTagString(y),v=b.node.openTagString(a(y).clone().addClass("fr-split").get(0))+v,s.get(0)!=y&&(w+=b.node.closeTagString(y),x=b.node.openTagString(a(y).clone().addClass("fr-split").get(0))+x)}while(s.get(0)!=y);var z=u+b.node.openTagString(a(s.get(0)).clone().css(c,d||"").get(0))+x+p.css(c,"").get(0).outerHTML+w+"</span>"+v;p.replaceWith('<span id="fr-break"></span>');var A=s.get(0).outerHTML;a(s.get(0)).replaceWith(A.replace(/<span id="fr-break"><\/span>/g,z))}}for(;b.$el.find(".fr-split:empty").length>0;)b.$el.find(".fr-split:empty").remove();b.$el.find(".fr-split").removeClass("fr-split"),b.$el.find('span[style=""]').removeAttr("style"),b.$el.find('span[class=""]').removeAttr("class"),b.html.cleanEmptyTags(),a(b.$el.find("span").get().reverse()).each(function(){this.attributes&&0!==this.attributes.length||a(this).replaceWith(this.innerHTML)}),b.el.normalize();var B=b.$el.find("span[style] + span[style]");for(e=0;e<B.length;e++){var C=a(B[e]),D=a(B[e]).prev();C.get(0).previousSibling==D.get(0)&&b.node.openTagString(C.get(0))==b.node.openTagString(D.get(0))&&(C.prepend(D.html()),D.remove())}b.$el.find("span[style] span[style]").each(function(){if(a(this).attr("style").indexOf("font-size")>=0){var b=a(this).parents("span[style]");b.attr("style").indexOf("background-color")>=0&&(a(this).attr("style",a(this).attr("style")+";"+b.attr("style")),i(a(this),"span[style]",{},!1))}}),b.el.normalize(),b.selection.restore()}}function p(a){o(a,null)}function q(a,c){void 0===c&&(c={}),c.style&&delete c.style;var d=b.selection.ranges(0),g=d.startContainer
;if(g.nodeType==Node.ELEMENT_NODE&&g.childNodes.length>0&&g.childNodes[d.startOffset]&&(g=g.childNodes[d.startOffset]),!d.collapsed&&g.nodeType==Node.TEXT_NODE&&d.startOffset==(g.textContent||"").length){for(;!b.node.isBlock(g.parentNode)&&!g.nextSibling;)g=g.parentNode;g.nextSibling&&(g=g.nextSibling)}for(var h=g;h&&h.nodeType==Node.ELEMENT_NODE&&!f(h,e(a,c));)h=h.firstChild;if(h&&h.nodeType==Node.ELEMENT_NODE&&f(h,e(a,c)))return!0;var i=g;for(i&&i.nodeType!=Node.ELEMENT_NODE&&(i=i.parentNode);i&&i.nodeType==Node.ELEMENT_NODE&&i!=b.el&&!f(i,e(a,c));)i=i.parentNode;return!(!i||i.nodeType!=Node.ELEMENT_NODE||i==b.el||!f(i,e(a,c)))}return{is:q,toggle:l,apply:h,remove:k,applyStyle:o,removeStyle:p}},a.extend(a.FE.DEFAULTS,{indentMargin:20}),a.FE.COMMANDS={bold:{title:"Bold",toggle:!0,refresh:function(a){var b=this.format.is("strong");a.toggleClass("fr-active",b).attr("aria-pressed",b)}},italic:{title:"Italic",toggle:!0,refresh:function(a){var b=this.format.is("em");a.toggleClass("fr-active",b).attr("aria-pressed",b)}},underline:{title:"Underline",toggle:!0,refresh:function(a){var b=this.format.is("u");a.toggleClass("fr-active",b).attr("aria-pressed",b)}},strikeThrough:{title:"Strikethrough",toggle:!0,refresh:function(a){var b=this.format.is("s");a.toggleClass("fr-active",b).attr("aria-pressed",b)}},subscript:{title:"Subscript",toggle:!0,refresh:function(a){var b=this.format.is("sub");a.toggleClass("fr-active",b).attr("aria-pressed",b)}},superscript:{title:"Superscript",toggle:!0,refresh:function(a){var b=this.format.is("sup");a.toggleClass("fr-active",b).attr("aria-pressed",b)}},outdent:{title:"Decrease Indent"},indent:{title:"Increase Indent"},undo:{title:"Undo",undo:!1,forcedRefresh:!0,disabled:!0},redo:{title:"Redo",undo:!1,forcedRefresh:!0,disabled:!0},insertHR:{title:"Insert Horizontal Line"},clearFormatting:{title:"Clear Formatting"},selectAll:{title:"Select All",undo:!1}},a.FE.RegisterCommand=function(b,c){a.FE.COMMANDS[b]=c},a.FE.MODULES.commands=function(b){function c(a){return b.html.defaultTag()&&(a="<"+b.html.defaultTag()+">"+a+"</"+b.html.defaultTag()+">"),a}function d(c,d){if(!1!==b.events.trigger("commands.before",a.merge([c],d||[]))){var e=a.FE.COMMANDS[c]&&a.FE.COMMANDS[c].callback||i[c],f=!0,g=!1;a.FE.COMMANDS[c]&&(void 0!==a.FE.COMMANDS[c].focus&&(f=a.FE.COMMANDS[c].focus),void 0!==a.FE.COMMANDS[c].accessibilityFocus&&(g=a.FE.COMMANDS[c].accessibilityFocus)),(!b.core.hasFocus()&&f&&!b.popups.areVisible()||!b.core.hasFocus()&&g&&b.accessibility.hasFocus())&&b.events.focus(!0),a.FE.COMMANDS[c]&&!1!==a.FE.COMMANDS[c].undo&&(b.$el.find(".fr-marker").length&&(b.events.disableBlur(),b.selection.restore()),b.undo.saveStep()),e&&e.apply(b,a.merge([c],d||[])),b.events.trigger("commands.after",a.merge([c],d||[])),a.FE.COMMANDS[c]&&!1!==a.FE.COMMANDS[c].undo&&b.undo.saveStep()}}function e(a,c){b.format.toggle(c)}function f(c){b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();for(var d=b.selection.blocks(),e=0;e<d.length;e++)if("LI"!=d[e].tagName&&"LI"!=d[e].parentNode.tagName){var f=a(d[e]),g="rtl"==b.opts.direction||"rtl"==f.css("direction")?"margin-right":"margin-left",h=b.helpers.getPX(f.css(g));f.css(g,Math.max(h+c*b.opts.indentMargin,0)||""),f.removeClass("fr-temp-div")}b.selection.save(),b.html.unwrap(),b.selection.restore()}function g(a){return function(){d(a)}}function h(){b.events.on("keydown",function(a){var c=b.selection.element();if(c&&"HR"==c.tagName&&!b.keys.isArrow(a.which))return a.preventDefault(),!1}),b.events.on("keyup",function(c){var d=b.selection.element();if(d&&"HR"==d.tagName)if(c.which==a.FE.KEYCODE.ARROW_LEFT||c.which==a.FE.KEYCODE.ARROW_UP){if(d.previousSibling)return b.node.isBlock(d.previousSibling)?b.selection.setAtEnd(d.previousSibling):a(d).before(a.FE.MARKERS),b.selection.restore(),!1}else if((c.which==a.FE.KEYCODE.ARROW_RIGHT||c.which==a.FE.KEYCODE.ARROW_DOWN)&&d.nextSibling)return b.node.isBlock(d.nextSibling)?b.selection.setAtStart(d.nextSibling):a(d).after(a.FE.MARKERS),b.selection.restore(),!1}),b.events.on("mousedown",function(a){if(a.target&&"HR"==a.target.tagName)return a.preventDefault(),a.stopPropagation(),!1}),b.events.on("mouseup",function(){var c=b.selection.element();c==b.selection.endElement()&&c&&"HR"==c.tagName&&(c.nextSibling&&(b.node.isBlock(c.nextSibling)?b.selection.setAtStart(c.nextSibling):a(c).after(a.FE.MARKERS)),b.selection.restore())})}var i={bold:function(){e("bold","strong")},subscript:function(){b.format.is("sup")&&b.format.remove("sup"),e("subscript","sub")},superscript:function(){b.format.is("sub")&&b.format.remove("sub"),e("superscript","sup")},italic:function(){e("italic","em")},strikeThrough:function(){e("strikeThrough","s")},underline:function(){e("underline","u")},undo:function(){b.undo.run()},redo:function(){b.undo.redo()},indent:function(){f(1)},outdent:function(){f(-1)},show:function(){b.opts.toolbarInline&&b.toolbar.showInline(null,!0)},insertHR:function(){b.selection.remove();var d="";b.core.isEmpty()&&(d="<br>",d=c(d)),b.html.insert('<hr id="fr-just">'+d);var e=b.$el.find("hr#fr-just");e.removeAttr("id");var f;if(0===e.next().length){var g=b.html.defaultTag();g?e.after(a("<"+g+">").append("<br>")):e.after("<br>")}e.prev().is("hr")?f=b.selection.setAfter(e.get(0),!1):e.next().is("hr")?f=b.selection.setBefore(e.get(0),!1):b.selection.setAfter(e.get(0),!1)||b.selection.setBefore(e.get(0),!1),f||void 0===f||(d=a.FE.MARKERS+"<br>",d=c(d),e.after(d)),b.selection.restore()},clearFormatting:function(){b.format.remove()},selectAll:function(){b.doc.execCommand("selectAll",!1,!1)}},j={};for(var k in i)i.hasOwnProperty(k)&&(j[k]=g(k));return a.extend(j,{exec:d,_init:h})},a.FE.MODULES.data=function(a){function b(a){return a}function c(a){if(!a)return a;for(var c="",f=b("charCodeAt"),g=b("fromCharCode"),h=l.indexOf(a[0]),i=1;i<a.length-2;i++){for(var j=d(++h),k=a[f](i),m="";/[0-9-]/.test(a[i+1]);)m+=a[++i];m=parseInt(m,10)||0,k=e(k,j,m),k^=h-1&31,c+=String[g](k)}return c}function d(a){for(var b=a.toString(),c=0,d=0;d<b.length;d++)c+=parseInt(b.charAt(d),10);return c>10?c%9+1:c}function e(a,b,c){for(var d=Math.abs(c);d-- >0;)a-=b;return c<0&&(a+=123),a}function f(a){return!(!a||"block"===a.css("display")||(a.remove(),0))}function g(){return f(j)||f(k)}function h(){if(o>10&&a.destroy(),!a.$box)return!1;a.$wp.prepend(n(b(n("NCKB1zwtPA9tqzajXC2c2A7B-16VD3spzJ1C9C3D5oOF2OB1NB1LD7VA5QF4TE3gytXB2A4C-8VA2AC4E1D3GB2EB2KC3KD1MF1juuSB1A8C6yfbmd1B2a1A5qdsdB2tivbC3CB1KC1CH1eLA2sTF1B4I4H-7B-21UB6b1F5bzzzyAB4JC3MG2hjdKC1JE6C1E1cj1pD-16pUE5B4prra2B5ZB3D3C3pxj1EA6A3rnJA2C-7I-7JD9D1E1wYH1F3sTB5TA2G4H4ZA22qZA5BB3mjcvcCC3JB1xillavC-21VE6PC5SI4YC5C8mb1A3WC3BD2B5aoDA2qqAE3A5D-17fOD1D5RD4WC10tE6OAZC3nF-7b1C4A4D3qCF2fgmapcromlHA2QA6a1E1D3e1A6C2bie2F4iddnIA7B2mvnwcIB5OA1DB2OLQA3PB10WC7WC5d1E3uI-7b1D5D6b1E4D2arlAA4EA1F-11srxI-7MB1D7PF1E5B4adB-21YD5vrZH3D3xAC4E1A2GF2CF2J-7yNC2JE1MI2hH-7QB1C6B5B-9bA-7XB13a1B5VievwpKB4LA3NF-10H-9I-8hhaC-16nqPG4wsleTD5zqYF3h1G2B7B4yvGE2Pi1H-7C-21OE6B1uLD1kI4WC1E7C5g1D-8fue1C8C6c1D4D3Hpi1CC4kvGC2E1legallyXB4axVA11rsA4A-9nkdtlmzBA2GD3A13A6CB1dabE1lezrUE6RD5TB4A-7f1C8c1B5d1D4D3tyfCD5C2D2==")))),j=a.$wp.find("> div:first"),k=j.find("> a"),"rtl"==a.opts.direction&&j.css("left","auto").css("right",0).setAttribute("direction","rtl"),o++}function i(){var c=a.o_win.FEK;try{c=c||localStorage&&localStorage.FEK}catch(k){}c=c||a.opts.key||[""];var d=n(b("ziRA1E3B9pA5B-11D-11xg1A3ZB5D1D4B-11ED2EG2pdeoC1clIH4wB-22yQD5uF4YE3E3A9=="));"string"==typeof c&&(c=[c]),a.ul=!0;for(var e=0;e<c.length;e++){var f=n(c[e])||"";if(!(f!==n(b(n("mcVRDoB1BGILD7YFe1BTXBA7B6==")))&&f.indexOf(m,f.length-m.length)<0&&[n("9qqG-7amjlwq=="),n("KA3B3C2A6D1D5H5H1A3=="),n("QzbzvxyB2yA-9m=="),n("ji1kacwmgG5bc=="),n("naamngiA3dA-16xtE-11C-9B1H-8sc==")].indexOf(m)<0)){a.ul=!1;break}}var i=new Image;!0===a.ul&&(h(),i.src=b(n(d))+"u"),a.events.on("contentChanged",function(){!0===a.ul&&g()&&h()}),a.events.on("destroy",function(){j&&j.length&&j.remove()},!0)}var j,k,l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",m=function(){for(var a=0,b=document.domain,c=b.split("."),d="_gd"+(new Date).getTime();a<c.length-1&&-1==document.cookie.indexOf(d+"="+d);)b=c.slice(-1-++a).join("."),document.cookie=d+"="+d+";domain="+b+";";return document.cookie=d+"=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain="+b+";",(b||"").replace(/(^\.*)|(\.*$)/g,"")}(),n=b(c),o=0;return{_init:i}},a.extend(a.FE.DEFAULTS,{pastePlain:!1,pasteDeniedTags:["colgroup","col","meta"],pasteDeniedAttrs:["class","id","style"],pasteAllowedStyleProps:[],pasteAllowLocalImages:!1}),a.FE.MODULES.paste=function(b){function c(a,c){try{b.win.localStorage.setItem("fr-copied-html",a),b.win.localStorage.setItem("fr-copied-text",c)}catch(d){}}function d(d){var e=b.html.getSelected();c(e,a("<div>").html(e).text()),"cut"==d.type&&(b.undo.saveStep(),setTimeout(function(){b.selection.save(),b.html.wrap(),b.selection.restore(),b.events.focus(),b.undo.saveStep()},0))}function e(a){if(w)return!1;if(a.originalEvent&&(a=a.originalEvent),!1===b.events.trigger("paste.before",[a]))return a.preventDefault(),!1;if(r=b.$win.scrollTop(),a&&a.clipboardData&&a.clipboardData.getData){var c="",d=a.clipboardData.types;if(b.helpers.isArray(d))for(var e=0;e<d.length;e++)c+=d[e]+";";else c=d;if(/text\/rtf/.test(c)&&(t=a.clipboardData.getData("text/rtf")),/text\/html/.test(c)&&!b.browser.safari?s=a.clipboardData.getData("text/html"):/text\/rtf/.test(c)&&b.browser.safari?s=t:/text\/plain/.test(c)&&!b.browser.mozilla&&(s=b.html.escapeEntities(a.clipboardData.getData("text/plain")).replace(/\n/g,"<br>")),""!==s)return j(),a.preventDefault&&(a.stopPropagation(),a.preventDefault()),!1;s=null}return g(),!1}function f(c){if(c.originalEvent&&(c=c.originalEvent),c&&c.dataTransfer&&c.dataTransfer.getData){var d="",e=c.dataTransfer.types;if(b.helpers.isArray(e))for(var f=0;f<e.length;f++)d+=e[f]+";";else d=e;if(s="",/text\/rtf/.test(d)&&(t=c.dataTransfer.getData("text/rtf")),/text\/html/.test(d)?s=c.dataTransfer.getData("text/html"):/text\/rtf/.test(d)&&b.browser.safari?s=t:/text\/plain/.test(d)&&!this.browser.mozilla&&(s=b.html.escapeEntities(c.dataTransfer.getData("text/plain")).replace(/\n/g,"<br>")),""!==s){b.keys.forceUndo(),v=b.snapshot.get(),b.selection.remove();if(!1!==b.markers.insertAtPoint(c)){var g=b.el.querySelector(".fr-marker");return a(g).replaceWith(a.FE.MARKERS),j(),c.preventDefault&&(c.stopPropagation(),c.preventDefault()),!1}}else s=null}}function g(){b.selection.save(),b.events.disableBlur(),s=null,u?(u.html(""),b.browser.edge&&b.opts.iframe&&b.$el.append(u)):(u=a('<div contenteditable="true" style="position: fixed; top: 0; left: -9999px; height: 100%; width: 0; word-break: break-all; overflow:hidden; z-index: 2147483647; line-height: 140%;" tabIndex="-1"></div>'),b.browser.safari?(u.css("top",b.$sc.scrollTop()),b.$el.after(u)):b.browser.edge&&b.opts.iframe?b.$el.append(u):b.$box.after(u),b.events.on("destroy",function(){u.remove()})),u.focus(),b.win.setTimeout(j,1)}function h(a){var c;a=a.replace(/<p(.*?)class="?'?MsoListParagraph"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<ul><li>$3</li></ul>"),a=a.replace(/<p(.*?)class="?'?NumberedText"?'? ([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<ol><li>$3</li></ol>"),a=a.replace(/<p(.*?)class="?'?MsoListParagraphCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<ul><li$3>$5</li>"),a=a.replace(/<p(.*?)class="?'?NumberedTextCxSpFirst"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<ol><li$3>$5</li>"),a=a.replace(/<p(.*?)class="?'?MsoListParagraphCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li>"),a=a.replace(/<p(.*?)class="?'?NumberedTextCxSpMiddle"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li>"),a=a.replace(/<p(.*?)class="?'?MsoListBullet"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li>"),a=a.replace(/<p(.*?)class="?'?MsoListParagraphCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li></ul>"),a=a.replace(/<p(.*?)class="?'?NumberedTextCxSpLast"?'?([\s\S]*?)(level\d)?([\s\S]*?)>([\s\S]*?)<\/p>/gi,"<li$3>$5</li></ol>"),a=a.replace(/<span([^<]*?)style="?'?mso-list:Ignore"?'?([\s\S]*?)>([\s\S]*?)<span/gi,"<span><span"),a=a.replace(/<!--\[if \!supportLists\]-->([\s\S]*?)<!--\[endif\]-->/gi,""),a=a.replace(/<!\[if \!supportLists\]>([\s\S]*?)<!\[endif\]>/gi,""),a=a.replace(/(\n|\r| class=(")?Mso[a-zA-Z0-9]+(")?)/gi," "),a=a.replace(/<!--[\s\S]*?-->/gi,""),a=a.replace(/<(\/)*(meta|link|span|\\?xml:|st1:|o:|font)(.*?)>/gi,"");var d=["style","script","applet","embed","noframes","noscript"];for(c=0;c<d.length;c++){var e=new RegExp("<"+d[c]+".*?"+d[c]+"(.*?)>","gi");a=a.replace(e,"")}a=a.replace(/&nbsp;/gi," "),a=a.replace(/<td([^>]*)><\/td>/g,"<td$1><br></td>"),a=a.replace(/<th([^>]*)><\/th>/g,"<th$1><br></th>");var f;do{f=a,a=a.replace(/<[^\/>][^>]*><\/[^>]+>/gi,"")}while(a!=f);a=a.replace(/<lilevel([^1])([^>]*)>/gi,'<li data-indent="true"$2>'),a=a.replace(/<lilevel1([^>]*)>/gi,"<li$1>"),a=b.clean.html(a,b.opts.pasteDeniedTags,b.opts.pasteDeniedAttrs),a=a.replace(/<a>(.[^<]+)<\/a>/gi,"$1"),a=a.replace(/<br> */g,"<br>");var g=b.o_doc.createElement("div");g.innerHTML=a;var h=g.querySelectorAll("li[data-indent]");for(c=0;c<h.length;c++){var i=h[c],j=i.previousElementSibling;if(j&&"LI"==j.tagName){var k=j.querySelector(":scope > ul, :scope > ol");k||(k=document.createElement("ul"),j.appendChild(k)),k.appendChild(i)}else i.removeAttribute("data-indent")}return b.html.cleanBlankSpaces(g),a=g.innerHTML}function i(a){var c,d=null,e=b.doc.createElement("div");e.innerHTML=a;var f=e.querySelectorAll("p, div, h1, h2, h3, h4, h5, h6, pre, blockquote");for(c=0;c<f.length;c++)d=f[c],d.outerHTML="<"+(b.html.defaultTag()||"DIV")+">"+d.innerHTML+"</"+(b.html.defaultTag()||"DIV")+">";for(f=e.querySelectorAll("*:not("+"p, div, h1, h2, h3, h4, h5, h6, pre, blockquote, ul, ol, li, table, tbody, thead, tr, td, br, img".split(",").join("):not(")+")"),c=f.length-1;c>=0;c--)d=f[c],d.outerHTML=d.innerHTML;var g=function(a){for(var c=b.node.contents(a),d=0;d<c.length;d++)c[d].nodeType!=Node.TEXT_NODE&&c[d].nodeType!=Node.ELEMENT_NODE?c[d].parentNode.removeChild(c[d]):g(c[d])};return g(e),e.innerHTML}function j(){b.browser.edge&&b.opts.iframe&&b.$box.after(u),v||(b.keys.forceUndo(),v=b.snapshot.get()),null===s&&(s=u.get(0).innerHTML,b.selection.restore(),b.events.enableBlur());var a=s.match(/(class=\"?Mso|class=\'?Mso|class="?Xl|class='?Xl|class=Xl|style=\"[^\"]*\bmso\-|style=\'[^\']*\bmso\-|w:WordDocument)/gi),c=b.events.chainTrigger("paste.beforeCleanup",s);c&&"string"==typeof c&&(s=c),(!a||a&&!1!==b.events.trigger("paste.wordPaste",[s]))&&l(s,a)}function k(c){var d=null;try{d=b.win.localStorage.getItem("fr-copied-text")}catch(e){}return!(!d||a("<div>").html(c).text().replace(/\u00A0/gi," ").replace(/\r|\n/gi,"")!=d.replace(/\u00A0/gi," ").replace(/\r|\n/gi,""))}function l(c,d,e){var f,g=null,j=null;c.toLowerCase().indexOf("<body")>=0&&(c=c.replace(/[.\s\S\w\W<>]*<body[^>]*>[\s]*([.\s\S\w\W<>]*)[\s]*<\/body>[.\s\S\w\W<>]*/gi,"$1"),c=c.replace(/ \n/g," ").replace(/\n /g," ").replace(/([^>])\n([^<])/g,"$1 $2"));var l=!1;if(c.indexOf('id="docs-internal-guid')>=0&&(c=c.replace(/^[\w\W\s\S]* id="docs-internal-guid[^>]*>([\w\W\s\S]*)<\/b>[\w\W\s\S]*$/g,"$1"),l=!0),!d){var n=k(c);if(n&&(c=b.win.localStorage.getItem("fr-copied-html")),!n){var p=b.opts.htmlAllowedStyleProps;b.opts.htmlAllowedStyleProps=b.opts.pasteAllowedStyleProps,b.opts.htmlAllowComments=!1,c=b.clean.html(c,b.opts.pasteDeniedTags,b.opts.pasteDeniedAttrs),b.opts.htmlAllowedStyleProps=p,b.opts.htmlAllowComments=!0,c=o(c),c=c.replace(/\r|\n|\t/g,""),c=c.replace(/^ */g,"").replace(/ *$/g,"")}}!d||b.wordPaste&&e||(c=c.replace(/^\n*/g,"").replace(/^ /g,""),0===c.indexOf("<colgroup>")&&(c="<table>"+c+"</table>"),c=h(c),c=o(c)),b.opts.pastePlain&&(c=i(c));var q=b.events.chainTrigger("paste.afterCleanup",c);if("string"==typeof q&&(c=q),""!==c){var r=b.o_doc.createElement("div");r.innerHTML=c,b.spaces.normalize(r);var s=r.getElementsByTagName("span");for(f=s.length-1;f>=0;f--){var t=s[f];0===t.attributes.length&&(t.outerHTML=t.innerHTML)}var u=b.selection.element(),w=!1;if(u&&a(u).parentsUntil(b.el,"ul, ol").length&&(w=!0),w){var x=r.children;1==x.length&&["OL","UL"].indexOf(x[0].tagName)>=0&&(x[0].outerHTML=x[0].innerHTML)}if(!l){var y=r.getElementsByTagName("br");for(f=y.length-1;f>=0;f--){var z=y[f];b.node.isBlock(z.previousSibling)&&z.parentNode.removeChild(z)}}if(b.opts.enter==a.FE.ENTER_BR)for(g=r.querySelectorAll("p, div"),f=g.length-1;f>=0;f--)j=g[f],0===j.attributes.length&&(j.outerHTML=j.innerHTML+(j.nextSibling&&!b.node.isEmpty(j)?"<br>":""));else if(b.opts.enter==a.FE.ENTER_DIV)for(g=r.getElementsByTagName("p"),f=g.length-1;f>=0;f--)j=g[f],j.outerHTML="<div>"+j.innerHTML+"</div>";else b.opts.enter==a.FE.ENTER_P&&1==r.childNodes.length&&"P"==r.childNodes[0].tagName&&(r.childNodes[0].outerHTML=r.childNodes[0].innerHTML);c=r.innerHTML,b.html.insert(c,!0)}m(),b.undo.saveStep(v),v=null,b.undo.saveStep()}function m(){b.events.trigger("paste.after")}function n(){return t}function o(c){var d,e=b.o_doc.createElement("div");e.innerHTML=c;for(var f=e.querySelectorAll("*:empty:not(td):not(th):not(iframe):not(svg):not("+a.FE.VOID_ELEMENTS.join("):not(")+")");f.length;){for(d=0;d<f.length;d++)f[d].parentNode.removeChild(f[d]);f=e.querySelectorAll("*:empty:not(td):not(th):not(iframe):not(svg):not("+a.FE.VOID_ELEMENTS.join("):not(")+")")}for(var g=e.querySelectorAll(":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])");g.length;){var h=g[g.length-1];if(b.html.defaultTag()&&"div"!=b.html.defaultTag())h.querySelector(b.html.blockTagsQuery())?h.outerHTML=h.innerHTML:h.outerHTML="<"+b.html.defaultTag()+">"+h.innerHTML+"</"+b.html.defaultTag()+">";else{var i=h.querySelectorAll("*");!i.length||"BR"!==i[i.length-1].tagName&&0===h.innerText.length?h.outerHTML=h.innerHTML+"<br>":h.outerHTML=h.innerHTML}g=e.querySelectorAll(":scope > div:not([style]), td > div:not([style]), th > div:not([style]), li > div:not([style])")}for(g=e.querySelectorAll("div:not([style])");g.length;){for(d=0;d<g.length;d++){var j=g[d],k=j.innerHTML.replace(/\u0009/gi,"").trim();j.outerHTML=k}g=e.querySelectorAll("div:not([style])")}return e.innerHTML}function p(){b.el.addEventListener("copy",d),b.el.addEventListener("cut",d),b.el.addEventListener("paste",e,{capture:!0}),b.events.on("drop",f),b.browser.msie&&b.browser.version<11&&(b.events.on("mouseup",function(a){2==a.button&&(setTimeout(function(){w=!1},50),w=!0)},!0),b.events.on("beforepaste",e)),b.events.on("destroy",q)}function q(){b.el.removeEventListener("copy",d),b.el.removeEventListener("cut",d),b.el.removeEventListener("paste",e)}var r,s,t,u,v,w=!1;return{_init:p,removeEmptyTags:o,getRtfClipboard:n,saveCopiedText:c,clean:l}},a.extend(a.FE.DEFAULTS,{shortcutsEnabled:[],shortcutsHint:!0}),a.FE.SHORTCUTS_MAP={},a.FE.RegisterShortcut=function(b,c,d,e,f,g){a.FE.SHORTCUTS_MAP[(f?"^":"")+(g?"@":"")+b]={cmd:c,val:d,letter:e,shift:f,option:g},a.FE.DEFAULTS.shortcutsEnabled.push(c)},a.FE.RegisterShortcut(a.FE.KEYCODE.E,"show",null,"E",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.B,"bold",null,"B",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.I,"italic",null,"I",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.U,"underline",null,"U",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.S,"strikeThrough",null,"S",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.CLOSE_SQUARE_BRACKET,"indent",null,"]",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.OPEN_SQUARE_BRACKET,"outdent",null,"[",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.Z,"undo",null,"Z",!1,!1),a.FE.RegisterShortcut(a.FE.KEYCODE.Z,"redo",null,"Z",!0,!1),a.FE.MODULES.shortcuts=function(b){function c(c){if(!b.opts.shortcutsHint)return null;if(!f){f={};for(var d in a.FE.SHORTCUTS_MAP)a.FE.SHORTCUTS_MAP.hasOwnProperty(d)&&b.opts.shortcutsEnabled.indexOf(a.FE.SHORTCUTS_MAP[d].cmd)>=0&&(f[a.FE.SHORTCUTS_MAP[d].cmd+"."+(a.FE.SHORTCUTS_MAP[d].val||"")]={shift:a.FE.SHORTCUTS_MAP[d].shift,option:a.FE.SHORTCUTS_MAP[d].option,letter:a.FE.SHORTCUTS_MAP[d].letter})}var e=f[c];return e?(b.helpers.isMac()?String.fromCharCode(8984):"Ctrl+")+(e.shift?b.helpers.isMac()?String.fromCharCode(8679):"Shift+":"")+(e.option?b.helpers.isMac()?String.fromCharCode(8997):"Alt+":"")+e.letter:null}function d(c){if(!b.core.hasFocus())return!0;var d=c.which,e=-1!=navigator.userAgent.indexOf("Mac OS X")?c.metaKey:c.ctrlKey;if("keyup"==c.type&&g&&d!=a.FE.KEYCODE.META)return g=!1,!1;"keydown"==c.type&&(g=!1);var f=(c.shiftKey?"^":"")+(c.altKey?"@":"")+d;if(e&&a.FE.SHORTCUTS_MAP[f]){var h=a.FE.SHORTCUTS_MAP[f].cmd;if(h&&b.opts.shortcutsEnabled.indexOf(h)>=0){var i,j=a.FE.SHORTCUTS_MAP[f].val;if(h&&!j?i=b.$tb.find('.fr-command[data-cmd="'+h+'"]'):h&&j&&(i=b.$tb.find('.fr-command[data-cmd="'+h+'"][data-param1="'+j+'"]')),i.length)return c.preventDefault(),c.stopPropagation(),i.parents(".fr-toolbar").data("instance",b),"keydown"==c.type&&(b.button.exec(i),g=!0),!1;if(h&&b.commands[h])return c.preventDefault(),c.stopPropagation(),"keydown"==c.type&&(b.commands[h](),g=!0),!1}}}function e(){b.events.on("keydown",d,!0),b.events.on("keyup",d,!0)}var f=null,g=!1;return{_init:e,get:c}},a.FE.MODULES.snapshot=function(a){function b(a){for(var b=a.parentNode.childNodes,c=0,d=null,e=0;e<b.length;e++){if(d){var f=b[e].nodeType===Node.TEXT_NODE&&""===b[e].textContent,g=d.nodeType===Node.TEXT_NODE&&b[e].nodeType===Node.TEXT_NODE;f||g||c++}if(b[e]==a)return c;d=b[e]}}function c(c){var d=[];if(!c.parentNode)return[];for(;!a.node.isElement(c);)d.push(b(c)),c=c.parentNode;return d.reverse()}function d(a,b){for(;a&&a.nodeType===Node.TEXT_NODE;){var c=a.previousSibling;c&&c.nodeType==Node.TEXT_NODE&&(b+=c.textContent.length),a=c}return b}function e(a){return{scLoc:c(a.startContainer),scOffset:d(a.startContainer,a.startOffset),ecLoc:c(a.endContainer),ecOffset:d(a.endContainer,a.endOffset)}}function f(){var b={};if(a.events.trigger("snapshot.before"),b.html=(a.$wp?a.$el.html():a.$oel.get(0).outerHTML).replace(/ style=""/g,""),b.ranges=[],a.$wp&&a.selection.inEditor()&&a.core.hasFocus())for(var c=a.selection.ranges(),d=0;d<c.length;d++)b.ranges.push(e(c[d]));return a.events.trigger("snapshot.after",[b]),b}function g(b){for(var c=a.el,d=0;d<b.length;d++)c=c.childNodes[b[d]];return c}function h(b,c){try{var d=g(c.scLoc),e=c.scOffset,f=g(c.ecLoc),h=c.ecOffset,i=a.doc.createRange();i.setStart(d,e),i.setEnd(f,h),b.addRange(i)}catch(j){}}function i(b){a.$el.html()!=b.html&&(a.opts.htmlExecuteScripts?a.$el.html(b.html):a.el.innerHTML=b.html);var c=a.selection.get();a.selection.clear(),a.events.focus(!0);for(var d=0;d<b.ranges.length;d++)h(c,b.ranges[d])}function j(b,c){return b.html==c.html&&(!a.core.hasFocus()||JSON.stringify(b.ranges)==JSON.stringify(c.ranges))}return{get:f,restore:i,equal:j}},a.FE.MODULES.undo=function(a){function b(b){var c=b.which;a.keys.ctrlKey(b)&&(90==c&&b.shiftKey&&b.preventDefault(),90==c&&b.preventDefault())}function c(){return!(0===a.undo_stack.length||a.undo_index<=1)}function d(){return a.undo_index!=a.undo_stack.length}function e(b){if(!a.undo_stack||a.undoing||a.el.querySelector(".fr-marker"))return!1;void 0===b?(b=a.snapshot.get(),a.undo_stack[a.undo_index-1]&&a.snapshot.equal(a.undo_stack[a.undo_index-1],b)||(f(),a.undo_stack.push(b),a.undo_index++,b.html!=l&&(a.events.trigger("contentChanged"),l=b.html))):(f(),a.undo_index>0?a.undo_stack[a.undo_index-1]=b:(a.undo_stack.push(b),a.undo_index++))}function f(){if(!a.undo_stack||a.undoing)return!1;for(;a.undo_stack.length>a.undo_index;)a.undo_stack.pop()}function g(){if(a.undo_index>1){a.undoing=!0;var b=a.undo_stack[--a.undo_index-1];clearTimeout(a._content_changed_timer),a.snapshot.restore(b),l=b.html,a.popups.hideAll(),a.toolbar.enable(),a.events.trigger("contentChanged"),a.events.trigger("commands.undo"),a.undoing=!1}}function h(){if(a.undo_index<a.undo_stack.length){a.undoing=!0;var b=a.undo_stack[a.undo_index++];clearTimeout(a._content_changed_timer),a.snapshot.restore(b),l=b.html,a.popups.hideAll(),a.toolbar.enable(),a.events.trigger("contentChanged"),a.events.trigger("commands.redo"),a.undoing=!1}}function i(){a.undo_index=0,a.undo_stack=[]}function j(){a.undo_stack=[]}function k(){i(),a.events.on("initialized",function(){l=(a.$wp?a.$el.html():a.$oel.get(0).outerHTML).replace(/ style=""/g,"")}),a.events.on("blur",function(){a.el.querySelector(".fr-dragging")||a.undo.saveStep()}),a.events.on("keydown",b),a.events.on("destroy",j)}var l=null;return{_init:k,run:g,redo:h,canDo:c,canRedo:d,dropRedo:f,reset:i,saveStep:e}},a.FE.ICON_DEFAULT_TEMPLATE="font_awesome",a.FE.ICON_TEMPLATES={font_awesome:'<i class="fa fa-[NAME]" aria-hidden="true"></i>',text:'<span style="text-align: center;">[NAME]</span>',image:"<img src=[SRC] alt=[ALT] />",svg:'<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">[PATH]</svg>'},a.FE.ICONS={bold:{NAME:"bold"},italic:{NAME:"italic"},underline:{NAME:"underline"},strikeThrough:{NAME:"strikethrough"},subscript:{NAME:"subscript"},superscript:{NAME:"superscript"},color:{NAME:"tint"},outdent:{NAME:"outdent"},indent:{NAME:"indent"},undo:{NAME:"rotate-left"},redo:{NAME:"rotate-right"},insertHR:{NAME:"minus"},clearFormatting:{NAME:"eraser"},selectAll:{NAME:"mouse-pointer"}},a.FE.DefineIconTemplate=function(b,c){a.FE.ICON_TEMPLATES[b]=c},a.FE.DefineIcon=function(b,c){a.FE.ICONS[b]=c},a.FE.MODULES.icon=function(){function b(b){var c=null,d=a.FE.ICONS[b];if(void 0!==d){var e=d.template||a.FE.ICON_DEFAULT_TEMPLATE;e&&(e=a.FE.ICON_TEMPLATES[e])&&(c=e.replace(/\[([a-zA-Z]*)\]/g,function(a,c){return"NAME"==c?d[c]||b:d[c]}))}return c||b}function c(b){var c=a.FE.ICONS[b],d=a.FE.ICON_DEFAULT_TEMPLATE;return void 0!==c?d=c.template||a.FE.ICON_DEFAULT_TEMPLATE:d}return{create:b,getTemplate:c}},a.extend(a.FE.DEFAULTS,{tooltips:!0}),a.FE.MODULES.tooltip=function(b){function c(){if(b.helpers.isMobile())return!1;b.$tooltip&&b.$tooltip.removeClass("fr-visible").css("left","-3000px").css("position","fixed")}function d(c,d){if(b.helpers.isMobile())return!1;if(c.data("title")||c.data("title",c.attr("title")),!c.data("title"))return!1;b.$tooltip||f(),c.removeAttr("title"),b.$tooltip.text(b.language.translate(c.data("title"))),b.$tooltip.addClass("fr-visible");var e=c.offset().left+(c.outerWidth()-b.$tooltip.outerWidth())/2;e<0&&(e=0),e+b.$tooltip.outerWidth()>a(b.o_win).width()&&(e=a(b.o_win).width()-b.$tooltip.outerWidth()),void 0===d&&(d=b.opts.toolbarBottom);var g=d?c.offset().top-b.$tooltip.height():c.offset().top+c.outerHeight();b.$tooltip.css("position",""),b.$tooltip.css("left",e),b.$tooltip.css("top",Math.ceil(g)),"static"!=a(b.o_doc).find("body:first").css("position")?(b.$tooltip.css("margin-left",-a(b.o_doc).find("body:first").offset().left),b.$tooltip.css("margin-top",-a(b.o_doc).find("body:first").offset().top)):(b.$tooltip.css("margin-left",""),b.$tooltip.css("margin-top",""))}function e(e,f,g){b.opts.tooltips&&!b.helpers.isMobile()&&(b.events.$on(e,"mouseenter",f,function(c){b.node.hasClass(c.currentTarget,"fr-disabled")||b.edit.isDisabled()||d(a(c.currentTarget),g)},!0),b.events.$on(e,"mouseleave "+b._mousedown+" "+b._mouseup,f,function(){c()},!0))}function f(){b.opts.tooltips&&!b.helpers.isMobile()&&(b.shared.$tooltip?b.$tooltip=b.shared.$tooltip:(b.shared.$tooltip=a('<div class="fr-tooltip"></div>'),b.$tooltip=b.shared.$tooltip,b.opts.theme&&b.$tooltip.addClass(b.opts.theme+"-theme"),a(b.o_doc).find("body:first").append(b.$tooltip)),b.events.on("shared.destroy",function(){b.$tooltip.html("").removeData().remove(),b.$tooltip=null},!0))}return{hide:c,to:d,bind:e}},a.FE.MODULES.button=function(b){function c(b,c,d){for(var e=a(),f=0;f<b.length;f++){var g=a(b[f]);if(g.is(c)&&(e=e.add(g)),d&&g.is(".fr-dropdown")){var h=g.next().find(c);e=e.add(h)}}return e}function d(d,e){var f,g=a();if(!d)return g;g=g.add(c(w,d,e)),g=g.add(c(x,d,e));for(f in b.shared.popups)if(b.shared.popups.hasOwnProperty(f)){var h=b.shared.popups[f],i=h.children().find(d);g=g.add(i)}for(f in b.shared.modals)if(b.shared.modals.hasOwnProperty(f)){var j=b.shared.modals[f],k=j.$modal.find(d);g=g.add(k)}return g}function e(c){var e=c.next(),f=b.node.hasClass(c.get(0),"fr-active"),g=d(".fr-dropdown.fr-active").not(c),h=c.parents(".fr-toolbar, .fr-popup").data("instance")||b;if(h.helpers.isIOS()&&!h.el.querySelector(".fr-marker")&&(h.selection.save(),h.selection.clear(),h.selection.restore()),!f){var i=c.data("cmd");e.find(".fr-command").removeClass("fr-active").attr("aria-selected",!1),a.FE.COMMANDS[i]&&a.FE.COMMANDS[i].refreshOnShow&&a.FE.COMMANDS[i].refreshOnShow.apply(h,[c,e]),e.css("left",c.offset().left-c.parent().offset().left-("rtl"==b.opts.direction?e.width()-c.outerWidth():0)),e.addClass("test-height");var j=e.outerHeight();e.removeClass("test-height"),e.css("top","").css("bottom",""),!b.opts.toolbarBottom&&e.offset().top+c.outerHeight()+j<a(b.o_doc).height()?e.css("top",c.position().top+c.outerHeight()):e.css("bottom",c.parents(".fr-popup, .fr-toolbar").first().height()-c.position().top)}c.addClass("fr-blink").toggleClass("fr-active"),c.hasClass("fr-active")?(e.attr("aria-hidden",!1),c.attr("aria-expanded",!0)):(e.attr("aria-hidden",!0),c.attr("aria-expanded",!1)),setTimeout(function(){c.removeClass("fr-blink")},300),e.css("margin-left",""),e.offset().left+e.outerWidth()>b.$sc.offset().left+b.$sc.width()&&e.css("margin-left",-(e.offset().left+e.outerWidth()-b.$sc.offset().left-b.$sc.width())),e.offset().left<b.$sc.offset().left&&"rtl"==b.opts.direction&&e.css("margin-left",e.offset().left+e.outerWidth()-b.$sc.offset().left),g.removeClass("fr-active").attr("aria-expanded",!1).next().attr("aria-hidden",!0),g.parent(".fr-toolbar:not(.fr-inline)").css("zIndex",""),0!==c.parents(".fr-popup").length||b.opts.toolbarInline||(b.node.hasClass(c.get(0),"fr-active")?b.$tb.css("zIndex",(b.opts.zIndex||1)+4):b.$tb.css("zIndex",""));var k=e.find("a.fr-command.fr-active:first");b.helpers.isMobile()||(k.length?b.accessibility.focusToolbarElement(k):b.accessibility.focusToolbarElement(c))}function f(a){a.addClass("fr-blink"),setTimeout(function(){a.removeClass("fr-blink")},500);for(var b=a.data("cmd"),c=[];void 0!==a.data("param"+(c.length+1));)c.push(a.data("param"+(c.length+1)));var e=d(".fr-dropdown.fr-active");e.length&&(e.removeClass("fr-active").attr("aria-expanded",!1).next().attr("aria-hidden",!0),e.parent(".fr-toolbar:not(.fr-inline)").css("zIndex","")),a.parents(".fr-popup, .fr-toolbar").data("instance").commands.exec(b,c)}function g(a){f(a)}function h(c){var d=c.parents(".fr-popup, .fr-toolbar").data("instance");if(0!==c.parents(".fr-popup").length||c.data("popup")||d.popups.hideAll(),d.popups.areVisible()&&!d.popups.areVisible(d)){for(var f=0;f<a.FE.INSTANCES.length;f++)a.FE.INSTANCES[f]!=d&&a.FE.INSTANCES[f].popups&&a.FE.INSTANCES[f].popups.areVisible()&&a.FE.INSTANCES[f].$el.find(".fr-marker").remove();d.popups.hideAll()}b.node.hasClass(c.get(0),"fr-dropdown")?e(c):(g(c),a.FE.COMMANDS[c.data("cmd")]&&!1!==a.FE.COMMANDS[c.data("cmd")].refreshAfterCallback&&d.button.bulkRefresh())}function i(b){h(a(b.currentTarget))}function j(a){var b=a.find(".fr-dropdown.fr-active");b.length&&(b.removeClass("fr-active").attr("aria-expanded",!1).next().attr("aria-hidden",!0),b.parent(".fr-toolbar:not(.fr-inline)").css("zIndex",""))}function k(a){a.preventDefault(),a.stopPropagation()}function l(a){if(a.stopPropagation(),!b.helpers.isMobile())return!1}function m(c,d){b.events.bindClick(c,".fr-command:not(.fr-disabled)",i),b.events.$on(c,b._mousedown+" "+b._mouseup+" "+b._move,".fr-dropdown-menu",k,!0),b.events.$on(c,b._mousedown+" "+b._mouseup+" "+b._move,".fr-dropdown-menu .fr-dropdown-wrapper",l,!0);var e=c.get(0).ownerDocument,f="defaultView"in e?e.defaultView:e.parentWindow,g=function(d){(!d||d.type==b._mouseup&&d.target!=a("html").get(0)||"keydown"==d.type&&(b.keys.isCharacter(d.which)&&!b.keys.ctrlKey(d)||d.which==a.FE.KEYCODE.ESC))&&j(c)};b.events.$on(a(f),b._mouseup+" resize keydown",g,!0),b.opts.iframe&&b.events.$on(b.$win,b._mouseup,g,!0),
b.node.hasClass(c.get(0),"fr-popup")?a.merge(x,c.find(".fr-btn").toArray()):a.merge(w,c.find(".fr-btn").toArray()),b.tooltip.bind(c,".fr-btn, .fr-title",d)}function n(a,c){var d="";if(c.html)"function"==typeof c.html?d+=c.html.call(b):d+=c.html;else{var e=c.options;"function"==typeof e&&(e=e()),d+='<ul class="fr-dropdown-list" role="presentation">';for(var f in e)if(e.hasOwnProperty(f)){var g=b.shortcuts.get(a+"."+f);g=g?'<span class="fr-shortcut">'+g+"</span>":"",d+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="'+a+'" data-param1="'+f+'" title="'+e[f]+'">'+b.language.translate(e[f])+"</a></li>"}d+="</ul>"}return d}function o(a,c,d){if(b.helpers.isMobile()&&!1===c.showOnMobile)return"";var e=c.displaySelection;"function"==typeof e&&(e=e(b));var f;if(e){var g="function"==typeof c.defaultSelection?c.defaultSelection(b):c.defaultSelection;f='<span style="width:'+(c.displaySelectionWidth||100)+'px">'+b.language.translate(g||c.title)+"</span>"}else f=b.icon.create(c.icon||a),f+='<span class="fr-sr-only">'+(b.language.translate(c.title)||"")+"</span>";var h=c.popup?' data-popup="true"':"",i=c.modal?' data-modal="true"':"",j=b.shortcuts.get(a+".");j=j?" ("+j+")":"";var k=a+"-"+b.id,l="dropdown-menu-"+k,m='<button id="'+k+'"type="button" tabIndex="-1" role="button"'+(c.toggle?' aria-pressed="false"':"")+("dropdown"==c.type?' aria-controls="'+l+'" aria-expanded="false" aria-haspopup="true"':"")+(c.disabled?' aria-disabled="true"':"")+' title="'+(b.language.translate(c.title)||"")+j+'" class="fr-command fr-btn'+("dropdown"==c.type?" fr-dropdown":"")+" fr-btn-"+b.icon.getTemplate(c.icon)+(c.displaySelection?" fr-selection":"")+(c.back?" fr-back":"")+(c.disabled?" fr-disabled":"")+(d?"":" fr-hidden")+'" data-cmd="'+a+'"'+h+i+">"+f+"</button>";if("dropdown"==c.type){var o='<div id="'+l+'" class="fr-dropdown-menu" role="listbox" aria-labelledby="'+k+'" aria-hidden="true"><div class="fr-dropdown-wrapper" role="presentation"><div class="fr-dropdown-content" role="presentation">';o+=n(a,c),o+="</div></div></div>",m+=o}return m}function p(c,d){for(var e="",f=0;f<c.length;f++){var g=c[f],h=a.FE.COMMANDS[g];if(!(h&&void 0!==h.plugin&&b.opts.pluginsEnabled.indexOf(h.plugin)<0))if(h){var i=void 0===d||d.indexOf(g)>=0;e+=o(g,h,i)}else"|"==g?e+='<div class="fr-separator fr-vs" role="separator" aria-orientation="vertical"></div>':"-"==g&&(e+='<div class="fr-separator fr-hs" role="separator" aria-orientation="horizontal"></div>')}return e}function q(c){var d,e=c.parents(".fr-popup, .fr-toolbar").data("instance")||b,f=c.data("cmd");b.node.hasClass(c.get(0),"fr-dropdown")?d=c.next():(c.removeClass("fr-active"),c.attr("aria-pressed")&&c.attr("aria-pressed",!1)),a.FE.COMMANDS[f]&&a.FE.COMMANDS[f].refresh?a.FE.COMMANDS[f].refresh.apply(e,[c,d]):b.refresh[f]&&e.refresh[f](c,d)}function r(c){var d=b.$tb?b.$tb.data("instance")||b:b;if(!1===b.events.trigger("buttons.refresh"))return!0;setTimeout(function(){for(var e=d.selection.inEditor()&&d.core.hasFocus(),f=0;f<c.length;f++){var g=a(c[f]),h=g.data("cmd");0===g.parents(".fr-popup").length?e||a.FE.COMMANDS[h]&&a.FE.COMMANDS[h].forcedRefresh?d.button.refresh(g):b.node.hasClass(g.get(0),"fr-dropdown")||(g.removeClass("fr-active"),g.attr("aria-pressed")&&g.attr("aria-pressed",!1)):g.parents(".fr-popup").is(":visible")&&d.button.refresh(g)}},0)}function s(){r(w),r(x)}function t(){w=[],x=[]}function u(){clearTimeout(y),y=setTimeout(s,50)}function v(){b.opts.toolbarInline?b.events.on("toolbar.show",s):(b.events.on("mouseup",u),b.events.on("keyup",u),b.events.on("blur",u),b.events.on("focus",u),b.events.on("contentChanged",u),b.helpers.isMobile()&&b.events.$on(b.$doc,"selectionchange",s)),b.events.on("shared.destroy",t)}var w=[];(b.opts.toolbarInline||b.opts.toolbarContainer)&&(b.shared.buttons||(b.shared.buttons=[]),w=b.shared.buttons);var x=[];b.shared.popup_buttons||(b.shared.popup_buttons=[]),x=b.shared.popup_buttons;var y=null;return{_init:v,buildList:p,bindCommands:m,refresh:q,bulkRefresh:s,exec:f,click:h,hideActiveDropdowns:j,getButtons:d}},a.FE.MODULES.modals=function(b){function c(a){return n[a]}function d(c,d){var e='<div tabIndex="-1" class="fr-modal'+(b.opts.theme?" "+b.opts.theme+"-theme":"")+'"><div class="fr-modal-wrapper">';return e+='<div class="fr-modal-head">'+c+'<i title="'+b.language.translate("Cancel")+'" class="fa fa-times fr-modal-close"></i></div>',e+='<div tabIndex="-1" class="fr-modal-body">'+d+"</div>",e+="</div></div>",a(e)}function e(c,e,f){if(b.shared.$overlay||(b.shared.$overlay=a('<div class="fr-overlay">').appendTo("body:first")),m=b.shared.$overlay,b.opts.theme&&m.addClass(b.opts.theme+"-theme"),!n[c]){var g=d(e,f);n[c]={$modal:g,$head:g.find(".fr-modal-head"),$body:g.find(".fr-modal-body")},b.helpers.isMobile()||g.addClass("fr-desktop"),g.appendTo("body:first"),b.events.bindClick(g,"i.fr-modal-close",function(){h(c)}),n[c].$body.css("margin-top",n[c].$head.outerHeight()),b.events.$on(g,"keydown",function(d){var e=d.which;return e==a.FE.KEYCODE.ESC?(h(c),b.accessibility.focusModalButton(g),!1):!(!a(d.currentTarget).is("input[type=text], textarea")&&e!=a.FE.KEYCODE.ARROW_UP&&e!=a.FE.KEYCODE.ARROW_DOWN&&!b.keys.isBrowserAction(d))||(d.preventDefault(),d.stopPropagation(),!1)},!0),h(c,!0)}return n[c]}function f(){for(var a in n){var b=n[a];b&&b.$modal&&b.$modal.removeData().remove()}m&&m.removeData().remove(),n={}}function g(c){if(n[c]){var d=n[c].$modal;d.data("instance",b),d.show(),m.show(),a(b.o_doc).find("body:first").addClass("prevent-scroll"),b.helpers.isMobile()&&a(b.o_doc).find("body:first").addClass("fr-mobile"),d.addClass("fr-active"),b.accessibility.focusModal(d)}}function h(c,d){if(n[c]){var e=n[c].$modal,f=e.data("instance")||b;f.events.enableBlur(),e.hide(),m.hide(),a(f.o_doc).find("body:first").removeClass("prevent-scroll fr-mobile"),e.removeClass("fr-active"),d||(b.accessibility.restoreSelection(f),b.events.trigger("modals.hide"))}}function i(c){if(n[c]){var d=n[c],e=d.$modal,f=d.$body,g=a(b.o_win).height(),h=e.find(".fr-modal-wrapper"),i=h.outerHeight(!0),j=h.height()-(f.outerHeight(!0)-f.height()),k=g-i+j,l=f.get(0).scrollHeight,m="auto";l>k&&(m=k),f.height(m)}}function j(a){var c;if("string"==typeof a){if(!n[a])return;c=n[a].$modal}else c=a;return c&&b.node.hasClass(c,"fr-active")&&b.core.sameInstance(c)||!1}function k(a){for(var b in n)if(n.hasOwnProperty(b)&&j(b)&&(void 0===a||n[b].$modal.data("instance")==a))return n[b].$modal;return!1}function l(){b.events.on("shared.destroy",f,!0)}b.shared.modals||(b.shared.modals={});var m,n=b.shared.modals;return{_init:l,get:c,create:e,show:g,hide:h,resize:i,isVisible:j,areVisible:k}},a.FE.POPUP_TEMPLATES={"text.edit":"[_EDIT_]"},a.FE.RegisterTemplate=function(b,c){a.FE.POPUP_TEMPLATES[b]=c},a.FE.MODULES.popups=function(b){function c(a,c){c.is(":visible")||(c=b.$sc),c.is(x[a].data("container"))||(x[a].data("container",c),c.append(x[a]))}function d(a,d,e,h){if(f(a)||(g()&&b.$el.find(".fr-marker").length>0?(b.events.disableBlur(),b.selection.restore()):g()||(b.events.disableBlur(),b.events.focus(),b.events.enableBlur())),m([a]),!x[a])return!1;var i=b.button.getButtons(".fr-dropdown.fr-active");i.removeClass("fr-active").attr("aria-expanded",!1).parent(".fr-toolbar").css("zIndex",""),i.next().attr("aria-hidden",!0),x[a].data("instance",b),b.$tb&&b.$tb.data("instance",b);var j=x[a].outerWidth(),k=f(a);x[a].addClass("fr-active").removeClass("fr-hidden").find("input, textarea").removeAttr("disabled");var l=x[a].data("container");b.opts.toolbarInline&&l&&b.$tb&&l.get(0)==b.$tb.get(0)&&(c(a,b.$sc),e=b.$tb.offset().top-b.helpers.getPX(b.$tb.css("margin-top")),d=b.$tb.offset().left+b.$tb.outerWidth()/2+(parseFloat(b.$tb.find(".fr-arrow").css("margin-left"))||0)+b.$tb.find(".fr-arrow").outerWidth()/2,b.node.hasClass(b.$tb.get(0),"fr-above")&&e&&(e+=b.$tb.outerHeight()),h=0),l=x[a].data("container"),!b.opts.iframe||h||k||(d&&(d-=b.$iframe.offset().left),e&&(e-=b.$iframe.offset().top)),l.is(b.$tb)?b.$tb.css("zIndex",(b.opts.zIndex||1)+4):x[a].css("zIndex",(b.opts.zIndex||1)+4),d&&(d-=j/2),b.opts.toolbarBottom&&l&&b.$tb&&l.get(0)==b.$tb.get(0)&&(x[a].addClass("fr-above"),e&&(e-=x[a].outerHeight())),x[a].removeClass("fr-active"),b.position.at(d,e,x[a],h||0),x[a].addClass("fr-active"),k||b.accessibility.focusPopup(x[a]),b.opts.toolbarInline&&b.toolbar.hide(),b.events.trigger("popups.show."+a),s(a)._repositionPopup(),o()}function e(a,c){b.events.on("popups.show."+a,c)}function f(a){return x[a]&&b.node.hasClass(x[a],"fr-active")&&b.core.sameInstance(x[a])||!1}function g(a){for(var b in x)if(x.hasOwnProperty(b)&&f(b)&&(void 0===a||x[b].data("instance")==a))return x[b];return!1}function h(a){var c=null;(c="string"!=typeof a?a:x[a])&&b.node.hasClass(c,"fr-active")&&(c.removeClass("fr-active fr-above"),b.events.trigger("popups.hide."+a),b.$tb&&(b.opts.zIndex>1?b.$tb.css("zIndex",b.opts.zIndex+1):b.$tb.css("zIndex","")),b.events.disableBlur(),c.find("input, textarea, button").filter(":focus").blur(),c.find("input, textarea").attr("disabled","disabled"))}function i(a,c){b.events.on("popups.hide."+a,c)}function j(a){var c=x[a];if(c&&!c.data("inst"+b.id)){t(s(a),a)}return c}function k(a,c){b.events.on("popups.refresh."+a,c)}function l(c){x[c].data("instance",b),b.events.trigger("popups.refresh."+c);for(var d=x[c].find(".fr-command"),e=0;e<d.length;e++){var f=a(d[e]);0===f.parents(".fr-dropdown-menu").length&&b.button.refresh(f)}}function m(a){void 0===a&&(a=[]);for(var b in x)x.hasOwnProperty(b)&&a.indexOf(b)<0&&h(b)}function n(){b.shared.exit_flag=!0}function o(){b.shared.exit_flag=!1}function p(){return b.shared.exit_flag}function q(c,d){var e=a.FE.POPUP_TEMPLATES[c];"function"==typeof e&&(e=e.apply(b));for(var f in d)d.hasOwnProperty(f)&&(e=e.replace("[_"+f.toUpperCase()+"_]",d[f]));return e}function r(c,d){var e=q(c,d),f=a('<div class="fr-popup'+(b.helpers.isMobile()?" fr-mobile":" fr-desktop")+(b.opts.toolbarInline?" fr-inline":"")+'"><span class="fr-arrow"></span>'+e+"</div>");b.opts.theme&&f.addClass(b.opts.theme+"-theme"),b.opts.zIndex>1&&b.$tb.css("z-index",b.opts.zIndex+2),"auto"!=b.opts.direction&&f.removeClass("fr-ltr fr-rtl").addClass("fr-"+b.opts.direction),f.find("input, textarea").attr("dir",b.opts.direction).attr("disabled","disabled");var g=a("body:first");return g.append(f),f.data("container",g),x[c]=f,b.button.bindCommands(f,!1),f}function s(c){var d=x[c];return{_windowResize:function(){var a=d.data("instance")||b;!a.helpers.isMobile()&&d.is(":visible")&&(a.events.disableBlur(),a.popups.hide(c),a.events.enableBlur())},_inputFocus:function(c){var e=d.data("instance")||b,f=a(c.currentTarget);if(f.is("input:file")&&f.closest(".fr-layer").addClass("fr-input-focus"),c.preventDefault(),c.stopPropagation(),setTimeout(function(){e.events.enableBlur()},100),e.helpers.isMobile()){var g=a(e.o_win).scrollTop();setTimeout(function(){a(e.o_win).scrollTop(g)},0)}},_inputBlur:function(c){var e=d.data("instance")||b,f=a(c.currentTarget);f.is("input:file")&&f.closest(".fr-layer").removeClass("fr-input-focus"),document.activeElement!=this&&a(this).is(":visible")&&(e.events.blurActive()&&e.events.trigger("blur"),e.events.enableBlur())},_editorKeydown:function(e){var g=d.data("instance")||b;g.keys.ctrlKey(e)||e.which==a.FE.KEYCODE.ALT||e.which==a.FE.KEYCODE.ESC||(f(c)&&d.find(".fr-back:visible").length?g.button.exec(d.find(".fr-back:visible:first")):e.which!=a.FE.KEYCODE.ALT&&g.popups.hide(c))},_preventFocus:function(c){var e=d.data("instance")||b,f=c.originalEvent?c.originalEvent.target||c.originalEvent.originalTarget:null;"mouseup"==c.type||a(f).is(":focus")||e.events.disableBlur(),"mouseup"!=c.type||a(f).hasClass("fr-command")||a(f).parents(".fr-command").length>0||a(f).hasClass("fr-dropdown-content")||b.button.hideActiveDropdowns(d),(b.browser.safari||b.browser.mozilla)&&"mousedown"==c.type&&a(f).is("input[type=file]")&&e.events.disableBlur();var g="input, textarea, button, select, label, .fr-command";if(f&&!a(f).is(g)&&0===a(f).parents(g).length)return c.stopPropagation(),!1;f&&a(f).is(g)&&c.stopPropagation(),o()},_editorMouseup:function(){d.is(":visible")&&p()&&d.find("input:focus, textarea:focus, button:focus, select:focus").filter(":visible").length>0&&b.events.disableBlur()},_windowMouseup:function(a){if(!b.core.sameInstance(d))return!0;var e=d.data("instance")||b;d.is(":visible")&&p()&&(a.stopPropagation(),e.markers.remove(),e.popups.hide(c),o())},_windowKeydown:function(e){if(!b.core.sameInstance(d))return!0;var f=d.data("instance")||b,g=e.which;if(a.FE.KEYCODE.ESC==g){if(f.popups.isVisible(c)&&f.opts.toolbarInline)return e.stopPropagation(),f.popups.isVisible(c)&&(d.find(".fr-back:visible").length?(f.button.exec(d.find(".fr-back:visible:first")),f.accessibility.focusPopupButton(d)):d.find(".fr-dismiss:visible").length?f.button.exec(d.find(".fr-dismiss:visible:first")):(f.popups.hide(c),f.toolbar.showInline(null,!0),f.accessibility.FocusPopupButton(d))),!1;if(f.popups.isVisible(c))return d.find(".fr-back:visible").length?(f.button.exec(d.find(".fr-back:visible:first")),f.accessibility.focusPopupButton(d)):d.find(".fr-dismiss:visible").length?f.button.exec(d.find(".fr-dismiss:visible:first")):(f.popups.hide(c),f.accessibility.focusPopupButton(d)),!1}},_doPlaceholder:function(){0===a(this).next().length&&a(this).attr("placeholder")&&a(this).after('<label for="'+a(this).attr("id")+'">'+a(this).attr("placeholder")+"</label>"),a(this).toggleClass("fr-not-empty",""!==a(this).val())},_repositionPopup:function(){if(!b.opts.height&&!b.opts.heightMax||b.opts.toolbarInline)return!0;if(b.$wp&&f(c)&&d.parent().get(0)==b.$sc.get(0)){var a=d.offset().top-b.$wp.offset().top,e=b.$wp.outerHeight();b.node.hasClass(d.get(0),"fr-above")&&(a+=d.outerHeight()),a>e||a<0?d.addClass("fr-hidden"):d.removeClass("fr-hidden")}}}}function t(a,c){b.events.on("mouseup",a._editorMouseup,!0),b.$wp&&b.events.on("keydown",a._editorKeydown),b.events.on("blur",function(){g()&&b.markers.remove(),m()}),b.$wp&&!b.helpers.isMobile()&&b.events.$on(b.$wp,"scroll.popup"+c,a._repositionPopup),b.events.on("window.mouseup",a._windowMouseup,!0),b.events.on("window.keydown",a._windowKeydown,!0),x[c].data("inst"+b.id,!0),b.events.on("destroy",function(){b.core.sameInstance(x[c])&&x[c].removeClass("fr-active").appendTo("body:first")},!0)}function u(c,d){var e=r(c,d),f=s(c);return t(f,c),b.events.$on(e,"mousedown mouseup touchstart touchend touch","*",f._preventFocus,!0),b.events.$on(e,"focus","input, textarea, button, select",f._inputFocus,!0),b.events.$on(e,"blur","input, textarea, button, select",f._inputBlur,!0),b.accessibility.registerPopup(c),b.events.$on(e,"keydown keyup change input","input, textarea",f._doPlaceholder,!0),b.helpers.isIOS()&&b.events.$on(e,"touchend","label",function(){a("#"+a(this).attr("for")).prop("checked",function(a,b){return!b})},!0),b.events.$on(a(b.o_win),"resize",f._windowResize,!0),e}function v(){for(var a in x)if(x.hasOwnProperty(a)){var b=x[a];b&&(b.html("").removeData().remove(),x[a]=null)}x=[]}function w(){b.events.on("shared.destroy",v,!0),b.events.on("window.mousedown",n),b.events.on("window.touchmove",o),b.events.$on(a(b.o_win),"scroll",o),b.events.on("mousedown",function(a){g()&&(a.stopPropagation(),b.$el.find(".fr-marker").remove(),n(),b.events.disableBlur())})}b.shared.popups||(b.shared.popups={});var x=b.shared.popups;return b.shared.exit_flag=!1,{_init:w,create:u,get:j,show:d,hide:h,onHide:i,hideAll:m,setContainer:c,refresh:l,onRefresh:k,onShow:e,isVisible:f,areVisible:g}},a.FE.MODULES.position=function(b){function c(){var a=b.selection.ranges(0),c=a.getBoundingClientRect();if(0===c.top&&0===c.left&&0===c.width||0===c.height){var d=!1;0===b.$el.find(".fr-marker").length&&(b.selection.save(),d=!0);var e=b.$el.find(".fr-marker:first");e.css("display","inline"),e.css("line-height","");var f=e.offset(),g=e.outerHeight();e.css("display","none"),e.css("line-height",0),c={},c.left=f.left,c.width=0,c.height=g,c.top=f.top-(b.helpers.isMobile()&&!b.helpers.isIOS()?0:b.helpers.scrollTop()),c.right=1,c.bottom=1,c.ok=!0,d&&b.selection.restore()}return c}function d(a,c,d){var e=a.outerHeight(!0);if(!b.helpers.isMobile()&&b.$tb&&a.parent().get(0)!=b.$tb.get(0)){var f=a.parent().offset().top,g=c-e-(d||0);a.parent().get(0)==b.$sc.get(0)&&(f-=a.parent().position().top);var h=b.$sc.get(0).clientHeight;f+c+e>b.$sc.offset().top+h&&a.parent().offset().top+g>0&&g>0?(c=g,a.addClass("fr-above")):a.removeClass("fr-above")}return c}function e(a,c){var d=a.outerWidth(!0);return c+d>b.$sc.get(0).clientWidth-10&&(c=b.$sc.get(0).clientWidth-d-10),c<0&&(c=10),c}function f(a){var d=c();a.css({top:0,left:0});var e=d.top+d.height,f=d.left+d.width/2-a.get(0).offsetWidth/2+b.helpers.scrollLeft();b.opts.iframe||(e+=b.helpers.scrollTop()),g(f,e,a,d.height)}function g(a,c,f,g){var h=f.data("container");!h||"BODY"===h.get(0).tagName&&"static"==h.css("position")||(a&&(a-=h.offset().left),c&&(c-=h.offset().top),"BODY"!=h.get(0).tagName?(a&&(a+=h.get(0).scrollLeft),c&&(c+=h.get(0).scrollTop)):"absolute"==h.css("position")&&(a&&(a+=h.position().left),c&&(c+=h.position().top))),b.opts.iframe&&h&&b.$tb&&h.get(0)!=b.$tb.get(0)&&(a&&(a+=b.$iframe.offset().left),c&&(c+=b.$iframe.offset().top));var i=e(f,a);if(a){f.css("left",i);var j=f.data("fr-arrow");j||(j=f.find(".fr-arrow"),f.data("fr-arrow",j)),j.data("margin-left")||j.data("margin-left",b.helpers.getPX(j.css("margin-left"))),j.css("margin-left",a-i+j.data("margin-left"))}c&&f.css("top",d(f,c,g))}function h(c){var d=a(c),e=d.is(".fr-sticky-on"),f=d.data("sticky-top"),g=d.data("sticky-scheduled");if(void 0===f){d.data("sticky-top",0);var h=a('<div class="fr-sticky-dummy" style="height: '+d.outerHeight()+'px;"></div>');b.$box.prepend(h)}else b.$box.find(".fr-sticky-dummy").css("height",d.outerHeight());if(b.core.hasFocus()||b.$tb.find("input:visible:focus").length>0){var i=b.helpers.scrollTop(),j=Math.min(Math.max(i-b.$tb.parent().offset().top,0),b.$tb.parent().outerHeight()-d.outerHeight());j!=f&&j!=g&&(clearTimeout(d.data("sticky-timeout")),d.data("sticky-scheduled",j),d.outerHeight()<i-b.$tb.parent().offset().top&&d.addClass("fr-opacity-0"),d.data("sticky-timeout",setTimeout(function(){var a=b.helpers.scrollTop(),c=Math.min(Math.max(a-b.$tb.parent().offset().top,0),b.$tb.parent().outerHeight()-d.outerHeight());c>0&&"BODY"==b.$tb.parent().get(0).tagName&&(c+=b.$tb.parent().position().top),c!=f&&(d.css("top",Math.max(c,0)),d.data("sticky-top",c),d.data("sticky-scheduled",c)),d.removeClass("fr-opacity-0")},100))),e||(d.css("top","0"),d.width(b.$tb.parent().width()),d.addClass("fr-sticky-on"),b.$box.addClass("fr-sticky-box"))}else clearTimeout(a(c).css("sticky-timeout")),d.css("top","0"),d.css("position",""),d.width(""),d.data("sticky-top",0),d.removeClass("fr-sticky-on"),b.$box.removeClass("fr-sticky-box")}function i(c){if(c.offsetWidth){var d,e,f=a(c),g=f.outerHeight(),h=f.data("sticky-position"),i=a("body"==b.opts.scrollableContainer?b.o_win:b.opts.scrollableContainer).outerHeight(),j=0,k=0;"body"!==b.opts.scrollableContainer&&(j=b.$sc.offset().top,k=a(b.o_win).outerHeight()-j-i);var l="body"==b.opts.scrollableContainer?b.helpers.scrollTop():j,m=f.is(".fr-sticky-on");f.data("sticky-parent")||f.data("sticky-parent",f.parent());var n=f.data("sticky-parent"),o=n.offset().top,p=n.outerHeight();if(f.data("sticky-offset")?b.$box.find(".fr-sticky-dummy").css("height",g+"px"):(f.data("sticky-offset",!0),f.after('<div class="fr-sticky-dummy" style="height: '+g+'px;"></div>')),!h){var q="auto"!==f.css("top")||"auto"!==f.css("bottom");q||f.css("position","fixed"),h={top:b.node.hasClass(f.get(0),"fr-top"),bottom:b.node.hasClass(f.get(0),"fr-bottom")},q||f.css("position",""),f.data("sticky-position",h),f.data("top",b.node.hasClass(f.get(0),"fr-top")?f.css("top"):"auto"),f.data("bottom",b.node.hasClass(f.get(0),"fr-bottom")?f.css("bottom"):"auto")}var r=function(){return o<l+d&&o+p-g>=l+d},s=function(){return o+g<l+i-e&&o+p>l+i-e};d=b.helpers.getPX(f.data("top")),e=b.helpers.getPX(f.data("bottom"));var t=h.top&&r()&&(b.helpers.isInViewPort(b.$sc.get(0))||"body"==b.opts.scrollableContainer),u=h.bottom&&s();t||u?(f.css("width",n.get(0).getBoundingClientRect().width+"px"),m||(f.addClass("fr-sticky-on"),f.removeClass("fr-sticky-off"),f.css("top")&&("auto"!=f.data("top")?f.css("top",b.helpers.getPX(f.data("top"))+j):f.data("top","auto")),f.css("bottom")&&("auto"!=f.data("bottom")?f.css("bottom",b.helpers.getPX(f.data("bottom"))+k):f.css("bottom","auto")))):b.node.hasClass(f.get(0),"fr-sticky-off")||(f.width(""),f.removeClass("fr-sticky-on"),f.addClass("fr-sticky-off"),f.css("top")&&"auto"!=f.data("top")&&h.top&&f.css("top",0),f.css("bottom")&&"auto"!=f.data("bottom")&&h.bottom&&f.css("bottom",0))}}function j(){var a=document.createElement("test"),c=a.style;return c.cssText="position:"+["-webkit-","-moz-","-ms-","-o-",""].join("sticky; position:")+" sticky;",-1!==c.position.indexOf("sticky")&&!b.helpers.isIOS()&&!b.helpers.isAndroid()&&!b.browser.chrome}function k(){if(!j())if(b._stickyElements=[],b.helpers.isIOS()){var c=function(){b.helpers.requestAnimationFrame()(c);for(var a=0;a<b._stickyElements.length;a++)h(b._stickyElements[a])};c(),b.events.$on(a(b.o_win),"scroll",function(){if(b.core.hasFocus())for(var c=0;c<b._stickyElements.length;c++){var d=a(b._stickyElements[c]),e=d.parent(),f=b.helpers.scrollTop();d.outerHeight()<f-e.offset().top&&(d.addClass("fr-opacity-0"),d.data("sticky-top",-1),d.data("sticky-scheduled",-1))}},!0)}else"body"!==b.opts.scrollableContainer&&b.events.$on(a(b.opts.scrollableContainer),"scroll",l,!0),b.events.$on(a(b.o_win),"scroll",l,!0),b.events.$on(a(b.o_win),"resize",l,!0),b.events.on("initialized",l),b.events.on("focus",l),b.events.$on(a(b.o_win),"resize","textarea",l,!0);b.events.on("destroy",function(){b._stickyElements=[]})}function l(){if(b._stickyElements)for(var a=0;a<b._stickyElements.length;a++)i(b._stickyElements[a])}function m(a){a.addClass("fr-sticky"),b.helpers.isIOS()&&a.addClass("fr-sticky-ios"),j()||(a.removeClass("fr-sticky"),b._stickyElements.push(a.get(0)))}function n(){k()}return{_init:n,forSelection:f,addSticky:m,refresh:l,at:g,getBoundingRect:c}},a.FE.MODULES.refresh=function(b){function c(a){g(a,!b.undo.canDo())}function d(a){g(a,!b.undo.canRedo())}function e(a){if(b.node.hasClass(a.get(0),"fr-no-refresh"))return!1;for(var c=b.selection.blocks(),d=0;d<c.length;d++){for(var e=c[d].previousSibling;e&&e.nodeType==Node.TEXT_NODE&&0===e.textContent.length;)e=e.previousSibling;if("LI"!=c[d].tagName||e)return g(a,!1),!0;g(a,!0)}}function f(c){if(b.node.hasClass(c.get(0),"fr-no-refresh"))return!1;for(var d=b.selection.blocks(),e=0;e<d.length;e++){var f="rtl"==b.opts.direction||"rtl"==a(d[e]).css("direction")?"margin-right":"margin-left";if("LI"==d[e].tagName||"LI"==d[e].parentNode.tagName)return g(c,!1),!0;if(b.helpers.getPX(a(d[e]).css(f))>0)return g(c,!1),!0}g(c,!0)}function g(a,b){a.toggleClass("fr-disabled",b).attr("aria-disabled",b)}return{undo:c,redo:d,outdent:f,indent:e}},a.extend(a.FE.DEFAULTS,{editInPopup:!1}),a.FE.MODULES.textEdit=function(a){function b(){var b='<div id="fr-text-edit-'+a.id+'" class="fr-layer fr-text-edit-layer"><div class="fr-input-line"><input type="text" placeholder="'+a.language.translate("Text")+'" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="updateText" tabIndex="2">'+a.language.translate("Update")+"</button></div></div>",c={edit:b};a.popups.create("text.edit",c)}function c(){var b,c=a.popups.get("text.edit");b="INPUT"===a.$el.prop("tagName")?a.$el.attr("placeholder"):a.$el.text(),c.find("input").val(b).trigger("change"),a.popups.setContainer("text.edit",a.$sc),a.popups.show("text.edit",a.$el.offset().left+a.$el.outerWidth()/2,a.$el.offset().top+a.$el.outerHeight(),a.$el.outerHeight())}function d(){a.events.$on(a.$el,a._mouseup,function(){setTimeout(function(){c()},10)})}function e(){var b=a.popups.get("text.edit"),c=b.find("input").val();0===c.length&&(c=a.opts.placeholderText),"INPUT"===a.$el.prop("tagName")?a.$el.attr("placeholder",c):a.$el.text(c),a.events.trigger("contentChanged"),a.popups.hide("text.edit")}function f(){a.opts.editInPopup&&(b(),d())}return{_init:f,update:e}},a.FE.RegisterCommand("updateText",{focus:!1,undo:!1,callback:function(){this.textEdit.update()}}),a.extend(a.FE.DEFAULTS,{toolbarBottom:!1,toolbarButtons:["fullscreen","bold","italic","underline","strikeThrough","subscript","superscript","|","fontFamily","fontSize","color","inlineStyle","paragraphStyle","|","paragraphFormat","align","formatOL","formatUL","outdent","indent","quote","-","insertLink","insertImage","insertVideo","embedly","insertFile","insertTable","|","emoticons","specialCharacters","insertHR","selectAll","clearFormatting","|","print","spellChecker","help","html","|","undo","redo"],toolbarButtonsXS:["bold","italic","fontFamily","fontSize","|","undo","redo"],toolbarButtonsSM:["bold","italic","underline","|","fontFamily","fontSize","insertLink","insertImage","table","|","undo","redo"],toolbarButtonsMD:null,toolbarContainer:null,toolbarInline:!1,toolbarSticky:!0,toolbarStickyOffset:0,toolbarVisibleWithoutSelection:!1}),a.FE.MODULES.toolbar=function(b){function c(a,b){for(var c=0;c<b.length;c++)"-"!=b[c]&&"|"!=b[c]&&a.indexOf(b[c])<0&&a.push(b[c])}function d(){var d=a.merge([],e());c(d,b.opts.toolbarButtonsXS||[]),c(d,b.opts.toolbarButtonsSM||[]),c(d,b.opts.toolbarButtonsMD||[]),c(d,b.opts.toolbarButtons);for(var f=d.length-1;f>=0;f--)"-"!=d[f]&&"|"!=d[f]&&d.indexOf(d[f])<f&&d.splice(f,1);var g=b.button.buildList(d,e());b.$tb.append(g),b.button.bindCommands(b.$tb)}function e(){var a=b.helpers.screenSize();return v[a]}function f(){var a=e();b.$tb.find(".fr-separator").remove(),b.$tb.find("> .fr-command").addClass("fr-hidden");for(var c=0;c<a.length;c++)if("|"==a[c]||"-"==a[c])b.$tb.append(b.button.buildList([a[c]]));else{var d=b.$tb.find('> .fr-command[data-cmd="'+a[c]+'"]'),f=null;b.node.hasClass(d.next().get(0),"fr-dropdown-menu")&&(f=d.next()),d.removeClass("fr-hidden").appendTo(b.$tb),f&&f.appendTo(b.$tb)}}function g(){b.events.$on(a(b.o_win),"resize",f),b.events.$on(a(b.o_win),"orientationchange",f)}function h(c,d){setTimeout(function(){if((!c||c.which!=a.FE.KEYCODE.ESC)&&b.selection.inEditor()&&b.core.hasFocus()&&!b.popups.areVisible()&&(b.opts.toolbarVisibleWithoutSelection||!b.selection.isCollapsed()&&!b.keys.isIME()||d)){if(b.$tb.data("instance",b),!1===b.events.trigger("toolbar.show",[c]))return!1;b.$tb.show(),b.opts.toolbarContainer||b.position.forSelection(b.$tb),b.opts.zIndex>1?b.$tb.css("z-index",b.opts.zIndex+1):b.$tb.css("z-index",null)}},0)}function i(a){return(!a||"blur"!==a.type||document.activeElement!==b.el)&&(!(!a||"keydown"!==a.type||!b.keys.ctrlKey(a))||(!!b.button.getButtons(".fr-dropdown.fr-active").next().find(b.o_doc.activeElement).length||void(!1!==b.events.trigger("toolbar.hide")&&b.$tb.hide())))}function j(){if(!1===b.events.trigger("toolbar.show"))return!1;b.$tb.show()}function k(c){clearTimeout(w),c&&c.which==a.FE.KEYCODE.ESC||(w=setTimeout(h,b.opts.typingTimer))}function l(){b.events.on("window.mousedown",i),b.events.on("keydown",i),b.events.on("blur",i),b.events.on("window.mouseup",h),b.helpers.isMobile()?b.helpers.isIOS()||(b.events.on("window.touchend",h),b.browser.mozilla&&setInterval(h,200)):b.events.on("window.keyup",k),b.events.on("keydown",function(b){b&&b.which==a.FE.KEYCODE.ESC&&i()}),b.events.on("keydown",function(b){if(b.which==a.FE.KEYCODE.ALT)return b.stopPropagation(),!1},!0),b.events.$on(b.$wp,"scroll.toolbar",h),b.events.on("commands.after",h),b.helpers.isMobile()&&(b.events.$on(b.$doc,"selectionchange",k),b.events.$on(b.$doc,"orientationchange",h))}function m(){b.opts.toolbarInline?(b.$sc.append(b.$tb),b.$tb.data("container",b.$sc),b.$tb.addClass("fr-inline"),b.$tb.prepend('<span class="fr-arrow"></span>'),l(),b.opts.toolbarBottom=!1):(b.opts.toolbarBottom&&!b.helpers.isIOS()?(b.$box.append(b.$tb),b.$tb.addClass("fr-bottom"),b.$box.addClass("fr-bottom")):(b.opts.toolbarBottom=!1,b.$box.prepend(b.$tb),b.$tb.addClass("fr-top"),b.$box.addClass("fr-top")),b.$tb.addClass("fr-basic"),b.opts.toolbarSticky&&(b.opts.toolbarStickyOffset&&(b.opts.toolbarBottom?b.$tb.css("bottom",b.opts.toolbarStickyOffset):b.$tb.css("top",b.opts.toolbarStickyOffset)),b.position.addSticky(b.$tb)))}function n(){b.$tb.html("").removeData().remove(),b.$tb=null}function o(){b.$box.removeClass("fr-top fr-bottom fr-inline fr-basic"),b.$box.find(".fr-sticky-dummy").remove()}function p(){b.opts.theme&&b.$tb.addClass(b.opts.theme+"-theme"),b.opts.zIndex>1&&b.$tb.css("z-index",b.opts.zIndex+1),"auto"!=b.opts.direction&&b.$tb.removeClass("fr-ltr fr-rtl").addClass("fr-"+b.opts.direction),b.helpers.isMobile()?b.$tb.addClass("fr-mobile"):b.$tb.addClass("fr-desktop"),b.opts.toolbarContainer?(b.opts.toolbarInline&&(l(),i()),b.opts.toolbarBottom?b.$tb.addClass("fr-bottom"):b.$tb.addClass("fr-top")):m(),t=b.$tb.get(0).ownerDocument,u="defaultView"in t?t.defaultView:t.parentWindow,d(),g(),b.accessibility.registerToolbar(b.$tb),b.events.$on(b.$tb,b._mousedown+" "+b._mouseup,function(a){var c=a.originalEvent?a.originalEvent.target||a.originalEvent.originalTarget:null;if(c&&"INPUT"!=c.tagName&&!b.edit.isDisabled())return a.stopPropagation(),a.preventDefault(),!1},!0)}function q(){if(b.$sc=a(b.opts.scrollableContainer).first(),!b.$wp)return!1;b.opts.toolbarContainer?(b.shared.$tb?(b.$tb=b.shared.$tb,b.opts.toolbarInline&&l()):(b.shared.$tb=a('<div class="fr-toolbar"></div>'),b.$tb=b.shared.$tb,a(b.opts.toolbarContainer).append(b.$tb),p(),b.$tb.data("instance",b)),b.opts.toolbarInline?b.$box.addClass("fr-inline"):b.$box.addClass("fr-basic"),b.events.on("focus",function(){b.$tb.data("instance",b)},!0),b.opts.toolbarInline=!1):b.opts.toolbarInline?(b.$box.addClass("fr-inline"),b.shared.$tb?(b.$tb=b.shared.$tb,l()):(b.shared.$tb=a('<div class="fr-toolbar"></div>'),b.$tb=b.shared.$tb,p())):(b.$box.addClass("fr-basic"),b.$tb=a('<div class="fr-toolbar"></div>'),p(),b.$tb.data("instance",b)),b.events.on("destroy",o,!0),b.events.on(b.opts.toolbarInline||b.opts.toolbarContainer?"shared.destroy":"destroy",n,!0)}function r(){!x&&b.$tb&&(b.$tb.find("> .fr-command").addClass("fr-disabled fr-no-refresh").attr("aria-disabled",!0),x=!0)}function s(){x&&b.$tb&&(b.$tb.find("> .fr-command").removeClass("fr-disabled fr-no-refresh").attr("aria-disabled",!1),x=!1),b.button.bulkRefresh()}var t,u,v=[];v[a.FE.XS]=b.opts.toolbarButtonsXS||b.opts.toolbarButtons,v[a.FE.SM]=b.opts.toolbarButtonsSM||b.opts.toolbarButtons,v[a.FE.MD]=b.opts.toolbarButtonsMD||b.opts.toolbarButtons,v[a.FE.LG]=b.opts.toolbarButtons;var w=null,x=!1;return{_init:q,hide:i,show:j,showInline:h,disable:r,enable:s}},a.FE.PLUGINS.align=function(b){function c(c){b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();for(var d=b.selection.blocks(),e=0;e<d.length;e++)b.helpers.getAlignment(a(d[e].parentNode))==c?a(d[e]).css("text-align","").removeClass("fr-temp-div"):a(d[e]).css("text-align",c).removeClass("fr-temp-div"),""===a(d[e]).attr("class")&&a(d[e]).removeAttr("class"),""===a(d[e]).attr("style")&&a(d[e]).removeAttr("style");b.selection.save(),b.html.unwrap(),b.selection.restore()}function d(c){var d=b.selection.blocks();if(d.length){var e=b.helpers.getAlignment(a(d[0]));c.find("> *:first").replaceWith(b.icon.create("align-"+e))}}function e(c,d){var e=b.selection.blocks();if(e.length){var f=b.helpers.getAlignment(a(e[0]));d.find('a.fr-command[data-param1="'+f+'"]').addClass("fr-active").attr("aria-selected",!0)}}return{apply:c,refresh:d,refreshOnShow:e}},a.FE.DefineIcon("align",{NAME:"align-left"}),a.FE.DefineIcon("align-left",{NAME:"align-left"}),a.FE.DefineIcon("align-right",{NAME:"align-right"}),a.FE.DefineIcon("align-center",{NAME:"align-center"}),a.FE.DefineIcon("align-justify",{NAME:"align-justify"}),a.FE.RegisterCommand("align",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"Align Center",right:"Align Right",justify:"Align Justify"},html:function(){
var b='<ul class="fr-dropdown-list" role="presentation">',c=a.FE.COMMANDS.align.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="align" data-param1="'+d+'" title="'+this.language.translate(c[d])+'">'+this.icon.create("align-"+d)+'<span class="fr-sr-only">'+this.language.translate(c[d])+"</span></a></li>");return b+="</ul>"},callback:function(a,b){this.align.apply(b)},refresh:function(a){this.align.refresh(a)},refreshOnShow:function(a,b){this.align.refreshOnShow(a,b)},plugin:"align"}),a.extend(a.FE.DEFAULTS,{charCounterMax:-1,charCounterCount:!0}),a.FE.PLUGINS.charCounter=function(b){function c(){return(b.el.textContent||"").replace(/\u200B/g,"").length}function d(d){if(b.opts.charCounterMax<0)return!0;if(c()<b.opts.charCounterMax)return!0;var e=d.which;return!(!b.keys.ctrlKey(d)&&b.keys.isCharacter(e)||e===a.FE.KEYCODE.IME)||(d.preventDefault(),d.stopPropagation(),b.events.trigger("charCounter.exceeded"),!1)}function e(d){return b.opts.charCounterMax<0?d:a("<div>").html(d).text().length+c()<=b.opts.charCounterMax?d:(b.events.trigger("charCounter.exceeded"),"")}function f(){if(b.opts.charCounterCount){var a=c()+(b.opts.charCounterMax>0?"/"+b.opts.charCounterMax:"");h.text(a),b.opts.toolbarBottom&&h.css("margin-bottom",b.$tb.outerHeight(!0));var d=b.$wp.get(0).offsetWidth-b.$wp.get(0).clientWidth;d>=0&&("rtl"==b.opts.direction?h.css("margin-left",d):h.css("margin-right",d))}}function g(){return!!b.$wp&&(!!b.opts.charCounterCount&&(h=a('<span class="fr-counter"></span>'),h.css("bottom",b.$wp.css("border-bottom-width")),b.$box.append(h),b.events.on("keydown",d,!0),b.events.on("paste.afterCleanup",e),b.events.on("keyup contentChanged input",function(){b.events.trigger("charCounter.update")}),b.events.on("charCounter.update",f),b.events.trigger("charCounter.update"),void b.events.on("destroy",function(){a(b.o_win).off("resize.char"+b.id),h.removeData().remove(),h=null})))}var h;return{_init:g,count:c}},a.FE.PLUGINS.codeBeautifier=function(){function a(a,c){function d(a){return a.replace(/^\s+/g,"")}function e(a){return a.replace(/\s+$/g,"")}function g(){return this.pos=0,this.token="",this.current_mode="CONTENT",this.tags={parent:"parent1",parentcount:1,parent1:""},this.tag_type="",this.token_text=this.last_token=this.last_text=this.token_type="",this.newlines=0,this.indent_content=i,this.Utils={whitespace:"\n\r\t ".split(""),single_token:"br,input,link,meta,source,!doctype,basefont,base,area,hr,wbr,param,img,isindex,embed".split(","),extra_liners:u,in_array:function(a,b){for(var c=0;c<b.length;c++)if(a==b[c])return!0;return!1}},this.is_whitespace=function(a){for(var b=0;b<a.length;a++)if(!this.Utils.in_array(a.charAt(b),this.Utils.whitespace))return!1;return!0},this.traverse_whitespace=function(){var a="";if(a=this.input.charAt(this.pos),this.Utils.in_array(a,this.Utils.whitespace)){for(this.newlines=0;this.Utils.in_array(a,this.Utils.whitespace);)o&&"\n"==a&&this.newlines<=p&&(this.newlines+=1),this.pos++,a=this.input.charAt(this.pos);return!0}return!1},this.space_or_wrap=function(a){this.line_char_count>=this.wrap_line_length?(this.print_newline(!1,a),this.print_indentation(a)):(this.line_char_count++,a.push(" "))},this.get_content=function(){for(var a="",b=[];"<"!=this.input.charAt(this.pos);){if(this.pos>=this.input.length)return b.length?b.join(""):["","TK_EOF"];if(this.traverse_whitespace())this.space_or_wrap(b);else{if(q){var c=this.input.substr(this.pos,3);if("{{#"==c||"{{/"==c)break;if("{{!"==c)return[this.get_tag(),"TK_TAG_HANDLEBARS_COMMENT"];if("{{"==this.input.substr(this.pos,2)&&"{{else}}"==this.get_tag(!0))break}a=this.input.charAt(this.pos),this.pos++,this.line_char_count++,b.push(a)}}return b.length?b.join(""):""},this.get_contents_to=function(a){if(this.pos==this.input.length)return["","TK_EOF"];var b="",c=new RegExp("</"+a+"\\s*>","igm");c.lastIndex=this.pos;var d=c.exec(this.input),e=d?d.index:this.input.length;return this.pos<e&&(b=this.input.substring(this.pos,e),this.pos=e),b},this.record_tag=function(a){this.tags[a+"count"]?(this.tags[a+"count"]++,this.tags[a+this.tags[a+"count"]]=this.indent_level):(this.tags[a+"count"]=1,this.tags[a+this.tags[a+"count"]]=this.indent_level),this.tags[a+this.tags[a+"count"]+"parent"]=this.tags.parent,this.tags.parent=a+this.tags[a+"count"]},this.retrieve_tag=function(a){if(this.tags[a+"count"]){for(var b=this.tags.parent;b&&a+this.tags[a+"count"]!=b;)b=this.tags[b+"parent"];b&&(this.indent_level=this.tags[a+this.tags[a+"count"]],this.tags.parent=this.tags[b+"parent"]),delete this.tags[a+this.tags[a+"count"]+"parent"],delete this.tags[a+this.tags[a+"count"]],1==this.tags[a+"count"]?delete this.tags[a+"count"]:this.tags[a+"count"]--}},this.indent_to_tag=function(a){if(this.tags[a+"count"]){for(var b=this.tags.parent;b&&a+this.tags[a+"count"]!=b;)b=this.tags[b+"parent"];b&&(this.indent_level=this.tags[a+this.tags[a+"count"]])}},this.get_tag=function(a){var b,c,d="",e=[],f="",g=!1,h=!0,i=this.pos,j=this.line_char_count;a=void 0!==a&&a;do{if(this.pos>=this.input.length)return a&&(this.pos=i,this.line_char_count=j),e.length?e.join(""):["","TK_EOF"];if(d=this.input.charAt(this.pos),this.pos++,this.Utils.in_array(d,this.Utils.whitespace))g=!0;else{if("'"!=d&&'"'!=d||(d+=this.get_unformatted(d),g=!0),"="==d&&(g=!1),e.length&&"="!=e[e.length-1]&&">"!=d&&g){if(this.space_or_wrap(e),g=!1,!h&&"force"==r&&"/"!=d){this.print_newline(!0,e),this.print_indentation(e);for(var l=0;l<s;l++)e.push(k)}for(var m=0;m<e.length;m++)if(" "==e[m]){h=!1;break}}if(q&&"<"==c&&d+this.input.charAt(this.pos)=="{{"&&(d+=this.get_unformatted("}}"),e.length&&" "!=e[e.length-1]&&"<"!=e[e.length-1]&&(d=" "+d),g=!0),"<"!=d||c||(b=this.pos-1,c="<"),q&&!c&&e.length>=2&&"{"==e[e.length-1]&&"{"==e[e.length-2]&&(b="#"==d||"/"==d||"!"==d?this.pos-3:this.pos-2,c="{"),this.line_char_count++,e.push(d),e[1]&&("!"==e[1]||"?"==e[1]||"%"==e[1])){e=[this.get_comment(b)];break}if(q&&e[1]&&"{"==e[1]&&e[2]&&"!"==e[2]){e=[this.get_comment(b)];break}if(q&&"{"==c&&e.length>2&&"}"==e[e.length-2]&&"}"==e[e.length-1])break}}while(">"!=d);var o,p,t=e.join("");o=-1!=t.indexOf(" ")?t.indexOf(" "):"{"==t[0]?t.indexOf("}"):t.indexOf(">"),p="<"!=t[0]&&q?"#"==t[2]?3:2:1;var u=t.substring(p,o).toLowerCase();return"/"==t.charAt(t.length-2)||this.Utils.in_array(u,this.Utils.single_token)?a||(this.tag_type="SINGLE"):q&&"{"==t[0]&&"else"==u?a||(this.indent_to_tag("if"),this.tag_type="HANDLEBARS_ELSE",this.indent_content=!0,this.traverse_whitespace()):this.is_unformatted(u,n)?(f=this.get_unformatted("</"+u+">",t),e.push(f),this.pos-1,this.tag_type="SINGLE"):"script"==u&&(-1==t.search("type")||t.search("type")>-1&&t.search(/\b(text|application)\/(x-)?(javascript|ecmascript|jscript|livescript)/)>-1)?a||(this.record_tag(u),this.tag_type="SCRIPT"):"style"==u&&(-1==t.search("type")||t.search("type")>-1&&t.search("text/css")>-1)?a||(this.record_tag(u),this.tag_type="STYLE"):"!"==u.charAt(0)?a||(this.tag_type="SINGLE",this.traverse_whitespace()):a||("/"==u.charAt(0)?(this.retrieve_tag(u.substring(1)),this.tag_type="END"):(this.record_tag(u),"html"!=u.toLowerCase()&&(this.indent_content=!0),this.tag_type="START"),this.traverse_whitespace()&&this.space_or_wrap(e),this.Utils.in_array(u,this.Utils.extra_liners)&&(this.print_newline(!1,this.output),this.output.length&&"\n"!=this.output[this.output.length-2]&&this.print_newline(!0,this.output))),a&&(this.pos=i,this.line_char_count=j),e.join("")},this.get_comment=function(a){var b="",c=">",d=!1;this.pos=a;var e=this.input.charAt(this.pos);for(this.pos++;this.pos<=this.input.length&&(b+=e,b[b.length-1]!=c[c.length-1]||-1==b.indexOf(c));)!d&&b.length<10&&(0===b.indexOf("<![if")?(c="<![endif]>",d=!0):0===b.indexOf("<![cdata[")?(c="]]>",d=!0):0===b.indexOf("<![")?(c="]>",d=!0):0===b.indexOf("\x3c!--")?(c="--\x3e",d=!0):0===b.indexOf("{{!")?(c="}}",d=!0):0===b.indexOf("<?")?(c="?>",d=!0):0===b.indexOf("<%")&&(c="%>",d=!0)),e=this.input.charAt(this.pos),this.pos++;return b},this.get_unformatted=function(a,b){if(b&&-1!=b.toLowerCase().indexOf(a))return"";var c="",d="",e=0,f=!0;do{if(this.pos>=this.input.length)return d;if(c=this.input.charAt(this.pos),this.pos++,this.Utils.in_array(c,this.Utils.whitespace)){if(!f){this.line_char_count--;continue}if("\n"==c||"\r"==c){d+="\n",this.line_char_count=0;continue}}d+=c,this.line_char_count++,f=!0,q&&"{"==c&&d.length&&"{"==d[d.length-2]&&(d+=this.get_unformatted("}}"),e=d.length)}while(-1==d.toLowerCase().indexOf(a,e));return d},this.get_token=function(){var a;if("TK_TAG_SCRIPT"==this.last_token||"TK_TAG_STYLE"==this.last_token){var b=this.last_token.substr(7);return a=this.get_contents_to(b),"string"!=typeof a?a:[a,"TK_"+b]}if("CONTENT"==this.current_mode)return a=this.get_content(),"string"!=typeof a?a:[a,"TK_CONTENT"];if("TAG"==this.current_mode){if("string"!=typeof(a=this.get_tag()))return a;return[a,"TK_TAG_"+this.tag_type]}},this.get_full_indent=function(a){return a=this.indent_level+a||0,a<1?"":new Array(a+1).join(this.indent_string)},this.is_unformatted=function(a,b){if(!this.Utils.in_array(a,b))return!1;if("a"!=a.toLowerCase()||!this.Utils.in_array("a",b))return!0;var c=this.get_tag(!0),d=(c||"").match(/^\s*<\s*\/?([a-z]*)\s*[^>]*>\s*$/);return!(d&&!this.Utils.in_array(d,b))},this.printer=function(a,b,c,f,g){this.input=a||"",this.output=[],this.indent_character=b,this.indent_string="",this.indent_size=c,this.brace_style=g,this.indent_level=0,this.wrap_line_length=f,this.line_char_count=0;for(var h=0;h<this.indent_size;h++)this.indent_string+=this.indent_character;this.print_newline=function(a,b){this.line_char_count=0,b&&b.length&&(a||"\n"!=b[b.length-1])&&("\n"!=b[b.length-1]&&(b[b.length-1]=e(b[b.length-1])),b.push("\n"))},this.print_indentation=function(a){for(var b=0;b<this.indent_level;b++)a.push(this.indent_string),this.line_char_count+=this.indent_string.length},this.print_token=function(a){this.is_whitespace(a)&&!this.output.length||((a||""!==a)&&this.output.length&&"\n"==this.output[this.output.length-1]&&(this.print_indentation(this.output),a=d(a)),this.print_token_raw(a))},this.print_token_raw=function(a){this.newlines>0&&(a=e(a)),a&&""!==a&&(a.length>1&&"\n"==a[a.length-1]?(this.output.push(a.slice(0,-1)),this.print_newline(!1,this.output)):this.output.push(a));for(var b=0;b<this.newlines;b++)this.print_newline(b>0,this.output);this.newlines=0},this.indent=function(){this.indent_level++},this.unindent=function(){this.indent_level>0&&this.indent_level--}},this}var h,i,j,k,l,m,n,o,p,q,r,s,t,u;for(c=c||{},void 0!==c.wrap_line_length&&0!==parseInt(c.wrap_line_length,10)||void 0===c.max_char||0===parseInt(c.max_char,10)||(c.wrap_line_length=c.max_char),i=void 0!==c.indent_inner_html&&c.indent_inner_html,j=void 0===c.indent_size?4:parseInt(c.indent_size,10),k=void 0===c.indent_char?" ":c.indent_char,m=void 0===c.brace_style?"collapse":c.brace_style,l=0===parseInt(c.wrap_line_length,10)?32786:parseInt(c.wrap_line_length||250,10),n=c.unformatted||["a","span","img","bdo","em","strong","dfn","code","samp","kbd","var","cite","abbr","acronym","q","sub","sup","tt","i","b","big","small","u","s","strike","font","ins","del","address","pre"],o=void 0===c.preserve_newlines||c.preserve_newlines,p=o?isNaN(parseInt(c.max_preserve_newlines,10))?32786:parseInt(c.max_preserve_newlines,10):0,q=void 0!==c.indent_handlebars&&c.indent_handlebars,r=void 0===c.wrap_attributes?"auto":c.wrap_attributes,s=void 0===c.wrap_attributes_indent_size?j:parseInt(c.wrap_attributes_indent_size,10)||j,t=void 0!==c.end_with_newline&&c.end_with_newline,u=Array.isArray(c.extra_liners)?c.extra_liners.concat():"string"==typeof c.extra_liners?c.extra_liners.split(","):"head,body,/html".split(","),c.indent_with_tabs&&(k="\t",j=1),h=new g,h.printer(a,k,j,l,m);;){var v=h.get_token();if(h.token_text=v[0],h.token_type=v[1],"TK_EOF"==h.token_type)break;switch(h.token_type){case"TK_TAG_START":h.print_newline(!1,h.output),h.print_token(h.token_text),h.indent_content&&(h.indent(),h.indent_content=!1),h.current_mode="CONTENT";break;case"TK_TAG_STYLE":case"TK_TAG_SCRIPT":h.print_newline(!1,h.output),h.print_token(h.token_text),h.current_mode="CONTENT";break;case"TK_TAG_END":if("TK_CONTENT"==h.last_token&&""===h.last_text){var w=h.token_text.match(/\w+/)[0],x=null;h.output.length&&(x=h.output[h.output.length-1].match(/(?:<|{{#)\s*(\w+)/)),(null==x||x[1]!=w&&!h.Utils.in_array(x[1],n))&&h.print_newline(!1,h.output)}h.print_token(h.token_text),h.current_mode="CONTENT";break;case"TK_TAG_SINGLE":var y=h.token_text.match(/^\s*<([a-z-]+)/i);y&&h.Utils.in_array(y[1],n)||h.print_newline(!1,h.output),h.print_token(h.token_text),h.current_mode="CONTENT";break;case"TK_TAG_HANDLEBARS_ELSE":h.print_token(h.token_text),h.indent_content&&(h.indent(),h.indent_content=!1),h.current_mode="CONTENT";break;case"TK_TAG_HANDLEBARS_COMMENT":case"TK_CONTENT":h.print_token(h.token_text),h.current_mode="TAG";break;case"TK_STYLE":case"TK_SCRIPT":if(""!==h.token_text){h.print_newline(!1,h.output);var z,A=h.token_text,B=1;"TK_SCRIPT"==h.token_type?z="function"==typeof f&&f:"TK_STYLE"==h.token_type&&(z="function"==typeof b&&b),"keep"==c.indent_scripts?B=0:"separate"==c.indent_scripts&&(B=-h.indent_level);var C=h.get_full_indent(B);if(z)A=z(A.replace(/^\s*/,C),c);else{var D=A.match(/^\s*/)[0],E=D.match(/[^\n\r]*$/)[0].split(h.indent_string).length-1,F=h.get_full_indent(B-E);A=A.replace(/^\s*/,C).replace(/\r\n|\r|\n/g,"\n"+F).replace(/\s+$/,"")}A&&(h.print_token_raw(A),h.print_newline(!0,h.output))}h.current_mode="TAG";break;default:""!==h.token_text&&h.print_token(h.token_text)}h.last_token=h.token_type,h.last_text=h.token_text}var G=h.output.join("").replace(/[\r\n\t ]+$/,"");return t&&(G+="\n"),G}function b(a,b){function c(){return(v=a.charAt(++x))||""}function d(b){var d="",e=x;return b&&g(),d=a.charAt(x+1)||"",x=e-1,c(),d}function e(b){for(var d=x;c();)if("\\"===v)c();else{if(-1!==b.indexOf(v))break;if("\n"===v)break}return a.substring(d,x+1)}function f(a){var b=x,d=e(a);return x=b-1,c(),d}function g(){for(var a="";w.test(d());)c(),a+=v;return a}function h(){var a="";for(v&&w.test(v)&&(a=v);w.test(c());)a+=v;return a}function i(b){var e=x;for(b="/"===d(),c();c();){if(!b&&"*"===v&&"/"===d()){c();break}if(b&&"\n"===v)return a.substring(e,x)}return a.substring(e,x)+v}function j(b){return a.substring(x-b.length,x).toLowerCase()===b}function k(){for(var b=0,c=x+1;c<a.length;c++){var d=a.charAt(c);if("{"===d)return!0;if("("===d)b+=1;else if(")"===d){if(0==b)return!1;b-=1}else if(";"===d||"}"===d)return!1}return!1}function l(){B++,z+=A}function m(){B--,z=z.slice(0,-p)}var n={"@page":!0,"@font-face":!0,"@keyframes":!0,"@media":!0,"@supports":!0,"@document":!0},o={"@media":!0,"@supports":!0,"@document":!0};b=b||{},a=a||"",a=a.replace(/\r\n|[\r\u2028\u2029]/g,"\n");var p=b.indent_size||4,q=b.indent_char||" ",r=void 0===b.selector_separator_newline||b.selector_separator_newline,s=void 0!==b.end_with_newline&&b.end_with_newline,t=void 0===b.newline_between_rules||b.newline_between_rules,u=b.eol?b.eol:"\n";"string"==typeof p&&(p=parseInt(p,10)),b.indent_with_tabs&&(q="\t",p=1),u=u.replace(/\\r/,"\r").replace(/\\n/,"\n");var v,w=/^\s+$/,x=-1,y=0,z=a.match(/^[\t ]*/)[0],A=new Array(p+1).join(q),B=0,C=0,D={};D["{"]=function(a){D.singleSpace(),E.push(a),D.newLine()},D["}"]=function(a){D.newLine(),E.push(a),D.newLine()},D._lastCharWhitespace=function(){return w.test(E[E.length-1])},D.newLine=function(a){E.length&&(a||"\n"===E[E.length-1]||D.trim(),E.push("\n"),z&&E.push(z))},D.singleSpace=function(){E.length&&!D._lastCharWhitespace()&&E.push(" ")},D.preserveSingleSpace=function(){L&&D.singleSpace()},D.trim=function(){for(;D._lastCharWhitespace();)E.pop()};for(var E=[],F=!1,G=!1,H=!1,I="",J="";;){var K=h(),L=""!==K,M=-1!==K.indexOf("\n");if(J=I,I=v,!v)break;if("/"===v&&"*"===d()){var N=0===B;(M||N)&&D.newLine(),E.push(i()),D.newLine(),N&&D.newLine(!0)}else if("/"===v&&"/"===d())M||"{"===J||D.trim(),D.singleSpace(),E.push(i()),D.newLine();else if("@"===v){D.preserveSingleSpace(),E.push(v);var O=f(": ,;{}()[]/='\"");O.match(/[ :]$/)&&(c(),O=e(": ").replace(/\s$/,""),E.push(O),D.singleSpace()),O=O.replace(/\s$/,""),O in n&&(C+=1,O in o&&(H=!0))}else"#"===v&&"{"===d()?(D.preserveSingleSpace(),E.push(e("}"))):"{"===v?"}"===d(!0)?(g(),c(),D.singleSpace(),E.push("{}"),D.newLine(),t&&0===B&&D.newLine(!0)):(l(),D["{"](v),H?(H=!1,F=B>C):F=B>=C):"}"===v?(m(),D["}"](v),F=!1,G=!1,C&&C--,t&&0===B&&D.newLine(!0)):":"===v?(g(),!F&&!H||j("&")||k()?":"===d()?(c(),E.push("::")):E.push(":"):(G=!0,E.push(":"),D.singleSpace())):'"'===v||"'"===v?(D.preserveSingleSpace(),E.push(e(v))):";"===v?(G=!1,E.push(v),D.newLine()):"("===v?j("url")?(E.push(v),g(),c()&&(")"!==v&&'"'!==v&&"'"!==v?E.push(e(")")):x--)):(y++,D.preserveSingleSpace(),E.push(v),g()):")"===v?(E.push(v),y--):","===v?(E.push(v),g(),r&&!G&&y<1?D.newLine():D.singleSpace()):"]"===v?E.push(v):"["===v?(D.preserveSingleSpace(),E.push(v)):"="===v?(g(),v="=",E.push(v)):(D.preserveSingleSpace(),E.push(v))}var P="";return z&&(P+=z),P+=E.join("").replace(/[\r\n\t ]+$/,""),s&&(P+="\n"),"\n"!=u&&(P=P.replace(/[\n]/g,u)),P}function c(a,b){for(var c=0;c<b.length;c+=1)if(b[c]===a)return!0;return!1}function d(a){return a.replace(/^\s+|\s+$/g,"")}function e(a){return a.replace(/^\s+/g,"")}function f(a,b){return new g(a,b).beautify()}function g(a,b){function f(a,b){var c=0;return a&&(c=a.indentation_level,!R.just_added_newline()&&a.line_indent_level>c&&(c=a.line_indent_level)),{mode:b,parent:a,last_text:a?a.last_text:"",last_word:a?a.last_word:"",declaration_statement:!1,declaration_assignment:!1,multiline_frame:!1,if_block:!1,else_block:!1,do_block:!1,do_while:!1,in_case_statement:!1,in_case:!1,case_body:!1,indentation_level:c,line_indent_level:a?a.line_indent_level:c,start_line_index:R.get_line_number(),ternary_depth:0}}function g(a){var b=a.newlines;if(ba.keep_array_indentation&&t(Y.mode))for(c=0;c<b;c+=1)n(c>0);else if(ba.max_preserve_newlines&&b>ba.max_preserve_newlines&&(b=ba.max_preserve_newlines),ba.preserve_newlines&&a.newlines>1){n();for(var c=1;c<b;c+=1)n(!0)}U=a,aa[U.type]()}function h(a){a=a.replace(/\x0d/g,"");for(var b=[],c=a.indexOf("\n");-1!==c;)b.push(a.substring(0,c)),a=a.substring(c+1),c=a.indexOf("\n");return a.length&&b.push(a),b}function m(a){if(a=void 0!==a&&a,!R.just_added_newline())if(ba.preserve_newlines&&U.wanted_newline||a)n(!1,!0);else if(ba.wrap_line_length){var b=R.current_line.get_character_count()+U.text.length+(R.space_before_token?1:0);b>=ba.wrap_line_length&&n(!1,!0)}}function n(a,b){if(!b&&";"!==Y.last_text&&","!==Y.last_text&&"="!==Y.last_text&&"TK_OPERATOR"!==V)for(;Y.mode===l.Statement&&!Y.if_block&&!Y.do_block;)v();R.add_new_line(a)&&(Y.multiline_frame=!0)}function o(){R.just_added_newline()&&(ba.keep_array_indentation&&t(Y.mode)&&U.wanted_newline?(R.current_line.push(U.whitespace_before),R.space_before_token=!1):R.set_indent(Y.indentation_level)&&(Y.line_indent_level=Y.indentation_level))}function p(a){if(R.raw)return void R.add_raw_token(U);ba.comma_first&&"TK_COMMA"===V&&R.just_added_newline()&&","===R.previous_line.last()&&(R.previous_line.pop(),o(),R.add_token(","),R.space_before_token=!0),a=a||U.text,o(),R.add_token(a)}function q(){Y.indentation_level+=1}function r(){Y.indentation_level>0&&(!Y.parent||Y.indentation_level>Y.parent.indentation_level)&&(Y.indentation_level-=1)}function s(a){Y?($.push(Y),Z=Y):Z=f(null,a),Y=f(Z,a)}function t(a){return a===l.ArrayLiteral}function u(a){return c(a,[l.Expression,l.ForInitializer,l.Conditional])}function v(){$.length>0&&(Z=Y,Y=$.pop(),Z.mode===l.Statement&&R.remove_redundant_indentation(Z))}function w(){return Y.parent.mode===l.ObjectLiteral&&Y.mode===l.Statement&&(":"===Y.last_text&&0===Y.ternary_depth||"TK_RESERVED"===V&&c(Y.last_text,["get","set"]))}function x(){return!!("TK_RESERVED"===V&&c(Y.last_text,["var","let","const"])&&"TK_WORD"===U.type||"TK_RESERVED"===V&&"do"===Y.last_text||"TK_RESERVED"===V&&"return"===Y.last_text&&!U.wanted_newline||"TK_RESERVED"===V&&"else"===Y.last_text&&("TK_RESERVED"!==U.type||"if"!==U.text)||"TK_END_EXPR"===V&&(Z.mode===l.ForInitializer||Z.mode===l.Conditional)||"TK_WORD"===V&&Y.mode===l.BlockStatement&&!Y.in_case&&"--"!==U.text&&"++"!==U.text&&"function"!==W&&"TK_WORD"!==U.type&&"TK_RESERVED"!==U.type||Y.mode===l.ObjectLiteral&&(":"===Y.last_text&&0===Y.ternary_depth||"TK_RESERVED"===V&&c(Y.last_text,["get","set"])))&&(s(l.Statement),q(),"TK_RESERVED"===V&&c(Y.last_text,["var","let","const"])&&"TK_WORD"===U.type&&(Y.declaration_statement=!0),w()||m("TK_RESERVED"===U.type&&c(U.text,["do","for","if","while"])),!0)}function y(a,b){for(var c=0;c<a.length;c++){if(d(a[c]).charAt(0)!==b)return!1}return!0}function z(a,b){for(var c,d=0,e=a.length;d<e;d++)if((c=a[d])&&0!==c.indexOf(b))return!1;return!0}function A(a){return c(a,["case","return","do","if","throw","else"])}function B(a){var b=S+(a||0);return b<0||b>=ca.length?null:ca[b]}function C(){x();var a=l.Expression;if("["===U.text){if("TK_WORD"===V||")"===Y.last_text)return"TK_RESERVED"===V&&c(Y.last_text,T.line_starters)&&(R.space_before_token=!0),s(a),p(),q(),void(ba.space_in_paren&&(R.space_before_token=!0));a=l.ArrayLiteral,t(Y.mode)&&("["!==Y.last_text&&(","!==Y.last_text||"]"!==W&&"}"!==W)||ba.keep_array_indentation||n())}else"TK_RESERVED"===V&&"for"===Y.last_text?a=l.ForInitializer:"TK_RESERVED"===V&&c(Y.last_text,["if","while"])&&(a=l.Conditional);";"===Y.last_text||"TK_START_BLOCK"===V?n():"TK_END_EXPR"===V||"TK_START_EXPR"===V||"TK_END_BLOCK"===V||"."===Y.last_text?m(U.wanted_newline):"TK_RESERVED"===V&&"("===U.text||"TK_WORD"===V||"TK_OPERATOR"===V?"TK_RESERVED"===V&&("function"===Y.last_word||"typeof"===Y.last_word)||"*"===Y.last_text&&"function"===W?ba.space_after_anon_function&&(R.space_before_token=!0):"TK_RESERVED"!==V||!c(Y.last_text,T.line_starters)&&"catch"!==Y.last_text||ba.space_before_conditional&&(R.space_before_token=!0):R.space_before_token=!0,"("===U.text&&"TK_RESERVED"===V&&"await"===Y.last_word&&(R.space_before_token=!0),"("===U.text&&("TK_EQUALS"!==V&&"TK_OPERATOR"!==V||w()||m()),s(a),p(),ba.space_in_paren&&(R.space_before_token=!0),q()}function D(){for(;Y.mode===l.Statement;)v();Y.multiline_frame&&m("]"===U.text&&t(Y.mode)&&!ba.keep_array_indentation),ba.space_in_paren&&("TK_START_EXPR"!==V||ba.space_in_empty_paren?R.space_before_token=!0:(R.trim(),R.space_before_token=!1)),"]"===U.text&&ba.keep_array_indentation?(p(),v()):(v(),p()),R.remove_redundant_indentation(Z),Y.do_while&&Z.mode===l.Conditional&&(Z.mode=l.Expression,Y.do_block=!1,Y.do_while=!1)}function E(){var a=B(1),b=B(2);s(b&&(":"===b.text&&c(a.type,["TK_STRING","TK_WORD","TK_RESERVED"])||c(a.text,["get","set"])&&c(b.type,["TK_WORD","TK_RESERVED"]))?c(W,["class","interface"])?l.BlockStatement:l.ObjectLiteral:l.BlockStatement);var d=!a.comments_before.length&&"}"===a.text,e=d&&"function"===Y.last_word&&"TK_END_EXPR"===V;"expand"===ba.brace_style||"none"===ba.brace_style&&U.wanted_newline?"TK_OPERATOR"!==V&&(e||"TK_EQUALS"===V||"TK_RESERVED"===V&&A(Y.last_text)&&"else"!==Y.last_text)?R.space_before_token=!0:n(!1,!0):"TK_OPERATOR"!==V&&"TK_START_EXPR"!==V?"TK_START_BLOCK"===V?n():R.space_before_token=!0:t(Z.mode)&&","===Y.last_text&&("}"===W?R.space_before_token=!0:n()),p(),q()}function F(){for(;Y.mode===l.Statement;)v();var a="TK_START_BLOCK"===V;"expand"===ba.brace_style?a||n():a||(t(Y.mode)&&ba.keep_array_indentation?(ba.keep_array_indentation=!1,n(),ba.keep_array_indentation=!0):n()),v(),p()}function G(){if("TK_RESERVED"===U.type&&Y.mode!==l.ObjectLiteral&&c(U.text,["set","get"])&&(U.type="TK_WORD"),"TK_RESERVED"===U.type&&Y.mode===l.ObjectLiteral){":"==B(1).text&&(U.type="TK_WORD")}if(x()||!U.wanted_newline||u(Y.mode)||"TK_OPERATOR"===V&&"--"!==Y.last_text&&"++"!==Y.last_text||"TK_EQUALS"===V||!ba.preserve_newlines&&"TK_RESERVED"===V&&c(Y.last_text,["var","let","const","set","get"])||n(),Y.do_block&&!Y.do_while){if("TK_RESERVED"===U.type&&"while"===U.text)return R.space_before_token=!0,p(),R.space_before_token=!0,void(Y.do_while=!0);n(),Y.do_block=!1}if(Y.if_block)if(Y.else_block||"TK_RESERVED"!==U.type||"else"!==U.text){for(;Y.mode===l.Statement;)v();Y.if_block=!1,Y.else_block=!1}else Y.else_block=!0;if("TK_RESERVED"===U.type&&("case"===U.text||"default"===U.text&&Y.in_case_statement))return n(),(Y.case_body||ba.jslint_happy)&&(r(),Y.case_body=!1),p(),Y.in_case=!0,void(Y.in_case_statement=!0);if("TK_RESERVED"===U.type&&"function"===U.text&&((c(Y.last_text,["}",";"])||R.just_added_newline()&&!c(Y.last_text,["[","{",":","=",","]))&&(R.just_added_blankline()||U.comments_before.length||(n(),n(!0))),"TK_RESERVED"===V||"TK_WORD"===V?"TK_RESERVED"===V&&c(Y.last_text,["get","set","new","return","export","async"])?R.space_before_token=!0:"TK_RESERVED"===V&&"default"===Y.last_text&&"export"===W?R.space_before_token=!0:n():"TK_OPERATOR"===V||"="===Y.last_text?R.space_before_token=!0:(Y.multiline_frame||!u(Y.mode)&&!t(Y.mode))&&n()),"TK_COMMA"!==V&&"TK_START_EXPR"!==V&&"TK_EQUALS"!==V&&"TK_OPERATOR"!==V||w()||m(),"TK_RESERVED"===U.type&&c(U.text,["function","get","set"]))return p(),void(Y.last_word=U.text);if(_="NONE","TK_END_BLOCK"===V?"TK_RESERVED"===U.type&&c(U.text,["else","catch","finally"])?"expand"===ba.brace_style||"end-expand"===ba.brace_style||"none"===ba.brace_style&&U.wanted_newline?_="NEWLINE":(_="SPACE",R.space_before_token=!0):_="NEWLINE":"TK_SEMICOLON"===V&&Y.mode===l.BlockStatement?_="NEWLINE":"TK_SEMICOLON"===V&&u(Y.mode)?_="SPACE":"TK_STRING"===V?_="NEWLINE":"TK_RESERVED"===V||"TK_WORD"===V||"*"===Y.last_text&&"function"===W?_="SPACE":"TK_START_BLOCK"===V?_="NEWLINE":"TK_END_EXPR"===V&&(R.space_before_token=!0,_="NEWLINE"),"TK_RESERVED"===U.type&&c(U.text,T.line_starters)&&")"!==Y.last_text&&(_="else"===Y.last_text||"export"===Y.last_text?"SPACE":"NEWLINE"),"TK_RESERVED"===U.type&&c(U.text,["else","catch","finally"]))if("TK_END_BLOCK"!==V||"expand"===ba.brace_style||"end-expand"===ba.brace_style||"none"===ba.brace_style&&U.wanted_newline)n();else{R.trim(!0);var a=R.current_line;"}"!==a.last()&&n(),R.space_before_token=!0}else"NEWLINE"===_?"TK_RESERVED"===V&&A(Y.last_text)?R.space_before_token=!0:"TK_END_EXPR"!==V?"TK_START_EXPR"===V&&"TK_RESERVED"===U.type&&c(U.text,["var","let","const"])||":"===Y.last_text||("TK_RESERVED"===U.type&&"if"===U.text&&"else"===Y.last_text?R.space_before_token=!0:n()):"TK_RESERVED"===U.type&&c(U.text,T.line_starters)&&")"!==Y.last_text&&n():Y.multiline_frame&&t(Y.mode)&&","===Y.last_text&&"}"===W?n():"SPACE"===_&&(R.space_before_token=!0);p(),Y.last_word=U.text,"TK_RESERVED"===U.type&&"do"===U.text&&(Y.do_block=!0),"TK_RESERVED"===U.type&&"if"===U.text&&(Y.if_block=!0)}function H(){for(x()&&(R.space_before_token=!1);Y.mode===l.Statement&&!Y.if_block&&!Y.do_block;)v();p()}function I(){x()?R.space_before_token=!0:"TK_RESERVED"===V||"TK_WORD"===V?R.space_before_token=!0:"TK_COMMA"===V||"TK_START_EXPR"===V||"TK_EQUALS"===V||"TK_OPERATOR"===V?w()||m():n(),p()}function J(){x(),Y.declaration_statement&&(Y.declaration_assignment=!0),R.space_before_token=!0,p(),R.space_before_token=!0}function K(){if(Y.declaration_statement)return u(Y.parent.mode)&&(Y.declaration_assignment=!1),p(),void(Y.declaration_assignment?(Y.declaration_assignment=!1,n(!1,!0)):(R.space_before_token=!0,ba.comma_first&&m()));p(),Y.mode===l.ObjectLiteral||Y.mode===l.Statement&&Y.parent.mode===l.ObjectLiteral?(Y.mode===l.Statement&&v(),n()):(R.space_before_token=!0,ba.comma_first&&m())}function L(){if(x(),"TK_RESERVED"===V&&A(Y.last_text))return R.space_before_token=!0,void p();if("*"===U.text&&"TK_DOT"===V)return void p();if(":"===U.text&&Y.in_case)return Y.case_body=!0,q(),p(),n(),void(Y.in_case=!1);if("::"===U.text)return void p();"TK_OPERATOR"===V&&m();var a=!0,b=!0;c(U.text,["--","++","!","~"])||c(U.text,["-","+"])&&(c(V,["TK_START_BLOCK","TK_START_EXPR","TK_EQUALS","TK_OPERATOR"])||c(Y.last_text,T.line_starters)||","===Y.last_text)?(a=!1,b=!1,!U.wanted_newline||"--"!==U.text&&"++"!==U.text||n(!1,!0),";"===Y.last_text&&u(Y.mode)&&(a=!0),"TK_RESERVED"===V?a=!0:"TK_END_EXPR"===V?a=!("]"===Y.last_text&&("--"===U.text||"++"===U.text)):"TK_OPERATOR"===V&&(a=c(U.text,["--","-","++","+"])&&c(Y.last_text,["--","-","++","+"]),c(U.text,["+","-"])&&c(Y.last_text,["--","++"])&&(b=!0)),Y.mode!==l.BlockStatement&&Y.mode!==l.Statement||"{"!==Y.last_text&&";"!==Y.last_text||n()):":"===U.text?0===Y.ternary_depth?a=!1:Y.ternary_depth-=1:"?"===U.text?Y.ternary_depth+=1:"*"===U.text&&"TK_RESERVED"===V&&"function"===Y.last_text&&(a=!1,b=!1),R.space_before_token=R.space_before_token||a,p(),R.space_before_token=b}function M(){if(R.raw)return R.add_raw_token(U),void(U.directives&&"end"===U.directives.preserve&&(ba.test_output_raw||(R.raw=!1)));if(U.directives)return n(!1,!0),p(),"start"===U.directives.preserve&&(R.raw=!0),void n(!1,!0);if(!k.newline.test(U.text)&&!U.wanted_newline)return R.space_before_token=!0,p(),void(R.space_before_token=!0);var a,b=h(U.text),c=!1,d=!1,f=U.whitespace_before,g=f.length;for(n(!1,!0),b.length>1&&(y(b.slice(1),"*")?c=!0:z(b.slice(1),f)&&(d=!0)),p(b[0]),a=1;a<b.length;a++)n(!1,!0),c?p(" "+e(b[a])):d&&b[a].length>g?p(b[a].substring(g)):R.add_token(b[a]);n(!1,!0)}function N(){U.wanted_newline?n(!1,!0):R.trim(!0),R.space_before_token=!0,p(),n(!1,!0)}function O(){x(),"TK_RESERVED"===V&&A(Y.last_text)?R.space_before_token=!0:m(")"===Y.last_text&&ba.break_chained_methods),p()}function P(){p(),"\n"===U.text[U.text.length-1]&&n()}function Q(){for(;Y.mode===l.Statement;)v()}var R,S,T,U,V,W,X,Y,Z,$,_,aa,ba,ca=[],da="";for(aa={TK_START_EXPR:C,TK_END_EXPR:D,TK_START_BLOCK:E,TK_END_BLOCK:F,TK_WORD:G,TK_RESERVED:G,TK_SEMICOLON:H,TK_STRING:I,TK_EQUALS:J,TK_OPERATOR:L,TK_COMMA:K,TK_BLOCK_COMMENT:M,TK_COMMENT:N,TK_DOT:O,TK_UNKNOWN:P,TK_EOF:Q},b=b||{},ba={},void 0!==b.braces_on_own_line&&(ba.brace_style=b.braces_on_own_line?"expand":"collapse"),ba.brace_style=b.brace_style?b.brace_style:ba.brace_style?ba.brace_style:"collapse","expand-strict"===ba.brace_style&&(ba.brace_style="expand"),ba.indent_size=b.indent_size?parseInt(b.indent_size,10):4,ba.indent_char=b.indent_char?b.indent_char:" ",ba.eol=b.eol?b.eol:"\n",ba.preserve_newlines=void 0===b.preserve_newlines||b.preserve_newlines,ba.break_chained_methods=void 0!==b.break_chained_methods&&b.break_chained_methods,ba.max_preserve_newlines=void 0===b.max_preserve_newlines?0:parseInt(b.max_preserve_newlines,10),ba.space_in_paren=void 0!==b.space_in_paren&&b.space_in_paren,ba.space_in_empty_paren=void 0!==b.space_in_empty_paren&&b.space_in_empty_paren,ba.jslint_happy=void 0!==b.jslint_happy&&b.jslint_happy,ba.space_after_anon_function=void 0!==b.space_after_anon_function&&b.space_after_anon_function,ba.keep_array_indentation=void 0!==b.keep_array_indentation&&b.keep_array_indentation,ba.space_before_conditional=void 0===b.space_before_conditional||b.space_before_conditional,ba.unescape_strings=void 0!==b.unescape_strings&&b.unescape_strings,ba.wrap_line_length=void 0===b.wrap_line_length?0:parseInt(b.wrap_line_length,10),ba.e4x=void 0!==b.e4x&&b.e4x,ba.end_with_newline=void 0!==b.end_with_newline&&b.end_with_newline,ba.comma_first=void 0!==b.comma_first&&b.comma_first,ba.test_output_raw=void 0!==b.test_output_raw&&b.test_output_raw,ba.jslint_happy&&(ba.space_after_anon_function=!0),b.indent_with_tabs&&(ba.indent_char="\t",ba.indent_size=1),ba.eol=ba.eol.replace(/\\r/,"\r").replace(/\\n/,"\n"),X="";ba.indent_size>0;)X+=ba.indent_char,ba.indent_size-=1;var ea=0;if(a&&a.length){for(;" "===a.charAt(ea)||"\t"===a.charAt(ea);)da+=a.charAt(ea),ea+=1;a=a.substring(ea)}V="TK_START_BLOCK",W="",R=new i(X,da),R.raw=ba.test_output_raw,$=[],s(l.BlockStatement),this.beautify=function(){var b,c;for(T=new j(a,ba,X),ca=T.tokenize(),S=0;b=B();){for(var d=0;d<b.comments_before.length;d++)g(b.comments_before[d]);g(b),W=Y.last_text,V=b.type,Y.last_text=b.text,S+=1}return c=R.get_code(),ba.end_with_newline&&(c+="\n"),"\n"!=ba.eol&&(c=c.replace(/[\n]/g,ba.eol)),c}}function h(a){var b=0,c=-1,d=[],e=!0;this.set_indent=function(d){
b=a.baseIndentLength+d*a.indent_length,c=d},this.get_character_count=function(){return b},this.is_empty=function(){return e},this.last=function(){return this._empty?null:d[d.length-1]},this.push=function(a){d.push(a),b+=a.length,e=!1},this.pop=function(){var a=null;return e||(a=d.pop(),b-=a.length,e=0===d.length),a},this.remove_indent=function(){c>0&&(c-=1,b-=a.indent_length)},this.trim=function(){for(;" "===this.last();){d.pop();b-=1}e=0===d.length},this.toString=function(){var b="";return this._empty||(c>=0&&(b=a.indent_cache[c]),b+=d.join("")),b}}function i(a,b){b=b||"",this.indent_cache=[b],this.baseIndentLength=b.length,this.indent_length=a.length,this.raw=!1;var c=[];this.baseIndentString=b,this.indent_string=a,this.previous_line=null,this.current_line=null,this.space_before_token=!1,this.add_outputline=function(){this.previous_line=this.current_line,this.current_line=new h(this),c.push(this.current_line)},this.add_outputline(),this.get_line_number=function(){return c.length},this.add_new_line=function(a){return(1!==this.get_line_number()||!this.just_added_newline())&&(!(!a&&this.just_added_newline())&&(this.raw||this.add_outputline(),!0))},this.get_code=function(){return c.join("\n").replace(/[\r\n\t ]+$/,"")},this.set_indent=function(a){if(c.length>1){for(;a>=this.indent_cache.length;)this.indent_cache.push(this.indent_cache[this.indent_cache.length-1]+this.indent_string);return this.current_line.set_indent(a),!0}return this.current_line.set_indent(0),!1},this.add_raw_token=function(a){for(var b=0;b<a.newlines;b++)this.add_outputline();this.current_line.push(a.whitespace_before),this.current_line.push(a.text),this.space_before_token=!1},this.add_token=function(a){this.add_space_before_token(),this.current_line.push(a)},this.add_space_before_token=function(){this.space_before_token&&!this.just_added_newline()&&this.current_line.push(" "),this.space_before_token=!1},this.remove_redundant_indentation=function(a){if(!a.multiline_frame&&a.mode!==l.ForInitializer&&a.mode!==l.Conditional)for(var b=a.start_line_index,d=c.length;b<d;)c[b].remove_indent(),b++},this.trim=function(d){for(d=void 0!==d&&d,this.current_line.trim(a,b);d&&c.length>1&&this.current_line.is_empty();)c.pop(),this.current_line=c[c.length-1],this.current_line.trim();this.previous_line=c.length>1?c[c.length-2]:null},this.just_added_newline=function(){return this.current_line.is_empty()},this.just_added_blankline=function(){if(this.just_added_newline()){if(1===c.length)return!0;return c[c.length-2].is_empty()}return!1}}function j(a,b,e){function f(a){if(!a.match(y))return null;var b={};z.lastIndex=0;for(var c=z.exec(a);c;)b[c[1]]=c[2],c=z.exec(a);return b}function g(){var e,g=[];if(p=0,q="",t>=u)return["","TK_EOF"];var y;y=s.length?s[s.length-1]:new m("TK_START_BLOCK","{");var z=a.charAt(t);for(t+=1;c(z,i);){if(k.newline.test(z)?"\n"===z&&"\r"===a.charAt(t-2)||(p+=1,g=[]):g.push(z),t>=u)return["","TK_EOF"];z=a.charAt(t),t+=1}if(g.length&&(q=g.join("")),j.test(z)){var C=!0,D=!0,E=j;for("0"===z&&t<u&&/[Xxo]/.test(a.charAt(t))?(C=!1,D=!1,z+=a.charAt(t),t+=1,E=/[o]/.test(a.charAt(t))?l:n):(z="",t-=1);t<u&&E.test(a.charAt(t));)z+=a.charAt(t),t+=1,C&&t<u&&"."===a.charAt(t)&&(z+=a.charAt(t),t+=1,C=!1),D&&t<u&&/[Ee]/.test(a.charAt(t))&&(z+=a.charAt(t),t+=1,t<u&&/[+-]/.test(a.charAt(t))&&(z+=a.charAt(t),t+=1),D=!1,C=!1);return[z,"TK_WORD"]}if(k.isIdentifierStart(a.charCodeAt(t-1))){if(t<u)for(;k.isIdentifierChar(a.charCodeAt(t))&&(z+=a.charAt(t),(t+=1)!==u););return"TK_DOT"===y.type||"TK_RESERVED"===y.type&&c(y.text,["set","get"])||!c(z,v)?[z,"TK_WORD"]:"in"===z?[z,"TK_OPERATOR"]:[z,"TK_RESERVED"]}if("("===z||"["===z)return[z,"TK_START_EXPR"];if(")"===z||"]"===z)return[z,"TK_END_EXPR"];if("{"===z)return[z,"TK_START_BLOCK"];if("}"===z)return[z,"TK_END_BLOCK"];if(";"===z)return[z,"TK_SEMICOLON"];if("/"===z){var F="";if("*"===a.charAt(t)){t+=1,w.lastIndex=t;var G=w.exec(a);F="/*"+G[0],t+=G[0].length;var H=f(F);return H&&"start"===H.ignore&&(A.lastIndex=t,G=A.exec(a),F+=G[0],t+=G[0].length),F=F.replace(k.lineBreak,"\n"),[F,"TK_BLOCK_COMMENT",H]}if("/"===a.charAt(t)){t+=1,x.lastIndex=t;var G=x.exec(a);return F="//"+G[0],t+=G[0].length,[F,"TK_COMMENT"]}}if("`"===z||"'"===z||'"'===z||("/"===z||b.e4x&&"<"===z&&a.slice(t-1).match(/^<([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/))&&("TK_RESERVED"===y.type&&c(y.text,["return","case","throw","else","do","typeof","yield"])||"TK_END_EXPR"===y.type&&")"===y.text&&y.parent&&"TK_RESERVED"===y.parent.type&&c(y.parent.text,["if","while","for"])||c(y.type,["TK_COMMENT","TK_START_EXPR","TK_START_BLOCK","TK_END_BLOCK","TK_OPERATOR","TK_EQUALS","TK_EOF","TK_SEMICOLON","TK_COMMA"]))){var I=z,J=!1,K=!1;if(e=z,"/"===I)for(var L=!1;t<u&&(J||L||a.charAt(t)!==I)&&!k.newline.test(a.charAt(t));)e+=a.charAt(t),J?J=!1:(J="\\"===a.charAt(t),"["===a.charAt(t)?L=!0:"]"===a.charAt(t)&&(L=!1)),t+=1;else if(b.e4x&&"<"===I){var M=/<(\/?)([-a-zA-Z:0-9_.]+|{[^{}]*}|!\[CDATA\[[\s\S]*?\]\])(\s+[-a-zA-Z:0-9_.]+\s*=\s*('[^']*'|"[^"]*"|{.*?}))*\s*(\/?)\s*>/g,N=a.slice(t-1),O=M.exec(N);if(O&&0===O.index){for(var P=O[2],Q=0;O;){var R=!!O[1],S=O[2],T=!!O[O.length-1]||"![CDATA["===S.slice(0,8);if(S!==P||T||(R?--Q:++Q),Q<=0)break;O=M.exec(N)}var U=O?O.index+O[0].length:N.length;return N=N.slice(0,U),t+=U-1,N=N.replace(k.lineBreak,"\n"),[N,"TK_STRING"]}}else for(;t<u&&(J||a.charAt(t)!==I&&("`"===I||!k.newline.test(a.charAt(t))));)(J||"`"===I)&&k.newline.test(a.charAt(t))?("\r"===a.charAt(t)&&"\n"===a.charAt(t+1)&&(t+=1),e+="\n"):e+=a.charAt(t),J?("x"!==a.charAt(t)&&"u"!==a.charAt(t)||(K=!0),J=!1):J="\\"===a.charAt(t),t+=1;if(K&&b.unescape_strings&&(e=h(e)),t<u&&a.charAt(t)===I&&(e+=I,t+=1,"/"===I))for(;t<u&&k.isIdentifierStart(a.charCodeAt(t));)e+=a.charAt(t),t+=1;return[e,"TK_STRING"]}if("#"===z){if(0===s.length&&"!"===a.charAt(t)){for(e=z;t<u&&"\n"!==z;)z=a.charAt(t),e+=z,t+=1;return[d(e)+"\n","TK_UNKNOWN"]}var V="#";if(t<u&&j.test(a.charAt(t))){do{z=a.charAt(t),V+=z,t+=1}while(t<u&&"#"!==z&&"="!==z);return"#"===z||("["===a.charAt(t)&&"]"===a.charAt(t+1)?(V+="[]",t+=2):"{"===a.charAt(t)&&"}"===a.charAt(t+1)&&(V+="{}",t+=2)),[V,"TK_WORD"]}}if("<"===z&&("?"===a.charAt(t)||"%"===a.charAt(t))){B.lastIndex=t-1;var W=B.exec(a);if(W)return z=W[0],t+=z.length-1,z=z.replace(k.lineBreak,"\n"),[z,"TK_STRING"]}if("<"===z&&"\x3c!--"===a.substring(t-1,t+3)){for(t+=3,z="\x3c!--";!k.newline.test(a.charAt(t))&&t<u;)z+=a.charAt(t),t++;return r=!0,[z,"TK_COMMENT"]}if("-"===z&&r&&"--\x3e"===a.substring(t-1,t+2))return r=!1,t+=2,["--\x3e","TK_COMMENT"];if("."===z)return[z,"TK_DOT"];if(c(z,o)){for(;t<u&&c(z+a.charAt(t),o)&&(z+=a.charAt(t),!((t+=1)>=u)););return","===z?[z,"TK_COMMA"]:"="===z?[z,"TK_EQUALS"]:[z,"TK_OPERATOR"]}return[z,"TK_UNKNOWN"]}function h(a){for(var b,c=!1,d="",e=0,f="",g=0;c||e<a.length;)if(b=a.charAt(e),e++,c){if(c=!1,"x"===b)f=a.substr(e,2),e+=2;else{if("u"!==b){d+="\\"+b;continue}f=a.substr(e,4),e+=4}if(!f.match(/^[0123456789abcdefABCDEF]+$/))return a;if((g=parseInt(f,16))>=0&&g<32){d+="x"===b?"\\x"+f:"\\u"+f;continue}if(34===g||39===g||92===g)d+="\\"+String.fromCharCode(g);else{if("x"===b&&g>126&&g<=255)return a;d+=String.fromCharCode(g)}}else"\\"===b?c=!0:d+=b;return d}var i="\n\r\t ".split(""),j=/[0-9]/,l=/[01234567]/,n=/[0123456789abcdefABCDEF]/,o="+ - * / % & ++ -- = += -= *= /= %= == === != !== > < >= <= >> << >>> >>>= >>= <<= && &= | || ! ~ , : ? ^ ^= |= :: =>".split(" ");this.line_starters="continue,try,throw,return,var,let,const,if,switch,case,default,for,while,break,function,import,export".split(",");var p,q,r,s,t,u,v=this.line_starters.concat(["do","in","else","get","set","new","catch","finally","typeof","yield","async","await"]),w=/([\s\S]*?)((?:\*\/)|$)/g,x=/([^\n\r\u2028\u2029]*)/g,y=/\/\* beautify( \w+[:]\w+)+ \*\//g,z=/ (\w+)[:](\w+)/g,A=/([\s\S]*?)((?:\/\*\sbeautify\signore:end\s\*\/)|$)/g,B=/((<\?php|<\?=)[\s\S]*?\?>)|(<%[\s\S]*?%>)/g;this.tokenize=function(){u=a.length,t=0,r=!1,s=[];for(var b,c,d,e=null,f=[],h=[];!c||"TK_EOF"!==c.type;){for(d=g(),b=new m(d[1],d[0],p,q);"TK_COMMENT"===b.type||"TK_BLOCK_COMMENT"===b.type||"TK_UNKNOWN"===b.type;)"TK_BLOCK_COMMENT"===b.type&&(b.directives=d[2]),h.push(b),d=g(),b=new m(d[1],d[0],p,q);h.length&&(b.comments_before=h,h=[]),"TK_START_BLOCK"===b.type||"TK_START_EXPR"===b.type?(b.parent=c,f.push(e),e=b):("TK_END_BLOCK"===b.type||"TK_END_EXPR"===b.type)&&e&&("]"===b.text&&"["===e.text||")"===b.text&&"("===e.text||"}"===b.text&&"{"===e.text)&&(b.parent=e.parent,e=f.pop()),s.push(b),c=b}return s}}var k={};!function(a){var b="\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc",c="\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f",d=new RegExp("["+b+"]"),e=new RegExp("["+b+c+"]");a.newline=/[\n\r\u2028\u2029]/,a.lineBreak=new RegExp("\r\n|"+a.newline.source),a.allLineBreaks=new RegExp(a.lineBreak.source,"g"),a.isIdentifierStart=function(a){return a<65?36===a||64===a:a<91||(a<97?95===a:a<123||a>=170&&d.test(String.fromCharCode(a)))},a.isIdentifierChar=function(a){return a<48?36===a:a<58||!(a<65)&&(a<91||(a<97?95===a:a<123||a>=170&&e.test(String.fromCharCode(a))))}}(k);var l={BlockStatement:"BlockStatement",Statement:"Statement",ObjectLiteral:"ObjectLiteral",ArrayLiteral:"ArrayLiteral",ForInitializer:"ForInitializer",Conditional:"Conditional",Expression:"Expression"},m=function(a,b,c,d,e,f){this.type=a,this.text=b,this.comments_before=[],this.newlines=c||0,this.wanted_newline=c>0,this.whitespace_before=d||"",this.parent=null,this.directives=null};return{run:a}},a.extend(a.FE.DEFAULTS,{codeMirror:window.CodeMirror,codeMirrorOptions:{lineNumbers:!0,tabMode:"indent",indentWithTabs:!0,lineWrapping:!0,mode:"text/html",tabSize:2},codeBeautifierOptions:{end_with_newline:!0,indent_inner_html:!0,extra_liners:["p","h1","h2","h3","h4","h5","h6","blockquote","pre","ul","ol","table","dl"],brace_style:"expand",indent_char:"\t",indent_size:1,wrap_line_length:0},codeViewKeepActiveButtons:["fullscreen"]}),a.FE.PLUGINS.codeView=function(b){function c(){return b.$box.hasClass("fr-code-view")}function d(){return l?l.getValue():k.val()}function e(a){var c=d();b.html.set(c),b.$el.blur(),b.$tb.find(" > .fr-command").not(a).removeClass("fr-disabled").attr("aria-disabled",!1),a.removeClass("fr-active").attr("aria-pressed",!1),b.selection.setAtStart(b.el),b.selection.restore(),b.placeholder.refresh(),b.undo.saveStep()}function f(c){k||(i(),!l&&b.opts.codeMirror?l=b.opts.codeMirror.fromTextArea(k.get(0),b.opts.codeMirrorOptions):b.events.$on(k,"keydown keyup change input",function(){b.opts.height?this.removeAttribute("rows"):(this.rows=1,0===this.value.length?this.style.height="auto":this.style.height=this.scrollHeight+"px")})),b.undo.saveStep(),b.html.cleanEmptyTags(),b.html.cleanWhiteTags(!0),b.core.hasFocus()&&(b.core.isEmpty()||(b.selection.save(),b.$el.find('.fr-marker[data-type="true"]:first').replaceWith('<span class="fr-tmp fr-sm">F</span>'),b.$el.find('.fr-marker[data-type="false"]:last').replaceWith('<span class="fr-tmp fr-em">F</span>')));var d=b.html.get(!1,!0);b.$el.find("span.fr-tmp").remove(),b.$box.toggleClass("fr-code-view",!0),b.core.hasFocus()&&b.$el.blur(),d=d.replace(/<span class="fr-tmp fr-sm">F<\/span>/,"FROALA-SM"),d=d.replace(/<span class="fr-tmp fr-em">F<\/span>/,"FROALA-EM"),b.codeBeautifier&&(d=b.codeBeautifier.run(d,b.opts.codeBeautifierOptions));var e,f;if(l){e=d.indexOf("FROALA-SM"),f=d.indexOf("FROALA-EM"),e>f?e=f:f-=9,d=d.replace(/FROALA-SM/g,"").replace(/FROALA-EM/g,"");var g=d.substring(0,e).length-d.substring(0,e).replace(/\n/g,"").length,h=d.substring(0,f).length-d.substring(0,f).replace(/\n/g,"").length;e=d.substring(0,e).length-d.substring(0,d.substring(0,e).lastIndexOf("\n")+1).length,f=d.substring(0,f).length-d.substring(0,d.substring(0,f).lastIndexOf("\n")+1).length,l.setSize(null,b.opts.height?b.opts.height:"auto"),b.opts.heightMin&&b.$box.find(".CodeMirror-scroll").css("min-height",b.opts.heightMin),l.setValue(d),l.focus(),l.setSelection({line:g,ch:e},{line:h,ch:f}),l.refresh(),l.clearHistory()}else{e=d.indexOf("FROALA-SM"),f=d.indexOf("FROALA-EM")-9,b.opts.heightMin&&k.css("min-height",b.opts.heightMin),b.opts.height&&k.css("height",b.opts.height),b.opts.heightMax&&k.css("max-height",b.opts.height||b.opts.heightMax),k.val(d.replace(/FROALA-SM/g,"").replace(/FROALA-EM/g,"")).trigger("change");var j=a(b.o_doc).scrollTop();k.focus(),k.get(0).setSelectionRange(e,f),a(b.o_doc).scrollTop(j)}b.$tb.find(" > .fr-command").not(c).filter(function(){return b.opts.codeViewKeepActiveButtons.indexOf(a(this).data("cmd"))<0}).addClass("fr-disabled").attr("aria-disabled",!0),c.addClass("fr-active").attr("aria-pressed",!0),!b.helpers.isMobile()&&b.opts.toolbarInline&&b.toolbar.hide()}function g(a){void 0===a&&(a=!c());var d=b.$tb.find('.fr-command[data-cmd="html"]');a?(b.popups.hideAll(),f(d)):(b.$box.toggleClass("fr-code-view",!1),e(d))}function h(){c()&&g(!1),l&&l.toTextArea(),k.val("").removeData().remove(),k=null,m&&(m.remove(),m=null)}function i(){k=a('<textarea class="fr-code" tabIndex="-1">'),b.$wp.append(k),k.attr("dir",b.opts.direction),b.$box.hasClass("fr-basic")||(m=a('<a data-cmd="html" title="Code View" class="fr-command fr-btn html-switch'+(b.helpers.isMobile()?"":" fr-desktop")+'" role="button" tabIndex="-1"><i class="fa fa-code"></i></button>'),b.$box.append(m),b.events.bindClick(b.$box,"a.html-switch",function(){g(!1)}));var e=function(){return!c()};b.events.on("buttons.refresh",e),b.events.on("copy",e,!0),b.events.on("cut",e,!0),b.events.on("paste",e,!0),b.events.on("destroy",h,!0),b.events.on("html.set",function(){c()&&g(!0)}),b.events.on("form.submit",function(){c()&&(b.html.set(d()),b.events.trigger("contentChanged",[],!0))},!0)}function j(){if(!b.$wp)return!1}var k,l,m;return{_init:j,toggle:g,isActive:c,get:d}},a.FE.RegisterCommand("html",{title:"Code View",undo:!1,focus:!1,forcedRefresh:!0,toggle:!0,callback:function(){this.codeView.toggle()},plugin:"codeView"}),a.FE.DefineIcon("html",{NAME:"code"}),a.extend(a.FE.POPUP_TEMPLATES,{"colors.picker":"[_BUTTONS_][_TEXT_COLORS_][_BACKGROUND_COLORS_][_CUSTOM_COLOR_]"}),a.extend(a.FE.DEFAULTS,{colorsText:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],colorsBackground:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],colorsStep:7,colorsHEXInput:!0,colorsDefaultTab:"text",colorsButtons:["colorsBack","|","-"]}),a.FE.PLUGINS.colors=function(b){function c(){var a=b.$tb.find('.fr-command[data-cmd="color"]'),c=b.popups.get("colors.picker");if(c||(c=e()),!c.hasClass("fr-active"))if(b.popups.setContainer("colors.picker",b.$tb),i(c.find(".fr-selected-tab").attr("data-param1")),a.is(":visible")){var d=a.offset().left+a.outerWidth()/2,f=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show("colors.picker",d,f,a.outerHeight())}else b.position.forSelection(c),b.popups.show("colors.picker")}function d(){b.popups.hide("colors.picker")}function e(){var a='<div class="fr-buttons fr-colors-buttons">';b.opts.toolbarInline&&b.opts.colorsButtons.length>0&&(a+=b.button.buildList(b.opts.colorsButtons)),a+=f()+"</div>";var c="";b.opts.colorsHEXInput&&(c='<div class="fr-color-hex-layer fr-active fr-layer" id="fr-color-hex-layer-'+b.id+'"><div class="fr-input-line"><input maxlength="7" id="fr-color-hex-layer-text-'+b.id+'" type="text" placeholder="'+b.language.translate("HEX Color")+'" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="customColor" tabIndex="2" role="button">'+b.language.translate("OK")+"</button></div></div>");var d={buttons:a,text_colors:g("text"),background_colors:g("background"),custom_color:c},e=b.popups.create("colors.picker",d);return h(e),e}function f(){var a='<div class="fr-colors-tabs fr-group">';return a+='<span class="fr-colors-tab '+("background"==b.opts.colorsDefaultTab?"":"fr-selected-tab ")+'fr-command" tabIndex="-1" role="button" aria-pressed="'+("background"!=b.opts.colorsDefaultTab)+'" data-param1="text" data-cmd="colorChangeSet" title="'+b.language.translate("Text")+'">'+b.language.translate("Text")+"</span>",(a+='<span class="fr-colors-tab '+("background"==b.opts.colorsDefaultTab?"fr-selected-tab ":"")+'fr-command" tabIndex="-1" role="button" aria-pressed="'+("background"==b.opts.colorsDefaultTab)+'" data-param1="background" data-cmd="colorChangeSet" title="'+b.language.translate("Background")+'">'+b.language.translate("Background")+"</span>")+"</div>"}function g(a){for(var c="text"==a?b.opts.colorsText:b.opts.colorsBackground,d='<div class="fr-color-set fr-'+a+"-color"+(b.opts.colorsDefaultTab==a||"text"!=b.opts.colorsDefaultTab&&"background"!=b.opts.colorsDefaultTab&&"text"==a?" fr-selected-set":"")+'">',e=0;e<c.length;e++)0!==e&&e%b.opts.colorsStep==0&&(d+="<br>"),"REMOVE"!=c[e]?d+='<span class="fr-command fr-select-color" style="background: '+c[e]+';" tabIndex="-1" aria-selected="false" role="button" data-cmd="'+a+'Color" data-param1="'+c[e]+'"><span class="fr-sr-only">'+b.language.translate("Color")+" "+c[e]+"&nbsp;&nbsp;&nbsp;</span></span>":d+='<span class="fr-command fr-select-color" data-cmd="'+a+'Color" tabIndex="-1" role="button" data-param1="REMOVE" title="'+b.language.translate("Clear Formatting")+'">'+b.icon.create("remove")+'<span class="fr-sr-only">'+b.language.translate("Clear Formatting")+"</span></span>";return d+"</div>"}function h(c){b.events.on("popup.tab",function(d){var e=a(d.currentTarget);if(!b.popups.isVisible("colors.picker")||!e.is("span"))return!0;var f=d.which,g=!0;if(a.FE.KEYCODE.TAB==f){var h=c.find(".fr-buttons");g=!b.accessibility.focusToolbar(h,!!d.shiftKey)}else if(a.FE.KEYCODE.ARROW_UP==f||a.FE.KEYCODE.ARROW_DOWN==f||a.FE.KEYCODE.ARROW_LEFT==f||a.FE.KEYCODE.ARROW_RIGHT==f){if(e.is("span.fr-select-color")){var i=e.parent().find("span.fr-select-color"),j=i.index(e),k=b.opts.colorsStep,l=Math.floor(i.length/k),m=j%k,n=Math.floor(j/k),o=n*k+m,p=l*k;a.FE.KEYCODE.ARROW_UP==f?o=((o-k)%p+p)%p:a.FE.KEYCODE.ARROW_DOWN==f?o=(o+k)%p:a.FE.KEYCODE.ARROW_LEFT==f?o=((o-1)%p+p)%p:a.FE.KEYCODE.ARROW_RIGHT==f&&(o=(o+1)%p);var q=a(i.get(o));b.events.disableBlur(),q.focus(),g=!1}}else a.FE.KEYCODE.ENTER==f&&(b.button.exec(e),g=!1);return!1===g&&(d.preventDefault(),d.stopPropagation()),g},!0)}function i(c){var d,e=b.popups.get("colors.picker"),f=a(b.selection.element());d="background"==c?"background-color":"color";var g=e.find(".fr-"+c+"-color .fr-select-color");for(g.find(".fr-selected-color").remove(),g.removeClass("fr-active-item"),g.not('[data-param1="REMOVE"]').attr("aria-selected",!1);f.get(0)!=b.el;){if("transparent"!=f.css(d)&&"rgba(0, 0, 0, 0)"!=f.css(d)){var h=e.find(".fr-"+c+'-color .fr-select-color[data-param1="'+b.helpers.RGBToHex(f.css(d))+'"]');h.append('<span class="fr-selected-color" aria-hidden="true">\uf00c</span>'),h.addClass("fr-active-item").attr("aria-selected",!0);break}f=f.parent()}var i=e.find(".fr-color-hex-layer input");i.length&&i.val(b.helpers.RGBToHex(f.css(d))).trigger("change")}function j(a,c){a.hasClass("fr-selected-tab")||(a.siblings().removeClass("fr-selected-tab").attr("aria-pressed",!1),a.addClass("fr-selected-tab").attr("aria-pressed",!0),a.parents(".fr-popup").find(".fr-color-set").removeClass("fr-selected-set"),a.parents(".fr-popup").find(".fr-color-set.fr-"+c+"-color").addClass("fr-selected-set"),i(c)),b.accessibility.focusPopup(a.parents(".fr-popup"))}function k(a){"REMOVE"!=a?b.format.applyStyle("background-color",b.helpers.HEXtoRGB(a)):b.format.removeStyle("background-color"),d()}function l(a){"REMOVE"!=a?b.format.applyStyle("color",b.helpers.HEXtoRGB(a)):b.format.removeStyle("color"),d()}function m(){b.popups.hide("colors.picker"),b.toolbar.showInline()}function n(){var a=b.popups.get("colors.picker"),c=a.find(".fr-color-hex-layer input");if(c.length){var d=c.val();"background"==a.find(".fr-selected-tab").attr("data-param1")?k(d):l(d)}}return{showColorsPopup:c,hideColorsPopup:d,changeSet:j,background:k,customColor:n,text:l,back:m}},a.FE.DefineIcon("colors",{NAME:"tint"}),a.FE.RegisterCommand("color",{title:"Colors",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("colors.picker")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("colors.picker")):this.colors.showColorsPopup()},plugin:"colors"}),a.FE.RegisterCommand("textColor",{undo:!0,callback:function(a,b){this.colors.text(b)}}),a.FE.RegisterCommand("backgroundColor",{undo:!0,callback:function(a,b){this.colors.background(b)}}),a.FE.RegisterCommand("colorChangeSet",{undo:!1,focus:!1,callback:function(a,b){var c=this.popups.get("colors.picker").find('.fr-command[data-cmd="'+a+'"][data-param1="'+b+'"]');this.colors.changeSet(c,b)}}),a.FE.DefineIcon("colorsBack",{NAME:"arrow-left"}),a.FE.RegisterCommand("colorsBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.colors.back()}}),a.FE.RegisterCommand("customColor",{title:"OK",undo:!0,callback:function(){this.colors.customColor()}}),a.FE.DefineIcon("remove",{NAME:"eraser"}),a.extend(a.FE.DEFAULTS,{dragInline:!0}),a.FE.PLUGINS.draggable=function(b){function c(c){return!(!c.originalEvent||!c.originalEvent.target||c.originalEvent.target.nodeType!=Node.TEXT_NODE)||(c.target&&"A"==c.target.tagName&&1==c.target.childNodes.length&&"IMG"==c.target.childNodes[0].tagName&&(c.target=c.target.childNodes[0]),a(c.target).hasClass("fr-draggable")?(b.undo.canDo()||b.undo.saveStep(),b.opts.dragInline?b.$el.attr("contenteditable",!0):b.$el.attr("contenteditable",!1),b.opts.toolbarInline&&b.toolbar.hide(),a(c.target).addClass("fr-dragging"),b.browser.msie||b.browser.edge||b.selection.clear(),void c.originalEvent.dataTransfer.setData("text","Froala")):(c.preventDefault(),!1))}function d(a){return!(a&&("HTML"==a.tagName||"BODY"==a.tagName||b.node.isElement(a)))}function e(a,c,d){b.opts.iframe&&(a+=b.$iframe.offset().top,c+=b.$iframe.offset().left),n.offset().top!=a&&n.css("top",a),n.offset().left!=c&&n.css("left",c),n.width()!=d&&n.css("width",d)}function f(c){var f=b.doc.elementFromPoint(c.originalEvent.pageX-b.win.pageXOffset,c.originalEvent.pageY-b.win.pageYOffset);if(!d(f)){for(var g=0,h=f;!d(h)&&h==f&&c.originalEvent.pageY-b.win.pageYOffset-g>0;)g++,h=b.doc.elementFromPoint(c.originalEvent.pageX-b.win.pageXOffset,c.originalEvent.pageY-b.win.pageYOffset-g);(!d(h)||n&&0===b.$el.find(h).length&&h!=n.get(0))&&(h=null);for(var i=0,j=f;!d(j)&&j==f&&c.originalEvent.pageY-b.win.pageYOffset+i<a(b.doc).height();)i++,j=b.doc.elementFromPoint(c.originalEvent.pageX-b.win.pageXOffset,c.originalEvent.pageY-b.win.pageYOffset+i);(!d(j)||n&&0===b.$el.find(j).length&&j!=n.get(0))&&(j=null),f=null==j&&h?h:j&&null==h?j:j&&h?g<i?h:j:null}if(a(f).hasClass("fr-drag-helper"))return!1;if(f&&!b.node.isBlock(f)&&(f=b.node.blockParent(f)),f&&["TD","TH","TR","THEAD","TBODY"].indexOf(f.tagName)>=0&&(f=a(f).parents("table").get(0)),f&&["LI"].indexOf(f.tagName)>=0&&(f=a(f).parents("UL, OL").get(0)),f&&!a(f).hasClass("fr-drag-helper")){n||(a.FE.$draggable_helper||(a.FE.$draggable_helper=a('<div class="fr-drag-helper"></div>')),n=a.FE.$draggable_helper,b.events.on("shared.destroy",function(){n.html("").removeData().remove(),n=null},!0));var k;k=c.originalEvent.pageY<a(f).offset().top+a(f).outerHeight()/2;var l=a(f),m=0;k||0!==l.next().length?(k||(l=l.next()),"before"==n.data("fr-position")&&l.is(n.data("fr-tag"))||(l.prev().length>0&&(m=parseFloat(l.prev().css("margin-bottom"))||0),m=Math.max(m,parseFloat(l.css("margin-top"))||0),e(l.offset().top-m/2-b.$box.offset().top,l.offset().left-b.win.pageXOffset-b.$box.offset().left,l.width()),n.data("fr-position","before"))):"after"==n.data("fr-position")&&l.is(n.data("fr-tag"))||(m=parseFloat(l.css("margin-bottom"))||0,e(l.offset().top+a(f).height()+m/2-b.$box.offset().top,l.offset().left-b.win.pageXOffset-b.$box.offset().left,l.width()),n.data("fr-position","after")),n.data("fr-tag",l),n.addClass("fr-visible"),n.appendTo(b.$box)}else n&&b.$box.find(n).length>0&&n.removeClass("fr-visible")}function g(a){a.originalEvent.dataTransfer.dropEffect="move",b.opts.dragInline?j()||!b.browser.msie&&!b.browser.edge||a.preventDefault():(a.preventDefault(),f(a))}function h(a){a.originalEvent.dataTransfer.dropEffect="move",b.opts.dragInline||a.preventDefault()}function i(a){b.$el.attr("contenteditable",!0);var c=b.$el.find(".fr-dragging");n&&n.hasClass("fr-visible")&&b.$box.find(n).length?k(a):c.length&&(a.preventDefault(),a.stopPropagation()),n&&b.$box.find(n).length&&n.removeClass("fr-visible"),c.removeClass("fr-dragging")}function j(){for(var b=null,c=0;c<a.FE.INSTANCES.length;c++)if(b=a.FE.INSTANCES[c].$el.find(".fr-dragging"),b.length)return b.get(0)}function k(c){for(var d,e,f=0;f<a.FE.INSTANCES.length;f++)if(d=a.FE.INSTANCES[f].$el.find(".fr-dragging"),d.length){e=a.FE.INSTANCES[f];break}if(d.length){if(c.preventDefault(),c.stopPropagation(),n&&n.hasClass("fr-visible")&&b.$box.find(n).length)n.data("fr-tag")[n.data("fr-position")]('<span class="fr-marker"></span>'),n.removeClass("fr-visible");else{if(!1===b.markers.insertAtPoint(c.originalEvent))return!1}if(d.removeClass("fr-dragging"),!1===(d=b.events.chainTrigger("element.beforeDrop",d)))return!1;var g=d;if(d.parent().is("A")&&(g=d.parent()),b.core.isEmpty())b.events.focus();else{
b.$el.find(".fr-marker").replaceWith(a.FE.MARKERS),b.selection.restore()}if(e==b||b.undo.canDo()||b.undo.saveStep(),b.core.isEmpty())b.$el.html(g);else{var h=b.markers.insert();0===g.find(h).length?a(h).replaceWith(g):a(h).replaceWith(d),d.after(a.FE.MARKERS),b.selection.restore()}return b.popups.hideAll(),b.selection.save(),b.$el.find(b.html.emptyBlockTagsQuery()).not("TD, TH, LI, .fr-inner").remove(),b.html.wrap(),b.html.fillEmptyBlocks(),b.selection.restore(),b.undo.saveStep(),b.opts.iframe&&b.size.syncIframe(),e!=b&&(e.popups.hideAll(),e.$el.find(e.html.emptyBlockTagsQuery()).not("TD, TH, LI, .fr-inner").remove(),e.html.wrap(),e.html.fillEmptyBlocks(),e.undo.saveStep(),e.events.trigger("element.dropped"),e.opts.iframe&&e.size.syncIframe()),b.events.trigger("element.dropped",[g]),!1}n&&n.removeClass("fr-visible"),b.undo.canDo()||b.undo.saveStep(),setTimeout(function(){b.undo.saveStep()},0)}function l(a){if(a&&"DIV"==a.tagName&&b.node.hasClass(a,"fr-drag-helper"))a.parentNode.removeChild(a);else if(a&&a.nodeType==Node.ELEMENT_NODE)for(var c=a.querySelectorAll("div.fr-drag-helper"),d=0;d<c.length;d++)c[d].parentNode.removeChild(c[d])}function m(){b.opts.enter==a.FE.ENTER_BR&&(b.opts.dragInline=!0),b.events.on("dragstart",c,!0),b.events.on("dragover",g,!0),b.events.on("dragenter",h,!0),b.events.on("document.dragend",i,!0),b.events.on("document.drop",i,!0),b.events.on("drop",k,!0),b.events.on("html.processGet",l)}var n;return{_init:m}},a.extend(a.FE.POPUP_TEMPLATES,{emoticons:"[_BUTTONS_][_EMOTICONS_]"}),a.extend(a.FE.DEFAULTS,{emoticonsStep:8,emoticonsSet:[{code:"1f600",desc:"Grinning face"},{code:"1f601",desc:"Grinning face with smiling eyes"},{code:"1f602",desc:"Face with tears of joy"},{code:"1f603",desc:"Smiling face with open mouth"},{code:"1f604",desc:"Smiling face with open mouth and smiling eyes"},{code:"1f605",desc:"Smiling face with open mouth and cold sweat"},{code:"1f606",desc:"Smiling face with open mouth and tightly-closed eyes"},{code:"1f607",desc:"Smiling face with halo"},{code:"1f608",desc:"Smiling face with horns"},{code:"1f609",desc:"Winking face"},{code:"1f60a",desc:"Smiling face with smiling eyes"},{code:"1f60b",desc:"Face savoring delicious food"},{code:"1f60c",desc:"Relieved face"},{code:"1f60d",desc:"Smiling face with heart-shaped eyes"},{code:"1f60e",desc:"Smiling face with sunglasses"},{code:"1f60f",desc:"Smirking face"},{code:"1f610",desc:"Neutral face"},{code:"1f611",desc:"Expressionless face"},{code:"1f612",desc:"Unamused face"},{code:"1f613",desc:"Face with cold sweat"},{code:"1f614",desc:"Pensive face"},{code:"1f615",desc:"Confused face"},{code:"1f616",desc:"Confounded face"},{code:"1f617",desc:"Kissing face"},{code:"1f618",desc:"Face throwing a kiss"},{code:"1f619",desc:"Kissing face with smiling eyes"},{code:"1f61a",desc:"Kissing face with closed eyes"},{code:"1f61b",desc:"Face with stuck out tongue"},{code:"1f61c",desc:"Face with stuck out tongue and winking eye"},{code:"1f61d",desc:"Face with stuck out tongue and tightly-closed eyes"},{code:"1f61e",desc:"Disappointed face"},{code:"1f61f",desc:"Worried face"},{code:"1f620",desc:"Angry face"},{code:"1f621",desc:"Pouting face"},{code:"1f622",desc:"Crying face"},{code:"1f623",desc:"Persevering face"},{code:"1f624",desc:"Face with look of triumph"},{code:"1f625",desc:"Disappointed but relieved face"},{code:"1f626",desc:"Frowning face with open mouth"},{code:"1f627",desc:"Anguished face"},{code:"1f628",desc:"Fearful face"},{code:"1f629",desc:"Weary face"},{code:"1f62a",desc:"Sleepy face"},{code:"1f62b",desc:"Tired face"},{code:"1f62c",desc:"Grimacing face"},{code:"1f62d",desc:"Loudly crying face"},{code:"1f62e",desc:"Face with open mouth"},{code:"1f62f",desc:"Hushed face"},{code:"1f630",desc:"Face with open mouth and cold sweat"},{code:"1f631",desc:"Face screaming in fear"},{code:"1f632",desc:"Astonished face"},{code:"1f633",desc:"Flushed face"},{code:"1f634",desc:"Sleeping face"},{code:"1f635",desc:"Dizzy face"},{code:"1f636",desc:"Face without mouth"},{code:"1f637",desc:"Face with medical mask"}],emoticonsButtons:["emoticonsBack","|"],emoticonsUseImage:!0}),a.FE.PLUGINS.emoticons=function(b){function c(){var a=b.$tb.find('.fr-command[data-cmd="emoticons"]'),c=b.popups.get("emoticons");if(c||(c=e()),!c.hasClass("fr-active")){b.popups.refresh("emoticons"),b.popups.setContainer("emoticons",b.$tb);var d=a.offset().left+a.outerWidth()/2,f=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show("emoticons",d,f,a.outerHeight())}}function d(){b.popups.hide("emoticons")}function e(){var a="";b.opts.toolbarInline&&b.opts.emoticonsButtons.length>0&&(a='<div class="fr-buttons fr-emoticons-buttons">'+b.button.buildList(b.opts.emoticonsButtons)+"</div>");var c={buttons:a,emoticons:g()},d=b.popups.create("emoticons",c);return b.tooltip.bind(d,".fr-emoticon"),h(d),d}function f(){if(!b.selection.isCollapsed())return!1;var a=b.selection.element(),c=b.selection.endElement();if(a&&b.node.hasClass(a,"fr-emoticon"))return a;if(c&&b.node.hasClass(c,"fr-emoticon"))return c;var d=b.selection.ranges(0),e=d.startContainer;if(e.nodeType==Node.ELEMENT_NODE&&e.childNodes.length>0&&d.startOffset>0){var f=e.childNodes[d.startOffset-1];if(b.node.hasClass(f,"fr-emoticon"))return f}return!1}function g(){for(var a='<div style="text-align: center">',c=0;c<b.opts.emoticonsSet.length;c++)0!==c&&c%b.opts.emoticonsStep==0&&(a+="<br>"),a+='<span class="fr-command fr-emoticon" tabIndex="-1" data-cmd="insertEmoticon" title="'+b.language.translate(b.opts.emoticonsSet[c].desc)+'" role="button" data-param1="'+b.opts.emoticonsSet[c].code+'">'+(b.opts.emoticonsUseImage?'<img src="https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/'+b.opts.emoticonsSet[c].code+'.svg"/>':"&#x"+b.opts.emoticonsSet[c].code+";")+'<span class="fr-sr-only">'+b.language.translate(b.opts.emoticonsSet[c].desc)+"&nbsp;&nbsp;&nbsp;</span></span>";return b.opts.emoticonsUseImage&&(a+='<p style="font-size: 12px; text-align: center; padding: 0 5px;">Emoji free by <a class="fr-link" tabIndex="-1" href="http://emojione.com/" target="_blank" rel="nofollow" role="link" aria-label="Open Emoji One website.">Emoji One</a></p>'),a+="</div>"}function h(c){b.events.on("popup.tab",function(d){var e=a(d.currentTarget);if(!b.popups.isVisible("emoticons")||!e.is("span, a"))return!0;var f,g,h,i=d.which;if(a.FE.KEYCODE.TAB==i){if(e.is("span.fr-emoticon")&&d.shiftKey||e.is("a")&&!d.shiftKey){var j=c.find(".fr-buttons");f=!b.accessibility.focusToolbar(j,!!d.shiftKey)}if(!1!==f){var k=c.find("span.fr-emoticon:focus:first, span.fr-emoticon:visible:first, a");e.is("span.fr-emoticon")&&(k=k.not("span.fr-emoticon:not(:focus)")),g=k.index(e),g=d.shiftKey?((g-1)%k.length+k.length)%k.length:(g+1)%k.length,h=k.get(g),b.events.disableBlur(),h.focus(),f=!1}}else if(a.FE.KEYCODE.ARROW_UP==i||a.FE.KEYCODE.ARROW_DOWN==i||a.FE.KEYCODE.ARROW_LEFT==i||a.FE.KEYCODE.ARROW_RIGHT==i){if(e.is("span.fr-emoticon")){var l=e.parent().find("span.fr-emoticon");g=l.index(e);var m=b.opts.emoticonsStep,n=Math.floor(l.length/m),o=g%m,p=Math.floor(g/m),q=p*m+o,r=n*m;a.FE.KEYCODE.ARROW_UP==i?q=((q-m)%r+r)%r:a.FE.KEYCODE.ARROW_DOWN==i?q=(q+m)%r:a.FE.KEYCODE.ARROW_LEFT==i?q=((q-1)%r+r)%r:a.FE.KEYCODE.ARROW_RIGHT==i&&(q=(q+1)%r),h=a(l.get(q)),b.events.disableBlur(),h.focus(),f=!1}}else a.FE.KEYCODE.ENTER==i&&(e.is("a")?e[0].click():b.button.exec(e),f=!1);return!1===f&&(d.preventDefault(),d.stopPropagation()),f},!0)}function i(c,d){var e=f(),g=b.selection.ranges(0);e?(0===g.startOffset&&b.selection.element()===e?a(e).before(a.FE.MARKERS+a.FE.INVISIBLE_SPACE):g.startOffset>0&&b.selection.element()===e&&g.commonAncestorContainer.parentNode.classList.contains("fr-emoticon")&&a(e).after(a.FE.INVISIBLE_SPACE+a.FE.MARKERS),b.selection.restore(),b.html.insert('<span class="fr-emoticon fr-deletable'+(d?" fr-emoticon-img":"")+'"'+(d?' style="background: url('+d+');"':"")+">"+(d?"&nbsp;":c)+"</span>&nbsp;"+a.FE.MARKERS,!0)):b.html.insert('<span class="fr-emoticon fr-deletable'+(d?" fr-emoticon-img":"")+'"'+(d?' style="background: url('+d+');"':"")+">"+(d?"&nbsp;":c)+"</span>&nbsp;",!0)}function j(){b.popups.hide("emoticons"),b.toolbar.showInline()}function k(){var c=function(){for(var a=b.el.querySelectorAll(".fr-emoticon:not(.fr-deletable)"),c=0;c<a.length;c++)a[c].className+=" fr-deletable"};c(),b.events.on("html.set",c),b.events.on("keydown",function(c){if(b.keys.isCharacter(c.which)&&b.selection.inEditor()){var d=b.selection.ranges(0),e=f();b.node.hasClass(e,"fr-emoticon-img")&&e&&(0===d.startOffset&&b.selection.element()===e?a(e).before(a.FE.MARKERS+a.FE.INVISIBLE_SPACE):a(e).after(a.FE.INVISIBLE_SPACE+a.FE.MARKERS),b.selection.restore())}}),b.events.on("keyup",function(c){for(var d=b.el.querySelectorAll(".fr-emoticon"),e=0;e<d.length;e++)void 0!==d[e].textContent&&0===d[e].textContent.replace(/\u200B/gi,"").length&&a(d[e]).remove();if(!(c.which>=a.FE.KEYCODE.ARROW_LEFT&&c.which<=a.FE.KEYCODE.ARROW_DOWN)){var g=f();b.node.hasClass(g,"fr-emoticon-img")&&(a(g).append(a.FE.MARKERS),b.selection.restore())}})}return{_init:k,insert:i,showEmoticonsPopup:c,hideEmoticonsPopup:d,back:j}},a.FE.DefineIcon("emoticons",{NAME:"smile-o"}),a.FE.RegisterCommand("emoticons",{title:"Emoticons",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("emoticons")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("emoticons")):this.emoticons.showEmoticonsPopup()},plugin:"emoticons"}),a.FE.RegisterCommand("insertEmoticon",{callback:function(a,b){this.emoticons.insert("&#x"+b+";",this.opts.emoticonsUseImage?"https://cdnjs.cloudflare.com/ajax/libs/emojione/2.0.1/assets/svg/"+b+".svg":null),this.emoticons.hideEmoticonsPopup()}}),a.FE.DefineIcon("emoticonsBack",{NAME:"arrow-left"}),a.FE.RegisterCommand("emoticonsBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.emoticons.back()}}),a.extend(a.FE.DEFAULTS,{entities:"&quot;&#39;&iexcl;&cent;&pound;&curren;&yen;&brvbar;&sect;&uml;&copy;&ordf;&laquo;&not;&shy;&reg;&macr;&deg;&plusmn;&sup2;&sup3;&acute;&micro;&para;&middot;&cedil;&sup1;&ordm;&raquo;&frac14;&frac12;&frac34;&iquest;&Agrave;&Aacute;&Acirc;&Atilde;&Auml;&Aring;&AElig;&Ccedil;&Egrave;&Eacute;&Ecirc;&Euml;&Igrave;&Iacute;&Icirc;&Iuml;&ETH;&Ntilde;&Ograve;&Oacute;&Ocirc;&Otilde;&Ouml;&times;&Oslash;&Ugrave;&Uacute;&Ucirc;&Uuml;&Yacute;&THORN;&szlig;&agrave;&aacute;&acirc;&atilde;&auml;&aring;&aelig;&ccedil;&egrave;&eacute;&ecirc;&euml;&igrave;&iacute;&icirc;&iuml;&eth;&ntilde;&ograve;&oacute;&ocirc;&otilde;&ouml;&divide;&oslash;&ugrave;&uacute;&ucirc;&uuml;&yacute;&thorn;&yuml;&OElig;&oelig;&Scaron;&scaron;&Yuml;&fnof;&circ;&tilde;&Alpha;&Beta;&Gamma;&Delta;&Epsilon;&Zeta;&Eta;&Theta;&Iota;&Kappa;&Lambda;&Mu;&Nu;&Xi;&Omicron;&Pi;&Rho;&Sigma;&Tau;&Upsilon;&Phi;&Chi;&Psi;&Omega;&alpha;&beta;&gamma;&delta;&epsilon;&zeta;&eta;&theta;&iota;&kappa;&lambda;&mu;&nu;&xi;&omicron;&pi;&rho;&sigmaf;&sigma;&tau;&upsilon;&phi;&chi;&psi;&omega;&thetasym;&upsih;&piv;&ensp;&emsp;&thinsp;&zwnj;&zwj;&lrm;&rlm;&ndash;&mdash;&lsquo;&rsquo;&sbquo;&ldquo;&rdquo;&bdquo;&dagger;&Dagger;&bull;&hellip;&permil;&prime;&Prime;&lsaquo;&rsaquo;&oline;&frasl;&euro;&image;&weierp;&real;&trade;&alefsym;&larr;&uarr;&rarr;&darr;&harr;&crarr;&lArr;&uArr;&rArr;&dArr;&hArr;&forall;&part;&exist;&empty;&nabla;&isin;&notin;&ni;&prod;&sum;&minus;&lowast;&radic;&prop;&infin;&ang;&and;&or;&cap;&cup;&int;&there4;&sim;&cong;&asymp;&ne;&equiv;&le;&ge;&sub;&sup;&nsub;&sube;&supe;&oplus;&otimes;&perp;&sdot;&lceil;&rceil;&lfloor;&rfloor;&lang;&rang;&loz;&spades;&clubs;&hearts;&diams;"}),a.FE.PLUGINS.entities=function(b){function c(a){var b=a.textContent;if(b.match(g)){for(var c="",d=0;d<b.length;d++)h[b[d]]?c+=h[b[d]]:c+=b[d];a.textContent=c}}function d(a){if(a&&["STYLE","SCRIPT","svg","IFRAME"].indexOf(a.tagName)>=0)return!0;for(var e=b.node.contents(a),f=0;f<e.length;f++)e[f].nodeType==Node.TEXT_NODE?c(e[f]):d(e[f]);a.nodeType==Node.TEXT_NODE&&c(a)}function e(a){return 0===a.length?"":b.clean.exec(a,d).replace(/\&amp;/g,"&")}function f(){b.opts.htmlSimpleAmpersand||(b.opts.entities=b.opts.entities+"&amp;");var c=a("<div>").html(b.opts.entities).text(),d=b.opts.entities.split(";");h={},g="";for(var f=0;f<c.length;f++){var i=c.charAt(f);h[i]=d[f]+";",g+="\\"+i+(f<c.length-1?"|":"")}g=new RegExp("("+g+")","g"),b.events.on("html.get",e,!0)}var g,h;return{_init:f}},a.extend(a.FE.POPUP_TEMPLATES,{"file.insert":"[_BUTTONS_][_UPLOAD_LAYER_][_PROGRESS_BAR_]"}),a.extend(a.FE.DEFAULTS,{fileUpload:!0,fileUploadURL:"https://i.froala.com/upload",fileUploadParam:"file",fileUploadParams:{},fileUploadToS3:!1,fileUploadMethod:"POST",fileMaxSize:10485760,fileAllowedTypes:["*"],fileInsertButtons:["fileBack","|"],fileUseSelectedText:!1}),a.FE.PLUGINS.file=function(b){function c(){var a=b.$tb.find('.fr-command[data-cmd="insertFile"]'),c=b.popups.get("file.insert");if(c||(c=s()),e(),!c.hasClass("fr-active"))if(b.popups.refresh("file.insert"),b.popups.setContainer("file.insert",b.$tb),a.is(":visible")){var d=a.offset().left+a.outerWidth()/2,f=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show("file.insert",d,f,a.outerHeight())}else b.position.forSelection(c),b.popups.show("file.insert")}function d(){var a=b.popups.get("file.insert");a||(a=s()),a.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),a.find(".fr-file-progress-bar-layer").addClass("fr-active"),a.find(".fr-buttons").hide(),f(b.language.translate("Uploading"),0)}function e(a){var c=b.popups.get("file.insert");c&&(c.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),c.find(".fr-file-progress-bar-layer").removeClass("fr-active"),c.find(".fr-buttons").show(),a&&(b.events.focus(),b.popups.hide("file.insert")))}function f(a,c){var d=b.popups.get("file.insert");if(d){var e=d.find(".fr-file-progress-bar-layer");e.find("h3").text(a+(c?" "+c+"%":"")),e.removeClass("fr-error"),c?(e.find("div").removeClass("fr-indeterminate"),e.find("div > span").css("width",c+"%")):e.find("div").addClass("fr-indeterminate")}}function g(a){d();var c=b.popups.get("file.insert"),e=c.find(".fr-file-progress-bar-layer");e.addClass("fr-error");var f=e.find("h3");f.text(a),b.events.disableBlur(),f.focus()}function h(a,c,d){b.edit.on(),b.events.focus(!0),b.selection.restore(),b.opts.fileUseSelectedText&&b.selection.text().length&&(c=b.selection.text()),b.html.insert('<a href="'+a+'" target="_blank" id="fr-inserted-file" class="fr-file">'+c+"</a>");var e=b.$el.find("#fr-inserted-file");e.removeAttr("id"),b.popups.hide("file.insert"),b.undo.saveStep(),x(),b.events.trigger("file.inserted",[e,d])}function i(a){try{if(!1===b.events.trigger("file.uploaded",[a],!0))return b.edit.on(),!1;var c=JSON.parse(a);return c.link?c:(n(z,a),!1)}catch(d){return n(B,a),!1}}function j(c){try{var d=a(c).find("Location").text(),e=a(c).find("Key").text();return!1===b.events.trigger("file.uploadedToS3",[d,e,c],!0)?(b.edit.on(),!1):d}catch(f){return n(B,c),!1}}function k(a){var c=this.status,d=this.response,e=this.responseXML,f=this.responseText;try{if(b.opts.fileUploadToS3)if(201==c){var g=j(e);g&&h(g,a,d||e)}else n(B,d||e);else if(c>=200&&c<300){var k=i(f);k&&h(k.link,a,d||f)}else n(A,d||f)}catch(l){n(B,d||f)}}function l(){n(B,this.response||this.responseText||this.responseXML)}function m(a){if(a.lengthComputable){var c=a.loaded/a.total*100|0;f(b.language.translate("Uploading"),c)}}function n(a,c){b.edit.on(),g(b.language.translate("Something went wrong. Please try again.")),b.events.trigger("file.error",[{code:a,message:E[a]},c])}function o(){b.edit.on(),e(!0)}function p(a){if(void 0!==a&&a.length>0){if(!1===b.events.trigger("file.beforeUpload",[a]))return!1;var c=a[0];if(c.size>b.opts.fileMaxSize)return n(C),!1;if(b.opts.fileAllowedTypes.indexOf("*")<0&&b.opts.fileAllowedTypes.indexOf(c.type.replace(/file\//g,""))<0)return n(D),!1;var e;if(b.drag_support.formdata&&(e=b.drag_support.formdata?new FormData:null),e){var f;if(!1!==b.opts.fileUploadToS3){e.append("key",b.opts.fileUploadToS3.keyStart+(new Date).getTime()+"-"+(c.name||"untitled")),e.append("success_action_status","201"),e.append("X-Requested-With","xhr"),e.append("Content-Type",c.type);for(f in b.opts.fileUploadToS3.params)b.opts.fileUploadToS3.params.hasOwnProperty(f)&&e.append(f,b.opts.fileUploadToS3.params[f])}for(f in b.opts.fileUploadParams)b.opts.fileUploadParams.hasOwnProperty(f)&&e.append(f,b.opts.fileUploadParams[f]);e.append(b.opts.fileUploadParam,c);var g=b.opts.fileUploadURL;b.opts.fileUploadToS3&&(g=b.opts.fileUploadToS3.uploadURL?b.opts.fileUploadToS3.uploadURL:"https://"+b.opts.fileUploadToS3.region+".amazonaws.com/"+b.opts.fileUploadToS3.bucket);var h=b.core.getXHR(g,b.opts.fileUploadMethod);h.onload=function(){k.call(h,c.name)},h.onerror=l,h.upload.onprogress=m,h.onabort=o,d(),b.edit.off();var i=b.popups.get("file.insert");i&&i.off("abortUpload").on("abortUpload",function(){4!=h.readyState&&h.abort()}),h.send(e)}}}function q(c){b.events.$on(c,"dragover dragenter",".fr-file-upload-layer",function(){return a(this).addClass("fr-drop"),!1},!0),b.events.$on(c,"dragleave dragend",".fr-file-upload-layer",function(){return a(this).removeClass("fr-drop"),!1},!0),b.events.$on(c,"drop",".fr-file-upload-layer",function(d){d.preventDefault(),d.stopPropagation(),a(this).removeClass("fr-drop");var e=d.originalEvent.dataTransfer;if(e&&e.files){(c.data("instance")||b).file.upload(e.files)}},!0),b.helpers.isIOS()&&b.events.$on(c,"touchstart",'.fr-file-upload-layer input[type="file"]',function(){a(this).trigger("click")}),b.events.$on(c,"change",'.fr-file-upload-layer input[type="file"]',function(){if(this.files){(c.data("instance")||b).file.upload(this.files)}a(this).val("")},!0)}function r(){e()}function s(a){if(a)return b.popups.onHide("file.insert",r),!0;var c="";b.opts.fileUpload||b.opts.fileInsertButtons.splice(b.opts.fileInsertButtons.indexOf("fileUpload"),1),c='<div class="fr-buttons">'+b.button.buildList(b.opts.fileInsertButtons)+"</div>";var d="";b.opts.fileUpload&&(d='<div class="fr-file-upload-layer fr-layer fr-active" id="fr-file-upload-layer-'+b.id+'"><strong>'+b.language.translate("Drop file")+"</strong><br>("+b.language.translate("or click")+')<div class="fr-form"><input type="file" name="'+b.opts.fileUploadParam+'" accept="/*" tabIndex="-1" aria-labelledby="fr-file-upload-layer-'+b.id+'" role="button"></div></div>');var e='<div class="fr-file-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="fileDismissError" tabIndex="2" role="button">OK</button></div></div>',f={buttons:c,upload_layer:d,progress_bar:e},g=b.popups.create("file.insert",f);return q(g),g}function t(a){b.node.hasClass(a,"fr-file")}function u(c){var e=c.originalEvent.dataTransfer;if(e&&e.files&&e.files.length){var f=e.files[0];if(f&&void 0!==f.type&&f.type.indexOf("image")<0&&(b.opts.fileAllowedTypes.indexOf(f.type)>=0||b.opts.fileAllowedTypes.indexOf("*")>=0)){if(!b.opts.fileUpload)return c.preventDefault(),c.stopPropagation(),!1;b.markers.remove(),b.markers.insertAtPoint(c.originalEvent),b.$el.find(".fr-marker").replaceWith(a.FE.MARKERS),b.popups.hideAll();var g=b.popups.get("file.insert");return g||(g=s()),b.popups.setContainer("file.insert",b.$sc),b.popups.show("file.insert",c.originalEvent.pageX,c.originalEvent.pageY),d(),p(e.files),c.preventDefault(),c.stopPropagation(),!1}}}function v(){b.events.on("drop",u),b.events.$on(b.$win,"keydown",function(c){var d=c.which,e=b.popups.get("file.insert");e&&d==a.FE.KEYCODE.ESC&&e.trigger("abortUpload")}),b.events.on("destroy",function(){var a=b.popups.get("file.insert");a&&a.trigger("abortUpload")})}function w(){b.events.disableBlur(),b.selection.restore(),b.events.enableBlur(),b.popups.hide("file.insert"),b.toolbar.showInline()}function x(){var a,c=Array.prototype.slice.call(b.el.querySelectorAll("a.fr-file")),d=[];for(a=0;a<c.length;a++)d.push(c[a].getAttribute("href"));if(F)for(a=0;a<F.length;a++)d.indexOf(F[a].getAttribute("href"))<0&&b.events.trigger("file.unlink",[F[a]]);F=c}function y(){v(),b.events.on("link.beforeRemove",t),b.$wp&&(x(),b.events.on("contentChanged",x)),s(!0)}var z=2,A=3,B=4,C=5,D=6,E={};E[1]="File cannot be loaded from the passed link.",E[z]="No link in upload response.",E[A]="Error during file upload.",E[B]="Parsing response failed.",E[C]="File is too large.",E[D]="File file type is invalid.",E[7]="Files can be uploaded only to same domain in IE 8 and IE 9.";var F;return{_init:y,showInsertPopup:c,upload:p,insert:h,back:w,hideProgressBar:e}},a.FE.DefineIcon("insertFile",{NAME:"file-o"}),a.FE.RegisterCommand("insertFile",{title:"Upload File",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("file.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("file.insert")):this.file.showInsertPopup()},plugin:"file"}),a.FE.DefineIcon("fileBack",{NAME:"arrow-left"}),a.FE.RegisterCommand("fileBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.file.back()},refresh:function(a){this.opts.toolbarInline?(a.removeClass("fr-hidden"),a.next(".fr-separator").removeClass("fr-hidden")):(a.addClass("fr-hidden"),a.next(".fr-separator").addClass("fr-hidden"))}}),a.FE.RegisterCommand("fileDismissError",{title:"OK",callback:function(){this.file.hideProgressBar(!0)}}),a.extend(a.FE.DEFAULTS,{fontFamily:{"Arial,Helvetica,sans-serif":"Arial","Georgia,serif":"Georgia","Impact,Charcoal,sans-serif":"Impact","Tahoma,Geneva,sans-serif":"Tahoma","Times New Roman,Times,serif,-webkit-standard":"Times New Roman","Verdana,Geneva,sans-serif":"Verdana"},fontFamilySelection:!1,fontFamilyDefaultSelection:"Font Family"}),a.FE.PLUGINS.fontFamily=function(b){function c(a){b.format.applyStyle("font-family",a)}function d(a,b){b.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected",!1),b.find('.fr-command[data-param1="'+g()+'"]').addClass("fr-active").attr("aria-selected",!0);var c=b.find(".fr-dropdown-list"),d=b.find(".fr-active").parent();d.length?c.parent().scrollTop(d.offset().top-c.offset().top-(c.parent().outerHeight()/2-d.outerHeight()/2)):c.parent().scrollTop(0)}function e(b){var c=b.replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi,"").replace(/"|'| /g,"").split(",");return a.grep(c,function(a){return a.length>0})}function f(a,b){for(var c=0;c<a.length;c++)for(var d=0;d<b.length;d++)if(a[c].toLowerCase()==b[d].toLowerCase())return[c,d];return null}function g(){var c=a(b.selection.element()).css("font-family"),d=e(c),g=[];for(var h in b.opts.fontFamily)if(b.opts.fontFamily.hasOwnProperty(h)){var i=e(h),j=f(d,i);j&&g.push([h,j])}return 0===g.length?null:(g.sort(function(a,b){var c=a[1][0]-b[1][0];return 0===c?a[1][1]-b[1][1]:c}),g[0][0])}function h(c){if(b.opts.fontFamilySelection){var d=a(b.selection.element()).css("font-family").replace(/(sans-serif|serif|monospace|cursive|fantasy)/gi,"").replace(/"|'|/g,"").split(",");c.find("> span").text(b.opts.fontFamily[g()]||d[0]||b.language.translate(b.opts.fontFamilyDefaultSelection))}}return{apply:c,refreshOnShow:d,refresh:h}},a.FE.RegisterCommand("fontFamily",{type:"dropdown",displaySelection:function(a){return a.opts.fontFamilySelection},defaultSelection:function(a){return a.opts.fontFamilyDefaultSelection},displaySelectionWidth:120,html:function(){var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.fontFamily;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontFamily" data-param1="'+c+'" style="font-family: '+c+'" title="'+b[c]+'">'+b[c]+"</a></li>");return a+="</ul>"},title:"Font Family",callback:function(a,b){this.fontFamily.apply(b)},refresh:function(a){this.fontFamily.refresh(a)},refreshOnShow:function(a,b){this.fontFamily.refreshOnShow(a,b)},plugin:"fontFamily"}),a.FE.DefineIcon("fontFamily",{NAME:"font"}),a.extend(a.FE.DEFAULTS,{fontSize:["8","9","10","11","12","14","18","24","30","36","48","60","72","96"],fontSizeSelection:!1,fontSizeDefaultSelection:"12"}),a.FE.PLUGINS.fontSize=function(b){function c(a){b.format.applyStyle("font-size",a)}function d(c,d){var e=a(b.selection.element()).css("font-size");d.find(".fr-command.fr-active").removeClass("fr-active").attr("aria-selected",!1),d.find('.fr-command[data-param1="'+e+'"]').addClass("fr-active").attr("aria-selected",!0);var f=d.find(".fr-dropdown-list"),g=d.find(".fr-active").parent();g.length?f.parent().scrollTop(g.offset().top-f.offset().top-(f.parent().outerHeight()/2-g.outerHeight()/2)):f.parent().scrollTop(0)}function e(c){if(b.opts.fontSizeSelection){var d=b.helpers.getPX(a(b.selection.element()).css("font-size"));c.find("> span").text(d)}}return{apply:c,refreshOnShow:d,refresh:e}},a.FE.RegisterCommand("fontSize",{type:"dropdown",title:"Font Size",displaySelection:function(a){return a.opts.fontSizeSelection},displaySelectionWidth:30,defaultSelection:function(a){return a.opts.fontSizeDefaultSelection},html:function(){for(var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.fontSize,c=0;c<b.length;c++){var d=b[c];a+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="fontSize" data-param1="'+d+'px" title="'+d+'">'+d+"</a></li>"}return a+="</ul>"},callback:function(a,b){this.fontSize.apply(b)},refresh:function(a){this.fontSize.refresh(a)},refreshOnShow:function(a,b){this.fontSize.refreshOnShow(a,b)},plugin:"fontSize"}),a.FE.DefineIcon("fontSize",{NAME:"text-height"}),a.extend(a.FE.POPUP_TEMPLATES,{"forms.edit":"[_BUTTONS_]","forms.update":"[_BUTTONS_][_TEXT_LAYER_]"}),a.extend(a.FE.DEFAULTS,{formEditButtons:["inputStyle","inputEdit"],formStyles:{"fr-rounded":"Rounded","fr-large":"Large"},formMultipleStyles:!0,formUpdateButtons:["inputBack","|"]}),a.FE.PLUGINS.forms=function(b){function c(c){c.preventDefault(),b.selection.clear(),a(this).data("mousedown",!0)}function d(b){a(this).data("mousedown")&&(b.stopPropagation(),a(this).removeData("mousedown"),s=this,j(this)),b.preventDefault()}function e(){b.$el.find("input, textarea, button").removeData("mousedown")}function f(){a(this).removeData("mousedown")}function g(){b.events.$on(b.$el,b._mousedown,"input, textarea, button",c),b.events.$on(b.$el,b._mouseup,"input, textarea, button",d),b.events.$on(b.$el,"touchmove","input, textarea, button",f),b.events.$on(b.$el,b._mouseup,e),b.events.$on(b.$win,b._mouseup,e),m(!0)}function h(){return s||null}function i(){var a="";b.opts.formEditButtons.length>0&&(a='<div class="fr-buttons">'+b.button.buildList(b.opts.formEditButtons)+"</div>");var c={buttons:a},d=b.popups.create("forms.edit",c);return b.$wp&&b.events.$on(b.$wp,"scroll.link-edit",function(){h()&&b.popups.isVisible("forms.edit")&&j(h())}),d}function j(c){var d=b.popups.get("forms.edit");d||(d=i()),s=c;var e=a(c);b.popups.refresh("forms.edit"),b.popups.setContainer("forms.edit",b.$sc);var f=e.offset().left+e.outerWidth()/2,g=e.offset().top+e.outerHeight();b.popups.show("forms.edit",f,g,e.outerHeight())}function k(){var c=b.popups.get("forms.update"),d=h();if(d){var e=a(d);e.is("button")?c.find('input[type="text"][name="text"]').val(e.text()):c.find('input[type="text"][name="text"]').val(e.attr("placeholder"))}c.find('input[type="text"][name="text"]').trigger("change")}function l(){s=null}function m(a){if(a)return b.popups.onRefresh("forms.update",k),b.popups.onHide("forms.update",l),!0;var c="";b.opts.formUpdateButtons.length>=1&&(c='<div class="fr-buttons">'+b.button.buildList(b.opts.formUpdateButtons)+"</div>");var d="",e=0;d='<div class="fr-forms-text-layer fr-layer fr-active">',d+='<div class="fr-input-line"><input name="text" type="text" placeholder="Text" tabIndex="'+ ++e+'"></div>',d+='<div class="fr-action-buttons"><button class="fr-command fr-submit" data-cmd="updateInput" href="#" tabIndex="'+ ++e+'" type="button">'+b.language.translate("Update")+"</button></div></div>";var f={buttons:c,text_layer:d};return b.popups.create("forms.update",f)}function n(){var c=h();if(c){var d=a(c),e=b.popups.get("forms.update");e||(e=m()),b.popups.isVisible("forms.update")||b.popups.refresh("forms.update"),b.popups.setContainer("forms.update",b.$sc);var f=d.offset().left+d.outerWidth()/2,g=d.offset().top+d.outerHeight();b.popups.show("forms.update",f,g,d.outerHeight())}}function o(c,d,e){void 0===d&&(d=b.opts.formStyles),void 0===e&&(e=b.opts.formMultipleStyles);var f=h();if(!f)return!1;if(!e){var g=Object.keys(d);g.splice(g.indexOf(c),1),a(f).removeClass(g.join(" "))}a(f).toggleClass(c)}function p(){b.events.disableBlur(),b.selection.restore(),b.events.enableBlur();var a=h();a&&b.$wp&&("BUTTON"==a.tagName&&b.selection.restore(),j(a))}function q(){var c=b.popups.get("forms.update"),d=h();if(d){var e=a(d),f=c.find('input[type="text"][name="text"]').val()||"";f.length&&(e.is("button")?e.text(f):e.attr("placeholder",f)),b.popups.hide("forms.update"),j(d)}}function r(){g(),b.events.$on(b.$el,"submit","form",function(a){return a.preventDefault(),!1})}var s;return{_init:r,updateInput:q,getInput:h,applyStyle:o,showUpdatePopup:n,showEditPopup:j,back:p}},a.FE.RegisterCommand("updateInput",{undo:!1,focus:!1,title:"Update",callback:function(){this.forms.updateInput()}}),a.FE.DefineIcon("inputStyle",{NAME:"magic"}),a.FE.RegisterCommand("inputStyle",{title:"Style",type:"dropdown",html:function(){var a='<ul class="fr-dropdown-list">',b=this.opts.formStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li><a class="fr-command" tabIndex="-1" data-cmd="inputStyle" data-param1="'+c+'">'+this.language.translate(b[c])+"</a></li>");return a+="</ul>"},callback:function(a,b){var c=this.forms.getInput();c&&(this.forms.applyStyle(b),this.forms.showEditPopup(c))},refreshOnShow:function(b,c){var d=this.forms.getInput();if(d){var e=a(d);c.find(".fr-command").each(function(){var b=a(this).data("param1");a(this).toggleClass("fr-active",e.hasClass(b))})}}}),a.FE.DefineIcon("inputEdit",{NAME:"edit"}),a.FE.RegisterCommand("inputEdit",{title:"Edit Button",undo:!1,refreshAfterCallback:!1,callback:function(){this.forms.showUpdatePopup()}}),a.FE.DefineIcon("inputBack",{NAME:"arrow-left"}),a.FE.RegisterCommand("inputBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.forms.back()}}),a.FE.RegisterCommand("updateInput",{undo:!1,focus:!1,title:"Update",callback:function(){this.forms.updateInput()}}),a.FE.PLUGINS.fullscreen=function(b){function c(){return b.$box.hasClass("fr-fullscreen")}function d(){i=b.helpers.scrollTop(),b.$box.toggleClass("fr-fullscreen"),a("body:first").toggleClass("fr-fullscreen"),j=a('<div style="display: none;"></div>'),b.$box.after(j),b.helpers.isMobile()&&(b.$tb.data("parent",b.$tb.parent()),b.$tb.prependTo(b.$box),b.$tb.data("sticky-dummy")&&b.$tb.after(b.$tb.data("sticky-dummy"))),k=b.opts.height,l=b.opts.heightMax,m=b.opts.zIndex,b.position.refresh(),b.opts.height=b.o_win.innerHeight-(b.opts.toolbarInline?0:b.$tb.outerHeight()),b.opts.zIndex=2147483641,b.opts.heightMax=null,b.size.refresh(),b.opts.toolbarInline&&b.toolbar.showInline();for(var c=b.$box.parent();!c.is("body:first");)c.data("z-index",c.css("z-index")).data("overflow",c.css("overflow")).css("z-index","2147483640").css("overflow","visible"),c=c.parent();b.events.trigger("charCounter.update"),b.$win.trigger("scroll")}function e(){b.$box.toggleClass("fr-fullscreen"),a("body:first").toggleClass("fr-fullscreen"),b.$tb.prependTo(b.$tb.data("parent")),b.$tb.data("sticky-dummy")&&b.$tb.after(b.$tb.data("sticky-dummy")),b.opts.height=k,b.opts.heightMax=l,b.opts.zIndex=m,b.size.refresh(),a(b.o_win).scrollTop(i),b.opts.toolbarInline&&b.toolbar.showInline(),b.events.trigger("charCounter.update"),
b.opts.toolbarSticky&&b.opts.toolbarStickyOffset&&(b.opts.toolbarBottom?b.$tb.css("bottom",b.opts.toolbarStickyOffset).data("bottom",b.opts.toolbarStickyOffset):b.$tb.css("top",b.opts.toolbarStickyOffset).data("top",b.opts.toolbarStickyOffset));for(var c=b.$box.parent();!c.is("body:first");)c.data("z-index")&&(c.css("z-index",""),c.css("z-index")!=c.data("z-index")&&c.css("z-index",c.data("z-index")),c.removeData("z-index")),c.data("overflow")?(c.css("overflow",""),c.css("overflow")!=c.data("overflow")&&c.css("overflow",c.data("overflow")),c.removeData("overflow")):(c.css("overflow",""),c.removeData("overflow")),c=c.parent();b.$win.trigger("scroll")}function f(){c()?e():d(),g(b.$tb.find('.fr-command[data-cmd="fullscreen"]'))}function g(a){var d=c();a.toggleClass("fr-active",d).attr("aria-pressed",d),a.find("> *:not(.fr-sr-only)").replaceWith(d?b.icon.create("fullscreenCompress"):b.icon.create("fullscreen"))}function h(){if(!b.$wp)return!1;b.events.$on(a(b.o_win),"resize",function(){c()&&(e(),d())}),b.events.on("toolbar.hide",function(){if(c()&&b.helpers.isMobile())return!1}),b.events.on("destroy",function(){c()&&e()},!0)}var i,j,k,l,m;return{_init:h,toggle:f,refresh:g,isActive:c}},a.FE.RegisterCommand("fullscreen",{title:"Fullscreen",undo:!1,focus:!1,accessibilityFocus:!0,forcedRefresh:!0,toggle:!0,callback:function(){this.fullscreen.toggle()},refresh:function(a){this.fullscreen.refresh(a)},plugin:"fullscreen"}),a.FE.DefineIcon("fullscreen",{NAME:"expand"}),a.FE.DefineIcon("fullscreenCompress",{NAME:"compress"}),a.extend(a.FE.DEFAULTS,{helpSets:[{title:"Inline Editor",commands:[{val:"OSkeyE",desc:"Show the editor"}]},{title:"Common actions",commands:[{val:"OSkeyC",desc:"Copy"},{val:"OSkeyX",desc:"Cut"},{val:"OSkeyV",desc:"Paste"},{val:"OSkeyZ",desc:"Undo"},{val:"OSkeyShift+Z",desc:"Redo"},{val:"OSkeyK",desc:"Insert Link"},{val:"OSkeyP",desc:"Insert Image"}]},{title:"Basic Formatting",commands:[{val:"OSkeyA",desc:"Select All"},{val:"OSkeyB",desc:"Bold"},{val:"OSkeyI",desc:"Italic"},{val:"OSkeyU",desc:"Underline"},{val:"OSkeyS",desc:"Strikethrough"},{val:"OSkey]",desc:"Increase Indent"},{val:"OSkey[",desc:"Decrease Indent"}]},{title:"Quote",commands:[{val:"OSkey'",desc:"Increase quote level"},{val:"OSkeyShift+'",desc:"Decrease quote level"}]},{title:"Image / Video",commands:[{val:"OSkey+",desc:"Resize larger"},{val:"OSkey-",desc:"Resize smaller"}]},{title:"Table",commands:[{val:"Alt+Space",desc:"Select table cell"},{val:"Shift+Left/Right arrow",desc:"Extend selection one cell"},{val:"Shift+Up/Down arrow",desc:"Extend selection one row"}]},{title:"Navigation",commands:[{val:"OSkey/",desc:"Shortcuts"},{val:"Alt+F10",desc:"Focus popup / toolbar"},{val:"Esc",desc:"Return focus to previous position"}]}]}),a.FE.PLUGINS.help=function(b){function c(){}function d(){for(var c='<div class="fr-help-modal">',d=0;d<a.FE.DEFAULTS.helpSets.length;d++){var e=a.FE.DEFAULTS.helpSets[d],f="<table>";f+="<thead><tr><th>"+b.language.translate(e.title)+"</th></tr></thead>",f+="<tbody>";for(var g=0;g<e.commands.length;g++){var h=e.commands[g];f+="<tr>",f+="<td>"+b.language.translate(h.desc)+"</td>",f+="<td>"+h.val.replace("OSkey",b.helpers.isMac()?"&#8984;":"Ctrl+")+"</td>",f+="</tr>"}f+="</tbody></table>",c+=f}return c+="</div>"}function e(){if(!g){var c="<h4>"+b.language.translate("Shortcuts")+"</h4>",e=d(),f=b.modals.create(j,c,e);g=f.$modal,h=f.$head,i=f.$body,b.events.$on(a(b.o_win),"resize",function(){b.modals.resize(j)})}b.modals.show(j),b.modals.resize(j)}function f(){b.modals.hide(j)}var g,h,i,j="help";return{_init:c,show:e,hide:f}},a.FroalaEditor.DefineIcon("help",{NAME:"question"}),a.FE.RegisterShortcut(a.FE.KEYCODE.SLASH,"help",null,"/"),a.FE.RegisterCommand("help",{title:"Help",icon:"help",undo:!1,focus:!1,modal:!0,callback:function(){this.help.show()},plugin:"help",showOnMobile:!1}),a.extend(a.FE.POPUP_TEMPLATES,{"image.insert":"[_BUTTONS_][_UPLOAD_LAYER_][_BY_URL_LAYER_][_PROGRESS_BAR_]","image.edit":"[_BUTTONS_]","image.alt":"[_BUTTONS_][_ALT_LAYER_]","image.size":"[_BUTTONS_][_SIZE_LAYER_]"}),a.extend(a.FE.DEFAULTS,{imageInsertButtons:["imageBack","|","imageUpload","imageByURL"],imageEditButtons:["imageReplace","imageAlign","imageCaption","imageRemove","|","imageLink","linkOpen","linkEdit","linkRemove","-","imageDisplay","imageStyle","imageAlt","imageSize"],imageAltButtons:["imageBack","|"],imageSizeButtons:["imageBack","|"],imageUpload:!0,imageUploadURL:"https://i.froala.com/upload",imageCORSProxy:"https://cors-anywhere.froala.com",imageUploadRemoteUrls:!0,imageUploadParam:"file",imageUploadParams:{},imageUploadToS3:!1,imageUploadMethod:"POST",imageMaxSize:10485760,imageAllowedTypes:["jpeg","jpg","png","gif","svg+xml"],imageResize:!0,imageResizeWithPercent:!1,imageRoundPercent:!1,imageDefaultWidth:300,imageDefaultAlign:"center",imageDefaultDisplay:"block",imageSplitHTML:!1,imageStyles:{"fr-rounded":"Rounded","fr-bordered":"Bordered","fr-shadow":"Shadow"},imageMove:!0,imageMultipleStyles:!0,imageTextNear:!0,imagePaste:!0,imagePasteProcess:!1,imageMinWidth:16,imageOutputSize:!1,imageDefaultMargin:5}),a.FE.PLUGINS.image=function(b){function c(){var a=b.popups.get("image.insert"),c=a.find(".fr-image-by-url-layer input");c.val(""),Da&&c.val(Da.attr("src")),c.trigger("change")}function d(){var a=b.$tb.find('.fr-command[data-cmd="insertImage"]'),c=b.popups.get("image.insert");if(c||(c=M()),s(),!c.hasClass("fr-active"))if(b.popups.refresh("image.insert"),b.popups.setContainer("image.insert",b.$tb),a.is(":visible")){var d=a.offset().left+a.outerWidth()/2,e=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show("image.insert",d,e,a.outerHeight())}else b.position.forSelection(c),b.popups.show("image.insert")}function e(){var a=b.popups.get("image.edit");if(a||(a=q()),a){var c=za();Ba()&&(c=c.find(".fr-img-wrap")),b.popups.setContainer("image.edit",b.$sc),b.popups.refresh("image.edit");var d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show("image.edit",d,e,c.outerHeight())}}function f(){s()}function g(a){a.parents(".fr-img-caption").length>0&&(a=a.parents(".fr-img-caption:first")),a.hasClass("fr-dii")||a.hasClass("fr-dib")||(a.addClass("fr-fi"+pa(a)[0]),a.addClass("fr-di"+qa(a)[0]),a.css("margin",""),a.css("float",""),a.css("display",""),a.css("z-index",""),a.css("position",""),a.css("overflow",""),a.css("vertical-align",""))}function h(a){a.parents(".fr-img-caption").length>0&&(a=a.parents(".fr-img-caption:first")),na(a,a.hasClass("fr-dib")?"block":a.hasClass("fr-dii")?"inline":null,a.hasClass("fr-fil")?"left":a.hasClass("fr-fir")?"right":pa(a)),a.removeClass("fr-dib fr-dii fr-fir fr-fil")}function i(){for(var c="IMG"==b.el.tagName?[b.el]:b.el.querySelectorAll("img"),d=0;d<c.length;d++){var e=a(c[d]);!b.opts.htmlUntouched&&b.opts.useClasses?((b.opts.imageEditButtons.indexOf("imageAlign")>=0||b.opts.imageEditButtons.indexOf("imageDisplay")>=0)&&g(e),b.opts.imageTextNear||(e.parents(".fr-img-caption").length>0?e.parents(".fr-img-caption:first").removeClass("fr-dii").addClass("fr-dib"):e.removeClass("fr-dii").addClass("fr-dib"))):b.opts.htmlUntouched||b.opts.useClasses||(b.opts.imageEditButtons.indexOf("imageAlign")>=0||b.opts.imageEditButtons.indexOf("imageDisplay")>=0)&&h(e),b.opts.iframe&&e.on("load",b.size.syncIframe)}}function j(c){void 0===c&&(c=!0);var d,e=Array.prototype.slice.call(b.el.querySelectorAll("img")),f=[];for(d=0;d<e.length;d++)if(f.push(e[d].getAttribute("src")),a(e[d]).toggleClass("fr-draggable",b.opts.imageMove),""===e[d].getAttribute("class")&&e[d].removeAttribute("class"),""===e[d].getAttribute("style")&&e[d].removeAttribute("style"),e[d].parentNode&&e[d].parentNode.parentNode&&b.node.hasClass(e[d].parentNode.parentNode,"fr-img-caption")){var g=e[d].parentNode.parentNode;b.browser.mozilla||g.setAttribute("contenteditable",!1),g.setAttribute("draggable",!1),g.classList.add("fr-draggable");var h=e[d].nextSibling;h&&h.setAttribute("contenteditable",!0)}if(Qa)for(d=0;d<Qa.length;d++)f.indexOf(Qa[d].getAttribute("src"))<0&&b.events.trigger("image.removed",[a(Qa[d])]);if(Qa&&c){var i=[];for(d=0;d<Qa.length;d++)i.push(Qa[d].getAttribute("src"));for(d=0;d<e.length;d++)i.indexOf(e[d].getAttribute("src"))<0&&b.events.trigger("image.loaded",[a(e[d])])}Qa=e}function k(){if(Ea||Z(),!Da)return!1;var a=b.$wp||b.$sc;a.append(Ea),Ea.data("instance",b);var c=a.scrollTop()-("static"!=a.css("position")?a.offset().top:0),d=a.scrollLeft()-("static"!=a.css("position")?a.offset().left:0);d-=b.helpers.getPX(a.css("border-left-width")),c-=b.helpers.getPX(a.css("border-top-width")),b.$el.is("img")&&b.$sc.is("body")&&(c=0,d=0);var e=za();Ba()&&(e=e.find(".fr-img-wrap")),Ea.css("top",(b.opts.iframe?e.offset().top:e.offset().top+c)-1).css("left",(b.opts.iframe?e.offset().left:e.offset().left+d)-1).css("width",e.get(0).getBoundingClientRect().width).css("height",e.get(0).getBoundingClientRect().height).addClass("fr-active")}function l(a){return'<div class="fr-handler fr-h'+a+'"></div>'}function m(c){if(!b.core.sameInstance(Ea))return!0;if(c.preventDefault(),c.stopPropagation(),b.$el.find("img.fr-error").left)return!1;b.undo.canDo()||b.undo.saveStep();var d=c.pageX||c.originalEvent.touches[0].pageX;if("mousedown"==c.type){var e=b.$oel.get(0),f=e.ownerDocument,g=f.defaultView||f.parentWindow,h=!1;try{h=g.location!=g.parent.location&&!(g.$&&g.$.FE)}catch(k){}h&&g.frameElement&&(d+=b.helpers.getPX(a(g.frameElement).offset().left)+g.frameElement.clientLeft)}Fa=a(this),Fa.data("start-x",d),Fa.data("start-width",Da.width()),Fa.data("start-height",Da.height());var i=Da.width();if(b.opts.imageResizeWithPercent){var j=Da.parentsUntil(b.$el,b.html.blockTagsQuery()).get(0)||b.el;Da.css("width",(i/a(j).outerWidth()*100).toFixed(2)+"%")}else Da.css("width",i);Ga.show(),b.popups.hideAll(),la()}function n(c){if(!b.core.sameInstance(Ea))return!0;var d;if(Fa&&Da){if(c.preventDefault(),b.$el.find("img.fr-error").left)return!1;var e=c.pageX||(c.originalEvent.touches?c.originalEvent.touches[0].pageX:null);if(!e)return!1;var f=Fa.data("start-x"),g=e-f,h=Fa.data("start-width");if((Fa.hasClass("fr-hnw")||Fa.hasClass("fr-hsw"))&&(g=0-g),b.opts.imageResizeWithPercent){var i=Da.parentsUntil(b.$el,b.html.blockTagsQuery()).get(0)||b.el;h=((h+g)/a(i).outerWidth()*100).toFixed(2),b.opts.imageRoundPercent&&(h=Math.round(h)),Da.css("width",h+"%"),d=(b.helpers.getPX(Da.css("width"))/a(i).outerWidth()*100).toFixed(2),d!==h&&Da.css("width",d+"%"),Da.css("height","").removeAttr("height")}else h+g>=b.opts.imageMinWidth&&(Ba()&&Da.parent().css("width",h+g),Da.css("width",h+g)),d=b.helpers.getPX(Da.css("width")),d!==h+g&&Da.css("width",d),((Da.attr("style")||"").match(/(^height:)|(; *height:)/)||Da.attr("height"))&&(Da.css("height",Fa.data("start-height")*Da.width()/Fa.data("start-width")),Da.removeAttr("height"));k(),b.events.trigger("image.resize",[ya()])}}function o(a){if(!b.core.sameInstance(Ea))return!0;if(Fa&&Da){if(a&&a.stopPropagation(),b.$el.find("img.fr-error").left)return!1;Fa=null,Ga.hide(),k(),e(),b.undo.saveStep(),b.events.trigger("image.resizeEnd",[ya()])}}function p(a,c,d){b.edit.on(),Da&&Da.addClass("fr-error"),u(b.language.translate("Something went wrong. Please try again.")),!Da&&d&&$(d),b.events.trigger("image.error",[{code:a,message:Pa[a]},c,d])}function q(a){if(a)return b.$wp&&b.events.$on(b.$wp,"scroll",function(){Da&&b.popups.isVisible("image.edit")&&(b.events.disableBlur(),w(Da))}),!0;var c="";if(b.opts.imageEditButtons.length>0){c+='<div class="fr-buttons">',c+=b.button.buildList(b.opts.imageEditButtons),c+="</div>";var d={buttons:c};return b.popups.create("image.edit",d)}return!1}function r(a){var c=b.popups.get("image.insert");if(c||(c=M()),c.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),c.find(".fr-image-progress-bar-layer").addClass("fr-active"),c.find(".fr-buttons").hide(),Da){var d=za();b.popups.setContainer("image.insert",b.$sc);var e=d.offset().left+d.width()/2,f=d.offset().top+d.height();b.popups.show("image.insert",e,f,d.outerHeight())}void 0===a&&t(b.language.translate("Uploading"),0)}function s(a){var c=b.popups.get("image.insert");if(c&&(c.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),c.find(".fr-image-progress-bar-layer").removeClass("fr-active"),c.find(".fr-buttons").show(),a||b.$el.find("img.fr-error").length)){if(b.events.focus(),b.$el.find("img.fr-error").length&&(b.$el.find("img.fr-error").remove(),b.undo.saveStep(),b.undo.run(),b.undo.dropRedo()),!b.$wp&&Da){var d=Da;ja(!0),b.selection.setAfter(d.get(0)),b.selection.restore()}b.popups.hide("image.insert")}}function t(a,c){var d=b.popups.get("image.insert");if(d){var e=d.find(".fr-image-progress-bar-layer");e.find("h3").text(a+(c?" "+c+"%":"")),e.removeClass("fr-error"),c?(e.find("div").removeClass("fr-indeterminate"),e.find("div > span").css("width",c+"%")):e.find("div").addClass("fr-indeterminate")}}function u(a){r();var c=b.popups.get("image.insert"),d=c.find(".fr-image-progress-bar-layer");d.addClass("fr-error");var e=d.find("h3");e.text(a),b.events.disableBlur(),e.focus()}function v(){var a=b.popups.get("image.insert"),c=a.find(".fr-image-by-url-layer input");if(c.val().length>0){if(r(),t(b.language.translate("Loading image")),b.opts.imageUploadRemoteUrls&&b.opts.imageCORSProxy){var d=new XMLHttpRequest;d.open("GET",b.opts.imageCORSProxy+"/"+c.val(),!0),d.responseType="blob",d.onload=function(){200==this.status&&H([new Blob([this.response],{type:this.response.type||"image/png"})],Da)},d.send()}else y(c.val(),!0,[],Da);c.val(""),c.blur()}}function w(a){ia.call(a.get(0))}function x(){var c=a(this);b.popups.hide("image.insert"),c.removeClass("fr-uploading"),c.next().is("br")&&c.next().remove(),w(c),b.events.trigger("image.loaded",[c])}function y(a,c,d,e,f){b.edit.off(),t(b.language.translate("Loading image")),c&&(a=b.helpers.sanitizeURL(a));var g=new Image;g.onload=function(){var c,g;if(e){b.undo.canDo()||e.hasClass("fr-uploading")||b.undo.saveStep();var h=e.data("fr-old-src");e.data("fr-image-pasted")&&(h=null),b.$wp?(c=e.clone().removeData("fr-old-src").removeClass("fr-uploading").removeAttr("data-fr-image-pasted"),c.off("load"),h&&e.attr("src",h),e.replaceWith(c)):c=e;for(var i=c.get(0).attributes,k=0;k<i.length;k++){var l=i[k];0===l.nodeName.indexOf("data-")&&c.removeAttr(l.nodeName)}if(void 0!==d)for(g in d)d.hasOwnProperty(g)&&"link"!=g&&c.attr("data-"+g,d[g]);c.on("load",x),c.attr("src",a),b.edit.on(),j(!1),b.undo.saveStep(),b.$el.blur(),b.events.trigger(h?"image.replaced":"image.inserted",[c,f])}else c=E(a,d,x),j(!1),b.undo.saveStep(),b.$el.blur(),b.events.trigger("image.inserted",[c,f])},g.onerror=function(){p(Ia)},r(b.language.translate("Loading image")),g.src=a}function z(a){try{if(!1===b.events.trigger("image.uploaded",[a],!0))return b.edit.on(),!1;var c=JSON.parse(a);return c.link?c:(p(Ja,a),!1)}catch(d){return p(La,a),!1}}function A(c){try{var d=a(c).find("Location").text(),e=a(c).find("Key").text();return!1===b.events.trigger("image.uploadedToS3",[d,e,c],!0)?(b.edit.on(),!1):d}catch(f){return p(La,c),!1}}function B(a){t(b.language.translate("Loading image"));var c=this.status,d=this.response,e=this.responseXML,f=this.responseText;try{if(b.opts.imageUploadToS3)if(201==c){var g=A(e);g&&y(g,!1,[],a,d||e)}else p(La,d||e,a);else if(c>=200&&c<300){var h=z(f);h&&y(h.link,!1,h,a,d||f)}else p(Ka,d||f,a)}catch(i){p(La,d||f,a)}}function C(){p(La,this.response||this.responseText||this.responseXML)}function D(a){if(a.lengthComputable){var c=a.loaded/a.total*100|0;t(b.language.translate("Uploading"),c)}}function E(c,d,e){var f,g="";if(d&&void 0!==d)for(f in d)d.hasOwnProperty(f)&&"link"!=f&&(g+=" data-"+f+'="'+d[f]+'"');var h=b.opts.imageDefaultWidth;h&&"auto"!=h&&(h+=b.opts.imageResizeWithPercent?"%":"px");var i=a('<img src="'+c+'"'+g+(h?' style="width: '+h+';"':"")+">");na(i,b.opts.imageDefaultDisplay,b.opts.imageDefaultAlign),i.on("load",e),i.on("error",function(){a(this).addClass("fr-error"),p(Oa)}),b.edit.on(),b.events.focus(!0),b.selection.restore(),b.undo.saveStep(),b.opts.imageSplitHTML?b.markers.split():b.markers.insert(),b.html.wrap();var j=b.$el.find(".fr-marker");return j.length?(j.parent().is("hr")&&j.parent().after(j),b.node.isLastSibling(j)&&j.parent().hasClass("fr-deletable")&&j.insertAfter(j.parent()),j.replaceWith(i)):b.$el.append(i),b.selection.clear(),i}function F(){b.edit.on(),s(!0)}function G(c,d,e,f){function g(){var e=a(this);e.off("load"),e.addClass("fr-uploading"),e.next().is("br")&&e.next().remove(),b.placeholder.refresh(),w(e),k(),r(),b.edit.off(),c.onload=function(){B.call(c,e)},c.onerror=C,c.upload.onprogress=D,c.onabort=F,e.off("abortUpload").on("abortUpload",function(){4!=c.readyState&&c.abort()}),c.send(d)}var h,i=new FileReader;i.addEventListener("load",function(){var a=i.result;if(i.result.indexOf("svg+xml")<0){for(var c=atob(i.result.split(",")[1]),d=[],e=0;e<c.length;e++)d.push(c.charCodeAt(e));a=window.URL.createObjectURL(new Blob([new Uint8Array(d)],{type:"image/jpeg"}))}f?(f.on("load",g),f.one("error",function(){f.off("load"),f.attr("src",f.data("fr-old-src")),p(Oa)}),b.edit.on(),b.undo.saveStep(),f.data("fr-old-src",f.attr("src")),f.attr("src",a)):h=E(a,null,g)},!1),i.readAsDataURL(e)}function H(a,c){if(void 0!==a&&a.length>0){if(!1===b.events.trigger("image.beforeUpload",[a,c]))return!1;var d=a[0];if(d.name||(d.name=(new Date).getTime()+".jpg"),d.size>b.opts.imageMaxSize)return p(Ma),!1;if(b.opts.imageAllowedTypes.indexOf(d.type.replace(/image\//g,""))<0)return p(Na),!1;var e;if(b.drag_support.formdata&&(e=b.drag_support.formdata?new FormData:null),e){var f;if(!1!==b.opts.imageUploadToS3){e.append("key",b.opts.imageUploadToS3.keyStart+(new Date).getTime()+"-"+(d.name||"untitled")),e.append("success_action_status","201"),e.append("X-Requested-With","xhr"),e.append("Content-Type",d.type);for(f in b.opts.imageUploadToS3.params)b.opts.imageUploadToS3.params.hasOwnProperty(f)&&e.append(f,b.opts.imageUploadToS3.params[f])}for(f in b.opts.imageUploadParams)b.opts.imageUploadParams.hasOwnProperty(f)&&e.append(f,b.opts.imageUploadParams[f]);e.append(b.opts.imageUploadParam,d,d.name);var g=b.opts.imageUploadURL;b.opts.imageUploadToS3&&(g=b.opts.imageUploadToS3.uploadURL?b.opts.imageUploadToS3.uploadURL:"https://"+b.opts.imageUploadToS3.region+".amazonaws.com/"+b.opts.imageUploadToS3.bucket);G(b.core.getXHR(g,b.opts.imageUploadMethod),e,d,c||Da)}}}function I(c){b.events.$on(c,"dragover dragenter",".fr-image-upload-layer",function(){return a(this).addClass("fr-drop"),!1},!0),b.events.$on(c,"dragleave dragend",".fr-image-upload-layer",function(){return a(this).removeClass("fr-drop"),!1},!0),b.events.$on(c,"drop",".fr-image-upload-layer",function(d){d.preventDefault(),d.stopPropagation(),a(this).removeClass("fr-drop");var e=d.originalEvent.dataTransfer;if(e&&e.files){var f=c.data("instance")||b;f.events.disableBlur(),f.image.upload(e.files),f.events.enableBlur()}},!0),b.helpers.isIOS()&&b.events.$on(c,"touchstart",'.fr-image-upload-layer input[type="file"]',function(){a(this).trigger("click")},!0),b.events.$on(c,"change",'.fr-image-upload-layer input[type="file"]',function(){if(this.files){var d=c.data("instance")||b;d.events.disableBlur(),c.find("input:focus").blur(),d.events.enableBlur(),d.image.upload(this.files,Da)}a(this).val("")},!0)}function J(a){if(a.is("img")&&a.parents(".fr-img-caption").length>0)return a.parents(".fr-img-caption")}function K(c){var d=c.originalEvent.dataTransfer;if(d&&d.files&&d.files.length){var e=d.files[0];if(e&&e.type&&-1!==e.type.indexOf("image")){if(!b.opts.imageUpload)return c.preventDefault(),c.stopPropagation(),!1;b.markers.remove(),b.markers.insertAtPoint(c.originalEvent),b.$el.find(".fr-marker").replaceWith(a.FE.MARKERS),0===b.$el.find(".fr-marker").length&&b.selection.setAtEnd(b.el),b.popups.hideAll();var f=b.popups.get("image.insert");f||(f=M()),b.popups.setContainer("image.insert",b.$sc);var g=c.originalEvent.pageX,h=c.originalEvent.pageY;return b.opts.iframe&&(h+=b.$iframe.offset().top,g+=b.$iframe.offset().left),b.popups.show("image.insert",g,h),r(),b.opts.imageAllowedTypes.indexOf(e.type.replace(/image\//g,""))>=0?(ja(!0),H(d.files)):p(Na),c.preventDefault(),c.stopPropagation(),!1}}}function L(){b.events.$on(b.$el,b._mousedown,"IMG"==b.el.tagName?null:'img:not([contenteditable="false"])',function(c){if("false"==a(this).parents("[contenteditable]:not(.fr-element):not(.fr-img-caption):not(body):first").attr("contenteditable"))return!0;b.helpers.isMobile()||b.selection.clear(),Ha=!0,b.popups.areVisible()&&b.events.disableBlur(),b.browser.msie&&(b.events.disableBlur(),b.$el.attr("contenteditable",!1)),b.draggable||"touchstart"==c.type||c.preventDefault(),c.stopPropagation()}),b.events.$on(b.$el,b._mouseup,"IMG"==b.el.tagName?null:'img:not([contenteditable="false"])',function(c){if("false"==a(this).parents("[contenteditable]:not(.fr-element):not(.fr-img-caption):not(body):first").attr("contenteditable"))return!0;Ha&&(Ha=!1,c.stopPropagation(),b.browser.msie&&(b.$el.attr("contenteditable",!0),b.events.enableBlur()))}),b.events.on("keyup",function(c){if(c.shiftKey&&""===b.selection.text().replace(/\n/g,"")&&b.keys.isArrow(c.which)){var d=b.selection.element(),e=b.selection.endElement();d&&"IMG"==d.tagName?w(a(d)):e&&"IMG"==e.tagName&&w(a(e))}},!0),b.events.on("drop",K),b.events.on("element.beforeDrop",J),b.events.on("mousedown window.mousedown",ka),b.events.on("window.touchmove",la),b.events.on("mouseup window.mouseup",function(){if(Da)return ja(),!1;la()}),b.events.on("commands.mousedown",function(a){a.parents(".fr-toolbar").length>0&&ja()}),b.events.on("blur image.hideResizer commands.undo commands.redo element.dropped",function(){Ha=!1,ja(!0)}),b.events.on("modals.hide",function(){Da&&(wa(),b.selection.clear())})}function M(a){if(a)return b.popups.onRefresh("image.insert",c),b.popups.onHide("image.insert",f),!0;var d,e="";b.opts.imageUpload||b.opts.imageInsertButtons.splice(b.opts.imageInsertButtons.indexOf("imageUpload"),1),b.opts.imageInsertButtons.length>1&&(e='<div class="fr-buttons">'+b.button.buildList(b.opts.imageInsertButtons)+"</div>");var g=b.opts.imageInsertButtons.indexOf("imageUpload"),h=b.opts.imageInsertButtons.indexOf("imageByURL"),i="";g>=0&&(d=" fr-active",h>=0&&g>h&&(d=""),i='<div class="fr-image-upload-layer'+d+' fr-layer" id="fr-image-upload-layer-'+b.id+'"><strong>'+b.language.translate("Drop image")+"</strong><br>("+b.language.translate("or click")+')<div class="fr-form"><input type="file" accept="image/'+b.opts.imageAllowedTypes.join(", image/").toLowerCase()+'" tabIndex="-1" aria-labelledby="fr-image-upload-layer-'+b.id+'" role="button"></div></div>');var j="";h>=0&&(d=" fr-active",g>=0&&h>g&&(d=""),j='<div class="fr-image-by-url-layer'+d+' fr-layer" id="fr-image-by-url-layer-'+b.id+'"><div class="fr-input-line"><input id="fr-image-by-url-layer-text-'+b.id+'" type="text" placeholder="http://" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageInsertByURL" tabIndex="2" role="button">'+b.language.translate("Insert")+"</button></div></div>");var k='<div class="fr-image-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="imageDismissError" tabIndex="2" role="button">OK</button></div></div>',l={buttons:e,upload_layer:i,by_url_layer:j,progress_bar:k},m=b.popups.create("image.insert",l);return b.$wp&&b.events.$on(b.$wp,"scroll",function(){Da&&b.popups.isVisible("image.insert")&&va()}),I(m),m}function N(){if(Da){b.popups.get("image.alt").find("input").val(Da.attr("alt")||"").trigger("change")}}function O(){var a=b.popups.get("image.alt");a||(a=P()),s(),b.popups.refresh("image.alt"),b.popups.setContainer("image.alt",b.$sc);var c=za();Ba()&&(c=c.find(".fr-img-wrap"));var d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show("image.alt",d,e,c.outerHeight())}function P(a){if(a)return b.popups.onRefresh("image.alt",N),!0;var c="";c='<div class="fr-buttons">'+b.button.buildList(b.opts.imageAltButtons)+"</div>";var d="";d='<div class="fr-image-alt-layer fr-layer fr-active" id="fr-image-alt-layer-'+b.id+'"><div class="fr-input-line"><input id="fr-image-alt-layer-text-'+b.id+'" type="text" placeholder="'+b.language.translate("Alternate Text")+'" tabIndex="1"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetAlt" tabIndex="2" role="button">'+b.language.translate("Update")+"</button></div></div>";var e={buttons:c,alt_layer:d},f=b.popups.create("image.alt",e);return b.$wp&&b.events.$on(b.$wp,"scroll.image-alt",function(){Da&&b.popups.isVisible("image.alt")&&O()}),f}function Q(a){if(Da){var c=b.popups.get("image.alt");Da.attr("alt",a||c.find("input").val()||""),c.find("input:focus").blur(),w(Da)}}function R(){if(Da){var a=b.popups.get("image.size");a.find('input[name="width"]').val(Da.get(0).style.width).trigger("change"),a.find('input[name="height"]').val(Da.get(0).style.height).trigger("change")}}function S(){var a=b.popups.get("image.size");a||(a=T()),s(),b.popups.refresh("image.size"),b.popups.setContainer("image.size",b.$sc);var c=za();Ba()&&(c=c.find(".fr-img-wrap"));var d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show("image.size",d,e,c.outerHeight())}function T(a){if(a)return b.popups.onRefresh("image.size",R),!0;var c="";c='<div class="fr-buttons">'+b.button.buildList(b.opts.imageSizeButtons)+"</div>";var d="";d='<div class="fr-image-size-layer fr-layer fr-active" id="fr-image-size-layer-'+b.id+'"><div class="fr-image-group"><div class="fr-input-line"><input id="fr-image-size-layer-width-'+b.id+'" type="text" name="width" placeholder="'+b.language.translate("Width")+'" tabIndex="1"></div><div class="fr-input-line"><input id="fr-image-size-layer-height'+b.id+'" type="text" name="height" placeholder="'+b.language.translate("Height")+'" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="imageSetSize" tabIndex="2" role="button">'+b.language.translate("Update")+"</button></div></div>";var e={buttons:c,size_layer:d},f=b.popups.create("image.size",e);return b.$wp&&b.events.$on(b.$wp,"scroll.image-size",function(){Da&&b.popups.isVisible("image.size")&&S()}),f}function U(a,c){if(Da){var d=b.popups.get("image.size");a=a||d.find('input[name="width"]').val()||"",c=c||d.find('input[name="height"]').val()||"";var e=/^[\d]+((px)|%)*$/g;Da.removeAttr("width").removeAttr("height"),a.match(e)?Da.css("width",a):Da.css("width",""),c.match(e)?Da.css("height",c):Da.css("height",""),Ba()&&(Da.parent().removeAttr("width").removeAttr("height"),a.match(e)?Da.parent().css("width",a):Da.parent().css("width",""),c.match(e)?Da.parent().css("height",c):Da.parent().css("height","")),d.find("input:focus").blur(),w(Da)}}function V(a){var c,d,e=b.popups.get("image.insert");if(Da||b.opts.toolbarInline){if(Da){var f=za();Ba()&&(f=f.find(".fr-img-wrap")),d=f.offset().top+f.outerHeight(),c=f.offset().left+f.outerWidth()/2}}else{var g=b.$tb.find('.fr-command[data-cmd="insertImage"]');c=g.offset().left+g.outerWidth()/2,d=g.offset().top+(b.opts.toolbarBottom?10:g.outerHeight()-10)}!Da&&b.opts.toolbarInline&&(d=e.offset().top-b.helpers.getPX(e.css("margin-top")),e.hasClass("fr-above")&&(d+=e.outerHeight())),e.find(".fr-layer").removeClass("fr-active"),e.find(".fr-"+a+"-layer").addClass("fr-active"),b.popups.show("image.insert",c,d,Da?Da.outerHeight():0),b.accessibility.focusPopup(e)}function W(a){b.popups.get("image.insert").find(".fr-image-upload-layer").hasClass("fr-active")&&a.addClass("fr-active").attr("aria-pressed",!0)}function X(a){b.popups.get("image.insert").find(".fr-image-by-url-layer").hasClass("fr-active")&&a.addClass("fr-active").attr("aria-pressed",!0)}function Y(a,b,c,d){return a.pageX=b,m.call(this,a),a.pageX=a.pageX+c*Math.floor(Math.pow(1.1,d)),n.call(this,a),o.call(this,a),++d}function Z(){var c;if(b.shared.$image_resizer?(Ea=b.shared.$image_resizer,Ga=b.shared.$img_overlay,b.events.on("destroy",function(){Ea.removeClass("fr-active").appendTo(a("body:first"))},!0)):(b.shared.$image_resizer=a('<div class="fr-image-resizer"></div>'),Ea=b.shared.$image_resizer,b.events.$on(Ea,"mousedown",function(a){a.stopPropagation()},!0),b.opts.imageResize&&(Ea.append(l("nw")+l("ne")+l("sw")+l("se")),b.shared.$img_overlay=a('<div class="fr-image-overlay"></div>'),Ga=b.shared.$img_overlay,c=Ea.get(0).ownerDocument,a(c).find("body:first").append(Ga))),b.events.on("shared.destroy",function(){Ea.html("").removeData().remove(),Ea=null,b.opts.imageResize&&(Ga.remove(),Ga=null)},!0),b.helpers.isMobile()||b.events.$on(a(b.o_win),"resize",function(){Da&&!Da.hasClass("fr-uploading")?ja(!0):Da&&(k(),va(),r(!1))}),b.opts.imageResize){c=Ea.get(0).ownerDocument,b.events.$on(Ea,b._mousedown,".fr-handler",m),b.events.$on(a(c),b._mousemove,n),b.events.$on(a(c.defaultView||c.parentWindow),b._mouseup,o),b.events.$on(Ga,"mouseleave",o);var d=1,e=null,f=0;b.events.on("keydown",function(c){if(Da){var g=-1!=navigator.userAgent.indexOf("Mac OS X")?c.metaKey:c.ctrlKey,h=c.which;(h!==e||c.timeStamp-f>200)&&(d=1),(h==a.FE.KEYCODE.EQUALS||b.browser.mozilla&&h==a.FE.KEYCODE.FF_EQUALS)&&g&&!c.altKey?d=Y.call(this,c,1,1,d):(h==a.FE.KEYCODE.HYPHEN||b.browser.mozilla&&h==a.FE.KEYCODE.FF_HYPHEN)&&g&&!c.altKey?d=Y.call(this,c,2,-1,d):b.keys.ctrlKey(c)||h!=a.FE.KEYCODE.ENTER||(Da.before("<br>"),w(Da)),e=h,f=c.timeStamp}},!0),b.events.on("keyup",function(){d=1})}}function $(c){(c=c||za())&&!1!==b.events.trigger("image.beforeRemove",[c])&&(b.popups.hideAll(),wa(),ja(!0),b.undo.canDo()||b.undo.saveStep(),c.get(0)==b.el?c.removeAttr("src"):("A"==c.get(0).parentNode.tagName?(b.selection.setBefore(c.get(0).parentNode)||b.selection.setAfter(c.get(0).parentNode)||c.parent().after(a.FE.MARKERS),a(c.get(0).parentNode).remove()):(b.selection.setBefore(c.get(0))||b.selection.setAfter(c.get(0))||c.after(a.FE.MARKERS),c.remove()),b.html.fillEmptyBlocks(),b.selection.restore()),b.undo.saveStep())}function _(c){var d=c.which;if(Da&&(d==a.FE.KEYCODE.BACKSPACE||d==a.FE.KEYCODE.DELETE))return c.preventDefault(),c.stopPropagation(),$(),!1;if(Da&&d==a.FE.KEYCODE.ESC){var e=Da;return ja(!0),b.selection.setAfter(e.get(0)),b.selection.restore(),c.preventDefault(),!1}if(Da&&(d==a.FE.KEYCODE.ARROW_LEFT||d==a.FE.KEYCODE.ARROW_RIGHT)){var f=Da.get(0);return ja(!0),d==a.FE.KEYCODE.ARROW_LEFT?b.selection.setBefore(f):b.selection.setAfter(f),b.selection.restore(),c.preventDefault(),!1}return Da&&d!=a.FE.KEYCODE.F10&&!b.keys.isBrowserAction(c)?(c.preventDefault(),c.stopPropagation(),!1):void 0}function aa(a){if(a&&"IMG"==a.tagName){if(b.node.hasClass(a,"fr-uploading")||b.node.hasClass(a,"fr-error")?a.parentNode.removeChild(a):b.node.hasClass(a,"fr-draggable")&&a.classList.remove("fr-draggable"),a.parentNode&&a.parentNode.parentNode&&b.node.hasClass(a.parentNode.parentNode,"fr-img-caption")){var c=a.parentNode.parentNode;c.removeAttribute("contenteditable"),c.removeAttribute("draggable"),c.classList.remove("fr-draggable");var d=a.nextSibling;d&&d.removeAttribute("contenteditable")}}else if(a&&a.nodeType==Node.ELEMENT_NODE)for(var e=a.querySelectorAll("img.fr-uploading, img.fr-error, img.fr-draggable"),f=0;f<e.length;f++)aa(e[f])}function ba(){if(L(),"IMG"==b.el.tagName&&b.$el.addClass("fr-view"),b.events.$on(b.$el,b.helpers.isMobile()&&!b.helpers.isWindowsPhone()?"touchend":"click","IMG"==b.el.tagName?null:'img:not([contenteditable="false"])',ia),b.helpers.isMobile()&&(b.events.$on(b.$el,"touchstart","IMG"==b.el.tagName?null:'img:not([contenteditable="false"])',function(){Ra=!1}),b.events.$on(b.$el,"touchmove",function(){Ra=!0})),b.$wp?(b.events.on("window.keydown keydown",_,!0),b.events.on("keyup",function(b){if(Da&&b.which==a.FE.KEYCODE.ENTER)return!1},!0)):b.events.$on(b.$win,"keydown",_),
b.events.on("toolbar.esc",function(){if(Da){if(b.$wp)b.events.disableBlur(),b.events.focus();else{var a=Da;ja(!0),b.selection.setAfter(a.get(0)),b.selection.restore()}return!1}},!0),b.events.on("toolbar.focusEditor",function(){if(Da)return!1},!0),b.events.on("window.cut window.copy",function(a){Da&&b.popups.isVisible("image.edit")&&!b.popups.get("image.edit").find(":focus").length&&(wa(),b.paste.saveCopiedText(a,Da.get(0).outerHTML,Da.attr("alt")),"copy"==a.type?setTimeout(function(){w(Da)}):(ja(!0),b.undo.saveStep(),setTimeout(function(){b.undo.saveStep()},0)))},!0),b.browser.msie&&b.events.on("keydown",function(c){if(!b.selection.isCollapsed()||!Da)return!0;var d=c.which;d==a.FE.KEYCODE.C&&b.keys.ctrlKey(c)?b.events.trigger("window.copy"):d==a.FE.KEYCODE.X&&b.keys.ctrlKey(c)&&b.events.trigger("window.cut")}),b.events.$on(a(b.o_win),"keydown",function(b){var c=b.which;if(Da&&c==a.FE.KEYCODE.BACKSPACE)return b.preventDefault(),!1}),b.events.$on(b.$win,"keydown",function(b){var c=b.which;Da&&Da.hasClass("fr-uploading")&&c==a.FE.KEYCODE.ESC&&Da.trigger("abortUpload")}),b.events.on("destroy",function(){Da&&Da.hasClass("fr-uploading")&&Da.trigger("abortUpload")}),b.events.on("paste.before",ga),b.events.on("paste.beforeCleanup",ha),b.events.on("paste.after",da),b.events.on("html.set",i),b.events.on("html.inserted",i),i(),b.events.on("destroy",function(){Qa=[]}),b.events.on("html.processGet",aa),b.opts.imageOutputSize){var c;b.events.on("html.beforeGet",function(){c=b.el.querySelectorAll("img");for(var d=0;d<c.length;d++){var e=c[d].style.width||a(c[d]).width(),f=c[d].style.height||a(c[d]).height();e&&c[d].setAttribute("width",(""+e).replace(/px/,"")),f&&c[d].setAttribute("height",(""+f).replace(/px/,""))}})}b.opts.iframe&&b.events.on("image.loaded",b.size.syncIframe),b.$wp&&(j(),b.events.on("contentChanged",j)),b.events.$on(a(b.o_win),"orientationchange.image",function(){setTimeout(function(){Da&&w(Da)},100)}),q(!0),M(!0),T(!0),P(!0),b.events.on("node.remove",function(a){if("IMG"==a.get(0).tagName)return $(a),!1})}function ca(c){if(!1===b.events.trigger("image.beforePasteUpload",[c]))return!1;Da=a(c),k(),e(),va(),r();for(var d=atob(a(c).attr("src").split(",")[1]),f=[],g=0;g<d.length;g++)f.push(d.charCodeAt(g));H([new Blob([new Uint8Array(f)],{type:"image/jpeg"})],Da)}function da(){b.opts.imagePaste?b.$el.find("img[data-fr-image-pasted]").each(function(c,d){if(b.opts.imagePasteProcess){var e=b.opts.imageDefaultWidth;e&&"auto"!=e&&(e+=b.opts.imageResizeWithPercent?"%":"px"),a(d).css("width",e).removeClass("fr-dii fr-dib fr-fir fr-fil").addClass((b.opts.imageDefaultDisplay?"fr-di"+b.opts.imageDefaultDisplay[0]:"")+(b.opts.imageDefaultAlign&&"center"!=b.opts.imageDefaultAlign?" fr-fi"+b.opts.imageDefaultAlign[0]:""))}if(0===d.src.indexOf("data:"))ca(d);else if(0===d.src.indexOf("blob:")||0===d.src.indexOf("http")&&b.opts.imageUploadRemoteUrls&&b.opts.imageCORSProxy){var f=new Image;f.crossOrigin="Anonymous",f.onload=function(){var a=b.o_doc.createElement("CANVAS"),c=a.getContext("2d");a.height=this.naturalHeight,a.width=this.naturalWidth,c.drawImage(this,0,0),d.src=a.toDataURL("image/png"),ca(d)},f.src=(0===d.src.indexOf("blob:")?"":b.opts.imageCORSProxy+"/")+d.src}else 0!==d.src.indexOf("http")||0===d.src.indexOf("https://mail.google.com/mail")?(b.selection.save(),a(d).remove(),b.selection.restore()):a(d).removeAttr("data-fr-image-pasted")}):b.$el.find("img[data-fr-image-pasted]").remove()}function ea(a){var c=a.target.result,d=b.opts.imageDefaultWidth;d&&"auto"!=d&&(d+=b.opts.imageResizeWithPercent?"%":"px"),b.html.insert('<img data-fr-image-pasted="true" class="'+(b.opts.imageDefaultDisplay?"fr-di"+b.opts.imageDefaultDisplay[0]:"")+(b.opts.imageDefaultAlign&&"center"!=b.opts.imageDefaultAlign?" fr-fi"+b.opts.imageDefaultAlign[0]:"")+'" src="'+c+'"'+(d?' style="width: '+d+';"':"")+">"),b.events.trigger("paste.after")}function fa(a){var b=new FileReader;b.onload=ea,b.readAsDataURL(a)}function ga(a){if(a&&a.clipboardData&&a.clipboardData.items){var b=null;if(a.clipboardData.getData("text/rtf"))b=a.clipboardData.items[0].getAsFile();else for(var c=0;c<a.clipboardData.items.length&&!(b=a.clipboardData.items[c].getAsFile());c++);if(b)return fa(b),!1}}function ha(a){return a=a.replace(/<img /gi,'<img data-fr-image-pasted="true" ')}function ia(c){if("false"==a(this).parents("[contenteditable]:not(.fr-element):not(.fr-img-caption):not(body):first").attr("contenteditable"))return!0;if(c&&"touchend"==c.type&&Ra)return!0;if(c&&b.edit.isDisabled())return c.stopPropagation(),c.preventDefault(),!1;for(var d=0;d<a.FE.INSTANCES.length;d++)a.FE.INSTANCES[d]!=b&&a.FE.INSTANCES[d].events.trigger("image.hideResizer");b.toolbar.disable(),c&&(c.stopPropagation(),c.preventDefault()),b.helpers.isMobile()&&(b.events.disableBlur(),b.$el.blur(),b.events.enableBlur()),b.opts.iframe&&b.size.syncIframe(),Da=a(this),b.browser.msie||wa(),k(),e(),b.browser.msie||b.selection.clear(),b.helpers.isIOS()&&(b.events.disableBlur(),b.$el.blur()),b.button.bulkRefresh(),b.events.trigger("video.hideResizer")}function ja(a){Da&&(ma()||!0===a)&&(b.toolbar.enable(),Ea.removeClass("fr-active"),b.popups.hide("image.edit"),Da=null,la(),Fa=null,Ga&&Ga.hide())}function ka(){Sa=!0}function la(){Sa=!1}function ma(){return Sa}function na(a,c,d){if(b.opts.imageEditButtons.indexOf("imageAlign")<0&&b.opts.imageEditButtons.indexOf("imageDisplay")<0)return!1;!b.opts.htmlUntouched&&b.opts.useClasses?(a.removeClass("fr-fil fr-fir fr-dib fr-dii"),d&&a.addClass("fr-fi"+d[0]),c&&a.addClass("fr-di"+c[0])):"inline"==c?(a.css({display:"inline-block",verticalAlign:"bottom",margin:b.opts.imageDefaultMargin}),"center"==d?a.css({float:"none",marginBottom:"",marginTop:"",maxWidth:"calc(100% - "+2*b.opts.imageDefaultMargin+"px)",textAlign:"center"}):"left"==d?a.css({float:"left",marginLeft:0,maxWidth:"calc(100% - "+b.opts.imageDefaultMargin+"px)",textAlign:"left"}):a.css({float:"right",marginRight:0,maxWidth:"calc(100% - "+b.opts.imageDefaultMargin+"px)",textAlign:"right"})):"block"==c&&(a.css({display:"block",float:"none",verticalAlign:"top",margin:b.opts.imageDefaultMargin+"px auto",textAlign:"center"}),"left"==d?a.css({marginLeft:0,textAlign:"left"}):"right"==d&&a.css({marginRight:0,textAlign:"right"}))}function oa(a){var c=za();c.removeClass("fr-fir fr-fil"),!b.opts.htmlUntouched&&b.opts.useClasses?"left"==a?c.addClass("fr-fil"):"right"==a&&c.addClass("fr-fir"):na(c,qa(),a),wa(),k(),e(),b.selection.clear()}function pa(a){if(void 0===a&&(a=za()),a){if(a.hasClass("fr-fil"))return"left";if(a.hasClass("fr-fir"))return"right";if(a.hasClass("fr-dib")||a.hasClass("fr-dii"))return"center";var b=a.css("float");if(a.css("float","none"),"block"==a.css("display")){if(a.css("float",""),a.css("float")!=b&&a.css("float",b),0===parseInt(a.css("margin-left"),10))return"left";if(0===parseInt(a.css("margin-right"),10))return"right"}else{if(a.css("float",""),a.css("float")!=b&&a.css("float",b),"left"==a.css("float"))return"left";if("right"==a.css("float"))return"right"}}return"center"}function qa(a){void 0===a&&(a=za());var b=a.css("float");return a.css("float","none"),"block"==a.css("display")?(a.css("float",""),a.css("float")!=b&&a.css("float",b),"block"):(a.css("float",""),a.css("float")!=b&&a.css("float",b),"inline")}function ra(a){Da&&a.find("> *:first").replaceWith(b.icon.create("image-align-"+pa()))}function sa(a,b){Da&&b.find('.fr-command[data-param1="'+pa()+'"]').addClass("fr-active").attr("aria-selected",!0)}function ta(a){var c=za();c.removeClass("fr-dii fr-dib"),!b.opts.htmlUntouched&&b.opts.useClasses?"inline"==a?c.addClass("fr-dii"):"block"==a&&c.addClass("fr-dib"):na(c,a,pa()),wa(),k(),e(),b.selection.clear()}function ua(a,b){Da&&b.find('.fr-command[data-param1="'+qa()+'"]').addClass("fr-active").attr("aria-selected",!0)}function va(){var a=b.popups.get("image.insert");a||(a=M()),b.popups.isVisible("image.insert")||(s(),b.popups.refresh("image.insert"),b.popups.setContainer("image.insert",b.$sc));var c=za();Ba()&&(c=c.find(".fr-img-wrap"));var d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show("image.insert",d,e,c.outerHeight(!0))}function wa(){if(Da){b.events.disableBlur(),b.selection.clear();var a=b.doc.createRange();a.selectNode(Da.get(0));b.selection.get().addRange(a),b.events.enableBlur()}}function xa(){Da?(b.events.disableBlur(),a(".fr-popup input:focus").blur(),w(Da)):(b.events.disableBlur(),b.selection.restore(),b.events.enableBlur(),b.popups.hide("image.insert"),b.toolbar.showInline())}function ya(){return Da}function za(){return Ba()?Da.parents(".fr-img-caption:first"):Da}function Aa(a,c,d){if(void 0===c&&(c=b.opts.imageStyles),void 0===d&&(d=b.opts.imageMultipleStyles),!Da)return!1;var e=za();if(!d){var f=Object.keys(c);f.splice(f.indexOf(a),1),e.removeClass(f.join(" "))}"object"==typeof c[a]?(e.removeAttr("style"),e.css(c[a].style)):e.toggleClass(a),w(Da)}function Ba(){return!!Da&&Da.parents(".fr-img-caption").length>0}function Ca(){var c;Da&&!Ba()?(c=Da,Da.parent().is("a")&&(c=Da.parent()),c.wrap("<span "+(b.browser.mozilla?"":'contenteditable="false"')+'class="fr-img-caption '+Da.attr("class")+'" style="'+Da.attr("style")+'" draggable="false"></span>'),c.wrap('<span class="fr-img-wrap"></span>'),c.after('<span class="fr-inner" contenteditable="true">'+a.FE.START_MARKER+"Image caption"+a.FE.END_MARKER+"</span>"),Da.parent().css("width",Da.width()),Da.removeAttr("class").removeAttr("style"),ja(!0),b.selection.restore()):(c=za(),Da.insertAfter(c),Da.attr("class",c.attr("class").replace("fr-img-caption","")).attr("style",c.attr("style")),c.remove(),w(Da))}var Da,Ea,Fa,Ga,Ha=!1,Ia=1,Ja=2,Ka=3,La=4,Ma=5,Na=6,Oa=8,Pa={};Pa[Ia]="Image cannot be loaded from the passed link.",Pa[Ja]="No link in upload response.",Pa[Ka]="Error during file upload.",Pa[La]="Parsing response failed.",Pa[Ma]="File is too large.",Pa[Na]="Image file type is invalid.",Pa[7]="Files can be uploaded only to same domain in IE 8 and IE 9.",Pa[Oa]="Image file is corrupted.";var Qa,Ra,Sa=!1;return{_init:ba,showInsertPopup:d,showLayer:V,refreshUploadButton:W,refreshByURLButton:X,upload:H,insertByURL:v,align:oa,refreshAlign:ra,refreshAlignOnShow:sa,display:ta,refreshDisplayOnShow:ua,replace:va,back:xa,get:ya,getEl:za,insert:y,showProgressBar:r,remove:$,hideProgressBar:s,applyStyle:Aa,showAltPopup:O,showSizePopup:S,setAlt:Q,setSize:U,toggleCaption:Ca,hasCaption:Ba,exitEdit:ja,edit:w}},a.FE.DefineIcon("insertImage",{NAME:"image"}),a.FE.RegisterShortcut(a.FE.KEYCODE.P,"insertImage",null,"P"),a.FE.RegisterCommand("insertImage",{title:"Insert Image",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("image.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("image.insert")):this.image.showInsertPopup()},plugin:"image"}),a.FE.DefineIcon("imageUpload",{NAME:"upload"}),a.FE.RegisterCommand("imageUpload",{title:"Upload Image",undo:!1,focus:!1,toggle:!0,callback:function(){this.image.showLayer("image-upload")},refresh:function(a){this.image.refreshUploadButton(a)}}),a.FE.DefineIcon("imageByURL",{NAME:"link"}),a.FE.RegisterCommand("imageByURL",{title:"By URL",undo:!1,focus:!1,toggle:!0,callback:function(){this.image.showLayer("image-by-url")},refresh:function(a){this.image.refreshByURLButton(a)}}),a.FE.RegisterCommand("imageInsertByURL",{title:"Insert Image",undo:!0,refreshAfterCallback:!1,callback:function(){this.image.insertByURL()},refresh:function(a){this.image.get()?a.text(this.language.translate("Replace")):a.text(this.language.translate("Insert"))}}),a.FE.DefineIcon("imageDisplay",{NAME:"star"}),a.FE.RegisterCommand("imageDisplay",{title:"Display",type:"dropdown",options:{inline:"Inline",block:"Break Text"},callback:function(a,b){this.image.display(b)},refresh:function(a){this.opts.imageTextNear||a.addClass("fr-hidden")},refreshOnShow:function(a,b){this.image.refreshDisplayOnShow(a,b)}}),a.FE.DefineIcon("image-align",{NAME:"align-left"}),a.FE.DefineIcon("image-align-left",{NAME:"align-left"}),a.FE.DefineIcon("image-align-right",{NAME:"align-right"}),a.FE.DefineIcon("image-align-center",{NAME:"align-justify"}),a.FE.DefineIcon("imageAlign",{NAME:"align-justify"}),a.FE.RegisterCommand("imageAlign",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"None",right:"Align Right"},html:function(){var b='<ul class="fr-dropdown-list" role="presentation">',c=a.FE.COMMANDS.imageAlign.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="imageAlign" data-param1="'+d+'" title="'+this.language.translate(c[d])+'">'+this.icon.create("image-align-"+d)+'<span class="fr-sr-only">'+this.language.translate(c[d])+"</span></a></li>");return b+="</ul>"},callback:function(a,b){this.image.align(b)},refresh:function(a){this.image.refreshAlign(a)},refreshOnShow:function(a,b){this.image.refreshAlignOnShow(a,b)}}),a.FE.DefineIcon("imageReplace",{NAME:"exchange"}),a.FE.RegisterCommand("imageReplace",{title:"Replace",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,callback:function(){this.image.replace()}}),a.FE.DefineIcon("imageRemove",{NAME:"trash"}),a.FE.RegisterCommand("imageRemove",{title:"Remove",callback:function(){this.image.remove()}}),a.FE.DefineIcon("imageBack",{NAME:"arrow-left"}),a.FE.RegisterCommand("imageBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.image.back()},refresh:function(a){this.image.get()||this.opts.toolbarInline?(a.removeClass("fr-hidden"),a.next(".fr-separator").removeClass("fr-hidden")):(a.addClass("fr-hidden"),a.next(".fr-separator").addClass("fr-hidden"))}}),a.FE.RegisterCommand("imageDismissError",{title:"OK",undo:!1,callback:function(){this.image.hideProgressBar(!0)}}),a.FE.DefineIcon("imageStyle",{NAME:"magic"}),a.FE.RegisterCommand("imageStyle",{title:"Style",type:"dropdown",html:function(){var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.imageStyles;for(var c in b)if(b.hasOwnProperty(c)){var d=b[c];"object"==typeof d&&(d=d.title),a+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="imageStyle" data-param1="'+c+'">'+this.language.translate(d)+"</a></li>"}return a+="</ul>"},callback:function(a,b){this.image.applyStyle(b)},refreshOnShow:function(b,c){var d=this.image.getEl();d&&c.find(".fr-command").each(function(){var b=a(this).data("param1"),c=d.hasClass(b);a(this).toggleClass("fr-active",c).attr("aria-selected",c)})}}),a.FE.DefineIcon("imageAlt",{NAME:"info"}),a.FE.RegisterCommand("imageAlt",{undo:!1,focus:!1,popup:!0,title:"Alternate Text",callback:function(){this.image.showAltPopup()}}),a.FE.RegisterCommand("imageSetAlt",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.image.setAlt()}}),a.FE.DefineIcon("imageSize",{NAME:"arrows-alt"}),a.FE.RegisterCommand("imageSize",{undo:!1,focus:!1,popup:!0,title:"Change Size",callback:function(){this.image.showSizePopup()}}),a.FE.RegisterCommand("imageSetSize",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.image.setSize()}}),a.FE.DefineIcon("imageCaption",{NAME:"commenting"}),a.FE.RegisterCommand("imageCaption",{undo:!0,focus:!1,title:"Image Caption",refreshAfterCallback:!0,callback:function(){this.image.toggleCaption()},refresh:function(a){this.image.get()&&a.toggleClass("fr-active",this.image.hasCaption())}}),a.extend(a.FE.DEFAULTS,{imageManagerLoadURL:"https://i.froala.com/load-files",imageManagerLoadMethod:"get",imageManagerLoadParams:{},imageManagerPreloader:"",imageManagerDeleteURL:"",imageManagerDeleteMethod:"post",imageManagerDeleteParams:{},imageManagerPageSize:12,imageManagerScrollOffset:20,imageManagerToggleTags:!0}),a.FE.PLUGINS.imageManager=function(b){function c(){if(!z){var a='<div class="fr-modal-head-line"><i class="fa fa-bars fr-modal-more fr-not-available" id="fr-modal-more-'+b.sid+'" title="'+b.language.translate("Tags")+'"></i><h4 data-text="true">'+b.language.translate("Manage Images")+"</h4></div>";a+='<div class="fr-modal-tags" id="fr-modal-tags"></div>';var c='<img class="fr-preloader" id="fr-preloader" alt="'+b.language.translate("Loading")+'.." src="'+b.opts.imageManagerPreloader+'" style="display: none;">';c+='<div class="fr-image-list" id="fr-image-list"></div>';var d=b.modals.create(K,a,c);z=d.$modal,A=d.$head,B=d.$body}z.data("current-image",b.image.get()),b.modals.show(K),C||x(),g()}function d(){b.modals.hide(K)}function e(){var b=a(window).outerWidth();return b<768?2:b<1200?3:4}function f(){D.empty();for(var a=0;a<J;a++)D.append('<div class="fr-list-column"></div>')}function g(){C.show(),D.find(".fr-list-column").empty(),b.opts.imageManagerLoadURL?a.ajax({url:b.opts.imageManagerLoadURL,method:b.opts.imageManagerLoadMethod,data:b.opts.imageManagerLoadParams,dataType:"json",crossDomain:b.opts.requestWithCORS,xhrFields:{withCredentials:b.opts.requestWithCredentials},headers:b.opts.requestHeaders}).done(function(a,c,d){b.events.trigger("imageManager.imagesLoaded",[a]),h(a,d.response),C.hide()}).fail(function(){var a=this.xhr();s(M,a.response||a.responseText)}):s(N)}function h(a,b){try{D.find(".fr-list-column").empty(),G=0,H=0,I=0,F=a,i()}catch(c){s(O,b)}}function i(){if(H<F.length&&(D.outerHeight()<=B.outerHeight()+b.opts.imageManagerScrollOffset||B.scrollTop()+b.opts.imageManagerScrollOffset>D.outerHeight()-B.outerHeight())){G++;for(var a=b.opts.imageManagerPageSize*(G-1);a<Math.min(F.length,b.opts.imageManagerPageSize*G);a++)j(F[a])}}function j(c){var d=new Image,e=a('<div class="fr-image-container fr-empty fr-image-'+I+++'" data-loading="'+b.language.translate("Loading")+'.." data-deleting="'+b.language.translate("Deleting")+'..">');n(!1),d.onload=function(){e.height(Math.floor(e.width()/d.width*d.height));var f=a("<img/>");if(c.thumb)f.attr("src",c.thumb);else{if(s(P,c),!c.url)return s(Q,c),!1;f.attr("src",c.url)}if(c.url&&f.attr("data-url",c.url),c.tag)if(A.find(".fr-modal-more.fr-not-available").removeClass("fr-not-available"),A.find(".fr-modal-tags").show(),c.tag.indexOf(",")>=0){for(var g=c.tag.split(","),h=0;h<g.length;h++)g[h]=g[h].trim(),0===E.find('a[title="'+g[h]+'"]').length&&E.append('<a role="button" title="'+g[h]+'">'+g[h]+"</a>");f.attr("data-tag",g.join())}else 0===E.find('a[title="'+c.tag.trim()+'"]').length&&E.append('<a role="button" title="'+c.tag.trim()+'">'+c.tag.trim()+"</a>"),f.attr("data-tag",c.tag.trim());c.name&&f.attr("alt",c.name);for(var j in c)c.hasOwnProperty(j)&&"thumb"!=j&&"url"!=j&&"tag"!=j&&f.attr("data-"+j,c[j]);e.append(f).append(a(b.icon.create("imageManagerDelete")).addClass("fr-delete-img").attr("title",b.language.translate("Delete"))).append(a(b.icon.create("imageManagerInsert")).addClass("fr-insert-img").attr("title",b.language.translate("Insert"))),E.find(".fr-selected-tag").each(function(a,b){w(f,b.text)||e.hide()}),f.on("load",function(){e.removeClass("fr-empty"),e.height("auto"),H++,m(l(parseInt(f.parent().attr("class").match(/fr-image-(\d+)/)[1],10)+1)),n(!1),H%b.opts.imageManagerPageSize==0&&i()}),b.events.trigger("imageManager.imageLoaded",[f])},d.onerror=function(){H++,e.remove(),m(l(parseInt(e.attr("class").match(/fr-image-(\d+)/)[1],10)+1)),s(L,c),H%b.opts.imageManagerPageSize==0&&i()},d.src=c.thumb||c.url,k().append(e)}function k(){var b,c;return D.find(".fr-list-column").each(function(d,e){var f=a(e);0===d?(c=f.outerHeight(),b=f):f.outerHeight()<c&&(c=f.outerHeight(),b=f)}),b}function l(b){void 0===b&&(b=0);for(var c=[],d=I-1;d>=b;d--){var e=D.find(".fr-image-"+d);e.length&&(c.push(e),a('<div id="fr-image-hidden-container">').append(e),D.find(".fr-image-"+d).remove())}return c}function m(a){for(var b=a.length-1;b>=0;b--)k().append(a[b])}function n(a){if(void 0===a&&(a=!0),!z.is(":visible"))return!0;var c=e();if(c!=J){J=c;var d=l();f(),m(d)}b.modals.resize(K),a&&i()}function o(a){var b={},c=a.data();for(var d in c)c.hasOwnProperty(d)&&"url"!=d&&"tag"!=d&&(b[d]=c[d]);return b}function p(c){var d=a(c.currentTarget).siblings("img"),e=z.data("instance")||b,f=z.data("current-image");if(b.modals.hide(K),e.image.showProgressBar(),f)f.data("fr-old-src",f.attr("src")),f.trigger("click");else{e.events.focus(!0),e.selection.restore();var g=e.position.getBoundingRect(),h=g.left+g.width/2+a(b.doc).scrollLeft(),i=g.top+g.height+a(b.doc).scrollTop();e.popups.setContainer("image.insert",b.$sc),e.popups.show("image.insert",h,i)}e.image.insert(d.data("url"),!1,o(d),f)}function q(){z.find("#fr-modal-tags > a").each(function(){0===z.find('#fr-image-list [data-tag*="'+a(this).text()+'"]').length&&a(this).removeClass("fr-selected-tag").hide()}),u()}function r(c){var d=a(c.currentTarget).siblings("img"),e=b.language.translate("Are you sure? Image will be deleted.");confirm(e)&&(b.opts.imageManagerDeleteURL?!1!==b.events.trigger("imageManager.beforeDeleteImage",[d])&&(d.parent().addClass("fr-image-deleting"),a.ajax({method:b.opts.imageManagerDeleteMethod,url:b.opts.imageManagerDeleteURL,data:a.extend(a.extend({src:d.attr("src")},o(d)),b.opts.imageManagerDeleteParams),crossDomain:b.opts.requestWithCORS,xhrFields:{withCredentials:b.opts.requestWithCredentials},headers:b.opts.requestHeaders}).done(function(a){b.events.trigger("imageManager.imageDeleted",[a]);var c=l(parseInt(d.parent().attr("class").match(/fr-image-(\d+)/)[1],10)+1);d.parent().remove(),m(c),q(),n(!0)}).fail(function(){var a=this.xhr();s(R,a.response||a.responseText)})):s(S))}function s(c,d){10<=c&&c<20?C.hide():20<=c&&c<30&&a(".fr-image-deleting").removeClass("fr-image-deleting"),b.events.trigger("imageManager.error",[{code:c,message:T[c]},d])}function t(){var a=A.find(".fr-modal-head-line").outerHeight(),b=E.outerHeight();A.toggleClass("fr-show-tags"),A.hasClass("fr-show-tags")?(A.css("height",a+b),E.find("a").css("opacity",1)):(A.css("height",a),E.find("a").css("opacity",0))}function u(){var b=E.find(".fr-selected-tag");b.length>0?(D.find("img").parent().show(),b.each(function(b,c){D.find("img").each(function(b,d){var e=a(d);w(e,c.text)||e.parent().hide()})})):D.find("img").parent().show(),m(l()),i()}function v(c){c.preventDefault();var d=a(c.currentTarget);d.toggleClass("fr-selected-tag"),b.opts.imageManagerToggleTags&&d.siblings("a").removeClass("fr-selected-tag"),u()}function w(a,b){for(var c=(a.attr("data-tag")||"").split(","),d=0;d<c.length;d++)if(c[d]==b)return!0;return!1}function x(){C=z.find("#fr-preloader"),D=z.find("#fr-image-list"),E=z.find("#fr-modal-tags"),J=e(),f(),A.css("height",A.find(".fr-modal-head-line").outerHeight()),b.events.$on(a(b.o_win),"resize",function(){n(F?!0:!1)}),b.helpers.isMobile()&&(b.events.bindClick(D,"div.fr-image-container",function(b){z.find(".fr-mobile-selected").removeClass("fr-mobile-selected"),a(b.currentTarget).addClass("fr-mobile-selected")}),z.on(b._mousedown,function(){z.find(".fr-mobile-selected").removeClass("fr-mobile-selected")})),b.events.bindClick(D,".fr-insert-img",p),b.events.bindClick(D,".fr-delete-img",r),z.on(b._mousedown+" "+b._mouseup,function(a){a.stopPropagation()}),z.on(b._mousedown,"*",function(){b.events.disableBlur()}),B.on("scroll",i),b.events.bindClick(z,"i#fr-modal-more-"+b.sid,t),b.events.bindClick(E,"a",v)}function y(){if(!b.$wp&&"IMG"!=b.el.tagName)return!1}var z,A,B,C,D,E,F,G,H,I,J,K="image_manager",L=10,M=11,N=12,O=13,P=14,Q=15,R=21,S=22,T={};return T[L]="Image cannot be loaded from the passed link.",T[M]="Error during load images request.",T[N]="Missing imageManagerLoadURL option.",T[O]="Parsing load response failed.",T[P]="Missing image thumb.",T[Q]="Missing image URL.",T[R]="Error during delete image request.",T[S]="Missing imageManagerDeleteURL option.",{require:["image"],_init:y,show:c,hide:d}},!a.FE.PLUGINS.image)throw new Error("Image manager plugin requires image plugin.");a.FE.DEFAULTS.imageInsertButtons.push("imageManager"),a.FE.RegisterCommand("imageManager",{title:"Browse",undo:!1,focus:!1,modal:!0,callback:function(){this.imageManager.show()},plugin:"imageManager"}),a.FE.DefineIcon("imageManager",{NAME:"folder"}),a.FE.DefineIcon("imageManagerInsert",{NAME:"plus"}),a.FE.DefineIcon("imageManagerDelete",{NAME:"trash"}),a.extend(a.FE.DEFAULTS,{inlineStyles:{"Big Red":"font-size: 20px; color: red;","Small Blue":"font-size: 14px; color: blue;"}}),a.FE.PLUGINS.inlineStyle=function(b){function c(c){""!==b.selection.text()?b.html.insert(a.FE.START_MARKER+'<span style="'+c+'">'+b.selection.text()+"</span>"+a.FE.END_MARKER):b.html.insert('<span style="'+c+'">'+a.FE.INVISIBLE_SPACE+a.FE.MARKERS+"</span>")}return{apply:c}},a.FE.RegisterCommand("inlineStyle",{type:"dropdown",html:function(){var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.inlineStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role="presentation"><span style="'+b[c]+'" role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="inlineStyle" data-param1="'+b[c]+'" title="'+this.language.translate(c)+'">'+this.language.translate(c)+"</a></span></li>");return a+="</ul>"},title:"Inline Style",callback:function(a,b){this.inlineStyle.apply(b)},plugin:"inlineStyle"}),a.FE.DefineIcon("inlineStyle",{NAME:"paint-brush"}),a.extend(a.FE.DEFAULTS,{lineBreakerTags:["table","hr","form","dl","span.fr-video",".fr-embedly",".fr-img-caption"],lineBreakerOffset:15,lineBreakerHorizontalOffset:10}),a.FE.PLUGINS.lineBreaker=function(b){function c(a,c){var d,e,f,g,h,i,j,k;if(null==a)g=c.parent(),h=g.offset().top,j=c.offset().top,d=j-Math.min((j-h)/2,b.opts.lineBreakerOffset),f=g.outerWidth(),e=g.offset().left;else if(null==c)g=a.parent(),i=g.offset().top+g.outerHeight(),k=a.offset().top+a.outerHeight(),d=k+Math.min((i-k)/2,b.opts.lineBreakerOffset),f=g.outerWidth(),e=g.offset().left;else{g=a.parent();var l=a.offset().top+a.height(),m=c.offset().top;if(l>m)return!1;d=(l+m)/2,f=g.outerWidth(),e=g.offset().left}b.opts.iframe&&(e+=b.$iframe.offset().left-b.helpers.scrollLeft(),d+=b.$iframe.offset().top-b.helpers.scrollTop()),b.$box.append(r),r.css("top",d-b.win.pageYOffset),r.css("left",e-b.win.pageXOffset),r.css("width",f),r.data("tag1",a),r.data("tag2",c),r.addClass("fr-visible").data("instance",b)}function d(a,d){var f,g,h=a.offset().top,i=a.offset().top+a.outerHeight();if(Math.abs(i-d)<=b.opts.lineBreakerOffset||Math.abs(d-h)<=b.opts.lineBreakerOffset)if(Math.abs(i-d)<Math.abs(d-h)){g=a.get(0);for(var j=g.nextSibling;j&&j.nodeType==Node.TEXT_NODE&&0===j.textContent.length;)j=j.nextSibling;if(!j)return c(a,null),!0;if(f=e(j))return c(a,f),!0}else{if(g=a.get(0),!g.previousSibling)return c(null,a),!0;if(f=e(g.previousSibling))return c(f,a),!0}r.removeClass("fr-visible").removeData("instance")}function e(c){if(c){var d=a(c);if(0===b.$el.find(d).length)return null;if(c.nodeType!=Node.TEXT_NODE&&d.is(b.opts.lineBreakerTags.join(",")))return d;if(d.parents(b.opts.lineBreakerTags.join(",")).length>0)return c=d.parents(b.opts.lineBreakerTags.join(",")).get(0),0!==b.$el.find(c).length&&a(c).is(b.opts.lineBreakerTags.join(","))?a(c):null}return null}function f(a){if(void 0!==a.inFroalaWrapper)return a.inFroalaWrapper;for(var c=a;a.parentNode&&a.parentNode!==b.$wp.get(0);)a=a.parentNode;return c.inFroalaWrapper=a.parentNode==b.$wp.get(0),c.inFroalaWrapper}function g(a,c){var d=b.doc.elementFromPoint(a,c);return d&&!d.closest(".fr-line-breaker")&&!b.node.isElement(d)&&d!=b.$wp.get(0)&&f(d)?d:null}function h(a,c,d){for(var e=d,f=null;e<=b.opts.lineBreakerOffset&&!f;)f=g(a,c-e),f||(f=g(a,c+e)),e+=d;return f}function i(a,c,d){for(var e=null,f=100;!e&&a>b.$box.offset().left&&a<b.$box.offset().left+b.$box.outerWidth()&&f>0;)e=g(a,c),e||(e=h(a,c,5)),"left"==d?a-=b.opts.lineBreakerHorizontalOffset:a+=b.opts.lineBreakerHorizontalOffset,f-=b.opts.lineBreakerHorizontalOffset;return e}function j(a){t=null;var c=null,f=null,g=b.doc.elementFromPoint(a.pageX-b.win.pageXOffset,a.pageY-b.win.pageYOffset);g&&("HTML"==g.tagName||"BODY"==g.tagName||b.node.isElement(g)||(g.getAttribute("class")||"").indexOf("fr-line-breaker")>=0)?(f=h(a.pageX-b.win.pageXOffset,a.pageY-b.win.pageYOffset,1),f||(f=i(a.pageX-b.win.pageXOffset-b.opts.lineBreakerHorizontalOffset,a.pageY-b.win.pageYOffset,"left")),f||(f=i(a.pageX-b.win.pageXOffset+b.opts.lineBreakerHorizontalOffset,a.pageY-b.win.pageYOffset,"right")),c=e(f)):c=e(g),c?d(c,a.pageY):b.core.sameInstance(r)&&r.removeClass("fr-visible").removeData("instance")}function k(a){return!(r.hasClass("fr-visible")&&!b.core.sameInstance(r))&&(b.popups.areVisible()||b.el.querySelector(".fr-selected-cell")?(r.removeClass("fr-visible"),!0):void(!1!==s||b.edit.isDisabled()||(t&&clearTimeout(t),t=setTimeout(j,30,a))))}function l(){t&&clearTimeout(t),r.hasClass("fr-visible")&&r.removeClass("fr-visible").removeData("instance")}function m(){s=!0,l()}function n(){s=!1}function o(c){if(!b.core.sameInstance(r))return!0;c.preventDefault(),r.removeClass("fr-visible").removeData("instance");var d=r.data("tag1"),e=r.data("tag2"),f=b.html.defaultTag();null==d?f&&"TD"!=e.parent().get(0).tagName&&0===e.parents(f).length?e.before("<"+f+">"+a.FE.MARKERS+"<br></"+f+">"):e.before(a.FE.MARKERS+"<br>"):f&&"TD"!=d.parent().get(0).tagName&&0===d.parents(f).length?d.after("<"+f+">"+a.FE.MARKERS+"<br></"+f+">"):d.after(a.FE.MARKERS+"<br>"),b.selection.restore()}function p(){b.shared.$line_breaker||(b.shared.$line_breaker=a('<div class="fr-line-breaker"><a class="fr-floating-btn" role="button" tabIndex="-1" title="'+b.language.translate("Break")+'"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect x="21" y="11" width="2" height="8"/><rect x="14" y="17" width="7" height="2"/><path d="M14.000,14.000 L14.000,22.013 L9.000,18.031 L14.000,14.000 Z"/></svg></a></div>')),r=b.shared.$line_breaker,b.events.on("shared.destroy",function(){r.html("").removeData().remove(),r=null},!0),b.events.on("destroy",function(){r.removeData("instance").removeClass("fr-visible").appendTo("body:first"),clearTimeout(t)},!0),b.events.$on(r,"mousemove",function(a){a.stopPropagation()},!0),b.events.bindClick(r,"a",o)}function q(){if(!b.$wp)return!1;p(),s=!1,b.events.$on(b.$win,"mousemove",k),b.events.$on(a(b.win),"scroll",l),b.events.on("popups.show.table.edit",l),b.events.on("commands.after",l),b.events.$on(a(b.win),"mousedown",m),b.events.$on(a(b.win),"mouseup",n)}var r,s,t;return{_init:q}},a.extend(a.FE.POPUP_TEMPLATES,{"link.edit":"[_BUTTONS_]","link.insert":"[_BUTTONS_][_INPUT_LAYER_]"}),a.extend(a.FE.DEFAULTS,{linkEditButtons:["linkOpen","linkStyle","linkEdit","linkRemove"],linkInsertButtons:["linkBack","|","linkList"],linkAttributes:{},linkAutoPrefix:"http://",linkStyles:{"fr-green":"Green","fr-strong":"Thick"},linkMultipleStyles:!0,linkConvertEmailAddress:!0,linkAlwaysBlank:!1,linkAlwaysNoFollow:!1,linkList:[{text:"Froala",href:"https://froala.com",target:"_blank"},{text:"Google",href:"https://google.com",target:"_blank"},{displayText:"Facebook",href:"https://facebook.com"}],linkText:!0}),a.FE.PLUGINS.link=function(b){function c(){var c=b.image?b.image.get():null;if(!c&&b.$wp){var d=b.selection.ranges(0).commonAncestorContainer;if(d&&(d.contains&&d.contains(b.el)||!b.el.contains(d)||b.el==d)&&(d=null),d&&"A"===d.tagName)return d;var e=b.selection.element(),f=b.selection.endElement();return"A"==e.tagName||b.node.isElement(e)||(e=a(e).parentsUntil(b.$el,"a:first").get(0)),"A"==f.tagName||b.node.isElement(f)||(f=a(f).parentsUntil(b.$el,"a:first").get(0)),f&&(f.contains&&f.contains(b.el)||!b.el.contains(f)||b.el==f)&&(f=null),e&&(e.contains&&e.contains(b.el)||!b.el.contains(e)||b.el==e)&&(e=null),f&&f==e&&"A"==f.tagName?(b.browser.msie||b.helpers.isMobile())&&(b.selection.info(e).atEnd||b.selection.info(e).atStart)?null:e:null}return"A"==b.el.tagName?b.el:c&&c.get(0).parentNode&&"A"==c.get(0).parentNode.tagName?c.get(0).parentNode:void 0}function d(){var a=b.image?b.image.get():null,c=[];if(a)"A"==a.get(0).parentNode.tagName&&c.push(a.get(0).parentNode);else{var d,e,f,g;if(b.win.getSelection){var h=b.win.getSelection();if(h.getRangeAt&&h.rangeCount){g=b.doc.createRange();for(var i=0;i<h.rangeCount;++i)if(d=h.getRangeAt(i),
e=d.commonAncestorContainer,e&&1!=e.nodeType&&(e=e.parentNode),e&&"a"==e.nodeName.toLowerCase())c.push(e);else{f=e.getElementsByTagName("a");for(var j=0;j<f.length;++j)g.selectNodeContents(f[j]),g.compareBoundaryPoints(d.END_TO_START,d)<1&&g.compareBoundaryPoints(d.START_TO_END,d)>-1&&c.push(f[j])}}}else if(b.doc.selection&&"Control"!=b.doc.selection.type)if(d=b.doc.selection.createRange(),e=d.parentElement(),"a"==e.nodeName.toLowerCase())c.push(e);else{f=e.getElementsByTagName("a"),g=b.doc.body.createTextRange();for(var k=0;k<f.length;++k)g.moveToElementText(f[k]),g.compareEndPoints("StartToEnd",d)>-1&&g.compareEndPoints("EndToStart",d)<1&&c.push(f[k])}}return c}function e(d){if(b.core.hasFocus()){if(g(),d&&"keyup"===d.type&&(d.altKey||d.which==a.FE.KEYCODE.ALT))return!0;setTimeout(function(){if(!d||d&&(1==d.which||"mouseup"!=d.type)){var e=c(),g=b.image?b.image.get():null;if(e&&!g){if(b.image){var h=b.node.contents(e);if(1==h.length&&"IMG"==h[0].tagName){var i=b.selection.ranges(0);return 0===i.startOffset&&0===i.endOffset?a(e).before(a.FE.MARKERS):a(e).after(a.FE.MARKERS),b.selection.restore(),!1}}d&&d.stopPropagation(),f(e)}}},b.helpers.isIOS()?100:0)}}function f(c){var d=b.popups.get("link.edit");d||(d=h());var e=a(c);b.popups.isVisible("link.edit")||b.popups.refresh("link.edit"),b.popups.setContainer("link.edit",b.$sc);var f=e.offset().left+a(c).outerWidth()/2,g=e.offset().top+e.outerHeight();b.popups.show("link.edit",f,g,e.outerHeight())}function g(){b.popups.hide("link.edit")}function h(){var a="";b.opts.linkEditButtons.length>1&&("A"==b.el.tagName&&b.opts.linkEditButtons.indexOf("linkRemove")>=0&&b.opts.linkEditButtons.splice(b.opts.linkEditButtons.indexOf("linkRemove"),1),a='<div class="fr-buttons">'+b.button.buildList(b.opts.linkEditButtons)+"</div>");var d={buttons:a},e=b.popups.create("link.edit",d);return b.$wp&&b.events.$on(b.$wp,"scroll.link-edit",function(){c()&&b.popups.isVisible("link.edit")&&f(c())}),e}function i(){}function j(){var d=b.popups.get("link.insert"),e=c();if(e){var f,g,h=a(e),i=d.find('input.fr-link-attr[type="text"]'),j=d.find('input.fr-link-attr[type="checkbox"]');for(f=0;f<i.length;f++)g=a(i[f]),g.val(h.attr(g.attr("name")||""));for(j.prop("checked",!1),f=0;f<j.length;f++)g=a(j[f]),h.attr(g.attr("name"))==g.data("checked")&&g.prop("checked",!0);d.find('input.fr-link-attr[type="text"][name="text"]').val(h.text())}else d.find('input.fr-link-attr[type="text"]').val(""),d.find('input.fr-link-attr[type="checkbox"]').prop("checked",!1),d.find('input.fr-link-attr[type="text"][name="text"]').val(b.selection.text());d.find("input.fr-link-attr").trigger("change"),(b.image?b.image.get():null)?d.find('.fr-link-attr[name="text"]').parent().hide():d.find('.fr-link-attr[name="text"]').parent().show()}function k(){var a=b.$tb.find('.fr-command[data-cmd="insertLink"]'),c=b.popups.get("link.insert");if(c||(c=l()),!c.hasClass("fr-active"))if(b.popups.refresh("link.insert"),b.popups.setContainer("link.insert",b.$tb||b.$sc),a.is(":visible")){var d=a.offset().left+a.outerWidth()/2,e=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show("link.insert",d,e,a.outerHeight())}else b.position.forSelection(c),b.popups.show("link.insert")}function l(a){if(a)return b.popups.onRefresh("link.insert",j),b.popups.onHide("link.insert",i),!0;var d="";b.opts.linkInsertButtons.length>=1&&(d='<div class="fr-buttons">'+b.button.buildList(b.opts.linkInsertButtons)+"</div>");var e='<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" viewBox="0 0 32 32"><path d="M27 4l-15 15-7-7-5 5 12 12 20-20z" fill="#FFF"></path></svg>',f="",g=0;f='<div class="fr-link-insert-layer fr-layer fr-active" id="fr-link-insert-layer-'+b.id+'">',f+='<div class="fr-input-line"><input id="fr-link-insert-layer-url-'+b.id+'" name="href" type="text" class="fr-link-attr" placeholder="'+b.language.translate("URL")+'" tabIndex="'+ ++g+'"></div>',b.opts.linkText&&(f+='<div class="fr-input-line"><input id="fr-link-insert-layer-text-'+b.id+'" name="text" type="text" class="fr-link-attr" placeholder="'+b.language.translate("Text")+'" tabIndex="'+ ++g+'"></div>');for(var h in b.opts.linkAttributes)if(b.opts.linkAttributes.hasOwnProperty(h)){var k=b.opts.linkAttributes[h];f+='<div class="fr-input-line"><input name="'+h+'" type="text" class="fr-link-attr" placeholder="'+b.language.translate(k)+'" tabIndex="'+ ++g+'"></div>'}b.opts.linkAlwaysBlank||(f+='<div class="fr-checkbox-line"><span class="fr-checkbox"><input name="target" class="fr-link-attr" data-checked="_blank" type="checkbox" id="fr-link-target-'+b.id+'" tabIndex="'+ ++g+'"><span>'+e+'</span></span><label for="fr-link-target-'+b.id+'">'+b.language.translate("Open in new tab")+"</label></div>"),f+='<div class="fr-action-buttons"><button class="fr-command fr-submit" role="button" data-cmd="linkInsert" href="#" tabIndex="'+ ++g+'" type="button">'+b.language.translate("Insert")+"</button></div></div>";var l={buttons:d,input_layer:f},m=b.popups.create("link.insert",l);return b.$wp&&b.events.$on(b.$wp,"scroll.link-insert",function(){(b.image?b.image.get():null)&&b.popups.isVisible("link.insert")&&u(),c&&b.popups.isVisible("link.insert")&&s()}),m}function m(){var d=c(),e=b.image?b.image.get():null;if(!1===b.events.trigger("link.beforeRemove",[d]))return!1;e&&d?(e.unwrap(),b.image.edit(e)):d&&(b.selection.save(),a(d).replaceWith(a(d).html()),b.selection.restore(),g())}function n(){b.events.on("keyup",function(b){b.which!=a.FE.KEYCODE.ESC&&e(b)}),b.events.on("window.mouseup",e),b.events.$on(b.$el,"click","a",function(a){b.edit.isDisabled()&&a.preventDefault()}),b.helpers.isMobile()&&b.events.$on(b.$doc,"selectionchange",e),l(!0),"A"==b.el.tagName&&b.$el.addClass("fr-view"),b.events.on("toolbar.esc",function(){if(b.popups.isVisible("link.edit"))return b.events.disableBlur(),b.events.focus(),!1},!0)}function o(c){var d,e,f=b.opts.linkList[c],g=b.popups.get("link.insert"),h=g.find('input.fr-link-attr[type="text"]'),i=g.find('input.fr-link-attr[type="checkbox"]');for(e=0;e<h.length;e++)d=a(h[e]),f[d.attr("name")]?d.val(f[d.attr("name")]):"text"!=d.attr("name")&&d.val("");for(e=0;e<i.length;e++)d=a(i[e]),d.prop("checked",d.data("checked")==f[d.attr("name")]);b.accessibility.focusPopup(g)}function p(){var c,d,e=b.popups.get("link.insert"),f=e.find('input.fr-link-attr[type="text"]'),g=e.find('input.fr-link-attr[type="checkbox"]'),h=(f.filter('[name="href"]').val()||"").trim(),i=f.filter('[name="text"]').val(),j={};for(d=0;d<f.length;d++)c=a(f[d]),["href","text"].indexOf(c.attr("name"))<0&&(j[c.attr("name")]=c.val());for(d=0;d<g.length;d++)c=a(g[d]),c.is(":checked")?j[c.attr("name")]=c.data("checked"):j[c.attr("name")]=c.data("unchecked")||null;var k=b.helpers.scrollTop();r(h,i,j),a(b.o_win).scrollTop(k)}function q(){if(!b.selection.isCollapsed()){b.selection.save();for(var c=b.$el.find(".fr-marker").addClass("fr-unprocessed").toArray();c.length;){var d=a(c.pop());d.removeClass("fr-unprocessed");var e=b.node.deepestParent(d.get(0));if(e){var f=d.get(0),g="",h="";do{f=f.parentNode,b.node.isBlock(f)||(g+=b.node.closeTagString(f),h=b.node.openTagString(f)+h)}while(f!=e);var i=b.node.openTagString(d.get(0))+d.html()+b.node.closeTagString(d.get(0));d.replaceWith('<span id="fr-break"></span>');var j=e.outerHTML;j=j.replace(/<span id="fr-break"><\/span>/g,g+i+h),e.outerHTML=j}c=b.$el.find(".fr-marker.fr-unprocessed").toArray()}b.html.cleanEmptyTags(),b.selection.restore()}}function r(f,g,h){if(void 0===h&&(h={}),!1===b.events.trigger("link.beforeInsert",[f,g,h]))return!1;var i=b.image?b.image.get():null;i||"A"==b.el.tagName?"A"==b.el.tagName&&b.$el.focus():(b.selection.restore(),b.popups.hide("link.insert"));var j=f;b.opts.linkConvertEmailAddress&&b.helpers.isEmail(f)&&!/^mailto:.*/i.test(f)&&(f="mailto:"+f);var k=/^([A-Za-z]:(\\){1,2}|[A-Za-z]:((\\){1,2}[^\\]+)+)(\\)?$/i;if(""===b.opts.linkAutoPrefix||new RegExp("^("+a.FE.LinkProtocols.join("|")+"):.","i").test(f)||/^data:image.*/i.test(f)||/^(https?:|ftps?:|file:|)\/\//i.test(f)||k.test(f)||["/","{","[","#","("].indexOf((f||"")[0])<0&&(f=b.opts.linkAutoPrefix+f),f=b.helpers.sanitizeURL(f),b.opts.linkAlwaysBlank&&(h.target="_blank"),b.opts.linkAlwaysNoFollow&&(h.rel="nofollow"),"_blank"==h.target?h.rel?h.rel+=" noopener noreferrer":h.rel="noopener noreferrer":null==h.target&&(h.rel?h.rel=h.rel.replace(/noopener/,"").replace(/noreferrer/,""):h.rel=null),g=g||"",f===b.opts.linkAutoPrefix){return b.popups.get("link.insert").find('input[name="href"]').addClass("fr-error"),b.events.trigger("link.bad",[j]),!1}var l,m=c();if(m)l=a(m),l.attr("href",f),g.length>0&&l.text()!=g&&!i&&l.text(g),i||l.prepend(a.FE.START_MARKER).append(a.FE.END_MARKER),l.attr(h),i||b.selection.restore();else{i?i.wrap('<a href="'+f+'"></a>'):(b.format.remove("a"),b.selection.isCollapsed()?(g=0===g.length?j:g,b.html.insert('<a href="'+f+'">'+a.FE.START_MARKER+g+a.FE.END_MARKER+"</a>"),b.selection.restore()):g.length>0&&g!=b.selection.text().replace(/\n/g,"")?(b.selection.remove(),b.html.insert('<a href="'+f+'">'+a.FE.START_MARKER+g+a.FE.END_MARKER+"</a>"),b.selection.restore()):(q(),b.format.apply("a",{href:f})));for(var n=d(),o=0;o<n.length;o++)l=a(n[o]),l.attr(h),l.removeAttr("_moz_dirty");1==n.length&&b.$wp&&!i&&(a(n[0]).prepend(a.FE.START_MARKER).append(a.FE.END_MARKER),b.selection.restore())}if(i){var p=b.popups.get("link.insert");p&&p.find("input:focus").blur(),b.image.edit(i)}else e()}function s(){g();var d=c();if(d){var e=b.popups.get("link.insert");e||(e=l()),b.popups.isVisible("link.insert")||(b.popups.refresh("link.insert"),b.selection.save(),b.helpers.isMobile()&&(b.events.disableBlur(),b.$el.blur(),b.events.enableBlur())),b.popups.setContainer("link.insert",b.$sc);var f=(b.image?b.image.get():null)||a(d),h=f.offset().left+f.outerWidth()/2,i=f.offset().top+f.outerHeight();b.popups.show("link.insert",h,i,f.outerHeight())}}function t(){(b.image?b.image.get():null)?b.image.back():(b.events.disableBlur(),b.selection.restore(),b.events.enableBlur(),c()&&b.$wp?(b.selection.restore(),g(),e()):"A"==b.el.tagName?(b.$el.focus(),e()):(b.popups.hide("link.insert"),b.toolbar.showInline()))}function u(){var a=b.image?b.image.getEl():null;if(a){var c=b.popups.get("link.insert");b.image.hasCaption()&&(a=a.find(".fr-img-wrap")),c||(c=l()),j(!0),b.popups.setContainer("link.insert",b.$sc);var d=a.offset().left+a.outerWidth(!0)/2,e=a.offset().top+a.outerHeight(!0);b.popups.show("link.insert",d,e,a.outerHeight())}}function v(d,f,g){void 0===g&&(g=b.opts.linkMultipleStyles),void 0===f&&(f=b.opts.linkStyles);var h=c();if(!h)return!1;if(!g){var i=Object.keys(f);i.splice(i.indexOf(d),1),a(h).removeClass(i.join(" "))}a(h).toggleClass(d),e()}return{_init:n,remove:m,showInsertPopup:k,usePredefined:o,insertCallback:p,insert:r,update:s,get:c,allSelected:d,back:t,imageLink:u,applyStyle:v}},a.FE.DefineIcon("insertLink",{NAME:"link"}),a.FE.RegisterShortcut(a.FE.KEYCODE.K,"insertLink",null,"K"),a.FE.RegisterCommand("insertLink",{title:"Insert Link",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("link.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("link.insert")):this.link.showInsertPopup()},plugin:"link"}),a.FE.DefineIcon("linkOpen",{NAME:"external-link"}),a.FE.RegisterCommand("linkOpen",{title:"Open Link",undo:!1,refresh:function(a){this.link.get()?a.removeClass("fr-hidden"):a.addClass("fr-hidden")},callback:function(){var a=this.link.get();a&&(this.o_win.open(a.href,"_blank","noopener"),this.popups.hide("link.edit"))},plugin:"link"}),a.FE.DefineIcon("linkEdit",{NAME:"edit"}),a.FE.RegisterCommand("linkEdit",{title:"Edit Link",undo:!1,refreshAfterCallback:!1,popup:!0,callback:function(){this.link.update()},refresh:function(a){this.link.get()?a.removeClass("fr-hidden"):a.addClass("fr-hidden")},plugin:"link"}),a.FE.DefineIcon("linkRemove",{NAME:"unlink"}),a.FE.RegisterCommand("linkRemove",{title:"Unlink",callback:function(){this.link.remove()},refresh:function(a){this.link.get()?a.removeClass("fr-hidden"):a.addClass("fr-hidden")},plugin:"link"}),a.FE.DefineIcon("linkBack",{NAME:"arrow-left"}),a.FE.RegisterCommand("linkBack",{title:"Back",undo:!1,focus:!1,back:!0,refreshAfterCallback:!1,callback:function(){this.link.back()},refresh:function(a){var b=this.link.get()&&this.doc.hasFocus();(this.image?this.image.get():null)||b||this.opts.toolbarInline?(a.removeClass("fr-hidden"),a.next(".fr-separator").removeClass("fr-hidden")):(a.addClass("fr-hidden"),a.next(".fr-separator").addClass("fr-hidden"))},plugin:"link"}),a.FE.DefineIcon("linkList",{NAME:"search"}),a.FE.RegisterCommand("linkList",{title:"Choose Link",type:"dropdown",focus:!1,undo:!1,refreshAfterCallback:!1,html:function(){for(var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.linkList,c=0;c<b.length;c++)a+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkList" data-param1="'+c+'">'+(b[c].displayText||b[c].text)+"</a></li>";return a+="</ul>"},callback:function(a,b){this.link.usePredefined(b)},plugin:"link"}),a.FE.RegisterCommand("linkInsert",{focus:!1,refreshAfterCallback:!1,callback:function(){this.link.insertCallback()},refresh:function(a){this.link.get()?a.text(this.language.translate("Update")):a.text(this.language.translate("Insert"))},plugin:"link"}),a.FE.DefineIcon("imageLink",{NAME:"link"}),a.FE.RegisterCommand("imageLink",{title:"Insert Link",undo:!1,focus:!1,popup:!0,callback:function(){this.link.imageLink()},refresh:function(a){var b,c=this.link.get();c?(b=a.prev(),b.hasClass("fr-separator")&&b.removeClass("fr-hidden"),a.addClass("fr-hidden")):(b=a.prev(),b.hasClass("fr-separator")&&b.addClass("fr-hidden"),a.removeClass("fr-hidden"))},plugin:"link"}),a.FE.DefineIcon("linkStyle",{NAME:"magic"}),a.FE.RegisterCommand("linkStyle",{title:"Style",type:"dropdown",html:function(){var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.linkStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="linkStyle" data-param1="'+c+'">'+this.language.translate(b[c])+"</a></li>");return a+="</ul>"},callback:function(a,b){this.link.applyStyle(b)},refreshOnShow:function(b,c){var d=this.link.get();if(d){var e=a(d);c.find(".fr-command").each(function(){var b=a(this).data("param1"),c=e.hasClass(b);a(this).toggleClass("fr-active",c).attr("aria-selected",c)})}},refresh:function(a){this.link.get()?a.removeClass("fr-hidden"):a.addClass("fr-hidden")},plugin:"link"}),a.FE.PLUGINS.lists=function(b){function c(a){return'<span class="fr-open-'+a.toLowerCase()+'"></span>'}function d(a){return'<span class="fr-close-'+a.toLowerCase()+'"></span>'}function e(c,d){for(var e=[],f=0;f<c.length;f++){var g=c[f].parentNode;"LI"==c[f].tagName&&g.tagName!=d&&e.indexOf(g)<0&&e.push(g)}for(f=e.length-1;f>=0;f--){var h=a(e[f]);h.replaceWith("<"+d.toLowerCase()+" "+b.node.attributes(h.get(0))+">"+h.html()+"</"+d.toLowerCase()+">")}}function f(c,d){e(c,d);var f,g=b.html.defaultTag(),h=null;c.length&&(f="rtl"==b.opts.direction||"rtl"==a(c[0]).css("direction")?"margin-right":"margin-left");for(var i=0;i<c.length;i++)if("LI"!=c[i].tagName){var j=b.helpers.getPX(a(c[i]).css(f))||0;c[i].style.marginLeft=null,null===h&&(h=j);var k=h>0?"<"+d+' style="'+f+": "+h+'px;">':"<"+d+">",l="</"+d+">";for(j-=h;j/b.opts.indentMargin>0;)k+="<"+d+">",l+=l,j-=b.opts.indentMargin;g&&c[i].tagName.toLowerCase()==g?a(c[i]).replaceWith(k+"<li"+b.node.attributes(c[i])+">"+a(c[i]).html()+"</li>"+l):a(c[i]).wrap(k+"<li></li>"+l)}b.clean.lists()}function g(e){var f,g;for(f=e.length-1;f>=0;f--)for(g=f-1;g>=0;g--)if(a(e[g]).find(e[f]).length||e[g]==e[f]){e.splice(f,1);break}var h=[];for(f=0;f<e.length;f++){var i=a(e[f]),j=e[f].parentNode,k=i.attr("class");if(i.before(d(j.tagName)),"LI"==j.parentNode.tagName)i.before(d("LI")),i.after(c("LI"));else{var l="";k&&(l+=' class="'+k+'"');var m="rtl"==b.opts.direction||"rtl"==i.css("direction")?"margin-right":"margin-left";b.helpers.getPX(a(j).css(m))&&(a(j).attr("style")||"").indexOf(m+":")>=0&&(l+=' style="'+m+":"+b.helpers.getPX(a(j).css(m))+'px;"'),l&&i.wrapInner("<"+b.html.defaultTag()+l+"></"+b.html.defaultTag()+">"),b.node.isEmpty(i.get(0),!0)||0!==i.find(b.html.blockTagsQuery()).length||i.append("<br>"),i.append(c("LI")),i.prepend(d("LI"))}i.after(c(j.tagName)),"LI"==j.parentNode.tagName&&(j=j.parentNode.parentNode),h.indexOf(j)<0&&h.push(j)}for(f=0;f<h.length;f++){var n=a(h[f]),o=n.html();o=o.replace(/<span class="fr-close-([a-z]*)"><\/span>/g,"</$1>"),o=o.replace(/<span class="fr-open-([a-z]*)"><\/span>/g,"<$1>"),n.replaceWith(b.node.openTagString(n.get(0))+o+b.node.closeTagString(n.get(0)))}b.$el.find("li:empty").remove(),b.$el.find("ul:empty, ol:empty").remove(),b.clean.lists(),b.html.wrap()}function h(a,b){for(var c=!0,d=0;d<a.length;d++){if("LI"!=a[d].tagName)return!1;a[d].parentNode.tagName!=b&&(c=!1)}return c}function i(a){b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();for(var c=b.selection.blocks(),d=0;d<c.length;d++)"LI"!=c[d].tagName&&"LI"==c[d].parentNode.tagName&&(c[d]=c[d].parentNode);b.selection.save(),h(c,a)?g(c):f(c,a),b.html.unwrap(),b.selection.restore()}function j(c,d){var e=a(b.selection.element());if(e.get(0)!=b.el){var f=e.get(0);f="LI"!=f.tagName&&f.firstElementChild&&"LI"!=f.firstElementChild.tagName?e.parents("li").get(0):"LI"==f.tagName||f.firstElementChild?f.firstElementChild&&"LI"==f.firstElementChild.tagName?e.get(0).firstChild:e.get(0):e.parents("li").get(0),f&&f.parentNode.tagName==d&&b.el.contains(f.parentNode)&&c.addClass("fr-active")}}function k(c){b.selection.save();for(var d=0;d<c.length;d++){var e=c[d].previousSibling;if(e){var f=a(c[d]).find("> ul, > ol").last().get(0);if(f){for(var g=a("<li>").prependTo(a(f)),h=b.node.contents(c[d])[0];h&&!b.node.isList(h);){var i=h.nextSibling;g.append(h),h=i}a(e).append(a(f)),a(c[d]).remove()}else{var j=a(e).find("> ul, > ol").last().get(0);if(j)a(j).append(a(c[d]));else{var k=a("<"+c[d].parentNode.tagName+">");a(e).append(k),k.append(a(c[d]))}}}}b.clean.lists(),b.selection.restore()}function l(a){b.selection.save(),g(a),b.selection.restore()}function m(a){if("indent"==a||"outdent"==a){for(var c=!1,d=b.selection.blocks(),e=[],f=0;f<d.length;f++)"LI"==d[f].tagName?(c=!0,e.push(d[f])):"LI"==d[f].parentNode.tagName&&(c=!0,e.push(d[f].parentNode));c&&("indent"==a?k(e):l(e))}}function n(){b.events.on("commands.after",m),b.events.on("keydown",function(c){if(c.which==a.FE.KEYCODE.TAB){for(var d=b.selection.blocks(),e=[],f=0;f<d.length;f++)"LI"==d[f].tagName?e.push(d[f]):"LI"==d[f].parentNode.tagName&&e.push(d[f].parentNode);if(e.length>1||e.length&&(b.selection.info(e[0]).atStart||b.node.isEmpty(e[0])))return c.preventDefault(),c.stopPropagation(),c.shiftKey?l(e):k(e),!1}},!0)}return{_init:n,format:i,refresh:j}},a.FE.RegisterCommand("formatUL",{title:"Unordered List",refresh:function(a){this.lists.refresh(a,"UL")},callback:function(){this.lists.format("UL")},plugin:"lists"}),a.FE.RegisterCommand("formatOL",{title:"Ordered List",refresh:function(a){this.lists.refresh(a,"OL")},callback:function(){this.lists.format("OL")},plugin:"lists"}),a.FE.DefineIcon("formatUL",{NAME:"list-ul"}),a.FE.DefineIcon("formatOL",{NAME:"list-ol"}),a.extend(a.FE.DEFAULTS,{paragraphFormat:{N:"Normal",H1:"Heading 1",H2:"Heading 2",H3:"Heading 3",H4:"Heading 4",PRE:"Code"},paragraphFormatSelection:!1}),a.FE.PLUGINS.paragraphFormat=function(b){function c(c,d){var e=b.html.defaultTag();if(d&&d.toLowerCase()!=e)if(c.find("ul, ol").length>0){var f=a("<"+d+">");c.prepend(f);for(var g=b.node.contents(c.get(0))[0];g&&["UL","OL"].indexOf(g.tagName)<0;){var h=g.nextSibling;f.append(g),g=h}}else c.html("<"+d+">"+c.html()+"</"+d+">")}function d(c,d){var e=b.html.defaultTag();d||(d='div class="fr-temp-div" data-empty="true"'),d.toLowerCase()==e?c.replaceWith(c.html()):c.replaceWith(a("<"+d+">").html(c.html()))}function e(c,d){var e=b.html.defaultTag();d||(d='div class="fr-temp-div"'+(b.node.isEmpty(c.get(0),!0)?' data-empty="true"':"")),d.toLowerCase()==e?(b.node.isEmpty(c.get(0),!0)||c.append("<br/>"),c.replaceWith(c.html())):c.replaceWith(a("<"+d+">").html(c.html()))}function f(c,d){d||(d='div class="fr-temp-div"'+(b.node.isEmpty(c.get(0),!0)?' data-empty="true"':"")),c.replaceWith(a("<"+d+" "+b.node.attributes(c.get(0))+">").html(c.html()).removeAttr("data-empty"))}function g(g){"N"==g&&(g=b.html.defaultTag()),b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();var h=b.selection.blocks();b.selection.save(),b.$el.find("pre").attr("skip",!0);for(var i=0;i<h.length;i++)if(h[i].tagName!=g&&!b.node.isList(h[i])){var j=a(h[i]);"LI"==h[i].tagName?c(j,g):"LI"==h[i].parentNode.tagName&&h[i]?d(j,g):["TD","TH"].indexOf(h[i].parentNode.tagName)>=0?e(j,g):f(j,g)}b.$el.find('pre:not([skip="true"]) + pre:not([skip="true"])').each(function(){a(this).prev().append("<br>"+a(this).html()),a(this).remove()}),b.$el.find("pre").removeAttr("skip"),b.html.unwrap(),b.selection.restore()}function h(a,c){var d=b.selection.blocks();if(d.length){var e=d[0],f="N",g=b.html.defaultTag();e.tagName.toLowerCase()!=g&&e!=b.el&&(f=e.tagName),c.find('.fr-command[data-param1="'+f+'"]').addClass("fr-active").attr("aria-selected",!0)}else c.find('.fr-command[data-param1="N"]').addClass("fr-active").attr("aria-selected",!0)}function i(a){if(b.opts.paragraphFormatSelection){var c=b.selection.blocks();if(c.length){var d=c[0],e="N",f=b.html.defaultTag();d.tagName.toLowerCase()!=f&&d!=b.el&&(e=d.tagName),["LI","TD","TH"].indexOf(e)>=0&&(e="N"),a.find("> span").text(b.language.translate(b.opts.paragraphFormat[e]))}else a.find("> span").text(b.language.translate(b.opts.paragraphFormat.N))}}return{apply:g,refreshOnShow:h,refresh:i}},a.FE.RegisterCommand("paragraphFormat",{type:"dropdown",displaySelection:function(a){return a.opts.paragraphFormatSelection},defaultSelection:"Normal",displaySelectionWidth:100,html:function(){var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.paragraphFormat;for(var c in b)if(b.hasOwnProperty(c)){var d=this.shortcuts.get("paragraphFormat."+c);d=d?'<span class="fr-shortcut">'+d+"</span>":"",a+='<li role="presentation"><'+("N"==c?this.html.defaultTag()||"DIV":c)+' style="padding: 0 !important; margin: 0 !important;" role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="paragraphFormat" data-param1="'+c+'" title="'+this.language.translate(b[c])+'">'+this.language.translate(b[c])+"</a></"+("N"==c?this.html.defaultTag()||"DIV":c)+"></li>"}return a+="</ul>"},title:"Paragraph Format",callback:function(a,b){this.paragraphFormat.apply(b)},refresh:function(a){this.paragraphFormat.refresh(a)},refreshOnShow:function(a,b){this.paragraphFormat.refreshOnShow(a,b)},plugin:"paragraphFormat"}),a.FE.DefineIcon("paragraphFormat",{NAME:"paragraph"}),a.extend(a.FE.DEFAULTS,{paragraphStyles:{"fr-text-gray":"Gray","fr-text-bordered":"Bordered","fr-text-spaced":"Spaced","fr-text-uppercase":"Uppercase"},paragraphMultipleStyles:!0}),a.FE.PLUGINS.paragraphStyle=function(b){function c(c,d,e){void 0===d&&(d=b.opts.paragraphStyles),void 0===e&&(e=b.opts.paragraphMultipleStyles);var f="";e||(f=Object.keys(d),f.splice(f.indexOf(c),1),f=f.join(" ")),b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore();var g=b.selection.blocks();b.selection.save();for(var h=a(g[0]).hasClass(c),i=0;i<g.length;i++)a(g[i]).removeClass(f).toggleClass(c,!h),a(g[i]).hasClass("fr-temp-div")&&a(g[i]).removeClass("fr-temp-div"),""===a(g[i]).attr("class")&&a(g[i]).removeAttr("class");b.html.unwrap(),b.selection.restore()}function d(c,d){var e=b.selection.blocks();if(e.length){var f=a(e[0]);d.find(".fr-command").each(function(){var b=a(this).data("param1"),c=f.hasClass(b);a(this).toggleClass("fr-active",c).attr("aria-selected",c)})}}function e(){}return{_init:e,apply:c,refreshOnShow:d}},a.FE.RegisterCommand("paragraphStyle",{type:"dropdown",html:function(){var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.paragraphStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role="presentation"><a class="fr-command '+c+'" tabIndex="-1" role="option" data-cmd="paragraphStyle" data-param1="'+c+'" title="'+this.language.translate(b[c])+'">'+this.language.translate(b[c])+"</a></li>");return a+="</ul>"},title:"Paragraph Style",callback:function(a,b){this.paragraphStyle.apply(b)},refreshOnShow:function(a,b){this.paragraphStyle.refreshOnShow(a,b)},plugin:"paragraphStyle"}),a.FE.DefineIcon("paragraphStyle",{NAME:"magic"}),a.FE.PLUGINS.print=function(a){function b(){var b=a.$el.html(),c=null;a.shared.print_iframe?c=a.shared.print_iframe:(c=document.createElement("iframe"),c.name="fr-print",c.style.position="fixed",c.style.top="0",c.style.left="-9999px",c.style.height="100%",c.style.width="0",c.style.overflow="hidden",c.style["z-index"]="2147483647",c.style.tabIndex="-1",document.body.appendChild(c),c.onload=function(){setTimeout(function(){a.events.disableBlur(),window.frames["fr-print"].focus(),window.frames["fr-print"].print(),a.$win.get(0).focus(),a.events.disableBlur(),a.events.focus()},0)},a.events.on("shared.destroy",function(){c.remove()}),a.shared.print_iframe=c);var d=c.contentWindow;d.document.open(),d.document.write("<!DOCTYPE html><html><head><title>"+document.title+"</title>"),Array.prototype.forEach.call(document.querySelectorAll("style"),function(a){a=a.cloneNode(!0),d.document.write(a.outerHTML)});var e=document.querySelectorAll("link[rel=stylesheet]");Array.prototype.forEach.call(e,function(a){var b=document.createElement("link");b.rel=a.rel,b.href=a.href,b.media="print",b.type="text/css",b.media="all",d.document.write(b.outerHTML)}),d.document.write('</head><body style="text-align: '+("rtl"==a.opts.direction?"right":"left")+"; direction: "+a.opts.direction+';"><div class="fr-view">'),d.document.write(b),d.document.write("</div></body></html>"),d.document.close()}return{run:b}},a.FE.DefineIcon("print",{NAME:"print"}),a.FE.RegisterCommand("print",{title:"Print",undo:!1,focus:!1,plugin:"print",callback:function(){this.print.run()}}),a.extend(a.FE.DEFAULTS,{quickInsertButtons:["image","video","embedly","table","ul","ol","hr"],quickInsertTags:["p","div","h1","h2","h3","h4","h5","h6","pre","blockquote"]}),a.FE.QUICK_INSERT_BUTTONS={},a.FE.DefineIcon("quickInsert",{PATH:'<path d="M22,16.75 L16.75,16.75 L16.75,22 L15.25,22.000 L15.25,16.75 L10,16.75 L10,15.25 L15.25,15.25 L15.25,10 L16.75,10 L16.75,15.25 L22,15.25 L22,16.75 Z"/>',template:"svg"}),a.FE.RegisterQuickInsertButton=function(b,c){a.FE.QUICK_INSERT_BUTTONS[b]=a.extend({undo:!0},c)},a.FE.RegisterQuickInsertButton("image",{icon:"insertImage",requiredPlugin:"image",title:"Insert Image",undo:!1,callback:function(){var b=this;b.shared.$qi_image_input||(b.shared.$qi_image_input=a('<input accept="image/*" name="quickInsertImage'+this.id+'" style="display: none;" type="file">'),a("body:first").append(b.shared.$qi_image_input),b.events.$on(b.shared.$qi_image_input,"change",function(){var b=a(this).data("inst");this.files&&(b.quickInsert.hide(),b.image.upload(this.files)),a(this).val("")},!0)),b.$qi_image_input=b.shared.$qi_image_input,b.helpers.isMobile()&&b.selection.save(),b.$qi_image_input.data("inst",b).trigger("click")}}),a.FE.RegisterQuickInsertButton("video",{icon:"insertVideo",requiredPlugin:"video",title:"Insert Video",undo:!1,callback:function(){var a=prompt(this.language.translate("Paste the URL of the video you want to insert."));a&&this.video.insertByURL(a)}}),a.FE.RegisterQuickInsertButton("embedly",{icon:"embedly",requiredPlugin:"embedly",title:"Embed URL",undo:!1,callback:function(){var a=prompt(this.language.translate("Paste the URL of any web content you want to insert."));a&&this.embedly.add(a)}}),a.FE.RegisterQuickInsertButton("table",{icon:"insertTable",requiredPlugin:"table",title:"Insert Table",callback:function(){this.table.insert(2,2)}}),a.FE.RegisterQuickInsertButton("ol",{icon:"formatOL",requiredPlugin:"lists",title:"Ordered List",callback:function(){this.lists.format("OL")}}),a.FE.RegisterQuickInsertButton("ul",{icon:"formatUL",requiredPlugin:"lists",title:"Unordered List",callback:function(){this.lists.format("UL")}}),a.FE.RegisterQuickInsertButton("hr",{icon:"insertHR",title:"Insert Horizontal Line",callback:function(){this.commands.insertHR()}}),a.FE.PLUGINS.quickInsert=function(b){function c(a){var c,d,e;c=a.offset().top-b.$box.offset().top,d=0-k.outerWidth(),e=(k.outerHeight()-a.outerHeight())/2,b.opts.iframe&&(c+=b.$iframe.offset().top-b.helpers.scrollTop()),k.hasClass("fr-on")&&c>=0&&l.css("top",c-e),c>=0&&c-e<=b.$box.outerHeight()-a.outerHeight()?(k.hasClass("fr-hidden")&&(k.hasClass("fr-on")&&g(),k.removeClass("fr-hidden")),k.css("top",c-e)):k.hasClass("fr-visible")&&(k.addClass("fr-hidden"),h()),k.css("left",d)}function d(a){k||i(),k.hasClass("fr-on")&&h(),b.$box.append(k),c(a),k.data("tag",a),k.addClass("fr-visible")}function e(){if(b.core.hasFocus()){var c=b.selection.element();b.node.isBlock(c)||(c=b.node.blockParent(c)),c&&b.node.isEmpty(c)&&b.node.isElement(c.parentNode)&&b.opts.quickInsertTags.indexOf(c.tagName.toLowerCase())>=0?k&&k.data("tag").is(a(c))&&k.hasClass("fr-on")?h():b.selection.isCollapsed()&&d(a(c)):f()}}function f(){k&&(b.html.checkIfEmpty(),k.hasClass("fr-on")&&h(),k.removeClass("fr-visible fr-on"),k.css("left",-9999).css("top",-9999))}function g(c){if(c&&c.preventDefault(),k.hasClass("fr-on")&&!k.hasClass("fr-hidden"))h();else{if(!b.shared.$qi_helper){for(var d=b.opts.quickInsertButtons,e='<div class="fr-qi-helper">',f=0,g=0;g<d.length;g++){var i=a.FE.QUICK_INSERT_BUTTONS[d[g]];i&&(!i.requiredPlugin||a.FE.PLUGINS[i.requiredPlugin]&&b.opts.pluginsEnabled.indexOf(i.requiredPlugin)>=0)&&(e+='<a class="fr-btn fr-floating-btn" role="button" title="'+b.language.translate(i.title)+'" tabIndex="-1" data-cmd="'+d[g]+'" style="transition-delay: '+.025*f+++'s;">'+b.icon.create(i.icon)+"</a>")}e+="</div>",b.shared.$qi_helper=a(e),b.tooltip.bind(b.shared.$qi_helper,"> a.fr-btn")}l=b.shared.$qi_helper,l.appendTo(b.$box),setTimeout(function(){l.css("top",parseFloat(k.css("top"))),l.css("left",parseFloat(k.css("left"))+k.outerWidth()),l.find("a").addClass("fr-size-1"),k.addClass("fr-on")},10)}}function h(){var a=b.$box.find(".fr-qi-helper");a.length&&(a.find("a").removeClass("fr-size-1"),a.css("left",-9999),k.hasClass("fr-hidden")||k.removeClass("fr-on"))}function i(){b.shared.$quick_insert||(b.shared.$quick_insert=a('<div class="fr-quick-insert"><a class="fr-floating-btn" role="button" tabIndex="-1" title="'+b.language.translate("Quick Insert")+'">'+b.icon.create("quickInsert")+"</a></div>")),k=b.shared.$quick_insert,b.tooltip.bind(b.$box,".fr-quick-insert > a.fr-floating-btn"),b.events.on("destroy",function(){k.removeClass("fr-on").appendTo(a("body:first")).css("left",-9999).css("top",-9999),l&&(h(),l.appendTo(a("body:first")))},!0),b.events.on("shared.destroy",function(){k.html("").removeData().remove(),k=null,l&&(l.html("").removeData().remove(),l=null)},!0),b.events.on("commands.before",f),b.events.on("commands.after",function(){b.popups.areVisible()||e()}),b.events.bindClick(b.$box,".fr-quick-insert > a",g),b.events.bindClick(b.$box,".fr-qi-helper > a.fr-btn",function(c){var d=a(c.currentTarget).data("cmd");a.FE.QUICK_INSERT_BUTTONS[d].callback.apply(b,[c.currentTarget]),a.FE.QUICK_INSERT_BUTTONS[d].undo&&b.undo.saveStep(),b.quickInsert.hide()}),b.events.$on(b.$wp,"scroll",function(){k.hasClass("fr-visible")&&c(k.data("tag"))})}function j(){if(!b.$wp)return!1;b.opts.iframe&&b.$el.parent("html").find("head").append('<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.4.0/css/font-awesome.min.css">'),b.popups.onShow("image.edit",f),b.events.on("mouseup",e),b.helpers.isMobile()&&b.events.$on(a(b.o_doc),"selectionchange",e),b.events.on("blur",f),b.events.on("keyup",e),b.events.on("keydown",function(){setTimeout(function(){e()},0)})}var k,l
;return{_init:j,hide:f}},a.FE.PLUGINS.quote=function(b){function c(a){for(;a.parentNode&&a.parentNode!=b.el;)a=a.parentNode;return a}function d(){var d,e=b.selection.blocks();for(d=0;d<e.length;d++)e[d]=c(e[d]);b.selection.save();var f=a("<blockquote>");for(f.insertBefore(e[0]),d=0;d<e.length;d++)f.append(e[d]);b.html.unwrap(),b.selection.restore()}function e(){var c,d=b.selection.blocks();for(c=0;c<d.length;c++)"BLOCKQUOTE"!=d[c].tagName&&(d[c]=a(d[c]).parentsUntil(b.$el,"BLOCKQUOTE").get(0));for(b.selection.save(),c=0;c<d.length;c++)d[c]&&a(d[c]).replaceWith(d[c].innerHTML);b.html.unwrap(),b.selection.restore()}function f(a){b.selection.save(),b.html.wrap(!0,!0,!0,!0),b.selection.restore(),"increase"==a?d():"decrease"==a&&e()}return{apply:f}},a.FE.RegisterShortcut(a.FE.KEYCODE.SINGLE_QUOTE,"quote","increase","'"),a.FE.RegisterShortcut(a.FE.KEYCODE.SINGLE_QUOTE,"quote","decrease","'",!0),a.FE.RegisterCommand("quote",{title:"Quote",type:"dropdown",options:{increase:"Increase",decrease:"Decrease"},callback:function(a,b){this.quote.apply(b)},plugin:"quote"}),a.FE.DefineIcon("quote",{NAME:"quote-left"}),a.extend(a.FE.DEFAULTS,{saveInterval:1e4,saveURL:null,saveParams:{},saveParam:"body",saveMethod:"POST"}),a.FE.PLUGINS.save=function(b){function c(a,c){b.events.trigger("save.error",[{code:a,message:n[a]},c])}function d(d){if(void 0===d&&(d=b.html.get()),!1===b.events.trigger("save.before"))return!1;if(b.opts.saveURL){var e={};for(var f in b.opts.saveParams)if(b.opts.saveParams.hasOwnProperty(f)){var g=b.opts.saveParams[f];e[f]="function"==typeof g?g.call(this):g}var h={};h[b.opts.saveParam]=d,a.ajax({type:b.opts.saveMethod,url:b.opts.saveURL,data:a.extend(h,e),crossDomain:b.opts.requestWithCORS,xhrFields:{withCredentials:b.opts.requestWithCredentials},headers:b.opts.requestHeaders}).done(function(a){j=d,b.events.trigger("save.after",[a])}).fail(function(a){c(m,a.response||a.responseText)})}else c(l)}function e(){clearTimeout(i),i=setTimeout(function(){var a=b.html.get();(j!=a||k)&&(j=a,k=!1,d(a))},b.opts.saveInterval)}function f(){e(),k=!1}function g(){k=!0}function h(){b.opts.saveInterval&&(j=b.html.get(),b.events.on("contentChanged",e),b.events.on("keydown destroy",function(){clearTimeout(i)}))}var i=null,j=null,k=!1,l=1,m=2,n={};return n[l]="Missing saveURL option.",n[m]="Something went wrong during save.",{_init:h,save:d,reset:f,force:g}},a.FE.DefineIcon("save",{NAME:"floppy-o"}),a.FE.RegisterCommand("save",{title:"Save",undo:!1,focus:!1,refreshAfterCallback:!1,callback:function(){this.save.save()},plugin:"save"}),a.extend(a.FE.DEFAULTS,{specialCharactersSets:[{title:"Latin",list:[{char:"&iexcl;",desc:"INVERTED EXCLAMATION MARK"},{char:"&cent;",desc:"CENT SIGN"},{char:"&pound;",desc:"POUND SIGN"},{char:"&curren;",desc:"CURRENCY SIGN"},{char:"&yen;",desc:"YEN SIGN"},{char:"&brvbar;",desc:"BROKEN BAR"},{char:"&sect;",desc:"SECTION SIGN"},{char:"&uml;",desc:"DIAERESIS"},{char:"&copy;",desc:"COPYRIGHT SIGN"},{char:"&trade;",desc:"TRADEMARK SIGN"},{char:"&ordf;",desc:"FEMININE ORDINAL INDICATOR"},{char:"&laquo;",desc:"LEFT-POINTING DOUBLE ANGLE QUOTATION MARK"},{char:"&not;",desc:"NOT SIGN"},{char:"&reg;",desc:"REGISTERED SIGN"},{char:"&macr;",desc:"MACRON"},{char:"&deg;",desc:"DEGREE SIGN"},{char:"&plusmn;",desc:"PLUS-MINUS SIGN"},{char:"&sup2;",desc:"SUPERSCRIPT TWO"},{char:"&sup3;",desc:"SUPERSCRIPT THREE"},{char:"&acute;",desc:"ACUTE ACCENT"},{char:"&micro;",desc:"MICRO SIGN"},{char:"&para;",desc:"PILCROW SIGN"},{char:"&middot;",desc:"MIDDLE DOT"},{char:"&cedil;",desc:"CEDILLA"},{char:"&sup1;",desc:"SUPERSCRIPT ONE"},{char:"&ordm;",desc:"MASCULINE ORDINAL INDICATOR"},{char:"&raquo;",desc:"RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK"},{char:"&frac14;",desc:"VULGAR FRACTION ONE QUARTER"},{char:"&frac12;",desc:"VULGAR FRACTION ONE HALF"},{char:"&frac34;",desc:"VULGAR FRACTION THREE QUARTERS"},{char:"&iquest;",desc:"INVERTED QUESTION MARK"},{char:"&Agrave;",desc:"LATIN CAPITAL LETTER A WITH GRAVE"},{char:"&Aacute;",desc:"LATIN CAPITAL LETTER A WITH ACUTE"},{char:"&Acirc;",desc:"LATIN CAPITAL LETTER A WITH CIRCUMFLEX"},{char:"&Atilde;",desc:"LATIN CAPITAL LETTER A WITH TILDE"},{char:"&Auml;",desc:"LATIN CAPITAL LETTER A WITH DIAERESIS "},{char:"&Aring;",desc:"LATIN CAPITAL LETTER A WITH RING ABOVE"},{char:"&AElig;",desc:"LATIN CAPITAL LETTER AE"},{char:"&Ccedil;",desc:"LATIN CAPITAL LETTER C WITH CEDILLA"},{char:"&Egrave;",desc:"LATIN CAPITAL LETTER E WITH GRAVE"},{char:"&Eacute;",desc:"LATIN CAPITAL LETTER E WITH ACUTE"},{char:"&Ecirc;",desc:"LATIN CAPITAL LETTER E WITH CIRCUMFLEX"},{char:"&Euml;",desc:"LATIN CAPITAL LETTER E WITH DIAERESIS"},{char:"&Igrave;",desc:"LATIN CAPITAL LETTER I WITH GRAVE"},{char:"&Iacute;",desc:"LATIN CAPITAL LETTER I WITH ACUTE"},{char:"&Icirc;",desc:"LATIN CAPITAL LETTER I WITH CIRCUMFLEX"},{char:"&Iuml;",desc:"LATIN CAPITAL LETTER I WITH DIAERESIS"},{char:"&ETH;",desc:"LATIN CAPITAL LETTER ETH"},{char:"&Ntilde;",desc:"LATIN CAPITAL LETTER N WITH TILDE"},{char:"&Ograve;",desc:"LATIN CAPITAL LETTER O WITH GRAVE"},{char:"&Oacute;",desc:"LATIN CAPITAL LETTER O WITH ACUTE"},{char:"&Ocirc;",desc:"LATIN CAPITAL LETTER O WITH CIRCUMFLEX"},{char:"&Otilde;",desc:"LATIN CAPITAL LETTER O WITH TILDE"},{char:"&Ouml;",desc:"LATIN CAPITAL LETTER O WITH DIAERESIS"},{char:"&times;",desc:"MULTIPLICATION SIGN"},{char:"&Oslash;",desc:"LATIN CAPITAL LETTER O WITH STROKE"},{char:"&Ugrave;",desc:"LATIN CAPITAL LETTER U WITH GRAVE"},{char:"&Uacute;",desc:"LATIN CAPITAL LETTER U WITH ACUTE"},{char:"&Ucirc;",desc:"LATIN CAPITAL LETTER U WITH CIRCUMFLEX"},{char:"&Uuml;",desc:"LATIN CAPITAL LETTER U WITH DIAERESIS"},{char:"&Yacute;",desc:"LATIN CAPITAL LETTER Y WITH ACUTE"},{char:"&THORN;",desc:"LATIN CAPITAL LETTER THORN"},{char:"&szlig;",desc:"LATIN SMALL LETTER SHARP S"},{char:"&agrave;",desc:"LATIN SMALL LETTER A WITH GRAVE"},{char:"&aacute;",desc:"LATIN SMALL LETTER A WITH ACUTE "},{char:"&acirc;",desc:"LATIN SMALL LETTER A WITH CIRCUMFLEX"},{char:"&atilde;",desc:"LATIN SMALL LETTER A WITH TILDE"},{char:"&auml;",desc:"LATIN SMALL LETTER A WITH DIAERESIS"},{char:"&aring;",desc:"LATIN SMALL LETTER A WITH RING ABOVE"},{char:"&aelig;",desc:"LATIN SMALL LETTER AE"},{char:"&ccedil;",desc:"LATIN SMALL LETTER C WITH CEDILLA"},{char:"&egrave;",desc:"LATIN SMALL LETTER E WITH GRAVE"},{char:"&eacute;",desc:"LATIN SMALL LETTER E WITH ACUTE"},{char:"&ecirc;",desc:"LATIN SMALL LETTER E WITH CIRCUMFLEX"},{char:"&euml;",desc:"LATIN SMALL LETTER E WITH DIAERESIS"},{char:"&igrave;",desc:"LATIN SMALL LETTER I WITH GRAVE"},{char:"&iacute;",desc:"LATIN SMALL LETTER I WITH ACUTE"},{char:"&icirc;",desc:"LATIN SMALL LETTER I WITH CIRCUMFLEX"},{char:"&iuml;",desc:"LATIN SMALL LETTER I WITH DIAERESIS"},{char:"&eth;",desc:"LATIN SMALL LETTER ETH"},{char:"&ntilde;",desc:"LATIN SMALL LETTER N WITH TILDE"},{char:"&ograve;",desc:"LATIN SMALL LETTER O WITH GRAVE"},{char:"&oacute;",desc:"LATIN SMALL LETTER O WITH ACUTE"},{char:"&ocirc;",desc:"LATIN SMALL LETTER O WITH CIRCUMFLEX"},{char:"&otilde;",desc:"LATIN SMALL LETTER O WITH TILDE"},{char:"&ouml;",desc:"LATIN SMALL LETTER O WITH DIAERESIS"},{char:"&divide;",desc:"DIVISION SIGN"},{char:"&oslash;",desc:"LATIN SMALL LETTER O WITH STROKE"},{char:"&ugrave;",desc:"LATIN SMALL LETTER U WITH GRAVE"},{char:"&uacute;",desc:"LATIN SMALL LETTER U WITH ACUTE"},{char:"&ucirc;",desc:"LATIN SMALL LETTER U WITH CIRCUMFLEX"},{char:"&uuml;",desc:"LATIN SMALL LETTER U WITH DIAERESIS"},{char:"&yacute;",desc:"LATIN SMALL LETTER Y WITH ACUTE"},{char:"&thorn;",desc:"LATIN SMALL LETTER THORN"},{char:"&yuml;",desc:"LATIN SMALL LETTER Y WITH DIAERESIS"}]},{title:"Greek",list:[{char:"&Alpha;",desc:"GREEK CAPITAL LETTER ALPHA"},{char:"&Beta;",desc:"GREEK CAPITAL LETTER BETA"},{char:"&Gamma;",desc:"GREEK CAPITAL LETTER GAMMA"},{char:"&Delta;",desc:"GREEK CAPITAL LETTER DELTA"},{char:"&Epsilon;",desc:"GREEK CAPITAL LETTER EPSILON"},{char:"&Zeta;",desc:"GREEK CAPITAL LETTER ZETA"},{char:"&Eta;",desc:"GREEK CAPITAL LETTER ETA"},{char:"&Theta;",desc:"GREEK CAPITAL LETTER THETA"},{char:"&Iota;",desc:"GREEK CAPITAL LETTER IOTA"},{char:"&Kappa;",desc:"GREEK CAPITAL LETTER KAPPA"},{char:"&Lambda;",desc:"GREEK CAPITAL LETTER LAMBDA"},{char:"&Mu;",desc:"GREEK CAPITAL LETTER MU"},{char:"&Nu;",desc:"GREEK CAPITAL LETTER NU"},{char:"&Xi;",desc:"GREEK CAPITAL LETTER XI"},{char:"&Omicron;",desc:"GREEK CAPITAL LETTER OMICRON"},{char:"&Pi;",desc:"GREEK CAPITAL LETTER PI"},{char:"&Rho;",desc:"GREEK CAPITAL LETTER RHO"},{char:"&Sigma;",desc:"GREEK CAPITAL LETTER SIGMA"},{char:"&Tau;",desc:"GREEK CAPITAL LETTER TAU"},{char:"&Upsilon;",desc:"GREEK CAPITAL LETTER UPSILON"},{char:"&Phi;",desc:"GREEK CAPITAL LETTER PHI"},{char:"&Chi;",desc:"GREEK CAPITAL LETTER CHI"},{char:"&Psi;",desc:"GREEK CAPITAL LETTER PSI"},{char:"&Omega;",desc:"GREEK CAPITAL LETTER OMEGA"},{char:"&alpha;",desc:"GREEK SMALL LETTER ALPHA"},{char:"&beta;",desc:"GREEK SMALL LETTER BETA"},{char:"&gamma;",desc:"GREEK SMALL LETTER GAMMA"},{char:"&delta;",desc:"GREEK SMALL LETTER DELTA"},{char:"&epsilon;",desc:"GREEK SMALL LETTER EPSILON"},{char:"&zeta;",desc:"GREEK SMALL LETTER ZETA"},{char:"&eta;",desc:"GREEK SMALL LETTER ETA"},{char:"&theta;",desc:"GREEK SMALL LETTER THETA"},{char:"&iota;",desc:"GREEK SMALL LETTER IOTA"},{char:"&kappa;",desc:"GREEK SMALL LETTER KAPPA"},{char:"&lambda;",desc:"GREEK SMALL LETTER LAMBDA"},{char:"&mu;",desc:"GREEK SMALL LETTER MU"},{char:"&nu;",desc:"GREEK SMALL LETTER NU"},{char:"&xi;",desc:"GREEK SMALL LETTER XI"},{char:"&omicron;",desc:"GREEK SMALL LETTER OMICRON"},{char:"&pi;",desc:"GREEK SMALL LETTER PI"},{char:"&rho;",desc:"GREEK SMALL LETTER RHO"},{char:"&sigmaf;",desc:"GREEK SMALL LETTER FINAL SIGMA"},{char:"&sigma;",desc:"GREEK SMALL LETTER SIGMA"},{char:"&tau;",desc:"GREEK SMALL LETTER TAU"},{char:"&upsilon;",desc:"GREEK SMALL LETTER UPSILON"},{char:"&phi;",desc:"GREEK SMALL LETTER PHI"},{char:"&chi;",desc:"GREEK SMALL LETTER CHI"},{char:"&psi;",desc:"GREEK SMALL LETTER PSI"},{char:"&omega;",desc:"GREEK SMALL LETTER OMEGA"},{char:"&thetasym;",desc:"GREEK THETA SYMBOL"},{char:"&upsih;",desc:"GREEK UPSILON WITH HOOK SYMBOL"},{char:"&straightphi;",desc:"GREEK PHI SYMBOL"},{char:"&piv;",desc:"GREEK PI SYMBOL"},{char:"&Gammad;",desc:"GREEK LETTER DIGAMMA"},{char:"&gammad;",desc:"GREEK SMALL LETTER DIGAMMA"},{char:"&varkappa;",desc:"GREEK KAPPA SYMBOL"},{char:"&varrho;",desc:"GREEK RHO SYMBOL"},{char:"&straightepsilon;",desc:"GREEK LUNATE EPSILON SYMBOL"},{char:"&backepsilon;",desc:"GREEK REVERSED LUNATE EPSILON SYMBOL"}]},{title:"Cyrillic",list:[{char:"&#x400",desc:"CYRILLIC CAPITAL LETTER IE WITH GRAVE"},{char:"&#x401",desc:"CYRILLIC CAPITAL LETTER IO"},{char:"&#x402",desc:"CYRILLIC CAPITAL LETTER DJE"},{char:"&#x403",desc:"CYRILLIC CAPITAL LETTER GJE"},{char:"&#x404",desc:"CYRILLIC CAPITAL LETTER UKRAINIAN IE"},{char:"&#x405",desc:"CYRILLIC CAPITAL LETTER DZE"},{char:"&#x406",desc:"CYRILLIC CAPITAL LETTER BYELORUSSIAN-UKRAINIAN I"},{char:"&#x407",desc:"CYRILLIC CAPITAL LETTER YI"},{char:"&#x408",desc:"CYRILLIC CAPITAL LETTER JE"},{char:"&#x409",desc:"CYRILLIC CAPITAL LETTER LJE"},{char:"&#x40A",desc:"CYRILLIC CAPITAL LETTER NJE"},{char:"&#x40B",desc:"CYRILLIC CAPITAL LETTER TSHE"},{char:"&#x40C",desc:"CYRILLIC CAPITAL LETTER KJE"},{char:"&#x40D",desc:"CYRILLIC CAPITAL LETTER I WITH GRAVE"},{char:"&#x40E",desc:"CYRILLIC CAPITAL LETTER SHORT U"},{char:"&#x40F",desc:"CYRILLIC CAPITAL LETTER DZHE"},{char:"&#x410",desc:"CYRILLIC CAPITAL LETTER A"},{char:"&#x411",desc:"CYRILLIC CAPITAL LETTER BE"},{char:"&#x412",desc:"CYRILLIC CAPITAL LETTER VE"},{char:"&#x413",desc:"CYRILLIC CAPITAL LETTER GHE"},{char:"&#x414",desc:"CYRILLIC CAPITAL LETTER DE"},{char:"&#x415",desc:"CYRILLIC CAPITAL LETTER IE"},{char:"&#x416",desc:"CYRILLIC CAPITAL LETTER ZHE"},{char:"&#x417",desc:"CYRILLIC CAPITAL LETTER ZE"},{char:"&#x418",desc:"CYRILLIC CAPITAL LETTER I"},{char:"&#x419",desc:"CYRILLIC CAPITAL LETTER SHORT I"},{char:"&#x41A",desc:"CYRILLIC CAPITAL LETTER KA"},{char:"&#x41B",desc:"CYRILLIC CAPITAL LETTER EL"},{char:"&#x41C",desc:"CYRILLIC CAPITAL LETTER EM"},{char:"&#x41D",desc:"CYRILLIC CAPITAL LETTER EN"},{char:"&#x41E",desc:"CYRILLIC CAPITAL LETTER O"},{char:"&#x41F",desc:"CYRILLIC CAPITAL LETTER PE"},{char:"&#x420",desc:"CYRILLIC CAPITAL LETTER ER"},{char:"&#x421",desc:"CYRILLIC CAPITAL LETTER ES"},{char:"&#x422",desc:"CYRILLIC CAPITAL LETTER TE"},{char:"&#x423",desc:"CYRILLIC CAPITAL LETTER U"},{char:"&#x424",desc:"CYRILLIC CAPITAL LETTER EF"},{char:"&#x425",desc:"CYRILLIC CAPITAL LETTER HA"},{char:"&#x426",desc:"CYRILLIC CAPITAL LETTER TSE"},{char:"&#x427",desc:"CYRILLIC CAPITAL LETTER CHE"},{char:"&#x428",desc:"CYRILLIC CAPITAL LETTER SHA"},{char:"&#x429",desc:"CYRILLIC CAPITAL LETTER SHCHA"},{char:"&#x42A",desc:"CYRILLIC CAPITAL LETTER HARD SIGN"},{char:"&#x42B",desc:"CYRILLIC CAPITAL LETTER YERU"},{char:"&#x42C",desc:"CYRILLIC CAPITAL LETTER SOFT SIGN"},{char:"&#x42D",desc:"CYRILLIC CAPITAL LETTER E"},{char:"&#x42E",desc:"CYRILLIC CAPITAL LETTER YU"},{char:"&#x42F",desc:"CYRILLIC CAPITAL LETTER YA"},{char:"&#x430",desc:"CYRILLIC SMALL LETTER A"},{char:"&#x431",desc:"CYRILLIC SMALL LETTER BE"},{char:"&#x432",desc:"CYRILLIC SMALL LETTER VE"},{char:"&#x433",desc:"CYRILLIC SMALL LETTER GHE"},{char:"&#x434",desc:"CYRILLIC SMALL LETTER DE"},{char:"&#x435",desc:"CYRILLIC SMALL LETTER IE"},{char:"&#x436",desc:"CYRILLIC SMALL LETTER ZHE"},{char:"&#x437",desc:"CYRILLIC SMALL LETTER ZE"},{char:"&#x438",desc:"CYRILLIC SMALL LETTER I"},{char:"&#x439",desc:"CYRILLIC SMALL LETTER SHORT I"},{char:"&#x43A",desc:"CYRILLIC SMALL LETTER KA"},{char:"&#x43B",desc:"CYRILLIC SMALL LETTER EL"},{char:"&#x43C",desc:"CYRILLIC SMALL LETTER EM"},{char:"&#x43D",desc:"CYRILLIC SMALL LETTER EN"},{char:"&#x43E",desc:"CYRILLIC SMALL LETTER O"},{char:"&#x43F",desc:"CYRILLIC SMALL LETTER PE"},{char:"&#x440",desc:"CYRILLIC SMALL LETTER ER"},{char:"&#x441",desc:"CYRILLIC SMALL LETTER ES"},{char:"&#x442",desc:"CYRILLIC SMALL LETTER TE"},{char:"&#x443",desc:"CYRILLIC SMALL LETTER U"},{char:"&#x444",desc:"CYRILLIC SMALL LETTER EF"},{char:"&#x445",desc:"CYRILLIC SMALL LETTER HA"},{char:"&#x446",desc:"CYRILLIC SMALL LETTER TSE"},{char:"&#x447",desc:"CYRILLIC SMALL LETTER CHE"},{char:"&#x448",desc:"CYRILLIC SMALL LETTER SHA"},{char:"&#x449",desc:"CYRILLIC SMALL LETTER SHCHA"},{char:"&#x44A",desc:"CYRILLIC SMALL LETTER HARD SIGN"},{char:"&#x44B",desc:"CYRILLIC SMALL LETTER YERU"},{char:"&#x44C",desc:"CYRILLIC SMALL LETTER SOFT SIGN"},{char:"&#x44D",desc:"CYRILLIC SMALL LETTER E"},{char:"&#x44E",desc:"CYRILLIC SMALL LETTER YU"},{char:"&#x44F",desc:"CYRILLIC SMALL LETTER YA"},{char:"&#x450",desc:"CYRILLIC SMALL LETTER IE WITH GRAVE"},{char:"&#x451",desc:"CYRILLIC SMALL LETTER IO"},{char:"&#x452",desc:"CYRILLIC SMALL LETTER DJE"},{char:"&#x453",desc:"CYRILLIC SMALL LETTER GJE"},{char:"&#x454",desc:"CYRILLIC SMALL LETTER UKRAINIAN IE"},{char:"&#x455",desc:"CYRILLIC SMALL LETTER DZE"},{char:"&#x456",desc:"CYRILLIC SMALL LETTER BYELORUSSIAN-UKRAINIAN I"},{char:"&#x457",desc:"CYRILLIC SMALL LETTER YI"},{char:"&#x458",desc:"CYRILLIC SMALL LETTER JE"},{char:"&#x459",desc:"CYRILLIC SMALL LETTER LJE"},{char:"&#x45A",desc:"CYRILLIC SMALL LETTER NJE"},{char:"&#x45B",desc:"CYRILLIC SMALL LETTER TSHE"},{char:"&#x45C",desc:"CYRILLIC SMALL LETTER KJE"},{char:"&#x45D",desc:"CYRILLIC SMALL LETTER I WITH GRAVE"},{char:"&#x45E",desc:"CYRILLIC SMALL LETTER SHORT U"},{char:"&#x45F",desc:"CYRILLIC SMALL LETTER DZHE"}]},{title:"Punctuation",list:[{char:"&ndash;",desc:"EN DASH"},{char:"&mdash;",desc:"EM DASH"},{char:"&lsquo;",desc:"LEFT SINGLE QUOTATION MARK"},{char:"&rsquo;",desc:"RIGHT SINGLE QUOTATION MARK"},{char:"&sbquo;",desc:"SINGLE LOW-9 QUOTATION MARK"},{char:"&ldquo;",desc:"LEFT DOUBLE QUOTATION MARK"},{char:"&rdquo;",desc:"RIGHT DOUBLE QUOTATION MARK"},{char:"&bdquo;",desc:"DOUBLE LOW-9 QUOTATION MARK"},{char:"&dagger;",desc:"DAGGER"},{char:"&Dagger;",desc:"DOUBLE DAGGER"},{char:"&bull;",desc:"BULLET"},{char:"&hellip;",desc:"HORIZONTAL ELLIPSIS"},{char:"&permil;",desc:"PER MILLE SIGN"},{char:"&prime;",desc:"PRIME"},{char:"&Prime;",desc:"DOUBLE PRIME"},{char:"&lsaquo;",desc:"SINGLE LEFT-POINTING ANGLE QUOTATION MARK"},{char:"&rsaquo;",desc:"SINGLE RIGHT-POINTING ANGLE QUOTATION MARK"},{char:"&oline;",desc:"OVERLINE"},{char:"&frasl;",desc:"FRACTION SLASH"}]},{title:"Currency",list:[{char:"&#x20A0",desc:"EURO-CURRENCY SIGN"},{char:"&#x20A1",desc:"COLON SIGN"},{char:"&#x20A2",desc:"CRUZEIRO SIGN"},{char:"&#x20A3",desc:"FRENCH FRANC SIGN"},{char:"&#x20A4",desc:"LIRA SIGN"},{char:"&#x20A5",desc:"MILL SIGN"},{char:"&#x20A6",desc:"NAIRA SIGN"},{char:"&#x20A7",desc:"PESETA SIGN"},{char:"&#x20A8",desc:"RUPEE SIGN"},{char:"&#x20A9",desc:"WON SIGN"},{char:"&#x20AA",desc:"NEW SHEQEL SIGN"},{char:"&#x20AB",desc:"DONG SIGN"},{char:"&#x20AC",desc:"EURO SIGN"},{char:"&#x20AD",desc:"KIP SIGN"},{char:"&#x20AE",desc:"TUGRIK SIGN"},{char:"&#x20AF",desc:"DRACHMA SIGN"},{char:"&#x20B0",desc:"GERMAN PENNY SYMBOL"},{char:"&#x20B1",desc:"PESO SIGN"},{char:"&#x20B2",desc:"GUARANI SIGN"},{char:"&#x20B3",desc:"AUSTRAL SIGN"},{char:"&#x20B4",desc:"HRYVNIA SIGN"},{char:"&#x20B5",desc:"CEDI SIGN"},{char:"&#x20B6",desc:"LIVRE TOURNOIS SIGN"},{char:"&#x20B7",desc:"SPESMILO SIGN"},{char:"&#x20B8",desc:"TENGE SIGN"},{char:"&#x20B9",desc:"INDIAN RUPEE SIGN"}]},{title:"Arrows",list:[{char:"&#x2190",desc:"LEFTWARDS ARROW"},{char:"&#x2191",desc:"UPWARDS ARROW"},{char:"&#x2192",desc:"RIGHTWARDS ARROW"},{char:"&#x2193",desc:"DOWNWARDS ARROW"},{char:"&#x2194",desc:"LEFT RIGHT ARROW"},{char:"&#x2195",desc:"UP DOWN ARROW"},{char:"&#x2196",desc:"NORTH WEST ARROW"},{char:"&#x2197",desc:"NORTH EAST ARROW"},{char:"&#x2198",desc:"SOUTH EAST ARROW"},{char:"&#x2199",desc:"SOUTH WEST ARROW"},{char:"&#x219A",desc:"LEFTWARDS ARROW WITH STROKE"},{char:"&#x219B",desc:"RIGHTWARDS ARROW WITH STROKE"},{char:"&#x219C",desc:"LEFTWARDS WAVE ARROW"},{char:"&#x219D",desc:"RIGHTWARDS WAVE ARROW"},{char:"&#x219E",desc:"LEFTWARDS TWO HEADED ARROW"},{char:"&#x219F",desc:"UPWARDS TWO HEADED ARROW"},{char:"&#x21A0",desc:"RIGHTWARDS TWO HEADED ARROW"},{char:"&#x21A1",desc:"DOWNWARDS TWO HEADED ARROW"},{char:"&#x21A2",desc:"LEFTWARDS ARROW WITH TAIL"},{char:"&#x21A3",desc:"RIGHTWARDS ARROW WITH TAIL"},{char:"&#x21A4",desc:"LEFTWARDS ARROW FROM BAR"},{char:"&#x21A5",desc:"UPWARDS ARROW FROM BAR"},{char:"&#x21A6",desc:"RIGHTWARDS ARROW FROM BAR"},{char:"&#x21A7",desc:"DOWNWARDS ARROW FROM BAR"},{char:"&#x21A8",desc:"UP DOWN ARROW WITH BASE"},{char:"&#x21A9",desc:"LEFTWARDS ARROW WITH HOOK"},{char:"&#x21AA",desc:"RIGHTWARDS ARROW WITH HOOK"},{char:"&#x21AB",desc:"LEFTWARDS ARROW WITH LOOP"},{char:"&#x21AC",desc:"RIGHTWARDS ARROW WITH LOOP"},{char:"&#x21AD",desc:"LEFT RIGHT WAVE ARROW"},{char:"&#x21AE",desc:"LEFT RIGHT ARROW WITH STROKE"},{char:"&#x21AF",desc:"DOWNWARDS ZIGZAG ARROW"},{char:"&#x21B0",desc:"UPWARDS ARROW WITH TIP LEFTWARDS"},{char:"&#x21B1",desc:"UPWARDS ARROW WITH TIP RIGHTWARDS"},{char:"&#x21B2",desc:"DOWNWARDS ARROW WITH TIP LEFTWARDS"},{char:"&#x21B3",desc:"DOWNWARDS ARROW WITH TIP RIGHTWARDS"},{char:"&#x21B4",desc:"RIGHTWARDS ARROW WITH CORNER DOWNWARDS"},{char:"&#x21B5",desc:"DOWNWARDS ARROW WITH CORNER LEFTWARDS"},{char:"&#x21B6",desc:"ANTICLOCKWISE TOP SEMICIRCLE ARROW"},{char:"&#x21B7",desc:"CLOCKWISE TOP SEMICIRCLE ARROW"},{char:"&#x21B8",desc:"NORTH WEST ARROW TO LONG BAR"},{char:"&#x21B9",desc:"LEFTWARDS ARROW TO BAR OVER RIGHTWARDS ARROW TO BAR"},{char:"&#x21BA",desc:"ANTICLOCKWISE OPEN CIRCLE ARROW"},{char:"&#x21BB",desc:"CLOCKWISE OPEN CIRCLE ARROW"},{char:"&#x21BC",desc:"LEFTWARDS HARPOON WITH BARB UPWARDS"},{char:"&#x21BD",desc:"LEFTWARDS HARPOON WITH BARB DOWNWARDS"},{char:"&#x21BE",desc:"UPWARDS HARPOON WITH BARB RIGHTWARDS"},{char:"&#x21BF",desc:"UPWARDS HARPOON WITH BARB LEFTWARDS"},{char:"&#x21C0",desc:"RIGHTWARDS HARPOON WITH BARB UPWARDS"},{char:"&#x21C1",desc:"RIGHTWARDS HARPOON WITH BARB DOWNWARDS"},{char:"&#x21C2",desc:"DOWNWARDS HARPOON WITH BARB RIGHTWARDS"},{char:"&#x21C3",desc:"DOWNWARDS HARPOON WITH BARB LEFTWARDS"},{char:"&#x21C4",desc:"RIGHTWARDS ARROW OVER LEFTWARDS ARROW"},{char:"&#x21C5",desc:"UPWARDS ARROW LEFTWARDS OF DOWNWARDS ARROW"},{char:"&#x21C6",desc:"LEFTWARDS ARROW OVER RIGHTWARDS ARROW"},{char:"&#x21C7",desc:"LEFTWARDS PAIRED ARROWS"},{char:"&#x21C8",desc:"UPWARDS PAIRED ARROWS"},{char:"&#x21C9",desc:"RIGHTWARDS PAIRED ARROWS"},{char:"&#x21CA",desc:"DOWNWARDS PAIRED ARROWS"},{char:"&#x21CB",desc:"LEFTWARDS HARPOON OVER RIGHTWARDS HARPOON"},{char:"&#x21CC",desc:"RIGHTWARDS HARPOON OVER LEFTWARDS HARPOON"},{char:"&#x21CD",desc:"LEFTWARDS DOUBLE ARROW WITH STROKE"},{char:"&#x21CE",desc:"LEFT RIGHT DOUBLE ARROW WITH STROKE"},{char:"&#x21CF",desc:"RIGHTWARDS DOUBLE ARROW WITH STROKE"},{char:"&#x21D0",desc:"LEFTWARDS DOUBLE ARROW"},{char:"&#x21D1",desc:"UPWARDS DOUBLE ARROW"},{char:"&#x21D2",desc:"RIGHTWARDS DOUBLE ARROW"},{char:"&#x21D3",desc:"DOWNWARDS DOUBLE ARROW"},{char:"&#x21D4",desc:"LEFT RIGHT DOUBLE ARROW"},{char:"&#x21D5",desc:"UP DOWN DOUBLE ARROW"},{char:"&#x21D6",desc:"NORTH WEST DOUBLE ARROW"},{char:"&#x21D7",desc:"NORTH EAST DOUBLE ARROW"},{char:"&#x21D8",desc:"SOUTH EAST DOUBLE ARROW"},{char:"&#x21D9",desc:"SOUTH WEST DOUBLE ARROW"},{char:"&#x21DA",desc:"LEFTWARDS TRIPLE ARROW"},{char:"&#x21DB",desc:"RIGHTWARDS TRIPLE ARROW"},{char:"&#x21DC",desc:"LEFTWARDS SQUIGGLE ARROW"},{char:"&#x21DD",desc:"RIGHTWARDS SQUIGGLE ARROW"},{char:"&#x21DE",desc:"UPWARDS ARROW WITH DOUBLE STROKE"},{char:"&#x21DF",desc:"DOWNWARDS ARROW WITH DOUBLE STROKE"},{char:"&#x21E0",desc:"LEFTWARDS DASHED ARROW"},{char:"&#x21E1",desc:"UPWARDS DASHED ARROW"},{char:"&#x21E2",desc:"RIGHTWARDS DASHED ARROW"},{char:"&#x21E3",desc:"DOWNWARDS DASHED ARROW"},{char:"&#x21E4",desc:"LEFTWARDS ARROW TO BAR"},{char:"&#x21E5",desc:"RIGHTWARDS ARROW TO BAR"},{char:"&#x21E6",desc:"LEFTWARDS WHITE ARROW"},{char:"&#x21E7",desc:"UPWARDS WHITE ARROW"},{char:"&#x21E8",desc:"RIGHTWARDS WHITE ARROW"},{char:"&#x21E9",desc:"DOWNWARDS WHITE ARROW"},{char:"&#x21EA",desc:"UPWARDS WHITE ARROW FROM BAR"},{char:"&#x21EB",desc:"UPWARDS WHITE ARROW ON PEDESTAL"},{char:"&#x21EC",desc:"UPWARDS WHITE ARROW ON PEDESTAL WITH HORIZONTAL BAR"},{char:"&#x21ED",desc:"UPWARDS WHITE ARROW ON PEDESTAL WITH VERTICAL BAR"},{char:"&#x21EE",desc:"UPWARDS WHITE DOUBLE ARROW"},{char:"&#x21EF",desc:"UPWARDS WHITE DOUBLE ARROW ON PEDESTAL"},{char:"&#x21F0",desc:"RIGHTWARDS WHITE ARROW FROM WALL"},{char:"&#x21F1",desc:"NORTH WEST ARROW TO CORNER"},{char:"&#x21F2",desc:"SOUTH EAST ARROW TO CORNER"},{char:"&#x21F3",desc:"UP DOWN WHITE ARROW"},{char:"&#x21F4",desc:"RIGHT ARROW WITH SMALL CIRCLE"},{char:"&#x21F5",desc:"DOWNWARDS ARROW LEFTWARDS OF UPWARDS ARROW"},{char:"&#x21F6",desc:"THREE RIGHTWARDS ARROWS"},{char:"&#x21F7",desc:"LEFTWARDS ARROW WITH VERTICAL STROKE"},{char:"&#x21F8",desc:"RIGHTWARDS ARROW WITH VERTICAL STROKE"},{char:"&#x21F9",desc:"LEFT RIGHT ARROW WITH VERTICAL STROKE"},{char:"&#x21FA",desc:"LEFTWARDS ARROW WITH DOUBLE VERTICAL STROKE"},{char:"&#x21FB",desc:"RIGHTWARDS ARROW WITH DOUBLE VERTICAL STROKE"},{char:"&#x21FC",desc:"LEFT RIGHT ARROW WITH DOUBLE VERTICAL STROKE"},{char:"&#x21FD",desc:"LEFTWARDS OPEN-HEADED ARROW"},{char:"&#x21FE",desc:"RIGHTWARDS OPEN-HEADED ARROW"},{char:"&#x21FF",desc:"LEFT RIGHT OPEN-HEADED ARROW"}]},{title:"Math",list:[{char:"&forall;",desc:"FOR ALL"},{char:"&part;",desc:"PARTIAL DIFFERENTIAL"},{char:"&exist;",desc:"THERE EXISTS"},{char:"&empty;",desc:"EMPTY SET"},{char:"&nabla;",desc:"NABLA"},{char:"&isin;",desc:"ELEMENT OF"},{char:"&notin;",desc:"NOT AN ELEMENT OF"},{char:"&ni;",desc:"CONTAINS AS MEMBER"},{char:"&prod;",desc:"N-ARY PRODUCT"},{char:"&sum;",desc:"N-ARY SUMMATION"},{char:"&minus;",desc:"MINUS SIGN"},{char:"&lowast;",desc:"ASTERISK OPERATOR"},{char:"&radic;",desc:"SQUARE ROOT"},{char:"&prop;",desc:"PROPORTIONAL TO"},{char:"&infin;",desc:"INFINITY"},{char:"&ang;",desc:"ANGLE"},{char:"&and;",desc:"LOGICAL AND"},{char:"&or;",desc:"LOGICAL OR"},{char:"&cap;",desc:"INTERSECTION"},{char:"&cup;",desc:"UNION"},{char:"&int;",desc:"INTEGRAL"},{char:"&there4;",desc:"THEREFORE"},{char:"&sim;",desc:"TILDE OPERATOR"},{char:"&cong;",desc:"APPROXIMATELY EQUAL TO"},{char:"&asymp;",desc:"ALMOST EQUAL TO"},{char:"&ne;",desc:"NOT EQUAL TO"},{char:"&equiv;",desc:"IDENTICAL TO"},{char:"&le;",desc:"LESS-THAN OR EQUAL TO"},{char:"&ge;",desc:"GREATER-THAN OR EQUAL TO"},{char:"&sub;",desc:"SUBSET OF"},{char:"&sup;",desc:"SUPERSET OF"},{char:"&nsub;",desc:"NOT A SUBSET OF"},{char:"&sube;",desc:"SUBSET OF OR EQUAL TO"},{char:"&supe;",desc:"SUPERSET OF OR EQUAL TO"},{char:"&oplus;",desc:"CIRCLED PLUS"},{char:"&otimes;",desc:"CIRCLED TIMES"},{char:"&perp;",desc:"UP TACK"}]},{title:"Misc",list:[{char:"&spades;",desc:"BLACK SPADE SUIT"},{char:"&clubs;",desc:"BLACK CLUB SUIT"},{char:"&hearts;",desc:"BLACK HEART SUIT"},{char:"&diams;",desc:"BLACK DIAMOND SUIT"},{char:"&#x2669",desc:"QUARTER NOTE"},{char:"&#x266A",desc:"EIGHTH NOTE"},{char:"&#x266B",desc:"BEAMED EIGHTH NOTES"},{char:"&#x266C",desc:"BEAMED SIXTEENTH NOTES"},{char:"&#x266D",desc:"MUSIC FLAT SIGN"},{char:"&#x266E",desc:"MUSIC NATURAL SIGN"},{char:"&#x2600",desc:"BLACK SUN WITH RAYS"},{char:"&#x2601",desc:"CLOUD"},{char:"&#x2602",desc:"UMBRELLA"},{char:"&#x2603",desc:"SNOWMAN"},{char:"&#x2615",desc:"HOT BEVERAGE"},{char:"&#x2618",desc:"SHAMROCK"},{char:"&#x262F",desc:"YIN YANG"},{char:"&#x2714",desc:"HEAVY CHECK MARK"},{char:"&#x2716",desc:"HEAVY MULTIPLICATION X"},{char:"&#x2744",desc:"SNOWFLAKE"},{char:"&#x275B",desc:"HEAVY SINGLE TURNED COMMA QUOTATION MARK ORNAMENT"},{char:"&#x275C",desc:"HEAVY SINGLE COMMA QUOTATION MARK ORNAMENT"},{char:"&#x275D",desc:"HEAVY DOUBLE TURNED COMMA QUOTATION MARK ORNAMENT"},{char:"&#x275E",desc:"HEAVY DOUBLE COMMA QUOTATION MARK ORNAMENT"},{char:"&#x2764",desc:"HEAVY BLACK HEART"}]}]}),a.FE.PLUGINS.specialCharacters=function(b){function c(){}function d(){for(var c='<div class="fr-special-characters-modal">',d=0;d<a.FE.DEFAULTS.specialCharactersSets.length;d++){for(var e=a.FE.DEFAULTS.specialCharactersSets[d],f=e.list,g='<div class="fr-special-characters-list"><p class="fr-special-characters-title">'+b.language.translate(e.title)+"</p>",h=0;h<f.length;h++){var i=f[h];g+='<span class="fr-command fr-special-character" tabIndex="-1" role="button" value="'+i.char+'" title="'+i.desc+'">'+i.char+'<span class="fr-sr-only">'+b.language.translate(i.desc)+"&nbsp;&nbsp;&nbsp;</span></span>"}c+=g+"</div>"}return c+="</div>"}function e(a,c){b.events.disableBlur(),a.focus(),c.preventDefault(),c.stopPropagation()}function f(){b.events.$on(l,"keydown",function(c){var d=c.which,f=l.find("span.fr-special-character:focus:first");if(!(f.length||d!=a.FE.KEYCODE.F10||b.keys.ctrlKey(c)||c.shiftKey)&&c.altKey){return e(l.find("span.fr-special-character:first"),c),!1}if(d==a.FE.KEYCODE.TAB||d==a.FE.KEYCODE.ARROW_LEFT||d==a.FE.KEYCODE.ARROW_RIGHT){var g=null,h=null,i=!1;return d==a.FE.KEYCODE.ARROW_LEFT||d==a.FE.KEYCODE.ARROW_RIGHT?(h=d==a.FE.KEYCODE.ARROW_RIGHT,i=!0):h=!c.shiftKey,f.length?(i&&(g=h?f.nextAll("span.fr-special-character:first"):f.prevAll("span.fr-special-character:first")),g&&g.length||(g=h?f.parent().next().find("span.fr-special-character:first"):f.parent().prev().find("span.fr-special-character:"+(i?"last":"first")),g.length||(g=l.find("span.fr-special-character:"+(h?"first":"last"))))):g=l.find("span.fr-special-character:"+(h?"first":"last")),e(g,c),!1}if(d!=a.FE.KEYCODE.ENTER||!f.length)return!0;(j.data("instance")||b).specialCharacters.insert(f)},!0)}function g(){if(!j){var c="<h4>"+b.language.translate("Special Characters")+"</h4>",e=d(),g=b.modals.create(m,c,e);j=g.$modal,k=g.$head,l=g.$body,b.events.$on(a(b.o_win),"resize",function(){(j.data("instance")||b).modals.resize(m)}),b.events.bindClick(l,".fr-special-character",function(c){var d=j.data("instance")||b,e=a(c.currentTarget);d.specialCharacters.insert(e)}),f()}b.modals.show(m),b.modals.resize(m)}function h(){b.modals.hide(m)}function i(a){b.specialCharacters.hide(),b.undo.saveStep(),b.html.insert(a.attr("value"),!0),b.undo.saveStep()}var j,k,l,m="special_characters";return{_init:c,show:g,hide:h,insert:i}},a.FroalaEditor.DefineIcon("specialCharacters",{template:"text",NAME:"&#937;"}),a.FE.RegisterCommand("specialCharacters",{title:"Special Characters",icon:"specialCharacters",undo:!1,focus:!1,modal:!0,callback:function(){this.specialCharacters.show()},plugin:"specialCharacters",showOnMobile:!1}),a.extend(a.FE.POPUP_TEMPLATES,{"table.insert":"[_BUTTONS_][_ROWS_COLUMNS_]","table.edit":"[_BUTTONS_]","table.colors":"[_BUTTONS_][_COLORS_][_CUSTOM_COLOR_]"}),a.extend(a.FE.DEFAULTS,{tableInsertMaxSize:10,tableEditButtons:["tableHeader","tableRemove","|","tableRows","tableColumns","tableStyle","-","tableCells","tableCellBackground","tableCellVerticalAlign","tableCellHorizontalAlign","tableCellStyle"],tableInsertButtons:["tableBack","|"],tableResizer:!0,tableResizerOffset:5,tableResizingLimit:30,tableColorsButtons:["tableBack","|"],tableColors:["#61BD6D","#1ABC9C","#54ACD2","#2C82C9","#9365B8","#475577","#CCCCCC","#41A85F","#00A885","#3D8EB9","#2969B0","#553982","#28324E","#000000","#F7DA64","#FBA026","#EB6B56","#E25041","#A38F84","#EFEFEF","#FFFFFF","#FAC51C","#F37934","#D14841","#B8312F","#7C706B","#D1D5D8","REMOVE"],tableColorsStep:7,tableCellStyles:{"fr-highlighted":"Highlighted","fr-thick":"Thick"},tableStyles:{"fr-dashed-borders":"Dashed Borders","fr-alternate-rows":"Alternate Rows"},tableCellMultipleStyles:!0,tableMultipleStyles:!0,tableInsertHelper:!0,tableInsertHelperOffset:15}),a.FE.PLUGINS.table=function(b){function c(){var a=b.$tb.find('.fr-command[data-cmd="insertTable"]'),c=b.popups.get("table.insert");if(c||(c=g()),!c.hasClass("fr-active")){b.popups.refresh("table.insert"),b.popups.setContainer("table.insert",b.$tb);var d=a.offset().left+a.outerWidth()/2,e=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show("table.insert",d,e,a.outerHeight())}}function d(){var a=J();if(a){var c=b.popups.get("table.edit");if(c||(c=k()),c){b.popups.setContainer("table.edit",b.$sc);var d=R(a),e=(d.left+d.right)/2,f=d.bottom;b.popups.show("table.edit",e,f,d.bottom-d.top),b.edit.isDisabled()&&(b.toolbar.disable(),b.$el.removeClass("fr-no-selection"),b.edit.on(),b.button.bulkRefresh(),b.selection.setAtEnd(b.$el.find(".fr-selected-cell:last").get(0)),b.selection.restore())}}}function e(){var a=J();if(a){var c=b.popups.get("table.colors");c||(c=l()),b.popups.setContainer("table.colors",b.$sc);var d=R(a),e=(d.left+d.right)/2,f=d.bottom;p(),b.popups.show("table.colors",e,f,d.bottom-d.top)}}function f(){0===ta().length&&b.toolbar.enable()}function g(c){if(c)return b.popups.onHide("table.insert",function(){b.popups.get("table.insert").find('.fr-table-size .fr-select-table-size > span[data-row="1"][data-col="1"]').trigger("mouseenter")}),!0;var d="";b.opts.tableInsertButtons.length>0&&(d='<div class="fr-buttons">'+b.button.buildList(b.opts.tableInsertButtons)+"</div>");var e={buttons:d,rows_columns:i()},f=b.popups.create("table.insert",e);return b.events.$on(f,"mouseenter",".fr-table-size .fr-select-table-size .fr-table-cell",function(b){h(a(b.currentTarget))},!0),j(f),f}function h(a){var c=a.data("row"),d=a.data("col"),e=a.parent();e.siblings(".fr-table-size-info").html(c+" &times; "+d),e.find("> span").removeClass("hover fr-active-item");for(var f=1;f<=b.opts.tableInsertMaxSize;f++)for(var g=0;g<=b.opts.tableInsertMaxSize;g++){var h=e.find('> span[data-row="'+f+'"][data-col="'+g+'"]');f<=c&&g<=d?h.addClass("hover"):f<=c+1||f<=2&&!b.helpers.isMobile()?h.css("display","inline-block"):f>2&&!b.helpers.isMobile()&&h.css("display","none")}a.addClass("fr-active-item")}function i(){for(var a='<div class="fr-table-size"><div class="fr-table-size-info">1 &times; 1</div><div class="fr-select-table-size">',c=1;c<=b.opts.tableInsertMaxSize;c++){for(var d=1;d<=b.opts.tableInsertMaxSize;d++){var e="inline-block";c>2&&!b.helpers.isMobile()&&(e="none");var f="fr-table-cell ";1==c&&1==d&&(f+=" hover"),
a+='<span class="fr-command '+f+'" tabIndex="-1" data-cmd="tableInsert" data-row="'+c+'" data-col="'+d+'" data-param1="'+c+'" data-param2="'+d+'" style="display: '+e+';" role="button"><span></span><span class="fr-sr-only">'+c+" &times; "+d+"&nbsp;&nbsp;&nbsp;</span></span>"}a+='<div class="new-line"></div>'}return a+="</div></div>"}function j(c){b.events.$on(c,"focus","[tabIndex]",function(b){h(a(b.currentTarget))}),b.events.on("popup.tab",function(c){var d=a(c.currentTarget);if(!b.popups.isVisible("table.insert")||!d.is("span, a"))return!0;var e,f=c.which;if(a.FE.KEYCODE.ARROW_UP==f||a.FE.KEYCODE.ARROW_DOWN==f||a.FE.KEYCODE.ARROW_LEFT==f||a.FE.KEYCODE.ARROW_RIGHT==f){if(d.is("span.fr-table-cell")){var g=d.parent().find("span.fr-table-cell"),i=g.index(d),j=b.opts.tableInsertMaxSize,k=i%j,l=Math.floor(i/j);a.FE.KEYCODE.ARROW_UP==f?l=Math.max(0,l-1):a.FE.KEYCODE.ARROW_DOWN==f?l=Math.min(b.opts.tableInsertMaxSize-1,l+1):a.FE.KEYCODE.ARROW_LEFT==f?k=Math.max(0,k-1):a.FE.KEYCODE.ARROW_RIGHT==f&&(k=Math.min(b.opts.tableInsertMaxSize-1,k+1));var m=l*j+k,n=a(g.get(m));h(n),b.events.disableBlur(),n.focus(),e=!1}}else a.FE.KEYCODE.ENTER==f&&(b.button.exec(d),e=!1);return!1===e&&(c.preventDefault(),c.stopPropagation()),e},!0)}function k(a){if(a)return b.popups.onHide("table.edit",f),!0;var c="";if(b.opts.tableEditButtons.length>0){c='<div class="fr-buttons">'+b.button.buildList(b.opts.tableEditButtons)+"</div>";var e={buttons:c},g=b.popups.create("table.edit",e);return b.events.$on(b.$wp,"scroll.table-edit",function(){b.popups.isVisible("table.edit")&&d()}),g}return!1}function l(){var a="";b.opts.tableColorsButtons.length>0&&(a='<div class="fr-buttons fr-table-colors-buttons">'+b.button.buildList(b.opts.tableColorsButtons)+"</div>");var c="";b.opts.colorsHEXInput&&(c='<div class="fr-table-colors-hex-layer fr-active fr-layer" id="fr-table-colors-hex-layer-'+b.id+'"><div class="fr-input-line"><input maxlength="7" id="fr-table-colors-hex-layer-text-'+b.id+'" type="text" placeholder="'+b.language.translate("HEX Color")+'" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="tableCellBackgroundCustomColor" tabIndex="2" role="button">'+b.language.translate("OK")+"</button></div></div>");var d={buttons:a,colors:m(),custom_color:c},f=b.popups.create("table.colors",d);return b.events.$on(b.$wp,"scroll.table-colors",function(){b.popups.isVisible("table.colors")&&e()}),o(f),f}function m(){for(var a='<div class="fr-table-colors">',c=0;c<b.opts.tableColors.length;c++)0!==c&&c%b.opts.tableColorsStep==0&&(a+="<br>"),"REMOVE"!=b.opts.tableColors[c]?a+='<span class="fr-command" style="background: '+b.opts.tableColors[c]+';" tabIndex="-1" role="button" data-cmd="tableCellBackgroundColor" data-param1="'+b.opts.tableColors[c]+'"><span class="fr-sr-only">'+b.language.translate("Color")+" "+b.opts.tableColors[c]+"&nbsp;&nbsp;&nbsp;</span></span>":a+='<span class="fr-command" data-cmd="tableCellBackgroundColor" tabIndex="-1" role="button" data-param1="REMOVE" title="'+b.language.translate("Clear Formatting")+'">'+b.icon.create("tableColorRemove")+'<span class="fr-sr-only">'+b.language.translate("Clear Formatting")+"</span></span>";return a+="</div>"}function n(){var a=b.popups.get("table.colors"),c=a.find(".fr-table-colors-hex-layer input");c.length&&F(c.val())}function o(c){b.events.on("popup.tab",function(d){var e=a(d.currentTarget);if(!b.popups.isVisible("table.colors")||!e.is("span"))return!0;var f=d.which,g=!0;if(a.FE.KEYCODE.TAB==f){var h=c.find(".fr-buttons");g=!b.accessibility.focusToolbar(h,!!d.shiftKey)}else if(a.FE.KEYCODE.ARROW_UP==f||a.FE.KEYCODE.ARROW_DOWN==f||a.FE.KEYCODE.ARROW_LEFT==f||a.FE.KEYCODE.ARROW_RIGHT==f){var i=e.parent().find("span.fr-command"),j=i.index(e),k=b.opts.colorsStep,l=Math.floor(i.length/k),m=j%k,n=Math.floor(j/k),o=n*k+m,p=l*k;a.FE.KEYCODE.ARROW_UP==f?o=((o-k)%p+p)%p:a.FE.KEYCODE.ARROW_DOWN==f?o=(o+k)%p:a.FE.KEYCODE.ARROW_LEFT==f?o=((o-1)%p+p)%p:a.FE.KEYCODE.ARROW_RIGHT==f&&(o=(o+1)%p);var q=a(i.get(o));b.events.disableBlur(),q.focus(),g=!1}else a.FE.KEYCODE.ENTER==f&&(b.button.exec(e),g=!1);return!1===g&&(d.preventDefault(),d.stopPropagation()),g},!0)}function p(){var a=b.popups.get("table.colors"),c=b.$el.find(".fr-selected-cell:first"),d=b.helpers.RGBToHex(c.css("background-color")),e=a.find(".fr-table-colors-hex-layer input");a.find(".fr-selected-color").removeClass("fr-selected-color fr-active-item"),a.find('span[data-param1="'+d+'"]').addClass("fr-selected-color fr-active-item"),e.val(d).trigger("change")}function q(c,d){var e,f,g='<table style="width: 100%;" class="fr-inserted-table"><tbody>',h=100/d;for(e=0;e<c;e++){for(g+="<tr>",f=0;f<d;f++)g+='<td style="width: '+h.toFixed(4)+'%;">',0===e&&0===f&&(g+=a.FE.MARKERS),g+="<br></td>";g+="</tr>"}g+="</tbody></table>",b.html.insert(g),b.selection.restore();var i=b.$el.find(".fr-inserted-table");i.removeClass("fr-inserted-table"),b.events.trigger("table.inserted",[i.get(0)])}function r(){if(ta().length>0){var a=ua();b.selection.setBefore(a.get(0))||b.selection.setAfter(a.get(0)),b.selection.restore(),b.popups.hide("table.edit"),a.remove(),b.toolbar.enable()}}function s(){var b=ua();if(b.length>0&&0===b.find("th").length){var c,e="<thead><tr>",f=0;for(b.find("tr:first > td").each(function(){var b=a(this);f+=parseInt(b.attr("colspan"),10)||1}),c=0;c<f;c++)e+="<th><br></th>";e+="</tr></thead>",b.prepend(e),d()}}function t(){var a=ua(),c=a.find("thead");if(c.length>0)if(0===a.find("tbody tr").length)r();else if(c.remove(),ta().length>0)d();else{b.popups.hide("table.edit");var e=a.find("tbody tr:first td:first").get(0);e&&(b.selection.setAtEnd(e),b.selection.restore())}}function u(c){var e=ua();if(e.length>0){if(b.$el.find("th.fr-selected-cell").length>0&&"above"==c)return;var f,g,h,i=J(),j=P(i);g="above"==c?j.min_i:j.max_i;var k="<tr>";for(f=0;f<i[g].length;f++)if("below"==c&&g<i.length-1&&i[g][f]==i[g+1][f]||"above"==c&&g>0&&i[g][f]==i[g-1][f]){if(0===f||f>0&&i[g][f]!=i[g][f-1]){var l=a(i[g][f]);l.attr("rowspan",parseInt(l.attr("rowspan"),10)+1)}}else k+="<td><br></td>";k+="</tr>",h=a(b.$el.find("th.fr-selected-cell").length>0&&"below"==c?e.find("tbody").not(e.find("table tbody")):e.find("tr").not(e.find("table tr")).get(g)),"below"==c?"TBODY"==h.prop("tagName")?h.prepend(k):h.after(k):"above"==c&&(h.before(k),b.popups.isVisible("table.edit")&&d())}}function v(){var c=ua();if(c.length>0){var d,e,f,g=J(),h=P(g);if(0===h.min_i&&h.max_i==g.length-1)r();else{for(d=h.max_i;d>=h.min_i;d--){for(f=a(c.find("tr").not(c.find("table tr")).get(d)),e=0;e<g[d].length;e++)if(0===e||g[d][e]!=g[d][e-1]){var i=a(g[d][e]);if(parseInt(i.attr("rowspan"),10)>1){var j=parseInt(i.attr("rowspan"),10)-1;1==j?i.removeAttr("rowspan"):i.attr("rowspan",j)}if(d<g.length-1&&g[d][e]==g[d+1][e]&&(0===d||g[d][e]!=g[d-1][e])){for(var k=g[d][e],l=e;l>0&&g[d][l]==g[d][l-1];)l--;0===l?a(c.find("tr").not(c.find("table tr")).get(d+1)).prepend(k):a(g[d+1][l-1]).after(k)}}var m=f.parent();f.remove(),0===m.find("tr").length&&m.remove(),g=J(c)}B(0,g.length-1,0,g[0].length-1,c),h.min_i>0?b.selection.setAtEnd(g[h.min_i-1][0]):b.selection.setAtEnd(g[0][0]),b.selection.restore(),b.popups.hide("table.edit")}}}function w(c){var e=ua();if(e.length>0){var f,g=J(),h=P(g);f="before"==c?h.min_j:h.max_j;var i,j=100/g[0].length,k=100/(g[0].length+1);e.find("th, td").each(function(){i=a(this),i.data("old-width",i.outerWidth()/e.outerWidth()*100)}),e.find("tr").not(e.find("table tr")).each(function(b){for(var d,e=a(this),h=0,i=0;h-1<f;){if(!(d=e.find("> th, > td").get(i))){d=null;break}d==g[b][h]?(h+=parseInt(a(d).attr("colspan"),10)||1,i++):(h+=parseInt(a(g[b][h]).attr("colspan"),10)||1,"after"==c&&(d=0===i?-1:e.find("> th, > td").get(i-1)))}var l=a(d);if("after"==c&&h-1>f||"before"==c&&f>0&&g[b][f]==g[b][f-1]){if(0===b||b>0&&g[b][f]!=g[b-1][f]){var m=parseInt(l.attr("colspan"),10)+1;l.attr("colspan",m),l.css("width",(l.data("old-width")*k/j+k).toFixed(4)+"%"),l.removeData("old-width")}}else{var n;n=e.find("th").length>0?'<th style="width: '+k.toFixed(4)+'%;"><br></th>':'<td style="width: '+k.toFixed(4)+'%;"><br></td>',-1==d?e.prepend(n):null==d?e.append(n):"before"==c?l.before(n):"after"==c&&l.after(n)}}),e.find("th, td").each(function(){i=a(this),i.data("old-width")&&(i.css("width",(i.data("old-width")*k/j).toFixed(4)+"%"),i.removeData("old-width"))}),b.popups.isVisible("table.edit")&&d()}}function x(){var c=ua();if(c.length>0){var d,e,f,g=J(),h=P(g);if(0===h.min_j&&h.max_j==g[0].length-1)r();else{var i=100/g[0].length,j=100/(g[0].length-h.max_j+h.min_j-1);for(c.find("th, td").each(function(){f=a(this),f.hasClass("fr-selected-cell")||f.data("old-width",f.outerWidth()/c.outerWidth()*100)}),e=h.max_j;e>=h.min_j;e--)for(d=0;d<g.length;d++)if(0===d||g[d][e]!=g[d-1][e])if(f=a(g[d][e]),(parseInt(f.attr("colspan"),10)||1)>1){var k=parseInt(f.attr("colspan"),10)-1;1==k?f.removeAttr("colspan"):f.attr("colspan",k),f.css("width",((f.data("old-width")-la(e,g))*j/i).toFixed(4)+"%"),f.removeData("old-width")}else{var l=a(f.parent().get(0));f.remove(),0===l.find("> th, > td").length&&(0===l.prev().length||0===l.next().length||l.prev().find("> th[rowspan], > td[rowspan]").length<l.prev().find("> th, > td").length)&&l.remove()}B(0,g.length-1,0,g[0].length-1,c),h.min_j>0?b.selection.setAtEnd(g[h.min_i][h.min_j-1]):b.selection.setAtEnd(g[h.min_i][0]),b.selection.restore(),b.popups.hide("table.edit"),c.find("th, td").each(function(){f=a(this),f.data("old-width")&&(f.css("width",(f.data("old-width")*j/i).toFixed(4)+"%"),f.removeData("old-width"))})}}}function y(a,b,c){var d,e,f,g,h,i=0,j=J(c);if((b=Math.min(b,j[0].length-1))>a)for(e=a;e<=b;e++)if(!(e>a&&j[0][e]==j[0][e-1])&&(g=Math.min(parseInt(j[0][e].getAttribute("colspan"),10)||1,b-a+1))>1&&j[0][e]==j[0][e+1])for(i=g-1,d=1;d<j.length;d++)if(j[d][e]!=j[d-1][e]){for(f=e;f<e+g;f++)if((h=parseInt(j[d][f].getAttribute("colspan"),10)||1)>1&&j[d][f]==j[d][f+1])i=Math.min(i,h-1),f+=i;else if(!(i=Math.max(0,i-1)))break;if(!i)break}i&&A(j,i,"colspan",0,j.length-1,a,b)}function z(a,b,c){var d,e,f,g,h,i=0,j=J(c);if((b=Math.min(b,j.length-1))>a)for(d=a;d<=b;d++)if(!(d>a&&j[d][0]==j[d-1][0])&&(g=Math.min(parseInt(j[d][0].getAttribute("rowspan"),10)||1,b-a+1))>1&&j[d][0]==j[d+1][0])for(i=g-1,e=1;e<j[0].length;e++)if(j[d][e]!=j[d][e-1]){for(f=d;f<d+g;f++)if((h=parseInt(j[f][e].getAttribute("rowspan"),10)||1)>1&&j[f][e]==j[f+1][e])i=Math.min(i,h-1),f+=i;else if(!(i=Math.max(0,i-1)))break;if(!i)break}i&&A(j,i,"rowspan",a,b,0,j[0].length-1)}function A(a,b,c,d,e,f,g){var h,i,j;for(h=d;h<=e;h++)for(i=f;i<=g;i++)h>d&&a[h][i]==a[h-1][i]||i>f&&a[h][i]==a[h][i-1]||(j=parseInt(a[h][i].getAttribute(c),10)||1)>1&&(j-b>1?a[h][i].setAttribute(c,j-b):a[h][i].removeAttribute(c))}function B(a,b,c,d,e){z(a,b,e),y(c,d,e)}function C(){if(ta().length>1&&(0===b.$el.find("th.fr-selected-cell").length||0===b.$el.find("td.fr-selected-cell").length)){M();var c,e,f=J(),g=P(f),h=b.$el.find(".fr-selected-cell"),i=a(h[0]),j=i.parent(),k=j.find(".fr-selected-cell"),l=i.closest("table"),m=i.html(),n=0;for(c=0;c<k.length;c++)n+=a(k[c]).outerWidth();for(i.css("width",(n/l.outerWidth()*100).toFixed(4)+"%"),g.min_j<g.max_j&&i.attr("colspan",g.max_j-g.min_j+1),g.min_i<g.max_i&&i.attr("rowspan",g.max_i-g.min_i+1),c=1;c<h.length;c++)e=a(h[c]),"<br>"!=e.html()&&""!==e.html()&&(m+="<br>"+e.html()),e.remove();i.html(m),b.selection.setAtEnd(i.get(0)),b.selection.restore(),b.toolbar.enable(),z(g.min_i,g.max_i,l);var o=l.find("tr:empty");for(c=o.length-1;c>=0;c--)a(o[c]).remove();y(g.min_j,g.max_j,l),d()}}function D(){if(1==ta().length){var c=b.$el.find(".fr-selected-cell"),d=c.parent(),e=c.closest("table"),f=parseInt(c.attr("rowspan"),10),g=J(),h=K(c.get(0),g),i=c.clone().html("<br>");if(f>1){var j=Math.ceil(f/2);j>1?c.attr("rowspan",j):c.removeAttr("rowspan"),f-j>1?i.attr("rowspan",f-j):i.removeAttr("rowspan");for(var k=h.row+j,l=0===h.col?h.col:h.col-1;l>=0&&(g[k][l]==g[k][l-1]||k>0&&g[k][l]==g[k-1][l]);)l--;-1==l?a(e.find("tr").not(e.find("table tr")).get(k)).prepend(i):a(g[k][l]).after(i)}else{var m,n=a("<tr>").append(i);for(m=0;m<g[0].length;m++)if(0===m||g[h.row][m]!=g[h.row][m-1]){var o=a(g[h.row][m]);o.is(c)||o.attr("rowspan",(parseInt(o.attr("rowspan"),10)||1)+1)}d.after(n)}N(),b.popups.hide("table.edit")}}function E(){if(1==ta().length){var c=b.$el.find(".fr-selected-cell"),d=parseInt(c.attr("colspan"),10)||1,e=c.parent().outerWidth(),f=c.outerWidth(),g=c.clone().html("<br>"),h=J(),i=K(c.get(0),h);if(d>1){var j=Math.ceil(d/2);f=ma(i.col,i.col+j-1,h)/e*100;var k=ma(i.col+j,i.col+d-1,h)/e*100;j>1?c.attr("colspan",j):c.removeAttr("colspan"),d-j>1?g.attr("colspan",d-j):g.removeAttr("colspan"),c.css("width",f.toFixed(4)+"%"),g.css("width",k.toFixed(4)+"%")}else{var l;for(l=0;l<h.length;l++)if(0===l||h[l][i.col]!=h[l-1][i.col]){var m=a(h[l][i.col]);if(!m.is(c)){var n=(parseInt(m.attr("colspan"),10)||1)+1;m.attr("colspan",n)}}f=f/e*100/2,c.css("width",f.toFixed(4)+"%"),g.css("width",f.toFixed(4)+"%")}c.after(g),N(),b.popups.hide("table.edit")}}function F(a){var c=b.$el.find(".fr-selected-cell");"REMOVE"!=a?c.css("background-color",b.helpers.HEXtoRGB(a)):c.css("background-color",""),d()}function G(a){b.$el.find(".fr-selected-cell").css("vertical-align",a)}function H(a){b.$el.find(".fr-selected-cell").css("text-align",a)}function I(a,b,c,d){if(b.length>0){if(!c){var e=Object.keys(d);e.splice(e.indexOf(a),1),b.removeClass(e.join(" "))}b.toggleClass(a)}}function J(b){b=b||null;var c=[];return null==b&&ta().length>0&&(b=ua()),b&&b.find("tr").not(b.find("table tr")).each(function(b,d){var e=a(d),f=0;e.find("> th, > td").each(function(d,e){for(var g=a(e),h=parseInt(g.attr("colspan"),10)||1,i=parseInt(g.attr("rowspan"),10)||1,j=b;j<b+i;j++)for(var k=f;k<f+h;k++)c[j]||(c[j]=[]),c[j][k]?f++:c[j][k]=e;f+=h})}),c}function K(a,b){for(var c=0;c<b.length;c++)for(var d=0;d<b[c].length;d++)if(b[c][d]==a)return{row:c,col:d}}function L(a,b,c){for(var d=a+1,e=b+1;d<c.length;){if(c[d][b]!=c[a][b]){d--;break}d++}for(d==c.length&&d--;e<c[a].length;){if(c[a][e]!=c[a][b]){e--;break}e++}return e==c[a].length&&e--,{row:d,col:e}}function M(){b.el.querySelector(".fr-cell-fixed")&&b.el.querySelector(".fr-cell-fixed").classList.remove("fr-cell-fixed"),b.el.querySelector(".fr-cell-handler")&&b.el.querySelector(".fr-cell-handler").classList.remove("fr-cell-handler")}function N(){var c=b.$el.find(".fr-selected-cell");c.length>0&&c.each(function(){var b=a(this);b.removeClass("fr-selected-cell"),""===b.attr("class")&&b.removeAttr("class")}),M()}function O(){b.events.disableBlur(),b.selection.clear(),b.$el.addClass("fr-no-selection"),b.$el.blur(),b.events.enableBlur()}function P(a){var c=b.$el.find(".fr-selected-cell");if(c.length>0){var d,e=a.length,f=0,g=a[0].length,h=0;for(d=0;d<c.length;d++){var i=K(c[d],a),j=L(i.row,i.col,a);e=Math.min(i.row,e),f=Math.max(j.row,f),g=Math.min(i.col,g),h=Math.max(j.col,h)}return{min_i:e,max_i:f,min_j:g,max_j:h}}return null}function Q(b,c,d,e,f){var g,h,i,j,k=b,l=c,m=d,n=e;for(g=k;g<=l;g++)((parseInt(a(f[g][m]).attr("rowspan"),10)||1)>1||(parseInt(a(f[g][m]).attr("colspan"),10)||1)>1)&&(i=K(f[g][m],f),j=L(i.row,i.col,f),k=Math.min(i.row,k),l=Math.max(j.row,l),m=Math.min(i.col,m),n=Math.max(j.col,n)),((parseInt(a(f[g][n]).attr("rowspan"),10)||1)>1||(parseInt(a(f[g][n]).attr("colspan"),10)||1)>1)&&(i=K(f[g][n],f),j=L(i.row,i.col,f),k=Math.min(i.row,k),l=Math.max(j.row,l),m=Math.min(i.col,m),n=Math.max(j.col,n));for(h=m;h<=n;h++)((parseInt(a(f[k][h]).attr("rowspan"),10)||1)>1||(parseInt(a(f[k][h]).attr("colspan"),10)||1)>1)&&(i=K(f[k][h],f),j=L(i.row,i.col,f),k=Math.min(i.row,k),l=Math.max(j.row,l),m=Math.min(i.col,m),n=Math.max(j.col,n)),((parseInt(a(f[l][h]).attr("rowspan"),10)||1)>1||(parseInt(a(f[l][h]).attr("colspan"),10)||1)>1)&&(i=K(f[l][h],f),j=L(i.row,i.col,f),k=Math.min(i.row,k),l=Math.max(j.row,l),m=Math.min(i.col,m),n=Math.max(j.col,n));return k==b&&l==c&&m==d&&n==e?{min_i:b,max_i:c,min_j:d,max_j:e}:Q(k,l,m,n,f)}function R(b){var c=P(b),d=a(b[c.min_i][c.min_j]),e=a(b[c.min_i][c.max_j]),f=a(b[c.max_i][c.min_j]);return{left:d.offset().left,right:e.offset().left+e.outerWidth(),top:d.offset().top,bottom:f.offset().top+f.outerHeight()}}function S(c,d){if(a(c).is(d))N(),b.edit.on(),a(c).addClass("fr-selected-cell");else{O(),b.edit.off();var e=J(),f=K(c,e),g=K(d,e),h=Q(Math.min(f.row,g.row),Math.max(f.row,g.row),Math.min(f.col,g.col),Math.max(f.col,g.col),e);N(),c.classList.add("fr-cell-fixed"),d.classList.add("fr-cell-handler");for(var i=h.min_i;i<=h.max_i;i++)for(var j=h.min_j;j<=h.max_j;j++)a(e[i][j]).addClass("fr-selected-cell")}}function T(c){var d=null,e=a(c.target);return"TD"==c.target.tagName||"TH"==c.target.tagName?d=c.target:e.closest("td").length>0?d=e.closest("td").get(0):e.closest("th").length>0&&(d=e.closest("th").get(0)),0===b.$el.find(d).length?null:d}function U(){N(),b.popups.hide("table.edit")}function V(c){var d=T(c);if(ta().length>0&&!d&&U(),!b.edit.isDisabled()||b.popups.isVisible("table.edit"))if(1!=c.which||1==c.which&&b.helpers.isMac()&&c.ctrlKey)(3==c.which||1==c.which&&b.helpers.isMac()&&c.ctrlKey)&&d&&U();else if(Ba=!0,d){ta().length>0&&!c.shiftKey&&U(),c.stopPropagation(),b.events.trigger("image.hideResizer"),b.events.trigger("video.hideResizer"),Aa=!0;var e=d.tagName.toLowerCase();c.shiftKey&&b.$el.find(e+".fr-selected-cell").length>0?a(b.$el.find(e+".fr-selected-cell").closest("table")).is(a(d).closest("table"))?S(Ca,d):O():((b.keys.ctrlKey(c)||c.shiftKey)&&(ta().length>1||0===a(d).find(b.selection.element()).length&&!a(d).is(b.selection.element()))&&O(),Ca=d,S(Ca,Ca))}}function W(c){if(Aa||b.$tb.is(c.target)||b.$tb.is(a(c.target).closest(b.$tb.get(0)))||(ta().length>0&&b.toolbar.enable(),N()),!(1!=c.which||1==c.which&&b.helpers.isMac()&&c.ctrlKey)){if(Ba=!1,Aa){Aa=!1;T(c)||1!=ta().length?ta().length>0&&(b.selection.isCollapsed()?d():N()):N()}if(Ea){Ea=!1,ya.removeClass("fr-moving"),b.$el.removeClass("fr-no-selection"),b.edit.on();var e=parseFloat(ya.css("left"))+b.opts.tableResizerOffset;b.opts.iframe&&(e-=b.$iframe.offset().left),ya.data("release-position",e),ya.removeData("max-left"),ya.removeData("max-right"),ka(c),ca()}}}function X(c){if(!0===Aa){if(a(c.currentTarget).closest("table").is(ua())){if("TD"==c.currentTarget.tagName&&0===b.$el.find("th.fr-selected-cell").length)return void S(Ca,c.currentTarget);if("TH"==c.currentTarget.tagName&&0===b.$el.find("td.fr-selected-cell").length)return void S(Ca,c.currentTarget)}O()}}function Y(c,d){for(var e=c;e&&"TABLE"!=e.tagName&&e.parentNode!=b.el;)e=e.parentNode;if(e&&"TABLE"==e.tagName){var f=J(a(e));"up"==d?$(K(c,f),e,f):"down"==d&&_(K(c,f),e,f)}}function Z(a,c,d,e){for(var f,g=c;g!=b.el&&"TD"!=g.tagName&&"TH"!=g.tagName&&("up"==e?f=g.previousElementSibling:"down"==e&&(f=g.nextElementSibling),!f);)g=g.parentNode;"TD"==g.tagName||"TH"==g.tagName?Y(g,e):f&&("up"==e&&b.selection.setAtEnd(f),"down"==e&&b.selection.setAtStart(f))}function $(a,c,d){a.row>0?b.selection.setAtEnd(d[a.row-1][a.col]):Z(a,c,d,"up")}function _(a,c,d){var e=parseInt(d[a.row][a.col].getAttribute("rowspan"),10)||1;a.row<d.length-e?b.selection.setAtStart(d[a.row+e][a.col]):Z(a,c,d,"down")}function aa(c){var d=c.which,e=b.selection.blocks();if(e.length&&(e=e[0],"TD"==e.tagName||"TH"==e.tagName)){for(var f=e;f&&"TABLE"!=f.tagName&&f.parentNode!=b.el;)f=f.parentNode;if(f&&"TABLE"==f.tagName&&(a.FE.KEYCODE.ARROW_LEFT==d||a.FE.KEYCODE.ARROW_UP==d||a.FE.KEYCODE.ARROW_RIGHT==d||a.FE.KEYCODE.ARROW_DOWN==d)&&(ta().length>0&&U(),b.browser.webkit&&(a.FE.KEYCODE.ARROW_UP==d||a.FE.KEYCODE.ARROW_DOWN==d))){var g=b.selection.ranges(0).startContainer;if(g.nodeType==Node.TEXT_NODE&&(a.FE.KEYCODE.ARROW_UP==d&&g.previousSibling||a.FE.KEYCODE.ARROW_DOWN==d&&g.nextSibling))return;c.preventDefault(),c.stopPropagation();var h=J(a(f)),i=K(e,h);return a.FE.KEYCODE.ARROW_UP==d?$(i,f,h):a.FE.KEYCODE.ARROW_DOWN==d&&_(i,f,h),b.selection.restore(),!1}}}function ba(){b.shared.$table_resizer||(b.shared.$table_resizer=a('<div class="fr-table-resizer"><div></div></div>')),ya=b.shared.$table_resizer,b.events.$on(ya,"mousedown",function(a){return!b.core.sameInstance(ya)||(ta().length>0&&U(),1==a.which?(b.selection.save(),Ea=!0,ya.addClass("fr-moving"),O(),b.edit.off(),ya.find("div").css("opacity",1),!1):void 0)}),b.events.$on(ya,"mousemove",function(a){if(!b.core.sameInstance(ya))return!0;Ea&&(b.opts.iframe&&(a.pageX-=b.$iframe.offset().left),na(a))}),b.events.on("shared.destroy",function(){ya.html("").removeData().remove(),ya=null},!0),b.events.on("destroy",function(){b.$el.find(".fr-selected-cell").removeClass("fr-selected-cell"),ya.hide().appendTo(a("body:first"))},!0)}function ca(){ya&&(ya.find("div").css("opacity",0),ya.css("top",0),ya.css("left",0),ya.css("height",0),ya.find("div").css("height",0),ya.hide())}function da(){za&&za.removeClass("fr-visible").css("left","-9999px")}function ea(c,d){var e=a(d),f=e.closest("table"),g=f.parent();if(d&&"TD"!=d.tagName&&"TH"!=d.tagName&&(e.closest("td").length>0?d=e.closest("td"):e.closest("th").length>0&&(d=e.closest("th"))),!d||"TD"!=d.tagName&&"TH"!=d.tagName)ya&&e.get(0)!=ya.get(0)&&e.parent().get(0)!=ya.get(0)&&b.core.sameInstance(ya)&&ca();else{if(e=a(d),0===b.$el.find(e).length)return!1;var h=e.offset().left-1,i=h+e.outerWidth();if(Math.abs(c.pageX-h)<=b.opts.tableResizerOffset||Math.abs(i-c.pageX)<=b.opts.tableResizerOffset){var j,k,l,m,n,o=J(f),p=K(d,o),q=L(p.row,p.col,o),r=f.offset().top,s=f.outerHeight()-1;"rtl"!=b.opts.direction?c.pageX-h<=b.opts.tableResizerOffset?(l=h,p.col>0?(m=h-la(p.col-1,o)+b.opts.tableResizingLimit,n=h+la(p.col,o)-b.opts.tableResizingLimit,j=p.col-1,k=p.col):(j=null,k=0,m=f.offset().left-1-parseInt(f.css("margin-left"),10),n=f.offset().left-1+f.width()-o[0].length*b.opts.tableResizingLimit)):i-c.pageX<=b.opts.tableResizerOffset&&(l=i,q.col<o[q.row].length&&o[q.row][q.col+1]?(m=i-la(q.col,o)+b.opts.tableResizingLimit,n=i+la(q.col+1,o)-b.opts.tableResizingLimit,j=q.col,k=q.col+1):(j=q.col,k=null,m=f.offset().left-1+o[0].length*b.opts.tableResizingLimit,n=g.offset().left-1+g.width()+parseFloat(g.css("padding-left")))):i-c.pageX<=b.opts.tableResizerOffset?(l=i,p.col>0?(m=i-la(p.col,o)+b.opts.tableResizingLimit,n=i+la(p.col-1,o)-b.opts.tableResizingLimit,j=p.col,k=p.col-1):(j=null,k=0,m=f.offset().left+o[0].length*b.opts.tableResizingLimit,n=g.offset().left-1+g.width()+parseFloat(g.css("padding-left")))):c.pageX-h<=b.opts.tableResizerOffset&&(l=h,q.col<o[q.row].length&&o[q.row][q.col+1]?(m=h-la(q.col+1,o)+b.opts.tableResizingLimit,n=h+la(q.col,o)-b.opts.tableResizingLimit,j=q.col+1,k=q.col):(j=q.col,k=null,m=g.offset().left+parseFloat(g.css("padding-left")),n=f.offset().left-1+f.width()-o[0].length*b.opts.tableResizingLimit)),ya||ba(),ya.data("table",f),ya.data("first",j),ya.data("second",k),ya.data("instance",b),b.$wp.append(ya);var t=l-b.win.pageXOffset-b.opts.tableResizerOffset,u=r-b.win.pageYOffset;b.opts.iframe&&(t+=b.$iframe.offset().left-b.helpers.scrollLeft(),u+=b.$iframe.offset().top-b.helpers.scrollTop(),m+=b.$iframe.offset().left,n+=b.$iframe.offset().left),ya.data("max-left",m),ya.data("max-right",n),ya.data("origin",l-b.win.pageXOffset),ya.css("top",u),ya.css("left",t),ya.css("height",s),ya.find("div").css("height",s),ya.css("padding-left",b.opts.tableResizerOffset),ya.css("padding-right",b.opts.tableResizerOffset),ya.show()}else b.core.sameInstance(ya)&&ca()}}function fa(c,d){if(b.$box.find(".fr-line-breaker").is(":visible"))return!1;za||qa(),b.$box.append(za),za.data("instance",b);var e=a(d),f=e.find("tr:first"),g=c.pageX,h=0,i=0;b.opts.iframe&&(h+=b.$iframe.offset().left-b.helpers.scrollLeft(),i+=b.$iframe.offset().top-b.helpers.scrollTop());var j;f.find("th, td").each(function(){var c=a(this);return c.offset().left<=g&&g<c.offset().left+c.outerWidth()/2?(j=parseInt(za.find("a").css("width"),10),za.css("top",i+c.offset().top-b.win.pageYOffset-j-5),za.css("left",h+c.offset().left-b.win.pageXOffset-j/2),za.data("selected-cell",c),za.data("position","before"),za.addClass("fr-visible"),!1):c.offset().left+c.outerWidth()/2<=g&&g<c.offset().left+c.outerWidth()?(j=parseInt(za.find("a").css("width"),10),za.css("top",i+c.offset().top-b.win.pageYOffset-j-5),za.css("left",h+c.offset().left+c.outerWidth()-b.win.pageXOffset-j/2),za.data("selected-cell",c),za.data("position","after"),za.addClass("fr-visible"),!1):void 0})}function ga(c,d){if(b.$box.find(".fr-line-breaker").is(":visible"))return!1;za||qa(),b.$box.append(za),za.data("instance",b);var e=a(d),f=c.pageY,g=0,h=0;b.opts.iframe&&(g+=b.$iframe.offset().left-b.helpers.scrollLeft(),h+=b.$iframe.offset().top-b.helpers.scrollTop());var i;e.find("tr").each(function(){var c=a(this);return c.offset().top<=f&&f<c.offset().top+c.outerHeight()/2?(i=parseInt(za.find("a").css("width"),10),za.css("top",h+c.offset().top-b.win.pageYOffset-i/2),za.css("left",g+c.offset().left-b.win.pageXOffset-i-5),za.data("selected-cell",c.find("td:first")),za.data("position","above"),za.addClass("fr-visible"),!1):c.offset().top+c.outerHeight()/2<=f&&f<c.offset().top+c.outerHeight()?(i=parseInt(za.find("a").css("width"),10),za.css("top",h+c.offset().top+c.outerHeight()-b.win.pageYOffset-i/2),za.css("left",g+c.offset().left-b.win.pageXOffset-i-5),za.data("selected-cell",c.find("td:first")),za.data("position","below"),za.addClass("fr-visible"),!1):void 0})}function ha(c,d){if(0===ta().length){var e,f,g;if(d&&("HTML"==d.tagName||"BODY"==d.tagName||b.node.isElement(d)))for(e=1;e<=b.opts.tableInsertHelperOffset;e++){if(f=b.doc.elementFromPoint(c.pageX-b.win.pageXOffset,c.pageY-b.win.pageYOffset+e),a(f).hasClass("fr-tooltip"))return!0;if(f&&("TH"==f.tagName||"TD"==f.tagName||"TABLE"==f.tagName)&&(a(f).parents(".fr-wrapper").length||b.opts.iframe))return fa(c,a(f).closest("table")),!0;if(g=b.doc.elementFromPoint(c.pageX-b.win.pageXOffset+e,c.pageY-b.win.pageYOffset),a(g).hasClass("fr-tooltip"))return!0;if(g&&("TH"==g.tagName||"TD"==g.tagName||"TABLE"==g.tagName)&&(a(g).parents(".fr-wrapper").length||b.opts.iframe))return ga(c,a(g).closest("table")),!0}b.core.sameInstance(za)&&da()}}function ia(a){Da=null;var c=b.doc.elementFromPoint(a.pageX-b.win.pageXOffset,a.pageY-b.win.pageYOffset);b.opts.tableResizer&&(!b.popups.areVisible()||b.popups.areVisible()&&b.popups.isVisible("table.edit"))&&ea(a,c),!b.opts.tableInsertHelper||b.popups.areVisible()||b.$tb.hasClass("fr-inline")&&b.$tb.is(":visible")||ha(a,c)}function ja(){if(Ea){var a=ya.data("table"),c=a.offset().top-b.win.pageYOffset;b.opts.iframe&&(c+=b.$iframe.offset().top-b.helpers.scrollTop()),ya.css("top",c)}}function ka(){var c=ya.data("origin"),d=ya.data("release-position");if(c!==d){var e=ya.data("first"),f=ya.data("second"),g=ya.data("table"),h=g.outerWidth();if(b.undo.canDo()||b.undo.saveStep(),null!==e&&null!==f){var i,j,k,l=J(g),m=[],n=[],o=[],p=[];for(i=0;i<l.length;i++)j=a(l[i][e]),k=a(l[i][f]),m[i]=j.outerWidth(),o[i]=k.outerWidth(),n[i]=m[i]/h*100,p[i]=o[i]/h*100;for(i=0;i<l.length;i++){j=a(l[i][e]),k=a(l[i][f]);var q=(n[i]*(m[i]+d-c)/m[i]).toFixed(4);j.css("width",q+"%"),k.css("width",(n[i]+p[i]-q).toFixed(4)+"%")}}else{var r,s=g.parent(),t=h/s.width()*100,u=(parseInt(g.css("margin-left"),10)||0)/s.width()*100,v=(parseInt(g.css("margin-right"),10)||0)/s.width()*100;"rtl"==b.opts.direction&&0===f||"rtl"!=b.opts.direction&&0!==f?(r=(h+d-c)/h*t,g.css("margin-right","calc(100% - "+Math.round(r).toFixed(4)+"% - "+Math.round(u).toFixed(4)+"%)")):("rtl"==b.opts.direction&&0!==f||"rtl"!=b.opts.direction&&0===f)&&(r=(h-d+c)/h*t,g.css("margin-left","calc(100% - "+Math.round(r).toFixed(4)+"% - "+Math.round(v).toFixed(4)+"%)")),g.css("width",Math.round(r).toFixed(4)+"%")}b.selection.restore(),b.undo.saveStep()}ya.removeData("origin"),ya.removeData("release-position"),ya.removeData("first"),ya.removeData("second"),ya.removeData("table")}function la(b,c){var d,e=a(c[0][b]).outerWidth();for(d=1;d<c.length;d++)e=Math.min(e,a(c[d][b]).outerWidth());return e}function ma(a,b,c){var d,e=0;for(d=a;d<=b;d++)e+=la(d,c);return e}function na(a){if(ta().length>1&&Ba&&O(),!1===Ba&&!1===Aa&&!1===Ea)Da&&clearTimeout(Da),b.edit.isDisabled()&&!b.popups.isVisible("table.edit")||(Da=setTimeout(ia,30,a));else if(Ea){var c=a.pageX-b.win.pageXOffset;b.opts.iframe&&(c+=b.$iframe.offset().left);var d=ya.data("max-left"),e=ya.data("max-right");c>=d&&c<=e?ya.css("left",c-b.opts.tableResizerOffset):c<d&&parseFloat(ya.css("left"),10)>d-b.opts.tableResizerOffset?ya.css("left",d-b.opts.tableResizerOffset):c>e&&parseFloat(ya.css("left"),10)<e-b.opts.tableResizerOffset&&ya.css("left",e-b.opts.tableResizerOffset)}else Ba&&da()}function oa(c){b.node.isEmpty(c.get(0))?c.prepend(a.FE.MARKERS):c.prepend(a.FE.START_MARKER).append(a.FE.END_MARKER)}function pa(c){if(c.which==a.FE.KEYCODE.TAB){var d;if(ta().length>0)d=b.$el.find(".fr-selected-cell:last");else{var e=b.selection.element();"TD"==e.tagName||"TH"==e.tagName?d=a(e):e!=b.el&&(a(e).parentsUntil(b.$el,"td").length>0?d=a(e).parents("td:first"):a(e).parentsUntil(b.$el,"th").length>0&&(d=a(e).parents("th:first")))}if(d)return c.preventDefault(),a(b.selection.element()).parents("ol, ul").length>0||(U(),c.shiftKey?d.prev().length>0?oa(d.prev()):d.closest("tr").length>0&&d.closest("tr").prev().length>0?oa(d.closest("tr").prev().find("td:last")):d.closest("tbody").length>0&&d.closest("table").find("thead tr").length>0&&oa(d.closest("table").find("thead tr th:last")):d.next().length>0?oa(d.next()):d.closest("tr").length>0&&d.closest("tr").next().length>0?oa(d.closest("tr").next().find("td:first")):d.closest("thead").length>0&&d.closest("table").find("tbody tr").length>0?oa(d.closest("table").find("tbody tr td:first")):(d.addClass("fr-selected-cell"),u("below"),N(),oa(d.closest("tr").next().find("td:first"))),b.selection.restore(),!1)}}function qa(){b.shared.$ti_helper||(b.shared.$ti_helper=a('<div class="fr-insert-helper"><a class="fr-floating-btn" role="button" tabIndex="-1" title="'+b.language.translate("Insert")+'"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M22,16.75 L16.75,16.75 L16.75,22 L15.25,22.000 L15.25,16.75 L10,16.75 L10,15.25 L15.25,15.25 L15.25,10 L16.75,10 L16.75,15.25 L22,15.25 L22,16.75 Z"/></svg></a></div>'),b.events.bindClick(b.shared.$ti_helper,"a",function(){var a=za.data("selected-cell"),c=za.data("position"),d=za.data("instance")||b;"before"==c?(b.undo.saveStep(),a.addClass("fr-selected-cell"),d.table.insertColumn(c),a.removeClass("fr-selected-cell"),b.undo.saveStep()):"after"==c?(b.undo.saveStep(),a.addClass("fr-selected-cell"),d.table.insertColumn(c),a.removeClass("fr-selected-cell"),b.undo.saveStep()):"above"==c?(b.undo.saveStep(),a.addClass("fr-selected-cell"),d.table.insertRow(c),a.removeClass("fr-selected-cell"),b.undo.saveStep()):"below"==c&&(b.undo.saveStep(),a.addClass("fr-selected-cell"),d.table.insertRow(c),a.removeClass("fr-selected-cell"),b.undo.saveStep()),da()}),b.events.on("shared.destroy",function(){b.shared.$ti_helper.html("").removeData().remove(),b.shared.$ti_helper=null},!0),b.events.$on(b.shared.$ti_helper,"mousemove",function(a){a.stopPropagation()},!0),b.events.$on(a(b.o_win),"scroll",function(){da()},!0),b.events.$on(b.$wp,"scroll",function(){da()},!0)),za=b.shared.$ti_helper,b.events.on("destroy",function(){za=null}),b.tooltip.bind(b.$box,".fr-insert-helper > a.fr-floating-btn")}function ra(){Ca=null,clearTimeout(Da)}function sa(){ta().length>0?d():(b.popups.hide("table.insert"),b.toolbar.showInline())}function ta(){return b.el.querySelectorAll(".fr-selected-cell")}function ua(){var c=ta();if(c.length){for(var d=c[0];d&&"TABLE"!=d.tagName&&d.parentNode!=b.el;)d=d.parentNode;return a(d&&"TABLE"==d.tagName?d:[])}return a([])}function va(c){if(c.altKey&&c.which==a.FE.KEYCODE.SPACE){var e,f=b.selection.element();if("TD"==f.tagName||"TH"==f.tagName?e=f:a(f).closest("td").length>0?e=a(f).closest("td").get(0):a(f).closest("th").length>0&&(e=a(f).closest("th").get(0)),e)return c.preventDefault(),S(e,e),d(),!1}}function wa(c){var d=ta();if(d.length>0){var e,f,g=J(),h=c.which;1==d.length?(e=d[0],
f=e):(e=b.el.querySelector(".fr-cell-fixed"),f=b.el.querySelector(".fr-cell-handler"));var i=K(f,g);if(a.FE.KEYCODE.ARROW_RIGHT==h){if(i.col<g[0].length-1)return S(e,g[i.row][i.col+1]),!1}else if(a.FE.KEYCODE.ARROW_DOWN==h){if(i.row<g.length-1)return S(e,g[i.row+1][i.col]),!1}else if(a.FE.KEYCODE.ARROW_LEFT==h){if(i.col>0)return S(e,g[i.row][i.col-1]),!1}else if(a.FE.KEYCODE.ARROW_UP==h&&i.row>0)return S(e,g[i.row-1][i.col]),!1}}function xa(){if(!b.$wp)return!1;if(!b.helpers.isMobile()){Ba=!1,Aa=!1,Ea=!1,b.events.$on(b.$el,"mousedown",V),b.popups.onShow("image.edit",function(){N(),Ba=!1,Aa=!1}),b.popups.onShow("link.edit",function(){N(),Ba=!1,Aa=!1}),b.events.on("commands.mousedown",function(a){a.parents(".fr-toolbar").length>0&&N()}),b.events.$on(b.$el,"mouseenter","th, td",X),b.events.$on(b.$win,"mouseup",W),b.opts.iframe&&b.events.$on(a(b.o_win),"mouseup",W),b.events.$on(b.$win,"mousemove",na),b.events.$on(a(b.o_win),"scroll",ja),b.events.on("contentChanged",function(){ta().length>0&&(d(),b.$el.find("img").on("load.selected-cells",function(){a(this).off("load.selected-cells"),ta().length>0&&d()}))}),b.events.$on(a(b.o_win),"resize",function(){N()}),b.events.on("toolbar.esc",function(){if(ta().length>0)return b.events.disableBlur(),b.events.focus(),!1},!0),b.events.$on(a(b.o_win),"keydown",function(){Ba&&Aa&&(Ba=!1,Aa=!1,b.$el.removeClass("fr-no-selection"),b.edit.on(),b.selection.setAtEnd(b.$el.find(".fr-selected-cell:last").get(0)),b.selection.restore(),N())}),b.events.$on(b.$el,"keydown",function(a){a.shiftKey?!1===wa(a)&&setTimeout(function(){d()},0):aa(a)}),b.events.on("keydown",function(c){if(!1===pa(c))return!1;var d=ta();if(d.length>0){if(d.length>0&&b.keys.ctrlKey(c)&&c.which==a.FE.KEYCODE.A)return N(),b.popups.isVisible("table.edit")&&b.popups.hide("table.edit"),d=[],!0;if(c.which==a.FE.KEYCODE.ESC&&b.popups.isVisible("table.edit"))return N(),b.popups.hide("table.edit"),c.preventDefault(),c.stopPropagation(),c.stopImmediatePropagation(),d=[],!1;if(d.length>1&&(c.which==a.FE.KEYCODE.BACKSPACE||c.which==a.FE.KEYCODE.DELETE)){b.undo.saveStep();for(var e=0;e<d.length;e++)a(d[e]).html("<br>"),e==d.length-1&&a(d[e]).prepend(a.FE.MARKERS);return b.selection.restore(),b.undo.saveStep(),d=[],!1}if(d.length>1&&c.which!=a.FE.KEYCODE.F10&&!b.keys.isBrowserAction(c))return c.preventDefault(),d=[],!1}else if(d=[],!1===va(c))return!1},!0);var c=[];b.events.on("html.beforeGet",function(){c=ta();for(var a=0;a<c.length;a++)c[a].className=(c[a].className||"").replace(/fr-selected-cell/g,"")}),b.events.on("html.afterGet",function(){for(var a=0;a<c.length;a++)c[a].className=(c[a].className?c[a].className.trim()+" ":"")+"fr-selected-cell";c=[]}),g(!0),k(!0)}b.events.on("destroy",ra)}var ya,za,Aa,Ba,Ca,Da,Ea;return{_init:xa,insert:q,remove:r,insertRow:u,deleteRow:v,insertColumn:w,deleteColumn:x,mergeCells:C,splitCellVertically:E,splitCellHorizontally:D,addHeader:s,removeHeader:t,setBackground:F,showInsertPopup:c,showEditPopup:d,showColorsPopup:e,back:sa,verticalAlign:G,horizontalAlign:H,applyStyle:I,selectedTable:ua,selectedCells:ta,customColor:n}},a.FE.DefineIcon("insertTable",{NAME:"table"}),a.FE.RegisterCommand("insertTable",{title:"Insert Table",undo:!1,focus:!0,refreshOnCallback:!1,popup:!0,callback:function(){this.popups.isVisible("table.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("table.insert")):this.table.showInsertPopup()},plugin:"table"}),a.FE.RegisterCommand("tableInsert",{callback:function(a,b,c){this.table.insert(b,c),this.popups.hide("table.insert")}}),a.FE.DefineIcon("tableHeader",{NAME:"header"}),a.FE.RegisterCommand("tableHeader",{title:"Table Header",focus:!1,toggle:!0,callback:function(){this.popups.get("table.edit").find('.fr-command[data-cmd="tableHeader"]').hasClass("fr-active")?this.table.removeHeader():this.table.addHeader()},refresh:function(a){var b=this.table.selectedTable();b.length>0&&(0===b.find("th").length?a.removeClass("fr-active").attr("aria-pressed",!1):a.addClass("fr-active").attr("aria-pressed",!0))}}),a.FE.DefineIcon("tableRows",{NAME:"bars"}),a.FE.RegisterCommand("tableRows",{type:"dropdown",focus:!1,title:"Row",options:{above:"Insert row above",below:"Insert row below",delete:"Delete row"},html:function(){var b='<ul class="fr-dropdown-list" role="presentation">',c=a.FE.COMMANDS.tableRows.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableRows" data-param1="'+d+'" title="'+this.language.translate(c[d])+'">'+this.language.translate(c[d])+"</a></li>");return b+="</ul>"},callback:function(a,b){"above"==b||"below"==b?this.table.insertRow(b):this.table.deleteRow()}}),a.FE.DefineIcon("tableColumns",{NAME:"bars fa-rotate-90"}),a.FE.RegisterCommand("tableColumns",{type:"dropdown",focus:!1,title:"Column",options:{before:"Insert column before",after:"Insert column after",delete:"Delete column"},html:function(){var b='<ul class="fr-dropdown-list" role="presentation">',c=a.FE.COMMANDS.tableColumns.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableColumns" data-param1="'+d+'" title="'+this.language.translate(c[d])+'">'+this.language.translate(c[d])+"</a></li>");return b+="</ul>"},callback:function(a,b){"before"==b||"after"==b?this.table.insertColumn(b):this.table.deleteColumn()}}),a.FE.DefineIcon("tableCells",{NAME:"square-o"}),a.FE.RegisterCommand("tableCells",{type:"dropdown",focus:!1,title:"Cell",options:{merge:"Merge cells","vertical-split":"Vertical split","horizontal-split":"Horizontal split"},html:function(){var b='<ul class="fr-dropdown-list" role="presentation">',c=a.FE.COMMANDS.tableCells.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCells" data-param1="'+d+'" title="'+this.language.translate(c[d])+'">'+this.language.translate(c[d])+"</a></li>");return b+="</ul>"},callback:function(a,b){"merge"==b?this.table.mergeCells():"vertical-split"==b?this.table.splitCellVertically():this.table.splitCellHorizontally()},refreshOnShow:function(a,b){this.$el.find(".fr-selected-cell").length>1?(b.find('a[data-param1="vertical-split"]').addClass("fr-disabled").attr("aria-disabled",!0),b.find('a[data-param1="horizontal-split"]').addClass("fr-disabled").attr("aria-disabled",!0),b.find('a[data-param1="merge"]').removeClass("fr-disabled").attr("aria-disabled",!1)):(b.find('a[data-param1="merge"]').addClass("fr-disabled").attr("aria-disabled",!0),b.find('a[data-param1="vertical-split"]').removeClass("fr-disabled").attr("aria-disabled",!1),b.find('a[data-param1="horizontal-split"]').removeClass("fr-disabled").attr("aria-disabled",!1))}}),a.FE.DefineIcon("tableRemove",{NAME:"trash"}),a.FE.RegisterCommand("tableRemove",{title:"Remove Table",focus:!1,callback:function(){this.table.remove()}}),a.FE.DefineIcon("tableStyle",{NAME:"paint-brush"}),a.FE.RegisterCommand("tableStyle",{title:"Table Style",type:"dropdown",focus:!1,html:function(){var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.tableStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableStyle" data-param1="'+c+'" title="'+this.language.translate(b[c])+'">'+this.language.translate(b[c])+"</a></li>");return a+="</ul>"},callback:function(a,b){this.table.applyStyle(b,this.$el.find(".fr-selected-cell").closest("table"),this.opts.tableMultipleStyles,this.opts.tableStyles)},refreshOnShow:function(b,c){var d=this.$el.find(".fr-selected-cell").closest("table");d&&c.find(".fr-command").each(function(){var b=a(this).data("param1"),c=d.hasClass(b);a(this).toggleClass("fr-active",c).attr("aria-selected",c)})}}),a.FE.DefineIcon("tableCellBackground",{NAME:"tint"}),a.FE.RegisterCommand("tableCellBackground",{title:"Cell Background",focus:!1,popup:!0,callback:function(){this.table.showColorsPopup()}}),a.FE.RegisterCommand("tableCellBackgroundColor",{undo:!0,focus:!1,callback:function(a,b){this.table.setBackground(b)}}),a.FE.DefineIcon("tableBack",{NAME:"arrow-left"}),a.FE.RegisterCommand("tableBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.table.back()},refresh:function(a){0!==this.table.selectedCells().length||this.opts.toolbarInline?(a.removeClass("fr-hidden"),a.next(".fr-separator").removeClass("fr-hidden")):(a.addClass("fr-hidden"),a.next(".fr-separator").addClass("fr-hidden"))}}),a.FE.DefineIcon("tableCellVerticalAlign",{NAME:"arrows-v"}),a.FE.RegisterCommand("tableCellVerticalAlign",{type:"dropdown",focus:!1,title:"Vertical Align",options:{Top:"Align Top",Middle:"Align Middle",Bottom:"Align Bottom"},html:function(){var b='<ul class="fr-dropdown-list" role="presentation">',c=a.FE.COMMANDS.tableCellVerticalAlign.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellVerticalAlign" data-param1="'+d.toLowerCase()+'" title="'+this.language.translate(c[d])+'">'+this.language.translate(d)+"</a></li>");return b+="</ul>"},callback:function(a,b){this.table.verticalAlign(b)},refreshOnShow:function(a,b){b.find('.fr-command[data-param1="'+this.$el.find(".fr-selected-cell").css("vertical-align")+'"]').addClass("fr-active").attr("aria-selected",!0)}}),a.FE.DefineIcon("tableCellHorizontalAlign",{NAME:"align-left"}),a.FE.DefineIcon("align-left",{NAME:"align-left"}),a.FE.DefineIcon("align-right",{NAME:"align-right"}),a.FE.DefineIcon("align-center",{NAME:"align-center"}),a.FE.DefineIcon("align-justify",{NAME:"align-justify"}),a.FE.RegisterCommand("tableCellHorizontalAlign",{type:"dropdown",focus:!1,title:"Horizontal Align",options:{left:"Align Left",center:"Align Center",right:"Align Right",justify:"Align Justify"},html:function(){var b='<ul class="fr-dropdown-list" role="presentation">',c=a.FE.COMMANDS.tableCellHorizontalAlign.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="tableCellHorizontalAlign" data-param1="'+d+'" title="'+this.language.translate(c[d])+'">'+this.icon.create("align-"+d)+'<span class="fr-sr-only">'+this.language.translate(c[d])+"</span></a></li>");return b+="</ul>"},callback:function(a,b){this.table.horizontalAlign(b)},refresh:function(b){var c=this.table.selectedCells();c.length&&b.find("> *:first").replaceWith(this.icon.create("align-"+this.helpers.getAlignment(a(c[0]))))},refreshOnShow:function(a,b){b.find('.fr-command[data-param1="'+this.helpers.getAlignment(this.$el.find(".fr-selected-cell:first"))+'"]').addClass("fr-active").attr("aria-selected",!0)}}),a.FE.DefineIcon("tableCellStyle",{NAME:"magic"}),a.FE.RegisterCommand("tableCellStyle",{title:"Cell Style",type:"dropdown",focus:!1,html:function(){var a='<ul class="fr-dropdown-list" role="presentation">',b=this.opts.tableCellStyles;for(var c in b)b.hasOwnProperty(c)&&(a+='<li role="presentation"><a class="fr-command" tabIndex="-1" role="option" data-cmd="tableCellStyle" data-param1="'+c+'" title="'+this.language.translate(b[c])+'">'+this.language.translate(b[c])+"</a></li>");return a+="</ul>"},callback:function(a,b){this.table.applyStyle(b,this.$el.find(".fr-selected-cell"),this.opts.tableCellMultipleStyles,this.opts.tableCellStyles)},refreshOnShow:function(b,c){var d=this.$el.find(".fr-selected-cell:first");d&&c.find(".fr-command").each(function(){var b=a(this).data("param1"),c=d.hasClass(b);a(this).toggleClass("fr-active",c).attr("aria-selected",c)})}}),a.FE.RegisterCommand("tableCellBackgroundCustomColor",{title:"OK",undo:!0,callback:function(){this.table.customColor()}}),a.FE.DefineIcon("tableColorRemove",{NAME:"eraser"}),a.FE.URLRegEx="(^| |\\u00A0)("+a.FE.LinkRegEx+"|([a-z0-9+-_.]{1,}@[a-z0-9+-_.]{1,}\\.[a-z0-9+-_]{1,}))$",a.FE.PLUGINS.url=function(b){function c(a,c,d){for(var e="";d.length&&"."==d[d.length-1];)e+=".",d=d.substring(0,d.length-1);var f=d;if(b.opts.linkConvertEmailAddress)b.helpers.isEmail(f)&&!/^mailto:.*/i.test(f)&&(f="mailto:"+f);else if(b.helpers.isEmail(f))return c+d;return/^((http|https|ftp|ftps|mailto|tel|sms|notes|data)\:)/i.test(f)||(f="//"+f),(c||"")+"<a"+(b.opts.linkAlwaysBlank?' target="_blank"':"")+(j?' rel="'+j+'"':"")+' href="'+f+'">'+d.replace(/</g,"&lt;").replace(/>/g,"&gt;")+"</a>"+e}function d(){return new RegExp(a.FE.URLRegEx,"gi")}function e(a){return b.opts.linkAlwaysNoFollow&&(j="nofollow"),b.opts.linkAlwaysBlank&&(j?j+=" noopener noreferrer":j="noopener noreferrer"),a.replace(d(),c)}function f(a){return!!a&&("A"===a.tagName||!(!a.parentNode||a.parentNode==b.el)&&f(a.parentNode))}function g(a){var b=a.split(" ");return b[b.length-1]}function h(){var c=b.selection.ranges(0),h=c.startContainer;if(!h||h.nodeType!==Node.TEXT_NODE)return!1;if(f(h))return!1;if(d().test(g(h.textContent)))a(h).before(e(h.textContent)),h.parentNode.removeChild(h);else if(h.previousSibling&&"A"===h.previousSibling.tagName){var i=h.previousSibling.innerText+h.textContent;d().test(g(i))&&(a(h.previousSibling).replaceWith(e(i)),h.parentNode.removeChild(h))}}function i(){b.events.on("keydown",function(c){var d=c.which;!b.selection.isCollapsed()||d!=a.FE.KEYCODE.ENTER&&d!=a.FE.KEYCODE.SPACE&&d!=a.FE.KEYCODE.PERIOD||h()},!0)}var j=null;return{_init:i}},a.extend(a.FE.POPUP_TEMPLATES,{"video.insert":"[_BUTTONS_][_BY_URL_LAYER_][_EMBED_LAYER_][_UPLOAD_LAYER_][_PROGRESS_BAR_]","video.edit":"[_BUTTONS_]","video.size":"[_BUTTONS_][_SIZE_LAYER_]"}),a.extend(a.FE.DEFAULTS,{videoAllowedTypes:["mp4","webm","ogg"],videoAllowedProviders:[".*"],videoDefaultAlign:"center",videoDefaultDisplay:"block",videoDefaultWidth:600,videoEditButtons:["videoReplace","videoRemove","|","videoDisplay","videoAlign","videoSize"],videoInsertButtons:["videoBack","|","videoByURL","videoEmbed","videoUpload"],videoMaxSize:52428800,videoMove:!0,videoResize:!0,videoSizeButtons:["videoBack","|"],videoSplitHTML:!1,videoTextNear:!0,videoUpload:!0,videoUploadMethod:"POST",videoUploadParam:"file",videoUploadParams:{},videoUploadToS3:!1,videoUploadURL:"https://i.froala.com/upload"}),a.FE.VIDEO_PROVIDERS=[{test_regex:/^.*((youtu.be)|(youtube.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#\&\?]*).*/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_\-]+)(.+)?/g,url_text:"https://www.youtube.com/embed/$1",html:'<iframe width="640" height="360" src="{url}?wmode=opaque" frameborder="0" allowfullscreen></iframe>',provider:"youtube"},{test_regex:/^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\u200b\d+\/|video\/|)(\d+)(?:$|\/|\?)/,url_regex:/(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i,url_text:"https://player.vimeo.com/video/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"vimeo"},{test_regex:/^.+(dailymotion.com|dai.ly)\/(video|hub)?\/?([^_]+)[^#]*(#video=([^_&]+))?/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:dailymotion\.com|dai\.ly)\/(?:video|hub)?\/?(.+)/g,url_text:"https://www.dailymotion.com/embed/video/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"dailymotion"},{test_regex:/^.+(screen.yahoo.com)\/[^_&]+/,url_regex:"",url_text:"",html:'<iframe width="640" height="360" src="{url}?format=embed" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',provider:"yahoo"},{test_regex:/^.+(rutube.ru)\/[^_&]+/,url_regex:/(?:https?:\/\/)?(?:www\.)?(?:rutube\.ru)\/(?:video)?\/?(.+)/g,url_text:"https://rutube.ru/play/embed/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allowtransparency="true"></iframe>',provider:"rutube"},{test_regex:/^(?:.+)vidyard.com\/(?:watch)?\/?([^.&\/]+)\/?(?:[^_.&]+)?/,url_regex:/^(?:.+)vidyard.com\/(?:watch)?\/?([^.&\/]+)\/?(?:[^_.&]+)?/g,url_text:"https://play.vidyard.com/$1",html:'<iframe width="640" height="360" src="{url}" frameborder="0" allowfullscreen></iframe>',provider:"vidyard"}],a.FE.VIDEO_EMBED_REGEX=/^\W*((<iframe.*><\/iframe>)|(<embed.*>))\W*$/i,a.FE.PLUGINS.video=function(b){function c(){var a=b.popups.get("video.insert");a.find(".fr-video-by-url-layer input").val("").trigger("change");var c=a.find(".fr-video-embed-layer textarea");c.val("").trigger("change"),c=a.find(".fr-video-upload-layer input"),c.val("").trigger("change")}function d(){var a=b.$tb.find('.fr-command[data-cmd="insertVideo"]'),c=b.popups.get("video.insert");if(c||(c=f()),o(),!c.hasClass("fr-active")){b.popups.refresh("video.insert"),b.popups.setContainer("video.insert",b.$tb);var d=a.offset().left+a.outerWidth()/2,e=a.offset().top+(b.opts.toolbarBottom?10:a.outerHeight()-10);b.popups.show("video.insert",d,e,a.outerHeight())}}function e(){var a=b.popups.get("video.edit");if(a||(a=T()),a){b.popups.setContainer("video.edit",b.$sc),b.popups.refresh("video.edit");var c=ra.find("iframe, embed, video"),d=c.offset().left+c.outerWidth()/2,e=c.offset().top+c.outerHeight();b.popups.show("video.edit",d,e,c.outerHeight())}}function f(a){if(a)return b.popups.onRefresh("video.insert",c),b.popups.onHide("image.insert",ea),!0;var d="";b.opts.videoUpload||b.opts.videoInsertButtons.splice(b.opts.videoInsertButtons.indexOf("videoUpload"),1),b.opts.videoInsertButtons.length>1&&(d='<div class="fr-buttons">'+b.button.buildList(b.opts.videoInsertButtons)+"</div>");var e,f="",g=b.opts.videoInsertButtons.indexOf("videoUpload"),h=b.opts.videoInsertButtons.indexOf("videoByURL"),i=b.opts.videoInsertButtons.indexOf("videoEmbed");h>=0&&(e=" fr-active",(h>g&&g>=0||h>i&&i>=0)&&(e=""),f='<div class="fr-video-by-url-layer fr-layer'+e+'" id="fr-video-by-url-layer-'+b.id+'"><div class="fr-input-line"><input id="fr-video-by-url-layer-text-'+b.id+'" type="text" placeholder="'+b.language.translate("Paste in a video URL")+'" tabIndex="1" aria-required="true"></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoInsertByURL" tabIndex="2" role="button">'+b.language.translate("Insert")+"</button></div></div>");var j="";i>=0&&(e=" fr-active",(i>g&&g>=0||i>h&&h>=0)&&(e=""),j='<div class="fr-video-embed-layer fr-layer'+e+'" id="fr-video-embed-layer-'+b.id+'"><div class="fr-input-line"><textarea id="fr-video-embed-layer-text'+b.id+'" type="text" placeholder="'+b.language.translate("Embedded Code")+'" tabIndex="1" aria-required="true" rows="5"></textarea></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoInsertEmbed" tabIndex="2" role="button">'+b.language.translate("Insert")+"</button></div></div>");var k="";g>=0&&(e=" fr-active",(g>i&&i>=0||g>h&&h>=0)&&(e=""),k='<div class="fr-video-upload-layer fr-layer'+e+'" id="fr-video-upload-layer-'+b.id+'"><strong>'+b.language.translate("Drop video")+"</strong><br>("+b.language.translate("or click")+')<div class="fr-form"><input type="file" accept="video/'+b.opts.videoAllowedTypes.join(", video/").toLowerCase()+'" tabIndex="-1" aria-labelledby="fr-video-upload-layer-'+b.id+'" role="button"></div></div>');var l='<div class="fr-video-progress-bar-layer fr-layer"><h3 tabIndex="-1" class="fr-message">Uploading</h3><div class="fr-loader"><span class="fr-progress"></span></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-dismiss" data-cmd="videoDismissError" tabIndex="2" role="button">OK</button></div></div>',m={buttons:d,by_url_layer:f,embed_layer:j,upload_layer:k,progress_bar:l},n=b.popups.create("video.insert",m);return Q(n),n}function g(a){var c,d,e=b.popups.get("video.insert");if(!ra&&!b.opts.toolbarInline){var f=b.$tb.find('.fr-command[data-cmd="insertVideo"]');c=f.offset().left+f.outerWidth()/2,d=f.offset().top+(b.opts.toolbarBottom?10:f.outerHeight()-10)}b.opts.toolbarInline&&(d=e.offset().top-b.helpers.getPX(e.css("margin-top")),e.hasClass("fr-above")&&(d+=e.outerHeight())),e.find(".fr-layer").removeClass("fr-active"),e.find(".fr-"+a+"-layer").addClass("fr-active"),b.popups.show("video.insert",c,d,0),b.accessibility.focusPopup(e)}function h(a){b.popups.get("video.insert").find(".fr-video-by-url-layer").hasClass("fr-active")&&a.addClass("fr-active").attr("aria-pressed",!0)}function i(a){b.popups.get("video.insert").find(".fr-video-embed-layer").hasClass("fr-active")&&a.addClass("fr-active").attr("aria-pressed",!0)}function j(a){b.popups.get("video.insert").find(".fr-video-upload-layer").hasClass("fr-active")&&a.addClass("fr-active").attr("aria-pressed",!0)}function k(a){b.events.focus(!0),b.selection.restore();var c=!1;ra&&(da(),c=!0),b.html.insert('<span contenteditable="false" draggable="true" class="fr-jiv fr-video">'+a+"</span>",!1,b.opts.videoSplitHTML),b.popups.hide("video.insert");var d=b.$el.find(".fr-jiv");d.removeClass("fr-jiv"),fa(d,b.opts.videoDefaultDisplay,b.opts.videoDefaultAlign),d.toggleClass("fr-draggable",b.opts.videoMove),b.events.trigger(c?"video.replaced":"video.inserted",[d])}function l(){var c=a(this);b.popups.hide("video.insert"),c.removeClass("fr-uploading"),c.parent().next().is("br")&&c.parent().next().remove(),t(c.parent()),b.events.trigger("video.loaded",[c.parent()])}function m(a,c,d,e,f){b.edit.off(),p("Loading video"),c&&(a=b.helpers.sanitizeURL(a));var g=function(){var c,g;if(e){b.undo.canDo()||e.find("video").hasClass("fr-uploading")||b.undo.saveStep();var h=e.find("video").data("fr-old-src"),i=e.data("fr-replaced");e.data("fr-replaced",!1),b.$wp?(c=e.clone(),c.find("video").removeData("fr-old-src").removeClass("fr-uploading"),c.find("video").off("canplay"),h&&e.find("video").attr("src",h),e.replaceWith(c)):c=e;for(var j=c.find("video").get(0).attributes,k=0;k<j.length;k++){var m=j[k];0===m.nodeName.indexOf("data-")&&c.find("video").removeAttr(m.nodeName)}if(void 0!==d)for(g in d)d.hasOwnProperty(g)&&"link"!=g&&c.find("video").attr("data-"+g,d[g]);c.find("video").on("canplay",l),c.find("video").attr("src",a),b.edit.on(),H(),b.undo.saveStep(),b.$el.blur(),b.events.trigger(i?"video.replaced":"video.inserted",[c,f])}else c=A(a,d,l),H(),b.undo.saveStep(),b.events.trigger("video.inserted",[c,f])};n("Loading video"),g()}function n(a){var c=b.popups.get("video.insert");if(c||(c=f()),c.find(".fr-layer.fr-active").removeClass("fr-active").addClass("fr-pactive"),c.find(".fr-video-progress-bar-layer").addClass("fr-active"),c.find(".fr-buttons").hide(),ra){var d=ra.find("video");b.popups.setContainer("video.insert",b.$sc);var e=d.offset().left+d.width()/2,g=d.offset().top+d.height();b.popups.show("video.insert",e,g,d.outerHeight())}void 0===a&&p(b.language.translate("Uploading"),0)}function o(a){var c=b.popups.get("video.insert");if(c&&(c.find(".fr-layer.fr-pactive").addClass("fr-active").removeClass("fr-pactive"),c.find(".fr-video-progress-bar-layer").removeClass("fr-active"),c.find(".fr-buttons").show(),a||b.$el.find("video.fr-error").length)){if(b.events.focus(),b.$el.find("video.fr-error").length&&(b.$el.find("video.fr-error").parent().remove(),b.undo.saveStep(),b.undo.run(),b.undo.dropRedo()),!b.$wp&&ra){var d=ra;K(!0),b.selection.setAfter(d.find("video").get(0)),b.selection.restore()}b.popups.hide("video.insert")}}function p(a,c){var d=b.popups.get("video.insert");if(d){var e=d.find(".fr-video-progress-bar-layer");e.find("h3").text(a+(c?" "+c+"%":"")),e.removeClass("fr-error"),c?(e.find("div").removeClass("fr-indeterminate"),e.find("div > span").css("width",c+"%")):e.find("div").addClass("fr-indeterminate")}}function q(a){n();var c=b.popups.get("video.insert"),d=c.find(".fr-video-progress-bar-layer");d.addClass("fr-error");var e=d.find("h3");e.text(a),b.events.disableBlur(),e.focus()}function r(c){if(void 0===c){c=(b.popups.get("video.insert").find('.fr-video-by-url-layer input[type="text"]').val()||"").trim()}var d=null;if(/^http/.test(c)||(c="https://"+c),b.helpers.isURL(c))for(var e=0;e<a.FE.VIDEO_PROVIDERS.length;e++){var f=a.FE.VIDEO_PROVIDERS[e];if(f.test_regex.test(c)&&new RegExp(b.opts.videoAllowedProviders.join("|")).test(f.provider)){d=c.replace(f.url_regex,f.url_text),d=f.html.replace(/\{url\}/,d);break}}d?k(d):b.events.trigger("video.linkError",[c])}function s(c){if(void 0===c){c=b.popups.get("video.insert").find(".fr-video-embed-layer textarea").val()||""}0!==c.length&&a.FE.VIDEO_EMBED_REGEX.test(c)?k(c):b.events.trigger("video.codeError",[c])}function t(a){J.call(a.get(0))}function u(a){try{if(!1===b.events.trigger("video.uploaded",[a],!0))return b.edit.on(),!1;var c=JSON.parse(a);return c.link?c:(S(sa,a),!1)}catch(d){return S(ua,a),!1}}function v(c){try{var d=a(c).find("Location").text(),e=a(c).find("Key").text();return!1===b.events.trigger("video.uploadedToS3",[d,e,c],!0)?(b.edit.on(),!1):d}catch(f){return S(ua,c),!1}}function w(a){p("Loading video");var c=this.status,d=this.response,e=this.responseXML,f=this.responseText;try{if(b.opts.videoUploadToS3)if(201==c){var g=v(e);g&&m(g,!1,[],a,d||e)}else S(ua,d||e);else if(c>=200&&c<300){var h=u(f);h&&m(h.link,!1,h,a,d||f)}else S(ta,d||f)}catch(i){S(ua,d||f)}}function x(){S(ua,this.response||this.responseText||this.responseXML)}function y(a){if(a.lengthComputable){var c=a.loaded/a.total*100|0;p(b.language.translate("Uploading"),c)}}function z(){b.edit.on(),o(!0)}function A(c,d,e){var f,g="";if(d&&void 0!==d)for(f in d)d.hasOwnProperty(f)&&"link"!=f&&(g+=" data-"+f+'="'+d[f]+'"');var h=b.opts.videoDefaultWidth;h&&"auto"!=h&&(h+="px");var i=a('<span contenteditable="false" draggable="true" class="fr-video fr-dv'+b.opts.videoDefaultDisplay[0]+("center"!=b.opts.videoDefaultAlign?" fr-fv"+b.opts.videoDefaultAlign[0]:"")+'"><video src="'+c+'" '+g+(h?' style="width: '+h+';" ':"")+" controls>"+b.language.translate("Your browser does not support HTML5 video.")+"</video></span>");i.toggleClass("fr-draggable",b.opts.videoMove),b.edit.on(),b.events.focus(!0),b.selection.restore(),b.undo.saveStep(),b.opts.videoSplitHTML?b.markers.split():b.markers.insert(),b.html.wrap();var j=b.$el.find(".fr-marker");return b.node.isLastSibling(j)&&j.parent().hasClass("fr-deletable")&&j.insertAfter(j.parent()),j.replaceWith(i),b.selection.clear(),i.find("video").get(0).readyState>i.find("video").get(0).HAVE_FUTURE_DATA||b.helpers.isIOS()?e.call(i.find("video").get(0)):i.find("video").on("canplaythrough load",e),i}function B(c){if(!b.core.sameInstance(qa))return!0;c.preventDefault(),c.stopPropagation();var d=c.pageX||(c.originalEvent.touches?c.originalEvent.touches[0].pageX:null),e=c.pageY||(c.originalEvent.touches?c.originalEvent.touches[0].pageY:null);if(!d||!e)return!1;if("mousedown"==c.type){var f=b.$oel.get(0),g=f.ownerDocument,h=g.defaultView||g.parentWindow,i=!1;try{i=h.location!=h.parent.location&&!(h.$&&h.$.FE)}catch(j){}i&&h.frameElement&&(d+=b.helpers.getPX(a(h.frameElement).offset().left)+h.frameElement.clientLeft,e=c.clientY+b.helpers.getPX(a(h.frameElement).offset().top)+h.frameElement.clientTop)}b.undo.canDo()||b.undo.saveStep(),pa=a(this),pa.data("start-x",d),pa.data("start-y",e),oa.show(),b.popups.hideAll(),M()}function C(a){if(!b.core.sameInstance(qa))return!0;if(pa){a.preventDefault();var c=a.pageX||(a.originalEvent.touches?a.originalEvent.touches[0].pageX:null),d=a.pageY||(a.originalEvent.touches?a.originalEvent.touches[0].pageY:null);if(!c||!d)return!1;var e=pa.data("start-x"),f=pa.data("start-y");pa.data("start-x",c),pa.data("start-y",d);var g=c-e,h=d-f,i=ra.find("iframe, embed, video"),j=i.width(),k=i.height();(pa.hasClass("fr-hnw")||pa.hasClass("fr-hsw"))&&(g=0-g),(pa.hasClass("fr-hnw")||pa.hasClass("fr-hne"))&&(h=0-h),i.css("width",j+g),i.css("height",k+h),i.removeAttr("width"),i.removeAttr("height"),I()}}function D(a){if(!b.core.sameInstance(qa))return!0;pa&&ra&&(a&&a.stopPropagation(),pa=null,oa.hide(),I(),e(),b.undo.saveStep())}function E(a){return'<div class="fr-handler fr-h'+a+'"></div>'}function F(a,b,c,d){return a.pageX=b,a.pageY=b,B.call(this,a),a.pageX=a.pageX+c*Math.floor(Math.pow(1.1,d)),a.pageY=a.pageY+c*Math.floor(Math.pow(1.1,d)),C.call(this,a),D.call(this,a),++d}function G(){var c;if(b.shared.$video_resizer?(qa=b.shared.$video_resizer,oa=b.shared.$vid_overlay,b.events.on("destroy",function(){qa.removeClass("fr-active").appendTo(a("body:first"))},!0)):(b.shared.$video_resizer=a('<div class="fr-video-resizer"></div>'),qa=b.shared.$video_resizer,b.events.$on(qa,"mousedown",function(a){a.stopPropagation()},!0),b.opts.videoResize&&(qa.append(E("nw")+E("ne")+E("sw")+E("se")),b.shared.$vid_overlay=a('<div class="fr-video-overlay"></div>'),oa=b.shared.$vid_overlay,c=qa.get(0).ownerDocument,a(c).find("body:first").append(oa))),b.events.on("shared.destroy",function(){qa.html("").removeData().remove(),qa=null,b.opts.videoResize&&(oa.remove(),oa=null)},!0),b.helpers.isMobile()||b.events.$on(a(b.o_win),"resize.video",function(){K(!0)}),b.opts.videoResize){c=qa.get(0).ownerDocument,b.events.$on(qa,b._mousedown,".fr-handler",B),b.events.$on(a(c),b._mousemove,C),b.events.$on(a(c.defaultView||c.parentWindow),b._mouseup,D),b.events.$on(oa,"mouseleave",D);var d=1,e=null,f=0;b.events.on("keydown",function(c){if(ra){var g=-1!=navigator.userAgent.indexOf("Mac OS X")?c.metaKey:c.ctrlKey,h=c.which;(h!==e||c.timeStamp-f>200)&&(d=1),(h==a.FE.KEYCODE.EQUALS||b.browser.mozilla&&h==a.FE.KEYCODE.FF_EQUALS)&&g&&!c.altKey?d=F.call(this,c,1,1,d):(h==a.FE.KEYCODE.HYPHEN||b.browser.mozilla&&h==a.FE.KEYCODE.FF_HYPHEN)&&g&&!c.altKey&&(d=F.call(this,c,2,-1,d)),e=h,f=c.timeStamp}}),b.events.on("keyup",function(){d=1})}}function H(){var c,d=Array.prototype.slice.call(b.el.querySelectorAll("video")),e=[];for(c=0;c<d.length;c++)e.push(d[c].getAttribute("src")),a(d[c]).toggleClass("fr-draggable",b.opts.videoMove),""===d[c].getAttribute("class")&&d[c].removeAttribute("class"),""===d[c].getAttribute("style")&&d[c].removeAttribute("style");if(ya)for(c=0;c<ya.length;c++)e.indexOf(ya[c].getAttribute("src"))<0&&b.events.trigger("video.removed",[a(ya[c])]);ya=d}function I(){qa||G(),(b.$wp||b.$sc).append(qa),qa.data("instance",b);var a=ra.find("iframe, embed, video");qa.css("top",(b.opts.iframe?a.offset().top-1:a.offset().top-b.$wp.offset().top-1)+b.$wp.scrollTop()).css("left",(b.opts.iframe?a.offset().left-1:a.offset().left-b.$wp.offset().left-1)+b.$wp.scrollLeft()).css("width",a.get(0).getBoundingClientRect().width).css("height",a.get(0).getBoundingClientRect().height).addClass("fr-active")}function J(c){if(c&&"touchend"==c.type&&za)return!0;if(c&&b.edit.isDisabled())return c.stopPropagation(),c.preventDefault(),!1;if(b.edit.isDisabled())return!1;for(var d=0;d<a.FE.INSTANCES.length;d++)a.FE.INSTANCES[d]!=b&&a.FE.INSTANCES[d].events.trigger("video.hideResizer");b.toolbar.disable(),b.helpers.isMobile()&&(b.events.disableBlur(),b.$el.blur(),b.events.enableBlur()),ra=a(this),a(this).addClass("fr-active"),b.opts.iframe&&b.size.syncIframe(),ka(),I(),e(),b.selection.clear(),b.button.bulkRefresh(),b.events.trigger("image.hideResizer")}function K(a){ra&&(N()||!0===a)&&(qa.removeClass("fr-active"),b.toolbar.enable(),ra.removeClass("fr-active"),ra=null,M())}function L(){b.shared.vid_exit_flag=!0}function M(){b.shared.vid_exit_flag=!1}function N(){return b.shared.vid_exit_flag}function O(c){var d=c.originalEvent.dataTransfer;if(d&&d.files&&d.files.length){var e=d.files[0];if(e&&e.type&&-1!==e.type.indexOf("video")){if(!b.opts.videoUpload)return c.preventDefault(),c.stopPropagation(),!1;b.markers.remove(),b.markers.insertAtPoint(c.originalEvent),b.$el.find(".fr-marker").replaceWith(a.FE.MARKERS),b.popups.hideAll();var g=b.popups.get("video.insert");return g||(g=f()),b.popups.setContainer("video.insert",b.$sc),b.popups.show("video.insert",c.originalEvent.pageX,c.originalEvent.pageY),n(),b.opts.videoAllowedTypes.indexOf(e.type.replace(/video\//g,""))>=0?P(d.files):S(wa),c.preventDefault(),c.stopPropagation(),!1}}}function P(a){
if(void 0!==a&&a.length>0){if(!1===b.events.trigger("video.beforeUpload",[a]))return!1;var c=a[0];if(c.size>b.opts.videoMaxSize)return S(va),!1;if(b.opts.videoAllowedTypes.indexOf(c.type.replace(/video\//g,""))<0)return S(wa),!1;var d;if(b.drag_support.formdata&&(d=b.drag_support.formdata?new FormData:null),d){var e;if(!1!==b.opts.videoUploadToS3){d.append("key",b.opts.videoUploadToS3.keyStart+(new Date).getTime()+"-"+(c.name||"untitled")),d.append("success_action_status","201"),d.append("X-Requested-With","xhr"),d.append("Content-Type",c.type);for(e in b.opts.videoUploadToS3.params)b.opts.videoUploadToS3.params.hasOwnProperty(e)&&d.append(e,b.opts.videoUploadToS3.params[e])}for(e in b.opts.videoUploadParams)b.opts.videoUploadParams.hasOwnProperty(e)&&d.append(e,b.opts.videoUploadParams[e]);d.append(b.opts.videoUploadParam,c);var f=b.opts.videoUploadURL;b.opts.videoUploadToS3&&(f=b.opts.videoUploadToS3.uploadURL?b.opts.videoUploadToS3.uploadURL:"https://"+b.opts.videoUploadToS3.region+".amazonaws.com/"+b.opts.videoUploadToS3.bucket);var g=b.core.getXHR(f,b.opts.videoUploadMethod);g.onload=function(){w.call(g,ra)},g.onerror=x,g.upload.onprogress=y,g.onabort=z,n(),b.events.disableBlur(),b.edit.off(),b.events.enableBlur();var h=b.popups.get("video.insert");h&&h.off("abortUpload").on("abortUpload",function(){4!=g.readyState&&g.abort()}),g.send(d)}}}function Q(c){b.events.$on(c,"dragover dragenter",".fr-video-upload-layer",function(){return a(this).addClass("fr-drop"),!1},!0),b.events.$on(c,"dragleave dragend",".fr-video-upload-layer",function(){return a(this).removeClass("fr-drop"),!1},!0),b.events.$on(c,"drop",".fr-video-upload-layer",function(d){d.preventDefault(),d.stopPropagation(),a(this).removeClass("fr-drop");var e=d.originalEvent.dataTransfer;if(e&&e.files){var f=c.data("instance")||b;f.events.disableBlur(),f.video.upload(e.files),f.events.enableBlur()}},!0),b.helpers.isIOS()&&b.events.$on(c,"touchstart",'.fr-video-upload-layer input[type="file"]',function(){a(this).trigger("click")},!0),b.events.$on(c,"change",'.fr-video-upload-layer input[type="file"]',function(){if(this.files){var d=c.data("instance")||b;d.events.disableBlur(),c.find("input:focus").blur(),d.events.enableBlur(),d.video.upload(this.files)}a(this).val("")},!0)}function R(){b.events.on("drop",O,!0),b.events.on("mousedown window.mousedown",L),b.events.on("window.touchmove",M),b.events.on("mouseup window.mouseup",K),b.events.on("commands.mousedown",function(a){a.parents(".fr-toolbar").length>0&&K()}),b.events.on("video.hideResizer commands.undo commands.redo element.dropped",function(){K(!0)})}function S(a,c){b.edit.on(),ra&&ra.find("video").addClass("fr-error"),q(b.language.translate("Something went wrong. Please try again.")),b.events.trigger("video.error",[{code:a,message:xa[a]},c])}function T(){var a="";if(b.opts.videoEditButtons.length>0){a+='<div class="fr-buttons">',a+=b.button.buildList(b.opts.videoEditButtons),a+="</div>";var c={buttons:a},d=b.popups.create("video.edit",c);return b.events.$on(b.$wp,"scroll.video-edit",function(){ra&&b.popups.isVisible("video.edit")&&(b.events.disableBlur(),t(ra))}),d}return!1}function U(){if(ra){var a=b.popups.get("video.size"),c=ra.find("iframe, embed, video");a.find('input[name="width"]').val(c.get(0).style.width||c.attr("width")).trigger("change"),a.find('input[name="height"]').val(c.get(0).style.height||c.attr("height")).trigger("change")}}function V(){var a=b.popups.get("video.size");a||(a=W()),o(),b.popups.refresh("video.size"),b.popups.setContainer("video.size",b.$sc);var c=ra.find("iframe, embed, video"),d=c.offset().left+c.width()/2,e=c.offset().top+c.height();b.popups.show("video.size",d,e,c.height())}function W(a){if(a)return b.popups.onRefresh("video.size",U),!0;var c="";c='<div class="fr-buttons">'+b.button.buildList(b.opts.videoSizeButtons)+"</div>";var d="";d='<div class="fr-video-size-layer fr-layer fr-active" id="fr-video-size-layer-'+b.id+'"><div class="fr-video-group"><div class="fr-input-line"><input id="fr-video-size-layer-width-'+b.id+'" type="text" name="width" placeholder="'+b.language.translate("Width")+'" tabIndex="1"></div><div class="fr-input-line"><input id="fr-video-size-layer-height-'+b.id+'" type="text" name="height" placeholder="'+b.language.translate("Height")+'" tabIndex="1"></div></div><div class="fr-action-buttons"><button type="button" class="fr-command fr-submit" data-cmd="videoSetSize" tabIndex="2" role="button">'+b.language.translate("Update")+"</button></div></div>";var e={buttons:c,size_layer:d},f=b.popups.create("video.size",e);return b.events.$on(b.$wp,"scroll",function(){ra&&b.popups.isVisible("video.size")&&(b.events.disableBlur(),t(ra))}),f}function X(a){if(void 0===a&&(a=ra),a){if(a.hasClass("fr-fvl"))return"left";if(a.hasClass("fr-fvr"))return"right";if(a.hasClass("fr-dvb")||a.hasClass("fr-dvi"))return"center";if("block"==a.css("display")){if("left"==a.css("text-algin"))return"left";if("right"==a.css("text-align"))return"right"}else{if("left"==a.css("float"))return"left";if("right"==a.css("float"))return"right"}}return"center"}function Y(a){ra.removeClass("fr-fvr fr-fvl"),!b.opts.htmlUntouched&&b.opts.useClasses?"left"==a?ra.addClass("fr-fvl"):"right"==a&&ra.addClass("fr-fvr"):fa(ra,_(),a),ka(),I(),e(),b.selection.clear()}function Z(a){if(!ra)return!1;a.find("> *:first").replaceWith(b.icon.create("video-align-"+X()))}function $(a,b){ra&&b.find('.fr-command[data-param1="'+X()+'"]').addClass("fr-active").attr("aria-selected",!0)}function _(a){void 0===a&&(a=ra);var b=a.css("float");return a.css("float","none"),"block"==a.css("display")?(a.css("float",""),a.css("float")!=b&&a.css("float",b),"block"):(a.css("float",""),a.css("float")!=b&&a.css("float",b),"inline")}function aa(a){ra.removeClass("fr-dvi fr-dvb"),!b.opts.htmlUntouched&&b.opts.useClasses?"inline"==a?ra.addClass("fr-dvi"):"block"==a&&ra.addClass("fr-dvb"):fa(ra,a,X()),ka(),I(),e(),b.selection.clear()}function ba(a,b){ra&&b.find('.fr-command[data-param1="'+_()+'"]').addClass("fr-active").attr("aria-selected",!0)}function ca(){var a=b.popups.get("video.insert");a||(a=f()),b.popups.isVisible("video.insert")||(o(),b.popups.refresh("video.insert"),b.popups.setContainer("video.insert",b.$sc));var c=ra.offset().left+ra.width()/2,d=ra.offset().top+ra.height();b.popups.show("video.insert",c,d,ra.outerHeight())}function da(){if(ra&&!1!==b.events.trigger("video.beforeRemove",[ra])){var a=ra;b.popups.hideAll(),K(!0),b.selection.setBefore(a.get(0))||b.selection.setAfter(a.get(0)),a.remove(),b.selection.restore(),b.html.fillEmptyBlocks(),b.events.trigger("video.removed",[a])}}function ea(){o()}function fa(a,c,d){!b.opts.htmlUntouched&&b.opts.useClasses?(a.removeClass("fr-fvl fr-fvr fr-dvb fr-dvi"),a.addClass("fr-fv"+d[0]+" fr-dv"+c[0])):"inline"==c?(a.css({display:"inline-block"}),"center"==d?a.css({float:"none"}):"left"==d?a.css({float:"left"}):a.css({float:"right"})):(a.css({display:"block",clear:"both"}),"left"==d?a.css({textAlign:"left"}):"right"==d?a.css({textAlign:"right"}):a.css({textAlign:"center"}))}function ga(a){a.hasClass("fr-dvi")||a.hasClass("fr-dvb")||(a.addClass("fr-fv"+X(a)[0]),a.addClass("fr-dv"+_(a)[0]))}function ha(a){fa(a,a.hasClass("fr-dvb")?"block":a.hasClass("fr-dvi")?"inline":null,a.hasClass("fr-fvl")?"left":a.hasClass("fr-fvr")?"right":X(a)),a.removeClass("fr-dvb fr-dvi fr-fvr fr-fvl")}function ia(){b.$el.find("video").filter(function(){return 0===a(this).parents("span.fr-video").length}).wrap('<span class="fr-video" contenteditable="false"></span>'),b.$el.find("embed, iframe").filter(function(){if(b.browser.safari&&this.getAttribute("src")&&this.setAttribute("src",this.src),a(this).parents("span.fr-video").length>0)return!1;for(var c=a(this).attr("src"),d=0;d<a.FE.VIDEO_PROVIDERS.length;d++){var e=a.FE.VIDEO_PROVIDERS[d];if(e.test_regex.test(c)&&new RegExp(b.opts.videoAllowedProviders.join("|")).test(e.provider))return!0}return!1}).map(function(){return 0===a(this).parents("object").length?this:a(this).parents("object").get(0)}).wrap('<span class="fr-video" contenteditable="false"></span>');for(var c=b.$el.find("span.fr-video, video"),d=0;d<c.length;d++){var e=a(c[d]);!b.opts.htmlUntouched&&b.opts.useClasses?(ga(e),b.opts.videoTextNear||e.removeClass("fr-dvi").addClass("fr-dvb")):b.opts.htmlUntouched||b.opts.useClasses||ha(e)}c.toggleClass("fr-draggable",b.opts.videoMove)}function ja(){R(),b.helpers.isMobile()&&(b.events.$on(b.$el,"touchstart","span.fr-video",function(){za=!1}),b.events.$on(b.$el,"touchmove",function(){za=!0})),b.events.on("html.set",ia),ia(),b.events.$on(b.$el,"mousedown","span.fr-video",function(a){a.stopPropagation()}),b.events.$on(b.$el,"click touchend","span.fr-video",J),b.events.on("keydown",function(c){var d=c.which;return!ra||d!=a.FE.KEYCODE.BACKSPACE&&d!=a.FE.KEYCODE.DELETE?ra&&d==a.FE.KEYCODE.ESC?(K(!0),c.preventDefault(),!1):ra&&d!=a.FE.KEYCODE.F10&&!b.keys.isBrowserAction(c)?(c.preventDefault(),!1):void 0:(c.preventDefault(),da(),b.undo.saveStep(),!1)},!0),b.events.on("toolbar.esc",function(){if(ra)return b.events.disableBlur(),b.events.focus(),!1},!0),b.events.on("toolbar.focusEditor",function(){if(ra)return!1},!0),b.events.on("keydown",function(){b.$el.find("span.fr-video:empty").remove()}),f(!0),W(!0)}function ka(){if(ra){b.selection.clear();var a=b.doc.createRange();a.selectNode(ra.get(0));b.selection.get().addRange(a)}}function la(){ra?(b.events.disableBlur(),ra.trigger("click")):(b.events.disableBlur(),b.selection.restore(),b.events.enableBlur(),b.popups.hide("video.insert"),b.toolbar.showInline())}function ma(a,c){if(ra){var d=b.popups.get("video.size"),e=ra.find("iframe, embed, video");e.css("width",a||d.find('input[name="width"]').val()),e.css("height",c||d.find('input[name="height"]').val()),e.get(0).style.width&&e.removeAttr("width"),e.get(0).style.height&&e.removeAttr("height"),d.find("input:focus").blur(),setTimeout(function(){ra.trigger("click")},b.helpers.isAndroid()?50:0)}}function na(){return ra}var oa,pa,qa,ra,sa=2,ta=3,ua=4,va=5,wa=6,xa={};xa[1]="Video cannot be loaded from the passed link.",xa[sa]="No link in upload response.",xa[ta]="Error during file upload.",xa[ua]="Parsing response failed.",xa[va]="File is too large.",xa[wa]="Video file type is invalid.",xa[7]="Files can be uploaded only to same domain in IE 8 and IE 9.";var ya,za;return b.shared.vid_exit_flag=!1,{_init:ja,showInsertPopup:d,showLayer:g,refreshByURLButton:h,refreshEmbedButton:i,refreshUploadButton:j,upload:P,insertByURL:r,insertEmbed:s,insert:k,align:Y,refreshAlign:Z,refreshAlignOnShow:$,display:aa,refreshDisplayOnShow:ba,remove:da,hideProgressBar:o,showSizePopup:V,replace:ca,back:la,setSize:ma,get:na}},a.FE.RegisterCommand("insertVideo",{title:"Insert Video",undo:!1,focus:!0,refreshAfterCallback:!1,popup:!0,callback:function(){this.popups.isVisible("video.insert")?(this.$el.find(".fr-marker").length&&(this.events.disableBlur(),this.selection.restore()),this.popups.hide("video.insert")):this.video.showInsertPopup()},plugin:"video"}),a.FE.DefineIcon("insertVideo",{NAME:"video-camera"}),a.FE.DefineIcon("videoByURL",{NAME:"link"}),a.FE.RegisterCommand("videoByURL",{title:"By URL",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-by-url")},refresh:function(a){this.video.refreshByURLButton(a)}}),a.FE.DefineIcon("videoEmbed",{NAME:"code"}),a.FE.RegisterCommand("videoEmbed",{title:"Embedded Code",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-embed")},refresh:function(a){this.video.refreshEmbedButton(a)}}),a.FE.DefineIcon("videoUpload",{NAME:"upload"}),a.FE.RegisterCommand("videoUpload",{title:"Upload Video",undo:!1,focus:!1,toggle:!0,callback:function(){this.video.showLayer("video-upload")},refresh:function(a){this.video.refreshUploadButton(a)}}),a.FE.RegisterCommand("videoInsertByURL",{undo:!0,focus:!0,callback:function(){this.video.insertByURL()}}),a.FE.RegisterCommand("videoInsertEmbed",{undo:!0,focus:!0,callback:function(){this.video.insertEmbed()}}),a.FE.DefineIcon("videoDisplay",{NAME:"star"}),a.FE.RegisterCommand("videoDisplay",{title:"Display",type:"dropdown",options:{inline:"Inline",block:"Break Text"},callback:function(a,b){this.video.display(b)},refresh:function(a){this.opts.videoTextNear||a.addClass("fr-hidden")},refreshOnShow:function(a,b){this.video.refreshDisplayOnShow(a,b)}}),a.FE.DefineIcon("video-align",{NAME:"align-left"}),a.FE.DefineIcon("video-align-left",{NAME:"align-left"}),a.FE.DefineIcon("video-align-right",{NAME:"align-right"}),a.FE.DefineIcon("video-align-center",{NAME:"align-justify"}),a.FE.DefineIcon("videoAlign",{NAME:"align-center"}),a.FE.RegisterCommand("videoAlign",{type:"dropdown",title:"Align",options:{left:"Align Left",center:"None",right:"Align Right"},html:function(){var b='<ul class="fr-dropdown-list" role="presentation">',c=a.FE.COMMANDS.videoAlign.options;for(var d in c)c.hasOwnProperty(d)&&(b+='<li role="presentation"><a class="fr-command fr-title" tabIndex="-1" role="option" data-cmd="videoAlign" data-param1="'+d+'" title="'+this.language.translate(c[d])+'">'+this.icon.create("video-align-"+d)+'<span class="fr-sr-only">'+this.language.translate(c[d])+"</span></a></li>");return b+="</ul>"},callback:function(a,b){this.video.align(b)},refresh:function(a){this.video.refreshAlign(a)},refreshOnShow:function(a,b){this.video.refreshAlignOnShow(a,b)}}),a.FE.DefineIcon("videoReplace",{NAME:"exchange"}),a.FE.RegisterCommand("videoReplace",{title:"Replace",undo:!1,focus:!1,popup:!0,refreshAfterCallback:!1,callback:function(){this.video.replace()}}),a.FE.DefineIcon("videoRemove",{NAME:"trash"}),a.FE.RegisterCommand("videoRemove",{title:"Remove",callback:function(){this.video.remove()}}),a.FE.DefineIcon("videoSize",{NAME:"arrows-alt"}),a.FE.RegisterCommand("videoSize",{undo:!1,focus:!1,popup:!0,title:"Change Size",callback:function(){this.video.showSizePopup()}}),a.FE.DefineIcon("videoBack",{NAME:"arrow-left"}),a.FE.RegisterCommand("videoBack",{title:"Back",undo:!1,focus:!1,back:!0,callback:function(){this.video.back()},refresh:function(a){this.video.get()||this.opts.toolbarInline?(a.removeClass("fr-hidden"),a.next(".fr-separator").removeClass("fr-hidden")):(a.addClass("fr-hidden"),a.next(".fr-separator").addClass("fr-hidden"))}}),a.FE.RegisterCommand("videoDismissError",{title:"OK",undo:!1,callback:function(){this.video.hideProgressBar(!0)}}),a.FE.RegisterCommand("videoSetSize",{undo:!0,focus:!1,title:"Update",refreshAfterCallback:!1,callback:function(){this.video.setSize()}}),a.extend(a.FE.DEFAULTS,{wordDeniedTags:[],wordDeniedAttrs:[],wordAllowedStyleProps:["font-family","font-size","background","color","width","text-align","vertical-align","background-color","padding","margin","height","margin-top","margin-left","margin-right","margin-bottom","text-decoration","font-weight","font-style"],wordPasteModal:!0}),a.FE.PLUGINS.wordPaste=function(b){function c(){b.events.on("paste.wordPaste",function(a){return C=a,b.opts.wordPasteModal?e():g(!0),!1})}function d(){var a='<div class="fr-word-paste-modal" style="padding: 20px 20px 10px 20px;">';return a+='<p style="text-align: left;">'+b.language.translate("The pasted content is coming from a Microsoft Word document. Do you want to keep the format or clean it up?")+"</p>",a+='<div style="text-align: right; margin-top: 50px;"><button class="fr-remove-word fr-command">'+b.language.translate("Clean")+'</button> <button class="fr-keep-word fr-command">'+b.language.translate("Keep")+"</button></div>",a+="</div>"}function e(){if(!B){var c='<h4><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.95 73.23" style="height: 25px; vertical-align: text-bottom; margin-right: 5px; display: inline-block"><defs><style>.a{fill:#2a5699;}.b{fill:#fff;}</style></defs><path class="a" d="M615.15,827.22h5.09V834c9.11.05,18.21-.09,27.32.05a2.93,2.93,0,0,1,3.29,3.25c.14,16.77,0,33.56.09,50.33-.09,1.72.17,3.63-.83,5.15-1.24.89-2.85.78-4.3.84-8.52,0-17,0-25.56,0v6.81h-5.32c-13-2.37-26-4.54-38.94-6.81q0-29.8,0-59.59c13.05-2.28,26.11-4.5,39.17-6.83Z" transform="translate(-575.97 -827.22)"/><path class="b" d="M620.24,836.59h28.1v54.49h-28.1v-6.81h22.14v-3.41H620.24v-4.26h22.14V873.2H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24v-4.26h22.14v-3.41H620.24V846h22.14v-3.41H620.24Zm-26.67,15c1.62-.09,3.24-.16,4.85-.25,1.13,5.75,2.29,11.49,3.52,17.21,1-5.91,2-11.8,3.06-17.7,1.7-.06,3.41-.15,5.1-.26-1.92,8.25-3.61,16.57-5.71,24.77-1.42.74-3.55,0-5.24.09-1.13-5.64-2.45-11.24-3.47-16.9-1,5.5-2.29,10.95-3.43,16.42q-2.45-.13-4.92-.3c-1.41-7.49-3.07-14.93-4.39-22.44l4.38-.18c.88,5.42,1.87,10.82,2.64,16.25,1.2-5.57,2.43-11.14,3.62-16.71Z" transform="translate(-575.97 -827.22)"/></svg> '+b.language.translate("Word Paste Detected")+"</h4>",e=d(),f=b.modals.create(D,c,e),g=f.$body;B=f.$modal,f.$modal.addClass("fr-middle"),b.events.bindClick(g,"button.fr-remove-word",function(){(B.data("instance")||b).wordPaste.clean()}),b.events.bindClick(g,"button.fr-keep-word",function(){(B.data("instance")||b).wordPaste.clean(!0)}),b.events.$on(a(b.o_win),"resize",function(){b.modals.resize(D)})}b.modals.show(D),b.modals.resize(D)}function f(){b.modals.hide(D)}function g(a){var c=b.opts.wordAllowedStyleProps;a||(b.opts.wordAllowedStyleProps=[]),0===C.indexOf("<colgroup>")&&(C="<table>"+C+"</table>"),C=A(C,b.paste.getRtfClipboard());var d=b.doc.createElement("DIV");d.innerHTML=C,b.html.cleanBlankSpaces(d),C=d.innerHTML,C=b.paste.removeEmptyTags(C),C=C.replace(/\u200b/g,""),f(),b.paste.clean(C,!0,!0),b.opts.wordAllowedStyleProps=c}function h(a){a.parentNode&&a.parentNode.removeChild(a)}function i(a,b){if(b(a))for(var c=a.firstChild;c;){var d=c,e=c.previousSibling;c=c.nextSibling,i(d,b),d.previousSibling||d.nextSibling||d.parentNode||!c||e==c.previousSibling||!c.parentNode?d.previousSibling||d.nextSibling||d.parentNode||!c||c.previousSibling||c.nextSibling||c.parentNode||(e?c=e.nextSibling?e.nextSibling.nextSibling:null:a.firstChild&&(c=a.firstChild.nextSibling)):c=e?e.nextSibling:a.firstChild}}function j(a){if(!a.getAttribute("style")||!/mso-list:[\s]*l/gi.test(a.getAttribute("style").replace(/\n/gi,"")))return!1;try{if(!a.querySelector('[style="mso-list:Ignore"]'))return!1}catch(b){return!1}return!0}function k(a){return a.getAttribute("style").replace(/\n/gi,"").replace(/.*level([0-9]+?).*/gi,"$1")}function l(a,b){var c=a.cloneNode(!0);if(c.firstElementChild&&"A"==c.firstElementChild.tagName&&(c=c.firstElementChild),-1!=["H1","H2","H3","H4","H5","H6"].indexOf(a.tagName)){var d=document.createElement(a.tagName.toLowerCase());d.setAttribute("style",a.getAttribute("style")),d.innerHTML=c.innerHTML,c.innerHTML=d.outerHTML}i(c,function(a){return a.nodeType==Node.ELEMENT_NODE&&("mso-list:Ignore"==a.getAttribute("style")&&a.parentNode.removeChild(a),x(a,b)),!0});var e=c.innerHTML;return e=e.replace(/<!--[\s\S]*?-->/gi,"")}function m(a,b){var c=/[0-9a-zA-Z]./gi,d=!1;a.firstElementChild&&a.firstElementChild.firstElementChild&&a.firstElementChild.firstElementChild.firstChild&&!(d=d||c.test(a.firstElementChild.firstElementChild.firstChild.data||""))&&a.firstElementChild.firstElementChild.firstElementChild&&a.firstElementChild.firstElementChild.firstElementChild.firstChild&&(d=d||c.test(a.firstElementChild.firstElementChild.firstElementChild.firstChild.data||""));var e=d?"ol":"ul",f=k(a),g="<"+e+"><li>"+l(a,b),i=a.nextElementSibling,n=a.parentNode;for(h(a),a=null;i&&j(i);){var o=i.previousElementSibling,p=k(i);if(p>f)g+=m(i,b).outerHTML;else{if(p<f)break;g+="</li><li>"+l(i,b)}if(f=p,i.previousElementSibling||i.nextElementSibling||i.parentNode){var q=i;i=i.nextElementSibling,h(q),q=null}else i=o?o.nextElementSibling:n.firstElementChild}g+="</li></"+e+">";var r=document.createElement("div");return r.innerHTML=g,r.firstElementChild}function n(a,b){for(var c=document.createElement(b),d=0;d<a.attributes.length;d++){var e=a.attributes[d].name;c.setAttribute(e,a.getAttribute(e))}return c.innerHTML=a.innerHTML,a.parentNode.replaceChild(c,a),c}function o(c,d){b.node.clearAttributes(c);for(var e=c.firstElementChild,f=0,g=!1,i=null;e;){e.firstElementChild&&-1!=e.firstElementChild.tagName.indexOf("W:")&&(e.innerHTML=e.firstElementChild.innerHTML),i=e.getAttribute("width"),i||g||(g=!0),f+=parseInt(i,10),(!e.firstChild||e.firstChild&&e.firstChild.data==a.FE.UNICODE_NBSP)&&(e.firstChild&&h(e.firstChild),e.innerHTML="<br>");for(var k=e.firstElementChild,l=1==e.children.length;k;)"P"!=k.tagName||j(k)||l&&p(k),k=k.nextElementSibling;if(d){var m=e.getAttribute("class");if(m){m=q(m);var n=m.match(/xl[0-9]+/gi);if(n){var o=n[0],s="."+o;d[s]&&r(e,d[s])}}d.td&&r(e,d.td)}var t=e.getAttribute("style");t&&(t=q(t))&&";"!=t.slice(-1)&&(t+=";");var u=e.getAttribute("valign");if(!u&&t){var v=t.match(/vertical-align:.+?[; "]{1,1}/gi);v&&(u=v[v.length-1].replace(/vertical-align:(.+?)[; "]{1,1}/gi,"$1"))}var w=null;if(t){var x=t.match(/text-align:.+?[; "]{1,1}/gi);x&&(w=x[x.length-1].replace(/text-align:(.+?)[; "]{1,1}/gi,"$1")),"general"==w&&(w=null)}var y=null;if(t){var z=t.match(/background:.+?[; "]{1,1}/gi);z&&(y=z[z.length-1].replace(/background:(.+?)[; "]{1,1}/gi,"$1"))}var A=e.getAttribute("colspan"),B=e.getAttribute("rowspan");A&&e.setAttribute("colspan",A),B&&e.setAttribute("rowspan",B),u&&(e.style["vertical-align"]=u),w&&(e.style["text-align"]=w),y&&(e.style["background-color"]=y),i&&e.setAttribute("width",i),e=e.nextElementSibling}for(e=c.firstElementChild;e;)i=e.getAttribute("width"),g?e.removeAttribute("width"):e.setAttribute("width",100*parseInt(i,10)/f+"%"),e=e.nextElementSibling}function p(a){var b=a.parentNode,c=a.getAttribute("align");c&&(b&&"TD"==b.tagName?(b.setAttribute("style",b.getAttribute("style")+"text-align:"+c+";"),a.removeAttribute("align")):(a.style["text-align"]=c,a.removeAttribute("align")))}function q(a){return a.replace(/\n|\r|\n\r|&quot;/g,"")}function r(a,b,c){if(b){var d=a.getAttribute("style");d&&";"!=d.slice(-1)&&(d+=";"),b&&";"!=b.slice(-1)&&(b+=";"),b=b.replace(/\n/gi,"");var e=null;e=c?(d||"")+b:b+(d||""),a.setAttribute("style",e)}}function s(a){var b=a.getAttribute("style");if(b){b=q(b),b&&";"!=b.slice(-1)&&(b+=";");var c=b.match(/(^|\S+?):.+?;{1,1}/gi);if(c){for(var d={},e=0;e<c.length;e++){var f=c[e],g=f.split(":");2==g.length&&("text-align"==g[0]&&"SPAN"==a.tagName||(d[g[0]]=g[1]))}var h="";for(var i in d)if(d.hasOwnProperty(i)){if("font-size"==i&&"pt;"==d[i].slice(-3)){var j=null;try{j=parseFloat(d[i].slice(0,-3),10)}catch(k){}j&&(j=Math.round(1.33*j),d[i]=j+"px;")}h+=i+":"+d[i]}h&&a.setAttribute("style",h)}}}function t(a){for(var b=a.match(/[0-9a-f]{2}/gi),c=[],d=0;d<b.length;d++)c.push(String.fromCharCode(parseInt(b[d],16)));var e=c.join("");return btoa(e)}function u(a,b,c){for(var d=a.split(c),e=1;e<d.length;e++){var f=d[e];if(f=f.split("shplid"),f.length>1){f=f[1];for(var g="",h=0;h<f.length&&"\\"!=f[h]&&"{"!=f[h]&&" "!=f[h]&&"\r"!=f[h]&&"\n"!=f[h];)g+=f[h],h++;var i=f.split("bliptag");if(i&&i.length<2)continue;var j=null;if(-1!=i[0].indexOf("pngblip")?j="image/png":-1!=i[0].indexOf("jpegblip")&&(j="image/jpeg"),!j)continue;var k=i[1].split("}");if(k&&k.length<2)continue;var l;if(k.length>2&&-1!=k[0].indexOf("blipuid"))l=k[1].split(" ");else{if((l=k[0].split(" "))&&l.length<2)continue;l.shift()}var m=l.join("");E[b+g]={image_hex:m,image_type:j}}}}function v(a){E={},u(a,"i","\\shppict"),u(a,"s","\\shp{")}function w(b,c){if(c){var d;if("IMG"==b.tagName){var e=b.getAttribute("src");if(!e||-1==e.indexOf("file://"))return;d=F[b.getAttribute("v:shapes")]}else d=b.parentNode.getAttribute("o:spid");if(b.removeAttribute("height"),d){E||v(c);var f=E[d.substring(7)];if(f){var g=t(f.image_hex),h="data:"+f.image_type+";base64,"+g;"IMG"===b.tagName?(b.src=h,b.setAttribute("data-fr-image-pasted",!0)):a(b.parentNode).before('<img data-fr-image-pasted="true" src="'+h+'" style="'+b.parentNode.getAttribute("style")+'">').remove()}}}}function x(a,b){var c=a.tagName,d=c.toLowerCase();if(a.firstElementChild&&("I"==a.firstElementChild.tagName?n(a.firstElementChild,"em"):"B"==a.firstElementChild.tagName&&n(a.firstElementChild,"strong")),-1!=["SCRIPT","APPLET","EMBED","NOFRAMES","NOSCRIPT"].indexOf(c))return h(a),!1;var e=-1,f=["META","LINK","XML","ST1:","O:","W:","FONT"];for(e=0;e<f.length;e++)if(-1!=c.indexOf(f[e]))return a.innerHTML?(a.outerHTML=a.innerHTML,h(a),!1):(h(a),!1);if("TD"!=c){var g=a.getAttribute("class");if(b&&g){g=q(g);var i=g.split(" ");for(e=0;e<i.length;e++){var j=i[e],k=[],l="."+j;k.push(l),l=d+l,k.push(l);for(var m=0;m<k.length;m++)b[k[m]]&&r(a,b[k[m]])}a.removeAttribute("class")}b&&b[d]&&r(a,b[d])}if(-1!=["P","H1","H2","H3","H4","H5","H6","PRE"].indexOf(c)){var s=a.getAttribute("class");if(s&&(b&&b[c.toLowerCase()+"."+s]&&r(a,b[c.toLowerCase()+"."+s]),-1!=s.toLowerCase().indexOf("mso"))){var t=q(s);t=t.replace(/[0-9a-z-_]*mso[0-9a-z-_]*/gi,""),t?a.setAttribute("class",t):a.removeAttribute("class")}var u=a.getAttribute("style");if(u){var v=u.match(/text-align:.+?[; "]{1,1}/gi);v&&v[v.length-1].replace(/(text-align:.+?[; "]{1,1})/gi,"$1")}p(a)}if("TR"==c&&o(a,b),"A"==c&&!a.attributes.getNamedItem("href")&&a.innerHTML&&(a.outerHTML=a.innerHTML),"TD"!=c&&"TH"!=c||a.innerHTML||(a.innerHTML="<br>"),"TABLE"==c&&(a.style.width="100%"),a.getAttribute("lang")&&a.removeAttribute("lang"),a.getAttribute("style")&&-1!=a.getAttribute("style").toLowerCase().indexOf("mso")){var w=q(a.getAttribute("style"));w=w.replace(/[0-9a-z-_]*mso[0-9a-z-_]*:.+?(;{1,1}|$)/gi,""),w?a.setAttribute("style",w):a.removeAttribute("style")}return!0}function y(a){var b={},c=a.getElementsByTagName("style");if(c.length){var d=c[0],e=d.innerHTML.match(/[\S ]+\s+{[\s\S]+?}/gi);if(e)for(var f=0;f<e.length;f++){var g=e[f],h=g.replace(/([\S ]+\s+){[\s\S]+?}/gi,"$1"),i=g.replace(/[\S ]+\s+{([\s\S]+?)}/gi,"$1");h=h.replace(/^[\s]|[\s]$/gm,""),i=i.replace(/^[\s]|[\s]$/gm,""),h=h.replace(/\n|\r|\n\r/g,""),i=i.replace(/\n|\r|\n\r/g,"");for(var j=h.split(", "),k=0;k<j.length;k++)b[j[k]]=i}}return b}function z(a){for(var b=a.split("v:shape"),c=1;c<b.length;c++){var d=b[c],e=d.split(' id="')[1];if(e&&e.length>1){e=e.split('"')[0];var f=d.split(' o:spid="')[1];f&&f.length>1&&(f=f.split('"')[0],F[e]=f)}}}function A(c,d){c=c.replace(/[.\s\S\w\W<>]*(<html[^>]*>[.\s\S\w\W<>]*<\/html>)[.\s\S\w\W<>]*/i,"$1"),z(c);var e=new DOMParser,f=e.parseFromString(c,"text/html"),g=f.head,k=f.body,l=y(g);i(k,function(b){if(b.nodeType==Node.TEXT_NODE&&/\n|\u00a0/.test(b.data)){if(!/\S| /.test(b.data))return b.data==a.FE.UNICODE_NBSP?(b.data="\u200b",!0):(h(b),!1);b.data=b.data.replace(/\n/gi," ")}return!0}),i(k,function(a){return a.nodeType!=Node.ELEMENT_NODE||"V:IMAGEDATA"!=a.tagName&&"IMG"!=a.tagName||w(a,d),!0}),i(k,function(a){if(a.nodeType==Node.TEXT_NODE)return a.data=a.data.replace(/<br>(\n|\r)/gi,"<br>"),!1;if(a.nodeType==Node.ELEMENT_NODE){if(j(a)){var b=a.parentNode,c=a.previousSibling,d=m(a,l),e=null;return e=c?c.nextSibling:b.firstChild,e?b.insertBefore(d,e):b.appendChild(d),!1}return x(a,l)}return a.nodeType!=Node.COMMENT_NODE||(h(a),!1)}),i(k,function(a){if(a.nodeType==Node.ELEMENT_NODE){var b=a.tagName;if(!a.innerHTML&&-1==["BR","IMG"].indexOf(b)){for(var c=a.parentNode;c&&(h(a),a=c,!a.innerHTML);)c=a.parentNode;return!1}s(a)}return!0});var n=k.outerHTML,o=b.opts.htmlAllowedStyleProps;return b.opts.htmlAllowedStyleProps=b.opts.wordAllowedStyleProps,n=b.clean.html(n,b.opts.wordDeniedTags,b.opts.wordDeniedAttrs,!1),b.opts.htmlAllowedStyleProps=o,n}var B,C,D="word_paste",E=null,F={};return{_init:c,clean:g}}});

/***/ }),

/***/ "sqLM":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        ss : '%d segundo',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),

/***/ "ssxj":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'sekundy' : 'sekund');
            } else {
                return result + 'sekundami';
            }
            break;
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),

/***/ "svD2":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        ss: ['sekund', 'sekunda', 'sekundi'],
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        ss     : translator.translate,
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),

/***/ "t8rQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("7e4z"),
    baseKeysIn = __webpack_require__("G0Wc"),
    isArrayLike = __webpack_require__("bGc4");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "tHks":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "tO4o":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("yCNF");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "tUzZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SubjectSubscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Subject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnonymousSubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscriber__ = /*@__PURE__*/__webpack_require__("p1Bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subscription__ = /*@__PURE__*/__webpack_require__("HC03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__ = /*@__PURE__*/__webpack_require__("LHMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SubjectSubscription__ = /*@__PURE__*/__webpack_require__("7HNm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_symbol_rxSubscriber__ = /*@__PURE__*/__webpack_require__("Egod");
/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */







/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(__WEBPACK_IMPORTED_MODULE_2__Subscriber__["a" /* Subscriber */]));

/**
 * @class Subject<T>
 */
var Subject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[__WEBPACK_IMPORTED_MODULE_6__internal_symbol_rxSubscriber__["a" /* rxSubscriber */]] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_4__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new __WEBPACK_IMPORTED_MODULE_5__SubjectSubscription__["a" /* SubjectSubscription */](this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new __WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]();
        observable.source = this;
        return observable;
    };
    /**@nocollapse */
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(__WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]));

/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    /** @deprecated This is an internal implementation detail, do not use. */
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_3__Subscription__["a" /* Subscription */].EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));






/***/ }),

/***/ "tkWw":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        ss : '%d ثانية',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),

/***/ "tv3T":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("i4ON"),
    baseAssignValue = __webpack_require__("nw3t");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "tzHd":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        ss : '%d secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),

/***/ "uCi2":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("bIjD"),
    toKey = __webpack_require__("Ubhr");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "uIr7":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "uLhX":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("NkRn");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "uOsm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSymbolIterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return iterator; });
/* unused harmony export $$iterator */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();
/**
 * @deprecated use {@link iterator} instead
 */
var $$iterator = iterator;
//# sourceMappingURL=iterator.js.map


/***/ }),

/***/ "uSe8":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        ss : '%d سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),

/***/ "ue/d":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "uieL":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "ujcs":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "ulq9":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., H:mm',
        LLLL : 'dddd, D MMMM YYYY г., H:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ru;

})));


/***/ }),

/***/ "upln":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'ss':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
            }
            return result + 'sekúnda';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uxTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArgumentOutOfRangeError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */

/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */
var ArgumentOutOfRangeError = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var _this = _super.call(this, 'argument out of range') || this;
        _this.name = 'ArgumentOutOfRangeError';
        Object.setPrototypeOf(_this, ArgumentOutOfRangeError.prototype);
        return _this;
    }
    return ArgumentOutOfRangeError;
}(Error));






/***/ }),

/***/ "v389":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_rxjs_operators__["share"]; });

//# sourceMappingURL=share.js.map

/***/ }),

/***/ "v38c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = race;
/* unused harmony export RaceOperator */
/* unused harmony export RaceSubscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArray__ = /*@__PURE__*/__webpack_require__("YgML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromArray__ = /*@__PURE__*/__webpack_require__("b2EL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__ = /*@__PURE__*/__webpack_require__("1E73");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__ = /*@__PURE__*/__webpack_require__("3SjU");
/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */





function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isArray__["a" /* isArray */])(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__fromArray__["a" /* fromArray */])(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RaceSubscriber = /*@__PURE__*/ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"](RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = Object(__WEBPACK_IMPORTED_MODULE_4__util_subscribeToResult__["a" /* subscribeToResult */])(this, observable, observable, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(__WEBPACK_IMPORTED_MODULE_3__OuterSubscriber__["a" /* OuterSubscriber */]));






/***/ }),

/***/ "v8Dt":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("pTUa");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "v9aJ":
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__("M6Wl"),
    createBaseEach = __webpack_require__("pQJ6");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ "vFoO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__("TdOr");
var mention_utils_1 = __webpack_require__("gBXS");
var caret_coords_1 = __webpack_require__("bx9F");
/**
 * Angular 2 Mentions.
 * https://github.com/dmacfarlane/angular-mentions
 *
 * Copyright (c) 2016 Dan MacFarlane
 */
var MentionListComponent = /*@__PURE__*/ (function () {
    function MentionListComponent(element) {
        this.element = element;
        this.labelKey = 'label';
        this.itemClick = new core_1.EventEmitter();
        this.items = [];
        this.activeIndex = 0;
        this.hidden = false;
    }
    MentionListComponent.prototype.ngOnInit = function () {
        if (!this.itemTemplate) {
            this.itemTemplate = this.defaultItemTemplate;
        }
    };
    // lots of confusion here between relative coordinates and containers
    MentionListComponent.prototype.position = function (nativeParentElement, iframe, dropUp) {
        if (iframe === void 0) {
            iframe = null;
        }
        var coords = { top: 0, left: 0 };
        if (mention_utils_1.isInputOrTextAreaElement(nativeParentElement)) {
            this.blockCursorSize = this.getBlockCursorDimensions(nativeParentElement);
            var scrollToHeightDiff = (nativeParentElement.scrollHeight - nativeParentElement.clientHeight);
            var scrollToWidthDiff = (nativeParentElement.scrollWidth - nativeParentElement.clientWidth);
            // parent elements need to have postition:relative for this to work correctly?
            coords = caret_coords_1.getCaretCoordinates(nativeParentElement, nativeParentElement.selectionStart);
            coords.top = nativeParentElement.offsetTop - scrollToHeightDiff + coords.top + this.blockCursorSize.height;
            coords.left = nativeParentElement.offsetLeft - (scrollToWidthDiff ? scrollToWidthDiff + this.blockCursorSize.width : 0) + coords.left;
        }
        else if (iframe) {
            var context = { iframe: iframe, parent: iframe.offsetParent };
            coords = mention_utils_1.getContentEditableCaretCoords(context);
        }
        else {
            var doc = document.documentElement;
            var scrollLeft = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            var scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            // bounding rectangles are relative to view, offsets are relative to container?
            var caretRelativeToView = mention_utils_1.getContentEditableCaretCoords({ iframe: iframe });
            var parentRelativeToContainer = nativeParentElement.getBoundingClientRect();
            coords.top = caretRelativeToView.top - parentRelativeToContainer.top + nativeParentElement.offsetTop - scrollTop;
            coords.left = caretRelativeToView.left - parentRelativeToContainer.left + nativeParentElement.offsetLeft - scrollLeft;
        }
        var el = this.element.nativeElement;
        this.list.nativeElement.style.marginBottom = dropUp ? '24px' : null;
        el.className = dropUp ? 'dropup' : null;
        el.style.position = "absolute";
        el.style.left = coords.left + 'px';
        el.style.top = coords.top + 'px';
    };
    Object.defineProperty(MentionListComponent.prototype, "activeItem", {
        get: function () {
            return this.items[this.activeIndex];
        },
        enumerable: true,
        configurable: true
    });
    MentionListComponent.prototype.activateNextItem = function () {
        // adjust scrollable-menu offset if the next item is out of view
        var listEl = this.list.nativeElement;
        var activeEl = listEl.getElementsByClassName('active').item(0);
        if (activeEl) {
            var nextLiEl = activeEl.nextSibling;
            if (nextLiEl && nextLiEl.nodeName == "LI") {
                var nextLiRect = nextLiEl.getBoundingClientRect();
                if (nextLiRect.bottom > listEl.getBoundingClientRect().bottom) {
                    listEl.scrollTop = nextLiEl.offsetTop + nextLiRect.height - listEl.clientHeight;
                }
            }
        }
        // select the next item
        this.activeIndex = Math.max(Math.min(this.activeIndex + 1, this.items.length - 1), 0);
    };
    MentionListComponent.prototype.activatePreviousItem = function () {
        // adjust the scrollable-menu offset if the previous item is out of view
        var listEl = this.list.nativeElement;
        var activeEl = listEl.getElementsByClassName('active').item(0);
        if (activeEl) {
            var prevLiEl = activeEl.previousSibling;
            if (prevLiEl && prevLiEl.nodeName == "LI") {
                var prevLiRect = prevLiEl.getBoundingClientRect();
                if (prevLiRect.top < listEl.getBoundingClientRect().top) {
                    listEl.scrollTop = prevLiEl.offsetTop;
                }
            }
        }
        // select the previous item
        this.activeIndex = Math.max(Math.min(this.activeIndex - 1, this.items.length - 1), 0);
    };
    MentionListComponent.prototype.resetScroll = function () {
        this.list.nativeElement.scrollTop = 0;
    };
    MentionListComponent.prototype.getBlockCursorDimensions = function (nativeParentElement) {
        if (this.blockCursorSize) {
            return this.blockCursorSize;
        }
        var parentStyles = window.getComputedStyle(nativeParentElement);
        return {
            height: parseFloat(parentStyles.lineHeight),
            width: parseFloat(parentStyles.fontSize)
        };
    };
    MentionListComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'mention-list',
                    styles: ["\n      .scrollable-menu {\n        display: block;\n        height: auto;\n        max-height: 300px;\n        overflow: auto;\n      }\n    ", "\n      [hidden] {\n        display: none;\n      }\n    ", "\n      li.active {\n        background-color: #f7f7f9;\n      }\n    "],
                    template: "\n    <ng-template #defaultItemTemplate let-item=\"item\">\n      {{item[labelKey]}}\n    </ng-template>\n    <ul #list [hidden]=\"hidden\" class=\"dropdown-menu scrollable-menu\">\n        <li *ngFor=\"let item of items; let i = index\" [class.active]=\"activeIndex==i\">\n            <a class=\"dropdown-item\" (mousedown)=\"activeIndex=i;itemClick.emit();$event.preventDefault()\">\n              <ng-template [ngTemplateOutlet]=\"itemTemplate\" [ngTemplateOutletContext]=\"{'item':item}\"></ng-template>\n            </a>\n        </li>\n    </ul>\n    "
                },] },
    ];
    MentionListComponent.propDecorators = {
        'labelKey': [{ type: core_1.Input },],
        'itemTemplate': [{ type: core_1.Input },],
        'itemClick': [{ type: core_1.Output },],
        'list': [{ type: core_1.ViewChild, args: ['list',] },],
        'defaultItemTemplate': [{ type: core_1.ViewChild, args: ['defaultItemTemplate',] },],
    };
    return MentionListComponent;
}());
exports.MentionListComponent = MentionListComponent;



/***/ }),

/***/ "vRV5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULE_CONFIG = {
    'OnInit': 'hmrOnInit',
    'OnStatus': 'hmrOnStatus',
    'OnCheck': 'hmrOnCheck',
    'OnDecline': 'hmrOnDecline',
    'OnDestroy': 'hmrOnDestroy',
    'AfterDestroy': 'hmrAfterDestroy'
};
function hmrModule(MODULE_REF, MODULE, CONFIG) {
    if (CONFIG === void 0) { CONFIG = exports.MODULE_CONFIG; }
    if (MODULE['hot']) {
        MODULE['hot']['accept']();
        if (MODULE_REF.instance[exports.MODULE_CONFIG['OnInit']]) {
            if (MODULE['hot']['data']) {
                MODULE_REF.instance[exports.MODULE_CONFIG['OnInit']](MODULE['hot']['data']);
            }
        }
        if (MODULE_REF.instance[exports.MODULE_CONFIG['OnStatus']]) {
            MODULE['hot']['apply'](function hmrOnStatus(status) {
                MODULE_REF.instance[exports.MODULE_CONFIG['OnStatus']](status);
            });
        }
        if (MODULE_REF.instance[exports.MODULE_CONFIG['OnCheck']]) {
            MODULE['hot']['check'](function hmrOnCheck(err, outdatedModules) {
                MODULE_REF.instance[exports.MODULE_CONFIG['OnCheck']](err, outdatedModules);
            });
        }
        if (MODULE_REF.instance[exports.MODULE_CONFIG['OnDecline']]) {
            MODULE['hot']['decline'](function hmrOnDecline(dependencies) {
                MODULE_REF.instance[exports.MODULE_CONFIG['OnDecline']](dependencies);
            });
        }
        MODULE['hot']['dispose'](function hmrOnDestroy(store) {
            if (MODULE_REF.instance[exports.MODULE_CONFIG['OnDestroy']]) {
                MODULE_REF.instance[exports.MODULE_CONFIG['OnDestroy']](store);
            }
            MODULE_REF.destroy();
            if (MODULE_REF.instance[exports.MODULE_CONFIG['AfterDestroy']]) {
                MODULE_REF.instance[exports.MODULE_CONFIG['AfterDestroy']](store);
            }
        });
    }
    return MODULE_REF;
}
exports.hmrModule = hmrModule;
//# sourceMappingURL=hmr.js.map

/***/ }),

/***/ "vi0E":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("f931");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "w2Hs":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        ss : '%d སྐར་ཆ།',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),

/***/ "w5lW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMPTY; });
/* harmony export (immutable) */ __webpack_exports__["b"] = empty;
/* unused harmony export emptyScheduled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = /*@__PURE__*/__webpack_require__("lWPP");
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */

/**
 * The same Observable instance returned by any call to {@link empty} without a
 * {@link Scheduler}. It is preferrable to use this over `empty()`.
 */
var EMPTY = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return subscriber.complete(); });
/**
 * Creates an Observable that emits no items to the Observer and immediately
 * emits a complete notification.
 *
 * <span class="informal">Just emits 'complete', and nothing else.
 * </span>
 *
 * <img src="./img/empty.png" width="100%">
 *
 * This static operator is useful for creating a simple Observable that only
 * emits the complete notification. It can be used for composing with other
 * Observables, such as in a {@link mergeMap}.
 *
 * @example <caption>Emit the number 7, then complete.</caption>
 * var result = Rx.Observable.empty().startWith(7);
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
 * var interval = Rx.Observable.interval(1000);
 * var result = interval.mergeMap(x =>
 *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following to the console:
 * // x is equal to the count on the interval eg(0,1,2,3,...)
 * // x will occur every 1000ms
 * // if x % 2 is equal to 1 print abc
 * // if x % 2 is not equal to 1 nothing will be output
 *
 * @see {@link create}
 * @see {@link never}
 * @see {@link of}
 * @see {@link throw}
 *
 * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
 * the emission of the complete notification.
 * @return {Observable} An "empty" Observable: emits only the complete
 * notification.
 * @static true
 * @name empty
 * @owner Observable
 * @deprecated Deprecated in favor of using EMPTY constant.
 */
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map


/***/ }),

/***/ "w9Mt":
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__("ZD0O"),
    flatRest = __webpack_require__("2N6f");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),

/***/ "wIgY":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : 'D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        ss : '%d segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),

/***/ "wPpW":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        ss : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),

/***/ "wSKX":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "wT5f":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'ss': 'secunde',
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        ss : relativeTimeWithPlural,
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),

/***/ "wTuo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_e", function() { return COMMON_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_d", function() { return findLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_a", function() { return DEPRECATED_PLURAL_FN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_b", function() { return getPluralCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_g", function() { return COMMON_DEPRECATED_I18N_PIPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵangular_packages_common_common_f", function() { return COMMON_PIPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵregisterLocaleData", function() { return registerLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDate", function() { return formatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatCurrency", function() { return formatCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatNumber", function() { return formatNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatPercent", function() { return formatPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgLocaleLocalization", function() { return NgLocaleLocalization; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgLocalization", function() { return NgLocalization; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerLocaleData", function() { return registerLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Plural", function() { return Plural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberFormatStyle", function() { return NumberFormatStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormStyle", function() { return FormStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TranslationWidth", function() { return TranslationWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatWidth", function() { return FormatWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberSymbol", function() { return NumberSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeekDay", function() { return WeekDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNumberOfCurrencyDigits", function() { return getNumberOfCurrencyDigits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrencySymbol", function() { return getCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleDayPeriods", function() { return getLocaleDayPeriods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleDayNames", function() { return getLocaleDayNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleMonthNames", function() { return getLocaleMonthNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleId", function() { return getLocaleId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleEraNames", function() { return getLocaleEraNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleWeekEndRange", function() { return getLocaleWeekEndRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleFirstDayOfWeek", function() { return getLocaleFirstDayOfWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleDateFormat", function() { return getLocaleDateFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleDateTimeFormat", function() { return getLocaleDateTimeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleExtraDayPeriodRules", function() { return getLocaleExtraDayPeriodRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleExtraDayPeriods", function() { return getLocaleExtraDayPeriods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocalePluralCase", function() { return getLocalePluralCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleTimeFormat", function() { return getLocaleTimeFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleNumberSymbol", function() { return getLocaleNumberSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleNumberFormat", function() { return getLocaleNumberFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleCurrencyName", function() { return getLocaleCurrencyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocaleCurrencySymbol", function() { return getLocaleCurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵparseCookieValue", function() { return parseCookieValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommonModule", function() { return CommonModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedI18NPipesModule", function() { return DeprecatedI18NPipesModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgClass", function() { return NgClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForOf", function() { return NgForOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForOfContext", function() { return NgForOfContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgIf", function() { return NgIf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgIfContext", function() { return NgIfContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgPlural", function() { return NgPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgPluralCase", function() { return NgPluralCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgStyle", function() { return NgStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitch", function() { return NgSwitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitchCase", function() { return NgSwitchCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitchDefault", function() { return NgSwitchDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgTemplateOutlet", function() { return NgTemplateOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgComponentOutlet", function() { return NgComponentOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOCUMENT", function() { return DOCUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncPipe", function() { return AsyncPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DatePipe", function() { return DatePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18nPluralPipe", function() { return I18nPluralPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18nSelectPipe", function() { return I18nSelectPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonPipe", function() { return JsonPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LowerCasePipe", function() { return LowerCasePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CurrencyPipe", function() { return CurrencyPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DecimalPipe", function() { return DecimalPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PercentPipe", function() { return PercentPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SlicePipe", function() { return SlicePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpperCasePipe", function() { return UpperCasePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TitleCasePipe", function() { return TitleCasePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyValuePipe", function() { return KeyValuePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedDatePipe", function() { return DeprecatedDatePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedCurrencyPipe", function() { return DeprecatedCurrencyPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedDecimalPipe", function() { return DeprecatedDecimalPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DeprecatedPercentPipe", function() { return DeprecatedPercentPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_BROWSER_ID", function() { return PLATFORM_BROWSER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_SERVER_ID", function() { return PLATFORM_SERVER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_WORKER_APP_ID", function() { return PLATFORM_WORKER_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_WORKER_UI_ID", function() { return PLATFORM_WORKER_UI_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformBrowser", function() { return isPlatformBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformServer", function() { return isPlatformServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformWorkerApp", function() { return isPlatformWorkerApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformWorkerUi", function() { return isPlatformWorkerUi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewportScroller", function() { return ViewportScroller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNullViewportScroller", function() { return NullViewportScroller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlatformLocation", function() { return PlatformLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCATION_INITIALIZED", function() { return LOCATION_INITIALIZED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationStrategy", function() { return LocationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_BASE_HREF", function() { return APP_BASE_HREF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashLocationStrategy", function() { return HashLocationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PathLocationStrategy", function() { return PathLocationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Location", function() { return Location; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START _angular_core,tslib PURE_IMPORTS_END */


/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This class should not be used directly by an application developer. Instead, use
 * {@link Location}.
 *
 * `PlatformLocation` encapsulates all calls to DOM apis, which allows the Router to be platform
 * agnostic.
 * This means that we can have different implementation of `PlatformLocation` for the different
 * platforms that angular supports. For example, `@angular/platform-browser` provides an
 * implementation specific to the browser environment, while `@angular/platform-webworker` provides
 * one suitable for use with web workers.
 *
 * The `PlatformLocation` class is used directly by all implementations of {@link LocationStrategy}
 * when they need to interact with the DOM apis like pushState, popState, etc...
 *
 * {@link LocationStrategy} in turn is used by the {@link Location} service which is used directly
 * by the {@link Router} in order to navigate between routes. Since all interactions between {@link
 * Router} /
 * {@link Location} / {@link LocationStrategy} and DOM apis flow through the `PlatformLocation`
 * class they are all platform independent.
 *
 *
 */
var PlatformLocation = /*@__PURE__*/ (function () {
    function PlatformLocation() {
    }
    return PlatformLocation;
}());
/**
 * @description Indicates when a location is initialized.
 * @experimental
 */
var LOCATION_INITIALIZED = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('Location Initialized');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * `LocationStrategy` is responsible for representing and reading route state
 * from the browser's URL. Angular provides two strategies:
 * {@link HashLocationStrategy} and {@link PathLocationStrategy}.
 *
 * This is used under the hood of the {@link Location} service.
 *
 * Applications should use the {@link Router} or {@link Location} services to
 * interact with application route state.
 *
 * For instance, {@link HashLocationStrategy} produces URLs like
 * `http://example.com#/foo`, and {@link PathLocationStrategy} produces
 * `http://example.com/foo` as an equivalent URL.
 *
 * See these two classes for more.
 *
 *
 */
var LocationStrategy = /*@__PURE__*/ (function () {
    function LocationStrategy() {
    }
    return LocationStrategy;
}());
/**
 * The `APP_BASE_HREF` token represents the base href to be used with the
 * {@link PathLocationStrategy}.
 *
 * If you're using {@link PathLocationStrategy}, you must provide a provider to a string
 * representing the URL prefix that should be preserved when generating and recognizing
 * URLs.
 *
 * @usageNotes
 *
 * ### Example
 *
 * ```typescript
 * import {Component, NgModule} from '@angular/core';
 * import {APP_BASE_HREF} from '@angular/common';
 *
 * @NgModule({
 *   providers: [{provide: APP_BASE_HREF, useValue: '/my/app'}]
 * })
 * class AppModule {}
 * ```
 *
 *
 */
var APP_BASE_HREF = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('appBaseHref');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * A service that applications can use to interact with a browser's URL.
 *
 * Depending on which {@link LocationStrategy} is used, `Location` will either persist
 * to the URL's path or the URL's hash segment.
 *
 * @usageNotes
 *
 * It's better to use {@link Router#navigate} service to trigger route changes. Use
 * `Location` only if you need to interact with or create normalized URLs outside of
 * routing.
 *
 * `Location` is responsible for normalizing the URL against the application's base href.
 * A normalized URL is absolute from the URL host, includes the application's base href, and has no
 * trailing slash:
 * - `/my/app/user/123` is normalized
 * - `my/app/user/123` **is not** normalized
 * - `/my/app/user/123/` **is not** normalized
 *
 * ### Example
 *
 * {@example common/location/ts/path_location_component.ts region='LocationComponent'}
 *
 */
var Location = /*@__PURE__*/ (function () {
    function Location(platformStrategy) {
        var _this = this;
        /** @internal */
        this._subject = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._platformStrategy = platformStrategy;
        var browserBaseHref = this._platformStrategy.getBaseHref();
        this._baseHref = Location_1.stripTrailingSlash(_stripIndexHtml(browserBaseHref));
        this._platformStrategy.onPopState(function (ev) {
            _this._subject.emit({
                'url': _this.path(true),
                'pop': true,
                'state': ev.state,
                'type': ev.type,
            });
        });
    }
    Location_1 = Location;
    /**
     * Returns the normalized URL path.
     */
    // TODO: vsavkin. Remove the boolean flag and always include hash once the deprecated router is
    // removed.
    Location.prototype.path = function (includeHash) {
        if (includeHash === void 0) {
            includeHash = false;
        }
        return this.normalize(this._platformStrategy.path(includeHash));
    };
    /**
     * Normalizes the given path and compares to the current normalized path.
     */
    Location.prototype.isCurrentPathEqualTo = function (path, query) {
        if (query === void 0) {
            query = '';
        }
        return this.path() == this.normalize(path + Location_1.normalizeQueryParams(query));
    };
    /**
     * Given a string representing a URL, returns the normalized URL path without leading or
     * trailing slashes.
     */
    Location.prototype.normalize = function (url) {
        return Location_1.stripTrailingSlash(_stripBaseHref(this._baseHref, _stripIndexHtml(url)));
    };
    /**
     * Given a string representing a URL, returns the platform-specific external URL path.
     * If the given URL doesn't begin with a leading slash (`'/'`), this method adds one
     * before normalizing. This method will also add a hash if `HashLocationStrategy` is
     * used, or the `APP_BASE_HREF` if the `PathLocationStrategy` is in use.
     */
    Location.prototype.prepareExternalUrl = function (url) {
        if (url && url[0] !== '/') {
            url = '/' + url;
        }
        return this._platformStrategy.prepareExternalUrl(url);
    };
    // TODO: rename this method to pushState
    /**
     * Changes the browsers URL to the normalized version of the given URL, and pushes a
     * new item onto the platform's history.
     */
    Location.prototype.go = function (path, query, state) {
        if (query === void 0) {
            query = '';
        }
        if (state === void 0) {
            state = null;
        }
        this._platformStrategy.pushState(state, '', path, query);
    };
    /**
     * Changes the browsers URL to the normalized version of the given URL, and replaces
     * the top item on the platform's history stack.
     */
    Location.prototype.replaceState = function (path, query, state) {
        if (query === void 0) {
            query = '';
        }
        if (state === void 0) {
            state = null;
        }
        this._platformStrategy.replaceState(state, '', path, query);
    };
    /**
     * Navigates forward in the platform's history.
     */
    Location.prototype.forward = function () { this._platformStrategy.forward(); };
    /**
     * Navigates back in the platform's history.
     */
    Location.prototype.back = function () { this._platformStrategy.back(); };
    /**
     * Subscribe to the platform's `popState` events.
     */
    Location.prototype.subscribe = function (onNext, onThrow, onReturn) {
        return this._subject.subscribe({ next: onNext, error: onThrow, complete: onReturn });
    };
    /**
     * Given a string of url parameters, prepend with '?' if needed, otherwise return parameters as
     * is.
     */
    Location.normalizeQueryParams = function (params) {
        return params && params[0] !== '?' ? '?' + params : params;
    };
    /**
     * Given 2 parts of a url, join them with a slash if needed.
     */
    Location.joinWithSlash = function (start, end) {
        if (start.length == 0) {
            return end;
        }
        if (end.length == 0) {
            return start;
        }
        var slashes = 0;
        if (start.endsWith('/')) {
            slashes++;
        }
        if (end.startsWith('/')) {
            slashes++;
        }
        if (slashes == 2) {
            return start + end.substring(1);
        }
        if (slashes == 1) {
            return start + end;
        }
        return start + '/' + end;
    };
    /**
     * If url has a trailing slash, remove it, otherwise return url as is. This
     * method looks for the first occurrence of either #, ?, or the end of the
     * line as `/` characters after any of these should not be replaced.
     */
    Location.stripTrailingSlash = function (url) {
        var match = url.match(/#|\?|$/);
        var pathEndIdx = match && match.index || url.length;
        var droppedSlashIdx = pathEndIdx - (url[pathEndIdx - 1] === '/' ? 1 : 0);
        return url.slice(0, droppedSlashIdx) + url.slice(pathEndIdx);
    };
    var Location_1;
    return Location;
}());
function _stripBaseHref(baseHref, url) {
    return baseHref && url.startsWith(baseHref) ? url.substring(baseHref.length) : url;
}
function _stripIndexHtml(url) {
    return url.replace(/\/index.html$/, '');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 * A {@link LocationStrategy} used to configure the {@link Location} service to
 * represent its state in the
 * [hash fragment](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax)
 * of the browser's URL.
 *
 * For instance, if you call `location.go('/foo')`, the browser's URL will become
 * `example.com#/foo`.
 *
 * @usageNotes
 *
 * ### Example
 *
 * {@example common/location/ts/hash_location_component.ts region='LocationComponent'}
 *
 *
 */
var HashLocationStrategy = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(HashLocationStrategy, _super);
    function HashLocationStrategy(_platformLocation, _baseHref) {
        var _this = _super.call(this) || this;
        _this._platformLocation = _platformLocation;
        _this._baseHref = '';
        if (_baseHref != null) {
            _this._baseHref = _baseHref;
        }
        return _this;
    }
    HashLocationStrategy.prototype.onPopState = function (fn) {
        this._platformLocation.onPopState(fn);
        this._platformLocation.onHashChange(fn);
    };
    HashLocationStrategy.prototype.getBaseHref = function () { return this._baseHref; };
    HashLocationStrategy.prototype.path = function (includeHash) {
        if (includeHash === void 0) {
            includeHash = false;
        }
        // the hash value is always prefixed with a `#`
        // and if it is empty then it will stay empty
        var path = this._platformLocation.hash;
        if (path == null)
            path = '#';
        return path.length > 0 ? path.substring(1) : path;
    };
    HashLocationStrategy.prototype.prepareExternalUrl = function (internal) {
        var url = Location.joinWithSlash(this._baseHref, internal);
        return url.length > 0 ? ('#' + url) : url;
    };
    HashLocationStrategy.prototype.pushState = function (state, title, path, queryParams) {
        var url = this.prepareExternalUrl(path + Location.normalizeQueryParams(queryParams));
        if (url.length == 0) {
            url = this._platformLocation.pathname;
        }
        this._platformLocation.pushState(state, title, url);
    };
    HashLocationStrategy.prototype.replaceState = function (state, title, path, queryParams) {
        var url = this.prepareExternalUrl(path + Location.normalizeQueryParams(queryParams));
        if (url.length == 0) {
            url = this._platformLocation.pathname;
        }
        this._platformLocation.replaceState(state, title, url);
    };
    HashLocationStrategy.prototype.forward = function () { this._platformLocation.forward(); };
    HashLocationStrategy.prototype.back = function () { this._platformLocation.back(); };
    HashLocationStrategy = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(APP_BASE_HREF))
    ], HashLocationStrategy);
    return HashLocationStrategy;
}(LocationStrategy));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 * A {@link LocationStrategy} used to configure the {@link Location} service to
 * represent its state in the
 * [path](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax) of the
 * browser's URL.
 *
 * If you're using `PathLocationStrategy`, you must provide a {@link APP_BASE_HREF}
 * or add a base element to the document. This URL prefix that will be preserved
 * when generating and recognizing URLs.
 *
 * For instance, if you provide an `APP_BASE_HREF` of `'/my/app'` and call
 * `location.go('/foo')`, the browser's URL will become
 * `example.com/my/app/foo`.
 *
 * Similarly, if you add `<base href='/my/app'/>` to the document and call
 * `location.go('/foo')`, the browser's URL will become
 * `example.com/my/app/foo`.
 *
 * @usageNotes
 *
 * ### Example
 *
 * {@example common/location/ts/path_location_component.ts region='LocationComponent'}
 *
 *
 */
var PathLocationStrategy = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(PathLocationStrategy, _super);
    function PathLocationStrategy(_platformLocation, href) {
        var _this = _super.call(this) || this;
        _this._platformLocation = _platformLocation;
        if (href == null) {
            href = _this._platformLocation.getBaseHrefFromDOM();
        }
        if (href == null) {
            throw new Error("No base href set. Please provide a value for the APP_BASE_HREF token or add a base element to the document.");
        }
        _this._baseHref = href;
        return _this;
    }
    PathLocationStrategy.prototype.onPopState = function (fn) {
        this._platformLocation.onPopState(fn);
        this._platformLocation.onHashChange(fn);
    };
    PathLocationStrategy.prototype.getBaseHref = function () { return this._baseHref; };
    PathLocationStrategy.prototype.prepareExternalUrl = function (internal) {
        return Location.joinWithSlash(this._baseHref, internal);
    };
    PathLocationStrategy.prototype.path = function (includeHash) {
        if (includeHash === void 0) {
            includeHash = false;
        }
        var pathname = this._platformLocation.pathname +
            Location.normalizeQueryParams(this._platformLocation.search);
        var hash = this._platformLocation.hash;
        return hash && includeHash ? "" + pathname + hash : pathname;
    };
    PathLocationStrategy.prototype.pushState = function (state, title, url, queryParams) {
        var externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
        this._platformLocation.pushState(state, title, externalUrl);
    };
    PathLocationStrategy.prototype.replaceState = function (state, title, url, queryParams) {
        var externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
        this._platformLocation.replaceState(state, title, externalUrl);
    };
    PathLocationStrategy.prototype.forward = function () { this._platformLocation.forward(); };
    PathLocationStrategy.prototype.back = function () { this._platformLocation.back(); };
    PathLocationStrategy = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(APP_BASE_HREF))
    ], PathLocationStrategy);
    return PathLocationStrategy;
}(LocationStrategy));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js
var u = undefined;
function plural(n) {
    var i = Math.floor(Math.abs(n)), v = n.toString().replace(/^[^.]*\.?/, '').length;
    if (i === 1 && v === 0)
        return 1;
    return 5;
}
var localeEn = [
    'en', [['a', 'p'], ['AM', 'PM'], u], [['AM', 'PM'], u, u],
    [
        ['S', 'M', 'T', 'W', 'T', 'F', 'S'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
    ],
    u,
    [
        ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        [
            'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
            'October', 'November', 'December'
        ]
    ],
    u, [['B', 'A'], ['BC', 'AD'], ['Before Christ', 'Anno Domini']], 0, [6, 0],
    ['M/d/yy', 'MMM d, y', 'MMMM d, y', 'EEEE, MMMM d, y'],
    ['h:mm a', 'h:mm:ss a', 'h:mm:ss a z', 'h:mm:ss a zzzz'], ['{1}, {0}', u, '{1} \'at\' {0}', u],
    ['.', ',', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'NaN', ':'],
    ['#,##0.###', '#,##0%', '¤#,##0.00', '#E0'], '$', 'US Dollar', {}, plural
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @experimental i18n support is experimental.
 */
var LOCALE_DATA = {};
/**
 * Register global data to be used internally by Angular. See the
 * ["I18n guide"](guide/i18n#i18n-pipes) to know how to import additional locale data.
 *
 * @experimental i18n support is experimental.
 */
// The signature registerLocaleData(data: any, extraData?: any) is deprecated since v5.1
function registerLocaleData(data, localeId, extraData) {
    if (typeof localeId !== 'string') {
        extraData = localeId;
        localeId = data[0 /* LocaleId */];
    }
    localeId = localeId.toLowerCase().replace(/_/g, '-');
    LOCALE_DATA[localeId] = data;
    if (extraData) {
        LOCALE_DATA[localeId][19 /* ExtraData */] = extraData;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** @internal */
var CURRENCIES_EN = {
    'ADP': [undefined, undefined, 0],
    'AFN': [undefined, undefined, 0],
    'ALL': [undefined, undefined, 0],
    'AMD': [undefined, undefined, 0],
    'AOA': [undefined, 'Kz'],
    'ARS': [undefined, '$'],
    'AUD': ['A$', '$'],
    'BAM': [undefined, 'KM'],
    'BBD': [undefined, '$'],
    'BDT': [undefined, '৳'],
    'BHD': [undefined, undefined, 3],
    'BIF': [undefined, undefined, 0],
    'BMD': [undefined, '$'],
    'BND': [undefined, '$'],
    'BOB': [undefined, 'Bs'],
    'BRL': ['R$'],
    'BSD': [undefined, '$'],
    'BWP': [undefined, 'P'],
    'BYN': [undefined, 'р.', 2],
    'BYR': [undefined, undefined, 0],
    'BZD': [undefined, '$'],
    'CAD': ['CA$', '$', 2],
    'CHF': [undefined, undefined, 2],
    'CLF': [undefined, undefined, 4],
    'CLP': [undefined, '$', 0],
    'CNY': ['CN¥', '¥'],
    'COP': [undefined, '$', 0],
    'CRC': [undefined, '₡', 2],
    'CUC': [undefined, '$'],
    'CUP': [undefined, '$'],
    'CZK': [undefined, 'Kč', 2],
    'DJF': [undefined, undefined, 0],
    'DKK': [undefined, 'kr', 2],
    'DOP': [undefined, '$'],
    'EGP': [undefined, 'E£'],
    'ESP': [undefined, '₧', 0],
    'EUR': ['€'],
    'FJD': [undefined, '$'],
    'FKP': [undefined, '£'],
    'GBP': ['£'],
    'GEL': [undefined, '₾'],
    'GIP': [undefined, '£'],
    'GNF': [undefined, 'FG', 0],
    'GTQ': [undefined, 'Q'],
    'GYD': [undefined, '$', 0],
    'HKD': ['HK$', '$'],
    'HNL': [undefined, 'L'],
    'HRK': [undefined, 'kn'],
    'HUF': [undefined, 'Ft', 2],
    'IDR': [undefined, 'Rp', 0],
    'ILS': ['₪'],
    'INR': ['₹'],
    'IQD': [undefined, undefined, 0],
    'IRR': [undefined, undefined, 0],
    'ISK': [undefined, 'kr', 0],
    'ITL': [undefined, undefined, 0],
    'JMD': [undefined, '$'],
    'JOD': [undefined, undefined, 3],
    'JPY': ['¥', undefined, 0],
    'KHR': [undefined, '៛'],
    'KMF': [undefined, 'CF', 0],
    'KPW': [undefined, '₩', 0],
    'KRW': ['₩', undefined, 0],
    'KWD': [undefined, undefined, 3],
    'KYD': [undefined, '$'],
    'KZT': [undefined, '₸'],
    'LAK': [undefined, '₭', 0],
    'LBP': [undefined, 'L£', 0],
    'LKR': [undefined, 'Rs'],
    'LRD': [undefined, '$'],
    'LTL': [undefined, 'Lt'],
    'LUF': [undefined, undefined, 0],
    'LVL': [undefined, 'Ls'],
    'LYD': [undefined, undefined, 3],
    'MGA': [undefined, 'Ar', 0],
    'MGF': [undefined, undefined, 0],
    'MMK': [undefined, 'K', 0],
    'MNT': [undefined, '₮', 0],
    'MRO': [undefined, undefined, 0],
    'MUR': [undefined, 'Rs', 0],
    'MXN': ['MX$', '$'],
    'MYR': [undefined, 'RM'],
    'NAD': [undefined, '$'],
    'NGN': [undefined, '₦'],
    'NIO': [undefined, 'C$'],
    'NOK': [undefined, 'kr', 2],
    'NPR': [undefined, 'Rs'],
    'NZD': ['NZ$', '$'],
    'OMR': [undefined, undefined, 3],
    'PHP': [undefined, '₱'],
    'PKR': [undefined, 'Rs', 0],
    'PLN': [undefined, 'zł'],
    'PYG': [undefined, '₲', 0],
    'RON': [undefined, 'lei'],
    'RSD': [undefined, undefined, 0],
    'RUB': [undefined, '₽'],
    'RUR': [undefined, 'р.'],
    'RWF': [undefined, 'RF', 0],
    'SBD': [undefined, '$'],
    'SEK': [undefined, 'kr', 2],
    'SGD': [undefined, '$'],
    'SHP': [undefined, '£'],
    'SLL': [undefined, undefined, 0],
    'SOS': [undefined, undefined, 0],
    'SRD': [undefined, '$'],
    'SSP': [undefined, '£'],
    'STD': [undefined, undefined, 0],
    'STN': [undefined, 'Db'],
    'SYP': [undefined, '£', 0],
    'THB': [undefined, '฿'],
    'TMM': [undefined, undefined, 0],
    'TND': [undefined, undefined, 3],
    'TOP': [undefined, 'T$'],
    'TRL': [undefined, undefined, 0],
    'TRY': [undefined, '₺'],
    'TTD': [undefined, '$'],
    'TWD': ['NT$', '$', 2],
    'TZS': [undefined, undefined, 0],
    'UAH': [undefined, '₴'],
    'UGX': [undefined, undefined, 0],
    'USD': ['$'],
    'UYI': [undefined, undefined, 0],
    'UYU': [undefined, '$'],
    'UZS': [undefined, undefined, 0],
    'VEF': [undefined, 'Bs'],
    'VND': ['₫', undefined, 0],
    'VUV': [undefined, undefined, 0],
    'XAF': ['FCFA', undefined, 0],
    'XCD': ['EC$', '$'],
    'XOF': ['CFA', undefined, 0],
    'XPF': ['CFPF', undefined, 0],
    'YER': [undefined, undefined, 0],
    'ZAR': [undefined, 'R'],
    'ZMK': [undefined, undefined, 0],
    'ZMW': [undefined, 'ZK'],
    'ZWD': [undefined, undefined, 0]
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The different format styles that can be used to represent numbers.
 * Used by the function {@link getLocaleNumberFormat}.
 *
 * @experimental i18n support is experimental.
 */
var NumberFormatStyle = /*@__PURE__*/ (function (NumberFormatStyle) {
    NumberFormatStyle[NumberFormatStyle["Decimal"] = 0] = "Decimal";
    NumberFormatStyle[NumberFormatStyle["Percent"] = 1] = "Percent";
    NumberFormatStyle[NumberFormatStyle["Currency"] = 2] = "Currency";
    NumberFormatStyle[NumberFormatStyle["Scientific"] = 3] = "Scientific";
    return NumberFormatStyle;
})({});
/** @experimental */
var Plural = /*@__PURE__*/ (function (Plural) {
    Plural[Plural["Zero"] = 0] = "Zero";
    Plural[Plural["One"] = 1] = "One";
    Plural[Plural["Two"] = 2] = "Two";
    Plural[Plural["Few"] = 3] = "Few";
    Plural[Plural["Many"] = 4] = "Many";
    Plural[Plural["Other"] = 5] = "Other";
    return Plural;
})({});
/**
 * Some languages use two different forms of strings (standalone and format) depending on the
 * context.
 * Typically the standalone version is the nominative form of the word, and the format version is in
 * the genitive.
 * See [the CLDR website](http://cldr.unicode.org/translation/date-time) for more information.
 *
 * @experimental i18n support is experimental.
 */
var FormStyle = /*@__PURE__*/ (function (FormStyle) {
    FormStyle[FormStyle["Format"] = 0] = "Format";
    FormStyle[FormStyle["Standalone"] = 1] = "Standalone";
    return FormStyle;
})({});
/**
 * Multiple widths are available for translations: narrow (1 character), abbreviated (3 characters),
 * wide (full length), and short (2 characters, only for days).
 *
 * For example the day `Sunday` will be:
 * - Narrow: `S`
 * - Short: `Su`
 * - Abbreviated: `Sun`
 * - Wide: `Sunday`
 *
 * @experimental i18n support is experimental.
 */
var TranslationWidth = /*@__PURE__*/ (function (TranslationWidth) {
    TranslationWidth[TranslationWidth["Narrow"] = 0] = "Narrow";
    TranslationWidth[TranslationWidth["Abbreviated"] = 1] = "Abbreviated";
    TranslationWidth[TranslationWidth["Wide"] = 2] = "Wide";
    TranslationWidth[TranslationWidth["Short"] = 3] = "Short";
    return TranslationWidth;
})({});
/**
 * Multiple widths are available for formats: short (minimal amount of data), medium (small amount
 * of data), long (complete amount of data), full (complete amount of data and extra information).
 *
 * For example the date-time formats for the english locale will be:
 *  - `'short'`: `'M/d/yy, h:mm a'` (e.g. `6/15/15, 9:03 AM`)
 *  - `'medium'`: `'MMM d, y, h:mm:ss a'` (e.g. `Jun 15, 2015, 9:03:01 AM`)
 *  - `'long'`: `'MMMM d, y, h:mm:ss a z'` (e.g. `June 15, 2015 at 9:03:01 AM GMT+1`)
 *  - `'full'`: `'EEEE, MMMM d, y, h:mm:ss a zzzz'` (e.g. `Monday, June 15, 2015 at
 * 9:03:01 AM GMT+01:00`)
 *
 * @experimental i18n support is experimental.
 */
var FormatWidth = /*@__PURE__*/ (function (FormatWidth) {
    FormatWidth[FormatWidth["Short"] = 0] = "Short";
    FormatWidth[FormatWidth["Medium"] = 1] = "Medium";
    FormatWidth[FormatWidth["Long"] = 2] = "Long";
    FormatWidth[FormatWidth["Full"] = 3] = "Full";
    return FormatWidth;
})({});
/**
 * Number symbol that can be used to replace placeholders in number patterns.
 * The placeholders are based on english values:
 *
 * | Name                   | Example for en-US | Meaning                                     |
 * |------------------------|-------------------|---------------------------------------------|
 * | decimal                | 2,345`.`67        | decimal separator                           |
 * | group                  | 2`,`345.67        | grouping separator, typically for thousands |
 * | plusSign               | `+`23             | the plus sign used with numbers             |
 * | minusSign              | `-`23             | the minus sign used with numbers            |
 * | percentSign            | 23.4`%`           | the percent sign (out of 100)               |
 * | perMille               | 234`‰`            | the permille sign (out of 1000)             |
 * | exponential            | 1.2`E`3           | used in computers for 1.2×10³.              |
 * | superscriptingExponent | 1.2`×`103         | human-readable format of exponential        |
 * | infinity               | `∞`               | used in +∞ and -∞.                          |
 * | nan                    | `NaN`             | "not a number".                             |
 * | timeSeparator          | 10`:`52           | symbol used between time units              |
 * | currencyDecimal        | $2,345`.`67       | decimal separator, fallback to "decimal"    |
 * | currencyGroup          | $2`,`345.67       | grouping separator, fallback to "group"     |
 *
 * @experimental i18n support is experimental.
 */
var NumberSymbol = /*@__PURE__*/ (function (NumberSymbol) {
    NumberSymbol[NumberSymbol["Decimal"] = 0] = "Decimal";
    NumberSymbol[NumberSymbol["Group"] = 1] = "Group";
    NumberSymbol[NumberSymbol["List"] = 2] = "List";
    NumberSymbol[NumberSymbol["PercentSign"] = 3] = "PercentSign";
    NumberSymbol[NumberSymbol["PlusSign"] = 4] = "PlusSign";
    NumberSymbol[NumberSymbol["MinusSign"] = 5] = "MinusSign";
    NumberSymbol[NumberSymbol["Exponential"] = 6] = "Exponential";
    NumberSymbol[NumberSymbol["SuperscriptingExponent"] = 7] = "SuperscriptingExponent";
    NumberSymbol[NumberSymbol["PerMille"] = 8] = "PerMille";
    NumberSymbol[NumberSymbol["Infinity"] = 9] = "Infinity";
    NumberSymbol[NumberSymbol["NaN"] = 10] = "NaN";
    NumberSymbol[NumberSymbol["TimeSeparator"] = 11] = "TimeSeparator";
    NumberSymbol[NumberSymbol["CurrencyDecimal"] = 12] = "CurrencyDecimal";
    NumberSymbol[NumberSymbol["CurrencyGroup"] = 13] = "CurrencyGroup";
    return NumberSymbol;
})({});
/**
 * The value for each day of the week, based on the en-US locale
 *
 * @experimental
 */
var WeekDay = /*@__PURE__*/ (function (WeekDay) {
    WeekDay[WeekDay["Sunday"] = 0] = "Sunday";
    WeekDay[WeekDay["Monday"] = 1] = "Monday";
    WeekDay[WeekDay["Tuesday"] = 2] = "Tuesday";
    WeekDay[WeekDay["Wednesday"] = 3] = "Wednesday";
    WeekDay[WeekDay["Thursday"] = 4] = "Thursday";
    WeekDay[WeekDay["Friday"] = 5] = "Friday";
    WeekDay[WeekDay["Saturday"] = 6] = "Saturday";
    return WeekDay;
})({});
/**
 * The locale id for the chosen locale (e.g `en-GB`).
 *
 * @experimental i18n support is experimental.
 */
function getLocaleId(locale) {
    return findLocaleData(locale)[0 /* LocaleId */];
}
/**
 * Periods of the day (e.g. `[AM, PM]` for en-US).
 *
 * @experimental i18n support is experimental.
 */
function getLocaleDayPeriods(locale, formStyle, width) {
    var data = findLocaleData(locale);
    var amPmData = [data[1 /* DayPeriodsFormat */], data[2 /* DayPeriodsStandalone */]];
    var amPm = getLastDefinedValue(amPmData, formStyle);
    return getLastDefinedValue(amPm, width);
}
/**
 * Days of the week for the Gregorian calendar (e.g. `[Sunday, Monday, ... Saturday]` for en-US).
 *
 * @experimental i18n support is experimental.
 */
function getLocaleDayNames(locale, formStyle, width) {
    var data = findLocaleData(locale);
    var daysData = [data[3 /* DaysFormat */], data[4 /* DaysStandalone */]];
    var days = getLastDefinedValue(daysData, formStyle);
    return getLastDefinedValue(days, width);
}
/**
 * Months of the year for the Gregorian calendar (e.g. `[January, February, ...]` for en-US).
 *
 * @experimental i18n support is experimental.
 */
function getLocaleMonthNames(locale, formStyle, width) {
    var data = findLocaleData(locale);
    var monthsData = [data[5 /* MonthsFormat */], data[6 /* MonthsStandalone */]];
    var months = getLastDefinedValue(monthsData, formStyle);
    return getLastDefinedValue(months, width);
}
/**
 * Eras for the Gregorian calendar (e.g. AD/BC).
 *
 * @experimental i18n support is experimental.
 */
function getLocaleEraNames(locale, width) {
    var data = findLocaleData(locale);
    var erasData = data[7 /* Eras */];
    return getLastDefinedValue(erasData, width);
}
/**
 * First day of the week for this locale, based on english days (Sunday = 0, Monday = 1, ...).
 * For example in french the value would be 1 because the first day of the week is Monday.
 *
 * @experimental i18n support is experimental.
 */
function getLocaleFirstDayOfWeek(locale) {
    var data = findLocaleData(locale);
    return data[8 /* FirstDayOfWeek */];
}
/**
 * Range of days in the week that represent the week-end for this locale, based on english days
 * (Sunday = 0, Monday = 1, ...).
 * For example in english the value would be [6,0] for Saturday to Sunday.
 *
 * @experimental i18n support is experimental.
 */
function getLocaleWeekEndRange(locale) {
    var data = findLocaleData(locale);
    return data[9 /* WeekendRange */];
}
/**
 * Date format that depends on the locale.
 *
 * There are four basic date formats:
 * - `full` should contain long-weekday (EEEE), year (y), long-month (MMMM), day (d).
 *
 *  For example, English uses `EEEE, MMMM d, y`, corresponding to a date like
 *  "Tuesday, September 14, 1999".
 *
 * - `long` should contain year, long-month, day.
 *
 *  For example, `MMMM d, y`, corresponding to a date like "September 14, 1999".
 *
 * - `medium` should contain year, abbreviated-month (MMM), day.
 *
 *  For example, `MMM d, y`, corresponding to a date like "Sep 14, 1999".
 *  For languages that do not use abbreviated months, use the numeric month (MM/M). For example,
 *  `y/MM/dd`, corresponding to a date like "1999/09/14".
 *
 * - `short` should contain year, numeric-month (MM/M), and day.
 *
 *  For example, `M/d/yy`, corresponding to a date like "9/14/99".
 *
 * @experimental i18n support is experimental.
 */
function getLocaleDateFormat(locale, width) {
    var data = findLocaleData(locale);
    return getLastDefinedValue(data[10 /* DateFormat */], width);
}
/**
 * Time format that depends on the locale.
 *
 * The standard formats include four basic time formats:
 * - `full` should contain hour (h/H), minute (mm), second (ss), and zone (zzzz).
 * - `long` should contain hour, minute, second, and zone (z)
 * - `medium` should contain hour, minute, second.
 * - `short` should contain hour, minute.
 *
 * Note: The patterns depend on whether the main country using your language uses 12-hour time or
 * not:
 * - For 12-hour time, use a pattern like `hh:mm a` using h to mean a 12-hour clock cycle running
 * 1 through 12 (midnight plus 1 minute is 12:01), or using K to mean a 12-hour clock cycle
 * running 0 through 11 (midnight plus 1 minute is 0:01).
 * - For 24-hour time, use a pattern like `HH:mm` using H to mean a 24-hour clock cycle running 0
 * through 23 (midnight plus 1 minute is 0:01), or using k to mean a 24-hour clock cycle running
 * 1 through 24 (midnight plus 1 minute is 24:01).
 *
 * @experimental i18n support is experimental.
 */
function getLocaleTimeFormat(locale, width) {
    var data = findLocaleData(locale);
    return getLastDefinedValue(data[11 /* TimeFormat */], width);
}
/**
 * Date-time format that depends on the locale.
 *
 * The date-time pattern shows how to combine separate patterns for date (represented by {1})
 * and time (represented by {0}) into a single pattern. It usually doesn't need to be changed.
 * What you want to pay attention to are:
 * - possibly removing a space for languages that don't use it, such as many East Asian languages
 * - possibly adding a comma, other punctuation, or a combining word
 *
 * For example:
 * - English uses `{1} 'at' {0}` or `{1}, {0}` (depending on date style), while Japanese uses
 *  `{1}{0}`.
 * - An English formatted date-time using the combining pattern `{1}, {0}` could be
 *  `Dec 10, 2010, 3:59:49 PM`. Notice the comma and space between the date portion and the time
 *  portion.
 *
 * There are four formats (`full`, `long`, `medium`, `short`); the determination of which to use
 * is normally based on the date style. For example, if the date has a full month and weekday
 * name, the full combining pattern will be used to combine that with a time. If the date has
 * numeric month, the short version of the combining pattern will be used to combine that with a
 * time. English uses `{1} 'at' {0}` for full and long styles, and `{1}, {0}` for medium and short
 * styles.
 *
 * @experimental i18n support is experimental.
 */
function getLocaleDateTimeFormat(locale, width) {
    var data = findLocaleData(locale);
    var dateTimeFormatData = data[12 /* DateTimeFormat */];
    return getLastDefinedValue(dateTimeFormatData, width);
}
/**
 * Number symbol that can be used to replace placeholders in number formats.
 * See {@link NumberSymbol} for more information.
 *
 * @experimental i18n support is experimental.
 */
function getLocaleNumberSymbol(locale, symbol) {
    var data = findLocaleData(locale);
    var res = data[13 /* NumberSymbols */][symbol];
    if (typeof res === 'undefined') {
        if (symbol === NumberSymbol.CurrencyDecimal) {
            return data[13 /* NumberSymbols */][NumberSymbol.Decimal];
        }
        else if (symbol === NumberSymbol.CurrencyGroup) {
            return data[13 /* NumberSymbols */][NumberSymbol.Group];
        }
    }
    return res;
}
/**
 * Number format that depends on the locale.
 *
 * Numbers are formatted using patterns, like `#,###.00`. For example, the pattern `#,###.00`
 * when used to format the number 12345.678 could result in "12'345,67". That would happen if the
 * grouping separator for your language is an apostrophe, and the decimal separator is a comma.
 *
 * <b>Important:</b> The characters `.` `,` `0` `#` (and others below) are special placeholders;
 * they stand for the decimal separator, and so on, and are NOT real characters.
 * You must NOT "translate" the placeholders; for example, don't change `.` to `,` even though in
 * your language the decimal point is written with a comma. The symbols should be replaced by the
 * local equivalents, using the Number Symbols for your language.
 *
 * Here are the special characters used in number patterns:
 *
 * | Symbol | Meaning |
 * |--------|---------|
 * | . | Replaced automatically by the character used for the decimal point. |
 * | , | Replaced by the "grouping" (thousands) separator. |
 * | 0 | Replaced by a digit (or zero if there aren't enough digits). |
 * | # | Replaced by a digit (or nothing if there aren't enough). |
 * | ¤ | This will be replaced by a currency symbol, such as $ or USD. |
 * | % | This marks a percent format. The % symbol may change position, but must be retained. |
 * | E | This marks a scientific format. The E symbol may change position, but must be retained. |
 * | ' | Special characters used as literal characters are quoted with ASCII single quotes. |
 *
 * You can find more information
 * [on the CLDR website](http://cldr.unicode.org/translation/number-patterns)
 *
 * @experimental i18n support is experimental.
 */
function getLocaleNumberFormat(locale, type) {
    var data = findLocaleData(locale);
    return data[14 /* NumberFormats */][type];
}
/**
 * The symbol used to represent the currency for the main country using this locale (e.g. $ for
 * the locale en-US).
 * The symbol will be `null` if the main country cannot be determined.
 *
 * @experimental i18n support is experimental.
 */
function getLocaleCurrencySymbol(locale) {
    var data = findLocaleData(locale);
    return data[15 /* CurrencySymbol */] || null;
}
/**
 * The name of the currency for the main country using this locale (e.g. USD for the locale
 * en-US).
 * The name will be `null` if the main country cannot be determined.
 *
 * @experimental i18n support is experimental.
 */
function getLocaleCurrencyName(locale) {
    var data = findLocaleData(locale);
    return data[16 /* CurrencyName */] || null;
}
/**
 * Returns the currency values for the locale
 */
function getLocaleCurrencies(locale) {
    var data = findLocaleData(locale);
    return data[17 /* Currencies */];
}
/**
 * The locale plural function used by ICU expressions to determine the plural case to use.
 * See {@link NgPlural} for more information.
 *
 * @experimental i18n support is experimental.
 */
function getLocalePluralCase(locale) {
    var data = findLocaleData(locale);
    return data[18 /* PluralCase */];
}
function checkFullData(data) {
    if (!data[19 /* ExtraData */]) {
        throw new Error("Missing extra locale data for the locale \"" + data[0 /* LocaleId */] + "\". Use \"registerLocaleData\" to load new data. See the \"I18n guide\" on angular.io to know more.");
    }
}
/**
 * Rules used to determine which day period to use (See `dayPeriods` below).
 * The rules can either be an array or a single value. If it's an array, consider it as "from"
 * and "to". If it's a single value then it means that the period is only valid at this exact
 * value.
 * There is always the same number of rules as the number of day periods, which means that the
 * first rule is applied to the first day period and so on.
 * You should fallback to AM/PM when there are no rules available.
 *
 * Note: this is only available if you load the full locale data.
 * See the ["I18n guide"](guide/i18n#i18n-pipes) to know how to import additional locale
 * data.
 *
 * @experimental i18n support is experimental.
 */
function getLocaleExtraDayPeriodRules(locale) {
    var data = findLocaleData(locale);
    checkFullData(data);
    var rules = data[19 /* ExtraData */][2 /* ExtraDayPeriodsRules */] || [];
    return rules.map(function (rule) {
        if (typeof rule === 'string') {
            return extractTime(rule);
        }
        return [extractTime(rule[0]), extractTime(rule[1])];
    });
}
/**
 * Day Periods indicate roughly how the day is broken up in different languages (e.g. morning,
 * noon, afternoon, midnight, ...).
 * You should use the function {@link getLocaleExtraDayPeriodRules} to determine which period to
 * use.
 * You should fallback to AM/PM when there are no day periods available.
 *
 * Note: this is only available if you load the full locale data.
 * See the ["I18n guide"](guide/i18n#i18n-pipes) to know how to import additional locale
 * data.
 *
 * @experimental i18n support is experimental.
 */
function getLocaleExtraDayPeriods(locale, formStyle, width) {
    var data = findLocaleData(locale);
    checkFullData(data);
    var dayPeriodsData = [
        data[19 /* ExtraData */][0 /* ExtraDayPeriodFormats */],
        data[19 /* ExtraData */][1 /* ExtraDayPeriodStandalone */]
    ];
    var dayPeriods = getLastDefinedValue(dayPeriodsData, formStyle) || [];
    return getLastDefinedValue(dayPeriods, width) || [];
}
/**
 * Returns the first value that is defined in an array, going backwards.
 *
 * To avoid repeating the same data (e.g. when "format" and "standalone" are the same) we only
 * add the first one to the locale data arrays, the other ones are only defined when different.
 * We use this function to retrieve the first defined value.
 *
 * @experimental i18n support is experimental.
 */
function getLastDefinedValue(data, index) {
    for (var i = index; i > -1; i--) {
        if (typeof data[i] !== 'undefined') {
            return data[i];
        }
    }
    throw new Error('Locale data API: locale data undefined');
}
/**
 * Extract the hours and minutes from a string like "15:45"
 */
function extractTime(time) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__read"])(time.split(':'), 2), h = _a[0], m = _a[1];
    return { hours: +h, minutes: +m };
}
/**
 * Finds the locale data for a locale id
 *
 * @experimental i18n support is experimental.
 */
function findLocaleData(locale) {
    var normalizedLocale = locale.toLowerCase().replace(/_/g, '-');
    var match = LOCALE_DATA[normalizedLocale];
    if (match) {
        return match;
    }
    // let's try to find a parent locale
    var parentLocale = normalizedLocale.split('-')[0];
    match = LOCALE_DATA[parentLocale];
    if (match) {
        return match;
    }
    if (parentLocale === 'en') {
        return localeEn;
    }
    throw new Error("Missing locale data for the locale \"" + locale + "\".");
}
/**
 * Returns the currency symbol for a given currency code, or the code if no symbol available
 * (e.g.: format narrow = $, format wide = US$, code = USD)
 * If no locale is provided, it uses the locale "en" by default
 *
 * @experimental i18n support is experimental.
 */
function getCurrencySymbol(code, format, locale) {
    if (locale === void 0) {
        locale = 'en';
    }
    var currency = getLocaleCurrencies(locale)[code] || CURRENCIES_EN[code] || [];
    var symbolNarrow = currency[1 /* SymbolNarrow */];
    if (format === 'narrow' && typeof symbolNarrow === 'string') {
        return symbolNarrow;
    }
    return currency[0 /* Symbol */] || code;
}
// Most currencies have cents, that's why the default is 2
var DEFAULT_NB_OF_CURRENCY_DIGITS = 2;
/**
 * Returns the number of decimal digits for the given currency.
 * Its value depends upon the presence of cents in that particular currency.
 *
 * @experimental i18n support is experimental.
 */
function getNumberOfCurrencyDigits(code) {
    var digits;
    var currency = CURRENCIES_EN[code];
    if (currency) {
        digits = currency[2 /* NbOfDigits */];
    }
    return typeof digits === 'number' ? digits : DEFAULT_NB_OF_CURRENCY_DIGITS;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ISO8601_DATE_REGEX = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
//    1        2       3         4          5          6          7          8  9     10      11
var NAMED_FORMATS = {};
var DATE_FORMATS_SPLIT = /((?:[^GyMLwWdEabBhHmsSzZO']+)|(?:'(?:[^']|'')*')|(?:G{1,5}|y{1,4}|M{1,5}|L{1,5}|w{1,2}|W{1}|d{1,2}|E{1,6}|a{1,5}|b{1,5}|B{1,5}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|S{1,3}|z{1,4}|Z{1,5}|O{1,4}))([\s\S]*)/;
var ZoneWidth = /*@__PURE__*/ (function (ZoneWidth) {
    ZoneWidth[ZoneWidth["Short"] = 0] = "Short";
    ZoneWidth[ZoneWidth["ShortGMT"] = 1] = "ShortGMT";
    ZoneWidth[ZoneWidth["Long"] = 2] = "Long";
    ZoneWidth[ZoneWidth["Extended"] = 3] = "Extended";
    return ZoneWidth;
})({});
var DateType = /*@__PURE__*/ (function (DateType) {
    DateType[DateType["FullYear"] = 0] = "FullYear";
    DateType[DateType["Month"] = 1] = "Month";
    DateType[DateType["Date"] = 2] = "Date";
    DateType[DateType["Hours"] = 3] = "Hours";
    DateType[DateType["Minutes"] = 4] = "Minutes";
    DateType[DateType["Seconds"] = 5] = "Seconds";
    DateType[DateType["FractionalSeconds"] = 6] = "FractionalSeconds";
    DateType[DateType["Day"] = 7] = "Day";
    return DateType;
})({});
var TranslationType = /*@__PURE__*/ (function (TranslationType) {
    TranslationType[TranslationType["DayPeriods"] = 0] = "DayPeriods";
    TranslationType[TranslationType["Days"] = 1] = "Days";
    TranslationType[TranslationType["Months"] = 2] = "Months";
    TranslationType[TranslationType["Eras"] = 3] = "Eras";
    return TranslationType;
})({});
/**
 * @ngModule CommonModule
 * @description
 *
 * Formats a date according to locale rules.
 *
 * Where:
 * - `value` is a Date, a number (milliseconds since UTC epoch) or an ISO string
 *   (https://www.w3.org/TR/NOTE-datetime).
 * - `format` indicates which date/time components to include. See {@link DatePipe} for more
 *   details.
 * - `locale` is a `string` defining the locale to use.
 * - `timezone` to be used for formatting. It understands UTC/GMT and the continental US time zone
 *   abbreviations, but for general use, use a time zone offset (e.g. `'+0430'`).
 *   If not specified, host system settings are used.
 *
 * See {@link DatePipe} for more details.
 */
function formatDate(value, format, locale, timezone) {
    var date = toDate(value);
    var namedFormat = getNamedFormat(locale, format);
    format = namedFormat || format;
    var parts = [];
    var match;
    while (format) {
        match = DATE_FORMATS_SPLIT.exec(format);
        if (match) {
            parts = parts.concat(match.slice(1));
            var part = parts.pop();
            if (!part) {
                break;
            }
            format = part;
        }
        else {
            parts.push(format);
            break;
        }
    }
    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
        dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        date = convertTimezoneToLocal(date, timezone, true);
    }
    var text = '';
    parts.forEach(function (value) {
        var dateFormatter = getDateFormatter(value);
        text += dateFormatter ?
            dateFormatter(date, locale, dateTimezoneOffset) :
            value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });
    return text;
}
function getNamedFormat(locale, format) {
    var localeId = getLocaleId(locale);
    NAMED_FORMATS[localeId] = NAMED_FORMATS[localeId] || {};
    if (NAMED_FORMATS[localeId][format]) {
        return NAMED_FORMATS[localeId][format];
    }
    var formatValue = '';
    switch (format) {
        case 'shortDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Short);
            break;
        case 'mediumDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Medium);
            break;
        case 'longDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Long);
            break;
        case 'fullDate':
            formatValue = getLocaleDateFormat(locale, FormatWidth.Full);
            break;
        case 'shortTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Short);
            break;
        case 'mediumTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Medium);
            break;
        case 'longTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Long);
            break;
        case 'fullTime':
            formatValue = getLocaleTimeFormat(locale, FormatWidth.Full);
            break;
        case 'short':
            var shortTime = getNamedFormat(locale, 'shortTime');
            var shortDate = getNamedFormat(locale, 'shortDate');
            formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Short), [shortTime, shortDate]);
            break;
        case 'medium':
            var mediumTime = getNamedFormat(locale, 'mediumTime');
            var mediumDate = getNamedFormat(locale, 'mediumDate');
            formatValue = formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Medium), [mediumTime, mediumDate]);
            break;
        case 'long':
            var longTime = getNamedFormat(locale, 'longTime');
            var longDate = getNamedFormat(locale, 'longDate');
            formatValue =
                formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Long), [longTime, longDate]);
            break;
        case 'full':
            var fullTime = getNamedFormat(locale, 'fullTime');
            var fullDate = getNamedFormat(locale, 'fullDate');
            formatValue =
                formatDateTime(getLocaleDateTimeFormat(locale, FormatWidth.Full), [fullTime, fullDate]);
            break;
    }
    if (formatValue) {
        NAMED_FORMATS[localeId][format] = formatValue;
    }
    return formatValue;
}
function formatDateTime(str, opt_values) {
    if (opt_values) {
        str = str.replace(/\{([^}]+)}/g, function (match, key) {
            return (opt_values != null && key in opt_values) ? opt_values[key] : match;
        });
    }
    return str;
}
function padNumber(num, digits, minusSign, trim, negWrap) {
    if (minusSign === void 0) {
        minusSign = '-';
    }
    var neg = '';
    if (num < 0 || (negWrap && num <= 0)) {
        if (negWrap) {
            num = -num + 1;
        }
        else {
            num = -num;
            neg = minusSign;
        }
    }
    var strNum = String(num);
    while (strNum.length < digits) {
        strNum = '0' + strNum;
    }
    if (trim) {
        strNum = strNum.substr(strNum.length - digits);
    }
    return neg + strNum;
}
function formatFractionalSeconds(milliseconds, digits) {
    var strMs = padNumber(milliseconds, 3);
    return strMs.substr(0, digits);
}
/**
 * Returns a date formatter that transforms a date into its locale digit representation
 */
function dateGetter(name, size, offset, trim, negWrap) {
    if (offset === void 0) {
        offset = 0;
    }
    if (trim === void 0) {
        trim = false;
    }
    if (negWrap === void 0) {
        negWrap = false;
    }
    return function (date, locale) {
        var part = getDatePart(name, date);
        if (offset > 0 || part > -offset) {
            part += offset;
        }
        if (name === DateType.Hours) {
            if (part === 0 && offset === -12) {
                part = 12;
            }
        }
        else if (name === DateType.FractionalSeconds) {
            return formatFractionalSeconds(part, size);
        }
        var localeMinus = getLocaleNumberSymbol(locale, NumberSymbol.MinusSign);
        return padNumber(part, size, localeMinus, trim, negWrap);
    };
}
function getDatePart(part, date) {
    switch (part) {
        case DateType.FullYear:
            return date.getFullYear();
        case DateType.Month:
            return date.getMonth();
        case DateType.Date:
            return date.getDate();
        case DateType.Hours:
            return date.getHours();
        case DateType.Minutes:
            return date.getMinutes();
        case DateType.Seconds:
            return date.getSeconds();
        case DateType.FractionalSeconds:
            return date.getMilliseconds();
        case DateType.Day:
            return date.getDay();
        default:
            throw new Error("Unknown DateType value \"" + part + "\".");
    }
}
/**
 * Returns a date formatter that transforms a date into its locale string representation
 */
function dateStrGetter(name, width, form, extended) {
    if (form === void 0) {
        form = FormStyle.Format;
    }
    if (extended === void 0) {
        extended = false;
    }
    return function (date, locale) {
        return getDateTranslation(date, locale, name, width, form, extended);
    };
}
/**
 * Returns the locale translation of a date for a given form, type and width
 */
function getDateTranslation(date, locale, name, width, form, extended) {
    switch (name) {
        case TranslationType.Months:
            return getLocaleMonthNames(locale, form, width)[date.getMonth()];
        case TranslationType.Days:
            return getLocaleDayNames(locale, form, width)[date.getDay()];
        case TranslationType.DayPeriods:
            var currentHours_1 = date.getHours();
            var currentMinutes_1 = date.getMinutes();
            if (extended) {
                var rules = getLocaleExtraDayPeriodRules(locale);
                var dayPeriods_1 = getLocaleExtraDayPeriods(locale, form, width);
                var result_1;
                rules.forEach(function (rule, index) {
                    if (Array.isArray(rule)) {
                        // morning, afternoon, evening, night
                        var _a = rule[0], hoursFrom = _a.hours, minutesFrom = _a.minutes;
                        var _b = rule[1], hoursTo = _b.hours, minutesTo = _b.minutes;
                        if (currentHours_1 >= hoursFrom && currentMinutes_1 >= minutesFrom &&
                            (currentHours_1 < hoursTo ||
                                (currentHours_1 === hoursTo && currentMinutes_1 < minutesTo))) {
                            result_1 = dayPeriods_1[index];
                        }
                    }
                    else {
                        var hours = rule.hours, minutes = rule.minutes;
                        if (hours === currentHours_1 && minutes === currentMinutes_1) {
                            result_1 = dayPeriods_1[index];
                        }
                    }
                });
                if (result_1) {
                    return result_1;
                }
            }
            // if no rules for the day periods, we use am/pm by default
            return getLocaleDayPeriods(locale, form, width)[currentHours_1 < 12 ? 0 : 1];
        case TranslationType.Eras:
            return getLocaleEraNames(locale, width)[date.getFullYear() <= 0 ? 0 : 1];
        default:
            // This default case is not needed by TypeScript compiler, as the switch is exhaustive.
            // However Closure Compiler does not understand that and reports an error in typed mode.
            // The `throw new Error` below works around the problem, and the unexpected: never variable
            // makes sure tsc still checks this code is unreachable.
            var unexpected = name;
            throw new Error("unexpected translation type " + unexpected);
    }
}
/**
 * Returns a date formatter that transforms a date and an offset into a timezone with ISO8601 or
 * GMT format depending on the width (eg: short = +0430, short:GMT = GMT+4, long = GMT+04:30,
 * extended = +04:30)
 */
function timeZoneGetter(width) {
    return function (date, locale, offset) {
        var zone = -1 * offset;
        var minusSign = getLocaleNumberSymbol(locale, NumberSymbol.MinusSign);
        var hours = zone > 0 ? Math.floor(zone / 60) : Math.ceil(zone / 60);
        switch (width) {
            case ZoneWidth.Short:
                return ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) +
                    padNumber(Math.abs(zone % 60), 2, minusSign);
            case ZoneWidth.ShortGMT:
                return 'GMT' + ((zone >= 0) ? '+' : '') + padNumber(hours, 1, minusSign);
            case ZoneWidth.Long:
                return 'GMT' + ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) + ':' +
                    padNumber(Math.abs(zone % 60), 2, minusSign);
            case ZoneWidth.Extended:
                if (offset === 0) {
                    return 'Z';
                }
                else {
                    return ((zone >= 0) ? '+' : '') + padNumber(hours, 2, minusSign) + ':' +
                        padNumber(Math.abs(zone % 60), 2, minusSign);
                }
            default:
                throw new Error("Unknown zone width \"" + width + "\"");
        }
    };
}
var JANUARY = 0;
var THURSDAY = 4;
function getFirstThursdayOfYear(year) {
    var firstDayOfYear = (new Date(year, JANUARY, 1)).getDay();
    return new Date(year, 0, 1 + ((firstDayOfYear <= THURSDAY) ? THURSDAY : THURSDAY + 7) - firstDayOfYear);
}
function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate() + (THURSDAY - datetime.getDay()));
}
function weekGetter(size, monthBased) {
    if (monthBased === void 0) {
        monthBased = false;
    }
    return function (date, locale) {
        var result;
        if (monthBased) {
            var nbDaysBefore1stDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1).getDay() - 1;
            var today = date.getDate();
            result = 1 + Math.floor((today + nbDaysBefore1stDayOfMonth) / 7);
        }
        else {
            var firstThurs = getFirstThursdayOfYear(date.getFullYear());
            var thisThurs = getThursdayThisWeek(date);
            var diff = thisThurs.getTime() - firstThurs.getTime();
            result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
        }
        return padNumber(result, size, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
    };
}
var DATE_FORMATS = {};
// Based on CLDR formats:
// See complete list: http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
// See also explanations: http://cldr.unicode.org/translation/date-time
// TODO(ocombe): support all missing cldr formats: Y, U, Q, D, F, e, c, j, J, C, A, v, V, X, x
function getDateFormatter(format) {
    if (DATE_FORMATS[format]) {
        return DATE_FORMATS[format];
    }
    var formatter;
    switch (format) {
        // Era name (AD/BC)
        case 'G':
        case 'GG':
        case 'GGG':
            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Abbreviated);
            break;
        case 'GGGG':
            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Wide);
            break;
        case 'GGGGG':
            formatter = dateStrGetter(TranslationType.Eras, TranslationWidth.Narrow);
            break;
        // 1 digit representation of the year, e.g. (AD 1 => 1, AD 199 => 199)
        case 'y':
            formatter = dateGetter(DateType.FullYear, 1, 0, false, true);
            break;
        // 2 digit representation of the year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
        case 'yy':
            formatter = dateGetter(DateType.FullYear, 2, 0, true, true);
            break;
        // 3 digit representation of the year, padded (000-999). (e.g. AD 2001 => 01, AD 2010 => 10)
        case 'yyy':
            formatter = dateGetter(DateType.FullYear, 3, 0, false, true);
            break;
        // 4 digit representation of the year (e.g. AD 1 => 0001, AD 2010 => 2010)
        case 'yyyy':
            formatter = dateGetter(DateType.FullYear, 4, 0, false, true);
            break;
        // Month of the year (1-12), numeric
        case 'M':
        case 'L':
            formatter = dateGetter(DateType.Month, 1, 1);
            break;
        case 'MM':
        case 'LL':
            formatter = dateGetter(DateType.Month, 2, 1);
            break;
        // Month of the year (January, ...), string, format
        case 'MMM':
            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Abbreviated);
            break;
        case 'MMMM':
            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Wide);
            break;
        case 'MMMMM':
            formatter = dateStrGetter(TranslationType.Months, TranslationWidth.Narrow);
            break;
        // Month of the year (January, ...), string, standalone
        case 'LLL':
            formatter =
                dateStrGetter(TranslationType.Months, TranslationWidth.Abbreviated, FormStyle.Standalone);
            break;
        case 'LLLL':
            formatter =
                dateStrGetter(TranslationType.Months, TranslationWidth.Wide, FormStyle.Standalone);
            break;
        case 'LLLLL':
            formatter =
                dateStrGetter(TranslationType.Months, TranslationWidth.Narrow, FormStyle.Standalone);
            break;
        // Week of the year (1, ... 52)
        case 'w':
            formatter = weekGetter(1);
            break;
        case 'ww':
            formatter = weekGetter(2);
            break;
        // Week of the month (1, ...)
        case 'W':
            formatter = weekGetter(1, true);
            break;
        // Day of the month (1-31)
        case 'd':
            formatter = dateGetter(DateType.Date, 1);
            break;
        case 'dd':
            formatter = dateGetter(DateType.Date, 2);
            break;
        // Day of the Week
        case 'E':
        case 'EE':
        case 'EEE':
            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Abbreviated);
            break;
        case 'EEEE':
            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Wide);
            break;
        case 'EEEEE':
            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Narrow);
            break;
        case 'EEEEEE':
            formatter = dateStrGetter(TranslationType.Days, TranslationWidth.Short);
            break;
        // Generic period of the day (am-pm)
        case 'a':
        case 'aa':
        case 'aaa':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated);
            break;
        case 'aaaa':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide);
            break;
        case 'aaaaa':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow);
            break;
        // Extended period of the day (midnight, at night, ...), standalone
        case 'b':
        case 'bb':
        case 'bbb':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated, FormStyle.Standalone, true);
            break;
        case 'bbbb':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide, FormStyle.Standalone, true);
            break;
        case 'bbbbb':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow, FormStyle.Standalone, true);
            break;
        // Extended period of the day (midnight, night, ...), standalone
        case 'B':
        case 'BB':
        case 'BBB':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Abbreviated, FormStyle.Format, true);
            break;
        case 'BBBB':
            formatter =
                dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Wide, FormStyle.Format, true);
            break;
        case 'BBBBB':
            formatter = dateStrGetter(TranslationType.DayPeriods, TranslationWidth.Narrow, FormStyle.Format, true);
            break;
        // Hour in AM/PM, (1-12)
        case 'h':
            formatter = dateGetter(DateType.Hours, 1, -12);
            break;
        case 'hh':
            formatter = dateGetter(DateType.Hours, 2, -12);
            break;
        // Hour of the day (0-23)
        case 'H':
            formatter = dateGetter(DateType.Hours, 1);
            break;
        // Hour in day, padded (00-23)
        case 'HH':
            formatter = dateGetter(DateType.Hours, 2);
            break;
        // Minute of the hour (0-59)
        case 'm':
            formatter = dateGetter(DateType.Minutes, 1);
            break;
        case 'mm':
            formatter = dateGetter(DateType.Minutes, 2);
            break;
        // Second of the minute (0-59)
        case 's':
            formatter = dateGetter(DateType.Seconds, 1);
            break;
        case 'ss':
            formatter = dateGetter(DateType.Seconds, 2);
            break;
        // Fractional second
        case 'S':
            formatter = dateGetter(DateType.FractionalSeconds, 1);
            break;
        case 'SS':
            formatter = dateGetter(DateType.FractionalSeconds, 2);
            break;
        case 'SSS':
            formatter = dateGetter(DateType.FractionalSeconds, 3);
            break;
        // Timezone ISO8601 short format (-0430)
        case 'Z':
        case 'ZZ':
        case 'ZZZ':
            formatter = timeZoneGetter(ZoneWidth.Short);
            break;
        // Timezone ISO8601 extended format (-04:30)
        case 'ZZZZZ':
            formatter = timeZoneGetter(ZoneWidth.Extended);
            break;
        // Timezone GMT short format (GMT+4)
        case 'O':
        case 'OO':
        case 'OOO':
        // Should be location, but fallback to format O instead because we don't have the data yet
        case 'z':
        case 'zz':
        case 'zzz':
            formatter = timeZoneGetter(ZoneWidth.ShortGMT);
            break;
        // Timezone GMT long format (GMT+0430)
        case 'OOOO':
        case 'ZZZZ':
        // Should be location, but fallback to format O instead because we don't have the data yet
        case 'zzzz':
            formatter = timeZoneGetter(ZoneWidth.Long);
            break;
        default:
            return null;
    }
    DATE_FORMATS[format] = formatter;
    return formatter;
}
function timezoneToOffset(timezone, fallback) {
    // Support: IE 9-11 only, Edge 13-15+
    // IE/Edge do not "understand" colon (`:`) in timezone
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}
function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
}
function convertTimezoneToLocal(date, timezone, reverse) {
    var reverseValue = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverseValue * (timezoneOffset - dateTimezoneOffset));
}
/**
 * Converts a value to date.
 *
 * Supported input formats:
 * - `Date`
 * - number: timestamp
 * - string: numeric (e.g. "1234"), ISO and date strings in a format supported by
 *   [Date.parse()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse).
 *   Note: ISO strings without time return a date without timeoffset.
 *
 * Throws if unable to convert to a date.
 */
function toDate(value) {
    if (isDate(value)) {
        return value;
    }
    if (typeof value === 'number' && !isNaN(value)) {
        return new Date(value);
    }
    if (typeof value === 'string') {
        value = value.trim();
        var parsedNb = parseFloat(value);
        // any string that only contains numbers, like "1234" but not like "1234hello"
        if (!isNaN(value - parsedNb)) {
            return new Date(parsedNb);
        }
        if (/^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
            /* For ISO Strings without time the day, month and year must be extracted from the ISO String
            before Date creation to avoid time offset and errors in the new Date.
            If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
            date, some browsers (e.g. IE 9) will throw an invalid Date error.
            If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the timeoffset
            is applied.
            Note: ISO months are 0 for January, 1 for February, ... */
            var _a = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__read"])(value.split('-').map(function (val) { return +val; }), 3), y = _a[0], m = _a[1], d = _a[2];
            return new Date(y, m - 1, d);
        }
        var match = void 0;
        if (match = value.match(ISO8601_DATE_REGEX)) {
            return isoStringToDate(match);
        }
    }
    var date = new Date(value);
    if (!isDate(date)) {
        throw new Error("Unable to convert \"" + value + "\" into a date");
    }
    return date;
}
/**
 * Converts a date in ISO8601 to a Date.
 * Used instead of `Date.parse` because of browser discrepancies.
 */
function isoStringToDate(match) {
    var date = new Date(0);
    var tzHour = 0;
    var tzMin = 0;
    // match[8] means that the string contains "Z" (UTC) or a timezone like "+01:00" or "+0100"
    var dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
    var timeSetter = match[8] ? date.setUTCHours : date.setHours;
    // if there is a timezone defined like "+01:00" or "+0100"
    if (match[9]) {
        tzHour = Number(match[9] + match[10]);
        tzMin = Number(match[9] + match[11]);
    }
    dateSetter.call(date, Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    var h = Number(match[4] || 0) - tzHour;
    var m = Number(match[5] || 0) - tzMin;
    var s = Number(match[6] || 0);
    var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
    timeSetter.call(date, h, m, s, ms);
    return date;
}
function isDate(value) {
    return value instanceof Date && !isNaN(value.valueOf());
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(-(\d+))?)?$/;
var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';
var PATTERN_SEP = ';';
var GROUP_SEP = ',';
var DIGIT_CHAR = '#';
var CURRENCY_CHAR = '¤';
var PERCENT_CHAR = '%';
/**
 * Transforms a number to a locale string based on a style and a format
 */
function formatNumberToLocaleString(value, pattern, locale, groupSymbol, decimalSymbol, digitsInfo, isPercent) {
    if (isPercent === void 0) {
        isPercent = false;
    }
    var formattedText = '';
    var isZero = false;
    if (!isFinite(value)) {
        formattedText = getLocaleNumberSymbol(locale, NumberSymbol.Infinity);
    }
    else {
        var parsedNumber = parseNumber(value);
        if (isPercent) {
            parsedNumber = toPercent(parsedNumber);
        }
        var minInt = pattern.minInt;
        var minFraction = pattern.minFrac;
        var maxFraction = pattern.maxFrac;
        if (digitsInfo) {
            var parts = digitsInfo.match(NUMBER_FORMAT_REGEXP);
            if (parts === null) {
                throw new Error(digitsInfo + " is not a valid digit info");
            }
            var minIntPart = parts[1];
            var minFractionPart = parts[3];
            var maxFractionPart = parts[5];
            if (minIntPart != null) {
                minInt = parseIntAutoRadix(minIntPart);
            }
            if (minFractionPart != null) {
                minFraction = parseIntAutoRadix(minFractionPart);
            }
            if (maxFractionPart != null) {
                maxFraction = parseIntAutoRadix(maxFractionPart);
            }
            else if (minFractionPart != null && minFraction > maxFraction) {
                maxFraction = minFraction;
            }
        }
        roundNumber(parsedNumber, minFraction, maxFraction);
        var digits = parsedNumber.digits;
        var integerLen = parsedNumber.integerLen;
        var exponent = parsedNumber.exponent;
        var decimals = [];
        isZero = digits.every(function (d) { return !d; });
        // pad zeros for small numbers
        for (; integerLen < minInt; integerLen++) {
            digits.unshift(0);
        }
        // pad zeros for small numbers
        for (; integerLen < 0; integerLen++) {
            digits.unshift(0);
        }
        // extract decimals digits
        if (integerLen > 0) {
            decimals = digits.splice(integerLen, digits.length);
        }
        else {
            decimals = digits;
            digits = [0];
        }
        // format the integer digits with grouping separators
        var groups = [];
        if (digits.length >= pattern.lgSize) {
            groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
        }
        while (digits.length > pattern.gSize) {
            groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
        }
        if (digits.length) {
            groups.unshift(digits.join(''));
        }
        formattedText = groups.join(getLocaleNumberSymbol(locale, groupSymbol));
        // append the decimal digits
        if (decimals.length) {
            formattedText += getLocaleNumberSymbol(locale, decimalSymbol) + decimals.join('');
        }
        if (exponent) {
            formattedText += getLocaleNumberSymbol(locale, NumberSymbol.Exponential) + '+' + exponent;
        }
    }
    if (value < 0 && !isZero) {
        formattedText = pattern.negPre + formattedText + pattern.negSuf;
    }
    else {
        formattedText = pattern.posPre + formattedText + pattern.posSuf;
    }
    return formattedText;
}
/**
 * @ngModule CommonModule
 * @description
 *
 * Formats a number as currency using locale rules.
 *
 * Use `currency` to format a number as currency.
 *
 * Where:
 * - `value` is a number.
 * - `locale` is a `string` defining the locale to use.
 * - `currency` is the string that represents the currency, it can be its symbol or its name.
 * - `currencyCode` is the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code, such
 *    as `USD` for the US dollar and `EUR` for the euro.
 * - `digitInfo` See {@link DecimalPipe} for more details.
 *
 *
 */
function formatCurrency(value, locale, currency, currencyCode, digitsInfo) {
    var format = getLocaleNumberFormat(locale, NumberFormatStyle.Currency);
    var pattern = parseNumberFormat(format, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
    pattern.minFrac = getNumberOfCurrencyDigits(currencyCode);
    pattern.maxFrac = pattern.minFrac;
    var res = formatNumberToLocaleString(value, pattern, locale, NumberSymbol.CurrencyGroup, NumberSymbol.CurrencyDecimal, digitsInfo);
    return res
        .replace(CURRENCY_CHAR, currency)
        .replace(CURRENCY_CHAR, '');
}
/**
 * @ngModule CommonModule
 * @description
 *
 * Formats a number as a percentage according to locale rules.
 *
 * Where:
 * - `value` is a number.
 * - `locale` is a `string` defining the locale to use.
 * - `digitInfo` See {@link DecimalPipe} for more details.
 *
 *
 */
function formatPercent(value, locale, digitsInfo) {
    var format = getLocaleNumberFormat(locale, NumberFormatStyle.Percent);
    var pattern = parseNumberFormat(format, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
    var res = formatNumberToLocaleString(value, pattern, locale, NumberSymbol.Group, NumberSymbol.Decimal, digitsInfo, true);
    return res.replace(new RegExp(PERCENT_CHAR, 'g'), getLocaleNumberSymbol(locale, NumberSymbol.PercentSign));
}
/**
 * @ngModule CommonModule
 * @description
 *
 * Formats a number as text. Group sizing and separator and other locale-specific
 * configurations are based on the locale.
 *
 * Where:
 * - `value` is a number.
 * - `locale` is a `string` defining the locale to use.
 * - `digitInfo` See {@link DecimalPipe} for more details.
 *
 *
 */
function formatNumber(value, locale, digitsInfo) {
    var format = getLocaleNumberFormat(locale, NumberFormatStyle.Decimal);
    var pattern = parseNumberFormat(format, getLocaleNumberSymbol(locale, NumberSymbol.MinusSign));
    return formatNumberToLocaleString(value, pattern, locale, NumberSymbol.Group, NumberSymbol.Decimal, digitsInfo);
}
function parseNumberFormat(format, minusSign) {
    if (minusSign === void 0) {
        minusSign = '-';
    }
    var p = {
        minInt: 1,
        minFrac: 0,
        maxFrac: 0,
        posPre: '',
        posSuf: '',
        negPre: '',
        negSuf: '',
        gSize: 0,
        lgSize: 0
    };
    var patternParts = format.split(PATTERN_SEP);
    var positive = patternParts[0];
    var negative = patternParts[1];
    var positiveParts = positive.indexOf(DECIMAL_SEP) !== -1 ?
        positive.split(DECIMAL_SEP) :
        [
            positive.substring(0, positive.lastIndexOf(ZERO_CHAR) + 1),
            positive.substring(positive.lastIndexOf(ZERO_CHAR) + 1)
        ], integer = positiveParts[0], fraction = positiveParts[1] || '';
    p.posPre = integer.substr(0, integer.indexOf(DIGIT_CHAR));
    for (var i = 0; i < fraction.length; i++) {
        var ch = fraction.charAt(i);
        if (ch === ZERO_CHAR) {
            p.minFrac = p.maxFrac = i + 1;
        }
        else if (ch === DIGIT_CHAR) {
            p.maxFrac = i + 1;
        }
        else {
            p.posSuf += ch;
        }
    }
    var groups = integer.split(GROUP_SEP);
    p.gSize = groups[1] ? groups[1].length : 0;
    p.lgSize = (groups[2] || groups[1]) ? (groups[2] || groups[1]).length : 0;
    if (negative) {
        var trunkLen = positive.length - p.posPre.length - p.posSuf.length, pos = negative.indexOf(DIGIT_CHAR);
        p.negPre = negative.substr(0, pos).replace(/'/g, '');
        p.negSuf = negative.substr(pos + trunkLen).replace(/'/g, '');
    }
    else {
        p.negPre = minusSign + p.posPre;
        p.negSuf = p.posSuf;
    }
    return p;
}
// Transforms a parsed number into a percentage by multiplying it by 100
function toPercent(parsedNumber) {
    // if the number is 0, don't do anything
    if (parsedNumber.digits[0] === 0) {
        return parsedNumber;
    }
    // Getting the current number of decimals
    var fractionLen = parsedNumber.digits.length - parsedNumber.integerLen;
    if (parsedNumber.exponent) {
        parsedNumber.exponent += 2;
    }
    else {
        if (fractionLen === 0) {
            parsedNumber.digits.push(0, 0);
        }
        else if (fractionLen === 1) {
            parsedNumber.digits.push(0);
        }
        parsedNumber.integerLen += 2;
    }
    return parsedNumber;
}
/**
 * Parses a number.
 * Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/
 */
function parseNumber(num) {
    var numStr = Math.abs(num) + '';
    var exponent = 0, digits, integerLen;
    var i, j, zeros;
    // Decimal point?
    if ((integerLen = numStr.indexOf(DECIMAL_SEP)) > -1) {
        numStr = numStr.replace(DECIMAL_SEP, '');
    }
    // Exponential form?
    if ((i = numStr.search(/e/i)) > 0) {
        // Work out the exponent.
        if (integerLen < 0)
            integerLen = i;
        integerLen += +numStr.slice(i + 1);
        numStr = numStr.substring(0, i);
    }
    else if (integerLen < 0) {
        // There was no decimal point or exponent so it is an integer.
        integerLen = numStr.length;
    }
    // Count the number of leading zeros.
    for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) {
    }
    if (i === (zeros = numStr.length)) {
        // The digits are all zero.
        digits = [0];
        integerLen = 1;
    }
    else {
        // Count the number of trailing zeros
        zeros--;
        while (numStr.charAt(zeros) === ZERO_CHAR)
            zeros--;
        // Trailing zeros are insignificant so ignore them
        integerLen -= i;
        digits = [];
        // Convert string to array of digits without leading/trailing zeros.
        for (j = 0; i <= zeros; i++, j++) {
            digits[j] = Number(numStr.charAt(i));
        }
    }
    // If the number overflows the maximum allowed digits then use an exponent.
    if (integerLen > MAX_DIGITS) {
        digits = digits.splice(0, MAX_DIGITS - 1);
        exponent = integerLen - 1;
        integerLen = 1;
    }
    return { digits: digits, exponent: exponent, integerLen: integerLen };
}
/**
 * Round the parsed number to the specified number of decimal places
 * This function changes the parsedNumber in-place
 */
function roundNumber(parsedNumber, minFrac, maxFrac) {
    if (minFrac > maxFrac) {
        throw new Error("The minimum number of digits after fraction (" + minFrac + ") is higher than the maximum (" + maxFrac + ").");
    }
    var digits = parsedNumber.digits;
    var fractionLen = digits.length - parsedNumber.integerLen;
    var fractionSize = Math.min(Math.max(minFrac, fractionLen), maxFrac);
    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.integerLen;
    var digit = digits[roundAt];
    if (roundAt > 0) {
        // Drop fractional digits beyond `roundAt`
        digits.splice(Math.max(parsedNumber.integerLen, roundAt));
        // Set non-fractional digits beyond `roundAt` to 0
        for (var j = roundAt; j < digits.length; j++) {
            digits[j] = 0;
        }
    }
    else {
        // We rounded to zero so reset the parsedNumber
        fractionLen = Math.max(0, fractionLen);
        parsedNumber.integerLen = 1;
        digits.length = Math.max(1, roundAt = fractionSize + 1);
        digits[0] = 0;
        for (var i = 1; i < roundAt; i++)
            digits[i] = 0;
    }
    if (digit >= 5) {
        if (roundAt - 1 < 0) {
            for (var k = 0; k > roundAt; k--) {
                digits.unshift(0);
                parsedNumber.integerLen++;
            }
            digits.unshift(1);
            parsedNumber.integerLen++;
        }
        else {
            digits[roundAt - 1]++;
        }
    }
    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++)
        digits.push(0);
    var dropTrailingZeros = fractionSize !== 0;
    // Minimal length = nb of decimals required + current nb of integers
    // Any number besides that is optional and can be removed if it's a trailing 0
    var minLen = minFrac + parsedNumber.integerLen;
    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function (carry, d, i, digits) {
        d = d + carry;
        digits[i] = d < 10 ? d : d - 10; // d % 10
        if (dropTrailingZeros) {
            // Do not keep meaningless fractional trailing zeros (e.g. 15.52000 --> 15.52)
            if (digits[i] === 0 && i >= minLen) {
                digits.pop();
            }
            else {
                dropTrailingZeros = false;
            }
        }
        return d >= 10 ? 1 : 0; // Math.floor(d / 10);
    }, 0);
    if (carry) {
        digits.unshift(carry);
        parsedNumber.integerLen++;
    }
}
function parseIntAutoRadix(text) {
    var result = parseInt(text);
    if (isNaN(result)) {
        throw new Error('Invalid integer literal when parsing ' + text);
    }
    return result;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @deprecated from v5
 */
var DEPRECATED_PLURAL_FN = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('UseV4Plurals');
/**
 * @experimental
 */
var NgLocalization = /*@__PURE__*/ (function () {
    function NgLocalization() {
    }
    return NgLocalization;
}());
/**
 * Returns the plural category for a given value.
 * - "=value" when the case exists,
 * - the plural category otherwise
 */
function getPluralCategory(value, cases, ngLocalization, locale) {
    var key = "=" + value;
    if (cases.indexOf(key) > -1) {
        return key;
    }
    key = ngLocalization.getPluralCategory(value, locale);
    if (cases.indexOf(key) > -1) {
        return key;
    }
    if (cases.indexOf('other') > -1) {
        return 'other';
    }
    throw new Error("No plural message found for value \"" + value + "\"");
}
/**
 * Returns the plural case based on the locale
 *
 * @experimental
 */
var NgLocaleLocalization = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(NgLocaleLocalization, _super);
    function NgLocaleLocalization(locale, 
    /** @deprecated from v5 */
    deprecatedPluralFn) {
        var _this = _super.call(this) || this;
        _this.locale = locale;
        _this.deprecatedPluralFn = deprecatedPluralFn;
        return _this;
    }
    NgLocaleLocalization.prototype.getPluralCategory = function (value, locale) {
        var plural = this.deprecatedPluralFn ? this.deprecatedPluralFn(locale || this.locale, value) :
            getLocalePluralCase(locale || this.locale)(value);
        switch (plural) {
            case Plural.Zero:
                return 'zero';
            case Plural.One:
                return 'one';
            case Plural.Two:
                return 'two';
            case Plural.Few:
                return 'few';
            case Plural.Many:
                return 'many';
            default:
                return 'other';
        }
    };
    NgLocaleLocalization = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"])),
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(DEPRECATED_PLURAL_FN))
    ], NgLocaleLocalization);
    return NgLocaleLocalization;
}(NgLocalization));
/**
 * Returns the plural case based on the locale
 *
 * @deprecated from v5 the plural case function is in locale data files common/locales/*.ts
 * @experimental
 */
function getPluralCase(locale, nLike) {
    // TODO(vicb): lazy compute
    if (typeof nLike === 'string') {
        nLike = parseInt(nLike, 10);
    }
    var n = nLike;
    var nDecimal = n.toString().replace(/^[^.]*\.?/, '');
    var i = Math.floor(Math.abs(n));
    var v = nDecimal.length;
    var f = parseInt(nDecimal, 10);
    var t = parseInt(n.toString().replace(/^[^.]*\.?|0+$/g, ''), 10) || 0;
    var lang = locale.split('-')[0].toLowerCase();
    switch (lang) {
        case 'af':
        case 'asa':
        case 'az':
        case 'bem':
        case 'bez':
        case 'bg':
        case 'brx':
        case 'ce':
        case 'cgg':
        case 'chr':
        case 'ckb':
        case 'ee':
        case 'el':
        case 'eo':
        case 'es':
        case 'eu':
        case 'fo':
        case 'fur':
        case 'gsw':
        case 'ha':
        case 'haw':
        case 'hu':
        case 'jgo':
        case 'jmc':
        case 'ka':
        case 'kk':
        case 'kkj':
        case 'kl':
        case 'ks':
        case 'ksb':
        case 'ky':
        case 'lb':
        case 'lg':
        case 'mas':
        case 'mgo':
        case 'ml':
        case 'mn':
        case 'nb':
        case 'nd':
        case 'ne':
        case 'nn':
        case 'nnh':
        case 'nyn':
        case 'om':
        case 'or':
        case 'os':
        case 'ps':
        case 'rm':
        case 'rof':
        case 'rwk':
        case 'saq':
        case 'seh':
        case 'sn':
        case 'so':
        case 'sq':
        case 'ta':
        case 'te':
        case 'teo':
        case 'tk':
        case 'tr':
        case 'ug':
        case 'uz':
        case 'vo':
        case 'vun':
        case 'wae':
        case 'xog':
            if (n === 1)
                return Plural.One;
            return Plural.Other;
        case 'ak':
        case 'ln':
        case 'mg':
        case 'pa':
        case 'ti':
            if (n === Math.floor(n) && n >= 0 && n <= 1)
                return Plural.One;
            return Plural.Other;
        case 'am':
        case 'as':
        case 'bn':
        case 'fa':
        case 'gu':
        case 'hi':
        case 'kn':
        case 'mr':
        case 'zu':
            if (i === 0 || n === 1)
                return Plural.One;
            return Plural.Other;
        case 'ar':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 3 && n % 100 <= 10)
                return Plural.Few;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 99)
                return Plural.Many;
            return Plural.Other;
        case 'ast':
        case 'ca':
        case 'de':
        case 'en':
        case 'et':
        case 'fi':
        case 'fy':
        case 'gl':
        case 'it':
        case 'nl':
        case 'sv':
        case 'sw':
        case 'ur':
        case 'yi':
            if (i === 1 && v === 0)
                return Plural.One;
            return Plural.Other;
        case 'be':
            if (n % 10 === 1 && !(n % 100 === 11))
                return Plural.One;
            if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 4 &&
                !(n % 100 >= 12 && n % 100 <= 14))
                return Plural.Few;
            if (n % 10 === 0 || n % 10 === Math.floor(n % 10) && n % 10 >= 5 && n % 10 <= 9 ||
                n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'br':
            if (n % 10 === 1 && !(n % 100 === 11 || n % 100 === 71 || n % 100 === 91))
                return Plural.One;
            if (n % 10 === 2 && !(n % 100 === 12 || n % 100 === 72 || n % 100 === 92))
                return Plural.Two;
            if (n % 10 === Math.floor(n % 10) && (n % 10 >= 3 && n % 10 <= 4 || n % 10 === 9) &&
                !(n % 100 >= 10 && n % 100 <= 19 || n % 100 >= 70 && n % 100 <= 79 ||
                    n % 100 >= 90 && n % 100 <= 99))
                return Plural.Few;
            if (!(n === 0) && n % 1e6 === 0)
                return Plural.Many;
            return Plural.Other;
        case 'bs':
        case 'hr':
        case 'sr':
            if (v === 0 && i % 10 === 1 && !(i % 100 === 11) || f % 10 === 1 && !(f % 100 === 11))
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14) ||
                f % 10 === Math.floor(f % 10) && f % 10 >= 2 && f % 10 <= 4 &&
                    !(f % 100 >= 12 && f % 100 <= 14))
                return Plural.Few;
            return Plural.Other;
        case 'cs':
        case 'sk':
            if (i === 1 && v === 0)
                return Plural.One;
            if (i === Math.floor(i) && i >= 2 && i <= 4 && v === 0)
                return Plural.Few;
            if (!(v === 0))
                return Plural.Many;
            return Plural.Other;
        case 'cy':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n === 3)
                return Plural.Few;
            if (n === 6)
                return Plural.Many;
            return Plural.Other;
        case 'da':
            if (n === 1 || !(t === 0) && (i === 0 || i === 1))
                return Plural.One;
            return Plural.Other;
        case 'dsb':
        case 'hsb':
            if (v === 0 && i % 100 === 1 || f % 100 === 1)
                return Plural.One;
            if (v === 0 && i % 100 === 2 || f % 100 === 2)
                return Plural.Two;
            if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 ||
                f % 100 === Math.floor(f % 100) && f % 100 >= 3 && f % 100 <= 4)
                return Plural.Few;
            return Plural.Other;
        case 'ff':
        case 'fr':
        case 'hy':
        case 'kab':
            if (i === 0 || i === 1)
                return Plural.One;
            return Plural.Other;
        case 'fil':
            if (v === 0 && (i === 1 || i === 2 || i === 3) ||
                v === 0 && !(i % 10 === 4 || i % 10 === 6 || i % 10 === 9) ||
                !(v === 0) && !(f % 10 === 4 || f % 10 === 6 || f % 10 === 9))
                return Plural.One;
            return Plural.Other;
        case 'ga':
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n === Math.floor(n) && n >= 3 && n <= 6)
                return Plural.Few;
            if (n === Math.floor(n) && n >= 7 && n <= 10)
                return Plural.Many;
            return Plural.Other;
        case 'gd':
            if (n === 1 || n === 11)
                return Plural.One;
            if (n === 2 || n === 12)
                return Plural.Two;
            if (n === Math.floor(n) && (n >= 3 && n <= 10 || n >= 13 && n <= 19))
                return Plural.Few;
            return Plural.Other;
        case 'gv':
            if (v === 0 && i % 10 === 1)
                return Plural.One;
            if (v === 0 && i % 10 === 2)
                return Plural.Two;
            if (v === 0 &&
                (i % 100 === 0 || i % 100 === 20 || i % 100 === 40 || i % 100 === 60 || i % 100 === 80))
                return Plural.Few;
            if (!(v === 0))
                return Plural.Many;
            return Plural.Other;
        case 'he':
            if (i === 1 && v === 0)
                return Plural.One;
            if (i === 2 && v === 0)
                return Plural.Two;
            if (v === 0 && !(n >= 0 && n <= 10) && n % 10 === 0)
                return Plural.Many;
            return Plural.Other;
        case 'is':
            if (t === 0 && i % 10 === 1 && !(i % 100 === 11) || !(t === 0))
                return Plural.One;
            return Plural.Other;
        case 'ksh':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            return Plural.Other;
        case 'kw':
        case 'naq':
        case 'se':
        case 'smn':
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            return Plural.Other;
        case 'lag':
            if (n === 0)
                return Plural.Zero;
            if ((i === 0 || i === 1) && !(n === 0))
                return Plural.One;
            return Plural.Other;
        case 'lt':
            if (n % 10 === 1 && !(n % 100 >= 11 && n % 100 <= 19))
                return Plural.One;
            if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 9 &&
                !(n % 100 >= 11 && n % 100 <= 19))
                return Plural.Few;
            if (!(f === 0))
                return Plural.Many;
            return Plural.Other;
        case 'lv':
        case 'prg':
            if (n % 10 === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19 ||
                v === 2 && f % 100 === Math.floor(f % 100) && f % 100 >= 11 && f % 100 <= 19)
                return Plural.Zero;
            if (n % 10 === 1 && !(n % 100 === 11) || v === 2 && f % 10 === 1 && !(f % 100 === 11) ||
                !(v === 2) && f % 10 === 1)
                return Plural.One;
            return Plural.Other;
        case 'mk':
            if (v === 0 && i % 10 === 1 || f % 10 === 1)
                return Plural.One;
            return Plural.Other;
        case 'mt':
            if (n === 1)
                return Plural.One;
            if (n === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 2 && n % 100 <= 10)
                return Plural.Few;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19)
                return Plural.Many;
            return Plural.Other;
        case 'pl':
            if (i === 1 && v === 0)
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14))
                return Plural.Few;
            if (v === 0 && !(i === 1) && i % 10 === Math.floor(i % 10) && i % 10 >= 0 && i % 10 <= 1 ||
                v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
                v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 12 && i % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'pt':
            if (n === Math.floor(n) && n >= 0 && n <= 2 && !(n === 2))
                return Plural.One;
            return Plural.Other;
        case 'ro':
            if (i === 1 && v === 0)
                return Plural.One;
            if (!(v === 0) || n === 0 ||
                !(n === 1) && n % 100 === Math.floor(n % 100) && n % 100 >= 1 && n % 100 <= 19)
                return Plural.Few;
            return Plural.Other;
        case 'ru':
        case 'uk':
            if (v === 0 && i % 10 === 1 && !(i % 100 === 11))
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14))
                return Plural.Few;
            if (v === 0 && i % 10 === 0 ||
                v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
                v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 11 && i % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'shi':
            if (i === 0 || n === 1)
                return Plural.One;
            if (n === Math.floor(n) && n >= 2 && n <= 10)
                return Plural.Few;
            return Plural.Other;
        case 'si':
            if (n === 0 || n === 1 || i === 0 && f === 1)
                return Plural.One;
            return Plural.Other;
        case 'sl':
            if (v === 0 && i % 100 === 1)
                return Plural.One;
            if (v === 0 && i % 100 === 2)
                return Plural.Two;
            if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 || !(v === 0))
                return Plural.Few;
            return Plural.Other;
        case 'tzm':
            if (n === Math.floor(n) && n >= 0 && n <= 1 || n === Math.floor(n) && n >= 11 && n <= 99)
                return Plural.One;
            return Plural.Other;
        // When there is no specification, the default is always "other"
        // Spec: http://cldr.unicode.org/index/cldr-spec/plural-rules
        // > other (required—general plural form — also used if the language only has a single form)
        default:
            return Plural.Other;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function parseCookieValue(cookieStr, name) {
    var e_1, _a;
    name = encodeURIComponent(name);
    try {
        for (var _b = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__values"])(cookieStr.split(';')), _c = _b.next(); !_c.done; _c = _b.next()) {
            var cookie = _c.value;
            var eqIndex = cookie.indexOf('=');
            var _d = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__read"])(eqIndex == -1 ? [cookie, ''] : [cookie.slice(0, eqIndex), cookie.slice(eqIndex + 1)], 2), cookieName = _d[0], cookieValue = _d[1];
            if (cookieName.trim() === name) {
                return decodeURIComponent(cookieValue);
            }
        }
    }
    catch (e_1_1) {
        e_1 = { error: e_1_1 };
    }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return))
                _a.call(_b);
        }
        finally {
            if (e_1)
                throw e_1.error;
        }
    }
    return null;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @ngModule CommonModule
 *
 * @usageNotes
 * ```
 *     <some-element [ngClass]="'first second'">...</some-element>
 *
 *     <some-element [ngClass]="['first', 'second']">...</some-element>
 *
 *     <some-element [ngClass]="{'first': true, 'second': true, 'third': false}">...</some-element>
 *
 *     <some-element [ngClass]="stringExp|arrayExp|objExp">...</some-element>
 *
 *     <some-element [ngClass]="{'class1 class2 class3' : true}">...</some-element>
 * ```
 *
 * @description
 *
 * Adds and removes CSS classes on an HTML element.
 *
 * The CSS classes are updated as follows, depending on the type of the expression evaluation:
 * - `string` - the CSS classes listed in the string (space delimited) are added,
 * - `Array` - the CSS classes declared as Array elements are added,
 * - `Object` - keys are CSS classes that get added when the expression given in the value
 *              evaluates to a truthy value, otherwise they are removed.
 *
 *
 */
var NgClass = /*@__PURE__*/ (function () {
    function NgClass(_iterableDiffers, _keyValueDiffers, _ngEl, _renderer) {
        this._iterableDiffers = _iterableDiffers;
        this._keyValueDiffers = _keyValueDiffers;
        this._ngEl = _ngEl;
        this._renderer = _renderer;
        this._initialClasses = [];
    }
    Object.defineProperty(NgClass.prototype, "klass", {
        set: function (value) {
            this._removeClasses(this._initialClasses);
            this._initialClasses = typeof value === 'string' ? value.split(/\s+/) : [];
            this._applyClasses(this._initialClasses);
            this._applyClasses(this._rawClass);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgClass.prototype, "ngClass", {
        set: function (value) {
            this._removeClasses(this._rawClass);
            this._applyClasses(this._initialClasses);
            this._iterableDiffer = null;
            this._keyValueDiffer = null;
            this._rawClass = typeof value === 'string' ? value.split(/\s+/) : value;
            if (this._rawClass) {
                if (Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisListLikeIterable"])(this._rawClass)) {
                    this._iterableDiffer = this._iterableDiffers.find(this._rawClass).create();
                }
                else {
                    this._keyValueDiffer = this._keyValueDiffers.find(this._rawClass).create();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    NgClass.prototype.ngDoCheck = function () {
        if (this._iterableDiffer) {
            var iterableChanges = this._iterableDiffer.diff(this._rawClass);
            if (iterableChanges) {
                this._applyIterableChanges(iterableChanges);
            }
        }
        else if (this._keyValueDiffer) {
            var keyValueChanges = this._keyValueDiffer.diff(this._rawClass);
            if (keyValueChanges) {
                this._applyKeyValueChanges(keyValueChanges);
            }
        }
    };
    NgClass.prototype._applyKeyValueChanges = function (changes) {
        var _this = this;
        changes.forEachAddedItem(function (record) { return _this._toggleClass(record.key, record.currentValue); });
        changes.forEachChangedItem(function (record) { return _this._toggleClass(record.key, record.currentValue); });
        changes.forEachRemovedItem(function (record) {
            if (record.previousValue) {
                _this._toggleClass(record.key, false);
            }
        });
    };
    NgClass.prototype._applyIterableChanges = function (changes) {
        var _this = this;
        changes.forEachAddedItem(function (record) {
            if (typeof record.item === 'string') {
                _this._toggleClass(record.item, true);
            }
            else {
                throw new Error("NgClass can only toggle CSS classes expressed as strings, got " + Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(record.item));
            }
        });
        changes.forEachRemovedItem(function (record) { return _this._toggleClass(record.item, false); });
    };
    /**
     * Applies a collection of CSS classes to the DOM element.
     *
     * For argument of type Set and Array CSS class names contained in those collections are always
     * added.
     * For argument of type Map CSS class name in the map's key is toggled based on the value (added
     * for truthy and removed for falsy).
     */
    NgClass.prototype._applyClasses = function (rawClassVal) {
        var _this = this;
        if (rawClassVal) {
            if (Array.isArray(rawClassVal) || rawClassVal instanceof Set) {
                rawClassVal.forEach(function (klass) { return _this._toggleClass(klass, true); });
            }
            else {
                Object.keys(rawClassVal).forEach(function (klass) { return _this._toggleClass(klass, !!rawClassVal[klass]); });
            }
        }
    };
    /**
     * Removes a collection of CSS classes from the DOM element. This is mostly useful for cleanup
     * purposes.
     */
    NgClass.prototype._removeClasses = function (rawClassVal) {
        var _this = this;
        if (rawClassVal) {
            if (Array.isArray(rawClassVal) || rawClassVal instanceof Set) {
                rawClassVal.forEach(function (klass) { return _this._toggleClass(klass, false); });
            }
            else {
                Object.keys(rawClassVal).forEach(function (klass) { return _this._toggleClass(klass, false); });
            }
        }
    };
    NgClass.prototype._toggleClass = function (klass, enabled) {
        var _this = this;
        klass = klass.trim();
        if (klass) {
            klass.split(/\s+/g).forEach(function (klass) {
                if (enabled) {
                    _this._renderer.addClass(_this._ngEl.nativeElement, klass);
                }
                else {
                    _this._renderer.removeClass(_this._ngEl.nativeElement, klass);
                }
            });
        }
    };
    return NgClass;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Instantiates a single {@link Component} type and inserts its Host View into current View.
 * `NgComponentOutlet` provides a declarative approach for dynamic component creation.
 *
 * `NgComponentOutlet` requires a component type, if a falsy value is set the view will clear and
 * any existing component will get destroyed.
 *
 * @usageNotes
 *
 * ### Fine tune control
 *
 * You can control the component creation process by using the following optional attributes:
 *
 * * `ngComponentOutletInjector`: Optional custom {@link Injector} that will be used as parent for
 * the Component. Defaults to the injector of the current view container.
 *
 * * `ngComponentOutletContent`: Optional list of projectable nodes to insert into the content
 * section of the component, if exists.
 *
 * * `ngComponentOutletNgModuleFactory`: Optional module factory to allow dynamically loading other
 * module, then load a component from that module.
 *
 * ### Syntax
 *
 * Simple
 * ```
 * <ng-container *ngComponentOutlet="componentTypeExpression"></ng-container>
 * ```
 *
 * Customized injector/content
 * ```
 * <ng-container *ngComponentOutlet="componentTypeExpression;
 *                                   injector: injectorExpression;
 *                                   content: contentNodesExpression;">
 * </ng-container>
 * ```
 *
 * Customized ngModuleFactory
 * ```
 * <ng-container *ngComponentOutlet="componentTypeExpression;
 *                                   ngModuleFactory: moduleFactory;">
 * </ng-container>
 * ```
 *
 * ### A simple example
 *
 * {@example common/ngComponentOutlet/ts/module.ts region='SimpleExample'}
 *
 * A more complete example with additional options:
 *
 * {@example common/ngComponentOutlet/ts/module.ts region='CompleteExample'}

 * A more complete example with ngModuleFactory:
 *
 * {@example common/ngComponentOutlet/ts/module.ts region='NgModuleFactoryExample'}
 *
 * @experimental
 * @ngModule CommonModule
 */
var NgComponentOutlet = /*@__PURE__*/ (function () {
    function NgComponentOutlet(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this._componentRef = null;
        this._moduleRef = null;
    }
    NgComponentOutlet.prototype.ngOnChanges = function (changes) {
        this._viewContainerRef.clear();
        this._componentRef = null;
        if (this.ngComponentOutlet) {
            var elInjector = this.ngComponentOutletInjector || this._viewContainerRef.parentInjector;
            if (changes['ngComponentOutletNgModuleFactory']) {
                if (this._moduleRef)
                    this._moduleRef.destroy();
                if (this.ngComponentOutletNgModuleFactory) {
                    var parentModule = elInjector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleRef"]);
                    this._moduleRef = this.ngComponentOutletNgModuleFactory.create(parentModule.injector);
                }
                else {
                    this._moduleRef = null;
                }
            }
            var componentFactoryResolver = this._moduleRef ? this._moduleRef.componentFactoryResolver :
                elInjector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]);
            var componentFactory = componentFactoryResolver.resolveComponentFactory(this.ngComponentOutlet);
            this._componentRef = this._viewContainerRef.createComponent(componentFactory, this._viewContainerRef.length, elInjector, this.ngComponentOutletContent);
        }
    };
    NgComponentOutlet.prototype.ngOnDestroy = function () {
        if (this._moduleRef)
            this._moduleRef.destroy();
    };
    return NgComponentOutlet;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NgForOfContext = /*@__PURE__*/ (function () {
    function NgForOfContext($implicit, ngForOf, index, count) {
        this.$implicit = $implicit;
        this.ngForOf = ngForOf;
        this.index = index;
        this.count = count;
    }
    Object.defineProperty(NgForOfContext.prototype, "first", {
        get: function () { return this.index === 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOfContext.prototype, "last", {
        get: function () { return this.index === this.count - 1; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOfContext.prototype, "even", {
        get: function () { return this.index % 2 === 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOfContext.prototype, "odd", {
        get: function () { return !this.even; },
        enumerable: true,
        configurable: true
    });
    return NgForOfContext;
}());
/**
 * The `NgForOf` directive instantiates a template once per item from an iterable. The context
 * for each instantiated template inherits from the outer context with the given loop variable
 * set to the current item from the iterable.
 *
 * @usageNotes
 *
 * ### Local Variables
 *
 * `NgForOf` provides several exported values that can be aliased to local variables:
 *
 * - `$implicit: T`: The value of the individual items in the iterable (`ngForOf`).
 * - `ngForOf: NgIterable<T>`: The value of the iterable expression. Useful when the expression is
 * more complex then a property access, for example when using the async pipe (`userStreams |
 * async`).
 * - `index: number`: The index of the current item in the iterable.
 * - `first: boolean`: True when the item is the first item in the iterable.
 * - `last: boolean`: True when the item is the last item in the iterable.
 * - `even: boolean`: True when the item has an even index in the iterable.
 * - `odd: boolean`: True when the item has an odd index in the iterable.
 *
 * ```
 * <li *ngFor="let user of userObservable | async as users; index as i; first as isFirst">
 *    {{i}}/{{users.length}}. {{user}} <span *ngIf="isFirst">default</span>
 * </li>
 * ```
 *
 * ### Change Propagation
 *
 * When the contents of the iterator changes, `NgForOf` makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 * * Otherwise, the DOM element for that item will remain the same.
 *
 * Angular uses object identity to track insertions and deletions within the iterator and reproduce
 * those changes in the DOM. This has important implications for animations and any stateful
 * controls (such as `<input>` elements which accept user input) that are present. Inserted rows can
 * be animated in, deleted rows can be animated out, and unchanged rows retain any unsaved state
 * such as user input.
 *
 * It is possible for the identities of elements in the iterator to change while the data does not.
 * This can happen, for example, if the iterator produced from an RPC to the server, and that
 * RPC is re-run. Even if the data hasn't changed, the second response will produce objects with
 * different identities, and Angular will tear down the entire DOM and rebuild it (as if all old
 * elements were deleted and all new elements inserted). This is an expensive operation and should
 * be avoided if possible.
 *
 * To customize the default tracking algorithm, `NgForOf` supports `trackBy` option.
 * `trackBy` takes a function which has two arguments: `index` and `item`.
 * If `trackBy` is given, Angular tracks changes by the return value of the function.
 *
 * ### Syntax
 *
 * - `<li *ngFor="let item of items; index as i; trackBy: trackByFn">...</li>`
 *
 * With `<ng-template>` element:
 *
 * ```
 * <ng-template ngFor let-item [ngForOf]="items" let-i="index" [ngForTrackBy]="trackByFn">
 *   <li>...</li>
 * </ng-template>
 * ```
 *
 * ### Example
 *
 * See a [live demo](http://plnkr.co/edit/KVuXxDp0qinGDyo307QW?p=preview) for a more detailed
 * example.
 *
 * @ngModule CommonModule
 */
var NgForOf = /*@__PURE__*/ (function () {
    function NgForOf(_viewContainer, _template, _differs) {
        this._viewContainer = _viewContainer;
        this._template = _template;
        this._differs = _differs;
        this._ngForOfDirty = true;
        this._differ = null;
    }
    Object.defineProperty(NgForOf.prototype, "ngForOf", {
        set: function (ngForOf) {
            this._ngForOf = ngForOf;
            this._ngForOfDirty = true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOf.prototype, "ngForTrackBy", {
        get: function () { return this._trackByFn; },
        set: function (fn) {
            if (Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])() && fn != null && typeof fn !== 'function') {
                // TODO(vicb): use a log service once there is a public one available
                if (console && console.warn) {
                    console.warn("trackBy must be a function, but received " + JSON.stringify(fn) + ". " +
                        "See https://angular.io/docs/ts/latest/api/common/index/NgFor-directive.html#!#change-propagation for more information.");
                }
            }
            this._trackByFn = fn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOf.prototype, "ngForTemplate", {
        set: function (value) {
            // TODO(TS2.1): make TemplateRef<Partial<NgForRowOf<T>>> once we move to TS v2.1
            // The current type is too restrictive; a template that just uses index, for example,
            // should be acceptable.
            if (value) {
                this._template = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    NgForOf.prototype.ngDoCheck = function () {
        if (this._ngForOfDirty) {
            this._ngForOfDirty = false;
            // React on ngForOf changes only once all inputs have been initialized
            var value = this._ngForOf;
            if (!this._differ && value) {
                try {
                    this._differ = this._differs.find(value).create(this.ngForTrackBy);
                }
                catch (e) {
                    throw new Error("Cannot find a differ supporting object '" + value + "' of type '" + getTypeNameForDebugging(value) + "'. NgFor only supports binding to Iterables such as Arrays.");
                }
            }
        }
        if (this._differ) {
            var changes = this._differ.diff(this._ngForOf);
            if (changes)
                this._applyChanges(changes);
        }
    };
    NgForOf.prototype._applyChanges = function (changes) {
        var _this = this;
        var insertTuples = [];
        changes.forEachOperation(function (item, adjustedPreviousIndex, currentIndex) {
            if (item.previousIndex == null) {
                var view = _this._viewContainer.createEmbeddedView(_this._template, new NgForOfContext(null, _this._ngForOf, -1, -1), currentIndex);
                var tuple = new RecordViewTuple(item, view);
                insertTuples.push(tuple);
            }
            else if (currentIndex == null) {
                _this._viewContainer.remove(adjustedPreviousIndex);
            }
            else {
                var view = _this._viewContainer.get(adjustedPreviousIndex);
                _this._viewContainer.move(view, currentIndex);
                var tuple = new RecordViewTuple(item, view);
                insertTuples.push(tuple);
            }
        });
        for (var i = 0; i < insertTuples.length; i++) {
            this._perViewChange(insertTuples[i].view, insertTuples[i].record);
        }
        for (var i = 0, ilen = this._viewContainer.length; i < ilen; i++) {
            var viewRef = this._viewContainer.get(i);
            viewRef.context.index = i;
            viewRef.context.count = ilen;
            viewRef.context.ngForOf = this._ngForOf;
        }
        changes.forEachIdentityChange(function (record) {
            var viewRef = _this._viewContainer.get(record.currentIndex);
            viewRef.context.$implicit = record.item;
        });
    };
    NgForOf.prototype._perViewChange = function (view, record) {
        view.context.$implicit = record.item;
    };
    return NgForOf;
}());
var RecordViewTuple = /*@__PURE__*/ (function () {
    function RecordViewTuple(record, view) {
        this.record = record;
        this.view = view;
    }
    return RecordViewTuple;
}());
function getTypeNameForDebugging(type) {
    return type['name'] || typeof type;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Conditionally includes a template based on the value of an `expression`.
 *
 * `ngIf` evaluates the `expression` and then renders the `then` or `else` template in its place
 * when expression is truthy or falsy respectively. Typically the:
 *  - `then` template is the inline template of `ngIf` unless bound to a different value.
 *  - `else` template is blank unless it is bound.
 *
 *
 * @usageNotes
 *
 * ### Most common usage
 *
 * The most common usage of the `ngIf` directive is to conditionally show the inline template as
 * seen in this example:
 * {@example common/ngIf/ts/module.ts region='NgIfSimple'}
 *
 * ### Showing an alternative template using `else`
 *
 * If it is necessary to display a template when the `expression` is falsy use the `else` template
 * binding as shown. Note that the `else` binding points to a `<ng-template>` labeled `#elseBlock`.
 * The template can be defined anywhere in the component view but is typically placed right after
 * `ngIf` for readability.
 *
 * {@example common/ngIf/ts/module.ts region='NgIfElse'}
 *
 * ### Using non-inlined `then` template
 *
 * Usually the `then` template is the inlined template of the `ngIf`, but it can be changed using
 * a binding (just like `else`). Because `then` and `else` are bindings, the template references can
 * change at runtime as shown in this example.
 *
 * {@example common/ngIf/ts/module.ts region='NgIfThenElse'}
 *
 * ### Storing conditional result in a variable
 *
 * A common pattern is that we need to show a set of properties from the same object. If the
 * object is undefined, then we have to use the safe-traversal-operator `?.` to guard against
 * dereferencing a `null` value. This is especially the case when waiting on async data such as
 * when using the `async` pipe as shown in following example:
 *
 * ```
 * Hello {{ (userStream|async)?.last }}, {{ (userStream|async)?.first }}!
 * ```
 *
 * There are several inefficiencies in the above example:
 *  - We create multiple subscriptions on `userStream`. One for each `async` pipe, or two in the
 *    example above.
 *  - We cannot display an alternative screen while waiting for the data to arrive asynchronously.
 *  - We have to use the safe-traversal-operator `?.` to access properties, which is cumbersome.
 *  - We have to place the `async` pipe in parenthesis.
 *
 * A better way to do this is to use `ngIf` and store the result of the condition in a local
 * variable as shown in the the example below:
 *
 * {@example common/ngIf/ts/module.ts region='NgIfAs'}
 *
 * Notice that:
 *  - We use only one `async` pipe and hence only one subscription gets created.
 *  - `ngIf` stores the result of the `userStream|async` in the local variable `user`.
 *  - The local `user` can then be bound repeatedly in a more efficient way.
 *  - No need to use the safe-traversal-operator `?.` to access properties as `ngIf` will only
 *    display the data if `userStream` returns a value.
 *  - We can display an alternative template while waiting for the data.
 *
 * ### Syntax
 *
 * Simple form:
 * - `<div *ngIf="condition">...</div>`
 * - `<ng-template [ngIf]="condition"><div>...</div></ng-template>`
 *
 * Form with an else block:
 * ```
 * <div *ngIf="condition; else elseBlock">...</div>
 * <ng-template #elseBlock>...</ng-template>
 * ```
 *
 * Form with a `then` and `else` block:
 * ```
 * <div *ngIf="condition; then thenBlock else elseBlock"></div>
 * <ng-template #thenBlock>...</ng-template>
 * <ng-template #elseBlock>...</ng-template>
 * ```
 *
 * Form with storing the value locally:
 * ```
 * <div *ngIf="condition as value; else elseBlock">{{value}}</div>
 * <ng-template #elseBlock>...</ng-template>
 * ```
 *
 * @ngModule CommonModule
 */
var NgIf = /*@__PURE__*/ (function () {
    function NgIf(_viewContainer, templateRef) {
        this._viewContainer = _viewContainer;
        this._context = new NgIfContext();
        this._thenTemplateRef = null;
        this._elseTemplateRef = null;
        this._thenViewRef = null;
        this._elseViewRef = null;
        this._thenTemplateRef = templateRef;
    }
    Object.defineProperty(NgIf.prototype, "ngIf", {
        set: function (condition) {
            this._context.$implicit = this._context.ngIf = condition;
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgIf.prototype, "ngIfThen", {
        set: function (templateRef) {
            assertTemplate('ngIfThen', templateRef);
            this._thenTemplateRef = templateRef;
            this._thenViewRef = null; // clear previous view if any.
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgIf.prototype, "ngIfElse", {
        set: function (templateRef) {
            assertTemplate('ngIfElse', templateRef);
            this._elseTemplateRef = templateRef;
            this._elseViewRef = null; // clear previous view if any.
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    NgIf.prototype._updateView = function () {
        if (this._context.$implicit) {
            if (!this._thenViewRef) {
                this._viewContainer.clear();
                this._elseViewRef = null;
                if (this._thenTemplateRef) {
                    this._thenViewRef =
                        this._viewContainer.createEmbeddedView(this._thenTemplateRef, this._context);
                }
            }
        }
        else {
            if (!this._elseViewRef) {
                this._viewContainer.clear();
                this._thenViewRef = null;
                if (this._elseTemplateRef) {
                    this._elseViewRef =
                        this._viewContainer.createEmbeddedView(this._elseTemplateRef, this._context);
                }
            }
        }
    };
    return NgIf;
}());
var NgIfContext = /*@__PURE__*/ (function () {
    function NgIfContext() {
        this.$implicit = null;
        this.ngIf = null;
    }
    return NgIfContext;
}());
function assertTemplate(property, templateRef) {
    var isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
    if (!isTemplateRefOrNull) {
        throw new Error(property + " must be a TemplateRef, but received '" + Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(templateRef) + "'.");
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SwitchView = /*@__PURE__*/ (function () {
    function SwitchView(_viewContainerRef, _templateRef) {
        this._viewContainerRef = _viewContainerRef;
        this._templateRef = _templateRef;
        this._created = false;
    }
    SwitchView.prototype.create = function () {
        this._created = true;
        this._viewContainerRef.createEmbeddedView(this._templateRef);
    };
    SwitchView.prototype.destroy = function () {
        this._created = false;
        this._viewContainerRef.clear();
    };
    SwitchView.prototype.enforceState = function (created) {
        if (created && !this._created) {
            this.create();
        }
        else if (!created && this._created) {
            this.destroy();
        }
    };
    return SwitchView;
}());
/**
 * @ngModule CommonModule
 *
 * @usageNotes
 * ```
 *     <container-element [ngSwitch]="switch_expression">
 *       <some-element *ngSwitchCase="match_expression_1">...</some-element>
 *       <some-element *ngSwitchCase="match_expression_2">...</some-element>
 *       <some-other-element *ngSwitchCase="match_expression_3">...</some-other-element>
 *       <ng-container *ngSwitchCase="match_expression_3">
 *         <!-- use a ng-container to group multiple root nodes -->
 *         <inner-element></inner-element>
 *         <inner-other-element></inner-other-element>
 *       </ng-container>
 *       <some-element *ngSwitchDefault>...</some-element>
 *     </container-element>
 * ```
 * @description
 *
 * Adds / removes DOM sub-trees when the nest match expressions matches the switch expression.
 *
 * `NgSwitch` stamps out nested views when their match expression value matches the value of the
 * switch expression.
 *
 * In other words:
 * - you define a container element (where you place the directive with a switch expression on the
 * `[ngSwitch]="..."` attribute)
 * - you define inner views inside the `NgSwitch` and place a `*ngSwitchCase` attribute on the view
 * root elements.
 *
 * Elements within `NgSwitch` but outside of a `NgSwitchCase` or `NgSwitchDefault` directives will
 * be preserved at the location.
 *
 * The `ngSwitchCase` directive informs the parent `NgSwitch` of which view to display when the
 * expression is evaluated.
 * When no matching expression is found on a `ngSwitchCase` view, the `ngSwitchDefault` view is
 * stamped out.
 *
 *
 */
var NgSwitch = /*@__PURE__*/ (function () {
    function NgSwitch() {
        this._defaultUsed = false;
        this._caseCount = 0;
        this._lastCaseCheckIndex = 0;
        this._lastCasesMatched = false;
    }
    Object.defineProperty(NgSwitch.prototype, "ngSwitch", {
        set: function (newValue) {
            this._ngSwitch = newValue;
            if (this._caseCount === 0) {
                this._updateDefaultCases(true);
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    NgSwitch.prototype._addCase = function () { return this._caseCount++; };
    /** @internal */
    NgSwitch.prototype._addDefault = function (view) {
        if (!this._defaultViews) {
            this._defaultViews = [];
        }
        this._defaultViews.push(view);
    };
    /** @internal */
    NgSwitch.prototype._matchCase = function (value) {
        var matched = value == this._ngSwitch;
        this._lastCasesMatched = this._lastCasesMatched || matched;
        this._lastCaseCheckIndex++;
        if (this._lastCaseCheckIndex === this._caseCount) {
            this._updateDefaultCases(!this._lastCasesMatched);
            this._lastCaseCheckIndex = 0;
            this._lastCasesMatched = false;
        }
        return matched;
    };
    NgSwitch.prototype._updateDefaultCases = function (useDefault) {
        if (this._defaultViews && useDefault !== this._defaultUsed) {
            this._defaultUsed = useDefault;
            for (var i = 0; i < this._defaultViews.length; i++) {
                var defaultView = this._defaultViews[i];
                defaultView.enforceState(useDefault);
            }
        }
    };
    return NgSwitch;
}());
/**
 * @ngModule CommonModule
 *
 * @usageNotes
 * ```
 * <container-element [ngSwitch]="switch_expression">
 *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
 * </container-element>
 *```
 * @description
 *
 * Creates a view that will be added/removed from the parent {@link NgSwitch} when the
 * given expression evaluate to respectively the same/different value as the switch
 * expression.
 *
 * Insert the sub-tree when the expression evaluates to the same value as the enclosing switch
 * expression.
 *
 * If multiple match expressions match the switch expression value, all of them are displayed.
 *
 * See {@link NgSwitch} for more details and example.
 *
 *
 */
var NgSwitchCase = /*@__PURE__*/ (function () {
    function NgSwitchCase(viewContainer, templateRef, ngSwitch) {
        this.ngSwitch = ngSwitch;
        ngSwitch._addCase();
        this._view = new SwitchView(viewContainer, templateRef);
    }
    NgSwitchCase.prototype.ngDoCheck = function () { this._view.enforceState(this.ngSwitch._matchCase(this.ngSwitchCase)); };
    NgSwitchCase = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"])())
    ], NgSwitchCase);
    return NgSwitchCase;
}());
/**
 * @ngModule CommonModule
 * @usageNotes
 * ```
 * <container-element [ngSwitch]="switch_expression">
 *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
 *   <some-other-element *ngSwitchDefault>...</some-other-element>
 * </container-element>
 * ```
 *
 * @description
 *
 * Creates a view that is added to the parent {@link NgSwitch} when no case expressions
 * match the switch expression.
 *
 * Insert the sub-tree when no case expressions evaluate to the same value as the enclosing switch
 * expression.
 *
 * See {@link NgSwitch} for more details and example.
 *
 *
 */
var NgSwitchDefault = /*@__PURE__*/ (function () {
    function NgSwitchDefault(viewContainer, templateRef, ngSwitch) {
        ngSwitch._addDefault(new SwitchView(viewContainer, templateRef));
    }
    NgSwitchDefault = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"])())
    ], NgSwitchDefault);
    return NgSwitchDefault;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @ngModule CommonModule
 *
 * @usageNotes
 * ```
 * <some-element [ngPlural]="value">
 *   <ng-template ngPluralCase="=0">there is nothing</ng-template>
 *   <ng-template ngPluralCase="=1">there is one</ng-template>
 *   <ng-template ngPluralCase="few">there are a few</ng-template>
 * </some-element>
 * ```
 *
 * @description
 *
 * Adds / removes DOM sub-trees based on a numeric value. Tailored for pluralization.
 *
 * Displays DOM sub-trees that match the switch expression value, or failing that, DOM sub-trees
 * that match the switch expression's pluralization category.
 *
 * To use this directive you must provide a container element that sets the `[ngPlural]` attribute
 * to a switch expression. Inner elements with a `[ngPluralCase]` will display based on their
 * expression:
 * - if `[ngPluralCase]` is set to a value starting with `=`, it will only display if the value
 *   matches the switch expression exactly,
 * - otherwise, the view will be treated as a "category match", and will only display if exact
 *   value matches aren't found and the value maps to its category for the defined locale.
 *
 * See http://cldr.unicode.org/index/cldr-spec/plural-rules
 *
 * @experimental
 */
var NgPlural = /*@__PURE__*/ (function () {
    function NgPlural(_localization) {
        this._localization = _localization;
        this._caseViews = {};
    }
    Object.defineProperty(NgPlural.prototype, "ngPlural", {
        set: function (value) {
            this._switchValue = value;
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    NgPlural.prototype.addCase = function (value, switchView) { this._caseViews[value] = switchView; };
    NgPlural.prototype._updateView = function () {
        this._clearViews();
        var cases = Object.keys(this._caseViews);
        var key = getPluralCategory(this._switchValue, cases, this._localization);
        this._activateView(this._caseViews[key]);
    };
    NgPlural.prototype._clearViews = function () {
        if (this._activeView)
            this._activeView.destroy();
    };
    NgPlural.prototype._activateView = function (view) {
        if (view) {
            this._activeView = view;
            this._activeView.create();
        }
    };
    return NgPlural;
}());
/**
 * @ngModule CommonModule
 *
 * @description
 *
 * Creates a view that will be added/removed from the parent {@link NgPlural} when the
 * given expression matches the plural expression according to CLDR rules.
 *
 * @usageNotes
 * ```
 * <some-element [ngPlural]="value">
 *   <ng-template ngPluralCase="=0">...</ng-template>
 *   <ng-template ngPluralCase="other">...</ng-template>
 * </some-element>
 *```
 *
 * See {@link NgPlural} for more details and example.
 *
 * @experimental
 */
var NgPluralCase = /*@__PURE__*/ (function () {
    function NgPluralCase(value, template, viewContainer, ngPlural) {
        this.value = value;
        var isANumber = !isNaN(Number(value));
        ngPlural.addCase(isANumber ? "=" + value : value, new SwitchView(viewContainer, template));
    }
    NgPluralCase = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"])('ngPluralCase')),
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"])())
    ], NgPluralCase);
    return NgPluralCase;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @ngModule CommonModule
 *
 * @usageNotes
 * ```
 * <some-element [ngStyle]="{'font-style': styleExp}">...</some-element>
 *
 * <some-element [ngStyle]="{'max-width.px': widthExp}">...</some-element>
 *
 * <some-element [ngStyle]="objExp">...</some-element>
 * ```
 *
 * @description
 *
 * Update an HTML element styles.
 *
 * The styles are updated according to the value of the expression evaluation:
 * - keys are style names with an optional `.<unit>` suffix (ie 'top.px', 'font-style.em'),
 * - values are the values assigned to those properties (expressed in the given unit).
 *
 *
 */
var NgStyle = /*@__PURE__*/ (function () {
    function NgStyle(_differs, _ngEl, _renderer) {
        this._differs = _differs;
        this._ngEl = _ngEl;
        this._renderer = _renderer;
    }
    Object.defineProperty(NgStyle.prototype, "ngStyle", {
        set: function (values) {
            this._ngStyle = values;
            if (!this._differ && values) {
                this._differ = this._differs.find(values).create();
            }
        },
        enumerable: true,
        configurable: true
    });
    NgStyle.prototype.ngDoCheck = function () {
        if (this._differ) {
            var changes = this._differ.diff(this._ngStyle);
            if (changes) {
                this._applyChanges(changes);
            }
        }
    };
    NgStyle.prototype._applyChanges = function (changes) {
        var _this = this;
        changes.forEachRemovedItem(function (record) { return _this._setStyle(record.key, null); });
        changes.forEachAddedItem(function (record) { return _this._setStyle(record.key, record.currentValue); });
        changes.forEachChangedItem(function (record) { return _this._setStyle(record.key, record.currentValue); });
    };
    NgStyle.prototype._setStyle = function (nameAndUnit, value) {
        var _a = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__read"])(nameAndUnit.split('.'), 2), name = _a[0], unit = _a[1];
        value = value != null && unit ? "" + value + unit : value;
        if (value != null) {
            this._renderer.setStyle(this._ngEl.nativeElement, name, value);
        }
        else {
            this._renderer.removeStyle(this._ngEl.nativeElement, name);
        }
    };
    return NgStyle;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @ngModule CommonModule
 *
 * @description
 *
 * Inserts an embedded view from a prepared `TemplateRef`.
 *
 * You can attach a context object to the `EmbeddedViewRef` by setting `[ngTemplateOutletContext]`.
 * `[ngTemplateOutletContext]` should be an object, the object's keys will be available for binding
 * by the local template `let` declarations.
 *
 * @usageNotes
 * ```
 * <ng-container *ngTemplateOutlet="templateRefExp; context: contextExp"></ng-container>
 * ```
 *
 * Using the key `$implicit` in the context object will set its value as default.
 *
 * ### Example
 *
 * {@example common/ngTemplateOutlet/ts/module.ts region='NgTemplateOutlet'}
 *
 */
var NgTemplateOutlet = /*@__PURE__*/ (function () {
    function NgTemplateOutlet(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
    }
    NgTemplateOutlet.prototype.ngOnChanges = function (changes) {
        var recreateView = this._shouldRecreateView(changes);
        if (recreateView) {
            if (this._viewRef) {
                this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._viewRef));
            }
            if (this.ngTemplateOutlet) {
                this._viewRef = this._viewContainerRef.createEmbeddedView(this.ngTemplateOutlet, this.ngTemplateOutletContext);
            }
        }
        else {
            if (this._viewRef && this.ngTemplateOutletContext) {
                this._updateExistingContext(this.ngTemplateOutletContext);
            }
        }
    };
    /**
     * We need to re-create existing embedded view if:
     * - templateRef has changed
     * - context has changes
     *
     * We mark context object as changed when the corresponding object
     * shape changes (new properties are added or existing properties are removed).
     * In other words we consider context with the same properties as "the same" even
     * if object reference changes (see https://github.com/angular/angular/issues/13407).
     */
    NgTemplateOutlet.prototype._shouldRecreateView = function (changes) {
        var ctxChange = changes['ngTemplateOutletContext'];
        return !!changes['ngTemplateOutlet'] || (ctxChange && this._hasContextShapeChanged(ctxChange));
    };
    NgTemplateOutlet.prototype._hasContextShapeChanged = function (ctxChange) {
        var e_1, _a;
        var prevCtxKeys = Object.keys(ctxChange.previousValue || {});
        var currCtxKeys = Object.keys(ctxChange.currentValue || {});
        if (prevCtxKeys.length === currCtxKeys.length) {
            try {
                for (var currCtxKeys_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__values"])(currCtxKeys), currCtxKeys_1_1 = currCtxKeys_1.next(); !currCtxKeys_1_1.done; currCtxKeys_1_1 = currCtxKeys_1.next()) {
                    var propName = currCtxKeys_1_1.value;
                    if (prevCtxKeys.indexOf(propName) === -1) {
                        return true;
                    }
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (currCtxKeys_1_1 && !currCtxKeys_1_1.done && (_a = currCtxKeys_1.return))
                        _a.call(currCtxKeys_1);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            return false;
        }
        else {
            return true;
        }
    };
    NgTemplateOutlet.prototype._updateExistingContext = function (ctx) {
        var e_2, _a;
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__values"])(Object.keys(ctx)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var propName = _c.value;
                this._viewRef.context[propName] = this.ngTemplateOutletContext[propName];
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
    };
    return NgTemplateOutlet;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A collection of Angular directives that are likely to be used in each and every Angular
 * application.
 */
var COMMON_DIRECTIVES = [
    NgClass,
    NgComponentOutlet,
    NgForOf,
    NgIf,
    NgTemplateOutlet,
    NgStyle,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    NgPlural,
    NgPluralCase,
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function invalidPipeArgumentError(type, value) {
    return Error("InvalidPipeArgument: '" + value + "' for pipe '" + Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(type) + "'");
}
var NumberFormatter = /*@__PURE__*/ (function () {
    function NumberFormatter() {
    }
    NumberFormatter.format = function (num, locale, style, opts) {
        if (opts === void 0) {
            opts = {};
        }
        var minimumIntegerDigits = opts.minimumIntegerDigits, minimumFractionDigits = opts.minimumFractionDigits, maximumFractionDigits = opts.maximumFractionDigits, currency = opts.currency, _a = opts.currencyAsSymbol, currencyAsSymbol = _a === void 0 ? false : _a;
        var options = {
            minimumIntegerDigits: minimumIntegerDigits,
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits,
            style: NumberFormatStyle[style].toLowerCase()
        };
        if (style == NumberFormatStyle.Currency) {
            options.currency = typeof currency == 'string' ? currency : undefined;
            options.currencyDisplay = currencyAsSymbol ? 'symbol' : 'code';
        }
        return new Intl.NumberFormat(locale, options).format(num);
    };
    return NumberFormatter;
}());
var DATE_FORMATS_SPLIT$1 = /((?:[^yMLdHhmsazZEwGjJ']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|J+|j+|m+|s+|a|z|Z|G+|w+))(.*)/;
var PATTERN_ALIASES = {
    // Keys are quoted so they do not get renamed during closure compilation.
    'yMMMdjms': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ combine([
        /*@__PURE__*/ digitCondition('year', 1),
        /*@__PURE__*/ nameCondition('month', 3),
        /*@__PURE__*/ digitCondition('day', 1),
        /*@__PURE__*/ digitCondition('hour', 1),
        /*@__PURE__*/ digitCondition('minute', 1),
        /*@__PURE__*/ digitCondition('second', 1),
    ])),
    'yMdjm': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ combine([
        /*@__PURE__*/ digitCondition('year', 1), /*@__PURE__*/ digitCondition('month', 1), /*@__PURE__*/ digitCondition('day', 1),
        /*@__PURE__*/ digitCondition('hour', 1), /*@__PURE__*/ digitCondition('minute', 1)
    ])),
    'yMMMMEEEEd': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ combine([
        /*@__PURE__*/ digitCondition('year', 1), /*@__PURE__*/ nameCondition('month', 4), /*@__PURE__*/ nameCondition('weekday', 4),
        /*@__PURE__*/ digitCondition('day', 1)
    ])),
    'yMMMMd': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ combine([/*@__PURE__*/ digitCondition('year', 1), /*@__PURE__*/ nameCondition('month', 4), /*@__PURE__*/ digitCondition('day', 1)])),
    'yMMMd': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ combine([/*@__PURE__*/ digitCondition('year', 1), /*@__PURE__*/ nameCondition('month', 3), /*@__PURE__*/ digitCondition('day', 1)])),
    'yMd': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ combine([/*@__PURE__*/ digitCondition('year', 1), /*@__PURE__*/ digitCondition('month', 1), /*@__PURE__*/ digitCondition('day', 1)])),
    'jms': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ combine([/*@__PURE__*/ digitCondition('hour', 1), /*@__PURE__*/ digitCondition('second', 1), /*@__PURE__*/ digitCondition('minute', 1)])),
    'jm': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ combine([/*@__PURE__*/ digitCondition('hour', 1), /*@__PURE__*/ digitCondition('minute', 1)]))
};
var DATE_FORMATS$1 = {
    // Keys are quoted so they do not get renamed.
    'yyyy': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('year', 4)),
    'yy': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('year', 2)),
    'y': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('year', 1)),
    'MMMM': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('month', 4)),
    'MMM': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('month', 3)),
    'MM': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('month', 2)),
    'M': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('month', 1)),
    'LLLL': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('month', 4)),
    'L': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('month', 1)),
    'dd': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('day', 2)),
    'd': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('day', 1)),
    'HH': /*@__PURE__*/ digitModifier(/*@__PURE__*/ hourExtractor(/*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ hour12Modify(/*@__PURE__*/ digitCondition('hour', 2), false)))),
    'H': /*@__PURE__*/ hourExtractor(/*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ hour12Modify(/*@__PURE__*/ digitCondition('hour', 1), false))),
    'hh': /*@__PURE__*/ digitModifier(/*@__PURE__*/ hourExtractor(/*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ hour12Modify(/*@__PURE__*/ digitCondition('hour', 2), true)))),
    'h': /*@__PURE__*/ hourExtractor(/*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ hour12Modify(/*@__PURE__*/ digitCondition('hour', 1), true))),
    'jj': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('hour', 2)),
    'j': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('hour', 1)),
    'mm': /*@__PURE__*/ digitModifier(/*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('minute', 2))),
    'm': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('minute', 1)),
    'ss': /*@__PURE__*/ digitModifier(/*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('second', 2))),
    's': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('second', 1)),
    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
    // we can be just safely rely on using `sss` since we currently don't support single or two digit
    // fractions
    'sss': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ digitCondition('second', 3)),
    'EEEE': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('weekday', 4)),
    'EEE': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('weekday', 3)),
    'EE': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('weekday', 2)),
    'E': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('weekday', 1)),
    'a': /*@__PURE__*/ hourClockExtractor(/*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ hour12Modify(/*@__PURE__*/ digitCondition('hour', 1), true))),
    'Z': /*@__PURE__*/ timeZoneGetter$1('short'),
    'z': /*@__PURE__*/ timeZoneGetter$1('long'),
    'ww': /*@__PURE__*/ datePartGetterFactory({}),
    // first Thursday of the year. not support ?
    'w': /*@__PURE__*/ datePartGetterFactory({}),
    // of the year not support ?
    'G': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('era', 1)),
    'GG': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('era', 2)),
    'GGG': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('era', 3)),
    'GGGG': /*@__PURE__*/ datePartGetterFactory(/*@__PURE__*/ nameCondition('era', 4))
};
function digitModifier(inner) {
    return function (date, locale) {
        var result = inner(date, locale);
        return result.length == 1 ? '0' + result : result;
    };
}
function hourClockExtractor(inner) {
    return function (date, locale) { return inner(date, locale).split(' ')[1]; };
}
function hourExtractor(inner) {
    return function (date, locale) { return inner(date, locale).split(' ')[0]; };
}
function intlDateFormat(date, locale, options) {
    return new Intl.DateTimeFormat(locale, options).format(date).replace(/[\u200e\u200f]/g, '');
}
function timeZoneGetter$1(timezone) {
    // To workaround `Intl` API restriction for single timezone let format with 24 hours
    var options = { hour: '2-digit', hour12: false, timeZoneName: timezone };
    return function (date, locale) {
        var result = intlDateFormat(date, locale, options);
        // Then extract first 3 letters that related to hours
        return result ? result.substring(3) : '';
    };
}
function hour12Modify(options, value) {
    options.hour12 = value;
    return options;
}
function digitCondition(prop, len) {
    var result = /*@__PURE__*/ (function () {
        var result = {};
        result[prop] = len === 2 ? '2-digit' : 'numeric';
        return result;
    }());
    return result;
}
function nameCondition(prop, len) {
    var result = {};
    if (len < 4) {
        result[prop] = len > 1 ? 'short' : 'narrow';
    }
    else {
        result[prop] = 'long';
    }
    return result;
}
function combine(options) {
    return options.reduce(function (merged, opt) { return (Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, merged, opt)); }, {});
}
function datePartGetterFactory(ret) {
    return function (date, locale) { return intlDateFormat(date, locale, ret); };
}
var DATE_FORMATTER_CACHE = /*@__PURE__*/ new Map();
function dateFormatter(format, date, locale) {
    var fn = PATTERN_ALIASES[format];
    if (fn)
        return fn(date, locale);
    var cacheKey = format;
    var parts = DATE_FORMATTER_CACHE.get(cacheKey);
    if (!parts) {
        parts = [];
        var match = void 0;
        DATE_FORMATS_SPLIT$1.exec(format);
        var _format = format;
        while (_format) {
            match = DATE_FORMATS_SPLIT$1.exec(_format);
            if (match) {
                parts = parts.concat(match.slice(1));
                _format = parts.pop();
            }
            else {
                parts.push(_format);
                _format = null;
            }
        }
        DATE_FORMATTER_CACHE.set(cacheKey, parts);
    }
    return parts.reduce(function (text, part) {
        var fn = DATE_FORMATS$1[part];
        return text + (fn ? fn(date, locale) : partToTime(part));
    }, '');
}
function partToTime(part) {
    return part === '\'\'' ? '\'' : part.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
}
var DateFormatter = /*@__PURE__*/ (function () {
    function DateFormatter() {
    }
    DateFormatter.format = function (date, locale, pattern) {
        return dateFormatter(pattern, date, locale);
    };
    return DateFormatter;
}());
/**
* @license
* Copyright Google Inc. All Rights Reserved.
*
* Use of this source code is governed by an MIT-style license that can be
* found in the LICENSE file at https://angular.io/license
  */
/**
 * @ngModule CommonModule
 * @description
 *
 * Formats a date according to locale rules.
 *
 * Where:
 * - `expression` is a date object or a number (milliseconds since UTC epoch) or an ISO string
 * (https://www.w3.org/TR/NOTE-datetime).
 * - `format` indicates which date/time components to include. The format can be predefined as
 *   shown below or custom as shown in the table.
 *   - `'medium'`: equivalent to `'yMMMdjms'` (e.g. `Sep 3, 2010, 12:05:08 PM` for `en-US`)
 *   - `'short'`: equivalent to `'yMdjm'` (e.g. `9/3/2010, 12:05 PM` for `en-US`)
 *   - `'fullDate'`: equivalent to `'yMMMMEEEEd'` (e.g. `Friday, September 3, 2010` for `en-US`)
 *   - `'longDate'`: equivalent to `'yMMMMd'` (e.g. `September 3, 2010` for `en-US`)
 *   - `'mediumDate'`: equivalent to `'yMMMd'` (e.g. `Sep 3, 2010` for `en-US`)
 *   - `'shortDate'`: equivalent to `'yMd'` (e.g. `9/3/2010` for `en-US`)
 *   - `'mediumTime'`: equivalent to `'jms'` (e.g. `12:05:08 PM` for `en-US`)
 *   - `'shortTime'`: equivalent to `'jm'` (e.g. `12:05 PM` for `en-US`)
 *
 *
 *  | Component | Symbol | Narrow | Short Form   | Long Form         | Numeric   | 2-digit   |
 *  |-----------|:------:|--------|--------------|-------------------|-----------|-----------|
 *  | era       |   G    | G (A)  | GGG (AD)     | GGGG (Anno Domini)| -         | -         |
 *  | year      |   y    | -      | -            | -                 | y (2015)  | yy (15)   |
 *  | month     |   M    | L (S)  | MMM (Sep)    | MMMM (September)  | M (9)     | MM (09)   |
 *  | day       |   d    | -      | -            | -                 | d (3)     | dd (03)   |
 *  | weekday   |   E    | E (S)  | EEE (Sun)    | EEEE (Sunday)     | -         | -         |
 *  | hour      |   j    | -      | -            | -                 | j (13)    | jj (13)   |
 *  | hour12    |   h    | -      | -            | -                 | h (1 PM)  | hh (01 PM)|
 *  | hour24    |   H    | -      | -            | -                 | H (13)    | HH (13)   |
 *  | minute    |   m    | -      | -            | -                 | m (5)     | mm (05)   |
 *  | second    |   s    | -      | -            | -                 | s (9)     | ss (09)   |
 *  | timezone  |   z    | -      | -            | z (Pacific Standard Time)| -  | -         |
 *  | timezone  |   Z    | -      | Z (GMT-8:00) | -                 | -         | -         |
 *  | timezone  |   a    | -      | a (PM)       | -                 | -         | -         |
 *
 * In javascript, only the components specified will be respected (not the ordering,
 * punctuations, ...) and details of the formatting will be dependent on the locale.
 *
 * Timezone of the formatted text will be the local system timezone of the end-user's machine.
 *
 * When the expression is a ISO string without time (e.g. 2016-09-19) the time zone offset is not
 * applied and the formatted text will have the same day, month and year of the expression.
 *
 * WARNINGS:
 * - this pipe is marked as pure hence it will not be re-evaluated when the input is mutated.
 *   Instead users should treat the date as an immutable object and change the reference when the
 *   pipe needs to re-run (this is to avoid reformatting the date on every change detection run
 *   which would be an expensive operation).
 * - this pipe uses the Internationalization API. Therefore it is only reliable in Chrome and Opera
 *   browsers.
 *
 * @usageNotes
 *
 * ### Examples
 *
 * Assuming `dateObj` is (year: 2010, month: 9, day: 3, hour: 12 PM, minute: 05, second: 08)
 * in the _local_ time and locale is 'en-US':
 *
 * {@example common/pipes/ts/date_pipe.ts region='DeprecatedDatePipe'}
 *
 *
 */
var DeprecatedDatePipe = /*@__PURE__*/ (function () {
    function DeprecatedDatePipe(_locale) {
        this._locale = _locale;
    }
    DeprecatedDatePipe_1 = DeprecatedDatePipe;
    DeprecatedDatePipe.prototype.transform = function (value, pattern) {
        if (pattern === void 0) {
            pattern = 'mediumDate';
        }
        if (value == null || value === '' || value !== value)
            return null;
        var date;
        if (typeof value === 'string') {
            value = value.trim();
        }
        if (isDate$1(value)) {
            date = value;
        }
        else if (!isNaN(value - parseFloat(value))) {
            date = new Date(parseFloat(value));
        }
        else if (typeof value === 'string' && /^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
            /**
             * For ISO Strings without time the day, month and year must be extracted from the ISO String
             * before Date creation to avoid time offset and errors in the new Date.
             * If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
             * date, some browsers (e.g. IE 9) will throw an invalid Date error
             * If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the
             * timeoffset
             * is applied
             * Note: ISO months are 0 for January, 1 for February, ...
             */
            var _a = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__read"])(value.split('-').map(function (val) { return parseInt(val, 10); }), 3), y = _a[0], m = _a[1], d = _a[2];
            date = new Date(y, m - 1, d);
        }
        else {
            date = new Date(value);
        }
        if (!isDate$1(date)) {
            var match = void 0;
            if ((typeof value === 'string') && (match = value.match(ISO8601_DATE_REGEX))) {
                date = isoStringToDate(match);
            }
            else {
                throw invalidPipeArgumentError(DeprecatedDatePipe_1, value);
            }
        }
        return DateFormatter.format(date, this._locale, DeprecatedDatePipe_1._ALIASES[pattern] || pattern);
    };
    var DeprecatedDatePipe_1;
    /** @internal */
    DeprecatedDatePipe._ALIASES = {
        'medium': 'yMMMdjms',
        'short': 'yMdjm',
        'fullDate': 'yMMMMEEEEd',
        'longDate': 'yMMMMd',
        'mediumDate': 'yMMMd',
        'shortDate': 'yMd',
        'mediumTime': 'jms',
        'shortTime': 'jm'
    };
    DeprecatedDatePipe = DeprecatedDatePipe_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]))
    ], DeprecatedDatePipe);
    return DeprecatedDatePipe;
}());
function isDate$1(value) {
    return value instanceof Date && !isNaN(value.valueOf());
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function formatNumber$1(pipe, locale, value, style, digits, currency, currencyAsSymbol) {
    if (currency === void 0) {
        currency = null;
    }
    if (currencyAsSymbol === void 0) {
        currencyAsSymbol = false;
    }
    if (value == null)
        return null;
    // Convert strings to numbers
    value = typeof value === 'string' && !isNaN(+value - parseFloat(value)) ? +value : value;
    if (typeof value !== 'number') {
        throw invalidPipeArgumentError(pipe, value);
    }
    var minInt;
    var minFraction;
    var maxFraction;
    if (style !== NumberFormatStyle.Currency) {
        // rely on Intl default for currency
        minInt = 1;
        minFraction = 0;
        maxFraction = 3;
    }
    if (digits) {
        var parts = digits.match(NUMBER_FORMAT_REGEXP);
        if (parts === null) {
            throw new Error(digits + " is not a valid digit info for number pipes");
        }
        if (parts[1] != null) {
            minInt = parseIntAutoRadix(parts[1]);
        }
        if (parts[3] != null) {
            minFraction = parseIntAutoRadix(parts[3]);
        }
        if (parts[5] != null) {
            maxFraction = parseIntAutoRadix(parts[5]);
        }
    }
    return NumberFormatter.format(value, locale, style, {
        minimumIntegerDigits: minInt,
        minimumFractionDigits: minFraction,
        maximumFractionDigits: maxFraction,
        currency: currency,
        currencyAsSymbol: currencyAsSymbol,
    });
}
/**
 * Formats a number as text. Group sizing and separator and other locale-specific
 * configurations are based on the active locale.
 *
 * where `expression` is a number:
 *  - `digitInfo` is a `string` which has a following format: <br>
 *     <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>
 *   - `minIntegerDigits` is the minimum number of integer digits to use. Defaults to `1`.
 *   - `minFractionDigits` is the minimum number of digits after fraction. Defaults to `0`.
 *   - `maxFractionDigits` is the maximum number of digits after fraction. Defaults to `3`.
 *
 * For more information on the acceptable range for each of these numbers and other
 * details see your native internationalization library.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
 *
 * @usageNotes
 *
 * ### Example
 *
 * {@example common/pipes/ts/number_pipe.ts region='DeprecatedNumberPipe'}
 *
 * @ngModule CommonModule
 */
var DeprecatedDecimalPipe = /*@__PURE__*/ (function () {
    function DeprecatedDecimalPipe(_locale) {
        this._locale = _locale;
    }
    DeprecatedDecimalPipe_1 = DeprecatedDecimalPipe;
    DeprecatedDecimalPipe.prototype.transform = function (value, digits) {
        return formatNumber$1(DeprecatedDecimalPipe_1, this._locale, value, NumberFormatStyle.Decimal, digits);
    };
    var DeprecatedDecimalPipe_1;
    DeprecatedDecimalPipe = DeprecatedDecimalPipe_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]))
    ], DeprecatedDecimalPipe);
    return DeprecatedDecimalPipe;
}());
/**
 * @ngModule CommonModule
 *
 * @description
 *
 * Formats a number as percentage according to locale rules.
 *
 * - `digitInfo` See {@link DecimalPipe} for detailed description.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
 *
 * @usageNotes
 *
 * ### Example
 *
 * {@example common/pipes/ts/percent_pipe.ts region='DeprecatedPercentPipe'}
 *
 *
 */
var DeprecatedPercentPipe = /*@__PURE__*/ (function () {
    function DeprecatedPercentPipe(_locale) {
        this._locale = _locale;
    }
    DeprecatedPercentPipe_1 = DeprecatedPercentPipe;
    DeprecatedPercentPipe.prototype.transform = function (value, digits) {
        return formatNumber$1(DeprecatedPercentPipe_1, this._locale, value, NumberFormatStyle.Percent, digits);
    };
    var DeprecatedPercentPipe_1;
    DeprecatedPercentPipe = DeprecatedPercentPipe_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]))
    ], DeprecatedPercentPipe);
    return DeprecatedPercentPipe;
}());
/**
 * @ngModule CommonModule
 * @description
 *
 * Formats a number as currency using locale rules.
 *
 * Use `currency` to format a number as currency.
 *
 * - `currencyCode` is the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code, such
 *    as `USD` for the US dollar and `EUR` for the euro.
 * - `symbolDisplay` is a boolean indicating whether to use the currency symbol or code.
 *   - `true`: use symbol (e.g. `$`).
 *   - `false`(default): use code (e.g. `USD`).
 * - `digitInfo` See {@link DecimalPipe} for detailed description.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See [Browser Support](guide/browser-support) for details.
 *
 * @usageNotes
 *
 * ### Example
 *
 * {@example common/pipes/ts/currency_pipe.ts region='DeprecatedCurrencyPipe'}
 *
 *
 */
var DeprecatedCurrencyPipe = /*@__PURE__*/ (function () {
    function DeprecatedCurrencyPipe(_locale) {
        this._locale = _locale;
    }
    DeprecatedCurrencyPipe_1 = DeprecatedCurrencyPipe;
    DeprecatedCurrencyPipe.prototype.transform = function (value, currencyCode, symbolDisplay, digits) {
        if (currencyCode === void 0) {
            currencyCode = 'USD';
        }
        if (symbolDisplay === void 0) {
            symbolDisplay = false;
        }
        return formatNumber$1(DeprecatedCurrencyPipe_1, this._locale, value, NumberFormatStyle.Currency, digits, currencyCode, symbolDisplay);
    };
    var DeprecatedCurrencyPipe_1;
    DeprecatedCurrencyPipe = DeprecatedCurrencyPipe_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]))
    ], DeprecatedCurrencyPipe);
    return DeprecatedCurrencyPipe;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A collection of deprecated i18n pipes that require intl api
 *
 * @deprecated from v5
 */
var COMMON_DEPRECATED_I18N_PIPES = [DeprecatedDecimalPipe, DeprecatedPercentPipe, DeprecatedCurrencyPipe, DeprecatedDatePipe];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ObservableStrategy = /*@__PURE__*/ (function () {
    function ObservableStrategy() {
    }
    ObservableStrategy.prototype.createSubscription = function (async, updateLatestValue) {
        return async.subscribe({ next: updateLatestValue, error: function (e) { throw e; } });
    };
    ObservableStrategy.prototype.dispose = function (subscription) { subscription.unsubscribe(); };
    ObservableStrategy.prototype.onDestroy = function (subscription) { subscription.unsubscribe(); };
    return ObservableStrategy;
}());
var PromiseStrategy = /*@__PURE__*/ (function () {
    function PromiseStrategy() {
    }
    PromiseStrategy.prototype.createSubscription = function (async, updateLatestValue) {
        return async.then(updateLatestValue, function (e) { throw e; });
    };
    PromiseStrategy.prototype.dispose = function (subscription) { };
    PromiseStrategy.prototype.onDestroy = function (subscription) { };
    return PromiseStrategy;
}());
var _promiseStrategy = /*@__PURE__*/ new PromiseStrategy();
var _observableStrategy = /*@__PURE__*/ new ObservableStrategy();
/**
 * @ngModule CommonModule
 * @description
 *
 * Unwraps a value from an asynchronous primitive.
 *
 * The `async` pipe subscribes to an `Observable` or `Promise` and returns the latest value it has
 * emitted. When a new value is emitted, the `async` pipe marks the component to be checked for
 * changes. When the component gets destroyed, the `async` pipe unsubscribes automatically to avoid
 * potential memory leaks.
 *
 * @usageNotes
 *
 * ### Examples
 *
 * This example binds a `Promise` to the view. Clicking the `Resolve` button resolves the
 * promise.
 *
 * {@example common/pipes/ts/async_pipe.ts region='AsyncPipePromise'}
 *
 * It's also possible to use `async` with Observables. The example below binds the `time` Observable
 * to the view. The Observable continuously updates the view with the current time.
 *
 * {@example common/pipes/ts/async_pipe.ts region='AsyncPipeObservable'}
 *
 */
var AsyncPipe = /*@__PURE__*/ (function () {
    function AsyncPipe(_ref) {
        this._ref = _ref;
        this._latestValue = null;
        this._latestReturnedValue = null;
        this._subscription = null;
        this._obj = null;
        this._strategy = null;
    }
    AsyncPipe_1 = AsyncPipe;
    AsyncPipe.prototype.ngOnDestroy = function () {
        if (this._subscription) {
            this._dispose();
        }
    };
    AsyncPipe.prototype.transform = function (obj) {
        if (!this._obj) {
            if (obj) {
                this._subscribe(obj);
            }
            this._latestReturnedValue = this._latestValue;
            return this._latestValue;
        }
        if (obj !== this._obj) {
            this._dispose();
            return this.transform(obj);
        }
        if (this._latestValue === this._latestReturnedValue) {
            return this._latestReturnedValue;
        }
        this._latestReturnedValue = this._latestValue;
        return __WEBPACK_IMPORTED_MODULE_0__angular_core__["WrappedValue"].wrap(this._latestValue);
    };
    AsyncPipe.prototype._subscribe = function (obj) {
        var _this = this;
        this._obj = obj;
        this._strategy = this._selectStrategy(obj);
        this._subscription = this._strategy.createSubscription(obj, function (value) { return _this._updateLatestValue(obj, value); });
    };
    AsyncPipe.prototype._selectStrategy = function (obj) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisPromise"])(obj)) {
            return _promiseStrategy;
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisObservable"])(obj)) {
            return _observableStrategy;
        }
        throw invalidPipeArgumentError(AsyncPipe_1, obj);
    };
    AsyncPipe.prototype._dispose = function () {
        this._strategy.dispose(this._subscription);
        this._latestValue = null;
        this._latestReturnedValue = null;
        this._subscription = null;
        this._obj = null;
    };
    AsyncPipe.prototype._updateLatestValue = function (async, value) {
        if (async === this._obj) {
            this._latestValue = value;
            this._ref.markForCheck();
        }
    };
    var AsyncPipe_1;
    return AsyncPipe;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Transforms text to all lower case.
 *
 * @see `UpperCasePipe`
 * @see `TitleCasePipe`
 * @usageNotes
 *
 * The following example defines a view that allows the user to enter
 * text, and then uses the pipe to convert the input text to all lower case.
 *
 * <code-example path="common/pipes/ts/lowerupper_pipe.ts" region='LowerUpperPipe'></code-example>
 *
 * @ngModule CommonModule
 */
var LowerCasePipe = /*@__PURE__*/ (function () {
    function LowerCasePipe() {
    }
    LowerCasePipe_1 = LowerCasePipe;
    /**
     * @param value The string to transform to lower case.
     */
    LowerCasePipe.prototype.transform = function (value) {
        if (!value)
            return value;
        if (typeof value !== 'string') {
            throw invalidPipeArgumentError(LowerCasePipe_1, value);
        }
        return value.toLowerCase();
    };
    var LowerCasePipe_1;
    return LowerCasePipe;
}());
//
// Regex below matches any Unicode word and compatible with ES5. In ES2018 the same result
// can be achieved by using /\p{L}\S*/gu and also known as Unicode Property Escapes
// (http://2ality.com/2017/07/regexp-unicode-property-escapes.html). Since there is no
// transpilation of this functionality down to ES5 without external tool, the only solution is
// to use already transpiled form. Example can be found here -
// https://mothereff.in/regexpu#input=var+regex+%3D+/%5Cp%7BL%7D/u%3B&unicodePropertyEscape=1
//
var unicodeWordMatch = /(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D])\S*/g;
/**
 * Transforms text to title case.
 * Capitalizes the first letter of each word, and transforms the
 * rest of the word to lower case.
 * Words are delimited by any whitespace character, such as a space, tab, or line-feed character.
 *
 * @see `LowerCasePipe`
 * @see `UpperCasePipe`
 *
 * @usageNotes
 * The following example shows the result of transforming various strings into title case.
 *
 * <code-example path="common/pipes/ts/titlecase_pipe.ts" region='TitleCasePipe'></code-example>
 *
 * @ngModule CommonModule
 */
var TitleCasePipe = /*@__PURE__*/ (function () {
    function TitleCasePipe() {
    }
    TitleCasePipe_1 = TitleCasePipe;
    /**
     * @param value The string to transform to title case.
     */
    TitleCasePipe.prototype.transform = function (value) {
        if (!value)
            return value;
        if (typeof value !== 'string') {
            throw invalidPipeArgumentError(TitleCasePipe_1, value);
        }
        return value.replace(unicodeWordMatch, (function (txt) { return txt[0].toUpperCase() + txt.substr(1).toLowerCase(); }));
    };
    var TitleCasePipe_1;
    return TitleCasePipe;
}());
/**
 * Transforms text to all upper case.
 * @see `LowerCasePipe`
 * @see `TitleCasePipe`
 *
 * @ngModule CommonModule
 */
var UpperCasePipe = /*@__PURE__*/ (function () {
    function UpperCasePipe() {
    }
    UpperCasePipe_1 = UpperCasePipe;
    /**
     * @param value The string to transform to upper case.
     */
    UpperCasePipe.prototype.transform = function (value) {
        if (!value)
            return value;
        if (typeof value !== 'string') {
            throw invalidPipeArgumentError(UpperCasePipe_1, value);
        }
        return value.toUpperCase();
    };
    var UpperCasePipe_1;
    return UpperCasePipe;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// clang-format off
/**
 * @ngModule CommonModule
 * @description
 *
 * Formats a date value according to locale rules.
 *
 * Only the `en-US` locale data comes with Angular. To localize dates
 * in another language, you must import the corresponding locale data.
 * See the [I18n guide](guide/i18n#i18n-pipes) for more information.
 *
 * @see `formatDate()`
 *
 *
 * @usageNotes
 *
 * The result of this pipe is not reevaluated when the input is mutated. To avoid the need to
 * reformat the date on every change-detection cycle, treat the date as an immutable object
 * and change the reference when the pipe needs to run again.
 *
 * ### Pre-defined format options
 *
 * Examples are given in `en-US` locale.
 *
 * - `'short'`: equivalent to `'M/d/yy, h:mm a'` (`6/15/15, 9:03 AM`).
 * - `'medium'`: equivalent to `'MMM d, y, h:mm:ss a'` (`Jun 15, 2015, 9:03:01 AM`).
 * - `'long'`: equivalent to `'MMMM d, y, h:mm:ss a z'` (`June 15, 2015 at 9:03:01 AM
 * GMT+1`).
 * - `'full'`: equivalent to `'EEEE, MMMM d, y, h:mm:ss a zzzz'` (`Monday, June 15, 2015 at
 * 9:03:01 AM GMT+01:00`).
 * - `'shortDate'`: equivalent to `'M/d/yy'` (`6/15/15`).
 * - `'mediumDate'`: equivalent to `'MMM d, y'` (`Jun 15, 2015`).
 * - `'longDate'`: equivalent to `'MMMM d, y'` (`June 15, 2015`).
 * - `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` (`Monday, June 15, 2015`).
 * - `'shortTime'`: equivalent to `'h:mm a'` (`9:03 AM`).
 * - `'mediumTime'`: equivalent to `'h:mm:ss a'` (`9:03:01 AM`).
 * - `'longTime'`: equivalent to `'h:mm:ss a z'` (`9:03:01 AM GMT+1`).
 * - `'fullTime'`: equivalent to `'h:mm:ss a zzzz'` (`9:03:01 AM GMT+01:00`).
 *
 * ### Custom format options
 *
 * You can construct a format string using symbols to specify the components
 * of a date-time value, as described in the following table.
 * Format details depend on the locale.
 * Fields marked with (*) are only available in the extra data set for the given locale.
 *
 *  | Field type         | Format      | Description                                                   | Example Value                                              |
 *  |--------------------|-------------|---------------------------------------------------------------|------------------------------------------------------------|
 *  | Era                | G, GG & GGG | Abbreviated                                                   | AD                                                         |
 *  |                    | GGGG        | Wide                                                          | Anno Domini                                                |
 *  |                    | GGGGG       | Narrow                                                        | A                                                          |
 *  | Year               | y           | Numeric: minimum digits                                       | 2, 20, 201, 2017, 20173                                    |
 *  |                    | yy          | Numeric: 2 digits + zero padded                               | 02, 20, 01, 17, 73                                         |
 *  |                    | yyy         | Numeric: 3 digits + zero padded                               | 002, 020, 201, 2017, 20173                                 |
 *  |                    | yyyy        | Numeric: 4 digits or more + zero padded                       | 0002, 0020, 0201, 2017, 20173                              |
 *  | Month              | M           | Numeric: 1 digit                                              | 9, 12                                                      |
 *  |                    | MM          | Numeric: 2 digits + zero padded                               | 09, 12                                                     |
 *  |                    | MMM         | Abbreviated                                                   | Sep                                                        |
 *  |                    | MMMM        | Wide                                                          | September                                                  |
 *  |                    | MMMMM       | Narrow                                                        | S                                                          |
 *  | Month standalone   | L           | Numeric: 1 digit                                              | 9, 12                                                      |
 *  |                    | LL          | Numeric: 2 digits + zero padded                               | 09, 12                                                     |
 *  |                    | LLL         | Abbreviated                                                   | Sep                                                        |
 *  |                    | LLLL        | Wide                                                          | September                                                  |
 *  |                    | LLLLL       | Narrow                                                        | S                                                          |
 *  | Week of year       | w           | Numeric: minimum digits                                       | 1... 53                                                    |
 *  |                    | ww          | Numeric: 2 digits + zero padded                               | 01... 53                                                   |
 *  | Week of month      | W           | Numeric: 1 digit                                              | 1... 5                                                     |
 *  | Day of month       | d           | Numeric: minimum digits                                       | 1                                                          |
 *  |                    | dd          | Numeric: 2 digits + zero padded                               | 01                                                          |
 *  | Week day           | E, EE & EEE | Abbreviated                                                   | Tue                                                        |
 *  |                    | EEEE        | Wide                                                          | Tuesday                                                    |
 *  |                    | EEEEE       | Narrow                                                        | T                                                          |
 *  |                    | EEEEEE      | Short                                                         | Tu                                                         |
 *  | Period             | a, aa & aaa | Abbreviated                                                   | am/pm or AM/PM                                             |
 *  |                    | aaaa        | Wide (fallback to `a` when missing)                           | ante meridiem/post meridiem                                |
 *  |                    | aaaaa       | Narrow                                                        | a/p                                                        |
 *  | Period*            | B, BB & BBB | Abbreviated                                                   | mid.                                                       |
 *  |                    | BBBB        | Wide                                                          | am, pm, midnight, noon, morning, afternoon, evening, night |
 *  |                    | BBBBB       | Narrow                                                        | md                                                         |
 *  | Period standalone* | b, bb & bbb | Abbreviated                                                   | mid.                                                       |
 *  |                    | bbbb        | Wide                                                          | am, pm, midnight, noon, morning, afternoon, evening, night |
 *  |                    | bbbbb       | Narrow                                                        | md                                                         |
 *  | Hour 1-12          | h           | Numeric: minimum digits                                       | 1, 12                                                      |
 *  |                    | hh          | Numeric: 2 digits + zero padded                               | 01, 12                                                     |
 *  | Hour 0-23          | H           | Numeric: minimum digits                                       | 0, 23                                                      |
 *  |                    | HH          | Numeric: 2 digits + zero padded                               | 00, 23                                                     |
 *  | Minute             | m           | Numeric: minimum digits                                       | 8, 59                                                      |
 *  |                    | mm          | Numeric: 2 digits + zero padded                               | 08, 59                                                     |
 *  | Second             | s           | Numeric: minimum digits                                       | 0... 59                                                    |
 *  |                    | ss          | Numeric: 2 digits + zero padded                               | 00... 59                                                   |
 *  | Fractional seconds | S           | Numeric: 1 digit                                              | 0... 9                                                     |
 *  |                    | SS          | Numeric: 2 digits + zero padded                               | 00... 99                                                   |
 *  |                    | SSS         | Numeric: 3 digits + zero padded (= milliseconds)              | 000... 999                                                 |
 *  | Zone               | z, zz & zzz | Short specific non location format (fallback to O)            | GMT-8                                                      |
 *  |                    | zzzz        | Long specific non location format (fallback to OOOO)          | GMT-08:00                                                  |
 *  |                    | Z, ZZ & ZZZ | ISO8601 basic format                                          | -0800                                                      |
 *  |                    | ZZZZ        | Long localized GMT format                                     | GMT-8:00                                                   |
 *  |                    | ZZZZZ       | ISO8601 extended format + Z indicator for offset 0 (= XXXXX)  | -08:00                                                     |
 *  |                    | O, OO & OOO | Short localized GMT format                                    | GMT-8                                                      |
 *  |                    | OOOO        | Long localized GMT format                                     | GMT-08:00                                                  |
 *
 * Note that timezone correction is not applied to an ISO string that has no time component, such as "2016-09-19"
 *
 * ### Format examples
 *
 * These examples transform a date into various formats,
 * assuming that `dateObj` is a JavaScript `Date` object for
 * year: 2015, month: 6, day: 15, hour: 21, minute: 43, second: 11,
 * given in the local time for the `en-US` locale.
 *
 * ```
 * {{ dateObj | date }}               // output is 'Jun 15, 2015'
 * {{ dateObj | date:'medium' }}      // output is 'Jun 15, 2015, 9:43:11 PM'
 * {{ dateObj | date:'shortTime' }}   // output is '9:43 PM'
 * {{ dateObj | date:'mmss' }}        // output is '43:11'
 * ```
 *
 * ### Usage example
 *
 * The following component uses a date pipe to display the current date in different formats.
 *
 * ```
 * @Component({
 *  selector: 'date-pipe',
 *  template: `<div>
 *    <p>Today is {{today | date}}</p>
 *    <p>Or if you prefer, {{today | date:'fullDate'}}</p>
 *    <p>The time is {{today | date:'h:mm a z'}}</p>
 *  </div>`
 * })
 * // Get the current date and time as a date-time value.
 * export class DatePipeComponent {
 *   today: number = Date.now();
 * }
 * ```
 *
 */
// clang-format on
var DatePipe = /*@__PURE__*/ (function () {
    function DatePipe(locale) {
        this.locale = locale;
    }
    DatePipe_1 = DatePipe;
    /**
     * @param value The date expression: a `Date` object,  a number
     * (milliseconds since UTC epoch), or an ISO string (https://www.w3.org/TR/NOTE-datetime).
     * @param format The date/time components to include, using predefined options or a
     * custom format string.
     * @param timezone A timezone offset (such as `'+0430'`), or a standard
     * UTC/GMT or continental US timezone abbreviation. Default is
     * the local system timezone of the end-user's machine.
     * @param locale A locale code for the locale format rules to use.
     * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
     * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
     * @returns A date string in the desired format.
     */
    DatePipe.prototype.transform = function (value, format, timezone, locale) {
        if (format === void 0) {
            format = 'mediumDate';
        }
        if (value == null || value === '' || value !== value)
            return null;
        try {
            return formatDate(value, format, locale || this.locale, timezone);
        }
        catch (error) {
            throw invalidPipeArgumentError(DatePipe_1, error.message);
        }
    };
    var DatePipe_1;
    DatePipe = DatePipe_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]))
    ], DatePipe);
    return DatePipe;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _INTERPOLATION_REGEXP = /#/g;
/**
 * @ngModule CommonModule
 * @description
 *
 * Maps a value to a string that pluralizes the value according to locale rules.
 *
 * @usageNotes
 *
 * ### Example
 *
 * {@example common/pipes/ts/i18n_pipe.ts region='I18nPluralPipeComponent'}
 *
 * @experimental
 */
var I18nPluralPipe = /*@__PURE__*/ (function () {
    function I18nPluralPipe(_localization) {
        this._localization = _localization;
    }
    I18nPluralPipe_1 = I18nPluralPipe;
    /**
     * @param value the number to be formatted
     * @param pluralMap an object that mimics the ICU format, see
     * http://userguide.icu-project.org/formatparse/messages.
     * @param locale a `string` defining the locale to use (uses the current {@link LOCALE_ID} by
     * default).
     */
    I18nPluralPipe.prototype.transform = function (value, pluralMap, locale) {
        if (value == null)
            return '';
        if (typeof pluralMap !== 'object' || pluralMap === null) {
            throw invalidPipeArgumentError(I18nPluralPipe_1, pluralMap);
        }
        var key = getPluralCategory(value, Object.keys(pluralMap), this._localization, locale);
        return pluralMap[key].replace(_INTERPOLATION_REGEXP, value.toString());
    };
    var I18nPluralPipe_1;
    return I18nPluralPipe;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @ngModule CommonModule
 * @description
 *
 * Generic selector that displays the string that matches the current value.
 *
 * If none of the keys of the `mapping` match the `value`, then the content
 * of the `other` key is returned when present, otherwise an empty string is returned.
 *
 * @usageNotes
 *
 * ### Example
 *
 * {@example common/pipes/ts/i18n_pipe.ts region='I18nSelectPipeComponent'}
 *
 * @experimental
 */
var I18nSelectPipe = /*@__PURE__*/ (function () {
    function I18nSelectPipe() {
    }
    I18nSelectPipe_1 = I18nSelectPipe;
    /**
     * @param value a string to be internationalized.
     * @param mapping an object that indicates the text that should be displayed
     * for different values of the provided `value`.
     */
    I18nSelectPipe.prototype.transform = function (value, mapping) {
        if (value == null)
            return '';
        if (typeof mapping !== 'object' || typeof value !== 'string') {
            throw invalidPipeArgumentError(I18nSelectPipe_1, mapping);
        }
        if (mapping.hasOwnProperty(value)) {
            return mapping[value];
        }
        if (mapping.hasOwnProperty('other')) {
            return mapping['other'];
        }
        return '';
    };
    var I18nSelectPipe_1;
    return I18nSelectPipe;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @ngModule CommonModule
 * @description
 *
 * Converts a value into its JSON-format representation.  Useful for debugging.
 *
 * @usageNotes
 *
 * The following component uses a JSON pipe to convert an object
 * to JSON format, and displays the string in both formats for comparison.
 *
 * {@example common/pipes/ts/json_pipe.ts region='JsonPipe'}
 *
 */
var JsonPipe = /*@__PURE__*/ (function () {
    function JsonPipe() {
    }
    /**
     * @param value A value of any type to convert into a JSON-format string.
     */
    JsonPipe.prototype.transform = function (value) { return JSON.stringify(value, null, 2); };
    return JsonPipe;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function makeKeyValuePair(key, value) {
    return { key: key, value: value };
}
/**
 * @ngModule CommonModule
 * @description
 *
 * Transforms Object or Map into an array of key value pairs.
 *
 * The output array will be ordered by keys.
 * By default the comparator will be by Unicode point value.
 * You can optionally pass a compareFn if your keys are complex types.
 *
 * @usageNotes
 * ### Examples
 *
 * This examples show how an Object or a Map and be iterated by ngFor with the use of this keyvalue
 * pipe.
 *
 * {@example common/pipes/ts/keyvalue_pipe.ts region='KeyValuePipe'}
 */
var KeyValuePipe = /*@__PURE__*/ (function () {
    function KeyValuePipe(differs) {
        this.differs = differs;
    }
    KeyValuePipe.prototype.transform = function (input, compareFn) {
        var _this = this;
        if (compareFn === void 0) {
            compareFn = defaultComparator;
        }
        if (!input || (!(input instanceof Map) && typeof input !== 'object')) {
            return null;
        }
        if (!this.differ) {
            // make a differ for whatever type we've been passed in
            this.differ = this.differs.find(input).create();
        }
        var differChanges = this.differ.diff(input);
        if (differChanges) {
            this.keyValues = [];
            differChanges.forEachItem(function (r) {
                _this.keyValues.push(makeKeyValuePair(r.key, r.currentValue));
            });
            this.keyValues.sort(compareFn);
        }
        return this.keyValues;
    };
    return KeyValuePipe;
}());
function defaultComparator(keyValueA, keyValueB) {
    var a = keyValueA.key;
    var b = keyValueB.key;
    // if same exit with 0;
    if (a === b)
        return 0;
    // make sure that undefined are at the end of the sort.
    if (a === undefined)
        return 1;
    if (b === undefined)
        return -1;
    // make sure that nulls are at the end of the sort.
    if (a === null)
        return 1;
    if (b === null)
        return -1;
    if (typeof a == 'string' && typeof b == 'string') {
        return a < b ? -1 : 1;
    }
    if (typeof a == 'number' && typeof b == 'number') {
        return a - b;
    }
    if (typeof a == 'boolean' && typeof b == 'boolean') {
        return a < b ? -1 : 1;
    }
    // `a` and `b` are of different types. Compare their string values.
    var aString = String(a);
    var bString = String(b);
    return aString == bString ? 0 : aString < bString ? -1 : 1;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @ngModule CommonModule
 * @description
 *
 * Transforms a number into a string,
 * formatted according to locale rules that determine group sizing and
 * separator, decimal-point character, and other locale-specific
 * configurations.
 *
 * If no parameters are specified, the function rounds off to the nearest value using this
 * [rounding method](https://en.wikibooks.org/wiki/Arithmetic/Rounding).
 * The behavior differs from that of the JavaScript ```Math.round()``` function.
 * In the following case for example, the pipe rounds down where
 * ```Math.round()``` rounds up:
 *
 * ```html
 * -2.5 | number:'1.0-0'
 * > -3
 * Math.round(-2.5)
 * > -2
 * ```
 *
 * @see `formatNumber()`
 *
 * @usageNotes
 * The following code shows how the pipe transforms numbers
 * into text strings, according to various format specifications,
 * where the caller's default locale is `en-US`.
 *
 * ### Example
 *
 * <code-example path="common/pipes/ts/number_pipe.ts" region='NumberPipe'></code-example>
 *
 */
var DecimalPipe = /*@__PURE__*/ (function () {
    function DecimalPipe(_locale) {
        this._locale = _locale;
    }
    DecimalPipe_1 = DecimalPipe;
    /**
     * @param value The number to be formatted.
     * @param digitsInfo Decimal representation options, specified by a string
     * in the following format:<br>
     * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
     *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
     * Default is `1`.
     *   - `minFractionDigits`: The minimum number of digits after the decimal point.
     * Default is `0`.
     *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
     * Default is `3`.
     * @param locale A locale code for the locale format rules to use.
     * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
     * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
     */
    DecimalPipe.prototype.transform = function (value, digitsInfo, locale) {
        if (isEmpty(value))
            return null;
        locale = locale || this._locale;
        try {
            var num = strToNumber(value);
            return formatNumber(num, locale, digitsInfo);
        }
        catch (error) {
            throw invalidPipeArgumentError(DecimalPipe_1, error.message);
        }
    };
    var DecimalPipe_1;
    DecimalPipe = DecimalPipe_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]))
    ], DecimalPipe);
    return DecimalPipe;
}());
/**
 * @ngModule CommonModule
 * @description
 *
 * Transforms a number to a percentage
 * string, formatted according to locale rules that determine group sizing and
 * separator, decimal-point character, and other locale-specific
 * configurations.
 *
 * @see `formatPercent()`
 *
 * @usageNotes
 * The following code shows how the pipe transforms numbers
 * into text strings, according to various format specifications,
 * where the caller's default locale is `en-US`.
 *
 * <code-example path="common/pipes/ts/percent_pipe.ts" region='PercentPipe'></code-example>
 *
 *
 */
var PercentPipe = /*@__PURE__*/ (function () {
    function PercentPipe(_locale) {
        this._locale = _locale;
    }
    PercentPipe_1 = PercentPipe;
    /**
     *
     * @param value The number to be formatted as a percentage.
     * @param digitsInfo Decimal representation options, specified by a string
     * in the following format:<br>
     * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
     *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
     * Default is `1`.
     *   - `minFractionDigits`: The minimum number of digits after the decimal point.
     * Default is `0`.
     *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
     * Default is `3`.
     * @param locale A locale code for the locale format rules to use.
     * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
     * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
     */
    PercentPipe.prototype.transform = function (value, digitsInfo, locale) {
        if (isEmpty(value))
            return null;
        locale = locale || this._locale;
        try {
            var num = strToNumber(value);
            return formatPercent(num, locale, digitsInfo);
        }
        catch (error) {
            throw invalidPipeArgumentError(PercentPipe_1, error.message);
        }
    };
    var PercentPipe_1;
    PercentPipe = PercentPipe_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]))
    ], PercentPipe);
    return PercentPipe;
}());
/**
 * @ngModule CommonModule
 * @description
 *
 * Transforms a number to a currency string, formatted according to locale rules
 * that determine group sizing and separator, decimal-point character,
 * and other locale-specific configurations.
 *
 * @see `getCurrencySymbol()`
 * @see `formatCurrency()`
 *
 * @usageNotes
 * The following code shows how the pipe transforms numbers
 * into text strings, according to various format specifications,
 * where the caller's default locale is `en-US`.
 *
 * <code-example path="common/pipes/ts/currency_pipe.ts" region='CurrencyPipe'></code-example>
 *
 *
 */
var CurrencyPipe = /*@__PURE__*/ (function () {
    function CurrencyPipe(_locale) {
        this._locale = _locale;
    }
    CurrencyPipe_1 = CurrencyPipe;
    /**
     *
     * @param value The number to be formatted as currency.
     * @param currencyCode The [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code,
     * such as `USD` for the US dollar and `EUR` for the euro.
     * @param display The format for the currency indicator. One of the following:
     *   - `code`: Show the code (such as `USD`).
     *   - `symbol`(default): Show the symbol (such as `$`).
     *   - `symbol-narrow`: Use the narrow symbol for locales that have two symbols for their
     * currency.
     * For example, the Canadian dollar CAD has the symbol `CA$` and the symbol-narrow `$`. If the
     * locale has no narrow symbol, uses the standard symbol for the locale.
     *   - String: Use the given string value instead of a code or a symbol.
     * For example, an empty string will suppress the currency & symbol.
     *   - Boolean (marked deprecated in v5): `true` for symbol and false for `code`.
     *
     * @param digitsInfo Decimal representation options, specified by a string
     * in the following format:<br>
     * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
     *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
     * Default is `1`.
     *   - `minFractionDigits`: The minimum number of digits after the decimal point.
     * Default is `0`.
     *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
     * Default is `3`.
     * If not provided, the number will be formatted with the proper amount of digits,
     * depending on what the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) specifies.
     * For example, the Canadian dollar has 2 digits, whereas the Chilean peso has none.
     * @param locale A locale code for the locale format rules to use.
     * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
     * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
     */
    CurrencyPipe.prototype.transform = function (value, currencyCode, display, digitsInfo, locale) {
        if (display === void 0) {
            display = 'symbol';
        }
        if (isEmpty(value))
            return null;
        locale = locale || this._locale;
        if (typeof display === 'boolean') {
            if (console && console.warn) {
                console.warn("Warning: the currency pipe has been changed in Angular v5. The symbolDisplay option (third parameter) is now a string instead of a boolean. The accepted values are \"code\", \"symbol\" or \"symbol-narrow\".");
            }
            display = display ? 'symbol' : 'code';
        }
        var currency = currencyCode || 'USD';
        if (display !== 'code') {
            if (display === 'symbol' || display === 'symbol-narrow') {
                currency = getCurrencySymbol(currency, display === 'symbol' ? 'wide' : 'narrow', locale);
            }
            else {
                currency = display;
            }
        }
        try {
            var num = strToNumber(value);
            return formatCurrency(num, locale, currency, currencyCode, digitsInfo);
        }
        catch (error) {
            throw invalidPipeArgumentError(CurrencyPipe_1, error.message);
        }
    };
    var CurrencyPipe_1;
    CurrencyPipe = CurrencyPipe_1 = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"]))
    ], CurrencyPipe);
    return CurrencyPipe;
}());
function isEmpty(value) {
    return value == null || value === '' || value !== value;
}
/**
 * Transforms a string into a number (if needed).
 */
function strToNumber(value) {
    // Convert strings to numbers
    if (typeof value === 'string' && !isNaN(Number(value) - parseFloat(value))) {
        return Number(value);
    }
    if (typeof value !== 'number') {
        throw new Error(value + " is not a number");
    }
    return value;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @ngModule CommonModule
 * @description
 *
 * Creates a new `Array` or `String` containing a subset (slice) of the elements.
 *
 * @usageNotes
 *
 * All behavior is based on the expected behavior of the JavaScript API `Array.prototype.slice()`
 * and `String.prototype.slice()`.
 *
 * When operating on an `Array`, the returned `Array` is always a copy even when all
 * the elements are being returned.
 *
 * When operating on a blank value, the pipe returns the blank value.
 *
 * ### List Example
 *
 * This `ngFor` example:
 *
 * {@example common/pipes/ts/slice_pipe.ts region='SlicePipe_list'}
 *
 * produces the following:
 *
 * ```html
 * <li>b</li>
 * <li>c</li>
 * ```
 *
 * ### String Examples
 *
 * {@example common/pipes/ts/slice_pipe.ts region='SlicePipe_string'}
 *
 */
var SlicePipe = /*@__PURE__*/ (function () {
    function SlicePipe() {
    }
    SlicePipe_1 = SlicePipe;
    /**
     * @param value a list or a string to be sliced.
     * @param start the starting index of the subset to return:
     *   - **a positive integer**: return the item at `start` index and all items after
     *     in the list or string expression.
     *   - **a negative integer**: return the item at `start` index from the end and all items after
     *     in the list or string expression.
     *   - **if positive and greater than the size of the expression**: return an empty list or
     * string.
     *   - **if negative and greater than the size of the expression**: return entire list or string.
     * @param end the ending index of the subset to return:
     *   - **omitted**: return all items until the end.
     *   - **if positive**: return all items before `end` index of the list or string.
     *   - **if negative**: return all items before `end` index from the end of the list or string.
     */
    SlicePipe.prototype.transform = function (value, start, end) {
        if (value == null)
            return value;
        if (!this.supports(value)) {
            throw invalidPipeArgumentError(SlicePipe_1, value);
        }
        return value.slice(start, end);
    };
    SlicePipe.prototype.supports = function (obj) { return typeof obj === 'string' || Array.isArray(obj); };
    var SlicePipe_1;
    return SlicePipe;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A collection of Angular pipes that are likely to be used in each and every application.
 */
var COMMON_PIPES = [
    AsyncPipe,
    UpperCasePipe,
    LowerCasePipe,
    JsonPipe,
    SlicePipe,
    DecimalPipe,
    PercentPipe,
    TitleCasePipe,
    CurrencyPipe,
    DatePipe,
    I18nPluralPipe,
    I18nSelectPipe,
    KeyValuePipe,
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Note: This does not contain the location providers,
// as they need some platform specific implementations to work.
/**
 * Exports all the basic Angular directives and pipes,
 * such as `NgIf`, `NgForOf`, `DecimalPipe`, and so on.
 * Re-exported by `BrowserModule`, which is included automatically in the root
 * `AppModule` when you create a new app with the CLI `new` command.
 *
 * * The `providers` options configure the NgModule's injector to provide
 * localization dependencies to members.
 * * The `exports` options make the declared directives and pipes available for import
 * by other NgModules.
 *
 */
var CommonModule = /*@__PURE__*/ (function () {
    function CommonModule() {
    }
    return CommonModule;
}());
var ɵ0 = getPluralCase;
/**
 * A module that contains the deprecated i18n pipes.
 *
 * @deprecated from v5
 */
var DeprecatedI18NPipesModule = /*@__PURE__*/ (function () {
    function DeprecatedI18NPipesModule() {
    }
    return DeprecatedI18NPipesModule;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A DI Token representing the main rendering context. In a browser this is the DOM Document.
 *
 * Note: Document might not be available in the Application Context when Application and Rendering
 * Contexts are not the same (e.g. when running the application into a Web Worker).
 *
 *
 */
var DOCUMENT = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('DocumentToken');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var PLATFORM_BROWSER_ID = 'browser';
var PLATFORM_SERVER_ID = 'server';
var PLATFORM_WORKER_APP_ID = 'browserWorkerApp';
var PLATFORM_WORKER_UI_ID = 'browserWorkerUi';
/**
 * Returns whether a platform id represents a browser platform.
 * @experimental
 */
function isPlatformBrowser(platformId) {
    return platformId === PLATFORM_BROWSER_ID;
}
/**
 * Returns whether a platform id represents a server platform.
 * @experimental
 */
function isPlatformServer(platformId) {
    return platformId === PLATFORM_SERVER_ID;
}
/**
 * Returns whether a platform id represents a web worker app platform.
 * @experimental
 */
function isPlatformWorkerApp(platformId) {
    return platformId === PLATFORM_WORKER_APP_ID;
}
/**
 * Returns whether a platform id represents a web worker UI platform.
 * @experimental
 */
function isPlatformWorkerUi(platformId) {
    return platformId === PLATFORM_WORKER_UI_ID;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var VERSION = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('6.1.10');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Manages the scroll position.
 */
var ViewportScroller = /*@__PURE__*/ (function () {
    function ViewportScroller() {
    }
    // De-sugared tree-shakable injection
    // See #23917
    /** @nocollapse */
    ViewportScroller.ngInjectableDef = Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["defineInjectable"])({ providedIn: 'root', factory: function () { return new BrowserViewportScroller(Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["inject"])(DOCUMENT), window); } });
    return ViewportScroller;
}());
/**
 * Manages the scroll position.
 */
var BrowserViewportScroller = /*@__PURE__*/ (function () {
    function BrowserViewportScroller(document, window) {
        this.document = document;
        this.window = window;
        this.offset = function () { return [0, 0]; };
    }
    /**
     * Configures the top offset used when scrolling to an anchor.
     *
     * * When given a number, the service will always use the number.
     * * When given a function, the service will invoke the function every time it restores scroll
     * position.
     */
    BrowserViewportScroller.prototype.setOffset = function (offset) {
        if (Array.isArray(offset)) {
            this.offset = function () { return offset; };
        }
        else {
            this.offset = offset;
        }
    };
    /**
     * Returns the current scroll position.
     */
    BrowserViewportScroller.prototype.getScrollPosition = function () {
        if (this.supportScrollRestoration()) {
            return [this.window.scrollX, this.window.scrollY];
        }
        else {
            return [0, 0];
        }
    };
    /**
     * Sets the scroll position.
     */
    BrowserViewportScroller.prototype.scrollToPosition = function (position) {
        if (this.supportScrollRestoration()) {
            this.window.scrollTo(position[0], position[1]);
        }
    };
    /**
     * Scrolls to the provided anchor.
     */
    BrowserViewportScroller.prototype.scrollToAnchor = function (anchor) {
        if (this.supportScrollRestoration()) {
            var elSelectedById = this.document.querySelector("#" + anchor);
            if (elSelectedById) {
                this.scrollToElement(elSelectedById);
                return;
            }
            var elSelectedByName = this.document.querySelector("[name='" + anchor + "']");
            if (elSelectedByName) {
                this.scrollToElement(elSelectedByName);
                return;
            }
        }
    };
    /**
     * Disables automatic scroll restoration provided by the browser.
     */
    BrowserViewportScroller.prototype.setHistoryScrollRestoration = function (scrollRestoration) {
        if (this.supportScrollRestoration()) {
            var history_1 = this.window.history;
            if (history_1 && history_1.scrollRestoration) {
                history_1.scrollRestoration = scrollRestoration;
            }
        }
    };
    BrowserViewportScroller.prototype.scrollToElement = function (el) {
        var rect = el.getBoundingClientRect();
        var left = rect.left + this.window.pageXOffset;
        var top = rect.top + this.window.pageYOffset;
        var offset = this.offset();
        this.window.scrollTo(left - offset[0], top - offset[1]);
    };
    /**
     * We only support scroll restoration when we can get a hold of window.
     * This means that we do not support this behavior when running in a web worker.
     *
     * Lifting this restriction right now would require more changes in the dom adapter.
     * Since webworkers aren't widely used, we will lift it once RouterScroller is
     * battle-tested.
     */
    BrowserViewportScroller.prototype.supportScrollRestoration = function () {
        try {
            return !!this.window && !!this.window.scrollTo;
        }
        catch (e) {
            return false;
        }
    };
    return BrowserViewportScroller;
}());
/**
 * Provides an empty implementation of the viewport scroller. This will
 * live in @angular/common as it will be used by both platform-server and platform-webworker.
 */
var NullViewportScroller = /*@__PURE__*/ (function () {
    function NullViewportScroller() {
    }
    /**
     * Empty implementation
     */
    NullViewportScroller.prototype.setOffset = function (offset) { };
    /**
     * Empty implementation
     */
    NullViewportScroller.prototype.getScrollPosition = function () { return [0, 0]; };
    /**
     * Empty implementation
     */
    NullViewportScroller.prototype.scrollToPosition = function (position) { };
    /**
     * Empty implementation
     */
    NullViewportScroller.prototype.scrollToAnchor = function (anchor) { };
    /**
     * Empty implementation
     */
    NullViewportScroller.prototype.setHistoryScrollRestoration = function (scrollRestoration) { };
    return NullViewportScroller;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */






/***/ }),

/***/ "wZJE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Experimental API below
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * get input values
 *
 * Extended by: Gabriel Schuster <github.com@actra.de>
 * Now gets values of inputs (including "checked" status radios, checkboxes), textareas and selects (including multiselects)
 * Tries to identify the elements as exact as possible, falls back to numeric index when identification fails
 * WIP refactor by: PatrickJS
 */
function __getInputValues() {
    var _inputs = document.querySelectorAll('input, textarea, select');
    var inputs = Array.prototype.slice.call(_inputs);
    return inputs.map(function (input) {
        var inputTagName = input.tagName.toLowerCase();
        var inputType = input.type;
        var inputId = (input.id && typeof input.id === 'string') ? input.id : null;
        var inputName = (input.name && typeof input.name === 'string') ? input.name : null;
        var inputValue = (input.value && typeof input.value === 'string') ? input.value : null;
        var inputChildNodes = input.childNodes;
        var inputSelected = Boolean(input.selected);
        var elementStore = {
            'tag': inputTagName,
            'type': null,
            'id': inputId,
            'name': inputName,
            'value': '',
            'checked': false,
            'options': []
        };
        if ('input' === inputTagName || 'textarea' === inputTagName) {
            elementStore['type'] = inputType;
            if ('input' !== inputTagName) {
                elementStore['value'] = inputValue;
                return elementStore;
            }
            switch (inputType) {
                case 'checkbox':
                case 'radio':
                    elementStore['checked'] = inputSelected;
                    elementStore['value'] = inputValue;
                    return elementStore;
                case 'image':
                case 'button':
                case 'submit':
                case 'reset':
                default:
                    // These types don't need any config and thus need no update, they only were stored because they match "input"
                    return elementStore;
            }
        }
        else if ('select' === inputTagName) {
            var childNodes = Array.prototype.slice.call(inputChildNodes);
            var options = childNodes.map(function (option, i) {
                return { value: option['value'], selected: Boolean(option['selected']) };
            });
            elementStore['options'] = options;
            return elementStore;
        }
        return elementStore;
    });
}
exports.__getInputValues = __getInputValues;
/**
 * set input values
 *
 * Extended by: Gabriel Schuster <github.com@actra.de>
 * WIP refactor by: PatrickJS
 */
function __setInputValues($inputs) {
    var inputs = document.querySelectorAll('input, textarea');
    $inputs.forEach(function (store, i) {
        if ('input' === store.tag || 'textarea' === store.tag) {
            if ('input' === store.tag && ('checkbox' === store.type || 'radio' === store.type)) {
                var selector = 'input' + (null !== store.id ? '#' + store.id : '') + '[type="' + store.type + '"]' + (null !== store.name ? '[name="' + store.name + '"]' : '') +
                    '[value="' + store.value + '"]';
                var element = document.body.querySelector(selector);
                if (element && Boolean(store['checked'])) {
                    element['checked'] = 'checked';
                    element.dispatchEvent(new CustomEvent('input', { detail: element['checked'] }));
                }
            }
            else if ('input' === store.tagName.toLowerCase() &&
                ('image' === store.type || 'button' === store.type || 'submit' === store.type || 'reset' === store.type)) {
                // These types don't need any config and thus need no update, they only were stored because they match "input"
            }
            else {
                if (null === store.id && null === store.name) {
                    if (store.value.length &&
                        inputs[i] &&
                        inputs[i].tagName.toLowerCase() === store.tag &&
                        ('textarea' === store.tag || inputs[i].getAttribute('type') === store.type) &&
                        ('string' !== typeof inputs[i].id || !inputs[i].id.length) &&
                        ('string' !== typeof inputs[i].getAttribute('name') ||
                            !inputs[i].getAttribute('name').length)) {
                        inputs[i]['value'] = store.value;
                        inputs[i].dispatchEvent(new CustomEvent('input', { detail: inputs[i]['value'] }));
                    }
                }
                else {
                    var selector = 'input' +
                        (null !== store.id ? '#' + store.id : '') + ('input' === store.tag ? '[type="' + store.type + '"]' : '') +
                        (null !== store.name ? '[name="' + store.name + '"]' : '');
                    var element = document.body.querySelector(selector);
                    if (element && store.value.length) {
                        element['value'] = store.value;
                        element.dispatchEvent(new CustomEvent('input', { detail: element['value'] }));
                    }
                }
            }
        }
        else if ('select' === store.tag) {
            var select_1 = null;
            if (null === store.id && null === store.name) {
                if (inputs[i] && inputs[i].tagName.toLowerCase() === store.tag && ('string' !== typeof inputs[i].id || !inputs[i].id.length) &&
                    ('string' !== typeof inputs[i].getAttribute('name') || !inputs[i].getAttribute('name').length)) {
                    select_1 = inputs[i];
                }
            }
            else {
                var selector = 'select' + (null !== store.id ? '#' + store.id : '') + (null !== store.name ? '[name="' + store.name + '"]' : '');
                var element = document.body.querySelector(selector);
                if (element) {
                    select_1 = element;
                }
            }
            if (select_1) {
                store.options.forEach(function (storedOption, j) {
                    var option = select_1.querySelector('option[value="' + storedOption.value + '"]');
                    if (!option &&
                        select_1.childNodes[j] &&
                        ('string' !== typeof select_1.childNodes[j]['value'] || !select_1.childNodes[j]['value'].length)) {
                        option = select_1.childNodes[j];
                    }
                    if (option && !!storedOption.selected) {
                        option['selected'] = 'selected';
                        option.dispatchEvent(new CustomEvent('input', { detail: option['selected'] }));
                    }
                });
            }
        }
    });
}
exports.__setInputValues = __setInputValues;
function __createInputTransfer() {
    var $inputs = __getInputValues();
    return function restoreInputValues() {
        return __setInputValues($inputs);
    };
}
exports.__createInputTransfer = __createInputTransfer;
//# sourceMappingURL=experimental.js.map

/***/ }),

/***/ "wdeq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("TToO");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/util/Immediate.js
var Immediate = __webpack_require__("bdRZ");

// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncAction.js + 1 modules
var AsyncAction = __webpack_require__("2mZA");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsapAction.js
/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */



/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsapAction_AsapAction = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = Immediate["a" /* Immediate */].setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            Immediate["a" /* Immediate */].clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}(AsyncAction["a" /* AsyncAction */]));





// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsyncScheduler.js
var AsyncScheduler = __webpack_require__("g8cW");

// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/AsapScheduler.js
/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */


var AsapScheduler_AsapScheduler = /*@__PURE__*/ (function (_super) {
    tslib_es6["__extends"](AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler["a" /* AsyncScheduler */]));





// CONCATENATED MODULE: ./node_modules/rxjs/_esm5/internal/scheduler/asap.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asap; });
/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */


/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */
var asap = /*@__PURE__*/ new AsapScheduler_AsapScheduler(AsapAction_AsapAction);
//# sourceMappingURL=asap.js.map


/***/ }),

/***/ "xne+":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'ss':
            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        ss : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),

/***/ "xond":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("FCuZ"),
    getSymbolsIn = __webpack_require__("09Qt"),
    keysIn = __webpack_require__("t8rQ");

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ "y986":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return extras; });
/* unused harmony export Reaction */
/* unused harmony export untracked */
/* unused harmony export IDerivationState */
/* unused harmony export Atom */
/* unused harmony export BaseAtom */
/* unused harmony export useStrict */
/* unused harmony export isStrictModeEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return spy; });
/* unused harmony export comparer */
/* unused harmony export asReference */
/* unused harmony export asFlat */
/* unused harmony export asStructure */
/* unused harmony export asMap */
/* unused harmony export isModifierDescriptor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isObservableObject; });
/* unused harmony export isBoxedObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isObservableArray; });
/* unused harmony export ObservableMap */
/* unused harmony export isObservableMap */
/* unused harmony export map */
/* unused harmony export transaction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return observable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return computed; });
/* unused harmony export isObservable */
/* unused harmony export isComputed */
/* unused harmony export extendObservable */
/* unused harmony export extendShallowObservable */
/* unused harmony export observe */
/* unused harmony export intercept */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return autorun; });
/* unused harmony export autorunAsync */
/* unused harmony export when */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return reaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return action; });
/* unused harmony export isAction */
/* unused harmony export runInAction */
/* unused harmony export expr */
/* unused harmony export toJS */
/* unused harmony export createTransformer */
/* unused harmony export whyRun */
/* unused harmony export trace */
/* unused harmony export isArrayLike */
/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */
var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p]; };
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var BaseAtom = /*@__PURE__*/ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function BaseAtom(name) {
        if (name === void 0) {
            name = "Atom@" + getNextId();
        }
        this.name = name;
        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    BaseAtom.prototype.onBecomeUnobserved = function () {
        // noop
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     */
    BaseAtom.prototype.reportObserved = function () {
        reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    BaseAtom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    BaseAtom.prototype.toString = function () {
        return this.name;
    };
    return BaseAtom;
}());
var Atom = /*@__PURE__*/ (function (_super) {
    __extends(Atom, _super);
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
        if (name === void 0) {
            name = "Atom@" + getNextId();
        }
        if (onBecomeObservedHandler === void 0) {
            onBecomeObservedHandler = noop;
        }
        if (onBecomeUnobservedHandler === void 0) {
            onBecomeUnobservedHandler = noop;
        }
        var _this = _super.call(this, name) || this;
        _this.name = name;
        _this.onBecomeObservedHandler = onBecomeObservedHandler;
        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
        _this.isPendingUnobservation = false; // for effective unobserving.
        _this.isBeingTracked = false;
        return _this;
    }
    Atom.prototype.reportObserved = function () {
        startBatch();
        _super.prototype.reportObserved.call(this);
        if (!this.isBeingTracked) {
            this.isBeingTracked = true;
            this.onBecomeObservedHandler();
        }
        endBatch();
        return !!globalState.trackingDerivation;
        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
    };
    Atom.prototype.onBecomeUnobserved = function () {
        this.isBeingTracked = false;
        this.onBecomeUnobservedHandler();
    };
    return Atom;
}(BaseAtom));
var isAtom = createInstanceofPredicate("Atom", BaseAtom);
function hasInterceptors(interceptable) {
    return interceptable.interceptors && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}
function isSpyEnabled() {
    return !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (!globalState.spyListeners.length)
        return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart(event) {
    var change = objectAssign({}, event, { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (change)
        spyReport(objectAssign({}, change, END_EVENT));
    else
        spyReport(END_EVENT);
}
function spy(listener) {
    globalState.spyListeners.push(listener);
    return once(function () {
        var idx = globalState.spyListeners.indexOf(listener);
        if (idx !== -1)
            globalState.spyListeners.splice(idx, 1);
    });
}
function iteratorSymbol() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}
var IS_ITERATING_MARKER = "__$$iterating";
function arrayAsIterator(array) {
    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
    // yet it is quite convenient to be able to use the response both as array directly and as iterator
    // it is suboptimal, but alas...
    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
    var idx = -1;
    addHiddenFinalProp(array, "next", function next() {
        idx++;
        return {
            done: idx >= this.length,
            value: idx < this.length ? this[idx] : undefined
        };
    });
    return array;
}
function declareIterator(prototType, iteratorFactory) {
    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
}
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = /*@__PURE__*/ (function () {
    function StubArray() {
    }
    return StubArray;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /*@__PURE__*/ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.interceptors = null;
        this.changeListeners = null;
        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined)
            return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) {
            fireImmediately = false;
        }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = [];
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
        var _a;
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray = /*@__PURE__*/ (function (_super) {
    __extends(ObservableArray, _super);
    function ObservableArray(initialValues, enhancer, name, owned) {
        if (name === void 0) {
            name = "ObservableArray@" + getNextId();
        }
        if (owned === void 0) {
            owned = false;
        }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            _this.spliceWithArray(0, 0, initialValues);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) {
            fireImmediately = false;
        }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
    };
    ObservableArray.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) {
            fromIndex = 0;
        }
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) {
            fromIndex = 0;
        }
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray.prototype.move = function (fromIndex, toIndex) {
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = oldItems.slice(0, toIndex).concat([
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
                .values
                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    };
    return ObservableArray;
}(StubArray));
declareIterator(ObservableArray.prototype, function () {
    return arrayAsIterator(this.slice());
});
Object.defineProperty(ObservableArray.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp(ObservableArray.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable(ObservableArray.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            // TODO: Check `this`?, see #752?
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer(1000);
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
}
var UNCHANGED = {};
var ObservableValue = /*@__PURE__*/ (function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy) {
        if (name === void 0) {
            name = "ObservableValue@" + getNextId();
        }
        if (notifySpy === void 0) {
            notifySpy = true;
        }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.dehancer = undefined;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled()) {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", object: _this, newValue: _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy) {
                spyReportStart({
                    type: "update",
                    object: this,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    return ObservableValue;
}(BaseAtom));
ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
var messages = {
    m001: "It is not allowed to assign new values to @action fields",
    m002: "`runInAction` expects a function",
    m003: "`runInAction` expects a function without arguments",
    m004: "autorun expects a function",
    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
    m012: "computed takes one or two arguments if used as function",
    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
    m014: "extendObservable expected 2 or more arguments",
    m015: "extendObservable expects an object as first argument",
    m016: "extendObservable should not be used on maps, use map.merge instead",
    m017: "all arguments of extendObservable should be objects",
    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
    m020: "modifiers can only be used for individual object properties",
    m021: "observable expects zero or one arguments",
    m022: "@observable can not be used on getters, use @computed instead",
    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
    m025: "whyRun can only be used on reactions and computed values",
    m026: "`action` can only be invoked on functions",
    m028: "It is not allowed to set `useStrict` when a derivation is running",
    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
    m033: "`observe` doesn't support the fire immediately property for observable maps.",
    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
    m035: "Cannot make the designated object observable; it is not extensible",
    m036: "It is not possible to get index atoms from arrays",
    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
};
function getMessage(id) {
    return messages[id];
}
function createAction(actionName, fn) {
    invariant(typeof fn === "function", getMessage("m026"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    var res = function () {
        return executeAction(actionName, fn, this, arguments);
    };
    res.originalFn = fn;
    res.isMobxAction = true;
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart({
            type: "action",
            name: actionName,
            fn: fn,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd({ time: Date.now() - runInfo.startTime });
}
function useStrict(strict) {
    invariant(globalState.trackingDerivation === null, getMessage("m028"));
    globalState.strictMode = strict;
    globalState.allowStateChanges = !strict;
}
function isStrictModeEnabled() {
    return globalState.strictMode;
}
function allowStateChanges(allowStateChanges, func) {
    // TODO: deprecate / refactor this function in next major
    // Currently only used by `@observer`
    // Proposed change: remove first param, rename to `forbidStateChanges`,
    // require error callback instead of the hardcoded error message now used
    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
/**
 * Constructs a decorator, that normalizes the differences between
 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
 * values during instance creation to properties that have a getter setter.
 *
 * - Sigh -
 *
 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
 */
function createClassPropertyDecorator(
/**
 * This function is invoked once, when the property is added to a new instance.
 * When this happens is not strictly determined due to differences in TS and Babel:
 * Typescript: Usually when constructing the new instance
 * Babel, sometimes Typescript: during the first get / set
 * Both: when calling `runLazyInitializers(instance)`
 */
onInitialize, get, set, enumerable, 
/**
 * Can this decorator invoked with arguments? e.g. @decorator(args)
 */
allowCustomArguments) {
    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
        if (argLen === void 0) {
            argLen = 0;
        }
        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
        if (!descriptor) {
            // typescript (except for getter / setters)
            var newDescriptor = {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
                    }
                    else {
                        set.call(this, key, v);
                    }
                }
            };
            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
                // Typescript target is ES3, so it won't define property for us
                // or using Reflect.decorate polyfill, which will return no descriptor
                // (see https://github.com/mobxjs/mobx/issues/333)
                Object.defineProperty(target, key, newDescriptor);
            }
            return newDescriptor;
        }
        else {
            // babel and typescript getter / setter props
            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
                );
            }
            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
            target.__mobxLazyInitializers.push(function (instance) {
                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
            });
            return {
                enumerable: enumerable,
                configurable: true,
                get: function () {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    return get.call(this, key);
                },
                set: function (v) {
                    if (this.__mobxDidRunLazyInitializers !== true)
                        runLazyInitializers(this);
                    set.call(this, key, v);
                }
            };
        }
    }
    if (allowCustomArguments) {
        /** If custom arguments are allowed, we should return a function that returns a decorator */
        return function () {
            /** Direct invocation: @decorator bla */
            if (quacksLikeADecorator(arguments))
                return classPropertyDecorator.apply(null, arguments);
            /** Indirect invocation: @decorator(args) bla */
            var outerArgs = arguments;
            var argLen = arguments.length;
            return function (target, key, descriptor) {
                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
            };
        };
    }
    return classPropertyDecorator;
}
function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
        addHiddenProp(instance, "__mobxInitializedProps", {});
    instance.__mobxInitializedProps[key] = true;
    onInitialize(instance, key, v, customArgs, baseDescriptor);
}
function runLazyInitializers(instance) {
    if (instance.__mobxDidRunLazyInitializers === true)
        return;
    if (instance.__mobxLazyInitializers) {
        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
        instance.__mobxDidRunLazyInitializers &&
            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
    }
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
}
var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
    var wrappedAction = action(actionName, value);
    addHiddenProp(target, key, wrappedAction);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, true);
var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
    defineBoundAction(target, key, value);
}, function (key) {
    return this[key];
}, function () {
    invariant(false, getMessage("m001"));
}, false, false);
var action = function action(arg1, arg2, arg3, arg4) {
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction(arg1.name || "<unnamed action>", arg1);
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction(arg1, arg2);
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator(arg1);
    return namedActionDecorator(arg2).apply(null, arguments);
};
action.bound = function boundAction(arg1, arg2, arg3) {
    if (typeof arg1 === "function") {
        var action_1 = createAction("<not yet bound action>", arg1);
        action_1.autoBind = true;
        return action_1;
    }
    return boundActionDecorator.apply(null, arguments);
};
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor && typeof descriptor.value === "function") {
            // TypeScript @action method() { }. Defined on proto before being decorated
            // Don't use the field decorator if we are just decorating a method
            descriptor.value = createAction(name, descriptor.value);
            descriptor.enumerable = false;
            descriptor.configurable = true;
            return descriptor;
        }
        if (descriptor !== undefined && descriptor.get !== undefined) {
            throw new Error("[mobx] action is not expected to be used with getters");
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function runInAction(arg1, arg2, arg3) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    var scope = typeof arg1 === "function" ? arg2 : arg3;
    invariant(typeof fn === "function", getMessage("m002"));
    invariant(fn.length === 0, getMessage("m003"));
    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
    return executeAction(actionName, fn, scope, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    var res = function () {
        return executeAction(propertyName, fn, target, arguments);
    };
    res.isMobxAction = true;
    addHiddenProp(target, propertyName, res);
}
var toString = Object.prototype.toString;
function deepEqual(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys = Object.keys(a), key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a))
        return a.peek();
    if (isObservableMap(a))
        return a.entries();
    if (isES6Map(a))
        return iteratorToArray(a.entries());
    return a;
}
function has(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN(a, b) || identityComparer(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};
function autorun(arg1, arg2, arg3) {
    var name, view, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        view = arg2;
        scope = arg3;
    }
    else {
        name = arg1.name || "Autorun@" + getNextId();
        view = arg1;
        scope = arg2;
    }
    invariant(typeof view === "function", getMessage("m004"));
    invariant(isAction(view) === false, getMessage("m005"));
    if (scope)
        view = view.bind(scope);
    var reaction = new Reaction(name, function () {
        this.track(reactionRunner);
    });
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
function when(arg1, arg2, arg3, arg4) {
    var name, predicate, effect, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        predicate = arg2;
        effect = arg3;
        scope = arg4;
    }
    else {
        name = "When@" + getNextId();
        predicate = arg1;
        effect = arg2;
        scope = arg3;
    }
    var disposer = autorun(name, function (r) {
        if (predicate.call(scope)) {
            r.dispose();
            var prevUntracked = untrackedStart();
            effect.call(scope);
            untrackedEnd(prevUntracked);
        }
    });
    return disposer;
}
function autorunAsync(arg1, arg2, arg3, arg4) {
    var name, func, delay, scope;
    if (typeof arg1 === "string") {
        name = arg1;
        func = arg2;
        delay = arg3;
        scope = arg4;
    }
    else {
        name = arg1.name || "AutorunAsync@" + getNextId();
        func = arg1;
        delay = arg2;
        scope = arg3;
    }
    invariant(isAction(func) === false, getMessage("m006"));
    if (delay === void 0)
        delay = 1;
    if (scope)
        func = func.bind(scope);
    var isScheduled = false;
    var r = new Reaction(name, function () {
        if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                if (!r.isDisposed)
                    r.track(reactionRunner);
            }, delay);
        }
    });
    function reactionRunner() {
        func(r);
    }
    r.schedule();
    return r.getDisposer();
}
function reaction(expression, effect, arg3) {
    if (arguments.length > 3) {
        fail(getMessage("m007"));
    }
    if (isModifierDescriptor(expression)) {
        fail(getMessage("m008"));
    }
    var opts;
    if (typeof arg3 === "object") {
        opts = arg3;
    }
    else {
        opts = {};
    }
    opts.name =
        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
    opts.delay = opts.delay || 0;
    opts.compareStructural = opts.compareStructural || opts.struct || false;
    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
    if (opts.context) {
        expression = expression.bind(opts.context);
    }
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    var r = new Reaction(opts.name, function () {
        if (firstTime || opts.delay < 1) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            setTimeout(function () {
                isScheduled = false;
                reactionRunner();
            }, opts.delay);
        }
    });
    function reactionRunner() {
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effect(value, r);
        if (!firstTime && changed === true)
            effect(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /*@__PURE__*/ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce an new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(derivation, scope, equals, name, setter) {
        this.derivation = derivation;
        this.scope = scope;
        this.equals = equals;
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        this.name = name || "ComputedValue@" + getNextId();
        if (setter)
            this.setter = createAction(name + "-setter", setter);
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        clearObserving(this);
        this.value = undefined;
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
        if (globalState.inBatch === 0) {
            // This is an minor optimization which could be omitted to simplify the code
            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
            // tracking as it will never be called again inside this batch.
            startBatch();
            if (shouldCompute(this)) {
                if (this.isTracing !== TraceMode.NONE) {
                    console.log("[mobx.trace] '" + this
                        .name + "' is being read outside a reactive context and doing a full recompute");
                }
                this.value = this.computeValue(false);
            }
            endBatch();
        }
        else {
            reportObserved(this);
            if (shouldCompute(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result))
            throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res))
            throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this
                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant(false, "[ComputedValue '" + this
                .name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled()) {
            spyReport({
                object: this.scope,
                type: "compute",
                fn: this.derivation
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = (this.value = this.computeValue(true));
        return (wasSuspended ||
            isCaughtException(oldValue) ||
            isCaughtException(newValue) ||
            !this.equals(oldValue, newValue));
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        }
        else {
            try {
                res = this.derivation.call(this.scope);
            }
            catch (e) {
                res = new CaughtException(e);
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype.whyRun = function () {
        var isTracking = Boolean(globalState.trackingDerivation);
        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
            ? "[active] the value of this computation is needed by a reaction"
            : this.isComputing
                ? "[get] The value of this computed was requested outside a reaction"
                : "[idle] not running at the moment") + "\n" +
            (this.dependenciesState === IDerivationState.NOT_TRACKING
                ? getMessage("m032")
                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
                    ? " (... or any observable accessed during the remainder of the current run)"
                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
    };
    return ComputedValue;
}());
ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
var ObservableObjectAdministration = /*@__PURE__*/ (function () {
    function ObservableObjectAdministration(target, name) {
        this.target = target;
        this.name = name;
        this.values = {};
        this.changeListeners = null;
        this.interceptors = null;
    }
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableObjectAdministration;
}());
function asObservableObject(target, name) {
    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
        return target.$mobx;
    invariant(Object.isExtensible(target), getMessage("m035"));
    if (!isPlainObject(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name)
        name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, name);
    addHiddenFinalProp(target, "$mobx", adm);
    return adm;
}
function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
        // already observable property
        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
        return;
    }
    // not yet observable property
    if ("value" in descriptor) {
        // not a computed value
        if (isModifierDescriptor(descriptor.value)) {
            // x : ref(someValue)
            var modifierDescriptor = descriptor.value;
            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
        }
        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
        }
        else if (isComputedValue(descriptor.value)) {
            // x: computed(someExpr)
            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
        }
        else {
            // x: someValue
            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
        }
    }
    else {
        // get x() { return 3 } set x(v) { }
        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
    }
}
function defineObservableProperty(adm, propName, newValue, enhancer) {
    assertPropertyConfigurable(adm.target, propName);
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            object: adm.target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable.value; // observableValue might have changed it
    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
    notifyPropertyAddition(adm, adm.target, propName, newValue);
}
function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
    if (asInstanceProperty)
        assertPropertyConfigurable(adm.target, propName);
    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
    if (asInstanceProperty) {
        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
    }
}
function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
    var name = adm.name + "." + propName;
    computedValue.name = name;
    if (!computedValue.scope)
        computedValue.scope = adm.target;
    adm.values[propName] = computedValue;
    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
}
var observablePropertyConfigs = {};
var computedPropertyConfigs = {};
function generateObservablePropConfig(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                setPropertyValue(this, propName, v);
            }
        }));
}
function generateComputedPropConfig(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return this.$mobx.values[propName].get();
            },
            set: function (v) {
                return this.$mobx.values[propName].set(v);
            }
        }));
}
function setPropertyValue(instance, name, newValue) {
    var adm = instance.$mobx;
    var observable = adm.values[name];
    // intercept
    if (hasInterceptors(adm)) {
        var change = interceptChange(adm, {
            type: "update",
            object: instance,
            name: name,
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    newValue = observable.prepareNewValue(newValue);
    // notify spy & observers
    if (newValue !== UNCHANGED) {
        var notify = hasListeners(adm);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy
            ? {
                type: "update",
                object: instance,
                oldValue: observable.value,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        observable.setNewValue(newValue);
        if (notify)
            notifyListeners(adm, change);
        if (notifySpy)
            spyReportEnd();
    }
}
function notifyPropertyAddition(adm, object, name, newValue) {
    var notify = hasListeners(adm);
    var notifySpy = isSpyEnabled();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: name,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart(change);
    if (notify)
        notifyListeners(adm, change);
    if (notifySpy)
        spyReportEnd();
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}
/**
 * Returns true if the provided value is reactive.
 * @param value object, function or array
 * @param property if property is specified, checks whether value.property is reactive.
 */
function isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableArray(value) || isObservableMap(value))
            throw new Error(getMessage("m019"));
        else if (isObservableObject(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject(value) ||
        !!value.$mobx ||
        isAtom(value) ||
        isReaction(value) ||
        isComputedValue(value));
}
function createDecoratorForEnhancer(enhancer) {
    invariant(!!enhancer, ":(");
    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
        assertPropertyConfigurable(target, name);
        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
        var adm = asObservableObject(target, undefined);
        defineObservableProperty(adm, name, baseValue, enhancer);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        setPropertyValue(this, name, value);
    }, true, false);
}
function extendObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, deepEnhancer, properties);
}
function extendShallowObservable(target) {
    var properties = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        properties[_i - 1] = arguments[_i];
    }
    return extendObservableHelper(target, referenceEnhancer, properties);
}
function extendObservableHelper(target, defaultEnhancer, properties) {
    invariant(arguments.length >= 2, getMessage("m014"));
    invariant(typeof target === "object", getMessage("m015"));
    invariant(!isObservableMap(target), getMessage("m016"));
    properties.forEach(function (propSet) {
        invariant(typeof propSet === "object", getMessage("m017"));
        invariant(!isObservable(propSet), getMessage("m018"));
    });
    var adm = asObservableObject(target);
    var definedProps = {};
    // Note could be optimised if properties.length === 1
    for (var i = properties.length - 1; i >= 0; i--) {
        var propSet = properties[i];
        for (var key in propSet)
            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
                definedProps[key] = true;
                if (target === propSet && !isPropertyConfigurable(target, key))
                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
            }
    }
    return target;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v) {
    if (v === void 0) {
        v = undefined;
    }
    // @observable someProp;
    if (typeof arguments[1] === "string")
        return deepDecorator.apply(null, arguments);
    invariant(arguments.length <= 1, getMessage("m021"));
    invariant(!isModifierDescriptor(v), getMessage("m020"));
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    var res = deepEnhancer(v, undefined, undefined);
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    return observable.box(v);
}
var observableFactories = {
    box: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        return new ObservableValue(value, deepEnhancer, name);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        return new ObservableValue(value, referenceEnhancer, name);
    },
    array: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        return new ObservableArray(initialValues, deepEnhancer, name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        return new ObservableArray(initialValues, referenceEnhancer, name);
    },
    map: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        return new ObservableMap(initialValues, deepEnhancer, name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        return new ObservableMap(initialValues, referenceEnhancer, name);
    },
    object: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("object");
        var res = {};
        // convert to observable object
        asObservableObject(res, name);
        // add properties
        extendObservable(res, props);
        return res;
    },
    shallowObject: function (props, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowObject");
        var res = {};
        asObservableObject(res, name);
        extendShallowObservable(res, props);
        return res;
    },
    ref: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(referenceEnhancer, arguments[0]);
        }
        else {
            return refDecorator.apply(null, arguments);
        }
    },
    shallow: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(shallowEnhancer, arguments[0]);
        }
        else {
            return shallowDecorator.apply(null, arguments);
        }
    },
    deep: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepEnhancer, arguments[0]);
        }
        else {
            return deepDecorator.apply(null, arguments);
        }
    },
    struct: function () {
        if (arguments.length < 2) {
            // although ref creates actually a modifier descriptor, the type of the resultig properties
            // of the object is `T` in the end, when the descriptors are interpreted
            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
        }
        else {
            return deepStructDecorator.apply(null, arguments);
        }
    }
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
observable.deep.struct = observable.struct;
observable.ref.struct = function () {
    if (arguments.length < 2) {
        return createModifierDescriptor(refStructEnhancer, arguments[0]);
    }
    else {
        return refStructDecorator.apply(null, arguments);
    }
};
function incorrectlyUsedAsDecorator(methodName) {
    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}
function isModifierDescriptor(thing) {
    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
}
function createModifierDescriptor(enhancer, initialValue) {
    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
    return {
        isMobxModifierDescriptor: true,
        initialValue: initialValue,
        enhancer: enhancer
    };
}
function deepEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable.array(v, name);
    if (isPlainObject(v))
        return observable.object(v, name);
    if (isES6Map(v))
        return observable.map(v, name);
    return v;
}
function shallowEnhancer(v, _, name) {
    if (isModifierDescriptor(v))
        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
    if (v === undefined || v === null)
        return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
        return v;
    if (Array.isArray(v))
        return observable.shallowArray(v, name);
    if (isPlainObject(v))
        return observable.shallowObject(v, name);
    if (isES6Map(v))
        return observable.shallowMap(v, name);
    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function deepStructEnhancer(v, oldValue, name) {
    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
    // more suited for immutable objects
    if (deepEqual(v, oldValue))
        return oldValue;
    // it is an observable already, done
    if (isObservable(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return new ObservableArray(v, deepStructEnhancer, name);
    if (isES6Map(v))
        return new ObservableMap(v, deepStructEnhancer, name);
    if (isPlainObject(v)) {
        var res = {};
        asObservableObject(res, name);
        extendObservableHelper(res, deepStructEnhancer, [v]);
        return res;
    }
    return v;
}
function refStructEnhancer(v, oldValue, name) {
    if (deepEqual(v, oldValue))
        return oldValue;
    return v;
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) {
        thisArg = undefined;
    }
    startBatch();
    try {
        return action.apply(thisArg);
    }
    finally {
        endBatch();
    }
}
var ObservableMapMarker = {};
var ObservableMap = /*@__PURE__*/ (function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) {
            enhancer = deepEnhancer;
        }
        if (name === void 0) {
            name = "ObservableMap@" + getNextId();
        }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._data = Object.create(null);
        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
        this.interceptors = null;
        this.changeListeners = null;
        this.dehancer = undefined;
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return typeof this._data[key] !== "undefined";
    };
    ObservableMap.prototype.has = function (key) {
        if (!this.isValidKey(key))
            return false;
        key = "" + key;
        if (this._hasMap[key])
            return this._hasMap[key].get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap.prototype.set = function (key, value) {
        this.assertValidKey(key);
        key = "" + key;
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        this.assertValidKey(key);
        key = "" + key;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data[key].value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            transaction(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data[key];
                observable$$1.setNewValue(undefined);
                _this._data[key] = undefined;
            });
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap[key];
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
        }
        return entry;
    };
    ObservableMap.prototype._updateValue = function (name, newValue) {
        var observable$$1 = this._data[name];
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: name,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart(change);
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners(this, change);
            if (notifySpy)
                spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (name, newValue) {
        var _this = this;
        transaction(function () {
            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(name, true);
            _this._keys.push(name);
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: name,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart(change);
        if (notify)
            notifyListeners(this, change);
        if (notifySpy)
            spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        key = "" + key;
        if (this.has(key))
            return this.dehanceValue(this._data[key].get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        return arrayAsIterator(this._keys.slice());
    };
    ObservableMap.prototype.values = function () {
        return arrayAsIterator(this._keys.map(this.get, this));
    };
    ObservableMap.prototype.entries = function () {
        var _this = this;
        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            if (isPlainObject(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    return _this.set(key, value);
                });
            else if (isES6Map(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                _this.keys().forEach(_this.delete, _this);
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        transaction(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys(values);
            var oldKeys = _this.keys();
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values);
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values might still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        var _this = this;
        var res = {};
        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
        return res;
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableMap.prototype.isValidKey = function (key) {
        if (key === null || key === undefined)
            return false;
        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
            return true;
        return false;
    };
    ObservableMap.prototype.assertValidKey = function (key) {
        if (!this.isValidKey(key))
            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        invariant(fireImmediately !== true, getMessage("m033"));
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}());
declareIterator(ObservableMap.prototype, function () {
    return this.entries();
});
function map(initialValues) {
    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
    return observable.map(initialValues);
}
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
function getGlobal() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message, thing) {
    invariant(false, message, thing);
    throw "X"; // unreachable
}
function invariant(check, message, thing) {
    if (!check)
        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg) {
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function () { };
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function joinStrings(things, limit, separator) {
    if (limit === void 0) {
        limit = 100;
    }
    if (separator === void 0) {
        separator = " - ";
    }
    if (!things)
        return "";
    var sliced = things.slice(0, limit);
    return "" + sliced.join(separator) + (things.length > limit
        ? " (... and " + (things.length - limit) + "more)"
        : "");
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function objectAssign() {
    var res = arguments[0];
    for (var i = 1, l = arguments.length; i < l; i++) {
        var source = arguments[i];
        for (var key in source)
            if (hasOwnProperty(source, key)) {
                res[key] = source[key];
            }
    }
    return res;
}
var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(object, propName) {
    return prototypeHasOwnProperty.call(object, propName);
}
function makeNonEnumerable(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable(object, prop) {
    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
function areBothNaN(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
        return true;
    return false;
}
function getMapLikeKeys(map$$1) {
    if (isPlainObject(map$$1))
        return Object.keys(map$$1);
    if (Array.isArray(map$$1))
        return map$$1.map(function (_a) {
            var key = _a[0];
            return key;
        });
    if (isES6Map(map$$1))
        return Array.from(map$$1.keys());
    if (isObservableMap(map$$1))
        return map$$1.keys();
    return fail("Cannot get keys from " + map$$1);
}
function iteratorToArray(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol() {
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
var MobXGlobals = /*@__PURE__*/ (function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.strictMode = false;
        /**
         * Used by createTransformer to detect that the global state has been reset.
         */
        this.resetId = 0;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
    }
    return MobXGlobals;
}());
var globalState = new MobXGlobals();
var shareGlobalStateCalled = false;
var runInIsolationCalled = false;
var warnedAboutMultipleInstances = false;
{
    var global_1 = getGlobal();
    if (!global_1.__mobxInstanceCount) {
        global_1.__mobxInstanceCount = 1;
    }
    else {
        global_1.__mobxInstanceCount++;
        setTimeout(function () {
            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
                warnedAboutMultipleInstances = true;
                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
            }
        }, 1);
    }
}
function isolateGlobalState() {
    runInIsolationCalled = true;
    getGlobal().__mobxInstanceCount--;
}
function shareGlobalState() {
    // TODO: remove in 4.0; just use peer dependencies instead.
    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
    shareGlobalStateCalled = true;
    var global = getGlobal();
    var ownState = globalState;
    /**
     * Backward compatibility check
     */
    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
    if (global.__mobxGlobal)
        globalState = global.__mobxGlobal;
    else
        global.__mobxGlobal = ownState;
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    globalState.resetId++;
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.strictMode;
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            invariant(property === undefined, getMessage("m036"));
            return thing.$mobx.atom;
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom(anyThing._keys);
            var observable = anyThing._data[property] || anyThing._hasMap[property];
            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        runLazyInitializers(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072 // TODO: remove in 4.0
        if (isObservableObject(thing)) {
            if (!property)
                return fail("please specify a property");
            var observable = thing.$mobx.values[property];
            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail("Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    invariant(thing, "Expecting some object");
    if (property !== undefined)
        return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
        return thing;
    if (isObservableMap(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    runLazyInitializers(thing);
    if (thing.$mobx)
        return thing.$mobx;
    invariant(false, "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom(thing, property);
    else if (isObservableObject(thing) || isObservableMap(thing))
        named = getAdministration(thing);
    else
        named = getAtom(thing); // valid for arrays as well
    return named.name;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node))
        result.observers = getObservers(node).map(nodeToObserverTree);
    return result;
}
function hasObservers(observable) {
    return observable.observers && observable.observers.length > 0;
}
function getObservers(observable) {
    return observable.observers;
}
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable.observersIndexes[node.__mapid] = l;
    }
    observable.observers[l] = node;
    if (observable.lowestObserverState > node.dependenciesState)
        observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable.observers.length === 1) {
        // deleting last observer
        observable.observers.length = 0;
        queueForUnobservation(observable);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable.observers;
        var map = observable.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (!observable.isPendingUnobservation) {
        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.length === 0) {
                observable.onBecomeUnobserved();
                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
        }
    }
    else if (observable.observers.length === 0) {
        queueForUnobservation(observable);
    }
}
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE)
        return;
    observable.lowestObserverState = IDerivationState.STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}
var IDerivationState = /*@__PURE__*/ (function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
    return IDerivationState;
})({});
var TraceMode = /*@__PURE__*/ (function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
    return TraceMode;
})({});
var CaughtException = /*@__PURE__*/ (function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}());
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    try {
                        obj.get();
                    }
                    catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            return false;
        }
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers$$1)
        fail(getMessage("m031") + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && hasObservers$$1)
        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    try {
        result = f.call(context);
    }
    catch (e) {
        result = new CaughtException(e);
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    var res = action();
    untrackedEnd(prev);
    return res;
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}
function log(msg) {
    console.log(msg);
    return msg;
}
function whyRun(thing, prop) {
    deprecated("`whyRun` is deprecated in favor of `trace`");
    thing = getAtomFromArgs(arguments);
    if (!thing)
        return log(getMessage("m024"));
    if (isComputedValue(thing) || isReaction(thing))
        return log(thing.whyRun());
    return fail(getMessage("m025"));
}
function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
var Reaction = /*@__PURE__*/ (function () {
    function Reaction(name, onInvalidate) {
        if (name === void 0) {
            name = "Reaction@" + getNextId();
        }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                this.onInvalidate();
                if (this._isTrackPending && isSpyEnabled()) {
                    // onInvalidate didn't trigger track right away..
                    spyReport({
                        object: this,
                        type: "scheduled-reaction"
                    });
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart({
                object: this,
                type: "reaction",
                fn: fn
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        var messageToUser = getMessage("m037");
        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                message: message,
                error: error,
                object: this
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        r.onError = registerErrorHandler;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.whyRun = function () {
        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
            ? "stopped"
            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
            ? " (... or any observable accessed during the remainder of the current run)"
            : "") + "\n\t" + getMessage("m038") + "\n";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) {
            enterBreakPoint = false;
        }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}());
function registerErrorHandler(handler) {
    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
    this.$mobx.errorHandler = handler;
}
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}
function asReference(value) {
    deprecated("asReference is deprecated, use observable.ref instead");
    return observable.ref(value);
}
function asStructure(value) {
    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
    return observable.struct(value);
}
function asFlat(value) {
    deprecated("asFlat is deprecated, use observable.shallow instead");
    return observable.shallow(value);
}
function asMap(data) {
    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
    return observable.map(data || {});
}
function createComputedDecorator(equals) {
    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
        var adm = asObservableObject(target, "");
        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
    }, function (name) {
        var observable = this.$mobx.values[name];
        if (observable === undefined // See #505
        )
            return undefined;
        return observable.get();
    }, function (name, value) {
        this.$mobx.values[name].set(value);
    }, false, false);
}
var computedDecorator = createComputedDecorator(comparer.default);
var computedStructDecorator = createComputedDecorator(comparer.structural);
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        return computedDecorator.apply(null, arguments);
    }
    invariant(typeof arg1 === "function", getMessage("m011"));
    invariant(arguments.length < 3, getMessage("m012"));
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
    var equals = opts.equals
        ? opts.equals
        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
};
computed.struct = computedStructDecorator;
computed.equals = createComputedDecorator;
function isComputed(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}
function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}
/**
 * expr can be used to create temporarily views inside views.
 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
 *
 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
 * instead it will only rerenders when the current todo is (de)selected.
 *
 * reactiveComponent((props) => {
 *     const todo = props.todo;
 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
 * });
 *
 */
function expr(expr, scope) {
    if (!isComputingDerivation())
        console.warn(getMessage("m013"));
    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
    return computed(expr, { context: scope }).get();
}
function toJS(source, detectCycles, __alreadySeen) {
    if (detectCycles === void 0) {
        detectCycles = true;
    }
    if (__alreadySeen === void 0) {
        __alreadySeen = [];
    }
    // optimization: using ES6 map would be more efficient!
    // optimization: lift this function outside toJS, this makes recursion expensive
    function cache(value) {
        if (detectCycles)
            __alreadySeen.push([source, value]);
        return value;
    }
    if (isObservable(source)) {
        if (detectCycles && __alreadySeen === null)
            __alreadySeen = [];
        if (detectCycles && source !== null && typeof source === "object") {
            for (var i = 0, l = __alreadySeen.length; i < l; i++)
                if (__alreadySeen[i][0] === source)
                    return __alreadySeen[i][1];
        }
        if (isObservableArray(source)) {
            var res = cache([]);
            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
            res.length = toAdd.length;
            for (var i = 0, l = toAdd.length; i < l; i++)
                res[i] = toAdd[i];
            return res;
        }
        if (isObservableObject(source)) {
            var res = cache({});
            for (var key in source)
                res[key] = toJS(source[key], detectCycles, __alreadySeen);
            return res;
        }
        if (isObservableMap(source)) {
            var res_1 = cache({});
            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
            return res_1;
        }
        if (isObservableValue(source))
            return toJS(source.get(), detectCycles, __alreadySeen);
    }
    return source;
}
function createTransformer(transformer, onCleanup) {
    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
    // Memoizes: object id -> reactive view that applies transformer to the object
    var objectCache = {};
    // If the resetId changes, we will clear the object cache, see #163
    // This construction is used to avoid leaking refs to the objectCache directly
    var resetId = globalState.resetId;
    // Local transformer class specifically for this transformer
    var Transformer = /*@__PURE__*/ (function (_super) {
        __extends(Transformer, _super);
        function Transformer(sourceIdentifier, sourceObject) {
            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
            _this.sourceIdentifier = sourceIdentifier;
            _this.sourceObject = sourceObject;
            return _this;
        }
        Transformer.prototype.onBecomeUnobserved = function () {
            var lastValue = this.value;
            _super.prototype.onBecomeUnobserved.call(this);
            delete objectCache[this.sourceIdentifier];
            if (onCleanup)
                onCleanup(lastValue, this.sourceObject);
        };
        return Transformer;
    }(ComputedValue));
    return function (object) {
        if (resetId !== globalState.resetId) {
            objectCache = {};
            resetId = globalState.resetId;
        }
        var identifier = getMemoizationId(object);
        var reactiveTransformer = objectCache[identifier];
        if (reactiveTransformer)
            return reactiveTransformer.get();
        // Not in cache; create a reactive view
        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
        return reactiveTransformer.get();
    };
}
function getMemoizationId(object) {
    if (typeof object === "string" || typeof object === "number")
        return object;
    if (object === null || typeof object !== "object")
        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
    var tid = object.$transformId;
    if (tid === undefined) {
        tid = getNextId();
        addHiddenProp(object, "$transformId", tid);
    }
    return tid;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    }
    else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string")
            return fail("InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    }
    else {
        return fail("Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail("An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}
/**
 * (c) Michel Weststrate 2015 - 2016
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
var extras = {
    allowStateChanges: allowStateChanges,
    deepEqual: deepEqual,
    getAtom: getAtom,
    getDebugName: getDebugName,
    getDependencyTree: getDependencyTree,
    getAdministration: getAdministration,
    getGlobalState: getGlobalState,
    getObserverTree: getObserverTree,
    interceptReads: interceptReads,
    isComputingDerivation: isComputingDerivation,
    isSpyEnabled: isSpyEnabled,
    onReactionError: onReactionError,
    reserveArrayBuffer: reserveArrayBuffer,
    resetGlobalState: resetGlobalState,
    isolateGlobalState: isolateGlobalState,
    shareGlobalState: shareGlobalState,
    spyReport: spyReport,
    spyReportEnd: spyReportEnd,
    spyReportStart: spyReportStart,
    setReactionScheduler: setReactionScheduler
};
var everything = {
    Reaction: Reaction,
    untracked: untracked,
    Atom: Atom,
    BaseAtom: BaseAtom,
    useStrict: useStrict,
    isStrictModeEnabled: isStrictModeEnabled,
    spy: spy,
    comparer: comparer,
    asReference: asReference,
    asFlat: asFlat,
    asStructure: asStructure,
    asMap: asMap,
    isModifierDescriptor: isModifierDescriptor,
    isObservableObject: isObservableObject,
    isBoxedObservable: isObservableValue,
    isObservableArray: isObservableArray,
    ObservableMap: ObservableMap,
    isObservableMap: isObservableMap,
    map: map,
    transaction: transaction,
    observable: observable,
    computed: computed,
    isObservable: isObservable,
    isComputed: isComputed,
    extendObservable: extendObservable,
    extendShallowObservable: extendShallowObservable,
    observe: observe,
    intercept: intercept,
    autorun: autorun,
    autorunAsync: autorunAsync,
    when: when,
    reaction: reaction,
    action: action,
    isAction: isAction,
    runInAction: runInAction,
    expr: expr,
    toJS: toJS,
    createTransformer: createTransformer,
    whyRun: whyRun,
    isArrayLike: isArrayLike,
    extras: extras
};
var warnedAboutDefaultExport = false;
var _loop_1 = function (p) {
    var val = everything[p];
    Object.defineProperty(everything, p, {
        get: function () {
            if (!warnedAboutDefaultExport) {
                warnedAboutDefaultExport = true;
                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
                    "and won’t work in mobx@4.0.0\n" +
                    "Use `import * as mobx from 'mobx'` instead");
            }
            return val;
        }
    });
};
for (var p in everything) {
    _loop_1(p);
}
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
}

/* unused harmony default export */ var _unused_webpack_default_export = (everything);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "y9NZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("DxBg");


/***/ }),

/***/ "yCNF":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "yCRx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("TdOr");
var color_picker_service_1 = __webpack_require__("RlMM");
var formats_1 = __webpack_require__("3BtS");
var helpers_1 = __webpack_require__("/mv9");
var ColorPickerComponent = /*@__PURE__*/ (function () {
    function ColorPickerComponent(el, cdr, service) {
        this.el = el;
        this.cdr = cdr;
        this.service = service;
        this.dialogArrowSize = 10;
        this.dialogArrowOffset = 15;
        this.useRootViewContainer = false;
        this.isIE10 = false;
    }
    ColorPickerComponent.prototype.setDialog = function (instance, elementRef, color, cpPosition, cpPositionOffset, cpPositionRelativeToArrow, cpOutputFormat, cpPresetLabel, cpPresetEmptyMessage, cpPresetEmptyMessageClass, cpPresetColors, cpMaxPresetColorsLength, cpCancelButton, cpCancelButtonClass, cpCancelButtonText, cpOKButton, cpOKButtonClass, cpOKButtonText, cpAddColorButton, cpAddColorButtonClass, cpAddColorButtonText, cpRemoveColorButtonClass, cpHeight, cpWidth, cpIgnoredElements, cpDialogDisplay, cpSaveClickOutside, cpAlphaChannel, cpUseRootViewContainer) {
        this.directiveInstance = instance;
        this.initialColor = color;
        this.directiveElementRef = elementRef;
        this.cpPosition = cpPosition;
        this.cpPositionOffset = parseInt(cpPositionOffset);
        if (!cpPositionRelativeToArrow) {
            this.dialogArrowOffset = 0;
        }
        this.cpOutputFormat = cpOutputFormat;
        this.cpPresetLabel = cpPresetLabel;
        this.cpPresetEmptyMessage = cpPresetEmptyMessage;
        this.cpPresetEmptyMessageClass = cpPresetEmptyMessageClass;
        this.cpPresetColors = cpPresetColors;
        this.cpMaxPresetColorsLength = cpMaxPresetColorsLength;
        this.cpCancelButton = cpCancelButton;
        this.cpCancelButtonClass = cpCancelButtonClass;
        this.cpCancelButtonText = cpCancelButtonText;
        this.cpOKButton = cpOKButton;
        this.cpOKButtonClass = cpOKButtonClass;
        this.cpOKButtonText = cpOKButtonText;
        this.cpAddColorButton = cpAddColorButton;
        this.cpAddColorButtonClass = cpAddColorButtonClass;
        this.cpAddColorButtonText = cpAddColorButtonText;
        this.cpRemoveColorButtonClass = cpRemoveColorButtonClass;
        this.width = this.cpWidth = parseInt(cpWidth);
        this.height = this.cpHeight = parseInt(cpHeight);
        this.cpIgnoredElements = cpIgnoredElements;
        this.cpDialogDisplay = cpDialogDisplay;
        if (this.cpDialogDisplay === 'inline') {
            this.dialogArrowOffset = 0;
            this.dialogArrowSize = 0;
        }
        this.cpSaveClickOutside = cpSaveClickOutside;
        this.cpAlphaChannel = cpAlphaChannel;
        this.useRootViewContainer = cpUseRootViewContainer;
        if (cpOutputFormat === 'hex' && cpAlphaChannel !== 'always' && cpAlphaChannel !== 'hex8') {
            this.cpAlphaChannel = 'disabled';
        }
        this.isIE10 = helpers_1.detectIE() === 10;
    };
    ColorPickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        var alphaWidth = this.alphaSlider.nativeElement.offsetWidth;
        var hueWidth = this.hueSlider.nativeElement.offsetWidth;
        this.sliderDimMax = new helpers_1.SliderDimension(hueWidth, this.cpWidth, 130, alphaWidth);
        this.slider = new helpers_1.SliderPosition(0, 0, 0, 0);
        if (this.cpOutputFormat === 'rgba') {
            this.format = 1;
        }
        else if (this.cpOutputFormat === 'hsla') {
            this.format = 2;
        }
        else {
            this.format = 0;
        }
        this.listenerMouseDown = function (event) { _this.onMouseDown(event); };
        this.listenerResize = function () { _this.onResize(); };
        this.openDialog(this.initialColor, false);
    };
    ColorPickerComponent.prototype.ngAfterViewInit = function () {
        if (this.cpWidth != 230) {
            var alphaWidth = this.alphaSlider.nativeElement.offsetWidth;
            var hueWidth = this.hueSlider.nativeElement.offsetWidth;
            this.sliderDimMax = new helpers_1.SliderDimension(hueWidth, this.cpWidth, 130, alphaWidth);
            this.update(false);
            this.cdr.detectChanges();
        }
    };
    ColorPickerComponent.prototype.setInitialColor = function (color) {
        this.initialColor = color;
    };
    ColorPickerComponent.prototype.setPresetConfig = function (cpPresetLabel, cpPresetColors) {
        this.cpPresetLabel = cpPresetLabel;
        this.cpPresetColors = cpPresetColors;
    };
    ColorPickerComponent.prototype.openDialog = function (color, emit) {
        if (emit === void 0) {
            emit = true;
        }
        this.service.setActive(this);
        if (!this.width) {
            this.cpWidth = this.directiveElementRef.nativeElement.offsetWidth;
        }
        this.setInitialColor(color);
        this.setColorFromString(color, emit);
        this.openColorPicker();
    };
    ColorPickerComponent.prototype.cancelColor = function (event) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        this.setColorFromString(this.initialColor, true);
        if (this.cpDialogDisplay === 'popup') {
            this.directiveInstance.colorChanged(this.initialColor, true);
            this.closeColorPicker();
        }
        this.directiveInstance.colorCanceled();
    };
    ColorPickerComponent.prototype.oKColor = function (event) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        if (this.cpDialogDisplay === 'popup') {
            this.closeColorPicker();
        }
        if (this.outputColor) {
            this.directiveInstance.colorSelected(this.outputColor);
        }
    };
    ColorPickerComponent.prototype.setColorFromString = function (value, emit, update) {
        if (emit === void 0) {
            emit = true;
        }
        if (update === void 0) {
            update = true;
        }
        var hsva;
        if (this.cpAlphaChannel === 'always' || this.cpAlphaChannel === 'hex8') {
            hsva = this.service.stringToHsva(value, true);
            if (!hsva && !this.hsva) {
                hsva = this.service.stringToHsva(value, false);
            }
        }
        else {
            hsva = this.service.stringToHsva(value, false);
        }
        if (hsva) {
            this.hsva = hsva;
            this.update(emit, update);
        }
    };
    ColorPickerComponent.prototype.addPresetColor = function (event, value) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        if (!this.cpPresetColors.filter(function (color) { return color === value; }).length) {
            this.cpPresetColors = this.cpPresetColors.concat(value);
            this.directiveInstance.presetColorsChanged(this.cpPresetColors);
        }
    };
    ColorPickerComponent.prototype.removePresetColor = function (event, value) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        this.cpPresetColors = this.cpPresetColors.filter(function (color) { return color !== value; });
        this.directiveInstance.presetColorsChanged(this.cpPresetColors);
    };
    ColorPickerComponent.prototype.onDragEnd = function (slider) {
        this.directiveInstance.sliderDragEnd({ slider: slider, color: this.outputColor });
    };
    ColorPickerComponent.prototype.onDragStart = function (slider) {
        this.directiveInstance.sliderDragStart({ slider: slider, color: this.outputColor });
    };
    ColorPickerComponent.prototype.onMouseDown = function (event) {
        // Workaround for IE10: We need to manually click on OK/Cancel button to close the color-picker [detectIE() !== 10]
        if ((!this.isDescendant(this.el.nativeElement, event.target)
            && event.target != this.directiveElementRef.nativeElement &&
            this.cpIgnoredElements.filter(function (item) { return item === event.target; }).length === 0) &&
            this.cpDialogDisplay === 'popup' && !this.isIE10) {
            if (!this.cpSaveClickOutside) {
                this.setColorFromString(this.initialColor, false);
                this.directiveInstance.colorChanged(this.initialColor);
            }
            this.closeColorPicker();
        }
    };
    ColorPickerComponent.prototype.openColorPicker = function () {
        var _this = this;
        if (!this.show) {
            this.show = true;
            this.hidden = true;
            setTimeout(function () {
                _this.setDialogPosition();
                _this.hidden = false;
                _this.cdr.detectChanges();
            }, 0);
            this.directiveInstance.toggle(true);
            /**
             * Required for IE10
             * This event listener is conditional to avoid memory leaks
             * If the directive was applied at the root level then this won't affect anything
             * but if we implement this color picker in child components then it closes on clicking anywhere (including this component)
             * and stopPropagation() does not work
             */
            if (!this.isIE10) {
                document.addEventListener('mousedown', this.listenerMouseDown);
            }
            window.addEventListener('resize', this.listenerResize);
        }
    };
    ColorPickerComponent.prototype.closeColorPicker = function () {
        if (this.show) {
            this.show = false;
            this.directiveInstance.toggle(false);
            /**
             * Required for IE10
             * If this is not attached then no need to remove the listener
             */
            if (!this.isIE10) {
                document.removeEventListener('mousedown', this.listenerMouseDown);
            }
            window.removeEventListener('resize', this.listenerResize);
            if (!this.cdr['destroyed']) {
                this.cdr.detectChanges();
            }
        }
    };
    ColorPickerComponent.prototype.onResize = function () {
        if (this.position === 'fixed') {
            this.setDialogPosition();
        }
        else if (this.cpDialogDisplay !== 'inline') {
            this.closeColorPicker();
        }
    };
    ColorPickerComponent.prototype.setDialogPosition = function () {
        if (this.cpDialogDisplay === 'inline') {
            this.position = 'relative';
            return;
        }
        var dialogHeight = this.dialogElement.nativeElement.offsetHeight;
        var node = this.directiveElementRef.nativeElement.parentNode, position = 'static', transform = '';
        var parentNode = null, transformNode = null, style = null;
        while (node !== null && node.tagName !== 'HTML') {
            style = window.getComputedStyle(node);
            position = style.getPropertyValue("position");
            transform = style.getPropertyValue("transform");
            if (position !== 'static' && parentNode === null) {
                parentNode = node;
            }
            if (transform && transform !== 'none' && transformNode === null) {
                transformNode = node;
            }
            if (position === 'fixed') {
                parentNode = transformNode;
                break;
            }
            node = node.parentNode;
        }
        var boxDirective = this.createBox(this.directiveElementRef.nativeElement, (position !== 'fixed'));
        if ((position !== 'fixed' || parentNode) && !this.useRootViewContainer) {
            if (parentNode === null) {
                parentNode = node;
            }
            var boxParent = this.createBox(parentNode, (position !== 'fixed'));
            this.top = boxDirective.top - boxParent.top;
            this.left = boxDirective.left - boxParent.left;
        }
        else {
            this.top = boxDirective.top;
            this.left = boxDirective.left;
        }
        if (position === 'fixed') {
            this.position = 'fixed';
        }
        if (this.cpPosition === 'left') {
            this.top += boxDirective.height * this.cpPositionOffset / 100 - this.dialogArrowOffset;
            this.left -= this.cpWidth + this.dialogArrowSize - 2;
        }
        else if (this.cpPosition === 'top') {
            this.top -= dialogHeight + this.dialogArrowSize;
            this.left += this.cpPositionOffset / 100 * boxDirective.width - this.dialogArrowOffset;
            this.arrowTop = dialogHeight - 1;
        }
        else if (this.cpPosition === 'bottom') {
            this.top += boxDirective.height + this.dialogArrowSize;
            this.left += this.cpPositionOffset / 100 * boxDirective.width - this.dialogArrowOffset;
        }
        else {
            this.top += boxDirective.height * this.cpPositionOffset / 100 - this.dialogArrowOffset;
            this.left += boxDirective.width + this.dialogArrowSize - 2;
        }
    };
    ColorPickerComponent.prototype.setSaturation = function (val) {
        var hsla = this.service.hsva2hsla(this.hsva);
        hsla.s = val.v / val.rg;
        this.hsva = this.service.hsla2hsva(hsla);
        this.update();
        this.directiveInstance.inputChanged({ input: 'saturation', value: hsla.s, color: this.outputColor });
    };
    ColorPickerComponent.prototype.setLightness = function (val) {
        var hsla = this.service.hsva2hsla(this.hsva);
        hsla.l = val.v / val.rg;
        this.hsva = this.service.hsla2hsva(hsla);
        this.update();
        this.directiveInstance.inputChanged({ input: 'lightness', value: hsla.l, color: this.outputColor });
    };
    ColorPickerComponent.prototype.setHue = function (val) {
        this.hsva.h = val.v / val.rg;
        this.update();
        this.directiveInstance.sliderChanged({ slider: 'hue', value: this.hsva.h, color: this.outputColor });
    };
    ColorPickerComponent.prototype.setAlpha = function (val) {
        this.hsva.a = val.v / val.rg;
        this.update();
        this.directiveInstance.sliderChanged({ slider: 'alpha', value: this.hsva.a, color: this.outputColor });
    };
    ColorPickerComponent.prototype.setR = function (val) {
        var rgba = this.service.hsvaToRgba(this.hsva);
        rgba.r = val.v / val.rg;
        this.hsva = this.service.rgbaToHsva(rgba);
        this.update();
        this.directiveInstance.inputChanged({ input: 'red', value: rgba.r, color: this.outputColor });
    };
    ColorPickerComponent.prototype.setG = function (val) {
        var rgba = this.service.hsvaToRgba(this.hsva);
        rgba.g = val.v / val.rg;
        this.hsva = this.service.rgbaToHsva(rgba);
        this.update();
        this.directiveInstance.inputChanged({ input: 'green', value: rgba.g, color: this.outputColor });
    };
    ColorPickerComponent.prototype.setB = function (val) {
        var rgba = this.service.hsvaToRgba(this.hsva);
        rgba.b = val.v / val.rg;
        this.hsva = this.service.rgbaToHsva(rgba);
        this.update();
        this.directiveInstance.inputChanged({ input: 'blue', value: rgba.b, color: this.outputColor });
    };
    ColorPickerComponent.prototype.setA = function (val) {
        this.hsva.a = val.v / val.rg;
        this.update();
        this.directiveInstance.inputChanged({ input: 'alpha', value: this.hsva.a, color: this.outputColor });
    };
    ColorPickerComponent.prototype.setHex = function (val) {
        if (val === null) {
            this.update();
        }
        else {
            this.setColorFromString(val, true, false);
            this.directiveInstance.inputChanged({ input: 'hex', value: val, color: this.outputColor });
        }
    };
    ColorPickerComponent.prototype.setSaturationAndBrightness = function (val) {
        this.hsva.s = val.s / val.rgX;
        this.hsva.v = val.v / val.rgY;
        this.update();
        this.directiveInstance.sliderChanged({ slider: 'lightness', value: this.hsva.v, color: this.outputColor });
        this.directiveInstance.sliderChanged({ slider: 'saturation', value: this.hsva.s, color: this.outputColor });
    };
    ColorPickerComponent.prototype.formatPolicy = function () {
        this.format = (this.format + 1) % 3;
        return this.format;
    };
    ColorPickerComponent.prototype.update = function (emit, update) {
        if (emit === void 0) {
            emit = true;
        }
        if (update === void 0) {
            update = true;
        }
        if (this.sliderDimMax) {
            var hsla = this.service.hsva2hsla(this.hsva);
            var rgba = this.service.denormalizeRGBA(this.service.hsvaToRgba(this.hsva));
            var hueRgba = this.service.denormalizeRGBA(this.service.hsvaToRgba(new formats_1.Hsva(this.hsva.h, 1, 1, 1)));
            if (update) {
                this.hslaText = new formats_1.Hsla(Math.round((hsla.h) * 360), Math.round(hsla.s * 100), Math.round(hsla.l * 100), Math.round(hsla.a * 100) / 100);
                this.rgbaText = new formats_1.Rgba(rgba.r, rgba.g, rgba.b, Math.round(rgba.a * 100) / 100);
                this.hexText = this.service.hexText(rgba, this.cpAlphaChannel === 'always' || this.cpAlphaChannel === 'hex8');
            }
            this.alphaSliderColor = 'rgb(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ')';
            this.hueSliderColor = 'rgb(' + hueRgba.r + ',' + hueRgba.g + ',' + hueRgba.b + ')';
            var lastOutput = this.outputColor;
            this.outputColor = this.service.outputFormat(this.hsva, this.cpOutputFormat, this.cpAlphaChannel);
            this.selectedColor = this.service.outputFormat(this.hsva, 'rgba', null);
            this.slider = new helpers_1.SliderPosition((this.hsva.h) * this.sliderDimMax.h - 8, this.hsva.s * this.sliderDimMax.s - 8, (1 - this.hsva.v) * this.sliderDimMax.v - 8, this.hsva.a * this.sliderDimMax.a - 8);
            if (emit && lastOutput !== this.outputColor) {
                this.directiveInstance.colorChanged(this.outputColor);
            }
        }
    };
    ColorPickerComponent.prototype.isDescendant = function (parent, child) {
        var node = child.parentNode;
        while (node !== null) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };
    ColorPickerComponent.prototype.createBox = function (element, offset) {
        return {
            top: element.getBoundingClientRect().top + (offset ? window.pageYOffset : 0),
            left: element.getBoundingClientRect().left + (offset ? window.pageXOffset : 0),
            width: element.offsetWidth,
            height: element.offsetHeight
        };
    };
    ColorPickerComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'color-picker',
                    template: '<div class="color-picker" [style.visibility]="hidden || !show ? \'hidden\' : \'visible\'" [style.height.px]="cpHeight" [style.width.px]="cpWidth" [style.top.px]="top" [style.left.px]="left" [style.position]="position" #dialogPopup><div *ngIf="cpDialogDisplay==\'popup\'" class="arrow arrow-{{cpPosition}}" [style.top.px]="arrowTop"></div><div [slider] [style.background-color]="hueSliderColor" [rgX]="1" [rgY]="1" (newValue)="setSaturationAndBrightness($event)" (dragStart)="onDragStart(\'saturation-lightness\')" (dragEnd)="onDragEnd(\'saturation-lightness\')" class="saturation-lightness"><div [style.left.px]="slider.s" [style.top.px]="slider.v" class="cursor"></div></div><div class="box"><div class="left"><div class="selected-color-background"></div><div [style.background-color]="selectedColor" class="selected-color"></div><button *ngIf="cpAddColorButton" class="{{cpAddColorButtonClass}}" (click)="addPresetColor($event, selectedColor)" [disabled]="cpPresetColors && cpPresetColors.length >= cpMaxPresetColorsLength">{{cpAddColorButtonText}}</button></div><div class="right"><div *ngIf="cpAlphaChannel===\'disabled\'" style="height: 16px"></div><div [slider] [rgX]="1" (newValue)="setHue($event)" (dragStart)="onDragStart(\'hue\')" (dragEnd)="onDragEnd(\'hue\')" class="hue" #hueSlider><div [style.left.px]="slider.h" class="cursor"></div></div><div [style.display]="cpAlphaChannel === \'disabled\' ? \'none\' : \'block\'" [slider] [style.background-color]="alphaSliderColor" [rgX]="1" (newValue)="setAlpha($event)" (dragStart)="onDragStart(\'alpha\')" (dragEnd)="onDragEnd(\'alpha\')" class="alpha" #alphaSlider><div [style.left.px]="slider.a" class="cursor"></div></div></div></div><div [style.display]="format !== 2 ? \'none\' : \'block\'" class="hsla-text"><div class="box"><input [text] type="number" pattern="[0-9]*" min="0" max="360" [rg]="360" (newValue)="setHue($event)" [value]="hslaText.h"> <input [text] type="number" pattern="[0-9]*" min="0" max="100" [rg]="100" (newValue)="setSaturation($event)" [value]="hslaText.s"> <input [text] type="number" pattern="[0-9]*" min="0" max="100" [rg]="100" (newValue)="setLightness($event)" [value]="hslaText.l"> <input *ngIf="cpAlphaChannel!==\'disabled\'" [text] type="number" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" max="1" step="0.1" [rg]="1" (newValue)="setA($event)" [value]="hslaText.a"></div><div class="box"><div>H</div><div>S</div><div>L</div><div *ngIf="cpAlphaChannel!==\'disabled\'">A</div></div></div><div [style.display]="format !== 1 ? \'none\' : \'block\'" class="rgba-text"><div class="box"><input [text] type="number" pattern="[0-9]*" min="0" max="255" [rg]="255" (newValue)="setR($event)" [value]="rgbaText.r"> <input [text] type="number" pattern="[0-9]*" min="0" max="255" [rg]="255" (newValue)="setG($event)" [value]="rgbaText.g"> <input [text] type="number" pattern="[0-9]*" min="0" max="255" [rg]="255" (newValue)="setB($event)" [value]="rgbaText.b"> <input *ngIf="cpAlphaChannel!==\'disabled\'" [text] type="number" pattern="[0-9]+([\.,][0-9]{1,2})?" min="0" max="1" step="0.1" [rg]="1" (newValue)="setA($event)" [value]="rgbaText.a"></div><div class="box"><div>R</div><div>G</div><div>B</div><div *ngIf="cpAlphaChannel!==\'disabled\'">A</div></div></div><div [style.display]="format !== 0 ? \'none\' : \'block\'" class="hex-text"><div class="box"><input [text] (blur)="setHex(null)" (newValue)="setHex($event)" [value]="hexText"></div><div class="box"><div>Hex</div></div></div><div (click)="formatPolicy()" class="type-policy"></div><div *ngIf="cpPresetColors" class="preset-area"><hr><div class="preset-label">{{cpPresetLabel}}</div><div *ngIf="cpPresetColors.length"><div *ngFor="let color of cpPresetColors" class="preset-color" [style.backgroundColor]="color" (click)="setColorFromString(color)"><span *ngIf="cpAddColorButton" class="{{cpRemoveColorButtonClass}}" (click)="removePresetColor($event, color)"></span></div></div><div *ngIf="!cpPresetColors.length && cpAddColorButton" class="{{cpPresetEmptyMessageClass}}">{{cpPresetEmptyMessage}}</div></div><div *ngIf="cpOKButton || cpCancelButton" class="button-area"><button *ngIf="cpOKButton" type="button" class="{{cpOKButtonClass}}" (click)="oKColor($event)">{{cpOKButtonText}}</button> <button *ngIf="cpCancelButton" type="button" class="{{cpCancelButtonClass}}" (click)="cancelColor($event)">{{cpCancelButtonText}}</button></div></div>',
                    styles: ['.color-picker *{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;margin:0;font-size:11px}.color-picker{cursor:default;width:230px;height:auto;border:1px solid #777;position:absolute;z-index:100000;background-color:#fff;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.color-picker i{cursor:default;position:relative}.color-picker input{text-align:center;font-size:13px;height:26px;min-width:0;-moz-appearance:textfield}.color-picker input:invalid{box-shadow:none}.color-picker input:-moz-submit-invalid{box-shadow:none}.color-picker input:-moz-ui-invalid{box-shadow:none}.color-picker input::-webkit-inner-spin-button,.color-picker input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.color-picker .button-area{padding:0 16px 16px;text-align:right}.color-picker .preset-area{padding:4px 15px}.color-picker .preset-area .preset-label{width:100%;padding:4px;font-size:11px;text-align:left;color:#555}.color-picker .preset-area .preset-color{-moz-border-radius:25%;-webkit-border-radius:25%;border-radius:25%;-khtml-border-radius:25%;border:1px solid #a9a9a9;cursor:pointer;display:inline-block;height:18px;margin:4px 6px 8px;position:relative;width:18px}.color-picker .preset-area .preset-empty-message{font-style:italic;margin-bottom:8px;margin-top:4px;min-height:18px;text-align:center}.color-picker .arrow{height:0;width:0;border-style:solid;position:absolute;z-index:999999}.color-picker .arrow-right{border-width:5px 10px;border-color:transparent #777 transparent transparent;top:10px;left:-20px}.color-picker .arrow-left{border-width:5px 10px;border-color:transparent transparent transparent #777;top:10px;left:100%}.color-picker .arrow-bottom{border-width:10px 5px;border-color:transparent transparent #777;top:-20px;left:10px}.color-picker .arrow-top{border-width:10px 5px;border-color:#777 transparent transparent;left:10px}.color-picker div.cursor-sv{cursor:default;position:relative;-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;-khtml-border-radius:50%;width:15px;height:15px;border:1px solid #ddd}.color-picker .selected-color,.color-picker div.cursor{-moz-border-radius:50%;-webkit-border-radius:50%;-khtml-border-radius:50%}.color-picker div.cursor{cursor:default;position:relative;border-radius:50%;width:16px;height:16px;border:2px solid #222}.color-picker .saturation-lightness{cursor:pointer;width:100%;height:130px;border:none;background-size:100% 100%;background-image:url(data:image/png;base64,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)}.color-picker .alpha,.color-picker .hue{width:100%;height:16px;border:none;background-size:100% 100%;cursor:pointer}.color-picker .box{display:-webkit-box;display:-webkit-flex;display:-moz-flex;display:-ms-flexbox;display:flex;padding:4px 8px}.color-picker .box .left{position:relative;padding:16px 8px}.color-picker .box .right{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;padding:12px 8px}.color-picker .hue{margin-bottom:16px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAQCAYAAAD06IYnAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AIWDwkUFWbCCAAAAFxJREFUaN7t0kEKg0AQAME2x83/n2qu5qCgD1iDhCoYdpnbQC9bbY1qVO/jvc6k3ad91s7/7F1/csgPrujuQ17BDYSFsBAWwgJhISyEBcJCWAgLhIWwEBYIi2f7Ar/1TCgFH2X9AAAAAElFTkSuQmCC)}.color-picker .alpha{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAQCAYAAAD06IYnAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AIWDwYQlZMa3gAAAWVJREFUaN7tmEGO6jAQRCsOArHgBpyAJYGjcGocxAm4A2IHpmoWE0eBH+ezmFlNvU06shJ3W6VEelWMUQAIIF9f6qZpimsA1LYtS2uF51/u27YVAFZVRUkEoGHdPV/sIcbIEIIkUdI/9Xa7neyv61+SWFUVAVCSct00TWn2fv6u3+Ecfd3tXzy/0+nEUu+SPjo/kqzrmiQpScN6v98XewfA8/lMkiLJ2WxGSUopcT6fM6U0NX9/frfbjev1WtfrlZfLhYfDQQHG/AIOlnGwjINlHCxjHCzjYJm/TJWdCwquJXseFFzGwDNNeiKMOJTO8xQdDQaeB29+K9efeLaBo9J7vdvtJj1RjFFjfiv7qv95tjx/7leSQgh93e1ffMeIp6O+YQjho/N791t1XVOSSI7N//K+4/GoxWLBx+PB5/Op5XLJ+/3OlJJWqxU3m83ovv5iGf8KjYNlHCxjHCzjYBkHy5gf5gusvQU7U37jTAAAAABJRU5ErkJggg==)}.color-picker .selected-color{width:40px;height:40px;top:16px;left:8px;position:absolute;border-radius:50%;border:1px solid #a9a9a9}.color-picker .selected-color-background{width:40px;height:40px;-moz-border-radius:50%;-webkit-border-radius:50%;border-radius:50%;-khtml-border-radius:50%;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAh0lEQVRYR+2W0QlAMQgD60zdfwOdqa8TmI/wQMr5K0I5bZLIzLOa2nt37VVVbd+dDx5obgCC3KBLwJ2ff4PnVidkf+ucIhw80HQaCLo3DMH3CRK3iFsmAWVl6hPNDwt8EvNE5q+YuEXcMgkonVM6SdyCoEvAnZ8v1Hjx817MilmxSUB5rdLJDycZgUAZUch/AAAAAElFTkSuQmCC)}.color-picker .type-policy{position:absolute;top:215px;right:12px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAgCAYAAAAffCjxAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACewAAAnsB01CO3AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAIASURBVEiJ7ZY9axRRFIafsxMStrLQJpAgpBFhi+C9w1YSo00I6RZ/g9vZpBf/QOr4GyRgkSKNSrAadsZqQGwCkuAWyRZJsySwvhZ7N/vhzrgbLH3Ld8597jlzz50zJokyxXH8DqDVar0qi6v8BbItqSGpEcfxdlmsFWXkvX8AfAVWg3UKPEnT9GKujMzsAFgZsVaCN1VTQd77XUnrgE1kv+6935268WRpzrnHZvYRWC7YvC3pRZZl3wozqtVqiyH9IgjAspkd1Gq1xUJQtVrdB9ZKIAOthdg/Qc65LUk7wNIMoCVJO865rYFhkqjX6/d7vV4GPJwBMqofURS5JEk6FYBer/eeYb/Mo9WwFnPOvQbeAvfuAAK4BN4sAJtAG/gJIElmNuiJyba3EGNmZiPeZuEVmVell/Y/6N+CzDn3AXhEOOo7Hv/3BeAz8IzQkMPnJbuPx1wC+yYJ7/0nYIP5S/0FHKdp+rwCEEXRS/rf5Hl1Gtb2M0iSpCOpCZzPATmX1EySpHMLAsiy7MjMDoHrGSDXZnaYZdnRwBh7J91utwmczAA6CbG3GgPleX4jqUH/a1CktqRGnuc3hSCAMB32gKspkCtgb3KCQMmkjeP4WNJThrNNZval1WptTIsv7JtQ4tmIdRa8qSoEpWl6YWZNoAN0zKxZNPehpLSBZv2t+Q0CJ9lLnARQLAAAAABJRU5ErkJggg==);background-repeat:no-repeat;background-position:center;background-size:8px 16px;-moz-background-size:8px 16px;-webkit-background-size:8px 16px;-o-background-size:8px 16px;width:16px;height:24px}.color-picker .hsla-text,.color-picker .rgba-text{width:100%;font-size:11px;padding:4px 8px}.color-picker .hsla-text .box,.color-picker .rgba-text .box{padding:0 24px 8px 8px}.color-picker .hsla-text .box input,.color-picker .rgba-text .box input{min-width:0;-webkit-flex:1;-ms-flex:1;flex:1;margin:0 8px 0 0;float:left;border:1px solid #a9a9a9;padding:1px}.color-picker .hsla-text .box input:last-child,.color-picker .rgba-text .box input:last-child{margin-right:0}.color-picker .hsla-text .box div,.color-picker .rgba-text .box div{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;text-align:center;color:#555;margin-right:8px}.color-picker .hsla-text .box div:last-child,.color-picker .rgba-text .box div:last-child{margin-right:0}.color-picker .hex-text{width:100%;font-size:11px;padding:4px 8px}.color-picker .hex-text .box{padding:0 24px 8px 8px}.color-picker .hex-text .box input{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;border:1px solid #a9a9a9;padding:1px}.color-picker .hex-text .box div{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;text-align:center;color:#555;float:left;clear:left}.color-picker .cp-add-color-button-class{background:0 0;border:0;cursor:pointer;display:inline;margin-left:-3px;margin-top:3px;padding:0;position:absolute}.color-picker .cp-add-color-button-class:hover{text-decoration:underline}.color-picker .cp-add-color-button-class:disabled{color:#999;cursor:not-allowed}.color-picker .cp-add-color-button-class:disabled:hover{text-decoration:none}.color-picker .cp-remove-color-button-class{background:#fff;border-radius:50%;box-shadow:1px 1px 5px #333;cursor:pointer;display:block;height:10px;position:absolute;right:-5px;text-align:center;top:-5px;width:10px}.color-picker .cp-remove-color-button-class:before{bottom:3.5px;content:\'x\';display:inline-block;font-size:10px;position:relative}']
                },] },
    ];
    ColorPickerComponent.propDecorators = {
        'hueSlider': [{ type: core_1.ViewChild, args: ['hueSlider',] },],
        'alphaSlider': [{ type: core_1.ViewChild, args: ['alphaSlider',] },],
        'dialogElement': [{ type: core_1.ViewChild, args: ['dialogPopup',] },],
    };
    return ColorPickerComponent;
}());
exports.ColorPickerComponent = ColorPickerComponent;



/***/ }),

/***/ "yPE/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
 * Quill Editor v1.3.4
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
    if (true)
        module.exports = factory();
    else if (typeof define === 'function' && define.amd)
        define([], factory);
    else if (typeof exports === 'object')
        exports["Quill"] = factory();
    else
        root["Quill"] = factory();
})(this, function () {
    return /******/ (function (modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/
        /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) {
                /******/ return installedModules[moduleId].exports;
                /******/ }
            /******/ // Create a new module (and put it into the cache)
            /******/ var module = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
                /******/ 
            };
            /******/
            /******/ // Execute the module function
            /******/ modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ // Flag the module as loaded
            /******/ module.l = true;
            /******/
            /******/ // Return the exports of the module
            /******/ return module.exports;
            /******/ 
        }
        /******/
        /******/
        /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/
        /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/
        /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function (exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) {
                /******/ Object.defineProperty(exports, name, {
                    /******/ configurable: false,
                    /******/ enumerable: true,
                    /******/ get: getter
                    /******/ 
                });
                /******/ }
            /******/ 
        };
        /******/
        /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function (module) {
            /******/ var getter = module && module.__esModule ?
                /******/ function getDefault() { return module['default']; } :
                /******/ function getModuleExports() { return module; };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
            /******/ 
        };
        /******/
        /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function (object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
        /******/
        /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 109);
        /******/ 
    })([
        /* 0 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", { value: true });
            var container_1 = __webpack_require__(17);
            var format_1 = __webpack_require__(18);
            var leaf_1 = __webpack_require__(19);
            var scroll_1 = __webpack_require__(45);
            var inline_1 = __webpack_require__(46);
            var block_1 = __webpack_require__(47);
            var embed_1 = __webpack_require__(48);
            var text_1 = __webpack_require__(49);
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var store_1 = __webpack_require__(31);
            var Registry = __webpack_require__(1);
            var Parchment = {
                Scope: Registry.Scope,
                create: Registry.create,
                find: Registry.find,
                query: Registry.query,
                register: Registry.register,
                Container: container_1.default,
                Format: format_1.default,
                Leaf: leaf_1.default,
                Embed: embed_1.default,
                Scroll: scroll_1.default,
                Block: block_1.default,
                Inline: inline_1.default,
                Text: text_1.default,
                Attributor: {
                    Attribute: attributor_1.default,
                    Class: class_1.default,
                    Style: style_1.default,
                    Store: store_1.default,
                },
            };
            exports.default = Parchment;
            /***/ 
        }),
        /* 1 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var ParchmentError = /*@__PURE__*/ (function (_super) {
                __extends(ParchmentError, _super);
                function ParchmentError(message) {
                    var _this = this;
                    message = '[Parchment] ' + message;
                    _this = _super.call(this, message) || this;
                    _this.message = message;
                    _this.name = _this.constructor.name;
                    return _this;
                }
                return ParchmentError;
            }(Error));
            exports.ParchmentError = ParchmentError;
            var attributes = {};
            var classes = {};
            var tags = {};
            var types = {};
            exports.DATA_KEY = '__blot';
            var Scope;
            (function (Scope) {
                Scope[Scope["TYPE"] = 3] = "TYPE";
                Scope[Scope["LEVEL"] = 12] = "LEVEL";
                Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
                Scope[Scope["BLOT"] = 14] = "BLOT";
                Scope[Scope["INLINE"] = 7] = "INLINE";
                Scope[Scope["BLOCK"] = 11] = "BLOCK";
                Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
                Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
                Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
                Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
                Scope[Scope["ANY"] = 15] = "ANY";
            })(Scope = exports.Scope || (exports.Scope = {}));
            function create(input, value) {
                var match = query(input);
                if (match == null) {
                    throw new ParchmentError("Unable to create " + input + " blot");
                }
                var BlotClass = match;
                var node = input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
                return new BlotClass(node, value);
            }
            exports.create = create;
            function find(node, bubble) {
                if (bubble === void 0) {
                    bubble = false;
                }
                if (node == null)
                    return null;
                if (node[exports.DATA_KEY] != null)
                    return node[exports.DATA_KEY].blot;
                if (bubble)
                    return find(node.parentNode, bubble);
                return null;
            }
            exports.find = find;
            function query(query, scope) {
                if (scope === void 0) {
                    scope = Scope.ANY;
                }
                var match;
                if (typeof query === 'string') {
                    match = types[query] || attributes[query];
                }
                else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
                    match = types['text'];
                }
                else if (typeof query === 'number') {
                    if (query & Scope.LEVEL & Scope.BLOCK) {
                        match = types['block'];
                    }
                    else if (query & Scope.LEVEL & Scope.INLINE) {
                        match = types['inline'];
                    }
                }
                else if (query instanceof HTMLElement) {
                    var names = (query.getAttribute('class') || '').split(/\s+/);
                    for (var i in names) {
                        match = classes[names[i]];
                        if (match)
                            break;
                    }
                    match = match || tags[query.tagName];
                }
                if (match == null)
                    return null;
                if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
                    return match;
                return null;
            }
            exports.query = query;
            function register() {
                var Definitions = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    Definitions[_i] = arguments[_i];
                }
                if (Definitions.length > 1) {
                    return Definitions.map(function (d) {
                        return register(d);
                    });
                }
                var Definition = Definitions[0];
                if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
                    throw new ParchmentError('Invalid definition');
                }
                else if (Definition.blotName === 'abstract') {
                    throw new ParchmentError('Cannot register abstract class');
                }
                types[Definition.blotName || Definition.attrName] = Definition;
                if (typeof Definition.keyName === 'string') {
                    attributes[Definition.keyName] = Definition;
                }
                else {
                    if (Definition.className != null) {
                        classes[Definition.className] = Definition;
                    }
                    if (Definition.tagName != null) {
                        if (Array.isArray(Definition.tagName)) {
                            Definition.tagName = Definition.tagName.map(function (tagName) {
                                return tagName.toUpperCase();
                            });
                        }
                        else {
                            Definition.tagName = Definition.tagName.toUpperCase();
                        }
                        var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
                        tagNames.forEach(function (tag) {
                            if (tags[tag] == null || Definition.className == null) {
                                tags[tag] = Definition;
                            }
                        });
                    }
                }
                return Definition;
            }
            exports.register = register;
            /***/ 
        }),
        /* 2 */
        /***/ (function (module, exports, __webpack_require__) {
            var diff = __webpack_require__(51);
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var op = __webpack_require__(20);
            var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
            var Delta = function (ops) {
                // Assume we are given a well formed ops
                if (Array.isArray(ops)) {
                    this.ops = ops;
                }
                else if (ops != null && Array.isArray(ops.ops)) {
                    this.ops = ops.ops;
                }
                else {
                    this.ops = [];
                }
            };
            Delta.prototype.insert = function (text, attributes) {
                var newOp = {};
                if (text.length === 0)
                    return this;
                newOp.insert = text;
                if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
                    newOp.attributes = attributes;
                }
                return this.push(newOp);
            };
            Delta.prototype['delete'] = function (length) {
                if (length <= 0)
                    return this;
                return this.push({ 'delete': length });
            };
            Delta.prototype.retain = function (length, attributes) {
                if (length <= 0)
                    return this;
                var newOp = { retain: length };
                if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
                    newOp.attributes = attributes;
                }
                return this.push(newOp);
            };
            Delta.prototype.push = function (newOp) {
                var index = this.ops.length;
                var lastOp = this.ops[index - 1];
                newOp = extend(true, {}, newOp);
                if (typeof lastOp === 'object') {
                    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
                        this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
                        return this;
                    }
                    // Since it does not matter if we insert before or after deleting at the same index,
                    // always prefer to insert first
                    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
                        index -= 1;
                        lastOp = this.ops[index - 1];
                        if (typeof lastOp !== 'object') {
                            this.ops.unshift(newOp);
                            return this;
                        }
                    }
                    if (equal(newOp.attributes, lastOp.attributes)) {
                        if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
                            this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
                            if (typeof newOp.attributes === 'object')
                                this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        }
                        else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
                            this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
                            if (typeof newOp.attributes === 'object')
                                this.ops[index - 1].attributes = newOp.attributes;
                            return this;
                        }
                    }
                }
                if (index === this.ops.length) {
                    this.ops.push(newOp);
                }
                else {
                    this.ops.splice(index, 0, newOp);
                }
                return this;
            };
            Delta.prototype.chop = function () {
                var lastOp = this.ops[this.ops.length - 1];
                if (lastOp && lastOp.retain && !lastOp.attributes) {
                    this.ops.pop();
                }
                return this;
            };
            Delta.prototype.filter = function (predicate) {
                return this.ops.filter(predicate);
            };
            Delta.prototype.forEach = function (predicate) {
                this.ops.forEach(predicate);
            };
            Delta.prototype.map = function (predicate) {
                return this.ops.map(predicate);
            };
            Delta.prototype.partition = function (predicate) {
                var passed = [], failed = [];
                this.forEach(function (op) {
                    var target = predicate(op) ? passed : failed;
                    target.push(op);
                });
                return [passed, failed];
            };
            Delta.prototype.reduce = function (predicate, initial) {
                return this.ops.reduce(predicate, initial);
            };
            Delta.prototype.changeLength = function () {
                return this.reduce(function (length, elem) {
                    if (elem.insert) {
                        return length + op.length(elem);
                    }
                    else if (elem.delete) {
                        return length - elem.delete;
                    }
                    return length;
                }, 0);
            };
            Delta.prototype.length = function () {
                return this.reduce(function (length, elem) {
                    return length + op.length(elem);
                }, 0);
            };
            Delta.prototype.slice = function (start, end) {
                start = start || 0;
                if (typeof end !== 'number')
                    end = Infinity;
                var ops = [];
                var iter = op.iterator(this.ops);
                var index = 0;
                while (index < end && iter.hasNext()) {
                    var nextOp;
                    if (index < start) {
                        nextOp = iter.next(start - index);
                    }
                    else {
                        nextOp = iter.next(end - index);
                        ops.push(nextOp);
                    }
                    index += op.length(nextOp);
                }
                return new Delta(ops);
            };
            Delta.prototype.compose = function (other) {
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var delta = new Delta();
                while (thisIter.hasNext() || otherIter.hasNext()) {
                    if (otherIter.peekType() === 'insert') {
                        delta.push(otherIter.next());
                    }
                    else if (thisIter.peekType() === 'delete') {
                        delta.push(thisIter.next());
                    }
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (typeof otherOp.retain === 'number') {
                            var newOp = {};
                            if (typeof thisOp.retain === 'number') {
                                newOp.retain = length;
                            }
                            else {
                                newOp.insert = thisOp.insert;
                            }
                            // Preserve null when composing with a retain, otherwise remove it for inserts
                            var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
                            if (attributes)
                                newOp.attributes = attributes;
                            delta.push(newOp);
                            // Other op should be delete, we could be an insert or retain
                            // Insert + delete cancels out
                        }
                        else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
                            delta.push(otherOp);
                        }
                    }
                }
                return delta.chop();
            };
            Delta.prototype.concat = function (other) {
                var delta = new Delta(this.ops.slice());
                if (other.ops.length > 0) {
                    delta.push(other.ops[0]);
                    delta.ops = delta.ops.concat(other.ops.slice(1));
                }
                return delta;
            };
            Delta.prototype.diff = function (other, index) {
                if (this.ops === other.ops) {
                    return new Delta();
                }
                var strings = [this, other].map(function (delta) {
                    return delta.map(function (op) {
                        if (op.insert != null) {
                            return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
                        }
                        var prep = (delta === other) ? 'on' : 'with';
                        throw new Error('diff() called ' + prep + ' non-document');
                    }).join('');
                });
                var delta = new Delta();
                var diffResult = diff(strings[0], strings[1], index);
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                diffResult.forEach(function (component) {
                    var length = component[1].length;
                    while (length > 0) {
                        var opLength = 0;
                        switch (component[0]) {
                            case diff.INSERT:
                                opLength = Math.min(otherIter.peekLength(), length);
                                delta.push(otherIter.next(opLength));
                                break;
                            case diff.DELETE:
                                opLength = Math.min(length, thisIter.peekLength());
                                thisIter.next(opLength);
                                delta['delete'](opLength);
                                break;
                            case diff.EQUAL:
                                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                                var thisOp = thisIter.next(opLength);
                                var otherOp = otherIter.next(opLength);
                                if (equal(thisOp.insert, otherOp.insert)) {
                                    delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                                }
                                else {
                                    delta.push(otherOp)['delete'](opLength);
                                }
                                break;
                        }
                        length -= opLength;
                    }
                });
                return delta.chop();
            };
            Delta.prototype.eachLine = function (predicate, newline) {
                newline = newline || '\n';
                var iter = op.iterator(this.ops);
                var line = new Delta();
                var i = 0;
                while (iter.hasNext()) {
                    if (iter.peekType() !== 'insert')
                        return;
                    var thisOp = iter.peek();
                    var start = op.length(thisOp) - iter.peekLength();
                    var index = typeof thisOp.insert === 'string' ?
                        thisOp.insert.indexOf(newline, start) - start : -1;
                    if (index < 0) {
                        line.push(iter.next());
                    }
                    else if (index > 0) {
                        line.push(iter.next(index));
                    }
                    else {
                        if (predicate(line, iter.next(1).attributes || {}, i) === false) {
                            return;
                        }
                        i += 1;
                        line = new Delta();
                    }
                }
                if (line.length() > 0) {
                    predicate(line, {}, i);
                }
            };
            Delta.prototype.transform = function (other, priority) {
                priority = !!priority;
                if (typeof other === 'number') {
                    return this.transformPosition(other, priority);
                }
                var thisIter = op.iterator(this.ops);
                var otherIter = op.iterator(other.ops);
                var delta = new Delta();
                while (thisIter.hasNext() || otherIter.hasNext()) {
                    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
                        delta.retain(op.length(thisIter.next()));
                    }
                    else if (otherIter.peekType() === 'insert') {
                        delta.push(otherIter.next());
                    }
                    else {
                        var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                        var thisOp = thisIter.next(length);
                        var otherOp = otherIter.next(length);
                        if (thisOp['delete']) {
                            // Our delete either makes their delete redundant or removes their retain
                            continue;
                        }
                        else if (otherOp['delete']) {
                            delta.push(otherOp);
                        }
                        else {
                            // We retain either their retain or insert
                            delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
                        }
                    }
                }
                return delta.chop();
            };
            Delta.prototype.transformPosition = function (index, priority) {
                priority = !!priority;
                var thisIter = op.iterator(this.ops);
                var offset = 0;
                while (thisIter.hasNext() && offset <= index) {
                    var length = thisIter.peekLength();
                    var nextType = thisIter.peekType();
                    thisIter.next();
                    if (nextType === 'delete') {
                        index -= Math.min(length, index - offset);
                        continue;
                    }
                    else if (nextType === 'insert' && (offset < index || !priority)) {
                        index += length;
                    }
                    offset += length;
                }
                return index;
            };
            module.exports = Delta;
            /***/ 
        }),
        /* 3 */
        /***/ (function (module, exports) {
            'use strict';
            var hasOwn = Object.prototype.hasOwnProperty;
            var toStr = Object.prototype.toString;
            var isArray = function isArray(arr) {
                if (typeof Array.isArray === 'function') {
                    return Array.isArray(arr);
                }
                return toStr.call(arr) === '[object Array]';
            };
            var isPlainObject = function isPlainObject(obj) {
                if (!obj || toStr.call(obj) !== '[object Object]') {
                    return false;
                }
                var hasOwnConstructor = hasOwn.call(obj, 'constructor');
                var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
                // Not own constructor property must be Object
                if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
                    return false;
                }
                // Own properties are enumerated firstly, so to speed up,
                // if last one is own, then all properties are own.
                var key;
                for (key in obj) { }
                return typeof key === 'undefined' || hasOwn.call(obj, key);
            };
            module.exports = function extend() {
                var options, name, src, copy, copyIsArray, clone;
                var target = arguments[0];
                var i = 1;
                var length = arguments.length;
                var deep = false;
                // Handle a deep copy situation
                if (typeof target === 'boolean') {
                    deep = target;
                    target = arguments[1] || {};
                    // skip the boolean and the target
                    i = 2;
                }
                if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
                    target = {};
                }
                for (; i < length; ++i) {
                    options = arguments[i];
                    // Only deal with non-null/undefined values
                    if (options != null) {
                        // Extend the base object
                        for (name in options) {
                            src = target[name];
                            copy = options[name];
                            // Prevent never-ending loop
                            if (target !== copy) {
                                // Recurse if we're merging plain objects or arrays
                                if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                                    if (copyIsArray) {
                                        copyIsArray = false;
                                        clone = src && isArray(src) ? src : [];
                                    }
                                    else {
                                        clone = src && isPlainObject(src) ? src : {};
                                    }
                                    // Never move original objects, clone them
                                    target[name] = extend(deep, clone, copy);
                                    // Don't bring in undefined values
                                }
                                else if (typeof copy !== 'undefined') {
                                    target[name] = copy;
                                }
                            }
                        }
                    }
                }
                // Return the modified object
                return target;
            };
            /***/ 
        }),
        /* 4 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var NEWLINE_LENGTH = 1;
            var BlockEmbed = function (_Parchment$Embed) {
                _inherits(BlockEmbed, _Parchment$Embed);
                function BlockEmbed() {
                    _classCallCheck(this, BlockEmbed);
                    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
                }
                _createClass(BlockEmbed, [{
                        key: 'attach',
                        value: function attach() {
                            _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
                            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
                        }
                    }, {
                        key: 'delta',
                        value: function delta() {
                            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
                        }
                    }, {
                        key: 'format',
                        value: function format(name, value) {
                            var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
                            if (attribute != null) {
                                this.attributes.attribute(attribute, value);
                            }
                        }
                    }, {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            this.format(name, value);
                        }
                    }, {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (typeof value === 'string' && value.endsWith('\n')) {
                                var block = _parchment2.default.create(Block.blotName);
                                this.parent.insertBefore(block, index === 0 ? this : this.next);
                                block.insertAt(0, value.slice(0, -1));
                            }
                            else {
                                _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
                            }
                        }
                    }]);
                return BlockEmbed;
            }(_parchment2.default.Embed);
            BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
            // It is important for cursor behavior BlockEmbeds use tags that are block level elements
            var Block = function (_Parchment$Block) {
                _inherits(Block, _Parchment$Block);
                function Block(domNode) {
                    _classCallCheck(this, Block);
                    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
                    _this2.cache = {};
                    return _this2;
                }
                _createClass(Block, [{
                        key: 'delta',
                        value: function delta() {
                            if (this.cache.delta == null) {
                                this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
                                    if (leaf.length() === 0) {
                                        return delta;
                                    }
                                    else {
                                        return delta.insert(leaf.value(), bubbleFormats(leaf));
                                    }
                                }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
                            }
                            return this.cache.delta;
                        }
                    }, {
                        key: 'deleteAt',
                        value: function deleteAt(index, length) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
                            this.cache = {};
                        }
                    }, {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (length <= 0)
                                return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                                if (index + length === this.length()) {
                                    this.format(name, value);
                                }
                            }
                            else {
                                _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
                            }
                            this.cache = {};
                        }
                    }, {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null)
                                return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
                            if (value.length === 0)
                                return;
                            var lines = value.split('\n');
                            var text = lines.shift();
                            if (text.length > 0) {
                                if (index < this.length() - 1 || this.children.tail == null) {
                                    _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
                                }
                                else {
                                    this.children.tail.insertAt(this.children.tail.length(), text);
                                }
                                this.cache = {};
                            }
                            var block = this;
                            lines.reduce(function (index, line) {
                                block = block.split(index, true);
                                block.insertAt(0, line);
                                return line.length;
                            }, index + text.length);
                        }
                    }, {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            var head = this.children.head;
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
                            if (head instanceof _break2.default) {
                                head.remove();
                            }
                            this.cache = {};
                        }
                    }, {
                        key: 'length',
                        value: function length() {
                            if (this.cache.length == null) {
                                this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
                            }
                            return this.cache.length;
                        }
                    }, {
                        key: 'moveChildren',
                        value: function moveChildren(target, ref) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
                            this.cache = {};
                        }
                    }, {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
                            this.cache = {};
                        }
                    }, {
                        key: 'path',
                        value: function path(index) {
                            return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
                        }
                    }, {
                        key: 'removeChild',
                        value: function removeChild(child) {
                            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
                            this.cache = {};
                        }
                    }, {
                        key: 'split',
                        value: function split(index) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
                                var clone = this.clone();
                                if (index === 0) {
                                    this.parent.insertBefore(clone, this);
                                    return this;
                                }
                                else {
                                    this.parent.insertBefore(clone, this.next);
                                    return clone;
                                }
                            }
                            else {
                                var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
                                this.cache = {};
                                return next;
                            }
                        }
                    }]);
                return Block;
            }(_parchment2.default.Block);
            Block.blotName = 'block';
            Block.tagName = 'P';
            Block.defaultChild = 'break';
            Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
            function bubbleFormats(blot) {
                var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (blot == null)
                    return formats;
                if (typeof blot.formats === 'function') {
                    formats = (0, _extend2.default)(formats, blot.formats());
                }
                if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
                    return formats;
                }
                return bubbleFormats(blot.parent, formats);
            }
            exports.bubbleFormats = bubbleFormats;
            exports.BlockEmbed = BlockEmbed;
            exports.default = Block;
            /***/ 
        }),
        /* 5 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.overload = exports.expandConfig = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            __webpack_require__(50);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _editor = __webpack_require__(14);
            var _editor2 = _interopRequireDefault(_editor);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _selection = __webpack_require__(15);
            var _selection2 = _interopRequireDefault(_selection);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _defineProperty(obj, key, value) { if (key in obj) {
                Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
            }
            else {
                obj[key] = value;
            } return obj; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            var debug = (0, _logger2.default)('quill');
            var Quill = function () {
                _createClass(Quill, null, [{
                        key: 'debug',
                        value: function debug(limit) {
                            if (limit === true) {
                                limit = 'log';
                            }
                            _logger2.default.level(limit);
                        }
                    }, {
                        key: 'find',
                        value: function find(node) {
                            return node.__quill || _parchment2.default.find(node);
                        }
                    }, {
                        key: 'import',
                        value: function _import(name) {
                            if (this.imports[name] == null) {
                                debug.error('Cannot import ' + name + '. Are you sure it was registered?');
                            }
                            return this.imports[name];
                        }
                    }, {
                        key: 'register',
                        value: function register(path, target) {
                            var _this = this;
                            var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                            if (typeof path !== 'string') {
                                var name = path.attrName || path.blotName;
                                if (typeof name === 'string') {
                                    // register(Blot | Attributor, overwrite)
                                    this.register('formats/' + name, path, target);
                                }
                                else {
                                    Object.keys(path).forEach(function (key) {
                                        _this.register(key, path[key], target);
                                    });
                                }
                            }
                            else {
                                if (this.imports[path] != null && !overwrite) {
                                    debug.warn('Overwriting ' + path + ' with', target);
                                }
                                this.imports[path] = target;
                                if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
                                    _parchment2.default.register(target);
                                }
                                else if (path.startsWith('modules') && typeof target.register === 'function') {
                                    target.register();
                                }
                            }
                        }
                    }]);
                function Quill(container) {
                    var _this2 = this;
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    _classCallCheck(this, Quill);
                    this.options = expandConfig(container, options);
                    this.container = this.options.container;
                    if (this.container == null) {
                        return debug.error('Invalid Quill container', container);
                    }
                    if (this.options.debug) {
                        Quill.debug(this.options.debug);
                    }
                    var html = this.container.innerHTML.trim();
                    this.container.classList.add('ql-container');
                    this.container.innerHTML = '';
                    this.container.__quill = this;
                    this.root = this.addContainer('ql-editor');
                    this.root.classList.add('ql-blank');
                    this.root.setAttribute('data-gramm', false);
                    this.scrollingContainer = this.options.scrollingContainer || this.root;
                    this.emitter = new _emitter4.default();
                    this.scroll = _parchment2.default.create(this.root, {
                        emitter: this.emitter,
                        whitelist: this.options.formats
                    });
                    this.editor = new _editor2.default(this.scroll);
                    this.selection = new _selection2.default(this.scroll, this.emitter);
                    this.theme = new this.options.theme(this, this.options);
                    this.keyboard = this.theme.addModule('keyboard');
                    this.clipboard = this.theme.addModule('clipboard');
                    this.history = this.theme.addModule('history');
                    this.theme.init();
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
                        if (type === _emitter4.default.events.TEXT_CHANGE) {
                            _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
                        }
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
                        var range = _this2.selection.lastRange;
                        var index = range && range.length === 0 ? range.index : undefined;
                        modify.call(_this2, function () {
                            return _this2.editor.update(null, mutations, index);
                        }, source);
                    });
                    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
                    this.setContents(contents);
                    this.history.clear();
                    if (this.options.placeholder) {
                        this.root.setAttribute('data-placeholder', this.options.placeholder);
                    }
                    if (this.options.readOnly) {
                        this.disable();
                    }
                }
                _createClass(Quill, [{
                        key: 'addContainer',
                        value: function addContainer(container) {
                            var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            if (typeof container === 'string') {
                                var className = container;
                                container = document.createElement('div');
                                container.classList.add(className);
                            }
                            this.container.insertBefore(container, refNode);
                            return container;
                        }
                    }, {
                        key: 'blur',
                        value: function blur() {
                            this.selection.setRange(null);
                        }
                    }, {
                        key: 'deleteText',
                        value: function deleteText(index, length, source) {
                            var _this3 = this;
                            var _overload = overload(index, length, source);
                            var _overload2 = _slicedToArray(_overload, 4);
                            index = _overload2[0];
                            length = _overload2[1];
                            source = _overload2[3];
                            return modify.call(this, function () {
                                return _this3.editor.deleteText(index, length);
                            }, source, index, -1 * length);
                        }
                    }, {
                        key: 'disable',
                        value: function disable() {
                            this.enable(false);
                        }
                    }, {
                        key: 'enable',
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.scroll.enable(enabled);
                            this.container.classList.toggle('ql-disabled', !enabled);
                        }
                    }, {
                        key: 'focus',
                        value: function focus() {
                            var scrollTop = this.scrollingContainer.scrollTop;
                            this.selection.focus();
                            this.scrollingContainer.scrollTop = scrollTop;
                            this.scrollIntoView();
                        }
                    }, {
                        key: 'format',
                        value: function format(name, value) {
                            var _this4 = this;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            return modify.call(this, function () {
                                var range = _this4.getSelection(true);
                                var change = new _quillDelta2.default();
                                if (range == null) {
                                    return change;
                                }
                                else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                                    change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
                                }
                                else if (range.length === 0) {
                                    _this4.selection.format(name, value);
                                    return change;
                                }
                                else {
                                    change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
                                }
                                _this4.setSelection(range, _emitter4.default.sources.SILENT);
                                return change;
                            }, source);
                        }
                    }, {
                        key: 'formatLine',
                        value: function formatLine(index, length, name, value, source) {
                            var _this5 = this;
                            var formats = void 0;
                            var _overload3 = overload(index, length, name, value, source);
                            var _overload4 = _slicedToArray(_overload3, 4);
                            index = _overload4[0];
                            length = _overload4[1];
                            formats = _overload4[2];
                            source = _overload4[3];
                            return modify.call(this, function () {
                                return _this5.editor.formatLine(index, length, formats);
                            }, source, index, 0);
                        }
                    }, {
                        key: 'formatText',
                        value: function formatText(index, length, name, value, source) {
                            var _this6 = this;
                            var formats = void 0;
                            var _overload5 = overload(index, length, name, value, source);
                            var _overload6 = _slicedToArray(_overload5, 4);
                            index = _overload6[0];
                            length = _overload6[1];
                            formats = _overload6[2];
                            source = _overload6[3];
                            return modify.call(this, function () {
                                return _this6.editor.formatText(index, length, formats);
                            }, source, index, 0);
                        }
                    }, {
                        key: 'getBounds',
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var bounds = void 0;
                            if (typeof index === 'number') {
                                bounds = this.selection.getBounds(index, length);
                            }
                            else {
                                bounds = this.selection.getBounds(index.index, index.length);
                            }
                            var containerBounds = this.container.getBoundingClientRect();
                            return {
                                bottom: bounds.bottom - containerBounds.top,
                                height: bounds.height,
                                left: bounds.left - containerBounds.left,
                                right: bounds.right - containerBounds.left,
                                top: bounds.top - containerBounds.top,
                                width: bounds.width
                            };
                        }
                    }, {
                        key: 'getContents',
                        value: function getContents() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload7 = overload(index, length);
                            var _overload8 = _slicedToArray(_overload7, 2);
                            index = _overload8[0];
                            length = _overload8[1];
                            return this.editor.getContents(index, length);
                        }
                    }, {
                        key: 'getFormat',
                        value: function getFormat() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            if (typeof index === 'number') {
                                return this.editor.getFormat(index, length);
                            }
                            else {
                                return this.editor.getFormat(index.index, index.length);
                            }
                        }
                    }, {
                        key: 'getIndex',
                        value: function getIndex(blot) {
                            return blot.offset(this.scroll);
                        }
                    }, {
                        key: 'getLength',
                        value: function getLength() {
                            return this.scroll.length();
                        }
                    }, {
                        key: 'getLeaf',
                        value: function getLeaf(index) {
                            return this.scroll.leaf(index);
                        }
                    }, {
                        key: 'getLine',
                        value: function getLine(index) {
                            return this.scroll.line(index);
                        }
                    }, {
                        key: 'getLines',
                        value: function getLines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            if (typeof index !== 'number') {
                                return this.scroll.lines(index.index, index.length);
                            }
                            else {
                                return this.scroll.lines(index, length);
                            }
                        }
                    }, {
                        key: 'getModule',
                        value: function getModule(name) {
                            return this.theme.modules[name];
                        }
                    }, {
                        key: 'getSelection',
                        value: function getSelection() {
                            var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                            if (focus)
                                this.focus();
                            this.update(); // Make sure we access getRange with editor in consistent state
                            return this.selection.getRange()[0];
                        }
                    }, {
                        key: 'getText',
                        value: function getText() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
                            var _overload9 = overload(index, length);
                            var _overload10 = _slicedToArray(_overload9, 2);
                            index = _overload10[0];
                            length = _overload10[1];
                            return this.editor.getText(index, length);
                        }
                    }, {
                        key: 'hasFocus',
                        value: function hasFocus() {
                            return this.selection.hasFocus();
                        }
                    }, {
                        key: 'insertEmbed',
                        value: function insertEmbed(index, embed, value) {
                            var _this7 = this;
                            var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
                            return modify.call(this, function () {
                                return _this7.editor.insertEmbed(index, embed, value);
                            }, source, index);
                        }
                    }, {
                        key: 'insertText',
                        value: function insertText(index, text, name, value, source) {
                            var _this8 = this;
                            var formats = void 0;
                            var _overload11 = overload(index, 0, name, value, source);
                            var _overload12 = _slicedToArray(_overload11, 4);
                            index = _overload12[0];
                            formats = _overload12[2];
                            source = _overload12[3];
                            return modify.call(this, function () {
                                return _this8.editor.insertText(index, text, formats);
                            }, source, index, text.length);
                        }
                    }, {
                        key: 'isEnabled',
                        value: function isEnabled() {
                            return !this.container.classList.contains('ql-disabled');
                        }
                    }, {
                        key: 'off',
                        value: function off() {
                            return this.emitter.off.apply(this.emitter, arguments);
                        }
                    }, {
                        key: 'on',
                        value: function on() {
                            return this.emitter.on.apply(this.emitter, arguments);
                        }
                    }, {
                        key: 'once',
                        value: function once() {
                            return this.emitter.once.apply(this.emitter, arguments);
                        }
                    }, {
                        key: 'pasteHTML',
                        value: function pasteHTML(index, html, source) {
                            this.clipboard.dangerouslyPasteHTML(index, html, source);
                        }
                    }, {
                        key: 'removeFormat',
                        value: function removeFormat(index, length, source) {
                            var _this9 = this;
                            var _overload13 = overload(index, length, source);
                            var _overload14 = _slicedToArray(_overload13, 4);
                            index = _overload14[0];
                            length = _overload14[1];
                            source = _overload14[3];
                            return modify.call(this, function () {
                                return _this9.editor.removeFormat(index, length);
                            }, source, index);
                        }
                    }, {
                        key: 'scrollIntoView',
                        value: function scrollIntoView() {
                            this.selection.scrollIntoView(this.scrollingContainer);
                        }
                    }, {
                        key: 'setContents',
                        value: function setContents(delta) {
                            var _this10 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function () {
                                delta = new _quillDelta2.default(delta);
                                var length = _this10.getLength();
                                var deleted = _this10.editor.deleteText(0, length);
                                var applied = _this10.editor.applyDelta(delta);
                                var lastOp = applied.ops[applied.ops.length - 1];
                                if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
                                    _this10.editor.deleteText(_this10.getLength() - 1, 1);
                                    applied.delete(1);
                                }
                                var ret = deleted.compose(applied);
                                return ret;
                            }, source);
                        }
                    }, {
                        key: 'setSelection',
                        value: function setSelection(index, length, source) {
                            if (index == null) {
                                this.selection.setRange(null, length || Quill.sources.API);
                            }
                            else {
                                var _overload15 = overload(index, length, source);
                                var _overload16 = _slicedToArray(_overload15, 4);
                                index = _overload16[0];
                                length = _overload16[1];
                                source = _overload16[3];
                                this.selection.setRange(new _selection.Range(index, length), source);
                                if (source !== _emitter4.default.sources.SILENT) {
                                    this.selection.scrollIntoView(this.scrollingContainer);
                                }
                            }
                        }
                    }, {
                        key: 'setText',
                        value: function setText(text) {
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            var delta = new _quillDelta2.default().insert(text);
                            return this.setContents(delta, source);
                        }
                    }, {
                        key: 'update',
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
                            this.selection.update(source);
                            return change;
                        }
                    }, {
                        key: 'updateContents',
                        value: function updateContents(delta) {
                            var _this11 = this;
                            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
                            return modify.call(this, function () {
                                delta = new _quillDelta2.default(delta);
                                return _this11.editor.applyDelta(delta, source);
                            }, source, true);
                        }
                    }]);
                return Quill;
            }();
            Quill.DEFAULTS = {
                bounds: null,
                formats: null,
                modules: {},
                placeholder: '',
                readOnly: false,
                scrollingContainer: null,
                strict: true,
                theme: 'default'
            };
            Quill.events = _emitter4.default.events;
            Quill.sources = _emitter4.default.sources;
            // eslint-disable-next-line no-undef
            Quill.version = false ? 'dev' : "1.3.4";
            Quill.imports = {
                'delta': _quillDelta2.default,
                'parchment': _parchment2.default,
                'core/module': _module2.default,
                'core/theme': _theme2.default
            };
            function expandConfig(container, userConfig) {
                userConfig = (0, _extend2.default)(true, {
                    container: container,
                    modules: {
                        clipboard: true,
                        keyboard: true,
                        history: true
                    }
                }, userConfig);
                if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
                    userConfig.theme = _theme2.default;
                }
                else {
                    userConfig.theme = Quill.import('themes/' + userConfig.theme);
                    if (userConfig.theme == null) {
                        throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
                    }
                }
                var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
                [themeConfig, userConfig].forEach(function (config) {
                    config.modules = config.modules || {};
                    Object.keys(config.modules).forEach(function (module) {
                        if (config.modules[module] === true) {
                            config.modules[module] = {};
                        }
                    });
                });
                var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
                var moduleConfig = moduleNames.reduce(function (config, name) {
                    var moduleClass = Quill.import('modules/' + name);
                    if (moduleClass == null) {
                        debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
                    }
                    else {
                        config[name] = moduleClass.DEFAULTS || {};
                    }
                    return config;
                }, {});
                // Special case toolbar shorthand
                if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
                    userConfig.modules.toolbar = {
                        container: userConfig.modules.toolbar
                    };
                }
                userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
                ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
                    if (typeof userConfig[key] === 'string') {
                        userConfig[key] = document.querySelector(userConfig[key]);
                    }
                });
                userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
                    if (userConfig.modules[name]) {
                        config[name] = userConfig.modules[name];
                    }
                    return config;
                }, {});
                return userConfig;
            }
            // Handle selection preservation and TEXT_CHANGE emission
            // common to modification APIs
            function modify(modifier, source, index, shift) {
                if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
                    return new _quillDelta2.default();
                }
                var range = index == null ? null : this.getSelection();
                var oldDelta = this.editor.delta;
                var change = modifier();
                if (range != null) {
                    if (index === true)
                        index = range.index;
                    if (shift == null) {
                        range = shiftRange(range, change, source);
                    }
                    else if (shift !== 0) {
                        range = shiftRange(range, index, shift, source);
                    }
                    this.setSelection(range, _emitter4.default.sources.SILENT);
                }
                if (change.length() > 0) {
                    var _emitter;
                    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
                    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
                    if (source !== _emitter4.default.sources.SILENT) {
                        var _emitter2;
                        (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                    }
                }
                return change;
            }
            function overload(index, length, name, value, source) {
                var formats = {};
                if (typeof index.index === 'number' && typeof index.length === 'number') {
                    // Allow for throwaway end (used by insertText/insertEmbed)
                    if (typeof length !== 'number') {
                        source = value, value = name, name = length, length = index.length, index = index.index;
                    }
                    else {
                        length = index.length, index = index.index;
                    }
                }
                else if (typeof length !== 'number') {
                    source = value, value = name, name = length, length = 0;
                }
                // Handle format being object, two format name/value strings or excluded
                if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
                    formats = name;
                    source = value;
                }
                else if (typeof name === 'string') {
                    if (value != null) {
                        formats[name] = value;
                    }
                    else {
                        source = name;
                    }
                }
                // Handle optional source
                source = source || _emitter4.default.sources.API;
                return [index, length, formats, source];
            }
            function shiftRange(range, index, length, source) {
                if (range == null)
                    return null;
                var start = void 0, end = void 0;
                if (index instanceof _quillDelta2.default) {
                    var _map = [range.index, range.index + range.length].map(function (pos) {
                        return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
                    });
                    var _map2 = _slicedToArray(_map, 2);
                    start = _map2[0];
                    end = _map2[1];
                }
                else {
                    var _map3 = [range.index, range.index + range.length].map(function (pos) {
                        if (pos < index || pos === index && source === _emitter4.default.sources.USER)
                            return pos;
                        if (length >= 0) {
                            return pos + length;
                        }
                        else {
                            return Math.max(index, pos + length);
                        }
                    });
                    var _map4 = _slicedToArray(_map3, 2);
                    start = _map4[0];
                    end = _map4[1];
                }
                return new _selection.Range(start, end - start);
            }
            exports.expandConfig = expandConfig;
            exports.overload = overload;
            exports.default = Quill;
            /***/ 
        }),
        /* 6 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Inline = function (_Parchment$Inline) {
                _inherits(Inline, _Parchment$Inline);
                function Inline() {
                    _classCallCheck(this, Inline);
                    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
                }
                _createClass(Inline, [{
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
                                var blot = this.isolate(index, length);
                                if (value) {
                                    blot.wrap(name, value);
                                }
                            }
                            else {
                                _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
                            }
                        }
                    }, {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
                            if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                                var parent = this.parent.isolate(this.offset(), this.length());
                                this.moveChildren(parent);
                                parent.wrap(this);
                            }
                        }
                    }], [{
                        key: 'compare',
                        value: function compare(self, other) {
                            var selfIndex = Inline.order.indexOf(self);
                            var otherIndex = Inline.order.indexOf(other);
                            if (selfIndex >= 0 || otherIndex >= 0) {
                                return selfIndex - otherIndex;
                            }
                            else if (self === other) {
                                return 0;
                            }
                            else if (self < other) {
                                return -1;
                            }
                            else {
                                return 1;
                            }
                        }
                    }]);
                return Inline;
            }(_parchment2.default.Inline);
            Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
            // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
            Inline.order = ['cursor', 'inline',
                'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
            ];
            exports.default = Inline;
            /***/ 
        }),
        /* 7 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var TextBlot = function (_Parchment$Text) {
                _inherits(TextBlot, _Parchment$Text);
                function TextBlot() {
                    _classCallCheck(this, TextBlot);
                    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
                }
                return TextBlot;
            }(_parchment2.default.Text);
            exports.default = TextBlot;
            /***/ 
        }),
        /* 8 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _eventemitter = __webpack_require__(54);
            var _eventemitter2 = _interopRequireDefault(_eventemitter);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var debug = (0, _logger2.default)('quill:events');
            var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
            EVENTS.forEach(function (eventName) {
                document.addEventListener(eventName, function () {
                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }
                    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
                        // TODO use WeakMap
                        if (node.__quill && node.__quill.emitter) {
                            var _node$__quill$emitter;
                            (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
                        }
                    });
                });
            });
            var Emitter = function (_EventEmitter) {
                _inherits(Emitter, _EventEmitter);
                function Emitter() {
                    _classCallCheck(this, Emitter);
                    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
                    _this.listeners = {};
                    _this.on('error', debug.error);
                    return _this;
                }
                _createClass(Emitter, [{
                        key: 'emit',
                        value: function emit() {
                            debug.log.apply(debug, arguments);
                            _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
                        }
                    }, {
                        key: 'handleDOM',
                        value: function handleDOM(event) {
                            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                                args[_key2 - 1] = arguments[_key2];
                            }
                            (this.listeners[event.type] || []).forEach(function (_ref) {
                                var node = _ref.node, handler = _ref.handler;
                                if (event.target === node || node.contains(event.target)) {
                                    handler.apply(undefined, [event].concat(args));
                                }
                            });
                        }
                    }, {
                        key: 'listenDOM',
                        value: function listenDOM(eventName, node, handler) {
                            if (!this.listeners[eventName]) {
                                this.listeners[eventName] = [];
                            }
                            this.listeners[eventName].push({ node: node, handler: handler });
                        }
                    }]);
                return Emitter;
            }(_eventemitter2.default);
            Emitter.events = {
                EDITOR_CHANGE: 'editor-change',
                SCROLL_BEFORE_UPDATE: 'scroll-before-update',
                SCROLL_OPTIMIZE: 'scroll-optimize',
                SCROLL_UPDATE: 'scroll-update',
                SELECTION_CHANGE: 'selection-change',
                TEXT_CHANGE: 'text-change'
            };
            Emitter.sources = {
                API: 'api',
                SILENT: 'silent',
                USER: 'user'
            };
            exports.default = Emitter;
            /***/ 
        }),
        /* 9 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            var Module = function Module(quill) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                _classCallCheck(this, Module);
                this.quill = quill;
                this.options = options;
            };
            Module.DEFAULTS = {};
            exports.default = Module;
            /***/ 
        }),
        /* 10 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var levels = ['error', 'warn', 'log', 'info'];
            var level = 'warn';
            function debug(method) {
                if (levels.indexOf(method) <= levels.indexOf(level)) {
                    var _console;
                    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        args[_key - 1] = arguments[_key];
                    }
                    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
                }
            }
            function namespace(ns) {
                return levels.reduce(function (logger, method) {
                    logger[method] = debug.bind(console, method, ns);
                    return logger;
                }, {});
            }
            debug.level = namespace.level = function (newLevel) {
                level = newLevel;
            };
            exports.default = namespace;
            /***/ 
        }),
        /* 11 */
        /***/ (function (module, exports, __webpack_require__) {
            var pSlice = Array.prototype.slice;
            var objectKeys = __webpack_require__(52);
            var isArguments = __webpack_require__(53);
            var deepEqual = module.exports = function (actual, expected, opts) {
                if (!opts)
                    opts = {};
                // 7.1. All identical values are equivalent, as determined by ===.
                if (actual === expected) {
                    return true;
                }
                else if (actual instanceof Date && expected instanceof Date) {
                    return actual.getTime() === expected.getTime();
                    // 7.3. Other pairs that do not both pass typeof value == 'object',
                    // equivalence is determined by ==.
                }
                else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
                    return opts.strict ? actual === expected : actual == expected;
                    // 7.4. For all other Object pairs, including Array objects, equivalence is
                    // determined by having the same number of owned properties (as verified
                    // with Object.prototype.hasOwnProperty.call), the same set of keys
                    // (although not necessarily the same order), equivalent values for every
                    // corresponding key, and an identical 'prototype' property. Note: this
                    // accounts for both named and indexed properties on Arrays.
                }
                else {
                    return objEquiv(actual, expected, opts);
                }
            };
            function isUndefinedOrNull(value) {
                return value === null || value === undefined;
            }
            function isBuffer(x) {
                if (!x || typeof x !== 'object' || typeof x.length !== 'number')
                    return false;
                if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
                    return false;
                }
                if (x.length > 0 && typeof x[0] !== 'number')
                    return false;
                return true;
            }
            function objEquiv(a, b, opts) {
                var i, key;
                if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
                    return false;
                // an identical 'prototype' property.
                if (a.prototype !== b.prototype)
                    return false;
                //~~~I've managed to break Object.keys through screwy arguments passing.
                //   Converting to array solves the problem.
                if (isArguments(a)) {
                    if (!isArguments(b)) {
                        return false;
                    }
                    a = pSlice.call(a);
                    b = pSlice.call(b);
                    return deepEqual(a, b, opts);
                }
                if (isBuffer(a)) {
                    if (!isBuffer(b)) {
                        return false;
                    }
                    if (a.length !== b.length)
                        return false;
                    for (i = 0; i < a.length; i++) {
                        if (a[i] !== b[i])
                            return false;
                    }
                    return true;
                }
                try {
                    var ka = objectKeys(a), kb = objectKeys(b);
                }
                catch (e) {
                    return false;
                }
                // having the same number of owned properties (keys incorporates
                // hasOwnProperty)
                if (ka.length != kb.length)
                    return false;
                //the same set of keys (although not necessarily the same order),
                ka.sort();
                kb.sort();
                //~~~cheap key test
                for (i = ka.length - 1; i >= 0; i--) {
                    if (ka[i] != kb[i])
                        return false;
                }
                //equivalent values for every corresponding key, and
                //~~~possibly expensive deep test
                for (i = ka.length - 1; i >= 0; i--) {
                    key = ka[i];
                    if (!deepEqual(a[key], b[key], opts))
                        return false;
                }
                return typeof a === typeof b;
            }
            /***/ 
        }),
        /* 12 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", { value: true });
            var Registry = __webpack_require__(1);
            var Attributor = /*@__PURE__*/ (function () {
                function Attributor(attrName, keyName, options) {
                    if (options === void 0) {
                        options = {};
                    }
                    this.attrName = attrName;
                    this.keyName = keyName;
                    var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
                    if (options.scope != null) {
                        // Ignore type bits, force attribute bit
                        this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
                    }
                    else {
                        this.scope = Registry.Scope.ATTRIBUTE;
                    }
                    if (options.whitelist != null)
                        this.whitelist = options.whitelist;
                }
                Attributor.keys = function (node) {
                    return [].map.call(node.attributes, function (item) {
                        return item.name;
                    });
                };
                Attributor.prototype.add = function (node, value) {
                    if (!this.canAdd(node, value))
                        return false;
                    node.setAttribute(this.keyName, value);
                    return true;
                };
                Attributor.prototype.canAdd = function (node, value) {
                    var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
                    if (match != null && (this.whitelist == null || this.whitelist.indexOf(value) > -1)) {
                        return true;
                    }
                    return false;
                };
                Attributor.prototype.remove = function (node) {
                    node.removeAttribute(this.keyName);
                };
                Attributor.prototype.value = function (node) {
                    var value = node.getAttribute(this.keyName);
                    return this.canAdd(node, value) ? value : '';
                };
                return Attributor;
            }());
            exports.default = Attributor;
            /***/ 
        }),
        /* 13 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Code = undefined;
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Code = function (_Inline) {
                _inherits(Code, _Inline);
                function Code() {
                    _classCallCheck(this, Code);
                    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
                }
                return Code;
            }(_inline2.default);
            Code.blotName = 'code';
            Code.tagName = 'CODE';
            var CodeBlock = function (_Block) {
                _inherits(CodeBlock, _Block);
                function CodeBlock() {
                    _classCallCheck(this, CodeBlock);
                    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
                }
                _createClass(CodeBlock, [{
                        key: 'delta',
                        value: function delta() {
                            var _this3 = this;
                            var text = this.domNode.textContent;
                            if (text.endsWith('\n')) {
                                // Should always be true
                                text = text.slice(0, -1);
                            }
                            return text.split('\n').reduce(function (delta, frag) {
                                return delta.insert(frag).insert('\n', _this3.formats());
                            }, new _quillDelta2.default());
                        }
                    }, {
                        key: 'format',
                        value: function format(name, value) {
                            if (name === this.statics.blotName && value)
                                return;
                            var _descendant = this.descendant(_text2.default, this.length() - 1), _descendant2 = _slicedToArray(_descendant, 1), text = _descendant2[0];
                            if (text != null) {
                                text.deleteAt(text.length() - 1, 1);
                            }
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
                        }
                    }, {
                        key: 'formatAt',
                        value: function formatAt(index, length, name, value) {
                            if (length === 0)
                                return;
                            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
                                return;
                            }
                            var nextNewline = this.newlineIndex(index);
                            if (nextNewline < 0 || nextNewline >= index + length)
                                return;
                            var prevNewline = this.newlineIndex(index, true) + 1;
                            var isolateLength = nextNewline - prevNewline + 1;
                            var blot = this.isolate(prevNewline, isolateLength);
                            var next = blot.next;
                            blot.format(name, value);
                            if (next instanceof CodeBlock) {
                                next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
                            }
                        }
                    }, {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null)
                                return;
                            var _descendant3 = this.descendant(_text2.default, index), _descendant4 = _slicedToArray(_descendant3, 2), text = _descendant4[0], offset = _descendant4[1];
                            text.insertAt(offset, value);
                        }
                    }, {
                        key: 'length',
                        value: function length() {
                            var length = this.domNode.textContent.length;
                            if (!this.domNode.textContent.endsWith('\n')) {
                                return length + 1;
                            }
                            return length;
                        }
                    }, {
                        key: 'newlineIndex',
                        value: function newlineIndex(searchIndex) {
                            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            if (!reverse) {
                                var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
                                return offset > -1 ? searchIndex + offset : -1;
                            }
                            else {
                                return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
                            }
                        }
                    }, {
                        key: 'optimize',
                        value: function optimize(context) {
                            if (!this.domNode.textContent.endsWith('\n')) {
                                this.appendChild(_parchment2.default.create('text', '\n'));
                            }
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
                                next.optimize(context);
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    }, {
                        key: 'replace',
                        value: function replace(target) {
                            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
                            [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
                                var blot = _parchment2.default.find(node);
                                if (blot == null) {
                                    node.parentNode.removeChild(node);
                                }
                                else if (blot instanceof _parchment2.default.Embed) {
                                    blot.remove();
                                }
                                else {
                                    blot.unwrap();
                                }
                            });
                        }
                    }], [{
                        key: 'create',
                        value: function create(value) {
                            var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
                            domNode.setAttribute('spellcheck', false);
                            return domNode;
                        }
                    }, {
                        key: 'formats',
                        value: function formats() {
                            return true;
                        }
                    }]);
                return CodeBlock;
            }(_block2.default);
            CodeBlock.blotName = 'code-block';
            CodeBlock.tagName = 'PRE';
            CodeBlock.TAB = '  ';
            exports.Code = Code;
            exports.default = CodeBlock;
            /***/ 
        }),
        /* 14 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _cursor = __webpack_require__(23);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _defineProperty(obj, key, value) { if (key in obj) {
                Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
            }
            else {
                obj[key] = value;
            } return obj; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            var ASCII = /^[ -~]*$/;
            var Editor = /*@__PURE__*/ function () {
                function Editor(scroll) {
                    _classCallCheck(this, Editor);
                    this.scroll = scroll;
                    this.delta = this.getDelta();
                }
                _createClass(Editor, [{
                        key: 'applyDelta',
                        value: function applyDelta(delta) {
                            var _this = this;
                            var consumeNextNewline = false;
                            this.scroll.update();
                            var scrollLength = this.scroll.length();
                            this.scroll.batchStart();
                            delta = normalizeDelta(delta);
                            delta.reduce(function (index, op) {
                                var length = op.retain || op.delete || op.insert.length || 1;
                                var attributes = op.attributes || {};
                                if (op.insert != null) {
                                    if (typeof op.insert === 'string') {
                                        var text = op.insert;
                                        if (text.endsWith('\n') && consumeNextNewline) {
                                            consumeNextNewline = false;
                                            text = text.slice(0, -1);
                                        }
                                        if (index >= scrollLength && !text.endsWith('\n')) {
                                            consumeNextNewline = true;
                                        }
                                        _this.scroll.insertAt(index, text);
                                        var _scroll$line = _this.scroll.line(index), _scroll$line2 = _slicedToArray(_scroll$line, 2), line = _scroll$line2[0], offset = _scroll$line2[1];
                                        var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                                        if (line instanceof _block2.default) {
                                            var _line$descendant = line.descendant(_parchment2.default.Leaf, offset), _line$descendant2 = _slicedToArray(_line$descendant, 1), leaf = _line$descendant2[0];
                                            formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                                        }
                                        attributes = _op2.default.attributes.diff(formats, attributes) || {};
                                    }
                                    else if (_typeof(op.insert) === 'object') {
                                        var key = Object.keys(op.insert)[0]; // There should only be one key
                                        if (key == null)
                                            return index;
                                        _this.scroll.insertAt(index, key, op.insert[key]);
                                    }
                                    scrollLength += length;
                                }
                                Object.keys(attributes).forEach(function (name) {
                                    _this.scroll.formatAt(index, length, name, attributes[name]);
                                });
                                return index + length;
                            }, 0);
                            delta.reduce(function (index, op) {
                                if (typeof op.delete === 'number') {
                                    _this.scroll.deleteAt(index, op.delete);
                                    return index;
                                }
                                return index + (op.retain || op.insert.length || 1);
                            }, 0);
                            this.scroll.batchEnd();
                            return this.update(delta);
                        }
                    }, {
                        key: 'deleteText',
                        value: function deleteText(index, length) {
                            this.scroll.deleteAt(index, length);
                            return this.update(new _quillDelta2.default().retain(index).delete(length));
                        }
                    }, {
                        key: 'formatLine',
                        value: function formatLine(index, length) {
                            var _this2 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            this.scroll.update();
                            Object.keys(formats).forEach(function (format) {
                                if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format])
                                    return;
                                var lines = _this2.scroll.lines(index, Math.max(length, 1));
                                var lengthRemaining = length;
                                lines.forEach(function (line) {
                                    var lineLength = line.length();
                                    if (!(line instanceof _code2.default)) {
                                        line.format(format, formats[format]);
                                    }
                                    else {
                                        var codeIndex = index - line.offset(_this2.scroll);
                                        var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                                        line.formatAt(codeIndex, codeLength, format, formats[format]);
                                    }
                                    lengthRemaining -= lineLength;
                                });
                            });
                            this.scroll.optimize();
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    }, {
                        key: 'formatText',
                        value: function formatText(index, length) {
                            var _this3 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            Object.keys(formats).forEach(function (format) {
                                _this3.scroll.formatAt(index, length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
                        }
                    }, {
                        key: 'getContents',
                        value: function getContents(index, length) {
                            return this.delta.slice(index, index + length);
                        }
                    }, {
                        key: 'getDelta',
                        value: function getDelta() {
                            return this.scroll.lines().reduce(function (delta, line) {
                                return delta.concat(line.delta());
                            }, new _quillDelta2.default());
                        }
                    }, {
                        key: 'getFormat',
                        value: function getFormat(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var lines = [], leaves = [];
                            if (length === 0) {
                                this.scroll.path(index).forEach(function (path) {
                                    var _path = _slicedToArray(path, 1), blot = _path[0];
                                    if (blot instanceof _block2.default) {
                                        lines.push(blot);
                                    }
                                    else if (blot instanceof _parchment2.default.Leaf) {
                                        leaves.push(blot);
                                    }
                                });
                            }
                            else {
                                lines = this.scroll.lines(index, length);
                                leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
                            }
                            var formatsArr = [lines, leaves].map(function (blots) {
                                if (blots.length === 0)
                                    return {};
                                var formats = (0, _block.bubbleFormats)(blots.shift());
                                while (Object.keys(formats).length > 0) {
                                    var blot = blots.shift();
                                    if (blot == null)
                                        return formats;
                                    formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
                                }
                                return formats;
                            });
                            return _extend2.default.apply(_extend2.default, formatsArr);
                        }
                    }, {
                        key: 'getText',
                        value: function getText(index, length) {
                            return this.getContents(index, length).filter(function (op) {
                                return typeof op.insert === 'string';
                            }).map(function (op) {
                                return op.insert;
                            }).join('');
                        }
                    }, {
                        key: 'insertEmbed',
                        value: function insertEmbed(index, embed, value) {
                            this.scroll.insertAt(index, embed, value);
                            return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
                        }
                    }, {
                        key: 'insertText',
                        value: function insertText(index, text) {
                            var _this4 = this;
                            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                            this.scroll.insertAt(index, text);
                            Object.keys(formats).forEach(function (format) {
                                _this4.scroll.formatAt(index, text.length, format, formats[format]);
                            });
                            return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
                        }
                    }, {
                        key: 'isBlank',
                        value: function isBlank() {
                            if (this.scroll.children.length == 0)
                                return true;
                            if (this.scroll.children.length > 1)
                                return false;
                            var block = this.scroll.children.head;
                            if (block.statics.blotName !== _block2.default.blotName)
                                return false;
                            if (block.children.length > 1)
                                return false;
                            return block.children.head instanceof _break2.default;
                        }
                    }, {
                        key: 'removeFormat',
                        value: function removeFormat(index, length) {
                            var text = this.getText(index, length);
                            var _scroll$line3 = this.scroll.line(index + length), _scroll$line4 = _slicedToArray(_scroll$line3, 2), line = _scroll$line4[0], offset = _scroll$line4[1];
                            var suffixLength = 0, suffix = new _quillDelta2.default();
                            if (line != null) {
                                if (!(line instanceof _code2.default)) {
                                    suffixLength = line.length() - offset;
                                }
                                else {
                                    suffixLength = line.newlineIndex(offset) - offset + 1;
                                }
                                suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
                            }
                            var contents = this.getContents(index, length + suffixLength);
                            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
                            var delta = new _quillDelta2.default().retain(index).concat(diff);
                            return this.applyDelta(delta);
                        }
                    }, {
                        key: 'update',
                        value: function update(change) {
                            var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                            var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                            var oldDelta = this.delta;
                            if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
                                // Optimization for character changes
                                var textBlot = _parchment2.default.find(mutations[0].target);
                                var formats = (0, _block.bubbleFormats)(textBlot);
                                var index = textBlot.offset(this.scroll);
                                var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
                                var oldText = new _quillDelta2.default().insert(oldValue);
                                var newText = new _quillDelta2.default().insert(textBlot.value());
                                var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
                                change = diffDelta.reduce(function (delta, op) {
                                    if (op.insert) {
                                        return delta.insert(op.insert, formats);
                                    }
                                    else {
                                        return delta.push(op);
                                    }
                                }, new _quillDelta2.default());
                                this.delta = oldDelta.compose(change);
                            }
                            else {
                                this.delta = this.getDelta();
                                if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
                                    change = oldDelta.diff(this.delta, cursorIndex);
                                }
                            }
                            return change;
                        }
                    }]);
                return Editor;
            }();
            function combineFormats(formats, combined) {
                return Object.keys(combined).reduce(function (merged, name) {
                    if (formats[name] == null)
                        return merged;
                    if (combined[name] === formats[name]) {
                        merged[name] = combined[name];
                    }
                    else if (Array.isArray(combined[name])) {
                        if (combined[name].indexOf(formats[name]) < 0) {
                            merged[name] = combined[name].concat([formats[name]]);
                        }
                    }
                    else {
                        merged[name] = [combined[name], formats[name]];
                    }
                    return merged;
                }, {});
            }
            function normalizeDelta(delta) {
                return delta.reduce(function (delta, op) {
                    if (op.insert === 1) {
                        var attributes = (0, _clone2.default)(op.attributes);
                        delete attributes['image'];
                        return delta.insert({ image: op.attributes.image }, attributes);
                    }
                    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
                        op = (0, _clone2.default)(op);
                        if (op.attributes.list) {
                            op.attributes.list = 'ordered';
                        }
                        else {
                            op.attributes.list = 'bullet';
                            delete op.attributes.bullet;
                        }
                    }
                    if (typeof op.insert === 'string') {
                        var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
                        return delta.insert(text, op.attributes);
                    }
                    return delta.push(op);
                }, new _quillDelta2.default());
            }
            exports.default = Editor;
            /***/ 
        }),
        /* 15 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.Range = undefined;
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _emitter3 = __webpack_require__(8);
            var _emitter4 = _interopRequireDefault(_emitter3);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _toConsumableArray(arr) { if (Array.isArray(arr)) {
                for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                    arr2[i] = arr[i];
                }
                return arr2;
            }
            else {
                return Array.from(arr);
            } }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            var debug = (0, _logger2.default)('quill:selection');
            var Range = function Range(index) {
                var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                _classCallCheck(this, Range);
                this.index = index;
                this.length = length;
            };
            var Selection = /*@__PURE__*/ function () {
                function Selection(scroll, emitter) {
                    var _this = this;
                    _classCallCheck(this, Selection);
                    this.emitter = emitter;
                    this.scroll = scroll;
                    this.composing = false;
                    this.mouseDown = false;
                    this.root = this.scroll.domNode;
                    this.cursor = _parchment2.default.create('cursor', this);
                    // savedRange is last non-null range
                    this.lastRange = this.savedRange = new Range(0, 0);
                    this.handleComposition();
                    this.handleDragging();
                    this.emitter.listenDOM('selectionchange', document, function () {
                        if (!_this.mouseDown) {
                            setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
                        }
                    });
                    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
                        if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
                            _this.update(_emitter4.default.sources.SILENT);
                        }
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
                        if (!_this.hasFocus())
                            return;
                        var native = _this.getNativeRange();
                        if (native == null)
                            return;
                        if (native.start.node === _this.cursor.textNode)
                            return; // cursor.restore() will handle
                        // TODO unclear if this has negative side effects
                        _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
                            try {
                                _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                            }
                            catch (ignored) { }
                        });
                    });
                    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
                        if (context.range) {
                            var _context$range = context.range, startNode = _context$range.startNode, startOffset = _context$range.startOffset, endNode = _context$range.endNode, endOffset = _context$range.endOffset;
                            _this.setNativeRange(startNode, startOffset, endNode, endOffset);
                        }
                    });
                    this.update(_emitter4.default.sources.SILENT);
                }
                _createClass(Selection, [{
                        key: 'handleComposition',
                        value: function handleComposition() {
                            var _this2 = this;
                            this.root.addEventListener('compositionstart', function () {
                                _this2.composing = true;
                            });
                            this.root.addEventListener('compositionend', function () {
                                _this2.composing = false;
                                if (_this2.cursor.parent) {
                                    var range = _this2.cursor.restore();
                                    if (!range)
                                        return;
                                    setTimeout(function () {
                                        _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                                    }, 1);
                                }
                            });
                        }
                    }, {
                        key: 'handleDragging',
                        value: function handleDragging() {
                            var _this3 = this;
                            this.emitter.listenDOM('mousedown', document.body, function () {
                                _this3.mouseDown = true;
                            });
                            this.emitter.listenDOM('mouseup', document.body, function () {
                                _this3.mouseDown = false;
                                _this3.update(_emitter4.default.sources.USER);
                            });
                        }
                    }, {
                        key: 'focus',
                        value: function focus() {
                            if (this.hasFocus())
                                return;
                            this.root.focus();
                            this.setRange(this.savedRange);
                        }
                    }, {
                        key: 'format',
                        value: function format(_format, value) {
                            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format])
                                return;
                            this.scroll.update();
                            var nativeRange = this.getNativeRange();
                            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK))
                                return;
                            if (nativeRange.start.node !== this.cursor.textNode) {
                                var blot = _parchment2.default.find(nativeRange.start.node, false);
                                if (blot == null)
                                    return;
                                // TODO Give blot ability to not split
                                if (blot instanceof _parchment2.default.Leaf) {
                                    var after = blot.split(nativeRange.start.offset);
                                    blot.parent.insertBefore(this.cursor, after);
                                }
                                else {
                                    blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
                                }
                                this.cursor.attach();
                            }
                            this.cursor.format(_format, value);
                            this.scroll.optimize();
                            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
                            this.update();
                        }
                    }, {
                        key: 'getBounds',
                        value: function getBounds(index) {
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                            var scrollLength = this.scroll.length();
                            index = Math.min(index, scrollLength - 1);
                            length = Math.min(index + length, scrollLength - 1) - index;
                            var node = void 0, _scroll$leaf = this.scroll.leaf(index), _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2), leaf = _scroll$leaf2[0], offset = _scroll$leaf2[1];
                            if (leaf == null)
                                return null;
                            var _leaf$position = leaf.position(offset, true);
                            var _leaf$position2 = _slicedToArray(_leaf$position, 2);
                            node = _leaf$position2[0];
                            offset = _leaf$position2[1];
                            var range = document.createRange();
                            if (length > 0) {
                                range.setStart(node, offset);
                                var _scroll$leaf3 = this.scroll.leaf(index + length);
                                var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
                                leaf = _scroll$leaf4[0];
                                offset = _scroll$leaf4[1];
                                if (leaf == null)
                                    return null;
                                var _leaf$position3 = leaf.position(offset, true);
                                var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
                                node = _leaf$position4[0];
                                offset = _leaf$position4[1];
                                range.setEnd(node, offset);
                                return range.getBoundingClientRect();
                            }
                            else {
                                var side = 'left';
                                var rect = void 0;
                                if (node instanceof Text) {
                                    if (offset < node.data.length) {
                                        range.setStart(node, offset);
                                        range.setEnd(node, offset + 1);
                                    }
                                    else {
                                        range.setStart(node, offset - 1);
                                        range.setEnd(node, offset);
                                        side = 'right';
                                    }
                                    rect = range.getBoundingClientRect();
                                }
                                else {
                                    rect = leaf.domNode.getBoundingClientRect();
                                    if (offset > 0)
                                        side = 'right';
                                }
                                return {
                                    bottom: rect.top + rect.height,
                                    height: rect.height,
                                    left: rect[side],
                                    right: rect[side],
                                    top: rect.top,
                                    width: 0
                                };
                            }
                        }
                    }, {
                        key: 'getNativeRange',
                        value: function getNativeRange() {
                            var selection = document.getSelection();
                            if (selection == null || selection.rangeCount <= 0)
                                return null;
                            var nativeRange = selection.getRangeAt(0);
                            if (nativeRange == null)
                                return null;
                            var range = this.normalizeNative(nativeRange);
                            debug.info('getNativeRange', range);
                            return range;
                        }
                    }, {
                        key: 'getRange',
                        value: function getRange() {
                            var normalized = this.getNativeRange();
                            if (normalized == null)
                                return [null, null];
                            var range = this.normalizedToRange(normalized);
                            return [range, normalized];
                        }
                    }, {
                        key: 'hasFocus',
                        value: function hasFocus() {
                            return document.activeElement === this.root;
                        }
                    }, {
                        key: 'normalizedToRange',
                        value: function normalizedToRange(range) {
                            var _this4 = this;
                            var positions = [[range.start.node, range.start.offset]];
                            if (!range.native.collapsed) {
                                positions.push([range.end.node, range.end.offset]);
                            }
                            var indexes = positions.map(function (position) {
                                var _position = _slicedToArray(position, 2), node = _position[0], offset = _position[1];
                                var blot = _parchment2.default.find(node, true);
                                var index = blot.offset(_this4.scroll);
                                if (offset === 0) {
                                    return index;
                                }
                                else if (blot instanceof _parchment2.default.Container) {
                                    return index + blot.length();
                                }
                                else {
                                    return index + blot.index(node, offset);
                                }
                            });
                            var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
                            var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
                            return new Range(start, end - start);
                        }
                    }, {
                        key: 'normalizeNative',
                        value: function normalizeNative(nativeRange) {
                            if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
                                return null;
                            }
                            var range = {
                                start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
                                end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
                                native: nativeRange
                            };
                            [range.start, range.end].forEach(function (position) {
                                var node = position.node, offset = position.offset;
                                while (!(node instanceof Text) && node.childNodes.length > 0) {
                                    if (node.childNodes.length > offset) {
                                        node = node.childNodes[offset];
                                        offset = 0;
                                    }
                                    else if (node.childNodes.length === offset) {
                                        node = node.lastChild;
                                        offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                                    }
                                    else {
                                        break;
                                    }
                                }
                                position.node = node, position.offset = offset;
                            });
                            return range;
                        }
                    }, {
                        key: 'rangeToNative',
                        value: function rangeToNative(range) {
                            var _this5 = this;
                            var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
                            var args = [];
                            var scrollLength = this.scroll.length();
                            indexes.forEach(function (index, i) {
                                index = Math.min(scrollLength - 1, index);
                                var node = void 0, _scroll$leaf5 = _this5.scroll.leaf(index), _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2), leaf = _scroll$leaf6[0], offset = _scroll$leaf6[1];
                                var _leaf$position5 = leaf.position(offset, i !== 0);
                                var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
                                node = _leaf$position6[0];
                                offset = _leaf$position6[1];
                                args.push(node, offset);
                            });
                            if (args.length < 2) {
                                args = args.concat(args);
                            }
                            return args;
                        }
                    }, {
                        key: 'scrollIntoView',
                        value: function scrollIntoView(scrollingContainer) {
                            var range = this.lastRange;
                            if (range == null)
                                return;
                            var bounds = this.getBounds(range.index, range.length);
                            if (bounds == null)
                                return;
                            var limit = this.scroll.length() - 1;
                            var _scroll$line = this.scroll.line(Math.min(range.index, limit)), _scroll$line2 = _slicedToArray(_scroll$line, 1), first = _scroll$line2[0];
                            var last = first;
                            if (range.length > 0) {
                                var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
                                var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
                                last = _scroll$line4[0];
                            }
                            if (first == null || last == null)
                                return;
                            var scrollBounds = scrollingContainer.getBoundingClientRect();
                            if (bounds.top < scrollBounds.top) {
                                scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
                            }
                            else if (bounds.bottom > scrollBounds.bottom) {
                                scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
                            }
                        }
                    }, {
                        key: 'setNativeRange',
                        value: function setNativeRange(startNode, startOffset) {
                            var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
                            var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
                            var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                            debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
                            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
                                return;
                            }
                            var selection = document.getSelection();
                            if (selection == null)
                                return;
                            if (startNode != null) {
                                if (!this.hasFocus())
                                    this.root.focus();
                                var native = (this.getNativeRange() || {}).native;
                                if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                                    if (startNode.tagName == "BR") {
                                        startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                                        startNode = startNode.parentNode;
                                    }
                                    if (endNode.tagName == "BR") {
                                        endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                                        endNode = endNode.parentNode;
                                    }
                                    var range = document.createRange();
                                    range.setStart(startNode, startOffset);
                                    range.setEnd(endNode, endOffset);
                                    selection.removeAllRanges();
                                    selection.addRange(range);
                                }
                            }
                            else {
                                selection.removeAllRanges();
                                this.root.blur();
                                document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
                            }
                        }
                    }, {
                        key: 'setRange',
                        value: function setRange(range) {
                            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
                            if (typeof force === 'string') {
                                source = force;
                                force = false;
                            }
                            debug.info('setRange', range);
                            if (range != null) {
                                var args = this.rangeToNative(range);
                                this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
                            }
                            else {
                                this.setNativeRange(null);
                            }
                            this.update(source);
                        }
                    }, {
                        key: 'update',
                        value: function update() {
                            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
                            var oldRange = this.lastRange;
                            var _getRange = this.getRange(), _getRange2 = _slicedToArray(_getRange, 2), lastRange = _getRange2[0], nativeRange = _getRange2[1];
                            this.lastRange = lastRange;
                            if (this.lastRange != null) {
                                this.savedRange = this.lastRange;
                            }
                            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
                                var _emitter;
                                if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                                    this.cursor.restore();
                                }
                                var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
                                (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
                                if (source !== _emitter4.default.sources.SILENT) {
                                    var _emitter2;
                                    (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                                }
                            }
                        }
                    }]);
                return Selection;
            }();
            function contains(parent, descendant) {
                try {
                    // Firefox inserts inaccessible nodes around video elements
                    descendant.parentNode;
                }
                catch (e) {
                    return false;
                }
                // IE11 has bug with Text nodes
                // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
                if (descendant instanceof Text) {
                    descendant = descendant.parentNode;
                }
                return parent.contains(descendant);
            }
            exports.Range = Range;
            exports.default = Selection;
            /***/ 
        }),
        /* 16 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Break = function (_Parchment$Embed) {
                _inherits(Break, _Parchment$Embed);
                function Break() {
                    _classCallCheck(this, Break);
                    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
                }
                _createClass(Break, [{
                        key: 'insertInto',
                        value: function insertInto(parent, ref) {
                            if (parent.children.length === 0) {
                                _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
                            }
                            else {
                                this.remove();
                            }
                        }
                    }, {
                        key: 'length',
                        value: function length() {
                            return 0;
                        }
                    }, {
                        key: 'value',
                        value: function value() {
                            return '';
                        }
                    }], [{
                        key: 'value',
                        value: function value() {
                            return undefined;
                        }
                    }]);
                return Break;
            }(_parchment2.default.Embed);
            Break.blotName = 'break';
            Break.tagName = 'BR';
            exports.default = Break;
            /***/ 
        }),
        /* 17 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var linked_list_1 = __webpack_require__(44);
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var ContainerBlot = /*@__PURE__*/ (function (_super) {
                __extends(ContainerBlot, _super);
                function ContainerBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ContainerBlot.prototype.appendChild = function (other) {
                    this.insertBefore(other);
                };
                ContainerBlot.prototype.attach = function () {
                    var _this = this;
                    _super.prototype.attach.call(this);
                    this.children = new linked_list_1.default();
                    // Need to be reversed for if DOM nodes already in order
                    [].slice
                        .call(this.domNode.childNodes)
                        .reverse()
                        .forEach(function (node) {
                        try {
                            var child = makeBlot(node);
                            _this.insertBefore(child, _this.children.head);
                        }
                        catch (err) {
                            if (err instanceof Registry.ParchmentError)
                                return;
                            else
                                throw err;
                        }
                    });
                };
                ContainerBlot.prototype.deleteAt = function (index, length) {
                    if (index === 0 && length === this.length()) {
                        return this.remove();
                    }
                    this.children.forEachAt(index, length, function (child, offset, length) {
                        child.deleteAt(offset, length);
                    });
                };
                ContainerBlot.prototype.descendant = function (criteria, index) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if ((criteria.blotName == null && criteria(child)) ||
                        (criteria.blotName != null && child instanceof criteria)) {
                        return [child, offset];
                    }
                    else if (child instanceof ContainerBlot) {
                        return child.descendant(criteria, offset);
                    }
                    else {
                        return [null, -1];
                    }
                };
                ContainerBlot.prototype.descendants = function (criteria, index, length) {
                    if (index === void 0) {
                        index = 0;
                    }
                    if (length === void 0) {
                        length = Number.MAX_VALUE;
                    }
                    var descendants = [], lengthLeft = length;
                    this.children.forEachAt(index, length, function (child, index, length) {
                        if ((criteria.blotName == null && criteria(child)) ||
                            (criteria.blotName != null && child instanceof criteria)) {
                            descendants.push(child);
                        }
                        if (child instanceof ContainerBlot) {
                            descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
                        }
                        lengthLeft -= length;
                    });
                    return descendants;
                };
                ContainerBlot.prototype.detach = function () {
                    this.children.forEach(function (child) {
                        child.detach();
                    });
                    _super.prototype.detach.call(this);
                };
                ContainerBlot.prototype.formatAt = function (index, length, name, value) {
                    this.children.forEachAt(index, length, function (child, offset, length) {
                        child.formatAt(offset, length, name, value);
                    });
                };
                ContainerBlot.prototype.insertAt = function (index, value, def) {
                    var _a = this.children.find(index), child = _a[0], offset = _a[1];
                    if (child) {
                        child.insertAt(offset, value, def);
                    }
                    else {
                        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
                        this.appendChild(blot);
                    }
                };
                ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
                    if (this.statics.allowedChildren != null &&
                        !this.statics.allowedChildren.some(function (child) {
                            return childBlot instanceof child;
                        })) {
                        throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
                    }
                    childBlot.insertInto(this, refBlot);
                };
                ContainerBlot.prototype.length = function () {
                    return this.children.reduce(function (memo, child) {
                        return memo + child.length();
                    }, 0);
                };
                ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
                    this.children.forEach(function (child) {
                        targetParent.insertBefore(child, refNode);
                    });
                };
                ContainerBlot.prototype.optimize = function (context) {
                    _super.prototype.optimize.call(this, context);
                    if (this.children.length === 0) {
                        if (this.statics.defaultChild != null) {
                            var child = Registry.create(this.statics.defaultChild);
                            this.appendChild(child);
                            child.optimize(context);
                        }
                        else {
                            this.remove();
                        }
                    }
                };
                ContainerBlot.prototype.path = function (index, inclusive) {
                    if (inclusive === void 0) {
                        inclusive = false;
                    }
                    var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
                    var position = [[this, index]];
                    if (child instanceof ContainerBlot) {
                        return position.concat(child.path(offset, inclusive));
                    }
                    else if (child != null) {
                        position.push([child, offset]);
                    }
                    return position;
                };
                ContainerBlot.prototype.removeChild = function (child) {
                    this.children.remove(child);
                };
                ContainerBlot.prototype.replace = function (target) {
                    if (target instanceof ContainerBlot) {
                        target.moveChildren(this);
                    }
                    _super.prototype.replace.call(this, target);
                };
                ContainerBlot.prototype.split = function (index, force) {
                    if (force === void 0) {
                        force = false;
                    }
                    if (!force) {
                        if (index === 0)
                            return this;
                        if (index === this.length())
                            return this.next;
                    }
                    var after = this.clone();
                    this.parent.insertBefore(after, this.next);
                    this.children.forEachAt(index, this.length(), function (child, offset, length) {
                        child = child.split(offset, force);
                        after.appendChild(child);
                    });
                    return after;
                };
                ContainerBlot.prototype.unwrap = function () {
                    this.moveChildren(this.parent, this.next);
                    this.remove();
                };
                ContainerBlot.prototype.update = function (mutations, context) {
                    var _this = this;
                    var addedNodes = [], removedNodes = [];
                    mutations.forEach(function (mutation) {
                        if (mutation.target === _this.domNode && mutation.type === 'childList') {
                            addedNodes.push.apply(addedNodes, mutation.addedNodes);
                            removedNodes.push.apply(removedNodes, mutation.removedNodes);
                        }
                    });
                    removedNodes.forEach(function (node) {
                        // Check node has actually been removed
                        // One exception is Chrome does not immediately remove IFRAMEs
                        // from DOM but MutationRecord is correct in its reported removal
                        if (node.parentNode != null &&
                            node.tagName !== 'IFRAME' &&
                            document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                            return;
                        }
                        var blot = Registry.find(node);
                        if (blot == null)
                            return;
                        if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                            blot.detach();
                        }
                    });
                    addedNodes
                        .filter(function (node) {
                        return node.parentNode == _this.domNode;
                    })
                        .sort(function (a, b) {
                        if (a === b)
                            return 0;
                        if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                            return 1;
                        }
                        return -1;
                    })
                        .forEach(function (node) {
                        var refBlot = null;
                        if (node.nextSibling != null) {
                            refBlot = Registry.find(node.nextSibling);
                        }
                        var blot = makeBlot(node);
                        if (blot.next != refBlot || blot.next == null) {
                            if (blot.parent != null) {
                                blot.parent.removeChild(_this);
                            }
                            _this.insertBefore(blot, refBlot);
                        }
                    });
                };
                return ContainerBlot;
            }(shadow_1.default));
            function makeBlot(node) {
                var blot = Registry.find(node);
                if (blot == null) {
                    try {
                        blot = Registry.create(node);
                    }
                    catch (e) {
                        blot = Registry.create(Registry.Scope.INLINE);
                        [].slice.call(node.childNodes).forEach(function (child) {
                            blot.domNode.appendChild(child);
                        });
                        node.parentNode.replaceChild(blot.domNode, node);
                        blot.attach();
                    }
                }
                return blot;
            }
            exports.default = ContainerBlot;
            /***/ 
        }),
        /* 18 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var attributor_1 = __webpack_require__(12);
            var store_1 = __webpack_require__(31);
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var FormatBlot = /*@__PURE__*/ (function (_super) {
                __extends(FormatBlot, _super);
                function FormatBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                FormatBlot.formats = function (domNode) {
                    if (typeof this.tagName === 'string') {
                        return true;
                    }
                    else if (Array.isArray(this.tagName)) {
                        return domNode.tagName.toLowerCase();
                    }
                    return undefined;
                };
                FormatBlot.prototype.attach = function () {
                    _super.prototype.attach.call(this);
                    this.attributes = new store_1.default(this.domNode);
                };
                FormatBlot.prototype.format = function (name, value) {
                    var format = Registry.query(name);
                    if (format instanceof attributor_1.default) {
                        this.attributes.attribute(format, value);
                    }
                    else if (value) {
                        if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                            this.replaceWith(name, value);
                        }
                    }
                };
                FormatBlot.prototype.formats = function () {
                    var formats = this.attributes.values();
                    var format = this.statics.formats(this.domNode);
                    if (format != null) {
                        formats[this.statics.blotName] = format;
                    }
                    return formats;
                };
                FormatBlot.prototype.replaceWith = function (name, value) {
                    var replacement = _super.prototype.replaceWith.call(this, name, value);
                    this.attributes.copy(replacement);
                    return replacement;
                };
                FormatBlot.prototype.update = function (mutations, context) {
                    var _this = this;
                    _super.prototype.update.call(this, mutations, context);
                    if (mutations.some(function (mutation) {
                        return mutation.target === _this.domNode && mutation.type === 'attributes';
                    })) {
                        this.attributes.build();
                    }
                };
                FormatBlot.prototype.wrap = function (name, value) {
                    var wrapper = _super.prototype.wrap.call(this, name, value);
                    if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
                        this.attributes.move(wrapper);
                    }
                    return wrapper;
                };
                return FormatBlot;
            }(container_1.default));
            exports.default = FormatBlot;
            /***/ 
        }),
        /* 19 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var shadow_1 = __webpack_require__(30);
            var Registry = __webpack_require__(1);
            var LeafBlot = /*@__PURE__*/ (function (_super) {
                __extends(LeafBlot, _super);
                function LeafBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                LeafBlot.value = function (domNode) {
                    return true;
                };
                LeafBlot.prototype.index = function (node, offset) {
                    if (this.domNode === node ||
                        this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                        return Math.min(offset, 1);
                    }
                    return -1;
                };
                LeafBlot.prototype.position = function (index, inclusive) {
                    var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                    if (index > 0)
                        offset += 1;
                    return [this.parent.domNode, offset];
                };
                LeafBlot.prototype.value = function () {
                    return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
                    var _a;
                };
                LeafBlot.scope = Registry.Scope.INLINE_BLOT;
                return LeafBlot;
            }(shadow_1.default));
            exports.default = LeafBlot;
            /***/ 
        }),
        /* 20 */
        /***/ (function (module, exports, __webpack_require__) {
            var equal = __webpack_require__(11);
            var extend = __webpack_require__(3);
            var lib = {
                attributes: {
                    compose: function (a, b, keepNull) {
                        if (typeof a !== 'object')
                            a = {};
                        if (typeof b !== 'object')
                            b = {};
                        var attributes = extend(true, {}, b);
                        if (!keepNull) {
                            attributes = Object.keys(attributes).reduce(function (copy, key) {
                                if (attributes[key] != null) {
                                    copy[key] = attributes[key];
                                }
                                return copy;
                            }, {});
                        }
                        for (var key in a) {
                            if (a[key] !== undefined && b[key] === undefined) {
                                attributes[key] = a[key];
                            }
                        }
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    diff: function (a, b) {
                        if (typeof a !== 'object')
                            a = {};
                        if (typeof b !== 'object')
                            b = {};
                        var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
                            if (!equal(a[key], b[key])) {
                                attributes[key] = b[key] === undefined ? null : b[key];
                            }
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    },
                    transform: function (a, b, priority) {
                        if (typeof a !== 'object')
                            return b;
                        if (typeof b !== 'object')
                            return undefined;
                        if (!priority)
                            return b; // b simply overwrites us without priority
                        var attributes = Object.keys(b).reduce(function (attributes, key) {
                            if (a[key] === undefined)
                                attributes[key] = b[key]; // null is a valid value
                            return attributes;
                        }, {});
                        return Object.keys(attributes).length > 0 ? attributes : undefined;
                    }
                },
                iterator: function (ops) {
                    return new Iterator(ops);
                },
                length: function (op) {
                    if (typeof op['delete'] === 'number') {
                        return op['delete'];
                    }
                    else if (typeof op.retain === 'number') {
                        return op.retain;
                    }
                    else {
                        return typeof op.insert === 'string' ? op.insert.length : 1;
                    }
                }
            };
            function Iterator(ops) {
                this.ops = ops;
                this.index = 0;
                this.offset = 0;
            }
            ;
            Iterator.prototype.hasNext = function () {
                return this.peekLength() < Infinity;
            };
            Iterator.prototype.next = function (length) {
                if (!length)
                    length = Infinity;
                var nextOp = this.ops[this.index];
                if (nextOp) {
                    var offset = this.offset;
                    var opLength = lib.length(nextOp);
                    if (length >= opLength - offset) {
                        length = opLength - offset;
                        this.index += 1;
                        this.offset = 0;
                    }
                    else {
                        this.offset += length;
                    }
                    if (typeof nextOp['delete'] === 'number') {
                        return { 'delete': length };
                    }
                    else {
                        var retOp = {};
                        if (nextOp.attributes) {
                            retOp.attributes = nextOp.attributes;
                        }
                        if (typeof nextOp.retain === 'number') {
                            retOp.retain = length;
                        }
                        else if (typeof nextOp.insert === 'string') {
                            retOp.insert = nextOp.insert.substr(offset, length);
                        }
                        else {
                            // offset should === 0, length should === 1
                            retOp.insert = nextOp.insert;
                        }
                        return retOp;
                    }
                }
                else {
                    return { retain: Infinity };
                }
            };
            Iterator.prototype.peek = function () {
                return this.ops[this.index];
            };
            Iterator.prototype.peekLength = function () {
                if (this.ops[this.index]) {
                    // Should never return 0 if our index is being managed correctly
                    return lib.length(this.ops[this.index]) - this.offset;
                }
                else {
                    return Infinity;
                }
            };
            Iterator.prototype.peekType = function () {
                if (this.ops[this.index]) {
                    if (typeof this.ops[this.index]['delete'] === 'number') {
                        return 'delete';
                    }
                    else if (typeof this.ops[this.index].retain === 'number') {
                        return 'retain';
                    }
                    else {
                        return 'insert';
                    }
                }
                return 'retain';
            };
            module.exports = lib;
            /***/ 
        }),
        /* 21 */
        /***/ (function (module, exports) {
            var clone = (function () {
                'use strict';
                function _instanceof(obj, type) {
                    return type != null && obj instanceof type;
                }
                var nativeMap;
                try {
                    nativeMap = Map;
                }
                catch (_) {
                    // maybe a reference error because no `Map`. Give it a dummy value that no
                    // value will ever be an instanceof.
                    nativeMap = function () { };
                }
                var nativeSet;
                try {
                    nativeSet = Set;
                }
                catch (_) {
                    nativeSet = function () { };
                }
                var nativePromise;
                try {
                    nativePromise = Promise;
                }
                catch (_) {
                    nativePromise = function () { };
                }
                /**
                 * Clones (copies) an Object using deep copying.
                 *
                 * This function supports circular references by default, but if you are certain
                 * there are no circular references in your object, you can save some CPU time
                 * by calling clone(obj, false).
                 *
                 * Caution: if `circular` is false and `parent` contains circular references,
                 * your program may enter an infinite loop and crash.
                 *
                 * @param `parent` - the object to be cloned
                 * @param `circular` - set to true if the object to be cloned may contain
                 *    circular references. (optional - true by default)
                 * @param `depth` - set to a number if the object is only to be cloned to
                 *    a particular depth. (optional - defaults to Infinity)
                 * @param `prototype` - sets the prototype to be used when cloning an object.
                 *    (optional - defaults to parent prototype).
                 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
                 *    should be cloned as well. Non-enumerable properties on the prototype
                 *    chain will be ignored. (optional - false by default)
                */
                function clone(parent, circular, depth, prototype, includeNonEnumerable) {
                    if (typeof circular === 'object') {
                        depth = circular.depth;
                        prototype = circular.prototype;
                        includeNonEnumerable = circular.includeNonEnumerable;
                        circular = circular.circular;
                    }
                    // maintain two arrays for circular references, where corresponding parents
                    // and children have the same index
                    var allParents = [];
                    var allChildren = [];
                    var useBuffer = typeof Buffer != 'undefined';
                    if (typeof circular == 'undefined')
                        circular = true;
                    if (typeof depth == 'undefined')
                        depth = Infinity;
                    // recurse this function so we don't reset allParents and allChildren
                    function _clone(parent, depth) {
                        // cloning null always returns null
                        if (parent === null)
                            return null;
                        if (depth === 0)
                            return parent;
                        var child;
                        var proto;
                        if (typeof parent != 'object') {
                            return parent;
                        }
                        if (_instanceof(parent, nativeMap)) {
                            child = new nativeMap();
                        }
                        else if (_instanceof(parent, nativeSet)) {
                            child = new nativeSet();
                        }
                        else if (_instanceof(parent, nativePromise)) {
                            child = new nativePromise(function (resolve, reject) {
                                parent.then(function (value) {
                                    resolve(_clone(value, depth - 1));
                                }, function (err) {
                                    reject(_clone(err, depth - 1));
                                });
                            });
                        }
                        else if (clone.__isArray(parent)) {
                            child = [];
                        }
                        else if (clone.__isRegExp(parent)) {
                            child = new RegExp(parent.source, __getRegExpFlags(parent));
                            if (parent.lastIndex)
                                child.lastIndex = parent.lastIndex;
                        }
                        else if (clone.__isDate(parent)) {
                            child = new Date(parent.getTime());
                        }
                        else if (useBuffer && Buffer.isBuffer(parent)) {
                            child = new Buffer(parent.length);
                            parent.copy(child);
                            return child;
                        }
                        else if (_instanceof(parent, Error)) {
                            child = Object.create(parent);
                        }
                        else {
                            if (typeof prototype == 'undefined') {
                                proto = Object.getPrototypeOf(parent);
                                child = Object.create(proto);
                            }
                            else {
                                child = Object.create(prototype);
                                proto = prototype;
                            }
                        }
                        if (circular) {
                            var index = allParents.indexOf(parent);
                            if (index != -1) {
                                return allChildren[index];
                            }
                            allParents.push(parent);
                            allChildren.push(child);
                        }
                        if (_instanceof(parent, nativeMap)) {
                            parent.forEach(function (value, key) {
                                var keyChild = _clone(key, depth - 1);
                                var valueChild = _clone(value, depth - 1);
                                child.set(keyChild, valueChild);
                            });
                        }
                        if (_instanceof(parent, nativeSet)) {
                            parent.forEach(function (value) {
                                var entryChild = _clone(value, depth - 1);
                                child.add(entryChild);
                            });
                        }
                        for (var i in parent) {
                            var attrs;
                            if (proto) {
                                attrs = Object.getOwnPropertyDescriptor(proto, i);
                            }
                            if (attrs && attrs.set == null) {
                                continue;
                            }
                            child[i] = _clone(parent[i], depth - 1);
                        }
                        if (Object.getOwnPropertySymbols) {
                            var symbols = Object.getOwnPropertySymbols(parent);
                            for (var i = 0; i < symbols.length; i++) {
                                // Don't need to worry about cloning a symbol because it is a primitive,
                                // like a number or string.
                                var symbol = symbols[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
                                    continue;
                                }
                                child[symbol] = _clone(parent[symbol], depth - 1);
                                if (!descriptor.enumerable) {
                                    Object.defineProperty(child, symbol, {
                                        enumerable: false
                                    });
                                }
                            }
                        }
                        if (includeNonEnumerable) {
                            var allPropertyNames = Object.getOwnPropertyNames(parent);
                            for (var i = 0; i < allPropertyNames.length; i++) {
                                var propertyName = allPropertyNames[i];
                                var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                                if (descriptor && descriptor.enumerable) {
                                    continue;
                                }
                                child[propertyName] = _clone(parent[propertyName], depth - 1);
                                Object.defineProperty(child, propertyName, {
                                    enumerable: false
                                });
                            }
                        }
                        return child;
                    }
                    return _clone(parent, depth);
                }
                /**
                 * Simple flat clone using prototype, accepts only objects, usefull for property
                 * override on FLAT configuration object (no nested props).
                 *
                 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
                 * works.
                 */
                clone.clonePrototype = function clonePrototype(parent) {
                    if (parent === null)
                        return null;
                    var c = function () { };
                    c.prototype = parent;
                    return new c();
                };
                // private utility functions
                function __objToStr(o) {
                    return Object.prototype.toString.call(o);
                }
                clone.__objToStr = __objToStr;
                function __isDate(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object Date]';
                }
                clone.__isDate = __isDate;
                function __isArray(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object Array]';
                }
                clone.__isArray = __isArray;
                function __isRegExp(o) {
                    return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
                }
                clone.__isRegExp = __isRegExp;
                function __getRegExpFlags(re) {
                    var flags = '';
                    if (re.global)
                        flags += 'g';
                    if (re.ignoreCase)
                        flags += 'i';
                    if (re.multiline)
                        flags += 'm';
                    return flags;
                }
                clone.__getRegExpFlags = __getRegExpFlags;
                return clone;
            })();
            if (typeof module === 'object' && module.exports) {
                module.exports = clone;
            }
            /***/ 
        }),
        /* 22 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _container = __webpack_require__(24);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            function isLine(blot) {
                return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
            }
            var Scroll = function (_Parchment$Scroll) {
                _inherits(Scroll, _Parchment$Scroll);
                function Scroll(domNode, config) {
                    _classCallCheck(this, Scroll);
                    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
                    _this.emitter = config.emitter;
                    if (Array.isArray(config.whitelist)) {
                        _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
                            whitelist[format] = true;
                            return whitelist;
                        }, {});
                    }
                    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
                    _this.domNode.addEventListener('DOMNodeInserted', function () { });
                    _this.optimize();
                    _this.enable();
                    return _this;
                }
                _createClass(Scroll, [{
                        key: 'batchStart',
                        value: function batchStart() {
                            this.batch = true;
                        }
                    }, {
                        key: 'batchEnd',
                        value: function batchEnd() {
                            this.batch = false;
                            this.optimize();
                        }
                    }, {
                        key: 'deleteAt',
                        value: function deleteAt(index, length) {
                            var _line = this.line(index), _line2 = _slicedToArray(_line, 2), first = _line2[0], offset = _line2[1];
                            var _line3 = this.line(index + length), _line4 = _slicedToArray(_line3, 1), last = _line4[0];
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
                            if (last != null && first !== last && offset > 0) {
                                if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                                    this.optimize();
                                    return;
                                }
                                if (first instanceof _code2.default) {
                                    var newlineIndex = first.newlineIndex(first.length(), true);
                                    if (newlineIndex > -1) {
                                        first = first.split(newlineIndex + 1);
                                        if (first === last) {
                                            this.optimize();
                                            return;
                                        }
                                    }
                                }
                                else if (last instanceof _code2.default) {
                                    var _newlineIndex = last.newlineIndex(0);
                                    if (_newlineIndex > -1) {
                                        last.split(_newlineIndex + 1);
                                    }
                                }
                                var ref = last.children.head instanceof _break2.default ? null : last.children.head;
                                first.moveChildren(last, ref);
                                first.remove();
                            }
                            this.optimize();
                        }
                    }, {
                        key: 'enable',
                        value: function enable() {
                            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                            this.domNode.setAttribute('contenteditable', enabled);
                        }
                    }, {
                        key: 'formatAt',
                        value: function formatAt(index, length, format, value) {
                            if (this.whitelist != null && !this.whitelist[format])
                                return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
                            this.optimize();
                        }
                    }, {
                        key: 'insertAt',
                        value: function insertAt(index, value, def) {
                            if (def != null && this.whitelist != null && !this.whitelist[value])
                                return;
                            if (index >= this.length()) {
                                if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                                    var blot = _parchment2.default.create(this.statics.defaultChild);
                                    this.appendChild(blot);
                                    if (def == null && value.endsWith('\n')) {
                                        value = value.slice(0, -1);
                                    }
                                    blot.insertAt(0, value, def);
                                }
                                else {
                                    var embed = _parchment2.default.create(value, def);
                                    this.appendChild(embed);
                                }
                            }
                            else {
                                _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
                            }
                            this.optimize();
                        }
                    }, {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
                                var wrapper = _parchment2.default.create(this.statics.defaultChild);
                                wrapper.appendChild(blot);
                                blot = wrapper;
                            }
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
                        }
                    }, {
                        key: 'leaf',
                        value: function leaf(index) {
                            return this.path(index).pop() || [null, -1];
                        }
                    }, {
                        key: 'line',
                        value: function line(index) {
                            if (index === this.length()) {
                                return this.line(index - 1);
                            }
                            return this.descendant(isLine, index);
                        }
                    }, {
                        key: 'lines',
                        value: function lines() {
                            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
                            var getLines = function getLines(blot, index, length) {
                                var lines = [], lengthLeft = length;
                                blot.children.forEachAt(index, length, function (child, index, length) {
                                    if (isLine(child)) {
                                        lines.push(child);
                                    }
                                    else if (child instanceof _parchment2.default.Container) {
                                        lines = lines.concat(getLines(child, index, lengthLeft));
                                    }
                                    lengthLeft -= length;
                                });
                                return lines;
                            };
                            return getLines(this, index, length);
                        }
                    }, {
                        key: 'optimize',
                        value: function optimize() {
                            var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            if (this.batch === true)
                                return;
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
                            if (mutations.length > 0) {
                                this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
                            }
                        }
                    }, {
                        key: 'path',
                        value: function path(index) {
                            return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
                        }
                    }, {
                        key: 'update',
                        value: function update(mutations) {
                            if (this.batch === true)
                                return;
                            var source = _emitter2.default.sources.USER;
                            if (typeof mutations === 'string') {
                                source = mutations;
                            }
                            if (!Array.isArray(mutations)) {
                                mutations = this.observer.takeRecords();
                            }
                            if (mutations.length > 0) {
                                this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
                            }
                            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
                            if (mutations.length > 0) {
                                this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
                            }
                        }
                    }]);
                return Scroll;
            }(_parchment2.default.Scroll);
            Scroll.blotName = 'scroll';
            Scroll.className = 'ql-editor';
            Scroll.tagName = 'DIV';
            Scroll.defaultChild = 'block';
            Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
            exports.default = Scroll;
            /***/ 
        }),
        /* 23 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Cursor = function (_Parchment$Embed) {
                _inherits(Cursor, _Parchment$Embed);
                _createClass(Cursor, null, [{
                        key: 'value',
                        value: function value() {
                            return undefined;
                        }
                    }]);
                function Cursor(domNode, selection) {
                    _classCallCheck(this, Cursor);
                    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
                    _this.selection = selection;
                    _this.textNode = document.createTextNode(Cursor.CONTENTS);
                    _this.domNode.appendChild(_this.textNode);
                    _this._length = 0;
                    return _this;
                }
                _createClass(Cursor, [{
                        key: 'detach',
                        value: function detach() {
                            // super.detach() will also clear domNode.__blot
                            if (this.parent != null)
                                this.parent.removeChild(this);
                        }
                    }, {
                        key: 'format',
                        value: function format(name, value) {
                            if (this._length !== 0) {
                                return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
                            }
                            var target = this, index = 0;
                            while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
                                index += target.offset(target.parent);
                                target = target.parent;
                            }
                            if (target != null) {
                                this._length = Cursor.CONTENTS.length;
                                target.optimize();
                                target.formatAt(index, Cursor.CONTENTS.length, name, value);
                                this._length = 0;
                            }
                        }
                    }, {
                        key: 'index',
                        value: function index(node, offset) {
                            if (node === this.textNode)
                                return 0;
                            return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
                        }
                    }, {
                        key: 'length',
                        value: function length() {
                            return this._length;
                        }
                    }, {
                        key: 'position',
                        value: function position() {
                            return [this.textNode, this.textNode.data.length];
                        }
                    }, {
                        key: 'remove',
                        value: function remove() {
                            _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
                            this.parent = null;
                        }
                    }, {
                        key: 'restore',
                        value: function restore() {
                            if (this.selection.composing || this.parent == null)
                                return;
                            var textNode = this.textNode;
                            var range = this.selection.getNativeRange();
                            var restoreText = void 0, start = void 0, end = void 0;
                            if (range != null && range.start.node === textNode && range.end.node === textNode) {
                                var _ref = [textNode, range.start.offset, range.end.offset];
                                restoreText = _ref[0];
                                start = _ref[1];
                                end = _ref[2];
                            }
                            // Link format will insert text outside of anchor tag
                            while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
                                this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                            }
                            if (this.textNode.data !== Cursor.CONTENTS) {
                                var text = this.textNode.data.split(Cursor.CONTENTS).join('');
                                if (this.next instanceof _text2.default) {
                                    restoreText = this.next.domNode;
                                    this.next.insertAt(0, text);
                                    this.textNode.data = Cursor.CONTENTS;
                                }
                                else {
                                    this.textNode.data = text;
                                    this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                                    this.textNode = document.createTextNode(Cursor.CONTENTS);
                                    this.domNode.appendChild(this.textNode);
                                }
                            }
                            this.remove();
                            if (start != null) {
                                var _map = [start, end].map(function (offset) {
                                    return Math.max(0, Math.min(restoreText.data.length, offset - 1));
                                });
                                var _map2 = _slicedToArray(_map, 2);
                                start = _map2[0];
                                end = _map2[1];
                                return {
                                    startNode: restoreText,
                                    startOffset: start,
                                    endNode: restoreText,
                                    endOffset: end
                                };
                            }
                        }
                    }, {
                        key: 'update',
                        value: function update(mutations, context) {
                            var _this2 = this;
                            if (mutations.some(function (mutation) {
                                return mutation.type === 'characterData' && mutation.target === _this2.textNode;
                            })) {
                                var range = this.restore();
                                if (range)
                                    context.range = range;
                            }
                        }
                    }, {
                        key: 'value',
                        value: function value() {
                            return '';
                        }
                    }]);
                return Cursor;
            }(_parchment2.default.Embed);
            Cursor.blotName = 'cursor';
            Cursor.className = 'ql-cursor';
            Cursor.tagName = 'span';
            Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
            exports.default = Cursor;
            /***/ 
        }),
        /* 24 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Container = function (_Parchment$Container) {
                _inherits(Container, _Parchment$Container);
                function Container() {
                    _classCallCheck(this, Container);
                    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
                }
                return Container;
            }(_parchment2.default.Container);
            Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];
            exports.default = Container;
            /***/ 
        }),
        /* 25 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var GUARD_TEXT = '\uFEFF';
            var Embed = function (_Parchment$Embed) {
                _inherits(Embed, _Parchment$Embed);
                function Embed(node) {
                    _classCallCheck(this, Embed);
                    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
                    _this.contentNode = document.createElement('span');
                    _this.contentNode.setAttribute('contenteditable', false);
                    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
                        _this.contentNode.appendChild(childNode);
                    });
                    _this.leftGuard = document.createTextNode(GUARD_TEXT);
                    _this.rightGuard = document.createTextNode(GUARD_TEXT);
                    _this.domNode.appendChild(_this.leftGuard);
                    _this.domNode.appendChild(_this.contentNode);
                    _this.domNode.appendChild(_this.rightGuard);
                    return _this;
                }
                _createClass(Embed, [{
                        key: 'index',
                        value: function index(node, offset) {
                            if (node === this.leftGuard)
                                return 0;
                            if (node === this.rightGuard)
                                return 1;
                            return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
                        }
                    }, {
                        key: 'restore',
                        value: function restore(node) {
                            var range = void 0, textNode = void 0;
                            var text = node.data.split(GUARD_TEXT).join('');
                            if (node === this.leftGuard) {
                                if (this.prev instanceof _text2.default) {
                                    var prevLength = this.prev.length();
                                    this.prev.insertAt(prevLength, text);
                                    range = {
                                        startNode: this.prev.domNode,
                                        startOffset: prevLength + text.length
                                    };
                                }
                                else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            }
                            else if (node === this.rightGuard) {
                                if (this.next instanceof _text2.default) {
                                    this.next.insertAt(0, text);
                                    range = {
                                        startNode: this.next.domNode,
                                        startOffset: text.length
                                    };
                                }
                                else {
                                    textNode = document.createTextNode(text);
                                    this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                                    range = {
                                        startNode: textNode,
                                        startOffset: text.length
                                    };
                                }
                            }
                            node.data = GUARD_TEXT;
                            return range;
                        }
                    }, {
                        key: 'update',
                        value: function update(mutations, context) {
                            var _this2 = this;
                            mutations.forEach(function (mutation) {
                                if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                                    var range = _this2.restore(mutation.target);
                                    if (range)
                                        context.range = range;
                                }
                            });
                        }
                    }]);
                return Embed;
            }(_parchment2.default.Embed);
            exports.default = Embed;
            /***/ 
        }),
        /* 26 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var ColorAttributor = function (_Parchment$Attributor) {
                _inherits(ColorAttributor, _Parchment$Attributor);
                function ColorAttributor() {
                    _classCallCheck(this, ColorAttributor);
                    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
                }
                _createClass(ColorAttributor, [{
                        key: 'value',
                        value: function value(domNode) {
                            var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
                            if (!value.startsWith('rgb('))
                                return value;
                            value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
                            return '#' + value.split(',').map(function (component) {
                                return ('00' + parseInt(component).toString(16)).slice(-2);
                            }).join('');
                        }
                    }]);
                return ColorAttributor;
            }(_parchment2.default.Attributor.Style);
            var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
                scope: _parchment2.default.Scope.INLINE
            });
            var ColorStyle = new ColorAttributor('color', 'color', {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.ColorAttributor = ColorAttributor;
            exports.ColorClass = ColorClass;
            exports.ColorStyle = ColorStyle;
            /***/ 
        }),
        /* 27 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.sanitize = exports.default = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Link = function (_Inline) {
                _inherits(Link, _Inline);
                function Link() {
                    _classCallCheck(this, Link);
                    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
                }
                _createClass(Link, [{
                        key: 'format',
                        value: function format(name, value) {
                            if (name !== this.statics.blotName || !value)
                                return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
                            value = this.constructor.sanitize(value);
                            this.domNode.setAttribute('href', value);
                        }
                    }], [{
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
                            value = this.sanitize(value);
                            node.setAttribute('href', value);
                            node.setAttribute('target', '_blank');
                            return node;
                        }
                    }, {
                        key: 'formats',
                        value: function formats(domNode) {
                            return domNode.getAttribute('href');
                        }
                    }, {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
                        }
                    }]);
                return Link;
            }(_inline2.default);
            Link.blotName = 'link';
            Link.tagName = 'A';
            Link.SANITIZED_URL = 'about:blank';
            Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
            function _sanitize(url, protocols) {
                var anchor = document.createElement('a');
                anchor.href = url;
                var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
                return protocols.indexOf(protocol) > -1;
            }
            exports.default = Link;
            exports.sanitize = _sanitize;
            /***/ 
        }),
        /* 28 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _dropdown = __webpack_require__(107);
            var _dropdown2 = _interopRequireDefault(_dropdown);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            var Picker = /*@__PURE__*/ function () {
                function Picker(select) {
                    var _this = this;
                    _classCallCheck(this, Picker);
                    this.select = select;
                    this.container = document.createElement('span');
                    this.buildPicker();
                    this.select.style.display = 'none';
                    this.select.parentNode.insertBefore(this.container, this.select);
                    this.label.addEventListener('mousedown', function () {
                        _this.container.classList.toggle('ql-expanded');
                    });
                    this.select.addEventListener('change', this.update.bind(this));
                }
                _createClass(Picker, [{
                        key: 'buildItem',
                        value: function buildItem(option) {
                            var _this2 = this;
                            var item = document.createElement('span');
                            item.classList.add('ql-picker-item');
                            if (option.hasAttribute('value')) {
                                item.setAttribute('data-value', option.getAttribute('value'));
                            }
                            if (option.textContent) {
                                item.setAttribute('data-label', option.textContent);
                            }
                            item.addEventListener('click', function () {
                                _this2.selectItem(item, true);
                            });
                            return item;
                        }
                    }, {
                        key: 'buildLabel',
                        value: function buildLabel() {
                            var label = document.createElement('span');
                            label.classList.add('ql-picker-label');
                            label.innerHTML = _dropdown2.default;
                            this.container.appendChild(label);
                            return label;
                        }
                    }, {
                        key: 'buildOptions',
                        value: function buildOptions() {
                            var _this3 = this;
                            var options = document.createElement('span');
                            options.classList.add('ql-picker-options');
                            [].slice.call(this.select.options).forEach(function (option) {
                                var item = _this3.buildItem(option);
                                options.appendChild(item);
                                if (option.selected === true) {
                                    _this3.selectItem(item);
                                }
                            });
                            this.container.appendChild(options);
                        }
                    }, {
                        key: 'buildPicker',
                        value: function buildPicker() {
                            var _this4 = this;
                            [].slice.call(this.select.attributes).forEach(function (item) {
                                _this4.container.setAttribute(item.name, item.value);
                            });
                            this.container.classList.add('ql-picker');
                            this.label = this.buildLabel();
                            this.buildOptions();
                        }
                    }, {
                        key: 'close',
                        value: function close() {
                            this.container.classList.remove('ql-expanded');
                        }
                    }, {
                        key: 'selectItem',
                        value: function selectItem(item) {
                            var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var selected = this.container.querySelector('.ql-selected');
                            if (item === selected)
                                return;
                            if (selected != null) {
                                selected.classList.remove('ql-selected');
                            }
                            if (item == null)
                                return;
                            item.classList.add('ql-selected');
                            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
                            if (item.hasAttribute('data-value')) {
                                this.label.setAttribute('data-value', item.getAttribute('data-value'));
                            }
                            else {
                                this.label.removeAttribute('data-value');
                            }
                            if (item.hasAttribute('data-label')) {
                                this.label.setAttribute('data-label', item.getAttribute('data-label'));
                            }
                            else {
                                this.label.removeAttribute('data-label');
                            }
                            if (trigger) {
                                if (typeof Event === 'function') {
                                    this.select.dispatchEvent(new Event('change'));
                                }
                                else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
                                    // IE11
                                    var event = document.createEvent('Event');
                                    event.initEvent('change', true, true);
                                    this.select.dispatchEvent(event);
                                }
                                this.close();
                            }
                        }
                    }, {
                        key: 'update',
                        value: function update() {
                            var option = void 0;
                            if (this.select.selectedIndex > -1) {
                                var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
                                option = this.select.options[this.select.selectedIndex];
                                this.selectItem(item);
                            }
                            else {
                                this.selectItem(null);
                            }
                            var isActive = option != null && option !== this.select.querySelector('option[selected]');
                            this.label.classList.toggle('ql-active', isActive);
                        }
                    }]);
                return Picker;
            }();
            exports.default = Picker;
            /***/ 
        }),
        /* 29 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _break = __webpack_require__(16);
            var _break2 = _interopRequireDefault(_break);
            var _container = __webpack_require__(24);
            var _container2 = _interopRequireDefault(_container);
            var _cursor = __webpack_require__(23);
            var _cursor2 = _interopRequireDefault(_cursor);
            var _embed = __webpack_require__(25);
            var _embed2 = _interopRequireDefault(_embed);
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            var _scroll = __webpack_require__(22);
            var _scroll2 = _interopRequireDefault(_scroll);
            var _text = __webpack_require__(7);
            var _text2 = _interopRequireDefault(_text);
            var _clipboard = __webpack_require__(55);
            var _clipboard2 = _interopRequireDefault(_clipboard);
            var _history = __webpack_require__(42);
            var _history2 = _interopRequireDefault(_history);
            var _keyboard = __webpack_require__(35);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            _quill2.default.register({
                'blots/block': _block2.default,
                'blots/block/embed': _block.BlockEmbed,
                'blots/break': _break2.default,
                'blots/container': _container2.default,
                'blots/cursor': _cursor2.default,
                'blots/embed': _embed2.default,
                'blots/inline': _inline2.default,
                'blots/scroll': _scroll2.default,
                'blots/text': _text2.default,
                'modules/clipboard': _clipboard2.default,
                'modules/history': _history2.default,
                'modules/keyboard': _keyboard2.default
            });
            _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
            exports.default = _quill2.default;
            /***/ 
        }),
        /* 30 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", { value: true });
            var Registry = __webpack_require__(1);
            var ShadowBlot = /*@__PURE__*/ (function () {
                function ShadowBlot(domNode) {
                    this.domNode = domNode;
                    this.attach();
                }
                Object.defineProperty(ShadowBlot.prototype, "statics", {
                    // Hack for accessing inherited static methods
                    get: function () {
                        return this.constructor;
                    },
                    enumerable: true,
                    configurable: true
                });
                ShadowBlot.create = function (value) {
                    if (this.tagName == null) {
                        throw new Registry.ParchmentError('Blot definition missing tagName');
                    }
                    var node;
                    if (Array.isArray(this.tagName)) {
                        if (typeof value === 'string') {
                            value = value.toUpperCase();
                            if (parseInt(value).toString() === value) {
                                value = parseInt(value);
                            }
                        }
                        if (typeof value === 'number') {
                            node = document.createElement(this.tagName[value - 1]);
                        }
                        else if (this.tagName.indexOf(value) > -1) {
                            node = document.createElement(value);
                        }
                        else {
                            node = document.createElement(this.tagName[0]);
                        }
                    }
                    else {
                        node = document.createElement(this.tagName);
                    }
                    if (this.className) {
                        node.classList.add(this.className);
                    }
                    return node;
                };
                ShadowBlot.prototype.attach = function () {
                    this.domNode[Registry.DATA_KEY] = { blot: this };
                };
                ShadowBlot.prototype.clone = function () {
                    var domNode = this.domNode.cloneNode(false);
                    return Registry.create(domNode);
                };
                ShadowBlot.prototype.detach = function () {
                    if (this.parent != null)
                        this.parent.removeChild(this);
                    delete this.domNode[Registry.DATA_KEY];
                };
                ShadowBlot.prototype.deleteAt = function (index, length) {
                    var blot = this.isolate(index, length);
                    blot.remove();
                };
                ShadowBlot.prototype.formatAt = function (index, length, name, value) {
                    var blot = this.isolate(index, length);
                    if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
                        blot.wrap(name, value);
                    }
                    else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
                        var parent = Registry.create(this.statics.scope);
                        blot.wrap(parent);
                        parent.format(name, value);
                    }
                };
                ShadowBlot.prototype.insertAt = function (index, value, def) {
                    var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
                    var ref = this.split(index);
                    this.parent.insertBefore(blot, ref);
                };
                ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
                    if (this.parent != null) {
                        this.parent.children.remove(this);
                    }
                    parentBlot.children.insertBefore(this, refBlot);
                    if (refBlot != null) {
                        var refDomNode = refBlot.domNode;
                    }
                    if (this.next == null || this.domNode.nextSibling != refDomNode) {
                        parentBlot.domNode.insertBefore(this.domNode, typeof refDomNode !== 'undefined' ? refDomNode : null);
                    }
                    this.parent = parentBlot;
                    this.scroll = parentBlot.scroll;
                };
                ShadowBlot.prototype.isolate = function (index, length) {
                    var target = this.split(index);
                    target.split(length);
                    return target;
                };
                ShadowBlot.prototype.length = function () {
                    return 1;
                };
                ShadowBlot.prototype.offset = function (root) {
                    if (root === void 0) {
                        root = this.parent;
                    }
                    if (this.parent == null || this == root)
                        return 0;
                    return this.parent.children.offset(this) + this.parent.offset(root);
                };
                ShadowBlot.prototype.optimize = function (context) {
                    // TODO clean up once we use WeakMap
                    if (this.domNode[Registry.DATA_KEY] != null) {
                        delete this.domNode[Registry.DATA_KEY].mutations;
                    }
                };
                ShadowBlot.prototype.remove = function () {
                    if (this.domNode.parentNode != null) {
                        this.domNode.parentNode.removeChild(this.domNode);
                    }
                    this.detach();
                };
                ShadowBlot.prototype.replace = function (target) {
                    if (target.parent == null)
                        return;
                    target.parent.insertBefore(this, target.next);
                    target.remove();
                };
                ShadowBlot.prototype.replaceWith = function (name, value) {
                    var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
                    replacement.replace(this);
                    return replacement;
                };
                ShadowBlot.prototype.split = function (index, force) {
                    return index === 0 ? this : this.next;
                };
                ShadowBlot.prototype.update = function (mutations, context) {
                    // Nothing to do by default
                };
                ShadowBlot.prototype.wrap = function (name, value) {
                    var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
                    if (this.parent != null) {
                        this.parent.insertBefore(wrapper, this.next);
                    }
                    wrapper.appendChild(this);
                    return wrapper;
                };
                ShadowBlot.blotName = 'abstract';
                return ShadowBlot;
            }());
            exports.default = ShadowBlot;
            /***/ 
        }),
        /* 31 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", { value: true });
            var attributor_1 = __webpack_require__(12);
            var class_1 = __webpack_require__(32);
            var style_1 = __webpack_require__(33);
            var Registry = __webpack_require__(1);
            var AttributorStore = /*@__PURE__*/ (function () {
                function AttributorStore(domNode) {
                    this.attributes = {};
                    this.domNode = domNode;
                    this.build();
                }
                AttributorStore.prototype.attribute = function (attribute, value) {
                    // verb
                    if (value) {
                        if (attribute.add(this.domNode, value)) {
                            if (attribute.value(this.domNode) != null) {
                                this.attributes[attribute.attrName] = attribute;
                            }
                            else {
                                delete this.attributes[attribute.attrName];
                            }
                        }
                    }
                    else {
                        attribute.remove(this.domNode);
                        delete this.attributes[attribute.attrName];
                    }
                };
                AttributorStore.prototype.build = function () {
                    var _this = this;
                    this.attributes = {};
                    var attributes = attributor_1.default.keys(this.domNode);
                    var classes = class_1.default.keys(this.domNode);
                    var styles = style_1.default.keys(this.domNode);
                    attributes
                        .concat(classes)
                        .concat(styles)
                        .forEach(function (name) {
                        var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
                        if (attr instanceof attributor_1.default) {
                            _this.attributes[attr.attrName] = attr;
                        }
                    });
                };
                AttributorStore.prototype.copy = function (target) {
                    var _this = this;
                    Object.keys(this.attributes).forEach(function (key) {
                        var value = _this.attributes[key].value(_this.domNode);
                        target.format(key, value);
                    });
                };
                AttributorStore.prototype.move = function (target) {
                    var _this = this;
                    this.copy(target);
                    Object.keys(this.attributes).forEach(function (key) {
                        _this.attributes[key].remove(_this.domNode);
                    });
                    this.attributes = {};
                };
                AttributorStore.prototype.values = function () {
                    var _this = this;
                    return Object.keys(this.attributes).reduce(function (attributes, name) {
                        attributes[name] = _this.attributes[name].value(_this.domNode);
                        return attributes;
                    }, {});
                };
                return AttributorStore;
            }());
            exports.default = AttributorStore;
            /***/ 
        }),
        /* 32 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var attributor_1 = __webpack_require__(12);
            function match(node, prefix) {
                var className = node.getAttribute('class') || '';
                return className.split(/\s+/).filter(function (name) {
                    return name.indexOf(prefix + "-") === 0;
                });
            }
            var ClassAttributor = /*@__PURE__*/ (function (_super) {
                __extends(ClassAttributor, _super);
                function ClassAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ClassAttributor.keys = function (node) {
                    return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
                        return name
                            .split('-')
                            .slice(0, -1)
                            .join('-');
                    });
                };
                ClassAttributor.prototype.add = function (node, value) {
                    if (!this.canAdd(node, value))
                        return false;
                    this.remove(node);
                    node.classList.add(this.keyName + "-" + value);
                    return true;
                };
                ClassAttributor.prototype.remove = function (node) {
                    var matches = match(node, this.keyName);
                    matches.forEach(function (name) {
                        node.classList.remove(name);
                    });
                    if (node.classList.length === 0) {
                        node.removeAttribute('class');
                    }
                };
                ClassAttributor.prototype.value = function (node) {
                    var result = match(node, this.keyName)[0] || '';
                    var value = result.slice(this.keyName.length + 1); // +1 for hyphen
                    return this.canAdd(node, value) ? value : '';
                };
                return ClassAttributor;
            }(attributor_1.default));
            exports.default = ClassAttributor;
            /***/ 
        }),
        /* 33 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var attributor_1 = __webpack_require__(12);
            function camelize(name) {
                var parts = name.split('-');
                var rest = parts
                    .slice(1)
                    .map(function (part) {
                    return part[0].toUpperCase() + part.slice(1);
                })
                    .join('');
                return parts[0] + rest;
            }
            var StyleAttributor = /*@__PURE__*/ (function (_super) {
                __extends(StyleAttributor, _super);
                function StyleAttributor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                StyleAttributor.keys = function (node) {
                    return (node.getAttribute('style') || '').split(';').map(function (value) {
                        var arr = value.split(':');
                        return arr[0].trim();
                    });
                };
                StyleAttributor.prototype.add = function (node, value) {
                    if (!this.canAdd(node, value))
                        return false;
                    node.style[camelize(this.keyName)] = value;
                    return true;
                };
                StyleAttributor.prototype.remove = function (node) {
                    node.style[camelize(this.keyName)] = '';
                    if (!node.getAttribute('style')) {
                        node.removeAttribute('style');
                    }
                };
                StyleAttributor.prototype.value = function (node) {
                    var value = node.style[camelize(this.keyName)];
                    return this.canAdd(node, value) ? value : '';
                };
                return StyleAttributor;
            }(attributor_1.default));
            exports.default = StyleAttributor;
            /***/ 
        }),
        /* 34 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            var Theme = /*@__PURE__*/ function () {
                function Theme(quill, options) {
                    _classCallCheck(this, Theme);
                    this.quill = quill;
                    this.options = options;
                    this.modules = {};
                }
                _createClass(Theme, [{
                        key: 'init',
                        value: function init() {
                            var _this = this;
                            Object.keys(this.options.modules).forEach(function (name) {
                                if (_this.modules[name] == null) {
                                    _this.addModule(name);
                                }
                            });
                        }
                    }, {
                        key: 'addModule',
                        value: function addModule(name) {
                            var moduleClass = this.quill.constructor.import('modules/' + name);
                            this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
                            return this.modules[name];
                        }
                    }]);
                return Theme;
            }();
            Theme.DEFAULTS = {
                modules: {}
            };
            Theme.themes = {
                'default': Theme
            };
            exports.default = Theme;
            /***/ 
        }),
        /* 35 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SHORTKEY = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _clone = __webpack_require__(21);
            var _clone2 = _interopRequireDefault(_clone);
            var _deepEqual = __webpack_require__(11);
            var _deepEqual2 = _interopRequireDefault(_deepEqual);
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _op = __webpack_require__(20);
            var _op2 = _interopRequireDefault(_op);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _embed = __webpack_require__(25);
            var _embed2 = _interopRequireDefault(_embed);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _defineProperty(obj, key, value) { if (key in obj) {
                Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
            }
            else {
                obj[key] = value;
            } return obj; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var debug = (0, _logger2.default)('quill:keyboard');
            var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
            var Keyboard = function (_Module) {
                _inherits(Keyboard, _Module);
                _createClass(Keyboard, null, [{
                        key: 'match',
                        value: function match(evt, binding) {
                            binding = normalize(binding);
                            if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
                                return !!binding[key] !== evt[key] && binding[key] !== null;
                            })) {
                                return false;
                            }
                            return binding.key === (evt.which || evt.keyCode);
                        }
                    }]);
                function Keyboard(quill, options) {
                    _classCallCheck(this, Keyboard);
                    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
                    _this.bindings = {};
                    Object.keys(_this.options.bindings).forEach(function (name) {
                        if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
                            return;
                        }
                        if (_this.options.bindings[name]) {
                            _this.addBinding(_this.options.bindings[name]);
                        }
                    });
                    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
                    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () { });
                    if (/Firefox/i.test(navigator.userAgent)) {
                        // Need to handle delete and backspace for Firefox in the general case #1171
                        _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
                        _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
                    }
                    else {
                        _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
                        _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
                    }
                    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
                    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
                    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
                    _this.listen();
                    return _this;
                }
                _createClass(Keyboard, [{
                        key: 'addBinding',
                        value: function addBinding(key) {
                            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                            var binding = normalize(key);
                            if (binding == null || binding.key == null) {
                                return debug.warn('Attempted to add invalid keyboard binding', binding);
                            }
                            if (typeof context === 'function') {
                                context = { handler: context };
                            }
                            if (typeof handler === 'function') {
                                handler = { handler: handler };
                            }
                            binding = (0, _extend2.default)(binding, context, handler);
                            this.bindings[binding.key] = this.bindings[binding.key] || [];
                            this.bindings[binding.key].push(binding);
                        }
                    }, {
                        key: 'listen',
                        value: function listen() {
                            var _this2 = this;
                            this.quill.root.addEventListener('keydown', function (evt) {
                                if (evt.defaultPrevented)
                                    return;
                                var which = evt.which || evt.keyCode;
                                var bindings = (_this2.bindings[which] || []).filter(function (binding) {
                                    return Keyboard.match(evt, binding);
                                });
                                if (bindings.length === 0)
                                    return;
                                var range = _this2.quill.getSelection();
                                if (range == null || !_this2.quill.hasFocus())
                                    return;
                                var _quill$getLine = _this2.quill.getLine(range.index), _quill$getLine2 = _slicedToArray(_quill$getLine, 2), line = _quill$getLine2[0], offset = _quill$getLine2[1];
                                var _quill$getLeaf = _this2.quill.getLeaf(range.index), _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2), leafStart = _quill$getLeaf2[0], offsetStart = _quill$getLeaf2[1];
                                var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length), _ref2 = _slicedToArray(_ref, 2), leafEnd = _ref2[0], offsetEnd = _ref2[1];
                                var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
                                var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
                                var curContext = {
                                    collapsed: range.length === 0,
                                    empty: range.length === 0 && line.length() <= 1,
                                    format: _this2.quill.getFormat(range),
                                    offset: offset,
                                    prefix: prefixText,
                                    suffix: suffixText
                                };
                                var prevented = bindings.some(function (binding) {
                                    if (binding.collapsed != null && binding.collapsed !== curContext.collapsed)
                                        return false;
                                    if (binding.empty != null && binding.empty !== curContext.empty)
                                        return false;
                                    if (binding.offset != null && binding.offset !== curContext.offset)
                                        return false;
                                    if (Array.isArray(binding.format)) {
                                        // any format is present
                                        if (binding.format.every(function (name) {
                                            return curContext.format[name] == null;
                                        })) {
                                            return false;
                                        }
                                    }
                                    else if (_typeof(binding.format) === 'object') {
                                        // all formats must match
                                        if (!Object.keys(binding.format).every(function (name) {
                                            if (binding.format[name] === true)
                                                return curContext.format[name] != null;
                                            if (binding.format[name] === false)
                                                return curContext.format[name] == null;
                                            return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                                        })) {
                                            return false;
                                        }
                                    }
                                    if (binding.prefix != null && !binding.prefix.test(curContext.prefix))
                                        return false;
                                    if (binding.suffix != null && !binding.suffix.test(curContext.suffix))
                                        return false;
                                    return binding.handler.call(_this2, range, curContext) !== true;
                                });
                                if (prevented) {
                                    evt.preventDefault();
                                }
                            });
                        }
                    }]);
                return Keyboard;
            }(_module2.default);
            Keyboard.keys = {
                BACKSPACE: 8,
                TAB: 9,
                ENTER: 13,
                ESCAPE: 27,
                LEFT: 37,
                UP: 38,
                RIGHT: 39,
                DOWN: 40,
                DELETE: 46
            };
            Keyboard.DEFAULTS = {
                bindings: {
                    'bold': makeFormatHandler('bold'),
                    'italic': makeFormatHandler('italic'),
                    'underline': makeFormatHandler('underline'),
                    'indent': {
                        // highlight tab or tab at beginning of list, indent or blockquote
                        key: Keyboard.keys.TAB,
                        format: ['blockquote', 'indent', 'list'],
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0)
                                return true;
                            this.quill.format('indent', '+1', _quill2.default.sources.USER);
                        }
                    },
                    'outdent': {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        format: ['blockquote', 'indent', 'list'],
                        // highlight tab or tab at beginning of list, indent or blockquote
                        handler: function handler(range, context) {
                            if (context.collapsed && context.offset !== 0)
                                return true;
                            this.quill.format('indent', '-1', _quill2.default.sources.USER);
                        }
                    },
                    'outdent backspace': {
                        key: Keyboard.keys.BACKSPACE,
                        collapsed: true,
                        shiftKey: null,
                        metaKey: null,
                        ctrlKey: null,
                        altKey: null,
                        format: ['indent', 'list'],
                        offset: 0,
                        handler: function handler(range, context) {
                            if (context.format.indent != null) {
                                this.quill.format('indent', '-1', _quill2.default.sources.USER);
                            }
                            else if (context.format.list != null) {
                                this.quill.format('list', false, _quill2.default.sources.USER);
                            }
                        }
                    },
                    'indent code-block': makeCodeBlockHandler(true),
                    'outdent code-block': makeCodeBlockHandler(false),
                    'remove tab': {
                        key: Keyboard.keys.TAB,
                        shiftKey: true,
                        collapsed: true,
                        prefix: /\t$/,
                        handler: function handler(range) {
                            this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
                        }
                    },
                    'tab': {
                        key: Keyboard.keys.TAB,
                        handler: function handler(range) {
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                        }
                    },
                    'list empty enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: ['list'],
                        empty: true,
                        handler: function handler(range, context) {
                            this.quill.format('list', false, _quill2.default.sources.USER);
                            if (context.format.indent) {
                                this.quill.format('indent', false, _quill2.default.sources.USER);
                            }
                        }
                    },
                    'checklist enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: { list: 'checked' },
                        handler: function handler(range) {
                            var _quill$getLine3 = this.quill.getLine(range.index), _quill$getLine4 = _slicedToArray(_quill$getLine3, 2), line = _quill$getLine4[0], offset = _quill$getLine4[1];
                            var delta = new _quillDelta2.default().retain(range.index).insert('\n', { list: 'checked' }).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    'header enter': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: ['header'],
                        suffix: /^$/,
                        handler: function handler(range, context) {
                            var _quill$getLine5 = this.quill.getLine(range.index), _quill$getLine6 = _slicedToArray(_quill$getLine5, 2), line = _quill$getLine6[0], offset = _quill$getLine6[1];
                            var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                            this.quill.scrollIntoView();
                        }
                    },
                    'list autofill': {
                        key: ' ',
                        collapsed: true,
                        format: { list: false },
                        prefix: /^\s*?(\d+\.|-|\[ ?\]|\[x\])$/,
                        handler: function handler(range, context) {
                            var length = context.prefix.length;
                            var _quill$getLine7 = this.quill.getLine(range.index), _quill$getLine8 = _slicedToArray(_quill$getLine7, 2), line = _quill$getLine8[0], offset = _quill$getLine8[1];
                            if (offset > length)
                                return true;
                            var value = void 0;
                            switch (context.prefix.trim()) {
                                case '[]':
                                case '[ ]':
                                    value = 'unchecked';
                                    break;
                                case '[x]':
                                    value = 'checked';
                                    break;
                                case '-':
                                    value = 'bullet';
                                    break;
                                default:
                                    value = 'ordered';
                            }
                            this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                            this.quill.history.cutoff();
                            this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
                        }
                    },
                    'code exit': {
                        key: Keyboard.keys.ENTER,
                        collapsed: true,
                        format: ['code-block'],
                        prefix: /\n\n$/,
                        suffix: /^\s+$/,
                        handler: function handler(range) {
                            var _quill$getLine9 = this.quill.getLine(range.index), _quill$getLine10 = _slicedToArray(_quill$getLine9, 2), line = _quill$getLine10[0], offset = _quill$getLine10[1];
                            var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
                            this.quill.updateContents(delta, _quill2.default.sources.USER);
                        }
                    },
                    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
                    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
                    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
                    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
                }
            };
            function makeEmbedArrowHandler(key, shiftKey) {
                var _ref3;
                var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
                return _ref3 = {
                    key: key,
                    shiftKey: shiftKey
                }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
                    var index = range.index;
                    if (key === Keyboard.keys.RIGHT) {
                        index += range.length + 1;
                    }
                    var _quill$getLeaf3 = this.quill.getLeaf(index), _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1), leaf = _quill$getLeaf4[0];
                    if (!(leaf instanceof _embed2.default))
                        return true;
                    if (key === Keyboard.keys.LEFT) {
                        if (shiftKey) {
                            this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
                        }
                        else {
                            this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
                        }
                    }
                    else {
                        if (shiftKey) {
                            this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
                        }
                        else {
                            this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
                        }
                    }
                    return false;
                }), _ref3;
            }
            function handleBackspace(range, context) {
                if (range.index === 0 || this.quill.getLength() <= 1)
                    return;
                var _quill$getLine11 = this.quill.getLine(range.index), _quill$getLine12 = _slicedToArray(_quill$getLine11, 1), line = _quill$getLine12[0];
                var formats = {};
                if (context.offset === 0) {
                    var _quill$getLine13 = this.quill.getLine(range.index - 1), _quill$getLine14 = _slicedToArray(_quill$getLine13, 1), prev = _quill$getLine14[0];
                    if (prev != null && prev.length() > 1) {
                        var curFormats = line.formats();
                        var prevFormats = this.quill.getFormat(range.index - 1, 1);
                        formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
                    }
                }
                // Check for astral symbols
                var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
                this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) {
                    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
                }
                this.quill.focus();
            }
            function handleDelete(range, context) {
                // Check for astral symbols
                var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
                if (range.index >= this.quill.getLength() - length)
                    return;
                var formats = {}, nextLength = 0;
                var _quill$getLine15 = this.quill.getLine(range.index), _quill$getLine16 = _slicedToArray(_quill$getLine15, 1), line = _quill$getLine16[0];
                if (context.offset >= line.length() - 1) {
                    var _quill$getLine17 = this.quill.getLine(range.index + 1), _quill$getLine18 = _slicedToArray(_quill$getLine17, 1), next = _quill$getLine18[0];
                    if (next) {
                        var curFormats = line.formats();
                        var nextFormats = this.quill.getFormat(range.index, 1);
                        formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
                        nextLength = next.length();
                    }
                }
                this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) {
                    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
                }
            }
            function handleDeleteRange(range) {
                var lines = this.quill.getLines(range);
                var formats = {};
                if (lines.length > 1) {
                    var firstFormats = lines[0].formats();
                    var lastFormats = lines[lines.length - 1].formats();
                    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
                }
                this.quill.deleteText(range, _quill2.default.sources.USER);
                if (Object.keys(formats).length > 0) {
                    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
                }
                this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
                this.quill.focus();
            }
            function handleEnter(range, context) {
                var _this3 = this;
                if (range.length > 0) {
                    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
                }
                var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
                    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
                        lineFormats[format] = context.format[format];
                    }
                    return lineFormats;
                }, {});
                this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
                // Earlier scroll.deleteAt might have messed up our selection,
                // so insertText's built in selection preservation is not reliable
                this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                this.quill.focus();
                Object.keys(context.format).forEach(function (name) {
                    if (lineFormats[name] != null)
                        return;
                    if (Array.isArray(context.format[name]))
                        return;
                    if (name === 'link')
                        return;
                    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
                });
            }
            function makeCodeBlockHandler(indent) {
                return {
                    key: Keyboard.keys.TAB,
                    shiftKey: !indent,
                    format: { 'code-block': true },
                    handler: function handler(range) {
                        var CodeBlock = _parchment2.default.query('code-block');
                        var index = range.index, length = range.length;
                        var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), block = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                        if (block == null)
                            return;
                        var scrollIndex = this.quill.getIndex(block);
                        var start = block.newlineIndex(offset, true) + 1;
                        var end = block.newlineIndex(scrollIndex + offset + length);
                        var lines = block.domNode.textContent.slice(start, end).split('\n');
                        offset = 0;
                        lines.forEach(function (line, i) {
                            if (indent) {
                                block.insertAt(start + offset, CodeBlock.TAB);
                                offset += CodeBlock.TAB.length;
                                if (i === 0) {
                                    index += CodeBlock.TAB.length;
                                }
                                else {
                                    length += CodeBlock.TAB.length;
                                }
                            }
                            else if (line.startsWith(CodeBlock.TAB)) {
                                block.deleteAt(start + offset, CodeBlock.TAB.length);
                                offset -= CodeBlock.TAB.length;
                                if (i === 0) {
                                    index -= CodeBlock.TAB.length;
                                }
                                else {
                                    length -= CodeBlock.TAB.length;
                                }
                            }
                            offset += line.length + 1;
                        });
                        this.quill.update(_quill2.default.sources.USER);
                        this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
                    }
                };
            }
            function makeFormatHandler(format) {
                return {
                    key: format[0].toUpperCase(),
                    shortKey: true,
                    handler: function handler(range, context) {
                        this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
                    }
                };
            }
            function normalize(binding) {
                if (typeof binding === 'string' || typeof binding === 'number') {
                    return normalize({ key: binding });
                }
                if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
                    binding = (0, _clone2.default)(binding, false);
                }
                if (typeof binding.key === 'string') {
                    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
                        binding.key = Keyboard.keys[binding.key.toUpperCase()];
                    }
                    else if (binding.key.length === 1) {
                        binding.key = binding.key.toUpperCase().charCodeAt(0);
                    }
                    else {
                        return null;
                    }
                }
                if (binding.shortKey) {
                    binding[SHORTKEY] = binding.shortKey;
                    delete binding.shortKey;
                }
                return binding;
            }
            exports.default = Keyboard;
            exports.SHORTKEY = SHORTKEY;
            /***/ 
        }),
        /* 36 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: ['right', 'center', 'justify']
            };
            var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
            var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
            var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
            exports.AlignAttribute = AlignAttribute;
            exports.AlignClass = AlignClass;
            exports.AlignStyle = AlignStyle;
            /***/ 
        }),
        /* 37 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BackgroundStyle = exports.BackgroundClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _color = __webpack_require__(26);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
                scope: _parchment2.default.Scope.INLINE
            });
            var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
                scope: _parchment2.default.Scope.INLINE
            });
            exports.BackgroundClass = BackgroundClass;
            exports.BackgroundStyle = BackgroundStyle;
            /***/ 
        }),
        /* 38 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            var config = {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: ['rtl']
            };
            var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
            var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
            var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
            exports.DirectionAttribute = DirectionAttribute;
            exports.DirectionClass = DirectionClass;
            exports.DirectionStyle = DirectionStyle;
            /***/ 
        }),
        /* 39 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.FontClass = exports.FontStyle = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var config = {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: ['serif', 'monospace']
            };
            var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
            var FontStyleAttributor = function (_Parchment$Attributor) {
                _inherits(FontStyleAttributor, _Parchment$Attributor);
                function FontStyleAttributor() {
                    _classCallCheck(this, FontStyleAttributor);
                    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
                }
                _createClass(FontStyleAttributor, [{
                        key: 'value',
                        value: function value(node) {
                            return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
                        }
                    }]);
                return FontStyleAttributor;
            }(_parchment2.default.Attributor.Style);
            var FontStyle = new FontStyleAttributor('font', 'font-family', config);
            exports.FontStyle = FontStyle;
            exports.FontClass = FontClass;
            /***/ 
        }),
        /* 40 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.SizeStyle = exports.SizeClass = undefined;
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: ['small', 'large', 'huge']
            });
            var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
                scope: _parchment2.default.Scope.INLINE,
                whitelist: ['10px', '18px', '32px']
            });
            exports.SizeClass = SizeClass;
            exports.SizeStyle = SizeStyle;
            /***/ 
        }),
        /* 41 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            module.exports = {
                'align': {
                    '': __webpack_require__(76),
                    'center': __webpack_require__(77),
                    'right': __webpack_require__(78),
                    'justify': __webpack_require__(79)
                },
                'background': __webpack_require__(80),
                'blockquote': __webpack_require__(81),
                'bold': __webpack_require__(82),
                'clean': __webpack_require__(83),
                'code': __webpack_require__(58),
                'code-block': __webpack_require__(58),
                'color': __webpack_require__(84),
                'direction': {
                    '': __webpack_require__(85),
                    'rtl': __webpack_require__(86)
                },
                'float': {
                    'center': __webpack_require__(87),
                    'full': __webpack_require__(88),
                    'left': __webpack_require__(89),
                    'right': __webpack_require__(90)
                },
                'formula': __webpack_require__(91),
                'header': {
                    '1': __webpack_require__(92),
                    '2': __webpack_require__(93)
                },
                'italic': __webpack_require__(94),
                'image': __webpack_require__(95),
                'indent': {
                    '+1': __webpack_require__(96),
                    '-1': __webpack_require__(97)
                },
                'link': __webpack_require__(98),
                'list': {
                    'ordered': __webpack_require__(99),
                    'bullet': __webpack_require__(100),
                    'check': __webpack_require__(101)
                },
                'script': {
                    'sub': __webpack_require__(102),
                    'super': __webpack_require__(103)
                },
                'strike': __webpack_require__(104),
                'underline': __webpack_require__(105),
                'video': __webpack_require__(106)
            };
            /***/ 
        }),
        /* 42 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.getLastChangeIndex = exports.default = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var History = function (_Module) {
                _inherits(History, _Module);
                function History(quill, options) {
                    _classCallCheck(this, History);
                    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
                    _this.lastRecorded = 0;
                    _this.ignoreChange = false;
                    _this.clear();
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
                        if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange)
                            return;
                        if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
                            _this.record(delta, oldDelta);
                        }
                        else {
                            _this.transform(delta);
                        }
                    });
                    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
                    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
                    if (/Win/i.test(navigator.platform)) {
                        _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
                    }
                    return _this;
                }
                _createClass(History, [{
                        key: 'change',
                        value: function change(source, dest) {
                            if (this.stack[source].length === 0)
                                return;
                            var delta = this.stack[source].pop();
                            this.lastRecorded = 0;
                            this.ignoreChange = true;
                            this.quill.updateContents(delta[source], _quill2.default.sources.USER);
                            this.ignoreChange = false;
                            var index = getLastChangeIndex(delta[source]);
                            this.quill.setSelection(index);
                            this.stack[dest].push(delta);
                        }
                    }, {
                        key: 'clear',
                        value: function clear() {
                            this.stack = { undo: [], redo: [] };
                        }
                    }, {
                        key: 'cutoff',
                        value: function cutoff() {
                            this.lastRecorded = 0;
                        }
                    }, {
                        key: 'record',
                        value: function record(changeDelta, oldDelta) {
                            if (changeDelta.ops.length === 0)
                                return;
                            this.stack.redo = [];
                            var undoDelta = this.quill.getContents().diff(oldDelta);
                            var timestamp = Date.now();
                            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
                                var delta = this.stack.undo.pop();
                                undoDelta = undoDelta.compose(delta.undo);
                                changeDelta = delta.redo.compose(changeDelta);
                            }
                            else {
                                this.lastRecorded = timestamp;
                            }
                            this.stack.undo.push({
                                redo: changeDelta,
                                undo: undoDelta
                            });
                            if (this.stack.undo.length > this.options.maxStack) {
                                this.stack.undo.shift();
                            }
                        }
                    }, {
                        key: 'redo',
                        value: function redo() {
                            this.change('redo', 'undo');
                        }
                    }, {
                        key: 'transform',
                        value: function transform(delta) {
                            this.stack.undo.forEach(function (change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                            this.stack.redo.forEach(function (change) {
                                change.undo = delta.transform(change.undo, true);
                                change.redo = delta.transform(change.redo, true);
                            });
                        }
                    }, {
                        key: 'undo',
                        value: function undo() {
                            this.change('undo', 'redo');
                        }
                    }]);
                return History;
            }(_module2.default);
            History.DEFAULTS = {
                delay: 1000,
                maxStack: 100,
                userOnly: false
            };
            function endsWithNewlineChange(delta) {
                var lastOp = delta.ops[delta.ops.length - 1];
                if (lastOp == null)
                    return false;
                if (lastOp.insert != null) {
                    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
                }
                if (lastOp.attributes != null) {
                    return Object.keys(lastOp.attributes).some(function (attr) {
                        return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
                    });
                }
                return false;
            }
            function getLastChangeIndex(delta) {
                var deleteLength = delta.reduce(function (length, op) {
                    length += op.delete || 0;
                    return length;
                }, 0);
                var changeIndex = delta.length() - deleteLength;
                if (endsWithNewlineChange(delta)) {
                    changeIndex -= 1;
                }
                return changeIndex;
            }
            exports.default = History;
            exports.getLastChangeIndex = getLastChangeIndex;
            /***/ 
        }),
        /* 43 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BaseTooltip = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _keyboard = __webpack_require__(35);
            var _keyboard2 = _interopRequireDefault(_keyboard);
            var _theme = __webpack_require__(34);
            var _theme2 = _interopRequireDefault(_theme);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var ALIGNS = [false, 'center', 'right', 'justify'];
            var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
            var FONTS = [false, 'serif', 'monospace'];
            var HEADERS = ['1', '2', '3', false];
            var SIZES = ['small', false, 'large', 'huge'];
            var BaseTheme = function (_Theme) {
                _inherits(BaseTheme, _Theme);
                function BaseTheme(quill, options) {
                    _classCallCheck(this, BaseTheme);
                    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
                    var listener = function listener(e) {
                        if (!document.body.contains(quill.root)) {
                            return document.body.removeEventListener('click', listener);
                        }
                        if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
                            _this.tooltip.hide();
                        }
                        if (_this.pickers != null) {
                            _this.pickers.forEach(function (picker) {
                                if (!picker.container.contains(e.target)) {
                                    picker.close();
                                }
                            });
                        }
                    };
                    quill.emitter.listenDOM('click', document.body, listener);
                    return _this;
                }
                _createClass(BaseTheme, [{
                        key: 'addModule',
                        value: function addModule(name) {
                            var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
                            if (name === 'toolbar') {
                                this.extendToolbar(module);
                            }
                            return module;
                        }
                    }, {
                        key: 'buildButtons',
                        value: function buildButtons(buttons, icons) {
                            buttons.forEach(function (button) {
                                var className = button.getAttribute('class') || '';
                                className.split(/\s+/).forEach(function (name) {
                                    if (!name.startsWith('ql-'))
                                        return;
                                    name = name.slice('ql-'.length);
                                    if (icons[name] == null)
                                        return;
                                    if (name === 'direction') {
                                        button.innerHTML = icons[name][''] + icons[name]['rtl'];
                                    }
                                    else if (typeof icons[name] === 'string') {
                                        button.innerHTML = icons[name];
                                    }
                                    else {
                                        var value = button.value || '';
                                        if (value != null && icons[name][value]) {
                                            button.innerHTML = icons[name][value];
                                        }
                                    }
                                });
                            });
                        }
                    }, {
                        key: 'buildPickers',
                        value: function buildPickers(selects, icons) {
                            var _this2 = this;
                            this.pickers = selects.map(function (select) {
                                if (select.classList.contains('ql-align')) {
                                    if (select.querySelector('option') == null) {
                                        fillSelect(select, ALIGNS);
                                    }
                                    return new _iconPicker2.default(select, icons.align);
                                }
                                else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                                    var format = select.classList.contains('ql-background') ? 'background' : 'color';
                                    if (select.querySelector('option') == null) {
                                        fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
                                    }
                                    return new _colorPicker2.default(select, icons[format]);
                                }
                                else {
                                    if (select.querySelector('option') == null) {
                                        if (select.classList.contains('ql-font')) {
                                            fillSelect(select, FONTS);
                                        }
                                        else if (select.classList.contains('ql-header')) {
                                            fillSelect(select, HEADERS);
                                        }
                                        else if (select.classList.contains('ql-size')) {
                                            fillSelect(select, SIZES);
                                        }
                                    }
                                    return new _picker2.default(select);
                                }
                            });
                            var update = function update() {
                                _this2.pickers.forEach(function (picker) {
                                    picker.update();
                                });
                            };
                            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
                        }
                    }]);
                return BaseTheme;
            }(_theme2.default);
            BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            formula: function formula() {
                                this.quill.theme.tooltip.edit('formula');
                            },
                            image: function image() {
                                var _this3 = this;
                                var fileInput = this.container.querySelector('input.ql-image[type=file]');
                                if (fileInput == null) {
                                    fileInput = document.createElement('input');
                                    fileInput.setAttribute('type', 'file');
                                    fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
                                    fileInput.classList.add('ql-image');
                                    fileInput.addEventListener('change', function () {
                                        if (fileInput.files != null && fileInput.files[0] != null) {
                                            var reader = new FileReader();
                                            reader.onload = function (e) {
                                                var range = _this3.quill.getSelection(true);
                                                _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                                                _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                                                fileInput.value = "";
                                            };
                                            reader.readAsDataURL(fileInput.files[0]);
                                        }
                                    });
                                    this.container.appendChild(fileInput);
                                }
                                fileInput.click();
                            },
                            video: function video() {
                                this.quill.theme.tooltip.edit('video');
                            }
                        }
                    }
                }
            });
            var BaseTooltip = function (_Tooltip) {
                _inherits(BaseTooltip, _Tooltip);
                function BaseTooltip(quill, boundsContainer) {
                    _classCallCheck(this, BaseTooltip);
                    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
                    _this4.textbox = _this4.root.querySelector('input[type="text"]');
                    _this4.listen();
                    return _this4;
                }
                _createClass(BaseTooltip, [{
                        key: 'listen',
                        value: function listen() {
                            var _this5 = this;
                            this.textbox.addEventListener('keydown', function (event) {
                                if (_keyboard2.default.match(event, 'enter')) {
                                    _this5.save();
                                    event.preventDefault();
                                }
                                else if (_keyboard2.default.match(event, 'escape')) {
                                    _this5.cancel();
                                    event.preventDefault();
                                }
                            });
                        }
                    }, {
                        key: 'cancel',
                        value: function cancel() {
                            this.hide();
                        }
                    }, {
                        key: 'edit',
                        value: function edit() {
                            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
                            var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                            this.root.classList.remove('ql-hidden');
                            this.root.classList.add('ql-editing');
                            if (preview != null) {
                                this.textbox.value = preview;
                            }
                            else if (mode !== this.root.getAttribute('data-mode')) {
                                this.textbox.value = '';
                            }
                            this.position(this.quill.getBounds(this.quill.selection.savedRange));
                            this.textbox.select();
                            this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
                            this.root.setAttribute('data-mode', mode);
                        }
                    }, {
                        key: 'restoreFocus',
                        value: function restoreFocus() {
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.quill.focus();
                            this.quill.scrollingContainer.scrollTop = scrollTop;
                        }
                    }, {
                        key: 'save',
                        value: function save() {
                            var value = this.textbox.value;
                            switch (this.root.getAttribute('data-mode')) {
                                case 'link':
                                    {
                                        var scrollTop = this.quill.root.scrollTop;
                                        if (this.linkRange) {
                                            this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
                                            delete this.linkRange;
                                        }
                                        else {
                                            this.restoreFocus();
                                            this.quill.format('link', value, _emitter2.default.sources.USER);
                                        }
                                        this.quill.root.scrollTop = scrollTop;
                                        break;
                                    }
                                case 'video':
                                    {
                                        value = extractVideoUrl(value);
                                    } // eslint-disable-next-line no-fallthrough
                                case 'formula':
                                    {
                                        if (!value)
                                            break;
                                        var range = this.quill.getSelection(true);
                                        if (range != null) {
                                            var index = range.index + range.length;
                                            this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
                                            if (this.root.getAttribute('data-mode') === 'formula') {
                                                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
                                            }
                                            this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                                        }
                                        break;
                                    }
                                default:
                            }
                            this.textbox.value = '';
                            this.hide();
                        }
                    }]);
                return BaseTooltip;
            }(_tooltip2.default);
            function extractVideoUrl(url) {
                var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
                if (match) {
                    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
                }
                if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
                    // eslint-disable-line no-cond-assign
                    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
                }
                return url;
            }
            function fillSelect(select, values) {
                var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                values.forEach(function (value) {
                    var option = document.createElement('option');
                    if (value === defaultValue) {
                        option.setAttribute('selected', 'selected');
                    }
                    else {
                        option.setAttribute('value', value);
                    }
                    select.appendChild(option);
                });
            }
            exports.BaseTooltip = BaseTooltip;
            exports.default = BaseTheme;
            /***/ 
        }),
        /* 44 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", { value: true });
            var LinkedList = /*@__PURE__*/ (function () {
                function LinkedList() {
                    this.head = this.tail = undefined;
                    this.length = 0;
                }
                LinkedList.prototype.append = function () {
                    var nodes = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        nodes[_i] = arguments[_i];
                    }
                    this.insertBefore(nodes[0], undefined);
                    if (nodes.length > 1) {
                        this.append.apply(this, nodes.slice(1));
                    }
                };
                LinkedList.prototype.contains = function (node) {
                    var cur, next = this.iterator();
                    while ((cur = next())) {
                        if (cur === node)
                            return true;
                    }
                    return false;
                };
                LinkedList.prototype.insertBefore = function (node, refNode) {
                    node.next = refNode;
                    if (refNode != null) {
                        node.prev = refNode.prev;
                        if (refNode.prev != null) {
                            refNode.prev.next = node;
                        }
                        refNode.prev = node;
                        if (refNode === this.head) {
                            this.head = node;
                        }
                    }
                    else if (this.tail != null) {
                        this.tail.next = node;
                        node.prev = this.tail;
                        this.tail = node;
                    }
                    else {
                        node.prev = undefined;
                        this.head = this.tail = node;
                    }
                    this.length += 1;
                };
                LinkedList.prototype.offset = function (target) {
                    var index = 0, cur = this.head;
                    while (cur != null) {
                        if (cur === target)
                            return index;
                        index += cur.length();
                        cur = cur.next;
                    }
                    return -1;
                };
                LinkedList.prototype.remove = function (node) {
                    if (!this.contains(node))
                        return;
                    if (node.prev != null)
                        node.prev.next = node.next;
                    if (node.next != null)
                        node.next.prev = node.prev;
                    if (node === this.head)
                        this.head = node.next;
                    if (node === this.tail)
                        this.tail = node.prev;
                    this.length -= 1;
                };
                LinkedList.prototype.iterator = function (curNode) {
                    if (curNode === void 0) {
                        curNode = this.head;
                    }
                    // TODO use yield when we can
                    return function () {
                        var ret = curNode;
                        if (curNode != null)
                            curNode = curNode.next;
                        return ret;
                    };
                };
                LinkedList.prototype.find = function (index, inclusive) {
                    if (inclusive === void 0) {
                        inclusive = false;
                    }
                    var cur, next = this.iterator();
                    while ((cur = next())) {
                        var length = cur.length();
                        if (index < length ||
                            (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                            return [cur, index];
                        }
                        index -= length;
                    }
                    return [null, 0];
                };
                LinkedList.prototype.forEach = function (callback) {
                    var cur, next = this.iterator();
                    while ((cur = next())) {
                        callback(cur);
                    }
                };
                LinkedList.prototype.forEachAt = function (index, length, callback) {
                    if (length <= 0)
                        return;
                    var _a = this.find(index), startNode = _a[0], offset = _a[1];
                    var cur, curIndex = index - offset, next = this.iterator(startNode);
                    while ((cur = next()) && curIndex < index + length) {
                        var curLength = cur.length();
                        if (index > curIndex) {
                            callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
                        }
                        else {
                            callback(cur, 0, Math.min(curLength, index + length - curIndex));
                        }
                        curIndex += curLength;
                    }
                };
                LinkedList.prototype.map = function (callback) {
                    return this.reduce(function (memo, cur) {
                        memo.push(callback(cur));
                        return memo;
                    }, []);
                };
                LinkedList.prototype.reduce = function (callback, memo) {
                    var cur, next = this.iterator();
                    while ((cur = next())) {
                        memo = callback(memo, cur);
                    }
                    return memo;
                };
                return LinkedList;
            }());
            exports.default = LinkedList;
            /***/ 
        }),
        /* 45 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var container_1 = __webpack_require__(17);
            var Registry = __webpack_require__(1);
            var OBSERVER_CONFIG = {
                attributes: true,
                characterData: true,
                characterDataOldValue: true,
                childList: true,
                subtree: true,
            };
            var MAX_OPTIMIZE_ITERATIONS = 100;
            var ScrollBlot = /*@__PURE__*/ (function (_super) {
                __extends(ScrollBlot, _super);
                function ScrollBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.parent = null;
                    _this.observer = new MutationObserver(function (mutations) {
                        _this.update(mutations);
                    });
                    _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
                    _this.scroll = _this;
                    return _this;
                }
                ScrollBlot.prototype.detach = function () {
                    _super.prototype.detach.call(this);
                    this.observer.disconnect();
                };
                ScrollBlot.prototype.deleteAt = function (index, length) {
                    this.update();
                    if (index === 0 && length === this.length()) {
                        this.children.forEach(function (child) {
                            child.remove();
                        });
                    }
                    else {
                        _super.prototype.deleteAt.call(this, index, length);
                    }
                };
                ScrollBlot.prototype.formatAt = function (index, length, name, value) {
                    this.update();
                    _super.prototype.formatAt.call(this, index, length, name, value);
                };
                ScrollBlot.prototype.insertAt = function (index, value, def) {
                    this.update();
                    _super.prototype.insertAt.call(this, index, value, def);
                };
                ScrollBlot.prototype.optimize = function (mutations, context) {
                    var _this = this;
                    if (mutations === void 0) {
                        mutations = [];
                    }
                    if (context === void 0) {
                        context = {};
                    }
                    _super.prototype.optimize.call(this, context);
                    // We must modify mutations directly, cannot make copy and then modify
                    var records = [].slice.call(this.observer.takeRecords());
                    // Array.push currently seems to be implemented by a non-tail recursive function
                    // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
                    while (records.length > 0)
                        mutations.push(records.pop());
                    // TODO use WeakMap
                    var mark = function (blot, markParent) {
                        if (markParent === void 0) {
                            markParent = true;
                        }
                        if (blot == null || blot === _this)
                            return;
                        if (blot.domNode.parentNode == null)
                            return;
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                            blot.domNode[Registry.DATA_KEY].mutations = [];
                        }
                        if (markParent)
                            mark(blot.parent);
                    };
                    var optimize = function (blot) {
                        // Post-order traversal
                        if (blot.domNode[Registry.DATA_KEY] == null ||
                            blot.domNode[Registry.DATA_KEY].mutations == null) {
                            return;
                        }
                        if (blot instanceof container_1.default) {
                            blot.children.forEach(optimize);
                        }
                        blot.optimize(context);
                    };
                    var remaining = mutations;
                    for (var i = 0; remaining.length > 0; i += 1) {
                        if (i >= MAX_OPTIMIZE_ITERATIONS) {
                            throw new Error('[Parchment] Maximum optimize iterations reached');
                        }
                        remaining.forEach(function (mutation) {
                            var blot = Registry.find(mutation.target, true);
                            if (blot == null)
                                return;
                            if (blot.domNode === mutation.target) {
                                if (mutation.type === 'childList') {
                                    mark(Registry.find(mutation.previousSibling, false));
                                    [].forEach.call(mutation.addedNodes, function (node) {
                                        var child = Registry.find(node, false);
                                        mark(child, false);
                                        if (child instanceof container_1.default) {
                                            child.children.forEach(function (grandChild) {
                                                mark(grandChild, false);
                                            });
                                        }
                                    });
                                }
                                else if (mutation.type === 'attributes') {
                                    mark(blot.prev);
                                }
                            }
                            mark(blot);
                        });
                        this.children.forEach(optimize);
                        remaining = [].slice.call(this.observer.takeRecords());
                        records = remaining.slice();
                        while (records.length > 0)
                            mutations.push(records.pop());
                    }
                };
                ScrollBlot.prototype.update = function (mutations, context) {
                    var _this = this;
                    if (context === void 0) {
                        context = {};
                    }
                    mutations = mutations || this.observer.takeRecords();
                    // TODO use WeakMap
                    mutations
                        .map(function (mutation) {
                        var blot = Registry.find(mutation.target, true);
                        if (blot == null)
                            return;
                        if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                            blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                            return blot;
                        }
                        else {
                            blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                            return null;
                        }
                    })
                        .forEach(function (blot) {
                        if (blot == null || blot === _this || blot.domNode[Registry.DATA_KEY] == null)
                            return;
                        blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
                    });
                    if (this.domNode[Registry.DATA_KEY].mutations != null) {
                        _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
                    }
                    this.optimize(mutations, context);
                };
                ScrollBlot.blotName = 'scroll';
                ScrollBlot.defaultChild = 'block';
                ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
                ScrollBlot.tagName = 'DIV';
                return ScrollBlot;
            }(container_1.default));
            exports.default = ScrollBlot;
            /***/ 
        }),
        /* 46 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            // Shallow object comparison
            function isEqual(obj1, obj2) {
                if (Object.keys(obj1).length !== Object.keys(obj2).length)
                    return false;
                for (var prop in obj1) {
                    if (obj1[prop] !== obj2[prop])
                        return false;
                }
                return true;
            }
            var InlineBlot = /*@__PURE__*/ (function (_super) {
                __extends(InlineBlot, _super);
                function InlineBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InlineBlot.formats = function (domNode) {
                    if (domNode.tagName === InlineBlot.tagName)
                        return undefined;
                    return _super.formats.call(this, domNode);
                };
                InlineBlot.prototype.format = function (name, value) {
                    var _this = this;
                    if (name === this.statics.blotName && !value) {
                        this.children.forEach(function (child) {
                            if (!(child instanceof format_1.default)) {
                                child = child.wrap(InlineBlot.blotName, true);
                            }
                            _this.attributes.copy(child);
                        });
                        this.unwrap();
                    }
                    else {
                        _super.prototype.format.call(this, name, value);
                    }
                };
                InlineBlot.prototype.formatAt = function (index, length, name, value) {
                    if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
                        var blot = this.isolate(index, length);
                        blot.format(name, value);
                    }
                    else {
                        _super.prototype.formatAt.call(this, index, length, name, value);
                    }
                };
                InlineBlot.prototype.optimize = function (context) {
                    _super.prototype.optimize.call(this, context);
                    var formats = this.formats();
                    if (Object.keys(formats).length === 0) {
                        return this.unwrap(); // unformatted span
                    }
                    var next = this.next;
                    if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
                        next.moveChildren(this);
                        next.remove();
                    }
                };
                InlineBlot.blotName = 'inline';
                InlineBlot.scope = Registry.Scope.INLINE_BLOT;
                InlineBlot.tagName = 'SPAN';
                return InlineBlot;
            }(format_1.default));
            exports.default = InlineBlot;
            /***/ 
        }),
        /* 47 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var format_1 = __webpack_require__(18);
            var Registry = __webpack_require__(1);
            var BlockBlot = /*@__PURE__*/ (function (_super) {
                __extends(BlockBlot, _super);
                function BlockBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                BlockBlot.formats = function (domNode) {
                    var tagName = Registry.query(BlockBlot.blotName).tagName;
                    if (domNode.tagName === tagName)
                        return undefined;
                    return _super.formats.call(this, domNode);
                };
                BlockBlot.prototype.format = function (name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) == null) {
                        return;
                    }
                    else if (name === this.statics.blotName && !value) {
                        this.replaceWith(BlockBlot.blotName);
                    }
                    else {
                        _super.prototype.format.call(this, name, value);
                    }
                };
                BlockBlot.prototype.formatAt = function (index, length, name, value) {
                    if (Registry.query(name, Registry.Scope.BLOCK) != null) {
                        this.format(name, value);
                    }
                    else {
                        _super.prototype.formatAt.call(this, index, length, name, value);
                    }
                };
                BlockBlot.prototype.insertAt = function (index, value, def) {
                    if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
                        // Insert text or inline
                        _super.prototype.insertAt.call(this, index, value, def);
                    }
                    else {
                        var after = this.split(index);
                        var blot = Registry.create(value, def);
                        after.parent.insertBefore(blot, after);
                    }
                };
                BlockBlot.prototype.update = function (mutations, context) {
                    if (navigator.userAgent.match(/Trident/)) {
                        this.attach();
                    }
                    else {
                        _super.prototype.update.call(this, mutations, context);
                    }
                };
                BlockBlot.blotName = 'block';
                BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
                BlockBlot.tagName = 'P';
                return BlockBlot;
            }(format_1.default));
            exports.default = BlockBlot;
            /***/ 
        }),
        /* 48 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var leaf_1 = __webpack_require__(19);
            var EmbedBlot = /*@__PURE__*/ (function (_super) {
                __extends(EmbedBlot, _super);
                function EmbedBlot() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                EmbedBlot.formats = function (domNode) {
                    return undefined;
                };
                EmbedBlot.prototype.format = function (name, value) {
                    // super.formatAt wraps, which is what we want in general,
                    // but this allows subclasses to overwrite for formats
                    // that just apply to particular embeds
                    _super.prototype.formatAt.call(this, 0, this.length(), name, value);
                };
                EmbedBlot.prototype.formatAt = function (index, length, name, value) {
                    if (index === 0 && length === this.length()) {
                        this.format(name, value);
                    }
                    else {
                        _super.prototype.formatAt.call(this, index, length, name, value);
                    }
                };
                EmbedBlot.prototype.formats = function () {
                    return this.statics.formats(this.domNode);
                };
                return EmbedBlot;
            }(leaf_1.default));
            exports.default = EmbedBlot;
            /***/ 
        }),
        /* 49 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = Object.setPrototypeOf ||
                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                    function (d, b) { for (var p in b)
                        if (b.hasOwnProperty(p))
                            d[p] = b[p]; };
                return function (d, b) {
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();
            Object.defineProperty(exports, "__esModule", { value: true });
            var leaf_1 = __webpack_require__(19);
            var Registry = __webpack_require__(1);
            var TextBlot = /*@__PURE__*/ (function (_super) {
                __extends(TextBlot, _super);
                function TextBlot(node) {
                    var _this = _super.call(this, node) || this;
                    _this.text = _this.statics.value(_this.domNode);
                    return _this;
                }
                TextBlot.create = function (value) {
                    return document.createTextNode(value);
                };
                TextBlot.value = function (domNode) {
                    var text = domNode.data;
                    if (text['normalize'])
                        text = text['normalize']();
                    return text;
                };
                TextBlot.prototype.deleteAt = function (index, length) {
                    this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
                };
                TextBlot.prototype.index = function (node, offset) {
                    if (this.domNode === node) {
                        return offset;
                    }
                    return -1;
                };
                TextBlot.prototype.insertAt = function (index, value, def) {
                    if (def == null) {
                        this.text = this.text.slice(0, index) + value + this.text.slice(index);
                        this.domNode.data = this.text;
                    }
                    else {
                        _super.prototype.insertAt.call(this, index, value, def);
                    }
                };
                TextBlot.prototype.length = function () {
                    return this.text.length;
                };
                TextBlot.prototype.optimize = function (context) {
                    _super.prototype.optimize.call(this, context);
                    this.text = this.statics.value(this.domNode);
                    if (this.text.length === 0) {
                        this.remove();
                    }
                    else if (this.next instanceof TextBlot && this.next.prev === this) {
                        this.insertAt(this.length(), this.next.value());
                        this.next.remove();
                    }
                };
                TextBlot.prototype.position = function (index, inclusive) {
                    if (inclusive === void 0) {
                        inclusive = false;
                    }
                    return [this.domNode, index];
                };
                TextBlot.prototype.split = function (index, force) {
                    if (force === void 0) {
                        force = false;
                    }
                    if (!force) {
                        if (index === 0)
                            return this;
                        if (index === this.length())
                            return this.next;
                    }
                    var after = Registry.create(this.domNode.splitText(index));
                    this.parent.insertBefore(after, this.next);
                    this.text = this.statics.value(this.domNode);
                    return after;
                };
                TextBlot.prototype.update = function (mutations, context) {
                    var _this = this;
                    if (mutations.some(function (mutation) {
                        return mutation.type === 'characterData' && mutation.target === _this.domNode;
                    })) {
                        this.text = this.statics.value(this.domNode);
                    }
                };
                TextBlot.prototype.value = function () {
                    return this.text;
                };
                TextBlot.blotName = 'text';
                TextBlot.scope = Registry.Scope.INLINE_BLOT;
                return TextBlot;
            }(leaf_1.default));
            exports.default = TextBlot;
            /***/ 
        }),
        /* 50 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            var elem = document.createElement('div');
            elem.classList.toggle('test-class', false);
            if (elem.classList.contains('test-class')) {
                var _toggle = DOMTokenList.prototype.toggle;
                DOMTokenList.prototype.toggle = function (token, force) {
                    if (arguments.length > 1 && !this.contains(token) === !force) {
                        return force;
                    }
                    else {
                        return _toggle.call(this, token);
                    }
                };
            }
            if (!String.prototype.startsWith) {
                String.prototype.startsWith = function (searchString, position) {
                    position = position || 0;
                    return this.substr(position, searchString.length) === searchString;
                };
            }
            if (!String.prototype.endsWith) {
                String.prototype.endsWith = function (searchString, position) {
                    var subjectString = this.toString();
                    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
                        position = subjectString.length;
                    }
                    position -= searchString.length;
                    var lastIndex = subjectString.indexOf(searchString, position);
                    return lastIndex !== -1 && lastIndex === position;
                };
            }
            if (!Array.prototype.find) {
                Object.defineProperty(Array.prototype, "find", {
                    value: function value(predicate) {
                        if (this === null) {
                            throw new TypeError('Array.prototype.find called on null or undefined');
                        }
                        if (typeof predicate !== 'function') {
                            throw new TypeError('predicate must be a function');
                        }
                        var list = Object(this);
                        var length = list.length >>> 0;
                        var thisArg = arguments[1];
                        var value;
                        for (var i = 0; i < length; i++) {
                            value = list[i];
                            if (predicate.call(thisArg, value, i, list)) {
                                return value;
                            }
                        }
                        return undefined;
                    }
                });
            }
            document.addEventListener("DOMContentLoaded", function () {
                // Disable resizing in Firefox
                document.execCommand("enableObjectResizing", false, false);
                // Disable automatic linkifying in IE11
                document.execCommand("autoUrlDetect", false, false);
            });
            /***/ 
        }),
        /* 51 */
        /***/ (function (module, exports) {
            /**
             * This library modifies the diff-patch-match library by Neil Fraser
             * by removing the patch and match functionality and certain advanced
             * options in the diff function. The original license is as follows:
             *
             * ===
             *
             * Diff Match and Patch
             *
             * Copyright 2006 Google Inc.
             * http://code.google.com/p/google-diff-match-patch/
             *
             * Licensed under the Apache License, Version 2.0 (the "License");
             * you may not use this file except in compliance with the License.
             * You may obtain a copy of the License at
             *
             *   http://www.apache.org/licenses/LICENSE-2.0
             *
             * Unless required by applicable law or agreed to in writing, software
             * distributed under the License is distributed on an "AS IS" BASIS,
             * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
             * See the License for the specific language governing permissions and
             * limitations under the License.
             */
            /**
             * The data structure representing a diff is an array of tuples:
             * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
             * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
             */
            var DIFF_DELETE = -1;
            var DIFF_INSERT = 1;
            var DIFF_EQUAL = 0;
            /**
             * Find the differences between two texts.  Simplifies the problem by stripping
             * any common prefix or suffix off the texts before diffing.
             * @param {string} text1 Old string to be diffed.
             * @param {string} text2 New string to be diffed.
             * @param {Int} cursor_pos Expected edit position in text1 (optional)
             * @return {Array} Array of diff tuples.
             */
            function diff_main(text1, text2, cursor_pos) {
                // Check for equality (speedup).
                if (text1 == text2) {
                    if (text1) {
                        return [[DIFF_EQUAL, text1]];
                    }
                    return [];
                }
                // Check cursor_pos within bounds
                if (cursor_pos < 0 || text1.length < cursor_pos) {
                    cursor_pos = null;
                }
                // Trim off common prefix (speedup).
                var commonlength = diff_commonPrefix(text1, text2);
                var commonprefix = text1.substring(0, commonlength);
                text1 = text1.substring(commonlength);
                text2 = text2.substring(commonlength);
                // Trim off common suffix (speedup).
                commonlength = diff_commonSuffix(text1, text2);
                var commonsuffix = text1.substring(text1.length - commonlength);
                text1 = text1.substring(0, text1.length - commonlength);
                text2 = text2.substring(0, text2.length - commonlength);
                // Compute the diff on the middle block.
                var diffs = diff_compute_(text1, text2);
                // Restore the prefix and suffix.
                if (commonprefix) {
                    diffs.unshift([DIFF_EQUAL, commonprefix]);
                }
                if (commonsuffix) {
                    diffs.push([DIFF_EQUAL, commonsuffix]);
                }
                diff_cleanupMerge(diffs);
                if (cursor_pos != null) {
                    diffs = fix_cursor(diffs, cursor_pos);
                }
                diffs = fix_emoji(diffs);
                return diffs;
            }
            ;
            /**
             * Find the differences between two texts.  Assumes that the texts do not
             * have any common prefix or suffix.
             * @param {string} text1 Old string to be diffed.
             * @param {string} text2 New string to be diffed.
             * @return {Array} Array of diff tuples.
             */
            function diff_compute_(text1, text2) {
                var diffs;
                if (!text1) {
                    // Just add some text (speedup).
                    return [[DIFF_INSERT, text2]];
                }
                if (!text2) {
                    // Just delete some text (speedup).
                    return [[DIFF_DELETE, text1]];
                }
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                var i = longtext.indexOf(shorttext);
                if (i != -1) {
                    // Shorter text is inside the longer text (speedup).
                    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
                        [DIFF_EQUAL, shorttext],
                        [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
                    // Swap insertions for deletions if diff is reversed.
                    if (text1.length > text2.length) {
                        diffs[0][0] = diffs[2][0] = DIFF_DELETE;
                    }
                    return diffs;
                }
                if (shorttext.length == 1) {
                    // Single character string.
                    // After the previous speedup, the character can't be an equality.
                    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
                }
                // Check to see if the problem can be split in two.
                var hm = diff_halfMatch_(text1, text2);
                if (hm) {
                    // A half-match was found, sort out the return data.
                    var text1_a = hm[0];
                    var text1_b = hm[1];
                    var text2_a = hm[2];
                    var text2_b = hm[3];
                    var mid_common = hm[4];
                    // Send both pairs off for separate processing.
                    var diffs_a = diff_main(text1_a, text2_a);
                    var diffs_b = diff_main(text1_b, text2_b);
                    // Merge the results.
                    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
                }
                return diff_bisect_(text1, text2);
            }
            ;
            /**
             * Find the 'middle snake' of a diff, split the problem in two
             * and return the recursively constructed diff.
             * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
             * @param {string} text1 Old string to be diffed.
             * @param {string} text2 New string to be diffed.
             * @return {Array} Array of diff tuples.
             * @private
             */
            function diff_bisect_(text1, text2) {
                // Cache the text lengths to prevent multiple calls.
                var text1_length = text1.length;
                var text2_length = text2.length;
                var max_d = Math.ceil((text1_length + text2_length) / 2);
                var v_offset = max_d;
                var v_length = 2 * max_d;
                var v1 = new Array(v_length);
                var v2 = new Array(v_length);
                // Setting all elements to -1 is faster in Chrome & Firefox than mixing
                // integers and undefined.
                for (var x = 0; x < v_length; x++) {
                    v1[x] = -1;
                    v2[x] = -1;
                }
                v1[v_offset + 1] = 0;
                v2[v_offset + 1] = 0;
                var delta = text1_length - text2_length;
                // If the total number of characters is odd, then the front path will collide
                // with the reverse path.
                var front = (delta % 2 != 0);
                // Offsets for start and end of k loop.
                // Prevents mapping of space beyond the grid.
                var k1start = 0;
                var k1end = 0;
                var k2start = 0;
                var k2end = 0;
                for (var d = 0; d < max_d; d++) {
                    // Walk the front path one step.
                    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
                        var k1_offset = v_offset + k1;
                        var x1;
                        if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
                            x1 = v1[k1_offset + 1];
                        }
                        else {
                            x1 = v1[k1_offset - 1] + 1;
                        }
                        var y1 = x1 - k1;
                        while (x1 < text1_length && y1 < text2_length &&
                            text1.charAt(x1) == text2.charAt(y1)) {
                            x1++;
                            y1++;
                        }
                        v1[k1_offset] = x1;
                        if (x1 > text1_length) {
                            // Ran off the right of the graph.
                            k1end += 2;
                        }
                        else if (y1 > text2_length) {
                            // Ran off the bottom of the graph.
                            k1start += 2;
                        }
                        else if (front) {
                            var k2_offset = v_offset + delta - k1;
                            if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                                // Mirror x2 onto top-left coordinate system.
                                var x2 = text1_length - v2[k2_offset];
                                if (x1 >= x2) {
                                    // Overlap detected.
                                    return diff_bisectSplit_(text1, text2, x1, y1);
                                }
                            }
                        }
                    }
                    // Walk the reverse path one step.
                    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
                        var k2_offset = v_offset + k2;
                        var x2;
                        if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
                            x2 = v2[k2_offset + 1];
                        }
                        else {
                            x2 = v2[k2_offset - 1] + 1;
                        }
                        var y2 = x2 - k2;
                        while (x2 < text1_length && y2 < text2_length &&
                            text1.charAt(text1_length - x2 - 1) ==
                                text2.charAt(text2_length - y2 - 1)) {
                            x2++;
                            y2++;
                        }
                        v2[k2_offset] = x2;
                        if (x2 > text1_length) {
                            // Ran off the left of the graph.
                            k2end += 2;
                        }
                        else if (y2 > text2_length) {
                            // Ran off the top of the graph.
                            k2start += 2;
                        }
                        else if (!front) {
                            var k1_offset = v_offset + delta - k2;
                            if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                                var x1 = v1[k1_offset];
                                var y1 = v_offset + x1 - k1_offset;
                                // Mirror x2 onto top-left coordinate system.
                                x2 = text1_length - x2;
                                if (x1 >= x2) {
                                    // Overlap detected.
                                    return diff_bisectSplit_(text1, text2, x1, y1);
                                }
                            }
                        }
                    }
                }
                // Diff took too long and hit the deadline or
                // number of diffs equals number of characters, no commonality at all.
                return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
            }
            ;
            /**
             * Given the location of the 'middle snake', split the diff in two parts
             * and recurse.
             * @param {string} text1 Old string to be diffed.
             * @param {string} text2 New string to be diffed.
             * @param {number} x Index of split point in text1.
             * @param {number} y Index of split point in text2.
             * @return {Array} Array of diff tuples.
             */
            function diff_bisectSplit_(text1, text2, x, y) {
                var text1a = text1.substring(0, x);
                var text2a = text2.substring(0, y);
                var text1b = text1.substring(x);
                var text2b = text2.substring(y);
                // Compute both diffs serially.
                var diffs = diff_main(text1a, text2a);
                var diffsb = diff_main(text1b, text2b);
                return diffs.concat(diffsb);
            }
            ;
            /**
             * Determine the common prefix of two strings.
             * @param {string} text1 First string.
             * @param {string} text2 Second string.
             * @return {number} The number of characters common to the start of each
             *     string.
             */
            function diff_commonPrefix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
                    return 0;
                }
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerstart = 0;
                while (pointermin < pointermid) {
                    if (text1.substring(pointerstart, pointermid) ==
                        text2.substring(pointerstart, pointermid)) {
                        pointermin = pointermid;
                        pointerstart = pointermin;
                    }
                    else {
                        pointermax = pointermid;
                    }
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            ;
            /**
             * Determine the common suffix of two strings.
             * @param {string} text1 First string.
             * @param {string} text2 Second string.
             * @return {number} The number of characters common to the end of each string.
             */
            function diff_commonSuffix(text1, text2) {
                // Quick check for common null cases.
                if (!text1 || !text2 ||
                    text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
                    return 0;
                }
                // Binary search.
                // Performance analysis: http://neil.fraser.name/news/2007/10/09/
                var pointermin = 0;
                var pointermax = Math.min(text1.length, text2.length);
                var pointermid = pointermax;
                var pointerend = 0;
                while (pointermin < pointermid) {
                    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
                        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                        pointermin = pointermid;
                        pointerend = pointermin;
                    }
                    else {
                        pointermax = pointermid;
                    }
                    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
                }
                return pointermid;
            }
            ;
            /**
             * Do the two texts share a substring which is at least half the length of the
             * longer text?
             * This speedup can produce non-minimal diffs.
             * @param {string} text1 First string.
             * @param {string} text2 Second string.
             * @return {Array.<string>} Five element Array, containing the prefix of
             *     text1, the suffix of text1, the prefix of text2, the suffix of
             *     text2 and the common middle.  Or null if there was no match.
             */
            function diff_halfMatch_(text1, text2) {
                var longtext = text1.length > text2.length ? text1 : text2;
                var shorttext = text1.length > text2.length ? text2 : text1;
                if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
                    return null; // Pointless.
                }
                /**
                 * Does a substring of shorttext exist within longtext such that the substring
                 * is at least half the length of longtext?
                 * Closure, but does not reference any external variables.
                 * @param {string} longtext Longer string.
                 * @param {string} shorttext Shorter string.
                 * @param {number} i Start index of quarter length substring within longtext.
                 * @return {Array.<string>} Five element Array, containing the prefix of
                 *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
                 *     of shorttext and the common middle.  Or null if there was no match.
                 * @private
                 */
                function diff_halfMatchI_(longtext, shorttext, i) {
                    // Start with a 1/4 length substring at position i as a seed.
                    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
                    var j = -1;
                    var best_common = '';
                    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
                    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
                        var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
                        var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
                        if (best_common.length < suffixLength + prefixLength) {
                            best_common = shorttext.substring(j - suffixLength, j) +
                                shorttext.substring(j, j + prefixLength);
                            best_longtext_a = longtext.substring(0, i - suffixLength);
                            best_longtext_b = longtext.substring(i + prefixLength);
                            best_shorttext_a = shorttext.substring(0, j - suffixLength);
                            best_shorttext_b = shorttext.substring(j + prefixLength);
                        }
                    }
                    if (best_common.length * 2 >= longtext.length) {
                        return [best_longtext_a, best_longtext_b,
                            best_shorttext_a, best_shorttext_b, best_common];
                    }
                    else {
                        return null;
                    }
                }
                // First check if the second quarter is the seed for a half-match.
                var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
                // Check again based on the third quarter.
                var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
                var hm;
                if (!hm1 && !hm2) {
                    return null;
                }
                else if (!hm2) {
                    hm = hm1;
                }
                else if (!hm1) {
                    hm = hm2;
                }
                else {
                    // Both matched.  Select the longest.
                    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
                }
                // A half-match was found, sort out the return data.
                var text1_a, text1_b, text2_a, text2_b;
                if (text1.length > text2.length) {
                    text1_a = hm[0];
                    text1_b = hm[1];
                    text2_a = hm[2];
                    text2_b = hm[3];
                }
                else {
                    text2_a = hm[0];
                    text2_b = hm[1];
                    text1_a = hm[2];
                    text1_b = hm[3];
                }
                var mid_common = hm[4];
                return [text1_a, text1_b, text2_a, text2_b, mid_common];
            }
            ;
            /**
             * Reorder and merge like edit sections.  Merge equalities.
             * Any edit section can move as long as it doesn't cross an equality.
             * @param {Array} diffs Array of diff tuples.
             */
            function diff_cleanupMerge(diffs) {
                diffs.push([DIFF_EQUAL, '']); // Add a dummy entry at the end.
                var pointer = 0;
                var count_delete = 0;
                var count_insert = 0;
                var text_delete = '';
                var text_insert = '';
                var commonlength;
                while (pointer < diffs.length) {
                    switch (diffs[pointer][0]) {
                        case DIFF_INSERT:
                            count_insert++;
                            text_insert += diffs[pointer][1];
                            pointer++;
                            break;
                        case DIFF_DELETE:
                            count_delete++;
                            text_delete += diffs[pointer][1];
                            pointer++;
                            break;
                        case DIFF_EQUAL:
                            // Upon reaching an equality, check for prior redundancies.
                            if (count_delete + count_insert > 1) {
                                if (count_delete !== 0 && count_insert !== 0) {
                                    // Factor out any common prefixies.
                                    commonlength = diff_commonPrefix(text_insert, text_delete);
                                    if (commonlength !== 0) {
                                        if ((pointer - count_delete - count_insert) > 0 &&
                                            diffs[pointer - count_delete - count_insert - 1][0] ==
                                                DIFF_EQUAL) {
                                            diffs[pointer - count_delete - count_insert - 1][1] +=
                                                text_insert.substring(0, commonlength);
                                        }
                                        else {
                                            diffs.splice(0, 0, [DIFF_EQUAL,
                                                text_insert.substring(0, commonlength)]);
                                            pointer++;
                                        }
                                        text_insert = text_insert.substring(commonlength);
                                        text_delete = text_delete.substring(commonlength);
                                    }
                                    // Factor out any common suffixies.
                                    commonlength = diff_commonSuffix(text_insert, text_delete);
                                    if (commonlength !== 0) {
                                        diffs[pointer][1] = text_insert.substring(text_insert.length -
                                            commonlength) + diffs[pointer][1];
                                        text_insert = text_insert.substring(0, text_insert.length -
                                            commonlength);
                                        text_delete = text_delete.substring(0, text_delete.length -
                                            commonlength);
                                    }
                                }
                                // Delete the offending records and add the merged ones.
                                if (count_delete === 0) {
                                    diffs.splice(pointer - count_insert, count_delete + count_insert, [DIFF_INSERT, text_insert]);
                                }
                                else if (count_insert === 0) {
                                    diffs.splice(pointer - count_delete, count_delete + count_insert, [DIFF_DELETE, text_delete]);
                                }
                                else {
                                    diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);
                                }
                                pointer = pointer - count_delete - count_insert +
                                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
                            }
                            else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                                // Merge this equality with the previous one.
                                diffs[pointer - 1][1] += diffs[pointer][1];
                                diffs.splice(pointer, 1);
                            }
                            else {
                                pointer++;
                            }
                            count_insert = 0;
                            count_delete = 0;
                            text_delete = '';
                            text_insert = '';
                            break;
                    }
                }
                if (diffs[diffs.length - 1][1] === '') {
                    diffs.pop(); // Remove the dummy entry at the end.
                }
                // Second pass: look for single edits surrounded on both sides by equalities
                // which can be shifted sideways to eliminate an equality.
                // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
                var changes = false;
                pointer = 1;
                // Intentionally ignore the first and last element (don't need checking).
                while (pointer < diffs.length - 1) {
                    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
                        diffs[pointer + 1][0] == DIFF_EQUAL) {
                        // This is a single edit surrounded by equalities.
                        if (diffs[pointer][1].substring(diffs[pointer][1].length -
                            diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                            // Shift the edit over the previous equality.
                            diffs[pointer][1] = diffs[pointer - 1][1] +
                                diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                    diffs[pointer - 1][1].length);
                            diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                            diffs.splice(pointer - 1, 1);
                            changes = true;
                        }
                        else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
                            diffs[pointer + 1][1]) {
                            // Shift the edit over the next equality.
                            diffs[pointer - 1][1] += diffs[pointer + 1][1];
                            diffs[pointer][1] =
                                diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
                                    diffs[pointer + 1][1];
                            diffs.splice(pointer + 1, 1);
                            changes = true;
                        }
                    }
                    pointer++;
                }
                // If shifts were made, the diff needs reordering and another shift sweep.
                if (changes) {
                    diff_cleanupMerge(diffs);
                }
            }
            ;
            var diff = diff_main;
            diff.INSERT = DIFF_INSERT;
            diff.DELETE = DIFF_DELETE;
            diff.EQUAL = DIFF_EQUAL;
            module.exports = diff;
            /*
             * Modify a diff such that the cursor position points to the start of a change:
             * E.g.
             *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
             *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
             *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
             *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
             *
             * @param {Array} diffs Array of diff tuples
             * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
             * @return {Array} A tuple [cursor location in the modified diff, modified diff]
             */
            function cursor_normalize_diff(diffs, cursor_pos) {
                if (cursor_pos === 0) {
                    return [DIFF_EQUAL, diffs];
                }
                for (var current_pos = 0, i = 0; i < diffs.length; i++) {
                    var d = diffs[i];
                    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
                        var next_pos = current_pos + d[1].length;
                        if (cursor_pos === next_pos) {
                            return [i + 1, diffs];
                        }
                        else if (cursor_pos < next_pos) {
                            // copy to prevent side effects
                            diffs = diffs.slice();
                            // split d into two diff changes
                            var split_pos = cursor_pos - current_pos;
                            var d_left = [d[0], d[1].slice(0, split_pos)];
                            var d_right = [d[0], d[1].slice(split_pos)];
                            diffs.splice(i, 1, d_left, d_right);
                            return [i + 1, diffs];
                        }
                        else {
                            current_pos = next_pos;
                        }
                    }
                }
                throw new Error('cursor_pos is out of bounds!');
            }
            /*
             * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
             *
             * Case 1)
             *   Check if a naive shift is possible:
             *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
             *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
             * Case 2)
             *   Check if the following shifts are possible:
             *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
             *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
             *         ^            ^
             *         d          d_next
             *
             * @param {Array} diffs Array of diff tuples
             * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
             * @return {Array} Array of diff tuples
             */
            function fix_cursor(diffs, cursor_pos) {
                var norm = cursor_normalize_diff(diffs, cursor_pos);
                var ndiffs = norm[1];
                var cursor_pointer = norm[0];
                var d = ndiffs[cursor_pointer];
                var d_next = ndiffs[cursor_pointer + 1];
                if (d == null) {
                    // Text was deleted from end of original string,
                    // cursor is now out of bounds in new string
                    return diffs;
                }
                else if (d[0] !== DIFF_EQUAL) {
                    // A modification happened at the cursor location.
                    // This is the expected outcome, so we can return the original diff.
                    return diffs;
                }
                else {
                    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
                        // Case 1)
                        // It is possible to perform a naive shift
                        ndiffs.splice(cursor_pointer, 2, d_next, d);
                        return merge_tuples(ndiffs, cursor_pointer, 2);
                    }
                    else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
                        // Case 2)
                        // d[1] is a prefix of d_next[1]
                        // We can assume that d_next[0] !== 0, since d[0] === 0
                        // Shift edit locations..
                        ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
                        var suffix = d_next[1].slice(d[1].length);
                        if (suffix.length > 0) {
                            ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
                        }
                        return merge_tuples(ndiffs, cursor_pointer, 3);
                    }
                    else {
                        // Not possible to perform any modification
                        return diffs;
                    }
                }
            }
            /*
             * Check diff did not split surrogate pairs.
             * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
             *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
             *
             * @param {Array} diffs Array of diff tuples
             * @return {Array} Array of diff tuples
             */
            function fix_emoji(diffs) {
                var compact = false;
                var starts_with_pair_end = function (str) {
                    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
                };
                var ends_with_pair_start = function (str) {
                    return str.charCodeAt(str.length - 1) >= 0xD800 && str.charCodeAt(str.length - 1) <= 0xDBFF;
                };
                for (var i = 2; i < diffs.length; i += 1) {
                    if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) &&
                        diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) &&
                        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
                        compact = true;
                        diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
                        diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
                        diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
                    }
                }
                if (!compact) {
                    return diffs;
                }
                var fixed_diffs = [];
                for (var i = 0; i < diffs.length; i += 1) {
                    if (diffs[i][1].length > 0) {
                        fixed_diffs.push(diffs[i]);
                    }
                }
                return fixed_diffs;
            }
            /*
             * Try to merge tuples with their neigbors in a given range.
             * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
             *
             * @param {Array} diffs Array of diff tuples.
             * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
             * @param {Int} length Number of consecutive elements to check.
             * @return {Array} Array of merged diff tuples.
             */
            function merge_tuples(diffs, start, length) {
                // Check from (start-1) to (start+length).
                for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
                    if (i + 1 < diffs.length) {
                        var left_d = diffs[i];
                        var right_d = diffs[i + 1];
                        if (left_d[0] === right_d[1]) {
                            diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
                        }
                    }
                }
                return diffs;
            }
            /***/ 
        }),
        /* 52 */
        /***/ (function (module, exports) {
            exports = module.exports = typeof Object.keys === 'function'
                ? Object.keys : shim;
            exports.shim = shim;
            function shim(obj) {
                var keys = [];
                for (var key in obj)
                    keys.push(key);
                return keys;
            }
            /***/ 
        }),
        /* 53 */
        /***/ (function (module, exports) {
            var supportsArgumentsClass = (function () {
                return Object.prototype.toString.call(arguments);
            })() == '[object Arguments]';
            exports = module.exports = supportsArgumentsClass ? supported : unsupported;
            exports.supported = supported;
            function supported(object) {
                return Object.prototype.toString.call(object) == '[object Arguments]';
            }
            ;
            exports.unsupported = unsupported;
            function unsupported(object) {
                return object &&
                    typeof object == 'object' &&
                    typeof object.length == 'number' &&
                    Object.prototype.hasOwnProperty.call(object, 'callee') &&
                    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
                    false;
            }
            ;
            /***/ 
        }),
        /* 54 */
        /***/ (function (module, exports) {
            'use strict';
            var has = Object.prototype.hasOwnProperty, prefix = '~';
            /**
             * Constructor to create a storage for our `EE` objects.
             * An `Events` instance is a plain object whose properties are event names.
             *
             * @constructor
             * @api private
             */
            function Events() { }
            //
            // We try to not inherit from `Object.prototype`. In some engines creating an
            // instance in this way is faster than calling `Object.create(null)` directly.
            // If `Object.create(null)` is not supported we prefix the event names with a
            // character to make sure that the built-in object properties are not
            // overridden or used as an attack vector.
            //
            if (Object.create) {
                Events.prototype = Object.create(null);
                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__)
                    prefix = false;
            }
            /**
             * Representation of a single event listener.
             *
             * @param {Function} fn The listener function.
             * @param {Mixed} context The context to invoke the listener with.
             * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
             * @constructor
             * @api private
             */
            function EE(fn, context, once) {
                this.fn = fn;
                this.context = context;
                this.once = once || false;
            }
            /**
             * Minimal `EventEmitter` interface that is molded against the Node.js
             * `EventEmitter` interface.
             *
             * @constructor
             * @api public
             */
            function EventEmitter() {
                this._events = new Events();
                this._eventsCount = 0;
            }
            /**
             * Return an array listing the events for which the emitter has registered
             * listeners.
             *
             * @returns {Array}
             * @api public
             */
            EventEmitter.prototype.eventNames = function eventNames() {
                var names = [], events, name;
                if (this._eventsCount === 0)
                    return names;
                for (name in (events = this._events)) {
                    if (has.call(events, name))
                        names.push(prefix ? name.slice(1) : name);
                }
                if (Object.getOwnPropertySymbols) {
                    return names.concat(Object.getOwnPropertySymbols(events));
                }
                return names;
            };
            /**
             * Return the listeners registered for a given event.
             *
             * @param {String|Symbol} event The event name.
             * @param {Boolean} exists Only check if there are listeners.
             * @returns {Array|Boolean}
             * @api public
             */
            EventEmitter.prototype.listeners = function listeners(event, exists) {
                var evt = prefix ? prefix + event : event, available = this._events[evt];
                if (exists)
                    return !!available;
                if (!available)
                    return [];
                if (available.fn)
                    return [available.fn];
                for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
                    ee[i] = available[i].fn;
                }
                return ee;
            };
            /**
             * Calls each of the listeners registered for a given event.
             *
             * @param {String|Symbol} event The event name.
             * @returns {Boolean} `true` if the event had listeners, else `false`.
             * @api public
             */
            EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt])
                    return false;
                var listeners = this._events[evt], len = arguments.length, args, i;
                if (listeners.fn) {
                    if (listeners.once)
                        this.removeListener(event, listeners.fn, undefined, true);
                    switch (len) {
                        case 1: return listeners.fn.call(listeners.context), true;
                        case 2: return listeners.fn.call(listeners.context, a1), true;
                        case 3: return listeners.fn.call(listeners.context, a1, a2), true;
                        case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
                        case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                        case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                    }
                    for (i = 1, args = new Array(len - 1); i < len; i++) {
                        args[i - 1] = arguments[i];
                    }
                    listeners.fn.apply(listeners.context, args);
                }
                else {
                    var length = listeners.length, j;
                    for (i = 0; i < length; i++) {
                        if (listeners[i].once)
                            this.removeListener(event, listeners[i].fn, undefined, true);
                        switch (len) {
                            case 1:
                                listeners[i].fn.call(listeners[i].context);
                                break;
                            case 2:
                                listeners[i].fn.call(listeners[i].context, a1);
                                break;
                            case 3:
                                listeners[i].fn.call(listeners[i].context, a1, a2);
                                break;
                            case 4:
                                listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                                break;
                            default:
                                if (!args)
                                    for (j = 1, args = new Array(len - 1); j < len; j++) {
                                        args[j - 1] = arguments[j];
                                    }
                                listeners[i].fn.apply(listeners[i].context, args);
                        }
                    }
                }
                return true;
            };
            /**
             * Add a listener for a given event.
             *
             * @param {String|Symbol} event The event name.
             * @param {Function} fn The listener function.
             * @param {Mixed} [context=this] The context to invoke the listener with.
             * @returns {EventEmitter} `this`.
             * @api public
             */
            EventEmitter.prototype.on = function on(event, fn, context) {
                var listener = new EE(fn, context || this), evt = prefix ? prefix + event : event;
                if (!this._events[evt])
                    this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn)
                    this._events[evt].push(listener);
                else
                    this._events[evt] = [this._events[evt], listener];
                return this;
            };
            /**
             * Add a one-time listener for a given event.
             *
             * @param {String|Symbol} event The event name.
             * @param {Function} fn The listener function.
             * @param {Mixed} [context=this] The context to invoke the listener with.
             * @returns {EventEmitter} `this`.
             * @api public
             */
            EventEmitter.prototype.once = function once(event, fn, context) {
                var listener = new EE(fn, context || this, true), evt = prefix ? prefix + event : event;
                if (!this._events[evt])
                    this._events[evt] = listener, this._eventsCount++;
                else if (!this._events[evt].fn)
                    this._events[evt].push(listener);
                else
                    this._events[evt] = [this._events[evt], listener];
                return this;
            };
            /**
             * Remove the listeners of a given event.
             *
             * @param {String|Symbol} event The event name.
             * @param {Function} fn Only remove the listeners that match this function.
             * @param {Mixed} context Only remove the listeners that have this context.
             * @param {Boolean} once Only remove one-time listeners.
             * @returns {EventEmitter} `this`.
             * @api public
             */
            EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!this._events[evt])
                    return this;
                if (!fn) {
                    if (--this._eventsCount === 0)
                        this._events = new Events();
                    else
                        delete this._events[evt];
                    return this;
                }
                var listeners = this._events[evt];
                if (listeners.fn) {
                    if (listeners.fn === fn
                        && (!once || listeners.once)
                        && (!context || listeners.context === context)) {
                        if (--this._eventsCount === 0)
                            this._events = new Events();
                        else
                            delete this._events[evt];
                    }
                }
                else {
                    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
                        if (listeners[i].fn !== fn
                            || (once && !listeners[i].once)
                            || (context && listeners[i].context !== context)) {
                            events.push(listeners[i]);
                        }
                    }
                    //
                    // Reset the array, or remove it completely if we have no more listeners.
                    //
                    if (events.length)
                        this._events[evt] = events.length === 1 ? events[0] : events;
                    else if (--this._eventsCount === 0)
                        this._events = new Events();
                    else
                        delete this._events[evt];
                }
                return this;
            };
            /**
             * Remove all listeners, or those of the specified event.
             *
             * @param {String|Symbol} [event] The event name.
             * @returns {EventEmitter} `this`.
             * @api public
             */
            EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                    evt = prefix ? prefix + event : event;
                    if (this._events[evt]) {
                        if (--this._eventsCount === 0)
                            this._events = new Events();
                        else
                            delete this._events[evt];
                    }
                }
                else {
                    this._events = new Events();
                    this._eventsCount = 0;
                }
                return this;
            };
            //
            // Alias methods names because people roll like that.
            //
            EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
            EventEmitter.prototype.addListener = EventEmitter.prototype.on;
            //
            // This function doesn't apply anymore.
            //
            EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
                return this;
            };
            //
            // Expose the prefix.
            //
            EventEmitter.prefixed = prefix;
            //
            // Allow `EventEmitter` to be imported as module namespace.
            //
            EventEmitter.EventEmitter = EventEmitter;
            //
            // Expose the module.
            //
            if ('undefined' !== typeof module) {
                module.exports = EventEmitter;
            }
            /***/ 
        }),
        /* 55 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _extend2 = __webpack_require__(3);
            var _extend3 = _interopRequireDefault(_extend2);
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _align = __webpack_require__(36);
            var _background = __webpack_require__(37);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _color = __webpack_require__(26);
            var _direction = __webpack_require__(38);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _defineProperty(obj, key, value) { if (key in obj) {
                Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
            }
            else {
                obj[key] = value;
            } return obj; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var debug = (0, _logger2.default)('quill:clipboard');
            var DOM_KEY = '__ql-matcher';
            var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];
            var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
                memo[attr.keyName] = attr;
                return memo;
            }, {});
            var Clipboard = function (_Module) {
                _inherits(Clipboard, _Module);
                function Clipboard(quill, options) {
                    _classCallCheck(this, Clipboard);
                    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
                    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
                    _this.container = _this.quill.addContainer('ql-clipboard');
                    _this.container.setAttribute('contenteditable', true);
                    _this.container.setAttribute('tabindex', -1);
                    _this.matchers = [];
                    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
                        var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], matcher = _ref2[1];
                        if (!options.matchVisual && matcher === matchSpacing)
                            return;
                        _this.addMatcher(selector, matcher);
                    });
                    return _this;
                }
                _createClass(Clipboard, [{
                        key: 'addMatcher',
                        value: function addMatcher(selector, matcher) {
                            this.matchers.push([selector, matcher]);
                        }
                    }, {
                        key: 'convert',
                        value: function convert(html) {
                            if (typeof html === 'string') {
                                this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
                                return this.convert();
                            }
                            var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
                            if (formats[_code2.default.blotName]) {
                                var text = this.container.innerText;
                                this.container.innerHTML = '';
                                return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
                            }
                            var _prepareMatching = this.prepareMatching(), _prepareMatching2 = _slicedToArray(_prepareMatching, 2), elementMatchers = _prepareMatching2[0], textMatchers = _prepareMatching2[1];
                            var delta = traverse(this.container, elementMatchers, textMatchers);
                            // Remove trailing newline
                            if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
                                delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
                            }
                            debug.log('convert', this.container.innerHTML, delta);
                            this.container.innerHTML = '';
                            return delta;
                        }
                    }, {
                        key: 'dangerouslyPasteHTML',
                        value: function dangerouslyPasteHTML(index, html) {
                            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
                            if (typeof index === 'string') {
                                return this.quill.setContents(this.convert(index), html);
                            }
                            else {
                                var paste = this.convert(html);
                                return this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
                            }
                        }
                    }, {
                        key: 'onPaste',
                        value: function onPaste(e) {
                            var _this2 = this;
                            if (e.defaultPrevented || !this.quill.isEnabled())
                                return;
                            var range = this.quill.getSelection();
                            var delta = new _quillDelta2.default().retain(range.index);
                            var scrollTop = this.quill.scrollingContainer.scrollTop;
                            this.container.focus();
                            this.quill.selection.update(_quill2.default.sources.SILENT);
                            setTimeout(function () {
                                delta = delta.concat(_this2.convert()).delete(range.length);
                                _this2.quill.updateContents(delta, _quill2.default.sources.USER);
                                // range.length contributes to delta.length()
                                _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
                                _this2.quill.scrollingContainer.scrollTop = scrollTop;
                                _this2.quill.focus();
                            }, 1);
                        }
                    }, {
                        key: 'prepareMatching',
                        value: function prepareMatching() {
                            var _this3 = this;
                            var elementMatchers = [], textMatchers = [];
                            this.matchers.forEach(function (pair) {
                                var _pair = _slicedToArray(pair, 2), selector = _pair[0], matcher = _pair[1];
                                switch (selector) {
                                    case Node.TEXT_NODE:
                                        textMatchers.push(matcher);
                                        break;
                                    case Node.ELEMENT_NODE:
                                        elementMatchers.push(matcher);
                                        break;
                                    default:
                                        [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
                                            // TODO use weakmap
                                            node[DOM_KEY] = node[DOM_KEY] || [];
                                            node[DOM_KEY].push(matcher);
                                        });
                                        break;
                                }
                            });
                            return [elementMatchers, textMatchers];
                        }
                    }]);
                return Clipboard;
            }(_module2.default);
            Clipboard.DEFAULTS = {
                matchers: [],
                matchVisual: true
            };
            function applyFormat(delta, format, value) {
                if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
                    return Object.keys(format).reduce(function (delta, key) {
                        return applyFormat(delta, key, format[key]);
                    }, delta);
                }
                else {
                    return delta.reduce(function (delta, op) {
                        if (op.attributes && op.attributes[format]) {
                            return delta.push(op);
                        }
                        else {
                            return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
                        }
                    }, new _quillDelta2.default());
                }
            }
            function computeStyle(node) {
                if (node.nodeType !== Node.ELEMENT_NODE)
                    return {};
                var DOM_KEY = '__ql-computed-style';
                return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
            }
            function deltaEndsWith(delta, text) {
                var endText = "";
                for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
                    var op = delta.ops[i];
                    if (typeof op.insert !== 'string')
                        break;
                    endText = op.insert + endText;
                }
                return endText.slice(-1 * text.length) === text;
            }
            function isLine(node) {
                if (node.childNodes.length === 0)
                    return false; // Exclude embed blocks
                var style = computeStyle(node);
                return ['block', 'list-item'].indexOf(style.display) > -1;
            }
            function traverse(node, elementMatchers, textMatchers) {
                // Post-order
                if (node.nodeType === node.TEXT_NODE) {
                    return textMatchers.reduce(function (delta, matcher) {
                        return matcher(node, delta);
                    }, new _quillDelta2.default());
                }
                else if (node.nodeType === node.ELEMENT_NODE) {
                    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
                        var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
                        if (childNode.nodeType === node.ELEMENT_NODE) {
                            childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
                                return matcher(childNode, childrenDelta);
                            }, childrenDelta);
                            childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
                                return matcher(childNode, childrenDelta);
                            }, childrenDelta);
                        }
                        return delta.concat(childrenDelta);
                    }, new _quillDelta2.default());
                }
                else {
                    return new _quillDelta2.default();
                }
            }
            function matchAlias(format, node, delta) {
                return applyFormat(delta, format, true);
            }
            function matchAttributor(node, delta) {
                var attributes = _parchment2.default.Attributor.Attribute.keys(node);
                var classes = _parchment2.default.Attributor.Class.keys(node);
                var styles = _parchment2.default.Attributor.Style.keys(node);
                var formats = {};
                attributes.concat(classes).concat(styles).forEach(function (name) {
                    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
                    if (attr != null) {
                        formats[attr.attrName] = attr.value(node);
                        if (formats[attr.attrName])
                            return;
                    }
                    attr = ATTRIBUTE_ATTRIBUTORS[name];
                    if (attr != null && attr.attrName === name) {
                        formats[attr.attrName] = attr.value(node) || undefined;
                    }
                    attr = STYLE_ATTRIBUTORS[name];
                    if (attr != null && attr.attrName === name) {
                        attr = STYLE_ATTRIBUTORS[name];
                        formats[attr.attrName] = attr.value(node) || undefined;
                    }
                });
                if (Object.keys(formats).length > 0) {
                    delta = applyFormat(delta, formats);
                }
                return delta;
            }
            function matchBlot(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null)
                    return delta;
                if (match.prototype instanceof _parchment2.default.Embed) {
                    var embed = {};
                    var value = match.value(node);
                    if (value != null) {
                        embed[match.blotName] = value;
                        delta = new _quillDelta2.default().insert(embed, match.formats(node));
                    }
                }
                else if (typeof match.formats === 'function') {
                    delta = applyFormat(delta, match.blotName, match.formats(node));
                }
                return delta;
            }
            function matchBreak(node, delta) {
                if (!deltaEndsWith(delta, '\n')) {
                    delta.insert('\n');
                }
                return delta;
            }
            function matchIgnore() {
                return new _quillDelta2.default();
            }
            function matchIndent(node, delta) {
                var match = _parchment2.default.query(node);
                if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
                    return delta;
                }
                var indent = -1, parent = node.parentNode;
                while (!parent.classList.contains('ql-clipboard')) {
                    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
                        indent += 1;
                    }
                    parent = parent.parentNode;
                }
                if (indent <= 0)
                    return delta;
                return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
            }
            function matchNewline(node, delta) {
                if (!deltaEndsWith(delta, '\n')) {
                    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
                        delta.insert('\n');
                    }
                }
                return delta;
            }
            function matchSpacing(node, delta) {
                if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
                    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
                    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
                        delta.insert('\n');
                    }
                }
                return delta;
            }
            function matchStyles(node, delta) {
                var formats = {};
                var style = node.style || {};
                if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
                    formats.italic = true;
                }
                if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
                    formats.bold = true;
                }
                if (Object.keys(formats).length > 0) {
                    delta = applyFormat(delta, formats);
                }
                if (parseFloat(style.textIndent || 0) > 0) {
                    // Could be 0.5in
                    delta = new _quillDelta2.default().insert('\t').concat(delta);
                }
                return delta;
            }
            function matchText(node, delta) {
                var text = node.data;
                // Word represents empty line with <o:p>&nbsp;</o:p>
                if (node.parentNode.tagName === 'O:P') {
                    return delta.insert(text.trim());
                }
                if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
                    return delta;
                }
                if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
                    // eslint-disable-next-line func-style
                    var replacer = function replacer(collapse, match) {
                        match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
                        return match.length < 1 && collapse ? ' ' : match;
                    };
                    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
                    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
                    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
                        text = text.replace(/^\s+/, replacer.bind(replacer, false));
                    }
                    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
                        text = text.replace(/\s+$/, replacer.bind(replacer, false));
                    }
                }
                return delta.insert(text);
            }
            exports.default = Clipboard;
            exports.matchAttributor = matchAttributor;
            exports.matchBlot = matchBlot;
            exports.matchNewline = matchNewline;
            exports.matchSpacing = matchSpacing;
            exports.matchText = matchText;
            /***/ 
        }),
        /* 56 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Bold = function (_Inline) {
                _inherits(Bold, _Inline);
                function Bold() {
                    _classCallCheck(this, Bold);
                    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
                }
                _createClass(Bold, [{
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
                            if (this.domNode.tagName !== this.statics.tagName[0]) {
                                this.replaceWith(this.statics.blotName);
                            }
                        }
                    }], [{
                        key: 'create',
                        value: function create() {
                            return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
                        }
                    }, {
                        key: 'formats',
                        value: function formats() {
                            return true;
                        }
                    }]);
                return Bold;
            }(_inline2.default);
            Bold.blotName = 'bold';
            Bold.tagName = ['STRONG', 'B'];
            exports.default = Bold;
            /***/ 
        }),
        /* 57 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.addControls = exports.default = undefined;
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _quillDelta = __webpack_require__(2);
            var _quillDelta2 = _interopRequireDefault(_quillDelta);
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _logger = __webpack_require__(10);
            var _logger2 = _interopRequireDefault(_logger);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _defineProperty(obj, key, value) { if (key in obj) {
                Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
            }
            else {
                obj[key] = value;
            } return obj; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var debug = (0, _logger2.default)('quill:toolbar');
            var Toolbar = function (_Module) {
                _inherits(Toolbar, _Module);
                function Toolbar(quill, options) {
                    _classCallCheck(this, Toolbar);
                    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
                    if (Array.isArray(_this.options.container)) {
                        var container = document.createElement('div');
                        addControls(container, _this.options.container);
                        quill.container.parentNode.insertBefore(container, quill.container);
                        _this.container = container;
                    }
                    else if (typeof _this.options.container === 'string') {
                        _this.container = document.querySelector(_this.options.container);
                    }
                    else {
                        _this.container = _this.options.container;
                    }
                    if (!(_this.container instanceof HTMLElement)) {
                        var _ret;
                        return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
                    }
                    _this.container.classList.add('ql-toolbar');
                    _this.controls = [];
                    _this.handlers = {};
                    Object.keys(_this.options.handlers).forEach(function (format) {
                        _this.addHandler(format, _this.options.handlers[format]);
                    });
                    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
                        _this.attach(input);
                    });
                    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
                        if (type === _quill2.default.events.SELECTION_CHANGE) {
                            _this.update(range);
                        }
                    });
                    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
                        var _this$quill$selection = _this.quill.selection.getRange(), _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1), range = _this$quill$selection2[0]; // quill.getSelection triggers update
                        _this.update(range);
                    });
                    return _this;
                }
                _createClass(Toolbar, [{
                        key: 'addHandler',
                        value: function addHandler(format, handler) {
                            this.handlers[format] = handler;
                        }
                    }, {
                        key: 'attach',
                        value: function attach(input) {
                            var _this2 = this;
                            var format = [].find.call(input.classList, function (className) {
                                return className.indexOf('ql-') === 0;
                            });
                            if (!format)
                                return;
                            format = format.slice('ql-'.length);
                            if (input.tagName === 'BUTTON') {
                                input.setAttribute('type', 'button');
                            }
                            if (this.handlers[format] == null) {
                                if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                                    debug.warn('ignoring attaching to disabled format', format, input);
                                    return;
                                }
                                if (_parchment2.default.query(format) == null) {
                                    debug.warn('ignoring attaching to nonexistent format', format, input);
                                    return;
                                }
                            }
                            var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
                            input.addEventListener(eventName, function (e) {
                                var value = void 0;
                                if (input.tagName === 'SELECT') {
                                    if (input.selectedIndex < 0)
                                        return;
                                    var selected = input.options[input.selectedIndex];
                                    if (selected.hasAttribute('selected')) {
                                        value = false;
                                    }
                                    else {
                                        value = selected.value || false;
                                    }
                                }
                                else {
                                    if (input.classList.contains('ql-active')) {
                                        value = false;
                                    }
                                    else {
                                        value = input.value || !input.hasAttribute('value');
                                    }
                                    e.preventDefault();
                                }
                                _this2.quill.focus();
                                var _quill$selection$getR = _this2.quill.selection.getRange(), _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1), range = _quill$selection$getR2[0];
                                if (_this2.handlers[format] != null) {
                                    _this2.handlers[format].call(_this2, value);
                                }
                                else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                                    value = prompt('Enter ' + format);
                                    if (!value)
                                        return;
                                    _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
                                }
                                else {
                                    _this2.quill.format(format, value, _quill2.default.sources.USER);
                                }
                                _this2.update(range);
                            });
                            // TODO use weakmap
                            this.controls.push([format, input]);
                        }
                    }, {
                        key: 'update',
                        value: function update(range) {
                            var formats = range == null ? {} : this.quill.getFormat(range);
                            this.controls.forEach(function (pair) {
                                var _pair = _slicedToArray(pair, 2), format = _pair[0], input = _pair[1];
                                if (input.tagName === 'SELECT') {
                                    var option = void 0;
                                    if (range == null) {
                                        option = null;
                                    }
                                    else if (formats[format] == null) {
                                        option = input.querySelector('option[selected]');
                                    }
                                    else if (!Array.isArray(formats[format])) {
                                        var value = formats[format];
                                        if (typeof value === 'string') {
                                            value = value.replace(/\"/g, '\\"');
                                        }
                                        option = input.querySelector('option[value="' + value + '"]');
                                    }
                                    if (option == null) {
                                        input.value = ''; // TODO make configurable?
                                        input.selectedIndex = -1;
                                    }
                                    else {
                                        option.selected = true;
                                    }
                                }
                                else {
                                    if (range == null) {
                                        input.classList.remove('ql-active');
                                    }
                                    else if (input.hasAttribute('value')) {
                                        // both being null should match (default values)
                                        // '1' should match with 1 (headers)
                                        var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
                                        input.classList.toggle('ql-active', isActive);
                                    }
                                    else {
                                        input.classList.toggle('ql-active', formats[format] != null);
                                    }
                                }
                            });
                        }
                    }]);
                return Toolbar;
            }(_module2.default);
            Toolbar.DEFAULTS = {};
            function addButton(container, format, value) {
                var input = document.createElement('button');
                input.setAttribute('type', 'button');
                input.classList.add('ql-' + format);
                if (value != null) {
                    input.value = value;
                }
                container.appendChild(input);
            }
            function addControls(container, groups) {
                if (!Array.isArray(groups[0])) {
                    groups = [groups];
                }
                groups.forEach(function (controls) {
                    var group = document.createElement('span');
                    group.classList.add('ql-formats');
                    controls.forEach(function (control) {
                        if (typeof control === 'string') {
                            addButton(group, control);
                        }
                        else {
                            var format = Object.keys(control)[0];
                            var value = control[format];
                            if (Array.isArray(value)) {
                                addSelect(group, format, value);
                            }
                            else {
                                addButton(group, format, value);
                            }
                        }
                    });
                    container.appendChild(group);
                });
            }
            function addSelect(container, format, values) {
                var input = document.createElement('select');
                input.classList.add('ql-' + format);
                values.forEach(function (value) {
                    var option = document.createElement('option');
                    if (value !== false) {
                        option.setAttribute('value', value);
                    }
                    else {
                        option.setAttribute('selected', 'selected');
                    }
                    input.appendChild(option);
                });
                container.appendChild(input);
            }
            Toolbar.DEFAULTS = {
                container: null,
                handlers: {
                    clean: function clean() {
                        var _this3 = this;
                        var range = this.quill.getSelection();
                        if (range == null)
                            return;
                        if (range.length == 0) {
                            var formats = this.quill.getFormat();
                            Object.keys(formats).forEach(function (name) {
                                // Clean functionality in existing apps only clean inline formats
                                if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
                                    _this3.quill.format(name, false);
                                }
                            });
                        }
                        else {
                            this.quill.removeFormat(range, _quill2.default.sources.USER);
                        }
                    },
                    direction: function direction(value) {
                        var align = this.quill.getFormat()['align'];
                        if (value === 'rtl' && align == null) {
                            this.quill.format('align', 'right', _quill2.default.sources.USER);
                        }
                        else if (!value && align === 'right') {
                            this.quill.format('align', false, _quill2.default.sources.USER);
                        }
                        this.quill.format('direction', value, _quill2.default.sources.USER);
                    },
                    indent: function indent(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        var indent = parseInt(formats.indent || 0);
                        if (value === '+1' || value === '-1') {
                            var modifier = value === '+1' ? 1 : -1;
                            if (formats.direction === 'rtl')
                                modifier *= -1;
                            this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
                        }
                    },
                    link: function link(value) {
                        if (value === true) {
                            value = prompt('Enter link URL:');
                        }
                        this.quill.format('link', value, _quill2.default.sources.USER);
                    },
                    list: function list(value) {
                        var range = this.quill.getSelection();
                        var formats = this.quill.getFormat(range);
                        if (value === 'check') {
                            if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
                                this.quill.format('list', false, _quill2.default.sources.USER);
                            }
                            else {
                                this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
                            }
                        }
                        else {
                            this.quill.format('list', value, _quill2.default.sources.USER);
                        }
                    }
                }
            };
            exports.default = Toolbar;
            exports.addControls = addControls;
            /***/ 
        }),
        /* 58 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
            /***/ 
        }),
        /* 59 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var ColorPicker = function (_Picker) {
                _inherits(ColorPicker, _Picker);
                function ColorPicker(select, label) {
                    _classCallCheck(this, ColorPicker);
                    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
                    _this.label.innerHTML = label;
                    _this.container.classList.add('ql-color-picker');
                    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
                        item.classList.add('ql-primary');
                    });
                    return _this;
                }
                _createClass(ColorPicker, [{
                        key: 'buildItem',
                        value: function buildItem(option) {
                            var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
                            item.style.backgroundColor = option.getAttribute('value') || '';
                            return item;
                        }
                    }, {
                        key: 'selectItem',
                        value: function selectItem(item, trigger) {
                            _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
                            var colorLabel = this.label.querySelector('.ql-color-label');
                            var value = item ? item.getAttribute('data-value') || '' : '';
                            if (colorLabel) {
                                if (colorLabel.tagName === 'line') {
                                    colorLabel.style.stroke = value;
                                }
                                else {
                                    colorLabel.style.fill = value;
                                }
                            }
                        }
                    }]);
                return ColorPicker;
            }(_picker2.default);
            exports.default = ColorPicker;
            /***/ 
        }),
        /* 60 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var IconPicker = function (_Picker) {
                _inherits(IconPicker, _Picker);
                function IconPicker(select, icons) {
                    _classCallCheck(this, IconPicker);
                    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
                    _this.container.classList.add('ql-icon-picker');
                    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
                        item.innerHTML = icons[item.getAttribute('data-value') || ''];
                    });
                    _this.defaultItem = _this.container.querySelector('.ql-selected');
                    _this.selectItem(_this.defaultItem);
                    return _this;
                }
                _createClass(IconPicker, [{
                        key: 'selectItem',
                        value: function selectItem(item, trigger) {
                            _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
                            item = item || this.defaultItem;
                            this.label.innerHTML = item.innerHTML;
                        }
                    }]);
                return IconPicker;
            }(_picker2.default);
            exports.default = IconPicker;
            /***/ 
        }),
        /* 61 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            var Tooltip = /*@__PURE__*/ function () {
                function Tooltip(quill, boundsContainer) {
                    var _this = this;
                    _classCallCheck(this, Tooltip);
                    this.quill = quill;
                    this.boundsContainer = boundsContainer || document.body;
                    this.root = quill.addContainer('ql-tooltip');
                    this.root.innerHTML = this.constructor.TEMPLATE;
                    if (this.quill.root === this.quill.scrollingContainer) {
                        this.quill.root.addEventListener('scroll', function () {
                            _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
                        });
                    }
                    this.hide();
                }
                _createClass(Tooltip, [{
                        key: 'hide',
                        value: function hide() {
                            this.root.classList.add('ql-hidden');
                        }
                    }, {
                        key: 'position',
                        value: function position(reference) {
                            var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
                            // root.scrollTop should be 0 if scrollContainer !== root
                            var top = reference.bottom + this.quill.root.scrollTop;
                            this.root.style.left = left + 'px';
                            this.root.style.top = top + 'px';
                            this.root.classList.remove('ql-flip');
                            var containerBounds = this.boundsContainer.getBoundingClientRect();
                            var rootBounds = this.root.getBoundingClientRect();
                            var shift = 0;
                            if (rootBounds.right > containerBounds.right) {
                                shift = containerBounds.right - rootBounds.right;
                                this.root.style.left = left + shift + 'px';
                            }
                            if (rootBounds.left < containerBounds.left) {
                                shift = containerBounds.left - rootBounds.left;
                                this.root.style.left = left + shift + 'px';
                            }
                            if (rootBounds.bottom > containerBounds.bottom) {
                                var height = rootBounds.bottom - rootBounds.top;
                                var verticalShift = reference.bottom - reference.top + height;
                                this.root.style.top = top - verticalShift + 'px';
                                this.root.classList.add('ql-flip');
                            }
                            return shift;
                        }
                    }, {
                        key: 'show',
                        value: function show() {
                            this.root.classList.remove('ql-editing');
                            this.root.classList.remove('ql-hidden');
                        }
                    }]);
                return Tooltip;
            }();
            exports.default = Tooltip;
            /***/ 
        }),
        /* 62 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                    _arr.push(_s.value);
                    if (i && _arr.length === i)
                        break;
                }
            }
            catch (err) {
                _d = true;
                _e = err;
            }
            finally {
                try {
                    if (!_n && _i["return"])
                        _i["return"]();
                }
                finally {
                    if (_d)
                        throw _e;
                }
            } return _arr; } return function (arr, i) { if (Array.isArray(arr)) {
                return arr;
            }
            else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
            }
            else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
            } }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];
            var SnowTheme = function (_BaseTheme) {
                _inherits(SnowTheme, _BaseTheme);
                function SnowTheme(quill, options) {
                    _classCallCheck(this, SnowTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
                        options.modules.toolbar.container = TOOLBAR_CONFIG;
                    }
                    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
                    _this.quill.container.classList.add('ql-snow');
                    return _this;
                }
                _createClass(SnowTheme, [{
                        key: 'extendToolbar',
                        value: function extendToolbar(toolbar) {
                            toolbar.container.classList.add('ql-snow');
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
                            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
                            if (toolbar.container.querySelector('.ql-link')) {
                                this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
                                    toolbar.handlers['link'].call(toolbar, !context.format.link);
                                });
                            }
                        }
                    }]);
                return SnowTheme;
            }(_base2.default);
            SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (value) {
                                    var range = this.quill.getSelection();
                                    if (range == null || range.length == 0)
                                        return;
                                    var preview = this.quill.getText(range);
                                    if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
                                        preview = 'mailto:' + preview;
                                    }
                                    var tooltip = this.quill.theme.tooltip;
                                    tooltip.edit('link', preview);
                                }
                                else {
                                    this.quill.format('link', false);
                                }
                            }
                        }
                    }
                }
            });
            var SnowTooltip = function (_BaseTooltip) {
                _inherits(SnowTooltip, _BaseTooltip);
                function SnowTooltip(quill, bounds) {
                    _classCallCheck(this, SnowTooltip);
                    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
                    _this2.preview = _this2.root.querySelector('a.ql-preview');
                    return _this2;
                }
                _createClass(SnowTooltip, [{
                        key: 'listen',
                        value: function listen() {
                            var _this3 = this;
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
                            this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
                                if (_this3.root.classList.contains('ql-editing')) {
                                    _this3.save();
                                }
                                else {
                                    _this3.edit('link', _this3.preview.textContent);
                                }
                                event.preventDefault();
                            });
                            this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
                                if (_this3.linkRange != null) {
                                    var range = _this3.linkRange;
                                    _this3.restoreFocus();
                                    _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
                                    delete _this3.linkRange;
                                }
                                event.preventDefault();
                                _this3.hide();
                            });
                            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
                                if (range == null)
                                    return;
                                if (range.length === 0 && source === _emitter2.default.sources.USER) {
                                    var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), link = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                                    if (link != null) {
                                        _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                                        var preview = _link2.default.formats(link.domNode);
                                        _this3.preview.textContent = preview;
                                        _this3.preview.setAttribute('href', preview);
                                        _this3.show();
                                        _this3.position(_this3.quill.getBounds(_this3.linkRange));
                                        return;
                                    }
                                }
                                else {
                                    delete _this3.linkRange;
                                }
                                _this3.hide();
                            });
                        }
                    }, {
                        key: 'show',
                        value: function show() {
                            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
                            this.root.removeAttribute('data-mode');
                        }
                    }]);
                return SnowTooltip;
            }(_base.BaseTooltip);
            SnowTooltip.TEMPLATE = ['<a class="ql-preview" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');
            exports.default = SnowTheme;
            /***/ 
        }),
        /* 63 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _core = __webpack_require__(29);
            var _core2 = _interopRequireDefault(_core);
            var _align = __webpack_require__(36);
            var _direction = __webpack_require__(38);
            var _indent = __webpack_require__(64);
            var _blockquote = __webpack_require__(65);
            var _blockquote2 = _interopRequireDefault(_blockquote);
            var _header = __webpack_require__(66);
            var _header2 = _interopRequireDefault(_header);
            var _list = __webpack_require__(67);
            var _list2 = _interopRequireDefault(_list);
            var _background = __webpack_require__(37);
            var _color = __webpack_require__(26);
            var _font = __webpack_require__(39);
            var _size = __webpack_require__(40);
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            var _italic = __webpack_require__(68);
            var _italic2 = _interopRequireDefault(_italic);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            var _script = __webpack_require__(69);
            var _script2 = _interopRequireDefault(_script);
            var _strike = __webpack_require__(70);
            var _strike2 = _interopRequireDefault(_strike);
            var _underline = __webpack_require__(71);
            var _underline2 = _interopRequireDefault(_underline);
            var _image = __webpack_require__(72);
            var _image2 = _interopRequireDefault(_image);
            var _video = __webpack_require__(73);
            var _video2 = _interopRequireDefault(_video);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            var _formula = __webpack_require__(74);
            var _formula2 = _interopRequireDefault(_formula);
            var _syntax = __webpack_require__(75);
            var _syntax2 = _interopRequireDefault(_syntax);
            var _toolbar = __webpack_require__(57);
            var _toolbar2 = _interopRequireDefault(_toolbar);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            var _picker = __webpack_require__(28);
            var _picker2 = _interopRequireDefault(_picker);
            var _colorPicker = __webpack_require__(59);
            var _colorPicker2 = _interopRequireDefault(_colorPicker);
            var _iconPicker = __webpack_require__(60);
            var _iconPicker2 = _interopRequireDefault(_iconPicker);
            var _tooltip = __webpack_require__(61);
            var _tooltip2 = _interopRequireDefault(_tooltip);
            var _bubble = __webpack_require__(108);
            var _bubble2 = _interopRequireDefault(_bubble);
            var _snow = __webpack_require__(62);
            var _snow2 = _interopRequireDefault(_snow);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            _core2.default.register({
                'attributors/attribute/direction': _direction.DirectionAttribute,
                'attributors/class/align': _align.AlignClass,
                'attributors/class/background': _background.BackgroundClass,
                'attributors/class/color': _color.ColorClass,
                'attributors/class/direction': _direction.DirectionClass,
                'attributors/class/font': _font.FontClass,
                'attributors/class/size': _size.SizeClass,
                'attributors/style/align': _align.AlignStyle,
                'attributors/style/background': _background.BackgroundStyle,
                'attributors/style/color': _color.ColorStyle,
                'attributors/style/direction': _direction.DirectionStyle,
                'attributors/style/font': _font.FontStyle,
                'attributors/style/size': _size.SizeStyle
            }, true);
            _core2.default.register({
                'formats/align': _align.AlignClass,
                'formats/direction': _direction.DirectionClass,
                'formats/indent': _indent.IndentClass,
                'formats/background': _background.BackgroundStyle,
                'formats/color': _color.ColorStyle,
                'formats/font': _font.FontClass,
                'formats/size': _size.SizeClass,
                'formats/blockquote': _blockquote2.default,
                'formats/code-block': _code2.default,
                'formats/header': _header2.default,
                'formats/list': _list2.default,
                'formats/bold': _bold2.default,
                'formats/code': _code.Code,
                'formats/italic': _italic2.default,
                'formats/link': _link2.default,
                'formats/script': _script2.default,
                'formats/strike': _strike2.default,
                'formats/underline': _underline2.default,
                'formats/image': _image2.default,
                'formats/video': _video2.default,
                'formats/list/item': _list.ListItem,
                'modules/formula': _formula2.default,
                'modules/syntax': _syntax2.default,
                'modules/toolbar': _toolbar2.default,
                'themes/bubble': _bubble2.default,
                'themes/snow': _snow2.default,
                'ui/icons': _icons2.default,
                'ui/picker': _picker2.default,
                'ui/icon-picker': _iconPicker2.default,
                'ui/color-picker': _colorPicker2.default,
                'ui/tooltip': _tooltip2.default
            }, true);
            exports.default = _core2.default;
            /***/ 
        }),
        /* 64 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.IndentClass = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var IdentAttributor = function (_Parchment$Attributor) {
                _inherits(IdentAttributor, _Parchment$Attributor);
                function IdentAttributor() {
                    _classCallCheck(this, IdentAttributor);
                    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
                }
                _createClass(IdentAttributor, [{
                        key: 'add',
                        value: function add(node, value) {
                            if (value === '+1' || value === '-1') {
                                var indent = this.value(node) || 0;
                                value = value === '+1' ? indent + 1 : indent - 1;
                            }
                            if (value === 0) {
                                this.remove(node);
                                return true;
                            }
                            else {
                                return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
                            }
                        }
                    }, {
                        key: 'canAdd',
                        value: function canAdd(node, value) {
                            return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
                        }
                    }, {
                        key: 'value',
                        value: function value(node) {
                            return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
                        }
                    }]);
                return IdentAttributor;
            }(_parchment2.default.Attributor.Class);
            var IndentClass = new IdentAttributor('indent', 'ql-indent', {
                scope: _parchment2.default.Scope.BLOCK,
                whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
            });
            exports.IndentClass = IndentClass;
            /***/ 
        }),
        /* 65 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Blockquote = function (_Block) {
                _inherits(Blockquote, _Block);
                function Blockquote() {
                    _classCallCheck(this, Blockquote);
                    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
                }
                return Blockquote;
            }(_block2.default);
            Blockquote.blotName = 'blockquote';
            Blockquote.tagName = 'blockquote';
            exports.default = Blockquote;
            /***/ 
        }),
        /* 66 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Header = function (_Block) {
                _inherits(Header, _Block);
                function Header() {
                    _classCallCheck(this, Header);
                    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
                }
                _createClass(Header, null, [{
                        key: 'formats',
                        value: function formats(domNode) {
                            return this.tagName.indexOf(domNode.tagName) + 1;
                        }
                    }]);
                return Header;
            }(_block2.default);
            Header.blotName = 'header';
            Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
            exports.default = Header;
            /***/ 
        }),
        /* 67 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.ListItem = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _block = __webpack_require__(4);
            var _block2 = _interopRequireDefault(_block);
            var _container = __webpack_require__(24);
            var _container2 = _interopRequireDefault(_container);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _defineProperty(obj, key, value) { if (key in obj) {
                Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
            }
            else {
                obj[key] = value;
            } return obj; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var ListItem = function (_Block) {
                _inherits(ListItem, _Block);
                function ListItem() {
                    _classCallCheck(this, ListItem);
                    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
                }
                _createClass(ListItem, [{
                        key: 'format',
                        value: function format(name, value) {
                            if (name === List.blotName && !value) {
                                this.replaceWith(_parchment2.default.create(this.statics.scope));
                            }
                            else {
                                _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
                            }
                        }
                    }, {
                        key: 'remove',
                        value: function remove() {
                            if (this.prev == null && this.next == null) {
                                this.parent.remove();
                            }
                            else {
                                _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
                            }
                        }
                    }, {
                        key: 'replaceWith',
                        value: function replaceWith(name, value) {
                            this.parent.isolate(this.offset(this.parent), this.length());
                            if (name === this.parent.statics.blotName) {
                                this.parent.replaceWith(name, value);
                                return this;
                            }
                            else {
                                this.parent.unwrap();
                                return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
                            }
                        }
                    }], [{
                        key: 'formats',
                        value: function formats(domNode) {
                            return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
                        }
                    }]);
                return ListItem;
            }(_block2.default);
            ListItem.blotName = 'list-item';
            ListItem.tagName = 'LI';
            var List = function (_Container) {
                _inherits(List, _Container);
                _createClass(List, null, [{
                        key: 'create',
                        value: function create(value) {
                            var tagName = value === 'ordered' ? 'OL' : 'UL';
                            var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
                            if (value === 'checked' || value === 'unchecked') {
                                node.setAttribute('data-checked', value === 'checked');
                            }
                            return node;
                        }
                    }, {
                        key: 'formats',
                        value: function formats(domNode) {
                            if (domNode.tagName === 'OL')
                                return 'ordered';
                            if (domNode.tagName === 'UL') {
                                if (domNode.hasAttribute('data-checked')) {
                                    return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
                                }
                                else {
                                    return 'bullet';
                                }
                            }
                            return undefined;
                        }
                    }]);
                function List(domNode) {
                    _classCallCheck(this, List);
                    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
                    var listEventHandler = function listEventHandler(e) {
                        if (e.target.parentNode !== domNode)
                            return;
                        var format = _this2.statics.formats(domNode);
                        var blot = _parchment2.default.find(e.target);
                        if (format === 'checked') {
                            blot.format('list', 'unchecked');
                        }
                        else if (format === 'unchecked') {
                            blot.format('list', 'checked');
                        }
                    };
                    domNode.addEventListener('touchstart', listEventHandler);
                    domNode.addEventListener('mousedown', listEventHandler);
                    return _this2;
                }
                _createClass(List, [{
                        key: 'format',
                        value: function format(name, value) {
                            if (this.children.length > 0) {
                                this.children.tail.format(name, value);
                            }
                        }
                    }, {
                        key: 'formats',
                        value: function formats() {
                            // We don't inherit from FormatBlot
                            return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
                        }
                    }, {
                        key: 'insertBefore',
                        value: function insertBefore(blot, ref) {
                            if (blot instanceof ListItem) {
                                _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
                            }
                            else {
                                var index = ref == null ? this.length() : ref.offset(this);
                                var after = this.split(index);
                                after.parent.insertBefore(blot, after);
                            }
                        }
                    }, {
                        key: 'optimize',
                        value: function optimize(context) {
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
                            var next = this.next;
                            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
                                next.moveChildren(this);
                                next.remove();
                            }
                        }
                    }, {
                        key: 'replace',
                        value: function replace(target) {
                            if (target.statics.blotName !== this.statics.blotName) {
                                var item = _parchment2.default.create(this.statics.defaultChild);
                                target.moveChildren(item);
                                this.appendChild(item);
                            }
                            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
                        }
                    }]);
                return List;
            }(_container2.default);
            List.blotName = 'list';
            List.scope = _parchment2.default.Scope.BLOCK_BLOT;
            List.tagName = ['OL', 'UL'];
            List.defaultChild = 'list-item';
            List.allowedChildren = [ListItem];
            exports.ListItem = ListItem;
            exports.default = List;
            /***/ 
        }),
        /* 68 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _bold = __webpack_require__(56);
            var _bold2 = _interopRequireDefault(_bold);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Italic = function (_Bold) {
                _inherits(Italic, _Bold);
                function Italic() {
                    _classCallCheck(this, Italic);
                    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
                }
                return Italic;
            }(_bold2.default);
            Italic.blotName = 'italic';
            Italic.tagName = ['EM', 'I'];
            exports.default = Italic;
            /***/ 
        }),
        /* 69 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Script = function (_Inline) {
                _inherits(Script, _Inline);
                function Script() {
                    _classCallCheck(this, Script);
                    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
                }
                _createClass(Script, null, [{
                        key: 'create',
                        value: function create(value) {
                            if (value === 'super') {
                                return document.createElement('sup');
                            }
                            else if (value === 'sub') {
                                return document.createElement('sub');
                            }
                            else {
                                return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
                            }
                        }
                    }, {
                        key: 'formats',
                        value: function formats(domNode) {
                            if (domNode.tagName === 'SUB')
                                return 'sub';
                            if (domNode.tagName === 'SUP')
                                return 'super';
                            return undefined;
                        }
                    }]);
                return Script;
            }(_inline2.default);
            Script.blotName = 'script';
            Script.tagName = ['SUB', 'SUP'];
            exports.default = Script;
            /***/ 
        }),
        /* 70 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Strike = function (_Inline) {
                _inherits(Strike, _Inline);
                function Strike() {
                    _classCallCheck(this, Strike);
                    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
                }
                return Strike;
            }(_inline2.default);
            Strike.blotName = 'strike';
            Strike.tagName = 'S';
            exports.default = Strike;
            /***/ 
        }),
        /* 71 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _inline = __webpack_require__(6);
            var _inline2 = _interopRequireDefault(_inline);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var Underline = function (_Inline) {
                _inherits(Underline, _Inline);
                function Underline() {
                    _classCallCheck(this, Underline);
                    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
                }
                return Underline;
            }(_inline2.default);
            Underline.blotName = 'underline';
            Underline.tagName = 'U';
            exports.default = Underline;
            /***/ 
        }),
        /* 72 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _link = __webpack_require__(27);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var ATTRIBUTES = ['alt', 'height', 'width'];
            var Image = function (_Parchment$Embed) {
                _inherits(Image, _Parchment$Embed);
                function Image() {
                    _classCallCheck(this, Image);
                    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
                }
                _createClass(Image, [{
                        key: 'format',
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) {
                                    this.domNode.setAttribute(name, value);
                                }
                                else {
                                    this.domNode.removeAttribute(name);
                                }
                            }
                            else {
                                _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
                            }
                        }
                    }], [{
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
                            if (typeof value === 'string') {
                                node.setAttribute('src', this.sanitize(value));
                            }
                            return node;
                        }
                    }, {
                        key: 'formats',
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function (formats, attribute) {
                                if (domNode.hasAttribute(attribute)) {
                                    formats[attribute] = domNode.getAttribute(attribute);
                                }
                                return formats;
                            }, {});
                        }
                    }, {
                        key: 'match',
                        value: function match(url) {
                            return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url));
                        }
                    }, {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
                        }
                    }, {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('src');
                        }
                    }]);
                return Image;
            }(_parchment2.default.Embed);
            Image.blotName = 'image';
            Image.tagName = 'IMG';
            exports.default = Image;
            /***/ 
        }),
        /* 73 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _block = __webpack_require__(4);
            var _link = __webpack_require__(27);
            var _link2 = _interopRequireDefault(_link);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var ATTRIBUTES = ['height', 'width'];
            var Video = function (_BlockEmbed) {
                _inherits(Video, _BlockEmbed);
                function Video() {
                    _classCallCheck(this, Video);
                    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
                }
                _createClass(Video, [{
                        key: 'format',
                        value: function format(name, value) {
                            if (ATTRIBUTES.indexOf(name) > -1) {
                                if (value) {
                                    this.domNode.setAttribute(name, value);
                                }
                                else {
                                    this.domNode.removeAttribute(name);
                                }
                            }
                            else {
                                _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
                            }
                        }
                    }], [{
                        key: 'create',
                        value: function create(value) {
                            var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
                            node.setAttribute('frameborder', '0');
                            node.setAttribute('allowfullscreen', true);
                            node.setAttribute('src', this.sanitize(value));
                            return node;
                        }
                    }, {
                        key: 'formats',
                        value: function formats(domNode) {
                            return ATTRIBUTES.reduce(function (formats, attribute) {
                                if (domNode.hasAttribute(attribute)) {
                                    formats[attribute] = domNode.getAttribute(attribute);
                                }
                                return formats;
                            }, {});
                        }
                    }, {
                        key: 'sanitize',
                        value: function sanitize(url) {
                            return _link2.default.sanitize(url);
                        }
                    }, {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('src');
                        }
                    }]);
                return Video;
            }(_block.BlockEmbed);
            Video.blotName = 'video';
            Video.className = 'ql-video';
            Video.tagName = 'IFRAME';
            exports.default = Video;
            /***/ 
        }),
        /* 74 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.FormulaBlot = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _embed = __webpack_require__(25);
            var _embed2 = _interopRequireDefault(_embed);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var FormulaBlot = function (_Embed) {
                _inherits(FormulaBlot, _Embed);
                function FormulaBlot() {
                    _classCallCheck(this, FormulaBlot);
                    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
                }
                _createClass(FormulaBlot, null, [{
                        key: 'create',
                        value: function create(value) {
                            var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
                            if (typeof value === 'string') {
                                window.katex.render(value, node, {
                                    throwOnError: false,
                                    errorColor: '#f00'
                                });
                                node.setAttribute('data-value', value);
                            }
                            return node;
                        }
                    }, {
                        key: 'value',
                        value: function value(domNode) {
                            return domNode.getAttribute('data-value');
                        }
                    }]);
                return FormulaBlot;
            }(_embed2.default);
            FormulaBlot.blotName = 'formula';
            FormulaBlot.className = 'ql-formula';
            FormulaBlot.tagName = 'SPAN';
            var Formula = function (_Module) {
                _inherits(Formula, _Module);
                _createClass(Formula, null, [{
                        key: 'register',
                        value: function register() {
                            _quill2.default.register(FormulaBlot, true);
                        }
                    }]);
                function Formula() {
                    _classCallCheck(this, Formula);
                    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
                    if (window.katex == null) {
                        throw new Error('Formula module requires KaTeX.');
                    }
                    return _this2;
                }
                return Formula;
            }(_module2.default);
            exports.FormulaBlot = FormulaBlot;
            exports.default = Formula;
            /***/ 
        }),
        /* 75 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.CodeToken = exports.CodeBlock = undefined;
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _parchment = __webpack_require__(0);
            var _parchment2 = _interopRequireDefault(_parchment);
            var _quill = __webpack_require__(5);
            var _quill2 = _interopRequireDefault(_quill);
            var _module = __webpack_require__(9);
            var _module2 = _interopRequireDefault(_module);
            var _code = __webpack_require__(13);
            var _code2 = _interopRequireDefault(_code);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var SyntaxCodeBlock = function (_CodeBlock) {
                _inherits(SyntaxCodeBlock, _CodeBlock);
                function SyntaxCodeBlock() {
                    _classCallCheck(this, SyntaxCodeBlock);
                    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
                }
                _createClass(SyntaxCodeBlock, [{
                        key: 'replaceWith',
                        value: function replaceWith(block) {
                            this.domNode.textContent = this.domNode.textContent;
                            this.attach();
                            _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
                        }
                    }, {
                        key: 'highlight',
                        value: function highlight(_highlight) {
                            var text = this.domNode.textContent;
                            if (this.cachedText !== text) {
                                if (text.trim().length > 0 || this.cachedText == null) {
                                    this.domNode.innerHTML = _highlight(text);
                                    this.domNode.normalize();
                                    this.attach();
                                }
                                this.cachedText = text;
                            }
                        }
                    }]);
                return SyntaxCodeBlock;
            }(_code2.default);
            SyntaxCodeBlock.className = 'ql-syntax';
            var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
                scope: _parchment2.default.Scope.INLINE
            });
            var Syntax = function (_Module) {
                _inherits(Syntax, _Module);
                _createClass(Syntax, null, [{
                        key: 'register',
                        value: function register() {
                            _quill2.default.register(CodeToken, true);
                            _quill2.default.register(SyntaxCodeBlock, true);
                        }
                    }]);
                function Syntax(quill, options) {
                    _classCallCheck(this, Syntax);
                    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
                    if (typeof _this2.options.highlight !== 'function') {
                        throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
                    }
                    var timer = null;
                    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
                        clearTimeout(timer);
                        timer = setTimeout(function () {
                            _this2.highlight();
                            timer = null;
                        }, _this2.options.interval);
                    });
                    _this2.highlight();
                    return _this2;
                }
                _createClass(Syntax, [{
                        key: 'highlight',
                        value: function highlight() {
                            var _this3 = this;
                            if (this.quill.selection.composing)
                                return;
                            this.quill.update(_quill2.default.sources.USER);
                            var range = this.quill.getSelection();
                            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
                                code.highlight(_this3.options.highlight);
                            });
                            this.quill.update(_quill2.default.sources.SILENT);
                            if (range != null) {
                                this.quill.setSelection(range, _quill2.default.sources.SILENT);
                            }
                        }
                    }]);
                return Syntax;
            }(_module2.default);
            Syntax.DEFAULTS = {
                highlight: function () {
                    if (window.hljs == null)
                        return null;
                    return function (text) {
                        var result = window.hljs.highlightAuto(text);
                        return result.value;
                    };
                }(),
                interval: 1000
            };
            exports.CodeBlock = SyntaxCodeBlock;
            exports.CodeToken = CodeToken;
            exports.default = Syntax;
            /***/ 
        }),
        /* 76 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
            /***/ 
        }),
        /* 77 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
            /***/ 
        }),
        /* 78 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
            /***/ 
        }),
        /* 79 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
            /***/ 
        }),
        /* 80 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
            /***/ 
        }),
        /* 81 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
            /***/ 
        }),
        /* 82 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
            /***/ 
        }),
        /* 83 */
        /***/ (function (module, exports) {
            module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
            /***/ 
        }),
        /* 84 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
            /***/ 
        }),
        /* 85 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
            /***/ 
        }),
        /* 86 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
            /***/ 
        }),
        /* 87 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
            /***/ 
        }),
        /* 88 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
            /***/ 
        }),
        /* 89 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
            /***/ 
        }),
        /* 90 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
            /***/ 
        }),
        /* 91 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
            /***/ 
        }),
        /* 92 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
            /***/ 
        }),
        /* 93 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
            /***/ 
        }),
        /* 94 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
            /***/ 
        }),
        /* 95 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
            /***/ 
        }),
        /* 96 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
            /***/ 
        }),
        /* 97 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
            /***/ 
        }),
        /* 98 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
            /***/ 
        }),
        /* 99 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
            /***/ 
        }),
        /* 100 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
            /***/ 
        }),
        /* 101 */
        /***/ (function (module, exports) {
            module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
            /***/ 
        }),
        /* 102 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
            /***/ 
        }),
        /* 103 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
            /***/ 
        }),
        /* 104 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
            /***/ 
        }),
        /* 105 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
            /***/ 
        }),
        /* 106 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
            /***/ 
        }),
        /* 107 */
        /***/ (function (module, exports) {
            module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
            /***/ 
        }),
        /* 108 */
        /***/ (function (module, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.default = exports.BubbleTooltip = undefined;
            var _get = function get(object, property, receiver) { if (object === null)
                object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) {
                    return undefined;
                }
                else {
                    return get(parent, property, receiver);
                }
            }
            else if ("value" in desc) {
                return desc.value;
            }
            else {
                var getter = desc.get;
                if (getter === undefined) {
                    return undefined;
                }
                return getter.call(receiver);
            } };
            var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                    descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            } } return function (Constructor, protoProps, staticProps) { if (protoProps)
                defineProperties(Constructor.prototype, protoProps); if (staticProps)
                defineProperties(Constructor, staticProps); return Constructor; }; }();
            var _extend = __webpack_require__(3);
            var _extend2 = _interopRequireDefault(_extend);
            var _emitter = __webpack_require__(8);
            var _emitter2 = _interopRequireDefault(_emitter);
            var _base = __webpack_require__(43);
            var _base2 = _interopRequireDefault(_base);
            var _selection = __webpack_require__(15);
            var _icons = __webpack_require__(41);
            var _icons2 = _interopRequireDefault(_icons);
            function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
            function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
            } }
            function _possibleConstructorReturn(self, call) { if (!self) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
            function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass)
                Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
            var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];
            var BubbleTheme = function (_BaseTheme) {
                _inherits(BubbleTheme, _BaseTheme);
                function BubbleTheme(quill, options) {
                    _classCallCheck(this, BubbleTheme);
                    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
                        options.modules.toolbar.container = TOOLBAR_CONFIG;
                    }
                    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
                    _this.quill.container.classList.add('ql-bubble');
                    return _this;
                }
                _createClass(BubbleTheme, [{
                        key: 'extendToolbar',
                        value: function extendToolbar(toolbar) {
                            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
                            this.tooltip.root.appendChild(toolbar.container);
                            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
                            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
                        }
                    }]);
                return BubbleTheme;
            }(_base2.default);
            BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
                modules: {
                    toolbar: {
                        handlers: {
                            link: function link(value) {
                                if (!value) {
                                    this.quill.format('link', false);
                                }
                                else {
                                    this.quill.theme.tooltip.edit();
                                }
                            }
                        }
                    }
                }
            });
            var BubbleTooltip = function (_BaseTooltip) {
                _inherits(BubbleTooltip, _BaseTooltip);
                function BubbleTooltip(quill, bounds) {
                    _classCallCheck(this, BubbleTooltip);
                    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
                    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
                        if (type !== _emitter2.default.events.SELECTION_CHANGE)
                            return;
                        if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
                            _this2.show();
                            // Lock our width so we will expand beyond our offsetParent boundaries
                            _this2.root.style.left = '0px';
                            _this2.root.style.width = '';
                            _this2.root.style.width = _this2.root.offsetWidth + 'px';
                            var lines = _this2.quill.getLines(range.index, range.length);
                            if (lines.length === 1) {
                                _this2.position(_this2.quill.getBounds(range));
                            }
                            else {
                                var lastLine = lines[lines.length - 1];
                                var index = _this2.quill.getIndex(lastLine);
                                var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                                var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                                _this2.position(_bounds);
                            }
                        }
                        else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
                            _this2.hide();
                        }
                    });
                    return _this2;
                }
                _createClass(BubbleTooltip, [{
                        key: 'listen',
                        value: function listen() {
                            var _this3 = this;
                            _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
                            this.root.querySelector('.ql-close').addEventListener('click', function () {
                                _this3.root.classList.remove('ql-editing');
                            });
                            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
                                // Let selection be restored by toolbar handlers before repositioning
                                setTimeout(function () {
                                    if (_this3.root.classList.contains('ql-hidden'))
                                        return;
                                    var range = _this3.quill.getSelection();
                                    if (range != null) {
                                        _this3.position(_this3.quill.getBounds(range));
                                    }
                                }, 1);
                            });
                        }
                    }, {
                        key: 'cancel',
                        value: function cancel() {
                            this.show();
                        }
                    }, {
                        key: 'position',
                        value: function position(reference) {
                            var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
                            var arrow = this.root.querySelector('.ql-tooltip-arrow');
                            arrow.style.marginLeft = '';
                            if (shift === 0)
                                return shift;
                            arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
                        }
                    }]);
                return BubbleTooltip;
            }(_base.BaseTooltip);
            BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
            exports.BubbleTooltip = BubbleTooltip;
            exports.default = BubbleTheme;
            /***/ 
        }),
        /* 109 */
        /***/ (function (module, exports, __webpack_require__) {
            module.exports = __webpack_require__(63);
            /***/ 
        })
        /******/ 
    ])["default"];
});


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "yRTJ":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        ss : '%d detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),

/***/ "yZfy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ROUTER_FORROOT_GUARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return RouterInitializer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return createRouterScroller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getAppInitializer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getBootstrapListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return provideForRootGuard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return provideLocationStrategy; });
/* unused harmony export ɵangular_packages_router_router_k */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return rootRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return routerNgProbeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return setupRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return RouterScroller; });
/* unused harmony export ɵangular_packages_router_router_l */
/* unused harmony export ɵangular_packages_router_router_m */
/* unused harmony export RouterLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RouterLinkWithHref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RouterLinkActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RouterOutlet; });
/* unused harmony export ActivationEnd */
/* unused harmony export ActivationStart */
/* unused harmony export ChildActivationEnd */
/* unused harmony export ChildActivationStart */
/* unused harmony export GuardsCheckEnd */
/* unused harmony export GuardsCheckStart */
/* unused harmony export NavigationCancel */
/* unused harmony export NavigationEnd */
/* unused harmony export NavigationError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NavigationStart; });
/* unused harmony export ResolveEnd */
/* unused harmony export ResolveStart */
/* unused harmony export RouteConfigLoadEnd */
/* unused harmony export RouteConfigLoadStart */
/* unused harmony export RouterEvent */
/* unused harmony export RoutesRecognized */
/* unused harmony export Scroll */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RouteReuseStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ROUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ROUTER_CONFIGURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ROUTER_INITIALIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RouterModule; });
/* unused harmony export provideRoutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChildrenOutletContexts; });
/* unused harmony export OutletContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NoPreloading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PreloadAllModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PreloadingStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RouterPreloader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivatedRoute; });
/* unused harmony export ActivatedRouteSnapshot */
/* unused harmony export RouterState */
/* unused harmony export RouterStateSnapshot */
/* unused harmony export PRIMARY_OUTLET */
/* unused harmony export convertToParamMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UrlHandlingStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DefaultUrlSerializer; });
/* unused harmony export UrlSegment */
/* unused harmony export UrlSegmentGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UrlSerializer; });
/* unused harmony export UrlTree */
/* unused harmony export VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return EmptyOutletComponent; });
/* unused harmony export ɵROUTER_PROVIDERS */
/* unused harmony export ɵflatten */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = /*@__PURE__*/__webpack_require__("TToO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = /*@__PURE__*/__webpack_require__("TdOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = /*@__PURE__*/__webpack_require__("0nHL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = /*@__PURE__*/__webpack_require__("Nyrq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_common__ = /*@__PURE__*/__webpack_require__("wTuo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__ = /*@__PURE__*/__webpack_require__("5D2H");
/**
 * @license Angular v6.1.10
 * (c) 2010-2018 Google, Inc. https://angular.io/
 * License: MIT
 */
/** PURE_IMPORTS_START tslib,_angular_core,rxjs,rxjs_operators,_angular_common,_angular_platform_browser PURE_IMPORTS_END */






/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Base for events the Router goes through, as opposed to events tied to a specific
 * Route. `RouterEvent`s will only be fired one time for any given navigation.
 *
 * Example:
 *
 * ```
 * class MyService {
 *   constructor(public router: Router, logger: Logger) {
 *     router.events.filter(e => e instanceof RouterEvent).subscribe(e => {
 *       logger.log(e.id, e.url);
 *     });
 *   }
 * }
 * ```
 *
 * @experimental
 */
var RouterEvent = /*@__PURE__*/ (function () {
    function RouterEvent(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url) {
        this.id = id;
        this.url = url;
    }
    return RouterEvent;
}());
/**
 * @description
 *
 * Represents an event triggered when a navigation starts.
 *
 *
 */
var NavigationStart = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NavigationStart, _super);
    function NavigationStart(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    navigationTrigger, 
    /** @docsNotRequired */
    restoredState) {
        if (navigationTrigger === void 0) {
            /** @docsNotRequired */
            navigationTrigger = 'imperative';
        }
        if (restoredState === void 0) {
            /** @docsNotRequired */
            restoredState = null;
        }
        var _this = _super.call(this, id, url) || this;
        _this.navigationTrigger = navigationTrigger;
        _this.restoredState = restoredState;
        return _this;
    }
    /** @docsNotRequired */
    NavigationStart.prototype.toString = function () { return "NavigationStart(id: " + this.id + ", url: '" + this.url + "')"; };
    return NavigationStart;
}(RouterEvent));
/**
 * @description
 *
 * Represents an event triggered when a navigation ends successfully.
 *
 *
 */
var NavigationEnd = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NavigationEnd, _super);
    function NavigationEnd(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    urlAfterRedirects) {
        var _this = _super.call(this, id, url) || this;
        _this.urlAfterRedirects = urlAfterRedirects;
        return _this;
    }
    /** @docsNotRequired */
    NavigationEnd.prototype.toString = function () {
        return "NavigationEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "')";
    };
    return NavigationEnd;
}(RouterEvent));
/**
 * @description
 *
 * Represents an event triggered when a navigation is canceled.
 *
 *
 */
var NavigationCancel = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NavigationCancel, _super);
    function NavigationCancel(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    reason) {
        var _this = _super.call(this, id, url) || this;
        _this.reason = reason;
        return _this;
    }
    /** @docsNotRequired */
    NavigationCancel.prototype.toString = function () { return "NavigationCancel(id: " + this.id + ", url: '" + this.url + "')"; };
    return NavigationCancel;
}(RouterEvent));
/**
 * @description
 *
 * Represents an event triggered when a navigation fails due to an unexpected error.
 *
 *
 */
var NavigationError = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(NavigationError, _super);
    function NavigationError(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    error) {
        var _this = _super.call(this, id, url) || this;
        _this.error = error;
        return _this;
    }
    /** @docsNotRequired */
    NavigationError.prototype.toString = function () {
        return "NavigationError(id: " + this.id + ", url: '" + this.url + "', error: " + this.error + ")";
    };
    return NavigationError;
}(RouterEvent));
/**
 * @description
 *
 * Represents an event triggered when routes are recognized.
 *
 *
 */
var RoutesRecognized = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(RoutesRecognized, _super);
    function RoutesRecognized(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    urlAfterRedirects, 
    /** @docsNotRequired */
    state) {
        var _this = _super.call(this, id, url) || this;
        _this.urlAfterRedirects = urlAfterRedirects;
        _this.state = state;
        return _this;
    }
    /** @docsNotRequired */
    RoutesRecognized.prototype.toString = function () {
        return "RoutesRecognized(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
    };
    return RoutesRecognized;
}(RouterEvent));
/**
 * @description
 *
 * Represents the start of the Guard phase of routing.
 *
 * @experimental
 */
var GuardsCheckStart = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(GuardsCheckStart, _super);
    function GuardsCheckStart(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    urlAfterRedirects, 
    /** @docsNotRequired */
    state) {
        var _this = _super.call(this, id, url) || this;
        _this.urlAfterRedirects = urlAfterRedirects;
        _this.state = state;
        return _this;
    }
    GuardsCheckStart.prototype.toString = function () {
        return "GuardsCheckStart(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
    };
    return GuardsCheckStart;
}(RouterEvent));
/**
 * @description
 *
 * Represents the end of the Guard phase of routing.
 *
 * @experimental
 */
var GuardsCheckEnd = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(GuardsCheckEnd, _super);
    function GuardsCheckEnd(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    urlAfterRedirects, 
    /** @docsNotRequired */
    state, 
    /** @docsNotRequired */
    shouldActivate) {
        var _this = _super.call(this, id, url) || this;
        _this.urlAfterRedirects = urlAfterRedirects;
        _this.state = state;
        _this.shouldActivate = shouldActivate;
        return _this;
    }
    GuardsCheckEnd.prototype.toString = function () {
        return "GuardsCheckEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ", shouldActivate: " + this.shouldActivate + ")";
    };
    return GuardsCheckEnd;
}(RouterEvent));
/**
 * @description
 *
 * Represents the start of the Resolve phase of routing. The timing of this
 * event may change, thus it's experimental. In the current iteration it will run
 * in the "resolve" phase whether there's things to resolve or not. In the future this
 * behavior may change to only run when there are things to be resolved.
 *
 * @experimental
 */
var ResolveStart = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ResolveStart, _super);
    function ResolveStart(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    urlAfterRedirects, 
    /** @docsNotRequired */
    state) {
        var _this = _super.call(this, id, url) || this;
        _this.urlAfterRedirects = urlAfterRedirects;
        _this.state = state;
        return _this;
    }
    ResolveStart.prototype.toString = function () {
        return "ResolveStart(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
    };
    return ResolveStart;
}(RouterEvent));
/**
 * @description
 *
 * Represents the end of the Resolve phase of routing. See note on
 * `ResolveStart` for use of this experimental API.
 *
 * @experimental
 */
var ResolveEnd = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ResolveEnd, _super);
    function ResolveEnd(
    /** @docsNotRequired */
    id, 
    /** @docsNotRequired */
    url, 
    /** @docsNotRequired */
    urlAfterRedirects, 
    /** @docsNotRequired */
    state) {
        var _this = _super.call(this, id, url) || this;
        _this.urlAfterRedirects = urlAfterRedirects;
        _this.state = state;
        return _this;
    }
    ResolveEnd.prototype.toString = function () {
        return "ResolveEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
    };
    return ResolveEnd;
}(RouterEvent));
/**
 * @description
 *
 * Represents an event triggered before lazy loading a route config.
 *
 * @experimental
 */
var RouteConfigLoadStart = /*@__PURE__*/ (function () {
    function RouteConfigLoadStart(
    /** @docsNotRequired */
    route) {
        this.route = route;
    }
    RouteConfigLoadStart.prototype.toString = function () { return "RouteConfigLoadStart(path: " + this.route.path + ")"; };
    return RouteConfigLoadStart;
}());
/**
 * @description
 *
 * Represents an event triggered when a route has been lazy loaded.
 *
 * @experimental
 */
var RouteConfigLoadEnd = /*@__PURE__*/ (function () {
    function RouteConfigLoadEnd(
    /** @docsNotRequired */
    route) {
        this.route = route;
    }
    RouteConfigLoadEnd.prototype.toString = function () { return "RouteConfigLoadEnd(path: " + this.route.path + ")"; };
    return RouteConfigLoadEnd;
}());
/**
 * @description
 *
 * Represents the start of end of the Resolve phase of routing. See note on
 * `ChildActivationEnd` for use of this experimental API.
 *
 * @experimental
 */
var ChildActivationStart = /*@__PURE__*/ (function () {
    function ChildActivationStart(
    /** @docsNotRequired */
    snapshot) {
        this.snapshot = snapshot;
    }
    ChildActivationStart.prototype.toString = function () {
        var path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
        return "ChildActivationStart(path: '" + path + "')";
    };
    return ChildActivationStart;
}());
/**
 * @description
 *
 * Represents the start of end of the Resolve phase of routing. See note on
 * `ChildActivationStart` for use of this experimental API.
 *
 * @experimental
 */
var ChildActivationEnd = /*@__PURE__*/ (function () {
    function ChildActivationEnd(
    /** @docsNotRequired */
    snapshot) {
        this.snapshot = snapshot;
    }
    ChildActivationEnd.prototype.toString = function () {
        var path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
        return "ChildActivationEnd(path: '" + path + "')";
    };
    return ChildActivationEnd;
}());
/**
 * @description
 *
 * Represents the start of end of the Resolve phase of routing. See note on
 * `ActivationEnd` for use of this experimental API.
 *
 * @experimental
 */
var ActivationStart = /*@__PURE__*/ (function () {
    function ActivationStart(
    /** @docsNotRequired */
    snapshot) {
        this.snapshot = snapshot;
    }
    ActivationStart.prototype.toString = function () {
        var path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
        return "ActivationStart(path: '" + path + "')";
    };
    return ActivationStart;
}());
/**
 * @description
 *
 * Represents the start of end of the Resolve phase of routing. See note on
 * `ActivationStart` for use of this experimental API.
 *
 * @experimental
 */
var ActivationEnd = /*@__PURE__*/ (function () {
    function ActivationEnd(
    /** @docsNotRequired */
    snapshot) {
        this.snapshot = snapshot;
    }
    ActivationEnd.prototype.toString = function () {
        var path = this.snapshot.routeConfig && this.snapshot.routeConfig.path || '';
        return "ActivationEnd(path: '" + path + "')";
    };
    return ActivationEnd;
}());
/**
 * @description
 *
 * Represents a scrolling event.
 */
var Scroll = /*@__PURE__*/ (function () {
    function Scroll(
    /** @docsNotRequired */
    routerEvent, 
    /** @docsNotRequired */
    position, 
    /** @docsNotRequired */
    anchor) {
        this.routerEvent = routerEvent;
        this.position = position;
        this.anchor = anchor;
    }
    Scroll.prototype.toString = function () {
        var pos = this.position ? this.position[0] + ", " + this.position[1] : null;
        return "Scroll(anchor: '" + this.anchor + "', position: '" + pos + "')";
    };
    return Scroll;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This component is used internally within the router to be a placeholder when an empty
 * router-outlet is needed. For example, with a config such as:
 *
 * `{path: 'parent', outlet: 'nav', children: [...]}`
 *
 * In order to render, there needs to be a component on this config, which will default
 * to this `EmptyOutletComponent`.
 */
var EmptyOutletComponent = /*@__PURE__*/ (function () {
    function EmptyOutletComponent() {
    }
    return EmptyOutletComponent;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Name of the primary outlet.
 *
 *
 */
var PRIMARY_OUTLET = 'primary';
var ParamsAsMap = /*@__PURE__*/ (function () {
    function ParamsAsMap(params) {
        this.params = params || {};
    }
    ParamsAsMap.prototype.has = function (name) { return this.params.hasOwnProperty(name); };
    ParamsAsMap.prototype.get = function (name) {
        if (this.has(name)) {
            var v = this.params[name];
            return Array.isArray(v) ? v[0] : v;
        }
        return null;
    };
    ParamsAsMap.prototype.getAll = function (name) {
        if (this.has(name)) {
            var v = this.params[name];
            return Array.isArray(v) ? v : [v];
        }
        return [];
    };
    Object.defineProperty(ParamsAsMap.prototype, "keys", {
        get: function () { return Object.keys(this.params); },
        enumerable: true,
        configurable: true
    });
    return ParamsAsMap;
}());
/**
 * Convert a `Params` instance to a `ParamMap`.
 *
 *
 */
function convertToParamMap(params) {
    return new ParamsAsMap(params);
}
var NAVIGATION_CANCELING_ERROR = 'ngNavigationCancelingError';
function navigationCancelingError(message) {
    var error = Error('NavigationCancelingError: ' + message);
    error[NAVIGATION_CANCELING_ERROR] = true;
    return error;
}
function isNavigationCancelingError(error) {
    return error && error[NAVIGATION_CANCELING_ERROR];
}
// Matches the route configuration (`route`) against the actual URL (`segments`).
function defaultUrlMatcher(segments, segmentGroup, route) {
    var parts = route.path.split('/');
    if (parts.length > segments.length) {
        // The actual URL is shorter than the config, no match
        return null;
    }
    if (route.pathMatch === 'full' &&
        (segmentGroup.hasChildren() || parts.length < segments.length)) {
        // The config is longer than the actual URL but we are looking for a full match, return null
        return null;
    }
    var posParams = {};
    // Check each config part against the actual URL
    for (var index = 0; index < parts.length; index++) {
        var part = parts[index];
        var segment = segments[index];
        var isParameter = part.startsWith(':');
        if (isParameter) {
            posParams[part.substring(1)] = segment;
        }
        else if (part !== segment.path) {
            // The actual URL part does not match the config, no match
            return null;
        }
    }
    return { consumed: segments.slice(0, parts.length), posParams: posParams };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var LoadedRouterConfig = /*@__PURE__*/ (function () {
    function LoadedRouterConfig(routes, module) {
        this.routes = routes;
        this.module = module;
    }
    return LoadedRouterConfig;
}());
function validateConfig(config, parentPath) {
    if (parentPath === void 0) {
        parentPath = '';
    }
    // forEach doesn't iterate undefined values
    for (var i = 0; i < config.length; i++) {
        var route = config[i];
        var fullPath = getFullPath(parentPath, route);
        validateNode(route, fullPath);
    }
}
function validateNode(route, fullPath) {
    if (!route) {
        throw new Error("\n      Invalid configuration of route '" + fullPath + "': Encountered undefined route.\n      The reason might be an extra comma.\n\n      Example:\n      const routes: Routes = [\n        { path: '', redirectTo: '/dashboard', pathMatch: 'full' },\n        { path: 'dashboard',  component: DashboardComponent },, << two commas\n        { path: 'detail/:id', component: HeroDetailComponent }\n      ];\n    ");
    }
    if (Array.isArray(route)) {
        throw new Error("Invalid configuration of route '" + fullPath + "': Array cannot be specified");
    }
    if (!route.component && !route.children && !route.loadChildren &&
        (route.outlet && route.outlet !== PRIMARY_OUTLET)) {
        throw new Error("Invalid configuration of route '" + fullPath + "': a componentless route without children or loadChildren cannot have a named outlet set");
    }
    if (route.redirectTo && route.children) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and children cannot be used together");
    }
    if (route.redirectTo && route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and loadChildren cannot be used together");
    }
    if (route.children && route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "': children and loadChildren cannot be used together");
    }
    if (route.redirectTo && route.component) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and component cannot be used together");
    }
    if (route.path && route.matcher) {
        throw new Error("Invalid configuration of route '" + fullPath + "': path and matcher cannot be used together");
    }
    if (route.redirectTo === void 0 && !route.component && !route.children && !route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "'. One of the following must be provided: component, redirectTo, children or loadChildren");
    }
    if (route.path === void 0 && route.matcher === void 0) {
        throw new Error("Invalid configuration of route '" + fullPath + "': routes must have either a path or a matcher specified");
    }
    if (typeof route.path === 'string' && route.path.charAt(0) === '/') {
        throw new Error("Invalid configuration of route '" + fullPath + "': path cannot start with a slash");
    }
    if (route.path === '' && route.redirectTo !== void 0 && route.pathMatch === void 0) {
        var exp = "The default value of 'pathMatch' is 'prefix', but often the intent is to use 'full'.";
        throw new Error("Invalid configuration of route '{path: \"" + fullPath + "\", redirectTo: \"" + route.redirectTo + "\"}': please provide 'pathMatch'. " + exp);
    }
    if (route.pathMatch !== void 0 && route.pathMatch !== 'full' && route.pathMatch !== 'prefix') {
        throw new Error("Invalid configuration of route '" + fullPath + "': pathMatch can only be set to 'prefix' or 'full'");
    }
    if (route.children) {
        validateConfig(route.children, fullPath);
    }
}
function getFullPath(parentPath, currentRoute) {
    if (!currentRoute) {
        return parentPath;
    }
    if (!parentPath && !currentRoute.path) {
        return '';
    }
    else if (parentPath && !currentRoute.path) {
        return parentPath + "/";
    }
    else if (!parentPath && currentRoute.path) {
        return currentRoute.path;
    }
    else {
        return parentPath + "/" + currentRoute.path;
    }
}
/**
 * Makes a copy of the config and adds any default required properties.
 */
function standardizeConfig(r) {
    var children = r.children && r.children.map(standardizeConfig);
    var c = children ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, r, { children: children }) : Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, r);
    if (!c.component && (children || c.loadChildren) && (c.outlet && c.outlet !== PRIMARY_OUTLET)) {
        c.component = EmptyOutletComponent;
    }
    return c;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function shallowEqualArrays(a, b) {
    if (a.length !== b.length)
        return false;
    for (var i = 0; i < a.length; ++i) {
        if (!shallowEqual(a[i], b[i]))
            return false;
    }
    return true;
}
function shallowEqual(a, b) {
    var k1 = Object.keys(a);
    var k2 = Object.keys(b);
    if (k1.length != k2.length) {
        return false;
    }
    var key;
    for (var i = 0; i < k1.length; i++) {
        key = k1[i];
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
/**
 * Flattens single-level nested arrays.
 */
function flatten(arr) {
    return Array.prototype.concat.apply([], arr);
}
/**
 * Return the last element of an array.
 */
function last$1(a) {
    return a.length > 0 ? a[a.length - 1] : null;
}
function forEach(map$$1, callback) {
    for (var prop in map$$1) {
        if (map$$1.hasOwnProperty(prop)) {
            callback(map$$1[prop], prop);
        }
    }
}
function waitForMap(obj, fn) {
    if (Object.keys(obj).length === 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])({});
    }
    var waitHead = [];
    var waitTail = [];
    var res = {};
    forEach(obj, function (a, k) {
        var mapped = fn(k, a).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (r) { return res[k] = r; }));
        if (k === PRIMARY_OUTLET) {
            waitHead.push(mapped);
        }
        else {
            waitTail.push(mapped);
        }
    });
    // Closure compiler has problem with using spread operator here. So just using Array.concat.
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */].apply(null, waitHead.concat(waitTail)).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["concatAll"])(), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["last"])(), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function () { return res; }));
}
/**
 * ANDs Observables by merging all input observables, reducing to an Observable verifying all
 * input Observables return `true`.
 */
function andObservables(observables) {
    return observables.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeAll"])(), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["every"])(function (result) { return result === true; }));
}
function wrapIntoObservable(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisObservable"])(value)) {
        return value;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisPromise"])(value)) {
        // Use `Promise.resolve()` to wrap promise-like instances.
        // Required ie when a Resolver returns a AngularJS `$q` promise to correctly trigger the
        // change detection.
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(Promise.resolve(value));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(value);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function createEmptyUrlTree() {
    return new UrlTree(new UrlSegmentGroup([], {}), {}, null);
}
function containsTree(container, containee, exact) {
    if (exact) {
        return equalQueryParams(container.queryParams, containee.queryParams) &&
            equalSegmentGroups(container.root, containee.root);
    }
    return containsQueryParams(container.queryParams, containee.queryParams) &&
        containsSegmentGroup(container.root, containee.root);
}
function equalQueryParams(container, containee) {
    // TODO: This does not handle array params correctly.
    return shallowEqual(container, containee);
}
function equalSegmentGroups(container, containee) {
    if (!equalPath(container.segments, containee.segments))
        return false;
    if (container.numberOfChildren !== containee.numberOfChildren)
        return false;
    for (var c in containee.children) {
        if (!container.children[c])
            return false;
        if (!equalSegmentGroups(container.children[c], containee.children[c]))
            return false;
    }
    return true;
}
function containsQueryParams(container, containee) {
    // TODO: This does not handle array params correctly.
    return Object.keys(containee).length <= Object.keys(container).length &&
        Object.keys(containee).every(function (key) { return containee[key] === container[key]; });
}
function containsSegmentGroup(container, containee) {
    return containsSegmentGroupHelper(container, containee, containee.segments);
}
function containsSegmentGroupHelper(container, containee, containeePaths) {
    if (container.segments.length > containeePaths.length) {
        var current = container.segments.slice(0, containeePaths.length);
        if (!equalPath(current, containeePaths))
            return false;
        if (containee.hasChildren())
            return false;
        return true;
    }
    else if (container.segments.length === containeePaths.length) {
        if (!equalPath(container.segments, containeePaths))
            return false;
        for (var c in containee.children) {
            if (!container.children[c])
                return false;
            if (!containsSegmentGroup(container.children[c], containee.children[c]))
                return false;
        }
        return true;
    }
    else {
        var current = containeePaths.slice(0, container.segments.length);
        var next = containeePaths.slice(container.segments.length);
        if (!equalPath(container.segments, current))
            return false;
        if (!container.children[PRIMARY_OUTLET])
            return false;
        return containsSegmentGroupHelper(container.children[PRIMARY_OUTLET], containee, next);
    }
}
/**
 * @description
 *
 * Represents the parsed URL.
 *
 * Since a router state is a tree, and the URL is nothing but a serialized state, the URL is a
 * serialized tree.
 * UrlTree is a data structure that provides a lot of affordances in dealing with URLs
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * @Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const tree: UrlTree =
 *       router.parseUrl('/team/33/(user/victor//support:help)?debug=true#fragment');
 *     const f = tree.fragment; // return 'fragment'
 *     const q = tree.queryParams; // returns {debug: 'true'}
 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
 *     const s: UrlSegment[] = g.segments; // returns 2 segments 'team' and '33'
 *     g.children[PRIMARY_OUTLET].segments; // returns 2 segments 'user' and 'victor'
 *     g.children['support'].segments; // return 1 segment 'help'
 *   }
 * }
 * ```
 *
 *
 */
var UrlTree = /*@__PURE__*/ (function () {
    /** @internal */
    function UrlTree(
    /** The root segment group of the URL tree */
    root, 
    /** The query params of the URL */
    queryParams, 
    /** The fragment of the URL */
    fragment) {
        this.root = root;
        this.queryParams = queryParams;
        this.fragment = fragment;
    }
    Object.defineProperty(UrlTree.prototype, "queryParamMap", {
        get: function () {
            if (!this._queryParamMap) {
                this._queryParamMap = convertToParamMap(this.queryParams);
            }
            return this._queryParamMap;
        },
        enumerable: true,
        configurable: true
    });
    /** @docsNotRequired */
    UrlTree.prototype.toString = function () { return DEFAULT_SERIALIZER.serialize(this); };
    return UrlTree;
}());
/**
 * @description
 *
 * Represents the parsed URL segment group.
 *
 * See `UrlTree` for more information.
 *
 *
 */
var UrlSegmentGroup = /*@__PURE__*/ (function () {
    function UrlSegmentGroup(
    /** The URL segments of this group. See `UrlSegment` for more information */
    segments, 
    /** The list of children of this group */
    children) {
        var _this = this;
        this.segments = segments;
        this.children = children;
        /** The parent node in the url tree */
        this.parent = null;
        forEach(children, function (v, k) { return v.parent = _this; });
    }
    /** Whether the segment has child segments */
    UrlSegmentGroup.prototype.hasChildren = function () { return this.numberOfChildren > 0; };
    Object.defineProperty(UrlSegmentGroup.prototype, "numberOfChildren", {
        /** Number of child segments */
        get: function () { return Object.keys(this.children).length; },
        enumerable: true,
        configurable: true
    });
    /** @docsNotRequired */
    UrlSegmentGroup.prototype.toString = function () { return serializePaths(this); };
    return UrlSegmentGroup;
}());
/**
 * @description
 *
 * Represents a single URL segment.
 *
 * A UrlSegment is a part of a URL between the two slashes. It contains a path and the matrix
 * parameters associated with the segment.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * @Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const tree: UrlTree = router.parseUrl('/team;id=33');
 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
 *     const s: UrlSegment[] = g.segments;
 *     s[0].path; // returns 'team'
 *     s[0].parameters; // returns {id: 33}
 *   }
 * }
 * ```
 *
 *
 */
var UrlSegment = /*@__PURE__*/ (function () {
    function UrlSegment(
    /** The path part of a URL segment */
    path, 
    /** The matrix parameters associated with a segment */
    parameters) {
        this.path = path;
        this.parameters = parameters;
    }
    Object.defineProperty(UrlSegment.prototype, "parameterMap", {
        get: function () {
            if (!this._parameterMap) {
                this._parameterMap = convertToParamMap(this.parameters);
            }
            return this._parameterMap;
        },
        enumerable: true,
        configurable: true
    });
    /** @docsNotRequired */
    UrlSegment.prototype.toString = function () { return serializePath(this); };
    return UrlSegment;
}());
function equalSegments(as, bs) {
    return equalPath(as, bs) && as.every(function (a, i) { return shallowEqual(a.parameters, bs[i].parameters); });
}
function equalPath(as, bs) {
    if (as.length !== bs.length)
        return false;
    return as.every(function (a, i) { return a.path === bs[i].path; });
}
function mapChildrenIntoArray(segment, fn) {
    var res = [];
    forEach(segment.children, function (child, childOutlet) {
        if (childOutlet === PRIMARY_OUTLET) {
            res = res.concat(fn(child, childOutlet));
        }
    });
    forEach(segment.children, function (child, childOutlet) {
        if (childOutlet !== PRIMARY_OUTLET) {
            res = res.concat(fn(child, childOutlet));
        }
    });
    return res;
}
/**
 * @description
 *
 * Serializes and deserializes a URL string into a URL tree.
 *
 * The url serialization strategy is customizable. You can
 * make all URLs case insensitive by providing a custom UrlSerializer.
 *
 * See `DefaultUrlSerializer` for an example of a URL serializer.
 *
 *
 */
var UrlSerializer = /*@__PURE__*/ (function () {
    function UrlSerializer() {
    }
    return UrlSerializer;
}());
/**
 * @description
 *
 * A default implementation of the `UrlSerializer`.
 *
 * Example URLs:
 *
 * ```
 * /inbox/33(popup:compose)
 * /inbox/33;open=true/messages/44
 * ```
 *
 * DefaultUrlSerializer uses parentheses to serialize secondary segments (e.g., popup:compose), the
 * colon syntax to specify the outlet, and the ';parameter=value' syntax (e.g., open=true) to
 * specify route specific parameters.
 *
 *
 */
var DefaultUrlSerializer = /*@__PURE__*/ (function () {
    function DefaultUrlSerializer() {
    }
    /** Parses a url into a `UrlTree` */
    DefaultUrlSerializer.prototype.parse = function (url) {
        var p = new UrlParser(url);
        return new UrlTree(p.parseRootSegment(), p.parseQueryParams(), p.parseFragment());
    };
    /** Converts a `UrlTree` into a url */
    DefaultUrlSerializer.prototype.serialize = function (tree) {
        var segment = "/" + serializeSegment(tree.root, true);
        var query = serializeQueryParams(tree.queryParams);
        var fragment = typeof tree.fragment === "string" ? "#" + encodeUriFragment(tree.fragment) : '';
        return "" + segment + query + fragment;
    };
    return DefaultUrlSerializer;
}());
var DEFAULT_SERIALIZER = /*@__PURE__*/ new DefaultUrlSerializer();
function serializePaths(segment) {
    return segment.segments.map(function (p) { return serializePath(p); }).join('/');
}
function serializeSegment(segment, root) {
    if (!segment.hasChildren()) {
        return serializePaths(segment);
    }
    if (root) {
        var primary = segment.children[PRIMARY_OUTLET] ?
            serializeSegment(segment.children[PRIMARY_OUTLET], false) :
            '';
        var children_1 = [];
        forEach(segment.children, function (v, k) {
            if (k !== PRIMARY_OUTLET) {
                children_1.push(k + ":" + serializeSegment(v, false));
            }
        });
        return children_1.length > 0 ? primary + "(" + children_1.join('//') + ")" : primary;
    }
    else {
        var children = mapChildrenIntoArray(segment, function (v, k) {
            if (k === PRIMARY_OUTLET) {
                return [serializeSegment(segment.children[PRIMARY_OUTLET], false)];
            }
            return [k + ":" + serializeSegment(v, false)];
        });
        return serializePaths(segment) + "/(" + children.join('//') + ")";
    }
}
/**
 * Encodes a URI string with the default encoding. This function will only ever be called from
 * `encodeUriQuery` or `encodeUriSegment` as it's the base set of encodings to be used. We need
 * a custom encoding because encodeURIComponent is too aggressive and encodes stuff that doesn't
 * have to be encoded per https://url.spec.whatwg.org.
 */
function encodeUriString(s) {
    return encodeURIComponent(s)
        .replace(/%40/g, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/g, '$')
        .replace(/%2C/gi, ',');
}
/**
 * This function should be used to encode both keys and values in a query string key/value. In
 * the following URL, you need to call encodeUriQuery on "k" and "v":
 *
 * http://www.site.org/html;mk=mv?k=v#f
 */
function encodeUriQuery(s) {
    return encodeUriString(s).replace(/%3B/gi, ';');
}
/**
 * This function should be used to encode a URL fragment. In the following URL, you need to call
 * encodeUriFragment on "f":
 *
 * http://www.site.org/html;mk=mv?k=v#f
 */
function encodeUriFragment(s) {
    return encodeURI(s);
}
/**
 * This function should be run on any URI segment as well as the key and value in a key/value
 * pair for matrix params. In the following URL, you need to call encodeUriSegment on "html",
 * "mk", and "mv":
 *
 * http://www.site.org/html;mk=mv?k=v#f
 */
function encodeUriSegment(s) {
    return encodeUriString(s).replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/%26/gi, '&');
}
function decode(s) {
    return decodeURIComponent(s);
}
// Query keys/values should have the "+" replaced first, as "+" in a query string is " ".
// decodeURIComponent function will not decode "+" as a space.
function decodeQuery(s) {
    return decode(s.replace(/\+/g, '%20'));
}
function serializePath(path) {
    return "" + encodeUriSegment(path.path) + serializeMatrixParams(path.parameters);
}
function serializeMatrixParams(params) {
    return Object.keys(params)
        .map(function (key) { return ";" + encodeUriSegment(key) + "=" + encodeUriSegment(params[key]); })
        .join('');
}
function serializeQueryParams(params) {
    var strParams = Object.keys(params).map(function (name) {
        var value = params[name];
        return Array.isArray(value) ?
            value.map(function (v) { return encodeUriQuery(name) + "=" + encodeUriQuery(v); }).join('&') :
            encodeUriQuery(name) + "=" + encodeUriQuery(value);
    });
    return strParams.length ? "?" + strParams.join("&") : '';
}
var SEGMENT_RE = /^[^\/()?;=#]+/;
function matchSegments(str) {
    var match = str.match(SEGMENT_RE);
    return match ? match[0] : '';
}
var QUERY_PARAM_RE = /^[^=?&#]+/;
// Return the name of the query param at the start of the string or an empty string
function matchQueryParams(str) {
    var match = str.match(QUERY_PARAM_RE);
    return match ? match[0] : '';
}
var QUERY_PARAM_VALUE_RE = /^[^?&#]+/;
// Return the value of the query param at the start of the string or an empty string
function matchUrlQueryParamValue(str) {
    var match = str.match(QUERY_PARAM_VALUE_RE);
    return match ? match[0] : '';
}
var UrlParser = /*@__PURE__*/ (function () {
    function UrlParser(url) {
        this.url = url;
        this.remaining = url;
    }
    UrlParser.prototype.parseRootSegment = function () {
        this.consumeOptional('/');
        if (this.remaining === '' || this.peekStartsWith('?') || this.peekStartsWith('#')) {
            return new UrlSegmentGroup([], {});
        }
        // The root segment group never has segments
        return new UrlSegmentGroup([], this.parseChildren());
    };
    UrlParser.prototype.parseQueryParams = function () {
        var params = {};
        if (this.consumeOptional('?')) {
            do {
                this.parseQueryParam(params);
            } while (this.consumeOptional('&'));
        }
        return params;
    };
    UrlParser.prototype.parseFragment = function () {
        return this.consumeOptional('#') ? decodeURIComponent(this.remaining) : null;
    };
    UrlParser.prototype.parseChildren = function () {
        if (this.remaining === '') {
            return {};
        }
        this.consumeOptional('/');
        var segments = [];
        if (!this.peekStartsWith('(')) {
            segments.push(this.parseSegment());
        }
        while (this.peekStartsWith('/') && !this.peekStartsWith('//') && !this.peekStartsWith('/(')) {
            this.capture('/');
            segments.push(this.parseSegment());
        }
        var children = {};
        if (this.peekStartsWith('/(')) {
            this.capture('/');
            children = this.parseParens(true);
        }
        var res = {};
        if (this.peekStartsWith('(')) {
            res = this.parseParens(false);
        }
        if (segments.length > 0 || Object.keys(children).length > 0) {
            res[PRIMARY_OUTLET] = new UrlSegmentGroup(segments, children);
        }
        return res;
    };
    // parse a segment with its matrix parameters
    // ie `name;k1=v1;k2`
    UrlParser.prototype.parseSegment = function () {
        var path = matchSegments(this.remaining);
        if (path === '' && this.peekStartsWith(';')) {
            throw new Error("Empty path url segment cannot have parameters: '" + this.remaining + "'.");
        }
        this.capture(path);
        return new UrlSegment(decode(path), this.parseMatrixParams());
    };
    UrlParser.prototype.parseMatrixParams = function () {
        var params = {};
        while (this.consumeOptional(';')) {
            this.parseParam(params);
        }
        return params;
    };
    UrlParser.prototype.parseParam = function (params) {
        var key = matchSegments(this.remaining);
        if (!key) {
            return;
        }
        this.capture(key);
        var value = '';
        if (this.consumeOptional('=')) {
            var valueMatch = matchSegments(this.remaining);
            if (valueMatch) {
                value = valueMatch;
                this.capture(value);
            }
        }
        params[decode(key)] = decode(value);
    };
    // Parse a single query parameter `name[=value]`
    UrlParser.prototype.parseQueryParam = function (params) {
        var key = matchQueryParams(this.remaining);
        if (!key) {
            return;
        }
        this.capture(key);
        var value = '';
        if (this.consumeOptional('=')) {
            var valueMatch = matchUrlQueryParamValue(this.remaining);
            if (valueMatch) {
                value = valueMatch;
                this.capture(value);
            }
        }
        var decodedKey = decodeQuery(key);
        var decodedVal = decodeQuery(value);
        if (params.hasOwnProperty(decodedKey)) {
            // Append to existing values
            var currentVal = params[decodedKey];
            if (!Array.isArray(currentVal)) {
                currentVal = [currentVal];
                params[decodedKey] = currentVal;
            }
            currentVal.push(decodedVal);
        }
        else {
            // Create a new value
            params[decodedKey] = decodedVal;
        }
    };
    // parse `(a/b//outlet_name:c/d)`
    UrlParser.prototype.parseParens = function (allowPrimary) {
        var segments = {};
        this.capture('(');
        while (!this.consumeOptional(')') && this.remaining.length > 0) {
            var path = matchSegments(this.remaining);
            var next = this.remaining[path.length];
            // if is is not one of these characters, then the segment was unescaped
            // or the group was not closed
            if (next !== '/' && next !== ')' && next !== ';') {
                throw new Error("Cannot parse url '" + this.url + "'");
            }
            var outletName = undefined;
            if (path.indexOf(':') > -1) {
                outletName = path.substr(0, path.indexOf(':'));
                this.capture(outletName);
                this.capture(':');
            }
            else if (allowPrimary) {
                outletName = PRIMARY_OUTLET;
            }
            var children = this.parseChildren();
            segments[outletName] = Object.keys(children).length === 1 ? children[PRIMARY_OUTLET] :
                new UrlSegmentGroup([], children);
            this.consumeOptional('//');
        }
        return segments;
    };
    UrlParser.prototype.peekStartsWith = function (str) { return this.remaining.startsWith(str); };
    // Consumes the prefix when it is present and returns whether it has been consumed
    UrlParser.prototype.consumeOptional = function (str) {
        if (this.peekStartsWith(str)) {
            this.remaining = this.remaining.substring(str.length);
            return true;
        }
        return false;
    };
    UrlParser.prototype.capture = function (str) {
        if (!this.consumeOptional(str)) {
            throw new Error("Expected \"" + str + "\".");
        }
    };
    return UrlParser;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NoMatch = /*@__PURE__*/ (function () {
    function NoMatch(segmentGroup) {
        this.segmentGroup = segmentGroup || null;
    }
    return NoMatch;
}());
var AbsoluteRedirect = /*@__PURE__*/ (function () {
    function AbsoluteRedirect(urlTree) {
        this.urlTree = urlTree;
    }
    return AbsoluteRedirect;
}());
function noMatch(segmentGroup) {
    return new __WEBPACK_IMPORTED_MODULE_2_rxjs__["d" /* Observable */](function (obs) { return obs.error(new NoMatch(segmentGroup)); });
}
function absoluteRedirect(newTree) {
    return new __WEBPACK_IMPORTED_MODULE_2_rxjs__["d" /* Observable */](function (obs) { return obs.error(new AbsoluteRedirect(newTree)); });
}
function namedOutletsRedirect(redirectTo) {
    return new __WEBPACK_IMPORTED_MODULE_2_rxjs__["d" /* Observable */](function (obs) { return obs.error(new Error("Only absolute redirects can have named outlets. redirectTo: '" + redirectTo + "'")); });
}
function canLoadFails(route) {
    return new __WEBPACK_IMPORTED_MODULE_2_rxjs__["d" /* Observable */](function (obs) { return obs.error(navigationCancelingError("Cannot load children because the guard of the route \"path: '" + route.path + "'\" returned false")); });
}
/**
 * Returns the `UrlTree` with the redirection applied.
 *
 * Lazy modules are loaded along the way.
 */
function applyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config) {
    return new ApplyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config).apply();
}
var ApplyRedirects = /*@__PURE__*/ (function () {
    function ApplyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config) {
        this.configLoader = configLoader;
        this.urlSerializer = urlSerializer;
        this.urlTree = urlTree;
        this.config = config;
        this.allowRedirects = true;
        this.ngModule = moduleInjector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleRef"]);
    }
    ApplyRedirects.prototype.apply = function () {
        var _this = this;
        var expanded$ = this.expandSegmentGroup(this.ngModule, this.config, this.urlTree.root, PRIMARY_OUTLET);
        var urlTrees$ = expanded$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (rootSegmentGroup) { return _this.createUrlTree(rootSegmentGroup, _this.urlTree.queryParams, _this.urlTree.fragment); }));
        return urlTrees$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["catchError"])(function (e) {
            if (e instanceof AbsoluteRedirect) {
                // after an absolute redirect we do not apply any more redirects!
                _this.allowRedirects = false;
                // we need to run matching, so we can fetch all lazy-loaded modules
                return _this.match(e.urlTree);
            }
            if (e instanceof NoMatch) {
                throw _this.noMatchError(e);
            }
            throw e;
        }));
    };
    ApplyRedirects.prototype.match = function (tree) {
        var _this = this;
        var expanded$ = this.expandSegmentGroup(this.ngModule, this.config, tree.root, PRIMARY_OUTLET);
        var mapped$ = expanded$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (rootSegmentGroup) {
            return _this.createUrlTree(rootSegmentGroup, tree.queryParams, tree.fragment);
        }));
        return mapped$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["catchError"])(function (e) {
            if (e instanceof NoMatch) {
                throw _this.noMatchError(e);
            }
            throw e;
        }));
    };
    ApplyRedirects.prototype.noMatchError = function (e) {
        return new Error("Cannot match any routes. URL Segment: '" + e.segmentGroup + "'");
    };
    ApplyRedirects.prototype.createUrlTree = function (rootCandidate, queryParams, fragment) {
        var _a;
        var root = rootCandidate.segments.length > 0 ?
            new UrlSegmentGroup([], (_a = {}, _a[PRIMARY_OUTLET] = rootCandidate, _a)) :
            rootCandidate;
        return new UrlTree(root, queryParams, fragment);
    };
    ApplyRedirects.prototype.expandSegmentGroup = function (ngModule, routes, segmentGroup, outlet) {
        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
            return this.expandChildren(ngModule, routes, segmentGroup)
                .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (children) { return new UrlSegmentGroup([], children); }));
        }
        return this.expandSegment(ngModule, segmentGroup, routes, segmentGroup.segments, outlet, true);
    };
    // Recursively expand segment groups for all the child outlets
    ApplyRedirects.prototype.expandChildren = function (ngModule, routes, segmentGroup) {
        var _this = this;
        return waitForMap(segmentGroup.children, function (childOutlet, child) { return _this.expandSegmentGroup(ngModule, routes, child, childOutlet); });
    };
    ApplyRedirects.prototype.expandSegment = function (ngModule, segmentGroup, routes, segments, outlet, allowRedirects) {
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */].apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(routes)).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (r) {
            var expanded$ = _this.expandSegmentAgainstRoute(ngModule, segmentGroup, routes, r, segments, outlet, allowRedirects);
            return expanded$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["catchError"])(function (e) {
                if (e instanceof NoMatch) {
                    // TODO(i): this return type doesn't match the declared Observable<UrlSegmentGroup> -
                    // talk to Jason
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(null);
                }
                throw e;
            }));
        }), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["concatAll"])(), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["first"])(function (s) { return !!s; }), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["catchError"])(function (e, _) {
            if (e instanceof __WEBPACK_IMPORTED_MODULE_2_rxjs__["b" /* EmptyError */] || e.name === 'EmptyError') {
                if (_this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(new UrlSegmentGroup([], {}));
                }
                throw new NoMatch(segmentGroup);
            }
            throw e;
        }));
    };
    ApplyRedirects.prototype.noLeftoversInUrl = function (segmentGroup, segments, outlet) {
        return segments.length === 0 && !segmentGroup.children[outlet];
    };
    ApplyRedirects.prototype.expandSegmentAgainstRoute = function (ngModule, segmentGroup, routes, route, paths, outlet, allowRedirects) {
        if (getOutlet(route) !== outlet) {
            return noMatch(segmentGroup);
        }
        if (route.redirectTo === undefined) {
            return this.matchSegmentAgainstRoute(ngModule, segmentGroup, route, paths);
        }
        if (allowRedirects && this.allowRedirects) {
            return this.expandSegmentAgainstRouteUsingRedirect(ngModule, segmentGroup, routes, route, paths, outlet);
        }
        return noMatch(segmentGroup);
    };
    ApplyRedirects.prototype.expandSegmentAgainstRouteUsingRedirect = function (ngModule, segmentGroup, routes, route, segments, outlet) {
        if (route.path === '**') {
            return this.expandWildCardWithParamsAgainstRouteUsingRedirect(ngModule, routes, route, outlet);
        }
        return this.expandRegularSegmentAgainstRouteUsingRedirect(ngModule, segmentGroup, routes, route, segments, outlet);
    };
    ApplyRedirects.prototype.expandWildCardWithParamsAgainstRouteUsingRedirect = function (ngModule, routes, route, outlet) {
        var _this = this;
        var newTree = this.applyRedirectCommands([], route.redirectTo, {});
        if (route.redirectTo.startsWith('/')) {
            return absoluteRedirect(newTree);
        }
        return this.lineralizeSegments(route, newTree).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (newSegments) {
            var group = new UrlSegmentGroup(newSegments, {});
            return _this.expandSegment(ngModule, group, routes, newSegments, outlet, false);
        }));
    };
    ApplyRedirects.prototype.expandRegularSegmentAgainstRouteUsingRedirect = function (ngModule, segmentGroup, routes, route, segments, outlet) {
        var _this = this;
        var _a = match(segmentGroup, route, segments), matched = _a.matched, consumedSegments = _a.consumedSegments, lastChild = _a.lastChild, positionalParamSegments = _a.positionalParamSegments;
        if (!matched)
            return noMatch(segmentGroup);
        var newTree = this.applyRedirectCommands(consumedSegments, route.redirectTo, positionalParamSegments);
        if (route.redirectTo.startsWith('/')) {
            return absoluteRedirect(newTree);
        }
        return this.lineralizeSegments(route, newTree).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (newSegments) {
            return _this.expandSegment(ngModule, segmentGroup, routes, newSegments.concat(segments.slice(lastChild)), outlet, false);
        }));
    };
    ApplyRedirects.prototype.matchSegmentAgainstRoute = function (ngModule, rawSegmentGroup, route, segments) {
        var _this = this;
        if (route.path === '**') {
            if (route.loadChildren) {
                return this.configLoader.load(ngModule.injector, route)
                    .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (cfg) {
                    route._loadedConfig = cfg;
                    return new UrlSegmentGroup(segments, {});
                }));
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(new UrlSegmentGroup(segments, {}));
        }
        var _a = match(rawSegmentGroup, route, segments), matched = _a.matched, consumedSegments = _a.consumedSegments, lastChild = _a.lastChild;
        if (!matched)
            return noMatch(rawSegmentGroup);
        var rawSlicedSegments = segments.slice(lastChild);
        var childConfig$ = this.getChildConfig(ngModule, route);
        return childConfig$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (routerConfig) {
            var childModule = routerConfig.module;
            var childConfig = routerConfig.routes;
            var _a = split(rawSegmentGroup, consumedSegments, rawSlicedSegments, childConfig), segmentGroup = _a.segmentGroup, slicedSegments = _a.slicedSegments;
            if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
                var expanded$_1 = _this.expandChildren(childModule, childConfig, segmentGroup);
                return expanded$_1.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (children) { return new UrlSegmentGroup(consumedSegments, children); }));
            }
            if (childConfig.length === 0 && slicedSegments.length === 0) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(new UrlSegmentGroup(consumedSegments, {}));
            }
            var expanded$ = _this.expandSegment(childModule, segmentGroup, childConfig, slicedSegments, PRIMARY_OUTLET, true);
            return expanded$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (cs) {
                return new UrlSegmentGroup(consumedSegments.concat(cs.segments), cs.children);
            }));
        }));
    };
    ApplyRedirects.prototype.getChildConfig = function (ngModule, route) {
        var _this = this;
        if (route.children) {
            // The children belong to the same module
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(new LoadedRouterConfig(route.children, ngModule));
        }
        if (route.loadChildren) {
            // lazy children belong to the loaded module
            if (route._loadedConfig !== undefined) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(route._loadedConfig);
            }
            return runCanLoadGuard(ngModule.injector, route).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (shouldLoad) {
                if (shouldLoad) {
                    return _this.configLoader.load(ngModule.injector, route)
                        .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (cfg) {
                        route._loadedConfig = cfg;
                        return cfg;
                    }));
                }
                return canLoadFails(route);
            }));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(new LoadedRouterConfig([], ngModule));
    };
    ApplyRedirects.prototype.lineralizeSegments = function (route, urlTree) {
        var res = [];
        var c = urlTree.root;
        while (true) {
            res = res.concat(c.segments);
            if (c.numberOfChildren === 0) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(res);
            }
            if (c.numberOfChildren > 1 || !c.children[PRIMARY_OUTLET]) {
                return namedOutletsRedirect(route.redirectTo);
            }
            c = c.children[PRIMARY_OUTLET];
        }
    };
    ApplyRedirects.prototype.applyRedirectCommands = function (segments, redirectTo, posParams) {
        return this.applyRedirectCreatreUrlTree(redirectTo, this.urlSerializer.parse(redirectTo), segments, posParams);
    };
    ApplyRedirects.prototype.applyRedirectCreatreUrlTree = function (redirectTo, urlTree, segments, posParams) {
        var newRoot = this.createSegmentGroup(redirectTo, urlTree.root, segments, posParams);
        return new UrlTree(newRoot, this.createQueryParams(urlTree.queryParams, this.urlTree.queryParams), urlTree.fragment);
    };
    ApplyRedirects.prototype.createQueryParams = function (redirectToParams, actualParams) {
        var res = {};
        forEach(redirectToParams, function (v, k) {
            var copySourceValue = typeof v === 'string' && v.startsWith(':');
            if (copySourceValue) {
                var sourceName = v.substring(1);
                res[k] = actualParams[sourceName];
            }
            else {
                res[k] = v;
            }
        });
        return res;
    };
    ApplyRedirects.prototype.createSegmentGroup = function (redirectTo, group, segments, posParams) {
        var _this = this;
        var updatedSegments = this.createSegments(redirectTo, group.segments, segments, posParams);
        var children = {};
        forEach(group.children, function (child, name) {
            children[name] = _this.createSegmentGroup(redirectTo, child, segments, posParams);
        });
        return new UrlSegmentGroup(updatedSegments, children);
    };
    ApplyRedirects.prototype.createSegments = function (redirectTo, redirectToSegments, actualSegments, posParams) {
        var _this = this;
        return redirectToSegments.map(function (s) {
            return s.path.startsWith(':') ? _this.findPosParam(redirectTo, s, posParams) :
                _this.findOrReturn(s, actualSegments);
        });
    };
    ApplyRedirects.prototype.findPosParam = function (redirectTo, redirectToUrlSegment, posParams) {
        var pos = posParams[redirectToUrlSegment.path.substring(1)];
        if (!pos)
            throw new Error("Cannot redirect to '" + redirectTo + "'. Cannot find '" + redirectToUrlSegment.path + "'.");
        return pos;
    };
    ApplyRedirects.prototype.findOrReturn = function (redirectToUrlSegment, actualSegments) {
        var e_1, _a;
        var idx = 0;
        try {
            for (var actualSegments_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(actualSegments), actualSegments_1_1 = actualSegments_1.next(); !actualSegments_1_1.done; actualSegments_1_1 = actualSegments_1.next()) {
                var s = actualSegments_1_1.value;
                if (s.path === redirectToUrlSegment.path) {
                    actualSegments.splice(idx);
                    return s;
                }
                idx++;
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (actualSegments_1_1 && !actualSegments_1_1.done && (_a = actualSegments_1.return))
                    _a.call(actualSegments_1);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return redirectToUrlSegment;
    };
    return ApplyRedirects;
}());
function runCanLoadGuard(moduleInjector, route) {
    var canLoad = route.canLoad;
    if (!canLoad || canLoad.length === 0)
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(true);
    var obs = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(canLoad).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (injectionToken) {
        var guard = moduleInjector.get(injectionToken);
        return wrapIntoObservable(guard.canLoad ? guard.canLoad(route) : guard(route));
    }));
    return andObservables(obs);
}
function match(segmentGroup, route, segments) {
    if (route.path === '') {
        if ((route.pathMatch === 'full') && (segmentGroup.hasChildren() || segments.length > 0)) {
            return { matched: false, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
        }
        return { matched: true, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
    }
    var matcher = route.matcher || defaultUrlMatcher;
    var res = matcher(segments, segmentGroup, route);
    if (!res) {
        return {
            matched: false,
            consumedSegments: [],
            lastChild: 0,
            positionalParamSegments: {},
        };
    }
    return {
        matched: true,
        consumedSegments: res.consumed,
        lastChild: res.consumed.length,
        positionalParamSegments: res.posParams,
    };
}
function split(segmentGroup, consumedSegments, slicedSegments, config) {
    if (slicedSegments.length > 0 &&
        containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, slicedSegments, config)) {
        var s = new UrlSegmentGroup(consumedSegments, createChildrenForEmptySegments(config, new UrlSegmentGroup(slicedSegments, segmentGroup.children)));
        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: [] };
    }
    if (slicedSegments.length === 0 &&
        containsEmptyPathRedirects(segmentGroup, slicedSegments, config)) {
        var s = new UrlSegmentGroup(segmentGroup.segments, addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: slicedSegments };
    }
    return { segmentGroup: segmentGroup, slicedSegments: slicedSegments };
}
function mergeTrivialChildren(s) {
    if (s.numberOfChildren === 1 && s.children[PRIMARY_OUTLET]) {
        var c = s.children[PRIMARY_OUTLET];
        return new UrlSegmentGroup(s.segments.concat(c.segments), c.children);
    }
    return s;
}
function addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
    var e_2, _a;
    var res = {};
    try {
        for (var routes_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(routes), routes_1_1 = routes_1.next(); !routes_1_1.done; routes_1_1 = routes_1.next()) {
            var r = routes_1_1.value;
            if (isEmptyPathRedirect(segmentGroup, slicedSegments, r) && !children[getOutlet(r)]) {
                res[getOutlet(r)] = new UrlSegmentGroup([], {});
            }
        }
    }
    catch (e_2_1) {
        e_2 = { error: e_2_1 };
    }
    finally {
        try {
            if (routes_1_1 && !routes_1_1.done && (_a = routes_1.return))
                _a.call(routes_1);
        }
        finally {
            if (e_2)
                throw e_2.error;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, children, res);
}
function createChildrenForEmptySegments(routes, primarySegmentGroup) {
    var e_3, _a;
    var res = {};
    res[PRIMARY_OUTLET] = primarySegmentGroup;
    try {
        for (var routes_2 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(routes), routes_2_1 = routes_2.next(); !routes_2_1.done; routes_2_1 = routes_2.next()) {
            var r = routes_2_1.value;
            if (r.path === '' && getOutlet(r) !== PRIMARY_OUTLET) {
                res[getOutlet(r)] = new UrlSegmentGroup([], {});
            }
        }
    }
    catch (e_3_1) {
        e_3 = { error: e_3_1 };
    }
    finally {
        try {
            if (routes_2_1 && !routes_2_1.done && (_a = routes_2.return))
                _a.call(routes_2);
        }
        finally {
            if (e_3)
                throw e_3.error;
        }
    }
    return res;
}
function containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, segments, routes) {
    return routes.some(function (r) { return isEmptyPathRedirect(segmentGroup, segments, r) && getOutlet(r) !== PRIMARY_OUTLET; });
}
function containsEmptyPathRedirects(segmentGroup, segments, routes) {
    return routes.some(function (r) { return isEmptyPathRedirect(segmentGroup, segments, r); });
}
function isEmptyPathRedirect(segmentGroup, segments, r) {
    if ((segmentGroup.hasChildren() || segments.length > 0) && r.pathMatch === 'full') {
        return false;
    }
    return r.path === '' && r.redirectTo !== undefined;
}
function getOutlet(route) {
    return route.outlet || PRIMARY_OUTLET;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Tree = /*@__PURE__*/ (function () {
    function Tree(root) {
        this._root = root;
    }
    Object.defineProperty(Tree.prototype, "root", {
        get: function () { return this._root.value; },
        enumerable: true,
        configurable: true
    });
    /**
     * @internal
     */
    Tree.prototype.parent = function (t) {
        var p = this.pathFromRoot(t);
        return p.length > 1 ? p[p.length - 2] : null;
    };
    /**
     * @internal
     */
    Tree.prototype.children = function (t) {
        var n = findNode(t, this._root);
        return n ? n.children.map(function (t) { return t.value; }) : [];
    };
    /**
     * @internal
     */
    Tree.prototype.firstChild = function (t) {
        var n = findNode(t, this._root);
        return n && n.children.length > 0 ? n.children[0].value : null;
    };
    /**
     * @internal
     */
    Tree.prototype.siblings = function (t) {
        var p = findPath(t, this._root);
        if (p.length < 2)
            return [];
        var c = p[p.length - 2].children.map(function (c) { return c.value; });
        return c.filter(function (cc) { return cc !== t; });
    };
    /**
     * @internal
     */
    Tree.prototype.pathFromRoot = function (t) { return findPath(t, this._root).map(function (s) { return s.value; }); };
    return Tree;
}());
// DFS for the node matching the value
function findNode(value, node) {
    var e_1, _a;
    if (value === node.value)
        return node;
    try {
        for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            var node_1 = findNode(value, child);
            if (node_1)
                return node_1;
        }
    }
    catch (e_1_1) {
        e_1 = { error: e_1_1 };
    }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return))
                _a.call(_b);
        }
        finally {
            if (e_1)
                throw e_1.error;
        }
    }
    return null;
}
// Return the path to the node with the given value using DFS
function findPath(value, node) {
    var e_2, _a;
    if (value === node.value)
        return [node];
    try {
        for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(node.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            var path = findPath(value, child);
            if (path.length) {
                path.unshift(node);
                return path;
            }
        }
    }
    catch (e_2_1) {
        e_2 = { error: e_2_1 };
    }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return))
                _a.call(_b);
        }
        finally {
            if (e_2)
                throw e_2.error;
        }
    }
    return [];
}
var TreeNode = /*@__PURE__*/ (function () {
    function TreeNode(value, children) {
        this.value = value;
        this.children = children;
    }
    TreeNode.prototype.toString = function () { return "TreeNode(" + this.value + ")"; };
    return TreeNode;
}());
// Return the list of T indexed by outlet name
function nodeChildrenAsMap(node) {
    var map$$1 = {};
    if (node) {
        node.children.forEach(function (child) { return map$$1[child.value.outlet] = child; });
    }
    return map$$1;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Represents the state of the router.
 *
 * RouterState is a tree of activated routes. Every node in this tree knows about the "consumed" URL
 * segments, the extracted parameters, and the resolved data.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * @Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const state: RouterState = router.routerState;
 *     const root: ActivatedRoute = state.root;
 *     const child = root.firstChild;
 *     const id: Observable<string> = child.params.map(p => p.id);
 *     //...
 *   }
 * }
 * ```
 *
 * See `ActivatedRoute` for more information.
 *
 *
 */
var RouterState = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(RouterState, _super);
    /** @internal */
    function RouterState(root, 
    /** The current snapshot of the router state */
    snapshot) {
        var _this = _super.call(this, root) || this;
        _this.snapshot = snapshot;
        setRouterState(_this, root);
        return _this;
    }
    RouterState.prototype.toString = function () { return this.snapshot.toString(); };
    return RouterState;
}(Tree));
function createEmptyState(urlTree, rootComponent) {
    var snapshot = createEmptyStateSnapshot(urlTree, rootComponent);
    var emptyUrl = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */]([new UrlSegment('', {})]);
    var emptyParams = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */]({});
    var emptyData = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */]({});
    var emptyQueryParams = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */]({});
    var fragment = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */]('');
    var activated = new ActivatedRoute(emptyUrl, emptyParams, emptyQueryParams, fragment, emptyData, PRIMARY_OUTLET, rootComponent, snapshot.root);
    activated.snapshot = snapshot.root;
    return new RouterState(new TreeNode(activated, []), snapshot);
}
function createEmptyStateSnapshot(urlTree, rootComponent) {
    var emptyParams = {};
    var emptyData = {};
    var emptyQueryParams = {};
    var fragment = '';
    var activated = new ActivatedRouteSnapshot([], emptyParams, emptyQueryParams, fragment, emptyData, PRIMARY_OUTLET, rootComponent, null, urlTree.root, -1, {});
    return new RouterStateSnapshot('', new TreeNode(activated, []));
}
/**
 * @description
 *
 * Contains the information about a route associated with a component loaded in an
 * outlet.  An `ActivatedRoute` can also be used to traverse the router state tree.
 *
 * ```
 * @Component({...})
 * class MyComponent {
 *   constructor(route: ActivatedRoute) {
 *     const id: Observable<string> = route.params.map(p => p.id);
 *     const url: Observable<string> = route.url.map(segments => segments.join(''));
 *     // route.data includes both `data` and `resolve`
 *     const user = route.data.map(d => d.user);
 *   }
 * }
 * ```
 *
 *
 */
var ActivatedRoute = /*@__PURE__*/ (function () {
    /** @internal */
    function ActivatedRoute(
    /** An observable of the URL segments matched by this route */
    url, 
    /** An observable of the matrix parameters scoped to this route */
    params, 
    /** An observable of the query parameters shared by all the routes */
    queryParams, 
    /** An observable of the URL fragment shared by all the routes */
    fragment, 
    /** An observable of the static and resolved data of this route. */
    data, 
    /** The outlet name of the route. It's a constant */
    outlet, 
    /** The component of the route. It's a constant */
    // TODO(vsavkin): remove |string
    component, futureSnapshot) {
        this.url = url;
        this.params = params;
        this.queryParams = queryParams;
        this.fragment = fragment;
        this.data = data;
        this.outlet = outlet;
        this.component = component;
        this._futureSnapshot = futureSnapshot;
    }
    Object.defineProperty(ActivatedRoute.prototype, "routeConfig", {
        /** The configuration used to match this route */
        get: function () { return this._futureSnapshot.routeConfig; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "root", {
        /** The root of the router state */
        get: function () { return this._routerState.root; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "parent", {
        /** The parent of this route in the router state tree */
        get: function () { return this._routerState.parent(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "firstChild", {
        /** The first child of this route in the router state tree */
        get: function () { return this._routerState.firstChild(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "children", {
        /** The children of this route in the router state tree */
        get: function () { return this._routerState.children(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "pathFromRoot", {
        /** The path from the root of the router state tree to this route */
        get: function () { return this._routerState.pathFromRoot(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "paramMap", {
        get: function () {
            if (!this._paramMap) {
                this._paramMap = this.params.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (p) { return convertToParamMap(p); }));
            }
            return this._paramMap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "queryParamMap", {
        get: function () {
            if (!this._queryParamMap) {
                this._queryParamMap =
                    this.queryParams.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (p) { return convertToParamMap(p); }));
            }
            return this._queryParamMap;
        },
        enumerable: true,
        configurable: true
    });
    ActivatedRoute.prototype.toString = function () {
        return this.snapshot ? this.snapshot.toString() : "Future(" + this._futureSnapshot + ")";
    };
    return ActivatedRoute;
}());
/**
 * Returns the inherited params, data, and resolve for a given route.
 * By default, this only inherits values up to the nearest path-less or component-less route.
 * @internal
 */
function inheritedParamsDataResolve(route, paramsInheritanceStrategy) {
    if (paramsInheritanceStrategy === void 0) {
        paramsInheritanceStrategy = 'emptyOnly';
    }
    var pathFromRoot = route.pathFromRoot;
    var inheritingStartingFrom = 0;
    if (paramsInheritanceStrategy !== 'always') {
        inheritingStartingFrom = pathFromRoot.length - 1;
        while (inheritingStartingFrom >= 1) {
            var current = pathFromRoot[inheritingStartingFrom];
            var parent_1 = pathFromRoot[inheritingStartingFrom - 1];
            // current route is an empty path => inherits its parent's params and data
            if (current.routeConfig && current.routeConfig.path === '') {
                inheritingStartingFrom--;
                // parent is componentless => current route should inherit its params and data
            }
            else if (!parent_1.component) {
                inheritingStartingFrom--;
            }
            else {
                break;
            }
        }
    }
    return flattenInherited(pathFromRoot.slice(inheritingStartingFrom));
}
/** @internal */
function flattenInherited(pathFromRoot) {
    return pathFromRoot.reduce(function (res, curr) {
        var params = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, res.params, curr.params);
        var data = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, res.data, curr.data);
        var resolve = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, res.resolve, curr._resolvedData);
        return { params: params, data: data, resolve: resolve };
    }, { params: {}, data: {}, resolve: {} });
}
/**
 * @description
 *
 * Contains the information about a route associated with a component loaded in an
 * outlet at a particular moment in time. ActivatedRouteSnapshot can also be used to
 * traverse the router state tree.
 *
 * ```
 * @Component({templateUrl:'./my-component.html'})
 * class MyComponent {
 *   constructor(route: ActivatedRoute) {
 *     const id: string = route.snapshot.params.id;
 *     const url: string = route.snapshot.url.join('');
 *     const user = route.snapshot.data.user;
 *   }
 * }
 * ```
 *
 *
 */
var ActivatedRouteSnapshot = /*@__PURE__*/ (function () {
    /** @internal */
    function ActivatedRouteSnapshot(
    /** The URL segments matched by this route */
    url, 
    /** The matrix parameters scoped to this route */
    params, 
    /** The query parameters shared by all the routes */
    queryParams, 
    /** The URL fragment shared by all the routes */
    fragment, 
    /** The static and resolved data of this route */
    data, 
    /** The outlet name of the route */
    outlet, 
    /** The component of the route */
    component, routeConfig, urlSegment, lastPathIndex, resolve) {
        this.url = url;
        this.params = params;
        this.queryParams = queryParams;
        this.fragment = fragment;
        this.data = data;
        this.outlet = outlet;
        this.component = component;
        this.routeConfig = routeConfig;
        this._urlSegment = urlSegment;
        this._lastPathIndex = lastPathIndex;
        this._resolve = resolve;
    }
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "root", {
        /** The root of the router state */
        get: function () { return this._routerState.root; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "parent", {
        /** The parent of this route in the router state tree */
        get: function () { return this._routerState.parent(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "firstChild", {
        /** The first child of this route in the router state tree */
        get: function () { return this._routerState.firstChild(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "children", {
        /** The children of this route in the router state tree */
        get: function () { return this._routerState.children(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "pathFromRoot", {
        /** The path from the root of the router state tree to this route */
        get: function () { return this._routerState.pathFromRoot(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "paramMap", {
        get: function () {
            if (!this._paramMap) {
                this._paramMap = convertToParamMap(this.params);
            }
            return this._paramMap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "queryParamMap", {
        get: function () {
            if (!this._queryParamMap) {
                this._queryParamMap = convertToParamMap(this.queryParams);
            }
            return this._queryParamMap;
        },
        enumerable: true,
        configurable: true
    });
    ActivatedRouteSnapshot.prototype.toString = function () {
        var url = this.url.map(function (segment) { return segment.toString(); }).join('/');
        var matched = this.routeConfig ? this.routeConfig.path : '';
        return "Route(url:'" + url + "', path:'" + matched + "')";
    };
    return ActivatedRouteSnapshot;
}());
/**
 * @description
 *
 * Represents the state of the router at a moment in time.
 *
 * This is a tree of activated route snapshots. Every node in this tree knows about
 * the "consumed" URL segments, the extracted parameters, and the resolved data.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * @Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const state: RouterState = router.routerState;
 *     const snapshot: RouterStateSnapshot = state.snapshot;
 *     const root: ActivatedRouteSnapshot = snapshot.root;
 *     const child = root.firstChild;
 *     const id: Observable<string> = child.params.map(p => p.id);
 *     //...
 *   }
 * }
 * ```
 *
 *
 */
var RouterStateSnapshot = /*@__PURE__*/ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(RouterStateSnapshot, _super);
    /** @internal */
    function RouterStateSnapshot(
    /** The url from which this snapshot was created */
    url, root) {
        var _this = _super.call(this, root) || this;
        _this.url = url;
        setRouterState(_this, root);
        return _this;
    }
    RouterStateSnapshot.prototype.toString = function () { return serializeNode(this._root); };
    return RouterStateSnapshot;
}(Tree));
function setRouterState(state, node) {
    node.value._routerState = state;
    node.children.forEach(function (c) { return setRouterState(state, c); });
}
function serializeNode(node) {
    var c = node.children.length > 0 ? " { " + node.children.map(serializeNode).join(', ') + " } " : '';
    return "" + node.value + c;
}
/**
 * The expectation is that the activate route is created with the right set of parameters.
 * So we push new values into the observables only when they are not the initial values.
 * And we detect that by checking if the snapshot field is set.
 */
function advanceActivatedRoute(route) {
    if (route.snapshot) {
        var currentSnapshot = route.snapshot;
        var nextSnapshot = route._futureSnapshot;
        route.snapshot = nextSnapshot;
        if (!shallowEqual(currentSnapshot.queryParams, nextSnapshot.queryParams)) {
            route.queryParams.next(nextSnapshot.queryParams);
        }
        if (currentSnapshot.fragment !== nextSnapshot.fragment) {
            route.fragment.next(nextSnapshot.fragment);
        }
        if (!shallowEqual(currentSnapshot.params, nextSnapshot.params)) {
            route.params.next(nextSnapshot.params);
        }
        if (!shallowEqualArrays(currentSnapshot.url, nextSnapshot.url)) {
            route.url.next(nextSnapshot.url);
        }
        if (!shallowEqual(currentSnapshot.data, nextSnapshot.data)) {
            route.data.next(nextSnapshot.data);
        }
    }
    else {
        route.snapshot = route._futureSnapshot;
        // this is for resolved data
        route.data.next(route._futureSnapshot.data);
    }
}
function equalParamsAndUrlSegments(a, b) {
    var equalUrlParams = shallowEqual(a.params, b.params) && equalSegments(a.url, b.url);
    var parentsMismatch = !a.parent !== !b.parent;
    return equalUrlParams && !parentsMismatch &&
        (!a.parent || equalParamsAndUrlSegments(a.parent, b.parent));
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function createRouterState(routeReuseStrategy, curr, prevState) {
    var root = createNode(routeReuseStrategy, curr._root, prevState ? prevState._root : undefined);
    return new RouterState(root, curr);
}
function createNode(routeReuseStrategy, curr, prevState) {
    // reuse an activated route that is currently displayed on the screen
    if (prevState && routeReuseStrategy.shouldReuseRoute(curr.value, prevState.value.snapshot)) {
        var value = prevState.value;
        value._futureSnapshot = curr.value;
        var children = createOrReuseChildren(routeReuseStrategy, curr, prevState);
        return new TreeNode(value, children);
        // retrieve an activated route that is used to be displayed, but is not currently displayed
    }
    else {
        var detachedRouteHandle = routeReuseStrategy.retrieve(curr.value);
        if (detachedRouteHandle) {
            var tree = detachedRouteHandle.route;
            setFutureSnapshotsOfActivatedRoutes(curr, tree);
            return tree;
        }
        else {
            var value = createActivatedRoute(curr.value);
            var children = curr.children.map(function (c) { return createNode(routeReuseStrategy, c); });
            return new TreeNode(value, children);
        }
    }
}
function setFutureSnapshotsOfActivatedRoutes(curr, result) {
    if (curr.value.routeConfig !== result.value.routeConfig) {
        throw new Error('Cannot reattach ActivatedRouteSnapshot created from a different route');
    }
    if (curr.children.length !== result.children.length) {
        throw new Error('Cannot reattach ActivatedRouteSnapshot with a different number of children');
    }
    result.value._futureSnapshot = curr.value;
    for (var i = 0; i < curr.children.length; ++i) {
        setFutureSnapshotsOfActivatedRoutes(curr.children[i], result.children[i]);
    }
}
function createOrReuseChildren(routeReuseStrategy, curr, prevState) {
    return curr.children.map(function (child) {
        var e_1, _a;
        try {
            for (var _b = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(prevState.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var p = _c.value;
                if (routeReuseStrategy.shouldReuseRoute(p.value.snapshot, child.value)) {
                    return createNode(routeReuseStrategy, child, p);
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return createNode(routeReuseStrategy, child);
    });
}
function createActivatedRoute(c) {
    return new ActivatedRoute(new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */](c.url), new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */](c.params), new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */](c.queryParams), new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */](c.fragment), new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */](c.data), c.outlet, c.component, c);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function createUrlTree(route, urlTree, commands, queryParams, fragment) {
    if (commands.length === 0) {
        return tree(urlTree.root, urlTree.root, urlTree, queryParams, fragment);
    }
    var nav = computeNavigation(commands);
    if (nav.toRoot()) {
        return tree(urlTree.root, new UrlSegmentGroup([], {}), urlTree, queryParams, fragment);
    }
    var startingPosition = findStartingPosition(nav, urlTree, route);
    var segmentGroup = startingPosition.processChildren ?
        updateSegmentGroupChildren(startingPosition.segmentGroup, startingPosition.index, nav.commands) :
        updateSegmentGroup(startingPosition.segmentGroup, startingPosition.index, nav.commands);
    return tree(startingPosition.segmentGroup, segmentGroup, urlTree, queryParams, fragment);
}
function isMatrixParams(command) {
    return typeof command === 'object' && command != null && !command.outlets && !command.segmentPath;
}
function tree(oldSegmentGroup, newSegmentGroup, urlTree, queryParams, fragment) {
    var qp = {};
    if (queryParams) {
        forEach(queryParams, function (value, name) {
            qp[name] = Array.isArray(value) ? value.map(function (v) { return "" + v; }) : "" + value;
        });
    }
    if (urlTree.root === oldSegmentGroup) {
        return new UrlTree(newSegmentGroup, qp, fragment);
    }
    return new UrlTree(replaceSegment(urlTree.root, oldSegmentGroup, newSegmentGroup), qp, fragment);
}
function replaceSegment(current, oldSegment, newSegment) {
    var children = {};
    forEach(current.children, function (c, outletName) {
        if (c === oldSegment) {
            children[outletName] = newSegment;
        }
        else {
            children[outletName] = replaceSegment(c, oldSegment, newSegment);
        }
    });
    return new UrlSegmentGroup(current.segments, children);
}
var Navigation = /*@__PURE__*/ (function () {
    function Navigation(isAbsolute, numberOfDoubleDots, commands) {
        this.isAbsolute = isAbsolute;
        this.numberOfDoubleDots = numberOfDoubleDots;
        this.commands = commands;
        if (isAbsolute && commands.length > 0 && isMatrixParams(commands[0])) {
            throw new Error('Root segment cannot have matrix parameters');
        }
        var cmdWithOutlet = commands.find(function (c) { return typeof c === 'object' && c != null && c.outlets; });
        if (cmdWithOutlet && cmdWithOutlet !== last$1(commands)) {
            throw new Error('{outlets:{}} has to be the last command');
        }
    }
    Navigation.prototype.toRoot = function () {
        return this.isAbsolute && this.commands.length === 1 && this.commands[0] == '/';
    };
    return Navigation;
}());
/** Transforms commands to a normalized `Navigation` */
function computeNavigation(commands) {
    if ((typeof commands[0] === 'string') && commands.length === 1 && commands[0] === '/') {
        return new Navigation(true, 0, commands);
    }
    var numberOfDoubleDots = 0;
    var isAbsolute = false;
    var res = commands.reduce(function (res, cmd, cmdIdx) {
        if (typeof cmd === 'object' && cmd != null) {
            if (cmd.outlets) {
                var outlets_1 = {};
                forEach(cmd.outlets, function (commands, name) {
                    outlets_1[name] = typeof commands === 'string' ? commands.split('/') : commands;
                });
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(res, [{ outlets: outlets_1 }]);
            }
            if (cmd.segmentPath) {
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(res, [cmd.segmentPath]);
            }
        }
        if (!(typeof cmd === 'string')) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(res, [cmd]);
        }
        if (cmdIdx === 0) {
            cmd.split('/').forEach(function (urlPart, partIndex) {
                if (partIndex == 0 && urlPart === '.')
                    ;
                else if (partIndex == 0 && urlPart === '') {
                    isAbsolute = true;
                }
                else if (urlPart === '..') {
                    numberOfDoubleDots++;
                }
                else if (urlPart != '') {
                    res.push(urlPart);
                }
            });
            return res;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(res, [cmd]);
    }, []);
    return new Navigation(isAbsolute, numberOfDoubleDots, res);
}
var Position = /*@__PURE__*/ (function () {
    function Position(segmentGroup, processChildren, index) {
        this.segmentGroup = segmentGroup;
        this.processChildren = processChildren;
        this.index = index;
    }
    return Position;
}());
function findStartingPosition(nav, tree, route) {
    if (nav.isAbsolute) {
        return new Position(tree.root, true, 0);
    }
    if (route.snapshot._lastPathIndex === -1) {
        return new Position(route.snapshot._urlSegment, true, 0);
    }
    var modifier = isMatrixParams(nav.commands[0]) ? 0 : 1;
    var index = route.snapshot._lastPathIndex + modifier;
    return createPositionApplyingDoubleDots(route.snapshot._urlSegment, index, nav.numberOfDoubleDots);
}
function createPositionApplyingDoubleDots(group, index, numberOfDoubleDots) {
    var g = group;
    var ci = index;
    var dd = numberOfDoubleDots;
    while (dd > ci) {
        dd -= ci;
        g = g.parent;
        if (!g) {
            throw new Error('Invalid number of \'../\'');
        }
        ci = g.segments.length;
    }
    return new Position(g, false, ci - dd);
}
function getPath(command) {
    if (typeof command === 'object' && command != null && command.outlets) {
        return command.outlets[PRIMARY_OUTLET];
    }
    return "" + command;
}
function getOutlets(commands) {
    var _a, _b;
    if (!(typeof commands[0] === 'object'))
        return _a = {}, _a[PRIMARY_OUTLET] = commands, _a;
    if (commands[0].outlets === undefined)
        return _b = {}, _b[PRIMARY_OUTLET] = commands, _b;
    return commands[0].outlets;
}
function updateSegmentGroup(segmentGroup, startIndex, commands) {
    if (!segmentGroup) {
        segmentGroup = new UrlSegmentGroup([], {});
    }
    if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
        return updateSegmentGroupChildren(segmentGroup, startIndex, commands);
    }
    var m = prefixedWith(segmentGroup, startIndex, commands);
    var slicedCommands = commands.slice(m.commandIndex);
    if (m.match && m.pathIndex < segmentGroup.segments.length) {
        var g = new UrlSegmentGroup(segmentGroup.segments.slice(0, m.pathIndex), {});
        g.children[PRIMARY_OUTLET] =
            new UrlSegmentGroup(segmentGroup.segments.slice(m.pathIndex), segmentGroup.children);
        return updateSegmentGroupChildren(g, 0, slicedCommands);
    }
    else if (m.match && slicedCommands.length === 0) {
        return new UrlSegmentGroup(segmentGroup.segments, {});
    }
    else if (m.match && !segmentGroup.hasChildren()) {
        return createNewSegmentGroup(segmentGroup, startIndex, commands);
    }
    else if (m.match) {
        return updateSegmentGroupChildren(segmentGroup, 0, slicedCommands);
    }
    else {
        return createNewSegmentGroup(segmentGroup, startIndex, commands);
    }
}
function updateSegmentGroupChildren(segmentGroup, startIndex, commands) {
    if (commands.length === 0) {
        return new UrlSegmentGroup(segmentGroup.segments, {});
    }
    else {
        var outlets_2 = getOutlets(commands);
        var children_1 = {};
        forEach(outlets_2, function (commands, outlet) {
            if (commands !== null) {
                children_1[outlet] = updateSegmentGroup(segmentGroup.children[outlet], startIndex, commands);
            }
        });
        forEach(segmentGroup.children, function (child, childOutlet) {
            if (outlets_2[childOutlet] === undefined) {
                children_1[childOutlet] = child;
            }
        });
        return new UrlSegmentGroup(segmentGroup.segments, children_1);
    }
}
function prefixedWith(segmentGroup, startIndex, commands) {
    var currentCommandIndex = 0;
    var currentPathIndex = startIndex;
    var noMatch = { match: false, pathIndex: 0, commandIndex: 0 };
    while (currentPathIndex < segmentGroup.segments.length) {
        if (currentCommandIndex >= commands.length)
            return noMatch;
        var path = segmentGroup.segments[currentPathIndex];
        var curr = getPath(commands[currentCommandIndex]);
        var next = currentCommandIndex < commands.length - 1 ? commands[currentCommandIndex + 1] : null;
        if (currentPathIndex > 0 && curr === undefined)
            break;
        if (curr && next && (typeof next === 'object') && next.outlets === undefined) {
            if (!compare(curr, next, path))
                return noMatch;
            currentCommandIndex += 2;
        }
        else {
            if (!compare(curr, {}, path))
                return noMatch;
            currentCommandIndex++;
        }
        currentPathIndex++;
    }
    return { match: true, pathIndex: currentPathIndex, commandIndex: currentCommandIndex };
}
function createNewSegmentGroup(segmentGroup, startIndex, commands) {
    var paths = segmentGroup.segments.slice(0, startIndex);
    var i = 0;
    while (i < commands.length) {
        if (typeof commands[i] === 'object' && commands[i].outlets !== undefined) {
            var children = createNewSegmentChildren(commands[i].outlets);
            return new UrlSegmentGroup(paths, children);
        }
        // if we start with an object literal, we need to reuse the path part from the segment
        if (i === 0 && isMatrixParams(commands[0])) {
            var p = segmentGroup.segments[startIndex];
            paths.push(new UrlSegment(p.path, commands[0]));
            i++;
            continue;
        }
        var curr = getPath(commands[i]);
        var next = (i < commands.length - 1) ? commands[i + 1] : null;
        if (curr && next && isMatrixParams(next)) {
            paths.push(new UrlSegment(curr, stringify(next)));
            i += 2;
        }
        else {
            paths.push(new UrlSegment(curr, {}));
            i++;
        }
    }
    return new UrlSegmentGroup(paths, {});
}
function createNewSegmentChildren(outlets) {
    var children = {};
    forEach(outlets, function (commands, outlet) {
        if (commands !== null) {
            children[outlet] = createNewSegmentGroup(new UrlSegmentGroup([], {}), 0, commands);
        }
    });
    return children;
}
function stringify(params) {
    var res = {};
    forEach(params, function (v, k) { return res[k] = "" + v; });
    return res;
}
function compare(path, params, segment) {
    return path == segment.path && shallowEqual(params, segment.parameters);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CanActivate = /*@__PURE__*/ (function () {
    function CanActivate(path) {
        this.path = path;
        this.route = this.path[this.path.length - 1];
    }
    return CanActivate;
}());
var CanDeactivate = /*@__PURE__*/ (function () {
    function CanDeactivate(component, route) {
        this.component = component;
        this.route = route;
    }
    return CanDeactivate;
}());
/**
 * This class bundles the actions involved in preactivation of a route.
 */
var PreActivation = /*@__PURE__*/ (function () {
    function PreActivation(future, curr, moduleInjector, forwardEvent) {
        this.future = future;
        this.curr = curr;
        this.moduleInjector = moduleInjector;
        this.forwardEvent = forwardEvent;
        this.canActivateChecks = [];
        this.canDeactivateChecks = [];
    }
    PreActivation.prototype.initialize = function (parentContexts) {
        var futureRoot = this.future._root;
        var currRoot = this.curr ? this.curr._root : null;
        this.setupChildRouteGuards(futureRoot, currRoot, parentContexts, [futureRoot.value]);
    };
    PreActivation.prototype.checkGuards = function () {
        var _this = this;
        if (!this.isDeactivating() && !this.isActivating()) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(true);
        }
        var canDeactivate$ = this.runCanDeactivateChecks();
        return canDeactivate$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (canDeactivate) { return canDeactivate ? _this.runCanActivateChecks() : Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(false); }));
    };
    PreActivation.prototype.resolveData = function (paramsInheritanceStrategy) {
        var _this = this;
        if (!this.isActivating())
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(null);
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(this.canActivateChecks)
            .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["concatMap"])(function (check) { return _this.runResolve(check.route, paramsInheritanceStrategy); }), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["reduce"])(function (_, __) { return _; }));
    };
    PreActivation.prototype.isDeactivating = function () { return this.canDeactivateChecks.length !== 0; };
    PreActivation.prototype.isActivating = function () { return this.canActivateChecks.length !== 0; };
    /**
     * Iterates over child routes and calls recursive `setupRouteGuards` to get `this` instance in
     * proper state to run `checkGuards()` method.
     */
    PreActivation.prototype.setupChildRouteGuards = function (futureNode, currNode, contexts, futurePath) {
        var _this = this;
        var prevChildren = nodeChildrenAsMap(currNode);
        // Process the children of the future route
        futureNode.children.forEach(function (c) {
            _this.setupRouteGuards(c, prevChildren[c.value.outlet], contexts, futurePath.concat([c.value]));
            delete prevChildren[c.value.outlet];
        });
        // Process any children left from the current route (not active for the future route)
        forEach(prevChildren, function (v, k) {
            return _this.deactivateRouteAndItsChildren(v, contexts.getContext(k));
        });
    };
    /**
     * Iterates over child routes and calls recursive `setupRouteGuards` to get `this` instance in
     * proper state to run `checkGuards()` method.
     */
    PreActivation.prototype.setupRouteGuards = function (futureNode, currNode, parentContexts, futurePath) {
        var future = futureNode.value;
        var curr = currNode ? currNode.value : null;
        var context = parentContexts ? parentContexts.getContext(futureNode.value.outlet) : null;
        // reusing the node
        if (curr && future.routeConfig === curr.routeConfig) {
            var shouldRunGuardsAndResolvers = this.shouldRunGuardsAndResolvers(curr, future, future.routeConfig.runGuardsAndResolvers);
            if (shouldRunGuardsAndResolvers) {
                this.canActivateChecks.push(new CanActivate(futurePath));
            }
            else {
                // we need to set the data
                future.data = curr.data;
                future._resolvedData = curr._resolvedData;
            }
            // If we have a component, we need to go through an outlet.
            if (future.component) {
                this.setupChildRouteGuards(futureNode, currNode, context ? context.children : null, futurePath);
                // if we have a componentless route, we recurse but keep the same outlet map.
            }
            else {
                this.setupChildRouteGuards(futureNode, currNode, parentContexts, futurePath);
            }
            if (shouldRunGuardsAndResolvers) {
                var outlet = context.outlet;
                this.canDeactivateChecks.push(new CanDeactivate(outlet.component, curr));
            }
        }
        else {
            if (curr) {
                this.deactivateRouteAndItsChildren(currNode, context);
            }
            this.canActivateChecks.push(new CanActivate(futurePath));
            // If we have a component, we need to go through an outlet.
            if (future.component) {
                this.setupChildRouteGuards(futureNode, null, context ? context.children : null, futurePath);
                // if we have a componentless route, we recurse but keep the same outlet map.
            }
            else {
                this.setupChildRouteGuards(futureNode, null, parentContexts, futurePath);
            }
        }
    };
    PreActivation.prototype.shouldRunGuardsAndResolvers = function (curr, future, mode) {
        switch (mode) {
            case 'always':
                return true;
            case 'paramsOrQueryParamsChange':
                return !equalParamsAndUrlSegments(curr, future) ||
                    !shallowEqual(curr.queryParams, future.queryParams);
            case 'paramsChange':
            default:
                return !equalParamsAndUrlSegments(curr, future);
        }
    };
    PreActivation.prototype.deactivateRouteAndItsChildren = function (route, context) {
        var _this = this;
        var children = nodeChildrenAsMap(route);
        var r = route.value;
        forEach(children, function (node, childName) {
            if (!r.component) {
                _this.deactivateRouteAndItsChildren(node, context);
            }
            else if (context) {
                _this.deactivateRouteAndItsChildren(node, context.children.getContext(childName));
            }
            else {
                _this.deactivateRouteAndItsChildren(node, null);
            }
        });
        if (!r.component) {
            this.canDeactivateChecks.push(new CanDeactivate(null, r));
        }
        else if (context && context.outlet && context.outlet.isActivated) {
            this.canDeactivateChecks.push(new CanDeactivate(context.outlet.component, r));
        }
        else {
            this.canDeactivateChecks.push(new CanDeactivate(null, r));
        }
    };
    PreActivation.prototype.runCanDeactivateChecks = function () {
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(this.canDeactivateChecks)
            .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (check) { return _this.runCanDeactivate(check.component, check.route); }), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["every"])(function (result) { return result === true; }));
    };
    PreActivation.prototype.runCanActivateChecks = function () {
        var _this = this;
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(this.canActivateChecks)
            .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["concatMap"])(function (check) {
            return andObservables(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])([
                _this.fireChildActivationStart(check.route.parent),
                _this.fireActivationStart(check.route), _this.runCanActivateChild(check.path),
                _this.runCanActivate(check.route)
            ]));
        }), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["every"])(function (result) { return result === true; }));
        // this.fireChildActivationStart(check.path),
    };
    /**
     * This should fire off `ActivationStart` events for each route being activated at this
     * level.
     * In other words, if you're activating `a` and `b` below, `path` will contain the
     * `ActivatedRouteSnapshot`s for both and we will fire `ActivationStart` for both. Always
     * return
     * `true` so checks continue to run.
     */
    PreActivation.prototype.fireActivationStart = function (snapshot) {
        if (snapshot !== null && this.forwardEvent) {
            this.forwardEvent(new ActivationStart(snapshot));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(true);
    };
    /**
     * This should fire off `ChildActivationStart` events for each route being activated at this
     * level.
     * In other words, if you're activating `a` and `b` below, `path` will contain the
     * `ActivatedRouteSnapshot`s for both and we will fire `ChildActivationStart` for both. Always
     * return
     * `true` so checks continue to run.
     */
    PreActivation.prototype.fireChildActivationStart = function (snapshot) {
        if (snapshot !== null && this.forwardEvent) {
            this.forwardEvent(new ChildActivationStart(snapshot));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(true);
    };
    PreActivation.prototype.runCanActivate = function (future) {
        var _this = this;
        var canActivate = future.routeConfig ? future.routeConfig.canActivate : null;
        if (!canActivate || canActivate.length === 0)
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(true);
        var obs = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(canActivate).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (c) {
            var guard = _this.getToken(c, future);
            var observable;
            if (guard.canActivate) {
                observable = wrapIntoObservable(guard.canActivate(future, _this.future));
            }
            else {
                observable = wrapIntoObservable(guard(future, _this.future));
            }
            return observable.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["first"])());
        }));
        return andObservables(obs);
    };
    PreActivation.prototype.runCanActivateChild = function (path) {
        var _this = this;
        var future = path[path.length - 1];
        var canActivateChildGuards = path.slice(0, path.length - 1)
            .reverse()
            .map(function (p) { return _this.extractCanActivateChild(p); })
            .filter(function (_) { return _ !== null; });
        return andObservables(Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(canActivateChildGuards).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (d) {
            var obs = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(d.guards).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (c) {
                var guard = _this.getToken(c, d.node);
                var observable;
                if (guard.canActivateChild) {
                    observable = wrapIntoObservable(guard.canActivateChild(future, _this.future));
                }
                else {
                    observable = wrapIntoObservable(guard(future, _this.future));
                }
                return observable.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["first"])());
            }));
            return andObservables(obs);
        })));
    };
    PreActivation.prototype.extractCanActivateChild = function (p) {
        var canActivateChild = p.routeConfig ? p.routeConfig.canActivateChild : null;
        if (!canActivateChild || canActivateChild.length === 0)
            return null;
        return { node: p, guards: canActivateChild };
    };
    PreActivation.prototype.runCanDeactivate = function (component, curr) {
        var _this = this;
        var canDeactivate = curr && curr.routeConfig ? curr.routeConfig.canDeactivate : null;
        if (!canDeactivate || canDeactivate.length === 0)
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(true);
        var canDeactivate$ = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(canDeactivate).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (c) {
            var guard = _this.getToken(c, curr);
            var observable;
            if (guard.canDeactivate) {
                observable =
                    wrapIntoObservable(guard.canDeactivate(component, curr, _this.curr, _this.future));
            }
            else {
                observable = wrapIntoObservable(guard(component, curr, _this.curr, _this.future));
            }
            return observable.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["first"])());
        }));
        return canDeactivate$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["every"])(function (result) { return result === true; }));
    };
    PreActivation.prototype.runResolve = function (future, paramsInheritanceStrategy) {
        var resolve = future._resolve;
        return this.resolveNode(resolve, future).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (resolvedData) {
            future._resolvedData = resolvedData;
            future.data = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, future.data, inheritedParamsDataResolve(future, paramsInheritanceStrategy).resolve);
            return null;
        }));
    };
    PreActivation.prototype.resolveNode = function (resolve, future) {
        var _this = this;
        var keys = Object.keys(resolve);
        if (keys.length === 0) {
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])({});
        }
        if (keys.length === 1) {
            var key_1 = keys[0];
            return this.getResolver(resolve[key_1], future).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (value) {
                var _a;
                return _a = {}, _a[key_1] = value, _a;
            }));
        }
        var data = {};
        var runningResolvers$ = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(keys).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (key) {
            return _this.getResolver(resolve[key], future).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (value) {
                data[key] = value;
                return value;
            }));
        }));
        return runningResolvers$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["last"])(), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function () { return data; }));
    };
    PreActivation.prototype.getResolver = function (injectionToken, future) {
        var resolver = this.getToken(injectionToken, future);
        return resolver.resolve ? wrapIntoObservable(resolver.resolve(future, this.future)) :
            wrapIntoObservable(resolver(future, this.future));
    };
    PreActivation.prototype.getToken = function (token, snapshot) {
        var config = closestLoadedConfig(snapshot);
        var injector = config ? config.module.injector : this.moduleInjector;
        return injector.get(token);
    };
    return PreActivation;
}());
function closestLoadedConfig(snapshot) {
    if (!snapshot)
        return null;
    for (var s = snapshot.parent; s; s = s.parent) {
        var route = s.routeConfig;
        if (route && route._loadedConfig)
            return route._loadedConfig;
    }
    return null;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NoMatch$1 = /*@__PURE__*/ (function () {
    function NoMatch() {
    }
    return NoMatch;
}());
function recognize(rootComponentType, config, urlTree, url, paramsInheritanceStrategy, relativeLinkResolution) {
    if (paramsInheritanceStrategy === void 0) {
        paramsInheritanceStrategy = 'emptyOnly';
    }
    if (relativeLinkResolution === void 0) {
        relativeLinkResolution = 'legacy';
    }
    return new Recognizer(rootComponentType, config, urlTree, url, paramsInheritanceStrategy, relativeLinkResolution)
        .recognize();
}
var Recognizer = /*@__PURE__*/ (function () {
    function Recognizer(rootComponentType, config, urlTree, url, paramsInheritanceStrategy, relativeLinkResolution) {
        this.rootComponentType = rootComponentType;
        this.config = config;
        this.urlTree = urlTree;
        this.url = url;
        this.paramsInheritanceStrategy = paramsInheritanceStrategy;
        this.relativeLinkResolution = relativeLinkResolution;
    }
    Recognizer.prototype.recognize = function () {
        try {
            var rootSegmentGroup = split$1(this.urlTree.root, [], [], this.config, this.relativeLinkResolution).segmentGroup;
            var children = this.processSegmentGroup(this.config, rootSegmentGroup, PRIMARY_OUTLET);
            var root = new ActivatedRouteSnapshot([], Object.freeze({}), Object.freeze(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.urlTree.queryParams)), this.urlTree.fragment, {}, PRIMARY_OUTLET, this.rootComponentType, null, this.urlTree.root, -1, {});
            var rootNode = new TreeNode(root, children);
            var routeState = new RouterStateSnapshot(this.url, rootNode);
            this.inheritParamsAndData(routeState._root);
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(routeState);
        }
        catch (e) {
            return new __WEBPACK_IMPORTED_MODULE_2_rxjs__["d" /* Observable */](function (obs) { return obs.error(e); });
        }
    };
    Recognizer.prototype.inheritParamsAndData = function (routeNode) {
        var _this = this;
        var route = routeNode.value;
        var i = inheritedParamsDataResolve(route, this.paramsInheritanceStrategy);
        route.params = Object.freeze(i.params);
        route.data = Object.freeze(i.data);
        routeNode.children.forEach(function (n) { return _this.inheritParamsAndData(n); });
    };
    Recognizer.prototype.processSegmentGroup = function (config, segmentGroup, outlet) {
        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
            return this.processChildren(config, segmentGroup);
        }
        return this.processSegment(config, segmentGroup, segmentGroup.segments, outlet);
    };
    Recognizer.prototype.processChildren = function (config, segmentGroup) {
        var _this = this;
        var children = mapChildrenIntoArray(segmentGroup, function (child, childOutlet) { return _this.processSegmentGroup(config, child, childOutlet); });
        checkOutletNameUniqueness(children);
        sortActivatedRouteSnapshots(children);
        return children;
    };
    Recognizer.prototype.processSegment = function (config, segmentGroup, segments, outlet) {
        var e_1, _a;
        try {
            for (var config_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(config), config_1_1 = config_1.next(); !config_1_1.done; config_1_1 = config_1.next()) {
                var r = config_1_1.value;
                try {
                    return this.processSegmentAgainstRoute(r, segmentGroup, segments, outlet);
                }
                catch (e) {
                    if (!(e instanceof NoMatch$1))
                        throw e;
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (config_1_1 && !config_1_1.done && (_a = config_1.return))
                    _a.call(config_1);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        if (this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
            return [];
        }
        throw new NoMatch$1();
    };
    Recognizer.prototype.noLeftoversInUrl = function (segmentGroup, segments, outlet) {
        return segments.length === 0 && !segmentGroup.children[outlet];
    };
    Recognizer.prototype.processSegmentAgainstRoute = function (route, rawSegment, segments, outlet) {
        if (route.redirectTo)
            throw new NoMatch$1();
        if ((route.outlet || PRIMARY_OUTLET) !== outlet)
            throw new NoMatch$1();
        var snapshot;
        var consumedSegments = [];
        var rawSlicedSegments = [];
        if (route.path === '**') {
            var params = segments.length > 0 ? last$1(segments).parameters : {};
            snapshot = new ActivatedRouteSnapshot(segments, params, Object.freeze(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.urlTree.queryParams)), this.urlTree.fragment, getData(route), outlet, route.component, route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + segments.length, getResolve(route));
        }
        else {
            var result = match$1(rawSegment, route, segments);
            consumedSegments = result.consumedSegments;
            rawSlicedSegments = segments.slice(result.lastChild);
            snapshot = new ActivatedRouteSnapshot(consumedSegments, result.parameters, Object.freeze(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.urlTree.queryParams)), this.urlTree.fragment, getData(route), outlet, route.component, route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + consumedSegments.length, getResolve(route));
        }
        var childConfig = getChildConfig(route);
        var _a = split$1(rawSegment, consumedSegments, rawSlicedSegments, childConfig, this.relativeLinkResolution), segmentGroup = _a.segmentGroup, slicedSegments = _a.slicedSegments;
        if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
            var children_1 = this.processChildren(childConfig, segmentGroup);
            return [new TreeNode(snapshot, children_1)];
        }
        if (childConfig.length === 0 && slicedSegments.length === 0) {
            return [new TreeNode(snapshot, [])];
        }
        var children = this.processSegment(childConfig, segmentGroup, slicedSegments, PRIMARY_OUTLET);
        return [new TreeNode(snapshot, children)];
    };
    return Recognizer;
}());
function sortActivatedRouteSnapshots(nodes) {
    nodes.sort(function (a, b) {
        if (a.value.outlet === PRIMARY_OUTLET)
            return -1;
        if (b.value.outlet === PRIMARY_OUTLET)
            return 1;
        return a.value.outlet.localeCompare(b.value.outlet);
    });
}
function getChildConfig(route) {
    if (route.children) {
        return route.children;
    }
    if (route.loadChildren) {
        return route._loadedConfig.routes;
    }
    return [];
}
function match$1(segmentGroup, route, segments) {
    if (route.path === '') {
        if (route.pathMatch === 'full' && (segmentGroup.hasChildren() || segments.length > 0)) {
            throw new NoMatch$1();
        }
        return { consumedSegments: [], lastChild: 0, parameters: {} };
    }
    var matcher = route.matcher || defaultUrlMatcher;
    var res = matcher(segments, segmentGroup, route);
    if (!res)
        throw new NoMatch$1();
    var posParams = {};
    forEach(res.posParams, function (v, k) { posParams[k] = v.path; });
    var parameters = res.consumed.length > 0 ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, posParams, res.consumed[res.consumed.length - 1].parameters) :
        posParams;
    return { consumedSegments: res.consumed, lastChild: res.consumed.length, parameters: parameters };
}
function checkOutletNameUniqueness(nodes) {
    var names = {};
    nodes.forEach(function (n) {
        var routeWithSameOutletName = names[n.value.outlet];
        if (routeWithSameOutletName) {
            var p = routeWithSameOutletName.url.map(function (s) { return s.toString(); }).join('/');
            var c = n.value.url.map(function (s) { return s.toString(); }).join('/');
            throw new Error("Two segments cannot have the same outlet name: '" + p + "' and '" + c + "'.");
        }
        names[n.value.outlet] = n.value;
    });
}
function getSourceSegmentGroup(segmentGroup) {
    var s = segmentGroup;
    while (s._sourceSegment) {
        s = s._sourceSegment;
    }
    return s;
}
function getPathIndexShift(segmentGroup) {
    var s = segmentGroup;
    var res = (s._segmentIndexShift ? s._segmentIndexShift : 0);
    while (s._sourceSegment) {
        s = s._sourceSegment;
        res += (s._segmentIndexShift ? s._segmentIndexShift : 0);
    }
    return res - 1;
}
function split$1(segmentGroup, consumedSegments, slicedSegments, config, relativeLinkResolution) {
    if (slicedSegments.length > 0 &&
        containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, config)) {
        var s_1 = new UrlSegmentGroup(consumedSegments, createChildrenForEmptyPaths(segmentGroup, consumedSegments, config, new UrlSegmentGroup(slicedSegments, segmentGroup.children)));
        s_1._sourceSegment = segmentGroup;
        s_1._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s_1, slicedSegments: [] };
    }
    if (slicedSegments.length === 0 &&
        containsEmptyPathMatches(segmentGroup, slicedSegments, config)) {
        var s_2 = new UrlSegmentGroup(segmentGroup.segments, addEmptyPathsToChildrenIfNeeded(segmentGroup, consumedSegments, slicedSegments, config, segmentGroup.children, relativeLinkResolution));
        s_2._sourceSegment = segmentGroup;
        s_2._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s_2, slicedSegments: slicedSegments };
    }
    var s = new UrlSegmentGroup(segmentGroup.segments, segmentGroup.children);
    s._sourceSegment = segmentGroup;
    s._segmentIndexShift = consumedSegments.length;
    return { segmentGroup: s, slicedSegments: slicedSegments };
}
function addEmptyPathsToChildrenIfNeeded(segmentGroup, consumedSegments, slicedSegments, routes, children, relativeLinkResolution) {
    var e_2, _a;
    var res = {};
    try {
        for (var routes_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(routes), routes_1_1 = routes_1.next(); !routes_1_1.done; routes_1_1 = routes_1.next()) {
            var r = routes_1_1.value;
            if (emptyPathMatch(segmentGroup, slicedSegments, r) && !children[getOutlet$1(r)]) {
                var s = new UrlSegmentGroup([], {});
                s._sourceSegment = segmentGroup;
                if (relativeLinkResolution === 'legacy') {
                    s._segmentIndexShift = segmentGroup.segments.length;
                }
                else {
                    s._segmentIndexShift = consumedSegments.length;
                }
                res[getOutlet$1(r)] = s;
            }
        }
    }
    catch (e_2_1) {
        e_2 = { error: e_2_1 };
    }
    finally {
        try {
            if (routes_1_1 && !routes_1_1.done && (_a = routes_1.return))
                _a.call(routes_1);
        }
        finally {
            if (e_2)
                throw e_2.error;
        }
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, children, res);
}
function createChildrenForEmptyPaths(segmentGroup, consumedSegments, routes, primarySegment) {
    var e_3, _a;
    var res = {};
    res[PRIMARY_OUTLET] = primarySegment;
    primarySegment._sourceSegment = segmentGroup;
    primarySegment._segmentIndexShift = consumedSegments.length;
    try {
        for (var routes_2 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(routes), routes_2_1 = routes_2.next(); !routes_2_1.done; routes_2_1 = routes_2.next()) {
            var r = routes_2_1.value;
            if (r.path === '' && getOutlet$1(r) !== PRIMARY_OUTLET) {
                var s = new UrlSegmentGroup([], {});
                s._sourceSegment = segmentGroup;
                s._segmentIndexShift = consumedSegments.length;
                res[getOutlet$1(r)] = s;
            }
        }
    }
    catch (e_3_1) {
        e_3 = { error: e_3_1 };
    }
    finally {
        try {
            if (routes_2_1 && !routes_2_1.done && (_a = routes_2.return))
                _a.call(routes_2);
        }
        finally {
            if (e_3)
                throw e_3.error;
        }
    }
    return res;
}
function containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, routes) {
    return routes.some(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r) && getOutlet$1(r) !== PRIMARY_OUTLET; });
}
function containsEmptyPathMatches(segmentGroup, slicedSegments, routes) {
    return routes.some(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r); });
}
function emptyPathMatch(segmentGroup, slicedSegments, r) {
    if ((segmentGroup.hasChildren() || slicedSegments.length > 0) && r.pathMatch === 'full') {
        return false;
    }
    return r.path === '' && r.redirectTo === undefined;
}
function getOutlet$1(route) {
    return route.outlet || PRIMARY_OUTLET;
}
function getData(route) {
    return route.data || {};
}
function getResolve(route) {
    return route.resolve || {};
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Provides a way to customize when activated routes get reused.
 *
 * @experimental
 */
var RouteReuseStrategy = /*@__PURE__*/ (function () {
    function RouteReuseStrategy() {
    }
    return RouteReuseStrategy;
}());
/**
 * Does not detach any subtrees. Reuses routes as long as their route config is the same.
 */
var DefaultRouteReuseStrategy = /*@__PURE__*/ (function () {
    function DefaultRouteReuseStrategy() {
    }
    DefaultRouteReuseStrategy.prototype.shouldDetach = function (route) { return false; };
    DefaultRouteReuseStrategy.prototype.store = function (route, detachedTree) { };
    DefaultRouteReuseStrategy.prototype.shouldAttach = function (route) { return false; };
    DefaultRouteReuseStrategy.prototype.retrieve = function (route) { return null; };
    DefaultRouteReuseStrategy.prototype.shouldReuseRoute = function (future, curr) {
        return future.routeConfig === curr.routeConfig;
    };
    return DefaultRouteReuseStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @docsNotRequired
 * @experimental
 */
var ROUTES = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('ROUTES');
var RouterConfigLoader = /*@__PURE__*/ (function () {
    function RouterConfigLoader(loader, compiler, onLoadStartListener, onLoadEndListener) {
        this.loader = loader;
        this.compiler = compiler;
        this.onLoadStartListener = onLoadStartListener;
        this.onLoadEndListener = onLoadEndListener;
    }
    RouterConfigLoader.prototype.load = function (parentInjector, route) {
        var _this = this;
        if (this.onLoadStartListener) {
            this.onLoadStartListener(route);
        }
        var moduleFactory$ = this.loadModuleFactory(route.loadChildren);
        return moduleFactory$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (factory) {
            if (_this.onLoadEndListener) {
                _this.onLoadEndListener(route);
            }
            var module = factory.create(parentInjector);
            return new LoadedRouterConfig(flatten(module.injector.get(ROUTES)).map(standardizeConfig), module);
        }));
    };
    RouterConfigLoader.prototype.loadModuleFactory = function (loadChildren) {
        var _this = this;
        if (typeof loadChildren === 'string') {
            return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(this.loader.load(loadChildren));
        }
        else {
            return wrapIntoObservable(loadChildren()).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (t) {
                if (t instanceof __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactory"]) {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(t);
                }
                else {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(_this.compiler.compileModuleAsync(t));
                }
            }));
        }
    };
    return RouterConfigLoader;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Provides a way to migrate AngularJS applications to Angular.
 *
 * @experimental
 */
var UrlHandlingStrategy = /*@__PURE__*/ (function () {
    function UrlHandlingStrategy() {
    }
    return UrlHandlingStrategy;
}());
/**
 * @experimental
 */
var DefaultUrlHandlingStrategy = /*@__PURE__*/ (function () {
    function DefaultUrlHandlingStrategy() {
    }
    DefaultUrlHandlingStrategy.prototype.shouldProcessUrl = function (url) { return true; };
    DefaultUrlHandlingStrategy.prototype.extract = function (url) { return url; };
    DefaultUrlHandlingStrategy.prototype.merge = function (newUrlPart, wholeUrl) { return newUrlPart; };
    return DefaultUrlHandlingStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
function defaultErrorHandler(error) {
    throw error;
}
function defaultMalformedUriErrorHandler(error, urlSerializer, url) {
    return urlSerializer.parse('/');
}
/**
 * @internal
 */
function defaultRouterHook(snapshot, runExtras) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(null);
}
/**
 * @description
 *
 * Provides the navigation and url manipulation capabilities.
 *
 * See `Routes` for more details and examples.
 *
 * @ngModule RouterModule
 *
 *
 */
var Router = /*@__PURE__*/ (function () {
    /**
     * Creates the router service.
     */
    // TODO: vsavkin make internal after the final is out.
    function Router(rootComponentType, urlSerializer, rootContexts, location, injector, loader, compiler, config) {
        var _this = this;
        this.rootComponentType = rootComponentType;
        this.urlSerializer = urlSerializer;
        this.rootContexts = rootContexts;
        this.location = location;
        this.config = config;
        this.navigations = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* BehaviorSubject */](null);
        this.navigationId = 0;
        this.isNgZoneEnabled = false;
        this.events = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["e" /* Subject */]();
        /**
         * Error handler that is invoked when a navigation errors.
         *
         * See `ErrorHandler` for more information.
         */
        this.errorHandler = defaultErrorHandler;
        /**
         * Malformed uri error handler is invoked when `Router.parseUrl(url)` throws an
         * error due to containing an invalid character. The most common case would be a `%` sign
         * that's not encoded and is not part of a percent encoded sequence.
         */
        this.malformedUriErrorHandler = defaultMalformedUriErrorHandler;
        /**
         * Indicates if at least one navigation happened.
         */
        this.navigated = false;
        this.lastSuccessfulId = -1;
        /**
         * Used by RouterModule. This allows us to
         * pause the navigation either before preactivation or after it.
         * @internal
         */
        this.hooks = {
            beforePreactivation: defaultRouterHook,
            afterPreactivation: defaultRouterHook
        };
        /**
         * Extracts and merges URLs. Used for AngularJS to Angular migrations.
         */
        this.urlHandlingStrategy = new DefaultUrlHandlingStrategy();
        this.routeReuseStrategy = new DefaultRouteReuseStrategy();
        /**
         * Define what the router should do if it receives a navigation request to the current URL.
         * By default, the router will ignore this navigation. However, this prevents features such
         * as a "refresh" button. Use this option to configure the behavior when navigating to the
         * current URL. Default is 'ignore'.
         */
        this.onSameUrlNavigation = 'ignore';
        /**
         * Defines how the router merges params, data and resolved data from parent to child
         * routes. Available options are:
         *
         * - `'emptyOnly'`, the default, only inherits parent params for path-less or component-less
         *   routes.
         * - `'always'`, enables unconditional inheritance of parent params.
         */
        this.paramsInheritanceStrategy = 'emptyOnly';
        /**
         * Defines when the router updates the browser URL. The default behavior is to update after
         * successful navigation. However, some applications may prefer a mode where the URL gets
         * updated at the beginning of navigation. The most common use case would be updating the
         * URL early so if navigation fails, you can show an error message with the URL that failed.
         * Available options are:
         *
         * - `'deferred'`, the default, updates the browser URL after navigation has finished.
         * - `'eager'`, updates browser URL at the beginning of navigation.
         */
        this.urlUpdateStrategy = 'deferred';
        /**
         * See {@link RouterModule} for more information.
         */
        this.relativeLinkResolution = 'legacy';
        var onLoadStart = function (r) { return _this.triggerEvent(new RouteConfigLoadStart(r)); };
        var onLoadEnd = function (r) { return _this.triggerEvent(new RouteConfigLoadEnd(r)); };
        this.ngModule = injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleRef"]);
        this.console = injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵConsole"]);
        var ngZone = injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"]);
        this.isNgZoneEnabled = ngZone instanceof __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"];
        this.resetConfig(config);
        this.currentUrlTree = createEmptyUrlTree();
        this.rawUrlTree = this.currentUrlTree;
        this.configLoader = new RouterConfigLoader(loader, compiler, onLoadStart, onLoadEnd);
        this.routerState = createEmptyState(this.currentUrlTree, this.rootComponentType);
        this.processNavigations();
    }
    /**
     * @internal
     * TODO: this should be removed once the constructor of the router made internal
     */
    Router.prototype.resetRootComponentType = function (rootComponentType) {
        this.rootComponentType = rootComponentType;
        // TODO: vsavkin router 4.0 should make the root component set to null
        // this will simplify the lifecycle of the router.
        this.routerState.root.component = this.rootComponentType;
    };
    /**
     * Sets up the location change listener and performs the initial navigation.
     */
    Router.prototype.initialNavigation = function () {
        this.setUpLocationChangeListener();
        if (this.navigationId === 0) {
            this.navigateByUrl(this.location.path(true), { replaceUrl: true });
        }
    };
    /**
     * Sets up the location change listener.
     */
    Router.prototype.setUpLocationChangeListener = function () {
        var _this = this;
        // Don't need to use Zone.wrap any more, because zone.js
        // already patch onPopState, so location change callback will
        // run into ngZone
        if (!this.locationSubscription) {
            this.locationSubscription = this.location.subscribe(function (change) {
                var rawUrlTree = _this.parseUrl(change['url']);
                var source = change['type'] === 'popstate' ? 'popstate' : 'hashchange';
                var state = change.state && change.state.navigationId ?
                    { navigationId: change.state.navigationId } :
                    null;
                setTimeout(function () { _this.scheduleNavigation(rawUrlTree, source, state, { replaceUrl: true }); }, 0);
            });
        }
    };
    Object.defineProperty(Router.prototype, "url", {
        /** The current url */
        get: function () { return this.serializeUrl(this.currentUrlTree); },
        enumerable: true,
        configurable: true
    });
    /** @internal */
    Router.prototype.triggerEvent = function (event) { this.events.next(event); };
    /**
     * Resets the configuration used for navigation and generating links.
     *
     * @usageNotes
     *
     * ### Example
     *
     * ```
     * router.resetConfig([
     *  { path: 'team/:id', component: TeamCmp, children: [
     *    { path: 'simple', component: SimpleCmp },
     *    { path: 'user/:name', component: UserCmp }
     *  ]}
     * ]);
     * ```
     */
    Router.prototype.resetConfig = function (config) {
        validateConfig(config);
        this.config = config.map(standardizeConfig);
        this.navigated = false;
        this.lastSuccessfulId = -1;
    };
    /** @docsNotRequired */
    Router.prototype.ngOnDestroy = function () { this.dispose(); };
    /** Disposes of the router */
    Router.prototype.dispose = function () {
        if (this.locationSubscription) {
            this.locationSubscription.unsubscribe();
            this.locationSubscription = null;
        }
    };
    /**
     * Applies an array of commands to the current url tree and creates a new url tree.
     *
     * When given an activate route, applies the given commands starting from the route.
     * When not given a route, applies the given command starting from the root.
     *
     * @usageNotes
     *
     * ### Example
     *
     * ```
     * // create /team/33/user/11
     * router.createUrlTree(['/team', 33, 'user', 11]);
     *
     * // create /team/33;expand=true/user/11
     * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
     *
     * // you can collapse static segments like this (this works only with the first passed-in value):
     * router.createUrlTree(['/team/33/user', userId]);
     *
     * // If the first segment can contain slashes, and you do not want the router to split it, you
     * // can do the following:
     *
     * router.createUrlTree([{segmentPath: '/one/two'}]);
     *
     * // create /team/33/(user/11//right:chat)
     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: 'chat'}}]);
     *
     * // remove the right secondary node
     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: null}}]);
     *
     * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
     *
     * // navigate to /team/33/user/11/details
     * router.createUrlTree(['details'], {relativeTo: route});
     *
     * // navigate to /team/33/user/22
     * router.createUrlTree(['../22'], {relativeTo: route});
     *
     * // navigate to /team/44/user/22
     * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
     * ```
     */
    Router.prototype.createUrlTree = function (commands, navigationExtras) {
        if (navigationExtras === void 0) {
            navigationExtras = {};
        }
        var relativeTo = navigationExtras.relativeTo, queryParams = navigationExtras.queryParams, fragment = navigationExtras.fragment, preserveQueryParams = navigationExtras.preserveQueryParams, queryParamsHandling = navigationExtras.queryParamsHandling, preserveFragment = navigationExtras.preserveFragment;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() && preserveQueryParams && console && console.warn) {
            console.warn('preserveQueryParams is deprecated, use queryParamsHandling instead.');
        }
        var a = relativeTo || this.routerState.root;
        var f = preserveFragment ? this.currentUrlTree.fragment : fragment;
        var q = null;
        if (queryParamsHandling) {
            switch (queryParamsHandling) {
                case 'merge':
                    q = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.currentUrlTree.queryParams, queryParams);
                    break;
                case 'preserve':
                    q = this.currentUrlTree.queryParams;
                    break;
                default:
                    q = queryParams || null;
            }
        }
        else {
            q = preserveQueryParams ? this.currentUrlTree.queryParams : queryParams || null;
        }
        if (q !== null) {
            q = this.removeEmptyProps(q);
        }
        return createUrlTree(a, this.currentUrlTree, commands, q, f);
    };
    /**
     * Navigate based on the provided url. This navigation is always absolute.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * @usageNotes
     *
     * ### Example
     *
     * ```
     * router.navigateByUrl("/team/33/user/11");
     *
     * // Navigate without updating the URL
     * router.navigateByUrl("/team/33/user/11", { skipLocationChange: true });
     * ```
     *
     * Since `navigateByUrl()` takes an absolute URL as the first parameter,
     * it will not apply any delta to the current URL and ignores any properties
     * in the second parameter (the `NavigationExtras`) that would change the
     * provided URL.
     */
    Router.prototype.navigateByUrl = function (url, extras) {
        if (extras === void 0) {
            extras = { skipLocationChange: false };
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() && this.isNgZoneEnabled && !__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"].isInAngularZone()) {
            this.console.warn("Navigation triggered outside Angular zone, did you forget to call 'ngZone.run()'?");
        }
        var urlTree = url instanceof UrlTree ? url : this.parseUrl(url);
        var mergedTree = this.urlHandlingStrategy.merge(urlTree, this.rawUrlTree);
        return this.scheduleNavigation(mergedTree, 'imperative', null, extras);
    };
    /**
     * Navigate based on the provided array of commands and a starting point.
     * If no starting route is provided, the navigation is absolute.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * @usageNotes
     *
     * ### Example
     *
     * ```
     * router.navigate(['team', 33, 'user', 11], {relativeTo: route});
     *
     * // Navigate without updating the URL
     * router.navigate(['team', 33, 'user', 11], {relativeTo: route, skipLocationChange: true});
     * ```
     *
     * The first parameter of `navigate()` is a delta to be applied to the current URL
     * or the one provided in the `relativeTo` property of the second parameter (the
     * `NavigationExtras`).
     */
    Router.prototype.navigate = function (commands, extras) {
        if (extras === void 0) {
            extras = { skipLocationChange: false };
        }
        validateCommands(commands);
        return this.navigateByUrl(this.createUrlTree(commands, extras), extras);
    };
    /** Serializes a `UrlTree` into a string */
    Router.prototype.serializeUrl = function (url) { return this.urlSerializer.serialize(url); };
    /** Parses a string into a `UrlTree` */
    Router.prototype.parseUrl = function (url) {
        var urlTree;
        try {
            urlTree = this.urlSerializer.parse(url);
        }
        catch (e) {
            urlTree = this.malformedUriErrorHandler(e, this.urlSerializer, url);
        }
        return urlTree;
    };
    /** Returns whether the url is activated */
    Router.prototype.isActive = function (url, exact) {
        if (url instanceof UrlTree) {
            return containsTree(this.currentUrlTree, url, exact);
        }
        var urlTree = this.parseUrl(url);
        return containsTree(this.currentUrlTree, urlTree, exact);
    };
    Router.prototype.removeEmptyProps = function (params) {
        return Object.keys(params).reduce(function (result, key) {
            var value = params[key];
            if (value !== null && value !== undefined) {
                result[key] = value;
            }
            return result;
        }, {});
    };
    Router.prototype.processNavigations = function () {
        var _this = this;
        this.navigations
            .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["concatMap"])(function (nav) {
            if (nav) {
                _this.executeScheduledNavigation(nav);
                // a failed navigation should not stop the router from processing
                // further navigations => the catch
                return nav.promise.catch(function () { });
            }
            else {
                return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(null);
            }
        }))
            .subscribe(function () { });
    };
    Router.prototype.scheduleNavigation = function (rawUrl, source, state, extras) {
        var lastNavigation = this.navigations.value;
        // If the user triggers a navigation imperatively (e.g., by using navigateByUrl),
        // and that navigation results in 'replaceState' that leads to the same URL,
        // we should skip those.
        if (lastNavigation && source !== 'imperative' && lastNavigation.source === 'imperative' &&
            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
            return Promise.resolve(true); // return value is not used
        }
        // Because of a bug in IE and Edge, the location class fires two events (popstate and
        // hashchange) every single time. The second one should be ignored. Otherwise, the URL will
        // flicker. Handles the case when a popstate was emitted first.
        if (lastNavigation && source == 'hashchange' && lastNavigation.source === 'popstate' &&
            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
            return Promise.resolve(true); // return value is not used
        }
        // Because of a bug in IE and Edge, the location class fires two events (popstate and
        // hashchange) every single time. The second one should be ignored. Otherwise, the URL will
        // flicker. Handles the case when a hashchange was emitted first.
        if (lastNavigation && source == 'popstate' && lastNavigation.source === 'hashchange' &&
            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
            return Promise.resolve(true); // return value is not used
        }
        var resolve = null;
        var reject = null;
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        var id = ++this.navigationId;
        this.navigations.next({ id: id, source: source, state: state, rawUrl: rawUrl, extras: extras, resolve: resolve, reject: reject, promise: promise });
        // Make sure that the error is propagated even though `processNavigations` catch
        // handler does not rethrow
        return promise.catch(function (e) { return Promise.reject(e); });
    };
    Router.prototype.executeScheduledNavigation = function (_a) {
        var _this = this;
        var id = _a.id, rawUrl = _a.rawUrl, extras = _a.extras, resolve = _a.resolve, reject = _a.reject, source = _a.source, state = _a.state;
        var url = this.urlHandlingStrategy.extract(rawUrl);
        var urlTransition = !this.navigated || url.toString() !== this.currentUrlTree.toString();
        if ((this.onSameUrlNavigation === 'reload' ? true : urlTransition) &&
            this.urlHandlingStrategy.shouldProcessUrl(rawUrl)) {
            if (this.urlUpdateStrategy === 'eager' && !extras.skipLocationChange) {
                this.setBrowserUrl(rawUrl, !!extras.replaceUrl, id);
            }
            this.events
                .next(new NavigationStart(id, this.serializeUrl(url), source, state));
            Promise.resolve()
                .then(function (_) { return _this.runNavigate(url, rawUrl, !!extras.skipLocationChange, !!extras.replaceUrl, id, null); })
                .then(resolve, reject);
            // we cannot process the current URL, but we could process the previous one =>
            // we need to do some cleanup
        }
        else if (urlTransition && this.rawUrlTree &&
            this.urlHandlingStrategy.shouldProcessUrl(this.rawUrlTree)) {
            this.events
                .next(new NavigationStart(id, this.serializeUrl(url), source, state));
            Promise.resolve()
                .then(function (_) { return _this.runNavigate(url, rawUrl, false, false, id, createEmptyState(url, _this.rootComponentType).snapshot); })
                .then(resolve, reject);
        }
        else {
            this.rawUrlTree = rawUrl;
            resolve(null);
        }
    };
    Router.prototype.runNavigate = function (url, rawUrl, skipLocationChange, replaceUrl, id, precreatedState) {
        var _this = this;
        if (id !== this.navigationId) {
            this.events
                .next(new NavigationCancel(id, this.serializeUrl(url), "Navigation ID " + id + " is not equal to the current navigation id " + this.navigationId));
            return Promise.resolve(false);
        }
        return new Promise(function (resolvePromise, rejectPromise) {
            // create an observable of the url and route state snapshot
            // this operation do not result in any side effects
            var urlAndSnapshot$;
            if (!precreatedState) {
                var moduleInjector = _this.ngModule.injector;
                var redirectsApplied$ = applyRedirects(moduleInjector, _this.configLoader, _this.urlSerializer, url, _this.config);
                urlAndSnapshot$ = redirectsApplied$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (appliedUrl) {
                    return recognize(_this.rootComponentType, _this.config, appliedUrl, _this.serializeUrl(appliedUrl), _this.paramsInheritanceStrategy, _this.relativeLinkResolution)
                        .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (snapshot) {
                        _this.events
                            .next(new RoutesRecognized(id, _this.serializeUrl(url), _this.serializeUrl(appliedUrl), snapshot));
                        return { appliedUrl: appliedUrl, snapshot: snapshot };
                    }));
                }));
            }
            else {
                urlAndSnapshot$ = Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])({ appliedUrl: url, snapshot: precreatedState });
            }
            var beforePreactivationDone$ = urlAndSnapshot$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (p) {
                if (typeof p === 'boolean')
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(p);
                return _this.hooks
                    .beforePreactivation(p.snapshot, {
                    navigationId: id,
                    appliedUrlTree: url,
                    rawUrlTree: rawUrl, skipLocationChange: skipLocationChange, replaceUrl: replaceUrl,
                })
                    .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function () { return p; }));
            }));
            // run preactivation: guards and data resolvers
            var preActivation;
            var preactivationSetup$ = beforePreactivationDone$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (p) {
                if (typeof p === 'boolean')
                    return p;
                var appliedUrl = p.appliedUrl, snapshot = p.snapshot;
                var moduleInjector = _this.ngModule.injector;
                preActivation = new PreActivation(snapshot, _this.routerState.snapshot, moduleInjector, function (evt) { return _this.triggerEvent(evt); });
                preActivation.initialize(_this.rootContexts);
                return { appliedUrl: appliedUrl, snapshot: snapshot };
            }));
            var preactivationCheckGuards$ = preactivationSetup$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (p) {
                if (typeof p === 'boolean' || _this.navigationId !== id)
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(false);
                var appliedUrl = p.appliedUrl, snapshot = p.snapshot;
                _this.triggerEvent(new GuardsCheckStart(id, _this.serializeUrl(url), _this.serializeUrl(appliedUrl), snapshot));
                return preActivation.checkGuards().pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (shouldActivate) {
                    _this.triggerEvent(new GuardsCheckEnd(id, _this.serializeUrl(url), _this.serializeUrl(appliedUrl), snapshot, shouldActivate));
                    return { appliedUrl: appliedUrl, snapshot: snapshot, shouldActivate: shouldActivate };
                }));
            }));
            var preactivationResolveData$ = preactivationCheckGuards$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (p) {
                if (typeof p === 'boolean' || _this.navigationId !== id)
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(false);
                if (p.shouldActivate && preActivation.isActivating()) {
                    _this.triggerEvent(new ResolveStart(id, _this.serializeUrl(url), _this.serializeUrl(p.appliedUrl), p.snapshot));
                    return preActivation.resolveData(_this.paramsInheritanceStrategy).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function () {
                        _this.triggerEvent(new ResolveEnd(id, _this.serializeUrl(url), _this.serializeUrl(p.appliedUrl), p.snapshot));
                        return p;
                    }));
                }
                else {
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(p);
                }
            }));
            var preactivationDone$ = preactivationResolveData$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (p) {
                if (typeof p === 'boolean' || _this.navigationId !== id)
                    return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(false);
                return _this.hooks
                    .afterPreactivation(p.snapshot, {
                    navigationId: id,
                    appliedUrlTree: url,
                    rawUrlTree: rawUrl, skipLocationChange: skipLocationChange, replaceUrl: replaceUrl,
                })
                    .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function () { return p; }));
            }));
            // create router state
            // this operation has side effects => route state is being affected
            var routerState$ = preactivationDone$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (p) {
                if (typeof p === 'boolean' || _this.navigationId !== id)
                    return false;
                var appliedUrl = p.appliedUrl, snapshot = p.snapshot, shouldActivate = p.shouldActivate;
                if (shouldActivate) {
                    var state = createRouterState(_this.routeReuseStrategy, snapshot, _this.routerState);
                    return { appliedUrl: appliedUrl, state: state, shouldActivate: shouldActivate };
                }
                else {
                    return { appliedUrl: appliedUrl, state: null, shouldActivate: shouldActivate };
                }
            }));
            _this.activateRoutes(routerState$, _this.routerState, _this.currentUrlTree, id, url, rawUrl, skipLocationChange, replaceUrl, resolvePromise, rejectPromise);
        });
    };
    /**
     * Performs the logic of activating routes. This is a synchronous process by default. While this
     * is a private method, it could be overridden to make activation asynchronous.
     */
    Router.prototype.activateRoutes = function (state, storedState, storedUrl, id, url, rawUrl, skipLocationChange, replaceUrl, resolvePromise, rejectPromise) {
        var _this = this;
        // applied the new router state
        // this operation has side effects
        var navigationIsSuccessful;
        state
            .forEach(function (p) {
            if (typeof p === 'boolean' || !p.shouldActivate || id !== _this.navigationId || !p.state) {
                navigationIsSuccessful = false;
                return;
            }
            var appliedUrl = p.appliedUrl, state = p.state;
            _this.currentUrlTree = appliedUrl;
            _this.rawUrlTree = _this.urlHandlingStrategy.merge(_this.currentUrlTree, rawUrl);
            _this.routerState = state;
            if (_this.urlUpdateStrategy === 'deferred' && !skipLocationChange) {
                _this.setBrowserUrl(_this.rawUrlTree, replaceUrl, id);
            }
            new ActivateRoutes(_this.routeReuseStrategy, state, storedState, function (evt) { return _this.triggerEvent(evt); })
                .activate(_this.rootContexts);
            navigationIsSuccessful = true;
        })
            .then(function () {
            if (navigationIsSuccessful) {
                _this.navigated = true;
                _this.lastSuccessfulId = id;
                _this.events
                    .next(new NavigationEnd(id, _this.serializeUrl(url), _this.serializeUrl(_this.currentUrlTree)));
                resolvePromise(true);
            }
            else {
                _this.resetUrlToCurrentUrlTree();
                _this.events
                    .next(new NavigationCancel(id, _this.serializeUrl(url), ''));
                resolvePromise(false);
            }
        }, function (e) {
            if (isNavigationCancelingError(e)) {
                _this.navigated = true;
                _this.resetStateAndUrl(storedState, storedUrl, rawUrl);
                _this.events
                    .next(new NavigationCancel(id, _this.serializeUrl(url), e.message));
                resolvePromise(false);
            }
            else {
                _this.resetStateAndUrl(storedState, storedUrl, rawUrl);
                _this.events
                    .next(new NavigationError(id, _this.serializeUrl(url), e));
                try {
                    resolvePromise(_this.errorHandler(e));
                }
                catch (ee) {
                    rejectPromise(ee);
                }
            }
        });
    };
    Router.prototype.setBrowserUrl = function (url, replaceUrl, id) {
        var path = this.urlSerializer.serialize(url);
        if (this.location.isCurrentPathEqualTo(path) || replaceUrl) {
            this.location.replaceState(path, '', { navigationId: id });
        }
        else {
            this.location.go(path, '', { navigationId: id });
        }
    };
    Router.prototype.resetStateAndUrl = function (storedState, storedUrl, rawUrl) {
        this.routerState = storedState;
        this.currentUrlTree = storedUrl;
        this.rawUrlTree = this.urlHandlingStrategy.merge(this.currentUrlTree, rawUrl);
        this.resetUrlToCurrentUrlTree();
    };
    Router.prototype.resetUrlToCurrentUrlTree = function () {
        this.location.replaceState(this.urlSerializer.serialize(this.rawUrlTree), '', { navigationId: this.lastSuccessfulId });
    };
    return Router;
}());
var ActivateRoutes = /*@__PURE__*/ (function () {
    function ActivateRoutes(routeReuseStrategy, futureState, currState, forwardEvent) {
        this.routeReuseStrategy = routeReuseStrategy;
        this.futureState = futureState;
        this.currState = currState;
        this.forwardEvent = forwardEvent;
    }
    ActivateRoutes.prototype.activate = function (parentContexts) {
        var futureRoot = this.futureState._root;
        var currRoot = this.currState ? this.currState._root : null;
        this.deactivateChildRoutes(futureRoot, currRoot, parentContexts);
        advanceActivatedRoute(this.futureState.root);
        this.activateChildRoutes(futureRoot, currRoot, parentContexts);
    };
    // De-activate the child route that are not re-used for the future state
    ActivateRoutes.prototype.deactivateChildRoutes = function (futureNode, currNode, contexts) {
        var _this = this;
        var children = nodeChildrenAsMap(currNode);
        // Recurse on the routes active in the future state to de-activate deeper children
        futureNode.children.forEach(function (futureChild) {
            var childOutletName = futureChild.value.outlet;
            _this.deactivateRoutes(futureChild, children[childOutletName], contexts);
            delete children[childOutletName];
        });
        // De-activate the routes that will not be re-used
        forEach(children, function (v, childName) {
            _this.deactivateRouteAndItsChildren(v, contexts);
        });
    };
    ActivateRoutes.prototype.deactivateRoutes = function (futureNode, currNode, parentContext) {
        var future = futureNode.value;
        var curr = currNode ? currNode.value : null;
        if (future === curr) {
            // Reusing the node, check to see if the children need to be de-activated
            if (future.component) {
                // If we have a normal route, we need to go through an outlet.
                var context = parentContext.getContext(future.outlet);
                if (context) {
                    this.deactivateChildRoutes(futureNode, currNode, context.children);
                }
            }
            else {
                // if we have a componentless route, we recurse but keep the same outlet map.
                this.deactivateChildRoutes(futureNode, currNode, parentContext);
            }
        }
        else {
            if (curr) {
                // Deactivate the current route which will not be re-used
                this.deactivateRouteAndItsChildren(currNode, parentContext);
            }
        }
    };
    ActivateRoutes.prototype.deactivateRouteAndItsChildren = function (route, parentContexts) {
        if (this.routeReuseStrategy.shouldDetach(route.value.snapshot)) {
            this.detachAndStoreRouteSubtree(route, parentContexts);
        }
        else {
            this.deactivateRouteAndOutlet(route, parentContexts);
        }
    };
    ActivateRoutes.prototype.detachAndStoreRouteSubtree = function (route, parentContexts) {
        var context = parentContexts.getContext(route.value.outlet);
        if (context && context.outlet) {
            var componentRef = context.outlet.detach();
            var contexts = context.children.onOutletDeactivated();
            this.routeReuseStrategy.store(route.value.snapshot, { componentRef: componentRef, route: route, contexts: contexts });
        }
    };
    ActivateRoutes.prototype.deactivateRouteAndOutlet = function (route, parentContexts) {
        var _this = this;
        var context = parentContexts.getContext(route.value.outlet);
        if (context) {
            var children = nodeChildrenAsMap(route);
            var contexts_1 = route.value.component ? context.children : parentContexts;
            forEach(children, function (v, k) { return _this.deactivateRouteAndItsChildren(v, contexts_1); });
            if (context.outlet) {
                // Destroy the component
                context.outlet.deactivate();
                // Destroy the contexts for all the outlets that were in the component
                context.children.onOutletDeactivated();
            }
        }
    };
    ActivateRoutes.prototype.activateChildRoutes = function (futureNode, currNode, contexts) {
        var _this = this;
        var children = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) {
            _this.activateRoutes(c, children[c.value.outlet], contexts);
            _this.forwardEvent(new ActivationEnd(c.value.snapshot));
        });
        if (futureNode.children.length) {
            this.forwardEvent(new ChildActivationEnd(futureNode.value.snapshot));
        }
    };
    ActivateRoutes.prototype.activateRoutes = function (futureNode, currNode, parentContexts) {
        var future = futureNode.value;
        var curr = currNode ? currNode.value : null;
        advanceActivatedRoute(future);
        // reusing the node
        if (future === curr) {
            if (future.component) {
                // If we have a normal route, we need to go through an outlet.
                var context = parentContexts.getOrCreateContext(future.outlet);
                this.activateChildRoutes(futureNode, currNode, context.children);
            }
            else {
                // if we have a componentless route, we recurse but keep the same outlet map.
                this.activateChildRoutes(futureNode, currNode, parentContexts);
            }
        }
        else {
            if (future.component) {
                // if we have a normal route, we need to place the component into the outlet and recurse.
                var context = parentContexts.getOrCreateContext(future.outlet);
                if (this.routeReuseStrategy.shouldAttach(future.snapshot)) {
                    var stored = this.routeReuseStrategy.retrieve(future.snapshot);
                    this.routeReuseStrategy.store(future.snapshot, null);
                    context.children.onOutletReAttached(stored.contexts);
                    context.attachRef = stored.componentRef;
                    context.route = stored.route.value;
                    if (context.outlet) {
                        // Attach right away when the outlet has already been instantiated
                        // Otherwise attach from `RouterOutlet.ngOnInit` when it is instantiated
                        context.outlet.attach(stored.componentRef, stored.route.value);
                    }
                    advanceActivatedRouteNodeAndItsChildren(stored.route);
                }
                else {
                    var config = parentLoadedConfig(future.snapshot);
                    var cmpFactoryResolver = config ? config.module.componentFactoryResolver : null;
                    context.attachRef = null;
                    context.route = future;
                    context.resolver = cmpFactoryResolver;
                    if (context.outlet) {
                        // Activate the outlet when it has already been instantiated
                        // Otherwise it will get activated from its `ngOnInit` when instantiated
                        context.outlet.activateWith(future, cmpFactoryResolver);
                    }
                    this.activateChildRoutes(futureNode, null, context.children);
                }
            }
            else {
                // if we have a componentless route, we recurse but keep the same outlet map.
                this.activateChildRoutes(futureNode, null, parentContexts);
            }
        }
    };
    return ActivateRoutes;
}());
function advanceActivatedRouteNodeAndItsChildren(node) {
    advanceActivatedRoute(node.value);
    node.children.forEach(advanceActivatedRouteNodeAndItsChildren);
}
function parentLoadedConfig(snapshot) {
    for (var s = snapshot.parent; s; s = s.parent) {
        var route = s.routeConfig;
        if (route && route._loadedConfig)
            return route._loadedConfig;
        if (route && route.component)
            return null;
    }
    return null;
}
function validateCommands(commands) {
    for (var i = 0; i < commands.length; i++) {
        var cmd = commands[i];
        if (cmd == null) {
            throw new Error("The requested path contains " + cmd + " segment at index " + i);
        }
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Lets you link to specific routes in your app.
 *
 * Consider the following route configuration:
 * `[{ path: 'user/:name', component: UserCmp }]`.
 * When linking to this `user/:name` route, you use the `RouterLink` directive.
 *
 * If the link is static, you can use the directive as follows:
 * `<a routerLink="/user/bob">link to user component</a>`
 *
 * If you use dynamic values to generate the link, you can pass an array of path
 * segments, followed by the params for each segment.
 *
 * For instance `['/team', teamId, 'user', userName, {details: true}]`
 * means that we want to generate a link to `/team/11/user/bob;details=true`.
 *
 * Multiple static segments can be merged into one
 * (e.g., `['/team/11/user', userName, {details: true}]`).
 *
 * The first segment name can be prepended with `/`, `./`, or `../`:
 * * If the first segment begins with `/`, the router will look up the route from the root of the
 *   app.
 * * If the first segment begins with `./`, or doesn't begin with a slash, the router will
 *   instead look in the children of the current activated route.
 * * And if the first segment begins with `../`, the router will go up one level.
 *
 * You can set query params and fragment as follows:
 *
 * ```
 * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" fragment="education">
 *   link to user component
 * </a>
 * ```
 * RouterLink will use these to generate this link: `/user/bob#education?debug=true`.
 *
 * (Deprecated in v4.0.0 use `queryParamsHandling` instead) You can also tell the
 * directive to preserve the current query params and fragment:
 *
 * ```
 * <a [routerLink]="['/user/bob']" preserveQueryParams preserveFragment>
 *   link to user component
 * </a>
 * ```
 *
 * You can tell the directive to how to handle queryParams, available options are:
 *  - `'merge'`: merge the queryParams into the current queryParams
 *  - `'preserve'`: preserve the current queryParams
 *  - default/`''`: use the queryParams only
 *
 * Same options for {@link NavigationExtras#queryParamsHandling
 * NavigationExtras#queryParamsHandling}.
 *
 * ```
 * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" queryParamsHandling="merge">
 *   link to user component
 * </a>
 * ```
 *
 * The router link directive always treats the provided input as a delta to the current url.
 *
 * For instance, if the current url is `/user/(box//aux:team)`.
 *
 * Then the following link `<a [routerLink]="['/user/jim']">Jim</a>` will generate the link
 * `/user/(jim//aux:team)`.
 *
 * See {@link Router#createUrlTree createUrlTree} for more information.
 *
 * @ngModule RouterModule
 *
 *
 */
var RouterLink = /*@__PURE__*/ (function () {
    function RouterLink(router, route, tabIndex, renderer, el) {
        this.router = router;
        this.route = route;
        this.commands = [];
        if (tabIndex == null) {
            renderer.setAttribute(el.nativeElement, 'tabindex', '0');
        }
    }
    Object.defineProperty(RouterLink.prototype, "routerLink", {
        set: function (commands) {
            if (commands != null) {
                this.commands = Array.isArray(commands) ? commands : [commands];
            }
            else {
                this.commands = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterLink.prototype, "preserveQueryParams", {
        /**
         * @deprecated 4.0.0 use `queryParamsHandling` instead.
         */
        set: function (value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() && console && console.warn) {
                console.warn('preserveQueryParams is deprecated!, use queryParamsHandling instead.');
            }
            this.preserve = value;
        },
        enumerable: true,
        configurable: true
    });
    RouterLink.prototype.onClick = function () {
        var extras = {
            skipLocationChange: attrBoolValue(this.skipLocationChange),
            replaceUrl: attrBoolValue(this.replaceUrl),
        };
        this.router.navigateByUrl(this.urlTree, extras);
        return true;
    };
    Object.defineProperty(RouterLink.prototype, "urlTree", {
        get: function () {
            return this.router.createUrlTree(this.commands, {
                relativeTo: this.route,
                queryParams: this.queryParams,
                fragment: this.fragment,
                preserveQueryParams: attrBoolValue(this.preserve),
                queryParamsHandling: this.queryParamsHandling,
                preserveFragment: attrBoolValue(this.preserveFragment),
            });
        },
        enumerable: true,
        configurable: true
    });
    RouterLink = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(2, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Attribute"])('tabindex'))
    ], RouterLink);
    return RouterLink;
}());
/**
 * @description
 *
 * Lets you link to specific routes in your app.
 *
 * See `RouterLink` for more information.
 *
 * @ngModule RouterModule
 *
 *
 */
var RouterLinkWithHref = /*@__PURE__*/ (function () {
    function RouterLinkWithHref(router, route, locationStrategy) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.locationStrategy = locationStrategy;
        this.commands = [];
        this.subscription = router.events.subscribe(function (s) {
            if (s instanceof NavigationEnd) {
                _this.updateTargetUrlAndHref();
            }
        });
    }
    Object.defineProperty(RouterLinkWithHref.prototype, "routerLink", {
        set: function (commands) {
            if (commands != null) {
                this.commands = Array.isArray(commands) ? commands : [commands];
            }
            else {
                this.commands = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterLinkWithHref.prototype, "preserveQueryParams", {
        set: function (value) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() && console && console.warn) {
                console.warn('preserveQueryParams is deprecated, use queryParamsHandling instead.');
            }
            this.preserve = value;
        },
        enumerable: true,
        configurable: true
    });
    RouterLinkWithHref.prototype.ngOnChanges = function (changes) { this.updateTargetUrlAndHref(); };
    RouterLinkWithHref.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    RouterLinkWithHref.prototype.onClick = function (button, ctrlKey, metaKey, shiftKey) {
        if (button !== 0 || ctrlKey || metaKey || shiftKey) {
            return true;
        }
        if (typeof this.target === 'string' && this.target != '_self') {
            return true;
        }
        var extras = {
            skipLocationChange: attrBoolValue(this.skipLocationChange),
            replaceUrl: attrBoolValue(this.replaceUrl),
        };
        this.router.navigateByUrl(this.urlTree, extras);
        return false;
    };
    RouterLinkWithHref.prototype.updateTargetUrlAndHref = function () {
        this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));
    };
    Object.defineProperty(RouterLinkWithHref.prototype, "urlTree", {
        get: function () {
            return this.router.createUrlTree(this.commands, {
                relativeTo: this.route,
                queryParams: this.queryParams,
                fragment: this.fragment,
                preserveQueryParams: attrBoolValue(this.preserve),
                queryParamsHandling: this.queryParamsHandling,
                preserveFragment: attrBoolValue(this.preserveFragment),
            });
        },
        enumerable: true,
        configurable: true
    });
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["HostBinding"])('attr.target'), Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"])(),
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__metadata"])("design:type", String)
    ], RouterLinkWithHref.prototype, "target", void 0);
    return RouterLinkWithHref;
}());
function attrBoolValue(s) {
    return s === '' || !!s;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 *
 * @description
 *
 * Lets you add a CSS class to an element when the link's route becomes active.
 *
 * This directive lets you add a CSS class to an element when the link's route
 * becomes active.
 *
 * Consider the following example:
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
 * ```
 *
 * When the url is either '/user' or '/user/bob', the active-link class will
 * be added to the `a` tag. If the url changes, the class will be removed.
 *
 * You can set more than one class, as follows:
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="class1 class2">Bob</a>
 * <a routerLink="/user/bob" [routerLinkActive]="['class1', 'class2']">Bob</a>
 * ```
 *
 * You can configure RouterLinkActive by passing `exact: true`. This will add the classes
 * only when the url matches the link exactly.
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:
 * true}">Bob</a>
 * ```
 *
 * You can assign the RouterLinkActive instance to a template variable and directly check
 * the `isActive` status.
 * ```
 * <a routerLink="/user/bob" routerLinkActive #rla="routerLinkActive">
 *   Bob {{ rla.isActive ? '(already open)' : ''}}
 * </a>
 * ```
 *
 * Finally, you can apply the RouterLinkActive directive to an ancestor of a RouterLink.
 *
 * ```
 * <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
 *   <a routerLink="/user/jim">Jim</a>
 *   <a routerLink="/user/bob">Bob</a>
 * </div>
 * ```
 *
 * This will set the active-link class on the div tag if the url is either '/user/jim' or
 * '/user/bob'.
 *
 * @ngModule RouterModule
 *
 *
 */
var RouterLinkActive = /*@__PURE__*/ (function () {
    function RouterLinkActive(router, element, renderer, cdr) {
        var _this = this;
        this.router = router;
        this.element = element;
        this.renderer = renderer;
        this.cdr = cdr;
        this.classes = [];
        this.isActive = false;
        this.routerLinkActiveOptions = { exact: false };
        this.subscription = router.events.subscribe(function (s) {
            if (s instanceof NavigationEnd) {
                _this.update();
            }
        });
    }
    RouterLinkActive.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.links.changes.subscribe(function (_) { return _this.update(); });
        this.linksWithHrefs.changes.subscribe(function (_) { return _this.update(); });
        this.update();
    };
    Object.defineProperty(RouterLinkActive.prototype, "routerLinkActive", {
        set: function (data) {
            var classes = Array.isArray(data) ? data : data.split(' ');
            this.classes = classes.filter(function (c) { return !!c; });
        },
        enumerable: true,
        configurable: true
    });
    RouterLinkActive.prototype.ngOnChanges = function (changes) { this.update(); };
    RouterLinkActive.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    RouterLinkActive.prototype.update = function () {
        var _this = this;
        if (!this.links || !this.linksWithHrefs || !this.router.navigated)
            return;
        Promise.resolve().then(function () {
            var hasActiveLinks = _this.hasActiveLinks();
            if (_this.isActive !== hasActiveLinks) {
                _this.isActive = hasActiveLinks;
                _this.classes.forEach(function (c) {
                    if (hasActiveLinks) {
                        _this.renderer.addClass(_this.element.nativeElement, c);
                    }
                    else {
                        _this.renderer.removeClass(_this.element.nativeElement, c);
                    }
                });
            }
        });
    };
    RouterLinkActive.prototype.isLinkActive = function (router) {
        var _this = this;
        return function (link) {
            return router.isActive(link.urlTree, _this.routerLinkActiveOptions.exact);
        };
    };
    RouterLinkActive.prototype.hasActiveLinks = function () {
        return this.links.some(this.isLinkActive(this.router)) ||
            this.linksWithHrefs.some(this.isLinkActive(this.router));
    };
    return RouterLinkActive;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Store contextual information about a `RouterOutlet`
 *
 *
 */
var OutletContext = /*@__PURE__*/ (function () {
    function OutletContext() {
        this.outlet = null;
        this.route = null;
        this.resolver = null;
        this.children = new ChildrenOutletContexts();
        this.attachRef = null;
    }
    return OutletContext;
}());
/**
 * Store contextual information about the children (= nested) `RouterOutlet`
 *
 *
 */
var ChildrenOutletContexts = /*@__PURE__*/ (function () {
    function ChildrenOutletContexts() {
        // contexts for child outlets, by name.
        this.contexts = new Map();
    }
    /** Called when a `RouterOutlet` directive is instantiated */
    ChildrenOutletContexts.prototype.onChildOutletCreated = function (childName, outlet) {
        var context = this.getOrCreateContext(childName);
        context.outlet = outlet;
        this.contexts.set(childName, context);
    };
    /**
     * Called when a `RouterOutlet` directive is destroyed.
     * We need to keep the context as the outlet could be destroyed inside a NgIf and might be
     * re-created later.
     */
    ChildrenOutletContexts.prototype.onChildOutletDestroyed = function (childName) {
        var context = this.getContext(childName);
        if (context) {
            context.outlet = null;
        }
    };
    /**
     * Called when the corresponding route is deactivated during navigation.
     * Because the component get destroyed, all children outlet are destroyed.
     */
    ChildrenOutletContexts.prototype.onOutletDeactivated = function () {
        var contexts = this.contexts;
        this.contexts = new Map();
        return contexts;
    };
    ChildrenOutletContexts.prototype.onOutletReAttached = function (contexts) { this.contexts = contexts; };
    ChildrenOutletContexts.prototype.getOrCreateContext = function (childName) {
        var context = this.getContext(childName);
        if (!context) {
            context = new OutletContext();
            this.contexts.set(childName, context);
        }
        return context;
    };
    ChildrenOutletContexts.prototype.getContext = function (childName) { return this.contexts.get(childName) || null; };
    return ChildrenOutletContexts;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Acts as a placeholder that Angular dynamically fills based on the current router state.
 *
 * ```
 * <router-outlet></router-outlet>
 * <router-outlet name='left'></router-outlet>
 * <router-outlet name='right'></router-outlet>
 * ```
 *
 * A router outlet will emit an activate event any time a new component is being instantiated,
 * and a deactivate event when it is being destroyed.
 *
 * ```
 * <router-outlet
 *   (activate)='onActivate($event)'
 *   (deactivate)='onDeactivate($event)'></router-outlet>
 * ```
 * @ngModule RouterModule
 *
 *
 */
var RouterOutlet = /*@__PURE__*/ (function () {
    function RouterOutlet(parentContexts, location, resolver, name, changeDetector) {
        this.parentContexts = parentContexts;
        this.location = location;
        this.resolver = resolver;
        this.changeDetector = changeDetector;
        this.activated = null;
        this._activatedRoute = null;
        this.activateEvents = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.deactivateEvents = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.name = name || PRIMARY_OUTLET;
        parentContexts.onChildOutletCreated(this.name, this);
    }
    RouterOutlet.prototype.ngOnDestroy = function () { this.parentContexts.onChildOutletDestroyed(this.name); };
    RouterOutlet.prototype.ngOnInit = function () {
        if (!this.activated) {
            // If the outlet was not instantiated at the time the route got activated we need to populate
            // the outlet when it is initialized (ie inside a NgIf)
            var context = this.parentContexts.getContext(this.name);
            if (context && context.route) {
                if (context.attachRef) {
                    // `attachRef` is populated when there is an existing component to mount
                    this.attach(context.attachRef, context.route);
                }
                else {
                    // otherwise the component defined in the configuration is created
                    this.activateWith(context.route, context.resolver || null);
                }
            }
        }
    };
    Object.defineProperty(RouterOutlet.prototype, "isActivated", {
        get: function () { return !!this.activated; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "component", {
        get: function () {
            if (!this.activated)
                throw new Error('Outlet is not activated');
            return this.activated.instance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "activatedRoute", {
        get: function () {
            if (!this.activated)
                throw new Error('Outlet is not activated');
            return this._activatedRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "activatedRouteData", {
        get: function () {
            if (this._activatedRoute) {
                return this._activatedRoute.snapshot.data;
            }
            return {};
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Called when the `RouteReuseStrategy` instructs to detach the subtree
     */
    RouterOutlet.prototype.detach = function () {
        if (!this.activated)
            throw new Error('Outlet is not activated');
        this.location.detach();
        var cmp = this.activated;
        this.activated = null;
        this._activatedRoute = null;
        return cmp;
    };
    /**
     * Called when the `RouteReuseStrategy` instructs to re-attach a previously detached subtree
     */
    RouterOutlet.prototype.attach = function (ref, activatedRoute) {
        this.activated = ref;
        this._activatedRoute = activatedRoute;
        this.location.insert(ref.hostView);
    };
    RouterOutlet.prototype.deactivate = function () {
        if (this.activated) {
            var c = this.component;
            this.activated.destroy();
            this.activated = null;
            this._activatedRoute = null;
            this.deactivateEvents.emit(c);
        }
    };
    RouterOutlet.prototype.activateWith = function (activatedRoute, resolver) {
        if (this.isActivated) {
            throw new Error('Cannot activate an already activated outlet');
        }
        this._activatedRoute = activatedRoute;
        var snapshot = activatedRoute._futureSnapshot;
        var component = snapshot.routeConfig.component;
        resolver = resolver || this.resolver;
        var factory = resolver.resolveComponentFactory(component);
        var childContexts = this.parentContexts.getOrCreateContext(this.name).children;
        var injector = new OutletInjector(activatedRoute, childContexts, this.location.injector);
        this.activated = this.location.createComponent(factory, this.location.length, injector);
        // Calling `markForCheck` to make sure we will run the change detection when the
        // `RouterOutlet` is inside a `ChangeDetectionStrategy.OnPush` component.
        this.changeDetector.markForCheck();
        this.activateEvents.emit(this.activated.instance);
    };
    RouterOutlet = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(3, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Attribute"])('name'))
    ], RouterOutlet);
    return RouterOutlet;
}());
var OutletInjector = /*@__PURE__*/ (function () {
    function OutletInjector(route, childContexts, parent) {
        this.route = route;
        this.childContexts = childContexts;
        this.parent = parent;
    }
    OutletInjector.prototype.get = function (token, notFoundValue) {
        if (token === ActivatedRoute) {
            return this.route;
        }
        if (token === ChildrenOutletContexts) {
            return this.childContexts;
        }
        return this.parent.get(token, notFoundValue);
    };
    return OutletInjector;
}());
/**
*@license
*Copyright Google Inc. All Rights Reserved.
*
*Use of this source code is governed by an MIT-style license that can be
*found in the LICENSE file at https://angular.io/license
*/
/**
 * @description
 *
 * Provides a preloading strategy.
 *
 * @experimental
 */
var PreloadingStrategy = /*@__PURE__*/ (function () {
    function PreloadingStrategy() {
    }
    return PreloadingStrategy;
}());
/**
 * @description
 *
 * Provides a preloading strategy that preloads all modules as quickly as possible.
 *
 * ```
 * RouteModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules})
 * ```
 *
 * @experimental
 */
var PreloadAllModules = /*@__PURE__*/ (function () {
    function PreloadAllModules() {
    }
    PreloadAllModules.prototype.preload = function (route, fn) {
        return fn().pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["catchError"])(function () { return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(null); }));
    };
    return PreloadAllModules;
}());
/**
 * @description
 *
 * Provides a preloading strategy that does not preload any modules.
 *
 * This strategy is enabled by default.
 *
 * @experimental
 */
var NoPreloading = /*@__PURE__*/ (function () {
    function NoPreloading() {
    }
    NoPreloading.prototype.preload = function (route, fn) { return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(null); };
    return NoPreloading;
}());
/**
 * The preloader optimistically loads all router configurations to
 * make navigations into lazily-loaded sections of the application faster.
 *
 * The preloader runs in the background. When the router bootstraps, the preloader
 * starts listening to all navigation events. After every such event, the preloader
 * will check if any configurations can be loaded lazily.
 *
 * If a route is protected by `canLoad` guards, the preloaded will not load it.
 *
 *
 */
var RouterPreloader = /*@__PURE__*/ (function () {
    function RouterPreloader(router, moduleLoader, compiler, injector, preloadingStrategy) {
        this.router = router;
        this.injector = injector;
        this.preloadingStrategy = preloadingStrategy;
        var onStartLoad = function (r) { return router.triggerEvent(new RouteConfigLoadStart(r)); };
        var onEndLoad = function (r) { return router.triggerEvent(new RouteConfigLoadEnd(r)); };
        this.loader = new RouterConfigLoader(moduleLoader, compiler, onStartLoad, onEndLoad);
    }
    RouterPreloader.prototype.setUpPreloading = function () {
        var _this = this;
        this.subscription =
            this.router.events
                .pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["filter"])(function (e) { return e instanceof NavigationEnd; }), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["concatMap"])(function () { return _this.preload(); }))
                .subscribe(function () { });
    };
    RouterPreloader.prototype.preload = function () {
        var ngModule = this.injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleRef"]);
        return this.processRoutes(ngModule, this.router.config);
    };
    // TODO(jasonaden): This class relies on code external to the class to call setUpPreloading. If
    // this hasn't been done, ngOnDestroy will fail as this.subscription will be undefined. This
    // should be refactored.
    RouterPreloader.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    RouterPreloader.prototype.processRoutes = function (ngModule, routes) {
        var e_1, _a;
        var res = [];
        try {
            for (var routes_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(routes), routes_1_1 = routes_1.next(); !routes_1_1.done; routes_1_1 = routes_1.next()) {
                var route = routes_1_1.value;
                // we already have the config loaded, just recurse
                if (route.loadChildren && !route.canLoad && route._loadedConfig) {
                    var childConfig = route._loadedConfig;
                    res.push(this.processRoutes(childConfig.module, childConfig.routes));
                    // no config loaded, fetch the config
                }
                else if (route.loadChildren && !route.canLoad) {
                    res.push(this.preloadConfig(ngModule, route));
                    // recurse into children
                }
                else if (route.children) {
                    res.push(this.processRoutes(ngModule, route.children));
                }
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (routes_1_1 && !routes_1_1.done && (_a = routes_1.return))
                    _a.call(routes_1);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["q" /* from */])(res).pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeAll"])(), Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["map"])(function (_) { return void 0; }));
    };
    RouterPreloader.prototype.preloadConfig = function (ngModule, route) {
        var _this = this;
        return this.preloadingStrategy.preload(route, function () {
            var loaded$ = _this.loader.load(ngModule.injector, route);
            return loaded$.pipe(Object(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__["mergeMap"])(function (config) {
                route._loadedConfig = config;
                return _this.processRoutes(config.module, config.routes);
            }));
        });
    };
    return RouterPreloader;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RouterScroller = /*@__PURE__*/ (function () {
    function RouterScroller(router, 
    /** @docsNotRequired */ viewportScroller, options) {
        if (options === void 0) {
            options = {};
        }
        this.router = router;
        this.viewportScroller = viewportScroller;
        this.options = options;
        this.lastId = 0;
        this.lastSource = 'imperative';
        this.restoredId = 0;
        this.store = {};
        // Default both options to 'disabled'
        options.scrollPositionRestoration = options.scrollPositionRestoration || 'disabled';
        options.anchorScrolling = options.anchorScrolling || 'disabled';
    }
    RouterScroller.prototype.init = function () {
        // we want to disable the automatic scrolling because having two places
        // responsible for scrolling results race conditions, especially given
        // that browser don't implement this behavior consistently
        if (this.options.scrollPositionRestoration !== 'disabled') {
            this.viewportScroller.setHistoryScrollRestoration('manual');
        }
        this.routerEventsSubscription = this.createScrollEvents();
        this.scrollEventsSubscription = this.consumeScrollEvents();
    };
    RouterScroller.prototype.createScrollEvents = function () {
        var _this = this;
        return this.router.events.subscribe(function (e) {
            if (e instanceof NavigationStart) {
                // store the scroll position of the current stable navigations.
                _this.store[_this.lastId] = _this.viewportScroller.getScrollPosition();
                _this.lastSource = e.navigationTrigger;
                _this.restoredId = e.restoredState ? e.restoredState.navigationId : 0;
            }
            else if (e instanceof NavigationEnd) {
                _this.lastId = e.id;
                _this.scheduleScrollEvent(e, _this.router.parseUrl(e.urlAfterRedirects).fragment);
            }
        });
    };
    RouterScroller.prototype.consumeScrollEvents = function () {
        var _this = this;
        return this.router.events.subscribe(function (e) {
            if (!(e instanceof Scroll))
                return;
            // a popstate event. The pop state event will always ignore anchor scrolling.
            if (e.position) {
                if (_this.options.scrollPositionRestoration === 'top') {
                    _this.viewportScroller.scrollToPosition([0, 0]);
                }
                else if (_this.options.scrollPositionRestoration === 'enabled') {
                    _this.viewportScroller.scrollToPosition(e.position);
                }
                // imperative navigation "forward"
            }
            else {
                if (e.anchor && _this.options.anchorScrolling === 'enabled') {
                    _this.viewportScroller.scrollToAnchor(e.anchor);
                }
                else if (_this.options.scrollPositionRestoration !== 'disabled') {
                    _this.viewportScroller.scrollToPosition([0, 0]);
                }
            }
        });
    };
    RouterScroller.prototype.scheduleScrollEvent = function (routerEvent, anchor) {
        this.router.triggerEvent(new Scroll(routerEvent, this.lastSource === 'popstate' ? this.store[this.restoredId] : null, anchor));
    };
    RouterScroller.prototype.ngOnDestroy = function () {
        if (this.routerEventsSubscription) {
            this.routerEventsSubscription.unsubscribe();
        }
        if (this.scrollEventsSubscription) {
            this.scrollEventsSubscription.unsubscribe();
        }
    };
    return RouterScroller;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @description
 *
 * Contains a list of directives
 *
 *
 */
var ROUTER_DIRECTIVES = [RouterOutlet, RouterLink, RouterLinkWithHref, RouterLinkActive, EmptyOutletComponent];
/**
 * @description
 *
 * Is used in DI to configure the router.
 *
 *
 */
var ROUTER_CONFIGURATION = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('ROUTER_CONFIGURATION');
/**
 * @docsNotRequired
 */
var ROUTER_FORROOT_GUARD = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('ROUTER_FORROOT_GUARD');
var ROUTER_PROVIDERS = [
    __WEBPACK_IMPORTED_MODULE_4__angular_common__["Location"],
    { provide: UrlSerializer, useClass: DefaultUrlSerializer },
    {
        provide: Router,
        useFactory: setupRouter,
        deps: [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"], UrlSerializer, ChildrenOutletContexts, __WEBPACK_IMPORTED_MODULE_4__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Compiler"], ROUTES, ROUTER_CONFIGURATION,
            [UrlHandlingStrategy, /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()], [RouteReuseStrategy, /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()]
        ]
    },
    ChildrenOutletContexts,
    { provide: ActivatedRoute, useFactory: rootRoute, deps: [Router] },
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"], useClass: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SystemJsNgModuleLoader"] },
    RouterPreloader,
    NoPreloading,
    PreloadAllModules,
    { provide: ROUTER_CONFIGURATION, useValue: { enableTracing: false } },
];
function routerNgProbeToken() {
    return new __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgProbeToken"]('Router', Router);
}
/**
 * @usageNotes
 *
 * RouterModule can be imported multiple times: once per lazily-loaded bundle.
 * Since the router deals with a global shared resource--location, we cannot have
 * more than one router service active.
 *
 * That is why there are two ways to create the module: `RouterModule.forRoot` and
 * `RouterModule.forChild`.
 *
 * * `forRoot` creates a module that contains all the directives, the given routes, and the router
 *   service itself.
 * * `forChild` creates a module that contains all the directives and the given routes, but does not
 *   include the router service.
 *
 * When registered at the root, the module should be used as follows
 *
 * ```
 * @NgModule({
 *   imports: [RouterModule.forRoot(ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * For submodules and lazy loaded submodules the module should be used as follows:
 *
 * ```
 * @NgModule({
 *   imports: [RouterModule.forChild(ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * @description
 *
 * Adds router directives and providers.
 *
 * Managing state transitions is one of the hardest parts of building applications. This is
 * especially true on the web, where you also need to ensure that the state is reflected in the URL.
 * In addition, we often want to split applications into multiple bundles and load them on demand.
 * Doing this transparently is not trivial.
 *
 * The Angular router solves these problems. Using the router, you can declaratively specify
 * application states, manage state transitions while taking care of the URL, and load bundles on
 * demand.
 *
 * [Read this developer guide](https://angular.io/docs/ts/latest/guide/router.html) to get an
 * overview of how the router should be used.
 *
 *
 */
var RouterModule = /*@__PURE__*/ (function () {
    // Note: We are injecting the Router so it gets created eagerly...
    function RouterModule(guard, router) {
    }
    RouterModule_1 = RouterModule;
    /**
     * Creates a module with all the router providers and directives. It also optionally sets up an
     * application listener to perform an initial navigation.
     *
     * Options (see `ExtraOptions`):
     * * `enableTracing` makes the router log all its internal events to the console.
     * * `useHash` enables the location strategy that uses the URL fragment instead of the history
     * API.
     * * `initialNavigation` disables the initial navigation.
     * * `errorHandler` provides a custom error handler.
     * * `preloadingStrategy` configures a preloading strategy (see `PreloadAllModules`).
     * * `onSameUrlNavigation` configures how the router handles navigation to the current URL. See
     * `ExtraOptions` for more details.
     * * `paramsInheritanceStrategy` defines how the router merges params, data and resolved data
     * from parent to child routes.
     */
    RouterModule.forRoot = function (routes, config) {
        return {
            ngModule: RouterModule_1,
            providers: [
                ROUTER_PROVIDERS,
                provideRoutes(routes),
                {
                    provide: ROUTER_FORROOT_GUARD,
                    useFactory: provideForRootGuard,
                    deps: [[Router, new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"]()]]
                },
                { provide: ROUTER_CONFIGURATION, useValue: config ? config : {} },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_4__angular_common__["LocationStrategy"],
                    useFactory: provideLocationStrategy,
                    deps: [
                        __WEBPACK_IMPORTED_MODULE_4__angular_common__["PlatformLocation"], [new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"](__WEBPACK_IMPORTED_MODULE_4__angular_common__["APP_BASE_HREF"]), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()], ROUTER_CONFIGURATION
                    ]
                },
                {
                    provide: RouterScroller,
                    useFactory: createRouterScroller,
                    deps: [Router, __WEBPACK_IMPORTED_MODULE_4__angular_common__["ViewportScroller"], ROUTER_CONFIGURATION]
                },
                {
                    provide: PreloadingStrategy,
                    useExisting: config && config.preloadingStrategy ? config.preloadingStrategy :
                        NoPreloading
                },
                { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgProbeToken"], multi: true, useFactory: routerNgProbeToken },
                provideRouterInitializer(),
            ],
        };
    };
    /**
     * Creates a module with all the router directives and a provider registering routes.
     */
    RouterModule.forChild = function (routes) {
        return { ngModule: RouterModule_1, providers: [provideRoutes(routes)] };
    };
    var RouterModule_1;
    RouterModule = RouterModule_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__decorate"])([
        Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])()), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(0, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"])(ROUTER_FORROOT_GUARD)), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__param"])(1, Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"])())
    ], RouterModule);
    return RouterModule;
}());
function createRouterScroller(router, viewportScroller, config) {
    if (config.scrollOffset) {
        viewportScroller.setOffset(config.scrollOffset);
    }
    return new RouterScroller(router, viewportScroller, config);
}
function provideLocationStrategy(platformLocationStrategy, baseHref, options) {
    if (options === void 0) {
        options = {};
    }
    return options.useHash ? new __WEBPACK_IMPORTED_MODULE_4__angular_common__["HashLocationStrategy"](platformLocationStrategy, baseHref) :
        new __WEBPACK_IMPORTED_MODULE_4__angular_common__["PathLocationStrategy"](platformLocationStrategy, baseHref);
}
function provideForRootGuard(router) {
    if (router) {
        throw new Error("RouterModule.forRoot() called twice. Lazy loaded modules should use RouterModule.forChild() instead.");
    }
    return 'guarded';
}
/**
 * @description
 *
 * Registers routes.
 *
 * @usageNotes
 * ### Example
 *
 * ```
 * @NgModule({
 *   imports: [RouterModule.forChild(ROUTES)],
 *   providers: [provideRoutes(EXTRA_ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 *
 */
function provideRoutes(routes) {
    return [
        { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ANALYZE_FOR_ENTRY_COMPONENTS"], multi: true, useValue: routes },
        { provide: ROUTES, multi: true, useValue: routes },
    ];
}
function setupRouter(ref, urlSerializer, contexts, location, injector, loader, compiler, config, opts, urlHandlingStrategy, routeReuseStrategy) {
    if (opts === void 0) {
        opts = {};
    }
    var router = new Router(null, urlSerializer, contexts, location, injector, loader, compiler, flatten(config));
    if (urlHandlingStrategy) {
        router.urlHandlingStrategy = urlHandlingStrategy;
    }
    if (routeReuseStrategy) {
        router.routeReuseStrategy = routeReuseStrategy;
    }
    if (opts.errorHandler) {
        router.errorHandler = opts.errorHandler;
    }
    if (opts.malformedUriErrorHandler) {
        router.malformedUriErrorHandler = opts.malformedUriErrorHandler;
    }
    if (opts.enableTracing) {
        var dom_1 = Object(__WEBPACK_IMPORTED_MODULE_5__angular_platform_browser__["t" /* ɵgetDOM */])();
        router.events.subscribe(function (e) {
            dom_1.logGroup("Router Event: " + e.constructor.name);
            dom_1.log(e.toString());
            dom_1.log(e);
            dom_1.logGroupEnd();
        });
    }
    if (opts.onSameUrlNavigation) {
        router.onSameUrlNavigation = opts.onSameUrlNavigation;
    }
    if (opts.paramsInheritanceStrategy) {
        router.paramsInheritanceStrategy = opts.paramsInheritanceStrategy;
    }
    if (opts.urlUpdateStrategy) {
        router.urlUpdateStrategy = opts.urlUpdateStrategy;
    }
    if (opts.relativeLinkResolution) {
        router.relativeLinkResolution = opts.relativeLinkResolution;
    }
    return router;
}
function rootRoute(router) {
    return router.routerState.root;
}
/**
 * To initialize the router properly we need to do in two steps:
 *
 * We need to start the navigation in a APP_INITIALIZER to block the bootstrap if
 * a resolver or a guards executes asynchronously. Second, we need to actually run
 * activation in a BOOTSTRAP_LISTENER. We utilize the afterPreactivation
 * hook provided by the router to do that.
 *
 * The router navigation starts, reaches the point when preactivation is done, and then
 * pauses. It waits for the hook to be resolved. We then resolve it only in a bootstrap listener.
 */
var RouterInitializer = /*@__PURE__*/ (function () {
    function RouterInitializer(injector) {
        this.injector = injector;
        this.initNavigation = false;
        this.resultOfPreactivationDone = new __WEBPACK_IMPORTED_MODULE_2_rxjs__["e" /* Subject */]();
    }
    RouterInitializer.prototype.appInitializer = function () {
        var _this = this;
        var p = this.injector.get(__WEBPACK_IMPORTED_MODULE_4__angular_common__["LOCATION_INITIALIZED"], Promise.resolve(null));
        return p.then(function () {
            var resolve = null;
            var res = new Promise(function (r) { return resolve = r; });
            var router = _this.injector.get(Router);
            var opts = _this.injector.get(ROUTER_CONFIGURATION);
            if (_this.isLegacyDisabled(opts) || _this.isLegacyEnabled(opts)) {
                resolve(true);
            }
            else if (opts.initialNavigation === 'disabled') {
                router.setUpLocationChangeListener();
                resolve(true);
            }
            else if (opts.initialNavigation === 'enabled') {
                router.hooks.afterPreactivation = function () {
                    // only the initial navigation should be delayed
                    if (!_this.initNavigation) {
                        _this.initNavigation = true;
                        resolve(true);
                        return _this.resultOfPreactivationDone;
                        // subsequent navigations should not be delayed
                    }
                    else {
                        return Object(__WEBPACK_IMPORTED_MODULE_2_rxjs__["x" /* of */])(null);
                    }
                };
                router.initialNavigation();
            }
            else {
                throw new Error("Invalid initialNavigation options: '" + opts.initialNavigation + "'");
            }
            return res;
        });
    };
    RouterInitializer.prototype.bootstrapListener = function (bootstrappedComponentRef) {
        var opts = this.injector.get(ROUTER_CONFIGURATION);
        var preloader = this.injector.get(RouterPreloader);
        var routerScroller = this.injector.get(RouterScroller);
        var router = this.injector.get(Router);
        var ref = this.injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"]);
        if (bootstrappedComponentRef !== ref.components[0]) {
            return;
        }
        if (this.isLegacyEnabled(opts)) {
            router.initialNavigation();
        }
        else if (this.isLegacyDisabled(opts)) {
            router.setUpLocationChangeListener();
        }
        preloader.setUpPreloading();
        routerScroller.init();
        router.resetRootComponentType(ref.componentTypes[0]);
        this.resultOfPreactivationDone.next(null);
        this.resultOfPreactivationDone.complete();
    };
    RouterInitializer.prototype.isLegacyEnabled = function (opts) {
        return opts.initialNavigation === 'legacy_enabled' || opts.initialNavigation === true ||
            opts.initialNavigation === undefined;
    };
    RouterInitializer.prototype.isLegacyDisabled = function (opts) {
        return opts.initialNavigation === 'legacy_disabled' || opts.initialNavigation === false;
    };
    return RouterInitializer;
}());
function getAppInitializer(r) {
    return r.appInitializer.bind(r);
}
function getBootstrapListener(r) {
    return r.bootstrapListener.bind(r);
}
/**
 * A token for the router initializer that will be called after the app is bootstrapped.
 *
 * @experimental
 */
var ROUTER_INITIALIZER = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('Router Initializer');
function provideRouterInitializer() {
    return [
        RouterInitializer,
        {
            provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_INITIALIZER"],
            multi: true,
            useFactory: getAppInitializer,
            deps: [RouterInitializer]
        },
        { provide: ROUTER_INITIALIZER, useFactory: getBootstrapListener, deps: [RouterInitializer] },
        { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_BOOTSTRAP_LISTENER"], multi: true, useExisting: ROUTER_INITIALIZER },
    ];
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var VERSION = /*@__PURE__*/ new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('6.1.10');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Generated bundle index. Do not edit.
 */






/***/ }),

/***/ "z3hR":
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__("PJh5")) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        ss : '%d Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),

/***/ "z4hc":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("aCM0"),
    isLength = __webpack_require__("Rh28"),
    isObjectLike = __webpack_require__("UnEC");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "zBOP":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("22B7"),
    isArrayLike = __webpack_require__("bGc4"),
    isIndex = __webpack_require__("ZGh9"),
    isObject = __webpack_require__("yCNF");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "zGZ6":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("YeCl");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ "zMR/":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("HbnZ"),
    createAssigner = __webpack_require__("0DSl");

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),

/***/ "zpVT":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("duB3"),
    Map = __webpack_require__("POb3"),
    MapCache = __webpack_require__("YeCl");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ })

},["fYOR"]);


// WEBPACK FOOTER //
// main.54a32560f7bd72ffbe63.bundle.js